import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never;
      };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
    BigInt: { input: any; output: any };
    /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
    DateTimeISO: { input: any; output: any };
    /** GraphQL Scalar representing the Prisma.Decimal type, based on Decimal.js library. */
    Decimal: { input: any; output: any };
    /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
    JSON: { input: any; output: any };
    /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
    JSONObject: { input: any; output: any };
};

export enum AirStatusCode {
    BenefitNotFound = 'BENEFIT_NOT_FOUND',
    BothInsuranceFailure = 'BOTH_INSURANCE_FAILURE',
    CommErrorTimeout = 'COMM_ERROR_TIMEOUT',
    ConcurrencyTimeout = 'CONCURRENCY_TIMEOUT',
    CoverageError = 'COVERAGE_ERROR',
    DobBadFormat = 'DOB_BAD_FORMAT',
    DobMismatch = 'DOB_MISMATCH',
    Error = 'ERROR',
    FirstInsuranceFailure = 'FIRST_INSURANCE_FAILURE',
    InactivePlan = 'INACTIVE_PLAN',
    InsuranceFailure = 'INSURANCE_FAILURE',
    InternalError = 'INTERNAL_ERROR',
    InvalidInfo = 'INVALID_INFO',
    InvalidMemberid = 'INVALID_MEMBERID',
    InvalidName = 'INVALID_NAME',
    InvalidProvider = 'INVALID_PROVIDER',
    InvalidSubscriber = 'INVALID_SUBSCRIBER',
    IrrelevantInsurance = 'IRRELEVANT_INSURANCE',
    MedicareMemberidError = 'MEDICARE_MEMBERID_ERROR',
    MemberidError = 'MEMBERID_ERROR',
    MemberidMismatch = 'MEMBERID_MISMATCH',
    NameMismatch = 'NAME_MISMATCH',
    NoPlansFound = 'NO_PLANS_FOUND',
    OutOfNetwork = 'OUT_OF_NETWORK',
    PayerIncomplete = 'PAYER_INCOMPLETE',
    PayerNotSupported = 'PAYER_NOT_SUPPORTED',
    ProcessingError = 'PROCESSING_ERROR',
    RateLimitTimeout = 'RATE_LIMIT_TIMEOUT',
    SecondInsuranceFailure = 'SECOND_INSURANCE_FAILURE',
    ServiceCodeNotSupported = 'SERVICE_CODE_NOT_SUPPORTED',
    SubscriberNotFound = 'SUBSCRIBER_NOT_FOUND',
    Success = 'SUCCESS',
    TimeoutError = 'TIMEOUT_ERROR',
}

export type AleConfig = {
    __typename?: 'ALEConfig';
    _count?: Maybe<AleConfigCount>;
    asyncActive: Scalars['Boolean']['output'];
    backfillActive: Scalars['Boolean']['output'];
    contextId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    departmentGoLives: Array<AleDepartmentGoLive>;
    departmentIds: Array<Scalars['String']['output']>;
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    oneDayOnlyDepartmentIds: Array<Scalars['String']['output']>;
    ordering?: Maybe<Scalars['Int']['output']>;
    orgId: Scalars['Int']['output'];
    post837JobActive: Scalars['Boolean']['output'];
    providerGroupIds: Array<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AleConfigDepartmentGoLivesArgs = {
    cursor?: InputMaybe<AleDepartmentGoLiveWhereUniqueInput>;
    distinct?: InputMaybe<Array<AleDepartmentGoLiveScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AleDepartmentGoLiveOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleDepartmentGoLiveWhereInput>;
};

export type AleConfigAvgAggregate = {
    __typename?: 'ALEConfigAvgAggregate';
    ordering?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type AleConfigAvgOrderByAggregateInput = {
    ordering?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type AleConfigCount = {
    __typename?: 'ALEConfigCount';
    departmentGoLives: Scalars['Int']['output'];
};

export type AleConfigCountDepartmentGoLivesArgs = {
    where?: InputMaybe<AleDepartmentGoLiveWhereInput>;
};

export type AleConfigCountAggregate = {
    __typename?: 'ALEConfigCountAggregate';
    _all: Scalars['Int']['output'];
    asyncActive: Scalars['Int']['output'];
    backfillActive: Scalars['Int']['output'];
    contextId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    departmentIds: Scalars['Int']['output'];
    goLiveDate: Scalars['Int']['output'];
    oneDayOnlyDepartmentIds: Scalars['Int']['output'];
    ordering: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    post837JobActive: Scalars['Int']['output'];
    providerGroupIds: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type AleConfigCountOrderByAggregateInput = {
    asyncActive?: InputMaybe<SortOrder>;
    backfillActive?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    departmentIds?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    oneDayOnlyDepartmentIds?: InputMaybe<SortOrder>;
    ordering?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    post837JobActive?: InputMaybe<SortOrder>;
    providerGroupIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AleConfigCreateInput = {
    asyncActive?: InputMaybe<Scalars['Boolean']['input']>;
    backfillActive?: InputMaybe<Scalars['Boolean']['input']>;
    contextId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    departmentGoLives?: InputMaybe<AleDepartmentGoLiveCreateNestedManyWithoutAleConfigInput>;
    departmentIds?: InputMaybe<AleConfigCreatedepartmentIdsInput>;
    goLiveDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    oneDayOnlyDepartmentIds?: InputMaybe<AleConfigCreateoneDayOnlyDepartmentIdsInput>;
    ordering?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    post837JobActive?: InputMaybe<Scalars['Boolean']['input']>;
    providerGroupIds?: InputMaybe<AleConfigCreateproviderGroupIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AleConfigCreateManyInput = {
    asyncActive?: InputMaybe<Scalars['Boolean']['input']>;
    backfillActive?: InputMaybe<Scalars['Boolean']['input']>;
    contextId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    departmentIds?: InputMaybe<AleConfigCreatedepartmentIdsInput>;
    goLiveDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    oneDayOnlyDepartmentIds?: InputMaybe<AleConfigCreateoneDayOnlyDepartmentIdsInput>;
    ordering?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    post837JobActive?: InputMaybe<Scalars['Boolean']['input']>;
    providerGroupIds?: InputMaybe<AleConfigCreateproviderGroupIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AleConfigCreateNestedOneWithoutDepartmentGoLivesInput = {
    connect?: InputMaybe<AleConfigWhereUniqueInput>;
    connectOrCreate?: InputMaybe<AleConfigCreateOrConnectWithoutDepartmentGoLivesInput>;
    create?: InputMaybe<AleConfigCreateWithoutDepartmentGoLivesInput>;
};

export type AleConfigCreateOrConnectWithoutDepartmentGoLivesInput = {
    create: AleConfigCreateWithoutDepartmentGoLivesInput;
    where: AleConfigWhereUniqueInput;
};

export type AleConfigCreateWithoutDepartmentGoLivesInput = {
    asyncActive?: InputMaybe<Scalars['Boolean']['input']>;
    backfillActive?: InputMaybe<Scalars['Boolean']['input']>;
    contextId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    departmentIds?: InputMaybe<AleConfigCreatedepartmentIdsInput>;
    goLiveDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    oneDayOnlyDepartmentIds?: InputMaybe<AleConfigCreateoneDayOnlyDepartmentIdsInput>;
    ordering?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    post837JobActive?: InputMaybe<Scalars['Boolean']['input']>;
    providerGroupIds?: InputMaybe<AleConfigCreateproviderGroupIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AleConfigCreatedepartmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AleConfigCreateoneDayOnlyDepartmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AleConfigCreateproviderGroupIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AleConfigGroupBy = {
    __typename?: 'ALEConfigGroupBy';
    _avg?: Maybe<AleConfigAvgAggregate>;
    _count?: Maybe<AleConfigCountAggregate>;
    _max?: Maybe<AleConfigMaxAggregate>;
    _min?: Maybe<AleConfigMinAggregate>;
    _sum?: Maybe<AleConfigSumAggregate>;
    asyncActive: Scalars['Boolean']['output'];
    backfillActive: Scalars['Boolean']['output'];
    contextId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    departmentIds?: Maybe<Array<Scalars['String']['output']>>;
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    oneDayOnlyDepartmentIds?: Maybe<Array<Scalars['String']['output']>>;
    ordering?: Maybe<Scalars['Int']['output']>;
    orgId: Scalars['Int']['output'];
    post837JobActive: Scalars['Boolean']['output'];
    providerGroupIds?: Maybe<Array<Scalars['String']['output']>>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AleConfigMaxAggregate = {
    __typename?: 'ALEConfigMaxAggregate';
    asyncActive?: Maybe<Scalars['Boolean']['output']>;
    backfillActive?: Maybe<Scalars['Boolean']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    ordering?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    post837JobActive?: Maybe<Scalars['Boolean']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AleConfigMaxOrderByAggregateInput = {
    asyncActive?: InputMaybe<SortOrder>;
    backfillActive?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    ordering?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    post837JobActive?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AleConfigMinAggregate = {
    __typename?: 'ALEConfigMinAggregate';
    asyncActive?: Maybe<Scalars['Boolean']['output']>;
    backfillActive?: Maybe<Scalars['Boolean']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    ordering?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    post837JobActive?: Maybe<Scalars['Boolean']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AleConfigMinOrderByAggregateInput = {
    asyncActive?: InputMaybe<SortOrder>;
    backfillActive?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    ordering?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    post837JobActive?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AleConfigOrderByWithAggregationInput = {
    _avg?: InputMaybe<AleConfigAvgOrderByAggregateInput>;
    _count?: InputMaybe<AleConfigCountOrderByAggregateInput>;
    _max?: InputMaybe<AleConfigMaxOrderByAggregateInput>;
    _min?: InputMaybe<AleConfigMinOrderByAggregateInput>;
    _sum?: InputMaybe<AleConfigSumOrderByAggregateInput>;
    asyncActive?: InputMaybe<SortOrder>;
    backfillActive?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    departmentIds?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrderInput>;
    oneDayOnlyDepartmentIds?: InputMaybe<SortOrder>;
    ordering?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    post837JobActive?: InputMaybe<SortOrder>;
    providerGroupIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AleConfigOrderByWithRelationInput = {
    asyncActive?: InputMaybe<SortOrder>;
    backfillActive?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    departmentGoLives?: InputMaybe<AleDepartmentGoLiveOrderByRelationAggregateInput>;
    departmentIds?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrderInput>;
    oneDayOnlyDepartmentIds?: InputMaybe<SortOrder>;
    ordering?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    post837JobActive?: InputMaybe<SortOrder>;
    providerGroupIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AleConfigRelationFilter = {
    is?: InputMaybe<AleConfigWhereInput>;
    isNot?: InputMaybe<AleConfigWhereInput>;
};

export enum AleConfigScalarFieldEnum {
    AsyncActive = 'asyncActive',
    BackfillActive = 'backfillActive',
    ContextId = 'contextId',
    CreatedAt = 'createdAt',
    DepartmentIds = 'departmentIds',
    GoLiveDate = 'goLiveDate',
    OneDayOnlyDepartmentIds = 'oneDayOnlyDepartmentIds',
    Ordering = 'ordering',
    OrgId = 'orgId',
    Post837JobActive = 'post837JobActive',
    ProviderGroupIds = 'providerGroupIds',
    UpdatedAt = 'updatedAt',
}

export type AleConfigScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AleConfigScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AleConfigScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AleConfigScalarWhereWithAggregatesInput>>;
    asyncActive?: InputMaybe<BoolWithAggregatesFilter>;
    backfillActive?: InputMaybe<BoolWithAggregatesFilter>;
    contextId?: InputMaybe<StringWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    departmentIds?: InputMaybe<StringNullableListFilter>;
    goLiveDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    oneDayOnlyDepartmentIds?: InputMaybe<StringNullableListFilter>;
    ordering?: InputMaybe<IntNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    post837JobActive?: InputMaybe<BoolWithAggregatesFilter>;
    providerGroupIds?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AleConfigSumAggregate = {
    __typename?: 'ALEConfigSumAggregate';
    ordering?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type AleConfigSumOrderByAggregateInput = {
    ordering?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type AleConfigUpdateInput = {
    asyncActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    backfillActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    contextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    departmentGoLives?: InputMaybe<AleDepartmentGoLiveUpdateManyWithoutAleConfigNestedInput>;
    departmentIds?: InputMaybe<AleConfigUpdatedepartmentIdsInput>;
    goLiveDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    oneDayOnlyDepartmentIds?: InputMaybe<AleConfigUpdateoneDayOnlyDepartmentIdsInput>;
    ordering?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    post837JobActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    providerGroupIds?: InputMaybe<AleConfigUpdateproviderGroupIdsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AleConfigUpdateManyMutationInput = {
    asyncActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    backfillActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    contextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    departmentIds?: InputMaybe<AleConfigUpdatedepartmentIdsInput>;
    goLiveDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    oneDayOnlyDepartmentIds?: InputMaybe<AleConfigUpdateoneDayOnlyDepartmentIdsInput>;
    ordering?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    post837JobActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    providerGroupIds?: InputMaybe<AleConfigUpdateproviderGroupIdsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AleConfigUpdateOneRequiredWithoutDepartmentGoLivesNestedInput = {
    connect?: InputMaybe<AleConfigWhereUniqueInput>;
    connectOrCreate?: InputMaybe<AleConfigCreateOrConnectWithoutDepartmentGoLivesInput>;
    create?: InputMaybe<AleConfigCreateWithoutDepartmentGoLivesInput>;
    update?: InputMaybe<AleConfigUpdateToOneWithWhereWithoutDepartmentGoLivesInput>;
    upsert?: InputMaybe<AleConfigUpsertWithoutDepartmentGoLivesInput>;
};

export type AleConfigUpdateToOneWithWhereWithoutDepartmentGoLivesInput = {
    data: AleConfigUpdateWithoutDepartmentGoLivesInput;
    where?: InputMaybe<AleConfigWhereInput>;
};

export type AleConfigUpdateWithoutDepartmentGoLivesInput = {
    asyncActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    backfillActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    contextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    departmentIds?: InputMaybe<AleConfigUpdatedepartmentIdsInput>;
    goLiveDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    oneDayOnlyDepartmentIds?: InputMaybe<AleConfigUpdateoneDayOnlyDepartmentIdsInput>;
    ordering?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    post837JobActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    providerGroupIds?: InputMaybe<AleConfigUpdateproviderGroupIdsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AleConfigUpdatedepartmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AleConfigUpdateoneDayOnlyDepartmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AleConfigUpdateproviderGroupIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AleConfigUpsertWithoutDepartmentGoLivesInput = {
    create: AleConfigCreateWithoutDepartmentGoLivesInput;
    update: AleConfigUpdateWithoutDepartmentGoLivesInput;
    where?: InputMaybe<AleConfigWhereInput>;
};

export type AleConfigWhereInput = {
    AND?: InputMaybe<Array<AleConfigWhereInput>>;
    NOT?: InputMaybe<Array<AleConfigWhereInput>>;
    OR?: InputMaybe<Array<AleConfigWhereInput>>;
    asyncActive?: InputMaybe<BoolFilter>;
    backfillActive?: InputMaybe<BoolFilter>;
    contextId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    departmentGoLives?: InputMaybe<AleDepartmentGoLiveListRelationFilter>;
    departmentIds?: InputMaybe<StringNullableListFilter>;
    goLiveDate?: InputMaybe<DateTimeNullableFilter>;
    oneDayOnlyDepartmentIds?: InputMaybe<StringNullableListFilter>;
    ordering?: InputMaybe<IntNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    post837JobActive?: InputMaybe<BoolFilter>;
    providerGroupIds?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AleConfigWhereUniqueInput = {
    AND?: InputMaybe<Array<AleConfigWhereInput>>;
    NOT?: InputMaybe<Array<AleConfigWhereInput>>;
    OR?: InputMaybe<Array<AleConfigWhereInput>>;
    asyncActive?: InputMaybe<BoolFilter>;
    backfillActive?: InputMaybe<BoolFilter>;
    contextId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    departmentGoLives?: InputMaybe<AleDepartmentGoLiveListRelationFilter>;
    departmentIds?: InputMaybe<StringNullableListFilter>;
    goLiveDate?: InputMaybe<DateTimeNullableFilter>;
    oneDayOnlyDepartmentIds?: InputMaybe<StringNullableListFilter>;
    ordering?: InputMaybe<IntNullableFilter>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    post837JobActive?: InputMaybe<BoolFilter>;
    providerGroupIds?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AleDepartmentGoLive = {
    __typename?: 'ALEDepartmentGoLive';
    aleConfig: AleConfig;
    createdAt: Scalars['DateTimeISO']['output'];
    departmentIds: Array<Scalars['String']['output']>;
    goLiveDate: Scalars['DateTimeISO']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AleDepartmentGoLiveAvgAggregate = {
    __typename?: 'ALEDepartmentGoLiveAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type AleDepartmentGoLiveAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type AleDepartmentGoLiveCountAggregate = {
    __typename?: 'ALEDepartmentGoLiveCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    departmentIds: Scalars['Int']['output'];
    goLiveDate: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type AleDepartmentGoLiveCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    departmentIds?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AleDepartmentGoLiveCreateInput = {
    aleConfig: AleConfigCreateNestedOneWithoutDepartmentGoLivesInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    departmentIds?: InputMaybe<AleDepartmentGoLiveCreatedepartmentIdsInput>;
    goLiveDate: Scalars['DateTimeISO']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AleDepartmentGoLiveCreateManyAleConfigInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    departmentIds?: InputMaybe<AleDepartmentGoLiveCreatedepartmentIdsInput>;
    goLiveDate: Scalars['DateTimeISO']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AleDepartmentGoLiveCreateManyAleConfigInputEnvelope = {
    data: Array<AleDepartmentGoLiveCreateManyAleConfigInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AleDepartmentGoLiveCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    departmentIds?: InputMaybe<AleDepartmentGoLiveCreatedepartmentIdsInput>;
    goLiveDate: Scalars['DateTimeISO']['input'];
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AleDepartmentGoLiveCreateNestedManyWithoutAleConfigInput = {
    connect?: InputMaybe<Array<AleDepartmentGoLiveWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<AleDepartmentGoLiveCreateOrConnectWithoutAleConfigInput>
    >;
    create?: InputMaybe<Array<AleDepartmentGoLiveCreateWithoutAleConfigInput>>;
    createMany?: InputMaybe<AleDepartmentGoLiveCreateManyAleConfigInputEnvelope>;
};

export type AleDepartmentGoLiveCreateOrConnectWithoutAleConfigInput = {
    create: AleDepartmentGoLiveCreateWithoutAleConfigInput;
    where: AleDepartmentGoLiveWhereUniqueInput;
};

export type AleDepartmentGoLiveCreateWithoutAleConfigInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    departmentIds?: InputMaybe<AleDepartmentGoLiveCreatedepartmentIdsInput>;
    goLiveDate: Scalars['DateTimeISO']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AleDepartmentGoLiveCreatedepartmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AleDepartmentGoLiveGroupBy = {
    __typename?: 'ALEDepartmentGoLiveGroupBy';
    _avg?: Maybe<AleDepartmentGoLiveAvgAggregate>;
    _count?: Maybe<AleDepartmentGoLiveCountAggregate>;
    _max?: Maybe<AleDepartmentGoLiveMaxAggregate>;
    _min?: Maybe<AleDepartmentGoLiveMinAggregate>;
    _sum?: Maybe<AleDepartmentGoLiveSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    departmentIds?: Maybe<Array<Scalars['String']['output']>>;
    goLiveDate: Scalars['DateTimeISO']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AleDepartmentGoLiveListRelationFilter = {
    every?: InputMaybe<AleDepartmentGoLiveWhereInput>;
    none?: InputMaybe<AleDepartmentGoLiveWhereInput>;
    some?: InputMaybe<AleDepartmentGoLiveWhereInput>;
};

export type AleDepartmentGoLiveMaxAggregate = {
    __typename?: 'ALEDepartmentGoLiveMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AleDepartmentGoLiveMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AleDepartmentGoLiveMinAggregate = {
    __typename?: 'ALEDepartmentGoLiveMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AleDepartmentGoLiveMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AleDepartmentGoLiveOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type AleDepartmentGoLiveOrderByWithAggregationInput = {
    _avg?: InputMaybe<AleDepartmentGoLiveAvgOrderByAggregateInput>;
    _count?: InputMaybe<AleDepartmentGoLiveCountOrderByAggregateInput>;
    _max?: InputMaybe<AleDepartmentGoLiveMaxOrderByAggregateInput>;
    _min?: InputMaybe<AleDepartmentGoLiveMinOrderByAggregateInput>;
    _sum?: InputMaybe<AleDepartmentGoLiveSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    departmentIds?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AleDepartmentGoLiveOrderByWithRelationInput = {
    aleConfig?: InputMaybe<AleConfigOrderByWithRelationInput>;
    createdAt?: InputMaybe<SortOrder>;
    departmentIds?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AleDepartmentGoLiveOrgIdGoLiveDateCompoundUniqueInput = {
    goLiveDate: Scalars['DateTimeISO']['input'];
    orgId: Scalars['Int']['input'];
};

export enum AleDepartmentGoLiveScalarFieldEnum {
    CreatedAt = 'createdAt',
    DepartmentIds = 'departmentIds',
    GoLiveDate = 'goLiveDate',
    OrgId = 'orgId',
    UpdatedAt = 'updatedAt',
}

export type AleDepartmentGoLiveScalarWhereInput = {
    AND?: InputMaybe<Array<AleDepartmentGoLiveScalarWhereInput>>;
    NOT?: InputMaybe<Array<AleDepartmentGoLiveScalarWhereInput>>;
    OR?: InputMaybe<Array<AleDepartmentGoLiveScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    departmentIds?: InputMaybe<StringNullableListFilter>;
    goLiveDate?: InputMaybe<DateTimeFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AleDepartmentGoLiveScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AleDepartmentGoLiveScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AleDepartmentGoLiveScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AleDepartmentGoLiveScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    departmentIds?: InputMaybe<StringNullableListFilter>;
    goLiveDate?: InputMaybe<DateTimeWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AleDepartmentGoLiveSumAggregate = {
    __typename?: 'ALEDepartmentGoLiveSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type AleDepartmentGoLiveSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type AleDepartmentGoLiveUpdateInput = {
    aleConfig?: InputMaybe<AleConfigUpdateOneRequiredWithoutDepartmentGoLivesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    departmentIds?: InputMaybe<AleDepartmentGoLiveUpdatedepartmentIdsInput>;
    goLiveDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AleDepartmentGoLiveUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    departmentIds?: InputMaybe<AleDepartmentGoLiveUpdatedepartmentIdsInput>;
    goLiveDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AleDepartmentGoLiveUpdateManyWithWhereWithoutAleConfigInput = {
    data: AleDepartmentGoLiveUpdateManyMutationInput;
    where: AleDepartmentGoLiveScalarWhereInput;
};

export type AleDepartmentGoLiveUpdateManyWithoutAleConfigNestedInput = {
    connect?: InputMaybe<Array<AleDepartmentGoLiveWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<AleDepartmentGoLiveCreateOrConnectWithoutAleConfigInput>
    >;
    create?: InputMaybe<Array<AleDepartmentGoLiveCreateWithoutAleConfigInput>>;
    createMany?: InputMaybe<AleDepartmentGoLiveCreateManyAleConfigInputEnvelope>;
    delete?: InputMaybe<Array<AleDepartmentGoLiveWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<AleDepartmentGoLiveScalarWhereInput>>;
    disconnect?: InputMaybe<Array<AleDepartmentGoLiveWhereUniqueInput>>;
    set?: InputMaybe<Array<AleDepartmentGoLiveWhereUniqueInput>>;
    update?: InputMaybe<
        Array<AleDepartmentGoLiveUpdateWithWhereUniqueWithoutAleConfigInput>
    >;
    updateMany?: InputMaybe<
        Array<AleDepartmentGoLiveUpdateManyWithWhereWithoutAleConfigInput>
    >;
    upsert?: InputMaybe<
        Array<AleDepartmentGoLiveUpsertWithWhereUniqueWithoutAleConfigInput>
    >;
};

export type AleDepartmentGoLiveUpdateWithWhereUniqueWithoutAleConfigInput = {
    data: AleDepartmentGoLiveUpdateWithoutAleConfigInput;
    where: AleDepartmentGoLiveWhereUniqueInput;
};

export type AleDepartmentGoLiveUpdateWithoutAleConfigInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    departmentIds?: InputMaybe<AleDepartmentGoLiveUpdatedepartmentIdsInput>;
    goLiveDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AleDepartmentGoLiveUpdatedepartmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AleDepartmentGoLiveUpsertWithWhereUniqueWithoutAleConfigInput = {
    create: AleDepartmentGoLiveCreateWithoutAleConfigInput;
    update: AleDepartmentGoLiveUpdateWithoutAleConfigInput;
    where: AleDepartmentGoLiveWhereUniqueInput;
};

export type AleDepartmentGoLiveWhereInput = {
    AND?: InputMaybe<Array<AleDepartmentGoLiveWhereInput>>;
    NOT?: InputMaybe<Array<AleDepartmentGoLiveWhereInput>>;
    OR?: InputMaybe<Array<AleDepartmentGoLiveWhereInput>>;
    aleConfig?: InputMaybe<AleConfigRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    departmentIds?: InputMaybe<StringNullableListFilter>;
    goLiveDate?: InputMaybe<DateTimeFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AleDepartmentGoLiveWhereUniqueInput = {
    AND?: InputMaybe<Array<AleDepartmentGoLiveWhereInput>>;
    NOT?: InputMaybe<Array<AleDepartmentGoLiveWhereInput>>;
    OR?: InputMaybe<Array<AleDepartmentGoLiveWhereInput>>;
    aleConfig?: InputMaybe<AleConfigRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    departmentIds?: InputMaybe<StringNullableListFilter>;
    goLiveDate?: InputMaybe<DateTimeFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgId_goLiveDate?: InputMaybe<AleDepartmentGoLiveOrgIdGoLiveDateCompoundUniqueInput>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum AttachPostCheckRules {
    Always = 'ALWAYS',
    AppointmentTypes = 'APPOINTMENT_TYPES',
    HasCommercialMedicare = 'HAS_COMMERCIAL_MEDICARE',
    HasGovernmentMedicare = 'HAS_GOVERNMENT_MEDICARE',
    HasMedicare = 'HAS_MEDICARE',
    Hrts = 'HRTS',
    IsFemale = 'IS_FEMALE',
    Payers = 'PAYERS',
}

export enum AttachPreCheckRules {
    FirstApptInYear = 'FIRST_APPT_IN_YEAR',
    NewPatient = 'NEW_PATIENT',
    OutsideOfRefreshPeriod = 'OUTSIDE_OF_REFRESH_PERIOD',
}

export enum AutoAddRule {
    AlwaysAttach = 'ALWAYS_ATTACH',
    AttachForHrts = 'ATTACH_FOR_HRTS',
    AttachForPayer = 'ATTACH_FOR_PAYER',
    DoNotAttachForMale = 'DO_NOT_ATTACH_FOR_MALE',
    OnlyAttachOutsideOfRefreshPeriod = 'ONLY_ATTACH_OUTSIDE_OF_REFRESH_PERIOD',
}

export type Adjudication = {
    __typename?: 'Adjudication';
    adjudicatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjudicationAction?: Maybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: Maybe<AdjudicationAppliedStatusEnum>;
    adjudicationType: ArtClaimStatusEnum;
    boughtTreatmentId: Scalars['String']['output'];
    claimId: Scalars['String']['output'];
    claimPayout: Scalars['Float']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrLedgerRowId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds: Array<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentMethodType?: Maybe<AdjudicationPaymentMethodEnum>;
    paymentType: PaymentTypeEnum;
    procedureCode: Scalars['String']['output'];
    secondaryClaimId?: Maybe<Scalars['String']['output']>;
    secondaryClaimIdType?: Maybe<EhrPostIdentifierTypeEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptResponsibility: Scalars['Float']['output'];
    transferredAmount: Scalars['Float']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum AdjudicationActionEnum {
    ExternalPayment = 'EXTERNAL_PAYMENT',
    PayAfter = 'PAY_AFTER',
    Repost = 'REPOST',
    SuperscriptGuarantee = 'SUPERSCRIPT_GUARANTEE',
}

export enum AdjudicationAppliedStatusEnum {
    Applied = 'APPLIED',
    Pending = 'PENDING',
    Voided = 'VOIDED',
}

export type AdjudicationAuditLog = {
    __typename?: 'AdjudicationAuditLog';
    adjudicatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjudicationAction?: Maybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: Maybe<AdjudicationAppliedStatusEnum>;
    adjudicationId?: Maybe<Scalars['String']['output']>;
    adjudicationType?: Maybe<ArtClaimStatusEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimPayout?: Maybe<Scalars['Float']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrLedgerRowId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds: Array<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<AdjudicationPaymentMethodEnum>;
    paymentType?: Maybe<PaymentTypeEnum>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    secondaryClaimId?: Maybe<Scalars['String']['output']>;
    secondaryClaimIdType?: Maybe<EhrPostIdentifierTypeEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AdjudicationAuditLogAvgAggregate = {
    __typename?: 'AdjudicationAuditLogAvgAggregate';
    claimPayout?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
};

export type AdjudicationAuditLogAvgOrderByAggregateInput = {
    claimPayout?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
};

export type AdjudicationAuditLogCountAggregate = {
    __typename?: 'AdjudicationAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    adjudicatedAt: Scalars['Int']['output'];
    adjudicationAction: Scalars['Int']['output'];
    adjudicationAppliedStatus: Scalars['Int']['output'];
    adjudicationId: Scalars['Int']['output'];
    adjudicationType: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    claimPayout: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrAppointmentId: Scalars['Int']['output'];
    ehrLedgerRowId: Scalars['Int']['output'];
    ehrPostLedgerIds: Scalars['Int']['output'];
    ehrSlotId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    metadata: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentMethodType: Scalars['Int']['output'];
    paymentType: Scalars['Int']['output'];
    procedureCode: Scalars['Int']['output'];
    secondaryClaimId: Scalars['Int']['output'];
    secondaryClaimIdType: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    superscriptResponsibility: Scalars['Int']['output'];
    transferredAmount: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type AdjudicationAuditLogCountOrderByAggregateInput = {
    adjudicatedAt?: InputMaybe<SortOrder>;
    adjudicationAction?: InputMaybe<SortOrder>;
    adjudicationAppliedStatus?: InputMaybe<SortOrder>;
    adjudicationId?: InputMaybe<SortOrder>;
    adjudicationType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimPayout?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrLedgerRowId?: InputMaybe<SortOrder>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    secondaryClaimId?: InputMaybe<SortOrder>;
    secondaryClaimIdType?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjudicationAuditLogCreateInput = {
    adjudicatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    adjudicationAction?: InputMaybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: InputMaybe<AdjudicationAppliedStatusEnum>;
    adjudicationId?: InputMaybe<Scalars['String']['input']>;
    adjudicationType?: InputMaybe<ArtClaimStatusEnum>;
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    claimPayout?: InputMaybe<Scalars['Float']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrLedgerRowId?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerIds?: InputMaybe<AdjudicationAuditLogCreateehrPostLedgerIdsInput>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentMethodType?: InputMaybe<AdjudicationPaymentMethodEnum>;
    paymentType?: InputMaybe<PaymentTypeEnum>;
    procedureCode?: InputMaybe<Scalars['String']['input']>;
    secondaryClaimId?: InputMaybe<Scalars['String']['input']>;
    secondaryClaimIdType?: InputMaybe<EhrPostIdentifierTypeEnum>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptResponsibility?: InputMaybe<Scalars['Float']['input']>;
    transferredAmount?: InputMaybe<Scalars['Float']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdjudicationAuditLogCreateManyInput = {
    adjudicatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    adjudicationAction?: InputMaybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: InputMaybe<AdjudicationAppliedStatusEnum>;
    adjudicationId?: InputMaybe<Scalars['String']['input']>;
    adjudicationType?: InputMaybe<ArtClaimStatusEnum>;
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    claimPayout?: InputMaybe<Scalars['Float']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrLedgerRowId?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerIds?: InputMaybe<AdjudicationAuditLogCreateehrPostLedgerIdsInput>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentMethodType?: InputMaybe<AdjudicationPaymentMethodEnum>;
    paymentType?: InputMaybe<PaymentTypeEnum>;
    procedureCode?: InputMaybe<Scalars['String']['input']>;
    secondaryClaimId?: InputMaybe<Scalars['String']['input']>;
    secondaryClaimIdType?: InputMaybe<EhrPostIdentifierTypeEnum>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptResponsibility?: InputMaybe<Scalars['Float']['input']>;
    transferredAmount?: InputMaybe<Scalars['Float']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdjudicationAuditLogCreateehrPostLedgerIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AdjudicationAuditLogGroupBy = {
    __typename?: 'AdjudicationAuditLogGroupBy';
    _avg?: Maybe<AdjudicationAuditLogAvgAggregate>;
    _count?: Maybe<AdjudicationAuditLogCountAggregate>;
    _max?: Maybe<AdjudicationAuditLogMaxAggregate>;
    _min?: Maybe<AdjudicationAuditLogMinAggregate>;
    _sum?: Maybe<AdjudicationAuditLogSumAggregate>;
    adjudicatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjudicationAction?: Maybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: Maybe<AdjudicationAppliedStatusEnum>;
    adjudicationId?: Maybe<Scalars['String']['output']>;
    adjudicationType?: Maybe<ArtClaimStatusEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimPayout?: Maybe<Scalars['Float']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrLedgerRowId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds?: Maybe<Array<Scalars['String']['output']>>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<AdjudicationPaymentMethodEnum>;
    paymentType?: Maybe<PaymentTypeEnum>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    secondaryClaimId?: Maybe<Scalars['String']['output']>;
    secondaryClaimIdType?: Maybe<EhrPostIdentifierTypeEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AdjudicationAuditLogMaxAggregate = {
    __typename?: 'AdjudicationAuditLogMaxAggregate';
    adjudicatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjudicationAction?: Maybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: Maybe<AdjudicationAppliedStatusEnum>;
    adjudicationId?: Maybe<Scalars['String']['output']>;
    adjudicationType?: Maybe<ArtClaimStatusEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimPayout?: Maybe<Scalars['Float']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrLedgerRowId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<AdjudicationPaymentMethodEnum>;
    paymentType?: Maybe<PaymentTypeEnum>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    secondaryClaimId?: Maybe<Scalars['String']['output']>;
    secondaryClaimIdType?: Maybe<EhrPostIdentifierTypeEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdjudicationAuditLogMaxOrderByAggregateInput = {
    adjudicatedAt?: InputMaybe<SortOrder>;
    adjudicationAction?: InputMaybe<SortOrder>;
    adjudicationAppliedStatus?: InputMaybe<SortOrder>;
    adjudicationId?: InputMaybe<SortOrder>;
    adjudicationType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimPayout?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrLedgerRowId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    secondaryClaimId?: InputMaybe<SortOrder>;
    secondaryClaimIdType?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjudicationAuditLogMinAggregate = {
    __typename?: 'AdjudicationAuditLogMinAggregate';
    adjudicatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjudicationAction?: Maybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: Maybe<AdjudicationAppliedStatusEnum>;
    adjudicationId?: Maybe<Scalars['String']['output']>;
    adjudicationType?: Maybe<ArtClaimStatusEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimPayout?: Maybe<Scalars['Float']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrLedgerRowId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<AdjudicationPaymentMethodEnum>;
    paymentType?: Maybe<PaymentTypeEnum>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    secondaryClaimId?: Maybe<Scalars['String']['output']>;
    secondaryClaimIdType?: Maybe<EhrPostIdentifierTypeEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdjudicationAuditLogMinOrderByAggregateInput = {
    adjudicatedAt?: InputMaybe<SortOrder>;
    adjudicationAction?: InputMaybe<SortOrder>;
    adjudicationAppliedStatus?: InputMaybe<SortOrder>;
    adjudicationId?: InputMaybe<SortOrder>;
    adjudicationType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimPayout?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrLedgerRowId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    secondaryClaimId?: InputMaybe<SortOrder>;
    secondaryClaimIdType?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjudicationAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<AdjudicationAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<AdjudicationAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<AdjudicationAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<AdjudicationAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<AdjudicationAuditLogSumOrderByAggregateInput>;
    adjudicatedAt?: InputMaybe<SortOrderInput>;
    adjudicationAction?: InputMaybe<SortOrderInput>;
    adjudicationAppliedStatus?: InputMaybe<SortOrderInput>;
    adjudicationId?: InputMaybe<SortOrderInput>;
    adjudicationType?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    claimId?: InputMaybe<SortOrderInput>;
    claimPayout?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrLedgerRowId?: InputMaybe<SortOrderInput>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    metadata?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    paymentType?: InputMaybe<SortOrderInput>;
    procedureCode?: InputMaybe<SortOrderInput>;
    secondaryClaimId?: InputMaybe<SortOrderInput>;
    secondaryClaimIdType?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    superscriptResponsibility?: InputMaybe<SortOrderInput>;
    transferredAmount?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjudicationAuditLogOrderByWithRelationInput = {
    adjudicatedAt?: InputMaybe<SortOrderInput>;
    adjudicationAction?: InputMaybe<SortOrderInput>;
    adjudicationAppliedStatus?: InputMaybe<SortOrderInput>;
    adjudicationId?: InputMaybe<SortOrderInput>;
    adjudicationType?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    claimId?: InputMaybe<SortOrderInput>;
    claimPayout?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrLedgerRowId?: InputMaybe<SortOrderInput>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    metadata?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    paymentType?: InputMaybe<SortOrderInput>;
    procedureCode?: InputMaybe<SortOrderInput>;
    secondaryClaimId?: InputMaybe<SortOrderInput>;
    secondaryClaimIdType?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    superscriptResponsibility?: InputMaybe<SortOrderInput>;
    transferredAmount?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum AdjudicationAuditLogScalarFieldEnum {
    AdjudicatedAt = 'adjudicatedAt',
    AdjudicationAction = 'adjudicationAction',
    AdjudicationAppliedStatus = 'adjudicationAppliedStatus',
    AdjudicationId = 'adjudicationId',
    AdjudicationType = 'adjudicationType',
    BoughtTreatmentId = 'boughtTreatmentId',
    ClaimId = 'claimId',
    ClaimPayout = 'claimPayout',
    CreatedAt = 'createdAt',
    EhrAppointmentId = 'ehrAppointmentId',
    EhrLedgerRowId = 'ehrLedgerRowId',
    EhrPostLedgerIds = 'ehrPostLedgerIds',
    EhrSlotId = 'ehrSlotId',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Metadata = 'metadata',
    Notes = 'notes',
    Operation = 'operation',
    OrgId = 'orgId',
    PaymentMethodType = 'paymentMethodType',
    PaymentType = 'paymentType',
    ProcedureCode = 'procedureCode',
    SecondaryClaimId = 'secondaryClaimId',
    SecondaryClaimIdType = 'secondaryClaimIdType',
    SlotId = 'slotId',
    SuperscriptResponsibility = 'superscriptResponsibility',
    TransferredAmount = 'transferredAmount',
    UpdatedAt = 'updatedAt',
}

export type AdjudicationAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AdjudicationAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AdjudicationAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AdjudicationAuditLogScalarWhereWithAggregatesInput>>;
    adjudicatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    adjudicationAction?: InputMaybe<EnumAdjudicationActionEnumNullableWithAggregatesFilter>;
    adjudicationAppliedStatus?: InputMaybe<EnumAdjudicationAppliedStatusEnumNullableWithAggregatesFilter>;
    adjudicationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    adjudicationType?: InputMaybe<EnumArtClaimStatusEnumNullableWithAggregatesFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    claimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    claimPayout?: InputMaybe<FloatNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrLedgerRowId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrSlotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    paymentMethodType?: InputMaybe<EnumAdjudicationPaymentMethodEnumNullableWithAggregatesFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumNullableWithAggregatesFilter>;
    procedureCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryClaimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryClaimIdType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableWithAggregatesFilter>;
    slotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    superscriptResponsibility?: InputMaybe<FloatNullableWithAggregatesFilter>;
    transferredAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AdjudicationAuditLogSumAggregate = {
    __typename?: 'AdjudicationAuditLogSumAggregate';
    claimPayout?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
};

export type AdjudicationAuditLogSumOrderByAggregateInput = {
    claimPayout?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
};

export type AdjudicationAuditLogUpdateInput = {
    adjudicatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    adjudicationAction?: InputMaybe<NullableEnumAdjudicationActionEnumFieldUpdateOperationsInput>;
    adjudicationAppliedStatus?: InputMaybe<NullableEnumAdjudicationAppliedStatusEnumFieldUpdateOperationsInput>;
    adjudicationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    adjudicationType?: InputMaybe<NullableEnumArtClaimStatusEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimPayout?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLedgerRowId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerIds?: InputMaybe<AdjudicationAuditLogUpdateehrPostLedgerIdsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumAdjudicationPaymentMethodEnumFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<NullableEnumPaymentTypeEnumFieldUpdateOperationsInput>;
    procedureCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryClaimIdType?: InputMaybe<NullableEnumEhrPostIdentifierTypeEnumFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    transferredAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdjudicationAuditLogUpdateManyMutationInput = {
    adjudicatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    adjudicationAction?: InputMaybe<NullableEnumAdjudicationActionEnumFieldUpdateOperationsInput>;
    adjudicationAppliedStatus?: InputMaybe<NullableEnumAdjudicationAppliedStatusEnumFieldUpdateOperationsInput>;
    adjudicationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    adjudicationType?: InputMaybe<NullableEnumArtClaimStatusEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimPayout?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLedgerRowId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerIds?: InputMaybe<AdjudicationAuditLogUpdateehrPostLedgerIdsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumAdjudicationPaymentMethodEnumFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<NullableEnumPaymentTypeEnumFieldUpdateOperationsInput>;
    procedureCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryClaimIdType?: InputMaybe<NullableEnumEhrPostIdentifierTypeEnumFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    transferredAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdjudicationAuditLogUpdateehrPostLedgerIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdjudicationAuditLogWhereInput = {
    AND?: InputMaybe<Array<AdjudicationAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<AdjudicationAuditLogWhereInput>>;
    OR?: InputMaybe<Array<AdjudicationAuditLogWhereInput>>;
    adjudicatedAt?: InputMaybe<DateTimeNullableFilter>;
    adjudicationAction?: InputMaybe<EnumAdjudicationActionEnumNullableFilter>;
    adjudicationAppliedStatus?: InputMaybe<EnumAdjudicationAppliedStatusEnumNullableFilter>;
    adjudicationId?: InputMaybe<UuidNullableFilter>;
    adjudicationType?: InputMaybe<EnumArtClaimStatusEnumNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    claimPayout?: InputMaybe<FloatNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrLedgerRowId?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentMethodType?: InputMaybe<EnumAdjudicationPaymentMethodEnumNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumNullableFilter>;
    procedureCode?: InputMaybe<StringNullableFilter>;
    secondaryClaimId?: InputMaybe<StringNullableFilter>;
    secondaryClaimIdType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    superscriptResponsibility?: InputMaybe<FloatNullableFilter>;
    transferredAmount?: InputMaybe<FloatNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdjudicationAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<AdjudicationAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<AdjudicationAuditLogWhereInput>>;
    OR?: InputMaybe<Array<AdjudicationAuditLogWhereInput>>;
    adjudicatedAt?: InputMaybe<DateTimeNullableFilter>;
    adjudicationAction?: InputMaybe<EnumAdjudicationActionEnumNullableFilter>;
    adjudicationAppliedStatus?: InputMaybe<EnumAdjudicationAppliedStatusEnumNullableFilter>;
    adjudicationId?: InputMaybe<UuidNullableFilter>;
    adjudicationType?: InputMaybe<EnumArtClaimStatusEnumNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    claimPayout?: InputMaybe<FloatNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrLedgerRowId?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentMethodType?: InputMaybe<EnumAdjudicationPaymentMethodEnumNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumNullableFilter>;
    procedureCode?: InputMaybe<StringNullableFilter>;
    secondaryClaimId?: InputMaybe<StringNullableFilter>;
    secondaryClaimIdType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    superscriptResponsibility?: InputMaybe<FloatNullableFilter>;
    transferredAmount?: InputMaybe<FloatNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdjudicationAvgAggregate = {
    __typename?: 'AdjudicationAvgAggregate';
    claimPayout?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
};

export type AdjudicationAvgOrderByAggregateInput = {
    claimPayout?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
};

export type AdjudicationCountAggregate = {
    __typename?: 'AdjudicationCountAggregate';
    _all: Scalars['Int']['output'];
    adjudicatedAt: Scalars['Int']['output'];
    adjudicationAction: Scalars['Int']['output'];
    adjudicationAppliedStatus: Scalars['Int']['output'];
    adjudicationType: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    claimPayout: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrAppointmentId: Scalars['Int']['output'];
    ehrLedgerRowId: Scalars['Int']['output'];
    ehrPostLedgerIds: Scalars['Int']['output'];
    ehrSlotId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    metadata: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentMethodType: Scalars['Int']['output'];
    paymentType: Scalars['Int']['output'];
    procedureCode: Scalars['Int']['output'];
    secondaryClaimId: Scalars['Int']['output'];
    secondaryClaimIdType: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    superscriptResponsibility: Scalars['Int']['output'];
    transferredAmount: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type AdjudicationCountOrderByAggregateInput = {
    adjudicatedAt?: InputMaybe<SortOrder>;
    adjudicationAction?: InputMaybe<SortOrder>;
    adjudicationAppliedStatus?: InputMaybe<SortOrder>;
    adjudicationType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimPayout?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrLedgerRowId?: InputMaybe<SortOrder>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    secondaryClaimId?: InputMaybe<SortOrder>;
    secondaryClaimIdType?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjudicationCreateInput = {
    adjudicatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    adjudicationAction?: InputMaybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: InputMaybe<AdjudicationAppliedStatusEnum>;
    adjudicationType: ArtClaimStatusEnum;
    boughtTreatmentId: Scalars['String']['input'];
    claimId: Scalars['String']['input'];
    claimPayout: Scalars['Float']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrLedgerRowId?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerIds?: InputMaybe<AdjudicationCreateehrPostLedgerIdsInput>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentMethodType?: InputMaybe<AdjudicationPaymentMethodEnum>;
    paymentType: PaymentTypeEnum;
    procedureCode: Scalars['String']['input'];
    secondaryClaimId?: InputMaybe<Scalars['String']['input']>;
    secondaryClaimIdType?: InputMaybe<EhrPostIdentifierTypeEnum>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptResponsibility: Scalars['Float']['input'];
    transferredAmount: Scalars['Float']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdjudicationCreateManyInput = {
    adjudicatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    adjudicationAction?: InputMaybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: InputMaybe<AdjudicationAppliedStatusEnum>;
    adjudicationType: ArtClaimStatusEnum;
    boughtTreatmentId: Scalars['String']['input'];
    claimId: Scalars['String']['input'];
    claimPayout: Scalars['Float']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrLedgerRowId?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerIds?: InputMaybe<AdjudicationCreateehrPostLedgerIdsInput>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentMethodType?: InputMaybe<AdjudicationPaymentMethodEnum>;
    paymentType: PaymentTypeEnum;
    procedureCode: Scalars['String']['input'];
    secondaryClaimId?: InputMaybe<Scalars['String']['input']>;
    secondaryClaimIdType?: InputMaybe<EhrPostIdentifierTypeEnum>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptResponsibility: Scalars['Float']['input'];
    transferredAmount: Scalars['Float']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdjudicationCreateehrPostLedgerIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AdjudicationGroupBy = {
    __typename?: 'AdjudicationGroupBy';
    _avg?: Maybe<AdjudicationAvgAggregate>;
    _count?: Maybe<AdjudicationCountAggregate>;
    _max?: Maybe<AdjudicationMaxAggregate>;
    _min?: Maybe<AdjudicationMinAggregate>;
    _sum?: Maybe<AdjudicationSumAggregate>;
    adjudicatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjudicationAction?: Maybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: Maybe<AdjudicationAppliedStatusEnum>;
    adjudicationType: ArtClaimStatusEnum;
    boughtTreatmentId: Scalars['String']['output'];
    claimId: Scalars['String']['output'];
    claimPayout: Scalars['Float']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrLedgerRowId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds?: Maybe<Array<Scalars['String']['output']>>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentMethodType?: Maybe<AdjudicationPaymentMethodEnum>;
    paymentType: PaymentTypeEnum;
    procedureCode: Scalars['String']['output'];
    secondaryClaimId?: Maybe<Scalars['String']['output']>;
    secondaryClaimIdType?: Maybe<EhrPostIdentifierTypeEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptResponsibility: Scalars['Float']['output'];
    transferredAmount: Scalars['Float']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdjudicationMaxAggregate = {
    __typename?: 'AdjudicationMaxAggregate';
    adjudicatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjudicationAction?: Maybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: Maybe<AdjudicationAppliedStatusEnum>;
    adjudicationType?: Maybe<ArtClaimStatusEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimPayout?: Maybe<Scalars['Float']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrLedgerRowId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<AdjudicationPaymentMethodEnum>;
    paymentType?: Maybe<PaymentTypeEnum>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    secondaryClaimId?: Maybe<Scalars['String']['output']>;
    secondaryClaimIdType?: Maybe<EhrPostIdentifierTypeEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdjudicationMaxOrderByAggregateInput = {
    adjudicatedAt?: InputMaybe<SortOrder>;
    adjudicationAction?: InputMaybe<SortOrder>;
    adjudicationAppliedStatus?: InputMaybe<SortOrder>;
    adjudicationType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimPayout?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrLedgerRowId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    secondaryClaimId?: InputMaybe<SortOrder>;
    secondaryClaimIdType?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjudicationMinAggregate = {
    __typename?: 'AdjudicationMinAggregate';
    adjudicatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjudicationAction?: Maybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: Maybe<AdjudicationAppliedStatusEnum>;
    adjudicationType?: Maybe<ArtClaimStatusEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimPayout?: Maybe<Scalars['Float']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrLedgerRowId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<AdjudicationPaymentMethodEnum>;
    paymentType?: Maybe<PaymentTypeEnum>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    secondaryClaimId?: Maybe<Scalars['String']['output']>;
    secondaryClaimIdType?: Maybe<EhrPostIdentifierTypeEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdjudicationMinOrderByAggregateInput = {
    adjudicatedAt?: InputMaybe<SortOrder>;
    adjudicationAction?: InputMaybe<SortOrder>;
    adjudicationAppliedStatus?: InputMaybe<SortOrder>;
    adjudicationType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimPayout?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrLedgerRowId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    secondaryClaimId?: InputMaybe<SortOrder>;
    secondaryClaimIdType?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjudicationOrderByWithAggregationInput = {
    _avg?: InputMaybe<AdjudicationAvgOrderByAggregateInput>;
    _count?: InputMaybe<AdjudicationCountOrderByAggregateInput>;
    _max?: InputMaybe<AdjudicationMaxOrderByAggregateInput>;
    _min?: InputMaybe<AdjudicationMinOrderByAggregateInput>;
    _sum?: InputMaybe<AdjudicationSumOrderByAggregateInput>;
    adjudicatedAt?: InputMaybe<SortOrderInput>;
    adjudicationAction?: InputMaybe<SortOrderInput>;
    adjudicationAppliedStatus?: InputMaybe<SortOrderInput>;
    adjudicationType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimPayout?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrLedgerRowId?: InputMaybe<SortOrderInput>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    metadata?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    paymentType?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    secondaryClaimId?: InputMaybe<SortOrderInput>;
    secondaryClaimIdType?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export type AdjudicationOrderByWithRelationInput = {
    adjudicatedAt?: InputMaybe<SortOrderInput>;
    adjudicationAction?: InputMaybe<SortOrderInput>;
    adjudicationAppliedStatus?: InputMaybe<SortOrderInput>;
    adjudicationType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimPayout?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrLedgerRowId?: InputMaybe<SortOrderInput>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    metadata?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    paymentType?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    secondaryClaimId?: InputMaybe<SortOrderInput>;
    secondaryClaimIdType?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export enum AdjudicationPaymentMethodEnum {
    Card = 'CARD',
    Cash = 'CASH',
    Check = 'CHECK',
    ExternalPayment = 'EXTERNAL_PAYMENT',
}

export enum AdjudicationScalarFieldEnum {
    AdjudicatedAt = 'adjudicatedAt',
    AdjudicationAction = 'adjudicationAction',
    AdjudicationAppliedStatus = 'adjudicationAppliedStatus',
    AdjudicationType = 'adjudicationType',
    BoughtTreatmentId = 'boughtTreatmentId',
    ClaimId = 'claimId',
    ClaimPayout = 'claimPayout',
    CreatedAt = 'createdAt',
    EhrAppointmentId = 'ehrAppointmentId',
    EhrLedgerRowId = 'ehrLedgerRowId',
    EhrPostLedgerIds = 'ehrPostLedgerIds',
    EhrSlotId = 'ehrSlotId',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Metadata = 'metadata',
    Notes = 'notes',
    OrgId = 'orgId',
    PaymentMethodType = 'paymentMethodType',
    PaymentType = 'paymentType',
    ProcedureCode = 'procedureCode',
    SecondaryClaimId = 'secondaryClaimId',
    SecondaryClaimIdType = 'secondaryClaimIdType',
    SlotId = 'slotId',
    SuperscriptResponsibility = 'superscriptResponsibility',
    TransferredAmount = 'transferredAmount',
    UpdatedAt = 'updatedAt',
}

export type AdjudicationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AdjudicationScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AdjudicationScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AdjudicationScalarWhereWithAggregatesInput>>;
    adjudicatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    adjudicationAction?: InputMaybe<EnumAdjudicationActionEnumNullableWithAggregatesFilter>;
    adjudicationAppliedStatus?: InputMaybe<EnumAdjudicationAppliedStatusEnumNullableWithAggregatesFilter>;
    adjudicationType?: InputMaybe<EnumArtClaimStatusEnumWithAggregatesFilter>;
    boughtTreatmentId?: InputMaybe<UuidWithAggregatesFilter>;
    claimId?: InputMaybe<StringWithAggregatesFilter>;
    claimPayout?: InputMaybe<FloatWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrLedgerRowId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrSlotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    paymentMethodType?: InputMaybe<EnumAdjudicationPaymentMethodEnumNullableWithAggregatesFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumWithAggregatesFilter>;
    procedureCode?: InputMaybe<StringWithAggregatesFilter>;
    secondaryClaimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryClaimIdType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableWithAggregatesFilter>;
    slotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    superscriptResponsibility?: InputMaybe<FloatWithAggregatesFilter>;
    transferredAmount?: InputMaybe<FloatWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type AdjudicationSumAggregate = {
    __typename?: 'AdjudicationSumAggregate';
    claimPayout?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
};

export type AdjudicationSumOrderByAggregateInput = {
    claimPayout?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    superscriptResponsibility?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
};

export enum AdjudicationType {
    Denial = 'DENIAL',
    Generic = 'GENERIC',
    Selfpay = 'SELFPAY',
}

export type AdjudicationUpdateInput = {
    adjudicatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    adjudicationAction?: InputMaybe<NullableEnumAdjudicationActionEnumFieldUpdateOperationsInput>;
    adjudicationAppliedStatus?: InputMaybe<NullableEnumAdjudicationAppliedStatusEnumFieldUpdateOperationsInput>;
    adjudicationType?: InputMaybe<EnumArtClaimStatusEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimPayout?: InputMaybe<FloatFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLedgerRowId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerIds?: InputMaybe<AdjudicationUpdateehrPostLedgerIdsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumAdjudicationPaymentMethodEnumFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFieldUpdateOperationsInput>;
    procedureCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    secondaryClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryClaimIdType?: InputMaybe<NullableEnumEhrPostIdentifierTypeEnumFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptResponsibility?: InputMaybe<FloatFieldUpdateOperationsInput>;
    transferredAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AdjudicationUpdateManyMutationInput = {
    adjudicatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    adjudicationAction?: InputMaybe<NullableEnumAdjudicationActionEnumFieldUpdateOperationsInput>;
    adjudicationAppliedStatus?: InputMaybe<NullableEnumAdjudicationAppliedStatusEnumFieldUpdateOperationsInput>;
    adjudicationType?: InputMaybe<EnumArtClaimStatusEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimPayout?: InputMaybe<FloatFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLedgerRowId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerIds?: InputMaybe<AdjudicationUpdateehrPostLedgerIdsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumAdjudicationPaymentMethodEnumFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFieldUpdateOperationsInput>;
    procedureCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    secondaryClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryClaimIdType?: InputMaybe<NullableEnumEhrPostIdentifierTypeEnumFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptResponsibility?: InputMaybe<FloatFieldUpdateOperationsInput>;
    transferredAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AdjudicationUpdateehrPostLedgerIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdjudicationWhereInput = {
    AND?: InputMaybe<Array<AdjudicationWhereInput>>;
    NOT?: InputMaybe<Array<AdjudicationWhereInput>>;
    OR?: InputMaybe<Array<AdjudicationWhereInput>>;
    adjudicatedAt?: InputMaybe<DateTimeNullableFilter>;
    adjudicationAction?: InputMaybe<EnumAdjudicationActionEnumNullableFilter>;
    adjudicationAppliedStatus?: InputMaybe<EnumAdjudicationAppliedStatusEnumNullableFilter>;
    adjudicationType?: InputMaybe<EnumArtClaimStatusEnumFilter>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    claimId?: InputMaybe<StringFilter>;
    claimPayout?: InputMaybe<FloatFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrLedgerRowId?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentMethodType?: InputMaybe<EnumAdjudicationPaymentMethodEnumNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFilter>;
    procedureCode?: InputMaybe<StringFilter>;
    secondaryClaimId?: InputMaybe<StringNullableFilter>;
    secondaryClaimIdType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    superscriptResponsibility?: InputMaybe<FloatFilter>;
    transferredAmount?: InputMaybe<FloatFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type AdjudicationWhereUniqueInput = {
    AND?: InputMaybe<Array<AdjudicationWhereInput>>;
    NOT?: InputMaybe<Array<AdjudicationWhereInput>>;
    OR?: InputMaybe<Array<AdjudicationWhereInput>>;
    adjudicatedAt?: InputMaybe<DateTimeNullableFilter>;
    adjudicationAction?: InputMaybe<EnumAdjudicationActionEnumNullableFilter>;
    adjudicationAppliedStatus?: InputMaybe<EnumAdjudicationAppliedStatusEnumNullableFilter>;
    adjudicationType?: InputMaybe<EnumArtClaimStatusEnumFilter>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    claimId?: InputMaybe<StringFilter>;
    claimPayout?: InputMaybe<FloatFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrLedgerRowId?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentMethodType?: InputMaybe<EnumAdjudicationPaymentMethodEnumNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFilter>;
    procedureCode?: InputMaybe<StringFilter>;
    secondaryClaimId?: InputMaybe<StringNullableFilter>;
    secondaryClaimIdType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    superscriptResponsibility?: InputMaybe<FloatFilter>;
    transferredAmount?: InputMaybe<FloatFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type Adjustment = {
    __typename?: 'Adjustment';
    adjustedBoughtTreatmentPrice: Scalars['Float']['output'];
    adjustmentAmount: Scalars['Float']['output'];
    adjustmentAppliedStatus?: Maybe<AdjustmentAppliedStatusEnum>;
    adjustmentType: AdjustmentTypeEnum;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    boughtTreatmentId: Scalars['String']['output'];
    claimIds: Array<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds: Array<Scalars['String']['output']>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    ehrReconciliationTransactionIds: Array<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    originalBoughtTreatmentPrice: Scalars['Float']['output'];
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    procedureCodes: Array<Scalars['String']['output']>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
    slotId: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum AdjustmentAckActionEnum {
    Applied = 'APPLIED',
    Dismissed = 'DISMISSED',
}

export enum AdjustmentAckRoleEnum {
    Admin = 'ADMIN',
    Patient = 'PATIENT',
}

export enum AdjustmentAppliedStatusEnum {
    Applied = 'APPLIED',
    Pending = 'PENDING',
    Voided = 'VOIDED',
}

export type AdjustmentAuditLog = {
    __typename?: 'AdjustmentAuditLog';
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    adjustmentAppliedStatus?: Maybe<AdjustmentAppliedStatusEnum>;
    adjustmentId?: Maybe<Scalars['String']['output']>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimIds: Array<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds: Array<Scalars['String']['output']>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    ehrReconciliationTransactionIds: Array<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    procedureCodes: Array<Scalars['String']['output']>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AdjustmentAuditLogAvgAggregate = {
    __typename?: 'AdjustmentAuditLogAvgAggregate';
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
};

export type AdjustmentAuditLogAvgOrderByAggregateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    moneyRefundAmount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrder>;
};

export type AdjustmentAuditLogCountAggregate = {
    __typename?: 'AdjustmentAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    adjustedBoughtTreatmentPrice: Scalars['Int']['output'];
    adjustmentAmount: Scalars['Int']['output'];
    adjustmentAppliedStatus: Scalars['Int']['output'];
    adjustmentId: Scalars['Int']['output'];
    adjustmentType: Scalars['Int']['output'];
    autoRefundAdjustmentValue: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    claimIds: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrPostLedgerId: Scalars['Int']['output'];
    ehrPostLedgerIds: Scalars['Int']['output'];
    ehrReconciliationAmount: Scalars['Int']['output'];
    ehrReconciliationTransactionIds: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    metadata: Scalars['Int']['output'];
    moneyRefundAmount: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    originalBoughtTreatmentPrice: Scalars['Int']['output'];
    priceSwapAdjustmentValue: Scalars['Int']['output'];
    procedureCodes: Scalars['Int']['output'];
    refundFromCollectedAmount: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type AdjustmentAuditLogCountOrderByAggregateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    adjustmentAppliedStatus?: InputMaybe<SortOrder>;
    adjustmentId?: InputMaybe<SortOrder>;
    adjustmentType?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrder>;
    ehrReconciliationTransactionIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    moneyRefundAmount?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjustmentAuditLogCreateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<Scalars['Float']['input']>;
    adjustmentAmount?: InputMaybe<Scalars['Float']['input']>;
    adjustmentAppliedStatus?: InputMaybe<AdjustmentAppliedStatusEnum>;
    adjustmentId?: InputMaybe<Scalars['String']['input']>;
    adjustmentType?: InputMaybe<AdjustmentTypeEnum>;
    autoRefundAdjustmentValue?: InputMaybe<Scalars['Float']['input']>;
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    claimIds?: InputMaybe<AdjustmentAuditLogCreateclaimIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerIds?: InputMaybe<AdjustmentAuditLogCreateehrPostLedgerIdsInput>;
    ehrReconciliationAmount?: InputMaybe<Scalars['Float']['input']>;
    ehrReconciliationTransactionIds?: InputMaybe<AdjustmentAuditLogCreateehrReconciliationTransactionIdsInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    moneyRefundAmount?: InputMaybe<Scalars['Float']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    originalBoughtTreatmentPrice?: InputMaybe<Scalars['Float']['input']>;
    priceSwapAdjustmentValue?: InputMaybe<Scalars['Float']['input']>;
    procedureCodes?: InputMaybe<AdjustmentAuditLogCreateprocedureCodesInput>;
    refundFromCollectedAmount?: InputMaybe<Scalars['Float']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdjustmentAuditLogCreateManyInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<Scalars['Float']['input']>;
    adjustmentAmount?: InputMaybe<Scalars['Float']['input']>;
    adjustmentAppliedStatus?: InputMaybe<AdjustmentAppliedStatusEnum>;
    adjustmentId?: InputMaybe<Scalars['String']['input']>;
    adjustmentType?: InputMaybe<AdjustmentTypeEnum>;
    autoRefundAdjustmentValue?: InputMaybe<Scalars['Float']['input']>;
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    claimIds?: InputMaybe<AdjustmentAuditLogCreateclaimIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerIds?: InputMaybe<AdjustmentAuditLogCreateehrPostLedgerIdsInput>;
    ehrReconciliationAmount?: InputMaybe<Scalars['Float']['input']>;
    ehrReconciliationTransactionIds?: InputMaybe<AdjustmentAuditLogCreateehrReconciliationTransactionIdsInput>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    moneyRefundAmount?: InputMaybe<Scalars['Float']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    originalBoughtTreatmentPrice?: InputMaybe<Scalars['Float']['input']>;
    priceSwapAdjustmentValue?: InputMaybe<Scalars['Float']['input']>;
    procedureCodes?: InputMaybe<AdjustmentAuditLogCreateprocedureCodesInput>;
    refundFromCollectedAmount?: InputMaybe<Scalars['Float']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdjustmentAuditLogCreateclaimIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AdjustmentAuditLogCreateehrPostLedgerIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AdjustmentAuditLogCreateehrReconciliationTransactionIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AdjustmentAuditLogCreateprocedureCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type AdjustmentAuditLogGroupBy = {
    __typename?: 'AdjustmentAuditLogGroupBy';
    _avg?: Maybe<AdjustmentAuditLogAvgAggregate>;
    _count?: Maybe<AdjustmentAuditLogCountAggregate>;
    _max?: Maybe<AdjustmentAuditLogMaxAggregate>;
    _min?: Maybe<AdjustmentAuditLogMinAggregate>;
    _sum?: Maybe<AdjustmentAuditLogSumAggregate>;
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    adjustmentAppliedStatus?: Maybe<AdjustmentAppliedStatusEnum>;
    adjustmentId?: Maybe<Scalars['String']['output']>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds?: Maybe<Array<Scalars['String']['output']>>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    ehrReconciliationTransactionIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    procedureCodes?: Maybe<Array<Scalars['String']['output']>>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AdjustmentAuditLogMaxAggregate = {
    __typename?: 'AdjustmentAuditLogMaxAggregate';
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    adjustmentAppliedStatus?: Maybe<AdjustmentAppliedStatusEnum>;
    adjustmentId?: Maybe<Scalars['String']['output']>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdjustmentAuditLogMaxOrderByAggregateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    adjustmentAppliedStatus?: InputMaybe<SortOrder>;
    adjustmentId?: InputMaybe<SortOrder>;
    adjustmentType?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    moneyRefundAmount?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjustmentAuditLogMinAggregate = {
    __typename?: 'AdjustmentAuditLogMinAggregate';
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    adjustmentAppliedStatus?: Maybe<AdjustmentAppliedStatusEnum>;
    adjustmentId?: Maybe<Scalars['String']['output']>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdjustmentAuditLogMinOrderByAggregateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    adjustmentAppliedStatus?: InputMaybe<SortOrder>;
    adjustmentId?: InputMaybe<SortOrder>;
    adjustmentType?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    moneyRefundAmount?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjustmentAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<AdjustmentAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<AdjustmentAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<AdjustmentAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<AdjustmentAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<AdjustmentAuditLogSumOrderByAggregateInput>;
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrderInput>;
    adjustmentAmount?: InputMaybe<SortOrderInput>;
    adjustmentAppliedStatus?: InputMaybe<SortOrderInput>;
    adjustmentId?: InputMaybe<SortOrderInput>;
    adjustmentType?: InputMaybe<SortOrderInput>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    claimIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrderInput>;
    ehrReconciliationTransactionIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    metadata?: InputMaybe<SortOrderInput>;
    moneyRefundAmount?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrderInput>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrderInput>;
    procedureCodes?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjustmentAuditLogOrderByWithRelationInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrderInput>;
    adjustmentAmount?: InputMaybe<SortOrderInput>;
    adjustmentAppliedStatus?: InputMaybe<SortOrderInput>;
    adjustmentId?: InputMaybe<SortOrderInput>;
    adjustmentType?: InputMaybe<SortOrderInput>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    claimIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrderInput>;
    ehrReconciliationTransactionIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    metadata?: InputMaybe<SortOrderInput>;
    moneyRefundAmount?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrderInput>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrderInput>;
    procedureCodes?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum AdjustmentAuditLogScalarFieldEnum {
    AdjustedBoughtTreatmentPrice = 'adjustedBoughtTreatmentPrice',
    AdjustmentAmount = 'adjustmentAmount',
    AdjustmentAppliedStatus = 'adjustmentAppliedStatus',
    AdjustmentId = 'adjustmentId',
    AdjustmentType = 'adjustmentType',
    AutoRefundAdjustmentValue = 'autoRefundAdjustmentValue',
    BoughtTreatmentId = 'boughtTreatmentId',
    ClaimIds = 'claimIds',
    CreatedAt = 'createdAt',
    EhrPostLedgerId = 'ehrPostLedgerId',
    EhrPostLedgerIds = 'ehrPostLedgerIds',
    EhrReconciliationAmount = 'ehrReconciliationAmount',
    EhrReconciliationTransactionIds = 'ehrReconciliationTransactionIds',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Metadata = 'metadata',
    MoneyRefundAmount = 'moneyRefundAmount',
    Notes = 'notes',
    Operation = 'operation',
    OrgId = 'orgId',
    OriginalBoughtTreatmentPrice = 'originalBoughtTreatmentPrice',
    PriceSwapAdjustmentValue = 'priceSwapAdjustmentValue',
    ProcedureCodes = 'procedureCodes',
    RefundFromCollectedAmount = 'refundFromCollectedAmount',
    SlotId = 'slotId',
    UpdatedAt = 'updatedAt',
}

export type AdjustmentAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AdjustmentAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AdjustmentAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AdjustmentAuditLogScalarWhereWithAggregatesInput>>;
    adjustedBoughtTreatmentPrice?: InputMaybe<FloatNullableWithAggregatesFilter>;
    adjustmentAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    adjustmentAppliedStatus?: InputMaybe<EnumAdjustmentAppliedStatusEnumNullableWithAggregatesFilter>;
    adjustmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumNullableWithAggregatesFilter>;
    autoRefundAdjustmentValue?: InputMaybe<FloatNullableWithAggregatesFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    claimIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrReconciliationAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    ehrReconciliationTransactionIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    moneyRefundAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    originalBoughtTreatmentPrice?: InputMaybe<FloatNullableWithAggregatesFilter>;
    priceSwapAdjustmentValue?: InputMaybe<FloatNullableWithAggregatesFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    refundFromCollectedAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    slotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AdjustmentAuditLogSumAggregate = {
    __typename?: 'AdjustmentAuditLogSumAggregate';
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
};

export type AdjustmentAuditLogSumOrderByAggregateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    moneyRefundAmount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrder>;
};

export type AdjustmentAuditLogUpdateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    adjustmentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    adjustmentAppliedStatus?: InputMaybe<NullableEnumAdjustmentAppliedStatusEnumFieldUpdateOperationsInput>;
    adjustmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    adjustmentType?: InputMaybe<NullableEnumAdjustmentTypeEnumFieldUpdateOperationsInput>;
    autoRefundAdjustmentValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimIds?: InputMaybe<AdjustmentAuditLogUpdateclaimIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerIds?: InputMaybe<AdjustmentAuditLogUpdateehrPostLedgerIdsInput>;
    ehrReconciliationAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrReconciliationTransactionIds?: InputMaybe<AdjustmentAuditLogUpdateehrReconciliationTransactionIdsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    moneyRefundAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    originalBoughtTreatmentPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    priceSwapAdjustmentValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    procedureCodes?: InputMaybe<AdjustmentAuditLogUpdateprocedureCodesInput>;
    refundFromCollectedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdjustmentAuditLogUpdateManyMutationInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    adjustmentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    adjustmentAppliedStatus?: InputMaybe<NullableEnumAdjustmentAppliedStatusEnumFieldUpdateOperationsInput>;
    adjustmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    adjustmentType?: InputMaybe<NullableEnumAdjustmentTypeEnumFieldUpdateOperationsInput>;
    autoRefundAdjustmentValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimIds?: InputMaybe<AdjustmentAuditLogUpdateclaimIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerIds?: InputMaybe<AdjustmentAuditLogUpdateehrPostLedgerIdsInput>;
    ehrReconciliationAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrReconciliationTransactionIds?: InputMaybe<AdjustmentAuditLogUpdateehrReconciliationTransactionIdsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    moneyRefundAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    originalBoughtTreatmentPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    priceSwapAdjustmentValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    procedureCodes?: InputMaybe<AdjustmentAuditLogUpdateprocedureCodesInput>;
    refundFromCollectedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdjustmentAuditLogUpdateclaimIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdjustmentAuditLogUpdateehrPostLedgerIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdjustmentAuditLogUpdateehrReconciliationTransactionIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdjustmentAuditLogUpdateprocedureCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdjustmentAuditLogWhereInput = {
    AND?: InputMaybe<Array<AdjustmentAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<AdjustmentAuditLogWhereInput>>;
    OR?: InputMaybe<Array<AdjustmentAuditLogWhereInput>>;
    adjustedBoughtTreatmentPrice?: InputMaybe<FloatNullableFilter>;
    adjustmentAmount?: InputMaybe<FloatNullableFilter>;
    adjustmentAppliedStatus?: InputMaybe<EnumAdjustmentAppliedStatusEnumNullableFilter>;
    adjustmentId?: InputMaybe<UuidNullableFilter>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumNullableFilter>;
    autoRefundAdjustmentValue?: InputMaybe<FloatNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    claimIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrReconciliationAmount?: InputMaybe<FloatNullableFilter>;
    ehrReconciliationTransactionIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    moneyRefundAmount?: InputMaybe<FloatNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    originalBoughtTreatmentPrice?: InputMaybe<FloatNullableFilter>;
    priceSwapAdjustmentValue?: InputMaybe<FloatNullableFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    refundFromCollectedAmount?: InputMaybe<FloatNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdjustmentAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<AdjustmentAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<AdjustmentAuditLogWhereInput>>;
    OR?: InputMaybe<Array<AdjustmentAuditLogWhereInput>>;
    adjustedBoughtTreatmentPrice?: InputMaybe<FloatNullableFilter>;
    adjustmentAmount?: InputMaybe<FloatNullableFilter>;
    adjustmentAppliedStatus?: InputMaybe<EnumAdjustmentAppliedStatusEnumNullableFilter>;
    adjustmentId?: InputMaybe<UuidNullableFilter>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumNullableFilter>;
    autoRefundAdjustmentValue?: InputMaybe<FloatNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    claimIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrReconciliationAmount?: InputMaybe<FloatNullableFilter>;
    ehrReconciliationTransactionIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    moneyRefundAmount?: InputMaybe<FloatNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    originalBoughtTreatmentPrice?: InputMaybe<FloatNullableFilter>;
    priceSwapAdjustmentValue?: InputMaybe<FloatNullableFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    refundFromCollectedAmount?: InputMaybe<FloatNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdjustmentAvgAggregate = {
    __typename?: 'AdjustmentAvgAggregate';
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
};

export type AdjustmentAvgOrderByAggregateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrder>;
    moneyRefundAmount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrder>;
};

export type AdjustmentCountAggregate = {
    __typename?: 'AdjustmentCountAggregate';
    _all: Scalars['Int']['output'];
    adjustedBoughtTreatmentPrice: Scalars['Int']['output'];
    adjustmentAmount: Scalars['Int']['output'];
    adjustmentAppliedStatus: Scalars['Int']['output'];
    adjustmentType: Scalars['Int']['output'];
    autoRefundAdjustmentValue: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    claimIds: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrPostLedgerId: Scalars['Int']['output'];
    ehrPostLedgerIds: Scalars['Int']['output'];
    ehrReconciliationAmount: Scalars['Int']['output'];
    ehrReconciliationTransactionIds: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    metadata: Scalars['Int']['output'];
    moneyRefundAmount: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    originalBoughtTreatmentPrice: Scalars['Int']['output'];
    priceSwapAdjustmentValue: Scalars['Int']['output'];
    procedureCodes: Scalars['Int']['output'];
    refundFromCollectedAmount: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type AdjustmentCountOrderByAggregateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    adjustmentAppliedStatus?: InputMaybe<SortOrder>;
    adjustmentType?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrder>;
    ehrReconciliationTransactionIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    moneyRefundAmount?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjustmentCreateInput = {
    adjustedBoughtTreatmentPrice: Scalars['Float']['input'];
    adjustmentAmount: Scalars['Float']['input'];
    adjustmentAppliedStatus?: InputMaybe<AdjustmentAppliedStatusEnum>;
    adjustmentType: AdjustmentTypeEnum;
    autoRefundAdjustmentValue?: InputMaybe<Scalars['Float']['input']>;
    boughtTreatmentId: Scalars['String']['input'];
    claimIds?: InputMaybe<AdjustmentCreateclaimIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerIds?: InputMaybe<AdjustmentCreateehrPostLedgerIdsInput>;
    ehrReconciliationAmount?: InputMaybe<Scalars['Float']['input']>;
    ehrReconciliationTransactionIds?: InputMaybe<AdjustmentCreateehrReconciliationTransactionIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    moneyRefundAmount?: InputMaybe<Scalars['Float']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    originalBoughtTreatmentPrice: Scalars['Float']['input'];
    priceSwapAdjustmentValue?: InputMaybe<Scalars['Float']['input']>;
    procedureCodes?: InputMaybe<AdjustmentCreateprocedureCodesInput>;
    refundFromCollectedAmount?: InputMaybe<Scalars['Float']['input']>;
    slotId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdjustmentCreateManyInput = {
    adjustedBoughtTreatmentPrice: Scalars['Float']['input'];
    adjustmentAmount: Scalars['Float']['input'];
    adjustmentAppliedStatus?: InputMaybe<AdjustmentAppliedStatusEnum>;
    adjustmentType: AdjustmentTypeEnum;
    autoRefundAdjustmentValue?: InputMaybe<Scalars['Float']['input']>;
    boughtTreatmentId: Scalars['String']['input'];
    claimIds?: InputMaybe<AdjustmentCreateclaimIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerIds?: InputMaybe<AdjustmentCreateehrPostLedgerIdsInput>;
    ehrReconciliationAmount?: InputMaybe<Scalars['Float']['input']>;
    ehrReconciliationTransactionIds?: InputMaybe<AdjustmentCreateehrReconciliationTransactionIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    moneyRefundAmount?: InputMaybe<Scalars['Float']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    originalBoughtTreatmentPrice: Scalars['Float']['input'];
    priceSwapAdjustmentValue?: InputMaybe<Scalars['Float']['input']>;
    procedureCodes?: InputMaybe<AdjustmentCreateprocedureCodesInput>;
    refundFromCollectedAmount?: InputMaybe<Scalars['Float']['input']>;
    slotId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdjustmentCreateclaimIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AdjustmentCreateehrPostLedgerIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AdjustmentCreateehrReconciliationTransactionIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type AdjustmentCreateprocedureCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type AdjustmentGroupBy = {
    __typename?: 'AdjustmentGroupBy';
    _avg?: Maybe<AdjustmentAvgAggregate>;
    _count?: Maybe<AdjustmentCountAggregate>;
    _max?: Maybe<AdjustmentMaxAggregate>;
    _min?: Maybe<AdjustmentMinAggregate>;
    _sum?: Maybe<AdjustmentSumAggregate>;
    adjustedBoughtTreatmentPrice: Scalars['Float']['output'];
    adjustmentAmount: Scalars['Float']['output'];
    adjustmentAppliedStatus?: Maybe<AdjustmentAppliedStatusEnum>;
    adjustmentType: AdjustmentTypeEnum;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    boughtTreatmentId: Scalars['String']['output'];
    claimIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds?: Maybe<Array<Scalars['String']['output']>>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    ehrReconciliationTransactionIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    originalBoughtTreatmentPrice: Scalars['Float']['output'];
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    procedureCodes?: Maybe<Array<Scalars['String']['output']>>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
    slotId: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdjustmentMaxAggregate = {
    __typename?: 'AdjustmentMaxAggregate';
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    adjustmentAppliedStatus?: Maybe<AdjustmentAppliedStatusEnum>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdjustmentMaxOrderByAggregateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    adjustmentAppliedStatus?: InputMaybe<SortOrder>;
    adjustmentType?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    moneyRefundAmount?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjustmentMinAggregate = {
    __typename?: 'AdjustmentMinAggregate';
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    adjustmentAppliedStatus?: Maybe<AdjustmentAppliedStatusEnum>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdjustmentMinOrderByAggregateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    adjustmentAppliedStatus?: InputMaybe<SortOrder>;
    adjustmentType?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    moneyRefundAmount?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AdjustmentOrderByWithAggregationInput = {
    _avg?: InputMaybe<AdjustmentAvgOrderByAggregateInput>;
    _count?: InputMaybe<AdjustmentCountOrderByAggregateInput>;
    _max?: InputMaybe<AdjustmentMaxOrderByAggregateInput>;
    _min?: InputMaybe<AdjustmentMinOrderByAggregateInput>;
    _sum?: InputMaybe<AdjustmentSumOrderByAggregateInput>;
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    adjustmentAppliedStatus?: InputMaybe<SortOrderInput>;
    adjustmentType?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrderInput>;
    ehrReconciliationTransactionIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    metadata?: InputMaybe<SortOrderInput>;
    moneyRefundAmount?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrderInput>;
    procedureCodes?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export type AdjustmentOrderByWithRelationInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    adjustmentAppliedStatus?: InputMaybe<SortOrderInput>;
    adjustmentType?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    ehrPostLedgerIds?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrderInput>;
    ehrReconciliationTransactionIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    metadata?: InputMaybe<SortOrderInput>;
    moneyRefundAmount?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrderInput>;
    procedureCodes?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export enum AdjustmentScalarFieldEnum {
    AdjustedBoughtTreatmentPrice = 'adjustedBoughtTreatmentPrice',
    AdjustmentAmount = 'adjustmentAmount',
    AdjustmentAppliedStatus = 'adjustmentAppliedStatus',
    AdjustmentType = 'adjustmentType',
    AutoRefundAdjustmentValue = 'autoRefundAdjustmentValue',
    BoughtTreatmentId = 'boughtTreatmentId',
    ClaimIds = 'claimIds',
    CreatedAt = 'createdAt',
    EhrPostLedgerId = 'ehrPostLedgerId',
    EhrPostLedgerIds = 'ehrPostLedgerIds',
    EhrReconciliationAmount = 'ehrReconciliationAmount',
    EhrReconciliationTransactionIds = 'ehrReconciliationTransactionIds',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Metadata = 'metadata',
    MoneyRefundAmount = 'moneyRefundAmount',
    Notes = 'notes',
    OrgId = 'orgId',
    OriginalBoughtTreatmentPrice = 'originalBoughtTreatmentPrice',
    PriceSwapAdjustmentValue = 'priceSwapAdjustmentValue',
    ProcedureCodes = 'procedureCodes',
    RefundFromCollectedAmount = 'refundFromCollectedAmount',
    SlotId = 'slotId',
    UpdatedAt = 'updatedAt',
}

export type AdjustmentScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AdjustmentScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AdjustmentScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AdjustmentScalarWhereWithAggregatesInput>>;
    adjustedBoughtTreatmentPrice?: InputMaybe<FloatWithAggregatesFilter>;
    adjustmentAmount?: InputMaybe<FloatWithAggregatesFilter>;
    adjustmentAppliedStatus?: InputMaybe<EnumAdjustmentAppliedStatusEnumNullableWithAggregatesFilter>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumWithAggregatesFilter>;
    autoRefundAdjustmentValue?: InputMaybe<FloatNullableWithAggregatesFilter>;
    boughtTreatmentId?: InputMaybe<UuidWithAggregatesFilter>;
    claimIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrReconciliationAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    ehrReconciliationTransactionIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    moneyRefundAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    originalBoughtTreatmentPrice?: InputMaybe<FloatWithAggregatesFilter>;
    priceSwapAdjustmentValue?: InputMaybe<FloatNullableWithAggregatesFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    refundFromCollectedAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    slotId?: InputMaybe<UuidWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type AdjustmentSumAggregate = {
    __typename?: 'AdjustmentSumAggregate';
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
};

export type AdjustmentSumOrderByAggregateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    adjustmentAmount?: InputMaybe<SortOrder>;
    autoRefundAdjustmentValue?: InputMaybe<SortOrder>;
    ehrReconciliationAmount?: InputMaybe<SortOrder>;
    moneyRefundAmount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalBoughtTreatmentPrice?: InputMaybe<SortOrder>;
    priceSwapAdjustmentValue?: InputMaybe<SortOrder>;
    refundFromCollectedAmount?: InputMaybe<SortOrder>;
};

export enum AdjustmentTypeEnum {
    AdditionalSrt = 'ADDITIONAL_SRT',
    BenefitMiss = 'BENEFIT_MISS',
    ClaimPriceOverride = 'CLAIM_PRICE_OVERRIDE',
    Other = 'OTHER',
    PaymentBypass = 'PAYMENT_BYPASS',
    TreatmentMiss = 'TREATMENT_MISS',
}

export type AdjustmentUpdateInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
    adjustmentAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
    adjustmentAppliedStatus?: InputMaybe<NullableEnumAdjustmentAppliedStatusEnumFieldUpdateOperationsInput>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumFieldUpdateOperationsInput>;
    autoRefundAdjustmentValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimIds?: InputMaybe<AdjustmentUpdateclaimIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerIds?: InputMaybe<AdjustmentUpdateehrPostLedgerIdsInput>;
    ehrReconciliationAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrReconciliationTransactionIds?: InputMaybe<AdjustmentUpdateehrReconciliationTransactionIdsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    moneyRefundAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    originalBoughtTreatmentPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
    priceSwapAdjustmentValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    procedureCodes?: InputMaybe<AdjustmentUpdateprocedureCodesInput>;
    refundFromCollectedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    slotId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AdjustmentUpdateManyMutationInput = {
    adjustedBoughtTreatmentPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
    adjustmentAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
    adjustmentAppliedStatus?: InputMaybe<NullableEnumAdjustmentAppliedStatusEnumFieldUpdateOperationsInput>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumFieldUpdateOperationsInput>;
    autoRefundAdjustmentValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimIds?: InputMaybe<AdjustmentUpdateclaimIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerIds?: InputMaybe<AdjustmentUpdateehrPostLedgerIdsInput>;
    ehrReconciliationAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrReconciliationTransactionIds?: InputMaybe<AdjustmentUpdateehrReconciliationTransactionIdsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    moneyRefundAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    originalBoughtTreatmentPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
    priceSwapAdjustmentValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    procedureCodes?: InputMaybe<AdjustmentUpdateprocedureCodesInput>;
    refundFromCollectedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    slotId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AdjustmentUpdateclaimIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdjustmentUpdateehrPostLedgerIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdjustmentUpdateehrReconciliationTransactionIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdjustmentUpdateprocedureCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdjustmentWhereInput = {
    AND?: InputMaybe<Array<AdjustmentWhereInput>>;
    NOT?: InputMaybe<Array<AdjustmentWhereInput>>;
    OR?: InputMaybe<Array<AdjustmentWhereInput>>;
    adjustedBoughtTreatmentPrice?: InputMaybe<FloatFilter>;
    adjustmentAmount?: InputMaybe<FloatFilter>;
    adjustmentAppliedStatus?: InputMaybe<EnumAdjustmentAppliedStatusEnumNullableFilter>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumFilter>;
    autoRefundAdjustmentValue?: InputMaybe<FloatNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    claimIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrReconciliationAmount?: InputMaybe<FloatNullableFilter>;
    ehrReconciliationTransactionIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    moneyRefundAmount?: InputMaybe<FloatNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    originalBoughtTreatmentPrice?: InputMaybe<FloatFilter>;
    priceSwapAdjustmentValue?: InputMaybe<FloatNullableFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    refundFromCollectedAmount?: InputMaybe<FloatNullableFilter>;
    slotId?: InputMaybe<UuidFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type AdjustmentWhereUniqueInput = {
    AND?: InputMaybe<Array<AdjustmentWhereInput>>;
    NOT?: InputMaybe<Array<AdjustmentWhereInput>>;
    OR?: InputMaybe<Array<AdjustmentWhereInput>>;
    adjustedBoughtTreatmentPrice?: InputMaybe<FloatFilter>;
    adjustmentAmount?: InputMaybe<FloatFilter>;
    adjustmentAppliedStatus?: InputMaybe<EnumAdjustmentAppliedStatusEnumNullableFilter>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumFilter>;
    autoRefundAdjustmentValue?: InputMaybe<FloatNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    claimIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerIds?: InputMaybe<StringNullableListFilter>;
    ehrReconciliationAmount?: InputMaybe<FloatNullableFilter>;
    ehrReconciliationTransactionIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    moneyRefundAmount?: InputMaybe<FloatNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    originalBoughtTreatmentPrice?: InputMaybe<FloatFilter>;
    priceSwapAdjustmentValue?: InputMaybe<FloatNullableFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    refundFromCollectedAmount?: InputMaybe<FloatNullableFilter>;
    slotId?: InputMaybe<UuidFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type Admin = {
    __typename?: 'Admin';
    _count?: Maybe<AdminCount>;
    adminInteraction: Array<AdminInteraction>;
    consumerMessage: Array<ConsumerMessage>;
    consumerNotes: Array<ConsumerNote>;
    email: Scalars['String']['output'];
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    idpRedirect?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    /**
     * The practice this admin is treated as working at, for feature-capability
     * resolution only. Nullable: an admin without one resolves at org level.
     * References pricing-gateway `practice.practice_id` across a database
     * boundary, so nothing constrains it here — consumers must confirm the
     * practice belongs to `orgId` before acting on it.
     */
    practiceId?: Maybe<Scalars['Int']['output']>;
    role: Scalars['String']['output'];
};

export type AdminAdminInteractionArgs = {
    cursor?: InputMaybe<AdminInteractionWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdminInteractionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdminInteractionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminInteractionWhereInput>;
};

export type AdminConsumerMessageArgs = {
    cursor?: InputMaybe<ConsumerMessageWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerMessageScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerMessageOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type AdminConsumerNotesArgs = {
    cursor?: InputMaybe<ConsumerNoteWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerNoteScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerNoteOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export enum AdminAction {
    CancelEncounter = 'CANCEL_ENCOUNTER',
    CreateAdmin = 'CREATE_ADMIN',
    CreateEncounter = 'CREATE_ENCOUNTER',
    EditEncounter = 'EDIT_ENCOUNTER',
    ExportTransfers = 'EXPORT_TRANSFERS',
    Login = 'LOGIN',
    Logout = 'LOGOUT',
}

export type AdminAvgAggregate = {
    __typename?: 'AdminAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type AdminAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type AdminCount = {
    __typename?: 'AdminCount';
    adminInteraction: Scalars['Int']['output'];
    consumerMessage: Scalars['Int']['output'];
    consumerNotes: Scalars['Int']['output'];
};

export type AdminCountAdminInteractionArgs = {
    where?: InputMaybe<AdminInteractionWhereInput>;
};

export type AdminCountConsumerMessageArgs = {
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type AdminCountConsumerNotesArgs = {
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type AdminCountAggregate = {
    __typename?: 'AdminCountAggregate';
    _all: Scalars['Int']['output'];
    email: Scalars['Int']['output'];
    firstName: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    idpRedirect: Scalars['Int']['output'];
    lastName: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    password_hash: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    role: Scalars['Int']['output'];
    salt: Scalars['Int']['output'];
};

export type AdminCountOrderByAggregateInput = {
    email?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idpRedirect?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    password_hash?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    role?: InputMaybe<SortOrder>;
    salt?: InputMaybe<SortOrder>;
};

export type AdminCreateInput = {
    adminInteraction?: InputMaybe<AdminInteractionCreateNestedManyWithoutAdminInput>;
    consumerMessage?: InputMaybe<ConsumerMessageCreateNestedManyWithoutAdminInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutAdminInput>;
    email: Scalars['String']['input'];
    firstName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    password_hash: Scalars['String']['input'];
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    role: Scalars['String']['input'];
    salt: Scalars['String']['input'];
};

export type AdminCreateManyInput = {
    email: Scalars['String']['input'];
    firstName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    password_hash: Scalars['String']['input'];
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    role: Scalars['String']['input'];
    salt: Scalars['String']['input'];
};

export type AdminCreateNestedOneWithoutAdminInteractionInput = {
    connect?: InputMaybe<AdminWhereUniqueInput>;
    connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutAdminInteractionInput>;
    create?: InputMaybe<AdminCreateWithoutAdminInteractionInput>;
};

export type AdminCreateNestedOneWithoutConsumerMessageInput = {
    connect?: InputMaybe<AdminWhereUniqueInput>;
    connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutConsumerMessageInput>;
    create?: InputMaybe<AdminCreateWithoutConsumerMessageInput>;
};

export type AdminCreateNestedOneWithoutConsumerNotesInput = {
    connect?: InputMaybe<AdminWhereUniqueInput>;
    connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutConsumerNotesInput>;
    create?: InputMaybe<AdminCreateWithoutConsumerNotesInput>;
};

export type AdminCreateOrConnectWithoutAdminInteractionInput = {
    create: AdminCreateWithoutAdminInteractionInput;
    where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutConsumerMessageInput = {
    create: AdminCreateWithoutConsumerMessageInput;
    where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutConsumerNotesInput = {
    create: AdminCreateWithoutConsumerNotesInput;
    where: AdminWhereUniqueInput;
};

export type AdminCreateWithoutAdminInteractionInput = {
    consumerMessage?: InputMaybe<ConsumerMessageCreateNestedManyWithoutAdminInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutAdminInput>;
    email: Scalars['String']['input'];
    firstName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    password_hash: Scalars['String']['input'];
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    role: Scalars['String']['input'];
    salt: Scalars['String']['input'];
};

export type AdminCreateWithoutConsumerMessageInput = {
    adminInteraction?: InputMaybe<AdminInteractionCreateNestedManyWithoutAdminInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutAdminInput>;
    email: Scalars['String']['input'];
    firstName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    password_hash: Scalars['String']['input'];
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    role: Scalars['String']['input'];
    salt: Scalars['String']['input'];
};

export type AdminCreateWithoutConsumerNotesInput = {
    adminInteraction?: InputMaybe<AdminInteractionCreateNestedManyWithoutAdminInput>;
    consumerMessage?: InputMaybe<ConsumerMessageCreateNestedManyWithoutAdminInput>;
    email: Scalars['String']['input'];
    firstName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    password_hash: Scalars['String']['input'];
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    role: Scalars['String']['input'];
    salt: Scalars['String']['input'];
};

export type AdminGroupBy = {
    __typename?: 'AdminGroupBy';
    _avg?: Maybe<AdminAvgAggregate>;
    _count?: Maybe<AdminCountAggregate>;
    _max?: Maybe<AdminMaxAggregate>;
    _min?: Maybe<AdminMinAggregate>;
    _sum?: Maybe<AdminSumAggregate>;
    email: Scalars['String']['output'];
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    idpRedirect?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    password_hash: Scalars['String']['output'];
    practiceId?: Maybe<Scalars['Int']['output']>;
    role: Scalars['String']['output'];
    salt: Scalars['String']['output'];
};

export type AdminInteraction = {
    __typename?: 'AdminInteraction';
    action: AdminAction;
    admin: Admin;
    adminId: Scalars['String']['output'];
    details?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['Int']['output'];
    timestamp: Scalars['DateTimeISO']['output'];
};

export type AdminInteractionAvgAggregate = {
    __typename?: 'AdminInteractionAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type AdminInteractionAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type AdminInteractionCountAggregate = {
    __typename?: 'AdminInteractionCountAggregate';
    _all: Scalars['Int']['output'];
    action: Scalars['Int']['output'];
    adminId: Scalars['Int']['output'];
    details: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    timestamp: Scalars['Int']['output'];
};

export type AdminInteractionCountOrderByAggregateInput = {
    action?: InputMaybe<SortOrder>;
    adminId?: InputMaybe<SortOrder>;
    details?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type AdminInteractionCreateInput = {
    action: AdminAction;
    admin: AdminCreateNestedOneWithoutAdminInteractionInput;
    details?: InputMaybe<Scalars['JSON']['input']>;
    timestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdminInteractionCreateManyAdminInput = {
    action: AdminAction;
    details?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    timestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdminInteractionCreateManyAdminInputEnvelope = {
    data: Array<AdminInteractionCreateManyAdminInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminInteractionCreateManyInput = {
    action: AdminAction;
    adminId: Scalars['String']['input'];
    details?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    timestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdminInteractionCreateNestedManyWithoutAdminInput = {
    connect?: InputMaybe<Array<AdminInteractionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<AdminInteractionCreateOrConnectWithoutAdminInput>
    >;
    create?: InputMaybe<Array<AdminInteractionCreateWithoutAdminInput>>;
    createMany?: InputMaybe<AdminInteractionCreateManyAdminInputEnvelope>;
};

export type AdminInteractionCreateOrConnectWithoutAdminInput = {
    create: AdminInteractionCreateWithoutAdminInput;
    where: AdminInteractionWhereUniqueInput;
};

export type AdminInteractionCreateWithoutAdminInput = {
    action: AdminAction;
    details?: InputMaybe<Scalars['JSON']['input']>;
    timestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AdminInteractionGroupBy = {
    __typename?: 'AdminInteractionGroupBy';
    _avg?: Maybe<AdminInteractionAvgAggregate>;
    _count?: Maybe<AdminInteractionCountAggregate>;
    _max?: Maybe<AdminInteractionMaxAggregate>;
    _min?: Maybe<AdminInteractionMinAggregate>;
    _sum?: Maybe<AdminInteractionSumAggregate>;
    action: AdminAction;
    adminId: Scalars['String']['output'];
    details?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['Int']['output'];
    timestamp: Scalars['DateTimeISO']['output'];
};

export type AdminInteractionListRelationFilter = {
    every?: InputMaybe<AdminInteractionWhereInput>;
    none?: InputMaybe<AdminInteractionWhereInput>;
    some?: InputMaybe<AdminInteractionWhereInput>;
};

export type AdminInteractionMaxAggregate = {
    __typename?: 'AdminInteractionMaxAggregate';
    action?: Maybe<AdminAction>;
    adminId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    timestamp?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdminInteractionMaxOrderByAggregateInput = {
    action?: InputMaybe<SortOrder>;
    adminId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type AdminInteractionMinAggregate = {
    __typename?: 'AdminInteractionMinAggregate';
    action?: Maybe<AdminAction>;
    adminId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    timestamp?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AdminInteractionMinOrderByAggregateInput = {
    action?: InputMaybe<SortOrder>;
    adminId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type AdminInteractionOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type AdminInteractionOrderByWithAggregationInput = {
    _avg?: InputMaybe<AdminInteractionAvgOrderByAggregateInput>;
    _count?: InputMaybe<AdminInteractionCountOrderByAggregateInput>;
    _max?: InputMaybe<AdminInteractionMaxOrderByAggregateInput>;
    _min?: InputMaybe<AdminInteractionMinOrderByAggregateInput>;
    _sum?: InputMaybe<AdminInteractionSumOrderByAggregateInput>;
    action?: InputMaybe<SortOrder>;
    adminId?: InputMaybe<SortOrder>;
    details?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type AdminInteractionOrderByWithRelationInput = {
    action?: InputMaybe<SortOrder>;
    admin?: InputMaybe<AdminOrderByWithRelationInput>;
    adminId?: InputMaybe<SortOrder>;
    details?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export enum AdminInteractionScalarFieldEnum {
    Action = 'action',
    AdminId = 'adminId',
    Details = 'details',
    Id = 'id',
    Timestamp = 'timestamp',
}

export type AdminInteractionScalarWhereInput = {
    AND?: InputMaybe<Array<AdminInteractionScalarWhereInput>>;
    NOT?: InputMaybe<Array<AdminInteractionScalarWhereInput>>;
    OR?: InputMaybe<Array<AdminInteractionScalarWhereInput>>;
    action?: InputMaybe<EnumAdminActionFilter>;
    adminId?: InputMaybe<UuidFilter>;
    details?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<IntFilter>;
    timestamp?: InputMaybe<DateTimeFilter>;
};

export type AdminInteractionScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AdminInteractionScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AdminInteractionScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AdminInteractionScalarWhereWithAggregatesInput>>;
    action?: InputMaybe<EnumAdminActionWithAggregatesFilter>;
    adminId?: InputMaybe<UuidWithAggregatesFilter>;
    details?: InputMaybe<JsonNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    timestamp?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AdminInteractionSumAggregate = {
    __typename?: 'AdminInteractionSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type AdminInteractionSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type AdminInteractionUpdateInput = {
    action?: InputMaybe<EnumAdminActionFieldUpdateOperationsInput>;
    admin?: InputMaybe<AdminUpdateOneRequiredWithoutAdminInteractionNestedInput>;
    details?: InputMaybe<Scalars['JSON']['input']>;
    timestamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminInteractionUpdateManyMutationInput = {
    action?: InputMaybe<EnumAdminActionFieldUpdateOperationsInput>;
    details?: InputMaybe<Scalars['JSON']['input']>;
    timestamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminInteractionUpdateManyWithWhereWithoutAdminInput = {
    data: AdminInteractionUpdateManyMutationInput;
    where: AdminInteractionScalarWhereInput;
};

export type AdminInteractionUpdateManyWithoutAdminNestedInput = {
    connect?: InputMaybe<Array<AdminInteractionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<AdminInteractionCreateOrConnectWithoutAdminInput>
    >;
    create?: InputMaybe<Array<AdminInteractionCreateWithoutAdminInput>>;
    createMany?: InputMaybe<AdminInteractionCreateManyAdminInputEnvelope>;
    delete?: InputMaybe<Array<AdminInteractionWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<AdminInteractionScalarWhereInput>>;
    disconnect?: InputMaybe<Array<AdminInteractionWhereUniqueInput>>;
    set?: InputMaybe<Array<AdminInteractionWhereUniqueInput>>;
    update?: InputMaybe<
        Array<AdminInteractionUpdateWithWhereUniqueWithoutAdminInput>
    >;
    updateMany?: InputMaybe<
        Array<AdminInteractionUpdateManyWithWhereWithoutAdminInput>
    >;
    upsert?: InputMaybe<
        Array<AdminInteractionUpsertWithWhereUniqueWithoutAdminInput>
    >;
};

export type AdminInteractionUpdateWithWhereUniqueWithoutAdminInput = {
    data: AdminInteractionUpdateWithoutAdminInput;
    where: AdminInteractionWhereUniqueInput;
};

export type AdminInteractionUpdateWithoutAdminInput = {
    action?: InputMaybe<EnumAdminActionFieldUpdateOperationsInput>;
    details?: InputMaybe<Scalars['JSON']['input']>;
    timestamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminInteractionUpsertWithWhereUniqueWithoutAdminInput = {
    create: AdminInteractionCreateWithoutAdminInput;
    update: AdminInteractionUpdateWithoutAdminInput;
    where: AdminInteractionWhereUniqueInput;
};

export type AdminInteractionWhereInput = {
    AND?: InputMaybe<Array<AdminInteractionWhereInput>>;
    NOT?: InputMaybe<Array<AdminInteractionWhereInput>>;
    OR?: InputMaybe<Array<AdminInteractionWhereInput>>;
    action?: InputMaybe<EnumAdminActionFilter>;
    admin?: InputMaybe<AdminRelationFilter>;
    adminId?: InputMaybe<UuidFilter>;
    details?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<IntFilter>;
    timestamp?: InputMaybe<DateTimeFilter>;
};

export type AdminInteractionWhereUniqueInput = {
    AND?: InputMaybe<Array<AdminInteractionWhereInput>>;
    NOT?: InputMaybe<Array<AdminInteractionWhereInput>>;
    OR?: InputMaybe<Array<AdminInteractionWhereInput>>;
    action?: InputMaybe<EnumAdminActionFilter>;
    admin?: InputMaybe<AdminRelationFilter>;
    adminId?: InputMaybe<UuidFilter>;
    details?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    timestamp?: InputMaybe<DateTimeFilter>;
};

export type AdminMaxAggregate = {
    __typename?: 'AdminMaxAggregate';
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    idpRedirect?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    password_hash?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    role?: Maybe<Scalars['String']['output']>;
    salt?: Maybe<Scalars['String']['output']>;
};

export type AdminMaxOrderByAggregateInput = {
    email?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idpRedirect?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    password_hash?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    role?: InputMaybe<SortOrder>;
    salt?: InputMaybe<SortOrder>;
};

export type AdminMinAggregate = {
    __typename?: 'AdminMinAggregate';
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    idpRedirect?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    password_hash?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    role?: Maybe<Scalars['String']['output']>;
    salt?: Maybe<Scalars['String']['output']>;
};

export type AdminMinOrderByAggregateInput = {
    email?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idpRedirect?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    password_hash?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    role?: InputMaybe<SortOrder>;
    salt?: InputMaybe<SortOrder>;
};

export type AdminNullableRelationFilter = {
    is?: InputMaybe<AdminWhereInput>;
    isNot?: InputMaybe<AdminWhereInput>;
};

export type AdminOrderByWithAggregationInput = {
    _avg?: InputMaybe<AdminAvgOrderByAggregateInput>;
    _count?: InputMaybe<AdminCountOrderByAggregateInput>;
    _max?: InputMaybe<AdminMaxOrderByAggregateInput>;
    _min?: InputMaybe<AdminMinOrderByAggregateInput>;
    _sum?: InputMaybe<AdminSumOrderByAggregateInput>;
    email?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    idpRedirect?: InputMaybe<SortOrderInput>;
    lastName?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    password_hash?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrderInput>;
    role?: InputMaybe<SortOrder>;
    salt?: InputMaybe<SortOrder>;
};

export type AdminOrderByWithRelationInput = {
    adminInteraction?: InputMaybe<AdminInteractionOrderByRelationAggregateInput>;
    consumerMessage?: InputMaybe<ConsumerMessageOrderByRelationAggregateInput>;
    consumerNotes?: InputMaybe<ConsumerNoteOrderByRelationAggregateInput>;
    email?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    idpRedirect?: InputMaybe<SortOrderInput>;
    lastName?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    password_hash?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrderInput>;
    role?: InputMaybe<SortOrder>;
    salt?: InputMaybe<SortOrder>;
};

export type AdminRelationFilter = {
    is?: InputMaybe<AdminWhereInput>;
    isNot?: InputMaybe<AdminWhereInput>;
};

export enum AdminScalarFieldEnum {
    Email = 'email',
    FirstName = 'firstName',
    Id = 'id',
    IdpRedirect = 'idpRedirect',
    LastName = 'lastName',
    OrgId = 'orgId',
    PasswordHash = 'password_hash',
    PracticeId = 'practiceId',
    Role = 'role',
    Salt = 'salt',
}

export type AdminScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AdminScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AdminScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AdminScalarWhereWithAggregatesInput>>;
    email?: InputMaybe<StringWithAggregatesFilter>;
    firstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    idpRedirect?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    password_hash?: InputMaybe<StringWithAggregatesFilter>;
    practiceId?: InputMaybe<IntNullableWithAggregatesFilter>;
    role?: InputMaybe<StringWithAggregatesFilter>;
    salt?: InputMaybe<StringWithAggregatesFilter>;
};

export type AdminSumAggregate = {
    __typename?: 'AdminSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type AdminSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type AdminUpdateInput = {
    adminInteraction?: InputMaybe<AdminInteractionUpdateManyWithoutAdminNestedInput>;
    consumerMessage?: InputMaybe<ConsumerMessageUpdateManyWithoutAdminNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutAdminNestedInput>;
    email?: InputMaybe<StringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    password_hash?: InputMaybe<StringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    role?: InputMaybe<StringFieldUpdateOperationsInput>;
    salt?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AdminUpdateManyMutationInput = {
    email?: InputMaybe<StringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    password_hash?: InputMaybe<StringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    role?: InputMaybe<StringFieldUpdateOperationsInput>;
    salt?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AdminUpdateOneRequiredWithoutAdminInteractionNestedInput = {
    connect?: InputMaybe<AdminWhereUniqueInput>;
    connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutAdminInteractionInput>;
    create?: InputMaybe<AdminCreateWithoutAdminInteractionInput>;
    update?: InputMaybe<AdminUpdateToOneWithWhereWithoutAdminInteractionInput>;
    upsert?: InputMaybe<AdminUpsertWithoutAdminInteractionInput>;
};

export type AdminUpdateOneRequiredWithoutConsumerNotesNestedInput = {
    connect?: InputMaybe<AdminWhereUniqueInput>;
    connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutConsumerNotesInput>;
    create?: InputMaybe<AdminCreateWithoutConsumerNotesInput>;
    update?: InputMaybe<AdminUpdateToOneWithWhereWithoutConsumerNotesInput>;
    upsert?: InputMaybe<AdminUpsertWithoutConsumerNotesInput>;
};

export type AdminUpdateOneWithoutConsumerMessageNestedInput = {
    connect?: InputMaybe<AdminWhereUniqueInput>;
    connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutConsumerMessageInput>;
    create?: InputMaybe<AdminCreateWithoutConsumerMessageInput>;
    delete?: InputMaybe<AdminWhereInput>;
    disconnect?: InputMaybe<AdminWhereInput>;
    update?: InputMaybe<AdminUpdateToOneWithWhereWithoutConsumerMessageInput>;
    upsert?: InputMaybe<AdminUpsertWithoutConsumerMessageInput>;
};

export type AdminUpdateToOneWithWhereWithoutAdminInteractionInput = {
    data: AdminUpdateWithoutAdminInteractionInput;
    where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutConsumerMessageInput = {
    data: AdminUpdateWithoutConsumerMessageInput;
    where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutConsumerNotesInput = {
    data: AdminUpdateWithoutConsumerNotesInput;
    where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateWithoutAdminInteractionInput = {
    consumerMessage?: InputMaybe<ConsumerMessageUpdateManyWithoutAdminNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutAdminNestedInput>;
    email?: InputMaybe<StringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    password_hash?: InputMaybe<StringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    role?: InputMaybe<StringFieldUpdateOperationsInput>;
    salt?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AdminUpdateWithoutConsumerMessageInput = {
    adminInteraction?: InputMaybe<AdminInteractionUpdateManyWithoutAdminNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutAdminNestedInput>;
    email?: InputMaybe<StringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    password_hash?: InputMaybe<StringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    role?: InputMaybe<StringFieldUpdateOperationsInput>;
    salt?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AdminUpdateWithoutConsumerNotesInput = {
    adminInteraction?: InputMaybe<AdminInteractionUpdateManyWithoutAdminNestedInput>;
    consumerMessage?: InputMaybe<ConsumerMessageUpdateManyWithoutAdminNestedInput>;
    email?: InputMaybe<StringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    password_hash?: InputMaybe<StringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    role?: InputMaybe<StringFieldUpdateOperationsInput>;
    salt?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AdminUpsertWithoutAdminInteractionInput = {
    create: AdminCreateWithoutAdminInteractionInput;
    update: AdminUpdateWithoutAdminInteractionInput;
    where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutConsumerMessageInput = {
    create: AdminCreateWithoutConsumerMessageInput;
    update: AdminUpdateWithoutConsumerMessageInput;
    where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutConsumerNotesInput = {
    create: AdminCreateWithoutConsumerNotesInput;
    update: AdminUpdateWithoutConsumerNotesInput;
    where?: InputMaybe<AdminWhereInput>;
};

export type AdminWhereInput = {
    AND?: InputMaybe<Array<AdminWhereInput>>;
    NOT?: InputMaybe<Array<AdminWhereInput>>;
    OR?: InputMaybe<Array<AdminWhereInput>>;
    adminInteraction?: InputMaybe<AdminInteractionListRelationFilter>;
    consumerMessage?: InputMaybe<ConsumerMessageListRelationFilter>;
    consumerNotes?: InputMaybe<ConsumerNoteListRelationFilter>;
    email?: InputMaybe<StringFilter>;
    firstName?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    idpRedirect?: InputMaybe<StringNullableFilter>;
    lastName?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    password_hash?: InputMaybe<StringFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    role?: InputMaybe<StringFilter>;
    salt?: InputMaybe<StringFilter>;
};

export type AdminWhereUniqueInput = {
    AND?: InputMaybe<Array<AdminWhereInput>>;
    NOT?: InputMaybe<Array<AdminWhereInput>>;
    OR?: InputMaybe<Array<AdminWhereInput>>;
    adminInteraction?: InputMaybe<AdminInteractionListRelationFilter>;
    consumerMessage?: InputMaybe<ConsumerMessageListRelationFilter>;
    consumerNotes?: InputMaybe<ConsumerNoteListRelationFilter>;
    email?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<StringNullableFilter>;
    lastName?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    password_hash?: InputMaybe<StringFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    role?: InputMaybe<StringFilter>;
    salt?: InputMaybe<StringFilter>;
};

export type AffectedRowsOutput = {
    __typename?: 'AffectedRowsOutput';
    count: Scalars['Int']['output'];
};

export type AggregateAleConfig = {
    __typename?: 'AggregateALEConfig';
    _avg?: Maybe<AleConfigAvgAggregate>;
    _count?: Maybe<AleConfigCountAggregate>;
    _max?: Maybe<AleConfigMaxAggregate>;
    _min?: Maybe<AleConfigMinAggregate>;
    _sum?: Maybe<AleConfigSumAggregate>;
};

export type AggregateAleDepartmentGoLive = {
    __typename?: 'AggregateALEDepartmentGoLive';
    _avg?: Maybe<AleDepartmentGoLiveAvgAggregate>;
    _count?: Maybe<AleDepartmentGoLiveCountAggregate>;
    _max?: Maybe<AleDepartmentGoLiveMaxAggregate>;
    _min?: Maybe<AleDepartmentGoLiveMinAggregate>;
    _sum?: Maybe<AleDepartmentGoLiveSumAggregate>;
};

export type AggregateAdjudication = {
    __typename?: 'AggregateAdjudication';
    _avg?: Maybe<AdjudicationAvgAggregate>;
    _count?: Maybe<AdjudicationCountAggregate>;
    _max?: Maybe<AdjudicationMaxAggregate>;
    _min?: Maybe<AdjudicationMinAggregate>;
    _sum?: Maybe<AdjudicationSumAggregate>;
};

export type AggregateAdjudicationAuditLog = {
    __typename?: 'AggregateAdjudicationAuditLog';
    _avg?: Maybe<AdjudicationAuditLogAvgAggregate>;
    _count?: Maybe<AdjudicationAuditLogCountAggregate>;
    _max?: Maybe<AdjudicationAuditLogMaxAggregate>;
    _min?: Maybe<AdjudicationAuditLogMinAggregate>;
    _sum?: Maybe<AdjudicationAuditLogSumAggregate>;
};

export type AggregateAdjustment = {
    __typename?: 'AggregateAdjustment';
    _avg?: Maybe<AdjustmentAvgAggregate>;
    _count?: Maybe<AdjustmentCountAggregate>;
    _max?: Maybe<AdjustmentMaxAggregate>;
    _min?: Maybe<AdjustmentMinAggregate>;
    _sum?: Maybe<AdjustmentSumAggregate>;
};

export type AggregateAdjustmentAuditLog = {
    __typename?: 'AggregateAdjustmentAuditLog';
    _avg?: Maybe<AdjustmentAuditLogAvgAggregate>;
    _count?: Maybe<AdjustmentAuditLogCountAggregate>;
    _max?: Maybe<AdjustmentAuditLogMaxAggregate>;
    _min?: Maybe<AdjustmentAuditLogMinAggregate>;
    _sum?: Maybe<AdjustmentAuditLogSumAggregate>;
};

export type AggregateAdmin = {
    __typename?: 'AggregateAdmin';
    _avg?: Maybe<AdminAvgAggregate>;
    _count?: Maybe<AdminCountAggregate>;
    _max?: Maybe<AdminMaxAggregate>;
    _min?: Maybe<AdminMinAggregate>;
    _sum?: Maybe<AdminSumAggregate>;
};

export type AggregateAdminInteraction = {
    __typename?: 'AggregateAdminInteraction';
    _avg?: Maybe<AdminInteractionAvgAggregate>;
    _count?: Maybe<AdminInteractionCountAggregate>;
    _max?: Maybe<AdminInteractionMaxAggregate>;
    _min?: Maybe<AdminInteractionMinAggregate>;
    _sum?: Maybe<AdminInteractionSumAggregate>;
};

export type AggregateAppointment = {
    __typename?: 'AggregateAppointment';
    _avg?: Maybe<AppointmentAvgAggregate>;
    _count?: Maybe<AppointmentCountAggregate>;
    _max?: Maybe<AppointmentMaxAggregate>;
    _min?: Maybe<AppointmentMinAggregate>;
    _sum?: Maybe<AppointmentSumAggregate>;
};

export type AggregateAppointmentAuditLog = {
    __typename?: 'AggregateAppointmentAuditLog';
    _avg?: Maybe<AppointmentAuditLogAvgAggregate>;
    _count?: Maybe<AppointmentAuditLogCountAggregate>;
    _max?: Maybe<AppointmentAuditLogMaxAggregate>;
    _min?: Maybe<AppointmentAuditLogMinAggregate>;
    _sum?: Maybe<AppointmentAuditLogSumAggregate>;
};

export type AggregateArrearBilling = {
    __typename?: 'AggregateArrearBilling';
    _avg?: Maybe<ArrearBillingAvgAggregate>;
    _count?: Maybe<ArrearBillingCountAggregate>;
    _max?: Maybe<ArrearBillingMaxAggregate>;
    _min?: Maybe<ArrearBillingMinAggregate>;
    _sum?: Maybe<ArrearBillingSumAggregate>;
};

export type AggregateArtClaim = {
    __typename?: 'AggregateArtClaim';
    _avg?: Maybe<ArtClaimAvgAggregate>;
    _count?: Maybe<ArtClaimCountAggregate>;
    _max?: Maybe<ArtClaimMaxAggregate>;
    _min?: Maybe<ArtClaimMinAggregate>;
    _sum?: Maybe<ArtClaimSumAggregate>;
};

export type AggregateArtClaimAuditLog = {
    __typename?: 'AggregateArtClaimAuditLog';
    _avg?: Maybe<ArtClaimAuditLogAvgAggregate>;
    _count?: Maybe<ArtClaimAuditLogCountAggregate>;
    _max?: Maybe<ArtClaimAuditLogMaxAggregate>;
    _min?: Maybe<ArtClaimAuditLogMinAggregate>;
    _sum?: Maybe<ArtClaimAuditLogSumAggregate>;
};

export type AggregateArtClaimCptLine = {
    __typename?: 'AggregateArtClaimCptLine';
    _avg?: Maybe<ArtClaimCptLineAvgAggregate>;
    _count?: Maybe<ArtClaimCptLineCountAggregate>;
    _max?: Maybe<ArtClaimCptLineMaxAggregate>;
    _min?: Maybe<ArtClaimCptLineMinAggregate>;
    _sum?: Maybe<ArtClaimCptLineSumAggregate>;
};

export type AggregateArtClaimCptLineAuditLog = {
    __typename?: 'AggregateArtClaimCptLineAuditLog';
    _avg?: Maybe<ArtClaimCptLineAuditLogAvgAggregate>;
    _count?: Maybe<ArtClaimCptLineAuditLogCountAggregate>;
    _max?: Maybe<ArtClaimCptLineAuditLogMaxAggregate>;
    _min?: Maybe<ArtClaimCptLineAuditLogMinAggregate>;
    _sum?: Maybe<ArtClaimCptLineAuditLogSumAggregate>;
};

export type AggregateArtOrgConfig = {
    __typename?: 'AggregateArtOrgConfig';
    _avg?: Maybe<ArtOrgConfigAvgAggregate>;
    _count?: Maybe<ArtOrgConfigCountAggregate>;
    _max?: Maybe<ArtOrgConfigMaxAggregate>;
    _min?: Maybe<ArtOrgConfigMinAggregate>;
    _sum?: Maybe<ArtOrgConfigSumAggregate>;
};

export type AggregateArtPracticeConfig = {
    __typename?: 'AggregateArtPracticeConfig';
    _avg?: Maybe<ArtPracticeConfigAvgAggregate>;
    _count?: Maybe<ArtPracticeConfigCountAggregate>;
    _max?: Maybe<ArtPracticeConfigMaxAggregate>;
    _min?: Maybe<ArtPracticeConfigMinAggregate>;
    _sum?: Maybe<ArtPracticeConfigSumAggregate>;
};

export type AggregateAthenaMedications = {
    __typename?: 'AggregateAthenaMedications';
    _avg?: Maybe<AthenaMedicationsAvgAggregate>;
    _count?: Maybe<AthenaMedicationsCountAggregate>;
    _max?: Maybe<AthenaMedicationsMaxAggregate>;
    _min?: Maybe<AthenaMedicationsMinAggregate>;
    _sum?: Maybe<AthenaMedicationsSumAggregate>;
};

export type AggregateAthenaPharmacy = {
    __typename?: 'AggregateAthenaPharmacy';
    _avg?: Maybe<AthenaPharmacyAvgAggregate>;
    _count?: Maybe<AthenaPharmacyCountAggregate>;
    _max?: Maybe<AthenaPharmacyMaxAggregate>;
    _min?: Maybe<AthenaPharmacyMinAggregate>;
    _sum?: Maybe<AthenaPharmacySumAggregate>;
};

export type AggregateAthenaProvider = {
    __typename?: 'AggregateAthenaProvider';
    _avg?: Maybe<AthenaProviderAvgAggregate>;
    _count?: Maybe<AthenaProviderCountAggregate>;
    _max?: Maybe<AthenaProviderMaxAggregate>;
    _min?: Maybe<AthenaProviderMinAggregate>;
    _sum?: Maybe<AthenaProviderSumAggregate>;
};

export type AggregateBenefitParsingRules = {
    __typename?: 'AggregateBenefitParsingRules';
    _avg?: Maybe<BenefitParsingRulesAvgAggregate>;
    _count?: Maybe<BenefitParsingRulesCountAggregate>;
    _max?: Maybe<BenefitParsingRulesMaxAggregate>;
    _min?: Maybe<BenefitParsingRulesMinAggregate>;
    _sum?: Maybe<BenefitParsingRulesSumAggregate>;
};

export type AggregateBillingCode = {
    __typename?: 'AggregateBillingCode';
    _avg?: Maybe<BillingCodeAvgAggregate>;
    _count?: Maybe<BillingCodeCountAggregate>;
    _max?: Maybe<BillingCodeMaxAggregate>;
    _min?: Maybe<BillingCodeMinAggregate>;
    _sum?: Maybe<BillingCodeSumAggregate>;
};

export type AggregateBillingTableDownloadRequest = {
    __typename?: 'AggregateBillingTableDownloadRequest';
    _avg?: Maybe<BillingTableDownloadRequestAvgAggregate>;
    _count?: Maybe<BillingTableDownloadRequestCountAggregate>;
    _max?: Maybe<BillingTableDownloadRequestMaxAggregate>;
    _min?: Maybe<BillingTableDownloadRequestMinAggregate>;
    _sum?: Maybe<BillingTableDownloadRequestSumAggregate>;
};

export type AggregateBoughtTreatment = {
    __typename?: 'AggregateBoughtTreatment';
    _avg?: Maybe<BoughtTreatmentAvgAggregate>;
    _count?: Maybe<BoughtTreatmentCountAggregate>;
    _max?: Maybe<BoughtTreatmentMaxAggregate>;
    _min?: Maybe<BoughtTreatmentMinAggregate>;
    _sum?: Maybe<BoughtTreatmentSumAggregate>;
};

export type AggregateBoughtTreatmentAuditLog = {
    __typename?: 'AggregateBoughtTreatmentAuditLog';
    _avg?: Maybe<BoughtTreatmentAuditLogAvgAggregate>;
    _count?: Maybe<BoughtTreatmentAuditLogCountAggregate>;
    _max?: Maybe<BoughtTreatmentAuditLogMaxAggregate>;
    _min?: Maybe<BoughtTreatmentAuditLogMinAggregate>;
    _sum?: Maybe<BoughtTreatmentAuditLogSumAggregate>;
};

export type AggregateBoughtTreatmentClaimDetail = {
    __typename?: 'AggregateBoughtTreatmentClaimDetail';
    _avg?: Maybe<BoughtTreatmentClaimDetailAvgAggregate>;
    _count?: Maybe<BoughtTreatmentClaimDetailCountAggregate>;
    _max?: Maybe<BoughtTreatmentClaimDetailMaxAggregate>;
    _min?: Maybe<BoughtTreatmentClaimDetailMinAggregate>;
    _sum?: Maybe<BoughtTreatmentClaimDetailSumAggregate>;
};

export type AggregateBulkChargeCardRun = {
    __typename?: 'AggregateBulkChargeCardRun';
    _avg?: Maybe<BulkChargeCardRunAvgAggregate>;
    _count?: Maybe<BulkChargeCardRunCountAggregate>;
    _max?: Maybe<BulkChargeCardRunMaxAggregate>;
    _min?: Maybe<BulkChargeCardRunMinAggregate>;
    _sum?: Maybe<BulkChargeCardRunSumAggregate>;
};

export type AggregateBulkChargeCardRunItem = {
    __typename?: 'AggregateBulkChargeCardRunItem';
    _avg?: Maybe<BulkChargeCardRunItemAvgAggregate>;
    _count?: Maybe<BulkChargeCardRunItemCountAggregate>;
    _max?: Maybe<BulkChargeCardRunItemMaxAggregate>;
    _min?: Maybe<BulkChargeCardRunItemMinAggregate>;
    _sum?: Maybe<BulkChargeCardRunItemSumAggregate>;
};

export type AggregateBundle = {
    __typename?: 'AggregateBundle';
    _avg?: Maybe<BundleAvgAggregate>;
    _count?: Maybe<BundleCountAggregate>;
    _max?: Maybe<BundleMaxAggregate>;
    _min?: Maybe<BundleMinAggregate>;
    _sum?: Maybe<BundleSumAggregate>;
};

export type AggregateBundleToHrt = {
    __typename?: 'AggregateBundleToHrt';
    _avg?: Maybe<BundleToHrtAvgAggregate>;
    _count?: Maybe<BundleToHrtCountAggregate>;
    _max?: Maybe<BundleToHrtMaxAggregate>;
    _min?: Maybe<BundleToHrtMinAggregate>;
    _sum?: Maybe<BundleToHrtSumAggregate>;
};

export type AggregateBusinessHour = {
    __typename?: 'AggregateBusinessHour';
    _avg?: Maybe<BusinessHourAvgAggregate>;
    _count?: Maybe<BusinessHourCountAggregate>;
    _max?: Maybe<BusinessHourMaxAggregate>;
    _min?: Maybe<BusinessHourMinAggregate>;
    _sum?: Maybe<BusinessHourSumAggregate>;
};

export type AggregateCandidateTreatment = {
    __typename?: 'AggregateCandidateTreatment';
    _avg?: Maybe<CandidateTreatmentAvgAggregate>;
    _count?: Maybe<CandidateTreatmentCountAggregate>;
    _max?: Maybe<CandidateTreatmentMaxAggregate>;
    _min?: Maybe<CandidateTreatmentMinAggregate>;
    _sum?: Maybe<CandidateTreatmentSumAggregate>;
};

export type AggregateCardAuthorization = {
    __typename?: 'AggregateCardAuthorization';
    _avg?: Maybe<CardAuthorizationAvgAggregate>;
    _count?: Maybe<CardAuthorizationCountAggregate>;
    _max?: Maybe<CardAuthorizationMaxAggregate>;
    _min?: Maybe<CardAuthorizationMinAggregate>;
    _sum?: Maybe<CardAuthorizationSumAggregate>;
};

export type AggregateCardAuthorizationAuditLog = {
    __typename?: 'AggregateCardAuthorizationAuditLog';
    _avg?: Maybe<CardAuthorizationAuditLogAvgAggregate>;
    _count?: Maybe<CardAuthorizationAuditLogCountAggregate>;
    _max?: Maybe<CardAuthorizationAuditLogMaxAggregate>;
    _min?: Maybe<CardAuthorizationAuditLogMinAggregate>;
    _sum?: Maybe<CardAuthorizationAuditLogSumAggregate>;
};

export type AggregateCashPrice = {
    __typename?: 'AggregateCashPrice';
    _avg?: Maybe<CashPriceAvgAggregate>;
    _count?: Maybe<CashPriceCountAggregate>;
    _max?: Maybe<CashPriceMaxAggregate>;
    _min?: Maybe<CashPriceMinAggregate>;
    _sum?: Maybe<CashPriceSumAggregate>;
};

export type AggregateCharge = {
    __typename?: 'AggregateCharge';
    _avg?: Maybe<ChargeAvgAggregate>;
    _count?: Maybe<ChargeCountAggregate>;
    _max?: Maybe<ChargeMaxAggregate>;
    _min?: Maybe<ChargeMinAggregate>;
    _sum?: Maybe<ChargeSumAggregate>;
};

export type AggregateChargeAuditLog = {
    __typename?: 'AggregateChargeAuditLog';
    _avg?: Maybe<ChargeAuditLogAvgAggregate>;
    _count?: Maybe<ChargeAuditLogCountAggregate>;
    _max?: Maybe<ChargeAuditLogMaxAggregate>;
    _min?: Maybe<ChargeAuditLogMinAggregate>;
    _sum?: Maybe<ChargeAuditLogSumAggregate>;
};

export type AggregateChargeReattributionAndPartialPaymentLog = {
    __typename?: 'AggregateChargeReattributionAndPartialPaymentLog';
    _avg?: Maybe<ChargeReattributionAndPartialPaymentLogAvgAggregate>;
    _count?: Maybe<ChargeReattributionAndPartialPaymentLogCountAggregate>;
    _max?: Maybe<ChargeReattributionAndPartialPaymentLogMaxAggregate>;
    _min?: Maybe<ChargeReattributionAndPartialPaymentLogMinAggregate>;
    _sum?: Maybe<ChargeReattributionAndPartialPaymentLogSumAggregate>;
};

export type AggregateChargeReattributionLog = {
    __typename?: 'AggregateChargeReattributionLog';
    _avg?: Maybe<ChargeReattributionLogAvgAggregate>;
    _count?: Maybe<ChargeReattributionLogCountAggregate>;
    _max?: Maybe<ChargeReattributionLogMaxAggregate>;
    _min?: Maybe<ChargeReattributionLogMinAggregate>;
    _sum?: Maybe<ChargeReattributionLogSumAggregate>;
};

export type AggregateCheckNetworkStatusResults = {
    __typename?: 'AggregateCheckNetworkStatusResults';
    _avg?: Maybe<CheckNetworkStatusResultsAvgAggregate>;
    _count?: Maybe<CheckNetworkStatusResultsCountAggregate>;
    _max?: Maybe<CheckNetworkStatusResultsMaxAggregate>;
    _min?: Maybe<CheckNetworkStatusResultsMinAggregate>;
    _sum?: Maybe<CheckNetworkStatusResultsSumAggregate>;
};

export type AggregateCheckoutAdjudication = {
    __typename?: 'AggregateCheckoutAdjudication';
    _avg?: Maybe<CheckoutAdjudicationAvgAggregate>;
    _count?: Maybe<CheckoutAdjudicationCountAggregate>;
    _max?: Maybe<CheckoutAdjudicationMaxAggregate>;
    _min?: Maybe<CheckoutAdjudicationMinAggregate>;
    _sum?: Maybe<CheckoutAdjudicationSumAggregate>;
};

export type AggregateClaimToBoughtTreatment = {
    __typename?: 'AggregateClaimToBoughtTreatment';
    _avg?: Maybe<ClaimToBoughtTreatmentAvgAggregate>;
    _count?: Maybe<ClaimToBoughtTreatmentCountAggregate>;
    _max?: Maybe<ClaimToBoughtTreatmentMaxAggregate>;
    _min?: Maybe<ClaimToBoughtTreatmentMinAggregate>;
    _sum?: Maybe<ClaimToBoughtTreatmentSumAggregate>;
};

export type AggregateConfigCommit = {
    __typename?: 'AggregateConfigCommit';
    _avg?: Maybe<ConfigCommitAvgAggregate>;
    _count?: Maybe<ConfigCommitCountAggregate>;
    _max?: Maybe<ConfigCommitMaxAggregate>;
    _min?: Maybe<ConfigCommitMinAggregate>;
    _sum?: Maybe<ConfigCommitSumAggregate>;
};

export type AggregateConfigFlag = {
    __typename?: 'AggregateConfigFlag';
    _count?: Maybe<ConfigFlagCountAggregate>;
    _max?: Maybe<ConfigFlagMaxAggregate>;
    _min?: Maybe<ConfigFlagMinAggregate>;
};

export type AggregateConfigSession = {
    __typename?: 'AggregateConfigSession';
    _count?: Maybe<ConfigSessionCountAggregate>;
    _max?: Maybe<ConfigSessionMaxAggregate>;
    _min?: Maybe<ConfigSessionMinAggregate>;
};

export type AggregateConsentForm = {
    __typename?: 'AggregateConsentForm';
    _count?: Maybe<ConsentFormCountAggregate>;
    _max?: Maybe<ConsentFormMaxAggregate>;
    _min?: Maybe<ConsentFormMinAggregate>;
};

export type AggregateConsumer = {
    __typename?: 'AggregateConsumer';
    _count?: Maybe<ConsumerCountAggregate>;
    _max?: Maybe<ConsumerMaxAggregate>;
    _min?: Maybe<ConsumerMinAggregate>;
};

export type AggregateConsumerAuditLog = {
    __typename?: 'AggregateConsumerAuditLog';
    _avg?: Maybe<ConsumerAuditLogAvgAggregate>;
    _count?: Maybe<ConsumerAuditLogCountAggregate>;
    _max?: Maybe<ConsumerAuditLogMaxAggregate>;
    _min?: Maybe<ConsumerAuditLogMinAggregate>;
    _sum?: Maybe<ConsumerAuditLogSumAggregate>;
};

export type AggregateConsumerMessage = {
    __typename?: 'AggregateConsumerMessage';
    _avg?: Maybe<ConsumerMessageAvgAggregate>;
    _count?: Maybe<ConsumerMessageCountAggregate>;
    _max?: Maybe<ConsumerMessageMaxAggregate>;
    _min?: Maybe<ConsumerMessageMinAggregate>;
    _sum?: Maybe<ConsumerMessageSumAggregate>;
};

export type AggregateConsumerNote = {
    __typename?: 'AggregateConsumerNote';
    _count?: Maybe<ConsumerNoteCountAggregate>;
    _max?: Maybe<ConsumerNoteMaxAggregate>;
    _min?: Maybe<ConsumerNoteMinAggregate>;
};

export type AggregateConsumerPhotoMetaData = {
    __typename?: 'AggregateConsumerPhotoMetaData';
    _avg?: Maybe<ConsumerPhotoMetaDataAvgAggregate>;
    _count?: Maybe<ConsumerPhotoMetaDataCountAggregate>;
    _max?: Maybe<ConsumerPhotoMetaDataMaxAggregate>;
    _min?: Maybe<ConsumerPhotoMetaDataMinAggregate>;
    _sum?: Maybe<ConsumerPhotoMetaDataSumAggregate>;
};

export type AggregateConsumerSrtRecords = {
    __typename?: 'AggregateConsumerSrtRecords';
    _avg?: Maybe<ConsumerSrtRecordsAvgAggregate>;
    _count?: Maybe<ConsumerSrtRecordsCountAggregate>;
    _max?: Maybe<ConsumerSrtRecordsMaxAggregate>;
    _min?: Maybe<ConsumerSrtRecordsMinAggregate>;
    _sum?: Maybe<ConsumerSrtRecordsSumAggregate>;
};

export type AggregateContract = {
    __typename?: 'AggregateContract';
    _count?: Maybe<ContractCountAggregate>;
    _max?: Maybe<ContractMaxAggregate>;
    _min?: Maybe<ContractMinAggregate>;
};

export type AggregateContractAuditLog = {
    __typename?: 'AggregateContractAuditLog';
    _avg?: Maybe<ContractAuditLogAvgAggregate>;
    _count?: Maybe<ContractAuditLogCountAggregate>;
    _max?: Maybe<ContractAuditLogMaxAggregate>;
    _min?: Maybe<ContractAuditLogMinAggregate>;
    _sum?: Maybe<ContractAuditLogSumAggregate>;
};

export type AggregateCoverageResponses = {
    __typename?: 'AggregateCoverageResponses';
    _avg?: Maybe<CoverageResponsesAvgAggregate>;
    _count?: Maybe<CoverageResponsesCountAggregate>;
    _max?: Maybe<CoverageResponsesMaxAggregate>;
    _min?: Maybe<CoverageResponsesMinAggregate>;
    _sum?: Maybe<CoverageResponsesSumAggregate>;
};

export type AggregateCptExclusivityEdge = {
    __typename?: 'AggregateCptExclusivityEdge';
    _count?: Maybe<CptExclusivityEdgeCountAggregate>;
    _max?: Maybe<CptExclusivityEdgeMaxAggregate>;
    _min?: Maybe<CptExclusivityEdgeMinAggregate>;
};

export type AggregateCustomField = {
    __typename?: 'AggregateCustomField';
    _avg?: Maybe<CustomFieldAvgAggregate>;
    _count?: Maybe<CustomFieldCountAggregate>;
    _max?: Maybe<CustomFieldMaxAggregate>;
    _min?: Maybe<CustomFieldMinAggregate>;
    _sum?: Maybe<CustomFieldSumAggregate>;
};

export type AggregateCustomFieldValue = {
    __typename?: 'AggregateCustomFieldValue';
    _count?: Maybe<CustomFieldValueCountAggregate>;
    _max?: Maybe<CustomFieldValueMaxAggregate>;
    _min?: Maybe<CustomFieldValueMinAggregate>;
};

export type AggregateDataMigrations = {
    __typename?: 'AggregateDataMigrations';
    _count?: Maybe<DataMigrationsCountAggregate>;
    _max?: Maybe<DataMigrationsMaxAggregate>;
    _min?: Maybe<DataMigrationsMinAggregate>;
};

export type AggregateDefaultPractice = {
    __typename?: 'AggregateDefaultPractice';
    _avg?: Maybe<DefaultPracticeAvgAggregate>;
    _count?: Maybe<DefaultPracticeCountAggregate>;
    _max?: Maybe<DefaultPracticeMaxAggregate>;
    _min?: Maybe<DefaultPracticeMinAggregate>;
    _sum?: Maybe<DefaultPracticeSumAggregate>;
};

export type AggregateDefaultProviders = {
    __typename?: 'AggregateDefault_providers';
    _avg?: Maybe<DefaultProvidersAvgAggregate>;
    _count?: Maybe<DefaultProvidersCountAggregate>;
    _max?: Maybe<DefaultProvidersMaxAggregate>;
    _min?: Maybe<DefaultProvidersMinAggregate>;
    _sum?: Maybe<DefaultProvidersSumAggregate>;
};

export type AggregateDeploymentOrgPhase = {
    __typename?: 'AggregateDeploymentOrgPhase';
    _avg?: Maybe<DeploymentOrgPhaseAvgAggregate>;
    _count?: Maybe<DeploymentOrgPhaseCountAggregate>;
    _max?: Maybe<DeploymentOrgPhaseMaxAggregate>;
    _min?: Maybe<DeploymentOrgPhaseMinAggregate>;
    _sum?: Maybe<DeploymentOrgPhaseSumAggregate>;
};

export type AggregateDeploymentOrgTask = {
    __typename?: 'AggregateDeploymentOrgTask';
    _avg?: Maybe<DeploymentOrgTaskAvgAggregate>;
    _count?: Maybe<DeploymentOrgTaskCountAggregate>;
    _max?: Maybe<DeploymentOrgTaskMaxAggregate>;
    _min?: Maybe<DeploymentOrgTaskMinAggregate>;
    _sum?: Maybe<DeploymentOrgTaskSumAggregate>;
};

export type AggregateDeploymentOrgTaskDependency = {
    __typename?: 'AggregateDeploymentOrgTaskDependency';
    _avg?: Maybe<DeploymentOrgTaskDependencyAvgAggregate>;
    _count?: Maybe<DeploymentOrgTaskDependencyCountAggregate>;
    _max?: Maybe<DeploymentOrgTaskDependencyMaxAggregate>;
    _min?: Maybe<DeploymentOrgTaskDependencyMinAggregate>;
    _sum?: Maybe<DeploymentOrgTaskDependencySumAggregate>;
};

export type AggregateDeploymentPhase = {
    __typename?: 'AggregateDeploymentPhase';
    _avg?: Maybe<DeploymentPhaseAvgAggregate>;
    _count?: Maybe<DeploymentPhaseCountAggregate>;
    _max?: Maybe<DeploymentPhaseMaxAggregate>;
    _min?: Maybe<DeploymentPhaseMinAggregate>;
    _sum?: Maybe<DeploymentPhaseSumAggregate>;
};

export type AggregateDeploymentTask = {
    __typename?: 'AggregateDeploymentTask';
    _avg?: Maybe<DeploymentTaskAvgAggregate>;
    _count?: Maybe<DeploymentTaskCountAggregate>;
    _max?: Maybe<DeploymentTaskMaxAggregate>;
    _min?: Maybe<DeploymentTaskMinAggregate>;
    _sum?: Maybe<DeploymentTaskSumAggregate>;
};

export type AggregateDeploymentTaskDependency = {
    __typename?: 'AggregateDeploymentTaskDependency';
    _avg?: Maybe<DeploymentTaskDependencyAvgAggregate>;
    _count?: Maybe<DeploymentTaskDependencyCountAggregate>;
    _max?: Maybe<DeploymentTaskDependencyMaxAggregate>;
    _min?: Maybe<DeploymentTaskDependencyMinAggregate>;
    _sum?: Maybe<DeploymentTaskDependencySumAggregate>;
};

export type AggregateDeploymentTeam = {
    __typename?: 'AggregateDeploymentTeam';
    _avg?: Maybe<DeploymentTeamAvgAggregate>;
    _count?: Maybe<DeploymentTeamCountAggregate>;
    _max?: Maybe<DeploymentTeamMaxAggregate>;
    _min?: Maybe<DeploymentTeamMinAggregate>;
    _sum?: Maybe<DeploymentTeamSumAggregate>;
};

export type AggregateDiscountCodes = {
    __typename?: 'AggregateDiscountCodes';
    _avg?: Maybe<DiscountCodesAvgAggregate>;
    _count?: Maybe<DiscountCodesCountAggregate>;
    _max?: Maybe<DiscountCodesMaxAggregate>;
    _min?: Maybe<DiscountCodesMinAggregate>;
    _sum?: Maybe<DiscountCodesSumAggregate>;
};

export type AggregateEcwPayerAlias = {
    __typename?: 'AggregateEcwPayerAlias';
    _avg?: Maybe<EcwPayerAliasAvgAggregate>;
    _count?: Maybe<EcwPayerAliasCountAggregate>;
    _max?: Maybe<EcwPayerAliasMaxAggregate>;
    _min?: Maybe<EcwPayerAliasMinAggregate>;
    _sum?: Maybe<EcwPayerAliasSumAggregate>;
};

export type AggregateEcwPayerStc = {
    __typename?: 'AggregateEcwPayerStc';
    _avg?: Maybe<EcwPayerStcAvgAggregate>;
    _count?: Maybe<EcwPayerStcCountAggregate>;
    _max?: Maybe<EcwPayerStcMaxAggregate>;
    _min?: Maybe<EcwPayerStcMinAggregate>;
    _sum?: Maybe<EcwPayerStcSumAggregate>;
};

export type AggregateEhrAppointmentTypeIdToName = {
    __typename?: 'AggregateEhrAppointmentTypeIdToName';
    _avg?: Maybe<EhrAppointmentTypeIdToNameAvgAggregate>;
    _count?: Maybe<EhrAppointmentTypeIdToNameCountAggregate>;
    _max?: Maybe<EhrAppointmentTypeIdToNameMaxAggregate>;
    _min?: Maybe<EhrAppointmentTypeIdToNameMinAggregate>;
    _sum?: Maybe<EhrAppointmentTypeIdToNameSumAggregate>;
};

export type AggregateEhrPaymentDescriptor = {
    __typename?: 'AggregateEhrPaymentDescriptor';
    _avg?: Maybe<EhrPaymentDescriptorAvgAggregate>;
    _count?: Maybe<EhrPaymentDescriptorCountAggregate>;
    _max?: Maybe<EhrPaymentDescriptorMaxAggregate>;
    _min?: Maybe<EhrPaymentDescriptorMinAggregate>;
    _sum?: Maybe<EhrPaymentDescriptorSumAggregate>;
};

export type AggregateEhrPaymentDescriptorAuditLog = {
    __typename?: 'AggregateEhrPaymentDescriptorAuditLog';
    _avg?: Maybe<EhrPaymentDescriptorAuditLogAvgAggregate>;
    _count?: Maybe<EhrPaymentDescriptorAuditLogCountAggregate>;
    _max?: Maybe<EhrPaymentDescriptorAuditLogMaxAggregate>;
    _min?: Maybe<EhrPaymentDescriptorAuditLogMinAggregate>;
    _sum?: Maybe<EhrPaymentDescriptorAuditLogSumAggregate>;
};

export type AggregateEhrPaymentDirectionSsAsset = {
    __typename?: 'AggregateEhrPaymentDirectionSsAsset';
    _avg?: Maybe<EhrPaymentDirectionSsAssetAvgAggregate>;
    _count?: Maybe<EhrPaymentDirectionSsAssetCountAggregate>;
    _max?: Maybe<EhrPaymentDirectionSsAssetMaxAggregate>;
    _min?: Maybe<EhrPaymentDirectionSsAssetMinAggregate>;
    _sum?: Maybe<EhrPaymentDirectionSsAssetSumAggregate>;
};

export type AggregateEhrPostDetail = {
    __typename?: 'AggregateEhrPostDetail';
    _avg?: Maybe<EhrPostDetailAvgAggregate>;
    _count?: Maybe<EhrPostDetailCountAggregate>;
    _max?: Maybe<EhrPostDetailMaxAggregate>;
    _min?: Maybe<EhrPostDetailMinAggregate>;
    _sum?: Maybe<EhrPostDetailSumAggregate>;
};

export type AggregateEhrPostDetailToPayout = {
    __typename?: 'AggregateEhrPostDetailToPayout';
    _count?: Maybe<EhrPostDetailToPayoutCountAggregate>;
    _max?: Maybe<EhrPostDetailToPayoutMaxAggregate>;
    _min?: Maybe<EhrPostDetailToPayoutMinAggregate>;
};

export type AggregateEhrPostLedger = {
    __typename?: 'AggregateEhrPostLedger';
    _avg?: Maybe<EhrPostLedgerAvgAggregate>;
    _count?: Maybe<EhrPostLedgerCountAggregate>;
    _max?: Maybe<EhrPostLedgerMaxAggregate>;
    _min?: Maybe<EhrPostLedgerMinAggregate>;
    _sum?: Maybe<EhrPostLedgerSumAggregate>;
};

export type AggregateEhrPostLedgerAuditLog = {
    __typename?: 'AggregateEhrPostLedgerAuditLog';
    _avg?: Maybe<EhrPostLedgerAuditLogAvgAggregate>;
    _count?: Maybe<EhrPostLedgerAuditLogCountAggregate>;
    _max?: Maybe<EhrPostLedgerAuditLogMaxAggregate>;
    _min?: Maybe<EhrPostLedgerAuditLogMinAggregate>;
    _sum?: Maybe<EhrPostLedgerAuditLogSumAggregate>;
};

export type AggregateEhrPostLedgerToPayout = {
    __typename?: 'AggregateEhrPostLedgerToPayout';
    _count?: Maybe<EhrPostLedgerToPayoutCountAggregate>;
    _max?: Maybe<EhrPostLedgerToPayoutMaxAggregate>;
    _min?: Maybe<EhrPostLedgerToPayoutMinAggregate>;
};

export type AggregateEhrPrimaryCareProvider = {
    __typename?: 'AggregateEhrPrimaryCareProvider';
    _avg?: Maybe<EhrPrimaryCareProviderAvgAggregate>;
    _count?: Maybe<EhrPrimaryCareProviderCountAggregate>;
    _max?: Maybe<EhrPrimaryCareProviderMaxAggregate>;
    _min?: Maybe<EhrPrimaryCareProviderMinAggregate>;
    _sum?: Maybe<EhrPrimaryCareProviderSumAggregate>;
};

export type AggregateEhrProviderMapping = {
    __typename?: 'AggregateEhrProviderMapping';
    _avg?: Maybe<EhrProviderMappingAvgAggregate>;
    _count?: Maybe<EhrProviderMappingCountAggregate>;
    _max?: Maybe<EhrProviderMappingMaxAggregate>;
    _min?: Maybe<EhrProviderMappingMinAggregate>;
    _sum?: Maybe<EhrProviderMappingSumAggregate>;
};

export type AggregateEhrSlot = {
    __typename?: 'AggregateEhrSlot';
    _avg?: Maybe<EhrSlotAvgAggregate>;
    _count?: Maybe<EhrSlotCountAggregate>;
    _max?: Maybe<EhrSlotMaxAggregate>;
    _min?: Maybe<EhrSlotMinAggregate>;
    _sum?: Maybe<EhrSlotSumAggregate>;
};

export type AggregateEhrSlotAuditLog = {
    __typename?: 'AggregateEhrSlotAuditLog';
    _avg?: Maybe<EhrSlotAuditLogAvgAggregate>;
    _count?: Maybe<EhrSlotAuditLogCountAggregate>;
    _max?: Maybe<EhrSlotAuditLogMaxAggregate>;
    _min?: Maybe<EhrSlotAuditLogMinAggregate>;
    _sum?: Maybe<EhrSlotAuditLogSumAggregate>;
};

export type AggregateEncounter = {
    __typename?: 'AggregateEncounter';
    _avg?: Maybe<EncounterAvgAggregate>;
    _count?: Maybe<EncounterCountAggregate>;
    _max?: Maybe<EncounterMaxAggregate>;
    _min?: Maybe<EncounterMinAggregate>;
    _sum?: Maybe<EncounterSumAggregate>;
};

export type AggregateExperityEncounter = {
    __typename?: 'AggregateExperityEncounter';
    _avg?: Maybe<ExperityEncounterAvgAggregate>;
    _count?: Maybe<ExperityEncounterCountAggregate>;
    _max?: Maybe<ExperityEncounterMaxAggregate>;
    _min?: Maybe<ExperityEncounterMinAggregate>;
    _sum?: Maybe<ExperityEncounterSumAggregate>;
};

export type AggregateFaqDropdowns = {
    __typename?: 'AggregateFaqDropdowns';
    _avg?: Maybe<FaqDropdownsAvgAggregate>;
    _count?: Maybe<FaqDropdownsCountAggregate>;
    _max?: Maybe<FaqDropdownsMaxAggregate>;
    _min?: Maybe<FaqDropdownsMinAggregate>;
    _sum?: Maybe<FaqDropdownsSumAggregate>;
};

export type AggregateFeeConfig = {
    __typename?: 'AggregateFeeConfig';
    _avg?: Maybe<FeeConfigAvgAggregate>;
    _count?: Maybe<FeeConfigCountAggregate>;
    _max?: Maybe<FeeConfigMaxAggregate>;
    _min?: Maybe<FeeConfigMinAggregate>;
    _sum?: Maybe<FeeConfigSumAggregate>;
};

export type AggregateFeeConfigAuditLog = {
    __typename?: 'AggregateFeeConfigAuditLog';
    _avg?: Maybe<FeeConfigAuditLogAvgAggregate>;
    _count?: Maybe<FeeConfigAuditLogCountAggregate>;
    _max?: Maybe<FeeConfigAuditLogMaxAggregate>;
    _min?: Maybe<FeeConfigAuditLogMinAggregate>;
    _sum?: Maybe<FeeConfigAuditLogSumAggregate>;
};

export type AggregateGuarantorPaymentLinkContext = {
    __typename?: 'AggregateGuarantorPaymentLinkContext';
    _avg?: Maybe<GuarantorPaymentLinkContextAvgAggregate>;
    _count?: Maybe<GuarantorPaymentLinkContextCountAggregate>;
    _max?: Maybe<GuarantorPaymentLinkContextMaxAggregate>;
    _min?: Maybe<GuarantorPaymentLinkContextMinAggregate>;
    _sum?: Maybe<GuarantorPaymentLinkContextSumAggregate>;
};

export type AggregateHoliday = {
    __typename?: 'AggregateHoliday';
    _avg?: Maybe<HolidayAvgAggregate>;
    _count?: Maybe<HolidayCountAggregate>;
    _max?: Maybe<HolidayMaxAggregate>;
    _min?: Maybe<HolidayMinAggregate>;
    _sum?: Maybe<HolidaySumAggregate>;
};

export type AggregateHrt = {
    __typename?: 'AggregateHrt';
    _avg?: Maybe<HrtAvgAggregate>;
    _count?: Maybe<HrtCountAggregate>;
    _max?: Maybe<HrtMaxAggregate>;
    _min?: Maybe<HrtMinAggregate>;
    _sum?: Maybe<HrtSumAggregate>;
};

export type AggregateHrtFlags = {
    __typename?: 'AggregateHrtFlags';
    _avg?: Maybe<HrtFlagsAvgAggregate>;
    _count?: Maybe<HrtFlagsCountAggregate>;
    _max?: Maybe<HrtFlagsMaxAggregate>;
    _min?: Maybe<HrtFlagsMinAggregate>;
    _sum?: Maybe<HrtFlagsSumAggregate>;
};

export type AggregateHrtPaymentType = {
    __typename?: 'AggregateHrtPaymentType';
    _avg?: Maybe<HrtPaymentTypeAvgAggregate>;
    _count?: Maybe<HrtPaymentTypeCountAggregate>;
    _max?: Maybe<HrtPaymentTypeMaxAggregate>;
    _min?: Maybe<HrtPaymentTypeMinAggregate>;
    _sum?: Maybe<HrtPaymentTypeSumAggregate>;
};

export type AggregateHrtToSrt = {
    __typename?: 'AggregateHrtToSrt';
    _avg?: Maybe<HrtToSrtAvgAggregate>;
    _count?: Maybe<HrtToSrtCountAggregate>;
    _max?: Maybe<HrtToSrtMaxAggregate>;
    _min?: Maybe<HrtToSrtMinAggregate>;
    _sum?: Maybe<HrtToSrtSumAggregate>;
};

export type AggregateHrtTranslation = {
    __typename?: 'AggregateHrtTranslation';
    _avg?: Maybe<HrtTranslationAvgAggregate>;
    _count?: Maybe<HrtTranslationCountAggregate>;
    _max?: Maybe<HrtTranslationMaxAggregate>;
    _min?: Maybe<HrtTranslationMinAggregate>;
    _sum?: Maybe<HrtTranslationSumAggregate>;
};

export type AggregateInboundRequestLog = {
    __typename?: 'AggregateInboundRequestLog';
    _avg?: Maybe<InboundRequestLogAvgAggregate>;
    _count?: Maybe<InboundRequestLogCountAggregate>;
    _max?: Maybe<InboundRequestLogMaxAggregate>;
    _min?: Maybe<InboundRequestLogMinAggregate>;
    _sum?: Maybe<InboundRequestLogSumAggregate>;
};

export type AggregateInboundTextMessageLog = {
    __typename?: 'AggregateInboundTextMessageLog';
    _count?: Maybe<InboundTextMessageLogCountAggregate>;
    _max?: Maybe<InboundTextMessageLogMaxAggregate>;
    _min?: Maybe<InboundTextMessageLogMinAggregate>;
};

export type AggregateInsurance = {
    __typename?: 'AggregateInsurance';
    _avg?: Maybe<InsuranceAvgAggregate>;
    _count?: Maybe<InsuranceCountAggregate>;
    _max?: Maybe<InsuranceMaxAggregate>;
    _min?: Maybe<InsuranceMinAggregate>;
    _sum?: Maybe<InsuranceSumAggregate>;
};

export type AggregateInsuranceAuditLog = {
    __typename?: 'AggregateInsuranceAuditLog';
    _avg?: Maybe<InsuranceAuditLogAvgAggregate>;
    _count?: Maybe<InsuranceAuditLogCountAggregate>;
    _max?: Maybe<InsuranceAuditLogMaxAggregate>;
    _min?: Maybe<InsuranceAuditLogMinAggregate>;
    _sum?: Maybe<InsuranceAuditLogSumAggregate>;
};

export type AggregateInsuranceMetadata = {
    __typename?: 'AggregateInsuranceMetadata';
    _count?: Maybe<InsuranceMetadataCountAggregate>;
    _max?: Maybe<InsuranceMetadataMaxAggregate>;
    _min?: Maybe<InsuranceMetadataMinAggregate>;
};

export type AggregateIntakeForm = {
    __typename?: 'AggregateIntakeForm';
    _avg?: Maybe<IntakeFormAvgAggregate>;
    _count?: Maybe<IntakeFormCountAggregate>;
    _max?: Maybe<IntakeFormMaxAggregate>;
    _min?: Maybe<IntakeFormMinAggregate>;
    _sum?: Maybe<IntakeFormSumAggregate>;
};

export type AggregateIntakeFormSection = {
    __typename?: 'AggregateIntakeFormSection';
    _avg?: Maybe<IntakeFormSectionAvgAggregate>;
    _count?: Maybe<IntakeFormSectionCountAggregate>;
    _max?: Maybe<IntakeFormSectionMaxAggregate>;
    _min?: Maybe<IntakeFormSectionMinAggregate>;
    _sum?: Maybe<IntakeFormSectionSumAggregate>;
};

export type AggregateIntakeFormSectionTranslation = {
    __typename?: 'AggregateIntakeFormSectionTranslation';
    _avg?: Maybe<IntakeFormSectionTranslationAvgAggregate>;
    _count?: Maybe<IntakeFormSectionTranslationCountAggregate>;
    _max?: Maybe<IntakeFormSectionTranslationMaxAggregate>;
    _min?: Maybe<IntakeFormSectionTranslationMinAggregate>;
    _sum?: Maybe<IntakeFormSectionTranslationSumAggregate>;
};

export type AggregateIntakeFormToQuestion = {
    __typename?: 'AggregateIntakeFormToQuestion';
    _avg?: Maybe<IntakeFormToQuestionAvgAggregate>;
    _count?: Maybe<IntakeFormToQuestionCountAggregate>;
    _max?: Maybe<IntakeFormToQuestionMaxAggregate>;
    _min?: Maybe<IntakeFormToQuestionMinAggregate>;
    _sum?: Maybe<IntakeFormToQuestionSumAggregate>;
};

export type AggregateIntakeQuestion = {
    __typename?: 'AggregateIntakeQuestion';
    _avg?: Maybe<IntakeQuestionAvgAggregate>;
    _count?: Maybe<IntakeQuestionCountAggregate>;
    _max?: Maybe<IntakeQuestionMaxAggregate>;
    _min?: Maybe<IntakeQuestionMinAggregate>;
    _sum?: Maybe<IntakeQuestionSumAggregate>;
};

export type AggregateIntakeQuestionTranslation = {
    __typename?: 'AggregateIntakeQuestionTranslation';
    _avg?: Maybe<IntakeQuestionTranslationAvgAggregate>;
    _count?: Maybe<IntakeQuestionTranslationCountAggregate>;
    _max?: Maybe<IntakeQuestionTranslationMaxAggregate>;
    _min?: Maybe<IntakeQuestionTranslationMinAggregate>;
    _sum?: Maybe<IntakeQuestionTranslationSumAggregate>;
};

export type AggregateInvoiceDailyLineItems = {
    __typename?: 'AggregateInvoiceDailyLineItems';
    _avg?: Maybe<InvoiceDailyLineItemsAvgAggregate>;
    _count?: Maybe<InvoiceDailyLineItemsCountAggregate>;
    _max?: Maybe<InvoiceDailyLineItemsMaxAggregate>;
    _min?: Maybe<InvoiceDailyLineItemsMinAggregate>;
    _sum?: Maybe<InvoiceDailyLineItemsSumAggregate>;
};

export type AggregateInvoices = {
    __typename?: 'AggregateInvoices';
    _avg?: Maybe<InvoicesAvgAggregate>;
    _count?: Maybe<InvoicesCountAggregate>;
    _max?: Maybe<InvoicesMaxAggregate>;
    _min?: Maybe<InvoicesMinAggregate>;
    _sum?: Maybe<InvoicesSumAggregate>;
};

export type AggregateKeywordRule = {
    __typename?: 'AggregateKeywordRule';
    _avg?: Maybe<KeywordRuleAvgAggregate>;
    _count?: Maybe<KeywordRuleCountAggregate>;
    _max?: Maybe<KeywordRuleMaxAggregate>;
    _min?: Maybe<KeywordRuleMinAggregate>;
    _sum?: Maybe<KeywordRuleSumAggregate>;
};

export type AggregateLinkMapping = {
    __typename?: 'AggregateLinkMapping';
    _count?: Maybe<LinkMappingCountAggregate>;
    _max?: Maybe<LinkMappingMaxAggregate>;
    _min?: Maybe<LinkMappingMinAggregate>;
};

export type AggregateLiveTransfers = {
    __typename?: 'AggregateLiveTransfers';
    _avg?: Maybe<LiveTransfersAvgAggregate>;
    _count?: Maybe<LiveTransfersCountAggregate>;
    _max?: Maybe<LiveTransfersMaxAggregate>;
    _min?: Maybe<LiveTransfersMinAggregate>;
    _sum?: Maybe<LiveTransfersSumAggregate>;
};

export type AggregateMcmsAssociation = {
    __typename?: 'AggregateMcmsAssociation';
    _avg?: Maybe<McmsAssociationAvgAggregate>;
    _count?: Maybe<McmsAssociationCountAggregate>;
    _max?: Maybe<McmsAssociationMaxAggregate>;
    _min?: Maybe<McmsAssociationMinAggregate>;
    _sum?: Maybe<McmsAssociationSumAggregate>;
};

export type AggregateMcmsAssociationAuditLog = {
    __typename?: 'AggregateMcmsAssociationAuditLog';
    _avg?: Maybe<McmsAssociationAuditLogAvgAggregate>;
    _count?: Maybe<McmsAssociationAuditLogCountAggregate>;
    _max?: Maybe<McmsAssociationAuditLogMaxAggregate>;
    _min?: Maybe<McmsAssociationAuditLogMinAggregate>;
    _sum?: Maybe<McmsAssociationAuditLogSumAggregate>;
};

export type AggregateMcmsAssociationClaim = {
    __typename?: 'AggregateMcmsAssociationClaim';
    _avg?: Maybe<McmsAssociationClaimAvgAggregate>;
    _count?: Maybe<McmsAssociationClaimCountAggregate>;
    _max?: Maybe<McmsAssociationClaimMaxAggregate>;
    _min?: Maybe<McmsAssociationClaimMinAggregate>;
    _sum?: Maybe<McmsAssociationClaimSumAggregate>;
};

export type AggregateMcmsAssociationClaimAuditLog = {
    __typename?: 'AggregateMcmsAssociationClaimAuditLog';
    _avg?: Maybe<McmsAssociationClaimAuditLogAvgAggregate>;
    _count?: Maybe<McmsAssociationClaimAuditLogCountAggregate>;
    _max?: Maybe<McmsAssociationClaimAuditLogMaxAggregate>;
    _min?: Maybe<McmsAssociationClaimAuditLogMinAggregate>;
    _sum?: Maybe<McmsAssociationClaimAuditLogSumAggregate>;
};

export type AggregateMcmsAssociationSlot = {
    __typename?: 'AggregateMcmsAssociationSlot';
    _count?: Maybe<McmsAssociationSlotCountAggregate>;
    _max?: Maybe<McmsAssociationSlotMaxAggregate>;
    _min?: Maybe<McmsAssociationSlotMinAggregate>;
};

export type AggregateMcmsAssociationSlotAuditLog = {
    __typename?: 'AggregateMcmsAssociationSlotAuditLog';
    _avg?: Maybe<McmsAssociationSlotAuditLogAvgAggregate>;
    _count?: Maybe<McmsAssociationSlotAuditLogCountAggregate>;
    _max?: Maybe<McmsAssociationSlotAuditLogMaxAggregate>;
    _min?: Maybe<McmsAssociationSlotAuditLogMinAggregate>;
    _sum?: Maybe<McmsAssociationSlotAuditLogSumAggregate>;
};

export type AggregateMessageBlueprint = {
    __typename?: 'AggregateMessageBlueprint';
    _count?: Maybe<MessageBlueprintCountAggregate>;
    _max?: Maybe<MessageBlueprintMaxAggregate>;
    _min?: Maybe<MessageBlueprintMinAggregate>;
};

export type AggregateMessageConsolidationContext = {
    __typename?: 'AggregateMessageConsolidationContext';
    _count?: Maybe<MessageConsolidationContextCountAggregate>;
    _max?: Maybe<MessageConsolidationContextMaxAggregate>;
    _min?: Maybe<MessageConsolidationContextMinAggregate>;
};

export type AggregateMessageConsolidationTemplate = {
    __typename?: 'AggregateMessageConsolidationTemplate';
    _avg?: Maybe<MessageConsolidationTemplateAvgAggregate>;
    _count?: Maybe<MessageConsolidationTemplateCountAggregate>;
    _max?: Maybe<MessageConsolidationTemplateMaxAggregate>;
    _min?: Maybe<MessageConsolidationTemplateMinAggregate>;
    _sum?: Maybe<MessageConsolidationTemplateSumAggregate>;
};

export type AggregateMessageNudge = {
    __typename?: 'AggregateMessageNudge';
    _avg?: Maybe<MessageNudgeAvgAggregate>;
    _count?: Maybe<MessageNudgeCountAggregate>;
    _max?: Maybe<MessageNudgeMaxAggregate>;
    _min?: Maybe<MessageNudgeMinAggregate>;
    _sum?: Maybe<MessageNudgeSumAggregate>;
};

export type AggregateMessageOrchestrationRule = {
    __typename?: 'AggregateMessageOrchestrationRule';
    _avg?: Maybe<MessageOrchestrationRuleAvgAggregate>;
    _count?: Maybe<MessageOrchestrationRuleCountAggregate>;
    _max?: Maybe<MessageOrchestrationRuleMaxAggregate>;
    _min?: Maybe<MessageOrchestrationRuleMinAggregate>;
    _sum?: Maybe<MessageOrchestrationRuleSumAggregate>;
};

export type AggregateMessagePayAfter = {
    __typename?: 'AggregateMessagePayAfter';
    _avg?: Maybe<MessagePayAfterAvgAggregate>;
    _count?: Maybe<MessagePayAfterCountAggregate>;
    _max?: Maybe<MessagePayAfterMaxAggregate>;
    _min?: Maybe<MessagePayAfterMinAggregate>;
    _sum?: Maybe<MessagePayAfterSumAggregate>;
};

export type AggregateMessageSettingsHrt = {
    __typename?: 'AggregateMessageSettingsHrt';
    _avg?: Maybe<MessageSettingsHrtAvgAggregate>;
    _count?: Maybe<MessageSettingsHrtCountAggregate>;
    _max?: Maybe<MessageSettingsHrtMaxAggregate>;
    _min?: Maybe<MessageSettingsHrtMinAggregate>;
    _sum?: Maybe<MessageSettingsHrtSumAggregate>;
};

export type AggregateMessageSettingsOrg = {
    __typename?: 'AggregateMessageSettingsOrg';
    _avg?: Maybe<MessageSettingsOrgAvgAggregate>;
    _count?: Maybe<MessageSettingsOrgCountAggregate>;
    _max?: Maybe<MessageSettingsOrgMaxAggregate>;
    _min?: Maybe<MessageSettingsOrgMinAggregate>;
    _sum?: Maybe<MessageSettingsOrgSumAggregate>;
};

export type AggregateMessageTemplateHrt = {
    __typename?: 'AggregateMessageTemplateHrt';
    _avg?: Maybe<MessageTemplateHrtAvgAggregate>;
    _count?: Maybe<MessageTemplateHrtCountAggregate>;
    _max?: Maybe<MessageTemplateHrtMaxAggregate>;
    _min?: Maybe<MessageTemplateHrtMinAggregate>;
    _sum?: Maybe<MessageTemplateHrtSumAggregate>;
};

export type AggregateMessageTemplateOrg = {
    __typename?: 'AggregateMessageTemplateOrg';
    _avg?: Maybe<MessageTemplateOrgAvgAggregate>;
    _count?: Maybe<MessageTemplateOrgCountAggregate>;
    _max?: Maybe<MessageTemplateOrgMaxAggregate>;
    _min?: Maybe<MessageTemplateOrgMinAggregate>;
    _sum?: Maybe<MessageTemplateOrgSumAggregate>;
};

export type AggregateMigratedEncounter = {
    __typename?: 'AggregateMigratedEncounter';
    _count?: Maybe<MigratedEncounterCountAggregate>;
    _max?: Maybe<MigratedEncounterMaxAggregate>;
    _min?: Maybe<MigratedEncounterMinAggregate>;
};

export type AggregateMigrations = {
    __typename?: 'AggregateMigrations';
    _avg?: Maybe<MigrationsAvgAggregate>;
    _count?: Maybe<MigrationsCountAggregate>;
    _max?: Maybe<MigrationsMaxAggregate>;
    _min?: Maybe<MigrationsMinAggregate>;
    _sum?: Maybe<MigrationsSumAggregate>;
};

export type AggregateNetworkValidation = {
    __typename?: 'AggregateNetworkValidation';
    _avg?: Maybe<NetworkValidationAvgAggregate>;
    _count?: Maybe<NetworkValidationCountAggregate>;
    _max?: Maybe<NetworkValidationMaxAggregate>;
    _min?: Maybe<NetworkValidationMinAggregate>;
    _sum?: Maybe<NetworkValidationSumAggregate>;
};

export type AggregateNetworkPlanExceptions = {
    __typename?: 'AggregateNetwork_plan_exceptions';
    _avg?: Maybe<NetworkPlanExceptionsAvgAggregate>;
    _count?: Maybe<NetworkPlanExceptionsCountAggregate>;
    _max?: Maybe<NetworkPlanExceptionsMaxAggregate>;
    _min?: Maybe<NetworkPlanExceptionsMinAggregate>;
    _sum?: Maybe<NetworkPlanExceptionsSumAggregate>;
};

export type AggregateNonCardRefunds = {
    __typename?: 'AggregateNonCardRefunds';
    _avg?: Maybe<NonCardRefundsAvgAggregate>;
    _count?: Maybe<NonCardRefundsCountAggregate>;
    _max?: Maybe<NonCardRefundsMaxAggregate>;
    _min?: Maybe<NonCardRefundsMinAggregate>;
    _sum?: Maybe<NonCardRefundsSumAggregate>;
};

export type AggregateOrgConfigFlag = {
    __typename?: 'AggregateOrgConfigFlag';
    _avg?: Maybe<OrgConfigFlagAvgAggregate>;
    _count?: Maybe<OrgConfigFlagCountAggregate>;
    _max?: Maybe<OrgConfigFlagMaxAggregate>;
    _min?: Maybe<OrgConfigFlagMinAggregate>;
    _sum?: Maybe<OrgConfigFlagSumAggregate>;
};

export type AggregateOrgHrtSrtRule = {
    __typename?: 'AggregateOrgHrtSrtRule';
    _avg?: Maybe<OrgHrtSrtRuleAvgAggregate>;
    _count?: Maybe<OrgHrtSrtRuleCountAggregate>;
    _max?: Maybe<OrgHrtSrtRuleMaxAggregate>;
    _min?: Maybe<OrgHrtSrtRuleMinAggregate>;
    _sum?: Maybe<OrgHrtSrtRuleSumAggregate>;
};

export type AggregateOrgNetworkResults = {
    __typename?: 'AggregateOrgNetworkResults';
    _avg?: Maybe<OrgNetworkResultsAvgAggregate>;
    _count?: Maybe<OrgNetworkResultsCountAggregate>;
    _max?: Maybe<OrgNetworkResultsMaxAggregate>;
    _min?: Maybe<OrgNetworkResultsMinAggregate>;
    _sum?: Maybe<OrgNetworkResultsSumAggregate>;
};

export type AggregateOrgOverrideRule = {
    __typename?: 'AggregateOrgOverrideRule';
    _avg?: Maybe<OrgOverrideRuleAvgAggregate>;
    _count?: Maybe<OrgOverrideRuleCountAggregate>;
    _max?: Maybe<OrgOverrideRuleMaxAggregate>;
    _min?: Maybe<OrgOverrideRuleMinAggregate>;
    _sum?: Maybe<OrgOverrideRuleSumAggregate>;
};

export type AggregateOrgFees = {
    __typename?: 'AggregateOrg_fees';
    _avg?: Maybe<OrgFeesAvgAggregate>;
    _count?: Maybe<OrgFeesCountAggregate>;
    _max?: Maybe<OrgFeesMaxAggregate>;
    _min?: Maybe<OrgFeesMinAggregate>;
    _sum?: Maybe<OrgFeesSumAggregate>;
};

export type AggregateOrgStripeMapping = {
    __typename?: 'AggregateOrg_stripe_mapping';
    _avg?: Maybe<OrgStripeMappingAvgAggregate>;
    _count?: Maybe<OrgStripeMappingCountAggregate>;
    _max?: Maybe<OrgStripeMappingMaxAggregate>;
    _min?: Maybe<OrgStripeMappingMinAggregate>;
    _sum?: Maybe<OrgStripeMappingSumAggregate>;
};

export type AggregateOrganization = {
    __typename?: 'AggregateOrganization';
    _avg?: Maybe<OrganizationAvgAggregate>;
    _count?: Maybe<OrganizationCountAggregate>;
    _max?: Maybe<OrganizationMaxAggregate>;
    _min?: Maybe<OrganizationMinAggregate>;
    _sum?: Maybe<OrganizationSumAggregate>;
};

export type AggregateOrganizationAssets = {
    __typename?: 'AggregateOrganizationAssets';
    _avg?: Maybe<OrganizationAssetsAvgAggregate>;
    _count?: Maybe<OrganizationAssetsCountAggregate>;
    _max?: Maybe<OrganizationAssetsMaxAggregate>;
    _min?: Maybe<OrganizationAssetsMinAggregate>;
    _sum?: Maybe<OrganizationAssetsSumAggregate>;
};

export type AggregateOrganizationTranslation = {
    __typename?: 'AggregateOrganizationTranslation';
    _avg?: Maybe<OrganizationTranslationAvgAggregate>;
    _count?: Maybe<OrganizationTranslationCountAggregate>;
    _max?: Maybe<OrganizationTranslationMaxAggregate>;
    _min?: Maybe<OrganizationTranslationMinAggregate>;
    _sum?: Maybe<OrganizationTranslationSumAggregate>;
};

export type AggregatePayLaterAuthorization = {
    __typename?: 'AggregatePayLaterAuthorization';
    _avg?: Maybe<PayLaterAuthorizationAvgAggregate>;
    _count?: Maybe<PayLaterAuthorizationCountAggregate>;
    _max?: Maybe<PayLaterAuthorizationMaxAggregate>;
    _min?: Maybe<PayLaterAuthorizationMinAggregate>;
    _sum?: Maybe<PayLaterAuthorizationSumAggregate>;
};

export type AggregatePayLaterAuthorizationAuditLog = {
    __typename?: 'AggregatePayLaterAuthorizationAuditLog';
    _avg?: Maybe<PayLaterAuthorizationAuditLogAvgAggregate>;
    _count?: Maybe<PayLaterAuthorizationAuditLogCountAggregate>;
    _max?: Maybe<PayLaterAuthorizationAuditLogMaxAggregate>;
    _min?: Maybe<PayLaterAuthorizationAuditLogMinAggregate>;
    _sum?: Maybe<PayLaterAuthorizationAuditLogSumAggregate>;
};

export type AggregatePayer = {
    __typename?: 'AggregatePayer';
    _avg?: Maybe<PayerAvgAggregate>;
    _count?: Maybe<PayerCountAggregate>;
    _max?: Maybe<PayerMaxAggregate>;
    _min?: Maybe<PayerMinAggregate>;
    _sum?: Maybe<PayerSumAggregate>;
};

export type AggregatePayerPlanMapping = {
    __typename?: 'AggregatePayerPlanMapping';
    _avg?: Maybe<PayerPlanMappingAvgAggregate>;
    _count?: Maybe<PayerPlanMappingCountAggregate>;
    _max?: Maybe<PayerPlanMappingMaxAggregate>;
    _min?: Maybe<PayerPlanMappingMinAggregate>;
    _sum?: Maybe<PayerPlanMappingSumAggregate>;
};

export type AggregatePayerToEhrInsurancePackageMapping = {
    __typename?: 'AggregatePayerToEhrInsurancePackageMapping';
    _avg?: Maybe<PayerToEhrInsurancePackageMappingAvgAggregate>;
    _count?: Maybe<PayerToEhrInsurancePackageMappingCountAggregate>;
    _max?: Maybe<PayerToEhrInsurancePackageMappingMaxAggregate>;
    _min?: Maybe<PayerToEhrInsurancePackageMappingMinAggregate>;
    _sum?: Maybe<PayerToEhrInsurancePackageMappingSumAggregate>;
};

export type AggregatePaymentAuthorization = {
    __typename?: 'AggregatePaymentAuthorization';
    _avg?: Maybe<PaymentAuthorizationAvgAggregate>;
    _count?: Maybe<PaymentAuthorizationCountAggregate>;
    _max?: Maybe<PaymentAuthorizationMaxAggregate>;
    _min?: Maybe<PaymentAuthorizationMinAggregate>;
    _sum?: Maybe<PaymentAuthorizationSumAggregate>;
};

export type AggregatePaymentAuthorizationAuditLog = {
    __typename?: 'AggregatePaymentAuthorizationAuditLog';
    _avg?: Maybe<PaymentAuthorizationAuditLogAvgAggregate>;
    _count?: Maybe<PaymentAuthorizationAuditLogCountAggregate>;
    _max?: Maybe<PaymentAuthorizationAuditLogMaxAggregate>;
    _min?: Maybe<PaymentAuthorizationAuditLogMinAggregate>;
    _sum?: Maybe<PaymentAuthorizationAuditLogSumAggregate>;
};

export type AggregatePaymentContract = {
    __typename?: 'AggregatePaymentContract';
    _avg?: Maybe<PaymentContractAvgAggregate>;
    _count?: Maybe<PaymentContractCountAggregate>;
    _max?: Maybe<PaymentContractMaxAggregate>;
    _min?: Maybe<PaymentContractMinAggregate>;
    _sum?: Maybe<PaymentContractSumAggregate>;
};

export type AggregatePaymentPlan = {
    __typename?: 'AggregatePaymentPlan';
    _avg?: Maybe<PaymentPlanAvgAggregate>;
    _count?: Maybe<PaymentPlanCountAggregate>;
    _max?: Maybe<PaymentPlanMaxAggregate>;
    _min?: Maybe<PaymentPlanMinAggregate>;
    _sum?: Maybe<PaymentPlanSumAggregate>;
};

export type AggregatePaymentPlanAdjustment = {
    __typename?: 'AggregatePaymentPlanAdjustment';
    _avg?: Maybe<PaymentPlanAdjustmentAvgAggregate>;
    _count?: Maybe<PaymentPlanAdjustmentCountAggregate>;
    _max?: Maybe<PaymentPlanAdjustmentMaxAggregate>;
    _min?: Maybe<PaymentPlanAdjustmentMinAggregate>;
    _sum?: Maybe<PaymentPlanAdjustmentSumAggregate>;
};

export type AggregatePaymentPlanAdjustmentAuditLog = {
    __typename?: 'AggregatePaymentPlanAdjustmentAuditLog';
    _avg?: Maybe<PaymentPlanAdjustmentAuditLogAvgAggregate>;
    _count?: Maybe<PaymentPlanAdjustmentAuditLogCountAggregate>;
    _max?: Maybe<PaymentPlanAdjustmentAuditLogMaxAggregate>;
    _min?: Maybe<PaymentPlanAdjustmentAuditLogMinAggregate>;
    _sum?: Maybe<PaymentPlanAdjustmentAuditLogSumAggregate>;
};

export type AggregatePaymentPlanAuditLog = {
    __typename?: 'AggregatePaymentPlanAuditLog';
    _avg?: Maybe<PaymentPlanAuditLogAvgAggregate>;
    _count?: Maybe<PaymentPlanAuditLogCountAggregate>;
    _max?: Maybe<PaymentPlanAuditLogMaxAggregate>;
    _min?: Maybe<PaymentPlanAuditLogMinAggregate>;
    _sum?: Maybe<PaymentPlanAuditLogSumAggregate>;
};

export type AggregatePaymentPlanAutoCharge = {
    __typename?: 'AggregatePaymentPlanAutoCharge';
    _avg?: Maybe<PaymentPlanAutoChargeAvgAggregate>;
    _count?: Maybe<PaymentPlanAutoChargeCountAggregate>;
    _max?: Maybe<PaymentPlanAutoChargeMaxAggregate>;
    _min?: Maybe<PaymentPlanAutoChargeMinAggregate>;
    _sum?: Maybe<PaymentPlanAutoChargeSumAggregate>;
};

export type AggregatePaymentPlanAutoChargeAuditLog = {
    __typename?: 'AggregatePaymentPlanAutoChargeAuditLog';
    _avg?: Maybe<PaymentPlanAutoChargeAuditLogAvgAggregate>;
    _count?: Maybe<PaymentPlanAutoChargeAuditLogCountAggregate>;
    _max?: Maybe<PaymentPlanAutoChargeAuditLogMaxAggregate>;
    _min?: Maybe<PaymentPlanAutoChargeAuditLogMinAggregate>;
    _sum?: Maybe<PaymentPlanAutoChargeAuditLogSumAggregate>;
};

export type AggregatePaymentPlanBoughtTreatment = {
    __typename?: 'AggregatePaymentPlanBoughtTreatment';
    _count?: Maybe<PaymentPlanBoughtTreatmentCountAggregate>;
    _max?: Maybe<PaymentPlanBoughtTreatmentMaxAggregate>;
    _min?: Maybe<PaymentPlanBoughtTreatmentMinAggregate>;
};

export type AggregatePaymentPlanBoughtTreatmentAuditLog = {
    __typename?: 'AggregatePaymentPlanBoughtTreatmentAuditLog';
    _avg?: Maybe<PaymentPlanBoughtTreatmentAuditLogAvgAggregate>;
    _count?: Maybe<PaymentPlanBoughtTreatmentAuditLogCountAggregate>;
    _max?: Maybe<PaymentPlanBoughtTreatmentAuditLogMaxAggregate>;
    _min?: Maybe<PaymentPlanBoughtTreatmentAuditLogMinAggregate>;
    _sum?: Maybe<PaymentPlanBoughtTreatmentAuditLogSumAggregate>;
};

export type AggregatePaymentPlanOrgConfig = {
    __typename?: 'AggregatePaymentPlanOrgConfig';
    _avg?: Maybe<PaymentPlanOrgConfigAvgAggregate>;
    _count?: Maybe<PaymentPlanOrgConfigCountAggregate>;
    _max?: Maybe<PaymentPlanOrgConfigMaxAggregate>;
    _min?: Maybe<PaymentPlanOrgConfigMinAggregate>;
    _sum?: Maybe<PaymentPlanOrgConfigSumAggregate>;
};

export type AggregatePaymentPlanOrgConfigAuditLog = {
    __typename?: 'AggregatePaymentPlanOrgConfigAuditLog';
    _avg?: Maybe<PaymentPlanOrgConfigAuditLogAvgAggregate>;
    _count?: Maybe<PaymentPlanOrgConfigAuditLogCountAggregate>;
    _max?: Maybe<PaymentPlanOrgConfigAuditLogMaxAggregate>;
    _min?: Maybe<PaymentPlanOrgConfigAuditLogMinAggregate>;
    _sum?: Maybe<PaymentPlanOrgConfigAuditLogSumAggregate>;
};

export type AggregatePayout = {
    __typename?: 'AggregatePayout';
    _avg?: Maybe<PayoutAvgAggregate>;
    _count?: Maybe<PayoutCountAggregate>;
    _max?: Maybe<PayoutMaxAggregate>;
    _min?: Maybe<PayoutMinAggregate>;
    _sum?: Maybe<PayoutSumAggregate>;
};

export type AggregatePayoutAuditLog = {
    __typename?: 'AggregatePayoutAuditLog';
    _avg?: Maybe<PayoutAuditLogAvgAggregate>;
    _count?: Maybe<PayoutAuditLogCountAggregate>;
    _max?: Maybe<PayoutAuditLogMaxAggregate>;
    _min?: Maybe<PayoutAuditLogMinAggregate>;
    _sum?: Maybe<PayoutAuditLogSumAggregate>;
};

export type AggregatePendingVoidPayoutReversal = {
    __typename?: 'AggregatePendingVoidPayoutReversal';
    _avg?: Maybe<PendingVoidPayoutReversalAvgAggregate>;
    _count?: Maybe<PendingVoidPayoutReversalCountAggregate>;
    _max?: Maybe<PendingVoidPayoutReversalMaxAggregate>;
    _min?: Maybe<PendingVoidPayoutReversalMinAggregate>;
    _sum?: Maybe<PendingVoidPayoutReversalSumAggregate>;
};

export type AggregatePhoneNumberType = {
    __typename?: 'AggregatePhoneNumberType';
    _count?: Maybe<PhoneNumberTypeCountAggregate>;
    _max?: Maybe<PhoneNumberTypeMaxAggregate>;
    _min?: Maybe<PhoneNumberTypeMinAggregate>;
};

export type AggregatePlaceOfServiceCode = {
    __typename?: 'AggregatePlaceOfServiceCode';
    _count?: Maybe<PlaceOfServiceCodeCountAggregate>;
    _max?: Maybe<PlaceOfServiceCodeMaxAggregate>;
    _min?: Maybe<PlaceOfServiceCodeMinAggregate>;
};

export type AggregatePractice = {
    __typename?: 'AggregatePractice';
    _avg?: Maybe<PracticeAvgAggregate>;
    _count?: Maybe<PracticeCountAggregate>;
    _max?: Maybe<PracticeMaxAggregate>;
    _min?: Maybe<PracticeMinAggregate>;
    _sum?: Maybe<PracticeSumAggregate>;
};

export type AggregatePracticeConfiguration = {
    __typename?: 'AggregatePracticeConfiguration';
    _avg?: Maybe<PracticeConfigurationAvgAggregate>;
    _count?: Maybe<PracticeConfigurationCountAggregate>;
    _max?: Maybe<PracticeConfigurationMaxAggregate>;
    _min?: Maybe<PracticeConfigurationMinAggregate>;
    _sum?: Maybe<PracticeConfigurationSumAggregate>;
};

export type AggregatePracticeHours = {
    __typename?: 'AggregatePracticeHours';
    _avg?: Maybe<PracticeHoursAvgAggregate>;
    _count?: Maybe<PracticeHoursCountAggregate>;
    _max?: Maybe<PracticeHoursMaxAggregate>;
    _min?: Maybe<PracticeHoursMinAggregate>;
    _sum?: Maybe<PracticeHoursSumAggregate>;
};

export type AggregatePracticeHoursOverrides = {
    __typename?: 'AggregatePracticeHoursOverrides';
    _avg?: Maybe<PracticeHoursOverridesAvgAggregate>;
    _count?: Maybe<PracticeHoursOverridesCountAggregate>;
    _max?: Maybe<PracticeHoursOverridesMaxAggregate>;
    _min?: Maybe<PracticeHoursOverridesMinAggregate>;
    _sum?: Maybe<PracticeHoursOverridesSumAggregate>;
};

export type AggregatePricedTreatment = {
    __typename?: 'AggregatePricedTreatment';
    _avg?: Maybe<PricedTreatmentAvgAggregate>;
    _count?: Maybe<PricedTreatmentCountAggregate>;
    _max?: Maybe<PricedTreatmentMaxAggregate>;
    _min?: Maybe<PricedTreatmentMinAggregate>;
    _sum?: Maybe<PricedTreatmentSumAggregate>;
};

export type AggregatePricingAttempt = {
    __typename?: 'AggregatePricingAttempt';
    _avg?: Maybe<PricingAttemptAvgAggregate>;
    _count?: Maybe<PricingAttemptCountAggregate>;
    _max?: Maybe<PricingAttemptMaxAggregate>;
    _min?: Maybe<PricingAttemptMinAggregate>;
    _sum?: Maybe<PricingAttemptSumAggregate>;
};

export type AggregatePricingEscalator = {
    __typename?: 'AggregatePricingEscalator';
    _avg?: Maybe<PricingEscalatorAvgAggregate>;
    _count?: Maybe<PricingEscalatorCountAggregate>;
    _max?: Maybe<PricingEscalatorMaxAggregate>;
    _min?: Maybe<PricingEscalatorMinAggregate>;
    _sum?: Maybe<PricingEscalatorSumAggregate>;
};

export type AggregatePricingQueue = {
    __typename?: 'AggregatePricingQueue';
    _avg?: Maybe<PricingQueueAvgAggregate>;
    _count?: Maybe<PricingQueueCountAggregate>;
    _max?: Maybe<PricingQueueMaxAggregate>;
    _min?: Maybe<PricingQueueMinAggregate>;
    _sum?: Maybe<PricingQueueSumAggregate>;
};

export type AggregatePricingResults = {
    __typename?: 'AggregatePricingResults';
    _avg?: Maybe<PricingResultsAvgAggregate>;
    _count?: Maybe<PricingResultsCountAggregate>;
    _max?: Maybe<PricingResultsMaxAggregate>;
    _min?: Maybe<PricingResultsMinAggregate>;
    _sum?: Maybe<PricingResultsSumAggregate>;
};

export type AggregateProcedureBenefitParsingRules = {
    __typename?: 'AggregateProcedureBenefitParsingRules';
    _avg?: Maybe<ProcedureBenefitParsingRulesAvgAggregate>;
    _count?: Maybe<ProcedureBenefitParsingRulesCountAggregate>;
    _max?: Maybe<ProcedureBenefitParsingRulesMaxAggregate>;
    _min?: Maybe<ProcedureBenefitParsingRulesMinAggregate>;
    _sum?: Maybe<ProcedureBenefitParsingRulesSumAggregate>;
};

export type AggregateProductCategories = {
    __typename?: 'AggregateProductCategories';
    _avg?: Maybe<ProductCategoriesAvgAggregate>;
    _count?: Maybe<ProductCategoriesCountAggregate>;
    _max?: Maybe<ProductCategoriesMaxAggregate>;
    _min?: Maybe<ProductCategoriesMinAggregate>;
    _sum?: Maybe<ProductCategoriesSumAggregate>;
};

export type AggregateProductCategoryTranslation = {
    __typename?: 'AggregateProductCategoryTranslation';
    _avg?: Maybe<ProductCategoryTranslationAvgAggregate>;
    _count?: Maybe<ProductCategoryTranslationCountAggregate>;
    _max?: Maybe<ProductCategoryTranslationMaxAggregate>;
    _min?: Maybe<ProductCategoryTranslationMinAggregate>;
    _sum?: Maybe<ProductCategoryTranslationSumAggregate>;
};

export type AggregateProductToBundle = {
    __typename?: 'AggregateProductToBundle';
    _avg?: Maybe<ProductToBundleAvgAggregate>;
    _count?: Maybe<ProductToBundleCountAggregate>;
    _max?: Maybe<ProductToBundleMaxAggregate>;
    _min?: Maybe<ProductToBundleMinAggregate>;
    _sum?: Maybe<ProductToBundleSumAggregate>;
};

export type AggregateProductToHrt = {
    __typename?: 'AggregateProductToHrt';
    _avg?: Maybe<ProductToHrtAvgAggregate>;
    _count?: Maybe<ProductToHrtCountAggregate>;
    _max?: Maybe<ProductToHrtMaxAggregate>;
    _min?: Maybe<ProductToHrtMinAggregate>;
    _sum?: Maybe<ProductToHrtSumAggregate>;
};

export type AggregateProductTranslation = {
    __typename?: 'AggregateProductTranslation';
    _avg?: Maybe<ProductTranslationAvgAggregate>;
    _count?: Maybe<ProductTranslationCountAggregate>;
    _max?: Maybe<ProductTranslationMaxAggregate>;
    _min?: Maybe<ProductTranslationMinAggregate>;
    _sum?: Maybe<ProductTranslationSumAggregate>;
};

export type AggregateProducts = {
    __typename?: 'AggregateProducts';
    _avg?: Maybe<ProductsAvgAggregate>;
    _count?: Maybe<ProductsCountAggregate>;
    _max?: Maybe<ProductsMaxAggregate>;
    _min?: Maybe<ProductsMinAggregate>;
    _sum?: Maybe<ProductsSumAggregate>;
};

export type AggregateProvider = {
    __typename?: 'AggregateProvider';
    _avg?: Maybe<ProviderAvgAggregate>;
    _count?: Maybe<ProviderCountAggregate>;
    _max?: Maybe<ProviderMaxAggregate>;
    _min?: Maybe<ProviderMinAggregate>;
    _sum?: Maybe<ProviderSumAggregate>;
};

export type AggregateProviderCredentialing = {
    __typename?: 'AggregateProviderCredentialing';
    _count?: Maybe<ProviderCredentialingCountAggregate>;
    _max?: Maybe<ProviderCredentialingMaxAggregate>;
    _min?: Maybe<ProviderCredentialingMinAggregate>;
};

export type AggregateProviderGroup = {
    __typename?: 'AggregateProviderGroup';
    _avg?: Maybe<ProviderGroupAvgAggregate>;
    _count?: Maybe<ProviderGroupCountAggregate>;
    _max?: Maybe<ProviderGroupMaxAggregate>;
    _min?: Maybe<ProviderGroupMinAggregate>;
    _sum?: Maybe<ProviderGroupSumAggregate>;
};

export type AggregateProviderGroupToHrt = {
    __typename?: 'AggregateProviderGroupToHrt';
    _avg?: Maybe<ProviderGroupToHrtAvgAggregate>;
    _count?: Maybe<ProviderGroupToHrtCountAggregate>;
    _max?: Maybe<ProviderGroupToHrtMaxAggregate>;
    _min?: Maybe<ProviderGroupToHrtMinAggregate>;
    _sum?: Maybe<ProviderGroupToHrtSumAggregate>;
};

export type AggregateProviderHrtMaxCount = {
    __typename?: 'AggregateProviderHrtMaxCount';
    _avg?: Maybe<ProviderHrtMaxCountAvgAggregate>;
    _count?: Maybe<ProviderHrtMaxCountCountAggregate>;
    _max?: Maybe<ProviderHrtMaxCountMaxAggregate>;
    _min?: Maybe<ProviderHrtMaxCountMinAggregate>;
    _sum?: Maybe<ProviderHrtMaxCountSumAggregate>;
};

export type AggregateProviderTaxonomy = {
    __typename?: 'AggregateProviderTaxonomy';
    _count?: Maybe<ProviderTaxonomyCountAggregate>;
    _max?: Maybe<ProviderTaxonomyMaxAggregate>;
    _min?: Maybe<ProviderTaxonomyMinAggregate>;
};

export type AggregateProviderToOrg = {
    __typename?: 'AggregateProviderToOrg';
    _avg?: Maybe<ProviderToOrgAvgAggregate>;
    _count?: Maybe<ProviderToOrgCountAggregate>;
    _max?: Maybe<ProviderToOrgMaxAggregate>;
    _min?: Maybe<ProviderToOrgMinAggregate>;
    _sum?: Maybe<ProviderToOrgSumAggregate>;
};

export type AggregateProviderToProviderGroup = {
    __typename?: 'AggregateProviderToProviderGroup';
    _avg?: Maybe<ProviderToProviderGroupAvgAggregate>;
    _count?: Maybe<ProviderToProviderGroupCountAggregate>;
    _max?: Maybe<ProviderToProviderGroupMaxAggregate>;
    _min?: Maybe<ProviderToProviderGroupMinAggregate>;
    _sum?: Maybe<ProviderToProviderGroupSumAggregate>;
};

export type AggregateReattributionDirection = {
    __typename?: 'AggregateReattributionDirection';
    _count?: Maybe<ReattributionDirectionCountAggregate>;
    _max?: Maybe<ReattributionDirectionMaxAggregate>;
    _min?: Maybe<ReattributionDirectionMinAggregate>;
};

export type AggregateReceiptArrangement = {
    __typename?: 'AggregateReceiptArrangement';
    _avg?: Maybe<ReceiptArrangementAvgAggregate>;
    _count?: Maybe<ReceiptArrangementCountAggregate>;
    _max?: Maybe<ReceiptArrangementMaxAggregate>;
    _min?: Maybe<ReceiptArrangementMinAggregate>;
    _sum?: Maybe<ReceiptArrangementSumAggregate>;
};

export type AggregateReservedEhrVisit = {
    __typename?: 'AggregateReservedEhrVisit';
    _avg?: Maybe<ReservedEhrVisitAvgAggregate>;
    _count?: Maybe<ReservedEhrVisitCountAggregate>;
    _max?: Maybe<ReservedEhrVisitMaxAggregate>;
    _min?: Maybe<ReservedEhrVisitMinAggregate>;
    _sum?: Maybe<ReservedEhrVisitSumAggregate>;
};

export type AggregateResetToken = {
    __typename?: 'AggregateResetToken';
    _count?: Maybe<ResetTokenCountAggregate>;
    _max?: Maybe<ResetTokenMaxAggregate>;
    _min?: Maybe<ResetTokenMinAggregate>;
};

export type AggregateSavedIntakeResponse = {
    __typename?: 'AggregateSavedIntakeResponse';
    _avg?: Maybe<SavedIntakeResponseAvgAggregate>;
    _count?: Maybe<SavedIntakeResponseCountAggregate>;
    _max?: Maybe<SavedIntakeResponseMaxAggregate>;
    _min?: Maybe<SavedIntakeResponseMinAggregate>;
    _sum?: Maybe<SavedIntakeResponseSumAggregate>;
};

export type AggregateSchedulingSlotConfig = {
    __typename?: 'AggregateSchedulingSlotConfig';
    _avg?: Maybe<SchedulingSlotConfigAvgAggregate>;
    _count?: Maybe<SchedulingSlotConfigCountAggregate>;
    _max?: Maybe<SchedulingSlotConfigMaxAggregate>;
    _min?: Maybe<SchedulingSlotConfigMinAggregate>;
    _sum?: Maybe<SchedulingSlotConfigSumAggregate>;
};

export type AggregateServiceTypeCode = {
    __typename?: 'AggregateServiceTypeCode';
    _count?: Maybe<ServiceTypeCodeCountAggregate>;
    _max?: Maybe<ServiceTypeCodeMaxAggregate>;
    _min?: Maybe<ServiceTypeCodeMinAggregate>;
};

export type AggregateSlot = {
    __typename?: 'AggregateSlot';
    _avg?: Maybe<SlotAvgAggregate>;
    _count?: Maybe<SlotCountAggregate>;
    _max?: Maybe<SlotMaxAggregate>;
    _min?: Maybe<SlotMinAggregate>;
    _sum?: Maybe<SlotSumAggregate>;
};

export type AggregateSlotAuditLog = {
    __typename?: 'AggregateSlotAuditLog';
    _avg?: Maybe<SlotAuditLogAvgAggregate>;
    _count?: Maybe<SlotAuditLogCountAggregate>;
    _max?: Maybe<SlotAuditLogMaxAggregate>;
    _min?: Maybe<SlotAuditLogMinAggregate>;
    _sum?: Maybe<SlotAuditLogSumAggregate>;
};

export type AggregateSrt = {
    __typename?: 'AggregateSrt';
    _avg?: Maybe<SrtAvgAggregate>;
    _count?: Maybe<SrtCountAggregate>;
    _max?: Maybe<SrtMaxAggregate>;
    _min?: Maybe<SrtMinAggregate>;
    _sum?: Maybe<SrtSumAggregate>;
};

export type AggregateSrtFlags = {
    __typename?: 'AggregateSrtFlags';
    _avg?: Maybe<SrtFlagsAvgAggregate>;
    _count?: Maybe<SrtFlagsCountAggregate>;
    _max?: Maybe<SrtFlagsMaxAggregate>;
    _min?: Maybe<SrtFlagsMinAggregate>;
    _sum?: Maybe<SrtFlagsSumAggregate>;
};

export type AggregateSrtMultiplierRule = {
    __typename?: 'AggregateSrtMultiplierRule';
    _avg?: Maybe<SrtMultiplierRuleAvgAggregate>;
    _count?: Maybe<SrtMultiplierRuleCountAggregate>;
    _max?: Maybe<SrtMultiplierRuleMaxAggregate>;
    _min?: Maybe<SrtMultiplierRuleMinAggregate>;
    _sum?: Maybe<SrtMultiplierRuleSumAggregate>;
};

export type AggregateSrtToBillingCode = {
    __typename?: 'AggregateSrtToBillingCode';
    _avg?: Maybe<SrtToBillingCodeAvgAggregate>;
    _count?: Maybe<SrtToBillingCodeCountAggregate>;
    _max?: Maybe<SrtToBillingCodeMaxAggregate>;
    _min?: Maybe<SrtToBillingCodeMinAggregate>;
    _sum?: Maybe<SrtToBillingCodeSumAggregate>;
};

export type AggregateStatePayerMapping = {
    __typename?: 'AggregateStatePayerMapping';
    _avg?: Maybe<StatePayerMappingAvgAggregate>;
    _count?: Maybe<StatePayerMappingCountAggregate>;
    _max?: Maybe<StatePayerMappingMaxAggregate>;
    _min?: Maybe<StatePayerMappingMinAggregate>;
    _sum?: Maybe<StatePayerMappingSumAggregate>;
};

export type AggregateSuperscriptFeeLineItem = {
    __typename?: 'AggregateSuperscriptFeeLineItem';
    _avg?: Maybe<SuperscriptFeeLineItemAvgAggregate>;
    _count?: Maybe<SuperscriptFeeLineItemCountAggregate>;
    _max?: Maybe<SuperscriptFeeLineItemMaxAggregate>;
    _min?: Maybe<SuperscriptFeeLineItemMinAggregate>;
    _sum?: Maybe<SuperscriptFeeLineItemSumAggregate>;
};

export type AggregateSuperscriptFees = {
    __typename?: 'AggregateSuperscriptFees';
    _avg?: Maybe<SuperscriptFeesAvgAggregate>;
    _count?: Maybe<SuperscriptFeesCountAggregate>;
    _max?: Maybe<SuperscriptFeesMaxAggregate>;
    _min?: Maybe<SuperscriptFeesMinAggregate>;
    _sum?: Maybe<SuperscriptFeesSumAggregate>;
};

export type AggregateSuperscriptIntakeQuestion = {
    __typename?: 'AggregateSuperscriptIntakeQuestion';
    _avg?: Maybe<SuperscriptIntakeQuestionAvgAggregate>;
    _count?: Maybe<SuperscriptIntakeQuestionCountAggregate>;
    _max?: Maybe<SuperscriptIntakeQuestionMaxAggregate>;
    _min?: Maybe<SuperscriptIntakeQuestionMinAggregate>;
    _sum?: Maybe<SuperscriptIntakeQuestionSumAggregate>;
};

export type AggregateTimeBlock = {
    __typename?: 'AggregateTimeBlock';
    _avg?: Maybe<TimeBlockAvgAggregate>;
    _count?: Maybe<TimeBlockCountAggregate>;
    _max?: Maybe<TimeBlockMaxAggregate>;
    _min?: Maybe<TimeBlockMinAggregate>;
    _sum?: Maybe<TimeBlockSumAggregate>;
};

export type AggregateTransaction = {
    __typename?: 'AggregateTransaction';
    _avg?: Maybe<TransactionAvgAggregate>;
    _count?: Maybe<TransactionCountAggregate>;
    _max?: Maybe<TransactionMaxAggregate>;
    _min?: Maybe<TransactionMinAggregate>;
    _sum?: Maybe<TransactionSumAggregate>;
};

export type AggregateUser = {
    __typename?: 'AggregateUser';
    _avg?: Maybe<UserAvgAggregate>;
    _count?: Maybe<UserCountAggregate>;
    _max?: Maybe<UserMaxAggregate>;
    _min?: Maybe<UserMinAggregate>;
    _sum?: Maybe<UserSumAggregate>;
};

export type AggregateUserAuditLog = {
    __typename?: 'AggregateUserAuditLog';
    _avg?: Maybe<UserAuditLogAvgAggregate>;
    _count?: Maybe<UserAuditLogCountAggregate>;
    _max?: Maybe<UserAuditLogMaxAggregate>;
    _min?: Maybe<UserAuditLogMinAggregate>;
    _sum?: Maybe<UserAuditLogSumAggregate>;
};

export type AggregateUserPracticeVisit = {
    __typename?: 'AggregateUserPracticeVisit';
    _avg?: Maybe<UserPracticeVisitAvgAggregate>;
    _count?: Maybe<UserPracticeVisitCountAggregate>;
    _max?: Maybe<UserPracticeVisitMaxAggregate>;
    _min?: Maybe<UserPracticeVisitMinAggregate>;
    _sum?: Maybe<UserPracticeVisitSumAggregate>;
};

export type AggregateUserToNewUser = {
    __typename?: 'AggregateUserToNewUser';
    _count?: Maybe<UserToNewUserCountAggregate>;
    _max?: Maybe<UserToNewUserMaxAggregate>;
    _min?: Maybe<UserToNewUserMinAggregate>;
};

export type AggregateValidPayers = {
    __typename?: 'AggregateValidPayers';
    _avg?: Maybe<ValidPayersAvgAggregate>;
    _count?: Maybe<ValidPayersCountAggregate>;
    _max?: Maybe<ValidPayersMaxAggregate>;
    _min?: Maybe<ValidPayersMinAggregate>;
    _sum?: Maybe<ValidPayersSumAggregate>;
};

export enum AmountType {
    FlatFee = 'FLAT_FEE',
    Other = 'OTHER',
    Percentage = 'PERCENTAGE',
}

export type Appointment = {
    __typename?: 'Appointment';
    _count?: Maybe<AppointmentCount>;
    additionalProviderCount?: Maybe<Scalars['Int']['output']>;
    arrivalStatusChangedBy?: Maybe<Scalars['String']['output']>;
    arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInBy?: Maybe<Scalars['String']['output']>;
    claimLifecycle?: Maybe<Scalars['String']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds: Array<Scalars['Int']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    intakeBypassed: Scalars['Boolean']['output'];
    intakeFormIds: Array<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    providerDisplayName?: Maybe<Scalars['String']['output']>;
    sendToBalanceNotes?: Maybe<Scalars['String']['output']>;
    slots: Array<Slot>;
    status: AppointmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AppointmentSlotsArgs = {
    cursor?: InputMaybe<SlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotWhereInput>;
};

export type AppointmentAuditLog = {
    __typename?: 'AppointmentAuditLog';
    appointmentId: Scalars['String']['output'];
    arrivalStatusChangedBy?: Maybe<Scalars['String']['output']>;
    arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInBy?: Maybe<Scalars['String']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds: Array<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    intakeBypassed: Scalars['Boolean']['output'];
    intakeFormIds: Array<Scalars['Int']['output']>;
    lastUpdatedAt: Scalars['DateTimeISO']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    status: AppointmentStatusEnum;
};

export type AppointmentAuditLogAvgAggregate = {
    __typename?: 'AppointmentAuditLogAvgAggregate';
    completedIntakeFormIds?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    intakeFormIds?: Maybe<Scalars['Float']['output']>;
};

export type AppointmentAuditLogAvgOrderByAggregateInput = {
    completedIntakeFormIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
};

export type AppointmentAuditLogCountAggregate = {
    __typename?: 'AppointmentAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    arrivalStatusChangedBy: Scalars['Int']['output'];
    arrivedAt: Scalars['Int']['output'];
    checkedInAt: Scalars['Int']['output'];
    checkedInBy: Scalars['Int']['output'];
    claimReturnStatus: Scalars['Int']['output'];
    completedIntakeFormIds: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    intakeBypassed: Scalars['Int']['output'];
    intakeFormIds: Scalars['Int']['output'];
    lastUpdatedAt: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
};

export type AppointmentAuditLogCountOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    arrivalStatusChangedBy?: InputMaybe<SortOrder>;
    arrivedAt?: InputMaybe<SortOrder>;
    checkedInAt?: InputMaybe<SortOrder>;
    checkedInBy?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    completedIntakeFormIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeBypassed?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type AppointmentAuditLogCreateInput = {
    appointmentId: Scalars['String']['input'];
    arrivalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
    arrivedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    checkedInAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    checkedInBy?: InputMaybe<Scalars['String']['input']>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds?: InputMaybe<AppointmentAuditLogCreatecompletedIntakeFormIdsInput>;
    intakeBypassed?: InputMaybe<Scalars['Boolean']['input']>;
    intakeFormIds?: InputMaybe<AppointmentAuditLogCreateintakeFormIdsInput>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    status: AppointmentStatusEnum;
};

export type AppointmentAuditLogCreateManyInput = {
    appointmentId: Scalars['String']['input'];
    arrivalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
    arrivedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    checkedInAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    checkedInBy?: InputMaybe<Scalars['String']['input']>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds?: InputMaybe<AppointmentAuditLogCreatecompletedIntakeFormIdsInput>;
    id?: InputMaybe<Scalars['Int']['input']>;
    intakeBypassed?: InputMaybe<Scalars['Boolean']['input']>;
    intakeFormIds?: InputMaybe<AppointmentAuditLogCreateintakeFormIdsInput>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    status: AppointmentStatusEnum;
};

export type AppointmentAuditLogCreatecompletedIntakeFormIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type AppointmentAuditLogCreateintakeFormIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type AppointmentAuditLogGroupBy = {
    __typename?: 'AppointmentAuditLogGroupBy';
    _avg?: Maybe<AppointmentAuditLogAvgAggregate>;
    _count?: Maybe<AppointmentAuditLogCountAggregate>;
    _max?: Maybe<AppointmentAuditLogMaxAggregate>;
    _min?: Maybe<AppointmentAuditLogMinAggregate>;
    _sum?: Maybe<AppointmentAuditLogSumAggregate>;
    appointmentId: Scalars['String']['output'];
    arrivalStatusChangedBy?: Maybe<Scalars['String']['output']>;
    arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInBy?: Maybe<Scalars['String']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    id: Scalars['Int']['output'];
    intakeBypassed: Scalars['Boolean']['output'];
    intakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    lastUpdatedAt: Scalars['DateTimeISO']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    status: AppointmentStatusEnum;
};

export type AppointmentAuditLogMaxAggregate = {
    __typename?: 'AppointmentAuditLogMaxAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    arrivalStatusChangedBy?: Maybe<Scalars['String']['output']>;
    arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInBy?: Maybe<Scalars['String']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    id?: Maybe<Scalars['Int']['output']>;
    intakeBypassed?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    status?: Maybe<AppointmentStatusEnum>;
};

export type AppointmentAuditLogMaxOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    arrivalStatusChangedBy?: InputMaybe<SortOrder>;
    arrivedAt?: InputMaybe<SortOrder>;
    checkedInAt?: InputMaybe<SortOrder>;
    checkedInBy?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeBypassed?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type AppointmentAuditLogMinAggregate = {
    __typename?: 'AppointmentAuditLogMinAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    arrivalStatusChangedBy?: Maybe<Scalars['String']['output']>;
    arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInBy?: Maybe<Scalars['String']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    id?: Maybe<Scalars['Int']['output']>;
    intakeBypassed?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    status?: Maybe<AppointmentStatusEnum>;
};

export type AppointmentAuditLogMinOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    arrivalStatusChangedBy?: InputMaybe<SortOrder>;
    arrivedAt?: InputMaybe<SortOrder>;
    checkedInAt?: InputMaybe<SortOrder>;
    checkedInBy?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeBypassed?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type AppointmentAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<AppointmentAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<AppointmentAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<AppointmentAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<AppointmentAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<AppointmentAuditLogSumOrderByAggregateInput>;
    appointmentId?: InputMaybe<SortOrder>;
    arrivalStatusChangedBy?: InputMaybe<SortOrderInput>;
    arrivedAt?: InputMaybe<SortOrderInput>;
    checkedInAt?: InputMaybe<SortOrderInput>;
    checkedInBy?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    completedIntakeFormIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeBypassed?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type AppointmentAuditLogOrderByWithRelationInput = {
    appointmentId?: InputMaybe<SortOrder>;
    arrivalStatusChangedBy?: InputMaybe<SortOrderInput>;
    arrivedAt?: InputMaybe<SortOrderInput>;
    checkedInAt?: InputMaybe<SortOrderInput>;
    checkedInBy?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    completedIntakeFormIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeBypassed?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export enum AppointmentAuditLogScalarFieldEnum {
    AppointmentId = 'appointmentId',
    ArrivalStatusChangedBy = 'arrivalStatusChangedBy',
    ArrivedAt = 'arrivedAt',
    CheckedInAt = 'checkedInAt',
    CheckedInBy = 'checkedInBy',
    ClaimReturnStatus = 'claimReturnStatus',
    CompletedIntakeFormIds = 'completedIntakeFormIds',
    Id = 'id',
    IntakeBypassed = 'intakeBypassed',
    IntakeFormIds = 'intakeFormIds',
    LastUpdatedAt = 'lastUpdatedAt',
    LastUpdatedBy = 'lastUpdatedBy',
    Operation = 'operation',
    Status = 'status',
}

export type AppointmentAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AppointmentAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AppointmentAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AppointmentAuditLogScalarWhereWithAggregatesInput>>;
    appointmentId?: InputMaybe<UuidWithAggregatesFilter>;
    arrivalStatusChangedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    arrivedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    checkedInAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    checkedInBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableWithAggregatesFilter>;
    completedIntakeFormIds?: InputMaybe<IntNullableListFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    intakeBypassed?: InputMaybe<BoolWithAggregatesFilter>;
    intakeFormIds?: InputMaybe<IntNullableListFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    status?: InputMaybe<EnumAppointmentStatusEnumWithAggregatesFilter>;
};

export type AppointmentAuditLogSumAggregate = {
    __typename?: 'AppointmentAuditLogSumAggregate';
    completedIntakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    id?: Maybe<Scalars['Int']['output']>;
    intakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type AppointmentAuditLogSumOrderByAggregateInput = {
    completedIntakeFormIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
};

export type AppointmentAuditLogUpdateInput = {
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    arrivalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    arrivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    checkedInAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    checkedInBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    completedIntakeFormIds?: InputMaybe<AppointmentAuditLogUpdatecompletedIntakeFormIdsInput>;
    intakeBypassed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    intakeFormIds?: InputMaybe<AppointmentAuditLogUpdateintakeFormIdsInput>;
    lastUpdatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumAppointmentStatusEnumFieldUpdateOperationsInput>;
};

export type AppointmentAuditLogUpdateManyMutationInput = {
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    arrivalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    arrivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    checkedInAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    checkedInBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    completedIntakeFormIds?: InputMaybe<AppointmentAuditLogUpdatecompletedIntakeFormIdsInput>;
    intakeBypassed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    intakeFormIds?: InputMaybe<AppointmentAuditLogUpdateintakeFormIdsInput>;
    lastUpdatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumAppointmentStatusEnumFieldUpdateOperationsInput>;
};

export type AppointmentAuditLogUpdatecompletedIntakeFormIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AppointmentAuditLogUpdateintakeFormIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AppointmentAuditLogWhereInput = {
    AND?: InputMaybe<Array<AppointmentAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<AppointmentAuditLogWhereInput>>;
    OR?: InputMaybe<Array<AppointmentAuditLogWhereInput>>;
    appointmentId?: InputMaybe<UuidFilter>;
    arrivalStatusChangedBy?: InputMaybe<StringNullableFilter>;
    arrivedAt?: InputMaybe<DateTimeNullableFilter>;
    checkedInAt?: InputMaybe<DateTimeNullableFilter>;
    checkedInBy?: InputMaybe<StringNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    completedIntakeFormIds?: InputMaybe<IntNullableListFilter>;
    id?: InputMaybe<IntFilter>;
    intakeBypassed?: InputMaybe<BoolFilter>;
    intakeFormIds?: InputMaybe<IntNullableListFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    status?: InputMaybe<EnumAppointmentStatusEnumFilter>;
};

export type AppointmentAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<AppointmentAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<AppointmentAuditLogWhereInput>>;
    OR?: InputMaybe<Array<AppointmentAuditLogWhereInput>>;
    appointmentId?: InputMaybe<UuidFilter>;
    arrivalStatusChangedBy?: InputMaybe<StringNullableFilter>;
    arrivedAt?: InputMaybe<DateTimeNullableFilter>;
    checkedInAt?: InputMaybe<DateTimeNullableFilter>;
    checkedInBy?: InputMaybe<StringNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    completedIntakeFormIds?: InputMaybe<IntNullableListFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    intakeBypassed?: InputMaybe<BoolFilter>;
    intakeFormIds?: InputMaybe<IntNullableListFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    status?: InputMaybe<EnumAppointmentStatusEnumFilter>;
};

export type AppointmentAvgAggregate = {
    __typename?: 'AppointmentAvgAggregate';
    completedIntakeFormIds?: Maybe<Scalars['Float']['output']>;
    intakeFormIds?: Maybe<Scalars['Float']['output']>;
};

export type AppointmentAvgOrderByAggregateInput = {
    completedIntakeFormIds?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
};

export type AppointmentCount = {
    __typename?: 'AppointmentCount';
    slots: Scalars['Int']['output'];
};

export type AppointmentCountSlotsArgs = {
    where?: InputMaybe<SlotWhereInput>;
};

export type AppointmentCountAggregate = {
    __typename?: 'AppointmentCountAggregate';
    _all: Scalars['Int']['output'];
    arrivalStatusChangedBy: Scalars['Int']['output'];
    arrivedAt: Scalars['Int']['output'];
    checkedInAt: Scalars['Int']['output'];
    checkedInBy: Scalars['Int']['output'];
    claimReturnStatus: Scalars['Int']['output'];
    completedIntakeFormIds: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    intakeBypassed: Scalars['Int']['output'];
    intakeFormIds: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    sendToBalanceNotes: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type AppointmentCountOrderByAggregateInput = {
    arrivalStatusChangedBy?: InputMaybe<SortOrder>;
    arrivedAt?: InputMaybe<SortOrder>;
    checkedInAt?: InputMaybe<SortOrder>;
    checkedInBy?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    completedIntakeFormIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeBypassed?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    sendToBalanceNotes?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AppointmentCreateInput = {
    arrivalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
    arrivedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    checkedInAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    checkedInBy?: InputMaybe<Scalars['String']['input']>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds?: InputMaybe<AppointmentCreatecompletedIntakeFormIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    intakeBypassed?: InputMaybe<Scalars['Boolean']['input']>;
    intakeFormIds?: InputMaybe<AppointmentCreateintakeFormIdsInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    sendToBalanceNotes?: InputMaybe<Scalars['String']['input']>;
    slots?: InputMaybe<SlotCreateNestedManyWithoutAppointmentInput>;
    status: AppointmentStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AppointmentCreateManyInput = {
    arrivalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
    arrivedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    checkedInAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    checkedInBy?: InputMaybe<Scalars['String']['input']>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds?: InputMaybe<AppointmentCreatecompletedIntakeFormIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    intakeBypassed?: InputMaybe<Scalars['Boolean']['input']>;
    intakeFormIds?: InputMaybe<AppointmentCreateintakeFormIdsInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    sendToBalanceNotes?: InputMaybe<Scalars['String']['input']>;
    status: AppointmentStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AppointmentCreateNestedOneWithoutSlotsInput = {
    connect?: InputMaybe<AppointmentWhereUniqueInput>;
    connectOrCreate?: InputMaybe<AppointmentCreateOrConnectWithoutSlotsInput>;
    create?: InputMaybe<AppointmentCreateWithoutSlotsInput>;
};

export type AppointmentCreateOrConnectWithoutSlotsInput = {
    create: AppointmentCreateWithoutSlotsInput;
    where: AppointmentWhereUniqueInput;
};

export type AppointmentCreateWithoutSlotsInput = {
    arrivalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
    arrivedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    checkedInAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    checkedInBy?: InputMaybe<Scalars['String']['input']>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds?: InputMaybe<AppointmentCreatecompletedIntakeFormIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    intakeBypassed?: InputMaybe<Scalars['Boolean']['input']>;
    intakeFormIds?: InputMaybe<AppointmentCreateintakeFormIdsInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    sendToBalanceNotes?: InputMaybe<Scalars['String']['input']>;
    status: AppointmentStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AppointmentCreatecompletedIntakeFormIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type AppointmentCreateintakeFormIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type AppointmentGroupBy = {
    __typename?: 'AppointmentGroupBy';
    _avg?: Maybe<AppointmentAvgAggregate>;
    _count?: Maybe<AppointmentCountAggregate>;
    _max?: Maybe<AppointmentMaxAggregate>;
    _min?: Maybe<AppointmentMinAggregate>;
    _sum?: Maybe<AppointmentSumAggregate>;
    arrivalStatusChangedBy?: Maybe<Scalars['String']['output']>;
    arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInBy?: Maybe<Scalars['String']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    intakeBypassed: Scalars['Boolean']['output'];
    intakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    sendToBalanceNotes?: Maybe<Scalars['String']['output']>;
    status: AppointmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AppointmentMaxAggregate = {
    __typename?: 'AppointmentMaxAggregate';
    arrivalStatusChangedBy?: Maybe<Scalars['String']['output']>;
    arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInBy?: Maybe<Scalars['String']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    intakeBypassed?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    sendToBalanceNotes?: Maybe<Scalars['String']['output']>;
    status?: Maybe<AppointmentStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AppointmentMaxOrderByAggregateInput = {
    arrivalStatusChangedBy?: InputMaybe<SortOrder>;
    arrivedAt?: InputMaybe<SortOrder>;
    checkedInAt?: InputMaybe<SortOrder>;
    checkedInBy?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeBypassed?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    sendToBalanceNotes?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AppointmentMinAggregate = {
    __typename?: 'AppointmentMinAggregate';
    arrivalStatusChangedBy?: Maybe<Scalars['String']['output']>;
    arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInBy?: Maybe<Scalars['String']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    intakeBypassed?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    sendToBalanceNotes?: Maybe<Scalars['String']['output']>;
    status?: Maybe<AppointmentStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AppointmentMinOrderByAggregateInput = {
    arrivalStatusChangedBy?: InputMaybe<SortOrder>;
    arrivedAt?: InputMaybe<SortOrder>;
    checkedInAt?: InputMaybe<SortOrder>;
    checkedInBy?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeBypassed?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    sendToBalanceNotes?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AppointmentNullableRelationFilter = {
    is?: InputMaybe<AppointmentWhereInput>;
    isNot?: InputMaybe<AppointmentWhereInput>;
};

export type AppointmentOrderByWithAggregationInput = {
    _avg?: InputMaybe<AppointmentAvgOrderByAggregateInput>;
    _count?: InputMaybe<AppointmentCountOrderByAggregateInput>;
    _max?: InputMaybe<AppointmentMaxOrderByAggregateInput>;
    _min?: InputMaybe<AppointmentMinOrderByAggregateInput>;
    _sum?: InputMaybe<AppointmentSumOrderByAggregateInput>;
    arrivalStatusChangedBy?: InputMaybe<SortOrderInput>;
    arrivedAt?: InputMaybe<SortOrderInput>;
    checkedInAt?: InputMaybe<SortOrderInput>;
    checkedInBy?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    completedIntakeFormIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeBypassed?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    sendToBalanceNotes?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AppointmentOrderByWithRelationInput = {
    arrivalStatusChangedBy?: InputMaybe<SortOrderInput>;
    arrivedAt?: InputMaybe<SortOrderInput>;
    checkedInAt?: InputMaybe<SortOrderInput>;
    checkedInBy?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    completedIntakeFormIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeBypassed?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    sendToBalanceNotes?: InputMaybe<SortOrderInput>;
    slots?: InputMaybe<SlotOrderByRelationAggregateInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum AppointmentScalarFieldEnum {
    ArrivalStatusChangedBy = 'arrivalStatusChangedBy',
    ArrivedAt = 'arrivedAt',
    CheckedInAt = 'checkedInAt',
    CheckedInBy = 'checkedInBy',
    ClaimReturnStatus = 'claimReturnStatus',
    CompletedIntakeFormIds = 'completedIntakeFormIds',
    CreatedAt = 'createdAt',
    Id = 'id',
    IntakeBypassed = 'intakeBypassed',
    IntakeFormIds = 'intakeFormIds',
    LastUpdatedBy = 'lastUpdatedBy',
    SendToBalanceNotes = 'sendToBalanceNotes',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type AppointmentScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AppointmentScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AppointmentScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AppointmentScalarWhereWithAggregatesInput>>;
    arrivalStatusChangedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    arrivedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    checkedInAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    checkedInBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableWithAggregatesFilter>;
    completedIntakeFormIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    intakeBypassed?: InputMaybe<BoolWithAggregatesFilter>;
    intakeFormIds?: InputMaybe<IntNullableListFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    sendToBalanceNotes?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumAppointmentStatusEnumWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum AppointmentStatusEnum {
    Active = 'active',
    Canceled = 'canceled',
    Completed = 'completed',
    Deleted = 'deleted',
    Missed = 'missed',
    Upcoming = 'upcoming',
}

export type AppointmentSumAggregate = {
    __typename?: 'AppointmentSumAggregate';
    completedIntakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    intakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type AppointmentSumOrderByAggregateInput = {
    completedIntakeFormIds?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
};

export type AppointmentUpdateInput = {
    arrivalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    arrivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    checkedInAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    checkedInBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    completedIntakeFormIds?: InputMaybe<AppointmentUpdatecompletedIntakeFormIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    intakeBypassed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    intakeFormIds?: InputMaybe<AppointmentUpdateintakeFormIdsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sendToBalanceNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slots?: InputMaybe<SlotUpdateManyWithoutAppointmentNestedInput>;
    status?: InputMaybe<EnumAppointmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AppointmentUpdateManyMutationInput = {
    arrivalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    arrivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    checkedInAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    checkedInBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    completedIntakeFormIds?: InputMaybe<AppointmentUpdatecompletedIntakeFormIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    intakeBypassed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    intakeFormIds?: InputMaybe<AppointmentUpdateintakeFormIdsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sendToBalanceNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumAppointmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AppointmentUpdateOneWithoutSlotsNestedInput = {
    connect?: InputMaybe<AppointmentWhereUniqueInput>;
    connectOrCreate?: InputMaybe<AppointmentCreateOrConnectWithoutSlotsInput>;
    create?: InputMaybe<AppointmentCreateWithoutSlotsInput>;
    delete?: InputMaybe<AppointmentWhereInput>;
    disconnect?: InputMaybe<AppointmentWhereInput>;
    update?: InputMaybe<AppointmentUpdateToOneWithWhereWithoutSlotsInput>;
    upsert?: InputMaybe<AppointmentUpsertWithoutSlotsInput>;
};

export type AppointmentUpdateToOneWithWhereWithoutSlotsInput = {
    data: AppointmentUpdateWithoutSlotsInput;
    where?: InputMaybe<AppointmentWhereInput>;
};

export type AppointmentUpdateWithoutSlotsInput = {
    arrivalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    arrivedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    checkedInAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    checkedInBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    completedIntakeFormIds?: InputMaybe<AppointmentUpdatecompletedIntakeFormIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    intakeBypassed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    intakeFormIds?: InputMaybe<AppointmentUpdateintakeFormIdsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sendToBalanceNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumAppointmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AppointmentUpdatecompletedIntakeFormIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AppointmentUpdateintakeFormIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AppointmentUpsertWithoutSlotsInput = {
    create: AppointmentCreateWithoutSlotsInput;
    update: AppointmentUpdateWithoutSlotsInput;
    where?: InputMaybe<AppointmentWhereInput>;
};

export type AppointmentWhereInput = {
    AND?: InputMaybe<Array<AppointmentWhereInput>>;
    NOT?: InputMaybe<Array<AppointmentWhereInput>>;
    OR?: InputMaybe<Array<AppointmentWhereInput>>;
    arrivalStatusChangedBy?: InputMaybe<StringNullableFilter>;
    arrivedAt?: InputMaybe<DateTimeNullableFilter>;
    checkedInAt?: InputMaybe<DateTimeNullableFilter>;
    checkedInBy?: InputMaybe<StringNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    completedIntakeFormIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    intakeBypassed?: InputMaybe<BoolFilter>;
    intakeFormIds?: InputMaybe<IntNullableListFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    sendToBalanceNotes?: InputMaybe<StringNullableFilter>;
    slots?: InputMaybe<SlotListRelationFilter>;
    status?: InputMaybe<EnumAppointmentStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AppointmentWhereUniqueInput = {
    AND?: InputMaybe<Array<AppointmentWhereInput>>;
    NOT?: InputMaybe<Array<AppointmentWhereInput>>;
    OR?: InputMaybe<Array<AppointmentWhereInput>>;
    arrivalStatusChangedBy?: InputMaybe<StringNullableFilter>;
    arrivedAt?: InputMaybe<DateTimeNullableFilter>;
    checkedInAt?: InputMaybe<DateTimeNullableFilter>;
    checkedInBy?: InputMaybe<StringNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    completedIntakeFormIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    intakeBypassed?: InputMaybe<BoolFilter>;
    intakeFormIds?: InputMaybe<IntNullableListFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    sendToBalanceNotes?: InputMaybe<StringNullableFilter>;
    slots?: InputMaybe<SlotListRelationFilter>;
    status?: InputMaybe<EnumAppointmentStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ArrearBilling = {
    __typename?: 'ArrearBilling';
    amount: Scalars['Decimal']['output'];
    billReason: BillReason;
    date: Scalars['DateTimeISO']['output'];
    encounterId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    invoiceId?: Maybe<Scalars['Int']['output']>;
    orgId: Scalars['Int']['output'];
    slotId?: Maybe<Scalars['String']['output']>;
    status: BillStatus;
    transactionId?: Maybe<Scalars['String']['output']>;
};

export type ArrearBillingAvgAggregate = {
    __typename?: 'ArrearBillingAvgAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    invoiceId?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type ArrearBillingAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type ArrearBillingCountAggregate = {
    __typename?: 'ArrearBillingCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    billReason: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    encounterId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    invoiceId: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    transactionId: Scalars['Int']['output'];
};

export type ArrearBillingCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    billReason?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
};

export type ArrearBillingCreateInput = {
    amount: Scalars['Decimal']['input'];
    billReason: BillReason;
    date: Scalars['DateTimeISO']['input'];
    encounterId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    invoiceId?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    slotId?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<BillStatus>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type ArrearBillingCreateManyInput = {
    amount: Scalars['Decimal']['input'];
    billReason: BillReason;
    date: Scalars['DateTimeISO']['input'];
    encounterId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    invoiceId?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    slotId?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<BillStatus>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type ArrearBillingGroupBy = {
    __typename?: 'ArrearBillingGroupBy';
    _avg?: Maybe<ArrearBillingAvgAggregate>;
    _count?: Maybe<ArrearBillingCountAggregate>;
    _max?: Maybe<ArrearBillingMaxAggregate>;
    _min?: Maybe<ArrearBillingMinAggregate>;
    _sum?: Maybe<ArrearBillingSumAggregate>;
    amount: Scalars['Decimal']['output'];
    billReason: BillReason;
    date: Scalars['DateTimeISO']['output'];
    encounterId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    invoiceId?: Maybe<Scalars['Int']['output']>;
    orgId: Scalars['Int']['output'];
    slotId?: Maybe<Scalars['String']['output']>;
    status: BillStatus;
    transactionId?: Maybe<Scalars['String']['output']>;
};

export type ArrearBillingMaxAggregate = {
    __typename?: 'ArrearBillingMaxAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    billReason?: Maybe<BillReason>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    invoiceId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<BillStatus>;
    transactionId?: Maybe<Scalars['String']['output']>;
};

export type ArrearBillingMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    billReason?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
};

export type ArrearBillingMinAggregate = {
    __typename?: 'ArrearBillingMinAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    billReason?: Maybe<BillReason>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    invoiceId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<BillStatus>;
    transactionId?: Maybe<Scalars['String']['output']>;
};

export type ArrearBillingMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    billReason?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
};

export type ArrearBillingOrderByWithAggregationInput = {
    _avg?: InputMaybe<ArrearBillingAvgOrderByAggregateInput>;
    _count?: InputMaybe<ArrearBillingCountOrderByAggregateInput>;
    _max?: InputMaybe<ArrearBillingMaxOrderByAggregateInput>;
    _min?: InputMaybe<ArrearBillingMinOrderByAggregateInput>;
    _sum?: InputMaybe<ArrearBillingSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrder>;
    billReason?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrderInput>;
};

export type ArrearBillingOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrder>;
    billReason?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrderInput>;
};

export enum ArrearBillingScalarFieldEnum {
    Amount = 'amount',
    BillReason = 'billReason',
    Date = 'date',
    EncounterId = 'encounterId',
    Id = 'id',
    InvoiceId = 'invoiceId',
    OrgId = 'orgId',
    SlotId = 'slotId',
    Status = 'status',
    TransactionId = 'transactionId',
}

export type ArrearBillingScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ArrearBillingScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ArrearBillingScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ArrearBillingScalarWhereWithAggregatesInput>>;
    amount?: InputMaybe<DecimalWithAggregatesFilter>;
    billReason?: InputMaybe<EnumBillReasonWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    encounterId?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    invoiceId?: InputMaybe<IntNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    slotId?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumBillStatusWithAggregatesFilter>;
    transactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ArrearBillingSumAggregate = {
    __typename?: 'ArrearBillingSumAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    invoiceId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type ArrearBillingSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type ArrearBillingUpdateInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    billReason?: InputMaybe<EnumBillReasonFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    invoiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumBillStatusFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArrearBillingUpdateManyMutationInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    billReason?: InputMaybe<EnumBillReasonFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    invoiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumBillStatusFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArrearBillingWhereInput = {
    AND?: InputMaybe<Array<ArrearBillingWhereInput>>;
    NOT?: InputMaybe<Array<ArrearBillingWhereInput>>;
    OR?: InputMaybe<Array<ArrearBillingWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    billReason?: InputMaybe<EnumBillReasonFilter>;
    date?: InputMaybe<DateTimeFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<StringFilter>;
    invoiceId?: InputMaybe<IntNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumBillStatusFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
};

export type ArrearBillingWhereUniqueInput = {
    AND?: InputMaybe<Array<ArrearBillingWhereInput>>;
    NOT?: InputMaybe<Array<ArrearBillingWhereInput>>;
    OR?: InputMaybe<Array<ArrearBillingWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    billReason?: InputMaybe<EnumBillReasonFilter>;
    date?: InputMaybe<DateTimeFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    invoiceId?: InputMaybe<IntNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumBillStatusFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
};

export type ArtClaim = {
    __typename?: 'ArtClaim';
    _count?: Maybe<ArtClaimCount>;
    artNotes: Array<Scalars['String']['output']>;
    claimId: Scalars['String']['output'];
    claimLastUpdated?: Maybe<Scalars['DateTimeISO']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    cptLines: Array<ArtClaimCptLine>;
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfRecentTransfer?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService: Scalars['DateTimeISO']['output'];
    departmentId?: Maybe<Scalars['String']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    firstCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    inboundSourceId?: Maybe<Scalars['String']['output']>;
    lastCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    manualReviewReasons: Array<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes: Array<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance: Scalars['Float']['output'];
    originalPrimaryPayerBalance: Scalars['Float']['output'];
    originalSecondaryPayerBalance: Scalars['Float']['output'];
    patientBalance: Scalars['Float']['output'];
    patientEnterpriseId?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    patientRemarkCodes: Array<Scalars['String']['output']>;
    patientStatus?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerBalance: Scalars['Float']['output'];
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    primaryPayerStatus?: Maybe<Scalars['String']['output']>;
    primaryRemarkCodes: Array<Scalars['String']['output']>;
    procedureCodes: Array<Scalars['String']['output']>;
    reviewNotes?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerBalance: Scalars['Float']['output'];
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    secondaryPayerStatus?: Maybe<Scalars['String']['output']>;
    secondaryRemarkCodes: Array<Scalars['String']['output']>;
    slotIds: Array<Scalars['String']['output']>;
    status?: Maybe<ArtClaimStatusEnum>;
    statusReason?: Maybe<Scalars['String']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
    unscheduledBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    visitId?: Maybe<Scalars['String']['output']>;
};

export type ArtClaimCptLinesArgs = {
    cursor?: InputMaybe<ArtClaimCptLineWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimCptLineScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtClaimCptLineOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineWhereInput>;
};

export type ArtClaimAuditLog = {
    __typename?: 'ArtClaimAuditLog';
    artClaimId?: Maybe<Scalars['String']['output']>;
    artNotes: Array<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimLastUpdated?: Maybe<Scalars['DateTimeISO']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfRecentTransfer?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    departmentId?: Maybe<Scalars['String']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    firstCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    inboundSourceId?: Maybe<Scalars['String']['output']>;
    lastCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    manualReviewReasons: Array<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes: Array<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    patientEnterpriseId?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    patientRemarkCodes: Array<Scalars['String']['output']>;
    patientStatus?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    primaryPayerStatus?: Maybe<Scalars['String']['output']>;
    primaryRemarkCodes: Array<Scalars['String']['output']>;
    procedureCodes: Array<Scalars['String']['output']>;
    reviewNotes?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    secondaryPayerStatus?: Maybe<Scalars['String']['output']>;
    secondaryRemarkCodes: Array<Scalars['String']['output']>;
    slotIds: Array<Scalars['String']['output']>;
    status?: Maybe<ArtClaimStatusEnum>;
    statusReason?: Maybe<Scalars['String']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
    unscheduledBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    visitId?: Maybe<Scalars['String']['output']>;
};

export type ArtClaimAuditLogAvgAggregate = {
    __typename?: 'ArtClaimAuditLogAvgAggregate';
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
};

export type ArtClaimAuditLogAvgOrderByAggregateInput = {
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    ehrPatientBalance?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrder>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrder>;
    totalArtTransferredAmount?: InputMaybe<SortOrder>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrder>;
    totalPostedOffPlatform?: InputMaybe<SortOrder>;
};

export type ArtClaimAuditLogCountAggregate = {
    __typename?: 'ArtClaimAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    artClaimId: Scalars['Int']['output'];
    artNotes: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    claimLastUpdated: Scalars['Int']['output'];
    claimReturnStatus: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    dateOfRecentTransfer: Scalars['Int']['output'];
    dateOfService: Scalars['Int']['output'];
    departmentId: Scalars['Int']['output'];
    ehrCollectionsBalance: Scalars['Int']['output'];
    ehrPatientBalance: Scalars['Int']['output'];
    firstCommunicationDate: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    inboundSourceId: Scalars['Int']['output'];
    lastCommunicationDate: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    manualReviewReasons: Scalars['Int']['output'];
    metadata: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    originalPatientBalance: Scalars['Int']['output'];
    originalPrimaryPayerBalance: Scalars['Int']['output'];
    originalSecondaryPayerBalance: Scalars['Int']['output'];
    patientBalance: Scalars['Int']['output'];
    patientEnterpriseId: Scalars['Int']['output'];
    patientOrgEhrId: Scalars['Int']['output'];
    patientRemarkCodes: Scalars['Int']['output'];
    patientStatus: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    primaryPayer: Scalars['Int']['output'];
    primaryPayerBalance: Scalars['Int']['output'];
    primaryPayerPackage: Scalars['Int']['output'];
    primaryPayerStatus: Scalars['Int']['output'];
    primaryRemarkCodes: Scalars['Int']['output'];
    procedureCodes: Scalars['Int']['output'];
    reviewNotes: Scalars['Int']['output'];
    secondaryPayer: Scalars['Int']['output'];
    secondaryPayerBalance: Scalars['Int']['output'];
    secondaryPayerPackage: Scalars['Int']['output'];
    secondaryPayerStatus: Scalars['Int']['output'];
    secondaryRemarkCodes: Scalars['Int']['output'];
    slotIds: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    statusReason: Scalars['Int']['output'];
    totalAdjudicatedResponsibility: Scalars['Int']['output'];
    totalAdjustedOffPlatform: Scalars['Int']['output'];
    totalArtTransferredAmount: Scalars['Int']['output'];
    totalPostedBySuperscriptAmount: Scalars['Int']['output'];
    totalPostedOffPlatform: Scalars['Int']['output'];
    unscheduledBoughtTreatmentId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    visitId: Scalars['Int']['output'];
};

export type ArtClaimAuditLogCountOrderByAggregateInput = {
    artClaimId?: InputMaybe<SortOrder>;
    artNotes?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimLastUpdated?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfRecentTransfer?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    departmentId?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    ehrPatientBalance?: InputMaybe<SortOrder>;
    firstCommunicationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    inboundSourceId?: InputMaybe<SortOrder>;
    lastCommunicationDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    manualReviewReasons?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    patientEnterpriseId?: InputMaybe<SortOrder>;
    patientOrgEhrId?: InputMaybe<SortOrder>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientStatus?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    primaryPayer?: InputMaybe<SortOrder>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrder>;
    primaryPayerStatus?: InputMaybe<SortOrder>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    reviewNotes?: InputMaybe<SortOrder>;
    secondaryPayer?: InputMaybe<SortOrder>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrder>;
    secondaryPayerStatus?: InputMaybe<SortOrder>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    slotIds?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrder>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrder>;
    totalArtTransferredAmount?: InputMaybe<SortOrder>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrder>;
    totalPostedOffPlatform?: InputMaybe<SortOrder>;
    unscheduledBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrder>;
};

export type ArtClaimAuditLogCreateInput = {
    artClaimId?: InputMaybe<Scalars['String']['input']>;
    artNotes?: InputMaybe<ArtClaimAuditLogCreateartNotesInput>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    claimLastUpdated?: InputMaybe<Scalars['DateTimeISO']['input']>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfRecentTransfer?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService?: InputMaybe<Scalars['DateTimeISO']['input']>;
    departmentId?: InputMaybe<Scalars['String']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    ehrPatientBalance?: InputMaybe<Scalars['Float']['input']>;
    firstCommunicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    inboundSourceId?: InputMaybe<Scalars['String']['input']>;
    lastCommunicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    manualReviewReasons?: InputMaybe<ArtClaimAuditLogCreatemanualReviewReasonsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<ArtClaimAuditLogCreatenotesInput>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    originalPatientBalance?: InputMaybe<Scalars['Float']['input']>;
    originalPrimaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    originalSecondaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    patientBalance?: InputMaybe<Scalars['Float']['input']>;
    patientEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    patientOrgEhrId?: InputMaybe<Scalars['String']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimAuditLogCreatepatientRemarkCodesInput>;
    patientStatus?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    primaryPayer?: InputMaybe<Scalars['String']['input']>;
    primaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    primaryPayerStatus?: InputMaybe<Scalars['String']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimAuditLogCreateprimaryRemarkCodesInput>;
    procedureCodes?: InputMaybe<ArtClaimAuditLogCreateprocedureCodesInput>;
    reviewNotes?: InputMaybe<Scalars['String']['input']>;
    secondaryPayer?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerStatus?: InputMaybe<Scalars['String']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimAuditLogCreatesecondaryRemarkCodesInput>;
    slotIds?: InputMaybe<ArtClaimAuditLogCreateslotIdsInput>;
    status?: InputMaybe<ArtClaimStatusEnum>;
    statusReason?: InputMaybe<Scalars['String']['input']>;
    totalAdjudicatedResponsibility?: InputMaybe<Scalars['Float']['input']>;
    totalAdjustedOffPlatform?: InputMaybe<Scalars['Float']['input']>;
    totalArtTransferredAmount?: InputMaybe<Scalars['Float']['input']>;
    totalPostedBySuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    totalPostedOffPlatform?: InputMaybe<Scalars['Float']['input']>;
    unscheduledBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visitId?: InputMaybe<Scalars['String']['input']>;
};

export type ArtClaimAuditLogCreateManyInput = {
    artClaimId?: InputMaybe<Scalars['String']['input']>;
    artNotes?: InputMaybe<ArtClaimAuditLogCreateartNotesInput>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    claimLastUpdated?: InputMaybe<Scalars['DateTimeISO']['input']>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfRecentTransfer?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService?: InputMaybe<Scalars['DateTimeISO']['input']>;
    departmentId?: InputMaybe<Scalars['String']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    ehrPatientBalance?: InputMaybe<Scalars['Float']['input']>;
    firstCommunicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    inboundSourceId?: InputMaybe<Scalars['String']['input']>;
    lastCommunicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    manualReviewReasons?: InputMaybe<ArtClaimAuditLogCreatemanualReviewReasonsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<ArtClaimAuditLogCreatenotesInput>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    originalPatientBalance?: InputMaybe<Scalars['Float']['input']>;
    originalPrimaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    originalSecondaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    patientBalance?: InputMaybe<Scalars['Float']['input']>;
    patientEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    patientOrgEhrId?: InputMaybe<Scalars['String']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimAuditLogCreatepatientRemarkCodesInput>;
    patientStatus?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    primaryPayer?: InputMaybe<Scalars['String']['input']>;
    primaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    primaryPayerStatus?: InputMaybe<Scalars['String']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimAuditLogCreateprimaryRemarkCodesInput>;
    procedureCodes?: InputMaybe<ArtClaimAuditLogCreateprocedureCodesInput>;
    reviewNotes?: InputMaybe<Scalars['String']['input']>;
    secondaryPayer?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerStatus?: InputMaybe<Scalars['String']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimAuditLogCreatesecondaryRemarkCodesInput>;
    slotIds?: InputMaybe<ArtClaimAuditLogCreateslotIdsInput>;
    status?: InputMaybe<ArtClaimStatusEnum>;
    statusReason?: InputMaybe<Scalars['String']['input']>;
    totalAdjudicatedResponsibility?: InputMaybe<Scalars['Float']['input']>;
    totalAdjustedOffPlatform?: InputMaybe<Scalars['Float']['input']>;
    totalArtTransferredAmount?: InputMaybe<Scalars['Float']['input']>;
    totalPostedBySuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    totalPostedOffPlatform?: InputMaybe<Scalars['Float']['input']>;
    unscheduledBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visitId?: InputMaybe<Scalars['String']['input']>;
};

export type ArtClaimAuditLogCreateartNotesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimAuditLogCreatemanualReviewReasonsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimAuditLogCreatenotesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimAuditLogCreatepatientRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimAuditLogCreateprimaryRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimAuditLogCreateprocedureCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimAuditLogCreatesecondaryRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimAuditLogCreateslotIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimAuditLogGroupBy = {
    __typename?: 'ArtClaimAuditLogGroupBy';
    _avg?: Maybe<ArtClaimAuditLogAvgAggregate>;
    _count?: Maybe<ArtClaimAuditLogCountAggregate>;
    _max?: Maybe<ArtClaimAuditLogMaxAggregate>;
    _min?: Maybe<ArtClaimAuditLogMinAggregate>;
    _sum?: Maybe<ArtClaimAuditLogSumAggregate>;
    artClaimId?: Maybe<Scalars['String']['output']>;
    artNotes?: Maybe<Array<Scalars['String']['output']>>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimLastUpdated?: Maybe<Scalars['DateTimeISO']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfRecentTransfer?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    departmentId?: Maybe<Scalars['String']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    firstCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    inboundSourceId?: Maybe<Scalars['String']['output']>;
    lastCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    manualReviewReasons?: Maybe<Array<Scalars['String']['output']>>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes?: Maybe<Array<Scalars['String']['output']>>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    patientEnterpriseId?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    patientRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    patientStatus?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    primaryPayerStatus?: Maybe<Scalars['String']['output']>;
    primaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    procedureCodes?: Maybe<Array<Scalars['String']['output']>>;
    reviewNotes?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    secondaryPayerStatus?: Maybe<Scalars['String']['output']>;
    secondaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    slotIds?: Maybe<Array<Scalars['String']['output']>>;
    status?: Maybe<ArtClaimStatusEnum>;
    statusReason?: Maybe<Scalars['String']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
    unscheduledBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    visitId?: Maybe<Scalars['String']['output']>;
};

export type ArtClaimAuditLogMaxAggregate = {
    __typename?: 'ArtClaimAuditLogMaxAggregate';
    artClaimId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimLastUpdated?: Maybe<Scalars['DateTimeISO']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfRecentTransfer?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    departmentId?: Maybe<Scalars['String']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    firstCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    inboundSourceId?: Maybe<Scalars['String']['output']>;
    lastCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    patientEnterpriseId?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    patientStatus?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    primaryPayerStatus?: Maybe<Scalars['String']['output']>;
    reviewNotes?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    secondaryPayerStatus?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ArtClaimStatusEnum>;
    statusReason?: Maybe<Scalars['String']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
    unscheduledBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    visitId?: Maybe<Scalars['String']['output']>;
};

export type ArtClaimAuditLogMaxOrderByAggregateInput = {
    artClaimId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimLastUpdated?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfRecentTransfer?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    departmentId?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    ehrPatientBalance?: InputMaybe<SortOrder>;
    firstCommunicationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    inboundSourceId?: InputMaybe<SortOrder>;
    lastCommunicationDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    patientEnterpriseId?: InputMaybe<SortOrder>;
    patientOrgEhrId?: InputMaybe<SortOrder>;
    patientStatus?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    primaryPayer?: InputMaybe<SortOrder>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrder>;
    primaryPayerStatus?: InputMaybe<SortOrder>;
    reviewNotes?: InputMaybe<SortOrder>;
    secondaryPayer?: InputMaybe<SortOrder>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrder>;
    secondaryPayerStatus?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrder>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrder>;
    totalArtTransferredAmount?: InputMaybe<SortOrder>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrder>;
    totalPostedOffPlatform?: InputMaybe<SortOrder>;
    unscheduledBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrder>;
};

export type ArtClaimAuditLogMinAggregate = {
    __typename?: 'ArtClaimAuditLogMinAggregate';
    artClaimId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimLastUpdated?: Maybe<Scalars['DateTimeISO']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfRecentTransfer?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    departmentId?: Maybe<Scalars['String']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    firstCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    inboundSourceId?: Maybe<Scalars['String']['output']>;
    lastCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    patientEnterpriseId?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    patientStatus?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    primaryPayerStatus?: Maybe<Scalars['String']['output']>;
    reviewNotes?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    secondaryPayerStatus?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ArtClaimStatusEnum>;
    statusReason?: Maybe<Scalars['String']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
    unscheduledBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    visitId?: Maybe<Scalars['String']['output']>;
};

export type ArtClaimAuditLogMinOrderByAggregateInput = {
    artClaimId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimLastUpdated?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfRecentTransfer?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    departmentId?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    ehrPatientBalance?: InputMaybe<SortOrder>;
    firstCommunicationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    inboundSourceId?: InputMaybe<SortOrder>;
    lastCommunicationDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    patientEnterpriseId?: InputMaybe<SortOrder>;
    patientOrgEhrId?: InputMaybe<SortOrder>;
    patientStatus?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    primaryPayer?: InputMaybe<SortOrder>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrder>;
    primaryPayerStatus?: InputMaybe<SortOrder>;
    reviewNotes?: InputMaybe<SortOrder>;
    secondaryPayer?: InputMaybe<SortOrder>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrder>;
    secondaryPayerStatus?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrder>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrder>;
    totalArtTransferredAmount?: InputMaybe<SortOrder>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrder>;
    totalPostedOffPlatform?: InputMaybe<SortOrder>;
    unscheduledBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrder>;
};

export type ArtClaimAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<ArtClaimAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<ArtClaimAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<ArtClaimAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<ArtClaimAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<ArtClaimAuditLogSumOrderByAggregateInput>;
    artClaimId?: InputMaybe<SortOrderInput>;
    artNotes?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrderInput>;
    claimLastUpdated?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfRecentTransfer?: InputMaybe<SortOrderInput>;
    dateOfService?: InputMaybe<SortOrderInput>;
    departmentId?: InputMaybe<SortOrderInput>;
    ehrCollectionsBalance?: InputMaybe<SortOrderInput>;
    ehrPatientBalance?: InputMaybe<SortOrderInput>;
    firstCommunicationDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    inboundSourceId?: InputMaybe<SortOrderInput>;
    lastCommunicationDate?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    manualReviewReasons?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    originalPatientBalance?: InputMaybe<SortOrderInput>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrderInput>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrderInput>;
    patientBalance?: InputMaybe<SortOrderInput>;
    patientEnterpriseId?: InputMaybe<SortOrderInput>;
    patientOrgEhrId?: InputMaybe<SortOrderInput>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientStatus?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrderInput>;
    primaryPayer?: InputMaybe<SortOrderInput>;
    primaryPayerBalance?: InputMaybe<SortOrderInput>;
    primaryPayerPackage?: InputMaybe<SortOrderInput>;
    primaryPayerStatus?: InputMaybe<SortOrderInput>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    reviewNotes?: InputMaybe<SortOrderInput>;
    secondaryPayer?: InputMaybe<SortOrderInput>;
    secondaryPayerBalance?: InputMaybe<SortOrderInput>;
    secondaryPayerPackage?: InputMaybe<SortOrderInput>;
    secondaryPayerStatus?: InputMaybe<SortOrderInput>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    slotIds?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrderInput>;
    statusReason?: InputMaybe<SortOrderInput>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrderInput>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrderInput>;
    totalArtTransferredAmount?: InputMaybe<SortOrderInput>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrderInput>;
    totalPostedOffPlatform?: InputMaybe<SortOrderInput>;
    unscheduledBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrderInput>;
};

export type ArtClaimAuditLogOrderByWithRelationInput = {
    artClaimId?: InputMaybe<SortOrderInput>;
    artNotes?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrderInput>;
    claimLastUpdated?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfRecentTransfer?: InputMaybe<SortOrderInput>;
    dateOfService?: InputMaybe<SortOrderInput>;
    departmentId?: InputMaybe<SortOrderInput>;
    ehrCollectionsBalance?: InputMaybe<SortOrderInput>;
    ehrPatientBalance?: InputMaybe<SortOrderInput>;
    firstCommunicationDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    inboundSourceId?: InputMaybe<SortOrderInput>;
    lastCommunicationDate?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    manualReviewReasons?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    originalPatientBalance?: InputMaybe<SortOrderInput>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrderInput>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrderInput>;
    patientBalance?: InputMaybe<SortOrderInput>;
    patientEnterpriseId?: InputMaybe<SortOrderInput>;
    patientOrgEhrId?: InputMaybe<SortOrderInput>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientStatus?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrderInput>;
    primaryPayer?: InputMaybe<SortOrderInput>;
    primaryPayerBalance?: InputMaybe<SortOrderInput>;
    primaryPayerPackage?: InputMaybe<SortOrderInput>;
    primaryPayerStatus?: InputMaybe<SortOrderInput>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    reviewNotes?: InputMaybe<SortOrderInput>;
    secondaryPayer?: InputMaybe<SortOrderInput>;
    secondaryPayerBalance?: InputMaybe<SortOrderInput>;
    secondaryPayerPackage?: InputMaybe<SortOrderInput>;
    secondaryPayerStatus?: InputMaybe<SortOrderInput>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    slotIds?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrderInput>;
    statusReason?: InputMaybe<SortOrderInput>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrderInput>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrderInput>;
    totalArtTransferredAmount?: InputMaybe<SortOrderInput>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrderInput>;
    totalPostedOffPlatform?: InputMaybe<SortOrderInput>;
    unscheduledBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrderInput>;
};

export enum ArtClaimAuditLogScalarFieldEnum {
    ArtClaimId = 'artClaimId',
    ArtNotes = 'artNotes',
    ClaimId = 'claimId',
    ClaimLastUpdated = 'claimLastUpdated',
    ClaimReturnStatus = 'claimReturnStatus',
    CreatedAt = 'createdAt',
    DateOfRecentTransfer = 'dateOfRecentTransfer',
    DateOfService = 'dateOfService',
    DepartmentId = 'departmentId',
    EhrCollectionsBalance = 'ehrCollectionsBalance',
    EhrPatientBalance = 'ehrPatientBalance',
    FirstCommunicationDate = 'firstCommunicationDate',
    Id = 'id',
    InboundSourceId = 'inboundSourceId',
    LastCommunicationDate = 'lastCommunicationDate',
    LastUpdatedBy = 'lastUpdatedBy',
    ManualReviewReasons = 'manualReviewReasons',
    Metadata = 'metadata',
    Notes = 'notes',
    Operation = 'operation',
    OrgId = 'orgId',
    OriginalPatientBalance = 'originalPatientBalance',
    OriginalPrimaryPayerBalance = 'originalPrimaryPayerBalance',
    OriginalSecondaryPayerBalance = 'originalSecondaryPayerBalance',
    PatientBalance = 'patientBalance',
    PatientEnterpriseId = 'patientEnterpriseId',
    PatientOrgEhrId = 'patientOrgEhrId',
    PatientRemarkCodes = 'patientRemarkCodes',
    PatientStatus = 'patientStatus',
    PracticeId = 'practiceId',
    PrimaryPayer = 'primaryPayer',
    PrimaryPayerBalance = 'primaryPayerBalance',
    PrimaryPayerPackage = 'primaryPayerPackage',
    PrimaryPayerStatus = 'primaryPayerStatus',
    PrimaryRemarkCodes = 'primaryRemarkCodes',
    ProcedureCodes = 'procedureCodes',
    ReviewNotes = 'reviewNotes',
    SecondaryPayer = 'secondaryPayer',
    SecondaryPayerBalance = 'secondaryPayerBalance',
    SecondaryPayerPackage = 'secondaryPayerPackage',
    SecondaryPayerStatus = 'secondaryPayerStatus',
    SecondaryRemarkCodes = 'secondaryRemarkCodes',
    SlotIds = 'slotIds',
    Status = 'status',
    StatusReason = 'statusReason',
    TotalAdjudicatedResponsibility = 'totalAdjudicatedResponsibility',
    TotalAdjustedOffPlatform = 'totalAdjustedOffPlatform',
    TotalArtTransferredAmount = 'totalArtTransferredAmount',
    TotalPostedBySuperscriptAmount = 'totalPostedBySuperscriptAmount',
    TotalPostedOffPlatform = 'totalPostedOffPlatform',
    UnscheduledBoughtTreatmentId = 'unscheduledBoughtTreatmentId',
    UpdatedAt = 'updatedAt',
    VisitId = 'visitId',
}

export type ArtClaimAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ArtClaimAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ArtClaimAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ArtClaimAuditLogScalarWhereWithAggregatesInput>>;
    artClaimId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    artNotes?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    claimLastUpdated?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    dateOfRecentTransfer?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    dateOfService?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    departmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    ehrPatientBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    firstCommunicationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    inboundSourceId?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastCommunicationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    manualReviewReasons?: InputMaybe<StringNullableListFilter>;
    metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableListFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    originalPatientBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    originalPrimaryPayerBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    originalSecondaryPayerBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    patientBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    patientEnterpriseId?: InputMaybe<StringNullableWithAggregatesFilter>;
    patientOrgEhrId?: InputMaybe<StringNullableWithAggregatesFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntNullableWithAggregatesFilter>;
    primaryPayer?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryPayerBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryPayerPackage?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryPayerStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    reviewNotes?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryPayer?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryPayerBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryPayerPackage?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryPayerStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    slotIds?: InputMaybe<StringNullableListFilter>;
    status?: InputMaybe<EnumArtClaimStatusEnumNullableWithAggregatesFilter>;
    statusReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    totalAdjudicatedResponsibility?: InputMaybe<FloatNullableWithAggregatesFilter>;
    totalAdjustedOffPlatform?: InputMaybe<FloatNullableWithAggregatesFilter>;
    totalArtTransferredAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    totalPostedBySuperscriptAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    totalPostedOffPlatform?: InputMaybe<FloatNullableWithAggregatesFilter>;
    unscheduledBoughtTreatmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    visitId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ArtClaimAuditLogSumAggregate = {
    __typename?: 'ArtClaimAuditLogSumAggregate';
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
};

export type ArtClaimAuditLogSumOrderByAggregateInput = {
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    ehrPatientBalance?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrder>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrder>;
    totalArtTransferredAmount?: InputMaybe<SortOrder>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrder>;
    totalPostedOffPlatform?: InputMaybe<SortOrder>;
};

export type ArtClaimAuditLogUpdateInput = {
    artClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    artNotes?: InputMaybe<ArtClaimAuditLogUpdateartNotesInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimLastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateOfRecentTransfer?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    departmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrCollectionsBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrPatientBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    firstCommunicationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    inboundSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastCommunicationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    manualReviewReasons?: InputMaybe<ArtClaimAuditLogUpdatemanualReviewReasonsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<ArtClaimAuditLogUpdatenotesInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    originalPatientBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    originalPrimaryPayerBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    originalSecondaryPayerBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOrgEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientRemarkCodes?: InputMaybe<ArtClaimAuditLogUpdatepatientRemarkCodesInput>;
    patientStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    primaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryRemarkCodes?: InputMaybe<ArtClaimAuditLogUpdateprimaryRemarkCodesInput>;
    procedureCodes?: InputMaybe<ArtClaimAuditLogUpdateprocedureCodesInput>;
    reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimAuditLogUpdatesecondaryRemarkCodesInput>;
    slotIds?: InputMaybe<ArtClaimAuditLogUpdateslotIdsInput>;
    status?: InputMaybe<NullableEnumArtClaimStatusEnumFieldUpdateOperationsInput>;
    statusReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    totalAdjudicatedResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalAdjustedOffPlatform?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalArtTransferredAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalPostedBySuperscriptAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalPostedOffPlatform?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    unscheduledBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    visitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArtClaimAuditLogUpdateManyMutationInput = {
    artClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    artNotes?: InputMaybe<ArtClaimAuditLogUpdateartNotesInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimLastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateOfRecentTransfer?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    departmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrCollectionsBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrPatientBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    firstCommunicationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    inboundSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastCommunicationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    manualReviewReasons?: InputMaybe<ArtClaimAuditLogUpdatemanualReviewReasonsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<ArtClaimAuditLogUpdatenotesInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    originalPatientBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    originalPrimaryPayerBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    originalSecondaryPayerBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOrgEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientRemarkCodes?: InputMaybe<ArtClaimAuditLogUpdatepatientRemarkCodesInput>;
    patientStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    primaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryRemarkCodes?: InputMaybe<ArtClaimAuditLogUpdateprimaryRemarkCodesInput>;
    procedureCodes?: InputMaybe<ArtClaimAuditLogUpdateprocedureCodesInput>;
    reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimAuditLogUpdatesecondaryRemarkCodesInput>;
    slotIds?: InputMaybe<ArtClaimAuditLogUpdateslotIdsInput>;
    status?: InputMaybe<NullableEnumArtClaimStatusEnumFieldUpdateOperationsInput>;
    statusReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    totalAdjudicatedResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalAdjustedOffPlatform?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalArtTransferredAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalPostedBySuperscriptAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalPostedOffPlatform?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    unscheduledBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    visitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArtClaimAuditLogUpdateartNotesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimAuditLogUpdatemanualReviewReasonsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimAuditLogUpdatenotesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimAuditLogUpdatepatientRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimAuditLogUpdateprimaryRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimAuditLogUpdateprocedureCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimAuditLogUpdatesecondaryRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimAuditLogUpdateslotIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimAuditLogWhereInput = {
    AND?: InputMaybe<Array<ArtClaimAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<ArtClaimAuditLogWhereInput>>;
    OR?: InputMaybe<Array<ArtClaimAuditLogWhereInput>>;
    artClaimId?: InputMaybe<UuidNullableFilter>;
    artNotes?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    claimLastUpdated?: InputMaybe<DateTimeNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dateOfRecentTransfer?: InputMaybe<DateTimeNullableFilter>;
    dateOfService?: InputMaybe<DateTimeNullableFilter>;
    departmentId?: InputMaybe<StringNullableFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableFilter>;
    ehrPatientBalance?: InputMaybe<FloatNullableFilter>;
    firstCommunicationDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    inboundSourceId?: InputMaybe<StringNullableFilter>;
    lastCommunicationDate?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    manualReviewReasons?: InputMaybe<StringNullableListFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    notes?: InputMaybe<StringNullableListFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    originalPatientBalance?: InputMaybe<FloatNullableFilter>;
    originalPrimaryPayerBalance?: InputMaybe<FloatNullableFilter>;
    originalSecondaryPayerBalance?: InputMaybe<FloatNullableFilter>;
    patientBalance?: InputMaybe<FloatNullableFilter>;
    patientEnterpriseId?: InputMaybe<StringNullableFilter>;
    patientOrgEhrId?: InputMaybe<StringNullableFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientStatus?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    primaryPayer?: InputMaybe<StringNullableFilter>;
    primaryPayerBalance?: InputMaybe<FloatNullableFilter>;
    primaryPayerPackage?: InputMaybe<StringNullableFilter>;
    primaryPayerStatus?: InputMaybe<StringNullableFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    reviewNotes?: InputMaybe<StringNullableFilter>;
    secondaryPayer?: InputMaybe<StringNullableFilter>;
    secondaryPayerBalance?: InputMaybe<FloatNullableFilter>;
    secondaryPayerPackage?: InputMaybe<StringNullableFilter>;
    secondaryPayerStatus?: InputMaybe<StringNullableFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    slotIds?: InputMaybe<StringNullableListFilter>;
    status?: InputMaybe<EnumArtClaimStatusEnumNullableFilter>;
    statusReason?: InputMaybe<StringNullableFilter>;
    totalAdjudicatedResponsibility?: InputMaybe<FloatNullableFilter>;
    totalAdjustedOffPlatform?: InputMaybe<FloatNullableFilter>;
    totalArtTransferredAmount?: InputMaybe<FloatNullableFilter>;
    totalPostedBySuperscriptAmount?: InputMaybe<FloatNullableFilter>;
    totalPostedOffPlatform?: InputMaybe<FloatNullableFilter>;
    unscheduledBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    visitId?: InputMaybe<StringNullableFilter>;
};

export type ArtClaimAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<ArtClaimAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<ArtClaimAuditLogWhereInput>>;
    OR?: InputMaybe<Array<ArtClaimAuditLogWhereInput>>;
    artClaimId?: InputMaybe<UuidNullableFilter>;
    artNotes?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    claimLastUpdated?: InputMaybe<DateTimeNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dateOfRecentTransfer?: InputMaybe<DateTimeNullableFilter>;
    dateOfService?: InputMaybe<DateTimeNullableFilter>;
    departmentId?: InputMaybe<StringNullableFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableFilter>;
    ehrPatientBalance?: InputMaybe<FloatNullableFilter>;
    firstCommunicationDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    inboundSourceId?: InputMaybe<StringNullableFilter>;
    lastCommunicationDate?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    manualReviewReasons?: InputMaybe<StringNullableListFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    notes?: InputMaybe<StringNullableListFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    originalPatientBalance?: InputMaybe<FloatNullableFilter>;
    originalPrimaryPayerBalance?: InputMaybe<FloatNullableFilter>;
    originalSecondaryPayerBalance?: InputMaybe<FloatNullableFilter>;
    patientBalance?: InputMaybe<FloatNullableFilter>;
    patientEnterpriseId?: InputMaybe<StringNullableFilter>;
    patientOrgEhrId?: InputMaybe<StringNullableFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientStatus?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    primaryPayer?: InputMaybe<StringNullableFilter>;
    primaryPayerBalance?: InputMaybe<FloatNullableFilter>;
    primaryPayerPackage?: InputMaybe<StringNullableFilter>;
    primaryPayerStatus?: InputMaybe<StringNullableFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    reviewNotes?: InputMaybe<StringNullableFilter>;
    secondaryPayer?: InputMaybe<StringNullableFilter>;
    secondaryPayerBalance?: InputMaybe<FloatNullableFilter>;
    secondaryPayerPackage?: InputMaybe<StringNullableFilter>;
    secondaryPayerStatus?: InputMaybe<StringNullableFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    slotIds?: InputMaybe<StringNullableListFilter>;
    status?: InputMaybe<EnumArtClaimStatusEnumNullableFilter>;
    statusReason?: InputMaybe<StringNullableFilter>;
    totalAdjudicatedResponsibility?: InputMaybe<FloatNullableFilter>;
    totalAdjustedOffPlatform?: InputMaybe<FloatNullableFilter>;
    totalArtTransferredAmount?: InputMaybe<FloatNullableFilter>;
    totalPostedBySuperscriptAmount?: InputMaybe<FloatNullableFilter>;
    totalPostedOffPlatform?: InputMaybe<FloatNullableFilter>;
    unscheduledBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    visitId?: InputMaybe<StringNullableFilter>;
};

export type ArtClaimAvgAggregate = {
    __typename?: 'ArtClaimAvgAggregate';
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
};

export type ArtClaimAvgOrderByAggregateInput = {
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    ehrPatientBalance?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrder>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrder>;
    totalArtTransferredAmount?: InputMaybe<SortOrder>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrder>;
    totalPostedOffPlatform?: InputMaybe<SortOrder>;
};

export type ArtClaimCount = {
    __typename?: 'ArtClaimCount';
    cptLines: Scalars['Int']['output'];
};

export type ArtClaimCountCptLinesArgs = {
    where?: InputMaybe<ArtClaimCptLineWhereInput>;
};

export type ArtClaimCountAggregate = {
    __typename?: 'ArtClaimCountAggregate';
    _all: Scalars['Int']['output'];
    artNotes: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    claimLastUpdated: Scalars['Int']['output'];
    claimReturnStatus: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    dateOfRecentTransfer: Scalars['Int']['output'];
    dateOfService: Scalars['Int']['output'];
    departmentId: Scalars['Int']['output'];
    ehrCollectionsBalance: Scalars['Int']['output'];
    ehrPatientBalance: Scalars['Int']['output'];
    firstCommunicationDate: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    inboundSourceId: Scalars['Int']['output'];
    lastCommunicationDate: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    manualReviewReasons: Scalars['Int']['output'];
    metadata: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    originalPatientBalance: Scalars['Int']['output'];
    originalPrimaryPayerBalance: Scalars['Int']['output'];
    originalSecondaryPayerBalance: Scalars['Int']['output'];
    patientBalance: Scalars['Int']['output'];
    patientEnterpriseId: Scalars['Int']['output'];
    patientOrgEhrId: Scalars['Int']['output'];
    patientRemarkCodes: Scalars['Int']['output'];
    patientStatus: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    primaryPayer: Scalars['Int']['output'];
    primaryPayerBalance: Scalars['Int']['output'];
    primaryPayerPackage: Scalars['Int']['output'];
    primaryPayerStatus: Scalars['Int']['output'];
    primaryRemarkCodes: Scalars['Int']['output'];
    procedureCodes: Scalars['Int']['output'];
    reviewNotes: Scalars['Int']['output'];
    secondaryPayer: Scalars['Int']['output'];
    secondaryPayerBalance: Scalars['Int']['output'];
    secondaryPayerPackage: Scalars['Int']['output'];
    secondaryPayerStatus: Scalars['Int']['output'];
    secondaryRemarkCodes: Scalars['Int']['output'];
    slotIds: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    statusReason: Scalars['Int']['output'];
    totalAdjudicatedResponsibility: Scalars['Int']['output'];
    totalAdjustedOffPlatform: Scalars['Int']['output'];
    totalArtTransferredAmount: Scalars['Int']['output'];
    totalPostedBySuperscriptAmount: Scalars['Int']['output'];
    totalPostedOffPlatform: Scalars['Int']['output'];
    unscheduledBoughtTreatmentId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    visitId: Scalars['Int']['output'];
};

export type ArtClaimCountOrderByAggregateInput = {
    artNotes?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimLastUpdated?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfRecentTransfer?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    departmentId?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    ehrPatientBalance?: InputMaybe<SortOrder>;
    firstCommunicationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    inboundSourceId?: InputMaybe<SortOrder>;
    lastCommunicationDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    manualReviewReasons?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    patientEnterpriseId?: InputMaybe<SortOrder>;
    patientOrgEhrId?: InputMaybe<SortOrder>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientStatus?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    primaryPayer?: InputMaybe<SortOrder>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrder>;
    primaryPayerStatus?: InputMaybe<SortOrder>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    reviewNotes?: InputMaybe<SortOrder>;
    secondaryPayer?: InputMaybe<SortOrder>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrder>;
    secondaryPayerStatus?: InputMaybe<SortOrder>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    slotIds?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrder>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrder>;
    totalArtTransferredAmount?: InputMaybe<SortOrder>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrder>;
    totalPostedOffPlatform?: InputMaybe<SortOrder>;
    unscheduledBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLine = {
    __typename?: 'ArtClaimCptLine';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    artClaim: ArtClaim;
    artClaimId: Scalars['String']['output'];
    billedAmount?: Maybe<Scalars['Float']['output']>;
    claimId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfService: Scalars['DateTimeISO']['output'];
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    highConfidenceBoughtTreatmentIds: Array<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    isClosedOut?: Maybe<Scalars['Boolean']['output']>;
    isDenied?: Maybe<Scalars['Boolean']['output']>;
    isFullyCovered?: Maybe<Scalars['Boolean']['output']>;
    isOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
    isSelfPay?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    noShowFeeFlag?: Maybe<Scalars['Boolean']['output']>;
    orgId: Scalars['Int']['output'];
    patientClaimStatus?: Maybe<Scalars['String']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientRemarkCodes: Array<Scalars['String']['output']>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    primaryRemarkCodes: Array<Scalars['String']['output']>;
    procedureCode: Scalars['String']['output'];
    procedureDescription?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    secondaryRemarkCodes: Array<Scalars['String']['output']>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
    unusualChargeFlag?: Maybe<Scalars['Boolean']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtClaimCptLineArtClaimIdProcedureCodeCompoundUniqueInput = {
    artClaimId: Scalars['String']['input'];
    procedureCode: Scalars['String']['input'];
};

export type ArtClaimCptLineAuditLog = {
    __typename?: 'ArtClaimCptLineAuditLog';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    artClaimCptLineId?: Maybe<Scalars['String']['output']>;
    artClaimId?: Maybe<Scalars['String']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    highConfidenceBoughtTreatmentIds: Array<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    isClosedOut?: Maybe<Scalars['Boolean']['output']>;
    isDenied?: Maybe<Scalars['Boolean']['output']>;
    isFullyCovered?: Maybe<Scalars['Boolean']['output']>;
    isOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
    isSelfPay?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    noShowFeeFlag?: Maybe<Scalars['Boolean']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    patientClaimStatus?: Maybe<Scalars['String']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientRemarkCodes: Array<Scalars['String']['output']>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    primaryRemarkCodes: Array<Scalars['String']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    procedureDescription?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    secondaryRemarkCodes: Array<Scalars['String']['output']>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
    unusualChargeFlag?: Maybe<Scalars['Boolean']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtClaimCptLineAuditLogAvgAggregate = {
    __typename?: 'ArtClaimCptLineAuditLogAvgAggregate';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    quantity?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
};

export type ArtClaimCptLineAuditLogAvgOrderByAggregateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrder>;
    allowable?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    externalAdjustmentAmount?: InputMaybe<SortOrder>;
    externalPaymentAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientOtherAmount?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrder>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrder>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    primaryContractualAmount?: InputMaybe<SortOrder>;
    primaryCopayAmount?: InputMaybe<SortOrder>;
    primaryDeductibleAmount?: InputMaybe<SortOrder>;
    primaryOtherAmount?: InputMaybe<SortOrder>;
    primaryPayerOutstanding?: InputMaybe<SortOrder>;
    primaryPayerPayment?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    secondaryContractualAmount?: InputMaybe<SortOrder>;
    secondaryCopayAmount?: InputMaybe<SortOrder>;
    secondaryDeductibleAmount?: InputMaybe<SortOrder>;
    secondaryOtherAmount?: InputMaybe<SortOrder>;
    secondaryPayerOutstanding?: InputMaybe<SortOrder>;
    secondaryPayerPayment?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineAuditLogCountAggregate = {
    __typename?: 'ArtClaimCptLineAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    adjudicatedSuperscriptGuaranteeAmount: Scalars['Int']['output'];
    allowable: Scalars['Int']['output'];
    artClaimCptLineId: Scalars['Int']['output'];
    artClaimId: Scalars['Int']['output'];
    billedAmount: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    dateOfService: Scalars['Int']['output'];
    displacedSuperscriptAmount: Scalars['Int']['output'];
    ehrCollectionsBalance: Scalars['Int']['output'];
    externalAdjustmentAmount: Scalars['Int']['output'];
    externalPaymentAmount: Scalars['Int']['output'];
    highConfidenceBoughtTreatmentIds: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isClosedOut: Scalars['Int']['output'];
    isDenied: Scalars['Int']['output'];
    isFullyCovered: Scalars['Int']['output'];
    isOutOfNetwork: Scalars['Int']['output'];
    isSelfPay: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    noShowFeeFlag: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    patientClaimStatus: Scalars['Int']['output'];
    patientOtherAmount: Scalars['Int']['output'];
    patientRemarkCodes: Scalars['Int']['output'];
    patientResponsibilityOriginal: Scalars['Int']['output'];
    patientResponsibilityOutstanding: Scalars['Int']['output'];
    primaryCoinsuranceAmount: Scalars['Int']['output'];
    primaryCoinsurancePercentage: Scalars['Int']['output'];
    primaryContractualAmount: Scalars['Int']['output'];
    primaryCopayAmount: Scalars['Int']['output'];
    primaryDeductibleAmount: Scalars['Int']['output'];
    primaryOtherAmount: Scalars['Int']['output'];
    primaryPayerOutstanding: Scalars['Int']['output'];
    primaryPayerPayment: Scalars['Int']['output'];
    primaryRemarkCodes: Scalars['Int']['output'];
    procedureCode: Scalars['Int']['output'];
    procedureDescription: Scalars['Int']['output'];
    quantity: Scalars['Int']['output'];
    secondaryCoinsuranceAmount: Scalars['Int']['output'];
    secondaryCoinsurancePercentage: Scalars['Int']['output'];
    secondaryContractualAmount: Scalars['Int']['output'];
    secondaryCopayAmount: Scalars['Int']['output'];
    secondaryDeductibleAmount: Scalars['Int']['output'];
    secondaryOtherAmount: Scalars['Int']['output'];
    secondaryPayerOutstanding: Scalars['Int']['output'];
    secondaryPayerPayment: Scalars['Int']['output'];
    secondaryRemarkCodes: Scalars['Int']['output'];
    totalAdjudicatedSuperscriptResponsibility: Scalars['Int']['output'];
    unusualChargeFlag: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    voidedAt: Scalars['Int']['output'];
};

export type ArtClaimCptLineAuditLogCountOrderByAggregateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrder>;
    allowable?: InputMaybe<SortOrder>;
    artClaimCptLineId?: InputMaybe<SortOrder>;
    artClaimId?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    externalAdjustmentAmount?: InputMaybe<SortOrder>;
    externalPaymentAmount?: InputMaybe<SortOrder>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isClosedOut?: InputMaybe<SortOrder>;
    isDenied?: InputMaybe<SortOrder>;
    isFullyCovered?: InputMaybe<SortOrder>;
    isOutOfNetwork?: InputMaybe<SortOrder>;
    isSelfPay?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    noShowFeeFlag?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientClaimStatus?: InputMaybe<SortOrder>;
    patientOtherAmount?: InputMaybe<SortOrder>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrder>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrder>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    primaryContractualAmount?: InputMaybe<SortOrder>;
    primaryCopayAmount?: InputMaybe<SortOrder>;
    primaryDeductibleAmount?: InputMaybe<SortOrder>;
    primaryOtherAmount?: InputMaybe<SortOrder>;
    primaryPayerOutstanding?: InputMaybe<SortOrder>;
    primaryPayerPayment?: InputMaybe<SortOrder>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    procedureDescription?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    secondaryContractualAmount?: InputMaybe<SortOrder>;
    secondaryCopayAmount?: InputMaybe<SortOrder>;
    secondaryDeductibleAmount?: InputMaybe<SortOrder>;
    secondaryOtherAmount?: InputMaybe<SortOrder>;
    secondaryPayerOutstanding?: InputMaybe<SortOrder>;
    secondaryPayerPayment?: InputMaybe<SortOrder>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrder>;
    unusualChargeFlag?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineAuditLogCreateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<
        Scalars['Float']['input']
    >;
    allowable?: InputMaybe<Scalars['Float']['input']>;
    artClaimCptLineId?: InputMaybe<Scalars['String']['input']>;
    artClaimId?: InputMaybe<Scalars['String']['input']>;
    billedAmount?: InputMaybe<Scalars['Float']['input']>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displacedSuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    externalAdjustmentAmount?: InputMaybe<Scalars['Float']['input']>;
    externalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineAuditLogCreatehighConfidenceBoughtTreatmentIdsInput>;
    isClosedOut?: InputMaybe<Scalars['Boolean']['input']>;
    isDenied?: InputMaybe<Scalars['Boolean']['input']>;
    isFullyCovered?: InputMaybe<Scalars['Boolean']['input']>;
    isOutOfNetwork?: InputMaybe<Scalars['Boolean']['input']>;
    isSelfPay?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    noShowFeeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    patientClaimStatus?: InputMaybe<Scalars['String']['input']>;
    patientOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogCreatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<Scalars['Float']['input']>;
    patientResponsibilityOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    primaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogCreateprimaryRemarkCodesInput>;
    procedureCode?: InputMaybe<Scalars['String']['input']>;
    procedureDescription?: InputMaybe<Scalars['String']['input']>;
    quantity?: InputMaybe<Scalars['Int']['input']>;
    secondaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    secondaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogCreatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<
        Scalars['Float']['input']
    >;
    unusualChargeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtClaimCptLineAuditLogCreateManyInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<
        Scalars['Float']['input']
    >;
    allowable?: InputMaybe<Scalars['Float']['input']>;
    artClaimCptLineId?: InputMaybe<Scalars['String']['input']>;
    artClaimId?: InputMaybe<Scalars['String']['input']>;
    billedAmount?: InputMaybe<Scalars['Float']['input']>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displacedSuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    externalAdjustmentAmount?: InputMaybe<Scalars['Float']['input']>;
    externalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineAuditLogCreatehighConfidenceBoughtTreatmentIdsInput>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isClosedOut?: InputMaybe<Scalars['Boolean']['input']>;
    isDenied?: InputMaybe<Scalars['Boolean']['input']>;
    isFullyCovered?: InputMaybe<Scalars['Boolean']['input']>;
    isOutOfNetwork?: InputMaybe<Scalars['Boolean']['input']>;
    isSelfPay?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    noShowFeeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    patientClaimStatus?: InputMaybe<Scalars['String']['input']>;
    patientOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogCreatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<Scalars['Float']['input']>;
    patientResponsibilityOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    primaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogCreateprimaryRemarkCodesInput>;
    procedureCode?: InputMaybe<Scalars['String']['input']>;
    procedureDescription?: InputMaybe<Scalars['String']['input']>;
    quantity?: InputMaybe<Scalars['Int']['input']>;
    secondaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    secondaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogCreatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<
        Scalars['Float']['input']
    >;
    unusualChargeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtClaimCptLineAuditLogCreatehighConfidenceBoughtTreatmentIdsInput =
    {
        set: Array<Scalars['String']['input']>;
    };

export type ArtClaimCptLineAuditLogCreatepatientRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCptLineAuditLogCreateprimaryRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCptLineAuditLogCreatesecondaryRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCptLineAuditLogGroupBy = {
    __typename?: 'ArtClaimCptLineAuditLogGroupBy';
    _avg?: Maybe<ArtClaimCptLineAuditLogAvgAggregate>;
    _count?: Maybe<ArtClaimCptLineAuditLogCountAggregate>;
    _max?: Maybe<ArtClaimCptLineAuditLogMaxAggregate>;
    _min?: Maybe<ArtClaimCptLineAuditLogMinAggregate>;
    _sum?: Maybe<ArtClaimCptLineAuditLogSumAggregate>;
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    artClaimCptLineId?: Maybe<Scalars['String']['output']>;
    artClaimId?: Maybe<Scalars['String']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    highConfidenceBoughtTreatmentIds?: Maybe<
        Array<Scalars['String']['output']>
    >;
    id: Scalars['Int']['output'];
    isClosedOut?: Maybe<Scalars['Boolean']['output']>;
    isDenied?: Maybe<Scalars['Boolean']['output']>;
    isFullyCovered?: Maybe<Scalars['Boolean']['output']>;
    isOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
    isSelfPay?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    noShowFeeFlag?: Maybe<Scalars['Boolean']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    patientClaimStatus?: Maybe<Scalars['String']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    primaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    procedureDescription?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    secondaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
    unusualChargeFlag?: Maybe<Scalars['Boolean']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtClaimCptLineAuditLogMaxAggregate = {
    __typename?: 'ArtClaimCptLineAuditLogMaxAggregate';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    artClaimCptLineId?: Maybe<Scalars['String']['output']>;
    artClaimId?: Maybe<Scalars['String']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isClosedOut?: Maybe<Scalars['Boolean']['output']>;
    isDenied?: Maybe<Scalars['Boolean']['output']>;
    isFullyCovered?: Maybe<Scalars['Boolean']['output']>;
    isOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
    isSelfPay?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    noShowFeeFlag?: Maybe<Scalars['Boolean']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientClaimStatus?: Maybe<Scalars['String']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    procedureDescription?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
    unusualChargeFlag?: Maybe<Scalars['Boolean']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtClaimCptLineAuditLogMaxOrderByAggregateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrder>;
    allowable?: InputMaybe<SortOrder>;
    artClaimCptLineId?: InputMaybe<SortOrder>;
    artClaimId?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    externalAdjustmentAmount?: InputMaybe<SortOrder>;
    externalPaymentAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isClosedOut?: InputMaybe<SortOrder>;
    isDenied?: InputMaybe<SortOrder>;
    isFullyCovered?: InputMaybe<SortOrder>;
    isOutOfNetwork?: InputMaybe<SortOrder>;
    isSelfPay?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    noShowFeeFlag?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientClaimStatus?: InputMaybe<SortOrder>;
    patientOtherAmount?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrder>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrder>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    primaryContractualAmount?: InputMaybe<SortOrder>;
    primaryCopayAmount?: InputMaybe<SortOrder>;
    primaryDeductibleAmount?: InputMaybe<SortOrder>;
    primaryOtherAmount?: InputMaybe<SortOrder>;
    primaryPayerOutstanding?: InputMaybe<SortOrder>;
    primaryPayerPayment?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    procedureDescription?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    secondaryContractualAmount?: InputMaybe<SortOrder>;
    secondaryCopayAmount?: InputMaybe<SortOrder>;
    secondaryDeductibleAmount?: InputMaybe<SortOrder>;
    secondaryOtherAmount?: InputMaybe<SortOrder>;
    secondaryPayerOutstanding?: InputMaybe<SortOrder>;
    secondaryPayerPayment?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrder>;
    unusualChargeFlag?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineAuditLogMinAggregate = {
    __typename?: 'ArtClaimCptLineAuditLogMinAggregate';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    artClaimCptLineId?: Maybe<Scalars['String']['output']>;
    artClaimId?: Maybe<Scalars['String']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isClosedOut?: Maybe<Scalars['Boolean']['output']>;
    isDenied?: Maybe<Scalars['Boolean']['output']>;
    isFullyCovered?: Maybe<Scalars['Boolean']['output']>;
    isOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
    isSelfPay?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    noShowFeeFlag?: Maybe<Scalars['Boolean']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientClaimStatus?: Maybe<Scalars['String']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    procedureDescription?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
    unusualChargeFlag?: Maybe<Scalars['Boolean']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtClaimCptLineAuditLogMinOrderByAggregateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrder>;
    allowable?: InputMaybe<SortOrder>;
    artClaimCptLineId?: InputMaybe<SortOrder>;
    artClaimId?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    externalAdjustmentAmount?: InputMaybe<SortOrder>;
    externalPaymentAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isClosedOut?: InputMaybe<SortOrder>;
    isDenied?: InputMaybe<SortOrder>;
    isFullyCovered?: InputMaybe<SortOrder>;
    isOutOfNetwork?: InputMaybe<SortOrder>;
    isSelfPay?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    noShowFeeFlag?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientClaimStatus?: InputMaybe<SortOrder>;
    patientOtherAmount?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrder>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrder>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    primaryContractualAmount?: InputMaybe<SortOrder>;
    primaryCopayAmount?: InputMaybe<SortOrder>;
    primaryDeductibleAmount?: InputMaybe<SortOrder>;
    primaryOtherAmount?: InputMaybe<SortOrder>;
    primaryPayerOutstanding?: InputMaybe<SortOrder>;
    primaryPayerPayment?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    procedureDescription?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    secondaryContractualAmount?: InputMaybe<SortOrder>;
    secondaryCopayAmount?: InputMaybe<SortOrder>;
    secondaryDeductibleAmount?: InputMaybe<SortOrder>;
    secondaryOtherAmount?: InputMaybe<SortOrder>;
    secondaryPayerOutstanding?: InputMaybe<SortOrder>;
    secondaryPayerPayment?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrder>;
    unusualChargeFlag?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<ArtClaimCptLineAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<ArtClaimCptLineAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<ArtClaimCptLineAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<ArtClaimCptLineAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<ArtClaimCptLineAuditLogSumOrderByAggregateInput>;
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrderInput>;
    allowable?: InputMaybe<SortOrderInput>;
    artClaimCptLineId?: InputMaybe<SortOrderInput>;
    artClaimId?: InputMaybe<SortOrderInput>;
    billedAmount?: InputMaybe<SortOrderInput>;
    claimId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrderInput>;
    displacedSuperscriptAmount?: InputMaybe<SortOrderInput>;
    ehrCollectionsBalance?: InputMaybe<SortOrderInput>;
    externalAdjustmentAmount?: InputMaybe<SortOrderInput>;
    externalPaymentAmount?: InputMaybe<SortOrderInput>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isClosedOut?: InputMaybe<SortOrderInput>;
    isDenied?: InputMaybe<SortOrderInput>;
    isFullyCovered?: InputMaybe<SortOrderInput>;
    isOutOfNetwork?: InputMaybe<SortOrderInput>;
    isSelfPay?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    noShowFeeFlag?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    patientClaimStatus?: InputMaybe<SortOrderInput>;
    patientOtherAmount?: InputMaybe<SortOrderInput>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrderInput>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrderInput>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrderInput>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    primaryContractualAmount?: InputMaybe<SortOrderInput>;
    primaryCopayAmount?: InputMaybe<SortOrderInput>;
    primaryDeductibleAmount?: InputMaybe<SortOrderInput>;
    primaryOtherAmount?: InputMaybe<SortOrderInput>;
    primaryPayerOutstanding?: InputMaybe<SortOrderInput>;
    primaryPayerPayment?: InputMaybe<SortOrderInput>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrderInput>;
    procedureDescription?: InputMaybe<SortOrderInput>;
    quantity?: InputMaybe<SortOrderInput>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrderInput>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    secondaryContractualAmount?: InputMaybe<SortOrderInput>;
    secondaryCopayAmount?: InputMaybe<SortOrderInput>;
    secondaryDeductibleAmount?: InputMaybe<SortOrderInput>;
    secondaryOtherAmount?: InputMaybe<SortOrderInput>;
    secondaryPayerOutstanding?: InputMaybe<SortOrderInput>;
    secondaryPayerPayment?: InputMaybe<SortOrderInput>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrderInput>;
    unusualChargeFlag?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export type ArtClaimCptLineAuditLogOrderByWithRelationInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrderInput>;
    allowable?: InputMaybe<SortOrderInput>;
    artClaimCptLineId?: InputMaybe<SortOrderInput>;
    artClaimId?: InputMaybe<SortOrderInput>;
    billedAmount?: InputMaybe<SortOrderInput>;
    claimId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrderInput>;
    displacedSuperscriptAmount?: InputMaybe<SortOrderInput>;
    ehrCollectionsBalance?: InputMaybe<SortOrderInput>;
    externalAdjustmentAmount?: InputMaybe<SortOrderInput>;
    externalPaymentAmount?: InputMaybe<SortOrderInput>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isClosedOut?: InputMaybe<SortOrderInput>;
    isDenied?: InputMaybe<SortOrderInput>;
    isFullyCovered?: InputMaybe<SortOrderInput>;
    isOutOfNetwork?: InputMaybe<SortOrderInput>;
    isSelfPay?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    noShowFeeFlag?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    patientClaimStatus?: InputMaybe<SortOrderInput>;
    patientOtherAmount?: InputMaybe<SortOrderInput>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrderInput>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrderInput>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrderInput>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    primaryContractualAmount?: InputMaybe<SortOrderInput>;
    primaryCopayAmount?: InputMaybe<SortOrderInput>;
    primaryDeductibleAmount?: InputMaybe<SortOrderInput>;
    primaryOtherAmount?: InputMaybe<SortOrderInput>;
    primaryPayerOutstanding?: InputMaybe<SortOrderInput>;
    primaryPayerPayment?: InputMaybe<SortOrderInput>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrderInput>;
    procedureDescription?: InputMaybe<SortOrderInput>;
    quantity?: InputMaybe<SortOrderInput>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrderInput>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    secondaryContractualAmount?: InputMaybe<SortOrderInput>;
    secondaryCopayAmount?: InputMaybe<SortOrderInput>;
    secondaryDeductibleAmount?: InputMaybe<SortOrderInput>;
    secondaryOtherAmount?: InputMaybe<SortOrderInput>;
    secondaryPayerOutstanding?: InputMaybe<SortOrderInput>;
    secondaryPayerPayment?: InputMaybe<SortOrderInput>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrderInput>;
    unusualChargeFlag?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export enum ArtClaimCptLineAuditLogScalarFieldEnum {
    AdjudicatedSuperscriptGuaranteeAmount = 'adjudicatedSuperscriptGuaranteeAmount',
    Allowable = 'allowable',
    ArtClaimCptLineId = 'artClaimCptLineId',
    ArtClaimId = 'artClaimId',
    BilledAmount = 'billedAmount',
    ClaimId = 'claimId',
    CreatedAt = 'createdAt',
    DateOfService = 'dateOfService',
    DisplacedSuperscriptAmount = 'displacedSuperscriptAmount',
    EhrCollectionsBalance = 'ehrCollectionsBalance',
    ExternalAdjustmentAmount = 'externalAdjustmentAmount',
    ExternalPaymentAmount = 'externalPaymentAmount',
    HighConfidenceBoughtTreatmentIds = 'highConfidenceBoughtTreatmentIds',
    Id = 'id',
    IsClosedOut = 'isClosedOut',
    IsDenied = 'isDenied',
    IsFullyCovered = 'isFullyCovered',
    IsOutOfNetwork = 'isOutOfNetwork',
    IsSelfPay = 'isSelfPay',
    LastUpdatedBy = 'lastUpdatedBy',
    NoShowFeeFlag = 'noShowFeeFlag',
    Operation = 'operation',
    OrgId = 'orgId',
    PatientClaimStatus = 'patientClaimStatus',
    PatientOtherAmount = 'patientOtherAmount',
    PatientRemarkCodes = 'patientRemarkCodes',
    PatientResponsibilityOriginal = 'patientResponsibilityOriginal',
    PatientResponsibilityOutstanding = 'patientResponsibilityOutstanding',
    PrimaryCoinsuranceAmount = 'primaryCoinsuranceAmount',
    PrimaryCoinsurancePercentage = 'primaryCoinsurancePercentage',
    PrimaryContractualAmount = 'primaryContractualAmount',
    PrimaryCopayAmount = 'primaryCopayAmount',
    PrimaryDeductibleAmount = 'primaryDeductibleAmount',
    PrimaryOtherAmount = 'primaryOtherAmount',
    PrimaryPayerOutstanding = 'primaryPayerOutstanding',
    PrimaryPayerPayment = 'primaryPayerPayment',
    PrimaryRemarkCodes = 'primaryRemarkCodes',
    ProcedureCode = 'procedureCode',
    ProcedureDescription = 'procedureDescription',
    Quantity = 'quantity',
    SecondaryCoinsuranceAmount = 'secondaryCoinsuranceAmount',
    SecondaryCoinsurancePercentage = 'secondaryCoinsurancePercentage',
    SecondaryContractualAmount = 'secondaryContractualAmount',
    SecondaryCopayAmount = 'secondaryCopayAmount',
    SecondaryDeductibleAmount = 'secondaryDeductibleAmount',
    SecondaryOtherAmount = 'secondaryOtherAmount',
    SecondaryPayerOutstanding = 'secondaryPayerOutstanding',
    SecondaryPayerPayment = 'secondaryPayerPayment',
    SecondaryRemarkCodes = 'secondaryRemarkCodes',
    TotalAdjudicatedSuperscriptResponsibility = 'totalAdjudicatedSuperscriptResponsibility',
    UnusualChargeFlag = 'unusualChargeFlag',
    UpdatedAt = 'updatedAt',
    VoidedAt = 'voidedAt',
}

export type ArtClaimCptLineAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<ArtClaimCptLineAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<ArtClaimCptLineAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<ArtClaimCptLineAuditLogScalarWhereWithAggregatesInput>
    >;
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    allowable?: InputMaybe<FloatNullableWithAggregatesFilter>;
    artClaimCptLineId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    artClaimId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    billedAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    claimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    dateOfService?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    displacedSuperscriptAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    externalAdjustmentAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    externalPaymentAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isClosedOut?: InputMaybe<BoolNullableWithAggregatesFilter>;
    isDenied?: InputMaybe<BoolNullableWithAggregatesFilter>;
    isFullyCovered?: InputMaybe<BoolNullableWithAggregatesFilter>;
    isOutOfNetwork?: InputMaybe<BoolNullableWithAggregatesFilter>;
    isSelfPay?: InputMaybe<BoolNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    noShowFeeFlag?: InputMaybe<BoolNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    patientClaimStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    patientOtherAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientResponsibilityOriginal?: InputMaybe<FloatNullableWithAggregatesFilter>;
    patientResponsibilityOutstanding?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryCoinsuranceAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryCoinsurancePercentage?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryContractualAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryCopayAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryDeductibleAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryOtherAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryPayerOutstanding?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryPayerPayment?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    procedureDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
    quantity?: InputMaybe<IntNullableWithAggregatesFilter>;
    secondaryCoinsuranceAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryCoinsurancePercentage?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryContractualAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryCopayAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryDeductibleAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryOtherAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryPayerOutstanding?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryPayerPayment?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<FloatNullableWithAggregatesFilter>;
    unusualChargeFlag?: InputMaybe<BoolNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    voidedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type ArtClaimCptLineAuditLogSumAggregate = {
    __typename?: 'ArtClaimCptLineAuditLogSumAggregate';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
};

export type ArtClaimCptLineAuditLogSumOrderByAggregateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrder>;
    allowable?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    externalAdjustmentAmount?: InputMaybe<SortOrder>;
    externalPaymentAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientOtherAmount?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrder>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrder>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    primaryContractualAmount?: InputMaybe<SortOrder>;
    primaryCopayAmount?: InputMaybe<SortOrder>;
    primaryDeductibleAmount?: InputMaybe<SortOrder>;
    primaryOtherAmount?: InputMaybe<SortOrder>;
    primaryPayerOutstanding?: InputMaybe<SortOrder>;
    primaryPayerPayment?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    secondaryContractualAmount?: InputMaybe<SortOrder>;
    secondaryCopayAmount?: InputMaybe<SortOrder>;
    secondaryDeductibleAmount?: InputMaybe<SortOrder>;
    secondaryOtherAmount?: InputMaybe<SortOrder>;
    secondaryPayerOutstanding?: InputMaybe<SortOrder>;
    secondaryPayerPayment?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineAuditLogUpdateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    allowable?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    artClaimCptLineId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    artClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    billedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    displacedSuperscriptAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrCollectionsBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    externalAdjustmentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    externalPaymentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineAuditLogUpdatehighConfidenceBoughtTreatmentIdsInput>;
    isClosedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isDenied?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isFullyCovered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isOutOfNetwork?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isSelfPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noShowFeeFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    patientClaimStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogUpdatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientResponsibilityOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCoinsuranceAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCoinsurancePercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryContractualAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCopayAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryDeductibleAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerPayment?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogUpdateprimaryRemarkCodesInput>;
    procedureCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    procedureDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    secondaryCoinsuranceAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryCoinsurancePercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryContractualAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryCopayAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryDeductibleAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerPayment?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogUpdatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    unusualChargeFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ArtClaimCptLineAuditLogUpdateManyMutationInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    allowable?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    artClaimCptLineId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    artClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    billedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    displacedSuperscriptAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrCollectionsBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    externalAdjustmentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    externalPaymentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineAuditLogUpdatehighConfidenceBoughtTreatmentIdsInput>;
    isClosedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isDenied?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isFullyCovered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isOutOfNetwork?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isSelfPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noShowFeeFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    patientClaimStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogUpdatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientResponsibilityOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCoinsuranceAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCoinsurancePercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryContractualAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCopayAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryDeductibleAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerPayment?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogUpdateprimaryRemarkCodesInput>;
    procedureCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    procedureDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    secondaryCoinsuranceAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryCoinsurancePercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryContractualAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryCopayAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryDeductibleAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerPayment?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineAuditLogUpdatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    unusualChargeFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ArtClaimCptLineAuditLogUpdatehighConfidenceBoughtTreatmentIdsInput =
    {
        push?: InputMaybe<Array<Scalars['String']['input']>>;
        set?: InputMaybe<Array<Scalars['String']['input']>>;
    };

export type ArtClaimCptLineAuditLogUpdatepatientRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimCptLineAuditLogUpdateprimaryRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimCptLineAuditLogUpdatesecondaryRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimCptLineAuditLogWhereInput = {
    AND?: InputMaybe<Array<ArtClaimCptLineAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<ArtClaimCptLineAuditLogWhereInput>>;
    OR?: InputMaybe<Array<ArtClaimCptLineAuditLogWhereInput>>;
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<FloatNullableFilter>;
    allowable?: InputMaybe<FloatNullableFilter>;
    artClaimCptLineId?: InputMaybe<UuidNullableFilter>;
    artClaimId?: InputMaybe<UuidNullableFilter>;
    billedAmount?: InputMaybe<FloatNullableFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dateOfService?: InputMaybe<DateTimeNullableFilter>;
    displacedSuperscriptAmount?: InputMaybe<FloatNullableFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableFilter>;
    externalAdjustmentAmount?: InputMaybe<FloatNullableFilter>;
    externalPaymentAmount?: InputMaybe<FloatNullableFilter>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntFilter>;
    isClosedOut?: InputMaybe<BoolNullableFilter>;
    isDenied?: InputMaybe<BoolNullableFilter>;
    isFullyCovered?: InputMaybe<BoolNullableFilter>;
    isOutOfNetwork?: InputMaybe<BoolNullableFilter>;
    isSelfPay?: InputMaybe<BoolNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    noShowFeeFlag?: InputMaybe<BoolNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    patientClaimStatus?: InputMaybe<StringNullableFilter>;
    patientOtherAmount?: InputMaybe<FloatNullableFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientResponsibilityOriginal?: InputMaybe<FloatNullableFilter>;
    patientResponsibilityOutstanding?: InputMaybe<FloatNullableFilter>;
    primaryCoinsuranceAmount?: InputMaybe<FloatNullableFilter>;
    primaryCoinsurancePercentage?: InputMaybe<FloatNullableFilter>;
    primaryContractualAmount?: InputMaybe<FloatNullableFilter>;
    primaryCopayAmount?: InputMaybe<FloatNullableFilter>;
    primaryDeductibleAmount?: InputMaybe<FloatNullableFilter>;
    primaryOtherAmount?: InputMaybe<FloatNullableFilter>;
    primaryPayerOutstanding?: InputMaybe<FloatNullableFilter>;
    primaryPayerPayment?: InputMaybe<FloatNullableFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCode?: InputMaybe<StringNullableFilter>;
    procedureDescription?: InputMaybe<StringNullableFilter>;
    quantity?: InputMaybe<IntNullableFilter>;
    secondaryCoinsuranceAmount?: InputMaybe<FloatNullableFilter>;
    secondaryCoinsurancePercentage?: InputMaybe<FloatNullableFilter>;
    secondaryContractualAmount?: InputMaybe<FloatNullableFilter>;
    secondaryCopayAmount?: InputMaybe<FloatNullableFilter>;
    secondaryDeductibleAmount?: InputMaybe<FloatNullableFilter>;
    secondaryOtherAmount?: InputMaybe<FloatNullableFilter>;
    secondaryPayerOutstanding?: InputMaybe<FloatNullableFilter>;
    secondaryPayerPayment?: InputMaybe<FloatNullableFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<FloatNullableFilter>;
    unusualChargeFlag?: InputMaybe<BoolNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ArtClaimCptLineAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<ArtClaimCptLineAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<ArtClaimCptLineAuditLogWhereInput>>;
    OR?: InputMaybe<Array<ArtClaimCptLineAuditLogWhereInput>>;
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<FloatNullableFilter>;
    allowable?: InputMaybe<FloatNullableFilter>;
    artClaimCptLineId?: InputMaybe<UuidNullableFilter>;
    artClaimId?: InputMaybe<UuidNullableFilter>;
    billedAmount?: InputMaybe<FloatNullableFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dateOfService?: InputMaybe<DateTimeNullableFilter>;
    displacedSuperscriptAmount?: InputMaybe<FloatNullableFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableFilter>;
    externalAdjustmentAmount?: InputMaybe<FloatNullableFilter>;
    externalPaymentAmount?: InputMaybe<FloatNullableFilter>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isClosedOut?: InputMaybe<BoolNullableFilter>;
    isDenied?: InputMaybe<BoolNullableFilter>;
    isFullyCovered?: InputMaybe<BoolNullableFilter>;
    isOutOfNetwork?: InputMaybe<BoolNullableFilter>;
    isSelfPay?: InputMaybe<BoolNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    noShowFeeFlag?: InputMaybe<BoolNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    patientClaimStatus?: InputMaybe<StringNullableFilter>;
    patientOtherAmount?: InputMaybe<FloatNullableFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientResponsibilityOriginal?: InputMaybe<FloatNullableFilter>;
    patientResponsibilityOutstanding?: InputMaybe<FloatNullableFilter>;
    primaryCoinsuranceAmount?: InputMaybe<FloatNullableFilter>;
    primaryCoinsurancePercentage?: InputMaybe<FloatNullableFilter>;
    primaryContractualAmount?: InputMaybe<FloatNullableFilter>;
    primaryCopayAmount?: InputMaybe<FloatNullableFilter>;
    primaryDeductibleAmount?: InputMaybe<FloatNullableFilter>;
    primaryOtherAmount?: InputMaybe<FloatNullableFilter>;
    primaryPayerOutstanding?: InputMaybe<FloatNullableFilter>;
    primaryPayerPayment?: InputMaybe<FloatNullableFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCode?: InputMaybe<StringNullableFilter>;
    procedureDescription?: InputMaybe<StringNullableFilter>;
    quantity?: InputMaybe<IntNullableFilter>;
    secondaryCoinsuranceAmount?: InputMaybe<FloatNullableFilter>;
    secondaryCoinsurancePercentage?: InputMaybe<FloatNullableFilter>;
    secondaryContractualAmount?: InputMaybe<FloatNullableFilter>;
    secondaryCopayAmount?: InputMaybe<FloatNullableFilter>;
    secondaryDeductibleAmount?: InputMaybe<FloatNullableFilter>;
    secondaryOtherAmount?: InputMaybe<FloatNullableFilter>;
    secondaryPayerOutstanding?: InputMaybe<FloatNullableFilter>;
    secondaryPayerPayment?: InputMaybe<FloatNullableFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<FloatNullableFilter>;
    unusualChargeFlag?: InputMaybe<BoolNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ArtClaimCptLineAvgAggregate = {
    __typename?: 'ArtClaimCptLineAvgAggregate';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    quantity?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
};

export type ArtClaimCptLineAvgOrderByAggregateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrder>;
    allowable?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    externalAdjustmentAmount?: InputMaybe<SortOrder>;
    externalPaymentAmount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientOtherAmount?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrder>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrder>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    primaryContractualAmount?: InputMaybe<SortOrder>;
    primaryCopayAmount?: InputMaybe<SortOrder>;
    primaryDeductibleAmount?: InputMaybe<SortOrder>;
    primaryOtherAmount?: InputMaybe<SortOrder>;
    primaryPayerOutstanding?: InputMaybe<SortOrder>;
    primaryPayerPayment?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    secondaryContractualAmount?: InputMaybe<SortOrder>;
    secondaryCopayAmount?: InputMaybe<SortOrder>;
    secondaryDeductibleAmount?: InputMaybe<SortOrder>;
    secondaryOtherAmount?: InputMaybe<SortOrder>;
    secondaryPayerOutstanding?: InputMaybe<SortOrder>;
    secondaryPayerPayment?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineCountAggregate = {
    __typename?: 'ArtClaimCptLineCountAggregate';
    _all: Scalars['Int']['output'];
    adjudicatedSuperscriptGuaranteeAmount: Scalars['Int']['output'];
    allowable: Scalars['Int']['output'];
    artClaimId: Scalars['Int']['output'];
    billedAmount: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    dateOfService: Scalars['Int']['output'];
    displacedSuperscriptAmount: Scalars['Int']['output'];
    ehrCollectionsBalance: Scalars['Int']['output'];
    externalAdjustmentAmount: Scalars['Int']['output'];
    externalPaymentAmount: Scalars['Int']['output'];
    highConfidenceBoughtTreatmentIds: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isClosedOut: Scalars['Int']['output'];
    isDenied: Scalars['Int']['output'];
    isFullyCovered: Scalars['Int']['output'];
    isOutOfNetwork: Scalars['Int']['output'];
    isSelfPay: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    noShowFeeFlag: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    patientClaimStatus: Scalars['Int']['output'];
    patientOtherAmount: Scalars['Int']['output'];
    patientRemarkCodes: Scalars['Int']['output'];
    patientResponsibilityOriginal: Scalars['Int']['output'];
    patientResponsibilityOutstanding: Scalars['Int']['output'];
    primaryCoinsuranceAmount: Scalars['Int']['output'];
    primaryCoinsurancePercentage: Scalars['Int']['output'];
    primaryContractualAmount: Scalars['Int']['output'];
    primaryCopayAmount: Scalars['Int']['output'];
    primaryDeductibleAmount: Scalars['Int']['output'];
    primaryOtherAmount: Scalars['Int']['output'];
    primaryPayerOutstanding: Scalars['Int']['output'];
    primaryPayerPayment: Scalars['Int']['output'];
    primaryRemarkCodes: Scalars['Int']['output'];
    procedureCode: Scalars['Int']['output'];
    procedureDescription: Scalars['Int']['output'];
    quantity: Scalars['Int']['output'];
    secondaryCoinsuranceAmount: Scalars['Int']['output'];
    secondaryCoinsurancePercentage: Scalars['Int']['output'];
    secondaryContractualAmount: Scalars['Int']['output'];
    secondaryCopayAmount: Scalars['Int']['output'];
    secondaryDeductibleAmount: Scalars['Int']['output'];
    secondaryOtherAmount: Scalars['Int']['output'];
    secondaryPayerOutstanding: Scalars['Int']['output'];
    secondaryPayerPayment: Scalars['Int']['output'];
    secondaryRemarkCodes: Scalars['Int']['output'];
    totalAdjudicatedSuperscriptResponsibility: Scalars['Int']['output'];
    unusualChargeFlag: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    voidedAt: Scalars['Int']['output'];
};

export type ArtClaimCptLineCountOrderByAggregateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrder>;
    allowable?: InputMaybe<SortOrder>;
    artClaimId?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    externalAdjustmentAmount?: InputMaybe<SortOrder>;
    externalPaymentAmount?: InputMaybe<SortOrder>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isClosedOut?: InputMaybe<SortOrder>;
    isDenied?: InputMaybe<SortOrder>;
    isFullyCovered?: InputMaybe<SortOrder>;
    isOutOfNetwork?: InputMaybe<SortOrder>;
    isSelfPay?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    noShowFeeFlag?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientClaimStatus?: InputMaybe<SortOrder>;
    patientOtherAmount?: InputMaybe<SortOrder>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrder>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrder>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    primaryContractualAmount?: InputMaybe<SortOrder>;
    primaryCopayAmount?: InputMaybe<SortOrder>;
    primaryDeductibleAmount?: InputMaybe<SortOrder>;
    primaryOtherAmount?: InputMaybe<SortOrder>;
    primaryPayerOutstanding?: InputMaybe<SortOrder>;
    primaryPayerPayment?: InputMaybe<SortOrder>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    procedureDescription?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    secondaryContractualAmount?: InputMaybe<SortOrder>;
    secondaryCopayAmount?: InputMaybe<SortOrder>;
    secondaryDeductibleAmount?: InputMaybe<SortOrder>;
    secondaryOtherAmount?: InputMaybe<SortOrder>;
    secondaryPayerOutstanding?: InputMaybe<SortOrder>;
    secondaryPayerPayment?: InputMaybe<SortOrder>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrder>;
    unusualChargeFlag?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineCreateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<
        Scalars['Float']['input']
    >;
    allowable?: InputMaybe<Scalars['Float']['input']>;
    artClaim: ArtClaimCreateNestedOneWithoutCptLinesInput;
    billedAmount?: InputMaybe<Scalars['Float']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService: Scalars['DateTimeISO']['input'];
    displacedSuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    externalAdjustmentAmount?: InputMaybe<Scalars['Float']['input']>;
    externalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineCreatehighConfidenceBoughtTreatmentIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    isClosedOut?: InputMaybe<Scalars['Boolean']['input']>;
    isDenied?: InputMaybe<Scalars['Boolean']['input']>;
    isFullyCovered?: InputMaybe<Scalars['Boolean']['input']>;
    isOutOfNetwork?: InputMaybe<Scalars['Boolean']['input']>;
    isSelfPay?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    noShowFeeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    patientClaimStatus?: InputMaybe<Scalars['String']['input']>;
    patientOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineCreatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<Scalars['Float']['input']>;
    patientResponsibilityOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    primaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineCreateprimaryRemarkCodesInput>;
    procedureCode: Scalars['String']['input'];
    procedureDescription?: InputMaybe<Scalars['String']['input']>;
    quantity?: InputMaybe<Scalars['Int']['input']>;
    secondaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    secondaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineCreatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<
        Scalars['Float']['input']
    >;
    unusualChargeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtClaimCptLineCreateManyArtClaimInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<
        Scalars['Float']['input']
    >;
    allowable?: InputMaybe<Scalars['Float']['input']>;
    billedAmount?: InputMaybe<Scalars['Float']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService: Scalars['DateTimeISO']['input'];
    displacedSuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    externalAdjustmentAmount?: InputMaybe<Scalars['Float']['input']>;
    externalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineCreatehighConfidenceBoughtTreatmentIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    isClosedOut?: InputMaybe<Scalars['Boolean']['input']>;
    isDenied?: InputMaybe<Scalars['Boolean']['input']>;
    isFullyCovered?: InputMaybe<Scalars['Boolean']['input']>;
    isOutOfNetwork?: InputMaybe<Scalars['Boolean']['input']>;
    isSelfPay?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    noShowFeeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    patientClaimStatus?: InputMaybe<Scalars['String']['input']>;
    patientOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineCreatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<Scalars['Float']['input']>;
    patientResponsibilityOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    primaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineCreateprimaryRemarkCodesInput>;
    procedureCode: Scalars['String']['input'];
    procedureDescription?: InputMaybe<Scalars['String']['input']>;
    quantity?: InputMaybe<Scalars['Int']['input']>;
    secondaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    secondaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineCreatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<
        Scalars['Float']['input']
    >;
    unusualChargeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtClaimCptLineCreateManyArtClaimInputEnvelope = {
    data: Array<ArtClaimCptLineCreateManyArtClaimInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArtClaimCptLineCreateManyInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<
        Scalars['Float']['input']
    >;
    allowable?: InputMaybe<Scalars['Float']['input']>;
    artClaimId: Scalars['String']['input'];
    billedAmount?: InputMaybe<Scalars['Float']['input']>;
    claimId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService: Scalars['DateTimeISO']['input'];
    displacedSuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    externalAdjustmentAmount?: InputMaybe<Scalars['Float']['input']>;
    externalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineCreatehighConfidenceBoughtTreatmentIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    isClosedOut?: InputMaybe<Scalars['Boolean']['input']>;
    isDenied?: InputMaybe<Scalars['Boolean']['input']>;
    isFullyCovered?: InputMaybe<Scalars['Boolean']['input']>;
    isOutOfNetwork?: InputMaybe<Scalars['Boolean']['input']>;
    isSelfPay?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    noShowFeeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    orgId: Scalars['Int']['input'];
    patientClaimStatus?: InputMaybe<Scalars['String']['input']>;
    patientOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineCreatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<Scalars['Float']['input']>;
    patientResponsibilityOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    primaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineCreateprimaryRemarkCodesInput>;
    procedureCode: Scalars['String']['input'];
    procedureDescription?: InputMaybe<Scalars['String']['input']>;
    quantity?: InputMaybe<Scalars['Int']['input']>;
    secondaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    secondaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineCreatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<
        Scalars['Float']['input']
    >;
    unusualChargeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtClaimCptLineCreateNestedManyWithoutArtClaimInput = {
    connect?: InputMaybe<Array<ArtClaimCptLineWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ArtClaimCptLineCreateOrConnectWithoutArtClaimInput>
    >;
    create?: InputMaybe<Array<ArtClaimCptLineCreateWithoutArtClaimInput>>;
    createMany?: InputMaybe<ArtClaimCptLineCreateManyArtClaimInputEnvelope>;
};

export type ArtClaimCptLineCreateOrConnectWithoutArtClaimInput = {
    create: ArtClaimCptLineCreateWithoutArtClaimInput;
    where: ArtClaimCptLineWhereUniqueInput;
};

export type ArtClaimCptLineCreateWithoutArtClaimInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<
        Scalars['Float']['input']
    >;
    allowable?: InputMaybe<Scalars['Float']['input']>;
    billedAmount?: InputMaybe<Scalars['Float']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService: Scalars['DateTimeISO']['input'];
    displacedSuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    externalAdjustmentAmount?: InputMaybe<Scalars['Float']['input']>;
    externalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineCreatehighConfidenceBoughtTreatmentIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    isClosedOut?: InputMaybe<Scalars['Boolean']['input']>;
    isDenied?: InputMaybe<Scalars['Boolean']['input']>;
    isFullyCovered?: InputMaybe<Scalars['Boolean']['input']>;
    isOutOfNetwork?: InputMaybe<Scalars['Boolean']['input']>;
    isSelfPay?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    noShowFeeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    patientClaimStatus?: InputMaybe<Scalars['String']['input']>;
    patientOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineCreatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<Scalars['Float']['input']>;
    patientResponsibilityOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    primaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineCreateprimaryRemarkCodesInput>;
    procedureCode: Scalars['String']['input'];
    procedureDescription?: InputMaybe<Scalars['String']['input']>;
    quantity?: InputMaybe<Scalars['Int']['input']>;
    secondaryCoinsuranceAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCoinsurancePercentage?: InputMaybe<Scalars['Float']['input']>;
    secondaryContractualAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryCopayAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryDeductibleAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryOtherAmount?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerOutstanding?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPayment?: InputMaybe<Scalars['Float']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineCreatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<
        Scalars['Float']['input']
    >;
    unusualChargeFlag?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtClaimCptLineCreatehighConfidenceBoughtTreatmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCptLineCreatepatientRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCptLineCreateprimaryRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCptLineCreatesecondaryRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCptLineGroupBy = {
    __typename?: 'ArtClaimCptLineGroupBy';
    _avg?: Maybe<ArtClaimCptLineAvgAggregate>;
    _count?: Maybe<ArtClaimCptLineCountAggregate>;
    _max?: Maybe<ArtClaimCptLineMaxAggregate>;
    _min?: Maybe<ArtClaimCptLineMinAggregate>;
    _sum?: Maybe<ArtClaimCptLineSumAggregate>;
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    artClaimId: Scalars['String']['output'];
    billedAmount?: Maybe<Scalars['Float']['output']>;
    claimId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfService: Scalars['DateTimeISO']['output'];
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    highConfidenceBoughtTreatmentIds?: Maybe<
        Array<Scalars['String']['output']>
    >;
    id: Scalars['String']['output'];
    isClosedOut?: Maybe<Scalars['Boolean']['output']>;
    isDenied?: Maybe<Scalars['Boolean']['output']>;
    isFullyCovered?: Maybe<Scalars['Boolean']['output']>;
    isOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
    isSelfPay?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    noShowFeeFlag?: Maybe<Scalars['Boolean']['output']>;
    orgId: Scalars['Int']['output'];
    patientClaimStatus?: Maybe<Scalars['String']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    primaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    procedureCode: Scalars['String']['output'];
    procedureDescription?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    secondaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
    unusualChargeFlag?: Maybe<Scalars['Boolean']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtClaimCptLineListRelationFilter = {
    every?: InputMaybe<ArtClaimCptLineWhereInput>;
    none?: InputMaybe<ArtClaimCptLineWhereInput>;
    some?: InputMaybe<ArtClaimCptLineWhereInput>;
};

export type ArtClaimCptLineMaxAggregate = {
    __typename?: 'ArtClaimCptLineMaxAggregate';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    artClaimId?: Maybe<Scalars['String']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isClosedOut?: Maybe<Scalars['Boolean']['output']>;
    isDenied?: Maybe<Scalars['Boolean']['output']>;
    isFullyCovered?: Maybe<Scalars['Boolean']['output']>;
    isOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
    isSelfPay?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    noShowFeeFlag?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientClaimStatus?: Maybe<Scalars['String']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    procedureDescription?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
    unusualChargeFlag?: Maybe<Scalars['Boolean']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtClaimCptLineMaxOrderByAggregateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrder>;
    allowable?: InputMaybe<SortOrder>;
    artClaimId?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    externalAdjustmentAmount?: InputMaybe<SortOrder>;
    externalPaymentAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isClosedOut?: InputMaybe<SortOrder>;
    isDenied?: InputMaybe<SortOrder>;
    isFullyCovered?: InputMaybe<SortOrder>;
    isOutOfNetwork?: InputMaybe<SortOrder>;
    isSelfPay?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    noShowFeeFlag?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientClaimStatus?: InputMaybe<SortOrder>;
    patientOtherAmount?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrder>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrder>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    primaryContractualAmount?: InputMaybe<SortOrder>;
    primaryCopayAmount?: InputMaybe<SortOrder>;
    primaryDeductibleAmount?: InputMaybe<SortOrder>;
    primaryOtherAmount?: InputMaybe<SortOrder>;
    primaryPayerOutstanding?: InputMaybe<SortOrder>;
    primaryPayerPayment?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    procedureDescription?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    secondaryContractualAmount?: InputMaybe<SortOrder>;
    secondaryCopayAmount?: InputMaybe<SortOrder>;
    secondaryDeductibleAmount?: InputMaybe<SortOrder>;
    secondaryOtherAmount?: InputMaybe<SortOrder>;
    secondaryPayerOutstanding?: InputMaybe<SortOrder>;
    secondaryPayerPayment?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrder>;
    unusualChargeFlag?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineMinAggregate = {
    __typename?: 'ArtClaimCptLineMinAggregate';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    artClaimId?: Maybe<Scalars['String']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isClosedOut?: Maybe<Scalars['Boolean']['output']>;
    isDenied?: Maybe<Scalars['Boolean']['output']>;
    isFullyCovered?: Maybe<Scalars['Boolean']['output']>;
    isOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
    isSelfPay?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    noShowFeeFlag?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientClaimStatus?: Maybe<Scalars['String']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    procedureDescription?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
    unusualChargeFlag?: Maybe<Scalars['Boolean']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtClaimCptLineMinOrderByAggregateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrder>;
    allowable?: InputMaybe<SortOrder>;
    artClaimId?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    externalAdjustmentAmount?: InputMaybe<SortOrder>;
    externalPaymentAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isClosedOut?: InputMaybe<SortOrder>;
    isDenied?: InputMaybe<SortOrder>;
    isFullyCovered?: InputMaybe<SortOrder>;
    isOutOfNetwork?: InputMaybe<SortOrder>;
    isSelfPay?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    noShowFeeFlag?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientClaimStatus?: InputMaybe<SortOrder>;
    patientOtherAmount?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrder>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrder>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    primaryContractualAmount?: InputMaybe<SortOrder>;
    primaryCopayAmount?: InputMaybe<SortOrder>;
    primaryDeductibleAmount?: InputMaybe<SortOrder>;
    primaryOtherAmount?: InputMaybe<SortOrder>;
    primaryPayerOutstanding?: InputMaybe<SortOrder>;
    primaryPayerPayment?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    procedureDescription?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    secondaryContractualAmount?: InputMaybe<SortOrder>;
    secondaryCopayAmount?: InputMaybe<SortOrder>;
    secondaryDeductibleAmount?: InputMaybe<SortOrder>;
    secondaryOtherAmount?: InputMaybe<SortOrder>;
    secondaryPayerOutstanding?: InputMaybe<SortOrder>;
    secondaryPayerPayment?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrder>;
    unusualChargeFlag?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineOrderByWithAggregationInput = {
    _avg?: InputMaybe<ArtClaimCptLineAvgOrderByAggregateInput>;
    _count?: InputMaybe<ArtClaimCptLineCountOrderByAggregateInput>;
    _max?: InputMaybe<ArtClaimCptLineMaxOrderByAggregateInput>;
    _min?: InputMaybe<ArtClaimCptLineMinOrderByAggregateInput>;
    _sum?: InputMaybe<ArtClaimCptLineSumOrderByAggregateInput>;
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrderInput>;
    allowable?: InputMaybe<SortOrderInput>;
    artClaimId?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrderInput>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrderInput>;
    ehrCollectionsBalance?: InputMaybe<SortOrderInput>;
    externalAdjustmentAmount?: InputMaybe<SortOrderInput>;
    externalPaymentAmount?: InputMaybe<SortOrderInput>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isClosedOut?: InputMaybe<SortOrderInput>;
    isDenied?: InputMaybe<SortOrderInput>;
    isFullyCovered?: InputMaybe<SortOrderInput>;
    isOutOfNetwork?: InputMaybe<SortOrderInput>;
    isSelfPay?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    noShowFeeFlag?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    patientClaimStatus?: InputMaybe<SortOrderInput>;
    patientOtherAmount?: InputMaybe<SortOrderInput>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrderInput>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrderInput>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrderInput>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    primaryContractualAmount?: InputMaybe<SortOrderInput>;
    primaryCopayAmount?: InputMaybe<SortOrderInput>;
    primaryDeductibleAmount?: InputMaybe<SortOrderInput>;
    primaryOtherAmount?: InputMaybe<SortOrderInput>;
    primaryPayerOutstanding?: InputMaybe<SortOrderInput>;
    primaryPayerPayment?: InputMaybe<SortOrderInput>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    procedureDescription?: InputMaybe<SortOrderInput>;
    quantity?: InputMaybe<SortOrderInput>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrderInput>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    secondaryContractualAmount?: InputMaybe<SortOrderInput>;
    secondaryCopayAmount?: InputMaybe<SortOrderInput>;
    secondaryDeductibleAmount?: InputMaybe<SortOrderInput>;
    secondaryOtherAmount?: InputMaybe<SortOrderInput>;
    secondaryPayerOutstanding?: InputMaybe<SortOrderInput>;
    secondaryPayerPayment?: InputMaybe<SortOrderInput>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrderInput>;
    unusualChargeFlag?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export type ArtClaimCptLineOrderByWithRelationInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrderInput>;
    allowable?: InputMaybe<SortOrderInput>;
    artClaim?: InputMaybe<ArtClaimOrderByWithRelationInput>;
    artClaimId?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrderInput>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrderInput>;
    ehrCollectionsBalance?: InputMaybe<SortOrderInput>;
    externalAdjustmentAmount?: InputMaybe<SortOrderInput>;
    externalPaymentAmount?: InputMaybe<SortOrderInput>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isClosedOut?: InputMaybe<SortOrderInput>;
    isDenied?: InputMaybe<SortOrderInput>;
    isFullyCovered?: InputMaybe<SortOrderInput>;
    isOutOfNetwork?: InputMaybe<SortOrderInput>;
    isSelfPay?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    noShowFeeFlag?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    patientClaimStatus?: InputMaybe<SortOrderInput>;
    patientOtherAmount?: InputMaybe<SortOrderInput>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrderInput>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrderInput>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrderInput>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    primaryContractualAmount?: InputMaybe<SortOrderInput>;
    primaryCopayAmount?: InputMaybe<SortOrderInput>;
    primaryDeductibleAmount?: InputMaybe<SortOrderInput>;
    primaryOtherAmount?: InputMaybe<SortOrderInput>;
    primaryPayerOutstanding?: InputMaybe<SortOrderInput>;
    primaryPayerPayment?: InputMaybe<SortOrderInput>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    procedureDescription?: InputMaybe<SortOrderInput>;
    quantity?: InputMaybe<SortOrderInput>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrderInput>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    secondaryContractualAmount?: InputMaybe<SortOrderInput>;
    secondaryCopayAmount?: InputMaybe<SortOrderInput>;
    secondaryDeductibleAmount?: InputMaybe<SortOrderInput>;
    secondaryOtherAmount?: InputMaybe<SortOrderInput>;
    secondaryPayerOutstanding?: InputMaybe<SortOrderInput>;
    secondaryPayerPayment?: InputMaybe<SortOrderInput>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrderInput>;
    unusualChargeFlag?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export enum ArtClaimCptLineScalarFieldEnum {
    AdjudicatedSuperscriptGuaranteeAmount = 'adjudicatedSuperscriptGuaranteeAmount',
    Allowable = 'allowable',
    ArtClaimId = 'artClaimId',
    BilledAmount = 'billedAmount',
    ClaimId = 'claimId',
    CreatedAt = 'createdAt',
    DateOfService = 'dateOfService',
    DisplacedSuperscriptAmount = 'displacedSuperscriptAmount',
    EhrCollectionsBalance = 'ehrCollectionsBalance',
    ExternalAdjustmentAmount = 'externalAdjustmentAmount',
    ExternalPaymentAmount = 'externalPaymentAmount',
    HighConfidenceBoughtTreatmentIds = 'highConfidenceBoughtTreatmentIds',
    Id = 'id',
    IsClosedOut = 'isClosedOut',
    IsDenied = 'isDenied',
    IsFullyCovered = 'isFullyCovered',
    IsOutOfNetwork = 'isOutOfNetwork',
    IsSelfPay = 'isSelfPay',
    LastUpdatedBy = 'lastUpdatedBy',
    NoShowFeeFlag = 'noShowFeeFlag',
    OrgId = 'orgId',
    PatientClaimStatus = 'patientClaimStatus',
    PatientOtherAmount = 'patientOtherAmount',
    PatientRemarkCodes = 'patientRemarkCodes',
    PatientResponsibilityOriginal = 'patientResponsibilityOriginal',
    PatientResponsibilityOutstanding = 'patientResponsibilityOutstanding',
    PrimaryCoinsuranceAmount = 'primaryCoinsuranceAmount',
    PrimaryCoinsurancePercentage = 'primaryCoinsurancePercentage',
    PrimaryContractualAmount = 'primaryContractualAmount',
    PrimaryCopayAmount = 'primaryCopayAmount',
    PrimaryDeductibleAmount = 'primaryDeductibleAmount',
    PrimaryOtherAmount = 'primaryOtherAmount',
    PrimaryPayerOutstanding = 'primaryPayerOutstanding',
    PrimaryPayerPayment = 'primaryPayerPayment',
    PrimaryRemarkCodes = 'primaryRemarkCodes',
    ProcedureCode = 'procedureCode',
    ProcedureDescription = 'procedureDescription',
    Quantity = 'quantity',
    SecondaryCoinsuranceAmount = 'secondaryCoinsuranceAmount',
    SecondaryCoinsurancePercentage = 'secondaryCoinsurancePercentage',
    SecondaryContractualAmount = 'secondaryContractualAmount',
    SecondaryCopayAmount = 'secondaryCopayAmount',
    SecondaryDeductibleAmount = 'secondaryDeductibleAmount',
    SecondaryOtherAmount = 'secondaryOtherAmount',
    SecondaryPayerOutstanding = 'secondaryPayerOutstanding',
    SecondaryPayerPayment = 'secondaryPayerPayment',
    SecondaryRemarkCodes = 'secondaryRemarkCodes',
    TotalAdjudicatedSuperscriptResponsibility = 'totalAdjudicatedSuperscriptResponsibility',
    UnusualChargeFlag = 'unusualChargeFlag',
    UpdatedAt = 'updatedAt',
    VoidedAt = 'voidedAt',
}

export type ArtClaimCptLineScalarWhereInput = {
    AND?: InputMaybe<Array<ArtClaimCptLineScalarWhereInput>>;
    NOT?: InputMaybe<Array<ArtClaimCptLineScalarWhereInput>>;
    OR?: InputMaybe<Array<ArtClaimCptLineScalarWhereInput>>;
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<FloatNullableFilter>;
    allowable?: InputMaybe<FloatNullableFilter>;
    artClaimId?: InputMaybe<UuidFilter>;
    billedAmount?: InputMaybe<FloatNullableFilter>;
    claimId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dateOfService?: InputMaybe<DateTimeFilter>;
    displacedSuperscriptAmount?: InputMaybe<FloatNullableFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableFilter>;
    externalAdjustmentAmount?: InputMaybe<FloatNullableFilter>;
    externalPaymentAmount?: InputMaybe<FloatNullableFilter>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<UuidFilter>;
    isClosedOut?: InputMaybe<BoolNullableFilter>;
    isDenied?: InputMaybe<BoolNullableFilter>;
    isFullyCovered?: InputMaybe<BoolNullableFilter>;
    isOutOfNetwork?: InputMaybe<BoolNullableFilter>;
    isSelfPay?: InputMaybe<BoolNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    noShowFeeFlag?: InputMaybe<BoolNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    patientClaimStatus?: InputMaybe<StringNullableFilter>;
    patientOtherAmount?: InputMaybe<FloatNullableFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientResponsibilityOriginal?: InputMaybe<FloatNullableFilter>;
    patientResponsibilityOutstanding?: InputMaybe<FloatNullableFilter>;
    primaryCoinsuranceAmount?: InputMaybe<FloatNullableFilter>;
    primaryCoinsurancePercentage?: InputMaybe<FloatNullableFilter>;
    primaryContractualAmount?: InputMaybe<FloatNullableFilter>;
    primaryCopayAmount?: InputMaybe<FloatNullableFilter>;
    primaryDeductibleAmount?: InputMaybe<FloatNullableFilter>;
    primaryOtherAmount?: InputMaybe<FloatNullableFilter>;
    primaryPayerOutstanding?: InputMaybe<FloatNullableFilter>;
    primaryPayerPayment?: InputMaybe<FloatNullableFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCode?: InputMaybe<StringFilter>;
    procedureDescription?: InputMaybe<StringNullableFilter>;
    quantity?: InputMaybe<IntNullableFilter>;
    secondaryCoinsuranceAmount?: InputMaybe<FloatNullableFilter>;
    secondaryCoinsurancePercentage?: InputMaybe<FloatNullableFilter>;
    secondaryContractualAmount?: InputMaybe<FloatNullableFilter>;
    secondaryCopayAmount?: InputMaybe<FloatNullableFilter>;
    secondaryDeductibleAmount?: InputMaybe<FloatNullableFilter>;
    secondaryOtherAmount?: InputMaybe<FloatNullableFilter>;
    secondaryPayerOutstanding?: InputMaybe<FloatNullableFilter>;
    secondaryPayerPayment?: InputMaybe<FloatNullableFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<FloatNullableFilter>;
    unusualChargeFlag?: InputMaybe<BoolNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ArtClaimCptLineScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ArtClaimCptLineScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ArtClaimCptLineScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ArtClaimCptLineScalarWhereWithAggregatesInput>>;
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    allowable?: InputMaybe<FloatNullableWithAggregatesFilter>;
    artClaimId?: InputMaybe<UuidWithAggregatesFilter>;
    billedAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    claimId?: InputMaybe<StringWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    dateOfService?: InputMaybe<DateTimeWithAggregatesFilter>;
    displacedSuperscriptAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    externalAdjustmentAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    externalPaymentAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    isClosedOut?: InputMaybe<BoolNullableWithAggregatesFilter>;
    isDenied?: InputMaybe<BoolNullableWithAggregatesFilter>;
    isFullyCovered?: InputMaybe<BoolNullableWithAggregatesFilter>;
    isOutOfNetwork?: InputMaybe<BoolNullableWithAggregatesFilter>;
    isSelfPay?: InputMaybe<BoolNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    noShowFeeFlag?: InputMaybe<BoolNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    patientClaimStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    patientOtherAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientResponsibilityOriginal?: InputMaybe<FloatNullableWithAggregatesFilter>;
    patientResponsibilityOutstanding?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryCoinsuranceAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryCoinsurancePercentage?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryContractualAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryCopayAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryDeductibleAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryOtherAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryPayerOutstanding?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryPayerPayment?: InputMaybe<FloatNullableWithAggregatesFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCode?: InputMaybe<StringWithAggregatesFilter>;
    procedureDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
    quantity?: InputMaybe<IntNullableWithAggregatesFilter>;
    secondaryCoinsuranceAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryCoinsurancePercentage?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryContractualAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryCopayAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryDeductibleAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryOtherAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryPayerOutstanding?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryPayerPayment?: InputMaybe<FloatNullableWithAggregatesFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<FloatNullableWithAggregatesFilter>;
    unusualChargeFlag?: InputMaybe<BoolNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    voidedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type ArtClaimCptLineSumAggregate = {
    __typename?: 'ArtClaimCptLineSumAggregate';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
};

export type ArtClaimCptLineSumOrderByAggregateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<SortOrder>;
    allowable?: InputMaybe<SortOrder>;
    billedAmount?: InputMaybe<SortOrder>;
    displacedSuperscriptAmount?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    externalAdjustmentAmount?: InputMaybe<SortOrder>;
    externalPaymentAmount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientOtherAmount?: InputMaybe<SortOrder>;
    patientResponsibilityOriginal?: InputMaybe<SortOrder>;
    patientResponsibilityOutstanding?: InputMaybe<SortOrder>;
    primaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    primaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    primaryContractualAmount?: InputMaybe<SortOrder>;
    primaryCopayAmount?: InputMaybe<SortOrder>;
    primaryDeductibleAmount?: InputMaybe<SortOrder>;
    primaryOtherAmount?: InputMaybe<SortOrder>;
    primaryPayerOutstanding?: InputMaybe<SortOrder>;
    primaryPayerPayment?: InputMaybe<SortOrder>;
    quantity?: InputMaybe<SortOrder>;
    secondaryCoinsuranceAmount?: InputMaybe<SortOrder>;
    secondaryCoinsurancePercentage?: InputMaybe<SortOrder>;
    secondaryContractualAmount?: InputMaybe<SortOrder>;
    secondaryCopayAmount?: InputMaybe<SortOrder>;
    secondaryDeductibleAmount?: InputMaybe<SortOrder>;
    secondaryOtherAmount?: InputMaybe<SortOrder>;
    secondaryPayerOutstanding?: InputMaybe<SortOrder>;
    secondaryPayerPayment?: InputMaybe<SortOrder>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<SortOrder>;
};

export type ArtClaimCptLineUpdateInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    allowable?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    artClaim?: InputMaybe<ArtClaimUpdateOneRequiredWithoutCptLinesNestedInput>;
    billedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    displacedSuperscriptAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrCollectionsBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    externalAdjustmentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    externalPaymentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineUpdatehighConfidenceBoughtTreatmentIdsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isClosedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isDenied?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isFullyCovered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isOutOfNetwork?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isSelfPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noShowFeeFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    patientClaimStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineUpdatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientResponsibilityOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCoinsuranceAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCoinsurancePercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryContractualAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCopayAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryDeductibleAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerPayment?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineUpdateprimaryRemarkCodesInput>;
    procedureCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    procedureDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    secondaryCoinsuranceAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryCoinsurancePercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryContractualAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryCopayAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryDeductibleAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerPayment?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineUpdatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    unusualChargeFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ArtClaimCptLineUpdateManyMutationInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    allowable?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    billedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    displacedSuperscriptAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrCollectionsBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    externalAdjustmentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    externalPaymentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineUpdatehighConfidenceBoughtTreatmentIdsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isClosedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isDenied?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isFullyCovered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isOutOfNetwork?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isSelfPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noShowFeeFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    patientClaimStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineUpdatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientResponsibilityOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCoinsuranceAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCoinsurancePercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryContractualAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCopayAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryDeductibleAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerPayment?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineUpdateprimaryRemarkCodesInput>;
    procedureCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    procedureDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    secondaryCoinsuranceAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryCoinsurancePercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryContractualAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryCopayAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryDeductibleAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerPayment?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineUpdatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    unusualChargeFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ArtClaimCptLineUpdateManyWithWhereWithoutArtClaimInput = {
    data: ArtClaimCptLineUpdateManyMutationInput;
    where: ArtClaimCptLineScalarWhereInput;
};

export type ArtClaimCptLineUpdateManyWithoutArtClaimNestedInput = {
    connect?: InputMaybe<Array<ArtClaimCptLineWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ArtClaimCptLineCreateOrConnectWithoutArtClaimInput>
    >;
    create?: InputMaybe<Array<ArtClaimCptLineCreateWithoutArtClaimInput>>;
    createMany?: InputMaybe<ArtClaimCptLineCreateManyArtClaimInputEnvelope>;
    delete?: InputMaybe<Array<ArtClaimCptLineWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ArtClaimCptLineScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ArtClaimCptLineWhereUniqueInput>>;
    set?: InputMaybe<Array<ArtClaimCptLineWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ArtClaimCptLineUpdateWithWhereUniqueWithoutArtClaimInput>
    >;
    updateMany?: InputMaybe<
        Array<ArtClaimCptLineUpdateManyWithWhereWithoutArtClaimInput>
    >;
    upsert?: InputMaybe<
        Array<ArtClaimCptLineUpsertWithWhereUniqueWithoutArtClaimInput>
    >;
};

export type ArtClaimCptLineUpdateWithWhereUniqueWithoutArtClaimInput = {
    data: ArtClaimCptLineUpdateWithoutArtClaimInput;
    where: ArtClaimCptLineWhereUniqueInput;
};

export type ArtClaimCptLineUpdateWithoutArtClaimInput = {
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    allowable?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    billedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    displacedSuperscriptAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrCollectionsBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    externalAdjustmentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    externalPaymentAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<ArtClaimCptLineUpdatehighConfidenceBoughtTreatmentIdsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isClosedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isDenied?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isFullyCovered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isOutOfNetwork?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    isSelfPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noShowFeeFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    patientClaimStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientRemarkCodes?: InputMaybe<ArtClaimCptLineUpdatepatientRemarkCodesInput>;
    patientResponsibilityOriginal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientResponsibilityOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCoinsuranceAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCoinsurancePercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryContractualAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryCopayAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryDeductibleAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryPayerPayment?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCptLineUpdateprimaryRemarkCodesInput>;
    procedureCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    procedureDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    secondaryCoinsuranceAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryCoinsurancePercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryContractualAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryCopayAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryDeductibleAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryOtherAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerOutstanding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryPayerPayment?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCptLineUpdatesecondaryRemarkCodesInput>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    unusualChargeFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ArtClaimCptLineUpdatehighConfidenceBoughtTreatmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimCptLineUpdatepatientRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimCptLineUpdateprimaryRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimCptLineUpdatesecondaryRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimCptLineUpsertWithWhereUniqueWithoutArtClaimInput = {
    create: ArtClaimCptLineCreateWithoutArtClaimInput;
    update: ArtClaimCptLineUpdateWithoutArtClaimInput;
    where: ArtClaimCptLineWhereUniqueInput;
};

export type ArtClaimCptLineWhereInput = {
    AND?: InputMaybe<Array<ArtClaimCptLineWhereInput>>;
    NOT?: InputMaybe<Array<ArtClaimCptLineWhereInput>>;
    OR?: InputMaybe<Array<ArtClaimCptLineWhereInput>>;
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<FloatNullableFilter>;
    allowable?: InputMaybe<FloatNullableFilter>;
    artClaim?: InputMaybe<ArtClaimRelationFilter>;
    artClaimId?: InputMaybe<UuidFilter>;
    billedAmount?: InputMaybe<FloatNullableFilter>;
    claimId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dateOfService?: InputMaybe<DateTimeFilter>;
    displacedSuperscriptAmount?: InputMaybe<FloatNullableFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableFilter>;
    externalAdjustmentAmount?: InputMaybe<FloatNullableFilter>;
    externalPaymentAmount?: InputMaybe<FloatNullableFilter>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<UuidFilter>;
    isClosedOut?: InputMaybe<BoolNullableFilter>;
    isDenied?: InputMaybe<BoolNullableFilter>;
    isFullyCovered?: InputMaybe<BoolNullableFilter>;
    isOutOfNetwork?: InputMaybe<BoolNullableFilter>;
    isSelfPay?: InputMaybe<BoolNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    noShowFeeFlag?: InputMaybe<BoolNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    patientClaimStatus?: InputMaybe<StringNullableFilter>;
    patientOtherAmount?: InputMaybe<FloatNullableFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientResponsibilityOriginal?: InputMaybe<FloatNullableFilter>;
    patientResponsibilityOutstanding?: InputMaybe<FloatNullableFilter>;
    primaryCoinsuranceAmount?: InputMaybe<FloatNullableFilter>;
    primaryCoinsurancePercentage?: InputMaybe<FloatNullableFilter>;
    primaryContractualAmount?: InputMaybe<FloatNullableFilter>;
    primaryCopayAmount?: InputMaybe<FloatNullableFilter>;
    primaryDeductibleAmount?: InputMaybe<FloatNullableFilter>;
    primaryOtherAmount?: InputMaybe<FloatNullableFilter>;
    primaryPayerOutstanding?: InputMaybe<FloatNullableFilter>;
    primaryPayerPayment?: InputMaybe<FloatNullableFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCode?: InputMaybe<StringFilter>;
    procedureDescription?: InputMaybe<StringNullableFilter>;
    quantity?: InputMaybe<IntNullableFilter>;
    secondaryCoinsuranceAmount?: InputMaybe<FloatNullableFilter>;
    secondaryCoinsurancePercentage?: InputMaybe<FloatNullableFilter>;
    secondaryContractualAmount?: InputMaybe<FloatNullableFilter>;
    secondaryCopayAmount?: InputMaybe<FloatNullableFilter>;
    secondaryDeductibleAmount?: InputMaybe<FloatNullableFilter>;
    secondaryOtherAmount?: InputMaybe<FloatNullableFilter>;
    secondaryPayerOutstanding?: InputMaybe<FloatNullableFilter>;
    secondaryPayerPayment?: InputMaybe<FloatNullableFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<FloatNullableFilter>;
    unusualChargeFlag?: InputMaybe<BoolNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ArtClaimCptLineWhereUniqueInput = {
    AND?: InputMaybe<Array<ArtClaimCptLineWhereInput>>;
    NOT?: InputMaybe<Array<ArtClaimCptLineWhereInput>>;
    OR?: InputMaybe<Array<ArtClaimCptLineWhereInput>>;
    adjudicatedSuperscriptGuaranteeAmount?: InputMaybe<FloatNullableFilter>;
    allowable?: InputMaybe<FloatNullableFilter>;
    artClaim?: InputMaybe<ArtClaimRelationFilter>;
    artClaimId?: InputMaybe<UuidFilter>;
    artClaimId_procedureCode?: InputMaybe<ArtClaimCptLineArtClaimIdProcedureCodeCompoundUniqueInput>;
    billedAmount?: InputMaybe<FloatNullableFilter>;
    claimId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dateOfService?: InputMaybe<DateTimeFilter>;
    displacedSuperscriptAmount?: InputMaybe<FloatNullableFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableFilter>;
    externalAdjustmentAmount?: InputMaybe<FloatNullableFilter>;
    externalPaymentAmount?: InputMaybe<FloatNullableFilter>;
    highConfidenceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    isClosedOut?: InputMaybe<BoolNullableFilter>;
    isDenied?: InputMaybe<BoolNullableFilter>;
    isFullyCovered?: InputMaybe<BoolNullableFilter>;
    isOutOfNetwork?: InputMaybe<BoolNullableFilter>;
    isSelfPay?: InputMaybe<BoolNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    noShowFeeFlag?: InputMaybe<BoolNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    patientClaimStatus?: InputMaybe<StringNullableFilter>;
    patientOtherAmount?: InputMaybe<FloatNullableFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientResponsibilityOriginal?: InputMaybe<FloatNullableFilter>;
    patientResponsibilityOutstanding?: InputMaybe<FloatNullableFilter>;
    primaryCoinsuranceAmount?: InputMaybe<FloatNullableFilter>;
    primaryCoinsurancePercentage?: InputMaybe<FloatNullableFilter>;
    primaryContractualAmount?: InputMaybe<FloatNullableFilter>;
    primaryCopayAmount?: InputMaybe<FloatNullableFilter>;
    primaryDeductibleAmount?: InputMaybe<FloatNullableFilter>;
    primaryOtherAmount?: InputMaybe<FloatNullableFilter>;
    primaryPayerOutstanding?: InputMaybe<FloatNullableFilter>;
    primaryPayerPayment?: InputMaybe<FloatNullableFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCode?: InputMaybe<StringFilter>;
    procedureDescription?: InputMaybe<StringNullableFilter>;
    quantity?: InputMaybe<IntNullableFilter>;
    secondaryCoinsuranceAmount?: InputMaybe<FloatNullableFilter>;
    secondaryCoinsurancePercentage?: InputMaybe<FloatNullableFilter>;
    secondaryContractualAmount?: InputMaybe<FloatNullableFilter>;
    secondaryCopayAmount?: InputMaybe<FloatNullableFilter>;
    secondaryDeductibleAmount?: InputMaybe<FloatNullableFilter>;
    secondaryOtherAmount?: InputMaybe<FloatNullableFilter>;
    secondaryPayerOutstanding?: InputMaybe<FloatNullableFilter>;
    secondaryPayerPayment?: InputMaybe<FloatNullableFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    totalAdjudicatedSuperscriptResponsibility?: InputMaybe<FloatNullableFilter>;
    unusualChargeFlag?: InputMaybe<BoolNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ArtClaimCreateInput = {
    artNotes?: InputMaybe<ArtClaimCreateartNotesInput>;
    claimId: Scalars['String']['input'];
    claimLastUpdated?: InputMaybe<Scalars['DateTimeISO']['input']>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    cptLines?: InputMaybe<ArtClaimCptLineCreateNestedManyWithoutArtClaimInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfRecentTransfer?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService: Scalars['DateTimeISO']['input'];
    departmentId?: InputMaybe<Scalars['String']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    ehrPatientBalance?: InputMaybe<Scalars['Float']['input']>;
    firstCommunicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    inboundSourceId?: InputMaybe<Scalars['String']['input']>;
    lastCommunicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    manualReviewReasons?: InputMaybe<ArtClaimCreatemanualReviewReasonsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<ArtClaimCreatenotesInput>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    originalPatientBalance?: InputMaybe<Scalars['Float']['input']>;
    originalPrimaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    originalSecondaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    patientBalance?: InputMaybe<Scalars['Float']['input']>;
    patientEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    patientOrgEhrId?: InputMaybe<Scalars['String']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimCreatepatientRemarkCodesInput>;
    patientStatus?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    primaryPayer?: InputMaybe<Scalars['String']['input']>;
    primaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    primaryPayerStatus?: InputMaybe<Scalars['String']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCreateprimaryRemarkCodesInput>;
    procedureCodes?: InputMaybe<ArtClaimCreateprocedureCodesInput>;
    reviewNotes?: InputMaybe<Scalars['String']['input']>;
    secondaryPayer?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerStatus?: InputMaybe<Scalars['String']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCreatesecondaryRemarkCodesInput>;
    slotIds?: InputMaybe<ArtClaimCreateslotIdsInput>;
    status?: InputMaybe<ArtClaimStatusEnum>;
    statusReason?: InputMaybe<Scalars['String']['input']>;
    totalAdjudicatedResponsibility?: InputMaybe<Scalars['Float']['input']>;
    totalAdjustedOffPlatform?: InputMaybe<Scalars['Float']['input']>;
    totalArtTransferredAmount?: InputMaybe<Scalars['Float']['input']>;
    totalPostedBySuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    totalPostedOffPlatform?: InputMaybe<Scalars['Float']['input']>;
    unscheduledBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visitId?: InputMaybe<Scalars['String']['input']>;
};

export type ArtClaimCreateManyInput = {
    artNotes?: InputMaybe<ArtClaimCreateartNotesInput>;
    claimId: Scalars['String']['input'];
    claimLastUpdated?: InputMaybe<Scalars['DateTimeISO']['input']>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfRecentTransfer?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService: Scalars['DateTimeISO']['input'];
    departmentId?: InputMaybe<Scalars['String']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    ehrPatientBalance?: InputMaybe<Scalars['Float']['input']>;
    firstCommunicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    inboundSourceId?: InputMaybe<Scalars['String']['input']>;
    lastCommunicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    manualReviewReasons?: InputMaybe<ArtClaimCreatemanualReviewReasonsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<ArtClaimCreatenotesInput>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    originalPatientBalance?: InputMaybe<Scalars['Float']['input']>;
    originalPrimaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    originalSecondaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    patientBalance?: InputMaybe<Scalars['Float']['input']>;
    patientEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    patientOrgEhrId?: InputMaybe<Scalars['String']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimCreatepatientRemarkCodesInput>;
    patientStatus?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    primaryPayer?: InputMaybe<Scalars['String']['input']>;
    primaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    primaryPayerStatus?: InputMaybe<Scalars['String']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCreateprimaryRemarkCodesInput>;
    procedureCodes?: InputMaybe<ArtClaimCreateprocedureCodesInput>;
    reviewNotes?: InputMaybe<Scalars['String']['input']>;
    secondaryPayer?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerStatus?: InputMaybe<Scalars['String']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCreatesecondaryRemarkCodesInput>;
    slotIds?: InputMaybe<ArtClaimCreateslotIdsInput>;
    status?: InputMaybe<ArtClaimStatusEnum>;
    statusReason?: InputMaybe<Scalars['String']['input']>;
    totalAdjudicatedResponsibility?: InputMaybe<Scalars['Float']['input']>;
    totalAdjustedOffPlatform?: InputMaybe<Scalars['Float']['input']>;
    totalArtTransferredAmount?: InputMaybe<Scalars['Float']['input']>;
    totalPostedBySuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    totalPostedOffPlatform?: InputMaybe<Scalars['Float']['input']>;
    unscheduledBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visitId?: InputMaybe<Scalars['String']['input']>;
};

export type ArtClaimCreateNestedOneWithoutCptLinesInput = {
    connect?: InputMaybe<ArtClaimWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ArtClaimCreateOrConnectWithoutCptLinesInput>;
    create?: InputMaybe<ArtClaimCreateWithoutCptLinesInput>;
};

export type ArtClaimCreateOrConnectWithoutCptLinesInput = {
    create: ArtClaimCreateWithoutCptLinesInput;
    where: ArtClaimWhereUniqueInput;
};

export type ArtClaimCreateWithoutCptLinesInput = {
    artNotes?: InputMaybe<ArtClaimCreateartNotesInput>;
    claimId: Scalars['String']['input'];
    claimLastUpdated?: InputMaybe<Scalars['DateTimeISO']['input']>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfRecentTransfer?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService: Scalars['DateTimeISO']['input'];
    departmentId?: InputMaybe<Scalars['String']['input']>;
    ehrCollectionsBalance?: InputMaybe<Scalars['Float']['input']>;
    ehrPatientBalance?: InputMaybe<Scalars['Float']['input']>;
    firstCommunicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    inboundSourceId?: InputMaybe<Scalars['String']['input']>;
    lastCommunicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    manualReviewReasons?: InputMaybe<ArtClaimCreatemanualReviewReasonsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<ArtClaimCreatenotesInput>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    originalPatientBalance?: InputMaybe<Scalars['Float']['input']>;
    originalPrimaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    originalSecondaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    patientBalance?: InputMaybe<Scalars['Float']['input']>;
    patientEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    patientOrgEhrId?: InputMaybe<Scalars['String']['input']>;
    patientRemarkCodes?: InputMaybe<ArtClaimCreatepatientRemarkCodesInput>;
    patientStatus?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    primaryPayer?: InputMaybe<Scalars['String']['input']>;
    primaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    primaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    primaryPayerStatus?: InputMaybe<Scalars['String']['input']>;
    primaryRemarkCodes?: InputMaybe<ArtClaimCreateprimaryRemarkCodesInput>;
    procedureCodes?: InputMaybe<ArtClaimCreateprocedureCodesInput>;
    reviewNotes?: InputMaybe<Scalars['String']['input']>;
    secondaryPayer?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerBalance?: InputMaybe<Scalars['Float']['input']>;
    secondaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerStatus?: InputMaybe<Scalars['String']['input']>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimCreatesecondaryRemarkCodesInput>;
    slotIds?: InputMaybe<ArtClaimCreateslotIdsInput>;
    status?: InputMaybe<ArtClaimStatusEnum>;
    statusReason?: InputMaybe<Scalars['String']['input']>;
    totalAdjudicatedResponsibility?: InputMaybe<Scalars['Float']['input']>;
    totalAdjustedOffPlatform?: InputMaybe<Scalars['Float']['input']>;
    totalArtTransferredAmount?: InputMaybe<Scalars['Float']['input']>;
    totalPostedBySuperscriptAmount?: InputMaybe<Scalars['Float']['input']>;
    totalPostedOffPlatform?: InputMaybe<Scalars['Float']['input']>;
    unscheduledBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visitId?: InputMaybe<Scalars['String']['input']>;
};

export type ArtClaimCreateartNotesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCreatemanualReviewReasonsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCreatenotesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCreatepatientRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCreateprimaryRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCreateprocedureCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCreatesecondaryRemarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimCreateslotIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ArtClaimGroupBy = {
    __typename?: 'ArtClaimGroupBy';
    _avg?: Maybe<ArtClaimAvgAggregate>;
    _count?: Maybe<ArtClaimCountAggregate>;
    _max?: Maybe<ArtClaimMaxAggregate>;
    _min?: Maybe<ArtClaimMinAggregate>;
    _sum?: Maybe<ArtClaimSumAggregate>;
    artNotes?: Maybe<Array<Scalars['String']['output']>>;
    claimId: Scalars['String']['output'];
    claimLastUpdated?: Maybe<Scalars['DateTimeISO']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfRecentTransfer?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService: Scalars['DateTimeISO']['output'];
    departmentId?: Maybe<Scalars['String']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    firstCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    inboundSourceId?: Maybe<Scalars['String']['output']>;
    lastCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    manualReviewReasons?: Maybe<Array<Scalars['String']['output']>>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes?: Maybe<Array<Scalars['String']['output']>>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance: Scalars['Float']['output'];
    originalPrimaryPayerBalance: Scalars['Float']['output'];
    originalSecondaryPayerBalance: Scalars['Float']['output'];
    patientBalance: Scalars['Float']['output'];
    patientEnterpriseId?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    patientRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    patientStatus?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerBalance: Scalars['Float']['output'];
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    primaryPayerStatus?: Maybe<Scalars['String']['output']>;
    primaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    procedureCodes?: Maybe<Array<Scalars['String']['output']>>;
    reviewNotes?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerBalance: Scalars['Float']['output'];
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    secondaryPayerStatus?: Maybe<Scalars['String']['output']>;
    secondaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    slotIds?: Maybe<Array<Scalars['String']['output']>>;
    status?: Maybe<ArtClaimStatusEnum>;
    statusReason?: Maybe<Scalars['String']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
    unscheduledBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    visitId?: Maybe<Scalars['String']['output']>;
};

export type ArtClaimIdOrgIdClaimIdCompoundUniqueInput = {
    claimId: Scalars['String']['input'];
    id: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
};

export type ArtClaimMaxAggregate = {
    __typename?: 'ArtClaimMaxAggregate';
    claimId?: Maybe<Scalars['String']['output']>;
    claimLastUpdated?: Maybe<Scalars['DateTimeISO']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfRecentTransfer?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    departmentId?: Maybe<Scalars['String']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    firstCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    inboundSourceId?: Maybe<Scalars['String']['output']>;
    lastCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    patientEnterpriseId?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    patientStatus?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    primaryPayerStatus?: Maybe<Scalars['String']['output']>;
    reviewNotes?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    secondaryPayerStatus?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ArtClaimStatusEnum>;
    statusReason?: Maybe<Scalars['String']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
    unscheduledBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    visitId?: Maybe<Scalars['String']['output']>;
};

export type ArtClaimMaxOrderByAggregateInput = {
    claimId?: InputMaybe<SortOrder>;
    claimLastUpdated?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfRecentTransfer?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    departmentId?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    ehrPatientBalance?: InputMaybe<SortOrder>;
    firstCommunicationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    inboundSourceId?: InputMaybe<SortOrder>;
    lastCommunicationDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    patientEnterpriseId?: InputMaybe<SortOrder>;
    patientOrgEhrId?: InputMaybe<SortOrder>;
    patientStatus?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    primaryPayer?: InputMaybe<SortOrder>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrder>;
    primaryPayerStatus?: InputMaybe<SortOrder>;
    reviewNotes?: InputMaybe<SortOrder>;
    secondaryPayer?: InputMaybe<SortOrder>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrder>;
    secondaryPayerStatus?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrder>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrder>;
    totalArtTransferredAmount?: InputMaybe<SortOrder>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrder>;
    totalPostedOffPlatform?: InputMaybe<SortOrder>;
    unscheduledBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrder>;
};

export type ArtClaimMinAggregate = {
    __typename?: 'ArtClaimMinAggregate';
    claimId?: Maybe<Scalars['String']['output']>;
    claimLastUpdated?: Maybe<Scalars['DateTimeISO']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfRecentTransfer?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    departmentId?: Maybe<Scalars['String']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    firstCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    inboundSourceId?: Maybe<Scalars['String']['output']>;
    lastCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    patientEnterpriseId?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    patientStatus?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    primaryPayerStatus?: Maybe<Scalars['String']['output']>;
    reviewNotes?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    secondaryPayerStatus?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ArtClaimStatusEnum>;
    statusReason?: Maybe<Scalars['String']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
    unscheduledBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    visitId?: Maybe<Scalars['String']['output']>;
};

export type ArtClaimMinOrderByAggregateInput = {
    claimId?: InputMaybe<SortOrder>;
    claimLastUpdated?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfRecentTransfer?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    departmentId?: InputMaybe<SortOrder>;
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    ehrPatientBalance?: InputMaybe<SortOrder>;
    firstCommunicationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    inboundSourceId?: InputMaybe<SortOrder>;
    lastCommunicationDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    patientEnterpriseId?: InputMaybe<SortOrder>;
    patientOrgEhrId?: InputMaybe<SortOrder>;
    patientStatus?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    primaryPayer?: InputMaybe<SortOrder>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrder>;
    primaryPayerStatus?: InputMaybe<SortOrder>;
    reviewNotes?: InputMaybe<SortOrder>;
    secondaryPayer?: InputMaybe<SortOrder>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrder>;
    secondaryPayerStatus?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrder>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrder>;
    totalArtTransferredAmount?: InputMaybe<SortOrder>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrder>;
    totalPostedOffPlatform?: InputMaybe<SortOrder>;
    unscheduledBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrder>;
};

export type ArtClaimOrderByWithAggregationInput = {
    _avg?: InputMaybe<ArtClaimAvgOrderByAggregateInput>;
    _count?: InputMaybe<ArtClaimCountOrderByAggregateInput>;
    _max?: InputMaybe<ArtClaimMaxOrderByAggregateInput>;
    _min?: InputMaybe<ArtClaimMinOrderByAggregateInput>;
    _sum?: InputMaybe<ArtClaimSumOrderByAggregateInput>;
    artNotes?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimLastUpdated?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfRecentTransfer?: InputMaybe<SortOrderInput>;
    dateOfService?: InputMaybe<SortOrder>;
    departmentId?: InputMaybe<SortOrderInput>;
    ehrCollectionsBalance?: InputMaybe<SortOrderInput>;
    ehrPatientBalance?: InputMaybe<SortOrderInput>;
    firstCommunicationDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    inboundSourceId?: InputMaybe<SortOrderInput>;
    lastCommunicationDate?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    manualReviewReasons?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    patientEnterpriseId?: InputMaybe<SortOrderInput>;
    patientOrgEhrId?: InputMaybe<SortOrderInput>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientStatus?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrderInput>;
    primaryPayer?: InputMaybe<SortOrderInput>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrderInput>;
    primaryPayerStatus?: InputMaybe<SortOrderInput>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    reviewNotes?: InputMaybe<SortOrderInput>;
    secondaryPayer?: InputMaybe<SortOrderInput>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrderInput>;
    secondaryPayerStatus?: InputMaybe<SortOrderInput>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    slotIds?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrderInput>;
    statusReason?: InputMaybe<SortOrderInput>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrderInput>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrderInput>;
    totalArtTransferredAmount?: InputMaybe<SortOrderInput>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrderInput>;
    totalPostedOffPlatform?: InputMaybe<SortOrderInput>;
    unscheduledBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrderInput>;
};

export type ArtClaimOrderByWithRelationInput = {
    artNotes?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    claimLastUpdated?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    cptLines?: InputMaybe<ArtClaimCptLineOrderByRelationAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    dateOfRecentTransfer?: InputMaybe<SortOrderInput>;
    dateOfService?: InputMaybe<SortOrder>;
    departmentId?: InputMaybe<SortOrderInput>;
    ehrCollectionsBalance?: InputMaybe<SortOrderInput>;
    ehrPatientBalance?: InputMaybe<SortOrderInput>;
    firstCommunicationDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    inboundSourceId?: InputMaybe<SortOrderInput>;
    lastCommunicationDate?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    manualReviewReasons?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    patientEnterpriseId?: InputMaybe<SortOrderInput>;
    patientOrgEhrId?: InputMaybe<SortOrderInput>;
    patientRemarkCodes?: InputMaybe<SortOrder>;
    patientStatus?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrderInput>;
    primaryPayer?: InputMaybe<SortOrderInput>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrderInput>;
    primaryPayerStatus?: InputMaybe<SortOrderInput>;
    primaryRemarkCodes?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    reviewNotes?: InputMaybe<SortOrderInput>;
    secondaryPayer?: InputMaybe<SortOrderInput>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrderInput>;
    secondaryPayerStatus?: InputMaybe<SortOrderInput>;
    secondaryRemarkCodes?: InputMaybe<SortOrder>;
    slotIds?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrderInput>;
    statusReason?: InputMaybe<SortOrderInput>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrderInput>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrderInput>;
    totalArtTransferredAmount?: InputMaybe<SortOrderInput>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrderInput>;
    totalPostedOffPlatform?: InputMaybe<SortOrderInput>;
    unscheduledBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrderInput>;
};

export type ArtClaimRelationFilter = {
    is?: InputMaybe<ArtClaimWhereInput>;
    isNot?: InputMaybe<ArtClaimWhereInput>;
};

export enum ArtClaimScalarFieldEnum {
    ArtNotes = 'artNotes',
    ClaimId = 'claimId',
    ClaimLastUpdated = 'claimLastUpdated',
    ClaimReturnStatus = 'claimReturnStatus',
    CreatedAt = 'createdAt',
    DateOfRecentTransfer = 'dateOfRecentTransfer',
    DateOfService = 'dateOfService',
    DepartmentId = 'departmentId',
    EhrCollectionsBalance = 'ehrCollectionsBalance',
    EhrPatientBalance = 'ehrPatientBalance',
    FirstCommunicationDate = 'firstCommunicationDate',
    Id = 'id',
    InboundSourceId = 'inboundSourceId',
    LastCommunicationDate = 'lastCommunicationDate',
    LastUpdatedBy = 'lastUpdatedBy',
    ManualReviewReasons = 'manualReviewReasons',
    Metadata = 'metadata',
    Notes = 'notes',
    OrgId = 'orgId',
    OriginalPatientBalance = 'originalPatientBalance',
    OriginalPrimaryPayerBalance = 'originalPrimaryPayerBalance',
    OriginalSecondaryPayerBalance = 'originalSecondaryPayerBalance',
    PatientBalance = 'patientBalance',
    PatientEnterpriseId = 'patientEnterpriseId',
    PatientOrgEhrId = 'patientOrgEhrId',
    PatientRemarkCodes = 'patientRemarkCodes',
    PatientStatus = 'patientStatus',
    PracticeId = 'practiceId',
    PrimaryPayer = 'primaryPayer',
    PrimaryPayerBalance = 'primaryPayerBalance',
    PrimaryPayerPackage = 'primaryPayerPackage',
    PrimaryPayerStatus = 'primaryPayerStatus',
    PrimaryRemarkCodes = 'primaryRemarkCodes',
    ProcedureCodes = 'procedureCodes',
    ReviewNotes = 'reviewNotes',
    SecondaryPayer = 'secondaryPayer',
    SecondaryPayerBalance = 'secondaryPayerBalance',
    SecondaryPayerPackage = 'secondaryPayerPackage',
    SecondaryPayerStatus = 'secondaryPayerStatus',
    SecondaryRemarkCodes = 'secondaryRemarkCodes',
    SlotIds = 'slotIds',
    Status = 'status',
    StatusReason = 'statusReason',
    TotalAdjudicatedResponsibility = 'totalAdjudicatedResponsibility',
    TotalAdjustedOffPlatform = 'totalAdjustedOffPlatform',
    TotalArtTransferredAmount = 'totalArtTransferredAmount',
    TotalPostedBySuperscriptAmount = 'totalPostedBySuperscriptAmount',
    TotalPostedOffPlatform = 'totalPostedOffPlatform',
    UnscheduledBoughtTreatmentId = 'unscheduledBoughtTreatmentId',
    UpdatedAt = 'updatedAt',
    VisitId = 'visitId',
}

export type ArtClaimScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ArtClaimScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ArtClaimScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ArtClaimScalarWhereWithAggregatesInput>>;
    artNotes?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringWithAggregatesFilter>;
    claimLastUpdated?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    dateOfRecentTransfer?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    dateOfService?: InputMaybe<DateTimeWithAggregatesFilter>;
    departmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    ehrPatientBalance?: InputMaybe<FloatNullableWithAggregatesFilter>;
    firstCommunicationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    inboundSourceId?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastCommunicationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    manualReviewReasons?: InputMaybe<StringNullableListFilter>;
    metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableListFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    originalPatientBalance?: InputMaybe<FloatWithAggregatesFilter>;
    originalPrimaryPayerBalance?: InputMaybe<FloatWithAggregatesFilter>;
    originalSecondaryPayerBalance?: InputMaybe<FloatWithAggregatesFilter>;
    patientBalance?: InputMaybe<FloatWithAggregatesFilter>;
    patientEnterpriseId?: InputMaybe<StringNullableWithAggregatesFilter>;
    patientOrgEhrId?: InputMaybe<StringNullableWithAggregatesFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntNullableWithAggregatesFilter>;
    primaryPayer?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryPayerBalance?: InputMaybe<FloatWithAggregatesFilter>;
    primaryPayerPackage?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryPayerStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    reviewNotes?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryPayer?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryPayerBalance?: InputMaybe<FloatWithAggregatesFilter>;
    secondaryPayerPackage?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryPayerStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    slotIds?: InputMaybe<StringNullableListFilter>;
    status?: InputMaybe<EnumArtClaimStatusEnumNullableWithAggregatesFilter>;
    statusReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    totalAdjudicatedResponsibility?: InputMaybe<FloatNullableWithAggregatesFilter>;
    totalAdjustedOffPlatform?: InputMaybe<FloatNullableWithAggregatesFilter>;
    totalArtTransferredAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    totalPostedBySuperscriptAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    totalPostedOffPlatform?: InputMaybe<FloatNullableWithAggregatesFilter>;
    unscheduledBoughtTreatmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    visitId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum ArtClaimStatusEnum {
    Adjusted = 'ADJUSTED',
    Cancelled = 'CANCELLED',
    Closed = 'CLOSED',
    Hold = 'HOLD',
    InProgress = 'IN_PROGRESS',
    ManualReview = 'MANUAL_REVIEW',
    MedicaidHold = 'MEDICAID_HOLD',
    NeedsAdminAdjustment = 'NEEDS_ADMIN_ADJUSTMENT',
    NotCollected = 'NOT_COLLECTED',
    NotLive = 'NOT_LIVE',
    NotRelevant = 'NOT_RELEVANT',
    NoAction = 'NO_ACTION',
    PartiallyCollected = 'PARTIALLY_COLLECTED',
    PartialTransfer = 'PARTIAL_TRANSFER',
    PartialTransferAtns = 'PARTIAL_TRANSFER_ATNS',
    PartialTransferClaimDenial = 'PARTIAL_TRANSFER_CLAIM_DENIAL',
    PartialTransferClaimDenialClericalAdministrative = 'PARTIAL_TRANSFER_CLAIM_DENIAL_CLERICAL_ADMINISTRATIVE',
    PartialTransferClaimDenialCoordinationOfCare = 'PARTIAL_TRANSFER_CLAIM_DENIAL_COORDINATION_OF_CARE',
    PartialTransferClaimDenialOurFault = 'PARTIAL_TRANSFER_CLAIM_DENIAL_OUR_FAULT',
    PartialTransferClaimOon = 'PARTIAL_TRANSFER_CLAIM_OON',
    PartialTransferFullAtnsMismatch = 'PARTIAL_TRANSFER_FULL_ATNS_MISMATCH',
    PartialTransferIncrementalCollection = 'PARTIAL_TRANSFER_INCREMENTAL_COLLECTION',
    PartialTransferInsuranceOverride = 'PARTIAL_TRANSFER_INSURANCE_OVERRIDE',
    PartialTransferSelfpay = 'PARTIAL_TRANSFER_SELFPAY',
    PendingAdmin = 'PENDING_ADMIN',
    RerunNeeded = 'RERUN_NEEDED',
    SelfPay = 'SELF_PAY',
    SelfPayReview = 'SELF_PAY_REVIEW',
    Transferred = 'TRANSFERRED',
    TransferredInsuranceMixed = 'TRANSFERRED_INSURANCE_MIXED',
    TransferredInsuranceOverride = 'TRANSFERRED_INSURANCE_OVERRIDE',
    Unmatched = 'UNMATCHED',
    Voided = 'VOIDED',
}

export type ArtClaimSumAggregate = {
    __typename?: 'ArtClaimSumAggregate';
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
};

export type ArtClaimSumOrderByAggregateInput = {
    ehrCollectionsBalance?: InputMaybe<SortOrder>;
    ehrPatientBalance?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientBalance?: InputMaybe<SortOrder>;
    originalPrimaryPayerBalance?: InputMaybe<SortOrder>;
    originalSecondaryPayerBalance?: InputMaybe<SortOrder>;
    patientBalance?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    primaryPayerBalance?: InputMaybe<SortOrder>;
    secondaryPayerBalance?: InputMaybe<SortOrder>;
    totalAdjudicatedResponsibility?: InputMaybe<SortOrder>;
    totalAdjustedOffPlatform?: InputMaybe<SortOrder>;
    totalArtTransferredAmount?: InputMaybe<SortOrder>;
    totalPostedBySuperscriptAmount?: InputMaybe<SortOrder>;
    totalPostedOffPlatform?: InputMaybe<SortOrder>;
};

export type ArtClaimUpdateInput = {
    artNotes?: InputMaybe<ArtClaimUpdateartNotesInput>;
    claimId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimLastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    cptLines?: InputMaybe<ArtClaimCptLineUpdateManyWithoutArtClaimNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateOfRecentTransfer?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    departmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrCollectionsBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrPatientBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    firstCommunicationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    inboundSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastCommunicationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    manualReviewReasons?: InputMaybe<ArtClaimUpdatemanualReviewReasonsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<ArtClaimUpdatenotesInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    originalPatientBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    originalPrimaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    originalSecondaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    patientBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    patientEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOrgEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientRemarkCodes?: InputMaybe<ArtClaimUpdatepatientRemarkCodesInput>;
    patientStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    primaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    primaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryRemarkCodes?: InputMaybe<ArtClaimUpdateprimaryRemarkCodesInput>;
    procedureCodes?: InputMaybe<ArtClaimUpdateprocedureCodesInput>;
    reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    secondaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimUpdatesecondaryRemarkCodesInput>;
    slotIds?: InputMaybe<ArtClaimUpdateslotIdsInput>;
    status?: InputMaybe<NullableEnumArtClaimStatusEnumFieldUpdateOperationsInput>;
    statusReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    totalAdjudicatedResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalAdjustedOffPlatform?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalArtTransferredAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalPostedBySuperscriptAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalPostedOffPlatform?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    unscheduledBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    visitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArtClaimUpdateManyMutationInput = {
    artNotes?: InputMaybe<ArtClaimUpdateartNotesInput>;
    claimId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimLastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateOfRecentTransfer?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    departmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrCollectionsBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrPatientBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    firstCommunicationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    inboundSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastCommunicationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    manualReviewReasons?: InputMaybe<ArtClaimUpdatemanualReviewReasonsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<ArtClaimUpdatenotesInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    originalPatientBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    originalPrimaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    originalSecondaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    patientBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    patientEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOrgEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientRemarkCodes?: InputMaybe<ArtClaimUpdatepatientRemarkCodesInput>;
    patientStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    primaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    primaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryRemarkCodes?: InputMaybe<ArtClaimUpdateprimaryRemarkCodesInput>;
    procedureCodes?: InputMaybe<ArtClaimUpdateprocedureCodesInput>;
    reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    secondaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimUpdatesecondaryRemarkCodesInput>;
    slotIds?: InputMaybe<ArtClaimUpdateslotIdsInput>;
    status?: InputMaybe<NullableEnumArtClaimStatusEnumFieldUpdateOperationsInput>;
    statusReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    totalAdjudicatedResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalAdjustedOffPlatform?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalArtTransferredAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalPostedBySuperscriptAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalPostedOffPlatform?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    unscheduledBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    visitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArtClaimUpdateOneRequiredWithoutCptLinesNestedInput = {
    connect?: InputMaybe<ArtClaimWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ArtClaimCreateOrConnectWithoutCptLinesInput>;
    create?: InputMaybe<ArtClaimCreateWithoutCptLinesInput>;
    update?: InputMaybe<ArtClaimUpdateToOneWithWhereWithoutCptLinesInput>;
    upsert?: InputMaybe<ArtClaimUpsertWithoutCptLinesInput>;
};

export type ArtClaimUpdateToOneWithWhereWithoutCptLinesInput = {
    data: ArtClaimUpdateWithoutCptLinesInput;
    where?: InputMaybe<ArtClaimWhereInput>;
};

export type ArtClaimUpdateWithoutCptLinesInput = {
    artNotes?: InputMaybe<ArtClaimUpdateartNotesInput>;
    claimId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimLastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateOfRecentTransfer?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    departmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrCollectionsBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    ehrPatientBalance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    firstCommunicationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    inboundSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastCommunicationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    manualReviewReasons?: InputMaybe<ArtClaimUpdatemanualReviewReasonsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    notes?: InputMaybe<ArtClaimUpdatenotesInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    originalPatientBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    originalPrimaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    originalSecondaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    patientBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    patientEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOrgEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientRemarkCodes?: InputMaybe<ArtClaimUpdatepatientRemarkCodesInput>;
    patientStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    primaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    primaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryRemarkCodes?: InputMaybe<ArtClaimUpdateprimaryRemarkCodesInput>;
    procedureCodes?: InputMaybe<ArtClaimUpdateprocedureCodesInput>;
    reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerBalance?: InputMaybe<FloatFieldUpdateOperationsInput>;
    secondaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryRemarkCodes?: InputMaybe<ArtClaimUpdatesecondaryRemarkCodesInput>;
    slotIds?: InputMaybe<ArtClaimUpdateslotIdsInput>;
    status?: InputMaybe<NullableEnumArtClaimStatusEnumFieldUpdateOperationsInput>;
    statusReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    totalAdjudicatedResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalAdjustedOffPlatform?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalArtTransferredAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalPostedBySuperscriptAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    totalPostedOffPlatform?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    unscheduledBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    visitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArtClaimUpdateartNotesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimUpdatemanualReviewReasonsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimUpdatenotesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimUpdatepatientRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimUpdateprimaryRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimUpdateprocedureCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimUpdatesecondaryRemarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimUpdateslotIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArtClaimUpsertWithoutCptLinesInput = {
    create: ArtClaimCreateWithoutCptLinesInput;
    update: ArtClaimUpdateWithoutCptLinesInput;
    where?: InputMaybe<ArtClaimWhereInput>;
};

export type ArtClaimWhereInput = {
    AND?: InputMaybe<Array<ArtClaimWhereInput>>;
    NOT?: InputMaybe<Array<ArtClaimWhereInput>>;
    OR?: InputMaybe<Array<ArtClaimWhereInput>>;
    artNotes?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringFilter>;
    claimLastUpdated?: InputMaybe<DateTimeNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    cptLines?: InputMaybe<ArtClaimCptLineListRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dateOfRecentTransfer?: InputMaybe<DateTimeNullableFilter>;
    dateOfService?: InputMaybe<DateTimeFilter>;
    departmentId?: InputMaybe<StringNullableFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableFilter>;
    ehrPatientBalance?: InputMaybe<FloatNullableFilter>;
    firstCommunicationDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    inboundSourceId?: InputMaybe<StringNullableFilter>;
    lastCommunicationDate?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    manualReviewReasons?: InputMaybe<StringNullableListFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    notes?: InputMaybe<StringNullableListFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    originalPatientBalance?: InputMaybe<FloatFilter>;
    originalPrimaryPayerBalance?: InputMaybe<FloatFilter>;
    originalSecondaryPayerBalance?: InputMaybe<FloatFilter>;
    patientBalance?: InputMaybe<FloatFilter>;
    patientEnterpriseId?: InputMaybe<StringNullableFilter>;
    patientOrgEhrId?: InputMaybe<StringNullableFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientStatus?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    primaryPayer?: InputMaybe<StringNullableFilter>;
    primaryPayerBalance?: InputMaybe<FloatFilter>;
    primaryPayerPackage?: InputMaybe<StringNullableFilter>;
    primaryPayerStatus?: InputMaybe<StringNullableFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    reviewNotes?: InputMaybe<StringNullableFilter>;
    secondaryPayer?: InputMaybe<StringNullableFilter>;
    secondaryPayerBalance?: InputMaybe<FloatFilter>;
    secondaryPayerPackage?: InputMaybe<StringNullableFilter>;
    secondaryPayerStatus?: InputMaybe<StringNullableFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    slotIds?: InputMaybe<StringNullableListFilter>;
    status?: InputMaybe<EnumArtClaimStatusEnumNullableFilter>;
    statusReason?: InputMaybe<StringNullableFilter>;
    totalAdjudicatedResponsibility?: InputMaybe<FloatNullableFilter>;
    totalAdjustedOffPlatform?: InputMaybe<FloatNullableFilter>;
    totalArtTransferredAmount?: InputMaybe<FloatNullableFilter>;
    totalPostedBySuperscriptAmount?: InputMaybe<FloatNullableFilter>;
    totalPostedOffPlatform?: InputMaybe<FloatNullableFilter>;
    unscheduledBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    visitId?: InputMaybe<StringNullableFilter>;
};

export type ArtClaimWhereUniqueInput = {
    AND?: InputMaybe<Array<ArtClaimWhereInput>>;
    NOT?: InputMaybe<Array<ArtClaimWhereInput>>;
    OR?: InputMaybe<Array<ArtClaimWhereInput>>;
    artNotes?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringFilter>;
    claimLastUpdated?: InputMaybe<DateTimeNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    cptLines?: InputMaybe<ArtClaimCptLineListRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dateOfRecentTransfer?: InputMaybe<DateTimeNullableFilter>;
    dateOfService?: InputMaybe<DateTimeFilter>;
    departmentId?: InputMaybe<StringNullableFilter>;
    ehrCollectionsBalance?: InputMaybe<FloatNullableFilter>;
    ehrPatientBalance?: InputMaybe<FloatNullableFilter>;
    firstCommunicationDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    id_orgId_claimId?: InputMaybe<ArtClaimIdOrgIdClaimIdCompoundUniqueInput>;
    inboundSourceId?: InputMaybe<StringNullableFilter>;
    lastCommunicationDate?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    manualReviewReasons?: InputMaybe<StringNullableListFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    notes?: InputMaybe<StringNullableListFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    originalPatientBalance?: InputMaybe<FloatFilter>;
    originalPrimaryPayerBalance?: InputMaybe<FloatFilter>;
    originalSecondaryPayerBalance?: InputMaybe<FloatFilter>;
    patientBalance?: InputMaybe<FloatFilter>;
    patientEnterpriseId?: InputMaybe<StringNullableFilter>;
    patientOrgEhrId?: InputMaybe<StringNullableFilter>;
    patientRemarkCodes?: InputMaybe<StringNullableListFilter>;
    patientStatus?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    primaryPayer?: InputMaybe<StringNullableFilter>;
    primaryPayerBalance?: InputMaybe<FloatFilter>;
    primaryPayerPackage?: InputMaybe<StringNullableFilter>;
    primaryPayerStatus?: InputMaybe<StringNullableFilter>;
    primaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    reviewNotes?: InputMaybe<StringNullableFilter>;
    secondaryPayer?: InputMaybe<StringNullableFilter>;
    secondaryPayerBalance?: InputMaybe<FloatFilter>;
    secondaryPayerPackage?: InputMaybe<StringNullableFilter>;
    secondaryPayerStatus?: InputMaybe<StringNullableFilter>;
    secondaryRemarkCodes?: InputMaybe<StringNullableListFilter>;
    slotIds?: InputMaybe<StringNullableListFilter>;
    status?: InputMaybe<EnumArtClaimStatusEnumNullableFilter>;
    statusReason?: InputMaybe<StringNullableFilter>;
    totalAdjudicatedResponsibility?: InputMaybe<FloatNullableFilter>;
    totalAdjustedOffPlatform?: InputMaybe<FloatNullableFilter>;
    totalArtTransferredAmount?: InputMaybe<FloatNullableFilter>;
    totalPostedBySuperscriptAmount?: InputMaybe<FloatNullableFilter>;
    totalPostedOffPlatform?: InputMaybe<FloatNullableFilter>;
    unscheduledBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    visitId?: InputMaybe<StringNullableFilter>;
};

export type ArtOrgConfig = {
    __typename?: 'ArtOrgConfig';
    createdAt: Scalars['DateTimeISO']['output'];
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    isFullOrgLive: Scalars['Boolean']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ArtOrgConfigAvgAggregate = {
    __typename?: 'ArtOrgConfigAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type ArtOrgConfigAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type ArtOrgConfigCountAggregate = {
    __typename?: 'ArtOrgConfigCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    goLiveDate: Scalars['Int']['output'];
    isFullOrgLive: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ArtOrgConfigCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    isFullOrgLive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ArtOrgConfigCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    goLiveDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isFullOrgLive?: InputMaybe<Scalars['Boolean']['input']>;
    org: OrganizationCreateNestedOneWithoutArtOrgConfigInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtOrgConfigCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    goLiveDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isFullOrgLive?: InputMaybe<Scalars['Boolean']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtOrgConfigCreateNestedOneWithoutOrgInput = {
    connect?: InputMaybe<ArtOrgConfigWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ArtOrgConfigCreateOrConnectWithoutOrgInput>;
    create?: InputMaybe<ArtOrgConfigCreateWithoutOrgInput>;
};

export type ArtOrgConfigCreateOrConnectWithoutOrgInput = {
    create: ArtOrgConfigCreateWithoutOrgInput;
    where: ArtOrgConfigWhereUniqueInput;
};

export type ArtOrgConfigCreateWithoutOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    goLiveDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isFullOrgLive?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtOrgConfigGroupBy = {
    __typename?: 'ArtOrgConfigGroupBy';
    _avg?: Maybe<ArtOrgConfigAvgAggregate>;
    _count?: Maybe<ArtOrgConfigCountAggregate>;
    _max?: Maybe<ArtOrgConfigMaxAggregate>;
    _min?: Maybe<ArtOrgConfigMinAggregate>;
    _sum?: Maybe<ArtOrgConfigSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    isFullOrgLive: Scalars['Boolean']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ArtOrgConfigMaxAggregate = {
    __typename?: 'ArtOrgConfigMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    isFullOrgLive?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtOrgConfigMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    isFullOrgLive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ArtOrgConfigMinAggregate = {
    __typename?: 'ArtOrgConfigMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    isFullOrgLive?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtOrgConfigMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    isFullOrgLive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ArtOrgConfigNullableRelationFilter = {
    is?: InputMaybe<ArtOrgConfigWhereInput>;
    isNot?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type ArtOrgConfigOrderByWithAggregationInput = {
    _avg?: InputMaybe<ArtOrgConfigAvgOrderByAggregateInput>;
    _count?: InputMaybe<ArtOrgConfigCountOrderByAggregateInput>;
    _max?: InputMaybe<ArtOrgConfigMaxOrderByAggregateInput>;
    _min?: InputMaybe<ArtOrgConfigMinOrderByAggregateInput>;
    _sum?: InputMaybe<ArtOrgConfigSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrderInput>;
    isFullOrgLive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ArtOrgConfigOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrderInput>;
    isFullOrgLive?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum ArtOrgConfigScalarFieldEnum {
    CreatedAt = 'createdAt',
    GoLiveDate = 'goLiveDate',
    IsFullOrgLive = 'isFullOrgLive',
    OrgId = 'orgId',
    UpdatedAt = 'updatedAt',
}

export type ArtOrgConfigScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ArtOrgConfigScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ArtOrgConfigScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ArtOrgConfigScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    goLiveDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    isFullOrgLive?: InputMaybe<BoolWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ArtOrgConfigSumAggregate = {
    __typename?: 'ArtOrgConfigSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type ArtOrgConfigSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type ArtOrgConfigUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    goLiveDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isFullOrgLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutArtOrgConfigNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArtOrgConfigUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    goLiveDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isFullOrgLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArtOrgConfigUpdateOneWithoutOrgNestedInput = {
    connect?: InputMaybe<ArtOrgConfigWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ArtOrgConfigCreateOrConnectWithoutOrgInput>;
    create?: InputMaybe<ArtOrgConfigCreateWithoutOrgInput>;
    delete?: InputMaybe<ArtOrgConfigWhereInput>;
    disconnect?: InputMaybe<ArtOrgConfigWhereInput>;
    update?: InputMaybe<ArtOrgConfigUpdateToOneWithWhereWithoutOrgInput>;
    upsert?: InputMaybe<ArtOrgConfigUpsertWithoutOrgInput>;
};

export type ArtOrgConfigUpdateToOneWithWhereWithoutOrgInput = {
    data: ArtOrgConfigUpdateWithoutOrgInput;
    where?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type ArtOrgConfigUpdateWithoutOrgInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    goLiveDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isFullOrgLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArtOrgConfigUpsertWithoutOrgInput = {
    create: ArtOrgConfigCreateWithoutOrgInput;
    update: ArtOrgConfigUpdateWithoutOrgInput;
    where?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type ArtOrgConfigWhereInput = {
    AND?: InputMaybe<Array<ArtOrgConfigWhereInput>>;
    NOT?: InputMaybe<Array<ArtOrgConfigWhereInput>>;
    OR?: InputMaybe<Array<ArtOrgConfigWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    goLiveDate?: InputMaybe<DateTimeNullableFilter>;
    isFullOrgLive?: InputMaybe<BoolFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ArtOrgConfigWhereUniqueInput = {
    AND?: InputMaybe<Array<ArtOrgConfigWhereInput>>;
    NOT?: InputMaybe<Array<ArtOrgConfigWhereInput>>;
    OR?: InputMaybe<Array<ArtOrgConfigWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    goLiveDate?: InputMaybe<DateTimeNullableFilter>;
    isFullOrgLive?: InputMaybe<BoolFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ArtPracticeConfig = {
    __typename?: 'ArtPracticeConfig';
    createdAt: Scalars['DateTimeISO']['output'];
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    isLive: Scalars['Boolean']['output'];
    practice: Practice;
    practiceId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ArtPracticeConfigAvgAggregate = {
    __typename?: 'ArtPracticeConfigAvgAggregate';
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type ArtPracticeConfigAvgOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
};

export type ArtPracticeConfigCountAggregate = {
    __typename?: 'ArtPracticeConfigCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    goLiveDate: Scalars['Int']['output'];
    isLive: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ArtPracticeConfigCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    isLive?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ArtPracticeConfigCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    goLiveDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isLive?: InputMaybe<Scalars['Boolean']['input']>;
    practice: PracticeCreateNestedOneWithoutArtPracticeConfigInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtPracticeConfigCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    goLiveDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isLive?: InputMaybe<Scalars['Boolean']['input']>;
    practiceId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtPracticeConfigCreateNestedOneWithoutPracticeInput = {
    connect?: InputMaybe<ArtPracticeConfigWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ArtPracticeConfigCreateOrConnectWithoutPracticeInput>;
    create?: InputMaybe<ArtPracticeConfigCreateWithoutPracticeInput>;
};

export type ArtPracticeConfigCreateOrConnectWithoutPracticeInput = {
    create: ArtPracticeConfigCreateWithoutPracticeInput;
    where: ArtPracticeConfigWhereUniqueInput;
};

export type ArtPracticeConfigCreateWithoutPracticeInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    goLiveDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isLive?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ArtPracticeConfigGroupBy = {
    __typename?: 'ArtPracticeConfigGroupBy';
    _avg?: Maybe<ArtPracticeConfigAvgAggregate>;
    _count?: Maybe<ArtPracticeConfigCountAggregate>;
    _max?: Maybe<ArtPracticeConfigMaxAggregate>;
    _min?: Maybe<ArtPracticeConfigMinAggregate>;
    _sum?: Maybe<ArtPracticeConfigSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    isLive: Scalars['Boolean']['output'];
    practiceId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ArtPracticeConfigMaxAggregate = {
    __typename?: 'ArtPracticeConfigMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    isLive?: Maybe<Scalars['Boolean']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtPracticeConfigMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    isLive?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ArtPracticeConfigMinAggregate = {
    __typename?: 'ArtPracticeConfigMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>;
    isLive?: Maybe<Scalars['Boolean']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ArtPracticeConfigMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrder>;
    isLive?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ArtPracticeConfigNullableRelationFilter = {
    is?: InputMaybe<ArtPracticeConfigWhereInput>;
    isNot?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type ArtPracticeConfigOrderByWithAggregationInput = {
    _avg?: InputMaybe<ArtPracticeConfigAvgOrderByAggregateInput>;
    _count?: InputMaybe<ArtPracticeConfigCountOrderByAggregateInput>;
    _max?: InputMaybe<ArtPracticeConfigMaxOrderByAggregateInput>;
    _min?: InputMaybe<ArtPracticeConfigMinOrderByAggregateInput>;
    _sum?: InputMaybe<ArtPracticeConfigSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrderInput>;
    isLive?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ArtPracticeConfigOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    goLiveDate?: InputMaybe<SortOrderInput>;
    isLive?: InputMaybe<SortOrder>;
    practice?: InputMaybe<PracticeOrderByWithRelationInput>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum ArtPracticeConfigScalarFieldEnum {
    CreatedAt = 'createdAt',
    GoLiveDate = 'goLiveDate',
    IsLive = 'isLive',
    PracticeId = 'practiceId',
    UpdatedAt = 'updatedAt',
}

export type ArtPracticeConfigScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ArtPracticeConfigScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ArtPracticeConfigScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ArtPracticeConfigScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    goLiveDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    isLive?: InputMaybe<BoolWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ArtPracticeConfigSumAggregate = {
    __typename?: 'ArtPracticeConfigSumAggregate';
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type ArtPracticeConfigSumOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
};

export type ArtPracticeConfigUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    goLiveDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutArtPracticeConfigNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArtPracticeConfigUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    goLiveDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArtPracticeConfigUpdateOneWithoutPracticeNestedInput = {
    connect?: InputMaybe<ArtPracticeConfigWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ArtPracticeConfigCreateOrConnectWithoutPracticeInput>;
    create?: InputMaybe<ArtPracticeConfigCreateWithoutPracticeInput>;
    delete?: InputMaybe<ArtPracticeConfigWhereInput>;
    disconnect?: InputMaybe<ArtPracticeConfigWhereInput>;
    update?: InputMaybe<ArtPracticeConfigUpdateToOneWithWhereWithoutPracticeInput>;
    upsert?: InputMaybe<ArtPracticeConfigUpsertWithoutPracticeInput>;
};

export type ArtPracticeConfigUpdateToOneWithWhereWithoutPracticeInput = {
    data: ArtPracticeConfigUpdateWithoutPracticeInput;
    where?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type ArtPracticeConfigUpdateWithoutPracticeInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    goLiveDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArtPracticeConfigUpsertWithoutPracticeInput = {
    create: ArtPracticeConfigCreateWithoutPracticeInput;
    update: ArtPracticeConfigUpdateWithoutPracticeInput;
    where?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type ArtPracticeConfigWhereInput = {
    AND?: InputMaybe<Array<ArtPracticeConfigWhereInput>>;
    NOT?: InputMaybe<Array<ArtPracticeConfigWhereInput>>;
    OR?: InputMaybe<Array<ArtPracticeConfigWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    goLiveDate?: InputMaybe<DateTimeNullableFilter>;
    isLive?: InputMaybe<BoolFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    practiceId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ArtPracticeConfigWhereUniqueInput = {
    AND?: InputMaybe<Array<ArtPracticeConfigWhereInput>>;
    NOT?: InputMaybe<Array<ArtPracticeConfigWhereInput>>;
    OR?: InputMaybe<Array<ArtPracticeConfigWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    goLiveDate?: InputMaybe<DateTimeNullableFilter>;
    isLive?: InputMaybe<BoolFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AthenaMedications = {
    __typename?: 'AthenaMedications';
    dosageAction?: Maybe<Scalars['String']['output']>;
    dosageForm?: Maybe<Scalars['String']['output']>;
    dosageRoute?: Maybe<Scalars['String']['output']>;
    frequency?: Maybe<Scalars['String']['output']>;
    medicationId: Scalars['Int']['output'];
    medicationName: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AthenaMedicationsAvgAggregate = {
    __typename?: 'AthenaMedicationsAvgAggregate';
    medicationId?: Maybe<Scalars['Float']['output']>;
};

export type AthenaMedicationsAvgOrderByAggregateInput = {
    medicationId?: InputMaybe<SortOrder>;
};

export type AthenaMedicationsCountAggregate = {
    __typename?: 'AthenaMedicationsCountAggregate';
    _all: Scalars['Int']['output'];
    dosageAction: Scalars['Int']['output'];
    dosageForm: Scalars['Int']['output'];
    dosageRoute: Scalars['Int']['output'];
    frequency: Scalars['Int']['output'];
    medicationId: Scalars['Int']['output'];
    medicationName: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type AthenaMedicationsCountOrderByAggregateInput = {
    dosageAction?: InputMaybe<SortOrder>;
    dosageForm?: InputMaybe<SortOrder>;
    dosageRoute?: InputMaybe<SortOrder>;
    frequency?: InputMaybe<SortOrder>;
    medicationId?: InputMaybe<SortOrder>;
    medicationName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AthenaMedicationsCreateInput = {
    dosageAction?: InputMaybe<Scalars['String']['input']>;
    dosageForm?: InputMaybe<Scalars['String']['input']>;
    dosageRoute?: InputMaybe<Scalars['String']['input']>;
    frequency?: InputMaybe<Scalars['String']['input']>;
    medicationId: Scalars['Int']['input'];
    medicationName: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AthenaMedicationsCreateManyInput = {
    dosageAction?: InputMaybe<Scalars['String']['input']>;
    dosageForm?: InputMaybe<Scalars['String']['input']>;
    dosageRoute?: InputMaybe<Scalars['String']['input']>;
    frequency?: InputMaybe<Scalars['String']['input']>;
    medicationId: Scalars['Int']['input'];
    medicationName: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AthenaMedicationsGroupBy = {
    __typename?: 'AthenaMedicationsGroupBy';
    _avg?: Maybe<AthenaMedicationsAvgAggregate>;
    _count?: Maybe<AthenaMedicationsCountAggregate>;
    _max?: Maybe<AthenaMedicationsMaxAggregate>;
    _min?: Maybe<AthenaMedicationsMinAggregate>;
    _sum?: Maybe<AthenaMedicationsSumAggregate>;
    dosageAction?: Maybe<Scalars['String']['output']>;
    dosageForm?: Maybe<Scalars['String']['output']>;
    dosageRoute?: Maybe<Scalars['String']['output']>;
    frequency?: Maybe<Scalars['String']['output']>;
    medicationId: Scalars['Int']['output'];
    medicationName: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type AthenaMedicationsMaxAggregate = {
    __typename?: 'AthenaMedicationsMaxAggregate';
    dosageAction?: Maybe<Scalars['String']['output']>;
    dosageForm?: Maybe<Scalars['String']['output']>;
    dosageRoute?: Maybe<Scalars['String']['output']>;
    frequency?: Maybe<Scalars['String']['output']>;
    medicationId?: Maybe<Scalars['Int']['output']>;
    medicationName?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AthenaMedicationsMaxOrderByAggregateInput = {
    dosageAction?: InputMaybe<SortOrder>;
    dosageForm?: InputMaybe<SortOrder>;
    dosageRoute?: InputMaybe<SortOrder>;
    frequency?: InputMaybe<SortOrder>;
    medicationId?: InputMaybe<SortOrder>;
    medicationName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AthenaMedicationsMedicationIdMedicationNameCompoundUniqueInput = {
    medicationId: Scalars['Int']['input'];
    medicationName: Scalars['String']['input'];
};

export type AthenaMedicationsMinAggregate = {
    __typename?: 'AthenaMedicationsMinAggregate';
    dosageAction?: Maybe<Scalars['String']['output']>;
    dosageForm?: Maybe<Scalars['String']['output']>;
    dosageRoute?: Maybe<Scalars['String']['output']>;
    frequency?: Maybe<Scalars['String']['output']>;
    medicationId?: Maybe<Scalars['Int']['output']>;
    medicationName?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AthenaMedicationsMinOrderByAggregateInput = {
    dosageAction?: InputMaybe<SortOrder>;
    dosageForm?: InputMaybe<SortOrder>;
    dosageRoute?: InputMaybe<SortOrder>;
    frequency?: InputMaybe<SortOrder>;
    medicationId?: InputMaybe<SortOrder>;
    medicationName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AthenaMedicationsOrderByWithAggregationInput = {
    _avg?: InputMaybe<AthenaMedicationsAvgOrderByAggregateInput>;
    _count?: InputMaybe<AthenaMedicationsCountOrderByAggregateInput>;
    _max?: InputMaybe<AthenaMedicationsMaxOrderByAggregateInput>;
    _min?: InputMaybe<AthenaMedicationsMinOrderByAggregateInput>;
    _sum?: InputMaybe<AthenaMedicationsSumOrderByAggregateInput>;
    dosageAction?: InputMaybe<SortOrderInput>;
    dosageForm?: InputMaybe<SortOrderInput>;
    dosageRoute?: InputMaybe<SortOrderInput>;
    frequency?: InputMaybe<SortOrderInput>;
    medicationId?: InputMaybe<SortOrder>;
    medicationName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type AthenaMedicationsOrderByWithRelationInput = {
    dosageAction?: InputMaybe<SortOrderInput>;
    dosageForm?: InputMaybe<SortOrderInput>;
    dosageRoute?: InputMaybe<SortOrderInput>;
    frequency?: InputMaybe<SortOrderInput>;
    medicationId?: InputMaybe<SortOrder>;
    medicationName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum AthenaMedicationsScalarFieldEnum {
    DosageAction = 'dosageAction',
    DosageForm = 'dosageForm',
    DosageRoute = 'dosageRoute',
    Frequency = 'frequency',
    MedicationId = 'medicationId',
    MedicationName = 'medicationName',
    UpdatedAt = 'updatedAt',
}

export type AthenaMedicationsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AthenaMedicationsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AthenaMedicationsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AthenaMedicationsScalarWhereWithAggregatesInput>>;
    dosageAction?: InputMaybe<StringNullableWithAggregatesFilter>;
    dosageForm?: InputMaybe<StringNullableWithAggregatesFilter>;
    dosageRoute?: InputMaybe<StringNullableWithAggregatesFilter>;
    frequency?: InputMaybe<StringNullableWithAggregatesFilter>;
    medicationId?: InputMaybe<IntWithAggregatesFilter>;
    medicationName?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AthenaMedicationsSumAggregate = {
    __typename?: 'AthenaMedicationsSumAggregate';
    medicationId?: Maybe<Scalars['Int']['output']>;
};

export type AthenaMedicationsSumOrderByAggregateInput = {
    medicationId?: InputMaybe<SortOrder>;
};

export type AthenaMedicationsUpdateInput = {
    dosageAction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    dosageForm?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    dosageRoute?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    medicationId?: InputMaybe<IntFieldUpdateOperationsInput>;
    medicationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AthenaMedicationsUpdateManyMutationInput = {
    dosageAction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    dosageForm?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    dosageRoute?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    medicationId?: InputMaybe<IntFieldUpdateOperationsInput>;
    medicationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AthenaMedicationsWhereInput = {
    AND?: InputMaybe<Array<AthenaMedicationsWhereInput>>;
    NOT?: InputMaybe<Array<AthenaMedicationsWhereInput>>;
    OR?: InputMaybe<Array<AthenaMedicationsWhereInput>>;
    dosageAction?: InputMaybe<StringNullableFilter>;
    dosageForm?: InputMaybe<StringNullableFilter>;
    dosageRoute?: InputMaybe<StringNullableFilter>;
    frequency?: InputMaybe<StringNullableFilter>;
    medicationId?: InputMaybe<IntFilter>;
    medicationName?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AthenaMedicationsWhereUniqueInput = {
    AND?: InputMaybe<Array<AthenaMedicationsWhereInput>>;
    NOT?: InputMaybe<Array<AthenaMedicationsWhereInput>>;
    OR?: InputMaybe<Array<AthenaMedicationsWhereInput>>;
    dosageAction?: InputMaybe<StringNullableFilter>;
    dosageForm?: InputMaybe<StringNullableFilter>;
    dosageRoute?: InputMaybe<StringNullableFilter>;
    frequency?: InputMaybe<StringNullableFilter>;
    medicationId?: InputMaybe<IntFilter>;
    medicationId_medicationName?: InputMaybe<AthenaMedicationsMedicationIdMedicationNameCompoundUniqueInput>;
    medicationName?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AthenaPharmacy = {
    __typename?: 'AthenaPharmacy';
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrId: Scalars['Int']['output'];
    fax?: Maybe<Scalars['String']['output']>;
    isDeleted: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    npi?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zip?: Maybe<Scalars['String']['output']>;
};

export type AthenaPharmacyAvgAggregate = {
    __typename?: 'AthenaPharmacyAvgAggregate';
    ehrId?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type AthenaPharmacyAvgOrderByAggregateInput = {
    ehrId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type AthenaPharmacyCountAggregate = {
    __typename?: 'AthenaPharmacyCountAggregate';
    _all: Scalars['Int']['output'];
    address1: Scalars['Int']['output'];
    address2: Scalars['Int']['output'];
    city: Scalars['Int']['output'];
    contextId: Scalars['Int']['output'];
    country: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrId: Scalars['Int']['output'];
    fax: Scalars['Int']['output'];
    isDeleted: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    phone: Scalars['Int']['output'];
    placeName: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    zip: Scalars['Int']['output'];
};

export type AthenaPharmacyCountOrderByAggregateInput = {
    address1?: InputMaybe<SortOrder>;
    address2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    placeName?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type AthenaPharmacyCreateInput = {
    address1?: InputMaybe<Scalars['String']['input']>;
    address2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    contextId?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrId: Scalars['Int']['input'];
    fax?: InputMaybe<Scalars['String']['input']>;
    isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    phone?: InputMaybe<Scalars['String']['input']>;
    placeName?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type AthenaPharmacyCreateManyInput = {
    address1?: InputMaybe<Scalars['String']['input']>;
    address2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    contextId?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrId: Scalars['Int']['input'];
    fax?: InputMaybe<Scalars['String']['input']>;
    isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    phone?: InputMaybe<Scalars['String']['input']>;
    placeName?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type AthenaPharmacyEhrIdNameOrgIdCompoundUniqueInput = {
    ehrId: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
};

export type AthenaPharmacyGroupBy = {
    __typename?: 'AthenaPharmacyGroupBy';
    _avg?: Maybe<AthenaPharmacyAvgAggregate>;
    _count?: Maybe<AthenaPharmacyCountAggregate>;
    _max?: Maybe<AthenaPharmacyMaxAggregate>;
    _min?: Maybe<AthenaPharmacyMinAggregate>;
    _sum?: Maybe<AthenaPharmacySumAggregate>;
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrId: Scalars['Int']['output'];
    fax?: Maybe<Scalars['String']['output']>;
    isDeleted: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    npi?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zip?: Maybe<Scalars['String']['output']>;
};

export type AthenaPharmacyMaxAggregate = {
    __typename?: 'AthenaPharmacyMaxAggregate';
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrId?: Maybe<Scalars['Int']['output']>;
    fax?: Maybe<Scalars['String']['output']>;
    isDeleted?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type AthenaPharmacyMaxOrderByAggregateInput = {
    address1?: InputMaybe<SortOrder>;
    address2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    placeName?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type AthenaPharmacyMinAggregate = {
    __typename?: 'AthenaPharmacyMinAggregate';
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrId?: Maybe<Scalars['Int']['output']>;
    fax?: Maybe<Scalars['String']['output']>;
    isDeleted?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type AthenaPharmacyMinOrderByAggregateInput = {
    address1?: InputMaybe<SortOrder>;
    address2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    placeName?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type AthenaPharmacyOrderByWithAggregationInput = {
    _avg?: InputMaybe<AthenaPharmacyAvgOrderByAggregateInput>;
    _count?: InputMaybe<AthenaPharmacyCountOrderByAggregateInput>;
    _max?: InputMaybe<AthenaPharmacyMaxOrderByAggregateInput>;
    _min?: InputMaybe<AthenaPharmacyMinOrderByAggregateInput>;
    _sum?: InputMaybe<AthenaPharmacySumOrderByAggregateInput>;
    address1?: InputMaybe<SortOrderInput>;
    address2?: InputMaybe<SortOrderInput>;
    city?: InputMaybe<SortOrderInput>;
    contextId?: InputMaybe<SortOrderInput>;
    country?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrderInput>;
    isDeleted?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrderInput>;
    placeName?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrderInput>;
};

export type AthenaPharmacyOrderByWithRelationInput = {
    address1?: InputMaybe<SortOrderInput>;
    address2?: InputMaybe<SortOrderInput>;
    city?: InputMaybe<SortOrderInput>;
    contextId?: InputMaybe<SortOrderInput>;
    country?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrderInput>;
    isDeleted?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrderInput>;
    placeName?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrderInput>;
};

export enum AthenaPharmacyScalarFieldEnum {
    Address1 = 'address1',
    Address2 = 'address2',
    City = 'city',
    ContextId = 'contextId',
    Country = 'country',
    CreatedAt = 'createdAt',
    EhrId = 'ehrId',
    Fax = 'fax',
    IsDeleted = 'isDeleted',
    Name = 'name',
    Npi = 'npi',
    OrgId = 'orgId',
    Phone = 'phone',
    PlaceName = 'placeName',
    State = 'state',
    UpdatedAt = 'updatedAt',
    Zip = 'zip',
}

export type AthenaPharmacyScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AthenaPharmacyScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AthenaPharmacyScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AthenaPharmacyScalarWhereWithAggregatesInput>>;
    address1?: InputMaybe<StringNullableWithAggregatesFilter>;
    address2?: InputMaybe<StringNullableWithAggregatesFilter>;
    city?: InputMaybe<StringNullableWithAggregatesFilter>;
    contextId?: InputMaybe<StringNullableWithAggregatesFilter>;
    country?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrId?: InputMaybe<IntWithAggregatesFilter>;
    fax?: InputMaybe<StringNullableWithAggregatesFilter>;
    isDeleted?: InputMaybe<BoolWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    npi?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    phone?: InputMaybe<StringNullableWithAggregatesFilter>;
    placeName?: InputMaybe<StringNullableWithAggregatesFilter>;
    state?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    zip?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type AthenaPharmacySumAggregate = {
    __typename?: 'AthenaPharmacySumAggregate';
    ehrId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type AthenaPharmacySumOrderByAggregateInput = {
    ehrId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type AthenaPharmacyUpdateInput = {
    address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<IntFieldUpdateOperationsInput>;
    fax?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AthenaPharmacyUpdateManyMutationInput = {
    address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<IntFieldUpdateOperationsInput>;
    fax?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AthenaPharmacyWhereInput = {
    AND?: InputMaybe<Array<AthenaPharmacyWhereInput>>;
    NOT?: InputMaybe<Array<AthenaPharmacyWhereInput>>;
    OR?: InputMaybe<Array<AthenaPharmacyWhereInput>>;
    address1?: InputMaybe<StringNullableFilter>;
    address2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    contextId?: InputMaybe<StringNullableFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrId?: InputMaybe<IntFilter>;
    fax?: InputMaybe<StringNullableFilter>;
    isDeleted?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    placeName?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type AthenaPharmacyWhereUniqueInput = {
    AND?: InputMaybe<Array<AthenaPharmacyWhereInput>>;
    NOT?: InputMaybe<Array<AthenaPharmacyWhereInput>>;
    OR?: InputMaybe<Array<AthenaPharmacyWhereInput>>;
    address1?: InputMaybe<StringNullableFilter>;
    address2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    contextId?: InputMaybe<StringNullableFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrId?: InputMaybe<IntFilter>;
    ehrId_name_orgId?: InputMaybe<AthenaPharmacyEhrIdNameOrgIdCompoundUniqueInput>;
    fax?: InputMaybe<StringNullableFilter>;
    isDeleted?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    placeName?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type AthenaProvider = {
    __typename?: 'AthenaProvider';
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrId: Scalars['Int']['output'];
    fax?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    isDeleted: Scalars['Boolean']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    middleName?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    npi?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zip?: Maybe<Scalars['String']['output']>;
};

export type AthenaProviderAvgAggregate = {
    __typename?: 'AthenaProviderAvgAggregate';
    ehrId?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type AthenaProviderAvgOrderByAggregateInput = {
    ehrId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type AthenaProviderCountAggregate = {
    __typename?: 'AthenaProviderCountAggregate';
    _all: Scalars['Int']['output'];
    address1: Scalars['Int']['output'];
    address2: Scalars['Int']['output'];
    city: Scalars['Int']['output'];
    contextId: Scalars['Int']['output'];
    country: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrId: Scalars['Int']['output'];
    fax: Scalars['Int']['output'];
    firstName: Scalars['Int']['output'];
    isDeleted: Scalars['Int']['output'];
    lastName: Scalars['Int']['output'];
    middleName: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    phone: Scalars['Int']['output'];
    placeName: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    zip: Scalars['Int']['output'];
};

export type AthenaProviderCountOrderByAggregateInput = {
    address1?: InputMaybe<SortOrder>;
    address2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    middleName?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    placeName?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type AthenaProviderCreateInput = {
    address1?: InputMaybe<Scalars['String']['input']>;
    address2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    contextId?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrId: Scalars['Int']['input'];
    fax?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    middleName?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    phone?: InputMaybe<Scalars['String']['input']>;
    placeName?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type AthenaProviderCreateManyInput = {
    address1?: InputMaybe<Scalars['String']['input']>;
    address2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    contextId?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrId: Scalars['Int']['input'];
    fax?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    middleName?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    phone?: InputMaybe<Scalars['String']['input']>;
    placeName?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type AthenaProviderEhrIdNameOrgIdCompoundUniqueInput = {
    ehrId: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
};

export type AthenaProviderGroupBy = {
    __typename?: 'AthenaProviderGroupBy';
    _avg?: Maybe<AthenaProviderAvgAggregate>;
    _count?: Maybe<AthenaProviderCountAggregate>;
    _max?: Maybe<AthenaProviderMaxAggregate>;
    _min?: Maybe<AthenaProviderMinAggregate>;
    _sum?: Maybe<AthenaProviderSumAggregate>;
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrId: Scalars['Int']['output'];
    fax?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    isDeleted: Scalars['Boolean']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    middleName?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    npi?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zip?: Maybe<Scalars['String']['output']>;
};

export type AthenaProviderMaxAggregate = {
    __typename?: 'AthenaProviderMaxAggregate';
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrId?: Maybe<Scalars['Int']['output']>;
    fax?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    isDeleted?: Maybe<Scalars['Boolean']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    middleName?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type AthenaProviderMaxOrderByAggregateInput = {
    address1?: InputMaybe<SortOrder>;
    address2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    middleName?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    placeName?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type AthenaProviderMinAggregate = {
    __typename?: 'AthenaProviderMinAggregate';
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrId?: Maybe<Scalars['Int']['output']>;
    fax?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    isDeleted?: Maybe<Scalars['Boolean']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    middleName?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type AthenaProviderMinOrderByAggregateInput = {
    address1?: InputMaybe<SortOrder>;
    address2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    middleName?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    placeName?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type AthenaProviderOrderByWithAggregationInput = {
    _avg?: InputMaybe<AthenaProviderAvgOrderByAggregateInput>;
    _count?: InputMaybe<AthenaProviderCountOrderByAggregateInput>;
    _max?: InputMaybe<AthenaProviderMaxOrderByAggregateInput>;
    _min?: InputMaybe<AthenaProviderMinOrderByAggregateInput>;
    _sum?: InputMaybe<AthenaProviderSumOrderByAggregateInput>;
    address1?: InputMaybe<SortOrderInput>;
    address2?: InputMaybe<SortOrderInput>;
    city?: InputMaybe<SortOrderInput>;
    contextId?: InputMaybe<SortOrderInput>;
    country?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrderInput>;
    firstName?: InputMaybe<SortOrderInput>;
    isDeleted?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrderInput>;
    middleName?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrderInput>;
    placeName?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrderInput>;
};

export type AthenaProviderOrderByWithRelationInput = {
    address1?: InputMaybe<SortOrderInput>;
    address2?: InputMaybe<SortOrderInput>;
    city?: InputMaybe<SortOrderInput>;
    contextId?: InputMaybe<SortOrderInput>;
    country?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrderInput>;
    firstName?: InputMaybe<SortOrderInput>;
    isDeleted?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrderInput>;
    middleName?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrderInput>;
    placeName?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrderInput>;
};

export enum AthenaProviderScalarFieldEnum {
    Address1 = 'address1',
    Address2 = 'address2',
    City = 'city',
    ContextId = 'contextId',
    Country = 'country',
    CreatedAt = 'createdAt',
    EhrId = 'ehrId',
    Fax = 'fax',
    FirstName = 'firstName',
    IsDeleted = 'isDeleted',
    LastName = 'lastName',
    MiddleName = 'middleName',
    Name = 'name',
    Npi = 'npi',
    OrgId = 'orgId',
    Phone = 'phone',
    PlaceName = 'placeName',
    State = 'state',
    UpdatedAt = 'updatedAt',
    Zip = 'zip',
}

export type AthenaProviderScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<AthenaProviderScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<AthenaProviderScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<AthenaProviderScalarWhereWithAggregatesInput>>;
    address1?: InputMaybe<StringNullableWithAggregatesFilter>;
    address2?: InputMaybe<StringNullableWithAggregatesFilter>;
    city?: InputMaybe<StringNullableWithAggregatesFilter>;
    contextId?: InputMaybe<StringNullableWithAggregatesFilter>;
    country?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrId?: InputMaybe<IntWithAggregatesFilter>;
    fax?: InputMaybe<StringNullableWithAggregatesFilter>;
    firstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    isDeleted?: InputMaybe<BoolWithAggregatesFilter>;
    lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    middleName?: InputMaybe<StringNullableWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    npi?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    phone?: InputMaybe<StringNullableWithAggregatesFilter>;
    placeName?: InputMaybe<StringNullableWithAggregatesFilter>;
    state?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    zip?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type AthenaProviderSumAggregate = {
    __typename?: 'AthenaProviderSumAggregate';
    ehrId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type AthenaProviderSumOrderByAggregateInput = {
    ehrId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type AthenaProviderUpdateInput = {
    address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<IntFieldUpdateOperationsInput>;
    fax?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AthenaProviderUpdateManyMutationInput = {
    address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<IntFieldUpdateOperationsInput>;
    fax?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AthenaProviderWhereInput = {
    AND?: InputMaybe<Array<AthenaProviderWhereInput>>;
    NOT?: InputMaybe<Array<AthenaProviderWhereInput>>;
    OR?: InputMaybe<Array<AthenaProviderWhereInput>>;
    address1?: InputMaybe<StringNullableFilter>;
    address2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    contextId?: InputMaybe<StringNullableFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrId?: InputMaybe<IntFilter>;
    fax?: InputMaybe<StringNullableFilter>;
    firstName?: InputMaybe<StringNullableFilter>;
    isDeleted?: InputMaybe<BoolFilter>;
    lastName?: InputMaybe<StringNullableFilter>;
    middleName?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    placeName?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type AthenaProviderWhereUniqueInput = {
    AND?: InputMaybe<Array<AthenaProviderWhereInput>>;
    NOT?: InputMaybe<Array<AthenaProviderWhereInput>>;
    OR?: InputMaybe<Array<AthenaProviderWhereInput>>;
    address1?: InputMaybe<StringNullableFilter>;
    address2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    contextId?: InputMaybe<StringNullableFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrId?: InputMaybe<IntFilter>;
    ehrId_name_orgId?: InputMaybe<AthenaProviderEhrIdNameOrgIdCompoundUniqueInput>;
    fax?: InputMaybe<StringNullableFilter>;
    firstName?: InputMaybe<StringNullableFilter>;
    isDeleted?: InputMaybe<BoolFilter>;
    lastName?: InputMaybe<StringNullableFilter>;
    middleName?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    placeName?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type BenefitParsingRules = {
    __typename?: 'BenefitParsingRules';
    id: Scalars['Int']['output'];
    npi?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    parsingRule: ParsingRule;
    payerId?: Maybe<Scalars['String']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type BenefitParsingRulesAvgAggregate = {
    __typename?: 'BenefitParsingRulesAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    providerGroupId?: Maybe<Scalars['Float']['output']>;
};

export type BenefitParsingRulesAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type BenefitParsingRulesCountAggregate = {
    __typename?: 'BenefitParsingRulesCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    parsingRule: Scalars['Int']['output'];
    payerId: Scalars['Int']['output'];
    planName: Scalars['Int']['output'];
    providerGroupId: Scalars['Int']['output'];
    value: Scalars['Int']['output'];
};

export type BenefitParsingRulesCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    parsingRule?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type BenefitParsingRulesCreateInput = {
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    parsingRule: ParsingRule;
    payerId?: InputMaybe<Scalars['String']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    providerGroupId?: InputMaybe<Scalars['Int']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export type BenefitParsingRulesCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    parsingRule: ParsingRule;
    payerId?: InputMaybe<Scalars['String']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    providerGroupId?: InputMaybe<Scalars['Int']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export type BenefitParsingRulesGroupBy = {
    __typename?: 'BenefitParsingRulesGroupBy';
    _avg?: Maybe<BenefitParsingRulesAvgAggregate>;
    _count?: Maybe<BenefitParsingRulesCountAggregate>;
    _max?: Maybe<BenefitParsingRulesMaxAggregate>;
    _min?: Maybe<BenefitParsingRulesMinAggregate>;
    _sum?: Maybe<BenefitParsingRulesSumAggregate>;
    id: Scalars['Int']['output'];
    npi?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    parsingRule: ParsingRule;
    payerId?: Maybe<Scalars['String']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type BenefitParsingRulesMaxAggregate = {
    __typename?: 'BenefitParsingRulesMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    parsingRule?: Maybe<ParsingRule>;
    payerId?: Maybe<Scalars['String']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type BenefitParsingRulesMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    parsingRule?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type BenefitParsingRulesMinAggregate = {
    __typename?: 'BenefitParsingRulesMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    parsingRule?: Maybe<ParsingRule>;
    payerId?: Maybe<Scalars['String']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type BenefitParsingRulesMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    parsingRule?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type BenefitParsingRulesOrderByWithAggregationInput = {
    _avg?: InputMaybe<BenefitParsingRulesAvgOrderByAggregateInput>;
    _count?: InputMaybe<BenefitParsingRulesCountOrderByAggregateInput>;
    _max?: InputMaybe<BenefitParsingRulesMaxOrderByAggregateInput>;
    _min?: InputMaybe<BenefitParsingRulesMinOrderByAggregateInput>;
    _sum?: InputMaybe<BenefitParsingRulesSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    parsingRule?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrderInput>;
    planName?: InputMaybe<SortOrderInput>;
    providerGroupId?: InputMaybe<SortOrderInput>;
    value?: InputMaybe<SortOrderInput>;
};

export type BenefitParsingRulesOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    parsingRule?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrderInput>;
    planName?: InputMaybe<SortOrderInput>;
    providerGroupId?: InputMaybe<SortOrderInput>;
    value?: InputMaybe<SortOrderInput>;
};

export enum BenefitParsingRulesScalarFieldEnum {
    Id = 'id',
    Npi = 'npi',
    OrgId = 'orgId',
    ParsingRule = 'parsingRule',
    PayerId = 'payerId',
    PlanName = 'planName',
    ProviderGroupId = 'providerGroupId',
    Value = 'value',
}

export type BenefitParsingRulesScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<BenefitParsingRulesScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<BenefitParsingRulesScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<BenefitParsingRulesScalarWhereWithAggregatesInput>>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    npi?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    parsingRule?: InputMaybe<EnumParsingRuleWithAggregatesFilter>;
    payerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    planName?: InputMaybe<StringNullableWithAggregatesFilter>;
    providerGroupId?: InputMaybe<IntNullableWithAggregatesFilter>;
    value?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type BenefitParsingRulesSumAggregate = {
    __typename?: 'BenefitParsingRulesSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type BenefitParsingRulesSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type BenefitParsingRulesUpdateInput = {
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    parsingRule?: InputMaybe<EnumParsingRuleFieldUpdateOperationsInput>;
    payerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    providerGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BenefitParsingRulesUpdateManyMutationInput = {
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    parsingRule?: InputMaybe<EnumParsingRuleFieldUpdateOperationsInput>;
    payerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    providerGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BenefitParsingRulesWhereInput = {
    AND?: InputMaybe<Array<BenefitParsingRulesWhereInput>>;
    NOT?: InputMaybe<Array<BenefitParsingRulesWhereInput>>;
    OR?: InputMaybe<Array<BenefitParsingRulesWhereInput>>;
    id?: InputMaybe<IntFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    parsingRule?: InputMaybe<EnumParsingRuleFilter>;
    payerId?: InputMaybe<StringNullableFilter>;
    planName?: InputMaybe<StringNullableFilter>;
    providerGroupId?: InputMaybe<IntNullableFilter>;
    value?: InputMaybe<StringNullableFilter>;
};

export type BenefitParsingRulesWhereUniqueInput = {
    AND?: InputMaybe<Array<BenefitParsingRulesWhereInput>>;
    NOT?: InputMaybe<Array<BenefitParsingRulesWhereInput>>;
    OR?: InputMaybe<Array<BenefitParsingRulesWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    parsingRule?: InputMaybe<EnumParsingRuleFilter>;
    payerId?: InputMaybe<StringNullableFilter>;
    planName?: InputMaybe<StringNullableFilter>;
    providerGroupId?: InputMaybe<IntNullableFilter>;
    value?: InputMaybe<StringNullableFilter>;
};

export type BigIntFieldUpdateOperationsInput = {
    decrement?: InputMaybe<Scalars['BigInt']['input']>;
    divide?: InputMaybe<Scalars['BigInt']['input']>;
    increment?: InputMaybe<Scalars['BigInt']['input']>;
    multiply?: InputMaybe<Scalars['BigInt']['input']>;
    set?: InputMaybe<Scalars['BigInt']['input']>;
};

export type BigIntFilter = {
    equals?: InputMaybe<Scalars['BigInt']['input']>;
    gt?: InputMaybe<Scalars['BigInt']['input']>;
    gte?: InputMaybe<Scalars['BigInt']['input']>;
    in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
    lt?: InputMaybe<Scalars['BigInt']['input']>;
    lte?: InputMaybe<Scalars['BigInt']['input']>;
    not?: InputMaybe<NestedBigIntFilter>;
    notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BigIntWithAggregatesFilter = {
    _avg?: InputMaybe<NestedFloatFilter>;
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedBigIntFilter>;
    _min?: InputMaybe<NestedBigIntFilter>;
    _sum?: InputMaybe<NestedBigIntFilter>;
    equals?: InputMaybe<Scalars['BigInt']['input']>;
    gt?: InputMaybe<Scalars['BigInt']['input']>;
    gte?: InputMaybe<Scalars['BigInt']['input']>;
    in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
    lt?: InputMaybe<Scalars['BigInt']['input']>;
    lte?: InputMaybe<Scalars['BigInt']['input']>;
    not?: InputMaybe<NestedBigIntWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum BillReason {
    CashCheckFee = 'CASH_CHECK_FEE',
    CashCheckPriceDiff = 'CASH_CHECK_PRICE_DIFF',
    MinimumSuperscriptFee = 'MINIMUM_SUPERSCRIPT_FEE',
    RefundStripeFee = 'REFUND_STRIPE_FEE',
    SuperscriptVerifications = 'SUPERSCRIPT_VERIFICATIONS',
}

export enum BillStatus {
    Billed = 'BILLED',
    New = 'NEW',
    Paid = 'PAID',
}

export type BillingCode = {
    __typename?: 'BillingCode';
    RVU?: Maybe<Scalars['Decimal']['output']>;
    baseEndoscopyBillingCode?: Maybe<Scalars['String']['output']>;
    bilateralSurgeryCode?: Maybe<Scalars['Int']['output']>;
    billingCode: Scalars['String']['output'];
    category: Scalars['String']['output'];
    codeGroup: Scalars['String']['output'];
    description: Scalars['String']['output'];
    globalDays?: Maybe<Scalars['Int']['output']>;
    multipleProcedurePaymentReductionCode?: Maybe<Scalars['Int']['output']>;
};

export type BillingCodeAvgAggregate = {
    __typename?: 'BillingCodeAvgAggregate';
    RVU?: Maybe<Scalars['Decimal']['output']>;
    bilateralSurgeryCode?: Maybe<Scalars['Float']['output']>;
    globalDays?: Maybe<Scalars['Float']['output']>;
    multipleProcedurePaymentReductionCode?: Maybe<Scalars['Float']['output']>;
};

export type BillingCodeAvgOrderByAggregateInput = {
    RVU?: InputMaybe<SortOrder>;
    bilateralSurgeryCode?: InputMaybe<SortOrder>;
    globalDays?: InputMaybe<SortOrder>;
    multipleProcedurePaymentReductionCode?: InputMaybe<SortOrder>;
};

export type BillingCodeCountAggregate = {
    __typename?: 'BillingCodeCountAggregate';
    RVU: Scalars['Int']['output'];
    _all: Scalars['Int']['output'];
    baseEndoscopyBillingCode: Scalars['Int']['output'];
    bilateralSurgeryCode: Scalars['Int']['output'];
    billingCode: Scalars['Int']['output'];
    category: Scalars['Int']['output'];
    codeGroup: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    globalDays: Scalars['Int']['output'];
    multipleProcedurePaymentReductionCode: Scalars['Int']['output'];
};

export type BillingCodeCountOrderByAggregateInput = {
    RVU?: InputMaybe<SortOrder>;
    baseEndoscopyBillingCode?: InputMaybe<SortOrder>;
    bilateralSurgeryCode?: InputMaybe<SortOrder>;
    billingCode?: InputMaybe<SortOrder>;
    category?: InputMaybe<SortOrder>;
    codeGroup?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    globalDays?: InputMaybe<SortOrder>;
    multipleProcedurePaymentReductionCode?: InputMaybe<SortOrder>;
};

export type BillingCodeCreateInput = {
    RVU?: InputMaybe<Scalars['Decimal']['input']>;
    baseEndoscopyBillingCode?: InputMaybe<Scalars['String']['input']>;
    bilateralSurgeryCode?: InputMaybe<Scalars['Int']['input']>;
    billingCode: Scalars['String']['input'];
    category: Scalars['String']['input'];
    codeGroup: Scalars['String']['input'];
    description: Scalars['String']['input'];
    globalDays?: InputMaybe<Scalars['Int']['input']>;
    multipleProcedurePaymentReductionCode?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingCodeCreateManyInput = {
    RVU?: InputMaybe<Scalars['Decimal']['input']>;
    baseEndoscopyBillingCode?: InputMaybe<Scalars['String']['input']>;
    bilateralSurgeryCode?: InputMaybe<Scalars['Int']['input']>;
    billingCode: Scalars['String']['input'];
    category: Scalars['String']['input'];
    codeGroup: Scalars['String']['input'];
    description: Scalars['String']['input'];
    globalDays?: InputMaybe<Scalars['Int']['input']>;
    multipleProcedurePaymentReductionCode?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingCodeGroupBy = {
    __typename?: 'BillingCodeGroupBy';
    RVU?: Maybe<Scalars['Decimal']['output']>;
    _avg?: Maybe<BillingCodeAvgAggregate>;
    _count?: Maybe<BillingCodeCountAggregate>;
    _max?: Maybe<BillingCodeMaxAggregate>;
    _min?: Maybe<BillingCodeMinAggregate>;
    _sum?: Maybe<BillingCodeSumAggregate>;
    baseEndoscopyBillingCode?: Maybe<Scalars['String']['output']>;
    bilateralSurgeryCode?: Maybe<Scalars['Int']['output']>;
    billingCode: Scalars['String']['output'];
    category: Scalars['String']['output'];
    codeGroup: Scalars['String']['output'];
    description: Scalars['String']['output'];
    globalDays?: Maybe<Scalars['Int']['output']>;
    multipleProcedurePaymentReductionCode?: Maybe<Scalars['Int']['output']>;
};

export type BillingCodeMaxAggregate = {
    __typename?: 'BillingCodeMaxAggregate';
    RVU?: Maybe<Scalars['Decimal']['output']>;
    baseEndoscopyBillingCode?: Maybe<Scalars['String']['output']>;
    bilateralSurgeryCode?: Maybe<Scalars['Int']['output']>;
    billingCode?: Maybe<Scalars['String']['output']>;
    category?: Maybe<Scalars['String']['output']>;
    codeGroup?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    globalDays?: Maybe<Scalars['Int']['output']>;
    multipleProcedurePaymentReductionCode?: Maybe<Scalars['Int']['output']>;
};

export type BillingCodeMaxOrderByAggregateInput = {
    RVU?: InputMaybe<SortOrder>;
    baseEndoscopyBillingCode?: InputMaybe<SortOrder>;
    bilateralSurgeryCode?: InputMaybe<SortOrder>;
    billingCode?: InputMaybe<SortOrder>;
    category?: InputMaybe<SortOrder>;
    codeGroup?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    globalDays?: InputMaybe<SortOrder>;
    multipleProcedurePaymentReductionCode?: InputMaybe<SortOrder>;
};

export type BillingCodeMinAggregate = {
    __typename?: 'BillingCodeMinAggregate';
    RVU?: Maybe<Scalars['Decimal']['output']>;
    baseEndoscopyBillingCode?: Maybe<Scalars['String']['output']>;
    bilateralSurgeryCode?: Maybe<Scalars['Int']['output']>;
    billingCode?: Maybe<Scalars['String']['output']>;
    category?: Maybe<Scalars['String']['output']>;
    codeGroup?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    globalDays?: Maybe<Scalars['Int']['output']>;
    multipleProcedurePaymentReductionCode?: Maybe<Scalars['Int']['output']>;
};

export type BillingCodeMinOrderByAggregateInput = {
    RVU?: InputMaybe<SortOrder>;
    baseEndoscopyBillingCode?: InputMaybe<SortOrder>;
    bilateralSurgeryCode?: InputMaybe<SortOrder>;
    billingCode?: InputMaybe<SortOrder>;
    category?: InputMaybe<SortOrder>;
    codeGroup?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    globalDays?: InputMaybe<SortOrder>;
    multipleProcedurePaymentReductionCode?: InputMaybe<SortOrder>;
};

export type BillingCodeOrderByWithAggregationInput = {
    RVU?: InputMaybe<SortOrderInput>;
    _avg?: InputMaybe<BillingCodeAvgOrderByAggregateInput>;
    _count?: InputMaybe<BillingCodeCountOrderByAggregateInput>;
    _max?: InputMaybe<BillingCodeMaxOrderByAggregateInput>;
    _min?: InputMaybe<BillingCodeMinOrderByAggregateInput>;
    _sum?: InputMaybe<BillingCodeSumOrderByAggregateInput>;
    baseEndoscopyBillingCode?: InputMaybe<SortOrderInput>;
    bilateralSurgeryCode?: InputMaybe<SortOrderInput>;
    billingCode?: InputMaybe<SortOrder>;
    category?: InputMaybe<SortOrder>;
    codeGroup?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    globalDays?: InputMaybe<SortOrderInput>;
    multipleProcedurePaymentReductionCode?: InputMaybe<SortOrderInput>;
};

export type BillingCodeOrderByWithRelationInput = {
    RVU?: InputMaybe<SortOrderInput>;
    baseEndoscopyBillingCode?: InputMaybe<SortOrderInput>;
    bilateralSurgeryCode?: InputMaybe<SortOrderInput>;
    billingCode?: InputMaybe<SortOrder>;
    category?: InputMaybe<SortOrder>;
    codeGroup?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    globalDays?: InputMaybe<SortOrderInput>;
    multipleProcedurePaymentReductionCode?: InputMaybe<SortOrderInput>;
};

export enum BillingCodeScalarFieldEnum {
    Rvu = 'RVU',
    BaseEndoscopyBillingCode = 'baseEndoscopyBillingCode',
    BilateralSurgeryCode = 'bilateralSurgeryCode',
    BillingCode = 'billingCode',
    Category = 'category',
    CodeGroup = 'codeGroup',
    Description = 'description',
    GlobalDays = 'globalDays',
    MultipleProcedurePaymentReductionCode = 'multipleProcedurePaymentReductionCode',
}

export type BillingCodeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<BillingCodeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<BillingCodeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<BillingCodeScalarWhereWithAggregatesInput>>;
    RVU?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    baseEndoscopyBillingCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    bilateralSurgeryCode?: InputMaybe<IntNullableWithAggregatesFilter>;
    billingCode?: InputMaybe<StringWithAggregatesFilter>;
    category?: InputMaybe<StringWithAggregatesFilter>;
    codeGroup?: InputMaybe<StringWithAggregatesFilter>;
    description?: InputMaybe<StringWithAggregatesFilter>;
    globalDays?: InputMaybe<IntNullableWithAggregatesFilter>;
    multipleProcedurePaymentReductionCode?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type BillingCodeSumAggregate = {
    __typename?: 'BillingCodeSumAggregate';
    RVU?: Maybe<Scalars['Decimal']['output']>;
    bilateralSurgeryCode?: Maybe<Scalars['Int']['output']>;
    globalDays?: Maybe<Scalars['Int']['output']>;
    multipleProcedurePaymentReductionCode?: Maybe<Scalars['Int']['output']>;
};

export type BillingCodeSumOrderByAggregateInput = {
    RVU?: InputMaybe<SortOrder>;
    bilateralSurgeryCode?: InputMaybe<SortOrder>;
    globalDays?: InputMaybe<SortOrder>;
    multipleProcedurePaymentReductionCode?: InputMaybe<SortOrder>;
};

export type BillingCodeUpdateInput = {
    RVU?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    baseEndoscopyBillingCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    bilateralSurgeryCode?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    billingCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    category?: InputMaybe<StringFieldUpdateOperationsInput>;
    codeGroup?: InputMaybe<StringFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    globalDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    multipleProcedurePaymentReductionCode?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type BillingCodeUpdateManyMutationInput = {
    RVU?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    baseEndoscopyBillingCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    bilateralSurgeryCode?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    billingCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    category?: InputMaybe<StringFieldUpdateOperationsInput>;
    codeGroup?: InputMaybe<StringFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    globalDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    multipleProcedurePaymentReductionCode?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type BillingCodeWhereInput = {
    AND?: InputMaybe<Array<BillingCodeWhereInput>>;
    NOT?: InputMaybe<Array<BillingCodeWhereInput>>;
    OR?: InputMaybe<Array<BillingCodeWhereInput>>;
    RVU?: InputMaybe<DecimalNullableFilter>;
    baseEndoscopyBillingCode?: InputMaybe<StringNullableFilter>;
    bilateralSurgeryCode?: InputMaybe<IntNullableFilter>;
    billingCode?: InputMaybe<StringFilter>;
    category?: InputMaybe<StringFilter>;
    codeGroup?: InputMaybe<StringFilter>;
    description?: InputMaybe<StringFilter>;
    globalDays?: InputMaybe<IntNullableFilter>;
    multipleProcedurePaymentReductionCode?: InputMaybe<IntNullableFilter>;
};

export type BillingCodeWhereUniqueInput = {
    AND?: InputMaybe<Array<BillingCodeWhereInput>>;
    NOT?: InputMaybe<Array<BillingCodeWhereInput>>;
    OR?: InputMaybe<Array<BillingCodeWhereInput>>;
    RVU?: InputMaybe<DecimalNullableFilter>;
    baseEndoscopyBillingCode?: InputMaybe<StringNullableFilter>;
    bilateralSurgeryCode?: InputMaybe<IntNullableFilter>;
    billingCode?: InputMaybe<Scalars['String']['input']>;
    category?: InputMaybe<StringFilter>;
    codeGroup?: InputMaybe<StringFilter>;
    description?: InputMaybe<StringFilter>;
    globalDays?: InputMaybe<IntNullableFilter>;
    multipleProcedurePaymentReductionCode?: InputMaybe<IntNullableFilter>;
};

export type BillingTableDownloadRequest = {
    __typename?: 'BillingTableDownloadRequest';
    adminId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    filters?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    status: BillingTableDownloadStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type BillingTableDownloadRequestAvgAggregate = {
    __typename?: 'BillingTableDownloadRequestAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type BillingTableDownloadRequestAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type BillingTableDownloadRequestCountAggregate = {
    __typename?: 'BillingTableDownloadRequestCountAggregate';
    _all: Scalars['Int']['output'];
    adminId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    filters: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type BillingTableDownloadRequestCountOrderByAggregateInput = {
    adminId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    filters?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BillingTableDownloadRequestCreateInput = {
    adminId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    filters?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    status?: InputMaybe<BillingTableDownloadStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BillingTableDownloadRequestCreateManyInput = {
    adminId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    filters?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    status?: InputMaybe<BillingTableDownloadStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BillingTableDownloadRequestGroupBy = {
    __typename?: 'BillingTableDownloadRequestGroupBy';
    _avg?: Maybe<BillingTableDownloadRequestAvgAggregate>;
    _count?: Maybe<BillingTableDownloadRequestCountAggregate>;
    _max?: Maybe<BillingTableDownloadRequestMaxAggregate>;
    _min?: Maybe<BillingTableDownloadRequestMinAggregate>;
    _sum?: Maybe<BillingTableDownloadRequestSumAggregate>;
    adminId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    filters?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    status: BillingTableDownloadStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type BillingTableDownloadRequestMaxAggregate = {
    __typename?: 'BillingTableDownloadRequestMaxAggregate';
    adminId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<BillingTableDownloadStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BillingTableDownloadRequestMaxOrderByAggregateInput = {
    adminId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BillingTableDownloadRequestMinAggregate = {
    __typename?: 'BillingTableDownloadRequestMinAggregate';
    adminId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<BillingTableDownloadStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BillingTableDownloadRequestMinOrderByAggregateInput = {
    adminId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BillingTableDownloadRequestOrderByWithAggregationInput = {
    _avg?: InputMaybe<BillingTableDownloadRequestAvgOrderByAggregateInput>;
    _count?: InputMaybe<BillingTableDownloadRequestCountOrderByAggregateInput>;
    _max?: InputMaybe<BillingTableDownloadRequestMaxOrderByAggregateInput>;
    _min?: InputMaybe<BillingTableDownloadRequestMinOrderByAggregateInput>;
    _sum?: InputMaybe<BillingTableDownloadRequestSumOrderByAggregateInput>;
    adminId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    filters?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BillingTableDownloadRequestOrderByWithRelationInput = {
    adminId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    filters?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum BillingTableDownloadRequestScalarFieldEnum {
    AdminId = 'adminId',
    CreatedAt = 'createdAt',
    Filters = 'filters',
    Id = 'id',
    OrgId = 'orgId',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type BillingTableDownloadRequestScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<BillingTableDownloadRequestScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<BillingTableDownloadRequestScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<BillingTableDownloadRequestScalarWhereWithAggregatesInput>
    >;
    adminId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    filters?: InputMaybe<JsonNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    status?: InputMaybe<EnumBillingTableDownloadStatusEnumWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type BillingTableDownloadRequestSumAggregate = {
    __typename?: 'BillingTableDownloadRequestSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type BillingTableDownloadRequestSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type BillingTableDownloadRequestUpdateInput = {
    adminId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    filters?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumBillingTableDownloadStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BillingTableDownloadRequestUpdateManyMutationInput = {
    adminId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    filters?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumBillingTableDownloadStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BillingTableDownloadRequestWhereInput = {
    AND?: InputMaybe<Array<BillingTableDownloadRequestWhereInput>>;
    NOT?: InputMaybe<Array<BillingTableDownloadRequestWhereInput>>;
    OR?: InputMaybe<Array<BillingTableDownloadRequestWhereInput>>;
    adminId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    filters?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    orgId?: InputMaybe<IntFilter>;
    status?: InputMaybe<EnumBillingTableDownloadStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BillingTableDownloadRequestWhereUniqueInput = {
    AND?: InputMaybe<Array<BillingTableDownloadRequestWhereInput>>;
    NOT?: InputMaybe<Array<BillingTableDownloadRequestWhereInput>>;
    OR?: InputMaybe<Array<BillingTableDownloadRequestWhereInput>>;
    adminId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    filters?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
    status?: InputMaybe<EnumBillingTableDownloadStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum BillingTableDownloadStatusEnum {
    Completed = 'COMPLETED',
    Dropped = 'DROPPED',
    Failed = 'FAILED',
    Pending = 'PENDING',
}

export type BoolFieldUpdateOperationsInput = {
    set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
    equals?: InputMaybe<Scalars['Boolean']['input']>;
    not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
    equals?: InputMaybe<Scalars['Boolean']['input']>;
    not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedBoolNullableFilter>;
    _min?: InputMaybe<NestedBoolNullableFilter>;
    equals?: InputMaybe<Scalars['Boolean']['input']>;
    not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedBoolFilter>;
    _min?: InputMaybe<NestedBoolFilter>;
    equals?: InputMaybe<Scalars['Boolean']['input']>;
    not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type BoughtTreatment = {
    __typename?: 'BoughtTreatment';
    _count?: Maybe<BoughtTreatmentCount>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    candidateTreatments: Array<CandidateTreatment>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    discountCodeApplied?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['String']['output'];
    insuranceIds: Array<Scalars['String']['output']>;
    isVirtual: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentContactId?: Maybe<Scalars['String']['output']>;
    paymentType: PaymentTypeEnum;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price: Scalars['Float']['output'];
    pricedTreatmentId: Scalars['Int']['output'];
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slot?: Maybe<Slot>;
    slotId?: Maybe<Scalars['String']['output']>;
    source: EncounterSourceEnum;
    status: BoughtTreatmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type BoughtTreatmentCandidateTreatmentsArgs = {
    cursor?: InputMaybe<CandidateTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<CandidateTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type BoughtTreatmentSlotArgs = {
    where?: InputMaybe<SlotWhereInput>;
};

export type BoughtTreatmentAuditLog = {
    __typename?: 'BoughtTreatmentAuditLog';
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    consumerId?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    insuranceIds: Array<Scalars['String']['output']>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentType?: Maybe<PaymentTypeEnum>;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<EncounterSourceEnum>;
    status?: Maybe<BoughtTreatmentStatusEnum>;
};

export type BoughtTreatmentAuditLogAvgAggregate = {
    __typename?: 'BoughtTreatmentAuditLogAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Float']['output']>;
};

export type BoughtTreatmentAuditLogAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentAuditLogCountAggregate = {
    __typename?: 'BoughtTreatmentAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    adjustmentType: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    boughtTreatmentKind: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    insuranceIds: Scalars['Int']['output'];
    isVirtual: Scalars['Int']['output'];
    lastUpdatedAt: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    overrideReason: Scalars['Int']['output'];
    paymentType: Scalars['Int']['output'];
    previousBoughtTreatmentId: Scalars['Int']['output'];
    price: Scalars['Int']['output'];
    pricedTreatmentId: Scalars['Int']['output'];
    reviewStatus: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    source: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
};

export type BoughtTreatmentAuditLogCountOrderByAggregateInput = {
    adjustmentType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    boughtTreatmentKind?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceIds?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    overrideReason?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    previousBoughtTreatmentId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentAuditLogCreateInput = {
    adjustmentType?: InputMaybe<AdjustmentTypeEnum>;
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentKind?: InputMaybe<BoughtTreatmentKind>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    insuranceIds?: InputMaybe<BoughtTreatmentAuditLogCreateinsuranceIdsInput>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    operation?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    overrideReason?: InputMaybe<Scalars['String']['input']>;
    paymentType?: InputMaybe<PaymentTypeEnum>;
    previousBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    price?: InputMaybe<Scalars['Float']['input']>;
    pricedTreatmentId?: InputMaybe<Scalars['Int']['input']>;
    reviewStatus?: InputMaybe<ReviewStatusEnum>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    source?: InputMaybe<EncounterSourceEnum>;
    status?: InputMaybe<BoughtTreatmentStatusEnum>;
};

export type BoughtTreatmentAuditLogCreateManyInput = {
    adjustmentType?: InputMaybe<AdjustmentTypeEnum>;
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentKind?: InputMaybe<BoughtTreatmentKind>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    insuranceIds?: InputMaybe<BoughtTreatmentAuditLogCreateinsuranceIdsInput>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    operation?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    overrideReason?: InputMaybe<Scalars['String']['input']>;
    paymentType?: InputMaybe<PaymentTypeEnum>;
    previousBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    price?: InputMaybe<Scalars['Float']['input']>;
    pricedTreatmentId?: InputMaybe<Scalars['Int']['input']>;
    reviewStatus?: InputMaybe<ReviewStatusEnum>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    source?: InputMaybe<EncounterSourceEnum>;
    status?: InputMaybe<BoughtTreatmentStatusEnum>;
};

export type BoughtTreatmentAuditLogCreateinsuranceIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type BoughtTreatmentAuditLogGroupBy = {
    __typename?: 'BoughtTreatmentAuditLogGroupBy';
    _avg?: Maybe<BoughtTreatmentAuditLogAvgAggregate>;
    _count?: Maybe<BoughtTreatmentAuditLogCountAggregate>;
    _max?: Maybe<BoughtTreatmentAuditLogMaxAggregate>;
    _min?: Maybe<BoughtTreatmentAuditLogMinAggregate>;
    _sum?: Maybe<BoughtTreatmentAuditLogSumAggregate>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    consumerId?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    insuranceIds?: Maybe<Array<Scalars['String']['output']>>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentType?: Maybe<PaymentTypeEnum>;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<EncounterSourceEnum>;
    status?: Maybe<BoughtTreatmentStatusEnum>;
};

export type BoughtTreatmentAuditLogMaxAggregate = {
    __typename?: 'BoughtTreatmentAuditLogMaxAggregate';
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    consumerId?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentType?: Maybe<PaymentTypeEnum>;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<EncounterSourceEnum>;
    status?: Maybe<BoughtTreatmentStatusEnum>;
};

export type BoughtTreatmentAuditLogMaxOrderByAggregateInput = {
    adjustmentType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    boughtTreatmentKind?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    overrideReason?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    previousBoughtTreatmentId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentAuditLogMinAggregate = {
    __typename?: 'BoughtTreatmentAuditLogMinAggregate';
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    consumerId?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentType?: Maybe<PaymentTypeEnum>;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<EncounterSourceEnum>;
    status?: Maybe<BoughtTreatmentStatusEnum>;
};

export type BoughtTreatmentAuditLogMinOrderByAggregateInput = {
    adjustmentType?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    boughtTreatmentKind?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    overrideReason?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    previousBoughtTreatmentId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<BoughtTreatmentAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<BoughtTreatmentAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<BoughtTreatmentAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<BoughtTreatmentAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<BoughtTreatmentAuditLogSumOrderByAggregateInput>;
    adjustmentType?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    boughtTreatmentKind?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    insuranceIds?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrderInput>;
    lastUpdatedAt?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    overrideReason?: InputMaybe<SortOrderInput>;
    paymentType?: InputMaybe<SortOrderInput>;
    previousBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    price?: InputMaybe<SortOrderInput>;
    pricedTreatmentId?: InputMaybe<SortOrderInput>;
    reviewStatus?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    source?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
};

export type BoughtTreatmentAuditLogOrderByWithRelationInput = {
    adjustmentType?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    boughtTreatmentKind?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    insuranceIds?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrderInput>;
    lastUpdatedAt?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    overrideReason?: InputMaybe<SortOrderInput>;
    paymentType?: InputMaybe<SortOrderInput>;
    previousBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    price?: InputMaybe<SortOrderInput>;
    pricedTreatmentId?: InputMaybe<SortOrderInput>;
    reviewStatus?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    source?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
};

export enum BoughtTreatmentAuditLogScalarFieldEnum {
    AdjustmentType = 'adjustmentType',
    BoughtTreatmentId = 'boughtTreatmentId',
    BoughtTreatmentKind = 'boughtTreatmentKind',
    ConsumerId = 'consumerId',
    HrtId = 'hrtId',
    Id = 'id',
    InsuranceIds = 'insuranceIds',
    IsVirtual = 'isVirtual',
    LastUpdatedAt = 'lastUpdatedAt',
    LastUpdatedBy = 'lastUpdatedBy',
    Name = 'name',
    Operation = 'operation',
    OrgId = 'orgId',
    OverrideReason = 'overrideReason',
    PaymentType = 'paymentType',
    PreviousBoughtTreatmentId = 'previousBoughtTreatmentId',
    Price = 'price',
    PricedTreatmentId = 'pricedTreatmentId',
    ReviewStatus = 'reviewStatus',
    SlotId = 'slotId',
    Source = 'source',
    Status = 'status',
}

export type BoughtTreatmentAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<BoughtTreatmentAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<BoughtTreatmentAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<BoughtTreatmentAuditLogScalarWhereWithAggregatesInput>
    >;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumNullableWithAggregatesFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    boughtTreatmentKind?: InputMaybe<EnumBoughtTreatmentKindNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    hrtId?: InputMaybe<IntNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    isVirtual?: InputMaybe<BoolNullableWithAggregatesFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    name?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    overrideReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumNullableWithAggregatesFilter>;
    previousBoughtTreatmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    price?: InputMaybe<FloatNullableWithAggregatesFilter>;
    pricedTreatmentId?: InputMaybe<IntNullableWithAggregatesFilter>;
    reviewStatus?: InputMaybe<EnumReviewStatusEnumNullableWithAggregatesFilter>;
    slotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumNullableWithAggregatesFilter>;
};

export type BoughtTreatmentAuditLogSumAggregate = {
    __typename?: 'BoughtTreatmentAuditLogSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
};

export type BoughtTreatmentAuditLogSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentAuditLogUpdateInput = {
    adjustmentType?: InputMaybe<NullableEnumAdjustmentTypeEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    boughtTreatmentKind?: InputMaybe<NullableEnumBoughtTreatmentKindFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    insuranceIds?: InputMaybe<BoughtTreatmentAuditLogUpdateinsuranceIdsInput>;
    isVirtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    overrideReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<NullableEnumPaymentTypeEnumFieldUpdateOperationsInput>;
    previousBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    pricedTreatmentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableEnumReviewStatusEnumFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    source?: InputMaybe<NullableEnumEncounterSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumBoughtTreatmentStatusEnumFieldUpdateOperationsInput>;
};

export type BoughtTreatmentAuditLogUpdateManyMutationInput = {
    adjustmentType?: InputMaybe<NullableEnumAdjustmentTypeEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    boughtTreatmentKind?: InputMaybe<NullableEnumBoughtTreatmentKindFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    insuranceIds?: InputMaybe<BoughtTreatmentAuditLogUpdateinsuranceIdsInput>;
    isVirtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    overrideReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<NullableEnumPaymentTypeEnumFieldUpdateOperationsInput>;
    previousBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    pricedTreatmentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableEnumReviewStatusEnumFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    source?: InputMaybe<NullableEnumEncounterSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumBoughtTreatmentStatusEnumFieldUpdateOperationsInput>;
};

export type BoughtTreatmentAuditLogUpdateinsuranceIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BoughtTreatmentAuditLogWhereInput = {
    AND?: InputMaybe<Array<BoughtTreatmentAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<BoughtTreatmentAuditLogWhereInput>>;
    OR?: InputMaybe<Array<BoughtTreatmentAuditLogWhereInput>>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    boughtTreatmentKind?: InputMaybe<EnumBoughtTreatmentKindNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<IntFilter>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    isVirtual?: InputMaybe<BoolNullableFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    overrideReason?: InputMaybe<StringNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumNullableFilter>;
    previousBoughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    price?: InputMaybe<FloatNullableFilter>;
    pricedTreatmentId?: InputMaybe<IntNullableFilter>;
    reviewStatus?: InputMaybe<EnumReviewStatusEnumNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumNullableFilter>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumNullableFilter>;
};

export type BoughtTreatmentAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<BoughtTreatmentAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<BoughtTreatmentAuditLogWhereInput>>;
    OR?: InputMaybe<Array<BoughtTreatmentAuditLogWhereInput>>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    boughtTreatmentKind?: InputMaybe<EnumBoughtTreatmentKindNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    isVirtual?: InputMaybe<BoolNullableFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    overrideReason?: InputMaybe<StringNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumNullableFilter>;
    previousBoughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    price?: InputMaybe<FloatNullableFilter>;
    pricedTreatmentId?: InputMaybe<IntNullableFilter>;
    reviewStatus?: InputMaybe<EnumReviewStatusEnumNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumNullableFilter>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumNullableFilter>;
};

export type BoughtTreatmentAvgAggregate = {
    __typename?: 'BoughtTreatmentAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Float']['output']>;
};

export type BoughtTreatmentAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentByPaymentTypeMap = {
    INSURANCE?: InputMaybe<Array<Scalars['String']['input']>>;
    INSURANCEMAKEITFREE?: InputMaybe<Array<Scalars['String']['input']>>;
    INSURANCEOVERRIDE?: InputMaybe<Array<Scalars['String']['input']>>;
    INSURANCE_ADMIN_CREATED?: InputMaybe<Array<Scalars['String']['input']>>;
    POSTCLAIM?: InputMaybe<Array<Scalars['String']['input']>>;
    SELFPAY?: InputMaybe<Array<Scalars['String']['input']>>;
    SELFPAYDISCOUNTED?: InputMaybe<Array<Scalars['String']['input']>>;
    SELFPAYOVERRIDE?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BoughtTreatmentClaimDetail = {
    __typename?: 'BoughtTreatmentClaimDetail';
    boughtTreatmentId: Scalars['String']['output'];
    claimIds: Array<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    inCollections?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    procedureCodes: Array<Scalars['String']['output']>;
    remarkCodes: Array<Scalars['String']['output']>;
    swapReason?: Maybe<PriceSwapReasonEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BoughtTreatmentClaimDetailAvgAggregate = {
    __typename?: 'BoughtTreatmentClaimDetailAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type BoughtTreatmentClaimDetailAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentClaimDetailCountAggregate = {
    __typename?: 'BoughtTreatmentClaimDetailCountAggregate';
    _all: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    claimIds: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    inCollections: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    procedureCodes: Scalars['Int']['output'];
    remarkCodes: Scalars['Int']['output'];
    swapReason: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type BoughtTreatmentClaimDetailCountOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    inCollections?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    remarkCodes?: InputMaybe<SortOrder>;
    swapReason?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentClaimDetailCreateInput = {
    boughtTreatmentId: Scalars['String']['input'];
    claimIds?: InputMaybe<BoughtTreatmentClaimDetailCreateclaimIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    inCollections?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    procedureCodes?: InputMaybe<BoughtTreatmentClaimDetailCreateprocedureCodesInput>;
    remarkCodes?: InputMaybe<BoughtTreatmentClaimDetailCreateremarkCodesInput>;
    swapReason?: InputMaybe<PriceSwapReasonEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BoughtTreatmentClaimDetailCreateManyInput = {
    boughtTreatmentId: Scalars['String']['input'];
    claimIds?: InputMaybe<BoughtTreatmentClaimDetailCreateclaimIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    inCollections?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    procedureCodes?: InputMaybe<BoughtTreatmentClaimDetailCreateprocedureCodesInput>;
    remarkCodes?: InputMaybe<BoughtTreatmentClaimDetailCreateremarkCodesInput>;
    swapReason?: InputMaybe<PriceSwapReasonEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BoughtTreatmentClaimDetailCreateclaimIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type BoughtTreatmentClaimDetailCreateprocedureCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type BoughtTreatmentClaimDetailCreateremarkCodesInput = {
    set: Array<Scalars['String']['input']>;
};

export type BoughtTreatmentClaimDetailGroupBy = {
    __typename?: 'BoughtTreatmentClaimDetailGroupBy';
    _avg?: Maybe<BoughtTreatmentClaimDetailAvgAggregate>;
    _count?: Maybe<BoughtTreatmentClaimDetailCountAggregate>;
    _max?: Maybe<BoughtTreatmentClaimDetailMaxAggregate>;
    _min?: Maybe<BoughtTreatmentClaimDetailMinAggregate>;
    _sum?: Maybe<BoughtTreatmentClaimDetailSumAggregate>;
    boughtTreatmentId: Scalars['String']['output'];
    claimIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    inCollections?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    procedureCodes?: Maybe<Array<Scalars['String']['output']>>;
    remarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    swapReason?: Maybe<PriceSwapReasonEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BoughtTreatmentClaimDetailMaxAggregate = {
    __typename?: 'BoughtTreatmentClaimDetailMaxAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    inCollections?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    swapReason?: Maybe<PriceSwapReasonEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BoughtTreatmentClaimDetailMaxOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    inCollections?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    swapReason?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentClaimDetailMinAggregate = {
    __typename?: 'BoughtTreatmentClaimDetailMinAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    inCollections?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    swapReason?: Maybe<PriceSwapReasonEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BoughtTreatmentClaimDetailMinOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    inCollections?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    swapReason?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentClaimDetailOrderByWithAggregationInput = {
    _avg?: InputMaybe<BoughtTreatmentClaimDetailAvgOrderByAggregateInput>;
    _count?: InputMaybe<BoughtTreatmentClaimDetailCountOrderByAggregateInput>;
    _max?: InputMaybe<BoughtTreatmentClaimDetailMaxOrderByAggregateInput>;
    _min?: InputMaybe<BoughtTreatmentClaimDetailMinOrderByAggregateInput>;
    _sum?: InputMaybe<BoughtTreatmentClaimDetailSumOrderByAggregateInput>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    inCollections?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    remarkCodes?: InputMaybe<SortOrder>;
    swapReason?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export type BoughtTreatmentClaimDetailOrderByWithRelationInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    inCollections?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    procedureCodes?: InputMaybe<SortOrder>;
    remarkCodes?: InputMaybe<SortOrder>;
    swapReason?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export enum BoughtTreatmentClaimDetailScalarFieldEnum {
    BoughtTreatmentId = 'boughtTreatmentId',
    ClaimIds = 'claimIds',
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    Id = 'id',
    InCollections = 'inCollections',
    LastUpdatedBy = 'lastUpdatedBy',
    OrgId = 'orgId',
    ProcedureCodes = 'procedureCodes',
    RemarkCodes = 'remarkCodes',
    SwapReason = 'swapReason',
    UpdatedAt = 'updatedAt',
}

export type BoughtTreatmentClaimDetailScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<BoughtTreatmentClaimDetailScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<BoughtTreatmentClaimDetailScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<BoughtTreatmentClaimDetailScalarWhereWithAggregatesInput>
    >;
    boughtTreatmentId?: InputMaybe<UuidWithAggregatesFilter>;
    claimIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    inCollections?: InputMaybe<BoolNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    remarkCodes?: InputMaybe<StringNullableListFilter>;
    swapReason?: InputMaybe<EnumPriceSwapReasonEnumNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type BoughtTreatmentClaimDetailSumAggregate = {
    __typename?: 'BoughtTreatmentClaimDetailSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type BoughtTreatmentClaimDetailSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentClaimDetailUpdateInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimIds?: InputMaybe<BoughtTreatmentClaimDetailUpdateclaimIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    inCollections?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    procedureCodes?: InputMaybe<BoughtTreatmentClaimDetailUpdateprocedureCodesInput>;
    remarkCodes?: InputMaybe<BoughtTreatmentClaimDetailUpdateremarkCodesInput>;
    swapReason?: InputMaybe<NullableEnumPriceSwapReasonEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type BoughtTreatmentClaimDetailUpdateManyMutationInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimIds?: InputMaybe<BoughtTreatmentClaimDetailUpdateclaimIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    inCollections?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    procedureCodes?: InputMaybe<BoughtTreatmentClaimDetailUpdateprocedureCodesInput>;
    remarkCodes?: InputMaybe<BoughtTreatmentClaimDetailUpdateremarkCodesInput>;
    swapReason?: InputMaybe<NullableEnumPriceSwapReasonEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type BoughtTreatmentClaimDetailUpdateclaimIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BoughtTreatmentClaimDetailUpdateprocedureCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BoughtTreatmentClaimDetailUpdateremarkCodesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BoughtTreatmentClaimDetailWhereInput = {
    AND?: InputMaybe<Array<BoughtTreatmentClaimDetailWhereInput>>;
    NOT?: InputMaybe<Array<BoughtTreatmentClaimDetailWhereInput>>;
    OR?: InputMaybe<Array<BoughtTreatmentClaimDetailWhereInput>>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    claimIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    inCollections?: InputMaybe<BoolNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    remarkCodes?: InputMaybe<StringNullableListFilter>;
    swapReason?: InputMaybe<EnumPriceSwapReasonEnumNullableFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type BoughtTreatmentClaimDetailWhereUniqueInput = {
    AND?: InputMaybe<Array<BoughtTreatmentClaimDetailWhereInput>>;
    NOT?: InputMaybe<Array<BoughtTreatmentClaimDetailWhereInput>>;
    OR?: InputMaybe<Array<BoughtTreatmentClaimDetailWhereInput>>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    claimIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    inCollections?: InputMaybe<BoolNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    procedureCodes?: InputMaybe<StringNullableListFilter>;
    remarkCodes?: InputMaybe<StringNullableListFilter>;
    swapReason?: InputMaybe<EnumPriceSwapReasonEnumNullableFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type BoughtTreatmentCount = {
    __typename?: 'BoughtTreatmentCount';
    candidateTreatments: Scalars['Int']['output'];
};

export type BoughtTreatmentCountCandidateTreatmentsArgs = {
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type BoughtTreatmentCountAggregate = {
    __typename?: 'BoughtTreatmentCountAggregate';
    _all: Scalars['Int']['output'];
    adjustmentType: Scalars['Int']['output'];
    boughtTreatmentKind: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    discountCodeApplied: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    insuranceIds: Scalars['Int']['output'];
    isVirtual: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    overrideReason: Scalars['Int']['output'];
    paymentContactId: Scalars['Int']['output'];
    paymentType: Scalars['Int']['output'];
    previousBoughtTreatmentId: Scalars['Int']['output'];
    price: Scalars['Int']['output'];
    pricedTreatmentId: Scalars['Int']['output'];
    reviewStatus: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    source: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type BoughtTreatmentCountOrderByAggregateInput = {
    adjustmentType?: InputMaybe<SortOrder>;
    boughtTreatmentKind?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    discountCodeApplied?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceIds?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    overrideReason?: InputMaybe<SortOrder>;
    paymentContactId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    previousBoughtTreatmentId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentCreateInput = {
    adjustmentType?: InputMaybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: InputMaybe<BoughtTreatmentKind>;
    candidateTreatments?: InputMaybe<CandidateTreatmentCreateNestedManyWithoutBoughtTreatmentInput>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    discountCodeApplied?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<BoughtTreatmentCreateinsuranceIdsInput>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    overrideReason?: InputMaybe<Scalars['String']['input']>;
    paymentContactId?: InputMaybe<Scalars['String']['input']>;
    paymentType: PaymentTypeEnum;
    previousBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    price: Scalars['Float']['input'];
    pricedTreatmentId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<ReviewStatusEnum>;
    slot?: InputMaybe<SlotCreateNestedOneWithoutBoughtTreatmentsInput>;
    source: EncounterSourceEnum;
    status?: InputMaybe<BoughtTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BoughtTreatmentCreateManyInput = {
    adjustmentType?: InputMaybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: InputMaybe<BoughtTreatmentKind>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    discountCodeApplied?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<BoughtTreatmentCreateinsuranceIdsInput>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    overrideReason?: InputMaybe<Scalars['String']['input']>;
    paymentContactId?: InputMaybe<Scalars['String']['input']>;
    paymentType: PaymentTypeEnum;
    previousBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    price: Scalars['Float']['input'];
    pricedTreatmentId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<ReviewStatusEnum>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    source: EncounterSourceEnum;
    status?: InputMaybe<BoughtTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BoughtTreatmentCreateManySlotInput = {
    adjustmentType?: InputMaybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: InputMaybe<BoughtTreatmentKind>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    discountCodeApplied?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<BoughtTreatmentCreateinsuranceIdsInput>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    overrideReason?: InputMaybe<Scalars['String']['input']>;
    paymentContactId?: InputMaybe<Scalars['String']['input']>;
    paymentType: PaymentTypeEnum;
    previousBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    price: Scalars['Float']['input'];
    pricedTreatmentId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<ReviewStatusEnum>;
    source: EncounterSourceEnum;
    status?: InputMaybe<BoughtTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BoughtTreatmentCreateManySlotInputEnvelope = {
    data: Array<BoughtTreatmentCreateManySlotInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoughtTreatmentCreateNestedManyWithoutSlotInput = {
    connect?: InputMaybe<Array<BoughtTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<BoughtTreatmentCreateOrConnectWithoutSlotInput>
    >;
    create?: InputMaybe<Array<BoughtTreatmentCreateWithoutSlotInput>>;
    createMany?: InputMaybe<BoughtTreatmentCreateManySlotInputEnvelope>;
};

export type BoughtTreatmentCreateNestedOneWithoutCandidateTreatmentsInput = {
    connect?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    connectOrCreate?: InputMaybe<BoughtTreatmentCreateOrConnectWithoutCandidateTreatmentsInput>;
    create?: InputMaybe<BoughtTreatmentCreateWithoutCandidateTreatmentsInput>;
};

export type BoughtTreatmentCreateOrConnectWithoutCandidateTreatmentsInput = {
    create: BoughtTreatmentCreateWithoutCandidateTreatmentsInput;
    where: BoughtTreatmentWhereUniqueInput;
};

export type BoughtTreatmentCreateOrConnectWithoutSlotInput = {
    create: BoughtTreatmentCreateWithoutSlotInput;
    where: BoughtTreatmentWhereUniqueInput;
};

export type BoughtTreatmentCreateWithoutCandidateTreatmentsInput = {
    adjustmentType?: InputMaybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: InputMaybe<BoughtTreatmentKind>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    discountCodeApplied?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<BoughtTreatmentCreateinsuranceIdsInput>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    overrideReason?: InputMaybe<Scalars['String']['input']>;
    paymentContactId?: InputMaybe<Scalars['String']['input']>;
    paymentType: PaymentTypeEnum;
    previousBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    price: Scalars['Float']['input'];
    pricedTreatmentId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<ReviewStatusEnum>;
    slot?: InputMaybe<SlotCreateNestedOneWithoutBoughtTreatmentsInput>;
    source: EncounterSourceEnum;
    status?: InputMaybe<BoughtTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BoughtTreatmentCreateWithoutSlotInput = {
    adjustmentType?: InputMaybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: InputMaybe<BoughtTreatmentKind>;
    candidateTreatments?: InputMaybe<CandidateTreatmentCreateNestedManyWithoutBoughtTreatmentInput>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    discountCodeApplied?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<BoughtTreatmentCreateinsuranceIdsInput>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    overrideReason?: InputMaybe<Scalars['String']['input']>;
    paymentContactId?: InputMaybe<Scalars['String']['input']>;
    paymentType: PaymentTypeEnum;
    previousBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    price: Scalars['Float']['input'];
    pricedTreatmentId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<ReviewStatusEnum>;
    source: EncounterSourceEnum;
    status?: InputMaybe<BoughtTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BoughtTreatmentCreateinsuranceIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type BoughtTreatmentGroupBy = {
    __typename?: 'BoughtTreatmentGroupBy';
    _avg?: Maybe<BoughtTreatmentAvgAggregate>;
    _count?: Maybe<BoughtTreatmentCountAggregate>;
    _max?: Maybe<BoughtTreatmentMaxAggregate>;
    _min?: Maybe<BoughtTreatmentMinAggregate>;
    _sum?: Maybe<BoughtTreatmentSumAggregate>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    discountCodeApplied?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['String']['output'];
    insuranceIds?: Maybe<Array<Scalars['String']['output']>>;
    isVirtual: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentContactId?: Maybe<Scalars['String']['output']>;
    paymentType: PaymentTypeEnum;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price: Scalars['Float']['output'];
    pricedTreatmentId: Scalars['Int']['output'];
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    source: EncounterSourceEnum;
    status: BoughtTreatmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export enum BoughtTreatmentKind {
    Unapplied = 'UNAPPLIED',
}

export type BoughtTreatmentListRelationFilter = {
    every?: InputMaybe<BoughtTreatmentWhereInput>;
    none?: InputMaybe<BoughtTreatmentWhereInput>;
    some?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type BoughtTreatmentMaxAggregate = {
    __typename?: 'BoughtTreatmentMaxAggregate';
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    discountCodeApplied?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentContactId?: Maybe<Scalars['String']['output']>;
    paymentType?: Maybe<PaymentTypeEnum>;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<EncounterSourceEnum>;
    status?: Maybe<BoughtTreatmentStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BoughtTreatmentMaxOrderByAggregateInput = {
    adjustmentType?: InputMaybe<SortOrder>;
    boughtTreatmentKind?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    discountCodeApplied?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    overrideReason?: InputMaybe<SortOrder>;
    paymentContactId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    previousBoughtTreatmentId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentMinAggregate = {
    __typename?: 'BoughtTreatmentMinAggregate';
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    discountCodeApplied?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentContactId?: Maybe<Scalars['String']['output']>;
    paymentType?: Maybe<PaymentTypeEnum>;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<EncounterSourceEnum>;
    status?: Maybe<BoughtTreatmentStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BoughtTreatmentMinOrderByAggregateInput = {
    adjustmentType?: InputMaybe<SortOrder>;
    boughtTreatmentKind?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    discountCodeApplied?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    overrideReason?: InputMaybe<SortOrder>;
    paymentContactId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    previousBoughtTreatmentId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentNullableRelationFilter = {
    is?: InputMaybe<BoughtTreatmentWhereInput>;
    isNot?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type BoughtTreatmentOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentOrderByWithAggregationInput = {
    _avg?: InputMaybe<BoughtTreatmentAvgOrderByAggregateInput>;
    _count?: InputMaybe<BoughtTreatmentCountOrderByAggregateInput>;
    _max?: InputMaybe<BoughtTreatmentMaxOrderByAggregateInput>;
    _min?: InputMaybe<BoughtTreatmentMinOrderByAggregateInput>;
    _sum?: InputMaybe<BoughtTreatmentSumOrderByAggregateInput>;
    adjustmentType?: InputMaybe<SortOrderInput>;
    boughtTreatmentKind?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    discountCodeApplied?: InputMaybe<SortOrderInput>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    insuranceIds?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    overrideReason?: InputMaybe<SortOrderInput>;
    paymentContactId?: InputMaybe<SortOrderInput>;
    paymentType?: InputMaybe<SortOrder>;
    previousBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentOrderByWithRelationInput = {
    adjustmentType?: InputMaybe<SortOrderInput>;
    boughtTreatmentKind?: InputMaybe<SortOrderInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentOrderByRelationAggregateInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    discountCodeApplied?: InputMaybe<SortOrderInput>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    insuranceIds?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    overrideReason?: InputMaybe<SortOrderInput>;
    paymentContactId?: InputMaybe<SortOrderInput>;
    paymentType?: InputMaybe<SortOrder>;
    previousBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrderInput>;
    slot?: InputMaybe<SlotOrderByWithRelationInput>;
    slotId?: InputMaybe<SortOrderInput>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum BoughtTreatmentScalarFieldEnum {
    AdjustmentType = 'adjustmentType',
    BoughtTreatmentKind = 'boughtTreatmentKind',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    DiscountCodeApplied = 'discountCodeApplied',
    HrtId = 'hrtId',
    Id = 'id',
    InsuranceIds = 'insuranceIds',
    IsVirtual = 'isVirtual',
    LastUpdatedBy = 'lastUpdatedBy',
    Name = 'name',
    OrgId = 'orgId',
    OverrideReason = 'overrideReason',
    PaymentContactId = 'paymentContactId',
    PaymentType = 'paymentType',
    PreviousBoughtTreatmentId = 'previousBoughtTreatmentId',
    Price = 'price',
    PricedTreatmentId = 'pricedTreatmentId',
    ReviewStatus = 'reviewStatus',
    SlotId = 'slotId',
    Source = 'source',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type BoughtTreatmentScalarWhereInput = {
    AND?: InputMaybe<Array<BoughtTreatmentScalarWhereInput>>;
    NOT?: InputMaybe<Array<BoughtTreatmentScalarWhereInput>>;
    OR?: InputMaybe<Array<BoughtTreatmentScalarWhereInput>>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumNullableFilter>;
    boughtTreatmentKind?: InputMaybe<EnumBoughtTreatmentKindNullableFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    discountCodeApplied?: InputMaybe<StringNullableFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    isVirtual?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    overrideReason?: InputMaybe<StringNullableFilter>;
    paymentContactId?: InputMaybe<UuidNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFilter>;
    previousBoughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    price?: InputMaybe<FloatFilter>;
    pricedTreatmentId?: InputMaybe<IntFilter>;
    reviewStatus?: InputMaybe<EnumReviewStatusEnumNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumFilter>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BoughtTreatmentScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<BoughtTreatmentScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<BoughtTreatmentScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<BoughtTreatmentScalarWhereWithAggregatesInput>>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumNullableWithAggregatesFilter>;
    boughtTreatmentKind?: InputMaybe<EnumBoughtTreatmentKindNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    discountCodeApplied?: InputMaybe<StringNullableWithAggregatesFilter>;
    hrtId?: InputMaybe<IntNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    isVirtual?: InputMaybe<BoolWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    overrideReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    paymentContactId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumWithAggregatesFilter>;
    previousBoughtTreatmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    price?: InputMaybe<FloatWithAggregatesFilter>;
    pricedTreatmentId?: InputMaybe<IntWithAggregatesFilter>;
    reviewStatus?: InputMaybe<EnumReviewStatusEnumNullableWithAggregatesFilter>;
    slotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumWithAggregatesFilter>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum BoughtTreatmentStatusEnum {
    Active = 'active',
    Canceled = 'canceled',
    Deleted = 'deleted',
}

export type BoughtTreatmentSumAggregate = {
    __typename?: 'BoughtTreatmentSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
};

export type BoughtTreatmentSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
};

export type BoughtTreatmentUpdateInput = {
    adjustmentType?: InputMaybe<NullableEnumAdjustmentTypeEnumFieldUpdateOperationsInput>;
    boughtTreatmentKind?: InputMaybe<NullableEnumBoughtTreatmentKindFieldUpdateOperationsInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentUpdateManyWithoutBoughtTreatmentNestedInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    discountCodeApplied?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceIds?: InputMaybe<BoughtTreatmentUpdateinsuranceIdsInput>;
    isVirtual?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    overrideReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFieldUpdateOperationsInput>;
    previousBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    price?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricedTreatmentId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableEnumReviewStatusEnumFieldUpdateOperationsInput>;
    slot?: InputMaybe<SlotUpdateOneWithoutBoughtTreatmentsNestedInput>;
    source?: InputMaybe<EnumEncounterSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BoughtTreatmentUpdateManyMutationInput = {
    adjustmentType?: InputMaybe<NullableEnumAdjustmentTypeEnumFieldUpdateOperationsInput>;
    boughtTreatmentKind?: InputMaybe<NullableEnumBoughtTreatmentKindFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    discountCodeApplied?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceIds?: InputMaybe<BoughtTreatmentUpdateinsuranceIdsInput>;
    isVirtual?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    overrideReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFieldUpdateOperationsInput>;
    previousBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    price?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricedTreatmentId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableEnumReviewStatusEnumFieldUpdateOperationsInput>;
    source?: InputMaybe<EnumEncounterSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BoughtTreatmentUpdateManyWithWhereWithoutSlotInput = {
    data: BoughtTreatmentUpdateManyMutationInput;
    where: BoughtTreatmentScalarWhereInput;
};

export type BoughtTreatmentUpdateManyWithoutSlotNestedInput = {
    connect?: InputMaybe<Array<BoughtTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<BoughtTreatmentCreateOrConnectWithoutSlotInput>
    >;
    create?: InputMaybe<Array<BoughtTreatmentCreateWithoutSlotInput>>;
    createMany?: InputMaybe<BoughtTreatmentCreateManySlotInputEnvelope>;
    delete?: InputMaybe<Array<BoughtTreatmentWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<BoughtTreatmentScalarWhereInput>>;
    disconnect?: InputMaybe<Array<BoughtTreatmentWhereUniqueInput>>;
    set?: InputMaybe<Array<BoughtTreatmentWhereUniqueInput>>;
    update?: InputMaybe<
        Array<BoughtTreatmentUpdateWithWhereUniqueWithoutSlotInput>
    >;
    updateMany?: InputMaybe<
        Array<BoughtTreatmentUpdateManyWithWhereWithoutSlotInput>
    >;
    upsert?: InputMaybe<
        Array<BoughtTreatmentUpsertWithWhereUniqueWithoutSlotInput>
    >;
};

export type BoughtTreatmentUpdateOneWithoutCandidateTreatmentsNestedInput = {
    connect?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    connectOrCreate?: InputMaybe<BoughtTreatmentCreateOrConnectWithoutCandidateTreatmentsInput>;
    create?: InputMaybe<BoughtTreatmentCreateWithoutCandidateTreatmentsInput>;
    delete?: InputMaybe<BoughtTreatmentWhereInput>;
    disconnect?: InputMaybe<BoughtTreatmentWhereInput>;
    update?: InputMaybe<BoughtTreatmentUpdateToOneWithWhereWithoutCandidateTreatmentsInput>;
    upsert?: InputMaybe<BoughtTreatmentUpsertWithoutCandidateTreatmentsInput>;
};

export type BoughtTreatmentUpdateToOneWithWhereWithoutCandidateTreatmentsInput =
    {
        data: BoughtTreatmentUpdateWithoutCandidateTreatmentsInput;
        where?: InputMaybe<BoughtTreatmentWhereInput>;
    };

export type BoughtTreatmentUpdateWithWhereUniqueWithoutSlotInput = {
    data: BoughtTreatmentUpdateWithoutSlotInput;
    where: BoughtTreatmentWhereUniqueInput;
};

export type BoughtTreatmentUpdateWithoutCandidateTreatmentsInput = {
    adjustmentType?: InputMaybe<NullableEnumAdjustmentTypeEnumFieldUpdateOperationsInput>;
    boughtTreatmentKind?: InputMaybe<NullableEnumBoughtTreatmentKindFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    discountCodeApplied?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceIds?: InputMaybe<BoughtTreatmentUpdateinsuranceIdsInput>;
    isVirtual?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    overrideReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFieldUpdateOperationsInput>;
    previousBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    price?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricedTreatmentId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableEnumReviewStatusEnumFieldUpdateOperationsInput>;
    slot?: InputMaybe<SlotUpdateOneWithoutBoughtTreatmentsNestedInput>;
    source?: InputMaybe<EnumEncounterSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BoughtTreatmentUpdateWithoutSlotInput = {
    adjustmentType?: InputMaybe<NullableEnumAdjustmentTypeEnumFieldUpdateOperationsInput>;
    boughtTreatmentKind?: InputMaybe<NullableEnumBoughtTreatmentKindFieldUpdateOperationsInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentUpdateManyWithoutBoughtTreatmentNestedInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    discountCodeApplied?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceIds?: InputMaybe<BoughtTreatmentUpdateinsuranceIdsInput>;
    isVirtual?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    overrideReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFieldUpdateOperationsInput>;
    previousBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    price?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricedTreatmentId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableEnumReviewStatusEnumFieldUpdateOperationsInput>;
    source?: InputMaybe<EnumEncounterSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BoughtTreatmentUpdateinsuranceIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BoughtTreatmentUpsertWithWhereUniqueWithoutSlotInput = {
    create: BoughtTreatmentCreateWithoutSlotInput;
    update: BoughtTreatmentUpdateWithoutSlotInput;
    where: BoughtTreatmentWhereUniqueInput;
};

export type BoughtTreatmentUpsertWithoutCandidateTreatmentsInput = {
    create: BoughtTreatmentCreateWithoutCandidateTreatmentsInput;
    update: BoughtTreatmentUpdateWithoutCandidateTreatmentsInput;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type BoughtTreatmentWhereInput = {
    AND?: InputMaybe<Array<BoughtTreatmentWhereInput>>;
    NOT?: InputMaybe<Array<BoughtTreatmentWhereInput>>;
    OR?: InputMaybe<Array<BoughtTreatmentWhereInput>>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumNullableFilter>;
    boughtTreatmentKind?: InputMaybe<EnumBoughtTreatmentKindNullableFilter>;
    candidateTreatments?: InputMaybe<CandidateTreatmentListRelationFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    discountCodeApplied?: InputMaybe<StringNullableFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    isVirtual?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    overrideReason?: InputMaybe<StringNullableFilter>;
    paymentContactId?: InputMaybe<UuidNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFilter>;
    previousBoughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    price?: InputMaybe<FloatFilter>;
    pricedTreatmentId?: InputMaybe<IntFilter>;
    reviewStatus?: InputMaybe<EnumReviewStatusEnumNullableFilter>;
    slot?: InputMaybe<SlotNullableRelationFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumFilter>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BoughtTreatmentWhereUniqueInput = {
    AND?: InputMaybe<Array<BoughtTreatmentWhereInput>>;
    NOT?: InputMaybe<Array<BoughtTreatmentWhereInput>>;
    OR?: InputMaybe<Array<BoughtTreatmentWhereInput>>;
    adjustmentType?: InputMaybe<EnumAdjustmentTypeEnumNullableFilter>;
    boughtTreatmentKind?: InputMaybe<EnumBoughtTreatmentKindNullableFilter>;
    candidateTreatments?: InputMaybe<CandidateTreatmentListRelationFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    discountCodeApplied?: InputMaybe<StringNullableFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    isVirtual?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    overrideReason?: InputMaybe<StringNullableFilter>;
    paymentContactId?: InputMaybe<UuidNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeEnumFilter>;
    previousBoughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    price?: InputMaybe<FloatFilter>;
    pricedTreatmentId?: InputMaybe<IntFilter>;
    reviewStatus?: InputMaybe<EnumReviewStatusEnumNullableFilter>;
    slot?: InputMaybe<SlotNullableRelationFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumFilter>;
    status?: InputMaybe<EnumBoughtTreatmentStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BulkChargeCardRun = {
    __typename?: 'BulkChargeCardRun';
    _count?: Maybe<BulkChargeCardRunCount>;
    createdAt: Scalars['DateTimeISO']['output'];
    createdBy: Scalars['String']['output'];
    csvS3Key?: Maybe<Scalars['String']['output']>;
    failedCount: Scalars['Int']['output'];
    id: Scalars['String']['output'];
    isDryRun: Scalars['Boolean']['output'];
    items: Array<BulkChargeCardRunItem>;
    orgId: Scalars['Int']['output'];
    orgName: Scalars['String']['output'];
    runDate: Scalars['String']['output'];
    skippedCount: Scalars['Int']['output'];
    status: Scalars['String']['output'];
    succeededCount: Scalars['Int']['output'];
    totalItems: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type BulkChargeCardRunItemsArgs = {
    cursor?: InputMaybe<BulkChargeCardRunItemWhereUniqueInput>;
    distinct?: InputMaybe<Array<BulkChargeCardRunItemScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BulkChargeCardRunItemOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunItemWhereInput>;
};

export type BulkChargeCardRunAvgAggregate = {
    __typename?: 'BulkChargeCardRunAvgAggregate';
    failedCount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    skippedCount?: Maybe<Scalars['Float']['output']>;
    succeededCount?: Maybe<Scalars['Float']['output']>;
    totalItems?: Maybe<Scalars['Float']['output']>;
};

export type BulkChargeCardRunAvgOrderByAggregateInput = {
    failedCount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    skippedCount?: InputMaybe<SortOrder>;
    succeededCount?: InputMaybe<SortOrder>;
    totalItems?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunCount = {
    __typename?: 'BulkChargeCardRunCount';
    items: Scalars['Int']['output'];
};

export type BulkChargeCardRunCountItemsArgs = {
    where?: InputMaybe<BulkChargeCardRunItemWhereInput>;
};

export type BulkChargeCardRunCountAggregate = {
    __typename?: 'BulkChargeCardRunCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    createdBy: Scalars['Int']['output'];
    csvS3Key: Scalars['Int']['output'];
    failedCount: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isDryRun: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    orgName: Scalars['Int']['output'];
    runDate: Scalars['Int']['output'];
    skippedCount: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    succeededCount: Scalars['Int']['output'];
    totalItems: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type BulkChargeCardRunCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    csvS3Key?: InputMaybe<SortOrder>;
    failedCount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isDryRun?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    orgName?: InputMaybe<SortOrder>;
    runDate?: InputMaybe<SortOrder>;
    skippedCount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    succeededCount?: InputMaybe<SortOrder>;
    totalItems?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy: Scalars['String']['input'];
    csvS3Key?: InputMaybe<Scalars['String']['input']>;
    failedCount?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    isDryRun: Scalars['Boolean']['input'];
    items?: InputMaybe<BulkChargeCardRunItemCreateNestedManyWithoutRunInput>;
    orgId: Scalars['Int']['input'];
    orgName: Scalars['String']['input'];
    runDate: Scalars['String']['input'];
    skippedCount?: InputMaybe<Scalars['Int']['input']>;
    status: Scalars['String']['input'];
    succeededCount?: InputMaybe<Scalars['Int']['input']>;
    totalItems: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BulkChargeCardRunCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy: Scalars['String']['input'];
    csvS3Key?: InputMaybe<Scalars['String']['input']>;
    failedCount?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    isDryRun: Scalars['Boolean']['input'];
    orgId: Scalars['Int']['input'];
    orgName: Scalars['String']['input'];
    runDate: Scalars['String']['input'];
    skippedCount?: InputMaybe<Scalars['Int']['input']>;
    status: Scalars['String']['input'];
    succeededCount?: InputMaybe<Scalars['Int']['input']>;
    totalItems: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BulkChargeCardRunCreateNestedOneWithoutItemsInput = {
    connect?: InputMaybe<BulkChargeCardRunWhereUniqueInput>;
    connectOrCreate?: InputMaybe<BulkChargeCardRunCreateOrConnectWithoutItemsInput>;
    create?: InputMaybe<BulkChargeCardRunCreateWithoutItemsInput>;
};

export type BulkChargeCardRunCreateOrConnectWithoutItemsInput = {
    create: BulkChargeCardRunCreateWithoutItemsInput;
    where: BulkChargeCardRunWhereUniqueInput;
};

export type BulkChargeCardRunCreateWithoutItemsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy: Scalars['String']['input'];
    csvS3Key?: InputMaybe<Scalars['String']['input']>;
    failedCount?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    isDryRun: Scalars['Boolean']['input'];
    orgId: Scalars['Int']['input'];
    orgName: Scalars['String']['input'];
    runDate: Scalars['String']['input'];
    skippedCount?: InputMaybe<Scalars['Int']['input']>;
    status: Scalars['String']['input'];
    succeededCount?: InputMaybe<Scalars['Int']['input']>;
    totalItems: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BulkChargeCardRunGroupBy = {
    __typename?: 'BulkChargeCardRunGroupBy';
    _avg?: Maybe<BulkChargeCardRunAvgAggregate>;
    _count?: Maybe<BulkChargeCardRunCountAggregate>;
    _max?: Maybe<BulkChargeCardRunMaxAggregate>;
    _min?: Maybe<BulkChargeCardRunMinAggregate>;
    _sum?: Maybe<BulkChargeCardRunSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    createdBy: Scalars['String']['output'];
    csvS3Key?: Maybe<Scalars['String']['output']>;
    failedCount: Scalars['Int']['output'];
    id: Scalars['String']['output'];
    isDryRun: Scalars['Boolean']['output'];
    orgId: Scalars['Int']['output'];
    orgName: Scalars['String']['output'];
    runDate: Scalars['String']['output'];
    skippedCount: Scalars['Int']['output'];
    status: Scalars['String']['output'];
    succeededCount: Scalars['Int']['output'];
    totalItems: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type BulkChargeCardRunItem = {
    __typename?: 'BulkChargeCardRunItem';
    amountDollars: Scalars['Decimal']['output'];
    appointmentId: Scalars['String']['output'];
    boughtTreatmentIds: Array<Scalars['String']['output']>;
    bulkChargeCardRunId: Scalars['String']['output'];
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    chargedAmountDollars?: Maybe<Scalars['Decimal']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    errorMessage?: Maybe<Scalars['String']['output']>;
    errorReason?: Maybe<Scalars['String']['output']>;
    filteredBtIds: Array<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    paymentIntentId?: Maybe<Scalars['String']['output']>;
    run: BulkChargeCardRun;
    status: Scalars['String']['output'];
    transactionIds: Array<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userId: Scalars['String']['output'];
};

export type BulkChargeCardRunItemAvgAggregate = {
    __typename?: 'BulkChargeCardRunItemAvgAggregate';
    amountDollars?: Maybe<Scalars['Decimal']['output']>;
    chargedAmountDollars?: Maybe<Scalars['Decimal']['output']>;
};

export type BulkChargeCardRunItemAvgOrderByAggregateInput = {
    amountDollars?: InputMaybe<SortOrder>;
    chargedAmountDollars?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunItemCountAggregate = {
    __typename?: 'BulkChargeCardRunItemCountAggregate';
    _all: Scalars['Int']['output'];
    amountDollars: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    boughtTreatmentIds: Scalars['Int']['output'];
    bulkChargeCardRunId: Scalars['Int']['output'];
    cardLastFourDigits: Scalars['Int']['output'];
    chargedAmountDollars: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    errorMessage: Scalars['Int']['output'];
    errorReason: Scalars['Int']['output'];
    filteredBtIds: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    paymentIntentId: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    transactionIds: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
};

export type BulkChargeCardRunItemCountOrderByAggregateInput = {
    amountDollars?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    bulkChargeCardRunId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    chargedAmountDollars?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    errorMessage?: InputMaybe<SortOrder>;
    errorReason?: InputMaybe<SortOrder>;
    filteredBtIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentIntentId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunItemCreateInput = {
    amountDollars: Scalars['Decimal']['input'];
    appointmentId: Scalars['String']['input'];
    boughtTreatmentIds?: InputMaybe<BulkChargeCardRunItemCreateboughtTreatmentIdsInput>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    chargedAmountDollars?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    errorReason?: InputMaybe<Scalars['String']['input']>;
    filteredBtIds?: InputMaybe<BulkChargeCardRunItemCreatefilteredBtIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    paymentIntentId?: InputMaybe<Scalars['String']['input']>;
    run: BulkChargeCardRunCreateNestedOneWithoutItemsInput;
    status: Scalars['String']['input'];
    transactionIds?: InputMaybe<BulkChargeCardRunItemCreatetransactionIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId: Scalars['String']['input'];
};

export type BulkChargeCardRunItemCreateManyInput = {
    amountDollars: Scalars['Decimal']['input'];
    appointmentId: Scalars['String']['input'];
    boughtTreatmentIds?: InputMaybe<BulkChargeCardRunItemCreateboughtTreatmentIdsInput>;
    bulkChargeCardRunId: Scalars['String']['input'];
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    chargedAmountDollars?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    errorReason?: InputMaybe<Scalars['String']['input']>;
    filteredBtIds?: InputMaybe<BulkChargeCardRunItemCreatefilteredBtIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    paymentIntentId?: InputMaybe<Scalars['String']['input']>;
    status: Scalars['String']['input'];
    transactionIds?: InputMaybe<BulkChargeCardRunItemCreatetransactionIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId: Scalars['String']['input'];
};

export type BulkChargeCardRunItemCreateManyRunInput = {
    amountDollars: Scalars['Decimal']['input'];
    appointmentId: Scalars['String']['input'];
    boughtTreatmentIds?: InputMaybe<BulkChargeCardRunItemCreateboughtTreatmentIdsInput>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    chargedAmountDollars?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    errorReason?: InputMaybe<Scalars['String']['input']>;
    filteredBtIds?: InputMaybe<BulkChargeCardRunItemCreatefilteredBtIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    paymentIntentId?: InputMaybe<Scalars['String']['input']>;
    status: Scalars['String']['input'];
    transactionIds?: InputMaybe<BulkChargeCardRunItemCreatetransactionIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId: Scalars['String']['input'];
};

export type BulkChargeCardRunItemCreateManyRunInputEnvelope = {
    data: Array<BulkChargeCardRunItemCreateManyRunInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkChargeCardRunItemCreateNestedManyWithoutRunInput = {
    connect?: InputMaybe<Array<BulkChargeCardRunItemWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<BulkChargeCardRunItemCreateOrConnectWithoutRunInput>
    >;
    create?: InputMaybe<Array<BulkChargeCardRunItemCreateWithoutRunInput>>;
    createMany?: InputMaybe<BulkChargeCardRunItemCreateManyRunInputEnvelope>;
};

export type BulkChargeCardRunItemCreateOrConnectWithoutRunInput = {
    create: BulkChargeCardRunItemCreateWithoutRunInput;
    where: BulkChargeCardRunItemWhereUniqueInput;
};

export type BulkChargeCardRunItemCreateWithoutRunInput = {
    amountDollars: Scalars['Decimal']['input'];
    appointmentId: Scalars['String']['input'];
    boughtTreatmentIds?: InputMaybe<BulkChargeCardRunItemCreateboughtTreatmentIdsInput>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    chargedAmountDollars?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    errorReason?: InputMaybe<Scalars['String']['input']>;
    filteredBtIds?: InputMaybe<BulkChargeCardRunItemCreatefilteredBtIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    paymentIntentId?: InputMaybe<Scalars['String']['input']>;
    status: Scalars['String']['input'];
    transactionIds?: InputMaybe<BulkChargeCardRunItemCreatetransactionIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId: Scalars['String']['input'];
};

export type BulkChargeCardRunItemCreateboughtTreatmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type BulkChargeCardRunItemCreatefilteredBtIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type BulkChargeCardRunItemCreatetransactionIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type BulkChargeCardRunItemGroupBy = {
    __typename?: 'BulkChargeCardRunItemGroupBy';
    _avg?: Maybe<BulkChargeCardRunItemAvgAggregate>;
    _count?: Maybe<BulkChargeCardRunItemCountAggregate>;
    _max?: Maybe<BulkChargeCardRunItemMaxAggregate>;
    _min?: Maybe<BulkChargeCardRunItemMinAggregate>;
    _sum?: Maybe<BulkChargeCardRunItemSumAggregate>;
    amountDollars: Scalars['Decimal']['output'];
    appointmentId: Scalars['String']['output'];
    boughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    bulkChargeCardRunId: Scalars['String']['output'];
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    chargedAmountDollars?: Maybe<Scalars['Decimal']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    errorMessage?: Maybe<Scalars['String']['output']>;
    errorReason?: Maybe<Scalars['String']['output']>;
    filteredBtIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['String']['output'];
    paymentIntentId?: Maybe<Scalars['String']['output']>;
    status: Scalars['String']['output'];
    transactionIds?: Maybe<Array<Scalars['String']['output']>>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userId: Scalars['String']['output'];
};

export type BulkChargeCardRunItemListRelationFilter = {
    every?: InputMaybe<BulkChargeCardRunItemWhereInput>;
    none?: InputMaybe<BulkChargeCardRunItemWhereInput>;
    some?: InputMaybe<BulkChargeCardRunItemWhereInput>;
};

export type BulkChargeCardRunItemMaxAggregate = {
    __typename?: 'BulkChargeCardRunItemMaxAggregate';
    amountDollars?: Maybe<Scalars['Decimal']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    bulkChargeCardRunId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    chargedAmountDollars?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    errorMessage?: Maybe<Scalars['String']['output']>;
    errorReason?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    paymentIntentId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type BulkChargeCardRunItemMaxOrderByAggregateInput = {
    amountDollars?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    bulkChargeCardRunId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    chargedAmountDollars?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    errorMessage?: InputMaybe<SortOrder>;
    errorReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentIntentId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunItemMinAggregate = {
    __typename?: 'BulkChargeCardRunItemMinAggregate';
    amountDollars?: Maybe<Scalars['Decimal']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    bulkChargeCardRunId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    chargedAmountDollars?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    errorMessage?: Maybe<Scalars['String']['output']>;
    errorReason?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    paymentIntentId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type BulkChargeCardRunItemMinOrderByAggregateInput = {
    amountDollars?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    bulkChargeCardRunId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    chargedAmountDollars?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    errorMessage?: InputMaybe<SortOrder>;
    errorReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentIntentId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunItemOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunItemOrderByWithAggregationInput = {
    _avg?: InputMaybe<BulkChargeCardRunItemAvgOrderByAggregateInput>;
    _count?: InputMaybe<BulkChargeCardRunItemCountOrderByAggregateInput>;
    _max?: InputMaybe<BulkChargeCardRunItemMaxOrderByAggregateInput>;
    _min?: InputMaybe<BulkChargeCardRunItemMinOrderByAggregateInput>;
    _sum?: InputMaybe<BulkChargeCardRunItemSumOrderByAggregateInput>;
    amountDollars?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    bulkChargeCardRunId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    chargedAmountDollars?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    errorMessage?: InputMaybe<SortOrderInput>;
    errorReason?: InputMaybe<SortOrderInput>;
    filteredBtIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentIntentId?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    transactionIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunItemOrderByWithRelationInput = {
    amountDollars?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    bulkChargeCardRunId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    chargedAmountDollars?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    errorMessage?: InputMaybe<SortOrderInput>;
    errorReason?: InputMaybe<SortOrderInput>;
    filteredBtIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentIntentId?: InputMaybe<SortOrderInput>;
    run?: InputMaybe<BulkChargeCardRunOrderByWithRelationInput>;
    status?: InputMaybe<SortOrder>;
    transactionIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export enum BulkChargeCardRunItemScalarFieldEnum {
    AmountDollars = 'amountDollars',
    AppointmentId = 'appointmentId',
    BoughtTreatmentIds = 'boughtTreatmentIds',
    BulkChargeCardRunId = 'bulkChargeCardRunId',
    CardLastFourDigits = 'cardLastFourDigits',
    ChargedAmountDollars = 'chargedAmountDollars',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    ErrorMessage = 'errorMessage',
    ErrorReason = 'errorReason',
    FilteredBtIds = 'filteredBtIds',
    Id = 'id',
    PaymentIntentId = 'paymentIntentId',
    Status = 'status',
    TransactionIds = 'transactionIds',
    UpdatedAt = 'updatedAt',
    UserId = 'userId',
}

export type BulkChargeCardRunItemScalarWhereInput = {
    AND?: InputMaybe<Array<BulkChargeCardRunItemScalarWhereInput>>;
    NOT?: InputMaybe<Array<BulkChargeCardRunItemScalarWhereInput>>;
    OR?: InputMaybe<Array<BulkChargeCardRunItemScalarWhereInput>>;
    amountDollars?: InputMaybe<DecimalFilter>;
    appointmentId?: InputMaybe<StringFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    bulkChargeCardRunId?: InputMaybe<UuidFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    chargedAmountDollars?: InputMaybe<DecimalNullableFilter>;
    consumerId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    errorMessage?: InputMaybe<StringNullableFilter>;
    errorReason?: InputMaybe<StringNullableFilter>;
    filteredBtIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<StringFilter>;
    paymentIntentId?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<StringFilter>;
    transactionIds?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<StringFilter>;
};

export type BulkChargeCardRunItemScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<BulkChargeCardRunItemScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<BulkChargeCardRunItemScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<BulkChargeCardRunItemScalarWhereWithAggregatesInput>>;
    amountDollars?: InputMaybe<DecimalWithAggregatesFilter>;
    appointmentId?: InputMaybe<StringWithAggregatesFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    bulkChargeCardRunId?: InputMaybe<UuidWithAggregatesFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableWithAggregatesFilter>;
    chargedAmountDollars?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<StringWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    errorMessage?: InputMaybe<StringNullableWithAggregatesFilter>;
    errorReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    filteredBtIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    paymentIntentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<StringWithAggregatesFilter>;
    transactionIds?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type BulkChargeCardRunItemSumAggregate = {
    __typename?: 'BulkChargeCardRunItemSumAggregate';
    amountDollars?: Maybe<Scalars['Decimal']['output']>;
    chargedAmountDollars?: Maybe<Scalars['Decimal']['output']>;
};

export type BulkChargeCardRunItemSumOrderByAggregateInput = {
    amountDollars?: InputMaybe<SortOrder>;
    chargedAmountDollars?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunItemUpdateInput = {
    amountDollars?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<BulkChargeCardRunItemUpdateboughtTreatmentIdsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    chargedAmountDollars?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    errorReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    filteredBtIds?: InputMaybe<BulkChargeCardRunItemUpdatefilteredBtIdsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    run?: InputMaybe<BulkChargeCardRunUpdateOneRequiredWithoutItemsNestedInput>;
    status?: InputMaybe<StringFieldUpdateOperationsInput>;
    transactionIds?: InputMaybe<BulkChargeCardRunItemUpdatetransactionIdsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BulkChargeCardRunItemUpdateManyMutationInput = {
    amountDollars?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<BulkChargeCardRunItemUpdateboughtTreatmentIdsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    chargedAmountDollars?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    errorReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    filteredBtIds?: InputMaybe<BulkChargeCardRunItemUpdatefilteredBtIdsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<StringFieldUpdateOperationsInput>;
    transactionIds?: InputMaybe<BulkChargeCardRunItemUpdatetransactionIdsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BulkChargeCardRunItemUpdateManyWithWhereWithoutRunInput = {
    data: BulkChargeCardRunItemUpdateManyMutationInput;
    where: BulkChargeCardRunItemScalarWhereInput;
};

export type BulkChargeCardRunItemUpdateManyWithoutRunNestedInput = {
    connect?: InputMaybe<Array<BulkChargeCardRunItemWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<BulkChargeCardRunItemCreateOrConnectWithoutRunInput>
    >;
    create?: InputMaybe<Array<BulkChargeCardRunItemCreateWithoutRunInput>>;
    createMany?: InputMaybe<BulkChargeCardRunItemCreateManyRunInputEnvelope>;
    delete?: InputMaybe<Array<BulkChargeCardRunItemWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<BulkChargeCardRunItemScalarWhereInput>>;
    disconnect?: InputMaybe<Array<BulkChargeCardRunItemWhereUniqueInput>>;
    set?: InputMaybe<Array<BulkChargeCardRunItemWhereUniqueInput>>;
    update?: InputMaybe<
        Array<BulkChargeCardRunItemUpdateWithWhereUniqueWithoutRunInput>
    >;
    updateMany?: InputMaybe<
        Array<BulkChargeCardRunItemUpdateManyWithWhereWithoutRunInput>
    >;
    upsert?: InputMaybe<
        Array<BulkChargeCardRunItemUpsertWithWhereUniqueWithoutRunInput>
    >;
};

export type BulkChargeCardRunItemUpdateWithWhereUniqueWithoutRunInput = {
    data: BulkChargeCardRunItemUpdateWithoutRunInput;
    where: BulkChargeCardRunItemWhereUniqueInput;
};

export type BulkChargeCardRunItemUpdateWithoutRunInput = {
    amountDollars?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<BulkChargeCardRunItemUpdateboughtTreatmentIdsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    chargedAmountDollars?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    errorReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    filteredBtIds?: InputMaybe<BulkChargeCardRunItemUpdatefilteredBtIdsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<StringFieldUpdateOperationsInput>;
    transactionIds?: InputMaybe<BulkChargeCardRunItemUpdatetransactionIdsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BulkChargeCardRunItemUpdateboughtTreatmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BulkChargeCardRunItemUpdatefilteredBtIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BulkChargeCardRunItemUpdatetransactionIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BulkChargeCardRunItemUpsertWithWhereUniqueWithoutRunInput = {
    create: BulkChargeCardRunItemCreateWithoutRunInput;
    update: BulkChargeCardRunItemUpdateWithoutRunInput;
    where: BulkChargeCardRunItemWhereUniqueInput;
};

export type BulkChargeCardRunItemWhereInput = {
    AND?: InputMaybe<Array<BulkChargeCardRunItemWhereInput>>;
    NOT?: InputMaybe<Array<BulkChargeCardRunItemWhereInput>>;
    OR?: InputMaybe<Array<BulkChargeCardRunItemWhereInput>>;
    amountDollars?: InputMaybe<DecimalFilter>;
    appointmentId?: InputMaybe<StringFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    bulkChargeCardRunId?: InputMaybe<UuidFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    chargedAmountDollars?: InputMaybe<DecimalNullableFilter>;
    consumerId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    errorMessage?: InputMaybe<StringNullableFilter>;
    errorReason?: InputMaybe<StringNullableFilter>;
    filteredBtIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<StringFilter>;
    paymentIntentId?: InputMaybe<StringNullableFilter>;
    run?: InputMaybe<BulkChargeCardRunRelationFilter>;
    status?: InputMaybe<StringFilter>;
    transactionIds?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<StringFilter>;
};

export type BulkChargeCardRunItemWhereUniqueInput = {
    AND?: InputMaybe<Array<BulkChargeCardRunItemWhereInput>>;
    NOT?: InputMaybe<Array<BulkChargeCardRunItemWhereInput>>;
    OR?: InputMaybe<Array<BulkChargeCardRunItemWhereInput>>;
    amountDollars?: InputMaybe<DecimalFilter>;
    appointmentId?: InputMaybe<StringFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    bulkChargeCardRunId?: InputMaybe<UuidFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    chargedAmountDollars?: InputMaybe<DecimalNullableFilter>;
    consumerId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    errorMessage?: InputMaybe<StringNullableFilter>;
    errorReason?: InputMaybe<StringNullableFilter>;
    filteredBtIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    paymentIntentId?: InputMaybe<StringNullableFilter>;
    run?: InputMaybe<BulkChargeCardRunRelationFilter>;
    status?: InputMaybe<StringFilter>;
    transactionIds?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<StringFilter>;
};

export type BulkChargeCardRunMaxAggregate = {
    __typename?: 'BulkChargeCardRunMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    csvS3Key?: Maybe<Scalars['String']['output']>;
    failedCount?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isDryRun?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    orgName?: Maybe<Scalars['String']['output']>;
    runDate?: Maybe<Scalars['String']['output']>;
    skippedCount?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    succeededCount?: Maybe<Scalars['Int']['output']>;
    totalItems?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BulkChargeCardRunMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    csvS3Key?: InputMaybe<SortOrder>;
    failedCount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isDryRun?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    orgName?: InputMaybe<SortOrder>;
    runDate?: InputMaybe<SortOrder>;
    skippedCount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    succeededCount?: InputMaybe<SortOrder>;
    totalItems?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunMinAggregate = {
    __typename?: 'BulkChargeCardRunMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    csvS3Key?: Maybe<Scalars['String']['output']>;
    failedCount?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isDryRun?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    orgName?: Maybe<Scalars['String']['output']>;
    runDate?: Maybe<Scalars['String']['output']>;
    skippedCount?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    succeededCount?: Maybe<Scalars['Int']['output']>;
    totalItems?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BulkChargeCardRunMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    csvS3Key?: InputMaybe<SortOrder>;
    failedCount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isDryRun?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    orgName?: InputMaybe<SortOrder>;
    runDate?: InputMaybe<SortOrder>;
    skippedCount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    succeededCount?: InputMaybe<SortOrder>;
    totalItems?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunOrderByWithAggregationInput = {
    _avg?: InputMaybe<BulkChargeCardRunAvgOrderByAggregateInput>;
    _count?: InputMaybe<BulkChargeCardRunCountOrderByAggregateInput>;
    _max?: InputMaybe<BulkChargeCardRunMaxOrderByAggregateInput>;
    _min?: InputMaybe<BulkChargeCardRunMinOrderByAggregateInput>;
    _sum?: InputMaybe<BulkChargeCardRunSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    csvS3Key?: InputMaybe<SortOrderInput>;
    failedCount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isDryRun?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    orgName?: InputMaybe<SortOrder>;
    runDate?: InputMaybe<SortOrder>;
    skippedCount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    succeededCount?: InputMaybe<SortOrder>;
    totalItems?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    csvS3Key?: InputMaybe<SortOrderInput>;
    failedCount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isDryRun?: InputMaybe<SortOrder>;
    items?: InputMaybe<BulkChargeCardRunItemOrderByRelationAggregateInput>;
    orgId?: InputMaybe<SortOrder>;
    orgName?: InputMaybe<SortOrder>;
    runDate?: InputMaybe<SortOrder>;
    skippedCount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    succeededCount?: InputMaybe<SortOrder>;
    totalItems?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunRelationFilter = {
    is?: InputMaybe<BulkChargeCardRunWhereInput>;
    isNot?: InputMaybe<BulkChargeCardRunWhereInput>;
};

export enum BulkChargeCardRunScalarFieldEnum {
    CreatedAt = 'createdAt',
    CreatedBy = 'createdBy',
    CsvS3Key = 'csvS3Key',
    FailedCount = 'failedCount',
    Id = 'id',
    IsDryRun = 'isDryRun',
    OrgId = 'orgId',
    OrgName = 'orgName',
    RunDate = 'runDate',
    SkippedCount = 'skippedCount',
    Status = 'status',
    SucceededCount = 'succeededCount',
    TotalItems = 'totalItems',
    UpdatedAt = 'updatedAt',
}

export type BulkChargeCardRunScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<BulkChargeCardRunScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<BulkChargeCardRunScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<BulkChargeCardRunScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    createdBy?: InputMaybe<StringWithAggregatesFilter>;
    csvS3Key?: InputMaybe<StringNullableWithAggregatesFilter>;
    failedCount?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    isDryRun?: InputMaybe<BoolWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    orgName?: InputMaybe<StringWithAggregatesFilter>;
    runDate?: InputMaybe<StringWithAggregatesFilter>;
    skippedCount?: InputMaybe<IntWithAggregatesFilter>;
    status?: InputMaybe<StringWithAggregatesFilter>;
    succeededCount?: InputMaybe<IntWithAggregatesFilter>;
    totalItems?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type BulkChargeCardRunSumAggregate = {
    __typename?: 'BulkChargeCardRunSumAggregate';
    failedCount?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    skippedCount?: Maybe<Scalars['Int']['output']>;
    succeededCount?: Maybe<Scalars['Int']['output']>;
    totalItems?: Maybe<Scalars['Int']['output']>;
};

export type BulkChargeCardRunSumOrderByAggregateInput = {
    failedCount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    skippedCount?: InputMaybe<SortOrder>;
    succeededCount?: InputMaybe<SortOrder>;
    totalItems?: InputMaybe<SortOrder>;
};

export type BulkChargeCardRunUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
    csvS3Key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    failedCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isDryRun?: InputMaybe<BoolFieldUpdateOperationsInput>;
    items?: InputMaybe<BulkChargeCardRunItemUpdateManyWithoutRunNestedInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    runDate?: InputMaybe<StringFieldUpdateOperationsInput>;
    skippedCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<StringFieldUpdateOperationsInput>;
    succeededCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    totalItems?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BulkChargeCardRunUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
    csvS3Key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    failedCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isDryRun?: InputMaybe<BoolFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    runDate?: InputMaybe<StringFieldUpdateOperationsInput>;
    skippedCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<StringFieldUpdateOperationsInput>;
    succeededCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    totalItems?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BulkChargeCardRunUpdateOneRequiredWithoutItemsNestedInput = {
    connect?: InputMaybe<BulkChargeCardRunWhereUniqueInput>;
    connectOrCreate?: InputMaybe<BulkChargeCardRunCreateOrConnectWithoutItemsInput>;
    create?: InputMaybe<BulkChargeCardRunCreateWithoutItemsInput>;
    update?: InputMaybe<BulkChargeCardRunUpdateToOneWithWhereWithoutItemsInput>;
    upsert?: InputMaybe<BulkChargeCardRunUpsertWithoutItemsInput>;
};

export type BulkChargeCardRunUpdateToOneWithWhereWithoutItemsInput = {
    data: BulkChargeCardRunUpdateWithoutItemsInput;
    where?: InputMaybe<BulkChargeCardRunWhereInput>;
};

export type BulkChargeCardRunUpdateWithoutItemsInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
    csvS3Key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    failedCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isDryRun?: InputMaybe<BoolFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    runDate?: InputMaybe<StringFieldUpdateOperationsInput>;
    skippedCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<StringFieldUpdateOperationsInput>;
    succeededCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    totalItems?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BulkChargeCardRunUpsertWithoutItemsInput = {
    create: BulkChargeCardRunCreateWithoutItemsInput;
    update: BulkChargeCardRunUpdateWithoutItemsInput;
    where?: InputMaybe<BulkChargeCardRunWhereInput>;
};

export type BulkChargeCardRunWhereInput = {
    AND?: InputMaybe<Array<BulkChargeCardRunWhereInput>>;
    NOT?: InputMaybe<Array<BulkChargeCardRunWhereInput>>;
    OR?: InputMaybe<Array<BulkChargeCardRunWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    createdBy?: InputMaybe<StringFilter>;
    csvS3Key?: InputMaybe<StringNullableFilter>;
    failedCount?: InputMaybe<IntFilter>;
    id?: InputMaybe<UuidFilter>;
    isDryRun?: InputMaybe<BoolFilter>;
    items?: InputMaybe<BulkChargeCardRunItemListRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgName?: InputMaybe<StringFilter>;
    runDate?: InputMaybe<StringFilter>;
    skippedCount?: InputMaybe<IntFilter>;
    status?: InputMaybe<StringFilter>;
    succeededCount?: InputMaybe<IntFilter>;
    totalItems?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BulkChargeCardRunWhereUniqueInput = {
    AND?: InputMaybe<Array<BulkChargeCardRunWhereInput>>;
    NOT?: InputMaybe<Array<BulkChargeCardRunWhereInput>>;
    OR?: InputMaybe<Array<BulkChargeCardRunWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    createdBy?: InputMaybe<StringFilter>;
    csvS3Key?: InputMaybe<StringNullableFilter>;
    failedCount?: InputMaybe<IntFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    isDryRun?: InputMaybe<BoolFilter>;
    items?: InputMaybe<BulkChargeCardRunItemListRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgName?: InputMaybe<StringFilter>;
    runDate?: InputMaybe<StringFilter>;
    skippedCount?: InputMaybe<IntFilter>;
    status?: InputMaybe<StringFilter>;
    succeededCount?: InputMaybe<IntFilter>;
    totalItems?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Bundle = {
    __typename?: 'Bundle';
    _count?: Maybe<BundleCount>;
    bundleId: Scalars['Int']['output'];
    bundleToHrt: Array<BundleToHrt>;
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    name: Scalars['String']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    popularity: Scalars['Float']['output'];
    productToBundle: Array<ProductToBundle>;
};

export type BundleBundleToHrtArgs = {
    cursor?: InputMaybe<BundleToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<BundleToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BundleToHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type BundleProductToBundleArgs = {
    cursor?: InputMaybe<ProductToBundleWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductToBundleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductToBundleOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type BundleAvgAggregate = {
    __typename?: 'BundleAvgAggregate';
    bundleId?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type BundleAvgOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type BundleCount = {
    __typename?: 'BundleCount';
    bundleToHrt: Scalars['Int']['output'];
    productToBundle: Scalars['Int']['output'];
};

export type BundleCountBundleToHrtArgs = {
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type BundleCountProductToBundleArgs = {
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type BundleCountAggregate = {
    __typename?: 'BundleCountAggregate';
    _all: Scalars['Int']['output'];
    bundleId: Scalars['Int']['output'];
    displayMetadata: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    popularity: Scalars['Int']['output'];
};

export type BundleCountOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type BundleCreateInput = {
    bundleId: Scalars['Int']['input'];
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutBundleInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutBundleInput;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    productToBundle?: InputMaybe<ProductToBundleCreateNestedManyWithoutBundleInput>;
};

export type BundleCreateManyInput = {
    bundleId: Scalars['Int']['input'];
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    popularity?: InputMaybe<Scalars['Float']['input']>;
};

export type BundleCreateManyOrgInput = {
    bundleId: Scalars['Int']['input'];
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name: Scalars['String']['input'];
    popularity?: InputMaybe<Scalars['Float']['input']>;
};

export type BundleCreateManyOrgInputEnvelope = {
    data: Array<BundleCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BundleCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<BundleWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<BundleCreateOrConnectWithoutOrgInput>>;
    create?: InputMaybe<Array<BundleCreateWithoutOrgInput>>;
    createMany?: InputMaybe<BundleCreateManyOrgInputEnvelope>;
};

export type BundleCreateNestedOneWithoutBundleToHrtInput = {
    connect?: InputMaybe<BundleWhereUniqueInput>;
    connectOrCreate?: InputMaybe<BundleCreateOrConnectWithoutBundleToHrtInput>;
    create?: InputMaybe<BundleCreateWithoutBundleToHrtInput>;
};

export type BundleCreateNestedOneWithoutProductToBundleInput = {
    connect?: InputMaybe<BundleWhereUniqueInput>;
    connectOrCreate?: InputMaybe<BundleCreateOrConnectWithoutProductToBundleInput>;
    create?: InputMaybe<BundleCreateWithoutProductToBundleInput>;
};

export type BundleCreateOrConnectWithoutBundleToHrtInput = {
    create: BundleCreateWithoutBundleToHrtInput;
    where: BundleWhereUniqueInput;
};

export type BundleCreateOrConnectWithoutOrgInput = {
    create: BundleCreateWithoutOrgInput;
    where: BundleWhereUniqueInput;
};

export type BundleCreateOrConnectWithoutProductToBundleInput = {
    create: BundleCreateWithoutProductToBundleInput;
    where: BundleWhereUniqueInput;
};

export type BundleCreateWithoutBundleToHrtInput = {
    bundleId: Scalars['Int']['input'];
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutBundleInput;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    productToBundle?: InputMaybe<ProductToBundleCreateNestedManyWithoutBundleInput>;
};

export type BundleCreateWithoutOrgInput = {
    bundleId: Scalars['Int']['input'];
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutBundleInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name: Scalars['String']['input'];
    popularity?: InputMaybe<Scalars['Float']['input']>;
    productToBundle?: InputMaybe<ProductToBundleCreateNestedManyWithoutBundleInput>;
};

export type BundleCreateWithoutProductToBundleInput = {
    bundleId: Scalars['Int']['input'];
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutBundleInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutBundleInput;
    popularity?: InputMaybe<Scalars['Float']['input']>;
};

export type BundleGroupBy = {
    __typename?: 'BundleGroupBy';
    _avg?: Maybe<BundleAvgAggregate>;
    _count?: Maybe<BundleCountAggregate>;
    _max?: Maybe<BundleMaxAggregate>;
    _min?: Maybe<BundleMinAggregate>;
    _sum?: Maybe<BundleSumAggregate>;
    bundleId: Scalars['Int']['output'];
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    popularity: Scalars['Float']['output'];
};

export type BundleListRelationFilter = {
    every?: InputMaybe<BundleWhereInput>;
    none?: InputMaybe<BundleWhereInput>;
    some?: InputMaybe<BundleWhereInput>;
};

export type BundleMaxAggregate = {
    __typename?: 'BundleMaxAggregate';
    bundleId?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type BundleMaxOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type BundleMinAggregate = {
    __typename?: 'BundleMinAggregate';
    bundleId?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type BundleMinOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type BundleOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type BundleOrderByWithAggregationInput = {
    _avg?: InputMaybe<BundleAvgOrderByAggregateInput>;
    _count?: InputMaybe<BundleCountOrderByAggregateInput>;
    _max?: InputMaybe<BundleMaxOrderByAggregateInput>;
    _min?: InputMaybe<BundleMinOrderByAggregateInput>;
    _sum?: InputMaybe<BundleSumOrderByAggregateInput>;
    bundleId?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type BundleOrderByWithRelationInput = {
    bundleId?: InputMaybe<SortOrder>;
    bundleToHrt?: InputMaybe<BundleToHrtOrderByRelationAggregateInput>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    productToBundle?: InputMaybe<ProductToBundleOrderByRelationAggregateInput>;
};

export type BundleRelationFilter = {
    is?: InputMaybe<BundleWhereInput>;
    isNot?: InputMaybe<BundleWhereInput>;
};

export enum BundleScalarFieldEnum {
    BundleId = 'bundleId',
    DisplayMetadata = 'displayMetadata',
    Name = 'name',
    OrgId = 'orgId',
    Popularity = 'popularity',
}

export type BundleScalarWhereInput = {
    AND?: InputMaybe<Array<BundleScalarWhereInput>>;
    NOT?: InputMaybe<Array<BundleScalarWhereInput>>;
    OR?: InputMaybe<Array<BundleScalarWhereInput>>;
    bundleId?: InputMaybe<IntFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    popularity?: InputMaybe<FloatFilter>;
};

export type BundleScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<BundleScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<BundleScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<BundleScalarWhereWithAggregatesInput>>;
    bundleId?: InputMaybe<IntWithAggregatesFilter>;
    displayMetadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    popularity?: InputMaybe<FloatWithAggregatesFilter>;
};

export type BundleSumAggregate = {
    __typename?: 'BundleSumAggregate';
    bundleId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type BundleSumOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type BundleToHrt = {
    __typename?: 'BundleToHrt';
    bundle: Bundle;
    bundleId: Scalars['Int']['output'];
    cashPrice?: Maybe<Scalars['Int']['output']>;
    hrt: Hrt;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isBookableOnStorefrontOverride: Scalars['Boolean']['output'];
};

export type BundleToHrtAvgAggregate = {
    __typename?: 'BundleToHrtAvgAggregate';
    bundleId?: Maybe<Scalars['Float']['output']>;
    cashPrice?: Maybe<Scalars['Float']['output']>;
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type BundleToHrtAvgOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type BundleToHrtCountAggregate = {
    __typename?: 'BundleToHrtCountAggregate';
    _all: Scalars['Int']['output'];
    bundleId: Scalars['Int']['output'];
    cashPrice: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isBookableOnStorefrontOverride: Scalars['Int']['output'];
};

export type BundleToHrtCountOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isBookableOnStorefrontOverride?: InputMaybe<SortOrder>;
};

export type BundleToHrtCreateInput = {
    bundle: BundleCreateNestedOneWithoutBundleToHrtInput;
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    hrt: HrtCreateNestedOneWithoutBundleToHrtInput;
    isBookableOnStorefrontOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BundleToHrtCreateManyBundleInput = {
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    isBookableOnStorefrontOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BundleToHrtCreateManyBundleInputEnvelope = {
    data: Array<BundleToHrtCreateManyBundleInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BundleToHrtCreateManyHrtInput = {
    bundleId: Scalars['Int']['input'];
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isBookableOnStorefrontOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BundleToHrtCreateManyHrtInputEnvelope = {
    data: Array<BundleToHrtCreateManyHrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BundleToHrtCreateManyInput = {
    bundleId: Scalars['Int']['input'];
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    isBookableOnStorefrontOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BundleToHrtCreateNestedManyWithoutBundleInput = {
    connect?: InputMaybe<Array<BundleToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<BundleToHrtCreateOrConnectWithoutBundleInput>
    >;
    create?: InputMaybe<Array<BundleToHrtCreateWithoutBundleInput>>;
    createMany?: InputMaybe<BundleToHrtCreateManyBundleInputEnvelope>;
};

export type BundleToHrtCreateNestedManyWithoutHrtInput = {
    connect?: InputMaybe<Array<BundleToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<BundleToHrtCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<BundleToHrtCreateWithoutHrtInput>>;
    createMany?: InputMaybe<BundleToHrtCreateManyHrtInputEnvelope>;
};

export type BundleToHrtCreateOrConnectWithoutBundleInput = {
    create: BundleToHrtCreateWithoutBundleInput;
    where: BundleToHrtWhereUniqueInput;
};

export type BundleToHrtCreateOrConnectWithoutHrtInput = {
    create: BundleToHrtCreateWithoutHrtInput;
    where: BundleToHrtWhereUniqueInput;
};

export type BundleToHrtCreateWithoutBundleInput = {
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    hrt: HrtCreateNestedOneWithoutBundleToHrtInput;
    isBookableOnStorefrontOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BundleToHrtCreateWithoutHrtInput = {
    bundle: BundleCreateNestedOneWithoutBundleToHrtInput;
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    isBookableOnStorefrontOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BundleToHrtGroupBy = {
    __typename?: 'BundleToHrtGroupBy';
    _avg?: Maybe<BundleToHrtAvgAggregate>;
    _count?: Maybe<BundleToHrtCountAggregate>;
    _max?: Maybe<BundleToHrtMaxAggregate>;
    _min?: Maybe<BundleToHrtMinAggregate>;
    _sum?: Maybe<BundleToHrtSumAggregate>;
    bundleId: Scalars['Int']['output'];
    cashPrice?: Maybe<Scalars['Int']['output']>;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isBookableOnStorefrontOverride: Scalars['Boolean']['output'];
};

export type BundleToHrtListRelationFilter = {
    every?: InputMaybe<BundleToHrtWhereInput>;
    none?: InputMaybe<BundleToHrtWhereInput>;
    some?: InputMaybe<BundleToHrtWhereInput>;
};

export type BundleToHrtMaxAggregate = {
    __typename?: 'BundleToHrtMaxAggregate';
    bundleId?: Maybe<Scalars['Int']['output']>;
    cashPrice?: Maybe<Scalars['Int']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isBookableOnStorefrontOverride?: Maybe<Scalars['Boolean']['output']>;
};

export type BundleToHrtMaxOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isBookableOnStorefrontOverride?: InputMaybe<SortOrder>;
};

export type BundleToHrtMinAggregate = {
    __typename?: 'BundleToHrtMinAggregate';
    bundleId?: Maybe<Scalars['Int']['output']>;
    cashPrice?: Maybe<Scalars['Int']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isBookableOnStorefrontOverride?: Maybe<Scalars['Boolean']['output']>;
};

export type BundleToHrtMinOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isBookableOnStorefrontOverride?: InputMaybe<SortOrder>;
};

export type BundleToHrtOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type BundleToHrtOrderByWithAggregationInput = {
    _avg?: InputMaybe<BundleToHrtAvgOrderByAggregateInput>;
    _count?: InputMaybe<BundleToHrtCountOrderByAggregateInput>;
    _max?: InputMaybe<BundleToHrtMaxOrderByAggregateInput>;
    _min?: InputMaybe<BundleToHrtMinOrderByAggregateInput>;
    _sum?: InputMaybe<BundleToHrtSumOrderByAggregateInput>;
    bundleId?: InputMaybe<SortOrder>;
    cashPrice?: InputMaybe<SortOrderInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isBookableOnStorefrontOverride?: InputMaybe<SortOrder>;
};

export type BundleToHrtOrderByWithRelationInput = {
    bundle?: InputMaybe<BundleOrderByWithRelationInput>;
    bundleId?: InputMaybe<SortOrder>;
    cashPrice?: InputMaybe<SortOrderInput>;
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isBookableOnStorefrontOverride?: InputMaybe<SortOrder>;
};

export enum BundleToHrtScalarFieldEnum {
    BundleId = 'bundleId',
    CashPrice = 'cashPrice',
    HrtId = 'hrtId',
    Id = 'id',
    IsBookableOnStorefrontOverride = 'isBookableOnStorefrontOverride',
}

export type BundleToHrtScalarWhereInput = {
    AND?: InputMaybe<Array<BundleToHrtScalarWhereInput>>;
    NOT?: InputMaybe<Array<BundleToHrtScalarWhereInput>>;
    OR?: InputMaybe<Array<BundleToHrtScalarWhereInput>>;
    bundleId?: InputMaybe<IntFilter>;
    cashPrice?: InputMaybe<IntNullableFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    isBookableOnStorefrontOverride?: InputMaybe<BoolFilter>;
};

export type BundleToHrtScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<BundleToHrtScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<BundleToHrtScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<BundleToHrtScalarWhereWithAggregatesInput>>;
    bundleId?: InputMaybe<IntWithAggregatesFilter>;
    cashPrice?: InputMaybe<IntNullableWithAggregatesFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isBookableOnStorefrontOverride?: InputMaybe<BoolWithAggregatesFilter>;
};

export type BundleToHrtSumAggregate = {
    __typename?: 'BundleToHrtSumAggregate';
    bundleId?: Maybe<Scalars['Int']['output']>;
    cashPrice?: Maybe<Scalars['Int']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type BundleToHrtSumOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type BundleToHrtUpdateInput = {
    bundle?: InputMaybe<BundleUpdateOneRequiredWithoutBundleToHrtNestedInput>;
    cashPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutBundleToHrtNestedInput>;
    isBookableOnStorefrontOverride?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type BundleToHrtUpdateManyMutationInput = {
    cashPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    isBookableOnStorefrontOverride?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type BundleToHrtUpdateManyWithWhereWithoutBundleInput = {
    data: BundleToHrtUpdateManyMutationInput;
    where: BundleToHrtScalarWhereInput;
};

export type BundleToHrtUpdateManyWithWhereWithoutHrtInput = {
    data: BundleToHrtUpdateManyMutationInput;
    where: BundleToHrtScalarWhereInput;
};

export type BundleToHrtUpdateManyWithoutBundleNestedInput = {
    connect?: InputMaybe<Array<BundleToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<BundleToHrtCreateOrConnectWithoutBundleInput>
    >;
    create?: InputMaybe<Array<BundleToHrtCreateWithoutBundleInput>>;
    createMany?: InputMaybe<BundleToHrtCreateManyBundleInputEnvelope>;
    delete?: InputMaybe<Array<BundleToHrtWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<BundleToHrtScalarWhereInput>>;
    disconnect?: InputMaybe<Array<BundleToHrtWhereUniqueInput>>;
    set?: InputMaybe<Array<BundleToHrtWhereUniqueInput>>;
    update?: InputMaybe<
        Array<BundleToHrtUpdateWithWhereUniqueWithoutBundleInput>
    >;
    updateMany?: InputMaybe<
        Array<BundleToHrtUpdateManyWithWhereWithoutBundleInput>
    >;
    upsert?: InputMaybe<
        Array<BundleToHrtUpsertWithWhereUniqueWithoutBundleInput>
    >;
};

export type BundleToHrtUpdateManyWithoutHrtNestedInput = {
    connect?: InputMaybe<Array<BundleToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<BundleToHrtCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<BundleToHrtCreateWithoutHrtInput>>;
    createMany?: InputMaybe<BundleToHrtCreateManyHrtInputEnvelope>;
    delete?: InputMaybe<Array<BundleToHrtWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<BundleToHrtScalarWhereInput>>;
    disconnect?: InputMaybe<Array<BundleToHrtWhereUniqueInput>>;
    set?: InputMaybe<Array<BundleToHrtWhereUniqueInput>>;
    update?: InputMaybe<Array<BundleToHrtUpdateWithWhereUniqueWithoutHrtInput>>;
    updateMany?: InputMaybe<
        Array<BundleToHrtUpdateManyWithWhereWithoutHrtInput>
    >;
    upsert?: InputMaybe<Array<BundleToHrtUpsertWithWhereUniqueWithoutHrtInput>>;
};

export type BundleToHrtUpdateWithWhereUniqueWithoutBundleInput = {
    data: BundleToHrtUpdateWithoutBundleInput;
    where: BundleToHrtWhereUniqueInput;
};

export type BundleToHrtUpdateWithWhereUniqueWithoutHrtInput = {
    data: BundleToHrtUpdateWithoutHrtInput;
    where: BundleToHrtWhereUniqueInput;
};

export type BundleToHrtUpdateWithoutBundleInput = {
    cashPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutBundleToHrtNestedInput>;
    isBookableOnStorefrontOverride?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type BundleToHrtUpdateWithoutHrtInput = {
    bundle?: InputMaybe<BundleUpdateOneRequiredWithoutBundleToHrtNestedInput>;
    cashPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    isBookableOnStorefrontOverride?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type BundleToHrtUpsertWithWhereUniqueWithoutBundleInput = {
    create: BundleToHrtCreateWithoutBundleInput;
    update: BundleToHrtUpdateWithoutBundleInput;
    where: BundleToHrtWhereUniqueInput;
};

export type BundleToHrtUpsertWithWhereUniqueWithoutHrtInput = {
    create: BundleToHrtCreateWithoutHrtInput;
    update: BundleToHrtUpdateWithoutHrtInput;
    where: BundleToHrtWhereUniqueInput;
};

export type BundleToHrtWhereInput = {
    AND?: InputMaybe<Array<BundleToHrtWhereInput>>;
    NOT?: InputMaybe<Array<BundleToHrtWhereInput>>;
    OR?: InputMaybe<Array<BundleToHrtWhereInput>>;
    bundle?: InputMaybe<BundleRelationFilter>;
    bundleId?: InputMaybe<IntFilter>;
    cashPrice?: InputMaybe<IntNullableFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    isBookableOnStorefrontOverride?: InputMaybe<BoolFilter>;
};

export type BundleToHrtWhereUniqueInput = {
    AND?: InputMaybe<Array<BundleToHrtWhereInput>>;
    NOT?: InputMaybe<Array<BundleToHrtWhereInput>>;
    OR?: InputMaybe<Array<BundleToHrtWhereInput>>;
    bundle?: InputMaybe<BundleRelationFilter>;
    bundleId?: InputMaybe<IntFilter>;
    cashPrice?: InputMaybe<IntNullableFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isBookableOnStorefrontOverride?: InputMaybe<BoolFilter>;
};

export type BundleUpdateInput = {
    bundleId?: InputMaybe<IntFieldUpdateOperationsInput>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutBundleNestedInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutBundleNestedInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    productToBundle?: InputMaybe<ProductToBundleUpdateManyWithoutBundleNestedInput>;
};

export type BundleUpdateManyMutationInput = {
    bundleId?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type BundleUpdateManyWithWhereWithoutOrgInput = {
    data: BundleUpdateManyMutationInput;
    where: BundleScalarWhereInput;
};

export type BundleUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<BundleWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<BundleCreateOrConnectWithoutOrgInput>>;
    create?: InputMaybe<Array<BundleCreateWithoutOrgInput>>;
    createMany?: InputMaybe<BundleCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<BundleWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<BundleScalarWhereInput>>;
    disconnect?: InputMaybe<Array<BundleWhereUniqueInput>>;
    set?: InputMaybe<Array<BundleWhereUniqueInput>>;
    update?: InputMaybe<Array<BundleUpdateWithWhereUniqueWithoutOrgInput>>;
    updateMany?: InputMaybe<Array<BundleUpdateManyWithWhereWithoutOrgInput>>;
    upsert?: InputMaybe<Array<BundleUpsertWithWhereUniqueWithoutOrgInput>>;
};

export type BundleUpdateOneRequiredWithoutBundleToHrtNestedInput = {
    connect?: InputMaybe<BundleWhereUniqueInput>;
    connectOrCreate?: InputMaybe<BundleCreateOrConnectWithoutBundleToHrtInput>;
    create?: InputMaybe<BundleCreateWithoutBundleToHrtInput>;
    update?: InputMaybe<BundleUpdateToOneWithWhereWithoutBundleToHrtInput>;
    upsert?: InputMaybe<BundleUpsertWithoutBundleToHrtInput>;
};

export type BundleUpdateOneRequiredWithoutProductToBundleNestedInput = {
    connect?: InputMaybe<BundleWhereUniqueInput>;
    connectOrCreate?: InputMaybe<BundleCreateOrConnectWithoutProductToBundleInput>;
    create?: InputMaybe<BundleCreateWithoutProductToBundleInput>;
    update?: InputMaybe<BundleUpdateToOneWithWhereWithoutProductToBundleInput>;
    upsert?: InputMaybe<BundleUpsertWithoutProductToBundleInput>;
};

export type BundleUpdateToOneWithWhereWithoutBundleToHrtInput = {
    data: BundleUpdateWithoutBundleToHrtInput;
    where?: InputMaybe<BundleWhereInput>;
};

export type BundleUpdateToOneWithWhereWithoutProductToBundleInput = {
    data: BundleUpdateWithoutProductToBundleInput;
    where?: InputMaybe<BundleWhereInput>;
};

export type BundleUpdateWithWhereUniqueWithoutOrgInput = {
    data: BundleUpdateWithoutOrgInput;
    where: BundleWhereUniqueInput;
};

export type BundleUpdateWithoutBundleToHrtInput = {
    bundleId?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutBundleNestedInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    productToBundle?: InputMaybe<ProductToBundleUpdateManyWithoutBundleNestedInput>;
};

export type BundleUpdateWithoutOrgInput = {
    bundleId?: InputMaybe<IntFieldUpdateOperationsInput>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutBundleNestedInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    productToBundle?: InputMaybe<ProductToBundleUpdateManyWithoutBundleNestedInput>;
};

export type BundleUpdateWithoutProductToBundleInput = {
    bundleId?: InputMaybe<IntFieldUpdateOperationsInput>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutBundleNestedInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutBundleNestedInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type BundleUpsertWithWhereUniqueWithoutOrgInput = {
    create: BundleCreateWithoutOrgInput;
    update: BundleUpdateWithoutOrgInput;
    where: BundleWhereUniqueInput;
};

export type BundleUpsertWithoutBundleToHrtInput = {
    create: BundleCreateWithoutBundleToHrtInput;
    update: BundleUpdateWithoutBundleToHrtInput;
    where?: InputMaybe<BundleWhereInput>;
};

export type BundleUpsertWithoutProductToBundleInput = {
    create: BundleCreateWithoutProductToBundleInput;
    update: BundleUpdateWithoutProductToBundleInput;
    where?: InputMaybe<BundleWhereInput>;
};

export type BundleWhereInput = {
    AND?: InputMaybe<Array<BundleWhereInput>>;
    NOT?: InputMaybe<Array<BundleWhereInput>>;
    OR?: InputMaybe<Array<BundleWhereInput>>;
    bundleId?: InputMaybe<IntFilter>;
    bundleToHrt?: InputMaybe<BundleToHrtListRelationFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    popularity?: InputMaybe<FloatFilter>;
    productToBundle?: InputMaybe<ProductToBundleListRelationFilter>;
};

export type BundleWhereUniqueInput = {
    AND?: InputMaybe<Array<BundleWhereInput>>;
    NOT?: InputMaybe<Array<BundleWhereInput>>;
    OR?: InputMaybe<Array<BundleWhereInput>>;
    bundleId?: InputMaybe<Scalars['Int']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtListRelationFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    popularity?: InputMaybe<FloatFilter>;
    productToBundle?: InputMaybe<ProductToBundleListRelationFilter>;
};

export type BusinessHour = {
    __typename?: 'BusinessHour';
    closeTime?: Maybe<Scalars['String']['output']>;
    dayOfWeek: Scalars['Int']['output'];
    id: Scalars['String']['output'];
    isEnabled: Scalars['Boolean']['output'];
    openTime?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
};

export type BusinessHourAvgAggregate = {
    __typename?: 'BusinessHourAvgAggregate';
    dayOfWeek?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type BusinessHourAvgOrderByAggregateInput = {
    dayOfWeek?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type BusinessHourCountAggregate = {
    __typename?: 'BusinessHourCountAggregate';
    _all: Scalars['Int']['output'];
    closeTime: Scalars['Int']['output'];
    dayOfWeek: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isEnabled: Scalars['Int']['output'];
    openTime: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
};

export type BusinessHourCountOrderByAggregateInput = {
    closeTime?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isEnabled?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type BusinessHourCreateInput = {
    closeTime?: InputMaybe<Scalars['String']['input']>;
    dayOfWeek: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    openTime?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
};

export type BusinessHourCreateManyInput = {
    closeTime?: InputMaybe<Scalars['String']['input']>;
    dayOfWeek: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    openTime?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
};

export type BusinessHourGroupBy = {
    __typename?: 'BusinessHourGroupBy';
    _avg?: Maybe<BusinessHourAvgAggregate>;
    _count?: Maybe<BusinessHourCountAggregate>;
    _max?: Maybe<BusinessHourMaxAggregate>;
    _min?: Maybe<BusinessHourMinAggregate>;
    _sum?: Maybe<BusinessHourSumAggregate>;
    closeTime?: Maybe<Scalars['String']['output']>;
    dayOfWeek: Scalars['Int']['output'];
    id: Scalars['String']['output'];
    isEnabled: Scalars['Boolean']['output'];
    openTime?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
};

export type BusinessHourMaxAggregate = {
    __typename?: 'BusinessHourMaxAggregate';
    closeTime?: Maybe<Scalars['String']['output']>;
    dayOfWeek?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isEnabled?: Maybe<Scalars['Boolean']['output']>;
    openTime?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type BusinessHourMaxOrderByAggregateInput = {
    closeTime?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isEnabled?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type BusinessHourMinAggregate = {
    __typename?: 'BusinessHourMinAggregate';
    closeTime?: Maybe<Scalars['String']['output']>;
    dayOfWeek?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isEnabled?: Maybe<Scalars['Boolean']['output']>;
    openTime?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type BusinessHourMinOrderByAggregateInput = {
    closeTime?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isEnabled?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type BusinessHourOrderByWithAggregationInput = {
    _avg?: InputMaybe<BusinessHourAvgOrderByAggregateInput>;
    _count?: InputMaybe<BusinessHourCountOrderByAggregateInput>;
    _max?: InputMaybe<BusinessHourMaxOrderByAggregateInput>;
    _min?: InputMaybe<BusinessHourMinOrderByAggregateInput>;
    _sum?: InputMaybe<BusinessHourSumOrderByAggregateInput>;
    closeTime?: InputMaybe<SortOrderInput>;
    dayOfWeek?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isEnabled?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
};

export type BusinessHourOrderByWithRelationInput = {
    closeTime?: InputMaybe<SortOrderInput>;
    dayOfWeek?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isEnabled?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
};

export type BusinessHourPracticeIdDayOfWeekCompoundUniqueInput = {
    dayOfWeek: Scalars['Int']['input'];
    practiceId: Scalars['Int']['input'];
};

export enum BusinessHourScalarFieldEnum {
    CloseTime = 'closeTime',
    DayOfWeek = 'dayOfWeek',
    Id = 'id',
    IsEnabled = 'isEnabled',
    OpenTime = 'openTime',
    PracticeId = 'practiceId',
}

export type BusinessHourScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<BusinessHourScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<BusinessHourScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<BusinessHourScalarWhereWithAggregatesInput>>;
    closeTime?: InputMaybe<StringNullableWithAggregatesFilter>;
    dayOfWeek?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    isEnabled?: InputMaybe<BoolWithAggregatesFilter>;
    openTime?: InputMaybe<StringNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
};

export type BusinessHourSumAggregate = {
    __typename?: 'BusinessHourSumAggregate';
    dayOfWeek?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type BusinessHourSumOrderByAggregateInput = {
    dayOfWeek?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type BusinessHourUpdateInput = {
    closeTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    dayOfWeek?: InputMaybe<IntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    openTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BusinessHourUpdateManyMutationInput = {
    closeTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    dayOfWeek?: InputMaybe<IntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    openTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BusinessHourWhereInput = {
    AND?: InputMaybe<Array<BusinessHourWhereInput>>;
    NOT?: InputMaybe<Array<BusinessHourWhereInput>>;
    OR?: InputMaybe<Array<BusinessHourWhereInput>>;
    closeTime?: InputMaybe<StringNullableFilter>;
    dayOfWeek?: InputMaybe<IntFilter>;
    id?: InputMaybe<UuidFilter>;
    isEnabled?: InputMaybe<BoolFilter>;
    openTime?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
};

export type BusinessHourWhereUniqueInput = {
    AND?: InputMaybe<Array<BusinessHourWhereInput>>;
    NOT?: InputMaybe<Array<BusinessHourWhereInput>>;
    OR?: InputMaybe<Array<BusinessHourWhereInput>>;
    closeTime?: InputMaybe<StringNullableFilter>;
    dayOfWeek?: InputMaybe<IntFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    isEnabled?: InputMaybe<BoolFilter>;
    openTime?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    practiceId_dayOfWeek?: InputMaybe<BusinessHourPracticeIdDayOfWeekCompoundUniqueInput>;
};

export enum CompletionTimingType {
    AfterCheckout = 'AFTER_CHECKOUT',
    DayOfService = 'DAY_OF_SERVICE',
    InOffice = 'IN_OFFICE',
}

export enum ConfigCommitStatus {
    Applied = 'APPLIED',
    Draft = 'DRAFT',
}

export enum ConsentType {
    AssignmentOfBenefits = 'ASSIGNMENT_OF_BENEFITS',
    HipaaAuthorization = 'HIPAA_AUTHORIZATION',
    Privacy = 'PRIVACY',
    ReleaseOfBilling = 'RELEASE_OF_BILLING',
}

export enum CoverageSource {
    Availity = 'AVAILITY',
    None = 'NONE',
    Pverify = 'PVERIFY',
    Stedi = 'STEDI',
}

export type CancelChargeInput = {
    boughtTreatmentId: Scalars['String']['input'];
    boughtTreatmentPrice: Scalars['Float']['input'];
    orgId: Scalars['Int']['input'];
};

export type CancelChargesDto = {
    cancelChargeInputs: Array<CancelChargeInput>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    userId: Scalars['String']['input'];
};

export type CandidateTreatment = {
    __typename?: 'CandidateTreatment';
    boughtTreatment?: Maybe<BoughtTreatment>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrtDisplayName?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    modelVersion?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    predictedCpt: Scalars['String']['output'];
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    pricingStatus: CandidateTreatmentPricingStatusEnum;
    probability: Scalars['Float']['output'];
    rank: Scalars['Int']['output'];
    relationType?: Maybe<CptRelationType>;
    scoredAt: Scalars['DateTimeISO']['output'];
    slot: Slot;
    slotId: Scalars['String']['output'];
    source?: Maybe<Scalars['String']['output']>;
    status: CandidateTreatmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CandidateTreatmentBoughtTreatmentArgs = {
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type CandidateTreatmentAvgAggregate = {
    __typename?: 'CandidateTreatmentAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Float']['output']>;
    probability?: Maybe<Scalars['Float']['output']>;
    rank?: Maybe<Scalars['Float']['output']>;
};

export type CandidateTreatmentAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    probability?: InputMaybe<SortOrder>;
    rank?: InputMaybe<SortOrder>;
};

export type CandidateTreatmentCountAggregate = {
    __typename?: 'CandidateTreatmentCountAggregate';
    _all: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    hrtDisplayName: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    modelVersion: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    predictedCpt: Scalars['Int']['output'];
    price: Scalars['Int']['output'];
    pricedTreatmentId: Scalars['Int']['output'];
    pricingStatus: Scalars['Int']['output'];
    probability: Scalars['Int']['output'];
    rank: Scalars['Int']['output'];
    relationType: Scalars['Int']['output'];
    scoredAt: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    source: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type CandidateTreatmentCountOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    hrtDisplayName?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    modelVersion?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    predictedCpt?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    pricingStatus?: InputMaybe<SortOrder>;
    probability?: InputMaybe<SortOrder>;
    rank?: InputMaybe<SortOrder>;
    relationType?: InputMaybe<SortOrder>;
    scoredAt?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type CandidateTreatmentCreateInput = {
    boughtTreatment?: InputMaybe<BoughtTreatmentCreateNestedOneWithoutCandidateTreatmentsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtDisplayName?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    modelVersion?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    predictedCpt: Scalars['String']['input'];
    price?: InputMaybe<Scalars['Float']['input']>;
    pricedTreatmentId?: InputMaybe<Scalars['Int']['input']>;
    pricingStatus?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
    probability: Scalars['Float']['input'];
    rank: Scalars['Int']['input'];
    relationType?: InputMaybe<CptRelationType>;
    scoredAt: Scalars['DateTimeISO']['input'];
    slot: SlotCreateNestedOneWithoutCandidateTreatmentsInput;
    source?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<CandidateTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CandidateTreatmentCreateManyBoughtTreatmentInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtDisplayName?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    modelVersion?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    predictedCpt: Scalars['String']['input'];
    price?: InputMaybe<Scalars['Float']['input']>;
    pricedTreatmentId?: InputMaybe<Scalars['Int']['input']>;
    pricingStatus?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
    probability: Scalars['Float']['input'];
    rank: Scalars['Int']['input'];
    relationType?: InputMaybe<CptRelationType>;
    scoredAt: Scalars['DateTimeISO']['input'];
    slotId: Scalars['String']['input'];
    source?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<CandidateTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CandidateTreatmentCreateManyBoughtTreatmentInputEnvelope = {
    data: Array<CandidateTreatmentCreateManyBoughtTreatmentInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CandidateTreatmentCreateManyInput = {
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtDisplayName?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    modelVersion?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    predictedCpt: Scalars['String']['input'];
    price?: InputMaybe<Scalars['Float']['input']>;
    pricedTreatmentId?: InputMaybe<Scalars['Int']['input']>;
    pricingStatus?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
    probability: Scalars['Float']['input'];
    rank: Scalars['Int']['input'];
    relationType?: InputMaybe<CptRelationType>;
    scoredAt: Scalars['DateTimeISO']['input'];
    slotId: Scalars['String']['input'];
    source?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<CandidateTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CandidateTreatmentCreateManySlotInput = {
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtDisplayName?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    modelVersion?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    predictedCpt: Scalars['String']['input'];
    price?: InputMaybe<Scalars['Float']['input']>;
    pricedTreatmentId?: InputMaybe<Scalars['Int']['input']>;
    pricingStatus?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
    probability: Scalars['Float']['input'];
    rank: Scalars['Int']['input'];
    relationType?: InputMaybe<CptRelationType>;
    scoredAt: Scalars['DateTimeISO']['input'];
    source?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<CandidateTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CandidateTreatmentCreateManySlotInputEnvelope = {
    data: Array<CandidateTreatmentCreateManySlotInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CandidateTreatmentCreateNestedManyWithoutBoughtTreatmentInput = {
    connect?: InputMaybe<Array<CandidateTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<CandidateTreatmentCreateOrConnectWithoutBoughtTreatmentInput>
    >;
    create?: InputMaybe<
        Array<CandidateTreatmentCreateWithoutBoughtTreatmentInput>
    >;
    createMany?: InputMaybe<CandidateTreatmentCreateManyBoughtTreatmentInputEnvelope>;
};

export type CandidateTreatmentCreateNestedManyWithoutSlotInput = {
    connect?: InputMaybe<Array<CandidateTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<CandidateTreatmentCreateOrConnectWithoutSlotInput>
    >;
    create?: InputMaybe<Array<CandidateTreatmentCreateWithoutSlotInput>>;
    createMany?: InputMaybe<CandidateTreatmentCreateManySlotInputEnvelope>;
};

export type CandidateTreatmentCreateOrConnectWithoutBoughtTreatmentInput = {
    create: CandidateTreatmentCreateWithoutBoughtTreatmentInput;
    where: CandidateTreatmentWhereUniqueInput;
};

export type CandidateTreatmentCreateOrConnectWithoutSlotInput = {
    create: CandidateTreatmentCreateWithoutSlotInput;
    where: CandidateTreatmentWhereUniqueInput;
};

export type CandidateTreatmentCreateWithoutBoughtTreatmentInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtDisplayName?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    modelVersion?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    predictedCpt: Scalars['String']['input'];
    price?: InputMaybe<Scalars['Float']['input']>;
    pricedTreatmentId?: InputMaybe<Scalars['Int']['input']>;
    pricingStatus?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
    probability: Scalars['Float']['input'];
    rank: Scalars['Int']['input'];
    relationType?: InputMaybe<CptRelationType>;
    scoredAt: Scalars['DateTimeISO']['input'];
    slot: SlotCreateNestedOneWithoutCandidateTreatmentsInput;
    source?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<CandidateTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CandidateTreatmentCreateWithoutSlotInput = {
    boughtTreatment?: InputMaybe<BoughtTreatmentCreateNestedOneWithoutCandidateTreatmentsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtDisplayName?: InputMaybe<Scalars['String']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    modelVersion?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    predictedCpt: Scalars['String']['input'];
    price?: InputMaybe<Scalars['Float']['input']>;
    pricedTreatmentId?: InputMaybe<Scalars['Int']['input']>;
    pricingStatus?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
    probability: Scalars['Float']['input'];
    rank: Scalars['Int']['input'];
    relationType?: InputMaybe<CptRelationType>;
    scoredAt: Scalars['DateTimeISO']['input'];
    source?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<CandidateTreatmentStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CandidateTreatmentGroupBy = {
    __typename?: 'CandidateTreatmentGroupBy';
    _avg?: Maybe<CandidateTreatmentAvgAggregate>;
    _count?: Maybe<CandidateTreatmentCountAggregate>;
    _max?: Maybe<CandidateTreatmentMaxAggregate>;
    _min?: Maybe<CandidateTreatmentMinAggregate>;
    _sum?: Maybe<CandidateTreatmentSumAggregate>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrtDisplayName?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    modelVersion?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    predictedCpt: Scalars['String']['output'];
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    pricingStatus: CandidateTreatmentPricingStatusEnum;
    probability: Scalars['Float']['output'];
    rank: Scalars['Int']['output'];
    relationType?: Maybe<CptRelationType>;
    scoredAt: Scalars['DateTimeISO']['output'];
    slotId: Scalars['String']['output'];
    source?: Maybe<Scalars['String']['output']>;
    status: CandidateTreatmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CandidateTreatmentListRelationFilter = {
    every?: InputMaybe<CandidateTreatmentWhereInput>;
    none?: InputMaybe<CandidateTreatmentWhereInput>;
    some?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type CandidateTreatmentMaxAggregate = {
    __typename?: 'CandidateTreatmentMaxAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtDisplayName?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    modelVersion?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    predictedCpt?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    pricingStatus?: Maybe<CandidateTreatmentPricingStatusEnum>;
    probability?: Maybe<Scalars['Float']['output']>;
    rank?: Maybe<Scalars['Int']['output']>;
    relationType?: Maybe<CptRelationType>;
    scoredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    status?: Maybe<CandidateTreatmentStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CandidateTreatmentMaxOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    hrtDisplayName?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    modelVersion?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    predictedCpt?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    pricingStatus?: InputMaybe<SortOrder>;
    probability?: InputMaybe<SortOrder>;
    rank?: InputMaybe<SortOrder>;
    relationType?: InputMaybe<SortOrder>;
    scoredAt?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type CandidateTreatmentMinAggregate = {
    __typename?: 'CandidateTreatmentMinAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtDisplayName?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    modelVersion?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    predictedCpt?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    pricingStatus?: Maybe<CandidateTreatmentPricingStatusEnum>;
    probability?: Maybe<Scalars['Float']['output']>;
    rank?: Maybe<Scalars['Int']['output']>;
    relationType?: Maybe<CptRelationType>;
    scoredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    status?: Maybe<CandidateTreatmentStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CandidateTreatmentMinOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    hrtDisplayName?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    modelVersion?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    predictedCpt?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    pricingStatus?: InputMaybe<SortOrder>;
    probability?: InputMaybe<SortOrder>;
    rank?: InputMaybe<SortOrder>;
    relationType?: InputMaybe<SortOrder>;
    scoredAt?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type CandidateTreatmentOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type CandidateTreatmentOrderByWithAggregationInput = {
    _avg?: InputMaybe<CandidateTreatmentAvgOrderByAggregateInput>;
    _count?: InputMaybe<CandidateTreatmentCountOrderByAggregateInput>;
    _max?: InputMaybe<CandidateTreatmentMaxOrderByAggregateInput>;
    _min?: InputMaybe<CandidateTreatmentMinOrderByAggregateInput>;
    _sum?: InputMaybe<CandidateTreatmentSumOrderByAggregateInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    hrtDisplayName?: InputMaybe<SortOrderInput>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    modelVersion?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    predictedCpt?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrderInput>;
    pricedTreatmentId?: InputMaybe<SortOrderInput>;
    pricingStatus?: InputMaybe<SortOrder>;
    probability?: InputMaybe<SortOrder>;
    rank?: InputMaybe<SortOrder>;
    relationType?: InputMaybe<SortOrderInput>;
    scoredAt?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type CandidateTreatmentOrderByWithRelationInput = {
    boughtTreatment?: InputMaybe<BoughtTreatmentOrderByWithRelationInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    hrtDisplayName?: InputMaybe<SortOrderInput>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    modelVersion?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    predictedCpt?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrderInput>;
    pricedTreatmentId?: InputMaybe<SortOrderInput>;
    pricingStatus?: InputMaybe<SortOrder>;
    probability?: InputMaybe<SortOrder>;
    rank?: InputMaybe<SortOrder>;
    relationType?: InputMaybe<SortOrderInput>;
    scoredAt?: InputMaybe<SortOrder>;
    slot?: InputMaybe<SlotOrderByWithRelationInput>;
    slotId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum CandidateTreatmentPricingStatusEnum {
    Pending = 'pending',
    Priced = 'priced',
}

export enum CandidateTreatmentScalarFieldEnum {
    BoughtTreatmentId = 'boughtTreatmentId',
    CreatedAt = 'createdAt',
    HrtDisplayName = 'hrtDisplayName',
    HrtId = 'hrtId',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    ModelVersion = 'modelVersion',
    OrgId = 'orgId',
    PredictedCpt = 'predictedCpt',
    Price = 'price',
    PricedTreatmentId = 'pricedTreatmentId',
    PricingStatus = 'pricingStatus',
    Probability = 'probability',
    Rank = 'rank',
    RelationType = 'relationType',
    ScoredAt = 'scoredAt',
    SlotId = 'slotId',
    Source = 'source',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type CandidateTreatmentScalarWhereInput = {
    AND?: InputMaybe<Array<CandidateTreatmentScalarWhereInput>>;
    NOT?: InputMaybe<Array<CandidateTreatmentScalarWhereInput>>;
    OR?: InputMaybe<Array<CandidateTreatmentScalarWhereInput>>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrtDisplayName?: InputMaybe<StringNullableFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    modelVersion?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    predictedCpt?: InputMaybe<StringFilter>;
    price?: InputMaybe<FloatNullableFilter>;
    pricedTreatmentId?: InputMaybe<IntNullableFilter>;
    pricingStatus?: InputMaybe<EnumCandidateTreatmentPricingStatusEnumFilter>;
    probability?: InputMaybe<FloatFilter>;
    rank?: InputMaybe<IntFilter>;
    relationType?: InputMaybe<EnumCptRelationTypeNullableFilter>;
    scoredAt?: InputMaybe<DateTimeFilter>;
    slotId?: InputMaybe<UuidFilter>;
    source?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumCandidateTreatmentStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CandidateTreatmentScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<CandidateTreatmentScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<CandidateTreatmentScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<CandidateTreatmentScalarWhereWithAggregatesInput>>;
    boughtTreatmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    hrtDisplayName?: InputMaybe<StringNullableWithAggregatesFilter>;
    hrtId?: InputMaybe<IntNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    modelVersion?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    predictedCpt?: InputMaybe<StringWithAggregatesFilter>;
    price?: InputMaybe<FloatNullableWithAggregatesFilter>;
    pricedTreatmentId?: InputMaybe<IntNullableWithAggregatesFilter>;
    pricingStatus?: InputMaybe<EnumCandidateTreatmentPricingStatusEnumWithAggregatesFilter>;
    probability?: InputMaybe<FloatWithAggregatesFilter>;
    rank?: InputMaybe<IntWithAggregatesFilter>;
    relationType?: InputMaybe<EnumCptRelationTypeNullableWithAggregatesFilter>;
    scoredAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    slotId?: InputMaybe<UuidWithAggregatesFilter>;
    source?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumCandidateTreatmentStatusEnumWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum CandidateTreatmentStatusEnum {
    Active = 'active',
    Canceled = 'canceled',
    Deleted = 'deleted',
}

export type CandidateTreatmentSumAggregate = {
    __typename?: 'CandidateTreatmentSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    probability?: Maybe<Scalars['Float']['output']>;
    rank?: Maybe<Scalars['Int']['output']>;
};

export type CandidateTreatmentSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricedTreatmentId?: InputMaybe<SortOrder>;
    probability?: InputMaybe<SortOrder>;
    rank?: InputMaybe<SortOrder>;
};

export type CandidateTreatmentUpdateInput = {
    boughtTreatment?: InputMaybe<BoughtTreatmentUpdateOneWithoutCandidateTreatmentsNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrtDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    modelVersion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    predictedCpt?: InputMaybe<StringFieldUpdateOperationsInput>;
    price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    pricedTreatmentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pricingStatus?: InputMaybe<EnumCandidateTreatmentPricingStatusEnumFieldUpdateOperationsInput>;
    probability?: InputMaybe<FloatFieldUpdateOperationsInput>;
    rank?: InputMaybe<IntFieldUpdateOperationsInput>;
    relationType?: InputMaybe<NullableEnumCptRelationTypeFieldUpdateOperationsInput>;
    scoredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    slot?: InputMaybe<SlotUpdateOneRequiredWithoutCandidateTreatmentsNestedInput>;
    source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumCandidateTreatmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CandidateTreatmentUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrtDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    modelVersion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    predictedCpt?: InputMaybe<StringFieldUpdateOperationsInput>;
    price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    pricedTreatmentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pricingStatus?: InputMaybe<EnumCandidateTreatmentPricingStatusEnumFieldUpdateOperationsInput>;
    probability?: InputMaybe<FloatFieldUpdateOperationsInput>;
    rank?: InputMaybe<IntFieldUpdateOperationsInput>;
    relationType?: InputMaybe<NullableEnumCptRelationTypeFieldUpdateOperationsInput>;
    scoredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumCandidateTreatmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CandidateTreatmentUpdateManyWithWhereWithoutBoughtTreatmentInput = {
    data: CandidateTreatmentUpdateManyMutationInput;
    where: CandidateTreatmentScalarWhereInput;
};

export type CandidateTreatmentUpdateManyWithWhereWithoutSlotInput = {
    data: CandidateTreatmentUpdateManyMutationInput;
    where: CandidateTreatmentScalarWhereInput;
};

export type CandidateTreatmentUpdateManyWithoutBoughtTreatmentNestedInput = {
    connect?: InputMaybe<Array<CandidateTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<CandidateTreatmentCreateOrConnectWithoutBoughtTreatmentInput>
    >;
    create?: InputMaybe<
        Array<CandidateTreatmentCreateWithoutBoughtTreatmentInput>
    >;
    createMany?: InputMaybe<CandidateTreatmentCreateManyBoughtTreatmentInputEnvelope>;
    delete?: InputMaybe<Array<CandidateTreatmentWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<CandidateTreatmentScalarWhereInput>>;
    disconnect?: InputMaybe<Array<CandidateTreatmentWhereUniqueInput>>;
    set?: InputMaybe<Array<CandidateTreatmentWhereUniqueInput>>;
    update?: InputMaybe<
        Array<CandidateTreatmentUpdateWithWhereUniqueWithoutBoughtTreatmentInput>
    >;
    updateMany?: InputMaybe<
        Array<CandidateTreatmentUpdateManyWithWhereWithoutBoughtTreatmentInput>
    >;
    upsert?: InputMaybe<
        Array<CandidateTreatmentUpsertWithWhereUniqueWithoutBoughtTreatmentInput>
    >;
};

export type CandidateTreatmentUpdateManyWithoutSlotNestedInput = {
    connect?: InputMaybe<Array<CandidateTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<CandidateTreatmentCreateOrConnectWithoutSlotInput>
    >;
    create?: InputMaybe<Array<CandidateTreatmentCreateWithoutSlotInput>>;
    createMany?: InputMaybe<CandidateTreatmentCreateManySlotInputEnvelope>;
    delete?: InputMaybe<Array<CandidateTreatmentWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<CandidateTreatmentScalarWhereInput>>;
    disconnect?: InputMaybe<Array<CandidateTreatmentWhereUniqueInput>>;
    set?: InputMaybe<Array<CandidateTreatmentWhereUniqueInput>>;
    update?: InputMaybe<
        Array<CandidateTreatmentUpdateWithWhereUniqueWithoutSlotInput>
    >;
    updateMany?: InputMaybe<
        Array<CandidateTreatmentUpdateManyWithWhereWithoutSlotInput>
    >;
    upsert?: InputMaybe<
        Array<CandidateTreatmentUpsertWithWhereUniqueWithoutSlotInput>
    >;
};

export type CandidateTreatmentUpdateWithWhereUniqueWithoutBoughtTreatmentInput =
    {
        data: CandidateTreatmentUpdateWithoutBoughtTreatmentInput;
        where: CandidateTreatmentWhereUniqueInput;
    };

export type CandidateTreatmentUpdateWithWhereUniqueWithoutSlotInput = {
    data: CandidateTreatmentUpdateWithoutSlotInput;
    where: CandidateTreatmentWhereUniqueInput;
};

export type CandidateTreatmentUpdateWithoutBoughtTreatmentInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrtDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    modelVersion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    predictedCpt?: InputMaybe<StringFieldUpdateOperationsInput>;
    price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    pricedTreatmentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pricingStatus?: InputMaybe<EnumCandidateTreatmentPricingStatusEnumFieldUpdateOperationsInput>;
    probability?: InputMaybe<FloatFieldUpdateOperationsInput>;
    rank?: InputMaybe<IntFieldUpdateOperationsInput>;
    relationType?: InputMaybe<NullableEnumCptRelationTypeFieldUpdateOperationsInput>;
    scoredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    slot?: InputMaybe<SlotUpdateOneRequiredWithoutCandidateTreatmentsNestedInput>;
    source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumCandidateTreatmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CandidateTreatmentUpdateWithoutSlotInput = {
    boughtTreatment?: InputMaybe<BoughtTreatmentUpdateOneWithoutCandidateTreatmentsNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrtDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    modelVersion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    predictedCpt?: InputMaybe<StringFieldUpdateOperationsInput>;
    price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    pricedTreatmentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pricingStatus?: InputMaybe<EnumCandidateTreatmentPricingStatusEnumFieldUpdateOperationsInput>;
    probability?: InputMaybe<FloatFieldUpdateOperationsInput>;
    rank?: InputMaybe<IntFieldUpdateOperationsInput>;
    relationType?: InputMaybe<NullableEnumCptRelationTypeFieldUpdateOperationsInput>;
    scoredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumCandidateTreatmentStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CandidateTreatmentUpsertWithWhereUniqueWithoutBoughtTreatmentInput =
    {
        create: CandidateTreatmentCreateWithoutBoughtTreatmentInput;
        update: CandidateTreatmentUpdateWithoutBoughtTreatmentInput;
        where: CandidateTreatmentWhereUniqueInput;
    };

export type CandidateTreatmentUpsertWithWhereUniqueWithoutSlotInput = {
    create: CandidateTreatmentCreateWithoutSlotInput;
    update: CandidateTreatmentUpdateWithoutSlotInput;
    where: CandidateTreatmentWhereUniqueInput;
};

export type CandidateTreatmentWhereInput = {
    AND?: InputMaybe<Array<CandidateTreatmentWhereInput>>;
    NOT?: InputMaybe<Array<CandidateTreatmentWhereInput>>;
    OR?: InputMaybe<Array<CandidateTreatmentWhereInput>>;
    boughtTreatment?: InputMaybe<BoughtTreatmentNullableRelationFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrtDisplayName?: InputMaybe<StringNullableFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    modelVersion?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    predictedCpt?: InputMaybe<StringFilter>;
    price?: InputMaybe<FloatNullableFilter>;
    pricedTreatmentId?: InputMaybe<IntNullableFilter>;
    pricingStatus?: InputMaybe<EnumCandidateTreatmentPricingStatusEnumFilter>;
    probability?: InputMaybe<FloatFilter>;
    rank?: InputMaybe<IntFilter>;
    relationType?: InputMaybe<EnumCptRelationTypeNullableFilter>;
    scoredAt?: InputMaybe<DateTimeFilter>;
    slot?: InputMaybe<SlotRelationFilter>;
    slotId?: InputMaybe<UuidFilter>;
    source?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumCandidateTreatmentStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CandidateTreatmentWhereUniqueInput = {
    AND?: InputMaybe<Array<CandidateTreatmentWhereInput>>;
    NOT?: InputMaybe<Array<CandidateTreatmentWhereInput>>;
    OR?: InputMaybe<Array<CandidateTreatmentWhereInput>>;
    boughtTreatment?: InputMaybe<BoughtTreatmentNullableRelationFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrtDisplayName?: InputMaybe<StringNullableFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    modelVersion?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    predictedCpt?: InputMaybe<StringFilter>;
    price?: InputMaybe<FloatNullableFilter>;
    pricedTreatmentId?: InputMaybe<IntNullableFilter>;
    pricingStatus?: InputMaybe<EnumCandidateTreatmentPricingStatusEnumFilter>;
    probability?: InputMaybe<FloatFilter>;
    rank?: InputMaybe<IntFilter>;
    relationType?: InputMaybe<EnumCptRelationTypeNullableFilter>;
    scoredAt?: InputMaybe<DateTimeFilter>;
    slot?: InputMaybe<SlotRelationFilter>;
    slotId?: InputMaybe<UuidFilter>;
    source?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumCandidateTreatmentStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CardAuthorization = {
    __typename?: 'CardAuthorization';
    cardBillingZipCode?: Maybe<Scalars['String']['output']>;
    cardExpirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    cardHolderName?: Maybe<Scalars['String']['output']>;
    cardIssuer?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    cardType?: Maybe<Scalars['String']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    cvcCheck?: Maybe<Scalars['Boolean']['output']>;
    expiresAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    status: CardAuthorizationStatus;
    statusReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zipCheck?: Maybe<Scalars['Boolean']['output']>;
};

export type CardAuthorizationAuditLog = {
    __typename?: 'CardAuthorizationAuditLog';
    cardAuthorizationId: Scalars['String']['output'];
    cardBillingZipCode?: Maybe<Scalars['String']['output']>;
    cardExpirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    cardHolderName?: Maybe<Scalars['String']['output']>;
    cardIssuer?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    cardType?: Maybe<Scalars['String']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    cvcCheck?: Maybe<Scalars['Boolean']['output']>;
    expiresAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    rawQuery?: Maybe<Scalars['String']['output']>;
    status: CardAuthorizationStatus;
    statusReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zipCheck?: Maybe<Scalars['Boolean']['output']>;
};

export type CardAuthorizationAuditLogAvgAggregate = {
    __typename?: 'CardAuthorizationAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type CardAuthorizationAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type CardAuthorizationAuditLogCountAggregate = {
    __typename?: 'CardAuthorizationAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    cardAuthorizationId: Scalars['Int']['output'];
    cardBillingZipCode: Scalars['Int']['output'];
    cardExpirationDate: Scalars['Int']['output'];
    cardHolderName: Scalars['Int']['output'];
    cardIssuer: Scalars['Int']['output'];
    cardLastFourDigits: Scalars['Int']['output'];
    cardType: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    cvcCheck: Scalars['Int']['output'];
    expiresAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    rawQuery: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    statusReason: Scalars['Int']['output'];
    stripePaymentMethodId: Scalars['Int']['output'];
    stripeSetupIntentId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    zipCheck: Scalars['Int']['output'];
};

export type CardAuthorizationAuditLogCountOrderByAggregateInput = {
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardBillingZipCode?: InputMaybe<SortOrder>;
    cardExpirationDate?: InputMaybe<SortOrder>;
    cardHolderName?: InputMaybe<SortOrder>;
    cardIssuer?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    cardType?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    cvcCheck?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    rawQuery?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    stripeSetupIntentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zipCheck?: InputMaybe<SortOrder>;
};

export type CardAuthorizationAuditLogCreateInput = {
    cardAuthorizationId: Scalars['String']['input'];
    cardBillingZipCode?: InputMaybe<Scalars['String']['input']>;
    cardExpirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cardHolderName?: InputMaybe<Scalars['String']['input']>;
    cardIssuer?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    cardType?: InputMaybe<Scalars['String']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cvcCheck?: InputMaybe<Scalars['Boolean']['input']>;
    expiresAt: Scalars['DateTimeISO']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    rawQuery?: InputMaybe<Scalars['String']['input']>;
    status: CardAuthorizationStatus;
    statusReason?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    stripeSetupIntentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zipCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CardAuthorizationAuditLogCreateManyInput = {
    cardAuthorizationId: Scalars['String']['input'];
    cardBillingZipCode?: InputMaybe<Scalars['String']['input']>;
    cardExpirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cardHolderName?: InputMaybe<Scalars['String']['input']>;
    cardIssuer?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    cardType?: InputMaybe<Scalars['String']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cvcCheck?: InputMaybe<Scalars['Boolean']['input']>;
    expiresAt: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    rawQuery?: InputMaybe<Scalars['String']['input']>;
    status: CardAuthorizationStatus;
    statusReason?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    stripeSetupIntentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zipCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CardAuthorizationAuditLogGroupBy = {
    __typename?: 'CardAuthorizationAuditLogGroupBy';
    _avg?: Maybe<CardAuthorizationAuditLogAvgAggregate>;
    _count?: Maybe<CardAuthorizationAuditLogCountAggregate>;
    _max?: Maybe<CardAuthorizationAuditLogMaxAggregate>;
    _min?: Maybe<CardAuthorizationAuditLogMinAggregate>;
    _sum?: Maybe<CardAuthorizationAuditLogSumAggregate>;
    cardAuthorizationId: Scalars['String']['output'];
    cardBillingZipCode?: Maybe<Scalars['String']['output']>;
    cardExpirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    cardHolderName?: Maybe<Scalars['String']['output']>;
    cardIssuer?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    cardType?: Maybe<Scalars['String']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    cvcCheck?: Maybe<Scalars['Boolean']['output']>;
    expiresAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    rawQuery?: Maybe<Scalars['String']['output']>;
    status: CardAuthorizationStatus;
    statusReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zipCheck?: Maybe<Scalars['Boolean']['output']>;
};

export type CardAuthorizationAuditLogMaxAggregate = {
    __typename?: 'CardAuthorizationAuditLogMaxAggregate';
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardBillingZipCode?: Maybe<Scalars['String']['output']>;
    cardExpirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    cardHolderName?: Maybe<Scalars['String']['output']>;
    cardIssuer?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    cardType?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    cvcCheck?: Maybe<Scalars['Boolean']['output']>;
    expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    rawQuery?: Maybe<Scalars['String']['output']>;
    status?: Maybe<CardAuthorizationStatus>;
    statusReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zipCheck?: Maybe<Scalars['Boolean']['output']>;
};

export type CardAuthorizationAuditLogMaxOrderByAggregateInput = {
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardBillingZipCode?: InputMaybe<SortOrder>;
    cardExpirationDate?: InputMaybe<SortOrder>;
    cardHolderName?: InputMaybe<SortOrder>;
    cardIssuer?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    cardType?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    cvcCheck?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    rawQuery?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    stripeSetupIntentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zipCheck?: InputMaybe<SortOrder>;
};

export type CardAuthorizationAuditLogMinAggregate = {
    __typename?: 'CardAuthorizationAuditLogMinAggregate';
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardBillingZipCode?: Maybe<Scalars['String']['output']>;
    cardExpirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    cardHolderName?: Maybe<Scalars['String']['output']>;
    cardIssuer?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    cardType?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    cvcCheck?: Maybe<Scalars['Boolean']['output']>;
    expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    rawQuery?: Maybe<Scalars['String']['output']>;
    status?: Maybe<CardAuthorizationStatus>;
    statusReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zipCheck?: Maybe<Scalars['Boolean']['output']>;
};

export type CardAuthorizationAuditLogMinOrderByAggregateInput = {
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardBillingZipCode?: InputMaybe<SortOrder>;
    cardExpirationDate?: InputMaybe<SortOrder>;
    cardHolderName?: InputMaybe<SortOrder>;
    cardIssuer?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    cardType?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    cvcCheck?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    rawQuery?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    stripeSetupIntentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zipCheck?: InputMaybe<SortOrder>;
};

export type CardAuthorizationAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<CardAuthorizationAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<CardAuthorizationAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<CardAuthorizationAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<CardAuthorizationAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<CardAuthorizationAuditLogSumOrderByAggregateInput>;
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardBillingZipCode?: InputMaybe<SortOrderInput>;
    cardExpirationDate?: InputMaybe<SortOrderInput>;
    cardHolderName?: InputMaybe<SortOrderInput>;
    cardIssuer?: InputMaybe<SortOrderInput>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    cardType?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    cvcCheck?: InputMaybe<SortOrderInput>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    rawQuery?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    stripeSetupIntentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zipCheck?: InputMaybe<SortOrderInput>;
};

export type CardAuthorizationAuditLogOrderByWithRelationInput = {
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardBillingZipCode?: InputMaybe<SortOrderInput>;
    cardExpirationDate?: InputMaybe<SortOrderInput>;
    cardHolderName?: InputMaybe<SortOrderInput>;
    cardIssuer?: InputMaybe<SortOrderInput>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    cardType?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    cvcCheck?: InputMaybe<SortOrderInput>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    rawQuery?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    stripeSetupIntentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zipCheck?: InputMaybe<SortOrderInput>;
};

export enum CardAuthorizationAuditLogScalarFieldEnum {
    CardAuthorizationId = 'cardAuthorizationId',
    CardBillingZipCode = 'cardBillingZipCode',
    CardExpirationDate = 'cardExpirationDate',
    CardHolderName = 'cardHolderName',
    CardIssuer = 'cardIssuer',
    CardLastFourDigits = 'cardLastFourDigits',
    CardType = 'cardType',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    CvcCheck = 'cvcCheck',
    ExpiresAt = 'expiresAt',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Operation = 'operation',
    OrgId = 'orgId',
    RawQuery = 'rawQuery',
    Status = 'status',
    StatusReason = 'statusReason',
    StripePaymentMethodId = 'stripePaymentMethodId',
    StripeSetupIntentId = 'stripeSetupIntentId',
    UpdatedAt = 'updatedAt',
    ZipCheck = 'zipCheck',
}

export type CardAuthorizationAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<CardAuthorizationAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<CardAuthorizationAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<CardAuthorizationAuditLogScalarWhereWithAggregatesInput>
    >;
    cardAuthorizationId?: InputMaybe<UuidWithAggregatesFilter>;
    cardBillingZipCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    cardExpirationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    cardHolderName?: InputMaybe<StringNullableWithAggregatesFilter>;
    cardIssuer?: InputMaybe<StringNullableWithAggregatesFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableWithAggregatesFilter>;
    cardType?: InputMaybe<StringNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    cvcCheck?: InputMaybe<BoolNullableWithAggregatesFilter>;
    expiresAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    rawQuery?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumCardAuthorizationStatusWithAggregatesFilter>;
    statusReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeSetupIntentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    zipCheck?: InputMaybe<BoolNullableWithAggregatesFilter>;
};

export type CardAuthorizationAuditLogSumAggregate = {
    __typename?: 'CardAuthorizationAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type CardAuthorizationAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type CardAuthorizationAuditLogUpdateInput = {
    cardAuthorizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
    cardBillingZipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardExpirationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    cardHolderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardIssuer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    cvcCheck?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    rawQuery?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumCardAuthorizationStatusFieldUpdateOperationsInput>;
    statusReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeSetupIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zipCheck?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type CardAuthorizationAuditLogUpdateManyMutationInput = {
    cardAuthorizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
    cardBillingZipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardExpirationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    cardHolderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardIssuer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    cvcCheck?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    rawQuery?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumCardAuthorizationStatusFieldUpdateOperationsInput>;
    statusReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeSetupIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zipCheck?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type CardAuthorizationAuditLogWhereInput = {
    AND?: InputMaybe<Array<CardAuthorizationAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<CardAuthorizationAuditLogWhereInput>>;
    OR?: InputMaybe<Array<CardAuthorizationAuditLogWhereInput>>;
    cardAuthorizationId?: InputMaybe<UuidFilter>;
    cardBillingZipCode?: InputMaybe<StringNullableFilter>;
    cardExpirationDate?: InputMaybe<DateTimeNullableFilter>;
    cardHolderName?: InputMaybe<StringNullableFilter>;
    cardIssuer?: InputMaybe<StringNullableFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    cardType?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    cvcCheck?: InputMaybe<BoolNullableFilter>;
    expiresAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    rawQuery?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumCardAuthorizationStatusFilter>;
    statusReason?: InputMaybe<StringNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    stripeSetupIntentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zipCheck?: InputMaybe<BoolNullableFilter>;
};

export type CardAuthorizationAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<CardAuthorizationAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<CardAuthorizationAuditLogWhereInput>>;
    OR?: InputMaybe<Array<CardAuthorizationAuditLogWhereInput>>;
    cardAuthorizationId?: InputMaybe<UuidFilter>;
    cardBillingZipCode?: InputMaybe<StringNullableFilter>;
    cardExpirationDate?: InputMaybe<DateTimeNullableFilter>;
    cardHolderName?: InputMaybe<StringNullableFilter>;
    cardIssuer?: InputMaybe<StringNullableFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    cardType?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    cvcCheck?: InputMaybe<BoolNullableFilter>;
    expiresAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    rawQuery?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumCardAuthorizationStatusFilter>;
    statusReason?: InputMaybe<StringNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    stripeSetupIntentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zipCheck?: InputMaybe<BoolNullableFilter>;
};

export type CardAuthorizationAvgAggregate = {
    __typename?: 'CardAuthorizationAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type CardAuthorizationAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type CardAuthorizationCountAggregate = {
    __typename?: 'CardAuthorizationCountAggregate';
    _all: Scalars['Int']['output'];
    cardBillingZipCode: Scalars['Int']['output'];
    cardExpirationDate: Scalars['Int']['output'];
    cardHolderName: Scalars['Int']['output'];
    cardIssuer: Scalars['Int']['output'];
    cardLastFourDigits: Scalars['Int']['output'];
    cardType: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    cvcCheck: Scalars['Int']['output'];
    expiresAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    statusReason: Scalars['Int']['output'];
    stripePaymentMethodId: Scalars['Int']['output'];
    stripeSetupIntentId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    zipCheck: Scalars['Int']['output'];
};

export type CardAuthorizationCountOrderByAggregateInput = {
    cardBillingZipCode?: InputMaybe<SortOrder>;
    cardExpirationDate?: InputMaybe<SortOrder>;
    cardHolderName?: InputMaybe<SortOrder>;
    cardIssuer?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    cardType?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    cvcCheck?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    stripeSetupIntentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zipCheck?: InputMaybe<SortOrder>;
};

export type CardAuthorizationCreateInput = {
    cardBillingZipCode?: InputMaybe<Scalars['String']['input']>;
    cardExpirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cardHolderName?: InputMaybe<Scalars['String']['input']>;
    cardIssuer?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    cardType?: InputMaybe<Scalars['String']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cvcCheck?: InputMaybe<Scalars['Boolean']['input']>;
    expiresAt: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    status?: InputMaybe<CardAuthorizationStatus>;
    statusReason?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    stripeSetupIntentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zipCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CardAuthorizationCreateManyInput = {
    cardBillingZipCode?: InputMaybe<Scalars['String']['input']>;
    cardExpirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cardHolderName?: InputMaybe<Scalars['String']['input']>;
    cardIssuer?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    cardType?: InputMaybe<Scalars['String']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cvcCheck?: InputMaybe<Scalars['Boolean']['input']>;
    expiresAt: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    status?: InputMaybe<CardAuthorizationStatus>;
    statusReason?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    stripeSetupIntentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zipCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CardAuthorizationGroupBy = {
    __typename?: 'CardAuthorizationGroupBy';
    _avg?: Maybe<CardAuthorizationAvgAggregate>;
    _count?: Maybe<CardAuthorizationCountAggregate>;
    _max?: Maybe<CardAuthorizationMaxAggregate>;
    _min?: Maybe<CardAuthorizationMinAggregate>;
    _sum?: Maybe<CardAuthorizationSumAggregate>;
    cardBillingZipCode?: Maybe<Scalars['String']['output']>;
    cardExpirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    cardHolderName?: Maybe<Scalars['String']['output']>;
    cardIssuer?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    cardType?: Maybe<Scalars['String']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    cvcCheck?: Maybe<Scalars['Boolean']['output']>;
    expiresAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    status: CardAuthorizationStatus;
    statusReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zipCheck?: Maybe<Scalars['Boolean']['output']>;
};

export type CardAuthorizationMaxAggregate = {
    __typename?: 'CardAuthorizationMaxAggregate';
    cardBillingZipCode?: Maybe<Scalars['String']['output']>;
    cardExpirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    cardHolderName?: Maybe<Scalars['String']['output']>;
    cardIssuer?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    cardType?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    cvcCheck?: Maybe<Scalars['Boolean']['output']>;
    expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<CardAuthorizationStatus>;
    statusReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zipCheck?: Maybe<Scalars['Boolean']['output']>;
};

export type CardAuthorizationMaxOrderByAggregateInput = {
    cardBillingZipCode?: InputMaybe<SortOrder>;
    cardExpirationDate?: InputMaybe<SortOrder>;
    cardHolderName?: InputMaybe<SortOrder>;
    cardIssuer?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    cardType?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    cvcCheck?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    stripeSetupIntentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zipCheck?: InputMaybe<SortOrder>;
};

export type CardAuthorizationMinAggregate = {
    __typename?: 'CardAuthorizationMinAggregate';
    cardBillingZipCode?: Maybe<Scalars['String']['output']>;
    cardExpirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    cardHolderName?: Maybe<Scalars['String']['output']>;
    cardIssuer?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    cardType?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    cvcCheck?: Maybe<Scalars['Boolean']['output']>;
    expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<CardAuthorizationStatus>;
    statusReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zipCheck?: Maybe<Scalars['Boolean']['output']>;
};

export type CardAuthorizationMinOrderByAggregateInput = {
    cardBillingZipCode?: InputMaybe<SortOrder>;
    cardExpirationDate?: InputMaybe<SortOrder>;
    cardHolderName?: InputMaybe<SortOrder>;
    cardIssuer?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    cardType?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    cvcCheck?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    stripeSetupIntentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zipCheck?: InputMaybe<SortOrder>;
};

export type CardAuthorizationOrderByWithAggregationInput = {
    _avg?: InputMaybe<CardAuthorizationAvgOrderByAggregateInput>;
    _count?: InputMaybe<CardAuthorizationCountOrderByAggregateInput>;
    _max?: InputMaybe<CardAuthorizationMaxOrderByAggregateInput>;
    _min?: InputMaybe<CardAuthorizationMinOrderByAggregateInput>;
    _sum?: InputMaybe<CardAuthorizationSumOrderByAggregateInput>;
    cardBillingZipCode?: InputMaybe<SortOrderInput>;
    cardExpirationDate?: InputMaybe<SortOrderInput>;
    cardHolderName?: InputMaybe<SortOrderInput>;
    cardIssuer?: InputMaybe<SortOrderInput>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    cardType?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    cvcCheck?: InputMaybe<SortOrderInput>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    stripeSetupIntentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zipCheck?: InputMaybe<SortOrderInput>;
};

export type CardAuthorizationOrderByWithRelationInput = {
    cardBillingZipCode?: InputMaybe<SortOrderInput>;
    cardExpirationDate?: InputMaybe<SortOrderInput>;
    cardHolderName?: InputMaybe<SortOrderInput>;
    cardIssuer?: InputMaybe<SortOrderInput>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    cardType?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    cvcCheck?: InputMaybe<SortOrderInput>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusReason?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    stripeSetupIntentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zipCheck?: InputMaybe<SortOrderInput>;
};

export enum CardAuthorizationScalarFieldEnum {
    CardBillingZipCode = 'cardBillingZipCode',
    CardExpirationDate = 'cardExpirationDate',
    CardHolderName = 'cardHolderName',
    CardIssuer = 'cardIssuer',
    CardLastFourDigits = 'cardLastFourDigits',
    CardType = 'cardType',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    CvcCheck = 'cvcCheck',
    ExpiresAt = 'expiresAt',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    OrgId = 'orgId',
    Status = 'status',
    StatusReason = 'statusReason',
    StripePaymentMethodId = 'stripePaymentMethodId',
    StripeSetupIntentId = 'stripeSetupIntentId',
    UpdatedAt = 'updatedAt',
    ZipCheck = 'zipCheck',
}

export type CardAuthorizationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<CardAuthorizationScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<CardAuthorizationScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<CardAuthorizationScalarWhereWithAggregatesInput>>;
    cardBillingZipCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    cardExpirationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    cardHolderName?: InputMaybe<StringNullableWithAggregatesFilter>;
    cardIssuer?: InputMaybe<StringNullableWithAggregatesFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableWithAggregatesFilter>;
    cardType?: InputMaybe<StringNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    cvcCheck?: InputMaybe<BoolNullableWithAggregatesFilter>;
    expiresAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    status?: InputMaybe<EnumCardAuthorizationStatusWithAggregatesFilter>;
    statusReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeSetupIntentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    zipCheck?: InputMaybe<BoolNullableWithAggregatesFilter>;
};

export enum CardAuthorizationStatus {
    Authorized = 'AUTHORIZED',
    Expired = 'EXPIRED',
    Failed = 'FAILED',
    Pending = 'PENDING',
    Revoked = 'REVOKED',
}

export type CardAuthorizationSumAggregate = {
    __typename?: 'CardAuthorizationSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type CardAuthorizationSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type CardAuthorizationUpdateInput = {
    cardBillingZipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardExpirationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    cardHolderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardIssuer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    cvcCheck?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumCardAuthorizationStatusFieldUpdateOperationsInput>;
    statusReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeSetupIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zipCheck?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type CardAuthorizationUpdateManyMutationInput = {
    cardBillingZipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardExpirationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    cardHolderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardIssuer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    cvcCheck?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumCardAuthorizationStatusFieldUpdateOperationsInput>;
    statusReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeSetupIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zipCheck?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type CardAuthorizationWhereInput = {
    AND?: InputMaybe<Array<CardAuthorizationWhereInput>>;
    NOT?: InputMaybe<Array<CardAuthorizationWhereInput>>;
    OR?: InputMaybe<Array<CardAuthorizationWhereInput>>;
    cardBillingZipCode?: InputMaybe<StringNullableFilter>;
    cardExpirationDate?: InputMaybe<DateTimeNullableFilter>;
    cardHolderName?: InputMaybe<StringNullableFilter>;
    cardIssuer?: InputMaybe<StringNullableFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    cardType?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    cvcCheck?: InputMaybe<BoolNullableFilter>;
    expiresAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    status?: InputMaybe<EnumCardAuthorizationStatusFilter>;
    statusReason?: InputMaybe<StringNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    stripeSetupIntentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zipCheck?: InputMaybe<BoolNullableFilter>;
};

export type CardAuthorizationWhereUniqueInput = {
    AND?: InputMaybe<Array<CardAuthorizationWhereInput>>;
    NOT?: InputMaybe<Array<CardAuthorizationWhereInput>>;
    OR?: InputMaybe<Array<CardAuthorizationWhereInput>>;
    cardBillingZipCode?: InputMaybe<StringNullableFilter>;
    cardExpirationDate?: InputMaybe<DateTimeNullableFilter>;
    cardHolderName?: InputMaybe<StringNullableFilter>;
    cardIssuer?: InputMaybe<StringNullableFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    cardType?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    cvcCheck?: InputMaybe<BoolNullableFilter>;
    expiresAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    status?: InputMaybe<EnumCardAuthorizationStatusFilter>;
    statusReason?: InputMaybe<StringNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    stripeSetupIntentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zipCheck?: InputMaybe<BoolNullableFilter>;
};

export type CashPrice = {
    __typename?: 'CashPrice';
    cashPrice: Scalars['Int']['output'];
    hrt: Hrt;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
};

export type CashPriceAvgAggregate = {
    __typename?: 'CashPriceAvgAggregate';
    cashPrice?: Maybe<Scalars['Float']['output']>;
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type CashPriceAvgOrderByAggregateInput = {
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type CashPriceCountAggregate = {
    __typename?: 'CashPriceCountAggregate';
    _all: Scalars['Int']['output'];
    cashPrice: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
};

export type CashPriceCountOrderByAggregateInput = {
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type CashPriceCreateInput = {
    cashPrice: Scalars['Int']['input'];
    hrt: HrtCreateNestedOneWithoutCashPricesInput;
};

export type CashPriceCreateManyInput = {
    cashPrice: Scalars['Int']['input'];
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
};

export type CashPriceCreateNestedOneWithoutHrtInput = {
    connect?: InputMaybe<CashPriceWhereUniqueInput>;
    connectOrCreate?: InputMaybe<CashPriceCreateOrConnectWithoutHrtInput>;
    create?: InputMaybe<CashPriceCreateWithoutHrtInput>;
};

export type CashPriceCreateOrConnectWithoutHrtInput = {
    create: CashPriceCreateWithoutHrtInput;
    where: CashPriceWhereUniqueInput;
};

export type CashPriceCreateWithoutHrtInput = {
    cashPrice: Scalars['Int']['input'];
};

export type CashPriceGroupBy = {
    __typename?: 'CashPriceGroupBy';
    _avg?: Maybe<CashPriceAvgAggregate>;
    _count?: Maybe<CashPriceCountAggregate>;
    _max?: Maybe<CashPriceMaxAggregate>;
    _min?: Maybe<CashPriceMinAggregate>;
    _sum?: Maybe<CashPriceSumAggregate>;
    cashPrice: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
};

export type CashPriceMaxAggregate = {
    __typename?: 'CashPriceMaxAggregate';
    cashPrice?: Maybe<Scalars['Int']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type CashPriceMaxOrderByAggregateInput = {
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type CashPriceMinAggregate = {
    __typename?: 'CashPriceMinAggregate';
    cashPrice?: Maybe<Scalars['Int']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type CashPriceMinOrderByAggregateInput = {
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type CashPriceNullableRelationFilter = {
    is?: InputMaybe<CashPriceWhereInput>;
    isNot?: InputMaybe<CashPriceWhereInput>;
};

export type CashPriceOrderByWithAggregationInput = {
    _avg?: InputMaybe<CashPriceAvgOrderByAggregateInput>;
    _count?: InputMaybe<CashPriceCountOrderByAggregateInput>;
    _max?: InputMaybe<CashPriceMaxOrderByAggregateInput>;
    _min?: InputMaybe<CashPriceMinOrderByAggregateInput>;
    _sum?: InputMaybe<CashPriceSumOrderByAggregateInput>;
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type CashPriceOrderByWithRelationInput = {
    cashPrice?: InputMaybe<SortOrder>;
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export enum CashPriceScalarFieldEnum {
    CashPrice = 'cashPrice',
    HrtId = 'hrtId',
    Id = 'id',
}

export type CashPriceScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<CashPriceScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<CashPriceScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<CashPriceScalarWhereWithAggregatesInput>>;
    cashPrice?: InputMaybe<IntWithAggregatesFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
};

export type CashPriceSumAggregate = {
    __typename?: 'CashPriceSumAggregate';
    cashPrice?: Maybe<Scalars['Int']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type CashPriceSumOrderByAggregateInput = {
    cashPrice?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type CashPriceUpdateInput = {
    cashPrice?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutCashPricesNestedInput>;
};

export type CashPriceUpdateManyMutationInput = {
    cashPrice?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type CashPriceUpdateOneWithoutHrtNestedInput = {
    connect?: InputMaybe<CashPriceWhereUniqueInput>;
    connectOrCreate?: InputMaybe<CashPriceCreateOrConnectWithoutHrtInput>;
    create?: InputMaybe<CashPriceCreateWithoutHrtInput>;
    delete?: InputMaybe<CashPriceWhereInput>;
    disconnect?: InputMaybe<CashPriceWhereInput>;
    update?: InputMaybe<CashPriceUpdateToOneWithWhereWithoutHrtInput>;
    upsert?: InputMaybe<CashPriceUpsertWithoutHrtInput>;
};

export type CashPriceUpdateToOneWithWhereWithoutHrtInput = {
    data: CashPriceUpdateWithoutHrtInput;
    where?: InputMaybe<CashPriceWhereInput>;
};

export type CashPriceUpdateWithoutHrtInput = {
    cashPrice?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type CashPriceUpsertWithoutHrtInput = {
    create: CashPriceCreateWithoutHrtInput;
    update: CashPriceUpdateWithoutHrtInput;
    where?: InputMaybe<CashPriceWhereInput>;
};

export type CashPriceWhereInput = {
    AND?: InputMaybe<Array<CashPriceWhereInput>>;
    NOT?: InputMaybe<Array<CashPriceWhereInput>>;
    OR?: InputMaybe<Array<CashPriceWhereInput>>;
    cashPrice?: InputMaybe<IntFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
};

export type CashPriceWhereUniqueInput = {
    AND?: InputMaybe<Array<CashPriceWhereInput>>;
    NOT?: InputMaybe<Array<CashPriceWhereInput>>;
    OR?: InputMaybe<Array<CashPriceWhereInput>>;
    cashPrice?: InputMaybe<IntFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
};

export type Charge = {
    __typename?: 'Charge';
    _count?: Maybe<ChargeCount>;
    boughtTreatmentId: Scalars['String']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    payoutIds: Array<Scalars['String']['output']>;
    payouts: Array<Payout>;
    reattributionState?: Maybe<ReattributionState>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptFee?: Maybe<SuperscriptFees>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    total: Scalars['Decimal']['output'];
    transaction?: Maybe<Transaction>;
    transactionId?: Maybe<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargePayoutsArgs = {
    cursor?: InputMaybe<PayoutWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayoutScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutWhereInput>;
};

export type ChargeSuperscriptFeeArgs = {
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type ChargeTransactionArgs = {
    where?: InputMaybe<TransactionWhereInput>;
};

export type ChargeAuditLog = {
    __typename?: 'ChargeAuditLog';
    boughtTreatmentId: Scalars['String']['output'];
    chargeId: Scalars['String']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    payoutIds: Array<Scalars['String']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    total: Scalars['Decimal']['output'];
    transactionId?: Maybe<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeAuditLogAvgAggregate = {
    __typename?: 'ChargeAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    total?: Maybe<Scalars['Decimal']['output']>;
};

export type ChargeAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
};

export type ChargeAuditLogCountAggregate = {
    __typename?: 'ChargeAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    chargeId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payoutIds: Scalars['Int']['output'];
    reattributionState: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    superscriptFeeId: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
    transactionId: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
};

export type ChargeAuditLogCountOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    chargeId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payoutIds?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeAuditLogCreateInput = {
    boughtTreatmentId: Scalars['String']['input'];
    chargeId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    operation: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    payoutIds?: InputMaybe<ChargeAuditLogCreatepayoutIdsInput>;
    reattributionState?: InputMaybe<ReattributionState>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptFeeId?: InputMaybe<Scalars['String']['input']>;
    total: Scalars['Decimal']['input'];
    transactionId?: InputMaybe<Scalars['String']['input']>;
    type: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeAuditLogCreateManyInput = {
    boughtTreatmentId: Scalars['String']['input'];
    chargeId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    operation: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    payoutIds?: InputMaybe<ChargeAuditLogCreatepayoutIdsInput>;
    reattributionState?: InputMaybe<ReattributionState>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptFeeId?: InputMaybe<Scalars['String']['input']>;
    total: Scalars['Decimal']['input'];
    transactionId?: InputMaybe<Scalars['String']['input']>;
    type: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeAuditLogCreatepayoutIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ChargeAuditLogGroupBy = {
    __typename?: 'ChargeAuditLogGroupBy';
    _avg?: Maybe<ChargeAuditLogAvgAggregate>;
    _count?: Maybe<ChargeAuditLogCountAggregate>;
    _max?: Maybe<ChargeAuditLogMaxAggregate>;
    _min?: Maybe<ChargeAuditLogMinAggregate>;
    _sum?: Maybe<ChargeAuditLogSumAggregate>;
    boughtTreatmentId: Scalars['String']['output'];
    chargeId: Scalars['String']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    payoutIds?: Maybe<Array<Scalars['String']['output']>>;
    reattributionState?: Maybe<ReattributionState>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    total: Scalars['Decimal']['output'];
    transactionId?: Maybe<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeAuditLogMaxAggregate = {
    __typename?: 'ChargeAuditLogMaxAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    chargeId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    total?: Maybe<Scalars['Decimal']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeAuditLogMaxOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    chargeId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeAuditLogMinAggregate = {
    __typename?: 'ChargeAuditLogMinAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    chargeId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    total?: Maybe<Scalars['Decimal']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeAuditLogMinOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    chargeId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<ChargeAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<ChargeAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<ChargeAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<ChargeAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<ChargeAuditLogSumOrderByAggregateInput>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    chargeId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payoutIds?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    superscriptFeeId?: InputMaybe<SortOrderInput>;
    total?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrderInput>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrderInput>;
};

export type ChargeAuditLogOrderByWithRelationInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    chargeId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payoutIds?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    superscriptFeeId?: InputMaybe<SortOrderInput>;
    total?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrderInput>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrderInput>;
};

export enum ChargeAuditLogScalarFieldEnum {
    BoughtTreatmentId = 'boughtTreatmentId',
    ChargeId = 'chargeId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    Date = 'date',
    Id = 'id',
    Operation = 'operation',
    OrgId = 'orgId',
    PayoutIds = 'payoutIds',
    ReattributionState = 'reattributionState',
    SlotId = 'slotId',
    SuperscriptFeeId = 'superscriptFeeId',
    Total = 'total',
    TransactionId = 'transactionId',
    Type = 'type',
    UpdatedAt = 'updatedAt',
    UserId = 'userId',
}

export type ChargeAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ChargeAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ChargeAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ChargeAuditLogScalarWhereWithAggregatesInput>>;
    boughtTreatmentId?: InputMaybe<StringWithAggregatesFilter>;
    chargeId?: InputMaybe<StringWithAggregatesFilter>;
    consumerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableWithAggregatesFilter>;
    slotId?: InputMaybe<StringNullableWithAggregatesFilter>;
    superscriptFeeId?: InputMaybe<StringNullableWithAggregatesFilter>;
    total?: InputMaybe<DecimalWithAggregatesFilter>;
    transactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    type?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    userId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ChargeAuditLogSumAggregate = {
    __typename?: 'ChargeAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    total?: Maybe<Scalars['Decimal']['output']>;
};

export type ChargeAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
};

export type ChargeAuditLogUpdateInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    chargeId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<ChargeAuditLogUpdatepayoutIdsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFeeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    total?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    type?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeAuditLogUpdateManyMutationInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    chargeId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<ChargeAuditLogUpdatepayoutIdsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFeeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    total?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    type?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeAuditLogUpdatepayoutIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChargeAuditLogWhereInput = {
    AND?: InputMaybe<Array<ChargeAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<ChargeAuditLogWhereInput>>;
    OR?: InputMaybe<Array<ChargeAuditLogWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringFilter>;
    chargeId?: InputMaybe<StringFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    date?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    superscriptFeeId?: InputMaybe<StringNullableFilter>;
    total?: InputMaybe<DecimalFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    type?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<StringNullableFilter>;
};

export type ChargeAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<ChargeAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<ChargeAuditLogWhereInput>>;
    OR?: InputMaybe<Array<ChargeAuditLogWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringFilter>;
    chargeId?: InputMaybe<StringFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    date?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    superscriptFeeId?: InputMaybe<StringNullableFilter>;
    total?: InputMaybe<DecimalFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    type?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<StringNullableFilter>;
};

export type ChargeAvgAggregate = {
    __typename?: 'ChargeAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
    total?: Maybe<Scalars['Decimal']['output']>;
};

export type ChargeAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
};

export type ChargeCount = {
    __typename?: 'ChargeCount';
    payouts: Scalars['Int']['output'];
};

export type ChargeCountPayoutsArgs = {
    where?: InputMaybe<PayoutWhereInput>;
};

export type ChargeCountAggregate = {
    __typename?: 'ChargeCountAggregate';
    _all: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payoutIds: Scalars['Int']['output'];
    reattributionState: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    superscriptFeeId: Scalars['Int']['output'];
    total: Scalars['Int']['output'];
    transactionId: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
};

export type ChargeCountOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payoutIds?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeCreateInput = {
    boughtTreatmentId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    id: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    payoutIds?: InputMaybe<ChargeCreatepayoutIdsInput>;
    payouts?: InputMaybe<PayoutCreateNestedManyWithoutChargesInput>;
    reattributionState?: InputMaybe<ReattributionState>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptFee?: InputMaybe<SuperscriptFeesCreateNestedOneWithoutChargesInput>;
    total: Scalars['Decimal']['input'];
    transaction?: InputMaybe<TransactionCreateNestedOneWithoutChargesInput>;
    type: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeCreateManyInput = {
    boughtTreatmentId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    id: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    payoutIds?: InputMaybe<ChargeCreatepayoutIdsInput>;
    reattributionState?: InputMaybe<ReattributionState>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptFeeId?: InputMaybe<Scalars['String']['input']>;
    total: Scalars['Decimal']['input'];
    transactionId?: InputMaybe<Scalars['String']['input']>;
    type: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeCreateManySuperscriptFeeInput = {
    boughtTreatmentId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    id: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    payoutIds?: InputMaybe<ChargeCreatepayoutIdsInput>;
    reattributionState?: InputMaybe<ReattributionState>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    total: Scalars['Decimal']['input'];
    transactionId?: InputMaybe<Scalars['String']['input']>;
    type: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeCreateManySuperscriptFeeInputEnvelope = {
    data: Array<ChargeCreateManySuperscriptFeeInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChargeCreateManyTransactionInput = {
    boughtTreatmentId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    id: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    payoutIds?: InputMaybe<ChargeCreatepayoutIdsInput>;
    reattributionState?: InputMaybe<ReattributionState>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptFeeId?: InputMaybe<Scalars['String']['input']>;
    total: Scalars['Decimal']['input'];
    type: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeCreateManyTransactionInputEnvelope = {
    data: Array<ChargeCreateManyTransactionInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChargeCreateNestedManyWithoutPayoutsInput = {
    connect?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ChargeCreateOrConnectWithoutPayoutsInput>
    >;
    create?: InputMaybe<Array<ChargeCreateWithoutPayoutsInput>>;
};

export type ChargeCreateNestedManyWithoutSuperscriptFeeInput = {
    connect?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ChargeCreateOrConnectWithoutSuperscriptFeeInput>
    >;
    create?: InputMaybe<Array<ChargeCreateWithoutSuperscriptFeeInput>>;
    createMany?: InputMaybe<ChargeCreateManySuperscriptFeeInputEnvelope>;
};

export type ChargeCreateNestedManyWithoutTransactionInput = {
    connect?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ChargeCreateOrConnectWithoutTransactionInput>
    >;
    create?: InputMaybe<Array<ChargeCreateWithoutTransactionInput>>;
    createMany?: InputMaybe<ChargeCreateManyTransactionInputEnvelope>;
};

export type ChargeCreateOrConnectWithoutPayoutsInput = {
    create: ChargeCreateWithoutPayoutsInput;
    where: ChargeWhereUniqueInput;
};

export type ChargeCreateOrConnectWithoutSuperscriptFeeInput = {
    create: ChargeCreateWithoutSuperscriptFeeInput;
    where: ChargeWhereUniqueInput;
};

export type ChargeCreateOrConnectWithoutTransactionInput = {
    create: ChargeCreateWithoutTransactionInput;
    where: ChargeWhereUniqueInput;
};

export type ChargeCreateWithoutPayoutsInput = {
    boughtTreatmentId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    id: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    payoutIds?: InputMaybe<ChargeCreatepayoutIdsInput>;
    reattributionState?: InputMaybe<ReattributionState>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptFee?: InputMaybe<SuperscriptFeesCreateNestedOneWithoutChargesInput>;
    total: Scalars['Decimal']['input'];
    transaction?: InputMaybe<TransactionCreateNestedOneWithoutChargesInput>;
    type: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeCreateWithoutSuperscriptFeeInput = {
    boughtTreatmentId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    id: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    payoutIds?: InputMaybe<ChargeCreatepayoutIdsInput>;
    payouts?: InputMaybe<PayoutCreateNestedManyWithoutChargesInput>;
    reattributionState?: InputMaybe<ReattributionState>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    total: Scalars['Decimal']['input'];
    transaction?: InputMaybe<TransactionCreateNestedOneWithoutChargesInput>;
    type: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeCreateWithoutTransactionInput = {
    boughtTreatmentId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    id: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    payoutIds?: InputMaybe<ChargeCreatepayoutIdsInput>;
    payouts?: InputMaybe<PayoutCreateNestedManyWithoutChargesInput>;
    reattributionState?: InputMaybe<ReattributionState>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    superscriptFee?: InputMaybe<SuperscriptFeesCreateNestedOneWithoutChargesInput>;
    total: Scalars['Decimal']['input'];
    type: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeCreatepayoutIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ChargeDto = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    status?: InputMaybe<TransactionStatus>;
    total: Scalars['Float']['input'];
    transactionId?: InputMaybe<Scalars['String']['input']>;
    type: Scalars['String']['input'];
    userId: Scalars['String']['input'];
};

export type ChargeGroupBy = {
    __typename?: 'ChargeGroupBy';
    _avg?: Maybe<ChargeAvgAggregate>;
    _count?: Maybe<ChargeCountAggregate>;
    _max?: Maybe<ChargeMaxAggregate>;
    _min?: Maybe<ChargeMinAggregate>;
    _sum?: Maybe<ChargeSumAggregate>;
    boughtTreatmentId: Scalars['String']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    payoutIds?: Maybe<Array<Scalars['String']['output']>>;
    reattributionState?: Maybe<ReattributionState>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    total: Scalars['Decimal']['output'];
    transactionId?: Maybe<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeListRelationFilter = {
    every?: InputMaybe<ChargeWhereInput>;
    none?: InputMaybe<ChargeWhereInput>;
    some?: InputMaybe<ChargeWhereInput>;
};

export type ChargeMaxAggregate = {
    __typename?: 'ChargeMaxAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    total?: Maybe<Scalars['Decimal']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeMaxOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeMinAggregate = {
    __typename?: 'ChargeMinAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    total?: Maybe<Scalars['Decimal']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeMinOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ChargeOrderByWithAggregationInput = {
    _avg?: InputMaybe<ChargeAvgOrderByAggregateInput>;
    _count?: InputMaybe<ChargeCountOrderByAggregateInput>;
    _max?: InputMaybe<ChargeMaxOrderByAggregateInput>;
    _min?: InputMaybe<ChargeMinOrderByAggregateInput>;
    _sum?: InputMaybe<ChargeSumOrderByAggregateInput>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payoutIds?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    superscriptFeeId?: InputMaybe<SortOrderInput>;
    total?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrderInput>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
    userId?: InputMaybe<SortOrderInput>;
};

export type ChargeOrderByWithRelationInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payoutIds?: InputMaybe<SortOrder>;
    payouts?: InputMaybe<PayoutOrderByRelationAggregateInput>;
    reattributionState?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    superscriptFee?: InputMaybe<SuperscriptFeesOrderByWithRelationInput>;
    superscriptFeeId?: InputMaybe<SortOrderInput>;
    total?: InputMaybe<SortOrder>;
    transaction?: InputMaybe<TransactionOrderByWithRelationInput>;
    transactionId?: InputMaybe<SortOrderInput>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
    userId?: InputMaybe<SortOrderInput>;
};

export type ChargeReattributionAndPartialPaymentLog = {
    __typename?: 'ChargeReattributionAndPartialPaymentLog';
    consumerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    destinationBoughtTreatmentIds: Array<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    moveList: Array<Scalars['String']['output']>;
    sourceBoughtTreatmentIds: Array<Scalars['String']['output']>;
    success: Scalars['Boolean']['output'];
    type: ChargeReattributionAndPartialPaymentLogType;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeReattributionAndPartialPaymentLogAvgAggregate = {
    __typename?: 'ChargeReattributionAndPartialPaymentLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type ChargeReattributionAndPartialPaymentLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ChargeReattributionAndPartialPaymentLogCountAggregate = {
    __typename?: 'ChargeReattributionAndPartialPaymentLogCountAggregate';
    _all: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    destinationBoughtTreatmentIds: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    moveList: Scalars['Int']['output'];
    sourceBoughtTreatmentIds: Scalars['Int']['output'];
    success: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
};

export type ChargeReattributionAndPartialPaymentLogCountOrderByAggregateInput =
    {
        consumerId?: InputMaybe<SortOrder>;
        date?: InputMaybe<SortOrder>;
        destinationBoughtTreatmentIds?: InputMaybe<SortOrder>;
        id?: InputMaybe<SortOrder>;
        moveList?: InputMaybe<SortOrder>;
        sourceBoughtTreatmentIds?: InputMaybe<SortOrder>;
        success?: InputMaybe<SortOrder>;
        type?: InputMaybe<SortOrder>;
        userId?: InputMaybe<SortOrder>;
    };

export type ChargeReattributionAndPartialPaymentLogCreateInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    destinationBoughtTreatmentIds?: InputMaybe<ChargeReattributionAndPartialPaymentLogCreatedestinationBoughtTreatmentIdsInput>;
    moveList?: InputMaybe<ChargeReattributionAndPartialPaymentLogCreatemoveListInput>;
    sourceBoughtTreatmentIds?: InputMaybe<ChargeReattributionAndPartialPaymentLogCreatesourceBoughtTreatmentIdsInput>;
    success?: InputMaybe<Scalars['Boolean']['input']>;
    type: ChargeReattributionAndPartialPaymentLogType;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeReattributionAndPartialPaymentLogCreateManyInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    destinationBoughtTreatmentIds?: InputMaybe<ChargeReattributionAndPartialPaymentLogCreatedestinationBoughtTreatmentIdsInput>;
    id?: InputMaybe<Scalars['Int']['input']>;
    moveList?: InputMaybe<ChargeReattributionAndPartialPaymentLogCreatemoveListInput>;
    sourceBoughtTreatmentIds?: InputMaybe<ChargeReattributionAndPartialPaymentLogCreatesourceBoughtTreatmentIdsInput>;
    success?: InputMaybe<Scalars['Boolean']['input']>;
    type: ChargeReattributionAndPartialPaymentLogType;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeReattributionAndPartialPaymentLogCreatedestinationBoughtTreatmentIdsInput =
    {
        set: Array<Scalars['String']['input']>;
    };

export type ChargeReattributionAndPartialPaymentLogCreatemoveListInput = {
    set: Array<Scalars['String']['input']>;
};

export type ChargeReattributionAndPartialPaymentLogCreatesourceBoughtTreatmentIdsInput =
    {
        set: Array<Scalars['String']['input']>;
    };

export type ChargeReattributionAndPartialPaymentLogGroupBy = {
    __typename?: 'ChargeReattributionAndPartialPaymentLogGroupBy';
    _avg?: Maybe<ChargeReattributionAndPartialPaymentLogAvgAggregate>;
    _count?: Maybe<ChargeReattributionAndPartialPaymentLogCountAggregate>;
    _max?: Maybe<ChargeReattributionAndPartialPaymentLogMaxAggregate>;
    _min?: Maybe<ChargeReattributionAndPartialPaymentLogMinAggregate>;
    _sum?: Maybe<ChargeReattributionAndPartialPaymentLogSumAggregate>;
    consumerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    destinationBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['Int']['output'];
    moveList?: Maybe<Array<Scalars['String']['output']>>;
    sourceBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    success: Scalars['Boolean']['output'];
    type: ChargeReattributionAndPartialPaymentLogType;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeReattributionAndPartialPaymentLogMaxAggregate = {
    __typename?: 'ChargeReattributionAndPartialPaymentLogMaxAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    success?: Maybe<Scalars['Boolean']['output']>;
    type?: Maybe<ChargeReattributionAndPartialPaymentLogType>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeReattributionAndPartialPaymentLogMaxOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    success?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeReattributionAndPartialPaymentLogMinAggregate = {
    __typename?: 'ChargeReattributionAndPartialPaymentLogMinAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    success?: Maybe<Scalars['Boolean']['output']>;
    type?: Maybe<ChargeReattributionAndPartialPaymentLogType>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeReattributionAndPartialPaymentLogMinOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    success?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeReattributionAndPartialPaymentLogOrderByWithAggregationInput =
    {
        _avg?: InputMaybe<ChargeReattributionAndPartialPaymentLogAvgOrderByAggregateInput>;
        _count?: InputMaybe<ChargeReattributionAndPartialPaymentLogCountOrderByAggregateInput>;
        _max?: InputMaybe<ChargeReattributionAndPartialPaymentLogMaxOrderByAggregateInput>;
        _min?: InputMaybe<ChargeReattributionAndPartialPaymentLogMinOrderByAggregateInput>;
        _sum?: InputMaybe<ChargeReattributionAndPartialPaymentLogSumOrderByAggregateInput>;
        consumerId?: InputMaybe<SortOrderInput>;
        date?: InputMaybe<SortOrder>;
        destinationBoughtTreatmentIds?: InputMaybe<SortOrder>;
        id?: InputMaybe<SortOrder>;
        moveList?: InputMaybe<SortOrder>;
        sourceBoughtTreatmentIds?: InputMaybe<SortOrder>;
        success?: InputMaybe<SortOrder>;
        type?: InputMaybe<SortOrder>;
        userId?: InputMaybe<SortOrderInput>;
    };

export type ChargeReattributionAndPartialPaymentLogOrderByWithRelationInput = {
    consumerId?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    destinationBoughtTreatmentIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    moveList?: InputMaybe<SortOrder>;
    sourceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    success?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrderInput>;
};

export enum ChargeReattributionAndPartialPaymentLogScalarFieldEnum {
    ConsumerId = 'consumerId',
    Date = 'date',
    DestinationBoughtTreatmentIds = 'destinationBoughtTreatmentIds',
    Id = 'id',
    MoveList = 'moveList',
    SourceBoughtTreatmentIds = 'sourceBoughtTreatmentIds',
    Success = 'success',
    Type = 'type',
    UserId = 'userId',
}

export type ChargeReattributionAndPartialPaymentLogScalarWhereWithAggregatesInput =
    {
        AND?: InputMaybe<
            Array<ChargeReattributionAndPartialPaymentLogScalarWhereWithAggregatesInput>
        >;
        NOT?: InputMaybe<
            Array<ChargeReattributionAndPartialPaymentLogScalarWhereWithAggregatesInput>
        >;
        OR?: InputMaybe<
            Array<ChargeReattributionAndPartialPaymentLogScalarWhereWithAggregatesInput>
        >;
        consumerId?: InputMaybe<StringNullableWithAggregatesFilter>;
        date?: InputMaybe<DateTimeWithAggregatesFilter>;
        destinationBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
        id?: InputMaybe<IntWithAggregatesFilter>;
        moveList?: InputMaybe<StringNullableListFilter>;
        sourceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
        success?: InputMaybe<BoolWithAggregatesFilter>;
        type?: InputMaybe<EnumChargeReattributionAndPartialPaymentLogTypeWithAggregatesFilter>;
        userId?: InputMaybe<StringNullableWithAggregatesFilter>;
    };

export type ChargeReattributionAndPartialPaymentLogSumAggregate = {
    __typename?: 'ChargeReattributionAndPartialPaymentLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type ChargeReattributionAndPartialPaymentLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export enum ChargeReattributionAndPartialPaymentLogType {
    PartialPayment = 'PARTIAL_PAYMENT',
    Reattribution = 'REATTRIBUTION',
}

export type ChargeReattributionAndPartialPaymentLogUpdateInput = {
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationBoughtTreatmentIds?: InputMaybe<ChargeReattributionAndPartialPaymentLogUpdatedestinationBoughtTreatmentIdsInput>;
    moveList?: InputMaybe<ChargeReattributionAndPartialPaymentLogUpdatemoveListInput>;
    sourceBoughtTreatmentIds?: InputMaybe<ChargeReattributionAndPartialPaymentLogUpdatesourceBoughtTreatmentIdsInput>;
    success?: InputMaybe<BoolFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumChargeReattributionAndPartialPaymentLogTypeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeReattributionAndPartialPaymentLogUpdateManyMutationInput = {
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationBoughtTreatmentIds?: InputMaybe<ChargeReattributionAndPartialPaymentLogUpdatedestinationBoughtTreatmentIdsInput>;
    moveList?: InputMaybe<ChargeReattributionAndPartialPaymentLogUpdatemoveListInput>;
    sourceBoughtTreatmentIds?: InputMaybe<ChargeReattributionAndPartialPaymentLogUpdatesourceBoughtTreatmentIdsInput>;
    success?: InputMaybe<BoolFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumChargeReattributionAndPartialPaymentLogTypeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeReattributionAndPartialPaymentLogUpdatedestinationBoughtTreatmentIdsInput =
    {
        push?: InputMaybe<Array<Scalars['String']['input']>>;
        set?: InputMaybe<Array<Scalars['String']['input']>>;
    };

export type ChargeReattributionAndPartialPaymentLogUpdatemoveListInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChargeReattributionAndPartialPaymentLogUpdatesourceBoughtTreatmentIdsInput =
    {
        push?: InputMaybe<Array<Scalars['String']['input']>>;
        set?: InputMaybe<Array<Scalars['String']['input']>>;
    };

export type ChargeReattributionAndPartialPaymentLogWhereInput = {
    AND?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogWhereInput>>;
    NOT?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogWhereInput>>;
    OR?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogWhereInput>>;
    consumerId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    destinationBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntFilter>;
    moveList?: InputMaybe<StringNullableListFilter>;
    sourceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    success?: InputMaybe<BoolFilter>;
    type?: InputMaybe<EnumChargeReattributionAndPartialPaymentLogTypeFilter>;
    userId?: InputMaybe<StringNullableFilter>;
};

export type ChargeReattributionAndPartialPaymentLogWhereUniqueInput = {
    AND?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogWhereInput>>;
    NOT?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogWhereInput>>;
    OR?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogWhereInput>>;
    consumerId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    destinationBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    moveList?: InputMaybe<StringNullableListFilter>;
    sourceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    success?: InputMaybe<BoolFilter>;
    type?: InputMaybe<EnumChargeReattributionAndPartialPaymentLogTypeFilter>;
    userId?: InputMaybe<StringNullableFilter>;
};

export type ChargeReattributionLog = {
    __typename?: 'ChargeReattributionLog';
    consumerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    destinationBoughtTreatmentIds: Array<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    moveList: Array<Scalars['String']['output']>;
    sourceBoughtTreatmentIds: Array<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeReattributionLogAvgAggregate = {
    __typename?: 'ChargeReattributionLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type ChargeReattributionLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ChargeReattributionLogCountAggregate = {
    __typename?: 'ChargeReattributionLogCountAggregate';
    _all: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    destinationBoughtTreatmentIds: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    moveList: Scalars['Int']['output'];
    sourceBoughtTreatmentIds: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
};

export type ChargeReattributionLogCountOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    destinationBoughtTreatmentIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    moveList?: InputMaybe<SortOrder>;
    sourceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeReattributionLogCreateInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    destinationBoughtTreatmentIds?: InputMaybe<ChargeReattributionLogCreatedestinationBoughtTreatmentIdsInput>;
    moveList?: InputMaybe<ChargeReattributionLogCreatemoveListInput>;
    sourceBoughtTreatmentIds?: InputMaybe<ChargeReattributionLogCreatesourceBoughtTreatmentIdsInput>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeReattributionLogCreateManyInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    destinationBoughtTreatmentIds?: InputMaybe<ChargeReattributionLogCreatedestinationBoughtTreatmentIdsInput>;
    id?: InputMaybe<Scalars['Int']['input']>;
    moveList?: InputMaybe<ChargeReattributionLogCreatemoveListInput>;
    sourceBoughtTreatmentIds?: InputMaybe<ChargeReattributionLogCreatesourceBoughtTreatmentIdsInput>;
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeReattributionLogCreatedestinationBoughtTreatmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ChargeReattributionLogCreatemoveListInput = {
    set: Array<Scalars['String']['input']>;
};

export type ChargeReattributionLogCreatesourceBoughtTreatmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ChargeReattributionLogGroupBy = {
    __typename?: 'ChargeReattributionLogGroupBy';
    _avg?: Maybe<ChargeReattributionLogAvgAggregate>;
    _count?: Maybe<ChargeReattributionLogCountAggregate>;
    _max?: Maybe<ChargeReattributionLogMaxAggregate>;
    _min?: Maybe<ChargeReattributionLogMinAggregate>;
    _sum?: Maybe<ChargeReattributionLogSumAggregate>;
    consumerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    destinationBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['Int']['output'];
    moveList?: Maybe<Array<Scalars['String']['output']>>;
    sourceBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeReattributionLogMaxAggregate = {
    __typename?: 'ChargeReattributionLogMaxAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeReattributionLogMaxOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeReattributionLogMinAggregate = {
    __typename?: 'ChargeReattributionLogMinAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeReattributionLogMinOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type ChargeReattributionLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<ChargeReattributionLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<ChargeReattributionLogCountOrderByAggregateInput>;
    _max?: InputMaybe<ChargeReattributionLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<ChargeReattributionLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<ChargeReattributionLogSumOrderByAggregateInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    destinationBoughtTreatmentIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    moveList?: InputMaybe<SortOrder>;
    sourceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrderInput>;
};

export type ChargeReattributionLogOrderByWithRelationInput = {
    consumerId?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    destinationBoughtTreatmentIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    moveList?: InputMaybe<SortOrder>;
    sourceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrderInput>;
};

export enum ChargeReattributionLogScalarFieldEnum {
    ConsumerId = 'consumerId',
    Date = 'date',
    DestinationBoughtTreatmentIds = 'destinationBoughtTreatmentIds',
    Id = 'id',
    MoveList = 'moveList',
    SourceBoughtTreatmentIds = 'sourceBoughtTreatmentIds',
    UserId = 'userId',
}

export type ChargeReattributionLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<ChargeReattributionLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<ChargeReattributionLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<ChargeReattributionLogScalarWhereWithAggregatesInput>
    >;
    consumerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    destinationBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    moveList?: InputMaybe<StringNullableListFilter>;
    sourceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    userId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ChargeReattributionLogSumAggregate = {
    __typename?: 'ChargeReattributionLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type ChargeReattributionLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ChargeReattributionLogUpdateInput = {
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationBoughtTreatmentIds?: InputMaybe<ChargeReattributionLogUpdatedestinationBoughtTreatmentIdsInput>;
    moveList?: InputMaybe<ChargeReattributionLogUpdatemoveListInput>;
    sourceBoughtTreatmentIds?: InputMaybe<ChargeReattributionLogUpdatesourceBoughtTreatmentIdsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeReattributionLogUpdateManyMutationInput = {
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationBoughtTreatmentIds?: InputMaybe<ChargeReattributionLogUpdatedestinationBoughtTreatmentIdsInput>;
    moveList?: InputMaybe<ChargeReattributionLogUpdatemoveListInput>;
    sourceBoughtTreatmentIds?: InputMaybe<ChargeReattributionLogUpdatesourceBoughtTreatmentIdsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeReattributionLogUpdatedestinationBoughtTreatmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChargeReattributionLogUpdatemoveListInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChargeReattributionLogUpdatesourceBoughtTreatmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChargeReattributionLogWhereInput = {
    AND?: InputMaybe<Array<ChargeReattributionLogWhereInput>>;
    NOT?: InputMaybe<Array<ChargeReattributionLogWhereInput>>;
    OR?: InputMaybe<Array<ChargeReattributionLogWhereInput>>;
    consumerId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    destinationBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntFilter>;
    moveList?: InputMaybe<StringNullableListFilter>;
    sourceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    userId?: InputMaybe<StringNullableFilter>;
};

export type ChargeReattributionLogWhereUniqueInput = {
    AND?: InputMaybe<Array<ChargeReattributionLogWhereInput>>;
    NOT?: InputMaybe<Array<ChargeReattributionLogWhereInput>>;
    OR?: InputMaybe<Array<ChargeReattributionLogWhereInput>>;
    consumerId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    destinationBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    moveList?: InputMaybe<StringNullableListFilter>;
    sourceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    userId?: InputMaybe<StringNullableFilter>;
};

export enum ChargeScalarFieldEnum {
    BoughtTreatmentId = 'boughtTreatmentId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    Date = 'date',
    Id = 'id',
    OrgId = 'orgId',
    PayoutIds = 'payoutIds',
    ReattributionState = 'reattributionState',
    SlotId = 'slotId',
    SuperscriptFeeId = 'superscriptFeeId',
    Total = 'total',
    TransactionId = 'transactionId',
    Type = 'type',
    UpdatedAt = 'updatedAt',
    UserId = 'userId',
}

export type ChargeScalarWhereInput = {
    AND?: InputMaybe<Array<ChargeScalarWhereInput>>;
    NOT?: InputMaybe<Array<ChargeScalarWhereInput>>;
    OR?: InputMaybe<Array<ChargeScalarWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    superscriptFeeId?: InputMaybe<StringNullableFilter>;
    total?: InputMaybe<DecimalFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    type?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
    userId?: InputMaybe<StringNullableFilter>;
};

export type ChargeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ChargeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ChargeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ChargeScalarWhereWithAggregatesInput>>;
    boughtTreatmentId?: InputMaybe<StringWithAggregatesFilter>;
    consumerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableWithAggregatesFilter>;
    slotId?: InputMaybe<StringNullableWithAggregatesFilter>;
    superscriptFeeId?: InputMaybe<StringNullableWithAggregatesFilter>;
    total?: InputMaybe<DecimalWithAggregatesFilter>;
    transactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    type?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    userId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ChargeSumAggregate = {
    __typename?: 'ChargeSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    total?: Maybe<Scalars['Decimal']['output']>;
};

export type ChargeSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    total?: InputMaybe<SortOrder>;
};

export type ChargeUpdateInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<ChargeUpdatepayoutIdsInput>;
    payouts?: InputMaybe<PayoutUpdateManyWithoutChargesNestedInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFee?: InputMaybe<SuperscriptFeesUpdateOneWithoutChargesNestedInput>;
    total?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    transaction?: InputMaybe<TransactionUpdateOneWithoutChargesNestedInput>;
    type?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeUpdateManyMutationInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<ChargeUpdatepayoutIdsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    total?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    type?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeUpdateManyWithWhereWithoutPayoutsInput = {
    data: ChargeUpdateManyMutationInput;
    where: ChargeScalarWhereInput;
};

export type ChargeUpdateManyWithWhereWithoutSuperscriptFeeInput = {
    data: ChargeUpdateManyMutationInput;
    where: ChargeScalarWhereInput;
};

export type ChargeUpdateManyWithWhereWithoutTransactionInput = {
    data: ChargeUpdateManyMutationInput;
    where: ChargeScalarWhereInput;
};

export type ChargeUpdateManyWithoutPayoutsNestedInput = {
    connect?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ChargeCreateOrConnectWithoutPayoutsInput>
    >;
    create?: InputMaybe<Array<ChargeCreateWithoutPayoutsInput>>;
    delete?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ChargeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    set?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    update?: InputMaybe<Array<ChargeUpdateWithWhereUniqueWithoutPayoutsInput>>;
    updateMany?: InputMaybe<
        Array<ChargeUpdateManyWithWhereWithoutPayoutsInput>
    >;
    upsert?: InputMaybe<Array<ChargeUpsertWithWhereUniqueWithoutPayoutsInput>>;
};

export type ChargeUpdateManyWithoutSuperscriptFeeNestedInput = {
    connect?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ChargeCreateOrConnectWithoutSuperscriptFeeInput>
    >;
    create?: InputMaybe<Array<ChargeCreateWithoutSuperscriptFeeInput>>;
    createMany?: InputMaybe<ChargeCreateManySuperscriptFeeInputEnvelope>;
    delete?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ChargeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    set?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ChargeUpdateWithWhereUniqueWithoutSuperscriptFeeInput>
    >;
    updateMany?: InputMaybe<
        Array<ChargeUpdateManyWithWhereWithoutSuperscriptFeeInput>
    >;
    upsert?: InputMaybe<
        Array<ChargeUpsertWithWhereUniqueWithoutSuperscriptFeeInput>
    >;
};

export type ChargeUpdateManyWithoutTransactionNestedInput = {
    connect?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ChargeCreateOrConnectWithoutTransactionInput>
    >;
    create?: InputMaybe<Array<ChargeCreateWithoutTransactionInput>>;
    createMany?: InputMaybe<ChargeCreateManyTransactionInputEnvelope>;
    delete?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ChargeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    set?: InputMaybe<Array<ChargeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ChargeUpdateWithWhereUniqueWithoutTransactionInput>
    >;
    updateMany?: InputMaybe<
        Array<ChargeUpdateManyWithWhereWithoutTransactionInput>
    >;
    upsert?: InputMaybe<
        Array<ChargeUpsertWithWhereUniqueWithoutTransactionInput>
    >;
};

export type ChargeUpdateWithWhereUniqueWithoutPayoutsInput = {
    data: ChargeUpdateWithoutPayoutsInput;
    where: ChargeWhereUniqueInput;
};

export type ChargeUpdateWithWhereUniqueWithoutSuperscriptFeeInput = {
    data: ChargeUpdateWithoutSuperscriptFeeInput;
    where: ChargeWhereUniqueInput;
};

export type ChargeUpdateWithWhereUniqueWithoutTransactionInput = {
    data: ChargeUpdateWithoutTransactionInput;
    where: ChargeWhereUniqueInput;
};

export type ChargeUpdateWithoutPayoutsInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<ChargeUpdatepayoutIdsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFee?: InputMaybe<SuperscriptFeesUpdateOneWithoutChargesNestedInput>;
    total?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    transaction?: InputMaybe<TransactionUpdateOneWithoutChargesNestedInput>;
    type?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeUpdateWithoutSuperscriptFeeInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<ChargeUpdatepayoutIdsInput>;
    payouts?: InputMaybe<PayoutUpdateManyWithoutChargesNestedInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    total?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    transaction?: InputMaybe<TransactionUpdateOneWithoutChargesNestedInput>;
    type?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeUpdateWithoutTransactionInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<ChargeUpdatepayoutIdsInput>;
    payouts?: InputMaybe<PayoutUpdateManyWithoutChargesNestedInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFee?: InputMaybe<SuperscriptFeesUpdateOneWithoutChargesNestedInput>;
    total?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    type?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChargeUpdatepayoutIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChargeUpsertWithWhereUniqueWithoutPayoutsInput = {
    create: ChargeCreateWithoutPayoutsInput;
    update: ChargeUpdateWithoutPayoutsInput;
    where: ChargeWhereUniqueInput;
};

export type ChargeUpsertWithWhereUniqueWithoutSuperscriptFeeInput = {
    create: ChargeCreateWithoutSuperscriptFeeInput;
    update: ChargeUpdateWithoutSuperscriptFeeInput;
    where: ChargeWhereUniqueInput;
};

export type ChargeUpsertWithWhereUniqueWithoutTransactionInput = {
    create: ChargeCreateWithoutTransactionInput;
    update: ChargeUpdateWithoutTransactionInput;
    where: ChargeWhereUniqueInput;
};

export type ChargeWhereInput = {
    AND?: InputMaybe<Array<ChargeWhereInput>>;
    NOT?: InputMaybe<Array<ChargeWhereInput>>;
    OR?: InputMaybe<Array<ChargeWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    payouts?: InputMaybe<PayoutListRelationFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    superscriptFee?: InputMaybe<SuperscriptFeesNullableRelationFilter>;
    superscriptFeeId?: InputMaybe<StringNullableFilter>;
    total?: InputMaybe<DecimalFilter>;
    transaction?: InputMaybe<TransactionNullableRelationFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    type?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
    userId?: InputMaybe<StringNullableFilter>;
};

export type ChargeWhereUniqueInput = {
    AND?: InputMaybe<Array<ChargeWhereInput>>;
    NOT?: InputMaybe<Array<ChargeWhereInput>>;
    OR?: InputMaybe<Array<ChargeWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    payouts?: InputMaybe<PayoutListRelationFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    superscriptFee?: InputMaybe<SuperscriptFeesNullableRelationFilter>;
    superscriptFeeId?: InputMaybe<StringNullableFilter>;
    total?: InputMaybe<DecimalFilter>;
    transaction?: InputMaybe<TransactionNullableRelationFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    type?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
    userId?: InputMaybe<StringNullableFilter>;
};

export type CheckNetworkStatusResults = {
    __typename?: 'CheckNetworkStatusResults';
    coverage_id?: Maybe<Scalars['String']['output']>;
    coverage_source?: Maybe<CoverageSource>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    from_cache: Scalars['Boolean']['output'];
    id: Scalars['Int']['output'];
    is_superscript_email?: Maybe<Scalars['Boolean']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    parent_request_id?: Maybe<Scalars['String']['output']>;
    payer?: Maybe<Scalars['String']['output']>;
    request_id: Scalars['String']['output'];
    request_source?: Maybe<RequestSource>;
    request_type?: Maybe<RequestType>;
    results: AirStatusCode;
    session_id?: Maybe<Scalars['String']['output']>;
};

export type CheckNetworkStatusResultsAvgAggregate = {
    __typename?: 'CheckNetworkStatusResultsAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    latency?: Maybe<Scalars['Float']['output']>;
    org_id?: Maybe<Scalars['Float']['output']>;
};

export type CheckNetworkStatusResultsAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
};

export type CheckNetworkStatusResultsCountAggregate = {
    __typename?: 'CheckNetworkStatusResultsCountAggregate';
    _all: Scalars['Int']['output'];
    coverage_id: Scalars['Int']['output'];
    coverage_source: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    from_cache: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    is_superscript_email: Scalars['Int']['output'];
    latency: Scalars['Int']['output'];
    org_id: Scalars['Int']['output'];
    parent_request_id: Scalars['Int']['output'];
    payer: Scalars['Int']['output'];
    request_id: Scalars['Int']['output'];
    request_source: Scalars['Int']['output'];
    request_type: Scalars['Int']['output'];
    results: Scalars['Int']['output'];
    session_id: Scalars['Int']['output'];
};

export type CheckNetworkStatusResultsCountOrderByAggregateInput = {
    coverage_id?: InputMaybe<SortOrder>;
    coverage_source?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    from_cache?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    is_superscript_email?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    parent_request_id?: InputMaybe<SortOrder>;
    payer?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    request_source?: InputMaybe<SortOrder>;
    request_type?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrder>;
};

export type CheckNetworkStatusResultsCreateInput = {
    coverage_id?: InputMaybe<Scalars['String']['input']>;
    coverage_source?: InputMaybe<CoverageSource>;
    date?: InputMaybe<Scalars['DateTimeISO']['input']>;
    from_cache?: InputMaybe<Scalars['Boolean']['input']>;
    is_superscript_email?: InputMaybe<Scalars['Boolean']['input']>;
    latency?: InputMaybe<Scalars['Int']['input']>;
    org_id?: InputMaybe<Scalars['Int']['input']>;
    parent_request_id?: InputMaybe<Scalars['String']['input']>;
    payer?: InputMaybe<Scalars['String']['input']>;
    request_id: Scalars['String']['input'];
    request_source?: InputMaybe<RequestSource>;
    request_type?: InputMaybe<RequestType>;
    results?: InputMaybe<AirStatusCode>;
    session_id?: InputMaybe<Scalars['String']['input']>;
};

export type CheckNetworkStatusResultsCreateManyInput = {
    coverage_id?: InputMaybe<Scalars['String']['input']>;
    coverage_source?: InputMaybe<CoverageSource>;
    date?: InputMaybe<Scalars['DateTimeISO']['input']>;
    from_cache?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    is_superscript_email?: InputMaybe<Scalars['Boolean']['input']>;
    latency?: InputMaybe<Scalars['Int']['input']>;
    org_id?: InputMaybe<Scalars['Int']['input']>;
    parent_request_id?: InputMaybe<Scalars['String']['input']>;
    payer?: InputMaybe<Scalars['String']['input']>;
    request_id: Scalars['String']['input'];
    request_source?: InputMaybe<RequestSource>;
    request_type?: InputMaybe<RequestType>;
    results?: InputMaybe<AirStatusCode>;
    session_id?: InputMaybe<Scalars['String']['input']>;
};

export type CheckNetworkStatusResultsGroupBy = {
    __typename?: 'CheckNetworkStatusResultsGroupBy';
    _avg?: Maybe<CheckNetworkStatusResultsAvgAggregate>;
    _count?: Maybe<CheckNetworkStatusResultsCountAggregate>;
    _max?: Maybe<CheckNetworkStatusResultsMaxAggregate>;
    _min?: Maybe<CheckNetworkStatusResultsMinAggregate>;
    _sum?: Maybe<CheckNetworkStatusResultsSumAggregate>;
    coverage_id?: Maybe<Scalars['String']['output']>;
    coverage_source?: Maybe<CoverageSource>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    from_cache: Scalars['Boolean']['output'];
    id: Scalars['Int']['output'];
    is_superscript_email?: Maybe<Scalars['Boolean']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    parent_request_id?: Maybe<Scalars['String']['output']>;
    payer?: Maybe<Scalars['String']['output']>;
    request_id: Scalars['String']['output'];
    request_source?: Maybe<RequestSource>;
    request_type?: Maybe<RequestType>;
    results: AirStatusCode;
    session_id?: Maybe<Scalars['String']['output']>;
};

export type CheckNetworkStatusResultsMaxAggregate = {
    __typename?: 'CheckNetworkStatusResultsMaxAggregate';
    coverage_id?: Maybe<Scalars['String']['output']>;
    coverage_source?: Maybe<CoverageSource>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    from_cache?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    is_superscript_email?: Maybe<Scalars['Boolean']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    parent_request_id?: Maybe<Scalars['String']['output']>;
    payer?: Maybe<Scalars['String']['output']>;
    request_id?: Maybe<Scalars['String']['output']>;
    request_source?: Maybe<RequestSource>;
    request_type?: Maybe<RequestType>;
    results?: Maybe<AirStatusCode>;
    session_id?: Maybe<Scalars['String']['output']>;
};

export type CheckNetworkStatusResultsMaxOrderByAggregateInput = {
    coverage_id?: InputMaybe<SortOrder>;
    coverage_source?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    from_cache?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    is_superscript_email?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    parent_request_id?: InputMaybe<SortOrder>;
    payer?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    request_source?: InputMaybe<SortOrder>;
    request_type?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrder>;
};

export type CheckNetworkStatusResultsMinAggregate = {
    __typename?: 'CheckNetworkStatusResultsMinAggregate';
    coverage_id?: Maybe<Scalars['String']['output']>;
    coverage_source?: Maybe<CoverageSource>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    from_cache?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    is_superscript_email?: Maybe<Scalars['Boolean']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    parent_request_id?: Maybe<Scalars['String']['output']>;
    payer?: Maybe<Scalars['String']['output']>;
    request_id?: Maybe<Scalars['String']['output']>;
    request_source?: Maybe<RequestSource>;
    request_type?: Maybe<RequestType>;
    results?: Maybe<AirStatusCode>;
    session_id?: Maybe<Scalars['String']['output']>;
};

export type CheckNetworkStatusResultsMinOrderByAggregateInput = {
    coverage_id?: InputMaybe<SortOrder>;
    coverage_source?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    from_cache?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    is_superscript_email?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    parent_request_id?: InputMaybe<SortOrder>;
    payer?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    request_source?: InputMaybe<SortOrder>;
    request_type?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrder>;
};

export type CheckNetworkStatusResultsOrderByWithAggregationInput = {
    _avg?: InputMaybe<CheckNetworkStatusResultsAvgOrderByAggregateInput>;
    _count?: InputMaybe<CheckNetworkStatusResultsCountOrderByAggregateInput>;
    _max?: InputMaybe<CheckNetworkStatusResultsMaxOrderByAggregateInput>;
    _min?: InputMaybe<CheckNetworkStatusResultsMinOrderByAggregateInput>;
    _sum?: InputMaybe<CheckNetworkStatusResultsSumOrderByAggregateInput>;
    coverage_id?: InputMaybe<SortOrderInput>;
    coverage_source?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrderInput>;
    from_cache?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    is_superscript_email?: InputMaybe<SortOrderInput>;
    latency?: InputMaybe<SortOrderInput>;
    org_id?: InputMaybe<SortOrderInput>;
    parent_request_id?: InputMaybe<SortOrderInput>;
    payer?: InputMaybe<SortOrderInput>;
    request_id?: InputMaybe<SortOrder>;
    request_source?: InputMaybe<SortOrderInput>;
    request_type?: InputMaybe<SortOrderInput>;
    results?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrderInput>;
};

export type CheckNetworkStatusResultsOrderByWithRelationInput = {
    coverage_id?: InputMaybe<SortOrderInput>;
    coverage_source?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrderInput>;
    from_cache?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    is_superscript_email?: InputMaybe<SortOrderInput>;
    latency?: InputMaybe<SortOrderInput>;
    org_id?: InputMaybe<SortOrderInput>;
    parent_request_id?: InputMaybe<SortOrderInput>;
    payer?: InputMaybe<SortOrderInput>;
    request_id?: InputMaybe<SortOrder>;
    request_source?: InputMaybe<SortOrderInput>;
    request_type?: InputMaybe<SortOrderInput>;
    results?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrderInput>;
};

export enum CheckNetworkStatusResultsScalarFieldEnum {
    CoverageId = 'coverage_id',
    CoverageSource = 'coverage_source',
    Date = 'date',
    FromCache = 'from_cache',
    Id = 'id',
    IsSuperscriptEmail = 'is_superscript_email',
    Latency = 'latency',
    OrgId = 'org_id',
    ParentRequestId = 'parent_request_id',
    Payer = 'payer',
    RequestId = 'request_id',
    RequestSource = 'request_source',
    RequestType = 'request_type',
    Results = 'results',
    SessionId = 'session_id',
}

export type CheckNetworkStatusResultsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<CheckNetworkStatusResultsScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<CheckNetworkStatusResultsScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<CheckNetworkStatusResultsScalarWhereWithAggregatesInput>
    >;
    coverage_id?: InputMaybe<StringNullableWithAggregatesFilter>;
    coverage_source?: InputMaybe<EnumCoverageSourceNullableWithAggregatesFilter>;
    date?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    from_cache?: InputMaybe<BoolWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    is_superscript_email?: InputMaybe<BoolNullableWithAggregatesFilter>;
    latency?: InputMaybe<IntNullableWithAggregatesFilter>;
    org_id?: InputMaybe<IntNullableWithAggregatesFilter>;
    parent_request_id?: InputMaybe<StringNullableWithAggregatesFilter>;
    payer?: InputMaybe<StringNullableWithAggregatesFilter>;
    request_id?: InputMaybe<StringWithAggregatesFilter>;
    request_source?: InputMaybe<EnumRequestSourceNullableWithAggregatesFilter>;
    request_type?: InputMaybe<EnumRequestTypeNullableWithAggregatesFilter>;
    results?: InputMaybe<EnumAirStatusCodeWithAggregatesFilter>;
    session_id?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type CheckNetworkStatusResultsSumAggregate = {
    __typename?: 'CheckNetworkStatusResultsSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
};

export type CheckNetworkStatusResultsSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
};

export type CheckNetworkStatusResultsUpdateInput = {
    coverage_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    coverage_source?: InputMaybe<NullableEnumCoverageSourceFieldUpdateOperationsInput>;
    date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    from_cache?: InputMaybe<BoolFieldUpdateOperationsInput>;
    is_superscript_email?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    latency?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    org_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    parent_request_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    request_source?: InputMaybe<NullableEnumRequestSourceFieldUpdateOperationsInput>;
    request_type?: InputMaybe<NullableEnumRequestTypeFieldUpdateOperationsInput>;
    results?: InputMaybe<EnumAirStatusCodeFieldUpdateOperationsInput>;
    session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CheckNetworkStatusResultsUpdateManyMutationInput = {
    coverage_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    coverage_source?: InputMaybe<NullableEnumCoverageSourceFieldUpdateOperationsInput>;
    date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    from_cache?: InputMaybe<BoolFieldUpdateOperationsInput>;
    is_superscript_email?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    latency?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    org_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    parent_request_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    request_source?: InputMaybe<NullableEnumRequestSourceFieldUpdateOperationsInput>;
    request_type?: InputMaybe<NullableEnumRequestTypeFieldUpdateOperationsInput>;
    results?: InputMaybe<EnumAirStatusCodeFieldUpdateOperationsInput>;
    session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CheckNetworkStatusResultsWhereInput = {
    AND?: InputMaybe<Array<CheckNetworkStatusResultsWhereInput>>;
    NOT?: InputMaybe<Array<CheckNetworkStatusResultsWhereInput>>;
    OR?: InputMaybe<Array<CheckNetworkStatusResultsWhereInput>>;
    coverage_id?: InputMaybe<StringNullableFilter>;
    coverage_source?: InputMaybe<EnumCoverageSourceNullableFilter>;
    date?: InputMaybe<DateTimeNullableFilter>;
    from_cache?: InputMaybe<BoolFilter>;
    id?: InputMaybe<IntFilter>;
    is_superscript_email?: InputMaybe<BoolNullableFilter>;
    latency?: InputMaybe<IntNullableFilter>;
    org_id?: InputMaybe<IntNullableFilter>;
    parent_request_id?: InputMaybe<StringNullableFilter>;
    payer?: InputMaybe<StringNullableFilter>;
    request_id?: InputMaybe<StringFilter>;
    request_source?: InputMaybe<EnumRequestSourceNullableFilter>;
    request_type?: InputMaybe<EnumRequestTypeNullableFilter>;
    results?: InputMaybe<EnumAirStatusCodeFilter>;
    session_id?: InputMaybe<StringNullableFilter>;
};

export type CheckNetworkStatusResultsWhereUniqueInput = {
    AND?: InputMaybe<Array<CheckNetworkStatusResultsWhereInput>>;
    NOT?: InputMaybe<Array<CheckNetworkStatusResultsWhereInput>>;
    OR?: InputMaybe<Array<CheckNetworkStatusResultsWhereInput>>;
    coverage_id?: InputMaybe<StringNullableFilter>;
    coverage_source?: InputMaybe<EnumCoverageSourceNullableFilter>;
    date?: InputMaybe<DateTimeNullableFilter>;
    from_cache?: InputMaybe<BoolFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    is_superscript_email?: InputMaybe<BoolNullableFilter>;
    latency?: InputMaybe<IntNullableFilter>;
    org_id?: InputMaybe<IntNullableFilter>;
    parent_request_id?: InputMaybe<StringNullableFilter>;
    payer?: InputMaybe<StringNullableFilter>;
    request_id?: InputMaybe<StringFilter>;
    request_source?: InputMaybe<EnumRequestSourceNullableFilter>;
    request_type?: InputMaybe<EnumRequestTypeNullableFilter>;
    results?: InputMaybe<EnumAirStatusCodeFilter>;
    session_id?: InputMaybe<StringNullableFilter>;
};

export type CheckoutAdjudication = {
    __typename?: 'CheckoutAdjudication';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    boughtTreatmentIds: Array<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    encounterId?: Maybe<Scalars['String']['output']>;
    fees?: Maybe<Scalars['Decimal']['output']>;
    id: Scalars['Int']['output'];
    logId?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    srtIds: Array<Scalars['Int']['output']>;
    type: AdjudicationType;
    visitId?: Maybe<Scalars['String']['output']>;
};

export type CheckoutAdjudicationAvgAggregate = {
    __typename?: 'CheckoutAdjudicationAvgAggregate';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    fees?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    srtIds?: Maybe<Scalars['Float']['output']>;
};

export type CheckoutAdjudicationAvgOrderByAggregateInput = {
    allowedAmount?: InputMaybe<SortOrder>;
    fees?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtIds?: InputMaybe<SortOrder>;
};

export type CheckoutAdjudicationCountAggregate = {
    __typename?: 'CheckoutAdjudicationCountAggregate';
    _all: Scalars['Int']['output'];
    allowedAmount: Scalars['Int']['output'];
    boughtTreatmentIds: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    encounterId: Scalars['Int']['output'];
    fees: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    logId: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    srtIds: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
    visitId: Scalars['Int']['output'];
};

export type CheckoutAdjudicationCountOrderByAggregateInput = {
    allowedAmount?: InputMaybe<SortOrder>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    fees?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    logId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    srtIds?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrder>;
};

export type CheckoutAdjudicationCreateInput = {
    allowedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    boughtTreatmentIds?: InputMaybe<CheckoutAdjudicationCreateboughtTreatmentIdsInput>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    encounterId?: InputMaybe<Scalars['String']['input']>;
    fees?: InputMaybe<Scalars['Decimal']['input']>;
    logId?: InputMaybe<Scalars['String']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    srtIds?: InputMaybe<CheckoutAdjudicationCreatesrtIdsInput>;
    type?: InputMaybe<AdjudicationType>;
    visitId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutAdjudicationCreateManyInput = {
    allowedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    boughtTreatmentIds?: InputMaybe<CheckoutAdjudicationCreateboughtTreatmentIdsInput>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    encounterId?: InputMaybe<Scalars['String']['input']>;
    fees?: InputMaybe<Scalars['Decimal']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    logId?: InputMaybe<Scalars['String']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    srtIds?: InputMaybe<CheckoutAdjudicationCreatesrtIdsInput>;
    type?: InputMaybe<AdjudicationType>;
    visitId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutAdjudicationCreateboughtTreatmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type CheckoutAdjudicationCreatesrtIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type CheckoutAdjudicationGroupBy = {
    __typename?: 'CheckoutAdjudicationGroupBy';
    _avg?: Maybe<CheckoutAdjudicationAvgAggregate>;
    _count?: Maybe<CheckoutAdjudicationCountAggregate>;
    _max?: Maybe<CheckoutAdjudicationMaxAggregate>;
    _min?: Maybe<CheckoutAdjudicationMinAggregate>;
    _sum?: Maybe<CheckoutAdjudicationSumAggregate>;
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    boughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    claimId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    encounterId?: Maybe<Scalars['String']['output']>;
    fees?: Maybe<Scalars['Decimal']['output']>;
    id: Scalars['Int']['output'];
    logId?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    srtIds?: Maybe<Array<Scalars['Int']['output']>>;
    type: AdjudicationType;
    visitId?: Maybe<Scalars['String']['output']>;
};

export type CheckoutAdjudicationMaxAggregate = {
    __typename?: 'CheckoutAdjudicationMaxAggregate';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    fees?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    logId?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<AdjudicationType>;
    visitId?: Maybe<Scalars['String']['output']>;
};

export type CheckoutAdjudicationMaxOrderByAggregateInput = {
    allowedAmount?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    fees?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    logId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrder>;
};

export type CheckoutAdjudicationMinAggregate = {
    __typename?: 'CheckoutAdjudicationMinAggregate';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    fees?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    logId?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<AdjudicationType>;
    visitId?: Maybe<Scalars['String']['output']>;
};

export type CheckoutAdjudicationMinOrderByAggregateInput = {
    allowedAmount?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    fees?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    logId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrder>;
};

export type CheckoutAdjudicationOrderByWithAggregationInput = {
    _avg?: InputMaybe<CheckoutAdjudicationAvgOrderByAggregateInput>;
    _count?: InputMaybe<CheckoutAdjudicationCountOrderByAggregateInput>;
    _max?: InputMaybe<CheckoutAdjudicationMaxOrderByAggregateInput>;
    _min?: InputMaybe<CheckoutAdjudicationMinOrderByAggregateInput>;
    _sum?: InputMaybe<CheckoutAdjudicationSumOrderByAggregateInput>;
    allowedAmount?: InputMaybe<SortOrderInput>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrderInput>;
    fees?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    logId?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    srtIds?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrderInput>;
};

export type CheckoutAdjudicationOrderByWithRelationInput = {
    allowedAmount?: InputMaybe<SortOrderInput>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrderInput>;
    fees?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    logId?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    srtIds?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrderInput>;
};

export enum CheckoutAdjudicationScalarFieldEnum {
    AllowedAmount = 'allowedAmount',
    BoughtTreatmentIds = 'boughtTreatmentIds',
    ClaimId = 'claimId',
    Date = 'date',
    EncounterId = 'encounterId',
    Fees = 'fees',
    Id = 'id',
    LogId = 'logId',
    SlotId = 'slotId',
    SrtIds = 'srtIds',
    Type = 'type',
    VisitId = 'visitId',
}

export type CheckoutAdjudicationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<CheckoutAdjudicationScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<CheckoutAdjudicationScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<CheckoutAdjudicationScalarWhereWithAggregatesInput>>;
    allowedAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    encounterId?: InputMaybe<StringNullableWithAggregatesFilter>;
    fees?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    logId?: InputMaybe<StringNullableWithAggregatesFilter>;
    slotId?: InputMaybe<StringNullableWithAggregatesFilter>;
    srtIds?: InputMaybe<IntNullableListFilter>;
    type?: InputMaybe<EnumAdjudicationTypeWithAggregatesFilter>;
    visitId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type CheckoutAdjudicationSumAggregate = {
    __typename?: 'CheckoutAdjudicationSumAggregate';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    fees?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    srtIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type CheckoutAdjudicationSumOrderByAggregateInput = {
    allowedAmount?: InputMaybe<SortOrder>;
    fees?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtIds?: InputMaybe<SortOrder>;
};

export type CheckoutAdjudicationUpdateInput = {
    allowedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<CheckoutAdjudicationUpdateboughtTreatmentIdsInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    fees?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    logId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    srtIds?: InputMaybe<CheckoutAdjudicationUpdatesrtIdsInput>;
    type?: InputMaybe<EnumAdjudicationTypeFieldUpdateOperationsInput>;
    visitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CheckoutAdjudicationUpdateManyMutationInput = {
    allowedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<CheckoutAdjudicationUpdateboughtTreatmentIdsInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    fees?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    logId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    srtIds?: InputMaybe<CheckoutAdjudicationUpdatesrtIdsInput>;
    type?: InputMaybe<EnumAdjudicationTypeFieldUpdateOperationsInput>;
    visitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CheckoutAdjudicationUpdateboughtTreatmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CheckoutAdjudicationUpdatesrtIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CheckoutAdjudicationWhereInput = {
    AND?: InputMaybe<Array<CheckoutAdjudicationWhereInput>>;
    NOT?: InputMaybe<Array<CheckoutAdjudicationWhereInput>>;
    OR?: InputMaybe<Array<CheckoutAdjudicationWhereInput>>;
    allowedAmount?: InputMaybe<DecimalNullableFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    fees?: InputMaybe<DecimalNullableFilter>;
    id?: InputMaybe<IntFilter>;
    logId?: InputMaybe<StringNullableFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    srtIds?: InputMaybe<IntNullableListFilter>;
    type?: InputMaybe<EnumAdjudicationTypeFilter>;
    visitId?: InputMaybe<StringNullableFilter>;
};

export type CheckoutAdjudicationWhereUniqueInput = {
    AND?: InputMaybe<Array<CheckoutAdjudicationWhereInput>>;
    NOT?: InputMaybe<Array<CheckoutAdjudicationWhereInput>>;
    OR?: InputMaybe<Array<CheckoutAdjudicationWhereInput>>;
    allowedAmount?: InputMaybe<DecimalNullableFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    fees?: InputMaybe<DecimalNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    logId?: InputMaybe<StringNullableFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    srtIds?: InputMaybe<IntNullableListFilter>;
    type?: InputMaybe<EnumAdjudicationTypeFilter>;
    visitId?: InputMaybe<StringNullableFilter>;
};

export enum ClaimReturnStatusEnum {
    Awaiting = 'AWAITING',
    Issue = 'ISSUE',
    Returned = 'RETURNED',
    Submitted = 'SUBMITTED',
    Voided = 'VOIDED',
}

export type ClaimToBoughtTreatment = {
    __typename?: 'ClaimToBoughtTreatment';
    boughtTreatmentId: Scalars['String']['output'];
    claimId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    orgId: Scalars['Int']['output'];
    procedureCode: Scalars['String']['output'];
};

export type ClaimToBoughtTreatmentAvgAggregate = {
    __typename?: 'ClaimToBoughtTreatmentAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type ClaimToBoughtTreatmentAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type ClaimToBoughtTreatmentClaimIdOrgIdProcedureCodeCompoundUniqueInput =
    {
        claimId: Scalars['String']['input'];
        orgId: Scalars['Int']['input'];
        procedureCode: Scalars['String']['input'];
    };

export type ClaimToBoughtTreatmentCountAggregate = {
    __typename?: 'ClaimToBoughtTreatmentCountAggregate';
    _all: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    procedureCode: Scalars['Int']['output'];
};

export type ClaimToBoughtTreatmentCountOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
};

export type ClaimToBoughtTreatmentCreateInput = {
    boughtTreatmentId: Scalars['String']['input'];
    claimId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    procedureCode: Scalars['String']['input'];
};

export type ClaimToBoughtTreatmentCreateManyInput = {
    boughtTreatmentId: Scalars['String']['input'];
    claimId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    procedureCode: Scalars['String']['input'];
};

export type ClaimToBoughtTreatmentGroupBy = {
    __typename?: 'ClaimToBoughtTreatmentGroupBy';
    _avg?: Maybe<ClaimToBoughtTreatmentAvgAggregate>;
    _count?: Maybe<ClaimToBoughtTreatmentCountAggregate>;
    _max?: Maybe<ClaimToBoughtTreatmentMaxAggregate>;
    _min?: Maybe<ClaimToBoughtTreatmentMinAggregate>;
    _sum?: Maybe<ClaimToBoughtTreatmentSumAggregate>;
    boughtTreatmentId: Scalars['String']['output'];
    claimId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    orgId: Scalars['Int']['output'];
    procedureCode: Scalars['String']['output'];
};

export type ClaimToBoughtTreatmentMaxAggregate = {
    __typename?: 'ClaimToBoughtTreatmentMaxAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
};

export type ClaimToBoughtTreatmentMaxOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
};

export type ClaimToBoughtTreatmentMinAggregate = {
    __typename?: 'ClaimToBoughtTreatmentMinAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
};

export type ClaimToBoughtTreatmentMinOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
};

export type ClaimToBoughtTreatmentOrderByWithAggregationInput = {
    _avg?: InputMaybe<ClaimToBoughtTreatmentAvgOrderByAggregateInput>;
    _count?: InputMaybe<ClaimToBoughtTreatmentCountOrderByAggregateInput>;
    _max?: InputMaybe<ClaimToBoughtTreatmentMaxOrderByAggregateInput>;
    _min?: InputMaybe<ClaimToBoughtTreatmentMinOrderByAggregateInput>;
    _sum?: InputMaybe<ClaimToBoughtTreatmentSumOrderByAggregateInput>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
};

export type ClaimToBoughtTreatmentOrderByWithRelationInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
};

export enum ClaimToBoughtTreatmentScalarFieldEnum {
    BoughtTreatmentId = 'boughtTreatmentId',
    ClaimId = 'claimId',
    CreatedAt = 'createdAt',
    OrgId = 'orgId',
    ProcedureCode = 'procedureCode',
}

export type ClaimToBoughtTreatmentScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<ClaimToBoughtTreatmentScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<ClaimToBoughtTreatmentScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<ClaimToBoughtTreatmentScalarWhereWithAggregatesInput>
    >;
    boughtTreatmentId?: InputMaybe<StringWithAggregatesFilter>;
    claimId?: InputMaybe<StringWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    procedureCode?: InputMaybe<StringWithAggregatesFilter>;
};

export type ClaimToBoughtTreatmentSumAggregate = {
    __typename?: 'ClaimToBoughtTreatmentSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type ClaimToBoughtTreatmentSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type ClaimToBoughtTreatmentUpdateInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    procedureCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ClaimToBoughtTreatmentUpdateManyMutationInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    procedureCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ClaimToBoughtTreatmentWhereInput = {
    AND?: InputMaybe<Array<ClaimToBoughtTreatmentWhereInput>>;
    NOT?: InputMaybe<Array<ClaimToBoughtTreatmentWhereInput>>;
    OR?: InputMaybe<Array<ClaimToBoughtTreatmentWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringFilter>;
    claimId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    orgId?: InputMaybe<IntFilter>;
    procedureCode?: InputMaybe<StringFilter>;
};

export type ClaimToBoughtTreatmentWhereUniqueInput = {
    AND?: InputMaybe<Array<ClaimToBoughtTreatmentWhereInput>>;
    NOT?: InputMaybe<Array<ClaimToBoughtTreatmentWhereInput>>;
    OR?: InputMaybe<Array<ClaimToBoughtTreatmentWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringFilter>;
    claimId?: InputMaybe<StringFilter>;
    claimId_orgId_procedureCode?: InputMaybe<ClaimToBoughtTreatmentClaimIdOrgIdProcedureCodeCompoundUniqueInput>;
    createdAt?: InputMaybe<DateTimeFilter>;
    orgId?: InputMaybe<IntFilter>;
    procedureCode?: InputMaybe<StringFilter>;
};

export type ConfigCommit = {
    __typename?: 'ConfigCommit';
    author: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    description: Scalars['String']['output'];
    entityIds: Array<Scalars['Int']['output']>;
    entityType?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    mutation: Scalars['String']['output'];
    newValues?: Maybe<Scalars['JSON']['output']>;
    org?: Maybe<Organization>;
    orgId?: Maybe<Scalars['Int']['output']>;
    previousValues?: Maybe<Scalars['JSON']['output']>;
    propagationType?: Maybe<PropagationType>;
    service?: Maybe<Service>;
    session: ConfigSession;
    sessionId: Scalars['String']['output'];
    softDeleted: Scalars['Boolean']['output'];
    softDeletedBy?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ConfigCommitStatus>;
};

export type ConfigCommitOrgArgs = {
    where?: InputMaybe<OrganizationWhereInput>;
};

export type ConfigCommitAvgAggregate = {
    __typename?: 'ConfigCommitAvgAggregate';
    entityIds?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type ConfigCommitAvgOrderByAggregateInput = {
    entityIds?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type ConfigCommitCountAggregate = {
    __typename?: 'ConfigCommitCountAggregate';
    _all: Scalars['Int']['output'];
    author: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    entityIds: Scalars['Int']['output'];
    entityType: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    mutation: Scalars['Int']['output'];
    newValues: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    previousValues: Scalars['Int']['output'];
    propagationType: Scalars['Int']['output'];
    service: Scalars['Int']['output'];
    sessionId: Scalars['Int']['output'];
    softDeleted: Scalars['Int']['output'];
    softDeletedBy: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
};

export type ConfigCommitCountOrderByAggregateInput = {
    author?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    entityIds?: InputMaybe<SortOrder>;
    entityType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    mutation?: InputMaybe<SortOrder>;
    newValues?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    previousValues?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    service?: InputMaybe<SortOrder>;
    sessionId?: InputMaybe<SortOrder>;
    softDeleted?: InputMaybe<SortOrder>;
    softDeletedBy?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type ConfigCommitCreateInput = {
    author: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description: Scalars['String']['input'];
    entityIds?: InputMaybe<ConfigCommitCreateentityIdsInput>;
    entityType?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    mutation: Scalars['String']['input'];
    newValues?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationCreateNestedOneWithoutConfigCommitsInput>;
    previousValues?: InputMaybe<Scalars['JSON']['input']>;
    propagationType?: InputMaybe<PropagationType>;
    service?: InputMaybe<Service>;
    session: ConfigSessionCreateNestedOneWithoutCommitsInput;
    softDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    softDeletedBy?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ConfigCommitStatus>;
};

export type ConfigCommitCreateManyInput = {
    author: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description: Scalars['String']['input'];
    entityIds?: InputMaybe<ConfigCommitCreateentityIdsInput>;
    entityType?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    mutation: Scalars['String']['input'];
    newValues?: InputMaybe<Scalars['JSON']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    previousValues?: InputMaybe<Scalars['JSON']['input']>;
    propagationType?: InputMaybe<PropagationType>;
    service?: InputMaybe<Service>;
    sessionId: Scalars['String']['input'];
    softDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    softDeletedBy?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ConfigCommitStatus>;
};

export type ConfigCommitCreateManyOrgInput = {
    author: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description: Scalars['String']['input'];
    entityIds?: InputMaybe<ConfigCommitCreateentityIdsInput>;
    entityType?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    mutation: Scalars['String']['input'];
    newValues?: InputMaybe<Scalars['JSON']['input']>;
    previousValues?: InputMaybe<Scalars['JSON']['input']>;
    propagationType?: InputMaybe<PropagationType>;
    service?: InputMaybe<Service>;
    sessionId: Scalars['String']['input'];
    softDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    softDeletedBy?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ConfigCommitStatus>;
};

export type ConfigCommitCreateManyOrgInputEnvelope = {
    data: Array<ConfigCommitCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConfigCommitCreateManySessionInput = {
    author: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description: Scalars['String']['input'];
    entityIds?: InputMaybe<ConfigCommitCreateentityIdsInput>;
    entityType?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    mutation: Scalars['String']['input'];
    newValues?: InputMaybe<Scalars['JSON']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    previousValues?: InputMaybe<Scalars['JSON']['input']>;
    propagationType?: InputMaybe<PropagationType>;
    service?: InputMaybe<Service>;
    softDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    softDeletedBy?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ConfigCommitStatus>;
};

export type ConfigCommitCreateManySessionInputEnvelope = {
    data: Array<ConfigCommitCreateManySessionInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConfigCommitCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<ConfigCommitWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConfigCommitCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<ConfigCommitCreateWithoutOrgInput>>;
    createMany?: InputMaybe<ConfigCommitCreateManyOrgInputEnvelope>;
};

export type ConfigCommitCreateNestedManyWithoutSessionInput = {
    connect?: InputMaybe<Array<ConfigCommitWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConfigCommitCreateOrConnectWithoutSessionInput>
    >;
    create?: InputMaybe<Array<ConfigCommitCreateWithoutSessionInput>>;
    createMany?: InputMaybe<ConfigCommitCreateManySessionInputEnvelope>;
};

export type ConfigCommitCreateOrConnectWithoutOrgInput = {
    create: ConfigCommitCreateWithoutOrgInput;
    where: ConfigCommitWhereUniqueInput;
};

export type ConfigCommitCreateOrConnectWithoutSessionInput = {
    create: ConfigCommitCreateWithoutSessionInput;
    where: ConfigCommitWhereUniqueInput;
};

export type ConfigCommitCreateWithoutOrgInput = {
    author: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description: Scalars['String']['input'];
    entityIds?: InputMaybe<ConfigCommitCreateentityIdsInput>;
    entityType?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    mutation: Scalars['String']['input'];
    newValues?: InputMaybe<Scalars['JSON']['input']>;
    previousValues?: InputMaybe<Scalars['JSON']['input']>;
    propagationType?: InputMaybe<PropagationType>;
    service?: InputMaybe<Service>;
    session: ConfigSessionCreateNestedOneWithoutCommitsInput;
    softDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    softDeletedBy?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ConfigCommitStatus>;
};

export type ConfigCommitCreateWithoutSessionInput = {
    author: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description: Scalars['String']['input'];
    entityIds?: InputMaybe<ConfigCommitCreateentityIdsInput>;
    entityType?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    mutation: Scalars['String']['input'];
    newValues?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationCreateNestedOneWithoutConfigCommitsInput>;
    previousValues?: InputMaybe<Scalars['JSON']['input']>;
    propagationType?: InputMaybe<PropagationType>;
    service?: InputMaybe<Service>;
    softDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    softDeletedBy?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ConfigCommitStatus>;
};

export type ConfigCommitCreateentityIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type ConfigCommitGroupBy = {
    __typename?: 'ConfigCommitGroupBy';
    _avg?: Maybe<ConfigCommitAvgAggregate>;
    _count?: Maybe<ConfigCommitCountAggregate>;
    _max?: Maybe<ConfigCommitMaxAggregate>;
    _min?: Maybe<ConfigCommitMinAggregate>;
    _sum?: Maybe<ConfigCommitSumAggregate>;
    author: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    description: Scalars['String']['output'];
    entityIds?: Maybe<Array<Scalars['Int']['output']>>;
    entityType?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    mutation: Scalars['String']['output'];
    newValues?: Maybe<Scalars['JSON']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    previousValues?: Maybe<Scalars['JSON']['output']>;
    propagationType?: Maybe<PropagationType>;
    service?: Maybe<Service>;
    sessionId: Scalars['String']['output'];
    softDeleted: Scalars['Boolean']['output'];
    softDeletedBy?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ConfigCommitStatus>;
};

export type ConfigCommitListRelationFilter = {
    every?: InputMaybe<ConfigCommitWhereInput>;
    none?: InputMaybe<ConfigCommitWhereInput>;
    some?: InputMaybe<ConfigCommitWhereInput>;
};

export type ConfigCommitMaxAggregate = {
    __typename?: 'ConfigCommitMaxAggregate';
    author?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    entityType?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    mutation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    propagationType?: Maybe<PropagationType>;
    service?: Maybe<Service>;
    sessionId?: Maybe<Scalars['String']['output']>;
    softDeleted?: Maybe<Scalars['Boolean']['output']>;
    softDeletedBy?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ConfigCommitStatus>;
};

export type ConfigCommitMaxOrderByAggregateInput = {
    author?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    entityType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    mutation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    service?: InputMaybe<SortOrder>;
    sessionId?: InputMaybe<SortOrder>;
    softDeleted?: InputMaybe<SortOrder>;
    softDeletedBy?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type ConfigCommitMinAggregate = {
    __typename?: 'ConfigCommitMinAggregate';
    author?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    entityType?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    mutation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    propagationType?: Maybe<PropagationType>;
    service?: Maybe<Service>;
    sessionId?: Maybe<Scalars['String']['output']>;
    softDeleted?: Maybe<Scalars['Boolean']['output']>;
    softDeletedBy?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ConfigCommitStatus>;
};

export type ConfigCommitMinOrderByAggregateInput = {
    author?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    entityType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    mutation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    service?: InputMaybe<SortOrder>;
    sessionId?: InputMaybe<SortOrder>;
    softDeleted?: InputMaybe<SortOrder>;
    softDeletedBy?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type ConfigCommitOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ConfigCommitOrderByWithAggregationInput = {
    _avg?: InputMaybe<ConfigCommitAvgOrderByAggregateInput>;
    _count?: InputMaybe<ConfigCommitCountOrderByAggregateInput>;
    _max?: InputMaybe<ConfigCommitMaxOrderByAggregateInput>;
    _min?: InputMaybe<ConfigCommitMinOrderByAggregateInput>;
    _sum?: InputMaybe<ConfigCommitSumOrderByAggregateInput>;
    author?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    entityIds?: InputMaybe<SortOrder>;
    entityType?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    mutation?: InputMaybe<SortOrder>;
    newValues?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    previousValues?: InputMaybe<SortOrderInput>;
    propagationType?: InputMaybe<SortOrderInput>;
    service?: InputMaybe<SortOrderInput>;
    sessionId?: InputMaybe<SortOrder>;
    softDeleted?: InputMaybe<SortOrder>;
    softDeletedBy?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
};

export type ConfigCommitOrderByWithRelationInput = {
    author?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    entityIds?: InputMaybe<SortOrder>;
    entityType?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    mutation?: InputMaybe<SortOrder>;
    newValues?: InputMaybe<SortOrderInput>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrderInput>;
    previousValues?: InputMaybe<SortOrderInput>;
    propagationType?: InputMaybe<SortOrderInput>;
    service?: InputMaybe<SortOrderInput>;
    session?: InputMaybe<ConfigSessionOrderByWithRelationInput>;
    sessionId?: InputMaybe<SortOrder>;
    softDeleted?: InputMaybe<SortOrder>;
    softDeletedBy?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
};

export enum ConfigCommitScalarFieldEnum {
    Author = 'author',
    CreatedAt = 'createdAt',
    Description = 'description',
    EntityIds = 'entityIds',
    EntityType = 'entityType',
    Id = 'id',
    Mutation = 'mutation',
    NewValues = 'newValues',
    OrgId = 'orgId',
    PreviousValues = 'previousValues',
    PropagationType = 'propagationType',
    Service = 'service',
    SessionId = 'sessionId',
    SoftDeleted = 'softDeleted',
    SoftDeletedBy = 'softDeletedBy',
    Status = 'status',
}

export type ConfigCommitScalarWhereInput = {
    AND?: InputMaybe<Array<ConfigCommitScalarWhereInput>>;
    NOT?: InputMaybe<Array<ConfigCommitScalarWhereInput>>;
    OR?: InputMaybe<Array<ConfigCommitScalarWhereInput>>;
    author?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    description?: InputMaybe<StringFilter>;
    entityIds?: InputMaybe<IntNullableListFilter>;
    entityType?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<StringFilter>;
    mutation?: InputMaybe<StringFilter>;
    newValues?: InputMaybe<JsonNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    previousValues?: InputMaybe<JsonNullableFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeNullableFilter>;
    service?: InputMaybe<EnumServiceNullableFilter>;
    sessionId?: InputMaybe<StringFilter>;
    softDeleted?: InputMaybe<BoolFilter>;
    softDeletedBy?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumConfigCommitStatusNullableFilter>;
};

export type ConfigCommitScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ConfigCommitScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ConfigCommitScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ConfigCommitScalarWhereWithAggregatesInput>>;
    author?: InputMaybe<StringWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    description?: InputMaybe<StringWithAggregatesFilter>;
    entityIds?: InputMaybe<IntNullableListFilter>;
    entityType?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    mutation?: InputMaybe<StringWithAggregatesFilter>;
    newValues?: InputMaybe<JsonNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    previousValues?: InputMaybe<JsonNullableWithAggregatesFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeNullableWithAggregatesFilter>;
    service?: InputMaybe<EnumServiceNullableWithAggregatesFilter>;
    sessionId?: InputMaybe<StringWithAggregatesFilter>;
    softDeleted?: InputMaybe<BoolWithAggregatesFilter>;
    softDeletedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumConfigCommitStatusNullableWithAggregatesFilter>;
};

export type ConfigCommitSumAggregate = {
    __typename?: 'ConfigCommitSumAggregate';
    entityIds?: Maybe<Array<Scalars['Int']['output']>>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type ConfigCommitSumOrderByAggregateInput = {
    entityIds?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type ConfigCommitUpdateInput = {
    author?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    entityIds?: InputMaybe<ConfigCommitUpdateentityIdsInput>;
    entityType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    mutation?: InputMaybe<StringFieldUpdateOperationsInput>;
    newValues?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneWithoutConfigCommitsNestedInput>;
    previousValues?: InputMaybe<Scalars['JSON']['input']>;
    propagationType?: InputMaybe<NullableEnumPropagationTypeFieldUpdateOperationsInput>;
    service?: InputMaybe<NullableEnumServiceFieldUpdateOperationsInput>;
    session?: InputMaybe<ConfigSessionUpdateOneRequiredWithoutCommitsNestedInput>;
    softDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    softDeletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumConfigCommitStatusFieldUpdateOperationsInput>;
};

export type ConfigCommitUpdateManyMutationInput = {
    author?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    entityIds?: InputMaybe<ConfigCommitUpdateentityIdsInput>;
    entityType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    mutation?: InputMaybe<StringFieldUpdateOperationsInput>;
    newValues?: InputMaybe<Scalars['JSON']['input']>;
    previousValues?: InputMaybe<Scalars['JSON']['input']>;
    propagationType?: InputMaybe<NullableEnumPropagationTypeFieldUpdateOperationsInput>;
    service?: InputMaybe<NullableEnumServiceFieldUpdateOperationsInput>;
    softDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    softDeletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumConfigCommitStatusFieldUpdateOperationsInput>;
};

export type ConfigCommitUpdateManyWithWhereWithoutOrgInput = {
    data: ConfigCommitUpdateManyMutationInput;
    where: ConfigCommitScalarWhereInput;
};

export type ConfigCommitUpdateManyWithWhereWithoutSessionInput = {
    data: ConfigCommitUpdateManyMutationInput;
    where: ConfigCommitScalarWhereInput;
};

export type ConfigCommitUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<ConfigCommitWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConfigCommitCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<ConfigCommitCreateWithoutOrgInput>>;
    createMany?: InputMaybe<ConfigCommitCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<ConfigCommitWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ConfigCommitScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ConfigCommitWhereUniqueInput>>;
    set?: InputMaybe<Array<ConfigCommitWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ConfigCommitUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<ConfigCommitUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<ConfigCommitUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type ConfigCommitUpdateManyWithoutSessionNestedInput = {
    connect?: InputMaybe<Array<ConfigCommitWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConfigCommitCreateOrConnectWithoutSessionInput>
    >;
    create?: InputMaybe<Array<ConfigCommitCreateWithoutSessionInput>>;
    createMany?: InputMaybe<ConfigCommitCreateManySessionInputEnvelope>;
    delete?: InputMaybe<Array<ConfigCommitWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ConfigCommitScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ConfigCommitWhereUniqueInput>>;
    set?: InputMaybe<Array<ConfigCommitWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ConfigCommitUpdateWithWhereUniqueWithoutSessionInput>
    >;
    updateMany?: InputMaybe<
        Array<ConfigCommitUpdateManyWithWhereWithoutSessionInput>
    >;
    upsert?: InputMaybe<
        Array<ConfigCommitUpsertWithWhereUniqueWithoutSessionInput>
    >;
};

export type ConfigCommitUpdateWithWhereUniqueWithoutOrgInput = {
    data: ConfigCommitUpdateWithoutOrgInput;
    where: ConfigCommitWhereUniqueInput;
};

export type ConfigCommitUpdateWithWhereUniqueWithoutSessionInput = {
    data: ConfigCommitUpdateWithoutSessionInput;
    where: ConfigCommitWhereUniqueInput;
};

export type ConfigCommitUpdateWithoutOrgInput = {
    author?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    entityIds?: InputMaybe<ConfigCommitUpdateentityIdsInput>;
    entityType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    mutation?: InputMaybe<StringFieldUpdateOperationsInput>;
    newValues?: InputMaybe<Scalars['JSON']['input']>;
    previousValues?: InputMaybe<Scalars['JSON']['input']>;
    propagationType?: InputMaybe<NullableEnumPropagationTypeFieldUpdateOperationsInput>;
    service?: InputMaybe<NullableEnumServiceFieldUpdateOperationsInput>;
    session?: InputMaybe<ConfigSessionUpdateOneRequiredWithoutCommitsNestedInput>;
    softDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    softDeletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumConfigCommitStatusFieldUpdateOperationsInput>;
};

export type ConfigCommitUpdateWithoutSessionInput = {
    author?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    entityIds?: InputMaybe<ConfigCommitUpdateentityIdsInput>;
    entityType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    mutation?: InputMaybe<StringFieldUpdateOperationsInput>;
    newValues?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneWithoutConfigCommitsNestedInput>;
    previousValues?: InputMaybe<Scalars['JSON']['input']>;
    propagationType?: InputMaybe<NullableEnumPropagationTypeFieldUpdateOperationsInput>;
    service?: InputMaybe<NullableEnumServiceFieldUpdateOperationsInput>;
    softDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    softDeletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumConfigCommitStatusFieldUpdateOperationsInput>;
};

export type ConfigCommitUpdateentityIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ConfigCommitUpsertWithWhereUniqueWithoutOrgInput = {
    create: ConfigCommitCreateWithoutOrgInput;
    update: ConfigCommitUpdateWithoutOrgInput;
    where: ConfigCommitWhereUniqueInput;
};

export type ConfigCommitUpsertWithWhereUniqueWithoutSessionInput = {
    create: ConfigCommitCreateWithoutSessionInput;
    update: ConfigCommitUpdateWithoutSessionInput;
    where: ConfigCommitWhereUniqueInput;
};

export type ConfigCommitWhereInput = {
    AND?: InputMaybe<Array<ConfigCommitWhereInput>>;
    NOT?: InputMaybe<Array<ConfigCommitWhereInput>>;
    OR?: InputMaybe<Array<ConfigCommitWhereInput>>;
    author?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    description?: InputMaybe<StringFilter>;
    entityIds?: InputMaybe<IntNullableListFilter>;
    entityType?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<StringFilter>;
    mutation?: InputMaybe<StringFilter>;
    newValues?: InputMaybe<JsonNullableFilter>;
    org?: InputMaybe<OrganizationNullableRelationFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    previousValues?: InputMaybe<JsonNullableFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeNullableFilter>;
    service?: InputMaybe<EnumServiceNullableFilter>;
    session?: InputMaybe<ConfigSessionRelationFilter>;
    sessionId?: InputMaybe<StringFilter>;
    softDeleted?: InputMaybe<BoolFilter>;
    softDeletedBy?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumConfigCommitStatusNullableFilter>;
};

export type ConfigCommitWhereUniqueInput = {
    AND?: InputMaybe<Array<ConfigCommitWhereInput>>;
    NOT?: InputMaybe<Array<ConfigCommitWhereInput>>;
    OR?: InputMaybe<Array<ConfigCommitWhereInput>>;
    author?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    description?: InputMaybe<StringFilter>;
    entityIds?: InputMaybe<IntNullableListFilter>;
    entityType?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    mutation?: InputMaybe<StringFilter>;
    newValues?: InputMaybe<JsonNullableFilter>;
    org?: InputMaybe<OrganizationNullableRelationFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    previousValues?: InputMaybe<JsonNullableFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeNullableFilter>;
    service?: InputMaybe<EnumServiceNullableFilter>;
    session?: InputMaybe<ConfigSessionRelationFilter>;
    sessionId?: InputMaybe<StringFilter>;
    softDeleted?: InputMaybe<BoolFilter>;
    softDeletedBy?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumConfigCommitStatusNullableFilter>;
};

export type ConfigFlag = {
    __typename?: 'ConfigFlag';
    _count?: Maybe<ConfigFlagCount>;
    createdAt: Scalars['DateTimeISO']['output'];
    description?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    orgFlags: Array<OrgConfigFlag>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ConfigFlagOrgFlagsArgs = {
    cursor?: InputMaybe<OrgConfigFlagWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgConfigFlagScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgConfigFlagOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type ConfigFlagCount = {
    __typename?: 'ConfigFlagCount';
    orgFlags: Scalars['Int']['output'];
};

export type ConfigFlagCountOrgFlagsArgs = {
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type ConfigFlagCountAggregate = {
    __typename?: 'ConfigFlagCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ConfigFlagCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ConfigFlagCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    orgFlags?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutFlagInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConfigFlagCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConfigFlagCreateNestedOneWithoutOrgFlagsInput = {
    connect?: InputMaybe<ConfigFlagWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConfigFlagCreateOrConnectWithoutOrgFlagsInput>;
    create?: InputMaybe<ConfigFlagCreateWithoutOrgFlagsInput>;
};

export type ConfigFlagCreateOrConnectWithoutOrgFlagsInput = {
    create: ConfigFlagCreateWithoutOrgFlagsInput;
    where: ConfigFlagWhereUniqueInput;
};

export type ConfigFlagCreateWithoutOrgFlagsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConfigFlagGroupBy = {
    __typename?: 'ConfigFlagGroupBy';
    _count?: Maybe<ConfigFlagCountAggregate>;
    _max?: Maybe<ConfigFlagMaxAggregate>;
    _min?: Maybe<ConfigFlagMinAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    description?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ConfigFlagMaxAggregate = {
    __typename?: 'ConfigFlagMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConfigFlagMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ConfigFlagMinAggregate = {
    __typename?: 'ConfigFlagMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConfigFlagMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ConfigFlagOrderByWithAggregationInput = {
    _count?: InputMaybe<ConfigFlagCountOrderByAggregateInput>;
    _max?: InputMaybe<ConfigFlagMaxOrderByAggregateInput>;
    _min?: InputMaybe<ConfigFlagMinOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ConfigFlagOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    orgFlags?: InputMaybe<OrgConfigFlagOrderByRelationAggregateInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ConfigFlagRelationFilter = {
    is?: InputMaybe<ConfigFlagWhereInput>;
    isNot?: InputMaybe<ConfigFlagWhereInput>;
};

export enum ConfigFlagScalarFieldEnum {
    CreatedAt = 'createdAt',
    Description = 'description',
    Name = 'name',
    UpdatedAt = 'updatedAt',
}

export type ConfigFlagScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ConfigFlagScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ConfigFlagScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ConfigFlagScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    description?: InputMaybe<StringNullableWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ConfigFlagUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgFlags?: InputMaybe<OrgConfigFlagUpdateManyWithoutFlagNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConfigFlagUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConfigFlagUpdateOneRequiredWithoutOrgFlagsNestedInput = {
    connect?: InputMaybe<ConfigFlagWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConfigFlagCreateOrConnectWithoutOrgFlagsInput>;
    create?: InputMaybe<ConfigFlagCreateWithoutOrgFlagsInput>;
    update?: InputMaybe<ConfigFlagUpdateToOneWithWhereWithoutOrgFlagsInput>;
    upsert?: InputMaybe<ConfigFlagUpsertWithoutOrgFlagsInput>;
};

export type ConfigFlagUpdateToOneWithWhereWithoutOrgFlagsInput = {
    data: ConfigFlagUpdateWithoutOrgFlagsInput;
    where?: InputMaybe<ConfigFlagWhereInput>;
};

export type ConfigFlagUpdateWithoutOrgFlagsInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConfigFlagUpsertWithoutOrgFlagsInput = {
    create: ConfigFlagCreateWithoutOrgFlagsInput;
    update: ConfigFlagUpdateWithoutOrgFlagsInput;
    where?: InputMaybe<ConfigFlagWhereInput>;
};

export type ConfigFlagWhereInput = {
    AND?: InputMaybe<Array<ConfigFlagWhereInput>>;
    NOT?: InputMaybe<Array<ConfigFlagWhereInput>>;
    OR?: InputMaybe<Array<ConfigFlagWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    description?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    orgFlags?: InputMaybe<OrgConfigFlagListRelationFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ConfigFlagWhereUniqueInput = {
    AND?: InputMaybe<Array<ConfigFlagWhereInput>>;
    NOT?: InputMaybe<Array<ConfigFlagWhereInput>>;
    OR?: InputMaybe<Array<ConfigFlagWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    description?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<Scalars['String']['input']>;
    orgFlags?: InputMaybe<OrgConfigFlagListRelationFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ConfigSession = {
    __typename?: 'ConfigSession';
    _count?: Maybe<ConfigSessionCount>;
    author: Scalars['String']['output'];
    commits: Array<ConfigCommit>;
    description?: Maybe<Scalars['String']['output']>;
    finishedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    startedAt: Scalars['DateTimeISO']['output'];
};

export type ConfigSessionCommitsArgs = {
    cursor?: InputMaybe<ConfigCommitWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigCommitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigCommitOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type ConfigSessionCount = {
    __typename?: 'ConfigSessionCount';
    commits: Scalars['Int']['output'];
};

export type ConfigSessionCountCommitsArgs = {
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type ConfigSessionCountAggregate = {
    __typename?: 'ConfigSessionCountAggregate';
    _all: Scalars['Int']['output'];
    author: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    finishedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    startedAt: Scalars['Int']['output'];
};

export type ConfigSessionCountOrderByAggregateInput = {
    author?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    finishedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrder>;
};

export type ConfigSessionCreateInput = {
    author: Scalars['String']['input'];
    commits?: InputMaybe<ConfigCommitCreateNestedManyWithoutSessionInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    finishedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConfigSessionCreateManyInput = {
    author: Scalars['String']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    finishedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConfigSessionCreateNestedOneWithoutCommitsInput = {
    connect?: InputMaybe<ConfigSessionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConfigSessionCreateOrConnectWithoutCommitsInput>;
    create?: InputMaybe<ConfigSessionCreateWithoutCommitsInput>;
};

export type ConfigSessionCreateOrConnectWithoutCommitsInput = {
    create: ConfigSessionCreateWithoutCommitsInput;
    where: ConfigSessionWhereUniqueInput;
};

export type ConfigSessionCreateWithoutCommitsInput = {
    author: Scalars['String']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    finishedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConfigSessionGroupBy = {
    __typename?: 'ConfigSessionGroupBy';
    _count?: Maybe<ConfigSessionCountAggregate>;
    _max?: Maybe<ConfigSessionMaxAggregate>;
    _min?: Maybe<ConfigSessionMinAggregate>;
    author: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    finishedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    startedAt: Scalars['DateTimeISO']['output'];
};

export type ConfigSessionMaxAggregate = {
    __typename?: 'ConfigSessionMaxAggregate';
    author?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    finishedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConfigSessionMaxOrderByAggregateInput = {
    author?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    finishedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrder>;
};

export type ConfigSessionMinAggregate = {
    __typename?: 'ConfigSessionMinAggregate';
    author?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    finishedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConfigSessionMinOrderByAggregateInput = {
    author?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    finishedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrder>;
};

export type ConfigSessionOrderByWithAggregationInput = {
    _count?: InputMaybe<ConfigSessionCountOrderByAggregateInput>;
    _max?: InputMaybe<ConfigSessionMaxOrderByAggregateInput>;
    _min?: InputMaybe<ConfigSessionMinOrderByAggregateInput>;
    author?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrderInput>;
    finishedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrder>;
};

export type ConfigSessionOrderByWithRelationInput = {
    author?: InputMaybe<SortOrder>;
    commits?: InputMaybe<ConfigCommitOrderByRelationAggregateInput>;
    description?: InputMaybe<SortOrderInput>;
    finishedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrder>;
};

export type ConfigSessionRelationFilter = {
    is?: InputMaybe<ConfigSessionWhereInput>;
    isNot?: InputMaybe<ConfigSessionWhereInput>;
};

export enum ConfigSessionScalarFieldEnum {
    Author = 'author',
    Description = 'description',
    FinishedAt = 'finishedAt',
    Id = 'id',
    StartedAt = 'startedAt',
}

export type ConfigSessionScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ConfigSessionScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ConfigSessionScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ConfigSessionScalarWhereWithAggregatesInput>>;
    author?: InputMaybe<StringWithAggregatesFilter>;
    description?: InputMaybe<StringNullableWithAggregatesFilter>;
    finishedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    startedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ConfigSessionUpdateInput = {
    author?: InputMaybe<StringFieldUpdateOperationsInput>;
    commits?: InputMaybe<ConfigCommitUpdateManyWithoutSessionNestedInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    finishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    startedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConfigSessionUpdateManyMutationInput = {
    author?: InputMaybe<StringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    finishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    startedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConfigSessionUpdateOneRequiredWithoutCommitsNestedInput = {
    connect?: InputMaybe<ConfigSessionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConfigSessionCreateOrConnectWithoutCommitsInput>;
    create?: InputMaybe<ConfigSessionCreateWithoutCommitsInput>;
    update?: InputMaybe<ConfigSessionUpdateToOneWithWhereWithoutCommitsInput>;
    upsert?: InputMaybe<ConfigSessionUpsertWithoutCommitsInput>;
};

export type ConfigSessionUpdateToOneWithWhereWithoutCommitsInput = {
    data: ConfigSessionUpdateWithoutCommitsInput;
    where?: InputMaybe<ConfigSessionWhereInput>;
};

export type ConfigSessionUpdateWithoutCommitsInput = {
    author?: InputMaybe<StringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    finishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    startedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConfigSessionUpsertWithoutCommitsInput = {
    create: ConfigSessionCreateWithoutCommitsInput;
    update: ConfigSessionUpdateWithoutCommitsInput;
    where?: InputMaybe<ConfigSessionWhereInput>;
};

export type ConfigSessionWhereInput = {
    AND?: InputMaybe<Array<ConfigSessionWhereInput>>;
    NOT?: InputMaybe<Array<ConfigSessionWhereInput>>;
    OR?: InputMaybe<Array<ConfigSessionWhereInput>>;
    author?: InputMaybe<StringFilter>;
    commits?: InputMaybe<ConfigCommitListRelationFilter>;
    description?: InputMaybe<StringNullableFilter>;
    finishedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<StringFilter>;
    startedAt?: InputMaybe<DateTimeFilter>;
};

export type ConfigSessionWhereUniqueInput = {
    AND?: InputMaybe<Array<ConfigSessionWhereInput>>;
    NOT?: InputMaybe<Array<ConfigSessionWhereInput>>;
    OR?: InputMaybe<Array<ConfigSessionWhereInput>>;
    author?: InputMaybe<StringFilter>;
    commits?: InputMaybe<ConfigCommitListRelationFilter>;
    description?: InputMaybe<StringNullableFilter>;
    finishedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    startedAt?: InputMaybe<DateTimeFilter>;
};

export type ConsentForm = {
    __typename?: 'ConsentForm';
    consentFormId: Scalars['String']['output'];
    date: Scalars['DateTimeISO']['output'];
    encounterId: Scalars['String']['output'];
    id: Scalars['String']['output'];
};

export type ConsentFormCountAggregate = {
    __typename?: 'ConsentFormCountAggregate';
    _all: Scalars['Int']['output'];
    consentFormId: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    encounterId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
};

export type ConsentFormCountOrderByAggregateInput = {
    consentFormId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type ConsentFormCreateInput = {
    consentFormId: Scalars['String']['input'];
    date: Scalars['DateTimeISO']['input'];
    encounterId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
};

export type ConsentFormCreateManyInput = {
    consentFormId: Scalars['String']['input'];
    date: Scalars['DateTimeISO']['input'];
    encounterId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
};

export type ConsentFormGroupBy = {
    __typename?: 'ConsentFormGroupBy';
    _count?: Maybe<ConsentFormCountAggregate>;
    _max?: Maybe<ConsentFormMaxAggregate>;
    _min?: Maybe<ConsentFormMinAggregate>;
    consentFormId: Scalars['String']['output'];
    date: Scalars['DateTimeISO']['output'];
    encounterId: Scalars['String']['output'];
    id: Scalars['String']['output'];
};

export type ConsentFormMaxAggregate = {
    __typename?: 'ConsentFormMaxAggregate';
    consentFormId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
};

export type ConsentFormMaxOrderByAggregateInput = {
    consentFormId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type ConsentFormMinAggregate = {
    __typename?: 'ConsentFormMinAggregate';
    consentFormId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
};

export type ConsentFormMinOrderByAggregateInput = {
    consentFormId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type ConsentFormOrderByWithAggregationInput = {
    _count?: InputMaybe<ConsentFormCountOrderByAggregateInput>;
    _max?: InputMaybe<ConsentFormMaxOrderByAggregateInput>;
    _min?: InputMaybe<ConsentFormMinOrderByAggregateInput>;
    consentFormId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type ConsentFormOrderByWithRelationInput = {
    consentFormId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export enum ConsentFormScalarFieldEnum {
    ConsentFormId = 'consentFormId',
    Date = 'date',
    EncounterId = 'encounterId',
    Id = 'id',
}

export type ConsentFormScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ConsentFormScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ConsentFormScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ConsentFormScalarWhereWithAggregatesInput>>;
    consentFormId?: InputMaybe<StringWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    encounterId?: InputMaybe<UuidWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
};

export type ConsentFormUpdateInput = {
    consentFormId?: InputMaybe<StringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ConsentFormUpdateManyMutationInput = {
    consentFormId?: InputMaybe<StringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ConsentFormWhereInput = {
    AND?: InputMaybe<Array<ConsentFormWhereInput>>;
    NOT?: InputMaybe<Array<ConsentFormWhereInput>>;
    OR?: InputMaybe<Array<ConsentFormWhereInput>>;
    consentFormId?: InputMaybe<StringFilter>;
    date?: InputMaybe<DateTimeFilter>;
    encounterId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<UuidFilter>;
};

export type ConsentFormWhereUniqueInput = {
    AND?: InputMaybe<Array<ConsentFormWhereInput>>;
    NOT?: InputMaybe<Array<ConsentFormWhereInput>>;
    OR?: InputMaybe<Array<ConsentFormWhereInput>>;
    consentFormId?: InputMaybe<StringFilter>;
    date?: InputMaybe<DateTimeFilter>;
    encounterId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
};

export type Consumer = {
    __typename?: 'Consumer';
    _count?: Maybe<ConsumerCount>;
    addressLine2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    consumerAccountStatus: ConsumerAccountStatus;
    consumerMessages: Array<ConsumerMessage>;
    consumerNotes: Array<ConsumerNote>;
    contracts: Array<Contract>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deceasedDate?: Maybe<Scalars['DateTimeISO']['output']>;
    dob: Scalars['DateTimeISO']['output'];
    ehrEnterpriseId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    emergencyContactFirstName?: Maybe<Scalars['String']['output']>;
    emergencyContactLastName?: Maybe<Scalars['String']['output']>;
    emergencyContactPhone?: Maybe<Scalars['String']['output']>;
    emergencyContactRelationship?: Maybe<EmergencyContactRelationship>;
    employmentStatus?: Maybe<EmploymentStatus>;
    enrolledInAthena: Scalars['Boolean']['output'];
    ethnicity?: Maybe<Ethnicity>;
    firstname: Scalars['String']['output'];
    id: Scalars['String']['output'];
    insurances: Array<Insurance>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lastname: Scalars['String']['output'];
    maritalStatus?: Maybe<MaritalStatus>;
    messageNudges: Array<MessageNudge>;
    messagePayAfter: Array<MessagePayAfter>;
    pcpAddress?: Maybe<Scalars['JSON']['output']>;
    pcpEhrId?: Maybe<Scalars['String']['output']>;
    pcpFirstName?: Maybe<Scalars['String']['output']>;
    pcpLastName?: Maybe<Scalars['String']['output']>;
    pcpPhone?: Maybe<Scalars['String']['output']>;
    pharmacyAddress?: Maybe<Scalars['JSON']['output']>;
    pharmacyEhrId?: Maybe<Scalars['String']['output']>;
    pharmacyName?: Maybe<Scalars['String']['output']>;
    pharmacyNcpdpId?: Maybe<Scalars['String']['output']>;
    pharmacyPhone?: Maybe<Scalars['String']['output']>;
    photos: Array<ConsumerPhotoMetaData>;
    preferredFirstName?: Maybe<Scalars['String']['output']>;
    preferredLanguage?: Maybe<LanguageCode>;
    preferredLastName?: Maybe<Scalars['String']['output']>;
    race: Array<Race>;
    referralSource?: Maybe<Scalars['String']['output']>;
    referralSourceDetail?: Maybe<Scalars['String']['output']>;
    referralSourceId?: Maybe<Scalars['String']['output']>;
    sex?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    user: User;
    userId: Scalars['String']['output'];
    userIfPrimaryConsumer?: Maybe<User>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type ConsumerConsumerMessagesArgs = {
    cursor?: InputMaybe<ConsumerMessageWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerMessageScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerMessageOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type ConsumerConsumerNotesArgs = {
    cursor?: InputMaybe<ConsumerNoteWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerNoteScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerNoteOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type ConsumerContractsArgs = {
    cursor?: InputMaybe<ContractWhereUniqueInput>;
    distinct?: InputMaybe<Array<ContractScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ContractOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractWhereInput>;
};

export type ConsumerInsurancesArgs = {
    cursor?: InputMaybe<InsuranceWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceWhereInput>;
};

export type ConsumerMessageNudgesArgs = {
    cursor?: InputMaybe<MessageNudgeWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageNudgeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageNudgeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type ConsumerMessagePayAfterArgs = {
    cursor?: InputMaybe<MessagePayAfterWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessagePayAfterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessagePayAfterOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessagePayAfterWhereInput>;
};

export type ConsumerPhotosArgs = {
    cursor?: InputMaybe<ConsumerPhotoMetaDataWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerPhotoMetaDataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerPhotoMetaDataOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type ConsumerUserIfPrimaryConsumerArgs = {
    where?: InputMaybe<UserWhereInput>;
};

export enum ConsumerAccountStatus {
    AdminCreated = 'ADMIN_CREATED',
    Connected = 'CONNECTED',
    Deleted = 'DELETED',
    Replaced = 'REPLACED',
}

export type ConsumerAndEhrPatientCreateInput = {
    consumer: ConsumerCreateInput;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
};

export type ConsumerAuditLog = {
    __typename?: 'ConsumerAuditLog';
    addressLine2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    consumerAccountStatus?: Maybe<ConsumerAccountStatus>;
    consumerId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deceasedDate?: Maybe<Scalars['DateTimeISO']['output']>;
    dob?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrEnterpriseId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    emergencyContactFirstName?: Maybe<Scalars['String']['output']>;
    emergencyContactLastName?: Maybe<Scalars['String']['output']>;
    emergencyContactPhone?: Maybe<Scalars['String']['output']>;
    emergencyContactRelationship?: Maybe<EmergencyContactRelationship>;
    employmentStatus?: Maybe<EmploymentStatus>;
    enrolledInAthena?: Maybe<Scalars['Boolean']['output']>;
    ethnicity?: Maybe<Ethnicity>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maritalStatus?: Maybe<MaritalStatus>;
    operation?: Maybe<Scalars['String']['output']>;
    pcpAddress?: Maybe<Scalars['JSON']['output']>;
    pcpEhrId?: Maybe<Scalars['String']['output']>;
    pcpFirstName?: Maybe<Scalars['String']['output']>;
    pcpLastName?: Maybe<Scalars['String']['output']>;
    pcpPhone?: Maybe<Scalars['String']['output']>;
    pharmacyAddress?: Maybe<Scalars['JSON']['output']>;
    pharmacyEhrId?: Maybe<Scalars['String']['output']>;
    pharmacyName?: Maybe<Scalars['String']['output']>;
    pharmacyNcpdpId?: Maybe<Scalars['String']['output']>;
    pharmacyPhone?: Maybe<Scalars['String']['output']>;
    preferredFirstName?: Maybe<Scalars['String']['output']>;
    preferredLanguage?: Maybe<LanguageCode>;
    preferredLastName?: Maybe<Scalars['String']['output']>;
    race: Array<Race>;
    referralSource?: Maybe<Scalars['String']['output']>;
    referralSourceDetail?: Maybe<Scalars['String']['output']>;
    referralSourceId?: Maybe<Scalars['String']['output']>;
    sex?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userId?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type ConsumerAuditLogAvgAggregate = {
    __typename?: 'ConsumerAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type ConsumerAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ConsumerAuditLogCountAggregate = {
    __typename?: 'ConsumerAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    addressLine2: Scalars['Int']['output'];
    city: Scalars['Int']['output'];
    consumerAccountStatus: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    country: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deceasedDate: Scalars['Int']['output'];
    dob: Scalars['Int']['output'];
    ehrEnterpriseId: Scalars['Int']['output'];
    ehrPatientId: Scalars['Int']['output'];
    emergencyContactFirstName: Scalars['Int']['output'];
    emergencyContactLastName: Scalars['Int']['output'];
    emergencyContactPhone: Scalars['Int']['output'];
    emergencyContactRelationship: Scalars['Int']['output'];
    employmentStatus: Scalars['Int']['output'];
    enrolledInAthena: Scalars['Int']['output'];
    ethnicity: Scalars['Int']['output'];
    firstName: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastName: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    maritalStatus: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    pcpAddress: Scalars['Int']['output'];
    pcpEhrId: Scalars['Int']['output'];
    pcpFirstName: Scalars['Int']['output'];
    pcpLastName: Scalars['Int']['output'];
    pcpPhone: Scalars['Int']['output'];
    pharmacyAddress: Scalars['Int']['output'];
    pharmacyEhrId: Scalars['Int']['output'];
    pharmacyName: Scalars['Int']['output'];
    pharmacyNcpdpId: Scalars['Int']['output'];
    pharmacyPhone: Scalars['Int']['output'];
    preferredFirstName: Scalars['Int']['output'];
    preferredLanguage: Scalars['Int']['output'];
    preferredLastName: Scalars['Int']['output'];
    race: Scalars['Int']['output'];
    referralSource: Scalars['Int']['output'];
    referralSourceDetail: Scalars['Int']['output'];
    referralSourceId: Scalars['Int']['output'];
    sex: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
    streetAddress: Scalars['Int']['output'];
    stripeCustomerId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
    zip: Scalars['Int']['output'];
};

export type ConsumerAuditLogCountOrderByAggregateInput = {
    addressLine2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    consumerAccountStatus?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deceasedDate?: InputMaybe<SortOrder>;
    dob?: InputMaybe<SortOrder>;
    ehrEnterpriseId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    emergencyContactFirstName?: InputMaybe<SortOrder>;
    emergencyContactLastName?: InputMaybe<SortOrder>;
    emergencyContactPhone?: InputMaybe<SortOrder>;
    emergencyContactRelationship?: InputMaybe<SortOrder>;
    employmentStatus?: InputMaybe<SortOrder>;
    enrolledInAthena?: InputMaybe<SortOrder>;
    ethnicity?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    maritalStatus?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    pcpAddress?: InputMaybe<SortOrder>;
    pcpEhrId?: InputMaybe<SortOrder>;
    pcpFirstName?: InputMaybe<SortOrder>;
    pcpLastName?: InputMaybe<SortOrder>;
    pcpPhone?: InputMaybe<SortOrder>;
    pharmacyAddress?: InputMaybe<SortOrder>;
    pharmacyEhrId?: InputMaybe<SortOrder>;
    pharmacyName?: InputMaybe<SortOrder>;
    pharmacyNcpdpId?: InputMaybe<SortOrder>;
    pharmacyPhone?: InputMaybe<SortOrder>;
    preferredFirstName?: InputMaybe<SortOrder>;
    preferredLanguage?: InputMaybe<SortOrder>;
    preferredLastName?: InputMaybe<SortOrder>;
    race?: InputMaybe<SortOrder>;
    referralSource?: InputMaybe<SortOrder>;
    referralSourceDetail?: InputMaybe<SortOrder>;
    referralSourceId?: InputMaybe<SortOrder>;
    sex?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    streetAddress?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type ConsumerAuditLogCreateInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maritalStatus?: InputMaybe<MaritalStatus>;
    operation?: InputMaybe<Scalars['String']['input']>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerAuditLogCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerAuditLogCreateManyInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maritalStatus?: InputMaybe<MaritalStatus>;
    operation?: InputMaybe<Scalars['String']['input']>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerAuditLogCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerAuditLogCreateraceInput = {
    set: Array<Race>;
};

export type ConsumerAuditLogGroupBy = {
    __typename?: 'ConsumerAuditLogGroupBy';
    _avg?: Maybe<ConsumerAuditLogAvgAggregate>;
    _count?: Maybe<ConsumerAuditLogCountAggregate>;
    _max?: Maybe<ConsumerAuditLogMaxAggregate>;
    _min?: Maybe<ConsumerAuditLogMinAggregate>;
    _sum?: Maybe<ConsumerAuditLogSumAggregate>;
    addressLine2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    consumerAccountStatus?: Maybe<ConsumerAccountStatus>;
    consumerId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deceasedDate?: Maybe<Scalars['DateTimeISO']['output']>;
    dob?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrEnterpriseId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    emergencyContactFirstName?: Maybe<Scalars['String']['output']>;
    emergencyContactLastName?: Maybe<Scalars['String']['output']>;
    emergencyContactPhone?: Maybe<Scalars['String']['output']>;
    emergencyContactRelationship?: Maybe<EmergencyContactRelationship>;
    employmentStatus?: Maybe<EmploymentStatus>;
    enrolledInAthena?: Maybe<Scalars['Boolean']['output']>;
    ethnicity?: Maybe<Ethnicity>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maritalStatus?: Maybe<MaritalStatus>;
    operation?: Maybe<Scalars['String']['output']>;
    pcpAddress?: Maybe<Scalars['JSON']['output']>;
    pcpEhrId?: Maybe<Scalars['String']['output']>;
    pcpFirstName?: Maybe<Scalars['String']['output']>;
    pcpLastName?: Maybe<Scalars['String']['output']>;
    pcpPhone?: Maybe<Scalars['String']['output']>;
    pharmacyAddress?: Maybe<Scalars['JSON']['output']>;
    pharmacyEhrId?: Maybe<Scalars['String']['output']>;
    pharmacyName?: Maybe<Scalars['String']['output']>;
    pharmacyNcpdpId?: Maybe<Scalars['String']['output']>;
    pharmacyPhone?: Maybe<Scalars['String']['output']>;
    preferredFirstName?: Maybe<Scalars['String']['output']>;
    preferredLanguage?: Maybe<LanguageCode>;
    preferredLastName?: Maybe<Scalars['String']['output']>;
    race?: Maybe<Array<Race>>;
    referralSource?: Maybe<Scalars['String']['output']>;
    referralSourceDetail?: Maybe<Scalars['String']['output']>;
    referralSourceId?: Maybe<Scalars['String']['output']>;
    sex?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userId?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type ConsumerAuditLogMaxAggregate = {
    __typename?: 'ConsumerAuditLogMaxAggregate';
    addressLine2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    consumerAccountStatus?: Maybe<ConsumerAccountStatus>;
    consumerId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deceasedDate?: Maybe<Scalars['DateTimeISO']['output']>;
    dob?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrEnterpriseId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    emergencyContactFirstName?: Maybe<Scalars['String']['output']>;
    emergencyContactLastName?: Maybe<Scalars['String']['output']>;
    emergencyContactPhone?: Maybe<Scalars['String']['output']>;
    emergencyContactRelationship?: Maybe<EmergencyContactRelationship>;
    employmentStatus?: Maybe<EmploymentStatus>;
    enrolledInAthena?: Maybe<Scalars['Boolean']['output']>;
    ethnicity?: Maybe<Ethnicity>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maritalStatus?: Maybe<MaritalStatus>;
    operation?: Maybe<Scalars['String']['output']>;
    pcpEhrId?: Maybe<Scalars['String']['output']>;
    pcpFirstName?: Maybe<Scalars['String']['output']>;
    pcpLastName?: Maybe<Scalars['String']['output']>;
    pcpPhone?: Maybe<Scalars['String']['output']>;
    pharmacyEhrId?: Maybe<Scalars['String']['output']>;
    pharmacyName?: Maybe<Scalars['String']['output']>;
    pharmacyNcpdpId?: Maybe<Scalars['String']['output']>;
    pharmacyPhone?: Maybe<Scalars['String']['output']>;
    preferredFirstName?: Maybe<Scalars['String']['output']>;
    preferredLanguage?: Maybe<LanguageCode>;
    preferredLastName?: Maybe<Scalars['String']['output']>;
    referralSource?: Maybe<Scalars['String']['output']>;
    referralSourceDetail?: Maybe<Scalars['String']['output']>;
    referralSourceId?: Maybe<Scalars['String']['output']>;
    sex?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type ConsumerAuditLogMaxOrderByAggregateInput = {
    addressLine2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    consumerAccountStatus?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deceasedDate?: InputMaybe<SortOrder>;
    dob?: InputMaybe<SortOrder>;
    ehrEnterpriseId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    emergencyContactFirstName?: InputMaybe<SortOrder>;
    emergencyContactLastName?: InputMaybe<SortOrder>;
    emergencyContactPhone?: InputMaybe<SortOrder>;
    emergencyContactRelationship?: InputMaybe<SortOrder>;
    employmentStatus?: InputMaybe<SortOrder>;
    enrolledInAthena?: InputMaybe<SortOrder>;
    ethnicity?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    maritalStatus?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    pcpEhrId?: InputMaybe<SortOrder>;
    pcpFirstName?: InputMaybe<SortOrder>;
    pcpLastName?: InputMaybe<SortOrder>;
    pcpPhone?: InputMaybe<SortOrder>;
    pharmacyEhrId?: InputMaybe<SortOrder>;
    pharmacyName?: InputMaybe<SortOrder>;
    pharmacyNcpdpId?: InputMaybe<SortOrder>;
    pharmacyPhone?: InputMaybe<SortOrder>;
    preferredFirstName?: InputMaybe<SortOrder>;
    preferredLanguage?: InputMaybe<SortOrder>;
    preferredLastName?: InputMaybe<SortOrder>;
    referralSource?: InputMaybe<SortOrder>;
    referralSourceDetail?: InputMaybe<SortOrder>;
    referralSourceId?: InputMaybe<SortOrder>;
    sex?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    streetAddress?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type ConsumerAuditLogMinAggregate = {
    __typename?: 'ConsumerAuditLogMinAggregate';
    addressLine2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    consumerAccountStatus?: Maybe<ConsumerAccountStatus>;
    consumerId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deceasedDate?: Maybe<Scalars['DateTimeISO']['output']>;
    dob?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrEnterpriseId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    emergencyContactFirstName?: Maybe<Scalars['String']['output']>;
    emergencyContactLastName?: Maybe<Scalars['String']['output']>;
    emergencyContactPhone?: Maybe<Scalars['String']['output']>;
    emergencyContactRelationship?: Maybe<EmergencyContactRelationship>;
    employmentStatus?: Maybe<EmploymentStatus>;
    enrolledInAthena?: Maybe<Scalars['Boolean']['output']>;
    ethnicity?: Maybe<Ethnicity>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maritalStatus?: Maybe<MaritalStatus>;
    operation?: Maybe<Scalars['String']['output']>;
    pcpEhrId?: Maybe<Scalars['String']['output']>;
    pcpFirstName?: Maybe<Scalars['String']['output']>;
    pcpLastName?: Maybe<Scalars['String']['output']>;
    pcpPhone?: Maybe<Scalars['String']['output']>;
    pharmacyEhrId?: Maybe<Scalars['String']['output']>;
    pharmacyName?: Maybe<Scalars['String']['output']>;
    pharmacyNcpdpId?: Maybe<Scalars['String']['output']>;
    pharmacyPhone?: Maybe<Scalars['String']['output']>;
    preferredFirstName?: Maybe<Scalars['String']['output']>;
    preferredLanguage?: Maybe<LanguageCode>;
    preferredLastName?: Maybe<Scalars['String']['output']>;
    referralSource?: Maybe<Scalars['String']['output']>;
    referralSourceDetail?: Maybe<Scalars['String']['output']>;
    referralSourceId?: Maybe<Scalars['String']['output']>;
    sex?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type ConsumerAuditLogMinOrderByAggregateInput = {
    addressLine2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    consumerAccountStatus?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deceasedDate?: InputMaybe<SortOrder>;
    dob?: InputMaybe<SortOrder>;
    ehrEnterpriseId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    emergencyContactFirstName?: InputMaybe<SortOrder>;
    emergencyContactLastName?: InputMaybe<SortOrder>;
    emergencyContactPhone?: InputMaybe<SortOrder>;
    emergencyContactRelationship?: InputMaybe<SortOrder>;
    employmentStatus?: InputMaybe<SortOrder>;
    enrolledInAthena?: InputMaybe<SortOrder>;
    ethnicity?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    maritalStatus?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    pcpEhrId?: InputMaybe<SortOrder>;
    pcpFirstName?: InputMaybe<SortOrder>;
    pcpLastName?: InputMaybe<SortOrder>;
    pcpPhone?: InputMaybe<SortOrder>;
    pharmacyEhrId?: InputMaybe<SortOrder>;
    pharmacyName?: InputMaybe<SortOrder>;
    pharmacyNcpdpId?: InputMaybe<SortOrder>;
    pharmacyPhone?: InputMaybe<SortOrder>;
    preferredFirstName?: InputMaybe<SortOrder>;
    preferredLanguage?: InputMaybe<SortOrder>;
    preferredLastName?: InputMaybe<SortOrder>;
    referralSource?: InputMaybe<SortOrder>;
    referralSourceDetail?: InputMaybe<SortOrder>;
    referralSourceId?: InputMaybe<SortOrder>;
    sex?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    streetAddress?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type ConsumerAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<ConsumerAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<ConsumerAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<ConsumerAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<ConsumerAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<ConsumerAuditLogSumOrderByAggregateInput>;
    addressLine2?: InputMaybe<SortOrderInput>;
    city?: InputMaybe<SortOrderInput>;
    consumerAccountStatus?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    country?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deceasedDate?: InputMaybe<SortOrderInput>;
    dob?: InputMaybe<SortOrderInput>;
    ehrEnterpriseId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrderInput>;
    emergencyContactFirstName?: InputMaybe<SortOrderInput>;
    emergencyContactLastName?: InputMaybe<SortOrderInput>;
    emergencyContactPhone?: InputMaybe<SortOrderInput>;
    emergencyContactRelationship?: InputMaybe<SortOrderInput>;
    employmentStatus?: InputMaybe<SortOrderInput>;
    enrolledInAthena?: InputMaybe<SortOrderInput>;
    ethnicity?: InputMaybe<SortOrderInput>;
    firstName?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    maritalStatus?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    pcpAddress?: InputMaybe<SortOrderInput>;
    pcpEhrId?: InputMaybe<SortOrderInput>;
    pcpFirstName?: InputMaybe<SortOrderInput>;
    pcpLastName?: InputMaybe<SortOrderInput>;
    pcpPhone?: InputMaybe<SortOrderInput>;
    pharmacyAddress?: InputMaybe<SortOrderInput>;
    pharmacyEhrId?: InputMaybe<SortOrderInput>;
    pharmacyName?: InputMaybe<SortOrderInput>;
    pharmacyNcpdpId?: InputMaybe<SortOrderInput>;
    pharmacyPhone?: InputMaybe<SortOrderInput>;
    preferredFirstName?: InputMaybe<SortOrderInput>;
    preferredLanguage?: InputMaybe<SortOrderInput>;
    preferredLastName?: InputMaybe<SortOrderInput>;
    race?: InputMaybe<SortOrder>;
    referralSource?: InputMaybe<SortOrderInput>;
    referralSourceDetail?: InputMaybe<SortOrderInput>;
    referralSourceId?: InputMaybe<SortOrderInput>;
    sex?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    streetAddress?: InputMaybe<SortOrderInput>;
    stripeCustomerId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrderInput>;
    zip?: InputMaybe<SortOrderInput>;
};

export type ConsumerAuditLogOrderByWithRelationInput = {
    addressLine2?: InputMaybe<SortOrderInput>;
    city?: InputMaybe<SortOrderInput>;
    consumerAccountStatus?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    country?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deceasedDate?: InputMaybe<SortOrderInput>;
    dob?: InputMaybe<SortOrderInput>;
    ehrEnterpriseId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrderInput>;
    emergencyContactFirstName?: InputMaybe<SortOrderInput>;
    emergencyContactLastName?: InputMaybe<SortOrderInput>;
    emergencyContactPhone?: InputMaybe<SortOrderInput>;
    emergencyContactRelationship?: InputMaybe<SortOrderInput>;
    employmentStatus?: InputMaybe<SortOrderInput>;
    enrolledInAthena?: InputMaybe<SortOrderInput>;
    ethnicity?: InputMaybe<SortOrderInput>;
    firstName?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    maritalStatus?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    pcpAddress?: InputMaybe<SortOrderInput>;
    pcpEhrId?: InputMaybe<SortOrderInput>;
    pcpFirstName?: InputMaybe<SortOrderInput>;
    pcpLastName?: InputMaybe<SortOrderInput>;
    pcpPhone?: InputMaybe<SortOrderInput>;
    pharmacyAddress?: InputMaybe<SortOrderInput>;
    pharmacyEhrId?: InputMaybe<SortOrderInput>;
    pharmacyName?: InputMaybe<SortOrderInput>;
    pharmacyNcpdpId?: InputMaybe<SortOrderInput>;
    pharmacyPhone?: InputMaybe<SortOrderInput>;
    preferredFirstName?: InputMaybe<SortOrderInput>;
    preferredLanguage?: InputMaybe<SortOrderInput>;
    preferredLastName?: InputMaybe<SortOrderInput>;
    race?: InputMaybe<SortOrder>;
    referralSource?: InputMaybe<SortOrderInput>;
    referralSourceDetail?: InputMaybe<SortOrderInput>;
    referralSourceId?: InputMaybe<SortOrderInput>;
    sex?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    streetAddress?: InputMaybe<SortOrderInput>;
    stripeCustomerId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrderInput>;
    zip?: InputMaybe<SortOrderInput>;
};

export enum ConsumerAuditLogScalarFieldEnum {
    AddressLine2 = 'addressLine2',
    City = 'city',
    ConsumerAccountStatus = 'consumerAccountStatus',
    ConsumerId = 'consumerId',
    Country = 'country',
    CreatedAt = 'createdAt',
    DeceasedDate = 'deceasedDate',
    Dob = 'dob',
    EhrEnterpriseId = 'ehrEnterpriseId',
    EhrPatientId = 'ehrPatientId',
    EmergencyContactFirstName = 'emergencyContactFirstName',
    EmergencyContactLastName = 'emergencyContactLastName',
    EmergencyContactPhone = 'emergencyContactPhone',
    EmergencyContactRelationship = 'emergencyContactRelationship',
    EmploymentStatus = 'employmentStatus',
    EnrolledInAthena = 'enrolledInAthena',
    Ethnicity = 'ethnicity',
    FirstName = 'firstName',
    Id = 'id',
    LastName = 'lastName',
    LastUpdatedBy = 'lastUpdatedBy',
    MaritalStatus = 'maritalStatus',
    Operation = 'operation',
    PcpAddress = 'pcpAddress',
    PcpEhrId = 'pcpEhrId',
    PcpFirstName = 'pcpFirstName',
    PcpLastName = 'pcpLastName',
    PcpPhone = 'pcpPhone',
    PharmacyAddress = 'pharmacyAddress',
    PharmacyEhrId = 'pharmacyEhrId',
    PharmacyName = 'pharmacyName',
    PharmacyNcpdpId = 'pharmacyNcpdpId',
    PharmacyPhone = 'pharmacyPhone',
    PreferredFirstName = 'preferredFirstName',
    PreferredLanguage = 'preferredLanguage',
    PreferredLastName = 'preferredLastName',
    Race = 'race',
    ReferralSource = 'referralSource',
    ReferralSourceDetail = 'referralSourceDetail',
    ReferralSourceId = 'referralSourceId',
    Sex = 'sex',
    State = 'state',
    StreetAddress = 'streetAddress',
    StripeCustomerId = 'stripeCustomerId',
    UpdatedAt = 'updatedAt',
    UserId = 'userId',
    Zip = 'zip',
}

export type ConsumerAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ConsumerAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ConsumerAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ConsumerAuditLogScalarWhereWithAggregatesInput>>;
    addressLine2?: InputMaybe<StringNullableWithAggregatesFilter>;
    city?: InputMaybe<StringNullableWithAggregatesFilter>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    country?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deceasedDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    dob?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    ehrEnterpriseId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPatientId?: InputMaybe<StringNullableWithAggregatesFilter>;
    emergencyContactFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    emergencyContactLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    emergencyContactPhone?: InputMaybe<StringNullableWithAggregatesFilter>;
    emergencyContactRelationship?: InputMaybe<EnumEmergencyContactRelationshipNullableWithAggregatesFilter>;
    employmentStatus?: InputMaybe<EnumEmploymentStatusNullableWithAggregatesFilter>;
    enrolledInAthena?: InputMaybe<BoolNullableWithAggregatesFilter>;
    ethnicity?: InputMaybe<EnumEthnicityNullableWithAggregatesFilter>;
    firstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    maritalStatus?: InputMaybe<EnumMaritalStatusNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringNullableWithAggregatesFilter>;
    pcpAddress?: InputMaybe<JsonNullableWithAggregatesFilter>;
    pcpEhrId?: InputMaybe<StringNullableWithAggregatesFilter>;
    pcpFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    pcpLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    pcpPhone?: InputMaybe<StringNullableWithAggregatesFilter>;
    pharmacyAddress?: InputMaybe<JsonNullableWithAggregatesFilter>;
    pharmacyEhrId?: InputMaybe<StringNullableWithAggregatesFilter>;
    pharmacyName?: InputMaybe<StringNullableWithAggregatesFilter>;
    pharmacyNcpdpId?: InputMaybe<StringNullableWithAggregatesFilter>;
    pharmacyPhone?: InputMaybe<StringNullableWithAggregatesFilter>;
    preferredFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    preferredLanguage?: InputMaybe<EnumLanguageCodeNullableWithAggregatesFilter>;
    preferredLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    race?: InputMaybe<EnumRaceNullableListFilter>;
    referralSource?: InputMaybe<StringNullableWithAggregatesFilter>;
    referralSourceDetail?: InputMaybe<StringNullableWithAggregatesFilter>;
    referralSourceId?: InputMaybe<StringNullableWithAggregatesFilter>;
    sex?: InputMaybe<StringNullableWithAggregatesFilter>;
    state?: InputMaybe<StringNullableWithAggregatesFilter>;
    streetAddress?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeCustomerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    userId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    zip?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ConsumerAuditLogSumAggregate = {
    __typename?: 'ConsumerAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type ConsumerAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ConsumerAuditLogUpdateInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<NullableEnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerAuditLogUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerAuditLogUpdateManyMutationInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<NullableEnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerAuditLogUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerAuditLogUpdateraceInput = {
    push?: InputMaybe<Array<Race>>;
    set?: InputMaybe<Array<Race>>;
};

export type ConsumerAuditLogWhereInput = {
    AND?: InputMaybe<Array<ConsumerAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerAuditLogWhereInput>>;
    OR?: InputMaybe<Array<ConsumerAuditLogWhereInput>>;
    addressLine2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deceasedDate?: InputMaybe<DateTimeNullableFilter>;
    dob?: InputMaybe<DateTimeNullableFilter>;
    ehrEnterpriseId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    emergencyContactFirstName?: InputMaybe<StringNullableFilter>;
    emergencyContactLastName?: InputMaybe<StringNullableFilter>;
    emergencyContactPhone?: InputMaybe<StringNullableFilter>;
    emergencyContactRelationship?: InputMaybe<EnumEmergencyContactRelationshipNullableFilter>;
    employmentStatus?: InputMaybe<EnumEmploymentStatusNullableFilter>;
    enrolledInAthena?: InputMaybe<BoolNullableFilter>;
    ethnicity?: InputMaybe<EnumEthnicityNullableFilter>;
    firstName?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    lastName?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    maritalStatus?: InputMaybe<EnumMaritalStatusNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    pcpAddress?: InputMaybe<JsonNullableFilter>;
    pcpEhrId?: InputMaybe<StringNullableFilter>;
    pcpFirstName?: InputMaybe<StringNullableFilter>;
    pcpLastName?: InputMaybe<StringNullableFilter>;
    pcpPhone?: InputMaybe<StringNullableFilter>;
    pharmacyAddress?: InputMaybe<JsonNullableFilter>;
    pharmacyEhrId?: InputMaybe<StringNullableFilter>;
    pharmacyName?: InputMaybe<StringNullableFilter>;
    pharmacyNcpdpId?: InputMaybe<StringNullableFilter>;
    pharmacyPhone?: InputMaybe<StringNullableFilter>;
    preferredFirstName?: InputMaybe<StringNullableFilter>;
    preferredLanguage?: InputMaybe<EnumLanguageCodeNullableFilter>;
    preferredLastName?: InputMaybe<StringNullableFilter>;
    race?: InputMaybe<EnumRaceNullableListFilter>;
    referralSource?: InputMaybe<StringNullableFilter>;
    referralSourceDetail?: InputMaybe<StringNullableFilter>;
    referralSourceId?: InputMaybe<StringNullableFilter>;
    sex?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    streetAddress?: InputMaybe<StringNullableFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<UuidNullableFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type ConsumerAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<ConsumerAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerAuditLogWhereInput>>;
    OR?: InputMaybe<Array<ConsumerAuditLogWhereInput>>;
    addressLine2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deceasedDate?: InputMaybe<DateTimeNullableFilter>;
    dob?: InputMaybe<DateTimeNullableFilter>;
    ehrEnterpriseId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    emergencyContactFirstName?: InputMaybe<StringNullableFilter>;
    emergencyContactLastName?: InputMaybe<StringNullableFilter>;
    emergencyContactPhone?: InputMaybe<StringNullableFilter>;
    emergencyContactRelationship?: InputMaybe<EnumEmergencyContactRelationshipNullableFilter>;
    employmentStatus?: InputMaybe<EnumEmploymentStatusNullableFilter>;
    enrolledInAthena?: InputMaybe<BoolNullableFilter>;
    ethnicity?: InputMaybe<EnumEthnicityNullableFilter>;
    firstName?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastName?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    maritalStatus?: InputMaybe<EnumMaritalStatusNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    pcpAddress?: InputMaybe<JsonNullableFilter>;
    pcpEhrId?: InputMaybe<StringNullableFilter>;
    pcpFirstName?: InputMaybe<StringNullableFilter>;
    pcpLastName?: InputMaybe<StringNullableFilter>;
    pcpPhone?: InputMaybe<StringNullableFilter>;
    pharmacyAddress?: InputMaybe<JsonNullableFilter>;
    pharmacyEhrId?: InputMaybe<StringNullableFilter>;
    pharmacyName?: InputMaybe<StringNullableFilter>;
    pharmacyNcpdpId?: InputMaybe<StringNullableFilter>;
    pharmacyPhone?: InputMaybe<StringNullableFilter>;
    preferredFirstName?: InputMaybe<StringNullableFilter>;
    preferredLanguage?: InputMaybe<EnumLanguageCodeNullableFilter>;
    preferredLastName?: InputMaybe<StringNullableFilter>;
    race?: InputMaybe<EnumRaceNullableListFilter>;
    referralSource?: InputMaybe<StringNullableFilter>;
    referralSourceDetail?: InputMaybe<StringNullableFilter>;
    referralSourceId?: InputMaybe<StringNullableFilter>;
    sex?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    streetAddress?: InputMaybe<StringNullableFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<UuidNullableFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type ConsumerCount = {
    __typename?: 'ConsumerCount';
    consumerMessages: Scalars['Int']['output'];
    consumerNotes: Scalars['Int']['output'];
    contracts: Scalars['Int']['output'];
    insurances: Scalars['Int']['output'];
    messageNudges: Scalars['Int']['output'];
    messagePayAfter: Scalars['Int']['output'];
    photos: Scalars['Int']['output'];
};

export type ConsumerCountConsumerMessagesArgs = {
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type ConsumerCountConsumerNotesArgs = {
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type ConsumerCountContractsArgs = {
    where?: InputMaybe<ContractWhereInput>;
};

export type ConsumerCountInsurancesArgs = {
    where?: InputMaybe<InsuranceWhereInput>;
};

export type ConsumerCountMessageNudgesArgs = {
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type ConsumerCountMessagePayAfterArgs = {
    where?: InputMaybe<MessagePayAfterWhereInput>;
};

export type ConsumerCountPhotosArgs = {
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type ConsumerCountAggregate = {
    __typename?: 'ConsumerCountAggregate';
    _all: Scalars['Int']['output'];
    addressLine2: Scalars['Int']['output'];
    city: Scalars['Int']['output'];
    consumerAccountStatus: Scalars['Int']['output'];
    country: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deceasedDate: Scalars['Int']['output'];
    dob: Scalars['Int']['output'];
    ehrEnterpriseId: Scalars['Int']['output'];
    ehrPatientId: Scalars['Int']['output'];
    emergencyContactFirstName: Scalars['Int']['output'];
    emergencyContactLastName: Scalars['Int']['output'];
    emergencyContactPhone: Scalars['Int']['output'];
    emergencyContactRelationship: Scalars['Int']['output'];
    employmentStatus: Scalars['Int']['output'];
    enrolledInAthena: Scalars['Int']['output'];
    ethnicity: Scalars['Int']['output'];
    firstname: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    lastname: Scalars['Int']['output'];
    maritalStatus: Scalars['Int']['output'];
    pcpAddress: Scalars['Int']['output'];
    pcpEhrId: Scalars['Int']['output'];
    pcpFirstName: Scalars['Int']['output'];
    pcpLastName: Scalars['Int']['output'];
    pcpPhone: Scalars['Int']['output'];
    pharmacyAddress: Scalars['Int']['output'];
    pharmacyEhrId: Scalars['Int']['output'];
    pharmacyName: Scalars['Int']['output'];
    pharmacyNcpdpId: Scalars['Int']['output'];
    pharmacyPhone: Scalars['Int']['output'];
    preferredFirstName: Scalars['Int']['output'];
    preferredLanguage: Scalars['Int']['output'];
    preferredLastName: Scalars['Int']['output'];
    race: Scalars['Int']['output'];
    referralSource: Scalars['Int']['output'];
    referralSourceDetail: Scalars['Int']['output'];
    referralSourceId: Scalars['Int']['output'];
    sex: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
    streetAddress: Scalars['Int']['output'];
    stripeCustomerId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
    zip: Scalars['Int']['output'];
};

export type ConsumerCountOrderByAggregateInput = {
    addressLine2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    consumerAccountStatus?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deceasedDate?: InputMaybe<SortOrder>;
    dob?: InputMaybe<SortOrder>;
    ehrEnterpriseId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    emergencyContactFirstName?: InputMaybe<SortOrder>;
    emergencyContactLastName?: InputMaybe<SortOrder>;
    emergencyContactPhone?: InputMaybe<SortOrder>;
    emergencyContactRelationship?: InputMaybe<SortOrder>;
    employmentStatus?: InputMaybe<SortOrder>;
    enrolledInAthena?: InputMaybe<SortOrder>;
    ethnicity?: InputMaybe<SortOrder>;
    firstname?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lastname?: InputMaybe<SortOrder>;
    maritalStatus?: InputMaybe<SortOrder>;
    pcpAddress?: InputMaybe<SortOrder>;
    pcpEhrId?: InputMaybe<SortOrder>;
    pcpFirstName?: InputMaybe<SortOrder>;
    pcpLastName?: InputMaybe<SortOrder>;
    pcpPhone?: InputMaybe<SortOrder>;
    pharmacyAddress?: InputMaybe<SortOrder>;
    pharmacyEhrId?: InputMaybe<SortOrder>;
    pharmacyName?: InputMaybe<SortOrder>;
    pharmacyNcpdpId?: InputMaybe<SortOrder>;
    pharmacyPhone?: InputMaybe<SortOrder>;
    preferredFirstName?: InputMaybe<SortOrder>;
    preferredLanguage?: InputMaybe<SortOrder>;
    preferredLastName?: InputMaybe<SortOrder>;
    race?: InputMaybe<SortOrder>;
    referralSource?: InputMaybe<SortOrder>;
    referralSourceDetail?: InputMaybe<SortOrder>;
    referralSourceId?: InputMaybe<SortOrder>;
    sex?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    streetAddress?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type ConsumerCreateInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerMessages?: InputMaybe<ConsumerMessageCreateNestedManyWithoutConsumerInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutConsumerInput>;
    contracts?: InputMaybe<ContractCreateNestedManyWithoutConsumerInput>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    insurances?: InputMaybe<InsuranceCreateNestedManyWithoutConsumerInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterCreateNestedManyWithoutConsumerInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutConsumerInput>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    user: UserCreateNestedOneWithoutConsumersInput;
    userIfPrimaryConsumer?: InputMaybe<UserCreateNestedOneWithoutPrimaryConsumerInput>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateManyInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId: Scalars['String']['input'];
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateManyUserInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateManyUserInputEnvelope = {
    data: Array<ConsumerCreateManyUserInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerCreateNestedManyWithoutUserInput = {
    connect?: InputMaybe<Array<ConsumerWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerCreateOrConnectWithoutUserInput>
    >;
    create?: InputMaybe<Array<ConsumerCreateWithoutUserInput>>;
    createMany?: InputMaybe<ConsumerCreateManyUserInputEnvelope>;
};

export type ConsumerCreateNestedOneWithoutConsumerMessagesInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutConsumerMessagesInput>;
    create?: InputMaybe<ConsumerCreateWithoutConsumerMessagesInput>;
};

export type ConsumerCreateNestedOneWithoutConsumerNotesInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutConsumerNotesInput>;
    create?: InputMaybe<ConsumerCreateWithoutConsumerNotesInput>;
};

export type ConsumerCreateNestedOneWithoutContractsInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutContractsInput>;
    create?: InputMaybe<ConsumerCreateWithoutContractsInput>;
};

export type ConsumerCreateNestedOneWithoutInsurancesInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutInsurancesInput>;
    create?: InputMaybe<ConsumerCreateWithoutInsurancesInput>;
};

export type ConsumerCreateNestedOneWithoutMessageNudgesInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutMessageNudgesInput>;
    create?: InputMaybe<ConsumerCreateWithoutMessageNudgesInput>;
};

export type ConsumerCreateNestedOneWithoutMessagePayAfterInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutMessagePayAfterInput>;
    create?: InputMaybe<ConsumerCreateWithoutMessagePayAfterInput>;
};

export type ConsumerCreateNestedOneWithoutPhotosInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutPhotosInput>;
    create?: InputMaybe<ConsumerCreateWithoutPhotosInput>;
};

export type ConsumerCreateNestedOneWithoutUserIfPrimaryConsumerInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutUserIfPrimaryConsumerInput>;
    create?: InputMaybe<ConsumerCreateWithoutUserIfPrimaryConsumerInput>;
};

export type ConsumerCreateOrConnectWithoutConsumerMessagesInput = {
    create: ConsumerCreateWithoutConsumerMessagesInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerCreateOrConnectWithoutConsumerNotesInput = {
    create: ConsumerCreateWithoutConsumerNotesInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerCreateOrConnectWithoutContractsInput = {
    create: ConsumerCreateWithoutContractsInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerCreateOrConnectWithoutInsurancesInput = {
    create: ConsumerCreateWithoutInsurancesInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerCreateOrConnectWithoutMessageNudgesInput = {
    create: ConsumerCreateWithoutMessageNudgesInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerCreateOrConnectWithoutMessagePayAfterInput = {
    create: ConsumerCreateWithoutMessagePayAfterInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerCreateOrConnectWithoutPhotosInput = {
    create: ConsumerCreateWithoutPhotosInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerCreateOrConnectWithoutUserIfPrimaryConsumerInput = {
    create: ConsumerCreateWithoutUserIfPrimaryConsumerInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerCreateOrConnectWithoutUserInput = {
    create: ConsumerCreateWithoutUserInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerCreateWithoutConsumerMessagesInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutConsumerInput>;
    contracts?: InputMaybe<ContractCreateNestedManyWithoutConsumerInput>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    insurances?: InputMaybe<InsuranceCreateNestedManyWithoutConsumerInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterCreateNestedManyWithoutConsumerInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutConsumerInput>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    user: UserCreateNestedOneWithoutConsumersInput;
    userIfPrimaryConsumer?: InputMaybe<UserCreateNestedOneWithoutPrimaryConsumerInput>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateWithoutConsumerNotesInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerMessages?: InputMaybe<ConsumerMessageCreateNestedManyWithoutConsumerInput>;
    contracts?: InputMaybe<ContractCreateNestedManyWithoutConsumerInput>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    insurances?: InputMaybe<InsuranceCreateNestedManyWithoutConsumerInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterCreateNestedManyWithoutConsumerInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutConsumerInput>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    user: UserCreateNestedOneWithoutConsumersInput;
    userIfPrimaryConsumer?: InputMaybe<UserCreateNestedOneWithoutPrimaryConsumerInput>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateWithoutContractsInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerMessages?: InputMaybe<ConsumerMessageCreateNestedManyWithoutConsumerInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutConsumerInput>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    insurances?: InputMaybe<InsuranceCreateNestedManyWithoutConsumerInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterCreateNestedManyWithoutConsumerInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutConsumerInput>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    user: UserCreateNestedOneWithoutConsumersInput;
    userIfPrimaryConsumer?: InputMaybe<UserCreateNestedOneWithoutPrimaryConsumerInput>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateWithoutInsurancesInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerMessages?: InputMaybe<ConsumerMessageCreateNestedManyWithoutConsumerInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutConsumerInput>;
    contracts?: InputMaybe<ContractCreateNestedManyWithoutConsumerInput>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterCreateNestedManyWithoutConsumerInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutConsumerInput>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    user: UserCreateNestedOneWithoutConsumersInput;
    userIfPrimaryConsumer?: InputMaybe<UserCreateNestedOneWithoutPrimaryConsumerInput>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateWithoutMessageNudgesInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerMessages?: InputMaybe<ConsumerMessageCreateNestedManyWithoutConsumerInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutConsumerInput>;
    contracts?: InputMaybe<ContractCreateNestedManyWithoutConsumerInput>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    insurances?: InputMaybe<InsuranceCreateNestedManyWithoutConsumerInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    messagePayAfter?: InputMaybe<MessagePayAfterCreateNestedManyWithoutConsumerInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutConsumerInput>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    user: UserCreateNestedOneWithoutConsumersInput;
    userIfPrimaryConsumer?: InputMaybe<UserCreateNestedOneWithoutPrimaryConsumerInput>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateWithoutMessagePayAfterInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerMessages?: InputMaybe<ConsumerMessageCreateNestedManyWithoutConsumerInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutConsumerInput>;
    contracts?: InputMaybe<ContractCreateNestedManyWithoutConsumerInput>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    insurances?: InputMaybe<InsuranceCreateNestedManyWithoutConsumerInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutConsumerInput>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    user: UserCreateNestedOneWithoutConsumersInput;
    userIfPrimaryConsumer?: InputMaybe<UserCreateNestedOneWithoutPrimaryConsumerInput>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateWithoutPhotosInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerMessages?: InputMaybe<ConsumerMessageCreateNestedManyWithoutConsumerInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutConsumerInput>;
    contracts?: InputMaybe<ContractCreateNestedManyWithoutConsumerInput>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    insurances?: InputMaybe<InsuranceCreateNestedManyWithoutConsumerInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterCreateNestedManyWithoutConsumerInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    user: UserCreateNestedOneWithoutConsumersInput;
    userIfPrimaryConsumer?: InputMaybe<UserCreateNestedOneWithoutPrimaryConsumerInput>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateWithoutUserIfPrimaryConsumerInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerMessages?: InputMaybe<ConsumerMessageCreateNestedManyWithoutConsumerInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutConsumerInput>;
    contracts?: InputMaybe<ContractCreateNestedManyWithoutConsumerInput>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    insurances?: InputMaybe<InsuranceCreateNestedManyWithoutConsumerInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterCreateNestedManyWithoutConsumerInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutConsumerInput>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    user: UserCreateNestedOneWithoutConsumersInput;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateWithoutUserInput = {
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    consumerAccountStatus?: InputMaybe<ConsumerAccountStatus>;
    consumerMessages?: InputMaybe<ConsumerMessageCreateNestedManyWithoutConsumerInput>;
    consumerNotes?: InputMaybe<ConsumerNoteCreateNestedManyWithoutConsumerInput>;
    contracts?: InputMaybe<ContractCreateNestedManyWithoutConsumerInput>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deceasedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dob: Scalars['DateTimeISO']['input'];
    ehrEnterpriseId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    emergencyContactFirstName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactLastName?: InputMaybe<Scalars['String']['input']>;
    emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
    emergencyContactRelationship?: InputMaybe<EmergencyContactRelationship>;
    employmentStatus?: InputMaybe<EmploymentStatus>;
    enrolledInAthena?: InputMaybe<Scalars['Boolean']['input']>;
    ethnicity?: InputMaybe<Ethnicity>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    insurances?: InputMaybe<InsuranceCreateNestedManyWithoutConsumerInput>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    maritalStatus?: InputMaybe<MaritalStatus>;
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterCreateNestedManyWithoutConsumerInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<Scalars['String']['input']>;
    pcpFirstName?: InputMaybe<Scalars['String']['input']>;
    pcpLastName?: InputMaybe<Scalars['String']['input']>;
    pcpPhone?: InputMaybe<Scalars['String']['input']>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<Scalars['String']['input']>;
    pharmacyName?: InputMaybe<Scalars['String']['input']>;
    pharmacyNcpdpId?: InputMaybe<Scalars['String']['input']>;
    pharmacyPhone?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutConsumerInput>;
    preferredFirstName?: InputMaybe<Scalars['String']['input']>;
    preferredLanguage?: InputMaybe<LanguageCode>;
    preferredLastName?: InputMaybe<Scalars['String']['input']>;
    race?: InputMaybe<ConsumerCreateraceInput>;
    referralSource?: InputMaybe<Scalars['String']['input']>;
    referralSourceDetail?: InputMaybe<Scalars['String']['input']>;
    referralSourceId?: InputMaybe<Scalars['String']['input']>;
    sex?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    streetAddress?: InputMaybe<Scalars['String']['input']>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userIfPrimaryConsumer?: InputMaybe<UserCreateNestedOneWithoutPrimaryConsumerInput>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerCreateraceInput = {
    set: Array<Race>;
};

export type ConsumerGroupBy = {
    __typename?: 'ConsumerGroupBy';
    _count?: Maybe<ConsumerCountAggregate>;
    _max?: Maybe<ConsumerMaxAggregate>;
    _min?: Maybe<ConsumerMinAggregate>;
    addressLine2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    consumerAccountStatus: ConsumerAccountStatus;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deceasedDate?: Maybe<Scalars['DateTimeISO']['output']>;
    dob: Scalars['DateTimeISO']['output'];
    ehrEnterpriseId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    emergencyContactFirstName?: Maybe<Scalars['String']['output']>;
    emergencyContactLastName?: Maybe<Scalars['String']['output']>;
    emergencyContactPhone?: Maybe<Scalars['String']['output']>;
    emergencyContactRelationship?: Maybe<EmergencyContactRelationship>;
    employmentStatus?: Maybe<EmploymentStatus>;
    enrolledInAthena: Scalars['Boolean']['output'];
    ethnicity?: Maybe<Ethnicity>;
    firstname: Scalars['String']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lastname: Scalars['String']['output'];
    maritalStatus?: Maybe<MaritalStatus>;
    pcpAddress?: Maybe<Scalars['JSON']['output']>;
    pcpEhrId?: Maybe<Scalars['String']['output']>;
    pcpFirstName?: Maybe<Scalars['String']['output']>;
    pcpLastName?: Maybe<Scalars['String']['output']>;
    pcpPhone?: Maybe<Scalars['String']['output']>;
    pharmacyAddress?: Maybe<Scalars['JSON']['output']>;
    pharmacyEhrId?: Maybe<Scalars['String']['output']>;
    pharmacyName?: Maybe<Scalars['String']['output']>;
    pharmacyNcpdpId?: Maybe<Scalars['String']['output']>;
    pharmacyPhone?: Maybe<Scalars['String']['output']>;
    preferredFirstName?: Maybe<Scalars['String']['output']>;
    preferredLanguage?: Maybe<LanguageCode>;
    preferredLastName?: Maybe<Scalars['String']['output']>;
    race?: Maybe<Array<Race>>;
    referralSource?: Maybe<Scalars['String']['output']>;
    referralSourceDetail?: Maybe<Scalars['String']['output']>;
    referralSourceId?: Maybe<Scalars['String']['output']>;
    sex?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userId: Scalars['String']['output'];
    zip?: Maybe<Scalars['String']['output']>;
};

export type ConsumerListRelationFilter = {
    every?: InputMaybe<ConsumerWhereInput>;
    none?: InputMaybe<ConsumerWhereInput>;
    some?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerMaxAggregate = {
    __typename?: 'ConsumerMaxAggregate';
    addressLine2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    consumerAccountStatus?: Maybe<ConsumerAccountStatus>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deceasedDate?: Maybe<Scalars['DateTimeISO']['output']>;
    dob?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrEnterpriseId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    emergencyContactFirstName?: Maybe<Scalars['String']['output']>;
    emergencyContactLastName?: Maybe<Scalars['String']['output']>;
    emergencyContactPhone?: Maybe<Scalars['String']['output']>;
    emergencyContactRelationship?: Maybe<EmergencyContactRelationship>;
    employmentStatus?: Maybe<EmploymentStatus>;
    enrolledInAthena?: Maybe<Scalars['Boolean']['output']>;
    ethnicity?: Maybe<Ethnicity>;
    firstname?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lastname?: Maybe<Scalars['String']['output']>;
    maritalStatus?: Maybe<MaritalStatus>;
    pcpEhrId?: Maybe<Scalars['String']['output']>;
    pcpFirstName?: Maybe<Scalars['String']['output']>;
    pcpLastName?: Maybe<Scalars['String']['output']>;
    pcpPhone?: Maybe<Scalars['String']['output']>;
    pharmacyEhrId?: Maybe<Scalars['String']['output']>;
    pharmacyName?: Maybe<Scalars['String']['output']>;
    pharmacyNcpdpId?: Maybe<Scalars['String']['output']>;
    pharmacyPhone?: Maybe<Scalars['String']['output']>;
    preferredFirstName?: Maybe<Scalars['String']['output']>;
    preferredLanguage?: Maybe<LanguageCode>;
    preferredLastName?: Maybe<Scalars['String']['output']>;
    referralSource?: Maybe<Scalars['String']['output']>;
    referralSourceDetail?: Maybe<Scalars['String']['output']>;
    referralSourceId?: Maybe<Scalars['String']['output']>;
    sex?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type ConsumerMaxOrderByAggregateInput = {
    addressLine2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    consumerAccountStatus?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deceasedDate?: InputMaybe<SortOrder>;
    dob?: InputMaybe<SortOrder>;
    ehrEnterpriseId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    emergencyContactFirstName?: InputMaybe<SortOrder>;
    emergencyContactLastName?: InputMaybe<SortOrder>;
    emergencyContactPhone?: InputMaybe<SortOrder>;
    emergencyContactRelationship?: InputMaybe<SortOrder>;
    employmentStatus?: InputMaybe<SortOrder>;
    enrolledInAthena?: InputMaybe<SortOrder>;
    ethnicity?: InputMaybe<SortOrder>;
    firstname?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lastname?: InputMaybe<SortOrder>;
    maritalStatus?: InputMaybe<SortOrder>;
    pcpEhrId?: InputMaybe<SortOrder>;
    pcpFirstName?: InputMaybe<SortOrder>;
    pcpLastName?: InputMaybe<SortOrder>;
    pcpPhone?: InputMaybe<SortOrder>;
    pharmacyEhrId?: InputMaybe<SortOrder>;
    pharmacyName?: InputMaybe<SortOrder>;
    pharmacyNcpdpId?: InputMaybe<SortOrder>;
    pharmacyPhone?: InputMaybe<SortOrder>;
    preferredFirstName?: InputMaybe<SortOrder>;
    preferredLanguage?: InputMaybe<SortOrder>;
    preferredLastName?: InputMaybe<SortOrder>;
    referralSource?: InputMaybe<SortOrder>;
    referralSourceDetail?: InputMaybe<SortOrder>;
    referralSourceId?: InputMaybe<SortOrder>;
    sex?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    streetAddress?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type ConsumerMessage = {
    __typename?: 'ConsumerMessage';
    _count?: Maybe<ConsumerMessageCount>;
    admin?: Maybe<Admin>;
    adminId?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumer?: Maybe<Consumer>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    email?: Maybe<Scalars['String']['output']>;
    emailBatchId?: Maybe<Scalars['String']['output']>;
    emailLastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    emailMessageId?: Maybe<Scalars['String']['output']>;
    emailStatus?: Maybe<MessageStatus>;
    id: Scalars['String']['output'];
    message: Scalars['String']['output'];
    messageNudges: Array<MessageNudge>;
    messageType?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    scheduledAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scheduledFor?: Maybe<Scalars['DateTimeISO']['output']>;
    sendAt?: Maybe<Scalars['DateTimeISO']['output']>;
    sentBy?: Maybe<Scalars['String']['output']>;
    smsLastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    textSid?: Maybe<Scalars['String']['output']>;
    textStatus?: Maybe<MessageStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ConsumerMessageAdminArgs = {
    where?: InputMaybe<AdminWhereInput>;
};

export type ConsumerMessageConsumerArgs = {
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerMessageMessageNudgesArgs = {
    cursor?: InputMaybe<MessageNudgeWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageNudgeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageNudgeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type ConsumerMessageAvgAggregate = {
    __typename?: 'ConsumerMessageAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type ConsumerMessageAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type ConsumerMessageCount = {
    __typename?: 'ConsumerMessageCount';
    messageNudges: Scalars['Int']['output'];
};

export type ConsumerMessageCountMessageNudgesArgs = {
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type ConsumerMessageCountAggregate = {
    __typename?: 'ConsumerMessageCountAggregate';
    _all: Scalars['Int']['output'];
    adminId: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    email: Scalars['Int']['output'];
    emailBatchId: Scalars['Int']['output'];
    emailLastUpdatedAt: Scalars['Int']['output'];
    emailMessageId: Scalars['Int']['output'];
    emailStatus: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    message: Scalars['Int']['output'];
    messageType: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    phone: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    scheduledAt: Scalars['Int']['output'];
    scheduledFor: Scalars['Int']['output'];
    sendAt: Scalars['Int']['output'];
    sentBy: Scalars['Int']['output'];
    smsLastUpdatedAt: Scalars['Int']['output'];
    textSid: Scalars['Int']['output'];
    textStatus: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ConsumerMessageCountOrderByAggregateInput = {
    adminId?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    emailBatchId?: InputMaybe<SortOrder>;
    emailLastUpdatedAt?: InputMaybe<SortOrder>;
    emailMessageId?: InputMaybe<SortOrder>;
    emailStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    message?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    scheduledAt?: InputMaybe<SortOrder>;
    scheduledFor?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrder>;
    sentBy?: InputMaybe<SortOrder>;
    smsLastUpdatedAt?: InputMaybe<SortOrder>;
    textSid?: InputMaybe<SortOrder>;
    textStatus?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ConsumerMessageCreateInput = {
    admin?: InputMaybe<AdminCreateNestedOneWithoutConsumerMessageInput>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumer?: InputMaybe<ConsumerCreateNestedOneWithoutConsumerMessagesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    emailBatchId?: InputMaybe<Scalars['String']['input']>;
    emailLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    emailMessageId?: InputMaybe<Scalars['String']['input']>;
    emailStatus?: InputMaybe<MessageStatus>;
    id?: InputMaybe<Scalars['String']['input']>;
    message: Scalars['String']['input'];
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerMessageInput>;
    messageType?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    scheduledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledFor?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sentBy?: InputMaybe<Scalars['String']['input']>;
    smsLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    textSid?: InputMaybe<Scalars['String']['input']>;
    textStatus?: InputMaybe<MessageStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerMessageCreateManyAdminInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    emailBatchId?: InputMaybe<Scalars['String']['input']>;
    emailLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    emailMessageId?: InputMaybe<Scalars['String']['input']>;
    emailStatus?: InputMaybe<MessageStatus>;
    id?: InputMaybe<Scalars['String']['input']>;
    message: Scalars['String']['input'];
    messageType?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    scheduledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledFor?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sentBy?: InputMaybe<Scalars['String']['input']>;
    smsLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    textSid?: InputMaybe<Scalars['String']['input']>;
    textStatus?: InputMaybe<MessageStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerMessageCreateManyAdminInputEnvelope = {
    data: Array<ConsumerMessageCreateManyAdminInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerMessageCreateManyConsumerInput = {
    adminId?: InputMaybe<Scalars['String']['input']>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    emailBatchId?: InputMaybe<Scalars['String']['input']>;
    emailLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    emailMessageId?: InputMaybe<Scalars['String']['input']>;
    emailStatus?: InputMaybe<MessageStatus>;
    id?: InputMaybe<Scalars['String']['input']>;
    message: Scalars['String']['input'];
    messageType?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    scheduledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledFor?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sentBy?: InputMaybe<Scalars['String']['input']>;
    smsLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    textSid?: InputMaybe<Scalars['String']['input']>;
    textStatus?: InputMaybe<MessageStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerMessageCreateManyConsumerInputEnvelope = {
    data: Array<ConsumerMessageCreateManyConsumerInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerMessageCreateManyInput = {
    adminId?: InputMaybe<Scalars['String']['input']>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    emailBatchId?: InputMaybe<Scalars['String']['input']>;
    emailLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    emailMessageId?: InputMaybe<Scalars['String']['input']>;
    emailStatus?: InputMaybe<MessageStatus>;
    id?: InputMaybe<Scalars['String']['input']>;
    message: Scalars['String']['input'];
    messageType?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    scheduledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledFor?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sentBy?: InputMaybe<Scalars['String']['input']>;
    smsLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    textSid?: InputMaybe<Scalars['String']['input']>;
    textStatus?: InputMaybe<MessageStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerMessageCreateNestedManyWithoutAdminInput = {
    connect?: InputMaybe<Array<ConsumerMessageWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerMessageCreateOrConnectWithoutAdminInput>
    >;
    create?: InputMaybe<Array<ConsumerMessageCreateWithoutAdminInput>>;
    createMany?: InputMaybe<ConsumerMessageCreateManyAdminInputEnvelope>;
};

export type ConsumerMessageCreateNestedManyWithoutConsumerInput = {
    connect?: InputMaybe<Array<ConsumerMessageWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerMessageCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<ConsumerMessageCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<ConsumerMessageCreateManyConsumerInputEnvelope>;
};

export type ConsumerMessageCreateNestedOneWithoutMessageNudgesInput = {
    connect?: InputMaybe<ConsumerMessageWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerMessageCreateOrConnectWithoutMessageNudgesInput>;
    create?: InputMaybe<ConsumerMessageCreateWithoutMessageNudgesInput>;
};

export type ConsumerMessageCreateOrConnectWithoutAdminInput = {
    create: ConsumerMessageCreateWithoutAdminInput;
    where: ConsumerMessageWhereUniqueInput;
};

export type ConsumerMessageCreateOrConnectWithoutConsumerInput = {
    create: ConsumerMessageCreateWithoutConsumerInput;
    where: ConsumerMessageWhereUniqueInput;
};

export type ConsumerMessageCreateOrConnectWithoutMessageNudgesInput = {
    create: ConsumerMessageCreateWithoutMessageNudgesInput;
    where: ConsumerMessageWhereUniqueInput;
};

export type ConsumerMessageCreateWithoutAdminInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumer?: InputMaybe<ConsumerCreateNestedOneWithoutConsumerMessagesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    emailBatchId?: InputMaybe<Scalars['String']['input']>;
    emailLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    emailMessageId?: InputMaybe<Scalars['String']['input']>;
    emailStatus?: InputMaybe<MessageStatus>;
    id?: InputMaybe<Scalars['String']['input']>;
    message: Scalars['String']['input'];
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerMessageInput>;
    messageType?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    scheduledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledFor?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sentBy?: InputMaybe<Scalars['String']['input']>;
    smsLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    textSid?: InputMaybe<Scalars['String']['input']>;
    textStatus?: InputMaybe<MessageStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerMessageCreateWithoutConsumerInput = {
    admin?: InputMaybe<AdminCreateNestedOneWithoutConsumerMessageInput>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    emailBatchId?: InputMaybe<Scalars['String']['input']>;
    emailLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    emailMessageId?: InputMaybe<Scalars['String']['input']>;
    emailStatus?: InputMaybe<MessageStatus>;
    id?: InputMaybe<Scalars['String']['input']>;
    message: Scalars['String']['input'];
    messageNudges?: InputMaybe<MessageNudgeCreateNestedManyWithoutConsumerMessageInput>;
    messageType?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    scheduledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledFor?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sentBy?: InputMaybe<Scalars['String']['input']>;
    smsLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    textSid?: InputMaybe<Scalars['String']['input']>;
    textStatus?: InputMaybe<MessageStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerMessageCreateWithoutMessageNudgesInput = {
    admin?: InputMaybe<AdminCreateNestedOneWithoutConsumerMessageInput>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumer?: InputMaybe<ConsumerCreateNestedOneWithoutConsumerMessagesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    emailBatchId?: InputMaybe<Scalars['String']['input']>;
    emailLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    emailMessageId?: InputMaybe<Scalars['String']['input']>;
    emailStatus?: InputMaybe<MessageStatus>;
    id?: InputMaybe<Scalars['String']['input']>;
    message: Scalars['String']['input'];
    messageType?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    scheduledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledFor?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    sentBy?: InputMaybe<Scalars['String']['input']>;
    smsLastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    textSid?: InputMaybe<Scalars['String']['input']>;
    textStatus?: InputMaybe<MessageStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerMessageGroupBy = {
    __typename?: 'ConsumerMessageGroupBy';
    _avg?: Maybe<ConsumerMessageAvgAggregate>;
    _count?: Maybe<ConsumerMessageCountAggregate>;
    _max?: Maybe<ConsumerMessageMaxAggregate>;
    _min?: Maybe<ConsumerMessageMinAggregate>;
    _sum?: Maybe<ConsumerMessageSumAggregate>;
    adminId?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    email?: Maybe<Scalars['String']['output']>;
    emailBatchId?: Maybe<Scalars['String']['output']>;
    emailLastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    emailMessageId?: Maybe<Scalars['String']['output']>;
    emailStatus?: Maybe<MessageStatus>;
    id: Scalars['String']['output'];
    message: Scalars['String']['output'];
    messageType?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    scheduledAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scheduledFor?: Maybe<Scalars['DateTimeISO']['output']>;
    sendAt?: Maybe<Scalars['DateTimeISO']['output']>;
    sentBy?: Maybe<Scalars['String']['output']>;
    smsLastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    textSid?: Maybe<Scalars['String']['output']>;
    textStatus?: Maybe<MessageStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ConsumerMessageListRelationFilter = {
    every?: InputMaybe<ConsumerMessageWhereInput>;
    none?: InputMaybe<ConsumerMessageWhereInput>;
    some?: InputMaybe<ConsumerMessageWhereInput>;
};

export type ConsumerMessageMaxAggregate = {
    __typename?: 'ConsumerMessageMaxAggregate';
    adminId?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    emailBatchId?: Maybe<Scalars['String']['output']>;
    emailLastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    emailMessageId?: Maybe<Scalars['String']['output']>;
    emailStatus?: Maybe<MessageStatus>;
    id?: Maybe<Scalars['String']['output']>;
    message?: Maybe<Scalars['String']['output']>;
    messageType?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    scheduledAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scheduledFor?: Maybe<Scalars['DateTimeISO']['output']>;
    sendAt?: Maybe<Scalars['DateTimeISO']['output']>;
    sentBy?: Maybe<Scalars['String']['output']>;
    smsLastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    textSid?: Maybe<Scalars['String']['output']>;
    textStatus?: Maybe<MessageStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConsumerMessageMaxOrderByAggregateInput = {
    adminId?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    emailBatchId?: InputMaybe<SortOrder>;
    emailLastUpdatedAt?: InputMaybe<SortOrder>;
    emailMessageId?: InputMaybe<SortOrder>;
    emailStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    message?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    scheduledAt?: InputMaybe<SortOrder>;
    scheduledFor?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrder>;
    sentBy?: InputMaybe<SortOrder>;
    smsLastUpdatedAt?: InputMaybe<SortOrder>;
    textSid?: InputMaybe<SortOrder>;
    textStatus?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ConsumerMessageMinAggregate = {
    __typename?: 'ConsumerMessageMinAggregate';
    adminId?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    emailBatchId?: Maybe<Scalars['String']['output']>;
    emailLastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    emailMessageId?: Maybe<Scalars['String']['output']>;
    emailStatus?: Maybe<MessageStatus>;
    id?: Maybe<Scalars['String']['output']>;
    message?: Maybe<Scalars['String']['output']>;
    messageType?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    scheduledAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scheduledFor?: Maybe<Scalars['DateTimeISO']['output']>;
    sendAt?: Maybe<Scalars['DateTimeISO']['output']>;
    sentBy?: Maybe<Scalars['String']['output']>;
    smsLastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    textSid?: Maybe<Scalars['String']['output']>;
    textStatus?: Maybe<MessageStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConsumerMessageMinOrderByAggregateInput = {
    adminId?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    emailBatchId?: InputMaybe<SortOrder>;
    emailLastUpdatedAt?: InputMaybe<SortOrder>;
    emailMessageId?: InputMaybe<SortOrder>;
    emailStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    message?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    scheduledAt?: InputMaybe<SortOrder>;
    scheduledFor?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrder>;
    sentBy?: InputMaybe<SortOrder>;
    smsLastUpdatedAt?: InputMaybe<SortOrder>;
    textSid?: InputMaybe<SortOrder>;
    textStatus?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ConsumerMessageNullableRelationFilter = {
    is?: InputMaybe<ConsumerMessageWhereInput>;
    isNot?: InputMaybe<ConsumerMessageWhereInput>;
};

export type ConsumerMessageOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ConsumerMessageOrderByWithAggregationInput = {
    _avg?: InputMaybe<ConsumerMessageAvgOrderByAggregateInput>;
    _count?: InputMaybe<ConsumerMessageCountOrderByAggregateInput>;
    _max?: InputMaybe<ConsumerMessageMaxOrderByAggregateInput>;
    _min?: InputMaybe<ConsumerMessageMinOrderByAggregateInput>;
    _sum?: InputMaybe<ConsumerMessageSumOrderByAggregateInput>;
    adminId?: InputMaybe<SortOrderInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrderInput>;
    emailBatchId?: InputMaybe<SortOrderInput>;
    emailLastUpdatedAt?: InputMaybe<SortOrderInput>;
    emailMessageId?: InputMaybe<SortOrderInput>;
    emailStatus?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    message?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    phone?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrderInput>;
    scheduledAt?: InputMaybe<SortOrderInput>;
    scheduledFor?: InputMaybe<SortOrderInput>;
    sendAt?: InputMaybe<SortOrderInput>;
    sentBy?: InputMaybe<SortOrderInput>;
    smsLastUpdatedAt?: InputMaybe<SortOrderInput>;
    textSid?: InputMaybe<SortOrderInput>;
    textStatus?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ConsumerMessageOrderByWithRelationInput = {
    admin?: InputMaybe<AdminOrderByWithRelationInput>;
    adminId?: InputMaybe<SortOrderInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    consumer?: InputMaybe<ConsumerOrderByWithRelationInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrderInput>;
    emailBatchId?: InputMaybe<SortOrderInput>;
    emailLastUpdatedAt?: InputMaybe<SortOrderInput>;
    emailMessageId?: InputMaybe<SortOrderInput>;
    emailStatus?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    message?: InputMaybe<SortOrder>;
    messageNudges?: InputMaybe<MessageNudgeOrderByRelationAggregateInput>;
    messageType?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    phone?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrderInput>;
    scheduledAt?: InputMaybe<SortOrderInput>;
    scheduledFor?: InputMaybe<SortOrderInput>;
    sendAt?: InputMaybe<SortOrderInput>;
    sentBy?: InputMaybe<SortOrderInput>;
    smsLastUpdatedAt?: InputMaybe<SortOrderInput>;
    textSid?: InputMaybe<SortOrderInput>;
    textStatus?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum ConsumerMessageScalarFieldEnum {
    AdminId = 'adminId',
    AppointmentId = 'appointmentId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    Email = 'email',
    EmailBatchId = 'emailBatchId',
    EmailLastUpdatedAt = 'emailLastUpdatedAt',
    EmailMessageId = 'emailMessageId',
    EmailStatus = 'emailStatus',
    Id = 'id',
    Message = 'message',
    MessageType = 'messageType',
    OrgId = 'orgId',
    Phone = 'phone',
    PracticeId = 'practiceId',
    ScheduledAt = 'scheduledAt',
    ScheduledFor = 'scheduledFor',
    SendAt = 'sendAt',
    SentBy = 'sentBy',
    SmsLastUpdatedAt = 'smsLastUpdatedAt',
    TextSid = 'textSid',
    TextStatus = 'textStatus',
    UpdatedAt = 'updatedAt',
}

export type ConsumerMessageScalarWhereInput = {
    AND?: InputMaybe<Array<ConsumerMessageScalarWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerMessageScalarWhereInput>>;
    OR?: InputMaybe<Array<ConsumerMessageScalarWhereInput>>;
    adminId?: InputMaybe<UuidNullableFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    email?: InputMaybe<StringNullableFilter>;
    emailBatchId?: InputMaybe<StringNullableFilter>;
    emailLastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    emailMessageId?: InputMaybe<StringNullableFilter>;
    emailStatus?: InputMaybe<EnumMessageStatusNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    message?: InputMaybe<StringFilter>;
    messageType?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    scheduledAt?: InputMaybe<DateTimeNullableFilter>;
    scheduledFor?: InputMaybe<DateTimeNullableFilter>;
    sendAt?: InputMaybe<DateTimeNullableFilter>;
    sentBy?: InputMaybe<StringNullableFilter>;
    smsLastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    textSid?: InputMaybe<StringNullableFilter>;
    textStatus?: InputMaybe<EnumMessageStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ConsumerMessageScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ConsumerMessageScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ConsumerMessageScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ConsumerMessageScalarWhereWithAggregatesInput>>;
    adminId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    appointmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    email?: InputMaybe<StringNullableWithAggregatesFilter>;
    emailBatchId?: InputMaybe<StringNullableWithAggregatesFilter>;
    emailLastUpdatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    emailMessageId?: InputMaybe<StringNullableWithAggregatesFilter>;
    emailStatus?: InputMaybe<EnumMessageStatusNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    message?: InputMaybe<StringWithAggregatesFilter>;
    messageType?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    phone?: InputMaybe<StringNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntNullableWithAggregatesFilter>;
    scheduledAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    scheduledFor?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    sendAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    sentBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    smsLastUpdatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    textSid?: InputMaybe<StringNullableWithAggregatesFilter>;
    textStatus?: InputMaybe<EnumMessageStatusNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ConsumerMessageSumAggregate = {
    __typename?: 'ConsumerMessageSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type ConsumerMessageSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type ConsumerMessageUpdateInput = {
    admin?: InputMaybe<AdminUpdateOneWithoutConsumerMessageNestedInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumer?: InputMaybe<ConsumerUpdateOneWithoutConsumerMessagesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailBatchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailLastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    emailMessageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailStatus?: InputMaybe<NullableEnumMessageStatusFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    message?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerMessageNestedInput>;
    messageType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    scheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    scheduledFor?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    sendAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    smsLastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    textSid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    textStatus?: InputMaybe<NullableEnumMessageStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConsumerMessageUpdateManyMutationInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailBatchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailLastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    emailMessageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailStatus?: InputMaybe<NullableEnumMessageStatusFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    message?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    scheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    scheduledFor?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    sendAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    smsLastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    textSid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    textStatus?: InputMaybe<NullableEnumMessageStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConsumerMessageUpdateManyWithWhereWithoutAdminInput = {
    data: ConsumerMessageUpdateManyMutationInput;
    where: ConsumerMessageScalarWhereInput;
};

export type ConsumerMessageUpdateManyWithWhereWithoutConsumerInput = {
    data: ConsumerMessageUpdateManyMutationInput;
    where: ConsumerMessageScalarWhereInput;
};

export type ConsumerMessageUpdateManyWithoutAdminNestedInput = {
    connect?: InputMaybe<Array<ConsumerMessageWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerMessageCreateOrConnectWithoutAdminInput>
    >;
    create?: InputMaybe<Array<ConsumerMessageCreateWithoutAdminInput>>;
    createMany?: InputMaybe<ConsumerMessageCreateManyAdminInputEnvelope>;
    delete?: InputMaybe<Array<ConsumerMessageWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ConsumerMessageScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ConsumerMessageWhereUniqueInput>>;
    set?: InputMaybe<Array<ConsumerMessageWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ConsumerMessageUpdateWithWhereUniqueWithoutAdminInput>
    >;
    updateMany?: InputMaybe<
        Array<ConsumerMessageUpdateManyWithWhereWithoutAdminInput>
    >;
    upsert?: InputMaybe<
        Array<ConsumerMessageUpsertWithWhereUniqueWithoutAdminInput>
    >;
};

export type ConsumerMessageUpdateManyWithoutConsumerNestedInput = {
    connect?: InputMaybe<Array<ConsumerMessageWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerMessageCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<ConsumerMessageCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<ConsumerMessageCreateManyConsumerInputEnvelope>;
    delete?: InputMaybe<Array<ConsumerMessageWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ConsumerMessageScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ConsumerMessageWhereUniqueInput>>;
    set?: InputMaybe<Array<ConsumerMessageWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ConsumerMessageUpdateWithWhereUniqueWithoutConsumerInput>
    >;
    updateMany?: InputMaybe<
        Array<ConsumerMessageUpdateManyWithWhereWithoutConsumerInput>
    >;
    upsert?: InputMaybe<
        Array<ConsumerMessageUpsertWithWhereUniqueWithoutConsumerInput>
    >;
};

export type ConsumerMessageUpdateOneWithoutMessageNudgesNestedInput = {
    connect?: InputMaybe<ConsumerMessageWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerMessageCreateOrConnectWithoutMessageNudgesInput>;
    create?: InputMaybe<ConsumerMessageCreateWithoutMessageNudgesInput>;
    delete?: InputMaybe<ConsumerMessageWhereInput>;
    disconnect?: InputMaybe<ConsumerMessageWhereInput>;
    update?: InputMaybe<ConsumerMessageUpdateToOneWithWhereWithoutMessageNudgesInput>;
    upsert?: InputMaybe<ConsumerMessageUpsertWithoutMessageNudgesInput>;
};

export type ConsumerMessageUpdateToOneWithWhereWithoutMessageNudgesInput = {
    data: ConsumerMessageUpdateWithoutMessageNudgesInput;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type ConsumerMessageUpdateWithWhereUniqueWithoutAdminInput = {
    data: ConsumerMessageUpdateWithoutAdminInput;
    where: ConsumerMessageWhereUniqueInput;
};

export type ConsumerMessageUpdateWithWhereUniqueWithoutConsumerInput = {
    data: ConsumerMessageUpdateWithoutConsumerInput;
    where: ConsumerMessageWhereUniqueInput;
};

export type ConsumerMessageUpdateWithoutAdminInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumer?: InputMaybe<ConsumerUpdateOneWithoutConsumerMessagesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailBatchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailLastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    emailMessageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailStatus?: InputMaybe<NullableEnumMessageStatusFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    message?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerMessageNestedInput>;
    messageType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    scheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    scheduledFor?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    sendAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    smsLastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    textSid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    textStatus?: InputMaybe<NullableEnumMessageStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConsumerMessageUpdateWithoutConsumerInput = {
    admin?: InputMaybe<AdminUpdateOneWithoutConsumerMessageNestedInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailBatchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailLastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    emailMessageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailStatus?: InputMaybe<NullableEnumMessageStatusFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    message?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerMessageNestedInput>;
    messageType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    scheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    scheduledFor?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    sendAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    smsLastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    textSid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    textStatus?: InputMaybe<NullableEnumMessageStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConsumerMessageUpdateWithoutMessageNudgesInput = {
    admin?: InputMaybe<AdminUpdateOneWithoutConsumerMessageNestedInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumer?: InputMaybe<ConsumerUpdateOneWithoutConsumerMessagesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailBatchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailLastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    emailMessageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emailStatus?: InputMaybe<NullableEnumMessageStatusFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    message?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    scheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    scheduledFor?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    sendAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    smsLastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    textSid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    textStatus?: InputMaybe<NullableEnumMessageStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConsumerMessageUpsertWithWhereUniqueWithoutAdminInput = {
    create: ConsumerMessageCreateWithoutAdminInput;
    update: ConsumerMessageUpdateWithoutAdminInput;
    where: ConsumerMessageWhereUniqueInput;
};

export type ConsumerMessageUpsertWithWhereUniqueWithoutConsumerInput = {
    create: ConsumerMessageCreateWithoutConsumerInput;
    update: ConsumerMessageUpdateWithoutConsumerInput;
    where: ConsumerMessageWhereUniqueInput;
};

export type ConsumerMessageUpsertWithoutMessageNudgesInput = {
    create: ConsumerMessageCreateWithoutMessageNudgesInput;
    update: ConsumerMessageUpdateWithoutMessageNudgesInput;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type ConsumerMessageWhereInput = {
    AND?: InputMaybe<Array<ConsumerMessageWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerMessageWhereInput>>;
    OR?: InputMaybe<Array<ConsumerMessageWhereInput>>;
    admin?: InputMaybe<AdminNullableRelationFilter>;
    adminId?: InputMaybe<UuidNullableFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    consumer?: InputMaybe<ConsumerNullableRelationFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    email?: InputMaybe<StringNullableFilter>;
    emailBatchId?: InputMaybe<StringNullableFilter>;
    emailLastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    emailMessageId?: InputMaybe<StringNullableFilter>;
    emailStatus?: InputMaybe<EnumMessageStatusNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    message?: InputMaybe<StringFilter>;
    messageNudges?: InputMaybe<MessageNudgeListRelationFilter>;
    messageType?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    scheduledAt?: InputMaybe<DateTimeNullableFilter>;
    scheduledFor?: InputMaybe<DateTimeNullableFilter>;
    sendAt?: InputMaybe<DateTimeNullableFilter>;
    sentBy?: InputMaybe<StringNullableFilter>;
    smsLastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    textSid?: InputMaybe<StringNullableFilter>;
    textStatus?: InputMaybe<EnumMessageStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ConsumerMessageWhereUniqueInput = {
    AND?: InputMaybe<Array<ConsumerMessageWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerMessageWhereInput>>;
    OR?: InputMaybe<Array<ConsumerMessageWhereInput>>;
    admin?: InputMaybe<AdminNullableRelationFilter>;
    adminId?: InputMaybe<UuidNullableFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    consumer?: InputMaybe<ConsumerNullableRelationFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    email?: InputMaybe<StringNullableFilter>;
    emailBatchId?: InputMaybe<StringNullableFilter>;
    emailLastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    emailMessageId?: InputMaybe<StringNullableFilter>;
    emailStatus?: InputMaybe<EnumMessageStatusNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    message?: InputMaybe<StringFilter>;
    messageNudges?: InputMaybe<MessageNudgeListRelationFilter>;
    messageType?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    scheduledAt?: InputMaybe<DateTimeNullableFilter>;
    scheduledFor?: InputMaybe<DateTimeNullableFilter>;
    sendAt?: InputMaybe<DateTimeNullableFilter>;
    sentBy?: InputMaybe<StringNullableFilter>;
    smsLastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    textSid?: InputMaybe<StringNullableFilter>;
    textStatus?: InputMaybe<EnumMessageStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ConsumerMinAggregate = {
    __typename?: 'ConsumerMinAggregate';
    addressLine2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    consumerAccountStatus?: Maybe<ConsumerAccountStatus>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deceasedDate?: Maybe<Scalars['DateTimeISO']['output']>;
    dob?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrEnterpriseId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    emergencyContactFirstName?: Maybe<Scalars['String']['output']>;
    emergencyContactLastName?: Maybe<Scalars['String']['output']>;
    emergencyContactPhone?: Maybe<Scalars['String']['output']>;
    emergencyContactRelationship?: Maybe<EmergencyContactRelationship>;
    employmentStatus?: Maybe<EmploymentStatus>;
    enrolledInAthena?: Maybe<Scalars['Boolean']['output']>;
    ethnicity?: Maybe<Ethnicity>;
    firstname?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lastname?: Maybe<Scalars['String']['output']>;
    maritalStatus?: Maybe<MaritalStatus>;
    pcpEhrId?: Maybe<Scalars['String']['output']>;
    pcpFirstName?: Maybe<Scalars['String']['output']>;
    pcpLastName?: Maybe<Scalars['String']['output']>;
    pcpPhone?: Maybe<Scalars['String']['output']>;
    pharmacyEhrId?: Maybe<Scalars['String']['output']>;
    pharmacyName?: Maybe<Scalars['String']['output']>;
    pharmacyNcpdpId?: Maybe<Scalars['String']['output']>;
    pharmacyPhone?: Maybe<Scalars['String']['output']>;
    preferredFirstName?: Maybe<Scalars['String']['output']>;
    preferredLanguage?: Maybe<LanguageCode>;
    preferredLastName?: Maybe<Scalars['String']['output']>;
    referralSource?: Maybe<Scalars['String']['output']>;
    referralSourceDetail?: Maybe<Scalars['String']['output']>;
    referralSourceId?: Maybe<Scalars['String']['output']>;
    sex?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type ConsumerMinOrderByAggregateInput = {
    addressLine2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    consumerAccountStatus?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deceasedDate?: InputMaybe<SortOrder>;
    dob?: InputMaybe<SortOrder>;
    ehrEnterpriseId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    emergencyContactFirstName?: InputMaybe<SortOrder>;
    emergencyContactLastName?: InputMaybe<SortOrder>;
    emergencyContactPhone?: InputMaybe<SortOrder>;
    emergencyContactRelationship?: InputMaybe<SortOrder>;
    employmentStatus?: InputMaybe<SortOrder>;
    enrolledInAthena?: InputMaybe<SortOrder>;
    ethnicity?: InputMaybe<SortOrder>;
    firstname?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lastname?: InputMaybe<SortOrder>;
    maritalStatus?: InputMaybe<SortOrder>;
    pcpEhrId?: InputMaybe<SortOrder>;
    pcpFirstName?: InputMaybe<SortOrder>;
    pcpLastName?: InputMaybe<SortOrder>;
    pcpPhone?: InputMaybe<SortOrder>;
    pharmacyEhrId?: InputMaybe<SortOrder>;
    pharmacyName?: InputMaybe<SortOrder>;
    pharmacyNcpdpId?: InputMaybe<SortOrder>;
    pharmacyPhone?: InputMaybe<SortOrder>;
    preferredFirstName?: InputMaybe<SortOrder>;
    preferredLanguage?: InputMaybe<SortOrder>;
    preferredLastName?: InputMaybe<SortOrder>;
    referralSource?: InputMaybe<SortOrder>;
    referralSourceDetail?: InputMaybe<SortOrder>;
    referralSourceId?: InputMaybe<SortOrder>;
    sex?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    streetAddress?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type ConsumerNote = {
    __typename?: 'ConsumerNote';
    admin: Admin;
    adminId: Scalars['String']['output'];
    consumer: Consumer;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    note: Scalars['String']['output'];
};

export type ConsumerNoteCountAggregate = {
    __typename?: 'ConsumerNoteCountAggregate';
    _all: Scalars['Int']['output'];
    adminId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    note: Scalars['Int']['output'];
};

export type ConsumerNoteCountOrderByAggregateInput = {
    adminId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
};

export type ConsumerNoteCreateInput = {
    admin: AdminCreateNestedOneWithoutConsumerNotesInput;
    consumer: ConsumerCreateNestedOneWithoutConsumerNotesInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    note: Scalars['String']['input'];
};

export type ConsumerNoteCreateManyAdminInput = {
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    note: Scalars['String']['input'];
};

export type ConsumerNoteCreateManyAdminInputEnvelope = {
    data: Array<ConsumerNoteCreateManyAdminInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerNoteCreateManyConsumerInput = {
    adminId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    note: Scalars['String']['input'];
};

export type ConsumerNoteCreateManyConsumerInputEnvelope = {
    data: Array<ConsumerNoteCreateManyConsumerInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerNoteCreateManyInput = {
    adminId: Scalars['String']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    note: Scalars['String']['input'];
};

export type ConsumerNoteCreateNestedManyWithoutAdminInput = {
    connect?: InputMaybe<Array<ConsumerNoteWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerNoteCreateOrConnectWithoutAdminInput>
    >;
    create?: InputMaybe<Array<ConsumerNoteCreateWithoutAdminInput>>;
    createMany?: InputMaybe<ConsumerNoteCreateManyAdminInputEnvelope>;
};

export type ConsumerNoteCreateNestedManyWithoutConsumerInput = {
    connect?: InputMaybe<Array<ConsumerNoteWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerNoteCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<ConsumerNoteCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<ConsumerNoteCreateManyConsumerInputEnvelope>;
};

export type ConsumerNoteCreateOrConnectWithoutAdminInput = {
    create: ConsumerNoteCreateWithoutAdminInput;
    where: ConsumerNoteWhereUniqueInput;
};

export type ConsumerNoteCreateOrConnectWithoutConsumerInput = {
    create: ConsumerNoteCreateWithoutConsumerInput;
    where: ConsumerNoteWhereUniqueInput;
};

export type ConsumerNoteCreateWithoutAdminInput = {
    consumer: ConsumerCreateNestedOneWithoutConsumerNotesInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    note: Scalars['String']['input'];
};

export type ConsumerNoteCreateWithoutConsumerInput = {
    admin: AdminCreateNestedOneWithoutConsumerNotesInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    note: Scalars['String']['input'];
};

export type ConsumerNoteGroupBy = {
    __typename?: 'ConsumerNoteGroupBy';
    _count?: Maybe<ConsumerNoteCountAggregate>;
    _max?: Maybe<ConsumerNoteMaxAggregate>;
    _min?: Maybe<ConsumerNoteMinAggregate>;
    adminId: Scalars['String']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    note: Scalars['String']['output'];
};

export type ConsumerNoteListRelationFilter = {
    every?: InputMaybe<ConsumerNoteWhereInput>;
    none?: InputMaybe<ConsumerNoteWhereInput>;
    some?: InputMaybe<ConsumerNoteWhereInput>;
};

export type ConsumerNoteMaxAggregate = {
    __typename?: 'ConsumerNoteMaxAggregate';
    adminId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
};

export type ConsumerNoteMaxOrderByAggregateInput = {
    adminId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
};

export type ConsumerNoteMinAggregate = {
    __typename?: 'ConsumerNoteMinAggregate';
    adminId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
};

export type ConsumerNoteMinOrderByAggregateInput = {
    adminId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
};

export type ConsumerNoteOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ConsumerNoteOrderByWithAggregationInput = {
    _count?: InputMaybe<ConsumerNoteCountOrderByAggregateInput>;
    _max?: InputMaybe<ConsumerNoteMaxOrderByAggregateInput>;
    _min?: InputMaybe<ConsumerNoteMinOrderByAggregateInput>;
    adminId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
};

export type ConsumerNoteOrderByWithRelationInput = {
    admin?: InputMaybe<AdminOrderByWithRelationInput>;
    adminId?: InputMaybe<SortOrder>;
    consumer?: InputMaybe<ConsumerOrderByWithRelationInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
};

export enum ConsumerNoteScalarFieldEnum {
    AdminId = 'adminId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    Id = 'id',
    Note = 'note',
}

export type ConsumerNoteScalarWhereInput = {
    AND?: InputMaybe<Array<ConsumerNoteScalarWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerNoteScalarWhereInput>>;
    OR?: InputMaybe<Array<ConsumerNoteScalarWhereInput>>;
    adminId?: InputMaybe<UuidFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    note?: InputMaybe<StringFilter>;
};

export type ConsumerNoteScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ConsumerNoteScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ConsumerNoteScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ConsumerNoteScalarWhereWithAggregatesInput>>;
    adminId?: InputMaybe<UuidWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    note?: InputMaybe<StringWithAggregatesFilter>;
};

export type ConsumerNoteUpdateInput = {
    admin?: InputMaybe<AdminUpdateOneRequiredWithoutConsumerNotesNestedInput>;
    consumer?: InputMaybe<ConsumerUpdateOneRequiredWithoutConsumerNotesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    note?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ConsumerNoteUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    note?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ConsumerNoteUpdateManyWithWhereWithoutAdminInput = {
    data: ConsumerNoteUpdateManyMutationInput;
    where: ConsumerNoteScalarWhereInput;
};

export type ConsumerNoteUpdateManyWithWhereWithoutConsumerInput = {
    data: ConsumerNoteUpdateManyMutationInput;
    where: ConsumerNoteScalarWhereInput;
};

export type ConsumerNoteUpdateManyWithoutAdminNestedInput = {
    connect?: InputMaybe<Array<ConsumerNoteWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerNoteCreateOrConnectWithoutAdminInput>
    >;
    create?: InputMaybe<Array<ConsumerNoteCreateWithoutAdminInput>>;
    createMany?: InputMaybe<ConsumerNoteCreateManyAdminInputEnvelope>;
    delete?: InputMaybe<Array<ConsumerNoteWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ConsumerNoteScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ConsumerNoteWhereUniqueInput>>;
    set?: InputMaybe<Array<ConsumerNoteWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ConsumerNoteUpdateWithWhereUniqueWithoutAdminInput>
    >;
    updateMany?: InputMaybe<
        Array<ConsumerNoteUpdateManyWithWhereWithoutAdminInput>
    >;
    upsert?: InputMaybe<
        Array<ConsumerNoteUpsertWithWhereUniqueWithoutAdminInput>
    >;
};

export type ConsumerNoteUpdateManyWithoutConsumerNestedInput = {
    connect?: InputMaybe<Array<ConsumerNoteWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerNoteCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<ConsumerNoteCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<ConsumerNoteCreateManyConsumerInputEnvelope>;
    delete?: InputMaybe<Array<ConsumerNoteWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ConsumerNoteScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ConsumerNoteWhereUniqueInput>>;
    set?: InputMaybe<Array<ConsumerNoteWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ConsumerNoteUpdateWithWhereUniqueWithoutConsumerInput>
    >;
    updateMany?: InputMaybe<
        Array<ConsumerNoteUpdateManyWithWhereWithoutConsumerInput>
    >;
    upsert?: InputMaybe<
        Array<ConsumerNoteUpsertWithWhereUniqueWithoutConsumerInput>
    >;
};

export type ConsumerNoteUpdateWithWhereUniqueWithoutAdminInput = {
    data: ConsumerNoteUpdateWithoutAdminInput;
    where: ConsumerNoteWhereUniqueInput;
};

export type ConsumerNoteUpdateWithWhereUniqueWithoutConsumerInput = {
    data: ConsumerNoteUpdateWithoutConsumerInput;
    where: ConsumerNoteWhereUniqueInput;
};

export type ConsumerNoteUpdateWithoutAdminInput = {
    consumer?: InputMaybe<ConsumerUpdateOneRequiredWithoutConsumerNotesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    note?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ConsumerNoteUpdateWithoutConsumerInput = {
    admin?: InputMaybe<AdminUpdateOneRequiredWithoutConsumerNotesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    note?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ConsumerNoteUpsertWithWhereUniqueWithoutAdminInput = {
    create: ConsumerNoteCreateWithoutAdminInput;
    update: ConsumerNoteUpdateWithoutAdminInput;
    where: ConsumerNoteWhereUniqueInput;
};

export type ConsumerNoteUpsertWithWhereUniqueWithoutConsumerInput = {
    create: ConsumerNoteCreateWithoutConsumerInput;
    update: ConsumerNoteUpdateWithoutConsumerInput;
    where: ConsumerNoteWhereUniqueInput;
};

export type ConsumerNoteWhereInput = {
    AND?: InputMaybe<Array<ConsumerNoteWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerNoteWhereInput>>;
    OR?: InputMaybe<Array<ConsumerNoteWhereInput>>;
    admin?: InputMaybe<AdminRelationFilter>;
    adminId?: InputMaybe<UuidFilter>;
    consumer?: InputMaybe<ConsumerRelationFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    note?: InputMaybe<StringFilter>;
};

export type ConsumerNoteWhereUniqueInput = {
    AND?: InputMaybe<Array<ConsumerNoteWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerNoteWhereInput>>;
    OR?: InputMaybe<Array<ConsumerNoteWhereInput>>;
    admin?: InputMaybe<AdminRelationFilter>;
    adminId?: InputMaybe<UuidFilter>;
    consumer?: InputMaybe<ConsumerRelationFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<StringFilter>;
};

export type ConsumerNullableRelationFilter = {
    is?: InputMaybe<ConsumerWhereInput>;
    isNot?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ConsumerOrderByWithAggregationInput = {
    _count?: InputMaybe<ConsumerCountOrderByAggregateInput>;
    _max?: InputMaybe<ConsumerMaxOrderByAggregateInput>;
    _min?: InputMaybe<ConsumerMinOrderByAggregateInput>;
    addressLine2?: InputMaybe<SortOrderInput>;
    city?: InputMaybe<SortOrderInput>;
    consumerAccountStatus?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deceasedDate?: InputMaybe<SortOrderInput>;
    dob?: InputMaybe<SortOrder>;
    ehrEnterpriseId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrderInput>;
    emergencyContactFirstName?: InputMaybe<SortOrderInput>;
    emergencyContactLastName?: InputMaybe<SortOrderInput>;
    emergencyContactPhone?: InputMaybe<SortOrderInput>;
    emergencyContactRelationship?: InputMaybe<SortOrderInput>;
    employmentStatus?: InputMaybe<SortOrderInput>;
    enrolledInAthena?: InputMaybe<SortOrder>;
    ethnicity?: InputMaybe<SortOrderInput>;
    firstname?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    lastname?: InputMaybe<SortOrder>;
    maritalStatus?: InputMaybe<SortOrderInput>;
    pcpAddress?: InputMaybe<SortOrderInput>;
    pcpEhrId?: InputMaybe<SortOrderInput>;
    pcpFirstName?: InputMaybe<SortOrderInput>;
    pcpLastName?: InputMaybe<SortOrderInput>;
    pcpPhone?: InputMaybe<SortOrderInput>;
    pharmacyAddress?: InputMaybe<SortOrderInput>;
    pharmacyEhrId?: InputMaybe<SortOrderInput>;
    pharmacyName?: InputMaybe<SortOrderInput>;
    pharmacyNcpdpId?: InputMaybe<SortOrderInput>;
    pharmacyPhone?: InputMaybe<SortOrderInput>;
    preferredFirstName?: InputMaybe<SortOrderInput>;
    preferredLanguage?: InputMaybe<SortOrderInput>;
    preferredLastName?: InputMaybe<SortOrderInput>;
    race?: InputMaybe<SortOrder>;
    referralSource?: InputMaybe<SortOrderInput>;
    referralSourceDetail?: InputMaybe<SortOrderInput>;
    referralSourceId?: InputMaybe<SortOrderInput>;
    sex?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    streetAddress?: InputMaybe<SortOrderInput>;
    stripeCustomerId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrderInput>;
};

export type ConsumerOrderByWithRelationInput = {
    addressLine2?: InputMaybe<SortOrderInput>;
    city?: InputMaybe<SortOrderInput>;
    consumerAccountStatus?: InputMaybe<SortOrder>;
    consumerMessages?: InputMaybe<ConsumerMessageOrderByRelationAggregateInput>;
    consumerNotes?: InputMaybe<ConsumerNoteOrderByRelationAggregateInput>;
    contracts?: InputMaybe<ContractOrderByRelationAggregateInput>;
    country?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deceasedDate?: InputMaybe<SortOrderInput>;
    dob?: InputMaybe<SortOrder>;
    ehrEnterpriseId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrderInput>;
    emergencyContactFirstName?: InputMaybe<SortOrderInput>;
    emergencyContactLastName?: InputMaybe<SortOrderInput>;
    emergencyContactPhone?: InputMaybe<SortOrderInput>;
    emergencyContactRelationship?: InputMaybe<SortOrderInput>;
    employmentStatus?: InputMaybe<SortOrderInput>;
    enrolledInAthena?: InputMaybe<SortOrder>;
    ethnicity?: InputMaybe<SortOrderInput>;
    firstname?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insurances?: InputMaybe<InsuranceOrderByRelationAggregateInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    lastname?: InputMaybe<SortOrder>;
    maritalStatus?: InputMaybe<SortOrderInput>;
    messageNudges?: InputMaybe<MessageNudgeOrderByRelationAggregateInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterOrderByRelationAggregateInput>;
    pcpAddress?: InputMaybe<SortOrderInput>;
    pcpEhrId?: InputMaybe<SortOrderInput>;
    pcpFirstName?: InputMaybe<SortOrderInput>;
    pcpLastName?: InputMaybe<SortOrderInput>;
    pcpPhone?: InputMaybe<SortOrderInput>;
    pharmacyAddress?: InputMaybe<SortOrderInput>;
    pharmacyEhrId?: InputMaybe<SortOrderInput>;
    pharmacyName?: InputMaybe<SortOrderInput>;
    pharmacyNcpdpId?: InputMaybe<SortOrderInput>;
    pharmacyPhone?: InputMaybe<SortOrderInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataOrderByRelationAggregateInput>;
    preferredFirstName?: InputMaybe<SortOrderInput>;
    preferredLanguage?: InputMaybe<SortOrderInput>;
    preferredLastName?: InputMaybe<SortOrderInput>;
    race?: InputMaybe<SortOrder>;
    referralSource?: InputMaybe<SortOrderInput>;
    referralSourceDetail?: InputMaybe<SortOrderInput>;
    referralSourceId?: InputMaybe<SortOrderInput>;
    sex?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    streetAddress?: InputMaybe<SortOrderInput>;
    stripeCustomerId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    user?: InputMaybe<UserOrderByWithRelationInput>;
    userId?: InputMaybe<SortOrder>;
    userIfPrimaryConsumer?: InputMaybe<UserOrderByWithRelationInput>;
    zip?: InputMaybe<SortOrderInput>;
};

export type ConsumerPhotoMetaData = {
    __typename?: 'ConsumerPhotoMetaData';
    associatedPhotoId?: Maybe<Scalars['String']['output']>;
    consumer: Consumer;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    insurance?: Maybe<Insurance>;
    label?: Maybe<Scalars['String']['output']>;
    linkedInsuranceId?: Maybe<Scalars['String']['output']>;
    ocrMetadata?: Maybe<Scalars['JSON']['output']>;
    orgId: Scalars['Int']['output'];
    s3Link?: Maybe<Scalars['String']['output']>;
    status: PhotoStatus;
    type: PhotoType;
    uploadedBy?: Maybe<Scalars['String']['output']>;
    uploadedToEhrAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConsumerPhotoMetaDataInsuranceArgs = {
    where?: InputMaybe<InsuranceWhereInput>;
};

export type ConsumerPhotoMetaDataAvgAggregate = {
    __typename?: 'ConsumerPhotoMetaDataAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type ConsumerPhotoMetaDataAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type ConsumerPhotoMetaDataCountAggregate = {
    __typename?: 'ConsumerPhotoMetaDataCountAggregate';
    _all: Scalars['Int']['output'];
    associatedPhotoId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    label: Scalars['Int']['output'];
    linkedInsuranceId: Scalars['Int']['output'];
    ocrMetadata: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    s3Link: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
    uploadedBy: Scalars['Int']['output'];
    uploadedToEhrAt: Scalars['Int']['output'];
};

export type ConsumerPhotoMetaDataCountOrderByAggregateInput = {
    associatedPhotoId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrder>;
    linkedInsuranceId?: InputMaybe<SortOrder>;
    ocrMetadata?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    s3Link?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    uploadedBy?: InputMaybe<SortOrder>;
    uploadedToEhrAt?: InputMaybe<SortOrder>;
};

export type ConsumerPhotoMetaDataCreateInput = {
    associatedPhotoId?: InputMaybe<Scalars['String']['input']>;
    consumer: ConsumerCreateNestedOneWithoutPhotosInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insurance?: InputMaybe<InsuranceCreateNestedOneWithoutPhotosInput>;
    label?: InputMaybe<Scalars['String']['input']>;
    ocrMetadata?: InputMaybe<Scalars['JSON']['input']>;
    orgId: Scalars['Int']['input'];
    s3Link?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PhotoStatus>;
    type?: InputMaybe<PhotoType>;
    uploadedBy?: InputMaybe<Scalars['String']['input']>;
    uploadedToEhrAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerPhotoMetaDataCreateManyConsumerInput = {
    associatedPhotoId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    label?: InputMaybe<Scalars['String']['input']>;
    linkedInsuranceId?: InputMaybe<Scalars['String']['input']>;
    ocrMetadata?: InputMaybe<Scalars['JSON']['input']>;
    orgId: Scalars['Int']['input'];
    s3Link?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PhotoStatus>;
    type?: InputMaybe<PhotoType>;
    uploadedBy?: InputMaybe<Scalars['String']['input']>;
    uploadedToEhrAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerPhotoMetaDataCreateManyConsumerInputEnvelope = {
    data: Array<ConsumerPhotoMetaDataCreateManyConsumerInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerPhotoMetaDataCreateManyInput = {
    associatedPhotoId?: InputMaybe<Scalars['String']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    label?: InputMaybe<Scalars['String']['input']>;
    linkedInsuranceId?: InputMaybe<Scalars['String']['input']>;
    ocrMetadata?: InputMaybe<Scalars['JSON']['input']>;
    orgId: Scalars['Int']['input'];
    s3Link?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PhotoStatus>;
    type?: InputMaybe<PhotoType>;
    uploadedBy?: InputMaybe<Scalars['String']['input']>;
    uploadedToEhrAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerPhotoMetaDataCreateManyInsuranceInput = {
    associatedPhotoId?: InputMaybe<Scalars['String']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    label?: InputMaybe<Scalars['String']['input']>;
    ocrMetadata?: InputMaybe<Scalars['JSON']['input']>;
    orgId: Scalars['Int']['input'];
    s3Link?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PhotoStatus>;
    type?: InputMaybe<PhotoType>;
    uploadedBy?: InputMaybe<Scalars['String']['input']>;
    uploadedToEhrAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerPhotoMetaDataCreateManyInsuranceInputEnvelope = {
    data: Array<ConsumerPhotoMetaDataCreateManyInsuranceInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerPhotoMetaDataCreateNestedManyWithoutConsumerInput = {
    connect?: InputMaybe<Array<ConsumerPhotoMetaDataWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerPhotoMetaDataCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<ConsumerPhotoMetaDataCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<ConsumerPhotoMetaDataCreateManyConsumerInputEnvelope>;
};

export type ConsumerPhotoMetaDataCreateNestedManyWithoutInsuranceInput = {
    connect?: InputMaybe<Array<ConsumerPhotoMetaDataWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerPhotoMetaDataCreateOrConnectWithoutInsuranceInput>
    >;
    create?: InputMaybe<
        Array<ConsumerPhotoMetaDataCreateWithoutInsuranceInput>
    >;
    createMany?: InputMaybe<ConsumerPhotoMetaDataCreateManyInsuranceInputEnvelope>;
};

export type ConsumerPhotoMetaDataCreateOrConnectWithoutConsumerInput = {
    create: ConsumerPhotoMetaDataCreateWithoutConsumerInput;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type ConsumerPhotoMetaDataCreateOrConnectWithoutInsuranceInput = {
    create: ConsumerPhotoMetaDataCreateWithoutInsuranceInput;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type ConsumerPhotoMetaDataCreateWithoutConsumerInput = {
    associatedPhotoId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insurance?: InputMaybe<InsuranceCreateNestedOneWithoutPhotosInput>;
    label?: InputMaybe<Scalars['String']['input']>;
    ocrMetadata?: InputMaybe<Scalars['JSON']['input']>;
    orgId: Scalars['Int']['input'];
    s3Link?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PhotoStatus>;
    type?: InputMaybe<PhotoType>;
    uploadedBy?: InputMaybe<Scalars['String']['input']>;
    uploadedToEhrAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerPhotoMetaDataCreateWithoutInsuranceInput = {
    associatedPhotoId?: InputMaybe<Scalars['String']['input']>;
    consumer: ConsumerCreateNestedOneWithoutPhotosInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    label?: InputMaybe<Scalars['String']['input']>;
    ocrMetadata?: InputMaybe<Scalars['JSON']['input']>;
    orgId: Scalars['Int']['input'];
    s3Link?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PhotoStatus>;
    type?: InputMaybe<PhotoType>;
    uploadedBy?: InputMaybe<Scalars['String']['input']>;
    uploadedToEhrAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConsumerPhotoMetaDataGroupBy = {
    __typename?: 'ConsumerPhotoMetaDataGroupBy';
    _avg?: Maybe<ConsumerPhotoMetaDataAvgAggregate>;
    _count?: Maybe<ConsumerPhotoMetaDataCountAggregate>;
    _max?: Maybe<ConsumerPhotoMetaDataMaxAggregate>;
    _min?: Maybe<ConsumerPhotoMetaDataMinAggregate>;
    _sum?: Maybe<ConsumerPhotoMetaDataSumAggregate>;
    associatedPhotoId?: Maybe<Scalars['String']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    label?: Maybe<Scalars['String']['output']>;
    linkedInsuranceId?: Maybe<Scalars['String']['output']>;
    ocrMetadata?: Maybe<Scalars['JSON']['output']>;
    orgId: Scalars['Int']['output'];
    s3Link?: Maybe<Scalars['String']['output']>;
    status: PhotoStatus;
    type: PhotoType;
    uploadedBy?: Maybe<Scalars['String']['output']>;
    uploadedToEhrAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConsumerPhotoMetaDataListRelationFilter = {
    every?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
    none?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
    some?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type ConsumerPhotoMetaDataMaxAggregate = {
    __typename?: 'ConsumerPhotoMetaDataMaxAggregate';
    associatedPhotoId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    linkedInsuranceId?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    s3Link?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PhotoStatus>;
    type?: Maybe<PhotoType>;
    uploadedBy?: Maybe<Scalars['String']['output']>;
    uploadedToEhrAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConsumerPhotoMetaDataMaxOrderByAggregateInput = {
    associatedPhotoId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrder>;
    linkedInsuranceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    s3Link?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    uploadedBy?: InputMaybe<SortOrder>;
    uploadedToEhrAt?: InputMaybe<SortOrder>;
};

export type ConsumerPhotoMetaDataMinAggregate = {
    __typename?: 'ConsumerPhotoMetaDataMinAggregate';
    associatedPhotoId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    linkedInsuranceId?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    s3Link?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PhotoStatus>;
    type?: Maybe<PhotoType>;
    uploadedBy?: Maybe<Scalars['String']['output']>;
    uploadedToEhrAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConsumerPhotoMetaDataMinOrderByAggregateInput = {
    associatedPhotoId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrder>;
    linkedInsuranceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    s3Link?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    uploadedBy?: InputMaybe<SortOrder>;
    uploadedToEhrAt?: InputMaybe<SortOrder>;
};

export type ConsumerPhotoMetaDataOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ConsumerPhotoMetaDataOrderByWithAggregationInput = {
    _avg?: InputMaybe<ConsumerPhotoMetaDataAvgOrderByAggregateInput>;
    _count?: InputMaybe<ConsumerPhotoMetaDataCountOrderByAggregateInput>;
    _max?: InputMaybe<ConsumerPhotoMetaDataMaxOrderByAggregateInput>;
    _min?: InputMaybe<ConsumerPhotoMetaDataMinOrderByAggregateInput>;
    _sum?: InputMaybe<ConsumerPhotoMetaDataSumOrderByAggregateInput>;
    associatedPhotoId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrderInput>;
    linkedInsuranceId?: InputMaybe<SortOrderInput>;
    ocrMetadata?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    s3Link?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    uploadedBy?: InputMaybe<SortOrderInput>;
    uploadedToEhrAt?: InputMaybe<SortOrderInput>;
};

export type ConsumerPhotoMetaDataOrderByWithRelationInput = {
    associatedPhotoId?: InputMaybe<SortOrderInput>;
    consumer?: InputMaybe<ConsumerOrderByWithRelationInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insurance?: InputMaybe<InsuranceOrderByWithRelationInput>;
    label?: InputMaybe<SortOrderInput>;
    linkedInsuranceId?: InputMaybe<SortOrderInput>;
    ocrMetadata?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    s3Link?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    uploadedBy?: InputMaybe<SortOrderInput>;
    uploadedToEhrAt?: InputMaybe<SortOrderInput>;
};

export enum ConsumerPhotoMetaDataScalarFieldEnum {
    AssociatedPhotoId = 'associatedPhotoId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    Id = 'id',
    Label = 'label',
    LinkedInsuranceId = 'linkedInsuranceId',
    OcrMetadata = 'ocrMetadata',
    OrgId = 'orgId',
    S3Link = 's3Link',
    Status = 'status',
    Type = 'type',
    UploadedBy = 'uploadedBy',
    UploadedToEhrAt = 'uploadedToEhrAt',
}

export type ConsumerPhotoMetaDataScalarWhereInput = {
    AND?: InputMaybe<Array<ConsumerPhotoMetaDataScalarWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerPhotoMetaDataScalarWhereInput>>;
    OR?: InputMaybe<Array<ConsumerPhotoMetaDataScalarWhereInput>>;
    associatedPhotoId?: InputMaybe<UuidNullableFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    label?: InputMaybe<StringNullableFilter>;
    linkedInsuranceId?: InputMaybe<UuidNullableFilter>;
    ocrMetadata?: InputMaybe<JsonNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    s3Link?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumPhotoStatusFilter>;
    type?: InputMaybe<EnumPhotoTypeFilter>;
    uploadedBy?: InputMaybe<StringNullableFilter>;
    uploadedToEhrAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ConsumerPhotoMetaDataScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<ConsumerPhotoMetaDataScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<ConsumerPhotoMetaDataScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<ConsumerPhotoMetaDataScalarWhereWithAggregatesInput>>;
    associatedPhotoId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    label?: InputMaybe<StringNullableWithAggregatesFilter>;
    linkedInsuranceId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    ocrMetadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    s3Link?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumPhotoStatusWithAggregatesFilter>;
    type?: InputMaybe<EnumPhotoTypeWithAggregatesFilter>;
    uploadedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    uploadedToEhrAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type ConsumerPhotoMetaDataSumAggregate = {
    __typename?: 'ConsumerPhotoMetaDataSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type ConsumerPhotoMetaDataSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type ConsumerPhotoMetaDataUpdateInput = {
    associatedPhotoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumer?: InputMaybe<ConsumerUpdateOneRequiredWithoutPhotosNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurance?: InputMaybe<InsuranceUpdateOneWithoutPhotosNestedInput>;
    label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ocrMetadata?: InputMaybe<Scalars['JSON']['input']>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    s3Link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPhotoStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPhotoTypeFieldUpdateOperationsInput>;
    uploadedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    uploadedToEhrAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ConsumerPhotoMetaDataUpdateManyMutationInput = {
    associatedPhotoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ocrMetadata?: InputMaybe<Scalars['JSON']['input']>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    s3Link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPhotoStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPhotoTypeFieldUpdateOperationsInput>;
    uploadedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    uploadedToEhrAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ConsumerPhotoMetaDataUpdateManyWithWhereWithoutConsumerInput = {
    data: ConsumerPhotoMetaDataUpdateManyMutationInput;
    where: ConsumerPhotoMetaDataScalarWhereInput;
};

export type ConsumerPhotoMetaDataUpdateManyWithWhereWithoutInsuranceInput = {
    data: ConsumerPhotoMetaDataUpdateManyMutationInput;
    where: ConsumerPhotoMetaDataScalarWhereInput;
};

export type ConsumerPhotoMetaDataUpdateManyWithoutConsumerNestedInput = {
    connect?: InputMaybe<Array<ConsumerPhotoMetaDataWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerPhotoMetaDataCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<ConsumerPhotoMetaDataCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<ConsumerPhotoMetaDataCreateManyConsumerInputEnvelope>;
    delete?: InputMaybe<Array<ConsumerPhotoMetaDataWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ConsumerPhotoMetaDataScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ConsumerPhotoMetaDataWhereUniqueInput>>;
    set?: InputMaybe<Array<ConsumerPhotoMetaDataWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ConsumerPhotoMetaDataUpdateWithWhereUniqueWithoutConsumerInput>
    >;
    updateMany?: InputMaybe<
        Array<ConsumerPhotoMetaDataUpdateManyWithWhereWithoutConsumerInput>
    >;
    upsert?: InputMaybe<
        Array<ConsumerPhotoMetaDataUpsertWithWhereUniqueWithoutConsumerInput>
    >;
};

export type ConsumerPhotoMetaDataUpdateManyWithoutInsuranceNestedInput = {
    connect?: InputMaybe<Array<ConsumerPhotoMetaDataWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerPhotoMetaDataCreateOrConnectWithoutInsuranceInput>
    >;
    create?: InputMaybe<
        Array<ConsumerPhotoMetaDataCreateWithoutInsuranceInput>
    >;
    createMany?: InputMaybe<ConsumerPhotoMetaDataCreateManyInsuranceInputEnvelope>;
    delete?: InputMaybe<Array<ConsumerPhotoMetaDataWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ConsumerPhotoMetaDataScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ConsumerPhotoMetaDataWhereUniqueInput>>;
    set?: InputMaybe<Array<ConsumerPhotoMetaDataWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ConsumerPhotoMetaDataUpdateWithWhereUniqueWithoutInsuranceInput>
    >;
    updateMany?: InputMaybe<
        Array<ConsumerPhotoMetaDataUpdateManyWithWhereWithoutInsuranceInput>
    >;
    upsert?: InputMaybe<
        Array<ConsumerPhotoMetaDataUpsertWithWhereUniqueWithoutInsuranceInput>
    >;
};

export type ConsumerPhotoMetaDataUpdateWithWhereUniqueWithoutConsumerInput = {
    data: ConsumerPhotoMetaDataUpdateWithoutConsumerInput;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type ConsumerPhotoMetaDataUpdateWithWhereUniqueWithoutInsuranceInput = {
    data: ConsumerPhotoMetaDataUpdateWithoutInsuranceInput;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type ConsumerPhotoMetaDataUpdateWithoutConsumerInput = {
    associatedPhotoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurance?: InputMaybe<InsuranceUpdateOneWithoutPhotosNestedInput>;
    label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ocrMetadata?: InputMaybe<Scalars['JSON']['input']>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    s3Link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPhotoStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPhotoTypeFieldUpdateOperationsInput>;
    uploadedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    uploadedToEhrAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ConsumerPhotoMetaDataUpdateWithoutInsuranceInput = {
    associatedPhotoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumer?: InputMaybe<ConsumerUpdateOneRequiredWithoutPhotosNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ocrMetadata?: InputMaybe<Scalars['JSON']['input']>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    s3Link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPhotoStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPhotoTypeFieldUpdateOperationsInput>;
    uploadedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    uploadedToEhrAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ConsumerPhotoMetaDataUpsertWithWhereUniqueWithoutConsumerInput = {
    create: ConsumerPhotoMetaDataCreateWithoutConsumerInput;
    update: ConsumerPhotoMetaDataUpdateWithoutConsumerInput;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type ConsumerPhotoMetaDataUpsertWithWhereUniqueWithoutInsuranceInput = {
    create: ConsumerPhotoMetaDataCreateWithoutInsuranceInput;
    update: ConsumerPhotoMetaDataUpdateWithoutInsuranceInput;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type ConsumerPhotoMetaDataWhereInput = {
    AND?: InputMaybe<Array<ConsumerPhotoMetaDataWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerPhotoMetaDataWhereInput>>;
    OR?: InputMaybe<Array<ConsumerPhotoMetaDataWhereInput>>;
    associatedPhotoId?: InputMaybe<UuidNullableFilter>;
    consumer?: InputMaybe<ConsumerRelationFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    insurance?: InputMaybe<InsuranceNullableRelationFilter>;
    label?: InputMaybe<StringNullableFilter>;
    linkedInsuranceId?: InputMaybe<UuidNullableFilter>;
    ocrMetadata?: InputMaybe<JsonNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    s3Link?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumPhotoStatusFilter>;
    type?: InputMaybe<EnumPhotoTypeFilter>;
    uploadedBy?: InputMaybe<StringNullableFilter>;
    uploadedToEhrAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ConsumerPhotoMetaDataWhereUniqueInput = {
    AND?: InputMaybe<Array<ConsumerPhotoMetaDataWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerPhotoMetaDataWhereInput>>;
    OR?: InputMaybe<Array<ConsumerPhotoMetaDataWhereInput>>;
    associatedPhotoId?: InputMaybe<UuidNullableFilter>;
    consumer?: InputMaybe<ConsumerRelationFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    insurance?: InputMaybe<InsuranceNullableRelationFilter>;
    label?: InputMaybe<StringNullableFilter>;
    linkedInsuranceId?: InputMaybe<UuidNullableFilter>;
    ocrMetadata?: InputMaybe<JsonNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    s3Link?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumPhotoStatusFilter>;
    type?: InputMaybe<EnumPhotoTypeFilter>;
    uploadedBy?: InputMaybe<StringNullableFilter>;
    uploadedToEhrAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ConsumerRelationFilter = {
    is?: InputMaybe<ConsumerWhereInput>;
    isNot?: InputMaybe<ConsumerWhereInput>;
};

export enum ConsumerScalarFieldEnum {
    AddressLine2 = 'addressLine2',
    City = 'city',
    ConsumerAccountStatus = 'consumerAccountStatus',
    Country = 'country',
    CreatedAt = 'createdAt',
    DeceasedDate = 'deceasedDate',
    Dob = 'dob',
    EhrEnterpriseId = 'ehrEnterpriseId',
    EhrPatientId = 'ehrPatientId',
    EmergencyContactFirstName = 'emergencyContactFirstName',
    EmergencyContactLastName = 'emergencyContactLastName',
    EmergencyContactPhone = 'emergencyContactPhone',
    EmergencyContactRelationship = 'emergencyContactRelationship',
    EmploymentStatus = 'employmentStatus',
    EnrolledInAthena = 'enrolledInAthena',
    Ethnicity = 'ethnicity',
    Firstname = 'firstname',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Lastname = 'lastname',
    MaritalStatus = 'maritalStatus',
    PcpAddress = 'pcpAddress',
    PcpEhrId = 'pcpEhrId',
    PcpFirstName = 'pcpFirstName',
    PcpLastName = 'pcpLastName',
    PcpPhone = 'pcpPhone',
    PharmacyAddress = 'pharmacyAddress',
    PharmacyEhrId = 'pharmacyEhrId',
    PharmacyName = 'pharmacyName',
    PharmacyNcpdpId = 'pharmacyNcpdpId',
    PharmacyPhone = 'pharmacyPhone',
    PreferredFirstName = 'preferredFirstName',
    PreferredLanguage = 'preferredLanguage',
    PreferredLastName = 'preferredLastName',
    Race = 'race',
    ReferralSource = 'referralSource',
    ReferralSourceDetail = 'referralSourceDetail',
    ReferralSourceId = 'referralSourceId',
    Sex = 'sex',
    State = 'state',
    StreetAddress = 'streetAddress',
    StripeCustomerId = 'stripeCustomerId',
    UpdatedAt = 'updatedAt',
    UserId = 'userId',
    Zip = 'zip',
}

export type ConsumerScalarWhereInput = {
    AND?: InputMaybe<Array<ConsumerScalarWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerScalarWhereInput>>;
    OR?: InputMaybe<Array<ConsumerScalarWhereInput>>;
    addressLine2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deceasedDate?: InputMaybe<DateTimeNullableFilter>;
    dob?: InputMaybe<DateTimeFilter>;
    ehrEnterpriseId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    emergencyContactFirstName?: InputMaybe<StringNullableFilter>;
    emergencyContactLastName?: InputMaybe<StringNullableFilter>;
    emergencyContactPhone?: InputMaybe<StringNullableFilter>;
    emergencyContactRelationship?: InputMaybe<EnumEmergencyContactRelationshipNullableFilter>;
    employmentStatus?: InputMaybe<EnumEmploymentStatusNullableFilter>;
    enrolledInAthena?: InputMaybe<BoolFilter>;
    ethnicity?: InputMaybe<EnumEthnicityNullableFilter>;
    firstname?: InputMaybe<StringFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    lastname?: InputMaybe<StringFilter>;
    maritalStatus?: InputMaybe<EnumMaritalStatusNullableFilter>;
    pcpAddress?: InputMaybe<JsonNullableFilter>;
    pcpEhrId?: InputMaybe<StringNullableFilter>;
    pcpFirstName?: InputMaybe<StringNullableFilter>;
    pcpLastName?: InputMaybe<StringNullableFilter>;
    pcpPhone?: InputMaybe<StringNullableFilter>;
    pharmacyAddress?: InputMaybe<JsonNullableFilter>;
    pharmacyEhrId?: InputMaybe<StringNullableFilter>;
    pharmacyName?: InputMaybe<StringNullableFilter>;
    pharmacyNcpdpId?: InputMaybe<StringNullableFilter>;
    pharmacyPhone?: InputMaybe<StringNullableFilter>;
    preferredFirstName?: InputMaybe<StringNullableFilter>;
    preferredLanguage?: InputMaybe<EnumLanguageCodeNullableFilter>;
    preferredLastName?: InputMaybe<StringNullableFilter>;
    race?: InputMaybe<EnumRaceNullableListFilter>;
    referralSource?: InputMaybe<StringNullableFilter>;
    referralSourceDetail?: InputMaybe<StringNullableFilter>;
    referralSourceId?: InputMaybe<StringNullableFilter>;
    sex?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    streetAddress?: InputMaybe<StringNullableFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<UuidFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type ConsumerScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ConsumerScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ConsumerScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ConsumerScalarWhereWithAggregatesInput>>;
    addressLine2?: InputMaybe<StringNullableWithAggregatesFilter>;
    city?: InputMaybe<StringNullableWithAggregatesFilter>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusWithAggregatesFilter>;
    country?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deceasedDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    dob?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrEnterpriseId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPatientId?: InputMaybe<StringNullableWithAggregatesFilter>;
    emergencyContactFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    emergencyContactLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    emergencyContactPhone?: InputMaybe<StringNullableWithAggregatesFilter>;
    emergencyContactRelationship?: InputMaybe<EnumEmergencyContactRelationshipNullableWithAggregatesFilter>;
    employmentStatus?: InputMaybe<EnumEmploymentStatusNullableWithAggregatesFilter>;
    enrolledInAthena?: InputMaybe<BoolWithAggregatesFilter>;
    ethnicity?: InputMaybe<EnumEthnicityNullableWithAggregatesFilter>;
    firstname?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastname?: InputMaybe<StringWithAggregatesFilter>;
    maritalStatus?: InputMaybe<EnumMaritalStatusNullableWithAggregatesFilter>;
    pcpAddress?: InputMaybe<JsonNullableWithAggregatesFilter>;
    pcpEhrId?: InputMaybe<StringNullableWithAggregatesFilter>;
    pcpFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    pcpLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    pcpPhone?: InputMaybe<StringNullableWithAggregatesFilter>;
    pharmacyAddress?: InputMaybe<JsonNullableWithAggregatesFilter>;
    pharmacyEhrId?: InputMaybe<StringNullableWithAggregatesFilter>;
    pharmacyName?: InputMaybe<StringNullableWithAggregatesFilter>;
    pharmacyNcpdpId?: InputMaybe<StringNullableWithAggregatesFilter>;
    pharmacyPhone?: InputMaybe<StringNullableWithAggregatesFilter>;
    preferredFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    preferredLanguage?: InputMaybe<EnumLanguageCodeNullableWithAggregatesFilter>;
    preferredLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    race?: InputMaybe<EnumRaceNullableListFilter>;
    referralSource?: InputMaybe<StringNullableWithAggregatesFilter>;
    referralSourceDetail?: InputMaybe<StringNullableWithAggregatesFilter>;
    referralSourceId?: InputMaybe<StringNullableWithAggregatesFilter>;
    sex?: InputMaybe<StringNullableWithAggregatesFilter>;
    state?: InputMaybe<StringNullableWithAggregatesFilter>;
    streetAddress?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeCustomerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    userId?: InputMaybe<UuidWithAggregatesFilter>;
    zip?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ConsumerSrtRecords = {
    __typename?: 'ConsumerSrtRecords';
    consumerId: Scalars['String']['output'];
    date: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    pricingEntityId: Scalars['String']['output'];
    srtId: Scalars['String']['output'];
};

export type ConsumerSrtRecordsAvgAggregate = {
    __typename?: 'ConsumerSrtRecordsAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type ConsumerSrtRecordsAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ConsumerSrtRecordsCountAggregate = {
    __typename?: 'ConsumerSrtRecordsCountAggregate';
    _all: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    pricingEntityId: Scalars['Int']['output'];
    srtId: Scalars['Int']['output'];
};

export type ConsumerSrtRecordsCountOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingEntityId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type ConsumerSrtRecordsCreateInput = {
    consumerId: Scalars['String']['input'];
    date: Scalars['DateTimeISO']['input'];
    pricingEntityId: Scalars['String']['input'];
    srtId: Scalars['String']['input'];
};

export type ConsumerSrtRecordsCreateManyInput = {
    consumerId: Scalars['String']['input'];
    date: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    pricingEntityId: Scalars['String']['input'];
    srtId: Scalars['String']['input'];
};

export type ConsumerSrtRecordsGroupBy = {
    __typename?: 'ConsumerSrtRecordsGroupBy';
    _avg?: Maybe<ConsumerSrtRecordsAvgAggregate>;
    _count?: Maybe<ConsumerSrtRecordsCountAggregate>;
    _max?: Maybe<ConsumerSrtRecordsMaxAggregate>;
    _min?: Maybe<ConsumerSrtRecordsMinAggregate>;
    _sum?: Maybe<ConsumerSrtRecordsSumAggregate>;
    consumerId: Scalars['String']['output'];
    date: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    pricingEntityId: Scalars['String']['output'];
    srtId: Scalars['String']['output'];
};

export type ConsumerSrtRecordsMaxAggregate = {
    __typename?: 'ConsumerSrtRecordsMaxAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    pricingEntityId?: Maybe<Scalars['String']['output']>;
    srtId?: Maybe<Scalars['String']['output']>;
};

export type ConsumerSrtRecordsMaxOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingEntityId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type ConsumerSrtRecordsMinAggregate = {
    __typename?: 'ConsumerSrtRecordsMinAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    pricingEntityId?: Maybe<Scalars['String']['output']>;
    srtId?: Maybe<Scalars['String']['output']>;
};

export type ConsumerSrtRecordsMinOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingEntityId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type ConsumerSrtRecordsOrderByWithAggregationInput = {
    _avg?: InputMaybe<ConsumerSrtRecordsAvgOrderByAggregateInput>;
    _count?: InputMaybe<ConsumerSrtRecordsCountOrderByAggregateInput>;
    _max?: InputMaybe<ConsumerSrtRecordsMaxOrderByAggregateInput>;
    _min?: InputMaybe<ConsumerSrtRecordsMinOrderByAggregateInput>;
    _sum?: InputMaybe<ConsumerSrtRecordsSumOrderByAggregateInput>;
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingEntityId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type ConsumerSrtRecordsOrderByWithRelationInput = {
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingEntityId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export enum ConsumerSrtRecordsScalarFieldEnum {
    ConsumerId = 'consumerId',
    Date = 'date',
    Id = 'id',
    PricingEntityId = 'pricingEntityId',
    SrtId = 'srtId',
}

export type ConsumerSrtRecordsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ConsumerSrtRecordsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ConsumerSrtRecordsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ConsumerSrtRecordsScalarWhereWithAggregatesInput>>;
    consumerId?: InputMaybe<StringWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    pricingEntityId?: InputMaybe<StringWithAggregatesFilter>;
    srtId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ConsumerSrtRecordsSumAggregate = {
    __typename?: 'ConsumerSrtRecordsSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type ConsumerSrtRecordsSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ConsumerSrtRecordsUpdateInput = {
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    pricingEntityId?: InputMaybe<StringFieldUpdateOperationsInput>;
    srtId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ConsumerSrtRecordsUpdateManyMutationInput = {
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    pricingEntityId?: InputMaybe<StringFieldUpdateOperationsInput>;
    srtId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ConsumerSrtRecordsWhereInput = {
    AND?: InputMaybe<Array<ConsumerSrtRecordsWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerSrtRecordsWhereInput>>;
    OR?: InputMaybe<Array<ConsumerSrtRecordsWhereInput>>;
    consumerId?: InputMaybe<StringFilter>;
    date?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    pricingEntityId?: InputMaybe<StringFilter>;
    srtId?: InputMaybe<StringFilter>;
};

export type ConsumerSrtRecordsWhereUniqueInput = {
    AND?: InputMaybe<Array<ConsumerSrtRecordsWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerSrtRecordsWhereInput>>;
    OR?: InputMaybe<Array<ConsumerSrtRecordsWhereInput>>;
    consumerId?: InputMaybe<StringFilter>;
    date?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    pricingEntityId?: InputMaybe<StringFilter>;
    srtId?: InputMaybe<StringFilter>;
};

export type ConsumerUpdateInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerMessages?: InputMaybe<ConsumerMessageUpdateManyWithoutConsumerNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutConsumerNestedInput>;
    contracts?: InputMaybe<ContractUpdateManyWithoutConsumerNestedInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurances?: InputMaybe<InsuranceUpdateManyWithoutConsumerNestedInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerNestedInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterUpdateManyWithoutConsumerNestedInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutConsumerNestedInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    user?: InputMaybe<UserUpdateOneRequiredWithoutConsumersNestedInput>;
    userIfPrimaryConsumer?: InputMaybe<UserUpdateOneWithoutPrimaryConsumerNestedInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateManyMutationInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateManyWithWhereWithoutUserInput = {
    data: ConsumerUpdateManyMutationInput;
    where: ConsumerScalarWhereInput;
};

export type ConsumerUpdateManyWithoutUserNestedInput = {
    connect?: InputMaybe<Array<ConsumerWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ConsumerCreateOrConnectWithoutUserInput>
    >;
    create?: InputMaybe<Array<ConsumerCreateWithoutUserInput>>;
    createMany?: InputMaybe<ConsumerCreateManyUserInputEnvelope>;
    delete?: InputMaybe<Array<ConsumerWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ConsumerScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ConsumerWhereUniqueInput>>;
    set?: InputMaybe<Array<ConsumerWhereUniqueInput>>;
    update?: InputMaybe<Array<ConsumerUpdateWithWhereUniqueWithoutUserInput>>;
    updateMany?: InputMaybe<Array<ConsumerUpdateManyWithWhereWithoutUserInput>>;
    upsert?: InputMaybe<Array<ConsumerUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ConsumerUpdateOneRequiredWithoutConsumerNotesNestedInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutConsumerNotesInput>;
    create?: InputMaybe<ConsumerCreateWithoutConsumerNotesInput>;
    update?: InputMaybe<ConsumerUpdateToOneWithWhereWithoutConsumerNotesInput>;
    upsert?: InputMaybe<ConsumerUpsertWithoutConsumerNotesInput>;
};

export type ConsumerUpdateOneRequiredWithoutMessageNudgesNestedInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutMessageNudgesInput>;
    create?: InputMaybe<ConsumerCreateWithoutMessageNudgesInput>;
    update?: InputMaybe<ConsumerUpdateToOneWithWhereWithoutMessageNudgesInput>;
    upsert?: InputMaybe<ConsumerUpsertWithoutMessageNudgesInput>;
};

export type ConsumerUpdateOneRequiredWithoutMessagePayAfterNestedInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutMessagePayAfterInput>;
    create?: InputMaybe<ConsumerCreateWithoutMessagePayAfterInput>;
    update?: InputMaybe<ConsumerUpdateToOneWithWhereWithoutMessagePayAfterInput>;
    upsert?: InputMaybe<ConsumerUpsertWithoutMessagePayAfterInput>;
};

export type ConsumerUpdateOneRequiredWithoutPhotosNestedInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutPhotosInput>;
    create?: InputMaybe<ConsumerCreateWithoutPhotosInput>;
    update?: InputMaybe<ConsumerUpdateToOneWithWhereWithoutPhotosInput>;
    upsert?: InputMaybe<ConsumerUpsertWithoutPhotosInput>;
};

export type ConsumerUpdateOneWithoutConsumerMessagesNestedInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutConsumerMessagesInput>;
    create?: InputMaybe<ConsumerCreateWithoutConsumerMessagesInput>;
    delete?: InputMaybe<ConsumerWhereInput>;
    disconnect?: InputMaybe<ConsumerWhereInput>;
    update?: InputMaybe<ConsumerUpdateToOneWithWhereWithoutConsumerMessagesInput>;
    upsert?: InputMaybe<ConsumerUpsertWithoutConsumerMessagesInput>;
};

export type ConsumerUpdateOneWithoutContractsNestedInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutContractsInput>;
    create?: InputMaybe<ConsumerCreateWithoutContractsInput>;
    delete?: InputMaybe<ConsumerWhereInput>;
    disconnect?: InputMaybe<ConsumerWhereInput>;
    update?: InputMaybe<ConsumerUpdateToOneWithWhereWithoutContractsInput>;
    upsert?: InputMaybe<ConsumerUpsertWithoutContractsInput>;
};

export type ConsumerUpdateOneWithoutInsurancesNestedInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutInsurancesInput>;
    create?: InputMaybe<ConsumerCreateWithoutInsurancesInput>;
    delete?: InputMaybe<ConsumerWhereInput>;
    disconnect?: InputMaybe<ConsumerWhereInput>;
    update?: InputMaybe<ConsumerUpdateToOneWithWhereWithoutInsurancesInput>;
    upsert?: InputMaybe<ConsumerUpsertWithoutInsurancesInput>;
};

export type ConsumerUpdateOneWithoutUserIfPrimaryConsumerNestedInput = {
    connect?: InputMaybe<ConsumerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ConsumerCreateOrConnectWithoutUserIfPrimaryConsumerInput>;
    create?: InputMaybe<ConsumerCreateWithoutUserIfPrimaryConsumerInput>;
    delete?: InputMaybe<ConsumerWhereInput>;
    disconnect?: InputMaybe<ConsumerWhereInput>;
    update?: InputMaybe<ConsumerUpdateToOneWithWhereWithoutUserIfPrimaryConsumerInput>;
    upsert?: InputMaybe<ConsumerUpsertWithoutUserIfPrimaryConsumerInput>;
};

export type ConsumerUpdateResponse = {
    __typename?: 'ConsumerUpdateResponse';
    _count?: Maybe<ConsumerCount>;
    addressLine2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    consumerAccountStatus: ConsumerAccountStatus;
    consumerMessages: Array<ConsumerMessage>;
    consumerNotes: Array<ConsumerNote>;
    contracts: Array<Contract>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deceasedDate?: Maybe<Scalars['DateTimeISO']['output']>;
    dob: Scalars['DateTimeISO']['output'];
    ehrEnterpriseId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrUpdateResponse?: Maybe<EhrUpdateResponse>;
    emergencyContactFirstName?: Maybe<Scalars['String']['output']>;
    emergencyContactLastName?: Maybe<Scalars['String']['output']>;
    emergencyContactPhone?: Maybe<Scalars['String']['output']>;
    emergencyContactRelationship?: Maybe<EmergencyContactRelationship>;
    employmentStatus?: Maybe<EmploymentStatus>;
    enrolledInAthena: Scalars['Boolean']['output'];
    ethnicity?: Maybe<Ethnicity>;
    firstname: Scalars['String']['output'];
    id: Scalars['String']['output'];
    insurances: Array<Insurance>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lastname: Scalars['String']['output'];
    maritalStatus?: Maybe<MaritalStatus>;
    messageNudges: Array<MessageNudge>;
    messagePayAfter: Array<MessagePayAfter>;
    pcpAddress?: Maybe<Scalars['JSON']['output']>;
    pcpEhrId?: Maybe<Scalars['String']['output']>;
    pcpFirstName?: Maybe<Scalars['String']['output']>;
    pcpLastName?: Maybe<Scalars['String']['output']>;
    pcpPhone?: Maybe<Scalars['String']['output']>;
    pharmacyAddress?: Maybe<Scalars['JSON']['output']>;
    pharmacyEhrId?: Maybe<Scalars['String']['output']>;
    pharmacyName?: Maybe<Scalars['String']['output']>;
    pharmacyNcpdpId?: Maybe<Scalars['String']['output']>;
    pharmacyPhone?: Maybe<Scalars['String']['output']>;
    photos: Array<ConsumerPhotoMetaData>;
    preferredFirstName?: Maybe<Scalars['String']['output']>;
    preferredLanguage?: Maybe<LanguageCode>;
    preferredLastName?: Maybe<Scalars['String']['output']>;
    race: Array<Race>;
    referralSource?: Maybe<Scalars['String']['output']>;
    referralSourceDetail?: Maybe<Scalars['String']['output']>;
    referralSourceId?: Maybe<Scalars['String']['output']>;
    sex?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    user: User;
    userId: Scalars['String']['output'];
    userIfPrimaryConsumer?: Maybe<User>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type ConsumerUpdateResponseConsumerMessagesArgs = {
    cursor?: InputMaybe<ConsumerMessageWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerMessageScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerMessageOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type ConsumerUpdateResponseConsumerNotesArgs = {
    cursor?: InputMaybe<ConsumerNoteWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerNoteScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerNoteOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type ConsumerUpdateResponseContractsArgs = {
    cursor?: InputMaybe<ContractWhereUniqueInput>;
    distinct?: InputMaybe<Array<ContractScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ContractOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractWhereInput>;
};

export type ConsumerUpdateResponseInsurancesArgs = {
    cursor?: InputMaybe<InsuranceWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceWhereInput>;
};

export type ConsumerUpdateResponseMessageNudgesArgs = {
    cursor?: InputMaybe<MessageNudgeWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageNudgeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageNudgeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type ConsumerUpdateResponseMessagePayAfterArgs = {
    cursor?: InputMaybe<MessagePayAfterWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessagePayAfterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessagePayAfterOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessagePayAfterWhereInput>;
};

export type ConsumerUpdateResponsePhotosArgs = {
    cursor?: InputMaybe<ConsumerPhotoMetaDataWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerPhotoMetaDataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerPhotoMetaDataOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type ConsumerUpdateResponseUserIfPrimaryConsumerArgs = {
    where?: InputMaybe<UserWhereInput>;
};

export type ConsumerUpdateToOneWithWhereWithoutConsumerMessagesInput = {
    data: ConsumerUpdateWithoutConsumerMessagesInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpdateToOneWithWhereWithoutConsumerNotesInput = {
    data: ConsumerUpdateWithoutConsumerNotesInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpdateToOneWithWhereWithoutContractsInput = {
    data: ConsumerUpdateWithoutContractsInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpdateToOneWithWhereWithoutInsurancesInput = {
    data: ConsumerUpdateWithoutInsurancesInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpdateToOneWithWhereWithoutMessageNudgesInput = {
    data: ConsumerUpdateWithoutMessageNudgesInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpdateToOneWithWhereWithoutMessagePayAfterInput = {
    data: ConsumerUpdateWithoutMessagePayAfterInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpdateToOneWithWhereWithoutPhotosInput = {
    data: ConsumerUpdateWithoutPhotosInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpdateToOneWithWhereWithoutUserIfPrimaryConsumerInput = {
    data: ConsumerUpdateWithoutUserIfPrimaryConsumerInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpdateWithWhereUniqueWithoutUserInput = {
    data: ConsumerUpdateWithoutUserInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerUpdateWithoutConsumerMessagesInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutConsumerNestedInput>;
    contracts?: InputMaybe<ContractUpdateManyWithoutConsumerNestedInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurances?: InputMaybe<InsuranceUpdateManyWithoutConsumerNestedInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerNestedInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterUpdateManyWithoutConsumerNestedInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutConsumerNestedInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    user?: InputMaybe<UserUpdateOneRequiredWithoutConsumersNestedInput>;
    userIfPrimaryConsumer?: InputMaybe<UserUpdateOneWithoutPrimaryConsumerNestedInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateWithoutConsumerNotesInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerMessages?: InputMaybe<ConsumerMessageUpdateManyWithoutConsumerNestedInput>;
    contracts?: InputMaybe<ContractUpdateManyWithoutConsumerNestedInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurances?: InputMaybe<InsuranceUpdateManyWithoutConsumerNestedInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerNestedInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterUpdateManyWithoutConsumerNestedInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutConsumerNestedInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    user?: InputMaybe<UserUpdateOneRequiredWithoutConsumersNestedInput>;
    userIfPrimaryConsumer?: InputMaybe<UserUpdateOneWithoutPrimaryConsumerNestedInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateWithoutContractsInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerMessages?: InputMaybe<ConsumerMessageUpdateManyWithoutConsumerNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutConsumerNestedInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurances?: InputMaybe<InsuranceUpdateManyWithoutConsumerNestedInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerNestedInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterUpdateManyWithoutConsumerNestedInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutConsumerNestedInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    user?: InputMaybe<UserUpdateOneRequiredWithoutConsumersNestedInput>;
    userIfPrimaryConsumer?: InputMaybe<UserUpdateOneWithoutPrimaryConsumerNestedInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateWithoutInsurancesInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerMessages?: InputMaybe<ConsumerMessageUpdateManyWithoutConsumerNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutConsumerNestedInput>;
    contracts?: InputMaybe<ContractUpdateManyWithoutConsumerNestedInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerNestedInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterUpdateManyWithoutConsumerNestedInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutConsumerNestedInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    user?: InputMaybe<UserUpdateOneRequiredWithoutConsumersNestedInput>;
    userIfPrimaryConsumer?: InputMaybe<UserUpdateOneWithoutPrimaryConsumerNestedInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateWithoutMessageNudgesInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerMessages?: InputMaybe<ConsumerMessageUpdateManyWithoutConsumerNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutConsumerNestedInput>;
    contracts?: InputMaybe<ContractUpdateManyWithoutConsumerNestedInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurances?: InputMaybe<InsuranceUpdateManyWithoutConsumerNestedInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterUpdateManyWithoutConsumerNestedInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutConsumerNestedInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    user?: InputMaybe<UserUpdateOneRequiredWithoutConsumersNestedInput>;
    userIfPrimaryConsumer?: InputMaybe<UserUpdateOneWithoutPrimaryConsumerNestedInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateWithoutMessagePayAfterInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerMessages?: InputMaybe<ConsumerMessageUpdateManyWithoutConsumerNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutConsumerNestedInput>;
    contracts?: InputMaybe<ContractUpdateManyWithoutConsumerNestedInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurances?: InputMaybe<InsuranceUpdateManyWithoutConsumerNestedInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerNestedInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutConsumerNestedInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    user?: InputMaybe<UserUpdateOneRequiredWithoutConsumersNestedInput>;
    userIfPrimaryConsumer?: InputMaybe<UserUpdateOneWithoutPrimaryConsumerNestedInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateWithoutPhotosInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerMessages?: InputMaybe<ConsumerMessageUpdateManyWithoutConsumerNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutConsumerNestedInput>;
    contracts?: InputMaybe<ContractUpdateManyWithoutConsumerNestedInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurances?: InputMaybe<InsuranceUpdateManyWithoutConsumerNestedInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerNestedInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterUpdateManyWithoutConsumerNestedInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    user?: InputMaybe<UserUpdateOneRequiredWithoutConsumersNestedInput>;
    userIfPrimaryConsumer?: InputMaybe<UserUpdateOneWithoutPrimaryConsumerNestedInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateWithoutUserIfPrimaryConsumerInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerMessages?: InputMaybe<ConsumerMessageUpdateManyWithoutConsumerNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutConsumerNestedInput>;
    contracts?: InputMaybe<ContractUpdateManyWithoutConsumerNestedInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurances?: InputMaybe<InsuranceUpdateManyWithoutConsumerNestedInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerNestedInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterUpdateManyWithoutConsumerNestedInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutConsumerNestedInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    user?: InputMaybe<UserUpdateOneRequiredWithoutConsumersNestedInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateWithoutUserInput = {
    addressLine2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFieldUpdateOperationsInput>;
    consumerMessages?: InputMaybe<ConsumerMessageUpdateManyWithoutConsumerNestedInput>;
    consumerNotes?: InputMaybe<ConsumerNoteUpdateManyWithoutConsumerNestedInput>;
    contracts?: InputMaybe<ContractUpdateManyWithoutConsumerNestedInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deceasedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dob?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrEnterpriseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    emergencyContactRelationship?: InputMaybe<NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput>;
    employmentStatus?: InputMaybe<NullableEnumEmploymentStatusFieldUpdateOperationsInput>;
    enrolledInAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    ethnicity?: InputMaybe<NullableEnumEthnicityFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insurances?: InputMaybe<InsuranceUpdateManyWithoutConsumerNestedInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    maritalStatus?: InputMaybe<NullableEnumMaritalStatusFieldUpdateOperationsInput>;
    messageNudges?: InputMaybe<MessageNudgeUpdateManyWithoutConsumerNestedInput>;
    messagePayAfter?: InputMaybe<MessagePayAfterUpdateManyWithoutConsumerNestedInput>;
    pcpAddress?: InputMaybe<Scalars['JSON']['input']>;
    pcpEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyAddress?: InputMaybe<Scalars['JSON']['input']>;
    pharmacyEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyNcpdpId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pharmacyPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutConsumerNestedInput>;
    preferredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    preferredLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    preferredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    race?: InputMaybe<ConsumerUpdateraceInput>;
    referralSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    referralSourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sex?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    streetAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userIfPrimaryConsumer?: InputMaybe<UserUpdateOneWithoutPrimaryConsumerNestedInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ConsumerUpdateraceInput = {
    push?: InputMaybe<Array<Race>>;
    set?: InputMaybe<Array<Race>>;
};

export type ConsumerUpsertWithWhereUniqueWithoutUserInput = {
    create: ConsumerCreateWithoutUserInput;
    update: ConsumerUpdateWithoutUserInput;
    where: ConsumerWhereUniqueInput;
};

export type ConsumerUpsertWithoutConsumerMessagesInput = {
    create: ConsumerCreateWithoutConsumerMessagesInput;
    update: ConsumerUpdateWithoutConsumerMessagesInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpsertWithoutConsumerNotesInput = {
    create: ConsumerCreateWithoutConsumerNotesInput;
    update: ConsumerUpdateWithoutConsumerNotesInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpsertWithoutContractsInput = {
    create: ConsumerCreateWithoutContractsInput;
    update: ConsumerUpdateWithoutContractsInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpsertWithoutInsurancesInput = {
    create: ConsumerCreateWithoutInsurancesInput;
    update: ConsumerUpdateWithoutInsurancesInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpsertWithoutMessageNudgesInput = {
    create: ConsumerCreateWithoutMessageNudgesInput;
    update: ConsumerUpdateWithoutMessageNudgesInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpsertWithoutMessagePayAfterInput = {
    create: ConsumerCreateWithoutMessagePayAfterInput;
    update: ConsumerUpdateWithoutMessagePayAfterInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpsertWithoutPhotosInput = {
    create: ConsumerCreateWithoutPhotosInput;
    update: ConsumerUpdateWithoutPhotosInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerUpsertWithoutUserIfPrimaryConsumerInput = {
    create: ConsumerCreateWithoutUserIfPrimaryConsumerInput;
    update: ConsumerUpdateWithoutUserIfPrimaryConsumerInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type ConsumerWhereInput = {
    AND?: InputMaybe<Array<ConsumerWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerWhereInput>>;
    OR?: InputMaybe<Array<ConsumerWhereInput>>;
    addressLine2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFilter>;
    consumerMessages?: InputMaybe<ConsumerMessageListRelationFilter>;
    consumerNotes?: InputMaybe<ConsumerNoteListRelationFilter>;
    contracts?: InputMaybe<ContractListRelationFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deceasedDate?: InputMaybe<DateTimeNullableFilter>;
    dob?: InputMaybe<DateTimeFilter>;
    ehrEnterpriseId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    emergencyContactFirstName?: InputMaybe<StringNullableFilter>;
    emergencyContactLastName?: InputMaybe<StringNullableFilter>;
    emergencyContactPhone?: InputMaybe<StringNullableFilter>;
    emergencyContactRelationship?: InputMaybe<EnumEmergencyContactRelationshipNullableFilter>;
    employmentStatus?: InputMaybe<EnumEmploymentStatusNullableFilter>;
    enrolledInAthena?: InputMaybe<BoolFilter>;
    ethnicity?: InputMaybe<EnumEthnicityNullableFilter>;
    firstname?: InputMaybe<StringFilter>;
    id?: InputMaybe<UuidFilter>;
    insurances?: InputMaybe<InsuranceListRelationFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    lastname?: InputMaybe<StringFilter>;
    maritalStatus?: InputMaybe<EnumMaritalStatusNullableFilter>;
    messageNudges?: InputMaybe<MessageNudgeListRelationFilter>;
    messagePayAfter?: InputMaybe<MessagePayAfterListRelationFilter>;
    pcpAddress?: InputMaybe<JsonNullableFilter>;
    pcpEhrId?: InputMaybe<StringNullableFilter>;
    pcpFirstName?: InputMaybe<StringNullableFilter>;
    pcpLastName?: InputMaybe<StringNullableFilter>;
    pcpPhone?: InputMaybe<StringNullableFilter>;
    pharmacyAddress?: InputMaybe<JsonNullableFilter>;
    pharmacyEhrId?: InputMaybe<StringNullableFilter>;
    pharmacyName?: InputMaybe<StringNullableFilter>;
    pharmacyNcpdpId?: InputMaybe<StringNullableFilter>;
    pharmacyPhone?: InputMaybe<StringNullableFilter>;
    photos?: InputMaybe<ConsumerPhotoMetaDataListRelationFilter>;
    preferredFirstName?: InputMaybe<StringNullableFilter>;
    preferredLanguage?: InputMaybe<EnumLanguageCodeNullableFilter>;
    preferredLastName?: InputMaybe<StringNullableFilter>;
    race?: InputMaybe<EnumRaceNullableListFilter>;
    referralSource?: InputMaybe<StringNullableFilter>;
    referralSourceDetail?: InputMaybe<StringNullableFilter>;
    referralSourceId?: InputMaybe<StringNullableFilter>;
    sex?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    streetAddress?: InputMaybe<StringNullableFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    user?: InputMaybe<UserRelationFilter>;
    userId?: InputMaybe<UuidFilter>;
    userIfPrimaryConsumer?: InputMaybe<UserNullableRelationFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type ConsumerWhereUniqueInput = {
    AND?: InputMaybe<Array<ConsumerWhereInput>>;
    NOT?: InputMaybe<Array<ConsumerWhereInput>>;
    OR?: InputMaybe<Array<ConsumerWhereInput>>;
    addressLine2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    consumerAccountStatus?: InputMaybe<EnumConsumerAccountStatusFilter>;
    consumerMessages?: InputMaybe<ConsumerMessageListRelationFilter>;
    consumerNotes?: InputMaybe<ConsumerNoteListRelationFilter>;
    contracts?: InputMaybe<ContractListRelationFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deceasedDate?: InputMaybe<DateTimeNullableFilter>;
    dob?: InputMaybe<DateTimeFilter>;
    ehrEnterpriseId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    emergencyContactFirstName?: InputMaybe<StringNullableFilter>;
    emergencyContactLastName?: InputMaybe<StringNullableFilter>;
    emergencyContactPhone?: InputMaybe<StringNullableFilter>;
    emergencyContactRelationship?: InputMaybe<EnumEmergencyContactRelationshipNullableFilter>;
    employmentStatus?: InputMaybe<EnumEmploymentStatusNullableFilter>;
    enrolledInAthena?: InputMaybe<BoolFilter>;
    ethnicity?: InputMaybe<EnumEthnicityNullableFilter>;
    firstname?: InputMaybe<StringFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    insurances?: InputMaybe<InsuranceListRelationFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    lastname?: InputMaybe<StringFilter>;
    maritalStatus?: InputMaybe<EnumMaritalStatusNullableFilter>;
    messageNudges?: InputMaybe<MessageNudgeListRelationFilter>;
    messagePayAfter?: InputMaybe<MessagePayAfterListRelationFilter>;
    pcpAddress?: InputMaybe<JsonNullableFilter>;
    pcpEhrId?: InputMaybe<StringNullableFilter>;
    pcpFirstName?: InputMaybe<StringNullableFilter>;
    pcpLastName?: InputMaybe<StringNullableFilter>;
    pcpPhone?: InputMaybe<StringNullableFilter>;
    pharmacyAddress?: InputMaybe<JsonNullableFilter>;
    pharmacyEhrId?: InputMaybe<StringNullableFilter>;
    pharmacyName?: InputMaybe<StringNullableFilter>;
    pharmacyNcpdpId?: InputMaybe<StringNullableFilter>;
    pharmacyPhone?: InputMaybe<StringNullableFilter>;
    photos?: InputMaybe<ConsumerPhotoMetaDataListRelationFilter>;
    preferredFirstName?: InputMaybe<StringNullableFilter>;
    preferredLanguage?: InputMaybe<EnumLanguageCodeNullableFilter>;
    preferredLastName?: InputMaybe<StringNullableFilter>;
    race?: InputMaybe<EnumRaceNullableListFilter>;
    referralSource?: InputMaybe<StringNullableFilter>;
    referralSourceDetail?: InputMaybe<StringNullableFilter>;
    referralSourceId?: InputMaybe<StringNullableFilter>;
    sex?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    streetAddress?: InputMaybe<StringNullableFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    user?: InputMaybe<UserRelationFilter>;
    userId?: InputMaybe<UuidFilter>;
    userIfPrimaryConsumer?: InputMaybe<UserNullableRelationFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type Contract = {
    __typename?: 'Contract';
    consumer?: Maybe<Consumer>;
    consumerId?: Maybe<Scalars['String']['output']>;
    contractAccountStatus?: Maybe<ContractAccountStatus>;
    contractType: ContractType;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrInsuranceId: Scalars['String']['output'];
    expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    patientRelation?: Maybe<Scalars['String']['output']>;
    policyNumber?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ContractStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ContractConsumerArgs = {
    where?: InputMaybe<ConsumerWhereInput>;
};

export enum ContractAccountStatus {
    Connected = 'CONNECTED',
    Deleted = 'DELETED',
}

export type ContractAuditLog = {
    __typename?: 'ContractAuditLog';
    consumerId?: Maybe<Scalars['String']['output']>;
    contractAccountStatus?: Maybe<ContractAccountStatus>;
    contractId?: Maybe<Scalars['String']['output']>;
    contractType?: Maybe<ContractType>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    patientRelation?: Maybe<Scalars['String']['output']>;
    policyNumber?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ContractStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ContractAuditLogAvgAggregate = {
    __typename?: 'ContractAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type ContractAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ContractAuditLogCountAggregate = {
    __typename?: 'ContractAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    contractAccountStatus: Scalars['Int']['output'];
    contractId: Scalars['Int']['output'];
    contractType: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrInsuranceId: Scalars['Int']['output'];
    expirationDate: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    issueDate: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    patientRelation: Scalars['Int']['output'];
    policyNumber: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ContractAuditLogCountOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    contractAccountStatus?: InputMaybe<SortOrder>;
    contractId?: InputMaybe<SortOrder>;
    contractType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    expirationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    issueDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    patientRelation?: InputMaybe<SortOrder>;
    policyNumber?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ContractAuditLogCreateInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    contractAccountStatus?: InputMaybe<ContractAccountStatus>;
    contractId?: InputMaybe<Scalars['String']['input']>;
    contractType?: InputMaybe<ContractType>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId?: InputMaybe<Scalars['String']['input']>;
    expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    operation?: InputMaybe<Scalars['String']['input']>;
    patientRelation?: InputMaybe<Scalars['String']['input']>;
    policyNumber?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ContractStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ContractAuditLogCreateManyInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    contractAccountStatus?: InputMaybe<ContractAccountStatus>;
    contractId?: InputMaybe<Scalars['String']['input']>;
    contractType?: InputMaybe<ContractType>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId?: InputMaybe<Scalars['String']['input']>;
    expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    operation?: InputMaybe<Scalars['String']['input']>;
    patientRelation?: InputMaybe<Scalars['String']['input']>;
    policyNumber?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ContractStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ContractAuditLogGroupBy = {
    __typename?: 'ContractAuditLogGroupBy';
    _avg?: Maybe<ContractAuditLogAvgAggregate>;
    _count?: Maybe<ContractAuditLogCountAggregate>;
    _max?: Maybe<ContractAuditLogMaxAggregate>;
    _min?: Maybe<ContractAuditLogMinAggregate>;
    _sum?: Maybe<ContractAuditLogSumAggregate>;
    consumerId?: Maybe<Scalars['String']['output']>;
    contractAccountStatus?: Maybe<ContractAccountStatus>;
    contractId?: Maybe<Scalars['String']['output']>;
    contractType?: Maybe<ContractType>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    patientRelation?: Maybe<Scalars['String']['output']>;
    policyNumber?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ContractStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ContractAuditLogMaxAggregate = {
    __typename?: 'ContractAuditLogMaxAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    contractAccountStatus?: Maybe<ContractAccountStatus>;
    contractId?: Maybe<Scalars['String']['output']>;
    contractType?: Maybe<ContractType>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    patientRelation?: Maybe<Scalars['String']['output']>;
    policyNumber?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ContractStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ContractAuditLogMaxOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    contractAccountStatus?: InputMaybe<SortOrder>;
    contractId?: InputMaybe<SortOrder>;
    contractType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    expirationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    issueDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    patientRelation?: InputMaybe<SortOrder>;
    policyNumber?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ContractAuditLogMinAggregate = {
    __typename?: 'ContractAuditLogMinAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    contractAccountStatus?: Maybe<ContractAccountStatus>;
    contractId?: Maybe<Scalars['String']['output']>;
    contractType?: Maybe<ContractType>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    patientRelation?: Maybe<Scalars['String']['output']>;
    policyNumber?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ContractStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ContractAuditLogMinOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    contractAccountStatus?: InputMaybe<SortOrder>;
    contractId?: InputMaybe<SortOrder>;
    contractType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    expirationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    issueDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    patientRelation?: InputMaybe<SortOrder>;
    policyNumber?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ContractAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<ContractAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<ContractAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<ContractAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<ContractAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<ContractAuditLogSumOrderByAggregateInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    contractAccountStatus?: InputMaybe<SortOrderInput>;
    contractId?: InputMaybe<SortOrderInput>;
    contractType?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrderInput>;
    expirationDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    issueDate?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    patientRelation?: InputMaybe<SortOrderInput>;
    policyNumber?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ContractAuditLogOrderByWithRelationInput = {
    consumerId?: InputMaybe<SortOrderInput>;
    contractAccountStatus?: InputMaybe<SortOrderInput>;
    contractId?: InputMaybe<SortOrderInput>;
    contractType?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrderInput>;
    expirationDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    issueDate?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    patientRelation?: InputMaybe<SortOrderInput>;
    policyNumber?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum ContractAuditLogScalarFieldEnum {
    ConsumerId = 'consumerId',
    ContractAccountStatus = 'contractAccountStatus',
    ContractId = 'contractId',
    ContractType = 'contractType',
    CreatedAt = 'createdAt',
    EhrInsuranceId = 'ehrInsuranceId',
    ExpirationDate = 'expirationDate',
    Id = 'id',
    IssueDate = 'issueDate',
    LastUpdatedBy = 'lastUpdatedBy',
    Name = 'name',
    Notes = 'notes',
    Operation = 'operation',
    PatientRelation = 'patientRelation',
    PolicyNumber = 'policyNumber',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type ContractAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ContractAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ContractAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ContractAuditLogScalarWhereWithAggregatesInput>>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    contractAccountStatus?: InputMaybe<EnumContractAccountStatusNullableWithAggregatesFilter>;
    contractId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    contractType?: InputMaybe<EnumContractTypeNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrInsuranceId?: InputMaybe<StringNullableWithAggregatesFilter>;
    expirationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    issueDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    name?: InputMaybe<StringNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringNullableWithAggregatesFilter>;
    patientRelation?: InputMaybe<StringNullableWithAggregatesFilter>;
    policyNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumContractStatusNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ContractAuditLogSumAggregate = {
    __typename?: 'ContractAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type ContractAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ContractAuditLogUpdateInput = {
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    contractAccountStatus?: InputMaybe<NullableEnumContractAccountStatusFieldUpdateOperationsInput>;
    contractId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    contractType?: InputMaybe<NullableEnumContractTypeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    expirationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    issueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientRelation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    policyNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumContractStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ContractAuditLogUpdateManyMutationInput = {
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    contractAccountStatus?: InputMaybe<NullableEnumContractAccountStatusFieldUpdateOperationsInput>;
    contractId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    contractType?: InputMaybe<NullableEnumContractTypeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    expirationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    issueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientRelation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    policyNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumContractStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ContractAuditLogWhereInput = {
    AND?: InputMaybe<Array<ContractAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<ContractAuditLogWhereInput>>;
    OR?: InputMaybe<Array<ContractAuditLogWhereInput>>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    contractAccountStatus?: InputMaybe<EnumContractAccountStatusNullableFilter>;
    contractId?: InputMaybe<UuidNullableFilter>;
    contractType?: InputMaybe<EnumContractTypeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrInsuranceId?: InputMaybe<StringNullableFilter>;
    expirationDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    issueDate?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    patientRelation?: InputMaybe<StringNullableFilter>;
    policyNumber?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumContractStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ContractAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<ContractAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<ContractAuditLogWhereInput>>;
    OR?: InputMaybe<Array<ContractAuditLogWhereInput>>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    contractAccountStatus?: InputMaybe<EnumContractAccountStatusNullableFilter>;
    contractId?: InputMaybe<UuidNullableFilter>;
    contractType?: InputMaybe<EnumContractTypeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrInsuranceId?: InputMaybe<StringNullableFilter>;
    expirationDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    issueDate?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    patientRelation?: InputMaybe<StringNullableFilter>;
    policyNumber?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumContractStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ContractCountAggregate = {
    __typename?: 'ContractCountAggregate';
    _all: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    contractAccountStatus: Scalars['Int']['output'];
    contractType: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrInsuranceId: Scalars['Int']['output'];
    expirationDate: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    issueDate: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    patientRelation: Scalars['Int']['output'];
    policyNumber: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ContractCountOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    contractAccountStatus?: InputMaybe<SortOrder>;
    contractType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    expirationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    issueDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    patientRelation?: InputMaybe<SortOrder>;
    policyNumber?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ContractCreateInput = {
    consumer?: InputMaybe<ConsumerCreateNestedOneWithoutContractsInput>;
    contractAccountStatus?: InputMaybe<ContractAccountStatus>;
    contractType?: InputMaybe<ContractType>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId: Scalars['String']['input'];
    expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    patientRelation?: InputMaybe<Scalars['String']['input']>;
    policyNumber?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ContractStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ContractCreateManyConsumerInput = {
    contractAccountStatus?: InputMaybe<ContractAccountStatus>;
    contractType?: InputMaybe<ContractType>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId: Scalars['String']['input'];
    expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    patientRelation?: InputMaybe<Scalars['String']['input']>;
    policyNumber?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ContractStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ContractCreateManyConsumerInputEnvelope = {
    data: Array<ContractCreateManyConsumerInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractCreateManyInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    contractAccountStatus?: InputMaybe<ContractAccountStatus>;
    contractType?: InputMaybe<ContractType>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId: Scalars['String']['input'];
    expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    patientRelation?: InputMaybe<Scalars['String']['input']>;
    policyNumber?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ContractStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ContractCreateNestedManyWithoutConsumerInput = {
    connect?: InputMaybe<Array<ContractWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ContractCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<ContractCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<ContractCreateManyConsumerInputEnvelope>;
};

export type ContractCreateOrConnectWithoutConsumerInput = {
    create: ContractCreateWithoutConsumerInput;
    where: ContractWhereUniqueInput;
};

export type ContractCreateWithoutConsumerInput = {
    contractAccountStatus?: InputMaybe<ContractAccountStatus>;
    contractType?: InputMaybe<ContractType>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId: Scalars['String']['input'];
    expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    patientRelation?: InputMaybe<Scalars['String']['input']>;
    policyNumber?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<ContractStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ContractGroupBy = {
    __typename?: 'ContractGroupBy';
    _count?: Maybe<ContractCountAggregate>;
    _max?: Maybe<ContractMaxAggregate>;
    _min?: Maybe<ContractMinAggregate>;
    consumerId?: Maybe<Scalars['String']['output']>;
    contractAccountStatus?: Maybe<ContractAccountStatus>;
    contractType: ContractType;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrInsuranceId: Scalars['String']['output'];
    expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    patientRelation?: Maybe<Scalars['String']['output']>;
    policyNumber?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ContractStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ContractListRelationFilter = {
    every?: InputMaybe<ContractWhereInput>;
    none?: InputMaybe<ContractWhereInput>;
    some?: InputMaybe<ContractWhereInput>;
};

export type ContractMaxAggregate = {
    __typename?: 'ContractMaxAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    contractAccountStatus?: Maybe<ContractAccountStatus>;
    contractType?: Maybe<ContractType>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    patientRelation?: Maybe<Scalars['String']['output']>;
    policyNumber?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ContractStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ContractMaxOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    contractAccountStatus?: InputMaybe<SortOrder>;
    contractType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    expirationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    issueDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    patientRelation?: InputMaybe<SortOrder>;
    policyNumber?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ContractMinAggregate = {
    __typename?: 'ContractMinAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    contractAccountStatus?: Maybe<ContractAccountStatus>;
    contractType?: Maybe<ContractType>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    patientRelation?: Maybe<Scalars['String']['output']>;
    policyNumber?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ContractStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ContractMinOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    contractAccountStatus?: InputMaybe<SortOrder>;
    contractType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    expirationDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    issueDate?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    patientRelation?: InputMaybe<SortOrder>;
    policyNumber?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ContractOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ContractOrderByWithAggregationInput = {
    _count?: InputMaybe<ContractCountOrderByAggregateInput>;
    _max?: InputMaybe<ContractMaxOrderByAggregateInput>;
    _min?: InputMaybe<ContractMinOrderByAggregateInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    contractAccountStatus?: InputMaybe<SortOrderInput>;
    contractType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    expirationDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    issueDate?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    patientRelation?: InputMaybe<SortOrderInput>;
    policyNumber?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ContractOrderByWithRelationInput = {
    consumer?: InputMaybe<ConsumerOrderByWithRelationInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    contractAccountStatus?: InputMaybe<SortOrderInput>;
    contractType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    expirationDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    issueDate?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    patientRelation?: InputMaybe<SortOrderInput>;
    policyNumber?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum ContractScalarFieldEnum {
    ConsumerId = 'consumerId',
    ContractAccountStatus = 'contractAccountStatus',
    ContractType = 'contractType',
    CreatedAt = 'createdAt',
    EhrInsuranceId = 'ehrInsuranceId',
    ExpirationDate = 'expirationDate',
    Id = 'id',
    IssueDate = 'issueDate',
    LastUpdatedBy = 'lastUpdatedBy',
    Name = 'name',
    Notes = 'notes',
    PatientRelation = 'patientRelation',
    PolicyNumber = 'policyNumber',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type ContractScalarWhereInput = {
    AND?: InputMaybe<Array<ContractScalarWhereInput>>;
    NOT?: InputMaybe<Array<ContractScalarWhereInput>>;
    OR?: InputMaybe<Array<ContractScalarWhereInput>>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    contractAccountStatus?: InputMaybe<EnumContractAccountStatusNullableFilter>;
    contractType?: InputMaybe<EnumContractTypeFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrInsuranceId?: InputMaybe<StringFilter>;
    expirationDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    issueDate?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    patientRelation?: InputMaybe<StringNullableFilter>;
    policyNumber?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumContractStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ContractScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ContractScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ContractScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ContractScalarWhereWithAggregatesInput>>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    contractAccountStatus?: InputMaybe<EnumContractAccountStatusNullableWithAggregatesFilter>;
    contractType?: InputMaybe<EnumContractTypeWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrInsuranceId?: InputMaybe<StringWithAggregatesFilter>;
    expirationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    issueDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    patientRelation?: InputMaybe<StringNullableWithAggregatesFilter>;
    policyNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumContractStatusNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum ContractStatus {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
}

export enum ContractType {
    Contract = 'CONTRACT',
    Other = 'OTHER',
}

export type ContractUpdateInput = {
    consumer?: InputMaybe<ConsumerUpdateOneWithoutContractsNestedInput>;
    contractAccountStatus?: InputMaybe<NullableEnumContractAccountStatusFieldUpdateOperationsInput>;
    contractType?: InputMaybe<EnumContractTypeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<StringFieldUpdateOperationsInput>;
    expirationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    issueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientRelation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    policyNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumContractStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ContractUpdateManyMutationInput = {
    contractAccountStatus?: InputMaybe<NullableEnumContractAccountStatusFieldUpdateOperationsInput>;
    contractType?: InputMaybe<EnumContractTypeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<StringFieldUpdateOperationsInput>;
    expirationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    issueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientRelation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    policyNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumContractStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ContractUpdateManyWithWhereWithoutConsumerInput = {
    data: ContractUpdateManyMutationInput;
    where: ContractScalarWhereInput;
};

export type ContractUpdateManyWithoutConsumerNestedInput = {
    connect?: InputMaybe<Array<ContractWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ContractCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<ContractCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<ContractCreateManyConsumerInputEnvelope>;
    delete?: InputMaybe<Array<ContractWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ContractScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ContractWhereUniqueInput>>;
    set?: InputMaybe<Array<ContractWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ContractUpdateWithWhereUniqueWithoutConsumerInput>
    >;
    updateMany?: InputMaybe<
        Array<ContractUpdateManyWithWhereWithoutConsumerInput>
    >;
    upsert?: InputMaybe<
        Array<ContractUpsertWithWhereUniqueWithoutConsumerInput>
    >;
};

export type ContractUpdateWithWhereUniqueWithoutConsumerInput = {
    data: ContractUpdateWithoutConsumerInput;
    where: ContractWhereUniqueInput;
};

export type ContractUpdateWithoutConsumerInput = {
    contractAccountStatus?: InputMaybe<NullableEnumContractAccountStatusFieldUpdateOperationsInput>;
    contractType?: InputMaybe<EnumContractTypeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<StringFieldUpdateOperationsInput>;
    expirationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    issueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientRelation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    policyNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumContractStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ContractUpsertWithWhereUniqueWithoutConsumerInput = {
    create: ContractCreateWithoutConsumerInput;
    update: ContractUpdateWithoutConsumerInput;
    where: ContractWhereUniqueInput;
};

export type ContractWhereInput = {
    AND?: InputMaybe<Array<ContractWhereInput>>;
    NOT?: InputMaybe<Array<ContractWhereInput>>;
    OR?: InputMaybe<Array<ContractWhereInput>>;
    consumer?: InputMaybe<ConsumerNullableRelationFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    contractAccountStatus?: InputMaybe<EnumContractAccountStatusNullableFilter>;
    contractType?: InputMaybe<EnumContractTypeFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrInsuranceId?: InputMaybe<StringFilter>;
    expirationDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    issueDate?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    patientRelation?: InputMaybe<StringNullableFilter>;
    policyNumber?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumContractStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ContractWhereUniqueInput = {
    AND?: InputMaybe<Array<ContractWhereInput>>;
    NOT?: InputMaybe<Array<ContractWhereInput>>;
    OR?: InputMaybe<Array<ContractWhereInput>>;
    consumer?: InputMaybe<ConsumerNullableRelationFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    contractAccountStatus?: InputMaybe<EnumContractAccountStatusNullableFilter>;
    contractType?: InputMaybe<EnumContractTypeFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrInsuranceId?: InputMaybe<StringFilter>;
    expirationDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    issueDate?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    patientRelation?: InputMaybe<StringNullableFilter>;
    policyNumber?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumContractStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CoverageResponses = {
    __typename?: 'CoverageResponses';
    communication_error_iterations?: Maybe<Scalars['Int']['output']>;
    concurrency_issue_iterations?: Maybe<Scalars['Int']['output']>;
    consumer_id?: Maybe<Scalars['String']['output']>;
    coverage_error_id?: Maybe<Scalars['String']['output']>;
    coverage_source?: Maybe<CoverageSource>;
    date_of_birth?: Maybe<Scalars['String']['output']>;
    ehr_patient_id?: Maybe<Scalars['String']['output']>;
    eligibility_payer_code: Scalars['String']['output'];
    end_time?: Maybe<Scalars['DateTimeISO']['output']>;
    first_name?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    last_name?: Maybe<Scalars['String']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    member_id?: Maybe<Scalars['String']['output']>;
    npi: Scalars['String']['output'];
    org_id: Scalars['String']['output'];
    patient_state: State;
    payer_name: Scalars['String']['output'];
    place_of_service_code: Scalars['String']['output'];
    provider_state?: Maybe<State>;
    rate_limit_iterations?: Maybe<Scalars['Int']['output']>;
    request_errors: Array<Scalars['String']['output']>;
    request_id: Scalars['String']['output'];
    response_codes?: Maybe<Scalars['String']['output']>;
    result?: Maybe<AirStatusCode>;
    service_type_code?: Maybe<Scalars['String']['output']>;
    session_id?: Maybe<Scalars['String']['output']>;
    start_time?: Maybe<Scalars['DateTimeISO']['output']>;
    superscript_payer_code: Scalars['String']['output'];
    total_iterations?: Maybe<Scalars['Int']['output']>;
    validation_errors: Array<Scalars['String']['output']>;
};

export type CoverageResponsesAvgAggregate = {
    __typename?: 'CoverageResponsesAvgAggregate';
    communication_error_iterations?: Maybe<Scalars['Float']['output']>;
    concurrency_issue_iterations?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    latency?: Maybe<Scalars['Float']['output']>;
    rate_limit_iterations?: Maybe<Scalars['Float']['output']>;
    total_iterations?: Maybe<Scalars['Float']['output']>;
};

export type CoverageResponsesAvgOrderByAggregateInput = {
    communication_error_iterations?: InputMaybe<SortOrder>;
    concurrency_issue_iterations?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    rate_limit_iterations?: InputMaybe<SortOrder>;
    total_iterations?: InputMaybe<SortOrder>;
};

export type CoverageResponsesCountAggregate = {
    __typename?: 'CoverageResponsesCountAggregate';
    _all: Scalars['Int']['output'];
    communication_error_iterations: Scalars['Int']['output'];
    concurrency_issue_iterations: Scalars['Int']['output'];
    consumer_id: Scalars['Int']['output'];
    coverage_error_id: Scalars['Int']['output'];
    coverage_source: Scalars['Int']['output'];
    date_of_birth: Scalars['Int']['output'];
    ehr_patient_id: Scalars['Int']['output'];
    eligibility_payer_code: Scalars['Int']['output'];
    end_time: Scalars['Int']['output'];
    first_name: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    last_name: Scalars['Int']['output'];
    latency: Scalars['Int']['output'];
    member_id: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    org_id: Scalars['Int']['output'];
    patient_state: Scalars['Int']['output'];
    payer_name: Scalars['Int']['output'];
    place_of_service_code: Scalars['Int']['output'];
    provider_state: Scalars['Int']['output'];
    rate_limit_iterations: Scalars['Int']['output'];
    request_errors: Scalars['Int']['output'];
    request_id: Scalars['Int']['output'];
    response_codes: Scalars['Int']['output'];
    result: Scalars['Int']['output'];
    service_type_code: Scalars['Int']['output'];
    session_id: Scalars['Int']['output'];
    start_time: Scalars['Int']['output'];
    superscript_payer_code: Scalars['Int']['output'];
    total_iterations: Scalars['Int']['output'];
    validation_errors: Scalars['Int']['output'];
};

export type CoverageResponsesCountOrderByAggregateInput = {
    communication_error_iterations?: InputMaybe<SortOrder>;
    concurrency_issue_iterations?: InputMaybe<SortOrder>;
    consumer_id?: InputMaybe<SortOrder>;
    coverage_error_id?: InputMaybe<SortOrder>;
    coverage_source?: InputMaybe<SortOrder>;
    date_of_birth?: InputMaybe<SortOrder>;
    ehr_patient_id?: InputMaybe<SortOrder>;
    eligibility_payer_code?: InputMaybe<SortOrder>;
    end_time?: InputMaybe<SortOrder>;
    first_name?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    last_name?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    member_id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    patient_state?: InputMaybe<SortOrder>;
    payer_name?: InputMaybe<SortOrder>;
    place_of_service_code?: InputMaybe<SortOrder>;
    provider_state?: InputMaybe<SortOrder>;
    rate_limit_iterations?: InputMaybe<SortOrder>;
    request_errors?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    response_codes?: InputMaybe<SortOrder>;
    result?: InputMaybe<SortOrder>;
    service_type_code?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrder>;
    start_time?: InputMaybe<SortOrder>;
    superscript_payer_code?: InputMaybe<SortOrder>;
    total_iterations?: InputMaybe<SortOrder>;
    validation_errors?: InputMaybe<SortOrder>;
};

export type CoverageResponsesCreateInput = {
    communication_error_iterations?: InputMaybe<Scalars['Int']['input']>;
    concurrency_issue_iterations?: InputMaybe<Scalars['Int']['input']>;
    consumer_id?: InputMaybe<Scalars['String']['input']>;
    coverage_error_id?: InputMaybe<Scalars['String']['input']>;
    coverage_source?: InputMaybe<CoverageSource>;
    date_of_birth?: InputMaybe<Scalars['String']['input']>;
    ehr_patient_id?: InputMaybe<Scalars['String']['input']>;
    eligibility_payer_code: Scalars['String']['input'];
    end_time?: InputMaybe<Scalars['DateTimeISO']['input']>;
    first_name?: InputMaybe<Scalars['String']['input']>;
    last_name?: InputMaybe<Scalars['String']['input']>;
    latency?: InputMaybe<Scalars['Int']['input']>;
    member_id?: InputMaybe<Scalars['String']['input']>;
    npi: Scalars['String']['input'];
    org_id: Scalars['String']['input'];
    patient_state: State;
    payer_name: Scalars['String']['input'];
    place_of_service_code: Scalars['String']['input'];
    provider_state?: InputMaybe<State>;
    rate_limit_iterations?: InputMaybe<Scalars['Int']['input']>;
    request_errors?: InputMaybe<CoverageResponsesCreaterequestErrorsInput>;
    request_id: Scalars['String']['input'];
    response_codes?: InputMaybe<Scalars['String']['input']>;
    result?: InputMaybe<AirStatusCode>;
    service_type_code?: InputMaybe<Scalars['String']['input']>;
    session_id?: InputMaybe<Scalars['String']['input']>;
    start_time?: InputMaybe<Scalars['DateTimeISO']['input']>;
    superscript_payer_code: Scalars['String']['input'];
    total_iterations?: InputMaybe<Scalars['Int']['input']>;
    validation_errors?: InputMaybe<CoverageResponsesCreatevalidationErrorsInput>;
};

export type CoverageResponsesCreateManyInput = {
    communication_error_iterations?: InputMaybe<Scalars['Int']['input']>;
    concurrency_issue_iterations?: InputMaybe<Scalars['Int']['input']>;
    consumer_id?: InputMaybe<Scalars['String']['input']>;
    coverage_error_id?: InputMaybe<Scalars['String']['input']>;
    coverage_source?: InputMaybe<CoverageSource>;
    date_of_birth?: InputMaybe<Scalars['String']['input']>;
    ehr_patient_id?: InputMaybe<Scalars['String']['input']>;
    eligibility_payer_code: Scalars['String']['input'];
    end_time?: InputMaybe<Scalars['DateTimeISO']['input']>;
    first_name?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    last_name?: InputMaybe<Scalars['String']['input']>;
    latency?: InputMaybe<Scalars['Int']['input']>;
    member_id?: InputMaybe<Scalars['String']['input']>;
    npi: Scalars['String']['input'];
    org_id: Scalars['String']['input'];
    patient_state: State;
    payer_name: Scalars['String']['input'];
    place_of_service_code: Scalars['String']['input'];
    provider_state?: InputMaybe<State>;
    rate_limit_iterations?: InputMaybe<Scalars['Int']['input']>;
    request_errors?: InputMaybe<CoverageResponsesCreaterequestErrorsInput>;
    request_id: Scalars['String']['input'];
    response_codes?: InputMaybe<Scalars['String']['input']>;
    result?: InputMaybe<AirStatusCode>;
    service_type_code?: InputMaybe<Scalars['String']['input']>;
    session_id?: InputMaybe<Scalars['String']['input']>;
    start_time?: InputMaybe<Scalars['DateTimeISO']['input']>;
    superscript_payer_code: Scalars['String']['input'];
    total_iterations?: InputMaybe<Scalars['Int']['input']>;
    validation_errors?: InputMaybe<CoverageResponsesCreatevalidationErrorsInput>;
};

export type CoverageResponsesCreaterequestErrorsInput = {
    set: Array<Scalars['String']['input']>;
};

export type CoverageResponsesCreatevalidationErrorsInput = {
    set: Array<Scalars['String']['input']>;
};

export type CoverageResponsesGroupBy = {
    __typename?: 'CoverageResponsesGroupBy';
    _avg?: Maybe<CoverageResponsesAvgAggregate>;
    _count?: Maybe<CoverageResponsesCountAggregate>;
    _max?: Maybe<CoverageResponsesMaxAggregate>;
    _min?: Maybe<CoverageResponsesMinAggregate>;
    _sum?: Maybe<CoverageResponsesSumAggregate>;
    communication_error_iterations?: Maybe<Scalars['Int']['output']>;
    concurrency_issue_iterations?: Maybe<Scalars['Int']['output']>;
    consumer_id?: Maybe<Scalars['String']['output']>;
    coverage_error_id?: Maybe<Scalars['String']['output']>;
    coverage_source?: Maybe<CoverageSource>;
    date_of_birth?: Maybe<Scalars['String']['output']>;
    ehr_patient_id?: Maybe<Scalars['String']['output']>;
    eligibility_payer_code: Scalars['String']['output'];
    end_time?: Maybe<Scalars['DateTimeISO']['output']>;
    first_name?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    last_name?: Maybe<Scalars['String']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    member_id?: Maybe<Scalars['String']['output']>;
    npi: Scalars['String']['output'];
    org_id: Scalars['String']['output'];
    patient_state: State;
    payer_name: Scalars['String']['output'];
    place_of_service_code: Scalars['String']['output'];
    provider_state?: Maybe<State>;
    rate_limit_iterations?: Maybe<Scalars['Int']['output']>;
    request_errors?: Maybe<Array<Scalars['String']['output']>>;
    request_id: Scalars['String']['output'];
    response_codes?: Maybe<Scalars['String']['output']>;
    result?: Maybe<AirStatusCode>;
    service_type_code?: Maybe<Scalars['String']['output']>;
    session_id?: Maybe<Scalars['String']['output']>;
    start_time?: Maybe<Scalars['DateTimeISO']['output']>;
    superscript_payer_code: Scalars['String']['output'];
    total_iterations?: Maybe<Scalars['Int']['output']>;
    validation_errors?: Maybe<Array<Scalars['String']['output']>>;
};

export type CoverageResponsesMaxAggregate = {
    __typename?: 'CoverageResponsesMaxAggregate';
    communication_error_iterations?: Maybe<Scalars['Int']['output']>;
    concurrency_issue_iterations?: Maybe<Scalars['Int']['output']>;
    consumer_id?: Maybe<Scalars['String']['output']>;
    coverage_error_id?: Maybe<Scalars['String']['output']>;
    coverage_source?: Maybe<CoverageSource>;
    date_of_birth?: Maybe<Scalars['String']['output']>;
    ehr_patient_id?: Maybe<Scalars['String']['output']>;
    eligibility_payer_code?: Maybe<Scalars['String']['output']>;
    end_time?: Maybe<Scalars['DateTimeISO']['output']>;
    first_name?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    last_name?: Maybe<Scalars['String']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    member_id?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    org_id?: Maybe<Scalars['String']['output']>;
    patient_state?: Maybe<State>;
    payer_name?: Maybe<Scalars['String']['output']>;
    place_of_service_code?: Maybe<Scalars['String']['output']>;
    provider_state?: Maybe<State>;
    rate_limit_iterations?: Maybe<Scalars['Int']['output']>;
    request_id?: Maybe<Scalars['String']['output']>;
    response_codes?: Maybe<Scalars['String']['output']>;
    result?: Maybe<AirStatusCode>;
    service_type_code?: Maybe<Scalars['String']['output']>;
    session_id?: Maybe<Scalars['String']['output']>;
    start_time?: Maybe<Scalars['DateTimeISO']['output']>;
    superscript_payer_code?: Maybe<Scalars['String']['output']>;
    total_iterations?: Maybe<Scalars['Int']['output']>;
};

export type CoverageResponsesMaxOrderByAggregateInput = {
    communication_error_iterations?: InputMaybe<SortOrder>;
    concurrency_issue_iterations?: InputMaybe<SortOrder>;
    consumer_id?: InputMaybe<SortOrder>;
    coverage_error_id?: InputMaybe<SortOrder>;
    coverage_source?: InputMaybe<SortOrder>;
    date_of_birth?: InputMaybe<SortOrder>;
    ehr_patient_id?: InputMaybe<SortOrder>;
    eligibility_payer_code?: InputMaybe<SortOrder>;
    end_time?: InputMaybe<SortOrder>;
    first_name?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    last_name?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    member_id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    patient_state?: InputMaybe<SortOrder>;
    payer_name?: InputMaybe<SortOrder>;
    place_of_service_code?: InputMaybe<SortOrder>;
    provider_state?: InputMaybe<SortOrder>;
    rate_limit_iterations?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    response_codes?: InputMaybe<SortOrder>;
    result?: InputMaybe<SortOrder>;
    service_type_code?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrder>;
    start_time?: InputMaybe<SortOrder>;
    superscript_payer_code?: InputMaybe<SortOrder>;
    total_iterations?: InputMaybe<SortOrder>;
};

export type CoverageResponsesMinAggregate = {
    __typename?: 'CoverageResponsesMinAggregate';
    communication_error_iterations?: Maybe<Scalars['Int']['output']>;
    concurrency_issue_iterations?: Maybe<Scalars['Int']['output']>;
    consumer_id?: Maybe<Scalars['String']['output']>;
    coverage_error_id?: Maybe<Scalars['String']['output']>;
    coverage_source?: Maybe<CoverageSource>;
    date_of_birth?: Maybe<Scalars['String']['output']>;
    ehr_patient_id?: Maybe<Scalars['String']['output']>;
    eligibility_payer_code?: Maybe<Scalars['String']['output']>;
    end_time?: Maybe<Scalars['DateTimeISO']['output']>;
    first_name?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    last_name?: Maybe<Scalars['String']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    member_id?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    org_id?: Maybe<Scalars['String']['output']>;
    patient_state?: Maybe<State>;
    payer_name?: Maybe<Scalars['String']['output']>;
    place_of_service_code?: Maybe<Scalars['String']['output']>;
    provider_state?: Maybe<State>;
    rate_limit_iterations?: Maybe<Scalars['Int']['output']>;
    request_id?: Maybe<Scalars['String']['output']>;
    response_codes?: Maybe<Scalars['String']['output']>;
    result?: Maybe<AirStatusCode>;
    service_type_code?: Maybe<Scalars['String']['output']>;
    session_id?: Maybe<Scalars['String']['output']>;
    start_time?: Maybe<Scalars['DateTimeISO']['output']>;
    superscript_payer_code?: Maybe<Scalars['String']['output']>;
    total_iterations?: Maybe<Scalars['Int']['output']>;
};

export type CoverageResponsesMinOrderByAggregateInput = {
    communication_error_iterations?: InputMaybe<SortOrder>;
    concurrency_issue_iterations?: InputMaybe<SortOrder>;
    consumer_id?: InputMaybe<SortOrder>;
    coverage_error_id?: InputMaybe<SortOrder>;
    coverage_source?: InputMaybe<SortOrder>;
    date_of_birth?: InputMaybe<SortOrder>;
    ehr_patient_id?: InputMaybe<SortOrder>;
    eligibility_payer_code?: InputMaybe<SortOrder>;
    end_time?: InputMaybe<SortOrder>;
    first_name?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    last_name?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    member_id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    patient_state?: InputMaybe<SortOrder>;
    payer_name?: InputMaybe<SortOrder>;
    place_of_service_code?: InputMaybe<SortOrder>;
    provider_state?: InputMaybe<SortOrder>;
    rate_limit_iterations?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    response_codes?: InputMaybe<SortOrder>;
    result?: InputMaybe<SortOrder>;
    service_type_code?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrder>;
    start_time?: InputMaybe<SortOrder>;
    superscript_payer_code?: InputMaybe<SortOrder>;
    total_iterations?: InputMaybe<SortOrder>;
};

export type CoverageResponsesOrderByWithAggregationInput = {
    _avg?: InputMaybe<CoverageResponsesAvgOrderByAggregateInput>;
    _count?: InputMaybe<CoverageResponsesCountOrderByAggregateInput>;
    _max?: InputMaybe<CoverageResponsesMaxOrderByAggregateInput>;
    _min?: InputMaybe<CoverageResponsesMinOrderByAggregateInput>;
    _sum?: InputMaybe<CoverageResponsesSumOrderByAggregateInput>;
    communication_error_iterations?: InputMaybe<SortOrderInput>;
    concurrency_issue_iterations?: InputMaybe<SortOrderInput>;
    consumer_id?: InputMaybe<SortOrderInput>;
    coverage_error_id?: InputMaybe<SortOrderInput>;
    coverage_source?: InputMaybe<SortOrderInput>;
    date_of_birth?: InputMaybe<SortOrderInput>;
    ehr_patient_id?: InputMaybe<SortOrderInput>;
    eligibility_payer_code?: InputMaybe<SortOrder>;
    end_time?: InputMaybe<SortOrderInput>;
    first_name?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    last_name?: InputMaybe<SortOrderInput>;
    latency?: InputMaybe<SortOrderInput>;
    member_id?: InputMaybe<SortOrderInput>;
    npi?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    patient_state?: InputMaybe<SortOrder>;
    payer_name?: InputMaybe<SortOrder>;
    place_of_service_code?: InputMaybe<SortOrder>;
    provider_state?: InputMaybe<SortOrderInput>;
    rate_limit_iterations?: InputMaybe<SortOrderInput>;
    request_errors?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    response_codes?: InputMaybe<SortOrderInput>;
    result?: InputMaybe<SortOrderInput>;
    service_type_code?: InputMaybe<SortOrderInput>;
    session_id?: InputMaybe<SortOrderInput>;
    start_time?: InputMaybe<SortOrderInput>;
    superscript_payer_code?: InputMaybe<SortOrder>;
    total_iterations?: InputMaybe<SortOrderInput>;
    validation_errors?: InputMaybe<SortOrder>;
};

export type CoverageResponsesOrderByWithRelationInput = {
    communication_error_iterations?: InputMaybe<SortOrderInput>;
    concurrency_issue_iterations?: InputMaybe<SortOrderInput>;
    consumer_id?: InputMaybe<SortOrderInput>;
    coverage_error_id?: InputMaybe<SortOrderInput>;
    coverage_source?: InputMaybe<SortOrderInput>;
    date_of_birth?: InputMaybe<SortOrderInput>;
    ehr_patient_id?: InputMaybe<SortOrderInput>;
    eligibility_payer_code?: InputMaybe<SortOrder>;
    end_time?: InputMaybe<SortOrderInput>;
    first_name?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    last_name?: InputMaybe<SortOrderInput>;
    latency?: InputMaybe<SortOrderInput>;
    member_id?: InputMaybe<SortOrderInput>;
    npi?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    patient_state?: InputMaybe<SortOrder>;
    payer_name?: InputMaybe<SortOrder>;
    place_of_service_code?: InputMaybe<SortOrder>;
    provider_state?: InputMaybe<SortOrderInput>;
    rate_limit_iterations?: InputMaybe<SortOrderInput>;
    request_errors?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    response_codes?: InputMaybe<SortOrderInput>;
    result?: InputMaybe<SortOrderInput>;
    service_type_code?: InputMaybe<SortOrderInput>;
    session_id?: InputMaybe<SortOrderInput>;
    start_time?: InputMaybe<SortOrderInput>;
    superscript_payer_code?: InputMaybe<SortOrder>;
    total_iterations?: InputMaybe<SortOrderInput>;
    validation_errors?: InputMaybe<SortOrder>;
};

export enum CoverageResponsesScalarFieldEnum {
    CommunicationErrorIterations = 'communication_error_iterations',
    ConcurrencyIssueIterations = 'concurrency_issue_iterations',
    ConsumerId = 'consumer_id',
    CoverageErrorId = 'coverage_error_id',
    CoverageSource = 'coverage_source',
    DateOfBirth = 'date_of_birth',
    EhrPatientId = 'ehr_patient_id',
    EligibilityPayerCode = 'eligibility_payer_code',
    EndTime = 'end_time',
    FirstName = 'first_name',
    Id = 'id',
    LastName = 'last_name',
    Latency = 'latency',
    MemberId = 'member_id',
    Npi = 'npi',
    OrgId = 'org_id',
    PatientState = 'patient_state',
    PayerName = 'payer_name',
    PlaceOfServiceCode = 'place_of_service_code',
    ProviderState = 'provider_state',
    RateLimitIterations = 'rate_limit_iterations',
    RequestErrors = 'request_errors',
    RequestId = 'request_id',
    ResponseCodes = 'response_codes',
    Result = 'result',
    ServiceTypeCode = 'service_type_code',
    SessionId = 'session_id',
    StartTime = 'start_time',
    SuperscriptPayerCode = 'superscript_payer_code',
    TotalIterations = 'total_iterations',
    ValidationErrors = 'validation_errors',
}

export type CoverageResponsesScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<CoverageResponsesScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<CoverageResponsesScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<CoverageResponsesScalarWhereWithAggregatesInput>>;
    communication_error_iterations?: InputMaybe<IntNullableWithAggregatesFilter>;
    concurrency_issue_iterations?: InputMaybe<IntNullableWithAggregatesFilter>;
    consumer_id?: InputMaybe<StringNullableWithAggregatesFilter>;
    coverage_error_id?: InputMaybe<StringNullableWithAggregatesFilter>;
    coverage_source?: InputMaybe<EnumCoverageSourceNullableWithAggregatesFilter>;
    date_of_birth?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehr_patient_id?: InputMaybe<StringNullableWithAggregatesFilter>;
    eligibility_payer_code?: InputMaybe<StringWithAggregatesFilter>;
    end_time?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    first_name?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    last_name?: InputMaybe<StringNullableWithAggregatesFilter>;
    latency?: InputMaybe<IntNullableWithAggregatesFilter>;
    member_id?: InputMaybe<StringNullableWithAggregatesFilter>;
    npi?: InputMaybe<StringWithAggregatesFilter>;
    org_id?: InputMaybe<StringWithAggregatesFilter>;
    patient_state?: InputMaybe<EnumStateWithAggregatesFilter>;
    payer_name?: InputMaybe<StringWithAggregatesFilter>;
    place_of_service_code?: InputMaybe<StringWithAggregatesFilter>;
    provider_state?: InputMaybe<EnumStateNullableWithAggregatesFilter>;
    rate_limit_iterations?: InputMaybe<IntNullableWithAggregatesFilter>;
    request_errors?: InputMaybe<StringNullableListFilter>;
    request_id?: InputMaybe<StringWithAggregatesFilter>;
    response_codes?: InputMaybe<StringNullableWithAggregatesFilter>;
    result?: InputMaybe<EnumAirStatusCodeNullableWithAggregatesFilter>;
    service_type_code?: InputMaybe<StringNullableWithAggregatesFilter>;
    session_id?: InputMaybe<StringNullableWithAggregatesFilter>;
    start_time?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    superscript_payer_code?: InputMaybe<StringWithAggregatesFilter>;
    total_iterations?: InputMaybe<IntNullableWithAggregatesFilter>;
    validation_errors?: InputMaybe<StringNullableListFilter>;
};

export type CoverageResponsesSumAggregate = {
    __typename?: 'CoverageResponsesSumAggregate';
    communication_error_iterations?: Maybe<Scalars['Int']['output']>;
    concurrency_issue_iterations?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    rate_limit_iterations?: Maybe<Scalars['Int']['output']>;
    total_iterations?: Maybe<Scalars['Int']['output']>;
};

export type CoverageResponsesSumOrderByAggregateInput = {
    communication_error_iterations?: InputMaybe<SortOrder>;
    concurrency_issue_iterations?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    rate_limit_iterations?: InputMaybe<SortOrder>;
    total_iterations?: InputMaybe<SortOrder>;
};

export type CoverageResponsesUpdateInput = {
    communication_error_iterations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    concurrency_issue_iterations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    consumer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    coverage_error_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    coverage_source?: InputMaybe<NullableEnumCoverageSourceFieldUpdateOperationsInput>;
    date_of_birth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehr_patient_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    eligibility_payer_code?: InputMaybe<StringFieldUpdateOperationsInput>;
    end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    first_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    last_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    latency?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    member_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    npi?: InputMaybe<StringFieldUpdateOperationsInput>;
    org_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    patient_state?: InputMaybe<EnumStateFieldUpdateOperationsInput>;
    payer_name?: InputMaybe<StringFieldUpdateOperationsInput>;
    place_of_service_code?: InputMaybe<StringFieldUpdateOperationsInput>;
    provider_state?: InputMaybe<NullableEnumStateFieldUpdateOperationsInput>;
    rate_limit_iterations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    request_errors?: InputMaybe<CoverageResponsesUpdaterequestErrorsInput>;
    request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    response_codes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    result?: InputMaybe<NullableEnumAirStatusCodeFieldUpdateOperationsInput>;
    service_type_code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    superscript_payer_code?: InputMaybe<StringFieldUpdateOperationsInput>;
    total_iterations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    validation_errors?: InputMaybe<CoverageResponsesUpdatevalidationErrorsInput>;
};

export type CoverageResponsesUpdateManyMutationInput = {
    communication_error_iterations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    concurrency_issue_iterations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    consumer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    coverage_error_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    coverage_source?: InputMaybe<NullableEnumCoverageSourceFieldUpdateOperationsInput>;
    date_of_birth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehr_patient_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    eligibility_payer_code?: InputMaybe<StringFieldUpdateOperationsInput>;
    end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    first_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    last_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    latency?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    member_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    npi?: InputMaybe<StringFieldUpdateOperationsInput>;
    org_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    patient_state?: InputMaybe<EnumStateFieldUpdateOperationsInput>;
    payer_name?: InputMaybe<StringFieldUpdateOperationsInput>;
    place_of_service_code?: InputMaybe<StringFieldUpdateOperationsInput>;
    provider_state?: InputMaybe<NullableEnumStateFieldUpdateOperationsInput>;
    rate_limit_iterations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    request_errors?: InputMaybe<CoverageResponsesUpdaterequestErrorsInput>;
    request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    response_codes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    result?: InputMaybe<NullableEnumAirStatusCodeFieldUpdateOperationsInput>;
    service_type_code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    superscript_payer_code?: InputMaybe<StringFieldUpdateOperationsInput>;
    total_iterations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    validation_errors?: InputMaybe<CoverageResponsesUpdatevalidationErrorsInput>;
};

export type CoverageResponsesUpdaterequestErrorsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CoverageResponsesUpdatevalidationErrorsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CoverageResponsesWhereInput = {
    AND?: InputMaybe<Array<CoverageResponsesWhereInput>>;
    NOT?: InputMaybe<Array<CoverageResponsesWhereInput>>;
    OR?: InputMaybe<Array<CoverageResponsesWhereInput>>;
    communication_error_iterations?: InputMaybe<IntNullableFilter>;
    concurrency_issue_iterations?: InputMaybe<IntNullableFilter>;
    consumer_id?: InputMaybe<StringNullableFilter>;
    coverage_error_id?: InputMaybe<StringNullableFilter>;
    coverage_source?: InputMaybe<EnumCoverageSourceNullableFilter>;
    date_of_birth?: InputMaybe<StringNullableFilter>;
    ehr_patient_id?: InputMaybe<StringNullableFilter>;
    eligibility_payer_code?: InputMaybe<StringFilter>;
    end_time?: InputMaybe<DateTimeNullableFilter>;
    first_name?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    last_name?: InputMaybe<StringNullableFilter>;
    latency?: InputMaybe<IntNullableFilter>;
    member_id?: InputMaybe<StringNullableFilter>;
    npi?: InputMaybe<StringFilter>;
    org_id?: InputMaybe<StringFilter>;
    patient_state?: InputMaybe<EnumStateFilter>;
    payer_name?: InputMaybe<StringFilter>;
    place_of_service_code?: InputMaybe<StringFilter>;
    provider_state?: InputMaybe<EnumStateNullableFilter>;
    rate_limit_iterations?: InputMaybe<IntNullableFilter>;
    request_errors?: InputMaybe<StringNullableListFilter>;
    request_id?: InputMaybe<StringFilter>;
    response_codes?: InputMaybe<StringNullableFilter>;
    result?: InputMaybe<EnumAirStatusCodeNullableFilter>;
    service_type_code?: InputMaybe<StringNullableFilter>;
    session_id?: InputMaybe<StringNullableFilter>;
    start_time?: InputMaybe<DateTimeNullableFilter>;
    superscript_payer_code?: InputMaybe<StringFilter>;
    total_iterations?: InputMaybe<IntNullableFilter>;
    validation_errors?: InputMaybe<StringNullableListFilter>;
};

export type CoverageResponsesWhereUniqueInput = {
    AND?: InputMaybe<Array<CoverageResponsesWhereInput>>;
    NOT?: InputMaybe<Array<CoverageResponsesWhereInput>>;
    OR?: InputMaybe<Array<CoverageResponsesWhereInput>>;
    communication_error_iterations?: InputMaybe<IntNullableFilter>;
    concurrency_issue_iterations?: InputMaybe<IntNullableFilter>;
    consumer_id?: InputMaybe<StringNullableFilter>;
    coverage_error_id?: InputMaybe<StringNullableFilter>;
    coverage_source?: InputMaybe<EnumCoverageSourceNullableFilter>;
    date_of_birth?: InputMaybe<StringNullableFilter>;
    ehr_patient_id?: InputMaybe<StringNullableFilter>;
    eligibility_payer_code?: InputMaybe<StringFilter>;
    end_time?: InputMaybe<DateTimeNullableFilter>;
    first_name?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    last_name?: InputMaybe<StringNullableFilter>;
    latency?: InputMaybe<IntNullableFilter>;
    member_id?: InputMaybe<StringNullableFilter>;
    npi?: InputMaybe<StringFilter>;
    org_id?: InputMaybe<StringFilter>;
    patient_state?: InputMaybe<EnumStateFilter>;
    payer_name?: InputMaybe<StringFilter>;
    place_of_service_code?: InputMaybe<StringFilter>;
    provider_state?: InputMaybe<EnumStateNullableFilter>;
    rate_limit_iterations?: InputMaybe<IntNullableFilter>;
    request_errors?: InputMaybe<StringNullableListFilter>;
    request_id?: InputMaybe<StringFilter>;
    response_codes?: InputMaybe<StringNullableFilter>;
    result?: InputMaybe<EnumAirStatusCodeNullableFilter>;
    service_type_code?: InputMaybe<StringNullableFilter>;
    session_id?: InputMaybe<StringNullableFilter>;
    start_time?: InputMaybe<DateTimeNullableFilter>;
    superscript_payer_code?: InputMaybe<StringFilter>;
    total_iterations?: InputMaybe<IntNullableFilter>;
    validation_errors?: InputMaybe<StringNullableListFilter>;
};

export type CptExclusivityEdge = {
    __typename?: 'CptExclusivityEdge';
    codeA: Scalars['String']['output'];
    codeB: Scalars['String']['output'];
    relationType: CptRelationType;
};

export type CptExclusivityEdgeCodeACodeBCompoundUniqueInput = {
    codeA: Scalars['String']['input'];
    codeB: Scalars['String']['input'];
};

export type CptExclusivityEdgeCountAggregate = {
    __typename?: 'CptExclusivityEdgeCountAggregate';
    _all: Scalars['Int']['output'];
    codeA: Scalars['Int']['output'];
    codeB: Scalars['Int']['output'];
    relationType: Scalars['Int']['output'];
};

export type CptExclusivityEdgeCountOrderByAggregateInput = {
    codeA?: InputMaybe<SortOrder>;
    codeB?: InputMaybe<SortOrder>;
    relationType?: InputMaybe<SortOrder>;
};

export type CptExclusivityEdgeCreateInput = {
    codeA: Scalars['String']['input'];
    codeB: Scalars['String']['input'];
    relationType: CptRelationType;
};

export type CptExclusivityEdgeCreateManyInput = {
    codeA: Scalars['String']['input'];
    codeB: Scalars['String']['input'];
    relationType: CptRelationType;
};

export type CptExclusivityEdgeGroupBy = {
    __typename?: 'CptExclusivityEdgeGroupBy';
    _count?: Maybe<CptExclusivityEdgeCountAggregate>;
    _max?: Maybe<CptExclusivityEdgeMaxAggregate>;
    _min?: Maybe<CptExclusivityEdgeMinAggregate>;
    codeA: Scalars['String']['output'];
    codeB: Scalars['String']['output'];
    relationType: CptRelationType;
};

export type CptExclusivityEdgeMaxAggregate = {
    __typename?: 'CptExclusivityEdgeMaxAggregate';
    codeA?: Maybe<Scalars['String']['output']>;
    codeB?: Maybe<Scalars['String']['output']>;
    relationType?: Maybe<CptRelationType>;
};

export type CptExclusivityEdgeMaxOrderByAggregateInput = {
    codeA?: InputMaybe<SortOrder>;
    codeB?: InputMaybe<SortOrder>;
    relationType?: InputMaybe<SortOrder>;
};

export type CptExclusivityEdgeMinAggregate = {
    __typename?: 'CptExclusivityEdgeMinAggregate';
    codeA?: Maybe<Scalars['String']['output']>;
    codeB?: Maybe<Scalars['String']['output']>;
    relationType?: Maybe<CptRelationType>;
};

export type CptExclusivityEdgeMinOrderByAggregateInput = {
    codeA?: InputMaybe<SortOrder>;
    codeB?: InputMaybe<SortOrder>;
    relationType?: InputMaybe<SortOrder>;
};

export type CptExclusivityEdgeOrderByWithAggregationInput = {
    _count?: InputMaybe<CptExclusivityEdgeCountOrderByAggregateInput>;
    _max?: InputMaybe<CptExclusivityEdgeMaxOrderByAggregateInput>;
    _min?: InputMaybe<CptExclusivityEdgeMinOrderByAggregateInput>;
    codeA?: InputMaybe<SortOrder>;
    codeB?: InputMaybe<SortOrder>;
    relationType?: InputMaybe<SortOrder>;
};

export type CptExclusivityEdgeOrderByWithRelationInput = {
    codeA?: InputMaybe<SortOrder>;
    codeB?: InputMaybe<SortOrder>;
    relationType?: InputMaybe<SortOrder>;
};

export enum CptExclusivityEdgeScalarFieldEnum {
    CodeA = 'codeA',
    CodeB = 'codeB',
    RelationType = 'relationType',
}

export type CptExclusivityEdgeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<CptExclusivityEdgeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<CptExclusivityEdgeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<CptExclusivityEdgeScalarWhereWithAggregatesInput>>;
    codeA?: InputMaybe<StringWithAggregatesFilter>;
    codeB?: InputMaybe<StringWithAggregatesFilter>;
    relationType?: InputMaybe<EnumCptRelationTypeWithAggregatesFilter>;
};

export type CptExclusivityEdgeUpdateInput = {
    codeA?: InputMaybe<StringFieldUpdateOperationsInput>;
    codeB?: InputMaybe<StringFieldUpdateOperationsInput>;
    relationType?: InputMaybe<EnumCptRelationTypeFieldUpdateOperationsInput>;
};

export type CptExclusivityEdgeUpdateManyMutationInput = {
    codeA?: InputMaybe<StringFieldUpdateOperationsInput>;
    codeB?: InputMaybe<StringFieldUpdateOperationsInput>;
    relationType?: InputMaybe<EnumCptRelationTypeFieldUpdateOperationsInput>;
};

export type CptExclusivityEdgeWhereInput = {
    AND?: InputMaybe<Array<CptExclusivityEdgeWhereInput>>;
    NOT?: InputMaybe<Array<CptExclusivityEdgeWhereInput>>;
    OR?: InputMaybe<Array<CptExclusivityEdgeWhereInput>>;
    codeA?: InputMaybe<StringFilter>;
    codeB?: InputMaybe<StringFilter>;
    relationType?: InputMaybe<EnumCptRelationTypeFilter>;
};

export type CptExclusivityEdgeWhereUniqueInput = {
    AND?: InputMaybe<Array<CptExclusivityEdgeWhereInput>>;
    NOT?: InputMaybe<Array<CptExclusivityEdgeWhereInput>>;
    OR?: InputMaybe<Array<CptExclusivityEdgeWhereInput>>;
    codeA?: InputMaybe<StringFilter>;
    codeA_codeB?: InputMaybe<CptExclusivityEdgeCodeACodeBCompoundUniqueInput>;
    codeB?: InputMaybe<StringFilter>;
    relationType?: InputMaybe<EnumCptRelationTypeFilter>;
};

export enum CptRelationType {
    Contrast = 'contrast',
    Laterality = 'laterality',
    NewVsEstablished = 'new_vs_established',
    ReferenceVsBiosimilar = 'reference_vs_biosimilar',
    RouteOfAdministration = 'route_of_administration',
    ScreeningVsDiagnostic = 'screening_vs_diagnostic',
    Severity = 'severity',
    TherapeuticAlternative = 'therapeutic_alternative',
    ViewCount = 'view_count',
}

export type CreateAdjudicationDto = {
    allowedAmount: Scalars['Float']['input'];
    boughtTreatmentByPaymentTypeMap: BoughtTreatmentByPaymentTypeMap;
    claimId?: InputMaybe<Scalars['String']['input']>;
    logId?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    slotId: Scalars['String']['input'];
    type: AdjudicationType;
    visitId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInsuranceResponse = {
    __typename?: 'CreateInsuranceResponse';
    _count?: Maybe<InsuranceCount>;
    consumer?: Maybe<Consumer>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    ehrWriteError?: Maybe<Scalars['Boolean']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance: Scalars['Boolean']['output'];
    lastCheckedAt: Scalars['DateTimeISO']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId: Scalars['String']['output'];
    otherInsurances?: Maybe<Scalars['JSON']['output']>;
    payer: Scalars['String']['output'];
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    photos: Array<ConsumerPhotoMetaData>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status: InsurancesStatusEnum;
    subscriberInfo?: Maybe<Scalars['JSON']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateInsuranceResponseConsumerArgs = {
    where?: InputMaybe<ConsumerWhereInput>;
};

export type CreateInsuranceResponsePhotosArgs = {
    cursor?: InputMaybe<ConsumerPhotoMetaDataWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerPhotoMetaDataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerPhotoMetaDataOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type CreateInsuranceWithEhrInput = {
    insurance: InsuranceCreateInput;
    orgId: Scalars['Float']['input'];
    payerId?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateManyAndReturnAdjudication = {
    __typename?: 'CreateManyAndReturnAdjudication';
    adjudicatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjudicationAction?: Maybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: Maybe<AdjudicationAppliedStatusEnum>;
    adjudicationType: ArtClaimStatusEnum;
    boughtTreatmentId: Scalars['String']['output'];
    claimId: Scalars['String']['output'];
    claimPayout: Scalars['Float']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrLedgerRowId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds?: Maybe<Array<Scalars['String']['output']>>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentMethodType?: Maybe<AdjudicationPaymentMethodEnum>;
    paymentType: PaymentTypeEnum;
    procedureCode: Scalars['String']['output'];
    secondaryClaimId?: Maybe<Scalars['String']['output']>;
    secondaryClaimIdType?: Maybe<EhrPostIdentifierTypeEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptResponsibility: Scalars['Float']['output'];
    transferredAmount: Scalars['Float']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnAdjudicationAuditLog = {
    __typename?: 'CreateManyAndReturnAdjudicationAuditLog';
    adjudicatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjudicationAction?: Maybe<AdjudicationActionEnum>;
    adjudicationAppliedStatus?: Maybe<AdjudicationAppliedStatusEnum>;
    adjudicationId?: Maybe<Scalars['String']['output']>;
    adjudicationType?: Maybe<ArtClaimStatusEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimPayout?: Maybe<Scalars['Float']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrLedgerRowId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds?: Maybe<Array<Scalars['String']['output']>>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<AdjudicationPaymentMethodEnum>;
    paymentType?: Maybe<PaymentTypeEnum>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    secondaryClaimId?: Maybe<Scalars['String']['output']>;
    secondaryClaimIdType?: Maybe<EhrPostIdentifierTypeEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptResponsibility?: Maybe<Scalars['Float']['output']>;
    transferredAmount?: Maybe<Scalars['Float']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnAdjustment = {
    __typename?: 'CreateManyAndReturnAdjustment';
    adjustedBoughtTreatmentPrice: Scalars['Float']['output'];
    adjustmentAmount: Scalars['Float']['output'];
    adjustmentAppliedStatus?: Maybe<AdjustmentAppliedStatusEnum>;
    adjustmentType: AdjustmentTypeEnum;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    boughtTreatmentId: Scalars['String']['output'];
    claimIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds?: Maybe<Array<Scalars['String']['output']>>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    ehrReconciliationTransactionIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    originalBoughtTreatmentPrice: Scalars['Float']['output'];
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    procedureCodes?: Maybe<Array<Scalars['String']['output']>>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
    slotId: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnAdjustmentAuditLog = {
    __typename?: 'CreateManyAndReturnAdjustmentAuditLog';
    adjustedBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    adjustmentAmount?: Maybe<Scalars['Float']['output']>;
    adjustmentAppliedStatus?: Maybe<AdjustmentAppliedStatusEnum>;
    adjustmentId?: Maybe<Scalars['String']['output']>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    autoRefundAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerIds?: Maybe<Array<Scalars['String']['output']>>;
    ehrReconciliationAmount?: Maybe<Scalars['Float']['output']>;
    ehrReconciliationTransactionIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    moneyRefundAmount?: Maybe<Scalars['Float']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    originalBoughtTreatmentPrice?: Maybe<Scalars['Float']['output']>;
    priceSwapAdjustmentValue?: Maybe<Scalars['Float']['output']>;
    procedureCodes?: Maybe<Array<Scalars['String']['output']>>;
    refundFromCollectedAmount?: Maybe<Scalars['Float']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnAppointment = {
    __typename?: 'CreateManyAndReturnAppointment';
    arrivalStatusChangedBy?: Maybe<Scalars['String']['output']>;
    arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInBy?: Maybe<Scalars['String']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    intakeBypassed: Scalars['Boolean']['output'];
    intakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    sendToBalanceNotes?: Maybe<Scalars['String']['output']>;
    status: AppointmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnAppointmentAuditLog = {
    __typename?: 'CreateManyAndReturnAppointmentAuditLog';
    appointmentId: Scalars['String']['output'];
    arrivalStatusChangedBy?: Maybe<Scalars['String']['output']>;
    arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInAt?: Maybe<Scalars['DateTimeISO']['output']>;
    checkedInBy?: Maybe<Scalars['String']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    completedIntakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    id: Scalars['Int']['output'];
    intakeBypassed: Scalars['Boolean']['output'];
    intakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    lastUpdatedAt: Scalars['DateTimeISO']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    status: AppointmentStatusEnum;
};

export type CreateManyAndReturnArrearBilling = {
    __typename?: 'CreateManyAndReturnArrearBilling';
    amount: Scalars['Decimal']['output'];
    billReason: BillReason;
    date: Scalars['DateTimeISO']['output'];
    encounterId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    invoiceId?: Maybe<Scalars['Int']['output']>;
    orgId: Scalars['Int']['output'];
    slotId?: Maybe<Scalars['String']['output']>;
    status: BillStatus;
    transactionId?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnArtClaim = {
    __typename?: 'CreateManyAndReturnArtClaim';
    artNotes?: Maybe<Array<Scalars['String']['output']>>;
    claimId: Scalars['String']['output'];
    claimLastUpdated?: Maybe<Scalars['DateTimeISO']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfRecentTransfer?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService: Scalars['DateTimeISO']['output'];
    departmentId?: Maybe<Scalars['String']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    firstCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    inboundSourceId?: Maybe<Scalars['String']['output']>;
    lastCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    manualReviewReasons?: Maybe<Array<Scalars['String']['output']>>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes?: Maybe<Array<Scalars['String']['output']>>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance: Scalars['Float']['output'];
    originalPrimaryPayerBalance: Scalars['Float']['output'];
    originalSecondaryPayerBalance: Scalars['Float']['output'];
    patientBalance: Scalars['Float']['output'];
    patientEnterpriseId?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    patientRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    patientStatus?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerBalance: Scalars['Float']['output'];
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    primaryPayerStatus?: Maybe<Scalars['String']['output']>;
    primaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    procedureCodes?: Maybe<Array<Scalars['String']['output']>>;
    reviewNotes?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerBalance: Scalars['Float']['output'];
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    secondaryPayerStatus?: Maybe<Scalars['String']['output']>;
    secondaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    slotIds?: Maybe<Array<Scalars['String']['output']>>;
    status?: Maybe<ArtClaimStatusEnum>;
    statusReason?: Maybe<Scalars['String']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
    unscheduledBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    visitId?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnArtClaimAuditLog = {
    __typename?: 'CreateManyAndReturnArtClaimAuditLog';
    artClaimId?: Maybe<Scalars['String']['output']>;
    artNotes?: Maybe<Array<Scalars['String']['output']>>;
    claimId?: Maybe<Scalars['String']['output']>;
    claimLastUpdated?: Maybe<Scalars['DateTimeISO']['output']>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfRecentTransfer?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    departmentId?: Maybe<Scalars['String']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    ehrPatientBalance?: Maybe<Scalars['Float']['output']>;
    firstCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    inboundSourceId?: Maybe<Scalars['String']['output']>;
    lastCommunicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    manualReviewReasons?: Maybe<Array<Scalars['String']['output']>>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    notes?: Maybe<Array<Scalars['String']['output']>>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientBalance?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    patientBalance?: Maybe<Scalars['Float']['output']>;
    patientEnterpriseId?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    patientRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    patientStatus?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    primaryPayerStatus?: Maybe<Scalars['String']['output']>;
    primaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    procedureCodes?: Maybe<Array<Scalars['String']['output']>>;
    reviewNotes?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerBalance?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    secondaryPayerStatus?: Maybe<Scalars['String']['output']>;
    secondaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    slotIds?: Maybe<Array<Scalars['String']['output']>>;
    status?: Maybe<ArtClaimStatusEnum>;
    statusReason?: Maybe<Scalars['String']['output']>;
    totalAdjudicatedResponsibility?: Maybe<Scalars['Float']['output']>;
    totalAdjustedOffPlatform?: Maybe<Scalars['Float']['output']>;
    totalArtTransferredAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedBySuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    totalPostedOffPlatform?: Maybe<Scalars['Float']['output']>;
    unscheduledBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    visitId?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnArtClaimCptLine = {
    __typename?: 'CreateManyAndReturnArtClaimCptLine';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    artClaim: ArtClaim;
    artClaimId: Scalars['String']['output'];
    billedAmount?: Maybe<Scalars['Float']['output']>;
    claimId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfService: Scalars['DateTimeISO']['output'];
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    highConfidenceBoughtTreatmentIds?: Maybe<
        Array<Scalars['String']['output']>
    >;
    id: Scalars['String']['output'];
    isClosedOut?: Maybe<Scalars['Boolean']['output']>;
    isDenied?: Maybe<Scalars['Boolean']['output']>;
    isFullyCovered?: Maybe<Scalars['Boolean']['output']>;
    isOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
    isSelfPay?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    noShowFeeFlag?: Maybe<Scalars['Boolean']['output']>;
    orgId: Scalars['Int']['output'];
    patientClaimStatus?: Maybe<Scalars['String']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    primaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    procedureCode: Scalars['String']['output'];
    procedureDescription?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    secondaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
    unusualChargeFlag?: Maybe<Scalars['Boolean']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnArtClaimCptLineAuditLog = {
    __typename?: 'CreateManyAndReturnArtClaimCptLineAuditLog';
    adjudicatedSuperscriptGuaranteeAmount?: Maybe<Scalars['Float']['output']>;
    allowable?: Maybe<Scalars['Float']['output']>;
    artClaimCptLineId?: Maybe<Scalars['String']['output']>;
    artClaimId?: Maybe<Scalars['String']['output']>;
    billedAmount?: Maybe<Scalars['Float']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    displacedSuperscriptAmount?: Maybe<Scalars['Float']['output']>;
    ehrCollectionsBalance?: Maybe<Scalars['Float']['output']>;
    externalAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
    externalPaymentAmount?: Maybe<Scalars['Float']['output']>;
    highConfidenceBoughtTreatmentIds?: Maybe<
        Array<Scalars['String']['output']>
    >;
    id: Scalars['Int']['output'];
    isClosedOut?: Maybe<Scalars['Boolean']['output']>;
    isDenied?: Maybe<Scalars['Boolean']['output']>;
    isFullyCovered?: Maybe<Scalars['Boolean']['output']>;
    isOutOfNetwork?: Maybe<Scalars['Boolean']['output']>;
    isSelfPay?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    noShowFeeFlag?: Maybe<Scalars['Boolean']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    patientClaimStatus?: Maybe<Scalars['String']['output']>;
    patientOtherAmount?: Maybe<Scalars['Float']['output']>;
    patientRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    patientResponsibilityOriginal?: Maybe<Scalars['Float']['output']>;
    patientResponsibilityOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    primaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    primaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    primaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    primaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    primaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    primaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    primaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    primaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    procedureDescription?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
    secondaryCoinsuranceAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    secondaryContractualAmount?: Maybe<Scalars['Float']['output']>;
    secondaryCopayAmount?: Maybe<Scalars['Float']['output']>;
    secondaryDeductibleAmount?: Maybe<Scalars['Float']['output']>;
    secondaryOtherAmount?: Maybe<Scalars['Float']['output']>;
    secondaryPayerOutstanding?: Maybe<Scalars['Float']['output']>;
    secondaryPayerPayment?: Maybe<Scalars['Float']['output']>;
    secondaryRemarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    totalAdjudicatedSuperscriptResponsibility?: Maybe<
        Scalars['Float']['output']
    >;
    unusualChargeFlag?: Maybe<Scalars['Boolean']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnBillingTableDownloadRequest = {
    __typename?: 'CreateManyAndReturnBillingTableDownloadRequest';
    adminId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    filters?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    status: BillingTableDownloadStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnBoughtTreatment = {
    __typename?: 'CreateManyAndReturnBoughtTreatment';
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    discountCodeApplied?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['String']['output'];
    insuranceIds?: Maybe<Array<Scalars['String']['output']>>;
    isVirtual: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentContactId?: Maybe<Scalars['String']['output']>;
    paymentType: PaymentTypeEnum;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price: Scalars['Float']['output'];
    pricedTreatmentId: Scalars['Int']['output'];
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slot?: Maybe<Slot>;
    slotId?: Maybe<Scalars['String']['output']>;
    source: EncounterSourceEnum;
    status: BoughtTreatmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnBoughtTreatmentSlotArgs = {
    where?: InputMaybe<SlotWhereInput>;
};

export type CreateManyAndReturnBoughtTreatmentAuditLog = {
    __typename?: 'CreateManyAndReturnBoughtTreatmentAuditLog';
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    consumerId?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    insuranceIds?: Maybe<Array<Scalars['String']['output']>>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentType?: Maybe<PaymentTypeEnum>;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    source?: Maybe<EncounterSourceEnum>;
    status?: Maybe<BoughtTreatmentStatusEnum>;
};

export type CreateManyAndReturnBoughtTreatmentClaimDetail = {
    __typename?: 'CreateManyAndReturnBoughtTreatmentClaimDetail';
    boughtTreatmentId: Scalars['String']['output'];
    claimIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    inCollections?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    procedureCodes?: Maybe<Array<Scalars['String']['output']>>;
    remarkCodes?: Maybe<Array<Scalars['String']['output']>>;
    swapReason?: Maybe<PriceSwapReasonEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnBulkChargeCardRun = {
    __typename?: 'CreateManyAndReturnBulkChargeCardRun';
    createdAt: Scalars['DateTimeISO']['output'];
    createdBy: Scalars['String']['output'];
    csvS3Key?: Maybe<Scalars['String']['output']>;
    failedCount: Scalars['Int']['output'];
    id: Scalars['String']['output'];
    isDryRun: Scalars['Boolean']['output'];
    orgId: Scalars['Int']['output'];
    orgName: Scalars['String']['output'];
    runDate: Scalars['String']['output'];
    skippedCount: Scalars['Int']['output'];
    status: Scalars['String']['output'];
    succeededCount: Scalars['Int']['output'];
    totalItems: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnBulkChargeCardRunItem = {
    __typename?: 'CreateManyAndReturnBulkChargeCardRunItem';
    amountDollars: Scalars['Decimal']['output'];
    appointmentId: Scalars['String']['output'];
    boughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    bulkChargeCardRunId: Scalars['String']['output'];
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    chargedAmountDollars?: Maybe<Scalars['Decimal']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    errorMessage?: Maybe<Scalars['String']['output']>;
    errorReason?: Maybe<Scalars['String']['output']>;
    filteredBtIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['String']['output'];
    paymentIntentId?: Maybe<Scalars['String']['output']>;
    run: BulkChargeCardRun;
    status: Scalars['String']['output'];
    transactionIds?: Maybe<Array<Scalars['String']['output']>>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userId: Scalars['String']['output'];
};

export type CreateManyAndReturnBusinessHour = {
    __typename?: 'CreateManyAndReturnBusinessHour';
    closeTime?: Maybe<Scalars['String']['output']>;
    dayOfWeek: Scalars['Int']['output'];
    id: Scalars['String']['output'];
    isEnabled: Scalars['Boolean']['output'];
    openTime?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
};

export type CreateManyAndReturnCandidateTreatment = {
    __typename?: 'CreateManyAndReturnCandidateTreatment';
    boughtTreatment?: Maybe<BoughtTreatment>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrtDisplayName?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    modelVersion?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    predictedCpt: Scalars['String']['output'];
    price?: Maybe<Scalars['Float']['output']>;
    pricedTreatmentId?: Maybe<Scalars['Int']['output']>;
    pricingStatus: CandidateTreatmentPricingStatusEnum;
    probability: Scalars['Float']['output'];
    rank: Scalars['Int']['output'];
    relationType?: Maybe<CptRelationType>;
    scoredAt: Scalars['DateTimeISO']['output'];
    slot: Slot;
    slotId: Scalars['String']['output'];
    source?: Maybe<Scalars['String']['output']>;
    status: CandidateTreatmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnCandidateTreatmentBoughtTreatmentArgs = {
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type CreateManyAndReturnCharge = {
    __typename?: 'CreateManyAndReturnCharge';
    boughtTreatmentId: Scalars['String']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    payoutIds?: Maybe<Array<Scalars['String']['output']>>;
    reattributionState?: Maybe<ReattributionState>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptFee?: Maybe<SuperscriptFees>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    total: Scalars['Decimal']['output'];
    transaction?: Maybe<Transaction>;
    transactionId?: Maybe<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnChargeSuperscriptFeeArgs = {
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type CreateManyAndReturnChargeTransactionArgs = {
    where?: InputMaybe<TransactionWhereInput>;
};

export type CreateManyAndReturnChargeAuditLog = {
    __typename?: 'CreateManyAndReturnChargeAuditLog';
    boughtTreatmentId: Scalars['String']['output'];
    chargeId: Scalars['String']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    payoutIds?: Maybe<Array<Scalars['String']['output']>>;
    reattributionState?: Maybe<ReattributionState>;
    slotId?: Maybe<Scalars['String']['output']>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    total: Scalars['Decimal']['output'];
    transactionId?: Maybe<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    userId?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnChargeReattributionAndPartialPaymentLog = {
    __typename?: 'CreateManyAndReturnChargeReattributionAndPartialPaymentLog';
    consumerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    destinationBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['Int']['output'];
    moveList?: Maybe<Array<Scalars['String']['output']>>;
    sourceBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    success: Scalars['Boolean']['output'];
    type: ChargeReattributionAndPartialPaymentLogType;
    userId?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnChargeReattributionLog = {
    __typename?: 'CreateManyAndReturnChargeReattributionLog';
    consumerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    destinationBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['Int']['output'];
    moveList?: Maybe<Array<Scalars['String']['output']>>;
    sourceBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnCheckoutAdjudication = {
    __typename?: 'CreateManyAndReturnCheckoutAdjudication';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    boughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    claimId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    encounterId?: Maybe<Scalars['String']['output']>;
    fees?: Maybe<Scalars['Decimal']['output']>;
    id: Scalars['Int']['output'];
    logId?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    srtIds?: Maybe<Array<Scalars['Int']['output']>>;
    type: AdjudicationType;
    visitId?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnClaimToBoughtTreatment = {
    __typename?: 'CreateManyAndReturnClaimToBoughtTreatment';
    boughtTreatmentId: Scalars['String']['output'];
    claimId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    orgId: Scalars['Int']['output'];
    procedureCode: Scalars['String']['output'];
};

export type CreateManyAndReturnConsentForm = {
    __typename?: 'CreateManyAndReturnConsentForm';
    consentFormId: Scalars['String']['output'];
    date: Scalars['DateTimeISO']['output'];
    encounterId: Scalars['String']['output'];
    id: Scalars['String']['output'];
};

export type CreateManyAndReturnCustomField = {
    __typename?: 'CreateManyAndReturnCustomField';
    customFieldType: CustomFieldTypeEnum;
    id: Scalars['String']['output'];
    name: Scalars['String']['output'];
    practiceId: Scalars['Int']['output'];
};

export type CreateManyAndReturnCustomFieldValue = {
    __typename?: 'CreateManyAndReturnCustomFieldValue';
    customField?: Maybe<CustomField>;
    customFieldId?: Maybe<Scalars['String']['output']>;
    encounter?: Maybe<Encounter>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

export type CreateManyAndReturnCustomFieldValueCustomFieldArgs = {
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type CreateManyAndReturnCustomFieldValueEncounterArgs = {
    where?: InputMaybe<EncounterWhereInput>;
};

export type CreateManyAndReturnDataMigrations = {
    __typename?: 'CreateManyAndReturnDataMigrations';
    migrationId: Scalars['String']['output'];
    timestamp: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnEhrPaymentDescriptor = {
    __typename?: 'CreateManyAndReturnEhrPaymentDescriptor';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrContextId: Scalars['String']['output'];
    ehrEpaymentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    isLocked: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lockType: EhrPaymentLockTypeEnum;
    originalEhrAppointmentId?: Maybe<Scalars['String']['output']>;
    originalEhrClaimId?: Maybe<Scalars['String']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
    resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status: EhrPaymentDescriptorStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnEhrPaymentDescriptorAuditLog = {
    __typename?: 'CreateManyAndReturnEhrPaymentDescriptorAuditLog';
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentDescriptorId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    isLocked?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lockType?: Maybe<EhrPaymentLockTypeEnum>;
    operation?: Maybe<Scalars['String']['output']>;
    originalEhrAppointmentId?: Maybe<Scalars['String']['output']>;
    originalEhrClaimId?: Maybe<Scalars['String']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
    resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<EhrPaymentDescriptorStatusEnum>;
};

export type CreateManyAndReturnEhrPaymentDirectionSsAsset = {
    __typename?: 'CreateManyAndReturnEhrPaymentDirectionSsAsset';
    amount: Scalars['Float']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    destinationBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    destinationEhrClaimId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    destinationMcmsAssociationId?: Maybe<Scalars['String']['output']>;
    destinationOrgId: Scalars['Int']['output'];
    destinationUnappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    ehrContextId: Scalars['String']['output'];
    ehrPaymentId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    sourceBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    sourceEhrClaimId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    sourceEhrVisitId?: Maybe<Scalars['String']['output']>;
    sourceMcmsAssociationId?: Maybe<Scalars['String']['output']>;
    sourceOrgId: Scalars['Int']['output'];
    sourceUnappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnEhrPostDetail = {
    __typename?: 'CreateManyAndReturnEhrPostDetail';
    amount: Scalars['Float']['output'];
    artCreditId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId: Scalars['String']['output'];
    ehrDepartmentId: Scalars['String']['output'];
    ehrPatientId: Scalars['String']['output'];
    ehrPaymentId: Scalars['String']['output'];
    ehrPostDetailAction: EhrPostDetailAction;
    ehrPostLedgerId: Scalars['String']['output'];
    ehrPostSource?: Maybe<EhrPostLedgerSourceEnum>;
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    paymentMethodType?: Maybe<PaymentMethodType>;
    reattributeDestArtCredit?: Maybe<Scalars['String']['output']>;
    reattributeDestBt?: Maybe<Scalars['String']['output']>;
    reattributeSourceArtCredit?: Maybe<Scalars['String']['output']>;
    reattributeSourceBt?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnEhrPostDetailToPayout = {
    __typename?: 'CreateManyAndReturnEhrPostDetailToPayout';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostDetailId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    payoutId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnEhrPostLedger = {
    __typename?: 'CreateManyAndReturnEhrPostLedger';
    amount: Scalars['Float']['output'];
    appointmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    chargedBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrEpaymentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId: Scalars['String']['output'];
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifier?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifierType?: Maybe<EhrPostIdentifierTypeEnum>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesAndPayoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationId?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    payoutIds?: Maybe<Array<Scalars['String']['output']>>;
    payoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    payoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    source?: Maybe<EhrPostLedgerSourceEnum>;
    status: EhrPostStatusEnum;
    transactionIds?: Maybe<Array<Scalars['String']['output']>>;
    unappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnEhrPostLedgerAuditLog = {
    __typename?: 'CreateManyAndReturnEhrPostLedgerAuditLog';
    amount?: Maybe<Scalars['Float']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifier?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifierType?: Maybe<EhrPostIdentifierTypeEnum>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesAndPayoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    payoutIds?: Maybe<Array<Scalars['String']['output']>>;
    payoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    payoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    source?: Maybe<EhrPostLedgerSourceEnum>;
    status?: Maybe<EhrPostStatusEnum>;
    transactionIds?: Maybe<Array<Scalars['String']['output']>>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnEhrPostLedgerToPayout = {
    __typename?: 'CreateManyAndReturnEhrPostLedgerToPayout';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    payoutId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnEhrSlot = {
    __typename?: 'CreateManyAndReturnEhrSlot';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrLocationId: Scalars['String']['output'];
    ehrSlotNoteId?: Maybe<Scalars['String']['output']>;
    ehrVisitIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['String']['output'];
    isCustomSlot: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    patientId: Scalars['String']['output'];
    scheduleSlotName?: Maybe<Scalars['String']['output']>;
    status: EhrSlotStatusEnum;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnEhrSlotAuditLog = {
    __typename?: 'CreateManyAndReturnEhrSlotAuditLog';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrSlotNoteId?: Maybe<Scalars['String']['output']>;
    ehrVisitIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['Int']['output'];
    isCustomSlot?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    patientId?: Maybe<Scalars['String']['output']>;
    scheduleSlotName?: Maybe<Scalars['String']['output']>;
    status?: Maybe<EhrSlotStatusEnum>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnEncounter = {
    __typename?: 'CreateManyAndReturnEncounter';
    action_required: Scalars['Boolean']['output'];
    appointmentEnd?: Maybe<Scalars['DateTimeISO']['output']>;
    appointmentStart?: Maybe<Scalars['DateTimeISO']['output']>;
    cartItemIds?: Maybe<Array<Scalars['Int']['output']>>;
    checkoutAccessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    ehrSlot?: Maybe<EhrSlot>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    hasPendingPayment: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
    insuranceIds?: Maybe<Array<Scalars['String']['output']>>;
    intakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    lastCommunicationTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
    linkId: Scalars['String']['output'];
    paymentContactId?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
    procedureName?: Maybe<Scalars['String']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    source: EncounterSourceEnum;
    status: EncounterStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
    userId: Scalars['String']['output'];
};

export type CreateManyAndReturnEncounterEhrSlotArgs = {
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type CreateManyAndReturnExperityEncounter = {
    __typename?: 'CreateManyAndReturnExperityEncounter';
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId: Scalars['String']['output'];
    ehrClinicId: Scalars['String']['output'];
    ehrPatientId: Scalars['String']['output'];
    ehrSlot: EhrSlot;
    ehrSlotId: Scalars['String']['output'];
    encounterId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    slotId: Scalars['String']['output'];
    status: ExperityEncounterStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnFeeConfig = {
    __typename?: 'CreateManyAndReturnFeeConfig';
    amount?: Maybe<Scalars['Decimal']['output']>;
    amountType?: Maybe<AmountType>;
    associatedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    description?: Maybe<Scalars['String']['output']>;
    excludedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    feeType: FeeType;
    id: Scalars['String']['output'];
    isActive: Scalars['Boolean']['output'];
    isArrears: Scalars['Boolean']['output'];
    isWaived: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentType?: Maybe<PaymentType>;
    revenueType?: Maybe<RevenueType>;
    unit?: Maybe<FeeUnit>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnFeeConfigAuditLog = {
    __typename?: 'CreateManyAndReturnFeeConfigAuditLog';
    amount?: Maybe<Scalars['Decimal']['output']>;
    amountType?: Maybe<AmountType>;
    associatedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    description?: Maybe<Scalars['String']['output']>;
    excludedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    feeConfigId: Scalars['String']['output'];
    feeType: FeeType;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    isArrears: Scalars['Boolean']['output'];
    isWaived: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    paymentType?: Maybe<PaymentType>;
    revenueType?: Maybe<RevenueType>;
    unit?: Maybe<FeeUnit>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnGuarantorPaymentLinkContext = {
    __typename?: 'CreateManyAndReturnGuarantorPaymentLinkContext';
    appointmentId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    guarantorName: Scalars['String']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    patientName: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnHoliday = {
    __typename?: 'CreateManyAndReturnHoliday';
    day: Scalars['DateTimeISO']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    practiceIdOverride?: Maybe<Array<Scalars['Int']['output']>>;
};

export type CreateManyAndReturnInsuranceMetadata = {
    __typename?: 'CreateManyAndReturnInsuranceMetadata';
    createdAt: Scalars['DateTimeISO']['output'];
    insuranceId: Scalars['String']['output'];
    status: InsuranceMetadataStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnInvoiceDailyLineItems = {
    __typename?: 'CreateManyAndReturnInvoiceDailyLineItems';
    amount: Scalars['Decimal']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    feeType: FeeType;
    id: Scalars['String']['output'];
    invoice: Invoices;
    invoiceId: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnInvoices = {
    __typename?: 'CreateManyAndReturnInvoices';
    createdAt: Scalars['DateTimeISO']['output'];
    endDate: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    invoiceDate: Scalars['DateTimeISO']['output'];
    orgId: Scalars['Int']['output'];
    startDate: Scalars['DateTimeISO']['output'];
    status: InvoiceStatus;
    stripeInvoiceId: Scalars['String']['output'];
    totalAmount: Scalars['Decimal']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnLiveTransfers = {
    __typename?: 'CreateManyAndReturnLiveTransfers';
    action?: Maybe<LiveTransferActionEnum>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    artNotes?: Maybe<Array<Scalars['String']['output']>>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    currentPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    currentPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    currentSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    dateOfFirstCommunication?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfLastCommunication?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService: Scalars['DateTimeISO']['output'];
    dateTransferred?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrVisitId?: Maybe<Scalars['String']['output']>;
    grossPayout?: Maybe<Scalars['Float']['output']>;
    id: Scalars['String']['output'];
    location?: Maybe<Scalars['String']['output']>;
    locationTimezone?: Maybe<Scalars['String']['output']>;
    netPayout?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    patientName?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    provider?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    status?: Maybe<LiveTransferStatusEnum>;
    stripeFeeAmount?: Maybe<Scalars['Float']['output']>;
    stripeTransferDate?: Maybe<Scalars['DateTimeISO']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    stripeTransferStatus?: Maybe<Scalars['String']['output']>;
    superscriptFeeAmount?: Maybe<Scalars['Float']['output']>;
    treatmentMap?: Maybe<Scalars['JSON']['output']>;
    treatmentNames?: Maybe<Scalars['String']['output']>;
    treatmentTypes?: Maybe<Array<PaymentTypeEnum>>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnMcmsAssociation = {
    __typename?: 'CreateManyAndReturnMcmsAssociation';
    adjudicationVersion?: Maybe<McmsAdjudicationVersion>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    reversalAction: McmsReversalAction;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnMcmsAssociationAuditLog = {
    __typename?: 'CreateManyAndReturnMcmsAssociationAuditLog';
    adjudicationVersion?: Maybe<McmsAdjudicationVersion>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationId?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    reversalAction?: Maybe<McmsReversalAction>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnMcmsAssociationClaim = {
    __typename?: 'CreateManyAndReturnMcmsAssociationClaim';
    artClaimId?: Maybe<Scalars['String']['output']>;
    association: McmsAssociation;
    associationId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrClaimId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnMcmsAssociationClaimAuditLog = {
    __typename?: 'CreateManyAndReturnMcmsAssociationClaimAuditLog';
    artClaimId?: Maybe<Scalars['String']['output']>;
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationClaimId?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnMcmsAssociationSlot = {
    __typename?: 'CreateManyAndReturnMcmsAssociationSlot';
    association: McmsAssociation;
    associationId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    slotId: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnMcmsAssociationSlotAuditLog = {
    __typename?: 'CreateManyAndReturnMcmsAssociationSlotAuditLog';
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationSlotId?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnMessageOrchestrationRule = {
    __typename?: 'CreateManyAndReturnMessageOrchestrationRule';
    createdAt: Scalars['DateTimeISO']['output'];
    isActive: Scalars['Boolean']['output'];
    orgId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    ruleConfig?: Maybe<Scalars['JSON']['output']>;
    ruleName: MessagingRuleName;
    ruleType: MessagingRuleType;
    updatedAt: Scalars['DateTimeISO']['output'];
    updatedBy: Scalars['String']['output'];
};

export type CreateManyAndReturnMigratedEncounter = {
    __typename?: 'CreateManyAndReturnMigratedEncounter';
    appointmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    encounterId: Scalars['String']['output'];
    linkId: Scalars['String']['output'];
    slotId?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnMigrations = {
    __typename?: 'CreateManyAndReturnMigrations';
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    timestamp: Scalars['BigInt']['output'];
};

export type CreateManyAndReturnNonCardRefunds = {
    __typename?: 'CreateManyAndReturnNonCardRefunds';
    amount: Scalars['Decimal']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    dateCompleted?: Maybe<Scalars['DateTimeISO']['output']>;
    dateRequested: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    initiatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType: PaymentMethodType;
    resolvedBy?: Maybe<Scalars['String']['output']>;
    status: NonCardRefundStatus;
    transaction?: Maybe<Transaction>;
    transactionId: Scalars['String']['output'];
    userId: Scalars['String']['output'];
};

export type CreateManyAndReturnNonCardRefundsTransactionArgs = {
    where?: InputMaybe<TransactionWhereInput>;
};

export type CreateManyAndReturnOrgFees = {
    __typename?: 'CreateManyAndReturnOrg_fees';
    cash_transaction_fee: Scalars['Decimal']['output'];
    id: Scalars['Int']['output'];
    insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type CreateManyAndReturnOrgStripeMapping = {
    __typename?: 'CreateManyAndReturnOrg_stripe_mapping';
    orgId: Scalars['Int']['output'];
    passThroughStripeFee: Scalars['Boolean']['output'];
    stripe_account_id: Scalars['String']['output'];
    stripe_customer_id?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnPayLaterAuthorization = {
    __typename?: 'CreateManyAndReturnPayLaterAuthorization';
    activationMessageAttemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    activationMessageErrorDetails?: Maybe<Scalars['String']['output']>;
    appointmentId: Scalars['String']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount: Scalars['Decimal']['output'];
    depositCollectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositTransaction?: Maybe<Transaction>;
    depositTransactionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentAuthorization: PaymentAuthorization;
    paymentAuthorizationId: Scalars['String']['output'];
    paymentPlan?: Maybe<PaymentPlan>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    status: PayLaterAuthorizationStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPayLaterAuthorizationDepositTransactionArgs = {
    where?: InputMaybe<TransactionWhereInput>;
};

export type CreateManyAndReturnPayLaterAuthorizationPaymentPlanArgs = {
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type CreateManyAndReturnPayLaterAuthorizationAuditLog = {
    __typename?: 'CreateManyAndReturnPayLaterAuthorizationAuditLog';
    activationMessageAttemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    activationMessageErrorDetails?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositCollectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositTransactionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PayLaterAuthorizationStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPaymentAuthorization = {
    __typename?: 'CreateManyAndReturnPaymentAuthorization';
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    consentText: Scalars['String']['output'];
    consentType: PaymentAuthorizationConsentType;
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    consentedAt: Scalars['DateTimeISO']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    ipAddress?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPaymentAuthorizationAuditLog = {
    __typename?: 'CreateManyAndReturnPaymentAuthorizationAuditLog';
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    consentText?: Maybe<Scalars['String']['output']>;
    consentType?: Maybe<PaymentAuthorizationConsentType>;
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    consentedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    ipAddress?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPaymentPlan = {
    __typename?: 'CreateManyAndReturnPaymentPlan';
    activatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    athenaAcceptanceWindowExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    chargeDayOfWeek?: Maybe<DayOfWeekEnum>;
    chargeFrequency: PaymentPlanFrequency;
    chargeMode: PaymentPlanChargeMode;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    confirmedRemaining: Scalars['Decimal']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount: Scalars['Decimal']['output'];
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    migratedFromAthena: Scalars['Boolean']['output'];
    newPaymentMethodRequiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    nextChargeDateAt?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId: Scalars['Int']['output'];
    paymentAuthorization?: Maybe<PaymentAuthorization>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    shortId: Scalars['Int']['output'];
    status: PaymentPlanStatus;
    type: PaymentPlanType;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnPaymentPlanPaymentAuthorizationArgs = {
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type CreateManyAndReturnPaymentPlanAdjustment = {
    __typename?: 'CreateManyAndReturnPaymentPlanAdjustment';
    acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    acknowledgedBy?: Maybe<Scalars['String']['output']>;
    acknowledgedByRole?: Maybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: Maybe<AdjustmentAckActionEnum>;
    boughtTreatmentId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    newAmount: Scalars['Decimal']['output'];
    paymentPlanId: Scalars['String']['output'];
    plan: PaymentPlan;
    previousAmount: Scalars['Decimal']['output'];
    status: PaymentPlanAdjustmentStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPaymentPlanAdjustmentAuditLog = {
    __typename?: 'CreateManyAndReturnPaymentPlanAdjustmentAuditLog';
    acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    acknowledgedBy?: Maybe<Scalars['String']['output']>;
    acknowledgedByRole?: Maybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: Maybe<AdjustmentAckActionEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    operation: Scalars['String']['output'];
    paymentPlanAdjustmentId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
    status?: Maybe<PaymentPlanAdjustmentStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPaymentPlanAuditLog = {
    __typename?: 'CreateManyAndReturnPaymentPlanAuditLog';
    activatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    athenaAcceptanceWindowExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    chargeFrequency?: Maybe<PaymentPlanFrequency>;
    chargeMode?: Maybe<PaymentPlanChargeMode>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    initiatedBy?: Maybe<PaymentPlanInitiatedBy>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    migratedFromAthena?: Maybe<Scalars['Boolean']['output']>;
    newPaymentMethodRequiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    nextChargeDateAt?: Maybe<Scalars['DateTimeISO']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    shortId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<PaymentPlanStatus>;
    type?: Maybe<PaymentPlanType>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnPaymentPlanAutoCharge = {
    __typename?: 'CreateManyAndReturnPaymentPlanAutoCharge';
    amount: Scalars['Decimal']['output'];
    attemptCount: Scalars['Int']['output'];
    attemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    idempotencyKey?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    nextRetryAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId: Scalars['String']['output'];
    plan: PaymentPlan;
    reminderSentAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scheduledDate: Scalars['DateTimeISO']['output'];
    snapshotAfterPayment?: Maybe<Scalars['JSON']['output']>;
    snapshotAtCreation: Scalars['JSON']['output'];
    status: PaymentPlanAutoChargeStatus;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    timezone: Scalars['String']['output'];
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPaymentPlanAutoChargeAuditLog = {
    __typename?: 'CreateManyAndReturnPaymentPlanAutoChargeAuditLog';
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
    attemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    idempotencyKey?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    nextRetryAt?: Maybe<Scalars['DateTimeISO']['output']>;
    operation: Scalars['String']['output'];
    paymentPlanAutoChargeId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    scheduledDate?: Maybe<Scalars['DateTimeISO']['output']>;
    snapshotAfterPayment?: Maybe<Scalars['JSON']['output']>;
    snapshotAtCreation?: Maybe<Scalars['JSON']['output']>;
    status?: Maybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPaymentPlanBoughtTreatment = {
    __typename?: 'CreateManyAndReturnPaymentPlanBoughtTreatment';
    boughtTreatmentId: Scalars['String']['output'];
    claimStage: PaymentPlanBoughtTreatmentClaimStage;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    patientAuthorizedIssueAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId: Scalars['String']['output'];
    plan: PaymentPlan;
    status: PaymentPlanBoughtTreatmentStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPaymentPlanBoughtTreatmentAuditLog = {
    __typename?: 'CreateManyAndReturnPaymentPlanBoughtTreatmentAuditLog';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimStage?: Maybe<PaymentPlanBoughtTreatmentClaimStage>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    patientAuthorizedIssueAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPaymentPlanOrgConfig = {
    __typename?: 'CreateManyAndReturnPaymentPlanOrgConfig';
    allowPaymentPlanCreateEditFromAccount: Scalars['Boolean']['output'];
    chargeDaysPostReturn: Scalars['Int']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    forceCardOnFile: Scalars['Boolean']['output'];
    installmentCadenceDays: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    migrationAcceptanceWindowDays: Scalars['Int']['output'];
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    orgId: Scalars['Int']['output'];
    payLaterAutoEnrollEnabled: Scalars['Boolean']['output'];
    payLaterEnabled: Scalars['Boolean']['output'];
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlansEnabled: Scalars['Boolean']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPaymentPlanOrgConfigAuditLog = {
    __typename?: 'CreateManyAndReturnPaymentPlanOrgConfigAuditLog';
    allowPaymentPlanCreateEditFromAccount?: Maybe<Scalars['Boolean']['output']>;
    chargeDaysPostReturn?: Maybe<Scalars['Int']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    forceCardOnFile?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['Int']['output'];
    installmentCadenceDays?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Int']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAutoEnrollEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlansEnabled?: Maybe<Scalars['Boolean']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPayout = {
    __typename?: 'CreateManyAndReturnPayout';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    chargeIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdByEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    expectedPayoutDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    isArtCreated?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedByEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    parentPayoutId?: Maybe<Scalars['String']['output']>;
    payoutReferencePaymentType?: Maybe<PayoutReferencePaymentType>;
    payoutType: Scalars['String']['output'];
    price: Scalars['Decimal']['output'];
    reattributionState?: Maybe<ReattributionState>;
    status: TransactionStatus;
    stripeDestinationId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePayoutFee?: Maybe<Scalars['Decimal']['output']>;
    stripeReversalId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnPayoutAuditLog = {
    __typename?: 'CreateManyAndReturnPayoutAuditLog';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    chargeIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    expectedPayoutDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    parentPayoutId?: Maybe<Scalars['String']['output']>;
    payoutId: Scalars['String']['output'];
    payoutType: Scalars['String']['output'];
    price: Scalars['Decimal']['output'];
    reattributionState?: Maybe<ReattributionState>;
    status: TransactionStatus;
    stripeDestinationId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripeReversalId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPendingVoidPayoutReversal = {
    __typename?: 'CreateManyAndReturnPendingVoidPayoutReversal';
    boughtTreatmentId: Scalars['String']['output'];
    chargeIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    processingStatus: PendingVoidPayoutReversalProcessingStatusEnum;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnPracticeConfiguration = {
    __typename?: 'CreateManyAndReturnPracticeConfiguration';
    activationCode: Scalars['String']['output'];
    posDeviceId: Scalars['String']['output'];
    practiceId: Scalars['Int']['output'];
};

export type CreateManyAndReturnPricingEscalator = {
    __typename?: 'CreateManyAndReturnPricingEscalator';
    id: Scalars['Int']['output'];
    insuredFee: Scalars['Decimal']['output'];
    milestoneProcessed: Scalars['Decimal']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    uninsuredFee: Scalars['Decimal']['output'];
};

export type CreateManyAndReturnReattributionDirection = {
    __typename?: 'CreateManyAndReturnReattributionDirection';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    destinationChargeId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostDetailId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    destinationPayoutId?: Maybe<Scalars['String']['output']>;
    destinationTransactionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    reattributionState?: Maybe<ReattributionState>;
    sourceBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    sourceChargeId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostDetailId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    sourcePayoutId?: Maybe<Scalars['String']['output']>;
    sourceTransactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CreateManyAndReturnReceiptArrangement = {
    __typename?: 'CreateManyAndReturnReceiptArrangement';
    blockGap?: Maybe<Scalars['Int']['output']>;
    components: Scalars['JSON']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    createdBy?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    receiptType: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnReservedEhrVisit = {
    __typename?: 'CreateManyAndReturnReservedEhrVisit';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrVisitId: Scalars['String']['output'];
    expiresAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
};

export type CreateManyAndReturnSlot = {
    __typename?: 'CreateManyAndReturnSlot';
    EhrSlot?: Maybe<EhrSlot>;
    appointment?: Maybe<Appointment>;
    appointmentId: Scalars['String']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt: Scalars['DateTimeISO']['output'];
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['output'];
    status: SlotStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnSlotEhrSlotArgs = {
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type CreateManyAndReturnSlotAppointmentArgs = {
    where?: InputMaybe<AppointmentWhereInput>;
};

export type CreateManyAndReturnSlotAuditLog = {
    __typename?: 'CreateManyAndReturnSlotAuditLog';
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<SlotStatusEnum>;
    updatedAt: Scalars['DateTimeISO']['output'];
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnSuperscriptFeeLineItem = {
    __typename?: 'CreateManyAndReturnSuperscriptFeeLineItem';
    amount: Scalars['Decimal']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    feeConfig: FeeConfig;
    feeConfigId: Scalars['String']['output'];
    feeType: FeeType;
    id: Scalars['String']['output'];
    isArrears: Scalars['Boolean']['output'];
    isWaived: Scalars['Boolean']['output'];
    superscriptFee: SuperscriptFees;
    superscriptFeeId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnSuperscriptFees = {
    __typename?: 'CreateManyAndReturnSuperscriptFees';
    chargeIds?: Maybe<Array<Scalars['String']['output']>>;
    date: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    feesToFloatTransferFailed: Scalars['Boolean']['output'];
    gross_fees: Scalars['Decimal']['output'];
    id: Scalars['String']['output'];
    net_fees: Scalars['Decimal']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    stripeInvoiceId?: Maybe<Scalars['String']['output']>;
    stripeRefundFeesTransferId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    totalFees?: Maybe<Scalars['Decimal']['output']>;
    totalFeesArrears?: Maybe<Scalars['Decimal']['output']>;
    totalFeesBilled?: Maybe<Scalars['Decimal']['output']>;
    totalFeesWaived?: Maybe<Scalars['Decimal']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
};

export type CreateManyAndReturnTimeBlock = {
    __typename?: 'CreateManyAndReturnTimeBlock';
    available: Scalars['Boolean']['output'];
    category?: Maybe<TimeBlockCategoryEnum>;
    dayOfWeek: Scalars['Int']['output'];
    endTime: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    isAllDay: Scalars['Boolean']['output'];
    label?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    startTime: Scalars['DateTimeISO']['output'];
};

export type CreateManyAndReturnTransaction = {
    __typename?: 'CreateManyAndReturnTransaction';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    bulkChargeCardRunId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    checkNumber?: Maybe<Scalars['String']['output']>;
    collectedBy?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    encounterId?: Maybe<Scalars['String']['output']>;
    externalPaymentReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdateDate?: Maybe<Scalars['DateTimeISO']['output']>;
    paidDate?: Maybe<Scalars['DateTimeISO']['output']>;
    parentTransactionId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    price: Scalars['Decimal']['output'];
    status: TransactionStatus;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    stripeDisputeId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePaymentId?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeRefundIds?: Maybe<Scalars['String']['output']>;
    superscriptFee?: Maybe<Scalars['Decimal']['output']>;
    transactionType: TransactionType;
    userId: Scalars['String']['output'];
};

export type CreateTransactionRequestDto = {
    chargeIds: Array<Scalars['String']['input']>;
    checkNumber?: InputMaybe<Scalars['String']['input']>;
    collectedBy?: InputMaybe<Scalars['String']['input']>;
    externalPaymentReason?: InputMaybe<Scalars['String']['input']>;
    paymentMethodType: PaymentMethodType;
    stripePaymentId?: InputMaybe<Scalars['String']['input']>;
    userId: Scalars['String']['input'];
};

export type CustomField = {
    __typename?: 'CustomField';
    _count?: Maybe<CustomFieldCount>;
    customFieldType: CustomFieldTypeEnum;
    customFieldValues: Array<CustomFieldValue>;
    id: Scalars['String']['output'];
    name: Scalars['String']['output'];
    practiceId: Scalars['Int']['output'];
};

export type CustomFieldCustomFieldValuesArgs = {
    cursor?: InputMaybe<CustomFieldValueWhereUniqueInput>;
    distinct?: InputMaybe<Array<CustomFieldValueScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CustomFieldValueOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type CustomFieldAvgAggregate = {
    __typename?: 'CustomFieldAvgAggregate';
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type CustomFieldAvgOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
};

export type CustomFieldCount = {
    __typename?: 'CustomFieldCount';
    customFieldValues: Scalars['Int']['output'];
};

export type CustomFieldCountCustomFieldValuesArgs = {
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type CustomFieldCountAggregate = {
    __typename?: 'CustomFieldCountAggregate';
    _all: Scalars['Int']['output'];
    customFieldType: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
};

export type CustomFieldCountOrderByAggregateInput = {
    customFieldType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type CustomFieldCreateInput = {
    customFieldType?: InputMaybe<CustomFieldTypeEnum>;
    customFieldValues?: InputMaybe<CustomFieldValueCreateNestedManyWithoutCustomFieldInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    practiceId: Scalars['Int']['input'];
};

export type CustomFieldCreateManyInput = {
    customFieldType?: InputMaybe<CustomFieldTypeEnum>;
    id?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    practiceId: Scalars['Int']['input'];
};

export type CustomFieldCreateNestedOneWithoutCustomFieldValuesInput = {
    connect?: InputMaybe<CustomFieldWhereUniqueInput>;
    connectOrCreate?: InputMaybe<CustomFieldCreateOrConnectWithoutCustomFieldValuesInput>;
    create?: InputMaybe<CustomFieldCreateWithoutCustomFieldValuesInput>;
};

export type CustomFieldCreateOrConnectWithoutCustomFieldValuesInput = {
    create: CustomFieldCreateWithoutCustomFieldValuesInput;
    where: CustomFieldWhereUniqueInput;
};

export type CustomFieldCreateWithoutCustomFieldValuesInput = {
    customFieldType?: InputMaybe<CustomFieldTypeEnum>;
    id?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    practiceId: Scalars['Int']['input'];
};

export type CustomFieldGroupBy = {
    __typename?: 'CustomFieldGroupBy';
    _avg?: Maybe<CustomFieldAvgAggregate>;
    _count?: Maybe<CustomFieldCountAggregate>;
    _max?: Maybe<CustomFieldMaxAggregate>;
    _min?: Maybe<CustomFieldMinAggregate>;
    _sum?: Maybe<CustomFieldSumAggregate>;
    customFieldType: CustomFieldTypeEnum;
    id: Scalars['String']['output'];
    name: Scalars['String']['output'];
    practiceId: Scalars['Int']['output'];
};

export type CustomFieldMaxAggregate = {
    __typename?: 'CustomFieldMaxAggregate';
    customFieldType?: Maybe<CustomFieldTypeEnum>;
    id?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type CustomFieldMaxOrderByAggregateInput = {
    customFieldType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type CustomFieldMinAggregate = {
    __typename?: 'CustomFieldMinAggregate';
    customFieldType?: Maybe<CustomFieldTypeEnum>;
    id?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type CustomFieldMinOrderByAggregateInput = {
    customFieldType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type CustomFieldNamePracticeIdCompoundUniqueInput = {
    name: Scalars['String']['input'];
    practiceId: Scalars['Int']['input'];
};

export type CustomFieldNullableRelationFilter = {
    is?: InputMaybe<CustomFieldWhereInput>;
    isNot?: InputMaybe<CustomFieldWhereInput>;
};

export type CustomFieldOrderByWithAggregationInput = {
    _avg?: InputMaybe<CustomFieldAvgOrderByAggregateInput>;
    _count?: InputMaybe<CustomFieldCountOrderByAggregateInput>;
    _max?: InputMaybe<CustomFieldMaxOrderByAggregateInput>;
    _min?: InputMaybe<CustomFieldMinOrderByAggregateInput>;
    _sum?: InputMaybe<CustomFieldSumOrderByAggregateInput>;
    customFieldType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type CustomFieldOrderByWithRelationInput = {
    customFieldType?: InputMaybe<SortOrder>;
    customFieldValues?: InputMaybe<CustomFieldValueOrderByRelationAggregateInput>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export enum CustomFieldScalarFieldEnum {
    CustomFieldType = 'customFieldType',
    Id = 'id',
    Name = 'name',
    PracticeId = 'practiceId',
}

export type CustomFieldScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<CustomFieldScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<CustomFieldScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<CustomFieldScalarWhereWithAggregatesInput>>;
    customFieldType?: InputMaybe<EnumCustomFieldTypeEnumWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
};

export type CustomFieldSumAggregate = {
    __typename?: 'CustomFieldSumAggregate';
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type CustomFieldSumOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
};

export enum CustomFieldTypeEnum {
    Boolean = 'BOOLEAN',
    Date = 'DATE',
    Number = 'NUMBER',
    String = 'STRING',
}

export type CustomFieldUpdateInput = {
    customFieldType?: InputMaybe<EnumCustomFieldTypeEnumFieldUpdateOperationsInput>;
    customFieldValues?: InputMaybe<CustomFieldValueUpdateManyWithoutCustomFieldNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type CustomFieldUpdateManyMutationInput = {
    customFieldType?: InputMaybe<EnumCustomFieldTypeEnumFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type CustomFieldUpdateOneWithoutCustomFieldValuesNestedInput = {
    connect?: InputMaybe<CustomFieldWhereUniqueInput>;
    connectOrCreate?: InputMaybe<CustomFieldCreateOrConnectWithoutCustomFieldValuesInput>;
    create?: InputMaybe<CustomFieldCreateWithoutCustomFieldValuesInput>;
    delete?: InputMaybe<CustomFieldWhereInput>;
    disconnect?: InputMaybe<CustomFieldWhereInput>;
    update?: InputMaybe<CustomFieldUpdateToOneWithWhereWithoutCustomFieldValuesInput>;
    upsert?: InputMaybe<CustomFieldUpsertWithoutCustomFieldValuesInput>;
};

export type CustomFieldUpdateToOneWithWhereWithoutCustomFieldValuesInput = {
    data: CustomFieldUpdateWithoutCustomFieldValuesInput;
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type CustomFieldUpdateWithoutCustomFieldValuesInput = {
    customFieldType?: InputMaybe<EnumCustomFieldTypeEnumFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type CustomFieldUpsertWithoutCustomFieldValuesInput = {
    create: CustomFieldCreateWithoutCustomFieldValuesInput;
    update: CustomFieldUpdateWithoutCustomFieldValuesInput;
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type CustomFieldValue = {
    __typename?: 'CustomFieldValue';
    customField?: Maybe<CustomField>;
    customFieldId?: Maybe<Scalars['String']['output']>;
    encounter?: Maybe<Encounter>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

export type CustomFieldValueCustomFieldArgs = {
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type CustomFieldValueEncounterArgs = {
    where?: InputMaybe<EncounterWhereInput>;
};

export type CustomFieldValueCountAggregate = {
    __typename?: 'CustomFieldValueCountAggregate';
    _all: Scalars['Int']['output'];
    customFieldId: Scalars['Int']['output'];
    encounterId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    value: Scalars['Int']['output'];
};

export type CustomFieldValueCountOrderByAggregateInput = {
    customFieldId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type CustomFieldValueCreateInput = {
    customField?: InputMaybe<CustomFieldCreateNestedOneWithoutCustomFieldValuesInput>;
    encounter?: InputMaybe<EncounterCreateNestedOneWithoutCustomFieldValueInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    value: Scalars['String']['input'];
};

export type CustomFieldValueCreateManyCustomFieldInput = {
    encounterId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    value: Scalars['String']['input'];
};

export type CustomFieldValueCreateManyCustomFieldInputEnvelope = {
    data: Array<CustomFieldValueCreateManyCustomFieldInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomFieldValueCreateManyEncounterInput = {
    customFieldId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    value: Scalars['String']['input'];
};

export type CustomFieldValueCreateManyEncounterInputEnvelope = {
    data: Array<CustomFieldValueCreateManyEncounterInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomFieldValueCreateManyInput = {
    customFieldId?: InputMaybe<Scalars['String']['input']>;
    encounterId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    value: Scalars['String']['input'];
};

export type CustomFieldValueCreateNestedManyWithoutCustomFieldInput = {
    connect?: InputMaybe<Array<CustomFieldValueWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<CustomFieldValueCreateOrConnectWithoutCustomFieldInput>
    >;
    create?: InputMaybe<Array<CustomFieldValueCreateWithoutCustomFieldInput>>;
    createMany?: InputMaybe<CustomFieldValueCreateManyCustomFieldInputEnvelope>;
};

export type CustomFieldValueCreateNestedManyWithoutEncounterInput = {
    connect?: InputMaybe<Array<CustomFieldValueWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<CustomFieldValueCreateOrConnectWithoutEncounterInput>
    >;
    create?: InputMaybe<Array<CustomFieldValueCreateWithoutEncounterInput>>;
    createMany?: InputMaybe<CustomFieldValueCreateManyEncounterInputEnvelope>;
};

export type CustomFieldValueCreateOrConnectWithoutCustomFieldInput = {
    create: CustomFieldValueCreateWithoutCustomFieldInput;
    where: CustomFieldValueWhereUniqueInput;
};

export type CustomFieldValueCreateOrConnectWithoutEncounterInput = {
    create: CustomFieldValueCreateWithoutEncounterInput;
    where: CustomFieldValueWhereUniqueInput;
};

export type CustomFieldValueCreateWithoutCustomFieldInput = {
    encounter?: InputMaybe<EncounterCreateNestedOneWithoutCustomFieldValueInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    value: Scalars['String']['input'];
};

export type CustomFieldValueCreateWithoutEncounterInput = {
    customField?: InputMaybe<CustomFieldCreateNestedOneWithoutCustomFieldValuesInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    value: Scalars['String']['input'];
};

export type CustomFieldValueCustomFieldIdEncounterIdCompoundUniqueInput = {
    customFieldId: Scalars['String']['input'];
    encounterId: Scalars['String']['input'];
};

export type CustomFieldValueGroupBy = {
    __typename?: 'CustomFieldValueGroupBy';
    _count?: Maybe<CustomFieldValueCountAggregate>;
    _max?: Maybe<CustomFieldValueMaxAggregate>;
    _min?: Maybe<CustomFieldValueMinAggregate>;
    customFieldId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

export type CustomFieldValueListRelationFilter = {
    every?: InputMaybe<CustomFieldValueWhereInput>;
    none?: InputMaybe<CustomFieldValueWhereInput>;
    some?: InputMaybe<CustomFieldValueWhereInput>;
};

export type CustomFieldValueMaxAggregate = {
    __typename?: 'CustomFieldValueMaxAggregate';
    customFieldId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type CustomFieldValueMaxOrderByAggregateInput = {
    customFieldId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type CustomFieldValueMinAggregate = {
    __typename?: 'CustomFieldValueMinAggregate';
    customFieldId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type CustomFieldValueMinOrderByAggregateInput = {
    customFieldId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type CustomFieldValueOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type CustomFieldValueOrderByWithAggregationInput = {
    _count?: InputMaybe<CustomFieldValueCountOrderByAggregateInput>;
    _max?: InputMaybe<CustomFieldValueMaxOrderByAggregateInput>;
    _min?: InputMaybe<CustomFieldValueMinOrderByAggregateInput>;
    customFieldId?: InputMaybe<SortOrderInput>;
    encounterId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type CustomFieldValueOrderByWithRelationInput = {
    customField?: InputMaybe<CustomFieldOrderByWithRelationInput>;
    customFieldId?: InputMaybe<SortOrderInput>;
    encounter?: InputMaybe<EncounterOrderByWithRelationInput>;
    encounterId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export enum CustomFieldValueScalarFieldEnum {
    CustomFieldId = 'customFieldId',
    EncounterId = 'encounterId',
    Id = 'id',
    Value = 'value',
}

export type CustomFieldValueScalarWhereInput = {
    AND?: InputMaybe<Array<CustomFieldValueScalarWhereInput>>;
    NOT?: InputMaybe<Array<CustomFieldValueScalarWhereInput>>;
    OR?: InputMaybe<Array<CustomFieldValueScalarWhereInput>>;
    customFieldId?: InputMaybe<UuidNullableFilter>;
    encounterId?: InputMaybe<UuidNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    value?: InputMaybe<StringFilter>;
};

export type CustomFieldValueScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<CustomFieldValueScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<CustomFieldValueScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<CustomFieldValueScalarWhereWithAggregatesInput>>;
    customFieldId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    encounterId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    value?: InputMaybe<StringWithAggregatesFilter>;
};

export type CustomFieldValueUpdateInput = {
    customField?: InputMaybe<CustomFieldUpdateOneWithoutCustomFieldValuesNestedInput>;
    encounter?: InputMaybe<EncounterUpdateOneWithoutCustomFieldValueNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CustomFieldValueUpdateManyMutationInput = {
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CustomFieldValueUpdateManyWithWhereWithoutCustomFieldInput = {
    data: CustomFieldValueUpdateManyMutationInput;
    where: CustomFieldValueScalarWhereInput;
};

export type CustomFieldValueUpdateManyWithWhereWithoutEncounterInput = {
    data: CustomFieldValueUpdateManyMutationInput;
    where: CustomFieldValueScalarWhereInput;
};

export type CustomFieldValueUpdateManyWithoutCustomFieldNestedInput = {
    connect?: InputMaybe<Array<CustomFieldValueWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<CustomFieldValueCreateOrConnectWithoutCustomFieldInput>
    >;
    create?: InputMaybe<Array<CustomFieldValueCreateWithoutCustomFieldInput>>;
    createMany?: InputMaybe<CustomFieldValueCreateManyCustomFieldInputEnvelope>;
    delete?: InputMaybe<Array<CustomFieldValueWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<CustomFieldValueScalarWhereInput>>;
    disconnect?: InputMaybe<Array<CustomFieldValueWhereUniqueInput>>;
    set?: InputMaybe<Array<CustomFieldValueWhereUniqueInput>>;
    update?: InputMaybe<
        Array<CustomFieldValueUpdateWithWhereUniqueWithoutCustomFieldInput>
    >;
    updateMany?: InputMaybe<
        Array<CustomFieldValueUpdateManyWithWhereWithoutCustomFieldInput>
    >;
    upsert?: InputMaybe<
        Array<CustomFieldValueUpsertWithWhereUniqueWithoutCustomFieldInput>
    >;
};

export type CustomFieldValueUpdateManyWithoutEncounterNestedInput = {
    connect?: InputMaybe<Array<CustomFieldValueWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<CustomFieldValueCreateOrConnectWithoutEncounterInput>
    >;
    create?: InputMaybe<Array<CustomFieldValueCreateWithoutEncounterInput>>;
    createMany?: InputMaybe<CustomFieldValueCreateManyEncounterInputEnvelope>;
    delete?: InputMaybe<Array<CustomFieldValueWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<CustomFieldValueScalarWhereInput>>;
    disconnect?: InputMaybe<Array<CustomFieldValueWhereUniqueInput>>;
    set?: InputMaybe<Array<CustomFieldValueWhereUniqueInput>>;
    update?: InputMaybe<
        Array<CustomFieldValueUpdateWithWhereUniqueWithoutEncounterInput>
    >;
    updateMany?: InputMaybe<
        Array<CustomFieldValueUpdateManyWithWhereWithoutEncounterInput>
    >;
    upsert?: InputMaybe<
        Array<CustomFieldValueUpsertWithWhereUniqueWithoutEncounterInput>
    >;
};

export type CustomFieldValueUpdateWithWhereUniqueWithoutCustomFieldInput = {
    data: CustomFieldValueUpdateWithoutCustomFieldInput;
    where: CustomFieldValueWhereUniqueInput;
};

export type CustomFieldValueUpdateWithWhereUniqueWithoutEncounterInput = {
    data: CustomFieldValueUpdateWithoutEncounterInput;
    where: CustomFieldValueWhereUniqueInput;
};

export type CustomFieldValueUpdateWithoutCustomFieldInput = {
    encounter?: InputMaybe<EncounterUpdateOneWithoutCustomFieldValueNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CustomFieldValueUpdateWithoutEncounterInput = {
    customField?: InputMaybe<CustomFieldUpdateOneWithoutCustomFieldValuesNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CustomFieldValueUpsertWithWhereUniqueWithoutCustomFieldInput = {
    create: CustomFieldValueCreateWithoutCustomFieldInput;
    update: CustomFieldValueUpdateWithoutCustomFieldInput;
    where: CustomFieldValueWhereUniqueInput;
};

export type CustomFieldValueUpsertWithWhereUniqueWithoutEncounterInput = {
    create: CustomFieldValueCreateWithoutEncounterInput;
    update: CustomFieldValueUpdateWithoutEncounterInput;
    where: CustomFieldValueWhereUniqueInput;
};

export type CustomFieldValueWhereInput = {
    AND?: InputMaybe<Array<CustomFieldValueWhereInput>>;
    NOT?: InputMaybe<Array<CustomFieldValueWhereInput>>;
    OR?: InputMaybe<Array<CustomFieldValueWhereInput>>;
    customField?: InputMaybe<CustomFieldNullableRelationFilter>;
    customFieldId?: InputMaybe<UuidNullableFilter>;
    encounter?: InputMaybe<EncounterNullableRelationFilter>;
    encounterId?: InputMaybe<UuidNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    value?: InputMaybe<StringFilter>;
};

export type CustomFieldValueWhereUniqueInput = {
    AND?: InputMaybe<Array<CustomFieldValueWhereInput>>;
    NOT?: InputMaybe<Array<CustomFieldValueWhereInput>>;
    OR?: InputMaybe<Array<CustomFieldValueWhereInput>>;
    customField?: InputMaybe<CustomFieldNullableRelationFilter>;
    customFieldId?: InputMaybe<UuidNullableFilter>;
    customFieldId_encounterId?: InputMaybe<CustomFieldValueCustomFieldIdEncounterIdCompoundUniqueInput>;
    encounter?: InputMaybe<EncounterNullableRelationFilter>;
    encounterId?: InputMaybe<UuidNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<StringFilter>;
};

export type CustomFieldWhereInput = {
    AND?: InputMaybe<Array<CustomFieldWhereInput>>;
    NOT?: InputMaybe<Array<CustomFieldWhereInput>>;
    OR?: InputMaybe<Array<CustomFieldWhereInput>>;
    customFieldType?: InputMaybe<EnumCustomFieldTypeEnumFilter>;
    customFieldValues?: InputMaybe<CustomFieldValueListRelationFilter>;
    id?: InputMaybe<UuidFilter>;
    name?: InputMaybe<StringFilter>;
    practiceId?: InputMaybe<IntFilter>;
};

export type CustomFieldWhereUniqueInput = {
    AND?: InputMaybe<Array<CustomFieldWhereInput>>;
    NOT?: InputMaybe<Array<CustomFieldWhereInput>>;
    OR?: InputMaybe<Array<CustomFieldWhereInput>>;
    customFieldType?: InputMaybe<EnumCustomFieldTypeEnumFilter>;
    customFieldValues?: InputMaybe<CustomFieldValueListRelationFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<StringFilter>;
    name_practiceId?: InputMaybe<CustomFieldNamePracticeIdCompoundUniqueInput>;
    practiceId?: InputMaybe<IntFilter>;
};

export enum DayOfWeek {
    Friday = 'FRIDAY',
    Monday = 'MONDAY',
    Saturday = 'SATURDAY',
    Sunday = 'SUNDAY',
    Thursday = 'THURSDAY',
    Tuesday = 'TUESDAY',
    Wednesday = 'WEDNESDAY',
}

export enum DiscountType {
    Dollar = 'DOLLAR',
    Percent = 'PERCENT',
}

export type DataMigrations = {
    __typename?: 'DataMigrations';
    migrationId: Scalars['String']['output'];
    timestamp: Scalars['DateTimeISO']['output'];
};

export type DataMigrationsCountAggregate = {
    __typename?: 'DataMigrationsCountAggregate';
    _all: Scalars['Int']['output'];
    migrationId: Scalars['Int']['output'];
    timestamp: Scalars['Int']['output'];
};

export type DataMigrationsCountOrderByAggregateInput = {
    migrationId?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type DataMigrationsCreateInput = {
    migrationId: Scalars['String']['input'];
    timestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DataMigrationsCreateManyInput = {
    migrationId: Scalars['String']['input'];
    timestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DataMigrationsGroupBy = {
    __typename?: 'DataMigrationsGroupBy';
    _count?: Maybe<DataMigrationsCountAggregate>;
    _max?: Maybe<DataMigrationsMaxAggregate>;
    _min?: Maybe<DataMigrationsMinAggregate>;
    migrationId: Scalars['String']['output'];
    timestamp: Scalars['DateTimeISO']['output'];
};

export type DataMigrationsMaxAggregate = {
    __typename?: 'DataMigrationsMaxAggregate';
    migrationId?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DataMigrationsMaxOrderByAggregateInput = {
    migrationId?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type DataMigrationsMinAggregate = {
    __typename?: 'DataMigrationsMinAggregate';
    migrationId?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DataMigrationsMinOrderByAggregateInput = {
    migrationId?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type DataMigrationsOrderByWithAggregationInput = {
    _count?: InputMaybe<DataMigrationsCountOrderByAggregateInput>;
    _max?: InputMaybe<DataMigrationsMaxOrderByAggregateInput>;
    _min?: InputMaybe<DataMigrationsMinOrderByAggregateInput>;
    migrationId?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type DataMigrationsOrderByWithRelationInput = {
    migrationId?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export enum DataMigrationsScalarFieldEnum {
    MigrationId = 'migrationId',
    Timestamp = 'timestamp',
}

export type DataMigrationsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<DataMigrationsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<DataMigrationsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<DataMigrationsScalarWhereWithAggregatesInput>>;
    migrationId?: InputMaybe<StringWithAggregatesFilter>;
    timestamp?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DataMigrationsUpdateInput = {
    migrationId?: InputMaybe<StringFieldUpdateOperationsInput>;
    timestamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataMigrationsUpdateManyMutationInput = {
    migrationId?: InputMaybe<StringFieldUpdateOperationsInput>;
    timestamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataMigrationsWhereInput = {
    AND?: InputMaybe<Array<DataMigrationsWhereInput>>;
    NOT?: InputMaybe<Array<DataMigrationsWhereInput>>;
    OR?: InputMaybe<Array<DataMigrationsWhereInput>>;
    migrationId?: InputMaybe<StringFilter>;
    timestamp?: InputMaybe<DateTimeFilter>;
};

export type DataMigrationsWhereUniqueInput = {
    AND?: InputMaybe<Array<DataMigrationsWhereInput>>;
    NOT?: InputMaybe<Array<DataMigrationsWhereInput>>;
    OR?: InputMaybe<Array<DataMigrationsWhereInput>>;
    migrationId?: InputMaybe<Scalars['String']['input']>;
    timestamp?: InputMaybe<DateTimeFilter>;
};

export type DateTimeFieldUpdateOperationsInput = {
    set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DateTimeFilter = {
    equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
    lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    not?: InputMaybe<NestedDateTimeFilter>;
    notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeNullableFilter = {
    equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
    lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    not?: InputMaybe<NestedDateTimeNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedDateTimeNullableFilter>;
    _min?: InputMaybe<NestedDateTimeNullableFilter>;
    equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
    lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedDateTimeFilter>;
    _min?: InputMaybe<NestedDateTimeFilter>;
    equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
    lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export enum DayOfWeekEnum {
    Friday = 'FRIDAY',
    Monday = 'MONDAY',
    Saturday = 'SATURDAY',
    Sunday = 'SUNDAY',
    Thursday = 'THURSDAY',
    Tuesday = 'TUESDAY',
    Wednesday = 'WEDNESDAY',
}

export type DeactivateInsuranceInput = {
    id: Scalars['String']['input'];
    orgId: Scalars['Float']['input'];
};

export type DeactivateInsuranceResponse = {
    __typename?: 'DeactivateInsuranceResponse';
    _count?: Maybe<InsuranceCount>;
    consumer?: Maybe<Consumer>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    ehrWriteError?: Maybe<Scalars['Boolean']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance: Scalars['Boolean']['output'];
    lastCheckedAt: Scalars['DateTimeISO']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId: Scalars['String']['output'];
    otherInsurances?: Maybe<Scalars['JSON']['output']>;
    payer: Scalars['String']['output'];
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    photos: Array<ConsumerPhotoMetaData>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status: InsurancesStatusEnum;
    subscriberInfo?: Maybe<Scalars['JSON']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DeactivateInsuranceResponseConsumerArgs = {
    where?: InputMaybe<ConsumerWhereInput>;
};

export type DeactivateInsuranceResponsePhotosArgs = {
    cursor?: InputMaybe<ConsumerPhotoMetaDataWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerPhotoMetaDataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerPhotoMetaDataOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type DecimalFieldUpdateOperationsInput = {
    decrement?: InputMaybe<Scalars['Decimal']['input']>;
    divide?: InputMaybe<Scalars['Decimal']['input']>;
    increment?: InputMaybe<Scalars['Decimal']['input']>;
    multiply?: InputMaybe<Scalars['Decimal']['input']>;
    set?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DecimalFilter = {
    equals?: InputMaybe<Scalars['Decimal']['input']>;
    gt?: InputMaybe<Scalars['Decimal']['input']>;
    gte?: InputMaybe<Scalars['Decimal']['input']>;
    in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
    lt?: InputMaybe<Scalars['Decimal']['input']>;
    lte?: InputMaybe<Scalars['Decimal']['input']>;
    not?: InputMaybe<NestedDecimalFilter>;
    notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalNullableFilter = {
    equals?: InputMaybe<Scalars['Decimal']['input']>;
    gt?: InputMaybe<Scalars['Decimal']['input']>;
    gte?: InputMaybe<Scalars['Decimal']['input']>;
    in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
    lt?: InputMaybe<Scalars['Decimal']['input']>;
    lte?: InputMaybe<Scalars['Decimal']['input']>;
    not?: InputMaybe<NestedDecimalNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalNullableWithAggregatesFilter = {
    _avg?: InputMaybe<NestedDecimalNullableFilter>;
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedDecimalNullableFilter>;
    _min?: InputMaybe<NestedDecimalNullableFilter>;
    _sum?: InputMaybe<NestedDecimalNullableFilter>;
    equals?: InputMaybe<Scalars['Decimal']['input']>;
    gt?: InputMaybe<Scalars['Decimal']['input']>;
    gte?: InputMaybe<Scalars['Decimal']['input']>;
    in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
    lt?: InputMaybe<Scalars['Decimal']['input']>;
    lte?: InputMaybe<Scalars['Decimal']['input']>;
    not?: InputMaybe<NestedDecimalNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalWithAggregatesFilter = {
    _avg?: InputMaybe<NestedDecimalFilter>;
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedDecimalFilter>;
    _min?: InputMaybe<NestedDecimalFilter>;
    _sum?: InputMaybe<NestedDecimalFilter>;
    equals?: InputMaybe<Scalars['Decimal']['input']>;
    gt?: InputMaybe<Scalars['Decimal']['input']>;
    gte?: InputMaybe<Scalars['Decimal']['input']>;
    in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
    lt?: InputMaybe<Scalars['Decimal']['input']>;
    lte?: InputMaybe<Scalars['Decimal']['input']>;
    not?: InputMaybe<NestedDecimalWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DefaultPractice = {
    __typename?: 'DefaultPractice';
    createdAt: Scalars['DateTimeISO']['output'];
    defaultPracticeId: Scalars['Int']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    practice: Practice;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DefaultPracticeAvgAggregate = {
    __typename?: 'DefaultPracticeAvgAggregate';
    defaultPracticeId?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type DefaultPracticeAvgOrderByAggregateInput = {
    defaultPracticeId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type DefaultPracticeCountAggregate = {
    __typename?: 'DefaultPracticeCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    defaultPracticeId: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type DefaultPracticeCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    defaultPracticeId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DefaultPracticeCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    org: OrganizationCreateNestedOneWithoutDefaultPracticesInput;
    practice: PracticeCreateNestedOneWithoutDefaultPracticesInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DefaultPracticeCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    defaultPracticeId: Scalars['Int']['input'];
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DefaultPracticeCreateManyOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    defaultPracticeId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DefaultPracticeCreateManyOrgInputEnvelope = {
    data: Array<DefaultPracticeCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultPracticeCreateManyPracticeInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DefaultPracticeCreateManyPracticeInputEnvelope = {
    data: Array<DefaultPracticeCreateManyPracticeInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultPracticeCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<DefaultPracticeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DefaultPracticeCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<DefaultPracticeCreateWithoutOrgInput>>;
    createMany?: InputMaybe<DefaultPracticeCreateManyOrgInputEnvelope>;
};

export type DefaultPracticeCreateNestedManyWithoutPracticeInput = {
    connect?: InputMaybe<Array<DefaultPracticeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DefaultPracticeCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<Array<DefaultPracticeCreateWithoutPracticeInput>>;
    createMany?: InputMaybe<DefaultPracticeCreateManyPracticeInputEnvelope>;
};

export type DefaultPracticeCreateOrConnectWithoutOrgInput = {
    create: DefaultPracticeCreateWithoutOrgInput;
    where: DefaultPracticeWhereUniqueInput;
};

export type DefaultPracticeCreateOrConnectWithoutPracticeInput = {
    create: DefaultPracticeCreateWithoutPracticeInput;
    where: DefaultPracticeWhereUniqueInput;
};

export type DefaultPracticeCreateWithoutOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    practice: PracticeCreateNestedOneWithoutDefaultPracticesInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DefaultPracticeCreateWithoutPracticeInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    org: OrganizationCreateNestedOneWithoutDefaultPracticesInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DefaultPracticeGroupBy = {
    __typename?: 'DefaultPracticeGroupBy';
    _avg?: Maybe<DefaultPracticeAvgAggregate>;
    _count?: Maybe<DefaultPracticeCountAggregate>;
    _max?: Maybe<DefaultPracticeMaxAggregate>;
    _min?: Maybe<DefaultPracticeMinAggregate>;
    _sum?: Maybe<DefaultPracticeSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    defaultPracticeId: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DefaultPracticeListRelationFilter = {
    every?: InputMaybe<DefaultPracticeWhereInput>;
    none?: InputMaybe<DefaultPracticeWhereInput>;
    some?: InputMaybe<DefaultPracticeWhereInput>;
};

export type DefaultPracticeMaxAggregate = {
    __typename?: 'DefaultPracticeMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    defaultPracticeId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DefaultPracticeMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    defaultPracticeId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DefaultPracticeMinAggregate = {
    __typename?: 'DefaultPracticeMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    defaultPracticeId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DefaultPracticeMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    defaultPracticeId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DefaultPracticeOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type DefaultPracticeOrderByWithAggregationInput = {
    _avg?: InputMaybe<DefaultPracticeAvgOrderByAggregateInput>;
    _count?: InputMaybe<DefaultPracticeCountOrderByAggregateInput>;
    _max?: InputMaybe<DefaultPracticeMaxOrderByAggregateInput>;
    _min?: InputMaybe<DefaultPracticeMinOrderByAggregateInput>;
    _sum?: InputMaybe<DefaultPracticeSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    defaultPracticeId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DefaultPracticeOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    defaultPracticeId?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    practice?: InputMaybe<PracticeOrderByWithRelationInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DefaultPracticeOrgIdDefaultPracticeIdCompoundUniqueInput = {
    defaultPracticeId: Scalars['Int']['input'];
    orgId: Scalars['Int']['input'];
};

export enum DefaultPracticeScalarFieldEnum {
    CreatedAt = 'createdAt',
    DefaultPracticeId = 'defaultPracticeId',
    OrgId = 'orgId',
    UpdatedAt = 'updatedAt',
}

export type DefaultPracticeScalarWhereInput = {
    AND?: InputMaybe<Array<DefaultPracticeScalarWhereInput>>;
    NOT?: InputMaybe<Array<DefaultPracticeScalarWhereInput>>;
    OR?: InputMaybe<Array<DefaultPracticeScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    defaultPracticeId?: InputMaybe<IntFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DefaultPracticeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<DefaultPracticeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<DefaultPracticeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<DefaultPracticeScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    defaultPracticeId?: InputMaybe<IntWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DefaultPracticeSumAggregate = {
    __typename?: 'DefaultPracticeSumAggregate';
    defaultPracticeId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type DefaultPracticeSumOrderByAggregateInput = {
    defaultPracticeId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type DefaultPracticeUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDefaultPracticesNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutDefaultPracticesNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefaultPracticeUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefaultPracticeUpdateManyWithWhereWithoutOrgInput = {
    data: DefaultPracticeUpdateManyMutationInput;
    where: DefaultPracticeScalarWhereInput;
};

export type DefaultPracticeUpdateManyWithWhereWithoutPracticeInput = {
    data: DefaultPracticeUpdateManyMutationInput;
    where: DefaultPracticeScalarWhereInput;
};

export type DefaultPracticeUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<DefaultPracticeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DefaultPracticeCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<DefaultPracticeCreateWithoutOrgInput>>;
    createMany?: InputMaybe<DefaultPracticeCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<DefaultPracticeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DefaultPracticeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DefaultPracticeWhereUniqueInput>>;
    set?: InputMaybe<Array<DefaultPracticeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DefaultPracticeUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<DefaultPracticeUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<DefaultPracticeUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type DefaultPracticeUpdateManyWithoutPracticeNestedInput = {
    connect?: InputMaybe<Array<DefaultPracticeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DefaultPracticeCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<Array<DefaultPracticeCreateWithoutPracticeInput>>;
    createMany?: InputMaybe<DefaultPracticeCreateManyPracticeInputEnvelope>;
    delete?: InputMaybe<Array<DefaultPracticeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DefaultPracticeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DefaultPracticeWhereUniqueInput>>;
    set?: InputMaybe<Array<DefaultPracticeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DefaultPracticeUpdateWithWhereUniqueWithoutPracticeInput>
    >;
    updateMany?: InputMaybe<
        Array<DefaultPracticeUpdateManyWithWhereWithoutPracticeInput>
    >;
    upsert?: InputMaybe<
        Array<DefaultPracticeUpsertWithWhereUniqueWithoutPracticeInput>
    >;
};

export type DefaultPracticeUpdateWithWhereUniqueWithoutOrgInput = {
    data: DefaultPracticeUpdateWithoutOrgInput;
    where: DefaultPracticeWhereUniqueInput;
};

export type DefaultPracticeUpdateWithWhereUniqueWithoutPracticeInput = {
    data: DefaultPracticeUpdateWithoutPracticeInput;
    where: DefaultPracticeWhereUniqueInput;
};

export type DefaultPracticeUpdateWithoutOrgInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutDefaultPracticesNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefaultPracticeUpdateWithoutPracticeInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDefaultPracticesNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefaultPracticeUpsertWithWhereUniqueWithoutOrgInput = {
    create: DefaultPracticeCreateWithoutOrgInput;
    update: DefaultPracticeUpdateWithoutOrgInput;
    where: DefaultPracticeWhereUniqueInput;
};

export type DefaultPracticeUpsertWithWhereUniqueWithoutPracticeInput = {
    create: DefaultPracticeCreateWithoutPracticeInput;
    update: DefaultPracticeUpdateWithoutPracticeInput;
    where: DefaultPracticeWhereUniqueInput;
};

export type DefaultPracticeWhereInput = {
    AND?: InputMaybe<Array<DefaultPracticeWhereInput>>;
    NOT?: InputMaybe<Array<DefaultPracticeWhereInput>>;
    OR?: InputMaybe<Array<DefaultPracticeWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    defaultPracticeId?: InputMaybe<IntFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DefaultPracticeWhereUniqueInput = {
    AND?: InputMaybe<Array<DefaultPracticeWhereInput>>;
    NOT?: InputMaybe<Array<DefaultPracticeWhereInput>>;
    OR?: InputMaybe<Array<DefaultPracticeWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    defaultPracticeId?: InputMaybe<IntFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    orgId_defaultPracticeId?: InputMaybe<DefaultPracticeOrgIdDefaultPracticeIdCompoundUniqueInput>;
    practice?: InputMaybe<PracticeRelationFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DefaultProviders = {
    __typename?: 'Default_providers';
    id: Scalars['Int']['output'];
    npi: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    practice_id: Scalars['Int']['output'];
    state?: Maybe<State>;
};

export type DefaultProvidersAvgAggregate = {
    __typename?: 'Default_providersAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    practice_id?: Maybe<Scalars['Float']['output']>;
};

export type DefaultProvidersAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrder>;
};

export type DefaultProvidersCountAggregate = {
    __typename?: 'Default_providersCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    practice_id: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
};

export type DefaultProvidersCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
};

export type DefaultProvidersCreateInput = {
    npi: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practice_id: Scalars['Int']['input'];
    state?: InputMaybe<State>;
};

export type DefaultProvidersCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    npi: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practice_id: Scalars['Int']['input'];
    state?: InputMaybe<State>;
};

export type DefaultProvidersGroupBy = {
    __typename?: 'Default_providersGroupBy';
    _avg?: Maybe<DefaultProvidersAvgAggregate>;
    _count?: Maybe<DefaultProvidersCountAggregate>;
    _max?: Maybe<DefaultProvidersMaxAggregate>;
    _min?: Maybe<DefaultProvidersMinAggregate>;
    _sum?: Maybe<DefaultProvidersSumAggregate>;
    id: Scalars['Int']['output'];
    npi: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    practice_id: Scalars['Int']['output'];
    state?: Maybe<State>;
};

export type DefaultProvidersMaxAggregate = {
    __typename?: 'Default_providersMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practice_id?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<State>;
};

export type DefaultProvidersMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
};

export type DefaultProvidersMinAggregate = {
    __typename?: 'Default_providersMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practice_id?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<State>;
};

export type DefaultProvidersMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
};

export type DefaultProvidersOrderByWithAggregationInput = {
    _avg?: InputMaybe<DefaultProvidersAvgOrderByAggregateInput>;
    _count?: InputMaybe<DefaultProvidersCountOrderByAggregateInput>;
    _max?: InputMaybe<DefaultProvidersMaxOrderByAggregateInput>;
    _min?: InputMaybe<DefaultProvidersMinOrderByAggregateInput>;
    _sum?: InputMaybe<DefaultProvidersSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    practice_id?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrderInput>;
};

export type DefaultProvidersOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    practice_id?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrderInput>;
};

export enum DefaultProvidersScalarFieldEnum {
    Id = 'id',
    Npi = 'npi',
    OrgId = 'orgId',
    PracticeId = 'practice_id',
    State = 'state',
}

export type DefaultProvidersScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<DefaultProvidersScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<DefaultProvidersScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<DefaultProvidersScalarWhereWithAggregatesInput>>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    npi?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    practice_id?: InputMaybe<IntWithAggregatesFilter>;
    state?: InputMaybe<EnumStateNullableWithAggregatesFilter>;
};

export type DefaultProvidersSumAggregate = {
    __typename?: 'Default_providersSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practice_id?: Maybe<Scalars['Int']['output']>;
};

export type DefaultProvidersSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrder>;
};

export type DefaultProvidersUpdateInput = {
    npi?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practice_id?: InputMaybe<IntFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableEnumStateFieldUpdateOperationsInput>;
};

export type DefaultProvidersUpdateManyMutationInput = {
    npi?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practice_id?: InputMaybe<IntFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableEnumStateFieldUpdateOperationsInput>;
};

export type DefaultProvidersWhereInput = {
    AND?: InputMaybe<Array<DefaultProvidersWhereInput>>;
    NOT?: InputMaybe<Array<DefaultProvidersWhereInput>>;
    OR?: InputMaybe<Array<DefaultProvidersWhereInput>>;
    id?: InputMaybe<IntFilter>;
    npi?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    practice_id?: InputMaybe<IntFilter>;
    state?: InputMaybe<EnumStateNullableFilter>;
};

export type DefaultProvidersWhereUniqueInput = {
    AND?: InputMaybe<Array<DefaultProvidersWhereInput>>;
    NOT?: InputMaybe<Array<DefaultProvidersWhereInput>>;
    OR?: InputMaybe<Array<DefaultProvidersWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    npi?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    practice_id?: InputMaybe<IntFilter>;
    state?: InputMaybe<EnumStateNullableFilter>;
};

export type DeploymentOrgPhase = {
    __typename?: 'DeploymentOrgPhase';
    _count?: Maybe<DeploymentOrgPhaseCount>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    org: Organization;
    orgId: Scalars['Int']['output'];
    orgTasks: Array<DeploymentOrgTask>;
    phase?: Maybe<DeploymentPhase>;
    phaseId?: Maybe<Scalars['Int']['output']>;
    sortOrder: Scalars['Int']['output'];
    startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DeploymentOrgPhaseOrgTasksArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgTaskOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type DeploymentOrgPhasePhaseArgs = {
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type DeploymentOrgPhaseAvgAggregate = {
    __typename?: 'DeploymentOrgPhaseAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    phaseId?: Maybe<Scalars['Float']['output']>;
    sortOrder?: Maybe<Scalars['Float']['output']>;
};

export type DeploymentOrgPhaseAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
};

export type DeploymentOrgPhaseCount = {
    __typename?: 'DeploymentOrgPhaseCount';
    orgTasks: Scalars['Int']['output'];
};

export type DeploymentOrgPhaseCountOrgTasksArgs = {
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type DeploymentOrgPhaseCountAggregate = {
    __typename?: 'DeploymentOrgPhaseCountAggregate';
    _all: Scalars['Int']['output'];
    completedAt: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    phaseId: Scalars['Int']['output'];
    sortOrder: Scalars['Int']['output'];
    startedAt: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type DeploymentOrgPhaseCountOrderByAggregateInput = {
    completedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentOrgPhaseCreateInput = {
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutDeploymentOrgPhaseInput;
    orgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgPhaseInput>;
    phase?: InputMaybe<DeploymentPhaseCreateNestedOneWithoutOrgPhasesInput>;
    sortOrder: Scalars['Int']['input'];
    startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgPhaseCreateManyInput = {
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    phaseId?: InputMaybe<Scalars['Int']['input']>;
    sortOrder: Scalars['Int']['input'];
    startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgPhaseCreateManyOrgInput = {
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    phaseId?: InputMaybe<Scalars['Int']['input']>;
    sortOrder: Scalars['Int']['input'];
    startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgPhaseCreateManyOrgInputEnvelope = {
    data: Array<DeploymentOrgPhaseCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentOrgPhaseCreateManyPhaseInput = {
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    sortOrder: Scalars['Int']['input'];
    startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgPhaseCreateManyPhaseInputEnvelope = {
    data: Array<DeploymentOrgPhaseCreateManyPhaseInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentOrgPhaseCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<DeploymentOrgPhaseWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgPhaseCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgPhaseCreateWithoutOrgInput>>;
    createMany?: InputMaybe<DeploymentOrgPhaseCreateManyOrgInputEnvelope>;
};

export type DeploymentOrgPhaseCreateNestedManyWithoutPhaseInput = {
    connect?: InputMaybe<Array<DeploymentOrgPhaseWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgPhaseCreateOrConnectWithoutPhaseInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgPhaseCreateWithoutPhaseInput>>;
    createMany?: InputMaybe<DeploymentOrgPhaseCreateManyPhaseInputEnvelope>;
};

export type DeploymentOrgPhaseCreateNestedOneWithoutOrgTasksInput = {
    connect?: InputMaybe<DeploymentOrgPhaseWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentOrgPhaseCreateOrConnectWithoutOrgTasksInput>;
    create?: InputMaybe<DeploymentOrgPhaseCreateWithoutOrgTasksInput>;
};

export type DeploymentOrgPhaseCreateOrConnectWithoutOrgInput = {
    create: DeploymentOrgPhaseCreateWithoutOrgInput;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type DeploymentOrgPhaseCreateOrConnectWithoutOrgTasksInput = {
    create: DeploymentOrgPhaseCreateWithoutOrgTasksInput;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type DeploymentOrgPhaseCreateOrConnectWithoutPhaseInput = {
    create: DeploymentOrgPhaseCreateWithoutPhaseInput;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type DeploymentOrgPhaseCreateWithoutOrgInput = {
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgPhaseInput>;
    phase?: InputMaybe<DeploymentPhaseCreateNestedOneWithoutOrgPhasesInput>;
    sortOrder: Scalars['Int']['input'];
    startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgPhaseCreateWithoutOrgTasksInput = {
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutDeploymentOrgPhaseInput;
    phase?: InputMaybe<DeploymentPhaseCreateNestedOneWithoutOrgPhasesInput>;
    sortOrder: Scalars['Int']['input'];
    startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgPhaseCreateWithoutPhaseInput = {
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutDeploymentOrgPhaseInput;
    orgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgPhaseInput>;
    sortOrder: Scalars['Int']['input'];
    startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgPhaseGroupBy = {
    __typename?: 'DeploymentOrgPhaseGroupBy';
    _avg?: Maybe<DeploymentOrgPhaseAvgAggregate>;
    _count?: Maybe<DeploymentOrgPhaseCountAggregate>;
    _max?: Maybe<DeploymentOrgPhaseMaxAggregate>;
    _min?: Maybe<DeploymentOrgPhaseMinAggregate>;
    _sum?: Maybe<DeploymentOrgPhaseSumAggregate>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    phaseId?: Maybe<Scalars['Int']['output']>;
    sortOrder: Scalars['Int']['output'];
    startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DeploymentOrgPhaseListRelationFilter = {
    every?: InputMaybe<DeploymentOrgPhaseWhereInput>;
    none?: InputMaybe<DeploymentOrgPhaseWhereInput>;
    some?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type DeploymentOrgPhaseMaxAggregate = {
    __typename?: 'DeploymentOrgPhaseMaxAggregate';
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phaseId?: Maybe<Scalars['Int']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DeploymentOrgPhaseMaxOrderByAggregateInput = {
    completedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentOrgPhaseMinAggregate = {
    __typename?: 'DeploymentOrgPhaseMinAggregate';
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phaseId?: Maybe<Scalars['Int']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DeploymentOrgPhaseMinOrderByAggregateInput = {
    completedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentOrgPhaseNullableRelationFilter = {
    is?: InputMaybe<DeploymentOrgPhaseWhereInput>;
    isNot?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type DeploymentOrgPhaseOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type DeploymentOrgPhaseOrderByWithAggregationInput = {
    _avg?: InputMaybe<DeploymentOrgPhaseAvgOrderByAggregateInput>;
    _count?: InputMaybe<DeploymentOrgPhaseCountOrderByAggregateInput>;
    _max?: InputMaybe<DeploymentOrgPhaseMaxOrderByAggregateInput>;
    _min?: InputMaybe<DeploymentOrgPhaseMinOrderByAggregateInput>;
    _sum?: InputMaybe<DeploymentOrgPhaseSumOrderByAggregateInput>;
    completedAt?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrderInput>;
    sortOrder?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentOrgPhaseOrderByWithRelationInput = {
    completedAt?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    orgTasks?: InputMaybe<DeploymentOrgTaskOrderByRelationAggregateInput>;
    phase?: InputMaybe<DeploymentPhaseOrderByWithRelationInput>;
    phaseId?: InputMaybe<SortOrderInput>;
    sortOrder?: InputMaybe<SortOrder>;
    startedAt?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentOrgPhaseOrgIdPhaseIdCompoundUniqueInput = {
    orgId: Scalars['Int']['input'];
    phaseId: Scalars['Int']['input'];
};

export type DeploymentOrgPhaseOrgIdSortOrderCompoundUniqueInput = {
    orgId: Scalars['Int']['input'];
    sortOrder: Scalars['Int']['input'];
};

export enum DeploymentOrgPhaseScalarFieldEnum {
    CompletedAt = 'completedAt',
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    Id = 'id',
    IsActive = 'isActive',
    Name = 'name',
    Notes = 'notes',
    OrgId = 'orgId',
    PhaseId = 'phaseId',
    SortOrder = 'sortOrder',
    StartedAt = 'startedAt',
    UpdatedAt = 'updatedAt',
}

export type DeploymentOrgPhaseScalarWhereInput = {
    AND?: InputMaybe<Array<DeploymentOrgPhaseScalarWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgPhaseScalarWhereInput>>;
    OR?: InputMaybe<Array<DeploymentOrgPhaseScalarWhereInput>>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    phaseId?: InputMaybe<IntNullableFilter>;
    sortOrder?: InputMaybe<IntFilter>;
    startedAt?: InputMaybe<DateTimeNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentOrgPhaseScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<DeploymentOrgPhaseScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgPhaseScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<DeploymentOrgPhaseScalarWhereWithAggregatesInput>>;
    completedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    phaseId?: InputMaybe<IntNullableWithAggregatesFilter>;
    sortOrder?: InputMaybe<IntWithAggregatesFilter>;
    startedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DeploymentOrgPhaseSumAggregate = {
    __typename?: 'DeploymentOrgPhaseSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phaseId?: Maybe<Scalars['Int']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type DeploymentOrgPhaseSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
};

export type DeploymentOrgPhaseUpdateInput = {
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDeploymentOrgPhaseNestedInput>;
    orgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgPhaseNestedInput>;
    phase?: InputMaybe<DeploymentPhaseUpdateOneWithoutOrgPhasesNestedInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentOrgPhaseUpdateManyMutationInput = {
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentOrgPhaseUpdateManyWithWhereWithoutOrgInput = {
    data: DeploymentOrgPhaseUpdateManyMutationInput;
    where: DeploymentOrgPhaseScalarWhereInput;
};

export type DeploymentOrgPhaseUpdateManyWithWhereWithoutPhaseInput = {
    data: DeploymentOrgPhaseUpdateManyMutationInput;
    where: DeploymentOrgPhaseScalarWhereInput;
};

export type DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<DeploymentOrgPhaseWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgPhaseCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgPhaseCreateWithoutOrgInput>>;
    createMany?: InputMaybe<DeploymentOrgPhaseCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<DeploymentOrgPhaseWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeploymentOrgPhaseScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DeploymentOrgPhaseWhereUniqueInput>>;
    set?: InputMaybe<Array<DeploymentOrgPhaseWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DeploymentOrgPhaseUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<DeploymentOrgPhaseUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<DeploymentOrgPhaseUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type DeploymentOrgPhaseUpdateManyWithoutPhaseNestedInput = {
    connect?: InputMaybe<Array<DeploymentOrgPhaseWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgPhaseCreateOrConnectWithoutPhaseInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgPhaseCreateWithoutPhaseInput>>;
    createMany?: InputMaybe<DeploymentOrgPhaseCreateManyPhaseInputEnvelope>;
    delete?: InputMaybe<Array<DeploymentOrgPhaseWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeploymentOrgPhaseScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DeploymentOrgPhaseWhereUniqueInput>>;
    set?: InputMaybe<Array<DeploymentOrgPhaseWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DeploymentOrgPhaseUpdateWithWhereUniqueWithoutPhaseInput>
    >;
    updateMany?: InputMaybe<
        Array<DeploymentOrgPhaseUpdateManyWithWhereWithoutPhaseInput>
    >;
    upsert?: InputMaybe<
        Array<DeploymentOrgPhaseUpsertWithWhereUniqueWithoutPhaseInput>
    >;
};

export type DeploymentOrgPhaseUpdateOneWithoutOrgTasksNestedInput = {
    connect?: InputMaybe<DeploymentOrgPhaseWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentOrgPhaseCreateOrConnectWithoutOrgTasksInput>;
    create?: InputMaybe<DeploymentOrgPhaseCreateWithoutOrgTasksInput>;
    delete?: InputMaybe<DeploymentOrgPhaseWhereInput>;
    disconnect?: InputMaybe<DeploymentOrgPhaseWhereInput>;
    update?: InputMaybe<DeploymentOrgPhaseUpdateToOneWithWhereWithoutOrgTasksInput>;
    upsert?: InputMaybe<DeploymentOrgPhaseUpsertWithoutOrgTasksInput>;
};

export type DeploymentOrgPhaseUpdateToOneWithWhereWithoutOrgTasksInput = {
    data: DeploymentOrgPhaseUpdateWithoutOrgTasksInput;
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type DeploymentOrgPhaseUpdateWithWhereUniqueWithoutOrgInput = {
    data: DeploymentOrgPhaseUpdateWithoutOrgInput;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type DeploymentOrgPhaseUpdateWithWhereUniqueWithoutPhaseInput = {
    data: DeploymentOrgPhaseUpdateWithoutPhaseInput;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type DeploymentOrgPhaseUpdateWithoutOrgInput = {
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgPhaseNestedInput>;
    phase?: InputMaybe<DeploymentPhaseUpdateOneWithoutOrgPhasesNestedInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentOrgPhaseUpdateWithoutOrgTasksInput = {
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDeploymentOrgPhaseNestedInput>;
    phase?: InputMaybe<DeploymentPhaseUpdateOneWithoutOrgPhasesNestedInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentOrgPhaseUpdateWithoutPhaseInput = {
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDeploymentOrgPhaseNestedInput>;
    orgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgPhaseNestedInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentOrgPhaseUpsertWithWhereUniqueWithoutOrgInput = {
    create: DeploymentOrgPhaseCreateWithoutOrgInput;
    update: DeploymentOrgPhaseUpdateWithoutOrgInput;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type DeploymentOrgPhaseUpsertWithWhereUniqueWithoutPhaseInput = {
    create: DeploymentOrgPhaseCreateWithoutPhaseInput;
    update: DeploymentOrgPhaseUpdateWithoutPhaseInput;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type DeploymentOrgPhaseUpsertWithoutOrgTasksInput = {
    create: DeploymentOrgPhaseCreateWithoutOrgTasksInput;
    update: DeploymentOrgPhaseUpdateWithoutOrgTasksInput;
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type DeploymentOrgPhaseWhereInput = {
    AND?: InputMaybe<Array<DeploymentOrgPhaseWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgPhaseWhereInput>>;
    OR?: InputMaybe<Array<DeploymentOrgPhaseWhereInput>>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgTasks?: InputMaybe<DeploymentOrgTaskListRelationFilter>;
    phase?: InputMaybe<DeploymentPhaseNullableRelationFilter>;
    phaseId?: InputMaybe<IntNullableFilter>;
    sortOrder?: InputMaybe<IntFilter>;
    startedAt?: InputMaybe<DateTimeNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentOrgPhaseWhereUniqueInput = {
    AND?: InputMaybe<Array<DeploymentOrgPhaseWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgPhaseWhereInput>>;
    OR?: InputMaybe<Array<DeploymentOrgPhaseWhereInput>>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgId_phaseId?: InputMaybe<DeploymentOrgPhaseOrgIdPhaseIdCompoundUniqueInput>;
    orgId_sortOrder?: InputMaybe<DeploymentOrgPhaseOrgIdSortOrderCompoundUniqueInput>;
    orgTasks?: InputMaybe<DeploymentOrgTaskListRelationFilter>;
    phase?: InputMaybe<DeploymentPhaseNullableRelationFilter>;
    phaseId?: InputMaybe<IntNullableFilter>;
    sortOrder?: InputMaybe<IntFilter>;
    startedAt?: InputMaybe<DateTimeNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentOrgTask = {
    __typename?: 'DeploymentOrgTask';
    _count?: Maybe<DeploymentOrgTaskCount>;
    actionTargetKey?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<Scalars['String']['output']>;
    blockedBy: Array<DeploymentOrgTaskDependency>;
    blocks: Array<DeploymentOrgTaskDependency>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    completedByUser?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    dataDriven: Scalars['Boolean']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    org: Organization;
    orgId: Scalars['Int']['output'];
    orgPhase?: Maybe<DeploymentOrgPhase>;
    orgPhaseId?: Maybe<Scalars['Int']['output']>;
    practice?: Maybe<Practice>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    propagationType: PropagationType;
    requiredBeforeGoLive: Scalars['Boolean']['output'];
    sortOrder: Scalars['Int']['output'];
    task?: Maybe<DeploymentTask>;
    taskId?: Maybe<Scalars['Int']['output']>;
    teamId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    verificationDetail?: Maybe<Scalars['String']['output']>;
    verificationKey?: Maybe<Scalars['String']['output']>;
    verificationSource?: Maybe<VerificationSource>;
    verificationStatus: VerificationStatus;
    verifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    visibility: TaskVisibility;
};

export type DeploymentOrgTaskBlockedByArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskDependencyWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskDependencyScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<DeploymentOrgTaskDependencyOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type DeploymentOrgTaskBlocksArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskDependencyWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskDependencyScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<DeploymentOrgTaskDependencyOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type DeploymentOrgTaskOrgPhaseArgs = {
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type DeploymentOrgTaskPracticeArgs = {
    where?: InputMaybe<PracticeWhereInput>;
};

export type DeploymentOrgTaskTaskArgs = {
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentOrgTaskAvgAggregate = {
    __typename?: 'DeploymentOrgTaskAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    orgPhaseId?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
    sortOrder?: Maybe<Scalars['Float']['output']>;
    taskId?: Maybe<Scalars['Float']['output']>;
    teamId?: Maybe<Scalars['Float']['output']>;
};

export type DeploymentOrgTaskAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    orgPhaseId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    taskId?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskCount = {
    __typename?: 'DeploymentOrgTaskCount';
    blockedBy: Scalars['Int']['output'];
    blocks: Scalars['Int']['output'];
};

export type DeploymentOrgTaskCountBlockedByArgs = {
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type DeploymentOrgTaskCountBlocksArgs = {
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type DeploymentOrgTaskCountAggregate = {
    __typename?: 'DeploymentOrgTaskCountAggregate';
    _all: Scalars['Int']['output'];
    actionTargetKey: Scalars['Int']['output'];
    assignee: Scalars['Int']['output'];
    completedAt: Scalars['Int']['output'];
    completedByUser: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    dataDriven: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    orgPhaseId: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    propagationType: Scalars['Int']['output'];
    requiredBeforeGoLive: Scalars['Int']['output'];
    sortOrder: Scalars['Int']['output'];
    taskId: Scalars['Int']['output'];
    teamId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    verificationDetail: Scalars['Int']['output'];
    verificationKey: Scalars['Int']['output'];
    verificationSource: Scalars['Int']['output'];
    verificationStatus: Scalars['Int']['output'];
    verifiedAt: Scalars['Int']['output'];
    visibility: Scalars['Int']['output'];
};

export type DeploymentOrgTaskCountOrderByAggregateInput = {
    actionTargetKey?: InputMaybe<SortOrder>;
    assignee?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrder>;
    completedByUser?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dataDriven?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    orgPhaseId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    requiredBeforeGoLive?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    taskId?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    verificationDetail?: InputMaybe<SortOrder>;
    verificationKey?: InputMaybe<SortOrder>;
    verificationSource?: InputMaybe<SortOrder>;
    verificationStatus?: InputMaybe<SortOrder>;
    verifiedAt?: InputMaybe<SortOrder>;
    visibility?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskCreateInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockedOrgTaskInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockerOrgTaskInput>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutDeploymentOrgTaskInput;
    orgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedOneWithoutOrgTasksInput>;
    practice?: InputMaybe<PracticeCreateNestedOneWithoutDeploymentOrgTasksInput>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    task?: InputMaybe<DeploymentTaskCreateNestedOneWithoutOrgTasksInput>;
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateManyInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    orgPhaseId?: InputMaybe<Scalars['Int']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    taskId?: InputMaybe<Scalars['Int']['input']>;
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateManyOrgInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgPhaseId?: InputMaybe<Scalars['Int']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    taskId?: InputMaybe<Scalars['Int']['input']>;
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateManyOrgInputEnvelope = {
    data: Array<DeploymentOrgTaskCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentOrgTaskCreateManyOrgPhaseInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    taskId?: InputMaybe<Scalars['Int']['input']>;
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateManyOrgPhaseInputEnvelope = {
    data: Array<DeploymentOrgTaskCreateManyOrgPhaseInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentOrgTaskCreateManyPracticeInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    orgPhaseId?: InputMaybe<Scalars['Int']['input']>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    taskId?: InputMaybe<Scalars['Int']['input']>;
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateManyPracticeInputEnvelope = {
    data: Array<DeploymentOrgTaskCreateManyPracticeInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentOrgTaskCreateManyTaskInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    orgPhaseId?: InputMaybe<Scalars['Int']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateManyTaskInputEnvelope = {
    data: Array<DeploymentOrgTaskCreateManyTaskInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentOrgTaskCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgTaskCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgTaskCreateWithoutOrgInput>>;
    createMany?: InputMaybe<DeploymentOrgTaskCreateManyOrgInputEnvelope>;
};

export type DeploymentOrgTaskCreateNestedManyWithoutOrgPhaseInput = {
    connect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgTaskCreateOrConnectWithoutOrgPhaseInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgTaskCreateWithoutOrgPhaseInput>>;
    createMany?: InputMaybe<DeploymentOrgTaskCreateManyOrgPhaseInputEnvelope>;
};

export type DeploymentOrgTaskCreateNestedManyWithoutPracticeInput = {
    connect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgTaskCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgTaskCreateWithoutPracticeInput>>;
    createMany?: InputMaybe<DeploymentOrgTaskCreateManyPracticeInputEnvelope>;
};

export type DeploymentOrgTaskCreateNestedManyWithoutTaskInput = {
    connect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgTaskCreateOrConnectWithoutTaskInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgTaskCreateWithoutTaskInput>>;
    createMany?: InputMaybe<DeploymentOrgTaskCreateManyTaskInputEnvelope>;
};

export type DeploymentOrgTaskCreateNestedOneWithoutBlockedByInput = {
    connect?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentOrgTaskCreateOrConnectWithoutBlockedByInput>;
    create?: InputMaybe<DeploymentOrgTaskCreateWithoutBlockedByInput>;
};

export type DeploymentOrgTaskCreateNestedOneWithoutBlocksInput = {
    connect?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentOrgTaskCreateOrConnectWithoutBlocksInput>;
    create?: InputMaybe<DeploymentOrgTaskCreateWithoutBlocksInput>;
};

export type DeploymentOrgTaskCreateOrConnectWithoutBlockedByInput = {
    create: DeploymentOrgTaskCreateWithoutBlockedByInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskCreateOrConnectWithoutBlocksInput = {
    create: DeploymentOrgTaskCreateWithoutBlocksInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskCreateOrConnectWithoutOrgInput = {
    create: DeploymentOrgTaskCreateWithoutOrgInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskCreateOrConnectWithoutOrgPhaseInput = {
    create: DeploymentOrgTaskCreateWithoutOrgPhaseInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskCreateOrConnectWithoutPracticeInput = {
    create: DeploymentOrgTaskCreateWithoutPracticeInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskCreateOrConnectWithoutTaskInput = {
    create: DeploymentOrgTaskCreateWithoutTaskInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskCreateWithoutBlockedByInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockerOrgTaskInput>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutDeploymentOrgTaskInput;
    orgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedOneWithoutOrgTasksInput>;
    practice?: InputMaybe<PracticeCreateNestedOneWithoutDeploymentOrgTasksInput>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    task?: InputMaybe<DeploymentTaskCreateNestedOneWithoutOrgTasksInput>;
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateWithoutBlocksInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockedOrgTaskInput>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutDeploymentOrgTaskInput;
    orgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedOneWithoutOrgTasksInput>;
    practice?: InputMaybe<PracticeCreateNestedOneWithoutDeploymentOrgTasksInput>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    task?: InputMaybe<DeploymentTaskCreateNestedOneWithoutOrgTasksInput>;
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateWithoutOrgInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockedOrgTaskInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockerOrgTaskInput>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedOneWithoutOrgTasksInput>;
    practice?: InputMaybe<PracticeCreateNestedOneWithoutDeploymentOrgTasksInput>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    task?: InputMaybe<DeploymentTaskCreateNestedOneWithoutOrgTasksInput>;
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateWithoutOrgPhaseInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockedOrgTaskInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockerOrgTaskInput>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutDeploymentOrgTaskInput;
    practice?: InputMaybe<PracticeCreateNestedOneWithoutDeploymentOrgTasksInput>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    task?: InputMaybe<DeploymentTaskCreateNestedOneWithoutOrgTasksInput>;
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateWithoutPracticeInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockedOrgTaskInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockerOrgTaskInput>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutDeploymentOrgTaskInput;
    orgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedOneWithoutOrgTasksInput>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    task?: InputMaybe<DeploymentTaskCreateNestedOneWithoutOrgTasksInput>;
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskCreateWithoutTaskInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockedOrgTaskInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockerOrgTaskInput>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    completedByUser?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutDeploymentOrgTaskInput;
    orgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedOneWithoutOrgTasksInput>;
    practice?: InputMaybe<PracticeCreateNestedOneWithoutDeploymentOrgTasksInput>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationDetail?: InputMaybe<Scalars['String']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    verificationStatus?: InputMaybe<VerificationStatus>;
    verifiedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentOrgTaskDependency = {
    __typename?: 'DeploymentOrgTaskDependency';
    blockedOrgTask: DeploymentOrgTask;
    blockedOrgTaskId: Scalars['Int']['output'];
    blockerOrgTask: DeploymentOrgTask;
    blockerOrgTaskId: Scalars['Int']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DeploymentOrgTaskDependencyAvgAggregate = {
    __typename?: 'DeploymentOrgTaskDependencyAvgAggregate';
    blockedOrgTaskId?: Maybe<Scalars['Float']['output']>;
    blockerOrgTaskId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type DeploymentOrgTaskDependencyAvgOrderByAggregateInput = {
    blockedOrgTaskId?: InputMaybe<SortOrder>;
    blockerOrgTaskId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskDependencyBlockedOrgTaskIdBlockerOrgTaskIdCompoundUniqueInput =
    {
        blockedOrgTaskId: Scalars['Int']['input'];
        blockerOrgTaskId: Scalars['Int']['input'];
    };

export type DeploymentOrgTaskDependencyCountAggregate = {
    __typename?: 'DeploymentOrgTaskDependencyCountAggregate';
    _all: Scalars['Int']['output'];
    blockedOrgTaskId: Scalars['Int']['output'];
    blockerOrgTaskId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type DeploymentOrgTaskDependencyCountOrderByAggregateInput = {
    blockedOrgTaskId?: InputMaybe<SortOrder>;
    blockerOrgTaskId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskDependencyCreateInput = {
    blockedOrgTask: DeploymentOrgTaskCreateNestedOneWithoutBlockedByInput;
    blockerOrgTask: DeploymentOrgTaskCreateNestedOneWithoutBlocksInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgTaskDependencyCreateManyBlockedOrgTaskInput = {
    blockerOrgTaskId: Scalars['Int']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgTaskDependencyCreateManyBlockedOrgTaskInputEnvelope = {
    data: Array<DeploymentOrgTaskDependencyCreateManyBlockedOrgTaskInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentOrgTaskDependencyCreateManyBlockerOrgTaskInput = {
    blockedOrgTaskId: Scalars['Int']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgTaskDependencyCreateManyBlockerOrgTaskInputEnvelope = {
    data: Array<DeploymentOrgTaskDependencyCreateManyBlockerOrgTaskInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentOrgTaskDependencyCreateManyInput = {
    blockedOrgTaskId: Scalars['Int']['input'];
    blockerOrgTaskId: Scalars['Int']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockedOrgTaskInput =
    {
        connect?: InputMaybe<
            Array<DeploymentOrgTaskDependencyWhereUniqueInput>
        >;
        connectOrCreate?: InputMaybe<
            Array<DeploymentOrgTaskDependencyCreateOrConnectWithoutBlockedOrgTaskInput>
        >;
        create?: InputMaybe<
            Array<DeploymentOrgTaskDependencyCreateWithoutBlockedOrgTaskInput>
        >;
        createMany?: InputMaybe<DeploymentOrgTaskDependencyCreateManyBlockedOrgTaskInputEnvelope>;
    };

export type DeploymentOrgTaskDependencyCreateNestedManyWithoutBlockerOrgTaskInput =
    {
        connect?: InputMaybe<
            Array<DeploymentOrgTaskDependencyWhereUniqueInput>
        >;
        connectOrCreate?: InputMaybe<
            Array<DeploymentOrgTaskDependencyCreateOrConnectWithoutBlockerOrgTaskInput>
        >;
        create?: InputMaybe<
            Array<DeploymentOrgTaskDependencyCreateWithoutBlockerOrgTaskInput>
        >;
        createMany?: InputMaybe<DeploymentOrgTaskDependencyCreateManyBlockerOrgTaskInputEnvelope>;
    };

export type DeploymentOrgTaskDependencyCreateOrConnectWithoutBlockedOrgTaskInput =
    {
        create: DeploymentOrgTaskDependencyCreateWithoutBlockedOrgTaskInput;
        where: DeploymentOrgTaskDependencyWhereUniqueInput;
    };

export type DeploymentOrgTaskDependencyCreateOrConnectWithoutBlockerOrgTaskInput =
    {
        create: DeploymentOrgTaskDependencyCreateWithoutBlockerOrgTaskInput;
        where: DeploymentOrgTaskDependencyWhereUniqueInput;
    };

export type DeploymentOrgTaskDependencyCreateWithoutBlockedOrgTaskInput = {
    blockerOrgTask: DeploymentOrgTaskCreateNestedOneWithoutBlocksInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgTaskDependencyCreateWithoutBlockerOrgTaskInput = {
    blockedOrgTask: DeploymentOrgTaskCreateNestedOneWithoutBlockedByInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentOrgTaskDependencyGroupBy = {
    __typename?: 'DeploymentOrgTaskDependencyGroupBy';
    _avg?: Maybe<DeploymentOrgTaskDependencyAvgAggregate>;
    _count?: Maybe<DeploymentOrgTaskDependencyCountAggregate>;
    _max?: Maybe<DeploymentOrgTaskDependencyMaxAggregate>;
    _min?: Maybe<DeploymentOrgTaskDependencyMinAggregate>;
    _sum?: Maybe<DeploymentOrgTaskDependencySumAggregate>;
    blockedOrgTaskId: Scalars['Int']['output'];
    blockerOrgTaskId: Scalars['Int']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DeploymentOrgTaskDependencyListRelationFilter = {
    every?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
    none?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
    some?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type DeploymentOrgTaskDependencyMaxAggregate = {
    __typename?: 'DeploymentOrgTaskDependencyMaxAggregate';
    blockedOrgTaskId?: Maybe<Scalars['Int']['output']>;
    blockerOrgTaskId?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DeploymentOrgTaskDependencyMaxOrderByAggregateInput = {
    blockedOrgTaskId?: InputMaybe<SortOrder>;
    blockerOrgTaskId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskDependencyMinAggregate = {
    __typename?: 'DeploymentOrgTaskDependencyMinAggregate';
    blockedOrgTaskId?: Maybe<Scalars['Int']['output']>;
    blockerOrgTaskId?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DeploymentOrgTaskDependencyMinOrderByAggregateInput = {
    blockedOrgTaskId?: InputMaybe<SortOrder>;
    blockerOrgTaskId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskDependencyOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskDependencyOrderByWithAggregationInput = {
    _avg?: InputMaybe<DeploymentOrgTaskDependencyAvgOrderByAggregateInput>;
    _count?: InputMaybe<DeploymentOrgTaskDependencyCountOrderByAggregateInput>;
    _max?: InputMaybe<DeploymentOrgTaskDependencyMaxOrderByAggregateInput>;
    _min?: InputMaybe<DeploymentOrgTaskDependencyMinOrderByAggregateInput>;
    _sum?: InputMaybe<DeploymentOrgTaskDependencySumOrderByAggregateInput>;
    blockedOrgTaskId?: InputMaybe<SortOrder>;
    blockerOrgTaskId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskDependencyOrderByWithRelationInput = {
    blockedOrgTask?: InputMaybe<DeploymentOrgTaskOrderByWithRelationInput>;
    blockedOrgTaskId?: InputMaybe<SortOrder>;
    blockerOrgTask?: InputMaybe<DeploymentOrgTaskOrderByWithRelationInput>;
    blockerOrgTaskId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum DeploymentOrgTaskDependencyScalarFieldEnum {
    BlockedOrgTaskId = 'blockedOrgTaskId',
    BlockerOrgTaskId = 'blockerOrgTaskId',
    CreatedAt = 'createdAt',
    Id = 'id',
    UpdatedAt = 'updatedAt',
}

export type DeploymentOrgTaskDependencyScalarWhereInput = {
    AND?: InputMaybe<Array<DeploymentOrgTaskDependencyScalarWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgTaskDependencyScalarWhereInput>>;
    OR?: InputMaybe<Array<DeploymentOrgTaskDependencyScalarWhereInput>>;
    blockedOrgTaskId?: InputMaybe<IntFilter>;
    blockerOrgTaskId?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentOrgTaskDependencyScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<DeploymentOrgTaskDependencyScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<DeploymentOrgTaskDependencyScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<DeploymentOrgTaskDependencyScalarWhereWithAggregatesInput>
    >;
    blockedOrgTaskId?: InputMaybe<IntWithAggregatesFilter>;
    blockerOrgTaskId?: InputMaybe<IntWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DeploymentOrgTaskDependencySumAggregate = {
    __typename?: 'DeploymentOrgTaskDependencySumAggregate';
    blockedOrgTaskId?: Maybe<Scalars['Int']['output']>;
    blockerOrgTaskId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type DeploymentOrgTaskDependencySumOrderByAggregateInput = {
    blockedOrgTaskId?: InputMaybe<SortOrder>;
    blockerOrgTaskId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskDependencyUpdateInput = {
    blockedOrgTask?: InputMaybe<DeploymentOrgTaskUpdateOneRequiredWithoutBlockedByNestedInput>;
    blockerOrgTask?: InputMaybe<DeploymentOrgTaskUpdateOneRequiredWithoutBlocksNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskDependencyUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskDependencyUpdateManyWithWhereWithoutBlockedOrgTaskInput =
    {
        data: DeploymentOrgTaskDependencyUpdateManyMutationInput;
        where: DeploymentOrgTaskDependencyScalarWhereInput;
    };

export type DeploymentOrgTaskDependencyUpdateManyWithWhereWithoutBlockerOrgTaskInput =
    {
        data: DeploymentOrgTaskDependencyUpdateManyMutationInput;
        where: DeploymentOrgTaskDependencyScalarWhereInput;
    };

export type DeploymentOrgTaskDependencyUpdateManyWithoutBlockedOrgTaskNestedInput =
    {
        connect?: InputMaybe<
            Array<DeploymentOrgTaskDependencyWhereUniqueInput>
        >;
        connectOrCreate?: InputMaybe<
            Array<DeploymentOrgTaskDependencyCreateOrConnectWithoutBlockedOrgTaskInput>
        >;
        create?: InputMaybe<
            Array<DeploymentOrgTaskDependencyCreateWithoutBlockedOrgTaskInput>
        >;
        createMany?: InputMaybe<DeploymentOrgTaskDependencyCreateManyBlockedOrgTaskInputEnvelope>;
        delete?: InputMaybe<Array<DeploymentOrgTaskDependencyWhereUniqueInput>>;
        deleteMany?: InputMaybe<
            Array<DeploymentOrgTaskDependencyScalarWhereInput>
        >;
        disconnect?: InputMaybe<
            Array<DeploymentOrgTaskDependencyWhereUniqueInput>
        >;
        set?: InputMaybe<Array<DeploymentOrgTaskDependencyWhereUniqueInput>>;
        update?: InputMaybe<
            Array<DeploymentOrgTaskDependencyUpdateWithWhereUniqueWithoutBlockedOrgTaskInput>
        >;
        updateMany?: InputMaybe<
            Array<DeploymentOrgTaskDependencyUpdateManyWithWhereWithoutBlockedOrgTaskInput>
        >;
        upsert?: InputMaybe<
            Array<DeploymentOrgTaskDependencyUpsertWithWhereUniqueWithoutBlockedOrgTaskInput>
        >;
    };

export type DeploymentOrgTaskDependencyUpdateManyWithoutBlockerOrgTaskNestedInput =
    {
        connect?: InputMaybe<
            Array<DeploymentOrgTaskDependencyWhereUniqueInput>
        >;
        connectOrCreate?: InputMaybe<
            Array<DeploymentOrgTaskDependencyCreateOrConnectWithoutBlockerOrgTaskInput>
        >;
        create?: InputMaybe<
            Array<DeploymentOrgTaskDependencyCreateWithoutBlockerOrgTaskInput>
        >;
        createMany?: InputMaybe<DeploymentOrgTaskDependencyCreateManyBlockerOrgTaskInputEnvelope>;
        delete?: InputMaybe<Array<DeploymentOrgTaskDependencyWhereUniqueInput>>;
        deleteMany?: InputMaybe<
            Array<DeploymentOrgTaskDependencyScalarWhereInput>
        >;
        disconnect?: InputMaybe<
            Array<DeploymentOrgTaskDependencyWhereUniqueInput>
        >;
        set?: InputMaybe<Array<DeploymentOrgTaskDependencyWhereUniqueInput>>;
        update?: InputMaybe<
            Array<DeploymentOrgTaskDependencyUpdateWithWhereUniqueWithoutBlockerOrgTaskInput>
        >;
        updateMany?: InputMaybe<
            Array<DeploymentOrgTaskDependencyUpdateManyWithWhereWithoutBlockerOrgTaskInput>
        >;
        upsert?: InputMaybe<
            Array<DeploymentOrgTaskDependencyUpsertWithWhereUniqueWithoutBlockerOrgTaskInput>
        >;
    };

export type DeploymentOrgTaskDependencyUpdateWithWhereUniqueWithoutBlockedOrgTaskInput =
    {
        data: DeploymentOrgTaskDependencyUpdateWithoutBlockedOrgTaskInput;
        where: DeploymentOrgTaskDependencyWhereUniqueInput;
    };

export type DeploymentOrgTaskDependencyUpdateWithWhereUniqueWithoutBlockerOrgTaskInput =
    {
        data: DeploymentOrgTaskDependencyUpdateWithoutBlockerOrgTaskInput;
        where: DeploymentOrgTaskDependencyWhereUniqueInput;
    };

export type DeploymentOrgTaskDependencyUpdateWithoutBlockedOrgTaskInput = {
    blockerOrgTask?: InputMaybe<DeploymentOrgTaskUpdateOneRequiredWithoutBlocksNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskDependencyUpdateWithoutBlockerOrgTaskInput = {
    blockedOrgTask?: InputMaybe<DeploymentOrgTaskUpdateOneRequiredWithoutBlockedByNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskDependencyUpsertWithWhereUniqueWithoutBlockedOrgTaskInput =
    {
        create: DeploymentOrgTaskDependencyCreateWithoutBlockedOrgTaskInput;
        update: DeploymentOrgTaskDependencyUpdateWithoutBlockedOrgTaskInput;
        where: DeploymentOrgTaskDependencyWhereUniqueInput;
    };

export type DeploymentOrgTaskDependencyUpsertWithWhereUniqueWithoutBlockerOrgTaskInput =
    {
        create: DeploymentOrgTaskDependencyCreateWithoutBlockerOrgTaskInput;
        update: DeploymentOrgTaskDependencyUpdateWithoutBlockerOrgTaskInput;
        where: DeploymentOrgTaskDependencyWhereUniqueInput;
    };

export type DeploymentOrgTaskDependencyWhereInput = {
    AND?: InputMaybe<Array<DeploymentOrgTaskDependencyWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgTaskDependencyWhereInput>>;
    OR?: InputMaybe<Array<DeploymentOrgTaskDependencyWhereInput>>;
    blockedOrgTask?: InputMaybe<DeploymentOrgTaskRelationFilter>;
    blockedOrgTaskId?: InputMaybe<IntFilter>;
    blockerOrgTask?: InputMaybe<DeploymentOrgTaskRelationFilter>;
    blockerOrgTaskId?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentOrgTaskDependencyWhereUniqueInput = {
    AND?: InputMaybe<Array<DeploymentOrgTaskDependencyWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgTaskDependencyWhereInput>>;
    OR?: InputMaybe<Array<DeploymentOrgTaskDependencyWhereInput>>;
    blockedOrgTask?: InputMaybe<DeploymentOrgTaskRelationFilter>;
    blockedOrgTaskId?: InputMaybe<IntFilter>;
    blockedOrgTaskId_blockerOrgTaskId?: InputMaybe<DeploymentOrgTaskDependencyBlockedOrgTaskIdBlockerOrgTaskIdCompoundUniqueInput>;
    blockerOrgTask?: InputMaybe<DeploymentOrgTaskRelationFilter>;
    blockerOrgTaskId?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentOrgTaskGroupBy = {
    __typename?: 'DeploymentOrgTaskGroupBy';
    _avg?: Maybe<DeploymentOrgTaskAvgAggregate>;
    _count?: Maybe<DeploymentOrgTaskCountAggregate>;
    _max?: Maybe<DeploymentOrgTaskMaxAggregate>;
    _min?: Maybe<DeploymentOrgTaskMinAggregate>;
    _sum?: Maybe<DeploymentOrgTaskSumAggregate>;
    actionTargetKey?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<Scalars['String']['output']>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    completedByUser?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    dataDriven: Scalars['Boolean']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    orgPhaseId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    propagationType: PropagationType;
    requiredBeforeGoLive: Scalars['Boolean']['output'];
    sortOrder: Scalars['Int']['output'];
    taskId?: Maybe<Scalars['Int']['output']>;
    teamId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    verificationDetail?: Maybe<Scalars['String']['output']>;
    verificationKey?: Maybe<Scalars['String']['output']>;
    verificationSource?: Maybe<VerificationSource>;
    verificationStatus: VerificationStatus;
    verifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    visibility: TaskVisibility;
};

export type DeploymentOrgTaskListRelationFilter = {
    every?: InputMaybe<DeploymentOrgTaskWhereInput>;
    none?: InputMaybe<DeploymentOrgTaskWhereInput>;
    some?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type DeploymentOrgTaskMaxAggregate = {
    __typename?: 'DeploymentOrgTaskMaxAggregate';
    actionTargetKey?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<Scalars['String']['output']>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    completedByUser?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dataDriven?: Maybe<Scalars['Boolean']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    orgPhaseId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    propagationType?: Maybe<PropagationType>;
    requiredBeforeGoLive?: Maybe<Scalars['Boolean']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    taskId?: Maybe<Scalars['Int']['output']>;
    teamId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    verificationDetail?: Maybe<Scalars['String']['output']>;
    verificationKey?: Maybe<Scalars['String']['output']>;
    verificationSource?: Maybe<VerificationSource>;
    verificationStatus?: Maybe<VerificationStatus>;
    verifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    visibility?: Maybe<TaskVisibility>;
};

export type DeploymentOrgTaskMaxOrderByAggregateInput = {
    actionTargetKey?: InputMaybe<SortOrder>;
    assignee?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrder>;
    completedByUser?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dataDriven?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    orgPhaseId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    requiredBeforeGoLive?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    taskId?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    verificationDetail?: InputMaybe<SortOrder>;
    verificationKey?: InputMaybe<SortOrder>;
    verificationSource?: InputMaybe<SortOrder>;
    verificationStatus?: InputMaybe<SortOrder>;
    verifiedAt?: InputMaybe<SortOrder>;
    visibility?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskMinAggregate = {
    __typename?: 'DeploymentOrgTaskMinAggregate';
    actionTargetKey?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<Scalars['String']['output']>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    completedByUser?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dataDriven?: Maybe<Scalars['Boolean']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    orgPhaseId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    propagationType?: Maybe<PropagationType>;
    requiredBeforeGoLive?: Maybe<Scalars['Boolean']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    taskId?: Maybe<Scalars['Int']['output']>;
    teamId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    verificationDetail?: Maybe<Scalars['String']['output']>;
    verificationKey?: Maybe<Scalars['String']['output']>;
    verificationSource?: Maybe<VerificationSource>;
    verificationStatus?: Maybe<VerificationStatus>;
    verifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    visibility?: Maybe<TaskVisibility>;
};

export type DeploymentOrgTaskMinOrderByAggregateInput = {
    actionTargetKey?: InputMaybe<SortOrder>;
    assignee?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrder>;
    completedByUser?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dataDriven?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    orgPhaseId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    requiredBeforeGoLive?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    taskId?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    verificationDetail?: InputMaybe<SortOrder>;
    verificationKey?: InputMaybe<SortOrder>;
    verificationSource?: InputMaybe<SortOrder>;
    verificationStatus?: InputMaybe<SortOrder>;
    verifiedAt?: InputMaybe<SortOrder>;
    visibility?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskOrderByWithAggregationInput = {
    _avg?: InputMaybe<DeploymentOrgTaskAvgOrderByAggregateInput>;
    _count?: InputMaybe<DeploymentOrgTaskCountOrderByAggregateInput>;
    _max?: InputMaybe<DeploymentOrgTaskMaxOrderByAggregateInput>;
    _min?: InputMaybe<DeploymentOrgTaskMinOrderByAggregateInput>;
    _sum?: InputMaybe<DeploymentOrgTaskSumOrderByAggregateInput>;
    actionTargetKey?: InputMaybe<SortOrderInput>;
    assignee?: InputMaybe<SortOrderInput>;
    completedAt?: InputMaybe<SortOrderInput>;
    completedByUser?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    dataDriven?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    orgPhaseId?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrderInput>;
    propagationType?: InputMaybe<SortOrder>;
    requiredBeforeGoLive?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    taskId?: InputMaybe<SortOrderInput>;
    teamId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    verificationDetail?: InputMaybe<SortOrderInput>;
    verificationKey?: InputMaybe<SortOrderInput>;
    verificationSource?: InputMaybe<SortOrderInput>;
    verificationStatus?: InputMaybe<SortOrder>;
    verifiedAt?: InputMaybe<SortOrderInput>;
    visibility?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskOrderByWithRelationInput = {
    actionTargetKey?: InputMaybe<SortOrderInput>;
    assignee?: InputMaybe<SortOrderInput>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyOrderByRelationAggregateInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyOrderByRelationAggregateInput>;
    completedAt?: InputMaybe<SortOrderInput>;
    completedByUser?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    dataDriven?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    orgPhase?: InputMaybe<DeploymentOrgPhaseOrderByWithRelationInput>;
    orgPhaseId?: InputMaybe<SortOrderInput>;
    practice?: InputMaybe<PracticeOrderByWithRelationInput>;
    practiceId?: InputMaybe<SortOrderInput>;
    propagationType?: InputMaybe<SortOrder>;
    requiredBeforeGoLive?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    task?: InputMaybe<DeploymentTaskOrderByWithRelationInput>;
    taskId?: InputMaybe<SortOrderInput>;
    teamId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    verificationDetail?: InputMaybe<SortOrderInput>;
    verificationKey?: InputMaybe<SortOrderInput>;
    verificationSource?: InputMaybe<SortOrderInput>;
    verificationStatus?: InputMaybe<SortOrder>;
    verifiedAt?: InputMaybe<SortOrderInput>;
    visibility?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskOrgIdTaskIdCompoundUniqueInput = {
    orgId: Scalars['Int']['input'];
    taskId: Scalars['Int']['input'];
};

export type DeploymentOrgTaskOrgPhaseIdSortOrderCompoundUniqueInput = {
    orgPhaseId: Scalars['Int']['input'];
    sortOrder: Scalars['Int']['input'];
};

export type DeploymentOrgTaskRelationFilter = {
    is?: InputMaybe<DeploymentOrgTaskWhereInput>;
    isNot?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export enum DeploymentOrgTaskScalarFieldEnum {
    ActionTargetKey = 'actionTargetKey',
    Assignee = 'assignee',
    CompletedAt = 'completedAt',
    CompletedByUser = 'completedByUser',
    CreatedAt = 'createdAt',
    DataDriven = 'dataDriven',
    DeletedAt = 'deletedAt',
    Id = 'id',
    IsActive = 'isActive',
    Name = 'name',
    Notes = 'notes',
    OrgId = 'orgId',
    OrgPhaseId = 'orgPhaseId',
    PracticeId = 'practiceId',
    PropagationType = 'propagationType',
    RequiredBeforeGoLive = 'requiredBeforeGoLive',
    SortOrder = 'sortOrder',
    TaskId = 'taskId',
    TeamId = 'teamId',
    UpdatedAt = 'updatedAt',
    VerificationDetail = 'verificationDetail',
    VerificationKey = 'verificationKey',
    VerificationSource = 'verificationSource',
    VerificationStatus = 'verificationStatus',
    VerifiedAt = 'verifiedAt',
    Visibility = 'visibility',
}

export type DeploymentOrgTaskScalarWhereInput = {
    AND?: InputMaybe<Array<DeploymentOrgTaskScalarWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgTaskScalarWhereInput>>;
    OR?: InputMaybe<Array<DeploymentOrgTaskScalarWhereInput>>;
    actionTargetKey?: InputMaybe<StringNullableFilter>;
    assignee?: InputMaybe<StringNullableFilter>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    completedByUser?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dataDriven?: InputMaybe<BoolFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgPhaseId?: InputMaybe<IntNullableFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeFilter>;
    requiredBeforeGoLive?: InputMaybe<BoolFilter>;
    sortOrder?: InputMaybe<IntFilter>;
    taskId?: InputMaybe<IntNullableFilter>;
    teamId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    verificationDetail?: InputMaybe<StringNullableFilter>;
    verificationKey?: InputMaybe<StringNullableFilter>;
    verificationSource?: InputMaybe<EnumVerificationSourceNullableFilter>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFilter>;
    verifiedAt?: InputMaybe<DateTimeNullableFilter>;
    visibility?: InputMaybe<EnumTaskVisibilityFilter>;
};

export type DeploymentOrgTaskScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<DeploymentOrgTaskScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgTaskScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<DeploymentOrgTaskScalarWhereWithAggregatesInput>>;
    actionTargetKey?: InputMaybe<StringNullableWithAggregatesFilter>;
    assignee?: InputMaybe<StringNullableWithAggregatesFilter>;
    completedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    completedByUser?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    dataDriven?: InputMaybe<BoolWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    orgPhaseId?: InputMaybe<IntNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntNullableWithAggregatesFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeWithAggregatesFilter>;
    requiredBeforeGoLive?: InputMaybe<BoolWithAggregatesFilter>;
    sortOrder?: InputMaybe<IntWithAggregatesFilter>;
    taskId?: InputMaybe<IntNullableWithAggregatesFilter>;
    teamId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    verificationDetail?: InputMaybe<StringNullableWithAggregatesFilter>;
    verificationKey?: InputMaybe<StringNullableWithAggregatesFilter>;
    verificationSource?: InputMaybe<EnumVerificationSourceNullableWithAggregatesFilter>;
    verificationStatus?: InputMaybe<EnumVerificationStatusWithAggregatesFilter>;
    verifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    visibility?: InputMaybe<EnumTaskVisibilityWithAggregatesFilter>;
};

export type DeploymentOrgTaskSumAggregate = {
    __typename?: 'DeploymentOrgTaskSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    orgPhaseId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    taskId?: Maybe<Scalars['Int']['output']>;
    teamId?: Maybe<Scalars['Int']['output']>;
};

export type DeploymentOrgTaskSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    orgPhaseId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    taskId?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
};

export type DeploymentOrgTaskUpdateInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockedOrgTaskNestedInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockerOrgTaskNestedInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    completedByUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDeploymentOrgTaskNestedInput>;
    orgPhase?: InputMaybe<DeploymentOrgPhaseUpdateOneWithoutOrgTasksNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneWithoutDeploymentOrgTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    task?: InputMaybe<DeploymentTaskUpdateOneWithoutOrgTasksNestedInput>;
    teamId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFieldUpdateOperationsInput>;
    verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskUpdateManyMutationInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    completedByUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    teamId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFieldUpdateOperationsInput>;
    verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskUpdateManyWithWhereWithoutOrgInput = {
    data: DeploymentOrgTaskUpdateManyMutationInput;
    where: DeploymentOrgTaskScalarWhereInput;
};

export type DeploymentOrgTaskUpdateManyWithWhereWithoutOrgPhaseInput = {
    data: DeploymentOrgTaskUpdateManyMutationInput;
    where: DeploymentOrgTaskScalarWhereInput;
};

export type DeploymentOrgTaskUpdateManyWithWhereWithoutPracticeInput = {
    data: DeploymentOrgTaskUpdateManyMutationInput;
    where: DeploymentOrgTaskScalarWhereInput;
};

export type DeploymentOrgTaskUpdateManyWithWhereWithoutTaskInput = {
    data: DeploymentOrgTaskUpdateManyMutationInput;
    where: DeploymentOrgTaskScalarWhereInput;
};

export type DeploymentOrgTaskUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgTaskCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgTaskCreateWithoutOrgInput>>;
    createMany?: InputMaybe<DeploymentOrgTaskCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeploymentOrgTaskScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    set?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DeploymentOrgTaskUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<DeploymentOrgTaskUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<DeploymentOrgTaskUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type DeploymentOrgTaskUpdateManyWithoutOrgPhaseNestedInput = {
    connect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgTaskCreateOrConnectWithoutOrgPhaseInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgTaskCreateWithoutOrgPhaseInput>>;
    createMany?: InputMaybe<DeploymentOrgTaskCreateManyOrgPhaseInputEnvelope>;
    delete?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeploymentOrgTaskScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    set?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DeploymentOrgTaskUpdateWithWhereUniqueWithoutOrgPhaseInput>
    >;
    updateMany?: InputMaybe<
        Array<DeploymentOrgTaskUpdateManyWithWhereWithoutOrgPhaseInput>
    >;
    upsert?: InputMaybe<
        Array<DeploymentOrgTaskUpsertWithWhereUniqueWithoutOrgPhaseInput>
    >;
};

export type DeploymentOrgTaskUpdateManyWithoutPracticeNestedInput = {
    connect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgTaskCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgTaskCreateWithoutPracticeInput>>;
    createMany?: InputMaybe<DeploymentOrgTaskCreateManyPracticeInputEnvelope>;
    delete?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeploymentOrgTaskScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    set?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DeploymentOrgTaskUpdateWithWhereUniqueWithoutPracticeInput>
    >;
    updateMany?: InputMaybe<
        Array<DeploymentOrgTaskUpdateManyWithWhereWithoutPracticeInput>
    >;
    upsert?: InputMaybe<
        Array<DeploymentOrgTaskUpsertWithWhereUniqueWithoutPracticeInput>
    >;
};

export type DeploymentOrgTaskUpdateManyWithoutTaskNestedInput = {
    connect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentOrgTaskCreateOrConnectWithoutTaskInput>
    >;
    create?: InputMaybe<Array<DeploymentOrgTaskCreateWithoutTaskInput>>;
    createMany?: InputMaybe<DeploymentOrgTaskCreateManyTaskInputEnvelope>;
    delete?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeploymentOrgTaskScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    set?: InputMaybe<Array<DeploymentOrgTaskWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DeploymentOrgTaskUpdateWithWhereUniqueWithoutTaskInput>
    >;
    updateMany?: InputMaybe<
        Array<DeploymentOrgTaskUpdateManyWithWhereWithoutTaskInput>
    >;
    upsert?: InputMaybe<
        Array<DeploymentOrgTaskUpsertWithWhereUniqueWithoutTaskInput>
    >;
};

export type DeploymentOrgTaskUpdateOneRequiredWithoutBlockedByNestedInput = {
    connect?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentOrgTaskCreateOrConnectWithoutBlockedByInput>;
    create?: InputMaybe<DeploymentOrgTaskCreateWithoutBlockedByInput>;
    update?: InputMaybe<DeploymentOrgTaskUpdateToOneWithWhereWithoutBlockedByInput>;
    upsert?: InputMaybe<DeploymentOrgTaskUpsertWithoutBlockedByInput>;
};

export type DeploymentOrgTaskUpdateOneRequiredWithoutBlocksNestedInput = {
    connect?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentOrgTaskCreateOrConnectWithoutBlocksInput>;
    create?: InputMaybe<DeploymentOrgTaskCreateWithoutBlocksInput>;
    update?: InputMaybe<DeploymentOrgTaskUpdateToOneWithWhereWithoutBlocksInput>;
    upsert?: InputMaybe<DeploymentOrgTaskUpsertWithoutBlocksInput>;
};

export type DeploymentOrgTaskUpdateToOneWithWhereWithoutBlockedByInput = {
    data: DeploymentOrgTaskUpdateWithoutBlockedByInput;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type DeploymentOrgTaskUpdateToOneWithWhereWithoutBlocksInput = {
    data: DeploymentOrgTaskUpdateWithoutBlocksInput;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type DeploymentOrgTaskUpdateWithWhereUniqueWithoutOrgInput = {
    data: DeploymentOrgTaskUpdateWithoutOrgInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskUpdateWithWhereUniqueWithoutOrgPhaseInput = {
    data: DeploymentOrgTaskUpdateWithoutOrgPhaseInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskUpdateWithWhereUniqueWithoutPracticeInput = {
    data: DeploymentOrgTaskUpdateWithoutPracticeInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskUpdateWithWhereUniqueWithoutTaskInput = {
    data: DeploymentOrgTaskUpdateWithoutTaskInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskUpdateWithoutBlockedByInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockerOrgTaskNestedInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    completedByUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDeploymentOrgTaskNestedInput>;
    orgPhase?: InputMaybe<DeploymentOrgPhaseUpdateOneWithoutOrgTasksNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneWithoutDeploymentOrgTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    task?: InputMaybe<DeploymentTaskUpdateOneWithoutOrgTasksNestedInput>;
    teamId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFieldUpdateOperationsInput>;
    verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskUpdateWithoutBlocksInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockedOrgTaskNestedInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    completedByUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDeploymentOrgTaskNestedInput>;
    orgPhase?: InputMaybe<DeploymentOrgPhaseUpdateOneWithoutOrgTasksNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneWithoutDeploymentOrgTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    task?: InputMaybe<DeploymentTaskUpdateOneWithoutOrgTasksNestedInput>;
    teamId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFieldUpdateOperationsInput>;
    verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskUpdateWithoutOrgInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockedOrgTaskNestedInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockerOrgTaskNestedInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    completedByUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgPhase?: InputMaybe<DeploymentOrgPhaseUpdateOneWithoutOrgTasksNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneWithoutDeploymentOrgTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    task?: InputMaybe<DeploymentTaskUpdateOneWithoutOrgTasksNestedInput>;
    teamId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFieldUpdateOperationsInput>;
    verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskUpdateWithoutOrgPhaseInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockedOrgTaskNestedInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockerOrgTaskNestedInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    completedByUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDeploymentOrgTaskNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneWithoutDeploymentOrgTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    task?: InputMaybe<DeploymentTaskUpdateOneWithoutOrgTasksNestedInput>;
    teamId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFieldUpdateOperationsInput>;
    verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskUpdateWithoutPracticeInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockedOrgTaskNestedInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockerOrgTaskNestedInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    completedByUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDeploymentOrgTaskNestedInput>;
    orgPhase?: InputMaybe<DeploymentOrgPhaseUpdateOneWithoutOrgTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    task?: InputMaybe<DeploymentTaskUpdateOneWithoutOrgTasksNestedInput>;
    teamId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFieldUpdateOperationsInput>;
    verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskUpdateWithoutTaskInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockedOrgTaskNestedInput>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyUpdateManyWithoutBlockerOrgTaskNestedInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    completedByUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutDeploymentOrgTaskNestedInput>;
    orgPhase?: InputMaybe<DeploymentOrgPhaseUpdateOneWithoutOrgTasksNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneWithoutDeploymentOrgTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    teamId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFieldUpdateOperationsInput>;
    verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentOrgTaskUpsertWithWhereUniqueWithoutOrgInput = {
    create: DeploymentOrgTaskCreateWithoutOrgInput;
    update: DeploymentOrgTaskUpdateWithoutOrgInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskUpsertWithWhereUniqueWithoutOrgPhaseInput = {
    create: DeploymentOrgTaskCreateWithoutOrgPhaseInput;
    update: DeploymentOrgTaskUpdateWithoutOrgPhaseInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskUpsertWithWhereUniqueWithoutPracticeInput = {
    create: DeploymentOrgTaskCreateWithoutPracticeInput;
    update: DeploymentOrgTaskUpdateWithoutPracticeInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskUpsertWithWhereUniqueWithoutTaskInput = {
    create: DeploymentOrgTaskCreateWithoutTaskInput;
    update: DeploymentOrgTaskUpdateWithoutTaskInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type DeploymentOrgTaskUpsertWithoutBlockedByInput = {
    create: DeploymentOrgTaskCreateWithoutBlockedByInput;
    update: DeploymentOrgTaskUpdateWithoutBlockedByInput;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type DeploymentOrgTaskUpsertWithoutBlocksInput = {
    create: DeploymentOrgTaskCreateWithoutBlocksInput;
    update: DeploymentOrgTaskUpdateWithoutBlocksInput;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type DeploymentOrgTaskWhereInput = {
    AND?: InputMaybe<Array<DeploymentOrgTaskWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgTaskWhereInput>>;
    OR?: InputMaybe<Array<DeploymentOrgTaskWhereInput>>;
    actionTargetKey?: InputMaybe<StringNullableFilter>;
    assignee?: InputMaybe<StringNullableFilter>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyListRelationFilter>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyListRelationFilter>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    completedByUser?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dataDriven?: InputMaybe<BoolFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgPhase?: InputMaybe<DeploymentOrgPhaseNullableRelationFilter>;
    orgPhaseId?: InputMaybe<IntNullableFilter>;
    practice?: InputMaybe<PracticeNullableRelationFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeFilter>;
    requiredBeforeGoLive?: InputMaybe<BoolFilter>;
    sortOrder?: InputMaybe<IntFilter>;
    task?: InputMaybe<DeploymentTaskNullableRelationFilter>;
    taskId?: InputMaybe<IntNullableFilter>;
    teamId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    verificationDetail?: InputMaybe<StringNullableFilter>;
    verificationKey?: InputMaybe<StringNullableFilter>;
    verificationSource?: InputMaybe<EnumVerificationSourceNullableFilter>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFilter>;
    verifiedAt?: InputMaybe<DateTimeNullableFilter>;
    visibility?: InputMaybe<EnumTaskVisibilityFilter>;
};

export type DeploymentOrgTaskWhereUniqueInput = {
    AND?: InputMaybe<Array<DeploymentOrgTaskWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentOrgTaskWhereInput>>;
    OR?: InputMaybe<Array<DeploymentOrgTaskWhereInput>>;
    actionTargetKey?: InputMaybe<StringNullableFilter>;
    assignee?: InputMaybe<StringNullableFilter>;
    blockedBy?: InputMaybe<DeploymentOrgTaskDependencyListRelationFilter>;
    blocks?: InputMaybe<DeploymentOrgTaskDependencyListRelationFilter>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    completedByUser?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dataDriven?: InputMaybe<BoolFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgId_taskId?: InputMaybe<DeploymentOrgTaskOrgIdTaskIdCompoundUniqueInput>;
    orgPhase?: InputMaybe<DeploymentOrgPhaseNullableRelationFilter>;
    orgPhaseId?: InputMaybe<IntNullableFilter>;
    orgPhaseId_sortOrder?: InputMaybe<DeploymentOrgTaskOrgPhaseIdSortOrderCompoundUniqueInput>;
    practice?: InputMaybe<PracticeNullableRelationFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeFilter>;
    requiredBeforeGoLive?: InputMaybe<BoolFilter>;
    sortOrder?: InputMaybe<IntFilter>;
    task?: InputMaybe<DeploymentTaskNullableRelationFilter>;
    taskId?: InputMaybe<IntNullableFilter>;
    teamId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    verificationDetail?: InputMaybe<StringNullableFilter>;
    verificationKey?: InputMaybe<StringNullableFilter>;
    verificationSource?: InputMaybe<EnumVerificationSourceNullableFilter>;
    verificationStatus?: InputMaybe<EnumVerificationStatusFilter>;
    verifiedAt?: InputMaybe<DateTimeNullableFilter>;
    visibility?: InputMaybe<EnumTaskVisibilityFilter>;
};

export type DeploymentPhase = {
    __typename?: 'DeploymentPhase';
    _count?: Maybe<DeploymentPhaseCount>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    isArchived: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    orgPhases: Array<DeploymentOrgPhase>;
    sortOrder: Scalars['Int']['output'];
    tasks: Array<DeploymentTask>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DeploymentPhaseOrgPhasesArgs = {
    cursor?: InputMaybe<DeploymentOrgPhaseWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgPhaseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgPhaseOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type DeploymentPhaseTasksArgs = {
    cursor?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentTaskOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentPhaseAvgAggregate = {
    __typename?: 'DeploymentPhaseAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    sortOrder?: Maybe<Scalars['Float']['output']>;
};

export type DeploymentPhaseAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
};

export type DeploymentPhaseCount = {
    __typename?: 'DeploymentPhaseCount';
    orgPhases: Scalars['Int']['output'];
    tasks: Scalars['Int']['output'];
};

export type DeploymentPhaseCountOrgPhasesArgs = {
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type DeploymentPhaseCountTasksArgs = {
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentPhaseCountAggregate = {
    __typename?: 'DeploymentPhaseCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isArchived: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    sortOrder: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type DeploymentPhaseCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArchived?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentPhaseCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    orgPhases?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutPhaseInput>;
    sortOrder: Scalars['Int']['input'];
    tasks?: InputMaybe<DeploymentTaskCreateNestedManyWithoutPhaseInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentPhaseCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    sortOrder: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentPhaseCreateNestedOneWithoutOrgPhasesInput = {
    connect?: InputMaybe<DeploymentPhaseWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentPhaseCreateOrConnectWithoutOrgPhasesInput>;
    create?: InputMaybe<DeploymentPhaseCreateWithoutOrgPhasesInput>;
};

export type DeploymentPhaseCreateNestedOneWithoutTasksInput = {
    connect?: InputMaybe<DeploymentPhaseWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentPhaseCreateOrConnectWithoutTasksInput>;
    create?: InputMaybe<DeploymentPhaseCreateWithoutTasksInput>;
};

export type DeploymentPhaseCreateOrConnectWithoutOrgPhasesInput = {
    create: DeploymentPhaseCreateWithoutOrgPhasesInput;
    where: DeploymentPhaseWhereUniqueInput;
};

export type DeploymentPhaseCreateOrConnectWithoutTasksInput = {
    create: DeploymentPhaseCreateWithoutTasksInput;
    where: DeploymentPhaseWhereUniqueInput;
};

export type DeploymentPhaseCreateWithoutOrgPhasesInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    sortOrder: Scalars['Int']['input'];
    tasks?: InputMaybe<DeploymentTaskCreateNestedManyWithoutPhaseInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentPhaseCreateWithoutTasksInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    orgPhases?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutPhaseInput>;
    sortOrder: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentPhaseGroupBy = {
    __typename?: 'DeploymentPhaseGroupBy';
    _avg?: Maybe<DeploymentPhaseAvgAggregate>;
    _count?: Maybe<DeploymentPhaseCountAggregate>;
    _max?: Maybe<DeploymentPhaseMaxAggregate>;
    _min?: Maybe<DeploymentPhaseMinAggregate>;
    _sum?: Maybe<DeploymentPhaseSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    isArchived: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    sortOrder: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DeploymentPhaseMaxAggregate = {
    __typename?: 'DeploymentPhaseMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isArchived?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DeploymentPhaseMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArchived?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentPhaseMinAggregate = {
    __typename?: 'DeploymentPhaseMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isArchived?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DeploymentPhaseMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArchived?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentPhaseNullableRelationFilter = {
    is?: InputMaybe<DeploymentPhaseWhereInput>;
    isNot?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type DeploymentPhaseOrderByWithAggregationInput = {
    _avg?: InputMaybe<DeploymentPhaseAvgOrderByAggregateInput>;
    _count?: InputMaybe<DeploymentPhaseCountOrderByAggregateInput>;
    _max?: InputMaybe<DeploymentPhaseMaxOrderByAggregateInput>;
    _min?: InputMaybe<DeploymentPhaseMinOrderByAggregateInput>;
    _sum?: InputMaybe<DeploymentPhaseSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isArchived?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentPhaseOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isArchived?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgPhases?: InputMaybe<DeploymentOrgPhaseOrderByRelationAggregateInput>;
    sortOrder?: InputMaybe<SortOrder>;
    tasks?: InputMaybe<DeploymentTaskOrderByRelationAggregateInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentPhaseRelationFilter = {
    is?: InputMaybe<DeploymentPhaseWhereInput>;
    isNot?: InputMaybe<DeploymentPhaseWhereInput>;
};

export enum DeploymentPhaseScalarFieldEnum {
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    Id = 'id',
    IsArchived = 'isArchived',
    Name = 'name',
    SortOrder = 'sortOrder',
    UpdatedAt = 'updatedAt',
}

export type DeploymentPhaseScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<DeploymentPhaseScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<DeploymentPhaseScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<DeploymentPhaseScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isArchived?: InputMaybe<BoolWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    sortOrder?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DeploymentPhaseSumAggregate = {
    __typename?: 'DeploymentPhaseSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type DeploymentPhaseSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
};

export type DeploymentPhaseUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgPhases?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutPhaseNestedInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    tasks?: InputMaybe<DeploymentTaskUpdateManyWithoutPhaseNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentPhaseUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentPhaseUpdateOneRequiredWithoutTasksNestedInput = {
    connect?: InputMaybe<DeploymentPhaseWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentPhaseCreateOrConnectWithoutTasksInput>;
    create?: InputMaybe<DeploymentPhaseCreateWithoutTasksInput>;
    update?: InputMaybe<DeploymentPhaseUpdateToOneWithWhereWithoutTasksInput>;
    upsert?: InputMaybe<DeploymentPhaseUpsertWithoutTasksInput>;
};

export type DeploymentPhaseUpdateOneWithoutOrgPhasesNestedInput = {
    connect?: InputMaybe<DeploymentPhaseWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentPhaseCreateOrConnectWithoutOrgPhasesInput>;
    create?: InputMaybe<DeploymentPhaseCreateWithoutOrgPhasesInput>;
    delete?: InputMaybe<DeploymentPhaseWhereInput>;
    disconnect?: InputMaybe<DeploymentPhaseWhereInput>;
    update?: InputMaybe<DeploymentPhaseUpdateToOneWithWhereWithoutOrgPhasesInput>;
    upsert?: InputMaybe<DeploymentPhaseUpsertWithoutOrgPhasesInput>;
};

export type DeploymentPhaseUpdateToOneWithWhereWithoutOrgPhasesInput = {
    data: DeploymentPhaseUpdateWithoutOrgPhasesInput;
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type DeploymentPhaseUpdateToOneWithWhereWithoutTasksInput = {
    data: DeploymentPhaseUpdateWithoutTasksInput;
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type DeploymentPhaseUpdateWithoutOrgPhasesInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    tasks?: InputMaybe<DeploymentTaskUpdateManyWithoutPhaseNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentPhaseUpdateWithoutTasksInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgPhases?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutPhaseNestedInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentPhaseUpsertWithoutOrgPhasesInput = {
    create: DeploymentPhaseCreateWithoutOrgPhasesInput;
    update: DeploymentPhaseUpdateWithoutOrgPhasesInput;
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type DeploymentPhaseUpsertWithoutTasksInput = {
    create: DeploymentPhaseCreateWithoutTasksInput;
    update: DeploymentPhaseUpdateWithoutTasksInput;
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type DeploymentPhaseWhereInput = {
    AND?: InputMaybe<Array<DeploymentPhaseWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentPhaseWhereInput>>;
    OR?: InputMaybe<Array<DeploymentPhaseWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    isArchived?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    orgPhases?: InputMaybe<DeploymentOrgPhaseListRelationFilter>;
    sortOrder?: InputMaybe<IntFilter>;
    tasks?: InputMaybe<DeploymentTaskListRelationFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentPhaseWhereUniqueInput = {
    AND?: InputMaybe<Array<DeploymentPhaseWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentPhaseWhereInput>>;
    OR?: InputMaybe<Array<DeploymentPhaseWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isArchived?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    orgPhases?: InputMaybe<DeploymentOrgPhaseListRelationFilter>;
    sortOrder?: InputMaybe<Scalars['Int']['input']>;
    tasks?: InputMaybe<DeploymentTaskListRelationFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentTask = {
    __typename?: 'DeploymentTask';
    _count?: Maybe<DeploymentTaskCount>;
    actionTargetKey?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<Scalars['String']['output']>;
    blockedBy: Array<DeploymentTaskDependency>;
    blocks: Array<DeploymentTaskDependency>;
    createdAt: Scalars['DateTimeISO']['output'];
    dataDriven: Scalars['Boolean']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    isArchived: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    orgTasks: Array<DeploymentOrgTask>;
    phase: DeploymentPhase;
    phaseId: Scalars['Int']['output'];
    propagationType: PropagationType;
    requiredBeforeGoLive: Scalars['Boolean']['output'];
    sortOrder: Scalars['Int']['output'];
    team: DeploymentTeam;
    teamId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    verificationKey?: Maybe<Scalars['String']['output']>;
    verificationSource?: Maybe<VerificationSource>;
    visibility: TaskVisibility;
};

export type DeploymentTaskBlockedByArgs = {
    cursor?: InputMaybe<DeploymentTaskDependencyWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTaskDependencyScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<DeploymentTaskDependencyOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type DeploymentTaskBlocksArgs = {
    cursor?: InputMaybe<DeploymentTaskDependencyWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTaskDependencyScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<DeploymentTaskDependencyOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type DeploymentTaskOrgTasksArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgTaskOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type DeploymentTaskAvgAggregate = {
    __typename?: 'DeploymentTaskAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    phaseId?: Maybe<Scalars['Float']['output']>;
    sortOrder?: Maybe<Scalars['Float']['output']>;
    teamId?: Maybe<Scalars['Float']['output']>;
};

export type DeploymentTaskAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
};

export type DeploymentTaskCount = {
    __typename?: 'DeploymentTaskCount';
    blockedBy: Scalars['Int']['output'];
    blocks: Scalars['Int']['output'];
    orgTasks: Scalars['Int']['output'];
};

export type DeploymentTaskCountBlockedByArgs = {
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type DeploymentTaskCountBlocksArgs = {
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type DeploymentTaskCountOrgTasksArgs = {
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type DeploymentTaskCountAggregate = {
    __typename?: 'DeploymentTaskCountAggregate';
    _all: Scalars['Int']['output'];
    actionTargetKey: Scalars['Int']['output'];
    assignee: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    dataDriven: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isArchived: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    phaseId: Scalars['Int']['output'];
    propagationType: Scalars['Int']['output'];
    requiredBeforeGoLive: Scalars['Int']['output'];
    sortOrder: Scalars['Int']['output'];
    teamId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    verificationKey: Scalars['Int']['output'];
    verificationSource: Scalars['Int']['output'];
    visibility: Scalars['Int']['output'];
};

export type DeploymentTaskCountOrderByAggregateInput = {
    actionTargetKey?: InputMaybe<SortOrder>;
    assignee?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dataDriven?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArchived?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    requiredBeforeGoLive?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    verificationKey?: InputMaybe<SortOrder>;
    verificationSource?: InputMaybe<SortOrder>;
    visibility?: InputMaybe<SortOrder>;
};

export type DeploymentTaskCreateInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyCreateNestedManyWithoutBlockedTaskInput>;
    blocks?: InputMaybe<DeploymentTaskDependencyCreateNestedManyWithoutBlockerTaskInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutTaskInput>;
    phase: DeploymentPhaseCreateNestedOneWithoutTasksInput;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    team: DeploymentTeamCreateNestedOneWithoutTasksInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentTaskCreateManyInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    phaseId: Scalars['Int']['input'];
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentTaskCreateManyPhaseInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    teamId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentTaskCreateManyPhaseInputEnvelope = {
    data: Array<DeploymentTaskCreateManyPhaseInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentTaskCreateManyTeamInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    phaseId: Scalars['Int']['input'];
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentTaskCreateManyTeamInputEnvelope = {
    data: Array<DeploymentTaskCreateManyTeamInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentTaskCreateNestedManyWithoutPhaseInput = {
    connect?: InputMaybe<Array<DeploymentTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentTaskCreateOrConnectWithoutPhaseInput>
    >;
    create?: InputMaybe<Array<DeploymentTaskCreateWithoutPhaseInput>>;
    createMany?: InputMaybe<DeploymentTaskCreateManyPhaseInputEnvelope>;
};

export type DeploymentTaskCreateNestedManyWithoutTeamInput = {
    connect?: InputMaybe<Array<DeploymentTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentTaskCreateOrConnectWithoutTeamInput>
    >;
    create?: InputMaybe<Array<DeploymentTaskCreateWithoutTeamInput>>;
    createMany?: InputMaybe<DeploymentTaskCreateManyTeamInputEnvelope>;
};

export type DeploymentTaskCreateNestedOneWithoutBlockedByInput = {
    connect?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentTaskCreateOrConnectWithoutBlockedByInput>;
    create?: InputMaybe<DeploymentTaskCreateWithoutBlockedByInput>;
};

export type DeploymentTaskCreateNestedOneWithoutBlocksInput = {
    connect?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentTaskCreateOrConnectWithoutBlocksInput>;
    create?: InputMaybe<DeploymentTaskCreateWithoutBlocksInput>;
};

export type DeploymentTaskCreateNestedOneWithoutOrgTasksInput = {
    connect?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentTaskCreateOrConnectWithoutOrgTasksInput>;
    create?: InputMaybe<DeploymentTaskCreateWithoutOrgTasksInput>;
};

export type DeploymentTaskCreateOrConnectWithoutBlockedByInput = {
    create: DeploymentTaskCreateWithoutBlockedByInput;
    where: DeploymentTaskWhereUniqueInput;
};

export type DeploymentTaskCreateOrConnectWithoutBlocksInput = {
    create: DeploymentTaskCreateWithoutBlocksInput;
    where: DeploymentTaskWhereUniqueInput;
};

export type DeploymentTaskCreateOrConnectWithoutOrgTasksInput = {
    create: DeploymentTaskCreateWithoutOrgTasksInput;
    where: DeploymentTaskWhereUniqueInput;
};

export type DeploymentTaskCreateOrConnectWithoutPhaseInput = {
    create: DeploymentTaskCreateWithoutPhaseInput;
    where: DeploymentTaskWhereUniqueInput;
};

export type DeploymentTaskCreateOrConnectWithoutTeamInput = {
    create: DeploymentTaskCreateWithoutTeamInput;
    where: DeploymentTaskWhereUniqueInput;
};

export type DeploymentTaskCreateWithoutBlockedByInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blocks?: InputMaybe<DeploymentTaskDependencyCreateNestedManyWithoutBlockerTaskInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutTaskInput>;
    phase: DeploymentPhaseCreateNestedOneWithoutTasksInput;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    team: DeploymentTeamCreateNestedOneWithoutTasksInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentTaskCreateWithoutBlocksInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyCreateNestedManyWithoutBlockedTaskInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutTaskInput>;
    phase: DeploymentPhaseCreateNestedOneWithoutTasksInput;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    team: DeploymentTeamCreateNestedOneWithoutTasksInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentTaskCreateWithoutOrgTasksInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyCreateNestedManyWithoutBlockedTaskInput>;
    blocks?: InputMaybe<DeploymentTaskDependencyCreateNestedManyWithoutBlockerTaskInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    phase: DeploymentPhaseCreateNestedOneWithoutTasksInput;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    team: DeploymentTeamCreateNestedOneWithoutTasksInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentTaskCreateWithoutPhaseInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyCreateNestedManyWithoutBlockedTaskInput>;
    blocks?: InputMaybe<DeploymentTaskDependencyCreateNestedManyWithoutBlockerTaskInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutTaskInput>;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    team: DeploymentTeamCreateNestedOneWithoutTasksInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentTaskCreateWithoutTeamInput = {
    actionTargetKey?: InputMaybe<Scalars['String']['input']>;
    assignee?: InputMaybe<Scalars['String']['input']>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyCreateNestedManyWithoutBlockedTaskInput>;
    blocks?: InputMaybe<DeploymentTaskDependencyCreateNestedManyWithoutBlockerTaskInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dataDriven?: InputMaybe<Scalars['Boolean']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    notes?: InputMaybe<Scalars['String']['input']>;
    orgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutTaskInput>;
    phase: DeploymentPhaseCreateNestedOneWithoutTasksInput;
    propagationType: PropagationType;
    requiredBeforeGoLive?: InputMaybe<Scalars['Boolean']['input']>;
    sortOrder: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    verificationKey?: InputMaybe<Scalars['String']['input']>;
    verificationSource?: InputMaybe<VerificationSource>;
    visibility?: InputMaybe<TaskVisibility>;
};

export type DeploymentTaskDependency = {
    __typename?: 'DeploymentTaskDependency';
    blockedTask: DeploymentTask;
    blockedTaskId: Scalars['Int']['output'];
    blockerTask: DeploymentTask;
    blockerTaskId: Scalars['Int']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DeploymentTaskDependencyAvgAggregate = {
    __typename?: 'DeploymentTaskDependencyAvgAggregate';
    blockedTaskId?: Maybe<Scalars['Float']['output']>;
    blockerTaskId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type DeploymentTaskDependencyAvgOrderByAggregateInput = {
    blockedTaskId?: InputMaybe<SortOrder>;
    blockerTaskId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type DeploymentTaskDependencyBlockedTaskIdBlockerTaskIdCompoundUniqueInput =
    {
        blockedTaskId: Scalars['Int']['input'];
        blockerTaskId: Scalars['Int']['input'];
    };

export type DeploymentTaskDependencyCountAggregate = {
    __typename?: 'DeploymentTaskDependencyCountAggregate';
    _all: Scalars['Int']['output'];
    blockedTaskId: Scalars['Int']['output'];
    blockerTaskId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type DeploymentTaskDependencyCountOrderByAggregateInput = {
    blockedTaskId?: InputMaybe<SortOrder>;
    blockerTaskId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentTaskDependencyCreateInput = {
    blockedTask: DeploymentTaskCreateNestedOneWithoutBlockedByInput;
    blockerTask: DeploymentTaskCreateNestedOneWithoutBlocksInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentTaskDependencyCreateManyBlockedTaskInput = {
    blockerTaskId: Scalars['Int']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentTaskDependencyCreateManyBlockedTaskInputEnvelope = {
    data: Array<DeploymentTaskDependencyCreateManyBlockedTaskInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentTaskDependencyCreateManyBlockerTaskInput = {
    blockedTaskId: Scalars['Int']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentTaskDependencyCreateManyBlockerTaskInputEnvelope = {
    data: Array<DeploymentTaskDependencyCreateManyBlockerTaskInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeploymentTaskDependencyCreateManyInput = {
    blockedTaskId: Scalars['Int']['input'];
    blockerTaskId: Scalars['Int']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentTaskDependencyCreateNestedManyWithoutBlockedTaskInput = {
    connect?: InputMaybe<Array<DeploymentTaskDependencyWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentTaskDependencyCreateOrConnectWithoutBlockedTaskInput>
    >;
    create?: InputMaybe<
        Array<DeploymentTaskDependencyCreateWithoutBlockedTaskInput>
    >;
    createMany?: InputMaybe<DeploymentTaskDependencyCreateManyBlockedTaskInputEnvelope>;
};

export type DeploymentTaskDependencyCreateNestedManyWithoutBlockerTaskInput = {
    connect?: InputMaybe<Array<DeploymentTaskDependencyWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentTaskDependencyCreateOrConnectWithoutBlockerTaskInput>
    >;
    create?: InputMaybe<
        Array<DeploymentTaskDependencyCreateWithoutBlockerTaskInput>
    >;
    createMany?: InputMaybe<DeploymentTaskDependencyCreateManyBlockerTaskInputEnvelope>;
};

export type DeploymentTaskDependencyCreateOrConnectWithoutBlockedTaskInput = {
    create: DeploymentTaskDependencyCreateWithoutBlockedTaskInput;
    where: DeploymentTaskDependencyWhereUniqueInput;
};

export type DeploymentTaskDependencyCreateOrConnectWithoutBlockerTaskInput = {
    create: DeploymentTaskDependencyCreateWithoutBlockerTaskInput;
    where: DeploymentTaskDependencyWhereUniqueInput;
};

export type DeploymentTaskDependencyCreateWithoutBlockedTaskInput = {
    blockerTask: DeploymentTaskCreateNestedOneWithoutBlocksInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentTaskDependencyCreateWithoutBlockerTaskInput = {
    blockedTask: DeploymentTaskCreateNestedOneWithoutBlockedByInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DeploymentTaskDependencyGroupBy = {
    __typename?: 'DeploymentTaskDependencyGroupBy';
    _avg?: Maybe<DeploymentTaskDependencyAvgAggregate>;
    _count?: Maybe<DeploymentTaskDependencyCountAggregate>;
    _max?: Maybe<DeploymentTaskDependencyMaxAggregate>;
    _min?: Maybe<DeploymentTaskDependencyMinAggregate>;
    _sum?: Maybe<DeploymentTaskDependencySumAggregate>;
    blockedTaskId: Scalars['Int']['output'];
    blockerTaskId: Scalars['Int']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DeploymentTaskDependencyListRelationFilter = {
    every?: InputMaybe<DeploymentTaskDependencyWhereInput>;
    none?: InputMaybe<DeploymentTaskDependencyWhereInput>;
    some?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type DeploymentTaskDependencyMaxAggregate = {
    __typename?: 'DeploymentTaskDependencyMaxAggregate';
    blockedTaskId?: Maybe<Scalars['Int']['output']>;
    blockerTaskId?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DeploymentTaskDependencyMaxOrderByAggregateInput = {
    blockedTaskId?: InputMaybe<SortOrder>;
    blockerTaskId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentTaskDependencyMinAggregate = {
    __typename?: 'DeploymentTaskDependencyMinAggregate';
    blockedTaskId?: Maybe<Scalars['Int']['output']>;
    blockerTaskId?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DeploymentTaskDependencyMinOrderByAggregateInput = {
    blockedTaskId?: InputMaybe<SortOrder>;
    blockerTaskId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentTaskDependencyOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type DeploymentTaskDependencyOrderByWithAggregationInput = {
    _avg?: InputMaybe<DeploymentTaskDependencyAvgOrderByAggregateInput>;
    _count?: InputMaybe<DeploymentTaskDependencyCountOrderByAggregateInput>;
    _max?: InputMaybe<DeploymentTaskDependencyMaxOrderByAggregateInput>;
    _min?: InputMaybe<DeploymentTaskDependencyMinOrderByAggregateInput>;
    _sum?: InputMaybe<DeploymentTaskDependencySumOrderByAggregateInput>;
    blockedTaskId?: InputMaybe<SortOrder>;
    blockerTaskId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type DeploymentTaskDependencyOrderByWithRelationInput = {
    blockedTask?: InputMaybe<DeploymentTaskOrderByWithRelationInput>;
    blockedTaskId?: InputMaybe<SortOrder>;
    blockerTask?: InputMaybe<DeploymentTaskOrderByWithRelationInput>;
    blockerTaskId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum DeploymentTaskDependencyScalarFieldEnum {
    BlockedTaskId = 'blockedTaskId',
    BlockerTaskId = 'blockerTaskId',
    CreatedAt = 'createdAt',
    Id = 'id',
    UpdatedAt = 'updatedAt',
}

export type DeploymentTaskDependencyScalarWhereInput = {
    AND?: InputMaybe<Array<DeploymentTaskDependencyScalarWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentTaskDependencyScalarWhereInput>>;
    OR?: InputMaybe<Array<DeploymentTaskDependencyScalarWhereInput>>;
    blockedTaskId?: InputMaybe<IntFilter>;
    blockerTaskId?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentTaskDependencyScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<DeploymentTaskDependencyScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<DeploymentTaskDependencyScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<DeploymentTaskDependencyScalarWhereWithAggregatesInput>
    >;
    blockedTaskId?: InputMaybe<IntWithAggregatesFilter>;
    blockerTaskId?: InputMaybe<IntWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DeploymentTaskDependencySumAggregate = {
    __typename?: 'DeploymentTaskDependencySumAggregate';
    blockedTaskId?: Maybe<Scalars['Int']['output']>;
    blockerTaskId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type DeploymentTaskDependencySumOrderByAggregateInput = {
    blockedTaskId?: InputMaybe<SortOrder>;
    blockerTaskId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type DeploymentTaskDependencyUpdateInput = {
    blockedTask?: InputMaybe<DeploymentTaskUpdateOneRequiredWithoutBlockedByNestedInput>;
    blockerTask?: InputMaybe<DeploymentTaskUpdateOneRequiredWithoutBlocksNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentTaskDependencyUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentTaskDependencyUpdateManyWithWhereWithoutBlockedTaskInput =
    {
        data: DeploymentTaskDependencyUpdateManyMutationInput;
        where: DeploymentTaskDependencyScalarWhereInput;
    };

export type DeploymentTaskDependencyUpdateManyWithWhereWithoutBlockerTaskInput =
    {
        data: DeploymentTaskDependencyUpdateManyMutationInput;
        where: DeploymentTaskDependencyScalarWhereInput;
    };

export type DeploymentTaskDependencyUpdateManyWithoutBlockedTaskNestedInput = {
    connect?: InputMaybe<Array<DeploymentTaskDependencyWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentTaskDependencyCreateOrConnectWithoutBlockedTaskInput>
    >;
    create?: InputMaybe<
        Array<DeploymentTaskDependencyCreateWithoutBlockedTaskInput>
    >;
    createMany?: InputMaybe<DeploymentTaskDependencyCreateManyBlockedTaskInputEnvelope>;
    delete?: InputMaybe<Array<DeploymentTaskDependencyWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeploymentTaskDependencyScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DeploymentTaskDependencyWhereUniqueInput>>;
    set?: InputMaybe<Array<DeploymentTaskDependencyWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DeploymentTaskDependencyUpdateWithWhereUniqueWithoutBlockedTaskInput>
    >;
    updateMany?: InputMaybe<
        Array<DeploymentTaskDependencyUpdateManyWithWhereWithoutBlockedTaskInput>
    >;
    upsert?: InputMaybe<
        Array<DeploymentTaskDependencyUpsertWithWhereUniqueWithoutBlockedTaskInput>
    >;
};

export type DeploymentTaskDependencyUpdateManyWithoutBlockerTaskNestedInput = {
    connect?: InputMaybe<Array<DeploymentTaskDependencyWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentTaskDependencyCreateOrConnectWithoutBlockerTaskInput>
    >;
    create?: InputMaybe<
        Array<DeploymentTaskDependencyCreateWithoutBlockerTaskInput>
    >;
    createMany?: InputMaybe<DeploymentTaskDependencyCreateManyBlockerTaskInputEnvelope>;
    delete?: InputMaybe<Array<DeploymentTaskDependencyWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeploymentTaskDependencyScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DeploymentTaskDependencyWhereUniqueInput>>;
    set?: InputMaybe<Array<DeploymentTaskDependencyWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DeploymentTaskDependencyUpdateWithWhereUniqueWithoutBlockerTaskInput>
    >;
    updateMany?: InputMaybe<
        Array<DeploymentTaskDependencyUpdateManyWithWhereWithoutBlockerTaskInput>
    >;
    upsert?: InputMaybe<
        Array<DeploymentTaskDependencyUpsertWithWhereUniqueWithoutBlockerTaskInput>
    >;
};

export type DeploymentTaskDependencyUpdateWithWhereUniqueWithoutBlockedTaskInput =
    {
        data: DeploymentTaskDependencyUpdateWithoutBlockedTaskInput;
        where: DeploymentTaskDependencyWhereUniqueInput;
    };

export type DeploymentTaskDependencyUpdateWithWhereUniqueWithoutBlockerTaskInput =
    {
        data: DeploymentTaskDependencyUpdateWithoutBlockerTaskInput;
        where: DeploymentTaskDependencyWhereUniqueInput;
    };

export type DeploymentTaskDependencyUpdateWithoutBlockedTaskInput = {
    blockerTask?: InputMaybe<DeploymentTaskUpdateOneRequiredWithoutBlocksNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentTaskDependencyUpdateWithoutBlockerTaskInput = {
    blockedTask?: InputMaybe<DeploymentTaskUpdateOneRequiredWithoutBlockedByNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeploymentTaskDependencyUpsertWithWhereUniqueWithoutBlockedTaskInput =
    {
        create: DeploymentTaskDependencyCreateWithoutBlockedTaskInput;
        update: DeploymentTaskDependencyUpdateWithoutBlockedTaskInput;
        where: DeploymentTaskDependencyWhereUniqueInput;
    };

export type DeploymentTaskDependencyUpsertWithWhereUniqueWithoutBlockerTaskInput =
    {
        create: DeploymentTaskDependencyCreateWithoutBlockerTaskInput;
        update: DeploymentTaskDependencyUpdateWithoutBlockerTaskInput;
        where: DeploymentTaskDependencyWhereUniqueInput;
    };

export type DeploymentTaskDependencyWhereInput = {
    AND?: InputMaybe<Array<DeploymentTaskDependencyWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentTaskDependencyWhereInput>>;
    OR?: InputMaybe<Array<DeploymentTaskDependencyWhereInput>>;
    blockedTask?: InputMaybe<DeploymentTaskRelationFilter>;
    blockedTaskId?: InputMaybe<IntFilter>;
    blockerTask?: InputMaybe<DeploymentTaskRelationFilter>;
    blockerTaskId?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentTaskDependencyWhereUniqueInput = {
    AND?: InputMaybe<Array<DeploymentTaskDependencyWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentTaskDependencyWhereInput>>;
    OR?: InputMaybe<Array<DeploymentTaskDependencyWhereInput>>;
    blockedTask?: InputMaybe<DeploymentTaskRelationFilter>;
    blockedTaskId?: InputMaybe<IntFilter>;
    blockedTaskId_blockerTaskId?: InputMaybe<DeploymentTaskDependencyBlockedTaskIdBlockerTaskIdCompoundUniqueInput>;
    blockerTask?: InputMaybe<DeploymentTaskRelationFilter>;
    blockerTaskId?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DeploymentTaskGroupBy = {
    __typename?: 'DeploymentTaskGroupBy';
    _avg?: Maybe<DeploymentTaskAvgAggregate>;
    _count?: Maybe<DeploymentTaskCountAggregate>;
    _max?: Maybe<DeploymentTaskMaxAggregate>;
    _min?: Maybe<DeploymentTaskMinAggregate>;
    _sum?: Maybe<DeploymentTaskSumAggregate>;
    actionTargetKey?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    dataDriven: Scalars['Boolean']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    isArchived: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    phaseId: Scalars['Int']['output'];
    propagationType: PropagationType;
    requiredBeforeGoLive: Scalars['Boolean']['output'];
    sortOrder: Scalars['Int']['output'];
    teamId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    verificationKey?: Maybe<Scalars['String']['output']>;
    verificationSource?: Maybe<VerificationSource>;
    visibility: TaskVisibility;
};

export type DeploymentTaskListRelationFilter = {
    every?: InputMaybe<DeploymentTaskWhereInput>;
    none?: InputMaybe<DeploymentTaskWhereInput>;
    some?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentTaskMaxAggregate = {
    __typename?: 'DeploymentTaskMaxAggregate';
    actionTargetKey?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dataDriven?: Maybe<Scalars['Boolean']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isArchived?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    phaseId?: Maybe<Scalars['Int']['output']>;
    propagationType?: Maybe<PropagationType>;
    requiredBeforeGoLive?: Maybe<Scalars['Boolean']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    teamId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    verificationKey?: Maybe<Scalars['String']['output']>;
    verificationSource?: Maybe<VerificationSource>;
    visibility?: Maybe<TaskVisibility>;
};

export type DeploymentTaskMaxOrderByAggregateInput = {
    actionTargetKey?: InputMaybe<SortOrder>;
    assignee?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dataDriven?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArchived?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    requiredBeforeGoLive?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    verificationKey?: InputMaybe<SortOrder>;
    verificationSource?: InputMaybe<SortOrder>;
    visibility?: InputMaybe<SortOrder>;
};

export type DeploymentTaskMinAggregate = {
    __typename?: 'DeploymentTaskMinAggregate';
    actionTargetKey?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dataDriven?: Maybe<Scalars['Boolean']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isArchived?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    phaseId?: Maybe<Scalars['Int']['output']>;
    propagationType?: Maybe<PropagationType>;
    requiredBeforeGoLive?: Maybe<Scalars['Boolean']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    teamId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    verificationKey?: Maybe<Scalars['String']['output']>;
    verificationSource?: Maybe<VerificationSource>;
    visibility?: Maybe<TaskVisibility>;
};

export type DeploymentTaskMinOrderByAggregateInput = {
    actionTargetKey?: InputMaybe<SortOrder>;
    assignee?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dataDriven?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArchived?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    requiredBeforeGoLive?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    verificationKey?: InputMaybe<SortOrder>;
    verificationSource?: InputMaybe<SortOrder>;
    visibility?: InputMaybe<SortOrder>;
};

export type DeploymentTaskNullableRelationFilter = {
    is?: InputMaybe<DeploymentTaskWhereInput>;
    isNot?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentTaskOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type DeploymentTaskOrderByWithAggregationInput = {
    _avg?: InputMaybe<DeploymentTaskAvgOrderByAggregateInput>;
    _count?: InputMaybe<DeploymentTaskCountOrderByAggregateInput>;
    _max?: InputMaybe<DeploymentTaskMaxOrderByAggregateInput>;
    _min?: InputMaybe<DeploymentTaskMinOrderByAggregateInput>;
    _sum?: InputMaybe<DeploymentTaskSumOrderByAggregateInput>;
    actionTargetKey?: InputMaybe<SortOrderInput>;
    assignee?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    dataDriven?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isArchived?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    phaseId?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    requiredBeforeGoLive?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    verificationKey?: InputMaybe<SortOrderInput>;
    verificationSource?: InputMaybe<SortOrderInput>;
    visibility?: InputMaybe<SortOrder>;
};

export type DeploymentTaskOrderByWithRelationInput = {
    actionTargetKey?: InputMaybe<SortOrderInput>;
    assignee?: InputMaybe<SortOrderInput>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyOrderByRelationAggregateInput>;
    blocks?: InputMaybe<DeploymentTaskDependencyOrderByRelationAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    dataDriven?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isArchived?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    orgTasks?: InputMaybe<DeploymentOrgTaskOrderByRelationAggregateInput>;
    phase?: InputMaybe<DeploymentPhaseOrderByWithRelationInput>;
    phaseId?: InputMaybe<SortOrder>;
    propagationType?: InputMaybe<SortOrder>;
    requiredBeforeGoLive?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    team?: InputMaybe<DeploymentTeamOrderByWithRelationInput>;
    teamId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    verificationKey?: InputMaybe<SortOrderInput>;
    verificationSource?: InputMaybe<SortOrderInput>;
    visibility?: InputMaybe<SortOrder>;
};

export type DeploymentTaskPhaseIdSortOrderCompoundUniqueInput = {
    phaseId: Scalars['Int']['input'];
    sortOrder: Scalars['Int']['input'];
};

export type DeploymentTaskRelationFilter = {
    is?: InputMaybe<DeploymentTaskWhereInput>;
    isNot?: InputMaybe<DeploymentTaskWhereInput>;
};

export enum DeploymentTaskScalarFieldEnum {
    ActionTargetKey = 'actionTargetKey',
    Assignee = 'assignee',
    CreatedAt = 'createdAt',
    DataDriven = 'dataDriven',
    DeletedAt = 'deletedAt',
    Id = 'id',
    IsArchived = 'isArchived',
    Name = 'name',
    Notes = 'notes',
    PhaseId = 'phaseId',
    PropagationType = 'propagationType',
    RequiredBeforeGoLive = 'requiredBeforeGoLive',
    SortOrder = 'sortOrder',
    TeamId = 'teamId',
    UpdatedAt = 'updatedAt',
    VerificationKey = 'verificationKey',
    VerificationSource = 'verificationSource',
    Visibility = 'visibility',
}

export type DeploymentTaskScalarWhereInput = {
    AND?: InputMaybe<Array<DeploymentTaskScalarWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentTaskScalarWhereInput>>;
    OR?: InputMaybe<Array<DeploymentTaskScalarWhereInput>>;
    actionTargetKey?: InputMaybe<StringNullableFilter>;
    assignee?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dataDriven?: InputMaybe<BoolFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    isArchived?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    phaseId?: InputMaybe<IntFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeFilter>;
    requiredBeforeGoLive?: InputMaybe<BoolFilter>;
    sortOrder?: InputMaybe<IntFilter>;
    teamId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    verificationKey?: InputMaybe<StringNullableFilter>;
    verificationSource?: InputMaybe<EnumVerificationSourceNullableFilter>;
    visibility?: InputMaybe<EnumTaskVisibilityFilter>;
};

export type DeploymentTaskScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<DeploymentTaskScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<DeploymentTaskScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<DeploymentTaskScalarWhereWithAggregatesInput>>;
    actionTargetKey?: InputMaybe<StringNullableWithAggregatesFilter>;
    assignee?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    dataDriven?: InputMaybe<BoolWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isArchived?: InputMaybe<BoolWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    phaseId?: InputMaybe<IntWithAggregatesFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeWithAggregatesFilter>;
    requiredBeforeGoLive?: InputMaybe<BoolWithAggregatesFilter>;
    sortOrder?: InputMaybe<IntWithAggregatesFilter>;
    teamId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    verificationKey?: InputMaybe<StringNullableWithAggregatesFilter>;
    verificationSource?: InputMaybe<EnumVerificationSourceNullableWithAggregatesFilter>;
    visibility?: InputMaybe<EnumTaskVisibilityWithAggregatesFilter>;
};

export type DeploymentTaskSumAggregate = {
    __typename?: 'DeploymentTaskSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    phaseId?: Maybe<Scalars['Int']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    teamId?: Maybe<Scalars['Int']['output']>;
};

export type DeploymentTaskSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    phaseId?: InputMaybe<SortOrder>;
    sortOrder?: InputMaybe<SortOrder>;
    teamId?: InputMaybe<SortOrder>;
};

export type DeploymentTaskUpdateInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyUpdateManyWithoutBlockedTaskNestedInput>;
    blocks?: InputMaybe<DeploymentTaskDependencyUpdateManyWithoutBlockerTaskNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutTaskNestedInput>;
    phase?: InputMaybe<DeploymentPhaseUpdateOneRequiredWithoutTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    team?: InputMaybe<DeploymentTeamUpdateOneRequiredWithoutTasksNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentTaskUpdateManyMutationInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentTaskUpdateManyWithWhereWithoutPhaseInput = {
    data: DeploymentTaskUpdateManyMutationInput;
    where: DeploymentTaskScalarWhereInput;
};

export type DeploymentTaskUpdateManyWithWhereWithoutTeamInput = {
    data: DeploymentTaskUpdateManyMutationInput;
    where: DeploymentTaskScalarWhereInput;
};

export type DeploymentTaskUpdateManyWithoutPhaseNestedInput = {
    connect?: InputMaybe<Array<DeploymentTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentTaskCreateOrConnectWithoutPhaseInput>
    >;
    create?: InputMaybe<Array<DeploymentTaskCreateWithoutPhaseInput>>;
    createMany?: InputMaybe<DeploymentTaskCreateManyPhaseInputEnvelope>;
    delete?: InputMaybe<Array<DeploymentTaskWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeploymentTaskScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DeploymentTaskWhereUniqueInput>>;
    set?: InputMaybe<Array<DeploymentTaskWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DeploymentTaskUpdateWithWhereUniqueWithoutPhaseInput>
    >;
    updateMany?: InputMaybe<
        Array<DeploymentTaskUpdateManyWithWhereWithoutPhaseInput>
    >;
    upsert?: InputMaybe<
        Array<DeploymentTaskUpsertWithWhereUniqueWithoutPhaseInput>
    >;
};

export type DeploymentTaskUpdateManyWithoutTeamNestedInput = {
    connect?: InputMaybe<Array<DeploymentTaskWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<DeploymentTaskCreateOrConnectWithoutTeamInput>
    >;
    create?: InputMaybe<Array<DeploymentTaskCreateWithoutTeamInput>>;
    createMany?: InputMaybe<DeploymentTaskCreateManyTeamInputEnvelope>;
    delete?: InputMaybe<Array<DeploymentTaskWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeploymentTaskScalarWhereInput>>;
    disconnect?: InputMaybe<Array<DeploymentTaskWhereUniqueInput>>;
    set?: InputMaybe<Array<DeploymentTaskWhereUniqueInput>>;
    update?: InputMaybe<
        Array<DeploymentTaskUpdateWithWhereUniqueWithoutTeamInput>
    >;
    updateMany?: InputMaybe<
        Array<DeploymentTaskUpdateManyWithWhereWithoutTeamInput>
    >;
    upsert?: InputMaybe<
        Array<DeploymentTaskUpsertWithWhereUniqueWithoutTeamInput>
    >;
};

export type DeploymentTaskUpdateOneRequiredWithoutBlockedByNestedInput = {
    connect?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentTaskCreateOrConnectWithoutBlockedByInput>;
    create?: InputMaybe<DeploymentTaskCreateWithoutBlockedByInput>;
    update?: InputMaybe<DeploymentTaskUpdateToOneWithWhereWithoutBlockedByInput>;
    upsert?: InputMaybe<DeploymentTaskUpsertWithoutBlockedByInput>;
};

export type DeploymentTaskUpdateOneRequiredWithoutBlocksNestedInput = {
    connect?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentTaskCreateOrConnectWithoutBlocksInput>;
    create?: InputMaybe<DeploymentTaskCreateWithoutBlocksInput>;
    update?: InputMaybe<DeploymentTaskUpdateToOneWithWhereWithoutBlocksInput>;
    upsert?: InputMaybe<DeploymentTaskUpsertWithoutBlocksInput>;
};

export type DeploymentTaskUpdateOneWithoutOrgTasksNestedInput = {
    connect?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentTaskCreateOrConnectWithoutOrgTasksInput>;
    create?: InputMaybe<DeploymentTaskCreateWithoutOrgTasksInput>;
    delete?: InputMaybe<DeploymentTaskWhereInput>;
    disconnect?: InputMaybe<DeploymentTaskWhereInput>;
    update?: InputMaybe<DeploymentTaskUpdateToOneWithWhereWithoutOrgTasksInput>;
    upsert?: InputMaybe<DeploymentTaskUpsertWithoutOrgTasksInput>;
};

export type DeploymentTaskUpdateToOneWithWhereWithoutBlockedByInput = {
    data: DeploymentTaskUpdateWithoutBlockedByInput;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentTaskUpdateToOneWithWhereWithoutBlocksInput = {
    data: DeploymentTaskUpdateWithoutBlocksInput;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentTaskUpdateToOneWithWhereWithoutOrgTasksInput = {
    data: DeploymentTaskUpdateWithoutOrgTasksInput;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentTaskUpdateWithWhereUniqueWithoutPhaseInput = {
    data: DeploymentTaskUpdateWithoutPhaseInput;
    where: DeploymentTaskWhereUniqueInput;
};

export type DeploymentTaskUpdateWithWhereUniqueWithoutTeamInput = {
    data: DeploymentTaskUpdateWithoutTeamInput;
    where: DeploymentTaskWhereUniqueInput;
};

export type DeploymentTaskUpdateWithoutBlockedByInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blocks?: InputMaybe<DeploymentTaskDependencyUpdateManyWithoutBlockerTaskNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutTaskNestedInput>;
    phase?: InputMaybe<DeploymentPhaseUpdateOneRequiredWithoutTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    team?: InputMaybe<DeploymentTeamUpdateOneRequiredWithoutTasksNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentTaskUpdateWithoutBlocksInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyUpdateManyWithoutBlockedTaskNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutTaskNestedInput>;
    phase?: InputMaybe<DeploymentPhaseUpdateOneRequiredWithoutTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    team?: InputMaybe<DeploymentTeamUpdateOneRequiredWithoutTasksNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentTaskUpdateWithoutOrgTasksInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyUpdateManyWithoutBlockedTaskNestedInput>;
    blocks?: InputMaybe<DeploymentTaskDependencyUpdateManyWithoutBlockerTaskNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    phase?: InputMaybe<DeploymentPhaseUpdateOneRequiredWithoutTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    team?: InputMaybe<DeploymentTeamUpdateOneRequiredWithoutTasksNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentTaskUpdateWithoutPhaseInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyUpdateManyWithoutBlockedTaskNestedInput>;
    blocks?: InputMaybe<DeploymentTaskDependencyUpdateManyWithoutBlockerTaskNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutTaskNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    team?: InputMaybe<DeploymentTeamUpdateOneRequiredWithoutTasksNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentTaskUpdateWithoutTeamInput = {
    actionTargetKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    assignee?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyUpdateManyWithoutBlockedTaskNestedInput>;
    blocks?: InputMaybe<DeploymentTaskDependencyUpdateManyWithoutBlockerTaskNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dataDriven?: InputMaybe<BoolFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutTaskNestedInput>;
    phase?: InputMaybe<DeploymentPhaseUpdateOneRequiredWithoutTasksNestedInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFieldUpdateOperationsInput>;
    requiredBeforeGoLive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    verificationKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verificationSource?: InputMaybe<NullableEnumVerificationSourceFieldUpdateOperationsInput>;
    visibility?: InputMaybe<EnumTaskVisibilityFieldUpdateOperationsInput>;
};

export type DeploymentTaskUpsertWithWhereUniqueWithoutPhaseInput = {
    create: DeploymentTaskCreateWithoutPhaseInput;
    update: DeploymentTaskUpdateWithoutPhaseInput;
    where: DeploymentTaskWhereUniqueInput;
};

export type DeploymentTaskUpsertWithWhereUniqueWithoutTeamInput = {
    create: DeploymentTaskCreateWithoutTeamInput;
    update: DeploymentTaskUpdateWithoutTeamInput;
    where: DeploymentTaskWhereUniqueInput;
};

export type DeploymentTaskUpsertWithoutBlockedByInput = {
    create: DeploymentTaskCreateWithoutBlockedByInput;
    update: DeploymentTaskUpdateWithoutBlockedByInput;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentTaskUpsertWithoutBlocksInput = {
    create: DeploymentTaskCreateWithoutBlocksInput;
    update: DeploymentTaskUpdateWithoutBlocksInput;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentTaskUpsertWithoutOrgTasksInput = {
    create: DeploymentTaskCreateWithoutOrgTasksInput;
    update: DeploymentTaskUpdateWithoutOrgTasksInput;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentTaskWhereInput = {
    AND?: InputMaybe<Array<DeploymentTaskWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentTaskWhereInput>>;
    OR?: InputMaybe<Array<DeploymentTaskWhereInput>>;
    actionTargetKey?: InputMaybe<StringNullableFilter>;
    assignee?: InputMaybe<StringNullableFilter>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyListRelationFilter>;
    blocks?: InputMaybe<DeploymentTaskDependencyListRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dataDriven?: InputMaybe<BoolFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    isArchived?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgTasks?: InputMaybe<DeploymentOrgTaskListRelationFilter>;
    phase?: InputMaybe<DeploymentPhaseRelationFilter>;
    phaseId?: InputMaybe<IntFilter>;
    propagationType?: InputMaybe<EnumPropagationTypeFilter>;
    requiredBeforeGoLive?: InputMaybe<BoolFilter>;
    sortOrder?: InputMaybe<IntFilter>;
    team?: InputMaybe<DeploymentTeamRelationFilter>;
    teamId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    verificationKey?: InputMaybe<StringNullableFilter>;
    verificationSource?: InputMaybe<EnumVerificationSourceNullableFilter>;
    visibility?: InputMaybe<EnumTaskVisibilityFilter>;
};

export type DeploymentTaskWhereUniqueInput = {
    AND?: InputMaybe<Array<DeploymentTaskWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentTaskWhereInput>>;
    OR?: InputMaybe<Array<DeploymentTaskWhereInput>>;
    actionTargetKey?: InputMaybe<StringNullableFilter>;
    assignee?: InputMaybe<StringNullableFilter>;
    blockedBy?: InputMaybe<DeploymentTaskDependencyListRelationFilter>;
    blocks?: InputMaybe<DeploymentTaskDependencyListRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dataDriven?: InputMaybe<BoolFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isArchived?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgTasks?: InputMaybe<DeploymentOrgTaskListRelationFilter>;
    phase?: InputMaybe<DeploymentPhaseRelationFilter>;
    phaseId?: InputMaybe<IntFilter>;
    phaseId_sortOrder?: InputMaybe<DeploymentTaskPhaseIdSortOrderCompoundUniqueInput>;
    propagationType?: InputMaybe<EnumPropagationTypeFilter>;
    requiredBeforeGoLive?: InputMaybe<BoolFilter>;
    sortOrder?: InputMaybe<IntFilter>;
    team?: InputMaybe<DeploymentTeamRelationFilter>;
    teamId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    verificationKey?: InputMaybe<StringNullableFilter>;
    verificationSource?: InputMaybe<EnumVerificationSourceNullableFilter>;
    visibility?: InputMaybe<EnumTaskVisibilityFilter>;
};

export type DeploymentTeam = {
    __typename?: 'DeploymentTeam';
    _count?: Maybe<DeploymentTeamCount>;
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    tasks: Array<DeploymentTask>;
};

export type DeploymentTeamTasksArgs = {
    cursor?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentTaskOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentTeamAvgAggregate = {
    __typename?: 'DeploymentTeamAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type DeploymentTeamAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type DeploymentTeamCount = {
    __typename?: 'DeploymentTeamCount';
    tasks: Scalars['Int']['output'];
};

export type DeploymentTeamCountTasksArgs = {
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type DeploymentTeamCountAggregate = {
    __typename?: 'DeploymentTeamCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
};

export type DeploymentTeamCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
};

export type DeploymentTeamCreateInput = {
    name: Scalars['String']['input'];
    tasks?: InputMaybe<DeploymentTaskCreateNestedManyWithoutTeamInput>;
};

export type DeploymentTeamCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
};

export type DeploymentTeamCreateNestedOneWithoutTasksInput = {
    connect?: InputMaybe<DeploymentTeamWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentTeamCreateOrConnectWithoutTasksInput>;
    create?: InputMaybe<DeploymentTeamCreateWithoutTasksInput>;
};

export type DeploymentTeamCreateOrConnectWithoutTasksInput = {
    create: DeploymentTeamCreateWithoutTasksInput;
    where: DeploymentTeamWhereUniqueInput;
};

export type DeploymentTeamCreateWithoutTasksInput = {
    name: Scalars['String']['input'];
};

export type DeploymentTeamGroupBy = {
    __typename?: 'DeploymentTeamGroupBy';
    _avg?: Maybe<DeploymentTeamAvgAggregate>;
    _count?: Maybe<DeploymentTeamCountAggregate>;
    _max?: Maybe<DeploymentTeamMaxAggregate>;
    _min?: Maybe<DeploymentTeamMinAggregate>;
    _sum?: Maybe<DeploymentTeamSumAggregate>;
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
};

export type DeploymentTeamMaxAggregate = {
    __typename?: 'DeploymentTeamMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

export type DeploymentTeamMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
};

export type DeploymentTeamMinAggregate = {
    __typename?: 'DeploymentTeamMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

export type DeploymentTeamMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
};

export type DeploymentTeamOrderByWithAggregationInput = {
    _avg?: InputMaybe<DeploymentTeamAvgOrderByAggregateInput>;
    _count?: InputMaybe<DeploymentTeamCountOrderByAggregateInput>;
    _max?: InputMaybe<DeploymentTeamMaxOrderByAggregateInput>;
    _min?: InputMaybe<DeploymentTeamMinOrderByAggregateInput>;
    _sum?: InputMaybe<DeploymentTeamSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
};

export type DeploymentTeamOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    tasks?: InputMaybe<DeploymentTaskOrderByRelationAggregateInput>;
};

export type DeploymentTeamRelationFilter = {
    is?: InputMaybe<DeploymentTeamWhereInput>;
    isNot?: InputMaybe<DeploymentTeamWhereInput>;
};

export enum DeploymentTeamScalarFieldEnum {
    Id = 'id',
    Name = 'name',
}

export type DeploymentTeamScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<DeploymentTeamScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<DeploymentTeamScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<DeploymentTeamScalarWhereWithAggregatesInput>>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
};

export type DeploymentTeamSumAggregate = {
    __typename?: 'DeploymentTeamSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type DeploymentTeamSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type DeploymentTeamUpdateInput = {
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    tasks?: InputMaybe<DeploymentTaskUpdateManyWithoutTeamNestedInput>;
};

export type DeploymentTeamUpdateManyMutationInput = {
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DeploymentTeamUpdateOneRequiredWithoutTasksNestedInput = {
    connect?: InputMaybe<DeploymentTeamWhereUniqueInput>;
    connectOrCreate?: InputMaybe<DeploymentTeamCreateOrConnectWithoutTasksInput>;
    create?: InputMaybe<DeploymentTeamCreateWithoutTasksInput>;
    update?: InputMaybe<DeploymentTeamUpdateToOneWithWhereWithoutTasksInput>;
    upsert?: InputMaybe<DeploymentTeamUpsertWithoutTasksInput>;
};

export type DeploymentTeamUpdateToOneWithWhereWithoutTasksInput = {
    data: DeploymentTeamUpdateWithoutTasksInput;
    where?: InputMaybe<DeploymentTeamWhereInput>;
};

export type DeploymentTeamUpdateWithoutTasksInput = {
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DeploymentTeamUpsertWithoutTasksInput = {
    create: DeploymentTeamCreateWithoutTasksInput;
    update: DeploymentTeamUpdateWithoutTasksInput;
    where?: InputMaybe<DeploymentTeamWhereInput>;
};

export type DeploymentTeamWhereInput = {
    AND?: InputMaybe<Array<DeploymentTeamWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentTeamWhereInput>>;
    OR?: InputMaybe<Array<DeploymentTeamWhereInput>>;
    id?: InputMaybe<IntFilter>;
    name?: InputMaybe<StringFilter>;
    tasks?: InputMaybe<DeploymentTaskListRelationFilter>;
};

export type DeploymentTeamWhereUniqueInput = {
    AND?: InputMaybe<Array<DeploymentTeamWhereInput>>;
    NOT?: InputMaybe<Array<DeploymentTeamWhereInput>>;
    OR?: InputMaybe<Array<DeploymentTeamWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    tasks?: InputMaybe<DeploymentTaskListRelationFilter>;
};

export type DetailBoughtTreatment = {
    __typename?: 'DetailBoughtTreatment';
    _count?: Maybe<BoughtTreatmentCount>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    candidateTreatments: Array<CandidateTreatment>;
    charges: Array<Scalars['JSONObject']['output']>;
    consumer: Scalars['JSONObject']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    discountCodeApplied?: Maybe<Scalars['String']['output']>;
    hrtFlags?: Maybe<Scalars['JSONObject']['output']>;
    hrtId: Scalars['Float']['output'];
    id: Scalars['String']['output'];
    insuranceIds: Array<Scalars['String']['output']>;
    isVirtual: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentContactId?: Maybe<Scalars['String']['output']>;
    paymentType: PaymentTypeEnum;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price: Scalars['Float']['output'];
    pricedTreatmentId: Scalars['Int']['output'];
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slot?: Maybe<Slot>;
    slotId?: Maybe<Scalars['String']['output']>;
    source: EncounterSourceEnum;
    status: BoughtTreatmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type DetailBoughtTreatmentCandidateTreatmentsArgs = {
    cursor?: InputMaybe<CandidateTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<CandidateTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type DetailBoughtTreatmentSlotArgs = {
    where?: InputMaybe<SlotWhereInput>;
};

export type DetailSlot = {
    __typename?: 'DetailSlot';
    EhrSlot?: Maybe<EhrSlot>;
    _count?: Maybe<SlotCount>;
    appointment?: Maybe<Appointment>;
    appointmentId: Scalars['String']['output'];
    boughtTreatments: Array<BoughtTreatment>;
    candidateTreatments: Array<CandidateTreatment>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    detailBoughtTreatments: Array<DetailBoughtTreatment>;
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt: Scalars['DateTimeISO']['output'];
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practice: Scalars['JSONObject']['output'];
    practiceId: Scalars['Int']['output'];
    provider: Scalars['JSONObject']['output'];
    providerId: Scalars['Int']['output'];
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['output'];
    status: SlotStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type DetailSlotEhrSlotArgs = {
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type DetailSlotAppointmentArgs = {
    where?: InputMaybe<AppointmentWhereInput>;
};

export type DetailSlotBoughtTreatmentsArgs = {
    cursor?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BoughtTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type DetailSlotCandidateTreatmentsArgs = {
    cursor?: InputMaybe<CandidateTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<CandidateTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type DiscountCodes = {
    __typename?: 'DiscountCodes';
    appliesToHrts: Array<Scalars['Int']['output']>;
    campaignEnd?: Maybe<Scalars['DateTimeISO']['output']>;
    campaignStart?: Maybe<Scalars['DateTimeISO']['output']>;
    code: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    discountDollarAmount?: Maybe<Scalars['Int']['output']>;
    discountPercent?: Maybe<Scalars['Int']['output']>;
    discountType: DiscountType;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    orgId: Scalars['Int']['output'];
};

export type DiscountCodesAvgAggregate = {
    __typename?: 'DiscountCodesAvgAggregate';
    appliesToHrts?: Maybe<Scalars['Float']['output']>;
    discountDollarAmount?: Maybe<Scalars['Float']['output']>;
    discountPercent?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type DiscountCodesAvgOrderByAggregateInput = {
    appliesToHrts?: InputMaybe<SortOrder>;
    discountDollarAmount?: InputMaybe<SortOrder>;
    discountPercent?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type DiscountCodesCountAggregate = {
    __typename?: 'DiscountCodesCountAggregate';
    _all: Scalars['Int']['output'];
    appliesToHrts: Scalars['Int']['output'];
    campaignEnd: Scalars['Int']['output'];
    campaignStart: Scalars['Int']['output'];
    code: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    discountDollarAmount: Scalars['Int']['output'];
    discountPercent: Scalars['Int']['output'];
    discountType: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
};

export type DiscountCodesCountOrderByAggregateInput = {
    appliesToHrts?: InputMaybe<SortOrder>;
    campaignEnd?: InputMaybe<SortOrder>;
    campaignStart?: InputMaybe<SortOrder>;
    code?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    discountDollarAmount?: InputMaybe<SortOrder>;
    discountPercent?: InputMaybe<SortOrder>;
    discountType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type DiscountCodesCreateInput = {
    appliesToHrts?: InputMaybe<DiscountCodesCreateappliesToHrtsInput>;
    campaignEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
    campaignStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
    code: Scalars['String']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    discountDollarAmount?: InputMaybe<Scalars['Int']['input']>;
    discountPercent?: InputMaybe<Scalars['Int']['input']>;
    discountType?: InputMaybe<DiscountType>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    orgId: Scalars['Int']['input'];
};

export type DiscountCodesCreateManyInput = {
    appliesToHrts?: InputMaybe<DiscountCodesCreateappliesToHrtsInput>;
    campaignEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
    campaignStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
    code: Scalars['String']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    discountDollarAmount?: InputMaybe<Scalars['Int']['input']>;
    discountPercent?: InputMaybe<Scalars['Int']['input']>;
    discountType?: InputMaybe<DiscountType>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    orgId: Scalars['Int']['input'];
};

export type DiscountCodesCreateappliesToHrtsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type DiscountCodesGroupBy = {
    __typename?: 'DiscountCodesGroupBy';
    _avg?: Maybe<DiscountCodesAvgAggregate>;
    _count?: Maybe<DiscountCodesCountAggregate>;
    _max?: Maybe<DiscountCodesMaxAggregate>;
    _min?: Maybe<DiscountCodesMinAggregate>;
    _sum?: Maybe<DiscountCodesSumAggregate>;
    appliesToHrts?: Maybe<Array<Scalars['Int']['output']>>;
    campaignEnd?: Maybe<Scalars['DateTimeISO']['output']>;
    campaignStart?: Maybe<Scalars['DateTimeISO']['output']>;
    code: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    discountDollarAmount?: Maybe<Scalars['Int']['output']>;
    discountPercent?: Maybe<Scalars['Int']['output']>;
    discountType: DiscountType;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    orgId: Scalars['Int']['output'];
};

export type DiscountCodesMaxAggregate = {
    __typename?: 'DiscountCodesMaxAggregate';
    campaignEnd?: Maybe<Scalars['DateTimeISO']['output']>;
    campaignStart?: Maybe<Scalars['DateTimeISO']['output']>;
    code?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    discountDollarAmount?: Maybe<Scalars['Int']['output']>;
    discountPercent?: Maybe<Scalars['Int']['output']>;
    discountType?: Maybe<DiscountType>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type DiscountCodesMaxOrderByAggregateInput = {
    campaignEnd?: InputMaybe<SortOrder>;
    campaignStart?: InputMaybe<SortOrder>;
    code?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    discountDollarAmount?: InputMaybe<SortOrder>;
    discountPercent?: InputMaybe<SortOrder>;
    discountType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type DiscountCodesMinAggregate = {
    __typename?: 'DiscountCodesMinAggregate';
    campaignEnd?: Maybe<Scalars['DateTimeISO']['output']>;
    campaignStart?: Maybe<Scalars['DateTimeISO']['output']>;
    code?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    discountDollarAmount?: Maybe<Scalars['Int']['output']>;
    discountPercent?: Maybe<Scalars['Int']['output']>;
    discountType?: Maybe<DiscountType>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type DiscountCodesMinOrderByAggregateInput = {
    campaignEnd?: InputMaybe<SortOrder>;
    campaignStart?: InputMaybe<SortOrder>;
    code?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    discountDollarAmount?: InputMaybe<SortOrder>;
    discountPercent?: InputMaybe<SortOrder>;
    discountType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type DiscountCodesOrderByWithAggregationInput = {
    _avg?: InputMaybe<DiscountCodesAvgOrderByAggregateInput>;
    _count?: InputMaybe<DiscountCodesCountOrderByAggregateInput>;
    _max?: InputMaybe<DiscountCodesMaxOrderByAggregateInput>;
    _min?: InputMaybe<DiscountCodesMinOrderByAggregateInput>;
    _sum?: InputMaybe<DiscountCodesSumOrderByAggregateInput>;
    appliesToHrts?: InputMaybe<SortOrder>;
    campaignEnd?: InputMaybe<SortOrderInput>;
    campaignStart?: InputMaybe<SortOrderInput>;
    code?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrderInput>;
    discountDollarAmount?: InputMaybe<SortOrderInput>;
    discountPercent?: InputMaybe<SortOrderInput>;
    discountType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type DiscountCodesOrderByWithRelationInput = {
    appliesToHrts?: InputMaybe<SortOrder>;
    campaignEnd?: InputMaybe<SortOrderInput>;
    campaignStart?: InputMaybe<SortOrderInput>;
    code?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrderInput>;
    discountDollarAmount?: InputMaybe<SortOrderInput>;
    discountPercent?: InputMaybe<SortOrderInput>;
    discountType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type DiscountCodesOrgIdIdCompoundUniqueInput = {
    id: Scalars['Int']['input'];
    orgId: Scalars['Int']['input'];
};

export enum DiscountCodesScalarFieldEnum {
    AppliesToHrts = 'appliesToHrts',
    CampaignEnd = 'campaignEnd',
    CampaignStart = 'campaignStart',
    Code = 'code',
    Description = 'description',
    DiscountDollarAmount = 'discountDollarAmount',
    DiscountPercent = 'discountPercent',
    DiscountType = 'discountType',
    Id = 'id',
    IsActive = 'isActive',
    OrgId = 'orgId',
}

export type DiscountCodesScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<DiscountCodesScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<DiscountCodesScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<DiscountCodesScalarWhereWithAggregatesInput>>;
    appliesToHrts?: InputMaybe<IntNullableListFilter>;
    campaignEnd?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    campaignStart?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    code?: InputMaybe<StringWithAggregatesFilter>;
    description?: InputMaybe<StringNullableWithAggregatesFilter>;
    discountDollarAmount?: InputMaybe<IntNullableWithAggregatesFilter>;
    discountPercent?: InputMaybe<IntNullableWithAggregatesFilter>;
    discountType?: InputMaybe<EnumDiscountTypeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
};

export type DiscountCodesSumAggregate = {
    __typename?: 'DiscountCodesSumAggregate';
    appliesToHrts?: Maybe<Array<Scalars['Int']['output']>>;
    discountDollarAmount?: Maybe<Scalars['Int']['output']>;
    discountPercent?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type DiscountCodesSumOrderByAggregateInput = {
    appliesToHrts?: InputMaybe<SortOrder>;
    discountDollarAmount?: InputMaybe<SortOrder>;
    discountPercent?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type DiscountCodesUpdateInput = {
    appliesToHrts?: InputMaybe<DiscountCodesUpdateappliesToHrtsInput>;
    campaignEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    campaignStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    code?: InputMaybe<StringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    discountDollarAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    discountPercent?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DiscountCodesUpdateManyMutationInput = {
    appliesToHrts?: InputMaybe<DiscountCodesUpdateappliesToHrtsInput>;
    campaignEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    campaignStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    code?: InputMaybe<StringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    discountDollarAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    discountPercent?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DiscountCodesUpdateappliesToHrtsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DiscountCodesWhereInput = {
    AND?: InputMaybe<Array<DiscountCodesWhereInput>>;
    NOT?: InputMaybe<Array<DiscountCodesWhereInput>>;
    OR?: InputMaybe<Array<DiscountCodesWhereInput>>;
    appliesToHrts?: InputMaybe<IntNullableListFilter>;
    campaignEnd?: InputMaybe<DateTimeNullableFilter>;
    campaignStart?: InputMaybe<DateTimeNullableFilter>;
    code?: InputMaybe<StringFilter>;
    description?: InputMaybe<StringNullableFilter>;
    discountDollarAmount?: InputMaybe<IntNullableFilter>;
    discountPercent?: InputMaybe<IntNullableFilter>;
    discountType?: InputMaybe<EnumDiscountTypeFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    orgId?: InputMaybe<IntFilter>;
};

export type DiscountCodesWhereUniqueInput = {
    AND?: InputMaybe<Array<DiscountCodesWhereInput>>;
    NOT?: InputMaybe<Array<DiscountCodesWhereInput>>;
    OR?: InputMaybe<Array<DiscountCodesWhereInput>>;
    appliesToHrts?: InputMaybe<IntNullableListFilter>;
    campaignEnd?: InputMaybe<DateTimeNullableFilter>;
    campaignStart?: InputMaybe<DateTimeNullableFilter>;
    code?: InputMaybe<StringFilter>;
    description?: InputMaybe<StringNullableFilter>;
    discountDollarAmount?: InputMaybe<IntNullableFilter>;
    discountPercent?: InputMaybe<IntNullableFilter>;
    discountType?: InputMaybe<EnumDiscountTypeFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgId_id?: InputMaybe<DiscountCodesOrgIdIdCompoundUniqueInput>;
};

export enum EhrType {
    Athena = 'ATHENA',
    Experity = 'EXPERITY',
    Nextgen = 'NEXTGEN',
    Partner = 'PARTNER',
}

export type EcwPayerAlias = {
    __typename?: 'EcwPayerAlias';
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    displayAlias: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    label?: Maybe<Scalars['String']['output']>;
    org: Organization;
    orgId: Scalars['Int']['output'];
    payerCode: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EcwPayerAliasAvgAggregate = {
    __typename?: 'EcwPayerAliasAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type EcwPayerAliasAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EcwPayerAliasCountAggregate = {
    __typename?: 'EcwPayerAliasCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    displayAlias: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    label: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payerCode: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type EcwPayerAliasCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    displayAlias?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerCode?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EcwPayerAliasCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayAlias: Scalars['String']['input'];
    label?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutEcwPayerAliasInput;
    payerCode: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EcwPayerAliasCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayAlias: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    label?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    payerCode: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EcwPayerAliasCreateManyOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayAlias: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    label?: InputMaybe<Scalars['String']['input']>;
    payerCode: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EcwPayerAliasCreateManyOrgInputEnvelope = {
    data: Array<EcwPayerAliasCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EcwPayerAliasCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<EcwPayerAliasWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<EcwPayerAliasCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<EcwPayerAliasCreateWithoutOrgInput>>;
    createMany?: InputMaybe<EcwPayerAliasCreateManyOrgInputEnvelope>;
};

export type EcwPayerAliasCreateOrConnectWithoutOrgInput = {
    create: EcwPayerAliasCreateWithoutOrgInput;
    where: EcwPayerAliasWhereUniqueInput;
};

export type EcwPayerAliasCreateWithoutOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayAlias: Scalars['String']['input'];
    label?: InputMaybe<Scalars['String']['input']>;
    payerCode: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EcwPayerAliasEcwPayerAliasOrgDisplayCodeCompoundUniqueInput = {
    displayAlias: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    payerCode: Scalars['String']['input'];
};

export type EcwPayerAliasGroupBy = {
    __typename?: 'EcwPayerAliasGroupBy';
    _avg?: Maybe<EcwPayerAliasAvgAggregate>;
    _count?: Maybe<EcwPayerAliasCountAggregate>;
    _max?: Maybe<EcwPayerAliasMaxAggregate>;
    _min?: Maybe<EcwPayerAliasMinAggregate>;
    _sum?: Maybe<EcwPayerAliasSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    displayAlias: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    label?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    payerCode: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EcwPayerAliasListRelationFilter = {
    every?: InputMaybe<EcwPayerAliasWhereInput>;
    none?: InputMaybe<EcwPayerAliasWhereInput>;
    some?: InputMaybe<EcwPayerAliasWhereInput>;
};

export type EcwPayerAliasMaxAggregate = {
    __typename?: 'EcwPayerAliasMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    displayAlias?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerCode?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EcwPayerAliasMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    displayAlias?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerCode?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EcwPayerAliasMinAggregate = {
    __typename?: 'EcwPayerAliasMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    displayAlias?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerCode?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EcwPayerAliasMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    displayAlias?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerCode?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EcwPayerAliasOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type EcwPayerAliasOrderByWithAggregationInput = {
    _avg?: InputMaybe<EcwPayerAliasAvgOrderByAggregateInput>;
    _count?: InputMaybe<EcwPayerAliasCountOrderByAggregateInput>;
    _max?: InputMaybe<EcwPayerAliasMaxOrderByAggregateInput>;
    _min?: InputMaybe<EcwPayerAliasMinOrderByAggregateInput>;
    _sum?: InputMaybe<EcwPayerAliasSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    displayAlias?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    payerCode?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EcwPayerAliasOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    displayAlias?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrderInput>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    payerCode?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum EcwPayerAliasScalarFieldEnum {
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    DisplayAlias = 'displayAlias',
    Id = 'id',
    Label = 'label',
    OrgId = 'orgId',
    PayerCode = 'payerCode',
    UpdatedAt = 'updatedAt',
}

export type EcwPayerAliasScalarWhereInput = {
    AND?: InputMaybe<Array<EcwPayerAliasScalarWhereInput>>;
    NOT?: InputMaybe<Array<EcwPayerAliasScalarWhereInput>>;
    OR?: InputMaybe<Array<EcwPayerAliasScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    displayAlias?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    label?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    payerCode?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EcwPayerAliasScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<EcwPayerAliasScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<EcwPayerAliasScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<EcwPayerAliasScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    displayAlias?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    label?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    payerCode?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EcwPayerAliasSumAggregate = {
    __typename?: 'EcwPayerAliasSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type EcwPayerAliasSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EcwPayerAliasUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    displayAlias?: InputMaybe<StringFieldUpdateOperationsInput>;
    label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutEcwPayerAliasNestedInput>;
    payerCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EcwPayerAliasUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    displayAlias?: InputMaybe<StringFieldUpdateOperationsInput>;
    label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payerCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EcwPayerAliasUpdateManyWithWhereWithoutOrgInput = {
    data: EcwPayerAliasUpdateManyMutationInput;
    where: EcwPayerAliasScalarWhereInput;
};

export type EcwPayerAliasUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<EcwPayerAliasWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<EcwPayerAliasCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<EcwPayerAliasCreateWithoutOrgInput>>;
    createMany?: InputMaybe<EcwPayerAliasCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<EcwPayerAliasWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<EcwPayerAliasScalarWhereInput>>;
    disconnect?: InputMaybe<Array<EcwPayerAliasWhereUniqueInput>>;
    set?: InputMaybe<Array<EcwPayerAliasWhereUniqueInput>>;
    update?: InputMaybe<
        Array<EcwPayerAliasUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<EcwPayerAliasUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<EcwPayerAliasUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type EcwPayerAliasUpdateWithWhereUniqueWithoutOrgInput = {
    data: EcwPayerAliasUpdateWithoutOrgInput;
    where: EcwPayerAliasWhereUniqueInput;
};

export type EcwPayerAliasUpdateWithoutOrgInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    displayAlias?: InputMaybe<StringFieldUpdateOperationsInput>;
    label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payerCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EcwPayerAliasUpsertWithWhereUniqueWithoutOrgInput = {
    create: EcwPayerAliasCreateWithoutOrgInput;
    update: EcwPayerAliasUpdateWithoutOrgInput;
    where: EcwPayerAliasWhereUniqueInput;
};

export type EcwPayerAliasWhereInput = {
    AND?: InputMaybe<Array<EcwPayerAliasWhereInput>>;
    NOT?: InputMaybe<Array<EcwPayerAliasWhereInput>>;
    OR?: InputMaybe<Array<EcwPayerAliasWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    displayAlias?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    label?: InputMaybe<StringNullableFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    payerCode?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EcwPayerAliasWhereUniqueInput = {
    AND?: InputMaybe<Array<EcwPayerAliasWhereInput>>;
    NOT?: InputMaybe<Array<EcwPayerAliasWhereInput>>;
    OR?: InputMaybe<Array<EcwPayerAliasWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    displayAlias?: InputMaybe<StringFilter>;
    ecw_payer_alias_org_display_code?: InputMaybe<EcwPayerAliasEcwPayerAliasOrgDisplayCodeCompoundUniqueInput>;
    id?: InputMaybe<Scalars['Int']['input']>;
    label?: InputMaybe<StringNullableFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    payerCode?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EcwPayerStc = {
    __typename?: 'EcwPayerStc';
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    payerCode?: Maybe<Scalars['String']['output']>;
    placeOfService?: Maybe<Scalars['String']['output']>;
    stc: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EcwPayerStcAvgAggregate = {
    __typename?: 'EcwPayerStcAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type EcwPayerStcAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EcwPayerStcCountAggregate = {
    __typename?: 'EcwPayerStcCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payerCode: Scalars['Int']['output'];
    placeOfService: Scalars['Int']['output'];
    stc: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type EcwPayerStcCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerCode?: InputMaybe<SortOrder>;
    placeOfService?: InputMaybe<SortOrder>;
    stc?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EcwPayerStcCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    org: OrganizationCreateNestedOneWithoutEcwPayerStcInput;
    payerCode?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<Scalars['String']['input']>;
    stc: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EcwPayerStcCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    payerCode?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<Scalars['String']['input']>;
    stc: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EcwPayerStcCreateManyOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    payerCode?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<Scalars['String']['input']>;
    stc: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EcwPayerStcCreateManyOrgInputEnvelope = {
    data: Array<EcwPayerStcCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EcwPayerStcCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<EcwPayerStcWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<EcwPayerStcCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<EcwPayerStcCreateWithoutOrgInput>>;
    createMany?: InputMaybe<EcwPayerStcCreateManyOrgInputEnvelope>;
};

export type EcwPayerStcCreateOrConnectWithoutOrgInput = {
    create: EcwPayerStcCreateWithoutOrgInput;
    where: EcwPayerStcWhereUniqueInput;
};

export type EcwPayerStcCreateWithoutOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    payerCode?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<Scalars['String']['input']>;
    stc: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EcwPayerStcGroupBy = {
    __typename?: 'EcwPayerStcGroupBy';
    _avg?: Maybe<EcwPayerStcAvgAggregate>;
    _count?: Maybe<EcwPayerStcCountAggregate>;
    _max?: Maybe<EcwPayerStcMaxAggregate>;
    _min?: Maybe<EcwPayerStcMinAggregate>;
    _sum?: Maybe<EcwPayerStcSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payerCode?: Maybe<Scalars['String']['output']>;
    placeOfService?: Maybe<Scalars['String']['output']>;
    stc: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EcwPayerStcListRelationFilter = {
    every?: InputMaybe<EcwPayerStcWhereInput>;
    none?: InputMaybe<EcwPayerStcWhereInput>;
    some?: InputMaybe<EcwPayerStcWhereInput>;
};

export type EcwPayerStcMaxAggregate = {
    __typename?: 'EcwPayerStcMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerCode?: Maybe<Scalars['String']['output']>;
    placeOfService?: Maybe<Scalars['String']['output']>;
    stc?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EcwPayerStcMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerCode?: InputMaybe<SortOrder>;
    placeOfService?: InputMaybe<SortOrder>;
    stc?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EcwPayerStcMinAggregate = {
    __typename?: 'EcwPayerStcMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerCode?: Maybe<Scalars['String']['output']>;
    placeOfService?: Maybe<Scalars['String']['output']>;
    stc?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EcwPayerStcMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerCode?: InputMaybe<SortOrder>;
    placeOfService?: InputMaybe<SortOrder>;
    stc?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EcwPayerStcOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type EcwPayerStcOrderByWithAggregationInput = {
    _avg?: InputMaybe<EcwPayerStcAvgOrderByAggregateInput>;
    _count?: InputMaybe<EcwPayerStcCountOrderByAggregateInput>;
    _max?: InputMaybe<EcwPayerStcMaxOrderByAggregateInput>;
    _min?: InputMaybe<EcwPayerStcMinOrderByAggregateInput>;
    _sum?: InputMaybe<EcwPayerStcSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerCode?: InputMaybe<SortOrderInput>;
    placeOfService?: InputMaybe<SortOrderInput>;
    stc?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EcwPayerStcOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    payerCode?: InputMaybe<SortOrderInput>;
    placeOfService?: InputMaybe<SortOrderInput>;
    stc?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum EcwPayerStcScalarFieldEnum {
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    Id = 'id',
    OrgId = 'orgId',
    PayerCode = 'payerCode',
    PlaceOfService = 'placeOfService',
    Stc = 'stc',
    UpdatedAt = 'updatedAt',
}

export type EcwPayerStcScalarWhereInput = {
    AND?: InputMaybe<Array<EcwPayerStcScalarWhereInput>>;
    NOT?: InputMaybe<Array<EcwPayerStcScalarWhereInput>>;
    OR?: InputMaybe<Array<EcwPayerStcScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    orgId?: InputMaybe<IntFilter>;
    payerCode?: InputMaybe<StringNullableFilter>;
    placeOfService?: InputMaybe<StringNullableFilter>;
    stc?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EcwPayerStcScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<EcwPayerStcScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<EcwPayerStcScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<EcwPayerStcScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    payerCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    placeOfService?: InputMaybe<StringNullableWithAggregatesFilter>;
    stc?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EcwPayerStcSumAggregate = {
    __typename?: 'EcwPayerStcSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type EcwPayerStcSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EcwPayerStcUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutEcwPayerStcNestedInput>;
    payerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stc?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EcwPayerStcUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    payerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stc?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EcwPayerStcUpdateManyWithWhereWithoutOrgInput = {
    data: EcwPayerStcUpdateManyMutationInput;
    where: EcwPayerStcScalarWhereInput;
};

export type EcwPayerStcUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<EcwPayerStcWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<EcwPayerStcCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<EcwPayerStcCreateWithoutOrgInput>>;
    createMany?: InputMaybe<EcwPayerStcCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<EcwPayerStcWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<EcwPayerStcScalarWhereInput>>;
    disconnect?: InputMaybe<Array<EcwPayerStcWhereUniqueInput>>;
    set?: InputMaybe<Array<EcwPayerStcWhereUniqueInput>>;
    update?: InputMaybe<Array<EcwPayerStcUpdateWithWhereUniqueWithoutOrgInput>>;
    updateMany?: InputMaybe<
        Array<EcwPayerStcUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<Array<EcwPayerStcUpsertWithWhereUniqueWithoutOrgInput>>;
};

export type EcwPayerStcUpdateWithWhereUniqueWithoutOrgInput = {
    data: EcwPayerStcUpdateWithoutOrgInput;
    where: EcwPayerStcWhereUniqueInput;
};

export type EcwPayerStcUpdateWithoutOrgInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    payerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stc?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EcwPayerStcUpsertWithWhereUniqueWithoutOrgInput = {
    create: EcwPayerStcCreateWithoutOrgInput;
    update: EcwPayerStcUpdateWithoutOrgInput;
    where: EcwPayerStcWhereUniqueInput;
};

export type EcwPayerStcWhereInput = {
    AND?: InputMaybe<Array<EcwPayerStcWhereInput>>;
    NOT?: InputMaybe<Array<EcwPayerStcWhereInput>>;
    OR?: InputMaybe<Array<EcwPayerStcWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    payerCode?: InputMaybe<StringNullableFilter>;
    placeOfService?: InputMaybe<StringNullableFilter>;
    stc?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EcwPayerStcWhereUniqueInput = {
    AND?: InputMaybe<Array<EcwPayerStcWhereInput>>;
    NOT?: InputMaybe<Array<EcwPayerStcWhereInput>>;
    OR?: InputMaybe<Array<EcwPayerStcWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    payerCode?: InputMaybe<StringNullableFilter>;
    placeOfService?: InputMaybe<StringNullableFilter>;
    stc?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrAppointmentTypeIdToName = {
    __typename?: 'EhrAppointmentTypeIdToName';
    candidateHrtIds: Array<Scalars['Int']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    duration: Scalars['Int']['output'];
    ehrAppointmentTypeName: Scalars['String']['output'];
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPrimaryAppointmentTypeId: Scalars['String']['output'];
    hrts: Array<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    isGeneric: Scalars['Boolean']['output'];
    isVirtual: Scalars['Boolean']['output'];
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    prompt?: Maybe<Scalars['String']['output']>;
    selectionPriority: SelectionPriority;
    selectionType: SelectionType;
    usesOrder: Scalars['Boolean']['output'];
};

export type EhrAppointmentTypeIdToNameAvgAggregate = {
    __typename?: 'EhrAppointmentTypeIdToNameAvgAggregate';
    candidateHrtIds?: Maybe<Scalars['Float']['output']>;
    duration?: Maybe<Scalars['Float']['output']>;
    hrts?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrAppointmentTypeIdToNameAvgOrderByAggregateInput = {
    candidateHrtIds?: InputMaybe<SortOrder>;
    duration?: InputMaybe<SortOrder>;
    hrts?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrAppointmentTypeIdToNameCountAggregate = {
    __typename?: 'EhrAppointmentTypeIdToNameCountAggregate';
    _all: Scalars['Int']['output'];
    candidateHrtIds: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    duration: Scalars['Int']['output'];
    ehrAppointmentTypeName: Scalars['Int']['output'];
    ehrDepartmentId: Scalars['Int']['output'];
    ehrPrimaryAppointmentTypeId: Scalars['Int']['output'];
    hrts: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isGeneric: Scalars['Int']['output'];
    isVirtual: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    prompt: Scalars['Int']['output'];
    selectionPriority: Scalars['Int']['output'];
    selectionType: Scalars['Int']['output'];
    usesOrder: Scalars['Int']['output'];
};

export type EhrAppointmentTypeIdToNameCountOrderByAggregateInput = {
    candidateHrtIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    duration?: InputMaybe<SortOrder>;
    ehrAppointmentTypeName?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<SortOrder>;
    hrts?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isGeneric?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    prompt?: InputMaybe<SortOrder>;
    selectionPriority?: InputMaybe<SortOrder>;
    selectionType?: InputMaybe<SortOrder>;
    usesOrder?: InputMaybe<SortOrder>;
};

export type EhrAppointmentTypeIdToNameCreateInput = {
    candidateHrtIds?: InputMaybe<EhrAppointmentTypeIdToNameCreatecandidateHrtIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    duration?: InputMaybe<Scalars['Int']['input']>;
    ehrAppointmentTypeName: Scalars['String']['input'];
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId: Scalars['String']['input'];
    hrts?: InputMaybe<EhrAppointmentTypeIdToNameCreatehrtsInput>;
    isGeneric?: InputMaybe<Scalars['Boolean']['input']>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    prompt?: InputMaybe<Scalars['String']['input']>;
    selectionPriority?: InputMaybe<SelectionPriority>;
    selectionType?: InputMaybe<SelectionType>;
    usesOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EhrAppointmentTypeIdToNameCreateManyInput = {
    candidateHrtIds?: InputMaybe<EhrAppointmentTypeIdToNameCreatecandidateHrtIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    duration?: InputMaybe<Scalars['Int']['input']>;
    ehrAppointmentTypeName: Scalars['String']['input'];
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId: Scalars['String']['input'];
    hrts?: InputMaybe<EhrAppointmentTypeIdToNameCreatehrtsInput>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isGeneric?: InputMaybe<Scalars['Boolean']['input']>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    prompt?: InputMaybe<Scalars['String']['input']>;
    selectionPriority?: InputMaybe<SelectionPriority>;
    selectionType?: InputMaybe<SelectionType>;
    usesOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EhrAppointmentTypeIdToNameCreatecandidateHrtIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type EhrAppointmentTypeIdToNameCreatehrtsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type EhrAppointmentTypeIdToNameGroupBy = {
    __typename?: 'EhrAppointmentTypeIdToNameGroupBy';
    _avg?: Maybe<EhrAppointmentTypeIdToNameAvgAggregate>;
    _count?: Maybe<EhrAppointmentTypeIdToNameCountAggregate>;
    _max?: Maybe<EhrAppointmentTypeIdToNameMaxAggregate>;
    _min?: Maybe<EhrAppointmentTypeIdToNameMinAggregate>;
    _sum?: Maybe<EhrAppointmentTypeIdToNameSumAggregate>;
    candidateHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    duration: Scalars['Int']['output'];
    ehrAppointmentTypeName: Scalars['String']['output'];
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPrimaryAppointmentTypeId: Scalars['String']['output'];
    hrts?: Maybe<Array<Scalars['Int']['output']>>;
    id: Scalars['Int']['output'];
    isGeneric: Scalars['Boolean']['output'];
    isVirtual: Scalars['Boolean']['output'];
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    prompt?: Maybe<Scalars['String']['output']>;
    selectionPriority: SelectionPriority;
    selectionType: SelectionType;
    usesOrder: Scalars['Boolean']['output'];
};

export type EhrAppointmentTypeIdToNameMaxAggregate = {
    __typename?: 'EhrAppointmentTypeIdToNameMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    duration?: Maybe<Scalars['Int']['output']>;
    ehrAppointmentTypeName?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPrimaryAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isGeneric?: Maybe<Scalars['Boolean']['output']>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    prompt?: Maybe<Scalars['String']['output']>;
    selectionPriority?: Maybe<SelectionPriority>;
    selectionType?: Maybe<SelectionType>;
    usesOrder?: Maybe<Scalars['Boolean']['output']>;
};

export type EhrAppointmentTypeIdToNameMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    duration?: InputMaybe<SortOrder>;
    ehrAppointmentTypeName?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isGeneric?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    prompt?: InputMaybe<SortOrder>;
    selectionPriority?: InputMaybe<SortOrder>;
    selectionType?: InputMaybe<SortOrder>;
    usesOrder?: InputMaybe<SortOrder>;
};

export type EhrAppointmentTypeIdToNameMinAggregate = {
    __typename?: 'EhrAppointmentTypeIdToNameMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    duration?: Maybe<Scalars['Int']['output']>;
    ehrAppointmentTypeName?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPrimaryAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isGeneric?: Maybe<Scalars['Boolean']['output']>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    prompt?: Maybe<Scalars['String']['output']>;
    selectionPriority?: Maybe<SelectionPriority>;
    selectionType?: Maybe<SelectionType>;
    usesOrder?: Maybe<Scalars['Boolean']['output']>;
};

export type EhrAppointmentTypeIdToNameMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    duration?: InputMaybe<SortOrder>;
    ehrAppointmentTypeName?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isGeneric?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    prompt?: InputMaybe<SortOrder>;
    selectionPriority?: InputMaybe<SortOrder>;
    selectionType?: InputMaybe<SortOrder>;
    usesOrder?: InputMaybe<SortOrder>;
};

export type EhrAppointmentTypeIdToNameOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrAppointmentTypeIdToNameAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrAppointmentTypeIdToNameCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrAppointmentTypeIdToNameMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrAppointmentTypeIdToNameMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrAppointmentTypeIdToNameSumOrderByAggregateInput>;
    candidateHrtIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    duration?: InputMaybe<SortOrder>;
    ehrAppointmentTypeName?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrderInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<SortOrder>;
    hrts?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isGeneric?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    prompt?: InputMaybe<SortOrderInput>;
    selectionPriority?: InputMaybe<SortOrder>;
    selectionType?: InputMaybe<SortOrder>;
    usesOrder?: InputMaybe<SortOrder>;
};

export type EhrAppointmentTypeIdToNameOrderByWithRelationInput = {
    candidateHrtIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    duration?: InputMaybe<SortOrder>;
    ehrAppointmentTypeName?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrderInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<SortOrder>;
    hrts?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isGeneric?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    prompt?: InputMaybe<SortOrderInput>;
    selectionPriority?: InputMaybe<SortOrder>;
    selectionType?: InputMaybe<SortOrder>;
    usesOrder?: InputMaybe<SortOrder>;
};

export enum EhrAppointmentTypeIdToNameScalarFieldEnum {
    CandidateHrtIds = 'candidateHrtIds',
    CreatedAt = 'createdAt',
    Duration = 'duration',
    EhrAppointmentTypeName = 'ehrAppointmentTypeName',
    EhrDepartmentId = 'ehrDepartmentId',
    EhrPrimaryAppointmentTypeId = 'ehrPrimaryAppointmentTypeId',
    Hrts = 'hrts',
    Id = 'id',
    IsGeneric = 'isGeneric',
    IsVirtual = 'isVirtual',
    Npi = 'npi',
    OrgId = 'orgId',
    Prompt = 'prompt',
    SelectionPriority = 'selectionPriority',
    SelectionType = 'selectionType',
    UsesOrder = 'usesOrder',
}

export type EhrAppointmentTypeIdToNameScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<EhrAppointmentTypeIdToNameScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<EhrAppointmentTypeIdToNameScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<EhrAppointmentTypeIdToNameScalarWhereWithAggregatesInput>
    >;
    candidateHrtIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    duration?: InputMaybe<IntWithAggregatesFilter>;
    ehrAppointmentTypeName?: InputMaybe<StringWithAggregatesFilter>;
    ehrDepartmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<StringWithAggregatesFilter>;
    hrts?: InputMaybe<IntNullableListFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isGeneric?: InputMaybe<BoolWithAggregatesFilter>;
    isVirtual?: InputMaybe<BoolWithAggregatesFilter>;
    npi?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    prompt?: InputMaybe<StringNullableWithAggregatesFilter>;
    selectionPriority?: InputMaybe<EnumSelectionPriorityWithAggregatesFilter>;
    selectionType?: InputMaybe<EnumSelectionTypeWithAggregatesFilter>;
    usesOrder?: InputMaybe<BoolWithAggregatesFilter>;
};

export type EhrAppointmentTypeIdToNameSumAggregate = {
    __typename?: 'EhrAppointmentTypeIdToNameSumAggregate';
    candidateHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    duration?: Maybe<Scalars['Int']['output']>;
    hrts?: Maybe<Array<Scalars['Int']['output']>>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrAppointmentTypeIdToNameSumOrderByAggregateInput = {
    candidateHrtIds?: InputMaybe<SortOrder>;
    duration?: InputMaybe<SortOrder>;
    hrts?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrAppointmentTypeIdToNameUpdateInput = {
    candidateHrtIds?: InputMaybe<EhrAppointmentTypeIdToNameUpdatecandidateHrtIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    duration?: InputMaybe<IntFieldUpdateOperationsInput>;
    ehrAppointmentTypeName?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<StringFieldUpdateOperationsInput>;
    hrts?: InputMaybe<EhrAppointmentTypeIdToNameUpdatehrtsInput>;
    isGeneric?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isVirtual?: InputMaybe<BoolFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    prompt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    selectionPriority?: InputMaybe<EnumSelectionPriorityFieldUpdateOperationsInput>;
    selectionType?: InputMaybe<EnumSelectionTypeFieldUpdateOperationsInput>;
    usesOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EhrAppointmentTypeIdToNameUpdateManyMutationInput = {
    candidateHrtIds?: InputMaybe<EhrAppointmentTypeIdToNameUpdatecandidateHrtIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    duration?: InputMaybe<IntFieldUpdateOperationsInput>;
    ehrAppointmentTypeName?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<StringFieldUpdateOperationsInput>;
    hrts?: InputMaybe<EhrAppointmentTypeIdToNameUpdatehrtsInput>;
    isGeneric?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isVirtual?: InputMaybe<BoolFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    prompt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    selectionPriority?: InputMaybe<EnumSelectionPriorityFieldUpdateOperationsInput>;
    selectionType?: InputMaybe<EnumSelectionTypeFieldUpdateOperationsInput>;
    usesOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EhrAppointmentTypeIdToNameUpdatecandidateHrtIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EhrAppointmentTypeIdToNameUpdatehrtsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EhrAppointmentTypeIdToNameWhereInput = {
    AND?: InputMaybe<Array<EhrAppointmentTypeIdToNameWhereInput>>;
    NOT?: InputMaybe<Array<EhrAppointmentTypeIdToNameWhereInput>>;
    OR?: InputMaybe<Array<EhrAppointmentTypeIdToNameWhereInput>>;
    candidateHrtIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    duration?: InputMaybe<IntFilter>;
    ehrAppointmentTypeName?: InputMaybe<StringFilter>;
    ehrDepartmentId?: InputMaybe<StringNullableFilter>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<StringFilter>;
    hrts?: InputMaybe<IntNullableListFilter>;
    id?: InputMaybe<IntFilter>;
    isGeneric?: InputMaybe<BoolFilter>;
    isVirtual?: InputMaybe<BoolFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    prompt?: InputMaybe<StringNullableFilter>;
    selectionPriority?: InputMaybe<EnumSelectionPriorityFilter>;
    selectionType?: InputMaybe<EnumSelectionTypeFilter>;
    usesOrder?: InputMaybe<BoolFilter>;
};

export type EhrAppointmentTypeIdToNameWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrAppointmentTypeIdToNameWhereInput>>;
    NOT?: InputMaybe<Array<EhrAppointmentTypeIdToNameWhereInput>>;
    OR?: InputMaybe<Array<EhrAppointmentTypeIdToNameWhereInput>>;
    candidateHrtIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    duration?: InputMaybe<IntFilter>;
    ehrAppointmentTypeName?: InputMaybe<StringFilter>;
    ehrDepartmentId?: InputMaybe<StringNullableFilter>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<StringFilter>;
    ehr_appointment_type_id_to_name?: InputMaybe<EhrAppointmentTypeIdToNameEhrAppointmentTypeIdToNameCompoundUniqueInput>;
    hrts?: InputMaybe<IntNullableListFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isGeneric?: InputMaybe<BoolFilter>;
    isVirtual?: InputMaybe<BoolFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    prompt?: InputMaybe<StringNullableFilter>;
    selectionPriority?: InputMaybe<EnumSelectionPriorityFilter>;
    selectionType?: InputMaybe<EnumSelectionTypeFilter>;
    usesOrder?: InputMaybe<BoolFilter>;
};

export type EhrPaymentDescriptor = {
    __typename?: 'EhrPaymentDescriptor';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrContextId: Scalars['String']['output'];
    /**
     * athena's `epaymentid` for an ATHENA_CARD charge (Credit Card Plus). A
     * co-equal lookup key next to `ehrPaymentId` (patientpaymentid): the charge
     * call returns it at once, so fences can recognise the payment before
     * patientpaymentid resolves. Null on every other lock type.
     */
    ehrEpaymentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    isLocked: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lockType: EhrPaymentLockTypeEnum;
    originalEhrAppointmentId?: Maybe<Scalars['String']['output']>;
    originalEhrClaimId?: Maybe<Scalars['String']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
    resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status: EhrPaymentDescriptorStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

/**
 * Mirrors ehr_payment_descriptor via the track_ehr_payment_descriptor_changes
 * trigger (AFTER INSERT OR UPDATE) — see the log_bought_treatment_changes
 * precedent for the pattern. Queryable audit trail; no application code
 * writes to this table directly.
 */
export type EhrPaymentDescriptorAuditLog = {
    __typename?: 'EhrPaymentDescriptorAuditLog';
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentDescriptorId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    isLocked?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lockType?: Maybe<EhrPaymentLockTypeEnum>;
    operation?: Maybe<Scalars['String']['output']>;
    originalEhrAppointmentId?: Maybe<Scalars['String']['output']>;
    originalEhrClaimId?: Maybe<Scalars['String']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
    resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<EhrPaymentDescriptorStatusEnum>;
};

export type EhrPaymentDescriptorAuditLogAvgAggregate = {
    __typename?: 'EhrPaymentDescriptorAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    originalOrgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrPaymentDescriptorAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    originalOrgId?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorAuditLogCountAggregate = {
    __typename?: 'EhrPaymentDescriptorAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    ehrContextId: Scalars['Int']['output'];
    ehrPatientId: Scalars['Int']['output'];
    ehrPaymentDescriptorId: Scalars['Int']['output'];
    ehrPaymentId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isLocked: Scalars['Int']['output'];
    lastUpdatedAt: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    lockType: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    originalEhrAppointmentId: Scalars['Int']['output'];
    originalEhrClaimId: Scalars['Int']['output'];
    originalOrgId: Scalars['Int']['output'];
    resolvedAt: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
};

export type EhrPaymentDescriptorAuditLogCountOrderByAggregateInput = {
    ehrContextId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentDescriptorId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isLocked?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lockType?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    originalEhrAppointmentId?: InputMaybe<SortOrder>;
    originalEhrClaimId?: InputMaybe<SortOrder>;
    originalOrgId?: InputMaybe<SortOrder>;
    resolvedAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorAuditLogCreateInput = {
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    ehrPaymentDescriptorId?: InputMaybe<Scalars['String']['input']>;
    ehrPaymentId?: InputMaybe<Scalars['String']['input']>;
    isLocked?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lockType?: InputMaybe<EhrPaymentLockTypeEnum>;
    operation?: InputMaybe<Scalars['String']['input']>;
    originalEhrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    originalEhrClaimId?: InputMaybe<Scalars['String']['input']>;
    originalOrgId?: InputMaybe<Scalars['Int']['input']>;
    resolvedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    status?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
};

export type EhrPaymentDescriptorAuditLogCreateManyInput = {
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    ehrPaymentDescriptorId?: InputMaybe<Scalars['String']['input']>;
    ehrPaymentId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isLocked?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lockType?: InputMaybe<EhrPaymentLockTypeEnum>;
    operation?: InputMaybe<Scalars['String']['input']>;
    originalEhrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    originalEhrClaimId?: InputMaybe<Scalars['String']['input']>;
    originalOrgId?: InputMaybe<Scalars['Int']['input']>;
    resolvedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    status?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
};

export type EhrPaymentDescriptorAuditLogGroupBy = {
    __typename?: 'EhrPaymentDescriptorAuditLogGroupBy';
    _avg?: Maybe<EhrPaymentDescriptorAuditLogAvgAggregate>;
    _count?: Maybe<EhrPaymentDescriptorAuditLogCountAggregate>;
    _max?: Maybe<EhrPaymentDescriptorAuditLogMaxAggregate>;
    _min?: Maybe<EhrPaymentDescriptorAuditLogMinAggregate>;
    _sum?: Maybe<EhrPaymentDescriptorAuditLogSumAggregate>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentDescriptorId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    isLocked?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lockType?: Maybe<EhrPaymentLockTypeEnum>;
    operation?: Maybe<Scalars['String']['output']>;
    originalEhrAppointmentId?: Maybe<Scalars['String']['output']>;
    originalEhrClaimId?: Maybe<Scalars['String']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
    resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<EhrPaymentDescriptorStatusEnum>;
};

export type EhrPaymentDescriptorAuditLogMaxAggregate = {
    __typename?: 'EhrPaymentDescriptorAuditLogMaxAggregate';
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentDescriptorId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isLocked?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lockType?: Maybe<EhrPaymentLockTypeEnum>;
    operation?: Maybe<Scalars['String']['output']>;
    originalEhrAppointmentId?: Maybe<Scalars['String']['output']>;
    originalEhrClaimId?: Maybe<Scalars['String']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
    resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<EhrPaymentDescriptorStatusEnum>;
};

export type EhrPaymentDescriptorAuditLogMaxOrderByAggregateInput = {
    ehrContextId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentDescriptorId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isLocked?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lockType?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    originalEhrAppointmentId?: InputMaybe<SortOrder>;
    originalEhrClaimId?: InputMaybe<SortOrder>;
    originalOrgId?: InputMaybe<SortOrder>;
    resolvedAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorAuditLogMinAggregate = {
    __typename?: 'EhrPaymentDescriptorAuditLogMinAggregate';
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentDescriptorId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isLocked?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lockType?: Maybe<EhrPaymentLockTypeEnum>;
    operation?: Maybe<Scalars['String']['output']>;
    originalEhrAppointmentId?: Maybe<Scalars['String']['output']>;
    originalEhrClaimId?: Maybe<Scalars['String']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
    resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<EhrPaymentDescriptorStatusEnum>;
};

export type EhrPaymentDescriptorAuditLogMinOrderByAggregateInput = {
    ehrContextId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentDescriptorId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isLocked?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lockType?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    originalEhrAppointmentId?: InputMaybe<SortOrder>;
    originalEhrClaimId?: InputMaybe<SortOrder>;
    originalOrgId?: InputMaybe<SortOrder>;
    resolvedAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrPaymentDescriptorAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrPaymentDescriptorAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrPaymentDescriptorAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrPaymentDescriptorAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrPaymentDescriptorAuditLogSumOrderByAggregateInput>;
    ehrContextId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrderInput>;
    ehrPaymentDescriptorId?: InputMaybe<SortOrderInput>;
    ehrPaymentId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isLocked?: InputMaybe<SortOrderInput>;
    lastUpdatedAt?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    lockType?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    originalEhrAppointmentId?: InputMaybe<SortOrderInput>;
    originalEhrClaimId?: InputMaybe<SortOrderInput>;
    originalOrgId?: InputMaybe<SortOrderInput>;
    resolvedAt?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
};

export type EhrPaymentDescriptorAuditLogOrderByWithRelationInput = {
    ehrContextId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrderInput>;
    ehrPaymentDescriptorId?: InputMaybe<SortOrderInput>;
    ehrPaymentId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isLocked?: InputMaybe<SortOrderInput>;
    lastUpdatedAt?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    lockType?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    originalEhrAppointmentId?: InputMaybe<SortOrderInput>;
    originalEhrClaimId?: InputMaybe<SortOrderInput>;
    originalOrgId?: InputMaybe<SortOrderInput>;
    resolvedAt?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
};

export enum EhrPaymentDescriptorAuditLogScalarFieldEnum {
    EhrContextId = 'ehrContextId',
    EhrPatientId = 'ehrPatientId',
    EhrPaymentDescriptorId = 'ehrPaymentDescriptorId',
    EhrPaymentId = 'ehrPaymentId',
    Id = 'id',
    IsLocked = 'isLocked',
    LastUpdatedAt = 'lastUpdatedAt',
    LastUpdatedBy = 'lastUpdatedBy',
    LockType = 'lockType',
    Operation = 'operation',
    OriginalEhrAppointmentId = 'originalEhrAppointmentId',
    OriginalEhrClaimId = 'originalEhrClaimId',
    OriginalOrgId = 'originalOrgId',
    ResolvedAt = 'resolvedAt',
    Status = 'status',
}

export type EhrPaymentDescriptorAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<EhrPaymentDescriptorAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<EhrPaymentDescriptorAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<EhrPaymentDescriptorAuditLogScalarWhereWithAggregatesInput>
    >;
    ehrContextId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPatientId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPaymentDescriptorId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    ehrPaymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isLocked?: InputMaybe<BoolNullableWithAggregatesFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    lockType?: InputMaybe<EnumEhrPaymentLockTypeEnumNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringNullableWithAggregatesFilter>;
    originalEhrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    originalEhrClaimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    originalOrgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    resolvedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumEhrPaymentDescriptorStatusEnumNullableWithAggregatesFilter>;
};

export type EhrPaymentDescriptorAuditLogSumAggregate = {
    __typename?: 'EhrPaymentDescriptorAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrPaymentDescriptorAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    originalOrgId?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorAuditLogUpdateInput = {
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPaymentDescriptorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isLocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lockType?: InputMaybe<NullableEnumEhrPaymentLockTypeEnumFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    originalEhrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    originalEhrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    originalOrgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumEhrPaymentDescriptorStatusEnumFieldUpdateOperationsInput>;
};

export type EhrPaymentDescriptorAuditLogUpdateManyMutationInput = {
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPaymentDescriptorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isLocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lockType?: InputMaybe<NullableEnumEhrPaymentLockTypeEnumFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    originalEhrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    originalEhrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    originalOrgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumEhrPaymentDescriptorStatusEnumFieldUpdateOperationsInput>;
};

export type EhrPaymentDescriptorAuditLogWhereInput = {
    AND?: InputMaybe<Array<EhrPaymentDescriptorAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<EhrPaymentDescriptorAuditLogWhereInput>>;
    OR?: InputMaybe<Array<EhrPaymentDescriptorAuditLogWhereInput>>;
    ehrContextId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    ehrPaymentDescriptorId?: InputMaybe<UuidNullableFilter>;
    ehrPaymentId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    isLocked?: InputMaybe<BoolNullableFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    lockType?: InputMaybe<EnumEhrPaymentLockTypeEnumNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    originalEhrAppointmentId?: InputMaybe<StringNullableFilter>;
    originalEhrClaimId?: InputMaybe<StringNullableFilter>;
    originalOrgId?: InputMaybe<IntNullableFilter>;
    resolvedAt?: InputMaybe<DateTimeNullableFilter>;
    status?: InputMaybe<EnumEhrPaymentDescriptorStatusEnumNullableFilter>;
};

export type EhrPaymentDescriptorAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrPaymentDescriptorAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<EhrPaymentDescriptorAuditLogWhereInput>>;
    OR?: InputMaybe<Array<EhrPaymentDescriptorAuditLogWhereInput>>;
    ehrContextId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    ehrPaymentDescriptorId?: InputMaybe<UuidNullableFilter>;
    ehrPaymentId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isLocked?: InputMaybe<BoolNullableFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    lockType?: InputMaybe<EnumEhrPaymentLockTypeEnumNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    originalEhrAppointmentId?: InputMaybe<StringNullableFilter>;
    originalEhrClaimId?: InputMaybe<StringNullableFilter>;
    originalOrgId?: InputMaybe<IntNullableFilter>;
    resolvedAt?: InputMaybe<DateTimeNullableFilter>;
    status?: InputMaybe<EnumEhrPaymentDescriptorStatusEnumNullableFilter>;
};

export type EhrPaymentDescriptorAvgAggregate = {
    __typename?: 'EhrPaymentDescriptorAvgAggregate';
    originalOrgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrPaymentDescriptorAvgOrderByAggregateInput = {
    originalOrgId?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorCountAggregate = {
    __typename?: 'EhrPaymentDescriptorCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrContextId: Scalars['Int']['output'];
    ehrEpaymentId: Scalars['Int']['output'];
    ehrPatientId: Scalars['Int']['output'];
    ehrPaymentId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isLocked: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    lockType: Scalars['Int']['output'];
    originalEhrAppointmentId: Scalars['Int']['output'];
    originalEhrClaimId: Scalars['Int']['output'];
    originalOrgId: Scalars['Int']['output'];
    resolvedAt: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type EhrPaymentDescriptorCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrEpaymentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isLocked?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lockType?: InputMaybe<SortOrder>;
    originalEhrAppointmentId?: InputMaybe<SortOrder>;
    originalEhrClaimId?: InputMaybe<SortOrder>;
    originalOrgId?: InputMaybe<SortOrder>;
    resolvedAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrContextId: Scalars['String']['input'];
    ehrEpaymentId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    ehrPaymentId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    isLocked?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lockType: EhrPaymentLockTypeEnum;
    originalEhrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    originalEhrClaimId?: InputMaybe<Scalars['String']['input']>;
    originalOrgId?: InputMaybe<Scalars['Int']['input']>;
    resolvedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    status?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPaymentDescriptorCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrContextId: Scalars['String']['input'];
    ehrEpaymentId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    ehrPaymentId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    isLocked?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lockType: EhrPaymentLockTypeEnum;
    originalEhrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    originalEhrClaimId?: InputMaybe<Scalars['String']['input']>;
    originalOrgId?: InputMaybe<Scalars['Int']['input']>;
    resolvedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    status?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPaymentDescriptorEhrPaymentIdEhrContextIdCompoundUniqueInput = {
    ehrContextId: Scalars['String']['input'];
    ehrPaymentId: Scalars['String']['input'];
};

export type EhrPaymentDescriptorGroupBy = {
    __typename?: 'EhrPaymentDescriptorGroupBy';
    _avg?: Maybe<EhrPaymentDescriptorAvgAggregate>;
    _count?: Maybe<EhrPaymentDescriptorCountAggregate>;
    _max?: Maybe<EhrPaymentDescriptorMaxAggregate>;
    _min?: Maybe<EhrPaymentDescriptorMinAggregate>;
    _sum?: Maybe<EhrPaymentDescriptorSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrContextId: Scalars['String']['output'];
    ehrEpaymentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    isLocked: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lockType: EhrPaymentLockTypeEnum;
    originalEhrAppointmentId?: Maybe<Scalars['String']['output']>;
    originalEhrClaimId?: Maybe<Scalars['String']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
    resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status: EhrPaymentDescriptorStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrPaymentDescriptorMaxAggregate = {
    __typename?: 'EhrPaymentDescriptorMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrEpaymentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isLocked?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lockType?: Maybe<EhrPaymentLockTypeEnum>;
    originalEhrAppointmentId?: Maybe<Scalars['String']['output']>;
    originalEhrClaimId?: Maybe<Scalars['String']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
    resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<EhrPaymentDescriptorStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPaymentDescriptorMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrEpaymentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isLocked?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lockType?: InputMaybe<SortOrder>;
    originalEhrAppointmentId?: InputMaybe<SortOrder>;
    originalEhrClaimId?: InputMaybe<SortOrder>;
    originalOrgId?: InputMaybe<SortOrder>;
    resolvedAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorMinAggregate = {
    __typename?: 'EhrPaymentDescriptorMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrEpaymentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isLocked?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lockType?: Maybe<EhrPaymentLockTypeEnum>;
    originalEhrAppointmentId?: Maybe<Scalars['String']['output']>;
    originalEhrClaimId?: Maybe<Scalars['String']['output']>;
    originalOrgId?: Maybe<Scalars['Int']['output']>;
    resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<EhrPaymentDescriptorStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPaymentDescriptorMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrEpaymentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isLocked?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lockType?: InputMaybe<SortOrder>;
    originalEhrAppointmentId?: InputMaybe<SortOrder>;
    originalEhrClaimId?: InputMaybe<SortOrder>;
    originalOrgId?: InputMaybe<SortOrder>;
    resolvedAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrPaymentDescriptorAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrPaymentDescriptorCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrPaymentDescriptorMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrPaymentDescriptorMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrPaymentDescriptorSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrEpaymentId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrderInput>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isLocked?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    lockType?: InputMaybe<SortOrder>;
    originalEhrAppointmentId?: InputMaybe<SortOrderInput>;
    originalEhrClaimId?: InputMaybe<SortOrderInput>;
    originalOrgId?: InputMaybe<SortOrderInput>;
    resolvedAt?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrEpaymentId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrderInput>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isLocked?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    lockType?: InputMaybe<SortOrder>;
    originalEhrAppointmentId?: InputMaybe<SortOrderInput>;
    originalEhrClaimId?: InputMaybe<SortOrderInput>;
    originalOrgId?: InputMaybe<SortOrderInput>;
    resolvedAt?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum EhrPaymentDescriptorScalarFieldEnum {
    CreatedAt = 'createdAt',
    EhrContextId = 'ehrContextId',
    EhrEpaymentId = 'ehrEpaymentId',
    EhrPatientId = 'ehrPatientId',
    EhrPaymentId = 'ehrPaymentId',
    Id = 'id',
    IsLocked = 'isLocked',
    LastUpdatedBy = 'lastUpdatedBy',
    LockType = 'lockType',
    OriginalEhrAppointmentId = 'originalEhrAppointmentId',
    OriginalEhrClaimId = 'originalEhrClaimId',
    OriginalOrgId = 'originalOrgId',
    ResolvedAt = 'resolvedAt',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type EhrPaymentDescriptorScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<EhrPaymentDescriptorScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<EhrPaymentDescriptorScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<EhrPaymentDescriptorScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrContextId?: InputMaybe<StringWithAggregatesFilter>;
    ehrEpaymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPatientId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPaymentId?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    isLocked?: InputMaybe<BoolWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    lockType?: InputMaybe<EnumEhrPaymentLockTypeEnumWithAggregatesFilter>;
    originalEhrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    originalEhrClaimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    originalOrgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    resolvedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumEhrPaymentDescriptorStatusEnumWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum EhrPaymentDescriptorStatusEnum {
    Ongoing = 'ONGOING',
    Resolved = 'RESOLVED',
    Voided = 'VOIDED',
}

export type EhrPaymentDescriptorSumAggregate = {
    __typename?: 'EhrPaymentDescriptorSumAggregate';
    originalOrgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrPaymentDescriptorSumOrderByAggregateInput = {
    originalOrgId?: InputMaybe<SortOrder>;
};

export type EhrPaymentDescriptorUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrEpaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isLocked?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lockType?: InputMaybe<EnumEhrPaymentLockTypeEnumFieldUpdateOperationsInput>;
    originalEhrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    originalEhrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    originalOrgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEhrPaymentDescriptorStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrPaymentDescriptorUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrEpaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isLocked?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lockType?: InputMaybe<EnumEhrPaymentLockTypeEnumFieldUpdateOperationsInput>;
    originalEhrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    originalEhrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    originalOrgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEhrPaymentDescriptorStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrPaymentDescriptorWhereInput = {
    AND?: InputMaybe<Array<EhrPaymentDescriptorWhereInput>>;
    NOT?: InputMaybe<Array<EhrPaymentDescriptorWhereInput>>;
    OR?: InputMaybe<Array<EhrPaymentDescriptorWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrContextId?: InputMaybe<StringFilter>;
    ehrEpaymentId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    ehrPaymentId?: InputMaybe<StringFilter>;
    id?: InputMaybe<UuidFilter>;
    isLocked?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    lockType?: InputMaybe<EnumEhrPaymentLockTypeEnumFilter>;
    originalEhrAppointmentId?: InputMaybe<StringNullableFilter>;
    originalEhrClaimId?: InputMaybe<StringNullableFilter>;
    originalOrgId?: InputMaybe<IntNullableFilter>;
    resolvedAt?: InputMaybe<DateTimeNullableFilter>;
    status?: InputMaybe<EnumEhrPaymentDescriptorStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrPaymentDescriptorWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrPaymentDescriptorWhereInput>>;
    NOT?: InputMaybe<Array<EhrPaymentDescriptorWhereInput>>;
    OR?: InputMaybe<Array<EhrPaymentDescriptorWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrContextId?: InputMaybe<StringFilter>;
    ehrEpaymentId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    ehrPaymentId?: InputMaybe<StringFilter>;
    ehrPaymentId_ehrContextId?: InputMaybe<EhrPaymentDescriptorEhrPaymentIdEhrContextIdCompoundUniqueInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    isLocked?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    lockType?: InputMaybe<EnumEhrPaymentLockTypeEnumFilter>;
    originalEhrAppointmentId?: InputMaybe<StringNullableFilter>;
    originalEhrClaimId?: InputMaybe<StringNullableFilter>;
    originalOrgId?: InputMaybe<IntNullableFilter>;
    resolvedAt?: InputMaybe<DateTimeNullableFilter>;
    status?: InputMaybe<EnumEhrPaymentDescriptorStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

/**
 * The SS-side record of each internal-asset move decided by misroute
 * reattribution — where money moved FROM and TO on OUR books, per EHR
 * payment. One row per executed source→destination movement; written by
 * the misroute reattribution endpoint (a later PR) via
 * EhrPaymentDirectionSsAssetService.createManyBestEffort. Differs from
 * ReattributionDirection (ledger-row-level: charge/transaction/payout) by
 * operating at the internal-asset level (org/claim/visit/unapplied-BT).
 */
export type EhrPaymentDirectionSsAsset = {
    __typename?: 'EhrPaymentDirectionSsAsset';
    amount: Scalars['Float']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    destinationBoughtTreatmentIds: Array<Scalars['String']['output']>;
    destinationEhrClaimId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    destinationMcmsAssociationId?: Maybe<Scalars['String']['output']>;
    destinationOrgId: Scalars['Int']['output'];
    destinationUnappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    ehrContextId: Scalars['String']['output'];
    ehrPaymentId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    sourceBoughtTreatmentIds: Array<Scalars['String']['output']>;
    sourceEhrClaimId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    sourceEhrVisitId?: Maybe<Scalars['String']['output']>;
    sourceMcmsAssociationId?: Maybe<Scalars['String']['output']>;
    sourceOrgId: Scalars['Int']['output'];
    sourceUnappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrPaymentDirectionSsAssetAvgAggregate = {
    __typename?: 'EhrPaymentDirectionSsAssetAvgAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    destinationOrgId?: Maybe<Scalars['Float']['output']>;
    sourceOrgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrPaymentDirectionSsAssetAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    destinationOrgId?: InputMaybe<SortOrder>;
    sourceOrgId?: InputMaybe<SortOrder>;
};

export type EhrPaymentDirectionSsAssetCountAggregate = {
    __typename?: 'EhrPaymentDirectionSsAssetCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    destinationBoughtTreatmentIds: Scalars['Int']['output'];
    destinationEhrClaimId: Scalars['Int']['output'];
    destinationEhrPostLedgerId: Scalars['Int']['output'];
    destinationMcmsAssociationId: Scalars['Int']['output'];
    destinationOrgId: Scalars['Int']['output'];
    destinationUnappliedBoughtTreatmentId: Scalars['Int']['output'];
    ehrContextId: Scalars['Int']['output'];
    ehrPaymentId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    sourceBoughtTreatmentIds: Scalars['Int']['output'];
    sourceEhrClaimId: Scalars['Int']['output'];
    sourceEhrPostLedgerId: Scalars['Int']['output'];
    sourceEhrVisitId: Scalars['Int']['output'];
    sourceMcmsAssociationId: Scalars['Int']['output'];
    sourceOrgId: Scalars['Int']['output'];
    sourceUnappliedBoughtTreatmentId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type EhrPaymentDirectionSsAssetCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    destinationBoughtTreatmentIds?: InputMaybe<SortOrder>;
    destinationEhrClaimId?: InputMaybe<SortOrder>;
    destinationEhrPostLedgerId?: InputMaybe<SortOrder>;
    destinationMcmsAssociationId?: InputMaybe<SortOrder>;
    destinationOrgId?: InputMaybe<SortOrder>;
    destinationUnappliedBoughtTreatmentId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    sourceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    sourceEhrClaimId?: InputMaybe<SortOrder>;
    sourceEhrPostLedgerId?: InputMaybe<SortOrder>;
    sourceEhrVisitId?: InputMaybe<SortOrder>;
    sourceMcmsAssociationId?: InputMaybe<SortOrder>;
    sourceOrgId?: InputMaybe<SortOrder>;
    sourceUnappliedBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPaymentDirectionSsAssetCreateInput = {
    amount: Scalars['Float']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    destinationBoughtTreatmentIds?: InputMaybe<EhrPaymentDirectionSsAssetCreatedestinationBoughtTreatmentIdsInput>;
    destinationEhrClaimId?: InputMaybe<Scalars['String']['input']>;
    destinationEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    destinationMcmsAssociationId?: InputMaybe<Scalars['String']['input']>;
    destinationOrgId: Scalars['Int']['input'];
    destinationUnappliedBoughtTreatmentId?: InputMaybe<
        Scalars['String']['input']
    >;
    ehrContextId: Scalars['String']['input'];
    ehrPaymentId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    sourceBoughtTreatmentIds?: InputMaybe<EhrPaymentDirectionSsAssetCreatesourceBoughtTreatmentIdsInput>;
    sourceEhrClaimId?: InputMaybe<Scalars['String']['input']>;
    sourceEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    sourceEhrVisitId?: InputMaybe<Scalars['String']['input']>;
    sourceMcmsAssociationId?: InputMaybe<Scalars['String']['input']>;
    sourceOrgId: Scalars['Int']['input'];
    sourceUnappliedBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPaymentDirectionSsAssetCreateManyInput = {
    amount: Scalars['Float']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    destinationBoughtTreatmentIds?: InputMaybe<EhrPaymentDirectionSsAssetCreatedestinationBoughtTreatmentIdsInput>;
    destinationEhrClaimId?: InputMaybe<Scalars['String']['input']>;
    destinationEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    destinationMcmsAssociationId?: InputMaybe<Scalars['String']['input']>;
    destinationOrgId: Scalars['Int']['input'];
    destinationUnappliedBoughtTreatmentId?: InputMaybe<
        Scalars['String']['input']
    >;
    ehrContextId: Scalars['String']['input'];
    ehrPaymentId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    sourceBoughtTreatmentIds?: InputMaybe<EhrPaymentDirectionSsAssetCreatesourceBoughtTreatmentIdsInput>;
    sourceEhrClaimId?: InputMaybe<Scalars['String']['input']>;
    sourceEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    sourceEhrVisitId?: InputMaybe<Scalars['String']['input']>;
    sourceMcmsAssociationId?: InputMaybe<Scalars['String']['input']>;
    sourceOrgId: Scalars['Int']['input'];
    sourceUnappliedBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPaymentDirectionSsAssetCreatedestinationBoughtTreatmentIdsInput =
    {
        set: Array<Scalars['String']['input']>;
    };

export type EhrPaymentDirectionSsAssetCreatesourceBoughtTreatmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EhrPaymentDirectionSsAssetGroupBy = {
    __typename?: 'EhrPaymentDirectionSsAssetGroupBy';
    _avg?: Maybe<EhrPaymentDirectionSsAssetAvgAggregate>;
    _count?: Maybe<EhrPaymentDirectionSsAssetCountAggregate>;
    _max?: Maybe<EhrPaymentDirectionSsAssetMaxAggregate>;
    _min?: Maybe<EhrPaymentDirectionSsAssetMinAggregate>;
    _sum?: Maybe<EhrPaymentDirectionSsAssetSumAggregate>;
    amount: Scalars['Float']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    destinationBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    destinationEhrClaimId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    destinationMcmsAssociationId?: Maybe<Scalars['String']['output']>;
    destinationOrgId: Scalars['Int']['output'];
    destinationUnappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    ehrContextId: Scalars['String']['output'];
    ehrPaymentId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    sourceBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    sourceEhrClaimId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    sourceEhrVisitId?: Maybe<Scalars['String']['output']>;
    sourceMcmsAssociationId?: Maybe<Scalars['String']['output']>;
    sourceOrgId: Scalars['Int']['output'];
    sourceUnappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrPaymentDirectionSsAssetMaxAggregate = {
    __typename?: 'EhrPaymentDirectionSsAssetMaxAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationEhrClaimId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    destinationMcmsAssociationId?: Maybe<Scalars['String']['output']>;
    destinationOrgId?: Maybe<Scalars['Int']['output']>;
    destinationUnappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    sourceEhrClaimId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    sourceEhrVisitId?: Maybe<Scalars['String']['output']>;
    sourceMcmsAssociationId?: Maybe<Scalars['String']['output']>;
    sourceOrgId?: Maybe<Scalars['Int']['output']>;
    sourceUnappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPaymentDirectionSsAssetMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    destinationEhrClaimId?: InputMaybe<SortOrder>;
    destinationEhrPostLedgerId?: InputMaybe<SortOrder>;
    destinationMcmsAssociationId?: InputMaybe<SortOrder>;
    destinationOrgId?: InputMaybe<SortOrder>;
    destinationUnappliedBoughtTreatmentId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    sourceEhrClaimId?: InputMaybe<SortOrder>;
    sourceEhrPostLedgerId?: InputMaybe<SortOrder>;
    sourceEhrVisitId?: InputMaybe<SortOrder>;
    sourceMcmsAssociationId?: InputMaybe<SortOrder>;
    sourceOrgId?: InputMaybe<SortOrder>;
    sourceUnappliedBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPaymentDirectionSsAssetMinAggregate = {
    __typename?: 'EhrPaymentDirectionSsAssetMinAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationEhrClaimId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    destinationMcmsAssociationId?: Maybe<Scalars['String']['output']>;
    destinationOrgId?: Maybe<Scalars['Int']['output']>;
    destinationUnappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    sourceEhrClaimId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    sourceEhrVisitId?: Maybe<Scalars['String']['output']>;
    sourceMcmsAssociationId?: Maybe<Scalars['String']['output']>;
    sourceOrgId?: Maybe<Scalars['Int']['output']>;
    sourceUnappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPaymentDirectionSsAssetMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    destinationEhrClaimId?: InputMaybe<SortOrder>;
    destinationEhrPostLedgerId?: InputMaybe<SortOrder>;
    destinationMcmsAssociationId?: InputMaybe<SortOrder>;
    destinationOrgId?: InputMaybe<SortOrder>;
    destinationUnappliedBoughtTreatmentId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    sourceEhrClaimId?: InputMaybe<SortOrder>;
    sourceEhrPostLedgerId?: InputMaybe<SortOrder>;
    sourceEhrVisitId?: InputMaybe<SortOrder>;
    sourceMcmsAssociationId?: InputMaybe<SortOrder>;
    sourceOrgId?: InputMaybe<SortOrder>;
    sourceUnappliedBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPaymentDirectionSsAssetOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrPaymentDirectionSsAssetAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrPaymentDirectionSsAssetCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrPaymentDirectionSsAssetMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrPaymentDirectionSsAssetMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrPaymentDirectionSsAssetSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    destinationBoughtTreatmentIds?: InputMaybe<SortOrder>;
    destinationEhrClaimId?: InputMaybe<SortOrderInput>;
    destinationEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    destinationMcmsAssociationId?: InputMaybe<SortOrderInput>;
    destinationOrgId?: InputMaybe<SortOrder>;
    destinationUnappliedBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    sourceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    sourceEhrClaimId?: InputMaybe<SortOrderInput>;
    sourceEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    sourceEhrVisitId?: InputMaybe<SortOrderInput>;
    sourceMcmsAssociationId?: InputMaybe<SortOrderInput>;
    sourceOrgId?: InputMaybe<SortOrder>;
    sourceUnappliedBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPaymentDirectionSsAssetOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    destinationBoughtTreatmentIds?: InputMaybe<SortOrder>;
    destinationEhrClaimId?: InputMaybe<SortOrderInput>;
    destinationEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    destinationMcmsAssociationId?: InputMaybe<SortOrderInput>;
    destinationOrgId?: InputMaybe<SortOrder>;
    destinationUnappliedBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    sourceBoughtTreatmentIds?: InputMaybe<SortOrder>;
    sourceEhrClaimId?: InputMaybe<SortOrderInput>;
    sourceEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    sourceEhrVisitId?: InputMaybe<SortOrderInput>;
    sourceMcmsAssociationId?: InputMaybe<SortOrderInput>;
    sourceOrgId?: InputMaybe<SortOrder>;
    sourceUnappliedBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum EhrPaymentDirectionSsAssetScalarFieldEnum {
    Amount = 'amount',
    CreatedAt = 'createdAt',
    DestinationBoughtTreatmentIds = 'destinationBoughtTreatmentIds',
    DestinationEhrClaimId = 'destinationEhrClaimId',
    DestinationEhrPostLedgerId = 'destinationEhrPostLedgerId',
    DestinationMcmsAssociationId = 'destinationMcmsAssociationId',
    DestinationOrgId = 'destinationOrgId',
    DestinationUnappliedBoughtTreatmentId = 'destinationUnappliedBoughtTreatmentId',
    EhrContextId = 'ehrContextId',
    EhrPaymentId = 'ehrPaymentId',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    SourceBoughtTreatmentIds = 'sourceBoughtTreatmentIds',
    SourceEhrClaimId = 'sourceEhrClaimId',
    SourceEhrPostLedgerId = 'sourceEhrPostLedgerId',
    SourceEhrVisitId = 'sourceEhrVisitId',
    SourceMcmsAssociationId = 'sourceMcmsAssociationId',
    SourceOrgId = 'sourceOrgId',
    SourceUnappliedBoughtTreatmentId = 'sourceUnappliedBoughtTreatmentId',
    UpdatedAt = 'updatedAt',
}

export type EhrPaymentDirectionSsAssetScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<EhrPaymentDirectionSsAssetScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<EhrPaymentDirectionSsAssetScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<EhrPaymentDirectionSsAssetScalarWhereWithAggregatesInput>
    >;
    amount?: InputMaybe<FloatWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    destinationBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    destinationEhrClaimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    destinationEhrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    destinationMcmsAssociationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    destinationOrgId?: InputMaybe<IntWithAggregatesFilter>;
    destinationUnappliedBoughtTreatmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrContextId?: InputMaybe<StringWithAggregatesFilter>;
    ehrPaymentId?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    sourceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    sourceEhrClaimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    sourceEhrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    sourceEhrVisitId?: InputMaybe<StringNullableWithAggregatesFilter>;
    sourceMcmsAssociationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    sourceOrgId?: InputMaybe<IntWithAggregatesFilter>;
    sourceUnappliedBoughtTreatmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EhrPaymentDirectionSsAssetSumAggregate = {
    __typename?: 'EhrPaymentDirectionSsAssetSumAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    destinationOrgId?: Maybe<Scalars['Int']['output']>;
    sourceOrgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrPaymentDirectionSsAssetSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    destinationOrgId?: InputMaybe<SortOrder>;
    sourceOrgId?: InputMaybe<SortOrder>;
};

export type EhrPaymentDirectionSsAssetUpdateInput = {
    amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationBoughtTreatmentIds?: InputMaybe<EhrPaymentDirectionSsAssetUpdatedestinationBoughtTreatmentIdsInput>;
    destinationEhrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationMcmsAssociationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationOrgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    destinationUnappliedBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceBoughtTreatmentIds?: InputMaybe<EhrPaymentDirectionSsAssetUpdatesourceBoughtTreatmentIdsInput>;
    sourceEhrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceEhrVisitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceMcmsAssociationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceOrgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    sourceUnappliedBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrPaymentDirectionSsAssetUpdateManyMutationInput = {
    amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationBoughtTreatmentIds?: InputMaybe<EhrPaymentDirectionSsAssetUpdatedestinationBoughtTreatmentIdsInput>;
    destinationEhrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationMcmsAssociationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationOrgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    destinationUnappliedBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceBoughtTreatmentIds?: InputMaybe<EhrPaymentDirectionSsAssetUpdatesourceBoughtTreatmentIdsInput>;
    sourceEhrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceEhrVisitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceMcmsAssociationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceOrgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    sourceUnappliedBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrPaymentDirectionSsAssetUpdatedestinationBoughtTreatmentIdsInput =
    {
        push?: InputMaybe<Array<Scalars['String']['input']>>;
        set?: InputMaybe<Array<Scalars['String']['input']>>;
    };

export type EhrPaymentDirectionSsAssetUpdatesourceBoughtTreatmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EhrPaymentDirectionSsAssetWhereInput = {
    AND?: InputMaybe<Array<EhrPaymentDirectionSsAssetWhereInput>>;
    NOT?: InputMaybe<Array<EhrPaymentDirectionSsAssetWhereInput>>;
    OR?: InputMaybe<Array<EhrPaymentDirectionSsAssetWhereInput>>;
    amount?: InputMaybe<FloatFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    destinationBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    destinationEhrClaimId?: InputMaybe<StringNullableFilter>;
    destinationEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    destinationMcmsAssociationId?: InputMaybe<UuidNullableFilter>;
    destinationOrgId?: InputMaybe<IntFilter>;
    destinationUnappliedBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringFilter>;
    ehrPaymentId?: InputMaybe<StringFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    sourceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    sourceEhrClaimId?: InputMaybe<StringNullableFilter>;
    sourceEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    sourceEhrVisitId?: InputMaybe<StringNullableFilter>;
    sourceMcmsAssociationId?: InputMaybe<UuidNullableFilter>;
    sourceOrgId?: InputMaybe<IntFilter>;
    sourceUnappliedBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrPaymentDirectionSsAssetWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrPaymentDirectionSsAssetWhereInput>>;
    NOT?: InputMaybe<Array<EhrPaymentDirectionSsAssetWhereInput>>;
    OR?: InputMaybe<Array<EhrPaymentDirectionSsAssetWhereInput>>;
    amount?: InputMaybe<FloatFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    destinationBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    destinationEhrClaimId?: InputMaybe<StringNullableFilter>;
    destinationEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    destinationMcmsAssociationId?: InputMaybe<UuidNullableFilter>;
    destinationOrgId?: InputMaybe<IntFilter>;
    destinationUnappliedBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringFilter>;
    ehrPaymentId?: InputMaybe<StringFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    sourceBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    sourceEhrClaimId?: InputMaybe<StringNullableFilter>;
    sourceEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    sourceEhrVisitId?: InputMaybe<StringNullableFilter>;
    sourceMcmsAssociationId?: InputMaybe<UuidNullableFilter>;
    sourceOrgId?: InputMaybe<IntFilter>;
    sourceUnappliedBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum EhrPaymentLockTypeEnum {
    AthenaBlocked = 'ATHENA_BLOCKED',
    AthenaCard = 'ATHENA_CARD',
    CashOrCheck = 'CASH_OR_CHECK',
    DirectPost = 'DIRECT_POST',
    ExternalPayment = 'EXTERNAL_PAYMENT',
    Misrouted = 'MISROUTED',
    OverAfterMisroute = 'OVER_AFTER_MISROUTE',
    OverCharge = 'OVER_CHARGE',
    SelfPayBundle = 'SELF_PAY_BUNDLE',
    Stable = 'STABLE',
    VoidedBypass = 'VOIDED_BYPASS',
}

export type EhrPostDetail = {
    __typename?: 'EhrPostDetail';
    amount: Scalars['Float']['output'];
    artCreditId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId: Scalars['String']['output'];
    ehrDepartmentId: Scalars['String']['output'];
    ehrPatientId: Scalars['String']['output'];
    ehrPaymentId: Scalars['String']['output'];
    ehrPostDetailAction: EhrPostDetailAction;
    ehrPostLedgerId: Scalars['String']['output'];
    ehrPostSource?: Maybe<EhrPostLedgerSourceEnum>;
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    paymentMethodType?: Maybe<PaymentMethodType>;
    reattributeDestArtCredit?: Maybe<Scalars['String']['output']>;
    reattributeDestBt?: Maybe<Scalars['String']['output']>;
    reattributeSourceArtCredit?: Maybe<Scalars['String']['output']>;
    reattributeSourceBt?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export enum EhrPostDetailAction {
    Other = 'OTHER',
    PaymentSplit = 'PAYMENT_SPLIT',
    Posted = 'POSTED',
    ReattributeDest = 'REATTRIBUTE_DEST',
    ReattributeSource = 'REATTRIBUTE_SOURCE',
    Voided = 'VOIDED',
}

export type EhrPostDetailAvgAggregate = {
    __typename?: 'EhrPostDetailAvgAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrPostDetailAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrPostDetailCountAggregate = {
    __typename?: 'EhrPostDetailCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    artCreditId: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrAppointmentId: Scalars['Int']['output'];
    ehrClaimId: Scalars['Int']['output'];
    ehrContextId: Scalars['Int']['output'];
    ehrDepartmentId: Scalars['Int']['output'];
    ehrPatientId: Scalars['Int']['output'];
    ehrPaymentId: Scalars['Int']['output'];
    ehrPostDetailAction: Scalars['Int']['output'];
    ehrPostLedgerId: Scalars['Int']['output'];
    ehrPostSource: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentMethodType: Scalars['Int']['output'];
    reattributeDestArtCredit: Scalars['Int']['output'];
    reattributeDestBt: Scalars['Int']['output'];
    reattributeSourceArtCredit: Scalars['Int']['output'];
    reattributeSourceBt: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type EhrPostDetailCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    artCreditId?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostDetailAction?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrPostSource?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    reattributeDestArtCredit?: InputMaybe<SortOrder>;
    reattributeDestBt?: InputMaybe<SortOrder>;
    reattributeSourceArtCredit?: InputMaybe<SortOrder>;
    reattributeSourceBt?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostDetailCreateInput = {
    amount?: InputMaybe<Scalars['Float']['input']>;
    artCreditId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrClaimId?: InputMaybe<Scalars['String']['input']>;
    ehrContextId: Scalars['String']['input'];
    ehrDepartmentId: Scalars['String']['input'];
    ehrPatientId: Scalars['String']['input'];
    ehrPaymentId: Scalars['String']['input'];
    ehrPostDetailAction: EhrPostDetailAction;
    ehrPostLedgerId: Scalars['String']['input'];
    ehrPostSource?: InputMaybe<EhrPostLedgerSourceEnum>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    reattributeDestArtCredit?: InputMaybe<Scalars['String']['input']>;
    reattributeDestBt?: InputMaybe<Scalars['String']['input']>;
    reattributeSourceArtCredit?: InputMaybe<Scalars['String']['input']>;
    reattributeSourceBt?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPostDetailCreateManyInput = {
    amount?: InputMaybe<Scalars['Float']['input']>;
    artCreditId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrClaimId?: InputMaybe<Scalars['String']['input']>;
    ehrContextId: Scalars['String']['input'];
    ehrDepartmentId: Scalars['String']['input'];
    ehrPatientId: Scalars['String']['input'];
    ehrPaymentId: Scalars['String']['input'];
    ehrPostDetailAction: EhrPostDetailAction;
    ehrPostLedgerId: Scalars['String']['input'];
    ehrPostSource?: InputMaybe<EhrPostLedgerSourceEnum>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    reattributeDestArtCredit?: InputMaybe<Scalars['String']['input']>;
    reattributeDestBt?: InputMaybe<Scalars['String']['input']>;
    reattributeSourceArtCredit?: InputMaybe<Scalars['String']['input']>;
    reattributeSourceBt?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPostDetailGroupBy = {
    __typename?: 'EhrPostDetailGroupBy';
    _avg?: Maybe<EhrPostDetailAvgAggregate>;
    _count?: Maybe<EhrPostDetailCountAggregate>;
    _max?: Maybe<EhrPostDetailMaxAggregate>;
    _min?: Maybe<EhrPostDetailMinAggregate>;
    _sum?: Maybe<EhrPostDetailSumAggregate>;
    amount: Scalars['Float']['output'];
    artCreditId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId: Scalars['String']['output'];
    ehrDepartmentId: Scalars['String']['output'];
    ehrPatientId: Scalars['String']['output'];
    ehrPaymentId: Scalars['String']['output'];
    ehrPostDetailAction: EhrPostDetailAction;
    ehrPostLedgerId: Scalars['String']['output'];
    ehrPostSource?: Maybe<EhrPostLedgerSourceEnum>;
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    paymentMethodType?: Maybe<PaymentMethodType>;
    reattributeDestArtCredit?: Maybe<Scalars['String']['output']>;
    reattributeDestBt?: Maybe<Scalars['String']['output']>;
    reattributeSourceArtCredit?: Maybe<Scalars['String']['output']>;
    reattributeSourceBt?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrPostDetailMaxAggregate = {
    __typename?: 'EhrPostDetailMaxAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    artCreditId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostDetailAction?: Maybe<EhrPostDetailAction>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrPostSource?: Maybe<EhrPostLedgerSourceEnum>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    reattributeDestArtCredit?: Maybe<Scalars['String']['output']>;
    reattributeDestBt?: Maybe<Scalars['String']['output']>;
    reattributeSourceArtCredit?: Maybe<Scalars['String']['output']>;
    reattributeSourceBt?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostDetailMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    artCreditId?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostDetailAction?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrPostSource?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    reattributeDestArtCredit?: InputMaybe<SortOrder>;
    reattributeDestBt?: InputMaybe<SortOrder>;
    reattributeSourceArtCredit?: InputMaybe<SortOrder>;
    reattributeSourceBt?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostDetailMinAggregate = {
    __typename?: 'EhrPostDetailMinAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    artCreditId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostDetailAction?: Maybe<EhrPostDetailAction>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrPostSource?: Maybe<EhrPostLedgerSourceEnum>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    reattributeDestArtCredit?: Maybe<Scalars['String']['output']>;
    reattributeDestBt?: Maybe<Scalars['String']['output']>;
    reattributeSourceArtCredit?: Maybe<Scalars['String']['output']>;
    reattributeSourceBt?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostDetailMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    artCreditId?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostDetailAction?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrPostSource?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    reattributeDestArtCredit?: InputMaybe<SortOrder>;
    reattributeDestBt?: InputMaybe<SortOrder>;
    reattributeSourceArtCredit?: InputMaybe<SortOrder>;
    reattributeSourceBt?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostDetailOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrPostDetailAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrPostDetailCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrPostDetailMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrPostDetailMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrPostDetailSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrder>;
    artCreditId?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrClaimId?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostDetailAction?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrPostSource?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    reattributeDestArtCredit?: InputMaybe<SortOrderInput>;
    reattributeDestBt?: InputMaybe<SortOrderInput>;
    reattributeSourceArtCredit?: InputMaybe<SortOrderInput>;
    reattributeSourceBt?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostDetailOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrder>;
    artCreditId?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrClaimId?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostDetailAction?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrPostSource?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    reattributeDestArtCredit?: InputMaybe<SortOrderInput>;
    reattributeDestBt?: InputMaybe<SortOrderInput>;
    reattributeSourceArtCredit?: InputMaybe<SortOrderInput>;
    reattributeSourceBt?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum EhrPostDetailScalarFieldEnum {
    Amount = 'amount',
    ArtCreditId = 'artCreditId',
    BoughtTreatmentId = 'boughtTreatmentId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    EhrAppointmentId = 'ehrAppointmentId',
    EhrClaimId = 'ehrClaimId',
    EhrContextId = 'ehrContextId',
    EhrDepartmentId = 'ehrDepartmentId',
    EhrPatientId = 'ehrPatientId',
    EhrPaymentId = 'ehrPaymentId',
    EhrPostDetailAction = 'ehrPostDetailAction',
    EhrPostLedgerId = 'ehrPostLedgerId',
    EhrPostSource = 'ehrPostSource',
    Id = 'id',
    OrgId = 'orgId',
    PaymentMethodType = 'paymentMethodType',
    ReattributeDestArtCredit = 'reattributeDestArtCredit',
    ReattributeDestBt = 'reattributeDestBt',
    ReattributeSourceArtCredit = 'reattributeSourceArtCredit',
    ReattributeSourceBt = 'reattributeSourceBt',
    UpdatedAt = 'updatedAt',
}

export type EhrPostDetailScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<EhrPostDetailScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<EhrPostDetailScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<EhrPostDetailScalarWhereWithAggregatesInput>>;
    amount?: InputMaybe<FloatWithAggregatesFilter>;
    artCreditId?: InputMaybe<StringNullableWithAggregatesFilter>;
    boughtTreatmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<StringWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrClaimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrContextId?: InputMaybe<StringWithAggregatesFilter>;
    ehrDepartmentId?: InputMaybe<StringWithAggregatesFilter>;
    ehrPatientId?: InputMaybe<StringWithAggregatesFilter>;
    ehrPaymentId?: InputMaybe<StringWithAggregatesFilter>;
    ehrPostDetailAction?: InputMaybe<EnumEhrPostDetailActionWithAggregatesFilter>;
    ehrPostLedgerId?: InputMaybe<StringWithAggregatesFilter>;
    ehrPostSource?: InputMaybe<EnumEhrPostLedgerSourceEnumNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableWithAggregatesFilter>;
    reattributeDestArtCredit?: InputMaybe<StringNullableWithAggregatesFilter>;
    reattributeDestBt?: InputMaybe<StringNullableWithAggregatesFilter>;
    reattributeSourceArtCredit?: InputMaybe<StringNullableWithAggregatesFilter>;
    reattributeSourceBt?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EhrPostDetailSumAggregate = {
    __typename?: 'EhrPostDetailSumAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrPostDetailSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrPostDetailToPayout = {
    __typename?: 'EhrPostDetailToPayout';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostDetailId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    payoutId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrPostDetailToPayoutCountAggregate = {
    __typename?: 'EhrPostDetailToPayoutCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrPostDetailId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    payoutId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type EhrPostDetailToPayoutCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrPostDetailId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostDetailToPayoutCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrPostDetailId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    payoutId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPostDetailToPayoutCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrPostDetailId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    payoutId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPostDetailToPayoutGroupBy = {
    __typename?: 'EhrPostDetailToPayoutGroupBy';
    _count?: Maybe<EhrPostDetailToPayoutCountAggregate>;
    _max?: Maybe<EhrPostDetailToPayoutMaxAggregate>;
    _min?: Maybe<EhrPostDetailToPayoutMinAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostDetailId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    payoutId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrPostDetailToPayoutMaxAggregate = {
    __typename?: 'EhrPostDetailToPayoutMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostDetailId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    payoutId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostDetailToPayoutMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrPostDetailId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostDetailToPayoutMinAggregate = {
    __typename?: 'EhrPostDetailToPayoutMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostDetailId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    payoutId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostDetailToPayoutMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrPostDetailId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostDetailToPayoutOrderByWithAggregationInput = {
    _count?: InputMaybe<EhrPostDetailToPayoutCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrPostDetailToPayoutMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrPostDetailToPayoutMinOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostDetailId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostDetailToPayoutOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrPostDetailId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum EhrPostDetailToPayoutScalarFieldEnum {
    CreatedAt = 'createdAt',
    EhrPostDetailId = 'ehrPostDetailId',
    Id = 'id',
    PayoutId = 'payoutId',
    UpdatedAt = 'updatedAt',
}

export type EhrPostDetailToPayoutScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<EhrPostDetailToPayoutScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<EhrPostDetailToPayoutScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<EhrPostDetailToPayoutScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrPostDetailId?: InputMaybe<UuidWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    payoutId?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EhrPostDetailToPayoutUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostDetailId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    payoutId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrPostDetailToPayoutUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostDetailId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    payoutId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrPostDetailToPayoutWhereInput = {
    AND?: InputMaybe<Array<EhrPostDetailToPayoutWhereInput>>;
    NOT?: InputMaybe<Array<EhrPostDetailToPayoutWhereInput>>;
    OR?: InputMaybe<Array<EhrPostDetailToPayoutWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrPostDetailId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<UuidFilter>;
    payoutId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrPostDetailToPayoutWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrPostDetailToPayoutWhereInput>>;
    NOT?: InputMaybe<Array<EhrPostDetailToPayoutWhereInput>>;
    OR?: InputMaybe<Array<EhrPostDetailToPayoutWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrPostDetailId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    payoutId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrPostDetailUpdateInput = {
    amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
    artCreditId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrDepartmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPostDetailAction?: InputMaybe<EnumEhrPostDetailActionFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPostSource?: InputMaybe<NullableEnumEhrPostLedgerSourceEnumFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    reattributeDestArtCredit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    reattributeDestBt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    reattributeSourceArtCredit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    reattributeSourceBt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrPostDetailUpdateManyMutationInput = {
    amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
    artCreditId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrDepartmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPostDetailAction?: InputMaybe<EnumEhrPostDetailActionFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPostSource?: InputMaybe<NullableEnumEhrPostLedgerSourceEnumFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    reattributeDestArtCredit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    reattributeDestBt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    reattributeSourceArtCredit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    reattributeSourceBt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrPostDetailWhereInput = {
    AND?: InputMaybe<Array<EhrPostDetailWhereInput>>;
    NOT?: InputMaybe<Array<EhrPostDetailWhereInput>>;
    OR?: InputMaybe<Array<EhrPostDetailWhereInput>>;
    amount?: InputMaybe<FloatFilter>;
    artCreditId?: InputMaybe<StringNullableFilter>;
    boughtTreatmentId?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrClaimId?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringFilter>;
    ehrDepartmentId?: InputMaybe<StringFilter>;
    ehrPatientId?: InputMaybe<StringFilter>;
    ehrPaymentId?: InputMaybe<StringFilter>;
    ehrPostDetailAction?: InputMaybe<EnumEhrPostDetailActionFilter>;
    ehrPostLedgerId?: InputMaybe<StringFilter>;
    ehrPostSource?: InputMaybe<EnumEhrPostLedgerSourceEnumNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableFilter>;
    reattributeDestArtCredit?: InputMaybe<StringNullableFilter>;
    reattributeDestBt?: InputMaybe<StringNullableFilter>;
    reattributeSourceArtCredit?: InputMaybe<StringNullableFilter>;
    reattributeSourceBt?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrPostDetailWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrPostDetailWhereInput>>;
    NOT?: InputMaybe<Array<EhrPostDetailWhereInput>>;
    OR?: InputMaybe<Array<EhrPostDetailWhereInput>>;
    amount?: InputMaybe<FloatFilter>;
    artCreditId?: InputMaybe<StringNullableFilter>;
    boughtTreatmentId?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrClaimId?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringFilter>;
    ehrDepartmentId?: InputMaybe<StringFilter>;
    ehrPatientId?: InputMaybe<StringFilter>;
    ehrPaymentId?: InputMaybe<StringFilter>;
    ehrPostDetailAction?: InputMaybe<EnumEhrPostDetailActionFilter>;
    ehrPostLedgerId?: InputMaybe<StringFilter>;
    ehrPostSource?: InputMaybe<EnumEhrPostLedgerSourceEnumNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableFilter>;
    reattributeDestArtCredit?: InputMaybe<StringNullableFilter>;
    reattributeDestBt?: InputMaybe<StringNullableFilter>;
    reattributeSourceArtCredit?: InputMaybe<StringNullableFilter>;
    reattributeSourceBt?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum EhrPostIdentifierTypeEnum {
    AppointmentId = 'APPOINTMENT_ID',
    ClaimId = 'CLAIM_ID',
    EncounterId = 'ENCOUNTER_ID',
    PatientId = 'PATIENT_ID',
    VisitId = 'VISIT_ID',
}

export type EhrPostLedger = {
    __typename?: 'EhrPostLedger';
    amount: Scalars['Float']['output'];
    appointmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentIds: Array<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    /**
     * ATHENA_CARD only: the bought treatments this charge paid, in the order
     * they were sent to hex-checkout. `boughtTreatmentIds` holds the whole
     * unit (every BT of the visit/claim); recovery of an unknown outcome must
     * pay exactly these, in this order.
     */
    chargedBoughtTreatmentIds: Array<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    /**
     * athena's `epaymentid` for an ATHENA_CARD charge (Credit Card Plus). Its
     * own column on purpose: `paymentId`/`ehrPaymentId` carry `patientpaymentid`
     * (what voids and ART match on) and `createEhrPostLedgerRow` copies
     * `paymentId` into `ehrPaymentId`, so overloading either would let a void
     * or a Dataview match key on the wrong id. Null for every other rail.
     */
    ehrEpaymentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId: Scalars['String']['output'];
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifier?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifierType?: Maybe<EhrPostIdentifierTypeEnum>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesAndPayoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationId?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    payoutIds: Array<Scalars['String']['output']>;
    payoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    payoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    source?: Maybe<EhrPostLedgerSourceEnum>;
    status: EhrPostStatusEnum;
    transactionIds: Array<Scalars['String']['output']>;
    /**
     * THE marker that this ledger row's money is parked on an unapplied bought
     * treatment. `reattributionState` alone is insufficient — it only says the
     * row was minted by a reattribution. Reconcile / fees / payout sweeps gate
     * on THIS column: ordinary reattribution rows may flow, unapplied-
     * associated rows never do. Set alongside `boughtTreatmentIds` by the
     * ledger reattribution primitive on UNAPPLIED-destination rows.
     */
    unappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostLedgerAuditLog = {
    __typename?: 'EhrPostLedgerAuditLog';
    amount?: Maybe<Scalars['Float']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentIds: Array<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifier?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifierType?: Maybe<EhrPostIdentifierTypeEnum>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesAndPayoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    payoutIds: Array<Scalars['String']['output']>;
    payoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    payoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    source?: Maybe<EhrPostLedgerSourceEnum>;
    status?: Maybe<EhrPostStatusEnum>;
    transactionIds: Array<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostLedgerAuditLogAvgAggregate = {
    __typename?: 'EhrPostLedgerAuditLogAvgAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrPostLedgerAuditLogAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerAuditLogCountAggregate = {
    __typename?: 'EhrPostLedgerAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    boughtTreatmentIds: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrAppointmentId: Scalars['Int']['output'];
    ehrClaimId: Scalars['Int']['output'];
    ehrContextId: Scalars['Int']['output'];
    ehrDepartmentId: Scalars['Int']['output'];
    ehrPatientId: Scalars['Int']['output'];
    ehrPaymentId: Scalars['Int']['output'];
    ehrPostAgainstIdentifier: Scalars['Int']['output'];
    ehrPostAgainstIdentifierType: Scalars['Int']['output'];
    ehrPostLedgerId: Scalars['Int']['output'];
    ehrSlotId: Scalars['Int']['output'];
    ehrType: Scalars['Int']['output'];
    feesAndPayoutsProcessedAt: Scalars['Int']['output'];
    feesAndPayoutsProcessingStatus: Scalars['Int']['output'];
    feesProcessedAt: Scalars['Int']['output'];
    feesProcessingStatus: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentId: Scalars['Int']['output'];
    paymentMethodType: Scalars['Int']['output'];
    payoutIds: Scalars['Int']['output'];
    payoutsProcessedAt: Scalars['Int']['output'];
    payoutsProcessingStatus: Scalars['Int']['output'];
    postedAt: Scalars['Int']['output'];
    source: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    transactionIds: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    voidReason: Scalars['Int']['output'];
    voidedAt: Scalars['Int']['output'];
};

export type EhrPostLedgerAuditLogCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifier?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifierType?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessedAt?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessingStatus?: InputMaybe<SortOrder>;
    feesProcessedAt?: InputMaybe<SortOrder>;
    feesProcessingStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    payoutIds?: InputMaybe<SortOrder>;
    payoutsProcessedAt?: InputMaybe<SortOrder>;
    payoutsProcessingStatus?: InputMaybe<SortOrder>;
    postedAt?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerAuditLogCreateInput = {
    amount?: InputMaybe<Scalars['Float']['input']>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentIds?: InputMaybe<EhrPostLedgerAuditLogCreateboughtTreatmentIdsInput>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrClaimId?: InputMaybe<Scalars['String']['input']>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    ehrPaymentId?: InputMaybe<Scalars['String']['input']>;
    ehrPostAgainstIdentifier?: InputMaybe<Scalars['String']['input']>;
    ehrPostAgainstIdentifierType?: InputMaybe<EhrPostIdentifierTypeEnum>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    ehrType?: InputMaybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feesAndPayoutsProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feesProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentId?: InputMaybe<Scalars['String']['input']>;
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    payoutIds?: InputMaybe<EhrPostLedgerAuditLogCreatepayoutIdsInput>;
    payoutsProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    payoutsProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    source?: InputMaybe<EhrPostLedgerSourceEnum>;
    status?: InputMaybe<EhrPostStatusEnum>;
    transactionIds?: InputMaybe<EhrPostLedgerAuditLogCreatetransactionIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPostLedgerAuditLogCreateManyInput = {
    amount?: InputMaybe<Scalars['Float']['input']>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentIds?: InputMaybe<EhrPostLedgerAuditLogCreateboughtTreatmentIdsInput>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrClaimId?: InputMaybe<Scalars['String']['input']>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId?: InputMaybe<Scalars['String']['input']>;
    ehrPaymentId?: InputMaybe<Scalars['String']['input']>;
    ehrPostAgainstIdentifier?: InputMaybe<Scalars['String']['input']>;
    ehrPostAgainstIdentifierType?: InputMaybe<EhrPostIdentifierTypeEnum>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    ehrType?: InputMaybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feesAndPayoutsProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feesProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentId?: InputMaybe<Scalars['String']['input']>;
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    payoutIds?: InputMaybe<EhrPostLedgerAuditLogCreatepayoutIdsInput>;
    payoutsProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    payoutsProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    source?: InputMaybe<EhrPostLedgerSourceEnum>;
    status?: InputMaybe<EhrPostStatusEnum>;
    transactionIds?: InputMaybe<EhrPostLedgerAuditLogCreatetransactionIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPostLedgerAuditLogCreateboughtTreatmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EhrPostLedgerAuditLogCreatepayoutIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EhrPostLedgerAuditLogCreatetransactionIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EhrPostLedgerAuditLogGroupBy = {
    __typename?: 'EhrPostLedgerAuditLogGroupBy';
    _avg?: Maybe<EhrPostLedgerAuditLogAvgAggregate>;
    _count?: Maybe<EhrPostLedgerAuditLogCountAggregate>;
    _max?: Maybe<EhrPostLedgerAuditLogMaxAggregate>;
    _min?: Maybe<EhrPostLedgerAuditLogMinAggregate>;
    _sum?: Maybe<EhrPostLedgerAuditLogSumAggregate>;
    amount?: Maybe<Scalars['Float']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifier?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifierType?: Maybe<EhrPostIdentifierTypeEnum>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesAndPayoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    payoutIds?: Maybe<Array<Scalars['String']['output']>>;
    payoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    payoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    source?: Maybe<EhrPostLedgerSourceEnum>;
    status?: Maybe<EhrPostStatusEnum>;
    transactionIds?: Maybe<Array<Scalars['String']['output']>>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostLedgerAuditLogMaxAggregate = {
    __typename?: 'EhrPostLedgerAuditLogMaxAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifier?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifierType?: Maybe<EhrPostIdentifierTypeEnum>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesAndPayoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    payoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    payoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    source?: Maybe<EhrPostLedgerSourceEnum>;
    status?: Maybe<EhrPostStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostLedgerAuditLogMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifier?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifierType?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessedAt?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessingStatus?: InputMaybe<SortOrder>;
    feesProcessedAt?: InputMaybe<SortOrder>;
    feesProcessingStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    payoutsProcessedAt?: InputMaybe<SortOrder>;
    payoutsProcessingStatus?: InputMaybe<SortOrder>;
    postedAt?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerAuditLogMinAggregate = {
    __typename?: 'EhrPostLedgerAuditLogMinAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifier?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifierType?: Maybe<EhrPostIdentifierTypeEnum>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesAndPayoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    payoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    payoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    source?: Maybe<EhrPostLedgerSourceEnum>;
    status?: Maybe<EhrPostStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostLedgerAuditLogMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifier?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifierType?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessedAt?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessingStatus?: InputMaybe<SortOrder>;
    feesProcessedAt?: InputMaybe<SortOrder>;
    feesProcessingStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    payoutsProcessedAt?: InputMaybe<SortOrder>;
    payoutsProcessingStatus?: InputMaybe<SortOrder>;
    postedAt?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrPostLedgerAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrPostLedgerAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrPostLedgerAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrPostLedgerAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrPostLedgerAuditLogSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrderInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrClaimId?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrderInput>;
    ehrDepartmentId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrderInput>;
    ehrPaymentId?: InputMaybe<SortOrderInput>;
    ehrPostAgainstIdentifier?: InputMaybe<SortOrderInput>;
    ehrPostAgainstIdentifierType?: InputMaybe<SortOrderInput>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    ehrType?: InputMaybe<SortOrderInput>;
    feesAndPayoutsProcessedAt?: InputMaybe<SortOrderInput>;
    feesAndPayoutsProcessingStatus?: InputMaybe<SortOrderInput>;
    feesProcessedAt?: InputMaybe<SortOrderInput>;
    feesProcessingStatus?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    paymentId?: InputMaybe<SortOrderInput>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    payoutIds?: InputMaybe<SortOrder>;
    payoutsProcessedAt?: InputMaybe<SortOrderInput>;
    payoutsProcessingStatus?: InputMaybe<SortOrderInput>;
    postedAt?: InputMaybe<SortOrderInput>;
    source?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    transactionIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrderInput>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export type EhrPostLedgerAuditLogOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrderInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrClaimId?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrderInput>;
    ehrDepartmentId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrderInput>;
    ehrPaymentId?: InputMaybe<SortOrderInput>;
    ehrPostAgainstIdentifier?: InputMaybe<SortOrderInput>;
    ehrPostAgainstIdentifierType?: InputMaybe<SortOrderInput>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    ehrType?: InputMaybe<SortOrderInput>;
    feesAndPayoutsProcessedAt?: InputMaybe<SortOrderInput>;
    feesAndPayoutsProcessingStatus?: InputMaybe<SortOrderInput>;
    feesProcessedAt?: InputMaybe<SortOrderInput>;
    feesProcessingStatus?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    paymentId?: InputMaybe<SortOrderInput>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    payoutIds?: InputMaybe<SortOrder>;
    payoutsProcessedAt?: InputMaybe<SortOrderInput>;
    payoutsProcessingStatus?: InputMaybe<SortOrderInput>;
    postedAt?: InputMaybe<SortOrderInput>;
    source?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    transactionIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrderInput>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export enum EhrPostLedgerAuditLogScalarFieldEnum {
    Amount = 'amount',
    AppointmentId = 'appointmentId',
    BoughtTreatmentIds = 'boughtTreatmentIds',
    ClaimId = 'claimId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    EhrAppointmentId = 'ehrAppointmentId',
    EhrClaimId = 'ehrClaimId',
    EhrContextId = 'ehrContextId',
    EhrDepartmentId = 'ehrDepartmentId',
    EhrPatientId = 'ehrPatientId',
    EhrPaymentId = 'ehrPaymentId',
    EhrPostAgainstIdentifier = 'ehrPostAgainstIdentifier',
    EhrPostAgainstIdentifierType = 'ehrPostAgainstIdentifierType',
    EhrPostLedgerId = 'ehrPostLedgerId',
    EhrSlotId = 'ehrSlotId',
    EhrType = 'ehrType',
    FeesAndPayoutsProcessedAt = 'feesAndPayoutsProcessedAt',
    FeesAndPayoutsProcessingStatus = 'feesAndPayoutsProcessingStatus',
    FeesProcessedAt = 'feesProcessedAt',
    FeesProcessingStatus = 'feesProcessingStatus',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Operation = 'operation',
    OrgId = 'orgId',
    PaymentId = 'paymentId',
    PaymentMethodType = 'paymentMethodType',
    PayoutIds = 'payoutIds',
    PayoutsProcessedAt = 'payoutsProcessedAt',
    PayoutsProcessingStatus = 'payoutsProcessingStatus',
    PostedAt = 'postedAt',
    Source = 'source',
    Status = 'status',
    TransactionIds = 'transactionIds',
    UpdatedAt = 'updatedAt',
    VoidReason = 'voidReason',
    VoidedAt = 'voidedAt',
}

export type EhrPostLedgerAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<EhrPostLedgerAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<EhrPostLedgerAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<EhrPostLedgerAuditLogScalarWhereWithAggregatesInput>>;
    amount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    appointmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrClaimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrContextId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrDepartmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPatientId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPaymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPostAgainstIdentifier?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPostAgainstIdentifierType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableWithAggregatesFilter>;
    ehrPostLedgerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    ehrSlotId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrType?: InputMaybe<EnumEhrTypeEnumNullableWithAggregatesFilter>;
    feesAndPayoutsProcessedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    feesAndPayoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableWithAggregatesFilter>;
    feesProcessedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    feesProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    paymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableWithAggregatesFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    payoutsProcessedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    payoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableWithAggregatesFilter>;
    postedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    source?: InputMaybe<EnumEhrPostLedgerSourceEnumNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumEhrPostStatusEnumNullableWithAggregatesFilter>;
    transactionIds?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    voidReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    voidedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type EhrPostLedgerAuditLogSumAggregate = {
    __typename?: 'EhrPostLedgerAuditLogSumAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrPostLedgerAuditLogSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerAuditLogUpdateInput = {
    amount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<EhrPostLedgerAuditLogUpdateboughtTreatmentIdsInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostAgainstIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostAgainstIdentifierType?: InputMaybe<NullableEnumEhrPostIdentifierTypeEnumFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrType?: InputMaybe<NullableEnumEhrTypeEnumFieldUpdateOperationsInput>;
    feesAndPayoutsProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    feesAndPayoutsProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    feesProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    feesProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<EhrPostLedgerAuditLogUpdatepayoutIdsInput>;
    payoutsProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    payoutsProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    postedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    source?: InputMaybe<NullableEnumEhrPostLedgerSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumEhrPostStatusEnumFieldUpdateOperationsInput>;
    transactionIds?: InputMaybe<EhrPostLedgerAuditLogUpdatetransactionIdsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type EhrPostLedgerAuditLogUpdateManyMutationInput = {
    amount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<EhrPostLedgerAuditLogUpdateboughtTreatmentIdsInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostAgainstIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostAgainstIdentifierType?: InputMaybe<NullableEnumEhrPostIdentifierTypeEnumFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrType?: InputMaybe<NullableEnumEhrTypeEnumFieldUpdateOperationsInput>;
    feesAndPayoutsProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    feesAndPayoutsProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    feesProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    feesProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<EhrPostLedgerAuditLogUpdatepayoutIdsInput>;
    payoutsProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    payoutsProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    postedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    source?: InputMaybe<NullableEnumEhrPostLedgerSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumEhrPostStatusEnumFieldUpdateOperationsInput>;
    transactionIds?: InputMaybe<EhrPostLedgerAuditLogUpdatetransactionIdsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type EhrPostLedgerAuditLogUpdateboughtTreatmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EhrPostLedgerAuditLogUpdatepayoutIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EhrPostLedgerAuditLogUpdatetransactionIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EhrPostLedgerAuditLogWhereInput = {
    AND?: InputMaybe<Array<EhrPostLedgerAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<EhrPostLedgerAuditLogWhereInput>>;
    OR?: InputMaybe<Array<EhrPostLedgerAuditLogWhereInput>>;
    amount?: InputMaybe<FloatNullableFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrClaimId?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringNullableFilter>;
    ehrDepartmentId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    ehrPaymentId?: InputMaybe<StringNullableFilter>;
    ehrPostAgainstIdentifier?: InputMaybe<StringNullableFilter>;
    ehrPostAgainstIdentifierType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableFilter>;
    ehrPostLedgerId?: InputMaybe<UuidNullableFilter>;
    ehrSlotId?: InputMaybe<StringNullableFilter>;
    ehrType?: InputMaybe<EnumEhrTypeEnumNullableFilter>;
    feesAndPayoutsProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    feesAndPayoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    feesProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    feesProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentId?: InputMaybe<StringNullableFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    payoutsProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    payoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    postedAt?: InputMaybe<DateTimeNullableFilter>;
    source?: InputMaybe<EnumEhrPostLedgerSourceEnumNullableFilter>;
    status?: InputMaybe<EnumEhrPostStatusEnumNullableFilter>;
    transactionIds?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidReason?: InputMaybe<StringNullableFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type EhrPostLedgerAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrPostLedgerAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<EhrPostLedgerAuditLogWhereInput>>;
    OR?: InputMaybe<Array<EhrPostLedgerAuditLogWhereInput>>;
    amount?: InputMaybe<FloatNullableFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrClaimId?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringNullableFilter>;
    ehrDepartmentId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringNullableFilter>;
    ehrPaymentId?: InputMaybe<StringNullableFilter>;
    ehrPostAgainstIdentifier?: InputMaybe<StringNullableFilter>;
    ehrPostAgainstIdentifierType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableFilter>;
    ehrPostLedgerId?: InputMaybe<UuidNullableFilter>;
    ehrSlotId?: InputMaybe<StringNullableFilter>;
    ehrType?: InputMaybe<EnumEhrTypeEnumNullableFilter>;
    feesAndPayoutsProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    feesAndPayoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    feesProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    feesProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentId?: InputMaybe<StringNullableFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    payoutsProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    payoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    postedAt?: InputMaybe<DateTimeNullableFilter>;
    source?: InputMaybe<EnumEhrPostLedgerSourceEnumNullableFilter>;
    status?: InputMaybe<EnumEhrPostStatusEnumNullableFilter>;
    transactionIds?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidReason?: InputMaybe<StringNullableFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type EhrPostLedgerAvgAggregate = {
    __typename?: 'EhrPostLedgerAvgAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrPostLedgerAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerCountAggregate = {
    __typename?: 'EhrPostLedgerCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    boughtTreatmentIds: Scalars['Int']['output'];
    cardLastFourDigits: Scalars['Int']['output'];
    chargedBoughtTreatmentIds: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrAppointmentId: Scalars['Int']['output'];
    ehrClaimId: Scalars['Int']['output'];
    ehrContextId: Scalars['Int']['output'];
    ehrDepartmentId: Scalars['Int']['output'];
    ehrEpaymentId: Scalars['Int']['output'];
    ehrPatientId: Scalars['Int']['output'];
    ehrPaymentId: Scalars['Int']['output'];
    ehrPostAgainstIdentifier: Scalars['Int']['output'];
    ehrPostAgainstIdentifierType: Scalars['Int']['output'];
    ehrSlotId: Scalars['Int']['output'];
    ehrType: Scalars['Int']['output'];
    feesAndPayoutsProcessedAt: Scalars['Int']['output'];
    feesAndPayoutsProcessingStatus: Scalars['Int']['output'];
    feesProcessedAt: Scalars['Int']['output'];
    feesProcessingStatus: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    mcmsAssociationId: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentId: Scalars['Int']['output'];
    paymentMethodType: Scalars['Int']['output'];
    payoutIds: Scalars['Int']['output'];
    payoutsProcessedAt: Scalars['Int']['output'];
    payoutsProcessingStatus: Scalars['Int']['output'];
    postedAt: Scalars['Int']['output'];
    reattributionState: Scalars['Int']['output'];
    source: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    transactionIds: Scalars['Int']['output'];
    unappliedBoughtTreatmentId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    voidReason: Scalars['Int']['output'];
    voidedAt: Scalars['Int']['output'];
};

export type EhrPostLedgerCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    chargedBoughtTreatmentIds?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrEpaymentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifier?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifierType?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessedAt?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessingStatus?: InputMaybe<SortOrder>;
    feesProcessedAt?: InputMaybe<SortOrder>;
    feesProcessingStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    payoutIds?: InputMaybe<SortOrder>;
    payoutsProcessedAt?: InputMaybe<SortOrder>;
    payoutsProcessingStatus?: InputMaybe<SortOrder>;
    postedAt?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionIds?: InputMaybe<SortOrder>;
    unappliedBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerCreateInput = {
    amount?: InputMaybe<Scalars['Float']['input']>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentIds?: InputMaybe<EhrPostLedgerCreateboughtTreatmentIdsInput>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    chargedBoughtTreatmentIds?: InputMaybe<EhrPostLedgerCreatechargedBoughtTreatmentIdsInput>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrClaimId?: InputMaybe<Scalars['String']['input']>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    ehrEpaymentId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId: Scalars['String']['input'];
    ehrPaymentId?: InputMaybe<Scalars['String']['input']>;
    ehrPostAgainstIdentifier?: InputMaybe<Scalars['String']['input']>;
    ehrPostAgainstIdentifierType?: InputMaybe<EhrPostIdentifierTypeEnum>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    ehrType?: InputMaybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feesAndPayoutsProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feesProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    mcmsAssociationId?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentId?: InputMaybe<Scalars['String']['input']>;
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    payoutIds?: InputMaybe<EhrPostLedgerCreatepayoutIdsInput>;
    payoutsProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    payoutsProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    reattributionState?: InputMaybe<ReattributionState>;
    source?: InputMaybe<EhrPostLedgerSourceEnum>;
    status: EhrPostStatusEnum;
    transactionIds?: InputMaybe<EhrPostLedgerCreatetransactionIdsInput>;
    unappliedBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPostLedgerCreateManyInput = {
    amount?: InputMaybe<Scalars['Float']['input']>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentIds?: InputMaybe<EhrPostLedgerCreateboughtTreatmentIdsInput>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    chargedBoughtTreatmentIds?: InputMaybe<EhrPostLedgerCreatechargedBoughtTreatmentIdsInput>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrClaimId?: InputMaybe<Scalars['String']['input']>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    ehrEpaymentId?: InputMaybe<Scalars['String']['input']>;
    ehrPatientId: Scalars['String']['input'];
    ehrPaymentId?: InputMaybe<Scalars['String']['input']>;
    ehrPostAgainstIdentifier?: InputMaybe<Scalars['String']['input']>;
    ehrPostAgainstIdentifierType?: InputMaybe<EhrPostIdentifierTypeEnum>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    ehrType?: InputMaybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feesAndPayoutsProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feesProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    mcmsAssociationId?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentId?: InputMaybe<Scalars['String']['input']>;
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    payoutIds?: InputMaybe<EhrPostLedgerCreatepayoutIdsInput>;
    payoutsProcessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    payoutsProcessingStatus?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    reattributionState?: InputMaybe<ReattributionState>;
    source?: InputMaybe<EhrPostLedgerSourceEnum>;
    status: EhrPostStatusEnum;
    transactionIds?: InputMaybe<EhrPostLedgerCreatetransactionIdsInput>;
    unappliedBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPostLedgerCreateboughtTreatmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EhrPostLedgerCreatechargedBoughtTreatmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EhrPostLedgerCreatepayoutIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EhrPostLedgerCreatetransactionIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EhrPostLedgerGroupBy = {
    __typename?: 'EhrPostLedgerGroupBy';
    _avg?: Maybe<EhrPostLedgerAvgAggregate>;
    _count?: Maybe<EhrPostLedgerCountAggregate>;
    _max?: Maybe<EhrPostLedgerMaxAggregate>;
    _min?: Maybe<EhrPostLedgerMinAggregate>;
    _sum?: Maybe<EhrPostLedgerSumAggregate>;
    amount: Scalars['Float']['output'];
    appointmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    chargedBoughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrEpaymentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId: Scalars['String']['output'];
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifier?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifierType?: Maybe<EhrPostIdentifierTypeEnum>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesAndPayoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationId?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    payoutIds?: Maybe<Array<Scalars['String']['output']>>;
    payoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    payoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    source?: Maybe<EhrPostLedgerSourceEnum>;
    status: EhrPostStatusEnum;
    transactionIds?: Maybe<Array<Scalars['String']['output']>>;
    unappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostLedgerMaxAggregate = {
    __typename?: 'EhrPostLedgerMaxAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrEpaymentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifier?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifierType?: Maybe<EhrPostIdentifierTypeEnum>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesAndPayoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationId?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    payoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    payoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    source?: Maybe<EhrPostLedgerSourceEnum>;
    status?: Maybe<EhrPostStatusEnum>;
    unappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostLedgerMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrEpaymentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifier?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifierType?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessedAt?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessingStatus?: InputMaybe<SortOrder>;
    feesProcessedAt?: InputMaybe<SortOrder>;
    feesProcessingStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    payoutsProcessedAt?: InputMaybe<SortOrder>;
    payoutsProcessingStatus?: InputMaybe<SortOrder>;
    postedAt?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    unappliedBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerMinAggregate = {
    __typename?: 'EhrPostLedgerMinAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    ehrEpaymentId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrPaymentId?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifier?: Maybe<Scalars['String']['output']>;
    ehrPostAgainstIdentifierType?: Maybe<EhrPostIdentifierTypeEnum>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrTypeEnum>;
    feesAndPayoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesAndPayoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    feesProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feesProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationId?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    payoutsProcessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    payoutsProcessingStatus?: Maybe<FeesAndPayoutsProcessingStatusEnum>;
    postedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    source?: Maybe<EhrPostLedgerSourceEnum>;
    status?: Maybe<EhrPostStatusEnum>;
    unappliedBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostLedgerMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrDepartmentId?: InputMaybe<SortOrder>;
    ehrEpaymentId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifier?: InputMaybe<SortOrder>;
    ehrPostAgainstIdentifierType?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessedAt?: InputMaybe<SortOrder>;
    feesAndPayoutsProcessingStatus?: InputMaybe<SortOrder>;
    feesProcessedAt?: InputMaybe<SortOrder>;
    feesProcessingStatus?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    payoutsProcessedAt?: InputMaybe<SortOrder>;
    payoutsProcessingStatus?: InputMaybe<SortOrder>;
    postedAt?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    unappliedBoughtTreatmentId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrPostLedgerAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrPostLedgerCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrPostLedgerMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrPostLedgerMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrPostLedgerSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrderInput>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    chargedBoughtTreatmentIds?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrClaimId?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrderInput>;
    ehrDepartmentId?: InputMaybe<SortOrderInput>;
    ehrEpaymentId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrderInput>;
    ehrPostAgainstIdentifier?: InputMaybe<SortOrderInput>;
    ehrPostAgainstIdentifierType?: InputMaybe<SortOrderInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    ehrType?: InputMaybe<SortOrderInput>;
    feesAndPayoutsProcessedAt?: InputMaybe<SortOrderInput>;
    feesAndPayoutsProcessingStatus?: InputMaybe<SortOrderInput>;
    feesProcessedAt?: InputMaybe<SortOrderInput>;
    feesProcessingStatus?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    mcmsAssociationId?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    paymentId?: InputMaybe<SortOrderInput>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    payoutIds?: InputMaybe<SortOrder>;
    payoutsProcessedAt?: InputMaybe<SortOrderInput>;
    payoutsProcessingStatus?: InputMaybe<SortOrderInput>;
    postedAt?: InputMaybe<SortOrderInput>;
    reattributionState?: InputMaybe<SortOrderInput>;
    source?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    transactionIds?: InputMaybe<SortOrder>;
    unappliedBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrderInput>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export type EhrPostLedgerOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrderInput>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    chargedBoughtTreatmentIds?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrClaimId?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrderInput>;
    ehrDepartmentId?: InputMaybe<SortOrderInput>;
    ehrEpaymentId?: InputMaybe<SortOrderInput>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrPaymentId?: InputMaybe<SortOrderInput>;
    ehrPostAgainstIdentifier?: InputMaybe<SortOrderInput>;
    ehrPostAgainstIdentifierType?: InputMaybe<SortOrderInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    ehrType?: InputMaybe<SortOrderInput>;
    feesAndPayoutsProcessedAt?: InputMaybe<SortOrderInput>;
    feesAndPayoutsProcessingStatus?: InputMaybe<SortOrderInput>;
    feesProcessedAt?: InputMaybe<SortOrderInput>;
    feesProcessingStatus?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    mcmsAssociationId?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    paymentId?: InputMaybe<SortOrderInput>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    payoutIds?: InputMaybe<SortOrder>;
    payoutsProcessedAt?: InputMaybe<SortOrderInput>;
    payoutsProcessingStatus?: InputMaybe<SortOrderInput>;
    postedAt?: InputMaybe<SortOrderInput>;
    reattributionState?: InputMaybe<SortOrderInput>;
    source?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    transactionIds?: InputMaybe<SortOrder>;
    unappliedBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrderInput>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export enum EhrPostLedgerScalarFieldEnum {
    Amount = 'amount',
    AppointmentId = 'appointmentId',
    BoughtTreatmentIds = 'boughtTreatmentIds',
    CardLastFourDigits = 'cardLastFourDigits',
    ChargedBoughtTreatmentIds = 'chargedBoughtTreatmentIds',
    ClaimId = 'claimId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    EhrAppointmentId = 'ehrAppointmentId',
    EhrClaimId = 'ehrClaimId',
    EhrContextId = 'ehrContextId',
    EhrDepartmentId = 'ehrDepartmentId',
    EhrEpaymentId = 'ehrEpaymentId',
    EhrPatientId = 'ehrPatientId',
    EhrPaymentId = 'ehrPaymentId',
    EhrPostAgainstIdentifier = 'ehrPostAgainstIdentifier',
    EhrPostAgainstIdentifierType = 'ehrPostAgainstIdentifierType',
    EhrSlotId = 'ehrSlotId',
    EhrType = 'ehrType',
    FeesAndPayoutsProcessedAt = 'feesAndPayoutsProcessedAt',
    FeesAndPayoutsProcessingStatus = 'feesAndPayoutsProcessingStatus',
    FeesProcessedAt = 'feesProcessedAt',
    FeesProcessingStatus = 'feesProcessingStatus',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    McmsAssociationId = 'mcmsAssociationId',
    OrgId = 'orgId',
    PaymentId = 'paymentId',
    PaymentMethodType = 'paymentMethodType',
    PayoutIds = 'payoutIds',
    PayoutsProcessedAt = 'payoutsProcessedAt',
    PayoutsProcessingStatus = 'payoutsProcessingStatus',
    PostedAt = 'postedAt',
    ReattributionState = 'reattributionState',
    Source = 'source',
    Status = 'status',
    TransactionIds = 'transactionIds',
    UnappliedBoughtTreatmentId = 'unappliedBoughtTreatmentId',
    UpdatedAt = 'updatedAt',
    VoidReason = 'voidReason',
    VoidedAt = 'voidedAt',
}

export type EhrPostLedgerScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<EhrPostLedgerScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<EhrPostLedgerScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<EhrPostLedgerScalarWhereWithAggregatesInput>>;
    amount?: InputMaybe<FloatWithAggregatesFilter>;
    appointmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableWithAggregatesFilter>;
    chargedBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrClaimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrContextId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrDepartmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrEpaymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPatientId?: InputMaybe<StringWithAggregatesFilter>;
    ehrPaymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPostAgainstIdentifier?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPostAgainstIdentifierType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableWithAggregatesFilter>;
    ehrSlotId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrType?: InputMaybe<EnumEhrTypeEnumNullableWithAggregatesFilter>;
    feesAndPayoutsProcessedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    feesAndPayoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableWithAggregatesFilter>;
    feesProcessedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    feesProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    mcmsAssociationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    paymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableWithAggregatesFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    payoutsProcessedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    payoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableWithAggregatesFilter>;
    postedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableWithAggregatesFilter>;
    source?: InputMaybe<EnumEhrPostLedgerSourceEnumNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumEhrPostStatusEnumWithAggregatesFilter>;
    transactionIds?: InputMaybe<StringNullableListFilter>;
    unappliedBoughtTreatmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    voidReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    voidedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export enum EhrPostLedgerSourceEnum {
    Adjudication = 'ADJUDICATION',
    Adjustment = 'ADJUSTMENT',
    Collection = 'COLLECTION',
    Guarantee = 'GUARANTEE',
    Reprice = 'REPRICE',
}

export type EhrPostLedgerSumAggregate = {
    __typename?: 'EhrPostLedgerSumAggregate';
    amount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrPostLedgerSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerToPayout = {
    __typename?: 'EhrPostLedgerToPayout';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    payoutId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrPostLedgerToPayoutCountAggregate = {
    __typename?: 'EhrPostLedgerToPayoutCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrPostLedgerId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    payoutId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type EhrPostLedgerToPayoutCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerToPayoutCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrPostLedgerId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    payoutId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPostLedgerToPayoutCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrPostLedgerId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    payoutId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrPostLedgerToPayoutGroupBy = {
    __typename?: 'EhrPostLedgerToPayoutGroupBy';
    _count?: Maybe<EhrPostLedgerToPayoutCountAggregate>;
    _max?: Maybe<EhrPostLedgerToPayoutMaxAggregate>;
    _min?: Maybe<EhrPostLedgerToPayoutMinAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    payoutId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrPostLedgerToPayoutMaxAggregate = {
    __typename?: 'EhrPostLedgerToPayoutMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    payoutId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostLedgerToPayoutMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerToPayoutMinAggregate = {
    __typename?: 'EhrPostLedgerToPayoutMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    payoutId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrPostLedgerToPayoutMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerToPayoutOrderByWithAggregationInput = {
    _count?: InputMaybe<EhrPostLedgerToPayoutCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrPostLedgerToPayoutMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrPostLedgerToPayoutMinOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrPostLedgerToPayoutOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum EhrPostLedgerToPayoutScalarFieldEnum {
    CreatedAt = 'createdAt',
    EhrPostLedgerId = 'ehrPostLedgerId',
    Id = 'id',
    PayoutId = 'payoutId',
    UpdatedAt = 'updatedAt',
}

export type EhrPostLedgerToPayoutScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<EhrPostLedgerToPayoutScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<EhrPostLedgerToPayoutScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<EhrPostLedgerToPayoutScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrPostLedgerId?: InputMaybe<UuidWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    payoutId?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EhrPostLedgerToPayoutUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    payoutId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrPostLedgerToPayoutUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    payoutId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrPostLedgerToPayoutWhereInput = {
    AND?: InputMaybe<Array<EhrPostLedgerToPayoutWhereInput>>;
    NOT?: InputMaybe<Array<EhrPostLedgerToPayoutWhereInput>>;
    OR?: InputMaybe<Array<EhrPostLedgerToPayoutWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrPostLedgerId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<UuidFilter>;
    payoutId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrPostLedgerToPayoutWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrPostLedgerToPayoutWhereInput>>;
    NOT?: InputMaybe<Array<EhrPostLedgerToPayoutWhereInput>>;
    OR?: InputMaybe<Array<EhrPostLedgerToPayoutWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrPostLedgerId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    payoutId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrPostLedgerUpdateInput = {
    amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<EhrPostLedgerUpdateboughtTreatmentIdsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    chargedBoughtTreatmentIds?: InputMaybe<EhrPostLedgerUpdatechargedBoughtTreatmentIdsInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrEpaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostAgainstIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostAgainstIdentifierType?: InputMaybe<NullableEnumEhrPostIdentifierTypeEnumFieldUpdateOperationsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrType?: InputMaybe<NullableEnumEhrTypeEnumFieldUpdateOperationsInput>;
    feesAndPayoutsProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    feesAndPayoutsProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    feesProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    feesProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    mcmsAssociationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<EhrPostLedgerUpdatepayoutIdsInput>;
    payoutsProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    payoutsProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    postedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    source?: InputMaybe<NullableEnumEhrPostLedgerSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEhrPostStatusEnumFieldUpdateOperationsInput>;
    transactionIds?: InputMaybe<EhrPostLedgerUpdatetransactionIdsInput>;
    unappliedBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type EhrPostLedgerUpdateManyMutationInput = {
    amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<EhrPostLedgerUpdateboughtTreatmentIdsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    chargedBoughtTreatmentIds?: InputMaybe<EhrPostLedgerUpdatechargedBoughtTreatmentIdsInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrEpaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostAgainstIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostAgainstIdentifierType?: InputMaybe<NullableEnumEhrPostIdentifierTypeEnumFieldUpdateOperationsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrType?: InputMaybe<NullableEnumEhrTypeEnumFieldUpdateOperationsInput>;
    feesAndPayoutsProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    feesAndPayoutsProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    feesProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    feesProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    mcmsAssociationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    payoutIds?: InputMaybe<EhrPostLedgerUpdatepayoutIdsInput>;
    payoutsProcessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    payoutsProcessingStatus?: InputMaybe<NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput>;
    postedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    source?: InputMaybe<NullableEnumEhrPostLedgerSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEhrPostStatusEnumFieldUpdateOperationsInput>;
    transactionIds?: InputMaybe<EhrPostLedgerUpdatetransactionIdsInput>;
    unappliedBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type EhrPostLedgerUpdateboughtTreatmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EhrPostLedgerUpdatechargedBoughtTreatmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EhrPostLedgerUpdatepayoutIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EhrPostLedgerUpdatetransactionIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EhrPostLedgerWhereInput = {
    AND?: InputMaybe<Array<EhrPostLedgerWhereInput>>;
    NOT?: InputMaybe<Array<EhrPostLedgerWhereInput>>;
    OR?: InputMaybe<Array<EhrPostLedgerWhereInput>>;
    amount?: InputMaybe<FloatFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    chargedBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrClaimId?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringNullableFilter>;
    ehrDepartmentId?: InputMaybe<StringNullableFilter>;
    ehrEpaymentId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringFilter>;
    ehrPaymentId?: InputMaybe<StringNullableFilter>;
    ehrPostAgainstIdentifier?: InputMaybe<StringNullableFilter>;
    ehrPostAgainstIdentifierType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableFilter>;
    ehrSlotId?: InputMaybe<StringNullableFilter>;
    ehrType?: InputMaybe<EnumEhrTypeEnumNullableFilter>;
    feesAndPayoutsProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    feesAndPayoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    feesProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    feesProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    mcmsAssociationId?: InputMaybe<UuidNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentId?: InputMaybe<StringNullableFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    payoutsProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    payoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    postedAt?: InputMaybe<DateTimeNullableFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    source?: InputMaybe<EnumEhrPostLedgerSourceEnumNullableFilter>;
    status?: InputMaybe<EnumEhrPostStatusEnumFilter>;
    transactionIds?: InputMaybe<StringNullableListFilter>;
    unappliedBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidReason?: InputMaybe<StringNullableFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type EhrPostLedgerWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrPostLedgerWhereInput>>;
    NOT?: InputMaybe<Array<EhrPostLedgerWhereInput>>;
    OR?: InputMaybe<Array<EhrPostLedgerWhereInput>>;
    amount?: InputMaybe<FloatFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    chargedBoughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrClaimId?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringNullableFilter>;
    ehrDepartmentId?: InputMaybe<StringNullableFilter>;
    ehrEpaymentId?: InputMaybe<StringNullableFilter>;
    ehrPatientId?: InputMaybe<StringFilter>;
    ehrPaymentId?: InputMaybe<StringNullableFilter>;
    ehrPostAgainstIdentifier?: InputMaybe<StringNullableFilter>;
    ehrPostAgainstIdentifierType?: InputMaybe<EnumEhrPostIdentifierTypeEnumNullableFilter>;
    ehrSlotId?: InputMaybe<StringNullableFilter>;
    ehrType?: InputMaybe<EnumEhrTypeEnumNullableFilter>;
    feesAndPayoutsProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    feesAndPayoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    feesProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    feesProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    mcmsAssociationId?: InputMaybe<UuidNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentId?: InputMaybe<StringNullableFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableFilter>;
    payoutIds?: InputMaybe<StringNullableListFilter>;
    payoutsProcessedAt?: InputMaybe<DateTimeNullableFilter>;
    payoutsProcessingStatus?: InputMaybe<EnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    postedAt?: InputMaybe<DateTimeNullableFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    source?: InputMaybe<EnumEhrPostLedgerSourceEnumNullableFilter>;
    status?: InputMaybe<EnumEhrPostStatusEnumFilter>;
    transactionIds?: InputMaybe<StringNullableListFilter>;
    unappliedBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidReason?: InputMaybe<StringNullableFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum EhrPostStatusEnum {
    CancelledPost = 'CANCELLED_POST',
    CancelledVoid = 'CANCELLED_VOID',
    PendingPost = 'PENDING_POST',
    PendingVoid = 'PENDING_VOID',
    Posted = 'POSTED',
    PostInProgress = 'POST_IN_PROGRESS',
    Voided = 'VOIDED',
    VoidInProgress = 'VOID_IN_PROGRESS',
}

export type EhrPrimaryCareProvider = {
    __typename?: 'EhrPrimaryCareProvider';
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrId: Scalars['String']['output'];
    fax?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    isDeleted: Scalars['Boolean']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    middleName?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    npi?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zip?: Maybe<Scalars['String']['output']>;
};

export type EhrPrimaryCareProviderAvgAggregate = {
    __typename?: 'EhrPrimaryCareProviderAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrPrimaryCareProviderAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type EhrPrimaryCareProviderCountAggregate = {
    __typename?: 'EhrPrimaryCareProviderCountAggregate';
    _all: Scalars['Int']['output'];
    address1: Scalars['Int']['output'];
    address2: Scalars['Int']['output'];
    city: Scalars['Int']['output'];
    contextId: Scalars['Int']['output'];
    country: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrId: Scalars['Int']['output'];
    fax: Scalars['Int']['output'];
    firstName: Scalars['Int']['output'];
    isDeleted: Scalars['Int']['output'];
    lastName: Scalars['Int']['output'];
    middleName: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    phone: Scalars['Int']['output'];
    placeName: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    zip: Scalars['Int']['output'];
};

export type EhrPrimaryCareProviderCountOrderByAggregateInput = {
    address1?: InputMaybe<SortOrder>;
    address2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    middleName?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    placeName?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type EhrPrimaryCareProviderCreateInput = {
    address1?: InputMaybe<Scalars['String']['input']>;
    address2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    contextId?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrId: Scalars['String']['input'];
    fax?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    middleName?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    phone?: InputMaybe<Scalars['String']['input']>;
    placeName?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type EhrPrimaryCareProviderCreateManyInput = {
    address1?: InputMaybe<Scalars['String']['input']>;
    address2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    contextId?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrId: Scalars['String']['input'];
    fax?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    middleName?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    phone?: InputMaybe<Scalars['String']['input']>;
    placeName?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type EhrPrimaryCareProviderEhrIdNameOrgIdCompoundUniqueInput = {
    ehrId: Scalars['String']['input'];
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
};

export type EhrPrimaryCareProviderGroupBy = {
    __typename?: 'EhrPrimaryCareProviderGroupBy';
    _avg?: Maybe<EhrPrimaryCareProviderAvgAggregate>;
    _count?: Maybe<EhrPrimaryCareProviderCountAggregate>;
    _max?: Maybe<EhrPrimaryCareProviderMaxAggregate>;
    _min?: Maybe<EhrPrimaryCareProviderMinAggregate>;
    _sum?: Maybe<EhrPrimaryCareProviderSumAggregate>;
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrId: Scalars['String']['output'];
    fax?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    isDeleted: Scalars['Boolean']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    middleName?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    npi?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zip?: Maybe<Scalars['String']['output']>;
};

export type EhrPrimaryCareProviderMaxAggregate = {
    __typename?: 'EhrPrimaryCareProviderMaxAggregate';
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrId?: Maybe<Scalars['String']['output']>;
    fax?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    isDeleted?: Maybe<Scalars['Boolean']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    middleName?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type EhrPrimaryCareProviderMaxOrderByAggregateInput = {
    address1?: InputMaybe<SortOrder>;
    address2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    middleName?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    placeName?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type EhrPrimaryCareProviderMinAggregate = {
    __typename?: 'EhrPrimaryCareProviderMinAggregate';
    address1?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    contextId?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrId?: Maybe<Scalars['String']['output']>;
    fax?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    isDeleted?: Maybe<Scalars['Boolean']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    middleName?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    placeName?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type EhrPrimaryCareProviderMinOrderByAggregateInput = {
    address1?: InputMaybe<SortOrder>;
    address2?: InputMaybe<SortOrder>;
    city?: InputMaybe<SortOrder>;
    contextId?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    middleName?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    placeName?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrder>;
};

export type EhrPrimaryCareProviderOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrPrimaryCareProviderAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrPrimaryCareProviderCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrPrimaryCareProviderMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrPrimaryCareProviderMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrPrimaryCareProviderSumOrderByAggregateInput>;
    address1?: InputMaybe<SortOrderInput>;
    address2?: InputMaybe<SortOrderInput>;
    city?: InputMaybe<SortOrderInput>;
    contextId?: InputMaybe<SortOrderInput>;
    country?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrderInput>;
    firstName?: InputMaybe<SortOrderInput>;
    isDeleted?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrderInput>;
    middleName?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrderInput>;
    placeName?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrderInput>;
};

export type EhrPrimaryCareProviderOrderByWithRelationInput = {
    address1?: InputMaybe<SortOrderInput>;
    address2?: InputMaybe<SortOrderInput>;
    city?: InputMaybe<SortOrderInput>;
    contextId?: InputMaybe<SortOrderInput>;
    country?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    fax?: InputMaybe<SortOrderInput>;
    firstName?: InputMaybe<SortOrderInput>;
    isDeleted?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrderInput>;
    middleName?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrderInput>;
    placeName?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zip?: InputMaybe<SortOrderInput>;
};

export enum EhrPrimaryCareProviderScalarFieldEnum {
    Address1 = 'address1',
    Address2 = 'address2',
    City = 'city',
    ContextId = 'contextId',
    Country = 'country',
    CreatedAt = 'createdAt',
    EhrId = 'ehrId',
    Fax = 'fax',
    FirstName = 'firstName',
    IsDeleted = 'isDeleted',
    LastName = 'lastName',
    MiddleName = 'middleName',
    Name = 'name',
    Npi = 'npi',
    OrgId = 'orgId',
    Phone = 'phone',
    PlaceName = 'placeName',
    State = 'state',
    UpdatedAt = 'updatedAt',
    Zip = 'zip',
}

export type EhrPrimaryCareProviderScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<EhrPrimaryCareProviderScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<EhrPrimaryCareProviderScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<EhrPrimaryCareProviderScalarWhereWithAggregatesInput>
    >;
    address1?: InputMaybe<StringNullableWithAggregatesFilter>;
    address2?: InputMaybe<StringNullableWithAggregatesFilter>;
    city?: InputMaybe<StringNullableWithAggregatesFilter>;
    contextId?: InputMaybe<StringNullableWithAggregatesFilter>;
    country?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrId?: InputMaybe<StringWithAggregatesFilter>;
    fax?: InputMaybe<StringNullableWithAggregatesFilter>;
    firstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    isDeleted?: InputMaybe<BoolWithAggregatesFilter>;
    lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    middleName?: InputMaybe<StringNullableWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    npi?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    phone?: InputMaybe<StringNullableWithAggregatesFilter>;
    placeName?: InputMaybe<StringNullableWithAggregatesFilter>;
    state?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    zip?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type EhrPrimaryCareProviderSumAggregate = {
    __typename?: 'EhrPrimaryCareProviderSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrPrimaryCareProviderSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type EhrPrimaryCareProviderUpdateInput = {
    address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<StringFieldUpdateOperationsInput>;
    fax?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EhrPrimaryCareProviderUpdateManyMutationInput = {
    address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<StringFieldUpdateOperationsInput>;
    fax?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EhrPrimaryCareProviderWhereInput = {
    AND?: InputMaybe<Array<EhrPrimaryCareProviderWhereInput>>;
    NOT?: InputMaybe<Array<EhrPrimaryCareProviderWhereInput>>;
    OR?: InputMaybe<Array<EhrPrimaryCareProviderWhereInput>>;
    address1?: InputMaybe<StringNullableFilter>;
    address2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    contextId?: InputMaybe<StringNullableFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrId?: InputMaybe<StringFilter>;
    fax?: InputMaybe<StringNullableFilter>;
    firstName?: InputMaybe<StringNullableFilter>;
    isDeleted?: InputMaybe<BoolFilter>;
    lastName?: InputMaybe<StringNullableFilter>;
    middleName?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    placeName?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type EhrPrimaryCareProviderWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrPrimaryCareProviderWhereInput>>;
    NOT?: InputMaybe<Array<EhrPrimaryCareProviderWhereInput>>;
    OR?: InputMaybe<Array<EhrPrimaryCareProviderWhereInput>>;
    address1?: InputMaybe<StringNullableFilter>;
    address2?: InputMaybe<StringNullableFilter>;
    city?: InputMaybe<StringNullableFilter>;
    contextId?: InputMaybe<StringNullableFilter>;
    country?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrId?: InputMaybe<StringFilter>;
    ehrId_name_orgId?: InputMaybe<EhrPrimaryCareProviderEhrIdNameOrgIdCompoundUniqueInput>;
    fax?: InputMaybe<StringNullableFilter>;
    firstName?: InputMaybe<StringNullableFilter>;
    isDeleted?: InputMaybe<BoolFilter>;
    lastName?: InputMaybe<StringNullableFilter>;
    middleName?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    placeName?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zip?: InputMaybe<StringNullableFilter>;
};

export type EhrProviderMapping = {
    __typename?: 'EhrProviderMapping';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrBillingName?: Maybe<Scalars['String']['output']>;
    ehrContextId: Scalars['String']['output'];
    ehrProviderGroupId?: Maybe<Scalars['Int']['output']>;
    ehrProviderId: Scalars['Int']['output'];
    ehrSchedulingName?: Maybe<Scalars['String']['output']>;
    isDeleted: Scalars['Boolean']['output'];
    npi: Scalars['String']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrProviderMappingAvgAggregate = {
    __typename?: 'EhrProviderMappingAvgAggregate';
    ehrProviderGroupId?: Maybe<Scalars['Float']['output']>;
    ehrProviderId?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrProviderMappingAvgOrderByAggregateInput = {
    ehrProviderGroupId?: InputMaybe<SortOrder>;
    ehrProviderId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrProviderMappingCountAggregate = {
    __typename?: 'EhrProviderMappingCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrBillingName: Scalars['Int']['output'];
    ehrContextId: Scalars['Int']['output'];
    ehrProviderGroupId: Scalars['Int']['output'];
    ehrProviderId: Scalars['Int']['output'];
    ehrSchedulingName: Scalars['Int']['output'];
    isDeleted: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type EhrProviderMappingCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrBillingName?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrProviderGroupId?: InputMaybe<SortOrder>;
    ehrProviderId?: InputMaybe<SortOrder>;
    ehrSchedulingName?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrProviderMappingCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrBillingName?: InputMaybe<Scalars['String']['input']>;
    ehrContextId: Scalars['String']['input'];
    ehrProviderGroupId?: InputMaybe<Scalars['Int']['input']>;
    ehrProviderId: Scalars['Int']['input'];
    ehrSchedulingName?: InputMaybe<Scalars['String']['input']>;
    isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    npi: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutEhrProviderMappingInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrProviderMappingCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrBillingName?: InputMaybe<Scalars['String']['input']>;
    ehrContextId: Scalars['String']['input'];
    ehrProviderGroupId?: InputMaybe<Scalars['Int']['input']>;
    ehrProviderId: Scalars['Int']['input'];
    ehrSchedulingName?: InputMaybe<Scalars['String']['input']>;
    isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    npi: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrProviderMappingCreateManyOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrBillingName?: InputMaybe<Scalars['String']['input']>;
    ehrContextId: Scalars['String']['input'];
    ehrProviderGroupId?: InputMaybe<Scalars['Int']['input']>;
    ehrProviderId: Scalars['Int']['input'];
    ehrSchedulingName?: InputMaybe<Scalars['String']['input']>;
    isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    npi: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrProviderMappingCreateManyOrgInputEnvelope = {
    data: Array<EhrProviderMappingCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EhrProviderMappingCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<EhrProviderMappingWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<EhrProviderMappingCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<EhrProviderMappingCreateWithoutOrgInput>>;
    createMany?: InputMaybe<EhrProviderMappingCreateManyOrgInputEnvelope>;
};

export type EhrProviderMappingCreateOrConnectWithoutOrgInput = {
    create: EhrProviderMappingCreateWithoutOrgInput;
    where: EhrProviderMappingWhereUniqueInput;
};

export type EhrProviderMappingCreateWithoutOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrBillingName?: InputMaybe<Scalars['String']['input']>;
    ehrContextId: Scalars['String']['input'];
    ehrProviderGroupId?: InputMaybe<Scalars['Int']['input']>;
    ehrProviderId: Scalars['Int']['input'];
    ehrSchedulingName?: InputMaybe<Scalars['String']['input']>;
    isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    npi: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrProviderMappingEhrContextIdEhrProviderIdOrgIdCompoundUniqueInput =
    {
        ehrContextId: Scalars['String']['input'];
        ehrProviderId: Scalars['Int']['input'];
        orgId: Scalars['Int']['input'];
    };

export type EhrProviderMappingGroupBy = {
    __typename?: 'EhrProviderMappingGroupBy';
    _avg?: Maybe<EhrProviderMappingAvgAggregate>;
    _count?: Maybe<EhrProviderMappingCountAggregate>;
    _max?: Maybe<EhrProviderMappingMaxAggregate>;
    _min?: Maybe<EhrProviderMappingMinAggregate>;
    _sum?: Maybe<EhrProviderMappingSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrBillingName?: Maybe<Scalars['String']['output']>;
    ehrContextId: Scalars['String']['output'];
    ehrProviderGroupId?: Maybe<Scalars['Int']['output']>;
    ehrProviderId: Scalars['Int']['output'];
    ehrSchedulingName?: Maybe<Scalars['String']['output']>;
    isDeleted: Scalars['Boolean']['output'];
    npi: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrProviderMappingListRelationFilter = {
    every?: InputMaybe<EhrProviderMappingWhereInput>;
    none?: InputMaybe<EhrProviderMappingWhereInput>;
    some?: InputMaybe<EhrProviderMappingWhereInput>;
};

export type EhrProviderMappingMaxAggregate = {
    __typename?: 'EhrProviderMappingMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrBillingName?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrProviderGroupId?: Maybe<Scalars['Int']['output']>;
    ehrProviderId?: Maybe<Scalars['Int']['output']>;
    ehrSchedulingName?: Maybe<Scalars['String']['output']>;
    isDeleted?: Maybe<Scalars['Boolean']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrProviderMappingMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrBillingName?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrProviderGroupId?: InputMaybe<SortOrder>;
    ehrProviderId?: InputMaybe<SortOrder>;
    ehrSchedulingName?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrProviderMappingMinAggregate = {
    __typename?: 'EhrProviderMappingMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrBillingName?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrProviderGroupId?: Maybe<Scalars['Int']['output']>;
    ehrProviderId?: Maybe<Scalars['Int']['output']>;
    ehrSchedulingName?: Maybe<Scalars['String']['output']>;
    isDeleted?: Maybe<Scalars['Boolean']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrProviderMappingMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrBillingName?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrProviderGroupId?: InputMaybe<SortOrder>;
    ehrProviderId?: InputMaybe<SortOrder>;
    ehrSchedulingName?: InputMaybe<SortOrder>;
    isDeleted?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrProviderMappingOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type EhrProviderMappingOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrProviderMappingAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrProviderMappingCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrProviderMappingMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrProviderMappingMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrProviderMappingSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrBillingName?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrProviderGroupId?: InputMaybe<SortOrderInput>;
    ehrProviderId?: InputMaybe<SortOrder>;
    ehrSchedulingName?: InputMaybe<SortOrderInput>;
    isDeleted?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrProviderMappingOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrBillingName?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrProviderGroupId?: InputMaybe<SortOrderInput>;
    ehrProviderId?: InputMaybe<SortOrder>;
    ehrSchedulingName?: InputMaybe<SortOrderInput>;
    isDeleted?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum EhrProviderMappingScalarFieldEnum {
    CreatedAt = 'createdAt',
    EhrBillingName = 'ehrBillingName',
    EhrContextId = 'ehrContextId',
    EhrProviderGroupId = 'ehrProviderGroupId',
    EhrProviderId = 'ehrProviderId',
    EhrSchedulingName = 'ehrSchedulingName',
    IsDeleted = 'isDeleted',
    Npi = 'npi',
    OrgId = 'orgId',
    UpdatedAt = 'updatedAt',
}

export type EhrProviderMappingScalarWhereInput = {
    AND?: InputMaybe<Array<EhrProviderMappingScalarWhereInput>>;
    NOT?: InputMaybe<Array<EhrProviderMappingScalarWhereInput>>;
    OR?: InputMaybe<Array<EhrProviderMappingScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrBillingName?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringFilter>;
    ehrProviderGroupId?: InputMaybe<IntNullableFilter>;
    ehrProviderId?: InputMaybe<IntFilter>;
    ehrSchedulingName?: InputMaybe<StringNullableFilter>;
    isDeleted?: InputMaybe<BoolFilter>;
    npi?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrProviderMappingScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<EhrProviderMappingScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<EhrProviderMappingScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<EhrProviderMappingScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrBillingName?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrContextId?: InputMaybe<StringWithAggregatesFilter>;
    ehrProviderGroupId?: InputMaybe<IntNullableWithAggregatesFilter>;
    ehrProviderId?: InputMaybe<IntWithAggregatesFilter>;
    ehrSchedulingName?: InputMaybe<StringNullableWithAggregatesFilter>;
    isDeleted?: InputMaybe<BoolWithAggregatesFilter>;
    npi?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EhrProviderMappingSumAggregate = {
    __typename?: 'EhrProviderMappingSumAggregate';
    ehrProviderGroupId?: Maybe<Scalars['Int']['output']>;
    ehrProviderId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrProviderMappingSumOrderByAggregateInput = {
    ehrProviderGroupId?: InputMaybe<SortOrder>;
    ehrProviderId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrProviderMappingUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrBillingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrProviderGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    ehrProviderId?: InputMaybe<IntFieldUpdateOperationsInput>;
    ehrSchedulingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    npi?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutEhrProviderMappingNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrProviderMappingUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrBillingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrProviderGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    ehrProviderId?: InputMaybe<IntFieldUpdateOperationsInput>;
    ehrSchedulingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    npi?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrProviderMappingUpdateManyWithWhereWithoutOrgInput = {
    data: EhrProviderMappingUpdateManyMutationInput;
    where: EhrProviderMappingScalarWhereInput;
};

export type EhrProviderMappingUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<EhrProviderMappingWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<EhrProviderMappingCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<EhrProviderMappingCreateWithoutOrgInput>>;
    createMany?: InputMaybe<EhrProviderMappingCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<EhrProviderMappingWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<EhrProviderMappingScalarWhereInput>>;
    disconnect?: InputMaybe<Array<EhrProviderMappingWhereUniqueInput>>;
    set?: InputMaybe<Array<EhrProviderMappingWhereUniqueInput>>;
    update?: InputMaybe<
        Array<EhrProviderMappingUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<EhrProviderMappingUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<EhrProviderMappingUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type EhrProviderMappingUpdateWithWhereUniqueWithoutOrgInput = {
    data: EhrProviderMappingUpdateWithoutOrgInput;
    where: EhrProviderMappingWhereUniqueInput;
};

export type EhrProviderMappingUpdateWithoutOrgInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrBillingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrProviderGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    ehrProviderId?: InputMaybe<IntFieldUpdateOperationsInput>;
    ehrSchedulingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isDeleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
    npi?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrProviderMappingUpsertWithWhereUniqueWithoutOrgInput = {
    create: EhrProviderMappingCreateWithoutOrgInput;
    update: EhrProviderMappingUpdateWithoutOrgInput;
    where: EhrProviderMappingWhereUniqueInput;
};

export type EhrProviderMappingWhereInput = {
    AND?: InputMaybe<Array<EhrProviderMappingWhereInput>>;
    NOT?: InputMaybe<Array<EhrProviderMappingWhereInput>>;
    OR?: InputMaybe<Array<EhrProviderMappingWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrBillingName?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringFilter>;
    ehrProviderGroupId?: InputMaybe<IntNullableFilter>;
    ehrProviderId?: InputMaybe<IntFilter>;
    ehrSchedulingName?: InputMaybe<StringNullableFilter>;
    isDeleted?: InputMaybe<BoolFilter>;
    npi?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrProviderMappingWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrProviderMappingWhereInput>>;
    NOT?: InputMaybe<Array<EhrProviderMappingWhereInput>>;
    OR?: InputMaybe<Array<EhrProviderMappingWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrBillingName?: InputMaybe<StringNullableFilter>;
    ehrContextId?: InputMaybe<StringFilter>;
    ehrContextId_ehrProviderId_orgId?: InputMaybe<EhrProviderMappingEhrContextIdEhrProviderIdOrgIdCompoundUniqueInput>;
    ehrProviderGroupId?: InputMaybe<IntNullableFilter>;
    ehrProviderId?: InputMaybe<IntFilter>;
    ehrSchedulingName?: InputMaybe<StringNullableFilter>;
    isDeleted?: InputMaybe<BoolFilter>;
    npi?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrSlot = {
    __typename?: 'EhrSlot';
    Slot: Array<Slot>;
    _count?: Maybe<EhrSlotCount>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrLocationId: Scalars['String']['output'];
    ehrSlotNoteId?: Maybe<Scalars['String']['output']>;
    ehrVisitIds: Array<Scalars['String']['output']>;
    encounters: Array<Encounter>;
    experityEncounters: Array<ExperityEncounter>;
    id: Scalars['String']['output'];
    isCustomSlot: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    patientId: Scalars['String']['output'];
    scheduleSlotName?: Maybe<Scalars['String']['output']>;
    status: EhrSlotStatusEnum;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrSlotSlotArgs = {
    cursor?: InputMaybe<SlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotWhereInput>;
};

export type EhrSlotEncountersArgs = {
    cursor?: InputMaybe<EncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<EncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EncounterOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EncounterWhereInput>;
};

export type EhrSlotExperityEncountersArgs = {
    cursor?: InputMaybe<ExperityEncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<ExperityEncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ExperityEncounterOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ExperityEncounterWhereInput>;
};

export type EhrSlotAuditLog = {
    __typename?: 'EhrSlotAuditLog';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrSlotNoteId?: Maybe<Scalars['String']['output']>;
    ehrVisitIds: Array<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    isCustomSlot?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    patientId?: Maybe<Scalars['String']['output']>;
    scheduleSlotName?: Maybe<Scalars['String']['output']>;
    status?: Maybe<EhrSlotStatusEnum>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrSlotAuditLogAvgAggregate = {
    __typename?: 'EhrSlotAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrSlotAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrSlotAuditLogCountAggregate = {
    __typename?: 'EhrSlotAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrAppointmentId: Scalars['Int']['output'];
    ehrAppointmentTypeId: Scalars['Int']['output'];
    ehrLocationId: Scalars['Int']['output'];
    ehrSlotId: Scalars['Int']['output'];
    ehrSlotNoteId: Scalars['Int']['output'];
    ehrVisitIds: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isCustomSlot: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    patientId: Scalars['Int']['output'];
    scheduleSlotName: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type EhrSlotAuditLogCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrder>;
    ehrLocationId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    ehrSlotNoteId?: InputMaybe<SortOrder>;
    ehrVisitIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isCustomSlot?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientId?: InputMaybe<SortOrder>;
    scheduleSlotName?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrSlotAuditLogCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    ehrSlotNoteId?: InputMaybe<Scalars['String']['input']>;
    ehrVisitIds?: InputMaybe<EhrSlotAuditLogCreateehrVisitIdsInput>;
    isCustomSlot?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    patientId?: InputMaybe<Scalars['String']['input']>;
    scheduleSlotName?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<EhrSlotStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrSlotAuditLogCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    ehrSlotNoteId?: InputMaybe<Scalars['String']['input']>;
    ehrVisitIds?: InputMaybe<EhrSlotAuditLogCreateehrVisitIdsInput>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isCustomSlot?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    patientId?: InputMaybe<Scalars['String']['input']>;
    scheduleSlotName?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<EhrSlotStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrSlotAuditLogCreateehrVisitIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EhrSlotAuditLogGroupBy = {
    __typename?: 'EhrSlotAuditLogGroupBy';
    _avg?: Maybe<EhrSlotAuditLogAvgAggregate>;
    _count?: Maybe<EhrSlotAuditLogCountAggregate>;
    _max?: Maybe<EhrSlotAuditLogMaxAggregate>;
    _min?: Maybe<EhrSlotAuditLogMinAggregate>;
    _sum?: Maybe<EhrSlotAuditLogSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrSlotNoteId?: Maybe<Scalars['String']['output']>;
    ehrVisitIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['Int']['output'];
    isCustomSlot?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    patientId?: Maybe<Scalars['String']['output']>;
    scheduleSlotName?: Maybe<Scalars['String']['output']>;
    status?: Maybe<EhrSlotStatusEnum>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type EhrSlotAuditLogMaxAggregate = {
    __typename?: 'EhrSlotAuditLogMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrSlotNoteId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isCustomSlot?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientId?: Maybe<Scalars['String']['output']>;
    scheduleSlotName?: Maybe<Scalars['String']['output']>;
    status?: Maybe<EhrSlotStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrSlotAuditLogMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrder>;
    ehrLocationId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    ehrSlotNoteId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isCustomSlot?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientId?: InputMaybe<SortOrder>;
    scheduleSlotName?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrSlotAuditLogMinAggregate = {
    __typename?: 'EhrSlotAuditLogMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    ehrSlotNoteId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isCustomSlot?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientId?: Maybe<Scalars['String']['output']>;
    scheduleSlotName?: Maybe<Scalars['String']['output']>;
    status?: Maybe<EhrSlotStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrSlotAuditLogMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrder>;
    ehrLocationId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    ehrSlotNoteId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isCustomSlot?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientId?: InputMaybe<SortOrder>;
    scheduleSlotName?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrSlotAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrSlotAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrSlotAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrSlotAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrSlotAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrSlotAuditLogSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrAppointmentTypeId?: InputMaybe<SortOrderInput>;
    ehrLocationId?: InputMaybe<SortOrderInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    ehrSlotNoteId?: InputMaybe<SortOrderInput>;
    ehrVisitIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isCustomSlot?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    patientId?: InputMaybe<SortOrderInput>;
    scheduleSlotName?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrSlotAuditLogOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrAppointmentTypeId?: InputMaybe<SortOrderInput>;
    ehrLocationId?: InputMaybe<SortOrderInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    ehrSlotNoteId?: InputMaybe<SortOrderInput>;
    ehrVisitIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isCustomSlot?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    patientId?: InputMaybe<SortOrderInput>;
    scheduleSlotName?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum EhrSlotAuditLogScalarFieldEnum {
    CreatedAt = 'createdAt',
    EhrAppointmentId = 'ehrAppointmentId',
    EhrAppointmentTypeId = 'ehrAppointmentTypeId',
    EhrLocationId = 'ehrLocationId',
    EhrSlotId = 'ehrSlotId',
    EhrSlotNoteId = 'ehrSlotNoteId',
    EhrVisitIds = 'ehrVisitIds',
    Id = 'id',
    IsCustomSlot = 'isCustomSlot',
    LastUpdatedBy = 'lastUpdatedBy',
    Operation = 'operation',
    OrgId = 'orgId',
    PatientId = 'patientId',
    ScheduleSlotName = 'scheduleSlotName',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type EhrSlotAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<EhrSlotAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<EhrSlotAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<EhrSlotAuditLogScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrAppointmentTypeId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrLocationId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrSlotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    ehrSlotNoteId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrVisitIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isCustomSlot?: InputMaybe<BoolNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    patientId?: InputMaybe<StringNullableWithAggregatesFilter>;
    scheduleSlotName?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumEhrSlotStatusEnumNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EhrSlotAuditLogSumAggregate = {
    __typename?: 'EhrSlotAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrSlotAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type EhrSlotAuditLogUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrAppointmentTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrSlotNoteId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitIds?: InputMaybe<EhrSlotAuditLogUpdateehrVisitIdsInput>;
    isCustomSlot?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    patientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    scheduleSlotName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumEhrSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrSlotAuditLogUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrAppointmentTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrSlotNoteId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitIds?: InputMaybe<EhrSlotAuditLogUpdateehrVisitIdsInput>;
    isCustomSlot?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    patientId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    scheduleSlotName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumEhrSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EhrSlotAuditLogUpdateehrVisitIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EhrSlotAuditLogWhereInput = {
    AND?: InputMaybe<Array<EhrSlotAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<EhrSlotAuditLogWhereInput>>;
    OR?: InputMaybe<Array<EhrSlotAuditLogWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrAppointmentTypeId?: InputMaybe<StringNullableFilter>;
    ehrLocationId?: InputMaybe<StringNullableFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    ehrSlotNoteId?: InputMaybe<StringNullableFilter>;
    ehrVisitIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntFilter>;
    isCustomSlot?: InputMaybe<BoolNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    patientId?: InputMaybe<StringNullableFilter>;
    scheduleSlotName?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumEhrSlotStatusEnumNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrSlotAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrSlotAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<EhrSlotAuditLogWhereInput>>;
    OR?: InputMaybe<Array<EhrSlotAuditLogWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrAppointmentTypeId?: InputMaybe<StringNullableFilter>;
    ehrLocationId?: InputMaybe<StringNullableFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    ehrSlotNoteId?: InputMaybe<StringNullableFilter>;
    ehrVisitIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isCustomSlot?: InputMaybe<BoolNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    patientId?: InputMaybe<StringNullableFilter>;
    scheduleSlotName?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumEhrSlotStatusEnumNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EhrSlotAvgAggregate = {
    __typename?: 'EhrSlotAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type EhrSlotAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type EhrSlotCount = {
    __typename?: 'EhrSlotCount';
    Slot: Scalars['Int']['output'];
    encounters: Scalars['Int']['output'];
    experityEncounters: Scalars['Int']['output'];
};

export type EhrSlotCountSlotArgs = {
    where?: InputMaybe<SlotWhereInput>;
};

export type EhrSlotCountEncountersArgs = {
    where?: InputMaybe<EncounterWhereInput>;
};

export type EhrSlotCountExperityEncountersArgs = {
    where?: InputMaybe<ExperityEncounterWhereInput>;
};

export type EhrSlotCountAggregate = {
    __typename?: 'EhrSlotCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrAppointmentId: Scalars['Int']['output'];
    ehrAppointmentTypeId: Scalars['Int']['output'];
    ehrLocationId: Scalars['Int']['output'];
    ehrSlotNoteId: Scalars['Int']['output'];
    ehrVisitIds: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isCustomSlot: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    patientId: Scalars['Int']['output'];
    scheduleSlotName: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type EhrSlotCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrder>;
    ehrLocationId?: InputMaybe<SortOrder>;
    ehrSlotNoteId?: InputMaybe<SortOrder>;
    ehrVisitIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isCustomSlot?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientId?: InputMaybe<SortOrder>;
    scheduleSlotName?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrSlotCreateInput = {
    Slot?: InputMaybe<SlotCreateNestedManyWithoutEhrSlotInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrLocationId: Scalars['String']['input'];
    ehrSlotNoteId?: InputMaybe<Scalars['String']['input']>;
    ehrVisitIds?: InputMaybe<EhrSlotCreateehrVisitIdsInput>;
    encounters?: InputMaybe<EncounterCreateNestedManyWithoutEhrSlotInput>;
    experityEncounters?: InputMaybe<ExperityEncounterCreateNestedManyWithoutEhrSlotInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    isCustomSlot?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    patientId: Scalars['String']['input'];
    scheduleSlotName?: InputMaybe<Scalars['String']['input']>;
    status: EhrSlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrSlotCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrLocationId: Scalars['String']['input'];
    ehrSlotNoteId?: InputMaybe<Scalars['String']['input']>;
    ehrVisitIds?: InputMaybe<EhrSlotCreateehrVisitIdsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    isCustomSlot?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    patientId: Scalars['String']['input'];
    scheduleSlotName?: InputMaybe<Scalars['String']['input']>;
    status: EhrSlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrSlotCreateNestedOneWithoutEncountersInput = {
    connect?: InputMaybe<EhrSlotWhereUniqueInput>;
    connectOrCreate?: InputMaybe<EhrSlotCreateOrConnectWithoutEncountersInput>;
    create?: InputMaybe<EhrSlotCreateWithoutEncountersInput>;
};

export type EhrSlotCreateNestedOneWithoutExperityEncountersInput = {
    connect?: InputMaybe<EhrSlotWhereUniqueInput>;
    connectOrCreate?: InputMaybe<EhrSlotCreateOrConnectWithoutExperityEncountersInput>;
    create?: InputMaybe<EhrSlotCreateWithoutExperityEncountersInput>;
};

export type EhrSlotCreateNestedOneWithoutSlotInput = {
    connect?: InputMaybe<EhrSlotWhereUniqueInput>;
    connectOrCreate?: InputMaybe<EhrSlotCreateOrConnectWithoutSlotInput>;
    create?: InputMaybe<EhrSlotCreateWithoutSlotInput>;
};

export type EhrSlotCreateOrConnectWithoutEncountersInput = {
    create: EhrSlotCreateWithoutEncountersInput;
    where: EhrSlotWhereUniqueInput;
};

export type EhrSlotCreateOrConnectWithoutExperityEncountersInput = {
    create: EhrSlotCreateWithoutExperityEncountersInput;
    where: EhrSlotWhereUniqueInput;
};

export type EhrSlotCreateOrConnectWithoutSlotInput = {
    create: EhrSlotCreateWithoutSlotInput;
    where: EhrSlotWhereUniqueInput;
};

export type EhrSlotCreateWithoutEncountersInput = {
    Slot?: InputMaybe<SlotCreateNestedManyWithoutEhrSlotInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrLocationId: Scalars['String']['input'];
    ehrSlotNoteId?: InputMaybe<Scalars['String']['input']>;
    ehrVisitIds?: InputMaybe<EhrSlotCreateehrVisitIdsInput>;
    experityEncounters?: InputMaybe<ExperityEncounterCreateNestedManyWithoutEhrSlotInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    isCustomSlot?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    patientId: Scalars['String']['input'];
    scheduleSlotName?: InputMaybe<Scalars['String']['input']>;
    status: EhrSlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrSlotCreateWithoutExperityEncountersInput = {
    Slot?: InputMaybe<SlotCreateNestedManyWithoutEhrSlotInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrLocationId: Scalars['String']['input'];
    ehrSlotNoteId?: InputMaybe<Scalars['String']['input']>;
    ehrVisitIds?: InputMaybe<EhrSlotCreateehrVisitIdsInput>;
    encounters?: InputMaybe<EncounterCreateNestedManyWithoutEhrSlotInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    isCustomSlot?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    patientId: Scalars['String']['input'];
    scheduleSlotName?: InputMaybe<Scalars['String']['input']>;
    status: EhrSlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrSlotCreateWithoutSlotInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrLocationId: Scalars['String']['input'];
    ehrSlotNoteId?: InputMaybe<Scalars['String']['input']>;
    ehrVisitIds?: InputMaybe<EhrSlotCreateehrVisitIdsInput>;
    encounters?: InputMaybe<EncounterCreateNestedManyWithoutEhrSlotInput>;
    experityEncounters?: InputMaybe<ExperityEncounterCreateNestedManyWithoutEhrSlotInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    isCustomSlot?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    patientId: Scalars['String']['input'];
    scheduleSlotName?: InputMaybe<Scalars['String']['input']>;
    status: EhrSlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EhrSlotCreateehrVisitIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EhrSlotGroupBy = {
    __typename?: 'EhrSlotGroupBy';
    _avg?: Maybe<EhrSlotAvgAggregate>;
    _count?: Maybe<EhrSlotCountAggregate>;
    _max?: Maybe<EhrSlotMaxAggregate>;
    _min?: Maybe<EhrSlotMinAggregate>;
    _sum?: Maybe<EhrSlotSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrLocationId: Scalars['String']['output'];
    ehrSlotNoteId?: Maybe<Scalars['String']['output']>;
    ehrVisitIds?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['String']['output'];
    isCustomSlot: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    patientId: Scalars['String']['output'];
    scheduleSlotName?: Maybe<Scalars['String']['output']>;
    status: EhrSlotStatusEnum;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrSlotMaxAggregate = {
    __typename?: 'EhrSlotMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    ehrSlotNoteId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isCustomSlot?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientId?: Maybe<Scalars['String']['output']>;
    scheduleSlotName?: Maybe<Scalars['String']['output']>;
    status?: Maybe<EhrSlotStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrSlotMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrder>;
    ehrLocationId?: InputMaybe<SortOrder>;
    ehrSlotNoteId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isCustomSlot?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientId?: InputMaybe<SortOrder>;
    scheduleSlotName?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrSlotMinAggregate = {
    __typename?: 'EhrSlotMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    ehrSlotNoteId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isCustomSlot?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientId?: Maybe<Scalars['String']['output']>;
    scheduleSlotName?: Maybe<Scalars['String']['output']>;
    status?: Maybe<EhrSlotStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EhrSlotMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrder>;
    ehrLocationId?: InputMaybe<SortOrder>;
    ehrSlotNoteId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isCustomSlot?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientId?: InputMaybe<SortOrder>;
    scheduleSlotName?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type EhrSlotNullableRelationFilter = {
    is?: InputMaybe<EhrSlotWhereInput>;
    isNot?: InputMaybe<EhrSlotWhereInput>;
};

export type EhrSlotOrderByWithAggregationInput = {
    _avg?: InputMaybe<EhrSlotAvgOrderByAggregateInput>;
    _count?: InputMaybe<EhrSlotCountOrderByAggregateInput>;
    _max?: InputMaybe<EhrSlotMaxOrderByAggregateInput>;
    _min?: InputMaybe<EhrSlotMinOrderByAggregateInput>;
    _sum?: InputMaybe<EhrSlotSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrAppointmentTypeId?: InputMaybe<SortOrderInput>;
    ehrLocationId?: InputMaybe<SortOrder>;
    ehrSlotNoteId?: InputMaybe<SortOrderInput>;
    ehrVisitIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isCustomSlot?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    patientId?: InputMaybe<SortOrder>;
    scheduleSlotName?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export type EhrSlotOrderByWithRelationInput = {
    Slot?: InputMaybe<SlotOrderByRelationAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    ehrAppointmentTypeId?: InputMaybe<SortOrderInput>;
    ehrLocationId?: InputMaybe<SortOrder>;
    ehrSlotNoteId?: InputMaybe<SortOrderInput>;
    ehrVisitIds?: InputMaybe<SortOrder>;
    encounters?: InputMaybe<EncounterOrderByRelationAggregateInput>;
    experityEncounters?: InputMaybe<ExperityEncounterOrderByRelationAggregateInput>;
    id?: InputMaybe<SortOrder>;
    isCustomSlot?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    patientId?: InputMaybe<SortOrder>;
    scheduleSlotName?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export type EhrSlotRelationFilter = {
    is?: InputMaybe<EhrSlotWhereInput>;
    isNot?: InputMaybe<EhrSlotWhereInput>;
};

export enum EhrSlotScalarFieldEnum {
    CreatedAt = 'createdAt',
    EhrAppointmentId = 'ehrAppointmentId',
    EhrAppointmentTypeId = 'ehrAppointmentTypeId',
    EhrLocationId = 'ehrLocationId',
    EhrSlotNoteId = 'ehrSlotNoteId',
    EhrVisitIds = 'ehrVisitIds',
    Id = 'id',
    IsCustomSlot = 'isCustomSlot',
    LastUpdatedBy = 'lastUpdatedBy',
    OrgId = 'orgId',
    PatientId = 'patientId',
    ScheduleSlotName = 'scheduleSlotName',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type EhrSlotScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<EhrSlotScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<EhrSlotScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<EhrSlotScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrAppointmentTypeId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrLocationId?: InputMaybe<StringWithAggregatesFilter>;
    ehrSlotNoteId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrVisitIds?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    isCustomSlot?: InputMaybe<BoolWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    patientId?: InputMaybe<StringWithAggregatesFilter>;
    scheduleSlotName?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumEhrSlotStatusEnumWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export enum EhrSlotStatusEnum {
    Canceled = 'CANCELED',
    Confirmed = 'CONFIRMED',
    Expired = 'EXPIRED',
    Pending = 'PENDING',
}

export type EhrSlotSumAggregate = {
    __typename?: 'EhrSlotSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type EhrSlotSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type EhrSlotUpdateInput = {
    Slot?: InputMaybe<SlotUpdateManyWithoutEhrSlotNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrAppointmentTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLocationId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrSlotNoteId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitIds?: InputMaybe<EhrSlotUpdateehrVisitIdsInput>;
    encounters?: InputMaybe<EncounterUpdateManyWithoutEhrSlotNestedInput>;
    experityEncounters?: InputMaybe<ExperityEncounterUpdateManyWithoutEhrSlotNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isCustomSlot?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    patientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    scheduleSlotName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEhrSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type EhrSlotUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrAppointmentTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLocationId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrSlotNoteId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitIds?: InputMaybe<EhrSlotUpdateehrVisitIdsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isCustomSlot?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    patientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    scheduleSlotName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEhrSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type EhrSlotUpdateOneRequiredWithoutExperityEncountersNestedInput = {
    connect?: InputMaybe<EhrSlotWhereUniqueInput>;
    connectOrCreate?: InputMaybe<EhrSlotCreateOrConnectWithoutExperityEncountersInput>;
    create?: InputMaybe<EhrSlotCreateWithoutExperityEncountersInput>;
    update?: InputMaybe<EhrSlotUpdateToOneWithWhereWithoutExperityEncountersInput>;
    upsert?: InputMaybe<EhrSlotUpsertWithoutExperityEncountersInput>;
};

export type EhrSlotUpdateOneWithoutEncountersNestedInput = {
    connect?: InputMaybe<EhrSlotWhereUniqueInput>;
    connectOrCreate?: InputMaybe<EhrSlotCreateOrConnectWithoutEncountersInput>;
    create?: InputMaybe<EhrSlotCreateWithoutEncountersInput>;
    delete?: InputMaybe<EhrSlotWhereInput>;
    disconnect?: InputMaybe<EhrSlotWhereInput>;
    update?: InputMaybe<EhrSlotUpdateToOneWithWhereWithoutEncountersInput>;
    upsert?: InputMaybe<EhrSlotUpsertWithoutEncountersInput>;
};

export type EhrSlotUpdateOneWithoutSlotNestedInput = {
    connect?: InputMaybe<EhrSlotWhereUniqueInput>;
    connectOrCreate?: InputMaybe<EhrSlotCreateOrConnectWithoutSlotInput>;
    create?: InputMaybe<EhrSlotCreateWithoutSlotInput>;
    delete?: InputMaybe<EhrSlotWhereInput>;
    disconnect?: InputMaybe<EhrSlotWhereInput>;
    update?: InputMaybe<EhrSlotUpdateToOneWithWhereWithoutSlotInput>;
    upsert?: InputMaybe<EhrSlotUpsertWithoutSlotInput>;
};

export type EhrSlotUpdateToOneWithWhereWithoutEncountersInput = {
    data: EhrSlotUpdateWithoutEncountersInput;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type EhrSlotUpdateToOneWithWhereWithoutExperityEncountersInput = {
    data: EhrSlotUpdateWithoutExperityEncountersInput;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type EhrSlotUpdateToOneWithWhereWithoutSlotInput = {
    data: EhrSlotUpdateWithoutSlotInput;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type EhrSlotUpdateWithoutEncountersInput = {
    Slot?: InputMaybe<SlotUpdateManyWithoutEhrSlotNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrAppointmentTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLocationId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrSlotNoteId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitIds?: InputMaybe<EhrSlotUpdateehrVisitIdsInput>;
    experityEncounters?: InputMaybe<ExperityEncounterUpdateManyWithoutEhrSlotNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isCustomSlot?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    patientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    scheduleSlotName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEhrSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type EhrSlotUpdateWithoutExperityEncountersInput = {
    Slot?: InputMaybe<SlotUpdateManyWithoutEhrSlotNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrAppointmentTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLocationId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrSlotNoteId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitIds?: InputMaybe<EhrSlotUpdateehrVisitIdsInput>;
    encounters?: InputMaybe<EncounterUpdateManyWithoutEhrSlotNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isCustomSlot?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    patientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    scheduleSlotName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEhrSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type EhrSlotUpdateWithoutSlotInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrAppointmentTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrLocationId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrSlotNoteId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitIds?: InputMaybe<EhrSlotUpdateehrVisitIdsInput>;
    encounters?: InputMaybe<EncounterUpdateManyWithoutEhrSlotNestedInput>;
    experityEncounters?: InputMaybe<ExperityEncounterUpdateManyWithoutEhrSlotNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isCustomSlot?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    patientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    scheduleSlotName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEhrSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type EhrSlotUpdateehrVisitIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EhrSlotUpsertWithoutEncountersInput = {
    create: EhrSlotCreateWithoutEncountersInput;
    update: EhrSlotUpdateWithoutEncountersInput;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type EhrSlotUpsertWithoutExperityEncountersInput = {
    create: EhrSlotCreateWithoutExperityEncountersInput;
    update: EhrSlotUpdateWithoutExperityEncountersInput;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type EhrSlotUpsertWithoutSlotInput = {
    create: EhrSlotCreateWithoutSlotInput;
    update: EhrSlotUpdateWithoutSlotInput;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type EhrSlotWhereInput = {
    AND?: InputMaybe<Array<EhrSlotWhereInput>>;
    NOT?: InputMaybe<Array<EhrSlotWhereInput>>;
    OR?: InputMaybe<Array<EhrSlotWhereInput>>;
    Slot?: InputMaybe<SlotListRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrAppointmentTypeId?: InputMaybe<StringNullableFilter>;
    ehrLocationId?: InputMaybe<StringFilter>;
    ehrSlotNoteId?: InputMaybe<StringNullableFilter>;
    ehrVisitIds?: InputMaybe<StringNullableListFilter>;
    encounters?: InputMaybe<EncounterListRelationFilter>;
    experityEncounters?: InputMaybe<ExperityEncounterListRelationFilter>;
    id?: InputMaybe<UuidFilter>;
    isCustomSlot?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    patientId?: InputMaybe<StringFilter>;
    scheduleSlotName?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumEhrSlotStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type EhrSlotWhereUniqueInput = {
    AND?: InputMaybe<Array<EhrSlotWhereInput>>;
    NOT?: InputMaybe<Array<EhrSlotWhereInput>>;
    OR?: InputMaybe<Array<EhrSlotWhereInput>>;
    Slot?: InputMaybe<SlotListRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    ehrAppointmentTypeId?: InputMaybe<StringNullableFilter>;
    ehrLocationId?: InputMaybe<StringFilter>;
    ehrSlotNoteId?: InputMaybe<StringNullableFilter>;
    ehrVisitIds?: InputMaybe<StringNullableListFilter>;
    encounters?: InputMaybe<EncounterListRelationFilter>;
    experityEncounters?: InputMaybe<ExperityEncounterListRelationFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    isCustomSlot?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    patientId?: InputMaybe<StringFilter>;
    scheduleSlotName?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumEhrSlotStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum EhrTypeEnum {
    Athena = 'ATHENA',
    Experity = 'EXPERITY',
    Supreme = 'SUPREME',
}

export type EhrUpdateResponse = {
    __typename?: 'EhrUpdateResponse';
    patientAthenaUpdateResponse?: Maybe<Scalars['JSON']['output']>;
    patientUpdateResponse?: Maybe<Scalars['JSON']['output']>;
    pcpUpdateResponse?: Maybe<Scalars['JSON']['output']>;
    pharmacyUpdateResponse?: Maybe<Scalars['JSON']['output']>;
};

export enum EmergencyContactRelationship {
    Child = 'CHILD',
    Cousin = 'COUSIN',
    Friend = 'FRIEND',
    Guardian = 'GUARDIAN',
    Other = 'OTHER',
    Parent = 'PARENT',
    Sibling = 'SIBLING',
    Spouse = 'SPOUSE',
}

export enum EmploymentStatus {
    Employed = 'EMPLOYED',
    Retired = 'RETIRED',
    Student = 'STUDENT',
    Unemployed = 'UNEMPLOYED',
}

export type Encounter = {
    __typename?: 'Encounter';
    _count?: Maybe<EncounterCount>;
    action_required: Scalars['Boolean']['output'];
    appointmentEnd?: Maybe<Scalars['DateTimeISO']['output']>;
    appointmentStart?: Maybe<Scalars['DateTimeISO']['output']>;
    cartItemIds: Array<Scalars['Int']['output']>;
    checkoutAccessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    customFieldValue: Array<CustomFieldValue>;
    ehrSlot?: Maybe<EhrSlot>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    hasPendingPayment: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
    insuranceIds: Array<Scalars['String']['output']>;
    intakeFormIds: Array<Scalars['Int']['output']>;
    lastCommunicationTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
    linkId: Scalars['String']['output'];
    paymentContactId?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
    procedureName?: Maybe<Scalars['String']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    source: EncounterSourceEnum;
    status: EncounterStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
    userId: Scalars['String']['output'];
};

export type EncounterCustomFieldValueArgs = {
    cursor?: InputMaybe<CustomFieldValueWhereUniqueInput>;
    distinct?: InputMaybe<Array<CustomFieldValueScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CustomFieldValueOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type EncounterEhrSlotArgs = {
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type EncounterAvgAggregate = {
    __typename?: 'EncounterAvgAggregate';
    cartItemIds?: Maybe<Scalars['Float']['output']>;
    intakeFormIds?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
    providerId?: Maybe<Scalars['Float']['output']>;
};

export type EncounterAvgOrderByAggregateInput = {
    cartItemIds?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type EncounterCount = {
    __typename?: 'EncounterCount';
    customFieldValue: Scalars['Int']['output'];
};

export type EncounterCountCustomFieldValueArgs = {
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type EncounterCountAggregate = {
    __typename?: 'EncounterCountAggregate';
    _all: Scalars['Int']['output'];
    action_required: Scalars['Int']['output'];
    appointmentEnd: Scalars['Int']['output'];
    appointmentStart: Scalars['Int']['output'];
    cartItemIds: Scalars['Int']['output'];
    checkoutAccessedAt: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrSlotId: Scalars['Int']['output'];
    hasPendingPayment: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    insuranceIds: Scalars['Int']['output'];
    intakeFormIds: Scalars['Int']['output'];
    lastCommunicationTimestamp: Scalars['Int']['output'];
    linkId: Scalars['Int']['output'];
    paymentContactId: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    procedureName: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    source: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
};

export type EncounterCountOrderByAggregateInput = {
    action_required?: InputMaybe<SortOrder>;
    appointmentEnd?: InputMaybe<SortOrder>;
    appointmentStart?: InputMaybe<SortOrder>;
    cartItemIds?: InputMaybe<SortOrder>;
    checkoutAccessedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    hasPendingPayment?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceIds?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    lastCommunicationTimestamp?: InputMaybe<SortOrder>;
    linkId?: InputMaybe<SortOrder>;
    paymentContactId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    procedureName?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type EncounterCreateInput = {
    action_required?: InputMaybe<Scalars['Boolean']['input']>;
    appointmentEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
    appointmentStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cartItemIds?: InputMaybe<EncounterCreatecartItemIdsInput>;
    checkoutAccessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    customFieldValue?: InputMaybe<CustomFieldValueCreateNestedManyWithoutEncounterInput>;
    ehrSlot?: InputMaybe<EhrSlotCreateNestedOneWithoutEncountersInput>;
    hasPendingPayment?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<EncounterCreateinsuranceIdsInput>;
    intakeFormIds?: InputMaybe<EncounterCreateintakeFormIdsInput>;
    lastCommunicationTimestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
    linkId: Scalars['String']['input'];
    paymentContactId?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    procedureName?: InputMaybe<Scalars['String']['input']>;
    providerId?: InputMaybe<Scalars['Int']['input']>;
    source?: InputMaybe<EncounterSourceEnum>;
    status?: InputMaybe<EncounterStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId: Scalars['String']['input'];
};

export type EncounterCreateManyEhrSlotInput = {
    action_required?: InputMaybe<Scalars['Boolean']['input']>;
    appointmentEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
    appointmentStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cartItemIds?: InputMaybe<EncounterCreatecartItemIdsInput>;
    checkoutAccessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hasPendingPayment?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<EncounterCreateinsuranceIdsInput>;
    intakeFormIds?: InputMaybe<EncounterCreateintakeFormIdsInput>;
    lastCommunicationTimestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
    linkId: Scalars['String']['input'];
    paymentContactId?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    procedureName?: InputMaybe<Scalars['String']['input']>;
    providerId?: InputMaybe<Scalars['Int']['input']>;
    source?: InputMaybe<EncounterSourceEnum>;
    status?: InputMaybe<EncounterStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId: Scalars['String']['input'];
};

export type EncounterCreateManyEhrSlotInputEnvelope = {
    data: Array<EncounterCreateManyEhrSlotInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EncounterCreateManyInput = {
    action_required?: InputMaybe<Scalars['Boolean']['input']>;
    appointmentEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
    appointmentStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cartItemIds?: InputMaybe<EncounterCreatecartItemIdsInput>;
    checkoutAccessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    hasPendingPayment?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<EncounterCreateinsuranceIdsInput>;
    intakeFormIds?: InputMaybe<EncounterCreateintakeFormIdsInput>;
    lastCommunicationTimestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
    linkId: Scalars['String']['input'];
    paymentContactId?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    procedureName?: InputMaybe<Scalars['String']['input']>;
    providerId?: InputMaybe<Scalars['Int']['input']>;
    source?: InputMaybe<EncounterSourceEnum>;
    status?: InputMaybe<EncounterStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId: Scalars['String']['input'];
};

export type EncounterCreateNestedManyWithoutEhrSlotInput = {
    connect?: InputMaybe<Array<EncounterWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<EncounterCreateOrConnectWithoutEhrSlotInput>
    >;
    create?: InputMaybe<Array<EncounterCreateWithoutEhrSlotInput>>;
    createMany?: InputMaybe<EncounterCreateManyEhrSlotInputEnvelope>;
};

export type EncounterCreateNestedOneWithoutCustomFieldValueInput = {
    connect?: InputMaybe<EncounterWhereUniqueInput>;
    connectOrCreate?: InputMaybe<EncounterCreateOrConnectWithoutCustomFieldValueInput>;
    create?: InputMaybe<EncounterCreateWithoutCustomFieldValueInput>;
};

export type EncounterCreateOrConnectWithoutCustomFieldValueInput = {
    create: EncounterCreateWithoutCustomFieldValueInput;
    where: EncounterWhereUniqueInput;
};

export type EncounterCreateOrConnectWithoutEhrSlotInput = {
    create: EncounterCreateWithoutEhrSlotInput;
    where: EncounterWhereUniqueInput;
};

export type EncounterCreateWithoutCustomFieldValueInput = {
    action_required?: InputMaybe<Scalars['Boolean']['input']>;
    appointmentEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
    appointmentStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cartItemIds?: InputMaybe<EncounterCreatecartItemIdsInput>;
    checkoutAccessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrSlot?: InputMaybe<EhrSlotCreateNestedOneWithoutEncountersInput>;
    hasPendingPayment?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<EncounterCreateinsuranceIdsInput>;
    intakeFormIds?: InputMaybe<EncounterCreateintakeFormIdsInput>;
    lastCommunicationTimestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
    linkId: Scalars['String']['input'];
    paymentContactId?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    procedureName?: InputMaybe<Scalars['String']['input']>;
    providerId?: InputMaybe<Scalars['Int']['input']>;
    source?: InputMaybe<EncounterSourceEnum>;
    status?: InputMaybe<EncounterStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId: Scalars['String']['input'];
};

export type EncounterCreateWithoutEhrSlotInput = {
    action_required?: InputMaybe<Scalars['Boolean']['input']>;
    appointmentEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
    appointmentStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
    cartItemIds?: InputMaybe<EncounterCreatecartItemIdsInput>;
    checkoutAccessedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    customFieldValue?: InputMaybe<CustomFieldValueCreateNestedManyWithoutEncounterInput>;
    hasPendingPayment?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<EncounterCreateinsuranceIdsInput>;
    intakeFormIds?: InputMaybe<EncounterCreateintakeFormIdsInput>;
    lastCommunicationTimestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
    linkId: Scalars['String']['input'];
    paymentContactId?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    procedureName?: InputMaybe<Scalars['String']['input']>;
    providerId?: InputMaybe<Scalars['Int']['input']>;
    source?: InputMaybe<EncounterSourceEnum>;
    status?: InputMaybe<EncounterStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userId: Scalars['String']['input'];
};

export type EncounterCreatecartItemIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type EncounterCreateinsuranceIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type EncounterCreateintakeFormIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type EncounterGroupBy = {
    __typename?: 'EncounterGroupBy';
    _avg?: Maybe<EncounterAvgAggregate>;
    _count?: Maybe<EncounterCountAggregate>;
    _max?: Maybe<EncounterMaxAggregate>;
    _min?: Maybe<EncounterMinAggregate>;
    _sum?: Maybe<EncounterSumAggregate>;
    action_required: Scalars['Boolean']['output'];
    appointmentEnd?: Maybe<Scalars['DateTimeISO']['output']>;
    appointmentStart?: Maybe<Scalars['DateTimeISO']['output']>;
    cartItemIds?: Maybe<Array<Scalars['Int']['output']>>;
    checkoutAccessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    hasPendingPayment: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
    insuranceIds?: Maybe<Array<Scalars['String']['output']>>;
    intakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    lastCommunicationTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
    linkId: Scalars['String']['output'];
    paymentContactId?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
    procedureName?: Maybe<Scalars['String']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    source: EncounterSourceEnum;
    status: EncounterStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
    userId: Scalars['String']['output'];
};

export type EncounterListRelationFilter = {
    every?: InputMaybe<EncounterWhereInput>;
    none?: InputMaybe<EncounterWhereInput>;
    some?: InputMaybe<EncounterWhereInput>;
};

export type EncounterMaxAggregate = {
    __typename?: 'EncounterMaxAggregate';
    action_required?: Maybe<Scalars['Boolean']['output']>;
    appointmentEnd?: Maybe<Scalars['DateTimeISO']['output']>;
    appointmentStart?: Maybe<Scalars['DateTimeISO']['output']>;
    checkoutAccessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    hasPendingPayment?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastCommunicationTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
    linkId?: Maybe<Scalars['String']['output']>;
    paymentContactId?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    procedureName?: Maybe<Scalars['String']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    source?: Maybe<EncounterSourceEnum>;
    status?: Maybe<EncounterStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type EncounterMaxOrderByAggregateInput = {
    action_required?: InputMaybe<SortOrder>;
    appointmentEnd?: InputMaybe<SortOrder>;
    appointmentStart?: InputMaybe<SortOrder>;
    checkoutAccessedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    hasPendingPayment?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastCommunicationTimestamp?: InputMaybe<SortOrder>;
    linkId?: InputMaybe<SortOrder>;
    paymentContactId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    procedureName?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type EncounterMinAggregate = {
    __typename?: 'EncounterMinAggregate';
    action_required?: Maybe<Scalars['Boolean']['output']>;
    appointmentEnd?: Maybe<Scalars['DateTimeISO']['output']>;
    appointmentStart?: Maybe<Scalars['DateTimeISO']['output']>;
    checkoutAccessedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    hasPendingPayment?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastCommunicationTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
    linkId?: Maybe<Scalars['String']['output']>;
    paymentContactId?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    procedureName?: Maybe<Scalars['String']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    source?: Maybe<EncounterSourceEnum>;
    status?: Maybe<EncounterStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type EncounterMinOrderByAggregateInput = {
    action_required?: InputMaybe<SortOrder>;
    appointmentEnd?: InputMaybe<SortOrder>;
    appointmentStart?: InputMaybe<SortOrder>;
    checkoutAccessedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    hasPendingPayment?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastCommunicationTimestamp?: InputMaybe<SortOrder>;
    linkId?: InputMaybe<SortOrder>;
    paymentContactId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    procedureName?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type EncounterNullableRelationFilter = {
    is?: InputMaybe<EncounterWhereInput>;
    isNot?: InputMaybe<EncounterWhereInput>;
};

export type EncounterOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type EncounterOrderByWithAggregationInput = {
    _avg?: InputMaybe<EncounterAvgOrderByAggregateInput>;
    _count?: InputMaybe<EncounterCountOrderByAggregateInput>;
    _max?: InputMaybe<EncounterMaxOrderByAggregateInput>;
    _min?: InputMaybe<EncounterMinOrderByAggregateInput>;
    _sum?: InputMaybe<EncounterSumOrderByAggregateInput>;
    action_required?: InputMaybe<SortOrder>;
    appointmentEnd?: InputMaybe<SortOrderInput>;
    appointmentStart?: InputMaybe<SortOrderInput>;
    cartItemIds?: InputMaybe<SortOrder>;
    checkoutAccessedAt?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    hasPendingPayment?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceIds?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    lastCommunicationTimestamp?: InputMaybe<SortOrderInput>;
    linkId?: InputMaybe<SortOrder>;
    paymentContactId?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
    procedureName?: InputMaybe<SortOrderInput>;
    providerId?: InputMaybe<SortOrderInput>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type EncounterOrderByWithRelationInput = {
    action_required?: InputMaybe<SortOrder>;
    appointmentEnd?: InputMaybe<SortOrderInput>;
    appointmentStart?: InputMaybe<SortOrderInput>;
    cartItemIds?: InputMaybe<SortOrder>;
    checkoutAccessedAt?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    customFieldValue?: InputMaybe<CustomFieldValueOrderByRelationAggregateInput>;
    ehrSlot?: InputMaybe<EhrSlotOrderByWithRelationInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    hasPendingPayment?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceIds?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    lastCommunicationTimestamp?: InputMaybe<SortOrderInput>;
    linkId?: InputMaybe<SortOrder>;
    paymentContactId?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
    procedureName?: InputMaybe<SortOrderInput>;
    providerId?: InputMaybe<SortOrderInput>;
    source?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export enum EncounterScalarFieldEnum {
    ActionRequired = 'action_required',
    AppointmentEnd = 'appointmentEnd',
    AppointmentStart = 'appointmentStart',
    CartItemIds = 'cartItemIds',
    CheckoutAccessedAt = 'checkoutAccessedAt',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    EhrSlotId = 'ehrSlotId',
    HasPendingPayment = 'hasPendingPayment',
    Id = 'id',
    InsuranceIds = 'insuranceIds',
    IntakeFormIds = 'intakeFormIds',
    LastCommunicationTimestamp = 'lastCommunicationTimestamp',
    LinkId = 'linkId',
    PaymentContactId = 'paymentContactId',
    PracticeId = 'practiceId',
    ProcedureName = 'procedureName',
    ProviderId = 'providerId',
    Source = 'source',
    Status = 'status',
    UpdatedAt = 'updatedAt',
    UserId = 'userId',
}

export type EncounterScalarWhereInput = {
    AND?: InputMaybe<Array<EncounterScalarWhereInput>>;
    NOT?: InputMaybe<Array<EncounterScalarWhereInput>>;
    OR?: InputMaybe<Array<EncounterScalarWhereInput>>;
    action_required?: InputMaybe<BoolFilter>;
    appointmentEnd?: InputMaybe<DateTimeNullableFilter>;
    appointmentStart?: InputMaybe<DateTimeNullableFilter>;
    cartItemIds?: InputMaybe<IntNullableListFilter>;
    checkoutAccessedAt?: InputMaybe<DateTimeNullableFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    hasPendingPayment?: InputMaybe<BoolFilter>;
    id?: InputMaybe<UuidFilter>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    intakeFormIds?: InputMaybe<IntNullableListFilter>;
    lastCommunicationTimestamp?: InputMaybe<DateTimeNullableFilter>;
    linkId?: InputMaybe<UuidFilter>;
    paymentContactId?: InputMaybe<UuidNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    procedureName?: InputMaybe<StringNullableFilter>;
    providerId?: InputMaybe<IntNullableFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumFilter>;
    status?: InputMaybe<EnumEncounterStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<UuidFilter>;
};

export type EncounterScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<EncounterScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<EncounterScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<EncounterScalarWhereWithAggregatesInput>>;
    action_required?: InputMaybe<BoolWithAggregatesFilter>;
    appointmentEnd?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    appointmentStart?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    cartItemIds?: InputMaybe<IntNullableListFilter>;
    checkoutAccessedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrSlotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    hasPendingPayment?: InputMaybe<BoolWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    intakeFormIds?: InputMaybe<IntNullableListFilter>;
    lastCommunicationTimestamp?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    linkId?: InputMaybe<UuidWithAggregatesFilter>;
    paymentContactId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
    procedureName?: InputMaybe<StringNullableWithAggregatesFilter>;
    providerId?: InputMaybe<IntNullableWithAggregatesFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumWithAggregatesFilter>;
    status?: InputMaybe<EnumEncounterStatusEnumWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    userId?: InputMaybe<UuidWithAggregatesFilter>;
};

export enum EncounterSourceEnum {
    AleService = 'ale_service',
    ArtClaimBackfill = 'art_claim_backfill',
    ArtTreatmentAdd = 'art_treatment_add',
    ArtUnapplied = 'art_unapplied',
    Kiosk = 'kiosk',
    Pc = 'pc',
    Skylight = 'skylight',
    Storefront = 'storefront',
}

export enum EncounterStatusEnum {
    Active = 'active',
    Canceled = 'canceled',
    Deleted = 'deleted',
    Replaced = 'replaced',
}

export type EncounterSumAggregate = {
    __typename?: 'EncounterSumAggregate';
    cartItemIds?: Maybe<Array<Scalars['Int']['output']>>;
    intakeFormIds?: Maybe<Array<Scalars['Int']['output']>>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
};

export type EncounterSumOrderByAggregateInput = {
    cartItemIds?: InputMaybe<SortOrder>;
    intakeFormIds?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type EncounterUpdateInput = {
    action_required?: InputMaybe<BoolFieldUpdateOperationsInput>;
    appointmentEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    appointmentStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    cartItemIds?: InputMaybe<EncounterUpdatecartItemIdsInput>;
    checkoutAccessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    customFieldValue?: InputMaybe<CustomFieldValueUpdateManyWithoutEncounterNestedInput>;
    ehrSlot?: InputMaybe<EhrSlotUpdateOneWithoutEncountersNestedInput>;
    hasPendingPayment?: InputMaybe<BoolFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceIds?: InputMaybe<EncounterUpdateinsuranceIdsInput>;
    intakeFormIds?: InputMaybe<EncounterUpdateintakeFormIdsInput>;
    lastCommunicationTimestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    linkId?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    procedureName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    providerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    source?: InputMaybe<EnumEncounterSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEncounterStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EncounterUpdateManyMutationInput = {
    action_required?: InputMaybe<BoolFieldUpdateOperationsInput>;
    appointmentEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    appointmentStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    cartItemIds?: InputMaybe<EncounterUpdatecartItemIdsInput>;
    checkoutAccessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hasPendingPayment?: InputMaybe<BoolFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceIds?: InputMaybe<EncounterUpdateinsuranceIdsInput>;
    intakeFormIds?: InputMaybe<EncounterUpdateintakeFormIdsInput>;
    lastCommunicationTimestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    linkId?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    procedureName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    providerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    source?: InputMaybe<EnumEncounterSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEncounterStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EncounterUpdateManyWithWhereWithoutEhrSlotInput = {
    data: EncounterUpdateManyMutationInput;
    where: EncounterScalarWhereInput;
};

export type EncounterUpdateManyWithoutEhrSlotNestedInput = {
    connect?: InputMaybe<Array<EncounterWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<EncounterCreateOrConnectWithoutEhrSlotInput>
    >;
    create?: InputMaybe<Array<EncounterCreateWithoutEhrSlotInput>>;
    createMany?: InputMaybe<EncounterCreateManyEhrSlotInputEnvelope>;
    delete?: InputMaybe<Array<EncounterWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<EncounterScalarWhereInput>>;
    disconnect?: InputMaybe<Array<EncounterWhereUniqueInput>>;
    set?: InputMaybe<Array<EncounterWhereUniqueInput>>;
    update?: InputMaybe<
        Array<EncounterUpdateWithWhereUniqueWithoutEhrSlotInput>
    >;
    updateMany?: InputMaybe<
        Array<EncounterUpdateManyWithWhereWithoutEhrSlotInput>
    >;
    upsert?: InputMaybe<
        Array<EncounterUpsertWithWhereUniqueWithoutEhrSlotInput>
    >;
};

export type EncounterUpdateOneWithoutCustomFieldValueNestedInput = {
    connect?: InputMaybe<EncounterWhereUniqueInput>;
    connectOrCreate?: InputMaybe<EncounterCreateOrConnectWithoutCustomFieldValueInput>;
    create?: InputMaybe<EncounterCreateWithoutCustomFieldValueInput>;
    delete?: InputMaybe<EncounterWhereInput>;
    disconnect?: InputMaybe<EncounterWhereInput>;
    update?: InputMaybe<EncounterUpdateToOneWithWhereWithoutCustomFieldValueInput>;
    upsert?: InputMaybe<EncounterUpsertWithoutCustomFieldValueInput>;
};

export type EncounterUpdateToOneWithWhereWithoutCustomFieldValueInput = {
    data: EncounterUpdateWithoutCustomFieldValueInput;
    where?: InputMaybe<EncounterWhereInput>;
};

export type EncounterUpdateWithWhereUniqueWithoutEhrSlotInput = {
    data: EncounterUpdateWithoutEhrSlotInput;
    where: EncounterWhereUniqueInput;
};

export type EncounterUpdateWithoutCustomFieldValueInput = {
    action_required?: InputMaybe<BoolFieldUpdateOperationsInput>;
    appointmentEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    appointmentStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    cartItemIds?: InputMaybe<EncounterUpdatecartItemIdsInput>;
    checkoutAccessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrSlot?: InputMaybe<EhrSlotUpdateOneWithoutEncountersNestedInput>;
    hasPendingPayment?: InputMaybe<BoolFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceIds?: InputMaybe<EncounterUpdateinsuranceIdsInput>;
    intakeFormIds?: InputMaybe<EncounterUpdateintakeFormIdsInput>;
    lastCommunicationTimestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    linkId?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    procedureName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    providerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    source?: InputMaybe<EnumEncounterSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEncounterStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EncounterUpdateWithoutEhrSlotInput = {
    action_required?: InputMaybe<BoolFieldUpdateOperationsInput>;
    appointmentEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    appointmentStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    cartItemIds?: InputMaybe<EncounterUpdatecartItemIdsInput>;
    checkoutAccessedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    customFieldValue?: InputMaybe<CustomFieldValueUpdateManyWithoutEncounterNestedInput>;
    hasPendingPayment?: InputMaybe<BoolFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceIds?: InputMaybe<EncounterUpdateinsuranceIdsInput>;
    intakeFormIds?: InputMaybe<EncounterUpdateintakeFormIdsInput>;
    lastCommunicationTimestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    linkId?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    procedureName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    providerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    source?: InputMaybe<EnumEncounterSourceEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumEncounterStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EncounterUpdatecartItemIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EncounterUpdateinsuranceIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EncounterUpdateintakeFormIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EncounterUpsertWithWhereUniqueWithoutEhrSlotInput = {
    create: EncounterCreateWithoutEhrSlotInput;
    update: EncounterUpdateWithoutEhrSlotInput;
    where: EncounterWhereUniqueInput;
};

export type EncounterUpsertWithoutCustomFieldValueInput = {
    create: EncounterCreateWithoutCustomFieldValueInput;
    update: EncounterUpdateWithoutCustomFieldValueInput;
    where?: InputMaybe<EncounterWhereInput>;
};

export type EncounterWhereInput = {
    AND?: InputMaybe<Array<EncounterWhereInput>>;
    NOT?: InputMaybe<Array<EncounterWhereInput>>;
    OR?: InputMaybe<Array<EncounterWhereInput>>;
    action_required?: InputMaybe<BoolFilter>;
    appointmentEnd?: InputMaybe<DateTimeNullableFilter>;
    appointmentStart?: InputMaybe<DateTimeNullableFilter>;
    cartItemIds?: InputMaybe<IntNullableListFilter>;
    checkoutAccessedAt?: InputMaybe<DateTimeNullableFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    customFieldValue?: InputMaybe<CustomFieldValueListRelationFilter>;
    ehrSlot?: InputMaybe<EhrSlotNullableRelationFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    hasPendingPayment?: InputMaybe<BoolFilter>;
    id?: InputMaybe<UuidFilter>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    intakeFormIds?: InputMaybe<IntNullableListFilter>;
    lastCommunicationTimestamp?: InputMaybe<DateTimeNullableFilter>;
    linkId?: InputMaybe<UuidFilter>;
    paymentContactId?: InputMaybe<UuidNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    procedureName?: InputMaybe<StringNullableFilter>;
    providerId?: InputMaybe<IntNullableFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumFilter>;
    status?: InputMaybe<EnumEncounterStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<UuidFilter>;
};

export type EncounterWhereUniqueInput = {
    AND?: InputMaybe<Array<EncounterWhereInput>>;
    NOT?: InputMaybe<Array<EncounterWhereInput>>;
    OR?: InputMaybe<Array<EncounterWhereInput>>;
    action_required?: InputMaybe<BoolFilter>;
    appointmentEnd?: InputMaybe<DateTimeNullableFilter>;
    appointmentStart?: InputMaybe<DateTimeNullableFilter>;
    cartItemIds?: InputMaybe<IntNullableListFilter>;
    checkoutAccessedAt?: InputMaybe<DateTimeNullableFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    customFieldValue?: InputMaybe<CustomFieldValueListRelationFilter>;
    ehrSlot?: InputMaybe<EhrSlotNullableRelationFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    hasPendingPayment?: InputMaybe<BoolFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceIds?: InputMaybe<StringNullableListFilter>;
    intakeFormIds?: InputMaybe<IntNullableListFilter>;
    lastCommunicationTimestamp?: InputMaybe<DateTimeNullableFilter>;
    linkId?: InputMaybe<UuidFilter>;
    paymentContactId?: InputMaybe<UuidNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    procedureName?: InputMaybe<StringNullableFilter>;
    providerId?: InputMaybe<IntNullableFilter>;
    source?: InputMaybe<EnumEncounterSourceEnumFilter>;
    status?: InputMaybe<EnumEncounterStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userId?: InputMaybe<UuidFilter>;
};

export type EnumAirStatusCodeFieldUpdateOperationsInput = {
    set?: InputMaybe<AirStatusCode>;
};

export type EnumAirStatusCodeFilter = {
    equals?: InputMaybe<AirStatusCode>;
    in?: InputMaybe<Array<AirStatusCode>>;
    not?: InputMaybe<NestedEnumAirStatusCodeFilter>;
    notIn?: InputMaybe<Array<AirStatusCode>>;
};

export type EnumAirStatusCodeNullableFilter = {
    equals?: InputMaybe<AirStatusCode>;
    in?: InputMaybe<Array<AirStatusCode>>;
    not?: InputMaybe<NestedEnumAirStatusCodeNullableFilter>;
    notIn?: InputMaybe<Array<AirStatusCode>>;
};

export type EnumAirStatusCodeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAirStatusCodeNullableFilter>;
    _min?: InputMaybe<NestedEnumAirStatusCodeNullableFilter>;
    equals?: InputMaybe<AirStatusCode>;
    in?: InputMaybe<Array<AirStatusCode>>;
    not?: InputMaybe<NestedEnumAirStatusCodeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AirStatusCode>>;
};

export type EnumAirStatusCodeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumAirStatusCodeFilter>;
    _min?: InputMaybe<NestedEnumAirStatusCodeFilter>;
    equals?: InputMaybe<AirStatusCode>;
    in?: InputMaybe<Array<AirStatusCode>>;
    not?: InputMaybe<NestedEnumAirStatusCodeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AirStatusCode>>;
};

export type EnumAttachPostCheckRulesNullableListFilter = {
    equals?: InputMaybe<Array<AttachPostCheckRules>>;
    has?: InputMaybe<AttachPostCheckRules>;
    hasEvery?: InputMaybe<Array<AttachPostCheckRules>>;
    hasSome?: InputMaybe<Array<AttachPostCheckRules>>;
    isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumAttachPreCheckRulesNullableListFilter = {
    equals?: InputMaybe<Array<AttachPreCheckRules>>;
    has?: InputMaybe<AttachPreCheckRules>;
    hasEvery?: InputMaybe<Array<AttachPreCheckRules>>;
    hasSome?: InputMaybe<Array<AttachPreCheckRules>>;
    isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumAutoAddRuleNullableListFilter = {
    equals?: InputMaybe<Array<AutoAddRule>>;
    has?: InputMaybe<AutoAddRule>;
    hasEvery?: InputMaybe<Array<AutoAddRule>>;
    hasSome?: InputMaybe<Array<AutoAddRule>>;
    isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumAdjudicationActionEnumNullableFilter = {
    equals?: InputMaybe<AdjudicationActionEnum>;
    in?: InputMaybe<Array<AdjudicationActionEnum>>;
    not?: InputMaybe<NestedEnumAdjudicationActionEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjudicationActionEnum>>;
};

export type EnumAdjudicationActionEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjudicationActionEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjudicationActionEnumNullableFilter>;
    equals?: InputMaybe<AdjudicationActionEnum>;
    in?: InputMaybe<Array<AdjudicationActionEnum>>;
    not?: InputMaybe<NestedEnumAdjudicationActionEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjudicationActionEnum>>;
};

export type EnumAdjudicationAppliedStatusEnumNullableFilter = {
    equals?: InputMaybe<AdjudicationAppliedStatusEnum>;
    in?: InputMaybe<Array<AdjudicationAppliedStatusEnum>>;
    not?: InputMaybe<NestedEnumAdjudicationAppliedStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjudicationAppliedStatusEnum>>;
};

export type EnumAdjudicationAppliedStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjudicationAppliedStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjudicationAppliedStatusEnumNullableFilter>;
    equals?: InputMaybe<AdjudicationAppliedStatusEnum>;
    in?: InputMaybe<Array<AdjudicationAppliedStatusEnum>>;
    not?: InputMaybe<NestedEnumAdjudicationAppliedStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjudicationAppliedStatusEnum>>;
};

export type EnumAdjudicationPaymentMethodEnumNullableFilter = {
    equals?: InputMaybe<AdjudicationPaymentMethodEnum>;
    in?: InputMaybe<Array<AdjudicationPaymentMethodEnum>>;
    not?: InputMaybe<NestedEnumAdjudicationPaymentMethodEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjudicationPaymentMethodEnum>>;
};

export type EnumAdjudicationPaymentMethodEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjudicationPaymentMethodEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjudicationPaymentMethodEnumNullableFilter>;
    equals?: InputMaybe<AdjudicationPaymentMethodEnum>;
    in?: InputMaybe<Array<AdjudicationPaymentMethodEnum>>;
    not?: InputMaybe<NestedEnumAdjudicationPaymentMethodEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjudicationPaymentMethodEnum>>;
};

export type EnumAdjudicationTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<AdjudicationType>;
};

export type EnumAdjudicationTypeFilter = {
    equals?: InputMaybe<AdjudicationType>;
    in?: InputMaybe<Array<AdjudicationType>>;
    not?: InputMaybe<NestedEnumAdjudicationTypeFilter>;
    notIn?: InputMaybe<Array<AdjudicationType>>;
};

export type EnumAdjudicationTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumAdjudicationTypeFilter>;
    _min?: InputMaybe<NestedEnumAdjudicationTypeFilter>;
    equals?: InputMaybe<AdjudicationType>;
    in?: InputMaybe<Array<AdjudicationType>>;
    not?: InputMaybe<NestedEnumAdjudicationTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjudicationType>>;
};

export type EnumAdjustmentAckActionEnumNullableFilter = {
    equals?: InputMaybe<AdjustmentAckActionEnum>;
    in?: InputMaybe<Array<AdjustmentAckActionEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAckActionEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjustmentAckActionEnum>>;
};

export type EnumAdjustmentAckActionEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjustmentAckActionEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjustmentAckActionEnumNullableFilter>;
    equals?: InputMaybe<AdjustmentAckActionEnum>;
    in?: InputMaybe<Array<AdjustmentAckActionEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAckActionEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjustmentAckActionEnum>>;
};

export type EnumAdjustmentAckRoleEnumNullableFilter = {
    equals?: InputMaybe<AdjustmentAckRoleEnum>;
    in?: InputMaybe<Array<AdjustmentAckRoleEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAckRoleEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjustmentAckRoleEnum>>;
};

export type EnumAdjustmentAckRoleEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjustmentAckRoleEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjustmentAckRoleEnumNullableFilter>;
    equals?: InputMaybe<AdjustmentAckRoleEnum>;
    in?: InputMaybe<Array<AdjustmentAckRoleEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAckRoleEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjustmentAckRoleEnum>>;
};

export type EnumAdjustmentAppliedStatusEnumNullableFilter = {
    equals?: InputMaybe<AdjustmentAppliedStatusEnum>;
    in?: InputMaybe<Array<AdjustmentAppliedStatusEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAppliedStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjustmentAppliedStatusEnum>>;
};

export type EnumAdjustmentAppliedStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjustmentAppliedStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjustmentAppliedStatusEnumNullableFilter>;
    equals?: InputMaybe<AdjustmentAppliedStatusEnum>;
    in?: InputMaybe<Array<AdjustmentAppliedStatusEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAppliedStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjustmentAppliedStatusEnum>>;
};

export type EnumAdjustmentTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<AdjustmentTypeEnum>;
};

export type EnumAdjustmentTypeEnumFilter = {
    equals?: InputMaybe<AdjustmentTypeEnum>;
    in?: InputMaybe<Array<AdjustmentTypeEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentTypeEnumFilter>;
    notIn?: InputMaybe<Array<AdjustmentTypeEnum>>;
};

export type EnumAdjustmentTypeEnumNullableFilter = {
    equals?: InputMaybe<AdjustmentTypeEnum>;
    in?: InputMaybe<Array<AdjustmentTypeEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjustmentTypeEnum>>;
};

export type EnumAdjustmentTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjustmentTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjustmentTypeEnumNullableFilter>;
    equals?: InputMaybe<AdjustmentTypeEnum>;
    in?: InputMaybe<Array<AdjustmentTypeEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjustmentTypeEnum>>;
};

export type EnumAdjustmentTypeEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumAdjustmentTypeEnumFilter>;
    _min?: InputMaybe<NestedEnumAdjustmentTypeEnumFilter>;
    equals?: InputMaybe<AdjustmentTypeEnum>;
    in?: InputMaybe<Array<AdjustmentTypeEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentTypeEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjustmentTypeEnum>>;
};

export type EnumAdminActionFieldUpdateOperationsInput = {
    set?: InputMaybe<AdminAction>;
};

export type EnumAdminActionFilter = {
    equals?: InputMaybe<AdminAction>;
    in?: InputMaybe<Array<AdminAction>>;
    not?: InputMaybe<NestedEnumAdminActionFilter>;
    notIn?: InputMaybe<Array<AdminAction>>;
};

export type EnumAdminActionWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumAdminActionFilter>;
    _min?: InputMaybe<NestedEnumAdminActionFilter>;
    equals?: InputMaybe<AdminAction>;
    in?: InputMaybe<Array<AdminAction>>;
    not?: InputMaybe<NestedEnumAdminActionWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdminAction>>;
};

export type EnumAmountTypeNullableFilter = {
    equals?: InputMaybe<AmountType>;
    in?: InputMaybe<Array<AmountType>>;
    not?: InputMaybe<NestedEnumAmountTypeNullableFilter>;
    notIn?: InputMaybe<Array<AmountType>>;
};

export type EnumAmountTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAmountTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumAmountTypeNullableFilter>;
    equals?: InputMaybe<AmountType>;
    in?: InputMaybe<Array<AmountType>>;
    not?: InputMaybe<NestedEnumAmountTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AmountType>>;
};

export type EnumAppointmentStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<AppointmentStatusEnum>;
};

export type EnumAppointmentStatusEnumFilter = {
    equals?: InputMaybe<AppointmentStatusEnum>;
    in?: InputMaybe<Array<AppointmentStatusEnum>>;
    not?: InputMaybe<NestedEnumAppointmentStatusEnumFilter>;
    notIn?: InputMaybe<Array<AppointmentStatusEnum>>;
};

export type EnumAppointmentStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumAppointmentStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumAppointmentStatusEnumFilter>;
    equals?: InputMaybe<AppointmentStatusEnum>;
    in?: InputMaybe<Array<AppointmentStatusEnum>>;
    not?: InputMaybe<NestedEnumAppointmentStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AppointmentStatusEnum>>;
};

export type EnumArtClaimStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<ArtClaimStatusEnum>;
};

export type EnumArtClaimStatusEnumFilter = {
    equals?: InputMaybe<ArtClaimStatusEnum>;
    in?: InputMaybe<Array<ArtClaimStatusEnum>>;
    not?: InputMaybe<NestedEnumArtClaimStatusEnumFilter>;
    notIn?: InputMaybe<Array<ArtClaimStatusEnum>>;
};

export type EnumArtClaimStatusEnumNullableFilter = {
    equals?: InputMaybe<ArtClaimStatusEnum>;
    in?: InputMaybe<Array<ArtClaimStatusEnum>>;
    not?: InputMaybe<NestedEnumArtClaimStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<ArtClaimStatusEnum>>;
};

export type EnumArtClaimStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumArtClaimStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumArtClaimStatusEnumNullableFilter>;
    equals?: InputMaybe<ArtClaimStatusEnum>;
    in?: InputMaybe<Array<ArtClaimStatusEnum>>;
    not?: InputMaybe<NestedEnumArtClaimStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ArtClaimStatusEnum>>;
};

export type EnumArtClaimStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumArtClaimStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumArtClaimStatusEnumFilter>;
    equals?: InputMaybe<ArtClaimStatusEnum>;
    in?: InputMaybe<Array<ArtClaimStatusEnum>>;
    not?: InputMaybe<NestedEnumArtClaimStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ArtClaimStatusEnum>>;
};

export type EnumBillReasonFieldUpdateOperationsInput = {
    set?: InputMaybe<BillReason>;
};

export type EnumBillReasonFilter = {
    equals?: InputMaybe<BillReason>;
    in?: InputMaybe<Array<BillReason>>;
    not?: InputMaybe<NestedEnumBillReasonFilter>;
    notIn?: InputMaybe<Array<BillReason>>;
};

export type EnumBillReasonWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumBillReasonFilter>;
    _min?: InputMaybe<NestedEnumBillReasonFilter>;
    equals?: InputMaybe<BillReason>;
    in?: InputMaybe<Array<BillReason>>;
    not?: InputMaybe<NestedEnumBillReasonWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BillReason>>;
};

export type EnumBillStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<BillStatus>;
};

export type EnumBillStatusFilter = {
    equals?: InputMaybe<BillStatus>;
    in?: InputMaybe<Array<BillStatus>>;
    not?: InputMaybe<NestedEnumBillStatusFilter>;
    notIn?: InputMaybe<Array<BillStatus>>;
};

export type EnumBillStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumBillStatusFilter>;
    _min?: InputMaybe<NestedEnumBillStatusFilter>;
    equals?: InputMaybe<BillStatus>;
    in?: InputMaybe<Array<BillStatus>>;
    not?: InputMaybe<NestedEnumBillStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BillStatus>>;
};

export type EnumBillingTableDownloadStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<BillingTableDownloadStatusEnum>;
};

export type EnumBillingTableDownloadStatusEnumFilter = {
    equals?: InputMaybe<BillingTableDownloadStatusEnum>;
    in?: InputMaybe<Array<BillingTableDownloadStatusEnum>>;
    not?: InputMaybe<NestedEnumBillingTableDownloadStatusEnumFilter>;
    notIn?: InputMaybe<Array<BillingTableDownloadStatusEnum>>;
};

export type EnumBillingTableDownloadStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumBillingTableDownloadStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumBillingTableDownloadStatusEnumFilter>;
    equals?: InputMaybe<BillingTableDownloadStatusEnum>;
    in?: InputMaybe<Array<BillingTableDownloadStatusEnum>>;
    not?: InputMaybe<NestedEnumBillingTableDownloadStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BillingTableDownloadStatusEnum>>;
};

export type EnumBoughtTreatmentKindNullableFilter = {
    equals?: InputMaybe<BoughtTreatmentKind>;
    in?: InputMaybe<Array<BoughtTreatmentKind>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentKindNullableFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentKind>>;
};

export type EnumBoughtTreatmentKindNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumBoughtTreatmentKindNullableFilter>;
    _min?: InputMaybe<NestedEnumBoughtTreatmentKindNullableFilter>;
    equals?: InputMaybe<BoughtTreatmentKind>;
    in?: InputMaybe<Array<BoughtTreatmentKind>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentKindNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentKind>>;
};

export type EnumBoughtTreatmentStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<BoughtTreatmentStatusEnum>;
};

export type EnumBoughtTreatmentStatusEnumFilter = {
    equals?: InputMaybe<BoughtTreatmentStatusEnum>;
    in?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
};

export type EnumBoughtTreatmentStatusEnumNullableFilter = {
    equals?: InputMaybe<BoughtTreatmentStatusEnum>;
    in?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
};

export type EnumBoughtTreatmentStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumNullableFilter>;
    equals?: InputMaybe<BoughtTreatmentStatusEnum>;
    in?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
};

export type EnumBoughtTreatmentStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumFilter>;
    equals?: InputMaybe<BoughtTreatmentStatusEnum>;
    in?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
};

export type EnumCompletionTimingTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<CompletionTimingType>;
};

export type EnumCompletionTimingTypeFilter = {
    equals?: InputMaybe<CompletionTimingType>;
    in?: InputMaybe<Array<CompletionTimingType>>;
    not?: InputMaybe<NestedEnumCompletionTimingTypeFilter>;
    notIn?: InputMaybe<Array<CompletionTimingType>>;
};

export type EnumCompletionTimingTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCompletionTimingTypeFilter>;
    _min?: InputMaybe<NestedEnumCompletionTimingTypeFilter>;
    equals?: InputMaybe<CompletionTimingType>;
    in?: InputMaybe<Array<CompletionTimingType>>;
    not?: InputMaybe<NestedEnumCompletionTimingTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CompletionTimingType>>;
};

export type EnumConfigCommitStatusNullableFilter = {
    equals?: InputMaybe<ConfigCommitStatus>;
    in?: InputMaybe<Array<ConfigCommitStatus>>;
    not?: InputMaybe<NestedEnumConfigCommitStatusNullableFilter>;
    notIn?: InputMaybe<Array<ConfigCommitStatus>>;
};

export type EnumConfigCommitStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumConfigCommitStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumConfigCommitStatusNullableFilter>;
    equals?: InputMaybe<ConfigCommitStatus>;
    in?: InputMaybe<Array<ConfigCommitStatus>>;
    not?: InputMaybe<NestedEnumConfigCommitStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ConfigCommitStatus>>;
};

export type EnumConsentTypeNullableListFilter = {
    equals?: InputMaybe<Array<ConsentType>>;
    has?: InputMaybe<ConsentType>;
    hasEvery?: InputMaybe<Array<ConsentType>>;
    hasSome?: InputMaybe<Array<ConsentType>>;
    isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumCoverageSourceNullableFilter = {
    equals?: InputMaybe<CoverageSource>;
    in?: InputMaybe<Array<CoverageSource>>;
    not?: InputMaybe<NestedEnumCoverageSourceNullableFilter>;
    notIn?: InputMaybe<Array<CoverageSource>>;
};

export type EnumCoverageSourceNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumCoverageSourceNullableFilter>;
    _min?: InputMaybe<NestedEnumCoverageSourceNullableFilter>;
    equals?: InputMaybe<CoverageSource>;
    in?: InputMaybe<Array<CoverageSource>>;
    not?: InputMaybe<NestedEnumCoverageSourceNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CoverageSource>>;
};

export type EnumCandidateTreatmentPricingStatusEnumFieldUpdateOperationsInput =
    {
        set?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
    };

export type EnumCandidateTreatmentPricingStatusEnumFilter = {
    equals?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
    in?: InputMaybe<Array<CandidateTreatmentPricingStatusEnum>>;
    not?: InputMaybe<NestedEnumCandidateTreatmentPricingStatusEnumFilter>;
    notIn?: InputMaybe<Array<CandidateTreatmentPricingStatusEnum>>;
};

export type EnumCandidateTreatmentPricingStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCandidateTreatmentPricingStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumCandidateTreatmentPricingStatusEnumFilter>;
    equals?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
    in?: InputMaybe<Array<CandidateTreatmentPricingStatusEnum>>;
    not?: InputMaybe<NestedEnumCandidateTreatmentPricingStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CandidateTreatmentPricingStatusEnum>>;
};

export type EnumCandidateTreatmentStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<CandidateTreatmentStatusEnum>;
};

export type EnumCandidateTreatmentStatusEnumFilter = {
    equals?: InputMaybe<CandidateTreatmentStatusEnum>;
    in?: InputMaybe<Array<CandidateTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumCandidateTreatmentStatusEnumFilter>;
    notIn?: InputMaybe<Array<CandidateTreatmentStatusEnum>>;
};

export type EnumCandidateTreatmentStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCandidateTreatmentStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumCandidateTreatmentStatusEnumFilter>;
    equals?: InputMaybe<CandidateTreatmentStatusEnum>;
    in?: InputMaybe<Array<CandidateTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumCandidateTreatmentStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CandidateTreatmentStatusEnum>>;
};

export type EnumCardAuthorizationStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<CardAuthorizationStatus>;
};

export type EnumCardAuthorizationStatusFilter = {
    equals?: InputMaybe<CardAuthorizationStatus>;
    in?: InputMaybe<Array<CardAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumCardAuthorizationStatusFilter>;
    notIn?: InputMaybe<Array<CardAuthorizationStatus>>;
};

export type EnumCardAuthorizationStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCardAuthorizationStatusFilter>;
    _min?: InputMaybe<NestedEnumCardAuthorizationStatusFilter>;
    equals?: InputMaybe<CardAuthorizationStatus>;
    in?: InputMaybe<Array<CardAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumCardAuthorizationStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CardAuthorizationStatus>>;
};

export type EnumChargeReattributionAndPartialPaymentLogTypeFieldUpdateOperationsInput =
    {
        set?: InputMaybe<ChargeReattributionAndPartialPaymentLogType>;
    };

export type EnumChargeReattributionAndPartialPaymentLogTypeFilter = {
    equals?: InputMaybe<ChargeReattributionAndPartialPaymentLogType>;
    in?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogType>>;
    not?: InputMaybe<NestedEnumChargeReattributionAndPartialPaymentLogTypeFilter>;
    notIn?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogType>>;
};

export type EnumChargeReattributionAndPartialPaymentLogTypeWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntFilter>;
        _max?: InputMaybe<NestedEnumChargeReattributionAndPartialPaymentLogTypeFilter>;
        _min?: InputMaybe<NestedEnumChargeReattributionAndPartialPaymentLogTypeFilter>;
        equals?: InputMaybe<ChargeReattributionAndPartialPaymentLogType>;
        in?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogType>>;
        not?: InputMaybe<NestedEnumChargeReattributionAndPartialPaymentLogTypeWithAggregatesFilter>;
        notIn?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogType>>;
    };

export type EnumClaimReturnStatusEnumNullableFilter = {
    equals?: InputMaybe<ClaimReturnStatusEnum>;
    in?: InputMaybe<Array<ClaimReturnStatusEnum>>;
    not?: InputMaybe<NestedEnumClaimReturnStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<ClaimReturnStatusEnum>>;
};

export type EnumClaimReturnStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumClaimReturnStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumClaimReturnStatusEnumNullableFilter>;
    equals?: InputMaybe<ClaimReturnStatusEnum>;
    in?: InputMaybe<Array<ClaimReturnStatusEnum>>;
    not?: InputMaybe<NestedEnumClaimReturnStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ClaimReturnStatusEnum>>;
};

export type EnumConsumerAccountStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<ConsumerAccountStatus>;
};

export type EnumConsumerAccountStatusFilter = {
    equals?: InputMaybe<ConsumerAccountStatus>;
    in?: InputMaybe<Array<ConsumerAccountStatus>>;
    not?: InputMaybe<NestedEnumConsumerAccountStatusFilter>;
    notIn?: InputMaybe<Array<ConsumerAccountStatus>>;
};

export type EnumConsumerAccountStatusNullableFilter = {
    equals?: InputMaybe<ConsumerAccountStatus>;
    in?: InputMaybe<Array<ConsumerAccountStatus>>;
    not?: InputMaybe<NestedEnumConsumerAccountStatusNullableFilter>;
    notIn?: InputMaybe<Array<ConsumerAccountStatus>>;
};

export type EnumConsumerAccountStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumConsumerAccountStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumConsumerAccountStatusNullableFilter>;
    equals?: InputMaybe<ConsumerAccountStatus>;
    in?: InputMaybe<Array<ConsumerAccountStatus>>;
    not?: InputMaybe<NestedEnumConsumerAccountStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ConsumerAccountStatus>>;
};

export type EnumConsumerAccountStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumConsumerAccountStatusFilter>;
    _min?: InputMaybe<NestedEnumConsumerAccountStatusFilter>;
    equals?: InputMaybe<ConsumerAccountStatus>;
    in?: InputMaybe<Array<ConsumerAccountStatus>>;
    not?: InputMaybe<NestedEnumConsumerAccountStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ConsumerAccountStatus>>;
};

export type EnumContractAccountStatusNullableFilter = {
    equals?: InputMaybe<ContractAccountStatus>;
    in?: InputMaybe<Array<ContractAccountStatus>>;
    not?: InputMaybe<NestedEnumContractAccountStatusNullableFilter>;
    notIn?: InputMaybe<Array<ContractAccountStatus>>;
};

export type EnumContractAccountStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumContractAccountStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumContractAccountStatusNullableFilter>;
    equals?: InputMaybe<ContractAccountStatus>;
    in?: InputMaybe<Array<ContractAccountStatus>>;
    not?: InputMaybe<NestedEnumContractAccountStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ContractAccountStatus>>;
};

export type EnumContractStatusNullableFilter = {
    equals?: InputMaybe<ContractStatus>;
    in?: InputMaybe<Array<ContractStatus>>;
    not?: InputMaybe<NestedEnumContractStatusNullableFilter>;
    notIn?: InputMaybe<Array<ContractStatus>>;
};

export type EnumContractStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumContractStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumContractStatusNullableFilter>;
    equals?: InputMaybe<ContractStatus>;
    in?: InputMaybe<Array<ContractStatus>>;
    not?: InputMaybe<NestedEnumContractStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ContractStatus>>;
};

export type EnumContractTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<ContractType>;
};

export type EnumContractTypeFilter = {
    equals?: InputMaybe<ContractType>;
    in?: InputMaybe<Array<ContractType>>;
    not?: InputMaybe<NestedEnumContractTypeFilter>;
    notIn?: InputMaybe<Array<ContractType>>;
};

export type EnumContractTypeNullableFilter = {
    equals?: InputMaybe<ContractType>;
    in?: InputMaybe<Array<ContractType>>;
    not?: InputMaybe<NestedEnumContractTypeNullableFilter>;
    notIn?: InputMaybe<Array<ContractType>>;
};

export type EnumContractTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumContractTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumContractTypeNullableFilter>;
    equals?: InputMaybe<ContractType>;
    in?: InputMaybe<Array<ContractType>>;
    not?: InputMaybe<NestedEnumContractTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ContractType>>;
};

export type EnumContractTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumContractTypeFilter>;
    _min?: InputMaybe<NestedEnumContractTypeFilter>;
    equals?: InputMaybe<ContractType>;
    in?: InputMaybe<Array<ContractType>>;
    not?: InputMaybe<NestedEnumContractTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ContractType>>;
};

export type EnumCptRelationTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<CptRelationType>;
};

export type EnumCptRelationTypeFilter = {
    equals?: InputMaybe<CptRelationType>;
    in?: InputMaybe<Array<CptRelationType>>;
    not?: InputMaybe<NestedEnumCptRelationTypeFilter>;
    notIn?: InputMaybe<Array<CptRelationType>>;
};

export type EnumCptRelationTypeNullableFilter = {
    equals?: InputMaybe<CptRelationType>;
    in?: InputMaybe<Array<CptRelationType>>;
    not?: InputMaybe<NestedEnumCptRelationTypeNullableFilter>;
    notIn?: InputMaybe<Array<CptRelationType>>;
};

export type EnumCptRelationTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumCptRelationTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumCptRelationTypeNullableFilter>;
    equals?: InputMaybe<CptRelationType>;
    in?: InputMaybe<Array<CptRelationType>>;
    not?: InputMaybe<NestedEnumCptRelationTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CptRelationType>>;
};

export type EnumCptRelationTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCptRelationTypeFilter>;
    _min?: InputMaybe<NestedEnumCptRelationTypeFilter>;
    equals?: InputMaybe<CptRelationType>;
    in?: InputMaybe<Array<CptRelationType>>;
    not?: InputMaybe<NestedEnumCptRelationTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CptRelationType>>;
};

export type EnumCustomFieldTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<CustomFieldTypeEnum>;
};

export type EnumCustomFieldTypeEnumFilter = {
    equals?: InputMaybe<CustomFieldTypeEnum>;
    in?: InputMaybe<Array<CustomFieldTypeEnum>>;
    not?: InputMaybe<NestedEnumCustomFieldTypeEnumFilter>;
    notIn?: InputMaybe<Array<CustomFieldTypeEnum>>;
};

export type EnumCustomFieldTypeEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCustomFieldTypeEnumFilter>;
    _min?: InputMaybe<NestedEnumCustomFieldTypeEnumFilter>;
    equals?: InputMaybe<CustomFieldTypeEnum>;
    in?: InputMaybe<Array<CustomFieldTypeEnum>>;
    not?: InputMaybe<NestedEnumCustomFieldTypeEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CustomFieldTypeEnum>>;
};

export type EnumDayOfWeekFieldUpdateOperationsInput = {
    set?: InputMaybe<DayOfWeek>;
};

export type EnumDayOfWeekFilter = {
    equals?: InputMaybe<DayOfWeek>;
    in?: InputMaybe<Array<DayOfWeek>>;
    not?: InputMaybe<NestedEnumDayOfWeekFilter>;
    notIn?: InputMaybe<Array<DayOfWeek>>;
};

export type EnumDayOfWeekWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumDayOfWeekFilter>;
    _min?: InputMaybe<NestedEnumDayOfWeekFilter>;
    equals?: InputMaybe<DayOfWeek>;
    in?: InputMaybe<Array<DayOfWeek>>;
    not?: InputMaybe<NestedEnumDayOfWeekWithAggregatesFilter>;
    notIn?: InputMaybe<Array<DayOfWeek>>;
};

export type EnumDiscountTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<DiscountType>;
};

export type EnumDiscountTypeFilter = {
    equals?: InputMaybe<DiscountType>;
    in?: InputMaybe<Array<DiscountType>>;
    not?: InputMaybe<NestedEnumDiscountTypeFilter>;
    notIn?: InputMaybe<Array<DiscountType>>;
};

export type EnumDiscountTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumDiscountTypeFilter>;
    _min?: InputMaybe<NestedEnumDiscountTypeFilter>;
    equals?: InputMaybe<DiscountType>;
    in?: InputMaybe<Array<DiscountType>>;
    not?: InputMaybe<NestedEnumDiscountTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<DiscountType>>;
};

export type EnumDayOfWeekEnumNullableFilter = {
    equals?: InputMaybe<DayOfWeekEnum>;
    in?: InputMaybe<Array<DayOfWeekEnum>>;
    not?: InputMaybe<NestedEnumDayOfWeekEnumNullableFilter>;
    notIn?: InputMaybe<Array<DayOfWeekEnum>>;
};

export type EnumDayOfWeekEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumDayOfWeekEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumDayOfWeekEnumNullableFilter>;
    equals?: InputMaybe<DayOfWeekEnum>;
    in?: InputMaybe<Array<DayOfWeekEnum>>;
    not?: InputMaybe<NestedEnumDayOfWeekEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<DayOfWeekEnum>>;
};

export type EnumEhrTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrType>;
};

export type EnumEhrTypeFilter = {
    equals?: InputMaybe<EhrType>;
    in?: InputMaybe<Array<EhrType>>;
    not?: InputMaybe<NestedEnumEhrTypeFilter>;
    notIn?: InputMaybe<Array<EhrType>>;
};

export type EnumEhrTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrTypeFilter>;
    _min?: InputMaybe<NestedEnumEhrTypeFilter>;
    equals?: InputMaybe<EhrType>;
    in?: InputMaybe<Array<EhrType>>;
    not?: InputMaybe<NestedEnumEhrTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrType>>;
};

export type EnumEhrPaymentDescriptorStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
};

export type EnumEhrPaymentDescriptorStatusEnumFilter = {
    equals?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
    in?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumFilter>;
    notIn?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
};

export type EnumEhrPaymentDescriptorStatusEnumNullableFilter = {
    equals?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
    in?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
};

export type EnumEhrPaymentDescriptorStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumNullableFilter>;
    equals?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
    in?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
};

export type EnumEhrPaymentDescriptorStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumFilter>;
    equals?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
    in?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
};

export type EnumEhrPaymentLockTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrPaymentLockTypeEnum>;
};

export type EnumEhrPaymentLockTypeEnumFilter = {
    equals?: InputMaybe<EhrPaymentLockTypeEnum>;
    in?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumFilter>;
    notIn?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
};

export type EnumEhrPaymentLockTypeEnumNullableFilter = {
    equals?: InputMaybe<EhrPaymentLockTypeEnum>;
    in?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
};

export type EnumEhrPaymentLockTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumNullableFilter>;
    equals?: InputMaybe<EhrPaymentLockTypeEnum>;
    in?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
};

export type EnumEhrPaymentLockTypeEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumFilter>;
    _min?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumFilter>;
    equals?: InputMaybe<EhrPaymentLockTypeEnum>;
    in?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
};

export type EnumEhrPostDetailActionFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrPostDetailAction>;
};

export type EnumEhrPostDetailActionFilter = {
    equals?: InputMaybe<EhrPostDetailAction>;
    in?: InputMaybe<Array<EhrPostDetailAction>>;
    not?: InputMaybe<NestedEnumEhrPostDetailActionFilter>;
    notIn?: InputMaybe<Array<EhrPostDetailAction>>;
};

export type EnumEhrPostDetailActionWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrPostDetailActionFilter>;
    _min?: InputMaybe<NestedEnumEhrPostDetailActionFilter>;
    equals?: InputMaybe<EhrPostDetailAction>;
    in?: InputMaybe<Array<EhrPostDetailAction>>;
    not?: InputMaybe<NestedEnumEhrPostDetailActionWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPostDetailAction>>;
};

export type EnumEhrPostIdentifierTypeEnumNullableFilter = {
    equals?: InputMaybe<EhrPostIdentifierTypeEnum>;
    in?: InputMaybe<Array<EhrPostIdentifierTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPostIdentifierTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrPostIdentifierTypeEnum>>;
};

export type EnumEhrPostIdentifierTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrPostIdentifierTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrPostIdentifierTypeEnumNullableFilter>;
    equals?: InputMaybe<EhrPostIdentifierTypeEnum>;
    in?: InputMaybe<Array<EhrPostIdentifierTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPostIdentifierTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPostIdentifierTypeEnum>>;
};

export type EnumEhrPostLedgerSourceEnumNullableFilter = {
    equals?: InputMaybe<EhrPostLedgerSourceEnum>;
    in?: InputMaybe<Array<EhrPostLedgerSourceEnum>>;
    not?: InputMaybe<NestedEnumEhrPostLedgerSourceEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrPostLedgerSourceEnum>>;
};

export type EnumEhrPostLedgerSourceEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrPostLedgerSourceEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrPostLedgerSourceEnumNullableFilter>;
    equals?: InputMaybe<EhrPostLedgerSourceEnum>;
    in?: InputMaybe<Array<EhrPostLedgerSourceEnum>>;
    not?: InputMaybe<NestedEnumEhrPostLedgerSourceEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPostLedgerSourceEnum>>;
};

export type EnumEhrPostStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrPostStatusEnum>;
};

export type EnumEhrPostStatusEnumFilter = {
    equals?: InputMaybe<EhrPostStatusEnum>;
    in?: InputMaybe<Array<EhrPostStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPostStatusEnumFilter>;
    notIn?: InputMaybe<Array<EhrPostStatusEnum>>;
};

export type EnumEhrPostStatusEnumNullableFilter = {
    equals?: InputMaybe<EhrPostStatusEnum>;
    in?: InputMaybe<Array<EhrPostStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPostStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrPostStatusEnum>>;
};

export type EnumEhrPostStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrPostStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrPostStatusEnumNullableFilter>;
    equals?: InputMaybe<EhrPostStatusEnum>;
    in?: InputMaybe<Array<EhrPostStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPostStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPostStatusEnum>>;
};

export type EnumEhrPostStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrPostStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumEhrPostStatusEnumFilter>;
    equals?: InputMaybe<EhrPostStatusEnum>;
    in?: InputMaybe<Array<EhrPostStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPostStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPostStatusEnum>>;
};

export type EnumEhrSlotStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrSlotStatusEnum>;
};

export type EnumEhrSlotStatusEnumFilter = {
    equals?: InputMaybe<EhrSlotStatusEnum>;
    in?: InputMaybe<Array<EhrSlotStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrSlotStatusEnumFilter>;
    notIn?: InputMaybe<Array<EhrSlotStatusEnum>>;
};

export type EnumEhrSlotStatusEnumNullableFilter = {
    equals?: InputMaybe<EhrSlotStatusEnum>;
    in?: InputMaybe<Array<EhrSlotStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrSlotStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrSlotStatusEnum>>;
};

export type EnumEhrSlotStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrSlotStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrSlotStatusEnumNullableFilter>;
    equals?: InputMaybe<EhrSlotStatusEnum>;
    in?: InputMaybe<Array<EhrSlotStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrSlotStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrSlotStatusEnum>>;
};

export type EnumEhrSlotStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrSlotStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumEhrSlotStatusEnumFilter>;
    equals?: InputMaybe<EhrSlotStatusEnum>;
    in?: InputMaybe<Array<EhrSlotStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrSlotStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrSlotStatusEnum>>;
};

export type EnumEhrTypeEnumNullableFilter = {
    equals?: InputMaybe<EhrTypeEnum>;
    in?: InputMaybe<Array<EhrTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrTypeEnum>>;
};

export type EnumEhrTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrTypeEnumNullableFilter>;
    equals?: InputMaybe<EhrTypeEnum>;
    in?: InputMaybe<Array<EhrTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrTypeEnum>>;
};

export type EnumEmergencyContactRelationshipNullableFilter = {
    equals?: InputMaybe<EmergencyContactRelationship>;
    in?: InputMaybe<Array<EmergencyContactRelationship>>;
    not?: InputMaybe<NestedEnumEmergencyContactRelationshipNullableFilter>;
    notIn?: InputMaybe<Array<EmergencyContactRelationship>>;
};

export type EnumEmergencyContactRelationshipNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEmergencyContactRelationshipNullableFilter>;
    _min?: InputMaybe<NestedEnumEmergencyContactRelationshipNullableFilter>;
    equals?: InputMaybe<EmergencyContactRelationship>;
    in?: InputMaybe<Array<EmergencyContactRelationship>>;
    not?: InputMaybe<NestedEnumEmergencyContactRelationshipNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EmergencyContactRelationship>>;
};

export type EnumEmploymentStatusNullableFilter = {
    equals?: InputMaybe<EmploymentStatus>;
    in?: InputMaybe<Array<EmploymentStatus>>;
    not?: InputMaybe<NestedEnumEmploymentStatusNullableFilter>;
    notIn?: InputMaybe<Array<EmploymentStatus>>;
};

export type EnumEmploymentStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEmploymentStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumEmploymentStatusNullableFilter>;
    equals?: InputMaybe<EmploymentStatus>;
    in?: InputMaybe<Array<EmploymentStatus>>;
    not?: InputMaybe<NestedEnumEmploymentStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EmploymentStatus>>;
};

export type EnumEncounterSourceEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EncounterSourceEnum>;
};

export type EnumEncounterSourceEnumFilter = {
    equals?: InputMaybe<EncounterSourceEnum>;
    in?: InputMaybe<Array<EncounterSourceEnum>>;
    not?: InputMaybe<NestedEnumEncounterSourceEnumFilter>;
    notIn?: InputMaybe<Array<EncounterSourceEnum>>;
};

export type EnumEncounterSourceEnumNullableFilter = {
    equals?: InputMaybe<EncounterSourceEnum>;
    in?: InputMaybe<Array<EncounterSourceEnum>>;
    not?: InputMaybe<NestedEnumEncounterSourceEnumNullableFilter>;
    notIn?: InputMaybe<Array<EncounterSourceEnum>>;
};

export type EnumEncounterSourceEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEncounterSourceEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEncounterSourceEnumNullableFilter>;
    equals?: InputMaybe<EncounterSourceEnum>;
    in?: InputMaybe<Array<EncounterSourceEnum>>;
    not?: InputMaybe<NestedEnumEncounterSourceEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EncounterSourceEnum>>;
};

export type EnumEncounterSourceEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEncounterSourceEnumFilter>;
    _min?: InputMaybe<NestedEnumEncounterSourceEnumFilter>;
    equals?: InputMaybe<EncounterSourceEnum>;
    in?: InputMaybe<Array<EncounterSourceEnum>>;
    not?: InputMaybe<NestedEnumEncounterSourceEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EncounterSourceEnum>>;
};

export type EnumEncounterStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EncounterStatusEnum>;
};

export type EnumEncounterStatusEnumFilter = {
    equals?: InputMaybe<EncounterStatusEnum>;
    in?: InputMaybe<Array<EncounterStatusEnum>>;
    not?: InputMaybe<NestedEnumEncounterStatusEnumFilter>;
    notIn?: InputMaybe<Array<EncounterStatusEnum>>;
};

export type EnumEncounterStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEncounterStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumEncounterStatusEnumFilter>;
    equals?: InputMaybe<EncounterStatusEnum>;
    in?: InputMaybe<Array<EncounterStatusEnum>>;
    not?: InputMaybe<NestedEnumEncounterStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EncounterStatusEnum>>;
};

export type EnumEthnicityNullableFilter = {
    equals?: InputMaybe<Ethnicity>;
    in?: InputMaybe<Array<Ethnicity>>;
    not?: InputMaybe<NestedEnumEthnicityNullableFilter>;
    notIn?: InputMaybe<Array<Ethnicity>>;
};

export type EnumEthnicityNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEthnicityNullableFilter>;
    _min?: InputMaybe<NestedEnumEthnicityNullableFilter>;
    equals?: InputMaybe<Ethnicity>;
    in?: InputMaybe<Array<Ethnicity>>;
    not?: InputMaybe<NestedEnumEthnicityNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Ethnicity>>;
};

export type EnumExperityEncounterStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<ExperityEncounterStatusEnum>;
};

export type EnumExperityEncounterStatusEnumFilter = {
    equals?: InputMaybe<ExperityEncounterStatusEnum>;
    in?: InputMaybe<Array<ExperityEncounterStatusEnum>>;
    not?: InputMaybe<NestedEnumExperityEncounterStatusEnumFilter>;
    notIn?: InputMaybe<Array<ExperityEncounterStatusEnum>>;
};

export type EnumExperityEncounterStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumExperityEncounterStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumExperityEncounterStatusEnumFilter>;
    equals?: InputMaybe<ExperityEncounterStatusEnum>;
    in?: InputMaybe<Array<ExperityEncounterStatusEnum>>;
    not?: InputMaybe<NestedEnumExperityEncounterStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ExperityEncounterStatusEnum>>;
};

export type EnumFeeTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<FeeType>;
};

export type EnumFeeTypeFilter = {
    equals?: InputMaybe<FeeType>;
    in?: InputMaybe<Array<FeeType>>;
    not?: InputMaybe<NestedEnumFeeTypeFilter>;
    notIn?: InputMaybe<Array<FeeType>>;
};

export type EnumFeeTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumFeeTypeFilter>;
    _min?: InputMaybe<NestedEnumFeeTypeFilter>;
    equals?: InputMaybe<FeeType>;
    in?: InputMaybe<Array<FeeType>>;
    not?: InputMaybe<NestedEnumFeeTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<FeeType>>;
};

export type EnumFeeUnitNullableFilter = {
    equals?: InputMaybe<FeeUnit>;
    in?: InputMaybe<Array<FeeUnit>>;
    not?: InputMaybe<NestedEnumFeeUnitNullableFilter>;
    notIn?: InputMaybe<Array<FeeUnit>>;
};

export type EnumFeeUnitNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumFeeUnitNullableFilter>;
    _min?: InputMaybe<NestedEnumFeeUnitNullableFilter>;
    equals?: InputMaybe<FeeUnit>;
    in?: InputMaybe<Array<FeeUnit>>;
    not?: InputMaybe<NestedEnumFeeUnitNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<FeeUnit>>;
};

export type EnumFeesAndPayoutsProcessingStatusEnumNullableFilter = {
    equals?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    in?: InputMaybe<Array<FeesAndPayoutsProcessingStatusEnum>>;
    not?: InputMaybe<NestedEnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<FeesAndPayoutsProcessingStatusEnum>>;
};

export type EnumFeesAndPayoutsProcessingStatusEnumNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
        _min?: InputMaybe<NestedEnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
        equals?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
        in?: InputMaybe<Array<FeesAndPayoutsProcessingStatusEnum>>;
        not?: InputMaybe<NestedEnumFeesAndPayoutsProcessingStatusEnumNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<FeesAndPayoutsProcessingStatusEnum>>;
    };

export type EnumIntakeQuestionTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<IntakeQuestionType>;
};

export type EnumIntakeQuestionTypeFilter = {
    equals?: InputMaybe<IntakeQuestionType>;
    in?: InputMaybe<Array<IntakeQuestionType>>;
    not?: InputMaybe<NestedEnumIntakeQuestionTypeFilter>;
    notIn?: InputMaybe<Array<IntakeQuestionType>>;
};

export type EnumIntakeQuestionTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumIntakeQuestionTypeFilter>;
    _min?: InputMaybe<NestedEnumIntakeQuestionTypeFilter>;
    equals?: InputMaybe<IntakeQuestionType>;
    in?: InputMaybe<Array<IntakeQuestionType>>;
    not?: InputMaybe<NestedEnumIntakeQuestionTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<IntakeQuestionType>>;
};

export type EnumInboundRequestLogStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<InboundRequestLogStatus>;
};

export type EnumInboundRequestLogStatusFilter = {
    equals?: InputMaybe<InboundRequestLogStatus>;
    in?: InputMaybe<Array<InboundRequestLogStatus>>;
    not?: InputMaybe<NestedEnumInboundRequestLogStatusFilter>;
    notIn?: InputMaybe<Array<InboundRequestLogStatus>>;
};

export type EnumInboundRequestLogStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumInboundRequestLogStatusFilter>;
    _min?: InputMaybe<NestedEnumInboundRequestLogStatusFilter>;
    equals?: InputMaybe<InboundRequestLogStatus>;
    in?: InputMaybe<Array<InboundRequestLogStatus>>;
    not?: InputMaybe<NestedEnumInboundRequestLogStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InboundRequestLogStatus>>;
};

export type EnumInsuranceAccountStatusNullableFilter = {
    equals?: InputMaybe<InsuranceAccountStatus>;
    in?: InputMaybe<Array<InsuranceAccountStatus>>;
    not?: InputMaybe<NestedEnumInsuranceAccountStatusNullableFilter>;
    notIn?: InputMaybe<Array<InsuranceAccountStatus>>;
};

export type EnumInsuranceAccountStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumInsuranceAccountStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumInsuranceAccountStatusNullableFilter>;
    equals?: InputMaybe<InsuranceAccountStatus>;
    in?: InputMaybe<Array<InsuranceAccountStatus>>;
    not?: InputMaybe<NestedEnumInsuranceAccountStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InsuranceAccountStatus>>;
};

export type EnumInsuranceMetadataStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<InsuranceMetadataStatusEnum>;
};

export type EnumInsuranceMetadataStatusEnumFilter = {
    equals?: InputMaybe<InsuranceMetadataStatusEnum>;
    in?: InputMaybe<Array<InsuranceMetadataStatusEnum>>;
    not?: InputMaybe<NestedEnumInsuranceMetadataStatusEnumFilter>;
    notIn?: InputMaybe<Array<InsuranceMetadataStatusEnum>>;
};

export type EnumInsuranceMetadataStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumInsuranceMetadataStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumInsuranceMetadataStatusEnumFilter>;
    equals?: InputMaybe<InsuranceMetadataStatusEnum>;
    in?: InputMaybe<Array<InsuranceMetadataStatusEnum>>;
    not?: InputMaybe<NestedEnumInsuranceMetadataStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InsuranceMetadataStatusEnum>>;
};

export type EnumInvoiceStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<InvoiceStatus>;
};

export type EnumInvoiceStatusFilter = {
    equals?: InputMaybe<InvoiceStatus>;
    in?: InputMaybe<Array<InvoiceStatus>>;
    not?: InputMaybe<NestedEnumInvoiceStatusFilter>;
    notIn?: InputMaybe<Array<InvoiceStatus>>;
};

export type EnumInvoiceStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumInvoiceStatusFilter>;
    _min?: InputMaybe<NestedEnumInvoiceStatusFilter>;
    equals?: InputMaybe<InvoiceStatus>;
    in?: InputMaybe<Array<InvoiceStatus>>;
    not?: InputMaybe<NestedEnumInvoiceStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InvoiceStatus>>;
};

export type EnumKioskHrtTypeNullableFilter = {
    equals?: InputMaybe<KioskHrtType>;
    in?: InputMaybe<Array<KioskHrtType>>;
    not?: InputMaybe<NestedEnumKioskHrtTypeNullableFilter>;
    notIn?: InputMaybe<Array<KioskHrtType>>;
};

export type EnumKioskHrtTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumKioskHrtTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumKioskHrtTypeNullableFilter>;
    equals?: InputMaybe<KioskHrtType>;
    in?: InputMaybe<Array<KioskHrtType>>;
    not?: InputMaybe<NestedEnumKioskHrtTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<KioskHrtType>>;
};

export type EnumLinkTypeNullableFilter = {
    equals?: InputMaybe<LinkType>;
    in?: InputMaybe<Array<LinkType>>;
    not?: InputMaybe<NestedEnumLinkTypeNullableFilter>;
    notIn?: InputMaybe<Array<LinkType>>;
};

export type EnumLinkTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumLinkTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumLinkTypeNullableFilter>;
    equals?: InputMaybe<LinkType>;
    in?: InputMaybe<Array<LinkType>>;
    not?: InputMaybe<NestedEnumLinkTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<LinkType>>;
};

export type EnumLanguageCodeFieldUpdateOperationsInput = {
    set?: InputMaybe<LanguageCode>;
};

export type EnumLanguageCodeFilter = {
    equals?: InputMaybe<LanguageCode>;
    in?: InputMaybe<Array<LanguageCode>>;
    not?: InputMaybe<NestedEnumLanguageCodeFilter>;
    notIn?: InputMaybe<Array<LanguageCode>>;
};

export type EnumLanguageCodeNullableFilter = {
    equals?: InputMaybe<LanguageCode>;
    in?: InputMaybe<Array<LanguageCode>>;
    not?: InputMaybe<NestedEnumLanguageCodeNullableFilter>;
    notIn?: InputMaybe<Array<LanguageCode>>;
};

export type EnumLanguageCodeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumLanguageCodeNullableFilter>;
    _min?: InputMaybe<NestedEnumLanguageCodeNullableFilter>;
    equals?: InputMaybe<LanguageCode>;
    in?: InputMaybe<Array<LanguageCode>>;
    not?: InputMaybe<NestedEnumLanguageCodeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<LanguageCode>>;
};

export type EnumLanguageCodeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumLanguageCodeFilter>;
    _min?: InputMaybe<NestedEnumLanguageCodeFilter>;
    equals?: InputMaybe<LanguageCode>;
    in?: InputMaybe<Array<LanguageCode>>;
    not?: InputMaybe<NestedEnumLanguageCodeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<LanguageCode>>;
};

export type EnumLiveTransferActionEnumNullableFilter = {
    equals?: InputMaybe<LiveTransferActionEnum>;
    in?: InputMaybe<Array<LiveTransferActionEnum>>;
    not?: InputMaybe<NestedEnumLiveTransferActionEnumNullableFilter>;
    notIn?: InputMaybe<Array<LiveTransferActionEnum>>;
};

export type EnumLiveTransferActionEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumLiveTransferActionEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumLiveTransferActionEnumNullableFilter>;
    equals?: InputMaybe<LiveTransferActionEnum>;
    in?: InputMaybe<Array<LiveTransferActionEnum>>;
    not?: InputMaybe<NestedEnumLiveTransferActionEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<LiveTransferActionEnum>>;
};

export type EnumLiveTransferStatusEnumNullableFilter = {
    equals?: InputMaybe<LiveTransferStatusEnum>;
    in?: InputMaybe<Array<LiveTransferStatusEnum>>;
    not?: InputMaybe<NestedEnumLiveTransferStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<LiveTransferStatusEnum>>;
};

export type EnumLiveTransferStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumLiveTransferStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumLiveTransferStatusEnumNullableFilter>;
    equals?: InputMaybe<LiveTransferStatusEnum>;
    in?: InputMaybe<Array<LiveTransferStatusEnum>>;
    not?: InputMaybe<NestedEnumLiveTransferStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<LiveTransferStatusEnum>>;
};

export type EnumMessageContextNullableListFilter = {
    equals?: InputMaybe<Array<MessageContext>>;
    has?: InputMaybe<MessageContext>;
    hasEvery?: InputMaybe<Array<MessageContext>>;
    hasSome?: InputMaybe<Array<MessageContext>>;
    isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumMaritalStatusNullableFilter = {
    equals?: InputMaybe<MaritalStatus>;
    in?: InputMaybe<Array<MaritalStatus>>;
    not?: InputMaybe<NestedEnumMaritalStatusNullableFilter>;
    notIn?: InputMaybe<Array<MaritalStatus>>;
};

export type EnumMaritalStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumMaritalStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumMaritalStatusNullableFilter>;
    equals?: InputMaybe<MaritalStatus>;
    in?: InputMaybe<Array<MaritalStatus>>;
    not?: InputMaybe<NestedEnumMaritalStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<MaritalStatus>>;
};

export type EnumMcmsAdjudicationVersionNullableFilter = {
    equals?: InputMaybe<McmsAdjudicationVersion>;
    in?: InputMaybe<Array<McmsAdjudicationVersion>>;
    not?: InputMaybe<NestedEnumMcmsAdjudicationVersionNullableFilter>;
    notIn?: InputMaybe<Array<McmsAdjudicationVersion>>;
};

export type EnumMcmsAdjudicationVersionNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumMcmsAdjudicationVersionNullableFilter>;
    _min?: InputMaybe<NestedEnumMcmsAdjudicationVersionNullableFilter>;
    equals?: InputMaybe<McmsAdjudicationVersion>;
    in?: InputMaybe<Array<McmsAdjudicationVersion>>;
    not?: InputMaybe<NestedEnumMcmsAdjudicationVersionNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<McmsAdjudicationVersion>>;
};

export type EnumMcmsReversalActionFieldUpdateOperationsInput = {
    set?: InputMaybe<McmsReversalAction>;
};

export type EnumMcmsReversalActionFilter = {
    equals?: InputMaybe<McmsReversalAction>;
    in?: InputMaybe<Array<McmsReversalAction>>;
    not?: InputMaybe<NestedEnumMcmsReversalActionFilter>;
    notIn?: InputMaybe<Array<McmsReversalAction>>;
};

export type EnumMcmsReversalActionNullableFilter = {
    equals?: InputMaybe<McmsReversalAction>;
    in?: InputMaybe<Array<McmsReversalAction>>;
    not?: InputMaybe<NestedEnumMcmsReversalActionNullableFilter>;
    notIn?: InputMaybe<Array<McmsReversalAction>>;
};

export type EnumMcmsReversalActionNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumMcmsReversalActionNullableFilter>;
    _min?: InputMaybe<NestedEnumMcmsReversalActionNullableFilter>;
    equals?: InputMaybe<McmsReversalAction>;
    in?: InputMaybe<Array<McmsReversalAction>>;
    not?: InputMaybe<NestedEnumMcmsReversalActionNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<McmsReversalAction>>;
};

export type EnumMcmsReversalActionWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumMcmsReversalActionFilter>;
    _min?: InputMaybe<NestedEnumMcmsReversalActionFilter>;
    equals?: InputMaybe<McmsReversalAction>;
    in?: InputMaybe<Array<McmsReversalAction>>;
    not?: InputMaybe<NestedEnumMcmsReversalActionWithAggregatesFilter>;
    notIn?: InputMaybe<Array<McmsReversalAction>>;
};

export type EnumMessageNudgeStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<MessageNudgeStatus>;
};

export type EnumMessageNudgeStatusFilter = {
    equals?: InputMaybe<MessageNudgeStatus>;
    in?: InputMaybe<Array<MessageNudgeStatus>>;
    not?: InputMaybe<NestedEnumMessageNudgeStatusFilter>;
    notIn?: InputMaybe<Array<MessageNudgeStatus>>;
};

export type EnumMessageNudgeStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumMessageNudgeStatusFilter>;
    _min?: InputMaybe<NestedEnumMessageNudgeStatusFilter>;
    equals?: InputMaybe<MessageNudgeStatus>;
    in?: InputMaybe<Array<MessageNudgeStatus>>;
    not?: InputMaybe<NestedEnumMessageNudgeStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<MessageNudgeStatus>>;
};

export type EnumMessageStatusNullableFilter = {
    equals?: InputMaybe<MessageStatus>;
    in?: InputMaybe<Array<MessageStatus>>;
    not?: InputMaybe<NestedEnumMessageStatusNullableFilter>;
    notIn?: InputMaybe<Array<MessageStatus>>;
};

export type EnumMessageStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumMessageStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumMessageStatusNullableFilter>;
    equals?: InputMaybe<MessageStatus>;
    in?: InputMaybe<Array<MessageStatus>>;
    not?: InputMaybe<NestedEnumMessageStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<MessageStatus>>;
};

export type EnumMessagingRuleNameFieldUpdateOperationsInput = {
    set?: InputMaybe<MessagingRuleName>;
};

export type EnumMessagingRuleNameFilter = {
    equals?: InputMaybe<MessagingRuleName>;
    in?: InputMaybe<Array<MessagingRuleName>>;
    not?: InputMaybe<NestedEnumMessagingRuleNameFilter>;
    notIn?: InputMaybe<Array<MessagingRuleName>>;
};

export type EnumMessagingRuleNameWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumMessagingRuleNameFilter>;
    _min?: InputMaybe<NestedEnumMessagingRuleNameFilter>;
    equals?: InputMaybe<MessagingRuleName>;
    in?: InputMaybe<Array<MessagingRuleName>>;
    not?: InputMaybe<NestedEnumMessagingRuleNameWithAggregatesFilter>;
    notIn?: InputMaybe<Array<MessagingRuleName>>;
};

export type EnumMessagingRuleTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<MessagingRuleType>;
};

export type EnumMessagingRuleTypeFilter = {
    equals?: InputMaybe<MessagingRuleType>;
    in?: InputMaybe<Array<MessagingRuleType>>;
    not?: InputMaybe<NestedEnumMessagingRuleTypeFilter>;
    notIn?: InputMaybe<Array<MessagingRuleType>>;
};

export type EnumMessagingRuleTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumMessagingRuleTypeFilter>;
    _min?: InputMaybe<NestedEnumMessagingRuleTypeFilter>;
    equals?: InputMaybe<MessagingRuleType>;
    in?: InputMaybe<Array<MessagingRuleType>>;
    not?: InputMaybe<NestedEnumMessagingRuleTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<MessagingRuleType>>;
};

export type EnumNetworkTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<NetworkType>;
};

export type EnumNetworkTypeFilter = {
    equals?: InputMaybe<NetworkType>;
    in?: InputMaybe<Array<NetworkType>>;
    not?: InputMaybe<NestedEnumNetworkTypeFilter>;
    notIn?: InputMaybe<Array<NetworkType>>;
};

export type EnumNetworkTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumNetworkTypeFilter>;
    _min?: InputMaybe<NestedEnumNetworkTypeFilter>;
    equals?: InputMaybe<NetworkType>;
    in?: InputMaybe<Array<NetworkType>>;
    not?: InputMaybe<NestedEnumNetworkTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<NetworkType>>;
};

export type EnumNonCardRefundStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<NonCardRefundStatus>;
};

export type EnumNonCardRefundStatusFilter = {
    equals?: InputMaybe<NonCardRefundStatus>;
    in?: InputMaybe<Array<NonCardRefundStatus>>;
    not?: InputMaybe<NestedEnumNonCardRefundStatusFilter>;
    notIn?: InputMaybe<Array<NonCardRefundStatus>>;
};

export type EnumNonCardRefundStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumNonCardRefundStatusFilter>;
    _min?: InputMaybe<NestedEnumNonCardRefundStatusFilter>;
    equals?: InputMaybe<NonCardRefundStatus>;
    in?: InputMaybe<Array<NonCardRefundStatus>>;
    not?: InputMaybe<NestedEnumNonCardRefundStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<NonCardRefundStatus>>;
};

export type EnumParsingRuleFieldUpdateOperationsInput = {
    set?: InputMaybe<ParsingRule>;
};

export type EnumParsingRuleFilter = {
    equals?: InputMaybe<ParsingRule>;
    in?: InputMaybe<Array<ParsingRule>>;
    not?: InputMaybe<NestedEnumParsingRuleFilter>;
    notIn?: InputMaybe<Array<ParsingRule>>;
};

export type EnumParsingRuleWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumParsingRuleFilter>;
    _min?: InputMaybe<NestedEnumParsingRuleFilter>;
    equals?: InputMaybe<ParsingRule>;
    in?: InputMaybe<Array<ParsingRule>>;
    not?: InputMaybe<NestedEnumParsingRuleWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ParsingRule>>;
};

export type EnumPayerTagNullableFilter = {
    equals?: InputMaybe<PayerTag>;
    in?: InputMaybe<Array<PayerTag>>;
    not?: InputMaybe<NestedEnumPayerTagNullableFilter>;
    notIn?: InputMaybe<Array<PayerTag>>;
};

export type EnumPayerTagNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPayerTagNullableFilter>;
    _min?: InputMaybe<NestedEnumPayerTagNullableFilter>;
    equals?: InputMaybe<PayerTag>;
    in?: InputMaybe<Array<PayerTag>>;
    not?: InputMaybe<NestedEnumPayerTagNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PayerTag>>;
};

export type EnumPayerTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PayerType>;
};

export type EnumPayerTypeFilter = {
    equals?: InputMaybe<PayerType>;
    in?: InputMaybe<Array<PayerType>>;
    not?: InputMaybe<NestedEnumPayerTypeFilter>;
    notIn?: InputMaybe<Array<PayerType>>;
};

export type EnumPayerTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPayerTypeFilter>;
    _min?: InputMaybe<NestedEnumPayerTypeFilter>;
    equals?: InputMaybe<PayerType>;
    in?: InputMaybe<Array<PayerType>>;
    not?: InputMaybe<NestedEnumPayerTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PayerType>>;
};

export type EnumPaymentTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentType>;
};

export type EnumPaymentTypeFilter = {
    equals?: InputMaybe<PaymentType>;
    in?: InputMaybe<Array<PaymentType>>;
    not?: InputMaybe<NestedEnumPaymentTypeFilter>;
    notIn?: InputMaybe<Array<PaymentType>>;
};

export type EnumPaymentTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentTypeFilter>;
    _min?: InputMaybe<NestedEnumPaymentTypeFilter>;
    equals?: InputMaybe<PaymentType>;
    in?: InputMaybe<Array<PaymentType>>;
    not?: InputMaybe<NestedEnumPaymentTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentType>>;
};

export type EnumPricingTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PricingType>;
};

export type EnumPricingTypeFilter = {
    equals?: InputMaybe<PricingType>;
    in?: InputMaybe<Array<PricingType>>;
    not?: InputMaybe<NestedEnumPricingTypeFilter>;
    notIn?: InputMaybe<Array<PricingType>>;
};

export type EnumPricingTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPricingTypeFilter>;
    _min?: InputMaybe<NestedEnumPricingTypeFilter>;
    equals?: InputMaybe<PricingType>;
    in?: InputMaybe<Array<PricingType>>;
    not?: InputMaybe<NestedEnumPricingTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PricingType>>;
};

export type EnumProductCategoryTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<ProductCategoryType>;
};

export type EnumProductCategoryTypeFilter = {
    equals?: InputMaybe<ProductCategoryType>;
    in?: InputMaybe<Array<ProductCategoryType>>;
    not?: InputMaybe<NestedEnumProductCategoryTypeFilter>;
    notIn?: InputMaybe<Array<ProductCategoryType>>;
};

export type EnumProductCategoryTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumProductCategoryTypeFilter>;
    _min?: InputMaybe<NestedEnumProductCategoryTypeFilter>;
    equals?: InputMaybe<ProductCategoryType>;
    in?: InputMaybe<Array<ProductCategoryType>>;
    not?: InputMaybe<NestedEnumProductCategoryTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ProductCategoryType>>;
};

export type EnumProductComponentTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<ProductComponentType>;
};

export type EnumProductComponentTypeFilter = {
    equals?: InputMaybe<ProductComponentType>;
    in?: InputMaybe<Array<ProductComponentType>>;
    not?: InputMaybe<NestedEnumProductComponentTypeFilter>;
    notIn?: InputMaybe<Array<ProductComponentType>>;
};

export type EnumProductComponentTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumProductComponentTypeFilter>;
    _min?: InputMaybe<NestedEnumProductComponentTypeFilter>;
    equals?: InputMaybe<ProductComponentType>;
    in?: InputMaybe<Array<ProductComponentType>>;
    not?: InputMaybe<NestedEnumProductComponentTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ProductComponentType>>;
};

export type EnumProductPageTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<ProductPageType>;
};

export type EnumProductPageTypeFilter = {
    equals?: InputMaybe<ProductPageType>;
    in?: InputMaybe<Array<ProductPageType>>;
    not?: InputMaybe<NestedEnumProductPageTypeFilter>;
    notIn?: InputMaybe<Array<ProductPageType>>;
};

export type EnumProductPageTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumProductPageTypeFilter>;
    _min?: InputMaybe<NestedEnumProductPageTypeFilter>;
    equals?: InputMaybe<ProductPageType>;
    in?: InputMaybe<Array<ProductPageType>>;
    not?: InputMaybe<NestedEnumProductPageTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ProductPageType>>;
};

export type EnumProductTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<ProductType>;
};

export type EnumProductTypeFilter = {
    equals?: InputMaybe<ProductType>;
    in?: InputMaybe<Array<ProductType>>;
    not?: InputMaybe<NestedEnumProductTypeFilter>;
    notIn?: InputMaybe<Array<ProductType>>;
};

export type EnumProductTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumProductTypeFilter>;
    _min?: InputMaybe<NestedEnumProductTypeFilter>;
    equals?: InputMaybe<ProductType>;
    in?: InputMaybe<Array<ProductType>>;
    not?: InputMaybe<NestedEnumProductTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ProductType>>;
};

export type EnumPropagationTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PropagationType>;
};

export type EnumPropagationTypeFilter = {
    equals?: InputMaybe<PropagationType>;
    in?: InputMaybe<Array<PropagationType>>;
    not?: InputMaybe<NestedEnumPropagationTypeFilter>;
    notIn?: InputMaybe<Array<PropagationType>>;
};

export type EnumPropagationTypeNullableFilter = {
    equals?: InputMaybe<PropagationType>;
    in?: InputMaybe<Array<PropagationType>>;
    not?: InputMaybe<NestedEnumPropagationTypeNullableFilter>;
    notIn?: InputMaybe<Array<PropagationType>>;
};

export type EnumPropagationTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPropagationTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPropagationTypeNullableFilter>;
    equals?: InputMaybe<PropagationType>;
    in?: InputMaybe<Array<PropagationType>>;
    not?: InputMaybe<NestedEnumPropagationTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PropagationType>>;
};

export type EnumPropagationTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPropagationTypeFilter>;
    _min?: InputMaybe<NestedEnumPropagationTypeFilter>;
    equals?: InputMaybe<PropagationType>;
    in?: InputMaybe<Array<PropagationType>>;
    not?: InputMaybe<NestedEnumPropagationTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PropagationType>>;
};

export type EnumPayLaterAuthorizationStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<PayLaterAuthorizationStatus>;
};

export type EnumPayLaterAuthorizationStatusFilter = {
    equals?: InputMaybe<PayLaterAuthorizationStatus>;
    in?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumPayLaterAuthorizationStatusFilter>;
    notIn?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
};

export type EnumPayLaterAuthorizationStatusNullableFilter = {
    equals?: InputMaybe<PayLaterAuthorizationStatus>;
    in?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumPayLaterAuthorizationStatusNullableFilter>;
    notIn?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
};

export type EnumPayLaterAuthorizationStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPayLaterAuthorizationStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumPayLaterAuthorizationStatusNullableFilter>;
    equals?: InputMaybe<PayLaterAuthorizationStatus>;
    in?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumPayLaterAuthorizationStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
};

export type EnumPayLaterAuthorizationStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPayLaterAuthorizationStatusFilter>;
    _min?: InputMaybe<NestedEnumPayLaterAuthorizationStatusFilter>;
    equals?: InputMaybe<PayLaterAuthorizationStatus>;
    in?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumPayLaterAuthorizationStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
};

export type EnumPaymentAuthorizationConsentTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentAuthorizationConsentType>;
};

export type EnumPaymentAuthorizationConsentTypeFilter = {
    equals?: InputMaybe<PaymentAuthorizationConsentType>;
    in?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
    not?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeFilter>;
    notIn?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
};

export type EnumPaymentAuthorizationConsentTypeNullableFilter = {
    equals?: InputMaybe<PaymentAuthorizationConsentType>;
    in?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
    not?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeNullableFilter>;
    notIn?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
};

export type EnumPaymentAuthorizationConsentTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeNullableFilter>;
    equals?: InputMaybe<PaymentAuthorizationConsentType>;
    in?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
    not?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
};

export type EnumPaymentAuthorizationConsentTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeFilter>;
    _min?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeFilter>;
    equals?: InputMaybe<PaymentAuthorizationConsentType>;
    in?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
    not?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
};

export type EnumPaymentContractEndReasonNullableFilter = {
    equals?: InputMaybe<PaymentContractEndReason>;
    in?: InputMaybe<Array<PaymentContractEndReason>>;
    not?: InputMaybe<NestedEnumPaymentContractEndReasonNullableFilter>;
    notIn?: InputMaybe<Array<PaymentContractEndReason>>;
};

export type EnumPaymentContractEndReasonNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentContractEndReasonNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentContractEndReasonNullableFilter>;
    equals?: InputMaybe<PaymentContractEndReason>;
    in?: InputMaybe<Array<PaymentContractEndReason>>;
    not?: InputMaybe<NestedEnumPaymentContractEndReasonNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentContractEndReason>>;
};

export type EnumPaymentContractOpenedViaNullableFilter = {
    equals?: InputMaybe<PaymentContractOpenedVia>;
    in?: InputMaybe<Array<PaymentContractOpenedVia>>;
    not?: InputMaybe<NestedEnumPaymentContractOpenedViaNullableFilter>;
    notIn?: InputMaybe<Array<PaymentContractOpenedVia>>;
};

export type EnumPaymentContractOpenedViaNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentContractOpenedViaNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentContractOpenedViaNullableFilter>;
    equals?: InputMaybe<PaymentContractOpenedVia>;
    in?: InputMaybe<Array<PaymentContractOpenedVia>>;
    not?: InputMaybe<NestedEnumPaymentContractOpenedViaNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentContractOpenedVia>>;
};

export type EnumPaymentContractStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentContractStatus>;
};

export type EnumPaymentContractStatusFilter = {
    equals?: InputMaybe<PaymentContractStatus>;
    in?: InputMaybe<Array<PaymentContractStatus>>;
    not?: InputMaybe<NestedEnumPaymentContractStatusFilter>;
    notIn?: InputMaybe<Array<PaymentContractStatus>>;
};

export type EnumPaymentContractStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentContractStatusFilter>;
    _min?: InputMaybe<NestedEnumPaymentContractStatusFilter>;
    equals?: InputMaybe<PaymentContractStatus>;
    in?: InputMaybe<Array<PaymentContractStatus>>;
    not?: InputMaybe<NestedEnumPaymentContractStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentContractStatus>>;
};

export type EnumPaymentMethodTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentMethodType>;
};

export type EnumPaymentMethodTypeFilter = {
    equals?: InputMaybe<PaymentMethodType>;
    in?: InputMaybe<Array<PaymentMethodType>>;
    not?: InputMaybe<NestedEnumPaymentMethodTypeFilter>;
    notIn?: InputMaybe<Array<PaymentMethodType>>;
};

export type EnumPaymentMethodTypeNullableFilter = {
    equals?: InputMaybe<PaymentMethodType>;
    in?: InputMaybe<Array<PaymentMethodType>>;
    not?: InputMaybe<NestedEnumPaymentMethodTypeNullableFilter>;
    notIn?: InputMaybe<Array<PaymentMethodType>>;
};

export type EnumPaymentMethodTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentMethodTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentMethodTypeNullableFilter>;
    equals?: InputMaybe<PaymentMethodType>;
    in?: InputMaybe<Array<PaymentMethodType>>;
    not?: InputMaybe<NestedEnumPaymentMethodTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentMethodType>>;
};

export type EnumPaymentMethodTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentMethodTypeFilter>;
    _min?: InputMaybe<NestedEnumPaymentMethodTypeFilter>;
    equals?: InputMaybe<PaymentMethodType>;
    in?: InputMaybe<Array<PaymentMethodType>>;
    not?: InputMaybe<NestedEnumPaymentMethodTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentMethodType>>;
};

export type EnumPaymentPlanAdjustmentStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanAdjustmentStatus>;
};

export type EnumPaymentPlanAdjustmentStatusFilter = {
    equals?: InputMaybe<PaymentPlanAdjustmentStatus>;
    in?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
};

export type EnumPaymentPlanAdjustmentStatusNullableFilter = {
    equals?: InputMaybe<PaymentPlanAdjustmentStatus>;
    in?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
};

export type EnumPaymentPlanAdjustmentStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusNullableFilter>;
    equals?: InputMaybe<PaymentPlanAdjustmentStatus>;
    in?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
};

export type EnumPaymentPlanAdjustmentStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusFilter>;
    equals?: InputMaybe<PaymentPlanAdjustmentStatus>;
    in?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
};

export type EnumPaymentPlanAutoChargeStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanAutoChargeStatus>;
};

export type EnumPaymentPlanAutoChargeStatusFilter = {
    equals?: InputMaybe<PaymentPlanAutoChargeStatus>;
    in?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
};

export type EnumPaymentPlanAutoChargeStatusNullableFilter = {
    equals?: InputMaybe<PaymentPlanAutoChargeStatus>;
    in?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
};

export type EnumPaymentPlanAutoChargeStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusNullableFilter>;
    equals?: InputMaybe<PaymentPlanAutoChargeStatus>;
    in?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
};

export type EnumPaymentPlanAutoChargeStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusFilter>;
    equals?: InputMaybe<PaymentPlanAutoChargeStatus>;
    in?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
};

export type EnumPaymentPlanBoughtTreatmentClaimStageFieldUpdateOperationsInput =
    {
        set?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
    };

export type EnumPaymentPlanBoughtTreatmentClaimStageFilter = {
    equals?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
};

export type EnumPaymentPlanBoughtTreatmentClaimStageNullableFilter = {
    equals?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
};

export type EnumPaymentPlanBoughtTreatmentClaimStageNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageNullableFilter>;
        _min?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageNullableFilter>;
        equals?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
        in?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
        not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
    };

export type EnumPaymentPlanBoughtTreatmentClaimStageWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageFilter>;
    equals?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
};

export type EnumPaymentPlanBoughtTreatmentStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
};

export type EnumPaymentPlanBoughtTreatmentStatusFilter = {
    equals?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
};

export type EnumPaymentPlanBoughtTreatmentStatusNullableFilter = {
    equals?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
};

export type EnumPaymentPlanBoughtTreatmentStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusNullableFilter>;
    equals?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
};

export type EnumPaymentPlanBoughtTreatmentStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusFilter>;
    equals?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
};

export type EnumPaymentPlanChargeModeFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanChargeMode>;
};

export type EnumPaymentPlanChargeModeFilter = {
    equals?: InputMaybe<PaymentPlanChargeMode>;
    in?: InputMaybe<Array<PaymentPlanChargeMode>>;
    not?: InputMaybe<NestedEnumPaymentPlanChargeModeFilter>;
    notIn?: InputMaybe<Array<PaymentPlanChargeMode>>;
};

export type EnumPaymentPlanChargeModeNullableFilter = {
    equals?: InputMaybe<PaymentPlanChargeMode>;
    in?: InputMaybe<Array<PaymentPlanChargeMode>>;
    not?: InputMaybe<NestedEnumPaymentPlanChargeModeNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanChargeMode>>;
};

export type EnumPaymentPlanChargeModeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanChargeModeNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanChargeModeNullableFilter>;
    equals?: InputMaybe<PaymentPlanChargeMode>;
    in?: InputMaybe<Array<PaymentPlanChargeMode>>;
    not?: InputMaybe<NestedEnumPaymentPlanChargeModeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanChargeMode>>;
};

export type EnumPaymentPlanChargeModeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanChargeModeFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanChargeModeFilter>;
    equals?: InputMaybe<PaymentPlanChargeMode>;
    in?: InputMaybe<Array<PaymentPlanChargeMode>>;
    not?: InputMaybe<NestedEnumPaymentPlanChargeModeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanChargeMode>>;
};

export type EnumPaymentPlanFrequencyFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanFrequency>;
};

export type EnumPaymentPlanFrequencyFilter = {
    equals?: InputMaybe<PaymentPlanFrequency>;
    in?: InputMaybe<Array<PaymentPlanFrequency>>;
    not?: InputMaybe<NestedEnumPaymentPlanFrequencyFilter>;
    notIn?: InputMaybe<Array<PaymentPlanFrequency>>;
};

export type EnumPaymentPlanFrequencyNullableFilter = {
    equals?: InputMaybe<PaymentPlanFrequency>;
    in?: InputMaybe<Array<PaymentPlanFrequency>>;
    not?: InputMaybe<NestedEnumPaymentPlanFrequencyNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanFrequency>>;
};

export type EnumPaymentPlanFrequencyNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanFrequencyNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanFrequencyNullableFilter>;
    equals?: InputMaybe<PaymentPlanFrequency>;
    in?: InputMaybe<Array<PaymentPlanFrequency>>;
    not?: InputMaybe<NestedEnumPaymentPlanFrequencyNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanFrequency>>;
};

export type EnumPaymentPlanFrequencyWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanFrequencyFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanFrequencyFilter>;
    equals?: InputMaybe<PaymentPlanFrequency>;
    in?: InputMaybe<Array<PaymentPlanFrequency>>;
    not?: InputMaybe<NestedEnumPaymentPlanFrequencyWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanFrequency>>;
};

export type EnumPaymentPlanInitiatedByFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanInitiatedBy>;
};

export type EnumPaymentPlanInitiatedByFilter = {
    equals?: InputMaybe<PaymentPlanInitiatedBy>;
    in?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
    not?: InputMaybe<NestedEnumPaymentPlanInitiatedByFilter>;
    notIn?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
};

export type EnumPaymentPlanInitiatedByNullableFilter = {
    equals?: InputMaybe<PaymentPlanInitiatedBy>;
    in?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
    not?: InputMaybe<NestedEnumPaymentPlanInitiatedByNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
};

export type EnumPaymentPlanInitiatedByNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanInitiatedByNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanInitiatedByNullableFilter>;
    equals?: InputMaybe<PaymentPlanInitiatedBy>;
    in?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
    not?: InputMaybe<NestedEnumPaymentPlanInitiatedByNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
};

export type EnumPaymentPlanInitiatedByWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanInitiatedByFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanInitiatedByFilter>;
    equals?: InputMaybe<PaymentPlanInitiatedBy>;
    in?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
    not?: InputMaybe<NestedEnumPaymentPlanInitiatedByWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
};

export type EnumPaymentPlanStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanStatus>;
};

export type EnumPaymentPlanStatusFilter = {
    equals?: InputMaybe<PaymentPlanStatus>;
    in?: InputMaybe<Array<PaymentPlanStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanStatusFilter>;
    notIn?: InputMaybe<Array<PaymentPlanStatus>>;
};

export type EnumPaymentPlanStatusNullableFilter = {
    equals?: InputMaybe<PaymentPlanStatus>;
    in?: InputMaybe<Array<PaymentPlanStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanStatusNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanStatus>>;
};

export type EnumPaymentPlanStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanStatusNullableFilter>;
    equals?: InputMaybe<PaymentPlanStatus>;
    in?: InputMaybe<Array<PaymentPlanStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanStatus>>;
};

export type EnumPaymentPlanStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanStatusFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanStatusFilter>;
    equals?: InputMaybe<PaymentPlanStatus>;
    in?: InputMaybe<Array<PaymentPlanStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanStatus>>;
};

export type EnumPaymentPlanTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanType>;
};

export type EnumPaymentPlanTypeFilter = {
    equals?: InputMaybe<PaymentPlanType>;
    in?: InputMaybe<Array<PaymentPlanType>>;
    not?: InputMaybe<NestedEnumPaymentPlanTypeFilter>;
    notIn?: InputMaybe<Array<PaymentPlanType>>;
};

export type EnumPaymentPlanTypeNullableFilter = {
    equals?: InputMaybe<PaymentPlanType>;
    in?: InputMaybe<Array<PaymentPlanType>>;
    not?: InputMaybe<NestedEnumPaymentPlanTypeNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanType>>;
};

export type EnumPaymentPlanTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanTypeNullableFilter>;
    equals?: InputMaybe<PaymentPlanType>;
    in?: InputMaybe<Array<PaymentPlanType>>;
    not?: InputMaybe<NestedEnumPaymentPlanTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanType>>;
};

export type EnumPaymentPlanTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanTypeFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanTypeFilter>;
    equals?: InputMaybe<PaymentPlanType>;
    in?: InputMaybe<Array<PaymentPlanType>>;
    not?: InputMaybe<NestedEnumPaymentPlanTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanType>>;
};

export type EnumPaymentTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentTypeEnum>;
};

export type EnumPaymentTypeEnumFilter = {
    equals?: InputMaybe<PaymentTypeEnum>;
    in?: InputMaybe<Array<PaymentTypeEnum>>;
    not?: InputMaybe<NestedEnumPaymentTypeEnumFilter>;
    notIn?: InputMaybe<Array<PaymentTypeEnum>>;
};

export type EnumPaymentTypeEnumNullableFilter = {
    equals?: InputMaybe<PaymentTypeEnum>;
    in?: InputMaybe<Array<PaymentTypeEnum>>;
    not?: InputMaybe<NestedEnumPaymentTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<PaymentTypeEnum>>;
};

export type EnumPaymentTypeEnumNullableListFilter = {
    equals?: InputMaybe<Array<PaymentTypeEnum>>;
    has?: InputMaybe<PaymentTypeEnum>;
    hasEvery?: InputMaybe<Array<PaymentTypeEnum>>;
    hasSome?: InputMaybe<Array<PaymentTypeEnum>>;
    isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumPaymentTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentTypeEnumNullableFilter>;
    equals?: InputMaybe<PaymentTypeEnum>;
    in?: InputMaybe<Array<PaymentTypeEnum>>;
    not?: InputMaybe<NestedEnumPaymentTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentTypeEnum>>;
};

export type EnumPaymentTypeEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentTypeEnumFilter>;
    _min?: InputMaybe<NestedEnumPaymentTypeEnumFilter>;
    equals?: InputMaybe<PaymentTypeEnum>;
    in?: InputMaybe<Array<PaymentTypeEnum>>;
    not?: InputMaybe<NestedEnumPaymentTypeEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentTypeEnum>>;
};

export type EnumPaymentTypeNullableFilter = {
    equals?: InputMaybe<PaymentType>;
    in?: InputMaybe<Array<PaymentType>>;
    not?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
    notIn?: InputMaybe<Array<PaymentType>>;
};

export type EnumPaymentTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
    equals?: InputMaybe<PaymentType>;
    in?: InputMaybe<Array<PaymentType>>;
    not?: InputMaybe<NestedEnumPaymentTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentType>>;
};

export type EnumPayoutReferencePaymentTypeNullableFilter = {
    equals?: InputMaybe<PayoutReferencePaymentType>;
    in?: InputMaybe<Array<PayoutReferencePaymentType>>;
    not?: InputMaybe<NestedEnumPayoutReferencePaymentTypeNullableFilter>;
    notIn?: InputMaybe<Array<PayoutReferencePaymentType>>;
};

export type EnumPayoutReferencePaymentTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPayoutReferencePaymentTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPayoutReferencePaymentTypeNullableFilter>;
    equals?: InputMaybe<PayoutReferencePaymentType>;
    in?: InputMaybe<Array<PayoutReferencePaymentType>>;
    not?: InputMaybe<NestedEnumPayoutReferencePaymentTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PayoutReferencePaymentType>>;
};

export type EnumPendingVoidPayoutReversalProcessingStatusEnumFieldUpdateOperationsInput =
    {
        set?: InputMaybe<PendingVoidPayoutReversalProcessingStatusEnum>;
    };

export type EnumPendingVoidPayoutReversalProcessingStatusEnumFilter = {
    equals?: InputMaybe<PendingVoidPayoutReversalProcessingStatusEnum>;
    in?: InputMaybe<Array<PendingVoidPayoutReversalProcessingStatusEnum>>;
    not?: InputMaybe<NestedEnumPendingVoidPayoutReversalProcessingStatusEnumFilter>;
    notIn?: InputMaybe<Array<PendingVoidPayoutReversalProcessingStatusEnum>>;
};

export type EnumPendingVoidPayoutReversalProcessingStatusEnumWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntFilter>;
        _max?: InputMaybe<NestedEnumPendingVoidPayoutReversalProcessingStatusEnumFilter>;
        _min?: InputMaybe<NestedEnumPendingVoidPayoutReversalProcessingStatusEnumFilter>;
        equals?: InputMaybe<PendingVoidPayoutReversalProcessingStatusEnum>;
        in?: InputMaybe<Array<PendingVoidPayoutReversalProcessingStatusEnum>>;
        not?: InputMaybe<NestedEnumPendingVoidPayoutReversalProcessingStatusEnumWithAggregatesFilter>;
        notIn?: InputMaybe<
            Array<PendingVoidPayoutReversalProcessingStatusEnum>
        >;
    };

export type EnumPhoneNumberTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<PhoneNumberTypeEnum>;
};

export type EnumPhoneNumberTypeEnumFilter = {
    equals?: InputMaybe<PhoneNumberTypeEnum>;
    in?: InputMaybe<Array<PhoneNumberTypeEnum>>;
    not?: InputMaybe<NestedEnumPhoneNumberTypeEnumFilter>;
    notIn?: InputMaybe<Array<PhoneNumberTypeEnum>>;
};

export type EnumPhoneNumberTypeEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPhoneNumberTypeEnumFilter>;
    _min?: InputMaybe<NestedEnumPhoneNumberTypeEnumFilter>;
    equals?: InputMaybe<PhoneNumberTypeEnum>;
    in?: InputMaybe<Array<PhoneNumberTypeEnum>>;
    not?: InputMaybe<NestedEnumPhoneNumberTypeEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PhoneNumberTypeEnum>>;
};

export type EnumPhotoStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<PhotoStatus>;
};

export type EnumPhotoStatusFilter = {
    equals?: InputMaybe<PhotoStatus>;
    in?: InputMaybe<Array<PhotoStatus>>;
    not?: InputMaybe<NestedEnumPhotoStatusFilter>;
    notIn?: InputMaybe<Array<PhotoStatus>>;
};

export type EnumPhotoStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPhotoStatusFilter>;
    _min?: InputMaybe<NestedEnumPhotoStatusFilter>;
    equals?: InputMaybe<PhotoStatus>;
    in?: InputMaybe<Array<PhotoStatus>>;
    not?: InputMaybe<NestedEnumPhotoStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PhotoStatus>>;
};

export type EnumPhotoTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PhotoType>;
};

export type EnumPhotoTypeFilter = {
    equals?: InputMaybe<PhotoType>;
    in?: InputMaybe<Array<PhotoType>>;
    not?: InputMaybe<NestedEnumPhotoTypeFilter>;
    notIn?: InputMaybe<Array<PhotoType>>;
};

export type EnumPhotoTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPhotoTypeFilter>;
    _min?: InputMaybe<NestedEnumPhotoTypeFilter>;
    equals?: InputMaybe<PhotoType>;
    in?: InputMaybe<Array<PhotoType>>;
    not?: InputMaybe<NestedEnumPhotoTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PhotoType>>;
};

export type EnumPriceSwapReasonEnumNullableFilter = {
    equals?: InputMaybe<PriceSwapReasonEnum>;
    in?: InputMaybe<Array<PriceSwapReasonEnum>>;
    not?: InputMaybe<NestedEnumPriceSwapReasonEnumNullableFilter>;
    notIn?: InputMaybe<Array<PriceSwapReasonEnum>>;
};

export type EnumPriceSwapReasonEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPriceSwapReasonEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumPriceSwapReasonEnumNullableFilter>;
    equals?: InputMaybe<PriceSwapReasonEnum>;
    in?: InputMaybe<Array<PriceSwapReasonEnum>>;
    not?: InputMaybe<NestedEnumPriceSwapReasonEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PriceSwapReasonEnum>>;
};

export type EnumRequestSourceFieldUpdateOperationsInput = {
    set?: InputMaybe<RequestSource>;
};

export type EnumRequestSourceFilter = {
    equals?: InputMaybe<RequestSource>;
    in?: InputMaybe<Array<RequestSource>>;
    not?: InputMaybe<NestedEnumRequestSourceFilter>;
    notIn?: InputMaybe<Array<RequestSource>>;
};

export type EnumRequestSourceNullableFilter = {
    equals?: InputMaybe<RequestSource>;
    in?: InputMaybe<Array<RequestSource>>;
    not?: InputMaybe<NestedEnumRequestSourceNullableFilter>;
    notIn?: InputMaybe<Array<RequestSource>>;
};

export type EnumRequestSourceNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumRequestSourceNullableFilter>;
    _min?: InputMaybe<NestedEnumRequestSourceNullableFilter>;
    equals?: InputMaybe<RequestSource>;
    in?: InputMaybe<Array<RequestSource>>;
    not?: InputMaybe<NestedEnumRequestSourceNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<RequestSource>>;
};

export type EnumRequestSourceWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumRequestSourceFilter>;
    _min?: InputMaybe<NestedEnumRequestSourceFilter>;
    equals?: InputMaybe<RequestSource>;
    in?: InputMaybe<Array<RequestSource>>;
    not?: InputMaybe<NestedEnumRequestSourceWithAggregatesFilter>;
    notIn?: InputMaybe<Array<RequestSource>>;
};

export type EnumRequestTypeNullableFilter = {
    equals?: InputMaybe<RequestType>;
    in?: InputMaybe<Array<RequestType>>;
    not?: InputMaybe<NestedEnumRequestTypeNullableFilter>;
    notIn?: InputMaybe<Array<RequestType>>;
};

export type EnumRequestTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumRequestTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumRequestTypeNullableFilter>;
    equals?: InputMaybe<RequestType>;
    in?: InputMaybe<Array<RequestType>>;
    not?: InputMaybe<NestedEnumRequestTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<RequestType>>;
};

export type EnumRaceNullableListFilter = {
    equals?: InputMaybe<Array<Race>>;
    has?: InputMaybe<Race>;
    hasEvery?: InputMaybe<Array<Race>>;
    hasSome?: InputMaybe<Array<Race>>;
    isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumReattributionStateNullableFilter = {
    equals?: InputMaybe<ReattributionState>;
    in?: InputMaybe<Array<ReattributionState>>;
    not?: InputMaybe<NestedEnumReattributionStateNullableFilter>;
    notIn?: InputMaybe<Array<ReattributionState>>;
};

export type EnumReattributionStateNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumReattributionStateNullableFilter>;
    _min?: InputMaybe<NestedEnumReattributionStateNullableFilter>;
    equals?: InputMaybe<ReattributionState>;
    in?: InputMaybe<Array<ReattributionState>>;
    not?: InputMaybe<NestedEnumReattributionStateNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ReattributionState>>;
};

export type EnumRevenueTypeNullableFilter = {
    equals?: InputMaybe<RevenueType>;
    in?: InputMaybe<Array<RevenueType>>;
    not?: InputMaybe<NestedEnumRevenueTypeNullableFilter>;
    notIn?: InputMaybe<Array<RevenueType>>;
};

export type EnumRevenueTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumRevenueTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumRevenueTypeNullableFilter>;
    equals?: InputMaybe<RevenueType>;
    in?: InputMaybe<Array<RevenueType>>;
    not?: InputMaybe<NestedEnumRevenueTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<RevenueType>>;
};

export type EnumReviewStatusEnumNullableFilter = {
    equals?: InputMaybe<ReviewStatusEnum>;
    in?: InputMaybe<Array<ReviewStatusEnum>>;
    not?: InputMaybe<NestedEnumReviewStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<ReviewStatusEnum>>;
};

export type EnumReviewStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumReviewStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumReviewStatusEnumNullableFilter>;
    equals?: InputMaybe<ReviewStatusEnum>;
    in?: InputMaybe<Array<ReviewStatusEnum>>;
    not?: InputMaybe<NestedEnumReviewStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ReviewStatusEnum>>;
};

export type EnumSchedulingTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<SchedulingType>;
};

export type EnumSchedulingTypeFilter = {
    equals?: InputMaybe<SchedulingType>;
    in?: InputMaybe<Array<SchedulingType>>;
    not?: InputMaybe<NestedEnumSchedulingTypeFilter>;
    notIn?: InputMaybe<Array<SchedulingType>>;
};

export type EnumSchedulingTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumSchedulingTypeFilter>;
    _min?: InputMaybe<NestedEnumSchedulingTypeFilter>;
    equals?: InputMaybe<SchedulingType>;
    in?: InputMaybe<Array<SchedulingType>>;
    not?: InputMaybe<NestedEnumSchedulingTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SchedulingType>>;
};

export type EnumSelectionPriorityFieldUpdateOperationsInput = {
    set?: InputMaybe<SelectionPriority>;
};

export type EnumSelectionPriorityFilter = {
    equals?: InputMaybe<SelectionPriority>;
    in?: InputMaybe<Array<SelectionPriority>>;
    not?: InputMaybe<NestedEnumSelectionPriorityFilter>;
    notIn?: InputMaybe<Array<SelectionPriority>>;
};

export type EnumSelectionPriorityWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumSelectionPriorityFilter>;
    _min?: InputMaybe<NestedEnumSelectionPriorityFilter>;
    equals?: InputMaybe<SelectionPriority>;
    in?: InputMaybe<Array<SelectionPriority>>;
    not?: InputMaybe<NestedEnumSelectionPriorityWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SelectionPriority>>;
};

export type EnumSelectionTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<SelectionType>;
};

export type EnumSelectionTypeFilter = {
    equals?: InputMaybe<SelectionType>;
    in?: InputMaybe<Array<SelectionType>>;
    not?: InputMaybe<NestedEnumSelectionTypeFilter>;
    notIn?: InputMaybe<Array<SelectionType>>;
};

export type EnumSelectionTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumSelectionTypeFilter>;
    _min?: InputMaybe<NestedEnumSelectionTypeFilter>;
    equals?: InputMaybe<SelectionType>;
    in?: InputMaybe<Array<SelectionType>>;
    not?: InputMaybe<NestedEnumSelectionTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SelectionType>>;
};

export type EnumServiceNullableFilter = {
    equals?: InputMaybe<Service>;
    in?: InputMaybe<Array<Service>>;
    not?: InputMaybe<NestedEnumServiceNullableFilter>;
    notIn?: InputMaybe<Array<Service>>;
};

export type EnumServiceNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumServiceNullableFilter>;
    _min?: InputMaybe<NestedEnumServiceNullableFilter>;
    equals?: InputMaybe<Service>;
    in?: InputMaybe<Array<Service>>;
    not?: InputMaybe<NestedEnumServiceNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Service>>;
};

export type EnumStateFieldUpdateOperationsInput = {
    set?: InputMaybe<State>;
};

export type EnumStateFilter = {
    equals?: InputMaybe<State>;
    in?: InputMaybe<Array<State>>;
    not?: InputMaybe<NestedEnumStateFilter>;
    notIn?: InputMaybe<Array<State>>;
};

export type EnumStateNullableFilter = {
    equals?: InputMaybe<State>;
    in?: InputMaybe<Array<State>>;
    not?: InputMaybe<NestedEnumStateNullableFilter>;
    notIn?: InputMaybe<Array<State>>;
};

export type EnumStateNullableListFilter = {
    equals?: InputMaybe<Array<State>>;
    has?: InputMaybe<State>;
    hasEvery?: InputMaybe<Array<State>>;
    hasSome?: InputMaybe<Array<State>>;
    isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumStateNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumStateNullableFilter>;
    _min?: InputMaybe<NestedEnumStateNullableFilter>;
    equals?: InputMaybe<State>;
    in?: InputMaybe<Array<State>>;
    not?: InputMaybe<NestedEnumStateNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<State>>;
};

export type EnumStateWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumStateFilter>;
    _min?: InputMaybe<NestedEnumStateFilter>;
    equals?: InputMaybe<State>;
    in?: InputMaybe<Array<State>>;
    not?: InputMaybe<NestedEnumStateWithAggregatesFilter>;
    notIn?: InputMaybe<Array<State>>;
};

export type EnumSlotStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<SlotStatusEnum>;
};

export type EnumSlotStatusEnumFilter = {
    equals?: InputMaybe<SlotStatusEnum>;
    in?: InputMaybe<Array<SlotStatusEnum>>;
    not?: InputMaybe<NestedEnumSlotStatusEnumFilter>;
    notIn?: InputMaybe<Array<SlotStatusEnum>>;
};

export type EnumSlotStatusEnumNullableFilter = {
    equals?: InputMaybe<SlotStatusEnum>;
    in?: InputMaybe<Array<SlotStatusEnum>>;
    not?: InputMaybe<NestedEnumSlotStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<SlotStatusEnum>>;
};

export type EnumSlotStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumSlotStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumSlotStatusEnumNullableFilter>;
    equals?: InputMaybe<SlotStatusEnum>;
    in?: InputMaybe<Array<SlotStatusEnum>>;
    not?: InputMaybe<NestedEnumSlotStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SlotStatusEnum>>;
};

export type EnumSlotStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumSlotStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumSlotStatusEnumFilter>;
    equals?: InputMaybe<SlotStatusEnum>;
    in?: InputMaybe<Array<SlotStatusEnum>>;
    not?: InputMaybe<NestedEnumSlotStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SlotStatusEnum>>;
};

export type EnumSlotTypeEnumNullableFilter = {
    equals?: InputMaybe<SlotTypeEnum>;
    in?: InputMaybe<Array<SlotTypeEnum>>;
    not?: InputMaybe<NestedEnumSlotTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<SlotTypeEnum>>;
};

export type EnumSlotTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumSlotTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumSlotTypeEnumNullableFilter>;
    equals?: InputMaybe<SlotTypeEnum>;
    in?: InputMaybe<Array<SlotTypeEnum>>;
    not?: InputMaybe<NestedEnumSlotTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SlotTypeEnum>>;
};

export type EnumTaskVisibilityFieldUpdateOperationsInput = {
    set?: InputMaybe<TaskVisibility>;
};

export type EnumTaskVisibilityFilter = {
    equals?: InputMaybe<TaskVisibility>;
    in?: InputMaybe<Array<TaskVisibility>>;
    not?: InputMaybe<NestedEnumTaskVisibilityFilter>;
    notIn?: InputMaybe<Array<TaskVisibility>>;
};

export type EnumTaskVisibilityWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumTaskVisibilityFilter>;
    _min?: InputMaybe<NestedEnumTaskVisibilityFilter>;
    equals?: InputMaybe<TaskVisibility>;
    in?: InputMaybe<Array<TaskVisibility>>;
    not?: InputMaybe<NestedEnumTaskVisibilityWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TaskVisibility>>;
};

export type EnumTaskStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<TaskStatus>;
};

export type EnumTaskStatusFilter = {
    equals?: InputMaybe<TaskStatus>;
    in?: InputMaybe<Array<TaskStatus>>;
    not?: InputMaybe<NestedEnumTaskStatusFilter>;
    notIn?: InputMaybe<Array<TaskStatus>>;
};

export type EnumTaskStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumTaskStatusFilter>;
    _min?: InputMaybe<NestedEnumTaskStatusFilter>;
    equals?: InputMaybe<TaskStatus>;
    in?: InputMaybe<Array<TaskStatus>>;
    not?: InputMaybe<NestedEnumTaskStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TaskStatus>>;
};

export type EnumTaskTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<TaskType>;
};

export type EnumTaskTypeFilter = {
    equals?: InputMaybe<TaskType>;
    in?: InputMaybe<Array<TaskType>>;
    not?: InputMaybe<NestedEnumTaskTypeFilter>;
    notIn?: InputMaybe<Array<TaskType>>;
};

export type EnumTaskTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumTaskTypeFilter>;
    _min?: InputMaybe<NestedEnumTaskTypeFilter>;
    equals?: InputMaybe<TaskType>;
    in?: InputMaybe<Array<TaskType>>;
    not?: InputMaybe<NestedEnumTaskTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TaskType>>;
};

export type EnumTimeBlockCategoryEnumNullableFilter = {
    equals?: InputMaybe<TimeBlockCategoryEnum>;
    in?: InputMaybe<Array<TimeBlockCategoryEnum>>;
    not?: InputMaybe<NestedEnumTimeBlockCategoryEnumNullableFilter>;
    notIn?: InputMaybe<Array<TimeBlockCategoryEnum>>;
};

export type EnumTimeBlockCategoryEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumTimeBlockCategoryEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumTimeBlockCategoryEnumNullableFilter>;
    equals?: InputMaybe<TimeBlockCategoryEnum>;
    in?: InputMaybe<Array<TimeBlockCategoryEnum>>;
    not?: InputMaybe<NestedEnumTimeBlockCategoryEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TimeBlockCategoryEnum>>;
};

export type EnumTransactionStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<TransactionStatus>;
};

export type EnumTransactionStatusFilter = {
    equals?: InputMaybe<TransactionStatus>;
    in?: InputMaybe<Array<TransactionStatus>>;
    not?: InputMaybe<NestedEnumTransactionStatusFilter>;
    notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type EnumTransactionStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumTransactionStatusFilter>;
    _min?: InputMaybe<NestedEnumTransactionStatusFilter>;
    equals?: InputMaybe<TransactionStatus>;
    in?: InputMaybe<Array<TransactionStatus>>;
    not?: InputMaybe<NestedEnumTransactionStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type EnumTransactionTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<TransactionType>;
};

export type EnumTransactionTypeFilter = {
    equals?: InputMaybe<TransactionType>;
    in?: InputMaybe<Array<TransactionType>>;
    not?: InputMaybe<NestedEnumTransactionTypeFilter>;
    notIn?: InputMaybe<Array<TransactionType>>;
};

export type EnumTransactionTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumTransactionTypeFilter>;
    _min?: InputMaybe<NestedEnumTransactionTypeFilter>;
    equals?: InputMaybe<TransactionType>;
    in?: InputMaybe<Array<TransactionType>>;
    not?: InputMaybe<NestedEnumTransactionTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TransactionType>>;
};

export type EnumUserAccountStatusNullableFilter = {
    equals?: InputMaybe<UserAccountStatus>;
    in?: InputMaybe<Array<UserAccountStatus>>;
    not?: InputMaybe<NestedEnumUserAccountStatusNullableFilter>;
    notIn?: InputMaybe<Array<UserAccountStatus>>;
};

export type EnumUserAccountStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumUserAccountStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumUserAccountStatusNullableFilter>;
    equals?: InputMaybe<UserAccountStatus>;
    in?: InputMaybe<Array<UserAccountStatus>>;
    not?: InputMaybe<NestedEnumUserAccountStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<UserAccountStatus>>;
};

export type EnumVerificationSourceNullableFilter = {
    equals?: InputMaybe<VerificationSource>;
    in?: InputMaybe<Array<VerificationSource>>;
    not?: InputMaybe<NestedEnumVerificationSourceNullableFilter>;
    notIn?: InputMaybe<Array<VerificationSource>>;
};

export type EnumVerificationSourceNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumVerificationSourceNullableFilter>;
    _min?: InputMaybe<NestedEnumVerificationSourceNullableFilter>;
    equals?: InputMaybe<VerificationSource>;
    in?: InputMaybe<Array<VerificationSource>>;
    not?: InputMaybe<NestedEnumVerificationSourceNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<VerificationSource>>;
};

export type EnumVerificationStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<VerificationStatus>;
};

export type EnumVerificationStatusFilter = {
    equals?: InputMaybe<VerificationStatus>;
    in?: InputMaybe<Array<VerificationStatus>>;
    not?: InputMaybe<NestedEnumVerificationStatusFilter>;
    notIn?: InputMaybe<Array<VerificationStatus>>;
};

export type EnumVerificationStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumVerificationStatusFilter>;
    _min?: InputMaybe<NestedEnumVerificationStatusFilter>;
    equals?: InputMaybe<VerificationStatus>;
    in?: InputMaybe<Array<VerificationStatus>>;
    not?: InputMaybe<NestedEnumVerificationStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<VerificationStatus>>;
};

export type EnumVirtualDayOfReminderNullableFilter = {
    equals?: InputMaybe<VirtualDayOfReminder>;
    in?: InputMaybe<Array<VirtualDayOfReminder>>;
    not?: InputMaybe<NestedEnumVirtualDayOfReminderNullableFilter>;
    notIn?: InputMaybe<Array<VirtualDayOfReminder>>;
};

export type EnumVirtualDayOfReminderNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumVirtualDayOfReminderNullableFilter>;
    _min?: InputMaybe<NestedEnumVirtualDayOfReminderNullableFilter>;
    equals?: InputMaybe<VirtualDayOfReminder>;
    in?: InputMaybe<Array<VirtualDayOfReminder>>;
    not?: InputMaybe<NestedEnumVirtualDayOfReminderNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<VirtualDayOfReminder>>;
};

export type EnuminsurancesStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<InsurancesStatusEnum>;
};

export type EnuminsurancesStatusEnumFilter = {
    equals?: InputMaybe<InsurancesStatusEnum>;
    in?: InputMaybe<Array<InsurancesStatusEnum>>;
    not?: InputMaybe<NestedEnuminsurancesStatusEnumFilter>;
    notIn?: InputMaybe<Array<InsurancesStatusEnum>>;
};

export type EnuminsurancesStatusEnumNullableFilter = {
    equals?: InputMaybe<InsurancesStatusEnum>;
    in?: InputMaybe<Array<InsurancesStatusEnum>>;
    not?: InputMaybe<NestedEnuminsurancesStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<InsurancesStatusEnum>>;
};

export type EnuminsurancesStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnuminsurancesStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnuminsurancesStatusEnumNullableFilter>;
    equals?: InputMaybe<InsurancesStatusEnum>;
    in?: InputMaybe<Array<InsurancesStatusEnum>>;
    not?: InputMaybe<NestedEnuminsurancesStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InsurancesStatusEnum>>;
};

export type EnuminsurancesStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnuminsurancesStatusEnumFilter>;
    _min?: InputMaybe<NestedEnuminsurancesStatusEnumFilter>;
    equals?: InputMaybe<InsurancesStatusEnum>;
    in?: InputMaybe<Array<InsurancesStatusEnum>>;
    not?: InputMaybe<NestedEnuminsurancesStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InsurancesStatusEnum>>;
};

export enum Ethnicity {
    DeclineToAnswer = 'DECLINE_TO_ANSWER',
    HispanicOrLatino = 'HISPANIC_OR_LATINO',
    NotHispanicOrLatino = 'NOT_HISPANIC_OR_LATINO',
}

export type ExperityEncounter = {
    __typename?: 'ExperityEncounter';
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId: Scalars['String']['output'];
    ehrClinicId: Scalars['String']['output'];
    ehrPatientId: Scalars['String']['output'];
    ehrSlot: EhrSlot;
    ehrSlotId: Scalars['String']['output'];
    encounterId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    slotId: Scalars['String']['output'];
    status: ExperityEncounterStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ExperityEncounterAvgAggregate = {
    __typename?: 'ExperityEncounterAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type ExperityEncounterAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type ExperityEncounterCountAggregate = {
    __typename?: 'ExperityEncounterCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    ehrAppointmentId: Scalars['Int']['output'];
    ehrClinicId: Scalars['Int']['output'];
    ehrPatientId: Scalars['Int']['output'];
    ehrSlotId: Scalars['Int']['output'];
    encounterId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ExperityEncounterCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClinicId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ExperityEncounterCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId: Scalars['String']['input'];
    ehrClinicId: Scalars['String']['input'];
    ehrPatientId: Scalars['String']['input'];
    ehrSlot: EhrSlotCreateNestedOneWithoutExperityEncountersInput;
    encounterId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    slotId: Scalars['String']['input'];
    status?: InputMaybe<ExperityEncounterStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExperityEncounterCreateManyEhrSlotInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId: Scalars['String']['input'];
    ehrClinicId: Scalars['String']['input'];
    ehrPatientId: Scalars['String']['input'];
    encounterId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    slotId: Scalars['String']['input'];
    status?: InputMaybe<ExperityEncounterStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExperityEncounterCreateManyEhrSlotInputEnvelope = {
    data: Array<ExperityEncounterCreateManyEhrSlotInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperityEncounterCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId: Scalars['String']['input'];
    ehrClinicId: Scalars['String']['input'];
    ehrPatientId: Scalars['String']['input'];
    ehrSlotId: Scalars['String']['input'];
    encounterId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    slotId: Scalars['String']['input'];
    status?: InputMaybe<ExperityEncounterStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExperityEncounterCreateNestedManyWithoutEhrSlotInput = {
    connect?: InputMaybe<Array<ExperityEncounterWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ExperityEncounterCreateOrConnectWithoutEhrSlotInput>
    >;
    create?: InputMaybe<Array<ExperityEncounterCreateWithoutEhrSlotInput>>;
    createMany?: InputMaybe<ExperityEncounterCreateManyEhrSlotInputEnvelope>;
};

export type ExperityEncounterCreateOrConnectWithoutEhrSlotInput = {
    create: ExperityEncounterCreateWithoutEhrSlotInput;
    where: ExperityEncounterWhereUniqueInput;
};

export type ExperityEncounterCreateWithoutEhrSlotInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId: Scalars['String']['input'];
    ehrClinicId: Scalars['String']['input'];
    ehrPatientId: Scalars['String']['input'];
    encounterId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    slotId: Scalars['String']['input'];
    status?: InputMaybe<ExperityEncounterStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExperityEncounterGroupBy = {
    __typename?: 'ExperityEncounterGroupBy';
    _avg?: Maybe<ExperityEncounterAvgAggregate>;
    _count?: Maybe<ExperityEncounterCountAggregate>;
    _max?: Maybe<ExperityEncounterMaxAggregate>;
    _min?: Maybe<ExperityEncounterMinAggregate>;
    _sum?: Maybe<ExperityEncounterSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId: Scalars['String']['output'];
    ehrClinicId: Scalars['String']['output'];
    ehrPatientId: Scalars['String']['output'];
    ehrSlotId: Scalars['String']['output'];
    encounterId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    slotId: Scalars['String']['output'];
    status: ExperityEncounterStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ExperityEncounterListRelationFilter = {
    every?: InputMaybe<ExperityEncounterWhereInput>;
    none?: InputMaybe<ExperityEncounterWhereInput>;
    some?: InputMaybe<ExperityEncounterWhereInput>;
};

export type ExperityEncounterMaxAggregate = {
    __typename?: 'ExperityEncounterMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClinicId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ExperityEncounterStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ExperityEncounterMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClinicId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ExperityEncounterMinAggregate = {
    __typename?: 'ExperityEncounterMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    ehrClinicId?: Maybe<Scalars['String']['output']>;
    ehrPatientId?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ExperityEncounterStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ExperityEncounterMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClinicId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ExperityEncounterOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ExperityEncounterOrderByWithAggregationInput = {
    _avg?: InputMaybe<ExperityEncounterAvgOrderByAggregateInput>;
    _count?: InputMaybe<ExperityEncounterCountOrderByAggregateInput>;
    _max?: InputMaybe<ExperityEncounterMaxOrderByAggregateInput>;
    _min?: InputMaybe<ExperityEncounterMinOrderByAggregateInput>;
    _sum?: InputMaybe<ExperityEncounterSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClinicId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ExperityEncounterOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    ehrClinicId?: InputMaybe<SortOrder>;
    ehrPatientId?: InputMaybe<SortOrder>;
    ehrSlot?: InputMaybe<EhrSlotOrderByWithRelationInput>;
    ehrSlotId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum ExperityEncounterScalarFieldEnum {
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    EhrAppointmentId = 'ehrAppointmentId',
    EhrClinicId = 'ehrClinicId',
    EhrPatientId = 'ehrPatientId',
    EhrSlotId = 'ehrSlotId',
    EncounterId = 'encounterId',
    Id = 'id',
    OrgId = 'orgId',
    SlotId = 'slotId',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type ExperityEncounterScalarWhereInput = {
    AND?: InputMaybe<Array<ExperityEncounterScalarWhereInput>>;
    NOT?: InputMaybe<Array<ExperityEncounterScalarWhereInput>>;
    OR?: InputMaybe<Array<ExperityEncounterScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrAppointmentId?: InputMaybe<UuidFilter>;
    ehrClinicId?: InputMaybe<UuidFilter>;
    ehrPatientId?: InputMaybe<UuidFilter>;
    ehrSlotId?: InputMaybe<UuidFilter>;
    encounterId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<UuidFilter>;
    orgId?: InputMaybe<IntFilter>;
    slotId?: InputMaybe<UuidFilter>;
    status?: InputMaybe<EnumExperityEncounterStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ExperityEncounterScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ExperityEncounterScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ExperityEncounterScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ExperityEncounterScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    ehrAppointmentId?: InputMaybe<UuidWithAggregatesFilter>;
    ehrClinicId?: InputMaybe<UuidWithAggregatesFilter>;
    ehrPatientId?: InputMaybe<UuidWithAggregatesFilter>;
    ehrSlotId?: InputMaybe<UuidWithAggregatesFilter>;
    encounterId?: InputMaybe<UuidWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    slotId?: InputMaybe<UuidWithAggregatesFilter>;
    status?: InputMaybe<EnumExperityEncounterStatusEnumWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum ExperityEncounterStatusEnum {
    Active = 'active',
    Inactive = 'inactive',
}

export type ExperityEncounterSumAggregate = {
    __typename?: 'ExperityEncounterSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type ExperityEncounterSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type ExperityEncounterUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrClinicId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrSlot?: InputMaybe<EhrSlotUpdateOneRequiredWithoutExperityEncountersNestedInput>;
    encounterId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    slotId?: InputMaybe<StringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumExperityEncounterStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExperityEncounterUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrClinicId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    slotId?: InputMaybe<StringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumExperityEncounterStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExperityEncounterUpdateManyWithWhereWithoutEhrSlotInput = {
    data: ExperityEncounterUpdateManyMutationInput;
    where: ExperityEncounterScalarWhereInput;
};

export type ExperityEncounterUpdateManyWithoutEhrSlotNestedInput = {
    connect?: InputMaybe<Array<ExperityEncounterWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ExperityEncounterCreateOrConnectWithoutEhrSlotInput>
    >;
    create?: InputMaybe<Array<ExperityEncounterCreateWithoutEhrSlotInput>>;
    createMany?: InputMaybe<ExperityEncounterCreateManyEhrSlotInputEnvelope>;
    delete?: InputMaybe<Array<ExperityEncounterWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ExperityEncounterScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ExperityEncounterWhereUniqueInput>>;
    set?: InputMaybe<Array<ExperityEncounterWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ExperityEncounterUpdateWithWhereUniqueWithoutEhrSlotInput>
    >;
    updateMany?: InputMaybe<
        Array<ExperityEncounterUpdateManyWithWhereWithoutEhrSlotInput>
    >;
    upsert?: InputMaybe<
        Array<ExperityEncounterUpsertWithWhereUniqueWithoutEhrSlotInput>
    >;
};

export type ExperityEncounterUpdateWithWhereUniqueWithoutEhrSlotInput = {
    data: ExperityEncounterUpdateWithoutEhrSlotInput;
    where: ExperityEncounterWhereUniqueInput;
};

export type ExperityEncounterUpdateWithoutEhrSlotInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrClinicId?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrPatientId?: InputMaybe<StringFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    slotId?: InputMaybe<StringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumExperityEncounterStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExperityEncounterUpsertWithWhereUniqueWithoutEhrSlotInput = {
    create: ExperityEncounterCreateWithoutEhrSlotInput;
    update: ExperityEncounterUpdateWithoutEhrSlotInput;
    where: ExperityEncounterWhereUniqueInput;
};

export type ExperityEncounterWhereInput = {
    AND?: InputMaybe<Array<ExperityEncounterWhereInput>>;
    NOT?: InputMaybe<Array<ExperityEncounterWhereInput>>;
    OR?: InputMaybe<Array<ExperityEncounterWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrAppointmentId?: InputMaybe<UuidFilter>;
    ehrClinicId?: InputMaybe<UuidFilter>;
    ehrPatientId?: InputMaybe<UuidFilter>;
    ehrSlot?: InputMaybe<EhrSlotRelationFilter>;
    ehrSlotId?: InputMaybe<UuidFilter>;
    encounterId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<UuidFilter>;
    orgId?: InputMaybe<IntFilter>;
    slotId?: InputMaybe<UuidFilter>;
    status?: InputMaybe<EnumExperityEncounterStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ExperityEncounterWhereUniqueInput = {
    AND?: InputMaybe<Array<ExperityEncounterWhereInput>>;
    NOT?: InputMaybe<Array<ExperityEncounterWhereInput>>;
    OR?: InputMaybe<Array<ExperityEncounterWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrAppointmentId?: InputMaybe<UuidFilter>;
    ehrClinicId?: InputMaybe<UuidFilter>;
    ehrPatientId?: InputMaybe<UuidFilter>;
    ehrSlot?: InputMaybe<EhrSlotRelationFilter>;
    ehrSlotId?: InputMaybe<UuidFilter>;
    encounterId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
    slotId?: InputMaybe<UuidFilter>;
    status?: InputMaybe<EnumExperityEncounterStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FaqDropdowns = {
    __typename?: 'FaqDropdowns';
    answer: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    question: Scalars['String']['output'];
};

export type FaqDropdownsAvgAggregate = {
    __typename?: 'FaqDropdownsAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
};

export type FaqDropdownsAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
};

export type FaqDropdownsCountAggregate = {
    __typename?: 'FaqDropdownsCountAggregate';
    _all: Scalars['Int']['output'];
    answer: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    question: Scalars['Int']['output'];
};

export type FaqDropdownsCountOrderByAggregateInput = {
    answer?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    question?: InputMaybe<SortOrder>;
};

export type FaqDropdownsCreateInput = {
    answer: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    priority?: InputMaybe<Scalars['Int']['input']>;
    question: Scalars['String']['input'];
};

export type FaqDropdownsCreateManyInput = {
    answer: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    priority?: InputMaybe<Scalars['Int']['input']>;
    question: Scalars['String']['input'];
};

export type FaqDropdownsGroupBy = {
    __typename?: 'FaqDropdownsGroupBy';
    _avg?: Maybe<FaqDropdownsAvgAggregate>;
    _count?: Maybe<FaqDropdownsCountAggregate>;
    _max?: Maybe<FaqDropdownsMaxAggregate>;
    _min?: Maybe<FaqDropdownsMinAggregate>;
    _sum?: Maybe<FaqDropdownsSumAggregate>;
    answer: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    question: Scalars['String']['output'];
};

export type FaqDropdownsMaxAggregate = {
    __typename?: 'FaqDropdownsMaxAggregate';
    answer?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    question?: Maybe<Scalars['String']['output']>;
};

export type FaqDropdownsMaxOrderByAggregateInput = {
    answer?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    question?: InputMaybe<SortOrder>;
};

export type FaqDropdownsMinAggregate = {
    __typename?: 'FaqDropdownsMinAggregate';
    answer?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    question?: Maybe<Scalars['String']['output']>;
};

export type FaqDropdownsMinOrderByAggregateInput = {
    answer?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    question?: InputMaybe<SortOrder>;
};

export type FaqDropdownsOrderByWithAggregationInput = {
    _avg?: InputMaybe<FaqDropdownsAvgOrderByAggregateInput>;
    _count?: InputMaybe<FaqDropdownsCountOrderByAggregateInput>;
    _max?: InputMaybe<FaqDropdownsMaxOrderByAggregateInput>;
    _min?: InputMaybe<FaqDropdownsMinOrderByAggregateInput>;
    _sum?: InputMaybe<FaqDropdownsSumOrderByAggregateInput>;
    answer?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    question?: InputMaybe<SortOrder>;
};

export type FaqDropdownsOrderByWithRelationInput = {
    answer?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    question?: InputMaybe<SortOrder>;
};

export enum FaqDropdownsScalarFieldEnum {
    Answer = 'answer',
    Id = 'id',
    OrgId = 'orgId',
    Priority = 'priority',
    Question = 'question',
}

export type FaqDropdownsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<FaqDropdownsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<FaqDropdownsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<FaqDropdownsScalarWhereWithAggregatesInput>>;
    answer?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    priority?: InputMaybe<IntWithAggregatesFilter>;
    question?: InputMaybe<StringWithAggregatesFilter>;
};

export type FaqDropdownsSumAggregate = {
    __typename?: 'FaqDropdownsSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
};

export type FaqDropdownsSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
};

export type FaqDropdownsUpdateInput = {
    answer?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    question?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FaqDropdownsUpdateManyMutationInput = {
    answer?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    question?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FaqDropdownsWhereInput = {
    AND?: InputMaybe<Array<FaqDropdownsWhereInput>>;
    NOT?: InputMaybe<Array<FaqDropdownsWhereInput>>;
    OR?: InputMaybe<Array<FaqDropdownsWhereInput>>;
    answer?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    orgId?: InputMaybe<IntFilter>;
    priority?: InputMaybe<IntFilter>;
    question?: InputMaybe<StringFilter>;
};

export type FaqDropdownsWhereUniqueInput = {
    AND?: InputMaybe<Array<FaqDropdownsWhereInput>>;
    NOT?: InputMaybe<Array<FaqDropdownsWhereInput>>;
    OR?: InputMaybe<Array<FaqDropdownsWhereInput>>;
    answer?: InputMaybe<StringFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    orgId?: InputMaybe<IntFilter>;
    priority?: InputMaybe<IntFilter>;
    question?: InputMaybe<StringFilter>;
};

export type FeeConfig = {
    __typename?: 'FeeConfig';
    SuperscriptFeeLineItem: Array<SuperscriptFeeLineItem>;
    _count?: Maybe<FeeConfigCount>;
    amount?: Maybe<Scalars['Decimal']['output']>;
    amountType?: Maybe<AmountType>;
    associatedHrtIds: Array<Scalars['Int']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    description?: Maybe<Scalars['String']['output']>;
    excludedHrtIds: Array<Scalars['Int']['output']>;
    feeType: FeeType;
    id: Scalars['String']['output'];
    isActive: Scalars['Boolean']['output'];
    isArrears: Scalars['Boolean']['output'];
    isWaived: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentType?: Maybe<PaymentType>;
    revenueType?: Maybe<RevenueType>;
    unit?: Maybe<FeeUnit>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type FeeConfigSuperscriptFeeLineItemArgs = {
    cursor?: InputMaybe<SuperscriptFeeLineItemWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptFeeLineItemScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SuperscriptFeeLineItemOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type FeeConfigAuditLog = {
    __typename?: 'FeeConfigAuditLog';
    amount?: Maybe<Scalars['Decimal']['output']>;
    amountType?: Maybe<AmountType>;
    associatedHrtIds: Array<Scalars['Int']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    description?: Maybe<Scalars['String']['output']>;
    excludedHrtIds: Array<Scalars['Int']['output']>;
    feeConfigId: Scalars['String']['output'];
    feeType: FeeType;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    isArrears: Scalars['Boolean']['output'];
    isWaived: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    paymentType?: Maybe<PaymentType>;
    revenueType?: Maybe<RevenueType>;
    unit?: Maybe<FeeUnit>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type FeeConfigAuditLogAvgAggregate = {
    __typename?: 'FeeConfigAuditLogAvgAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    associatedHrtIds?: Maybe<Scalars['Float']['output']>;
    excludedHrtIds?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type FeeConfigAuditLogAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    excludedHrtIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type FeeConfigAuditLogCountAggregate = {
    __typename?: 'FeeConfigAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    amountType: Scalars['Int']['output'];
    associatedHrtIds: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    excludedHrtIds: Scalars['Int']['output'];
    feeConfigId: Scalars['Int']['output'];
    feeType: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    isArrears: Scalars['Int']['output'];
    isWaived: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentType: Scalars['Int']['output'];
    revenueType: Scalars['Int']['output'];
    unit: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type FeeConfigAuditLogCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    amountType?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    excludedHrtIds?: InputMaybe<SortOrder>;
    feeConfigId?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    revenueType?: InputMaybe<SortOrder>;
    unit?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FeeConfigAuditLogCreateInput = {
    amount?: InputMaybe<Scalars['Decimal']['input']>;
    amountType?: InputMaybe<AmountType>;
    associatedHrtIds?: InputMaybe<FeeConfigAuditLogCreateassociatedHrtIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    excludedHrtIds?: InputMaybe<FeeConfigAuditLogCreateexcludedHrtIdsInput>;
    feeConfigId: Scalars['String']['input'];
    feeType: FeeType;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    paymentType?: InputMaybe<PaymentType>;
    revenueType?: InputMaybe<RevenueType>;
    unit?: InputMaybe<FeeUnit>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FeeConfigAuditLogCreateManyInput = {
    amount?: InputMaybe<Scalars['Decimal']['input']>;
    amountType?: InputMaybe<AmountType>;
    associatedHrtIds?: InputMaybe<FeeConfigAuditLogCreateassociatedHrtIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    excludedHrtIds?: InputMaybe<FeeConfigAuditLogCreateexcludedHrtIdsInput>;
    feeConfigId: Scalars['String']['input'];
    feeType: FeeType;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    paymentType?: InputMaybe<PaymentType>;
    revenueType?: InputMaybe<RevenueType>;
    unit?: InputMaybe<FeeUnit>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FeeConfigAuditLogCreateassociatedHrtIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type FeeConfigAuditLogCreateexcludedHrtIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type FeeConfigAuditLogGroupBy = {
    __typename?: 'FeeConfigAuditLogGroupBy';
    _avg?: Maybe<FeeConfigAuditLogAvgAggregate>;
    _count?: Maybe<FeeConfigAuditLogCountAggregate>;
    _max?: Maybe<FeeConfigAuditLogMaxAggregate>;
    _min?: Maybe<FeeConfigAuditLogMinAggregate>;
    _sum?: Maybe<FeeConfigAuditLogSumAggregate>;
    amount?: Maybe<Scalars['Decimal']['output']>;
    amountType?: Maybe<AmountType>;
    associatedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    description?: Maybe<Scalars['String']['output']>;
    excludedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    feeConfigId: Scalars['String']['output'];
    feeType: FeeType;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    isArrears: Scalars['Boolean']['output'];
    isWaived: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    paymentType?: Maybe<PaymentType>;
    revenueType?: Maybe<RevenueType>;
    unit?: Maybe<FeeUnit>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type FeeConfigAuditLogMaxAggregate = {
    __typename?: 'FeeConfigAuditLogMaxAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    amountType?: Maybe<AmountType>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    feeConfigId?: Maybe<Scalars['String']['output']>;
    feeType?: Maybe<FeeType>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    isArrears?: Maybe<Scalars['Boolean']['output']>;
    isWaived?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentType?: Maybe<PaymentType>;
    revenueType?: Maybe<RevenueType>;
    unit?: Maybe<FeeUnit>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type FeeConfigAuditLogMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    amountType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    feeConfigId?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    revenueType?: InputMaybe<SortOrder>;
    unit?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FeeConfigAuditLogMinAggregate = {
    __typename?: 'FeeConfigAuditLogMinAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    amountType?: Maybe<AmountType>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    feeConfigId?: Maybe<Scalars['String']['output']>;
    feeType?: Maybe<FeeType>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    isArrears?: Maybe<Scalars['Boolean']['output']>;
    isWaived?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentType?: Maybe<PaymentType>;
    revenueType?: Maybe<RevenueType>;
    unit?: Maybe<FeeUnit>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type FeeConfigAuditLogMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    amountType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    feeConfigId?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    revenueType?: InputMaybe<SortOrder>;
    unit?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FeeConfigAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<FeeConfigAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<FeeConfigAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<FeeConfigAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<FeeConfigAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<FeeConfigAuditLogSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrderInput>;
    amountType?: InputMaybe<SortOrderInput>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrderInput>;
    excludedHrtIds?: InputMaybe<SortOrder>;
    feeConfigId?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrderInput>;
    revenueType?: InputMaybe<SortOrderInput>;
    unit?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FeeConfigAuditLogOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrderInput>;
    amountType?: InputMaybe<SortOrderInput>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrderInput>;
    excludedHrtIds?: InputMaybe<SortOrder>;
    feeConfigId?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrderInput>;
    revenueType?: InputMaybe<SortOrderInput>;
    unit?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum FeeConfigAuditLogScalarFieldEnum {
    Amount = 'amount',
    AmountType = 'amountType',
    AssociatedHrtIds = 'associatedHrtIds',
    CreatedAt = 'createdAt',
    Description = 'description',
    ExcludedHrtIds = 'excludedHrtIds',
    FeeConfigId = 'feeConfigId',
    FeeType = 'feeType',
    Id = 'id',
    IsActive = 'isActive',
    IsArrears = 'isArrears',
    IsWaived = 'isWaived',
    LastUpdatedBy = 'lastUpdatedBy',
    Notes = 'notes',
    Operation = 'operation',
    OrgId = 'orgId',
    PaymentType = 'paymentType',
    RevenueType = 'revenueType',
    Unit = 'unit',
    UpdatedAt = 'updatedAt',
}

export type FeeConfigAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<FeeConfigAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<FeeConfigAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<FeeConfigAuditLogScalarWhereWithAggregatesInput>>;
    amount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    amountType?: InputMaybe<EnumAmountTypeNullableWithAggregatesFilter>;
    associatedHrtIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    description?: InputMaybe<StringNullableWithAggregatesFilter>;
    excludedHrtIds?: InputMaybe<IntNullableListFilter>;
    feeConfigId?: InputMaybe<StringWithAggregatesFilter>;
    feeType?: InputMaybe<EnumFeeTypeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    isArrears?: InputMaybe<BoolWithAggregatesFilter>;
    isWaived?: InputMaybe<BoolWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeNullableWithAggregatesFilter>;
    revenueType?: InputMaybe<EnumRevenueTypeNullableWithAggregatesFilter>;
    unit?: InputMaybe<EnumFeeUnitNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type FeeConfigAuditLogSumAggregate = {
    __typename?: 'FeeConfigAuditLogSumAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    associatedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    excludedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type FeeConfigAuditLogSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    excludedHrtIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type FeeConfigAuditLogUpdateInput = {
    amount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    amountType?: InputMaybe<NullableEnumAmountTypeFieldUpdateOperationsInput>;
    associatedHrtIds?: InputMaybe<FeeConfigAuditLogUpdateassociatedHrtIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    excludedHrtIds?: InputMaybe<FeeConfigAuditLogUpdateexcludedHrtIdsInput>;
    feeConfigId?: InputMaybe<StringFieldUpdateOperationsInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isArrears?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isWaived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
    revenueType?: InputMaybe<NullableEnumRevenueTypeFieldUpdateOperationsInput>;
    unit?: InputMaybe<NullableEnumFeeUnitFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FeeConfigAuditLogUpdateManyMutationInput = {
    amount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    amountType?: InputMaybe<NullableEnumAmountTypeFieldUpdateOperationsInput>;
    associatedHrtIds?: InputMaybe<FeeConfigAuditLogUpdateassociatedHrtIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    excludedHrtIds?: InputMaybe<FeeConfigAuditLogUpdateexcludedHrtIdsInput>;
    feeConfigId?: InputMaybe<StringFieldUpdateOperationsInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isArrears?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isWaived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
    revenueType?: InputMaybe<NullableEnumRevenueTypeFieldUpdateOperationsInput>;
    unit?: InputMaybe<NullableEnumFeeUnitFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FeeConfigAuditLogUpdateassociatedHrtIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FeeConfigAuditLogUpdateexcludedHrtIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FeeConfigAuditLogWhereInput = {
    AND?: InputMaybe<Array<FeeConfigAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<FeeConfigAuditLogWhereInput>>;
    OR?: InputMaybe<Array<FeeConfigAuditLogWhereInput>>;
    amount?: InputMaybe<DecimalNullableFilter>;
    amountType?: InputMaybe<EnumAmountTypeNullableFilter>;
    associatedHrtIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    description?: InputMaybe<StringNullableFilter>;
    excludedHrtIds?: InputMaybe<IntNullableListFilter>;
    feeConfigId?: InputMaybe<StringFilter>;
    feeType?: InputMaybe<EnumFeeTypeFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    isArrears?: InputMaybe<BoolFilter>;
    isWaived?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeNullableFilter>;
    revenueType?: InputMaybe<EnumRevenueTypeNullableFilter>;
    unit?: InputMaybe<EnumFeeUnitNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FeeConfigAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<FeeConfigAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<FeeConfigAuditLogWhereInput>>;
    OR?: InputMaybe<Array<FeeConfigAuditLogWhereInput>>;
    amount?: InputMaybe<DecimalNullableFilter>;
    amountType?: InputMaybe<EnumAmountTypeNullableFilter>;
    associatedHrtIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    description?: InputMaybe<StringNullableFilter>;
    excludedHrtIds?: InputMaybe<IntNullableListFilter>;
    feeConfigId?: InputMaybe<StringFilter>;
    feeType?: InputMaybe<EnumFeeTypeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<BoolFilter>;
    isArrears?: InputMaybe<BoolFilter>;
    isWaived?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeNullableFilter>;
    revenueType?: InputMaybe<EnumRevenueTypeNullableFilter>;
    unit?: InputMaybe<EnumFeeUnitNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FeeConfigAvgAggregate = {
    __typename?: 'FeeConfigAvgAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    associatedHrtIds?: Maybe<Scalars['Float']['output']>;
    excludedHrtIds?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type FeeConfigAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    excludedHrtIds?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type FeeConfigCount = {
    __typename?: 'FeeConfigCount';
    SuperscriptFeeLineItem: Scalars['Int']['output'];
};

export type FeeConfigCountSuperscriptFeeLineItemArgs = {
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type FeeConfigCountAggregate = {
    __typename?: 'FeeConfigCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    amountType: Scalars['Int']['output'];
    associatedHrtIds: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    excludedHrtIds: Scalars['Int']['output'];
    feeType: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    isArrears: Scalars['Int']['output'];
    isWaived: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentType: Scalars['Int']['output'];
    revenueType: Scalars['Int']['output'];
    unit: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type FeeConfigCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    amountType?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    excludedHrtIds?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    revenueType?: InputMaybe<SortOrder>;
    unit?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FeeConfigCreateInput = {
    SuperscriptFeeLineItem?: InputMaybe<SuperscriptFeeLineItemCreateNestedManyWithoutFeeConfigInput>;
    amount?: InputMaybe<Scalars['Decimal']['input']>;
    amountType?: InputMaybe<AmountType>;
    associatedHrtIds?: InputMaybe<FeeConfigCreateassociatedHrtIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    excludedHrtIds?: InputMaybe<FeeConfigCreateexcludedHrtIdsInput>;
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentType?: InputMaybe<PaymentType>;
    revenueType?: InputMaybe<RevenueType>;
    unit?: InputMaybe<FeeUnit>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FeeConfigCreateManyInput = {
    amount?: InputMaybe<Scalars['Decimal']['input']>;
    amountType?: InputMaybe<AmountType>;
    associatedHrtIds?: InputMaybe<FeeConfigCreateassociatedHrtIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    excludedHrtIds?: InputMaybe<FeeConfigCreateexcludedHrtIdsInput>;
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentType?: InputMaybe<PaymentType>;
    revenueType?: InputMaybe<RevenueType>;
    unit?: InputMaybe<FeeUnit>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FeeConfigCreateNestedOneWithoutSuperscriptFeeLineItemInput = {
    connect?: InputMaybe<FeeConfigWhereUniqueInput>;
    connectOrCreate?: InputMaybe<FeeConfigCreateOrConnectWithoutSuperscriptFeeLineItemInput>;
    create?: InputMaybe<FeeConfigCreateWithoutSuperscriptFeeLineItemInput>;
};

export type FeeConfigCreateOrConnectWithoutSuperscriptFeeLineItemInput = {
    create: FeeConfigCreateWithoutSuperscriptFeeLineItemInput;
    where: FeeConfigWhereUniqueInput;
};

export type FeeConfigCreateWithoutSuperscriptFeeLineItemInput = {
    amount?: InputMaybe<Scalars['Decimal']['input']>;
    amountType?: InputMaybe<AmountType>;
    associatedHrtIds?: InputMaybe<FeeConfigCreateassociatedHrtIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    excludedHrtIds?: InputMaybe<FeeConfigCreateexcludedHrtIdsInput>;
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentType?: InputMaybe<PaymentType>;
    revenueType?: InputMaybe<RevenueType>;
    unit?: InputMaybe<FeeUnit>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FeeConfigCreateassociatedHrtIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type FeeConfigCreateexcludedHrtIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type FeeConfigGroupBy = {
    __typename?: 'FeeConfigGroupBy';
    _avg?: Maybe<FeeConfigAvgAggregate>;
    _count?: Maybe<FeeConfigCountAggregate>;
    _max?: Maybe<FeeConfigMaxAggregate>;
    _min?: Maybe<FeeConfigMinAggregate>;
    _sum?: Maybe<FeeConfigSumAggregate>;
    amount?: Maybe<Scalars['Decimal']['output']>;
    amountType?: Maybe<AmountType>;
    associatedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    description?: Maybe<Scalars['String']['output']>;
    excludedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    feeType: FeeType;
    id: Scalars['String']['output'];
    isActive: Scalars['Boolean']['output'];
    isArrears: Scalars['Boolean']['output'];
    isWaived: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentType?: Maybe<PaymentType>;
    revenueType?: Maybe<RevenueType>;
    unit?: Maybe<FeeUnit>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type FeeConfigMaxAggregate = {
    __typename?: 'FeeConfigMaxAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    amountType?: Maybe<AmountType>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    feeType?: Maybe<FeeType>;
    id?: Maybe<Scalars['String']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    isArrears?: Maybe<Scalars['Boolean']['output']>;
    isWaived?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentType?: Maybe<PaymentType>;
    revenueType?: Maybe<RevenueType>;
    unit?: Maybe<FeeUnit>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type FeeConfigMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    amountType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    revenueType?: InputMaybe<SortOrder>;
    unit?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FeeConfigMinAggregate = {
    __typename?: 'FeeConfigMinAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    amountType?: Maybe<AmountType>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    feeType?: Maybe<FeeType>;
    id?: Maybe<Scalars['String']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    isArrears?: Maybe<Scalars['Boolean']['output']>;
    isWaived?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentType?: Maybe<PaymentType>;
    revenueType?: Maybe<RevenueType>;
    unit?: Maybe<FeeUnit>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type FeeConfigMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    amountType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    revenueType?: InputMaybe<SortOrder>;
    unit?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FeeConfigOrderByWithAggregationInput = {
    _avg?: InputMaybe<FeeConfigAvgOrderByAggregateInput>;
    _count?: InputMaybe<FeeConfigCountOrderByAggregateInput>;
    _max?: InputMaybe<FeeConfigMaxOrderByAggregateInput>;
    _min?: InputMaybe<FeeConfigMinOrderByAggregateInput>;
    _sum?: InputMaybe<FeeConfigSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrderInput>;
    amountType?: InputMaybe<SortOrderInput>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrderInput>;
    excludedHrtIds?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrderInput>;
    revenueType?: InputMaybe<SortOrderInput>;
    unit?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FeeConfigOrderByWithRelationInput = {
    SuperscriptFeeLineItem?: InputMaybe<SuperscriptFeeLineItemOrderByRelationAggregateInput>;
    amount?: InputMaybe<SortOrderInput>;
    amountType?: InputMaybe<SortOrderInput>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrderInput>;
    excludedHrtIds?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrderInput>;
    revenueType?: InputMaybe<SortOrderInput>;
    unit?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type FeeConfigRelationFilter = {
    is?: InputMaybe<FeeConfigWhereInput>;
    isNot?: InputMaybe<FeeConfigWhereInput>;
};

export enum FeeConfigScalarFieldEnum {
    Amount = 'amount',
    AmountType = 'amountType',
    AssociatedHrtIds = 'associatedHrtIds',
    CreatedAt = 'createdAt',
    Description = 'description',
    ExcludedHrtIds = 'excludedHrtIds',
    FeeType = 'feeType',
    Id = 'id',
    IsActive = 'isActive',
    IsArrears = 'isArrears',
    IsWaived = 'isWaived',
    LastUpdatedBy = 'lastUpdatedBy',
    Notes = 'notes',
    OrgId = 'orgId',
    PaymentType = 'paymentType',
    RevenueType = 'revenueType',
    Unit = 'unit',
    UpdatedAt = 'updatedAt',
}

export type FeeConfigScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<FeeConfigScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<FeeConfigScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<FeeConfigScalarWhereWithAggregatesInput>>;
    amount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    amountType?: InputMaybe<EnumAmountTypeNullableWithAggregatesFilter>;
    associatedHrtIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    description?: InputMaybe<StringNullableWithAggregatesFilter>;
    excludedHrtIds?: InputMaybe<IntNullableListFilter>;
    feeType?: InputMaybe<EnumFeeTypeWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    isArrears?: InputMaybe<BoolWithAggregatesFilter>;
    isWaived?: InputMaybe<BoolWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeNullableWithAggregatesFilter>;
    revenueType?: InputMaybe<EnumRevenueTypeNullableWithAggregatesFilter>;
    unit?: InputMaybe<EnumFeeUnitNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type FeeConfigSumAggregate = {
    __typename?: 'FeeConfigSumAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    associatedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    excludedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type FeeConfigSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    excludedHrtIds?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type FeeConfigUpdateInput = {
    SuperscriptFeeLineItem?: InputMaybe<SuperscriptFeeLineItemUpdateManyWithoutFeeConfigNestedInput>;
    amount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    amountType?: InputMaybe<NullableEnumAmountTypeFieldUpdateOperationsInput>;
    associatedHrtIds?: InputMaybe<FeeConfigUpdateassociatedHrtIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    excludedHrtIds?: InputMaybe<FeeConfigUpdateexcludedHrtIdsInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isArrears?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isWaived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
    revenueType?: InputMaybe<NullableEnumRevenueTypeFieldUpdateOperationsInput>;
    unit?: InputMaybe<NullableEnumFeeUnitFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FeeConfigUpdateManyMutationInput = {
    amount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    amountType?: InputMaybe<NullableEnumAmountTypeFieldUpdateOperationsInput>;
    associatedHrtIds?: InputMaybe<FeeConfigUpdateassociatedHrtIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    excludedHrtIds?: InputMaybe<FeeConfigUpdateexcludedHrtIdsInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isArrears?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isWaived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
    revenueType?: InputMaybe<NullableEnumRevenueTypeFieldUpdateOperationsInput>;
    unit?: InputMaybe<NullableEnumFeeUnitFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FeeConfigUpdateOneRequiredWithoutSuperscriptFeeLineItemNestedInput =
    {
        connect?: InputMaybe<FeeConfigWhereUniqueInput>;
        connectOrCreate?: InputMaybe<FeeConfigCreateOrConnectWithoutSuperscriptFeeLineItemInput>;
        create?: InputMaybe<FeeConfigCreateWithoutSuperscriptFeeLineItemInput>;
        update?: InputMaybe<FeeConfigUpdateToOneWithWhereWithoutSuperscriptFeeLineItemInput>;
        upsert?: InputMaybe<FeeConfigUpsertWithoutSuperscriptFeeLineItemInput>;
    };

export type FeeConfigUpdateToOneWithWhereWithoutSuperscriptFeeLineItemInput = {
    data: FeeConfigUpdateWithoutSuperscriptFeeLineItemInput;
    where?: InputMaybe<FeeConfigWhereInput>;
};

export type FeeConfigUpdateWithoutSuperscriptFeeLineItemInput = {
    amount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    amountType?: InputMaybe<NullableEnumAmountTypeFieldUpdateOperationsInput>;
    associatedHrtIds?: InputMaybe<FeeConfigUpdateassociatedHrtIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    excludedHrtIds?: InputMaybe<FeeConfigUpdateexcludedHrtIdsInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isArrears?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isWaived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentType?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
    revenueType?: InputMaybe<NullableEnumRevenueTypeFieldUpdateOperationsInput>;
    unit?: InputMaybe<NullableEnumFeeUnitFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FeeConfigUpdateassociatedHrtIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FeeConfigUpdateexcludedHrtIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FeeConfigUpsertWithoutSuperscriptFeeLineItemInput = {
    create: FeeConfigCreateWithoutSuperscriptFeeLineItemInput;
    update: FeeConfigUpdateWithoutSuperscriptFeeLineItemInput;
    where?: InputMaybe<FeeConfigWhereInput>;
};

export type FeeConfigWhereInput = {
    AND?: InputMaybe<Array<FeeConfigWhereInput>>;
    NOT?: InputMaybe<Array<FeeConfigWhereInput>>;
    OR?: InputMaybe<Array<FeeConfigWhereInput>>;
    SuperscriptFeeLineItem?: InputMaybe<SuperscriptFeeLineItemListRelationFilter>;
    amount?: InputMaybe<DecimalNullableFilter>;
    amountType?: InputMaybe<EnumAmountTypeNullableFilter>;
    associatedHrtIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    description?: InputMaybe<StringNullableFilter>;
    excludedHrtIds?: InputMaybe<IntNullableListFilter>;
    feeType?: InputMaybe<EnumFeeTypeFilter>;
    id?: InputMaybe<StringFilter>;
    isActive?: InputMaybe<BoolFilter>;
    isArrears?: InputMaybe<BoolFilter>;
    isWaived?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeNullableFilter>;
    revenueType?: InputMaybe<EnumRevenueTypeNullableFilter>;
    unit?: InputMaybe<EnumFeeUnitNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FeeConfigWhereUniqueInput = {
    AND?: InputMaybe<Array<FeeConfigWhereInput>>;
    NOT?: InputMaybe<Array<FeeConfigWhereInput>>;
    OR?: InputMaybe<Array<FeeConfigWhereInput>>;
    SuperscriptFeeLineItem?: InputMaybe<SuperscriptFeeLineItemListRelationFilter>;
    amount?: InputMaybe<DecimalNullableFilter>;
    amountType?: InputMaybe<EnumAmountTypeNullableFilter>;
    associatedHrtIds?: InputMaybe<IntNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    description?: InputMaybe<StringNullableFilter>;
    excludedHrtIds?: InputMaybe<IntNullableListFilter>;
    feeType?: InputMaybe<EnumFeeTypeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    isActive?: InputMaybe<BoolFilter>;
    isArrears?: InputMaybe<BoolFilter>;
    isWaived?: InputMaybe<BoolFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeNullableFilter>;
    revenueType?: InputMaybe<EnumRevenueTypeNullableFilter>;
    unit?: InputMaybe<EnumFeeUnitNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum FeeType {
    ExistingPatient = 'EXISTING_PATIENT',
    FixedSlot = 'FIXED_SLOT',
    FixedSlotInsured = 'FIXED_SLOT_INSURED',
    FixedTransaction = 'FIXED_TRANSACTION',
    MinimumCash = 'MINIMUM_CASH',
    MinimumInsured = 'MINIMUM_INSURED',
    NewPatient = 'NEW_PATIENT',
    StripeFee = 'STRIPE_FEE',
    Subscription = 'SUBSCRIPTION',
    TransactionTakeInsured = 'TRANSACTION_TAKE_INSURED',
    TransactionTakeSelfpay = 'TRANSACTION_TAKE_SELFPAY',
    WaivedFeesOnCopayUsed = 'WAIVED_FEES_ON_COPAY_USED',
}

export enum FeeUnit {
    Appointment = 'APPOINTMENT',
    Day = 'DAY',
    Month = 'MONTH',
    Patient = 'PATIENT',
    Slot = 'SLOT',
    Transaction = 'TRANSACTION',
    Year = 'YEAR',
}

export enum FeesAndPayoutsProcessingStatusEnum {
    Cancelled = 'CANCELLED',
    Completed = 'COMPLETED',
    Failed = 'FAILED',
    Pending = 'PENDING',
    Skipped = 'SKIPPED',
}

export type FloatFieldUpdateOperationsInput = {
    decrement?: InputMaybe<Scalars['Float']['input']>;
    divide?: InputMaybe<Scalars['Float']['input']>;
    increment?: InputMaybe<Scalars['Float']['input']>;
    multiply?: InputMaybe<Scalars['Float']['input']>;
    set?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatFilter = {
    equals?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    gte?: InputMaybe<Scalars['Float']['input']>;
    in?: InputMaybe<Array<Scalars['Float']['input']>>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    lte?: InputMaybe<Scalars['Float']['input']>;
    not?: InputMaybe<NestedFloatFilter>;
    notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableFilter = {
    equals?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    gte?: InputMaybe<Scalars['Float']['input']>;
    in?: InputMaybe<Array<Scalars['Float']['input']>>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    lte?: InputMaybe<Scalars['Float']['input']>;
    not?: InputMaybe<NestedFloatNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableWithAggregatesFilter = {
    _avg?: InputMaybe<NestedFloatNullableFilter>;
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedFloatNullableFilter>;
    _min?: InputMaybe<NestedFloatNullableFilter>;
    _sum?: InputMaybe<NestedFloatNullableFilter>;
    equals?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    gte?: InputMaybe<Scalars['Float']['input']>;
    in?: InputMaybe<Array<Scalars['Float']['input']>>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    lte?: InputMaybe<Scalars['Float']['input']>;
    not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatWithAggregatesFilter = {
    _avg?: InputMaybe<NestedFloatFilter>;
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedFloatFilter>;
    _min?: InputMaybe<NestedFloatFilter>;
    _sum?: InputMaybe<NestedFloatFilter>;
    equals?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    gte?: InputMaybe<Scalars['Float']['input']>;
    in?: InputMaybe<Array<Scalars['Float']['input']>>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    lte?: InputMaybe<Scalars['Float']['input']>;
    not?: InputMaybe<NestedFloatWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GuarantorPaymentLinkContext = {
    __typename?: 'GuarantorPaymentLinkContext';
    appointmentId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    guarantorName: Scalars['String']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    patientName: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type GuarantorPaymentLinkContextAvgAggregate = {
    __typename?: 'GuarantorPaymentLinkContextAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type GuarantorPaymentLinkContextAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type GuarantorPaymentLinkContextCountAggregate = {
    __typename?: 'GuarantorPaymentLinkContextCountAggregate';
    _all: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    guarantorName: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    patientName: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type GuarantorPaymentLinkContextCountOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    guarantorName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type GuarantorPaymentLinkContextCreateInput = {
    appointmentId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    guarantorName: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    patientName: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type GuarantorPaymentLinkContextCreateManyInput = {
    appointmentId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    guarantorName: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    patientName: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type GuarantorPaymentLinkContextGroupBy = {
    __typename?: 'GuarantorPaymentLinkContextGroupBy';
    _avg?: Maybe<GuarantorPaymentLinkContextAvgAggregate>;
    _count?: Maybe<GuarantorPaymentLinkContextCountAggregate>;
    _max?: Maybe<GuarantorPaymentLinkContextMaxAggregate>;
    _min?: Maybe<GuarantorPaymentLinkContextMinAggregate>;
    _sum?: Maybe<GuarantorPaymentLinkContextSumAggregate>;
    appointmentId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    guarantorName: Scalars['String']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    patientName: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type GuarantorPaymentLinkContextMaxAggregate = {
    __typename?: 'GuarantorPaymentLinkContextMaxAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    guarantorName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientName?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type GuarantorPaymentLinkContextMaxOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    guarantorName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type GuarantorPaymentLinkContextMinAggregate = {
    __typename?: 'GuarantorPaymentLinkContextMinAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    guarantorName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    patientName?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type GuarantorPaymentLinkContextMinOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    guarantorName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type GuarantorPaymentLinkContextOrderByWithAggregationInput = {
    _avg?: InputMaybe<GuarantorPaymentLinkContextAvgOrderByAggregateInput>;
    _count?: InputMaybe<GuarantorPaymentLinkContextCountOrderByAggregateInput>;
    _max?: InputMaybe<GuarantorPaymentLinkContextMaxOrderByAggregateInput>;
    _min?: InputMaybe<GuarantorPaymentLinkContextMinOrderByAggregateInput>;
    _sum?: InputMaybe<GuarantorPaymentLinkContextSumOrderByAggregateInput>;
    appointmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    guarantorName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type GuarantorPaymentLinkContextOrderByWithRelationInput = {
    appointmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    guarantorName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    patientName?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum GuarantorPaymentLinkContextScalarFieldEnum {
    AppointmentId = 'appointmentId',
    CreatedAt = 'createdAt',
    GuarantorName = 'guarantorName',
    Id = 'id',
    OrgId = 'orgId',
    PatientName = 'patientName',
    UpdatedAt = 'updatedAt',
}

export type GuarantorPaymentLinkContextScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<GuarantorPaymentLinkContextScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<GuarantorPaymentLinkContextScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<GuarantorPaymentLinkContextScalarWhereWithAggregatesInput>
    >;
    appointmentId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    guarantorName?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    patientName?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type GuarantorPaymentLinkContextSumAggregate = {
    __typename?: 'GuarantorPaymentLinkContextSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type GuarantorPaymentLinkContextSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type GuarantorPaymentLinkContextUpdateInput = {
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    guarantorName?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    patientName?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type GuarantorPaymentLinkContextUpdateManyMutationInput = {
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    guarantorName?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    patientName?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type GuarantorPaymentLinkContextWhereInput = {
    AND?: InputMaybe<Array<GuarantorPaymentLinkContextWhereInput>>;
    NOT?: InputMaybe<Array<GuarantorPaymentLinkContextWhereInput>>;
    OR?: InputMaybe<Array<GuarantorPaymentLinkContextWhereInput>>;
    appointmentId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    guarantorName?: InputMaybe<StringFilter>;
    id?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    patientName?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type GuarantorPaymentLinkContextWhereUniqueInput = {
    AND?: InputMaybe<Array<GuarantorPaymentLinkContextWhereInput>>;
    NOT?: InputMaybe<Array<GuarantorPaymentLinkContextWhereInput>>;
    OR?: InputMaybe<Array<GuarantorPaymentLinkContextWhereInput>>;
    appointmentId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    guarantorName?: InputMaybe<StringFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
    patientName?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Holiday = {
    __typename?: 'Holiday';
    day: Scalars['DateTimeISO']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    practiceIdOverride: Array<Scalars['Int']['output']>;
};

export type HolidayAvgAggregate = {
    __typename?: 'HolidayAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
    practiceIdOverride?: Maybe<Scalars['Float']['output']>;
};

export type HolidayAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    practiceIdOverride?: InputMaybe<SortOrder>;
};

export type HolidayCountAggregate = {
    __typename?: 'HolidayCountAggregate';
    _all: Scalars['Int']['output'];
    day: Scalars['Int']['output'];
    enabled: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    practiceIdOverride: Scalars['Int']['output'];
};

export type HolidayCountOrderByAggregateInput = {
    day?: InputMaybe<SortOrder>;
    enabled?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceIdOverride?: InputMaybe<SortOrder>;
};

export type HolidayCreateInput = {
    day: Scalars['DateTimeISO']['input'];
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    practiceIdOverride?: InputMaybe<HolidayCreatepracticeIdOverrideInput>;
};

export type HolidayCreateManyInput = {
    day: Scalars['DateTimeISO']['input'];
    enabled?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    practiceIdOverride?: InputMaybe<HolidayCreatepracticeIdOverrideInput>;
};

export type HolidayCreatepracticeIdOverrideInput = {
    set: Array<Scalars['Int']['input']>;
};

export type HolidayGroupBy = {
    __typename?: 'HolidayGroupBy';
    _avg?: Maybe<HolidayAvgAggregate>;
    _count?: Maybe<HolidayCountAggregate>;
    _max?: Maybe<HolidayMaxAggregate>;
    _min?: Maybe<HolidayMinAggregate>;
    _sum?: Maybe<HolidaySumAggregate>;
    day: Scalars['DateTimeISO']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    practiceIdOverride?: Maybe<Array<Scalars['Int']['output']>>;
};

export type HolidayMaxAggregate = {
    __typename?: 'HolidayMaxAggregate';
    day?: Maybe<Scalars['DateTimeISO']['output']>;
    enabled?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type HolidayMaxOrderByAggregateInput = {
    day?: InputMaybe<SortOrder>;
    enabled?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type HolidayMinAggregate = {
    __typename?: 'HolidayMinAggregate';
    day?: Maybe<Scalars['DateTimeISO']['output']>;
    enabled?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type HolidayMinOrderByAggregateInput = {
    day?: InputMaybe<SortOrder>;
    enabled?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type HolidayOrderByWithAggregationInput = {
    _avg?: InputMaybe<HolidayAvgOrderByAggregateInput>;
    _count?: InputMaybe<HolidayCountOrderByAggregateInput>;
    _max?: InputMaybe<HolidayMaxOrderByAggregateInput>;
    _min?: InputMaybe<HolidayMinOrderByAggregateInput>;
    _sum?: InputMaybe<HolidaySumOrderByAggregateInput>;
    day?: InputMaybe<SortOrder>;
    enabled?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceIdOverride?: InputMaybe<SortOrder>;
};

export type HolidayOrderByWithRelationInput = {
    day?: InputMaybe<SortOrder>;
    enabled?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceIdOverride?: InputMaybe<SortOrder>;
};

export enum HolidayScalarFieldEnum {
    Day = 'day',
    Enabled = 'enabled',
    Id = 'id',
    Name = 'name',
    OrgId = 'orgId',
    PracticeIdOverride = 'practiceIdOverride',
}

export type HolidayScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<HolidayScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<HolidayScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<HolidayScalarWhereWithAggregatesInput>>;
    day?: InputMaybe<DateTimeWithAggregatesFilter>;
    enabled?: InputMaybe<BoolWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    practiceIdOverride?: InputMaybe<IntNullableListFilter>;
};

export type HolidaySumAggregate = {
    __typename?: 'HolidaySumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceIdOverride?: Maybe<Array<Scalars['Int']['output']>>;
};

export type HolidaySumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    practiceIdOverride?: InputMaybe<SortOrder>;
};

export type HolidayUpdateInput = {
    day?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    practiceIdOverride?: InputMaybe<HolidayUpdatepracticeIdOverrideInput>;
};

export type HolidayUpdateManyMutationInput = {
    day?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    practiceIdOverride?: InputMaybe<HolidayUpdatepracticeIdOverrideInput>;
};

export type HolidayUpdatepracticeIdOverrideInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type HolidayWhereInput = {
    AND?: InputMaybe<Array<HolidayWhereInput>>;
    NOT?: InputMaybe<Array<HolidayWhereInput>>;
    OR?: InputMaybe<Array<HolidayWhereInput>>;
    day?: InputMaybe<DateTimeFilter>;
    enabled?: InputMaybe<BoolFilter>;
    id?: InputMaybe<UuidFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    practiceIdOverride?: InputMaybe<IntNullableListFilter>;
};

export type HolidayWhereUniqueInput = {
    AND?: InputMaybe<Array<HolidayWhereInput>>;
    NOT?: InputMaybe<Array<HolidayWhereInput>>;
    OR?: InputMaybe<Array<HolidayWhereInput>>;
    day?: InputMaybe<DateTimeFilter>;
    enabled?: InputMaybe<BoolFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    practiceIdOverride?: InputMaybe<IntNullableListFilter>;
};

export type Hrt = {
    __typename?: 'Hrt';
    HrtFlags: Array<HrtFlags>;
    HrtTranslation: Array<HrtTranslation>;
    PricedTreatment: Array<PricedTreatment>;
    ProviderHrtMaxCount: Array<ProviderHrtMaxCount>;
    _count?: Maybe<HrtCount>;
    additionalResources?: Maybe<Scalars['JSON']['output']>;
    bundleToHrt: Array<BundleToHrt>;
    cash_prices?: Maybe<CashPrice>;
    customDuration: Scalars['Int']['output'];
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
    ehrPrimaryAppointmentTypeId: Array<Scalars['String']['output']>;
    hrtId: Scalars['Int']['output'];
    hrtPaymentType: Array<HrtPaymentType>;
    hrtToSrt: Array<HrtToSrt>;
    isBookableOnStorefront: Scalars['Boolean']['output'];
    isConsumerFacing: Scalars['Boolean']['output'];
    isPrimary: Scalars['Boolean']['output'];
    isPrimaryCandidateSameCpt: Scalars['Boolean']['output'];
    isShownOnCompanion: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    pcDisplayName?: Maybe<Scalars['String']['output']>;
    popularity: Scalars['Float']['output'];
    pricingAttempt: Array<PricingAttempt>;
    productToHrt: Array<ProductToHrt>;
    providerGroupToHrt: Array<ProviderGroupToHrt>;
};

export type HrtHrtFlagsArgs = {
    cursor?: InputMaybe<HrtFlagsWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtFlagsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtFlagsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtFlagsWhereInput>;
};

export type HrtHrtTranslationArgs = {
    cursor?: InputMaybe<HrtTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtTranslationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtTranslationWhereInput>;
};

export type HrtPricedTreatmentArgs = {
    cursor?: InputMaybe<PricedTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricedTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricedTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type HrtProviderHrtMaxCountArgs = {
    cursor?: InputMaybe<ProviderHrtMaxCountWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderHrtMaxCountScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderHrtMaxCountOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type HrtBundleToHrtArgs = {
    cursor?: InputMaybe<BundleToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<BundleToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BundleToHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type HrtCashPricesArgs = {
    where?: InputMaybe<CashPriceWhereInput>;
};

export type HrtHrtPaymentTypeArgs = {
    cursor?: InputMaybe<HrtPaymentTypeWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtPaymentTypeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtPaymentTypeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtPaymentTypeWhereInput>;
};

export type HrtHrtToSrtArgs = {
    cursor?: InputMaybe<HrtToSrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtToSrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtToSrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type HrtPricingAttemptArgs = {
    cursor?: InputMaybe<PricingAttemptWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingAttemptScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingAttemptOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type HrtProductToHrtArgs = {
    cursor?: InputMaybe<ProductToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductToHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type HrtProviderGroupToHrtArgs = {
    cursor?: InputMaybe<ProviderGroupToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupToHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type HrtAvgAggregate = {
    __typename?: 'HrtAvgAggregate';
    customDuration?: Maybe<Scalars['Float']['output']>;
    hrtId?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type HrtAvgOrderByAggregateInput = {
    customDuration?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type HrtCount = {
    __typename?: 'HrtCount';
    HrtFlags: Scalars['Int']['output'];
    HrtTranslation: Scalars['Int']['output'];
    PricedTreatment: Scalars['Int']['output'];
    ProviderHrtMaxCount: Scalars['Int']['output'];
    bundleToHrt: Scalars['Int']['output'];
    hrtPaymentType: Scalars['Int']['output'];
    hrtToSrt: Scalars['Int']['output'];
    pricingAttempt: Scalars['Int']['output'];
    productToHrt: Scalars['Int']['output'];
    providerGroupToHrt: Scalars['Int']['output'];
};

export type HrtCountHrtFlagsArgs = {
    where?: InputMaybe<HrtFlagsWhereInput>;
};

export type HrtCountHrtTranslationArgs = {
    where?: InputMaybe<HrtTranslationWhereInput>;
};

export type HrtCountPricedTreatmentArgs = {
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type HrtCountProviderHrtMaxCountArgs = {
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type HrtCountBundleToHrtArgs = {
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type HrtCountHrtPaymentTypeArgs = {
    where?: InputMaybe<HrtPaymentTypeWhereInput>;
};

export type HrtCountHrtToSrtArgs = {
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type HrtCountPricingAttemptArgs = {
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type HrtCountProductToHrtArgs = {
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type HrtCountProviderGroupToHrtArgs = {
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type HrtCountAggregate = {
    __typename?: 'HrtCountAggregate';
    _all: Scalars['Int']['output'];
    additionalResources: Scalars['Int']['output'];
    customDuration: Scalars['Int']['output'];
    displayMetadata: Scalars['Int']['output'];
    displayName: Scalars['Int']['output'];
    ehrPrimaryAppointmentTypeId: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    isBookableOnStorefront: Scalars['Int']['output'];
    isConsumerFacing: Scalars['Int']['output'];
    isPrimary: Scalars['Int']['output'];
    isPrimaryCandidateSameCpt: Scalars['Int']['output'];
    isShownOnCompanion: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    pcDisplayName: Scalars['Int']['output'];
    popularity: Scalars['Int']['output'];
};

export type HrtCountOrderByAggregateInput = {
    additionalResources?: InputMaybe<SortOrder>;
    customDuration?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrder>;
    displayName?: InputMaybe<SortOrder>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    isBookableOnStorefront?: InputMaybe<SortOrder>;
    isConsumerFacing?: InputMaybe<SortOrder>;
    isPrimary?: InputMaybe<SortOrder>;
    isPrimaryCandidateSameCpt?: InputMaybe<SortOrder>;
    isShownOnCompanion?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    pcDisplayName?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type HrtCreateInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateManyInput = {
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
};

export type HrtCreateManyOrgInput = {
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
};

export type HrtCreateManyOrgInputEnvelope = {
    data: Array<HrtCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HrtCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<HrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<HrtCreateOrConnectWithoutOrgInput>>;
    create?: InputMaybe<Array<HrtCreateWithoutOrgInput>>;
    createMany?: InputMaybe<HrtCreateManyOrgInputEnvelope>;
};

export type HrtCreateNestedOneWithoutBundleToHrtInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutBundleToHrtInput>;
    create?: InputMaybe<HrtCreateWithoutBundleToHrtInput>;
};

export type HrtCreateNestedOneWithoutCashPricesInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutCashPricesInput>;
    create?: InputMaybe<HrtCreateWithoutCashPricesInput>;
};

export type HrtCreateNestedOneWithoutHrtFlagsInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutHrtFlagsInput>;
    create?: InputMaybe<HrtCreateWithoutHrtFlagsInput>;
};

export type HrtCreateNestedOneWithoutHrtPaymentTypeInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutHrtPaymentTypeInput>;
    create?: InputMaybe<HrtCreateWithoutHrtPaymentTypeInput>;
};

export type HrtCreateNestedOneWithoutHrtToSrtInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutHrtToSrtInput>;
    create?: InputMaybe<HrtCreateWithoutHrtToSrtInput>;
};

export type HrtCreateNestedOneWithoutHrtTranslationInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutHrtTranslationInput>;
    create?: InputMaybe<HrtCreateWithoutHrtTranslationInput>;
};

export type HrtCreateNestedOneWithoutPricedTreatmentInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutPricedTreatmentInput>;
    create?: InputMaybe<HrtCreateWithoutPricedTreatmentInput>;
};

export type HrtCreateNestedOneWithoutPricingAttemptInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutPricingAttemptInput>;
    create?: InputMaybe<HrtCreateWithoutPricingAttemptInput>;
};

export type HrtCreateNestedOneWithoutProductToHrtInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutProductToHrtInput>;
    create?: InputMaybe<HrtCreateWithoutProductToHrtInput>;
};

export type HrtCreateNestedOneWithoutProviderGroupToHrtInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutProviderGroupToHrtInput>;
    create?: InputMaybe<HrtCreateWithoutProviderGroupToHrtInput>;
};

export type HrtCreateNestedOneWithoutProviderHrtMaxCountInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutProviderHrtMaxCountInput>;
    create?: InputMaybe<HrtCreateWithoutProviderHrtMaxCountInput>;
};

export type HrtCreateOrConnectWithoutBundleToHrtInput = {
    create: HrtCreateWithoutBundleToHrtInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutCashPricesInput = {
    create: HrtCreateWithoutCashPricesInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutHrtFlagsInput = {
    create: HrtCreateWithoutHrtFlagsInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutHrtPaymentTypeInput = {
    create: HrtCreateWithoutHrtPaymentTypeInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutHrtToSrtInput = {
    create: HrtCreateWithoutHrtToSrtInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutHrtTranslationInput = {
    create: HrtCreateWithoutHrtTranslationInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutOrgInput = {
    create: HrtCreateWithoutOrgInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutPricedTreatmentInput = {
    create: HrtCreateWithoutPricedTreatmentInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutPricingAttemptInput = {
    create: HrtCreateWithoutPricingAttemptInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutProductToHrtInput = {
    create: HrtCreateWithoutProductToHrtInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutProviderGroupToHrtInput = {
    create: HrtCreateWithoutProviderGroupToHrtInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateOrConnectWithoutProviderHrtMaxCountInput = {
    create: HrtCreateWithoutProviderHrtMaxCountInput;
    where: HrtWhereUniqueInput;
};

export type HrtCreateWithoutBundleToHrtInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutCashPricesInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutHrtFlagsInput = {
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutHrtPaymentTypeInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutHrtToSrtInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutHrtTranslationInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutOrgInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutPricedTreatmentInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutPricingAttemptInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutProductToHrtInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutProviderGroupToHrtInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateWithoutProviderHrtMaxCountInput = {
    HrtFlags?: InputMaybe<HrtFlagsCreateNestedManyWithoutHrtInput>;
    HrtTranslation?: InputMaybe<HrtTranslationCreateNestedManyWithoutHrtInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutHrtInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtCreateNestedManyWithoutHrtInput>;
    cash_prices?: InputMaybe<CashPriceCreateNestedOneWithoutHrtInput>;
    customDuration?: InputMaybe<Scalars['Int']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtCreateehrPrimaryAppointmentTypeIdInput>;
    hrtId: Scalars['Int']['input'];
    hrtPaymentType?: InputMaybe<HrtPaymentTypeCreateNestedManyWithoutHrtInput>;
    hrtToSrt?: InputMaybe<HrtToSrtCreateNestedManyWithoutHrtInput>;
    isBookableOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    isConsumerFacing?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
    isPrimaryCandidateSameCpt?: InputMaybe<Scalars['Boolean']['input']>;
    isShownOnCompanion?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutHrtInput;
    pcDisplayName?: InputMaybe<Scalars['String']['input']>;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutHrtInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutHrtInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutHrtInput>;
};

export type HrtCreateehrPrimaryAppointmentTypeIdInput = {
    set: Array<Scalars['String']['input']>;
};

export type HrtFlags = {
    __typename?: 'HrtFlags';
    hrt: Hrt;
    hrtId: Scalars['Int']['output'];
    isAnnualVisit: Scalars['Boolean']['output'];
    isGlobalBilling: Scalars['Boolean']['output'];
    isInOfficeProcedure: Scalars['Boolean']['output'];
    isOutstandingBalance: Scalars['Boolean']['output'];
    isSurgery: Scalars['Boolean']['output'];
    isVirtualVisit: Scalars['Boolean']['output'];
    kioskHrtType?: Maybe<KioskHrtType>;
};

export type HrtFlagsAvgAggregate = {
    __typename?: 'HrtFlagsAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
};

export type HrtFlagsAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
};

export type HrtFlagsCountAggregate = {
    __typename?: 'HrtFlagsCountAggregate';
    _all: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    isAnnualVisit: Scalars['Int']['output'];
    isGlobalBilling: Scalars['Int']['output'];
    isInOfficeProcedure: Scalars['Int']['output'];
    isOutstandingBalance: Scalars['Int']['output'];
    isSurgery: Scalars['Int']['output'];
    isVirtualVisit: Scalars['Int']['output'];
    kioskHrtType: Scalars['Int']['output'];
};

export type HrtFlagsCountOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    isAnnualVisit?: InputMaybe<SortOrder>;
    isGlobalBilling?: InputMaybe<SortOrder>;
    isInOfficeProcedure?: InputMaybe<SortOrder>;
    isOutstandingBalance?: InputMaybe<SortOrder>;
    isSurgery?: InputMaybe<SortOrder>;
    isVirtualVisit?: InputMaybe<SortOrder>;
    kioskHrtType?: InputMaybe<SortOrder>;
};

export type HrtFlagsCreateInput = {
    hrt: HrtCreateNestedOneWithoutHrtFlagsInput;
    isAnnualVisit?: InputMaybe<Scalars['Boolean']['input']>;
    isGlobalBilling?: InputMaybe<Scalars['Boolean']['input']>;
    isInOfficeProcedure?: InputMaybe<Scalars['Boolean']['input']>;
    isOutstandingBalance?: InputMaybe<Scalars['Boolean']['input']>;
    isSurgery?: InputMaybe<Scalars['Boolean']['input']>;
    isVirtualVisit?: InputMaybe<Scalars['Boolean']['input']>;
    kioskHrtType?: InputMaybe<KioskHrtType>;
};

export type HrtFlagsCreateManyHrtInput = {
    isAnnualVisit?: InputMaybe<Scalars['Boolean']['input']>;
    isGlobalBilling?: InputMaybe<Scalars['Boolean']['input']>;
    isInOfficeProcedure?: InputMaybe<Scalars['Boolean']['input']>;
    isOutstandingBalance?: InputMaybe<Scalars['Boolean']['input']>;
    isSurgery?: InputMaybe<Scalars['Boolean']['input']>;
    isVirtualVisit?: InputMaybe<Scalars['Boolean']['input']>;
    kioskHrtType?: InputMaybe<KioskHrtType>;
};

export type HrtFlagsCreateManyHrtInputEnvelope = {
    data: Array<HrtFlagsCreateManyHrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HrtFlagsCreateManyInput = {
    hrtId: Scalars['Int']['input'];
    isAnnualVisit?: InputMaybe<Scalars['Boolean']['input']>;
    isGlobalBilling?: InputMaybe<Scalars['Boolean']['input']>;
    isInOfficeProcedure?: InputMaybe<Scalars['Boolean']['input']>;
    isOutstandingBalance?: InputMaybe<Scalars['Boolean']['input']>;
    isSurgery?: InputMaybe<Scalars['Boolean']['input']>;
    isVirtualVisit?: InputMaybe<Scalars['Boolean']['input']>;
    kioskHrtType?: InputMaybe<KioskHrtType>;
};

export type HrtFlagsCreateNestedManyWithoutHrtInput = {
    connect?: InputMaybe<Array<HrtFlagsWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<HrtFlagsCreateOrConnectWithoutHrtInput>>;
    create?: InputMaybe<Array<HrtFlagsCreateWithoutHrtInput>>;
    createMany?: InputMaybe<HrtFlagsCreateManyHrtInputEnvelope>;
};

export type HrtFlagsCreateOrConnectWithoutHrtInput = {
    create: HrtFlagsCreateWithoutHrtInput;
    where: HrtFlagsWhereUniqueInput;
};

export type HrtFlagsCreateWithoutHrtInput = {
    isAnnualVisit?: InputMaybe<Scalars['Boolean']['input']>;
    isGlobalBilling?: InputMaybe<Scalars['Boolean']['input']>;
    isInOfficeProcedure?: InputMaybe<Scalars['Boolean']['input']>;
    isOutstandingBalance?: InputMaybe<Scalars['Boolean']['input']>;
    isSurgery?: InputMaybe<Scalars['Boolean']['input']>;
    isVirtualVisit?: InputMaybe<Scalars['Boolean']['input']>;
    kioskHrtType?: InputMaybe<KioskHrtType>;
};

export type HrtFlagsGroupBy = {
    __typename?: 'HrtFlagsGroupBy';
    _avg?: Maybe<HrtFlagsAvgAggregate>;
    _count?: Maybe<HrtFlagsCountAggregate>;
    _max?: Maybe<HrtFlagsMaxAggregate>;
    _min?: Maybe<HrtFlagsMinAggregate>;
    _sum?: Maybe<HrtFlagsSumAggregate>;
    hrtId: Scalars['Int']['output'];
    isAnnualVisit: Scalars['Boolean']['output'];
    isGlobalBilling: Scalars['Boolean']['output'];
    isInOfficeProcedure: Scalars['Boolean']['output'];
    isOutstandingBalance: Scalars['Boolean']['output'];
    isSurgery: Scalars['Boolean']['output'];
    isVirtualVisit: Scalars['Boolean']['output'];
    kioskHrtType?: Maybe<KioskHrtType>;
};

export type HrtFlagsListRelationFilter = {
    every?: InputMaybe<HrtFlagsWhereInput>;
    none?: InputMaybe<HrtFlagsWhereInput>;
    some?: InputMaybe<HrtFlagsWhereInput>;
};

export type HrtFlagsMaxAggregate = {
    __typename?: 'HrtFlagsMaxAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    isAnnualVisit?: Maybe<Scalars['Boolean']['output']>;
    isGlobalBilling?: Maybe<Scalars['Boolean']['output']>;
    isInOfficeProcedure?: Maybe<Scalars['Boolean']['output']>;
    isOutstandingBalance?: Maybe<Scalars['Boolean']['output']>;
    isSurgery?: Maybe<Scalars['Boolean']['output']>;
    isVirtualVisit?: Maybe<Scalars['Boolean']['output']>;
    kioskHrtType?: Maybe<KioskHrtType>;
};

export type HrtFlagsMaxOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    isAnnualVisit?: InputMaybe<SortOrder>;
    isGlobalBilling?: InputMaybe<SortOrder>;
    isInOfficeProcedure?: InputMaybe<SortOrder>;
    isOutstandingBalance?: InputMaybe<SortOrder>;
    isSurgery?: InputMaybe<SortOrder>;
    isVirtualVisit?: InputMaybe<SortOrder>;
    kioskHrtType?: InputMaybe<SortOrder>;
};

export type HrtFlagsMinAggregate = {
    __typename?: 'HrtFlagsMinAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    isAnnualVisit?: Maybe<Scalars['Boolean']['output']>;
    isGlobalBilling?: Maybe<Scalars['Boolean']['output']>;
    isInOfficeProcedure?: Maybe<Scalars['Boolean']['output']>;
    isOutstandingBalance?: Maybe<Scalars['Boolean']['output']>;
    isSurgery?: Maybe<Scalars['Boolean']['output']>;
    isVirtualVisit?: Maybe<Scalars['Boolean']['output']>;
    kioskHrtType?: Maybe<KioskHrtType>;
};

export type HrtFlagsMinOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    isAnnualVisit?: InputMaybe<SortOrder>;
    isGlobalBilling?: InputMaybe<SortOrder>;
    isInOfficeProcedure?: InputMaybe<SortOrder>;
    isOutstandingBalance?: InputMaybe<SortOrder>;
    isSurgery?: InputMaybe<SortOrder>;
    isVirtualVisit?: InputMaybe<SortOrder>;
    kioskHrtType?: InputMaybe<SortOrder>;
};

export type HrtFlagsOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type HrtFlagsOrderByWithAggregationInput = {
    _avg?: InputMaybe<HrtFlagsAvgOrderByAggregateInput>;
    _count?: InputMaybe<HrtFlagsCountOrderByAggregateInput>;
    _max?: InputMaybe<HrtFlagsMaxOrderByAggregateInput>;
    _min?: InputMaybe<HrtFlagsMinOrderByAggregateInput>;
    _sum?: InputMaybe<HrtFlagsSumOrderByAggregateInput>;
    hrtId?: InputMaybe<SortOrder>;
    isAnnualVisit?: InputMaybe<SortOrder>;
    isGlobalBilling?: InputMaybe<SortOrder>;
    isInOfficeProcedure?: InputMaybe<SortOrder>;
    isOutstandingBalance?: InputMaybe<SortOrder>;
    isSurgery?: InputMaybe<SortOrder>;
    isVirtualVisit?: InputMaybe<SortOrder>;
    kioskHrtType?: InputMaybe<SortOrderInput>;
};

export type HrtFlagsOrderByWithRelationInput = {
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrder>;
    isAnnualVisit?: InputMaybe<SortOrder>;
    isGlobalBilling?: InputMaybe<SortOrder>;
    isInOfficeProcedure?: InputMaybe<SortOrder>;
    isOutstandingBalance?: InputMaybe<SortOrder>;
    isSurgery?: InputMaybe<SortOrder>;
    isVirtualVisit?: InputMaybe<SortOrder>;
    kioskHrtType?: InputMaybe<SortOrderInput>;
};

export enum HrtFlagsScalarFieldEnum {
    HrtId = 'hrtId',
    IsAnnualVisit = 'isAnnualVisit',
    IsGlobalBilling = 'isGlobalBilling',
    IsInOfficeProcedure = 'isInOfficeProcedure',
    IsOutstandingBalance = 'isOutstandingBalance',
    IsSurgery = 'isSurgery',
    IsVirtualVisit = 'isVirtualVisit',
    KioskHrtType = 'kioskHrtType',
}

export type HrtFlagsScalarWhereInput = {
    AND?: InputMaybe<Array<HrtFlagsScalarWhereInput>>;
    NOT?: InputMaybe<Array<HrtFlagsScalarWhereInput>>;
    OR?: InputMaybe<Array<HrtFlagsScalarWhereInput>>;
    hrtId?: InputMaybe<IntFilter>;
    isAnnualVisit?: InputMaybe<BoolFilter>;
    isGlobalBilling?: InputMaybe<BoolFilter>;
    isInOfficeProcedure?: InputMaybe<BoolFilter>;
    isOutstandingBalance?: InputMaybe<BoolFilter>;
    isSurgery?: InputMaybe<BoolFilter>;
    isVirtualVisit?: InputMaybe<BoolFilter>;
    kioskHrtType?: InputMaybe<EnumKioskHrtTypeNullableFilter>;
};

export type HrtFlagsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<HrtFlagsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<HrtFlagsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<HrtFlagsScalarWhereWithAggregatesInput>>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    isAnnualVisit?: InputMaybe<BoolWithAggregatesFilter>;
    isGlobalBilling?: InputMaybe<BoolWithAggregatesFilter>;
    isInOfficeProcedure?: InputMaybe<BoolWithAggregatesFilter>;
    isOutstandingBalance?: InputMaybe<BoolWithAggregatesFilter>;
    isSurgery?: InputMaybe<BoolWithAggregatesFilter>;
    isVirtualVisit?: InputMaybe<BoolWithAggregatesFilter>;
    kioskHrtType?: InputMaybe<EnumKioskHrtTypeNullableWithAggregatesFilter>;
};

export type HrtFlagsSumAggregate = {
    __typename?: 'HrtFlagsSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
};

export type HrtFlagsSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
};

export type HrtFlagsUpdateInput = {
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutHrtFlagsNestedInput>;
    isAnnualVisit?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isGlobalBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isInOfficeProcedure?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isOutstandingBalance?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isSurgery?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isVirtualVisit?: InputMaybe<BoolFieldUpdateOperationsInput>;
    kioskHrtType?: InputMaybe<NullableEnumKioskHrtTypeFieldUpdateOperationsInput>;
};

export type HrtFlagsUpdateManyMutationInput = {
    isAnnualVisit?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isGlobalBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isInOfficeProcedure?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isOutstandingBalance?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isSurgery?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isVirtualVisit?: InputMaybe<BoolFieldUpdateOperationsInput>;
    kioskHrtType?: InputMaybe<NullableEnumKioskHrtTypeFieldUpdateOperationsInput>;
};

export type HrtFlagsUpdateManyWithWhereWithoutHrtInput = {
    data: HrtFlagsUpdateManyMutationInput;
    where: HrtFlagsScalarWhereInput;
};

export type HrtFlagsUpdateManyWithoutHrtNestedInput = {
    connect?: InputMaybe<Array<HrtFlagsWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<HrtFlagsCreateOrConnectWithoutHrtInput>>;
    create?: InputMaybe<Array<HrtFlagsCreateWithoutHrtInput>>;
    createMany?: InputMaybe<HrtFlagsCreateManyHrtInputEnvelope>;
    delete?: InputMaybe<Array<HrtFlagsWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<HrtFlagsScalarWhereInput>>;
    disconnect?: InputMaybe<Array<HrtFlagsWhereUniqueInput>>;
    set?: InputMaybe<Array<HrtFlagsWhereUniqueInput>>;
    update?: InputMaybe<Array<HrtFlagsUpdateWithWhereUniqueWithoutHrtInput>>;
    updateMany?: InputMaybe<Array<HrtFlagsUpdateManyWithWhereWithoutHrtInput>>;
    upsert?: InputMaybe<Array<HrtFlagsUpsertWithWhereUniqueWithoutHrtInput>>;
};

export type HrtFlagsUpdateWithWhereUniqueWithoutHrtInput = {
    data: HrtFlagsUpdateWithoutHrtInput;
    where: HrtFlagsWhereUniqueInput;
};

export type HrtFlagsUpdateWithoutHrtInput = {
    isAnnualVisit?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isGlobalBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isInOfficeProcedure?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isOutstandingBalance?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isSurgery?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isVirtualVisit?: InputMaybe<BoolFieldUpdateOperationsInput>;
    kioskHrtType?: InputMaybe<NullableEnumKioskHrtTypeFieldUpdateOperationsInput>;
};

export type HrtFlagsUpsertWithWhereUniqueWithoutHrtInput = {
    create: HrtFlagsCreateWithoutHrtInput;
    update: HrtFlagsUpdateWithoutHrtInput;
    where: HrtFlagsWhereUniqueInput;
};

export type HrtFlagsWhereInput = {
    AND?: InputMaybe<Array<HrtFlagsWhereInput>>;
    NOT?: InputMaybe<Array<HrtFlagsWhereInput>>;
    OR?: InputMaybe<Array<HrtFlagsWhereInput>>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    isAnnualVisit?: InputMaybe<BoolFilter>;
    isGlobalBilling?: InputMaybe<BoolFilter>;
    isInOfficeProcedure?: InputMaybe<BoolFilter>;
    isOutstandingBalance?: InputMaybe<BoolFilter>;
    isSurgery?: InputMaybe<BoolFilter>;
    isVirtualVisit?: InputMaybe<BoolFilter>;
    kioskHrtType?: InputMaybe<EnumKioskHrtTypeNullableFilter>;
};

export type HrtFlagsWhereUniqueInput = {
    AND?: InputMaybe<Array<HrtFlagsWhereInput>>;
    NOT?: InputMaybe<Array<HrtFlagsWhereInput>>;
    OR?: InputMaybe<Array<HrtFlagsWhereInput>>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    isAnnualVisit?: InputMaybe<BoolFilter>;
    isGlobalBilling?: InputMaybe<BoolFilter>;
    isInOfficeProcedure?: InputMaybe<BoolFilter>;
    isOutstandingBalance?: InputMaybe<BoolFilter>;
    isSurgery?: InputMaybe<BoolFilter>;
    isVirtualVisit?: InputMaybe<BoolFilter>;
    kioskHrtType?: InputMaybe<EnumKioskHrtTypeNullableFilter>;
};

export type HrtGroupBy = {
    __typename?: 'HrtGroupBy';
    _avg?: Maybe<HrtAvgAggregate>;
    _count?: Maybe<HrtCountAggregate>;
    _max?: Maybe<HrtMaxAggregate>;
    _min?: Maybe<HrtMinAggregate>;
    _sum?: Maybe<HrtSumAggregate>;
    additionalResources?: Maybe<Scalars['JSON']['output']>;
    customDuration: Scalars['Int']['output'];
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
    ehrPrimaryAppointmentTypeId?: Maybe<Array<Scalars['String']['output']>>;
    hrtId: Scalars['Int']['output'];
    isBookableOnStorefront: Scalars['Boolean']['output'];
    isConsumerFacing: Scalars['Boolean']['output'];
    isPrimary: Scalars['Boolean']['output'];
    isPrimaryCandidateSameCpt: Scalars['Boolean']['output'];
    isShownOnCompanion: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    pcDisplayName?: Maybe<Scalars['String']['output']>;
    popularity: Scalars['Float']['output'];
};

export type HrtListRelationFilter = {
    every?: InputMaybe<HrtWhereInput>;
    none?: InputMaybe<HrtWhereInput>;
    some?: InputMaybe<HrtWhereInput>;
};

export type HrtMaxAggregate = {
    __typename?: 'HrtMaxAggregate';
    customDuration?: Maybe<Scalars['Int']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    isBookableOnStorefront?: Maybe<Scalars['Boolean']['output']>;
    isConsumerFacing?: Maybe<Scalars['Boolean']['output']>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
    isPrimaryCandidateSameCpt?: Maybe<Scalars['Boolean']['output']>;
    isShownOnCompanion?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    pcDisplayName?: Maybe<Scalars['String']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type HrtMaxOrderByAggregateInput = {
    customDuration?: InputMaybe<SortOrder>;
    displayName?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    isBookableOnStorefront?: InputMaybe<SortOrder>;
    isConsumerFacing?: InputMaybe<SortOrder>;
    isPrimary?: InputMaybe<SortOrder>;
    isPrimaryCandidateSameCpt?: InputMaybe<SortOrder>;
    isShownOnCompanion?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    pcDisplayName?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type HrtMinAggregate = {
    __typename?: 'HrtMinAggregate';
    customDuration?: Maybe<Scalars['Int']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    isBookableOnStorefront?: Maybe<Scalars['Boolean']['output']>;
    isConsumerFacing?: Maybe<Scalars['Boolean']['output']>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
    isPrimaryCandidateSameCpt?: Maybe<Scalars['Boolean']['output']>;
    isShownOnCompanion?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    pcDisplayName?: Maybe<Scalars['String']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type HrtMinOrderByAggregateInput = {
    customDuration?: InputMaybe<SortOrder>;
    displayName?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    isBookableOnStorefront?: InputMaybe<SortOrder>;
    isConsumerFacing?: InputMaybe<SortOrder>;
    isPrimary?: InputMaybe<SortOrder>;
    isPrimaryCandidateSameCpt?: InputMaybe<SortOrder>;
    isShownOnCompanion?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    pcDisplayName?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type HrtNullableRelationFilter = {
    is?: InputMaybe<HrtWhereInput>;
    isNot?: InputMaybe<HrtWhereInput>;
};

export type HrtOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type HrtOrderByWithAggregationInput = {
    _avg?: InputMaybe<HrtAvgOrderByAggregateInput>;
    _count?: InputMaybe<HrtCountOrderByAggregateInput>;
    _max?: InputMaybe<HrtMaxOrderByAggregateInput>;
    _min?: InputMaybe<HrtMinOrderByAggregateInput>;
    _sum?: InputMaybe<HrtSumOrderByAggregateInput>;
    additionalResources?: InputMaybe<SortOrderInput>;
    customDuration?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    displayName?: InputMaybe<SortOrderInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    isBookableOnStorefront?: InputMaybe<SortOrder>;
    isConsumerFacing?: InputMaybe<SortOrder>;
    isPrimary?: InputMaybe<SortOrder>;
    isPrimaryCandidateSameCpt?: InputMaybe<SortOrder>;
    isShownOnCompanion?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    pcDisplayName?: InputMaybe<SortOrderInput>;
    popularity?: InputMaybe<SortOrder>;
};

export type HrtOrderByWithRelationInput = {
    HrtFlags?: InputMaybe<HrtFlagsOrderByRelationAggregateInput>;
    HrtTranslation?: InputMaybe<HrtTranslationOrderByRelationAggregateInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentOrderByRelationAggregateInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountOrderByRelationAggregateInput>;
    additionalResources?: InputMaybe<SortOrderInput>;
    bundleToHrt?: InputMaybe<BundleToHrtOrderByRelationAggregateInput>;
    cash_prices?: InputMaybe<CashPriceOrderByWithRelationInput>;
    customDuration?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    displayName?: InputMaybe<SortOrderInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeOrderByRelationAggregateInput>;
    hrtToSrt?: InputMaybe<HrtToSrtOrderByRelationAggregateInput>;
    isBookableOnStorefront?: InputMaybe<SortOrder>;
    isConsumerFacing?: InputMaybe<SortOrder>;
    isPrimary?: InputMaybe<SortOrder>;
    isPrimaryCandidateSameCpt?: InputMaybe<SortOrder>;
    isShownOnCompanion?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    pcDisplayName?: InputMaybe<SortOrderInput>;
    popularity?: InputMaybe<SortOrder>;
    pricingAttempt?: InputMaybe<PricingAttemptOrderByRelationAggregateInput>;
    productToHrt?: InputMaybe<ProductToHrtOrderByRelationAggregateInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtOrderByRelationAggregateInput>;
};

export type HrtPaymentType = {
    __typename?: 'HrtPaymentType';
    hrt: Hrt;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    paymentType: PaymentType;
};

export type HrtPaymentTypeAvgAggregate = {
    __typename?: 'HrtPaymentTypeAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type HrtPaymentTypeAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type HrtPaymentTypeCountAggregate = {
    __typename?: 'HrtPaymentTypeCountAggregate';
    _all: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    paymentType: Scalars['Int']['output'];
};

export type HrtPaymentTypeCountOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
};

export type HrtPaymentTypeCreateInput = {
    hrt: HrtCreateNestedOneWithoutHrtPaymentTypeInput;
    paymentType?: InputMaybe<PaymentType>;
};

export type HrtPaymentTypeCreateManyHrtInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    paymentType?: InputMaybe<PaymentType>;
};

export type HrtPaymentTypeCreateManyHrtInputEnvelope = {
    data: Array<HrtPaymentTypeCreateManyHrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HrtPaymentTypeCreateManyInput = {
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    paymentType?: InputMaybe<PaymentType>;
};

export type HrtPaymentTypeCreateNestedManyWithoutHrtInput = {
    connect?: InputMaybe<Array<HrtPaymentTypeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<HrtPaymentTypeCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<HrtPaymentTypeCreateWithoutHrtInput>>;
    createMany?: InputMaybe<HrtPaymentTypeCreateManyHrtInputEnvelope>;
};

export type HrtPaymentTypeCreateOrConnectWithoutHrtInput = {
    create: HrtPaymentTypeCreateWithoutHrtInput;
    where: HrtPaymentTypeWhereUniqueInput;
};

export type HrtPaymentTypeCreateWithoutHrtInput = {
    paymentType?: InputMaybe<PaymentType>;
};

export type HrtPaymentTypeGroupBy = {
    __typename?: 'HrtPaymentTypeGroupBy';
    _avg?: Maybe<HrtPaymentTypeAvgAggregate>;
    _count?: Maybe<HrtPaymentTypeCountAggregate>;
    _max?: Maybe<HrtPaymentTypeMaxAggregate>;
    _min?: Maybe<HrtPaymentTypeMinAggregate>;
    _sum?: Maybe<HrtPaymentTypeSumAggregate>;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    paymentType: PaymentType;
};

export type HrtPaymentTypeListRelationFilter = {
    every?: InputMaybe<HrtPaymentTypeWhereInput>;
    none?: InputMaybe<HrtPaymentTypeWhereInput>;
    some?: InputMaybe<HrtPaymentTypeWhereInput>;
};

export type HrtPaymentTypeMaxAggregate = {
    __typename?: 'HrtPaymentTypeMaxAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    paymentType?: Maybe<PaymentType>;
};

export type HrtPaymentTypeMaxOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
};

export type HrtPaymentTypeMinAggregate = {
    __typename?: 'HrtPaymentTypeMinAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    paymentType?: Maybe<PaymentType>;
};

export type HrtPaymentTypeMinOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
};

export type HrtPaymentTypeOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type HrtPaymentTypeOrderByWithAggregationInput = {
    _avg?: InputMaybe<HrtPaymentTypeAvgOrderByAggregateInput>;
    _count?: InputMaybe<HrtPaymentTypeCountOrderByAggregateInput>;
    _max?: InputMaybe<HrtPaymentTypeMaxOrderByAggregateInput>;
    _min?: InputMaybe<HrtPaymentTypeMinOrderByAggregateInput>;
    _sum?: InputMaybe<HrtPaymentTypeSumOrderByAggregateInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
};

export type HrtPaymentTypeOrderByWithRelationInput = {
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
};

export enum HrtPaymentTypeScalarFieldEnum {
    HrtId = 'hrtId',
    Id = 'id',
    PaymentType = 'paymentType',
}

export type HrtPaymentTypeScalarWhereInput = {
    AND?: InputMaybe<Array<HrtPaymentTypeScalarWhereInput>>;
    NOT?: InputMaybe<Array<HrtPaymentTypeScalarWhereInput>>;
    OR?: InputMaybe<Array<HrtPaymentTypeScalarWhereInput>>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeFilter>;
};

export type HrtPaymentTypeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<HrtPaymentTypeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<HrtPaymentTypeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<HrtPaymentTypeScalarWhereWithAggregatesInput>>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeWithAggregatesFilter>;
};

export type HrtPaymentTypeSumAggregate = {
    __typename?: 'HrtPaymentTypeSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type HrtPaymentTypeSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type HrtPaymentTypeUpdateInput = {
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutHrtPaymentTypeNestedInput>;
    paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
};

export type HrtPaymentTypeUpdateManyMutationInput = {
    paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
};

export type HrtPaymentTypeUpdateManyWithWhereWithoutHrtInput = {
    data: HrtPaymentTypeUpdateManyMutationInput;
    where: HrtPaymentTypeScalarWhereInput;
};

export type HrtPaymentTypeUpdateManyWithoutHrtNestedInput = {
    connect?: InputMaybe<Array<HrtPaymentTypeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<HrtPaymentTypeCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<HrtPaymentTypeCreateWithoutHrtInput>>;
    createMany?: InputMaybe<HrtPaymentTypeCreateManyHrtInputEnvelope>;
    delete?: InputMaybe<Array<HrtPaymentTypeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<HrtPaymentTypeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<HrtPaymentTypeWhereUniqueInput>>;
    set?: InputMaybe<Array<HrtPaymentTypeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<HrtPaymentTypeUpdateWithWhereUniqueWithoutHrtInput>
    >;
    updateMany?: InputMaybe<
        Array<HrtPaymentTypeUpdateManyWithWhereWithoutHrtInput>
    >;
    upsert?: InputMaybe<
        Array<HrtPaymentTypeUpsertWithWhereUniqueWithoutHrtInput>
    >;
};

export type HrtPaymentTypeUpdateWithWhereUniqueWithoutHrtInput = {
    data: HrtPaymentTypeUpdateWithoutHrtInput;
    where: HrtPaymentTypeWhereUniqueInput;
};

export type HrtPaymentTypeUpdateWithoutHrtInput = {
    paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
};

export type HrtPaymentTypeUpsertWithWhereUniqueWithoutHrtInput = {
    create: HrtPaymentTypeCreateWithoutHrtInput;
    update: HrtPaymentTypeUpdateWithoutHrtInput;
    where: HrtPaymentTypeWhereUniqueInput;
};

export type HrtPaymentTypeWhereInput = {
    AND?: InputMaybe<Array<HrtPaymentTypeWhereInput>>;
    NOT?: InputMaybe<Array<HrtPaymentTypeWhereInput>>;
    OR?: InputMaybe<Array<HrtPaymentTypeWhereInput>>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeFilter>;
};

export type HrtPaymentTypeWhereUniqueInput = {
    AND?: InputMaybe<Array<HrtPaymentTypeWhereInput>>;
    NOT?: InputMaybe<Array<HrtPaymentTypeWhereInput>>;
    OR?: InputMaybe<Array<HrtPaymentTypeWhereInput>>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    paymentType?: InputMaybe<EnumPaymentTypeFilter>;
};

export type HrtRelationFilter = {
    is?: InputMaybe<HrtWhereInput>;
    isNot?: InputMaybe<HrtWhereInput>;
};

export enum HrtScalarFieldEnum {
    AdditionalResources = 'additionalResources',
    CustomDuration = 'customDuration',
    DisplayMetadata = 'displayMetadata',
    DisplayName = 'displayName',
    EhrPrimaryAppointmentTypeId = 'ehrPrimaryAppointmentTypeId',
    HrtId = 'hrtId',
    IsBookableOnStorefront = 'isBookableOnStorefront',
    IsConsumerFacing = 'isConsumerFacing',
    IsPrimary = 'isPrimary',
    IsPrimaryCandidateSameCpt = 'isPrimaryCandidateSameCpt',
    IsShownOnCompanion = 'isShownOnCompanion',
    Name = 'name',
    OrgId = 'orgId',
    PcDisplayName = 'pcDisplayName',
    Popularity = 'popularity',
}

export type HrtScalarWhereInput = {
    AND?: InputMaybe<Array<HrtScalarWhereInput>>;
    NOT?: InputMaybe<Array<HrtScalarWhereInput>>;
    OR?: InputMaybe<Array<HrtScalarWhereInput>>;
    additionalResources?: InputMaybe<JsonNullableFilter>;
    customDuration?: InputMaybe<IntFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    displayName?: InputMaybe<StringNullableFilter>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<StringNullableListFilter>;
    hrtId?: InputMaybe<IntFilter>;
    isBookableOnStorefront?: InputMaybe<BoolFilter>;
    isConsumerFacing?: InputMaybe<BoolFilter>;
    isPrimary?: InputMaybe<BoolFilter>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFilter>;
    isShownOnCompanion?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    pcDisplayName?: InputMaybe<StringNullableFilter>;
    popularity?: InputMaybe<FloatFilter>;
};

export type HrtScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<HrtScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<HrtScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<HrtScalarWhereWithAggregatesInput>>;
    additionalResources?: InputMaybe<JsonNullableWithAggregatesFilter>;
    customDuration?: InputMaybe<IntWithAggregatesFilter>;
    displayMetadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    displayName?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<StringNullableListFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    isBookableOnStorefront?: InputMaybe<BoolWithAggregatesFilter>;
    isConsumerFacing?: InputMaybe<BoolWithAggregatesFilter>;
    isPrimary?: InputMaybe<BoolWithAggregatesFilter>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolWithAggregatesFilter>;
    isShownOnCompanion?: InputMaybe<BoolWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    pcDisplayName?: InputMaybe<StringNullableWithAggregatesFilter>;
    popularity?: InputMaybe<FloatWithAggregatesFilter>;
};

export type HrtSumAggregate = {
    __typename?: 'HrtSumAggregate';
    customDuration?: Maybe<Scalars['Int']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type HrtSumOrderByAggregateInput = {
    customDuration?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type HrtToSrt = {
    __typename?: 'HrtToSrt';
    createdAt: Scalars['DateTimeISO']['output'];
    hrt: Hrt;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    srt: Srt;
    srtId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type HrtToSrtAvgAggregate = {
    __typename?: 'HrtToSrtAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    srtId?: Maybe<Scalars['Float']['output']>;
};

export type HrtToSrtAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type HrtToSrtCountAggregate = {
    __typename?: 'HrtToSrtCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    srtId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type HrtToSrtCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type HrtToSrtCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutHrtToSrtInput;
    srt: SrtCreateNestedOneWithoutHrtToSrtInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type HrtToSrtCreateManyHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    srtId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type HrtToSrtCreateManyHrtInputEnvelope = {
    data: Array<HrtToSrtCreateManyHrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HrtToSrtCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    srtId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type HrtToSrtCreateManySrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type HrtToSrtCreateManySrtInputEnvelope = {
    data: Array<HrtToSrtCreateManySrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HrtToSrtCreateNestedManyWithoutHrtInput = {
    connect?: InputMaybe<Array<HrtToSrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<HrtToSrtCreateOrConnectWithoutHrtInput>>;
    create?: InputMaybe<Array<HrtToSrtCreateWithoutHrtInput>>;
    createMany?: InputMaybe<HrtToSrtCreateManyHrtInputEnvelope>;
};

export type HrtToSrtCreateNestedManyWithoutSrtInput = {
    connect?: InputMaybe<Array<HrtToSrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<HrtToSrtCreateOrConnectWithoutSrtInput>>;
    create?: InputMaybe<Array<HrtToSrtCreateWithoutSrtInput>>;
    createMany?: InputMaybe<HrtToSrtCreateManySrtInputEnvelope>;
};

export type HrtToSrtCreateOrConnectWithoutHrtInput = {
    create: HrtToSrtCreateWithoutHrtInput;
    where: HrtToSrtWhereUniqueInput;
};

export type HrtToSrtCreateOrConnectWithoutSrtInput = {
    create: HrtToSrtCreateWithoutSrtInput;
    where: HrtToSrtWhereUniqueInput;
};

export type HrtToSrtCreateWithoutHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    srt: SrtCreateNestedOneWithoutHrtToSrtInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type HrtToSrtCreateWithoutSrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutHrtToSrtInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type HrtToSrtGroupBy = {
    __typename?: 'HrtToSrtGroupBy';
    _avg?: Maybe<HrtToSrtAvgAggregate>;
    _count?: Maybe<HrtToSrtCountAggregate>;
    _max?: Maybe<HrtToSrtMaxAggregate>;
    _min?: Maybe<HrtToSrtMinAggregate>;
    _sum?: Maybe<HrtToSrtSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    srtId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type HrtToSrtListRelationFilter = {
    every?: InputMaybe<HrtToSrtWhereInput>;
    none?: InputMaybe<HrtToSrtWhereInput>;
    some?: InputMaybe<HrtToSrtWhereInput>;
};

export type HrtToSrtMaxAggregate = {
    __typename?: 'HrtToSrtMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type HrtToSrtMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type HrtToSrtMinAggregate = {
    __typename?: 'HrtToSrtMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type HrtToSrtMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type HrtToSrtOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type HrtToSrtOrderByWithAggregationInput = {
    _avg?: InputMaybe<HrtToSrtAvgOrderByAggregateInput>;
    _count?: InputMaybe<HrtToSrtCountOrderByAggregateInput>;
    _max?: InputMaybe<HrtToSrtMaxOrderByAggregateInput>;
    _min?: InputMaybe<HrtToSrtMinOrderByAggregateInput>;
    _sum?: InputMaybe<HrtToSrtSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type HrtToSrtOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srt?: InputMaybe<SrtOrderByWithRelationInput>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum HrtToSrtScalarFieldEnum {
    CreatedAt = 'createdAt',
    HrtId = 'hrtId',
    Id = 'id',
    SrtId = 'srtId',
    UpdatedAt = 'updatedAt',
}

export type HrtToSrtScalarWhereInput = {
    AND?: InputMaybe<Array<HrtToSrtScalarWhereInput>>;
    NOT?: InputMaybe<Array<HrtToSrtScalarWhereInput>>;
    OR?: InputMaybe<Array<HrtToSrtScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    srtId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HrtToSrtScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<HrtToSrtScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<HrtToSrtScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<HrtToSrtScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    srtId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type HrtToSrtSumAggregate = {
    __typename?: 'HrtToSrtSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
};

export type HrtToSrtSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type HrtToSrtUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutHrtToSrtNestedInput>;
    srt?: InputMaybe<SrtUpdateOneRequiredWithoutHrtToSrtNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type HrtToSrtUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type HrtToSrtUpdateManyWithWhereWithoutHrtInput = {
    data: HrtToSrtUpdateManyMutationInput;
    where: HrtToSrtScalarWhereInput;
};

export type HrtToSrtUpdateManyWithWhereWithoutSrtInput = {
    data: HrtToSrtUpdateManyMutationInput;
    where: HrtToSrtScalarWhereInput;
};

export type HrtToSrtUpdateManyWithoutHrtNestedInput = {
    connect?: InputMaybe<Array<HrtToSrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<HrtToSrtCreateOrConnectWithoutHrtInput>>;
    create?: InputMaybe<Array<HrtToSrtCreateWithoutHrtInput>>;
    createMany?: InputMaybe<HrtToSrtCreateManyHrtInputEnvelope>;
    delete?: InputMaybe<Array<HrtToSrtWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<HrtToSrtScalarWhereInput>>;
    disconnect?: InputMaybe<Array<HrtToSrtWhereUniqueInput>>;
    set?: InputMaybe<Array<HrtToSrtWhereUniqueInput>>;
    update?: InputMaybe<Array<HrtToSrtUpdateWithWhereUniqueWithoutHrtInput>>;
    updateMany?: InputMaybe<Array<HrtToSrtUpdateManyWithWhereWithoutHrtInput>>;
    upsert?: InputMaybe<Array<HrtToSrtUpsertWithWhereUniqueWithoutHrtInput>>;
};

export type HrtToSrtUpdateManyWithoutSrtNestedInput = {
    connect?: InputMaybe<Array<HrtToSrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<HrtToSrtCreateOrConnectWithoutSrtInput>>;
    create?: InputMaybe<Array<HrtToSrtCreateWithoutSrtInput>>;
    createMany?: InputMaybe<HrtToSrtCreateManySrtInputEnvelope>;
    delete?: InputMaybe<Array<HrtToSrtWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<HrtToSrtScalarWhereInput>>;
    disconnect?: InputMaybe<Array<HrtToSrtWhereUniqueInput>>;
    set?: InputMaybe<Array<HrtToSrtWhereUniqueInput>>;
    update?: InputMaybe<Array<HrtToSrtUpdateWithWhereUniqueWithoutSrtInput>>;
    updateMany?: InputMaybe<Array<HrtToSrtUpdateManyWithWhereWithoutSrtInput>>;
    upsert?: InputMaybe<Array<HrtToSrtUpsertWithWhereUniqueWithoutSrtInput>>;
};

export type HrtToSrtUpdateWithWhereUniqueWithoutHrtInput = {
    data: HrtToSrtUpdateWithoutHrtInput;
    where: HrtToSrtWhereUniqueInput;
};

export type HrtToSrtUpdateWithWhereUniqueWithoutSrtInput = {
    data: HrtToSrtUpdateWithoutSrtInput;
    where: HrtToSrtWhereUniqueInput;
};

export type HrtToSrtUpdateWithoutHrtInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    srt?: InputMaybe<SrtUpdateOneRequiredWithoutHrtToSrtNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type HrtToSrtUpdateWithoutSrtInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutHrtToSrtNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type HrtToSrtUpsertWithWhereUniqueWithoutHrtInput = {
    create: HrtToSrtCreateWithoutHrtInput;
    update: HrtToSrtUpdateWithoutHrtInput;
    where: HrtToSrtWhereUniqueInput;
};

export type HrtToSrtUpsertWithWhereUniqueWithoutSrtInput = {
    create: HrtToSrtCreateWithoutSrtInput;
    update: HrtToSrtUpdateWithoutSrtInput;
    where: HrtToSrtWhereUniqueInput;
};

export type HrtToSrtWhereInput = {
    AND?: InputMaybe<Array<HrtToSrtWhereInput>>;
    NOT?: InputMaybe<Array<HrtToSrtWhereInput>>;
    OR?: InputMaybe<Array<HrtToSrtWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    srt?: InputMaybe<SrtRelationFilter>;
    srtId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HrtToSrtWhereUniqueInput = {
    AND?: InputMaybe<Array<HrtToSrtWhereInput>>;
    NOT?: InputMaybe<Array<HrtToSrtWhereInput>>;
    OR?: InputMaybe<Array<HrtToSrtWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    srt?: InputMaybe<SrtRelationFilter>;
    srtId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type HrtTranslation = {
    __typename?: 'HrtTranslation';
    createdAt: Scalars['DateTimeISO']['output'];
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    displayName: Scalars['String']['output'];
    hrt: Hrt;
    hrtId: Scalars['Int']['output'];
    languageCode: Scalars['String']['output'];
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    warningFlags: Array<Scalars['String']['output']>;
};

export type HrtTranslationAvgAggregate = {
    __typename?: 'HrtTranslationAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
};

export type HrtTranslationAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
};

export type HrtTranslationCountAggregate = {
    __typename?: 'HrtTranslationCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    displayMetadata: Scalars['Int']['output'];
    displayName: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    languageCode: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    warningFlags: Scalars['Int']['output'];
};

export type HrtTranslationCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrder>;
    displayName?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type HrtTranslationCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName: Scalars['String']['input'];
    hrt: HrtCreateNestedOneWithoutHrtTranslationInput;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<HrtTranslationCreatewarningFlagsInput>;
};

export type HrtTranslationCreateManyHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName: Scalars['String']['input'];
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<HrtTranslationCreatewarningFlagsInput>;
};

export type HrtTranslationCreateManyHrtInputEnvelope = {
    data: Array<HrtTranslationCreateManyHrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HrtTranslationCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName: Scalars['String']['input'];
    hrtId: Scalars['Int']['input'];
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<HrtTranslationCreatewarningFlagsInput>;
};

export type HrtTranslationCreateNestedManyWithoutHrtInput = {
    connect?: InputMaybe<Array<HrtTranslationWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<HrtTranslationCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<HrtTranslationCreateWithoutHrtInput>>;
    createMany?: InputMaybe<HrtTranslationCreateManyHrtInputEnvelope>;
};

export type HrtTranslationCreateOrConnectWithoutHrtInput = {
    create: HrtTranslationCreateWithoutHrtInput;
    where: HrtTranslationWhereUniqueInput;
};

export type HrtTranslationCreateWithoutHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName: Scalars['String']['input'];
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<HrtTranslationCreatewarningFlagsInput>;
};

export type HrtTranslationCreatewarningFlagsInput = {
    set: Array<Scalars['String']['input']>;
};

export type HrtTranslationGroupBy = {
    __typename?: 'HrtTranslationGroupBy';
    _avg?: Maybe<HrtTranslationAvgAggregate>;
    _count?: Maybe<HrtTranslationCountAggregate>;
    _max?: Maybe<HrtTranslationMaxAggregate>;
    _min?: Maybe<HrtTranslationMinAggregate>;
    _sum?: Maybe<HrtTranslationSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    displayName: Scalars['String']['output'];
    hrtId: Scalars['Int']['output'];
    languageCode: Scalars['String']['output'];
    name: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    warningFlags?: Maybe<Array<Scalars['String']['output']>>;
};

export type HrtTranslationHrtIdLanguageCodeCompoundUniqueInput = {
    hrtId: Scalars['Int']['input'];
    languageCode: Scalars['String']['input'];
};

export type HrtTranslationListRelationFilter = {
    every?: InputMaybe<HrtTranslationWhereInput>;
    none?: InputMaybe<HrtTranslationWhereInput>;
    some?: InputMaybe<HrtTranslationWhereInput>;
};

export type HrtTranslationMaxAggregate = {
    __typename?: 'HrtTranslationMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type HrtTranslationMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    displayName?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type HrtTranslationMinAggregate = {
    __typename?: 'HrtTranslationMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type HrtTranslationMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    displayName?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type HrtTranslationOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type HrtTranslationOrderByWithAggregationInput = {
    _avg?: InputMaybe<HrtTranslationAvgOrderByAggregateInput>;
    _count?: InputMaybe<HrtTranslationCountOrderByAggregateInput>;
    _max?: InputMaybe<HrtTranslationMaxOrderByAggregateInput>;
    _min?: InputMaybe<HrtTranslationMinOrderByAggregateInput>;
    _sum?: InputMaybe<HrtTranslationSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    displayName?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type HrtTranslationOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    displayName?: InputMaybe<SortOrder>;
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export enum HrtTranslationScalarFieldEnum {
    CreatedAt = 'createdAt',
    DisplayMetadata = 'displayMetadata',
    DisplayName = 'displayName',
    HrtId = 'hrtId',
    LanguageCode = 'languageCode',
    Name = 'name',
    UpdatedAt = 'updatedAt',
    WarningFlags = 'warningFlags',
}

export type HrtTranslationScalarWhereInput = {
    AND?: InputMaybe<Array<HrtTranslationScalarWhereInput>>;
    NOT?: InputMaybe<Array<HrtTranslationScalarWhereInput>>;
    OR?: InputMaybe<Array<HrtTranslationScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    displayName?: InputMaybe<StringFilter>;
    hrtId?: InputMaybe<IntFilter>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type HrtTranslationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<HrtTranslationScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<HrtTranslationScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<HrtTranslationScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    displayMetadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    displayName?: InputMaybe<StringWithAggregatesFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    languageCode?: InputMaybe<StringWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type HrtTranslationSumAggregate = {
    __typename?: 'HrtTranslationSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
};

export type HrtTranslationSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
};

export type HrtTranslationUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutHrtTranslationNestedInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<HrtTranslationUpdatewarningFlagsInput>;
};

export type HrtTranslationUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<HrtTranslationUpdatewarningFlagsInput>;
};

export type HrtTranslationUpdateManyWithWhereWithoutHrtInput = {
    data: HrtTranslationUpdateManyMutationInput;
    where: HrtTranslationScalarWhereInput;
};

export type HrtTranslationUpdateManyWithoutHrtNestedInput = {
    connect?: InputMaybe<Array<HrtTranslationWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<HrtTranslationCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<HrtTranslationCreateWithoutHrtInput>>;
    createMany?: InputMaybe<HrtTranslationCreateManyHrtInputEnvelope>;
    delete?: InputMaybe<Array<HrtTranslationWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<HrtTranslationScalarWhereInput>>;
    disconnect?: InputMaybe<Array<HrtTranslationWhereUniqueInput>>;
    set?: InputMaybe<Array<HrtTranslationWhereUniqueInput>>;
    update?: InputMaybe<
        Array<HrtTranslationUpdateWithWhereUniqueWithoutHrtInput>
    >;
    updateMany?: InputMaybe<
        Array<HrtTranslationUpdateManyWithWhereWithoutHrtInput>
    >;
    upsert?: InputMaybe<
        Array<HrtTranslationUpsertWithWhereUniqueWithoutHrtInput>
    >;
};

export type HrtTranslationUpdateWithWhereUniqueWithoutHrtInput = {
    data: HrtTranslationUpdateWithoutHrtInput;
    where: HrtTranslationWhereUniqueInput;
};

export type HrtTranslationUpdateWithoutHrtInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<HrtTranslationUpdatewarningFlagsInput>;
};

export type HrtTranslationUpdatewarningFlagsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type HrtTranslationUpsertWithWhereUniqueWithoutHrtInput = {
    create: HrtTranslationCreateWithoutHrtInput;
    update: HrtTranslationUpdateWithoutHrtInput;
    where: HrtTranslationWhereUniqueInput;
};

export type HrtTranslationWhereInput = {
    AND?: InputMaybe<Array<HrtTranslationWhereInput>>;
    NOT?: InputMaybe<Array<HrtTranslationWhereInput>>;
    OR?: InputMaybe<Array<HrtTranslationWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    displayName?: InputMaybe<StringFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type HrtTranslationWhereUniqueInput = {
    AND?: InputMaybe<Array<HrtTranslationWhereInput>>;
    NOT?: InputMaybe<Array<HrtTranslationWhereInput>>;
    OR?: InputMaybe<Array<HrtTranslationWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    displayName?: InputMaybe<StringFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    hrtId_languageCode?: InputMaybe<HrtTranslationHrtIdLanguageCodeCompoundUniqueInput>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type HrtUpdateInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateManyMutationInput = {
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type HrtUpdateManyWithWhereWithoutOrgInput = {
    data: HrtUpdateManyMutationInput;
    where: HrtScalarWhereInput;
};

export type HrtUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<HrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<HrtCreateOrConnectWithoutOrgInput>>;
    create?: InputMaybe<Array<HrtCreateWithoutOrgInput>>;
    createMany?: InputMaybe<HrtCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<HrtWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<HrtScalarWhereInput>>;
    disconnect?: InputMaybe<Array<HrtWhereUniqueInput>>;
    set?: InputMaybe<Array<HrtWhereUniqueInput>>;
    update?: InputMaybe<Array<HrtUpdateWithWhereUniqueWithoutOrgInput>>;
    updateMany?: InputMaybe<Array<HrtUpdateManyWithWhereWithoutOrgInput>>;
    upsert?: InputMaybe<Array<HrtUpsertWithWhereUniqueWithoutOrgInput>>;
};

export type HrtUpdateOneRequiredWithoutBundleToHrtNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutBundleToHrtInput>;
    create?: InputMaybe<HrtCreateWithoutBundleToHrtInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutBundleToHrtInput>;
    upsert?: InputMaybe<HrtUpsertWithoutBundleToHrtInput>;
};

export type HrtUpdateOneRequiredWithoutCashPricesNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutCashPricesInput>;
    create?: InputMaybe<HrtCreateWithoutCashPricesInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutCashPricesInput>;
    upsert?: InputMaybe<HrtUpsertWithoutCashPricesInput>;
};

export type HrtUpdateOneRequiredWithoutHrtFlagsNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutHrtFlagsInput>;
    create?: InputMaybe<HrtCreateWithoutHrtFlagsInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutHrtFlagsInput>;
    upsert?: InputMaybe<HrtUpsertWithoutHrtFlagsInput>;
};

export type HrtUpdateOneRequiredWithoutHrtPaymentTypeNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutHrtPaymentTypeInput>;
    create?: InputMaybe<HrtCreateWithoutHrtPaymentTypeInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutHrtPaymentTypeInput>;
    upsert?: InputMaybe<HrtUpsertWithoutHrtPaymentTypeInput>;
};

export type HrtUpdateOneRequiredWithoutHrtToSrtNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutHrtToSrtInput>;
    create?: InputMaybe<HrtCreateWithoutHrtToSrtInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutHrtToSrtInput>;
    upsert?: InputMaybe<HrtUpsertWithoutHrtToSrtInput>;
};

export type HrtUpdateOneRequiredWithoutHrtTranslationNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutHrtTranslationInput>;
    create?: InputMaybe<HrtCreateWithoutHrtTranslationInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutHrtTranslationInput>;
    upsert?: InputMaybe<HrtUpsertWithoutHrtTranslationInput>;
};

export type HrtUpdateOneRequiredWithoutPricedTreatmentNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutPricedTreatmentInput>;
    create?: InputMaybe<HrtCreateWithoutPricedTreatmentInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutPricedTreatmentInput>;
    upsert?: InputMaybe<HrtUpsertWithoutPricedTreatmentInput>;
};

export type HrtUpdateOneRequiredWithoutPricingAttemptNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutPricingAttemptInput>;
    create?: InputMaybe<HrtCreateWithoutPricingAttemptInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutPricingAttemptInput>;
    upsert?: InputMaybe<HrtUpsertWithoutPricingAttemptInput>;
};

export type HrtUpdateOneRequiredWithoutProductToHrtNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutProductToHrtInput>;
    create?: InputMaybe<HrtCreateWithoutProductToHrtInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutProductToHrtInput>;
    upsert?: InputMaybe<HrtUpsertWithoutProductToHrtInput>;
};

export type HrtUpdateOneRequiredWithoutProviderGroupToHrtNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutProviderGroupToHrtInput>;
    create?: InputMaybe<HrtCreateWithoutProviderGroupToHrtInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutProviderGroupToHrtInput>;
    upsert?: InputMaybe<HrtUpsertWithoutProviderGroupToHrtInput>;
};

export type HrtUpdateOneWithoutProviderHrtMaxCountNestedInput = {
    connect?: InputMaybe<HrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<HrtCreateOrConnectWithoutProviderHrtMaxCountInput>;
    create?: InputMaybe<HrtCreateWithoutProviderHrtMaxCountInput>;
    delete?: InputMaybe<HrtWhereInput>;
    disconnect?: InputMaybe<HrtWhereInput>;
    update?: InputMaybe<HrtUpdateToOneWithWhereWithoutProviderHrtMaxCountInput>;
    upsert?: InputMaybe<HrtUpsertWithoutProviderHrtMaxCountInput>;
};

export type HrtUpdateToOneWithWhereWithoutBundleToHrtInput = {
    data: HrtUpdateWithoutBundleToHrtInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateToOneWithWhereWithoutCashPricesInput = {
    data: HrtUpdateWithoutCashPricesInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateToOneWithWhereWithoutHrtFlagsInput = {
    data: HrtUpdateWithoutHrtFlagsInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateToOneWithWhereWithoutHrtPaymentTypeInput = {
    data: HrtUpdateWithoutHrtPaymentTypeInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateToOneWithWhereWithoutHrtToSrtInput = {
    data: HrtUpdateWithoutHrtToSrtInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateToOneWithWhereWithoutHrtTranslationInput = {
    data: HrtUpdateWithoutHrtTranslationInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateToOneWithWhereWithoutPricedTreatmentInput = {
    data: HrtUpdateWithoutPricedTreatmentInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateToOneWithWhereWithoutPricingAttemptInput = {
    data: HrtUpdateWithoutPricingAttemptInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateToOneWithWhereWithoutProductToHrtInput = {
    data: HrtUpdateWithoutProductToHrtInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateToOneWithWhereWithoutProviderGroupToHrtInput = {
    data: HrtUpdateWithoutProviderGroupToHrtInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateToOneWithWhereWithoutProviderHrtMaxCountInput = {
    data: HrtUpdateWithoutProviderHrtMaxCountInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpdateWithWhereUniqueWithoutOrgInput = {
    data: HrtUpdateWithoutOrgInput;
    where: HrtWhereUniqueInput;
};

export type HrtUpdateWithoutBundleToHrtInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutCashPricesInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutHrtFlagsInput = {
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutHrtPaymentTypeInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutHrtToSrtInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutHrtTranslationInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutOrgInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutPricedTreatmentInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutPricingAttemptInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutProductToHrtInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutProviderGroupToHrtInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateWithoutProviderHrtMaxCountInput = {
    HrtFlags?: InputMaybe<HrtFlagsUpdateManyWithoutHrtNestedInput>;
    HrtTranslation?: InputMaybe<HrtTranslationUpdateManyWithoutHrtNestedInput>;
    PricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutHrtNestedInput>;
    additionalResources?: InputMaybe<Scalars['JSON']['input']>;
    bundleToHrt?: InputMaybe<BundleToHrtUpdateManyWithoutHrtNestedInput>;
    cash_prices?: InputMaybe<CashPriceUpdateOneWithoutHrtNestedInput>;
    customDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<HrtUpdateehrPrimaryAppointmentTypeIdInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeUpdateManyWithoutHrtNestedInput>;
    hrtToSrt?: InputMaybe<HrtToSrtUpdateManyWithoutHrtNestedInput>;
    isBookableOnStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isConsumerFacing?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isShownOnCompanion?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutHrtNestedInput>;
    pcDisplayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutHrtNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutHrtNestedInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutHrtNestedInput>;
};

export type HrtUpdateehrPrimaryAppointmentTypeIdInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type HrtUpsertWithWhereUniqueWithoutOrgInput = {
    create: HrtCreateWithoutOrgInput;
    update: HrtUpdateWithoutOrgInput;
    where: HrtWhereUniqueInput;
};

export type HrtUpsertWithoutBundleToHrtInput = {
    create: HrtCreateWithoutBundleToHrtInput;
    update: HrtUpdateWithoutBundleToHrtInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpsertWithoutCashPricesInput = {
    create: HrtCreateWithoutCashPricesInput;
    update: HrtUpdateWithoutCashPricesInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpsertWithoutHrtFlagsInput = {
    create: HrtCreateWithoutHrtFlagsInput;
    update: HrtUpdateWithoutHrtFlagsInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpsertWithoutHrtPaymentTypeInput = {
    create: HrtCreateWithoutHrtPaymentTypeInput;
    update: HrtUpdateWithoutHrtPaymentTypeInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpsertWithoutHrtToSrtInput = {
    create: HrtCreateWithoutHrtToSrtInput;
    update: HrtUpdateWithoutHrtToSrtInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpsertWithoutHrtTranslationInput = {
    create: HrtCreateWithoutHrtTranslationInput;
    update: HrtUpdateWithoutHrtTranslationInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpsertWithoutPricedTreatmentInput = {
    create: HrtCreateWithoutPricedTreatmentInput;
    update: HrtUpdateWithoutPricedTreatmentInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpsertWithoutPricingAttemptInput = {
    create: HrtCreateWithoutPricingAttemptInput;
    update: HrtUpdateWithoutPricingAttemptInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpsertWithoutProductToHrtInput = {
    create: HrtCreateWithoutProductToHrtInput;
    update: HrtUpdateWithoutProductToHrtInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpsertWithoutProviderGroupToHrtInput = {
    create: HrtCreateWithoutProviderGroupToHrtInput;
    update: HrtUpdateWithoutProviderGroupToHrtInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtUpsertWithoutProviderHrtMaxCountInput = {
    create: HrtCreateWithoutProviderHrtMaxCountInput;
    update: HrtUpdateWithoutProviderHrtMaxCountInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type HrtWhereInput = {
    AND?: InputMaybe<Array<HrtWhereInput>>;
    HrtFlags?: InputMaybe<HrtFlagsListRelationFilter>;
    HrtTranslation?: InputMaybe<HrtTranslationListRelationFilter>;
    NOT?: InputMaybe<Array<HrtWhereInput>>;
    OR?: InputMaybe<Array<HrtWhereInput>>;
    PricedTreatment?: InputMaybe<PricedTreatmentListRelationFilter>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountListRelationFilter>;
    additionalResources?: InputMaybe<JsonNullableFilter>;
    bundleToHrt?: InputMaybe<BundleToHrtListRelationFilter>;
    cash_prices?: InputMaybe<CashPriceNullableRelationFilter>;
    customDuration?: InputMaybe<IntFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    displayName?: InputMaybe<StringNullableFilter>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<StringNullableListFilter>;
    hrtId?: InputMaybe<IntFilter>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeListRelationFilter>;
    hrtToSrt?: InputMaybe<HrtToSrtListRelationFilter>;
    isBookableOnStorefront?: InputMaybe<BoolFilter>;
    isConsumerFacing?: InputMaybe<BoolFilter>;
    isPrimary?: InputMaybe<BoolFilter>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFilter>;
    isShownOnCompanion?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    pcDisplayName?: InputMaybe<StringNullableFilter>;
    popularity?: InputMaybe<FloatFilter>;
    pricingAttempt?: InputMaybe<PricingAttemptListRelationFilter>;
    productToHrt?: InputMaybe<ProductToHrtListRelationFilter>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtListRelationFilter>;
};

export type HrtWhereUniqueInput = {
    AND?: InputMaybe<Array<HrtWhereInput>>;
    HrtFlags?: InputMaybe<HrtFlagsListRelationFilter>;
    HrtTranslation?: InputMaybe<HrtTranslationListRelationFilter>;
    NOT?: InputMaybe<Array<HrtWhereInput>>;
    OR?: InputMaybe<Array<HrtWhereInput>>;
    PricedTreatment?: InputMaybe<PricedTreatmentListRelationFilter>;
    ProviderHrtMaxCount?: InputMaybe<ProviderHrtMaxCountListRelationFilter>;
    additionalResources?: InputMaybe<JsonNullableFilter>;
    bundleToHrt?: InputMaybe<BundleToHrtListRelationFilter>;
    cash_prices?: InputMaybe<CashPriceNullableRelationFilter>;
    customDuration?: InputMaybe<IntFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    displayName?: InputMaybe<StringNullableFilter>;
    ehrPrimaryAppointmentTypeId?: InputMaybe<StringNullableListFilter>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    hrtPaymentType?: InputMaybe<HrtPaymentTypeListRelationFilter>;
    hrtToSrt?: InputMaybe<HrtToSrtListRelationFilter>;
    isBookableOnStorefront?: InputMaybe<BoolFilter>;
    isConsumerFacing?: InputMaybe<BoolFilter>;
    isPrimary?: InputMaybe<BoolFilter>;
    isPrimaryCandidateSameCpt?: InputMaybe<BoolFilter>;
    isShownOnCompanion?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    pcDisplayName?: InputMaybe<StringNullableFilter>;
    popularity?: InputMaybe<FloatFilter>;
    pricingAttempt?: InputMaybe<PricingAttemptListRelationFilter>;
    productToHrt?: InputMaybe<ProductToHrtListRelationFilter>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtListRelationFilter>;
};

export enum IntakeQuestionType {
    Address = 'ADDRESS',
    Checkbox = 'CHECKBOX',
    ClinicalProvider = 'CLINICAL_PROVIDER',
    Date = 'DATE',
    Email = 'EMAIL',
    Image = 'IMAGE',
    List = 'LIST',
    LongText = 'LONG_TEXT',
    MultiSelect = 'MULTI_SELECT',
    PhoneNumber = 'PHONE_NUMBER',
    Signature = 'SIGNATURE',
    SingleSelect = 'SINGLE_SELECT',
    Text = 'TEXT',
}

export type InboundRequestLog = {
    __typename?: 'InboundRequestLog';
    actionType?: Maybe<Scalars['String']['output']>;
    attemptCount: Scalars['Int']['output'];
    correlationId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    endpoint: Scalars['String']['output'];
    errorMessage?: Maybe<Scalars['String']['output']>;
    executedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    metadata?: Maybe<Scalars['JSON']['output']>;
    method: Scalars['String']['output'];
    requestHeaders?: Maybe<Scalars['JSON']['output']>;
    requestPayload?: Maybe<Scalars['JSON']['output']>;
    responsePayload?: Maybe<Scalars['JSON']['output']>;
    status: InboundRequestLogStatus;
    statusCode?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type InboundRequestLogAvgAggregate = {
    __typename?: 'InboundRequestLogAvgAggregate';
    attemptCount?: Maybe<Scalars['Float']['output']>;
    statusCode?: Maybe<Scalars['Float']['output']>;
};

export type InboundRequestLogAvgOrderByAggregateInput = {
    attemptCount?: InputMaybe<SortOrder>;
    statusCode?: InputMaybe<SortOrder>;
};

export type InboundRequestLogCountAggregate = {
    __typename?: 'InboundRequestLogCountAggregate';
    _all: Scalars['Int']['output'];
    actionType: Scalars['Int']['output'];
    attemptCount: Scalars['Int']['output'];
    correlationId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    endpoint: Scalars['Int']['output'];
    errorMessage: Scalars['Int']['output'];
    executedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    metadata: Scalars['Int']['output'];
    method: Scalars['Int']['output'];
    requestHeaders: Scalars['Int']['output'];
    requestPayload: Scalars['Int']['output'];
    responsePayload: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    statusCode: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type InboundRequestLogCountOrderByAggregateInput = {
    actionType?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    correlationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    endpoint?: InputMaybe<SortOrder>;
    errorMessage?: InputMaybe<SortOrder>;
    executedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    method?: InputMaybe<SortOrder>;
    requestHeaders?: InputMaybe<SortOrder>;
    requestPayload?: InputMaybe<SortOrder>;
    responsePayload?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusCode?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InboundRequestLogCreateInput = {
    actionType?: InputMaybe<Scalars['String']['input']>;
    attemptCount?: InputMaybe<Scalars['Int']['input']>;
    correlationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    endpoint: Scalars['String']['input'];
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    executedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    method: Scalars['String']['input'];
    requestHeaders?: InputMaybe<Scalars['JSON']['input']>;
    requestPayload?: InputMaybe<Scalars['JSON']['input']>;
    responsePayload?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<InboundRequestLogStatus>;
    statusCode?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InboundRequestLogCreateManyInput = {
    actionType?: InputMaybe<Scalars['String']['input']>;
    attemptCount?: InputMaybe<Scalars['Int']['input']>;
    correlationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    endpoint: Scalars['String']['input'];
    errorMessage?: InputMaybe<Scalars['String']['input']>;
    executedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    method: Scalars['String']['input'];
    requestHeaders?: InputMaybe<Scalars['JSON']['input']>;
    requestPayload?: InputMaybe<Scalars['JSON']['input']>;
    responsePayload?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<InboundRequestLogStatus>;
    statusCode?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InboundRequestLogGroupBy = {
    __typename?: 'InboundRequestLogGroupBy';
    _avg?: Maybe<InboundRequestLogAvgAggregate>;
    _count?: Maybe<InboundRequestLogCountAggregate>;
    _max?: Maybe<InboundRequestLogMaxAggregate>;
    _min?: Maybe<InboundRequestLogMinAggregate>;
    _sum?: Maybe<InboundRequestLogSumAggregate>;
    actionType?: Maybe<Scalars['String']['output']>;
    attemptCount: Scalars['Int']['output'];
    correlationId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    endpoint: Scalars['String']['output'];
    errorMessage?: Maybe<Scalars['String']['output']>;
    executedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    metadata?: Maybe<Scalars['JSON']['output']>;
    method: Scalars['String']['output'];
    requestHeaders?: Maybe<Scalars['JSON']['output']>;
    requestPayload?: Maybe<Scalars['JSON']['output']>;
    responsePayload?: Maybe<Scalars['JSON']['output']>;
    status: InboundRequestLogStatus;
    statusCode?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type InboundRequestLogMaxAggregate = {
    __typename?: 'InboundRequestLogMaxAggregate';
    actionType?: Maybe<Scalars['String']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
    correlationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    endpoint?: Maybe<Scalars['String']['output']>;
    errorMessage?: Maybe<Scalars['String']['output']>;
    executedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    method?: Maybe<Scalars['String']['output']>;
    status?: Maybe<InboundRequestLogStatus>;
    statusCode?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type InboundRequestLogMaxOrderByAggregateInput = {
    actionType?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    correlationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    endpoint?: InputMaybe<SortOrder>;
    errorMessage?: InputMaybe<SortOrder>;
    executedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    method?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusCode?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InboundRequestLogMinAggregate = {
    __typename?: 'InboundRequestLogMinAggregate';
    actionType?: Maybe<Scalars['String']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
    correlationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    endpoint?: Maybe<Scalars['String']['output']>;
    errorMessage?: Maybe<Scalars['String']['output']>;
    executedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    method?: Maybe<Scalars['String']['output']>;
    status?: Maybe<InboundRequestLogStatus>;
    statusCode?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type InboundRequestLogMinOrderByAggregateInput = {
    actionType?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    correlationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    endpoint?: InputMaybe<SortOrder>;
    errorMessage?: InputMaybe<SortOrder>;
    executedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    method?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    statusCode?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InboundRequestLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<InboundRequestLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<InboundRequestLogCountOrderByAggregateInput>;
    _max?: InputMaybe<InboundRequestLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<InboundRequestLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<InboundRequestLogSumOrderByAggregateInput>;
    actionType?: InputMaybe<SortOrderInput>;
    attemptCount?: InputMaybe<SortOrder>;
    correlationId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    endpoint?: InputMaybe<SortOrder>;
    errorMessage?: InputMaybe<SortOrderInput>;
    executedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrderInput>;
    method?: InputMaybe<SortOrder>;
    requestHeaders?: InputMaybe<SortOrderInput>;
    requestPayload?: InputMaybe<SortOrderInput>;
    responsePayload?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    statusCode?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InboundRequestLogOrderByWithRelationInput = {
    actionType?: InputMaybe<SortOrderInput>;
    attemptCount?: InputMaybe<SortOrder>;
    correlationId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    endpoint?: InputMaybe<SortOrder>;
    errorMessage?: InputMaybe<SortOrderInput>;
    executedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrderInput>;
    method?: InputMaybe<SortOrder>;
    requestHeaders?: InputMaybe<SortOrderInput>;
    requestPayload?: InputMaybe<SortOrderInput>;
    responsePayload?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    statusCode?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum InboundRequestLogScalarFieldEnum {
    ActionType = 'actionType',
    AttemptCount = 'attemptCount',
    CorrelationId = 'correlationId',
    CreatedAt = 'createdAt',
    Endpoint = 'endpoint',
    ErrorMessage = 'errorMessage',
    ExecutedAt = 'executedAt',
    Id = 'id',
    Metadata = 'metadata',
    Method = 'method',
    RequestHeaders = 'requestHeaders',
    RequestPayload = 'requestPayload',
    ResponsePayload = 'responsePayload',
    Status = 'status',
    StatusCode = 'statusCode',
    UpdatedAt = 'updatedAt',
}

export type InboundRequestLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<InboundRequestLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<InboundRequestLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<InboundRequestLogScalarWhereWithAggregatesInput>>;
    actionType?: InputMaybe<StringNullableWithAggregatesFilter>;
    attemptCount?: InputMaybe<IntWithAggregatesFilter>;
    correlationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    endpoint?: InputMaybe<StringWithAggregatesFilter>;
    errorMessage?: InputMaybe<StringNullableWithAggregatesFilter>;
    executedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    method?: InputMaybe<StringWithAggregatesFilter>;
    requestHeaders?: InputMaybe<JsonNullableWithAggregatesFilter>;
    requestPayload?: InputMaybe<JsonNullableWithAggregatesFilter>;
    responsePayload?: InputMaybe<JsonNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumInboundRequestLogStatusWithAggregatesFilter>;
    statusCode?: InputMaybe<IntNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum InboundRequestLogStatus {
    Cancelled = 'CANCELLED',
    Completed = 'COMPLETED',
    Failed = 'FAILED',
    Pending = 'PENDING',
    Running = 'RUNNING',
}

export type InboundRequestLogSumAggregate = {
    __typename?: 'InboundRequestLogSumAggregate';
    attemptCount?: Maybe<Scalars['Int']['output']>;
    statusCode?: Maybe<Scalars['Int']['output']>;
};

export type InboundRequestLogSumOrderByAggregateInput = {
    attemptCount?: InputMaybe<SortOrder>;
    statusCode?: InputMaybe<SortOrder>;
};

export type InboundRequestLogUpdateInput = {
    actionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    attemptCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    correlationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    endpoint?: InputMaybe<StringFieldUpdateOperationsInput>;
    errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    executedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    method?: InputMaybe<StringFieldUpdateOperationsInput>;
    requestHeaders?: InputMaybe<Scalars['JSON']['input']>;
    requestPayload?: InputMaybe<Scalars['JSON']['input']>;
    responsePayload?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<EnumInboundRequestLogStatusFieldUpdateOperationsInput>;
    statusCode?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InboundRequestLogUpdateManyMutationInput = {
    actionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    attemptCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    correlationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    endpoint?: InputMaybe<StringFieldUpdateOperationsInput>;
    errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    executedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    method?: InputMaybe<StringFieldUpdateOperationsInput>;
    requestHeaders?: InputMaybe<Scalars['JSON']['input']>;
    requestPayload?: InputMaybe<Scalars['JSON']['input']>;
    responsePayload?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<EnumInboundRequestLogStatusFieldUpdateOperationsInput>;
    statusCode?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InboundRequestLogWhereInput = {
    AND?: InputMaybe<Array<InboundRequestLogWhereInput>>;
    NOT?: InputMaybe<Array<InboundRequestLogWhereInput>>;
    OR?: InputMaybe<Array<InboundRequestLogWhereInput>>;
    actionType?: InputMaybe<StringNullableFilter>;
    attemptCount?: InputMaybe<IntFilter>;
    correlationId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    endpoint?: InputMaybe<StringFilter>;
    errorMessage?: InputMaybe<StringNullableFilter>;
    executedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    method?: InputMaybe<StringFilter>;
    requestHeaders?: InputMaybe<JsonNullableFilter>;
    requestPayload?: InputMaybe<JsonNullableFilter>;
    responsePayload?: InputMaybe<JsonNullableFilter>;
    status?: InputMaybe<EnumInboundRequestLogStatusFilter>;
    statusCode?: InputMaybe<IntNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InboundRequestLogWhereUniqueInput = {
    AND?: InputMaybe<Array<InboundRequestLogWhereInput>>;
    NOT?: InputMaybe<Array<InboundRequestLogWhereInput>>;
    OR?: InputMaybe<Array<InboundRequestLogWhereInput>>;
    actionType?: InputMaybe<StringNullableFilter>;
    attemptCount?: InputMaybe<IntFilter>;
    correlationId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    endpoint?: InputMaybe<StringFilter>;
    errorMessage?: InputMaybe<StringNullableFilter>;
    executedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    metadata?: InputMaybe<JsonNullableFilter>;
    method?: InputMaybe<StringFilter>;
    requestHeaders?: InputMaybe<JsonNullableFilter>;
    requestPayload?: InputMaybe<JsonNullableFilter>;
    responsePayload?: InputMaybe<JsonNullableFilter>;
    status?: InputMaybe<EnumInboundRequestLogStatusFilter>;
    statusCode?: InputMaybe<IntNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InboundTextMessageLog = {
    __typename?: 'InboundTextMessageLog';
    body: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    from: Scalars['String']['output'];
    messageSid: Scalars['String']['output'];
    messagingServiceSid?: Maybe<Scalars['String']['output']>;
    to: Scalars['String']['output'];
};

export type InboundTextMessageLogCountAggregate = {
    __typename?: 'InboundTextMessageLogCountAggregate';
    _all: Scalars['Int']['output'];
    body: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    from: Scalars['Int']['output'];
    messageSid: Scalars['Int']['output'];
    messagingServiceSid: Scalars['Int']['output'];
    to: Scalars['Int']['output'];
};

export type InboundTextMessageLogCountOrderByAggregateInput = {
    body?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    from?: InputMaybe<SortOrder>;
    messageSid?: InputMaybe<SortOrder>;
    messagingServiceSid?: InputMaybe<SortOrder>;
    to?: InputMaybe<SortOrder>;
};

export type InboundTextMessageLogCreateInput = {
    body: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    from: Scalars['String']['input'];
    messageSid: Scalars['String']['input'];
    messagingServiceSid?: InputMaybe<Scalars['String']['input']>;
    to: Scalars['String']['input'];
};

export type InboundTextMessageLogCreateManyInput = {
    body: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    from: Scalars['String']['input'];
    messageSid: Scalars['String']['input'];
    messagingServiceSid?: InputMaybe<Scalars['String']['input']>;
    to: Scalars['String']['input'];
};

export type InboundTextMessageLogGroupBy = {
    __typename?: 'InboundTextMessageLogGroupBy';
    _count?: Maybe<InboundTextMessageLogCountAggregate>;
    _max?: Maybe<InboundTextMessageLogMaxAggregate>;
    _min?: Maybe<InboundTextMessageLogMinAggregate>;
    body: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    from: Scalars['String']['output'];
    messageSid: Scalars['String']['output'];
    messagingServiceSid?: Maybe<Scalars['String']['output']>;
    to: Scalars['String']['output'];
};

export type InboundTextMessageLogMaxAggregate = {
    __typename?: 'InboundTextMessageLogMaxAggregate';
    body?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    from?: Maybe<Scalars['String']['output']>;
    messageSid?: Maybe<Scalars['String']['output']>;
    messagingServiceSid?: Maybe<Scalars['String']['output']>;
    to?: Maybe<Scalars['String']['output']>;
};

export type InboundTextMessageLogMaxOrderByAggregateInput = {
    body?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    from?: InputMaybe<SortOrder>;
    messageSid?: InputMaybe<SortOrder>;
    messagingServiceSid?: InputMaybe<SortOrder>;
    to?: InputMaybe<SortOrder>;
};

export type InboundTextMessageLogMinAggregate = {
    __typename?: 'InboundTextMessageLogMinAggregate';
    body?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    from?: Maybe<Scalars['String']['output']>;
    messageSid?: Maybe<Scalars['String']['output']>;
    messagingServiceSid?: Maybe<Scalars['String']['output']>;
    to?: Maybe<Scalars['String']['output']>;
};

export type InboundTextMessageLogMinOrderByAggregateInput = {
    body?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    from?: InputMaybe<SortOrder>;
    messageSid?: InputMaybe<SortOrder>;
    messagingServiceSid?: InputMaybe<SortOrder>;
    to?: InputMaybe<SortOrder>;
};

export type InboundTextMessageLogOrderByWithAggregationInput = {
    _count?: InputMaybe<InboundTextMessageLogCountOrderByAggregateInput>;
    _max?: InputMaybe<InboundTextMessageLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<InboundTextMessageLogMinOrderByAggregateInput>;
    body?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    from?: InputMaybe<SortOrder>;
    messageSid?: InputMaybe<SortOrder>;
    messagingServiceSid?: InputMaybe<SortOrderInput>;
    to?: InputMaybe<SortOrder>;
};

export type InboundTextMessageLogOrderByWithRelationInput = {
    body?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    from?: InputMaybe<SortOrder>;
    messageSid?: InputMaybe<SortOrder>;
    messagingServiceSid?: InputMaybe<SortOrderInput>;
    to?: InputMaybe<SortOrder>;
};

export enum InboundTextMessageLogScalarFieldEnum {
    Body = 'body',
    CreatedAt = 'createdAt',
    From = 'from',
    MessageSid = 'messageSid',
    MessagingServiceSid = 'messagingServiceSid',
    To = 'to',
}

export type InboundTextMessageLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<InboundTextMessageLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<InboundTextMessageLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<InboundTextMessageLogScalarWhereWithAggregatesInput>>;
    body?: InputMaybe<StringWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    from?: InputMaybe<StringWithAggregatesFilter>;
    messageSid?: InputMaybe<StringWithAggregatesFilter>;
    messagingServiceSid?: InputMaybe<StringNullableWithAggregatesFilter>;
    to?: InputMaybe<StringWithAggregatesFilter>;
};

export type InboundTextMessageLogUpdateInput = {
    body?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    from?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageSid?: InputMaybe<StringFieldUpdateOperationsInput>;
    messagingServiceSid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    to?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type InboundTextMessageLogUpdateManyMutationInput = {
    body?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    from?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageSid?: InputMaybe<StringFieldUpdateOperationsInput>;
    messagingServiceSid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    to?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type InboundTextMessageLogWhereInput = {
    AND?: InputMaybe<Array<InboundTextMessageLogWhereInput>>;
    NOT?: InputMaybe<Array<InboundTextMessageLogWhereInput>>;
    OR?: InputMaybe<Array<InboundTextMessageLogWhereInput>>;
    body?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    from?: InputMaybe<StringFilter>;
    messageSid?: InputMaybe<StringFilter>;
    messagingServiceSid?: InputMaybe<StringNullableFilter>;
    to?: InputMaybe<StringFilter>;
};

export type InboundTextMessageLogWhereUniqueInput = {
    AND?: InputMaybe<Array<InboundTextMessageLogWhereInput>>;
    NOT?: InputMaybe<Array<InboundTextMessageLogWhereInput>>;
    OR?: InputMaybe<Array<InboundTextMessageLogWhereInput>>;
    body?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    from?: InputMaybe<StringFilter>;
    messageSid?: InputMaybe<Scalars['String']['input']>;
    messagingServiceSid?: InputMaybe<StringNullableFilter>;
    to?: InputMaybe<StringFilter>;
};

export type Insurance = {
    __typename?: 'Insurance';
    _count?: Maybe<InsuranceCount>;
    consumer?: Maybe<Consumer>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance: Scalars['Boolean']['output'];
    lastCheckedAt: Scalars['DateTimeISO']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId: Scalars['String']['output'];
    otherInsurances?: Maybe<Scalars['JSON']['output']>;
    payer: Scalars['String']['output'];
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    photos: Array<ConsumerPhotoMetaData>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status: InsurancesStatusEnum;
    subscriberInfo?: Maybe<Scalars['JSON']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type InsuranceConsumerArgs = {
    where?: InputMaybe<ConsumerWhereInput>;
};

export type InsurancePhotosArgs = {
    cursor?: InputMaybe<ConsumerPhotoMetaDataWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerPhotoMetaDataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerPhotoMetaDataOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export enum InsuranceAccountStatus {
    AdminCreated = 'ADMIN_CREATED',
    Connected = 'CONNECTED',
    Deleted = 'DELETED',
    Replaced = 'REPLACED',
}

export type InsuranceAuditLog = {
    __typename?: 'InsuranceAuditLog';
    consumerId?: Maybe<Scalars['String']['output']>;
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuranceId?: Maybe<Scalars['String']['output']>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    otherInsurances?: Maybe<Scalars['JSON']['output']>;
    payer?: Maybe<Scalars['String']['output']>;
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status?: Maybe<InsurancesStatusEnum>;
    subscriberInfo?: Maybe<Scalars['JSON']['output']>;
};

export type InsuranceAuditLogAvgAggregate = {
    __typename?: 'InsuranceAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    pcpCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Float']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Float']['output']>;
};

export type InsuranceAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrder>;
    pcpCopayAmount?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrder>;
    specialistCopayAmount?: InputMaybe<SortOrder>;
};

export type InsuranceAuditLogCountAggregate = {
    __typename?: 'InsuranceAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    ehrInsuranceId: Scalars['Int']['output'];
    ehrInsurancePackageId: Scalars['Int']['output'];
    groupNumber: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    insuranceAccountStatus: Scalars['Int']['output'];
    insuranceId: Scalars['Int']['output'];
    insuredDob: Scalars['Int']['output'];
    insuredFirstName: Scalars['Int']['output'];
    insuredLastName: Scalars['Int']['output'];
    insuredRelationshipCode: Scalars['Int']['output'];
    isPrimaryInsurance: Scalars['Int']['output'];
    lastUpdatedAt: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    memberId: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    otherInsurances: Scalars['Int']['output'];
    payer: Scalars['Int']['output'];
    pcpCoinsurancePercentage: Scalars['Int']['output'];
    pcpCopayAmount: Scalars['Int']['output'];
    pcpName: Scalars['Int']['output'];
    planEndDate: Scalars['Int']['output'];
    planName: Scalars['Int']['output'];
    planStartDate: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    specialistCoinsurancePercentage: Scalars['Int']['output'];
    specialistCopayAmount: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    subscriberInfo: Scalars['Int']['output'];
};

export type InsuranceAuditLogCountOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    groupNumber?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceAccountStatus?: InputMaybe<SortOrder>;
    insuranceId?: InputMaybe<SortOrder>;
    insuredDob?: InputMaybe<SortOrder>;
    insuredFirstName?: InputMaybe<SortOrder>;
    insuredLastName?: InputMaybe<SortOrder>;
    insuredRelationshipCode?: InputMaybe<SortOrder>;
    isPrimaryInsurance?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    memberId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    otherInsurances?: InputMaybe<SortOrder>;
    payer?: InputMaybe<SortOrder>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrder>;
    pcpCopayAmount?: InputMaybe<SortOrder>;
    pcpName?: InputMaybe<SortOrder>;
    planEndDate?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    planStartDate?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrder>;
    specialistCopayAmount?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    subscriberInfo?: InputMaybe<SortOrder>;
};

export type InsuranceAuditLogCreateInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    ehrInsuranceId?: InputMaybe<Scalars['String']['input']>;
    ehrInsurancePackageId?: InputMaybe<Scalars['String']['input']>;
    groupNumber?: InputMaybe<Scalars['String']['input']>;
    insuranceAccountStatus?: InputMaybe<InsuranceAccountStatus>;
    insuranceId?: InputMaybe<Scalars['String']['input']>;
    insuredDob?: InputMaybe<Scalars['String']['input']>;
    insuredFirstName?: InputMaybe<Scalars['String']['input']>;
    insuredLastName?: InputMaybe<Scalars['String']['input']>;
    insuredRelationshipCode?: InputMaybe<Scalars['String']['input']>;
    isPrimaryInsurance?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    memberId?: InputMaybe<Scalars['String']['input']>;
    operation?: InputMaybe<Scalars['String']['input']>;
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer?: InputMaybe<Scalars['String']['input']>;
    pcpCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    pcpCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    pcpName?: InputMaybe<Scalars['String']['input']>;
    planEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    planStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    priority?: InputMaybe<Scalars['Int']['input']>;
    specialistCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    specialistCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<InsurancesStatusEnum>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
};

export type InsuranceAuditLogCreateManyInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    ehrInsuranceId?: InputMaybe<Scalars['String']['input']>;
    ehrInsurancePackageId?: InputMaybe<Scalars['String']['input']>;
    groupNumber?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    insuranceAccountStatus?: InputMaybe<InsuranceAccountStatus>;
    insuranceId?: InputMaybe<Scalars['String']['input']>;
    insuredDob?: InputMaybe<Scalars['String']['input']>;
    insuredFirstName?: InputMaybe<Scalars['String']['input']>;
    insuredLastName?: InputMaybe<Scalars['String']['input']>;
    insuredRelationshipCode?: InputMaybe<Scalars['String']['input']>;
    isPrimaryInsurance?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    memberId?: InputMaybe<Scalars['String']['input']>;
    operation?: InputMaybe<Scalars['String']['input']>;
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer?: InputMaybe<Scalars['String']['input']>;
    pcpCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    pcpCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    pcpName?: InputMaybe<Scalars['String']['input']>;
    planEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    planStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    priority?: InputMaybe<Scalars['Int']['input']>;
    specialistCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    specialistCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<InsurancesStatusEnum>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
};

export type InsuranceAuditLogGroupBy = {
    __typename?: 'InsuranceAuditLogGroupBy';
    _avg?: Maybe<InsuranceAuditLogAvgAggregate>;
    _count?: Maybe<InsuranceAuditLogCountAggregate>;
    _max?: Maybe<InsuranceAuditLogMaxAggregate>;
    _min?: Maybe<InsuranceAuditLogMinAggregate>;
    _sum?: Maybe<InsuranceAuditLogSumAggregate>;
    consumerId?: Maybe<Scalars['String']['output']>;
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuranceId?: Maybe<Scalars['String']['output']>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    otherInsurances?: Maybe<Scalars['JSON']['output']>;
    payer?: Maybe<Scalars['String']['output']>;
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status?: Maybe<InsurancesStatusEnum>;
    subscriberInfo?: Maybe<Scalars['JSON']['output']>;
};

export type InsuranceAuditLogMaxAggregate = {
    __typename?: 'InsuranceAuditLogMaxAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuranceId?: Maybe<Scalars['String']['output']>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    payer?: Maybe<Scalars['String']['output']>;
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status?: Maybe<InsurancesStatusEnum>;
};

export type InsuranceAuditLogMaxOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    groupNumber?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceAccountStatus?: InputMaybe<SortOrder>;
    insuranceId?: InputMaybe<SortOrder>;
    insuredDob?: InputMaybe<SortOrder>;
    insuredFirstName?: InputMaybe<SortOrder>;
    insuredLastName?: InputMaybe<SortOrder>;
    insuredRelationshipCode?: InputMaybe<SortOrder>;
    isPrimaryInsurance?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    memberId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    payer?: InputMaybe<SortOrder>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrder>;
    pcpCopayAmount?: InputMaybe<SortOrder>;
    pcpName?: InputMaybe<SortOrder>;
    planEndDate?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    planStartDate?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrder>;
    specialistCopayAmount?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type InsuranceAuditLogMinAggregate = {
    __typename?: 'InsuranceAuditLogMinAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuranceId?: Maybe<Scalars['String']['output']>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    payer?: Maybe<Scalars['String']['output']>;
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status?: Maybe<InsurancesStatusEnum>;
};

export type InsuranceAuditLogMinOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    groupNumber?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceAccountStatus?: InputMaybe<SortOrder>;
    insuranceId?: InputMaybe<SortOrder>;
    insuredDob?: InputMaybe<SortOrder>;
    insuredFirstName?: InputMaybe<SortOrder>;
    insuredLastName?: InputMaybe<SortOrder>;
    insuredRelationshipCode?: InputMaybe<SortOrder>;
    isPrimaryInsurance?: InputMaybe<SortOrder>;
    lastUpdatedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    memberId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    payer?: InputMaybe<SortOrder>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrder>;
    pcpCopayAmount?: InputMaybe<SortOrder>;
    pcpName?: InputMaybe<SortOrder>;
    planEndDate?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    planStartDate?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrder>;
    specialistCopayAmount?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
};

export type InsuranceAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<InsuranceAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<InsuranceAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<InsuranceAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<InsuranceAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<InsuranceAuditLogSumOrderByAggregateInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    ehrInsuranceId?: InputMaybe<SortOrderInput>;
    ehrInsurancePackageId?: InputMaybe<SortOrderInput>;
    groupNumber?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    insuranceAccountStatus?: InputMaybe<SortOrderInput>;
    insuranceId?: InputMaybe<SortOrderInput>;
    insuredDob?: InputMaybe<SortOrderInput>;
    insuredFirstName?: InputMaybe<SortOrderInput>;
    insuredLastName?: InputMaybe<SortOrderInput>;
    insuredRelationshipCode?: InputMaybe<SortOrderInput>;
    isPrimaryInsurance?: InputMaybe<SortOrderInput>;
    lastUpdatedAt?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    memberId?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    otherInsurances?: InputMaybe<SortOrderInput>;
    payer?: InputMaybe<SortOrderInput>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    pcpCopayAmount?: InputMaybe<SortOrderInput>;
    pcpName?: InputMaybe<SortOrderInput>;
    planEndDate?: InputMaybe<SortOrderInput>;
    planName?: InputMaybe<SortOrderInput>;
    planStartDate?: InputMaybe<SortOrderInput>;
    priority?: InputMaybe<SortOrderInput>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    specialistCopayAmount?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    subscriberInfo?: InputMaybe<SortOrderInput>;
};

export type InsuranceAuditLogOrderByWithRelationInput = {
    consumerId?: InputMaybe<SortOrderInput>;
    ehrInsuranceId?: InputMaybe<SortOrderInput>;
    ehrInsurancePackageId?: InputMaybe<SortOrderInput>;
    groupNumber?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    insuranceAccountStatus?: InputMaybe<SortOrderInput>;
    insuranceId?: InputMaybe<SortOrderInput>;
    insuredDob?: InputMaybe<SortOrderInput>;
    insuredFirstName?: InputMaybe<SortOrderInput>;
    insuredLastName?: InputMaybe<SortOrderInput>;
    insuredRelationshipCode?: InputMaybe<SortOrderInput>;
    isPrimaryInsurance?: InputMaybe<SortOrderInput>;
    lastUpdatedAt?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    memberId?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    otherInsurances?: InputMaybe<SortOrderInput>;
    payer?: InputMaybe<SortOrderInput>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    pcpCopayAmount?: InputMaybe<SortOrderInput>;
    pcpName?: InputMaybe<SortOrderInput>;
    planEndDate?: InputMaybe<SortOrderInput>;
    planName?: InputMaybe<SortOrderInput>;
    planStartDate?: InputMaybe<SortOrderInput>;
    priority?: InputMaybe<SortOrderInput>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    specialistCopayAmount?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    subscriberInfo?: InputMaybe<SortOrderInput>;
};

export enum InsuranceAuditLogScalarFieldEnum {
    ConsumerId = 'consumerId',
    EhrInsuranceId = 'ehrInsuranceId',
    EhrInsurancePackageId = 'ehrInsurancePackageId',
    GroupNumber = 'groupNumber',
    Id = 'id',
    InsuranceAccountStatus = 'insuranceAccountStatus',
    InsuranceId = 'insuranceId',
    InsuredDob = 'insuredDob',
    InsuredFirstName = 'insuredFirstName',
    InsuredLastName = 'insuredLastName',
    InsuredRelationshipCode = 'insuredRelationshipCode',
    IsPrimaryInsurance = 'isPrimaryInsurance',
    LastUpdatedAt = 'lastUpdatedAt',
    LastUpdatedBy = 'lastUpdatedBy',
    MemberId = 'memberId',
    Operation = 'operation',
    OtherInsurances = 'otherInsurances',
    Payer = 'payer',
    PcpCoinsurancePercentage = 'pcpCoinsurancePercentage',
    PcpCopayAmount = 'pcpCopayAmount',
    PcpName = 'pcpName',
    PlanEndDate = 'planEndDate',
    PlanName = 'planName',
    PlanStartDate = 'planStartDate',
    Priority = 'priority',
    SpecialistCoinsurancePercentage = 'specialistCoinsurancePercentage',
    SpecialistCopayAmount = 'specialistCopayAmount',
    State = 'state',
    Status = 'status',
    SubscriberInfo = 'subscriberInfo',
}

export type InsuranceAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<InsuranceAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<InsuranceAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<InsuranceAuditLogScalarWhereWithAggregatesInput>>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    ehrInsuranceId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrInsurancePackageId?: InputMaybe<StringNullableWithAggregatesFilter>;
    groupNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    insuranceAccountStatus?: InputMaybe<EnumInsuranceAccountStatusNullableWithAggregatesFilter>;
    insuranceId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    insuredDob?: InputMaybe<StringNullableWithAggregatesFilter>;
    insuredFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    insuredLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    insuredRelationshipCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    isPrimaryInsurance?: InputMaybe<BoolNullableWithAggregatesFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    memberId?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringNullableWithAggregatesFilter>;
    otherInsurances?: InputMaybe<JsonNullableWithAggregatesFilter>;
    payer?: InputMaybe<StringNullableWithAggregatesFilter>;
    pcpCoinsurancePercentage?: InputMaybe<IntNullableWithAggregatesFilter>;
    pcpCopayAmount?: InputMaybe<IntNullableWithAggregatesFilter>;
    pcpName?: InputMaybe<StringNullableWithAggregatesFilter>;
    planEndDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    planName?: InputMaybe<StringNullableWithAggregatesFilter>;
    planStartDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    priority?: InputMaybe<IntNullableWithAggregatesFilter>;
    specialistCoinsurancePercentage?: InputMaybe<IntNullableWithAggregatesFilter>;
    specialistCopayAmount?: InputMaybe<IntNullableWithAggregatesFilter>;
    state?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnuminsurancesStatusEnumNullableWithAggregatesFilter>;
    subscriberInfo?: InputMaybe<JsonNullableWithAggregatesFilter>;
};

export type InsuranceAuditLogSumAggregate = {
    __typename?: 'InsuranceAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrder>;
    pcpCopayAmount?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrder>;
    specialistCopayAmount?: InputMaybe<SortOrder>;
};

export type InsuranceAuditLogUpdateInput = {
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrInsurancePackageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    groupNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuranceAccountStatus?: InputMaybe<NullableEnumInsuranceAccountStatusFieldUpdateOperationsInput>;
    insuranceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredDob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredRelationshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isPrimaryInsurance?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    memberId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    planName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnuminsurancesStatusEnumFieldUpdateOperationsInput>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
};

export type InsuranceAuditLogUpdateManyMutationInput = {
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrInsurancePackageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    groupNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuranceAccountStatus?: InputMaybe<NullableEnumInsuranceAccountStatusFieldUpdateOperationsInput>;
    insuranceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredDob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredRelationshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isPrimaryInsurance?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    memberId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pcpCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    planName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnuminsurancesStatusEnumFieldUpdateOperationsInput>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
};

export type InsuranceAuditLogWhereInput = {
    AND?: InputMaybe<Array<InsuranceAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<InsuranceAuditLogWhereInput>>;
    OR?: InputMaybe<Array<InsuranceAuditLogWhereInput>>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    ehrInsuranceId?: InputMaybe<StringNullableFilter>;
    ehrInsurancePackageId?: InputMaybe<StringNullableFilter>;
    groupNumber?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    insuranceAccountStatus?: InputMaybe<EnumInsuranceAccountStatusNullableFilter>;
    insuranceId?: InputMaybe<UuidNullableFilter>;
    insuredDob?: InputMaybe<StringNullableFilter>;
    insuredFirstName?: InputMaybe<StringNullableFilter>;
    insuredLastName?: InputMaybe<StringNullableFilter>;
    insuredRelationshipCode?: InputMaybe<StringNullableFilter>;
    isPrimaryInsurance?: InputMaybe<BoolNullableFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    memberId?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    otherInsurances?: InputMaybe<JsonNullableFilter>;
    payer?: InputMaybe<StringNullableFilter>;
    pcpCoinsurancePercentage?: InputMaybe<IntNullableFilter>;
    pcpCopayAmount?: InputMaybe<IntNullableFilter>;
    pcpName?: InputMaybe<StringNullableFilter>;
    planEndDate?: InputMaybe<DateTimeNullableFilter>;
    planName?: InputMaybe<StringNullableFilter>;
    planStartDate?: InputMaybe<DateTimeNullableFilter>;
    priority?: InputMaybe<IntNullableFilter>;
    specialistCoinsurancePercentage?: InputMaybe<IntNullableFilter>;
    specialistCopayAmount?: InputMaybe<IntNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnuminsurancesStatusEnumNullableFilter>;
    subscriberInfo?: InputMaybe<JsonNullableFilter>;
};

export type InsuranceAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<InsuranceAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<InsuranceAuditLogWhereInput>>;
    OR?: InputMaybe<Array<InsuranceAuditLogWhereInput>>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    ehrInsuranceId?: InputMaybe<StringNullableFilter>;
    ehrInsurancePackageId?: InputMaybe<StringNullableFilter>;
    groupNumber?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    insuranceAccountStatus?: InputMaybe<EnumInsuranceAccountStatusNullableFilter>;
    insuranceId?: InputMaybe<UuidNullableFilter>;
    insuredDob?: InputMaybe<StringNullableFilter>;
    insuredFirstName?: InputMaybe<StringNullableFilter>;
    insuredLastName?: InputMaybe<StringNullableFilter>;
    insuredRelationshipCode?: InputMaybe<StringNullableFilter>;
    isPrimaryInsurance?: InputMaybe<BoolNullableFilter>;
    lastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    memberId?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    otherInsurances?: InputMaybe<JsonNullableFilter>;
    payer?: InputMaybe<StringNullableFilter>;
    pcpCoinsurancePercentage?: InputMaybe<IntNullableFilter>;
    pcpCopayAmount?: InputMaybe<IntNullableFilter>;
    pcpName?: InputMaybe<StringNullableFilter>;
    planEndDate?: InputMaybe<DateTimeNullableFilter>;
    planName?: InputMaybe<StringNullableFilter>;
    planStartDate?: InputMaybe<DateTimeNullableFilter>;
    priority?: InputMaybe<IntNullableFilter>;
    specialistCoinsurancePercentage?: InputMaybe<IntNullableFilter>;
    specialistCopayAmount?: InputMaybe<IntNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnuminsurancesStatusEnumNullableFilter>;
    subscriberInfo?: InputMaybe<JsonNullableFilter>;
};

export type InsuranceAvgAggregate = {
    __typename?: 'InsuranceAvgAggregate';
    pcpCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Float']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Float']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Float']['output']>;
};

export type InsuranceAvgOrderByAggregateInput = {
    pcpCoinsurancePercentage?: InputMaybe<SortOrder>;
    pcpCopayAmount?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrder>;
    specialistCopayAmount?: InputMaybe<SortOrder>;
};

export type InsuranceCount = {
    __typename?: 'InsuranceCount';
    photos: Scalars['Int']['output'];
};

export type InsuranceCountPhotosArgs = {
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type InsuranceCountAggregate = {
    __typename?: 'InsuranceCountAggregate';
    _all: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrInsuranceId: Scalars['Int']['output'];
    ehrInsurancePackageId: Scalars['Int']['output'];
    groupNumber: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    insuranceAccountStatus: Scalars['Int']['output'];
    insuredDob: Scalars['Int']['output'];
    insuredFirstName: Scalars['Int']['output'];
    insuredLastName: Scalars['Int']['output'];
    insuredRelationshipCode: Scalars['Int']['output'];
    isPrimaryInsurance: Scalars['Int']['output'];
    lastCheckedAt: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    memberId: Scalars['Int']['output'];
    otherInsurances: Scalars['Int']['output'];
    payer: Scalars['Int']['output'];
    pcpCoinsurancePercentage: Scalars['Int']['output'];
    pcpCopayAmount: Scalars['Int']['output'];
    pcpName: Scalars['Int']['output'];
    planEndDate: Scalars['Int']['output'];
    planName: Scalars['Int']['output'];
    planStartDate: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    specialistCoinsurancePercentage: Scalars['Int']['output'];
    specialistCopayAmount: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    subscriberInfo: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type InsuranceCountOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    groupNumber?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceAccountStatus?: InputMaybe<SortOrder>;
    insuredDob?: InputMaybe<SortOrder>;
    insuredFirstName?: InputMaybe<SortOrder>;
    insuredLastName?: InputMaybe<SortOrder>;
    insuredRelationshipCode?: InputMaybe<SortOrder>;
    isPrimaryInsurance?: InputMaybe<SortOrder>;
    lastCheckedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    memberId?: InputMaybe<SortOrder>;
    otherInsurances?: InputMaybe<SortOrder>;
    payer?: InputMaybe<SortOrder>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrder>;
    pcpCopayAmount?: InputMaybe<SortOrder>;
    pcpName?: InputMaybe<SortOrder>;
    planEndDate?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    planStartDate?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrder>;
    specialistCopayAmount?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    subscriberInfo?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InsuranceCreateInput = {
    consumer?: InputMaybe<ConsumerCreateNestedOneWithoutInsurancesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId?: InputMaybe<Scalars['String']['input']>;
    ehrInsurancePackageId?: InputMaybe<Scalars['String']['input']>;
    groupNumber?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceAccountStatus?: InputMaybe<InsuranceAccountStatus>;
    insuredDob?: InputMaybe<Scalars['String']['input']>;
    insuredFirstName?: InputMaybe<Scalars['String']['input']>;
    insuredLastName?: InputMaybe<Scalars['String']['input']>;
    insuredRelationshipCode?: InputMaybe<Scalars['String']['input']>;
    isPrimaryInsurance?: InputMaybe<Scalars['Boolean']['input']>;
    lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    memberId: Scalars['String']['input'];
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer: Scalars['String']['input'];
    pcpCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    pcpCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    pcpName?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutInsuranceInput>;
    planEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    planStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    priority?: InputMaybe<Scalars['Int']['input']>;
    specialistCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    specialistCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<InsurancesStatusEnum>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InsuranceCreateManyConsumerInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId?: InputMaybe<Scalars['String']['input']>;
    ehrInsurancePackageId?: InputMaybe<Scalars['String']['input']>;
    groupNumber?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceAccountStatus?: InputMaybe<InsuranceAccountStatus>;
    insuredDob?: InputMaybe<Scalars['String']['input']>;
    insuredFirstName?: InputMaybe<Scalars['String']['input']>;
    insuredLastName?: InputMaybe<Scalars['String']['input']>;
    insuredRelationshipCode?: InputMaybe<Scalars['String']['input']>;
    isPrimaryInsurance?: InputMaybe<Scalars['Boolean']['input']>;
    lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    memberId: Scalars['String']['input'];
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer: Scalars['String']['input'];
    pcpCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    pcpCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    pcpName?: InputMaybe<Scalars['String']['input']>;
    planEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    planStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    priority?: InputMaybe<Scalars['Int']['input']>;
    specialistCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    specialistCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<InsurancesStatusEnum>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InsuranceCreateManyConsumerInputEnvelope = {
    data: Array<InsuranceCreateManyConsumerInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceCreateManyInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId?: InputMaybe<Scalars['String']['input']>;
    ehrInsurancePackageId?: InputMaybe<Scalars['String']['input']>;
    groupNumber?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceAccountStatus?: InputMaybe<InsuranceAccountStatus>;
    insuredDob?: InputMaybe<Scalars['String']['input']>;
    insuredFirstName?: InputMaybe<Scalars['String']['input']>;
    insuredLastName?: InputMaybe<Scalars['String']['input']>;
    insuredRelationshipCode?: InputMaybe<Scalars['String']['input']>;
    isPrimaryInsurance?: InputMaybe<Scalars['Boolean']['input']>;
    lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    memberId: Scalars['String']['input'];
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer: Scalars['String']['input'];
    pcpCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    pcpCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    pcpName?: InputMaybe<Scalars['String']['input']>;
    planEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    planStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    priority?: InputMaybe<Scalars['Int']['input']>;
    specialistCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    specialistCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<InsurancesStatusEnum>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InsuranceCreateNestedManyWithoutConsumerInput = {
    connect?: InputMaybe<Array<InsuranceWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<InsuranceCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<InsuranceCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<InsuranceCreateManyConsumerInputEnvelope>;
};

export type InsuranceCreateNestedOneWithoutPhotosInput = {
    connect?: InputMaybe<InsuranceWhereUniqueInput>;
    connectOrCreate?: InputMaybe<InsuranceCreateOrConnectWithoutPhotosInput>;
    create?: InputMaybe<InsuranceCreateWithoutPhotosInput>;
};

export type InsuranceCreateOrConnectWithoutConsumerInput = {
    create: InsuranceCreateWithoutConsumerInput;
    where: InsuranceWhereUniqueInput;
};

export type InsuranceCreateOrConnectWithoutPhotosInput = {
    create: InsuranceCreateWithoutPhotosInput;
    where: InsuranceWhereUniqueInput;
};

export type InsuranceCreateWithoutConsumerInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId?: InputMaybe<Scalars['String']['input']>;
    ehrInsurancePackageId?: InputMaybe<Scalars['String']['input']>;
    groupNumber?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceAccountStatus?: InputMaybe<InsuranceAccountStatus>;
    insuredDob?: InputMaybe<Scalars['String']['input']>;
    insuredFirstName?: InputMaybe<Scalars['String']['input']>;
    insuredLastName?: InputMaybe<Scalars['String']['input']>;
    insuredRelationshipCode?: InputMaybe<Scalars['String']['input']>;
    isPrimaryInsurance?: InputMaybe<Scalars['Boolean']['input']>;
    lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    memberId: Scalars['String']['input'];
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer: Scalars['String']['input'];
    pcpCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    pcpCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    pcpName?: InputMaybe<Scalars['String']['input']>;
    photos?: InputMaybe<ConsumerPhotoMetaDataCreateNestedManyWithoutInsuranceInput>;
    planEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    planStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    priority?: InputMaybe<Scalars['Int']['input']>;
    specialistCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    specialistCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<InsurancesStatusEnum>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InsuranceCreateWithoutPhotosInput = {
    consumer?: InputMaybe<ConsumerCreateNestedOneWithoutInsurancesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsuranceId?: InputMaybe<Scalars['String']['input']>;
    ehrInsurancePackageId?: InputMaybe<Scalars['String']['input']>;
    groupNumber?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceAccountStatus?: InputMaybe<InsuranceAccountStatus>;
    insuredDob?: InputMaybe<Scalars['String']['input']>;
    insuredFirstName?: InputMaybe<Scalars['String']['input']>;
    insuredLastName?: InputMaybe<Scalars['String']['input']>;
    insuredRelationshipCode?: InputMaybe<Scalars['String']['input']>;
    isPrimaryInsurance?: InputMaybe<Scalars['Boolean']['input']>;
    lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    memberId: Scalars['String']['input'];
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer: Scalars['String']['input'];
    pcpCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    pcpCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    pcpName?: InputMaybe<Scalars['String']['input']>;
    planEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    planStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    priority?: InputMaybe<Scalars['Int']['input']>;
    specialistCoinsurancePercentage?: InputMaybe<Scalars['Int']['input']>;
    specialistCopayAmount?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<InsurancesStatusEnum>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InsuranceGroupBy = {
    __typename?: 'InsuranceGroupBy';
    _avg?: Maybe<InsuranceAvgAggregate>;
    _count?: Maybe<InsuranceCountAggregate>;
    _max?: Maybe<InsuranceMaxAggregate>;
    _min?: Maybe<InsuranceMinAggregate>;
    _sum?: Maybe<InsuranceSumAggregate>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance: Scalars['Boolean']['output'];
    lastCheckedAt: Scalars['DateTimeISO']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId: Scalars['String']['output'];
    otherInsurances?: Maybe<Scalars['JSON']['output']>;
    payer: Scalars['String']['output'];
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status: InsurancesStatusEnum;
    subscriberInfo?: Maybe<Scalars['JSON']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type InsuranceListRelationFilter = {
    every?: InputMaybe<InsuranceWhereInput>;
    none?: InputMaybe<InsuranceWhereInput>;
    some?: InputMaybe<InsuranceWhereInput>;
};

export type InsuranceMaxAggregate = {
    __typename?: 'InsuranceMaxAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance?: Maybe<Scalars['Boolean']['output']>;
    lastCheckedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId?: Maybe<Scalars['String']['output']>;
    payer?: Maybe<Scalars['String']['output']>;
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status?: Maybe<InsurancesStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type InsuranceMaxOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    groupNumber?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceAccountStatus?: InputMaybe<SortOrder>;
    insuredDob?: InputMaybe<SortOrder>;
    insuredFirstName?: InputMaybe<SortOrder>;
    insuredLastName?: InputMaybe<SortOrder>;
    insuredRelationshipCode?: InputMaybe<SortOrder>;
    isPrimaryInsurance?: InputMaybe<SortOrder>;
    lastCheckedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    memberId?: InputMaybe<SortOrder>;
    payer?: InputMaybe<SortOrder>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrder>;
    pcpCopayAmount?: InputMaybe<SortOrder>;
    pcpName?: InputMaybe<SortOrder>;
    planEndDate?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    planStartDate?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrder>;
    specialistCopayAmount?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InsuranceMetadata = {
    __typename?: 'InsuranceMetadata';
    createdAt: Scalars['DateTimeISO']['output'];
    insuranceId: Scalars['String']['output'];
    status: InsuranceMetadataStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type InsuranceMetadataCountAggregate = {
    __typename?: 'InsuranceMetadataCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    insuranceId: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type InsuranceMetadataCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    insuranceId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InsuranceMetadataCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    insuranceId: Scalars['String']['input'];
    status?: InputMaybe<InsuranceMetadataStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InsuranceMetadataCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    insuranceId: Scalars['String']['input'];
    status?: InputMaybe<InsuranceMetadataStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InsuranceMetadataGroupBy = {
    __typename?: 'InsuranceMetadataGroupBy';
    _count?: Maybe<InsuranceMetadataCountAggregate>;
    _max?: Maybe<InsuranceMetadataMaxAggregate>;
    _min?: Maybe<InsuranceMetadataMinAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    insuranceId: Scalars['String']['output'];
    status: InsuranceMetadataStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type InsuranceMetadataMaxAggregate = {
    __typename?: 'InsuranceMetadataMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    insuranceId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<InsuranceMetadataStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type InsuranceMetadataMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    insuranceId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InsuranceMetadataMinAggregate = {
    __typename?: 'InsuranceMetadataMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    insuranceId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<InsuranceMetadataStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type InsuranceMetadataMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    insuranceId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InsuranceMetadataOrderByWithAggregationInput = {
    _count?: InputMaybe<InsuranceMetadataCountOrderByAggregateInput>;
    _max?: InputMaybe<InsuranceMetadataMaxOrderByAggregateInput>;
    _min?: InputMaybe<InsuranceMetadataMinOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    insuranceId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InsuranceMetadataOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    insuranceId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum InsuranceMetadataScalarFieldEnum {
    CreatedAt = 'createdAt',
    InsuranceId = 'insuranceId',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type InsuranceMetadataScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<InsuranceMetadataScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<InsuranceMetadataScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<InsuranceMetadataScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    insuranceId?: InputMaybe<UuidWithAggregatesFilter>;
    status?: InputMaybe<EnumInsuranceMetadataStatusEnumWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum InsuranceMetadataStatusEnum {
    Active = 'active',
    Inactive = 'inactive',
    Stale = 'stale',
}

export type InsuranceMetadataUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    insuranceId?: InputMaybe<StringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumInsuranceMetadataStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InsuranceMetadataUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    insuranceId?: InputMaybe<StringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumInsuranceMetadataStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InsuranceMetadataWhereInput = {
    AND?: InputMaybe<Array<InsuranceMetadataWhereInput>>;
    NOT?: InputMaybe<Array<InsuranceMetadataWhereInput>>;
    OR?: InputMaybe<Array<InsuranceMetadataWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    insuranceId?: InputMaybe<UuidFilter>;
    status?: InputMaybe<EnumInsuranceMetadataStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InsuranceMetadataWhereUniqueInput = {
    AND?: InputMaybe<Array<InsuranceMetadataWhereInput>>;
    NOT?: InputMaybe<Array<InsuranceMetadataWhereInput>>;
    OR?: InputMaybe<Array<InsuranceMetadataWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    insuranceId?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<EnumInsuranceMetadataStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InsuranceMinAggregate = {
    __typename?: 'InsuranceMinAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance?: Maybe<Scalars['Boolean']['output']>;
    lastCheckedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId?: Maybe<Scalars['String']['output']>;
    payer?: Maybe<Scalars['String']['output']>;
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status?: Maybe<InsurancesStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type InsuranceMinOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrder>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    groupNumber?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceAccountStatus?: InputMaybe<SortOrder>;
    insuredDob?: InputMaybe<SortOrder>;
    insuredFirstName?: InputMaybe<SortOrder>;
    insuredLastName?: InputMaybe<SortOrder>;
    insuredRelationshipCode?: InputMaybe<SortOrder>;
    isPrimaryInsurance?: InputMaybe<SortOrder>;
    lastCheckedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    memberId?: InputMaybe<SortOrder>;
    payer?: InputMaybe<SortOrder>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrder>;
    pcpCopayAmount?: InputMaybe<SortOrder>;
    pcpName?: InputMaybe<SortOrder>;
    planEndDate?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    planStartDate?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrder>;
    specialistCopayAmount?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InsuranceNullableRelationFilter = {
    is?: InputMaybe<InsuranceWhereInput>;
    isNot?: InputMaybe<InsuranceWhereInput>;
};

export type InsuranceOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type InsuranceOrderByWithAggregationInput = {
    _avg?: InputMaybe<InsuranceAvgOrderByAggregateInput>;
    _count?: InputMaybe<InsuranceCountOrderByAggregateInput>;
    _max?: InputMaybe<InsuranceMaxOrderByAggregateInput>;
    _min?: InputMaybe<InsuranceMinOrderByAggregateInput>;
    _sum?: InputMaybe<InsuranceSumOrderByAggregateInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrderInput>;
    ehrInsurancePackageId?: InputMaybe<SortOrderInput>;
    groupNumber?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    insuranceAccountStatus?: InputMaybe<SortOrderInput>;
    insuredDob?: InputMaybe<SortOrderInput>;
    insuredFirstName?: InputMaybe<SortOrderInput>;
    insuredLastName?: InputMaybe<SortOrderInput>;
    insuredRelationshipCode?: InputMaybe<SortOrderInput>;
    isPrimaryInsurance?: InputMaybe<SortOrder>;
    lastCheckedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    memberId?: InputMaybe<SortOrder>;
    otherInsurances?: InputMaybe<SortOrderInput>;
    payer?: InputMaybe<SortOrder>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    pcpCopayAmount?: InputMaybe<SortOrderInput>;
    pcpName?: InputMaybe<SortOrderInput>;
    planEndDate?: InputMaybe<SortOrderInput>;
    planName?: InputMaybe<SortOrderInput>;
    planStartDate?: InputMaybe<SortOrderInput>;
    priority?: InputMaybe<SortOrderInput>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    specialistCopayAmount?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    subscriberInfo?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InsuranceOrderByWithRelationInput = {
    consumer?: InputMaybe<ConsumerOrderByWithRelationInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrInsuranceId?: InputMaybe<SortOrderInput>;
    ehrInsurancePackageId?: InputMaybe<SortOrderInput>;
    groupNumber?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    insuranceAccountStatus?: InputMaybe<SortOrderInput>;
    insuredDob?: InputMaybe<SortOrderInput>;
    insuredFirstName?: InputMaybe<SortOrderInput>;
    insuredLastName?: InputMaybe<SortOrderInput>;
    insuredRelationshipCode?: InputMaybe<SortOrderInput>;
    isPrimaryInsurance?: InputMaybe<SortOrder>;
    lastCheckedAt?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    memberId?: InputMaybe<SortOrder>;
    otherInsurances?: InputMaybe<SortOrderInput>;
    payer?: InputMaybe<SortOrder>;
    pcpCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    pcpCopayAmount?: InputMaybe<SortOrderInput>;
    pcpName?: InputMaybe<SortOrderInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataOrderByRelationAggregateInput>;
    planEndDate?: InputMaybe<SortOrderInput>;
    planName?: InputMaybe<SortOrderInput>;
    planStartDate?: InputMaybe<SortOrderInput>;
    priority?: InputMaybe<SortOrderInput>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrderInput>;
    specialistCopayAmount?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    subscriberInfo?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum InsuranceScalarFieldEnum {
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    EhrInsuranceId = 'ehrInsuranceId',
    EhrInsurancePackageId = 'ehrInsurancePackageId',
    GroupNumber = 'groupNumber',
    Id = 'id',
    InsuranceAccountStatus = 'insuranceAccountStatus',
    InsuredDob = 'insuredDob',
    InsuredFirstName = 'insuredFirstName',
    InsuredLastName = 'insuredLastName',
    InsuredRelationshipCode = 'insuredRelationshipCode',
    IsPrimaryInsurance = 'isPrimaryInsurance',
    LastCheckedAt = 'lastCheckedAt',
    LastUpdatedBy = 'lastUpdatedBy',
    MemberId = 'memberId',
    OtherInsurances = 'otherInsurances',
    Payer = 'payer',
    PcpCoinsurancePercentage = 'pcpCoinsurancePercentage',
    PcpCopayAmount = 'pcpCopayAmount',
    PcpName = 'pcpName',
    PlanEndDate = 'planEndDate',
    PlanName = 'planName',
    PlanStartDate = 'planStartDate',
    Priority = 'priority',
    SpecialistCoinsurancePercentage = 'specialistCoinsurancePercentage',
    SpecialistCopayAmount = 'specialistCopayAmount',
    State = 'state',
    Status = 'status',
    SubscriberInfo = 'subscriberInfo',
    UpdatedAt = 'updatedAt',
}

export type InsuranceScalarWhereInput = {
    AND?: InputMaybe<Array<InsuranceScalarWhereInput>>;
    NOT?: InputMaybe<Array<InsuranceScalarWhereInput>>;
    OR?: InputMaybe<Array<InsuranceScalarWhereInput>>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrInsuranceId?: InputMaybe<StringNullableFilter>;
    ehrInsurancePackageId?: InputMaybe<StringNullableFilter>;
    groupNumber?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    insuranceAccountStatus?: InputMaybe<EnumInsuranceAccountStatusNullableFilter>;
    insuredDob?: InputMaybe<StringNullableFilter>;
    insuredFirstName?: InputMaybe<StringNullableFilter>;
    insuredLastName?: InputMaybe<StringNullableFilter>;
    insuredRelationshipCode?: InputMaybe<StringNullableFilter>;
    isPrimaryInsurance?: InputMaybe<BoolFilter>;
    lastCheckedAt?: InputMaybe<DateTimeFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    memberId?: InputMaybe<StringFilter>;
    otherInsurances?: InputMaybe<JsonNullableFilter>;
    payer?: InputMaybe<StringFilter>;
    pcpCoinsurancePercentage?: InputMaybe<IntNullableFilter>;
    pcpCopayAmount?: InputMaybe<IntNullableFilter>;
    pcpName?: InputMaybe<StringNullableFilter>;
    planEndDate?: InputMaybe<DateTimeNullableFilter>;
    planName?: InputMaybe<StringNullableFilter>;
    planStartDate?: InputMaybe<DateTimeNullableFilter>;
    priority?: InputMaybe<IntNullableFilter>;
    specialistCoinsurancePercentage?: InputMaybe<IntNullableFilter>;
    specialistCopayAmount?: InputMaybe<IntNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnuminsurancesStatusEnumFilter>;
    subscriberInfo?: InputMaybe<JsonNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InsuranceScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<InsuranceScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<InsuranceScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<InsuranceScalarWhereWithAggregatesInput>>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrInsuranceId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrInsurancePackageId?: InputMaybe<StringNullableWithAggregatesFilter>;
    groupNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    insuranceAccountStatus?: InputMaybe<EnumInsuranceAccountStatusNullableWithAggregatesFilter>;
    insuredDob?: InputMaybe<StringNullableWithAggregatesFilter>;
    insuredFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    insuredLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    insuredRelationshipCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    isPrimaryInsurance?: InputMaybe<BoolWithAggregatesFilter>;
    lastCheckedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    memberId?: InputMaybe<StringWithAggregatesFilter>;
    otherInsurances?: InputMaybe<JsonNullableWithAggregatesFilter>;
    payer?: InputMaybe<StringWithAggregatesFilter>;
    pcpCoinsurancePercentage?: InputMaybe<IntNullableWithAggregatesFilter>;
    pcpCopayAmount?: InputMaybe<IntNullableWithAggregatesFilter>;
    pcpName?: InputMaybe<StringNullableWithAggregatesFilter>;
    planEndDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    planName?: InputMaybe<StringNullableWithAggregatesFilter>;
    planStartDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    priority?: InputMaybe<IntNullableWithAggregatesFilter>;
    specialistCoinsurancePercentage?: InputMaybe<IntNullableWithAggregatesFilter>;
    specialistCopayAmount?: InputMaybe<IntNullableWithAggregatesFilter>;
    state?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnuminsurancesStatusEnumWithAggregatesFilter>;
    subscriberInfo?: InputMaybe<JsonNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type InsuranceSumAggregate = {
    __typename?: 'InsuranceSumAggregate';
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceSumOrderByAggregateInput = {
    pcpCoinsurancePercentage?: InputMaybe<SortOrder>;
    pcpCopayAmount?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    specialistCoinsurancePercentage?: InputMaybe<SortOrder>;
    specialistCopayAmount?: InputMaybe<SortOrder>;
};

export type InsuranceUpdateInput = {
    consumer?: InputMaybe<ConsumerUpdateOneWithoutInsurancesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrInsurancePackageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    groupNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceAccountStatus?: InputMaybe<NullableEnumInsuranceAccountStatusFieldUpdateOperationsInput>;
    insuredDob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredRelationshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isPrimaryInsurance?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastCheckedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    memberId?: InputMaybe<StringFieldUpdateOperationsInput>;
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer?: InputMaybe<StringFieldUpdateOperationsInput>;
    pcpCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutInsuranceNestedInput>;
    planEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    planName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnuminsurancesStatusEnumFieldUpdateOperationsInput>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InsuranceUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrInsurancePackageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    groupNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceAccountStatus?: InputMaybe<NullableEnumInsuranceAccountStatusFieldUpdateOperationsInput>;
    insuredDob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredRelationshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isPrimaryInsurance?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastCheckedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    memberId?: InputMaybe<StringFieldUpdateOperationsInput>;
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer?: InputMaybe<StringFieldUpdateOperationsInput>;
    pcpCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    planName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnuminsurancesStatusEnumFieldUpdateOperationsInput>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InsuranceUpdateManyWithWhereWithoutConsumerInput = {
    data: InsuranceUpdateManyMutationInput;
    where: InsuranceScalarWhereInput;
};

export type InsuranceUpdateManyWithoutConsumerNestedInput = {
    connect?: InputMaybe<Array<InsuranceWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<InsuranceCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<InsuranceCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<InsuranceCreateManyConsumerInputEnvelope>;
    delete?: InputMaybe<Array<InsuranceWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<InsuranceScalarWhereInput>>;
    disconnect?: InputMaybe<Array<InsuranceWhereUniqueInput>>;
    set?: InputMaybe<Array<InsuranceWhereUniqueInput>>;
    update?: InputMaybe<
        Array<InsuranceUpdateWithWhereUniqueWithoutConsumerInput>
    >;
    updateMany?: InputMaybe<
        Array<InsuranceUpdateManyWithWhereWithoutConsumerInput>
    >;
    upsert?: InputMaybe<
        Array<InsuranceUpsertWithWhereUniqueWithoutConsumerInput>
    >;
};

export type InsuranceUpdateOneWithoutPhotosNestedInput = {
    connect?: InputMaybe<InsuranceWhereUniqueInput>;
    connectOrCreate?: InputMaybe<InsuranceCreateOrConnectWithoutPhotosInput>;
    create?: InputMaybe<InsuranceCreateWithoutPhotosInput>;
    delete?: InputMaybe<InsuranceWhereInput>;
    disconnect?: InputMaybe<InsuranceWhereInput>;
    update?: InputMaybe<InsuranceUpdateToOneWithWhereWithoutPhotosInput>;
    upsert?: InputMaybe<InsuranceUpsertWithoutPhotosInput>;
};

export type InsuranceUpdateToOneWithWhereWithoutPhotosInput = {
    data: InsuranceUpdateWithoutPhotosInput;
    where?: InputMaybe<InsuranceWhereInput>;
};

export type InsuranceUpdateWithWhereUniqueWithoutConsumerInput = {
    data: InsuranceUpdateWithoutConsumerInput;
    where: InsuranceWhereUniqueInput;
};

export type InsuranceUpdateWithoutConsumerInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrInsurancePackageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    groupNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceAccountStatus?: InputMaybe<NullableEnumInsuranceAccountStatusFieldUpdateOperationsInput>;
    insuredDob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredRelationshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isPrimaryInsurance?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastCheckedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    memberId?: InputMaybe<StringFieldUpdateOperationsInput>;
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer?: InputMaybe<StringFieldUpdateOperationsInput>;
    pcpCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    photos?: InputMaybe<ConsumerPhotoMetaDataUpdateManyWithoutInsuranceNestedInput>;
    planEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    planName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnuminsurancesStatusEnumFieldUpdateOperationsInput>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InsuranceUpdateWithoutPhotosInput = {
    consumer?: InputMaybe<ConsumerUpdateOneWithoutInsurancesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrInsuranceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrInsurancePackageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    groupNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    insuranceAccountStatus?: InputMaybe<NullableEnumInsuranceAccountStatusFieldUpdateOperationsInput>;
    insuredDob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuredRelationshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isPrimaryInsurance?: InputMaybe<BoolFieldUpdateOperationsInput>;
    lastCheckedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    memberId?: InputMaybe<StringFieldUpdateOperationsInput>;
    otherInsurances?: InputMaybe<Scalars['JSON']['input']>;
    payer?: InputMaybe<StringFieldUpdateOperationsInput>;
    pcpCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    pcpName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    planName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCoinsurancePercentage?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    specialistCopayAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnuminsurancesStatusEnumFieldUpdateOperationsInput>;
    subscriberInfo?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InsuranceUpsertWithWhereUniqueWithoutConsumerInput = {
    create: InsuranceCreateWithoutConsumerInput;
    update: InsuranceUpdateWithoutConsumerInput;
    where: InsuranceWhereUniqueInput;
};

export type InsuranceUpsertWithoutPhotosInput = {
    create: InsuranceCreateWithoutPhotosInput;
    update: InsuranceUpdateWithoutPhotosInput;
    where?: InputMaybe<InsuranceWhereInput>;
};

export type InsuranceWhereInput = {
    AND?: InputMaybe<Array<InsuranceWhereInput>>;
    NOT?: InputMaybe<Array<InsuranceWhereInput>>;
    OR?: InputMaybe<Array<InsuranceWhereInput>>;
    consumer?: InputMaybe<ConsumerNullableRelationFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrInsuranceId?: InputMaybe<StringNullableFilter>;
    ehrInsurancePackageId?: InputMaybe<StringNullableFilter>;
    groupNumber?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    insuranceAccountStatus?: InputMaybe<EnumInsuranceAccountStatusNullableFilter>;
    insuredDob?: InputMaybe<StringNullableFilter>;
    insuredFirstName?: InputMaybe<StringNullableFilter>;
    insuredLastName?: InputMaybe<StringNullableFilter>;
    insuredRelationshipCode?: InputMaybe<StringNullableFilter>;
    isPrimaryInsurance?: InputMaybe<BoolFilter>;
    lastCheckedAt?: InputMaybe<DateTimeFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    memberId?: InputMaybe<StringFilter>;
    otherInsurances?: InputMaybe<JsonNullableFilter>;
    payer?: InputMaybe<StringFilter>;
    pcpCoinsurancePercentage?: InputMaybe<IntNullableFilter>;
    pcpCopayAmount?: InputMaybe<IntNullableFilter>;
    pcpName?: InputMaybe<StringNullableFilter>;
    photos?: InputMaybe<ConsumerPhotoMetaDataListRelationFilter>;
    planEndDate?: InputMaybe<DateTimeNullableFilter>;
    planName?: InputMaybe<StringNullableFilter>;
    planStartDate?: InputMaybe<DateTimeNullableFilter>;
    priority?: InputMaybe<IntNullableFilter>;
    specialistCoinsurancePercentage?: InputMaybe<IntNullableFilter>;
    specialistCopayAmount?: InputMaybe<IntNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnuminsurancesStatusEnumFilter>;
    subscriberInfo?: InputMaybe<JsonNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InsuranceWhereUniqueInput = {
    AND?: InputMaybe<Array<InsuranceWhereInput>>;
    NOT?: InputMaybe<Array<InsuranceWhereInput>>;
    OR?: InputMaybe<Array<InsuranceWhereInput>>;
    consumer?: InputMaybe<ConsumerNullableRelationFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrInsuranceId?: InputMaybe<StringNullableFilter>;
    ehrInsurancePackageId?: InputMaybe<StringNullableFilter>;
    groupNumber?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    insuranceAccountStatus?: InputMaybe<EnumInsuranceAccountStatusNullableFilter>;
    insuredDob?: InputMaybe<StringNullableFilter>;
    insuredFirstName?: InputMaybe<StringNullableFilter>;
    insuredLastName?: InputMaybe<StringNullableFilter>;
    insuredRelationshipCode?: InputMaybe<StringNullableFilter>;
    isPrimaryInsurance?: InputMaybe<BoolFilter>;
    lastCheckedAt?: InputMaybe<DateTimeFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    memberId?: InputMaybe<StringFilter>;
    otherInsurances?: InputMaybe<JsonNullableFilter>;
    payer?: InputMaybe<StringFilter>;
    pcpCoinsurancePercentage?: InputMaybe<IntNullableFilter>;
    pcpCopayAmount?: InputMaybe<IntNullableFilter>;
    pcpName?: InputMaybe<StringNullableFilter>;
    photos?: InputMaybe<ConsumerPhotoMetaDataListRelationFilter>;
    planEndDate?: InputMaybe<DateTimeNullableFilter>;
    planName?: InputMaybe<StringNullableFilter>;
    planStartDate?: InputMaybe<DateTimeNullableFilter>;
    priority?: InputMaybe<IntNullableFilter>;
    specialistCoinsurancePercentage?: InputMaybe<IntNullableFilter>;
    specialistCopayAmount?: InputMaybe<IntNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnuminsurancesStatusEnumFilter>;
    subscriberInfo?: InputMaybe<JsonNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntFieldUpdateOperationsInput = {
    decrement?: InputMaybe<Scalars['Int']['input']>;
    divide?: InputMaybe<Scalars['Int']['input']>;
    increment?: InputMaybe<Scalars['Int']['input']>;
    multiply?: InputMaybe<Scalars['Int']['input']>;
    set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
    equals?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<Scalars['Int']['input']>>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
    not?: InputMaybe<NestedIntFilter>;
    notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
    equals?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<Scalars['Int']['input']>>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
    not?: InputMaybe<NestedIntNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableListFilter = {
    equals?: InputMaybe<Array<Scalars['Int']['input']>>;
    has?: InputMaybe<Scalars['Int']['input']>;
    hasEvery?: InputMaybe<Array<Scalars['Int']['input']>>;
    hasSome?: InputMaybe<Array<Scalars['Int']['input']>>;
    isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntNullableWithAggregatesFilter = {
    _avg?: InputMaybe<NestedFloatNullableFilter>;
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedIntNullableFilter>;
    _min?: InputMaybe<NestedIntNullableFilter>;
    _sum?: InputMaybe<NestedIntNullableFilter>;
    equals?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<Scalars['Int']['input']>>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
    not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntWithAggregatesFilter = {
    _avg?: InputMaybe<NestedFloatFilter>;
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedIntFilter>;
    _min?: InputMaybe<NestedIntFilter>;
    _sum?: InputMaybe<NestedIntFilter>;
    equals?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<Scalars['Int']['input']>>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
    not?: InputMaybe<NestedIntWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntakeForm = {
    __typename?: 'IntakeForm';
    _count?: Maybe<IntakeFormCount>;
    associatedAppointmentTypeIds: Array<Scalars['Int']['output']>;
    associatedHrtIds: Array<Scalars['Int']['output']>;
    associatedPayerIds: Array<Scalars['Int']['output']>;
    athenaDocumentSubclass?: Maybe<Scalars['String']['output']>;
    autoAddRules: Array<AutoAddRule>;
    autoSendForOrg: Scalars['Boolean']['output'];
    autoSendPayerIds: Array<Scalars['Int']['output']>;
    completionTiming: CompletionTimingType;
    consentTypes: Array<ConsentType>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    intakeFormToQuestions: Array<IntakeFormToQuestion>;
    name: Scalars['String']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    postCheckRules: Array<AttachPostCheckRules>;
    preCheckRules: Array<AttachPreCheckRules>;
    priority: Scalars['Int']['output'];
    refreshPeriodInDays: Scalars['Int']['output'];
    sections: Array<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeFormIntakeFormToQuestionsArgs = {
    cursor?: InputMaybe<IntakeFormToQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormToQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormToQuestionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type IntakeFormAvgAggregate = {
    __typename?: 'IntakeFormAvgAggregate';
    associatedAppointmentTypeIds?: Maybe<Scalars['Float']['output']>;
    associatedHrtIds?: Maybe<Scalars['Float']['output']>;
    associatedPayerIds?: Maybe<Scalars['Float']['output']>;
    autoSendPayerIds?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
    refreshPeriodInDays?: Maybe<Scalars['Float']['output']>;
};

export type IntakeFormAvgOrderByAggregateInput = {
    associatedAppointmentTypeIds?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    associatedPayerIds?: InputMaybe<SortOrder>;
    autoSendPayerIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    refreshPeriodInDays?: InputMaybe<SortOrder>;
};

export type IntakeFormCount = {
    __typename?: 'IntakeFormCount';
    intakeFormToQuestions: Scalars['Int']['output'];
};

export type IntakeFormCountIntakeFormToQuestionsArgs = {
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type IntakeFormCountAggregate = {
    __typename?: 'IntakeFormCountAggregate';
    _all: Scalars['Int']['output'];
    associatedAppointmentTypeIds: Scalars['Int']['output'];
    associatedHrtIds: Scalars['Int']['output'];
    associatedPayerIds: Scalars['Int']['output'];
    athenaDocumentSubclass: Scalars['Int']['output'];
    autoAddRules: Scalars['Int']['output'];
    autoSendForOrg: Scalars['Int']['output'];
    autoSendPayerIds: Scalars['Int']['output'];
    completionTiming: Scalars['Int']['output'];
    consentTypes: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    postCheckRules: Scalars['Int']['output'];
    preCheckRules: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    refreshPeriodInDays: Scalars['Int']['output'];
    sections: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type IntakeFormCountOrderByAggregateInput = {
    associatedAppointmentTypeIds?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    associatedPayerIds?: InputMaybe<SortOrder>;
    athenaDocumentSubclass?: InputMaybe<SortOrder>;
    autoAddRules?: InputMaybe<SortOrder>;
    autoSendForOrg?: InputMaybe<SortOrder>;
    autoSendPayerIds?: InputMaybe<SortOrder>;
    completionTiming?: InputMaybe<SortOrder>;
    consentTypes?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    postCheckRules?: InputMaybe<SortOrder>;
    preCheckRules?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    refreshPeriodInDays?: InputMaybe<SortOrder>;
    sections?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormCreateInput = {
    associatedAppointmentTypeIds?: InputMaybe<IntakeFormCreateassociatedAppointmentTypeIdsInput>;
    associatedHrtIds?: InputMaybe<IntakeFormCreateassociatedHrtIdsInput>;
    associatedPayerIds?: InputMaybe<IntakeFormCreateassociatedPayerIdsInput>;
    athenaDocumentSubclass?: InputMaybe<Scalars['String']['input']>;
    autoAddRules?: InputMaybe<IntakeFormCreateautoAddRulesInput>;
    autoSendForOrg?: InputMaybe<Scalars['Boolean']['input']>;
    autoSendPayerIds?: InputMaybe<IntakeFormCreateautoSendPayerIdsInput>;
    completionTiming: CompletionTimingType;
    consentTypes?: InputMaybe<IntakeFormCreateconsentTypesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionCreateNestedManyWithoutIntakeFormInput>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeFormsInput;
    postCheckRules?: InputMaybe<IntakeFormCreatepostCheckRulesInput>;
    preCheckRules?: InputMaybe<IntakeFormCreatepreCheckRulesInput>;
    priority: Scalars['Int']['input'];
    refreshPeriodInDays?: InputMaybe<Scalars['Int']['input']>;
    sections?: InputMaybe<IntakeFormCreatesectionsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormCreateManyInput = {
    associatedAppointmentTypeIds?: InputMaybe<IntakeFormCreateassociatedAppointmentTypeIdsInput>;
    associatedHrtIds?: InputMaybe<IntakeFormCreateassociatedHrtIdsInput>;
    associatedPayerIds?: InputMaybe<IntakeFormCreateassociatedPayerIdsInput>;
    athenaDocumentSubclass?: InputMaybe<Scalars['String']['input']>;
    autoAddRules?: InputMaybe<IntakeFormCreateautoAddRulesInput>;
    autoSendForOrg?: InputMaybe<Scalars['Boolean']['input']>;
    autoSendPayerIds?: InputMaybe<IntakeFormCreateautoSendPayerIdsInput>;
    completionTiming: CompletionTimingType;
    consentTypes?: InputMaybe<IntakeFormCreateconsentTypesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    postCheckRules?: InputMaybe<IntakeFormCreatepostCheckRulesInput>;
    preCheckRules?: InputMaybe<IntakeFormCreatepreCheckRulesInput>;
    priority: Scalars['Int']['input'];
    refreshPeriodInDays?: InputMaybe<Scalars['Int']['input']>;
    sections?: InputMaybe<IntakeFormCreatesectionsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormCreateManyOrgInput = {
    associatedAppointmentTypeIds?: InputMaybe<IntakeFormCreateassociatedAppointmentTypeIdsInput>;
    associatedHrtIds?: InputMaybe<IntakeFormCreateassociatedHrtIdsInput>;
    associatedPayerIds?: InputMaybe<IntakeFormCreateassociatedPayerIdsInput>;
    athenaDocumentSubclass?: InputMaybe<Scalars['String']['input']>;
    autoAddRules?: InputMaybe<IntakeFormCreateautoAddRulesInput>;
    autoSendForOrg?: InputMaybe<Scalars['Boolean']['input']>;
    autoSendPayerIds?: InputMaybe<IntakeFormCreateautoSendPayerIdsInput>;
    completionTiming: CompletionTimingType;
    consentTypes?: InputMaybe<IntakeFormCreateconsentTypesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    postCheckRules?: InputMaybe<IntakeFormCreatepostCheckRulesInput>;
    preCheckRules?: InputMaybe<IntakeFormCreatepreCheckRulesInput>;
    priority: Scalars['Int']['input'];
    refreshPeriodInDays?: InputMaybe<Scalars['Int']['input']>;
    sections?: InputMaybe<IntakeFormCreatesectionsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormCreateManyOrgInputEnvelope = {
    data: Array<IntakeFormCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntakeFormCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<IntakeFormWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeFormCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<IntakeFormCreateWithoutOrgInput>>;
    createMany?: InputMaybe<IntakeFormCreateManyOrgInputEnvelope>;
};

export type IntakeFormCreateNestedOneWithoutIntakeFormToQuestionsInput = {
    connect?: InputMaybe<IntakeFormWhereUniqueInput>;
    connectOrCreate?: InputMaybe<IntakeFormCreateOrConnectWithoutIntakeFormToQuestionsInput>;
    create?: InputMaybe<IntakeFormCreateWithoutIntakeFormToQuestionsInput>;
};

export type IntakeFormCreateOrConnectWithoutIntakeFormToQuestionsInput = {
    create: IntakeFormCreateWithoutIntakeFormToQuestionsInput;
    where: IntakeFormWhereUniqueInput;
};

export type IntakeFormCreateOrConnectWithoutOrgInput = {
    create: IntakeFormCreateWithoutOrgInput;
    where: IntakeFormWhereUniqueInput;
};

export type IntakeFormCreateWithoutIntakeFormToQuestionsInput = {
    associatedAppointmentTypeIds?: InputMaybe<IntakeFormCreateassociatedAppointmentTypeIdsInput>;
    associatedHrtIds?: InputMaybe<IntakeFormCreateassociatedHrtIdsInput>;
    associatedPayerIds?: InputMaybe<IntakeFormCreateassociatedPayerIdsInput>;
    athenaDocumentSubclass?: InputMaybe<Scalars['String']['input']>;
    autoAddRules?: InputMaybe<IntakeFormCreateautoAddRulesInput>;
    autoSendForOrg?: InputMaybe<Scalars['Boolean']['input']>;
    autoSendPayerIds?: InputMaybe<IntakeFormCreateautoSendPayerIdsInput>;
    completionTiming: CompletionTimingType;
    consentTypes?: InputMaybe<IntakeFormCreateconsentTypesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeFormsInput;
    postCheckRules?: InputMaybe<IntakeFormCreatepostCheckRulesInput>;
    preCheckRules?: InputMaybe<IntakeFormCreatepreCheckRulesInput>;
    priority: Scalars['Int']['input'];
    refreshPeriodInDays?: InputMaybe<Scalars['Int']['input']>;
    sections?: InputMaybe<IntakeFormCreatesectionsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormCreateWithoutOrgInput = {
    associatedAppointmentTypeIds?: InputMaybe<IntakeFormCreateassociatedAppointmentTypeIdsInput>;
    associatedHrtIds?: InputMaybe<IntakeFormCreateassociatedHrtIdsInput>;
    associatedPayerIds?: InputMaybe<IntakeFormCreateassociatedPayerIdsInput>;
    athenaDocumentSubclass?: InputMaybe<Scalars['String']['input']>;
    autoAddRules?: InputMaybe<IntakeFormCreateautoAddRulesInput>;
    autoSendForOrg?: InputMaybe<Scalars['Boolean']['input']>;
    autoSendPayerIds?: InputMaybe<IntakeFormCreateautoSendPayerIdsInput>;
    completionTiming: CompletionTimingType;
    consentTypes?: InputMaybe<IntakeFormCreateconsentTypesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionCreateNestedManyWithoutIntakeFormInput>;
    name: Scalars['String']['input'];
    postCheckRules?: InputMaybe<IntakeFormCreatepostCheckRulesInput>;
    preCheckRules?: InputMaybe<IntakeFormCreatepreCheckRulesInput>;
    priority: Scalars['Int']['input'];
    refreshPeriodInDays?: InputMaybe<Scalars['Int']['input']>;
    sections?: InputMaybe<IntakeFormCreatesectionsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormCreateassociatedAppointmentTypeIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type IntakeFormCreateassociatedHrtIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type IntakeFormCreateassociatedPayerIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type IntakeFormCreateautoAddRulesInput = {
    set: Array<AutoAddRule>;
};

export type IntakeFormCreateautoSendPayerIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type IntakeFormCreateconsentTypesInput = {
    set: Array<ConsentType>;
};

export type IntakeFormCreatepostCheckRulesInput = {
    set: Array<AttachPostCheckRules>;
};

export type IntakeFormCreatepreCheckRulesInput = {
    set: Array<AttachPreCheckRules>;
};

export type IntakeFormCreatesectionsInput = {
    set: Array<Scalars['String']['input']>;
};

export type IntakeFormGroupBy = {
    __typename?: 'IntakeFormGroupBy';
    _avg?: Maybe<IntakeFormAvgAggregate>;
    _count?: Maybe<IntakeFormCountAggregate>;
    _max?: Maybe<IntakeFormMaxAggregate>;
    _min?: Maybe<IntakeFormMinAggregate>;
    _sum?: Maybe<IntakeFormSumAggregate>;
    associatedAppointmentTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
    associatedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    associatedPayerIds?: Maybe<Array<Scalars['Int']['output']>>;
    athenaDocumentSubclass?: Maybe<Scalars['String']['output']>;
    autoAddRules?: Maybe<Array<AutoAddRule>>;
    autoSendForOrg: Scalars['Boolean']['output'];
    autoSendPayerIds?: Maybe<Array<Scalars['Int']['output']>>;
    completionTiming: CompletionTimingType;
    consentTypes?: Maybe<Array<ConsentType>>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    postCheckRules?: Maybe<Array<AttachPostCheckRules>>;
    preCheckRules?: Maybe<Array<AttachPreCheckRules>>;
    priority: Scalars['Int']['output'];
    refreshPeriodInDays: Scalars['Int']['output'];
    sections?: Maybe<Array<Scalars['String']['output']>>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeFormListRelationFilter = {
    every?: InputMaybe<IntakeFormWhereInput>;
    none?: InputMaybe<IntakeFormWhereInput>;
    some?: InputMaybe<IntakeFormWhereInput>;
};

export type IntakeFormMaxAggregate = {
    __typename?: 'IntakeFormMaxAggregate';
    athenaDocumentSubclass?: Maybe<Scalars['String']['output']>;
    autoSendForOrg?: Maybe<Scalars['Boolean']['output']>;
    completionTiming?: Maybe<CompletionTimingType>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    refreshPeriodInDays?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeFormMaxOrderByAggregateInput = {
    athenaDocumentSubclass?: InputMaybe<SortOrder>;
    autoSendForOrg?: InputMaybe<SortOrder>;
    completionTiming?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    refreshPeriodInDays?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormMinAggregate = {
    __typename?: 'IntakeFormMinAggregate';
    athenaDocumentSubclass?: Maybe<Scalars['String']['output']>;
    autoSendForOrg?: Maybe<Scalars['Boolean']['output']>;
    completionTiming?: Maybe<CompletionTimingType>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    refreshPeriodInDays?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeFormMinOrderByAggregateInput = {
    athenaDocumentSubclass?: InputMaybe<SortOrder>;
    autoSendForOrg?: InputMaybe<SortOrder>;
    completionTiming?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    refreshPeriodInDays?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type IntakeFormOrderByWithAggregationInput = {
    _avg?: InputMaybe<IntakeFormAvgOrderByAggregateInput>;
    _count?: InputMaybe<IntakeFormCountOrderByAggregateInput>;
    _max?: InputMaybe<IntakeFormMaxOrderByAggregateInput>;
    _min?: InputMaybe<IntakeFormMinOrderByAggregateInput>;
    _sum?: InputMaybe<IntakeFormSumOrderByAggregateInput>;
    associatedAppointmentTypeIds?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    associatedPayerIds?: InputMaybe<SortOrder>;
    athenaDocumentSubclass?: InputMaybe<SortOrderInput>;
    autoAddRules?: InputMaybe<SortOrder>;
    autoSendForOrg?: InputMaybe<SortOrder>;
    autoSendPayerIds?: InputMaybe<SortOrder>;
    completionTiming?: InputMaybe<SortOrder>;
    consentTypes?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    postCheckRules?: InputMaybe<SortOrder>;
    preCheckRules?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    refreshPeriodInDays?: InputMaybe<SortOrder>;
    sections?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormOrderByWithRelationInput = {
    associatedAppointmentTypeIds?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    associatedPayerIds?: InputMaybe<SortOrder>;
    athenaDocumentSubclass?: InputMaybe<SortOrderInput>;
    autoAddRules?: InputMaybe<SortOrder>;
    autoSendForOrg?: InputMaybe<SortOrder>;
    autoSendPayerIds?: InputMaybe<SortOrder>;
    completionTiming?: InputMaybe<SortOrder>;
    consentTypes?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionOrderByRelationAggregateInput>;
    name?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    postCheckRules?: InputMaybe<SortOrder>;
    preCheckRules?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    refreshPeriodInDays?: InputMaybe<SortOrder>;
    sections?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormRelationFilter = {
    is?: InputMaybe<IntakeFormWhereInput>;
    isNot?: InputMaybe<IntakeFormWhereInput>;
};

export enum IntakeFormScalarFieldEnum {
    AssociatedAppointmentTypeIds = 'associatedAppointmentTypeIds',
    AssociatedHrtIds = 'associatedHrtIds',
    AssociatedPayerIds = 'associatedPayerIds',
    AthenaDocumentSubclass = 'athenaDocumentSubclass',
    AutoAddRules = 'autoAddRules',
    AutoSendForOrg = 'autoSendForOrg',
    AutoSendPayerIds = 'autoSendPayerIds',
    CompletionTiming = 'completionTiming',
    ConsentTypes = 'consentTypes',
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    Id = 'id',
    Name = 'name',
    OrgId = 'orgId',
    PostCheckRules = 'postCheckRules',
    PreCheckRules = 'preCheckRules',
    Priority = 'priority',
    RefreshPeriodInDays = 'refreshPeriodInDays',
    Sections = 'sections',
    UpdatedAt = 'updatedAt',
}

export type IntakeFormScalarWhereInput = {
    AND?: InputMaybe<Array<IntakeFormScalarWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormScalarWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormScalarWhereInput>>;
    associatedAppointmentTypeIds?: InputMaybe<IntNullableListFilter>;
    associatedHrtIds?: InputMaybe<IntNullableListFilter>;
    associatedPayerIds?: InputMaybe<IntNullableListFilter>;
    athenaDocumentSubclass?: InputMaybe<StringNullableFilter>;
    autoAddRules?: InputMaybe<EnumAutoAddRuleNullableListFilter>;
    autoSendForOrg?: InputMaybe<BoolFilter>;
    autoSendPayerIds?: InputMaybe<IntNullableListFilter>;
    completionTiming?: InputMaybe<EnumCompletionTimingTypeFilter>;
    consentTypes?: InputMaybe<EnumConsentTypeNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    postCheckRules?: InputMaybe<EnumAttachPostCheckRulesNullableListFilter>;
    preCheckRules?: InputMaybe<EnumAttachPreCheckRulesNullableListFilter>;
    priority?: InputMaybe<IntFilter>;
    refreshPeriodInDays?: InputMaybe<IntFilter>;
    sections?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<IntakeFormScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<IntakeFormScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<IntakeFormScalarWhereWithAggregatesInput>>;
    associatedAppointmentTypeIds?: InputMaybe<IntNullableListFilter>;
    associatedHrtIds?: InputMaybe<IntNullableListFilter>;
    associatedPayerIds?: InputMaybe<IntNullableListFilter>;
    athenaDocumentSubclass?: InputMaybe<StringNullableWithAggregatesFilter>;
    autoAddRules?: InputMaybe<EnumAutoAddRuleNullableListFilter>;
    autoSendForOrg?: InputMaybe<BoolWithAggregatesFilter>;
    autoSendPayerIds?: InputMaybe<IntNullableListFilter>;
    completionTiming?: InputMaybe<EnumCompletionTimingTypeWithAggregatesFilter>;
    consentTypes?: InputMaybe<EnumConsentTypeNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    postCheckRules?: InputMaybe<EnumAttachPostCheckRulesNullableListFilter>;
    preCheckRules?: InputMaybe<EnumAttachPreCheckRulesNullableListFilter>;
    priority?: InputMaybe<IntWithAggregatesFilter>;
    refreshPeriodInDays?: InputMaybe<IntWithAggregatesFilter>;
    sections?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type IntakeFormSection = {
    __typename?: 'IntakeFormSection';
    _count?: Maybe<IntakeFormSectionCount>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    intakeFormSectionTranslations: Array<IntakeFormSectionTranslation>;
    intakeQuestions: Array<IntakeQuestion>;
    name: Scalars['String']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    text: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeFormSectionIntakeFormSectionTranslationsArgs = {
    cursor?: InputMaybe<IntakeFormSectionTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormSectionTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<IntakeFormSectionTranslationOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
};

export type IntakeFormSectionIntakeQuestionsArgs = {
    cursor?: InputMaybe<IntakeQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeQuestionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type IntakeFormSectionAvgAggregate = {
    __typename?: 'IntakeFormSectionAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
};

export type IntakeFormSectionAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionCount = {
    __typename?: 'IntakeFormSectionCount';
    intakeFormSectionTranslations: Scalars['Int']['output'];
    intakeQuestions: Scalars['Int']['output'];
};

export type IntakeFormSectionCountIntakeFormSectionTranslationsArgs = {
    where?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
};

export type IntakeFormSectionCountIntakeQuestionsArgs = {
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type IntakeFormSectionCountAggregate = {
    __typename?: 'IntakeFormSectionCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    text: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type IntakeFormSectionCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSectionTranslations?: InputMaybe<IntakeFormSectionTranslationCreateNestedManyWithoutIntakeFormSectionInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutIntakeFormSectionInput>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeFormSectionsInput;
    priority: Scalars['Int']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormSectionCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    priority: Scalars['Int']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormSectionCreateManyOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    priority: Scalars['Int']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormSectionCreateManyOrgInputEnvelope = {
    data: Array<IntakeFormSectionCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntakeFormSectionCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<IntakeFormSectionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeFormSectionCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<IntakeFormSectionCreateWithoutOrgInput>>;
    createMany?: InputMaybe<IntakeFormSectionCreateManyOrgInputEnvelope>;
};

export type IntakeFormSectionCreateNestedOneWithoutIntakeFormSectionTranslationsInput =
    {
        connect?: InputMaybe<IntakeFormSectionWhereUniqueInput>;
        connectOrCreate?: InputMaybe<IntakeFormSectionCreateOrConnectWithoutIntakeFormSectionTranslationsInput>;
        create?: InputMaybe<IntakeFormSectionCreateWithoutIntakeFormSectionTranslationsInput>;
    };

export type IntakeFormSectionCreateNestedOneWithoutIntakeQuestionsInput = {
    connect?: InputMaybe<IntakeFormSectionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<IntakeFormSectionCreateOrConnectWithoutIntakeQuestionsInput>;
    create?: InputMaybe<IntakeFormSectionCreateWithoutIntakeQuestionsInput>;
};

export type IntakeFormSectionCreateOrConnectWithoutIntakeFormSectionTranslationsInput =
    {
        create: IntakeFormSectionCreateWithoutIntakeFormSectionTranslationsInput;
        where: IntakeFormSectionWhereUniqueInput;
    };

export type IntakeFormSectionCreateOrConnectWithoutIntakeQuestionsInput = {
    create: IntakeFormSectionCreateWithoutIntakeQuestionsInput;
    where: IntakeFormSectionWhereUniqueInput;
};

export type IntakeFormSectionCreateOrConnectWithoutOrgInput = {
    create: IntakeFormSectionCreateWithoutOrgInput;
    where: IntakeFormSectionWhereUniqueInput;
};

export type IntakeFormSectionCreateWithoutIntakeFormSectionTranslationsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutIntakeFormSectionInput>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeFormSectionsInput;
    priority: Scalars['Int']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormSectionCreateWithoutIntakeQuestionsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSectionTranslations?: InputMaybe<IntakeFormSectionTranslationCreateNestedManyWithoutIntakeFormSectionInput>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeFormSectionsInput;
    priority: Scalars['Int']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormSectionCreateWithoutOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSectionTranslations?: InputMaybe<IntakeFormSectionTranslationCreateNestedManyWithoutIntakeFormSectionInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutIntakeFormSectionInput>;
    name: Scalars['String']['input'];
    priority: Scalars['Int']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormSectionGroupBy = {
    __typename?: 'IntakeFormSectionGroupBy';
    _avg?: Maybe<IntakeFormSectionAvgAggregate>;
    _count?: Maybe<IntakeFormSectionCountAggregate>;
    _max?: Maybe<IntakeFormSectionMaxAggregate>;
    _min?: Maybe<IntakeFormSectionMinAggregate>;
    _sum?: Maybe<IntakeFormSectionSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    text: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeFormSectionListRelationFilter = {
    every?: InputMaybe<IntakeFormSectionWhereInput>;
    none?: InputMaybe<IntakeFormSectionWhereInput>;
    some?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type IntakeFormSectionMaxAggregate = {
    __typename?: 'IntakeFormSectionMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeFormSectionMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionMinAggregate = {
    __typename?: 'IntakeFormSectionMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeFormSectionMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionNullableRelationFilter = {
    is?: InputMaybe<IntakeFormSectionWhereInput>;
    isNot?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type IntakeFormSectionOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionOrderByWithAggregationInput = {
    _avg?: InputMaybe<IntakeFormSectionAvgOrderByAggregateInput>;
    _count?: InputMaybe<IntakeFormSectionCountOrderByAggregateInput>;
    _max?: InputMaybe<IntakeFormSectionMaxOrderByAggregateInput>;
    _min?: InputMaybe<IntakeFormSectionMinOrderByAggregateInput>;
    _sum?: InputMaybe<IntakeFormSectionSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    intakeFormSectionTranslations?: InputMaybe<IntakeFormSectionTranslationOrderByRelationAggregateInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionOrderByRelationAggregateInput>;
    name?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionRelationFilter = {
    is?: InputMaybe<IntakeFormSectionWhereInput>;
    isNot?: InputMaybe<IntakeFormSectionWhereInput>;
};

export enum IntakeFormSectionScalarFieldEnum {
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    Id = 'id',
    Name = 'name',
    OrgId = 'orgId',
    Priority = 'priority',
    Text = 'text',
    UpdatedAt = 'updatedAt',
}

export type IntakeFormSectionScalarWhereInput = {
    AND?: InputMaybe<Array<IntakeFormSectionScalarWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormSectionScalarWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormSectionScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    priority?: InputMaybe<IntFilter>;
    text?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormSectionScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<IntakeFormSectionScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<IntakeFormSectionScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<IntakeFormSectionScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    priority?: InputMaybe<IntWithAggregatesFilter>;
    text?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type IntakeFormSectionSumAggregate = {
    __typename?: 'IntakeFormSectionSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
};

export type IntakeFormSectionSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionTranslation = {
    __typename?: 'IntakeFormSectionTranslation';
    createdAt: Scalars['DateTimeISO']['output'];
    intakeFormSection: IntakeFormSection;
    intakeFormSectionId: Scalars['Int']['output'];
    languageCode: Scalars['String']['output'];
    name: Scalars['String']['output'];
    text: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeFormSectionTranslationAvgAggregate = {
    __typename?: 'IntakeFormSectionTranslationAvgAggregate';
    intakeFormSectionId?: Maybe<Scalars['Float']['output']>;
};

export type IntakeFormSectionTranslationAvgOrderByAggregateInput = {
    intakeFormSectionId?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionTranslationCountAggregate = {
    __typename?: 'IntakeFormSectionTranslationCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    intakeFormSectionId: Scalars['Int']['output'];
    languageCode: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    text: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type IntakeFormSectionTranslationCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeFormSectionId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionTranslationCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeFormSection: IntakeFormSectionCreateNestedOneWithoutIntakeFormSectionTranslationsInput;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormSectionTranslationCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeFormSectionId: Scalars['Int']['input'];
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormSectionTranslationCreateManyIntakeFormSectionInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormSectionTranslationCreateManyIntakeFormSectionInputEnvelope =
    {
        data: Array<IntakeFormSectionTranslationCreateManyIntakeFormSectionInput>;
        skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
    };

export type IntakeFormSectionTranslationCreateNestedManyWithoutIntakeFormSectionInput =
    {
        connect?: InputMaybe<
            Array<IntakeFormSectionTranslationWhereUniqueInput>
        >;
        connectOrCreate?: InputMaybe<
            Array<IntakeFormSectionTranslationCreateOrConnectWithoutIntakeFormSectionInput>
        >;
        create?: InputMaybe<
            Array<IntakeFormSectionTranslationCreateWithoutIntakeFormSectionInput>
        >;
        createMany?: InputMaybe<IntakeFormSectionTranslationCreateManyIntakeFormSectionInputEnvelope>;
    };

export type IntakeFormSectionTranslationCreateOrConnectWithoutIntakeFormSectionInput =
    {
        create: IntakeFormSectionTranslationCreateWithoutIntakeFormSectionInput;
        where: IntakeFormSectionTranslationWhereUniqueInput;
    };

export type IntakeFormSectionTranslationCreateWithoutIntakeFormSectionInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    text: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormSectionTranslationGroupBy = {
    __typename?: 'IntakeFormSectionTranslationGroupBy';
    _avg?: Maybe<IntakeFormSectionTranslationAvgAggregate>;
    _count?: Maybe<IntakeFormSectionTranslationCountAggregate>;
    _max?: Maybe<IntakeFormSectionTranslationMaxAggregate>;
    _min?: Maybe<IntakeFormSectionTranslationMinAggregate>;
    _sum?: Maybe<IntakeFormSectionTranslationSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    intakeFormSectionId: Scalars['Int']['output'];
    languageCode: Scalars['String']['output'];
    name: Scalars['String']['output'];
    text: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeFormSectionTranslationIntakeFormSectionIdLanguageCodeCompoundUniqueInput =
    {
        intakeFormSectionId: Scalars['Int']['input'];
        languageCode: Scalars['String']['input'];
    };

export type IntakeFormSectionTranslationListRelationFilter = {
    every?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
    none?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
    some?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
};

export type IntakeFormSectionTranslationMaxAggregate = {
    __typename?: 'IntakeFormSectionTranslationMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    intakeFormSectionId?: Maybe<Scalars['Int']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeFormSectionTranslationMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeFormSectionId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionTranslationMinAggregate = {
    __typename?: 'IntakeFormSectionTranslationMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    intakeFormSectionId?: Maybe<Scalars['Int']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeFormSectionTranslationMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeFormSectionId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionTranslationOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionTranslationOrderByWithAggregationInput = {
    _avg?: InputMaybe<IntakeFormSectionTranslationAvgOrderByAggregateInput>;
    _count?: InputMaybe<IntakeFormSectionTranslationCountOrderByAggregateInput>;
    _max?: InputMaybe<IntakeFormSectionTranslationMaxOrderByAggregateInput>;
    _min?: InputMaybe<IntakeFormSectionTranslationMinOrderByAggregateInput>;
    _sum?: InputMaybe<IntakeFormSectionTranslationSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    intakeFormSectionId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionTranslationOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeFormSection?: InputMaybe<IntakeFormSectionOrderByWithRelationInput>;
    intakeFormSectionId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum IntakeFormSectionTranslationScalarFieldEnum {
    CreatedAt = 'createdAt',
    IntakeFormSectionId = 'intakeFormSectionId',
    LanguageCode = 'languageCode',
    Name = 'name',
    Text = 'text',
    UpdatedAt = 'updatedAt',
}

export type IntakeFormSectionTranslationScalarWhereInput = {
    AND?: InputMaybe<Array<IntakeFormSectionTranslationScalarWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormSectionTranslationScalarWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormSectionTranslationScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeFormSectionId?: InputMaybe<IntFilter>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    text?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormSectionTranslationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<IntakeFormSectionTranslationScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<IntakeFormSectionTranslationScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<IntakeFormSectionTranslationScalarWhereWithAggregatesInput>
    >;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    intakeFormSectionId?: InputMaybe<IntWithAggregatesFilter>;
    languageCode?: InputMaybe<StringWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    text?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type IntakeFormSectionTranslationSumAggregate = {
    __typename?: 'IntakeFormSectionTranslationSumAggregate';
    intakeFormSectionId?: Maybe<Scalars['Int']['output']>;
};

export type IntakeFormSectionTranslationSumOrderByAggregateInput = {
    intakeFormSectionId?: InputMaybe<SortOrder>;
};

export type IntakeFormSectionTranslationUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    intakeFormSection?: InputMaybe<IntakeFormSectionUpdateOneRequiredWithoutIntakeFormSectionTranslationsNestedInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    text?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormSectionTranslationUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    text?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormSectionTranslationUpdateManyWithWhereWithoutIntakeFormSectionInput =
    {
        data: IntakeFormSectionTranslationUpdateManyMutationInput;
        where: IntakeFormSectionTranslationScalarWhereInput;
    };

export type IntakeFormSectionTranslationUpdateManyWithoutIntakeFormSectionNestedInput =
    {
        connect?: InputMaybe<
            Array<IntakeFormSectionTranslationWhereUniqueInput>
        >;
        connectOrCreate?: InputMaybe<
            Array<IntakeFormSectionTranslationCreateOrConnectWithoutIntakeFormSectionInput>
        >;
        create?: InputMaybe<
            Array<IntakeFormSectionTranslationCreateWithoutIntakeFormSectionInput>
        >;
        createMany?: InputMaybe<IntakeFormSectionTranslationCreateManyIntakeFormSectionInputEnvelope>;
        delete?: InputMaybe<
            Array<IntakeFormSectionTranslationWhereUniqueInput>
        >;
        deleteMany?: InputMaybe<
            Array<IntakeFormSectionTranslationScalarWhereInput>
        >;
        disconnect?: InputMaybe<
            Array<IntakeFormSectionTranslationWhereUniqueInput>
        >;
        set?: InputMaybe<Array<IntakeFormSectionTranslationWhereUniqueInput>>;
        update?: InputMaybe<
            Array<IntakeFormSectionTranslationUpdateWithWhereUniqueWithoutIntakeFormSectionInput>
        >;
        updateMany?: InputMaybe<
            Array<IntakeFormSectionTranslationUpdateManyWithWhereWithoutIntakeFormSectionInput>
        >;
        upsert?: InputMaybe<
            Array<IntakeFormSectionTranslationUpsertWithWhereUniqueWithoutIntakeFormSectionInput>
        >;
    };

export type IntakeFormSectionTranslationUpdateWithWhereUniqueWithoutIntakeFormSectionInput =
    {
        data: IntakeFormSectionTranslationUpdateWithoutIntakeFormSectionInput;
        where: IntakeFormSectionTranslationWhereUniqueInput;
    };

export type IntakeFormSectionTranslationUpdateWithoutIntakeFormSectionInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    text?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormSectionTranslationUpsertWithWhereUniqueWithoutIntakeFormSectionInput =
    {
        create: IntakeFormSectionTranslationCreateWithoutIntakeFormSectionInput;
        update: IntakeFormSectionTranslationUpdateWithoutIntakeFormSectionInput;
        where: IntakeFormSectionTranslationWhereUniqueInput;
    };

export type IntakeFormSectionTranslationWhereInput = {
    AND?: InputMaybe<Array<IntakeFormSectionTranslationWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormSectionTranslationWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormSectionTranslationWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeFormSection?: InputMaybe<IntakeFormSectionRelationFilter>;
    intakeFormSectionId?: InputMaybe<IntFilter>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    text?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormSectionTranslationWhereUniqueInput = {
    AND?: InputMaybe<Array<IntakeFormSectionTranslationWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormSectionTranslationWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormSectionTranslationWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeFormSection?: InputMaybe<IntakeFormSectionRelationFilter>;
    intakeFormSectionId?: InputMaybe<IntFilter>;
    intakeFormSectionId_languageCode?: InputMaybe<IntakeFormSectionTranslationIntakeFormSectionIdLanguageCodeCompoundUniqueInput>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    text?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormSectionUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSectionTranslations?: InputMaybe<IntakeFormSectionTranslationUpdateManyWithoutIntakeFormSectionNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutIntakeFormSectionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeFormSectionsNestedInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    text?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormSectionUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    text?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormSectionUpdateManyWithWhereWithoutOrgInput = {
    data: IntakeFormSectionUpdateManyMutationInput;
    where: IntakeFormSectionScalarWhereInput;
};

export type IntakeFormSectionUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<IntakeFormSectionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeFormSectionCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<IntakeFormSectionCreateWithoutOrgInput>>;
    createMany?: InputMaybe<IntakeFormSectionCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<IntakeFormSectionWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<IntakeFormSectionScalarWhereInput>>;
    disconnect?: InputMaybe<Array<IntakeFormSectionWhereUniqueInput>>;
    set?: InputMaybe<Array<IntakeFormSectionWhereUniqueInput>>;
    update?: InputMaybe<
        Array<IntakeFormSectionUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<IntakeFormSectionUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<IntakeFormSectionUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type IntakeFormSectionUpdateOneRequiredWithoutIntakeFormSectionTranslationsNestedInput =
    {
        connect?: InputMaybe<IntakeFormSectionWhereUniqueInput>;
        connectOrCreate?: InputMaybe<IntakeFormSectionCreateOrConnectWithoutIntakeFormSectionTranslationsInput>;
        create?: InputMaybe<IntakeFormSectionCreateWithoutIntakeFormSectionTranslationsInput>;
        update?: InputMaybe<IntakeFormSectionUpdateToOneWithWhereWithoutIntakeFormSectionTranslationsInput>;
        upsert?: InputMaybe<IntakeFormSectionUpsertWithoutIntakeFormSectionTranslationsInput>;
    };

export type IntakeFormSectionUpdateOneWithoutIntakeQuestionsNestedInput = {
    connect?: InputMaybe<IntakeFormSectionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<IntakeFormSectionCreateOrConnectWithoutIntakeQuestionsInput>;
    create?: InputMaybe<IntakeFormSectionCreateWithoutIntakeQuestionsInput>;
    delete?: InputMaybe<IntakeFormSectionWhereInput>;
    disconnect?: InputMaybe<IntakeFormSectionWhereInput>;
    update?: InputMaybe<IntakeFormSectionUpdateToOneWithWhereWithoutIntakeQuestionsInput>;
    upsert?: InputMaybe<IntakeFormSectionUpsertWithoutIntakeQuestionsInput>;
};

export type IntakeFormSectionUpdateToOneWithWhereWithoutIntakeFormSectionTranslationsInput =
    {
        data: IntakeFormSectionUpdateWithoutIntakeFormSectionTranslationsInput;
        where?: InputMaybe<IntakeFormSectionWhereInput>;
    };

export type IntakeFormSectionUpdateToOneWithWhereWithoutIntakeQuestionsInput = {
    data: IntakeFormSectionUpdateWithoutIntakeQuestionsInput;
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type IntakeFormSectionUpdateWithWhereUniqueWithoutOrgInput = {
    data: IntakeFormSectionUpdateWithoutOrgInput;
    where: IntakeFormSectionWhereUniqueInput;
};

export type IntakeFormSectionUpdateWithoutIntakeFormSectionTranslationsInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutIntakeFormSectionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeFormSectionsNestedInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    text?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormSectionUpdateWithoutIntakeQuestionsInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSectionTranslations?: InputMaybe<IntakeFormSectionTranslationUpdateManyWithoutIntakeFormSectionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeFormSectionsNestedInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    text?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormSectionUpdateWithoutOrgInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSectionTranslations?: InputMaybe<IntakeFormSectionTranslationUpdateManyWithoutIntakeFormSectionNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutIntakeFormSectionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    text?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormSectionUpsertWithWhereUniqueWithoutOrgInput = {
    create: IntakeFormSectionCreateWithoutOrgInput;
    update: IntakeFormSectionUpdateWithoutOrgInput;
    where: IntakeFormSectionWhereUniqueInput;
};

export type IntakeFormSectionUpsertWithoutIntakeFormSectionTranslationsInput = {
    create: IntakeFormSectionCreateWithoutIntakeFormSectionTranslationsInput;
    update: IntakeFormSectionUpdateWithoutIntakeFormSectionTranslationsInput;
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type IntakeFormSectionUpsertWithoutIntakeQuestionsInput = {
    create: IntakeFormSectionCreateWithoutIntakeQuestionsInput;
    update: IntakeFormSectionUpdateWithoutIntakeQuestionsInput;
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type IntakeFormSectionWhereInput = {
    AND?: InputMaybe<Array<IntakeFormSectionWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormSectionWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormSectionWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    intakeFormSectionTranslations?: InputMaybe<IntakeFormSectionTranslationListRelationFilter>;
    intakeQuestions?: InputMaybe<IntakeQuestionListRelationFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    priority?: InputMaybe<IntFilter>;
    text?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormSectionWhereUniqueInput = {
    AND?: InputMaybe<Array<IntakeFormSectionWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormSectionWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormSectionWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    intakeFormSectionTranslations?: InputMaybe<IntakeFormSectionTranslationListRelationFilter>;
    intakeQuestions?: InputMaybe<IntakeQuestionListRelationFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    priority?: InputMaybe<IntFilter>;
    text?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormSumAggregate = {
    __typename?: 'IntakeFormSumAggregate';
    associatedAppointmentTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
    associatedHrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    associatedPayerIds?: Maybe<Array<Scalars['Int']['output']>>;
    autoSendPayerIds?: Maybe<Array<Scalars['Int']['output']>>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    refreshPeriodInDays?: Maybe<Scalars['Int']['output']>;
};

export type IntakeFormSumOrderByAggregateInput = {
    associatedAppointmentTypeIds?: InputMaybe<SortOrder>;
    associatedHrtIds?: InputMaybe<SortOrder>;
    associatedPayerIds?: InputMaybe<SortOrder>;
    autoSendPayerIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    refreshPeriodInDays?: InputMaybe<SortOrder>;
};

export type IntakeFormToQuestion = {
    __typename?: 'IntakeFormToQuestion';
    createdAt: Scalars['DateTimeISO']['output'];
    intakeForm: IntakeForm;
    intakeFormId: Scalars['Int']['output'];
    intakeQuestion: IntakeQuestion;
    intakeQuestionId: Scalars['Int']['output'];
    isRequired: Scalars['Boolean']['output'];
    questionNumber: Scalars['Int']['output'];
    section?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeFormToQuestionAvgAggregate = {
    __typename?: 'IntakeFormToQuestionAvgAggregate';
    intakeFormId?: Maybe<Scalars['Float']['output']>;
    intakeQuestionId?: Maybe<Scalars['Float']['output']>;
    questionNumber?: Maybe<Scalars['Float']['output']>;
};

export type IntakeFormToQuestionAvgOrderByAggregateInput = {
    intakeFormId?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    questionNumber?: InputMaybe<SortOrder>;
};

export type IntakeFormToQuestionCountAggregate = {
    __typename?: 'IntakeFormToQuestionCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    intakeFormId: Scalars['Int']['output'];
    intakeQuestionId: Scalars['Int']['output'];
    isRequired: Scalars['Int']['output'];
    questionNumber: Scalars['Int']['output'];
    section: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type IntakeFormToQuestionCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeFormId?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    isRequired?: InputMaybe<SortOrder>;
    questionNumber?: InputMaybe<SortOrder>;
    section?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormToQuestionCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeForm: IntakeFormCreateNestedOneWithoutIntakeFormToQuestionsInput;
    intakeQuestion: IntakeQuestionCreateNestedOneWithoutIntakeFormToQuestionsInput;
    isRequired?: InputMaybe<Scalars['Boolean']['input']>;
    questionNumber: Scalars['Int']['input'];
    section?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormToQuestionCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeFormId: Scalars['Int']['input'];
    intakeQuestionId: Scalars['Int']['input'];
    isRequired?: InputMaybe<Scalars['Boolean']['input']>;
    questionNumber: Scalars['Int']['input'];
    section?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormToQuestionCreateManyIntakeFormInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeQuestionId: Scalars['Int']['input'];
    isRequired?: InputMaybe<Scalars['Boolean']['input']>;
    questionNumber: Scalars['Int']['input'];
    section?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormToQuestionCreateManyIntakeFormInputEnvelope = {
    data: Array<IntakeFormToQuestionCreateManyIntakeFormInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntakeFormToQuestionCreateManyIntakeQuestionInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeFormId: Scalars['Int']['input'];
    isRequired?: InputMaybe<Scalars['Boolean']['input']>;
    questionNumber: Scalars['Int']['input'];
    section?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormToQuestionCreateManyIntakeQuestionInputEnvelope = {
    data: Array<IntakeFormToQuestionCreateManyIntakeQuestionInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntakeFormToQuestionCreateNestedManyWithoutIntakeFormInput = {
    connect?: InputMaybe<Array<IntakeFormToQuestionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeFormToQuestionCreateOrConnectWithoutIntakeFormInput>
    >;
    create?: InputMaybe<
        Array<IntakeFormToQuestionCreateWithoutIntakeFormInput>
    >;
    createMany?: InputMaybe<IntakeFormToQuestionCreateManyIntakeFormInputEnvelope>;
};

export type IntakeFormToQuestionCreateNestedManyWithoutIntakeQuestionInput = {
    connect?: InputMaybe<Array<IntakeFormToQuestionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeFormToQuestionCreateOrConnectWithoutIntakeQuestionInput>
    >;
    create?: InputMaybe<
        Array<IntakeFormToQuestionCreateWithoutIntakeQuestionInput>
    >;
    createMany?: InputMaybe<IntakeFormToQuestionCreateManyIntakeQuestionInputEnvelope>;
};

export type IntakeFormToQuestionCreateOrConnectWithoutIntakeFormInput = {
    create: IntakeFormToQuestionCreateWithoutIntakeFormInput;
    where: IntakeFormToQuestionWhereUniqueInput;
};

export type IntakeFormToQuestionCreateOrConnectWithoutIntakeQuestionInput = {
    create: IntakeFormToQuestionCreateWithoutIntakeQuestionInput;
    where: IntakeFormToQuestionWhereUniqueInput;
};

export type IntakeFormToQuestionCreateWithoutIntakeFormInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeQuestion: IntakeQuestionCreateNestedOneWithoutIntakeFormToQuestionsInput;
    isRequired?: InputMaybe<Scalars['Boolean']['input']>;
    questionNumber: Scalars['Int']['input'];
    section?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormToQuestionCreateWithoutIntakeQuestionInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeForm: IntakeFormCreateNestedOneWithoutIntakeFormToQuestionsInput;
    isRequired?: InputMaybe<Scalars['Boolean']['input']>;
    questionNumber: Scalars['Int']['input'];
    section?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeFormToQuestionGroupBy = {
    __typename?: 'IntakeFormToQuestionGroupBy';
    _avg?: Maybe<IntakeFormToQuestionAvgAggregate>;
    _count?: Maybe<IntakeFormToQuestionCountAggregate>;
    _max?: Maybe<IntakeFormToQuestionMaxAggregate>;
    _min?: Maybe<IntakeFormToQuestionMinAggregate>;
    _sum?: Maybe<IntakeFormToQuestionSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    intakeFormId: Scalars['Int']['output'];
    intakeQuestionId: Scalars['Int']['output'];
    isRequired: Scalars['Boolean']['output'];
    questionNumber: Scalars['Int']['output'];
    section?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeFormToQuestionIntakeFormIdQuestionNumberCompoundUniqueInput =
    {
        intakeFormId: Scalars['Int']['input'];
        questionNumber: Scalars['Int']['input'];
    };

export type IntakeFormToQuestionListRelationFilter = {
    every?: InputMaybe<IntakeFormToQuestionWhereInput>;
    none?: InputMaybe<IntakeFormToQuestionWhereInput>;
    some?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type IntakeFormToQuestionMaxAggregate = {
    __typename?: 'IntakeFormToQuestionMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    intakeFormId?: Maybe<Scalars['Int']['output']>;
    intakeQuestionId?: Maybe<Scalars['Int']['output']>;
    isRequired?: Maybe<Scalars['Boolean']['output']>;
    questionNumber?: Maybe<Scalars['Int']['output']>;
    section?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeFormToQuestionMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeFormId?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    isRequired?: InputMaybe<SortOrder>;
    questionNumber?: InputMaybe<SortOrder>;
    section?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormToQuestionMinAggregate = {
    __typename?: 'IntakeFormToQuestionMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    intakeFormId?: Maybe<Scalars['Int']['output']>;
    intakeQuestionId?: Maybe<Scalars['Int']['output']>;
    isRequired?: Maybe<Scalars['Boolean']['output']>;
    questionNumber?: Maybe<Scalars['Int']['output']>;
    section?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeFormToQuestionMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeFormId?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    isRequired?: InputMaybe<SortOrder>;
    questionNumber?: InputMaybe<SortOrder>;
    section?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormToQuestionOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type IntakeFormToQuestionOrderByWithAggregationInput = {
    _avg?: InputMaybe<IntakeFormToQuestionAvgOrderByAggregateInput>;
    _count?: InputMaybe<IntakeFormToQuestionCountOrderByAggregateInput>;
    _max?: InputMaybe<IntakeFormToQuestionMaxOrderByAggregateInput>;
    _min?: InputMaybe<IntakeFormToQuestionMinOrderByAggregateInput>;
    _sum?: InputMaybe<IntakeFormToQuestionSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    intakeFormId?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    isRequired?: InputMaybe<SortOrder>;
    questionNumber?: InputMaybe<SortOrder>;
    section?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeFormToQuestionOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeForm?: InputMaybe<IntakeFormOrderByWithRelationInput>;
    intakeFormId?: InputMaybe<SortOrder>;
    intakeQuestion?: InputMaybe<IntakeQuestionOrderByWithRelationInput>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    isRequired?: InputMaybe<SortOrder>;
    questionNumber?: InputMaybe<SortOrder>;
    section?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum IntakeFormToQuestionScalarFieldEnum {
    CreatedAt = 'createdAt',
    IntakeFormId = 'intakeFormId',
    IntakeQuestionId = 'intakeQuestionId',
    IsRequired = 'isRequired',
    QuestionNumber = 'questionNumber',
    Section = 'section',
    UpdatedAt = 'updatedAt',
}

export type IntakeFormToQuestionScalarWhereInput = {
    AND?: InputMaybe<Array<IntakeFormToQuestionScalarWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormToQuestionScalarWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormToQuestionScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeFormId?: InputMaybe<IntFilter>;
    intakeQuestionId?: InputMaybe<IntFilter>;
    isRequired?: InputMaybe<BoolFilter>;
    questionNumber?: InputMaybe<IntFilter>;
    section?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormToQuestionScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<IntakeFormToQuestionScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<IntakeFormToQuestionScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<IntakeFormToQuestionScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    intakeFormId?: InputMaybe<IntWithAggregatesFilter>;
    intakeQuestionId?: InputMaybe<IntWithAggregatesFilter>;
    isRequired?: InputMaybe<BoolWithAggregatesFilter>;
    questionNumber?: InputMaybe<IntWithAggregatesFilter>;
    section?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type IntakeFormToQuestionSumAggregate = {
    __typename?: 'IntakeFormToQuestionSumAggregate';
    intakeFormId?: Maybe<Scalars['Int']['output']>;
    intakeQuestionId?: Maybe<Scalars['Int']['output']>;
    questionNumber?: Maybe<Scalars['Int']['output']>;
};

export type IntakeFormToQuestionSumOrderByAggregateInput = {
    intakeFormId?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    questionNumber?: InputMaybe<SortOrder>;
};

export type IntakeFormToQuestionUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    intakeForm?: InputMaybe<IntakeFormUpdateOneRequiredWithoutIntakeFormToQuestionsNestedInput>;
    intakeQuestion?: InputMaybe<IntakeQuestionUpdateOneRequiredWithoutIntakeFormToQuestionsNestedInput>;
    isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
    questionNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
    section?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormToQuestionUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
    questionNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
    section?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormToQuestionUpdateManyWithWhereWithoutIntakeFormInput = {
    data: IntakeFormToQuestionUpdateManyMutationInput;
    where: IntakeFormToQuestionScalarWhereInput;
};

export type IntakeFormToQuestionUpdateManyWithWhereWithoutIntakeQuestionInput =
    {
        data: IntakeFormToQuestionUpdateManyMutationInput;
        where: IntakeFormToQuestionScalarWhereInput;
    };

export type IntakeFormToQuestionUpdateManyWithoutIntakeFormNestedInput = {
    connect?: InputMaybe<Array<IntakeFormToQuestionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeFormToQuestionCreateOrConnectWithoutIntakeFormInput>
    >;
    create?: InputMaybe<
        Array<IntakeFormToQuestionCreateWithoutIntakeFormInput>
    >;
    createMany?: InputMaybe<IntakeFormToQuestionCreateManyIntakeFormInputEnvelope>;
    delete?: InputMaybe<Array<IntakeFormToQuestionWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<IntakeFormToQuestionScalarWhereInput>>;
    disconnect?: InputMaybe<Array<IntakeFormToQuestionWhereUniqueInput>>;
    set?: InputMaybe<Array<IntakeFormToQuestionWhereUniqueInput>>;
    update?: InputMaybe<
        Array<IntakeFormToQuestionUpdateWithWhereUniqueWithoutIntakeFormInput>
    >;
    updateMany?: InputMaybe<
        Array<IntakeFormToQuestionUpdateManyWithWhereWithoutIntakeFormInput>
    >;
    upsert?: InputMaybe<
        Array<IntakeFormToQuestionUpsertWithWhereUniqueWithoutIntakeFormInput>
    >;
};

export type IntakeFormToQuestionUpdateManyWithoutIntakeQuestionNestedInput = {
    connect?: InputMaybe<Array<IntakeFormToQuestionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeFormToQuestionCreateOrConnectWithoutIntakeQuestionInput>
    >;
    create?: InputMaybe<
        Array<IntakeFormToQuestionCreateWithoutIntakeQuestionInput>
    >;
    createMany?: InputMaybe<IntakeFormToQuestionCreateManyIntakeQuestionInputEnvelope>;
    delete?: InputMaybe<Array<IntakeFormToQuestionWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<IntakeFormToQuestionScalarWhereInput>>;
    disconnect?: InputMaybe<Array<IntakeFormToQuestionWhereUniqueInput>>;
    set?: InputMaybe<Array<IntakeFormToQuestionWhereUniqueInput>>;
    update?: InputMaybe<
        Array<IntakeFormToQuestionUpdateWithWhereUniqueWithoutIntakeQuestionInput>
    >;
    updateMany?: InputMaybe<
        Array<IntakeFormToQuestionUpdateManyWithWhereWithoutIntakeQuestionInput>
    >;
    upsert?: InputMaybe<
        Array<IntakeFormToQuestionUpsertWithWhereUniqueWithoutIntakeQuestionInput>
    >;
};

export type IntakeFormToQuestionUpdateWithWhereUniqueWithoutIntakeFormInput = {
    data: IntakeFormToQuestionUpdateWithoutIntakeFormInput;
    where: IntakeFormToQuestionWhereUniqueInput;
};

export type IntakeFormToQuestionUpdateWithWhereUniqueWithoutIntakeQuestionInput =
    {
        data: IntakeFormToQuestionUpdateWithoutIntakeQuestionInput;
        where: IntakeFormToQuestionWhereUniqueInput;
    };

export type IntakeFormToQuestionUpdateWithoutIntakeFormInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    intakeQuestion?: InputMaybe<IntakeQuestionUpdateOneRequiredWithoutIntakeFormToQuestionsNestedInput>;
    isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
    questionNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
    section?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormToQuestionUpdateWithoutIntakeQuestionInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    intakeForm?: InputMaybe<IntakeFormUpdateOneRequiredWithoutIntakeFormToQuestionsNestedInput>;
    isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
    questionNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
    section?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormToQuestionUpsertWithWhereUniqueWithoutIntakeFormInput = {
    create: IntakeFormToQuestionCreateWithoutIntakeFormInput;
    update: IntakeFormToQuestionUpdateWithoutIntakeFormInput;
    where: IntakeFormToQuestionWhereUniqueInput;
};

export type IntakeFormToQuestionUpsertWithWhereUniqueWithoutIntakeQuestionInput =
    {
        create: IntakeFormToQuestionCreateWithoutIntakeQuestionInput;
        update: IntakeFormToQuestionUpdateWithoutIntakeQuestionInput;
        where: IntakeFormToQuestionWhereUniqueInput;
    };

export type IntakeFormToQuestionWhereInput = {
    AND?: InputMaybe<Array<IntakeFormToQuestionWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormToQuestionWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormToQuestionWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeForm?: InputMaybe<IntakeFormRelationFilter>;
    intakeFormId?: InputMaybe<IntFilter>;
    intakeQuestion?: InputMaybe<IntakeQuestionRelationFilter>;
    intakeQuestionId?: InputMaybe<IntFilter>;
    isRequired?: InputMaybe<BoolFilter>;
    questionNumber?: InputMaybe<IntFilter>;
    section?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormToQuestionWhereUniqueInput = {
    AND?: InputMaybe<Array<IntakeFormToQuestionWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormToQuestionWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormToQuestionWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeForm?: InputMaybe<IntakeFormRelationFilter>;
    intakeFormId?: InputMaybe<IntFilter>;
    intakeFormId_questionNumber?: InputMaybe<IntakeFormToQuestionIntakeFormIdQuestionNumberCompoundUniqueInput>;
    intakeQuestion?: InputMaybe<IntakeQuestionRelationFilter>;
    intakeQuestionId?: InputMaybe<IntFilter>;
    isRequired?: InputMaybe<BoolFilter>;
    questionNumber?: InputMaybe<IntFilter>;
    section?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormUpdateInput = {
    associatedAppointmentTypeIds?: InputMaybe<IntakeFormUpdateassociatedAppointmentTypeIdsInput>;
    associatedHrtIds?: InputMaybe<IntakeFormUpdateassociatedHrtIdsInput>;
    associatedPayerIds?: InputMaybe<IntakeFormUpdateassociatedPayerIdsInput>;
    athenaDocumentSubclass?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    autoAddRules?: InputMaybe<IntakeFormUpdateautoAddRulesInput>;
    autoSendForOrg?: InputMaybe<BoolFieldUpdateOperationsInput>;
    autoSendPayerIds?: InputMaybe<IntakeFormUpdateautoSendPayerIdsInput>;
    completionTiming?: InputMaybe<EnumCompletionTimingTypeFieldUpdateOperationsInput>;
    consentTypes?: InputMaybe<IntakeFormUpdateconsentTypesInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionUpdateManyWithoutIntakeFormNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeFormsNestedInput>;
    postCheckRules?: InputMaybe<IntakeFormUpdatepostCheckRulesInput>;
    preCheckRules?: InputMaybe<IntakeFormUpdatepreCheckRulesInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    refreshPeriodInDays?: InputMaybe<IntFieldUpdateOperationsInput>;
    sections?: InputMaybe<IntakeFormUpdatesectionsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormUpdateManyMutationInput = {
    associatedAppointmentTypeIds?: InputMaybe<IntakeFormUpdateassociatedAppointmentTypeIdsInput>;
    associatedHrtIds?: InputMaybe<IntakeFormUpdateassociatedHrtIdsInput>;
    associatedPayerIds?: InputMaybe<IntakeFormUpdateassociatedPayerIdsInput>;
    athenaDocumentSubclass?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    autoAddRules?: InputMaybe<IntakeFormUpdateautoAddRulesInput>;
    autoSendForOrg?: InputMaybe<BoolFieldUpdateOperationsInput>;
    autoSendPayerIds?: InputMaybe<IntakeFormUpdateautoSendPayerIdsInput>;
    completionTiming?: InputMaybe<EnumCompletionTimingTypeFieldUpdateOperationsInput>;
    consentTypes?: InputMaybe<IntakeFormUpdateconsentTypesInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    postCheckRules?: InputMaybe<IntakeFormUpdatepostCheckRulesInput>;
    preCheckRules?: InputMaybe<IntakeFormUpdatepreCheckRulesInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    refreshPeriodInDays?: InputMaybe<IntFieldUpdateOperationsInput>;
    sections?: InputMaybe<IntakeFormUpdatesectionsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormUpdateManyWithWhereWithoutOrgInput = {
    data: IntakeFormUpdateManyMutationInput;
    where: IntakeFormScalarWhereInput;
};

export type IntakeFormUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<IntakeFormWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeFormCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<IntakeFormCreateWithoutOrgInput>>;
    createMany?: InputMaybe<IntakeFormCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<IntakeFormWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<IntakeFormScalarWhereInput>>;
    disconnect?: InputMaybe<Array<IntakeFormWhereUniqueInput>>;
    set?: InputMaybe<Array<IntakeFormWhereUniqueInput>>;
    update?: InputMaybe<Array<IntakeFormUpdateWithWhereUniqueWithoutOrgInput>>;
    updateMany?: InputMaybe<
        Array<IntakeFormUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<Array<IntakeFormUpsertWithWhereUniqueWithoutOrgInput>>;
};

export type IntakeFormUpdateOneRequiredWithoutIntakeFormToQuestionsNestedInput =
    {
        connect?: InputMaybe<IntakeFormWhereUniqueInput>;
        connectOrCreate?: InputMaybe<IntakeFormCreateOrConnectWithoutIntakeFormToQuestionsInput>;
        create?: InputMaybe<IntakeFormCreateWithoutIntakeFormToQuestionsInput>;
        update?: InputMaybe<IntakeFormUpdateToOneWithWhereWithoutIntakeFormToQuestionsInput>;
        upsert?: InputMaybe<IntakeFormUpsertWithoutIntakeFormToQuestionsInput>;
    };

export type IntakeFormUpdateToOneWithWhereWithoutIntakeFormToQuestionsInput = {
    data: IntakeFormUpdateWithoutIntakeFormToQuestionsInput;
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type IntakeFormUpdateWithWhereUniqueWithoutOrgInput = {
    data: IntakeFormUpdateWithoutOrgInput;
    where: IntakeFormWhereUniqueInput;
};

export type IntakeFormUpdateWithoutIntakeFormToQuestionsInput = {
    associatedAppointmentTypeIds?: InputMaybe<IntakeFormUpdateassociatedAppointmentTypeIdsInput>;
    associatedHrtIds?: InputMaybe<IntakeFormUpdateassociatedHrtIdsInput>;
    associatedPayerIds?: InputMaybe<IntakeFormUpdateassociatedPayerIdsInput>;
    athenaDocumentSubclass?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    autoAddRules?: InputMaybe<IntakeFormUpdateautoAddRulesInput>;
    autoSendForOrg?: InputMaybe<BoolFieldUpdateOperationsInput>;
    autoSendPayerIds?: InputMaybe<IntakeFormUpdateautoSendPayerIdsInput>;
    completionTiming?: InputMaybe<EnumCompletionTimingTypeFieldUpdateOperationsInput>;
    consentTypes?: InputMaybe<IntakeFormUpdateconsentTypesInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeFormsNestedInput>;
    postCheckRules?: InputMaybe<IntakeFormUpdatepostCheckRulesInput>;
    preCheckRules?: InputMaybe<IntakeFormUpdatepreCheckRulesInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    refreshPeriodInDays?: InputMaybe<IntFieldUpdateOperationsInput>;
    sections?: InputMaybe<IntakeFormUpdatesectionsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormUpdateWithoutOrgInput = {
    associatedAppointmentTypeIds?: InputMaybe<IntakeFormUpdateassociatedAppointmentTypeIdsInput>;
    associatedHrtIds?: InputMaybe<IntakeFormUpdateassociatedHrtIdsInput>;
    associatedPayerIds?: InputMaybe<IntakeFormUpdateassociatedPayerIdsInput>;
    athenaDocumentSubclass?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    autoAddRules?: InputMaybe<IntakeFormUpdateautoAddRulesInput>;
    autoSendForOrg?: InputMaybe<BoolFieldUpdateOperationsInput>;
    autoSendPayerIds?: InputMaybe<IntakeFormUpdateautoSendPayerIdsInput>;
    completionTiming?: InputMaybe<EnumCompletionTimingTypeFieldUpdateOperationsInput>;
    consentTypes?: InputMaybe<IntakeFormUpdateconsentTypesInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionUpdateManyWithoutIntakeFormNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    postCheckRules?: InputMaybe<IntakeFormUpdatepostCheckRulesInput>;
    preCheckRules?: InputMaybe<IntakeFormUpdatepreCheckRulesInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    refreshPeriodInDays?: InputMaybe<IntFieldUpdateOperationsInput>;
    sections?: InputMaybe<IntakeFormUpdatesectionsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeFormUpdateassociatedAppointmentTypeIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntakeFormUpdateassociatedHrtIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntakeFormUpdateassociatedPayerIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntakeFormUpdateautoAddRulesInput = {
    push?: InputMaybe<Array<AutoAddRule>>;
    set?: InputMaybe<Array<AutoAddRule>>;
};

export type IntakeFormUpdateautoSendPayerIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntakeFormUpdateconsentTypesInput = {
    push?: InputMaybe<Array<ConsentType>>;
    set?: InputMaybe<Array<ConsentType>>;
};

export type IntakeFormUpdatepostCheckRulesInput = {
    push?: InputMaybe<Array<AttachPostCheckRules>>;
    set?: InputMaybe<Array<AttachPostCheckRules>>;
};

export type IntakeFormUpdatepreCheckRulesInput = {
    push?: InputMaybe<Array<AttachPreCheckRules>>;
    set?: InputMaybe<Array<AttachPreCheckRules>>;
};

export type IntakeFormUpdatesectionsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntakeFormUpsertWithWhereUniqueWithoutOrgInput = {
    create: IntakeFormCreateWithoutOrgInput;
    update: IntakeFormUpdateWithoutOrgInput;
    where: IntakeFormWhereUniqueInput;
};

export type IntakeFormUpsertWithoutIntakeFormToQuestionsInput = {
    create: IntakeFormCreateWithoutIntakeFormToQuestionsInput;
    update: IntakeFormUpdateWithoutIntakeFormToQuestionsInput;
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type IntakeFormWhereInput = {
    AND?: InputMaybe<Array<IntakeFormWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormWhereInput>>;
    associatedAppointmentTypeIds?: InputMaybe<IntNullableListFilter>;
    associatedHrtIds?: InputMaybe<IntNullableListFilter>;
    associatedPayerIds?: InputMaybe<IntNullableListFilter>;
    athenaDocumentSubclass?: InputMaybe<StringNullableFilter>;
    autoAddRules?: InputMaybe<EnumAutoAddRuleNullableListFilter>;
    autoSendForOrg?: InputMaybe<BoolFilter>;
    autoSendPayerIds?: InputMaybe<IntNullableListFilter>;
    completionTiming?: InputMaybe<EnumCompletionTimingTypeFilter>;
    consentTypes?: InputMaybe<EnumConsentTypeNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionListRelationFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    postCheckRules?: InputMaybe<EnumAttachPostCheckRulesNullableListFilter>;
    preCheckRules?: InputMaybe<EnumAttachPreCheckRulesNullableListFilter>;
    priority?: InputMaybe<IntFilter>;
    refreshPeriodInDays?: InputMaybe<IntFilter>;
    sections?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeFormWhereUniqueInput = {
    AND?: InputMaybe<Array<IntakeFormWhereInput>>;
    NOT?: InputMaybe<Array<IntakeFormWhereInput>>;
    OR?: InputMaybe<Array<IntakeFormWhereInput>>;
    associatedAppointmentTypeIds?: InputMaybe<IntNullableListFilter>;
    associatedHrtIds?: InputMaybe<IntNullableListFilter>;
    associatedPayerIds?: InputMaybe<IntNullableListFilter>;
    athenaDocumentSubclass?: InputMaybe<StringNullableFilter>;
    autoAddRules?: InputMaybe<EnumAutoAddRuleNullableListFilter>;
    autoSendForOrg?: InputMaybe<BoolFilter>;
    autoSendPayerIds?: InputMaybe<IntNullableListFilter>;
    completionTiming?: InputMaybe<EnumCompletionTimingTypeFilter>;
    consentTypes?: InputMaybe<EnumConsentTypeNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionListRelationFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    postCheckRules?: InputMaybe<EnumAttachPostCheckRulesNullableListFilter>;
    preCheckRules?: InputMaybe<EnumAttachPreCheckRulesNullableListFilter>;
    priority?: InputMaybe<IntFilter>;
    refreshPeriodInDays?: InputMaybe<IntFilter>;
    sections?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeQuestion = {
    __typename?: 'IntakeQuestion';
    _count?: Maybe<IntakeQuestionCount>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    intakeFormSection?: Maybe<IntakeFormSection>;
    intakeFormSectionId?: Maybe<Scalars['Int']['output']>;
    intakeFormSectionOrder?: Maybe<Scalars['Int']['output']>;
    intakeFormToQuestions: Array<IntakeFormToQuestion>;
    intakeQuestionTranslations: Array<IntakeQuestionTranslation>;
    name: Scalars['String']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    questionAttributes?: Maybe<Scalars['JSON']['output']>;
    questionText: Scalars['String']['output'];
    retrievable: Scalars['Boolean']['output'];
    savedIntakeResponses: Array<SavedIntakeResponse>;
    superscriptIntakeQuestion?: Maybe<SuperscriptIntakeQuestion>;
    superscriptIntakeQuestionId?: Maybe<Scalars['Int']['output']>;
    type: IntakeQuestionType;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeQuestionIntakeFormSectionArgs = {
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type IntakeQuestionIntakeFormToQuestionsArgs = {
    cursor?: InputMaybe<IntakeFormToQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormToQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormToQuestionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type IntakeQuestionIntakeQuestionTranslationsArgs = {
    cursor?: InputMaybe<IntakeQuestionTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeQuestionTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<IntakeQuestionTranslationOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionTranslationWhereInput>;
};

export type IntakeQuestionSavedIntakeResponsesArgs = {
    cursor?: InputMaybe<SavedIntakeResponseWhereUniqueInput>;
    distinct?: InputMaybe<Array<SavedIntakeResponseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SavedIntakeResponseOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SavedIntakeResponseWhereInput>;
};

export type IntakeQuestionSuperscriptIntakeQuestionArgs = {
    where?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
};

export type IntakeQuestionAvgAggregate = {
    __typename?: 'IntakeQuestionAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    intakeFormSectionId?: Maybe<Scalars['Float']['output']>;
    intakeFormSectionOrder?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    superscriptIntakeQuestionId?: Maybe<Scalars['Float']['output']>;
};

export type IntakeQuestionAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    intakeFormSectionId?: InputMaybe<SortOrder>;
    intakeFormSectionOrder?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    superscriptIntakeQuestionId?: InputMaybe<SortOrder>;
};

export type IntakeQuestionCount = {
    __typename?: 'IntakeQuestionCount';
    intakeFormToQuestions: Scalars['Int']['output'];
    intakeQuestionTranslations: Scalars['Int']['output'];
    savedIntakeResponses: Scalars['Int']['output'];
};

export type IntakeQuestionCountIntakeFormToQuestionsArgs = {
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type IntakeQuestionCountIntakeQuestionTranslationsArgs = {
    where?: InputMaybe<IntakeQuestionTranslationWhereInput>;
};

export type IntakeQuestionCountSavedIntakeResponsesArgs = {
    where?: InputMaybe<SavedIntakeResponseWhereInput>;
};

export type IntakeQuestionCountAggregate = {
    __typename?: 'IntakeQuestionCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    intakeFormSectionId: Scalars['Int']['output'];
    intakeFormSectionOrder: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    questionAttributes: Scalars['Int']['output'];
    questionText: Scalars['Int']['output'];
    retrievable: Scalars['Int']['output'];
    superscriptIntakeQuestionId: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type IntakeQuestionCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeFormSectionId?: InputMaybe<SortOrder>;
    intakeFormSectionOrder?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    questionAttributes?: InputMaybe<SortOrder>;
    questionText?: InputMaybe<SortOrder>;
    retrievable?: InputMaybe<SortOrder>;
    superscriptIntakeQuestionId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeQuestionCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSection?: InputMaybe<IntakeFormSectionCreateNestedOneWithoutIntakeQuestionsInput>;
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionCreateNestedManyWithoutIntakeQuestionInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationCreateNestedManyWithoutIntakeQuestionInput>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeQuestionsInput;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseCreateNestedManyWithoutIntakeQuestionInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionCreateNestedOneWithoutIntakeQuestionsInput>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSectionId?: InputMaybe<Scalars['Int']['input']>;
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    superscriptIntakeQuestionId?: InputMaybe<Scalars['Int']['input']>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionCreateManyIntakeFormSectionInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    superscriptIntakeQuestionId?: InputMaybe<Scalars['Int']['input']>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionCreateManyIntakeFormSectionInputEnvelope = {
    data: Array<IntakeQuestionCreateManyIntakeFormSectionInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntakeQuestionCreateManyOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSectionId?: InputMaybe<Scalars['Int']['input']>;
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    superscriptIntakeQuestionId?: InputMaybe<Scalars['Int']['input']>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionCreateManyOrgInputEnvelope = {
    data: Array<IntakeQuestionCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntakeQuestionCreateManySuperscriptIntakeQuestionInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSectionId?: InputMaybe<Scalars['Int']['input']>;
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionCreateManySuperscriptIntakeQuestionInputEnvelope = {
    data: Array<IntakeQuestionCreateManySuperscriptIntakeQuestionInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntakeQuestionCreateNestedManyWithoutIntakeFormSectionInput = {
    connect?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeQuestionCreateOrConnectWithoutIntakeFormSectionInput>
    >;
    create?: InputMaybe<
        Array<IntakeQuestionCreateWithoutIntakeFormSectionInput>
    >;
    createMany?: InputMaybe<IntakeQuestionCreateManyIntakeFormSectionInputEnvelope>;
};

export type IntakeQuestionCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeQuestionCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<IntakeQuestionCreateWithoutOrgInput>>;
    createMany?: InputMaybe<IntakeQuestionCreateManyOrgInputEnvelope>;
};

export type IntakeQuestionCreateNestedManyWithoutSuperscriptIntakeQuestionInput =
    {
        connect?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
        connectOrCreate?: InputMaybe<
            Array<IntakeQuestionCreateOrConnectWithoutSuperscriptIntakeQuestionInput>
        >;
        create?: InputMaybe<
            Array<IntakeQuestionCreateWithoutSuperscriptIntakeQuestionInput>
        >;
        createMany?: InputMaybe<IntakeQuestionCreateManySuperscriptIntakeQuestionInputEnvelope>;
    };

export type IntakeQuestionCreateNestedOneWithoutIntakeFormToQuestionsInput = {
    connect?: InputMaybe<IntakeQuestionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<IntakeQuestionCreateOrConnectWithoutIntakeFormToQuestionsInput>;
    create?: InputMaybe<IntakeQuestionCreateWithoutIntakeFormToQuestionsInput>;
};

export type IntakeQuestionCreateNestedOneWithoutIntakeQuestionTranslationsInput =
    {
        connect?: InputMaybe<IntakeQuestionWhereUniqueInput>;
        connectOrCreate?: InputMaybe<IntakeQuestionCreateOrConnectWithoutIntakeQuestionTranslationsInput>;
        create?: InputMaybe<IntakeQuestionCreateWithoutIntakeQuestionTranslationsInput>;
    };

export type IntakeQuestionCreateNestedOneWithoutSavedIntakeResponsesInput = {
    connect?: InputMaybe<IntakeQuestionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<IntakeQuestionCreateOrConnectWithoutSavedIntakeResponsesInput>;
    create?: InputMaybe<IntakeQuestionCreateWithoutSavedIntakeResponsesInput>;
};

export type IntakeQuestionCreateOrConnectWithoutIntakeFormSectionInput = {
    create: IntakeQuestionCreateWithoutIntakeFormSectionInput;
    where: IntakeQuestionWhereUniqueInput;
};

export type IntakeQuestionCreateOrConnectWithoutIntakeFormToQuestionsInput = {
    create: IntakeQuestionCreateWithoutIntakeFormToQuestionsInput;
    where: IntakeQuestionWhereUniqueInput;
};

export type IntakeQuestionCreateOrConnectWithoutIntakeQuestionTranslationsInput =
    {
        create: IntakeQuestionCreateWithoutIntakeQuestionTranslationsInput;
        where: IntakeQuestionWhereUniqueInput;
    };

export type IntakeQuestionCreateOrConnectWithoutOrgInput = {
    create: IntakeQuestionCreateWithoutOrgInput;
    where: IntakeQuestionWhereUniqueInput;
};

export type IntakeQuestionCreateOrConnectWithoutSavedIntakeResponsesInput = {
    create: IntakeQuestionCreateWithoutSavedIntakeResponsesInput;
    where: IntakeQuestionWhereUniqueInput;
};

export type IntakeQuestionCreateOrConnectWithoutSuperscriptIntakeQuestionInput =
    {
        create: IntakeQuestionCreateWithoutSuperscriptIntakeQuestionInput;
        where: IntakeQuestionWhereUniqueInput;
    };

export type IntakeQuestionCreateWithoutIntakeFormSectionInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionCreateNestedManyWithoutIntakeQuestionInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationCreateNestedManyWithoutIntakeQuestionInput>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeQuestionsInput;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseCreateNestedManyWithoutIntakeQuestionInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionCreateNestedOneWithoutIntakeQuestionsInput>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionCreateWithoutIntakeFormToQuestionsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSection?: InputMaybe<IntakeFormSectionCreateNestedOneWithoutIntakeQuestionsInput>;
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationCreateNestedManyWithoutIntakeQuestionInput>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeQuestionsInput;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseCreateNestedManyWithoutIntakeQuestionInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionCreateNestedOneWithoutIntakeQuestionsInput>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionCreateWithoutIntakeQuestionTranslationsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSection?: InputMaybe<IntakeFormSectionCreateNestedOneWithoutIntakeQuestionsInput>;
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionCreateNestedManyWithoutIntakeQuestionInput>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeQuestionsInput;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseCreateNestedManyWithoutIntakeQuestionInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionCreateNestedOneWithoutIntakeQuestionsInput>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionCreateWithoutOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSection?: InputMaybe<IntakeFormSectionCreateNestedOneWithoutIntakeQuestionsInput>;
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionCreateNestedManyWithoutIntakeQuestionInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationCreateNestedManyWithoutIntakeQuestionInput>;
    name: Scalars['String']['input'];
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseCreateNestedManyWithoutIntakeQuestionInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionCreateNestedOneWithoutIntakeQuestionsInput>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionCreateWithoutSavedIntakeResponsesInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSection?: InputMaybe<IntakeFormSectionCreateNestedOneWithoutIntakeQuestionsInput>;
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionCreateNestedManyWithoutIntakeQuestionInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationCreateNestedManyWithoutIntakeQuestionInput>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeQuestionsInput;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionCreateNestedOneWithoutIntakeQuestionsInput>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionCreateWithoutSuperscriptIntakeQuestionInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['Int']['input'];
    intakeFormSection?: InputMaybe<IntakeFormSectionCreateNestedOneWithoutIntakeQuestionsInput>;
    intakeFormSectionOrder?: InputMaybe<Scalars['Int']['input']>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionCreateNestedManyWithoutIntakeQuestionInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationCreateNestedManyWithoutIntakeQuestionInput>;
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutIntakeQuestionsInput;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseCreateNestedManyWithoutIntakeQuestionInput>;
    type: IntakeQuestionType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionGroupBy = {
    __typename?: 'IntakeQuestionGroupBy';
    _avg?: Maybe<IntakeQuestionAvgAggregate>;
    _count?: Maybe<IntakeQuestionCountAggregate>;
    _max?: Maybe<IntakeQuestionMaxAggregate>;
    _min?: Maybe<IntakeQuestionMinAggregate>;
    _sum?: Maybe<IntakeQuestionSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    intakeFormSectionId?: Maybe<Scalars['Int']['output']>;
    intakeFormSectionOrder?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    questionAttributes?: Maybe<Scalars['JSON']['output']>;
    questionText: Scalars['String']['output'];
    retrievable: Scalars['Boolean']['output'];
    superscriptIntakeQuestionId?: Maybe<Scalars['Int']['output']>;
    type: IntakeQuestionType;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeQuestionIntakeQuestionNameAndOrgUniqueCompoundUniqueInput = {
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
};

export type IntakeQuestionListRelationFilter = {
    every?: InputMaybe<IntakeQuestionWhereInput>;
    none?: InputMaybe<IntakeQuestionWhereInput>;
    some?: InputMaybe<IntakeQuestionWhereInput>;
};

export type IntakeQuestionMaxAggregate = {
    __typename?: 'IntakeQuestionMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    intakeFormSectionId?: Maybe<Scalars['Int']['output']>;
    intakeFormSectionOrder?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    questionText?: Maybe<Scalars['String']['output']>;
    retrievable?: Maybe<Scalars['Boolean']['output']>;
    superscriptIntakeQuestionId?: Maybe<Scalars['Int']['output']>;
    type?: Maybe<IntakeQuestionType>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeQuestionMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeFormSectionId?: InputMaybe<SortOrder>;
    intakeFormSectionOrder?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    questionText?: InputMaybe<SortOrder>;
    retrievable?: InputMaybe<SortOrder>;
    superscriptIntakeQuestionId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeQuestionMinAggregate = {
    __typename?: 'IntakeQuestionMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    intakeFormSectionId?: Maybe<Scalars['Int']['output']>;
    intakeFormSectionOrder?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    questionText?: Maybe<Scalars['String']['output']>;
    retrievable?: Maybe<Scalars['Boolean']['output']>;
    superscriptIntakeQuestionId?: Maybe<Scalars['Int']['output']>;
    type?: Maybe<IntakeQuestionType>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeQuestionMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intakeFormSectionId?: InputMaybe<SortOrder>;
    intakeFormSectionOrder?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    questionText?: InputMaybe<SortOrder>;
    retrievable?: InputMaybe<SortOrder>;
    superscriptIntakeQuestionId?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeQuestionOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type IntakeQuestionOrderByWithAggregationInput = {
    _avg?: InputMaybe<IntakeQuestionAvgOrderByAggregateInput>;
    _count?: InputMaybe<IntakeQuestionCountOrderByAggregateInput>;
    _max?: InputMaybe<IntakeQuestionMaxOrderByAggregateInput>;
    _min?: InputMaybe<IntakeQuestionMinOrderByAggregateInput>;
    _sum?: InputMaybe<IntakeQuestionSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    intakeFormSectionId?: InputMaybe<SortOrderInput>;
    intakeFormSectionOrder?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    questionAttributes?: InputMaybe<SortOrderInput>;
    questionText?: InputMaybe<SortOrder>;
    retrievable?: InputMaybe<SortOrder>;
    superscriptIntakeQuestionId?: InputMaybe<SortOrderInput>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeQuestionOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    intakeFormSection?: InputMaybe<IntakeFormSectionOrderByWithRelationInput>;
    intakeFormSectionId?: InputMaybe<SortOrderInput>;
    intakeFormSectionOrder?: InputMaybe<SortOrderInput>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionOrderByRelationAggregateInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationOrderByRelationAggregateInput>;
    name?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    questionAttributes?: InputMaybe<SortOrderInput>;
    questionText?: InputMaybe<SortOrder>;
    retrievable?: InputMaybe<SortOrder>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseOrderByRelationAggregateInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionOrderByWithRelationInput>;
    superscriptIntakeQuestionId?: InputMaybe<SortOrderInput>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeQuestionRelationFilter = {
    is?: InputMaybe<IntakeQuestionWhereInput>;
    isNot?: InputMaybe<IntakeQuestionWhereInput>;
};

export enum IntakeQuestionScalarFieldEnum {
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    Id = 'id',
    IntakeFormSectionId = 'intakeFormSectionId',
    IntakeFormSectionOrder = 'intakeFormSectionOrder',
    Name = 'name',
    OrgId = 'orgId',
    QuestionAttributes = 'questionAttributes',
    QuestionText = 'questionText',
    Retrievable = 'retrievable',
    SuperscriptIntakeQuestionId = 'superscriptIntakeQuestionId',
    Type = 'type',
    UpdatedAt = 'updatedAt',
}

export type IntakeQuestionScalarWhereInput = {
    AND?: InputMaybe<Array<IntakeQuestionScalarWhereInput>>;
    NOT?: InputMaybe<Array<IntakeQuestionScalarWhereInput>>;
    OR?: InputMaybe<Array<IntakeQuestionScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    intakeFormSectionId?: InputMaybe<IntNullableFilter>;
    intakeFormSectionOrder?: InputMaybe<IntNullableFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    questionAttributes?: InputMaybe<JsonNullableFilter>;
    questionText?: InputMaybe<StringFilter>;
    retrievable?: InputMaybe<BoolFilter>;
    superscriptIntakeQuestionId?: InputMaybe<IntNullableFilter>;
    type?: InputMaybe<EnumIntakeQuestionTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeQuestionScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<IntakeQuestionScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<IntakeQuestionScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<IntakeQuestionScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    intakeFormSectionId?: InputMaybe<IntNullableWithAggregatesFilter>;
    intakeFormSectionOrder?: InputMaybe<IntNullableWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    questionAttributes?: InputMaybe<JsonNullableWithAggregatesFilter>;
    questionText?: InputMaybe<StringWithAggregatesFilter>;
    retrievable?: InputMaybe<BoolWithAggregatesFilter>;
    superscriptIntakeQuestionId?: InputMaybe<IntNullableWithAggregatesFilter>;
    type?: InputMaybe<EnumIntakeQuestionTypeWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type IntakeQuestionSumAggregate = {
    __typename?: 'IntakeQuestionSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    intakeFormSectionId?: Maybe<Scalars['Int']['output']>;
    intakeFormSectionOrder?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    superscriptIntakeQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type IntakeQuestionSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    intakeFormSectionId?: InputMaybe<SortOrder>;
    intakeFormSectionOrder?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    superscriptIntakeQuestionId?: InputMaybe<SortOrder>;
};

export type IntakeQuestionTranslation = {
    __typename?: 'IntakeQuestionTranslation';
    createdAt: Scalars['DateTimeISO']['output'];
    intakeQuestion: IntakeQuestion;
    intakeQuestionId: Scalars['Int']['output'];
    languageCode: Scalars['String']['output'];
    questionAttributes?: Maybe<Scalars['JSON']['output']>;
    questionText: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeQuestionTranslationAvgAggregate = {
    __typename?: 'IntakeQuestionTranslationAvgAggregate';
    intakeQuestionId?: Maybe<Scalars['Float']['output']>;
};

export type IntakeQuestionTranslationAvgOrderByAggregateInput = {
    intakeQuestionId?: InputMaybe<SortOrder>;
};

export type IntakeQuestionTranslationCountAggregate = {
    __typename?: 'IntakeQuestionTranslationCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    intakeQuestionId: Scalars['Int']['output'];
    languageCode: Scalars['Int']['output'];
    questionAttributes: Scalars['Int']['output'];
    questionText: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type IntakeQuestionTranslationCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    questionAttributes?: InputMaybe<SortOrder>;
    questionText?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeQuestionTranslationCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeQuestion: IntakeQuestionCreateNestedOneWithoutIntakeQuestionTranslationsInput;
    languageCode: Scalars['String']['input'];
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionTranslationCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeQuestionId: Scalars['Int']['input'];
    languageCode: Scalars['String']['input'];
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionTranslationCreateManyIntakeQuestionInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionTranslationCreateManyIntakeQuestionInputEnvelope = {
    data: Array<IntakeQuestionTranslationCreateManyIntakeQuestionInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntakeQuestionTranslationCreateNestedManyWithoutIntakeQuestionInput =
    {
        connect?: InputMaybe<Array<IntakeQuestionTranslationWhereUniqueInput>>;
        connectOrCreate?: InputMaybe<
            Array<IntakeQuestionTranslationCreateOrConnectWithoutIntakeQuestionInput>
        >;
        create?: InputMaybe<
            Array<IntakeQuestionTranslationCreateWithoutIntakeQuestionInput>
        >;
        createMany?: InputMaybe<IntakeQuestionTranslationCreateManyIntakeQuestionInputEnvelope>;
    };

export type IntakeQuestionTranslationCreateOrConnectWithoutIntakeQuestionInput =
    {
        create: IntakeQuestionTranslationCreateWithoutIntakeQuestionInput;
        where: IntakeQuestionTranslationWhereUniqueInput;
    };

export type IntakeQuestionTranslationCreateWithoutIntakeQuestionInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IntakeQuestionTranslationGroupBy = {
    __typename?: 'IntakeQuestionTranslationGroupBy';
    _avg?: Maybe<IntakeQuestionTranslationAvgAggregate>;
    _count?: Maybe<IntakeQuestionTranslationCountAggregate>;
    _max?: Maybe<IntakeQuestionTranslationMaxAggregate>;
    _min?: Maybe<IntakeQuestionTranslationMinAggregate>;
    _sum?: Maybe<IntakeQuestionTranslationSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    intakeQuestionId: Scalars['Int']['output'];
    languageCode: Scalars['String']['output'];
    questionAttributes?: Maybe<Scalars['JSON']['output']>;
    questionText: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type IntakeQuestionTranslationIntakeQuestionIdLanguageCodeCompoundUniqueInput =
    {
        intakeQuestionId: Scalars['Int']['input'];
        languageCode: Scalars['String']['input'];
    };

export type IntakeQuestionTranslationIntakeQuestionToLanguageCodeUniqueCompoundUniqueInput =
    {
        intakeQuestionId: Scalars['Int']['input'];
        languageCode: Scalars['String']['input'];
    };

export type IntakeQuestionTranslationListRelationFilter = {
    every?: InputMaybe<IntakeQuestionTranslationWhereInput>;
    none?: InputMaybe<IntakeQuestionTranslationWhereInput>;
    some?: InputMaybe<IntakeQuestionTranslationWhereInput>;
};

export type IntakeQuestionTranslationMaxAggregate = {
    __typename?: 'IntakeQuestionTranslationMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    intakeQuestionId?: Maybe<Scalars['Int']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    questionText?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeQuestionTranslationMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    questionText?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeQuestionTranslationMinAggregate = {
    __typename?: 'IntakeQuestionTranslationMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    intakeQuestionId?: Maybe<Scalars['Int']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    questionText?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type IntakeQuestionTranslationMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    questionText?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeQuestionTranslationOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type IntakeQuestionTranslationOrderByWithAggregationInput = {
    _avg?: InputMaybe<IntakeQuestionTranslationAvgOrderByAggregateInput>;
    _count?: InputMaybe<IntakeQuestionTranslationCountOrderByAggregateInput>;
    _max?: InputMaybe<IntakeQuestionTranslationMaxOrderByAggregateInput>;
    _min?: InputMaybe<IntakeQuestionTranslationMinOrderByAggregateInput>;
    _sum?: InputMaybe<IntakeQuestionTranslationSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    questionAttributes?: InputMaybe<SortOrderInput>;
    questionText?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type IntakeQuestionTranslationOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    intakeQuestion?: InputMaybe<IntakeQuestionOrderByWithRelationInput>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    questionAttributes?: InputMaybe<SortOrderInput>;
    questionText?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum IntakeQuestionTranslationScalarFieldEnum {
    CreatedAt = 'createdAt',
    IntakeQuestionId = 'intakeQuestionId',
    LanguageCode = 'languageCode',
    QuestionAttributes = 'questionAttributes',
    QuestionText = 'questionText',
    UpdatedAt = 'updatedAt',
}

export type IntakeQuestionTranslationScalarWhereInput = {
    AND?: InputMaybe<Array<IntakeQuestionTranslationScalarWhereInput>>;
    NOT?: InputMaybe<Array<IntakeQuestionTranslationScalarWhereInput>>;
    OR?: InputMaybe<Array<IntakeQuestionTranslationScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeQuestionId?: InputMaybe<IntFilter>;
    languageCode?: InputMaybe<StringFilter>;
    questionAttributes?: InputMaybe<JsonNullableFilter>;
    questionText?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeQuestionTranslationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<IntakeQuestionTranslationScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<IntakeQuestionTranslationScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<IntakeQuestionTranslationScalarWhereWithAggregatesInput>
    >;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    intakeQuestionId?: InputMaybe<IntWithAggregatesFilter>;
    languageCode?: InputMaybe<StringWithAggregatesFilter>;
    questionAttributes?: InputMaybe<JsonNullableWithAggregatesFilter>;
    questionText?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type IntakeQuestionTranslationSumAggregate = {
    __typename?: 'IntakeQuestionTranslationSumAggregate';
    intakeQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type IntakeQuestionTranslationSumOrderByAggregateInput = {
    intakeQuestionId?: InputMaybe<SortOrder>;
};

export type IntakeQuestionTranslationUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    intakeQuestion?: InputMaybe<IntakeQuestionUpdateOneRequiredWithoutIntakeQuestionTranslationsNestedInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionTranslationUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionTranslationUpdateManyWithWhereWithoutIntakeQuestionInput =
    {
        data: IntakeQuestionTranslationUpdateManyMutationInput;
        where: IntakeQuestionTranslationScalarWhereInput;
    };

export type IntakeQuestionTranslationUpdateManyWithoutIntakeQuestionNestedInput =
    {
        connect?: InputMaybe<Array<IntakeQuestionTranslationWhereUniqueInput>>;
        connectOrCreate?: InputMaybe<
            Array<IntakeQuestionTranslationCreateOrConnectWithoutIntakeQuestionInput>
        >;
        create?: InputMaybe<
            Array<IntakeQuestionTranslationCreateWithoutIntakeQuestionInput>
        >;
        createMany?: InputMaybe<IntakeQuestionTranslationCreateManyIntakeQuestionInputEnvelope>;
        delete?: InputMaybe<Array<IntakeQuestionTranslationWhereUniqueInput>>;
        deleteMany?: InputMaybe<
            Array<IntakeQuestionTranslationScalarWhereInput>
        >;
        disconnect?: InputMaybe<
            Array<IntakeQuestionTranslationWhereUniqueInput>
        >;
        set?: InputMaybe<Array<IntakeQuestionTranslationWhereUniqueInput>>;
        update?: InputMaybe<
            Array<IntakeQuestionTranslationUpdateWithWhereUniqueWithoutIntakeQuestionInput>
        >;
        updateMany?: InputMaybe<
            Array<IntakeQuestionTranslationUpdateManyWithWhereWithoutIntakeQuestionInput>
        >;
        upsert?: InputMaybe<
            Array<IntakeQuestionTranslationUpsertWithWhereUniqueWithoutIntakeQuestionInput>
        >;
    };

export type IntakeQuestionTranslationUpdateWithWhereUniqueWithoutIntakeQuestionInput =
    {
        data: IntakeQuestionTranslationUpdateWithoutIntakeQuestionInput;
        where: IntakeQuestionTranslationWhereUniqueInput;
    };

export type IntakeQuestionTranslationUpdateWithoutIntakeQuestionInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionTranslationUpsertWithWhereUniqueWithoutIntakeQuestionInput =
    {
        create: IntakeQuestionTranslationCreateWithoutIntakeQuestionInput;
        update: IntakeQuestionTranslationUpdateWithoutIntakeQuestionInput;
        where: IntakeQuestionTranslationWhereUniqueInput;
    };

export type IntakeQuestionTranslationWhereInput = {
    AND?: InputMaybe<Array<IntakeQuestionTranslationWhereInput>>;
    NOT?: InputMaybe<Array<IntakeQuestionTranslationWhereInput>>;
    OR?: InputMaybe<Array<IntakeQuestionTranslationWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeQuestion?: InputMaybe<IntakeQuestionRelationFilter>;
    intakeQuestionId?: InputMaybe<IntFilter>;
    languageCode?: InputMaybe<StringFilter>;
    questionAttributes?: InputMaybe<JsonNullableFilter>;
    questionText?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeQuestionTranslationWhereUniqueInput = {
    AND?: InputMaybe<Array<IntakeQuestionTranslationWhereInput>>;
    NOT?: InputMaybe<Array<IntakeQuestionTranslationWhereInput>>;
    OR?: InputMaybe<Array<IntakeQuestionTranslationWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeQuestion?: InputMaybe<IntakeQuestionRelationFilter>;
    intakeQuestionId?: InputMaybe<IntFilter>;
    intakeQuestionId_languageCode?: InputMaybe<IntakeQuestionTranslationIntakeQuestionIdLanguageCodeCompoundUniqueInput>;
    intake_question_to_language_code_unique?: InputMaybe<IntakeQuestionTranslationIntakeQuestionToLanguageCodeUniqueCompoundUniqueInput>;
    languageCode?: InputMaybe<StringFilter>;
    questionAttributes?: InputMaybe<JsonNullableFilter>;
    questionText?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeQuestionUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSection?: InputMaybe<IntakeFormSectionUpdateOneWithoutIntakeQuestionsNestedInput>;
    intakeFormSectionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionUpdateManyWithoutIntakeQuestionNestedInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationUpdateManyWithoutIntakeQuestionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeQuestionsNestedInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseUpdateManyWithoutIntakeQuestionNestedInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionUpdateOneWithoutIntakeQuestionsNestedInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSectionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionUpdateManyWithWhereWithoutIntakeFormSectionInput = {
    data: IntakeQuestionUpdateManyMutationInput;
    where: IntakeQuestionScalarWhereInput;
};

export type IntakeQuestionUpdateManyWithWhereWithoutOrgInput = {
    data: IntakeQuestionUpdateManyMutationInput;
    where: IntakeQuestionScalarWhereInput;
};

export type IntakeQuestionUpdateManyWithWhereWithoutSuperscriptIntakeQuestionInput =
    {
        data: IntakeQuestionUpdateManyMutationInput;
        where: IntakeQuestionScalarWhereInput;
    };

export type IntakeQuestionUpdateManyWithoutIntakeFormSectionNestedInput = {
    connect?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeQuestionCreateOrConnectWithoutIntakeFormSectionInput>
    >;
    create?: InputMaybe<
        Array<IntakeQuestionCreateWithoutIntakeFormSectionInput>
    >;
    createMany?: InputMaybe<IntakeQuestionCreateManyIntakeFormSectionInputEnvelope>;
    delete?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<IntakeQuestionScalarWhereInput>>;
    disconnect?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
    set?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
    update?: InputMaybe<
        Array<IntakeQuestionUpdateWithWhereUniqueWithoutIntakeFormSectionInput>
    >;
    updateMany?: InputMaybe<
        Array<IntakeQuestionUpdateManyWithWhereWithoutIntakeFormSectionInput>
    >;
    upsert?: InputMaybe<
        Array<IntakeQuestionUpsertWithWhereUniqueWithoutIntakeFormSectionInput>
    >;
};

export type IntakeQuestionUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<IntakeQuestionCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<IntakeQuestionCreateWithoutOrgInput>>;
    createMany?: InputMaybe<IntakeQuestionCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<IntakeQuestionScalarWhereInput>>;
    disconnect?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
    set?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
    update?: InputMaybe<
        Array<IntakeQuestionUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<IntakeQuestionUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<IntakeQuestionUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type IntakeQuestionUpdateManyWithoutSuperscriptIntakeQuestionNestedInput =
    {
        connect?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
        connectOrCreate?: InputMaybe<
            Array<IntakeQuestionCreateOrConnectWithoutSuperscriptIntakeQuestionInput>
        >;
        create?: InputMaybe<
            Array<IntakeQuestionCreateWithoutSuperscriptIntakeQuestionInput>
        >;
        createMany?: InputMaybe<IntakeQuestionCreateManySuperscriptIntakeQuestionInputEnvelope>;
        delete?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
        deleteMany?: InputMaybe<Array<IntakeQuestionScalarWhereInput>>;
        disconnect?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
        set?: InputMaybe<Array<IntakeQuestionWhereUniqueInput>>;
        update?: InputMaybe<
            Array<IntakeQuestionUpdateWithWhereUniqueWithoutSuperscriptIntakeQuestionInput>
        >;
        updateMany?: InputMaybe<
            Array<IntakeQuestionUpdateManyWithWhereWithoutSuperscriptIntakeQuestionInput>
        >;
        upsert?: InputMaybe<
            Array<IntakeQuestionUpsertWithWhereUniqueWithoutSuperscriptIntakeQuestionInput>
        >;
    };

export type IntakeQuestionUpdateOneRequiredWithoutIntakeFormToQuestionsNestedInput =
    {
        connect?: InputMaybe<IntakeQuestionWhereUniqueInput>;
        connectOrCreate?: InputMaybe<IntakeQuestionCreateOrConnectWithoutIntakeFormToQuestionsInput>;
        create?: InputMaybe<IntakeQuestionCreateWithoutIntakeFormToQuestionsInput>;
        update?: InputMaybe<IntakeQuestionUpdateToOneWithWhereWithoutIntakeFormToQuestionsInput>;
        upsert?: InputMaybe<IntakeQuestionUpsertWithoutIntakeFormToQuestionsInput>;
    };

export type IntakeQuestionUpdateOneRequiredWithoutIntakeQuestionTranslationsNestedInput =
    {
        connect?: InputMaybe<IntakeQuestionWhereUniqueInput>;
        connectOrCreate?: InputMaybe<IntakeQuestionCreateOrConnectWithoutIntakeQuestionTranslationsInput>;
        create?: InputMaybe<IntakeQuestionCreateWithoutIntakeQuestionTranslationsInput>;
        update?: InputMaybe<IntakeQuestionUpdateToOneWithWhereWithoutIntakeQuestionTranslationsInput>;
        upsert?: InputMaybe<IntakeQuestionUpsertWithoutIntakeQuestionTranslationsInput>;
    };

export type IntakeQuestionUpdateOneRequiredWithoutSavedIntakeResponsesNestedInput =
    {
        connect?: InputMaybe<IntakeQuestionWhereUniqueInput>;
        connectOrCreate?: InputMaybe<IntakeQuestionCreateOrConnectWithoutSavedIntakeResponsesInput>;
        create?: InputMaybe<IntakeQuestionCreateWithoutSavedIntakeResponsesInput>;
        update?: InputMaybe<IntakeQuestionUpdateToOneWithWhereWithoutSavedIntakeResponsesInput>;
        upsert?: InputMaybe<IntakeQuestionUpsertWithoutSavedIntakeResponsesInput>;
    };

export type IntakeQuestionUpdateToOneWithWhereWithoutIntakeFormToQuestionsInput =
    {
        data: IntakeQuestionUpdateWithoutIntakeFormToQuestionsInput;
        where?: InputMaybe<IntakeQuestionWhereInput>;
    };

export type IntakeQuestionUpdateToOneWithWhereWithoutIntakeQuestionTranslationsInput =
    {
        data: IntakeQuestionUpdateWithoutIntakeQuestionTranslationsInput;
        where?: InputMaybe<IntakeQuestionWhereInput>;
    };

export type IntakeQuestionUpdateToOneWithWhereWithoutSavedIntakeResponsesInput =
    {
        data: IntakeQuestionUpdateWithoutSavedIntakeResponsesInput;
        where?: InputMaybe<IntakeQuestionWhereInput>;
    };

export type IntakeQuestionUpdateWithWhereUniqueWithoutIntakeFormSectionInput = {
    data: IntakeQuestionUpdateWithoutIntakeFormSectionInput;
    where: IntakeQuestionWhereUniqueInput;
};

export type IntakeQuestionUpdateWithWhereUniqueWithoutOrgInput = {
    data: IntakeQuestionUpdateWithoutOrgInput;
    where: IntakeQuestionWhereUniqueInput;
};

export type IntakeQuestionUpdateWithWhereUniqueWithoutSuperscriptIntakeQuestionInput =
    {
        data: IntakeQuestionUpdateWithoutSuperscriptIntakeQuestionInput;
        where: IntakeQuestionWhereUniqueInput;
    };

export type IntakeQuestionUpdateWithoutIntakeFormSectionInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSectionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionUpdateManyWithoutIntakeQuestionNestedInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationUpdateManyWithoutIntakeQuestionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeQuestionsNestedInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseUpdateManyWithoutIntakeQuestionNestedInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionUpdateOneWithoutIntakeQuestionsNestedInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionUpdateWithoutIntakeFormToQuestionsInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSection?: InputMaybe<IntakeFormSectionUpdateOneWithoutIntakeQuestionsNestedInput>;
    intakeFormSectionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationUpdateManyWithoutIntakeQuestionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeQuestionsNestedInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseUpdateManyWithoutIntakeQuestionNestedInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionUpdateOneWithoutIntakeQuestionsNestedInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionUpdateWithoutIntakeQuestionTranslationsInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSection?: InputMaybe<IntakeFormSectionUpdateOneWithoutIntakeQuestionsNestedInput>;
    intakeFormSectionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionUpdateManyWithoutIntakeQuestionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeQuestionsNestedInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseUpdateManyWithoutIntakeQuestionNestedInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionUpdateOneWithoutIntakeQuestionsNestedInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionUpdateWithoutOrgInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSection?: InputMaybe<IntakeFormSectionUpdateOneWithoutIntakeQuestionsNestedInput>;
    intakeFormSectionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionUpdateManyWithoutIntakeQuestionNestedInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationUpdateManyWithoutIntakeQuestionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseUpdateManyWithoutIntakeQuestionNestedInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionUpdateOneWithoutIntakeQuestionsNestedInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionUpdateWithoutSavedIntakeResponsesInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSection?: InputMaybe<IntakeFormSectionUpdateOneWithoutIntakeQuestionsNestedInput>;
    intakeFormSectionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionUpdateManyWithoutIntakeQuestionNestedInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationUpdateManyWithoutIntakeQuestionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeQuestionsNestedInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionUpdateOneWithoutIntakeQuestionsNestedInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionUpdateWithoutSuperscriptIntakeQuestionInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    intakeFormSection?: InputMaybe<IntakeFormSectionUpdateOneWithoutIntakeQuestionsNestedInput>;
    intakeFormSectionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionUpdateManyWithoutIntakeQuestionNestedInput>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationUpdateManyWithoutIntakeQuestionNestedInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutIntakeQuestionsNestedInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseUpdateManyWithoutIntakeQuestionNestedInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IntakeQuestionUpsertWithWhereUniqueWithoutIntakeFormSectionInput = {
    create: IntakeQuestionCreateWithoutIntakeFormSectionInput;
    update: IntakeQuestionUpdateWithoutIntakeFormSectionInput;
    where: IntakeQuestionWhereUniqueInput;
};

export type IntakeQuestionUpsertWithWhereUniqueWithoutOrgInput = {
    create: IntakeQuestionCreateWithoutOrgInput;
    update: IntakeQuestionUpdateWithoutOrgInput;
    where: IntakeQuestionWhereUniqueInput;
};

export type IntakeQuestionUpsertWithWhereUniqueWithoutSuperscriptIntakeQuestionInput =
    {
        create: IntakeQuestionCreateWithoutSuperscriptIntakeQuestionInput;
        update: IntakeQuestionUpdateWithoutSuperscriptIntakeQuestionInput;
        where: IntakeQuestionWhereUniqueInput;
    };

export type IntakeQuestionUpsertWithoutIntakeFormToQuestionsInput = {
    create: IntakeQuestionCreateWithoutIntakeFormToQuestionsInput;
    update: IntakeQuestionUpdateWithoutIntakeFormToQuestionsInput;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type IntakeQuestionUpsertWithoutIntakeQuestionTranslationsInput = {
    create: IntakeQuestionCreateWithoutIntakeQuestionTranslationsInput;
    update: IntakeQuestionUpdateWithoutIntakeQuestionTranslationsInput;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type IntakeQuestionUpsertWithoutSavedIntakeResponsesInput = {
    create: IntakeQuestionCreateWithoutSavedIntakeResponsesInput;
    update: IntakeQuestionUpdateWithoutSavedIntakeResponsesInput;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type IntakeQuestionWhereInput = {
    AND?: InputMaybe<Array<IntakeQuestionWhereInput>>;
    NOT?: InputMaybe<Array<IntakeQuestionWhereInput>>;
    OR?: InputMaybe<Array<IntakeQuestionWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    intakeFormSection?: InputMaybe<IntakeFormSectionNullableRelationFilter>;
    intakeFormSectionId?: InputMaybe<IntNullableFilter>;
    intakeFormSectionOrder?: InputMaybe<IntNullableFilter>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionListRelationFilter>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationListRelationFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    questionAttributes?: InputMaybe<JsonNullableFilter>;
    questionText?: InputMaybe<StringFilter>;
    retrievable?: InputMaybe<BoolFilter>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseListRelationFilter>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionNullableRelationFilter>;
    superscriptIntakeQuestionId?: InputMaybe<IntNullableFilter>;
    type?: InputMaybe<EnumIntakeQuestionTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntakeQuestionWhereUniqueInput = {
    AND?: InputMaybe<Array<IntakeQuestionWhereInput>>;
    NOT?: InputMaybe<Array<IntakeQuestionWhereInput>>;
    OR?: InputMaybe<Array<IntakeQuestionWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    intakeFormSection?: InputMaybe<IntakeFormSectionNullableRelationFilter>;
    intakeFormSectionId?: InputMaybe<IntNullableFilter>;
    intakeFormSectionOrder?: InputMaybe<IntNullableFilter>;
    intakeFormToQuestions?: InputMaybe<IntakeFormToQuestionListRelationFilter>;
    intakeQuestionTranslations?: InputMaybe<IntakeQuestionTranslationListRelationFilter>;
    intake_question_name_and_org_unique?: InputMaybe<IntakeQuestionIntakeQuestionNameAndOrgUniqueCompoundUniqueInput>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    questionAttributes?: InputMaybe<JsonNullableFilter>;
    questionText?: InputMaybe<StringFilter>;
    retrievable?: InputMaybe<BoolFilter>;
    savedIntakeResponses?: InputMaybe<SavedIntakeResponseListRelationFilter>;
    superscriptIntakeQuestion?: InputMaybe<SuperscriptIntakeQuestionNullableRelationFilter>;
    superscriptIntakeQuestionId?: InputMaybe<IntNullableFilter>;
    type?: InputMaybe<EnumIntakeQuestionTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InvoiceDailyLineItems = {
    __typename?: 'InvoiceDailyLineItems';
    amount: Scalars['Decimal']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    feeType: FeeType;
    id: Scalars['String']['output'];
    invoice: Invoices;
    invoiceId: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type InvoiceDailyLineItemsAvgAggregate = {
    __typename?: 'InvoiceDailyLineItemsAvgAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type InvoiceDailyLineItemsAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type InvoiceDailyLineItemsCountAggregate = {
    __typename?: 'InvoiceDailyLineItemsCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    feeType: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    invoiceId: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type InvoiceDailyLineItemsCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InvoiceDailyLineItemsCreateInput = {
    amount: Scalars['Decimal']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    invoice: InvoicesCreateNestedOneWithoutDailyLineItemsInput;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InvoiceDailyLineItemsCreateManyInput = {
    amount: Scalars['Decimal']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    invoiceId: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InvoiceDailyLineItemsCreateManyInvoiceInput = {
    amount: Scalars['Decimal']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InvoiceDailyLineItemsCreateManyInvoiceInputEnvelope = {
    data: Array<InvoiceDailyLineItemsCreateManyInvoiceInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceDailyLineItemsCreateNestedManyWithoutInvoiceInput = {
    connect?: InputMaybe<Array<InvoiceDailyLineItemsWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<InvoiceDailyLineItemsCreateOrConnectWithoutInvoiceInput>
    >;
    create?: InputMaybe<Array<InvoiceDailyLineItemsCreateWithoutInvoiceInput>>;
    createMany?: InputMaybe<InvoiceDailyLineItemsCreateManyInvoiceInputEnvelope>;
};

export type InvoiceDailyLineItemsCreateOrConnectWithoutInvoiceInput = {
    create: InvoiceDailyLineItemsCreateWithoutInvoiceInput;
    where: InvoiceDailyLineItemsWhereUniqueInput;
};

export type InvoiceDailyLineItemsCreateWithoutInvoiceInput = {
    amount: Scalars['Decimal']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InvoiceDailyLineItemsGroupBy = {
    __typename?: 'InvoiceDailyLineItemsGroupBy';
    _avg?: Maybe<InvoiceDailyLineItemsAvgAggregate>;
    _count?: Maybe<InvoiceDailyLineItemsCountAggregate>;
    _max?: Maybe<InvoiceDailyLineItemsMaxAggregate>;
    _min?: Maybe<InvoiceDailyLineItemsMinAggregate>;
    _sum?: Maybe<InvoiceDailyLineItemsSumAggregate>;
    amount: Scalars['Decimal']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    feeType: FeeType;
    id: Scalars['String']['output'];
    invoiceId: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type InvoiceDailyLineItemsListRelationFilter = {
    every?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
    none?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
    some?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
};

export type InvoiceDailyLineItemsMaxAggregate = {
    __typename?: 'InvoiceDailyLineItemsMaxAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    feeType?: Maybe<FeeType>;
    id?: Maybe<Scalars['String']['output']>;
    invoiceId?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type InvoiceDailyLineItemsMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InvoiceDailyLineItemsMinAggregate = {
    __typename?: 'InvoiceDailyLineItemsMinAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    feeType?: Maybe<FeeType>;
    id?: Maybe<Scalars['String']['output']>;
    invoiceId?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type InvoiceDailyLineItemsMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InvoiceDailyLineItemsOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type InvoiceDailyLineItemsOrderByWithAggregationInput = {
    _avg?: InputMaybe<InvoiceDailyLineItemsAvgOrderByAggregateInput>;
    _count?: InputMaybe<InvoiceDailyLineItemsCountOrderByAggregateInput>;
    _max?: InputMaybe<InvoiceDailyLineItemsMaxOrderByAggregateInput>;
    _min?: InputMaybe<InvoiceDailyLineItemsMinOrderByAggregateInput>;
    _sum?: InputMaybe<InvoiceDailyLineItemsSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InvoiceDailyLineItemsOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoice?: InputMaybe<InvoicesOrderByWithRelationInput>;
    invoiceId?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum InvoiceDailyLineItemsScalarFieldEnum {
    Amount = 'amount',
    CreatedAt = 'createdAt',
    Date = 'date',
    FeeType = 'feeType',
    Id = 'id',
    InvoiceId = 'invoiceId',
    OrgId = 'orgId',
    UpdatedAt = 'updatedAt',
}

export type InvoiceDailyLineItemsScalarWhereInput = {
    AND?: InputMaybe<Array<InvoiceDailyLineItemsScalarWhereInput>>;
    NOT?: InputMaybe<Array<InvoiceDailyLineItemsScalarWhereInput>>;
    OR?: InputMaybe<Array<InvoiceDailyLineItemsScalarWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    date?: InputMaybe<DateTimeFilter>;
    feeType?: InputMaybe<EnumFeeTypeFilter>;
    id?: InputMaybe<StringFilter>;
    invoiceId?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InvoiceDailyLineItemsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<InvoiceDailyLineItemsScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<InvoiceDailyLineItemsScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<InvoiceDailyLineItemsScalarWhereWithAggregatesInput>>;
    amount?: InputMaybe<DecimalWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    feeType?: InputMaybe<EnumFeeTypeWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    invoiceId?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type InvoiceDailyLineItemsSumAggregate = {
    __typename?: 'InvoiceDailyLineItemsSumAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceDailyLineItemsSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type InvoiceDailyLineItemsUpdateInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    invoice?: InputMaybe<InvoicesUpdateOneRequiredWithoutDailyLineItemsNestedInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InvoiceDailyLineItemsUpdateManyMutationInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InvoiceDailyLineItemsUpdateManyWithWhereWithoutInvoiceInput = {
    data: InvoiceDailyLineItemsUpdateManyMutationInput;
    where: InvoiceDailyLineItemsScalarWhereInput;
};

export type InvoiceDailyLineItemsUpdateManyWithoutInvoiceNestedInput = {
    connect?: InputMaybe<Array<InvoiceDailyLineItemsWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<InvoiceDailyLineItemsCreateOrConnectWithoutInvoiceInput>
    >;
    create?: InputMaybe<Array<InvoiceDailyLineItemsCreateWithoutInvoiceInput>>;
    createMany?: InputMaybe<InvoiceDailyLineItemsCreateManyInvoiceInputEnvelope>;
    delete?: InputMaybe<Array<InvoiceDailyLineItemsWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<InvoiceDailyLineItemsScalarWhereInput>>;
    disconnect?: InputMaybe<Array<InvoiceDailyLineItemsWhereUniqueInput>>;
    set?: InputMaybe<Array<InvoiceDailyLineItemsWhereUniqueInput>>;
    update?: InputMaybe<
        Array<InvoiceDailyLineItemsUpdateWithWhereUniqueWithoutInvoiceInput>
    >;
    updateMany?: InputMaybe<
        Array<InvoiceDailyLineItemsUpdateManyWithWhereWithoutInvoiceInput>
    >;
    upsert?: InputMaybe<
        Array<InvoiceDailyLineItemsUpsertWithWhereUniqueWithoutInvoiceInput>
    >;
};

export type InvoiceDailyLineItemsUpdateWithWhereUniqueWithoutInvoiceInput = {
    data: InvoiceDailyLineItemsUpdateWithoutInvoiceInput;
    where: InvoiceDailyLineItemsWhereUniqueInput;
};

export type InvoiceDailyLineItemsUpdateWithoutInvoiceInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InvoiceDailyLineItemsUpsertWithWhereUniqueWithoutInvoiceInput = {
    create: InvoiceDailyLineItemsCreateWithoutInvoiceInput;
    update: InvoiceDailyLineItemsUpdateWithoutInvoiceInput;
    where: InvoiceDailyLineItemsWhereUniqueInput;
};

export type InvoiceDailyLineItemsWhereInput = {
    AND?: InputMaybe<Array<InvoiceDailyLineItemsWhereInput>>;
    NOT?: InputMaybe<Array<InvoiceDailyLineItemsWhereInput>>;
    OR?: InputMaybe<Array<InvoiceDailyLineItemsWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    date?: InputMaybe<DateTimeFilter>;
    feeType?: InputMaybe<EnumFeeTypeFilter>;
    id?: InputMaybe<StringFilter>;
    invoice?: InputMaybe<InvoicesRelationFilter>;
    invoiceId?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InvoiceDailyLineItemsWhereUniqueInput = {
    AND?: InputMaybe<Array<InvoiceDailyLineItemsWhereInput>>;
    NOT?: InputMaybe<Array<InvoiceDailyLineItemsWhereInput>>;
    OR?: InputMaybe<Array<InvoiceDailyLineItemsWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    date?: InputMaybe<DateTimeFilter>;
    feeType?: InputMaybe<EnumFeeTypeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    invoice?: InputMaybe<InvoicesRelationFilter>;
    invoiceId?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum InvoiceStatus {
    Draft = 'DRAFT',
    Open = 'OPEN',
    Paid = 'PAID',
    Uncollectible = 'UNCOLLECTIBLE',
    Void = 'VOID',
}

export type Invoices = {
    __typename?: 'Invoices';
    _count?: Maybe<InvoicesCount>;
    createdAt: Scalars['DateTimeISO']['output'];
    dailyLineItems: Array<InvoiceDailyLineItems>;
    endDate: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    invoiceDate: Scalars['DateTimeISO']['output'];
    orgId: Scalars['Int']['output'];
    startDate: Scalars['DateTimeISO']['output'];
    status: InvoiceStatus;
    stripeInvoiceId: Scalars['String']['output'];
    totalAmount: Scalars['Decimal']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type InvoicesDailyLineItemsArgs = {
    cursor?: InputMaybe<InvoiceDailyLineItemsWhereUniqueInput>;
    distinct?: InputMaybe<Array<InvoiceDailyLineItemsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InvoiceDailyLineItemsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
};

export type InvoicesAvgAggregate = {
    __typename?: 'InvoicesAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
    totalAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoicesAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    totalAmount?: InputMaybe<SortOrder>;
};

export type InvoicesCount = {
    __typename?: 'InvoicesCount';
    dailyLineItems: Scalars['Int']['output'];
};

export type InvoicesCountDailyLineItemsArgs = {
    where?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
};

export type InvoicesCountAggregate = {
    __typename?: 'InvoicesCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    endDate: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    invoiceDate: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    startDate: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    stripeInvoiceId: Scalars['Int']['output'];
    totalAmount: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type InvoicesCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceDate?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    startDate?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeInvoiceId?: InputMaybe<SortOrder>;
    totalAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InvoicesCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dailyLineItems?: InputMaybe<InvoiceDailyLineItemsCreateNestedManyWithoutInvoiceInput>;
    endDate: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    invoiceDate: Scalars['DateTimeISO']['input'];
    orgId: Scalars['Int']['input'];
    startDate: Scalars['DateTimeISO']['input'];
    status?: InputMaybe<InvoiceStatus>;
    stripeInvoiceId: Scalars['String']['input'];
    totalAmount: Scalars['Decimal']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InvoicesCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    endDate: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    invoiceDate: Scalars['DateTimeISO']['input'];
    orgId: Scalars['Int']['input'];
    startDate: Scalars['DateTimeISO']['input'];
    status?: InputMaybe<InvoiceStatus>;
    stripeInvoiceId: Scalars['String']['input'];
    totalAmount: Scalars['Decimal']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InvoicesCreateNestedOneWithoutDailyLineItemsInput = {
    connect?: InputMaybe<InvoicesWhereUniqueInput>;
    connectOrCreate?: InputMaybe<InvoicesCreateOrConnectWithoutDailyLineItemsInput>;
    create?: InputMaybe<InvoicesCreateWithoutDailyLineItemsInput>;
};

export type InvoicesCreateOrConnectWithoutDailyLineItemsInput = {
    create: InvoicesCreateWithoutDailyLineItemsInput;
    where: InvoicesWhereUniqueInput;
};

export type InvoicesCreateWithoutDailyLineItemsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    endDate: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    invoiceDate: Scalars['DateTimeISO']['input'];
    orgId: Scalars['Int']['input'];
    startDate: Scalars['DateTimeISO']['input'];
    status?: InputMaybe<InvoiceStatus>;
    stripeInvoiceId: Scalars['String']['input'];
    totalAmount: Scalars['Decimal']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InvoicesGroupBy = {
    __typename?: 'InvoicesGroupBy';
    _avg?: Maybe<InvoicesAvgAggregate>;
    _count?: Maybe<InvoicesCountAggregate>;
    _max?: Maybe<InvoicesMaxAggregate>;
    _min?: Maybe<InvoicesMinAggregate>;
    _sum?: Maybe<InvoicesSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    endDate: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    invoiceDate: Scalars['DateTimeISO']['output'];
    orgId: Scalars['Int']['output'];
    startDate: Scalars['DateTimeISO']['output'];
    status: InvoiceStatus;
    stripeInvoiceId: Scalars['String']['output'];
    totalAmount: Scalars['Decimal']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type InvoicesMaxAggregate = {
    __typename?: 'InvoicesMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    invoiceDate?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    startDate?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<InvoiceStatus>;
    stripeInvoiceId?: Maybe<Scalars['String']['output']>;
    totalAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type InvoicesMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceDate?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    startDate?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeInvoiceId?: InputMaybe<SortOrder>;
    totalAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InvoicesMinAggregate = {
    __typename?: 'InvoicesMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    invoiceDate?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    startDate?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<InvoiceStatus>;
    stripeInvoiceId?: Maybe<Scalars['String']['output']>;
    totalAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type InvoicesMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceDate?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    startDate?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeInvoiceId?: InputMaybe<SortOrder>;
    totalAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InvoicesOrderByWithAggregationInput = {
    _avg?: InputMaybe<InvoicesAvgOrderByAggregateInput>;
    _count?: InputMaybe<InvoicesCountOrderByAggregateInput>;
    _max?: InputMaybe<InvoicesMaxOrderByAggregateInput>;
    _min?: InputMaybe<InvoicesMinOrderByAggregateInput>;
    _sum?: InputMaybe<InvoicesSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceDate?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    startDate?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeInvoiceId?: InputMaybe<SortOrder>;
    totalAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InvoicesOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    dailyLineItems?: InputMaybe<InvoiceDailyLineItemsOrderByRelationAggregateInput>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    invoiceDate?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    startDate?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeInvoiceId?: InputMaybe<SortOrder>;
    totalAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type InvoicesRelationFilter = {
    is?: InputMaybe<InvoicesWhereInput>;
    isNot?: InputMaybe<InvoicesWhereInput>;
};

export enum InvoicesScalarFieldEnum {
    CreatedAt = 'createdAt',
    EndDate = 'endDate',
    Id = 'id',
    InvoiceDate = 'invoiceDate',
    OrgId = 'orgId',
    StartDate = 'startDate',
    Status = 'status',
    StripeInvoiceId = 'stripeInvoiceId',
    TotalAmount = 'totalAmount',
    UpdatedAt = 'updatedAt',
}

export type InvoicesScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<InvoicesScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<InvoicesScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<InvoicesScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    endDate?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    invoiceDate?: InputMaybe<DateTimeWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    startDate?: InputMaybe<DateTimeWithAggregatesFilter>;
    status?: InputMaybe<EnumInvoiceStatusWithAggregatesFilter>;
    stripeInvoiceId?: InputMaybe<StringWithAggregatesFilter>;
    totalAmount?: InputMaybe<DecimalWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type InvoicesSumAggregate = {
    __typename?: 'InvoicesSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    totalAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoicesSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    totalAmount?: InputMaybe<SortOrder>;
};

export type InvoicesUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dailyLineItems?: InputMaybe<InvoiceDailyLineItemsUpdateManyWithoutInvoiceNestedInput>;
    endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    invoiceDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumInvoiceStatusFieldUpdateOperationsInput>;
    stripeInvoiceId?: InputMaybe<StringFieldUpdateOperationsInput>;
    totalAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InvoicesUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    invoiceDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumInvoiceStatusFieldUpdateOperationsInput>;
    stripeInvoiceId?: InputMaybe<StringFieldUpdateOperationsInput>;
    totalAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InvoicesUpdateOneRequiredWithoutDailyLineItemsNestedInput = {
    connect?: InputMaybe<InvoicesWhereUniqueInput>;
    connectOrCreate?: InputMaybe<InvoicesCreateOrConnectWithoutDailyLineItemsInput>;
    create?: InputMaybe<InvoicesCreateWithoutDailyLineItemsInput>;
    update?: InputMaybe<InvoicesUpdateToOneWithWhereWithoutDailyLineItemsInput>;
    upsert?: InputMaybe<InvoicesUpsertWithoutDailyLineItemsInput>;
};

export type InvoicesUpdateToOneWithWhereWithoutDailyLineItemsInput = {
    data: InvoicesUpdateWithoutDailyLineItemsInput;
    where?: InputMaybe<InvoicesWhereInput>;
};

export type InvoicesUpdateWithoutDailyLineItemsInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    invoiceDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumInvoiceStatusFieldUpdateOperationsInput>;
    stripeInvoiceId?: InputMaybe<StringFieldUpdateOperationsInput>;
    totalAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InvoicesUpsertWithoutDailyLineItemsInput = {
    create: InvoicesCreateWithoutDailyLineItemsInput;
    update: InvoicesUpdateWithoutDailyLineItemsInput;
    where?: InputMaybe<InvoicesWhereInput>;
};

export type InvoicesWhereInput = {
    AND?: InputMaybe<Array<InvoicesWhereInput>>;
    NOT?: InputMaybe<Array<InvoicesWhereInput>>;
    OR?: InputMaybe<Array<InvoicesWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dailyLineItems?: InputMaybe<InvoiceDailyLineItemsListRelationFilter>;
    endDate?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<StringFilter>;
    invoiceDate?: InputMaybe<DateTimeFilter>;
    orgId?: InputMaybe<IntFilter>;
    startDate?: InputMaybe<DateTimeFilter>;
    status?: InputMaybe<EnumInvoiceStatusFilter>;
    stripeInvoiceId?: InputMaybe<StringFilter>;
    totalAmount?: InputMaybe<DecimalFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InvoicesWhereUniqueInput = {
    AND?: InputMaybe<Array<InvoicesWhereInput>>;
    NOT?: InputMaybe<Array<InvoicesWhereInput>>;
    OR?: InputMaybe<Array<InvoicesWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dailyLineItems?: InputMaybe<InvoiceDailyLineItemsListRelationFilter>;
    endDate?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    invoiceDate?: InputMaybe<DateTimeFilter>;
    orgId?: InputMaybe<IntFilter>;
    startDate?: InputMaybe<DateTimeFilter>;
    status?: InputMaybe<EnumInvoiceStatusFilter>;
    stripeInvoiceId?: InputMaybe<Scalars['String']['input']>;
    totalAmount?: InputMaybe<DecimalFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type JsonFilter = {
    array_contains?: InputMaybe<Scalars['JSON']['input']>;
    array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
    array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
    equals?: InputMaybe<Scalars['JSON']['input']>;
    gt?: InputMaybe<Scalars['JSON']['input']>;
    gte?: InputMaybe<Scalars['JSON']['input']>;
    lt?: InputMaybe<Scalars['JSON']['input']>;
    lte?: InputMaybe<Scalars['JSON']['input']>;
    not?: InputMaybe<Scalars['JSON']['input']>;
    path?: InputMaybe<Array<Scalars['String']['input']>>;
    string_contains?: InputMaybe<Scalars['String']['input']>;
    string_ends_with?: InputMaybe<Scalars['String']['input']>;
    string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableFilter = {
    array_contains?: InputMaybe<Scalars['JSON']['input']>;
    array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
    array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
    equals?: InputMaybe<Scalars['JSON']['input']>;
    gt?: InputMaybe<Scalars['JSON']['input']>;
    gte?: InputMaybe<Scalars['JSON']['input']>;
    lt?: InputMaybe<Scalars['JSON']['input']>;
    lte?: InputMaybe<Scalars['JSON']['input']>;
    not?: InputMaybe<Scalars['JSON']['input']>;
    path?: InputMaybe<Array<Scalars['String']['input']>>;
    string_contains?: InputMaybe<Scalars['String']['input']>;
    string_ends_with?: InputMaybe<Scalars['String']['input']>;
    string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedJsonNullableFilter>;
    _min?: InputMaybe<NestedJsonNullableFilter>;
    array_contains?: InputMaybe<Scalars['JSON']['input']>;
    array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
    array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
    equals?: InputMaybe<Scalars['JSON']['input']>;
    gt?: InputMaybe<Scalars['JSON']['input']>;
    gte?: InputMaybe<Scalars['JSON']['input']>;
    lt?: InputMaybe<Scalars['JSON']['input']>;
    lte?: InputMaybe<Scalars['JSON']['input']>;
    not?: InputMaybe<Scalars['JSON']['input']>;
    path?: InputMaybe<Array<Scalars['String']['input']>>;
    string_contains?: InputMaybe<Scalars['String']['input']>;
    string_ends_with?: InputMaybe<Scalars['String']['input']>;
    string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedJsonFilter>;
    _min?: InputMaybe<NestedJsonFilter>;
    array_contains?: InputMaybe<Scalars['JSON']['input']>;
    array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
    array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
    equals?: InputMaybe<Scalars['JSON']['input']>;
    gt?: InputMaybe<Scalars['JSON']['input']>;
    gte?: InputMaybe<Scalars['JSON']['input']>;
    lt?: InputMaybe<Scalars['JSON']['input']>;
    lte?: InputMaybe<Scalars['JSON']['input']>;
    not?: InputMaybe<Scalars['JSON']['input']>;
    path?: InputMaybe<Array<Scalars['String']['input']>>;
    string_contains?: InputMaybe<Scalars['String']['input']>;
    string_ends_with?: InputMaybe<Scalars['String']['input']>;
    string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum KioskHrtType {
    DefaultKiosk = 'DEFAULT_KIOSK',
    Eps = 'EPS',
    TravelInsurance = 'TRAVEL_INSURANCE',
    WorkersComp = 'WORKERS_COMP',
}

export type KeywordRule = {
    __typename?: 'KeywordRule';
    addIgnoreList: Array<Scalars['String']['output']>;
    addKeywords: Array<Scalars['String']['output']>;
    addSoftIgnoreList: Array<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    removeIgnoreList: Array<Scalars['String']['output']>;
    removeSoftIgnoreList: Array<Scalars['String']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type KeywordRuleAvgAggregate = {
    __typename?: 'KeywordRuleAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    srtId?: Maybe<Scalars['Float']['output']>;
};

export type KeywordRuleAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type KeywordRuleCountAggregate = {
    __typename?: 'KeywordRuleCountAggregate';
    _all: Scalars['Int']['output'];
    addIgnoreList: Scalars['Int']['output'];
    addKeywords: Scalars['Int']['output'];
    addSoftIgnoreList: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    removeIgnoreList: Scalars['Int']['output'];
    removeSoftIgnoreList: Scalars['Int']['output'];
    srtId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type KeywordRuleCountOrderByAggregateInput = {
    addIgnoreList?: InputMaybe<SortOrder>;
    addKeywords?: InputMaybe<SortOrder>;
    addSoftIgnoreList?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    removeIgnoreList?: InputMaybe<SortOrder>;
    removeSoftIgnoreList?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type KeywordRuleCreateInput = {
    addIgnoreList?: InputMaybe<KeywordRuleCreateaddIgnoreListInput>;
    addKeywords?: InputMaybe<KeywordRuleCreateaddKeywordsInput>;
    addSoftIgnoreList?: InputMaybe<KeywordRuleCreateaddSoftIgnoreListInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    removeIgnoreList?: InputMaybe<KeywordRuleCreateremoveIgnoreListInput>;
    removeSoftIgnoreList?: InputMaybe<KeywordRuleCreateremoveSoftIgnoreListInput>;
    srtId?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type KeywordRuleCreateManyInput = {
    addIgnoreList?: InputMaybe<KeywordRuleCreateaddIgnoreListInput>;
    addKeywords?: InputMaybe<KeywordRuleCreateaddKeywordsInput>;
    addSoftIgnoreList?: InputMaybe<KeywordRuleCreateaddSoftIgnoreListInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    removeIgnoreList?: InputMaybe<KeywordRuleCreateremoveIgnoreListInput>;
    removeSoftIgnoreList?: InputMaybe<KeywordRuleCreateremoveSoftIgnoreListInput>;
    srtId?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type KeywordRuleCreateaddIgnoreListInput = {
    set: Array<Scalars['String']['input']>;
};

export type KeywordRuleCreateaddKeywordsInput = {
    set: Array<Scalars['String']['input']>;
};

export type KeywordRuleCreateaddSoftIgnoreListInput = {
    set: Array<Scalars['String']['input']>;
};

export type KeywordRuleCreateremoveIgnoreListInput = {
    set: Array<Scalars['String']['input']>;
};

export type KeywordRuleCreateremoveSoftIgnoreListInput = {
    set: Array<Scalars['String']['input']>;
};

export type KeywordRuleGroupBy = {
    __typename?: 'KeywordRuleGroupBy';
    _avg?: Maybe<KeywordRuleAvgAggregate>;
    _count?: Maybe<KeywordRuleCountAggregate>;
    _max?: Maybe<KeywordRuleMaxAggregate>;
    _min?: Maybe<KeywordRuleMinAggregate>;
    _sum?: Maybe<KeywordRuleSumAggregate>;
    addIgnoreList?: Maybe<Array<Scalars['String']['output']>>;
    addKeywords?: Maybe<Array<Scalars['String']['output']>>;
    addSoftIgnoreList?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    removeIgnoreList?: Maybe<Array<Scalars['String']['output']>>;
    removeSoftIgnoreList?: Maybe<Array<Scalars['String']['output']>>;
    srtId?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type KeywordRuleMaxAggregate = {
    __typename?: 'KeywordRuleMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type KeywordRuleMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type KeywordRuleMinAggregate = {
    __typename?: 'KeywordRuleMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type KeywordRuleMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type KeywordRuleOrderByWithAggregationInput = {
    _avg?: InputMaybe<KeywordRuleAvgOrderByAggregateInput>;
    _count?: InputMaybe<KeywordRuleCountOrderByAggregateInput>;
    _max?: InputMaybe<KeywordRuleMaxOrderByAggregateInput>;
    _min?: InputMaybe<KeywordRuleMinOrderByAggregateInput>;
    _sum?: InputMaybe<KeywordRuleSumOrderByAggregateInput>;
    addIgnoreList?: InputMaybe<SortOrder>;
    addKeywords?: InputMaybe<SortOrder>;
    addSoftIgnoreList?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    removeIgnoreList?: InputMaybe<SortOrder>;
    removeSoftIgnoreList?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type KeywordRuleOrderByWithRelationInput = {
    addIgnoreList?: InputMaybe<SortOrder>;
    addKeywords?: InputMaybe<SortOrder>;
    addSoftIgnoreList?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    removeIgnoreList?: InputMaybe<SortOrder>;
    removeSoftIgnoreList?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum KeywordRuleScalarFieldEnum {
    AddIgnoreList = 'addIgnoreList',
    AddKeywords = 'addKeywords',
    AddSoftIgnoreList = 'addSoftIgnoreList',
    CreatedAt = 'createdAt',
    HrtId = 'hrtId',
    Id = 'id',
    IsActive = 'isActive',
    Notes = 'notes',
    OrgId = 'orgId',
    RemoveIgnoreList = 'removeIgnoreList',
    RemoveSoftIgnoreList = 'removeSoftIgnoreList',
    SrtId = 'srtId',
    UpdatedAt = 'updatedAt',
}

export type KeywordRuleScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<KeywordRuleScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<KeywordRuleScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<KeywordRuleScalarWhereWithAggregatesInput>>;
    addIgnoreList?: InputMaybe<StringNullableListFilter>;
    addKeywords?: InputMaybe<StringNullableListFilter>;
    addSoftIgnoreList?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    hrtId?: InputMaybe<IntNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    removeIgnoreList?: InputMaybe<StringNullableListFilter>;
    removeSoftIgnoreList?: InputMaybe<StringNullableListFilter>;
    srtId?: InputMaybe<IntNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type KeywordRuleSumAggregate = {
    __typename?: 'KeywordRuleSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
};

export type KeywordRuleSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type KeywordRuleUpdateInput = {
    addIgnoreList?: InputMaybe<KeywordRuleUpdateaddIgnoreListInput>;
    addKeywords?: InputMaybe<KeywordRuleUpdateaddKeywordsInput>;
    addSoftIgnoreList?: InputMaybe<KeywordRuleUpdateaddSoftIgnoreListInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    removeIgnoreList?: InputMaybe<KeywordRuleUpdateremoveIgnoreListInput>;
    removeSoftIgnoreList?: InputMaybe<KeywordRuleUpdateremoveSoftIgnoreListInput>;
    srtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type KeywordRuleUpdateManyMutationInput = {
    addIgnoreList?: InputMaybe<KeywordRuleUpdateaddIgnoreListInput>;
    addKeywords?: InputMaybe<KeywordRuleUpdateaddKeywordsInput>;
    addSoftIgnoreList?: InputMaybe<KeywordRuleUpdateaddSoftIgnoreListInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    removeIgnoreList?: InputMaybe<KeywordRuleUpdateremoveIgnoreListInput>;
    removeSoftIgnoreList?: InputMaybe<KeywordRuleUpdateremoveSoftIgnoreListInput>;
    srtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type KeywordRuleUpdateaddIgnoreListInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KeywordRuleUpdateaddKeywordsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KeywordRuleUpdateaddSoftIgnoreListInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KeywordRuleUpdateremoveIgnoreListInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KeywordRuleUpdateremoveSoftIgnoreListInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KeywordRuleWhereInput = {
    AND?: InputMaybe<Array<KeywordRuleWhereInput>>;
    NOT?: InputMaybe<Array<KeywordRuleWhereInput>>;
    OR?: InputMaybe<Array<KeywordRuleWhereInput>>;
    addIgnoreList?: InputMaybe<StringNullableListFilter>;
    addKeywords?: InputMaybe<StringNullableListFilter>;
    addSoftIgnoreList?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    removeIgnoreList?: InputMaybe<StringNullableListFilter>;
    removeSoftIgnoreList?: InputMaybe<StringNullableListFilter>;
    srtId?: InputMaybe<IntNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type KeywordRuleWhereUniqueInput = {
    AND?: InputMaybe<Array<KeywordRuleWhereInput>>;
    NOT?: InputMaybe<Array<KeywordRuleWhereInput>>;
    OR?: InputMaybe<Array<KeywordRuleWhereInput>>;
    addIgnoreList?: InputMaybe<StringNullableListFilter>;
    addKeywords?: InputMaybe<StringNullableListFilter>;
    addSoftIgnoreList?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<BoolFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    removeIgnoreList?: InputMaybe<StringNullableListFilter>;
    removeSoftIgnoreList?: InputMaybe<StringNullableListFilter>;
    srtId?: InputMaybe<IntNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum LinkType {
    AccountAppointment = 'ACCOUNT_APPOINTMENT',
    AccountAppointments = 'ACCOUNT_APPOINTMENTS',
    AccountAppointmentDetails = 'ACCOUNT_APPOINTMENT_DETAILS',
    AccountAppointmentReceipt = 'ACCOUNT_APPOINTMENT_RECEIPT',
    AccountHome = 'ACCOUNT_HOME',
    AccountIntake = 'ACCOUNT_INTAKE',
    AccountPaymentAppointment = 'ACCOUNT_PAYMENT_APPOINTMENT',
    AccountPaymentOrg = 'ACCOUNT_PAYMENT_ORG',
    AccountPaymentOutstanding = 'ACCOUNT_PAYMENT_OUTSTANDING',
    AccountPaymentPast = 'ACCOUNT_PAYMENT_PAST',
    AccountPaymentPlan = 'ACCOUNT_PAYMENT_PLAN',
    AccountPaymentTransaction = 'ACCOUNT_PAYMENT_TRANSACTION',
    AccountProfile = 'ACCOUNT_PROFILE',
    AccountTreatment = 'ACCOUNT_TREATMENT',
    AccountTreatmentReceipt = 'ACCOUNT_TREATMENT_RECEIPT',
    AutoChargeReceipt = 'AUTO_CHARGE_RECEIPT',
    CompanionConsumerScheduled = 'COMPANION_CONSUMER_SCHEDULED',
    CompanionConsumerUnscheduled = 'COMPANION_CONSUMER_UNSCHEDULED',
    ShopVerify = 'SHOP_VERIFY',
}

export enum LanguageCode {
    En = 'en',
    Es = 'es',
    Ru = 'ru',
    Zh = 'zh',
    ZhHk = 'zh_HK',
}

export type LinkMapping = {
    __typename?: 'LinkMapping';
    clickedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    linkCode: Scalars['String']['output'];
    linkFull: Scalars['String']['output'];
    linkType?: Maybe<LinkType>;
};

export type LinkMappingCountAggregate = {
    __typename?: 'LinkMappingCountAggregate';
    _all: Scalars['Int']['output'];
    clickedAt: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    expiresAt: Scalars['Int']['output'];
    linkCode: Scalars['Int']['output'];
    linkFull: Scalars['Int']['output'];
    linkType: Scalars['Int']['output'];
};

export type LinkMappingCountOrderByAggregateInput = {
    clickedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    linkCode?: InputMaybe<SortOrder>;
    linkFull?: InputMaybe<SortOrder>;
    linkType?: InputMaybe<SortOrder>;
};

export type LinkMappingCreateInput = {
    clickedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    linkCode?: InputMaybe<Scalars['String']['input']>;
    linkFull: Scalars['String']['input'];
    linkType?: InputMaybe<LinkType>;
};

export type LinkMappingCreateManyInput = {
    clickedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    linkCode?: InputMaybe<Scalars['String']['input']>;
    linkFull: Scalars['String']['input'];
    linkType?: InputMaybe<LinkType>;
};

export type LinkMappingGroupBy = {
    __typename?: 'LinkMappingGroupBy';
    _count?: Maybe<LinkMappingCountAggregate>;
    _max?: Maybe<LinkMappingMaxAggregate>;
    _min?: Maybe<LinkMappingMinAggregate>;
    clickedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    linkCode: Scalars['String']['output'];
    linkFull: Scalars['String']['output'];
    linkType?: Maybe<LinkType>;
};

export type LinkMappingMaxAggregate = {
    __typename?: 'LinkMappingMaxAggregate';
    clickedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    linkCode?: Maybe<Scalars['String']['output']>;
    linkFull?: Maybe<Scalars['String']['output']>;
    linkType?: Maybe<LinkType>;
};

export type LinkMappingMaxOrderByAggregateInput = {
    clickedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    linkCode?: InputMaybe<SortOrder>;
    linkFull?: InputMaybe<SortOrder>;
    linkType?: InputMaybe<SortOrder>;
};

export type LinkMappingMinAggregate = {
    __typename?: 'LinkMappingMinAggregate';
    clickedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    linkCode?: Maybe<Scalars['String']['output']>;
    linkFull?: Maybe<Scalars['String']['output']>;
    linkType?: Maybe<LinkType>;
};

export type LinkMappingMinOrderByAggregateInput = {
    clickedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    linkCode?: InputMaybe<SortOrder>;
    linkFull?: InputMaybe<SortOrder>;
    linkType?: InputMaybe<SortOrder>;
};

export type LinkMappingOrderByWithAggregationInput = {
    _count?: InputMaybe<LinkMappingCountOrderByAggregateInput>;
    _max?: InputMaybe<LinkMappingMaxOrderByAggregateInput>;
    _min?: InputMaybe<LinkMappingMinOrderByAggregateInput>;
    clickedAt?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrderInput>;
    linkCode?: InputMaybe<SortOrder>;
    linkFull?: InputMaybe<SortOrder>;
    linkType?: InputMaybe<SortOrderInput>;
};

export type LinkMappingOrderByWithRelationInput = {
    clickedAt?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrderInput>;
    linkCode?: InputMaybe<SortOrder>;
    linkFull?: InputMaybe<SortOrder>;
    linkType?: InputMaybe<SortOrderInput>;
};

export enum LinkMappingScalarFieldEnum {
    ClickedAt = 'clickedAt',
    CreatedAt = 'createdAt',
    ExpiresAt = 'expiresAt',
    LinkCode = 'linkCode',
    LinkFull = 'linkFull',
    LinkType = 'linkType',
}

export type LinkMappingScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<LinkMappingScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<LinkMappingScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<LinkMappingScalarWhereWithAggregatesInput>>;
    clickedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    expiresAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    linkCode?: InputMaybe<StringWithAggregatesFilter>;
    linkFull?: InputMaybe<StringWithAggregatesFilter>;
    linkType?: InputMaybe<EnumLinkTypeNullableWithAggregatesFilter>;
};

export type LinkMappingUpdateInput = {
    clickedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    linkCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    linkFull?: InputMaybe<StringFieldUpdateOperationsInput>;
    linkType?: InputMaybe<NullableEnumLinkTypeFieldUpdateOperationsInput>;
};

export type LinkMappingUpdateManyMutationInput = {
    clickedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    linkCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    linkFull?: InputMaybe<StringFieldUpdateOperationsInput>;
    linkType?: InputMaybe<NullableEnumLinkTypeFieldUpdateOperationsInput>;
};

export type LinkMappingWhereInput = {
    AND?: InputMaybe<Array<LinkMappingWhereInput>>;
    NOT?: InputMaybe<Array<LinkMappingWhereInput>>;
    OR?: InputMaybe<Array<LinkMappingWhereInput>>;
    clickedAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    expiresAt?: InputMaybe<DateTimeNullableFilter>;
    linkCode?: InputMaybe<StringFilter>;
    linkFull?: InputMaybe<StringFilter>;
    linkType?: InputMaybe<EnumLinkTypeNullableFilter>;
};

export type LinkMappingWhereUniqueInput = {
    AND?: InputMaybe<Array<LinkMappingWhereInput>>;
    NOT?: InputMaybe<Array<LinkMappingWhereInput>>;
    OR?: InputMaybe<Array<LinkMappingWhereInput>>;
    clickedAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    expiresAt?: InputMaybe<DateTimeNullableFilter>;
    linkCode?: InputMaybe<Scalars['String']['input']>;
    linkFull?: InputMaybe<StringFilter>;
    linkType?: InputMaybe<EnumLinkTypeNullableFilter>;
};

export enum LiveTransferActionEnum {
    AddTreatmentsCollectThroughSuperscript = 'ADD_TREATMENTS_COLLECT_THROUGH_SUPERSCRIPT',
    AdjustBalanceZeroContactSuperscript = 'ADJUST_BALANCE_ZERO_CONTACT_SUPERSCRIPT',
    AdjustBalanceZeroContactSuperscriptSelfpay = 'ADJUST_BALANCE_ZERO_CONTACT_SUPERSCRIPT_SELFPAY',
    CheckCobOrAdjustBalance = 'CHECK_COB_OR_ADJUST_BALANCE',
    ClosedWithoutSlot = 'CLOSED_WITHOUT_SLOT',
    ClosedWithSlot = 'CLOSED_WITH_SLOT',
    ContactSuperscriptForAdditionalInfo = 'CONTACT_SUPERSCRIPT_FOR_ADDITIONAL_INFO',
    ContactSuperscriptForMoreInfo = 'CONTACT_SUPERSCRIPT_FOR_MORE_INFO',
    ContactSuperscriptIfAwareOfMatchingSlot = 'CONTACT_SUPERSCRIPT_IF_AWARE_OF_MATCHING_SLOT',
    ContactSuperscriptIfClaimReturned = 'CONTACT_SUPERSCRIPT_IF_CLAIM_RETURNED',
    ContinueStandardClaimsProcess = 'CONTINUE_STANDARD_CLAIMS_PROCESS',
    CreateSelfPayClaim = 'CREATE_SELF_PAY_CLAIM',
    NoActionRequired = 'NO_ACTION_REQUIRED',
    ResendCheckoutLink = 'RESEND_CHECKOUT_LINK',
    ReviewClaimContactSuperscript = 'REVIEW_CLAIM_CONTACT_SUPERSCRIPT',
}

export enum LiveTransferStatusEnum {
    Adjusted = 'ADJUSTED',
    ClaimNotSuperscriptRelevant = 'CLAIM_NOT_SUPERSCRIPT_RELEVANT',
    ClaimVoided = 'CLAIM_VOIDED',
    Closed = 'CLOSED',
    InHoldAwaitingClaim = 'IN_HOLD_AWAITING_CLAIM',
    InHoldMatchingClaim = 'IN_HOLD_MATCHING_CLAIM',
    InHoldOrgReview = 'IN_HOLD_ORG_REVIEW',
    NotYetCollected = 'NOT_YET_COLLECTED',
    NoTransferMedicaid = 'NO_TRANSFER_MEDICAID',
    PartiallyCollected = 'PARTIALLY_COLLECTED',
    Pending = 'PENDING',
    PendingAwaitingPayerInfo = 'PENDING_AWAITING_PAYER_INFO',
    SlotCancelledPatientRefunded = 'SLOT_CANCELLED_PATIENT_REFUNDED',
    TransferredCollectedAmountAdministrativeIssue = 'TRANSFERRED_COLLECTED_AMOUNT_ADMINISTRATIVE_ISSUE',
    TransferredCollectedAmountClaimDenial = 'TRANSFERRED_COLLECTED_AMOUNT_CLAIM_DENIAL',
    TransferredCollectedAmountCobIssue = 'TRANSFERRED_COLLECTED_AMOUNT_COB_ISSUE',
    TransferredCollectedAmountTreatmentMismatch = 'TRANSFERRED_COLLECTED_AMOUNT_TREATMENT_MISMATCH',
    TransferredFullPatientResponsibility = 'TRANSFERRED_FULL_PATIENT_RESPONSIBILITY',
    TransferredFullSelfPayRate = 'TRANSFERRED_FULL_SELF_PAY_RATE',
    TransferredFullSelfPayRateNoClaim = 'TRANSFERRED_FULL_SELF_PAY_RATE_NO_CLAIM',
    TransferredPartialPatientResponsibility = 'TRANSFERRED_PARTIAL_PATIENT_RESPONSIBILITY',
    TransferredPartialResponsibilityAdditionalTreatments = 'TRANSFERRED_PARTIAL_RESPONSIBILITY_ADDITIONAL_TREATMENTS',
    TransferredSelfPayAmountClaimDenial = 'TRANSFERRED_SELF_PAY_AMOUNT_CLAIM_DENIAL',
    TransferredSelfPayAmountOon = 'TRANSFERRED_SELF_PAY_AMOUNT_OON',
    TransferredUserModifiedPrices = 'TRANSFERRED_USER_MODIFIED_PRICES',
    TransferredUserModifiedPricesAdditionalTreatments = 'TRANSFERRED_USER_MODIFIED_PRICES_ADDITIONAL_TREATMENTS',
    TransferredUserModifiedPricesNoClaim = 'TRANSFERRED_USER_MODIFIED_PRICES_NO_CLAIM',
    UnderSuperscriptReview = 'UNDER_SUPERSCRIPT_REVIEW',
}

export type LiveTransfers = {
    __typename?: 'LiveTransfers';
    action?: Maybe<LiveTransferActionEnum>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    artNotes: Array<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    currentPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    currentPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    currentSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    dateOfFirstCommunication?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfLastCommunication?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService: Scalars['DateTimeISO']['output'];
    dateTransferred?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrVisitId?: Maybe<Scalars['String']['output']>;
    grossPayout?: Maybe<Scalars['Float']['output']>;
    id: Scalars['String']['output'];
    location?: Maybe<Scalars['String']['output']>;
    locationTimezone?: Maybe<Scalars['String']['output']>;
    netPayout?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    patientName?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    provider?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    status?: Maybe<LiveTransferStatusEnum>;
    stripeFeeAmount?: Maybe<Scalars['Float']['output']>;
    stripeTransferDate?: Maybe<Scalars['DateTimeISO']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    stripeTransferStatus?: Maybe<Scalars['String']['output']>;
    superscriptFeeAmount?: Maybe<Scalars['Float']['output']>;
    treatmentMap?: Maybe<Scalars['JSON']['output']>;
    treatmentNames?: Maybe<Scalars['String']['output']>;
    treatmentTypes: Array<PaymentTypeEnum>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type LiveTransfersAvgAggregate = {
    __typename?: 'LiveTransfersAvgAggregate';
    currentPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    currentPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    currentSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    grossPayout?: Maybe<Scalars['Float']['output']>;
    netPayout?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    originalPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    stripeFeeAmount?: Maybe<Scalars['Float']['output']>;
    superscriptFeeAmount?: Maybe<Scalars['Float']['output']>;
};

export type LiveTransfersAvgOrderByAggregateInput = {
    currentPatientResponsibility?: InputMaybe<SortOrder>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    grossPayout?: InputMaybe<SortOrder>;
    netPayout?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientResponsibility?: InputMaybe<SortOrder>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    stripeFeeAmount?: InputMaybe<SortOrder>;
    superscriptFeeAmount?: InputMaybe<SortOrder>;
};

export type LiveTransfersCountAggregate = {
    __typename?: 'LiveTransfersCountAggregate';
    _all: Scalars['Int']['output'];
    action: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    artNotes: Scalars['Int']['output'];
    claimId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    currentPatientResponsibility: Scalars['Int']['output'];
    currentPrimaryPayerAllowableAmount: Scalars['Int']['output'];
    currentSecondaryPayerAllowableAmount: Scalars['Int']['output'];
    dateOfFirstCommunication: Scalars['Int']['output'];
    dateOfLastCommunication: Scalars['Int']['output'];
    dateOfService: Scalars['Int']['output'];
    dateTransferred: Scalars['Int']['output'];
    destinationPayment: Scalars['Int']['output'];
    ehrVisitId: Scalars['Int']['output'];
    grossPayout: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    location: Scalars['Int']['output'];
    locationTimezone: Scalars['Int']['output'];
    netPayout: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    originalPatientResponsibility: Scalars['Int']['output'];
    originalPrimaryPayerAllowableAmount: Scalars['Int']['output'];
    originalSecondaryPayerAllowableAmount: Scalars['Int']['output'];
    patientName: Scalars['Int']['output'];
    patientOrgEhrId: Scalars['Int']['output'];
    primaryPayer: Scalars['Int']['output'];
    primaryPayerPackage: Scalars['Int']['output'];
    provider: Scalars['Int']['output'];
    secondaryPayer: Scalars['Int']['output'];
    secondaryPayerPackage: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    slotType: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    stripeFeeAmount: Scalars['Int']['output'];
    stripeTransferDate: Scalars['Int']['output'];
    stripeTransferId: Scalars['Int']['output'];
    stripeTransferStatus: Scalars['Int']['output'];
    superscriptFeeAmount: Scalars['Int']['output'];
    treatmentMap: Scalars['Int']['output'];
    treatmentNames: Scalars['Int']['output'];
    treatmentTypes: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type LiveTransfersCountOrderByAggregateInput = {
    action?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    artNotes?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    currentPatientResponsibility?: InputMaybe<SortOrder>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    dateOfFirstCommunication?: InputMaybe<SortOrder>;
    dateOfLastCommunication?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    dateTransferred?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    grossPayout?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    location?: InputMaybe<SortOrder>;
    locationTimezone?: InputMaybe<SortOrder>;
    netPayout?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientResponsibility?: InputMaybe<SortOrder>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    patientName?: InputMaybe<SortOrder>;
    patientOrgEhrId?: InputMaybe<SortOrder>;
    primaryPayer?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrder>;
    provider?: InputMaybe<SortOrder>;
    secondaryPayer?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    slotType?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeFeeAmount?: InputMaybe<SortOrder>;
    stripeTransferDate?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    stripeTransferStatus?: InputMaybe<SortOrder>;
    superscriptFeeAmount?: InputMaybe<SortOrder>;
    treatmentMap?: InputMaybe<SortOrder>;
    treatmentNames?: InputMaybe<SortOrder>;
    treatmentTypes?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type LiveTransfersCreateInput = {
    action?: InputMaybe<LiveTransferActionEnum>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    artNotes?: InputMaybe<LiveTransfersCreateartNotesInput>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    currentPatientResponsibility?: InputMaybe<Scalars['Float']['input']>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<Scalars['Float']['input']>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<
        Scalars['Float']['input']
    >;
    dateOfFirstCommunication?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfLastCommunication?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService: Scalars['DateTimeISO']['input'];
    dateTransferred?: InputMaybe<Scalars['DateTimeISO']['input']>;
    destinationPayment?: InputMaybe<Scalars['String']['input']>;
    ehrVisitId?: InputMaybe<Scalars['String']['input']>;
    grossPayout?: InputMaybe<Scalars['Float']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    location?: InputMaybe<Scalars['String']['input']>;
    locationTimezone?: InputMaybe<Scalars['String']['input']>;
    netPayout?: InputMaybe<Scalars['Float']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    originalPatientResponsibility?: InputMaybe<Scalars['Float']['input']>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<Scalars['Float']['input']>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<
        Scalars['Float']['input']
    >;
    patientName?: InputMaybe<Scalars['String']['input']>;
    patientOrgEhrId?: InputMaybe<Scalars['String']['input']>;
    primaryPayer?: InputMaybe<Scalars['String']['input']>;
    primaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    provider?: InputMaybe<Scalars['String']['input']>;
    secondaryPayer?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    status?: InputMaybe<LiveTransferStatusEnum>;
    stripeFeeAmount?: InputMaybe<Scalars['Float']['input']>;
    stripeTransferDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferStatus?: InputMaybe<Scalars['String']['input']>;
    superscriptFeeAmount?: InputMaybe<Scalars['Float']['input']>;
    treatmentMap?: InputMaybe<Scalars['JSON']['input']>;
    treatmentNames?: InputMaybe<Scalars['String']['input']>;
    treatmentTypes?: InputMaybe<LiveTransfersCreatetreatmentTypesInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LiveTransfersCreateManyInput = {
    action?: InputMaybe<LiveTransferActionEnum>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    artNotes?: InputMaybe<LiveTransfersCreateartNotesInput>;
    claimId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    currentPatientResponsibility?: InputMaybe<Scalars['Float']['input']>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<Scalars['Float']['input']>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<
        Scalars['Float']['input']
    >;
    dateOfFirstCommunication?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfLastCommunication?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateOfService: Scalars['DateTimeISO']['input'];
    dateTransferred?: InputMaybe<Scalars['DateTimeISO']['input']>;
    destinationPayment?: InputMaybe<Scalars['String']['input']>;
    ehrVisitId?: InputMaybe<Scalars['String']['input']>;
    grossPayout?: InputMaybe<Scalars['Float']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    location?: InputMaybe<Scalars['String']['input']>;
    locationTimezone?: InputMaybe<Scalars['String']['input']>;
    netPayout?: InputMaybe<Scalars['Float']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    originalPatientResponsibility?: InputMaybe<Scalars['Float']['input']>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<Scalars['Float']['input']>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<
        Scalars['Float']['input']
    >;
    patientName?: InputMaybe<Scalars['String']['input']>;
    patientOrgEhrId?: InputMaybe<Scalars['String']['input']>;
    primaryPayer?: InputMaybe<Scalars['String']['input']>;
    primaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    provider?: InputMaybe<Scalars['String']['input']>;
    secondaryPayer?: InputMaybe<Scalars['String']['input']>;
    secondaryPayerPackage?: InputMaybe<Scalars['String']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    status?: InputMaybe<LiveTransferStatusEnum>;
    stripeFeeAmount?: InputMaybe<Scalars['Float']['input']>;
    stripeTransferDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferStatus?: InputMaybe<Scalars['String']['input']>;
    superscriptFeeAmount?: InputMaybe<Scalars['Float']['input']>;
    treatmentMap?: InputMaybe<Scalars['JSON']['input']>;
    treatmentNames?: InputMaybe<Scalars['String']['input']>;
    treatmentTypes?: InputMaybe<LiveTransfersCreatetreatmentTypesInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LiveTransfersCreateartNotesInput = {
    set: Array<Scalars['String']['input']>;
};

export type LiveTransfersCreatetreatmentTypesInput = {
    set: Array<PaymentTypeEnum>;
};

export type LiveTransfersGroupBy = {
    __typename?: 'LiveTransfersGroupBy';
    _avg?: Maybe<LiveTransfersAvgAggregate>;
    _count?: Maybe<LiveTransfersCountAggregate>;
    _max?: Maybe<LiveTransfersMaxAggregate>;
    _min?: Maybe<LiveTransfersMinAggregate>;
    _sum?: Maybe<LiveTransfersSumAggregate>;
    action?: Maybe<LiveTransferActionEnum>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    artNotes?: Maybe<Array<Scalars['String']['output']>>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    currentPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    currentPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    currentSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    dateOfFirstCommunication?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfLastCommunication?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService: Scalars['DateTimeISO']['output'];
    dateTransferred?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrVisitId?: Maybe<Scalars['String']['output']>;
    grossPayout?: Maybe<Scalars['Float']['output']>;
    id: Scalars['String']['output'];
    location?: Maybe<Scalars['String']['output']>;
    locationTimezone?: Maybe<Scalars['String']['output']>;
    netPayout?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    patientName?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    provider?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    status?: Maybe<LiveTransferStatusEnum>;
    stripeFeeAmount?: Maybe<Scalars['Float']['output']>;
    stripeTransferDate?: Maybe<Scalars['DateTimeISO']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    stripeTransferStatus?: Maybe<Scalars['String']['output']>;
    superscriptFeeAmount?: Maybe<Scalars['Float']['output']>;
    treatmentMap?: Maybe<Scalars['JSON']['output']>;
    treatmentNames?: Maybe<Scalars['String']['output']>;
    treatmentTypes?: Maybe<Array<PaymentTypeEnum>>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type LiveTransfersMaxAggregate = {
    __typename?: 'LiveTransfersMaxAggregate';
    action?: Maybe<LiveTransferActionEnum>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    currentPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    currentPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    currentSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    dateOfFirstCommunication?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfLastCommunication?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    dateTransferred?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrVisitId?: Maybe<Scalars['String']['output']>;
    grossPayout?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    location?: Maybe<Scalars['String']['output']>;
    locationTimezone?: Maybe<Scalars['String']['output']>;
    netPayout?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    patientName?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    provider?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    status?: Maybe<LiveTransferStatusEnum>;
    stripeFeeAmount?: Maybe<Scalars['Float']['output']>;
    stripeTransferDate?: Maybe<Scalars['DateTimeISO']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    stripeTransferStatus?: Maybe<Scalars['String']['output']>;
    superscriptFeeAmount?: Maybe<Scalars['Float']['output']>;
    treatmentNames?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type LiveTransfersMaxOrderByAggregateInput = {
    action?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    currentPatientResponsibility?: InputMaybe<SortOrder>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    dateOfFirstCommunication?: InputMaybe<SortOrder>;
    dateOfLastCommunication?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    dateTransferred?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    grossPayout?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    location?: InputMaybe<SortOrder>;
    locationTimezone?: InputMaybe<SortOrder>;
    netPayout?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientResponsibility?: InputMaybe<SortOrder>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    patientName?: InputMaybe<SortOrder>;
    patientOrgEhrId?: InputMaybe<SortOrder>;
    primaryPayer?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrder>;
    provider?: InputMaybe<SortOrder>;
    secondaryPayer?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    slotType?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeFeeAmount?: InputMaybe<SortOrder>;
    stripeTransferDate?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    stripeTransferStatus?: InputMaybe<SortOrder>;
    superscriptFeeAmount?: InputMaybe<SortOrder>;
    treatmentNames?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type LiveTransfersMinAggregate = {
    __typename?: 'LiveTransfersMinAggregate';
    action?: Maybe<LiveTransferActionEnum>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    claimId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    currentPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    currentPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    currentSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    dateOfFirstCommunication?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfLastCommunication?: Maybe<Scalars['DateTimeISO']['output']>;
    dateOfService?: Maybe<Scalars['DateTimeISO']['output']>;
    dateTransferred?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrVisitId?: Maybe<Scalars['String']['output']>;
    grossPayout?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    location?: Maybe<Scalars['String']['output']>;
    locationTimezone?: Maybe<Scalars['String']['output']>;
    netPayout?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    patientName?: Maybe<Scalars['String']['output']>;
    patientOrgEhrId?: Maybe<Scalars['String']['output']>;
    primaryPayer?: Maybe<Scalars['String']['output']>;
    primaryPayerPackage?: Maybe<Scalars['String']['output']>;
    provider?: Maybe<Scalars['String']['output']>;
    secondaryPayer?: Maybe<Scalars['String']['output']>;
    secondaryPayerPackage?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    status?: Maybe<LiveTransferStatusEnum>;
    stripeFeeAmount?: Maybe<Scalars['Float']['output']>;
    stripeTransferDate?: Maybe<Scalars['DateTimeISO']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    stripeTransferStatus?: Maybe<Scalars['String']['output']>;
    superscriptFeeAmount?: Maybe<Scalars['Float']['output']>;
    treatmentNames?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type LiveTransfersMinOrderByAggregateInput = {
    action?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    currentPatientResponsibility?: InputMaybe<SortOrder>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    dateOfFirstCommunication?: InputMaybe<SortOrder>;
    dateOfLastCommunication?: InputMaybe<SortOrder>;
    dateOfService?: InputMaybe<SortOrder>;
    dateTransferred?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    grossPayout?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    location?: InputMaybe<SortOrder>;
    locationTimezone?: InputMaybe<SortOrder>;
    netPayout?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientResponsibility?: InputMaybe<SortOrder>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    patientName?: InputMaybe<SortOrder>;
    patientOrgEhrId?: InputMaybe<SortOrder>;
    primaryPayer?: InputMaybe<SortOrder>;
    primaryPayerPackage?: InputMaybe<SortOrder>;
    provider?: InputMaybe<SortOrder>;
    secondaryPayer?: InputMaybe<SortOrder>;
    secondaryPayerPackage?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    slotType?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeFeeAmount?: InputMaybe<SortOrder>;
    stripeTransferDate?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    stripeTransferStatus?: InputMaybe<SortOrder>;
    superscriptFeeAmount?: InputMaybe<SortOrder>;
    treatmentNames?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type LiveTransfersOrderByWithAggregationInput = {
    _avg?: InputMaybe<LiveTransfersAvgOrderByAggregateInput>;
    _count?: InputMaybe<LiveTransfersCountOrderByAggregateInput>;
    _max?: InputMaybe<LiveTransfersMaxOrderByAggregateInput>;
    _min?: InputMaybe<LiveTransfersMinOrderByAggregateInput>;
    _sum?: InputMaybe<LiveTransfersSumOrderByAggregateInput>;
    action?: InputMaybe<SortOrderInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    artNotes?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    currentPatientResponsibility?: InputMaybe<SortOrderInput>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<SortOrderInput>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<SortOrderInput>;
    dateOfFirstCommunication?: InputMaybe<SortOrderInput>;
    dateOfLastCommunication?: InputMaybe<SortOrderInput>;
    dateOfService?: InputMaybe<SortOrder>;
    dateTransferred?: InputMaybe<SortOrderInput>;
    destinationPayment?: InputMaybe<SortOrderInput>;
    ehrVisitId?: InputMaybe<SortOrderInput>;
    grossPayout?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    location?: InputMaybe<SortOrderInput>;
    locationTimezone?: InputMaybe<SortOrderInput>;
    netPayout?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    originalPatientResponsibility?: InputMaybe<SortOrderInput>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<SortOrderInput>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<SortOrderInput>;
    patientName?: InputMaybe<SortOrderInput>;
    patientOrgEhrId?: InputMaybe<SortOrderInput>;
    primaryPayer?: InputMaybe<SortOrderInput>;
    primaryPayerPackage?: InputMaybe<SortOrderInput>;
    provider?: InputMaybe<SortOrderInput>;
    secondaryPayer?: InputMaybe<SortOrderInput>;
    secondaryPayerPackage?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    slotType?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    stripeFeeAmount?: InputMaybe<SortOrderInput>;
    stripeTransferDate?: InputMaybe<SortOrderInput>;
    stripeTransferId?: InputMaybe<SortOrderInput>;
    stripeTransferStatus?: InputMaybe<SortOrderInput>;
    superscriptFeeAmount?: InputMaybe<SortOrderInput>;
    treatmentMap?: InputMaybe<SortOrderInput>;
    treatmentNames?: InputMaybe<SortOrderInput>;
    treatmentTypes?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type LiveTransfersOrderByWithRelationInput = {
    action?: InputMaybe<SortOrderInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    artNotes?: InputMaybe<SortOrder>;
    claimId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    currentPatientResponsibility?: InputMaybe<SortOrderInput>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<SortOrderInput>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<SortOrderInput>;
    dateOfFirstCommunication?: InputMaybe<SortOrderInput>;
    dateOfLastCommunication?: InputMaybe<SortOrderInput>;
    dateOfService?: InputMaybe<SortOrder>;
    dateTransferred?: InputMaybe<SortOrderInput>;
    destinationPayment?: InputMaybe<SortOrderInput>;
    ehrVisitId?: InputMaybe<SortOrderInput>;
    grossPayout?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    location?: InputMaybe<SortOrderInput>;
    locationTimezone?: InputMaybe<SortOrderInput>;
    netPayout?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    originalPatientResponsibility?: InputMaybe<SortOrderInput>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<SortOrderInput>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<SortOrderInput>;
    patientName?: InputMaybe<SortOrderInput>;
    patientOrgEhrId?: InputMaybe<SortOrderInput>;
    primaryPayer?: InputMaybe<SortOrderInput>;
    primaryPayerPackage?: InputMaybe<SortOrderInput>;
    provider?: InputMaybe<SortOrderInput>;
    secondaryPayer?: InputMaybe<SortOrderInput>;
    secondaryPayerPackage?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    slotType?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    stripeFeeAmount?: InputMaybe<SortOrderInput>;
    stripeTransferDate?: InputMaybe<SortOrderInput>;
    stripeTransferId?: InputMaybe<SortOrderInput>;
    stripeTransferStatus?: InputMaybe<SortOrderInput>;
    superscriptFeeAmount?: InputMaybe<SortOrderInput>;
    treatmentMap?: InputMaybe<SortOrderInput>;
    treatmentNames?: InputMaybe<SortOrderInput>;
    treatmentTypes?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum LiveTransfersScalarFieldEnum {
    Action = 'action',
    AppointmentId = 'appointmentId',
    ArtNotes = 'artNotes',
    ClaimId = 'claimId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    CurrentPatientResponsibility = 'currentPatientResponsibility',
    CurrentPrimaryPayerAllowableAmount = 'currentPrimaryPayerAllowableAmount',
    CurrentSecondaryPayerAllowableAmount = 'currentSecondaryPayerAllowableAmount',
    DateOfFirstCommunication = 'dateOfFirstCommunication',
    DateOfLastCommunication = 'dateOfLastCommunication',
    DateOfService = 'dateOfService',
    DateTransferred = 'dateTransferred',
    DestinationPayment = 'destinationPayment',
    EhrVisitId = 'ehrVisitId',
    GrossPayout = 'grossPayout',
    Id = 'id',
    Location = 'location',
    LocationTimezone = 'locationTimezone',
    NetPayout = 'netPayout',
    OrgId = 'orgId',
    OriginalPatientResponsibility = 'originalPatientResponsibility',
    OriginalPrimaryPayerAllowableAmount = 'originalPrimaryPayerAllowableAmount',
    OriginalSecondaryPayerAllowableAmount = 'originalSecondaryPayerAllowableAmount',
    PatientName = 'patientName',
    PatientOrgEhrId = 'patientOrgEhrId',
    PrimaryPayer = 'primaryPayer',
    PrimaryPayerPackage = 'primaryPayerPackage',
    Provider = 'provider',
    SecondaryPayer = 'secondaryPayer',
    SecondaryPayerPackage = 'secondaryPayerPackage',
    SlotId = 'slotId',
    SlotType = 'slotType',
    Status = 'status',
    StripeFeeAmount = 'stripeFeeAmount',
    StripeTransferDate = 'stripeTransferDate',
    StripeTransferId = 'stripeTransferId',
    StripeTransferStatus = 'stripeTransferStatus',
    SuperscriptFeeAmount = 'superscriptFeeAmount',
    TreatmentMap = 'treatmentMap',
    TreatmentNames = 'treatmentNames',
    TreatmentTypes = 'treatmentTypes',
    UpdatedAt = 'updatedAt',
}

export type LiveTransfersScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<LiveTransfersScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<LiveTransfersScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<LiveTransfersScalarWhereWithAggregatesInput>>;
    action?: InputMaybe<EnumLiveTransferActionEnumNullableWithAggregatesFilter>;
    appointmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    artNotes?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    currentPatientResponsibility?: InputMaybe<FloatNullableWithAggregatesFilter>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    dateOfFirstCommunication?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    dateOfLastCommunication?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    dateOfService?: InputMaybe<DateTimeWithAggregatesFilter>;
    dateTransferred?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    destinationPayment?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrVisitId?: InputMaybe<StringNullableWithAggregatesFilter>;
    grossPayout?: InputMaybe<FloatNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    location?: InputMaybe<StringNullableWithAggregatesFilter>;
    locationTimezone?: InputMaybe<StringNullableWithAggregatesFilter>;
    netPayout?: InputMaybe<FloatNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    originalPatientResponsibility?: InputMaybe<FloatNullableWithAggregatesFilter>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    patientName?: InputMaybe<StringNullableWithAggregatesFilter>;
    patientOrgEhrId?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryPayer?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryPayerPackage?: InputMaybe<StringNullableWithAggregatesFilter>;
    provider?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryPayer?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryPayerPackage?: InputMaybe<StringNullableWithAggregatesFilter>;
    slotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    slotType?: InputMaybe<EnumSlotTypeEnumNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumLiveTransferStatusEnumNullableWithAggregatesFilter>;
    stripeFeeAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    stripeTransferDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    stripeTransferId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeTransferStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    superscriptFeeAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
    treatmentMap?: InputMaybe<JsonNullableWithAggregatesFilter>;
    treatmentNames?: InputMaybe<StringNullableWithAggregatesFilter>;
    treatmentTypes?: InputMaybe<EnumPaymentTypeEnumNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type LiveTransfersSumAggregate = {
    __typename?: 'LiveTransfersSumAggregate';
    currentPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    currentPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    currentSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    grossPayout?: Maybe<Scalars['Float']['output']>;
    netPayout?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    originalPatientResponsibility?: Maybe<Scalars['Float']['output']>;
    originalPrimaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    originalSecondaryPayerAllowableAmount?: Maybe<Scalars['Float']['output']>;
    stripeFeeAmount?: Maybe<Scalars['Float']['output']>;
    superscriptFeeAmount?: Maybe<Scalars['Float']['output']>;
};

export type LiveTransfersSumOrderByAggregateInput = {
    currentPatientResponsibility?: InputMaybe<SortOrder>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    grossPayout?: InputMaybe<SortOrder>;
    netPayout?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    originalPatientResponsibility?: InputMaybe<SortOrder>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<SortOrder>;
    stripeFeeAmount?: InputMaybe<SortOrder>;
    superscriptFeeAmount?: InputMaybe<SortOrder>;
};

export type LiveTransfersUpdateInput = {
    action?: InputMaybe<NullableEnumLiveTransferActionEnumFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    artNotes?: InputMaybe<LiveTransfersUpdateartNotesInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    currentPatientResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    dateOfFirstCommunication?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateOfLastCommunication?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateTransferred?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    destinationPayment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    grossPayout?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    locationTimezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    netPayout?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    originalPatientResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOrgEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotType?: InputMaybe<NullableEnumSlotTypeEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumLiveTransferStatusEnumFieldUpdateOperationsInput>;
    stripeFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    stripeTransferDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    treatmentMap?: InputMaybe<Scalars['JSON']['input']>;
    treatmentNames?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    treatmentTypes?: InputMaybe<LiveTransfersUpdatetreatmentTypesInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LiveTransfersUpdateManyMutationInput = {
    action?: InputMaybe<NullableEnumLiveTransferActionEnumFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    artNotes?: InputMaybe<LiveTransfersUpdateartNotesInput>;
    claimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    currentPatientResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    dateOfFirstCommunication?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateOfLastCommunication?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateOfService?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dateTransferred?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    destinationPayment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    grossPayout?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    locationTimezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    netPayout?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    originalPatientResponsibility?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    patientName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientOrgEhrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryPayerPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotType?: InputMaybe<NullableEnumSlotTypeEnumFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumLiveTransferStatusEnumFieldUpdateOperationsInput>;
    stripeFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    stripeTransferDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    treatmentMap?: InputMaybe<Scalars['JSON']['input']>;
    treatmentNames?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    treatmentTypes?: InputMaybe<LiveTransfersUpdatetreatmentTypesInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LiveTransfersUpdateartNotesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LiveTransfersUpdatetreatmentTypesInput = {
    push?: InputMaybe<Array<PaymentTypeEnum>>;
    set?: InputMaybe<Array<PaymentTypeEnum>>;
};

export type LiveTransfersWhereInput = {
    AND?: InputMaybe<Array<LiveTransfersWhereInput>>;
    NOT?: InputMaybe<Array<LiveTransfersWhereInput>>;
    OR?: InputMaybe<Array<LiveTransfersWhereInput>>;
    action?: InputMaybe<EnumLiveTransferActionEnumNullableFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    artNotes?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    currentPatientResponsibility?: InputMaybe<FloatNullableFilter>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<FloatNullableFilter>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<FloatNullableFilter>;
    dateOfFirstCommunication?: InputMaybe<DateTimeNullableFilter>;
    dateOfLastCommunication?: InputMaybe<DateTimeNullableFilter>;
    dateOfService?: InputMaybe<DateTimeFilter>;
    dateTransferred?: InputMaybe<DateTimeNullableFilter>;
    destinationPayment?: InputMaybe<StringNullableFilter>;
    ehrVisitId?: InputMaybe<StringNullableFilter>;
    grossPayout?: InputMaybe<FloatNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    location?: InputMaybe<StringNullableFilter>;
    locationTimezone?: InputMaybe<StringNullableFilter>;
    netPayout?: InputMaybe<FloatNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    originalPatientResponsibility?: InputMaybe<FloatNullableFilter>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<FloatNullableFilter>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<FloatNullableFilter>;
    patientName?: InputMaybe<StringNullableFilter>;
    patientOrgEhrId?: InputMaybe<StringNullableFilter>;
    primaryPayer?: InputMaybe<StringNullableFilter>;
    primaryPayerPackage?: InputMaybe<StringNullableFilter>;
    provider?: InputMaybe<StringNullableFilter>;
    secondaryPayer?: InputMaybe<StringNullableFilter>;
    secondaryPayerPackage?: InputMaybe<StringNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    slotType?: InputMaybe<EnumSlotTypeEnumNullableFilter>;
    status?: InputMaybe<EnumLiveTransferStatusEnumNullableFilter>;
    stripeFeeAmount?: InputMaybe<FloatNullableFilter>;
    stripeTransferDate?: InputMaybe<DateTimeNullableFilter>;
    stripeTransferId?: InputMaybe<StringNullableFilter>;
    stripeTransferStatus?: InputMaybe<StringNullableFilter>;
    superscriptFeeAmount?: InputMaybe<FloatNullableFilter>;
    treatmentMap?: InputMaybe<JsonNullableFilter>;
    treatmentNames?: InputMaybe<StringNullableFilter>;
    treatmentTypes?: InputMaybe<EnumPaymentTypeEnumNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LiveTransfersWhereUniqueInput = {
    AND?: InputMaybe<Array<LiveTransfersWhereInput>>;
    NOT?: InputMaybe<Array<LiveTransfersWhereInput>>;
    OR?: InputMaybe<Array<LiveTransfersWhereInput>>;
    action?: InputMaybe<EnumLiveTransferActionEnumNullableFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    artNotes?: InputMaybe<StringNullableListFilter>;
    claimId?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    currentPatientResponsibility?: InputMaybe<FloatNullableFilter>;
    currentPrimaryPayerAllowableAmount?: InputMaybe<FloatNullableFilter>;
    currentSecondaryPayerAllowableAmount?: InputMaybe<FloatNullableFilter>;
    dateOfFirstCommunication?: InputMaybe<DateTimeNullableFilter>;
    dateOfLastCommunication?: InputMaybe<DateTimeNullableFilter>;
    dateOfService?: InputMaybe<DateTimeFilter>;
    dateTransferred?: InputMaybe<DateTimeNullableFilter>;
    destinationPayment?: InputMaybe<StringNullableFilter>;
    ehrVisitId?: InputMaybe<StringNullableFilter>;
    grossPayout?: InputMaybe<FloatNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    location?: InputMaybe<StringNullableFilter>;
    locationTimezone?: InputMaybe<StringNullableFilter>;
    netPayout?: InputMaybe<FloatNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    originalPatientResponsibility?: InputMaybe<FloatNullableFilter>;
    originalPrimaryPayerAllowableAmount?: InputMaybe<FloatNullableFilter>;
    originalSecondaryPayerAllowableAmount?: InputMaybe<FloatNullableFilter>;
    patientName?: InputMaybe<StringNullableFilter>;
    patientOrgEhrId?: InputMaybe<StringNullableFilter>;
    primaryPayer?: InputMaybe<StringNullableFilter>;
    primaryPayerPackage?: InputMaybe<StringNullableFilter>;
    provider?: InputMaybe<StringNullableFilter>;
    secondaryPayer?: InputMaybe<StringNullableFilter>;
    secondaryPayerPackage?: InputMaybe<StringNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    slotType?: InputMaybe<EnumSlotTypeEnumNullableFilter>;
    status?: InputMaybe<EnumLiveTransferStatusEnumNullableFilter>;
    stripeFeeAmount?: InputMaybe<FloatNullableFilter>;
    stripeTransferDate?: InputMaybe<DateTimeNullableFilter>;
    stripeTransferId?: InputMaybe<StringNullableFilter>;
    stripeTransferStatus?: InputMaybe<StringNullableFilter>;
    superscriptFeeAmount?: InputMaybe<FloatNullableFilter>;
    treatmentMap?: InputMaybe<JsonNullableFilter>;
    treatmentNames?: InputMaybe<StringNullableFilter>;
    treatmentTypes?: InputMaybe<EnumPaymentTypeEnumNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum MessageContext {
    Amount = 'amount',
    AppointmentDate = 'appointmentDate',
    AppointmentTime = 'appointmentTime',
    CardLastFourDigits = 'cardLastFourDigits',
    ChargeDate = 'chargeDate',
    ConsumerFirstName = 'consumerFirstName',
    ConsumerLastName = 'consumerLastName',
    FutureApptDays = 'futureApptDays',
    Link = 'link',
    OrgName = 'orgName',
    OrgPhoneNumber = 'orgPhoneNumber',
    PracticeAddress = 'practiceAddress',
    PracticeName = 'practiceName',
    PracticePhoneNumber = 'practicePhoneNumber',
    ProviderDisplayFirstName = 'providerDisplayFirstName',
    ProviderDisplayLastName = 'providerDisplayLastName',
    ProviderDisplayName = 'providerDisplayName',
    ProviderFirstName = 'providerFirstName',
    ProviderLastName = 'providerLastName',
    TreatmentName = 'treatmentName',
}

export enum MaritalStatus {
    Divorced = 'DIVORCED',
    Married = 'MARRIED',
    Partner = 'PARTNER',
    Separated = 'SEPARATED',
    Single = 'SINGLE',
    Unknown = 'UNKNOWN',
    Widowed = 'WIDOWED',
}

export type MarkAppointmentStatusResult = {
    __typename?: 'MarkAppointmentStatusResult';
    appointment: Appointment;
    ehrCheckinSuccessful: Scalars['Boolean']['output'];
};

export enum McmsAdjudicationVersion {
    AthenaIpit = 'ATHENA_IPIT',
    AthenaLegacy = 'ATHENA_LEGACY',
    MedriteIpit = 'MEDRITE_IPIT',
}

export type McmsAssociation = {
    __typename?: 'McmsAssociation';
    _count?: Maybe<McmsAssociationCount>;
    adjudicationVersion?: Maybe<McmsAdjudicationVersion>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    claims: Array<McmsAssociationClaim>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    reversalAction: McmsReversalAction;
    slots: Array<McmsAssociationSlot>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type McmsAssociationClaimsArgs = {
    cursor?: InputMaybe<McmsAssociationClaimWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationClaimScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationClaimOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimWhereInput>;
};

export type McmsAssociationSlotsArgs = {
    cursor?: InputMaybe<McmsAssociationSlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationSlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationSlotOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotWhereInput>;
};

export type McmsAssociationAuditLog = {
    __typename?: 'McmsAssociationAuditLog';
    adjudicationVersion?: Maybe<McmsAdjudicationVersion>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationId?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    reversalAction?: Maybe<McmsReversalAction>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type McmsAssociationAuditLogAvgAggregate = {
    __typename?: 'McmsAssociationAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type McmsAssociationAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type McmsAssociationAuditLogCountAggregate = {
    __typename?: 'McmsAssociationAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    adjudicationVersion: Scalars['Int']['output'];
    claimReturnStatus: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    mcmsAssociationId: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    reversalAction: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type McmsAssociationAuditLogCountOrderByAggregateInput = {
    adjudicationVersion?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    reversalAction?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationAuditLogCreateInput = {
    adjudicationVersion?: InputMaybe<McmsAdjudicationVersion>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    mcmsAssociationId?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    reversalAction?: InputMaybe<McmsReversalAction>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationAuditLogCreateManyInput = {
    adjudicationVersion?: InputMaybe<McmsAdjudicationVersion>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    mcmsAssociationId?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    reversalAction?: InputMaybe<McmsReversalAction>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationAuditLogGroupBy = {
    __typename?: 'McmsAssociationAuditLogGroupBy';
    _avg?: Maybe<McmsAssociationAuditLogAvgAggregate>;
    _count?: Maybe<McmsAssociationAuditLogCountAggregate>;
    _max?: Maybe<McmsAssociationAuditLogMaxAggregate>;
    _min?: Maybe<McmsAssociationAuditLogMinAggregate>;
    _sum?: Maybe<McmsAssociationAuditLogSumAggregate>;
    adjudicationVersion?: Maybe<McmsAdjudicationVersion>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationId?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    reversalAction?: Maybe<McmsReversalAction>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type McmsAssociationAuditLogMaxAggregate = {
    __typename?: 'McmsAssociationAuditLogMaxAggregate';
    adjudicationVersion?: Maybe<McmsAdjudicationVersion>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationId?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    reversalAction?: Maybe<McmsReversalAction>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationAuditLogMaxOrderByAggregateInput = {
    adjudicationVersion?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    reversalAction?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationAuditLogMinAggregate = {
    __typename?: 'McmsAssociationAuditLogMinAggregate';
    adjudicationVersion?: Maybe<McmsAdjudicationVersion>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationId?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    reversalAction?: Maybe<McmsReversalAction>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationAuditLogMinOrderByAggregateInput = {
    adjudicationVersion?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    reversalAction?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<McmsAssociationAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<McmsAssociationAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<McmsAssociationAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<McmsAssociationAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<McmsAssociationAuditLogSumOrderByAggregateInput>;
    adjudicationVersion?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    mcmsAssociationId?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    reversalAction?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationAuditLogOrderByWithRelationInput = {
    adjudicationVersion?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    mcmsAssociationId?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    reversalAction?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum McmsAssociationAuditLogScalarFieldEnum {
    AdjudicationVersion = 'adjudicationVersion',
    ClaimReturnStatus = 'claimReturnStatus',
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    McmsAssociationId = 'mcmsAssociationId',
    Operation = 'operation',
    OrgId = 'orgId',
    ReversalAction = 'reversalAction',
    UpdatedAt = 'updatedAt',
}

export type McmsAssociationAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<McmsAssociationAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<McmsAssociationAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<McmsAssociationAuditLogScalarWhereWithAggregatesInput>
    >;
    adjudicationVersion?: InputMaybe<EnumMcmsAdjudicationVersionNullableWithAggregatesFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    mcmsAssociationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    reversalAction?: InputMaybe<EnumMcmsReversalActionNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type McmsAssociationAuditLogSumAggregate = {
    __typename?: 'McmsAssociationAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type McmsAssociationAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type McmsAssociationAuditLogUpdateInput = {
    adjudicationVersion?: InputMaybe<NullableEnumMcmsAdjudicationVersionFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    mcmsAssociationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    reversalAction?: InputMaybe<NullableEnumMcmsReversalActionFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationAuditLogUpdateManyMutationInput = {
    adjudicationVersion?: InputMaybe<NullableEnumMcmsAdjudicationVersionFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    mcmsAssociationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    reversalAction?: InputMaybe<NullableEnumMcmsReversalActionFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationAuditLogWhereInput = {
    AND?: InputMaybe<Array<McmsAssociationAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationAuditLogWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationAuditLogWhereInput>>;
    adjudicationVersion?: InputMaybe<EnumMcmsAdjudicationVersionNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    mcmsAssociationId?: InputMaybe<UuidNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    reversalAction?: InputMaybe<EnumMcmsReversalActionNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type McmsAssociationAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<McmsAssociationAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationAuditLogWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationAuditLogWhereInput>>;
    adjudicationVersion?: InputMaybe<EnumMcmsAdjudicationVersionNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    mcmsAssociationId?: InputMaybe<UuidNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    reversalAction?: InputMaybe<EnumMcmsReversalActionNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type McmsAssociationAvgAggregate = {
    __typename?: 'McmsAssociationAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type McmsAssociationAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaim = {
    __typename?: 'McmsAssociationClaim';
    artClaimId?: Maybe<Scalars['String']['output']>;
    association: McmsAssociation;
    associationId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrClaimId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationClaimAssociationIdEhrClaimIdCompoundUniqueInput = {
    associationId: Scalars['String']['input'];
    ehrClaimId: Scalars['String']['input'];
};

export type McmsAssociationClaimAuditLog = {
    __typename?: 'McmsAssociationClaimAuditLog';
    artClaimId?: Maybe<Scalars['String']['output']>;
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationClaimId?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type McmsAssociationClaimAuditLogAvgAggregate = {
    __typename?: 'McmsAssociationClaimAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type McmsAssociationClaimAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimAuditLogCountAggregate = {
    __typename?: 'McmsAssociationClaimAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    artClaimId: Scalars['Int']['output'];
    associationId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    ehrClaimId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    mcmsAssociationClaimId: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type McmsAssociationClaimAuditLogCountOrderByAggregateInput = {
    artClaimId?: InputMaybe<SortOrder>;
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationClaimId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimAuditLogCreateInput = {
    artClaimId?: InputMaybe<Scalars['String']['input']>;
    associationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrClaimId?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    mcmsAssociationClaimId?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationClaimAuditLogCreateManyInput = {
    artClaimId?: InputMaybe<Scalars['String']['input']>;
    associationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrClaimId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    mcmsAssociationClaimId?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationClaimAuditLogGroupBy = {
    __typename?: 'McmsAssociationClaimAuditLogGroupBy';
    _avg?: Maybe<McmsAssociationClaimAuditLogAvgAggregate>;
    _count?: Maybe<McmsAssociationClaimAuditLogCountAggregate>;
    _max?: Maybe<McmsAssociationClaimAuditLogMaxAggregate>;
    _min?: Maybe<McmsAssociationClaimAuditLogMinAggregate>;
    _sum?: Maybe<McmsAssociationClaimAuditLogSumAggregate>;
    artClaimId?: Maybe<Scalars['String']['output']>;
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationClaimId?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type McmsAssociationClaimAuditLogMaxAggregate = {
    __typename?: 'McmsAssociationClaimAuditLogMaxAggregate';
    artClaimId?: Maybe<Scalars['String']['output']>;
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationClaimId?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationClaimAuditLogMaxOrderByAggregateInput = {
    artClaimId?: InputMaybe<SortOrder>;
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationClaimId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimAuditLogMinAggregate = {
    __typename?: 'McmsAssociationClaimAuditLogMinAggregate';
    artClaimId?: Maybe<Scalars['String']['output']>;
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationClaimId?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationClaimAuditLogMinOrderByAggregateInput = {
    artClaimId?: InputMaybe<SortOrder>;
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationClaimId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<McmsAssociationClaimAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<McmsAssociationClaimAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<McmsAssociationClaimAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<McmsAssociationClaimAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<McmsAssociationClaimAuditLogSumOrderByAggregateInput>;
    artClaimId?: InputMaybe<SortOrderInput>;
    associationId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrClaimId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    mcmsAssociationClaimId?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimAuditLogOrderByWithRelationInput = {
    artClaimId?: InputMaybe<SortOrderInput>;
    associationId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrClaimId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    mcmsAssociationClaimId?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum McmsAssociationClaimAuditLogScalarFieldEnum {
    ArtClaimId = 'artClaimId',
    AssociationId = 'associationId',
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    EhrClaimId = 'ehrClaimId',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    McmsAssociationClaimId = 'mcmsAssociationClaimId',
    Operation = 'operation',
    OrgId = 'orgId',
    UpdatedAt = 'updatedAt',
}

export type McmsAssociationClaimAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<McmsAssociationClaimAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<McmsAssociationClaimAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<McmsAssociationClaimAuditLogScalarWhereWithAggregatesInput>
    >;
    artClaimId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    associationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    ehrClaimId?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    mcmsAssociationClaimId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type McmsAssociationClaimAuditLogSumAggregate = {
    __typename?: 'McmsAssociationClaimAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type McmsAssociationClaimAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimAuditLogUpdateInput = {
    artClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    associationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    mcmsAssociationClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationClaimAuditLogUpdateManyMutationInput = {
    artClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    associationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    mcmsAssociationClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationClaimAuditLogWhereInput = {
    AND?: InputMaybe<Array<McmsAssociationClaimAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationClaimAuditLogWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationClaimAuditLogWhereInput>>;
    artClaimId?: InputMaybe<UuidNullableFilter>;
    associationId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrClaimId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    mcmsAssociationClaimId?: InputMaybe<UuidNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type McmsAssociationClaimAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<McmsAssociationClaimAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationClaimAuditLogWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationClaimAuditLogWhereInput>>;
    artClaimId?: InputMaybe<UuidNullableFilter>;
    associationId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrClaimId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    mcmsAssociationClaimId?: InputMaybe<UuidNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type McmsAssociationClaimAvgAggregate = {
    __typename?: 'McmsAssociationClaimAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type McmsAssociationClaimAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimCountAggregate = {
    __typename?: 'McmsAssociationClaimCountAggregate';
    _all: Scalars['Int']['output'];
    artClaimId: Scalars['Int']['output'];
    associationId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    ehrClaimId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type McmsAssociationClaimCountOrderByAggregateInput = {
    artClaimId?: InputMaybe<SortOrder>;
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimCreateInput = {
    artClaimId?: InputMaybe<Scalars['String']['input']>;
    association: McmsAssociationCreateNestedOneWithoutClaimsInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrClaimId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationClaimCreateManyAssociationInput = {
    artClaimId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrClaimId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationClaimCreateManyAssociationInputEnvelope = {
    data: Array<McmsAssociationClaimCreateManyAssociationInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type McmsAssociationClaimCreateManyInput = {
    artClaimId?: InputMaybe<Scalars['String']['input']>;
    associationId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrClaimId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationClaimCreateNestedManyWithoutAssociationInput = {
    connect?: InputMaybe<Array<McmsAssociationClaimWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<McmsAssociationClaimCreateOrConnectWithoutAssociationInput>
    >;
    create?: InputMaybe<
        Array<McmsAssociationClaimCreateWithoutAssociationInput>
    >;
    createMany?: InputMaybe<McmsAssociationClaimCreateManyAssociationInputEnvelope>;
};

export type McmsAssociationClaimCreateOrConnectWithoutAssociationInput = {
    create: McmsAssociationClaimCreateWithoutAssociationInput;
    where: McmsAssociationClaimWhereUniqueInput;
};

export type McmsAssociationClaimCreateWithoutAssociationInput = {
    artClaimId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrClaimId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationClaimGroupBy = {
    __typename?: 'McmsAssociationClaimGroupBy';
    _avg?: Maybe<McmsAssociationClaimAvgAggregate>;
    _count?: Maybe<McmsAssociationClaimCountAggregate>;
    _max?: Maybe<McmsAssociationClaimMaxAggregate>;
    _min?: Maybe<McmsAssociationClaimMinAggregate>;
    _sum?: Maybe<McmsAssociationClaimSumAggregate>;
    artClaimId?: Maybe<Scalars['String']['output']>;
    associationId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrClaimId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationClaimListRelationFilter = {
    every?: InputMaybe<McmsAssociationClaimWhereInput>;
    none?: InputMaybe<McmsAssociationClaimWhereInput>;
    some?: InputMaybe<McmsAssociationClaimWhereInput>;
};

export type McmsAssociationClaimMaxAggregate = {
    __typename?: 'McmsAssociationClaimMaxAggregate';
    artClaimId?: Maybe<Scalars['String']['output']>;
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationClaimMaxOrderByAggregateInput = {
    artClaimId?: InputMaybe<SortOrder>;
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimMinAggregate = {
    __typename?: 'McmsAssociationClaimMinAggregate';
    artClaimId?: Maybe<Scalars['String']['output']>;
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrClaimId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationClaimMinOrderByAggregateInput = {
    artClaimId?: InputMaybe<SortOrder>;
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrClaimId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimOrderByWithAggregationInput = {
    _avg?: InputMaybe<McmsAssociationClaimAvgOrderByAggregateInput>;
    _count?: InputMaybe<McmsAssociationClaimCountOrderByAggregateInput>;
    _max?: InputMaybe<McmsAssociationClaimMaxOrderByAggregateInput>;
    _min?: InputMaybe<McmsAssociationClaimMinOrderByAggregateInput>;
    _sum?: InputMaybe<McmsAssociationClaimSumOrderByAggregateInput>;
    artClaimId?: InputMaybe<SortOrderInput>;
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrClaimId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export type McmsAssociationClaimOrderByWithRelationInput = {
    artClaimId?: InputMaybe<SortOrderInput>;
    association?: InputMaybe<McmsAssociationOrderByWithRelationInput>;
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrClaimId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export enum McmsAssociationClaimScalarFieldEnum {
    ArtClaimId = 'artClaimId',
    AssociationId = 'associationId',
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    EhrClaimId = 'ehrClaimId',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    OrgId = 'orgId',
    UpdatedAt = 'updatedAt',
}

export type McmsAssociationClaimScalarWhereInput = {
    AND?: InputMaybe<Array<McmsAssociationClaimScalarWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationClaimScalarWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationClaimScalarWhereInput>>;
    artClaimId?: InputMaybe<UuidNullableFilter>;
    associationId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrClaimId?: InputMaybe<StringFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type McmsAssociationClaimScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<McmsAssociationClaimScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<McmsAssociationClaimScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<McmsAssociationClaimScalarWhereWithAggregatesInput>>;
    artClaimId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    associationId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    ehrClaimId?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type McmsAssociationClaimSumAggregate = {
    __typename?: 'McmsAssociationClaimSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type McmsAssociationClaimSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type McmsAssociationClaimUpdateInput = {
    artClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    association?: InputMaybe<McmsAssociationUpdateOneRequiredWithoutClaimsNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationClaimUpdateManyMutationInput = {
    artClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationClaimUpdateManyWithWhereWithoutAssociationInput = {
    data: McmsAssociationClaimUpdateManyMutationInput;
    where: McmsAssociationClaimScalarWhereInput;
};

export type McmsAssociationClaimUpdateManyWithoutAssociationNestedInput = {
    connect?: InputMaybe<Array<McmsAssociationClaimWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<McmsAssociationClaimCreateOrConnectWithoutAssociationInput>
    >;
    create?: InputMaybe<
        Array<McmsAssociationClaimCreateWithoutAssociationInput>
    >;
    createMany?: InputMaybe<McmsAssociationClaimCreateManyAssociationInputEnvelope>;
    delete?: InputMaybe<Array<McmsAssociationClaimWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<McmsAssociationClaimScalarWhereInput>>;
    disconnect?: InputMaybe<Array<McmsAssociationClaimWhereUniqueInput>>;
    set?: InputMaybe<Array<McmsAssociationClaimWhereUniqueInput>>;
    update?: InputMaybe<
        Array<McmsAssociationClaimUpdateWithWhereUniqueWithoutAssociationInput>
    >;
    updateMany?: InputMaybe<
        Array<McmsAssociationClaimUpdateManyWithWhereWithoutAssociationInput>
    >;
    upsert?: InputMaybe<
        Array<McmsAssociationClaimUpsertWithWhereUniqueWithoutAssociationInput>
    >;
};

export type McmsAssociationClaimUpdateWithWhereUniqueWithoutAssociationInput = {
    data: McmsAssociationClaimUpdateWithoutAssociationInput;
    where: McmsAssociationClaimWhereUniqueInput;
};

export type McmsAssociationClaimUpdateWithoutAssociationInput = {
    artClaimId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrClaimId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationClaimUpsertWithWhereUniqueWithoutAssociationInput = {
    create: McmsAssociationClaimCreateWithoutAssociationInput;
    update: McmsAssociationClaimUpdateWithoutAssociationInput;
    where: McmsAssociationClaimWhereUniqueInput;
};

export type McmsAssociationClaimWhereInput = {
    AND?: InputMaybe<Array<McmsAssociationClaimWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationClaimWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationClaimWhereInput>>;
    artClaimId?: InputMaybe<UuidNullableFilter>;
    association?: InputMaybe<McmsAssociationRelationFilter>;
    associationId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrClaimId?: InputMaybe<StringFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type McmsAssociationClaimWhereUniqueInput = {
    AND?: InputMaybe<Array<McmsAssociationClaimWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationClaimWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationClaimWhereInput>>;
    artClaimId?: InputMaybe<UuidNullableFilter>;
    association?: InputMaybe<McmsAssociationRelationFilter>;
    associationId?: InputMaybe<UuidFilter>;
    associationId_ehrClaimId?: InputMaybe<McmsAssociationClaimAssociationIdEhrClaimIdCompoundUniqueInput>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrClaimId?: InputMaybe<StringFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type McmsAssociationCount = {
    __typename?: 'McmsAssociationCount';
    claims: Scalars['Int']['output'];
    slots: Scalars['Int']['output'];
};

export type McmsAssociationCountClaimsArgs = {
    where?: InputMaybe<McmsAssociationClaimWhereInput>;
};

export type McmsAssociationCountSlotsArgs = {
    where?: InputMaybe<McmsAssociationSlotWhereInput>;
};

export type McmsAssociationCountAggregate = {
    __typename?: 'McmsAssociationCountAggregate';
    _all: Scalars['Int']['output'];
    adjudicationVersion: Scalars['Int']['output'];
    claimReturnStatus: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    reversalAction: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type McmsAssociationCountOrderByAggregateInput = {
    adjudicationVersion?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    reversalAction?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationCreateInput = {
    adjudicationVersion?: InputMaybe<McmsAdjudicationVersion>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    claims?: InputMaybe<McmsAssociationClaimCreateNestedManyWithoutAssociationInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['String']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    reversalAction?: InputMaybe<McmsReversalAction>;
    slots?: InputMaybe<McmsAssociationSlotCreateNestedManyWithoutAssociationInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationCreateManyInput = {
    adjudicationVersion?: InputMaybe<McmsAdjudicationVersion>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['String']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    reversalAction?: InputMaybe<McmsReversalAction>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationCreateNestedOneWithoutClaimsInput = {
    connect?: InputMaybe<McmsAssociationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<McmsAssociationCreateOrConnectWithoutClaimsInput>;
    create?: InputMaybe<McmsAssociationCreateWithoutClaimsInput>;
};

export type McmsAssociationCreateNestedOneWithoutSlotsInput = {
    connect?: InputMaybe<McmsAssociationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<McmsAssociationCreateOrConnectWithoutSlotsInput>;
    create?: InputMaybe<McmsAssociationCreateWithoutSlotsInput>;
};

export type McmsAssociationCreateOrConnectWithoutClaimsInput = {
    create: McmsAssociationCreateWithoutClaimsInput;
    where: McmsAssociationWhereUniqueInput;
};

export type McmsAssociationCreateOrConnectWithoutSlotsInput = {
    create: McmsAssociationCreateWithoutSlotsInput;
    where: McmsAssociationWhereUniqueInput;
};

export type McmsAssociationCreateWithoutClaimsInput = {
    adjudicationVersion?: InputMaybe<McmsAdjudicationVersion>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['String']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    reversalAction?: InputMaybe<McmsReversalAction>;
    slots?: InputMaybe<McmsAssociationSlotCreateNestedManyWithoutAssociationInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationCreateWithoutSlotsInput = {
    adjudicationVersion?: InputMaybe<McmsAdjudicationVersion>;
    claimReturnStatus?: InputMaybe<ClaimReturnStatusEnum>;
    claims?: InputMaybe<McmsAssociationClaimCreateNestedManyWithoutAssociationInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['String']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    reversalAction?: InputMaybe<McmsReversalAction>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationGroupBy = {
    __typename?: 'McmsAssociationGroupBy';
    _avg?: Maybe<McmsAssociationAvgAggregate>;
    _count?: Maybe<McmsAssociationCountAggregate>;
    _max?: Maybe<McmsAssociationMaxAggregate>;
    _min?: Maybe<McmsAssociationMinAggregate>;
    _sum?: Maybe<McmsAssociationSumAggregate>;
    adjudicationVersion?: Maybe<McmsAdjudicationVersion>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    reversalAction: McmsReversalAction;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type McmsAssociationMaxAggregate = {
    __typename?: 'McmsAssociationMaxAggregate';
    adjudicationVersion?: Maybe<McmsAdjudicationVersion>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    reversalAction?: Maybe<McmsReversalAction>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationMaxOrderByAggregateInput = {
    adjudicationVersion?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    reversalAction?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationMinAggregate = {
    __typename?: 'McmsAssociationMinAggregate';
    adjudicationVersion?: Maybe<McmsAdjudicationVersion>;
    claimReturnStatus?: Maybe<ClaimReturnStatusEnum>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    reversalAction?: Maybe<McmsReversalAction>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationMinOrderByAggregateInput = {
    adjudicationVersion?: InputMaybe<SortOrder>;
    claimReturnStatus?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    reversalAction?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationOrderByWithAggregationInput = {
    _avg?: InputMaybe<McmsAssociationAvgOrderByAggregateInput>;
    _count?: InputMaybe<McmsAssociationCountOrderByAggregateInput>;
    _max?: InputMaybe<McmsAssociationMaxOrderByAggregateInput>;
    _min?: InputMaybe<McmsAssociationMinOrderByAggregateInput>;
    _sum?: InputMaybe<McmsAssociationSumOrderByAggregateInput>;
    adjudicationVersion?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    reversalAction?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationOrderByWithRelationInput = {
    adjudicationVersion?: InputMaybe<SortOrderInput>;
    claimReturnStatus?: InputMaybe<SortOrderInput>;
    claims?: InputMaybe<McmsAssociationClaimOrderByRelationAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    reversalAction?: InputMaybe<SortOrder>;
    slots?: InputMaybe<McmsAssociationSlotOrderByRelationAggregateInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationRelationFilter = {
    is?: InputMaybe<McmsAssociationWhereInput>;
    isNot?: InputMaybe<McmsAssociationWhereInput>;
};

export enum McmsAssociationScalarFieldEnum {
    AdjudicationVersion = 'adjudicationVersion',
    ClaimReturnStatus = 'claimReturnStatus',
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    OrgId = 'orgId',
    ReversalAction = 'reversalAction',
    UpdatedAt = 'updatedAt',
}

export type McmsAssociationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<McmsAssociationScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<McmsAssociationScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<McmsAssociationScalarWhereWithAggregatesInput>>;
    adjudicationVersion?: InputMaybe<EnumMcmsAdjudicationVersionNullableWithAggregatesFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    reversalAction?: InputMaybe<EnumMcmsReversalActionWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type McmsAssociationSlot = {
    __typename?: 'McmsAssociationSlot';
    association: McmsAssociation;
    associationId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    slotId: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationSlotAssociationIdSlotIdCompoundUniqueInput = {
    associationId: Scalars['String']['input'];
    slotId: Scalars['String']['input'];
};

export type McmsAssociationSlotAuditLog = {
    __typename?: 'McmsAssociationSlotAuditLog';
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationSlotId?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type McmsAssociationSlotAuditLogAvgAggregate = {
    __typename?: 'McmsAssociationSlotAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type McmsAssociationSlotAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type McmsAssociationSlotAuditLogCountAggregate = {
    __typename?: 'McmsAssociationSlotAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    associationId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    ehrAppointmentId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    mcmsAssociationSlotId: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type McmsAssociationSlotAuditLogCountOrderByAggregateInput = {
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationSlotId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationSlotAuditLogCreateInput = {
    associationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    mcmsAssociationSlotId?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    slotId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationSlotAuditLogCreateManyInput = {
    associationId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    mcmsAssociationSlotId?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    slotId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationSlotAuditLogGroupBy = {
    __typename?: 'McmsAssociationSlotAuditLogGroupBy';
    _avg?: Maybe<McmsAssociationSlotAuditLogAvgAggregate>;
    _count?: Maybe<McmsAssociationSlotAuditLogCountAggregate>;
    _max?: Maybe<McmsAssociationSlotAuditLogMaxAggregate>;
    _min?: Maybe<McmsAssociationSlotAuditLogMinAggregate>;
    _sum?: Maybe<McmsAssociationSlotAuditLogSumAggregate>;
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationSlotId?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type McmsAssociationSlotAuditLogMaxAggregate = {
    __typename?: 'McmsAssociationSlotAuditLogMaxAggregate';
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationSlotId?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationSlotAuditLogMaxOrderByAggregateInput = {
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationSlotId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationSlotAuditLogMinAggregate = {
    __typename?: 'McmsAssociationSlotAuditLogMinAggregate';
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    mcmsAssociationSlotId?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationSlotAuditLogMinOrderByAggregateInput = {
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    mcmsAssociationSlotId?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationSlotAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<McmsAssociationSlotAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<McmsAssociationSlotAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<McmsAssociationSlotAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<McmsAssociationSlotAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<McmsAssociationSlotAuditLogSumOrderByAggregateInput>;
    associationId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    mcmsAssociationSlotId?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationSlotAuditLogOrderByWithRelationInput = {
    associationId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    mcmsAssociationSlotId?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum McmsAssociationSlotAuditLogScalarFieldEnum {
    AssociationId = 'associationId',
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    EhrAppointmentId = 'ehrAppointmentId',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    McmsAssociationSlotId = 'mcmsAssociationSlotId',
    Operation = 'operation',
    SlotId = 'slotId',
    UpdatedAt = 'updatedAt',
}

export type McmsAssociationSlotAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<McmsAssociationSlotAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<McmsAssociationSlotAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<McmsAssociationSlotAuditLogScalarWhereWithAggregatesInput>
    >;
    associationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    mcmsAssociationSlotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    slotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type McmsAssociationSlotAuditLogSumAggregate = {
    __typename?: 'McmsAssociationSlotAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type McmsAssociationSlotAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type McmsAssociationSlotAuditLogUpdateInput = {
    associationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    mcmsAssociationSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationSlotAuditLogUpdateManyMutationInput = {
    associationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    mcmsAssociationSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationSlotAuditLogWhereInput = {
    AND?: InputMaybe<Array<McmsAssociationSlotAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationSlotAuditLogWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationSlotAuditLogWhereInput>>;
    associationId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    mcmsAssociationSlotId?: InputMaybe<UuidNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type McmsAssociationSlotAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<McmsAssociationSlotAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationSlotAuditLogWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationSlotAuditLogWhereInput>>;
    associationId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    mcmsAssociationSlotId?: InputMaybe<UuidNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type McmsAssociationSlotCountAggregate = {
    __typename?: 'McmsAssociationSlotCountAggregate';
    _all: Scalars['Int']['output'];
    associationId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    ehrAppointmentId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type McmsAssociationSlotCountOrderByAggregateInput = {
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationSlotCreateInput = {
    association: McmsAssociationCreateNestedOneWithoutSlotsInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    slotId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationSlotCreateManyAssociationInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    slotId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationSlotCreateManyAssociationInputEnvelope = {
    data: Array<McmsAssociationSlotCreateManyAssociationInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type McmsAssociationSlotCreateManyInput = {
    associationId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    slotId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationSlotCreateNestedManyWithoutAssociationInput = {
    connect?: InputMaybe<Array<McmsAssociationSlotWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<McmsAssociationSlotCreateOrConnectWithoutAssociationInput>
    >;
    create?: InputMaybe<
        Array<McmsAssociationSlotCreateWithoutAssociationInput>
    >;
    createMany?: InputMaybe<McmsAssociationSlotCreateManyAssociationInputEnvelope>;
};

export type McmsAssociationSlotCreateOrConnectWithoutAssociationInput = {
    create: McmsAssociationSlotCreateWithoutAssociationInput;
    where: McmsAssociationSlotWhereUniqueInput;
};

export type McmsAssociationSlotCreateWithoutAssociationInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrAppointmentId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    slotId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type McmsAssociationSlotGroupBy = {
    __typename?: 'McmsAssociationSlotGroupBy';
    _count?: Maybe<McmsAssociationSlotCountAggregate>;
    _max?: Maybe<McmsAssociationSlotMaxAggregate>;
    _min?: Maybe<McmsAssociationSlotMinAggregate>;
    associationId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    slotId: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationSlotListRelationFilter = {
    every?: InputMaybe<McmsAssociationSlotWhereInput>;
    none?: InputMaybe<McmsAssociationSlotWhereInput>;
    some?: InputMaybe<McmsAssociationSlotWhereInput>;
};

export type McmsAssociationSlotMaxAggregate = {
    __typename?: 'McmsAssociationSlotMaxAggregate';
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationSlotMaxOrderByAggregateInput = {
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationSlotMinAggregate = {
    __typename?: 'McmsAssociationSlotMinAggregate';
    associationId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrAppointmentId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type McmsAssociationSlotMinOrderByAggregateInput = {
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrAppointmentId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type McmsAssociationSlotOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type McmsAssociationSlotOrderByWithAggregationInput = {
    _count?: InputMaybe<McmsAssociationSlotCountOrderByAggregateInput>;
    _max?: InputMaybe<McmsAssociationSlotMaxOrderByAggregateInput>;
    _min?: InputMaybe<McmsAssociationSlotMinOrderByAggregateInput>;
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export type McmsAssociationSlotOrderByWithRelationInput = {
    association?: InputMaybe<McmsAssociationOrderByWithRelationInput>;
    associationId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrAppointmentId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export enum McmsAssociationSlotScalarFieldEnum {
    AssociationId = 'associationId',
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    EhrAppointmentId = 'ehrAppointmentId',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    SlotId = 'slotId',
    UpdatedAt = 'updatedAt',
}

export type McmsAssociationSlotScalarWhereInput = {
    AND?: InputMaybe<Array<McmsAssociationSlotScalarWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationSlotScalarWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationSlotScalarWhereInput>>;
    associationId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    slotId?: InputMaybe<UuidFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type McmsAssociationSlotScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<McmsAssociationSlotScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<McmsAssociationSlotScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<McmsAssociationSlotScalarWhereWithAggregatesInput>>;
    associationId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    slotId?: InputMaybe<UuidWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type McmsAssociationSlotUpdateInput = {
    association?: InputMaybe<McmsAssociationUpdateOneRequiredWithoutSlotsNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationSlotUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationSlotUpdateManyWithWhereWithoutAssociationInput = {
    data: McmsAssociationSlotUpdateManyMutationInput;
    where: McmsAssociationSlotScalarWhereInput;
};

export type McmsAssociationSlotUpdateManyWithoutAssociationNestedInput = {
    connect?: InputMaybe<Array<McmsAssociationSlotWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<McmsAssociationSlotCreateOrConnectWithoutAssociationInput>
    >;
    create?: InputMaybe<
        Array<McmsAssociationSlotCreateWithoutAssociationInput>
    >;
    createMany?: InputMaybe<McmsAssociationSlotCreateManyAssociationInputEnvelope>;
    delete?: InputMaybe<Array<McmsAssociationSlotWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<McmsAssociationSlotScalarWhereInput>>;
    disconnect?: InputMaybe<Array<McmsAssociationSlotWhereUniqueInput>>;
    set?: InputMaybe<Array<McmsAssociationSlotWhereUniqueInput>>;
    update?: InputMaybe<
        Array<McmsAssociationSlotUpdateWithWhereUniqueWithoutAssociationInput>
    >;
    updateMany?: InputMaybe<
        Array<McmsAssociationSlotUpdateManyWithWhereWithoutAssociationInput>
    >;
    upsert?: InputMaybe<
        Array<McmsAssociationSlotUpsertWithWhereUniqueWithoutAssociationInput>
    >;
};

export type McmsAssociationSlotUpdateWithWhereUniqueWithoutAssociationInput = {
    data: McmsAssociationSlotUpdateWithoutAssociationInput;
    where: McmsAssociationSlotWhereUniqueInput;
};

export type McmsAssociationSlotUpdateWithoutAssociationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrAppointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationSlotUpsertWithWhereUniqueWithoutAssociationInput = {
    create: McmsAssociationSlotCreateWithoutAssociationInput;
    update: McmsAssociationSlotUpdateWithoutAssociationInput;
    where: McmsAssociationSlotWhereUniqueInput;
};

export type McmsAssociationSlotWhereInput = {
    AND?: InputMaybe<Array<McmsAssociationSlotWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationSlotWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationSlotWhereInput>>;
    association?: InputMaybe<McmsAssociationRelationFilter>;
    associationId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    slotId?: InputMaybe<UuidFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type McmsAssociationSlotWhereUniqueInput = {
    AND?: InputMaybe<Array<McmsAssociationSlotWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationSlotWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationSlotWhereInput>>;
    association?: InputMaybe<McmsAssociationRelationFilter>;
    associationId?: InputMaybe<UuidFilter>;
    associationId_slotId?: InputMaybe<McmsAssociationSlotAssociationIdSlotIdCompoundUniqueInput>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrAppointmentId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    slotId?: InputMaybe<UuidFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type McmsAssociationSumAggregate = {
    __typename?: 'McmsAssociationSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type McmsAssociationSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type McmsAssociationUpdateInput = {
    adjudicationVersion?: InputMaybe<NullableEnumMcmsAdjudicationVersionFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    claims?: InputMaybe<McmsAssociationClaimUpdateManyWithoutAssociationNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reversalAction?: InputMaybe<EnumMcmsReversalActionFieldUpdateOperationsInput>;
    slots?: InputMaybe<McmsAssociationSlotUpdateManyWithoutAssociationNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationUpdateManyMutationInput = {
    adjudicationVersion?: InputMaybe<NullableEnumMcmsAdjudicationVersionFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reversalAction?: InputMaybe<EnumMcmsReversalActionFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationUpdateOneRequiredWithoutClaimsNestedInput = {
    connect?: InputMaybe<McmsAssociationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<McmsAssociationCreateOrConnectWithoutClaimsInput>;
    create?: InputMaybe<McmsAssociationCreateWithoutClaimsInput>;
    update?: InputMaybe<McmsAssociationUpdateToOneWithWhereWithoutClaimsInput>;
    upsert?: InputMaybe<McmsAssociationUpsertWithoutClaimsInput>;
};

export type McmsAssociationUpdateOneRequiredWithoutSlotsNestedInput = {
    connect?: InputMaybe<McmsAssociationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<McmsAssociationCreateOrConnectWithoutSlotsInput>;
    create?: InputMaybe<McmsAssociationCreateWithoutSlotsInput>;
    update?: InputMaybe<McmsAssociationUpdateToOneWithWhereWithoutSlotsInput>;
    upsert?: InputMaybe<McmsAssociationUpsertWithoutSlotsInput>;
};

export type McmsAssociationUpdateToOneWithWhereWithoutClaimsInput = {
    data: McmsAssociationUpdateWithoutClaimsInput;
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type McmsAssociationUpdateToOneWithWhereWithoutSlotsInput = {
    data: McmsAssociationUpdateWithoutSlotsInput;
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type McmsAssociationUpdateWithoutClaimsInput = {
    adjudicationVersion?: InputMaybe<NullableEnumMcmsAdjudicationVersionFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reversalAction?: InputMaybe<EnumMcmsReversalActionFieldUpdateOperationsInput>;
    slots?: InputMaybe<McmsAssociationSlotUpdateManyWithoutAssociationNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationUpdateWithoutSlotsInput = {
    adjudicationVersion?: InputMaybe<NullableEnumMcmsAdjudicationVersionFieldUpdateOperationsInput>;
    claimReturnStatus?: InputMaybe<NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput>;
    claims?: InputMaybe<McmsAssociationClaimUpdateManyWithoutAssociationNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reversalAction?: InputMaybe<EnumMcmsReversalActionFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type McmsAssociationUpsertWithoutClaimsInput = {
    create: McmsAssociationCreateWithoutClaimsInput;
    update: McmsAssociationUpdateWithoutClaimsInput;
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type McmsAssociationUpsertWithoutSlotsInput = {
    create: McmsAssociationCreateWithoutSlotsInput;
    update: McmsAssociationUpdateWithoutSlotsInput;
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type McmsAssociationWhereInput = {
    AND?: InputMaybe<Array<McmsAssociationWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationWhereInput>>;
    adjudicationVersion?: InputMaybe<EnumMcmsAdjudicationVersionNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    claims?: InputMaybe<McmsAssociationClaimListRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    reversalAction?: InputMaybe<EnumMcmsReversalActionFilter>;
    slots?: InputMaybe<McmsAssociationSlotListRelationFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type McmsAssociationWhereUniqueInput = {
    AND?: InputMaybe<Array<McmsAssociationWhereInput>>;
    NOT?: InputMaybe<Array<McmsAssociationWhereInput>>;
    OR?: InputMaybe<Array<McmsAssociationWhereInput>>;
    adjudicationVersion?: InputMaybe<EnumMcmsAdjudicationVersionNullableFilter>;
    claimReturnStatus?: InputMaybe<EnumClaimReturnStatusEnumNullableFilter>;
    claims?: InputMaybe<McmsAssociationClaimListRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    reversalAction?: InputMaybe<EnumMcmsReversalActionFilter>;
    slots?: InputMaybe<McmsAssociationSlotListRelationFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum McmsReversalAction {
    Blocked = 'BLOCKED',
    Completed = 'COMPLETED',
    NotApplicable = 'NOT_APPLICABLE',
    Pending = 'PENDING',
    PendingGuaranteed = 'PENDING_GUARANTEED',
    PendingPayAfter = 'PENDING_PAY_AFTER',
}

export type MessageBlueprint = {
    __typename?: 'MessageBlueprint';
    _count?: Maybe<MessageBlueprintCount>;
    createdAt: Scalars['DateTimeISO']['output'];
    createdBy?: Maybe<Scalars['String']['output']>;
    hrtMessageTemplate: Array<MessageTemplateHrt>;
    linkType?: Maybe<LinkType>;
    messageType: Scalars['String']['output'];
    orgMessageTemplate: Array<MessageTemplateOrg>;
    parentConsolidationContext?: Maybe<MessageConsolidationContext>;
    parentConsolidationMessageType?: Maybe<Scalars['String']['output']>;
    requiredContext: Array<MessageContext>;
    updatedAt: Scalars['DateTimeISO']['output'];
    updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MessageBlueprintHrtMessageTemplateArgs = {
    cursor?: InputMaybe<MessageTemplateHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageTemplateHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageTemplateHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateHrtWhereInput>;
};

export type MessageBlueprintOrgMessageTemplateArgs = {
    cursor?: InputMaybe<MessageTemplateOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageTemplateOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageTemplateOrgOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateOrgWhereInput>;
};

export type MessageBlueprintParentConsolidationContextArgs = {
    where?: InputMaybe<MessageConsolidationContextWhereInput>;
};

export type MessageBlueprintCount = {
    __typename?: 'MessageBlueprintCount';
    hrtMessageTemplate: Scalars['Int']['output'];
    orgMessageTemplate: Scalars['Int']['output'];
};

export type MessageBlueprintCountHrtMessageTemplateArgs = {
    where?: InputMaybe<MessageTemplateHrtWhereInput>;
};

export type MessageBlueprintCountOrgMessageTemplateArgs = {
    where?: InputMaybe<MessageTemplateOrgWhereInput>;
};

export type MessageBlueprintCountAggregate = {
    __typename?: 'MessageBlueprintCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    createdBy: Scalars['Int']['output'];
    linkType: Scalars['Int']['output'];
    messageType: Scalars['Int']['output'];
    parentConsolidationMessageType: Scalars['Int']['output'];
    requiredContext: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    updatedBy: Scalars['Int']['output'];
};

export type MessageBlueprintCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    linkType?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    parentConsolidationMessageType?: InputMaybe<SortOrder>;
    requiredContext?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageBlueprintCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy?: InputMaybe<Scalars['String']['input']>;
    hrtMessageTemplate?: InputMaybe<MessageTemplateHrtCreateNestedManyWithoutMessageBlueprintInput>;
    linkType?: InputMaybe<LinkType>;
    messageType: Scalars['String']['input'];
    orgMessageTemplate?: InputMaybe<MessageTemplateOrgCreateNestedManyWithoutMessageBlueprintInput>;
    parentConsolidationContext?: InputMaybe<MessageConsolidationContextCreateNestedOneWithoutChildMessageBlueprintsInput>;
    requiredContext?: InputMaybe<MessageBlueprintCreaterequiredContextInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type MessageBlueprintCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy?: InputMaybe<Scalars['String']['input']>;
    linkType?: InputMaybe<LinkType>;
    messageType: Scalars['String']['input'];
    parentConsolidationMessageType?: InputMaybe<Scalars['String']['input']>;
    requiredContext?: InputMaybe<MessageBlueprintCreaterequiredContextInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type MessageBlueprintCreateManyParentConsolidationContextInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy?: InputMaybe<Scalars['String']['input']>;
    linkType?: InputMaybe<LinkType>;
    messageType: Scalars['String']['input'];
    requiredContext?: InputMaybe<MessageBlueprintCreaterequiredContextInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type MessageBlueprintCreateManyParentConsolidationContextInputEnvelope =
    {
        data: Array<MessageBlueprintCreateManyParentConsolidationContextInput>;
        skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
    };

export type MessageBlueprintCreateNestedManyWithoutParentConsolidationContextInput =
    {
        connect?: InputMaybe<Array<MessageBlueprintWhereUniqueInput>>;
        connectOrCreate?: InputMaybe<
            Array<MessageBlueprintCreateOrConnectWithoutParentConsolidationContextInput>
        >;
        create?: InputMaybe<
            Array<MessageBlueprintCreateWithoutParentConsolidationContextInput>
        >;
        createMany?: InputMaybe<MessageBlueprintCreateManyParentConsolidationContextInputEnvelope>;
    };

export type MessageBlueprintCreateNestedOneWithoutHrtMessageTemplateInput = {
    connect?: InputMaybe<MessageBlueprintWhereUniqueInput>;
    connectOrCreate?: InputMaybe<MessageBlueprintCreateOrConnectWithoutHrtMessageTemplateInput>;
    create?: InputMaybe<MessageBlueprintCreateWithoutHrtMessageTemplateInput>;
};

export type MessageBlueprintCreateNestedOneWithoutOrgMessageTemplateInput = {
    connect?: InputMaybe<MessageBlueprintWhereUniqueInput>;
    connectOrCreate?: InputMaybe<MessageBlueprintCreateOrConnectWithoutOrgMessageTemplateInput>;
    create?: InputMaybe<MessageBlueprintCreateWithoutOrgMessageTemplateInput>;
};

export type MessageBlueprintCreateOrConnectWithoutHrtMessageTemplateInput = {
    create: MessageBlueprintCreateWithoutHrtMessageTemplateInput;
    where: MessageBlueprintWhereUniqueInput;
};

export type MessageBlueprintCreateOrConnectWithoutOrgMessageTemplateInput = {
    create: MessageBlueprintCreateWithoutOrgMessageTemplateInput;
    where: MessageBlueprintWhereUniqueInput;
};

export type MessageBlueprintCreateOrConnectWithoutParentConsolidationContextInput =
    {
        create: MessageBlueprintCreateWithoutParentConsolidationContextInput;
        where: MessageBlueprintWhereUniqueInput;
    };

export type MessageBlueprintCreateWithoutHrtMessageTemplateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy?: InputMaybe<Scalars['String']['input']>;
    linkType?: InputMaybe<LinkType>;
    messageType: Scalars['String']['input'];
    orgMessageTemplate?: InputMaybe<MessageTemplateOrgCreateNestedManyWithoutMessageBlueprintInput>;
    parentConsolidationContext?: InputMaybe<MessageConsolidationContextCreateNestedOneWithoutChildMessageBlueprintsInput>;
    requiredContext?: InputMaybe<MessageBlueprintCreaterequiredContextInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type MessageBlueprintCreateWithoutOrgMessageTemplateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy?: InputMaybe<Scalars['String']['input']>;
    hrtMessageTemplate?: InputMaybe<MessageTemplateHrtCreateNestedManyWithoutMessageBlueprintInput>;
    linkType?: InputMaybe<LinkType>;
    messageType: Scalars['String']['input'];
    parentConsolidationContext?: InputMaybe<MessageConsolidationContextCreateNestedOneWithoutChildMessageBlueprintsInput>;
    requiredContext?: InputMaybe<MessageBlueprintCreaterequiredContextInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type MessageBlueprintCreateWithoutParentConsolidationContextInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy?: InputMaybe<Scalars['String']['input']>;
    hrtMessageTemplate?: InputMaybe<MessageTemplateHrtCreateNestedManyWithoutMessageBlueprintInput>;
    linkType?: InputMaybe<LinkType>;
    messageType: Scalars['String']['input'];
    orgMessageTemplate?: InputMaybe<MessageTemplateOrgCreateNestedManyWithoutMessageBlueprintInput>;
    requiredContext?: InputMaybe<MessageBlueprintCreaterequiredContextInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type MessageBlueprintCreaterequiredContextInput = {
    set: Array<MessageContext>;
};

export type MessageBlueprintGroupBy = {
    __typename?: 'MessageBlueprintGroupBy';
    _count?: Maybe<MessageBlueprintCountAggregate>;
    _max?: Maybe<MessageBlueprintMaxAggregate>;
    _min?: Maybe<MessageBlueprintMinAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    createdBy?: Maybe<Scalars['String']['output']>;
    linkType?: Maybe<LinkType>;
    messageType: Scalars['String']['output'];
    parentConsolidationMessageType?: Maybe<Scalars['String']['output']>;
    requiredContext?: Maybe<Array<MessageContext>>;
    updatedAt: Scalars['DateTimeISO']['output'];
    updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MessageBlueprintListRelationFilter = {
    every?: InputMaybe<MessageBlueprintWhereInput>;
    none?: InputMaybe<MessageBlueprintWhereInput>;
    some?: InputMaybe<MessageBlueprintWhereInput>;
};

export type MessageBlueprintMaxAggregate = {
    __typename?: 'MessageBlueprintMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    linkType?: Maybe<LinkType>;
    messageType?: Maybe<Scalars['String']['output']>;
    parentConsolidationMessageType?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MessageBlueprintMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    linkType?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    parentConsolidationMessageType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageBlueprintMinAggregate = {
    __typename?: 'MessageBlueprintMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    linkType?: Maybe<LinkType>;
    messageType?: Maybe<Scalars['String']['output']>;
    parentConsolidationMessageType?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MessageBlueprintMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    linkType?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    parentConsolidationMessageType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageBlueprintOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type MessageBlueprintOrderByWithAggregationInput = {
    _count?: InputMaybe<MessageBlueprintCountOrderByAggregateInput>;
    _max?: InputMaybe<MessageBlueprintMaxOrderByAggregateInput>;
    _min?: InputMaybe<MessageBlueprintMinOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrderInput>;
    linkType?: InputMaybe<SortOrderInput>;
    messageType?: InputMaybe<SortOrder>;
    parentConsolidationMessageType?: InputMaybe<SortOrderInput>;
    requiredContext?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrderInput>;
};

export type MessageBlueprintOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrderInput>;
    hrtMessageTemplate?: InputMaybe<MessageTemplateHrtOrderByRelationAggregateInput>;
    linkType?: InputMaybe<SortOrderInput>;
    messageType?: InputMaybe<SortOrder>;
    orgMessageTemplate?: InputMaybe<MessageTemplateOrgOrderByRelationAggregateInput>;
    parentConsolidationContext?: InputMaybe<MessageConsolidationContextOrderByWithRelationInput>;
    parentConsolidationMessageType?: InputMaybe<SortOrderInput>;
    requiredContext?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrderInput>;
};

export type MessageBlueprintRelationFilter = {
    is?: InputMaybe<MessageBlueprintWhereInput>;
    isNot?: InputMaybe<MessageBlueprintWhereInput>;
};

export enum MessageBlueprintScalarFieldEnum {
    CreatedAt = 'createdAt',
    CreatedBy = 'createdBy',
    LinkType = 'linkType',
    MessageType = 'messageType',
    ParentConsolidationMessageType = 'parentConsolidationMessageType',
    RequiredContext = 'requiredContext',
    UpdatedAt = 'updatedAt',
    UpdatedBy = 'updatedBy',
}

export type MessageBlueprintScalarWhereInput = {
    AND?: InputMaybe<Array<MessageBlueprintScalarWhereInput>>;
    NOT?: InputMaybe<Array<MessageBlueprintScalarWhereInput>>;
    OR?: InputMaybe<Array<MessageBlueprintScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    createdBy?: InputMaybe<StringNullableFilter>;
    linkType?: InputMaybe<EnumLinkTypeNullableFilter>;
    messageType?: InputMaybe<StringFilter>;
    parentConsolidationMessageType?: InputMaybe<StringNullableFilter>;
    requiredContext?: InputMaybe<EnumMessageContextNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    updatedBy?: InputMaybe<StringNullableFilter>;
};

export type MessageBlueprintScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<MessageBlueprintScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<MessageBlueprintScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<MessageBlueprintScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    createdBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    linkType?: InputMaybe<EnumLinkTypeNullableWithAggregatesFilter>;
    messageType?: InputMaybe<StringWithAggregatesFilter>;
    parentConsolidationMessageType?: InputMaybe<StringNullableWithAggregatesFilter>;
    requiredContext?: InputMaybe<EnumMessageContextNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    updatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type MessageBlueprintUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtMessageTemplate?: InputMaybe<MessageTemplateHrtUpdateManyWithoutMessageBlueprintNestedInput>;
    linkType?: InputMaybe<NullableEnumLinkTypeFieldUpdateOperationsInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgMessageTemplate?: InputMaybe<MessageTemplateOrgUpdateManyWithoutMessageBlueprintNestedInput>;
    parentConsolidationContext?: InputMaybe<MessageConsolidationContextUpdateOneWithoutChildMessageBlueprintsNestedInput>;
    requiredContext?: InputMaybe<MessageBlueprintUpdaterequiredContextInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type MessageBlueprintUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    linkType?: InputMaybe<NullableEnumLinkTypeFieldUpdateOperationsInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    requiredContext?: InputMaybe<MessageBlueprintUpdaterequiredContextInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type MessageBlueprintUpdateManyWithWhereWithoutParentConsolidationContextInput =
    {
        data: MessageBlueprintUpdateManyMutationInput;
        where: MessageBlueprintScalarWhereInput;
    };

export type MessageBlueprintUpdateManyWithoutParentConsolidationContextNestedInput =
    {
        connect?: InputMaybe<Array<MessageBlueprintWhereUniqueInput>>;
        connectOrCreate?: InputMaybe<
            Array<MessageBlueprintCreateOrConnectWithoutParentConsolidationContextInput>
        >;
        create?: InputMaybe<
            Array<MessageBlueprintCreateWithoutParentConsolidationContextInput>
        >;
        createMany?: InputMaybe<MessageBlueprintCreateManyParentConsolidationContextInputEnvelope>;
        delete?: InputMaybe<Array<MessageBlueprintWhereUniqueInput>>;
        deleteMany?: InputMaybe<Array<MessageBlueprintScalarWhereInput>>;
        disconnect?: InputMaybe<Array<MessageBlueprintWhereUniqueInput>>;
        set?: InputMaybe<Array<MessageBlueprintWhereUniqueInput>>;
        update?: InputMaybe<
            Array<MessageBlueprintUpdateWithWhereUniqueWithoutParentConsolidationContextInput>
        >;
        updateMany?: InputMaybe<
            Array<MessageBlueprintUpdateManyWithWhereWithoutParentConsolidationContextInput>
        >;
        upsert?: InputMaybe<
            Array<MessageBlueprintUpsertWithWhereUniqueWithoutParentConsolidationContextInput>
        >;
    };

export type MessageBlueprintUpdateOneRequiredWithoutHrtMessageTemplateNestedInput =
    {
        connect?: InputMaybe<MessageBlueprintWhereUniqueInput>;
        connectOrCreate?: InputMaybe<MessageBlueprintCreateOrConnectWithoutHrtMessageTemplateInput>;
        create?: InputMaybe<MessageBlueprintCreateWithoutHrtMessageTemplateInput>;
        update?: InputMaybe<MessageBlueprintUpdateToOneWithWhereWithoutHrtMessageTemplateInput>;
        upsert?: InputMaybe<MessageBlueprintUpsertWithoutHrtMessageTemplateInput>;
    };

export type MessageBlueprintUpdateOneRequiredWithoutOrgMessageTemplateNestedInput =
    {
        connect?: InputMaybe<MessageBlueprintWhereUniqueInput>;
        connectOrCreate?: InputMaybe<MessageBlueprintCreateOrConnectWithoutOrgMessageTemplateInput>;
        create?: InputMaybe<MessageBlueprintCreateWithoutOrgMessageTemplateInput>;
        update?: InputMaybe<MessageBlueprintUpdateToOneWithWhereWithoutOrgMessageTemplateInput>;
        upsert?: InputMaybe<MessageBlueprintUpsertWithoutOrgMessageTemplateInput>;
    };

export type MessageBlueprintUpdateToOneWithWhereWithoutHrtMessageTemplateInput =
    {
        data: MessageBlueprintUpdateWithoutHrtMessageTemplateInput;
        where?: InputMaybe<MessageBlueprintWhereInput>;
    };

export type MessageBlueprintUpdateToOneWithWhereWithoutOrgMessageTemplateInput =
    {
        data: MessageBlueprintUpdateWithoutOrgMessageTemplateInput;
        where?: InputMaybe<MessageBlueprintWhereInput>;
    };

export type MessageBlueprintUpdateWithWhereUniqueWithoutParentConsolidationContextInput =
    {
        data: MessageBlueprintUpdateWithoutParentConsolidationContextInput;
        where: MessageBlueprintWhereUniqueInput;
    };

export type MessageBlueprintUpdateWithoutHrtMessageTemplateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    linkType?: InputMaybe<NullableEnumLinkTypeFieldUpdateOperationsInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgMessageTemplate?: InputMaybe<MessageTemplateOrgUpdateManyWithoutMessageBlueprintNestedInput>;
    parentConsolidationContext?: InputMaybe<MessageConsolidationContextUpdateOneWithoutChildMessageBlueprintsNestedInput>;
    requiredContext?: InputMaybe<MessageBlueprintUpdaterequiredContextInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type MessageBlueprintUpdateWithoutOrgMessageTemplateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtMessageTemplate?: InputMaybe<MessageTemplateHrtUpdateManyWithoutMessageBlueprintNestedInput>;
    linkType?: InputMaybe<NullableEnumLinkTypeFieldUpdateOperationsInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    parentConsolidationContext?: InputMaybe<MessageConsolidationContextUpdateOneWithoutChildMessageBlueprintsNestedInput>;
    requiredContext?: InputMaybe<MessageBlueprintUpdaterequiredContextInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type MessageBlueprintUpdateWithoutParentConsolidationContextInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hrtMessageTemplate?: InputMaybe<MessageTemplateHrtUpdateManyWithoutMessageBlueprintNestedInput>;
    linkType?: InputMaybe<NullableEnumLinkTypeFieldUpdateOperationsInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgMessageTemplate?: InputMaybe<MessageTemplateOrgUpdateManyWithoutMessageBlueprintNestedInput>;
    requiredContext?: InputMaybe<MessageBlueprintUpdaterequiredContextInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type MessageBlueprintUpdaterequiredContextInput = {
    push?: InputMaybe<Array<MessageContext>>;
    set?: InputMaybe<Array<MessageContext>>;
};

export type MessageBlueprintUpsertWithWhereUniqueWithoutParentConsolidationContextInput =
    {
        create: MessageBlueprintCreateWithoutParentConsolidationContextInput;
        update: MessageBlueprintUpdateWithoutParentConsolidationContextInput;
        where: MessageBlueprintWhereUniqueInput;
    };

export type MessageBlueprintUpsertWithoutHrtMessageTemplateInput = {
    create: MessageBlueprintCreateWithoutHrtMessageTemplateInput;
    update: MessageBlueprintUpdateWithoutHrtMessageTemplateInput;
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type MessageBlueprintUpsertWithoutOrgMessageTemplateInput = {
    create: MessageBlueprintCreateWithoutOrgMessageTemplateInput;
    update: MessageBlueprintUpdateWithoutOrgMessageTemplateInput;
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type MessageBlueprintWhereInput = {
    AND?: InputMaybe<Array<MessageBlueprintWhereInput>>;
    NOT?: InputMaybe<Array<MessageBlueprintWhereInput>>;
    OR?: InputMaybe<Array<MessageBlueprintWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    createdBy?: InputMaybe<StringNullableFilter>;
    hrtMessageTemplate?: InputMaybe<MessageTemplateHrtListRelationFilter>;
    linkType?: InputMaybe<EnumLinkTypeNullableFilter>;
    messageType?: InputMaybe<StringFilter>;
    orgMessageTemplate?: InputMaybe<MessageTemplateOrgListRelationFilter>;
    parentConsolidationContext?: InputMaybe<MessageConsolidationContextNullableRelationFilter>;
    parentConsolidationMessageType?: InputMaybe<StringNullableFilter>;
    requiredContext?: InputMaybe<EnumMessageContextNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    updatedBy?: InputMaybe<StringNullableFilter>;
};

export type MessageBlueprintWhereUniqueInput = {
    AND?: InputMaybe<Array<MessageBlueprintWhereInput>>;
    NOT?: InputMaybe<Array<MessageBlueprintWhereInput>>;
    OR?: InputMaybe<Array<MessageBlueprintWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    createdBy?: InputMaybe<StringNullableFilter>;
    hrtMessageTemplate?: InputMaybe<MessageTemplateHrtListRelationFilter>;
    linkType?: InputMaybe<EnumLinkTypeNullableFilter>;
    messageType?: InputMaybe<Scalars['String']['input']>;
    orgMessageTemplate?: InputMaybe<MessageTemplateOrgListRelationFilter>;
    parentConsolidationContext?: InputMaybe<MessageConsolidationContextNullableRelationFilter>;
    parentConsolidationMessageType?: InputMaybe<StringNullableFilter>;
    requiredContext?: InputMaybe<EnumMessageContextNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    updatedBy?: InputMaybe<StringNullableFilter>;
};

export type MessageConsolidationContext = {
    __typename?: 'MessageConsolidationContext';
    _count?: Maybe<MessageConsolidationContextCount>;
    childMessageBlueprints: Array<MessageBlueprint>;
    context: Scalars['JSON']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    messageConsolidationTemplates: Array<MessageConsolidationTemplate>;
    messageType: Scalars['String']['output'];
    renderVariables: Array<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type MessageConsolidationContextChildMessageBlueprintsArgs = {
    cursor?: InputMaybe<MessageBlueprintWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageBlueprintScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageBlueprintOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type MessageConsolidationContextMessageConsolidationTemplatesArgs = {
    cursor?: InputMaybe<MessageConsolidationTemplateWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageConsolidationTemplateScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationTemplateOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationTemplateWhereInput>;
};

export type MessageConsolidationContextCount = {
    __typename?: 'MessageConsolidationContextCount';
    childMessageBlueprints: Scalars['Int']['output'];
    messageConsolidationTemplates: Scalars['Int']['output'];
};

export type MessageConsolidationContextCountChildMessageBlueprintsArgs = {
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type MessageConsolidationContextCountMessageConsolidationTemplatesArgs =
    {
        where?: InputMaybe<MessageConsolidationTemplateWhereInput>;
    };

export type MessageConsolidationContextCountAggregate = {
    __typename?: 'MessageConsolidationContextCountAggregate';
    _all: Scalars['Int']['output'];
    context: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    messageType: Scalars['Int']['output'];
    renderVariables: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type MessageConsolidationContextCountOrderByAggregateInput = {
    context?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    renderVariables?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessageConsolidationContextCreateInput = {
    childMessageBlueprints?: InputMaybe<MessageBlueprintCreateNestedManyWithoutParentConsolidationContextInput>;
    context: Scalars['JSON']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    messageConsolidationTemplates?: InputMaybe<MessageConsolidationTemplateCreateNestedManyWithoutMessageConsolidationContextInput>;
    messageType: Scalars['String']['input'];
    renderVariables?: InputMaybe<MessageConsolidationContextCreaterenderVariablesInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessageConsolidationContextCreateManyInput = {
    context: Scalars['JSON']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    messageType: Scalars['String']['input'];
    renderVariables?: InputMaybe<MessageConsolidationContextCreaterenderVariablesInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessageConsolidationContextCreateNestedOneWithoutChildMessageBlueprintsInput =
    {
        connect?: InputMaybe<MessageConsolidationContextWhereUniqueInput>;
        connectOrCreate?: InputMaybe<MessageConsolidationContextCreateOrConnectWithoutChildMessageBlueprintsInput>;
        create?: InputMaybe<MessageConsolidationContextCreateWithoutChildMessageBlueprintsInput>;
    };

export type MessageConsolidationContextCreateNestedOneWithoutMessageConsolidationTemplatesInput =
    {
        connect?: InputMaybe<MessageConsolidationContextWhereUniqueInput>;
        connectOrCreate?: InputMaybe<MessageConsolidationContextCreateOrConnectWithoutMessageConsolidationTemplatesInput>;
        create?: InputMaybe<MessageConsolidationContextCreateWithoutMessageConsolidationTemplatesInput>;
    };

export type MessageConsolidationContextCreateOrConnectWithoutChildMessageBlueprintsInput =
    {
        create: MessageConsolidationContextCreateWithoutChildMessageBlueprintsInput;
        where: MessageConsolidationContextWhereUniqueInput;
    };

export type MessageConsolidationContextCreateOrConnectWithoutMessageConsolidationTemplatesInput =
    {
        create: MessageConsolidationContextCreateWithoutMessageConsolidationTemplatesInput;
        where: MessageConsolidationContextWhereUniqueInput;
    };

export type MessageConsolidationContextCreateWithoutChildMessageBlueprintsInput =
    {
        context: Scalars['JSON']['input'];
        createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
        messageConsolidationTemplates?: InputMaybe<MessageConsolidationTemplateCreateNestedManyWithoutMessageConsolidationContextInput>;
        messageType: Scalars['String']['input'];
        renderVariables?: InputMaybe<MessageConsolidationContextCreaterenderVariablesInput>;
        updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    };

export type MessageConsolidationContextCreateWithoutMessageConsolidationTemplatesInput =
    {
        childMessageBlueprints?: InputMaybe<MessageBlueprintCreateNestedManyWithoutParentConsolidationContextInput>;
        context: Scalars['JSON']['input'];
        createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
        messageType: Scalars['String']['input'];
        renderVariables?: InputMaybe<MessageConsolidationContextCreaterenderVariablesInput>;
        updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    };

export type MessageConsolidationContextCreaterenderVariablesInput = {
    set: Array<Scalars['String']['input']>;
};

export type MessageConsolidationContextGroupBy = {
    __typename?: 'MessageConsolidationContextGroupBy';
    _count?: Maybe<MessageConsolidationContextCountAggregate>;
    _max?: Maybe<MessageConsolidationContextMaxAggregate>;
    _min?: Maybe<MessageConsolidationContextMinAggregate>;
    context: Scalars['JSON']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    messageType: Scalars['String']['output'];
    renderVariables?: Maybe<Array<Scalars['String']['output']>>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type MessageConsolidationContextMaxAggregate = {
    __typename?: 'MessageConsolidationContextMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    messageType?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MessageConsolidationContextMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessageConsolidationContextMinAggregate = {
    __typename?: 'MessageConsolidationContextMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    messageType?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MessageConsolidationContextMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessageConsolidationContextNullableRelationFilter = {
    is?: InputMaybe<MessageConsolidationContextWhereInput>;
    isNot?: InputMaybe<MessageConsolidationContextWhereInput>;
};

export type MessageConsolidationContextOrderByWithAggregationInput = {
    _count?: InputMaybe<MessageConsolidationContextCountOrderByAggregateInput>;
    _max?: InputMaybe<MessageConsolidationContextMaxOrderByAggregateInput>;
    _min?: InputMaybe<MessageConsolidationContextMinOrderByAggregateInput>;
    context?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    renderVariables?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessageConsolidationContextOrderByWithRelationInput = {
    childMessageBlueprints?: InputMaybe<MessageBlueprintOrderByRelationAggregateInput>;
    context?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    messageConsolidationTemplates?: InputMaybe<MessageConsolidationTemplateOrderByRelationAggregateInput>;
    messageType?: InputMaybe<SortOrder>;
    renderVariables?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessageConsolidationContextRelationFilter = {
    is?: InputMaybe<MessageConsolidationContextWhereInput>;
    isNot?: InputMaybe<MessageConsolidationContextWhereInput>;
};

export enum MessageConsolidationContextScalarFieldEnum {
    Context = 'context',
    CreatedAt = 'createdAt',
    MessageType = 'messageType',
    RenderVariables = 'renderVariables',
    UpdatedAt = 'updatedAt',
}

export type MessageConsolidationContextScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<MessageConsolidationContextScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<MessageConsolidationContextScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<MessageConsolidationContextScalarWhereWithAggregatesInput>
    >;
    context?: InputMaybe<JsonWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    messageType?: InputMaybe<StringWithAggregatesFilter>;
    renderVariables?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type MessageConsolidationContextUpdateInput = {
    childMessageBlueprints?: InputMaybe<MessageBlueprintUpdateManyWithoutParentConsolidationContextNestedInput>;
    context?: InputMaybe<Scalars['JSON']['input']>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    messageConsolidationTemplates?: InputMaybe<MessageConsolidationTemplateUpdateManyWithoutMessageConsolidationContextNestedInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    renderVariables?: InputMaybe<MessageConsolidationContextUpdaterenderVariablesInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageConsolidationContextUpdateManyMutationInput = {
    context?: InputMaybe<Scalars['JSON']['input']>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    renderVariables?: InputMaybe<MessageConsolidationContextUpdaterenderVariablesInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageConsolidationContextUpdateOneRequiredWithoutMessageConsolidationTemplatesNestedInput =
    {
        connect?: InputMaybe<MessageConsolidationContextWhereUniqueInput>;
        connectOrCreate?: InputMaybe<MessageConsolidationContextCreateOrConnectWithoutMessageConsolidationTemplatesInput>;
        create?: InputMaybe<MessageConsolidationContextCreateWithoutMessageConsolidationTemplatesInput>;
        update?: InputMaybe<MessageConsolidationContextUpdateToOneWithWhereWithoutMessageConsolidationTemplatesInput>;
        upsert?: InputMaybe<MessageConsolidationContextUpsertWithoutMessageConsolidationTemplatesInput>;
    };

export type MessageConsolidationContextUpdateOneWithoutChildMessageBlueprintsNestedInput =
    {
        connect?: InputMaybe<MessageConsolidationContextWhereUniqueInput>;
        connectOrCreate?: InputMaybe<MessageConsolidationContextCreateOrConnectWithoutChildMessageBlueprintsInput>;
        create?: InputMaybe<MessageConsolidationContextCreateWithoutChildMessageBlueprintsInput>;
        delete?: InputMaybe<MessageConsolidationContextWhereInput>;
        disconnect?: InputMaybe<MessageConsolidationContextWhereInput>;
        update?: InputMaybe<MessageConsolidationContextUpdateToOneWithWhereWithoutChildMessageBlueprintsInput>;
        upsert?: InputMaybe<MessageConsolidationContextUpsertWithoutChildMessageBlueprintsInput>;
    };

export type MessageConsolidationContextUpdateToOneWithWhereWithoutChildMessageBlueprintsInput =
    {
        data: MessageConsolidationContextUpdateWithoutChildMessageBlueprintsInput;
        where?: InputMaybe<MessageConsolidationContextWhereInput>;
    };

export type MessageConsolidationContextUpdateToOneWithWhereWithoutMessageConsolidationTemplatesInput =
    {
        data: MessageConsolidationContextUpdateWithoutMessageConsolidationTemplatesInput;
        where?: InputMaybe<MessageConsolidationContextWhereInput>;
    };

export type MessageConsolidationContextUpdateWithoutChildMessageBlueprintsInput =
    {
        context?: InputMaybe<Scalars['JSON']['input']>;
        createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
        messageConsolidationTemplates?: InputMaybe<MessageConsolidationTemplateUpdateManyWithoutMessageConsolidationContextNestedInput>;
        messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
        renderVariables?: InputMaybe<MessageConsolidationContextUpdaterenderVariablesInput>;
        updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    };

export type MessageConsolidationContextUpdateWithoutMessageConsolidationTemplatesInput =
    {
        childMessageBlueprints?: InputMaybe<MessageBlueprintUpdateManyWithoutParentConsolidationContextNestedInput>;
        context?: InputMaybe<Scalars['JSON']['input']>;
        createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
        messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
        renderVariables?: InputMaybe<MessageConsolidationContextUpdaterenderVariablesInput>;
        updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    };

export type MessageConsolidationContextUpdaterenderVariablesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MessageConsolidationContextUpsertWithoutChildMessageBlueprintsInput =
    {
        create: MessageConsolidationContextCreateWithoutChildMessageBlueprintsInput;
        update: MessageConsolidationContextUpdateWithoutChildMessageBlueprintsInput;
        where?: InputMaybe<MessageConsolidationContextWhereInput>;
    };

export type MessageConsolidationContextUpsertWithoutMessageConsolidationTemplatesInput =
    {
        create: MessageConsolidationContextCreateWithoutMessageConsolidationTemplatesInput;
        update: MessageConsolidationContextUpdateWithoutMessageConsolidationTemplatesInput;
        where?: InputMaybe<MessageConsolidationContextWhereInput>;
    };

export type MessageConsolidationContextWhereInput = {
    AND?: InputMaybe<Array<MessageConsolidationContextWhereInput>>;
    NOT?: InputMaybe<Array<MessageConsolidationContextWhereInput>>;
    OR?: InputMaybe<Array<MessageConsolidationContextWhereInput>>;
    childMessageBlueprints?: InputMaybe<MessageBlueprintListRelationFilter>;
    context?: InputMaybe<JsonFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    messageConsolidationTemplates?: InputMaybe<MessageConsolidationTemplateListRelationFilter>;
    messageType?: InputMaybe<StringFilter>;
    renderVariables?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageConsolidationContextWhereUniqueInput = {
    AND?: InputMaybe<Array<MessageConsolidationContextWhereInput>>;
    NOT?: InputMaybe<Array<MessageConsolidationContextWhereInput>>;
    OR?: InputMaybe<Array<MessageConsolidationContextWhereInput>>;
    childMessageBlueprints?: InputMaybe<MessageBlueprintListRelationFilter>;
    context?: InputMaybe<JsonFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    messageConsolidationTemplates?: InputMaybe<MessageConsolidationTemplateListRelationFilter>;
    messageType?: InputMaybe<Scalars['String']['input']>;
    renderVariables?: InputMaybe<StringNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageConsolidationTemplate = {
    __typename?: 'MessageConsolidationTemplate';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    messageConsolidationContext: MessageConsolidationContext;
    messageType: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    template: Scalars['JSON']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    updatedBy: Scalars['String']['output'];
};

export type MessageConsolidationTemplateAvgAggregate = {
    __typename?: 'MessageConsolidationTemplateAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type MessageConsolidationTemplateAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type MessageConsolidationTemplateCountAggregate = {
    __typename?: 'MessageConsolidationTemplateCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    messageType: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    template: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    updatedBy: Scalars['Int']['output'];
};

export type MessageConsolidationTemplateCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    template?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageConsolidationTemplateCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageConsolidationContext: MessageConsolidationContextCreateNestedOneWithoutMessageConsolidationTemplatesInput;
    orgId: Scalars['Int']['input'];
    template: Scalars['JSON']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedBy: Scalars['String']['input'];
};

export type MessageConsolidationTemplateCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageType: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    template: Scalars['JSON']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedBy: Scalars['String']['input'];
};

export type MessageConsolidationTemplateCreateManyMessageConsolidationContextInput =
    {
        createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
        id?: InputMaybe<Scalars['String']['input']>;
        orgId: Scalars['Int']['input'];
        template: Scalars['JSON']['input'];
        updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
        updatedBy: Scalars['String']['input'];
    };

export type MessageConsolidationTemplateCreateManyMessageConsolidationContextInputEnvelope =
    {
        data: Array<MessageConsolidationTemplateCreateManyMessageConsolidationContextInput>;
        skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
    };

export type MessageConsolidationTemplateCreateNestedManyWithoutMessageConsolidationContextInput =
    {
        connect?: InputMaybe<
            Array<MessageConsolidationTemplateWhereUniqueInput>
        >;
        connectOrCreate?: InputMaybe<
            Array<MessageConsolidationTemplateCreateOrConnectWithoutMessageConsolidationContextInput>
        >;
        create?: InputMaybe<
            Array<MessageConsolidationTemplateCreateWithoutMessageConsolidationContextInput>
        >;
        createMany?: InputMaybe<MessageConsolidationTemplateCreateManyMessageConsolidationContextInputEnvelope>;
    };

export type MessageConsolidationTemplateCreateOrConnectWithoutMessageConsolidationContextInput =
    {
        create: MessageConsolidationTemplateCreateWithoutMessageConsolidationContextInput;
        where: MessageConsolidationTemplateWhereUniqueInput;
    };

export type MessageConsolidationTemplateCreateWithoutMessageConsolidationContextInput =
    {
        createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
        id?: InputMaybe<Scalars['String']['input']>;
        orgId: Scalars['Int']['input'];
        template: Scalars['JSON']['input'];
        updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
        updatedBy: Scalars['String']['input'];
    };

export type MessageConsolidationTemplateGroupBy = {
    __typename?: 'MessageConsolidationTemplateGroupBy';
    _avg?: Maybe<MessageConsolidationTemplateAvgAggregate>;
    _count?: Maybe<MessageConsolidationTemplateCountAggregate>;
    _max?: Maybe<MessageConsolidationTemplateMaxAggregate>;
    _min?: Maybe<MessageConsolidationTemplateMinAggregate>;
    _sum?: Maybe<MessageConsolidationTemplateSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    messageType: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    template: Scalars['JSON']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    updatedBy: Scalars['String']['output'];
};

export type MessageConsolidationTemplateListRelationFilter = {
    every?: InputMaybe<MessageConsolidationTemplateWhereInput>;
    none?: InputMaybe<MessageConsolidationTemplateWhereInput>;
    some?: InputMaybe<MessageConsolidationTemplateWhereInput>;
};

export type MessageConsolidationTemplateMaxAggregate = {
    __typename?: 'MessageConsolidationTemplateMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    messageType?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MessageConsolidationTemplateMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageConsolidationTemplateMinAggregate = {
    __typename?: 'MessageConsolidationTemplateMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    messageType?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MessageConsolidationTemplateMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageConsolidationTemplateOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type MessageConsolidationTemplateOrderByWithAggregationInput = {
    _avg?: InputMaybe<MessageConsolidationTemplateAvgOrderByAggregateInput>;
    _count?: InputMaybe<MessageConsolidationTemplateCountOrderByAggregateInput>;
    _max?: InputMaybe<MessageConsolidationTemplateMaxOrderByAggregateInput>;
    _min?: InputMaybe<MessageConsolidationTemplateMinOrderByAggregateInput>;
    _sum?: InputMaybe<MessageConsolidationTemplateSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    template?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageConsolidationTemplateOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    messageConsolidationContext?: InputMaybe<MessageConsolidationContextOrderByWithRelationInput>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    template?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageConsolidationTemplateOrgIdMessageTypeCompoundUniqueInput = {
    messageType: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
};

export enum MessageConsolidationTemplateScalarFieldEnum {
    CreatedAt = 'createdAt',
    Id = 'id',
    MessageType = 'messageType',
    OrgId = 'orgId',
    Template = 'template',
    UpdatedAt = 'updatedAt',
    UpdatedBy = 'updatedBy',
}

export type MessageConsolidationTemplateScalarWhereInput = {
    AND?: InputMaybe<Array<MessageConsolidationTemplateScalarWhereInput>>;
    NOT?: InputMaybe<Array<MessageConsolidationTemplateScalarWhereInput>>;
    OR?: InputMaybe<Array<MessageConsolidationTemplateScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    messageType?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    template?: InputMaybe<JsonFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    updatedBy?: InputMaybe<StringFilter>;
};

export type MessageConsolidationTemplateScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<MessageConsolidationTemplateScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<MessageConsolidationTemplateScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<MessageConsolidationTemplateScalarWhereWithAggregatesInput>
    >;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    messageType?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    template?: InputMaybe<JsonWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    updatedBy?: InputMaybe<StringWithAggregatesFilter>;
};

export type MessageConsolidationTemplateSumAggregate = {
    __typename?: 'MessageConsolidationTemplateSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type MessageConsolidationTemplateSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type MessageConsolidationTemplateUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageConsolidationContext?: InputMaybe<MessageConsolidationContextUpdateOneRequiredWithoutMessageConsolidationTemplatesNestedInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    template?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MessageConsolidationTemplateUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    template?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MessageConsolidationTemplateUpdateManyWithWhereWithoutMessageConsolidationContextInput =
    {
        data: MessageConsolidationTemplateUpdateManyMutationInput;
        where: MessageConsolidationTemplateScalarWhereInput;
    };

export type MessageConsolidationTemplateUpdateManyWithoutMessageConsolidationContextNestedInput =
    {
        connect?: InputMaybe<
            Array<MessageConsolidationTemplateWhereUniqueInput>
        >;
        connectOrCreate?: InputMaybe<
            Array<MessageConsolidationTemplateCreateOrConnectWithoutMessageConsolidationContextInput>
        >;
        create?: InputMaybe<
            Array<MessageConsolidationTemplateCreateWithoutMessageConsolidationContextInput>
        >;
        createMany?: InputMaybe<MessageConsolidationTemplateCreateManyMessageConsolidationContextInputEnvelope>;
        delete?: InputMaybe<
            Array<MessageConsolidationTemplateWhereUniqueInput>
        >;
        deleteMany?: InputMaybe<
            Array<MessageConsolidationTemplateScalarWhereInput>
        >;
        disconnect?: InputMaybe<
            Array<MessageConsolidationTemplateWhereUniqueInput>
        >;
        set?: InputMaybe<Array<MessageConsolidationTemplateWhereUniqueInput>>;
        update?: InputMaybe<
            Array<MessageConsolidationTemplateUpdateWithWhereUniqueWithoutMessageConsolidationContextInput>
        >;
        updateMany?: InputMaybe<
            Array<MessageConsolidationTemplateUpdateManyWithWhereWithoutMessageConsolidationContextInput>
        >;
        upsert?: InputMaybe<
            Array<MessageConsolidationTemplateUpsertWithWhereUniqueWithoutMessageConsolidationContextInput>
        >;
    };

export type MessageConsolidationTemplateUpdateWithWhereUniqueWithoutMessageConsolidationContextInput =
    {
        data: MessageConsolidationTemplateUpdateWithoutMessageConsolidationContextInput;
        where: MessageConsolidationTemplateWhereUniqueInput;
    };

export type MessageConsolidationTemplateUpdateWithoutMessageConsolidationContextInput =
    {
        createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
        id?: InputMaybe<StringFieldUpdateOperationsInput>;
        orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
        template?: InputMaybe<Scalars['JSON']['input']>;
        updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
        updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
    };

export type MessageConsolidationTemplateUpsertWithWhereUniqueWithoutMessageConsolidationContextInput =
    {
        create: MessageConsolidationTemplateCreateWithoutMessageConsolidationContextInput;
        update: MessageConsolidationTemplateUpdateWithoutMessageConsolidationContextInput;
        where: MessageConsolidationTemplateWhereUniqueInput;
    };

export type MessageConsolidationTemplateWhereInput = {
    AND?: InputMaybe<Array<MessageConsolidationTemplateWhereInput>>;
    NOT?: InputMaybe<Array<MessageConsolidationTemplateWhereInput>>;
    OR?: InputMaybe<Array<MessageConsolidationTemplateWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    messageConsolidationContext?: InputMaybe<MessageConsolidationContextRelationFilter>;
    messageType?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    template?: InputMaybe<JsonFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    updatedBy?: InputMaybe<StringFilter>;
};

export type MessageConsolidationTemplateWhereUniqueInput = {
    AND?: InputMaybe<Array<MessageConsolidationTemplateWhereInput>>;
    NOT?: InputMaybe<Array<MessageConsolidationTemplateWhereInput>>;
    OR?: InputMaybe<Array<MessageConsolidationTemplateWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageConsolidationContext?: InputMaybe<MessageConsolidationContextRelationFilter>;
    messageType?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgId_messageType?: InputMaybe<MessageConsolidationTemplateOrgIdMessageTypeCompoundUniqueInput>;
    template?: InputMaybe<JsonFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    updatedBy?: InputMaybe<StringFilter>;
};

export type MessageNudge = {
    __typename?: 'MessageNudge';
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumer: Consumer;
    consumerId: Scalars['String']['output'];
    consumerMessage?: Maybe<ConsumerMessage>;
    consumerMessageId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    messageType: Scalars['String']['output'];
    nudgePayload: Scalars['JSON']['output'];
    orgId: Scalars['Int']['output'];
    processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    processingDetails?: Maybe<Scalars['JSON']['output']>;
    sendAt: Scalars['DateTimeISO']['output'];
    status: MessageNudgeStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type MessageNudgeConsumerMessageArgs = {
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type MessageNudgeAvgAggregate = {
    __typename?: 'MessageNudgeAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type MessageNudgeAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type MessageNudgeCountAggregate = {
    __typename?: 'MessageNudgeCountAggregate';
    _all: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    consumerMessageId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    messageType: Scalars['Int']['output'];
    nudgePayload: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    processedAt: Scalars['Int']['output'];
    processingDetails: Scalars['Int']['output'];
    sendAt: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type MessageNudgeCountOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    consumerMessageId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    nudgePayload?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    processedAt?: InputMaybe<SortOrder>;
    processingDetails?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessageNudgeCreateInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumer: ConsumerCreateNestedOneWithoutMessageNudgesInput;
    consumerMessage?: InputMaybe<ConsumerMessageCreateNestedOneWithoutMessageNudgesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageType: Scalars['String']['input'];
    nudgePayload: Scalars['JSON']['input'];
    orgId: Scalars['Int']['input'];
    processedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processingDetails?: InputMaybe<Scalars['JSON']['input']>;
    sendAt: Scalars['DateTimeISO']['input'];
    status?: InputMaybe<MessageNudgeStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessageNudgeCreateManyConsumerInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumerMessageId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageType: Scalars['String']['input'];
    nudgePayload: Scalars['JSON']['input'];
    orgId: Scalars['Int']['input'];
    processedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processingDetails?: InputMaybe<Scalars['JSON']['input']>;
    sendAt: Scalars['DateTimeISO']['input'];
    status?: InputMaybe<MessageNudgeStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessageNudgeCreateManyConsumerInputEnvelope = {
    data: Array<MessageNudgeCreateManyConsumerInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageNudgeCreateManyConsumerMessageInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageType: Scalars['String']['input'];
    nudgePayload: Scalars['JSON']['input'];
    orgId: Scalars['Int']['input'];
    processedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processingDetails?: InputMaybe<Scalars['JSON']['input']>;
    sendAt: Scalars['DateTimeISO']['input'];
    status?: InputMaybe<MessageNudgeStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessageNudgeCreateManyConsumerMessageInputEnvelope = {
    data: Array<MessageNudgeCreateManyConsumerMessageInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageNudgeCreateManyInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumerId: Scalars['String']['input'];
    consumerMessageId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageType: Scalars['String']['input'];
    nudgePayload: Scalars['JSON']['input'];
    orgId: Scalars['Int']['input'];
    processedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processingDetails?: InputMaybe<Scalars['JSON']['input']>;
    sendAt: Scalars['DateTimeISO']['input'];
    status?: InputMaybe<MessageNudgeStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessageNudgeCreateNestedManyWithoutConsumerInput = {
    connect?: InputMaybe<Array<MessageNudgeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<MessageNudgeCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<MessageNudgeCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<MessageNudgeCreateManyConsumerInputEnvelope>;
};

export type MessageNudgeCreateNestedManyWithoutConsumerMessageInput = {
    connect?: InputMaybe<Array<MessageNudgeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<MessageNudgeCreateOrConnectWithoutConsumerMessageInput>
    >;
    create?: InputMaybe<Array<MessageNudgeCreateWithoutConsumerMessageInput>>;
    createMany?: InputMaybe<MessageNudgeCreateManyConsumerMessageInputEnvelope>;
};

export type MessageNudgeCreateOrConnectWithoutConsumerInput = {
    create: MessageNudgeCreateWithoutConsumerInput;
    where: MessageNudgeWhereUniqueInput;
};

export type MessageNudgeCreateOrConnectWithoutConsumerMessageInput = {
    create: MessageNudgeCreateWithoutConsumerMessageInput;
    where: MessageNudgeWhereUniqueInput;
};

export type MessageNudgeCreateWithoutConsumerInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumerMessage?: InputMaybe<ConsumerMessageCreateNestedOneWithoutMessageNudgesInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageType: Scalars['String']['input'];
    nudgePayload: Scalars['JSON']['input'];
    orgId: Scalars['Int']['input'];
    processedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processingDetails?: InputMaybe<Scalars['JSON']['input']>;
    sendAt: Scalars['DateTimeISO']['input'];
    status?: InputMaybe<MessageNudgeStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessageNudgeCreateWithoutConsumerMessageInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumer: ConsumerCreateNestedOneWithoutMessageNudgesInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageType: Scalars['String']['input'];
    nudgePayload: Scalars['JSON']['input'];
    orgId: Scalars['Int']['input'];
    processedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processingDetails?: InputMaybe<Scalars['JSON']['input']>;
    sendAt: Scalars['DateTimeISO']['input'];
    status?: InputMaybe<MessageNudgeStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessageNudgeGroupBy = {
    __typename?: 'MessageNudgeGroupBy';
    _avg?: Maybe<MessageNudgeAvgAggregate>;
    _count?: Maybe<MessageNudgeCountAggregate>;
    _max?: Maybe<MessageNudgeMaxAggregate>;
    _min?: Maybe<MessageNudgeMinAggregate>;
    _sum?: Maybe<MessageNudgeSumAggregate>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId: Scalars['String']['output'];
    consumerMessageId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    messageType: Scalars['String']['output'];
    nudgePayload: Scalars['JSON']['output'];
    orgId: Scalars['Int']['output'];
    processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    processingDetails?: Maybe<Scalars['JSON']['output']>;
    sendAt: Scalars['DateTimeISO']['output'];
    status: MessageNudgeStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type MessageNudgeListRelationFilter = {
    every?: InputMaybe<MessageNudgeWhereInput>;
    none?: InputMaybe<MessageNudgeWhereInput>;
    some?: InputMaybe<MessageNudgeWhereInput>;
};

export type MessageNudgeMaxAggregate = {
    __typename?: 'MessageNudgeMaxAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    consumerMessageId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    messageType?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    sendAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<MessageNudgeStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MessageNudgeMaxOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    consumerMessageId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    processedAt?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessageNudgeMinAggregate = {
    __typename?: 'MessageNudgeMinAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    consumerMessageId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    messageType?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    sendAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<MessageNudgeStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MessageNudgeMinOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    consumerMessageId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    processedAt?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessageNudgeOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type MessageNudgeOrderByWithAggregationInput = {
    _avg?: InputMaybe<MessageNudgeAvgOrderByAggregateInput>;
    _count?: InputMaybe<MessageNudgeCountOrderByAggregateInput>;
    _max?: InputMaybe<MessageNudgeMaxOrderByAggregateInput>;
    _min?: InputMaybe<MessageNudgeMinOrderByAggregateInput>;
    _sum?: InputMaybe<MessageNudgeSumOrderByAggregateInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrder>;
    consumerMessageId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    nudgePayload?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    processedAt?: InputMaybe<SortOrderInput>;
    processingDetails?: InputMaybe<SortOrderInput>;
    sendAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessageNudgeOrderByWithRelationInput = {
    appointmentId?: InputMaybe<SortOrderInput>;
    consumer?: InputMaybe<ConsumerOrderByWithRelationInput>;
    consumerId?: InputMaybe<SortOrder>;
    consumerMessage?: InputMaybe<ConsumerMessageOrderByWithRelationInput>;
    consumerMessageId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    nudgePayload?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    processedAt?: InputMaybe<SortOrderInput>;
    processingDetails?: InputMaybe<SortOrderInput>;
    sendAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum MessageNudgeScalarFieldEnum {
    AppointmentId = 'appointmentId',
    ConsumerId = 'consumerId',
    ConsumerMessageId = 'consumerMessageId',
    CreatedAt = 'createdAt',
    Id = 'id',
    MessageType = 'messageType',
    NudgePayload = 'nudgePayload',
    OrgId = 'orgId',
    ProcessedAt = 'processedAt',
    ProcessingDetails = 'processingDetails',
    SendAt = 'sendAt',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type MessageNudgeScalarWhereInput = {
    AND?: InputMaybe<Array<MessageNudgeScalarWhereInput>>;
    NOT?: InputMaybe<Array<MessageNudgeScalarWhereInput>>;
    OR?: InputMaybe<Array<MessageNudgeScalarWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    consumerMessageId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    messageType?: InputMaybe<StringFilter>;
    nudgePayload?: InputMaybe<JsonFilter>;
    orgId?: InputMaybe<IntFilter>;
    processedAt?: InputMaybe<DateTimeNullableFilter>;
    processingDetails?: InputMaybe<JsonNullableFilter>;
    sendAt?: InputMaybe<DateTimeFilter>;
    status?: InputMaybe<EnumMessageNudgeStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageNudgeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<MessageNudgeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<MessageNudgeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<MessageNudgeScalarWhereWithAggregatesInput>>;
    appointmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    consumerMessageId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    messageType?: InputMaybe<StringWithAggregatesFilter>;
    nudgePayload?: InputMaybe<JsonWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    processedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    processingDetails?: InputMaybe<JsonNullableWithAggregatesFilter>;
    sendAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    status?: InputMaybe<EnumMessageNudgeStatusWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum MessageNudgeStatus {
    Cancelled = 'CANCELLED',
    Consolidated = 'CONSOLIDATED',
    Failed = 'FAILED',
    Pending = 'PENDING',
    Processed = 'PROCESSED',
    Processing = 'PROCESSING',
    Suppressed = 'SUPPRESSED',
}

export type MessageNudgeSumAggregate = {
    __typename?: 'MessageNudgeSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type MessageNudgeSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type MessageNudgeUpdateInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumer?: InputMaybe<ConsumerUpdateOneRequiredWithoutMessageNudgesNestedInput>;
    consumerMessage?: InputMaybe<ConsumerMessageUpdateOneWithoutMessageNudgesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    nudgePayload?: InputMaybe<Scalars['JSON']['input']>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    processingDetails?: InputMaybe<Scalars['JSON']['input']>;
    sendAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumMessageNudgeStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageNudgeUpdateManyMutationInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    nudgePayload?: InputMaybe<Scalars['JSON']['input']>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    processingDetails?: InputMaybe<Scalars['JSON']['input']>;
    sendAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumMessageNudgeStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageNudgeUpdateManyWithWhereWithoutConsumerInput = {
    data: MessageNudgeUpdateManyMutationInput;
    where: MessageNudgeScalarWhereInput;
};

export type MessageNudgeUpdateManyWithWhereWithoutConsumerMessageInput = {
    data: MessageNudgeUpdateManyMutationInput;
    where: MessageNudgeScalarWhereInput;
};

export type MessageNudgeUpdateManyWithoutConsumerMessageNestedInput = {
    connect?: InputMaybe<Array<MessageNudgeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<MessageNudgeCreateOrConnectWithoutConsumerMessageInput>
    >;
    create?: InputMaybe<Array<MessageNudgeCreateWithoutConsumerMessageInput>>;
    createMany?: InputMaybe<MessageNudgeCreateManyConsumerMessageInputEnvelope>;
    delete?: InputMaybe<Array<MessageNudgeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<MessageNudgeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<MessageNudgeWhereUniqueInput>>;
    set?: InputMaybe<Array<MessageNudgeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<MessageNudgeUpdateWithWhereUniqueWithoutConsumerMessageInput>
    >;
    updateMany?: InputMaybe<
        Array<MessageNudgeUpdateManyWithWhereWithoutConsumerMessageInput>
    >;
    upsert?: InputMaybe<
        Array<MessageNudgeUpsertWithWhereUniqueWithoutConsumerMessageInput>
    >;
};

export type MessageNudgeUpdateManyWithoutConsumerNestedInput = {
    connect?: InputMaybe<Array<MessageNudgeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<MessageNudgeCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<MessageNudgeCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<MessageNudgeCreateManyConsumerInputEnvelope>;
    delete?: InputMaybe<Array<MessageNudgeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<MessageNudgeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<MessageNudgeWhereUniqueInput>>;
    set?: InputMaybe<Array<MessageNudgeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<MessageNudgeUpdateWithWhereUniqueWithoutConsumerInput>
    >;
    updateMany?: InputMaybe<
        Array<MessageNudgeUpdateManyWithWhereWithoutConsumerInput>
    >;
    upsert?: InputMaybe<
        Array<MessageNudgeUpsertWithWhereUniqueWithoutConsumerInput>
    >;
};

export type MessageNudgeUpdateWithWhereUniqueWithoutConsumerInput = {
    data: MessageNudgeUpdateWithoutConsumerInput;
    where: MessageNudgeWhereUniqueInput;
};

export type MessageNudgeUpdateWithWhereUniqueWithoutConsumerMessageInput = {
    data: MessageNudgeUpdateWithoutConsumerMessageInput;
    where: MessageNudgeWhereUniqueInput;
};

export type MessageNudgeUpdateWithoutConsumerInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerMessage?: InputMaybe<ConsumerMessageUpdateOneWithoutMessageNudgesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    nudgePayload?: InputMaybe<Scalars['JSON']['input']>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    processingDetails?: InputMaybe<Scalars['JSON']['input']>;
    sendAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumMessageNudgeStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageNudgeUpdateWithoutConsumerMessageInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumer?: InputMaybe<ConsumerUpdateOneRequiredWithoutMessageNudgesNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    messageType?: InputMaybe<StringFieldUpdateOperationsInput>;
    nudgePayload?: InputMaybe<Scalars['JSON']['input']>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    processingDetails?: InputMaybe<Scalars['JSON']['input']>;
    sendAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumMessageNudgeStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageNudgeUpsertWithWhereUniqueWithoutConsumerInput = {
    create: MessageNudgeCreateWithoutConsumerInput;
    update: MessageNudgeUpdateWithoutConsumerInput;
    where: MessageNudgeWhereUniqueInput;
};

export type MessageNudgeUpsertWithWhereUniqueWithoutConsumerMessageInput = {
    create: MessageNudgeCreateWithoutConsumerMessageInput;
    update: MessageNudgeUpdateWithoutConsumerMessageInput;
    where: MessageNudgeWhereUniqueInput;
};

export type MessageNudgeWhereInput = {
    AND?: InputMaybe<Array<MessageNudgeWhereInput>>;
    NOT?: InputMaybe<Array<MessageNudgeWhereInput>>;
    OR?: InputMaybe<Array<MessageNudgeWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    consumer?: InputMaybe<ConsumerRelationFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    consumerMessage?: InputMaybe<ConsumerMessageNullableRelationFilter>;
    consumerMessageId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    messageType?: InputMaybe<StringFilter>;
    nudgePayload?: InputMaybe<JsonFilter>;
    orgId?: InputMaybe<IntFilter>;
    processedAt?: InputMaybe<DateTimeNullableFilter>;
    processingDetails?: InputMaybe<JsonNullableFilter>;
    sendAt?: InputMaybe<DateTimeFilter>;
    status?: InputMaybe<EnumMessageNudgeStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageNudgeWhereUniqueInput = {
    AND?: InputMaybe<Array<MessageNudgeWhereInput>>;
    NOT?: InputMaybe<Array<MessageNudgeWhereInput>>;
    OR?: InputMaybe<Array<MessageNudgeWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    consumer?: InputMaybe<ConsumerRelationFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    consumerMessage?: InputMaybe<ConsumerMessageNullableRelationFilter>;
    consumerMessageId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    messageType?: InputMaybe<StringFilter>;
    nudgePayload?: InputMaybe<JsonFilter>;
    orgId?: InputMaybe<IntFilter>;
    processedAt?: InputMaybe<DateTimeNullableFilter>;
    processingDetails?: InputMaybe<JsonNullableFilter>;
    sendAt?: InputMaybe<DateTimeFilter>;
    status?: InputMaybe<EnumMessageNudgeStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageOrchestrationRule = {
    __typename?: 'MessageOrchestrationRule';
    createdAt: Scalars['DateTimeISO']['output'];
    isActive: Scalars['Boolean']['output'];
    orgId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    ruleConfig?: Maybe<Scalars['JSON']['output']>;
    ruleName: MessagingRuleName;
    ruleType: MessagingRuleType;
    updatedAt: Scalars['DateTimeISO']['output'];
    updatedBy: Scalars['String']['output'];
};

export type MessageOrchestrationRuleAvgAggregate = {
    __typename?: 'MessageOrchestrationRuleAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
};

export type MessageOrchestrationRuleAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
};

export type MessageOrchestrationRuleCountAggregate = {
    __typename?: 'MessageOrchestrationRuleCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    ruleConfig: Scalars['Int']['output'];
    ruleName: Scalars['Int']['output'];
    ruleType: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    updatedBy: Scalars['Int']['output'];
};

export type MessageOrchestrationRuleCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    ruleConfig?: InputMaybe<SortOrder>;
    ruleName?: InputMaybe<SortOrder>;
    ruleType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageOrchestrationRuleCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    orgId: Scalars['Int']['input'];
    priority?: InputMaybe<Scalars['Int']['input']>;
    ruleConfig?: InputMaybe<Scalars['JSON']['input']>;
    ruleName: MessagingRuleName;
    ruleType: MessagingRuleType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedBy: Scalars['String']['input'];
};

export type MessageOrchestrationRuleCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    orgId: Scalars['Int']['input'];
    priority?: InputMaybe<Scalars['Int']['input']>;
    ruleConfig?: InputMaybe<Scalars['JSON']['input']>;
    ruleName: MessagingRuleName;
    ruleType: MessagingRuleType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedBy: Scalars['String']['input'];
};

export type MessageOrchestrationRuleGroupBy = {
    __typename?: 'MessageOrchestrationRuleGroupBy';
    _avg?: Maybe<MessageOrchestrationRuleAvgAggregate>;
    _count?: Maybe<MessageOrchestrationRuleCountAggregate>;
    _max?: Maybe<MessageOrchestrationRuleMaxAggregate>;
    _min?: Maybe<MessageOrchestrationRuleMinAggregate>;
    _sum?: Maybe<MessageOrchestrationRuleSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    isActive: Scalars['Boolean']['output'];
    orgId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    ruleConfig?: Maybe<Scalars['JSON']['output']>;
    ruleName: MessagingRuleName;
    ruleType: MessagingRuleType;
    updatedAt: Scalars['DateTimeISO']['output'];
    updatedBy: Scalars['String']['output'];
};

export type MessageOrchestrationRuleMaxAggregate = {
    __typename?: 'MessageOrchestrationRuleMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    ruleName?: Maybe<MessagingRuleName>;
    ruleType?: Maybe<MessagingRuleType>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MessageOrchestrationRuleMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    ruleName?: InputMaybe<SortOrder>;
    ruleType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageOrchestrationRuleMinAggregate = {
    __typename?: 'MessageOrchestrationRuleMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    ruleName?: Maybe<MessagingRuleName>;
    ruleType?: Maybe<MessagingRuleType>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MessageOrchestrationRuleMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    ruleName?: InputMaybe<SortOrder>;
    ruleType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageOrchestrationRuleOrderByWithAggregationInput = {
    _avg?: InputMaybe<MessageOrchestrationRuleAvgOrderByAggregateInput>;
    _count?: InputMaybe<MessageOrchestrationRuleCountOrderByAggregateInput>;
    _max?: InputMaybe<MessageOrchestrationRuleMaxOrderByAggregateInput>;
    _min?: InputMaybe<MessageOrchestrationRuleMinOrderByAggregateInput>;
    _sum?: InputMaybe<MessageOrchestrationRuleSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    ruleConfig?: InputMaybe<SortOrderInput>;
    ruleName?: InputMaybe<SortOrder>;
    ruleType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageOrchestrationRuleOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    ruleConfig?: InputMaybe<SortOrderInput>;
    ruleName?: InputMaybe<SortOrder>;
    ruleType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    updatedBy?: InputMaybe<SortOrder>;
};

export type MessageOrchestrationRuleOrgIdRuleTypeRuleNameCompoundUniqueInput = {
    orgId: Scalars['Int']['input'];
    ruleName: MessagingRuleName;
    ruleType: MessagingRuleType;
};

export enum MessageOrchestrationRuleScalarFieldEnum {
    CreatedAt = 'createdAt',
    IsActive = 'isActive',
    OrgId = 'orgId',
    Priority = 'priority',
    RuleConfig = 'ruleConfig',
    RuleName = 'ruleName',
    RuleType = 'ruleType',
    UpdatedAt = 'updatedAt',
    UpdatedBy = 'updatedBy',
}

export type MessageOrchestrationRuleScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<MessageOrchestrationRuleScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<MessageOrchestrationRuleScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<MessageOrchestrationRuleScalarWhereWithAggregatesInput>
    >;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    priority?: InputMaybe<IntWithAggregatesFilter>;
    ruleConfig?: InputMaybe<JsonNullableWithAggregatesFilter>;
    ruleName?: InputMaybe<EnumMessagingRuleNameWithAggregatesFilter>;
    ruleType?: InputMaybe<EnumMessagingRuleTypeWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    updatedBy?: InputMaybe<StringWithAggregatesFilter>;
};

export type MessageOrchestrationRuleSumAggregate = {
    __typename?: 'MessageOrchestrationRuleSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
};

export type MessageOrchestrationRuleSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
};

export type MessageOrchestrationRuleUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    ruleConfig?: InputMaybe<Scalars['JSON']['input']>;
    ruleName?: InputMaybe<EnumMessagingRuleNameFieldUpdateOperationsInput>;
    ruleType?: InputMaybe<EnumMessagingRuleTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MessageOrchestrationRuleUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    priority?: InputMaybe<IntFieldUpdateOperationsInput>;
    ruleConfig?: InputMaybe<Scalars['JSON']['input']>;
    ruleName?: InputMaybe<EnumMessagingRuleNameFieldUpdateOperationsInput>;
    ruleType?: InputMaybe<EnumMessagingRuleTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MessageOrchestrationRuleWhereInput = {
    AND?: InputMaybe<Array<MessageOrchestrationRuleWhereInput>>;
    NOT?: InputMaybe<Array<MessageOrchestrationRuleWhereInput>>;
    OR?: InputMaybe<Array<MessageOrchestrationRuleWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    isActive?: InputMaybe<BoolFilter>;
    orgId?: InputMaybe<IntFilter>;
    priority?: InputMaybe<IntFilter>;
    ruleConfig?: InputMaybe<JsonNullableFilter>;
    ruleName?: InputMaybe<EnumMessagingRuleNameFilter>;
    ruleType?: InputMaybe<EnumMessagingRuleTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    updatedBy?: InputMaybe<StringFilter>;
};

export type MessageOrchestrationRuleWhereUniqueInput = {
    AND?: InputMaybe<Array<MessageOrchestrationRuleWhereInput>>;
    NOT?: InputMaybe<Array<MessageOrchestrationRuleWhereInput>>;
    OR?: InputMaybe<Array<MessageOrchestrationRuleWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    isActive?: InputMaybe<BoolFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgId_ruleType_ruleName?: InputMaybe<MessageOrchestrationRuleOrgIdRuleTypeRuleNameCompoundUniqueInput>;
    priority?: InputMaybe<IntFilter>;
    ruleConfig?: InputMaybe<JsonNullableFilter>;
    ruleName?: InputMaybe<EnumMessagingRuleNameFilter>;
    ruleType?: InputMaybe<EnumMessagingRuleTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    updatedBy?: InputMaybe<StringFilter>;
};

export type MessagePayAfter = {
    __typename?: 'MessagePayAfter';
    consumer: Consumer;
    consumerId: Scalars['String']['output'];
    messageCount: Scalars['Int']['output'];
    outstandingBalance: Scalars['Decimal']['output'];
    sendAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type MessagePayAfterAvgAggregate = {
    __typename?: 'MessagePayAfterAvgAggregate';
    messageCount?: Maybe<Scalars['Float']['output']>;
    outstandingBalance?: Maybe<Scalars['Decimal']['output']>;
};

export type MessagePayAfterAvgOrderByAggregateInput = {
    messageCount?: InputMaybe<SortOrder>;
    outstandingBalance?: InputMaybe<SortOrder>;
};

export type MessagePayAfterCountAggregate = {
    __typename?: 'MessagePayAfterCountAggregate';
    _all: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    messageCount: Scalars['Int']['output'];
    outstandingBalance: Scalars['Int']['output'];
    sendAt: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type MessagePayAfterCountOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    messageCount?: InputMaybe<SortOrder>;
    outstandingBalance?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessagePayAfterCreateInput = {
    consumer: ConsumerCreateNestedOneWithoutMessagePayAfterInput;
    messageCount?: InputMaybe<Scalars['Int']['input']>;
    outstandingBalance: Scalars['Decimal']['input'];
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessagePayAfterCreateManyConsumerInput = {
    messageCount?: InputMaybe<Scalars['Int']['input']>;
    outstandingBalance: Scalars['Decimal']['input'];
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessagePayAfterCreateManyConsumerInputEnvelope = {
    data: Array<MessagePayAfterCreateManyConsumerInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessagePayAfterCreateManyInput = {
    consumerId: Scalars['String']['input'];
    messageCount?: InputMaybe<Scalars['Int']['input']>;
    outstandingBalance: Scalars['Decimal']['input'];
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessagePayAfterCreateNestedManyWithoutConsumerInput = {
    connect?: InputMaybe<Array<MessagePayAfterWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<MessagePayAfterCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<MessagePayAfterCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<MessagePayAfterCreateManyConsumerInputEnvelope>;
};

export type MessagePayAfterCreateOrConnectWithoutConsumerInput = {
    create: MessagePayAfterCreateWithoutConsumerInput;
    where: MessagePayAfterWhereUniqueInput;
};

export type MessagePayAfterCreateWithoutConsumerInput = {
    messageCount?: InputMaybe<Scalars['Int']['input']>;
    outstandingBalance: Scalars['Decimal']['input'];
    sendAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MessagePayAfterGroupBy = {
    __typename?: 'MessagePayAfterGroupBy';
    _avg?: Maybe<MessagePayAfterAvgAggregate>;
    _count?: Maybe<MessagePayAfterCountAggregate>;
    _max?: Maybe<MessagePayAfterMaxAggregate>;
    _min?: Maybe<MessagePayAfterMinAggregate>;
    _sum?: Maybe<MessagePayAfterSumAggregate>;
    consumerId: Scalars['String']['output'];
    messageCount: Scalars['Int']['output'];
    outstandingBalance: Scalars['Decimal']['output'];
    sendAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type MessagePayAfterListRelationFilter = {
    every?: InputMaybe<MessagePayAfterWhereInput>;
    none?: InputMaybe<MessagePayAfterWhereInput>;
    some?: InputMaybe<MessagePayAfterWhereInput>;
};

export type MessagePayAfterMaxAggregate = {
    __typename?: 'MessagePayAfterMaxAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    messageCount?: Maybe<Scalars['Int']['output']>;
    outstandingBalance?: Maybe<Scalars['Decimal']['output']>;
    sendAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MessagePayAfterMaxOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    messageCount?: InputMaybe<SortOrder>;
    outstandingBalance?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessagePayAfterMinAggregate = {
    __typename?: 'MessagePayAfterMinAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    messageCount?: Maybe<Scalars['Int']['output']>;
    outstandingBalance?: Maybe<Scalars['Decimal']['output']>;
    sendAt?: Maybe<Scalars['DateTimeISO']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MessagePayAfterMinOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    messageCount?: InputMaybe<SortOrder>;
    outstandingBalance?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessagePayAfterOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type MessagePayAfterOrderByWithAggregationInput = {
    _avg?: InputMaybe<MessagePayAfterAvgOrderByAggregateInput>;
    _count?: InputMaybe<MessagePayAfterCountOrderByAggregateInput>;
    _max?: InputMaybe<MessagePayAfterMaxOrderByAggregateInput>;
    _min?: InputMaybe<MessagePayAfterMinOrderByAggregateInput>;
    _sum?: InputMaybe<MessagePayAfterSumOrderByAggregateInput>;
    consumerId?: InputMaybe<SortOrder>;
    messageCount?: InputMaybe<SortOrder>;
    outstandingBalance?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type MessagePayAfterOrderByWithRelationInput = {
    consumer?: InputMaybe<ConsumerOrderByWithRelationInput>;
    consumerId?: InputMaybe<SortOrder>;
    messageCount?: InputMaybe<SortOrder>;
    outstandingBalance?: InputMaybe<SortOrder>;
    sendAt?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum MessagePayAfterScalarFieldEnum {
    ConsumerId = 'consumerId',
    MessageCount = 'messageCount',
    OutstandingBalance = 'outstandingBalance',
    SendAt = 'sendAt',
    UpdatedAt = 'updatedAt',
}

export type MessagePayAfterScalarWhereInput = {
    AND?: InputMaybe<Array<MessagePayAfterScalarWhereInput>>;
    NOT?: InputMaybe<Array<MessagePayAfterScalarWhereInput>>;
    OR?: InputMaybe<Array<MessagePayAfterScalarWhereInput>>;
    consumerId?: InputMaybe<UuidFilter>;
    messageCount?: InputMaybe<IntFilter>;
    outstandingBalance?: InputMaybe<DecimalFilter>;
    sendAt?: InputMaybe<DateTimeNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessagePayAfterScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<MessagePayAfterScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<MessagePayAfterScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<MessagePayAfterScalarWhereWithAggregatesInput>>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    messageCount?: InputMaybe<IntWithAggregatesFilter>;
    outstandingBalance?: InputMaybe<DecimalWithAggregatesFilter>;
    sendAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type MessagePayAfterSumAggregate = {
    __typename?: 'MessagePayAfterSumAggregate';
    messageCount?: Maybe<Scalars['Int']['output']>;
    outstandingBalance?: Maybe<Scalars['Decimal']['output']>;
};

export type MessagePayAfterSumOrderByAggregateInput = {
    messageCount?: InputMaybe<SortOrder>;
    outstandingBalance?: InputMaybe<SortOrder>;
};

export type MessagePayAfterUpdateInput = {
    consumer?: InputMaybe<ConsumerUpdateOneRequiredWithoutMessagePayAfterNestedInput>;
    messageCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    outstandingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    sendAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessagePayAfterUpdateManyMutationInput = {
    messageCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    outstandingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    sendAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessagePayAfterUpdateManyWithWhereWithoutConsumerInput = {
    data: MessagePayAfterUpdateManyMutationInput;
    where: MessagePayAfterScalarWhereInput;
};

export type MessagePayAfterUpdateManyWithoutConsumerNestedInput = {
    connect?: InputMaybe<Array<MessagePayAfterWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<MessagePayAfterCreateOrConnectWithoutConsumerInput>
    >;
    create?: InputMaybe<Array<MessagePayAfterCreateWithoutConsumerInput>>;
    createMany?: InputMaybe<MessagePayAfterCreateManyConsumerInputEnvelope>;
    delete?: InputMaybe<Array<MessagePayAfterWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<MessagePayAfterScalarWhereInput>>;
    disconnect?: InputMaybe<Array<MessagePayAfterWhereUniqueInput>>;
    set?: InputMaybe<Array<MessagePayAfterWhereUniqueInput>>;
    update?: InputMaybe<
        Array<MessagePayAfterUpdateWithWhereUniqueWithoutConsumerInput>
    >;
    updateMany?: InputMaybe<
        Array<MessagePayAfterUpdateManyWithWhereWithoutConsumerInput>
    >;
    upsert?: InputMaybe<
        Array<MessagePayAfterUpsertWithWhereUniqueWithoutConsumerInput>
    >;
};

export type MessagePayAfterUpdateWithWhereUniqueWithoutConsumerInput = {
    data: MessagePayAfterUpdateWithoutConsumerInput;
    where: MessagePayAfterWhereUniqueInput;
};

export type MessagePayAfterUpdateWithoutConsumerInput = {
    messageCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    outstandingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    sendAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessagePayAfterUpsertWithWhereUniqueWithoutConsumerInput = {
    create: MessagePayAfterCreateWithoutConsumerInput;
    update: MessagePayAfterUpdateWithoutConsumerInput;
    where: MessagePayAfterWhereUniqueInput;
};

export type MessagePayAfterWhereInput = {
    AND?: InputMaybe<Array<MessagePayAfterWhereInput>>;
    NOT?: InputMaybe<Array<MessagePayAfterWhereInput>>;
    OR?: InputMaybe<Array<MessagePayAfterWhereInput>>;
    consumer?: InputMaybe<ConsumerRelationFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    messageCount?: InputMaybe<IntFilter>;
    outstandingBalance?: InputMaybe<DecimalFilter>;
    sendAt?: InputMaybe<DateTimeNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessagePayAfterWhereUniqueInput = {
    AND?: InputMaybe<Array<MessagePayAfterWhereInput>>;
    NOT?: InputMaybe<Array<MessagePayAfterWhereInput>>;
    OR?: InputMaybe<Array<MessagePayAfterWhereInput>>;
    consumer?: InputMaybe<ConsumerRelationFilter>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    messageCount?: InputMaybe<IntFilter>;
    outstandingBalance?: InputMaybe<DecimalFilter>;
    sendAt?: InputMaybe<DateTimeNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageSettingsHrt = {
    __typename?: 'MessageSettingsHrt';
    hrtId: Scalars['Int']['output'];
    priority: Scalars['Float']['output'];
    reminderDays: Array<Scalars['Int']['output']>;
    virtualDayOfReminder?: Maybe<VirtualDayOfReminder>;
};

export type MessageSettingsHrtAvgAggregate = {
    __typename?: 'MessageSettingsHrtAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
    reminderDays?: Maybe<Scalars['Float']['output']>;
};

export type MessageSettingsHrtAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    reminderDays?: InputMaybe<SortOrder>;
};

export type MessageSettingsHrtCountAggregate = {
    __typename?: 'MessageSettingsHrtCountAggregate';
    _all: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    reminderDays: Scalars['Int']['output'];
    virtualDayOfReminder: Scalars['Int']['output'];
};

export type MessageSettingsHrtCountOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    reminderDays?: InputMaybe<SortOrder>;
    virtualDayOfReminder?: InputMaybe<SortOrder>;
};

export type MessageSettingsHrtCreateInput = {
    hrtId: Scalars['Int']['input'];
    priority?: InputMaybe<Scalars['Float']['input']>;
    reminderDays?: InputMaybe<MessageSettingsHrtCreatereminderDaysInput>;
    virtualDayOfReminder?: InputMaybe<VirtualDayOfReminder>;
};

export type MessageSettingsHrtCreateManyInput = {
    hrtId: Scalars['Int']['input'];
    priority?: InputMaybe<Scalars['Float']['input']>;
    reminderDays?: InputMaybe<MessageSettingsHrtCreatereminderDaysInput>;
    virtualDayOfReminder?: InputMaybe<VirtualDayOfReminder>;
};

export type MessageSettingsHrtCreatereminderDaysInput = {
    set: Array<Scalars['Int']['input']>;
};

export type MessageSettingsHrtGroupBy = {
    __typename?: 'MessageSettingsHrtGroupBy';
    _avg?: Maybe<MessageSettingsHrtAvgAggregate>;
    _count?: Maybe<MessageSettingsHrtCountAggregate>;
    _max?: Maybe<MessageSettingsHrtMaxAggregate>;
    _min?: Maybe<MessageSettingsHrtMinAggregate>;
    _sum?: Maybe<MessageSettingsHrtSumAggregate>;
    hrtId: Scalars['Int']['output'];
    priority: Scalars['Float']['output'];
    reminderDays?: Maybe<Array<Scalars['Int']['output']>>;
    virtualDayOfReminder?: Maybe<VirtualDayOfReminder>;
};

export type MessageSettingsHrtMaxAggregate = {
    __typename?: 'MessageSettingsHrtMaxAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
    virtualDayOfReminder?: Maybe<VirtualDayOfReminder>;
};

export type MessageSettingsHrtMaxOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    virtualDayOfReminder?: InputMaybe<SortOrder>;
};

export type MessageSettingsHrtMinAggregate = {
    __typename?: 'MessageSettingsHrtMinAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
    virtualDayOfReminder?: Maybe<VirtualDayOfReminder>;
};

export type MessageSettingsHrtMinOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    virtualDayOfReminder?: InputMaybe<SortOrder>;
};

export type MessageSettingsHrtOrderByWithAggregationInput = {
    _avg?: InputMaybe<MessageSettingsHrtAvgOrderByAggregateInput>;
    _count?: InputMaybe<MessageSettingsHrtCountOrderByAggregateInput>;
    _max?: InputMaybe<MessageSettingsHrtMaxOrderByAggregateInput>;
    _min?: InputMaybe<MessageSettingsHrtMinOrderByAggregateInput>;
    _sum?: InputMaybe<MessageSettingsHrtSumOrderByAggregateInput>;
    hrtId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    reminderDays?: InputMaybe<SortOrder>;
    virtualDayOfReminder?: InputMaybe<SortOrderInput>;
};

export type MessageSettingsHrtOrderByWithRelationInput = {
    hrtId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    reminderDays?: InputMaybe<SortOrder>;
    virtualDayOfReminder?: InputMaybe<SortOrderInput>;
};

export enum MessageSettingsHrtScalarFieldEnum {
    HrtId = 'hrtId',
    Priority = 'priority',
    ReminderDays = 'reminderDays',
    VirtualDayOfReminder = 'virtualDayOfReminder',
}

export type MessageSettingsHrtScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<MessageSettingsHrtScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<MessageSettingsHrtScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<MessageSettingsHrtScalarWhereWithAggregatesInput>>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    priority?: InputMaybe<FloatWithAggregatesFilter>;
    reminderDays?: InputMaybe<IntNullableListFilter>;
    virtualDayOfReminder?: InputMaybe<EnumVirtualDayOfReminderNullableWithAggregatesFilter>;
};

export type MessageSettingsHrtSumAggregate = {
    __typename?: 'MessageSettingsHrtSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
    reminderDays?: Maybe<Array<Scalars['Int']['output']>>;
};

export type MessageSettingsHrtSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    reminderDays?: InputMaybe<SortOrder>;
};

export type MessageSettingsHrtUpdateInput = {
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    priority?: InputMaybe<FloatFieldUpdateOperationsInput>;
    reminderDays?: InputMaybe<MessageSettingsHrtUpdatereminderDaysInput>;
    virtualDayOfReminder?: InputMaybe<NullableEnumVirtualDayOfReminderFieldUpdateOperationsInput>;
};

export type MessageSettingsHrtUpdateManyMutationInput = {
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    priority?: InputMaybe<FloatFieldUpdateOperationsInput>;
    reminderDays?: InputMaybe<MessageSettingsHrtUpdatereminderDaysInput>;
    virtualDayOfReminder?: InputMaybe<NullableEnumVirtualDayOfReminderFieldUpdateOperationsInput>;
};

export type MessageSettingsHrtUpdatereminderDaysInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MessageSettingsHrtWhereInput = {
    AND?: InputMaybe<Array<MessageSettingsHrtWhereInput>>;
    NOT?: InputMaybe<Array<MessageSettingsHrtWhereInput>>;
    OR?: InputMaybe<Array<MessageSettingsHrtWhereInput>>;
    hrtId?: InputMaybe<IntFilter>;
    priority?: InputMaybe<FloatFilter>;
    reminderDays?: InputMaybe<IntNullableListFilter>;
    virtualDayOfReminder?: InputMaybe<EnumVirtualDayOfReminderNullableFilter>;
};

export type MessageSettingsHrtWhereUniqueInput = {
    AND?: InputMaybe<Array<MessageSettingsHrtWhereInput>>;
    NOT?: InputMaybe<Array<MessageSettingsHrtWhereInput>>;
    OR?: InputMaybe<Array<MessageSettingsHrtWhereInput>>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    priority?: InputMaybe<FloatFilter>;
    reminderDays?: InputMaybe<IntNullableListFilter>;
    virtualDayOfReminder?: InputMaybe<EnumVirtualDayOfReminderNullableFilter>;
};

export type MessageSettingsOrg = {
    __typename?: 'MessageSettingsOrg';
    linkExpirationMinutes?: Maybe<Scalars['Int']['output']>;
    orgId: Scalars['Int']['output'];
    payAfterCadence?: Maybe<Scalars['Int']['output']>;
    payAfterLimit?: Maybe<Scalars['Int']['output']>;
    payAfterThreshold?: Maybe<Scalars['Float']['output']>;
    reminderDays: Array<Scalars['Int']['output']>;
    reminderTime: Scalars['DateTimeISO']['output'];
    virtualDayOfReminder?: Maybe<VirtualDayOfReminder>;
};

export type MessageSettingsOrgAvgAggregate = {
    __typename?: 'MessageSettingsOrgAvgAggregate';
    linkExpirationMinutes?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    payAfterCadence?: Maybe<Scalars['Float']['output']>;
    payAfterLimit?: Maybe<Scalars['Float']['output']>;
    payAfterThreshold?: Maybe<Scalars['Float']['output']>;
    reminderDays?: Maybe<Scalars['Float']['output']>;
};

export type MessageSettingsOrgAvgOrderByAggregateInput = {
    linkExpirationMinutes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payAfterCadence?: InputMaybe<SortOrder>;
    payAfterLimit?: InputMaybe<SortOrder>;
    payAfterThreshold?: InputMaybe<SortOrder>;
    reminderDays?: InputMaybe<SortOrder>;
};

export type MessageSettingsOrgCountAggregate = {
    __typename?: 'MessageSettingsOrgCountAggregate';
    _all: Scalars['Int']['output'];
    linkExpirationMinutes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payAfterCadence: Scalars['Int']['output'];
    payAfterLimit: Scalars['Int']['output'];
    payAfterThreshold: Scalars['Int']['output'];
    reminderDays: Scalars['Int']['output'];
    reminderTime: Scalars['Int']['output'];
    virtualDayOfReminder: Scalars['Int']['output'];
};

export type MessageSettingsOrgCountOrderByAggregateInput = {
    linkExpirationMinutes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payAfterCadence?: InputMaybe<SortOrder>;
    payAfterLimit?: InputMaybe<SortOrder>;
    payAfterThreshold?: InputMaybe<SortOrder>;
    reminderDays?: InputMaybe<SortOrder>;
    reminderTime?: InputMaybe<SortOrder>;
    virtualDayOfReminder?: InputMaybe<SortOrder>;
};

export type MessageSettingsOrgCreateInput = {
    linkExpirationMinutes?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    payAfterCadence?: InputMaybe<Scalars['Int']['input']>;
    payAfterLimit?: InputMaybe<Scalars['Int']['input']>;
    payAfterThreshold?: InputMaybe<Scalars['Float']['input']>;
    reminderDays?: InputMaybe<MessageSettingsOrgCreatereminderDaysInput>;
    reminderTime: Scalars['DateTimeISO']['input'];
    virtualDayOfReminder?: InputMaybe<VirtualDayOfReminder>;
};

export type MessageSettingsOrgCreateManyInput = {
    linkExpirationMinutes?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    payAfterCadence?: InputMaybe<Scalars['Int']['input']>;
    payAfterLimit?: InputMaybe<Scalars['Int']['input']>;
    payAfterThreshold?: InputMaybe<Scalars['Float']['input']>;
    reminderDays?: InputMaybe<MessageSettingsOrgCreatereminderDaysInput>;
    reminderTime: Scalars['DateTimeISO']['input'];
    virtualDayOfReminder?: InputMaybe<VirtualDayOfReminder>;
};

export type MessageSettingsOrgCreatereminderDaysInput = {
    set: Array<Scalars['Int']['input']>;
};

export type MessageSettingsOrgGroupBy = {
    __typename?: 'MessageSettingsOrgGroupBy';
    _avg?: Maybe<MessageSettingsOrgAvgAggregate>;
    _count?: Maybe<MessageSettingsOrgCountAggregate>;
    _max?: Maybe<MessageSettingsOrgMaxAggregate>;
    _min?: Maybe<MessageSettingsOrgMinAggregate>;
    _sum?: Maybe<MessageSettingsOrgSumAggregate>;
    linkExpirationMinutes?: Maybe<Scalars['Int']['output']>;
    orgId: Scalars['Int']['output'];
    payAfterCadence?: Maybe<Scalars['Int']['output']>;
    payAfterLimit?: Maybe<Scalars['Int']['output']>;
    payAfterThreshold?: Maybe<Scalars['Float']['output']>;
    reminderDays?: Maybe<Array<Scalars['Int']['output']>>;
    reminderTime: Scalars['DateTimeISO']['output'];
    virtualDayOfReminder?: Maybe<VirtualDayOfReminder>;
};

export type MessageSettingsOrgMaxAggregate = {
    __typename?: 'MessageSettingsOrgMaxAggregate';
    linkExpirationMinutes?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payAfterCadence?: Maybe<Scalars['Int']['output']>;
    payAfterLimit?: Maybe<Scalars['Int']['output']>;
    payAfterThreshold?: Maybe<Scalars['Float']['output']>;
    reminderTime?: Maybe<Scalars['DateTimeISO']['output']>;
    virtualDayOfReminder?: Maybe<VirtualDayOfReminder>;
};

export type MessageSettingsOrgMaxOrderByAggregateInput = {
    linkExpirationMinutes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payAfterCadence?: InputMaybe<SortOrder>;
    payAfterLimit?: InputMaybe<SortOrder>;
    payAfterThreshold?: InputMaybe<SortOrder>;
    reminderTime?: InputMaybe<SortOrder>;
    virtualDayOfReminder?: InputMaybe<SortOrder>;
};

export type MessageSettingsOrgMinAggregate = {
    __typename?: 'MessageSettingsOrgMinAggregate';
    linkExpirationMinutes?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payAfterCadence?: Maybe<Scalars['Int']['output']>;
    payAfterLimit?: Maybe<Scalars['Int']['output']>;
    payAfterThreshold?: Maybe<Scalars['Float']['output']>;
    reminderTime?: Maybe<Scalars['DateTimeISO']['output']>;
    virtualDayOfReminder?: Maybe<VirtualDayOfReminder>;
};

export type MessageSettingsOrgMinOrderByAggregateInput = {
    linkExpirationMinutes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payAfterCadence?: InputMaybe<SortOrder>;
    payAfterLimit?: InputMaybe<SortOrder>;
    payAfterThreshold?: InputMaybe<SortOrder>;
    reminderTime?: InputMaybe<SortOrder>;
    virtualDayOfReminder?: InputMaybe<SortOrder>;
};

export type MessageSettingsOrgOrderByWithAggregationInput = {
    _avg?: InputMaybe<MessageSettingsOrgAvgOrderByAggregateInput>;
    _count?: InputMaybe<MessageSettingsOrgCountOrderByAggregateInput>;
    _max?: InputMaybe<MessageSettingsOrgMaxOrderByAggregateInput>;
    _min?: InputMaybe<MessageSettingsOrgMinOrderByAggregateInput>;
    _sum?: InputMaybe<MessageSettingsOrgSumOrderByAggregateInput>;
    linkExpirationMinutes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    payAfterCadence?: InputMaybe<SortOrderInput>;
    payAfterLimit?: InputMaybe<SortOrderInput>;
    payAfterThreshold?: InputMaybe<SortOrderInput>;
    reminderDays?: InputMaybe<SortOrder>;
    reminderTime?: InputMaybe<SortOrder>;
    virtualDayOfReminder?: InputMaybe<SortOrderInput>;
};

export type MessageSettingsOrgOrderByWithRelationInput = {
    linkExpirationMinutes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    payAfterCadence?: InputMaybe<SortOrderInput>;
    payAfterLimit?: InputMaybe<SortOrderInput>;
    payAfterThreshold?: InputMaybe<SortOrderInput>;
    reminderDays?: InputMaybe<SortOrder>;
    reminderTime?: InputMaybe<SortOrder>;
    virtualDayOfReminder?: InputMaybe<SortOrderInput>;
};

export enum MessageSettingsOrgScalarFieldEnum {
    LinkExpirationMinutes = 'linkExpirationMinutes',
    OrgId = 'orgId',
    PayAfterCadence = 'payAfterCadence',
    PayAfterLimit = 'payAfterLimit',
    PayAfterThreshold = 'payAfterThreshold',
    ReminderDays = 'reminderDays',
    ReminderTime = 'reminderTime',
    VirtualDayOfReminder = 'virtualDayOfReminder',
}

export type MessageSettingsOrgScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<MessageSettingsOrgScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<MessageSettingsOrgScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<MessageSettingsOrgScalarWhereWithAggregatesInput>>;
    linkExpirationMinutes?: InputMaybe<IntNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    payAfterCadence?: InputMaybe<IntNullableWithAggregatesFilter>;
    payAfterLimit?: InputMaybe<IntNullableWithAggregatesFilter>;
    payAfterThreshold?: InputMaybe<FloatNullableWithAggregatesFilter>;
    reminderDays?: InputMaybe<IntNullableListFilter>;
    reminderTime?: InputMaybe<DateTimeWithAggregatesFilter>;
    virtualDayOfReminder?: InputMaybe<EnumVirtualDayOfReminderNullableWithAggregatesFilter>;
};

export type MessageSettingsOrgSumAggregate = {
    __typename?: 'MessageSettingsOrgSumAggregate';
    linkExpirationMinutes?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payAfterCadence?: Maybe<Scalars['Int']['output']>;
    payAfterLimit?: Maybe<Scalars['Int']['output']>;
    payAfterThreshold?: Maybe<Scalars['Float']['output']>;
    reminderDays?: Maybe<Array<Scalars['Int']['output']>>;
};

export type MessageSettingsOrgSumOrderByAggregateInput = {
    linkExpirationMinutes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payAfterCadence?: InputMaybe<SortOrder>;
    payAfterLimit?: InputMaybe<SortOrder>;
    payAfterThreshold?: InputMaybe<SortOrder>;
    reminderDays?: InputMaybe<SortOrder>;
};

export type MessageSettingsOrgUpdateInput = {
    linkExpirationMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payAfterCadence?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payAfterLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payAfterThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    reminderDays?: InputMaybe<MessageSettingsOrgUpdatereminderDaysInput>;
    reminderTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    virtualDayOfReminder?: InputMaybe<NullableEnumVirtualDayOfReminderFieldUpdateOperationsInput>;
};

export type MessageSettingsOrgUpdateManyMutationInput = {
    linkExpirationMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payAfterCadence?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payAfterLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payAfterThreshold?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
    reminderDays?: InputMaybe<MessageSettingsOrgUpdatereminderDaysInput>;
    reminderTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    virtualDayOfReminder?: InputMaybe<NullableEnumVirtualDayOfReminderFieldUpdateOperationsInput>;
};

export type MessageSettingsOrgUpdatereminderDaysInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MessageSettingsOrgWhereInput = {
    AND?: InputMaybe<Array<MessageSettingsOrgWhereInput>>;
    NOT?: InputMaybe<Array<MessageSettingsOrgWhereInput>>;
    OR?: InputMaybe<Array<MessageSettingsOrgWhereInput>>;
    linkExpirationMinutes?: InputMaybe<IntNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    payAfterCadence?: InputMaybe<IntNullableFilter>;
    payAfterLimit?: InputMaybe<IntNullableFilter>;
    payAfterThreshold?: InputMaybe<FloatNullableFilter>;
    reminderDays?: InputMaybe<IntNullableListFilter>;
    reminderTime?: InputMaybe<DateTimeFilter>;
    virtualDayOfReminder?: InputMaybe<EnumVirtualDayOfReminderNullableFilter>;
};

export type MessageSettingsOrgWhereUniqueInput = {
    AND?: InputMaybe<Array<MessageSettingsOrgWhereInput>>;
    NOT?: InputMaybe<Array<MessageSettingsOrgWhereInput>>;
    OR?: InputMaybe<Array<MessageSettingsOrgWhereInput>>;
    linkExpirationMinutes?: InputMaybe<IntNullableFilter>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    payAfterCadence?: InputMaybe<IntNullableFilter>;
    payAfterLimit?: InputMaybe<IntNullableFilter>;
    payAfterThreshold?: InputMaybe<FloatNullableFilter>;
    reminderDays?: InputMaybe<IntNullableListFilter>;
    reminderTime?: InputMaybe<DateTimeFilter>;
    virtualDayOfReminder?: InputMaybe<EnumVirtualDayOfReminderNullableFilter>;
};

export enum MessageStatus {
    Blocked = 'BLOCKED',
    Cancelled = 'CANCELLED',
    Delivered = 'DELIVERED',
    Failed = 'FAILED',
    Scheduled = 'SCHEDULED',
    Sent = 'SENT',
}

export type MessageTemplateHrt = {
    __typename?: 'MessageTemplateHrt';
    body: Scalars['String']['output'];
    hrtId: Scalars['Int']['output'];
    languageCode: LanguageCode;
    messageBlueprint: MessageBlueprint;
    messageType: Scalars['String']['output'];
    priority: Scalars['Float']['output'];
    subject: Scalars['String']['output'];
};

export type MessageTemplateHrtAvgAggregate = {
    __typename?: 'MessageTemplateHrtAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
};

export type MessageTemplateHrtAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
};

export type MessageTemplateHrtCountAggregate = {
    __typename?: 'MessageTemplateHrtCountAggregate';
    _all: Scalars['Int']['output'];
    body: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    languageCode: Scalars['Int']['output'];
    messageType: Scalars['Int']['output'];
    priority: Scalars['Int']['output'];
    subject: Scalars['Int']['output'];
};

export type MessageTemplateHrtCountOrderByAggregateInput = {
    body?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    subject?: InputMaybe<SortOrder>;
};

export type MessageTemplateHrtCreateInput = {
    body: Scalars['String']['input'];
    hrtId: Scalars['Int']['input'];
    languageCode: LanguageCode;
    messageBlueprint: MessageBlueprintCreateNestedOneWithoutHrtMessageTemplateInput;
    priority?: InputMaybe<Scalars['Float']['input']>;
    subject: Scalars['String']['input'];
};

export type MessageTemplateHrtCreateManyInput = {
    body: Scalars['String']['input'];
    hrtId: Scalars['Int']['input'];
    languageCode: LanguageCode;
    messageType: Scalars['String']['input'];
    priority?: InputMaybe<Scalars['Float']['input']>;
    subject: Scalars['String']['input'];
};

export type MessageTemplateHrtCreateManyMessageBlueprintInput = {
    body: Scalars['String']['input'];
    hrtId: Scalars['Int']['input'];
    languageCode: LanguageCode;
    priority?: InputMaybe<Scalars['Float']['input']>;
    subject: Scalars['String']['input'];
};

export type MessageTemplateHrtCreateManyMessageBlueprintInputEnvelope = {
    data: Array<MessageTemplateHrtCreateManyMessageBlueprintInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageTemplateHrtCreateNestedManyWithoutMessageBlueprintInput = {
    connect?: InputMaybe<Array<MessageTemplateHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<MessageTemplateHrtCreateOrConnectWithoutMessageBlueprintInput>
    >;
    create?: InputMaybe<
        Array<MessageTemplateHrtCreateWithoutMessageBlueprintInput>
    >;
    createMany?: InputMaybe<MessageTemplateHrtCreateManyMessageBlueprintInputEnvelope>;
};

export type MessageTemplateHrtCreateOrConnectWithoutMessageBlueprintInput = {
    create: MessageTemplateHrtCreateWithoutMessageBlueprintInput;
    where: MessageTemplateHrtWhereUniqueInput;
};

export type MessageTemplateHrtCreateWithoutMessageBlueprintInput = {
    body: Scalars['String']['input'];
    hrtId: Scalars['Int']['input'];
    languageCode: LanguageCode;
    priority?: InputMaybe<Scalars['Float']['input']>;
    subject: Scalars['String']['input'];
};

export type MessageTemplateHrtGroupBy = {
    __typename?: 'MessageTemplateHrtGroupBy';
    _avg?: Maybe<MessageTemplateHrtAvgAggregate>;
    _count?: Maybe<MessageTemplateHrtCountAggregate>;
    _max?: Maybe<MessageTemplateHrtMaxAggregate>;
    _min?: Maybe<MessageTemplateHrtMinAggregate>;
    _sum?: Maybe<MessageTemplateHrtSumAggregate>;
    body: Scalars['String']['output'];
    hrtId: Scalars['Int']['output'];
    languageCode: LanguageCode;
    messageType: Scalars['String']['output'];
    priority: Scalars['Float']['output'];
    subject: Scalars['String']['output'];
};

export type MessageTemplateHrtHrtIdMessageTypeLanguageCodeCompoundUniqueInput =
    {
        hrtId: Scalars['Int']['input'];
        languageCode: LanguageCode;
        messageType: Scalars['String']['input'];
    };

export type MessageTemplateHrtListRelationFilter = {
    every?: InputMaybe<MessageTemplateHrtWhereInput>;
    none?: InputMaybe<MessageTemplateHrtWhereInput>;
    some?: InputMaybe<MessageTemplateHrtWhereInput>;
};

export type MessageTemplateHrtMaxAggregate = {
    __typename?: 'MessageTemplateHrtMaxAggregate';
    body?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    languageCode?: Maybe<LanguageCode>;
    messageType?: Maybe<Scalars['String']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
    subject?: Maybe<Scalars['String']['output']>;
};

export type MessageTemplateHrtMaxOrderByAggregateInput = {
    body?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    subject?: InputMaybe<SortOrder>;
};

export type MessageTemplateHrtMinAggregate = {
    __typename?: 'MessageTemplateHrtMinAggregate';
    body?: Maybe<Scalars['String']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    languageCode?: Maybe<LanguageCode>;
    messageType?: Maybe<Scalars['String']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
    subject?: Maybe<Scalars['String']['output']>;
};

export type MessageTemplateHrtMinOrderByAggregateInput = {
    body?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    subject?: InputMaybe<SortOrder>;
};

export type MessageTemplateHrtOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type MessageTemplateHrtOrderByWithAggregationInput = {
    _avg?: InputMaybe<MessageTemplateHrtAvgOrderByAggregateInput>;
    _count?: InputMaybe<MessageTemplateHrtCountOrderByAggregateInput>;
    _max?: InputMaybe<MessageTemplateHrtMaxOrderByAggregateInput>;
    _min?: InputMaybe<MessageTemplateHrtMinOrderByAggregateInput>;
    _sum?: InputMaybe<MessageTemplateHrtSumOrderByAggregateInput>;
    body?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    subject?: InputMaybe<SortOrder>;
};

export type MessageTemplateHrtOrderByWithRelationInput = {
    body?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    messageBlueprint?: InputMaybe<MessageBlueprintOrderByWithRelationInput>;
    messageType?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
    subject?: InputMaybe<SortOrder>;
};

export enum MessageTemplateHrtScalarFieldEnum {
    Body = 'body',
    HrtId = 'hrtId',
    LanguageCode = 'languageCode',
    MessageType = 'messageType',
    Priority = 'priority',
    Subject = 'subject',
}

export type MessageTemplateHrtScalarWhereInput = {
    AND?: InputMaybe<Array<MessageTemplateHrtScalarWhereInput>>;
    NOT?: InputMaybe<Array<MessageTemplateHrtScalarWhereInput>>;
    OR?: InputMaybe<Array<MessageTemplateHrtScalarWhereInput>>;
    body?: InputMaybe<StringFilter>;
    hrtId?: InputMaybe<IntFilter>;
    languageCode?: InputMaybe<EnumLanguageCodeFilter>;
    messageType?: InputMaybe<StringFilter>;
    priority?: InputMaybe<FloatFilter>;
    subject?: InputMaybe<StringFilter>;
};

export type MessageTemplateHrtScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<MessageTemplateHrtScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<MessageTemplateHrtScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<MessageTemplateHrtScalarWhereWithAggregatesInput>>;
    body?: InputMaybe<StringWithAggregatesFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    languageCode?: InputMaybe<EnumLanguageCodeWithAggregatesFilter>;
    messageType?: InputMaybe<StringWithAggregatesFilter>;
    priority?: InputMaybe<FloatWithAggregatesFilter>;
    subject?: InputMaybe<StringWithAggregatesFilter>;
};

export type MessageTemplateHrtSumAggregate = {
    __typename?: 'MessageTemplateHrtSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    priority?: Maybe<Scalars['Float']['output']>;
};

export type MessageTemplateHrtSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    priority?: InputMaybe<SortOrder>;
};

export type MessageTemplateHrtUpdateInput = {
    body?: InputMaybe<StringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    messageBlueprint?: InputMaybe<MessageBlueprintUpdateOneRequiredWithoutHrtMessageTemplateNestedInput>;
    priority?: InputMaybe<FloatFieldUpdateOperationsInput>;
    subject?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MessageTemplateHrtUpdateManyMutationInput = {
    body?: InputMaybe<StringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    priority?: InputMaybe<FloatFieldUpdateOperationsInput>;
    subject?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MessageTemplateHrtUpdateManyWithWhereWithoutMessageBlueprintInput =
    {
        data: MessageTemplateHrtUpdateManyMutationInput;
        where: MessageTemplateHrtScalarWhereInput;
    };

export type MessageTemplateHrtUpdateManyWithoutMessageBlueprintNestedInput = {
    connect?: InputMaybe<Array<MessageTemplateHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<MessageTemplateHrtCreateOrConnectWithoutMessageBlueprintInput>
    >;
    create?: InputMaybe<
        Array<MessageTemplateHrtCreateWithoutMessageBlueprintInput>
    >;
    createMany?: InputMaybe<MessageTemplateHrtCreateManyMessageBlueprintInputEnvelope>;
    delete?: InputMaybe<Array<MessageTemplateHrtWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<MessageTemplateHrtScalarWhereInput>>;
    disconnect?: InputMaybe<Array<MessageTemplateHrtWhereUniqueInput>>;
    set?: InputMaybe<Array<MessageTemplateHrtWhereUniqueInput>>;
    update?: InputMaybe<
        Array<MessageTemplateHrtUpdateWithWhereUniqueWithoutMessageBlueprintInput>
    >;
    updateMany?: InputMaybe<
        Array<MessageTemplateHrtUpdateManyWithWhereWithoutMessageBlueprintInput>
    >;
    upsert?: InputMaybe<
        Array<MessageTemplateHrtUpsertWithWhereUniqueWithoutMessageBlueprintInput>
    >;
};

export type MessageTemplateHrtUpdateWithWhereUniqueWithoutMessageBlueprintInput =
    {
        data: MessageTemplateHrtUpdateWithoutMessageBlueprintInput;
        where: MessageTemplateHrtWhereUniqueInput;
    };

export type MessageTemplateHrtUpdateWithoutMessageBlueprintInput = {
    body?: InputMaybe<StringFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    priority?: InputMaybe<FloatFieldUpdateOperationsInput>;
    subject?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MessageTemplateHrtUpsertWithWhereUniqueWithoutMessageBlueprintInput =
    {
        create: MessageTemplateHrtCreateWithoutMessageBlueprintInput;
        update: MessageTemplateHrtUpdateWithoutMessageBlueprintInput;
        where: MessageTemplateHrtWhereUniqueInput;
    };

export type MessageTemplateHrtWhereInput = {
    AND?: InputMaybe<Array<MessageTemplateHrtWhereInput>>;
    NOT?: InputMaybe<Array<MessageTemplateHrtWhereInput>>;
    OR?: InputMaybe<Array<MessageTemplateHrtWhereInput>>;
    body?: InputMaybe<StringFilter>;
    hrtId?: InputMaybe<IntFilter>;
    languageCode?: InputMaybe<EnumLanguageCodeFilter>;
    messageBlueprint?: InputMaybe<MessageBlueprintRelationFilter>;
    messageType?: InputMaybe<StringFilter>;
    priority?: InputMaybe<FloatFilter>;
    subject?: InputMaybe<StringFilter>;
};

export type MessageTemplateHrtWhereUniqueInput = {
    AND?: InputMaybe<Array<MessageTemplateHrtWhereInput>>;
    NOT?: InputMaybe<Array<MessageTemplateHrtWhereInput>>;
    OR?: InputMaybe<Array<MessageTemplateHrtWhereInput>>;
    body?: InputMaybe<StringFilter>;
    hrtId?: InputMaybe<IntFilter>;
    hrtId_messageType_languageCode?: InputMaybe<MessageTemplateHrtHrtIdMessageTypeLanguageCodeCompoundUniqueInput>;
    languageCode?: InputMaybe<EnumLanguageCodeFilter>;
    messageBlueprint?: InputMaybe<MessageBlueprintRelationFilter>;
    messageType?: InputMaybe<StringFilter>;
    priority?: InputMaybe<FloatFilter>;
    subject?: InputMaybe<StringFilter>;
};

export type MessageTemplateOrg = {
    __typename?: 'MessageTemplateOrg';
    body: Scalars['String']['output'];
    languageCode: LanguageCode;
    messageBlueprint: MessageBlueprint;
    messageType: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    subject: Scalars['String']['output'];
};

export type MessageTemplateOrgAvgAggregate = {
    __typename?: 'MessageTemplateOrgAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type MessageTemplateOrgAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type MessageTemplateOrgCountAggregate = {
    __typename?: 'MessageTemplateOrgCountAggregate';
    _all: Scalars['Int']['output'];
    body: Scalars['Int']['output'];
    languageCode: Scalars['Int']['output'];
    messageType: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    subject: Scalars['Int']['output'];
};

export type MessageTemplateOrgCountOrderByAggregateInput = {
    body?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    subject?: InputMaybe<SortOrder>;
};

export type MessageTemplateOrgCreateInput = {
    body: Scalars['String']['input'];
    languageCode: LanguageCode;
    messageBlueprint: MessageBlueprintCreateNestedOneWithoutOrgMessageTemplateInput;
    orgId: Scalars['Int']['input'];
    subject: Scalars['String']['input'];
};

export type MessageTemplateOrgCreateManyInput = {
    body: Scalars['String']['input'];
    languageCode: LanguageCode;
    messageType: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    subject: Scalars['String']['input'];
};

export type MessageTemplateOrgCreateManyMessageBlueprintInput = {
    body: Scalars['String']['input'];
    languageCode: LanguageCode;
    orgId: Scalars['Int']['input'];
    subject: Scalars['String']['input'];
};

export type MessageTemplateOrgCreateManyMessageBlueprintInputEnvelope = {
    data: Array<MessageTemplateOrgCreateManyMessageBlueprintInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageTemplateOrgCreateNestedManyWithoutMessageBlueprintInput = {
    connect?: InputMaybe<Array<MessageTemplateOrgWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<MessageTemplateOrgCreateOrConnectWithoutMessageBlueprintInput>
    >;
    create?: InputMaybe<
        Array<MessageTemplateOrgCreateWithoutMessageBlueprintInput>
    >;
    createMany?: InputMaybe<MessageTemplateOrgCreateManyMessageBlueprintInputEnvelope>;
};

export type MessageTemplateOrgCreateOrConnectWithoutMessageBlueprintInput = {
    create: MessageTemplateOrgCreateWithoutMessageBlueprintInput;
    where: MessageTemplateOrgWhereUniqueInput;
};

export type MessageTemplateOrgCreateWithoutMessageBlueprintInput = {
    body: Scalars['String']['input'];
    languageCode: LanguageCode;
    orgId: Scalars['Int']['input'];
    subject: Scalars['String']['input'];
};

export type MessageTemplateOrgGroupBy = {
    __typename?: 'MessageTemplateOrgGroupBy';
    _avg?: Maybe<MessageTemplateOrgAvgAggregate>;
    _count?: Maybe<MessageTemplateOrgCountAggregate>;
    _max?: Maybe<MessageTemplateOrgMaxAggregate>;
    _min?: Maybe<MessageTemplateOrgMinAggregate>;
    _sum?: Maybe<MessageTemplateOrgSumAggregate>;
    body: Scalars['String']['output'];
    languageCode: LanguageCode;
    messageType: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    subject: Scalars['String']['output'];
};

export type MessageTemplateOrgListRelationFilter = {
    every?: InputMaybe<MessageTemplateOrgWhereInput>;
    none?: InputMaybe<MessageTemplateOrgWhereInput>;
    some?: InputMaybe<MessageTemplateOrgWhereInput>;
};

export type MessageTemplateOrgMaxAggregate = {
    __typename?: 'MessageTemplateOrgMaxAggregate';
    body?: Maybe<Scalars['String']['output']>;
    languageCode?: Maybe<LanguageCode>;
    messageType?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    subject?: Maybe<Scalars['String']['output']>;
};

export type MessageTemplateOrgMaxOrderByAggregateInput = {
    body?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    subject?: InputMaybe<SortOrder>;
};

export type MessageTemplateOrgMinAggregate = {
    __typename?: 'MessageTemplateOrgMinAggregate';
    body?: Maybe<Scalars['String']['output']>;
    languageCode?: Maybe<LanguageCode>;
    messageType?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    subject?: Maybe<Scalars['String']['output']>;
};

export type MessageTemplateOrgMinOrderByAggregateInput = {
    body?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    subject?: InputMaybe<SortOrder>;
};

export type MessageTemplateOrgOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type MessageTemplateOrgOrderByWithAggregationInput = {
    _avg?: InputMaybe<MessageTemplateOrgAvgOrderByAggregateInput>;
    _count?: InputMaybe<MessageTemplateOrgCountOrderByAggregateInput>;
    _max?: InputMaybe<MessageTemplateOrgMaxOrderByAggregateInput>;
    _min?: InputMaybe<MessageTemplateOrgMinOrderByAggregateInput>;
    _sum?: InputMaybe<MessageTemplateOrgSumOrderByAggregateInput>;
    body?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    subject?: InputMaybe<SortOrder>;
};

export type MessageTemplateOrgOrderByWithRelationInput = {
    body?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    messageBlueprint?: InputMaybe<MessageBlueprintOrderByWithRelationInput>;
    messageType?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    subject?: InputMaybe<SortOrder>;
};

export type MessageTemplateOrgOrgIdMessageTypeLanguageCodeCompoundUniqueInput =
    {
        languageCode: LanguageCode;
        messageType: Scalars['String']['input'];
        orgId: Scalars['Int']['input'];
    };

export enum MessageTemplateOrgScalarFieldEnum {
    Body = 'body',
    LanguageCode = 'languageCode',
    MessageType = 'messageType',
    OrgId = 'orgId',
    Subject = 'subject',
}

export type MessageTemplateOrgScalarWhereInput = {
    AND?: InputMaybe<Array<MessageTemplateOrgScalarWhereInput>>;
    NOT?: InputMaybe<Array<MessageTemplateOrgScalarWhereInput>>;
    OR?: InputMaybe<Array<MessageTemplateOrgScalarWhereInput>>;
    body?: InputMaybe<StringFilter>;
    languageCode?: InputMaybe<EnumLanguageCodeFilter>;
    messageType?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    subject?: InputMaybe<StringFilter>;
};

export type MessageTemplateOrgScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<MessageTemplateOrgScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<MessageTemplateOrgScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<MessageTemplateOrgScalarWhereWithAggregatesInput>>;
    body?: InputMaybe<StringWithAggregatesFilter>;
    languageCode?: InputMaybe<EnumLanguageCodeWithAggregatesFilter>;
    messageType?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    subject?: InputMaybe<StringWithAggregatesFilter>;
};

export type MessageTemplateOrgSumAggregate = {
    __typename?: 'MessageTemplateOrgSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type MessageTemplateOrgSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type MessageTemplateOrgUpdateInput = {
    body?: InputMaybe<StringFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    messageBlueprint?: InputMaybe<MessageBlueprintUpdateOneRequiredWithoutOrgMessageTemplateNestedInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    subject?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MessageTemplateOrgUpdateManyMutationInput = {
    body?: InputMaybe<StringFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    subject?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MessageTemplateOrgUpdateManyWithWhereWithoutMessageBlueprintInput =
    {
        data: MessageTemplateOrgUpdateManyMutationInput;
        where: MessageTemplateOrgScalarWhereInput;
    };

export type MessageTemplateOrgUpdateManyWithoutMessageBlueprintNestedInput = {
    connect?: InputMaybe<Array<MessageTemplateOrgWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<MessageTemplateOrgCreateOrConnectWithoutMessageBlueprintInput>
    >;
    create?: InputMaybe<
        Array<MessageTemplateOrgCreateWithoutMessageBlueprintInput>
    >;
    createMany?: InputMaybe<MessageTemplateOrgCreateManyMessageBlueprintInputEnvelope>;
    delete?: InputMaybe<Array<MessageTemplateOrgWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<MessageTemplateOrgScalarWhereInput>>;
    disconnect?: InputMaybe<Array<MessageTemplateOrgWhereUniqueInput>>;
    set?: InputMaybe<Array<MessageTemplateOrgWhereUniqueInput>>;
    update?: InputMaybe<
        Array<MessageTemplateOrgUpdateWithWhereUniqueWithoutMessageBlueprintInput>
    >;
    updateMany?: InputMaybe<
        Array<MessageTemplateOrgUpdateManyWithWhereWithoutMessageBlueprintInput>
    >;
    upsert?: InputMaybe<
        Array<MessageTemplateOrgUpsertWithWhereUniqueWithoutMessageBlueprintInput>
    >;
};

export type MessageTemplateOrgUpdateWithWhereUniqueWithoutMessageBlueprintInput =
    {
        data: MessageTemplateOrgUpdateWithoutMessageBlueprintInput;
        where: MessageTemplateOrgWhereUniqueInput;
    };

export type MessageTemplateOrgUpdateWithoutMessageBlueprintInput = {
    body?: InputMaybe<StringFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    subject?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MessageTemplateOrgUpsertWithWhereUniqueWithoutMessageBlueprintInput =
    {
        create: MessageTemplateOrgCreateWithoutMessageBlueprintInput;
        update: MessageTemplateOrgUpdateWithoutMessageBlueprintInput;
        where: MessageTemplateOrgWhereUniqueInput;
    };

export type MessageTemplateOrgWhereInput = {
    AND?: InputMaybe<Array<MessageTemplateOrgWhereInput>>;
    NOT?: InputMaybe<Array<MessageTemplateOrgWhereInput>>;
    OR?: InputMaybe<Array<MessageTemplateOrgWhereInput>>;
    body?: InputMaybe<StringFilter>;
    languageCode?: InputMaybe<EnumLanguageCodeFilter>;
    messageBlueprint?: InputMaybe<MessageBlueprintRelationFilter>;
    messageType?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    subject?: InputMaybe<StringFilter>;
};

export type MessageTemplateOrgWhereUniqueInput = {
    AND?: InputMaybe<Array<MessageTemplateOrgWhereInput>>;
    NOT?: InputMaybe<Array<MessageTemplateOrgWhereInput>>;
    OR?: InputMaybe<Array<MessageTemplateOrgWhereInput>>;
    body?: InputMaybe<StringFilter>;
    languageCode?: InputMaybe<EnumLanguageCodeFilter>;
    messageBlueprint?: InputMaybe<MessageBlueprintRelationFilter>;
    messageType?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgId_messageType_languageCode?: InputMaybe<MessageTemplateOrgOrgIdMessageTypeLanguageCodeCompoundUniqueInput>;
    subject?: InputMaybe<StringFilter>;
};

export enum MessagingRuleName {
    ApptReminderSuppressEmptyCta = 'APPT_REMINDER_SUPPRESS_EMPTY_CTA',
    ApptReminderSuppressForDays = 'APPT_REMINDER_SUPPRESS_FOR_DAYS',
    CollectionReminderSuppressByTouch = 'COLLECTION_REMINDER_SUPPRESS_BY_TOUCH',
    CollectionReminderSuppressEmptyBody = 'COLLECTION_REMINDER_SUPPRESS_EMPTY_BODY',
    CollectionReminderSuppressNotCollectible = 'COLLECTION_REMINDER_SUPPRESS_NOT_COLLECTIBLE',
    PaymentPlanPriceAdjustmentSuppression = 'PAYMENT_PLAN_PRICE_ADJUSTMENT_SUPPRESSION',
    SuppressBySource = 'SUPPRESS_BY_SOURCE',
}

export enum MessagingRuleType {
    Consolidation = 'CONSOLIDATION',
    Suppression = 'SUPPRESSION',
}

export type MigratedEncounter = {
    __typename?: 'MigratedEncounter';
    appointmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentIds: Array<Scalars['String']['output']>;
    encounterId: Scalars['String']['output'];
    linkId: Scalars['String']['output'];
    slotId?: Maybe<Scalars['String']['output']>;
};

export type MigratedEncounterCountAggregate = {
    __typename?: 'MigratedEncounterCountAggregate';
    _all: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    boughtTreatmentIds: Scalars['Int']['output'];
    encounterId: Scalars['Int']['output'];
    linkId: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
};

export type MigratedEncounterCountOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    linkId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
};

export type MigratedEncounterCreateInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentIds?: InputMaybe<MigratedEncounterCreateboughtTreatmentIdsInput>;
    encounterId: Scalars['String']['input'];
    linkId: Scalars['String']['input'];
    slotId?: InputMaybe<Scalars['String']['input']>;
};

export type MigratedEncounterCreateManyInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    boughtTreatmentIds?: InputMaybe<MigratedEncounterCreateboughtTreatmentIdsInput>;
    encounterId: Scalars['String']['input'];
    linkId: Scalars['String']['input'];
    slotId?: InputMaybe<Scalars['String']['input']>;
};

export type MigratedEncounterCreateboughtTreatmentIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type MigratedEncounterGroupBy = {
    __typename?: 'MigratedEncounterGroupBy';
    _count?: Maybe<MigratedEncounterCountAggregate>;
    _max?: Maybe<MigratedEncounterMaxAggregate>;
    _min?: Maybe<MigratedEncounterMinAggregate>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    boughtTreatmentIds?: Maybe<Array<Scalars['String']['output']>>;
    encounterId: Scalars['String']['output'];
    linkId: Scalars['String']['output'];
    slotId?: Maybe<Scalars['String']['output']>;
};

export type MigratedEncounterMaxAggregate = {
    __typename?: 'MigratedEncounterMaxAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    linkId?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
};

export type MigratedEncounterMaxOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    linkId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
};

export type MigratedEncounterMinAggregate = {
    __typename?: 'MigratedEncounterMinAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    linkId?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
};

export type MigratedEncounterMinOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    linkId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
};

export type MigratedEncounterOrderByWithAggregationInput = {
    _count?: InputMaybe<MigratedEncounterCountOrderByAggregateInput>;
    _max?: InputMaybe<MigratedEncounterMaxOrderByAggregateInput>;
    _min?: InputMaybe<MigratedEncounterMinOrderByAggregateInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    linkId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrderInput>;
};

export type MigratedEncounterOrderByWithRelationInput = {
    appointmentId?: InputMaybe<SortOrderInput>;
    boughtTreatmentIds?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    linkId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrderInput>;
};

export enum MigratedEncounterScalarFieldEnum {
    AppointmentId = 'appointmentId',
    BoughtTreatmentIds = 'boughtTreatmentIds',
    EncounterId = 'encounterId',
    LinkId = 'linkId',
    SlotId = 'slotId',
}

export type MigratedEncounterScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<MigratedEncounterScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<MigratedEncounterScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<MigratedEncounterScalarWhereWithAggregatesInput>>;
    appointmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    encounterId?: InputMaybe<UuidWithAggregatesFilter>;
    linkId?: InputMaybe<UuidWithAggregatesFilter>;
    slotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
};

export type MigratedEncounterUpdateInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<MigratedEncounterUpdateboughtTreatmentIdsInput>;
    encounterId?: InputMaybe<StringFieldUpdateOperationsInput>;
    linkId?: InputMaybe<StringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type MigratedEncounterUpdateManyMutationInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    boughtTreatmentIds?: InputMaybe<MigratedEncounterUpdateboughtTreatmentIdsInput>;
    encounterId?: InputMaybe<StringFieldUpdateOperationsInput>;
    linkId?: InputMaybe<StringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type MigratedEncounterUpdateboughtTreatmentIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MigratedEncounterWhereInput = {
    AND?: InputMaybe<Array<MigratedEncounterWhereInput>>;
    NOT?: InputMaybe<Array<MigratedEncounterWhereInput>>;
    OR?: InputMaybe<Array<MigratedEncounterWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    encounterId?: InputMaybe<UuidFilter>;
    linkId?: InputMaybe<UuidFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
};

export type MigratedEncounterWhereUniqueInput = {
    AND?: InputMaybe<Array<MigratedEncounterWhereInput>>;
    NOT?: InputMaybe<Array<MigratedEncounterWhereInput>>;
    OR?: InputMaybe<Array<MigratedEncounterWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    boughtTreatmentIds?: InputMaybe<StringNullableListFilter>;
    encounterId?: InputMaybe<Scalars['String']['input']>;
    linkId?: InputMaybe<UuidFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
};

export type Migrations = {
    __typename?: 'Migrations';
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    timestamp: Scalars['BigInt']['output'];
};

export type MigrationsAvgAggregate = {
    __typename?: 'MigrationsAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    timestamp?: Maybe<Scalars['Float']['output']>;
};

export type MigrationsAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type MigrationsCountAggregate = {
    __typename?: 'MigrationsCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    timestamp: Scalars['Int']['output'];
};

export type MigrationsCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type MigrationsCreateInput = {
    name: Scalars['String']['input'];
    timestamp: Scalars['BigInt']['input'];
};

export type MigrationsCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
    timestamp: Scalars['BigInt']['input'];
};

export type MigrationsGroupBy = {
    __typename?: 'MigrationsGroupBy';
    _avg?: Maybe<MigrationsAvgAggregate>;
    _count?: Maybe<MigrationsCountAggregate>;
    _max?: Maybe<MigrationsMaxAggregate>;
    _min?: Maybe<MigrationsMinAggregate>;
    _sum?: Maybe<MigrationsSumAggregate>;
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    timestamp: Scalars['BigInt']['output'];
};

export type MigrationsMaxAggregate = {
    __typename?: 'MigrationsMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['BigInt']['output']>;
};

export type MigrationsMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type MigrationsMinAggregate = {
    __typename?: 'MigrationsMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['BigInt']['output']>;
};

export type MigrationsMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type MigrationsOrderByWithAggregationInput = {
    _avg?: InputMaybe<MigrationsAvgOrderByAggregateInput>;
    _count?: InputMaybe<MigrationsCountOrderByAggregateInput>;
    _max?: InputMaybe<MigrationsMaxOrderByAggregateInput>;
    _min?: InputMaybe<MigrationsMinOrderByAggregateInput>;
    _sum?: InputMaybe<MigrationsSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type MigrationsOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export enum MigrationsScalarFieldEnum {
    Id = 'id',
    Name = 'name',
    Timestamp = 'timestamp',
}

export type MigrationsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<MigrationsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<MigrationsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<MigrationsScalarWhereWithAggregatesInput>>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    timestamp?: InputMaybe<BigIntWithAggregatesFilter>;
};

export type MigrationsSumAggregate = {
    __typename?: 'MigrationsSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    timestamp?: Maybe<Scalars['BigInt']['output']>;
};

export type MigrationsSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    timestamp?: InputMaybe<SortOrder>;
};

export type MigrationsUpdateInput = {
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    timestamp?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type MigrationsUpdateManyMutationInput = {
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    timestamp?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type MigrationsWhereInput = {
    AND?: InputMaybe<Array<MigrationsWhereInput>>;
    NOT?: InputMaybe<Array<MigrationsWhereInput>>;
    OR?: InputMaybe<Array<MigrationsWhereInput>>;
    id?: InputMaybe<IntFilter>;
    name?: InputMaybe<StringFilter>;
    timestamp?: InputMaybe<BigIntFilter>;
};

export type MigrationsWhereUniqueInput = {
    AND?: InputMaybe<Array<MigrationsWhereInput>>;
    NOT?: InputMaybe<Array<MigrationsWhereInput>>;
    OR?: InputMaybe<Array<MigrationsWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<StringFilter>;
    timestamp?: InputMaybe<BigIntFilter>;
};

export type Mutation = {
    __typename?: 'Mutation';
    cancelCharges: Array<Charge>;
    checkIn: MarkAppointmentStatusResult;
    createAdjudication: CheckoutAdjudication;
    createCharges: Array<Charge>;
    createConsumerAndEhrPatient: Consumer;
    createInsurance: CreateInsuranceResponse;
    createManyALEConfig: AffectedRowsOutput;
    createManyALEDepartmentGoLive: AffectedRowsOutput;
    createManyAdjudication: AffectedRowsOutput;
    createManyAdjudicationAuditLog: AffectedRowsOutput;
    createManyAdjustment: AffectedRowsOutput;
    createManyAdjustmentAuditLog: AffectedRowsOutput;
    createManyAdmin: AffectedRowsOutput;
    createManyAdminInteraction: AffectedRowsOutput;
    createManyAndReturnAdjudication: Array<CreateManyAndReturnAdjudication>;
    createManyAndReturnAdjudicationAuditLog: Array<CreateManyAndReturnAdjudicationAuditLog>;
    createManyAndReturnAdjustment: Array<CreateManyAndReturnAdjustment>;
    createManyAndReturnAdjustmentAuditLog: Array<CreateManyAndReturnAdjustmentAuditLog>;
    createManyAndReturnAppointment: Array<CreateManyAndReturnAppointment>;
    createManyAndReturnAppointmentAuditLog: Array<CreateManyAndReturnAppointmentAuditLog>;
    createManyAndReturnArrearBilling: Array<CreateManyAndReturnArrearBilling>;
    createManyAndReturnArtClaim: Array<CreateManyAndReturnArtClaim>;
    createManyAndReturnArtClaimAuditLog: Array<CreateManyAndReturnArtClaimAuditLog>;
    createManyAndReturnArtClaimCptLine: Array<CreateManyAndReturnArtClaimCptLine>;
    createManyAndReturnArtClaimCptLineAuditLog: Array<CreateManyAndReturnArtClaimCptLineAuditLog>;
    createManyAndReturnBillingTableDownloadRequest: Array<CreateManyAndReturnBillingTableDownloadRequest>;
    createManyAndReturnBoughtTreatment: Array<CreateManyAndReturnBoughtTreatment>;
    createManyAndReturnBoughtTreatmentAuditLog: Array<CreateManyAndReturnBoughtTreatmentAuditLog>;
    createManyAndReturnBoughtTreatmentClaimDetail: Array<CreateManyAndReturnBoughtTreatmentClaimDetail>;
    createManyAndReturnBulkChargeCardRun: Array<CreateManyAndReturnBulkChargeCardRun>;
    createManyAndReturnBulkChargeCardRunItem: Array<CreateManyAndReturnBulkChargeCardRunItem>;
    createManyAndReturnBusinessHour: Array<CreateManyAndReturnBusinessHour>;
    createManyAndReturnCandidateTreatment: Array<CreateManyAndReturnCandidateTreatment>;
    createManyAndReturnCharge: Array<CreateManyAndReturnCharge>;
    createManyAndReturnChargeAuditLog: Array<CreateManyAndReturnChargeAuditLog>;
    createManyAndReturnChargeReattributionAndPartialPaymentLog: Array<CreateManyAndReturnChargeReattributionAndPartialPaymentLog>;
    createManyAndReturnChargeReattributionLog: Array<CreateManyAndReturnChargeReattributionLog>;
    createManyAndReturnCheckoutAdjudication: Array<CreateManyAndReturnCheckoutAdjudication>;
    createManyAndReturnClaimToBoughtTreatment: Array<CreateManyAndReturnClaimToBoughtTreatment>;
    createManyAndReturnConsentForm: Array<CreateManyAndReturnConsentForm>;
    createManyAndReturnCustomField: Array<CreateManyAndReturnCustomField>;
    createManyAndReturnCustomFieldValue: Array<CreateManyAndReturnCustomFieldValue>;
    createManyAndReturnDataMigrations: Array<CreateManyAndReturnDataMigrations>;
    createManyAndReturnEhrPaymentDescriptor: Array<CreateManyAndReturnEhrPaymentDescriptor>;
    createManyAndReturnEhrPaymentDescriptorAuditLog: Array<CreateManyAndReturnEhrPaymentDescriptorAuditLog>;
    createManyAndReturnEhrPaymentDirectionSsAsset: Array<CreateManyAndReturnEhrPaymentDirectionSsAsset>;
    createManyAndReturnEhrPostDetail: Array<CreateManyAndReturnEhrPostDetail>;
    createManyAndReturnEhrPostDetailToPayout: Array<CreateManyAndReturnEhrPostDetailToPayout>;
    createManyAndReturnEhrPostLedger: Array<CreateManyAndReturnEhrPostLedger>;
    createManyAndReturnEhrPostLedgerAuditLog: Array<CreateManyAndReturnEhrPostLedgerAuditLog>;
    createManyAndReturnEhrPostLedgerToPayout: Array<CreateManyAndReturnEhrPostLedgerToPayout>;
    createManyAndReturnEhrSlot: Array<CreateManyAndReturnEhrSlot>;
    createManyAndReturnEhrSlotAuditLog: Array<CreateManyAndReturnEhrSlotAuditLog>;
    createManyAndReturnEncounter: Array<CreateManyAndReturnEncounter>;
    createManyAndReturnExperityEncounter: Array<CreateManyAndReturnExperityEncounter>;
    createManyAndReturnFeeConfig: Array<CreateManyAndReturnFeeConfig>;
    createManyAndReturnFeeConfigAuditLog: Array<CreateManyAndReturnFeeConfigAuditLog>;
    createManyAndReturnGuarantorPaymentLinkContext: Array<CreateManyAndReturnGuarantorPaymentLinkContext>;
    createManyAndReturnHoliday: Array<CreateManyAndReturnHoliday>;
    createManyAndReturnInsuranceMetadata: Array<CreateManyAndReturnInsuranceMetadata>;
    createManyAndReturnInvoiceDailyLineItems: Array<CreateManyAndReturnInvoiceDailyLineItems>;
    createManyAndReturnInvoices: Array<CreateManyAndReturnInvoices>;
    createManyAndReturnLiveTransfers: Array<CreateManyAndReturnLiveTransfers>;
    createManyAndReturnMcmsAssociation: Array<CreateManyAndReturnMcmsAssociation>;
    createManyAndReturnMcmsAssociationAuditLog: Array<CreateManyAndReturnMcmsAssociationAuditLog>;
    createManyAndReturnMcmsAssociationClaim: Array<CreateManyAndReturnMcmsAssociationClaim>;
    createManyAndReturnMcmsAssociationClaimAuditLog: Array<CreateManyAndReturnMcmsAssociationClaimAuditLog>;
    createManyAndReturnMcmsAssociationSlot: Array<CreateManyAndReturnMcmsAssociationSlot>;
    createManyAndReturnMcmsAssociationSlotAuditLog: Array<CreateManyAndReturnMcmsAssociationSlotAuditLog>;
    createManyAndReturnMessageOrchestrationRule: Array<CreateManyAndReturnMessageOrchestrationRule>;
    createManyAndReturnMigratedEncounter: Array<CreateManyAndReturnMigratedEncounter>;
    createManyAndReturnMigrations: Array<CreateManyAndReturnMigrations>;
    createManyAndReturnNonCardRefunds: Array<CreateManyAndReturnNonCardRefunds>;
    createManyAndReturnOrg_fees: Array<CreateManyAndReturnOrgFees>;
    createManyAndReturnOrg_stripe_mapping: Array<CreateManyAndReturnOrgStripeMapping>;
    createManyAndReturnPayLaterAuthorization: Array<CreateManyAndReturnPayLaterAuthorization>;
    createManyAndReturnPayLaterAuthorizationAuditLog: Array<CreateManyAndReturnPayLaterAuthorizationAuditLog>;
    createManyAndReturnPaymentAuthorization: Array<CreateManyAndReturnPaymentAuthorization>;
    createManyAndReturnPaymentAuthorizationAuditLog: Array<CreateManyAndReturnPaymentAuthorizationAuditLog>;
    createManyAndReturnPaymentPlan: Array<CreateManyAndReturnPaymentPlan>;
    createManyAndReturnPaymentPlanAdjustment: Array<CreateManyAndReturnPaymentPlanAdjustment>;
    createManyAndReturnPaymentPlanAdjustmentAuditLog: Array<CreateManyAndReturnPaymentPlanAdjustmentAuditLog>;
    createManyAndReturnPaymentPlanAuditLog: Array<CreateManyAndReturnPaymentPlanAuditLog>;
    createManyAndReturnPaymentPlanAutoCharge: Array<CreateManyAndReturnPaymentPlanAutoCharge>;
    createManyAndReturnPaymentPlanAutoChargeAuditLog: Array<CreateManyAndReturnPaymentPlanAutoChargeAuditLog>;
    createManyAndReturnPaymentPlanBoughtTreatment: Array<CreateManyAndReturnPaymentPlanBoughtTreatment>;
    createManyAndReturnPaymentPlanBoughtTreatmentAuditLog: Array<CreateManyAndReturnPaymentPlanBoughtTreatmentAuditLog>;
    createManyAndReturnPaymentPlanOrgConfig: Array<CreateManyAndReturnPaymentPlanOrgConfig>;
    createManyAndReturnPaymentPlanOrgConfigAuditLog: Array<CreateManyAndReturnPaymentPlanOrgConfigAuditLog>;
    createManyAndReturnPayout: Array<CreateManyAndReturnPayout>;
    createManyAndReturnPayoutAuditLog: Array<CreateManyAndReturnPayoutAuditLog>;
    createManyAndReturnPendingVoidPayoutReversal: Array<CreateManyAndReturnPendingVoidPayoutReversal>;
    createManyAndReturnPracticeConfiguration: Array<CreateManyAndReturnPracticeConfiguration>;
    createManyAndReturnPricingEscalator: Array<CreateManyAndReturnPricingEscalator>;
    createManyAndReturnReattributionDirection: Array<CreateManyAndReturnReattributionDirection>;
    createManyAndReturnReceiptArrangement: Array<CreateManyAndReturnReceiptArrangement>;
    createManyAndReturnReservedEhrVisit: Array<CreateManyAndReturnReservedEhrVisit>;
    createManyAndReturnSlot: Array<CreateManyAndReturnSlot>;
    createManyAndReturnSlotAuditLog: Array<CreateManyAndReturnSlotAuditLog>;
    createManyAndReturnSuperscriptFeeLineItem: Array<CreateManyAndReturnSuperscriptFeeLineItem>;
    createManyAndReturnSuperscriptFees: Array<CreateManyAndReturnSuperscriptFees>;
    createManyAndReturnTimeBlock: Array<CreateManyAndReturnTimeBlock>;
    createManyAndReturnTransaction: Array<CreateManyAndReturnTransaction>;
    createManyAppointment: AffectedRowsOutput;
    createManyAppointmentAuditLog: AffectedRowsOutput;
    createManyArrearBilling: AffectedRowsOutput;
    createManyArtClaim: AffectedRowsOutput;
    createManyArtClaimAuditLog: AffectedRowsOutput;
    createManyArtClaimCptLine: AffectedRowsOutput;
    createManyArtClaimCptLineAuditLog: AffectedRowsOutput;
    createManyArtOrgConfig: AffectedRowsOutput;
    createManyArtPracticeConfig: AffectedRowsOutput;
    createManyAthenaMedications: AffectedRowsOutput;
    createManyAthenaPharmacy: AffectedRowsOutput;
    createManyAthenaProvider: AffectedRowsOutput;
    createManyBenefitParsingRules: AffectedRowsOutput;
    createManyBillingCode: AffectedRowsOutput;
    createManyBillingTableDownloadRequest: AffectedRowsOutput;
    createManyBoughtTreatment: AffectedRowsOutput;
    createManyBoughtTreatmentAuditLog: AffectedRowsOutput;
    createManyBoughtTreatmentClaimDetail: AffectedRowsOutput;
    createManyBulkChargeCardRun: AffectedRowsOutput;
    createManyBulkChargeCardRunItem: AffectedRowsOutput;
    createManyBundle: AffectedRowsOutput;
    createManyBundleToHrt: AffectedRowsOutput;
    createManyBusinessHour: AffectedRowsOutput;
    createManyCandidateTreatment: AffectedRowsOutput;
    createManyCardAuthorization: AffectedRowsOutput;
    createManyCardAuthorizationAuditLog: AffectedRowsOutput;
    createManyCashPrice: AffectedRowsOutput;
    createManyCharge: AffectedRowsOutput;
    createManyChargeAuditLog: AffectedRowsOutput;
    createManyChargeReattributionAndPartialPaymentLog: AffectedRowsOutput;
    createManyChargeReattributionLog: AffectedRowsOutput;
    createManyCheckNetworkStatusResults: AffectedRowsOutput;
    createManyCheckoutAdjudication: AffectedRowsOutput;
    createManyClaimToBoughtTreatment: AffectedRowsOutput;
    createManyConfigCommit: AffectedRowsOutput;
    createManyConfigFlag: AffectedRowsOutput;
    createManyConfigSession: AffectedRowsOutput;
    createManyConsentForm: AffectedRowsOutput;
    createManyConsumer: AffectedRowsOutput;
    createManyConsumerAuditLog: AffectedRowsOutput;
    createManyConsumerMessage: AffectedRowsOutput;
    createManyConsumerNote: AffectedRowsOutput;
    createManyConsumerPhotoMetaData: AffectedRowsOutput;
    createManyConsumerSrtRecords: AffectedRowsOutput;
    createManyContract: AffectedRowsOutput;
    createManyContractAuditLog: AffectedRowsOutput;
    createManyCoverageResponses: AffectedRowsOutput;
    createManyCptExclusivityEdge: AffectedRowsOutput;
    createManyCustomField: AffectedRowsOutput;
    createManyCustomFieldValue: AffectedRowsOutput;
    createManyDataMigrations: AffectedRowsOutput;
    createManyDefaultPractice: AffectedRowsOutput;
    createManyDefault_providers: AffectedRowsOutput;
    createManyDeploymentOrgPhase: AffectedRowsOutput;
    createManyDeploymentOrgTask: AffectedRowsOutput;
    createManyDeploymentOrgTaskDependency: AffectedRowsOutput;
    createManyDeploymentPhase: AffectedRowsOutput;
    createManyDeploymentTask: AffectedRowsOutput;
    createManyDeploymentTaskDependency: AffectedRowsOutput;
    createManyDeploymentTeam: AffectedRowsOutput;
    createManyDiscountCodes: AffectedRowsOutput;
    createManyEcwPayerAlias: AffectedRowsOutput;
    createManyEcwPayerStc: AffectedRowsOutput;
    createManyEhrAppointmentTypeIdToName: AffectedRowsOutput;
    createManyEhrPaymentDescriptor: AffectedRowsOutput;
    createManyEhrPaymentDescriptorAuditLog: AffectedRowsOutput;
    createManyEhrPaymentDirectionSsAsset: AffectedRowsOutput;
    createManyEhrPostDetail: AffectedRowsOutput;
    createManyEhrPostDetailToPayout: AffectedRowsOutput;
    createManyEhrPostLedger: AffectedRowsOutput;
    createManyEhrPostLedgerAuditLog: AffectedRowsOutput;
    createManyEhrPostLedgerToPayout: AffectedRowsOutput;
    createManyEhrPrimaryCareProvider: AffectedRowsOutput;
    createManyEhrProviderMapping: AffectedRowsOutput;
    createManyEhrSlot: AffectedRowsOutput;
    createManyEhrSlotAuditLog: AffectedRowsOutput;
    createManyEncounter: AffectedRowsOutput;
    createManyExperityEncounter: AffectedRowsOutput;
    createManyFaqDropdowns: AffectedRowsOutput;
    createManyFeeConfig: AffectedRowsOutput;
    createManyFeeConfigAuditLog: AffectedRowsOutput;
    createManyGuarantorPaymentLinkContext: AffectedRowsOutput;
    createManyHoliday: AffectedRowsOutput;
    createManyHrt: AffectedRowsOutput;
    createManyHrtFlags: AffectedRowsOutput;
    createManyHrtPaymentType: AffectedRowsOutput;
    createManyHrtToSrt: AffectedRowsOutput;
    createManyHrtTranslation: AffectedRowsOutput;
    createManyInboundRequestLog: AffectedRowsOutput;
    createManyInboundTextMessageLog: AffectedRowsOutput;
    createManyInsurance: AffectedRowsOutput;
    createManyInsuranceAuditLog: AffectedRowsOutput;
    createManyInsuranceMetadata: AffectedRowsOutput;
    createManyIntakeForm: AffectedRowsOutput;
    createManyIntakeFormSection: AffectedRowsOutput;
    createManyIntakeFormSectionTranslation: AffectedRowsOutput;
    createManyIntakeFormToQuestion: AffectedRowsOutput;
    createManyIntakeQuestion: AffectedRowsOutput;
    createManyIntakeQuestionTranslation: AffectedRowsOutput;
    createManyInvoiceDailyLineItems: AffectedRowsOutput;
    createManyInvoices: AffectedRowsOutput;
    createManyKeywordRule: AffectedRowsOutput;
    createManyLinkMapping: AffectedRowsOutput;
    createManyLiveTransfers: AffectedRowsOutput;
    createManyMcmsAssociation: AffectedRowsOutput;
    createManyMcmsAssociationAuditLog: AffectedRowsOutput;
    createManyMcmsAssociationClaim: AffectedRowsOutput;
    createManyMcmsAssociationClaimAuditLog: AffectedRowsOutput;
    createManyMcmsAssociationSlot: AffectedRowsOutput;
    createManyMcmsAssociationSlotAuditLog: AffectedRowsOutput;
    createManyMessageBlueprint: AffectedRowsOutput;
    createManyMessageConsolidationContext: AffectedRowsOutput;
    createManyMessageConsolidationTemplate: AffectedRowsOutput;
    createManyMessageNudge: AffectedRowsOutput;
    createManyMessageOrchestrationRule: AffectedRowsOutput;
    createManyMessagePayAfter: AffectedRowsOutput;
    createManyMessageSettingsHrt: AffectedRowsOutput;
    createManyMessageSettingsOrg: AffectedRowsOutput;
    createManyMessageTemplateHrt: AffectedRowsOutput;
    createManyMessageTemplateOrg: AffectedRowsOutput;
    createManyMigratedEncounter: AffectedRowsOutput;
    createManyMigrations: AffectedRowsOutput;
    createManyNetworkValidation: AffectedRowsOutput;
    createManyNetwork_plan_exceptions: AffectedRowsOutput;
    createManyNonCardRefunds: AffectedRowsOutput;
    createManyOrgConfigFlag: AffectedRowsOutput;
    createManyOrgHrtSrtRule: AffectedRowsOutput;
    createManyOrgNetworkResults: AffectedRowsOutput;
    createManyOrgOverrideRule: AffectedRowsOutput;
    createManyOrg_fees: AffectedRowsOutput;
    createManyOrg_stripe_mapping: AffectedRowsOutput;
    createManyOrganization: AffectedRowsOutput;
    createManyOrganizationAssets: AffectedRowsOutput;
    createManyOrganizationTranslation: AffectedRowsOutput;
    createManyPayLaterAuthorization: AffectedRowsOutput;
    createManyPayLaterAuthorizationAuditLog: AffectedRowsOutput;
    createManyPayer: AffectedRowsOutput;
    createManyPayerPlanMapping: AffectedRowsOutput;
    createManyPayerToEhrInsurancePackageMapping: AffectedRowsOutput;
    createManyPaymentAuthorization: AffectedRowsOutput;
    createManyPaymentAuthorizationAuditLog: AffectedRowsOutput;
    createManyPaymentContract: AffectedRowsOutput;
    createManyPaymentPlan: AffectedRowsOutput;
    createManyPaymentPlanAdjustment: AffectedRowsOutput;
    createManyPaymentPlanAdjustmentAuditLog: AffectedRowsOutput;
    createManyPaymentPlanAuditLog: AffectedRowsOutput;
    createManyPaymentPlanAutoCharge: AffectedRowsOutput;
    createManyPaymentPlanAutoChargeAuditLog: AffectedRowsOutput;
    createManyPaymentPlanBoughtTreatment: AffectedRowsOutput;
    createManyPaymentPlanBoughtTreatmentAuditLog: AffectedRowsOutput;
    createManyPaymentPlanOrgConfig: AffectedRowsOutput;
    createManyPaymentPlanOrgConfigAuditLog: AffectedRowsOutput;
    createManyPayout: AffectedRowsOutput;
    createManyPayoutAuditLog: AffectedRowsOutput;
    createManyPendingVoidPayoutReversal: AffectedRowsOutput;
    createManyPhoneNumberType: AffectedRowsOutput;
    createManyPlaceOfServiceCode: AffectedRowsOutput;
    createManyPractice: AffectedRowsOutput;
    createManyPracticeConfiguration: AffectedRowsOutput;
    createManyPracticeHours: AffectedRowsOutput;
    createManyPracticeHoursOverrides: AffectedRowsOutput;
    createManyPricedTreatment: AffectedRowsOutput;
    createManyPricingAttempt: AffectedRowsOutput;
    createManyPricingEscalator: AffectedRowsOutput;
    createManyPricingQueue: AffectedRowsOutput;
    createManyPricingResults: AffectedRowsOutput;
    createManyProcedureBenefitParsingRules: AffectedRowsOutput;
    createManyProductCategories: AffectedRowsOutput;
    createManyProductCategoryTranslation: AffectedRowsOutput;
    createManyProductToBundle: AffectedRowsOutput;
    createManyProductToHrt: AffectedRowsOutput;
    createManyProductTranslation: AffectedRowsOutput;
    createManyProducts: AffectedRowsOutput;
    createManyProvider: AffectedRowsOutput;
    createManyProviderCredentialing: AffectedRowsOutput;
    createManyProviderGroup: AffectedRowsOutput;
    createManyProviderGroupToHrt: AffectedRowsOutput;
    createManyProviderHrtMaxCount: AffectedRowsOutput;
    createManyProviderTaxonomy: AffectedRowsOutput;
    createManyProviderToOrg: AffectedRowsOutput;
    createManyProviderToProviderGroup: AffectedRowsOutput;
    createManyReattributionDirection: AffectedRowsOutput;
    createManyReceiptArrangement: AffectedRowsOutput;
    createManyReservedEhrVisit: AffectedRowsOutput;
    createManyResetToken: AffectedRowsOutput;
    createManySavedIntakeResponse: AffectedRowsOutput;
    createManySchedulingSlotConfig: AffectedRowsOutput;
    createManyServiceTypeCode: AffectedRowsOutput;
    createManySlot: AffectedRowsOutput;
    createManySlotAuditLog: AffectedRowsOutput;
    createManySrt: AffectedRowsOutput;
    createManySrtFlags: AffectedRowsOutput;
    createManySrtMultiplierRule: AffectedRowsOutput;
    createManySrtToBillingCode: AffectedRowsOutput;
    createManyStatePayerMapping: AffectedRowsOutput;
    createManySuperscriptFeeLineItem: AffectedRowsOutput;
    createManySuperscriptFees: AffectedRowsOutput;
    createManySuperscriptIntakeQuestion: AffectedRowsOutput;
    createManyTimeBlock: AffectedRowsOutput;
    createManyTransaction: AffectedRowsOutput;
    createManyUser: AffectedRowsOutput;
    createManyUserAuditLog: AffectedRowsOutput;
    createManyUserPracticeVisit: AffectedRowsOutput;
    createManyUserToNewUser: AffectedRowsOutput;
    createManyValidPayers: AffectedRowsOutput;
    createOneALEConfig: AleConfig;
    createOneALEDepartmentGoLive: AleDepartmentGoLive;
    createOneAdjudication: Adjudication;
    createOneAdjudicationAuditLog: AdjudicationAuditLog;
    createOneAdjustment: Adjustment;
    createOneAdjustmentAuditLog: AdjustmentAuditLog;
    createOneAdmin: Admin;
    createOneAdminInteraction: AdminInteraction;
    createOneAppointment: Appointment;
    createOneAppointmentAuditLog: AppointmentAuditLog;
    createOneArrearBilling: ArrearBilling;
    createOneArtClaim: ArtClaim;
    createOneArtClaimAuditLog: ArtClaimAuditLog;
    createOneArtClaimCptLine: ArtClaimCptLine;
    createOneArtClaimCptLineAuditLog: ArtClaimCptLineAuditLog;
    createOneArtOrgConfig: ArtOrgConfig;
    createOneArtPracticeConfig: ArtPracticeConfig;
    createOneAthenaMedications: AthenaMedications;
    createOneAthenaPharmacy: AthenaPharmacy;
    createOneAthenaProvider: AthenaProvider;
    createOneBenefitParsingRules: BenefitParsingRules;
    createOneBillingCode: BillingCode;
    createOneBillingTableDownloadRequest: BillingTableDownloadRequest;
    createOneBoughtTreatment: BoughtTreatment;
    createOneBoughtTreatmentAuditLog: BoughtTreatmentAuditLog;
    createOneBoughtTreatmentClaimDetail: BoughtTreatmentClaimDetail;
    createOneBulkChargeCardRun: BulkChargeCardRun;
    createOneBulkChargeCardRunItem: BulkChargeCardRunItem;
    createOneBundle: Bundle;
    createOneBundleToHrt: BundleToHrt;
    createOneBusinessHour: BusinessHour;
    createOneCandidateTreatment: CandidateTreatment;
    createOneCardAuthorization: CardAuthorization;
    createOneCardAuthorizationAuditLog: CardAuthorizationAuditLog;
    createOneCashPrice: CashPrice;
    createOneCharge: Charge;
    createOneChargeAuditLog: ChargeAuditLog;
    createOneChargeReattributionAndPartialPaymentLog: ChargeReattributionAndPartialPaymentLog;
    createOneChargeReattributionLog: ChargeReattributionLog;
    createOneCheckNetworkStatusResults: CheckNetworkStatusResults;
    createOneCheckoutAdjudication: CheckoutAdjudication;
    createOneClaimToBoughtTreatment: ClaimToBoughtTreatment;
    createOneConfigCommit: ConfigCommit;
    createOneConfigFlag: ConfigFlag;
    createOneConfigSession: ConfigSession;
    createOneConsentForm: ConsentForm;
    createOneConsumer: Consumer;
    createOneConsumerAuditLog: ConsumerAuditLog;
    createOneConsumerMessage: ConsumerMessage;
    createOneConsumerNote: ConsumerNote;
    createOneConsumerPhotoMetaData: ConsumerPhotoMetaData;
    createOneConsumerSrtRecords: ConsumerSrtRecords;
    createOneContract: Contract;
    createOneContractAuditLog: ContractAuditLog;
    createOneCoverageResponses: CoverageResponses;
    createOneCptExclusivityEdge: CptExclusivityEdge;
    createOneCustomField: CustomField;
    createOneCustomFieldValue: CustomFieldValue;
    createOneDataMigrations: DataMigrations;
    createOneDefaultPractice: DefaultPractice;
    createOneDefault_providers: DefaultProviders;
    createOneDeploymentOrgPhase: DeploymentOrgPhase;
    createOneDeploymentOrgTask: DeploymentOrgTask;
    createOneDeploymentOrgTaskDependency: DeploymentOrgTaskDependency;
    createOneDeploymentPhase: DeploymentPhase;
    createOneDeploymentTask: DeploymentTask;
    createOneDeploymentTaskDependency: DeploymentTaskDependency;
    createOneDeploymentTeam: DeploymentTeam;
    createOneDiscountCodes: DiscountCodes;
    createOneEcwPayerAlias: EcwPayerAlias;
    createOneEcwPayerStc: EcwPayerStc;
    createOneEhrAppointmentTypeIdToName: EhrAppointmentTypeIdToName;
    createOneEhrPaymentDescriptor: EhrPaymentDescriptor;
    createOneEhrPaymentDescriptorAuditLog: EhrPaymentDescriptorAuditLog;
    createOneEhrPaymentDirectionSsAsset: EhrPaymentDirectionSsAsset;
    createOneEhrPostDetail: EhrPostDetail;
    createOneEhrPostDetailToPayout: EhrPostDetailToPayout;
    createOneEhrPostLedger: EhrPostLedger;
    createOneEhrPostLedgerAuditLog: EhrPostLedgerAuditLog;
    createOneEhrPostLedgerToPayout: EhrPostLedgerToPayout;
    createOneEhrPrimaryCareProvider: EhrPrimaryCareProvider;
    createOneEhrProviderMapping: EhrProviderMapping;
    createOneEhrSlot: EhrSlot;
    createOneEhrSlotAuditLog: EhrSlotAuditLog;
    createOneEncounter: Encounter;
    createOneExperityEncounter: ExperityEncounter;
    createOneFaqDropdowns: FaqDropdowns;
    createOneFeeConfig: FeeConfig;
    createOneFeeConfigAuditLog: FeeConfigAuditLog;
    createOneGuarantorPaymentLinkContext: GuarantorPaymentLinkContext;
    createOneHoliday: Holiday;
    createOneHrt: Hrt;
    createOneHrtFlags: HrtFlags;
    createOneHrtPaymentType: HrtPaymentType;
    createOneHrtToSrt: HrtToSrt;
    createOneHrtTranslation: HrtTranslation;
    createOneInboundRequestLog: InboundRequestLog;
    createOneInboundTextMessageLog: InboundTextMessageLog;
    createOneInsurance: Insurance;
    createOneInsuranceAuditLog: InsuranceAuditLog;
    createOneInsuranceMetadata: InsuranceMetadata;
    createOneIntakeForm: IntakeForm;
    createOneIntakeFormSection: IntakeFormSection;
    createOneIntakeFormSectionTranslation: IntakeFormSectionTranslation;
    createOneIntakeFormToQuestion: IntakeFormToQuestion;
    createOneIntakeQuestion: IntakeQuestion;
    createOneIntakeQuestionTranslation: IntakeQuestionTranslation;
    createOneInvoiceDailyLineItems: InvoiceDailyLineItems;
    createOneInvoices: Invoices;
    createOneKeywordRule: KeywordRule;
    createOneLinkMapping: LinkMapping;
    createOneLiveTransfers: LiveTransfers;
    createOneMcmsAssociation: McmsAssociation;
    createOneMcmsAssociationAuditLog: McmsAssociationAuditLog;
    createOneMcmsAssociationClaim: McmsAssociationClaim;
    createOneMcmsAssociationClaimAuditLog: McmsAssociationClaimAuditLog;
    createOneMcmsAssociationSlot: McmsAssociationSlot;
    createOneMcmsAssociationSlotAuditLog: McmsAssociationSlotAuditLog;
    createOneMessageBlueprint: MessageBlueprint;
    createOneMessageConsolidationContext: MessageConsolidationContext;
    createOneMessageConsolidationTemplate: MessageConsolidationTemplate;
    createOneMessageNudge: MessageNudge;
    createOneMessageOrchestrationRule: MessageOrchestrationRule;
    createOneMessagePayAfter: MessagePayAfter;
    createOneMessageSettingsHrt: MessageSettingsHrt;
    createOneMessageSettingsOrg: MessageSettingsOrg;
    createOneMessageTemplateHrt: MessageTemplateHrt;
    createOneMessageTemplateOrg: MessageTemplateOrg;
    createOneMigratedEncounter: MigratedEncounter;
    createOneMigrations: Migrations;
    createOneNetworkValidation: NetworkValidation;
    createOneNetwork_plan_exceptions: NetworkPlanExceptions;
    createOneNonCardRefunds: NonCardRefunds;
    createOneOrgConfigFlag: OrgConfigFlag;
    createOneOrgHrtSrtRule: OrgHrtSrtRule;
    createOneOrgNetworkResults: OrgNetworkResults;
    createOneOrgOverrideRule: OrgOverrideRule;
    createOneOrg_fees: OrgFees;
    createOneOrg_stripe_mapping: OrgStripeMapping;
    createOneOrganization: Organization;
    createOneOrganizationAssets: OrganizationAssets;
    createOneOrganizationTranslation: OrganizationTranslation;
    createOnePayLaterAuthorization: PayLaterAuthorization;
    createOnePayLaterAuthorizationAuditLog: PayLaterAuthorizationAuditLog;
    createOnePayer: Payer;
    createOnePayerPlanMapping: PayerPlanMapping;
    createOnePayerToEhrInsurancePackageMapping: PayerToEhrInsurancePackageMapping;
    createOnePaymentAuthorization: PaymentAuthorization;
    createOnePaymentAuthorizationAuditLog: PaymentAuthorizationAuditLog;
    createOnePaymentContract: PaymentContract;
    createOnePaymentPlan: PaymentPlan;
    createOnePaymentPlanAdjustment: PaymentPlanAdjustment;
    createOnePaymentPlanAdjustmentAuditLog: PaymentPlanAdjustmentAuditLog;
    createOnePaymentPlanAuditLog: PaymentPlanAuditLog;
    createOnePaymentPlanAutoCharge: PaymentPlanAutoCharge;
    createOnePaymentPlanAutoChargeAuditLog: PaymentPlanAutoChargeAuditLog;
    createOnePaymentPlanBoughtTreatment: PaymentPlanBoughtTreatment;
    createOnePaymentPlanBoughtTreatmentAuditLog: PaymentPlanBoughtTreatmentAuditLog;
    createOnePaymentPlanOrgConfig: PaymentPlanOrgConfig;
    createOnePaymentPlanOrgConfigAuditLog: PaymentPlanOrgConfigAuditLog;
    createOnePayout: Payout;
    createOnePayoutAuditLog: PayoutAuditLog;
    createOnePendingVoidPayoutReversal: PendingVoidPayoutReversal;
    createOnePhoneNumberType: PhoneNumberType;
    createOnePlaceOfServiceCode: PlaceOfServiceCode;
    createOnePractice: Practice;
    createOnePracticeConfiguration: PracticeConfiguration;
    createOnePracticeHours: PracticeHours;
    createOnePracticeHoursOverrides: PracticeHoursOverrides;
    createOnePricedTreatment: PricedTreatment;
    createOnePricingAttempt: PricingAttempt;
    createOnePricingEscalator: PricingEscalator;
    createOnePricingQueue: PricingQueue;
    createOnePricingResults: PricingResults;
    createOneProcedureBenefitParsingRules: ProcedureBenefitParsingRules;
    createOneProductCategories: ProductCategories;
    createOneProductCategoryTranslation: ProductCategoryTranslation;
    createOneProductToBundle: ProductToBundle;
    createOneProductToHrt: ProductToHrt;
    createOneProductTranslation: ProductTranslation;
    createOneProducts: Products;
    createOneProvider: Provider;
    createOneProviderCredentialing: ProviderCredentialing;
    createOneProviderGroup: ProviderGroup;
    createOneProviderGroupToHrt: ProviderGroupToHrt;
    createOneProviderHrtMaxCount: ProviderHrtMaxCount;
    createOneProviderTaxonomy: ProviderTaxonomy;
    createOneProviderToOrg: ProviderToOrg;
    createOneProviderToProviderGroup: ProviderToProviderGroup;
    createOneReattributionDirection: ReattributionDirection;
    createOneReceiptArrangement: ReceiptArrangement;
    createOneReservedEhrVisit: ReservedEhrVisit;
    createOneResetToken: ResetToken;
    createOneSavedIntakeResponse: SavedIntakeResponse;
    createOneSchedulingSlotConfig: SchedulingSlotConfig;
    createOneServiceTypeCode: ServiceTypeCode;
    createOneSlot: Slot;
    createOneSlotAuditLog: SlotAuditLog;
    createOneSrt: Srt;
    createOneSrtFlags: SrtFlags;
    createOneSrtMultiplierRule: SrtMultiplierRule;
    createOneSrtToBillingCode: SrtToBillingCode;
    createOneStatePayerMapping: StatePayerMapping;
    createOneSuperscriptFeeLineItem: SuperscriptFeeLineItem;
    createOneSuperscriptFees: SuperscriptFees;
    createOneSuperscriptIntakeQuestion: SuperscriptIntakeQuestion;
    createOneTimeBlock: TimeBlock;
    createOneTransaction: Transaction;
    createOneUser: User;
    createOneUserAuditLog: UserAuditLog;
    createOneUserPracticeVisit: UserPracticeVisit;
    createOneUserToNewUser: UserToNewUser;
    createOneValidPayers: ValidPayers;
    deactivateInsurance: DeactivateInsuranceResponse;
    deleteManyALEConfig: AffectedRowsOutput;
    deleteManyALEDepartmentGoLive: AffectedRowsOutput;
    deleteManyAdjudication: AffectedRowsOutput;
    deleteManyAdjudicationAuditLog: AffectedRowsOutput;
    deleteManyAdjustment: AffectedRowsOutput;
    deleteManyAdjustmentAuditLog: AffectedRowsOutput;
    deleteManyAdmin: AffectedRowsOutput;
    deleteManyAdminInteraction: AffectedRowsOutput;
    deleteManyAppointment: AffectedRowsOutput;
    deleteManyAppointmentAuditLog: AffectedRowsOutput;
    deleteManyArrearBilling: AffectedRowsOutput;
    deleteManyArtClaim: AffectedRowsOutput;
    deleteManyArtClaimAuditLog: AffectedRowsOutput;
    deleteManyArtClaimCptLine: AffectedRowsOutput;
    deleteManyArtClaimCptLineAuditLog: AffectedRowsOutput;
    deleteManyArtOrgConfig: AffectedRowsOutput;
    deleteManyArtPracticeConfig: AffectedRowsOutput;
    deleteManyAthenaMedications: AffectedRowsOutput;
    deleteManyAthenaPharmacy: AffectedRowsOutput;
    deleteManyAthenaProvider: AffectedRowsOutput;
    deleteManyBenefitParsingRules: AffectedRowsOutput;
    deleteManyBillingCode: AffectedRowsOutput;
    deleteManyBillingTableDownloadRequest: AffectedRowsOutput;
    deleteManyBoughtTreatment: AffectedRowsOutput;
    deleteManyBoughtTreatmentAuditLog: AffectedRowsOutput;
    deleteManyBoughtTreatmentClaimDetail: AffectedRowsOutput;
    deleteManyBulkChargeCardRun: AffectedRowsOutput;
    deleteManyBulkChargeCardRunItem: AffectedRowsOutput;
    deleteManyBundle: AffectedRowsOutput;
    deleteManyBundleToHrt: AffectedRowsOutput;
    deleteManyBusinessHour: AffectedRowsOutput;
    deleteManyCandidateTreatment: AffectedRowsOutput;
    deleteManyCardAuthorization: AffectedRowsOutput;
    deleteManyCardAuthorizationAuditLog: AffectedRowsOutput;
    deleteManyCashPrice: AffectedRowsOutput;
    deleteManyCharge: AffectedRowsOutput;
    deleteManyChargeAuditLog: AffectedRowsOutput;
    deleteManyChargeReattributionAndPartialPaymentLog: AffectedRowsOutput;
    deleteManyChargeReattributionLog: AffectedRowsOutput;
    deleteManyCheckNetworkStatusResults: AffectedRowsOutput;
    deleteManyCheckoutAdjudication: AffectedRowsOutput;
    deleteManyClaimToBoughtTreatment: AffectedRowsOutput;
    deleteManyConfigCommit: AffectedRowsOutput;
    deleteManyConfigFlag: AffectedRowsOutput;
    deleteManyConfigSession: AffectedRowsOutput;
    deleteManyConsentForm: AffectedRowsOutput;
    deleteManyConsumer: AffectedRowsOutput;
    deleteManyConsumerAuditLog: AffectedRowsOutput;
    deleteManyConsumerMessage: AffectedRowsOutput;
    deleteManyConsumerNote: AffectedRowsOutput;
    deleteManyConsumerPhotoMetaData: AffectedRowsOutput;
    deleteManyConsumerSrtRecords: AffectedRowsOutput;
    deleteManyContract: AffectedRowsOutput;
    deleteManyContractAuditLog: AffectedRowsOutput;
    deleteManyCoverageResponses: AffectedRowsOutput;
    deleteManyCptExclusivityEdge: AffectedRowsOutput;
    deleteManyCustomField: AffectedRowsOutput;
    deleteManyCustomFieldValue: AffectedRowsOutput;
    deleteManyDataMigrations: AffectedRowsOutput;
    deleteManyDefaultPractice: AffectedRowsOutput;
    deleteManyDefault_providers: AffectedRowsOutput;
    deleteManyDeploymentOrgPhase: AffectedRowsOutput;
    deleteManyDeploymentOrgTask: AffectedRowsOutput;
    deleteManyDeploymentOrgTaskDependency: AffectedRowsOutput;
    deleteManyDeploymentPhase: AffectedRowsOutput;
    deleteManyDeploymentTask: AffectedRowsOutput;
    deleteManyDeploymentTaskDependency: AffectedRowsOutput;
    deleteManyDeploymentTeam: AffectedRowsOutput;
    deleteManyDiscountCodes: AffectedRowsOutput;
    deleteManyEcwPayerAlias: AffectedRowsOutput;
    deleteManyEcwPayerStc: AffectedRowsOutput;
    deleteManyEhrAppointmentTypeIdToName: AffectedRowsOutput;
    deleteManyEhrPaymentDescriptor: AffectedRowsOutput;
    deleteManyEhrPaymentDescriptorAuditLog: AffectedRowsOutput;
    deleteManyEhrPaymentDirectionSsAsset: AffectedRowsOutput;
    deleteManyEhrPostDetail: AffectedRowsOutput;
    deleteManyEhrPostDetailToPayout: AffectedRowsOutput;
    deleteManyEhrPostLedger: AffectedRowsOutput;
    deleteManyEhrPostLedgerAuditLog: AffectedRowsOutput;
    deleteManyEhrPostLedgerToPayout: AffectedRowsOutput;
    deleteManyEhrPrimaryCareProvider: AffectedRowsOutput;
    deleteManyEhrProviderMapping: AffectedRowsOutput;
    deleteManyEhrSlot: AffectedRowsOutput;
    deleteManyEhrSlotAuditLog: AffectedRowsOutput;
    deleteManyEncounter: AffectedRowsOutput;
    deleteManyExperityEncounter: AffectedRowsOutput;
    deleteManyFaqDropdowns: AffectedRowsOutput;
    deleteManyFeeConfig: AffectedRowsOutput;
    deleteManyFeeConfigAuditLog: AffectedRowsOutput;
    deleteManyGuarantorPaymentLinkContext: AffectedRowsOutput;
    deleteManyHoliday: AffectedRowsOutput;
    deleteManyHrt: AffectedRowsOutput;
    deleteManyHrtFlags: AffectedRowsOutput;
    deleteManyHrtPaymentType: AffectedRowsOutput;
    deleteManyHrtToSrt: AffectedRowsOutput;
    deleteManyHrtTranslation: AffectedRowsOutput;
    deleteManyInboundRequestLog: AffectedRowsOutput;
    deleteManyInboundTextMessageLog: AffectedRowsOutput;
    deleteManyInsurance: AffectedRowsOutput;
    deleteManyInsuranceAuditLog: AffectedRowsOutput;
    deleteManyInsuranceMetadata: AffectedRowsOutput;
    deleteManyIntakeForm: AffectedRowsOutput;
    deleteManyIntakeFormSection: AffectedRowsOutput;
    deleteManyIntakeFormSectionTranslation: AffectedRowsOutput;
    deleteManyIntakeFormToQuestion: AffectedRowsOutput;
    deleteManyIntakeQuestion: AffectedRowsOutput;
    deleteManyIntakeQuestionTranslation: AffectedRowsOutput;
    deleteManyInvoiceDailyLineItems: AffectedRowsOutput;
    deleteManyInvoices: AffectedRowsOutput;
    deleteManyKeywordRule: AffectedRowsOutput;
    deleteManyLinkMapping: AffectedRowsOutput;
    deleteManyLiveTransfers: AffectedRowsOutput;
    deleteManyMcmsAssociation: AffectedRowsOutput;
    deleteManyMcmsAssociationAuditLog: AffectedRowsOutput;
    deleteManyMcmsAssociationClaim: AffectedRowsOutput;
    deleteManyMcmsAssociationClaimAuditLog: AffectedRowsOutput;
    deleteManyMcmsAssociationSlot: AffectedRowsOutput;
    deleteManyMcmsAssociationSlotAuditLog: AffectedRowsOutput;
    deleteManyMessageBlueprint: AffectedRowsOutput;
    deleteManyMessageConsolidationContext: AffectedRowsOutput;
    deleteManyMessageConsolidationTemplate: AffectedRowsOutput;
    deleteManyMessageNudge: AffectedRowsOutput;
    deleteManyMessageOrchestrationRule: AffectedRowsOutput;
    deleteManyMessagePayAfter: AffectedRowsOutput;
    deleteManyMessageSettingsHrt: AffectedRowsOutput;
    deleteManyMessageSettingsOrg: AffectedRowsOutput;
    deleteManyMessageTemplateHrt: AffectedRowsOutput;
    deleteManyMessageTemplateOrg: AffectedRowsOutput;
    deleteManyMigratedEncounter: AffectedRowsOutput;
    deleteManyMigrations: AffectedRowsOutput;
    deleteManyNetworkValidation: AffectedRowsOutput;
    deleteManyNetwork_plan_exceptions: AffectedRowsOutput;
    deleteManyNonCardRefunds: AffectedRowsOutput;
    deleteManyOrgConfigFlag: AffectedRowsOutput;
    deleteManyOrgHrtSrtRule: AffectedRowsOutput;
    deleteManyOrgNetworkResults: AffectedRowsOutput;
    deleteManyOrgOverrideRule: AffectedRowsOutput;
    deleteManyOrg_fees: AffectedRowsOutput;
    deleteManyOrg_stripe_mapping: AffectedRowsOutput;
    deleteManyOrganization: AffectedRowsOutput;
    deleteManyOrganizationAssets: AffectedRowsOutput;
    deleteManyOrganizationTranslation: AffectedRowsOutput;
    deleteManyPayLaterAuthorization: AffectedRowsOutput;
    deleteManyPayLaterAuthorizationAuditLog: AffectedRowsOutput;
    deleteManyPayer: AffectedRowsOutput;
    deleteManyPayerPlanMapping: AffectedRowsOutput;
    deleteManyPayerToEhrInsurancePackageMapping: AffectedRowsOutput;
    deleteManyPaymentAuthorization: AffectedRowsOutput;
    deleteManyPaymentAuthorizationAuditLog: AffectedRowsOutput;
    deleteManyPaymentContract: AffectedRowsOutput;
    deleteManyPaymentPlan: AffectedRowsOutput;
    deleteManyPaymentPlanAdjustment: AffectedRowsOutput;
    deleteManyPaymentPlanAdjustmentAuditLog: AffectedRowsOutput;
    deleteManyPaymentPlanAuditLog: AffectedRowsOutput;
    deleteManyPaymentPlanAutoCharge: AffectedRowsOutput;
    deleteManyPaymentPlanAutoChargeAuditLog: AffectedRowsOutput;
    deleteManyPaymentPlanBoughtTreatment: AffectedRowsOutput;
    deleteManyPaymentPlanBoughtTreatmentAuditLog: AffectedRowsOutput;
    deleteManyPaymentPlanOrgConfig: AffectedRowsOutput;
    deleteManyPaymentPlanOrgConfigAuditLog: AffectedRowsOutput;
    deleteManyPayout: AffectedRowsOutput;
    deleteManyPayoutAuditLog: AffectedRowsOutput;
    deleteManyPendingVoidPayoutReversal: AffectedRowsOutput;
    deleteManyPhoneNumberType: AffectedRowsOutput;
    deleteManyPlaceOfServiceCode: AffectedRowsOutput;
    deleteManyPractice: AffectedRowsOutput;
    deleteManyPracticeConfiguration: AffectedRowsOutput;
    deleteManyPracticeHours: AffectedRowsOutput;
    deleteManyPracticeHoursOverrides: AffectedRowsOutput;
    deleteManyPricedTreatment: AffectedRowsOutput;
    deleteManyPricingAttempt: AffectedRowsOutput;
    deleteManyPricingEscalator: AffectedRowsOutput;
    deleteManyPricingQueue: AffectedRowsOutput;
    deleteManyPricingResults: AffectedRowsOutput;
    deleteManyProcedureBenefitParsingRules: AffectedRowsOutput;
    deleteManyProductCategories: AffectedRowsOutput;
    deleteManyProductCategoryTranslation: AffectedRowsOutput;
    deleteManyProductToBundle: AffectedRowsOutput;
    deleteManyProductToHrt: AffectedRowsOutput;
    deleteManyProductTranslation: AffectedRowsOutput;
    deleteManyProducts: AffectedRowsOutput;
    deleteManyProvider: AffectedRowsOutput;
    deleteManyProviderCredentialing: AffectedRowsOutput;
    deleteManyProviderGroup: AffectedRowsOutput;
    deleteManyProviderGroupToHrt: AffectedRowsOutput;
    deleteManyProviderHrtMaxCount: AffectedRowsOutput;
    deleteManyProviderTaxonomy: AffectedRowsOutput;
    deleteManyProviderToOrg: AffectedRowsOutput;
    deleteManyProviderToProviderGroup: AffectedRowsOutput;
    deleteManyReattributionDirection: AffectedRowsOutput;
    deleteManyReceiptArrangement: AffectedRowsOutput;
    deleteManyReservedEhrVisit: AffectedRowsOutput;
    deleteManyResetToken: AffectedRowsOutput;
    deleteManySavedIntakeResponse: AffectedRowsOutput;
    deleteManySchedulingSlotConfig: AffectedRowsOutput;
    deleteManyServiceTypeCode: AffectedRowsOutput;
    deleteManySlot: AffectedRowsOutput;
    deleteManySlotAuditLog: AffectedRowsOutput;
    deleteManySrt: AffectedRowsOutput;
    deleteManySrtFlags: AffectedRowsOutput;
    deleteManySrtMultiplierRule: AffectedRowsOutput;
    deleteManySrtToBillingCode: AffectedRowsOutput;
    deleteManyStatePayerMapping: AffectedRowsOutput;
    deleteManySuperscriptFeeLineItem: AffectedRowsOutput;
    deleteManySuperscriptFees: AffectedRowsOutput;
    deleteManySuperscriptIntakeQuestion: AffectedRowsOutput;
    deleteManyTimeBlock: AffectedRowsOutput;
    deleteManyTransaction: AffectedRowsOutput;
    deleteManyUser: AffectedRowsOutput;
    deleteManyUserAuditLog: AffectedRowsOutput;
    deleteManyUserPracticeVisit: AffectedRowsOutput;
    deleteManyUserToNewUser: AffectedRowsOutput;
    deleteManyValidPayers: AffectedRowsOutput;
    deleteOneALEConfig?: Maybe<AleConfig>;
    deleteOneALEDepartmentGoLive?: Maybe<AleDepartmentGoLive>;
    deleteOneAdjudication?: Maybe<Adjudication>;
    deleteOneAdjudicationAuditLog?: Maybe<AdjudicationAuditLog>;
    deleteOneAdjustment?: Maybe<Adjustment>;
    deleteOneAdjustmentAuditLog?: Maybe<AdjustmentAuditLog>;
    deleteOneAdmin?: Maybe<Admin>;
    deleteOneAdminInteraction?: Maybe<AdminInteraction>;
    deleteOneAppointment?: Maybe<Appointment>;
    deleteOneAppointmentAuditLog?: Maybe<AppointmentAuditLog>;
    deleteOneArrearBilling?: Maybe<ArrearBilling>;
    deleteOneArtClaim?: Maybe<ArtClaim>;
    deleteOneArtClaimAuditLog?: Maybe<ArtClaimAuditLog>;
    deleteOneArtClaimCptLine?: Maybe<ArtClaimCptLine>;
    deleteOneArtClaimCptLineAuditLog?: Maybe<ArtClaimCptLineAuditLog>;
    deleteOneArtOrgConfig?: Maybe<ArtOrgConfig>;
    deleteOneArtPracticeConfig?: Maybe<ArtPracticeConfig>;
    deleteOneAthenaMedications?: Maybe<AthenaMedications>;
    deleteOneAthenaPharmacy?: Maybe<AthenaPharmacy>;
    deleteOneAthenaProvider?: Maybe<AthenaProvider>;
    deleteOneBenefitParsingRules?: Maybe<BenefitParsingRules>;
    deleteOneBillingCode?: Maybe<BillingCode>;
    deleteOneBillingTableDownloadRequest?: Maybe<BillingTableDownloadRequest>;
    deleteOneBoughtTreatment?: Maybe<BoughtTreatment>;
    deleteOneBoughtTreatmentAuditLog?: Maybe<BoughtTreatmentAuditLog>;
    deleteOneBoughtTreatmentClaimDetail?: Maybe<BoughtTreatmentClaimDetail>;
    deleteOneBulkChargeCardRun?: Maybe<BulkChargeCardRun>;
    deleteOneBulkChargeCardRunItem?: Maybe<BulkChargeCardRunItem>;
    deleteOneBundle?: Maybe<Bundle>;
    deleteOneBundleToHrt?: Maybe<BundleToHrt>;
    deleteOneBusinessHour?: Maybe<BusinessHour>;
    deleteOneCandidateTreatment?: Maybe<CandidateTreatment>;
    deleteOneCardAuthorization?: Maybe<CardAuthorization>;
    deleteOneCardAuthorizationAuditLog?: Maybe<CardAuthorizationAuditLog>;
    deleteOneCashPrice?: Maybe<CashPrice>;
    deleteOneCharge?: Maybe<Charge>;
    deleteOneChargeAuditLog?: Maybe<ChargeAuditLog>;
    deleteOneChargeReattributionAndPartialPaymentLog?: Maybe<ChargeReattributionAndPartialPaymentLog>;
    deleteOneChargeReattributionLog?: Maybe<ChargeReattributionLog>;
    deleteOneCheckNetworkStatusResults?: Maybe<CheckNetworkStatusResults>;
    deleteOneCheckoutAdjudication?: Maybe<CheckoutAdjudication>;
    deleteOneClaimToBoughtTreatment?: Maybe<ClaimToBoughtTreatment>;
    deleteOneConfigCommit?: Maybe<ConfigCommit>;
    deleteOneConfigFlag?: Maybe<ConfigFlag>;
    deleteOneConfigSession?: Maybe<ConfigSession>;
    deleteOneConsentForm?: Maybe<ConsentForm>;
    deleteOneConsumer?: Maybe<Consumer>;
    deleteOneConsumerAuditLog?: Maybe<ConsumerAuditLog>;
    deleteOneConsumerMessage?: Maybe<ConsumerMessage>;
    deleteOneConsumerNote?: Maybe<ConsumerNote>;
    deleteOneConsumerPhotoMetaData?: Maybe<ConsumerPhotoMetaData>;
    deleteOneConsumerSrtRecords?: Maybe<ConsumerSrtRecords>;
    deleteOneContract?: Maybe<Contract>;
    deleteOneContractAuditLog?: Maybe<ContractAuditLog>;
    deleteOneCoverageResponses?: Maybe<CoverageResponses>;
    deleteOneCptExclusivityEdge?: Maybe<CptExclusivityEdge>;
    deleteOneCustomField?: Maybe<CustomField>;
    deleteOneCustomFieldValue?: Maybe<CustomFieldValue>;
    deleteOneDataMigrations?: Maybe<DataMigrations>;
    deleteOneDefaultPractice?: Maybe<DefaultPractice>;
    deleteOneDefault_providers?: Maybe<DefaultProviders>;
    deleteOneDeploymentOrgPhase?: Maybe<DeploymentOrgPhase>;
    deleteOneDeploymentOrgTask?: Maybe<DeploymentOrgTask>;
    deleteOneDeploymentOrgTaskDependency?: Maybe<DeploymentOrgTaskDependency>;
    deleteOneDeploymentPhase?: Maybe<DeploymentPhase>;
    deleteOneDeploymentTask?: Maybe<DeploymentTask>;
    deleteOneDeploymentTaskDependency?: Maybe<DeploymentTaskDependency>;
    deleteOneDeploymentTeam?: Maybe<DeploymentTeam>;
    deleteOneDiscountCodes?: Maybe<DiscountCodes>;
    deleteOneEcwPayerAlias?: Maybe<EcwPayerAlias>;
    deleteOneEcwPayerStc?: Maybe<EcwPayerStc>;
    deleteOneEhrAppointmentTypeIdToName?: Maybe<EhrAppointmentTypeIdToName>;
    deleteOneEhrPaymentDescriptor?: Maybe<EhrPaymentDescriptor>;
    deleteOneEhrPaymentDescriptorAuditLog?: Maybe<EhrPaymentDescriptorAuditLog>;
    deleteOneEhrPaymentDirectionSsAsset?: Maybe<EhrPaymentDirectionSsAsset>;
    deleteOneEhrPostDetail?: Maybe<EhrPostDetail>;
    deleteOneEhrPostDetailToPayout?: Maybe<EhrPostDetailToPayout>;
    deleteOneEhrPostLedger?: Maybe<EhrPostLedger>;
    deleteOneEhrPostLedgerAuditLog?: Maybe<EhrPostLedgerAuditLog>;
    deleteOneEhrPostLedgerToPayout?: Maybe<EhrPostLedgerToPayout>;
    deleteOneEhrPrimaryCareProvider?: Maybe<EhrPrimaryCareProvider>;
    deleteOneEhrProviderMapping?: Maybe<EhrProviderMapping>;
    deleteOneEhrSlot?: Maybe<EhrSlot>;
    deleteOneEhrSlotAuditLog?: Maybe<EhrSlotAuditLog>;
    deleteOneEncounter?: Maybe<Encounter>;
    deleteOneExperityEncounter?: Maybe<ExperityEncounter>;
    deleteOneFaqDropdowns?: Maybe<FaqDropdowns>;
    deleteOneFeeConfig?: Maybe<FeeConfig>;
    deleteOneFeeConfigAuditLog?: Maybe<FeeConfigAuditLog>;
    deleteOneGuarantorPaymentLinkContext?: Maybe<GuarantorPaymentLinkContext>;
    deleteOneHoliday?: Maybe<Holiday>;
    deleteOneHrt?: Maybe<Hrt>;
    deleteOneHrtFlags?: Maybe<HrtFlags>;
    deleteOneHrtPaymentType?: Maybe<HrtPaymentType>;
    deleteOneHrtToSrt?: Maybe<HrtToSrt>;
    deleteOneHrtTranslation?: Maybe<HrtTranslation>;
    deleteOneInboundRequestLog?: Maybe<InboundRequestLog>;
    deleteOneInboundTextMessageLog?: Maybe<InboundTextMessageLog>;
    deleteOneInsurance?: Maybe<Insurance>;
    deleteOneInsuranceAuditLog?: Maybe<InsuranceAuditLog>;
    deleteOneInsuranceMetadata?: Maybe<InsuranceMetadata>;
    deleteOneIntakeForm?: Maybe<IntakeForm>;
    deleteOneIntakeFormSection?: Maybe<IntakeFormSection>;
    deleteOneIntakeFormSectionTranslation?: Maybe<IntakeFormSectionTranslation>;
    deleteOneIntakeFormToQuestion?: Maybe<IntakeFormToQuestion>;
    deleteOneIntakeQuestion?: Maybe<IntakeQuestion>;
    deleteOneIntakeQuestionTranslation?: Maybe<IntakeQuestionTranslation>;
    deleteOneInvoiceDailyLineItems?: Maybe<InvoiceDailyLineItems>;
    deleteOneInvoices?: Maybe<Invoices>;
    deleteOneKeywordRule?: Maybe<KeywordRule>;
    deleteOneLinkMapping?: Maybe<LinkMapping>;
    deleteOneLiveTransfers?: Maybe<LiveTransfers>;
    deleteOneMcmsAssociation?: Maybe<McmsAssociation>;
    deleteOneMcmsAssociationAuditLog?: Maybe<McmsAssociationAuditLog>;
    deleteOneMcmsAssociationClaim?: Maybe<McmsAssociationClaim>;
    deleteOneMcmsAssociationClaimAuditLog?: Maybe<McmsAssociationClaimAuditLog>;
    deleteOneMcmsAssociationSlot?: Maybe<McmsAssociationSlot>;
    deleteOneMcmsAssociationSlotAuditLog?: Maybe<McmsAssociationSlotAuditLog>;
    deleteOneMessageBlueprint?: Maybe<MessageBlueprint>;
    deleteOneMessageConsolidationContext?: Maybe<MessageConsolidationContext>;
    deleteOneMessageConsolidationTemplate?: Maybe<MessageConsolidationTemplate>;
    deleteOneMessageNudge?: Maybe<MessageNudge>;
    deleteOneMessageOrchestrationRule?: Maybe<MessageOrchestrationRule>;
    deleteOneMessagePayAfter?: Maybe<MessagePayAfter>;
    deleteOneMessageSettingsHrt?: Maybe<MessageSettingsHrt>;
    deleteOneMessageSettingsOrg?: Maybe<MessageSettingsOrg>;
    deleteOneMessageTemplateHrt?: Maybe<MessageTemplateHrt>;
    deleteOneMessageTemplateOrg?: Maybe<MessageTemplateOrg>;
    deleteOneMigratedEncounter?: Maybe<MigratedEncounter>;
    deleteOneMigrations?: Maybe<Migrations>;
    deleteOneNetworkValidation?: Maybe<NetworkValidation>;
    deleteOneNetwork_plan_exceptions?: Maybe<NetworkPlanExceptions>;
    deleteOneNonCardRefunds?: Maybe<NonCardRefunds>;
    deleteOneOrgConfigFlag?: Maybe<OrgConfigFlag>;
    deleteOneOrgHrtSrtRule?: Maybe<OrgHrtSrtRule>;
    deleteOneOrgNetworkResults?: Maybe<OrgNetworkResults>;
    deleteOneOrgOverrideRule?: Maybe<OrgOverrideRule>;
    deleteOneOrg_fees?: Maybe<OrgFees>;
    deleteOneOrg_stripe_mapping?: Maybe<OrgStripeMapping>;
    deleteOneOrganization?: Maybe<Organization>;
    deleteOneOrganizationAssets?: Maybe<OrganizationAssets>;
    deleteOneOrganizationTranslation?: Maybe<OrganizationTranslation>;
    deleteOnePayLaterAuthorization?: Maybe<PayLaterAuthorization>;
    deleteOnePayLaterAuthorizationAuditLog?: Maybe<PayLaterAuthorizationAuditLog>;
    deleteOnePayer?: Maybe<Payer>;
    deleteOnePayerPlanMapping?: Maybe<PayerPlanMapping>;
    deleteOnePayerToEhrInsurancePackageMapping?: Maybe<PayerToEhrInsurancePackageMapping>;
    deleteOnePaymentAuthorization?: Maybe<PaymentAuthorization>;
    deleteOnePaymentAuthorizationAuditLog?: Maybe<PaymentAuthorizationAuditLog>;
    deleteOnePaymentContract?: Maybe<PaymentContract>;
    deleteOnePaymentPlan?: Maybe<PaymentPlan>;
    deleteOnePaymentPlanAdjustment?: Maybe<PaymentPlanAdjustment>;
    deleteOnePaymentPlanAdjustmentAuditLog?: Maybe<PaymentPlanAdjustmentAuditLog>;
    deleteOnePaymentPlanAuditLog?: Maybe<PaymentPlanAuditLog>;
    deleteOnePaymentPlanAutoCharge?: Maybe<PaymentPlanAutoCharge>;
    deleteOnePaymentPlanAutoChargeAuditLog?: Maybe<PaymentPlanAutoChargeAuditLog>;
    deleteOnePaymentPlanBoughtTreatment?: Maybe<PaymentPlanBoughtTreatment>;
    deleteOnePaymentPlanBoughtTreatmentAuditLog?: Maybe<PaymentPlanBoughtTreatmentAuditLog>;
    deleteOnePaymentPlanOrgConfig?: Maybe<PaymentPlanOrgConfig>;
    deleteOnePaymentPlanOrgConfigAuditLog?: Maybe<PaymentPlanOrgConfigAuditLog>;
    deleteOnePayout?: Maybe<Payout>;
    deleteOnePayoutAuditLog?: Maybe<PayoutAuditLog>;
    deleteOnePendingVoidPayoutReversal?: Maybe<PendingVoidPayoutReversal>;
    deleteOnePhoneNumberType?: Maybe<PhoneNumberType>;
    deleteOnePlaceOfServiceCode?: Maybe<PlaceOfServiceCode>;
    deleteOnePractice?: Maybe<Practice>;
    deleteOnePracticeConfiguration?: Maybe<PracticeConfiguration>;
    deleteOnePracticeHours?: Maybe<PracticeHours>;
    deleteOnePracticeHoursOverrides?: Maybe<PracticeHoursOverrides>;
    deleteOnePricedTreatment?: Maybe<PricedTreatment>;
    deleteOnePricingAttempt?: Maybe<PricingAttempt>;
    deleteOnePricingEscalator?: Maybe<PricingEscalator>;
    deleteOnePricingQueue?: Maybe<PricingQueue>;
    deleteOnePricingResults?: Maybe<PricingResults>;
    deleteOneProcedureBenefitParsingRules?: Maybe<ProcedureBenefitParsingRules>;
    deleteOneProductCategories?: Maybe<ProductCategories>;
    deleteOneProductCategoryTranslation?: Maybe<ProductCategoryTranslation>;
    deleteOneProductToBundle?: Maybe<ProductToBundle>;
    deleteOneProductToHrt?: Maybe<ProductToHrt>;
    deleteOneProductTranslation?: Maybe<ProductTranslation>;
    deleteOneProducts?: Maybe<Products>;
    deleteOneProvider?: Maybe<Provider>;
    deleteOneProviderCredentialing?: Maybe<ProviderCredentialing>;
    deleteOneProviderGroup?: Maybe<ProviderGroup>;
    deleteOneProviderGroupToHrt?: Maybe<ProviderGroupToHrt>;
    deleteOneProviderHrtMaxCount?: Maybe<ProviderHrtMaxCount>;
    deleteOneProviderTaxonomy?: Maybe<ProviderTaxonomy>;
    deleteOneProviderToOrg?: Maybe<ProviderToOrg>;
    deleteOneProviderToProviderGroup?: Maybe<ProviderToProviderGroup>;
    deleteOneReattributionDirection?: Maybe<ReattributionDirection>;
    deleteOneReceiptArrangement?: Maybe<ReceiptArrangement>;
    deleteOneReservedEhrVisit?: Maybe<ReservedEhrVisit>;
    deleteOneResetToken?: Maybe<ResetToken>;
    deleteOneSavedIntakeResponse?: Maybe<SavedIntakeResponse>;
    deleteOneSchedulingSlotConfig?: Maybe<SchedulingSlotConfig>;
    deleteOneServiceTypeCode?: Maybe<ServiceTypeCode>;
    deleteOneSlot?: Maybe<Slot>;
    deleteOneSlotAuditLog?: Maybe<SlotAuditLog>;
    deleteOneSrt?: Maybe<Srt>;
    deleteOneSrtFlags?: Maybe<SrtFlags>;
    deleteOneSrtMultiplierRule?: Maybe<SrtMultiplierRule>;
    deleteOneSrtToBillingCode?: Maybe<SrtToBillingCode>;
    deleteOneStatePayerMapping?: Maybe<StatePayerMapping>;
    deleteOneSuperscriptFeeLineItem?: Maybe<SuperscriptFeeLineItem>;
    deleteOneSuperscriptFees?: Maybe<SuperscriptFees>;
    deleteOneSuperscriptIntakeQuestion?: Maybe<SuperscriptIntakeQuestion>;
    deleteOneTimeBlock?: Maybe<TimeBlock>;
    deleteOneTransaction?: Maybe<Transaction>;
    deleteOneUser?: Maybe<User>;
    deleteOneUserAuditLog?: Maybe<UserAuditLog>;
    deleteOneUserPracticeVisit?: Maybe<UserPracticeVisit>;
    deleteOneUserToNewUser?: Maybe<UserToNewUser>;
    deleteOneValidPayers?: Maybe<ValidPayers>;
    markAppointmentArrived: MarkAppointmentStatusResult;
    markAppointmentUnarrived: MarkAppointmentStatusResult;
    payCharges: Array<Charge>;
    relinkInsurancePhoto: RelinkInsurancePhotoResponse;
    updateConsumerAndEhrPatient: ConsumerUpdateResponse;
    updateInsurance: UpdateInsuranceResponse;
    updateManyALEConfig: AffectedRowsOutput;
    updateManyALEDepartmentGoLive: AffectedRowsOutput;
    updateManyAdjudication: AffectedRowsOutput;
    updateManyAdjudicationAuditLog: AffectedRowsOutput;
    updateManyAdjustment: AffectedRowsOutput;
    updateManyAdjustmentAuditLog: AffectedRowsOutput;
    updateManyAdmin: AffectedRowsOutput;
    updateManyAdminInteraction: AffectedRowsOutput;
    updateManyAppointment: AffectedRowsOutput;
    updateManyAppointmentAuditLog: AffectedRowsOutput;
    updateManyArrearBilling: AffectedRowsOutput;
    updateManyArtClaim: AffectedRowsOutput;
    updateManyArtClaimAuditLog: AffectedRowsOutput;
    updateManyArtClaimCptLine: AffectedRowsOutput;
    updateManyArtClaimCptLineAuditLog: AffectedRowsOutput;
    updateManyArtOrgConfig: AffectedRowsOutput;
    updateManyArtPracticeConfig: AffectedRowsOutput;
    updateManyAthenaMedications: AffectedRowsOutput;
    updateManyAthenaPharmacy: AffectedRowsOutput;
    updateManyAthenaProvider: AffectedRowsOutput;
    updateManyBenefitParsingRules: AffectedRowsOutput;
    updateManyBillingCode: AffectedRowsOutput;
    updateManyBillingTableDownloadRequest: AffectedRowsOutput;
    updateManyBoughtTreatment: AffectedRowsOutput;
    updateManyBoughtTreatmentAuditLog: AffectedRowsOutput;
    updateManyBoughtTreatmentClaimDetail: AffectedRowsOutput;
    updateManyBulkChargeCardRun: AffectedRowsOutput;
    updateManyBulkChargeCardRunItem: AffectedRowsOutput;
    updateManyBundle: AffectedRowsOutput;
    updateManyBundleToHrt: AffectedRowsOutput;
    updateManyBusinessHour: AffectedRowsOutput;
    updateManyCandidateTreatment: AffectedRowsOutput;
    updateManyCardAuthorization: AffectedRowsOutput;
    updateManyCardAuthorizationAuditLog: AffectedRowsOutput;
    updateManyCashPrice: AffectedRowsOutput;
    updateManyCharge: AffectedRowsOutput;
    updateManyChargeAuditLog: AffectedRowsOutput;
    updateManyChargeReattributionAndPartialPaymentLog: AffectedRowsOutput;
    updateManyChargeReattributionLog: AffectedRowsOutput;
    updateManyCheckNetworkStatusResults: AffectedRowsOutput;
    updateManyCheckoutAdjudication: AffectedRowsOutput;
    updateManyClaimToBoughtTreatment: AffectedRowsOutput;
    updateManyConfigCommit: AffectedRowsOutput;
    updateManyConfigFlag: AffectedRowsOutput;
    updateManyConfigSession: AffectedRowsOutput;
    updateManyConsentForm: AffectedRowsOutput;
    updateManyConsumer: AffectedRowsOutput;
    updateManyConsumerAuditLog: AffectedRowsOutput;
    updateManyConsumerMessage: AffectedRowsOutput;
    updateManyConsumerNote: AffectedRowsOutput;
    updateManyConsumerPhotoMetaData: AffectedRowsOutput;
    updateManyConsumerSrtRecords: AffectedRowsOutput;
    updateManyContract: AffectedRowsOutput;
    updateManyContractAuditLog: AffectedRowsOutput;
    updateManyCoverageResponses: AffectedRowsOutput;
    updateManyCptExclusivityEdge: AffectedRowsOutput;
    updateManyCustomField: AffectedRowsOutput;
    updateManyCustomFieldValue: AffectedRowsOutput;
    updateManyDataMigrations: AffectedRowsOutput;
    updateManyDefaultPractice: AffectedRowsOutput;
    updateManyDefault_providers: AffectedRowsOutput;
    updateManyDeploymentOrgPhase: AffectedRowsOutput;
    updateManyDeploymentOrgTask: AffectedRowsOutput;
    updateManyDeploymentOrgTaskDependency: AffectedRowsOutput;
    updateManyDeploymentPhase: AffectedRowsOutput;
    updateManyDeploymentTask: AffectedRowsOutput;
    updateManyDeploymentTaskDependency: AffectedRowsOutput;
    updateManyDeploymentTeam: AffectedRowsOutput;
    updateManyDiscountCodes: AffectedRowsOutput;
    updateManyEcwPayerAlias: AffectedRowsOutput;
    updateManyEcwPayerStc: AffectedRowsOutput;
    updateManyEhrAppointmentTypeIdToName: AffectedRowsOutput;
    updateManyEhrPaymentDescriptor: AffectedRowsOutput;
    updateManyEhrPaymentDescriptorAuditLog: AffectedRowsOutput;
    updateManyEhrPaymentDirectionSsAsset: AffectedRowsOutput;
    updateManyEhrPostDetail: AffectedRowsOutput;
    updateManyEhrPostDetailToPayout: AffectedRowsOutput;
    updateManyEhrPostLedger: AffectedRowsOutput;
    updateManyEhrPostLedgerAuditLog: AffectedRowsOutput;
    updateManyEhrPostLedgerToPayout: AffectedRowsOutput;
    updateManyEhrPrimaryCareProvider: AffectedRowsOutput;
    updateManyEhrProviderMapping: AffectedRowsOutput;
    updateManyEhrSlot: AffectedRowsOutput;
    updateManyEhrSlotAuditLog: AffectedRowsOutput;
    updateManyEncounter: AffectedRowsOutput;
    updateManyExperityEncounter: AffectedRowsOutput;
    updateManyFaqDropdowns: AffectedRowsOutput;
    updateManyFeeConfig: AffectedRowsOutput;
    updateManyFeeConfigAuditLog: AffectedRowsOutput;
    updateManyGuarantorPaymentLinkContext: AffectedRowsOutput;
    updateManyHoliday: AffectedRowsOutput;
    updateManyHrt: AffectedRowsOutput;
    updateManyHrtFlags: AffectedRowsOutput;
    updateManyHrtPaymentType: AffectedRowsOutput;
    updateManyHrtToSrt: AffectedRowsOutput;
    updateManyHrtTranslation: AffectedRowsOutput;
    updateManyInboundRequestLog: AffectedRowsOutput;
    updateManyInboundTextMessageLog: AffectedRowsOutput;
    updateManyInsurance: AffectedRowsOutput;
    updateManyInsuranceAuditLog: AffectedRowsOutput;
    updateManyInsuranceMetadata: AffectedRowsOutput;
    updateManyIntakeForm: AffectedRowsOutput;
    updateManyIntakeFormSection: AffectedRowsOutput;
    updateManyIntakeFormSectionTranslation: AffectedRowsOutput;
    updateManyIntakeFormToQuestion: AffectedRowsOutput;
    updateManyIntakeQuestion: AffectedRowsOutput;
    updateManyIntakeQuestionTranslation: AffectedRowsOutput;
    updateManyInvoiceDailyLineItems: AffectedRowsOutput;
    updateManyInvoices: AffectedRowsOutput;
    updateManyKeywordRule: AffectedRowsOutput;
    updateManyLinkMapping: AffectedRowsOutput;
    updateManyLiveTransfers: AffectedRowsOutput;
    updateManyMcmsAssociation: AffectedRowsOutput;
    updateManyMcmsAssociationAuditLog: AffectedRowsOutput;
    updateManyMcmsAssociationClaim: AffectedRowsOutput;
    updateManyMcmsAssociationClaimAuditLog: AffectedRowsOutput;
    updateManyMcmsAssociationSlot: AffectedRowsOutput;
    updateManyMcmsAssociationSlotAuditLog: AffectedRowsOutput;
    updateManyMessageBlueprint: AffectedRowsOutput;
    updateManyMessageConsolidationContext: AffectedRowsOutput;
    updateManyMessageConsolidationTemplate: AffectedRowsOutput;
    updateManyMessageNudge: AffectedRowsOutput;
    updateManyMessageOrchestrationRule: AffectedRowsOutput;
    updateManyMessagePayAfter: AffectedRowsOutput;
    updateManyMessageSettingsHrt: AffectedRowsOutput;
    updateManyMessageSettingsOrg: AffectedRowsOutput;
    updateManyMessageTemplateHrt: AffectedRowsOutput;
    updateManyMessageTemplateOrg: AffectedRowsOutput;
    updateManyMigratedEncounter: AffectedRowsOutput;
    updateManyMigrations: AffectedRowsOutput;
    updateManyNetworkValidation: AffectedRowsOutput;
    updateManyNetwork_plan_exceptions: AffectedRowsOutput;
    updateManyNonCardRefunds: AffectedRowsOutput;
    updateManyOrgConfigFlag: AffectedRowsOutput;
    updateManyOrgHrtSrtRule: AffectedRowsOutput;
    updateManyOrgNetworkResults: AffectedRowsOutput;
    updateManyOrgOverrideRule: AffectedRowsOutput;
    updateManyOrg_fees: AffectedRowsOutput;
    updateManyOrg_stripe_mapping: AffectedRowsOutput;
    updateManyOrganization: AffectedRowsOutput;
    updateManyOrganizationAssets: AffectedRowsOutput;
    updateManyOrganizationTranslation: AffectedRowsOutput;
    updateManyPayLaterAuthorization: AffectedRowsOutput;
    updateManyPayLaterAuthorizationAuditLog: AffectedRowsOutput;
    updateManyPayer: AffectedRowsOutput;
    updateManyPayerPlanMapping: AffectedRowsOutput;
    updateManyPayerToEhrInsurancePackageMapping: AffectedRowsOutput;
    updateManyPaymentAuthorization: AffectedRowsOutput;
    updateManyPaymentAuthorizationAuditLog: AffectedRowsOutput;
    updateManyPaymentContract: AffectedRowsOutput;
    updateManyPaymentPlan: AffectedRowsOutput;
    updateManyPaymentPlanAdjustment: AffectedRowsOutput;
    updateManyPaymentPlanAdjustmentAuditLog: AffectedRowsOutput;
    updateManyPaymentPlanAuditLog: AffectedRowsOutput;
    updateManyPaymentPlanAutoCharge: AffectedRowsOutput;
    updateManyPaymentPlanAutoChargeAuditLog: AffectedRowsOutput;
    updateManyPaymentPlanBoughtTreatment: AffectedRowsOutput;
    updateManyPaymentPlanBoughtTreatmentAuditLog: AffectedRowsOutput;
    updateManyPaymentPlanOrgConfig: AffectedRowsOutput;
    updateManyPaymentPlanOrgConfigAuditLog: AffectedRowsOutput;
    updateManyPayout: AffectedRowsOutput;
    updateManyPayoutAuditLog: AffectedRowsOutput;
    updateManyPendingVoidPayoutReversal: AffectedRowsOutput;
    updateManyPhoneNumberType: AffectedRowsOutput;
    updateManyPlaceOfServiceCode: AffectedRowsOutput;
    updateManyPractice: AffectedRowsOutput;
    updateManyPracticeConfiguration: AffectedRowsOutput;
    updateManyPracticeHours: AffectedRowsOutput;
    updateManyPracticeHoursOverrides: AffectedRowsOutput;
    updateManyPricedTreatment: AffectedRowsOutput;
    updateManyPricingAttempt: AffectedRowsOutput;
    updateManyPricingEscalator: AffectedRowsOutput;
    updateManyPricingQueue: AffectedRowsOutput;
    updateManyPricingResults: AffectedRowsOutput;
    updateManyProcedureBenefitParsingRules: AffectedRowsOutput;
    updateManyProductCategories: AffectedRowsOutput;
    updateManyProductCategoryTranslation: AffectedRowsOutput;
    updateManyProductToBundle: AffectedRowsOutput;
    updateManyProductToHrt: AffectedRowsOutput;
    updateManyProductTranslation: AffectedRowsOutput;
    updateManyProducts: AffectedRowsOutput;
    updateManyProvider: AffectedRowsOutput;
    updateManyProviderCredentialing: AffectedRowsOutput;
    updateManyProviderGroup: AffectedRowsOutput;
    updateManyProviderGroupToHrt: AffectedRowsOutput;
    updateManyProviderHrtMaxCount: AffectedRowsOutput;
    updateManyProviderTaxonomy: AffectedRowsOutput;
    updateManyProviderToOrg: AffectedRowsOutput;
    updateManyProviderToProviderGroup: AffectedRowsOutput;
    updateManyReattributionDirection: AffectedRowsOutput;
    updateManyReceiptArrangement: AffectedRowsOutput;
    updateManyReservedEhrVisit: AffectedRowsOutput;
    updateManyResetToken: AffectedRowsOutput;
    updateManySavedIntakeResponse: AffectedRowsOutput;
    updateManySchedulingSlotConfig: AffectedRowsOutput;
    updateManyServiceTypeCode: AffectedRowsOutput;
    updateManySlot: AffectedRowsOutput;
    updateManySlotAuditLog: AffectedRowsOutput;
    updateManySrt: AffectedRowsOutput;
    updateManySrtFlags: AffectedRowsOutput;
    updateManySrtMultiplierRule: AffectedRowsOutput;
    updateManySrtToBillingCode: AffectedRowsOutput;
    updateManyStatePayerMapping: AffectedRowsOutput;
    updateManySuperscriptFeeLineItem: AffectedRowsOutput;
    updateManySuperscriptFees: AffectedRowsOutput;
    updateManySuperscriptIntakeQuestion: AffectedRowsOutput;
    updateManyTimeBlock: AffectedRowsOutput;
    updateManyTransaction: AffectedRowsOutput;
    updateManyUser: AffectedRowsOutput;
    updateManyUserAuditLog: AffectedRowsOutput;
    updateManyUserPracticeVisit: AffectedRowsOutput;
    updateManyUserToNewUser: AffectedRowsOutput;
    updateManyValidPayers: AffectedRowsOutput;
    updateOneALEConfig?: Maybe<AleConfig>;
    updateOneALEDepartmentGoLive?: Maybe<AleDepartmentGoLive>;
    updateOneAdjudication?: Maybe<Adjudication>;
    updateOneAdjudicationAuditLog?: Maybe<AdjudicationAuditLog>;
    updateOneAdjustment?: Maybe<Adjustment>;
    updateOneAdjustmentAuditLog?: Maybe<AdjustmentAuditLog>;
    updateOneAdmin?: Maybe<Admin>;
    updateOneAdminInteraction?: Maybe<AdminInteraction>;
    updateOneAppointment?: Maybe<Appointment>;
    updateOneAppointmentAuditLog?: Maybe<AppointmentAuditLog>;
    updateOneArrearBilling?: Maybe<ArrearBilling>;
    updateOneArtClaim?: Maybe<ArtClaim>;
    updateOneArtClaimAuditLog?: Maybe<ArtClaimAuditLog>;
    updateOneArtClaimCptLine?: Maybe<ArtClaimCptLine>;
    updateOneArtClaimCptLineAuditLog?: Maybe<ArtClaimCptLineAuditLog>;
    updateOneArtOrgConfig?: Maybe<ArtOrgConfig>;
    updateOneArtPracticeConfig?: Maybe<ArtPracticeConfig>;
    updateOneAthenaMedications?: Maybe<AthenaMedications>;
    updateOneAthenaPharmacy?: Maybe<AthenaPharmacy>;
    updateOneAthenaProvider?: Maybe<AthenaProvider>;
    updateOneBenefitParsingRules?: Maybe<BenefitParsingRules>;
    updateOneBillingCode?: Maybe<BillingCode>;
    updateOneBillingTableDownloadRequest?: Maybe<BillingTableDownloadRequest>;
    updateOneBoughtTreatment?: Maybe<BoughtTreatment>;
    updateOneBoughtTreatmentAuditLog?: Maybe<BoughtTreatmentAuditLog>;
    updateOneBoughtTreatmentClaimDetail?: Maybe<BoughtTreatmentClaimDetail>;
    updateOneBulkChargeCardRun?: Maybe<BulkChargeCardRun>;
    updateOneBulkChargeCardRunItem?: Maybe<BulkChargeCardRunItem>;
    updateOneBundle?: Maybe<Bundle>;
    updateOneBundleToHrt?: Maybe<BundleToHrt>;
    updateOneBusinessHour?: Maybe<BusinessHour>;
    updateOneCandidateTreatment?: Maybe<CandidateTreatment>;
    updateOneCardAuthorization?: Maybe<CardAuthorization>;
    updateOneCardAuthorizationAuditLog?: Maybe<CardAuthorizationAuditLog>;
    updateOneCashPrice?: Maybe<CashPrice>;
    updateOneCharge?: Maybe<Charge>;
    updateOneChargeAuditLog?: Maybe<ChargeAuditLog>;
    updateOneChargeReattributionAndPartialPaymentLog?: Maybe<ChargeReattributionAndPartialPaymentLog>;
    updateOneChargeReattributionLog?: Maybe<ChargeReattributionLog>;
    updateOneCheckNetworkStatusResults?: Maybe<CheckNetworkStatusResults>;
    updateOneCheckoutAdjudication?: Maybe<CheckoutAdjudication>;
    updateOneClaimToBoughtTreatment?: Maybe<ClaimToBoughtTreatment>;
    updateOneConfigCommit?: Maybe<ConfigCommit>;
    updateOneConfigFlag?: Maybe<ConfigFlag>;
    updateOneConfigSession?: Maybe<ConfigSession>;
    updateOneConsentForm?: Maybe<ConsentForm>;
    updateOneConsumer?: Maybe<Consumer>;
    updateOneConsumerAuditLog?: Maybe<ConsumerAuditLog>;
    updateOneConsumerMessage?: Maybe<ConsumerMessage>;
    updateOneConsumerNote?: Maybe<ConsumerNote>;
    updateOneConsumerPhotoMetaData?: Maybe<ConsumerPhotoMetaData>;
    updateOneConsumerSrtRecords?: Maybe<ConsumerSrtRecords>;
    updateOneContract?: Maybe<Contract>;
    updateOneContractAuditLog?: Maybe<ContractAuditLog>;
    updateOneCoverageResponses?: Maybe<CoverageResponses>;
    updateOneCptExclusivityEdge?: Maybe<CptExclusivityEdge>;
    updateOneCustomField?: Maybe<CustomField>;
    updateOneCustomFieldValue?: Maybe<CustomFieldValue>;
    updateOneDataMigrations?: Maybe<DataMigrations>;
    updateOneDefaultPractice?: Maybe<DefaultPractice>;
    updateOneDefault_providers?: Maybe<DefaultProviders>;
    updateOneDeploymentOrgPhase?: Maybe<DeploymentOrgPhase>;
    updateOneDeploymentOrgTask?: Maybe<DeploymentOrgTask>;
    updateOneDeploymentOrgTaskDependency?: Maybe<DeploymentOrgTaskDependency>;
    updateOneDeploymentPhase?: Maybe<DeploymentPhase>;
    updateOneDeploymentTask?: Maybe<DeploymentTask>;
    updateOneDeploymentTaskDependency?: Maybe<DeploymentTaskDependency>;
    updateOneDeploymentTeam?: Maybe<DeploymentTeam>;
    updateOneDiscountCodes?: Maybe<DiscountCodes>;
    updateOneEcwPayerAlias?: Maybe<EcwPayerAlias>;
    updateOneEcwPayerStc?: Maybe<EcwPayerStc>;
    updateOneEhrAppointmentTypeIdToName?: Maybe<EhrAppointmentTypeIdToName>;
    updateOneEhrPaymentDescriptor?: Maybe<EhrPaymentDescriptor>;
    updateOneEhrPaymentDescriptorAuditLog?: Maybe<EhrPaymentDescriptorAuditLog>;
    updateOneEhrPaymentDirectionSsAsset?: Maybe<EhrPaymentDirectionSsAsset>;
    updateOneEhrPostDetail?: Maybe<EhrPostDetail>;
    updateOneEhrPostDetailToPayout?: Maybe<EhrPostDetailToPayout>;
    updateOneEhrPostLedger?: Maybe<EhrPostLedger>;
    updateOneEhrPostLedgerAuditLog?: Maybe<EhrPostLedgerAuditLog>;
    updateOneEhrPostLedgerToPayout?: Maybe<EhrPostLedgerToPayout>;
    updateOneEhrPrimaryCareProvider?: Maybe<EhrPrimaryCareProvider>;
    updateOneEhrProviderMapping?: Maybe<EhrProviderMapping>;
    updateOneEhrSlot?: Maybe<EhrSlot>;
    updateOneEhrSlotAuditLog?: Maybe<EhrSlotAuditLog>;
    updateOneEncounter?: Maybe<Encounter>;
    updateOneExperityEncounter?: Maybe<ExperityEncounter>;
    updateOneFaqDropdowns?: Maybe<FaqDropdowns>;
    updateOneFeeConfig?: Maybe<FeeConfig>;
    updateOneFeeConfigAuditLog?: Maybe<FeeConfigAuditLog>;
    updateOneGuarantorPaymentLinkContext?: Maybe<GuarantorPaymentLinkContext>;
    updateOneHoliday?: Maybe<Holiday>;
    updateOneHrt?: Maybe<Hrt>;
    updateOneHrtFlags?: Maybe<HrtFlags>;
    updateOneHrtPaymentType?: Maybe<HrtPaymentType>;
    updateOneHrtToSrt?: Maybe<HrtToSrt>;
    updateOneHrtTranslation?: Maybe<HrtTranslation>;
    updateOneInboundRequestLog?: Maybe<InboundRequestLog>;
    updateOneInboundTextMessageLog?: Maybe<InboundTextMessageLog>;
    updateOneInsurance?: Maybe<Insurance>;
    updateOneInsuranceAuditLog?: Maybe<InsuranceAuditLog>;
    updateOneInsuranceMetadata?: Maybe<InsuranceMetadata>;
    updateOneIntakeForm?: Maybe<IntakeForm>;
    updateOneIntakeFormSection?: Maybe<IntakeFormSection>;
    updateOneIntakeFormSectionTranslation?: Maybe<IntakeFormSectionTranslation>;
    updateOneIntakeFormToQuestion?: Maybe<IntakeFormToQuestion>;
    updateOneIntakeQuestion?: Maybe<IntakeQuestion>;
    updateOneIntakeQuestionTranslation?: Maybe<IntakeQuestionTranslation>;
    updateOneInvoiceDailyLineItems?: Maybe<InvoiceDailyLineItems>;
    updateOneInvoices?: Maybe<Invoices>;
    updateOneKeywordRule?: Maybe<KeywordRule>;
    updateOneLinkMapping?: Maybe<LinkMapping>;
    updateOneLiveTransfers?: Maybe<LiveTransfers>;
    updateOneMcmsAssociation?: Maybe<McmsAssociation>;
    updateOneMcmsAssociationAuditLog?: Maybe<McmsAssociationAuditLog>;
    updateOneMcmsAssociationClaim?: Maybe<McmsAssociationClaim>;
    updateOneMcmsAssociationClaimAuditLog?: Maybe<McmsAssociationClaimAuditLog>;
    updateOneMcmsAssociationSlot?: Maybe<McmsAssociationSlot>;
    updateOneMcmsAssociationSlotAuditLog?: Maybe<McmsAssociationSlotAuditLog>;
    updateOneMessageBlueprint?: Maybe<MessageBlueprint>;
    updateOneMessageConsolidationContext?: Maybe<MessageConsolidationContext>;
    updateOneMessageConsolidationTemplate?: Maybe<MessageConsolidationTemplate>;
    updateOneMessageNudge?: Maybe<MessageNudge>;
    updateOneMessageOrchestrationRule?: Maybe<MessageOrchestrationRule>;
    updateOneMessagePayAfter?: Maybe<MessagePayAfter>;
    updateOneMessageSettingsHrt?: Maybe<MessageSettingsHrt>;
    updateOneMessageSettingsOrg?: Maybe<MessageSettingsOrg>;
    updateOneMessageTemplateHrt?: Maybe<MessageTemplateHrt>;
    updateOneMessageTemplateOrg?: Maybe<MessageTemplateOrg>;
    updateOneMigratedEncounter?: Maybe<MigratedEncounter>;
    updateOneMigrations?: Maybe<Migrations>;
    updateOneNetworkValidation?: Maybe<NetworkValidation>;
    updateOneNetwork_plan_exceptions?: Maybe<NetworkPlanExceptions>;
    updateOneNonCardRefunds?: Maybe<NonCardRefunds>;
    updateOneOrgConfigFlag?: Maybe<OrgConfigFlag>;
    updateOneOrgHrtSrtRule?: Maybe<OrgHrtSrtRule>;
    updateOneOrgNetworkResults?: Maybe<OrgNetworkResults>;
    updateOneOrgOverrideRule?: Maybe<OrgOverrideRule>;
    updateOneOrg_fees?: Maybe<OrgFees>;
    updateOneOrg_stripe_mapping?: Maybe<OrgStripeMapping>;
    updateOneOrganization?: Maybe<Organization>;
    updateOneOrganizationAssets?: Maybe<OrganizationAssets>;
    updateOneOrganizationTranslation?: Maybe<OrganizationTranslation>;
    updateOnePayLaterAuthorization?: Maybe<PayLaterAuthorization>;
    updateOnePayLaterAuthorizationAuditLog?: Maybe<PayLaterAuthorizationAuditLog>;
    updateOnePayer?: Maybe<Payer>;
    updateOnePayerPlanMapping?: Maybe<PayerPlanMapping>;
    updateOnePayerToEhrInsurancePackageMapping?: Maybe<PayerToEhrInsurancePackageMapping>;
    updateOnePaymentAuthorization?: Maybe<PaymentAuthorization>;
    updateOnePaymentAuthorizationAuditLog?: Maybe<PaymentAuthorizationAuditLog>;
    updateOnePaymentContract?: Maybe<PaymentContract>;
    updateOnePaymentPlan?: Maybe<PaymentPlan>;
    updateOnePaymentPlanAdjustment?: Maybe<PaymentPlanAdjustment>;
    updateOnePaymentPlanAdjustmentAuditLog?: Maybe<PaymentPlanAdjustmentAuditLog>;
    updateOnePaymentPlanAuditLog?: Maybe<PaymentPlanAuditLog>;
    updateOnePaymentPlanAutoCharge?: Maybe<PaymentPlanAutoCharge>;
    updateOnePaymentPlanAutoChargeAuditLog?: Maybe<PaymentPlanAutoChargeAuditLog>;
    updateOnePaymentPlanBoughtTreatment?: Maybe<PaymentPlanBoughtTreatment>;
    updateOnePaymentPlanBoughtTreatmentAuditLog?: Maybe<PaymentPlanBoughtTreatmentAuditLog>;
    updateOnePaymentPlanOrgConfig?: Maybe<PaymentPlanOrgConfig>;
    updateOnePaymentPlanOrgConfigAuditLog?: Maybe<PaymentPlanOrgConfigAuditLog>;
    updateOnePayout?: Maybe<Payout>;
    updateOnePayoutAuditLog?: Maybe<PayoutAuditLog>;
    updateOnePendingVoidPayoutReversal?: Maybe<PendingVoidPayoutReversal>;
    updateOnePhoneNumberType?: Maybe<PhoneNumberType>;
    updateOnePlaceOfServiceCode?: Maybe<PlaceOfServiceCode>;
    updateOnePractice?: Maybe<Practice>;
    updateOnePracticeConfiguration?: Maybe<PracticeConfiguration>;
    updateOnePracticeHours?: Maybe<PracticeHours>;
    updateOnePracticeHoursOverrides?: Maybe<PracticeHoursOverrides>;
    updateOnePricedTreatment?: Maybe<PricedTreatment>;
    updateOnePricingAttempt?: Maybe<PricingAttempt>;
    updateOnePricingEscalator?: Maybe<PricingEscalator>;
    updateOnePricingQueue?: Maybe<PricingQueue>;
    updateOnePricingResults?: Maybe<PricingResults>;
    updateOneProcedureBenefitParsingRules?: Maybe<ProcedureBenefitParsingRules>;
    updateOneProductCategories?: Maybe<ProductCategories>;
    updateOneProductCategoryTranslation?: Maybe<ProductCategoryTranslation>;
    updateOneProductToBundle?: Maybe<ProductToBundle>;
    updateOneProductToHrt?: Maybe<ProductToHrt>;
    updateOneProductTranslation?: Maybe<ProductTranslation>;
    updateOneProducts?: Maybe<Products>;
    updateOneProvider?: Maybe<Provider>;
    updateOneProviderCredentialing?: Maybe<ProviderCredentialing>;
    updateOneProviderGroup?: Maybe<ProviderGroup>;
    updateOneProviderGroupToHrt?: Maybe<ProviderGroupToHrt>;
    updateOneProviderHrtMaxCount?: Maybe<ProviderHrtMaxCount>;
    updateOneProviderTaxonomy?: Maybe<ProviderTaxonomy>;
    updateOneProviderToOrg?: Maybe<ProviderToOrg>;
    updateOneProviderToProviderGroup?: Maybe<ProviderToProviderGroup>;
    updateOneReattributionDirection?: Maybe<ReattributionDirection>;
    updateOneReceiptArrangement?: Maybe<ReceiptArrangement>;
    updateOneReservedEhrVisit?: Maybe<ReservedEhrVisit>;
    updateOneResetToken?: Maybe<ResetToken>;
    updateOneSavedIntakeResponse?: Maybe<SavedIntakeResponse>;
    updateOneSchedulingSlotConfig?: Maybe<SchedulingSlotConfig>;
    updateOneServiceTypeCode?: Maybe<ServiceTypeCode>;
    updateOneSlot?: Maybe<Slot>;
    updateOneSlotAuditLog?: Maybe<SlotAuditLog>;
    updateOneSrt?: Maybe<Srt>;
    updateOneSrtFlags?: Maybe<SrtFlags>;
    updateOneSrtMultiplierRule?: Maybe<SrtMultiplierRule>;
    updateOneSrtToBillingCode?: Maybe<SrtToBillingCode>;
    updateOneStatePayerMapping?: Maybe<StatePayerMapping>;
    updateOneSuperscriptFeeLineItem?: Maybe<SuperscriptFeeLineItem>;
    updateOneSuperscriptFees?: Maybe<SuperscriptFees>;
    updateOneSuperscriptIntakeQuestion?: Maybe<SuperscriptIntakeQuestion>;
    updateOneTimeBlock?: Maybe<TimeBlock>;
    updateOneTransaction?: Maybe<Transaction>;
    updateOneUser?: Maybe<User>;
    updateOneUserAuditLog?: Maybe<UserAuditLog>;
    updateOneUserPracticeVisit?: Maybe<UserPracticeVisit>;
    updateOneUserToNewUser?: Maybe<UserToNewUser>;
    updateOneValidPayers?: Maybe<ValidPayers>;
    updateUserAndEhrPatient: UpdateUserResponse;
    upsertOneALEConfig: AleConfig;
    upsertOneALEDepartmentGoLive: AleDepartmentGoLive;
    upsertOneAdjudication: Adjudication;
    upsertOneAdjudicationAuditLog: AdjudicationAuditLog;
    upsertOneAdjustment: Adjustment;
    upsertOneAdjustmentAuditLog: AdjustmentAuditLog;
    upsertOneAdmin: Admin;
    upsertOneAdminInteraction: AdminInteraction;
    upsertOneAppointment: Appointment;
    upsertOneAppointmentAuditLog: AppointmentAuditLog;
    upsertOneArrearBilling: ArrearBilling;
    upsertOneArtClaim: ArtClaim;
    upsertOneArtClaimAuditLog: ArtClaimAuditLog;
    upsertOneArtClaimCptLine: ArtClaimCptLine;
    upsertOneArtClaimCptLineAuditLog: ArtClaimCptLineAuditLog;
    upsertOneArtOrgConfig: ArtOrgConfig;
    upsertOneArtPracticeConfig: ArtPracticeConfig;
    upsertOneAthenaMedications: AthenaMedications;
    upsertOneAthenaPharmacy: AthenaPharmacy;
    upsertOneAthenaProvider: AthenaProvider;
    upsertOneBenefitParsingRules: BenefitParsingRules;
    upsertOneBillingCode: BillingCode;
    upsertOneBillingTableDownloadRequest: BillingTableDownloadRequest;
    upsertOneBoughtTreatment: BoughtTreatment;
    upsertOneBoughtTreatmentAuditLog: BoughtTreatmentAuditLog;
    upsertOneBoughtTreatmentClaimDetail: BoughtTreatmentClaimDetail;
    upsertOneBulkChargeCardRun: BulkChargeCardRun;
    upsertOneBulkChargeCardRunItem: BulkChargeCardRunItem;
    upsertOneBundle: Bundle;
    upsertOneBundleToHrt: BundleToHrt;
    upsertOneBusinessHour: BusinessHour;
    upsertOneCandidateTreatment: CandidateTreatment;
    upsertOneCardAuthorization: CardAuthorization;
    upsertOneCardAuthorizationAuditLog: CardAuthorizationAuditLog;
    upsertOneCashPrice: CashPrice;
    upsertOneCharge: Charge;
    upsertOneChargeAuditLog: ChargeAuditLog;
    upsertOneChargeReattributionAndPartialPaymentLog: ChargeReattributionAndPartialPaymentLog;
    upsertOneChargeReattributionLog: ChargeReattributionLog;
    upsertOneCheckNetworkStatusResults: CheckNetworkStatusResults;
    upsertOneCheckoutAdjudication: CheckoutAdjudication;
    upsertOneClaimToBoughtTreatment: ClaimToBoughtTreatment;
    upsertOneConfigCommit: ConfigCommit;
    upsertOneConfigFlag: ConfigFlag;
    upsertOneConfigSession: ConfigSession;
    upsertOneConsentForm: ConsentForm;
    upsertOneConsumer: Consumer;
    upsertOneConsumerAuditLog: ConsumerAuditLog;
    upsertOneConsumerMessage: ConsumerMessage;
    upsertOneConsumerNote: ConsumerNote;
    upsertOneConsumerPhotoMetaData: ConsumerPhotoMetaData;
    upsertOneConsumerSrtRecords: ConsumerSrtRecords;
    upsertOneContract: Contract;
    upsertOneContractAuditLog: ContractAuditLog;
    upsertOneCoverageResponses: CoverageResponses;
    upsertOneCptExclusivityEdge: CptExclusivityEdge;
    upsertOneCustomField: CustomField;
    upsertOneCustomFieldValue: CustomFieldValue;
    upsertOneDataMigrations: DataMigrations;
    upsertOneDefaultPractice: DefaultPractice;
    upsertOneDefault_providers: DefaultProviders;
    upsertOneDeploymentOrgPhase: DeploymentOrgPhase;
    upsertOneDeploymentOrgTask: DeploymentOrgTask;
    upsertOneDeploymentOrgTaskDependency: DeploymentOrgTaskDependency;
    upsertOneDeploymentPhase: DeploymentPhase;
    upsertOneDeploymentTask: DeploymentTask;
    upsertOneDeploymentTaskDependency: DeploymentTaskDependency;
    upsertOneDeploymentTeam: DeploymentTeam;
    upsertOneDiscountCodes: DiscountCodes;
    upsertOneEcwPayerAlias: EcwPayerAlias;
    upsertOneEcwPayerStc: EcwPayerStc;
    upsertOneEhrAppointmentTypeIdToName: EhrAppointmentTypeIdToName;
    upsertOneEhrPaymentDescriptor: EhrPaymentDescriptor;
    upsertOneEhrPaymentDescriptorAuditLog: EhrPaymentDescriptorAuditLog;
    upsertOneEhrPaymentDirectionSsAsset: EhrPaymentDirectionSsAsset;
    upsertOneEhrPostDetail: EhrPostDetail;
    upsertOneEhrPostDetailToPayout: EhrPostDetailToPayout;
    upsertOneEhrPostLedger: EhrPostLedger;
    upsertOneEhrPostLedgerAuditLog: EhrPostLedgerAuditLog;
    upsertOneEhrPostLedgerToPayout: EhrPostLedgerToPayout;
    upsertOneEhrPrimaryCareProvider: EhrPrimaryCareProvider;
    upsertOneEhrProviderMapping: EhrProviderMapping;
    upsertOneEhrSlot: EhrSlot;
    upsertOneEhrSlotAuditLog: EhrSlotAuditLog;
    upsertOneEncounter: Encounter;
    upsertOneExperityEncounter: ExperityEncounter;
    upsertOneFaqDropdowns: FaqDropdowns;
    upsertOneFeeConfig: FeeConfig;
    upsertOneFeeConfigAuditLog: FeeConfigAuditLog;
    upsertOneGuarantorPaymentLinkContext: GuarantorPaymentLinkContext;
    upsertOneHoliday: Holiday;
    upsertOneHrt: Hrt;
    upsertOneHrtFlags: HrtFlags;
    upsertOneHrtPaymentType: HrtPaymentType;
    upsertOneHrtToSrt: HrtToSrt;
    upsertOneHrtTranslation: HrtTranslation;
    upsertOneInboundRequestLog: InboundRequestLog;
    upsertOneInboundTextMessageLog: InboundTextMessageLog;
    upsertOneInsurance: Insurance;
    upsertOneInsuranceAuditLog: InsuranceAuditLog;
    upsertOneInsuranceMetadata: InsuranceMetadata;
    upsertOneIntakeForm: IntakeForm;
    upsertOneIntakeFormSection: IntakeFormSection;
    upsertOneIntakeFormSectionTranslation: IntakeFormSectionTranslation;
    upsertOneIntakeFormToQuestion: IntakeFormToQuestion;
    upsertOneIntakeQuestion: IntakeQuestion;
    upsertOneIntakeQuestionTranslation: IntakeQuestionTranslation;
    upsertOneInvoiceDailyLineItems: InvoiceDailyLineItems;
    upsertOneInvoices: Invoices;
    upsertOneKeywordRule: KeywordRule;
    upsertOneLinkMapping: LinkMapping;
    upsertOneLiveTransfers: LiveTransfers;
    upsertOneMcmsAssociation: McmsAssociation;
    upsertOneMcmsAssociationAuditLog: McmsAssociationAuditLog;
    upsertOneMcmsAssociationClaim: McmsAssociationClaim;
    upsertOneMcmsAssociationClaimAuditLog: McmsAssociationClaimAuditLog;
    upsertOneMcmsAssociationSlot: McmsAssociationSlot;
    upsertOneMcmsAssociationSlotAuditLog: McmsAssociationSlotAuditLog;
    upsertOneMessageBlueprint: MessageBlueprint;
    upsertOneMessageConsolidationContext: MessageConsolidationContext;
    upsertOneMessageConsolidationTemplate: MessageConsolidationTemplate;
    upsertOneMessageNudge: MessageNudge;
    upsertOneMessageOrchestrationRule: MessageOrchestrationRule;
    upsertOneMessagePayAfter: MessagePayAfter;
    upsertOneMessageSettingsHrt: MessageSettingsHrt;
    upsertOneMessageSettingsOrg: MessageSettingsOrg;
    upsertOneMessageTemplateHrt: MessageTemplateHrt;
    upsertOneMessageTemplateOrg: MessageTemplateOrg;
    upsertOneMigratedEncounter: MigratedEncounter;
    upsertOneMigrations: Migrations;
    upsertOneNetworkValidation: NetworkValidation;
    upsertOneNetwork_plan_exceptions: NetworkPlanExceptions;
    upsertOneNonCardRefunds: NonCardRefunds;
    upsertOneOrgConfigFlag: OrgConfigFlag;
    upsertOneOrgHrtSrtRule: OrgHrtSrtRule;
    upsertOneOrgNetworkResults: OrgNetworkResults;
    upsertOneOrgOverrideRule: OrgOverrideRule;
    upsertOneOrg_fees: OrgFees;
    upsertOneOrg_stripe_mapping: OrgStripeMapping;
    upsertOneOrganization: Organization;
    upsertOneOrganizationAssets: OrganizationAssets;
    upsertOneOrganizationTranslation: OrganizationTranslation;
    upsertOnePayLaterAuthorization: PayLaterAuthorization;
    upsertOnePayLaterAuthorizationAuditLog: PayLaterAuthorizationAuditLog;
    upsertOnePayer: Payer;
    upsertOnePayerPlanMapping: PayerPlanMapping;
    upsertOnePayerToEhrInsurancePackageMapping: PayerToEhrInsurancePackageMapping;
    upsertOnePaymentAuthorization: PaymentAuthorization;
    upsertOnePaymentAuthorizationAuditLog: PaymentAuthorizationAuditLog;
    upsertOnePaymentContract: PaymentContract;
    upsertOnePaymentPlan: PaymentPlan;
    upsertOnePaymentPlanAdjustment: PaymentPlanAdjustment;
    upsertOnePaymentPlanAdjustmentAuditLog: PaymentPlanAdjustmentAuditLog;
    upsertOnePaymentPlanAuditLog: PaymentPlanAuditLog;
    upsertOnePaymentPlanAutoCharge: PaymentPlanAutoCharge;
    upsertOnePaymentPlanAutoChargeAuditLog: PaymentPlanAutoChargeAuditLog;
    upsertOnePaymentPlanBoughtTreatment: PaymentPlanBoughtTreatment;
    upsertOnePaymentPlanBoughtTreatmentAuditLog: PaymentPlanBoughtTreatmentAuditLog;
    upsertOnePaymentPlanOrgConfig: PaymentPlanOrgConfig;
    upsertOnePaymentPlanOrgConfigAuditLog: PaymentPlanOrgConfigAuditLog;
    upsertOnePayout: Payout;
    upsertOnePayoutAuditLog: PayoutAuditLog;
    upsertOnePendingVoidPayoutReversal: PendingVoidPayoutReversal;
    upsertOnePhoneNumberType: PhoneNumberType;
    upsertOnePlaceOfServiceCode: PlaceOfServiceCode;
    upsertOnePractice: Practice;
    upsertOnePracticeConfiguration: PracticeConfiguration;
    upsertOnePracticeHours: PracticeHours;
    upsertOnePracticeHoursOverrides: PracticeHoursOverrides;
    upsertOnePricedTreatment: PricedTreatment;
    upsertOnePricingAttempt: PricingAttempt;
    upsertOnePricingEscalator: PricingEscalator;
    upsertOnePricingQueue: PricingQueue;
    upsertOnePricingResults: PricingResults;
    upsertOneProcedureBenefitParsingRules: ProcedureBenefitParsingRules;
    upsertOneProductCategories: ProductCategories;
    upsertOneProductCategoryTranslation: ProductCategoryTranslation;
    upsertOneProductToBundle: ProductToBundle;
    upsertOneProductToHrt: ProductToHrt;
    upsertOneProductTranslation: ProductTranslation;
    upsertOneProducts: Products;
    upsertOneProvider: Provider;
    upsertOneProviderCredentialing: ProviderCredentialing;
    upsertOneProviderGroup: ProviderGroup;
    upsertOneProviderGroupToHrt: ProviderGroupToHrt;
    upsertOneProviderHrtMaxCount: ProviderHrtMaxCount;
    upsertOneProviderTaxonomy: ProviderTaxonomy;
    upsertOneProviderToOrg: ProviderToOrg;
    upsertOneProviderToProviderGroup: ProviderToProviderGroup;
    upsertOneReattributionDirection: ReattributionDirection;
    upsertOneReceiptArrangement: ReceiptArrangement;
    upsertOneReservedEhrVisit: ReservedEhrVisit;
    upsertOneResetToken: ResetToken;
    upsertOneSavedIntakeResponse: SavedIntakeResponse;
    upsertOneSchedulingSlotConfig: SchedulingSlotConfig;
    upsertOneServiceTypeCode: ServiceTypeCode;
    upsertOneSlot: Slot;
    upsertOneSlotAuditLog: SlotAuditLog;
    upsertOneSrt: Srt;
    upsertOneSrtFlags: SrtFlags;
    upsertOneSrtMultiplierRule: SrtMultiplierRule;
    upsertOneSrtToBillingCode: SrtToBillingCode;
    upsertOneStatePayerMapping: StatePayerMapping;
    upsertOneSuperscriptFeeLineItem: SuperscriptFeeLineItem;
    upsertOneSuperscriptFees: SuperscriptFees;
    upsertOneSuperscriptIntakeQuestion: SuperscriptIntakeQuestion;
    upsertOneTimeBlock: TimeBlock;
    upsertOneTransaction: Transaction;
    upsertOneUser: User;
    upsertOneUserAuditLog: UserAuditLog;
    upsertOneUserPracticeVisit: UserPracticeVisit;
    upsertOneUserToNewUser: UserToNewUser;
    upsertOneValidPayers: ValidPayers;
};

export type MutationCancelChargesArgs = {
    data: CancelChargesDto;
};

export type MutationCheckInArgs = {
    checkedInBy: Scalars['String']['input'];
    id: Scalars['String']['input'];
};

export type MutationCreateAdjudicationArgs = {
    createAdjudicationInfo: CreateAdjudicationDto;
};

export type MutationCreateChargesArgs = {
    charges: Array<ChargeDto>;
};

export type MutationCreateConsumerAndEhrPatientArgs = {
    consumerAndEhrPatientInput: ConsumerAndEhrPatientCreateInput;
};

export type MutationCreateInsuranceArgs = {
    data: CreateInsuranceWithEhrInput;
};

export type MutationCreateManyAleConfigArgs = {
    data: Array<AleConfigCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAleDepartmentGoLiveArgs = {
    data: Array<AleDepartmentGoLiveCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAdjudicationArgs = {
    data: Array<AdjudicationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAdjudicationAuditLogArgs = {
    data: Array<AdjudicationAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAdjustmentArgs = {
    data: Array<AdjustmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAdjustmentAuditLogArgs = {
    data: Array<AdjustmentAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAdminArgs = {
    data: Array<AdminCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAdminInteractionArgs = {
    data: Array<AdminInteractionCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnAdjudicationArgs = {
    data: Array<AdjudicationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnAdjudicationAuditLogArgs = {
    data: Array<AdjudicationAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnAdjustmentArgs = {
    data: Array<AdjustmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnAdjustmentAuditLogArgs = {
    data: Array<AdjustmentAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnAppointmentArgs = {
    data: Array<AppointmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnAppointmentAuditLogArgs = {
    data: Array<AppointmentAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnArrearBillingArgs = {
    data: Array<ArrearBillingCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnArtClaimArgs = {
    data: Array<ArtClaimCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnArtClaimAuditLogArgs = {
    data: Array<ArtClaimAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnArtClaimCptLineArgs = {
    data: Array<ArtClaimCptLineCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnArtClaimCptLineAuditLogArgs = {
    data: Array<ArtClaimCptLineAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnBillingTableDownloadRequestArgs = {
    data: Array<BillingTableDownloadRequestCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnBoughtTreatmentArgs = {
    data: Array<BoughtTreatmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnBoughtTreatmentAuditLogArgs = {
    data: Array<BoughtTreatmentAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnBoughtTreatmentClaimDetailArgs = {
    data: Array<BoughtTreatmentClaimDetailCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnBulkChargeCardRunArgs = {
    data: Array<BulkChargeCardRunCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnBulkChargeCardRunItemArgs = {
    data: Array<BulkChargeCardRunItemCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnBusinessHourArgs = {
    data: Array<BusinessHourCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnCandidateTreatmentArgs = {
    data: Array<CandidateTreatmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnChargeArgs = {
    data: Array<ChargeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnChargeAuditLogArgs = {
    data: Array<ChargeAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnChargeReattributionAndPartialPaymentLogArgs =
    {
        data: Array<ChargeReattributionAndPartialPaymentLogCreateManyInput>;
        skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
    };

export type MutationCreateManyAndReturnChargeReattributionLogArgs = {
    data: Array<ChargeReattributionLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnCheckoutAdjudicationArgs = {
    data: Array<CheckoutAdjudicationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnClaimToBoughtTreatmentArgs = {
    data: Array<ClaimToBoughtTreatmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnConsentFormArgs = {
    data: Array<ConsentFormCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnCustomFieldArgs = {
    data: Array<CustomFieldCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnCustomFieldValueArgs = {
    data: Array<CustomFieldValueCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnDataMigrationsArgs = {
    data: Array<DataMigrationsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEhrPaymentDescriptorArgs = {
    data: Array<EhrPaymentDescriptorCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEhrPaymentDescriptorAuditLogArgs = {
    data: Array<EhrPaymentDescriptorAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEhrPaymentDirectionSsAssetArgs = {
    data: Array<EhrPaymentDirectionSsAssetCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEhrPostDetailArgs = {
    data: Array<EhrPostDetailCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEhrPostDetailToPayoutArgs = {
    data: Array<EhrPostDetailToPayoutCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEhrPostLedgerArgs = {
    data: Array<EhrPostLedgerCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEhrPostLedgerAuditLogArgs = {
    data: Array<EhrPostLedgerAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEhrPostLedgerToPayoutArgs = {
    data: Array<EhrPostLedgerToPayoutCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEhrSlotArgs = {
    data: Array<EhrSlotCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEhrSlotAuditLogArgs = {
    data: Array<EhrSlotAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnEncounterArgs = {
    data: Array<EncounterCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnExperityEncounterArgs = {
    data: Array<ExperityEncounterCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnFeeConfigArgs = {
    data: Array<FeeConfigCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnFeeConfigAuditLogArgs = {
    data: Array<FeeConfigAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnGuarantorPaymentLinkContextArgs = {
    data: Array<GuarantorPaymentLinkContextCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnHolidayArgs = {
    data: Array<HolidayCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnInsuranceMetadataArgs = {
    data: Array<InsuranceMetadataCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnInvoiceDailyLineItemsArgs = {
    data: Array<InvoiceDailyLineItemsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnInvoicesArgs = {
    data: Array<InvoicesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnLiveTransfersArgs = {
    data: Array<LiveTransfersCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnMcmsAssociationArgs = {
    data: Array<McmsAssociationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnMcmsAssociationAuditLogArgs = {
    data: Array<McmsAssociationAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnMcmsAssociationClaimArgs = {
    data: Array<McmsAssociationClaimCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnMcmsAssociationClaimAuditLogArgs = {
    data: Array<McmsAssociationClaimAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnMcmsAssociationSlotArgs = {
    data: Array<McmsAssociationSlotCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnMcmsAssociationSlotAuditLogArgs = {
    data: Array<McmsAssociationSlotAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnMessageOrchestrationRuleArgs = {
    data: Array<MessageOrchestrationRuleCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnMigratedEncounterArgs = {
    data: Array<MigratedEncounterCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnMigrationsArgs = {
    data: Array<MigrationsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnNonCardRefundsArgs = {
    data: Array<NonCardRefundsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnOrgFeesArgs = {
    data: Array<OrgFeesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnOrgStripeMappingArgs = {
    data: Array<OrgStripeMappingCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPayLaterAuthorizationArgs = {
    data: Array<PayLaterAuthorizationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPayLaterAuthorizationAuditLogArgs = {
    data: Array<PayLaterAuthorizationAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentAuthorizationArgs = {
    data: Array<PaymentAuthorizationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentAuthorizationAuditLogArgs = {
    data: Array<PaymentAuthorizationAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentPlanArgs = {
    data: Array<PaymentPlanCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentPlanAdjustmentArgs = {
    data: Array<PaymentPlanAdjustmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentPlanAdjustmentAuditLogArgs = {
    data: Array<PaymentPlanAdjustmentAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentPlanAuditLogArgs = {
    data: Array<PaymentPlanAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentPlanAutoChargeArgs = {
    data: Array<PaymentPlanAutoChargeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentPlanAutoChargeAuditLogArgs = {
    data: Array<PaymentPlanAutoChargeAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentPlanBoughtTreatmentArgs = {
    data: Array<PaymentPlanBoughtTreatmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentPlanBoughtTreatmentAuditLogArgs =
    {
        data: Array<PaymentPlanBoughtTreatmentAuditLogCreateManyInput>;
        skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
    };

export type MutationCreateManyAndReturnPaymentPlanOrgConfigArgs = {
    data: Array<PaymentPlanOrgConfigCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPaymentPlanOrgConfigAuditLogArgs = {
    data: Array<PaymentPlanOrgConfigAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPayoutArgs = {
    data: Array<PayoutCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPayoutAuditLogArgs = {
    data: Array<PayoutAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPendingVoidPayoutReversalArgs = {
    data: Array<PendingVoidPayoutReversalCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPracticeConfigurationArgs = {
    data: Array<PracticeConfigurationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnPricingEscalatorArgs = {
    data: Array<PricingEscalatorCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnReattributionDirectionArgs = {
    data: Array<ReattributionDirectionCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnReceiptArrangementArgs = {
    data: Array<ReceiptArrangementCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnReservedEhrVisitArgs = {
    data: Array<ReservedEhrVisitCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnSlotArgs = {
    data: Array<SlotCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnSlotAuditLogArgs = {
    data: Array<SlotAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnSuperscriptFeeLineItemArgs = {
    data: Array<SuperscriptFeeLineItemCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnSuperscriptFeesArgs = {
    data: Array<SuperscriptFeesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnTimeBlockArgs = {
    data: Array<TimeBlockCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAndReturnTransactionArgs = {
    data: Array<TransactionCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAppointmentArgs = {
    data: Array<AppointmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAppointmentAuditLogArgs = {
    data: Array<AppointmentAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyArrearBillingArgs = {
    data: Array<ArrearBillingCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyArtClaimArgs = {
    data: Array<ArtClaimCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyArtClaimAuditLogArgs = {
    data: Array<ArtClaimAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyArtClaimCptLineArgs = {
    data: Array<ArtClaimCptLineCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyArtClaimCptLineAuditLogArgs = {
    data: Array<ArtClaimCptLineAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyArtOrgConfigArgs = {
    data: Array<ArtOrgConfigCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyArtPracticeConfigArgs = {
    data: Array<ArtPracticeConfigCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAthenaMedicationsArgs = {
    data: Array<AthenaMedicationsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAthenaPharmacyArgs = {
    data: Array<AthenaPharmacyCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyAthenaProviderArgs = {
    data: Array<AthenaProviderCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBenefitParsingRulesArgs = {
    data: Array<BenefitParsingRulesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBillingCodeArgs = {
    data: Array<BillingCodeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBillingTableDownloadRequestArgs = {
    data: Array<BillingTableDownloadRequestCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBoughtTreatmentArgs = {
    data: Array<BoughtTreatmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBoughtTreatmentAuditLogArgs = {
    data: Array<BoughtTreatmentAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBoughtTreatmentClaimDetailArgs = {
    data: Array<BoughtTreatmentClaimDetailCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBulkChargeCardRunArgs = {
    data: Array<BulkChargeCardRunCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBulkChargeCardRunItemArgs = {
    data: Array<BulkChargeCardRunItemCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBundleArgs = {
    data: Array<BundleCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBundleToHrtArgs = {
    data: Array<BundleToHrtCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyBusinessHourArgs = {
    data: Array<BusinessHourCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyCandidateTreatmentArgs = {
    data: Array<CandidateTreatmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyCardAuthorizationArgs = {
    data: Array<CardAuthorizationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyCardAuthorizationAuditLogArgs = {
    data: Array<CardAuthorizationAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyCashPriceArgs = {
    data: Array<CashPriceCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyChargeArgs = {
    data: Array<ChargeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyChargeAuditLogArgs = {
    data: Array<ChargeAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyChargeReattributionAndPartialPaymentLogArgs = {
    data: Array<ChargeReattributionAndPartialPaymentLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyChargeReattributionLogArgs = {
    data: Array<ChargeReattributionLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyCheckNetworkStatusResultsArgs = {
    data: Array<CheckNetworkStatusResultsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyCheckoutAdjudicationArgs = {
    data: Array<CheckoutAdjudicationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyClaimToBoughtTreatmentArgs = {
    data: Array<ClaimToBoughtTreatmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyConfigCommitArgs = {
    data: Array<ConfigCommitCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyConfigFlagArgs = {
    data: Array<ConfigFlagCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyConfigSessionArgs = {
    data: Array<ConfigSessionCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyConsentFormArgs = {
    data: Array<ConsentFormCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyConsumerArgs = {
    data: Array<ConsumerCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyConsumerAuditLogArgs = {
    data: Array<ConsumerAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyConsumerMessageArgs = {
    data: Array<ConsumerMessageCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyConsumerNoteArgs = {
    data: Array<ConsumerNoteCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyConsumerPhotoMetaDataArgs = {
    data: Array<ConsumerPhotoMetaDataCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyConsumerSrtRecordsArgs = {
    data: Array<ConsumerSrtRecordsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyContractArgs = {
    data: Array<ContractCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyContractAuditLogArgs = {
    data: Array<ContractAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyCoverageResponsesArgs = {
    data: Array<CoverageResponsesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyCptExclusivityEdgeArgs = {
    data: Array<CptExclusivityEdgeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyCustomFieldArgs = {
    data: Array<CustomFieldCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyCustomFieldValueArgs = {
    data: Array<CustomFieldValueCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDataMigrationsArgs = {
    data: Array<DataMigrationsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDefaultPracticeArgs = {
    data: Array<DefaultPracticeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDefaultProvidersArgs = {
    data: Array<DefaultProvidersCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDeploymentOrgPhaseArgs = {
    data: Array<DeploymentOrgPhaseCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDeploymentOrgTaskArgs = {
    data: Array<DeploymentOrgTaskCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDeploymentOrgTaskDependencyArgs = {
    data: Array<DeploymentOrgTaskDependencyCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDeploymentPhaseArgs = {
    data: Array<DeploymentPhaseCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDeploymentTaskArgs = {
    data: Array<DeploymentTaskCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDeploymentTaskDependencyArgs = {
    data: Array<DeploymentTaskDependencyCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDeploymentTeamArgs = {
    data: Array<DeploymentTeamCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyDiscountCodesArgs = {
    data: Array<DiscountCodesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEcwPayerAliasArgs = {
    data: Array<EcwPayerAliasCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEcwPayerStcArgs = {
    data: Array<EcwPayerStcCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrAppointmentTypeIdToNameArgs = {
    data: Array<EhrAppointmentTypeIdToNameCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrPaymentDescriptorArgs = {
    data: Array<EhrPaymentDescriptorCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrPaymentDescriptorAuditLogArgs = {
    data: Array<EhrPaymentDescriptorAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrPaymentDirectionSsAssetArgs = {
    data: Array<EhrPaymentDirectionSsAssetCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrPostDetailArgs = {
    data: Array<EhrPostDetailCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrPostDetailToPayoutArgs = {
    data: Array<EhrPostDetailToPayoutCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrPostLedgerArgs = {
    data: Array<EhrPostLedgerCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrPostLedgerAuditLogArgs = {
    data: Array<EhrPostLedgerAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrPostLedgerToPayoutArgs = {
    data: Array<EhrPostLedgerToPayoutCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrPrimaryCareProviderArgs = {
    data: Array<EhrPrimaryCareProviderCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrProviderMappingArgs = {
    data: Array<EhrProviderMappingCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrSlotArgs = {
    data: Array<EhrSlotCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEhrSlotAuditLogArgs = {
    data: Array<EhrSlotAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyEncounterArgs = {
    data: Array<EncounterCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyExperityEncounterArgs = {
    data: Array<ExperityEncounterCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyFaqDropdownsArgs = {
    data: Array<FaqDropdownsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyFeeConfigArgs = {
    data: Array<FeeConfigCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyFeeConfigAuditLogArgs = {
    data: Array<FeeConfigAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyGuarantorPaymentLinkContextArgs = {
    data: Array<GuarantorPaymentLinkContextCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyHolidayArgs = {
    data: Array<HolidayCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyHrtArgs = {
    data: Array<HrtCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyHrtFlagsArgs = {
    data: Array<HrtFlagsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyHrtPaymentTypeArgs = {
    data: Array<HrtPaymentTypeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyHrtToSrtArgs = {
    data: Array<HrtToSrtCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyHrtTranslationArgs = {
    data: Array<HrtTranslationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyInboundRequestLogArgs = {
    data: Array<InboundRequestLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyInboundTextMessageLogArgs = {
    data: Array<InboundTextMessageLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyInsuranceArgs = {
    data: Array<InsuranceCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyInsuranceAuditLogArgs = {
    data: Array<InsuranceAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyInsuranceMetadataArgs = {
    data: Array<InsuranceMetadataCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyIntakeFormArgs = {
    data: Array<IntakeFormCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyIntakeFormSectionArgs = {
    data: Array<IntakeFormSectionCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyIntakeFormSectionTranslationArgs = {
    data: Array<IntakeFormSectionTranslationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyIntakeFormToQuestionArgs = {
    data: Array<IntakeFormToQuestionCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyIntakeQuestionArgs = {
    data: Array<IntakeQuestionCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyIntakeQuestionTranslationArgs = {
    data: Array<IntakeQuestionTranslationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyInvoiceDailyLineItemsArgs = {
    data: Array<InvoiceDailyLineItemsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyInvoicesArgs = {
    data: Array<InvoicesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyKeywordRuleArgs = {
    data: Array<KeywordRuleCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyLinkMappingArgs = {
    data: Array<LinkMappingCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyLiveTransfersArgs = {
    data: Array<LiveTransfersCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMcmsAssociationArgs = {
    data: Array<McmsAssociationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMcmsAssociationAuditLogArgs = {
    data: Array<McmsAssociationAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMcmsAssociationClaimArgs = {
    data: Array<McmsAssociationClaimCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMcmsAssociationClaimAuditLogArgs = {
    data: Array<McmsAssociationClaimAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMcmsAssociationSlotArgs = {
    data: Array<McmsAssociationSlotCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMcmsAssociationSlotAuditLogArgs = {
    data: Array<McmsAssociationSlotAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMessageBlueprintArgs = {
    data: Array<MessageBlueprintCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMessageConsolidationContextArgs = {
    data: Array<MessageConsolidationContextCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMessageConsolidationTemplateArgs = {
    data: Array<MessageConsolidationTemplateCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMessageNudgeArgs = {
    data: Array<MessageNudgeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMessageOrchestrationRuleArgs = {
    data: Array<MessageOrchestrationRuleCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMessagePayAfterArgs = {
    data: Array<MessagePayAfterCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMessageSettingsHrtArgs = {
    data: Array<MessageSettingsHrtCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMessageSettingsOrgArgs = {
    data: Array<MessageSettingsOrgCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMessageTemplateHrtArgs = {
    data: Array<MessageTemplateHrtCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMessageTemplateOrgArgs = {
    data: Array<MessageTemplateOrgCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMigratedEncounterArgs = {
    data: Array<MigratedEncounterCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyMigrationsArgs = {
    data: Array<MigrationsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyNetworkValidationArgs = {
    data: Array<NetworkValidationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyNetworkPlanExceptionsArgs = {
    data: Array<NetworkPlanExceptionsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyNonCardRefundsArgs = {
    data: Array<NonCardRefundsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyOrgConfigFlagArgs = {
    data: Array<OrgConfigFlagCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyOrgHrtSrtRuleArgs = {
    data: Array<OrgHrtSrtRuleCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyOrgNetworkResultsArgs = {
    data: Array<OrgNetworkResultsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyOrgOverrideRuleArgs = {
    data: Array<OrgOverrideRuleCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyOrgFeesArgs = {
    data: Array<OrgFeesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyOrgStripeMappingArgs = {
    data: Array<OrgStripeMappingCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyOrganizationArgs = {
    data: Array<OrganizationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyOrganizationAssetsArgs = {
    data: Array<OrganizationAssetsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyOrganizationTranslationArgs = {
    data: Array<OrganizationTranslationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPayLaterAuthorizationArgs = {
    data: Array<PayLaterAuthorizationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPayLaterAuthorizationAuditLogArgs = {
    data: Array<PayLaterAuthorizationAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPayerArgs = {
    data: Array<PayerCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPayerPlanMappingArgs = {
    data: Array<PayerPlanMappingCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPayerToEhrInsurancePackageMappingArgs = {
    data: Array<PayerToEhrInsurancePackageMappingCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentAuthorizationArgs = {
    data: Array<PaymentAuthorizationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentAuthorizationAuditLogArgs = {
    data: Array<PaymentAuthorizationAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentContractArgs = {
    data: Array<PaymentContractCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentPlanArgs = {
    data: Array<PaymentPlanCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentPlanAdjustmentArgs = {
    data: Array<PaymentPlanAdjustmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentPlanAdjustmentAuditLogArgs = {
    data: Array<PaymentPlanAdjustmentAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentPlanAuditLogArgs = {
    data: Array<PaymentPlanAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentPlanAutoChargeArgs = {
    data: Array<PaymentPlanAutoChargeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentPlanAutoChargeAuditLogArgs = {
    data: Array<PaymentPlanAutoChargeAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentPlanBoughtTreatmentArgs = {
    data: Array<PaymentPlanBoughtTreatmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentPlanBoughtTreatmentAuditLogArgs = {
    data: Array<PaymentPlanBoughtTreatmentAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentPlanOrgConfigArgs = {
    data: Array<PaymentPlanOrgConfigCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPaymentPlanOrgConfigAuditLogArgs = {
    data: Array<PaymentPlanOrgConfigAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPayoutArgs = {
    data: Array<PayoutCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPayoutAuditLogArgs = {
    data: Array<PayoutAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPendingVoidPayoutReversalArgs = {
    data: Array<PendingVoidPayoutReversalCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPhoneNumberTypeArgs = {
    data: Array<PhoneNumberTypeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPlaceOfServiceCodeArgs = {
    data: Array<PlaceOfServiceCodeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPracticeArgs = {
    data: Array<PracticeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPracticeConfigurationArgs = {
    data: Array<PracticeConfigurationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPracticeHoursArgs = {
    data: Array<PracticeHoursCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPracticeHoursOverridesArgs = {
    data: Array<PracticeHoursOverridesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPricedTreatmentArgs = {
    data: Array<PricedTreatmentCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPricingAttemptArgs = {
    data: Array<PricingAttemptCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPricingEscalatorArgs = {
    data: Array<PricingEscalatorCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPricingQueueArgs = {
    data: Array<PricingQueueCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyPricingResultsArgs = {
    data: Array<PricingResultsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProcedureBenefitParsingRulesArgs = {
    data: Array<ProcedureBenefitParsingRulesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProductCategoriesArgs = {
    data: Array<ProductCategoriesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProductCategoryTranslationArgs = {
    data: Array<ProductCategoryTranslationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProductToBundleArgs = {
    data: Array<ProductToBundleCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProductToHrtArgs = {
    data: Array<ProductToHrtCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProductTranslationArgs = {
    data: Array<ProductTranslationCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProductsArgs = {
    data: Array<ProductsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProviderArgs = {
    data: Array<ProviderCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProviderCredentialingArgs = {
    data: Array<ProviderCredentialingCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProviderGroupArgs = {
    data: Array<ProviderGroupCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProviderGroupToHrtArgs = {
    data: Array<ProviderGroupToHrtCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProviderHrtMaxCountArgs = {
    data: Array<ProviderHrtMaxCountCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProviderTaxonomyArgs = {
    data: Array<ProviderTaxonomyCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProviderToOrgArgs = {
    data: Array<ProviderToOrgCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyProviderToProviderGroupArgs = {
    data: Array<ProviderToProviderGroupCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyReattributionDirectionArgs = {
    data: Array<ReattributionDirectionCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyReceiptArrangementArgs = {
    data: Array<ReceiptArrangementCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyReservedEhrVisitArgs = {
    data: Array<ReservedEhrVisitCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyResetTokenArgs = {
    data: Array<ResetTokenCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySavedIntakeResponseArgs = {
    data: Array<SavedIntakeResponseCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySchedulingSlotConfigArgs = {
    data: Array<SchedulingSlotConfigCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyServiceTypeCodeArgs = {
    data: Array<ServiceTypeCodeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySlotArgs = {
    data: Array<SlotCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySlotAuditLogArgs = {
    data: Array<SlotAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySrtArgs = {
    data: Array<SrtCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySrtFlagsArgs = {
    data: Array<SrtFlagsCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySrtMultiplierRuleArgs = {
    data: Array<SrtMultiplierRuleCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySrtToBillingCodeArgs = {
    data: Array<SrtToBillingCodeCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyStatePayerMappingArgs = {
    data: Array<StatePayerMappingCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySuperscriptFeeLineItemArgs = {
    data: Array<SuperscriptFeeLineItemCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySuperscriptFeesArgs = {
    data: Array<SuperscriptFeesCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManySuperscriptIntakeQuestionArgs = {
    data: Array<SuperscriptIntakeQuestionCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyTimeBlockArgs = {
    data: Array<TimeBlockCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyTransactionArgs = {
    data: Array<TransactionCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyUserArgs = {
    data: Array<UserCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyUserAuditLogArgs = {
    data: Array<UserAuditLogCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyUserPracticeVisitArgs = {
    data: Array<UserPracticeVisitCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyUserToNewUserArgs = {
    data: Array<UserToNewUserCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateManyValidPayersArgs = {
    data: Array<ValidPayersCreateManyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateOneAleConfigArgs = {
    data: AleConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAleDepartmentGoLiveArgs = {
    data: AleDepartmentGoLiveCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAdjudicationArgs = {
    data: AdjudicationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAdjudicationAuditLogArgs = {
    data: AdjudicationAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAdjustmentArgs = {
    data: AdjustmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAdjustmentAuditLogArgs = {
    data: AdjustmentAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAdminArgs = {
    data: AdminCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAdminInteractionArgs = {
    data: AdminInteractionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAppointmentArgs = {
    data: AppointmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAppointmentAuditLogArgs = {
    data: AppointmentAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneArrearBillingArgs = {
    data: ArrearBillingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneArtClaimArgs = {
    data: ArtClaimCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneArtClaimAuditLogArgs = {
    data: ArtClaimAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneArtClaimCptLineArgs = {
    data: ArtClaimCptLineCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneArtClaimCptLineAuditLogArgs = {
    data: ArtClaimCptLineAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneArtOrgConfigArgs = {
    data: ArtOrgConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneArtPracticeConfigArgs = {
    data: ArtPracticeConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAthenaMedicationsArgs = {
    data: AthenaMedicationsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAthenaPharmacyArgs = {
    data: AthenaPharmacyCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneAthenaProviderArgs = {
    data: AthenaProviderCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBenefitParsingRulesArgs = {
    data: BenefitParsingRulesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBillingCodeArgs = {
    data: BillingCodeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBillingTableDownloadRequestArgs = {
    data: BillingTableDownloadRequestCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBoughtTreatmentArgs = {
    data: BoughtTreatmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBoughtTreatmentAuditLogArgs = {
    data?: InputMaybe<BoughtTreatmentAuditLogCreateInput>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBoughtTreatmentClaimDetailArgs = {
    data: BoughtTreatmentClaimDetailCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBulkChargeCardRunArgs = {
    data: BulkChargeCardRunCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBulkChargeCardRunItemArgs = {
    data: BulkChargeCardRunItemCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBundleArgs = {
    data: BundleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBundleToHrtArgs = {
    data: BundleToHrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneBusinessHourArgs = {
    data: BusinessHourCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneCandidateTreatmentArgs = {
    data: CandidateTreatmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneCardAuthorizationArgs = {
    data: CardAuthorizationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneCardAuthorizationAuditLogArgs = {
    data: CardAuthorizationAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneCashPriceArgs = {
    data: CashPriceCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneChargeArgs = {
    data: ChargeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneChargeAuditLogArgs = {
    data: ChargeAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneChargeReattributionAndPartialPaymentLogArgs = {
    data: ChargeReattributionAndPartialPaymentLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneChargeReattributionLogArgs = {
    data: ChargeReattributionLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneCheckNetworkStatusResultsArgs = {
    data: CheckNetworkStatusResultsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneCheckoutAdjudicationArgs = {
    data: CheckoutAdjudicationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneClaimToBoughtTreatmentArgs = {
    data: ClaimToBoughtTreatmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneConfigCommitArgs = {
    data: ConfigCommitCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneConfigFlagArgs = {
    data: ConfigFlagCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneConfigSessionArgs = {
    data: ConfigSessionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneConsentFormArgs = {
    data: ConsentFormCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneConsumerArgs = {
    data: ConsumerCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneConsumerAuditLogArgs = {
    data?: InputMaybe<ConsumerAuditLogCreateInput>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneConsumerMessageArgs = {
    data: ConsumerMessageCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneConsumerNoteArgs = {
    data: ConsumerNoteCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneConsumerPhotoMetaDataArgs = {
    data: ConsumerPhotoMetaDataCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneConsumerSrtRecordsArgs = {
    data: ConsumerSrtRecordsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneContractArgs = {
    data: ContractCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneContractAuditLogArgs = {
    data?: InputMaybe<ContractAuditLogCreateInput>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneCoverageResponsesArgs = {
    data: CoverageResponsesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneCptExclusivityEdgeArgs = {
    data: CptExclusivityEdgeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneCustomFieldArgs = {
    data: CustomFieldCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneCustomFieldValueArgs = {
    data: CustomFieldValueCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDataMigrationsArgs = {
    data: DataMigrationsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDefaultPracticeArgs = {
    data: DefaultPracticeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDefaultProvidersArgs = {
    data: DefaultProvidersCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDeploymentOrgPhaseArgs = {
    data: DeploymentOrgPhaseCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDeploymentOrgTaskArgs = {
    data: DeploymentOrgTaskCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDeploymentOrgTaskDependencyArgs = {
    data: DeploymentOrgTaskDependencyCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDeploymentPhaseArgs = {
    data: DeploymentPhaseCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDeploymentTaskArgs = {
    data: DeploymentTaskCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDeploymentTaskDependencyArgs = {
    data: DeploymentTaskDependencyCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDeploymentTeamArgs = {
    data: DeploymentTeamCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneDiscountCodesArgs = {
    data: DiscountCodesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEcwPayerAliasArgs = {
    data: EcwPayerAliasCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEcwPayerStcArgs = {
    data: EcwPayerStcCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrAppointmentTypeIdToNameArgs = {
    data: EhrAppointmentTypeIdToNameCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrPaymentDescriptorArgs = {
    data: EhrPaymentDescriptorCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrPaymentDescriptorAuditLogArgs = {
    data?: InputMaybe<EhrPaymentDescriptorAuditLogCreateInput>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrPaymentDirectionSsAssetArgs = {
    data: EhrPaymentDirectionSsAssetCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrPostDetailArgs = {
    data: EhrPostDetailCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrPostDetailToPayoutArgs = {
    data: EhrPostDetailToPayoutCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrPostLedgerArgs = {
    data: EhrPostLedgerCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrPostLedgerAuditLogArgs = {
    data: EhrPostLedgerAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrPostLedgerToPayoutArgs = {
    data: EhrPostLedgerToPayoutCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrPrimaryCareProviderArgs = {
    data: EhrPrimaryCareProviderCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrProviderMappingArgs = {
    data: EhrProviderMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrSlotArgs = {
    data: EhrSlotCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEhrSlotAuditLogArgs = {
    data: EhrSlotAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneEncounterArgs = {
    data: EncounterCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneExperityEncounterArgs = {
    data: ExperityEncounterCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneFaqDropdownsArgs = {
    data: FaqDropdownsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneFeeConfigArgs = {
    data: FeeConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneFeeConfigAuditLogArgs = {
    data: FeeConfigAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneGuarantorPaymentLinkContextArgs = {
    data: GuarantorPaymentLinkContextCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneHolidayArgs = {
    data: HolidayCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneHrtArgs = {
    data: HrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneHrtFlagsArgs = {
    data: HrtFlagsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneHrtPaymentTypeArgs = {
    data: HrtPaymentTypeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneHrtToSrtArgs = {
    data: HrtToSrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneHrtTranslationArgs = {
    data: HrtTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneInboundRequestLogArgs = {
    data: InboundRequestLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneInboundTextMessageLogArgs = {
    data: InboundTextMessageLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneInsuranceArgs = {
    data: InsuranceCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneInsuranceAuditLogArgs = {
    data?: InputMaybe<InsuranceAuditLogCreateInput>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneInsuranceMetadataArgs = {
    data: InsuranceMetadataCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneIntakeFormArgs = {
    data: IntakeFormCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneIntakeFormSectionArgs = {
    data: IntakeFormSectionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneIntakeFormSectionTranslationArgs = {
    data: IntakeFormSectionTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneIntakeFormToQuestionArgs = {
    data: IntakeFormToQuestionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneIntakeQuestionArgs = {
    data: IntakeQuestionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneIntakeQuestionTranslationArgs = {
    data: IntakeQuestionTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneInvoiceDailyLineItemsArgs = {
    data: InvoiceDailyLineItemsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneInvoicesArgs = {
    data: InvoicesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneKeywordRuleArgs = {
    data?: InputMaybe<KeywordRuleCreateInput>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneLinkMappingArgs = {
    data: LinkMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneLiveTransfersArgs = {
    data: LiveTransfersCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMcmsAssociationArgs = {
    data: McmsAssociationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMcmsAssociationAuditLogArgs = {
    data: McmsAssociationAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMcmsAssociationClaimArgs = {
    data: McmsAssociationClaimCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMcmsAssociationClaimAuditLogArgs = {
    data: McmsAssociationClaimAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMcmsAssociationSlotArgs = {
    data: McmsAssociationSlotCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMcmsAssociationSlotAuditLogArgs = {
    data: McmsAssociationSlotAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMessageBlueprintArgs = {
    data: MessageBlueprintCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMessageConsolidationContextArgs = {
    data: MessageConsolidationContextCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMessageConsolidationTemplateArgs = {
    data: MessageConsolidationTemplateCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMessageNudgeArgs = {
    data: MessageNudgeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMessageOrchestrationRuleArgs = {
    data: MessageOrchestrationRuleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMessagePayAfterArgs = {
    data: MessagePayAfterCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMessageSettingsHrtArgs = {
    data: MessageSettingsHrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMessageSettingsOrgArgs = {
    data: MessageSettingsOrgCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMessageTemplateHrtArgs = {
    data: MessageTemplateHrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMessageTemplateOrgArgs = {
    data: MessageTemplateOrgCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMigratedEncounterArgs = {
    data: MigratedEncounterCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneMigrationsArgs = {
    data: MigrationsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneNetworkValidationArgs = {
    data: NetworkValidationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneNetworkPlanExceptionsArgs = {
    data: NetworkPlanExceptionsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneNonCardRefundsArgs = {
    data: NonCardRefundsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneOrgConfigFlagArgs = {
    data: OrgConfigFlagCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneOrgHrtSrtRuleArgs = {
    data?: InputMaybe<OrgHrtSrtRuleCreateInput>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneOrgNetworkResultsArgs = {
    data: OrgNetworkResultsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneOrgOverrideRuleArgs = {
    data: OrgOverrideRuleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneOrgFeesArgs = {
    data: OrgFeesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneOrgStripeMappingArgs = {
    data: OrgStripeMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneOrganizationArgs = {
    data: OrganizationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneOrganizationAssetsArgs = {
    data: OrganizationAssetsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneOrganizationTranslationArgs = {
    data: OrganizationTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePayLaterAuthorizationArgs = {
    data: PayLaterAuthorizationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePayLaterAuthorizationAuditLogArgs = {
    data: PayLaterAuthorizationAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePayerArgs = {
    data: PayerCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePayerPlanMappingArgs = {
    data: PayerPlanMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePayerToEhrInsurancePackageMappingArgs = {
    data: PayerToEhrInsurancePackageMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentAuthorizationArgs = {
    data: PaymentAuthorizationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentAuthorizationAuditLogArgs = {
    data: PaymentAuthorizationAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentContractArgs = {
    data: PaymentContractCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentPlanArgs = {
    data: PaymentPlanCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentPlanAdjustmentArgs = {
    data: PaymentPlanAdjustmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentPlanAdjustmentAuditLogArgs = {
    data: PaymentPlanAdjustmentAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentPlanAuditLogArgs = {
    data: PaymentPlanAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentPlanAutoChargeArgs = {
    data: PaymentPlanAutoChargeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentPlanAutoChargeAuditLogArgs = {
    data: PaymentPlanAutoChargeAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentPlanBoughtTreatmentArgs = {
    data: PaymentPlanBoughtTreatmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentPlanBoughtTreatmentAuditLogArgs = {
    data: PaymentPlanBoughtTreatmentAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentPlanOrgConfigArgs = {
    data: PaymentPlanOrgConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePaymentPlanOrgConfigAuditLogArgs = {
    data: PaymentPlanOrgConfigAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePayoutArgs = {
    data: PayoutCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePayoutAuditLogArgs = {
    data: PayoutAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePendingVoidPayoutReversalArgs = {
    data: PendingVoidPayoutReversalCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePhoneNumberTypeArgs = {
    data: PhoneNumberTypeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePlaceOfServiceCodeArgs = {
    data: PlaceOfServiceCodeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePracticeArgs = {
    data: PracticeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePracticeConfigurationArgs = {
    data: PracticeConfigurationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePracticeHoursArgs = {
    data: PracticeHoursCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePracticeHoursOverridesArgs = {
    data: PracticeHoursOverridesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePricedTreatmentArgs = {
    data: PricedTreatmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePricingAttemptArgs = {
    data: PricingAttemptCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePricingEscalatorArgs = {
    data: PricingEscalatorCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePricingQueueArgs = {
    data: PricingQueueCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOnePricingResultsArgs = {
    data: PricingResultsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProcedureBenefitParsingRulesArgs = {
    data: ProcedureBenefitParsingRulesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProductCategoriesArgs = {
    data: ProductCategoriesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProductCategoryTranslationArgs = {
    data: ProductCategoryTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProductToBundleArgs = {
    data: ProductToBundleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProductToHrtArgs = {
    data: ProductToHrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProductTranslationArgs = {
    data: ProductTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProductsArgs = {
    data: ProductsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProviderArgs = {
    data: ProviderCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProviderCredentialingArgs = {
    data: ProviderCredentialingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProviderGroupArgs = {
    data: ProviderGroupCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProviderGroupToHrtArgs = {
    data: ProviderGroupToHrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProviderHrtMaxCountArgs = {
    data: ProviderHrtMaxCountCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProviderTaxonomyArgs = {
    data: ProviderTaxonomyCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProviderToOrgArgs = {
    data: ProviderToOrgCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneProviderToProviderGroupArgs = {
    data: ProviderToProviderGroupCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneReattributionDirectionArgs = {
    data?: InputMaybe<ReattributionDirectionCreateInput>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneReceiptArrangementArgs = {
    data: ReceiptArrangementCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneReservedEhrVisitArgs = {
    data: ReservedEhrVisitCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneResetTokenArgs = {
    data: ResetTokenCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSavedIntakeResponseArgs = {
    data: SavedIntakeResponseCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSchedulingSlotConfigArgs = {
    data: SchedulingSlotConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneServiceTypeCodeArgs = {
    data: ServiceTypeCodeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSlotArgs = {
    data: SlotCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSlotAuditLogArgs = {
    data: SlotAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSrtArgs = {
    data: SrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSrtFlagsArgs = {
    data: SrtFlagsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSrtMultiplierRuleArgs = {
    data: SrtMultiplierRuleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSrtToBillingCodeArgs = {
    data: SrtToBillingCodeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneStatePayerMappingArgs = {
    data: StatePayerMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSuperscriptFeeLineItemArgs = {
    data: SuperscriptFeeLineItemCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSuperscriptFeesArgs = {
    data: SuperscriptFeesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneSuperscriptIntakeQuestionArgs = {
    data: SuperscriptIntakeQuestionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneTimeBlockArgs = {
    data: TimeBlockCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneTransactionArgs = {
    data: TransactionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneUserArgs = {
    data: UserCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneUserAuditLogArgs = {
    data?: InputMaybe<UserAuditLogCreateInput>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneUserPracticeVisitArgs = {
    data: UserPracticeVisitCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneUserToNewUserArgs = {
    data: UserToNewUserCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationCreateOneValidPayersArgs = {
    data: ValidPayersCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};

export type MutationDeactivateInsuranceArgs = {
    data: DeactivateInsuranceInput;
};

export type MutationDeleteManyAleConfigArgs = {
    where?: InputMaybe<AleConfigWhereInput>;
};

export type MutationDeleteManyAleDepartmentGoLiveArgs = {
    where?: InputMaybe<AleDepartmentGoLiveWhereInput>;
};

export type MutationDeleteManyAdjudicationArgs = {
    where?: InputMaybe<AdjudicationWhereInput>;
};

export type MutationDeleteManyAdjudicationAuditLogArgs = {
    where?: InputMaybe<AdjudicationAuditLogWhereInput>;
};

export type MutationDeleteManyAdjustmentArgs = {
    where?: InputMaybe<AdjustmentWhereInput>;
};

export type MutationDeleteManyAdjustmentAuditLogArgs = {
    where?: InputMaybe<AdjustmentAuditLogWhereInput>;
};

export type MutationDeleteManyAdminArgs = {
    where?: InputMaybe<AdminWhereInput>;
};

export type MutationDeleteManyAdminInteractionArgs = {
    where?: InputMaybe<AdminInteractionWhereInput>;
};

export type MutationDeleteManyAppointmentArgs = {
    where?: InputMaybe<AppointmentWhereInput>;
};

export type MutationDeleteManyAppointmentAuditLogArgs = {
    where?: InputMaybe<AppointmentAuditLogWhereInput>;
};

export type MutationDeleteManyArrearBillingArgs = {
    where?: InputMaybe<ArrearBillingWhereInput>;
};

export type MutationDeleteManyArtClaimArgs = {
    where?: InputMaybe<ArtClaimWhereInput>;
};

export type MutationDeleteManyArtClaimAuditLogArgs = {
    where?: InputMaybe<ArtClaimAuditLogWhereInput>;
};

export type MutationDeleteManyArtClaimCptLineArgs = {
    where?: InputMaybe<ArtClaimCptLineWhereInput>;
};

export type MutationDeleteManyArtClaimCptLineAuditLogArgs = {
    where?: InputMaybe<ArtClaimCptLineAuditLogWhereInput>;
};

export type MutationDeleteManyArtOrgConfigArgs = {
    where?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type MutationDeleteManyArtPracticeConfigArgs = {
    where?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type MutationDeleteManyAthenaMedicationsArgs = {
    where?: InputMaybe<AthenaMedicationsWhereInput>;
};

export type MutationDeleteManyAthenaPharmacyArgs = {
    where?: InputMaybe<AthenaPharmacyWhereInput>;
};

export type MutationDeleteManyAthenaProviderArgs = {
    where?: InputMaybe<AthenaProviderWhereInput>;
};

export type MutationDeleteManyBenefitParsingRulesArgs = {
    where?: InputMaybe<BenefitParsingRulesWhereInput>;
};

export type MutationDeleteManyBillingCodeArgs = {
    where?: InputMaybe<BillingCodeWhereInput>;
};

export type MutationDeleteManyBillingTableDownloadRequestArgs = {
    where?: InputMaybe<BillingTableDownloadRequestWhereInput>;
};

export type MutationDeleteManyBoughtTreatmentArgs = {
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type MutationDeleteManyBoughtTreatmentAuditLogArgs = {
    where?: InputMaybe<BoughtTreatmentAuditLogWhereInput>;
};

export type MutationDeleteManyBoughtTreatmentClaimDetailArgs = {
    where?: InputMaybe<BoughtTreatmentClaimDetailWhereInput>;
};

export type MutationDeleteManyBulkChargeCardRunArgs = {
    where?: InputMaybe<BulkChargeCardRunWhereInput>;
};

export type MutationDeleteManyBulkChargeCardRunItemArgs = {
    where?: InputMaybe<BulkChargeCardRunItemWhereInput>;
};

export type MutationDeleteManyBundleArgs = {
    where?: InputMaybe<BundleWhereInput>;
};

export type MutationDeleteManyBundleToHrtArgs = {
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type MutationDeleteManyBusinessHourArgs = {
    where?: InputMaybe<BusinessHourWhereInput>;
};

export type MutationDeleteManyCandidateTreatmentArgs = {
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type MutationDeleteManyCardAuthorizationArgs = {
    where?: InputMaybe<CardAuthorizationWhereInput>;
};

export type MutationDeleteManyCardAuthorizationAuditLogArgs = {
    where?: InputMaybe<CardAuthorizationAuditLogWhereInput>;
};

export type MutationDeleteManyCashPriceArgs = {
    where?: InputMaybe<CashPriceWhereInput>;
};

export type MutationDeleteManyChargeArgs = {
    where?: InputMaybe<ChargeWhereInput>;
};

export type MutationDeleteManyChargeAuditLogArgs = {
    where?: InputMaybe<ChargeAuditLogWhereInput>;
};

export type MutationDeleteManyChargeReattributionAndPartialPaymentLogArgs = {
    where?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereInput>;
};

export type MutationDeleteManyChargeReattributionLogArgs = {
    where?: InputMaybe<ChargeReattributionLogWhereInput>;
};

export type MutationDeleteManyCheckNetworkStatusResultsArgs = {
    where?: InputMaybe<CheckNetworkStatusResultsWhereInput>;
};

export type MutationDeleteManyCheckoutAdjudicationArgs = {
    where?: InputMaybe<CheckoutAdjudicationWhereInput>;
};

export type MutationDeleteManyClaimToBoughtTreatmentArgs = {
    where?: InputMaybe<ClaimToBoughtTreatmentWhereInput>;
};

export type MutationDeleteManyConfigCommitArgs = {
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type MutationDeleteManyConfigFlagArgs = {
    where?: InputMaybe<ConfigFlagWhereInput>;
};

export type MutationDeleteManyConfigSessionArgs = {
    where?: InputMaybe<ConfigSessionWhereInput>;
};

export type MutationDeleteManyConsentFormArgs = {
    where?: InputMaybe<ConsentFormWhereInput>;
};

export type MutationDeleteManyConsumerArgs = {
    where?: InputMaybe<ConsumerWhereInput>;
};

export type MutationDeleteManyConsumerAuditLogArgs = {
    where?: InputMaybe<ConsumerAuditLogWhereInput>;
};

export type MutationDeleteManyConsumerMessageArgs = {
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type MutationDeleteManyConsumerNoteArgs = {
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type MutationDeleteManyConsumerPhotoMetaDataArgs = {
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type MutationDeleteManyConsumerSrtRecordsArgs = {
    where?: InputMaybe<ConsumerSrtRecordsWhereInput>;
};

export type MutationDeleteManyContractArgs = {
    where?: InputMaybe<ContractWhereInput>;
};

export type MutationDeleteManyContractAuditLogArgs = {
    where?: InputMaybe<ContractAuditLogWhereInput>;
};

export type MutationDeleteManyCoverageResponsesArgs = {
    where?: InputMaybe<CoverageResponsesWhereInput>;
};

export type MutationDeleteManyCptExclusivityEdgeArgs = {
    where?: InputMaybe<CptExclusivityEdgeWhereInput>;
};

export type MutationDeleteManyCustomFieldArgs = {
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type MutationDeleteManyCustomFieldValueArgs = {
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type MutationDeleteManyDataMigrationsArgs = {
    where?: InputMaybe<DataMigrationsWhereInput>;
};

export type MutationDeleteManyDefaultPracticeArgs = {
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type MutationDeleteManyDefaultProvidersArgs = {
    where?: InputMaybe<DefaultProvidersWhereInput>;
};

export type MutationDeleteManyDeploymentOrgPhaseArgs = {
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type MutationDeleteManyDeploymentOrgTaskArgs = {
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type MutationDeleteManyDeploymentOrgTaskDependencyArgs = {
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type MutationDeleteManyDeploymentPhaseArgs = {
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type MutationDeleteManyDeploymentTaskArgs = {
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type MutationDeleteManyDeploymentTaskDependencyArgs = {
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type MutationDeleteManyDeploymentTeamArgs = {
    where?: InputMaybe<DeploymentTeamWhereInput>;
};

export type MutationDeleteManyDiscountCodesArgs = {
    where?: InputMaybe<DiscountCodesWhereInput>;
};

export type MutationDeleteManyEcwPayerAliasArgs = {
    where?: InputMaybe<EcwPayerAliasWhereInput>;
};

export type MutationDeleteManyEcwPayerStcArgs = {
    where?: InputMaybe<EcwPayerStcWhereInput>;
};

export type MutationDeleteManyEhrAppointmentTypeIdToNameArgs = {
    where?: InputMaybe<EhrAppointmentTypeIdToNameWhereInput>;
};

export type MutationDeleteManyEhrPaymentDescriptorArgs = {
    where?: InputMaybe<EhrPaymentDescriptorWhereInput>;
};

export type MutationDeleteManyEhrPaymentDescriptorAuditLogArgs = {
    where?: InputMaybe<EhrPaymentDescriptorAuditLogWhereInput>;
};

export type MutationDeleteManyEhrPaymentDirectionSsAssetArgs = {
    where?: InputMaybe<EhrPaymentDirectionSsAssetWhereInput>;
};

export type MutationDeleteManyEhrPostDetailArgs = {
    where?: InputMaybe<EhrPostDetailWhereInput>;
};

export type MutationDeleteManyEhrPostDetailToPayoutArgs = {
    where?: InputMaybe<EhrPostDetailToPayoutWhereInput>;
};

export type MutationDeleteManyEhrPostLedgerArgs = {
    where?: InputMaybe<EhrPostLedgerWhereInput>;
};

export type MutationDeleteManyEhrPostLedgerAuditLogArgs = {
    where?: InputMaybe<EhrPostLedgerAuditLogWhereInput>;
};

export type MutationDeleteManyEhrPostLedgerToPayoutArgs = {
    where?: InputMaybe<EhrPostLedgerToPayoutWhereInput>;
};

export type MutationDeleteManyEhrPrimaryCareProviderArgs = {
    where?: InputMaybe<EhrPrimaryCareProviderWhereInput>;
};

export type MutationDeleteManyEhrProviderMappingArgs = {
    where?: InputMaybe<EhrProviderMappingWhereInput>;
};

export type MutationDeleteManyEhrSlotArgs = {
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type MutationDeleteManyEhrSlotAuditLogArgs = {
    where?: InputMaybe<EhrSlotAuditLogWhereInput>;
};

export type MutationDeleteManyEncounterArgs = {
    where?: InputMaybe<EncounterWhereInput>;
};

export type MutationDeleteManyExperityEncounterArgs = {
    where?: InputMaybe<ExperityEncounterWhereInput>;
};

export type MutationDeleteManyFaqDropdownsArgs = {
    where?: InputMaybe<FaqDropdownsWhereInput>;
};

export type MutationDeleteManyFeeConfigArgs = {
    where?: InputMaybe<FeeConfigWhereInput>;
};

export type MutationDeleteManyFeeConfigAuditLogArgs = {
    where?: InputMaybe<FeeConfigAuditLogWhereInput>;
};

export type MutationDeleteManyGuarantorPaymentLinkContextArgs = {
    where?: InputMaybe<GuarantorPaymentLinkContextWhereInput>;
};

export type MutationDeleteManyHolidayArgs = {
    where?: InputMaybe<HolidayWhereInput>;
};

export type MutationDeleteManyHrtArgs = {
    where?: InputMaybe<HrtWhereInput>;
};

export type MutationDeleteManyHrtFlagsArgs = {
    where?: InputMaybe<HrtFlagsWhereInput>;
};

export type MutationDeleteManyHrtPaymentTypeArgs = {
    where?: InputMaybe<HrtPaymentTypeWhereInput>;
};

export type MutationDeleteManyHrtToSrtArgs = {
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type MutationDeleteManyHrtTranslationArgs = {
    where?: InputMaybe<HrtTranslationWhereInput>;
};

export type MutationDeleteManyInboundRequestLogArgs = {
    where?: InputMaybe<InboundRequestLogWhereInput>;
};

export type MutationDeleteManyInboundTextMessageLogArgs = {
    where?: InputMaybe<InboundTextMessageLogWhereInput>;
};

export type MutationDeleteManyInsuranceArgs = {
    where?: InputMaybe<InsuranceWhereInput>;
};

export type MutationDeleteManyInsuranceAuditLogArgs = {
    where?: InputMaybe<InsuranceAuditLogWhereInput>;
};

export type MutationDeleteManyInsuranceMetadataArgs = {
    where?: InputMaybe<InsuranceMetadataWhereInput>;
};

export type MutationDeleteManyIntakeFormArgs = {
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type MutationDeleteManyIntakeFormSectionArgs = {
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type MutationDeleteManyIntakeFormSectionTranslationArgs = {
    where?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
};

export type MutationDeleteManyIntakeFormToQuestionArgs = {
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type MutationDeleteManyIntakeQuestionArgs = {
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type MutationDeleteManyIntakeQuestionTranslationArgs = {
    where?: InputMaybe<IntakeQuestionTranslationWhereInput>;
};

export type MutationDeleteManyInvoiceDailyLineItemsArgs = {
    where?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
};

export type MutationDeleteManyInvoicesArgs = {
    where?: InputMaybe<InvoicesWhereInput>;
};

export type MutationDeleteManyKeywordRuleArgs = {
    where?: InputMaybe<KeywordRuleWhereInput>;
};

export type MutationDeleteManyLinkMappingArgs = {
    where?: InputMaybe<LinkMappingWhereInput>;
};

export type MutationDeleteManyLiveTransfersArgs = {
    where?: InputMaybe<LiveTransfersWhereInput>;
};

export type MutationDeleteManyMcmsAssociationArgs = {
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type MutationDeleteManyMcmsAssociationAuditLogArgs = {
    where?: InputMaybe<McmsAssociationAuditLogWhereInput>;
};

export type MutationDeleteManyMcmsAssociationClaimArgs = {
    where?: InputMaybe<McmsAssociationClaimWhereInput>;
};

export type MutationDeleteManyMcmsAssociationClaimAuditLogArgs = {
    where?: InputMaybe<McmsAssociationClaimAuditLogWhereInput>;
};

export type MutationDeleteManyMcmsAssociationSlotArgs = {
    where?: InputMaybe<McmsAssociationSlotWhereInput>;
};

export type MutationDeleteManyMcmsAssociationSlotAuditLogArgs = {
    where?: InputMaybe<McmsAssociationSlotAuditLogWhereInput>;
};

export type MutationDeleteManyMessageBlueprintArgs = {
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type MutationDeleteManyMessageConsolidationContextArgs = {
    where?: InputMaybe<MessageConsolidationContextWhereInput>;
};

export type MutationDeleteManyMessageConsolidationTemplateArgs = {
    where?: InputMaybe<MessageConsolidationTemplateWhereInput>;
};

export type MutationDeleteManyMessageNudgeArgs = {
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type MutationDeleteManyMessageOrchestrationRuleArgs = {
    where?: InputMaybe<MessageOrchestrationRuleWhereInput>;
};

export type MutationDeleteManyMessagePayAfterArgs = {
    where?: InputMaybe<MessagePayAfterWhereInput>;
};

export type MutationDeleteManyMessageSettingsHrtArgs = {
    where?: InputMaybe<MessageSettingsHrtWhereInput>;
};

export type MutationDeleteManyMessageSettingsOrgArgs = {
    where?: InputMaybe<MessageSettingsOrgWhereInput>;
};

export type MutationDeleteManyMessageTemplateHrtArgs = {
    where?: InputMaybe<MessageTemplateHrtWhereInput>;
};

export type MutationDeleteManyMessageTemplateOrgArgs = {
    where?: InputMaybe<MessageTemplateOrgWhereInput>;
};

export type MutationDeleteManyMigratedEncounterArgs = {
    where?: InputMaybe<MigratedEncounterWhereInput>;
};

export type MutationDeleteManyMigrationsArgs = {
    where?: InputMaybe<MigrationsWhereInput>;
};

export type MutationDeleteManyNetworkValidationArgs = {
    where?: InputMaybe<NetworkValidationWhereInput>;
};

export type MutationDeleteManyNetworkPlanExceptionsArgs = {
    where?: InputMaybe<NetworkPlanExceptionsWhereInput>;
};

export type MutationDeleteManyNonCardRefundsArgs = {
    where?: InputMaybe<NonCardRefundsWhereInput>;
};

export type MutationDeleteManyOrgConfigFlagArgs = {
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type MutationDeleteManyOrgHrtSrtRuleArgs = {
    where?: InputMaybe<OrgHrtSrtRuleWhereInput>;
};

export type MutationDeleteManyOrgNetworkResultsArgs = {
    where?: InputMaybe<OrgNetworkResultsWhereInput>;
};

export type MutationDeleteManyOrgOverrideRuleArgs = {
    where?: InputMaybe<OrgOverrideRuleWhereInput>;
};

export type MutationDeleteManyOrgFeesArgs = {
    where?: InputMaybe<OrgFeesWhereInput>;
};

export type MutationDeleteManyOrgStripeMappingArgs = {
    where?: InputMaybe<OrgStripeMappingWhereInput>;
};

export type MutationDeleteManyOrganizationArgs = {
    where?: InputMaybe<OrganizationWhereInput>;
};

export type MutationDeleteManyOrganizationAssetsArgs = {
    where?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type MutationDeleteManyOrganizationTranslationArgs = {
    where?: InputMaybe<OrganizationTranslationWhereInput>;
};

export type MutationDeleteManyPayLaterAuthorizationArgs = {
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type MutationDeleteManyPayLaterAuthorizationAuditLogArgs = {
    where?: InputMaybe<PayLaterAuthorizationAuditLogWhereInput>;
};

export type MutationDeleteManyPayerArgs = {
    where?: InputMaybe<PayerWhereInput>;
};

export type MutationDeleteManyPayerPlanMappingArgs = {
    where?: InputMaybe<PayerPlanMappingWhereInput>;
};

export type MutationDeleteManyPayerToEhrInsurancePackageMappingArgs = {
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type MutationDeleteManyPaymentAuthorizationArgs = {
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type MutationDeleteManyPaymentAuthorizationAuditLogArgs = {
    where?: InputMaybe<PaymentAuthorizationAuditLogWhereInput>;
};

export type MutationDeleteManyPaymentContractArgs = {
    where?: InputMaybe<PaymentContractWhereInput>;
};

export type MutationDeleteManyPaymentPlanArgs = {
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type MutationDeleteManyPaymentPlanAdjustmentArgs = {
    where?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
};

export type MutationDeleteManyPaymentPlanAdjustmentAuditLogArgs = {
    where?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereInput>;
};

export type MutationDeleteManyPaymentPlanAuditLogArgs = {
    where?: InputMaybe<PaymentPlanAuditLogWhereInput>;
};

export type MutationDeleteManyPaymentPlanAutoChargeArgs = {
    where?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
};

export type MutationDeleteManyPaymentPlanAutoChargeAuditLogArgs = {
    where?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereInput>;
};

export type MutationDeleteManyPaymentPlanBoughtTreatmentArgs = {
    where?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
};

export type MutationDeleteManyPaymentPlanBoughtTreatmentAuditLogArgs = {
    where?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereInput>;
};

export type MutationDeleteManyPaymentPlanOrgConfigArgs = {
    where?: InputMaybe<PaymentPlanOrgConfigWhereInput>;
};

export type MutationDeleteManyPaymentPlanOrgConfigAuditLogArgs = {
    where?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereInput>;
};

export type MutationDeleteManyPayoutArgs = {
    where?: InputMaybe<PayoutWhereInput>;
};

export type MutationDeleteManyPayoutAuditLogArgs = {
    where?: InputMaybe<PayoutAuditLogWhereInput>;
};

export type MutationDeleteManyPendingVoidPayoutReversalArgs = {
    where?: InputMaybe<PendingVoidPayoutReversalWhereInput>;
};

export type MutationDeleteManyPhoneNumberTypeArgs = {
    where?: InputMaybe<PhoneNumberTypeWhereInput>;
};

export type MutationDeleteManyPlaceOfServiceCodeArgs = {
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type MutationDeleteManyPracticeArgs = {
    where?: InputMaybe<PracticeWhereInput>;
};

export type MutationDeleteManyPracticeConfigurationArgs = {
    where?: InputMaybe<PracticeConfigurationWhereInput>;
};

export type MutationDeleteManyPracticeHoursArgs = {
    where?: InputMaybe<PracticeHoursWhereInput>;
};

export type MutationDeleteManyPracticeHoursOverridesArgs = {
    where?: InputMaybe<PracticeHoursOverridesWhereInput>;
};

export type MutationDeleteManyPricedTreatmentArgs = {
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type MutationDeleteManyPricingAttemptArgs = {
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type MutationDeleteManyPricingEscalatorArgs = {
    where?: InputMaybe<PricingEscalatorWhereInput>;
};

export type MutationDeleteManyPricingQueueArgs = {
    where?: InputMaybe<PricingQueueWhereInput>;
};

export type MutationDeleteManyPricingResultsArgs = {
    where?: InputMaybe<PricingResultsWhereInput>;
};

export type MutationDeleteManyProcedureBenefitParsingRulesArgs = {
    where?: InputMaybe<ProcedureBenefitParsingRulesWhereInput>;
};

export type MutationDeleteManyProductCategoriesArgs = {
    where?: InputMaybe<ProductCategoriesWhereInput>;
};

export type MutationDeleteManyProductCategoryTranslationArgs = {
    where?: InputMaybe<ProductCategoryTranslationWhereInput>;
};

export type MutationDeleteManyProductToBundleArgs = {
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type MutationDeleteManyProductToHrtArgs = {
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type MutationDeleteManyProductTranslationArgs = {
    where?: InputMaybe<ProductTranslationWhereInput>;
};

export type MutationDeleteManyProductsArgs = {
    where?: InputMaybe<ProductsWhereInput>;
};

export type MutationDeleteManyProviderArgs = {
    where?: InputMaybe<ProviderWhereInput>;
};

export type MutationDeleteManyProviderCredentialingArgs = {
    where?: InputMaybe<ProviderCredentialingWhereInput>;
};

export type MutationDeleteManyProviderGroupArgs = {
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type MutationDeleteManyProviderGroupToHrtArgs = {
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type MutationDeleteManyProviderHrtMaxCountArgs = {
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type MutationDeleteManyProviderTaxonomyArgs = {
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type MutationDeleteManyProviderToOrgArgs = {
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type MutationDeleteManyProviderToProviderGroupArgs = {
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type MutationDeleteManyReattributionDirectionArgs = {
    where?: InputMaybe<ReattributionDirectionWhereInput>;
};

export type MutationDeleteManyReceiptArrangementArgs = {
    where?: InputMaybe<ReceiptArrangementWhereInput>;
};

export type MutationDeleteManyReservedEhrVisitArgs = {
    where?: InputMaybe<ReservedEhrVisitWhereInput>;
};

export type MutationDeleteManyResetTokenArgs = {
    where?: InputMaybe<ResetTokenWhereInput>;
};

export type MutationDeleteManySavedIntakeResponseArgs = {
    where?: InputMaybe<SavedIntakeResponseWhereInput>;
};

export type MutationDeleteManySchedulingSlotConfigArgs = {
    where?: InputMaybe<SchedulingSlotConfigWhereInput>;
};

export type MutationDeleteManyServiceTypeCodeArgs = {
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type MutationDeleteManySlotArgs = {
    where?: InputMaybe<SlotWhereInput>;
};

export type MutationDeleteManySlotAuditLogArgs = {
    where?: InputMaybe<SlotAuditLogWhereInput>;
};

export type MutationDeleteManySrtArgs = {
    where?: InputMaybe<SrtWhereInput>;
};

export type MutationDeleteManySrtFlagsArgs = {
    where?: InputMaybe<SrtFlagsWhereInput>;
};

export type MutationDeleteManySrtMultiplierRuleArgs = {
    where?: InputMaybe<SrtMultiplierRuleWhereInput>;
};

export type MutationDeleteManySrtToBillingCodeArgs = {
    where?: InputMaybe<SrtToBillingCodeWhereInput>;
};

export type MutationDeleteManyStatePayerMappingArgs = {
    where?: InputMaybe<StatePayerMappingWhereInput>;
};

export type MutationDeleteManySuperscriptFeeLineItemArgs = {
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type MutationDeleteManySuperscriptFeesArgs = {
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type MutationDeleteManySuperscriptIntakeQuestionArgs = {
    where?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
};

export type MutationDeleteManyTimeBlockArgs = {
    where?: InputMaybe<TimeBlockWhereInput>;
};

export type MutationDeleteManyTransactionArgs = {
    where?: InputMaybe<TransactionWhereInput>;
};

export type MutationDeleteManyUserArgs = {
    where?: InputMaybe<UserWhereInput>;
};

export type MutationDeleteManyUserAuditLogArgs = {
    where?: InputMaybe<UserAuditLogWhereInput>;
};

export type MutationDeleteManyUserPracticeVisitArgs = {
    where?: InputMaybe<UserPracticeVisitWhereInput>;
};

export type MutationDeleteManyUserToNewUserArgs = {
    where?: InputMaybe<UserToNewUserWhereInput>;
};

export type MutationDeleteManyValidPayersArgs = {
    where?: InputMaybe<ValidPayersWhereInput>;
};

export type MutationDeleteOneAleConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AleConfigWhereUniqueInput;
};

export type MutationDeleteOneAleDepartmentGoLiveArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AleDepartmentGoLiveWhereUniqueInput;
};

export type MutationDeleteOneAdjudicationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjudicationWhereUniqueInput;
};

export type MutationDeleteOneAdjudicationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjudicationAuditLogWhereUniqueInput;
};

export type MutationDeleteOneAdjustmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjustmentWhereUniqueInput;
};

export type MutationDeleteOneAdjustmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjustmentAuditLogWhereUniqueInput;
};

export type MutationDeleteOneAdminArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdminWhereUniqueInput;
};

export type MutationDeleteOneAdminInteractionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdminInteractionWhereUniqueInput;
};

export type MutationDeleteOneAppointmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AppointmentWhereUniqueInput;
};

export type MutationDeleteOneAppointmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AppointmentAuditLogWhereUniqueInput;
};

export type MutationDeleteOneArrearBillingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArrearBillingWhereUniqueInput;
};

export type MutationDeleteOneArtClaimArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimWhereUniqueInput;
};

export type MutationDeleteOneArtClaimAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimAuditLogWhereUniqueInput;
};

export type MutationDeleteOneArtClaimCptLineArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimCptLineWhereUniqueInput;
};

export type MutationDeleteOneArtClaimCptLineAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimCptLineAuditLogWhereUniqueInput;
};

export type MutationDeleteOneArtOrgConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtOrgConfigWhereUniqueInput;
};

export type MutationDeleteOneArtPracticeConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtPracticeConfigWhereUniqueInput;
};

export type MutationDeleteOneAthenaMedicationsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaMedicationsWhereUniqueInput;
};

export type MutationDeleteOneAthenaPharmacyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaPharmacyWhereUniqueInput;
};

export type MutationDeleteOneAthenaProviderArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaProviderWhereUniqueInput;
};

export type MutationDeleteOneBenefitParsingRulesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BenefitParsingRulesWhereUniqueInput;
};

export type MutationDeleteOneBillingCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BillingCodeWhereUniqueInput;
};

export type MutationDeleteOneBillingTableDownloadRequestArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BillingTableDownloadRequestWhereUniqueInput;
};

export type MutationDeleteOneBoughtTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentWhereUniqueInput;
};

export type MutationDeleteOneBoughtTreatmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentAuditLogWhereUniqueInput;
};

export type MutationDeleteOneBoughtTreatmentClaimDetailArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentClaimDetailWhereUniqueInput;
};

export type MutationDeleteOneBulkChargeCardRunArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BulkChargeCardRunWhereUniqueInput;
};

export type MutationDeleteOneBulkChargeCardRunItemArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BulkChargeCardRunItemWhereUniqueInput;
};

export type MutationDeleteOneBundleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BundleWhereUniqueInput;
};

export type MutationDeleteOneBundleToHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BundleToHrtWhereUniqueInput;
};

export type MutationDeleteOneBusinessHourArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BusinessHourWhereUniqueInput;
};

export type MutationDeleteOneCandidateTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CandidateTreatmentWhereUniqueInput;
};

export type MutationDeleteOneCardAuthorizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CardAuthorizationWhereUniqueInput;
};

export type MutationDeleteOneCardAuthorizationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CardAuthorizationAuditLogWhereUniqueInput;
};

export type MutationDeleteOneCashPriceArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CashPriceWhereUniqueInput;
};

export type MutationDeleteOneChargeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeWhereUniqueInput;
};

export type MutationDeleteOneChargeAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeAuditLogWhereUniqueInput;
};

export type MutationDeleteOneChargeReattributionAndPartialPaymentLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeReattributionAndPartialPaymentLogWhereUniqueInput;
};

export type MutationDeleteOneChargeReattributionLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeReattributionLogWhereUniqueInput;
};

export type MutationDeleteOneCheckNetworkStatusResultsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CheckNetworkStatusResultsWhereUniqueInput;
};

export type MutationDeleteOneCheckoutAdjudicationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CheckoutAdjudicationWhereUniqueInput;
};

export type MutationDeleteOneClaimToBoughtTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ClaimToBoughtTreatmentWhereUniqueInput;
};

export type MutationDeleteOneConfigCommitArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigCommitWhereUniqueInput;
};

export type MutationDeleteOneConfigFlagArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigFlagWhereUniqueInput;
};

export type MutationDeleteOneConfigSessionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigSessionWhereUniqueInput;
};

export type MutationDeleteOneConsentFormArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsentFormWhereUniqueInput;
};

export type MutationDeleteOneConsumerArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerWhereUniqueInput;
};

export type MutationDeleteOneConsumerAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerAuditLogWhereUniqueInput;
};

export type MutationDeleteOneConsumerMessageArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerMessageWhereUniqueInput;
};

export type MutationDeleteOneConsumerNoteArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerNoteWhereUniqueInput;
};

export type MutationDeleteOneConsumerPhotoMetaDataArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type MutationDeleteOneConsumerSrtRecordsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerSrtRecordsWhereUniqueInput;
};

export type MutationDeleteOneContractArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ContractWhereUniqueInput;
};

export type MutationDeleteOneContractAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ContractAuditLogWhereUniqueInput;
};

export type MutationDeleteOneCoverageResponsesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CoverageResponsesWhereUniqueInput;
};

export type MutationDeleteOneCptExclusivityEdgeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CptExclusivityEdgeWhereUniqueInput;
};

export type MutationDeleteOneCustomFieldArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CustomFieldWhereUniqueInput;
};

export type MutationDeleteOneCustomFieldValueArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CustomFieldValueWhereUniqueInput;
};

export type MutationDeleteOneDataMigrationsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DataMigrationsWhereUniqueInput;
};

export type MutationDeleteOneDefaultPracticeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DefaultPracticeWhereUniqueInput;
};

export type MutationDeleteOneDefaultProvidersArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DefaultProvidersWhereUniqueInput;
};

export type MutationDeleteOneDeploymentOrgPhaseArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type MutationDeleteOneDeploymentOrgTaskArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type MutationDeleteOneDeploymentOrgTaskDependencyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgTaskDependencyWhereUniqueInput;
};

export type MutationDeleteOneDeploymentPhaseArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentPhaseWhereUniqueInput;
};

export type MutationDeleteOneDeploymentTaskArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTaskWhereUniqueInput;
};

export type MutationDeleteOneDeploymentTaskDependencyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTaskDependencyWhereUniqueInput;
};

export type MutationDeleteOneDeploymentTeamArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTeamWhereUniqueInput;
};

export type MutationDeleteOneDiscountCodesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DiscountCodesWhereUniqueInput;
};

export type MutationDeleteOneEcwPayerAliasArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EcwPayerAliasWhereUniqueInput;
};

export type MutationDeleteOneEcwPayerStcArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EcwPayerStcWhereUniqueInput;
};

export type MutationDeleteOneEhrAppointmentTypeIdToNameArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrAppointmentTypeIdToNameWhereUniqueInput;
};

export type MutationDeleteOneEhrPaymentDescriptorArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDescriptorWhereUniqueInput;
};

export type MutationDeleteOneEhrPaymentDescriptorAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDescriptorAuditLogWhereUniqueInput;
};

export type MutationDeleteOneEhrPaymentDirectionSsAssetArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDirectionSsAssetWhereUniqueInput;
};

export type MutationDeleteOneEhrPostDetailArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostDetailWhereUniqueInput;
};

export type MutationDeleteOneEhrPostDetailToPayoutArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostDetailToPayoutWhereUniqueInput;
};

export type MutationDeleteOneEhrPostLedgerArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerWhereUniqueInput;
};

export type MutationDeleteOneEhrPostLedgerAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerAuditLogWhereUniqueInput;
};

export type MutationDeleteOneEhrPostLedgerToPayoutArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerToPayoutWhereUniqueInput;
};

export type MutationDeleteOneEhrPrimaryCareProviderArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPrimaryCareProviderWhereUniqueInput;
};

export type MutationDeleteOneEhrProviderMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrProviderMappingWhereUniqueInput;
};

export type MutationDeleteOneEhrSlotArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrSlotWhereUniqueInput;
};

export type MutationDeleteOneEhrSlotAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrSlotAuditLogWhereUniqueInput;
};

export type MutationDeleteOneEncounterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EncounterWhereUniqueInput;
};

export type MutationDeleteOneExperityEncounterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ExperityEncounterWhereUniqueInput;
};

export type MutationDeleteOneFaqDropdownsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FaqDropdownsWhereUniqueInput;
};

export type MutationDeleteOneFeeConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FeeConfigWhereUniqueInput;
};

export type MutationDeleteOneFeeConfigAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FeeConfigAuditLogWhereUniqueInput;
};

export type MutationDeleteOneGuarantorPaymentLinkContextArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: GuarantorPaymentLinkContextWhereUniqueInput;
};

export type MutationDeleteOneHolidayArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HolidayWhereUniqueInput;
};

export type MutationDeleteOneHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtWhereUniqueInput;
};

export type MutationDeleteOneHrtFlagsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtFlagsWhereUniqueInput;
};

export type MutationDeleteOneHrtPaymentTypeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtPaymentTypeWhereUniqueInput;
};

export type MutationDeleteOneHrtToSrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtToSrtWhereUniqueInput;
};

export type MutationDeleteOneHrtTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtTranslationWhereUniqueInput;
};

export type MutationDeleteOneInboundRequestLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InboundRequestLogWhereUniqueInput;
};

export type MutationDeleteOneInboundTextMessageLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InboundTextMessageLogWhereUniqueInput;
};

export type MutationDeleteOneInsuranceArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceWhereUniqueInput;
};

export type MutationDeleteOneInsuranceAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceAuditLogWhereUniqueInput;
};

export type MutationDeleteOneInsuranceMetadataArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceMetadataWhereUniqueInput;
};

export type MutationDeleteOneIntakeFormArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormWhereUniqueInput;
};

export type MutationDeleteOneIntakeFormSectionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormSectionWhereUniqueInput;
};

export type MutationDeleteOneIntakeFormSectionTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormSectionTranslationWhereUniqueInput;
};

export type MutationDeleteOneIntakeFormToQuestionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormToQuestionWhereUniqueInput;
};

export type MutationDeleteOneIntakeQuestionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeQuestionWhereUniqueInput;
};

export type MutationDeleteOneIntakeQuestionTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeQuestionTranslationWhereUniqueInput;
};

export type MutationDeleteOneInvoiceDailyLineItemsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InvoiceDailyLineItemsWhereUniqueInput;
};

export type MutationDeleteOneInvoicesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InvoicesWhereUniqueInput;
};

export type MutationDeleteOneKeywordRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: KeywordRuleWhereUniqueInput;
};

export type MutationDeleteOneLinkMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: LinkMappingWhereUniqueInput;
};

export type MutationDeleteOneLiveTransfersArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: LiveTransfersWhereUniqueInput;
};

export type MutationDeleteOneMcmsAssociationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationWhereUniqueInput;
};

export type MutationDeleteOneMcmsAssociationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationAuditLogWhereUniqueInput;
};

export type MutationDeleteOneMcmsAssociationClaimArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationClaimWhereUniqueInput;
};

export type MutationDeleteOneMcmsAssociationClaimAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationClaimAuditLogWhereUniqueInput;
};

export type MutationDeleteOneMcmsAssociationSlotArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationSlotWhereUniqueInput;
};

export type MutationDeleteOneMcmsAssociationSlotAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationSlotAuditLogWhereUniqueInput;
};

export type MutationDeleteOneMessageBlueprintArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageBlueprintWhereUniqueInput;
};

export type MutationDeleteOneMessageConsolidationContextArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageConsolidationContextWhereUniqueInput;
};

export type MutationDeleteOneMessageConsolidationTemplateArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageConsolidationTemplateWhereUniqueInput;
};

export type MutationDeleteOneMessageNudgeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageNudgeWhereUniqueInput;
};

export type MutationDeleteOneMessageOrchestrationRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageOrchestrationRuleWhereUniqueInput;
};

export type MutationDeleteOneMessagePayAfterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessagePayAfterWhereUniqueInput;
};

export type MutationDeleteOneMessageSettingsHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageSettingsHrtWhereUniqueInput;
};

export type MutationDeleteOneMessageSettingsOrgArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageSettingsOrgWhereUniqueInput;
};

export type MutationDeleteOneMessageTemplateHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageTemplateHrtWhereUniqueInput;
};

export type MutationDeleteOneMessageTemplateOrgArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageTemplateOrgWhereUniqueInput;
};

export type MutationDeleteOneMigratedEncounterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MigratedEncounterWhereUniqueInput;
};

export type MutationDeleteOneMigrationsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MigrationsWhereUniqueInput;
};

export type MutationDeleteOneNetworkValidationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NetworkValidationWhereUniqueInput;
};

export type MutationDeleteOneNetworkPlanExceptionsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NetworkPlanExceptionsWhereUniqueInput;
};

export type MutationDeleteOneNonCardRefundsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NonCardRefundsWhereUniqueInput;
};

export type MutationDeleteOneOrgConfigFlagArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgConfigFlagWhereUniqueInput;
};

export type MutationDeleteOneOrgHrtSrtRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgHrtSrtRuleWhereUniqueInput;
};

export type MutationDeleteOneOrgNetworkResultsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgNetworkResultsWhereUniqueInput;
};

export type MutationDeleteOneOrgOverrideRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgOverrideRuleWhereUniqueInput;
};

export type MutationDeleteOneOrgFeesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgFeesWhereUniqueInput;
};

export type MutationDeleteOneOrgStripeMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgStripeMappingWhereUniqueInput;
};

export type MutationDeleteOneOrganizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationWhereUniqueInput;
};

export type MutationDeleteOneOrganizationAssetsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationAssetsWhereUniqueInput;
};

export type MutationDeleteOneOrganizationTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationTranslationWhereUniqueInput;
};

export type MutationDeleteOnePayLaterAuthorizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayLaterAuthorizationWhereUniqueInput;
};

export type MutationDeleteOnePayLaterAuthorizationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayLaterAuthorizationAuditLogWhereUniqueInput;
};

export type MutationDeleteOnePayerArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerWhereUniqueInput;
};

export type MutationDeleteOnePayerPlanMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerPlanMappingWhereUniqueInput;
};

export type MutationDeleteOnePayerToEhrInsurancePackageMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
};

export type MutationDeleteOnePaymentAuthorizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentAuthorizationWhereUniqueInput;
};

export type MutationDeleteOnePaymentAuthorizationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentAuthorizationAuditLogWhereUniqueInput;
};

export type MutationDeleteOnePaymentContractArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentContractWhereUniqueInput;
};

export type MutationDeleteOnePaymentPlanArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanWhereUniqueInput;
};

export type MutationDeleteOnePaymentPlanAdjustmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAdjustmentWhereUniqueInput;
};

export type MutationDeleteOnePaymentPlanAdjustmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAdjustmentAuditLogWhereUniqueInput;
};

export type MutationDeleteOnePaymentPlanAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAuditLogWhereUniqueInput;
};

export type MutationDeleteOnePaymentPlanAutoChargeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAutoChargeWhereUniqueInput;
};

export type MutationDeleteOnePaymentPlanAutoChargeAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAutoChargeAuditLogWhereUniqueInput;
};

export type MutationDeleteOnePaymentPlanBoughtTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanBoughtTreatmentWhereUniqueInput;
};

export type MutationDeleteOnePaymentPlanBoughtTreatmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanBoughtTreatmentAuditLogWhereUniqueInput;
};

export type MutationDeleteOnePaymentPlanOrgConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanOrgConfigWhereUniqueInput;
};

export type MutationDeleteOnePaymentPlanOrgConfigAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanOrgConfigAuditLogWhereUniqueInput;
};

export type MutationDeleteOnePayoutArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayoutWhereUniqueInput;
};

export type MutationDeleteOnePayoutAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayoutAuditLogWhereUniqueInput;
};

export type MutationDeleteOnePendingVoidPayoutReversalArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PendingVoidPayoutReversalWhereUniqueInput;
};

export type MutationDeleteOnePhoneNumberTypeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PhoneNumberTypeWhereUniqueInput;
};

export type MutationDeleteOnePlaceOfServiceCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PlaceOfServiceCodeWhereUniqueInput;
};

export type MutationDeleteOnePracticeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeWhereUniqueInput;
};

export type MutationDeleteOnePracticeConfigurationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeConfigurationWhereUniqueInput;
};

export type MutationDeleteOnePracticeHoursArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeHoursWhereUniqueInput;
};

export type MutationDeleteOnePracticeHoursOverridesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeHoursOverridesWhereUniqueInput;
};

export type MutationDeleteOnePricedTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricedTreatmentWhereUniqueInput;
};

export type MutationDeleteOnePricingAttemptArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingAttemptWhereUniqueInput;
};

export type MutationDeleteOnePricingEscalatorArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingEscalatorWhereUniqueInput;
};

export type MutationDeleteOnePricingQueueArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingQueueWhereUniqueInput;
};

export type MutationDeleteOnePricingResultsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingResultsWhereUniqueInput;
};

export type MutationDeleteOneProcedureBenefitParsingRulesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProcedureBenefitParsingRulesWhereUniqueInput;
};

export type MutationDeleteOneProductCategoriesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductCategoriesWhereUniqueInput;
};

export type MutationDeleteOneProductCategoryTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductCategoryTranslationWhereUniqueInput;
};

export type MutationDeleteOneProductToBundleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductToBundleWhereUniqueInput;
};

export type MutationDeleteOneProductToHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductToHrtWhereUniqueInput;
};

export type MutationDeleteOneProductTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductTranslationWhereUniqueInput;
};

export type MutationDeleteOneProductsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductsWhereUniqueInput;
};

export type MutationDeleteOneProviderArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderWhereUniqueInput;
};

export type MutationDeleteOneProviderCredentialingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderCredentialingWhereUniqueInput;
};

export type MutationDeleteOneProviderGroupArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderGroupWhereUniqueInput;
};

export type MutationDeleteOneProviderGroupToHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type MutationDeleteOneProviderHrtMaxCountArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type MutationDeleteOneProviderTaxonomyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderTaxonomyWhereUniqueInput;
};

export type MutationDeleteOneProviderToOrgArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderToOrgWhereUniqueInput;
};

export type MutationDeleteOneProviderToProviderGroupArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderToProviderGroupWhereUniqueInput;
};

export type MutationDeleteOneReattributionDirectionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReattributionDirectionWhereUniqueInput;
};

export type MutationDeleteOneReceiptArrangementArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReceiptArrangementWhereUniqueInput;
};

export type MutationDeleteOneReservedEhrVisitArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReservedEhrVisitWhereUniqueInput;
};

export type MutationDeleteOneResetTokenArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ResetTokenWhereUniqueInput;
};

export type MutationDeleteOneSavedIntakeResponseArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SavedIntakeResponseWhereUniqueInput;
};

export type MutationDeleteOneSchedulingSlotConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SchedulingSlotConfigWhereUniqueInput;
};

export type MutationDeleteOneServiceTypeCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ServiceTypeCodeWhereUniqueInput;
};

export type MutationDeleteOneSlotArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SlotWhereUniqueInput;
};

export type MutationDeleteOneSlotAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SlotAuditLogWhereUniqueInput;
};

export type MutationDeleteOneSrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtWhereUniqueInput;
};

export type MutationDeleteOneSrtFlagsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtFlagsWhereUniqueInput;
};

export type MutationDeleteOneSrtMultiplierRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtMultiplierRuleWhereUniqueInput;
};

export type MutationDeleteOneSrtToBillingCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtToBillingCodeWhereUniqueInput;
};

export type MutationDeleteOneStatePayerMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: StatePayerMappingWhereUniqueInput;
};

export type MutationDeleteOneSuperscriptFeeLineItemArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptFeeLineItemWhereUniqueInput;
};

export type MutationDeleteOneSuperscriptFeesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptFeesWhereUniqueInput;
};

export type MutationDeleteOneSuperscriptIntakeQuestionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptIntakeQuestionWhereUniqueInput;
};

export type MutationDeleteOneTimeBlockArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: TimeBlockWhereUniqueInput;
};

export type MutationDeleteOneTransactionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: TransactionWhereUniqueInput;
};

export type MutationDeleteOneUserArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserWhereUniqueInput;
};

export type MutationDeleteOneUserAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserAuditLogWhereUniqueInput;
};

export type MutationDeleteOneUserPracticeVisitArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserPracticeVisitWhereUniqueInput;
};

export type MutationDeleteOneUserToNewUserArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserToNewUserWhereUniqueInput;
};

export type MutationDeleteOneValidPayersArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ValidPayersWhereUniqueInput;
};

export type MutationMarkAppointmentArrivedArgs = {
    id: Scalars['String']['input'];
    markedAsArrivedBy: Scalars['String']['input'];
};

export type MutationMarkAppointmentUnarrivedArgs = {
    id: Scalars['String']['input'];
    markedAsUnarrivedBy: Scalars['String']['input'];
};

export type MutationPayChargesArgs = {
    transactionMetadata: CreateTransactionRequestDto;
};

export type MutationRelinkInsurancePhotoArgs = {
    data: RelinkInsurancePhotoInput;
};

export type MutationUpdateConsumerAndEhrPatientArgs = {
    data: ConsumerUpdateInput;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['String']['input'];
};

export type MutationUpdateInsuranceArgs = {
    data: UpdateInsuranceInput;
};

export type MutationUpdateManyAleConfigArgs = {
    data: AleConfigUpdateManyMutationInput;
    where?: InputMaybe<AleConfigWhereInput>;
};

export type MutationUpdateManyAleDepartmentGoLiveArgs = {
    data: AleDepartmentGoLiveUpdateManyMutationInput;
    where?: InputMaybe<AleDepartmentGoLiveWhereInput>;
};

export type MutationUpdateManyAdjudicationArgs = {
    data: AdjudicationUpdateManyMutationInput;
    where?: InputMaybe<AdjudicationWhereInput>;
};

export type MutationUpdateManyAdjudicationAuditLogArgs = {
    data: AdjudicationAuditLogUpdateManyMutationInput;
    where?: InputMaybe<AdjudicationAuditLogWhereInput>;
};

export type MutationUpdateManyAdjustmentArgs = {
    data: AdjustmentUpdateManyMutationInput;
    where?: InputMaybe<AdjustmentWhereInput>;
};

export type MutationUpdateManyAdjustmentAuditLogArgs = {
    data: AdjustmentAuditLogUpdateManyMutationInput;
    where?: InputMaybe<AdjustmentAuditLogWhereInput>;
};

export type MutationUpdateManyAdminArgs = {
    data: AdminUpdateManyMutationInput;
    where?: InputMaybe<AdminWhereInput>;
};

export type MutationUpdateManyAdminInteractionArgs = {
    data: AdminInteractionUpdateManyMutationInput;
    where?: InputMaybe<AdminInteractionWhereInput>;
};

export type MutationUpdateManyAppointmentArgs = {
    data: AppointmentUpdateManyMutationInput;
    where?: InputMaybe<AppointmentWhereInput>;
};

export type MutationUpdateManyAppointmentAuditLogArgs = {
    data: AppointmentAuditLogUpdateManyMutationInput;
    where?: InputMaybe<AppointmentAuditLogWhereInput>;
};

export type MutationUpdateManyArrearBillingArgs = {
    data: ArrearBillingUpdateManyMutationInput;
    where?: InputMaybe<ArrearBillingWhereInput>;
};

export type MutationUpdateManyArtClaimArgs = {
    data: ArtClaimUpdateManyMutationInput;
    where?: InputMaybe<ArtClaimWhereInput>;
};

export type MutationUpdateManyArtClaimAuditLogArgs = {
    data: ArtClaimAuditLogUpdateManyMutationInput;
    where?: InputMaybe<ArtClaimAuditLogWhereInput>;
};

export type MutationUpdateManyArtClaimCptLineArgs = {
    data: ArtClaimCptLineUpdateManyMutationInput;
    where?: InputMaybe<ArtClaimCptLineWhereInput>;
};

export type MutationUpdateManyArtClaimCptLineAuditLogArgs = {
    data: ArtClaimCptLineAuditLogUpdateManyMutationInput;
    where?: InputMaybe<ArtClaimCptLineAuditLogWhereInput>;
};

export type MutationUpdateManyArtOrgConfigArgs = {
    data: ArtOrgConfigUpdateManyMutationInput;
    where?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type MutationUpdateManyArtPracticeConfigArgs = {
    data: ArtPracticeConfigUpdateManyMutationInput;
    where?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type MutationUpdateManyAthenaMedicationsArgs = {
    data: AthenaMedicationsUpdateManyMutationInput;
    where?: InputMaybe<AthenaMedicationsWhereInput>;
};

export type MutationUpdateManyAthenaPharmacyArgs = {
    data: AthenaPharmacyUpdateManyMutationInput;
    where?: InputMaybe<AthenaPharmacyWhereInput>;
};

export type MutationUpdateManyAthenaProviderArgs = {
    data: AthenaProviderUpdateManyMutationInput;
    where?: InputMaybe<AthenaProviderWhereInput>;
};

export type MutationUpdateManyBenefitParsingRulesArgs = {
    data: BenefitParsingRulesUpdateManyMutationInput;
    where?: InputMaybe<BenefitParsingRulesWhereInput>;
};

export type MutationUpdateManyBillingCodeArgs = {
    data: BillingCodeUpdateManyMutationInput;
    where?: InputMaybe<BillingCodeWhereInput>;
};

export type MutationUpdateManyBillingTableDownloadRequestArgs = {
    data: BillingTableDownloadRequestUpdateManyMutationInput;
    where?: InputMaybe<BillingTableDownloadRequestWhereInput>;
};

export type MutationUpdateManyBoughtTreatmentArgs = {
    data: BoughtTreatmentUpdateManyMutationInput;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type MutationUpdateManyBoughtTreatmentAuditLogArgs = {
    data: BoughtTreatmentAuditLogUpdateManyMutationInput;
    where?: InputMaybe<BoughtTreatmentAuditLogWhereInput>;
};

export type MutationUpdateManyBoughtTreatmentClaimDetailArgs = {
    data: BoughtTreatmentClaimDetailUpdateManyMutationInput;
    where?: InputMaybe<BoughtTreatmentClaimDetailWhereInput>;
};

export type MutationUpdateManyBulkChargeCardRunArgs = {
    data: BulkChargeCardRunUpdateManyMutationInput;
    where?: InputMaybe<BulkChargeCardRunWhereInput>;
};

export type MutationUpdateManyBulkChargeCardRunItemArgs = {
    data: BulkChargeCardRunItemUpdateManyMutationInput;
    where?: InputMaybe<BulkChargeCardRunItemWhereInput>;
};

export type MutationUpdateManyBundleArgs = {
    data: BundleUpdateManyMutationInput;
    where?: InputMaybe<BundleWhereInput>;
};

export type MutationUpdateManyBundleToHrtArgs = {
    data: BundleToHrtUpdateManyMutationInput;
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type MutationUpdateManyBusinessHourArgs = {
    data: BusinessHourUpdateManyMutationInput;
    where?: InputMaybe<BusinessHourWhereInput>;
};

export type MutationUpdateManyCandidateTreatmentArgs = {
    data: CandidateTreatmentUpdateManyMutationInput;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type MutationUpdateManyCardAuthorizationArgs = {
    data: CardAuthorizationUpdateManyMutationInput;
    where?: InputMaybe<CardAuthorizationWhereInput>;
};

export type MutationUpdateManyCardAuthorizationAuditLogArgs = {
    data: CardAuthorizationAuditLogUpdateManyMutationInput;
    where?: InputMaybe<CardAuthorizationAuditLogWhereInput>;
};

export type MutationUpdateManyCashPriceArgs = {
    data: CashPriceUpdateManyMutationInput;
    where?: InputMaybe<CashPriceWhereInput>;
};

export type MutationUpdateManyChargeArgs = {
    data: ChargeUpdateManyMutationInput;
    where?: InputMaybe<ChargeWhereInput>;
};

export type MutationUpdateManyChargeAuditLogArgs = {
    data: ChargeAuditLogUpdateManyMutationInput;
    where?: InputMaybe<ChargeAuditLogWhereInput>;
};

export type MutationUpdateManyChargeReattributionAndPartialPaymentLogArgs = {
    data: ChargeReattributionAndPartialPaymentLogUpdateManyMutationInput;
    where?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereInput>;
};

export type MutationUpdateManyChargeReattributionLogArgs = {
    data: ChargeReattributionLogUpdateManyMutationInput;
    where?: InputMaybe<ChargeReattributionLogWhereInput>;
};

export type MutationUpdateManyCheckNetworkStatusResultsArgs = {
    data: CheckNetworkStatusResultsUpdateManyMutationInput;
    where?: InputMaybe<CheckNetworkStatusResultsWhereInput>;
};

export type MutationUpdateManyCheckoutAdjudicationArgs = {
    data: CheckoutAdjudicationUpdateManyMutationInput;
    where?: InputMaybe<CheckoutAdjudicationWhereInput>;
};

export type MutationUpdateManyClaimToBoughtTreatmentArgs = {
    data: ClaimToBoughtTreatmentUpdateManyMutationInput;
    where?: InputMaybe<ClaimToBoughtTreatmentWhereInput>;
};

export type MutationUpdateManyConfigCommitArgs = {
    data: ConfigCommitUpdateManyMutationInput;
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type MutationUpdateManyConfigFlagArgs = {
    data: ConfigFlagUpdateManyMutationInput;
    where?: InputMaybe<ConfigFlagWhereInput>;
};

export type MutationUpdateManyConfigSessionArgs = {
    data: ConfigSessionUpdateManyMutationInput;
    where?: InputMaybe<ConfigSessionWhereInput>;
};

export type MutationUpdateManyConsentFormArgs = {
    data: ConsentFormUpdateManyMutationInput;
    where?: InputMaybe<ConsentFormWhereInput>;
};

export type MutationUpdateManyConsumerArgs = {
    data: ConsumerUpdateManyMutationInput;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type MutationUpdateManyConsumerAuditLogArgs = {
    data: ConsumerAuditLogUpdateManyMutationInput;
    where?: InputMaybe<ConsumerAuditLogWhereInput>;
};

export type MutationUpdateManyConsumerMessageArgs = {
    data: ConsumerMessageUpdateManyMutationInput;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type MutationUpdateManyConsumerNoteArgs = {
    data: ConsumerNoteUpdateManyMutationInput;
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type MutationUpdateManyConsumerPhotoMetaDataArgs = {
    data: ConsumerPhotoMetaDataUpdateManyMutationInput;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type MutationUpdateManyConsumerSrtRecordsArgs = {
    data: ConsumerSrtRecordsUpdateManyMutationInput;
    where?: InputMaybe<ConsumerSrtRecordsWhereInput>;
};

export type MutationUpdateManyContractArgs = {
    data: ContractUpdateManyMutationInput;
    where?: InputMaybe<ContractWhereInput>;
};

export type MutationUpdateManyContractAuditLogArgs = {
    data: ContractAuditLogUpdateManyMutationInput;
    where?: InputMaybe<ContractAuditLogWhereInput>;
};

export type MutationUpdateManyCoverageResponsesArgs = {
    data: CoverageResponsesUpdateManyMutationInput;
    where?: InputMaybe<CoverageResponsesWhereInput>;
};

export type MutationUpdateManyCptExclusivityEdgeArgs = {
    data: CptExclusivityEdgeUpdateManyMutationInput;
    where?: InputMaybe<CptExclusivityEdgeWhereInput>;
};

export type MutationUpdateManyCustomFieldArgs = {
    data: CustomFieldUpdateManyMutationInput;
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type MutationUpdateManyCustomFieldValueArgs = {
    data: CustomFieldValueUpdateManyMutationInput;
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type MutationUpdateManyDataMigrationsArgs = {
    data: DataMigrationsUpdateManyMutationInput;
    where?: InputMaybe<DataMigrationsWhereInput>;
};

export type MutationUpdateManyDefaultPracticeArgs = {
    data: DefaultPracticeUpdateManyMutationInput;
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type MutationUpdateManyDefaultProvidersArgs = {
    data: DefaultProvidersUpdateManyMutationInput;
    where?: InputMaybe<DefaultProvidersWhereInput>;
};

export type MutationUpdateManyDeploymentOrgPhaseArgs = {
    data: DeploymentOrgPhaseUpdateManyMutationInput;
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type MutationUpdateManyDeploymentOrgTaskArgs = {
    data: DeploymentOrgTaskUpdateManyMutationInput;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type MutationUpdateManyDeploymentOrgTaskDependencyArgs = {
    data: DeploymentOrgTaskDependencyUpdateManyMutationInput;
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type MutationUpdateManyDeploymentPhaseArgs = {
    data: DeploymentPhaseUpdateManyMutationInput;
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type MutationUpdateManyDeploymentTaskArgs = {
    data: DeploymentTaskUpdateManyMutationInput;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type MutationUpdateManyDeploymentTaskDependencyArgs = {
    data: DeploymentTaskDependencyUpdateManyMutationInput;
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type MutationUpdateManyDeploymentTeamArgs = {
    data: DeploymentTeamUpdateManyMutationInput;
    where?: InputMaybe<DeploymentTeamWhereInput>;
};

export type MutationUpdateManyDiscountCodesArgs = {
    data: DiscountCodesUpdateManyMutationInput;
    where?: InputMaybe<DiscountCodesWhereInput>;
};

export type MutationUpdateManyEcwPayerAliasArgs = {
    data: EcwPayerAliasUpdateManyMutationInput;
    where?: InputMaybe<EcwPayerAliasWhereInput>;
};

export type MutationUpdateManyEcwPayerStcArgs = {
    data: EcwPayerStcUpdateManyMutationInput;
    where?: InputMaybe<EcwPayerStcWhereInput>;
};

export type MutationUpdateManyEhrAppointmentTypeIdToNameArgs = {
    data: EhrAppointmentTypeIdToNameUpdateManyMutationInput;
    where?: InputMaybe<EhrAppointmentTypeIdToNameWhereInput>;
};

export type MutationUpdateManyEhrPaymentDescriptorArgs = {
    data: EhrPaymentDescriptorUpdateManyMutationInput;
    where?: InputMaybe<EhrPaymentDescriptorWhereInput>;
};

export type MutationUpdateManyEhrPaymentDescriptorAuditLogArgs = {
    data: EhrPaymentDescriptorAuditLogUpdateManyMutationInput;
    where?: InputMaybe<EhrPaymentDescriptorAuditLogWhereInput>;
};

export type MutationUpdateManyEhrPaymentDirectionSsAssetArgs = {
    data: EhrPaymentDirectionSsAssetUpdateManyMutationInput;
    where?: InputMaybe<EhrPaymentDirectionSsAssetWhereInput>;
};

export type MutationUpdateManyEhrPostDetailArgs = {
    data: EhrPostDetailUpdateManyMutationInput;
    where?: InputMaybe<EhrPostDetailWhereInput>;
};

export type MutationUpdateManyEhrPostDetailToPayoutArgs = {
    data: EhrPostDetailToPayoutUpdateManyMutationInput;
    where?: InputMaybe<EhrPostDetailToPayoutWhereInput>;
};

export type MutationUpdateManyEhrPostLedgerArgs = {
    data: EhrPostLedgerUpdateManyMutationInput;
    where?: InputMaybe<EhrPostLedgerWhereInput>;
};

export type MutationUpdateManyEhrPostLedgerAuditLogArgs = {
    data: EhrPostLedgerAuditLogUpdateManyMutationInput;
    where?: InputMaybe<EhrPostLedgerAuditLogWhereInput>;
};

export type MutationUpdateManyEhrPostLedgerToPayoutArgs = {
    data: EhrPostLedgerToPayoutUpdateManyMutationInput;
    where?: InputMaybe<EhrPostLedgerToPayoutWhereInput>;
};

export type MutationUpdateManyEhrPrimaryCareProviderArgs = {
    data: EhrPrimaryCareProviderUpdateManyMutationInput;
    where?: InputMaybe<EhrPrimaryCareProviderWhereInput>;
};

export type MutationUpdateManyEhrProviderMappingArgs = {
    data: EhrProviderMappingUpdateManyMutationInput;
    where?: InputMaybe<EhrProviderMappingWhereInput>;
};

export type MutationUpdateManyEhrSlotArgs = {
    data: EhrSlotUpdateManyMutationInput;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type MutationUpdateManyEhrSlotAuditLogArgs = {
    data: EhrSlotAuditLogUpdateManyMutationInput;
    where?: InputMaybe<EhrSlotAuditLogWhereInput>;
};

export type MutationUpdateManyEncounterArgs = {
    data: EncounterUpdateManyMutationInput;
    where?: InputMaybe<EncounterWhereInput>;
};

export type MutationUpdateManyExperityEncounterArgs = {
    data: ExperityEncounterUpdateManyMutationInput;
    where?: InputMaybe<ExperityEncounterWhereInput>;
};

export type MutationUpdateManyFaqDropdownsArgs = {
    data: FaqDropdownsUpdateManyMutationInput;
    where?: InputMaybe<FaqDropdownsWhereInput>;
};

export type MutationUpdateManyFeeConfigArgs = {
    data: FeeConfigUpdateManyMutationInput;
    where?: InputMaybe<FeeConfigWhereInput>;
};

export type MutationUpdateManyFeeConfigAuditLogArgs = {
    data: FeeConfigAuditLogUpdateManyMutationInput;
    where?: InputMaybe<FeeConfigAuditLogWhereInput>;
};

export type MutationUpdateManyGuarantorPaymentLinkContextArgs = {
    data: GuarantorPaymentLinkContextUpdateManyMutationInput;
    where?: InputMaybe<GuarantorPaymentLinkContextWhereInput>;
};

export type MutationUpdateManyHolidayArgs = {
    data: HolidayUpdateManyMutationInput;
    where?: InputMaybe<HolidayWhereInput>;
};

export type MutationUpdateManyHrtArgs = {
    data: HrtUpdateManyMutationInput;
    where?: InputMaybe<HrtWhereInput>;
};

export type MutationUpdateManyHrtFlagsArgs = {
    data: HrtFlagsUpdateManyMutationInput;
    where?: InputMaybe<HrtFlagsWhereInput>;
};

export type MutationUpdateManyHrtPaymentTypeArgs = {
    data: HrtPaymentTypeUpdateManyMutationInput;
    where?: InputMaybe<HrtPaymentTypeWhereInput>;
};

export type MutationUpdateManyHrtToSrtArgs = {
    data: HrtToSrtUpdateManyMutationInput;
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type MutationUpdateManyHrtTranslationArgs = {
    data: HrtTranslationUpdateManyMutationInput;
    where?: InputMaybe<HrtTranslationWhereInput>;
};

export type MutationUpdateManyInboundRequestLogArgs = {
    data: InboundRequestLogUpdateManyMutationInput;
    where?: InputMaybe<InboundRequestLogWhereInput>;
};

export type MutationUpdateManyInboundTextMessageLogArgs = {
    data: InboundTextMessageLogUpdateManyMutationInput;
    where?: InputMaybe<InboundTextMessageLogWhereInput>;
};

export type MutationUpdateManyInsuranceArgs = {
    data: InsuranceUpdateManyMutationInput;
    where?: InputMaybe<InsuranceWhereInput>;
};

export type MutationUpdateManyInsuranceAuditLogArgs = {
    data: InsuranceAuditLogUpdateManyMutationInput;
    where?: InputMaybe<InsuranceAuditLogWhereInput>;
};

export type MutationUpdateManyInsuranceMetadataArgs = {
    data: InsuranceMetadataUpdateManyMutationInput;
    where?: InputMaybe<InsuranceMetadataWhereInput>;
};

export type MutationUpdateManyIntakeFormArgs = {
    data: IntakeFormUpdateManyMutationInput;
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type MutationUpdateManyIntakeFormSectionArgs = {
    data: IntakeFormSectionUpdateManyMutationInput;
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type MutationUpdateManyIntakeFormSectionTranslationArgs = {
    data: IntakeFormSectionTranslationUpdateManyMutationInput;
    where?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
};

export type MutationUpdateManyIntakeFormToQuestionArgs = {
    data: IntakeFormToQuestionUpdateManyMutationInput;
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type MutationUpdateManyIntakeQuestionArgs = {
    data: IntakeQuestionUpdateManyMutationInput;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type MutationUpdateManyIntakeQuestionTranslationArgs = {
    data: IntakeQuestionTranslationUpdateManyMutationInput;
    where?: InputMaybe<IntakeQuestionTranslationWhereInput>;
};

export type MutationUpdateManyInvoiceDailyLineItemsArgs = {
    data: InvoiceDailyLineItemsUpdateManyMutationInput;
    where?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
};

export type MutationUpdateManyInvoicesArgs = {
    data: InvoicesUpdateManyMutationInput;
    where?: InputMaybe<InvoicesWhereInput>;
};

export type MutationUpdateManyKeywordRuleArgs = {
    data: KeywordRuleUpdateManyMutationInput;
    where?: InputMaybe<KeywordRuleWhereInput>;
};

export type MutationUpdateManyLinkMappingArgs = {
    data: LinkMappingUpdateManyMutationInput;
    where?: InputMaybe<LinkMappingWhereInput>;
};

export type MutationUpdateManyLiveTransfersArgs = {
    data: LiveTransfersUpdateManyMutationInput;
    where?: InputMaybe<LiveTransfersWhereInput>;
};

export type MutationUpdateManyMcmsAssociationArgs = {
    data: McmsAssociationUpdateManyMutationInput;
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type MutationUpdateManyMcmsAssociationAuditLogArgs = {
    data: McmsAssociationAuditLogUpdateManyMutationInput;
    where?: InputMaybe<McmsAssociationAuditLogWhereInput>;
};

export type MutationUpdateManyMcmsAssociationClaimArgs = {
    data: McmsAssociationClaimUpdateManyMutationInput;
    where?: InputMaybe<McmsAssociationClaimWhereInput>;
};

export type MutationUpdateManyMcmsAssociationClaimAuditLogArgs = {
    data: McmsAssociationClaimAuditLogUpdateManyMutationInput;
    where?: InputMaybe<McmsAssociationClaimAuditLogWhereInput>;
};

export type MutationUpdateManyMcmsAssociationSlotArgs = {
    data: McmsAssociationSlotUpdateManyMutationInput;
    where?: InputMaybe<McmsAssociationSlotWhereInput>;
};

export type MutationUpdateManyMcmsAssociationSlotAuditLogArgs = {
    data: McmsAssociationSlotAuditLogUpdateManyMutationInput;
    where?: InputMaybe<McmsAssociationSlotAuditLogWhereInput>;
};

export type MutationUpdateManyMessageBlueprintArgs = {
    data: MessageBlueprintUpdateManyMutationInput;
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type MutationUpdateManyMessageConsolidationContextArgs = {
    data: MessageConsolidationContextUpdateManyMutationInput;
    where?: InputMaybe<MessageConsolidationContextWhereInput>;
};

export type MutationUpdateManyMessageConsolidationTemplateArgs = {
    data: MessageConsolidationTemplateUpdateManyMutationInput;
    where?: InputMaybe<MessageConsolidationTemplateWhereInput>;
};

export type MutationUpdateManyMessageNudgeArgs = {
    data: MessageNudgeUpdateManyMutationInput;
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type MutationUpdateManyMessageOrchestrationRuleArgs = {
    data: MessageOrchestrationRuleUpdateManyMutationInput;
    where?: InputMaybe<MessageOrchestrationRuleWhereInput>;
};

export type MutationUpdateManyMessagePayAfterArgs = {
    data: MessagePayAfterUpdateManyMutationInput;
    where?: InputMaybe<MessagePayAfterWhereInput>;
};

export type MutationUpdateManyMessageSettingsHrtArgs = {
    data: MessageSettingsHrtUpdateManyMutationInput;
    where?: InputMaybe<MessageSettingsHrtWhereInput>;
};

export type MutationUpdateManyMessageSettingsOrgArgs = {
    data: MessageSettingsOrgUpdateManyMutationInput;
    where?: InputMaybe<MessageSettingsOrgWhereInput>;
};

export type MutationUpdateManyMessageTemplateHrtArgs = {
    data: MessageTemplateHrtUpdateManyMutationInput;
    where?: InputMaybe<MessageTemplateHrtWhereInput>;
};

export type MutationUpdateManyMessageTemplateOrgArgs = {
    data: MessageTemplateOrgUpdateManyMutationInput;
    where?: InputMaybe<MessageTemplateOrgWhereInput>;
};

export type MutationUpdateManyMigratedEncounterArgs = {
    data: MigratedEncounterUpdateManyMutationInput;
    where?: InputMaybe<MigratedEncounterWhereInput>;
};

export type MutationUpdateManyMigrationsArgs = {
    data: MigrationsUpdateManyMutationInput;
    where?: InputMaybe<MigrationsWhereInput>;
};

export type MutationUpdateManyNetworkValidationArgs = {
    data: NetworkValidationUpdateManyMutationInput;
    where?: InputMaybe<NetworkValidationWhereInput>;
};

export type MutationUpdateManyNetworkPlanExceptionsArgs = {
    data: NetworkPlanExceptionsUpdateManyMutationInput;
    where?: InputMaybe<NetworkPlanExceptionsWhereInput>;
};

export type MutationUpdateManyNonCardRefundsArgs = {
    data: NonCardRefundsUpdateManyMutationInput;
    where?: InputMaybe<NonCardRefundsWhereInput>;
};

export type MutationUpdateManyOrgConfigFlagArgs = {
    data: OrgConfigFlagUpdateManyMutationInput;
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type MutationUpdateManyOrgHrtSrtRuleArgs = {
    data: OrgHrtSrtRuleUpdateManyMutationInput;
    where?: InputMaybe<OrgHrtSrtRuleWhereInput>;
};

export type MutationUpdateManyOrgNetworkResultsArgs = {
    data: OrgNetworkResultsUpdateManyMutationInput;
    where?: InputMaybe<OrgNetworkResultsWhereInput>;
};

export type MutationUpdateManyOrgOverrideRuleArgs = {
    data: OrgOverrideRuleUpdateManyMutationInput;
    where?: InputMaybe<OrgOverrideRuleWhereInput>;
};

export type MutationUpdateManyOrgFeesArgs = {
    data: OrgFeesUpdateManyMutationInput;
    where?: InputMaybe<OrgFeesWhereInput>;
};

export type MutationUpdateManyOrgStripeMappingArgs = {
    data: OrgStripeMappingUpdateManyMutationInput;
    where?: InputMaybe<OrgStripeMappingWhereInput>;
};

export type MutationUpdateManyOrganizationArgs = {
    data: OrganizationUpdateManyMutationInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type MutationUpdateManyOrganizationAssetsArgs = {
    data: OrganizationAssetsUpdateManyMutationInput;
    where?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type MutationUpdateManyOrganizationTranslationArgs = {
    data: OrganizationTranslationUpdateManyMutationInput;
    where?: InputMaybe<OrganizationTranslationWhereInput>;
};

export type MutationUpdateManyPayLaterAuthorizationArgs = {
    data: PayLaterAuthorizationUpdateManyMutationInput;
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type MutationUpdateManyPayLaterAuthorizationAuditLogArgs = {
    data: PayLaterAuthorizationAuditLogUpdateManyMutationInput;
    where?: InputMaybe<PayLaterAuthorizationAuditLogWhereInput>;
};

export type MutationUpdateManyPayerArgs = {
    data: PayerUpdateManyMutationInput;
    where?: InputMaybe<PayerWhereInput>;
};

export type MutationUpdateManyPayerPlanMappingArgs = {
    data: PayerPlanMappingUpdateManyMutationInput;
    where?: InputMaybe<PayerPlanMappingWhereInput>;
};

export type MutationUpdateManyPayerToEhrInsurancePackageMappingArgs = {
    data: PayerToEhrInsurancePackageMappingUpdateManyMutationInput;
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type MutationUpdateManyPaymentAuthorizationArgs = {
    data: PaymentAuthorizationUpdateManyMutationInput;
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type MutationUpdateManyPaymentAuthorizationAuditLogArgs = {
    data: PaymentAuthorizationAuditLogUpdateManyMutationInput;
    where?: InputMaybe<PaymentAuthorizationAuditLogWhereInput>;
};

export type MutationUpdateManyPaymentContractArgs = {
    data: PaymentContractUpdateManyMutationInput;
    where?: InputMaybe<PaymentContractWhereInput>;
};

export type MutationUpdateManyPaymentPlanArgs = {
    data: PaymentPlanUpdateManyMutationInput;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type MutationUpdateManyPaymentPlanAdjustmentArgs = {
    data: PaymentPlanAdjustmentUpdateManyMutationInput;
    where?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
};

export type MutationUpdateManyPaymentPlanAdjustmentAuditLogArgs = {
    data: PaymentPlanAdjustmentAuditLogUpdateManyMutationInput;
    where?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereInput>;
};

export type MutationUpdateManyPaymentPlanAuditLogArgs = {
    data: PaymentPlanAuditLogUpdateManyMutationInput;
    where?: InputMaybe<PaymentPlanAuditLogWhereInput>;
};

export type MutationUpdateManyPaymentPlanAutoChargeArgs = {
    data: PaymentPlanAutoChargeUpdateManyMutationInput;
    where?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
};

export type MutationUpdateManyPaymentPlanAutoChargeAuditLogArgs = {
    data: PaymentPlanAutoChargeAuditLogUpdateManyMutationInput;
    where?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereInput>;
};

export type MutationUpdateManyPaymentPlanBoughtTreatmentArgs = {
    data: PaymentPlanBoughtTreatmentUpdateManyMutationInput;
    where?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
};

export type MutationUpdateManyPaymentPlanBoughtTreatmentAuditLogArgs = {
    data: PaymentPlanBoughtTreatmentAuditLogUpdateManyMutationInput;
    where?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereInput>;
};

export type MutationUpdateManyPaymentPlanOrgConfigArgs = {
    data: PaymentPlanOrgConfigUpdateManyMutationInput;
    where?: InputMaybe<PaymentPlanOrgConfigWhereInput>;
};

export type MutationUpdateManyPaymentPlanOrgConfigAuditLogArgs = {
    data: PaymentPlanOrgConfigAuditLogUpdateManyMutationInput;
    where?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereInput>;
};

export type MutationUpdateManyPayoutArgs = {
    data: PayoutUpdateManyMutationInput;
    where?: InputMaybe<PayoutWhereInput>;
};

export type MutationUpdateManyPayoutAuditLogArgs = {
    data: PayoutAuditLogUpdateManyMutationInput;
    where?: InputMaybe<PayoutAuditLogWhereInput>;
};

export type MutationUpdateManyPendingVoidPayoutReversalArgs = {
    data: PendingVoidPayoutReversalUpdateManyMutationInput;
    where?: InputMaybe<PendingVoidPayoutReversalWhereInput>;
};

export type MutationUpdateManyPhoneNumberTypeArgs = {
    data: PhoneNumberTypeUpdateManyMutationInput;
    where?: InputMaybe<PhoneNumberTypeWhereInput>;
};

export type MutationUpdateManyPlaceOfServiceCodeArgs = {
    data: PlaceOfServiceCodeUpdateManyMutationInput;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type MutationUpdateManyPracticeArgs = {
    data: PracticeUpdateManyMutationInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type MutationUpdateManyPracticeConfigurationArgs = {
    data: PracticeConfigurationUpdateManyMutationInput;
    where?: InputMaybe<PracticeConfigurationWhereInput>;
};

export type MutationUpdateManyPracticeHoursArgs = {
    data: PracticeHoursUpdateManyMutationInput;
    where?: InputMaybe<PracticeHoursWhereInput>;
};

export type MutationUpdateManyPracticeHoursOverridesArgs = {
    data: PracticeHoursOverridesUpdateManyMutationInput;
    where?: InputMaybe<PracticeHoursOverridesWhereInput>;
};

export type MutationUpdateManyPricedTreatmentArgs = {
    data: PricedTreatmentUpdateManyMutationInput;
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type MutationUpdateManyPricingAttemptArgs = {
    data: PricingAttemptUpdateManyMutationInput;
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type MutationUpdateManyPricingEscalatorArgs = {
    data: PricingEscalatorUpdateManyMutationInput;
    where?: InputMaybe<PricingEscalatorWhereInput>;
};

export type MutationUpdateManyPricingQueueArgs = {
    data: PricingQueueUpdateManyMutationInput;
    where?: InputMaybe<PricingQueueWhereInput>;
};

export type MutationUpdateManyPricingResultsArgs = {
    data: PricingResultsUpdateManyMutationInput;
    where?: InputMaybe<PricingResultsWhereInput>;
};

export type MutationUpdateManyProcedureBenefitParsingRulesArgs = {
    data: ProcedureBenefitParsingRulesUpdateManyMutationInput;
    where?: InputMaybe<ProcedureBenefitParsingRulesWhereInput>;
};

export type MutationUpdateManyProductCategoriesArgs = {
    data: ProductCategoriesUpdateManyMutationInput;
    where?: InputMaybe<ProductCategoriesWhereInput>;
};

export type MutationUpdateManyProductCategoryTranslationArgs = {
    data: ProductCategoryTranslationUpdateManyMutationInput;
    where?: InputMaybe<ProductCategoryTranslationWhereInput>;
};

export type MutationUpdateManyProductToBundleArgs = {
    data: ProductToBundleUpdateManyMutationInput;
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type MutationUpdateManyProductToHrtArgs = {
    data: ProductToHrtUpdateManyMutationInput;
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type MutationUpdateManyProductTranslationArgs = {
    data: ProductTranslationUpdateManyMutationInput;
    where?: InputMaybe<ProductTranslationWhereInput>;
};

export type MutationUpdateManyProductsArgs = {
    data: ProductsUpdateManyMutationInput;
    where?: InputMaybe<ProductsWhereInput>;
};

export type MutationUpdateManyProviderArgs = {
    data: ProviderUpdateManyMutationInput;
    where?: InputMaybe<ProviderWhereInput>;
};

export type MutationUpdateManyProviderCredentialingArgs = {
    data: ProviderCredentialingUpdateManyMutationInput;
    where?: InputMaybe<ProviderCredentialingWhereInput>;
};

export type MutationUpdateManyProviderGroupArgs = {
    data: ProviderGroupUpdateManyMutationInput;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type MutationUpdateManyProviderGroupToHrtArgs = {
    data: ProviderGroupToHrtUpdateManyMutationInput;
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type MutationUpdateManyProviderHrtMaxCountArgs = {
    data: ProviderHrtMaxCountUpdateManyMutationInput;
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type MutationUpdateManyProviderTaxonomyArgs = {
    data: ProviderTaxonomyUpdateManyMutationInput;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type MutationUpdateManyProviderToOrgArgs = {
    data: ProviderToOrgUpdateManyMutationInput;
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type MutationUpdateManyProviderToProviderGroupArgs = {
    data: ProviderToProviderGroupUpdateManyMutationInput;
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type MutationUpdateManyReattributionDirectionArgs = {
    data: ReattributionDirectionUpdateManyMutationInput;
    where?: InputMaybe<ReattributionDirectionWhereInput>;
};

export type MutationUpdateManyReceiptArrangementArgs = {
    data: ReceiptArrangementUpdateManyMutationInput;
    where?: InputMaybe<ReceiptArrangementWhereInput>;
};

export type MutationUpdateManyReservedEhrVisitArgs = {
    data: ReservedEhrVisitUpdateManyMutationInput;
    where?: InputMaybe<ReservedEhrVisitWhereInput>;
};

export type MutationUpdateManyResetTokenArgs = {
    data: ResetTokenUpdateManyMutationInput;
    where?: InputMaybe<ResetTokenWhereInput>;
};

export type MutationUpdateManySavedIntakeResponseArgs = {
    data: SavedIntakeResponseUpdateManyMutationInput;
    where?: InputMaybe<SavedIntakeResponseWhereInput>;
};

export type MutationUpdateManySchedulingSlotConfigArgs = {
    data: SchedulingSlotConfigUpdateManyMutationInput;
    where?: InputMaybe<SchedulingSlotConfigWhereInput>;
};

export type MutationUpdateManyServiceTypeCodeArgs = {
    data: ServiceTypeCodeUpdateManyMutationInput;
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type MutationUpdateManySlotArgs = {
    data: SlotUpdateManyMutationInput;
    where?: InputMaybe<SlotWhereInput>;
};

export type MutationUpdateManySlotAuditLogArgs = {
    data: SlotAuditLogUpdateManyMutationInput;
    where?: InputMaybe<SlotAuditLogWhereInput>;
};

export type MutationUpdateManySrtArgs = {
    data: SrtUpdateManyMutationInput;
    where?: InputMaybe<SrtWhereInput>;
};

export type MutationUpdateManySrtFlagsArgs = {
    data: SrtFlagsUpdateManyMutationInput;
    where?: InputMaybe<SrtFlagsWhereInput>;
};

export type MutationUpdateManySrtMultiplierRuleArgs = {
    data: SrtMultiplierRuleUpdateManyMutationInput;
    where?: InputMaybe<SrtMultiplierRuleWhereInput>;
};

export type MutationUpdateManySrtToBillingCodeArgs = {
    data: SrtToBillingCodeUpdateManyMutationInput;
    where?: InputMaybe<SrtToBillingCodeWhereInput>;
};

export type MutationUpdateManyStatePayerMappingArgs = {
    data: StatePayerMappingUpdateManyMutationInput;
    where?: InputMaybe<StatePayerMappingWhereInput>;
};

export type MutationUpdateManySuperscriptFeeLineItemArgs = {
    data: SuperscriptFeeLineItemUpdateManyMutationInput;
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type MutationUpdateManySuperscriptFeesArgs = {
    data: SuperscriptFeesUpdateManyMutationInput;
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type MutationUpdateManySuperscriptIntakeQuestionArgs = {
    data: SuperscriptIntakeQuestionUpdateManyMutationInput;
    where?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
};

export type MutationUpdateManyTimeBlockArgs = {
    data: TimeBlockUpdateManyMutationInput;
    where?: InputMaybe<TimeBlockWhereInput>;
};

export type MutationUpdateManyTransactionArgs = {
    data: TransactionUpdateManyMutationInput;
    where?: InputMaybe<TransactionWhereInput>;
};

export type MutationUpdateManyUserArgs = {
    data: UserUpdateManyMutationInput;
    where?: InputMaybe<UserWhereInput>;
};

export type MutationUpdateManyUserAuditLogArgs = {
    data: UserAuditLogUpdateManyMutationInput;
    where?: InputMaybe<UserAuditLogWhereInput>;
};

export type MutationUpdateManyUserPracticeVisitArgs = {
    data: UserPracticeVisitUpdateManyMutationInput;
    where?: InputMaybe<UserPracticeVisitWhereInput>;
};

export type MutationUpdateManyUserToNewUserArgs = {
    data: UserToNewUserUpdateManyMutationInput;
    where?: InputMaybe<UserToNewUserWhereInput>;
};

export type MutationUpdateManyValidPayersArgs = {
    data: ValidPayersUpdateManyMutationInput;
    where?: InputMaybe<ValidPayersWhereInput>;
};

export type MutationUpdateOneAleConfigArgs = {
    data: AleConfigUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AleConfigWhereUniqueInput;
};

export type MutationUpdateOneAleDepartmentGoLiveArgs = {
    data: AleDepartmentGoLiveUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AleDepartmentGoLiveWhereUniqueInput;
};

export type MutationUpdateOneAdjudicationArgs = {
    data: AdjudicationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjudicationWhereUniqueInput;
};

export type MutationUpdateOneAdjudicationAuditLogArgs = {
    data: AdjudicationAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjudicationAuditLogWhereUniqueInput;
};

export type MutationUpdateOneAdjustmentArgs = {
    data: AdjustmentUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjustmentWhereUniqueInput;
};

export type MutationUpdateOneAdjustmentAuditLogArgs = {
    data: AdjustmentAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjustmentAuditLogWhereUniqueInput;
};

export type MutationUpdateOneAdminArgs = {
    data: AdminUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdminWhereUniqueInput;
};

export type MutationUpdateOneAdminInteractionArgs = {
    data: AdminInteractionUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdminInteractionWhereUniqueInput;
};

export type MutationUpdateOneAppointmentArgs = {
    data: AppointmentUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AppointmentWhereUniqueInput;
};

export type MutationUpdateOneAppointmentAuditLogArgs = {
    data: AppointmentAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AppointmentAuditLogWhereUniqueInput;
};

export type MutationUpdateOneArrearBillingArgs = {
    data: ArrearBillingUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArrearBillingWhereUniqueInput;
};

export type MutationUpdateOneArtClaimArgs = {
    data: ArtClaimUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimWhereUniqueInput;
};

export type MutationUpdateOneArtClaimAuditLogArgs = {
    data: ArtClaimAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimAuditLogWhereUniqueInput;
};

export type MutationUpdateOneArtClaimCptLineArgs = {
    data: ArtClaimCptLineUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimCptLineWhereUniqueInput;
};

export type MutationUpdateOneArtClaimCptLineAuditLogArgs = {
    data: ArtClaimCptLineAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimCptLineAuditLogWhereUniqueInput;
};

export type MutationUpdateOneArtOrgConfigArgs = {
    data: ArtOrgConfigUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtOrgConfigWhereUniqueInput;
};

export type MutationUpdateOneArtPracticeConfigArgs = {
    data: ArtPracticeConfigUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtPracticeConfigWhereUniqueInput;
};

export type MutationUpdateOneAthenaMedicationsArgs = {
    data: AthenaMedicationsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaMedicationsWhereUniqueInput;
};

export type MutationUpdateOneAthenaPharmacyArgs = {
    data: AthenaPharmacyUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaPharmacyWhereUniqueInput;
};

export type MutationUpdateOneAthenaProviderArgs = {
    data: AthenaProviderUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaProviderWhereUniqueInput;
};

export type MutationUpdateOneBenefitParsingRulesArgs = {
    data: BenefitParsingRulesUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BenefitParsingRulesWhereUniqueInput;
};

export type MutationUpdateOneBillingCodeArgs = {
    data: BillingCodeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BillingCodeWhereUniqueInput;
};

export type MutationUpdateOneBillingTableDownloadRequestArgs = {
    data: BillingTableDownloadRequestUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BillingTableDownloadRequestWhereUniqueInput;
};

export type MutationUpdateOneBoughtTreatmentArgs = {
    data: BoughtTreatmentUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentWhereUniqueInput;
};

export type MutationUpdateOneBoughtTreatmentAuditLogArgs = {
    data: BoughtTreatmentAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentAuditLogWhereUniqueInput;
};

export type MutationUpdateOneBoughtTreatmentClaimDetailArgs = {
    data: BoughtTreatmentClaimDetailUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentClaimDetailWhereUniqueInput;
};

export type MutationUpdateOneBulkChargeCardRunArgs = {
    data: BulkChargeCardRunUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BulkChargeCardRunWhereUniqueInput;
};

export type MutationUpdateOneBulkChargeCardRunItemArgs = {
    data: BulkChargeCardRunItemUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BulkChargeCardRunItemWhereUniqueInput;
};

export type MutationUpdateOneBundleArgs = {
    data: BundleUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BundleWhereUniqueInput;
};

export type MutationUpdateOneBundleToHrtArgs = {
    data: BundleToHrtUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BundleToHrtWhereUniqueInput;
};

export type MutationUpdateOneBusinessHourArgs = {
    data: BusinessHourUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BusinessHourWhereUniqueInput;
};

export type MutationUpdateOneCandidateTreatmentArgs = {
    data: CandidateTreatmentUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CandidateTreatmentWhereUniqueInput;
};

export type MutationUpdateOneCardAuthorizationArgs = {
    data: CardAuthorizationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CardAuthorizationWhereUniqueInput;
};

export type MutationUpdateOneCardAuthorizationAuditLogArgs = {
    data: CardAuthorizationAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CardAuthorizationAuditLogWhereUniqueInput;
};

export type MutationUpdateOneCashPriceArgs = {
    data: CashPriceUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CashPriceWhereUniqueInput;
};

export type MutationUpdateOneChargeArgs = {
    data: ChargeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeWhereUniqueInput;
};

export type MutationUpdateOneChargeAuditLogArgs = {
    data: ChargeAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeAuditLogWhereUniqueInput;
};

export type MutationUpdateOneChargeReattributionAndPartialPaymentLogArgs = {
    data: ChargeReattributionAndPartialPaymentLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeReattributionAndPartialPaymentLogWhereUniqueInput;
};

export type MutationUpdateOneChargeReattributionLogArgs = {
    data: ChargeReattributionLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeReattributionLogWhereUniqueInput;
};

export type MutationUpdateOneCheckNetworkStatusResultsArgs = {
    data: CheckNetworkStatusResultsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CheckNetworkStatusResultsWhereUniqueInput;
};

export type MutationUpdateOneCheckoutAdjudicationArgs = {
    data: CheckoutAdjudicationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CheckoutAdjudicationWhereUniqueInput;
};

export type MutationUpdateOneClaimToBoughtTreatmentArgs = {
    data: ClaimToBoughtTreatmentUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ClaimToBoughtTreatmentWhereUniqueInput;
};

export type MutationUpdateOneConfigCommitArgs = {
    data: ConfigCommitUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigCommitWhereUniqueInput;
};

export type MutationUpdateOneConfigFlagArgs = {
    data: ConfigFlagUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigFlagWhereUniqueInput;
};

export type MutationUpdateOneConfigSessionArgs = {
    data: ConfigSessionUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigSessionWhereUniqueInput;
};

export type MutationUpdateOneConsentFormArgs = {
    data: ConsentFormUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsentFormWhereUniqueInput;
};

export type MutationUpdateOneConsumerArgs = {
    data: ConsumerUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerWhereUniqueInput;
};

export type MutationUpdateOneConsumerAuditLogArgs = {
    data: ConsumerAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerAuditLogWhereUniqueInput;
};

export type MutationUpdateOneConsumerMessageArgs = {
    data: ConsumerMessageUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerMessageWhereUniqueInput;
};

export type MutationUpdateOneConsumerNoteArgs = {
    data: ConsumerNoteUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerNoteWhereUniqueInput;
};

export type MutationUpdateOneConsumerPhotoMetaDataArgs = {
    data: ConsumerPhotoMetaDataUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type MutationUpdateOneConsumerSrtRecordsArgs = {
    data: ConsumerSrtRecordsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerSrtRecordsWhereUniqueInput;
};

export type MutationUpdateOneContractArgs = {
    data: ContractUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ContractWhereUniqueInput;
};

export type MutationUpdateOneContractAuditLogArgs = {
    data: ContractAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ContractAuditLogWhereUniqueInput;
};

export type MutationUpdateOneCoverageResponsesArgs = {
    data: CoverageResponsesUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CoverageResponsesWhereUniqueInput;
};

export type MutationUpdateOneCptExclusivityEdgeArgs = {
    data: CptExclusivityEdgeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CptExclusivityEdgeWhereUniqueInput;
};

export type MutationUpdateOneCustomFieldArgs = {
    data: CustomFieldUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CustomFieldWhereUniqueInput;
};

export type MutationUpdateOneCustomFieldValueArgs = {
    data: CustomFieldValueUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CustomFieldValueWhereUniqueInput;
};

export type MutationUpdateOneDataMigrationsArgs = {
    data: DataMigrationsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DataMigrationsWhereUniqueInput;
};

export type MutationUpdateOneDefaultPracticeArgs = {
    data: DefaultPracticeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DefaultPracticeWhereUniqueInput;
};

export type MutationUpdateOneDefaultProvidersArgs = {
    data: DefaultProvidersUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DefaultProvidersWhereUniqueInput;
};

export type MutationUpdateOneDeploymentOrgPhaseArgs = {
    data: DeploymentOrgPhaseUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type MutationUpdateOneDeploymentOrgTaskArgs = {
    data: DeploymentOrgTaskUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type MutationUpdateOneDeploymentOrgTaskDependencyArgs = {
    data: DeploymentOrgTaskDependencyUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgTaskDependencyWhereUniqueInput;
};

export type MutationUpdateOneDeploymentPhaseArgs = {
    data: DeploymentPhaseUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentPhaseWhereUniqueInput;
};

export type MutationUpdateOneDeploymentTaskArgs = {
    data: DeploymentTaskUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTaskWhereUniqueInput;
};

export type MutationUpdateOneDeploymentTaskDependencyArgs = {
    data: DeploymentTaskDependencyUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTaskDependencyWhereUniqueInput;
};

export type MutationUpdateOneDeploymentTeamArgs = {
    data: DeploymentTeamUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTeamWhereUniqueInput;
};

export type MutationUpdateOneDiscountCodesArgs = {
    data: DiscountCodesUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DiscountCodesWhereUniqueInput;
};

export type MutationUpdateOneEcwPayerAliasArgs = {
    data: EcwPayerAliasUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EcwPayerAliasWhereUniqueInput;
};

export type MutationUpdateOneEcwPayerStcArgs = {
    data: EcwPayerStcUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EcwPayerStcWhereUniqueInput;
};

export type MutationUpdateOneEhrAppointmentTypeIdToNameArgs = {
    data: EhrAppointmentTypeIdToNameUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrAppointmentTypeIdToNameWhereUniqueInput;
};

export type MutationUpdateOneEhrPaymentDescriptorArgs = {
    data: EhrPaymentDescriptorUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDescriptorWhereUniqueInput;
};

export type MutationUpdateOneEhrPaymentDescriptorAuditLogArgs = {
    data: EhrPaymentDescriptorAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDescriptorAuditLogWhereUniqueInput;
};

export type MutationUpdateOneEhrPaymentDirectionSsAssetArgs = {
    data: EhrPaymentDirectionSsAssetUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDirectionSsAssetWhereUniqueInput;
};

export type MutationUpdateOneEhrPostDetailArgs = {
    data: EhrPostDetailUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostDetailWhereUniqueInput;
};

export type MutationUpdateOneEhrPostDetailToPayoutArgs = {
    data: EhrPostDetailToPayoutUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostDetailToPayoutWhereUniqueInput;
};

export type MutationUpdateOneEhrPostLedgerArgs = {
    data: EhrPostLedgerUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerWhereUniqueInput;
};

export type MutationUpdateOneEhrPostLedgerAuditLogArgs = {
    data: EhrPostLedgerAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerAuditLogWhereUniqueInput;
};

export type MutationUpdateOneEhrPostLedgerToPayoutArgs = {
    data: EhrPostLedgerToPayoutUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerToPayoutWhereUniqueInput;
};

export type MutationUpdateOneEhrPrimaryCareProviderArgs = {
    data: EhrPrimaryCareProviderUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPrimaryCareProviderWhereUniqueInput;
};

export type MutationUpdateOneEhrProviderMappingArgs = {
    data: EhrProviderMappingUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrProviderMappingWhereUniqueInput;
};

export type MutationUpdateOneEhrSlotArgs = {
    data: EhrSlotUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrSlotWhereUniqueInput;
};

export type MutationUpdateOneEhrSlotAuditLogArgs = {
    data: EhrSlotAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrSlotAuditLogWhereUniqueInput;
};

export type MutationUpdateOneEncounterArgs = {
    data: EncounterUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EncounterWhereUniqueInput;
};

export type MutationUpdateOneExperityEncounterArgs = {
    data: ExperityEncounterUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ExperityEncounterWhereUniqueInput;
};

export type MutationUpdateOneFaqDropdownsArgs = {
    data: FaqDropdownsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FaqDropdownsWhereUniqueInput;
};

export type MutationUpdateOneFeeConfigArgs = {
    data: FeeConfigUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FeeConfigWhereUniqueInput;
};

export type MutationUpdateOneFeeConfigAuditLogArgs = {
    data: FeeConfigAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FeeConfigAuditLogWhereUniqueInput;
};

export type MutationUpdateOneGuarantorPaymentLinkContextArgs = {
    data: GuarantorPaymentLinkContextUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: GuarantorPaymentLinkContextWhereUniqueInput;
};

export type MutationUpdateOneHolidayArgs = {
    data: HolidayUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HolidayWhereUniqueInput;
};

export type MutationUpdateOneHrtArgs = {
    data: HrtUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtWhereUniqueInput;
};

export type MutationUpdateOneHrtFlagsArgs = {
    data: HrtFlagsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtFlagsWhereUniqueInput;
};

export type MutationUpdateOneHrtPaymentTypeArgs = {
    data: HrtPaymentTypeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtPaymentTypeWhereUniqueInput;
};

export type MutationUpdateOneHrtToSrtArgs = {
    data: HrtToSrtUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtToSrtWhereUniqueInput;
};

export type MutationUpdateOneHrtTranslationArgs = {
    data: HrtTranslationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtTranslationWhereUniqueInput;
};

export type MutationUpdateOneInboundRequestLogArgs = {
    data: InboundRequestLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InboundRequestLogWhereUniqueInput;
};

export type MutationUpdateOneInboundTextMessageLogArgs = {
    data: InboundTextMessageLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InboundTextMessageLogWhereUniqueInput;
};

export type MutationUpdateOneInsuranceArgs = {
    data: InsuranceUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceWhereUniqueInput;
};

export type MutationUpdateOneInsuranceAuditLogArgs = {
    data: InsuranceAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceAuditLogWhereUniqueInput;
};

export type MutationUpdateOneInsuranceMetadataArgs = {
    data: InsuranceMetadataUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceMetadataWhereUniqueInput;
};

export type MutationUpdateOneIntakeFormArgs = {
    data: IntakeFormUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormWhereUniqueInput;
};

export type MutationUpdateOneIntakeFormSectionArgs = {
    data: IntakeFormSectionUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormSectionWhereUniqueInput;
};

export type MutationUpdateOneIntakeFormSectionTranslationArgs = {
    data: IntakeFormSectionTranslationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormSectionTranslationWhereUniqueInput;
};

export type MutationUpdateOneIntakeFormToQuestionArgs = {
    data: IntakeFormToQuestionUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormToQuestionWhereUniqueInput;
};

export type MutationUpdateOneIntakeQuestionArgs = {
    data: IntakeQuestionUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeQuestionWhereUniqueInput;
};

export type MutationUpdateOneIntakeQuestionTranslationArgs = {
    data: IntakeQuestionTranslationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeQuestionTranslationWhereUniqueInput;
};

export type MutationUpdateOneInvoiceDailyLineItemsArgs = {
    data: InvoiceDailyLineItemsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InvoiceDailyLineItemsWhereUniqueInput;
};

export type MutationUpdateOneInvoicesArgs = {
    data: InvoicesUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InvoicesWhereUniqueInput;
};

export type MutationUpdateOneKeywordRuleArgs = {
    data: KeywordRuleUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: KeywordRuleWhereUniqueInput;
};

export type MutationUpdateOneLinkMappingArgs = {
    data: LinkMappingUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: LinkMappingWhereUniqueInput;
};

export type MutationUpdateOneLiveTransfersArgs = {
    data: LiveTransfersUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: LiveTransfersWhereUniqueInput;
};

export type MutationUpdateOneMcmsAssociationArgs = {
    data: McmsAssociationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationWhereUniqueInput;
};

export type MutationUpdateOneMcmsAssociationAuditLogArgs = {
    data: McmsAssociationAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationAuditLogWhereUniqueInput;
};

export type MutationUpdateOneMcmsAssociationClaimArgs = {
    data: McmsAssociationClaimUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationClaimWhereUniqueInput;
};

export type MutationUpdateOneMcmsAssociationClaimAuditLogArgs = {
    data: McmsAssociationClaimAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationClaimAuditLogWhereUniqueInput;
};

export type MutationUpdateOneMcmsAssociationSlotArgs = {
    data: McmsAssociationSlotUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationSlotWhereUniqueInput;
};

export type MutationUpdateOneMcmsAssociationSlotAuditLogArgs = {
    data: McmsAssociationSlotAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationSlotAuditLogWhereUniqueInput;
};

export type MutationUpdateOneMessageBlueprintArgs = {
    data: MessageBlueprintUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageBlueprintWhereUniqueInput;
};

export type MutationUpdateOneMessageConsolidationContextArgs = {
    data: MessageConsolidationContextUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageConsolidationContextWhereUniqueInput;
};

export type MutationUpdateOneMessageConsolidationTemplateArgs = {
    data: MessageConsolidationTemplateUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageConsolidationTemplateWhereUniqueInput;
};

export type MutationUpdateOneMessageNudgeArgs = {
    data: MessageNudgeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageNudgeWhereUniqueInput;
};

export type MutationUpdateOneMessageOrchestrationRuleArgs = {
    data: MessageOrchestrationRuleUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageOrchestrationRuleWhereUniqueInput;
};

export type MutationUpdateOneMessagePayAfterArgs = {
    data: MessagePayAfterUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessagePayAfterWhereUniqueInput;
};

export type MutationUpdateOneMessageSettingsHrtArgs = {
    data: MessageSettingsHrtUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageSettingsHrtWhereUniqueInput;
};

export type MutationUpdateOneMessageSettingsOrgArgs = {
    data: MessageSettingsOrgUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageSettingsOrgWhereUniqueInput;
};

export type MutationUpdateOneMessageTemplateHrtArgs = {
    data: MessageTemplateHrtUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageTemplateHrtWhereUniqueInput;
};

export type MutationUpdateOneMessageTemplateOrgArgs = {
    data: MessageTemplateOrgUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageTemplateOrgWhereUniqueInput;
};

export type MutationUpdateOneMigratedEncounterArgs = {
    data: MigratedEncounterUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MigratedEncounterWhereUniqueInput;
};

export type MutationUpdateOneMigrationsArgs = {
    data: MigrationsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MigrationsWhereUniqueInput;
};

export type MutationUpdateOneNetworkValidationArgs = {
    data: NetworkValidationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NetworkValidationWhereUniqueInput;
};

export type MutationUpdateOneNetworkPlanExceptionsArgs = {
    data: NetworkPlanExceptionsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NetworkPlanExceptionsWhereUniqueInput;
};

export type MutationUpdateOneNonCardRefundsArgs = {
    data: NonCardRefundsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NonCardRefundsWhereUniqueInput;
};

export type MutationUpdateOneOrgConfigFlagArgs = {
    data: OrgConfigFlagUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgConfigFlagWhereUniqueInput;
};

export type MutationUpdateOneOrgHrtSrtRuleArgs = {
    data: OrgHrtSrtRuleUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgHrtSrtRuleWhereUniqueInput;
};

export type MutationUpdateOneOrgNetworkResultsArgs = {
    data: OrgNetworkResultsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgNetworkResultsWhereUniqueInput;
};

export type MutationUpdateOneOrgOverrideRuleArgs = {
    data: OrgOverrideRuleUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgOverrideRuleWhereUniqueInput;
};

export type MutationUpdateOneOrgFeesArgs = {
    data: OrgFeesUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgFeesWhereUniqueInput;
};

export type MutationUpdateOneOrgStripeMappingArgs = {
    data: OrgStripeMappingUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgStripeMappingWhereUniqueInput;
};

export type MutationUpdateOneOrganizationArgs = {
    data: OrganizationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationWhereUniqueInput;
};

export type MutationUpdateOneOrganizationAssetsArgs = {
    data: OrganizationAssetsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationAssetsWhereUniqueInput;
};

export type MutationUpdateOneOrganizationTranslationArgs = {
    data: OrganizationTranslationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationTranslationWhereUniqueInput;
};

export type MutationUpdateOnePayLaterAuthorizationArgs = {
    data: PayLaterAuthorizationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayLaterAuthorizationWhereUniqueInput;
};

export type MutationUpdateOnePayLaterAuthorizationAuditLogArgs = {
    data: PayLaterAuthorizationAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayLaterAuthorizationAuditLogWhereUniqueInput;
};

export type MutationUpdateOnePayerArgs = {
    data: PayerUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerWhereUniqueInput;
};

export type MutationUpdateOnePayerPlanMappingArgs = {
    data: PayerPlanMappingUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerPlanMappingWhereUniqueInput;
};

export type MutationUpdateOnePayerToEhrInsurancePackageMappingArgs = {
    data: PayerToEhrInsurancePackageMappingUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
};

export type MutationUpdateOnePaymentAuthorizationArgs = {
    data: PaymentAuthorizationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentAuthorizationWhereUniqueInput;
};

export type MutationUpdateOnePaymentAuthorizationAuditLogArgs = {
    data: PaymentAuthorizationAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentAuthorizationAuditLogWhereUniqueInput;
};

export type MutationUpdateOnePaymentContractArgs = {
    data: PaymentContractUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentContractWhereUniqueInput;
};

export type MutationUpdateOnePaymentPlanArgs = {
    data: PaymentPlanUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanWhereUniqueInput;
};

export type MutationUpdateOnePaymentPlanAdjustmentArgs = {
    data: PaymentPlanAdjustmentUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAdjustmentWhereUniqueInput;
};

export type MutationUpdateOnePaymentPlanAdjustmentAuditLogArgs = {
    data: PaymentPlanAdjustmentAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAdjustmentAuditLogWhereUniqueInput;
};

export type MutationUpdateOnePaymentPlanAuditLogArgs = {
    data: PaymentPlanAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAuditLogWhereUniqueInput;
};

export type MutationUpdateOnePaymentPlanAutoChargeArgs = {
    data: PaymentPlanAutoChargeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAutoChargeWhereUniqueInput;
};

export type MutationUpdateOnePaymentPlanAutoChargeAuditLogArgs = {
    data: PaymentPlanAutoChargeAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAutoChargeAuditLogWhereUniqueInput;
};

export type MutationUpdateOnePaymentPlanBoughtTreatmentArgs = {
    data: PaymentPlanBoughtTreatmentUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanBoughtTreatmentWhereUniqueInput;
};

export type MutationUpdateOnePaymentPlanBoughtTreatmentAuditLogArgs = {
    data: PaymentPlanBoughtTreatmentAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanBoughtTreatmentAuditLogWhereUniqueInput;
};

export type MutationUpdateOnePaymentPlanOrgConfigArgs = {
    data: PaymentPlanOrgConfigUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanOrgConfigWhereUniqueInput;
};

export type MutationUpdateOnePaymentPlanOrgConfigAuditLogArgs = {
    data: PaymentPlanOrgConfigAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanOrgConfigAuditLogWhereUniqueInput;
};

export type MutationUpdateOnePayoutArgs = {
    data: PayoutUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayoutWhereUniqueInput;
};

export type MutationUpdateOnePayoutAuditLogArgs = {
    data: PayoutAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayoutAuditLogWhereUniqueInput;
};

export type MutationUpdateOnePendingVoidPayoutReversalArgs = {
    data: PendingVoidPayoutReversalUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PendingVoidPayoutReversalWhereUniqueInput;
};

export type MutationUpdateOnePhoneNumberTypeArgs = {
    data: PhoneNumberTypeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PhoneNumberTypeWhereUniqueInput;
};

export type MutationUpdateOnePlaceOfServiceCodeArgs = {
    data: PlaceOfServiceCodeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PlaceOfServiceCodeWhereUniqueInput;
};

export type MutationUpdateOnePracticeArgs = {
    data: PracticeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeWhereUniqueInput;
};

export type MutationUpdateOnePracticeConfigurationArgs = {
    data: PracticeConfigurationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeConfigurationWhereUniqueInput;
};

export type MutationUpdateOnePracticeHoursArgs = {
    data: PracticeHoursUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeHoursWhereUniqueInput;
};

export type MutationUpdateOnePracticeHoursOverridesArgs = {
    data: PracticeHoursOverridesUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeHoursOverridesWhereUniqueInput;
};

export type MutationUpdateOnePricedTreatmentArgs = {
    data: PricedTreatmentUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricedTreatmentWhereUniqueInput;
};

export type MutationUpdateOnePricingAttemptArgs = {
    data: PricingAttemptUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingAttemptWhereUniqueInput;
};

export type MutationUpdateOnePricingEscalatorArgs = {
    data: PricingEscalatorUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingEscalatorWhereUniqueInput;
};

export type MutationUpdateOnePricingQueueArgs = {
    data: PricingQueueUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingQueueWhereUniqueInput;
};

export type MutationUpdateOnePricingResultsArgs = {
    data: PricingResultsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingResultsWhereUniqueInput;
};

export type MutationUpdateOneProcedureBenefitParsingRulesArgs = {
    data: ProcedureBenefitParsingRulesUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProcedureBenefitParsingRulesWhereUniqueInput;
};

export type MutationUpdateOneProductCategoriesArgs = {
    data: ProductCategoriesUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductCategoriesWhereUniqueInput;
};

export type MutationUpdateOneProductCategoryTranslationArgs = {
    data: ProductCategoryTranslationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductCategoryTranslationWhereUniqueInput;
};

export type MutationUpdateOneProductToBundleArgs = {
    data: ProductToBundleUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductToBundleWhereUniqueInput;
};

export type MutationUpdateOneProductToHrtArgs = {
    data: ProductToHrtUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductToHrtWhereUniqueInput;
};

export type MutationUpdateOneProductTranslationArgs = {
    data: ProductTranslationUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductTranslationWhereUniqueInput;
};

export type MutationUpdateOneProductsArgs = {
    data: ProductsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductsWhereUniqueInput;
};

export type MutationUpdateOneProviderArgs = {
    data: ProviderUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderWhereUniqueInput;
};

export type MutationUpdateOneProviderCredentialingArgs = {
    data: ProviderCredentialingUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderCredentialingWhereUniqueInput;
};

export type MutationUpdateOneProviderGroupArgs = {
    data: ProviderGroupUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderGroupWhereUniqueInput;
};

export type MutationUpdateOneProviderGroupToHrtArgs = {
    data: ProviderGroupToHrtUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type MutationUpdateOneProviderHrtMaxCountArgs = {
    data: ProviderHrtMaxCountUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type MutationUpdateOneProviderTaxonomyArgs = {
    data: ProviderTaxonomyUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderTaxonomyWhereUniqueInput;
};

export type MutationUpdateOneProviderToOrgArgs = {
    data: ProviderToOrgUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderToOrgWhereUniqueInput;
};

export type MutationUpdateOneProviderToProviderGroupArgs = {
    data: ProviderToProviderGroupUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderToProviderGroupWhereUniqueInput;
};

export type MutationUpdateOneReattributionDirectionArgs = {
    data: ReattributionDirectionUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReattributionDirectionWhereUniqueInput;
};

export type MutationUpdateOneReceiptArrangementArgs = {
    data: ReceiptArrangementUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReceiptArrangementWhereUniqueInput;
};

export type MutationUpdateOneReservedEhrVisitArgs = {
    data: ReservedEhrVisitUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReservedEhrVisitWhereUniqueInput;
};

export type MutationUpdateOneResetTokenArgs = {
    data: ResetTokenUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ResetTokenWhereUniqueInput;
};

export type MutationUpdateOneSavedIntakeResponseArgs = {
    data: SavedIntakeResponseUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SavedIntakeResponseWhereUniqueInput;
};

export type MutationUpdateOneSchedulingSlotConfigArgs = {
    data: SchedulingSlotConfigUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SchedulingSlotConfigWhereUniqueInput;
};

export type MutationUpdateOneServiceTypeCodeArgs = {
    data: ServiceTypeCodeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ServiceTypeCodeWhereUniqueInput;
};

export type MutationUpdateOneSlotArgs = {
    data: SlotUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SlotWhereUniqueInput;
};

export type MutationUpdateOneSlotAuditLogArgs = {
    data: SlotAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SlotAuditLogWhereUniqueInput;
};

export type MutationUpdateOneSrtArgs = {
    data: SrtUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtWhereUniqueInput;
};

export type MutationUpdateOneSrtFlagsArgs = {
    data: SrtFlagsUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtFlagsWhereUniqueInput;
};

export type MutationUpdateOneSrtMultiplierRuleArgs = {
    data: SrtMultiplierRuleUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtMultiplierRuleWhereUniqueInput;
};

export type MutationUpdateOneSrtToBillingCodeArgs = {
    data: SrtToBillingCodeUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtToBillingCodeWhereUniqueInput;
};

export type MutationUpdateOneStatePayerMappingArgs = {
    data: StatePayerMappingUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: StatePayerMappingWhereUniqueInput;
};

export type MutationUpdateOneSuperscriptFeeLineItemArgs = {
    data: SuperscriptFeeLineItemUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptFeeLineItemWhereUniqueInput;
};

export type MutationUpdateOneSuperscriptFeesArgs = {
    data: SuperscriptFeesUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptFeesWhereUniqueInput;
};

export type MutationUpdateOneSuperscriptIntakeQuestionArgs = {
    data: SuperscriptIntakeQuestionUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptIntakeQuestionWhereUniqueInput;
};

export type MutationUpdateOneTimeBlockArgs = {
    data: TimeBlockUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: TimeBlockWhereUniqueInput;
};

export type MutationUpdateOneTransactionArgs = {
    data: TransactionUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: TransactionWhereUniqueInput;
};

export type MutationUpdateOneUserArgs = {
    data: UserUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserWhereUniqueInput;
};

export type MutationUpdateOneUserAuditLogArgs = {
    data: UserAuditLogUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserAuditLogWhereUniqueInput;
};

export type MutationUpdateOneUserPracticeVisitArgs = {
    data: UserPracticeVisitUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserPracticeVisitWhereUniqueInput;
};

export type MutationUpdateOneUserToNewUserArgs = {
    data: UserToNewUserUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserToNewUserWhereUniqueInput;
};

export type MutationUpdateOneValidPayersArgs = {
    data: ValidPayersUpdateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ValidPayersWhereUniqueInput;
};

export type MutationUpdateUserAndEhrPatientArgs = {
    data: UpdateUserInput;
};

export type MutationUpsertOneAleConfigArgs = {
    create: AleConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AleConfigUpdateInput;
    where: AleConfigWhereUniqueInput;
};

export type MutationUpsertOneAleDepartmentGoLiveArgs = {
    create: AleDepartmentGoLiveCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AleDepartmentGoLiveUpdateInput;
    where: AleDepartmentGoLiveWhereUniqueInput;
};

export type MutationUpsertOneAdjudicationArgs = {
    create: AdjudicationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AdjudicationUpdateInput;
    where: AdjudicationWhereUniqueInput;
};

export type MutationUpsertOneAdjudicationAuditLogArgs = {
    create: AdjudicationAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AdjudicationAuditLogUpdateInput;
    where: AdjudicationAuditLogWhereUniqueInput;
};

export type MutationUpsertOneAdjustmentArgs = {
    create: AdjustmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AdjustmentUpdateInput;
    where: AdjustmentWhereUniqueInput;
};

export type MutationUpsertOneAdjustmentAuditLogArgs = {
    create: AdjustmentAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AdjustmentAuditLogUpdateInput;
    where: AdjustmentAuditLogWhereUniqueInput;
};

export type MutationUpsertOneAdminArgs = {
    create: AdminCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AdminUpdateInput;
    where: AdminWhereUniqueInput;
};

export type MutationUpsertOneAdminInteractionArgs = {
    create: AdminInteractionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AdminInteractionUpdateInput;
    where: AdminInteractionWhereUniqueInput;
};

export type MutationUpsertOneAppointmentArgs = {
    create: AppointmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AppointmentUpdateInput;
    where: AppointmentWhereUniqueInput;
};

export type MutationUpsertOneAppointmentAuditLogArgs = {
    create: AppointmentAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AppointmentAuditLogUpdateInput;
    where: AppointmentAuditLogWhereUniqueInput;
};

export type MutationUpsertOneArrearBillingArgs = {
    create: ArrearBillingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ArrearBillingUpdateInput;
    where: ArrearBillingWhereUniqueInput;
};

export type MutationUpsertOneArtClaimArgs = {
    create: ArtClaimCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ArtClaimUpdateInput;
    where: ArtClaimWhereUniqueInput;
};

export type MutationUpsertOneArtClaimAuditLogArgs = {
    create: ArtClaimAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ArtClaimAuditLogUpdateInput;
    where: ArtClaimAuditLogWhereUniqueInput;
};

export type MutationUpsertOneArtClaimCptLineArgs = {
    create: ArtClaimCptLineCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ArtClaimCptLineUpdateInput;
    where: ArtClaimCptLineWhereUniqueInput;
};

export type MutationUpsertOneArtClaimCptLineAuditLogArgs = {
    create: ArtClaimCptLineAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ArtClaimCptLineAuditLogUpdateInput;
    where: ArtClaimCptLineAuditLogWhereUniqueInput;
};

export type MutationUpsertOneArtOrgConfigArgs = {
    create: ArtOrgConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ArtOrgConfigUpdateInput;
    where: ArtOrgConfigWhereUniqueInput;
};

export type MutationUpsertOneArtPracticeConfigArgs = {
    create: ArtPracticeConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ArtPracticeConfigUpdateInput;
    where: ArtPracticeConfigWhereUniqueInput;
};

export type MutationUpsertOneAthenaMedicationsArgs = {
    create: AthenaMedicationsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AthenaMedicationsUpdateInput;
    where: AthenaMedicationsWhereUniqueInput;
};

export type MutationUpsertOneAthenaPharmacyArgs = {
    create: AthenaPharmacyCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AthenaPharmacyUpdateInput;
    where: AthenaPharmacyWhereUniqueInput;
};

export type MutationUpsertOneAthenaProviderArgs = {
    create: AthenaProviderCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: AthenaProviderUpdateInput;
    where: AthenaProviderWhereUniqueInput;
};

export type MutationUpsertOneBenefitParsingRulesArgs = {
    create: BenefitParsingRulesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BenefitParsingRulesUpdateInput;
    where: BenefitParsingRulesWhereUniqueInput;
};

export type MutationUpsertOneBillingCodeArgs = {
    create: BillingCodeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BillingCodeUpdateInput;
    where: BillingCodeWhereUniqueInput;
};

export type MutationUpsertOneBillingTableDownloadRequestArgs = {
    create: BillingTableDownloadRequestCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BillingTableDownloadRequestUpdateInput;
    where: BillingTableDownloadRequestWhereUniqueInput;
};

export type MutationUpsertOneBoughtTreatmentArgs = {
    create: BoughtTreatmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BoughtTreatmentUpdateInput;
    where: BoughtTreatmentWhereUniqueInput;
};

export type MutationUpsertOneBoughtTreatmentAuditLogArgs = {
    create: BoughtTreatmentAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BoughtTreatmentAuditLogUpdateInput;
    where: BoughtTreatmentAuditLogWhereUniqueInput;
};

export type MutationUpsertOneBoughtTreatmentClaimDetailArgs = {
    create: BoughtTreatmentClaimDetailCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BoughtTreatmentClaimDetailUpdateInput;
    where: BoughtTreatmentClaimDetailWhereUniqueInput;
};

export type MutationUpsertOneBulkChargeCardRunArgs = {
    create: BulkChargeCardRunCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BulkChargeCardRunUpdateInput;
    where: BulkChargeCardRunWhereUniqueInput;
};

export type MutationUpsertOneBulkChargeCardRunItemArgs = {
    create: BulkChargeCardRunItemCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BulkChargeCardRunItemUpdateInput;
    where: BulkChargeCardRunItemWhereUniqueInput;
};

export type MutationUpsertOneBundleArgs = {
    create: BundleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BundleUpdateInput;
    where: BundleWhereUniqueInput;
};

export type MutationUpsertOneBundleToHrtArgs = {
    create: BundleToHrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BundleToHrtUpdateInput;
    where: BundleToHrtWhereUniqueInput;
};

export type MutationUpsertOneBusinessHourArgs = {
    create: BusinessHourCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: BusinessHourUpdateInput;
    where: BusinessHourWhereUniqueInput;
};

export type MutationUpsertOneCandidateTreatmentArgs = {
    create: CandidateTreatmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: CandidateTreatmentUpdateInput;
    where: CandidateTreatmentWhereUniqueInput;
};

export type MutationUpsertOneCardAuthorizationArgs = {
    create: CardAuthorizationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: CardAuthorizationUpdateInput;
    where: CardAuthorizationWhereUniqueInput;
};

export type MutationUpsertOneCardAuthorizationAuditLogArgs = {
    create: CardAuthorizationAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: CardAuthorizationAuditLogUpdateInput;
    where: CardAuthorizationAuditLogWhereUniqueInput;
};

export type MutationUpsertOneCashPriceArgs = {
    create: CashPriceCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: CashPriceUpdateInput;
    where: CashPriceWhereUniqueInput;
};

export type MutationUpsertOneChargeArgs = {
    create: ChargeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ChargeUpdateInput;
    where: ChargeWhereUniqueInput;
};

export type MutationUpsertOneChargeAuditLogArgs = {
    create: ChargeAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ChargeAuditLogUpdateInput;
    where: ChargeAuditLogWhereUniqueInput;
};

export type MutationUpsertOneChargeReattributionAndPartialPaymentLogArgs = {
    create: ChargeReattributionAndPartialPaymentLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ChargeReattributionAndPartialPaymentLogUpdateInput;
    where: ChargeReattributionAndPartialPaymentLogWhereUniqueInput;
};

export type MutationUpsertOneChargeReattributionLogArgs = {
    create: ChargeReattributionLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ChargeReattributionLogUpdateInput;
    where: ChargeReattributionLogWhereUniqueInput;
};

export type MutationUpsertOneCheckNetworkStatusResultsArgs = {
    create: CheckNetworkStatusResultsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: CheckNetworkStatusResultsUpdateInput;
    where: CheckNetworkStatusResultsWhereUniqueInput;
};

export type MutationUpsertOneCheckoutAdjudicationArgs = {
    create: CheckoutAdjudicationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: CheckoutAdjudicationUpdateInput;
    where: CheckoutAdjudicationWhereUniqueInput;
};

export type MutationUpsertOneClaimToBoughtTreatmentArgs = {
    create: ClaimToBoughtTreatmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ClaimToBoughtTreatmentUpdateInput;
    where: ClaimToBoughtTreatmentWhereUniqueInput;
};

export type MutationUpsertOneConfigCommitArgs = {
    create: ConfigCommitCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ConfigCommitUpdateInput;
    where: ConfigCommitWhereUniqueInput;
};

export type MutationUpsertOneConfigFlagArgs = {
    create: ConfigFlagCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ConfigFlagUpdateInput;
    where: ConfigFlagWhereUniqueInput;
};

export type MutationUpsertOneConfigSessionArgs = {
    create: ConfigSessionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ConfigSessionUpdateInput;
    where: ConfigSessionWhereUniqueInput;
};

export type MutationUpsertOneConsentFormArgs = {
    create: ConsentFormCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ConsentFormUpdateInput;
    where: ConsentFormWhereUniqueInput;
};

export type MutationUpsertOneConsumerArgs = {
    create: ConsumerCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ConsumerUpdateInput;
    where: ConsumerWhereUniqueInput;
};

export type MutationUpsertOneConsumerAuditLogArgs = {
    create: ConsumerAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ConsumerAuditLogUpdateInput;
    where: ConsumerAuditLogWhereUniqueInput;
};

export type MutationUpsertOneConsumerMessageArgs = {
    create: ConsumerMessageCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ConsumerMessageUpdateInput;
    where: ConsumerMessageWhereUniqueInput;
};

export type MutationUpsertOneConsumerNoteArgs = {
    create: ConsumerNoteCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ConsumerNoteUpdateInput;
    where: ConsumerNoteWhereUniqueInput;
};

export type MutationUpsertOneConsumerPhotoMetaDataArgs = {
    create: ConsumerPhotoMetaDataCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ConsumerPhotoMetaDataUpdateInput;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type MutationUpsertOneConsumerSrtRecordsArgs = {
    create: ConsumerSrtRecordsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ConsumerSrtRecordsUpdateInput;
    where: ConsumerSrtRecordsWhereUniqueInput;
};

export type MutationUpsertOneContractArgs = {
    create: ContractCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ContractUpdateInput;
    where: ContractWhereUniqueInput;
};

export type MutationUpsertOneContractAuditLogArgs = {
    create: ContractAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ContractAuditLogUpdateInput;
    where: ContractAuditLogWhereUniqueInput;
};

export type MutationUpsertOneCoverageResponsesArgs = {
    create: CoverageResponsesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: CoverageResponsesUpdateInput;
    where: CoverageResponsesWhereUniqueInput;
};

export type MutationUpsertOneCptExclusivityEdgeArgs = {
    create: CptExclusivityEdgeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: CptExclusivityEdgeUpdateInput;
    where: CptExclusivityEdgeWhereUniqueInput;
};

export type MutationUpsertOneCustomFieldArgs = {
    create: CustomFieldCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: CustomFieldUpdateInput;
    where: CustomFieldWhereUniqueInput;
};

export type MutationUpsertOneCustomFieldValueArgs = {
    create: CustomFieldValueCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: CustomFieldValueUpdateInput;
    where: CustomFieldValueWhereUniqueInput;
};

export type MutationUpsertOneDataMigrationsArgs = {
    create: DataMigrationsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DataMigrationsUpdateInput;
    where: DataMigrationsWhereUniqueInput;
};

export type MutationUpsertOneDefaultPracticeArgs = {
    create: DefaultPracticeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DefaultPracticeUpdateInput;
    where: DefaultPracticeWhereUniqueInput;
};

export type MutationUpsertOneDefaultProvidersArgs = {
    create: DefaultProvidersCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DefaultProvidersUpdateInput;
    where: DefaultProvidersWhereUniqueInput;
};

export type MutationUpsertOneDeploymentOrgPhaseArgs = {
    create: DeploymentOrgPhaseCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DeploymentOrgPhaseUpdateInput;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type MutationUpsertOneDeploymentOrgTaskArgs = {
    create: DeploymentOrgTaskCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DeploymentOrgTaskUpdateInput;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type MutationUpsertOneDeploymentOrgTaskDependencyArgs = {
    create: DeploymentOrgTaskDependencyCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DeploymentOrgTaskDependencyUpdateInput;
    where: DeploymentOrgTaskDependencyWhereUniqueInput;
};

export type MutationUpsertOneDeploymentPhaseArgs = {
    create: DeploymentPhaseCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DeploymentPhaseUpdateInput;
    where: DeploymentPhaseWhereUniqueInput;
};

export type MutationUpsertOneDeploymentTaskArgs = {
    create: DeploymentTaskCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DeploymentTaskUpdateInput;
    where: DeploymentTaskWhereUniqueInput;
};

export type MutationUpsertOneDeploymentTaskDependencyArgs = {
    create: DeploymentTaskDependencyCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DeploymentTaskDependencyUpdateInput;
    where: DeploymentTaskDependencyWhereUniqueInput;
};

export type MutationUpsertOneDeploymentTeamArgs = {
    create: DeploymentTeamCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DeploymentTeamUpdateInput;
    where: DeploymentTeamWhereUniqueInput;
};

export type MutationUpsertOneDiscountCodesArgs = {
    create: DiscountCodesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: DiscountCodesUpdateInput;
    where: DiscountCodesWhereUniqueInput;
};

export type MutationUpsertOneEcwPayerAliasArgs = {
    create: EcwPayerAliasCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EcwPayerAliasUpdateInput;
    where: EcwPayerAliasWhereUniqueInput;
};

export type MutationUpsertOneEcwPayerStcArgs = {
    create: EcwPayerStcCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EcwPayerStcUpdateInput;
    where: EcwPayerStcWhereUniqueInput;
};

export type MutationUpsertOneEhrAppointmentTypeIdToNameArgs = {
    create: EhrAppointmentTypeIdToNameCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrAppointmentTypeIdToNameUpdateInput;
    where: EhrAppointmentTypeIdToNameWhereUniqueInput;
};

export type MutationUpsertOneEhrPaymentDescriptorArgs = {
    create: EhrPaymentDescriptorCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrPaymentDescriptorUpdateInput;
    where: EhrPaymentDescriptorWhereUniqueInput;
};

export type MutationUpsertOneEhrPaymentDescriptorAuditLogArgs = {
    create: EhrPaymentDescriptorAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrPaymentDescriptorAuditLogUpdateInput;
    where: EhrPaymentDescriptorAuditLogWhereUniqueInput;
};

export type MutationUpsertOneEhrPaymentDirectionSsAssetArgs = {
    create: EhrPaymentDirectionSsAssetCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrPaymentDirectionSsAssetUpdateInput;
    where: EhrPaymentDirectionSsAssetWhereUniqueInput;
};

export type MutationUpsertOneEhrPostDetailArgs = {
    create: EhrPostDetailCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrPostDetailUpdateInput;
    where: EhrPostDetailWhereUniqueInput;
};

export type MutationUpsertOneEhrPostDetailToPayoutArgs = {
    create: EhrPostDetailToPayoutCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrPostDetailToPayoutUpdateInput;
    where: EhrPostDetailToPayoutWhereUniqueInput;
};

export type MutationUpsertOneEhrPostLedgerArgs = {
    create: EhrPostLedgerCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrPostLedgerUpdateInput;
    where: EhrPostLedgerWhereUniqueInput;
};

export type MutationUpsertOneEhrPostLedgerAuditLogArgs = {
    create: EhrPostLedgerAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrPostLedgerAuditLogUpdateInput;
    where: EhrPostLedgerAuditLogWhereUniqueInput;
};

export type MutationUpsertOneEhrPostLedgerToPayoutArgs = {
    create: EhrPostLedgerToPayoutCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrPostLedgerToPayoutUpdateInput;
    where: EhrPostLedgerToPayoutWhereUniqueInput;
};

export type MutationUpsertOneEhrPrimaryCareProviderArgs = {
    create: EhrPrimaryCareProviderCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrPrimaryCareProviderUpdateInput;
    where: EhrPrimaryCareProviderWhereUniqueInput;
};

export type MutationUpsertOneEhrProviderMappingArgs = {
    create: EhrProviderMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrProviderMappingUpdateInput;
    where: EhrProviderMappingWhereUniqueInput;
};

export type MutationUpsertOneEhrSlotArgs = {
    create: EhrSlotCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrSlotUpdateInput;
    where: EhrSlotWhereUniqueInput;
};

export type MutationUpsertOneEhrSlotAuditLogArgs = {
    create: EhrSlotAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EhrSlotAuditLogUpdateInput;
    where: EhrSlotAuditLogWhereUniqueInput;
};

export type MutationUpsertOneEncounterArgs = {
    create: EncounterCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: EncounterUpdateInput;
    where: EncounterWhereUniqueInput;
};

export type MutationUpsertOneExperityEncounterArgs = {
    create: ExperityEncounterCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ExperityEncounterUpdateInput;
    where: ExperityEncounterWhereUniqueInput;
};

export type MutationUpsertOneFaqDropdownsArgs = {
    create: FaqDropdownsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: FaqDropdownsUpdateInput;
    where: FaqDropdownsWhereUniqueInput;
};

export type MutationUpsertOneFeeConfigArgs = {
    create: FeeConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: FeeConfigUpdateInput;
    where: FeeConfigWhereUniqueInput;
};

export type MutationUpsertOneFeeConfigAuditLogArgs = {
    create: FeeConfigAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: FeeConfigAuditLogUpdateInput;
    where: FeeConfigAuditLogWhereUniqueInput;
};

export type MutationUpsertOneGuarantorPaymentLinkContextArgs = {
    create: GuarantorPaymentLinkContextCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: GuarantorPaymentLinkContextUpdateInput;
    where: GuarantorPaymentLinkContextWhereUniqueInput;
};

export type MutationUpsertOneHolidayArgs = {
    create: HolidayCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: HolidayUpdateInput;
    where: HolidayWhereUniqueInput;
};

export type MutationUpsertOneHrtArgs = {
    create: HrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: HrtUpdateInput;
    where: HrtWhereUniqueInput;
};

export type MutationUpsertOneHrtFlagsArgs = {
    create: HrtFlagsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: HrtFlagsUpdateInput;
    where: HrtFlagsWhereUniqueInput;
};

export type MutationUpsertOneHrtPaymentTypeArgs = {
    create: HrtPaymentTypeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: HrtPaymentTypeUpdateInput;
    where: HrtPaymentTypeWhereUniqueInput;
};

export type MutationUpsertOneHrtToSrtArgs = {
    create: HrtToSrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: HrtToSrtUpdateInput;
    where: HrtToSrtWhereUniqueInput;
};

export type MutationUpsertOneHrtTranslationArgs = {
    create: HrtTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: HrtTranslationUpdateInput;
    where: HrtTranslationWhereUniqueInput;
};

export type MutationUpsertOneInboundRequestLogArgs = {
    create: InboundRequestLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: InboundRequestLogUpdateInput;
    where: InboundRequestLogWhereUniqueInput;
};

export type MutationUpsertOneInboundTextMessageLogArgs = {
    create: InboundTextMessageLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: InboundTextMessageLogUpdateInput;
    where: InboundTextMessageLogWhereUniqueInput;
};

export type MutationUpsertOneInsuranceArgs = {
    create: InsuranceCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: InsuranceUpdateInput;
    where: InsuranceWhereUniqueInput;
};

export type MutationUpsertOneInsuranceAuditLogArgs = {
    create: InsuranceAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: InsuranceAuditLogUpdateInput;
    where: InsuranceAuditLogWhereUniqueInput;
};

export type MutationUpsertOneInsuranceMetadataArgs = {
    create: InsuranceMetadataCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: InsuranceMetadataUpdateInput;
    where: InsuranceMetadataWhereUniqueInput;
};

export type MutationUpsertOneIntakeFormArgs = {
    create: IntakeFormCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: IntakeFormUpdateInput;
    where: IntakeFormWhereUniqueInput;
};

export type MutationUpsertOneIntakeFormSectionArgs = {
    create: IntakeFormSectionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: IntakeFormSectionUpdateInput;
    where: IntakeFormSectionWhereUniqueInput;
};

export type MutationUpsertOneIntakeFormSectionTranslationArgs = {
    create: IntakeFormSectionTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: IntakeFormSectionTranslationUpdateInput;
    where: IntakeFormSectionTranslationWhereUniqueInput;
};

export type MutationUpsertOneIntakeFormToQuestionArgs = {
    create: IntakeFormToQuestionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: IntakeFormToQuestionUpdateInput;
    where: IntakeFormToQuestionWhereUniqueInput;
};

export type MutationUpsertOneIntakeQuestionArgs = {
    create: IntakeQuestionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: IntakeQuestionUpdateInput;
    where: IntakeQuestionWhereUniqueInput;
};

export type MutationUpsertOneIntakeQuestionTranslationArgs = {
    create: IntakeQuestionTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: IntakeQuestionTranslationUpdateInput;
    where: IntakeQuestionTranslationWhereUniqueInput;
};

export type MutationUpsertOneInvoiceDailyLineItemsArgs = {
    create: InvoiceDailyLineItemsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: InvoiceDailyLineItemsUpdateInput;
    where: InvoiceDailyLineItemsWhereUniqueInput;
};

export type MutationUpsertOneInvoicesArgs = {
    create: InvoicesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: InvoicesUpdateInput;
    where: InvoicesWhereUniqueInput;
};

export type MutationUpsertOneKeywordRuleArgs = {
    create: KeywordRuleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: KeywordRuleUpdateInput;
    where: KeywordRuleWhereUniqueInput;
};

export type MutationUpsertOneLinkMappingArgs = {
    create: LinkMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: LinkMappingUpdateInput;
    where: LinkMappingWhereUniqueInput;
};

export type MutationUpsertOneLiveTransfersArgs = {
    create: LiveTransfersCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: LiveTransfersUpdateInput;
    where: LiveTransfersWhereUniqueInput;
};

export type MutationUpsertOneMcmsAssociationArgs = {
    create: McmsAssociationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: McmsAssociationUpdateInput;
    where: McmsAssociationWhereUniqueInput;
};

export type MutationUpsertOneMcmsAssociationAuditLogArgs = {
    create: McmsAssociationAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: McmsAssociationAuditLogUpdateInput;
    where: McmsAssociationAuditLogWhereUniqueInput;
};

export type MutationUpsertOneMcmsAssociationClaimArgs = {
    create: McmsAssociationClaimCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: McmsAssociationClaimUpdateInput;
    where: McmsAssociationClaimWhereUniqueInput;
};

export type MutationUpsertOneMcmsAssociationClaimAuditLogArgs = {
    create: McmsAssociationClaimAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: McmsAssociationClaimAuditLogUpdateInput;
    where: McmsAssociationClaimAuditLogWhereUniqueInput;
};

export type MutationUpsertOneMcmsAssociationSlotArgs = {
    create: McmsAssociationSlotCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: McmsAssociationSlotUpdateInput;
    where: McmsAssociationSlotWhereUniqueInput;
};

export type MutationUpsertOneMcmsAssociationSlotAuditLogArgs = {
    create: McmsAssociationSlotAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: McmsAssociationSlotAuditLogUpdateInput;
    where: McmsAssociationSlotAuditLogWhereUniqueInput;
};

export type MutationUpsertOneMessageBlueprintArgs = {
    create: MessageBlueprintCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MessageBlueprintUpdateInput;
    where: MessageBlueprintWhereUniqueInput;
};

export type MutationUpsertOneMessageConsolidationContextArgs = {
    create: MessageConsolidationContextCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MessageConsolidationContextUpdateInput;
    where: MessageConsolidationContextWhereUniqueInput;
};

export type MutationUpsertOneMessageConsolidationTemplateArgs = {
    create: MessageConsolidationTemplateCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MessageConsolidationTemplateUpdateInput;
    where: MessageConsolidationTemplateWhereUniqueInput;
};

export type MutationUpsertOneMessageNudgeArgs = {
    create: MessageNudgeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MessageNudgeUpdateInput;
    where: MessageNudgeWhereUniqueInput;
};

export type MutationUpsertOneMessageOrchestrationRuleArgs = {
    create: MessageOrchestrationRuleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MessageOrchestrationRuleUpdateInput;
    where: MessageOrchestrationRuleWhereUniqueInput;
};

export type MutationUpsertOneMessagePayAfterArgs = {
    create: MessagePayAfterCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MessagePayAfterUpdateInput;
    where: MessagePayAfterWhereUniqueInput;
};

export type MutationUpsertOneMessageSettingsHrtArgs = {
    create: MessageSettingsHrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MessageSettingsHrtUpdateInput;
    where: MessageSettingsHrtWhereUniqueInput;
};

export type MutationUpsertOneMessageSettingsOrgArgs = {
    create: MessageSettingsOrgCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MessageSettingsOrgUpdateInput;
    where: MessageSettingsOrgWhereUniqueInput;
};

export type MutationUpsertOneMessageTemplateHrtArgs = {
    create: MessageTemplateHrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MessageTemplateHrtUpdateInput;
    where: MessageTemplateHrtWhereUniqueInput;
};

export type MutationUpsertOneMessageTemplateOrgArgs = {
    create: MessageTemplateOrgCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MessageTemplateOrgUpdateInput;
    where: MessageTemplateOrgWhereUniqueInput;
};

export type MutationUpsertOneMigratedEncounterArgs = {
    create: MigratedEncounterCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MigratedEncounterUpdateInput;
    where: MigratedEncounterWhereUniqueInput;
};

export type MutationUpsertOneMigrationsArgs = {
    create: MigrationsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: MigrationsUpdateInput;
    where: MigrationsWhereUniqueInput;
};

export type MutationUpsertOneNetworkValidationArgs = {
    create: NetworkValidationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: NetworkValidationUpdateInput;
    where: NetworkValidationWhereUniqueInput;
};

export type MutationUpsertOneNetworkPlanExceptionsArgs = {
    create: NetworkPlanExceptionsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: NetworkPlanExceptionsUpdateInput;
    where: NetworkPlanExceptionsWhereUniqueInput;
};

export type MutationUpsertOneNonCardRefundsArgs = {
    create: NonCardRefundsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: NonCardRefundsUpdateInput;
    where: NonCardRefundsWhereUniqueInput;
};

export type MutationUpsertOneOrgConfigFlagArgs = {
    create: OrgConfigFlagCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: OrgConfigFlagUpdateInput;
    where: OrgConfigFlagWhereUniqueInput;
};

export type MutationUpsertOneOrgHrtSrtRuleArgs = {
    create: OrgHrtSrtRuleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: OrgHrtSrtRuleUpdateInput;
    where: OrgHrtSrtRuleWhereUniqueInput;
};

export type MutationUpsertOneOrgNetworkResultsArgs = {
    create: OrgNetworkResultsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: OrgNetworkResultsUpdateInput;
    where: OrgNetworkResultsWhereUniqueInput;
};

export type MutationUpsertOneOrgOverrideRuleArgs = {
    create: OrgOverrideRuleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: OrgOverrideRuleUpdateInput;
    where: OrgOverrideRuleWhereUniqueInput;
};

export type MutationUpsertOneOrgFeesArgs = {
    create: OrgFeesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: OrgFeesUpdateInput;
    where: OrgFeesWhereUniqueInput;
};

export type MutationUpsertOneOrgStripeMappingArgs = {
    create: OrgStripeMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: OrgStripeMappingUpdateInput;
    where: OrgStripeMappingWhereUniqueInput;
};

export type MutationUpsertOneOrganizationArgs = {
    create: OrganizationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: OrganizationUpdateInput;
    where: OrganizationWhereUniqueInput;
};

export type MutationUpsertOneOrganizationAssetsArgs = {
    create: OrganizationAssetsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: OrganizationAssetsUpdateInput;
    where: OrganizationAssetsWhereUniqueInput;
};

export type MutationUpsertOneOrganizationTranslationArgs = {
    create: OrganizationTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: OrganizationTranslationUpdateInput;
    where: OrganizationTranslationWhereUniqueInput;
};

export type MutationUpsertOnePayLaterAuthorizationArgs = {
    create: PayLaterAuthorizationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PayLaterAuthorizationUpdateInput;
    where: PayLaterAuthorizationWhereUniqueInput;
};

export type MutationUpsertOnePayLaterAuthorizationAuditLogArgs = {
    create: PayLaterAuthorizationAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PayLaterAuthorizationAuditLogUpdateInput;
    where: PayLaterAuthorizationAuditLogWhereUniqueInput;
};

export type MutationUpsertOnePayerArgs = {
    create: PayerCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PayerUpdateInput;
    where: PayerWhereUniqueInput;
};

export type MutationUpsertOnePayerPlanMappingArgs = {
    create: PayerPlanMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PayerPlanMappingUpdateInput;
    where: PayerPlanMappingWhereUniqueInput;
};

export type MutationUpsertOnePayerToEhrInsurancePackageMappingArgs = {
    create: PayerToEhrInsurancePackageMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PayerToEhrInsurancePackageMappingUpdateInput;
    where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
};

export type MutationUpsertOnePaymentAuthorizationArgs = {
    create: PaymentAuthorizationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentAuthorizationUpdateInput;
    where: PaymentAuthorizationWhereUniqueInput;
};

export type MutationUpsertOnePaymentAuthorizationAuditLogArgs = {
    create: PaymentAuthorizationAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentAuthorizationAuditLogUpdateInput;
    where: PaymentAuthorizationAuditLogWhereUniqueInput;
};

export type MutationUpsertOnePaymentContractArgs = {
    create: PaymentContractCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentContractUpdateInput;
    where: PaymentContractWhereUniqueInput;
};

export type MutationUpsertOnePaymentPlanArgs = {
    create: PaymentPlanCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentPlanUpdateInput;
    where: PaymentPlanWhereUniqueInput;
};

export type MutationUpsertOnePaymentPlanAdjustmentArgs = {
    create: PaymentPlanAdjustmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentPlanAdjustmentUpdateInput;
    where: PaymentPlanAdjustmentWhereUniqueInput;
};

export type MutationUpsertOnePaymentPlanAdjustmentAuditLogArgs = {
    create: PaymentPlanAdjustmentAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentPlanAdjustmentAuditLogUpdateInput;
    where: PaymentPlanAdjustmentAuditLogWhereUniqueInput;
};

export type MutationUpsertOnePaymentPlanAuditLogArgs = {
    create: PaymentPlanAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentPlanAuditLogUpdateInput;
    where: PaymentPlanAuditLogWhereUniqueInput;
};

export type MutationUpsertOnePaymentPlanAutoChargeArgs = {
    create: PaymentPlanAutoChargeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentPlanAutoChargeUpdateInput;
    where: PaymentPlanAutoChargeWhereUniqueInput;
};

export type MutationUpsertOnePaymentPlanAutoChargeAuditLogArgs = {
    create: PaymentPlanAutoChargeAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentPlanAutoChargeAuditLogUpdateInput;
    where: PaymentPlanAutoChargeAuditLogWhereUniqueInput;
};

export type MutationUpsertOnePaymentPlanBoughtTreatmentArgs = {
    create: PaymentPlanBoughtTreatmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentPlanBoughtTreatmentUpdateInput;
    where: PaymentPlanBoughtTreatmentWhereUniqueInput;
};

export type MutationUpsertOnePaymentPlanBoughtTreatmentAuditLogArgs = {
    create: PaymentPlanBoughtTreatmentAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentPlanBoughtTreatmentAuditLogUpdateInput;
    where: PaymentPlanBoughtTreatmentAuditLogWhereUniqueInput;
};

export type MutationUpsertOnePaymentPlanOrgConfigArgs = {
    create: PaymentPlanOrgConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentPlanOrgConfigUpdateInput;
    where: PaymentPlanOrgConfigWhereUniqueInput;
};

export type MutationUpsertOnePaymentPlanOrgConfigAuditLogArgs = {
    create: PaymentPlanOrgConfigAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PaymentPlanOrgConfigAuditLogUpdateInput;
    where: PaymentPlanOrgConfigAuditLogWhereUniqueInput;
};

export type MutationUpsertOnePayoutArgs = {
    create: PayoutCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PayoutUpdateInput;
    where: PayoutWhereUniqueInput;
};

export type MutationUpsertOnePayoutAuditLogArgs = {
    create: PayoutAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PayoutAuditLogUpdateInput;
    where: PayoutAuditLogWhereUniqueInput;
};

export type MutationUpsertOnePendingVoidPayoutReversalArgs = {
    create: PendingVoidPayoutReversalCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PendingVoidPayoutReversalUpdateInput;
    where: PendingVoidPayoutReversalWhereUniqueInput;
};

export type MutationUpsertOnePhoneNumberTypeArgs = {
    create: PhoneNumberTypeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PhoneNumberTypeUpdateInput;
    where: PhoneNumberTypeWhereUniqueInput;
};

export type MutationUpsertOnePlaceOfServiceCodeArgs = {
    create: PlaceOfServiceCodeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PlaceOfServiceCodeUpdateInput;
    where: PlaceOfServiceCodeWhereUniqueInput;
};

export type MutationUpsertOnePracticeArgs = {
    create: PracticeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PracticeUpdateInput;
    where: PracticeWhereUniqueInput;
};

export type MutationUpsertOnePracticeConfigurationArgs = {
    create: PracticeConfigurationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PracticeConfigurationUpdateInput;
    where: PracticeConfigurationWhereUniqueInput;
};

export type MutationUpsertOnePracticeHoursArgs = {
    create: PracticeHoursCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PracticeHoursUpdateInput;
    where: PracticeHoursWhereUniqueInput;
};

export type MutationUpsertOnePracticeHoursOverridesArgs = {
    create: PracticeHoursOverridesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PracticeHoursOverridesUpdateInput;
    where: PracticeHoursOverridesWhereUniqueInput;
};

export type MutationUpsertOnePricedTreatmentArgs = {
    create: PricedTreatmentCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PricedTreatmentUpdateInput;
    where: PricedTreatmentWhereUniqueInput;
};

export type MutationUpsertOnePricingAttemptArgs = {
    create: PricingAttemptCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PricingAttemptUpdateInput;
    where: PricingAttemptWhereUniqueInput;
};

export type MutationUpsertOnePricingEscalatorArgs = {
    create: PricingEscalatorCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PricingEscalatorUpdateInput;
    where: PricingEscalatorWhereUniqueInput;
};

export type MutationUpsertOnePricingQueueArgs = {
    create: PricingQueueCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PricingQueueUpdateInput;
    where: PricingQueueWhereUniqueInput;
};

export type MutationUpsertOnePricingResultsArgs = {
    create: PricingResultsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: PricingResultsUpdateInput;
    where: PricingResultsWhereUniqueInput;
};

export type MutationUpsertOneProcedureBenefitParsingRulesArgs = {
    create: ProcedureBenefitParsingRulesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProcedureBenefitParsingRulesUpdateInput;
    where: ProcedureBenefitParsingRulesWhereUniqueInput;
};

export type MutationUpsertOneProductCategoriesArgs = {
    create: ProductCategoriesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProductCategoriesUpdateInput;
    where: ProductCategoriesWhereUniqueInput;
};

export type MutationUpsertOneProductCategoryTranslationArgs = {
    create: ProductCategoryTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProductCategoryTranslationUpdateInput;
    where: ProductCategoryTranslationWhereUniqueInput;
};

export type MutationUpsertOneProductToBundleArgs = {
    create: ProductToBundleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProductToBundleUpdateInput;
    where: ProductToBundleWhereUniqueInput;
};

export type MutationUpsertOneProductToHrtArgs = {
    create: ProductToHrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProductToHrtUpdateInput;
    where: ProductToHrtWhereUniqueInput;
};

export type MutationUpsertOneProductTranslationArgs = {
    create: ProductTranslationCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProductTranslationUpdateInput;
    where: ProductTranslationWhereUniqueInput;
};

export type MutationUpsertOneProductsArgs = {
    create: ProductsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProductsUpdateInput;
    where: ProductsWhereUniqueInput;
};

export type MutationUpsertOneProviderArgs = {
    create: ProviderCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProviderUpdateInput;
    where: ProviderWhereUniqueInput;
};

export type MutationUpsertOneProviderCredentialingArgs = {
    create: ProviderCredentialingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProviderCredentialingUpdateInput;
    where: ProviderCredentialingWhereUniqueInput;
};

export type MutationUpsertOneProviderGroupArgs = {
    create: ProviderGroupCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProviderGroupUpdateInput;
    where: ProviderGroupWhereUniqueInput;
};

export type MutationUpsertOneProviderGroupToHrtArgs = {
    create: ProviderGroupToHrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProviderGroupToHrtUpdateInput;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type MutationUpsertOneProviderHrtMaxCountArgs = {
    create: ProviderHrtMaxCountCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProviderHrtMaxCountUpdateInput;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type MutationUpsertOneProviderTaxonomyArgs = {
    create: ProviderTaxonomyCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProviderTaxonomyUpdateInput;
    where: ProviderTaxonomyWhereUniqueInput;
};

export type MutationUpsertOneProviderToOrgArgs = {
    create: ProviderToOrgCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProviderToOrgUpdateInput;
    where: ProviderToOrgWhereUniqueInput;
};

export type MutationUpsertOneProviderToProviderGroupArgs = {
    create: ProviderToProviderGroupCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ProviderToProviderGroupUpdateInput;
    where: ProviderToProviderGroupWhereUniqueInput;
};

export type MutationUpsertOneReattributionDirectionArgs = {
    create: ReattributionDirectionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ReattributionDirectionUpdateInput;
    where: ReattributionDirectionWhereUniqueInput;
};

export type MutationUpsertOneReceiptArrangementArgs = {
    create: ReceiptArrangementCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ReceiptArrangementUpdateInput;
    where: ReceiptArrangementWhereUniqueInput;
};

export type MutationUpsertOneReservedEhrVisitArgs = {
    create: ReservedEhrVisitCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ReservedEhrVisitUpdateInput;
    where: ReservedEhrVisitWhereUniqueInput;
};

export type MutationUpsertOneResetTokenArgs = {
    create: ResetTokenCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ResetTokenUpdateInput;
    where: ResetTokenWhereUniqueInput;
};

export type MutationUpsertOneSavedIntakeResponseArgs = {
    create: SavedIntakeResponseCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SavedIntakeResponseUpdateInput;
    where: SavedIntakeResponseWhereUniqueInput;
};

export type MutationUpsertOneSchedulingSlotConfigArgs = {
    create: SchedulingSlotConfigCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SchedulingSlotConfigUpdateInput;
    where: SchedulingSlotConfigWhereUniqueInput;
};

export type MutationUpsertOneServiceTypeCodeArgs = {
    create: ServiceTypeCodeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ServiceTypeCodeUpdateInput;
    where: ServiceTypeCodeWhereUniqueInput;
};

export type MutationUpsertOneSlotArgs = {
    create: SlotCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SlotUpdateInput;
    where: SlotWhereUniqueInput;
};

export type MutationUpsertOneSlotAuditLogArgs = {
    create: SlotAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SlotAuditLogUpdateInput;
    where: SlotAuditLogWhereUniqueInput;
};

export type MutationUpsertOneSrtArgs = {
    create: SrtCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SrtUpdateInput;
    where: SrtWhereUniqueInput;
};

export type MutationUpsertOneSrtFlagsArgs = {
    create: SrtFlagsCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SrtFlagsUpdateInput;
    where: SrtFlagsWhereUniqueInput;
};

export type MutationUpsertOneSrtMultiplierRuleArgs = {
    create: SrtMultiplierRuleCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SrtMultiplierRuleUpdateInput;
    where: SrtMultiplierRuleWhereUniqueInput;
};

export type MutationUpsertOneSrtToBillingCodeArgs = {
    create: SrtToBillingCodeCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SrtToBillingCodeUpdateInput;
    where: SrtToBillingCodeWhereUniqueInput;
};

export type MutationUpsertOneStatePayerMappingArgs = {
    create: StatePayerMappingCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: StatePayerMappingUpdateInput;
    where: StatePayerMappingWhereUniqueInput;
};

export type MutationUpsertOneSuperscriptFeeLineItemArgs = {
    create: SuperscriptFeeLineItemCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SuperscriptFeeLineItemUpdateInput;
    where: SuperscriptFeeLineItemWhereUniqueInput;
};

export type MutationUpsertOneSuperscriptFeesArgs = {
    create: SuperscriptFeesCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SuperscriptFeesUpdateInput;
    where: SuperscriptFeesWhereUniqueInput;
};

export type MutationUpsertOneSuperscriptIntakeQuestionArgs = {
    create: SuperscriptIntakeQuestionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: SuperscriptIntakeQuestionUpdateInput;
    where: SuperscriptIntakeQuestionWhereUniqueInput;
};

export type MutationUpsertOneTimeBlockArgs = {
    create: TimeBlockCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: TimeBlockUpdateInput;
    where: TimeBlockWhereUniqueInput;
};

export type MutationUpsertOneTransactionArgs = {
    create: TransactionCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: TransactionUpdateInput;
    where: TransactionWhereUniqueInput;
};

export type MutationUpsertOneUserArgs = {
    create: UserCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: UserUpdateInput;
    where: UserWhereUniqueInput;
};

export type MutationUpsertOneUserAuditLogArgs = {
    create: UserAuditLogCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: UserAuditLogUpdateInput;
    where: UserAuditLogWhereUniqueInput;
};

export type MutationUpsertOneUserPracticeVisitArgs = {
    create: UserPracticeVisitCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: UserPracticeVisitUpdateInput;
    where: UserPracticeVisitWhereUniqueInput;
};

export type MutationUpsertOneUserToNewUserArgs = {
    create: UserToNewUserCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: UserToNewUserUpdateInput;
    where: UserToNewUserWhereUniqueInput;
};

export type MutationUpsertOneValidPayersArgs = {
    create: ValidPayersCreateInput;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    update: ValidPayersUpdateInput;
    where: ValidPayersWhereUniqueInput;
};

export enum NetworkType {
    In = 'IN',
    Out = 'OUT',
}

export type NestedBigIntFilter = {
    equals?: InputMaybe<Scalars['BigInt']['input']>;
    gt?: InputMaybe<Scalars['BigInt']['input']>;
    gte?: InputMaybe<Scalars['BigInt']['input']>;
    in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
    lt?: InputMaybe<Scalars['BigInt']['input']>;
    lte?: InputMaybe<Scalars['BigInt']['input']>;
    not?: InputMaybe<NestedBigIntFilter>;
    notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBigIntWithAggregatesFilter = {
    _avg?: InputMaybe<NestedFloatFilter>;
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedBigIntFilter>;
    _min?: InputMaybe<NestedBigIntFilter>;
    _sum?: InputMaybe<NestedBigIntFilter>;
    equals?: InputMaybe<Scalars['BigInt']['input']>;
    gt?: InputMaybe<Scalars['BigInt']['input']>;
    gte?: InputMaybe<Scalars['BigInt']['input']>;
    in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
    lt?: InputMaybe<Scalars['BigInt']['input']>;
    lte?: InputMaybe<Scalars['BigInt']['input']>;
    not?: InputMaybe<NestedBigIntWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBoolFilter = {
    equals?: InputMaybe<Scalars['Boolean']['input']>;
    not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
    equals?: InputMaybe<Scalars['Boolean']['input']>;
    not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedBoolNullableFilter>;
    _min?: InputMaybe<NestedBoolNullableFilter>;
    equals?: InputMaybe<Scalars['Boolean']['input']>;
    not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedBoolFilter>;
    _min?: InputMaybe<NestedBoolFilter>;
    equals?: InputMaybe<Scalars['Boolean']['input']>;
    not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
    equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
    lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    not?: InputMaybe<NestedDateTimeFilter>;
    notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeNullableFilter = {
    equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
    lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    not?: InputMaybe<NestedDateTimeNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedDateTimeNullableFilter>;
    _min?: InputMaybe<NestedDateTimeNullableFilter>;
    equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
    lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedDateTimeFilter>;
    _min?: InputMaybe<NestedDateTimeFilter>;
    equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
    lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
    not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDecimalFilter = {
    equals?: InputMaybe<Scalars['Decimal']['input']>;
    gt?: InputMaybe<Scalars['Decimal']['input']>;
    gte?: InputMaybe<Scalars['Decimal']['input']>;
    in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
    lt?: InputMaybe<Scalars['Decimal']['input']>;
    lte?: InputMaybe<Scalars['Decimal']['input']>;
    not?: InputMaybe<NestedDecimalFilter>;
    notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedDecimalNullableFilter = {
    equals?: InputMaybe<Scalars['Decimal']['input']>;
    gt?: InputMaybe<Scalars['Decimal']['input']>;
    gte?: InputMaybe<Scalars['Decimal']['input']>;
    in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
    lt?: InputMaybe<Scalars['Decimal']['input']>;
    lte?: InputMaybe<Scalars['Decimal']['input']>;
    not?: InputMaybe<NestedDecimalNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedDecimalNullableWithAggregatesFilter = {
    _avg?: InputMaybe<NestedDecimalNullableFilter>;
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedDecimalNullableFilter>;
    _min?: InputMaybe<NestedDecimalNullableFilter>;
    _sum?: InputMaybe<NestedDecimalNullableFilter>;
    equals?: InputMaybe<Scalars['Decimal']['input']>;
    gt?: InputMaybe<Scalars['Decimal']['input']>;
    gte?: InputMaybe<Scalars['Decimal']['input']>;
    in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
    lt?: InputMaybe<Scalars['Decimal']['input']>;
    lte?: InputMaybe<Scalars['Decimal']['input']>;
    not?: InputMaybe<NestedDecimalNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedDecimalWithAggregatesFilter = {
    _avg?: InputMaybe<NestedDecimalFilter>;
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedDecimalFilter>;
    _min?: InputMaybe<NestedDecimalFilter>;
    _sum?: InputMaybe<NestedDecimalFilter>;
    equals?: InputMaybe<Scalars['Decimal']['input']>;
    gt?: InputMaybe<Scalars['Decimal']['input']>;
    gte?: InputMaybe<Scalars['Decimal']['input']>;
    in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
    lt?: InputMaybe<Scalars['Decimal']['input']>;
    lte?: InputMaybe<Scalars['Decimal']['input']>;
    not?: InputMaybe<NestedDecimalWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedEnumAirStatusCodeFilter = {
    equals?: InputMaybe<AirStatusCode>;
    in?: InputMaybe<Array<AirStatusCode>>;
    not?: InputMaybe<NestedEnumAirStatusCodeFilter>;
    notIn?: InputMaybe<Array<AirStatusCode>>;
};

export type NestedEnumAirStatusCodeNullableFilter = {
    equals?: InputMaybe<AirStatusCode>;
    in?: InputMaybe<Array<AirStatusCode>>;
    not?: InputMaybe<NestedEnumAirStatusCodeNullableFilter>;
    notIn?: InputMaybe<Array<AirStatusCode>>;
};

export type NestedEnumAirStatusCodeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAirStatusCodeNullableFilter>;
    _min?: InputMaybe<NestedEnumAirStatusCodeNullableFilter>;
    equals?: InputMaybe<AirStatusCode>;
    in?: InputMaybe<Array<AirStatusCode>>;
    not?: InputMaybe<NestedEnumAirStatusCodeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AirStatusCode>>;
};

export type NestedEnumAirStatusCodeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumAirStatusCodeFilter>;
    _min?: InputMaybe<NestedEnumAirStatusCodeFilter>;
    equals?: InputMaybe<AirStatusCode>;
    in?: InputMaybe<Array<AirStatusCode>>;
    not?: InputMaybe<NestedEnumAirStatusCodeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AirStatusCode>>;
};

export type NestedEnumAdjudicationActionEnumNullableFilter = {
    equals?: InputMaybe<AdjudicationActionEnum>;
    in?: InputMaybe<Array<AdjudicationActionEnum>>;
    not?: InputMaybe<NestedEnumAdjudicationActionEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjudicationActionEnum>>;
};

export type NestedEnumAdjudicationActionEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjudicationActionEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjudicationActionEnumNullableFilter>;
    equals?: InputMaybe<AdjudicationActionEnum>;
    in?: InputMaybe<Array<AdjudicationActionEnum>>;
    not?: InputMaybe<NestedEnumAdjudicationActionEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjudicationActionEnum>>;
};

export type NestedEnumAdjudicationAppliedStatusEnumNullableFilter = {
    equals?: InputMaybe<AdjudicationAppliedStatusEnum>;
    in?: InputMaybe<Array<AdjudicationAppliedStatusEnum>>;
    not?: InputMaybe<NestedEnumAdjudicationAppliedStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjudicationAppliedStatusEnum>>;
};

export type NestedEnumAdjudicationAppliedStatusEnumNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumAdjudicationAppliedStatusEnumNullableFilter>;
        _min?: InputMaybe<NestedEnumAdjudicationAppliedStatusEnumNullableFilter>;
        equals?: InputMaybe<AdjudicationAppliedStatusEnum>;
        in?: InputMaybe<Array<AdjudicationAppliedStatusEnum>>;
        not?: InputMaybe<NestedEnumAdjudicationAppliedStatusEnumNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<AdjudicationAppliedStatusEnum>>;
    };

export type NestedEnumAdjudicationPaymentMethodEnumNullableFilter = {
    equals?: InputMaybe<AdjudicationPaymentMethodEnum>;
    in?: InputMaybe<Array<AdjudicationPaymentMethodEnum>>;
    not?: InputMaybe<NestedEnumAdjudicationPaymentMethodEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjudicationPaymentMethodEnum>>;
};

export type NestedEnumAdjudicationPaymentMethodEnumNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumAdjudicationPaymentMethodEnumNullableFilter>;
        _min?: InputMaybe<NestedEnumAdjudicationPaymentMethodEnumNullableFilter>;
        equals?: InputMaybe<AdjudicationPaymentMethodEnum>;
        in?: InputMaybe<Array<AdjudicationPaymentMethodEnum>>;
        not?: InputMaybe<NestedEnumAdjudicationPaymentMethodEnumNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<AdjudicationPaymentMethodEnum>>;
    };

export type NestedEnumAdjudicationTypeFilter = {
    equals?: InputMaybe<AdjudicationType>;
    in?: InputMaybe<Array<AdjudicationType>>;
    not?: InputMaybe<NestedEnumAdjudicationTypeFilter>;
    notIn?: InputMaybe<Array<AdjudicationType>>;
};

export type NestedEnumAdjudicationTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumAdjudicationTypeFilter>;
    _min?: InputMaybe<NestedEnumAdjudicationTypeFilter>;
    equals?: InputMaybe<AdjudicationType>;
    in?: InputMaybe<Array<AdjudicationType>>;
    not?: InputMaybe<NestedEnumAdjudicationTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjudicationType>>;
};

export type NestedEnumAdjustmentAckActionEnumNullableFilter = {
    equals?: InputMaybe<AdjustmentAckActionEnum>;
    in?: InputMaybe<Array<AdjustmentAckActionEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAckActionEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjustmentAckActionEnum>>;
};

export type NestedEnumAdjustmentAckActionEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjustmentAckActionEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjustmentAckActionEnumNullableFilter>;
    equals?: InputMaybe<AdjustmentAckActionEnum>;
    in?: InputMaybe<Array<AdjustmentAckActionEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAckActionEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjustmentAckActionEnum>>;
};

export type NestedEnumAdjustmentAckRoleEnumNullableFilter = {
    equals?: InputMaybe<AdjustmentAckRoleEnum>;
    in?: InputMaybe<Array<AdjustmentAckRoleEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAckRoleEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjustmentAckRoleEnum>>;
};

export type NestedEnumAdjustmentAckRoleEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjustmentAckRoleEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjustmentAckRoleEnumNullableFilter>;
    equals?: InputMaybe<AdjustmentAckRoleEnum>;
    in?: InputMaybe<Array<AdjustmentAckRoleEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAckRoleEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjustmentAckRoleEnum>>;
};

export type NestedEnumAdjustmentAppliedStatusEnumNullableFilter = {
    equals?: InputMaybe<AdjustmentAppliedStatusEnum>;
    in?: InputMaybe<Array<AdjustmentAppliedStatusEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentAppliedStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjustmentAppliedStatusEnum>>;
};

export type NestedEnumAdjustmentAppliedStatusEnumNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumAdjustmentAppliedStatusEnumNullableFilter>;
        _min?: InputMaybe<NestedEnumAdjustmentAppliedStatusEnumNullableFilter>;
        equals?: InputMaybe<AdjustmentAppliedStatusEnum>;
        in?: InputMaybe<Array<AdjustmentAppliedStatusEnum>>;
        not?: InputMaybe<NestedEnumAdjustmentAppliedStatusEnumNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<AdjustmentAppliedStatusEnum>>;
    };

export type NestedEnumAdjustmentTypeEnumFilter = {
    equals?: InputMaybe<AdjustmentTypeEnum>;
    in?: InputMaybe<Array<AdjustmentTypeEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentTypeEnumFilter>;
    notIn?: InputMaybe<Array<AdjustmentTypeEnum>>;
};

export type NestedEnumAdjustmentTypeEnumNullableFilter = {
    equals?: InputMaybe<AdjustmentTypeEnum>;
    in?: InputMaybe<Array<AdjustmentTypeEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<AdjustmentTypeEnum>>;
};

export type NestedEnumAdjustmentTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAdjustmentTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumAdjustmentTypeEnumNullableFilter>;
    equals?: InputMaybe<AdjustmentTypeEnum>;
    in?: InputMaybe<Array<AdjustmentTypeEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjustmentTypeEnum>>;
};

export type NestedEnumAdjustmentTypeEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumAdjustmentTypeEnumFilter>;
    _min?: InputMaybe<NestedEnumAdjustmentTypeEnumFilter>;
    equals?: InputMaybe<AdjustmentTypeEnum>;
    in?: InputMaybe<Array<AdjustmentTypeEnum>>;
    not?: InputMaybe<NestedEnumAdjustmentTypeEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdjustmentTypeEnum>>;
};

export type NestedEnumAdminActionFilter = {
    equals?: InputMaybe<AdminAction>;
    in?: InputMaybe<Array<AdminAction>>;
    not?: InputMaybe<NestedEnumAdminActionFilter>;
    notIn?: InputMaybe<Array<AdminAction>>;
};

export type NestedEnumAdminActionWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumAdminActionFilter>;
    _min?: InputMaybe<NestedEnumAdminActionFilter>;
    equals?: InputMaybe<AdminAction>;
    in?: InputMaybe<Array<AdminAction>>;
    not?: InputMaybe<NestedEnumAdminActionWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AdminAction>>;
};

export type NestedEnumAmountTypeNullableFilter = {
    equals?: InputMaybe<AmountType>;
    in?: InputMaybe<Array<AmountType>>;
    not?: InputMaybe<NestedEnumAmountTypeNullableFilter>;
    notIn?: InputMaybe<Array<AmountType>>;
};

export type NestedEnumAmountTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumAmountTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumAmountTypeNullableFilter>;
    equals?: InputMaybe<AmountType>;
    in?: InputMaybe<Array<AmountType>>;
    not?: InputMaybe<NestedEnumAmountTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AmountType>>;
};

export type NestedEnumAppointmentStatusEnumFilter = {
    equals?: InputMaybe<AppointmentStatusEnum>;
    in?: InputMaybe<Array<AppointmentStatusEnum>>;
    not?: InputMaybe<NestedEnumAppointmentStatusEnumFilter>;
    notIn?: InputMaybe<Array<AppointmentStatusEnum>>;
};

export type NestedEnumAppointmentStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumAppointmentStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumAppointmentStatusEnumFilter>;
    equals?: InputMaybe<AppointmentStatusEnum>;
    in?: InputMaybe<Array<AppointmentStatusEnum>>;
    not?: InputMaybe<NestedEnumAppointmentStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<AppointmentStatusEnum>>;
};

export type NestedEnumArtClaimStatusEnumFilter = {
    equals?: InputMaybe<ArtClaimStatusEnum>;
    in?: InputMaybe<Array<ArtClaimStatusEnum>>;
    not?: InputMaybe<NestedEnumArtClaimStatusEnumFilter>;
    notIn?: InputMaybe<Array<ArtClaimStatusEnum>>;
};

export type NestedEnumArtClaimStatusEnumNullableFilter = {
    equals?: InputMaybe<ArtClaimStatusEnum>;
    in?: InputMaybe<Array<ArtClaimStatusEnum>>;
    not?: InputMaybe<NestedEnumArtClaimStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<ArtClaimStatusEnum>>;
};

export type NestedEnumArtClaimStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumArtClaimStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumArtClaimStatusEnumNullableFilter>;
    equals?: InputMaybe<ArtClaimStatusEnum>;
    in?: InputMaybe<Array<ArtClaimStatusEnum>>;
    not?: InputMaybe<NestedEnumArtClaimStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ArtClaimStatusEnum>>;
};

export type NestedEnumArtClaimStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumArtClaimStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumArtClaimStatusEnumFilter>;
    equals?: InputMaybe<ArtClaimStatusEnum>;
    in?: InputMaybe<Array<ArtClaimStatusEnum>>;
    not?: InputMaybe<NestedEnumArtClaimStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ArtClaimStatusEnum>>;
};

export type NestedEnumBillReasonFilter = {
    equals?: InputMaybe<BillReason>;
    in?: InputMaybe<Array<BillReason>>;
    not?: InputMaybe<NestedEnumBillReasonFilter>;
    notIn?: InputMaybe<Array<BillReason>>;
};

export type NestedEnumBillReasonWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumBillReasonFilter>;
    _min?: InputMaybe<NestedEnumBillReasonFilter>;
    equals?: InputMaybe<BillReason>;
    in?: InputMaybe<Array<BillReason>>;
    not?: InputMaybe<NestedEnumBillReasonWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BillReason>>;
};

export type NestedEnumBillStatusFilter = {
    equals?: InputMaybe<BillStatus>;
    in?: InputMaybe<Array<BillStatus>>;
    not?: InputMaybe<NestedEnumBillStatusFilter>;
    notIn?: InputMaybe<Array<BillStatus>>;
};

export type NestedEnumBillStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumBillStatusFilter>;
    _min?: InputMaybe<NestedEnumBillStatusFilter>;
    equals?: InputMaybe<BillStatus>;
    in?: InputMaybe<Array<BillStatus>>;
    not?: InputMaybe<NestedEnumBillStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BillStatus>>;
};

export type NestedEnumBillingTableDownloadStatusEnumFilter = {
    equals?: InputMaybe<BillingTableDownloadStatusEnum>;
    in?: InputMaybe<Array<BillingTableDownloadStatusEnum>>;
    not?: InputMaybe<NestedEnumBillingTableDownloadStatusEnumFilter>;
    notIn?: InputMaybe<Array<BillingTableDownloadStatusEnum>>;
};

export type NestedEnumBillingTableDownloadStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumBillingTableDownloadStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumBillingTableDownloadStatusEnumFilter>;
    equals?: InputMaybe<BillingTableDownloadStatusEnum>;
    in?: InputMaybe<Array<BillingTableDownloadStatusEnum>>;
    not?: InputMaybe<NestedEnumBillingTableDownloadStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BillingTableDownloadStatusEnum>>;
};

export type NestedEnumBoughtTreatmentKindNullableFilter = {
    equals?: InputMaybe<BoughtTreatmentKind>;
    in?: InputMaybe<Array<BoughtTreatmentKind>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentKindNullableFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentKind>>;
};

export type NestedEnumBoughtTreatmentKindNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumBoughtTreatmentKindNullableFilter>;
    _min?: InputMaybe<NestedEnumBoughtTreatmentKindNullableFilter>;
    equals?: InputMaybe<BoughtTreatmentKind>;
    in?: InputMaybe<Array<BoughtTreatmentKind>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentKindNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentKind>>;
};

export type NestedEnumBoughtTreatmentStatusEnumFilter = {
    equals?: InputMaybe<BoughtTreatmentStatusEnum>;
    in?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
};

export type NestedEnumBoughtTreatmentStatusEnumNullableFilter = {
    equals?: InputMaybe<BoughtTreatmentStatusEnum>;
    in?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
};

export type NestedEnumBoughtTreatmentStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumNullableFilter>;
    equals?: InputMaybe<BoughtTreatmentStatusEnum>;
    in?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
};

export type NestedEnumBoughtTreatmentStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumFilter>;
    equals?: InputMaybe<BoughtTreatmentStatusEnum>;
    in?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumBoughtTreatmentStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
};

export type NestedEnumCompletionTimingTypeFilter = {
    equals?: InputMaybe<CompletionTimingType>;
    in?: InputMaybe<Array<CompletionTimingType>>;
    not?: InputMaybe<NestedEnumCompletionTimingTypeFilter>;
    notIn?: InputMaybe<Array<CompletionTimingType>>;
};

export type NestedEnumCompletionTimingTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCompletionTimingTypeFilter>;
    _min?: InputMaybe<NestedEnumCompletionTimingTypeFilter>;
    equals?: InputMaybe<CompletionTimingType>;
    in?: InputMaybe<Array<CompletionTimingType>>;
    not?: InputMaybe<NestedEnumCompletionTimingTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CompletionTimingType>>;
};

export type NestedEnumConfigCommitStatusNullableFilter = {
    equals?: InputMaybe<ConfigCommitStatus>;
    in?: InputMaybe<Array<ConfigCommitStatus>>;
    not?: InputMaybe<NestedEnumConfigCommitStatusNullableFilter>;
    notIn?: InputMaybe<Array<ConfigCommitStatus>>;
};

export type NestedEnumConfigCommitStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumConfigCommitStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumConfigCommitStatusNullableFilter>;
    equals?: InputMaybe<ConfigCommitStatus>;
    in?: InputMaybe<Array<ConfigCommitStatus>>;
    not?: InputMaybe<NestedEnumConfigCommitStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ConfigCommitStatus>>;
};

export type NestedEnumCoverageSourceNullableFilter = {
    equals?: InputMaybe<CoverageSource>;
    in?: InputMaybe<Array<CoverageSource>>;
    not?: InputMaybe<NestedEnumCoverageSourceNullableFilter>;
    notIn?: InputMaybe<Array<CoverageSource>>;
};

export type NestedEnumCoverageSourceNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumCoverageSourceNullableFilter>;
    _min?: InputMaybe<NestedEnumCoverageSourceNullableFilter>;
    equals?: InputMaybe<CoverageSource>;
    in?: InputMaybe<Array<CoverageSource>>;
    not?: InputMaybe<NestedEnumCoverageSourceNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CoverageSource>>;
};

export type NestedEnumCandidateTreatmentPricingStatusEnumFilter = {
    equals?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
    in?: InputMaybe<Array<CandidateTreatmentPricingStatusEnum>>;
    not?: InputMaybe<NestedEnumCandidateTreatmentPricingStatusEnumFilter>;
    notIn?: InputMaybe<Array<CandidateTreatmentPricingStatusEnum>>;
};

export type NestedEnumCandidateTreatmentPricingStatusEnumWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntFilter>;
        _max?: InputMaybe<NestedEnumCandidateTreatmentPricingStatusEnumFilter>;
        _min?: InputMaybe<NestedEnumCandidateTreatmentPricingStatusEnumFilter>;
        equals?: InputMaybe<CandidateTreatmentPricingStatusEnum>;
        in?: InputMaybe<Array<CandidateTreatmentPricingStatusEnum>>;
        not?: InputMaybe<NestedEnumCandidateTreatmentPricingStatusEnumWithAggregatesFilter>;
        notIn?: InputMaybe<Array<CandidateTreatmentPricingStatusEnum>>;
    };

export type NestedEnumCandidateTreatmentStatusEnumFilter = {
    equals?: InputMaybe<CandidateTreatmentStatusEnum>;
    in?: InputMaybe<Array<CandidateTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumCandidateTreatmentStatusEnumFilter>;
    notIn?: InputMaybe<Array<CandidateTreatmentStatusEnum>>;
};

export type NestedEnumCandidateTreatmentStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCandidateTreatmentStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumCandidateTreatmentStatusEnumFilter>;
    equals?: InputMaybe<CandidateTreatmentStatusEnum>;
    in?: InputMaybe<Array<CandidateTreatmentStatusEnum>>;
    not?: InputMaybe<NestedEnumCandidateTreatmentStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CandidateTreatmentStatusEnum>>;
};

export type NestedEnumCardAuthorizationStatusFilter = {
    equals?: InputMaybe<CardAuthorizationStatus>;
    in?: InputMaybe<Array<CardAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumCardAuthorizationStatusFilter>;
    notIn?: InputMaybe<Array<CardAuthorizationStatus>>;
};

export type NestedEnumCardAuthorizationStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCardAuthorizationStatusFilter>;
    _min?: InputMaybe<NestedEnumCardAuthorizationStatusFilter>;
    equals?: InputMaybe<CardAuthorizationStatus>;
    in?: InputMaybe<Array<CardAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumCardAuthorizationStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CardAuthorizationStatus>>;
};

export type NestedEnumChargeReattributionAndPartialPaymentLogTypeFilter = {
    equals?: InputMaybe<ChargeReattributionAndPartialPaymentLogType>;
    in?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogType>>;
    not?: InputMaybe<NestedEnumChargeReattributionAndPartialPaymentLogTypeFilter>;
    notIn?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogType>>;
};

export type NestedEnumChargeReattributionAndPartialPaymentLogTypeWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntFilter>;
        _max?: InputMaybe<NestedEnumChargeReattributionAndPartialPaymentLogTypeFilter>;
        _min?: InputMaybe<NestedEnumChargeReattributionAndPartialPaymentLogTypeFilter>;
        equals?: InputMaybe<ChargeReattributionAndPartialPaymentLogType>;
        in?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogType>>;
        not?: InputMaybe<NestedEnumChargeReattributionAndPartialPaymentLogTypeWithAggregatesFilter>;
        notIn?: InputMaybe<Array<ChargeReattributionAndPartialPaymentLogType>>;
    };

export type NestedEnumClaimReturnStatusEnumNullableFilter = {
    equals?: InputMaybe<ClaimReturnStatusEnum>;
    in?: InputMaybe<Array<ClaimReturnStatusEnum>>;
    not?: InputMaybe<NestedEnumClaimReturnStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<ClaimReturnStatusEnum>>;
};

export type NestedEnumClaimReturnStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumClaimReturnStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumClaimReturnStatusEnumNullableFilter>;
    equals?: InputMaybe<ClaimReturnStatusEnum>;
    in?: InputMaybe<Array<ClaimReturnStatusEnum>>;
    not?: InputMaybe<NestedEnumClaimReturnStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ClaimReturnStatusEnum>>;
};

export type NestedEnumConsumerAccountStatusFilter = {
    equals?: InputMaybe<ConsumerAccountStatus>;
    in?: InputMaybe<Array<ConsumerAccountStatus>>;
    not?: InputMaybe<NestedEnumConsumerAccountStatusFilter>;
    notIn?: InputMaybe<Array<ConsumerAccountStatus>>;
};

export type NestedEnumConsumerAccountStatusNullableFilter = {
    equals?: InputMaybe<ConsumerAccountStatus>;
    in?: InputMaybe<Array<ConsumerAccountStatus>>;
    not?: InputMaybe<NestedEnumConsumerAccountStatusNullableFilter>;
    notIn?: InputMaybe<Array<ConsumerAccountStatus>>;
};

export type NestedEnumConsumerAccountStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumConsumerAccountStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumConsumerAccountStatusNullableFilter>;
    equals?: InputMaybe<ConsumerAccountStatus>;
    in?: InputMaybe<Array<ConsumerAccountStatus>>;
    not?: InputMaybe<NestedEnumConsumerAccountStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ConsumerAccountStatus>>;
};

export type NestedEnumConsumerAccountStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumConsumerAccountStatusFilter>;
    _min?: InputMaybe<NestedEnumConsumerAccountStatusFilter>;
    equals?: InputMaybe<ConsumerAccountStatus>;
    in?: InputMaybe<Array<ConsumerAccountStatus>>;
    not?: InputMaybe<NestedEnumConsumerAccountStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ConsumerAccountStatus>>;
};

export type NestedEnumContractAccountStatusNullableFilter = {
    equals?: InputMaybe<ContractAccountStatus>;
    in?: InputMaybe<Array<ContractAccountStatus>>;
    not?: InputMaybe<NestedEnumContractAccountStatusNullableFilter>;
    notIn?: InputMaybe<Array<ContractAccountStatus>>;
};

export type NestedEnumContractAccountStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumContractAccountStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumContractAccountStatusNullableFilter>;
    equals?: InputMaybe<ContractAccountStatus>;
    in?: InputMaybe<Array<ContractAccountStatus>>;
    not?: InputMaybe<NestedEnumContractAccountStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ContractAccountStatus>>;
};

export type NestedEnumContractStatusNullableFilter = {
    equals?: InputMaybe<ContractStatus>;
    in?: InputMaybe<Array<ContractStatus>>;
    not?: InputMaybe<NestedEnumContractStatusNullableFilter>;
    notIn?: InputMaybe<Array<ContractStatus>>;
};

export type NestedEnumContractStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumContractStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumContractStatusNullableFilter>;
    equals?: InputMaybe<ContractStatus>;
    in?: InputMaybe<Array<ContractStatus>>;
    not?: InputMaybe<NestedEnumContractStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ContractStatus>>;
};

export type NestedEnumContractTypeFilter = {
    equals?: InputMaybe<ContractType>;
    in?: InputMaybe<Array<ContractType>>;
    not?: InputMaybe<NestedEnumContractTypeFilter>;
    notIn?: InputMaybe<Array<ContractType>>;
};

export type NestedEnumContractTypeNullableFilter = {
    equals?: InputMaybe<ContractType>;
    in?: InputMaybe<Array<ContractType>>;
    not?: InputMaybe<NestedEnumContractTypeNullableFilter>;
    notIn?: InputMaybe<Array<ContractType>>;
};

export type NestedEnumContractTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumContractTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumContractTypeNullableFilter>;
    equals?: InputMaybe<ContractType>;
    in?: InputMaybe<Array<ContractType>>;
    not?: InputMaybe<NestedEnumContractTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ContractType>>;
};

export type NestedEnumContractTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumContractTypeFilter>;
    _min?: InputMaybe<NestedEnumContractTypeFilter>;
    equals?: InputMaybe<ContractType>;
    in?: InputMaybe<Array<ContractType>>;
    not?: InputMaybe<NestedEnumContractTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ContractType>>;
};

export type NestedEnumCptRelationTypeFilter = {
    equals?: InputMaybe<CptRelationType>;
    in?: InputMaybe<Array<CptRelationType>>;
    not?: InputMaybe<NestedEnumCptRelationTypeFilter>;
    notIn?: InputMaybe<Array<CptRelationType>>;
};

export type NestedEnumCptRelationTypeNullableFilter = {
    equals?: InputMaybe<CptRelationType>;
    in?: InputMaybe<Array<CptRelationType>>;
    not?: InputMaybe<NestedEnumCptRelationTypeNullableFilter>;
    notIn?: InputMaybe<Array<CptRelationType>>;
};

export type NestedEnumCptRelationTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumCptRelationTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumCptRelationTypeNullableFilter>;
    equals?: InputMaybe<CptRelationType>;
    in?: InputMaybe<Array<CptRelationType>>;
    not?: InputMaybe<NestedEnumCptRelationTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CptRelationType>>;
};

export type NestedEnumCptRelationTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCptRelationTypeFilter>;
    _min?: InputMaybe<NestedEnumCptRelationTypeFilter>;
    equals?: InputMaybe<CptRelationType>;
    in?: InputMaybe<Array<CptRelationType>>;
    not?: InputMaybe<NestedEnumCptRelationTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CptRelationType>>;
};

export type NestedEnumCustomFieldTypeEnumFilter = {
    equals?: InputMaybe<CustomFieldTypeEnum>;
    in?: InputMaybe<Array<CustomFieldTypeEnum>>;
    not?: InputMaybe<NestedEnumCustomFieldTypeEnumFilter>;
    notIn?: InputMaybe<Array<CustomFieldTypeEnum>>;
};

export type NestedEnumCustomFieldTypeEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumCustomFieldTypeEnumFilter>;
    _min?: InputMaybe<NestedEnumCustomFieldTypeEnumFilter>;
    equals?: InputMaybe<CustomFieldTypeEnum>;
    in?: InputMaybe<Array<CustomFieldTypeEnum>>;
    not?: InputMaybe<NestedEnumCustomFieldTypeEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<CustomFieldTypeEnum>>;
};

export type NestedEnumDayOfWeekFilter = {
    equals?: InputMaybe<DayOfWeek>;
    in?: InputMaybe<Array<DayOfWeek>>;
    not?: InputMaybe<NestedEnumDayOfWeekFilter>;
    notIn?: InputMaybe<Array<DayOfWeek>>;
};

export type NestedEnumDayOfWeekWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumDayOfWeekFilter>;
    _min?: InputMaybe<NestedEnumDayOfWeekFilter>;
    equals?: InputMaybe<DayOfWeek>;
    in?: InputMaybe<Array<DayOfWeek>>;
    not?: InputMaybe<NestedEnumDayOfWeekWithAggregatesFilter>;
    notIn?: InputMaybe<Array<DayOfWeek>>;
};

export type NestedEnumDiscountTypeFilter = {
    equals?: InputMaybe<DiscountType>;
    in?: InputMaybe<Array<DiscountType>>;
    not?: InputMaybe<NestedEnumDiscountTypeFilter>;
    notIn?: InputMaybe<Array<DiscountType>>;
};

export type NestedEnumDiscountTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumDiscountTypeFilter>;
    _min?: InputMaybe<NestedEnumDiscountTypeFilter>;
    equals?: InputMaybe<DiscountType>;
    in?: InputMaybe<Array<DiscountType>>;
    not?: InputMaybe<NestedEnumDiscountTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<DiscountType>>;
};

export type NestedEnumDayOfWeekEnumNullableFilter = {
    equals?: InputMaybe<DayOfWeekEnum>;
    in?: InputMaybe<Array<DayOfWeekEnum>>;
    not?: InputMaybe<NestedEnumDayOfWeekEnumNullableFilter>;
    notIn?: InputMaybe<Array<DayOfWeekEnum>>;
};

export type NestedEnumDayOfWeekEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumDayOfWeekEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumDayOfWeekEnumNullableFilter>;
    equals?: InputMaybe<DayOfWeekEnum>;
    in?: InputMaybe<Array<DayOfWeekEnum>>;
    not?: InputMaybe<NestedEnumDayOfWeekEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<DayOfWeekEnum>>;
};

export type NestedEnumEhrTypeFilter = {
    equals?: InputMaybe<EhrType>;
    in?: InputMaybe<Array<EhrType>>;
    not?: InputMaybe<NestedEnumEhrTypeFilter>;
    notIn?: InputMaybe<Array<EhrType>>;
};

export type NestedEnumEhrTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrTypeFilter>;
    _min?: InputMaybe<NestedEnumEhrTypeFilter>;
    equals?: InputMaybe<EhrType>;
    in?: InputMaybe<Array<EhrType>>;
    not?: InputMaybe<NestedEnumEhrTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrType>>;
};

export type NestedEnumEhrPaymentDescriptorStatusEnumFilter = {
    equals?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
    in?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumFilter>;
    notIn?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
};

export type NestedEnumEhrPaymentDescriptorStatusEnumNullableFilter = {
    equals?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
    in?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
};

export type NestedEnumEhrPaymentDescriptorStatusEnumNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumNullableFilter>;
        _min?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumNullableFilter>;
        equals?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
        in?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
        not?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
    };

export type NestedEnumEhrPaymentDescriptorStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumFilter>;
    equals?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
    in?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentDescriptorStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPaymentDescriptorStatusEnum>>;
};

export type NestedEnumEhrPaymentLockTypeEnumFilter = {
    equals?: InputMaybe<EhrPaymentLockTypeEnum>;
    in?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumFilter>;
    notIn?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
};

export type NestedEnumEhrPaymentLockTypeEnumNullableFilter = {
    equals?: InputMaybe<EhrPaymentLockTypeEnum>;
    in?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
};

export type NestedEnumEhrPaymentLockTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumNullableFilter>;
    equals?: InputMaybe<EhrPaymentLockTypeEnum>;
    in?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
};

export type NestedEnumEhrPaymentLockTypeEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumFilter>;
    _min?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumFilter>;
    equals?: InputMaybe<EhrPaymentLockTypeEnum>;
    in?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPaymentLockTypeEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPaymentLockTypeEnum>>;
};

export type NestedEnumEhrPostDetailActionFilter = {
    equals?: InputMaybe<EhrPostDetailAction>;
    in?: InputMaybe<Array<EhrPostDetailAction>>;
    not?: InputMaybe<NestedEnumEhrPostDetailActionFilter>;
    notIn?: InputMaybe<Array<EhrPostDetailAction>>;
};

export type NestedEnumEhrPostDetailActionWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrPostDetailActionFilter>;
    _min?: InputMaybe<NestedEnumEhrPostDetailActionFilter>;
    equals?: InputMaybe<EhrPostDetailAction>;
    in?: InputMaybe<Array<EhrPostDetailAction>>;
    not?: InputMaybe<NestedEnumEhrPostDetailActionWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPostDetailAction>>;
};

export type NestedEnumEhrPostIdentifierTypeEnumNullableFilter = {
    equals?: InputMaybe<EhrPostIdentifierTypeEnum>;
    in?: InputMaybe<Array<EhrPostIdentifierTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPostIdentifierTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrPostIdentifierTypeEnum>>;
};

export type NestedEnumEhrPostIdentifierTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrPostIdentifierTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrPostIdentifierTypeEnumNullableFilter>;
    equals?: InputMaybe<EhrPostIdentifierTypeEnum>;
    in?: InputMaybe<Array<EhrPostIdentifierTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrPostIdentifierTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPostIdentifierTypeEnum>>;
};

export type NestedEnumEhrPostLedgerSourceEnumNullableFilter = {
    equals?: InputMaybe<EhrPostLedgerSourceEnum>;
    in?: InputMaybe<Array<EhrPostLedgerSourceEnum>>;
    not?: InputMaybe<NestedEnumEhrPostLedgerSourceEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrPostLedgerSourceEnum>>;
};

export type NestedEnumEhrPostLedgerSourceEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrPostLedgerSourceEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrPostLedgerSourceEnumNullableFilter>;
    equals?: InputMaybe<EhrPostLedgerSourceEnum>;
    in?: InputMaybe<Array<EhrPostLedgerSourceEnum>>;
    not?: InputMaybe<NestedEnumEhrPostLedgerSourceEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPostLedgerSourceEnum>>;
};

export type NestedEnumEhrPostStatusEnumFilter = {
    equals?: InputMaybe<EhrPostStatusEnum>;
    in?: InputMaybe<Array<EhrPostStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPostStatusEnumFilter>;
    notIn?: InputMaybe<Array<EhrPostStatusEnum>>;
};

export type NestedEnumEhrPostStatusEnumNullableFilter = {
    equals?: InputMaybe<EhrPostStatusEnum>;
    in?: InputMaybe<Array<EhrPostStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPostStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrPostStatusEnum>>;
};

export type NestedEnumEhrPostStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrPostStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrPostStatusEnumNullableFilter>;
    equals?: InputMaybe<EhrPostStatusEnum>;
    in?: InputMaybe<Array<EhrPostStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPostStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPostStatusEnum>>;
};

export type NestedEnumEhrPostStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrPostStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumEhrPostStatusEnumFilter>;
    equals?: InputMaybe<EhrPostStatusEnum>;
    in?: InputMaybe<Array<EhrPostStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrPostStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrPostStatusEnum>>;
};

export type NestedEnumEhrSlotStatusEnumFilter = {
    equals?: InputMaybe<EhrSlotStatusEnum>;
    in?: InputMaybe<Array<EhrSlotStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrSlotStatusEnumFilter>;
    notIn?: InputMaybe<Array<EhrSlotStatusEnum>>;
};

export type NestedEnumEhrSlotStatusEnumNullableFilter = {
    equals?: InputMaybe<EhrSlotStatusEnum>;
    in?: InputMaybe<Array<EhrSlotStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrSlotStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrSlotStatusEnum>>;
};

export type NestedEnumEhrSlotStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrSlotStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrSlotStatusEnumNullableFilter>;
    equals?: InputMaybe<EhrSlotStatusEnum>;
    in?: InputMaybe<Array<EhrSlotStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrSlotStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrSlotStatusEnum>>;
};

export type NestedEnumEhrSlotStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEhrSlotStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumEhrSlotStatusEnumFilter>;
    equals?: InputMaybe<EhrSlotStatusEnum>;
    in?: InputMaybe<Array<EhrSlotStatusEnum>>;
    not?: InputMaybe<NestedEnumEhrSlotStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrSlotStatusEnum>>;
};

export type NestedEnumEhrTypeEnumNullableFilter = {
    equals?: InputMaybe<EhrTypeEnum>;
    in?: InputMaybe<Array<EhrTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<EhrTypeEnum>>;
};

export type NestedEnumEhrTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEhrTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEhrTypeEnumNullableFilter>;
    equals?: InputMaybe<EhrTypeEnum>;
    in?: InputMaybe<Array<EhrTypeEnum>>;
    not?: InputMaybe<NestedEnumEhrTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EhrTypeEnum>>;
};

export type NestedEnumEmergencyContactRelationshipNullableFilter = {
    equals?: InputMaybe<EmergencyContactRelationship>;
    in?: InputMaybe<Array<EmergencyContactRelationship>>;
    not?: InputMaybe<NestedEnumEmergencyContactRelationshipNullableFilter>;
    notIn?: InputMaybe<Array<EmergencyContactRelationship>>;
};

export type NestedEnumEmergencyContactRelationshipNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumEmergencyContactRelationshipNullableFilter>;
        _min?: InputMaybe<NestedEnumEmergencyContactRelationshipNullableFilter>;
        equals?: InputMaybe<EmergencyContactRelationship>;
        in?: InputMaybe<Array<EmergencyContactRelationship>>;
        not?: InputMaybe<NestedEnumEmergencyContactRelationshipNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<EmergencyContactRelationship>>;
    };

export type NestedEnumEmploymentStatusNullableFilter = {
    equals?: InputMaybe<EmploymentStatus>;
    in?: InputMaybe<Array<EmploymentStatus>>;
    not?: InputMaybe<NestedEnumEmploymentStatusNullableFilter>;
    notIn?: InputMaybe<Array<EmploymentStatus>>;
};

export type NestedEnumEmploymentStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEmploymentStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumEmploymentStatusNullableFilter>;
    equals?: InputMaybe<EmploymentStatus>;
    in?: InputMaybe<Array<EmploymentStatus>>;
    not?: InputMaybe<NestedEnumEmploymentStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EmploymentStatus>>;
};

export type NestedEnumEncounterSourceEnumFilter = {
    equals?: InputMaybe<EncounterSourceEnum>;
    in?: InputMaybe<Array<EncounterSourceEnum>>;
    not?: InputMaybe<NestedEnumEncounterSourceEnumFilter>;
    notIn?: InputMaybe<Array<EncounterSourceEnum>>;
};

export type NestedEnumEncounterSourceEnumNullableFilter = {
    equals?: InputMaybe<EncounterSourceEnum>;
    in?: InputMaybe<Array<EncounterSourceEnum>>;
    not?: InputMaybe<NestedEnumEncounterSourceEnumNullableFilter>;
    notIn?: InputMaybe<Array<EncounterSourceEnum>>;
};

export type NestedEnumEncounterSourceEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEncounterSourceEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumEncounterSourceEnumNullableFilter>;
    equals?: InputMaybe<EncounterSourceEnum>;
    in?: InputMaybe<Array<EncounterSourceEnum>>;
    not?: InputMaybe<NestedEnumEncounterSourceEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EncounterSourceEnum>>;
};

export type NestedEnumEncounterSourceEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEncounterSourceEnumFilter>;
    _min?: InputMaybe<NestedEnumEncounterSourceEnumFilter>;
    equals?: InputMaybe<EncounterSourceEnum>;
    in?: InputMaybe<Array<EncounterSourceEnum>>;
    not?: InputMaybe<NestedEnumEncounterSourceEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EncounterSourceEnum>>;
};

export type NestedEnumEncounterStatusEnumFilter = {
    equals?: InputMaybe<EncounterStatusEnum>;
    in?: InputMaybe<Array<EncounterStatusEnum>>;
    not?: InputMaybe<NestedEnumEncounterStatusEnumFilter>;
    notIn?: InputMaybe<Array<EncounterStatusEnum>>;
};

export type NestedEnumEncounterStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumEncounterStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumEncounterStatusEnumFilter>;
    equals?: InputMaybe<EncounterStatusEnum>;
    in?: InputMaybe<Array<EncounterStatusEnum>>;
    not?: InputMaybe<NestedEnumEncounterStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<EncounterStatusEnum>>;
};

export type NestedEnumEthnicityNullableFilter = {
    equals?: InputMaybe<Ethnicity>;
    in?: InputMaybe<Array<Ethnicity>>;
    not?: InputMaybe<NestedEnumEthnicityNullableFilter>;
    notIn?: InputMaybe<Array<Ethnicity>>;
};

export type NestedEnumEthnicityNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumEthnicityNullableFilter>;
    _min?: InputMaybe<NestedEnumEthnicityNullableFilter>;
    equals?: InputMaybe<Ethnicity>;
    in?: InputMaybe<Array<Ethnicity>>;
    not?: InputMaybe<NestedEnumEthnicityNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Ethnicity>>;
};

export type NestedEnumExperityEncounterStatusEnumFilter = {
    equals?: InputMaybe<ExperityEncounterStatusEnum>;
    in?: InputMaybe<Array<ExperityEncounterStatusEnum>>;
    not?: InputMaybe<NestedEnumExperityEncounterStatusEnumFilter>;
    notIn?: InputMaybe<Array<ExperityEncounterStatusEnum>>;
};

export type NestedEnumExperityEncounterStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumExperityEncounterStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumExperityEncounterStatusEnumFilter>;
    equals?: InputMaybe<ExperityEncounterStatusEnum>;
    in?: InputMaybe<Array<ExperityEncounterStatusEnum>>;
    not?: InputMaybe<NestedEnumExperityEncounterStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ExperityEncounterStatusEnum>>;
};

export type NestedEnumFeeTypeFilter = {
    equals?: InputMaybe<FeeType>;
    in?: InputMaybe<Array<FeeType>>;
    not?: InputMaybe<NestedEnumFeeTypeFilter>;
    notIn?: InputMaybe<Array<FeeType>>;
};

export type NestedEnumFeeTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumFeeTypeFilter>;
    _min?: InputMaybe<NestedEnumFeeTypeFilter>;
    equals?: InputMaybe<FeeType>;
    in?: InputMaybe<Array<FeeType>>;
    not?: InputMaybe<NestedEnumFeeTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<FeeType>>;
};

export type NestedEnumFeeUnitNullableFilter = {
    equals?: InputMaybe<FeeUnit>;
    in?: InputMaybe<Array<FeeUnit>>;
    not?: InputMaybe<NestedEnumFeeUnitNullableFilter>;
    notIn?: InputMaybe<Array<FeeUnit>>;
};

export type NestedEnumFeeUnitNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumFeeUnitNullableFilter>;
    _min?: InputMaybe<NestedEnumFeeUnitNullableFilter>;
    equals?: InputMaybe<FeeUnit>;
    in?: InputMaybe<Array<FeeUnit>>;
    not?: InputMaybe<NestedEnumFeeUnitNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<FeeUnit>>;
};

export type NestedEnumFeesAndPayoutsProcessingStatusEnumNullableFilter = {
    equals?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    in?: InputMaybe<Array<FeesAndPayoutsProcessingStatusEnum>>;
    not?: InputMaybe<NestedEnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<FeesAndPayoutsProcessingStatusEnum>>;
};

export type NestedEnumFeesAndPayoutsProcessingStatusEnumNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
        _min?: InputMaybe<NestedEnumFeesAndPayoutsProcessingStatusEnumNullableFilter>;
        equals?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
        in?: InputMaybe<Array<FeesAndPayoutsProcessingStatusEnum>>;
        not?: InputMaybe<NestedEnumFeesAndPayoutsProcessingStatusEnumNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<FeesAndPayoutsProcessingStatusEnum>>;
    };

export type NestedEnumIntakeQuestionTypeFilter = {
    equals?: InputMaybe<IntakeQuestionType>;
    in?: InputMaybe<Array<IntakeQuestionType>>;
    not?: InputMaybe<NestedEnumIntakeQuestionTypeFilter>;
    notIn?: InputMaybe<Array<IntakeQuestionType>>;
};

export type NestedEnumIntakeQuestionTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumIntakeQuestionTypeFilter>;
    _min?: InputMaybe<NestedEnumIntakeQuestionTypeFilter>;
    equals?: InputMaybe<IntakeQuestionType>;
    in?: InputMaybe<Array<IntakeQuestionType>>;
    not?: InputMaybe<NestedEnumIntakeQuestionTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<IntakeQuestionType>>;
};

export type NestedEnumInboundRequestLogStatusFilter = {
    equals?: InputMaybe<InboundRequestLogStatus>;
    in?: InputMaybe<Array<InboundRequestLogStatus>>;
    not?: InputMaybe<NestedEnumInboundRequestLogStatusFilter>;
    notIn?: InputMaybe<Array<InboundRequestLogStatus>>;
};

export type NestedEnumInboundRequestLogStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumInboundRequestLogStatusFilter>;
    _min?: InputMaybe<NestedEnumInboundRequestLogStatusFilter>;
    equals?: InputMaybe<InboundRequestLogStatus>;
    in?: InputMaybe<Array<InboundRequestLogStatus>>;
    not?: InputMaybe<NestedEnumInboundRequestLogStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InboundRequestLogStatus>>;
};

export type NestedEnumInsuranceAccountStatusNullableFilter = {
    equals?: InputMaybe<InsuranceAccountStatus>;
    in?: InputMaybe<Array<InsuranceAccountStatus>>;
    not?: InputMaybe<NestedEnumInsuranceAccountStatusNullableFilter>;
    notIn?: InputMaybe<Array<InsuranceAccountStatus>>;
};

export type NestedEnumInsuranceAccountStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumInsuranceAccountStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumInsuranceAccountStatusNullableFilter>;
    equals?: InputMaybe<InsuranceAccountStatus>;
    in?: InputMaybe<Array<InsuranceAccountStatus>>;
    not?: InputMaybe<NestedEnumInsuranceAccountStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InsuranceAccountStatus>>;
};

export type NestedEnumInsuranceMetadataStatusEnumFilter = {
    equals?: InputMaybe<InsuranceMetadataStatusEnum>;
    in?: InputMaybe<Array<InsuranceMetadataStatusEnum>>;
    not?: InputMaybe<NestedEnumInsuranceMetadataStatusEnumFilter>;
    notIn?: InputMaybe<Array<InsuranceMetadataStatusEnum>>;
};

export type NestedEnumInsuranceMetadataStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumInsuranceMetadataStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumInsuranceMetadataStatusEnumFilter>;
    equals?: InputMaybe<InsuranceMetadataStatusEnum>;
    in?: InputMaybe<Array<InsuranceMetadataStatusEnum>>;
    not?: InputMaybe<NestedEnumInsuranceMetadataStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InsuranceMetadataStatusEnum>>;
};

export type NestedEnumInvoiceStatusFilter = {
    equals?: InputMaybe<InvoiceStatus>;
    in?: InputMaybe<Array<InvoiceStatus>>;
    not?: InputMaybe<NestedEnumInvoiceStatusFilter>;
    notIn?: InputMaybe<Array<InvoiceStatus>>;
};

export type NestedEnumInvoiceStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumInvoiceStatusFilter>;
    _min?: InputMaybe<NestedEnumInvoiceStatusFilter>;
    equals?: InputMaybe<InvoiceStatus>;
    in?: InputMaybe<Array<InvoiceStatus>>;
    not?: InputMaybe<NestedEnumInvoiceStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InvoiceStatus>>;
};

export type NestedEnumKioskHrtTypeNullableFilter = {
    equals?: InputMaybe<KioskHrtType>;
    in?: InputMaybe<Array<KioskHrtType>>;
    not?: InputMaybe<NestedEnumKioskHrtTypeNullableFilter>;
    notIn?: InputMaybe<Array<KioskHrtType>>;
};

export type NestedEnumKioskHrtTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumKioskHrtTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumKioskHrtTypeNullableFilter>;
    equals?: InputMaybe<KioskHrtType>;
    in?: InputMaybe<Array<KioskHrtType>>;
    not?: InputMaybe<NestedEnumKioskHrtTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<KioskHrtType>>;
};

export type NestedEnumLinkTypeNullableFilter = {
    equals?: InputMaybe<LinkType>;
    in?: InputMaybe<Array<LinkType>>;
    not?: InputMaybe<NestedEnumLinkTypeNullableFilter>;
    notIn?: InputMaybe<Array<LinkType>>;
};

export type NestedEnumLinkTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumLinkTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumLinkTypeNullableFilter>;
    equals?: InputMaybe<LinkType>;
    in?: InputMaybe<Array<LinkType>>;
    not?: InputMaybe<NestedEnumLinkTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<LinkType>>;
};

export type NestedEnumLanguageCodeFilter = {
    equals?: InputMaybe<LanguageCode>;
    in?: InputMaybe<Array<LanguageCode>>;
    not?: InputMaybe<NestedEnumLanguageCodeFilter>;
    notIn?: InputMaybe<Array<LanguageCode>>;
};

export type NestedEnumLanguageCodeNullableFilter = {
    equals?: InputMaybe<LanguageCode>;
    in?: InputMaybe<Array<LanguageCode>>;
    not?: InputMaybe<NestedEnumLanguageCodeNullableFilter>;
    notIn?: InputMaybe<Array<LanguageCode>>;
};

export type NestedEnumLanguageCodeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumLanguageCodeNullableFilter>;
    _min?: InputMaybe<NestedEnumLanguageCodeNullableFilter>;
    equals?: InputMaybe<LanguageCode>;
    in?: InputMaybe<Array<LanguageCode>>;
    not?: InputMaybe<NestedEnumLanguageCodeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<LanguageCode>>;
};

export type NestedEnumLanguageCodeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumLanguageCodeFilter>;
    _min?: InputMaybe<NestedEnumLanguageCodeFilter>;
    equals?: InputMaybe<LanguageCode>;
    in?: InputMaybe<Array<LanguageCode>>;
    not?: InputMaybe<NestedEnumLanguageCodeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<LanguageCode>>;
};

export type NestedEnumLiveTransferActionEnumNullableFilter = {
    equals?: InputMaybe<LiveTransferActionEnum>;
    in?: InputMaybe<Array<LiveTransferActionEnum>>;
    not?: InputMaybe<NestedEnumLiveTransferActionEnumNullableFilter>;
    notIn?: InputMaybe<Array<LiveTransferActionEnum>>;
};

export type NestedEnumLiveTransferActionEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumLiveTransferActionEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumLiveTransferActionEnumNullableFilter>;
    equals?: InputMaybe<LiveTransferActionEnum>;
    in?: InputMaybe<Array<LiveTransferActionEnum>>;
    not?: InputMaybe<NestedEnumLiveTransferActionEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<LiveTransferActionEnum>>;
};

export type NestedEnumLiveTransferStatusEnumNullableFilter = {
    equals?: InputMaybe<LiveTransferStatusEnum>;
    in?: InputMaybe<Array<LiveTransferStatusEnum>>;
    not?: InputMaybe<NestedEnumLiveTransferStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<LiveTransferStatusEnum>>;
};

export type NestedEnumLiveTransferStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumLiveTransferStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumLiveTransferStatusEnumNullableFilter>;
    equals?: InputMaybe<LiveTransferStatusEnum>;
    in?: InputMaybe<Array<LiveTransferStatusEnum>>;
    not?: InputMaybe<NestedEnumLiveTransferStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<LiveTransferStatusEnum>>;
};

export type NestedEnumMaritalStatusNullableFilter = {
    equals?: InputMaybe<MaritalStatus>;
    in?: InputMaybe<Array<MaritalStatus>>;
    not?: InputMaybe<NestedEnumMaritalStatusNullableFilter>;
    notIn?: InputMaybe<Array<MaritalStatus>>;
};

export type NestedEnumMaritalStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumMaritalStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumMaritalStatusNullableFilter>;
    equals?: InputMaybe<MaritalStatus>;
    in?: InputMaybe<Array<MaritalStatus>>;
    not?: InputMaybe<NestedEnumMaritalStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<MaritalStatus>>;
};

export type NestedEnumMcmsAdjudicationVersionNullableFilter = {
    equals?: InputMaybe<McmsAdjudicationVersion>;
    in?: InputMaybe<Array<McmsAdjudicationVersion>>;
    not?: InputMaybe<NestedEnumMcmsAdjudicationVersionNullableFilter>;
    notIn?: InputMaybe<Array<McmsAdjudicationVersion>>;
};

export type NestedEnumMcmsAdjudicationVersionNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumMcmsAdjudicationVersionNullableFilter>;
    _min?: InputMaybe<NestedEnumMcmsAdjudicationVersionNullableFilter>;
    equals?: InputMaybe<McmsAdjudicationVersion>;
    in?: InputMaybe<Array<McmsAdjudicationVersion>>;
    not?: InputMaybe<NestedEnumMcmsAdjudicationVersionNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<McmsAdjudicationVersion>>;
};

export type NestedEnumMcmsReversalActionFilter = {
    equals?: InputMaybe<McmsReversalAction>;
    in?: InputMaybe<Array<McmsReversalAction>>;
    not?: InputMaybe<NestedEnumMcmsReversalActionFilter>;
    notIn?: InputMaybe<Array<McmsReversalAction>>;
};

export type NestedEnumMcmsReversalActionNullableFilter = {
    equals?: InputMaybe<McmsReversalAction>;
    in?: InputMaybe<Array<McmsReversalAction>>;
    not?: InputMaybe<NestedEnumMcmsReversalActionNullableFilter>;
    notIn?: InputMaybe<Array<McmsReversalAction>>;
};

export type NestedEnumMcmsReversalActionNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumMcmsReversalActionNullableFilter>;
    _min?: InputMaybe<NestedEnumMcmsReversalActionNullableFilter>;
    equals?: InputMaybe<McmsReversalAction>;
    in?: InputMaybe<Array<McmsReversalAction>>;
    not?: InputMaybe<NestedEnumMcmsReversalActionNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<McmsReversalAction>>;
};

export type NestedEnumMcmsReversalActionWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumMcmsReversalActionFilter>;
    _min?: InputMaybe<NestedEnumMcmsReversalActionFilter>;
    equals?: InputMaybe<McmsReversalAction>;
    in?: InputMaybe<Array<McmsReversalAction>>;
    not?: InputMaybe<NestedEnumMcmsReversalActionWithAggregatesFilter>;
    notIn?: InputMaybe<Array<McmsReversalAction>>;
};

export type NestedEnumMessageNudgeStatusFilter = {
    equals?: InputMaybe<MessageNudgeStatus>;
    in?: InputMaybe<Array<MessageNudgeStatus>>;
    not?: InputMaybe<NestedEnumMessageNudgeStatusFilter>;
    notIn?: InputMaybe<Array<MessageNudgeStatus>>;
};

export type NestedEnumMessageNudgeStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumMessageNudgeStatusFilter>;
    _min?: InputMaybe<NestedEnumMessageNudgeStatusFilter>;
    equals?: InputMaybe<MessageNudgeStatus>;
    in?: InputMaybe<Array<MessageNudgeStatus>>;
    not?: InputMaybe<NestedEnumMessageNudgeStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<MessageNudgeStatus>>;
};

export type NestedEnumMessageStatusNullableFilter = {
    equals?: InputMaybe<MessageStatus>;
    in?: InputMaybe<Array<MessageStatus>>;
    not?: InputMaybe<NestedEnumMessageStatusNullableFilter>;
    notIn?: InputMaybe<Array<MessageStatus>>;
};

export type NestedEnumMessageStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumMessageStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumMessageStatusNullableFilter>;
    equals?: InputMaybe<MessageStatus>;
    in?: InputMaybe<Array<MessageStatus>>;
    not?: InputMaybe<NestedEnumMessageStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<MessageStatus>>;
};

export type NestedEnumMessagingRuleNameFilter = {
    equals?: InputMaybe<MessagingRuleName>;
    in?: InputMaybe<Array<MessagingRuleName>>;
    not?: InputMaybe<NestedEnumMessagingRuleNameFilter>;
    notIn?: InputMaybe<Array<MessagingRuleName>>;
};

export type NestedEnumMessagingRuleNameWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumMessagingRuleNameFilter>;
    _min?: InputMaybe<NestedEnumMessagingRuleNameFilter>;
    equals?: InputMaybe<MessagingRuleName>;
    in?: InputMaybe<Array<MessagingRuleName>>;
    not?: InputMaybe<NestedEnumMessagingRuleNameWithAggregatesFilter>;
    notIn?: InputMaybe<Array<MessagingRuleName>>;
};

export type NestedEnumMessagingRuleTypeFilter = {
    equals?: InputMaybe<MessagingRuleType>;
    in?: InputMaybe<Array<MessagingRuleType>>;
    not?: InputMaybe<NestedEnumMessagingRuleTypeFilter>;
    notIn?: InputMaybe<Array<MessagingRuleType>>;
};

export type NestedEnumMessagingRuleTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumMessagingRuleTypeFilter>;
    _min?: InputMaybe<NestedEnumMessagingRuleTypeFilter>;
    equals?: InputMaybe<MessagingRuleType>;
    in?: InputMaybe<Array<MessagingRuleType>>;
    not?: InputMaybe<NestedEnumMessagingRuleTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<MessagingRuleType>>;
};

export type NestedEnumNetworkTypeFilter = {
    equals?: InputMaybe<NetworkType>;
    in?: InputMaybe<Array<NetworkType>>;
    not?: InputMaybe<NestedEnumNetworkTypeFilter>;
    notIn?: InputMaybe<Array<NetworkType>>;
};

export type NestedEnumNetworkTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumNetworkTypeFilter>;
    _min?: InputMaybe<NestedEnumNetworkTypeFilter>;
    equals?: InputMaybe<NetworkType>;
    in?: InputMaybe<Array<NetworkType>>;
    not?: InputMaybe<NestedEnumNetworkTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<NetworkType>>;
};

export type NestedEnumNonCardRefundStatusFilter = {
    equals?: InputMaybe<NonCardRefundStatus>;
    in?: InputMaybe<Array<NonCardRefundStatus>>;
    not?: InputMaybe<NestedEnumNonCardRefundStatusFilter>;
    notIn?: InputMaybe<Array<NonCardRefundStatus>>;
};

export type NestedEnumNonCardRefundStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumNonCardRefundStatusFilter>;
    _min?: InputMaybe<NestedEnumNonCardRefundStatusFilter>;
    equals?: InputMaybe<NonCardRefundStatus>;
    in?: InputMaybe<Array<NonCardRefundStatus>>;
    not?: InputMaybe<NestedEnumNonCardRefundStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<NonCardRefundStatus>>;
};

export type NestedEnumParsingRuleFilter = {
    equals?: InputMaybe<ParsingRule>;
    in?: InputMaybe<Array<ParsingRule>>;
    not?: InputMaybe<NestedEnumParsingRuleFilter>;
    notIn?: InputMaybe<Array<ParsingRule>>;
};

export type NestedEnumParsingRuleWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumParsingRuleFilter>;
    _min?: InputMaybe<NestedEnumParsingRuleFilter>;
    equals?: InputMaybe<ParsingRule>;
    in?: InputMaybe<Array<ParsingRule>>;
    not?: InputMaybe<NestedEnumParsingRuleWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ParsingRule>>;
};

export type NestedEnumPayerTagNullableFilter = {
    equals?: InputMaybe<PayerTag>;
    in?: InputMaybe<Array<PayerTag>>;
    not?: InputMaybe<NestedEnumPayerTagNullableFilter>;
    notIn?: InputMaybe<Array<PayerTag>>;
};

export type NestedEnumPayerTagNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPayerTagNullableFilter>;
    _min?: InputMaybe<NestedEnumPayerTagNullableFilter>;
    equals?: InputMaybe<PayerTag>;
    in?: InputMaybe<Array<PayerTag>>;
    not?: InputMaybe<NestedEnumPayerTagNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PayerTag>>;
};

export type NestedEnumPayerTypeFilter = {
    equals?: InputMaybe<PayerType>;
    in?: InputMaybe<Array<PayerType>>;
    not?: InputMaybe<NestedEnumPayerTypeFilter>;
    notIn?: InputMaybe<Array<PayerType>>;
};

export type NestedEnumPayerTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPayerTypeFilter>;
    _min?: InputMaybe<NestedEnumPayerTypeFilter>;
    equals?: InputMaybe<PayerType>;
    in?: InputMaybe<Array<PayerType>>;
    not?: InputMaybe<NestedEnumPayerTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PayerType>>;
};

export type NestedEnumPaymentTypeFilter = {
    equals?: InputMaybe<PaymentType>;
    in?: InputMaybe<Array<PaymentType>>;
    not?: InputMaybe<NestedEnumPaymentTypeFilter>;
    notIn?: InputMaybe<Array<PaymentType>>;
};

export type NestedEnumPaymentTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentTypeFilter>;
    _min?: InputMaybe<NestedEnumPaymentTypeFilter>;
    equals?: InputMaybe<PaymentType>;
    in?: InputMaybe<Array<PaymentType>>;
    not?: InputMaybe<NestedEnumPaymentTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentType>>;
};

export type NestedEnumPricingTypeFilter = {
    equals?: InputMaybe<PricingType>;
    in?: InputMaybe<Array<PricingType>>;
    not?: InputMaybe<NestedEnumPricingTypeFilter>;
    notIn?: InputMaybe<Array<PricingType>>;
};

export type NestedEnumPricingTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPricingTypeFilter>;
    _min?: InputMaybe<NestedEnumPricingTypeFilter>;
    equals?: InputMaybe<PricingType>;
    in?: InputMaybe<Array<PricingType>>;
    not?: InputMaybe<NestedEnumPricingTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PricingType>>;
};

export type NestedEnumProductCategoryTypeFilter = {
    equals?: InputMaybe<ProductCategoryType>;
    in?: InputMaybe<Array<ProductCategoryType>>;
    not?: InputMaybe<NestedEnumProductCategoryTypeFilter>;
    notIn?: InputMaybe<Array<ProductCategoryType>>;
};

export type NestedEnumProductCategoryTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumProductCategoryTypeFilter>;
    _min?: InputMaybe<NestedEnumProductCategoryTypeFilter>;
    equals?: InputMaybe<ProductCategoryType>;
    in?: InputMaybe<Array<ProductCategoryType>>;
    not?: InputMaybe<NestedEnumProductCategoryTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ProductCategoryType>>;
};

export type NestedEnumProductComponentTypeFilter = {
    equals?: InputMaybe<ProductComponentType>;
    in?: InputMaybe<Array<ProductComponentType>>;
    not?: InputMaybe<NestedEnumProductComponentTypeFilter>;
    notIn?: InputMaybe<Array<ProductComponentType>>;
};

export type NestedEnumProductComponentTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumProductComponentTypeFilter>;
    _min?: InputMaybe<NestedEnumProductComponentTypeFilter>;
    equals?: InputMaybe<ProductComponentType>;
    in?: InputMaybe<Array<ProductComponentType>>;
    not?: InputMaybe<NestedEnumProductComponentTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ProductComponentType>>;
};

export type NestedEnumProductPageTypeFilter = {
    equals?: InputMaybe<ProductPageType>;
    in?: InputMaybe<Array<ProductPageType>>;
    not?: InputMaybe<NestedEnumProductPageTypeFilter>;
    notIn?: InputMaybe<Array<ProductPageType>>;
};

export type NestedEnumProductPageTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumProductPageTypeFilter>;
    _min?: InputMaybe<NestedEnumProductPageTypeFilter>;
    equals?: InputMaybe<ProductPageType>;
    in?: InputMaybe<Array<ProductPageType>>;
    not?: InputMaybe<NestedEnumProductPageTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ProductPageType>>;
};

export type NestedEnumProductTypeFilter = {
    equals?: InputMaybe<ProductType>;
    in?: InputMaybe<Array<ProductType>>;
    not?: InputMaybe<NestedEnumProductTypeFilter>;
    notIn?: InputMaybe<Array<ProductType>>;
};

export type NestedEnumProductTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumProductTypeFilter>;
    _min?: InputMaybe<NestedEnumProductTypeFilter>;
    equals?: InputMaybe<ProductType>;
    in?: InputMaybe<Array<ProductType>>;
    not?: InputMaybe<NestedEnumProductTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ProductType>>;
};

export type NestedEnumPropagationTypeFilter = {
    equals?: InputMaybe<PropagationType>;
    in?: InputMaybe<Array<PropagationType>>;
    not?: InputMaybe<NestedEnumPropagationTypeFilter>;
    notIn?: InputMaybe<Array<PropagationType>>;
};

export type NestedEnumPropagationTypeNullableFilter = {
    equals?: InputMaybe<PropagationType>;
    in?: InputMaybe<Array<PropagationType>>;
    not?: InputMaybe<NestedEnumPropagationTypeNullableFilter>;
    notIn?: InputMaybe<Array<PropagationType>>;
};

export type NestedEnumPropagationTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPropagationTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPropagationTypeNullableFilter>;
    equals?: InputMaybe<PropagationType>;
    in?: InputMaybe<Array<PropagationType>>;
    not?: InputMaybe<NestedEnumPropagationTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PropagationType>>;
};

export type NestedEnumPropagationTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPropagationTypeFilter>;
    _min?: InputMaybe<NestedEnumPropagationTypeFilter>;
    equals?: InputMaybe<PropagationType>;
    in?: InputMaybe<Array<PropagationType>>;
    not?: InputMaybe<NestedEnumPropagationTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PropagationType>>;
};

export type NestedEnumPayLaterAuthorizationStatusFilter = {
    equals?: InputMaybe<PayLaterAuthorizationStatus>;
    in?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumPayLaterAuthorizationStatusFilter>;
    notIn?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
};

export type NestedEnumPayLaterAuthorizationStatusNullableFilter = {
    equals?: InputMaybe<PayLaterAuthorizationStatus>;
    in?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumPayLaterAuthorizationStatusNullableFilter>;
    notIn?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
};

export type NestedEnumPayLaterAuthorizationStatusNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumPayLaterAuthorizationStatusNullableFilter>;
        _min?: InputMaybe<NestedEnumPayLaterAuthorizationStatusNullableFilter>;
        equals?: InputMaybe<PayLaterAuthorizationStatus>;
        in?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
        not?: InputMaybe<NestedEnumPayLaterAuthorizationStatusNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
    };

export type NestedEnumPayLaterAuthorizationStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPayLaterAuthorizationStatusFilter>;
    _min?: InputMaybe<NestedEnumPayLaterAuthorizationStatusFilter>;
    equals?: InputMaybe<PayLaterAuthorizationStatus>;
    in?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
    not?: InputMaybe<NestedEnumPayLaterAuthorizationStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PayLaterAuthorizationStatus>>;
};

export type NestedEnumPaymentAuthorizationConsentTypeFilter = {
    equals?: InputMaybe<PaymentAuthorizationConsentType>;
    in?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
    not?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeFilter>;
    notIn?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
};

export type NestedEnumPaymentAuthorizationConsentTypeNullableFilter = {
    equals?: InputMaybe<PaymentAuthorizationConsentType>;
    in?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
    not?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeNullableFilter>;
    notIn?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
};

export type NestedEnumPaymentAuthorizationConsentTypeNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeNullableFilter>;
        _min?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeNullableFilter>;
        equals?: InputMaybe<PaymentAuthorizationConsentType>;
        in?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
        not?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
    };

export type NestedEnumPaymentAuthorizationConsentTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeFilter>;
    _min?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeFilter>;
    equals?: InputMaybe<PaymentAuthorizationConsentType>;
    in?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
    not?: InputMaybe<NestedEnumPaymentAuthorizationConsentTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentAuthorizationConsentType>>;
};

export type NestedEnumPaymentContractEndReasonNullableFilter = {
    equals?: InputMaybe<PaymentContractEndReason>;
    in?: InputMaybe<Array<PaymentContractEndReason>>;
    not?: InputMaybe<NestedEnumPaymentContractEndReasonNullableFilter>;
    notIn?: InputMaybe<Array<PaymentContractEndReason>>;
};

export type NestedEnumPaymentContractEndReasonNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentContractEndReasonNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentContractEndReasonNullableFilter>;
    equals?: InputMaybe<PaymentContractEndReason>;
    in?: InputMaybe<Array<PaymentContractEndReason>>;
    not?: InputMaybe<NestedEnumPaymentContractEndReasonNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentContractEndReason>>;
};

export type NestedEnumPaymentContractOpenedViaNullableFilter = {
    equals?: InputMaybe<PaymentContractOpenedVia>;
    in?: InputMaybe<Array<PaymentContractOpenedVia>>;
    not?: InputMaybe<NestedEnumPaymentContractOpenedViaNullableFilter>;
    notIn?: InputMaybe<Array<PaymentContractOpenedVia>>;
};

export type NestedEnumPaymentContractOpenedViaNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentContractOpenedViaNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentContractOpenedViaNullableFilter>;
    equals?: InputMaybe<PaymentContractOpenedVia>;
    in?: InputMaybe<Array<PaymentContractOpenedVia>>;
    not?: InputMaybe<NestedEnumPaymentContractOpenedViaNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentContractOpenedVia>>;
};

export type NestedEnumPaymentContractStatusFilter = {
    equals?: InputMaybe<PaymentContractStatus>;
    in?: InputMaybe<Array<PaymentContractStatus>>;
    not?: InputMaybe<NestedEnumPaymentContractStatusFilter>;
    notIn?: InputMaybe<Array<PaymentContractStatus>>;
};

export type NestedEnumPaymentContractStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentContractStatusFilter>;
    _min?: InputMaybe<NestedEnumPaymentContractStatusFilter>;
    equals?: InputMaybe<PaymentContractStatus>;
    in?: InputMaybe<Array<PaymentContractStatus>>;
    not?: InputMaybe<NestedEnumPaymentContractStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentContractStatus>>;
};

export type NestedEnumPaymentMethodTypeFilter = {
    equals?: InputMaybe<PaymentMethodType>;
    in?: InputMaybe<Array<PaymentMethodType>>;
    not?: InputMaybe<NestedEnumPaymentMethodTypeFilter>;
    notIn?: InputMaybe<Array<PaymentMethodType>>;
};

export type NestedEnumPaymentMethodTypeNullableFilter = {
    equals?: InputMaybe<PaymentMethodType>;
    in?: InputMaybe<Array<PaymentMethodType>>;
    not?: InputMaybe<NestedEnumPaymentMethodTypeNullableFilter>;
    notIn?: InputMaybe<Array<PaymentMethodType>>;
};

export type NestedEnumPaymentMethodTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentMethodTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentMethodTypeNullableFilter>;
    equals?: InputMaybe<PaymentMethodType>;
    in?: InputMaybe<Array<PaymentMethodType>>;
    not?: InputMaybe<NestedEnumPaymentMethodTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentMethodType>>;
};

export type NestedEnumPaymentMethodTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentMethodTypeFilter>;
    _min?: InputMaybe<NestedEnumPaymentMethodTypeFilter>;
    equals?: InputMaybe<PaymentMethodType>;
    in?: InputMaybe<Array<PaymentMethodType>>;
    not?: InputMaybe<NestedEnumPaymentMethodTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentMethodType>>;
};

export type NestedEnumPaymentPlanAdjustmentStatusFilter = {
    equals?: InputMaybe<PaymentPlanAdjustmentStatus>;
    in?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
};

export type NestedEnumPaymentPlanAdjustmentStatusNullableFilter = {
    equals?: InputMaybe<PaymentPlanAdjustmentStatus>;
    in?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
};

export type NestedEnumPaymentPlanAdjustmentStatusNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusNullableFilter>;
        _min?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusNullableFilter>;
        equals?: InputMaybe<PaymentPlanAdjustmentStatus>;
        in?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
        not?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
    };

export type NestedEnumPaymentPlanAdjustmentStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusFilter>;
    equals?: InputMaybe<PaymentPlanAdjustmentStatus>;
    in?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAdjustmentStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAdjustmentStatus>>;
};

export type NestedEnumPaymentPlanAutoChargeStatusFilter = {
    equals?: InputMaybe<PaymentPlanAutoChargeStatus>;
    in?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
};

export type NestedEnumPaymentPlanAutoChargeStatusNullableFilter = {
    equals?: InputMaybe<PaymentPlanAutoChargeStatus>;
    in?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
};

export type NestedEnumPaymentPlanAutoChargeStatusNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusNullableFilter>;
        _min?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusNullableFilter>;
        equals?: InputMaybe<PaymentPlanAutoChargeStatus>;
        in?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
        not?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
    };

export type NestedEnumPaymentPlanAutoChargeStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusFilter>;
    equals?: InputMaybe<PaymentPlanAutoChargeStatus>;
    in?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanAutoChargeStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanAutoChargeStatus>>;
};

export type NestedEnumPaymentPlanBoughtTreatmentClaimStageFilter = {
    equals?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
};

export type NestedEnumPaymentPlanBoughtTreatmentClaimStageNullableFilter = {
    equals?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
};

export type NestedEnumPaymentPlanBoughtTreatmentClaimStageNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageNullableFilter>;
        _min?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageNullableFilter>;
        equals?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
        in?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
        not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
    };

export type NestedEnumPaymentPlanBoughtTreatmentClaimStageWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntFilter>;
        _max?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageFilter>;
        _min?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageFilter>;
        equals?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
        in?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
        not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentClaimStageWithAggregatesFilter>;
        notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentClaimStage>>;
    };

export type NestedEnumPaymentPlanBoughtTreatmentStatusFilter = {
    equals?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
};

export type NestedEnumPaymentPlanBoughtTreatmentStatusNullableFilter = {
    equals?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
};

export type NestedEnumPaymentPlanBoughtTreatmentStatusNullableWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntNullableFilter>;
        _max?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusNullableFilter>;
        _min?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusNullableFilter>;
        equals?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
        in?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
        not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusNullableWithAggregatesFilter>;
        notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
    };

export type NestedEnumPaymentPlanBoughtTreatmentStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusFilter>;
    equals?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    in?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanBoughtTreatmentStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanBoughtTreatmentStatus>>;
};

export type NestedEnumPaymentPlanChargeModeFilter = {
    equals?: InputMaybe<PaymentPlanChargeMode>;
    in?: InputMaybe<Array<PaymentPlanChargeMode>>;
    not?: InputMaybe<NestedEnumPaymentPlanChargeModeFilter>;
    notIn?: InputMaybe<Array<PaymentPlanChargeMode>>;
};

export type NestedEnumPaymentPlanChargeModeNullableFilter = {
    equals?: InputMaybe<PaymentPlanChargeMode>;
    in?: InputMaybe<Array<PaymentPlanChargeMode>>;
    not?: InputMaybe<NestedEnumPaymentPlanChargeModeNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanChargeMode>>;
};

export type NestedEnumPaymentPlanChargeModeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanChargeModeNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanChargeModeNullableFilter>;
    equals?: InputMaybe<PaymentPlanChargeMode>;
    in?: InputMaybe<Array<PaymentPlanChargeMode>>;
    not?: InputMaybe<NestedEnumPaymentPlanChargeModeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanChargeMode>>;
};

export type NestedEnumPaymentPlanChargeModeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanChargeModeFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanChargeModeFilter>;
    equals?: InputMaybe<PaymentPlanChargeMode>;
    in?: InputMaybe<Array<PaymentPlanChargeMode>>;
    not?: InputMaybe<NestedEnumPaymentPlanChargeModeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanChargeMode>>;
};

export type NestedEnumPaymentPlanFrequencyFilter = {
    equals?: InputMaybe<PaymentPlanFrequency>;
    in?: InputMaybe<Array<PaymentPlanFrequency>>;
    not?: InputMaybe<NestedEnumPaymentPlanFrequencyFilter>;
    notIn?: InputMaybe<Array<PaymentPlanFrequency>>;
};

export type NestedEnumPaymentPlanFrequencyNullableFilter = {
    equals?: InputMaybe<PaymentPlanFrequency>;
    in?: InputMaybe<Array<PaymentPlanFrequency>>;
    not?: InputMaybe<NestedEnumPaymentPlanFrequencyNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanFrequency>>;
};

export type NestedEnumPaymentPlanFrequencyNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanFrequencyNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanFrequencyNullableFilter>;
    equals?: InputMaybe<PaymentPlanFrequency>;
    in?: InputMaybe<Array<PaymentPlanFrequency>>;
    not?: InputMaybe<NestedEnumPaymentPlanFrequencyNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanFrequency>>;
};

export type NestedEnumPaymentPlanFrequencyWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanFrequencyFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanFrequencyFilter>;
    equals?: InputMaybe<PaymentPlanFrequency>;
    in?: InputMaybe<Array<PaymentPlanFrequency>>;
    not?: InputMaybe<NestedEnumPaymentPlanFrequencyWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanFrequency>>;
};

export type NestedEnumPaymentPlanInitiatedByFilter = {
    equals?: InputMaybe<PaymentPlanInitiatedBy>;
    in?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
    not?: InputMaybe<NestedEnumPaymentPlanInitiatedByFilter>;
    notIn?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
};

export type NestedEnumPaymentPlanInitiatedByNullableFilter = {
    equals?: InputMaybe<PaymentPlanInitiatedBy>;
    in?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
    not?: InputMaybe<NestedEnumPaymentPlanInitiatedByNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
};

export type NestedEnumPaymentPlanInitiatedByNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanInitiatedByNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanInitiatedByNullableFilter>;
    equals?: InputMaybe<PaymentPlanInitiatedBy>;
    in?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
    not?: InputMaybe<NestedEnumPaymentPlanInitiatedByNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
};

export type NestedEnumPaymentPlanInitiatedByWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanInitiatedByFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanInitiatedByFilter>;
    equals?: InputMaybe<PaymentPlanInitiatedBy>;
    in?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
    not?: InputMaybe<NestedEnumPaymentPlanInitiatedByWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanInitiatedBy>>;
};

export type NestedEnumPaymentPlanStatusFilter = {
    equals?: InputMaybe<PaymentPlanStatus>;
    in?: InputMaybe<Array<PaymentPlanStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanStatusFilter>;
    notIn?: InputMaybe<Array<PaymentPlanStatus>>;
};

export type NestedEnumPaymentPlanStatusNullableFilter = {
    equals?: InputMaybe<PaymentPlanStatus>;
    in?: InputMaybe<Array<PaymentPlanStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanStatusNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanStatus>>;
};

export type NestedEnumPaymentPlanStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanStatusNullableFilter>;
    equals?: InputMaybe<PaymentPlanStatus>;
    in?: InputMaybe<Array<PaymentPlanStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanStatus>>;
};

export type NestedEnumPaymentPlanStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanStatusFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanStatusFilter>;
    equals?: InputMaybe<PaymentPlanStatus>;
    in?: InputMaybe<Array<PaymentPlanStatus>>;
    not?: InputMaybe<NestedEnumPaymentPlanStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanStatus>>;
};

export type NestedEnumPaymentPlanTypeFilter = {
    equals?: InputMaybe<PaymentPlanType>;
    in?: InputMaybe<Array<PaymentPlanType>>;
    not?: InputMaybe<NestedEnumPaymentPlanTypeFilter>;
    notIn?: InputMaybe<Array<PaymentPlanType>>;
};

export type NestedEnumPaymentPlanTypeNullableFilter = {
    equals?: InputMaybe<PaymentPlanType>;
    in?: InputMaybe<Array<PaymentPlanType>>;
    not?: InputMaybe<NestedEnumPaymentPlanTypeNullableFilter>;
    notIn?: InputMaybe<Array<PaymentPlanType>>;
};

export type NestedEnumPaymentPlanTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanTypeNullableFilter>;
    equals?: InputMaybe<PaymentPlanType>;
    in?: InputMaybe<Array<PaymentPlanType>>;
    not?: InputMaybe<NestedEnumPaymentPlanTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanType>>;
};

export type NestedEnumPaymentPlanTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentPlanTypeFilter>;
    _min?: InputMaybe<NestedEnumPaymentPlanTypeFilter>;
    equals?: InputMaybe<PaymentPlanType>;
    in?: InputMaybe<Array<PaymentPlanType>>;
    not?: InputMaybe<NestedEnumPaymentPlanTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentPlanType>>;
};

export type NestedEnumPaymentTypeEnumFilter = {
    equals?: InputMaybe<PaymentTypeEnum>;
    in?: InputMaybe<Array<PaymentTypeEnum>>;
    not?: InputMaybe<NestedEnumPaymentTypeEnumFilter>;
    notIn?: InputMaybe<Array<PaymentTypeEnum>>;
};

export type NestedEnumPaymentTypeEnumNullableFilter = {
    equals?: InputMaybe<PaymentTypeEnum>;
    in?: InputMaybe<Array<PaymentTypeEnum>>;
    not?: InputMaybe<NestedEnumPaymentTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<PaymentTypeEnum>>;
};

export type NestedEnumPaymentTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentTypeEnumNullableFilter>;
    equals?: InputMaybe<PaymentTypeEnum>;
    in?: InputMaybe<Array<PaymentTypeEnum>>;
    not?: InputMaybe<NestedEnumPaymentTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentTypeEnum>>;
};

export type NestedEnumPaymentTypeEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPaymentTypeEnumFilter>;
    _min?: InputMaybe<NestedEnumPaymentTypeEnumFilter>;
    equals?: InputMaybe<PaymentTypeEnum>;
    in?: InputMaybe<Array<PaymentTypeEnum>>;
    not?: InputMaybe<NestedEnumPaymentTypeEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentTypeEnum>>;
};

export type NestedEnumPaymentTypeNullableFilter = {
    equals?: InputMaybe<PaymentType>;
    in?: InputMaybe<Array<PaymentType>>;
    not?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
    notIn?: InputMaybe<Array<PaymentType>>;
};

export type NestedEnumPaymentTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
    equals?: InputMaybe<PaymentType>;
    in?: InputMaybe<Array<PaymentType>>;
    not?: InputMaybe<NestedEnumPaymentTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PaymentType>>;
};

export type NestedEnumPayoutReferencePaymentTypeNullableFilter = {
    equals?: InputMaybe<PayoutReferencePaymentType>;
    in?: InputMaybe<Array<PayoutReferencePaymentType>>;
    not?: InputMaybe<NestedEnumPayoutReferencePaymentTypeNullableFilter>;
    notIn?: InputMaybe<Array<PayoutReferencePaymentType>>;
};

export type NestedEnumPayoutReferencePaymentTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPayoutReferencePaymentTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumPayoutReferencePaymentTypeNullableFilter>;
    equals?: InputMaybe<PayoutReferencePaymentType>;
    in?: InputMaybe<Array<PayoutReferencePaymentType>>;
    not?: InputMaybe<NestedEnumPayoutReferencePaymentTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PayoutReferencePaymentType>>;
};

export type NestedEnumPendingVoidPayoutReversalProcessingStatusEnumFilter = {
    equals?: InputMaybe<PendingVoidPayoutReversalProcessingStatusEnum>;
    in?: InputMaybe<Array<PendingVoidPayoutReversalProcessingStatusEnum>>;
    not?: InputMaybe<NestedEnumPendingVoidPayoutReversalProcessingStatusEnumFilter>;
    notIn?: InputMaybe<Array<PendingVoidPayoutReversalProcessingStatusEnum>>;
};

export type NestedEnumPendingVoidPayoutReversalProcessingStatusEnumWithAggregatesFilter =
    {
        _count?: InputMaybe<NestedIntFilter>;
        _max?: InputMaybe<NestedEnumPendingVoidPayoutReversalProcessingStatusEnumFilter>;
        _min?: InputMaybe<NestedEnumPendingVoidPayoutReversalProcessingStatusEnumFilter>;
        equals?: InputMaybe<PendingVoidPayoutReversalProcessingStatusEnum>;
        in?: InputMaybe<Array<PendingVoidPayoutReversalProcessingStatusEnum>>;
        not?: InputMaybe<NestedEnumPendingVoidPayoutReversalProcessingStatusEnumWithAggregatesFilter>;
        notIn?: InputMaybe<
            Array<PendingVoidPayoutReversalProcessingStatusEnum>
        >;
    };

export type NestedEnumPhoneNumberTypeEnumFilter = {
    equals?: InputMaybe<PhoneNumberTypeEnum>;
    in?: InputMaybe<Array<PhoneNumberTypeEnum>>;
    not?: InputMaybe<NestedEnumPhoneNumberTypeEnumFilter>;
    notIn?: InputMaybe<Array<PhoneNumberTypeEnum>>;
};

export type NestedEnumPhoneNumberTypeEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPhoneNumberTypeEnumFilter>;
    _min?: InputMaybe<NestedEnumPhoneNumberTypeEnumFilter>;
    equals?: InputMaybe<PhoneNumberTypeEnum>;
    in?: InputMaybe<Array<PhoneNumberTypeEnum>>;
    not?: InputMaybe<NestedEnumPhoneNumberTypeEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PhoneNumberTypeEnum>>;
};

export type NestedEnumPhotoStatusFilter = {
    equals?: InputMaybe<PhotoStatus>;
    in?: InputMaybe<Array<PhotoStatus>>;
    not?: InputMaybe<NestedEnumPhotoStatusFilter>;
    notIn?: InputMaybe<Array<PhotoStatus>>;
};

export type NestedEnumPhotoStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPhotoStatusFilter>;
    _min?: InputMaybe<NestedEnumPhotoStatusFilter>;
    equals?: InputMaybe<PhotoStatus>;
    in?: InputMaybe<Array<PhotoStatus>>;
    not?: InputMaybe<NestedEnumPhotoStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PhotoStatus>>;
};

export type NestedEnumPhotoTypeFilter = {
    equals?: InputMaybe<PhotoType>;
    in?: InputMaybe<Array<PhotoType>>;
    not?: InputMaybe<NestedEnumPhotoTypeFilter>;
    notIn?: InputMaybe<Array<PhotoType>>;
};

export type NestedEnumPhotoTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumPhotoTypeFilter>;
    _min?: InputMaybe<NestedEnumPhotoTypeFilter>;
    equals?: InputMaybe<PhotoType>;
    in?: InputMaybe<Array<PhotoType>>;
    not?: InputMaybe<NestedEnumPhotoTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PhotoType>>;
};

export type NestedEnumPriceSwapReasonEnumNullableFilter = {
    equals?: InputMaybe<PriceSwapReasonEnum>;
    in?: InputMaybe<Array<PriceSwapReasonEnum>>;
    not?: InputMaybe<NestedEnumPriceSwapReasonEnumNullableFilter>;
    notIn?: InputMaybe<Array<PriceSwapReasonEnum>>;
};

export type NestedEnumPriceSwapReasonEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumPriceSwapReasonEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumPriceSwapReasonEnumNullableFilter>;
    equals?: InputMaybe<PriceSwapReasonEnum>;
    in?: InputMaybe<Array<PriceSwapReasonEnum>>;
    not?: InputMaybe<NestedEnumPriceSwapReasonEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<PriceSwapReasonEnum>>;
};

export type NestedEnumRequestSourceFilter = {
    equals?: InputMaybe<RequestSource>;
    in?: InputMaybe<Array<RequestSource>>;
    not?: InputMaybe<NestedEnumRequestSourceFilter>;
    notIn?: InputMaybe<Array<RequestSource>>;
};

export type NestedEnumRequestSourceNullableFilter = {
    equals?: InputMaybe<RequestSource>;
    in?: InputMaybe<Array<RequestSource>>;
    not?: InputMaybe<NestedEnumRequestSourceNullableFilter>;
    notIn?: InputMaybe<Array<RequestSource>>;
};

export type NestedEnumRequestSourceNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumRequestSourceNullableFilter>;
    _min?: InputMaybe<NestedEnumRequestSourceNullableFilter>;
    equals?: InputMaybe<RequestSource>;
    in?: InputMaybe<Array<RequestSource>>;
    not?: InputMaybe<NestedEnumRequestSourceNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<RequestSource>>;
};

export type NestedEnumRequestSourceWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumRequestSourceFilter>;
    _min?: InputMaybe<NestedEnumRequestSourceFilter>;
    equals?: InputMaybe<RequestSource>;
    in?: InputMaybe<Array<RequestSource>>;
    not?: InputMaybe<NestedEnumRequestSourceWithAggregatesFilter>;
    notIn?: InputMaybe<Array<RequestSource>>;
};

export type NestedEnumRequestTypeNullableFilter = {
    equals?: InputMaybe<RequestType>;
    in?: InputMaybe<Array<RequestType>>;
    not?: InputMaybe<NestedEnumRequestTypeNullableFilter>;
    notIn?: InputMaybe<Array<RequestType>>;
};

export type NestedEnumRequestTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumRequestTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumRequestTypeNullableFilter>;
    equals?: InputMaybe<RequestType>;
    in?: InputMaybe<Array<RequestType>>;
    not?: InputMaybe<NestedEnumRequestTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<RequestType>>;
};

export type NestedEnumReattributionStateNullableFilter = {
    equals?: InputMaybe<ReattributionState>;
    in?: InputMaybe<Array<ReattributionState>>;
    not?: InputMaybe<NestedEnumReattributionStateNullableFilter>;
    notIn?: InputMaybe<Array<ReattributionState>>;
};

export type NestedEnumReattributionStateNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumReattributionStateNullableFilter>;
    _min?: InputMaybe<NestedEnumReattributionStateNullableFilter>;
    equals?: InputMaybe<ReattributionState>;
    in?: InputMaybe<Array<ReattributionState>>;
    not?: InputMaybe<NestedEnumReattributionStateNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ReattributionState>>;
};

export type NestedEnumRevenueTypeNullableFilter = {
    equals?: InputMaybe<RevenueType>;
    in?: InputMaybe<Array<RevenueType>>;
    not?: InputMaybe<NestedEnumRevenueTypeNullableFilter>;
    notIn?: InputMaybe<Array<RevenueType>>;
};

export type NestedEnumRevenueTypeNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumRevenueTypeNullableFilter>;
    _min?: InputMaybe<NestedEnumRevenueTypeNullableFilter>;
    equals?: InputMaybe<RevenueType>;
    in?: InputMaybe<Array<RevenueType>>;
    not?: InputMaybe<NestedEnumRevenueTypeNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<RevenueType>>;
};

export type NestedEnumReviewStatusEnumNullableFilter = {
    equals?: InputMaybe<ReviewStatusEnum>;
    in?: InputMaybe<Array<ReviewStatusEnum>>;
    not?: InputMaybe<NestedEnumReviewStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<ReviewStatusEnum>>;
};

export type NestedEnumReviewStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumReviewStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumReviewStatusEnumNullableFilter>;
    equals?: InputMaybe<ReviewStatusEnum>;
    in?: InputMaybe<Array<ReviewStatusEnum>>;
    not?: InputMaybe<NestedEnumReviewStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<ReviewStatusEnum>>;
};

export type NestedEnumSchedulingTypeFilter = {
    equals?: InputMaybe<SchedulingType>;
    in?: InputMaybe<Array<SchedulingType>>;
    not?: InputMaybe<NestedEnumSchedulingTypeFilter>;
    notIn?: InputMaybe<Array<SchedulingType>>;
};

export type NestedEnumSchedulingTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumSchedulingTypeFilter>;
    _min?: InputMaybe<NestedEnumSchedulingTypeFilter>;
    equals?: InputMaybe<SchedulingType>;
    in?: InputMaybe<Array<SchedulingType>>;
    not?: InputMaybe<NestedEnumSchedulingTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SchedulingType>>;
};

export type NestedEnumSelectionPriorityFilter = {
    equals?: InputMaybe<SelectionPriority>;
    in?: InputMaybe<Array<SelectionPriority>>;
    not?: InputMaybe<NestedEnumSelectionPriorityFilter>;
    notIn?: InputMaybe<Array<SelectionPriority>>;
};

export type NestedEnumSelectionPriorityWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumSelectionPriorityFilter>;
    _min?: InputMaybe<NestedEnumSelectionPriorityFilter>;
    equals?: InputMaybe<SelectionPriority>;
    in?: InputMaybe<Array<SelectionPriority>>;
    not?: InputMaybe<NestedEnumSelectionPriorityWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SelectionPriority>>;
};

export type NestedEnumSelectionTypeFilter = {
    equals?: InputMaybe<SelectionType>;
    in?: InputMaybe<Array<SelectionType>>;
    not?: InputMaybe<NestedEnumSelectionTypeFilter>;
    notIn?: InputMaybe<Array<SelectionType>>;
};

export type NestedEnumSelectionTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumSelectionTypeFilter>;
    _min?: InputMaybe<NestedEnumSelectionTypeFilter>;
    equals?: InputMaybe<SelectionType>;
    in?: InputMaybe<Array<SelectionType>>;
    not?: InputMaybe<NestedEnumSelectionTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SelectionType>>;
};

export type NestedEnumServiceNullableFilter = {
    equals?: InputMaybe<Service>;
    in?: InputMaybe<Array<Service>>;
    not?: InputMaybe<NestedEnumServiceNullableFilter>;
    notIn?: InputMaybe<Array<Service>>;
};

export type NestedEnumServiceNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumServiceNullableFilter>;
    _min?: InputMaybe<NestedEnumServiceNullableFilter>;
    equals?: InputMaybe<Service>;
    in?: InputMaybe<Array<Service>>;
    not?: InputMaybe<NestedEnumServiceNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Service>>;
};

export type NestedEnumStateFilter = {
    equals?: InputMaybe<State>;
    in?: InputMaybe<Array<State>>;
    not?: InputMaybe<NestedEnumStateFilter>;
    notIn?: InputMaybe<Array<State>>;
};

export type NestedEnumStateNullableFilter = {
    equals?: InputMaybe<State>;
    in?: InputMaybe<Array<State>>;
    not?: InputMaybe<NestedEnumStateNullableFilter>;
    notIn?: InputMaybe<Array<State>>;
};

export type NestedEnumStateNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumStateNullableFilter>;
    _min?: InputMaybe<NestedEnumStateNullableFilter>;
    equals?: InputMaybe<State>;
    in?: InputMaybe<Array<State>>;
    not?: InputMaybe<NestedEnumStateNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<State>>;
};

export type NestedEnumStateWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumStateFilter>;
    _min?: InputMaybe<NestedEnumStateFilter>;
    equals?: InputMaybe<State>;
    in?: InputMaybe<Array<State>>;
    not?: InputMaybe<NestedEnumStateWithAggregatesFilter>;
    notIn?: InputMaybe<Array<State>>;
};

export type NestedEnumSlotStatusEnumFilter = {
    equals?: InputMaybe<SlotStatusEnum>;
    in?: InputMaybe<Array<SlotStatusEnum>>;
    not?: InputMaybe<NestedEnumSlotStatusEnumFilter>;
    notIn?: InputMaybe<Array<SlotStatusEnum>>;
};

export type NestedEnumSlotStatusEnumNullableFilter = {
    equals?: InputMaybe<SlotStatusEnum>;
    in?: InputMaybe<Array<SlotStatusEnum>>;
    not?: InputMaybe<NestedEnumSlotStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<SlotStatusEnum>>;
};

export type NestedEnumSlotStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumSlotStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumSlotStatusEnumNullableFilter>;
    equals?: InputMaybe<SlotStatusEnum>;
    in?: InputMaybe<Array<SlotStatusEnum>>;
    not?: InputMaybe<NestedEnumSlotStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SlotStatusEnum>>;
};

export type NestedEnumSlotStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumSlotStatusEnumFilter>;
    _min?: InputMaybe<NestedEnumSlotStatusEnumFilter>;
    equals?: InputMaybe<SlotStatusEnum>;
    in?: InputMaybe<Array<SlotStatusEnum>>;
    not?: InputMaybe<NestedEnumSlotStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SlotStatusEnum>>;
};

export type NestedEnumSlotTypeEnumNullableFilter = {
    equals?: InputMaybe<SlotTypeEnum>;
    in?: InputMaybe<Array<SlotTypeEnum>>;
    not?: InputMaybe<NestedEnumSlotTypeEnumNullableFilter>;
    notIn?: InputMaybe<Array<SlotTypeEnum>>;
};

export type NestedEnumSlotTypeEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumSlotTypeEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumSlotTypeEnumNullableFilter>;
    equals?: InputMaybe<SlotTypeEnum>;
    in?: InputMaybe<Array<SlotTypeEnum>>;
    not?: InputMaybe<NestedEnumSlotTypeEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<SlotTypeEnum>>;
};

export type NestedEnumTaskVisibilityFilter = {
    equals?: InputMaybe<TaskVisibility>;
    in?: InputMaybe<Array<TaskVisibility>>;
    not?: InputMaybe<NestedEnumTaskVisibilityFilter>;
    notIn?: InputMaybe<Array<TaskVisibility>>;
};

export type NestedEnumTaskVisibilityWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumTaskVisibilityFilter>;
    _min?: InputMaybe<NestedEnumTaskVisibilityFilter>;
    equals?: InputMaybe<TaskVisibility>;
    in?: InputMaybe<Array<TaskVisibility>>;
    not?: InputMaybe<NestedEnumTaskVisibilityWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TaskVisibility>>;
};

export type NestedEnumTaskStatusFilter = {
    equals?: InputMaybe<TaskStatus>;
    in?: InputMaybe<Array<TaskStatus>>;
    not?: InputMaybe<NestedEnumTaskStatusFilter>;
    notIn?: InputMaybe<Array<TaskStatus>>;
};

export type NestedEnumTaskStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumTaskStatusFilter>;
    _min?: InputMaybe<NestedEnumTaskStatusFilter>;
    equals?: InputMaybe<TaskStatus>;
    in?: InputMaybe<Array<TaskStatus>>;
    not?: InputMaybe<NestedEnumTaskStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TaskStatus>>;
};

export type NestedEnumTaskTypeFilter = {
    equals?: InputMaybe<TaskType>;
    in?: InputMaybe<Array<TaskType>>;
    not?: InputMaybe<NestedEnumTaskTypeFilter>;
    notIn?: InputMaybe<Array<TaskType>>;
};

export type NestedEnumTaskTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumTaskTypeFilter>;
    _min?: InputMaybe<NestedEnumTaskTypeFilter>;
    equals?: InputMaybe<TaskType>;
    in?: InputMaybe<Array<TaskType>>;
    not?: InputMaybe<NestedEnumTaskTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TaskType>>;
};

export type NestedEnumTimeBlockCategoryEnumNullableFilter = {
    equals?: InputMaybe<TimeBlockCategoryEnum>;
    in?: InputMaybe<Array<TimeBlockCategoryEnum>>;
    not?: InputMaybe<NestedEnumTimeBlockCategoryEnumNullableFilter>;
    notIn?: InputMaybe<Array<TimeBlockCategoryEnum>>;
};

export type NestedEnumTimeBlockCategoryEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumTimeBlockCategoryEnumNullableFilter>;
    _min?: InputMaybe<NestedEnumTimeBlockCategoryEnumNullableFilter>;
    equals?: InputMaybe<TimeBlockCategoryEnum>;
    in?: InputMaybe<Array<TimeBlockCategoryEnum>>;
    not?: InputMaybe<NestedEnumTimeBlockCategoryEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TimeBlockCategoryEnum>>;
};

export type NestedEnumTransactionStatusFilter = {
    equals?: InputMaybe<TransactionStatus>;
    in?: InputMaybe<Array<TransactionStatus>>;
    not?: InputMaybe<NestedEnumTransactionStatusFilter>;
    notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type NestedEnumTransactionStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumTransactionStatusFilter>;
    _min?: InputMaybe<NestedEnumTransactionStatusFilter>;
    equals?: InputMaybe<TransactionStatus>;
    in?: InputMaybe<Array<TransactionStatus>>;
    not?: InputMaybe<NestedEnumTransactionStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type NestedEnumTransactionTypeFilter = {
    equals?: InputMaybe<TransactionType>;
    in?: InputMaybe<Array<TransactionType>>;
    not?: InputMaybe<NestedEnumTransactionTypeFilter>;
    notIn?: InputMaybe<Array<TransactionType>>;
};

export type NestedEnumTransactionTypeWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumTransactionTypeFilter>;
    _min?: InputMaybe<NestedEnumTransactionTypeFilter>;
    equals?: InputMaybe<TransactionType>;
    in?: InputMaybe<Array<TransactionType>>;
    not?: InputMaybe<NestedEnumTransactionTypeWithAggregatesFilter>;
    notIn?: InputMaybe<Array<TransactionType>>;
};

export type NestedEnumUserAccountStatusNullableFilter = {
    equals?: InputMaybe<UserAccountStatus>;
    in?: InputMaybe<Array<UserAccountStatus>>;
    not?: InputMaybe<NestedEnumUserAccountStatusNullableFilter>;
    notIn?: InputMaybe<Array<UserAccountStatus>>;
};

export type NestedEnumUserAccountStatusNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumUserAccountStatusNullableFilter>;
    _min?: InputMaybe<NestedEnumUserAccountStatusNullableFilter>;
    equals?: InputMaybe<UserAccountStatus>;
    in?: InputMaybe<Array<UserAccountStatus>>;
    not?: InputMaybe<NestedEnumUserAccountStatusNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<UserAccountStatus>>;
};

export type NestedEnumVerificationSourceNullableFilter = {
    equals?: InputMaybe<VerificationSource>;
    in?: InputMaybe<Array<VerificationSource>>;
    not?: InputMaybe<NestedEnumVerificationSourceNullableFilter>;
    notIn?: InputMaybe<Array<VerificationSource>>;
};

export type NestedEnumVerificationSourceNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumVerificationSourceNullableFilter>;
    _min?: InputMaybe<NestedEnumVerificationSourceNullableFilter>;
    equals?: InputMaybe<VerificationSource>;
    in?: InputMaybe<Array<VerificationSource>>;
    not?: InputMaybe<NestedEnumVerificationSourceNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<VerificationSource>>;
};

export type NestedEnumVerificationStatusFilter = {
    equals?: InputMaybe<VerificationStatus>;
    in?: InputMaybe<Array<VerificationStatus>>;
    not?: InputMaybe<NestedEnumVerificationStatusFilter>;
    notIn?: InputMaybe<Array<VerificationStatus>>;
};

export type NestedEnumVerificationStatusWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnumVerificationStatusFilter>;
    _min?: InputMaybe<NestedEnumVerificationStatusFilter>;
    equals?: InputMaybe<VerificationStatus>;
    in?: InputMaybe<Array<VerificationStatus>>;
    not?: InputMaybe<NestedEnumVerificationStatusWithAggregatesFilter>;
    notIn?: InputMaybe<Array<VerificationStatus>>;
};

export type NestedEnumVirtualDayOfReminderNullableFilter = {
    equals?: InputMaybe<VirtualDayOfReminder>;
    in?: InputMaybe<Array<VirtualDayOfReminder>>;
    not?: InputMaybe<NestedEnumVirtualDayOfReminderNullableFilter>;
    notIn?: InputMaybe<Array<VirtualDayOfReminder>>;
};

export type NestedEnumVirtualDayOfReminderNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnumVirtualDayOfReminderNullableFilter>;
    _min?: InputMaybe<NestedEnumVirtualDayOfReminderNullableFilter>;
    equals?: InputMaybe<VirtualDayOfReminder>;
    in?: InputMaybe<Array<VirtualDayOfReminder>>;
    not?: InputMaybe<NestedEnumVirtualDayOfReminderNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<VirtualDayOfReminder>>;
};

export type NestedEnuminsurancesStatusEnumFilter = {
    equals?: InputMaybe<InsurancesStatusEnum>;
    in?: InputMaybe<Array<InsurancesStatusEnum>>;
    not?: InputMaybe<NestedEnuminsurancesStatusEnumFilter>;
    notIn?: InputMaybe<Array<InsurancesStatusEnum>>;
};

export type NestedEnuminsurancesStatusEnumNullableFilter = {
    equals?: InputMaybe<InsurancesStatusEnum>;
    in?: InputMaybe<Array<InsurancesStatusEnum>>;
    not?: InputMaybe<NestedEnuminsurancesStatusEnumNullableFilter>;
    notIn?: InputMaybe<Array<InsurancesStatusEnum>>;
};

export type NestedEnuminsurancesStatusEnumNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedEnuminsurancesStatusEnumNullableFilter>;
    _min?: InputMaybe<NestedEnuminsurancesStatusEnumNullableFilter>;
    equals?: InputMaybe<InsurancesStatusEnum>;
    in?: InputMaybe<Array<InsurancesStatusEnum>>;
    not?: InputMaybe<NestedEnuminsurancesStatusEnumNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InsurancesStatusEnum>>;
};

export type NestedEnuminsurancesStatusEnumWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedEnuminsurancesStatusEnumFilter>;
    _min?: InputMaybe<NestedEnuminsurancesStatusEnumFilter>;
    equals?: InputMaybe<InsurancesStatusEnum>;
    in?: InputMaybe<Array<InsurancesStatusEnum>>;
    not?: InputMaybe<NestedEnuminsurancesStatusEnumWithAggregatesFilter>;
    notIn?: InputMaybe<Array<InsurancesStatusEnum>>;
};

export type NestedFloatFilter = {
    equals?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    gte?: InputMaybe<Scalars['Float']['input']>;
    in?: InputMaybe<Array<Scalars['Float']['input']>>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    lte?: InputMaybe<Scalars['Float']['input']>;
    not?: InputMaybe<NestedFloatFilter>;
    notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
    equals?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    gte?: InputMaybe<Scalars['Float']['input']>;
    in?: InputMaybe<Array<Scalars['Float']['input']>>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    lte?: InputMaybe<Scalars['Float']['input']>;
    not?: InputMaybe<NestedFloatNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableWithAggregatesFilter = {
    _avg?: InputMaybe<NestedFloatNullableFilter>;
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedFloatNullableFilter>;
    _min?: InputMaybe<NestedFloatNullableFilter>;
    _sum?: InputMaybe<NestedFloatNullableFilter>;
    equals?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    gte?: InputMaybe<Scalars['Float']['input']>;
    in?: InputMaybe<Array<Scalars['Float']['input']>>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    lte?: InputMaybe<Scalars['Float']['input']>;
    not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatWithAggregatesFilter = {
    _avg?: InputMaybe<NestedFloatFilter>;
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedFloatFilter>;
    _min?: InputMaybe<NestedFloatFilter>;
    _sum?: InputMaybe<NestedFloatFilter>;
    equals?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    gte?: InputMaybe<Scalars['Float']['input']>;
    in?: InputMaybe<Array<Scalars['Float']['input']>>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    lte?: InputMaybe<Scalars['Float']['input']>;
    not?: InputMaybe<NestedFloatWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
    equals?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<Scalars['Int']['input']>>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
    not?: InputMaybe<NestedIntFilter>;
    notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
    equals?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<Scalars['Int']['input']>>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
    not?: InputMaybe<NestedIntNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
    _avg?: InputMaybe<NestedFloatNullableFilter>;
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedIntNullableFilter>;
    _min?: InputMaybe<NestedIntNullableFilter>;
    _sum?: InputMaybe<NestedIntNullableFilter>;
    equals?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<Scalars['Int']['input']>>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
    not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntWithAggregatesFilter = {
    _avg?: InputMaybe<NestedFloatFilter>;
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedIntFilter>;
    _min?: InputMaybe<NestedIntFilter>;
    _sum?: InputMaybe<NestedIntFilter>;
    equals?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<Scalars['Int']['input']>>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
    not?: InputMaybe<NestedIntWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedJsonFilter = {
    array_contains?: InputMaybe<Scalars['JSON']['input']>;
    array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
    array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
    equals?: InputMaybe<Scalars['JSON']['input']>;
    gt?: InputMaybe<Scalars['JSON']['input']>;
    gte?: InputMaybe<Scalars['JSON']['input']>;
    lt?: InputMaybe<Scalars['JSON']['input']>;
    lte?: InputMaybe<Scalars['JSON']['input']>;
    not?: InputMaybe<Scalars['JSON']['input']>;
    path?: InputMaybe<Array<Scalars['String']['input']>>;
    string_contains?: InputMaybe<Scalars['String']['input']>;
    string_ends_with?: InputMaybe<Scalars['String']['input']>;
    string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedJsonNullableFilter = {
    array_contains?: InputMaybe<Scalars['JSON']['input']>;
    array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
    array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
    equals?: InputMaybe<Scalars['JSON']['input']>;
    gt?: InputMaybe<Scalars['JSON']['input']>;
    gte?: InputMaybe<Scalars['JSON']['input']>;
    lt?: InputMaybe<Scalars['JSON']['input']>;
    lte?: InputMaybe<Scalars['JSON']['input']>;
    not?: InputMaybe<Scalars['JSON']['input']>;
    path?: InputMaybe<Array<Scalars['String']['input']>>;
    string_contains?: InputMaybe<Scalars['String']['input']>;
    string_ends_with?: InputMaybe<Scalars['String']['input']>;
    string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringFilter = {
    contains?: InputMaybe<Scalars['String']['input']>;
    endsWith?: InputMaybe<Scalars['String']['input']>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    not?: InputMaybe<NestedStringFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
    contains?: InputMaybe<Scalars['String']['input']>;
    endsWith?: InputMaybe<Scalars['String']['input']>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    not?: InputMaybe<NestedStringNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedStringNullableFilter>;
    _min?: InputMaybe<NestedStringNullableFilter>;
    contains?: InputMaybe<Scalars['String']['input']>;
    endsWith?: InputMaybe<Scalars['String']['input']>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedStringFilter>;
    _min?: InputMaybe<NestedStringFilter>;
    contains?: InputMaybe<Scalars['String']['input']>;
    endsWith?: InputMaybe<Scalars['String']['input']>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    not?: InputMaybe<NestedStringWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedUuidFilter = {
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    not?: InputMaybe<NestedUuidFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedUuidNullableFilter = {
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    not?: InputMaybe<NestedUuidNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedUuidNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedStringNullableFilter>;
    _min?: InputMaybe<NestedStringNullableFilter>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    not?: InputMaybe<NestedUuidNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedUuidWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedStringFilter>;
    _min?: InputMaybe<NestedStringFilter>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    not?: InputMaybe<NestedUuidWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NetworkValidation = {
    __typename?: 'NetworkValidation';
    createdAt: Scalars['DateTimeISO']['output'];
    groupName?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    hiosId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    insuranceType?: Maybe<Scalars['String']['output']>;
    memberId?: Maybe<Scalars['String']['output']>;
    network: NetworkType;
    notes: Array<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId: Scalars['Int']['output'];
    planLevel?: Maybe<Scalars['String']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planNetworkname?: Maybe<Scalars['String']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<State>;
};

export type NetworkValidationAvgAggregate = {
    __typename?: 'NetworkValidationAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    payerId?: Maybe<Scalars['Float']['output']>;
    providerGroupId?: Maybe<Scalars['Float']['output']>;
};

export type NetworkValidationAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type NetworkValidationCountAggregate = {
    __typename?: 'NetworkValidationCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    groupName: Scalars['Int']['output'];
    groupNumber: Scalars['Int']['output'];
    hiosId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    insuranceType: Scalars['Int']['output'];
    memberId: Scalars['Int']['output'];
    network: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payerId: Scalars['Int']['output'];
    planLevel: Scalars['Int']['output'];
    planName: Scalars['Int']['output'];
    planNetworkname: Scalars['Int']['output'];
    procedureCode: Scalars['Int']['output'];
    providerGroupId: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
};

export type NetworkValidationCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    groupName?: InputMaybe<SortOrder>;
    groupNumber?: InputMaybe<SortOrder>;
    hiosId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceType?: InputMaybe<SortOrder>;
    memberId?: InputMaybe<SortOrder>;
    network?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    planLevel?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    planNetworkname?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
};

export type NetworkValidationCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    groupName?: InputMaybe<Scalars['String']['input']>;
    groupNumber?: InputMaybe<Scalars['String']['input']>;
    hiosId?: InputMaybe<Scalars['String']['input']>;
    insuranceType?: InputMaybe<Scalars['String']['input']>;
    memberId?: InputMaybe<Scalars['String']['input']>;
    network?: InputMaybe<NetworkType>;
    notes?: InputMaybe<NetworkValidationCreatenotesInput>;
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    payerId: Scalars['Int']['input'];
    planLevel?: InputMaybe<Scalars['String']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    planNetworkname?: InputMaybe<Scalars['String']['input']>;
    procedureCode?: InputMaybe<Scalars['String']['input']>;
    providerGroupId?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<State>;
};

export type NetworkValidationCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    groupName?: InputMaybe<Scalars['String']['input']>;
    groupNumber?: InputMaybe<Scalars['String']['input']>;
    hiosId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    insuranceType?: InputMaybe<Scalars['String']['input']>;
    memberId?: InputMaybe<Scalars['String']['input']>;
    network?: InputMaybe<NetworkType>;
    notes?: InputMaybe<NetworkValidationCreatenotesInput>;
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    payerId: Scalars['Int']['input'];
    planLevel?: InputMaybe<Scalars['String']['input']>;
    planName?: InputMaybe<Scalars['String']['input']>;
    planNetworkname?: InputMaybe<Scalars['String']['input']>;
    procedureCode?: InputMaybe<Scalars['String']['input']>;
    providerGroupId?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<State>;
};

export type NetworkValidationCreatenotesInput = {
    set: Array<Scalars['String']['input']>;
};

export type NetworkValidationGroupBy = {
    __typename?: 'NetworkValidationGroupBy';
    _avg?: Maybe<NetworkValidationAvgAggregate>;
    _count?: Maybe<NetworkValidationCountAggregate>;
    _max?: Maybe<NetworkValidationMaxAggregate>;
    _min?: Maybe<NetworkValidationMinAggregate>;
    _sum?: Maybe<NetworkValidationSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    groupName?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    hiosId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    insuranceType?: Maybe<Scalars['String']['output']>;
    memberId?: Maybe<Scalars['String']['output']>;
    network: NetworkType;
    notes?: Maybe<Array<Scalars['String']['output']>>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId: Scalars['Int']['output'];
    planLevel?: Maybe<Scalars['String']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planNetworkname?: Maybe<Scalars['String']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<State>;
};

export type NetworkValidationMaxAggregate = {
    __typename?: 'NetworkValidationMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    groupName?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    hiosId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    insuranceType?: Maybe<Scalars['String']['output']>;
    memberId?: Maybe<Scalars['String']['output']>;
    network?: Maybe<NetworkType>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
    planLevel?: Maybe<Scalars['String']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planNetworkname?: Maybe<Scalars['String']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<State>;
};

export type NetworkValidationMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    groupName?: InputMaybe<SortOrder>;
    groupNumber?: InputMaybe<SortOrder>;
    hiosId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceType?: InputMaybe<SortOrder>;
    memberId?: InputMaybe<SortOrder>;
    network?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    planLevel?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    planNetworkname?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
};

export type NetworkValidationMinAggregate = {
    __typename?: 'NetworkValidationMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    groupName?: Maybe<Scalars['String']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    hiosId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    insuranceType?: Maybe<Scalars['String']['output']>;
    memberId?: Maybe<Scalars['String']['output']>;
    network?: Maybe<NetworkType>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
    planLevel?: Maybe<Scalars['String']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planNetworkname?: Maybe<Scalars['String']['output']>;
    procedureCode?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<State>;
};

export type NetworkValidationMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    groupName?: InputMaybe<SortOrder>;
    groupNumber?: InputMaybe<SortOrder>;
    hiosId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insuranceType?: InputMaybe<SortOrder>;
    memberId?: InputMaybe<SortOrder>;
    network?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    planLevel?: InputMaybe<SortOrder>;
    planName?: InputMaybe<SortOrder>;
    planNetworkname?: InputMaybe<SortOrder>;
    procedureCode?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
};

export type NetworkValidationOrderByWithAggregationInput = {
    _avg?: InputMaybe<NetworkValidationAvgOrderByAggregateInput>;
    _count?: InputMaybe<NetworkValidationCountOrderByAggregateInput>;
    _max?: InputMaybe<NetworkValidationMaxOrderByAggregateInput>;
    _min?: InputMaybe<NetworkValidationMinOrderByAggregateInput>;
    _sum?: InputMaybe<NetworkValidationSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    groupName?: InputMaybe<SortOrderInput>;
    groupNumber?: InputMaybe<SortOrderInput>;
    hiosId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    insuranceType?: InputMaybe<SortOrderInput>;
    memberId?: InputMaybe<SortOrderInput>;
    network?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    payerId?: InputMaybe<SortOrder>;
    planLevel?: InputMaybe<SortOrderInput>;
    planName?: InputMaybe<SortOrderInput>;
    planNetworkname?: InputMaybe<SortOrderInput>;
    procedureCode?: InputMaybe<SortOrderInput>;
    providerGroupId?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
};

export type NetworkValidationOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    groupName?: InputMaybe<SortOrderInput>;
    groupNumber?: InputMaybe<SortOrderInput>;
    hiosId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    insuranceType?: InputMaybe<SortOrderInput>;
    memberId?: InputMaybe<SortOrderInput>;
    network?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    payerId?: InputMaybe<SortOrder>;
    planLevel?: InputMaybe<SortOrderInput>;
    planName?: InputMaybe<SortOrderInput>;
    planNetworkname?: InputMaybe<SortOrderInput>;
    procedureCode?: InputMaybe<SortOrderInput>;
    providerGroupId?: InputMaybe<SortOrderInput>;
    state?: InputMaybe<SortOrderInput>;
};

export enum NetworkValidationScalarFieldEnum {
    CreatedAt = 'createdAt',
    GroupName = 'groupName',
    GroupNumber = 'groupNumber',
    HiosId = 'hiosId',
    Id = 'id',
    InsuranceType = 'insuranceType',
    MemberId = 'memberId',
    Network = 'network',
    Notes = 'notes',
    Npi = 'npi',
    OrgId = 'orgId',
    PayerId = 'payerId',
    PlanLevel = 'planLevel',
    PlanName = 'planName',
    PlanNetworkname = 'planNetworkname',
    ProcedureCode = 'procedureCode',
    ProviderGroupId = 'providerGroupId',
    State = 'state',
}

export type NetworkValidationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<NetworkValidationScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<NetworkValidationScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<NetworkValidationScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    groupName?: InputMaybe<StringNullableWithAggregatesFilter>;
    groupNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
    hiosId?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    insuranceType?: InputMaybe<StringNullableWithAggregatesFilter>;
    memberId?: InputMaybe<StringNullableWithAggregatesFilter>;
    network?: InputMaybe<EnumNetworkTypeWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableListFilter>;
    npi?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    payerId?: InputMaybe<IntWithAggregatesFilter>;
    planLevel?: InputMaybe<StringNullableWithAggregatesFilter>;
    planName?: InputMaybe<StringNullableWithAggregatesFilter>;
    planNetworkname?: InputMaybe<StringNullableWithAggregatesFilter>;
    procedureCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    providerGroupId?: InputMaybe<IntNullableWithAggregatesFilter>;
    state?: InputMaybe<EnumStateNullableWithAggregatesFilter>;
};

export type NetworkValidationSumAggregate = {
    __typename?: 'NetworkValidationSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type NetworkValidationSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type NetworkValidationUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    groupName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    groupNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hiosId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuranceType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    memberId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    network?: InputMaybe<EnumNetworkTypeFieldUpdateOperationsInput>;
    notes?: InputMaybe<NetworkValidationUpdatenotesInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    planLevel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planNetworkname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    procedureCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    providerGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableEnumStateFieldUpdateOperationsInput>;
};

export type NetworkValidationUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    groupName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    groupNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    hiosId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    insuranceType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    memberId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    network?: InputMaybe<EnumNetworkTypeFieldUpdateOperationsInput>;
    notes?: InputMaybe<NetworkValidationUpdatenotesInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    planLevel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    planNetworkname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    procedureCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    providerGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    state?: InputMaybe<NullableEnumStateFieldUpdateOperationsInput>;
};

export type NetworkValidationUpdatenotesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NetworkValidationWhereInput = {
    AND?: InputMaybe<Array<NetworkValidationWhereInput>>;
    NOT?: InputMaybe<Array<NetworkValidationWhereInput>>;
    OR?: InputMaybe<Array<NetworkValidationWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    groupName?: InputMaybe<StringNullableFilter>;
    groupNumber?: InputMaybe<StringNullableFilter>;
    hiosId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    insuranceType?: InputMaybe<StringNullableFilter>;
    memberId?: InputMaybe<StringNullableFilter>;
    network?: InputMaybe<EnumNetworkTypeFilter>;
    notes?: InputMaybe<StringNullableListFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    payerId?: InputMaybe<IntFilter>;
    planLevel?: InputMaybe<StringNullableFilter>;
    planName?: InputMaybe<StringNullableFilter>;
    planNetworkname?: InputMaybe<StringNullableFilter>;
    procedureCode?: InputMaybe<StringNullableFilter>;
    providerGroupId?: InputMaybe<IntNullableFilter>;
    state?: InputMaybe<EnumStateNullableFilter>;
};

export type NetworkValidationWhereUniqueInput = {
    AND?: InputMaybe<Array<NetworkValidationWhereInput>>;
    NOT?: InputMaybe<Array<NetworkValidationWhereInput>>;
    OR?: InputMaybe<Array<NetworkValidationWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    groupName?: InputMaybe<StringNullableFilter>;
    groupNumber?: InputMaybe<StringNullableFilter>;
    hiosId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    insuranceType?: InputMaybe<StringNullableFilter>;
    memberId?: InputMaybe<StringNullableFilter>;
    network?: InputMaybe<EnumNetworkTypeFilter>;
    notes?: InputMaybe<StringNullableListFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    payerId?: InputMaybe<IntFilter>;
    planLevel?: InputMaybe<StringNullableFilter>;
    planName?: InputMaybe<StringNullableFilter>;
    planNetworkname?: InputMaybe<StringNullableFilter>;
    procedureCode?: InputMaybe<StringNullableFilter>;
    providerGroupId?: InputMaybe<IntNullableFilter>;
    state?: InputMaybe<EnumStateNullableFilter>;
};

export type NetworkPlanExceptions = {
    __typename?: 'Network_plan_exceptions';
    id: Scalars['Int']['output'];
    ins_network?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    payer_id?: Maybe<Scalars['String']['output']>;
    plan_scope: Scalars['String']['output'];
    practice_id?: Maybe<Scalars['Int']['output']>;
    provider_group_id?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type NetworkPlanExceptionsAvgAggregate = {
    __typename?: 'Network_plan_exceptionsAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    org_id?: Maybe<Scalars['Float']['output']>;
    practice_id?: Maybe<Scalars['Float']['output']>;
    provider_group_id?: Maybe<Scalars['Float']['output']>;
};

export type NetworkPlanExceptionsAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrder>;
    provider_group_id?: InputMaybe<SortOrder>;
};

export type NetworkPlanExceptionsCountAggregate = {
    __typename?: 'Network_plan_exceptionsCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    ins_network: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    org_id: Scalars['Int']['output'];
    payer_id: Scalars['Int']['output'];
    plan_scope: Scalars['Int']['output'];
    practice_id: Scalars['Int']['output'];
    provider_group_id: Scalars['Int']['output'];
    value: Scalars['Int']['output'];
};

export type NetworkPlanExceptionsCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    ins_network?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    payer_id?: InputMaybe<SortOrder>;
    plan_scope?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrder>;
    provider_group_id?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type NetworkPlanExceptionsCreateInput = {
    ins_network?: InputMaybe<Scalars['String']['input']>;
    npi?: InputMaybe<Scalars['String']['input']>;
    org_id?: InputMaybe<Scalars['Int']['input']>;
    payer_id?: InputMaybe<Scalars['String']['input']>;
    plan_scope: Scalars['String']['input'];
    practice_id?: InputMaybe<Scalars['Int']['input']>;
    provider_group_id?: InputMaybe<Scalars['Int']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export type NetworkPlanExceptionsCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    ins_network?: InputMaybe<Scalars['String']['input']>;
    npi?: InputMaybe<Scalars['String']['input']>;
    org_id?: InputMaybe<Scalars['Int']['input']>;
    payer_id?: InputMaybe<Scalars['String']['input']>;
    plan_scope: Scalars['String']['input'];
    practice_id?: InputMaybe<Scalars['Int']['input']>;
    provider_group_id?: InputMaybe<Scalars['Int']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export type NetworkPlanExceptionsGroupBy = {
    __typename?: 'Network_plan_exceptionsGroupBy';
    _avg?: Maybe<NetworkPlanExceptionsAvgAggregate>;
    _count?: Maybe<NetworkPlanExceptionsCountAggregate>;
    _max?: Maybe<NetworkPlanExceptionsMaxAggregate>;
    _min?: Maybe<NetworkPlanExceptionsMinAggregate>;
    _sum?: Maybe<NetworkPlanExceptionsSumAggregate>;
    id: Scalars['Int']['output'];
    ins_network?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    payer_id?: Maybe<Scalars['String']['output']>;
    plan_scope: Scalars['String']['output'];
    practice_id?: Maybe<Scalars['Int']['output']>;
    provider_group_id?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type NetworkPlanExceptionsMaxAggregate = {
    __typename?: 'Network_plan_exceptionsMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    ins_network?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    payer_id?: Maybe<Scalars['String']['output']>;
    plan_scope?: Maybe<Scalars['String']['output']>;
    practice_id?: Maybe<Scalars['Int']['output']>;
    provider_group_id?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type NetworkPlanExceptionsMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    ins_network?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    payer_id?: InputMaybe<SortOrder>;
    plan_scope?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrder>;
    provider_group_id?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type NetworkPlanExceptionsMinAggregate = {
    __typename?: 'Network_plan_exceptionsMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    ins_network?: Maybe<Scalars['String']['output']>;
    npi?: Maybe<Scalars['String']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    payer_id?: Maybe<Scalars['String']['output']>;
    plan_scope?: Maybe<Scalars['String']['output']>;
    practice_id?: Maybe<Scalars['Int']['output']>;
    provider_group_id?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type NetworkPlanExceptionsMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    ins_network?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    payer_id?: InputMaybe<SortOrder>;
    plan_scope?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrder>;
    provider_group_id?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type NetworkPlanExceptionsOrderByWithAggregationInput = {
    _avg?: InputMaybe<NetworkPlanExceptionsAvgOrderByAggregateInput>;
    _count?: InputMaybe<NetworkPlanExceptionsCountOrderByAggregateInput>;
    _max?: InputMaybe<NetworkPlanExceptionsMaxOrderByAggregateInput>;
    _min?: InputMaybe<NetworkPlanExceptionsMinOrderByAggregateInput>;
    _sum?: InputMaybe<NetworkPlanExceptionsSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    ins_network?: InputMaybe<SortOrderInput>;
    npi?: InputMaybe<SortOrderInput>;
    org_id?: InputMaybe<SortOrderInput>;
    payer_id?: InputMaybe<SortOrderInput>;
    plan_scope?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrderInput>;
    provider_group_id?: InputMaybe<SortOrderInput>;
    value?: InputMaybe<SortOrderInput>;
};

export type NetworkPlanExceptionsOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    ins_network?: InputMaybe<SortOrderInput>;
    npi?: InputMaybe<SortOrderInput>;
    org_id?: InputMaybe<SortOrderInput>;
    payer_id?: InputMaybe<SortOrderInput>;
    plan_scope?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrderInput>;
    provider_group_id?: InputMaybe<SortOrderInput>;
    value?: InputMaybe<SortOrderInput>;
};

export enum NetworkPlanExceptionsScalarFieldEnum {
    Id = 'id',
    InsNetwork = 'ins_network',
    Npi = 'npi',
    OrgId = 'org_id',
    PayerId = 'payer_id',
    PlanScope = 'plan_scope',
    PracticeId = 'practice_id',
    ProviderGroupId = 'provider_group_id',
    Value = 'value',
}

export type NetworkPlanExceptionsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<NetworkPlanExceptionsScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<NetworkPlanExceptionsScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<NetworkPlanExceptionsScalarWhereWithAggregatesInput>>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    ins_network?: InputMaybe<StringNullableWithAggregatesFilter>;
    npi?: InputMaybe<StringNullableWithAggregatesFilter>;
    org_id?: InputMaybe<IntNullableWithAggregatesFilter>;
    payer_id?: InputMaybe<StringNullableWithAggregatesFilter>;
    plan_scope?: InputMaybe<StringWithAggregatesFilter>;
    practice_id?: InputMaybe<IntNullableWithAggregatesFilter>;
    provider_group_id?: InputMaybe<IntNullableWithAggregatesFilter>;
    value?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type NetworkPlanExceptionsSumAggregate = {
    __typename?: 'Network_plan_exceptionsSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    practice_id?: Maybe<Scalars['Int']['output']>;
    provider_group_id?: Maybe<Scalars['Int']['output']>;
};

export type NetworkPlanExceptionsSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    practice_id?: InputMaybe<SortOrder>;
    provider_group_id?: InputMaybe<SortOrder>;
};

export type NetworkPlanExceptionsUpdateInput = {
    ins_network?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    plan_scope?: InputMaybe<StringFieldUpdateOperationsInput>;
    practice_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    provider_group_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type NetworkPlanExceptionsUpdateManyMutationInput = {
    ins_network?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    plan_scope?: InputMaybe<StringFieldUpdateOperationsInput>;
    practice_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    provider_group_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type NetworkPlanExceptionsWhereInput = {
    AND?: InputMaybe<Array<NetworkPlanExceptionsWhereInput>>;
    NOT?: InputMaybe<Array<NetworkPlanExceptionsWhereInput>>;
    OR?: InputMaybe<Array<NetworkPlanExceptionsWhereInput>>;
    id?: InputMaybe<IntFilter>;
    ins_network?: InputMaybe<StringNullableFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    org_id?: InputMaybe<IntNullableFilter>;
    payer_id?: InputMaybe<StringNullableFilter>;
    plan_scope?: InputMaybe<StringFilter>;
    practice_id?: InputMaybe<IntNullableFilter>;
    provider_group_id?: InputMaybe<IntNullableFilter>;
    value?: InputMaybe<StringNullableFilter>;
};

export type NetworkPlanExceptionsWhereUniqueInput = {
    AND?: InputMaybe<Array<NetworkPlanExceptionsWhereInput>>;
    NOT?: InputMaybe<Array<NetworkPlanExceptionsWhereInput>>;
    OR?: InputMaybe<Array<NetworkPlanExceptionsWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    ins_network?: InputMaybe<StringNullableFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    org_id?: InputMaybe<IntNullableFilter>;
    payer_id?: InputMaybe<StringNullableFilter>;
    plan_scope?: InputMaybe<StringFilter>;
    practice_id?: InputMaybe<IntNullableFilter>;
    provider_group_id?: InputMaybe<IntNullableFilter>;
    value?: InputMaybe<StringNullableFilter>;
};

export enum NonCardRefundStatus {
    Cancelled = 'CANCELLED',
    Completed = 'COMPLETED',
    Pending = 'PENDING',
}

export type NonCardRefunds = {
    __typename?: 'NonCardRefunds';
    amount: Scalars['Decimal']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    dateCompleted?: Maybe<Scalars['DateTimeISO']['output']>;
    dateRequested: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    initiatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType: PaymentMethodType;
    resolvedBy?: Maybe<Scalars['String']['output']>;
    status: NonCardRefundStatus;
    transaction?: Maybe<Transaction>;
    transactionId: Scalars['String']['output'];
    userId: Scalars['String']['output'];
};

export type NonCardRefundsTransactionArgs = {
    where?: InputMaybe<TransactionWhereInput>;
};

export type NonCardRefundsAvgAggregate = {
    __typename?: 'NonCardRefundsAvgAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type NonCardRefundsAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type NonCardRefundsCountAggregate = {
    __typename?: 'NonCardRefundsCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    dateCompleted: Scalars['Int']['output'];
    dateRequested: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    initiatedBy: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentMethodType: Scalars['Int']['output'];
    resolvedBy: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    transactionId: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
};

export type NonCardRefundsCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    dateCompleted?: InputMaybe<SortOrder>;
    dateRequested?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    resolvedBy?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type NonCardRefundsCreateInput = {
    amount: Scalars['Decimal']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    dateCompleted?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateRequested: Scalars['DateTimeISO']['input'];
    initiatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentMethodType: PaymentMethodType;
    resolvedBy?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<NonCardRefundStatus>;
    transaction?: InputMaybe<TransactionCreateNestedOneWithoutNonCardRefundsInput>;
    userId: Scalars['String']['input'];
};

export type NonCardRefundsCreateManyInput = {
    amount: Scalars['Decimal']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    dateCompleted?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateRequested: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    initiatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentMethodType: PaymentMethodType;
    resolvedBy?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<NonCardRefundStatus>;
    transactionId: Scalars['String']['input'];
    userId: Scalars['String']['input'];
};

export type NonCardRefundsCreateManyTransactionInput = {
    amount: Scalars['Decimal']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    dateCompleted?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateRequested: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    initiatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentMethodType: PaymentMethodType;
    resolvedBy?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<NonCardRefundStatus>;
    userId: Scalars['String']['input'];
};

export type NonCardRefundsCreateManyTransactionInputEnvelope = {
    data: Array<NonCardRefundsCreateManyTransactionInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NonCardRefundsCreateNestedManyWithoutTransactionInput = {
    connect?: InputMaybe<Array<NonCardRefundsWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<NonCardRefundsCreateOrConnectWithoutTransactionInput>
    >;
    create?: InputMaybe<Array<NonCardRefundsCreateWithoutTransactionInput>>;
    createMany?: InputMaybe<NonCardRefundsCreateManyTransactionInputEnvelope>;
};

export type NonCardRefundsCreateOrConnectWithoutTransactionInput = {
    create: NonCardRefundsCreateWithoutTransactionInput;
    where: NonCardRefundsWhereUniqueInput;
};

export type NonCardRefundsCreateWithoutTransactionInput = {
    amount: Scalars['Decimal']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    dateCompleted?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dateRequested: Scalars['DateTimeISO']['input'];
    initiatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentMethodType: PaymentMethodType;
    resolvedBy?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<NonCardRefundStatus>;
    userId: Scalars['String']['input'];
};

export type NonCardRefundsGroupBy = {
    __typename?: 'NonCardRefundsGroupBy';
    _avg?: Maybe<NonCardRefundsAvgAggregate>;
    _count?: Maybe<NonCardRefundsCountAggregate>;
    _max?: Maybe<NonCardRefundsMaxAggregate>;
    _min?: Maybe<NonCardRefundsMinAggregate>;
    _sum?: Maybe<NonCardRefundsSumAggregate>;
    amount: Scalars['Decimal']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    dateCompleted?: Maybe<Scalars['DateTimeISO']['output']>;
    dateRequested: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    initiatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType: PaymentMethodType;
    resolvedBy?: Maybe<Scalars['String']['output']>;
    status: NonCardRefundStatus;
    transactionId: Scalars['String']['output'];
    userId: Scalars['String']['output'];
};

export type NonCardRefundsListRelationFilter = {
    every?: InputMaybe<NonCardRefundsWhereInput>;
    none?: InputMaybe<NonCardRefundsWhereInput>;
    some?: InputMaybe<NonCardRefundsWhereInput>;
};

export type NonCardRefundsMaxAggregate = {
    __typename?: 'NonCardRefundsMaxAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    dateCompleted?: Maybe<Scalars['DateTimeISO']['output']>;
    dateRequested?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    initiatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    resolvedBy?: Maybe<Scalars['String']['output']>;
    status?: Maybe<NonCardRefundStatus>;
    transactionId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type NonCardRefundsMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    dateCompleted?: InputMaybe<SortOrder>;
    dateRequested?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    resolvedBy?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type NonCardRefundsMinAggregate = {
    __typename?: 'NonCardRefundsMinAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    dateCompleted?: Maybe<Scalars['DateTimeISO']['output']>;
    dateRequested?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    initiatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    resolvedBy?: Maybe<Scalars['String']['output']>;
    status?: Maybe<NonCardRefundStatus>;
    transactionId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type NonCardRefundsMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    dateCompleted?: InputMaybe<SortOrder>;
    dateRequested?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    resolvedBy?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type NonCardRefundsOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type NonCardRefundsOrderByWithAggregationInput = {
    _avg?: InputMaybe<NonCardRefundsAvgOrderByAggregateInput>;
    _count?: InputMaybe<NonCardRefundsCountOrderByAggregateInput>;
    _max?: InputMaybe<NonCardRefundsMaxOrderByAggregateInput>;
    _min?: InputMaybe<NonCardRefundsMinOrderByAggregateInput>;
    _sum?: InputMaybe<NonCardRefundsSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrderInput>;
    dateCompleted?: InputMaybe<SortOrderInput>;
    dateRequested?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    paymentMethodType?: InputMaybe<SortOrder>;
    resolvedBy?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type NonCardRefundsOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrderInput>;
    dateCompleted?: InputMaybe<SortOrderInput>;
    dateRequested?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    paymentMethodType?: InputMaybe<SortOrder>;
    resolvedBy?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    transaction?: InputMaybe<TransactionOrderByWithRelationInput>;
    transactionId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export enum NonCardRefundsScalarFieldEnum {
    Amount = 'amount',
    ConsumerId = 'consumerId',
    DateCompleted = 'dateCompleted',
    DateRequested = 'dateRequested',
    Id = 'id',
    InitiatedBy = 'initiatedBy',
    OrgId = 'orgId',
    PaymentMethodType = 'paymentMethodType',
    ResolvedBy = 'resolvedBy',
    Status = 'status',
    TransactionId = 'transactionId',
    UserId = 'userId',
}

export type NonCardRefundsScalarWhereInput = {
    AND?: InputMaybe<Array<NonCardRefundsScalarWhereInput>>;
    NOT?: InputMaybe<Array<NonCardRefundsScalarWhereInput>>;
    OR?: InputMaybe<Array<NonCardRefundsScalarWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    dateCompleted?: InputMaybe<DateTimeNullableFilter>;
    dateRequested?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    initiatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeFilter>;
    resolvedBy?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumNonCardRefundStatusFilter>;
    transactionId?: InputMaybe<StringFilter>;
    userId?: InputMaybe<StringFilter>;
};

export type NonCardRefundsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<NonCardRefundsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<NonCardRefundsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<NonCardRefundsScalarWhereWithAggregatesInput>>;
    amount?: InputMaybe<DecimalWithAggregatesFilter>;
    consumerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    dateCompleted?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    dateRequested?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    initiatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeWithAggregatesFilter>;
    resolvedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumNonCardRefundStatusWithAggregatesFilter>;
    transactionId?: InputMaybe<StringWithAggregatesFilter>;
    userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type NonCardRefundsSumAggregate = {
    __typename?: 'NonCardRefundsSumAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type NonCardRefundsSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type NonCardRefundsUpdateInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    dateCompleted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateRequested?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeFieldUpdateOperationsInput>;
    resolvedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumNonCardRefundStatusFieldUpdateOperationsInput>;
    transaction?: InputMaybe<TransactionUpdateOneWithoutNonCardRefundsNestedInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonCardRefundsUpdateManyMutationInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    dateCompleted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateRequested?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeFieldUpdateOperationsInput>;
    resolvedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumNonCardRefundStatusFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonCardRefundsUpdateManyWithWhereWithoutTransactionInput = {
    data: NonCardRefundsUpdateManyMutationInput;
    where: NonCardRefundsScalarWhereInput;
};

export type NonCardRefundsUpdateManyWithoutTransactionNestedInput = {
    connect?: InputMaybe<Array<NonCardRefundsWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<NonCardRefundsCreateOrConnectWithoutTransactionInput>
    >;
    create?: InputMaybe<Array<NonCardRefundsCreateWithoutTransactionInput>>;
    createMany?: InputMaybe<NonCardRefundsCreateManyTransactionInputEnvelope>;
    delete?: InputMaybe<Array<NonCardRefundsWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<NonCardRefundsScalarWhereInput>>;
    disconnect?: InputMaybe<Array<NonCardRefundsWhereUniqueInput>>;
    set?: InputMaybe<Array<NonCardRefundsWhereUniqueInput>>;
    update?: InputMaybe<
        Array<NonCardRefundsUpdateWithWhereUniqueWithoutTransactionInput>
    >;
    updateMany?: InputMaybe<
        Array<NonCardRefundsUpdateManyWithWhereWithoutTransactionInput>
    >;
    upsert?: InputMaybe<
        Array<NonCardRefundsUpsertWithWhereUniqueWithoutTransactionInput>
    >;
};

export type NonCardRefundsUpdateWithWhereUniqueWithoutTransactionInput = {
    data: NonCardRefundsUpdateWithoutTransactionInput;
    where: NonCardRefundsWhereUniqueInput;
};

export type NonCardRefundsUpdateWithoutTransactionInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    dateCompleted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    dateRequested?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeFieldUpdateOperationsInput>;
    resolvedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumNonCardRefundStatusFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonCardRefundsUpsertWithWhereUniqueWithoutTransactionInput = {
    create: NonCardRefundsCreateWithoutTransactionInput;
    update: NonCardRefundsUpdateWithoutTransactionInput;
    where: NonCardRefundsWhereUniqueInput;
};

export type NonCardRefundsWhereInput = {
    AND?: InputMaybe<Array<NonCardRefundsWhereInput>>;
    NOT?: InputMaybe<Array<NonCardRefundsWhereInput>>;
    OR?: InputMaybe<Array<NonCardRefundsWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    dateCompleted?: InputMaybe<DateTimeNullableFilter>;
    dateRequested?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    initiatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeFilter>;
    resolvedBy?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumNonCardRefundStatusFilter>;
    transaction?: InputMaybe<TransactionNullableRelationFilter>;
    transactionId?: InputMaybe<StringFilter>;
    userId?: InputMaybe<StringFilter>;
};

export type NonCardRefundsWhereUniqueInput = {
    AND?: InputMaybe<Array<NonCardRefundsWhereInput>>;
    NOT?: InputMaybe<Array<NonCardRefundsWhereInput>>;
    OR?: InputMaybe<Array<NonCardRefundsWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    dateCompleted?: InputMaybe<DateTimeNullableFilter>;
    dateRequested?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    initiatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeFilter>;
    resolvedBy?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumNonCardRefundStatusFilter>;
    transaction?: InputMaybe<TransactionNullableRelationFilter>;
    transactionId?: InputMaybe<StringFilter>;
    userId?: InputMaybe<StringFilter>;
};

export type NullableBoolFieldUpdateOperationsInput = {
    set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
    set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NullableDecimalFieldUpdateOperationsInput = {
    decrement?: InputMaybe<Scalars['Decimal']['input']>;
    divide?: InputMaybe<Scalars['Decimal']['input']>;
    increment?: InputMaybe<Scalars['Decimal']['input']>;
    multiply?: InputMaybe<Scalars['Decimal']['input']>;
    set?: InputMaybe<Scalars['Decimal']['input']>;
};

export type NullableEnumAirStatusCodeFieldUpdateOperationsInput = {
    set?: InputMaybe<AirStatusCode>;
};

export type NullableEnumAdjudicationActionEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<AdjudicationActionEnum>;
};

export type NullableEnumAdjudicationAppliedStatusEnumFieldUpdateOperationsInput =
    {
        set?: InputMaybe<AdjudicationAppliedStatusEnum>;
    };

export type NullableEnumAdjudicationPaymentMethodEnumFieldUpdateOperationsInput =
    {
        set?: InputMaybe<AdjudicationPaymentMethodEnum>;
    };

export type NullableEnumAdjustmentAckActionEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<AdjustmentAckActionEnum>;
};

export type NullableEnumAdjustmentAckRoleEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<AdjustmentAckRoleEnum>;
};

export type NullableEnumAdjustmentAppliedStatusEnumFieldUpdateOperationsInput =
    {
        set?: InputMaybe<AdjustmentAppliedStatusEnum>;
    };

export type NullableEnumAdjustmentTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<AdjustmentTypeEnum>;
};

export type NullableEnumAmountTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<AmountType>;
};

export type NullableEnumArtClaimStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<ArtClaimStatusEnum>;
};

export type NullableEnumBoughtTreatmentKindFieldUpdateOperationsInput = {
    set?: InputMaybe<BoughtTreatmentKind>;
};

export type NullableEnumBoughtTreatmentStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<BoughtTreatmentStatusEnum>;
};

export type NullableEnumConfigCommitStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<ConfigCommitStatus>;
};

export type NullableEnumCoverageSourceFieldUpdateOperationsInput = {
    set?: InputMaybe<CoverageSource>;
};

export type NullableEnumClaimReturnStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<ClaimReturnStatusEnum>;
};

export type NullableEnumConsumerAccountStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<ConsumerAccountStatus>;
};

export type NullableEnumContractAccountStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<ContractAccountStatus>;
};

export type NullableEnumContractStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<ContractStatus>;
};

export type NullableEnumContractTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<ContractType>;
};

export type NullableEnumCptRelationTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<CptRelationType>;
};

export type NullableEnumDayOfWeekEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<DayOfWeekEnum>;
};

export type NullableEnumEhrPaymentDescriptorStatusEnumFieldUpdateOperationsInput =
    {
        set?: InputMaybe<EhrPaymentDescriptorStatusEnum>;
    };

export type NullableEnumEhrPaymentLockTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrPaymentLockTypeEnum>;
};

export type NullableEnumEhrPostIdentifierTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrPostIdentifierTypeEnum>;
};

export type NullableEnumEhrPostLedgerSourceEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrPostLedgerSourceEnum>;
};

export type NullableEnumEhrPostStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrPostStatusEnum>;
};

export type NullableEnumEhrSlotStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrSlotStatusEnum>;
};

export type NullableEnumEhrTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EhrTypeEnum>;
};

export type NullableEnumEmergencyContactRelationshipFieldUpdateOperationsInput =
    {
        set?: InputMaybe<EmergencyContactRelationship>;
    };

export type NullableEnumEmploymentStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<EmploymentStatus>;
};

export type NullableEnumEncounterSourceEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<EncounterSourceEnum>;
};

export type NullableEnumEthnicityFieldUpdateOperationsInput = {
    set?: InputMaybe<Ethnicity>;
};

export type NullableEnumFeeUnitFieldUpdateOperationsInput = {
    set?: InputMaybe<FeeUnit>;
};

export type NullableEnumFeesAndPayoutsProcessingStatusEnumFieldUpdateOperationsInput =
    {
        set?: InputMaybe<FeesAndPayoutsProcessingStatusEnum>;
    };

export type NullableEnumInsuranceAccountStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<InsuranceAccountStatus>;
};

export type NullableEnumKioskHrtTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<KioskHrtType>;
};

export type NullableEnumLinkTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<LinkType>;
};

export type NullableEnumLanguageCodeFieldUpdateOperationsInput = {
    set?: InputMaybe<LanguageCode>;
};

export type NullableEnumLiveTransferActionEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<LiveTransferActionEnum>;
};

export type NullableEnumLiveTransferStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<LiveTransferStatusEnum>;
};

export type NullableEnumMaritalStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<MaritalStatus>;
};

export type NullableEnumMcmsAdjudicationVersionFieldUpdateOperationsInput = {
    set?: InputMaybe<McmsAdjudicationVersion>;
};

export type NullableEnumMcmsReversalActionFieldUpdateOperationsInput = {
    set?: InputMaybe<McmsReversalAction>;
};

export type NullableEnumMessageStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<MessageStatus>;
};

export type NullableEnumPayerTagFieldUpdateOperationsInput = {
    set?: InputMaybe<PayerTag>;
};

export type NullableEnumPropagationTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PropagationType>;
};

export type NullableEnumPayLaterAuthorizationStatusFieldUpdateOperationsInput =
    {
        set?: InputMaybe<PayLaterAuthorizationStatus>;
    };

export type NullableEnumPaymentAuthorizationConsentTypeFieldUpdateOperationsInput =
    {
        set?: InputMaybe<PaymentAuthorizationConsentType>;
    };

export type NullableEnumPaymentContractEndReasonFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentContractEndReason>;
};

export type NullableEnumPaymentContractOpenedViaFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentContractOpenedVia>;
};

export type NullableEnumPaymentMethodTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentMethodType>;
};

export type NullableEnumPaymentPlanAdjustmentStatusFieldUpdateOperationsInput =
    {
        set?: InputMaybe<PaymentPlanAdjustmentStatus>;
    };

export type NullableEnumPaymentPlanAutoChargeStatusFieldUpdateOperationsInput =
    {
        set?: InputMaybe<PaymentPlanAutoChargeStatus>;
    };

export type NullableEnumPaymentPlanBoughtTreatmentClaimStageFieldUpdateOperationsInput =
    {
        set?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
    };

export type NullableEnumPaymentPlanBoughtTreatmentStatusFieldUpdateOperationsInput =
    {
        set?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    };

export type NullableEnumPaymentPlanChargeModeFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanChargeMode>;
};

export type NullableEnumPaymentPlanFrequencyFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanFrequency>;
};

export type NullableEnumPaymentPlanInitiatedByFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanInitiatedBy>;
};

export type NullableEnumPaymentPlanStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanStatus>;
};

export type NullableEnumPaymentPlanTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentPlanType>;
};

export type NullableEnumPaymentTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentTypeEnum>;
};

export type NullableEnumPaymentTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PaymentType>;
};

export type NullableEnumPayoutReferencePaymentTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<PayoutReferencePaymentType>;
};

export type NullableEnumPriceSwapReasonEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<PriceSwapReasonEnum>;
};

export type NullableEnumRequestSourceFieldUpdateOperationsInput = {
    set?: InputMaybe<RequestSource>;
};

export type NullableEnumRequestTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<RequestType>;
};

export type NullableEnumReattributionStateFieldUpdateOperationsInput = {
    set?: InputMaybe<ReattributionState>;
};

export type NullableEnumRevenueTypeFieldUpdateOperationsInput = {
    set?: InputMaybe<RevenueType>;
};

export type NullableEnumReviewStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<ReviewStatusEnum>;
};

export type NullableEnumServiceFieldUpdateOperationsInput = {
    set?: InputMaybe<Service>;
};

export type NullableEnumStateFieldUpdateOperationsInput = {
    set?: InputMaybe<State>;
};

export type NullableEnumSlotStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<SlotStatusEnum>;
};

export type NullableEnumSlotTypeEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<SlotTypeEnum>;
};

export type NullableEnumTimeBlockCategoryEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<TimeBlockCategoryEnum>;
};

export type NullableEnumUserAccountStatusFieldUpdateOperationsInput = {
    set?: InputMaybe<UserAccountStatus>;
};

export type NullableEnumVerificationSourceFieldUpdateOperationsInput = {
    set?: InputMaybe<VerificationSource>;
};

export type NullableEnumVirtualDayOfReminderFieldUpdateOperationsInput = {
    set?: InputMaybe<VirtualDayOfReminder>;
};

export type NullableEnuminsurancesStatusEnumFieldUpdateOperationsInput = {
    set?: InputMaybe<InsurancesStatusEnum>;
};

export type NullableFloatFieldUpdateOperationsInput = {
    decrement?: InputMaybe<Scalars['Float']['input']>;
    divide?: InputMaybe<Scalars['Float']['input']>;
    increment?: InputMaybe<Scalars['Float']['input']>;
    multiply?: InputMaybe<Scalars['Float']['input']>;
    set?: InputMaybe<Scalars['Float']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
    decrement?: InputMaybe<Scalars['Int']['input']>;
    divide?: InputMaybe<Scalars['Int']['input']>;
    increment?: InputMaybe<Scalars['Int']['input']>;
    multiply?: InputMaybe<Scalars['Int']['input']>;
    set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
    set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
    First = 'first',
    Last = 'last',
}

export type OrgConfigFlag = {
    __typename?: 'OrgConfigFlag';
    createdAt: Scalars['DateTimeISO']['output'];
    flag: ConfigFlag;
    flagName: Scalars['String']['output'];
    isEnabled: Scalars['Boolean']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrgConfigFlagAvgAggregate = {
    __typename?: 'OrgConfigFlagAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type OrgConfigFlagAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type OrgConfigFlagCountAggregate = {
    __typename?: 'OrgConfigFlagCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    flagName: Scalars['Int']['output'];
    isEnabled: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type OrgConfigFlagCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    flagName?: InputMaybe<SortOrder>;
    isEnabled?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrgConfigFlagCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    flag: ConfigFlagCreateNestedOneWithoutOrgFlagsInput;
    isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    org: OrganizationCreateNestedOneWithoutOrgConfigFlagInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrgConfigFlagCreateManyFlagInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrgConfigFlagCreateManyFlagInputEnvelope = {
    data: Array<OrgConfigFlagCreateManyFlagInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrgConfigFlagCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    flagName: Scalars['String']['input'];
    isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrgConfigFlagCreateManyOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    flagName: Scalars['String']['input'];
    isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrgConfigFlagCreateManyOrgInputEnvelope = {
    data: Array<OrgConfigFlagCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrgConfigFlagCreateNestedManyWithoutFlagInput = {
    connect?: InputMaybe<Array<OrgConfigFlagWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<OrgConfigFlagCreateOrConnectWithoutFlagInput>
    >;
    create?: InputMaybe<Array<OrgConfigFlagCreateWithoutFlagInput>>;
    createMany?: InputMaybe<OrgConfigFlagCreateManyFlagInputEnvelope>;
};

export type OrgConfigFlagCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<OrgConfigFlagWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<OrgConfigFlagCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<OrgConfigFlagCreateWithoutOrgInput>>;
    createMany?: InputMaybe<OrgConfigFlagCreateManyOrgInputEnvelope>;
};

export type OrgConfigFlagCreateOrConnectWithoutFlagInput = {
    create: OrgConfigFlagCreateWithoutFlagInput;
    where: OrgConfigFlagWhereUniqueInput;
};

export type OrgConfigFlagCreateOrConnectWithoutOrgInput = {
    create: OrgConfigFlagCreateWithoutOrgInput;
    where: OrgConfigFlagWhereUniqueInput;
};

export type OrgConfigFlagCreateWithoutFlagInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    org: OrganizationCreateNestedOneWithoutOrgConfigFlagInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrgConfigFlagCreateWithoutOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    flag: ConfigFlagCreateNestedOneWithoutOrgFlagsInput;
    isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrgConfigFlagGroupBy = {
    __typename?: 'OrgConfigFlagGroupBy';
    _avg?: Maybe<OrgConfigFlagAvgAggregate>;
    _count?: Maybe<OrgConfigFlagCountAggregate>;
    _max?: Maybe<OrgConfigFlagMaxAggregate>;
    _min?: Maybe<OrgConfigFlagMinAggregate>;
    _sum?: Maybe<OrgConfigFlagSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    flagName: Scalars['String']['output'];
    isEnabled: Scalars['Boolean']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrgConfigFlagListRelationFilter = {
    every?: InputMaybe<OrgConfigFlagWhereInput>;
    none?: InputMaybe<OrgConfigFlagWhereInput>;
    some?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type OrgConfigFlagMaxAggregate = {
    __typename?: 'OrgConfigFlagMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    flagName?: Maybe<Scalars['String']['output']>;
    isEnabled?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrgConfigFlagMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    flagName?: InputMaybe<SortOrder>;
    isEnabled?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrgConfigFlagMinAggregate = {
    __typename?: 'OrgConfigFlagMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    flagName?: Maybe<Scalars['String']['output']>;
    isEnabled?: Maybe<Scalars['Boolean']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrgConfigFlagMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    flagName?: InputMaybe<SortOrder>;
    isEnabled?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrgConfigFlagOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type OrgConfigFlagOrderByWithAggregationInput = {
    _avg?: InputMaybe<OrgConfigFlagAvgOrderByAggregateInput>;
    _count?: InputMaybe<OrgConfigFlagCountOrderByAggregateInput>;
    _max?: InputMaybe<OrgConfigFlagMaxOrderByAggregateInput>;
    _min?: InputMaybe<OrgConfigFlagMinOrderByAggregateInput>;
    _sum?: InputMaybe<OrgConfigFlagSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    flagName?: InputMaybe<SortOrder>;
    isEnabled?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrgConfigFlagOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    flag?: InputMaybe<ConfigFlagOrderByWithRelationInput>;
    flagName?: InputMaybe<SortOrder>;
    isEnabled?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrgConfigFlagOrgIdFlagNameCompoundUniqueInput = {
    flagName: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
};

export type OrgConfigFlagOrgIdFlagNameUniqueCompoundUniqueInput = {
    flagName: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
};

export enum OrgConfigFlagScalarFieldEnum {
    CreatedAt = 'createdAt',
    FlagName = 'flagName',
    IsEnabled = 'isEnabled',
    OrgId = 'orgId',
    UpdatedAt = 'updatedAt',
}

export type OrgConfigFlagScalarWhereInput = {
    AND?: InputMaybe<Array<OrgConfigFlagScalarWhereInput>>;
    NOT?: InputMaybe<Array<OrgConfigFlagScalarWhereInput>>;
    OR?: InputMaybe<Array<OrgConfigFlagScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    flagName?: InputMaybe<StringFilter>;
    isEnabled?: InputMaybe<BoolFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrgConfigFlagScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<OrgConfigFlagScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<OrgConfigFlagScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<OrgConfigFlagScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    flagName?: InputMaybe<StringWithAggregatesFilter>;
    isEnabled?: InputMaybe<BoolWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type OrgConfigFlagSumAggregate = {
    __typename?: 'OrgConfigFlagSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type OrgConfigFlagSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type OrgConfigFlagUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    flag?: InputMaybe<ConfigFlagUpdateOneRequiredWithoutOrgFlagsNestedInput>;
    isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutOrgConfigFlagNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrgConfigFlagUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrgConfigFlagUpdateManyWithWhereWithoutFlagInput = {
    data: OrgConfigFlagUpdateManyMutationInput;
    where: OrgConfigFlagScalarWhereInput;
};

export type OrgConfigFlagUpdateManyWithWhereWithoutOrgInput = {
    data: OrgConfigFlagUpdateManyMutationInput;
    where: OrgConfigFlagScalarWhereInput;
};

export type OrgConfigFlagUpdateManyWithoutFlagNestedInput = {
    connect?: InputMaybe<Array<OrgConfigFlagWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<OrgConfigFlagCreateOrConnectWithoutFlagInput>
    >;
    create?: InputMaybe<Array<OrgConfigFlagCreateWithoutFlagInput>>;
    createMany?: InputMaybe<OrgConfigFlagCreateManyFlagInputEnvelope>;
    delete?: InputMaybe<Array<OrgConfigFlagWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<OrgConfigFlagScalarWhereInput>>;
    disconnect?: InputMaybe<Array<OrgConfigFlagWhereUniqueInput>>;
    set?: InputMaybe<Array<OrgConfigFlagWhereUniqueInput>>;
    update?: InputMaybe<
        Array<OrgConfigFlagUpdateWithWhereUniqueWithoutFlagInput>
    >;
    updateMany?: InputMaybe<
        Array<OrgConfigFlagUpdateManyWithWhereWithoutFlagInput>
    >;
    upsert?: InputMaybe<
        Array<OrgConfigFlagUpsertWithWhereUniqueWithoutFlagInput>
    >;
};

export type OrgConfigFlagUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<OrgConfigFlagWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<OrgConfigFlagCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<OrgConfigFlagCreateWithoutOrgInput>>;
    createMany?: InputMaybe<OrgConfigFlagCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<OrgConfigFlagWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<OrgConfigFlagScalarWhereInput>>;
    disconnect?: InputMaybe<Array<OrgConfigFlagWhereUniqueInput>>;
    set?: InputMaybe<Array<OrgConfigFlagWhereUniqueInput>>;
    update?: InputMaybe<
        Array<OrgConfigFlagUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<OrgConfigFlagUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<OrgConfigFlagUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type OrgConfigFlagUpdateWithWhereUniqueWithoutFlagInput = {
    data: OrgConfigFlagUpdateWithoutFlagInput;
    where: OrgConfigFlagWhereUniqueInput;
};

export type OrgConfigFlagUpdateWithWhereUniqueWithoutOrgInput = {
    data: OrgConfigFlagUpdateWithoutOrgInput;
    where: OrgConfigFlagWhereUniqueInput;
};

export type OrgConfigFlagUpdateWithoutFlagInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutOrgConfigFlagNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrgConfigFlagUpdateWithoutOrgInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    flag?: InputMaybe<ConfigFlagUpdateOneRequiredWithoutOrgFlagsNestedInput>;
    isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrgConfigFlagUpsertWithWhereUniqueWithoutFlagInput = {
    create: OrgConfigFlagCreateWithoutFlagInput;
    update: OrgConfigFlagUpdateWithoutFlagInput;
    where: OrgConfigFlagWhereUniqueInput;
};

export type OrgConfigFlagUpsertWithWhereUniqueWithoutOrgInput = {
    create: OrgConfigFlagCreateWithoutOrgInput;
    update: OrgConfigFlagUpdateWithoutOrgInput;
    where: OrgConfigFlagWhereUniqueInput;
};

export type OrgConfigFlagWhereInput = {
    AND?: InputMaybe<Array<OrgConfigFlagWhereInput>>;
    NOT?: InputMaybe<Array<OrgConfigFlagWhereInput>>;
    OR?: InputMaybe<Array<OrgConfigFlagWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    flag?: InputMaybe<ConfigFlagRelationFilter>;
    flagName?: InputMaybe<StringFilter>;
    isEnabled?: InputMaybe<BoolFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrgConfigFlagWhereUniqueInput = {
    AND?: InputMaybe<Array<OrgConfigFlagWhereInput>>;
    NOT?: InputMaybe<Array<OrgConfigFlagWhereInput>>;
    OR?: InputMaybe<Array<OrgConfigFlagWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    flag?: InputMaybe<ConfigFlagRelationFilter>;
    flagName?: InputMaybe<StringFilter>;
    isEnabled?: InputMaybe<BoolFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgId_flagName?: InputMaybe<OrgConfigFlagOrgIdFlagNameCompoundUniqueInput>;
    org_id_flag_name_unique?: InputMaybe<OrgConfigFlagOrgIdFlagNameUniqueCompoundUniqueInput>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrgHrtSrtRule = {
    __typename?: 'OrgHrtSrtRule';
    checkDeductibleExists?: Maybe<Scalars['Boolean']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    forcePCP?: Maybe<Scalars['Boolean']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    isSpecialistRelated?: Maybe<Scalars['Boolean']['output']>;
    lookForEmptyPayerNotes?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    primarySTC?: Maybe<Scalars['String']['output']>;
    secondarySTCs: Array<Scalars['String']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zeroPatientObligation?: Maybe<Scalars['Boolean']['output']>;
};

export type OrgHrtSrtRuleAvgAggregate = {
    __typename?: 'OrgHrtSrtRuleAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    srtId?: Maybe<Scalars['Float']['output']>;
};

export type OrgHrtSrtRuleAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type OrgHrtSrtRuleCountAggregate = {
    __typename?: 'OrgHrtSrtRuleCountAggregate';
    _all: Scalars['Int']['output'];
    checkDeductibleExists: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    forcePCP: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    isSpecialistRelated: Scalars['Int']['output'];
    lookForEmptyPayerNotes: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    primarySTC: Scalars['Int']['output'];
    secondarySTCs: Scalars['Int']['output'];
    srtId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    zeroPatientObligation: Scalars['Int']['output'];
};

export type OrgHrtSrtRuleCountOrderByAggregateInput = {
    checkDeductibleExists?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    forcePCP?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isSpecialistRelated?: InputMaybe<SortOrder>;
    lookForEmptyPayerNotes?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    primarySTC?: InputMaybe<SortOrder>;
    secondarySTCs?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zeroPatientObligation?: InputMaybe<SortOrder>;
};

export type OrgHrtSrtRuleCreateInput = {
    checkDeductibleExists?: InputMaybe<Scalars['Boolean']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    forcePCP?: InputMaybe<Scalars['Boolean']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    isSpecialistRelated?: InputMaybe<Scalars['Boolean']['input']>;
    lookForEmptyPayerNotes?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    primarySTC?: InputMaybe<Scalars['String']['input']>;
    secondarySTCs?: InputMaybe<OrgHrtSrtRuleCreatesecondaryStCsInput>;
    srtId?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zeroPatientObligation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrgHrtSrtRuleCreateManyInput = {
    checkDeductibleExists?: InputMaybe<Scalars['Boolean']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    forcePCP?: InputMaybe<Scalars['Boolean']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    isSpecialistRelated?: InputMaybe<Scalars['Boolean']['input']>;
    lookForEmptyPayerNotes?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    primarySTC?: InputMaybe<Scalars['String']['input']>;
    secondarySTCs?: InputMaybe<OrgHrtSrtRuleCreatesecondaryStCsInput>;
    srtId?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    zeroPatientObligation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrgHrtSrtRuleCreatesecondaryStCsInput = {
    set: Array<Scalars['String']['input']>;
};

export type OrgHrtSrtRuleGroupBy = {
    __typename?: 'OrgHrtSrtRuleGroupBy';
    _avg?: Maybe<OrgHrtSrtRuleAvgAggregate>;
    _count?: Maybe<OrgHrtSrtRuleCountAggregate>;
    _max?: Maybe<OrgHrtSrtRuleMaxAggregate>;
    _min?: Maybe<OrgHrtSrtRuleMinAggregate>;
    _sum?: Maybe<OrgHrtSrtRuleSumAggregate>;
    checkDeductibleExists?: Maybe<Scalars['Boolean']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    forcePCP?: Maybe<Scalars['Boolean']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    isSpecialistRelated?: Maybe<Scalars['Boolean']['output']>;
    lookForEmptyPayerNotes?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    primarySTC?: Maybe<Scalars['String']['output']>;
    secondarySTCs?: Maybe<Array<Scalars['String']['output']>>;
    srtId?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    zeroPatientObligation?: Maybe<Scalars['Boolean']['output']>;
};

export type OrgHrtSrtRuleMaxAggregate = {
    __typename?: 'OrgHrtSrtRuleMaxAggregate';
    checkDeductibleExists?: Maybe<Scalars['Boolean']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    forcePCP?: Maybe<Scalars['Boolean']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    isSpecialistRelated?: Maybe<Scalars['Boolean']['output']>;
    lookForEmptyPayerNotes?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    primarySTC?: Maybe<Scalars['String']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zeroPatientObligation?: Maybe<Scalars['Boolean']['output']>;
};

export type OrgHrtSrtRuleMaxOrderByAggregateInput = {
    checkDeductibleExists?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    forcePCP?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isSpecialistRelated?: InputMaybe<SortOrder>;
    lookForEmptyPayerNotes?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    primarySTC?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zeroPatientObligation?: InputMaybe<SortOrder>;
};

export type OrgHrtSrtRuleMinAggregate = {
    __typename?: 'OrgHrtSrtRuleMinAggregate';
    checkDeductibleExists?: Maybe<Scalars['Boolean']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    forcePCP?: Maybe<Scalars['Boolean']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    isSpecialistRelated?: Maybe<Scalars['Boolean']['output']>;
    lookForEmptyPayerNotes?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    primarySTC?: Maybe<Scalars['String']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    zeroPatientObligation?: Maybe<Scalars['Boolean']['output']>;
};

export type OrgHrtSrtRuleMinOrderByAggregateInput = {
    checkDeductibleExists?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    forcePCP?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isSpecialistRelated?: InputMaybe<SortOrder>;
    lookForEmptyPayerNotes?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    primarySTC?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    zeroPatientObligation?: InputMaybe<SortOrder>;
};

export type OrgHrtSrtRuleOrderByWithAggregationInput = {
    _avg?: InputMaybe<OrgHrtSrtRuleAvgOrderByAggregateInput>;
    _count?: InputMaybe<OrgHrtSrtRuleCountOrderByAggregateInput>;
    _max?: InputMaybe<OrgHrtSrtRuleMaxOrderByAggregateInput>;
    _min?: InputMaybe<OrgHrtSrtRuleMinOrderByAggregateInput>;
    _sum?: InputMaybe<OrgHrtSrtRuleSumOrderByAggregateInput>;
    checkDeductibleExists?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    forcePCP?: InputMaybe<SortOrderInput>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isSpecialistRelated?: InputMaybe<SortOrderInput>;
    lookForEmptyPayerNotes?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    primarySTC?: InputMaybe<SortOrderInput>;
    secondarySTCs?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zeroPatientObligation?: InputMaybe<SortOrderInput>;
};

export type OrgHrtSrtRuleOrderByWithRelationInput = {
    checkDeductibleExists?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    forcePCP?: InputMaybe<SortOrderInput>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    isSpecialistRelated?: InputMaybe<SortOrderInput>;
    lookForEmptyPayerNotes?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    primarySTC?: InputMaybe<SortOrderInput>;
    secondarySTCs?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    zeroPatientObligation?: InputMaybe<SortOrderInput>;
};

export enum OrgHrtSrtRuleScalarFieldEnum {
    CheckDeductibleExists = 'checkDeductibleExists',
    CreatedAt = 'createdAt',
    ForcePcp = 'forcePCP',
    HrtId = 'hrtId',
    Id = 'id',
    IsActive = 'isActive',
    IsSpecialistRelated = 'isSpecialistRelated',
    LookForEmptyPayerNotes = 'lookForEmptyPayerNotes',
    Notes = 'notes',
    OrgId = 'orgId',
    PrimaryStc = 'primarySTC',
    SecondaryStCs = 'secondarySTCs',
    SrtId = 'srtId',
    UpdatedAt = 'updatedAt',
    ZeroPatientObligation = 'zeroPatientObligation',
}

export type OrgHrtSrtRuleScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<OrgHrtSrtRuleScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<OrgHrtSrtRuleScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<OrgHrtSrtRuleScalarWhereWithAggregatesInput>>;
    checkDeductibleExists?: InputMaybe<BoolNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    forcePCP?: InputMaybe<BoolNullableWithAggregatesFilter>;
    hrtId?: InputMaybe<IntNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    isSpecialistRelated?: InputMaybe<BoolNullableWithAggregatesFilter>;
    lookForEmptyPayerNotes?: InputMaybe<BoolNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    primarySTC?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondarySTCs?: InputMaybe<StringNullableListFilter>;
    srtId?: InputMaybe<IntNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    zeroPatientObligation?: InputMaybe<BoolNullableWithAggregatesFilter>;
};

export type OrgHrtSrtRuleSumAggregate = {
    __typename?: 'OrgHrtSrtRuleSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
};

export type OrgHrtSrtRuleSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type OrgHrtSrtRuleUpdateInput = {
    checkDeductibleExists?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    forcePCP?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isSpecialistRelated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lookForEmptyPayerNotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    primarySTC?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondarySTCs?: InputMaybe<OrgHrtSrtRuleUpdatesecondaryStCsInput>;
    srtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zeroPatientObligation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type OrgHrtSrtRuleUpdateManyMutationInput = {
    checkDeductibleExists?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    forcePCP?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isSpecialistRelated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lookForEmptyPayerNotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    primarySTC?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondarySTCs?: InputMaybe<OrgHrtSrtRuleUpdatesecondaryStCsInput>;
    srtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    zeroPatientObligation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type OrgHrtSrtRuleUpdatesecondaryStCsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrgHrtSrtRuleWhereInput = {
    AND?: InputMaybe<Array<OrgHrtSrtRuleWhereInput>>;
    NOT?: InputMaybe<Array<OrgHrtSrtRuleWhereInput>>;
    OR?: InputMaybe<Array<OrgHrtSrtRuleWhereInput>>;
    checkDeductibleExists?: InputMaybe<BoolNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    forcePCP?: InputMaybe<BoolNullableFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    isSpecialistRelated?: InputMaybe<BoolNullableFilter>;
    lookForEmptyPayerNotes?: InputMaybe<BoolNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    primarySTC?: InputMaybe<StringNullableFilter>;
    secondarySTCs?: InputMaybe<StringNullableListFilter>;
    srtId?: InputMaybe<IntNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zeroPatientObligation?: InputMaybe<BoolNullableFilter>;
};

export type OrgHrtSrtRuleWhereUniqueInput = {
    AND?: InputMaybe<Array<OrgHrtSrtRuleWhereInput>>;
    NOT?: InputMaybe<Array<OrgHrtSrtRuleWhereInput>>;
    OR?: InputMaybe<Array<OrgHrtSrtRuleWhereInput>>;
    checkDeductibleExists?: InputMaybe<BoolNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    forcePCP?: InputMaybe<BoolNullableFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<BoolFilter>;
    isSpecialistRelated?: InputMaybe<BoolNullableFilter>;
    lookForEmptyPayerNotes?: InputMaybe<BoolNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    primarySTC?: InputMaybe<StringNullableFilter>;
    secondarySTCs?: InputMaybe<StringNullableListFilter>;
    srtId?: InputMaybe<IntNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    zeroPatientObligation?: InputMaybe<BoolNullableFilter>;
};

export type OrgNetworkResults = {
    __typename?: 'OrgNetworkResults';
    date: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    latency: Scalars['Int']['output'];
    results: Scalars['String']['output'];
};

export type OrgNetworkResultsAvgAggregate = {
    __typename?: 'OrgNetworkResultsAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    latency?: Maybe<Scalars['Float']['output']>;
};

export type OrgNetworkResultsAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
};

export type OrgNetworkResultsCountAggregate = {
    __typename?: 'OrgNetworkResultsCountAggregate';
    _all: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    latency: Scalars['Int']['output'];
    results: Scalars['Int']['output'];
};

export type OrgNetworkResultsCountOrderByAggregateInput = {
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
};

export type OrgNetworkResultsCreateInput = {
    date: Scalars['DateTimeISO']['input'];
    latency: Scalars['Int']['input'];
    results: Scalars['String']['input'];
};

export type OrgNetworkResultsCreateManyInput = {
    date: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    latency: Scalars['Int']['input'];
    results: Scalars['String']['input'];
};

export type OrgNetworkResultsGroupBy = {
    __typename?: 'OrgNetworkResultsGroupBy';
    _avg?: Maybe<OrgNetworkResultsAvgAggregate>;
    _count?: Maybe<OrgNetworkResultsCountAggregate>;
    _max?: Maybe<OrgNetworkResultsMaxAggregate>;
    _min?: Maybe<OrgNetworkResultsMinAggregate>;
    _sum?: Maybe<OrgNetworkResultsSumAggregate>;
    date: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    latency: Scalars['Int']['output'];
    results: Scalars['String']['output'];
};

export type OrgNetworkResultsMaxAggregate = {
    __typename?: 'OrgNetworkResultsMaxAggregate';
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    results?: Maybe<Scalars['String']['output']>;
};

export type OrgNetworkResultsMaxOrderByAggregateInput = {
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
};

export type OrgNetworkResultsMinAggregate = {
    __typename?: 'OrgNetworkResultsMinAggregate';
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    results?: Maybe<Scalars['String']['output']>;
};

export type OrgNetworkResultsMinOrderByAggregateInput = {
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
};

export type OrgNetworkResultsOrderByWithAggregationInput = {
    _avg?: InputMaybe<OrgNetworkResultsAvgOrderByAggregateInput>;
    _count?: InputMaybe<OrgNetworkResultsCountOrderByAggregateInput>;
    _max?: InputMaybe<OrgNetworkResultsMaxOrderByAggregateInput>;
    _min?: InputMaybe<OrgNetworkResultsMinOrderByAggregateInput>;
    _sum?: InputMaybe<OrgNetworkResultsSumOrderByAggregateInput>;
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
};

export type OrgNetworkResultsOrderByWithRelationInput = {
    date?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
};

export enum OrgNetworkResultsScalarFieldEnum {
    Date = 'date',
    Id = 'id',
    Latency = 'latency',
    Results = 'results',
}

export type OrgNetworkResultsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<OrgNetworkResultsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<OrgNetworkResultsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<OrgNetworkResultsScalarWhereWithAggregatesInput>>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    latency?: InputMaybe<IntWithAggregatesFilter>;
    results?: InputMaybe<StringWithAggregatesFilter>;
};

export type OrgNetworkResultsSumAggregate = {
    __typename?: 'OrgNetworkResultsSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
};

export type OrgNetworkResultsSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
};

export type OrgNetworkResultsUpdateInput = {
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    latency?: InputMaybe<IntFieldUpdateOperationsInput>;
    results?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrgNetworkResultsUpdateManyMutationInput = {
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    latency?: InputMaybe<IntFieldUpdateOperationsInput>;
    results?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrgNetworkResultsWhereInput = {
    AND?: InputMaybe<Array<OrgNetworkResultsWhereInput>>;
    NOT?: InputMaybe<Array<OrgNetworkResultsWhereInput>>;
    OR?: InputMaybe<Array<OrgNetworkResultsWhereInput>>;
    date?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    latency?: InputMaybe<IntFilter>;
    results?: InputMaybe<StringFilter>;
};

export type OrgNetworkResultsWhereUniqueInput = {
    AND?: InputMaybe<Array<OrgNetworkResultsWhereInput>>;
    NOT?: InputMaybe<Array<OrgNetworkResultsWhereInput>>;
    OR?: InputMaybe<Array<OrgNetworkResultsWhereInput>>;
    date?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    latency?: InputMaybe<IntFilter>;
    results?: InputMaybe<StringFilter>;
};

export type OrgOverrideRule = {
    __typename?: 'OrgOverrideRule';
    claimMatchingConfig?: Maybe<Scalars['JSON']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    excludeFromBCBS: Scalars['Boolean']['output'];
    excludeFromMedicaid: Scalars['Boolean']['output'];
    excludeNPIs: Array<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrgOverrideRuleAvgAggregate = {
    __typename?: 'OrgOverrideRuleAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type OrgOverrideRuleAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type OrgOverrideRuleCountAggregate = {
    __typename?: 'OrgOverrideRuleCountAggregate';
    _all: Scalars['Int']['output'];
    claimMatchingConfig: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    excludeFromBCBS: Scalars['Int']['output'];
    excludeFromMedicaid: Scalars['Int']['output'];
    excludeNPIs: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type OrgOverrideRuleCountOrderByAggregateInput = {
    claimMatchingConfig?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    excludeFromBCBS?: InputMaybe<SortOrder>;
    excludeFromMedicaid?: InputMaybe<SortOrder>;
    excludeNPIs?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrgOverrideRuleCreateInput = {
    claimMatchingConfig?: InputMaybe<Scalars['JSON']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    excludeFromBCBS?: InputMaybe<Scalars['Boolean']['input']>;
    excludeFromMedicaid?: InputMaybe<Scalars['Boolean']['input']>;
    excludeNPIs?: InputMaybe<OrgOverrideRuleCreateexcludeNpIsInput>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrgOverrideRuleCreateManyInput = {
    claimMatchingConfig?: InputMaybe<Scalars['JSON']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    excludeFromBCBS?: InputMaybe<Scalars['Boolean']['input']>;
    excludeFromMedicaid?: InputMaybe<Scalars['Boolean']['input']>;
    excludeNPIs?: InputMaybe<OrgOverrideRuleCreateexcludeNpIsInput>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrgOverrideRuleCreateexcludeNpIsInput = {
    set: Array<Scalars['String']['input']>;
};

export type OrgOverrideRuleGroupBy = {
    __typename?: 'OrgOverrideRuleGroupBy';
    _avg?: Maybe<OrgOverrideRuleAvgAggregate>;
    _count?: Maybe<OrgOverrideRuleCountAggregate>;
    _max?: Maybe<OrgOverrideRuleMaxAggregate>;
    _min?: Maybe<OrgOverrideRuleMinAggregate>;
    _sum?: Maybe<OrgOverrideRuleSumAggregate>;
    claimMatchingConfig?: Maybe<Scalars['JSON']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    excludeFromBCBS: Scalars['Boolean']['output'];
    excludeFromMedicaid: Scalars['Boolean']['output'];
    excludeNPIs?: Maybe<Array<Scalars['String']['output']>>;
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrgOverrideRuleMaxAggregate = {
    __typename?: 'OrgOverrideRuleMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    excludeFromBCBS?: Maybe<Scalars['Boolean']['output']>;
    excludeFromMedicaid?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrgOverrideRuleMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    excludeFromBCBS?: InputMaybe<SortOrder>;
    excludeFromMedicaid?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrgOverrideRuleMinAggregate = {
    __typename?: 'OrgOverrideRuleMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    excludeFromBCBS?: Maybe<Scalars['Boolean']['output']>;
    excludeFromMedicaid?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrgOverrideRuleMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    excludeFromBCBS?: InputMaybe<SortOrder>;
    excludeFromMedicaid?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrgOverrideRuleOrderByWithAggregationInput = {
    _avg?: InputMaybe<OrgOverrideRuleAvgOrderByAggregateInput>;
    _count?: InputMaybe<OrgOverrideRuleCountOrderByAggregateInput>;
    _max?: InputMaybe<OrgOverrideRuleMaxOrderByAggregateInput>;
    _min?: InputMaybe<OrgOverrideRuleMinOrderByAggregateInput>;
    _sum?: InputMaybe<OrgOverrideRuleSumOrderByAggregateInput>;
    claimMatchingConfig?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    excludeFromBCBS?: InputMaybe<SortOrder>;
    excludeFromMedicaid?: InputMaybe<SortOrder>;
    excludeNPIs?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrgOverrideRuleOrderByWithRelationInput = {
    claimMatchingConfig?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    excludeFromBCBS?: InputMaybe<SortOrder>;
    excludeFromMedicaid?: InputMaybe<SortOrder>;
    excludeNPIs?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum OrgOverrideRuleScalarFieldEnum {
    ClaimMatchingConfig = 'claimMatchingConfig',
    CreatedAt = 'createdAt',
    ExcludeFromBcbs = 'excludeFromBCBS',
    ExcludeFromMedicaid = 'excludeFromMedicaid',
    ExcludeNpIs = 'excludeNPIs',
    Id = 'id',
    IsActive = 'isActive',
    Notes = 'notes',
    OrgId = 'orgId',
    UpdatedAt = 'updatedAt',
}

export type OrgOverrideRuleScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<OrgOverrideRuleScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<OrgOverrideRuleScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<OrgOverrideRuleScalarWhereWithAggregatesInput>>;
    claimMatchingConfig?: InputMaybe<JsonNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    excludeFromBCBS?: InputMaybe<BoolWithAggregatesFilter>;
    excludeFromMedicaid?: InputMaybe<BoolWithAggregatesFilter>;
    excludeNPIs?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type OrgOverrideRuleSumAggregate = {
    __typename?: 'OrgOverrideRuleSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type OrgOverrideRuleSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type OrgOverrideRuleUpdateInput = {
    claimMatchingConfig?: InputMaybe<Scalars['JSON']['input']>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    excludeFromBCBS?: InputMaybe<BoolFieldUpdateOperationsInput>;
    excludeFromMedicaid?: InputMaybe<BoolFieldUpdateOperationsInput>;
    excludeNPIs?: InputMaybe<OrgOverrideRuleUpdateexcludeNpIsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrgOverrideRuleUpdateManyMutationInput = {
    claimMatchingConfig?: InputMaybe<Scalars['JSON']['input']>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    excludeFromBCBS?: InputMaybe<BoolFieldUpdateOperationsInput>;
    excludeFromMedicaid?: InputMaybe<BoolFieldUpdateOperationsInput>;
    excludeNPIs?: InputMaybe<OrgOverrideRuleUpdateexcludeNpIsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrgOverrideRuleUpdateexcludeNpIsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrgOverrideRuleWhereInput = {
    AND?: InputMaybe<Array<OrgOverrideRuleWhereInput>>;
    NOT?: InputMaybe<Array<OrgOverrideRuleWhereInput>>;
    OR?: InputMaybe<Array<OrgOverrideRuleWhereInput>>;
    claimMatchingConfig?: InputMaybe<JsonNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    excludeFromBCBS?: InputMaybe<BoolFilter>;
    excludeFromMedicaid?: InputMaybe<BoolFilter>;
    excludeNPIs?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrgOverrideRuleWhereUniqueInput = {
    AND?: InputMaybe<Array<OrgOverrideRuleWhereInput>>;
    NOT?: InputMaybe<Array<OrgOverrideRuleWhereInput>>;
    OR?: InputMaybe<Array<OrgOverrideRuleWhereInput>>;
    claimMatchingConfig?: InputMaybe<JsonNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    excludeFromBCBS?: InputMaybe<BoolFilter>;
    excludeFromMedicaid?: InputMaybe<BoolFilter>;
    excludeNPIs?: InputMaybe<StringNullableListFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<BoolFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrgFees = {
    __typename?: 'Org_fees';
    cash_transaction_fee: Scalars['Decimal']['output'];
    id: Scalars['Int']['output'];
    insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type OrgFeesAvgAggregate = {
    __typename?: 'Org_feesAvgAggregate';
    cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type OrgFeesAvgOrderByAggregateInput = {
    cash_transaction_fee?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insured_transaction_fee?: InputMaybe<SortOrder>;
    minimum_cash_transaction_fee?: InputMaybe<SortOrder>;
    minimum_insured_transaction_fee?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type OrgFeesCountAggregate = {
    __typename?: 'Org_feesCountAggregate';
    _all: Scalars['Int']['output'];
    cash_transaction_fee: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    insured_transaction_fee: Scalars['Int']['output'];
    minimum_cash_transaction_fee: Scalars['Int']['output'];
    minimum_insured_transaction_fee: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
};

export type OrgFeesCountOrderByAggregateInput = {
    cash_transaction_fee?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insured_transaction_fee?: InputMaybe<SortOrder>;
    minimum_cash_transaction_fee?: InputMaybe<SortOrder>;
    minimum_insured_transaction_fee?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type OrgFeesCreateInput = {
    cash_transaction_fee: Scalars['Decimal']['input'];
    insured_transaction_fee?: InputMaybe<Scalars['Decimal']['input']>;
    minimum_cash_transaction_fee?: InputMaybe<Scalars['Decimal']['input']>;
    minimum_insured_transaction_fee?: InputMaybe<Scalars['Decimal']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgFeesCreateManyInput = {
    cash_transaction_fee: Scalars['Decimal']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    insured_transaction_fee?: InputMaybe<Scalars['Decimal']['input']>;
    minimum_cash_transaction_fee?: InputMaybe<Scalars['Decimal']['input']>;
    minimum_insured_transaction_fee?: InputMaybe<Scalars['Decimal']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgFeesGroupBy = {
    __typename?: 'Org_feesGroupBy';
    _avg?: Maybe<OrgFeesAvgAggregate>;
    _count?: Maybe<OrgFeesCountAggregate>;
    _max?: Maybe<OrgFeesMaxAggregate>;
    _min?: Maybe<OrgFeesMinAggregate>;
    _sum?: Maybe<OrgFeesSumAggregate>;
    cash_transaction_fee: Scalars['Decimal']['output'];
    id: Scalars['Int']['output'];
    insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type OrgFeesMaxAggregate = {
    __typename?: 'Org_feesMaxAggregate';
    cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type OrgFeesMaxOrderByAggregateInput = {
    cash_transaction_fee?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insured_transaction_fee?: InputMaybe<SortOrder>;
    minimum_cash_transaction_fee?: InputMaybe<SortOrder>;
    minimum_insured_transaction_fee?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type OrgFeesMinAggregate = {
    __typename?: 'Org_feesMinAggregate';
    cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type OrgFeesMinOrderByAggregateInput = {
    cash_transaction_fee?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insured_transaction_fee?: InputMaybe<SortOrder>;
    minimum_cash_transaction_fee?: InputMaybe<SortOrder>;
    minimum_insured_transaction_fee?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type OrgFeesOrderByWithAggregationInput = {
    _avg?: InputMaybe<OrgFeesAvgOrderByAggregateInput>;
    _count?: InputMaybe<OrgFeesCountOrderByAggregateInput>;
    _max?: InputMaybe<OrgFeesMaxOrderByAggregateInput>;
    _min?: InputMaybe<OrgFeesMinOrderByAggregateInput>;
    _sum?: InputMaybe<OrgFeesSumOrderByAggregateInput>;
    cash_transaction_fee?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insured_transaction_fee?: InputMaybe<SortOrderInput>;
    minimum_cash_transaction_fee?: InputMaybe<SortOrderInput>;
    minimum_insured_transaction_fee?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
};

export type OrgFeesOrderByWithRelationInput = {
    cash_transaction_fee?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insured_transaction_fee?: InputMaybe<SortOrderInput>;
    minimum_cash_transaction_fee?: InputMaybe<SortOrderInput>;
    minimum_insured_transaction_fee?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
};

export enum OrgFeesScalarFieldEnum {
    CashTransactionFee = 'cash_transaction_fee',
    Id = 'id',
    InsuredTransactionFee = 'insured_transaction_fee',
    MinimumCashTransactionFee = 'minimum_cash_transaction_fee',
    MinimumInsuredTransactionFee = 'minimum_insured_transaction_fee',
    OrgId = 'orgId',
}

export type OrgFeesScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<OrgFeesScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<OrgFeesScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<OrgFeesScalarWhereWithAggregatesInput>>;
    cash_transaction_fee?: InputMaybe<DecimalWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    insured_transaction_fee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    minimum_cash_transaction_fee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    minimum_insured_transaction_fee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type OrgFeesSumAggregate = {
    __typename?: 'Org_feesSumAggregate';
    cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_cash_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    minimum_insured_transaction_fee?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type OrgFeesSumOrderByAggregateInput = {
    cash_transaction_fee?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    insured_transaction_fee?: InputMaybe<SortOrder>;
    minimum_cash_transaction_fee?: InputMaybe<SortOrder>;
    minimum_insured_transaction_fee?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type OrgFeesUpdateInput = {
    cash_transaction_fee?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    insured_transaction_fee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    minimum_cash_transaction_fee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    minimum_insured_transaction_fee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrgFeesUpdateManyMutationInput = {
    cash_transaction_fee?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    insured_transaction_fee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    minimum_cash_transaction_fee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    minimum_insured_transaction_fee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrgFeesWhereInput = {
    AND?: InputMaybe<Array<OrgFeesWhereInput>>;
    NOT?: InputMaybe<Array<OrgFeesWhereInput>>;
    OR?: InputMaybe<Array<OrgFeesWhereInput>>;
    cash_transaction_fee?: InputMaybe<DecimalFilter>;
    id?: InputMaybe<IntFilter>;
    insured_transaction_fee?: InputMaybe<DecimalNullableFilter>;
    minimum_cash_transaction_fee?: InputMaybe<DecimalNullableFilter>;
    minimum_insured_transaction_fee?: InputMaybe<DecimalNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
};

export type OrgFeesWhereUniqueInput = {
    AND?: InputMaybe<Array<OrgFeesWhereInput>>;
    NOT?: InputMaybe<Array<OrgFeesWhereInput>>;
    OR?: InputMaybe<Array<OrgFeesWhereInput>>;
    cash_transaction_fee?: InputMaybe<DecimalFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    insured_transaction_fee?: InputMaybe<DecimalNullableFilter>;
    minimum_cash_transaction_fee?: InputMaybe<DecimalNullableFilter>;
    minimum_insured_transaction_fee?: InputMaybe<DecimalNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
};

/** The underlying table does not contain a valid unique identifier and can therefore currently not be handled by Prisma Client. */
export type OrgStripeMapping = {
    __typename?: 'Org_stripe_mapping';
    orgId: Scalars['Int']['output'];
    passThroughStripeFee: Scalars['Boolean']['output'];
    stripe_account_id: Scalars['String']['output'];
    stripe_customer_id?: Maybe<Scalars['String']['output']>;
};

export type OrgStripeMappingAvgAggregate = {
    __typename?: 'Org_stripe_mappingAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type OrgStripeMappingAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type OrgStripeMappingCountAggregate = {
    __typename?: 'Org_stripe_mappingCountAggregate';
    _all: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    passThroughStripeFee: Scalars['Int']['output'];
    stripe_account_id: Scalars['Int']['output'];
    stripe_customer_id: Scalars['Int']['output'];
};

export type OrgStripeMappingCountOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    passThroughStripeFee?: InputMaybe<SortOrder>;
    stripe_account_id?: InputMaybe<SortOrder>;
    stripe_customer_id?: InputMaybe<SortOrder>;
};

export type OrgStripeMappingCreateInput = {
    orgId: Scalars['Int']['input'];
    passThroughStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
    stripe_account_id: Scalars['String']['input'];
    stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
};

export type OrgStripeMappingCreateManyInput = {
    orgId: Scalars['Int']['input'];
    passThroughStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
    stripe_account_id: Scalars['String']['input'];
    stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
};

export type OrgStripeMappingGroupBy = {
    __typename?: 'Org_stripe_mappingGroupBy';
    _avg?: Maybe<OrgStripeMappingAvgAggregate>;
    _count?: Maybe<OrgStripeMappingCountAggregate>;
    _max?: Maybe<OrgStripeMappingMaxAggregate>;
    _min?: Maybe<OrgStripeMappingMinAggregate>;
    _sum?: Maybe<OrgStripeMappingSumAggregate>;
    orgId: Scalars['Int']['output'];
    passThroughStripeFee: Scalars['Boolean']['output'];
    stripe_account_id: Scalars['String']['output'];
    stripe_customer_id?: Maybe<Scalars['String']['output']>;
};

export type OrgStripeMappingMaxAggregate = {
    __typename?: 'Org_stripe_mappingMaxAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    passThroughStripeFee?: Maybe<Scalars['Boolean']['output']>;
    stripe_account_id?: Maybe<Scalars['String']['output']>;
    stripe_customer_id?: Maybe<Scalars['String']['output']>;
};

export type OrgStripeMappingMaxOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    passThroughStripeFee?: InputMaybe<SortOrder>;
    stripe_account_id?: InputMaybe<SortOrder>;
    stripe_customer_id?: InputMaybe<SortOrder>;
};

export type OrgStripeMappingMinAggregate = {
    __typename?: 'Org_stripe_mappingMinAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    passThroughStripeFee?: Maybe<Scalars['Boolean']['output']>;
    stripe_account_id?: Maybe<Scalars['String']['output']>;
    stripe_customer_id?: Maybe<Scalars['String']['output']>;
};

export type OrgStripeMappingMinOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    passThroughStripeFee?: InputMaybe<SortOrder>;
    stripe_account_id?: InputMaybe<SortOrder>;
    stripe_customer_id?: InputMaybe<SortOrder>;
};

export type OrgStripeMappingOrderByWithAggregationInput = {
    _avg?: InputMaybe<OrgStripeMappingAvgOrderByAggregateInput>;
    _count?: InputMaybe<OrgStripeMappingCountOrderByAggregateInput>;
    _max?: InputMaybe<OrgStripeMappingMaxOrderByAggregateInput>;
    _min?: InputMaybe<OrgStripeMappingMinOrderByAggregateInput>;
    _sum?: InputMaybe<OrgStripeMappingSumOrderByAggregateInput>;
    orgId?: InputMaybe<SortOrder>;
    passThroughStripeFee?: InputMaybe<SortOrder>;
    stripe_account_id?: InputMaybe<SortOrder>;
    stripe_customer_id?: InputMaybe<SortOrderInput>;
};

export type OrgStripeMappingOrderByWithRelationInput = {
    orgId?: InputMaybe<SortOrder>;
    passThroughStripeFee?: InputMaybe<SortOrder>;
    stripe_account_id?: InputMaybe<SortOrder>;
    stripe_customer_id?: InputMaybe<SortOrderInput>;
};

export enum OrgStripeMappingScalarFieldEnum {
    OrgId = 'orgId',
    PassThroughStripeFee = 'passThroughStripeFee',
    StripeAccountId = 'stripe_account_id',
    StripeCustomerId = 'stripe_customer_id',
}

export type OrgStripeMappingScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<OrgStripeMappingScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<OrgStripeMappingScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<OrgStripeMappingScalarWhereWithAggregatesInput>>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    passThroughStripeFee?: InputMaybe<BoolWithAggregatesFilter>;
    stripe_account_id?: InputMaybe<StringWithAggregatesFilter>;
    stripe_customer_id?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type OrgStripeMappingSumAggregate = {
    __typename?: 'Org_stripe_mappingSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type OrgStripeMappingSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type OrgStripeMappingUpdateInput = {
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    passThroughStripeFee?: InputMaybe<BoolFieldUpdateOperationsInput>;
    stripe_account_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    stripe_customer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrgStripeMappingUpdateManyMutationInput = {
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    passThroughStripeFee?: InputMaybe<BoolFieldUpdateOperationsInput>;
    stripe_account_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    stripe_customer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrgStripeMappingWhereInput = {
    AND?: InputMaybe<Array<OrgStripeMappingWhereInput>>;
    NOT?: InputMaybe<Array<OrgStripeMappingWhereInput>>;
    OR?: InputMaybe<Array<OrgStripeMappingWhereInput>>;
    orgId?: InputMaybe<IntFilter>;
    passThroughStripeFee?: InputMaybe<BoolFilter>;
    stripe_account_id?: InputMaybe<StringFilter>;
    stripe_customer_id?: InputMaybe<StringNullableFilter>;
};

export type OrgStripeMappingWhereUniqueInput = {
    AND?: InputMaybe<Array<OrgStripeMappingWhereInput>>;
    NOT?: InputMaybe<Array<OrgStripeMappingWhereInput>>;
    OR?: InputMaybe<Array<OrgStripeMappingWhereInput>>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    passThroughStripeFee?: InputMaybe<BoolFilter>;
    stripe_account_id?: InputMaybe<StringFilter>;
    stripe_customer_id?: InputMaybe<StringNullableFilter>;
};

export type Organization = {
    __typename?: 'Organization';
    Bundle: Array<Bundle>;
    DeploymentOrgPhase: Array<DeploymentOrgPhase>;
    DeploymentOrgTask: Array<DeploymentOrgTask>;
    EcwPayerAlias: Array<EcwPayerAlias>;
    EcwPayerStc: Array<EcwPayerStc>;
    EhrProviderMapping: Array<EhrProviderMapping>;
    Hrt: Array<Hrt>;
    OrgConfigFlag: Array<OrgConfigFlag>;
    OrganizationAssets?: Maybe<OrganizationAssets>;
    PayerToEhrInsurancePackage: Array<PayerToEhrInsurancePackageMapping>;
    ProductCategories: Array<ProductCategories>;
    Products: Array<Products>;
    _count?: Maybe<OrganizationCount>;
    abeCustomerName: Scalars['String']['output'];
    artOrgConfig?: Maybe<ArtOrgConfig>;
    claimsHistorySource?: Maybe<Scalars['String']['output']>;
    configCommits: Array<ConfigCommit>;
    defaultPractices: Array<DefaultPractice>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrProviderGroupIds: Array<Scalars['Int']['output']>;
    ehrType: EhrType;
    ein: Scalars['String']['output'];
    facebookPixelId?: Maybe<Scalars['String']['output']>;
    googleAnalyticsTag?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    idpRedirect?: Maybe<Scalars['String']['output']>;
    intakeFormSections: Array<IntakeFormSection>;
    intakeForms: Array<IntakeForm>;
    intakeQuestions: Array<IntakeQuestion>;
    metadata: Scalars['JSON']['output'];
    orgName: Scalars['String']['output'];
    orgTitle: Scalars['String']['output'];
    organizationTranslations: Array<OrganizationTranslation>;
    patientPylonAccountId?: Maybe<Scalars['String']['output']>;
    practices: Array<Practice>;
    providerToOrgs: Array<ProviderToOrg>;
    pylonAccountId?: Maybe<Scalars['String']['output']>;
    renderConfig: Scalars['JSON']['output'];
    schedulingTimeWindow: Scalars['Int']['output'];
    schedulingType: SchedulingType;
    storefrontEligibilityAllowedStates: Array<State>;
    storefrontEligibilityMinimumAge?: Maybe<Scalars['Int']['output']>;
    supportedLanguages: Array<Scalars['String']['output']>;
    waitingRoomPin: Scalars['String']['output'];
};

export type OrganizationBundleArgs = {
    cursor?: InputMaybe<BundleWhereUniqueInput>;
    distinct?: InputMaybe<Array<BundleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BundleOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleWhereInput>;
};

export type OrganizationDeploymentOrgPhaseArgs = {
    cursor?: InputMaybe<DeploymentOrgPhaseWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgPhaseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgPhaseOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type OrganizationDeploymentOrgTaskArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgTaskOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type OrganizationEcwPayerAliasArgs = {
    cursor?: InputMaybe<EcwPayerAliasWhereUniqueInput>;
    distinct?: InputMaybe<Array<EcwPayerAliasScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EcwPayerAliasOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerAliasWhereInput>;
};

export type OrganizationEcwPayerStcArgs = {
    cursor?: InputMaybe<EcwPayerStcWhereUniqueInput>;
    distinct?: InputMaybe<Array<EcwPayerStcScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EcwPayerStcOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerStcWhereInput>;
};

export type OrganizationEhrProviderMappingArgs = {
    cursor?: InputMaybe<EhrProviderMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrProviderMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrProviderMappingOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrProviderMappingWhereInput>;
};

export type OrganizationHrtArgs = {
    cursor?: InputMaybe<HrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtWhereInput>;
};

export type OrganizationOrgConfigFlagArgs = {
    cursor?: InputMaybe<OrgConfigFlagWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgConfigFlagScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgConfigFlagOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type OrganizationOrganizationAssetsArgs = {
    where?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type OrganizationPayerToEhrInsurancePackageArgs = {
    cursor?: InputMaybe<PayerToEhrInsurancePackageMappingWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type OrganizationProductCategoriesArgs = {
    cursor?: InputMaybe<ProductCategoriesWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductCategoriesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductCategoriesOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoriesWhereInput>;
};

export type OrganizationProductsArgs = {
    cursor?: InputMaybe<ProductsWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductsWhereInput>;
};

export type OrganizationArtOrgConfigArgs = {
    where?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type OrganizationConfigCommitsArgs = {
    cursor?: InputMaybe<ConfigCommitWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigCommitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigCommitOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type OrganizationDefaultPracticesArgs = {
    cursor?: InputMaybe<DefaultPracticeWhereUniqueInput>;
    distinct?: InputMaybe<Array<DefaultPracticeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DefaultPracticeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type OrganizationIntakeFormSectionsArgs = {
    cursor?: InputMaybe<IntakeFormSectionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormSectionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormSectionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type OrganizationIntakeFormsArgs = {
    cursor?: InputMaybe<IntakeFormWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type OrganizationIntakeQuestionsArgs = {
    cursor?: InputMaybe<IntakeQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeQuestionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type OrganizationOrganizationTranslationsArgs = {
    cursor?: InputMaybe<OrganizationTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrganizationTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<OrganizationTranslationOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationTranslationWhereInput>;
};

export type OrganizationPracticesArgs = {
    cursor?: InputMaybe<PracticeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeWhereInput>;
};

export type OrganizationProviderToOrgsArgs = {
    cursor?: InputMaybe<ProviderToOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderToOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderToOrgOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type OrganizationAssets = {
    __typename?: 'OrganizationAssets';
    darkModeLogo?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    iconLogo?: Maybe<Scalars['String']['output']>;
    lightModeLogo?: Maybe<Scalars['String']['output']>;
    org: Organization;
    orgId: Scalars['Int']['output'];
    phoneNumber?: Maybe<Scalars['String']['output']>;
    primaryBackgroundColor?: Maybe<Scalars['String']['output']>;
    primaryColor?: Maybe<Scalars['String']['output']>;
    secondaryBackgroundColor?: Maybe<Scalars['String']['output']>;
    secondaryColor?: Maybe<Scalars['String']['output']>;
    seoDescription?: Maybe<Scalars['String']['output']>;
    seoImageUrl?: Maybe<Scalars['String']['output']>;
    seoTitle?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAssetsAvgAggregate = {
    __typename?: 'OrganizationAssetsAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationAssetsAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type OrganizationAssetsCountAggregate = {
    __typename?: 'OrganizationAssetsCountAggregate';
    _all: Scalars['Int']['output'];
    darkModeLogo: Scalars['Int']['output'];
    email: Scalars['Int']['output'];
    iconLogo: Scalars['Int']['output'];
    lightModeLogo: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    phoneNumber: Scalars['Int']['output'];
    primaryBackgroundColor: Scalars['Int']['output'];
    primaryColor: Scalars['Int']['output'];
    secondaryBackgroundColor: Scalars['Int']['output'];
    secondaryColor: Scalars['Int']['output'];
    seoDescription: Scalars['Int']['output'];
    seoImageUrl: Scalars['Int']['output'];
    seoTitle: Scalars['Int']['output'];
};

export type OrganizationAssetsCountOrderByAggregateInput = {
    darkModeLogo?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    iconLogo?: InputMaybe<SortOrder>;
    lightModeLogo?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    primaryBackgroundColor?: InputMaybe<SortOrder>;
    primaryColor?: InputMaybe<SortOrder>;
    secondaryBackgroundColor?: InputMaybe<SortOrder>;
    secondaryColor?: InputMaybe<SortOrder>;
    seoDescription?: InputMaybe<SortOrder>;
    seoImageUrl?: InputMaybe<SortOrder>;
    seoTitle?: InputMaybe<SortOrder>;
};

export type OrganizationAssetsCreateInput = {
    darkModeLogo?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    iconLogo?: InputMaybe<Scalars['String']['input']>;
    lightModeLogo?: InputMaybe<Scalars['String']['input']>;
    org: OrganizationCreateNestedOneWithoutOrganizationAssetsInput;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    primaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
    primaryColor?: InputMaybe<Scalars['String']['input']>;
    secondaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
    secondaryColor?: InputMaybe<Scalars['String']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoImageUrl?: InputMaybe<Scalars['String']['input']>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationAssetsCreateManyInput = {
    darkModeLogo?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    iconLogo?: InputMaybe<Scalars['String']['input']>;
    lightModeLogo?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    primaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
    primaryColor?: InputMaybe<Scalars['String']['input']>;
    secondaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
    secondaryColor?: InputMaybe<Scalars['String']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoImageUrl?: InputMaybe<Scalars['String']['input']>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationAssetsCreateNestedOneWithoutOrgInput = {
    connect?: InputMaybe<OrganizationAssetsWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationAssetsCreateOrConnectWithoutOrgInput>;
    create?: InputMaybe<OrganizationAssetsCreateWithoutOrgInput>;
};

export type OrganizationAssetsCreateOrConnectWithoutOrgInput = {
    create: OrganizationAssetsCreateWithoutOrgInput;
    where: OrganizationAssetsWhereUniqueInput;
};

export type OrganizationAssetsCreateWithoutOrgInput = {
    darkModeLogo?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    iconLogo?: InputMaybe<Scalars['String']['input']>;
    lightModeLogo?: InputMaybe<Scalars['String']['input']>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    primaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
    primaryColor?: InputMaybe<Scalars['String']['input']>;
    secondaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
    secondaryColor?: InputMaybe<Scalars['String']['input']>;
    seoDescription?: InputMaybe<Scalars['String']['input']>;
    seoImageUrl?: InputMaybe<Scalars['String']['input']>;
    seoTitle?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationAssetsGroupBy = {
    __typename?: 'OrganizationAssetsGroupBy';
    _avg?: Maybe<OrganizationAssetsAvgAggregate>;
    _count?: Maybe<OrganizationAssetsCountAggregate>;
    _max?: Maybe<OrganizationAssetsMaxAggregate>;
    _min?: Maybe<OrganizationAssetsMinAggregate>;
    _sum?: Maybe<OrganizationAssetsSumAggregate>;
    darkModeLogo?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    iconLogo?: Maybe<Scalars['String']['output']>;
    lightModeLogo?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    phoneNumber?: Maybe<Scalars['String']['output']>;
    primaryBackgroundColor?: Maybe<Scalars['String']['output']>;
    primaryColor?: Maybe<Scalars['String']['output']>;
    secondaryBackgroundColor?: Maybe<Scalars['String']['output']>;
    secondaryColor?: Maybe<Scalars['String']['output']>;
    seoDescription?: Maybe<Scalars['String']['output']>;
    seoImageUrl?: Maybe<Scalars['String']['output']>;
    seoTitle?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAssetsMaxAggregate = {
    __typename?: 'OrganizationAssetsMaxAggregate';
    darkModeLogo?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    iconLogo?: Maybe<Scalars['String']['output']>;
    lightModeLogo?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    primaryBackgroundColor?: Maybe<Scalars['String']['output']>;
    primaryColor?: Maybe<Scalars['String']['output']>;
    secondaryBackgroundColor?: Maybe<Scalars['String']['output']>;
    secondaryColor?: Maybe<Scalars['String']['output']>;
    seoDescription?: Maybe<Scalars['String']['output']>;
    seoImageUrl?: Maybe<Scalars['String']['output']>;
    seoTitle?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAssetsMaxOrderByAggregateInput = {
    darkModeLogo?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    iconLogo?: InputMaybe<SortOrder>;
    lightModeLogo?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    primaryBackgroundColor?: InputMaybe<SortOrder>;
    primaryColor?: InputMaybe<SortOrder>;
    secondaryBackgroundColor?: InputMaybe<SortOrder>;
    secondaryColor?: InputMaybe<SortOrder>;
    seoDescription?: InputMaybe<SortOrder>;
    seoImageUrl?: InputMaybe<SortOrder>;
    seoTitle?: InputMaybe<SortOrder>;
};

export type OrganizationAssetsMinAggregate = {
    __typename?: 'OrganizationAssetsMinAggregate';
    darkModeLogo?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    iconLogo?: Maybe<Scalars['String']['output']>;
    lightModeLogo?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    primaryBackgroundColor?: Maybe<Scalars['String']['output']>;
    primaryColor?: Maybe<Scalars['String']['output']>;
    secondaryBackgroundColor?: Maybe<Scalars['String']['output']>;
    secondaryColor?: Maybe<Scalars['String']['output']>;
    seoDescription?: Maybe<Scalars['String']['output']>;
    seoImageUrl?: Maybe<Scalars['String']['output']>;
    seoTitle?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAssetsMinOrderByAggregateInput = {
    darkModeLogo?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    iconLogo?: InputMaybe<SortOrder>;
    lightModeLogo?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    primaryBackgroundColor?: InputMaybe<SortOrder>;
    primaryColor?: InputMaybe<SortOrder>;
    secondaryBackgroundColor?: InputMaybe<SortOrder>;
    secondaryColor?: InputMaybe<SortOrder>;
    seoDescription?: InputMaybe<SortOrder>;
    seoImageUrl?: InputMaybe<SortOrder>;
    seoTitle?: InputMaybe<SortOrder>;
};

export type OrganizationAssetsNullableRelationFilter = {
    is?: InputMaybe<OrganizationAssetsWhereInput>;
    isNot?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type OrganizationAssetsOrderByWithAggregationInput = {
    _avg?: InputMaybe<OrganizationAssetsAvgOrderByAggregateInput>;
    _count?: InputMaybe<OrganizationAssetsCountOrderByAggregateInput>;
    _max?: InputMaybe<OrganizationAssetsMaxOrderByAggregateInput>;
    _min?: InputMaybe<OrganizationAssetsMinOrderByAggregateInput>;
    _sum?: InputMaybe<OrganizationAssetsSumOrderByAggregateInput>;
    darkModeLogo?: InputMaybe<SortOrderInput>;
    email?: InputMaybe<SortOrderInput>;
    iconLogo?: InputMaybe<SortOrderInput>;
    lightModeLogo?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrderInput>;
    primaryBackgroundColor?: InputMaybe<SortOrderInput>;
    primaryColor?: InputMaybe<SortOrderInput>;
    secondaryBackgroundColor?: InputMaybe<SortOrderInput>;
    secondaryColor?: InputMaybe<SortOrderInput>;
    seoDescription?: InputMaybe<SortOrderInput>;
    seoImageUrl?: InputMaybe<SortOrderInput>;
    seoTitle?: InputMaybe<SortOrderInput>;
};

export type OrganizationAssetsOrderByWithRelationInput = {
    darkModeLogo?: InputMaybe<SortOrderInput>;
    email?: InputMaybe<SortOrderInput>;
    iconLogo?: InputMaybe<SortOrderInput>;
    lightModeLogo?: InputMaybe<SortOrderInput>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrderInput>;
    primaryBackgroundColor?: InputMaybe<SortOrderInput>;
    primaryColor?: InputMaybe<SortOrderInput>;
    secondaryBackgroundColor?: InputMaybe<SortOrderInput>;
    secondaryColor?: InputMaybe<SortOrderInput>;
    seoDescription?: InputMaybe<SortOrderInput>;
    seoImageUrl?: InputMaybe<SortOrderInput>;
    seoTitle?: InputMaybe<SortOrderInput>;
};

export enum OrganizationAssetsScalarFieldEnum {
    DarkModeLogo = 'darkModeLogo',
    Email = 'email',
    IconLogo = 'iconLogo',
    LightModeLogo = 'lightModeLogo',
    OrgId = 'orgId',
    PhoneNumber = 'phoneNumber',
    PrimaryBackgroundColor = 'primaryBackgroundColor',
    PrimaryColor = 'primaryColor',
    SecondaryBackgroundColor = 'secondaryBackgroundColor',
    SecondaryColor = 'secondaryColor',
    SeoDescription = 'seoDescription',
    SeoImageUrl = 'seoImageUrl',
    SeoTitle = 'seoTitle',
}

export type OrganizationAssetsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<OrganizationAssetsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<OrganizationAssetsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<OrganizationAssetsScalarWhereWithAggregatesInput>>;
    darkModeLogo?: InputMaybe<StringNullableWithAggregatesFilter>;
    email?: InputMaybe<StringNullableWithAggregatesFilter>;
    iconLogo?: InputMaybe<StringNullableWithAggregatesFilter>;
    lightModeLogo?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    phoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryBackgroundColor?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryColor?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryBackgroundColor?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryColor?: InputMaybe<StringNullableWithAggregatesFilter>;
    seoDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
    seoImageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
    seoTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type OrganizationAssetsSumAggregate = {
    __typename?: 'OrganizationAssetsSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationAssetsSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type OrganizationAssetsUpdateInput = {
    darkModeLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    iconLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lightModeLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutOrganizationAssetsNestedInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryBackgroundColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryBackgroundColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    seoImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationAssetsUpdateManyMutationInput = {
    darkModeLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    iconLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lightModeLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryBackgroundColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryBackgroundColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    seoImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationAssetsUpdateOneWithoutOrgNestedInput = {
    connect?: InputMaybe<OrganizationAssetsWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationAssetsCreateOrConnectWithoutOrgInput>;
    create?: InputMaybe<OrganizationAssetsCreateWithoutOrgInput>;
    delete?: InputMaybe<OrganizationAssetsWhereInput>;
    disconnect?: InputMaybe<OrganizationAssetsWhereInput>;
    update?: InputMaybe<OrganizationAssetsUpdateToOneWithWhereWithoutOrgInput>;
    upsert?: InputMaybe<OrganizationAssetsUpsertWithoutOrgInput>;
};

export type OrganizationAssetsUpdateToOneWithWhereWithoutOrgInput = {
    data: OrganizationAssetsUpdateWithoutOrgInput;
    where?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type OrganizationAssetsUpdateWithoutOrgInput = {
    darkModeLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    iconLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lightModeLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryBackgroundColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryBackgroundColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    seoImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationAssetsUpsertWithoutOrgInput = {
    create: OrganizationAssetsCreateWithoutOrgInput;
    update: OrganizationAssetsUpdateWithoutOrgInput;
    where?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type OrganizationAssetsWhereInput = {
    AND?: InputMaybe<Array<OrganizationAssetsWhereInput>>;
    NOT?: InputMaybe<Array<OrganizationAssetsWhereInput>>;
    OR?: InputMaybe<Array<OrganizationAssetsWhereInput>>;
    darkModeLogo?: InputMaybe<StringNullableFilter>;
    email?: InputMaybe<StringNullableFilter>;
    iconLogo?: InputMaybe<StringNullableFilter>;
    lightModeLogo?: InputMaybe<StringNullableFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    phoneNumber?: InputMaybe<StringNullableFilter>;
    primaryBackgroundColor?: InputMaybe<StringNullableFilter>;
    primaryColor?: InputMaybe<StringNullableFilter>;
    secondaryBackgroundColor?: InputMaybe<StringNullableFilter>;
    secondaryColor?: InputMaybe<StringNullableFilter>;
    seoDescription?: InputMaybe<StringNullableFilter>;
    seoImageUrl?: InputMaybe<StringNullableFilter>;
    seoTitle?: InputMaybe<StringNullableFilter>;
};

export type OrganizationAssetsWhereUniqueInput = {
    AND?: InputMaybe<Array<OrganizationAssetsWhereInput>>;
    NOT?: InputMaybe<Array<OrganizationAssetsWhereInput>>;
    OR?: InputMaybe<Array<OrganizationAssetsWhereInput>>;
    darkModeLogo?: InputMaybe<StringNullableFilter>;
    email?: InputMaybe<StringNullableFilter>;
    iconLogo?: InputMaybe<StringNullableFilter>;
    lightModeLogo?: InputMaybe<StringNullableFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phoneNumber?: InputMaybe<StringNullableFilter>;
    primaryBackgroundColor?: InputMaybe<StringNullableFilter>;
    primaryColor?: InputMaybe<StringNullableFilter>;
    secondaryBackgroundColor?: InputMaybe<StringNullableFilter>;
    secondaryColor?: InputMaybe<StringNullableFilter>;
    seoDescription?: InputMaybe<StringNullableFilter>;
    seoImageUrl?: InputMaybe<StringNullableFilter>;
    seoTitle?: InputMaybe<StringNullableFilter>;
};

export type OrganizationAvgAggregate = {
    __typename?: 'OrganizationAvgAggregate';
    ehrProviderGroupIds?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    schedulingTimeWindow?: Maybe<Scalars['Float']['output']>;
    storefrontEligibilityMinimumAge?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationAvgOrderByAggregateInput = {
    ehrProviderGroupIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    schedulingTimeWindow?: InputMaybe<SortOrder>;
    storefrontEligibilityMinimumAge?: InputMaybe<SortOrder>;
};

export type OrganizationCount = {
    __typename?: 'OrganizationCount';
    Bundle: Scalars['Int']['output'];
    DeploymentOrgPhase: Scalars['Int']['output'];
    DeploymentOrgTask: Scalars['Int']['output'];
    EcwPayerAlias: Scalars['Int']['output'];
    EcwPayerStc: Scalars['Int']['output'];
    EhrProviderMapping: Scalars['Int']['output'];
    Hrt: Scalars['Int']['output'];
    OrgConfigFlag: Scalars['Int']['output'];
    PayerToEhrInsurancePackage: Scalars['Int']['output'];
    ProductCategories: Scalars['Int']['output'];
    Products: Scalars['Int']['output'];
    configCommits: Scalars['Int']['output'];
    defaultPractices: Scalars['Int']['output'];
    intakeFormSections: Scalars['Int']['output'];
    intakeForms: Scalars['Int']['output'];
    intakeQuestions: Scalars['Int']['output'];
    organizationTranslations: Scalars['Int']['output'];
    practices: Scalars['Int']['output'];
    providerToOrgs: Scalars['Int']['output'];
};

export type OrganizationCountBundleArgs = {
    where?: InputMaybe<BundleWhereInput>;
};

export type OrganizationCountDeploymentOrgPhaseArgs = {
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type OrganizationCountDeploymentOrgTaskArgs = {
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type OrganizationCountEcwPayerAliasArgs = {
    where?: InputMaybe<EcwPayerAliasWhereInput>;
};

export type OrganizationCountEcwPayerStcArgs = {
    where?: InputMaybe<EcwPayerStcWhereInput>;
};

export type OrganizationCountEhrProviderMappingArgs = {
    where?: InputMaybe<EhrProviderMappingWhereInput>;
};

export type OrganizationCountHrtArgs = {
    where?: InputMaybe<HrtWhereInput>;
};

export type OrganizationCountOrgConfigFlagArgs = {
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type OrganizationCountPayerToEhrInsurancePackageArgs = {
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type OrganizationCountProductCategoriesArgs = {
    where?: InputMaybe<ProductCategoriesWhereInput>;
};

export type OrganizationCountProductsArgs = {
    where?: InputMaybe<ProductsWhereInput>;
};

export type OrganizationCountConfigCommitsArgs = {
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type OrganizationCountDefaultPracticesArgs = {
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type OrganizationCountIntakeFormSectionsArgs = {
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type OrganizationCountIntakeFormsArgs = {
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type OrganizationCountIntakeQuestionsArgs = {
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type OrganizationCountOrganizationTranslationsArgs = {
    where?: InputMaybe<OrganizationTranslationWhereInput>;
};

export type OrganizationCountPracticesArgs = {
    where?: InputMaybe<PracticeWhereInput>;
};

export type OrganizationCountProviderToOrgsArgs = {
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type OrganizationCountAggregate = {
    __typename?: 'OrganizationCountAggregate';
    _all: Scalars['Int']['output'];
    abeCustomerName: Scalars['Int']['output'];
    claimsHistorySource: Scalars['Int']['output'];
    ehrContextId: Scalars['Int']['output'];
    ehrProviderGroupIds: Scalars['Int']['output'];
    ehrType: Scalars['Int']['output'];
    ein: Scalars['Int']['output'];
    facebookPixelId: Scalars['Int']['output'];
    googleAnalyticsTag: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    idpRedirect: Scalars['Int']['output'];
    metadata: Scalars['Int']['output'];
    orgName: Scalars['Int']['output'];
    orgTitle: Scalars['Int']['output'];
    patientPylonAccountId: Scalars['Int']['output'];
    pylonAccountId: Scalars['Int']['output'];
    renderConfig: Scalars['Int']['output'];
    schedulingTimeWindow: Scalars['Int']['output'];
    schedulingType: Scalars['Int']['output'];
    storefrontEligibilityAllowedStates: Scalars['Int']['output'];
    storefrontEligibilityMinimumAge: Scalars['Int']['output'];
    supportedLanguages: Scalars['Int']['output'];
    waitingRoomPin: Scalars['Int']['output'];
};

export type OrganizationCountOrderByAggregateInput = {
    abeCustomerName?: InputMaybe<SortOrder>;
    claimsHistorySource?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrProviderGroupIds?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    ein?: InputMaybe<SortOrder>;
    facebookPixelId?: InputMaybe<SortOrder>;
    googleAnalyticsTag?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idpRedirect?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    orgName?: InputMaybe<SortOrder>;
    orgTitle?: InputMaybe<SortOrder>;
    patientPylonAccountId?: InputMaybe<SortOrder>;
    pylonAccountId?: InputMaybe<SortOrder>;
    renderConfig?: InputMaybe<SortOrder>;
    schedulingTimeWindow?: InputMaybe<SortOrder>;
    schedulingType?: InputMaybe<SortOrder>;
    storefrontEligibilityAllowedStates?: InputMaybe<SortOrder>;
    storefrontEligibilityMinimumAge?: InputMaybe<SortOrder>;
    supportedLanguages?: InputMaybe<SortOrder>;
    waitingRoomPin?: InputMaybe<SortOrder>;
};

export type OrganizationCreateInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateManyInput = {
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateNestedOneWithoutArtOrgConfigInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutArtOrgConfigInput>;
    create?: InputMaybe<OrganizationCreateWithoutArtOrgConfigInput>;
};

export type OrganizationCreateNestedOneWithoutBundleInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutBundleInput>;
    create?: InputMaybe<OrganizationCreateWithoutBundleInput>;
};

export type OrganizationCreateNestedOneWithoutConfigCommitsInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutConfigCommitsInput>;
    create?: InputMaybe<OrganizationCreateWithoutConfigCommitsInput>;
};

export type OrganizationCreateNestedOneWithoutDefaultPracticesInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDefaultPracticesInput>;
    create?: InputMaybe<OrganizationCreateWithoutDefaultPracticesInput>;
};

export type OrganizationCreateNestedOneWithoutDeploymentOrgPhaseInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDeploymentOrgPhaseInput>;
    create?: InputMaybe<OrganizationCreateWithoutDeploymentOrgPhaseInput>;
};

export type OrganizationCreateNestedOneWithoutDeploymentOrgTaskInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDeploymentOrgTaskInput>;
    create?: InputMaybe<OrganizationCreateWithoutDeploymentOrgTaskInput>;
};

export type OrganizationCreateNestedOneWithoutEcwPayerAliasInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutEcwPayerAliasInput>;
    create?: InputMaybe<OrganizationCreateWithoutEcwPayerAliasInput>;
};

export type OrganizationCreateNestedOneWithoutEcwPayerStcInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutEcwPayerStcInput>;
    create?: InputMaybe<OrganizationCreateWithoutEcwPayerStcInput>;
};

export type OrganizationCreateNestedOneWithoutEhrProviderMappingInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutEhrProviderMappingInput>;
    create?: InputMaybe<OrganizationCreateWithoutEhrProviderMappingInput>;
};

export type OrganizationCreateNestedOneWithoutHrtInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutHrtInput>;
    create?: InputMaybe<OrganizationCreateWithoutHrtInput>;
};

export type OrganizationCreateNestedOneWithoutIntakeFormSectionsInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutIntakeFormSectionsInput>;
    create?: InputMaybe<OrganizationCreateWithoutIntakeFormSectionsInput>;
};

export type OrganizationCreateNestedOneWithoutIntakeFormsInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutIntakeFormsInput>;
    create?: InputMaybe<OrganizationCreateWithoutIntakeFormsInput>;
};

export type OrganizationCreateNestedOneWithoutIntakeQuestionsInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutIntakeQuestionsInput>;
    create?: InputMaybe<OrganizationCreateWithoutIntakeQuestionsInput>;
};

export type OrganizationCreateNestedOneWithoutOrgConfigFlagInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutOrgConfigFlagInput>;
    create?: InputMaybe<OrganizationCreateWithoutOrgConfigFlagInput>;
};

export type OrganizationCreateNestedOneWithoutOrganizationAssetsInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutOrganizationAssetsInput>;
    create?: InputMaybe<OrganizationCreateWithoutOrganizationAssetsInput>;
};

export type OrganizationCreateNestedOneWithoutOrganizationTranslationsInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutOrganizationTranslationsInput>;
    create?: InputMaybe<OrganizationCreateWithoutOrganizationTranslationsInput>;
};

export type OrganizationCreateNestedOneWithoutPayerToEhrInsurancePackageInput =
    {
        connect?: InputMaybe<OrganizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPayerToEhrInsurancePackageInput>;
        create?: InputMaybe<OrganizationCreateWithoutPayerToEhrInsurancePackageInput>;
    };

export type OrganizationCreateNestedOneWithoutPracticesInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPracticesInput>;
    create?: InputMaybe<OrganizationCreateWithoutPracticesInput>;
};

export type OrganizationCreateNestedOneWithoutProductCategoriesInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutProductCategoriesInput>;
    create?: InputMaybe<OrganizationCreateWithoutProductCategoriesInput>;
};

export type OrganizationCreateNestedOneWithoutProductsInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutProductsInput>;
    create?: InputMaybe<OrganizationCreateWithoutProductsInput>;
};

export type OrganizationCreateNestedOneWithoutProviderToOrgsInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutProviderToOrgsInput>;
    create?: InputMaybe<OrganizationCreateWithoutProviderToOrgsInput>;
};

export type OrganizationCreateOrConnectWithoutArtOrgConfigInput = {
    create: OrganizationCreateWithoutArtOrgConfigInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutBundleInput = {
    create: OrganizationCreateWithoutBundleInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutConfigCommitsInput = {
    create: OrganizationCreateWithoutConfigCommitsInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDefaultPracticesInput = {
    create: OrganizationCreateWithoutDefaultPracticesInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDeploymentOrgPhaseInput = {
    create: OrganizationCreateWithoutDeploymentOrgPhaseInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDeploymentOrgTaskInput = {
    create: OrganizationCreateWithoutDeploymentOrgTaskInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutEcwPayerAliasInput = {
    create: OrganizationCreateWithoutEcwPayerAliasInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutEcwPayerStcInput = {
    create: OrganizationCreateWithoutEcwPayerStcInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutEhrProviderMappingInput = {
    create: OrganizationCreateWithoutEhrProviderMappingInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutHrtInput = {
    create: OrganizationCreateWithoutHrtInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutIntakeFormSectionsInput = {
    create: OrganizationCreateWithoutIntakeFormSectionsInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutIntakeFormsInput = {
    create: OrganizationCreateWithoutIntakeFormsInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutIntakeQuestionsInput = {
    create: OrganizationCreateWithoutIntakeQuestionsInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutOrgConfigFlagInput = {
    create: OrganizationCreateWithoutOrgConfigFlagInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutOrganizationAssetsInput = {
    create: OrganizationCreateWithoutOrganizationAssetsInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutOrganizationTranslationsInput = {
    create: OrganizationCreateWithoutOrganizationTranslationsInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutPayerToEhrInsurancePackageInput =
    {
        create: OrganizationCreateWithoutPayerToEhrInsurancePackageInput;
        where: OrganizationWhereUniqueInput;
    };

export type OrganizationCreateOrConnectWithoutPracticesInput = {
    create: OrganizationCreateWithoutPracticesInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutProductCategoriesInput = {
    create: OrganizationCreateWithoutProductCategoriesInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutProductsInput = {
    create: OrganizationCreateWithoutProductsInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutProviderToOrgsInput = {
    create: OrganizationCreateWithoutProviderToOrgsInput;
    where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateWithoutArtOrgConfigInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutBundleInput = {
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutConfigCommitsInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutDefaultPracticesInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutDeploymentOrgPhaseInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutDeploymentOrgTaskInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutEcwPayerAliasInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutEcwPayerStcInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutEhrProviderMappingInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutHrtInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutIntakeFormSectionsInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutIntakeFormsInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutIntakeQuestionsInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutOrgConfigFlagInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutOrganizationAssetsInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutOrganizationTranslationsInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutPayerToEhrInsurancePackageInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutPracticesInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutProductCategoriesInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutProductsInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutProviderToOrgsInput = {
    Bundle?: InputMaybe<BundleCreateNestedManyWithoutOrgInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseCreateNestedManyWithoutOrgInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutOrgInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasCreateNestedManyWithoutOrgInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcCreateNestedManyWithoutOrgInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingCreateNestedManyWithoutOrgInput>;
    Hrt?: InputMaybe<HrtCreateNestedManyWithoutOrgInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagCreateNestedManyWithoutOrgInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsCreateNestedOneWithoutOrgInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput>;
    ProductCategories?: InputMaybe<ProductCategoriesCreateNestedManyWithoutOrgInput>;
    Products?: InputMaybe<ProductsCreateNestedManyWithoutOrgInput>;
    abeCustomerName?: InputMaybe<Scalars['String']['input']>;
    artOrgConfig?: InputMaybe<ArtOrgConfigCreateNestedOneWithoutOrgInput>;
    claimsHistorySource?: InputMaybe<Scalars['String']['input']>;
    configCommits?: InputMaybe<ConfigCommitCreateNestedManyWithoutOrgInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutOrgInput>;
    ehrContextId?: InputMaybe<Scalars['String']['input']>;
    ehrProviderGroupIds?: InputMaybe<OrganizationCreateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EhrType>;
    ein: Scalars['String']['input'];
    facebookPixelId?: InputMaybe<Scalars['String']['input']>;
    googleAnalyticsTag?: InputMaybe<Scalars['String']['input']>;
    idpRedirect?: InputMaybe<Scalars['String']['input']>;
    intakeFormSections?: InputMaybe<IntakeFormSectionCreateNestedManyWithoutOrgInput>;
    intakeForms?: InputMaybe<IntakeFormCreateNestedManyWithoutOrgInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutOrgInput>;
    metadata: Scalars['JSON']['input'];
    orgName: Scalars['String']['input'];
    orgTitle?: InputMaybe<Scalars['String']['input']>;
    organizationTranslations?: InputMaybe<OrganizationTranslationCreateNestedManyWithoutOrgInput>;
    patientPylonAccountId?: InputMaybe<Scalars['String']['input']>;
    practices?: InputMaybe<PracticeCreateNestedManyWithoutOrgInput>;
    pylonAccountId?: InputMaybe<Scalars['String']['input']>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<Scalars['Int']['input']>;
    schedulingType?: InputMaybe<SchedulingType>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationCreatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<Scalars['Int']['input']>;
    supportedLanguages?: InputMaybe<OrganizationCreatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateehrProviderGroupIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type OrganizationCreatestorefrontEligibilityAllowedStatesInput = {
    set: Array<State>;
};

export type OrganizationCreatesupportedLanguagesInput = {
    set: Array<Scalars['String']['input']>;
};

export type OrganizationGroupBy = {
    __typename?: 'OrganizationGroupBy';
    _avg?: Maybe<OrganizationAvgAggregate>;
    _count?: Maybe<OrganizationCountAggregate>;
    _max?: Maybe<OrganizationMaxAggregate>;
    _min?: Maybe<OrganizationMinAggregate>;
    _sum?: Maybe<OrganizationSumAggregate>;
    abeCustomerName: Scalars['String']['output'];
    claimsHistorySource?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrProviderGroupIds?: Maybe<Array<Scalars['Int']['output']>>;
    ehrType: EhrType;
    ein: Scalars['String']['output'];
    facebookPixelId?: Maybe<Scalars['String']['output']>;
    googleAnalyticsTag?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    idpRedirect?: Maybe<Scalars['String']['output']>;
    metadata: Scalars['JSON']['output'];
    orgName: Scalars['String']['output'];
    orgTitle: Scalars['String']['output'];
    patientPylonAccountId?: Maybe<Scalars['String']['output']>;
    pylonAccountId?: Maybe<Scalars['String']['output']>;
    renderConfig: Scalars['JSON']['output'];
    schedulingTimeWindow: Scalars['Int']['output'];
    schedulingType: SchedulingType;
    storefrontEligibilityAllowedStates?: Maybe<Array<State>>;
    storefrontEligibilityMinimumAge?: Maybe<Scalars['Int']['output']>;
    supportedLanguages?: Maybe<Array<Scalars['String']['output']>>;
    waitingRoomPin: Scalars['String']['output'];
};

export type OrganizationMaxAggregate = {
    __typename?: 'OrganizationMaxAggregate';
    abeCustomerName?: Maybe<Scalars['String']['output']>;
    claimsHistorySource?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrType>;
    ein?: Maybe<Scalars['String']['output']>;
    facebookPixelId?: Maybe<Scalars['String']['output']>;
    googleAnalyticsTag?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    idpRedirect?: Maybe<Scalars['String']['output']>;
    orgName?: Maybe<Scalars['String']['output']>;
    orgTitle?: Maybe<Scalars['String']['output']>;
    patientPylonAccountId?: Maybe<Scalars['String']['output']>;
    pylonAccountId?: Maybe<Scalars['String']['output']>;
    schedulingTimeWindow?: Maybe<Scalars['Int']['output']>;
    schedulingType?: Maybe<SchedulingType>;
    storefrontEligibilityMinimumAge?: Maybe<Scalars['Int']['output']>;
    waitingRoomPin?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMaxOrderByAggregateInput = {
    abeCustomerName?: InputMaybe<SortOrder>;
    claimsHistorySource?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    ein?: InputMaybe<SortOrder>;
    facebookPixelId?: InputMaybe<SortOrder>;
    googleAnalyticsTag?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idpRedirect?: InputMaybe<SortOrder>;
    orgName?: InputMaybe<SortOrder>;
    orgTitle?: InputMaybe<SortOrder>;
    patientPylonAccountId?: InputMaybe<SortOrder>;
    pylonAccountId?: InputMaybe<SortOrder>;
    schedulingTimeWindow?: InputMaybe<SortOrder>;
    schedulingType?: InputMaybe<SortOrder>;
    storefrontEligibilityMinimumAge?: InputMaybe<SortOrder>;
    waitingRoomPin?: InputMaybe<SortOrder>;
};

export type OrganizationMinAggregate = {
    __typename?: 'OrganizationMinAggregate';
    abeCustomerName?: Maybe<Scalars['String']['output']>;
    claimsHistorySource?: Maybe<Scalars['String']['output']>;
    ehrContextId?: Maybe<Scalars['String']['output']>;
    ehrType?: Maybe<EhrType>;
    ein?: Maybe<Scalars['String']['output']>;
    facebookPixelId?: Maybe<Scalars['String']['output']>;
    googleAnalyticsTag?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    idpRedirect?: Maybe<Scalars['String']['output']>;
    orgName?: Maybe<Scalars['String']['output']>;
    orgTitle?: Maybe<Scalars['String']['output']>;
    patientPylonAccountId?: Maybe<Scalars['String']['output']>;
    pylonAccountId?: Maybe<Scalars['String']['output']>;
    schedulingTimeWindow?: Maybe<Scalars['Int']['output']>;
    schedulingType?: Maybe<SchedulingType>;
    storefrontEligibilityMinimumAge?: Maybe<Scalars['Int']['output']>;
    waitingRoomPin?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMinOrderByAggregateInput = {
    abeCustomerName?: InputMaybe<SortOrder>;
    claimsHistorySource?: InputMaybe<SortOrder>;
    ehrContextId?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    ein?: InputMaybe<SortOrder>;
    facebookPixelId?: InputMaybe<SortOrder>;
    googleAnalyticsTag?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idpRedirect?: InputMaybe<SortOrder>;
    orgName?: InputMaybe<SortOrder>;
    orgTitle?: InputMaybe<SortOrder>;
    patientPylonAccountId?: InputMaybe<SortOrder>;
    pylonAccountId?: InputMaybe<SortOrder>;
    schedulingTimeWindow?: InputMaybe<SortOrder>;
    schedulingType?: InputMaybe<SortOrder>;
    storefrontEligibilityMinimumAge?: InputMaybe<SortOrder>;
    waitingRoomPin?: InputMaybe<SortOrder>;
};

export type OrganizationNullableRelationFilter = {
    is?: InputMaybe<OrganizationWhereInput>;
    isNot?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationOrderByWithAggregationInput = {
    _avg?: InputMaybe<OrganizationAvgOrderByAggregateInput>;
    _count?: InputMaybe<OrganizationCountOrderByAggregateInput>;
    _max?: InputMaybe<OrganizationMaxOrderByAggregateInput>;
    _min?: InputMaybe<OrganizationMinOrderByAggregateInput>;
    _sum?: InputMaybe<OrganizationSumOrderByAggregateInput>;
    abeCustomerName?: InputMaybe<SortOrder>;
    claimsHistorySource?: InputMaybe<SortOrderInput>;
    ehrContextId?: InputMaybe<SortOrderInput>;
    ehrProviderGroupIds?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    ein?: InputMaybe<SortOrder>;
    facebookPixelId?: InputMaybe<SortOrderInput>;
    googleAnalyticsTag?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    idpRedirect?: InputMaybe<SortOrderInput>;
    metadata?: InputMaybe<SortOrder>;
    orgName?: InputMaybe<SortOrder>;
    orgTitle?: InputMaybe<SortOrder>;
    patientPylonAccountId?: InputMaybe<SortOrderInput>;
    pylonAccountId?: InputMaybe<SortOrderInput>;
    renderConfig?: InputMaybe<SortOrder>;
    schedulingTimeWindow?: InputMaybe<SortOrder>;
    schedulingType?: InputMaybe<SortOrder>;
    storefrontEligibilityAllowedStates?: InputMaybe<SortOrder>;
    storefrontEligibilityMinimumAge?: InputMaybe<SortOrderInput>;
    supportedLanguages?: InputMaybe<SortOrder>;
    waitingRoomPin?: InputMaybe<SortOrder>;
};

export type OrganizationOrderByWithRelationInput = {
    Bundle?: InputMaybe<BundleOrderByRelationAggregateInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseOrderByRelationAggregateInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskOrderByRelationAggregateInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasOrderByRelationAggregateInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcOrderByRelationAggregateInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingOrderByRelationAggregateInput>;
    Hrt?: InputMaybe<HrtOrderByRelationAggregateInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagOrderByRelationAggregateInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsOrderByWithRelationInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingOrderByRelationAggregateInput>;
    ProductCategories?: InputMaybe<ProductCategoriesOrderByRelationAggregateInput>;
    Products?: InputMaybe<ProductsOrderByRelationAggregateInput>;
    abeCustomerName?: InputMaybe<SortOrder>;
    artOrgConfig?: InputMaybe<ArtOrgConfigOrderByWithRelationInput>;
    claimsHistorySource?: InputMaybe<SortOrderInput>;
    configCommits?: InputMaybe<ConfigCommitOrderByRelationAggregateInput>;
    defaultPractices?: InputMaybe<DefaultPracticeOrderByRelationAggregateInput>;
    ehrContextId?: InputMaybe<SortOrderInput>;
    ehrProviderGroupIds?: InputMaybe<SortOrder>;
    ehrType?: InputMaybe<SortOrder>;
    ein?: InputMaybe<SortOrder>;
    facebookPixelId?: InputMaybe<SortOrderInput>;
    googleAnalyticsTag?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    idpRedirect?: InputMaybe<SortOrderInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionOrderByRelationAggregateInput>;
    intakeForms?: InputMaybe<IntakeFormOrderByRelationAggregateInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionOrderByRelationAggregateInput>;
    metadata?: InputMaybe<SortOrder>;
    orgName?: InputMaybe<SortOrder>;
    orgTitle?: InputMaybe<SortOrder>;
    organizationTranslations?: InputMaybe<OrganizationTranslationOrderByRelationAggregateInput>;
    patientPylonAccountId?: InputMaybe<SortOrderInput>;
    practices?: InputMaybe<PracticeOrderByRelationAggregateInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgOrderByRelationAggregateInput>;
    pylonAccountId?: InputMaybe<SortOrderInput>;
    renderConfig?: InputMaybe<SortOrder>;
    schedulingTimeWindow?: InputMaybe<SortOrder>;
    schedulingType?: InputMaybe<SortOrder>;
    storefrontEligibilityAllowedStates?: InputMaybe<SortOrder>;
    storefrontEligibilityMinimumAge?: InputMaybe<SortOrderInput>;
    supportedLanguages?: InputMaybe<SortOrder>;
    waitingRoomPin?: InputMaybe<SortOrder>;
};

export type OrganizationRelationFilter = {
    is?: InputMaybe<OrganizationWhereInput>;
    isNot?: InputMaybe<OrganizationWhereInput>;
};

export enum OrganizationScalarFieldEnum {
    AbeCustomerName = 'abeCustomerName',
    ClaimsHistorySource = 'claimsHistorySource',
    EhrContextId = 'ehrContextId',
    EhrProviderGroupIds = 'ehrProviderGroupIds',
    EhrType = 'ehrType',
    Ein = 'ein',
    FacebookPixelId = 'facebookPixelId',
    GoogleAnalyticsTag = 'googleAnalyticsTag',
    Id = 'id',
    IdpRedirect = 'idpRedirect',
    Metadata = 'metadata',
    OrgName = 'orgName',
    OrgTitle = 'orgTitle',
    PatientPylonAccountId = 'patientPylonAccountId',
    PylonAccountId = 'pylonAccountId',
    RenderConfig = 'renderConfig',
    SchedulingTimeWindow = 'schedulingTimeWindow',
    SchedulingType = 'schedulingType',
    StorefrontEligibilityAllowedStates = 'storefrontEligibilityAllowedStates',
    StorefrontEligibilityMinimumAge = 'storefrontEligibilityMinimumAge',
    SupportedLanguages = 'supportedLanguages',
    WaitingRoomPin = 'waitingRoomPin',
}

export type OrganizationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<OrganizationScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<OrganizationScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<OrganizationScalarWhereWithAggregatesInput>>;
    abeCustomerName?: InputMaybe<StringWithAggregatesFilter>;
    claimsHistorySource?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrContextId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrProviderGroupIds?: InputMaybe<IntNullableListFilter>;
    ehrType?: InputMaybe<EnumEhrTypeWithAggregatesFilter>;
    ein?: InputMaybe<StringWithAggregatesFilter>;
    facebookPixelId?: InputMaybe<StringNullableWithAggregatesFilter>;
    googleAnalyticsTag?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    idpRedirect?: InputMaybe<StringNullableWithAggregatesFilter>;
    metadata?: InputMaybe<JsonWithAggregatesFilter>;
    orgName?: InputMaybe<StringWithAggregatesFilter>;
    orgTitle?: InputMaybe<StringWithAggregatesFilter>;
    patientPylonAccountId?: InputMaybe<StringNullableWithAggregatesFilter>;
    pylonAccountId?: InputMaybe<StringNullableWithAggregatesFilter>;
    renderConfig?: InputMaybe<JsonWithAggregatesFilter>;
    schedulingTimeWindow?: InputMaybe<IntWithAggregatesFilter>;
    schedulingType?: InputMaybe<EnumSchedulingTypeWithAggregatesFilter>;
    storefrontEligibilityAllowedStates?: InputMaybe<EnumStateNullableListFilter>;
    storefrontEligibilityMinimumAge?: InputMaybe<IntNullableWithAggregatesFilter>;
    supportedLanguages?: InputMaybe<StringNullableListFilter>;
    waitingRoomPin?: InputMaybe<StringWithAggregatesFilter>;
};

export type OrganizationSumAggregate = {
    __typename?: 'OrganizationSumAggregate';
    ehrProviderGroupIds?: Maybe<Array<Scalars['Int']['output']>>;
    id?: Maybe<Scalars['Int']['output']>;
    schedulingTimeWindow?: Maybe<Scalars['Int']['output']>;
    storefrontEligibilityMinimumAge?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationSumOrderByAggregateInput = {
    ehrProviderGroupIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    schedulingTimeWindow?: InputMaybe<SortOrder>;
    storefrontEligibilityMinimumAge?: InputMaybe<SortOrder>;
};

export type OrganizationTranslation = {
    __typename?: 'OrganizationTranslation';
    createdAt: Scalars['DateTimeISO']['output'];
    languageCode: Scalars['String']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    renderConfig?: Maybe<Scalars['JSON']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    warningFlags: Array<Scalars['String']['output']>;
};

export type OrganizationTranslationAvgAggregate = {
    __typename?: 'OrganizationTranslationAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationTranslationAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type OrganizationTranslationCountAggregate = {
    __typename?: 'OrganizationTranslationCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    languageCode: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    renderConfig: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    warningFlags: Scalars['Int']['output'];
};

export type OrganizationTranslationCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    renderConfig?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type OrganizationTranslationCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutOrganizationTranslationsInput;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<OrganizationTranslationCreatewarningFlagsInput>;
};

export type OrganizationTranslationCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<OrganizationTranslationCreatewarningFlagsInput>;
};

export type OrganizationTranslationCreateManyOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<OrganizationTranslationCreatewarningFlagsInput>;
};

export type OrganizationTranslationCreateManyOrgInputEnvelope = {
    data: Array<OrganizationTranslationCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationTranslationCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<OrganizationTranslationWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<OrganizationTranslationCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<OrganizationTranslationCreateWithoutOrgInput>>;
    createMany?: InputMaybe<OrganizationTranslationCreateManyOrgInputEnvelope>;
};

export type OrganizationTranslationCreateOrConnectWithoutOrgInput = {
    create: OrganizationTranslationCreateWithoutOrgInput;
    where: OrganizationTranslationWhereUniqueInput;
};

export type OrganizationTranslationCreateWithoutOrgInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<OrganizationTranslationCreatewarningFlagsInput>;
};

export type OrganizationTranslationCreatewarningFlagsInput = {
    set: Array<Scalars['String']['input']>;
};

export type OrganizationTranslationGroupBy = {
    __typename?: 'OrganizationTranslationGroupBy';
    _avg?: Maybe<OrganizationTranslationAvgAggregate>;
    _count?: Maybe<OrganizationTranslationCountAggregate>;
    _max?: Maybe<OrganizationTranslationMaxAggregate>;
    _min?: Maybe<OrganizationTranslationMinAggregate>;
    _sum?: Maybe<OrganizationTranslationSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    languageCode: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    renderConfig?: Maybe<Scalars['JSON']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    warningFlags?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrganizationTranslationListRelationFilter = {
    every?: InputMaybe<OrganizationTranslationWhereInput>;
    none?: InputMaybe<OrganizationTranslationWhereInput>;
    some?: InputMaybe<OrganizationTranslationWhereInput>;
};

export type OrganizationTranslationMaxAggregate = {
    __typename?: 'OrganizationTranslationMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrganizationTranslationMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrganizationTranslationMinAggregate = {
    __typename?: 'OrganizationTranslationMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrganizationTranslationMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type OrganizationTranslationOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type OrganizationTranslationOrderByWithAggregationInput = {
    _avg?: InputMaybe<OrganizationTranslationAvgOrderByAggregateInput>;
    _count?: InputMaybe<OrganizationTranslationCountOrderByAggregateInput>;
    _max?: InputMaybe<OrganizationTranslationMaxOrderByAggregateInput>;
    _min?: InputMaybe<OrganizationTranslationMinOrderByAggregateInput>;
    _sum?: InputMaybe<OrganizationTranslationSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    renderConfig?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type OrganizationTranslationOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    renderConfig?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type OrganizationTranslationOrgIdLanguageCodeCompoundUniqueInput = {
    languageCode: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
};

export enum OrganizationTranslationScalarFieldEnum {
    CreatedAt = 'createdAt',
    LanguageCode = 'languageCode',
    OrgId = 'orgId',
    RenderConfig = 'renderConfig',
    UpdatedAt = 'updatedAt',
    WarningFlags = 'warningFlags',
}

export type OrganizationTranslationScalarWhereInput = {
    AND?: InputMaybe<Array<OrganizationTranslationScalarWhereInput>>;
    NOT?: InputMaybe<Array<OrganizationTranslationScalarWhereInput>>;
    OR?: InputMaybe<Array<OrganizationTranslationScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    languageCode?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    renderConfig?: InputMaybe<JsonNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type OrganizationTranslationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<OrganizationTranslationScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<OrganizationTranslationScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<OrganizationTranslationScalarWhereWithAggregatesInput>
    >;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    languageCode?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    renderConfig?: InputMaybe<JsonNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type OrganizationTranslationSumAggregate = {
    __typename?: 'OrganizationTranslationSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationTranslationSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type OrganizationTranslationUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutOrganizationTranslationsNestedInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<OrganizationTranslationUpdatewarningFlagsInput>;
};

export type OrganizationTranslationUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<OrganizationTranslationUpdatewarningFlagsInput>;
};

export type OrganizationTranslationUpdateManyWithWhereWithoutOrgInput = {
    data: OrganizationTranslationUpdateManyMutationInput;
    where: OrganizationTranslationScalarWhereInput;
};

export type OrganizationTranslationUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<OrganizationTranslationWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<OrganizationTranslationCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<OrganizationTranslationCreateWithoutOrgInput>>;
    createMany?: InputMaybe<OrganizationTranslationCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<OrganizationTranslationWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<OrganizationTranslationScalarWhereInput>>;
    disconnect?: InputMaybe<Array<OrganizationTranslationWhereUniqueInput>>;
    set?: InputMaybe<Array<OrganizationTranslationWhereUniqueInput>>;
    update?: InputMaybe<
        Array<OrganizationTranslationUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<OrganizationTranslationUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<OrganizationTranslationUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type OrganizationTranslationUpdateWithWhereUniqueWithoutOrgInput = {
    data: OrganizationTranslationUpdateWithoutOrgInput;
    where: OrganizationTranslationWhereUniqueInput;
};

export type OrganizationTranslationUpdateWithoutOrgInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<OrganizationTranslationUpdatewarningFlagsInput>;
};

export type OrganizationTranslationUpdatewarningFlagsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrganizationTranslationUpsertWithWhereUniqueWithoutOrgInput = {
    create: OrganizationTranslationCreateWithoutOrgInput;
    update: OrganizationTranslationUpdateWithoutOrgInput;
    where: OrganizationTranslationWhereUniqueInput;
};

export type OrganizationTranslationWhereInput = {
    AND?: InputMaybe<Array<OrganizationTranslationWhereInput>>;
    NOT?: InputMaybe<Array<OrganizationTranslationWhereInput>>;
    OR?: InputMaybe<Array<OrganizationTranslationWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    languageCode?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    renderConfig?: InputMaybe<JsonNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type OrganizationTranslationWhereUniqueInput = {
    AND?: InputMaybe<Array<OrganizationTranslationWhereInput>>;
    NOT?: InputMaybe<Array<OrganizationTranslationWhereInput>>;
    OR?: InputMaybe<Array<OrganizationTranslationWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    languageCode?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    orgId_languageCode?: InputMaybe<OrganizationTranslationOrgIdLanguageCodeCompoundUniqueInput>;
    renderConfig?: InputMaybe<JsonNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type OrganizationUpdateInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateManyMutationInput = {
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateOneRequiredWithoutArtOrgConfigNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutArtOrgConfigInput>;
    create?: InputMaybe<OrganizationCreateWithoutArtOrgConfigInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutArtOrgConfigInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutArtOrgConfigInput>;
};

export type OrganizationUpdateOneRequiredWithoutBundleNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutBundleInput>;
    create?: InputMaybe<OrganizationCreateWithoutBundleInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutBundleInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutBundleInput>;
};

export type OrganizationUpdateOneRequiredWithoutDefaultPracticesNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDefaultPracticesInput>;
    create?: InputMaybe<OrganizationCreateWithoutDefaultPracticesInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutDefaultPracticesInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutDefaultPracticesInput>;
};

export type OrganizationUpdateOneRequiredWithoutDeploymentOrgPhaseNestedInput =
    {
        connect?: InputMaybe<OrganizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDeploymentOrgPhaseInput>;
        create?: InputMaybe<OrganizationCreateWithoutDeploymentOrgPhaseInput>;
        update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutDeploymentOrgPhaseInput>;
        upsert?: InputMaybe<OrganizationUpsertWithoutDeploymentOrgPhaseInput>;
    };

export type OrganizationUpdateOneRequiredWithoutDeploymentOrgTaskNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDeploymentOrgTaskInput>;
    create?: InputMaybe<OrganizationCreateWithoutDeploymentOrgTaskInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutDeploymentOrgTaskInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutDeploymentOrgTaskInput>;
};

export type OrganizationUpdateOneRequiredWithoutEcwPayerAliasNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutEcwPayerAliasInput>;
    create?: InputMaybe<OrganizationCreateWithoutEcwPayerAliasInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutEcwPayerAliasInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutEcwPayerAliasInput>;
};

export type OrganizationUpdateOneRequiredWithoutEcwPayerStcNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutEcwPayerStcInput>;
    create?: InputMaybe<OrganizationCreateWithoutEcwPayerStcInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutEcwPayerStcInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutEcwPayerStcInput>;
};

export type OrganizationUpdateOneRequiredWithoutEhrProviderMappingNestedInput =
    {
        connect?: InputMaybe<OrganizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutEhrProviderMappingInput>;
        create?: InputMaybe<OrganizationCreateWithoutEhrProviderMappingInput>;
        update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutEhrProviderMappingInput>;
        upsert?: InputMaybe<OrganizationUpsertWithoutEhrProviderMappingInput>;
    };

export type OrganizationUpdateOneRequiredWithoutHrtNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutHrtInput>;
    create?: InputMaybe<OrganizationCreateWithoutHrtInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutHrtInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutHrtInput>;
};

export type OrganizationUpdateOneRequiredWithoutIntakeFormSectionsNestedInput =
    {
        connect?: InputMaybe<OrganizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutIntakeFormSectionsInput>;
        create?: InputMaybe<OrganizationCreateWithoutIntakeFormSectionsInput>;
        update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutIntakeFormSectionsInput>;
        upsert?: InputMaybe<OrganizationUpsertWithoutIntakeFormSectionsInput>;
    };

export type OrganizationUpdateOneRequiredWithoutIntakeFormsNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutIntakeFormsInput>;
    create?: InputMaybe<OrganizationCreateWithoutIntakeFormsInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutIntakeFormsInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutIntakeFormsInput>;
};

export type OrganizationUpdateOneRequiredWithoutIntakeQuestionsNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutIntakeQuestionsInput>;
    create?: InputMaybe<OrganizationCreateWithoutIntakeQuestionsInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutIntakeQuestionsInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutIntakeQuestionsInput>;
};

export type OrganizationUpdateOneRequiredWithoutOrgConfigFlagNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutOrgConfigFlagInput>;
    create?: InputMaybe<OrganizationCreateWithoutOrgConfigFlagInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutOrgConfigFlagInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutOrgConfigFlagInput>;
};

export type OrganizationUpdateOneRequiredWithoutOrganizationAssetsNestedInput =
    {
        connect?: InputMaybe<OrganizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutOrganizationAssetsInput>;
        create?: InputMaybe<OrganizationCreateWithoutOrganizationAssetsInput>;
        update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutOrganizationAssetsInput>;
        upsert?: InputMaybe<OrganizationUpsertWithoutOrganizationAssetsInput>;
    };

export type OrganizationUpdateOneRequiredWithoutOrganizationTranslationsNestedInput =
    {
        connect?: InputMaybe<OrganizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutOrganizationTranslationsInput>;
        create?: InputMaybe<OrganizationCreateWithoutOrganizationTranslationsInput>;
        update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutOrganizationTranslationsInput>;
        upsert?: InputMaybe<OrganizationUpsertWithoutOrganizationTranslationsInput>;
    };

export type OrganizationUpdateOneRequiredWithoutPayerToEhrInsurancePackageNestedInput =
    {
        connect?: InputMaybe<OrganizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPayerToEhrInsurancePackageInput>;
        create?: InputMaybe<OrganizationCreateWithoutPayerToEhrInsurancePackageInput>;
        update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPayerToEhrInsurancePackageInput>;
        upsert?: InputMaybe<OrganizationUpsertWithoutPayerToEhrInsurancePackageInput>;
    };

export type OrganizationUpdateOneRequiredWithoutPracticesNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPracticesInput>;
    create?: InputMaybe<OrganizationCreateWithoutPracticesInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPracticesInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutPracticesInput>;
};

export type OrganizationUpdateOneRequiredWithoutProductCategoriesNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutProductCategoriesInput>;
    create?: InputMaybe<OrganizationCreateWithoutProductCategoriesInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutProductCategoriesInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutProductCategoriesInput>;
};

export type OrganizationUpdateOneRequiredWithoutProductsNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutProductsInput>;
    create?: InputMaybe<OrganizationCreateWithoutProductsInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutProductsInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutProductsInput>;
};

export type OrganizationUpdateOneRequiredWithoutProviderToOrgsNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutProviderToOrgsInput>;
    create?: InputMaybe<OrganizationCreateWithoutProviderToOrgsInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutProviderToOrgsInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutProviderToOrgsInput>;
};

export type OrganizationUpdateOneWithoutConfigCommitsNestedInput = {
    connect?: InputMaybe<OrganizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutConfigCommitsInput>;
    create?: InputMaybe<OrganizationCreateWithoutConfigCommitsInput>;
    delete?: InputMaybe<OrganizationWhereInput>;
    disconnect?: InputMaybe<OrganizationWhereInput>;
    update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutConfigCommitsInput>;
    upsert?: InputMaybe<OrganizationUpsertWithoutConfigCommitsInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutArtOrgConfigInput = {
    data: OrganizationUpdateWithoutArtOrgConfigInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutBundleInput = {
    data: OrganizationUpdateWithoutBundleInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutConfigCommitsInput = {
    data: OrganizationUpdateWithoutConfigCommitsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutDefaultPracticesInput = {
    data: OrganizationUpdateWithoutDefaultPracticesInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutDeploymentOrgPhaseInput = {
    data: OrganizationUpdateWithoutDeploymentOrgPhaseInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutDeploymentOrgTaskInput = {
    data: OrganizationUpdateWithoutDeploymentOrgTaskInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutEcwPayerAliasInput = {
    data: OrganizationUpdateWithoutEcwPayerAliasInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutEcwPayerStcInput = {
    data: OrganizationUpdateWithoutEcwPayerStcInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutEhrProviderMappingInput = {
    data: OrganizationUpdateWithoutEhrProviderMappingInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutHrtInput = {
    data: OrganizationUpdateWithoutHrtInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutIntakeFormSectionsInput = {
    data: OrganizationUpdateWithoutIntakeFormSectionsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutIntakeFormsInput = {
    data: OrganizationUpdateWithoutIntakeFormsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutIntakeQuestionsInput = {
    data: OrganizationUpdateWithoutIntakeQuestionsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutOrgConfigFlagInput = {
    data: OrganizationUpdateWithoutOrgConfigFlagInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutOrganizationAssetsInput = {
    data: OrganizationUpdateWithoutOrganizationAssetsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutOrganizationTranslationsInput =
    {
        data: OrganizationUpdateWithoutOrganizationTranslationsInput;
        where?: InputMaybe<OrganizationWhereInput>;
    };

export type OrganizationUpdateToOneWithWhereWithoutPayerToEhrInsurancePackageInput =
    {
        data: OrganizationUpdateWithoutPayerToEhrInsurancePackageInput;
        where?: InputMaybe<OrganizationWhereInput>;
    };

export type OrganizationUpdateToOneWithWhereWithoutPracticesInput = {
    data: OrganizationUpdateWithoutPracticesInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutProductCategoriesInput = {
    data: OrganizationUpdateWithoutProductCategoriesInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutProductsInput = {
    data: OrganizationUpdateWithoutProductsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutProviderToOrgsInput = {
    data: OrganizationUpdateWithoutProviderToOrgsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateWithoutArtOrgConfigInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutBundleInput = {
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutConfigCommitsInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutDefaultPracticesInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutDeploymentOrgPhaseInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutDeploymentOrgTaskInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutEcwPayerAliasInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutEcwPayerStcInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutEhrProviderMappingInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutHrtInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutIntakeFormSectionsInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutIntakeFormsInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutIntakeQuestionsInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutOrgConfigFlagInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutOrganizationAssetsInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutOrganizationTranslationsInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutPayerToEhrInsurancePackageInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutPracticesInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutProductCategoriesInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutProductsInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutProviderToOrgsInput = {
    Bundle?: InputMaybe<BundleUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseUpdateManyWithoutOrgNestedInput>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutOrgNestedInput>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasUpdateManyWithoutOrgNestedInput>;
    EcwPayerStc?: InputMaybe<EcwPayerStcUpdateManyWithoutOrgNestedInput>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingUpdateManyWithoutOrgNestedInput>;
    Hrt?: InputMaybe<HrtUpdateManyWithoutOrgNestedInput>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagUpdateManyWithoutOrgNestedInput>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsUpdateOneWithoutOrgNestedInput>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput>;
    ProductCategories?: InputMaybe<ProductCategoriesUpdateManyWithoutOrgNestedInput>;
    Products?: InputMaybe<ProductsUpdateManyWithoutOrgNestedInput>;
    abeCustomerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    artOrgConfig?: InputMaybe<ArtOrgConfigUpdateOneWithoutOrgNestedInput>;
    claimsHistorySource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    configCommits?: InputMaybe<ConfigCommitUpdateManyWithoutOrgNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutOrgNestedInput>;
    ehrContextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrProviderGroupIds?: InputMaybe<OrganizationUpdateehrProviderGroupIdsInput>;
    ehrType?: InputMaybe<EnumEhrTypeFieldUpdateOperationsInput>;
    ein?: InputMaybe<StringFieldUpdateOperationsInput>;
    facebookPixelId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleAnalyticsTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idpRedirect?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    intakeFormSections?: InputMaybe<IntakeFormSectionUpdateManyWithoutOrgNestedInput>;
    intakeForms?: InputMaybe<IntakeFormUpdateManyWithoutOrgNestedInput>;
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutOrgNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    orgName?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
    organizationTranslations?: InputMaybe<OrganizationTranslationUpdateManyWithoutOrgNestedInput>;
    patientPylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practices?: InputMaybe<PracticeUpdateManyWithoutOrgNestedInput>;
    pylonAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    schedulingTimeWindow?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFieldUpdateOperationsInput>;
    storefrontEligibilityAllowedStates?: InputMaybe<OrganizationUpdatestorefrontEligibilityAllowedStatesInput>;
    storefrontEligibilityMinimumAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    supportedLanguages?: InputMaybe<OrganizationUpdatesupportedLanguagesInput>;
    waitingRoomPin?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateehrProviderGroupIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OrganizationUpdatestorefrontEligibilityAllowedStatesInput = {
    push?: InputMaybe<Array<State>>;
    set?: InputMaybe<Array<State>>;
};

export type OrganizationUpdatesupportedLanguagesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrganizationUpsertWithoutArtOrgConfigInput = {
    create: OrganizationCreateWithoutArtOrgConfigInput;
    update: OrganizationUpdateWithoutArtOrgConfigInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutBundleInput = {
    create: OrganizationCreateWithoutBundleInput;
    update: OrganizationUpdateWithoutBundleInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutConfigCommitsInput = {
    create: OrganizationCreateWithoutConfigCommitsInput;
    update: OrganizationUpdateWithoutConfigCommitsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutDefaultPracticesInput = {
    create: OrganizationCreateWithoutDefaultPracticesInput;
    update: OrganizationUpdateWithoutDefaultPracticesInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutDeploymentOrgPhaseInput = {
    create: OrganizationCreateWithoutDeploymentOrgPhaseInput;
    update: OrganizationUpdateWithoutDeploymentOrgPhaseInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutDeploymentOrgTaskInput = {
    create: OrganizationCreateWithoutDeploymentOrgTaskInput;
    update: OrganizationUpdateWithoutDeploymentOrgTaskInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutEcwPayerAliasInput = {
    create: OrganizationCreateWithoutEcwPayerAliasInput;
    update: OrganizationUpdateWithoutEcwPayerAliasInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutEcwPayerStcInput = {
    create: OrganizationCreateWithoutEcwPayerStcInput;
    update: OrganizationUpdateWithoutEcwPayerStcInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutEhrProviderMappingInput = {
    create: OrganizationCreateWithoutEhrProviderMappingInput;
    update: OrganizationUpdateWithoutEhrProviderMappingInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutHrtInput = {
    create: OrganizationCreateWithoutHrtInput;
    update: OrganizationUpdateWithoutHrtInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutIntakeFormSectionsInput = {
    create: OrganizationCreateWithoutIntakeFormSectionsInput;
    update: OrganizationUpdateWithoutIntakeFormSectionsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutIntakeFormsInput = {
    create: OrganizationCreateWithoutIntakeFormsInput;
    update: OrganizationUpdateWithoutIntakeFormsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutIntakeQuestionsInput = {
    create: OrganizationCreateWithoutIntakeQuestionsInput;
    update: OrganizationUpdateWithoutIntakeQuestionsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutOrgConfigFlagInput = {
    create: OrganizationCreateWithoutOrgConfigFlagInput;
    update: OrganizationUpdateWithoutOrgConfigFlagInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutOrganizationAssetsInput = {
    create: OrganizationCreateWithoutOrganizationAssetsInput;
    update: OrganizationUpdateWithoutOrganizationAssetsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutOrganizationTranslationsInput = {
    create: OrganizationCreateWithoutOrganizationTranslationsInput;
    update: OrganizationUpdateWithoutOrganizationTranslationsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPayerToEhrInsurancePackageInput = {
    create: OrganizationCreateWithoutPayerToEhrInsurancePackageInput;
    update: OrganizationUpdateWithoutPayerToEhrInsurancePackageInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPracticesInput = {
    create: OrganizationCreateWithoutPracticesInput;
    update: OrganizationUpdateWithoutPracticesInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutProductCategoriesInput = {
    create: OrganizationCreateWithoutProductCategoriesInput;
    update: OrganizationUpdateWithoutProductCategoriesInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutProductsInput = {
    create: OrganizationCreateWithoutProductsInput;
    update: OrganizationUpdateWithoutProductsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutProviderToOrgsInput = {
    create: OrganizationCreateWithoutProviderToOrgsInput;
    update: OrganizationUpdateWithoutProviderToOrgsInput;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationWhereInput = {
    AND?: InputMaybe<Array<OrganizationWhereInput>>;
    Bundle?: InputMaybe<BundleListRelationFilter>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseListRelationFilter>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskListRelationFilter>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasListRelationFilter>;
    EcwPayerStc?: InputMaybe<EcwPayerStcListRelationFilter>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingListRelationFilter>;
    Hrt?: InputMaybe<HrtListRelationFilter>;
    NOT?: InputMaybe<Array<OrganizationWhereInput>>;
    OR?: InputMaybe<Array<OrganizationWhereInput>>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagListRelationFilter>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsNullableRelationFilter>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingListRelationFilter>;
    ProductCategories?: InputMaybe<ProductCategoriesListRelationFilter>;
    Products?: InputMaybe<ProductsListRelationFilter>;
    abeCustomerName?: InputMaybe<StringFilter>;
    artOrgConfig?: InputMaybe<ArtOrgConfigNullableRelationFilter>;
    claimsHistorySource?: InputMaybe<StringNullableFilter>;
    configCommits?: InputMaybe<ConfigCommitListRelationFilter>;
    defaultPractices?: InputMaybe<DefaultPracticeListRelationFilter>;
    ehrContextId?: InputMaybe<StringNullableFilter>;
    ehrProviderGroupIds?: InputMaybe<IntNullableListFilter>;
    ehrType?: InputMaybe<EnumEhrTypeFilter>;
    ein?: InputMaybe<StringFilter>;
    facebookPixelId?: InputMaybe<StringNullableFilter>;
    googleAnalyticsTag?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    idpRedirect?: InputMaybe<StringNullableFilter>;
    intakeFormSections?: InputMaybe<IntakeFormSectionListRelationFilter>;
    intakeForms?: InputMaybe<IntakeFormListRelationFilter>;
    intakeQuestions?: InputMaybe<IntakeQuestionListRelationFilter>;
    metadata?: InputMaybe<JsonFilter>;
    orgName?: InputMaybe<StringFilter>;
    orgTitle?: InputMaybe<StringFilter>;
    organizationTranslations?: InputMaybe<OrganizationTranslationListRelationFilter>;
    patientPylonAccountId?: InputMaybe<StringNullableFilter>;
    practices?: InputMaybe<PracticeListRelationFilter>;
    providerToOrgs?: InputMaybe<ProviderToOrgListRelationFilter>;
    pylonAccountId?: InputMaybe<StringNullableFilter>;
    renderConfig?: InputMaybe<JsonFilter>;
    schedulingTimeWindow?: InputMaybe<IntFilter>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFilter>;
    storefrontEligibilityAllowedStates?: InputMaybe<EnumStateNullableListFilter>;
    storefrontEligibilityMinimumAge?: InputMaybe<IntNullableFilter>;
    supportedLanguages?: InputMaybe<StringNullableListFilter>;
    waitingRoomPin?: InputMaybe<StringFilter>;
};

export type OrganizationWhereUniqueInput = {
    AND?: InputMaybe<Array<OrganizationWhereInput>>;
    Bundle?: InputMaybe<BundleListRelationFilter>;
    DeploymentOrgPhase?: InputMaybe<DeploymentOrgPhaseListRelationFilter>;
    DeploymentOrgTask?: InputMaybe<DeploymentOrgTaskListRelationFilter>;
    EcwPayerAlias?: InputMaybe<EcwPayerAliasListRelationFilter>;
    EcwPayerStc?: InputMaybe<EcwPayerStcListRelationFilter>;
    EhrProviderMapping?: InputMaybe<EhrProviderMappingListRelationFilter>;
    Hrt?: InputMaybe<HrtListRelationFilter>;
    NOT?: InputMaybe<Array<OrganizationWhereInput>>;
    OR?: InputMaybe<Array<OrganizationWhereInput>>;
    OrgConfigFlag?: InputMaybe<OrgConfigFlagListRelationFilter>;
    OrganizationAssets?: InputMaybe<OrganizationAssetsNullableRelationFilter>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingListRelationFilter>;
    ProductCategories?: InputMaybe<ProductCategoriesListRelationFilter>;
    Products?: InputMaybe<ProductsListRelationFilter>;
    abeCustomerName?: InputMaybe<StringFilter>;
    artOrgConfig?: InputMaybe<ArtOrgConfigNullableRelationFilter>;
    claimsHistorySource?: InputMaybe<StringNullableFilter>;
    configCommits?: InputMaybe<ConfigCommitListRelationFilter>;
    defaultPractices?: InputMaybe<DefaultPracticeListRelationFilter>;
    ehrContextId?: InputMaybe<StringNullableFilter>;
    ehrProviderGroupIds?: InputMaybe<IntNullableListFilter>;
    ehrType?: InputMaybe<EnumEhrTypeFilter>;
    ein?: InputMaybe<StringFilter>;
    facebookPixelId?: InputMaybe<StringNullableFilter>;
    googleAnalyticsTag?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    idpRedirect?: InputMaybe<StringNullableFilter>;
    intakeFormSections?: InputMaybe<IntakeFormSectionListRelationFilter>;
    intakeForms?: InputMaybe<IntakeFormListRelationFilter>;
    intakeQuestions?: InputMaybe<IntakeQuestionListRelationFilter>;
    metadata?: InputMaybe<JsonFilter>;
    orgName?: InputMaybe<StringFilter>;
    orgTitle?: InputMaybe<StringFilter>;
    organizationTranslations?: InputMaybe<OrganizationTranslationListRelationFilter>;
    patientPylonAccountId?: InputMaybe<StringNullableFilter>;
    practices?: InputMaybe<PracticeListRelationFilter>;
    providerToOrgs?: InputMaybe<ProviderToOrgListRelationFilter>;
    pylonAccountId?: InputMaybe<StringNullableFilter>;
    renderConfig?: InputMaybe<JsonFilter>;
    schedulingTimeWindow?: InputMaybe<IntFilter>;
    schedulingType?: InputMaybe<EnumSchedulingTypeFilter>;
    storefrontEligibilityAllowedStates?: InputMaybe<EnumStateNullableListFilter>;
    storefrontEligibilityMinimumAge?: InputMaybe<IntNullableFilter>;
    supportedLanguages?: InputMaybe<StringNullableListFilter>;
    waitingRoomPin?: InputMaybe<StringFilter>;
};

export enum ParsingRule {
    HigherCopay = 'HIGHER_COPAY',
    Ignore = 'IGNORE',
    Keyword = 'KEYWORD',
}

export enum PayerTag {
    Anthem = 'ANTHEM',
    Capital = 'CAPITAL',
    Carefirst = 'CAREFIRST',
    HealthyBlue = 'HEALTHY_BLUE',
    Highmark = 'HIGHMARK',
    Horizon = 'HORIZON',
    Independence = 'INDEPENDENCE',
    Premera = 'PREMERA',
    Regence = 'REGENCE',
}

export enum PayerType {
    Bcbs = 'BCBS',
    Medicaid = 'MEDICAID',
}

export enum PaymentType {
    Cash = 'CASH',
    Insured = 'INSURED',
    OverrideInsured = 'OVERRIDE_INSURED',
    OverrideSelfpay = 'OVERRIDE_SELFPAY',
}

export enum PricingType {
    CartPricing = 'CART_PRICING',
    PriceTreatments = 'PRICE_TREATMENTS',
}

export enum ProductCategoryType {
    Carousel = 'CAROUSEL',
    Featured = 'FEATURED',
    Section = 'SECTION',
    Tab = 'TAB',
}

export enum ProductComponentType {
    Default = 'DEFAULT',
    InitialRequired = 'INITIAL_REQUIRED',
    PrerequisiteAdditional = 'PREREQUISITE_ADDITIONAL',
    PrerequisiteBase = 'PREREQUISITE_BASE',
}

export enum ProductPageType {
    Default = 'DEFAULT',
    InitialFollowUp = 'INITIAL_FOLLOW_UP',
    Link = 'LINK',
    Prerequisite = 'PREREQUISITE',
}

export enum ProductType {
    BuyNow = 'BUY_NOW',
    Pdp = 'PDP',
    PdpAndBuyNow = 'PDP_AND_BUY_NOW',
}

export enum PropagationType {
    Auto = 'AUTO',
    Manual = 'MANUAL',
    OnDqc = 'ON_DQC',
}

export type PayLaterAuthorization = {
    __typename?: 'PayLaterAuthorization';
    activationMessageAttemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    activationMessageErrorDetails?: Maybe<Scalars['String']['output']>;
    appointmentId: Scalars['String']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount: Scalars['Decimal']['output'];
    depositCollectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositTransaction?: Maybe<Transaction>;
    depositTransactionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentAuthorization: PaymentAuthorization;
    paymentAuthorizationId: Scalars['String']['output'];
    paymentPlan?: Maybe<PaymentPlan>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    status: PayLaterAuthorizationStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PayLaterAuthorizationDepositTransactionArgs = {
    where?: InputMaybe<TransactionWhereInput>;
};

export type PayLaterAuthorizationPaymentPlanArgs = {
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PayLaterAuthorizationAuditLog = {
    __typename?: 'PayLaterAuthorizationAuditLog';
    activationMessageAttemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    activationMessageErrorDetails?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositCollectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositTransactionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PayLaterAuthorizationStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PayLaterAuthorizationAuditLogAvgAggregate = {
    __typename?: 'PayLaterAuthorizationAuditLogAvgAggregate';
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type PayLaterAuthorizationAuditLogAvgOrderByAggregateInput = {
    depositAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationAuditLogCountAggregate = {
    __typename?: 'PayLaterAuthorizationAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    activationMessageAttemptedAt: Scalars['Int']['output'];
    activationMessageErrorDetails: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    depositAmount: Scalars['Int']['output'];
    depositCollectedAt: Scalars['Int']['output'];
    depositTransactionId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payLaterAuthorizationId: Scalars['Int']['output'];
    paymentAuthorizationId: Scalars['Int']['output'];
    paymentPlanId: Scalars['Int']['output'];
    revokedAt: Scalars['Int']['output'];
    revokedReason: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PayLaterAuthorizationAuditLogCountOrderByAggregateInput = {
    activationMessageAttemptedAt?: InputMaybe<SortOrder>;
    activationMessageErrorDetails?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositCollectedAt?: InputMaybe<SortOrder>;
    depositTransactionId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAuthorizationId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationAuditLogCreateInput = {
    activationMessageAttemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    activationMessageErrorDetails?: InputMaybe<Scalars['String']['input']>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositCollectedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositTransactionId?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    payLaterAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    paymentAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PayLaterAuthorizationStatus>;
    updatedAt: Scalars['DateTimeISO']['input'];
};

export type PayLaterAuthorizationAuditLogCreateManyInput = {
    activationMessageAttemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    activationMessageErrorDetails?: InputMaybe<Scalars['String']['input']>;
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositCollectedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositTransactionId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    payLaterAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    paymentAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PayLaterAuthorizationStatus>;
    updatedAt: Scalars['DateTimeISO']['input'];
};

export type PayLaterAuthorizationAuditLogGroupBy = {
    __typename?: 'PayLaterAuthorizationAuditLogGroupBy';
    _avg?: Maybe<PayLaterAuthorizationAuditLogAvgAggregate>;
    _count?: Maybe<PayLaterAuthorizationAuditLogCountAggregate>;
    _max?: Maybe<PayLaterAuthorizationAuditLogMaxAggregate>;
    _min?: Maybe<PayLaterAuthorizationAuditLogMinAggregate>;
    _sum?: Maybe<PayLaterAuthorizationAuditLogSumAggregate>;
    activationMessageAttemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    activationMessageErrorDetails?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositCollectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositTransactionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PayLaterAuthorizationStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PayLaterAuthorizationAuditLogMaxAggregate = {
    __typename?: 'PayLaterAuthorizationAuditLogMaxAggregate';
    activationMessageAttemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    activationMessageErrorDetails?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositCollectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositTransactionId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PayLaterAuthorizationStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayLaterAuthorizationAuditLogMaxOrderByAggregateInput = {
    activationMessageAttemptedAt?: InputMaybe<SortOrder>;
    activationMessageErrorDetails?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositCollectedAt?: InputMaybe<SortOrder>;
    depositTransactionId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAuthorizationId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationAuditLogMinAggregate = {
    __typename?: 'PayLaterAuthorizationAuditLogMinAggregate';
    activationMessageAttemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    activationMessageErrorDetails?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositCollectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositTransactionId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PayLaterAuthorizationStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayLaterAuthorizationAuditLogMinOrderByAggregateInput = {
    activationMessageAttemptedAt?: InputMaybe<SortOrder>;
    activationMessageErrorDetails?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositCollectedAt?: InputMaybe<SortOrder>;
    depositTransactionId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAuthorizationId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<PayLaterAuthorizationAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<PayLaterAuthorizationAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<PayLaterAuthorizationAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<PayLaterAuthorizationAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<PayLaterAuthorizationAuditLogSumOrderByAggregateInput>;
    activationMessageAttemptedAt?: InputMaybe<SortOrderInput>;
    activationMessageErrorDetails?: InputMaybe<SortOrderInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrderInput>;
    depositCollectedAt?: InputMaybe<SortOrderInput>;
    depositTransactionId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    payLaterAuthorizationId?: InputMaybe<SortOrderInput>;
    paymentAuthorizationId?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    revokedAt?: InputMaybe<SortOrderInput>;
    revokedReason?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationAuditLogOrderByWithRelationInput = {
    activationMessageAttemptedAt?: InputMaybe<SortOrderInput>;
    activationMessageErrorDetails?: InputMaybe<SortOrderInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrderInput>;
    depositCollectedAt?: InputMaybe<SortOrderInput>;
    depositTransactionId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    payLaterAuthorizationId?: InputMaybe<SortOrderInput>;
    paymentAuthorizationId?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    revokedAt?: InputMaybe<SortOrderInput>;
    revokedReason?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PayLaterAuthorizationAuditLogScalarFieldEnum {
    ActivationMessageAttemptedAt = 'activationMessageAttemptedAt',
    ActivationMessageErrorDetails = 'activationMessageErrorDetails',
    AppointmentId = 'appointmentId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    DepositAmount = 'depositAmount',
    DepositCollectedAt = 'depositCollectedAt',
    DepositTransactionId = 'depositTransactionId',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Operation = 'operation',
    OrgId = 'orgId',
    PayLaterAuthorizationId = 'payLaterAuthorizationId',
    PaymentAuthorizationId = 'paymentAuthorizationId',
    PaymentPlanId = 'paymentPlanId',
    RevokedAt = 'revokedAt',
    RevokedReason = 'revokedReason',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type PayLaterAuthorizationAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PayLaterAuthorizationAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PayLaterAuthorizationAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<PayLaterAuthorizationAuditLogScalarWhereWithAggregatesInput>
    >;
    activationMessageAttemptedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    activationMessageErrorDetails?: InputMaybe<StringNullableWithAggregatesFilter>;
    appointmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    depositAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    depositCollectedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    depositTransactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    payLaterAuthorizationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    paymentPlanId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    revokedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    revokedReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PayLaterAuthorizationAuditLogSumAggregate = {
    __typename?: 'PayLaterAuthorizationAuditLogSumAggregate';
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type PayLaterAuthorizationAuditLogSumOrderByAggregateInput = {
    depositAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationAuditLogUpdateInput = {
    activationMessageAttemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    activationMessageErrorDetails?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    depositCollectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    depositTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payLaterAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentPlanId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumPayLaterAuthorizationStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayLaterAuthorizationAuditLogUpdateManyMutationInput = {
    activationMessageAttemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    activationMessageErrorDetails?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    depositCollectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    depositTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payLaterAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentPlanId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumPayLaterAuthorizationStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayLaterAuthorizationAuditLogWhereInput = {
    AND?: InputMaybe<Array<PayLaterAuthorizationAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PayLaterAuthorizationAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PayLaterAuthorizationAuditLogWhereInput>>;
    activationMessageAttemptedAt?: InputMaybe<DateTimeNullableFilter>;
    activationMessageErrorDetails?: InputMaybe<StringNullableFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalNullableFilter>;
    depositCollectedAt?: InputMaybe<DateTimeNullableFilter>;
    depositTransactionId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    payLaterAuthorizationId?: InputMaybe<UuidNullableFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    revokedAt?: InputMaybe<DateTimeNullableFilter>;
    revokedReason?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PayLaterAuthorizationAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<PayLaterAuthorizationAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PayLaterAuthorizationAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PayLaterAuthorizationAuditLogWhereInput>>;
    activationMessageAttemptedAt?: InputMaybe<DateTimeNullableFilter>;
    activationMessageErrorDetails?: InputMaybe<StringNullableFilter>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalNullableFilter>;
    depositCollectedAt?: InputMaybe<DateTimeNullableFilter>;
    depositTransactionId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    payLaterAuthorizationId?: InputMaybe<UuidNullableFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    revokedAt?: InputMaybe<DateTimeNullableFilter>;
    revokedReason?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PayLaterAuthorizationAvgAggregate = {
    __typename?: 'PayLaterAuthorizationAvgAggregate';
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type PayLaterAuthorizationAvgOrderByAggregateInput = {
    depositAmount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationCountAggregate = {
    __typename?: 'PayLaterAuthorizationCountAggregate';
    _all: Scalars['Int']['output'];
    activationMessageAttemptedAt: Scalars['Int']['output'];
    activationMessageErrorDetails: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    depositAmount: Scalars['Int']['output'];
    depositCollectedAt: Scalars['Int']['output'];
    depositTransactionId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentAuthorizationId: Scalars['Int']['output'];
    paymentPlanId: Scalars['Int']['output'];
    revokedAt: Scalars['Int']['output'];
    revokedReason: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PayLaterAuthorizationCountOrderByAggregateInput = {
    activationMessageAttemptedAt?: InputMaybe<SortOrder>;
    activationMessageErrorDetails?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositCollectedAt?: InputMaybe<SortOrder>;
    depositTransactionId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationCreateInput = {
    activationMessageAttemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    activationMessageErrorDetails?: InputMaybe<Scalars['String']['input']>;
    appointmentId: Scalars['String']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositCollectedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositTransaction?: InputMaybe<TransactionCreateNestedOneWithoutPayLaterAuthorizationsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentAuthorization: PaymentAuthorizationCreateNestedOneWithoutPayLaterAuthorizationInput;
    paymentPlan?: InputMaybe<PaymentPlanCreateNestedOneWithoutPayLaterAuthorizationInput>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PayLaterAuthorizationStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayLaterAuthorizationCreateManyDepositTransactionInput = {
    activationMessageAttemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    activationMessageErrorDetails?: InputMaybe<Scalars['String']['input']>;
    appointmentId: Scalars['String']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositCollectedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentAuthorizationId: Scalars['String']['input'];
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PayLaterAuthorizationStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayLaterAuthorizationCreateManyDepositTransactionInputEnvelope = {
    data: Array<PayLaterAuthorizationCreateManyDepositTransactionInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayLaterAuthorizationCreateManyInput = {
    activationMessageAttemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    activationMessageErrorDetails?: InputMaybe<Scalars['String']['input']>;
    appointmentId: Scalars['String']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositCollectedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositTransactionId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentAuthorizationId: Scalars['String']['input'];
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PayLaterAuthorizationStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayLaterAuthorizationCreateNestedManyWithoutDepositTransactionInput =
    {
        connect?: InputMaybe<Array<PayLaterAuthorizationWhereUniqueInput>>;
        connectOrCreate?: InputMaybe<
            Array<PayLaterAuthorizationCreateOrConnectWithoutDepositTransactionInput>
        >;
        create?: InputMaybe<
            Array<PayLaterAuthorizationCreateWithoutDepositTransactionInput>
        >;
        createMany?: InputMaybe<PayLaterAuthorizationCreateManyDepositTransactionInputEnvelope>;
    };

export type PayLaterAuthorizationCreateNestedOneWithoutPaymentAuthorizationInput =
    {
        connect?: InputMaybe<PayLaterAuthorizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<PayLaterAuthorizationCreateOrConnectWithoutPaymentAuthorizationInput>;
        create?: InputMaybe<PayLaterAuthorizationCreateWithoutPaymentAuthorizationInput>;
    };

export type PayLaterAuthorizationCreateNestedOneWithoutPaymentPlanInput = {
    connect?: InputMaybe<PayLaterAuthorizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PayLaterAuthorizationCreateOrConnectWithoutPaymentPlanInput>;
    create?: InputMaybe<PayLaterAuthorizationCreateWithoutPaymentPlanInput>;
};

export type PayLaterAuthorizationCreateOrConnectWithoutDepositTransactionInput =
    {
        create: PayLaterAuthorizationCreateWithoutDepositTransactionInput;
        where: PayLaterAuthorizationWhereUniqueInput;
    };

export type PayLaterAuthorizationCreateOrConnectWithoutPaymentAuthorizationInput =
    {
        create: PayLaterAuthorizationCreateWithoutPaymentAuthorizationInput;
        where: PayLaterAuthorizationWhereUniqueInput;
    };

export type PayLaterAuthorizationCreateOrConnectWithoutPaymentPlanInput = {
    create: PayLaterAuthorizationCreateWithoutPaymentPlanInput;
    where: PayLaterAuthorizationWhereUniqueInput;
};

export type PayLaterAuthorizationCreateWithoutDepositTransactionInput = {
    activationMessageAttemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    activationMessageErrorDetails?: InputMaybe<Scalars['String']['input']>;
    appointmentId: Scalars['String']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositCollectedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentAuthorization: PaymentAuthorizationCreateNestedOneWithoutPayLaterAuthorizationInput;
    paymentPlan?: InputMaybe<PaymentPlanCreateNestedOneWithoutPayLaterAuthorizationInput>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PayLaterAuthorizationStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayLaterAuthorizationCreateWithoutPaymentAuthorizationInput = {
    activationMessageAttemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    activationMessageErrorDetails?: InputMaybe<Scalars['String']['input']>;
    appointmentId: Scalars['String']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositCollectedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositTransaction?: InputMaybe<TransactionCreateNestedOneWithoutPayLaterAuthorizationsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentPlan?: InputMaybe<PaymentPlanCreateNestedOneWithoutPayLaterAuthorizationInput>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PayLaterAuthorizationStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayLaterAuthorizationCreateWithoutPaymentPlanInput = {
    activationMessageAttemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    activationMessageErrorDetails?: InputMaybe<Scalars['String']['input']>;
    appointmentId: Scalars['String']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositCollectedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositTransaction?: InputMaybe<TransactionCreateNestedOneWithoutPayLaterAuthorizationsInput>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentAuthorization: PaymentAuthorizationCreateNestedOneWithoutPayLaterAuthorizationInput;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PayLaterAuthorizationStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayLaterAuthorizationGroupBy = {
    __typename?: 'PayLaterAuthorizationGroupBy';
    _avg?: Maybe<PayLaterAuthorizationAvgAggregate>;
    _count?: Maybe<PayLaterAuthorizationCountAggregate>;
    _max?: Maybe<PayLaterAuthorizationMaxAggregate>;
    _min?: Maybe<PayLaterAuthorizationMinAggregate>;
    _sum?: Maybe<PayLaterAuthorizationSumAggregate>;
    activationMessageAttemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    activationMessageErrorDetails?: Maybe<Scalars['String']['output']>;
    appointmentId: Scalars['String']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount: Scalars['Decimal']['output'];
    depositCollectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositTransactionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    paymentAuthorizationId: Scalars['String']['output'];
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    status: PayLaterAuthorizationStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PayLaterAuthorizationListRelationFilter = {
    every?: InputMaybe<PayLaterAuthorizationWhereInput>;
    none?: InputMaybe<PayLaterAuthorizationWhereInput>;
    some?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type PayLaterAuthorizationMaxAggregate = {
    __typename?: 'PayLaterAuthorizationMaxAggregate';
    activationMessageAttemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    activationMessageErrorDetails?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositCollectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositTransactionId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PayLaterAuthorizationStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayLaterAuthorizationMaxOrderByAggregateInput = {
    activationMessageAttemptedAt?: InputMaybe<SortOrder>;
    activationMessageErrorDetails?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositCollectedAt?: InputMaybe<SortOrder>;
    depositTransactionId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationMinAggregate = {
    __typename?: 'PayLaterAuthorizationMinAggregate';
    activationMessageAttemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    activationMessageErrorDetails?: Maybe<Scalars['String']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositCollectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositTransactionId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PayLaterAuthorizationStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayLaterAuthorizationMinOrderByAggregateInput = {
    activationMessageAttemptedAt?: InputMaybe<SortOrder>;
    activationMessageErrorDetails?: InputMaybe<SortOrder>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositCollectedAt?: InputMaybe<SortOrder>;
    depositTransactionId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationNullableRelationFilter = {
    is?: InputMaybe<PayLaterAuthorizationWhereInput>;
    isNot?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type PayLaterAuthorizationOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationOrderByWithAggregationInput = {
    _avg?: InputMaybe<PayLaterAuthorizationAvgOrderByAggregateInput>;
    _count?: InputMaybe<PayLaterAuthorizationCountOrderByAggregateInput>;
    _max?: InputMaybe<PayLaterAuthorizationMaxOrderByAggregateInput>;
    _min?: InputMaybe<PayLaterAuthorizationMinOrderByAggregateInput>;
    _sum?: InputMaybe<PayLaterAuthorizationSumOrderByAggregateInput>;
    activationMessageAttemptedAt?: InputMaybe<SortOrderInput>;
    activationMessageErrorDetails?: InputMaybe<SortOrderInput>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositCollectedAt?: InputMaybe<SortOrderInput>;
    depositTransactionId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    revokedAt?: InputMaybe<SortOrderInput>;
    revokedReason?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationOrderByWithRelationInput = {
    activationMessageAttemptedAt?: InputMaybe<SortOrderInput>;
    activationMessageErrorDetails?: InputMaybe<SortOrderInput>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositCollectedAt?: InputMaybe<SortOrderInput>;
    depositTransaction?: InputMaybe<TransactionOrderByWithRelationInput>;
    depositTransactionId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationOrderByWithRelationInput>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentPlan?: InputMaybe<PaymentPlanOrderByWithRelationInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    revokedAt?: InputMaybe<SortOrderInput>;
    revokedReason?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PayLaterAuthorizationScalarFieldEnum {
    ActivationMessageAttemptedAt = 'activationMessageAttemptedAt',
    ActivationMessageErrorDetails = 'activationMessageErrorDetails',
    AppointmentId = 'appointmentId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    DepositAmount = 'depositAmount',
    DepositCollectedAt = 'depositCollectedAt',
    DepositTransactionId = 'depositTransactionId',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    OrgId = 'orgId',
    PaymentAuthorizationId = 'paymentAuthorizationId',
    PaymentPlanId = 'paymentPlanId',
    RevokedAt = 'revokedAt',
    RevokedReason = 'revokedReason',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type PayLaterAuthorizationScalarWhereInput = {
    AND?: InputMaybe<Array<PayLaterAuthorizationScalarWhereInput>>;
    NOT?: InputMaybe<Array<PayLaterAuthorizationScalarWhereInput>>;
    OR?: InputMaybe<Array<PayLaterAuthorizationScalarWhereInput>>;
    activationMessageAttemptedAt?: InputMaybe<DateTimeNullableFilter>;
    activationMessageErrorDetails?: InputMaybe<StringNullableFilter>;
    appointmentId?: InputMaybe<UuidFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalFilter>;
    depositCollectedAt?: InputMaybe<DateTimeNullableFilter>;
    depositTransactionId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentAuthorizationId?: InputMaybe<UuidFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    revokedAt?: InputMaybe<DateTimeNullableFilter>;
    revokedReason?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PayLaterAuthorizationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PayLaterAuthorizationScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PayLaterAuthorizationScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<PayLaterAuthorizationScalarWhereWithAggregatesInput>>;
    activationMessageAttemptedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    activationMessageErrorDetails?: InputMaybe<StringNullableWithAggregatesFilter>;
    appointmentId?: InputMaybe<UuidWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    depositAmount?: InputMaybe<DecimalWithAggregatesFilter>;
    depositCollectedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    depositTransactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    paymentAuthorizationId?: InputMaybe<UuidWithAggregatesFilter>;
    paymentPlanId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    revokedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    revokedReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum PayLaterAuthorizationStatus {
    Activated = 'ACTIVATED',
    Canceled = 'CANCELED',
    PendingClaim = 'PENDING_CLAIM',
    Revoked = 'REVOKED',
}

export type PayLaterAuthorizationSumAggregate = {
    __typename?: 'PayLaterAuthorizationSumAggregate';
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type PayLaterAuthorizationSumOrderByAggregateInput = {
    depositAmount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type PayLaterAuthorizationUpdateInput = {
    activationMessageAttemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    activationMessageErrorDetails?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    depositCollectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    depositTransaction?: InputMaybe<TransactionUpdateOneWithoutPayLaterAuthorizationsNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationUpdateOneRequiredWithoutPayLaterAuthorizationNestedInput>;
    paymentPlan?: InputMaybe<PaymentPlanUpdateOneWithoutPayLaterAuthorizationNestedInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayLaterAuthorizationUpdateManyMutationInput = {
    activationMessageAttemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    activationMessageErrorDetails?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    depositCollectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayLaterAuthorizationUpdateManyWithWhereWithoutDepositTransactionInput =
    {
        data: PayLaterAuthorizationUpdateManyMutationInput;
        where: PayLaterAuthorizationScalarWhereInput;
    };

export type PayLaterAuthorizationUpdateManyWithoutDepositTransactionNestedInput =
    {
        connect?: InputMaybe<Array<PayLaterAuthorizationWhereUniqueInput>>;
        connectOrCreate?: InputMaybe<
            Array<PayLaterAuthorizationCreateOrConnectWithoutDepositTransactionInput>
        >;
        create?: InputMaybe<
            Array<PayLaterAuthorizationCreateWithoutDepositTransactionInput>
        >;
        createMany?: InputMaybe<PayLaterAuthorizationCreateManyDepositTransactionInputEnvelope>;
        delete?: InputMaybe<Array<PayLaterAuthorizationWhereUniqueInput>>;
        deleteMany?: InputMaybe<Array<PayLaterAuthorizationScalarWhereInput>>;
        disconnect?: InputMaybe<Array<PayLaterAuthorizationWhereUniqueInput>>;
        set?: InputMaybe<Array<PayLaterAuthorizationWhereUniqueInput>>;
        update?: InputMaybe<
            Array<PayLaterAuthorizationUpdateWithWhereUniqueWithoutDepositTransactionInput>
        >;
        updateMany?: InputMaybe<
            Array<PayLaterAuthorizationUpdateManyWithWhereWithoutDepositTransactionInput>
        >;
        upsert?: InputMaybe<
            Array<PayLaterAuthorizationUpsertWithWhereUniqueWithoutDepositTransactionInput>
        >;
    };

export type PayLaterAuthorizationUpdateOneWithoutPaymentAuthorizationNestedInput =
    {
        connect?: InputMaybe<PayLaterAuthorizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<PayLaterAuthorizationCreateOrConnectWithoutPaymentAuthorizationInput>;
        create?: InputMaybe<PayLaterAuthorizationCreateWithoutPaymentAuthorizationInput>;
        delete?: InputMaybe<PayLaterAuthorizationWhereInput>;
        disconnect?: InputMaybe<PayLaterAuthorizationWhereInput>;
        update?: InputMaybe<PayLaterAuthorizationUpdateToOneWithWhereWithoutPaymentAuthorizationInput>;
        upsert?: InputMaybe<PayLaterAuthorizationUpsertWithoutPaymentAuthorizationInput>;
    };

export type PayLaterAuthorizationUpdateOneWithoutPaymentPlanNestedInput = {
    connect?: InputMaybe<PayLaterAuthorizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PayLaterAuthorizationCreateOrConnectWithoutPaymentPlanInput>;
    create?: InputMaybe<PayLaterAuthorizationCreateWithoutPaymentPlanInput>;
    delete?: InputMaybe<PayLaterAuthorizationWhereInput>;
    disconnect?: InputMaybe<PayLaterAuthorizationWhereInput>;
    update?: InputMaybe<PayLaterAuthorizationUpdateToOneWithWhereWithoutPaymentPlanInput>;
    upsert?: InputMaybe<PayLaterAuthorizationUpsertWithoutPaymentPlanInput>;
};

export type PayLaterAuthorizationUpdateToOneWithWhereWithoutPaymentAuthorizationInput =
    {
        data: PayLaterAuthorizationUpdateWithoutPaymentAuthorizationInput;
        where?: InputMaybe<PayLaterAuthorizationWhereInput>;
    };

export type PayLaterAuthorizationUpdateToOneWithWhereWithoutPaymentPlanInput = {
    data: PayLaterAuthorizationUpdateWithoutPaymentPlanInput;
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type PayLaterAuthorizationUpdateWithWhereUniqueWithoutDepositTransactionInput =
    {
        data: PayLaterAuthorizationUpdateWithoutDepositTransactionInput;
        where: PayLaterAuthorizationWhereUniqueInput;
    };

export type PayLaterAuthorizationUpdateWithoutDepositTransactionInput = {
    activationMessageAttemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    activationMessageErrorDetails?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    depositCollectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationUpdateOneRequiredWithoutPayLaterAuthorizationNestedInput>;
    paymentPlan?: InputMaybe<PaymentPlanUpdateOneWithoutPayLaterAuthorizationNestedInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayLaterAuthorizationUpdateWithoutPaymentAuthorizationInput = {
    activationMessageAttemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    activationMessageErrorDetails?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    depositCollectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    depositTransaction?: InputMaybe<TransactionUpdateOneWithoutPayLaterAuthorizationsNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentPlan?: InputMaybe<PaymentPlanUpdateOneWithoutPayLaterAuthorizationNestedInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayLaterAuthorizationUpdateWithoutPaymentPlanInput = {
    activationMessageAttemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    activationMessageErrorDetails?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    appointmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    depositCollectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    depositTransaction?: InputMaybe<TransactionUpdateOneWithoutPayLaterAuthorizationsNestedInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationUpdateOneRequiredWithoutPayLaterAuthorizationNestedInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayLaterAuthorizationUpsertWithWhereUniqueWithoutDepositTransactionInput =
    {
        create: PayLaterAuthorizationCreateWithoutDepositTransactionInput;
        update: PayLaterAuthorizationUpdateWithoutDepositTransactionInput;
        where: PayLaterAuthorizationWhereUniqueInput;
    };

export type PayLaterAuthorizationUpsertWithoutPaymentAuthorizationInput = {
    create: PayLaterAuthorizationCreateWithoutPaymentAuthorizationInput;
    update: PayLaterAuthorizationUpdateWithoutPaymentAuthorizationInput;
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type PayLaterAuthorizationUpsertWithoutPaymentPlanInput = {
    create: PayLaterAuthorizationCreateWithoutPaymentPlanInput;
    update: PayLaterAuthorizationUpdateWithoutPaymentPlanInput;
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type PayLaterAuthorizationWhereInput = {
    AND?: InputMaybe<Array<PayLaterAuthorizationWhereInput>>;
    NOT?: InputMaybe<Array<PayLaterAuthorizationWhereInput>>;
    OR?: InputMaybe<Array<PayLaterAuthorizationWhereInput>>;
    activationMessageAttemptedAt?: InputMaybe<DateTimeNullableFilter>;
    activationMessageErrorDetails?: InputMaybe<StringNullableFilter>;
    appointmentId?: InputMaybe<UuidFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalFilter>;
    depositCollectedAt?: InputMaybe<DateTimeNullableFilter>;
    depositTransaction?: InputMaybe<TransactionNullableRelationFilter>;
    depositTransactionId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationRelationFilter>;
    paymentAuthorizationId?: InputMaybe<UuidFilter>;
    paymentPlan?: InputMaybe<PaymentPlanNullableRelationFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    revokedAt?: InputMaybe<DateTimeNullableFilter>;
    revokedReason?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PayLaterAuthorizationWhereUniqueInput = {
    AND?: InputMaybe<Array<PayLaterAuthorizationWhereInput>>;
    NOT?: InputMaybe<Array<PayLaterAuthorizationWhereInput>>;
    OR?: InputMaybe<Array<PayLaterAuthorizationWhereInput>>;
    activationMessageAttemptedAt?: InputMaybe<DateTimeNullableFilter>;
    activationMessageErrorDetails?: InputMaybe<StringNullableFilter>;
    appointmentId?: InputMaybe<UuidFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalFilter>;
    depositCollectedAt?: InputMaybe<DateTimeNullableFilter>;
    depositTransaction?: InputMaybe<TransactionNullableRelationFilter>;
    depositTransactionId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationRelationFilter>;
    paymentAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    paymentPlan?: InputMaybe<PaymentPlanNullableRelationFilter>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    revokedAt?: InputMaybe<DateTimeNullableFilter>;
    revokedReason?: InputMaybe<StringNullableFilter>;
    status?: InputMaybe<EnumPayLaterAuthorizationStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Payer = {
    __typename?: 'Payer';
    PayerToEhrInsurancePackage: Array<PayerToEhrInsurancePackageMapping>;
    PlanPayerMapping: Array<PayerPlanMapping>;
    _count?: Maybe<PayerCount>;
    active: Scalars['Boolean']['output'];
    availityPayerCode?: Maybe<Scalars['String']['output']>;
    bcbs: Scalars['Boolean']['output'];
    id: Scalars['Int']['output'];
    payerName: Scalars['String']['output'];
    pverifyPayerCode?: Maybe<Scalars['String']['output']>;
    ribbonCarrierName?: Maybe<Scalars['String']['output']>;
};

export type PayerPayerToEhrInsurancePackageArgs = {
    cursor?: InputMaybe<PayerToEhrInsurancePackageMappingWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type PayerPlanPayerMappingArgs = {
    cursor?: InputMaybe<PayerPlanMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayerPlanMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayerPlanMappingOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerPlanMappingWhereInput>;
};

export type PayerAvgAggregate = {
    __typename?: 'PayerAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type PayerAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type PayerCount = {
    __typename?: 'PayerCount';
    PayerToEhrInsurancePackage: Scalars['Int']['output'];
    PlanPayerMapping: Scalars['Int']['output'];
};

export type PayerCountPayerToEhrInsurancePackageArgs = {
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type PayerCountPlanPayerMappingArgs = {
    where?: InputMaybe<PayerPlanMappingWhereInput>;
};

export type PayerCountAggregate = {
    __typename?: 'PayerCountAggregate';
    _all: Scalars['Int']['output'];
    active: Scalars['Int']['output'];
    availityPayerCode: Scalars['Int']['output'];
    bcbs: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    payerName: Scalars['Int']['output'];
    pverifyPayerCode: Scalars['Int']['output'];
    ribbonCarrierName: Scalars['Int']['output'];
};

export type PayerCountOrderByAggregateInput = {
    active?: InputMaybe<SortOrder>;
    availityPayerCode?: InputMaybe<SortOrder>;
    bcbs?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payerName?: InputMaybe<SortOrder>;
    pverifyPayerCode?: InputMaybe<SortOrder>;
    ribbonCarrierName?: InputMaybe<SortOrder>;
};

export type PayerCreateInput = {
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutPayerInput>;
    PlanPayerMapping?: InputMaybe<PayerPlanMappingCreateNestedManyWithoutPayerInput>;
    active?: InputMaybe<Scalars['Boolean']['input']>;
    availityPayerCode?: InputMaybe<Scalars['String']['input']>;
    bcbs?: InputMaybe<Scalars['Boolean']['input']>;
    payerName: Scalars['String']['input'];
    pverifyPayerCode?: InputMaybe<Scalars['String']['input']>;
    ribbonCarrierName?: InputMaybe<Scalars['String']['input']>;
};

export type PayerCreateManyInput = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    availityPayerCode?: InputMaybe<Scalars['String']['input']>;
    bcbs?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    payerName: Scalars['String']['input'];
    pverifyPayerCode?: InputMaybe<Scalars['String']['input']>;
    ribbonCarrierName?: InputMaybe<Scalars['String']['input']>;
};

export type PayerCreateNestedOneWithoutPayerToEhrInsurancePackageInput = {
    connect?: InputMaybe<PayerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PayerCreateOrConnectWithoutPayerToEhrInsurancePackageInput>;
    create?: InputMaybe<PayerCreateWithoutPayerToEhrInsurancePackageInput>;
};

export type PayerCreateNestedOneWithoutPlanPayerMappingInput = {
    connect?: InputMaybe<PayerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PayerCreateOrConnectWithoutPlanPayerMappingInput>;
    create?: InputMaybe<PayerCreateWithoutPlanPayerMappingInput>;
};

export type PayerCreateOrConnectWithoutPayerToEhrInsurancePackageInput = {
    create: PayerCreateWithoutPayerToEhrInsurancePackageInput;
    where: PayerWhereUniqueInput;
};

export type PayerCreateOrConnectWithoutPlanPayerMappingInput = {
    create: PayerCreateWithoutPlanPayerMappingInput;
    where: PayerWhereUniqueInput;
};

export type PayerCreateWithoutPayerToEhrInsurancePackageInput = {
    PlanPayerMapping?: InputMaybe<PayerPlanMappingCreateNestedManyWithoutPayerInput>;
    active?: InputMaybe<Scalars['Boolean']['input']>;
    availityPayerCode?: InputMaybe<Scalars['String']['input']>;
    bcbs?: InputMaybe<Scalars['Boolean']['input']>;
    payerName: Scalars['String']['input'];
    pverifyPayerCode?: InputMaybe<Scalars['String']['input']>;
    ribbonCarrierName?: InputMaybe<Scalars['String']['input']>;
};

export type PayerCreateWithoutPlanPayerMappingInput = {
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingCreateNestedManyWithoutPayerInput>;
    active?: InputMaybe<Scalars['Boolean']['input']>;
    availityPayerCode?: InputMaybe<Scalars['String']['input']>;
    bcbs?: InputMaybe<Scalars['Boolean']['input']>;
    payerName: Scalars['String']['input'];
    pverifyPayerCode?: InputMaybe<Scalars['String']['input']>;
    ribbonCarrierName?: InputMaybe<Scalars['String']['input']>;
};

export type PayerGroupBy = {
    __typename?: 'PayerGroupBy';
    _avg?: Maybe<PayerAvgAggregate>;
    _count?: Maybe<PayerCountAggregate>;
    _max?: Maybe<PayerMaxAggregate>;
    _min?: Maybe<PayerMinAggregate>;
    _sum?: Maybe<PayerSumAggregate>;
    active: Scalars['Boolean']['output'];
    availityPayerCode?: Maybe<Scalars['String']['output']>;
    bcbs: Scalars['Boolean']['output'];
    id: Scalars['Int']['output'];
    payerName: Scalars['String']['output'];
    pverifyPayerCode?: Maybe<Scalars['String']['output']>;
    ribbonCarrierName?: Maybe<Scalars['String']['output']>;
};

export type PayerMaxAggregate = {
    __typename?: 'PayerMaxAggregate';
    active?: Maybe<Scalars['Boolean']['output']>;
    availityPayerCode?: Maybe<Scalars['String']['output']>;
    bcbs?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    payerName?: Maybe<Scalars['String']['output']>;
    pverifyPayerCode?: Maybe<Scalars['String']['output']>;
    ribbonCarrierName?: Maybe<Scalars['String']['output']>;
};

export type PayerMaxOrderByAggregateInput = {
    active?: InputMaybe<SortOrder>;
    availityPayerCode?: InputMaybe<SortOrder>;
    bcbs?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payerName?: InputMaybe<SortOrder>;
    pverifyPayerCode?: InputMaybe<SortOrder>;
    ribbonCarrierName?: InputMaybe<SortOrder>;
};

export type PayerMinAggregate = {
    __typename?: 'PayerMinAggregate';
    active?: Maybe<Scalars['Boolean']['output']>;
    availityPayerCode?: Maybe<Scalars['String']['output']>;
    bcbs?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    payerName?: Maybe<Scalars['String']['output']>;
    pverifyPayerCode?: Maybe<Scalars['String']['output']>;
    ribbonCarrierName?: Maybe<Scalars['String']['output']>;
};

export type PayerMinOrderByAggregateInput = {
    active?: InputMaybe<SortOrder>;
    availityPayerCode?: InputMaybe<SortOrder>;
    bcbs?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payerName?: InputMaybe<SortOrder>;
    pverifyPayerCode?: InputMaybe<SortOrder>;
    ribbonCarrierName?: InputMaybe<SortOrder>;
};

export type PayerOrderByWithAggregationInput = {
    _avg?: InputMaybe<PayerAvgOrderByAggregateInput>;
    _count?: InputMaybe<PayerCountOrderByAggregateInput>;
    _max?: InputMaybe<PayerMaxOrderByAggregateInput>;
    _min?: InputMaybe<PayerMinOrderByAggregateInput>;
    _sum?: InputMaybe<PayerSumOrderByAggregateInput>;
    active?: InputMaybe<SortOrder>;
    availityPayerCode?: InputMaybe<SortOrderInput>;
    bcbs?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payerName?: InputMaybe<SortOrder>;
    pverifyPayerCode?: InputMaybe<SortOrderInput>;
    ribbonCarrierName?: InputMaybe<SortOrderInput>;
};

export type PayerOrderByWithRelationInput = {
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingOrderByRelationAggregateInput>;
    PlanPayerMapping?: InputMaybe<PayerPlanMappingOrderByRelationAggregateInput>;
    active?: InputMaybe<SortOrder>;
    availityPayerCode?: InputMaybe<SortOrderInput>;
    bcbs?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    payerName?: InputMaybe<SortOrder>;
    pverifyPayerCode?: InputMaybe<SortOrderInput>;
    ribbonCarrierName?: InputMaybe<SortOrderInput>;
};

export type PayerPlanMapping = {
    __typename?: 'PayerPlanMapping';
    id: Scalars['Int']['output'];
    payer: Payer;
    payerId: Scalars['Int']['output'];
    rawPlanAlias: Scalars['String']['output'];
};

export type PayerPlanMappingAvgAggregate = {
    __typename?: 'PayerPlanMappingAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    payerId?: Maybe<Scalars['Float']['output']>;
};

export type PayerPlanMappingAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
};

export type PayerPlanMappingCountAggregate = {
    __typename?: 'PayerPlanMappingCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    payerId: Scalars['Int']['output'];
    rawPlanAlias: Scalars['Int']['output'];
};

export type PayerPlanMappingCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    rawPlanAlias?: InputMaybe<SortOrder>;
};

export type PayerPlanMappingCreateInput = {
    payer: PayerCreateNestedOneWithoutPlanPayerMappingInput;
    rawPlanAlias: Scalars['String']['input'];
};

export type PayerPlanMappingCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    payerId: Scalars['Int']['input'];
    rawPlanAlias: Scalars['String']['input'];
};

export type PayerPlanMappingCreateManyPayerInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    rawPlanAlias: Scalars['String']['input'];
};

export type PayerPlanMappingCreateManyPayerInputEnvelope = {
    data: Array<PayerPlanMappingCreateManyPayerInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayerPlanMappingCreateNestedManyWithoutPayerInput = {
    connect?: InputMaybe<Array<PayerPlanMappingWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PayerPlanMappingCreateOrConnectWithoutPayerInput>
    >;
    create?: InputMaybe<Array<PayerPlanMappingCreateWithoutPayerInput>>;
    createMany?: InputMaybe<PayerPlanMappingCreateManyPayerInputEnvelope>;
};

export type PayerPlanMappingCreateOrConnectWithoutPayerInput = {
    create: PayerPlanMappingCreateWithoutPayerInput;
    where: PayerPlanMappingWhereUniqueInput;
};

export type PayerPlanMappingCreateWithoutPayerInput = {
    rawPlanAlias: Scalars['String']['input'];
};

export type PayerPlanMappingGroupBy = {
    __typename?: 'PayerPlanMappingGroupBy';
    _avg?: Maybe<PayerPlanMappingAvgAggregate>;
    _count?: Maybe<PayerPlanMappingCountAggregate>;
    _max?: Maybe<PayerPlanMappingMaxAggregate>;
    _min?: Maybe<PayerPlanMappingMinAggregate>;
    _sum?: Maybe<PayerPlanMappingSumAggregate>;
    id: Scalars['Int']['output'];
    payerId: Scalars['Int']['output'];
    rawPlanAlias: Scalars['String']['output'];
};

export type PayerPlanMappingListRelationFilter = {
    every?: InputMaybe<PayerPlanMappingWhereInput>;
    none?: InputMaybe<PayerPlanMappingWhereInput>;
    some?: InputMaybe<PayerPlanMappingWhereInput>;
};

export type PayerPlanMappingMaxAggregate = {
    __typename?: 'PayerPlanMappingMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
    rawPlanAlias?: Maybe<Scalars['String']['output']>;
};

export type PayerPlanMappingMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    rawPlanAlias?: InputMaybe<SortOrder>;
};

export type PayerPlanMappingMinAggregate = {
    __typename?: 'PayerPlanMappingMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
    rawPlanAlias?: Maybe<Scalars['String']['output']>;
};

export type PayerPlanMappingMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    rawPlanAlias?: InputMaybe<SortOrder>;
};

export type PayerPlanMappingOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PayerPlanMappingOrderByWithAggregationInput = {
    _avg?: InputMaybe<PayerPlanMappingAvgOrderByAggregateInput>;
    _count?: InputMaybe<PayerPlanMappingCountOrderByAggregateInput>;
    _max?: InputMaybe<PayerPlanMappingMaxOrderByAggregateInput>;
    _min?: InputMaybe<PayerPlanMappingMinOrderByAggregateInput>;
    _sum?: InputMaybe<PayerPlanMappingSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    rawPlanAlias?: InputMaybe<SortOrder>;
};

export type PayerPlanMappingOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    payer?: InputMaybe<PayerOrderByWithRelationInput>;
    payerId?: InputMaybe<SortOrder>;
    rawPlanAlias?: InputMaybe<SortOrder>;
};

export enum PayerPlanMappingScalarFieldEnum {
    Id = 'id',
    PayerId = 'payerId',
    RawPlanAlias = 'rawPlanAlias',
}

export type PayerPlanMappingScalarWhereInput = {
    AND?: InputMaybe<Array<PayerPlanMappingScalarWhereInput>>;
    NOT?: InputMaybe<Array<PayerPlanMappingScalarWhereInput>>;
    OR?: InputMaybe<Array<PayerPlanMappingScalarWhereInput>>;
    id?: InputMaybe<IntFilter>;
    payerId?: InputMaybe<IntFilter>;
    rawPlanAlias?: InputMaybe<StringFilter>;
};

export type PayerPlanMappingScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PayerPlanMappingScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PayerPlanMappingScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PayerPlanMappingScalarWhereWithAggregatesInput>>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    payerId?: InputMaybe<IntWithAggregatesFilter>;
    rawPlanAlias?: InputMaybe<StringWithAggregatesFilter>;
};

export type PayerPlanMappingSumAggregate = {
    __typename?: 'PayerPlanMappingSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
};

export type PayerPlanMappingSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
};

export type PayerPlanMappingUpdateInput = {
    payer?: InputMaybe<PayerUpdateOneRequiredWithoutPlanPayerMappingNestedInput>;
    rawPlanAlias?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayerPlanMappingUpdateManyMutationInput = {
    rawPlanAlias?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayerPlanMappingUpdateManyWithWhereWithoutPayerInput = {
    data: PayerPlanMappingUpdateManyMutationInput;
    where: PayerPlanMappingScalarWhereInput;
};

export type PayerPlanMappingUpdateManyWithoutPayerNestedInput = {
    connect?: InputMaybe<Array<PayerPlanMappingWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PayerPlanMappingCreateOrConnectWithoutPayerInput>
    >;
    create?: InputMaybe<Array<PayerPlanMappingCreateWithoutPayerInput>>;
    createMany?: InputMaybe<PayerPlanMappingCreateManyPayerInputEnvelope>;
    delete?: InputMaybe<Array<PayerPlanMappingWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PayerPlanMappingScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PayerPlanMappingWhereUniqueInput>>;
    set?: InputMaybe<Array<PayerPlanMappingWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PayerPlanMappingUpdateWithWhereUniqueWithoutPayerInput>
    >;
    updateMany?: InputMaybe<
        Array<PayerPlanMappingUpdateManyWithWhereWithoutPayerInput>
    >;
    upsert?: InputMaybe<
        Array<PayerPlanMappingUpsertWithWhereUniqueWithoutPayerInput>
    >;
};

export type PayerPlanMappingUpdateWithWhereUniqueWithoutPayerInput = {
    data: PayerPlanMappingUpdateWithoutPayerInput;
    where: PayerPlanMappingWhereUniqueInput;
};

export type PayerPlanMappingUpdateWithoutPayerInput = {
    rawPlanAlias?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayerPlanMappingUpsertWithWhereUniqueWithoutPayerInput = {
    create: PayerPlanMappingCreateWithoutPayerInput;
    update: PayerPlanMappingUpdateWithoutPayerInput;
    where: PayerPlanMappingWhereUniqueInput;
};

export type PayerPlanMappingWhereInput = {
    AND?: InputMaybe<Array<PayerPlanMappingWhereInput>>;
    NOT?: InputMaybe<Array<PayerPlanMappingWhereInput>>;
    OR?: InputMaybe<Array<PayerPlanMappingWhereInput>>;
    id?: InputMaybe<IntFilter>;
    payer?: InputMaybe<PayerRelationFilter>;
    payerId?: InputMaybe<IntFilter>;
    rawPlanAlias?: InputMaybe<StringFilter>;
};

export type PayerPlanMappingWhereUniqueInput = {
    AND?: InputMaybe<Array<PayerPlanMappingWhereInput>>;
    NOT?: InputMaybe<Array<PayerPlanMappingWhereInput>>;
    OR?: InputMaybe<Array<PayerPlanMappingWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    payer?: InputMaybe<PayerRelationFilter>;
    payerId?: InputMaybe<IntFilter>;
    rawPlanAlias?: InputMaybe<Scalars['String']['input']>;
};

export type PayerRelationFilter = {
    is?: InputMaybe<PayerWhereInput>;
    isNot?: InputMaybe<PayerWhereInput>;
};

export enum PayerScalarFieldEnum {
    Active = 'active',
    AvailityPayerCode = 'availityPayerCode',
    Bcbs = 'bcbs',
    Id = 'id',
    PayerName = 'payerName',
    PverifyPayerCode = 'pverifyPayerCode',
    RibbonCarrierName = 'ribbonCarrierName',
}

export type PayerScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PayerScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PayerScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PayerScalarWhereWithAggregatesInput>>;
    active?: InputMaybe<BoolWithAggregatesFilter>;
    availityPayerCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    bcbs?: InputMaybe<BoolWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    payerName?: InputMaybe<StringWithAggregatesFilter>;
    pverifyPayerCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    ribbonCarrierName?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type PayerSumAggregate = {
    __typename?: 'PayerSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type PayerSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type PayerToEhrInsurancePackageMapping = {
    __typename?: 'PayerToEhrInsurancePackageMapping';
    coverageType?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrInsurancePackageId: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    payer: Payer;
    payerId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PayerToEhrInsurancePackageMappingAvgAggregate = {
    __typename?: 'PayerToEhrInsurancePackageMappingAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    payerId?: Maybe<Scalars['Float']['output']>;
};

export type PayerToEhrInsurancePackageMappingAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
};

export type PayerToEhrInsurancePackageMappingCountAggregate = {
    __typename?: 'PayerToEhrInsurancePackageMappingCountAggregate';
    _all: Scalars['Int']['output'];
    coverageType: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    ehrInsurancePackageId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payerId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PayerToEhrInsurancePackageMappingCountOrderByAggregateInput = {
    coverageType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayerToEhrInsurancePackageMappingCreateInput = {
    coverageType?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsurancePackageId: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutPayerToEhrInsurancePackageInput;
    payer: PayerCreateNestedOneWithoutPayerToEhrInsurancePackageInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayerToEhrInsurancePackageMappingCreateManyInput = {
    coverageType?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsurancePackageId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    payerId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayerToEhrInsurancePackageMappingCreateManyOrgInput = {
    coverageType?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsurancePackageId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    payerId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayerToEhrInsurancePackageMappingCreateManyOrgInputEnvelope = {
    data: Array<PayerToEhrInsurancePackageMappingCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayerToEhrInsurancePackageMappingCreateManyPayerInput = {
    coverageType?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsurancePackageId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayerToEhrInsurancePackageMappingCreateManyPayerInputEnvelope = {
    data: Array<PayerToEhrInsurancePackageMappingCreateManyPayerInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayerToEhrInsurancePackageMappingCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingWhereUniqueInput>
    >;
    connectOrCreate?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingCreateWithoutOrgInput>
    >;
    createMany?: InputMaybe<PayerToEhrInsurancePackageMappingCreateManyOrgInputEnvelope>;
};

export type PayerToEhrInsurancePackageMappingCreateNestedManyWithoutPayerInput =
    {
        connect?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingWhereUniqueInput>
        >;
        connectOrCreate?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingCreateOrConnectWithoutPayerInput>
        >;
        create?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingCreateWithoutPayerInput>
        >;
        createMany?: InputMaybe<PayerToEhrInsurancePackageMappingCreateManyPayerInputEnvelope>;
    };

export type PayerToEhrInsurancePackageMappingCreateOrConnectWithoutOrgInput = {
    create: PayerToEhrInsurancePackageMappingCreateWithoutOrgInput;
    where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
};

export type PayerToEhrInsurancePackageMappingCreateOrConnectWithoutPayerInput =
    {
        create: PayerToEhrInsurancePackageMappingCreateWithoutPayerInput;
        where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
    };

export type PayerToEhrInsurancePackageMappingCreateWithoutOrgInput = {
    coverageType?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsurancePackageId: Scalars['String']['input'];
    payer: PayerCreateNestedOneWithoutPayerToEhrInsurancePackageInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayerToEhrInsurancePackageMappingCreateWithoutPayerInput = {
    coverageType?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrInsurancePackageId: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutPayerToEhrInsurancePackageInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayerToEhrInsurancePackageMappingGroupBy = {
    __typename?: 'PayerToEhrInsurancePackageMappingGroupBy';
    _avg?: Maybe<PayerToEhrInsurancePackageMappingAvgAggregate>;
    _count?: Maybe<PayerToEhrInsurancePackageMappingCountAggregate>;
    _max?: Maybe<PayerToEhrInsurancePackageMappingMaxAggregate>;
    _min?: Maybe<PayerToEhrInsurancePackageMappingMinAggregate>;
    _sum?: Maybe<PayerToEhrInsurancePackageMappingSumAggregate>;
    coverageType?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrInsurancePackageId: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payerId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PayerToEhrInsurancePackageMappingListRelationFilter = {
    every?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
    none?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
    some?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type PayerToEhrInsurancePackageMappingMaxAggregate = {
    __typename?: 'PayerToEhrInsurancePackageMappingMaxAggregate';
    coverageType?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayerToEhrInsurancePackageMappingMaxOrderByAggregateInput = {
    coverageType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayerToEhrInsurancePackageMappingMinAggregate = {
    __typename?: 'PayerToEhrInsurancePackageMappingMinAggregate';
    coverageType?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayerToEhrInsurancePackageMappingMinOrderByAggregateInput = {
    coverageType?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayerToEhrInsurancePackageMappingOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PayerToEhrInsurancePackageMappingOrderByWithAggregationInput = {
    _avg?: InputMaybe<PayerToEhrInsurancePackageMappingAvgOrderByAggregateInput>;
    _count?: InputMaybe<PayerToEhrInsurancePackageMappingCountOrderByAggregateInput>;
    _max?: InputMaybe<PayerToEhrInsurancePackageMappingMaxOrderByAggregateInput>;
    _min?: InputMaybe<PayerToEhrInsurancePackageMappingMinOrderByAggregateInput>;
    _sum?: InputMaybe<PayerToEhrInsurancePackageMappingSumOrderByAggregateInput>;
    coverageType?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayerToEhrInsurancePackageMappingOrderByWithRelationInput = {
    coverageType?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    ehrInsurancePackageId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    payer?: InputMaybe<PayerOrderByWithRelationInput>;
    payerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PayerToEhrInsurancePackageMappingScalarFieldEnum {
    CoverageType = 'coverageType',
    CreatedAt = 'createdAt',
    DeletedAt = 'deletedAt',
    EhrInsurancePackageId = 'ehrInsurancePackageId',
    Id = 'id',
    OrgId = 'orgId',
    PayerId = 'payerId',
    UpdatedAt = 'updatedAt',
}

export type PayerToEhrInsurancePackageMappingScalarWhereInput = {
    AND?: InputMaybe<Array<PayerToEhrInsurancePackageMappingScalarWhereInput>>;
    NOT?: InputMaybe<Array<PayerToEhrInsurancePackageMappingScalarWhereInput>>;
    OR?: InputMaybe<Array<PayerToEhrInsurancePackageMappingScalarWhereInput>>;
    coverageType?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrInsurancePackageId?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    orgId?: InputMaybe<IntFilter>;
    payerId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PayerToEhrInsurancePackageMappingScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingScalarWhereWithAggregatesInput>
    >;
    coverageType?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    ehrInsurancePackageId?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    payerId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PayerToEhrInsurancePackageMappingSumAggregate = {
    __typename?: 'PayerToEhrInsurancePackageMappingSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
};

export type PayerToEhrInsurancePackageMappingSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
};

export type PayerToEhrInsurancePackageMappingUpdateInput = {
    coverageType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrInsurancePackageId?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPayerToEhrInsurancePackageNestedInput>;
    payer?: InputMaybe<PayerUpdateOneRequiredWithoutPayerToEhrInsurancePackageNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayerToEhrInsurancePackageMappingUpdateManyMutationInput = {
    coverageType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrInsurancePackageId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayerToEhrInsurancePackageMappingUpdateManyWithWhereWithoutOrgInput =
    {
        data: PayerToEhrInsurancePackageMappingUpdateManyMutationInput;
        where: PayerToEhrInsurancePackageMappingScalarWhereInput;
    };

export type PayerToEhrInsurancePackageMappingUpdateManyWithWhereWithoutPayerInput =
    {
        data: PayerToEhrInsurancePackageMappingUpdateManyMutationInput;
        where: PayerToEhrInsurancePackageMappingScalarWhereInput;
    };

export type PayerToEhrInsurancePackageMappingUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingWhereUniqueInput>
    >;
    connectOrCreate?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingCreateWithoutOrgInput>
    >;
    createMany?: InputMaybe<PayerToEhrInsurancePackageMappingCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingWhereUniqueInput>
    >;
    deleteMany?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingScalarWhereInput>
    >;
    disconnect?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingWhereUniqueInput>
    >;
    set?: InputMaybe<Array<PayerToEhrInsurancePackageMappingWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type PayerToEhrInsurancePackageMappingUpdateManyWithoutPayerNestedInput =
    {
        connect?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingWhereUniqueInput>
        >;
        connectOrCreate?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingCreateOrConnectWithoutPayerInput>
        >;
        create?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingCreateWithoutPayerInput>
        >;
        createMany?: InputMaybe<PayerToEhrInsurancePackageMappingCreateManyPayerInputEnvelope>;
        delete?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingWhereUniqueInput>
        >;
        deleteMany?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingScalarWhereInput>
        >;
        disconnect?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingWhereUniqueInput>
        >;
        set?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingWhereUniqueInput>
        >;
        update?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingUpdateWithWhereUniqueWithoutPayerInput>
        >;
        updateMany?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingUpdateManyWithWhereWithoutPayerInput>
        >;
        upsert?: InputMaybe<
            Array<PayerToEhrInsurancePackageMappingUpsertWithWhereUniqueWithoutPayerInput>
        >;
    };

export type PayerToEhrInsurancePackageMappingUpdateWithWhereUniqueWithoutOrgInput =
    {
        data: PayerToEhrInsurancePackageMappingUpdateWithoutOrgInput;
        where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
    };

export type PayerToEhrInsurancePackageMappingUpdateWithWhereUniqueWithoutPayerInput =
    {
        data: PayerToEhrInsurancePackageMappingUpdateWithoutPayerInput;
        where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
    };

export type PayerToEhrInsurancePackageMappingUpdateWithoutOrgInput = {
    coverageType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrInsurancePackageId?: InputMaybe<StringFieldUpdateOperationsInput>;
    payer?: InputMaybe<PayerUpdateOneRequiredWithoutPayerToEhrInsurancePackageNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayerToEhrInsurancePackageMappingUpdateWithoutPayerInput = {
    coverageType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    ehrInsurancePackageId?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPayerToEhrInsurancePackageNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayerToEhrInsurancePackageMappingUpsertWithWhereUniqueWithoutOrgInput =
    {
        create: PayerToEhrInsurancePackageMappingCreateWithoutOrgInput;
        update: PayerToEhrInsurancePackageMappingUpdateWithoutOrgInput;
        where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
    };

export type PayerToEhrInsurancePackageMappingUpsertWithWhereUniqueWithoutPayerInput =
    {
        create: PayerToEhrInsurancePackageMappingCreateWithoutPayerInput;
        update: PayerToEhrInsurancePackageMappingUpdateWithoutPayerInput;
        where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
    };

export type PayerToEhrInsurancePackageMappingWhereInput = {
    AND?: InputMaybe<Array<PayerToEhrInsurancePackageMappingWhereInput>>;
    NOT?: InputMaybe<Array<PayerToEhrInsurancePackageMappingWhereInput>>;
    OR?: InputMaybe<Array<PayerToEhrInsurancePackageMappingWhereInput>>;
    coverageType?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrInsurancePackageId?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    payer?: InputMaybe<PayerRelationFilter>;
    payerId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PayerToEhrInsurancePackageMappingWhereUniqueInput = {
    AND?: InputMaybe<Array<PayerToEhrInsurancePackageMappingWhereInput>>;
    NOT?: InputMaybe<Array<PayerToEhrInsurancePackageMappingWhereInput>>;
    OR?: InputMaybe<Array<PayerToEhrInsurancePackageMappingWhereInput>>;
    coverageType?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    ehrInsurancePackageId?: InputMaybe<StringFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    payer?: InputMaybe<PayerRelationFilter>;
    payerId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PayerUpdateInput = {
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutPayerNestedInput>;
    PlanPayerMapping?: InputMaybe<PayerPlanMappingUpdateManyWithoutPayerNestedInput>;
    active?: InputMaybe<BoolFieldUpdateOperationsInput>;
    availityPayerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    bcbs?: InputMaybe<BoolFieldUpdateOperationsInput>;
    payerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    pverifyPayerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ribbonCarrierName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PayerUpdateManyMutationInput = {
    active?: InputMaybe<BoolFieldUpdateOperationsInput>;
    availityPayerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    bcbs?: InputMaybe<BoolFieldUpdateOperationsInput>;
    payerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    pverifyPayerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ribbonCarrierName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PayerUpdateOneRequiredWithoutPayerToEhrInsurancePackageNestedInput =
    {
        connect?: InputMaybe<PayerWhereUniqueInput>;
        connectOrCreate?: InputMaybe<PayerCreateOrConnectWithoutPayerToEhrInsurancePackageInput>;
        create?: InputMaybe<PayerCreateWithoutPayerToEhrInsurancePackageInput>;
        update?: InputMaybe<PayerUpdateToOneWithWhereWithoutPayerToEhrInsurancePackageInput>;
        upsert?: InputMaybe<PayerUpsertWithoutPayerToEhrInsurancePackageInput>;
    };

export type PayerUpdateOneRequiredWithoutPlanPayerMappingNestedInput = {
    connect?: InputMaybe<PayerWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PayerCreateOrConnectWithoutPlanPayerMappingInput>;
    create?: InputMaybe<PayerCreateWithoutPlanPayerMappingInput>;
    update?: InputMaybe<PayerUpdateToOneWithWhereWithoutPlanPayerMappingInput>;
    upsert?: InputMaybe<PayerUpsertWithoutPlanPayerMappingInput>;
};

export type PayerUpdateToOneWithWhereWithoutPayerToEhrInsurancePackageInput = {
    data: PayerUpdateWithoutPayerToEhrInsurancePackageInput;
    where?: InputMaybe<PayerWhereInput>;
};

export type PayerUpdateToOneWithWhereWithoutPlanPayerMappingInput = {
    data: PayerUpdateWithoutPlanPayerMappingInput;
    where?: InputMaybe<PayerWhereInput>;
};

export type PayerUpdateWithoutPayerToEhrInsurancePackageInput = {
    PlanPayerMapping?: InputMaybe<PayerPlanMappingUpdateManyWithoutPayerNestedInput>;
    active?: InputMaybe<BoolFieldUpdateOperationsInput>;
    availityPayerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    bcbs?: InputMaybe<BoolFieldUpdateOperationsInput>;
    payerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    pverifyPayerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ribbonCarrierName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PayerUpdateWithoutPlanPayerMappingInput = {
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingUpdateManyWithoutPayerNestedInput>;
    active?: InputMaybe<BoolFieldUpdateOperationsInput>;
    availityPayerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    bcbs?: InputMaybe<BoolFieldUpdateOperationsInput>;
    payerName?: InputMaybe<StringFieldUpdateOperationsInput>;
    pverifyPayerCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ribbonCarrierName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PayerUpsertWithoutPayerToEhrInsurancePackageInput = {
    create: PayerCreateWithoutPayerToEhrInsurancePackageInput;
    update: PayerUpdateWithoutPayerToEhrInsurancePackageInput;
    where?: InputMaybe<PayerWhereInput>;
};

export type PayerUpsertWithoutPlanPayerMappingInput = {
    create: PayerCreateWithoutPlanPayerMappingInput;
    update: PayerUpdateWithoutPlanPayerMappingInput;
    where?: InputMaybe<PayerWhereInput>;
};

export type PayerWhereInput = {
    AND?: InputMaybe<Array<PayerWhereInput>>;
    NOT?: InputMaybe<Array<PayerWhereInput>>;
    OR?: InputMaybe<Array<PayerWhereInput>>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingListRelationFilter>;
    PlanPayerMapping?: InputMaybe<PayerPlanMappingListRelationFilter>;
    active?: InputMaybe<BoolFilter>;
    availityPayerCode?: InputMaybe<StringNullableFilter>;
    bcbs?: InputMaybe<BoolFilter>;
    id?: InputMaybe<IntFilter>;
    payerName?: InputMaybe<StringFilter>;
    pverifyPayerCode?: InputMaybe<StringNullableFilter>;
    ribbonCarrierName?: InputMaybe<StringNullableFilter>;
};

export type PayerWhereUniqueInput = {
    AND?: InputMaybe<Array<PayerWhereInput>>;
    NOT?: InputMaybe<Array<PayerWhereInput>>;
    OR?: InputMaybe<Array<PayerWhereInput>>;
    PayerToEhrInsurancePackage?: InputMaybe<PayerToEhrInsurancePackageMappingListRelationFilter>;
    PlanPayerMapping?: InputMaybe<PayerPlanMappingListRelationFilter>;
    active?: InputMaybe<BoolFilter>;
    availityPayerCode?: InputMaybe<StringNullableFilter>;
    bcbs?: InputMaybe<BoolFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    payerName?: InputMaybe<Scalars['String']['input']>;
    pverifyPayerCode?: InputMaybe<StringNullableFilter>;
    ribbonCarrierName?: InputMaybe<StringNullableFilter>;
};

export type PaymentAuthorization = {
    __typename?: 'PaymentAuthorization';
    _count?: Maybe<PaymentAuthorizationCount>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    consentText: Scalars['String']['output'];
    consentType: PaymentAuthorizationConsentType;
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    consentedAt: Scalars['DateTimeISO']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    ipAddress?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    payLaterAuthorization?: Maybe<PayLaterAuthorization>;
    paymentPlans: Array<PaymentPlan>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentAuthorizationPayLaterAuthorizationArgs = {
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type PaymentAuthorizationPaymentPlansArgs = {
    cursor?: InputMaybe<PaymentPlanWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentAuthorizationAuditLog = {
    __typename?: 'PaymentAuthorizationAuditLog';
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    consentText?: Maybe<Scalars['String']['output']>;
    consentType?: Maybe<PaymentAuthorizationConsentType>;
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    consentedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    ipAddress?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentAuthorizationAuditLogAvgAggregate = {
    __typename?: 'PaymentAuthorizationAuditLogAvgAggregate';
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type PaymentAuthorizationAuditLogAvgOrderByAggregateInput = {
    consentedAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationAuditLogCountAggregate = {
    __typename?: 'PaymentAuthorizationAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    cardAuthorizationId: Scalars['Int']['output'];
    cardLastFourDigits: Scalars['Int']['output'];
    consentText: Scalars['Int']['output'];
    consentType: Scalars['Int']['output'];
    consentedAmount: Scalars['Int']['output'];
    consentedAt: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    ipAddress: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentAuthorizationId: Scalars['Int']['output'];
    revokedAt: Scalars['Int']['output'];
    revokedReason: Scalars['Int']['output'];
    stripePaymentMethodId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PaymentAuthorizationAuditLogCountOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    consentText?: InputMaybe<SortOrder>;
    consentType?: InputMaybe<SortOrder>;
    consentedAmount?: InputMaybe<SortOrder>;
    consentedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    ipAddress?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationAuditLogCreateInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    cardAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    consentText?: InputMaybe<Scalars['String']['input']>;
    consentType?: InputMaybe<PaymentAuthorizationConsentType>;
    consentedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    consentedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ipAddress?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentAuthorizationAuditLogCreateManyInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    cardAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    consentText?: InputMaybe<Scalars['String']['input']>;
    consentType?: InputMaybe<PaymentAuthorizationConsentType>;
    consentedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    consentedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    ipAddress?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentAuthorizationAuditLogGroupBy = {
    __typename?: 'PaymentAuthorizationAuditLogGroupBy';
    _avg?: Maybe<PaymentAuthorizationAuditLogAvgAggregate>;
    _count?: Maybe<PaymentAuthorizationAuditLogCountAggregate>;
    _max?: Maybe<PaymentAuthorizationAuditLogMaxAggregate>;
    _min?: Maybe<PaymentAuthorizationAuditLogMinAggregate>;
    _sum?: Maybe<PaymentAuthorizationAuditLogSumAggregate>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    consentText?: Maybe<Scalars['String']['output']>;
    consentType?: Maybe<PaymentAuthorizationConsentType>;
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    consentedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    ipAddress?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentAuthorizationAuditLogMaxAggregate = {
    __typename?: 'PaymentAuthorizationAuditLogMaxAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    consentText?: Maybe<Scalars['String']['output']>;
    consentType?: Maybe<PaymentAuthorizationConsentType>;
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    consentedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    ipAddress?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentAuthorizationAuditLogMaxOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    consentText?: InputMaybe<SortOrder>;
    consentType?: InputMaybe<SortOrder>;
    consentedAmount?: InputMaybe<SortOrder>;
    consentedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    ipAddress?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationAuditLogMinAggregate = {
    __typename?: 'PaymentAuthorizationAuditLogMinAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    consentText?: Maybe<Scalars['String']['output']>;
    consentType?: Maybe<PaymentAuthorizationConsentType>;
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    consentedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    ipAddress?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentAuthorizationAuditLogMinOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    consentText?: InputMaybe<SortOrder>;
    consentType?: InputMaybe<SortOrder>;
    consentedAmount?: InputMaybe<SortOrder>;
    consentedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    ipAddress?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentAuthorizationAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentAuthorizationAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentAuthorizationAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentAuthorizationAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentAuthorizationAuditLogSumOrderByAggregateInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    cardAuthorizationId?: InputMaybe<SortOrderInput>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    consentText?: InputMaybe<SortOrderInput>;
    consentType?: InputMaybe<SortOrderInput>;
    consentedAmount?: InputMaybe<SortOrderInput>;
    consentedAt?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    ipAddress?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    paymentAuthorizationId?: InputMaybe<SortOrderInput>;
    revokedAt?: InputMaybe<SortOrderInput>;
    revokedReason?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationAuditLogOrderByWithRelationInput = {
    appointmentId?: InputMaybe<SortOrderInput>;
    cardAuthorizationId?: InputMaybe<SortOrderInput>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    consentText?: InputMaybe<SortOrderInput>;
    consentType?: InputMaybe<SortOrderInput>;
    consentedAmount?: InputMaybe<SortOrderInput>;
    consentedAt?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    ipAddress?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    paymentAuthorizationId?: InputMaybe<SortOrderInput>;
    revokedAt?: InputMaybe<SortOrderInput>;
    revokedReason?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentAuthorizationAuditLogScalarFieldEnum {
    AppointmentId = 'appointmentId',
    CardAuthorizationId = 'cardAuthorizationId',
    CardLastFourDigits = 'cardLastFourDigits',
    ConsentText = 'consentText',
    ConsentType = 'consentType',
    ConsentedAmount = 'consentedAmount',
    ConsentedAt = 'consentedAt',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    Id = 'id',
    IpAddress = 'ipAddress',
    LastUpdatedBy = 'lastUpdatedBy',
    Operation = 'operation',
    OrgId = 'orgId',
    PaymentAuthorizationId = 'paymentAuthorizationId',
    RevokedAt = 'revokedAt',
    RevokedReason = 'revokedReason',
    StripePaymentMethodId = 'stripePaymentMethodId',
    UpdatedAt = 'updatedAt',
}

export type PaymentAuthorizationAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PaymentAuthorizationAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PaymentAuthorizationAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<PaymentAuthorizationAuditLogScalarWhereWithAggregatesInput>
    >;
    appointmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    cardAuthorizationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableWithAggregatesFilter>;
    consentText?: InputMaybe<StringNullableWithAggregatesFilter>;
    consentType?: InputMaybe<EnumPaymentAuthorizationConsentTypeNullableWithAggregatesFilter>;
    consentedAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    consentedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    ipAddress?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    revokedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    revokedReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PaymentAuthorizationAuditLogSumAggregate = {
    __typename?: 'PaymentAuthorizationAuditLogSumAggregate';
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentAuthorizationAuditLogSumOrderByAggregateInput = {
    consentedAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationAuditLogUpdateInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consentText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consentType?: InputMaybe<NullableEnumPaymentAuthorizationConsentTypeFieldUpdateOperationsInput>;
    consentedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consentedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentAuthorizationAuditLogUpdateManyMutationInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consentText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consentType?: InputMaybe<NullableEnumPaymentAuthorizationConsentTypeFieldUpdateOperationsInput>;
    consentedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consentedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentAuthorizationAuditLogWhereInput = {
    AND?: InputMaybe<Array<PaymentAuthorizationAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentAuthorizationAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentAuthorizationAuditLogWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    cardAuthorizationId?: InputMaybe<UuidNullableFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    consentText?: InputMaybe<StringNullableFilter>;
    consentType?: InputMaybe<EnumPaymentAuthorizationConsentTypeNullableFilter>;
    consentedAmount?: InputMaybe<DecimalNullableFilter>;
    consentedAt?: InputMaybe<DateTimeNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    ipAddress?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableFilter>;
    revokedAt?: InputMaybe<DateTimeNullableFilter>;
    revokedReason?: InputMaybe<StringNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentAuthorizationAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentAuthorizationAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentAuthorizationAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentAuthorizationAuditLogWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    cardAuthorizationId?: InputMaybe<UuidNullableFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    consentText?: InputMaybe<StringNullableFilter>;
    consentType?: InputMaybe<EnumPaymentAuthorizationConsentTypeNullableFilter>;
    consentedAmount?: InputMaybe<DecimalNullableFilter>;
    consentedAt?: InputMaybe<DateTimeNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    ipAddress?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableFilter>;
    revokedAt?: InputMaybe<DateTimeNullableFilter>;
    revokedReason?: InputMaybe<StringNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentAuthorizationAvgAggregate = {
    __typename?: 'PaymentAuthorizationAvgAggregate';
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type PaymentAuthorizationAvgOrderByAggregateInput = {
    consentedAmount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export enum PaymentAuthorizationConsentType {
    CardOnFile = 'CARD_ON_FILE',
    PaymentPlan = 'PAYMENT_PLAN',
    PayLater = 'PAY_LATER',
}

export type PaymentAuthorizationCount = {
    __typename?: 'PaymentAuthorizationCount';
    paymentPlans: Scalars['Int']['output'];
};

export type PaymentAuthorizationCountPaymentPlansArgs = {
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentAuthorizationCountAggregate = {
    __typename?: 'PaymentAuthorizationCountAggregate';
    _all: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    cardAuthorizationId: Scalars['Int']['output'];
    cardLastFourDigits: Scalars['Int']['output'];
    consentText: Scalars['Int']['output'];
    consentType: Scalars['Int']['output'];
    consentedAmount: Scalars['Int']['output'];
    consentedAt: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    ipAddress: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    revokedAt: Scalars['Int']['output'];
    revokedReason: Scalars['Int']['output'];
    stripePaymentMethodId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PaymentAuthorizationCountOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    consentText?: InputMaybe<SortOrder>;
    consentType?: InputMaybe<SortOrder>;
    consentedAmount?: InputMaybe<SortOrder>;
    consentedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    ipAddress?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationCreateInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    cardAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    consentText: Scalars['String']['input'];
    consentType: PaymentAuthorizationConsentType;
    consentedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    consentedAt: Scalars['DateTimeISO']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    ipAddress?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationCreateNestedOneWithoutPaymentAuthorizationInput>;
    paymentPlans?: InputMaybe<PaymentPlanCreateNestedManyWithoutPaymentAuthorizationInput>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentAuthorizationCreateManyInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    cardAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    consentText: Scalars['String']['input'];
    consentType: PaymentAuthorizationConsentType;
    consentedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    consentedAt: Scalars['DateTimeISO']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    ipAddress?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentAuthorizationCreateNestedOneWithoutPayLaterAuthorizationInput =
    {
        connect?: InputMaybe<PaymentAuthorizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<PaymentAuthorizationCreateOrConnectWithoutPayLaterAuthorizationInput>;
        create?: InputMaybe<PaymentAuthorizationCreateWithoutPayLaterAuthorizationInput>;
    };

export type PaymentAuthorizationCreateNestedOneWithoutPaymentPlansInput = {
    connect?: InputMaybe<PaymentAuthorizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PaymentAuthorizationCreateOrConnectWithoutPaymentPlansInput>;
    create?: InputMaybe<PaymentAuthorizationCreateWithoutPaymentPlansInput>;
};

export type PaymentAuthorizationCreateOrConnectWithoutPayLaterAuthorizationInput =
    {
        create: PaymentAuthorizationCreateWithoutPayLaterAuthorizationInput;
        where: PaymentAuthorizationWhereUniqueInput;
    };

export type PaymentAuthorizationCreateOrConnectWithoutPaymentPlansInput = {
    create: PaymentAuthorizationCreateWithoutPaymentPlansInput;
    where: PaymentAuthorizationWhereUniqueInput;
};

export type PaymentAuthorizationCreateWithoutPayLaterAuthorizationInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    cardAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    consentText: Scalars['String']['input'];
    consentType: PaymentAuthorizationConsentType;
    consentedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    consentedAt: Scalars['DateTimeISO']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    ipAddress?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    paymentPlans?: InputMaybe<PaymentPlanCreateNestedManyWithoutPaymentAuthorizationInput>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentAuthorizationCreateWithoutPaymentPlansInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    cardAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    consentText: Scalars['String']['input'];
    consentType: PaymentAuthorizationConsentType;
    consentedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    consentedAt: Scalars['DateTimeISO']['input'];
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    ipAddress?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationCreateNestedOneWithoutPaymentAuthorizationInput>;
    revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    revokedReason?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentAuthorizationGroupBy = {
    __typename?: 'PaymentAuthorizationGroupBy';
    _avg?: Maybe<PaymentAuthorizationAvgAggregate>;
    _count?: Maybe<PaymentAuthorizationCountAggregate>;
    _max?: Maybe<PaymentAuthorizationMaxAggregate>;
    _min?: Maybe<PaymentAuthorizationMinAggregate>;
    _sum?: Maybe<PaymentAuthorizationSumAggregate>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    consentText: Scalars['String']['output'];
    consentType: PaymentAuthorizationConsentType;
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    consentedAt: Scalars['DateTimeISO']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    ipAddress?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentAuthorizationMaxAggregate = {
    __typename?: 'PaymentAuthorizationMaxAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    consentText?: Maybe<Scalars['String']['output']>;
    consentType?: Maybe<PaymentAuthorizationConsentType>;
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    consentedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    ipAddress?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentAuthorizationMaxOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    consentText?: InputMaybe<SortOrder>;
    consentType?: InputMaybe<SortOrder>;
    consentedAmount?: InputMaybe<SortOrder>;
    consentedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    ipAddress?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationMinAggregate = {
    __typename?: 'PaymentAuthorizationMinAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    cardAuthorizationId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    consentText?: Maybe<Scalars['String']['output']>;
    consentType?: Maybe<PaymentAuthorizationConsentType>;
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    consentedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    ipAddress?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    revokedReason?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentAuthorizationMinOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    cardAuthorizationId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    consentText?: InputMaybe<SortOrder>;
    consentType?: InputMaybe<SortOrder>;
    consentedAmount?: InputMaybe<SortOrder>;
    consentedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    ipAddress?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrder>;
    revokedReason?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationNullableRelationFilter = {
    is?: InputMaybe<PaymentAuthorizationWhereInput>;
    isNot?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type PaymentAuthorizationOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentAuthorizationAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentAuthorizationCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentAuthorizationMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentAuthorizationMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentAuthorizationSumOrderByAggregateInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    cardAuthorizationId?: InputMaybe<SortOrderInput>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    consentText?: InputMaybe<SortOrder>;
    consentType?: InputMaybe<SortOrder>;
    consentedAmount?: InputMaybe<SortOrderInput>;
    consentedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    ipAddress?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    revokedAt?: InputMaybe<SortOrderInput>;
    revokedReason?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationOrderByWithRelationInput = {
    appointmentId?: InputMaybe<SortOrderInput>;
    cardAuthorizationId?: InputMaybe<SortOrderInput>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    consentText?: InputMaybe<SortOrder>;
    consentType?: InputMaybe<SortOrder>;
    consentedAmount?: InputMaybe<SortOrderInput>;
    consentedAt?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    ipAddress?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationOrderByWithRelationInput>;
    paymentPlans?: InputMaybe<PaymentPlanOrderByRelationAggregateInput>;
    revokedAt?: InputMaybe<SortOrderInput>;
    revokedReason?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationRelationFilter = {
    is?: InputMaybe<PaymentAuthorizationWhereInput>;
    isNot?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export enum PaymentAuthorizationScalarFieldEnum {
    AppointmentId = 'appointmentId',
    CardAuthorizationId = 'cardAuthorizationId',
    CardLastFourDigits = 'cardLastFourDigits',
    ConsentText = 'consentText',
    ConsentType = 'consentType',
    ConsentedAmount = 'consentedAmount',
    ConsentedAt = 'consentedAt',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    Id = 'id',
    IpAddress = 'ipAddress',
    LastUpdatedBy = 'lastUpdatedBy',
    OrgId = 'orgId',
    RevokedAt = 'revokedAt',
    RevokedReason = 'revokedReason',
    StripePaymentMethodId = 'stripePaymentMethodId',
    UpdatedAt = 'updatedAt',
}

export type PaymentAuthorizationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PaymentAuthorizationScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PaymentAuthorizationScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PaymentAuthorizationScalarWhereWithAggregatesInput>>;
    appointmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    cardAuthorizationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableWithAggregatesFilter>;
    consentText?: InputMaybe<StringWithAggregatesFilter>;
    consentType?: InputMaybe<EnumPaymentAuthorizationConsentTypeWithAggregatesFilter>;
    consentedAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    consentedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    ipAddress?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    revokedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    revokedReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripePaymentMethodId?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PaymentAuthorizationSumAggregate = {
    __typename?: 'PaymentAuthorizationSumAggregate';
    consentedAmount?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentAuthorizationSumOrderByAggregateInput = {
    consentedAmount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type PaymentAuthorizationUpdateInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consentText?: InputMaybe<StringFieldUpdateOperationsInput>;
    consentType?: InputMaybe<EnumPaymentAuthorizationConsentTypeFieldUpdateOperationsInput>;
    consentedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consentedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationUpdateOneWithoutPaymentAuthorizationNestedInput>;
    paymentPlans?: InputMaybe<PaymentPlanUpdateManyWithoutPaymentAuthorizationNestedInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentAuthorizationUpdateManyMutationInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consentText?: InputMaybe<StringFieldUpdateOperationsInput>;
    consentType?: InputMaybe<EnumPaymentAuthorizationConsentTypeFieldUpdateOperationsInput>;
    consentedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consentedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentAuthorizationUpdateOneRequiredWithoutPayLaterAuthorizationNestedInput =
    {
        connect?: InputMaybe<PaymentAuthorizationWhereUniqueInput>;
        connectOrCreate?: InputMaybe<PaymentAuthorizationCreateOrConnectWithoutPayLaterAuthorizationInput>;
        create?: InputMaybe<PaymentAuthorizationCreateWithoutPayLaterAuthorizationInput>;
        update?: InputMaybe<PaymentAuthorizationUpdateToOneWithWhereWithoutPayLaterAuthorizationInput>;
        upsert?: InputMaybe<PaymentAuthorizationUpsertWithoutPayLaterAuthorizationInput>;
    };

export type PaymentAuthorizationUpdateOneWithoutPaymentPlansNestedInput = {
    connect?: InputMaybe<PaymentAuthorizationWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PaymentAuthorizationCreateOrConnectWithoutPaymentPlansInput>;
    create?: InputMaybe<PaymentAuthorizationCreateWithoutPaymentPlansInput>;
    delete?: InputMaybe<PaymentAuthorizationWhereInput>;
    disconnect?: InputMaybe<PaymentAuthorizationWhereInput>;
    update?: InputMaybe<PaymentAuthorizationUpdateToOneWithWhereWithoutPaymentPlansInput>;
    upsert?: InputMaybe<PaymentAuthorizationUpsertWithoutPaymentPlansInput>;
};

export type PaymentAuthorizationUpdateToOneWithWhereWithoutPayLaterAuthorizationInput =
    {
        data: PaymentAuthorizationUpdateWithoutPayLaterAuthorizationInput;
        where?: InputMaybe<PaymentAuthorizationWhereInput>;
    };

export type PaymentAuthorizationUpdateToOneWithWhereWithoutPaymentPlansInput = {
    data: PaymentAuthorizationUpdateWithoutPaymentPlansInput;
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type PaymentAuthorizationUpdateWithoutPayLaterAuthorizationInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consentText?: InputMaybe<StringFieldUpdateOperationsInput>;
    consentType?: InputMaybe<EnumPaymentAuthorizationConsentTypeFieldUpdateOperationsInput>;
    consentedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consentedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentPlans?: InputMaybe<PaymentPlanUpdateManyWithoutPaymentAuthorizationNestedInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentAuthorizationUpdateWithoutPaymentPlansInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consentText?: InputMaybe<StringFieldUpdateOperationsInput>;
    consentType?: InputMaybe<EnumPaymentAuthorizationConsentTypeFieldUpdateOperationsInput>;
    consentedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consentedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationUpdateOneWithoutPaymentAuthorizationNestedInput>;
    revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    revokedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentAuthorizationUpsertWithoutPayLaterAuthorizationInput = {
    create: PaymentAuthorizationCreateWithoutPayLaterAuthorizationInput;
    update: PaymentAuthorizationUpdateWithoutPayLaterAuthorizationInput;
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type PaymentAuthorizationUpsertWithoutPaymentPlansInput = {
    create: PaymentAuthorizationCreateWithoutPaymentPlansInput;
    update: PaymentAuthorizationUpdateWithoutPaymentPlansInput;
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type PaymentAuthorizationWhereInput = {
    AND?: InputMaybe<Array<PaymentAuthorizationWhereInput>>;
    NOT?: InputMaybe<Array<PaymentAuthorizationWhereInput>>;
    OR?: InputMaybe<Array<PaymentAuthorizationWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    cardAuthorizationId?: InputMaybe<UuidNullableFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    consentText?: InputMaybe<StringFilter>;
    consentType?: InputMaybe<EnumPaymentAuthorizationConsentTypeFilter>;
    consentedAmount?: InputMaybe<DecimalNullableFilter>;
    consentedAt?: InputMaybe<DateTimeFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    ipAddress?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationNullableRelationFilter>;
    paymentPlans?: InputMaybe<PaymentPlanListRelationFilter>;
    revokedAt?: InputMaybe<DateTimeNullableFilter>;
    revokedReason?: InputMaybe<StringNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentAuthorizationWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentAuthorizationWhereInput>>;
    NOT?: InputMaybe<Array<PaymentAuthorizationWhereInput>>;
    OR?: InputMaybe<Array<PaymentAuthorizationWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    cardAuthorizationId?: InputMaybe<UuidNullableFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    consentText?: InputMaybe<StringFilter>;
    consentType?: InputMaybe<EnumPaymentAuthorizationConsentTypeFilter>;
    consentedAmount?: InputMaybe<DecimalNullableFilter>;
    consentedAt?: InputMaybe<DateTimeFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    ipAddress?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationNullableRelationFilter>;
    paymentPlans?: InputMaybe<PaymentPlanListRelationFilter>;
    revokedAt?: InputMaybe<DateTimeNullableFilter>;
    revokedReason?: InputMaybe<StringNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

/**
 * PLA-2474. One row per attempt to pay: what the patient agreed to, frozen,
 * and the one PaymentIntent it goes through. `id` is the Stripe idempotency
 * key for that PI and comes back as metadata `payment_contract_id`.
 * A2 creates it; checkout's finalize ends it inside the payment's transaction.
 */
export type PaymentContract = {
    __typename?: 'PaymentContract';
    /** What the patient agreed to pay. Frozen. */
    authorizedCents: Scalars['Int']['output'];
    /**
     * The staff operator who collected this payment: the Admin's email, resolved
     * by hex-pc from the caller's token at mint. Null for patient and service
     * callers. Frozen after insert by payment_contract_freeze; checkout reads it
     * for Transaction.collectedBy and never writes it. hex-pc owns the migration.
     */
    collectedBy?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    /** Set exactly when the contract is CANCELED. */
    endReason?: Maybe<PaymentContractEndReason>;
    endedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    /** Patient, staff user (kiosk), or job id. */
    initiatedBy: Scalars['String']['output'];
    /** When it was last handed over. Starts at created_at. */
    lastOpenedAt: Scalars['DateTimeISO']['output'];
    /**
     * Who it was last handed to, from the caller's token: the patient, the
     * kiosk staff user, or a service id. Starts at initiated_by.
     */
    lastOpenedBy: Scalars['String']['output'];
    /** What kind of session that was, from the token's claims. Null when unknown. */
    lastOpenedVia?: Maybe<PaymentContractOpenedVia>;
    /**
     * `[{bought_treatment_id, open_amount_cents}]`, one entry per BoughtTreatment
     * with money owed. Frozen after insert by payment_contract_freeze.
     */
    lines: Scalars['JSON']['output'];
    /** sha256 over lines sorted by bought_treatment_id. Frozen. */
    linesHash: Scalars['String']['output'];
    /**
     * How many times this contract was handed to someone to pay. Minting is the
     * first; each A2 reuse (a refresh, a dropped connection, a second tab) adds one.
     */
    openCount: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentIntentId?: Maybe<Scalars['String']['output']>;
    /**
     * Which surface minted it: ACCOUNT, STOREFRONT, SKYLIGHT, KIOSK, BULK or PLAN.
     * A string, not an enum, so a new surface needs no migration; the allowed
     * values are PAYMENT_CONTRACT_RAILS in the payment-contract module.
     */
    rail: Scalars['String']['output'];
    reconciledAt?: Maybe<Scalars['DateTimeISO']['output']>;
    /**
     * Descriptive label: `appointment:<appointmentId>` or `balance:<orgId>:<userId>`.
     * Used to choose lines and for display. Nothing keys on it.
     */
    scope: Scalars['String']['output'];
    status: PaymentContractStatus;
    /** The money-received Transaction, set at reconcile. */
    transactionId?: Maybe<Scalars['String']['output']>;
    userId: Scalars['String']['output'];
};

export type PaymentContractAvgAggregate = {
    __typename?: 'PaymentContractAvgAggregate';
    authorizedCents?: Maybe<Scalars['Float']['output']>;
    openCount?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type PaymentContractAvgOrderByAggregateInput = {
    authorizedCents?: InputMaybe<SortOrder>;
    openCount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type PaymentContractCountAggregate = {
    __typename?: 'PaymentContractCountAggregate';
    _all: Scalars['Int']['output'];
    authorizedCents: Scalars['Int']['output'];
    collectedBy: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    endReason: Scalars['Int']['output'];
    endedAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    initiatedBy: Scalars['Int']['output'];
    lastOpenedAt: Scalars['Int']['output'];
    lastOpenedBy: Scalars['Int']['output'];
    lastOpenedVia: Scalars['Int']['output'];
    lines: Scalars['Int']['output'];
    linesHash: Scalars['Int']['output'];
    openCount: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentIntentId: Scalars['Int']['output'];
    rail: Scalars['Int']['output'];
    reconciledAt: Scalars['Int']['output'];
    scope: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    transactionId: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
};

export type PaymentContractCountOrderByAggregateInput = {
    authorizedCents?: InputMaybe<SortOrder>;
    collectedBy?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    endReason?: InputMaybe<SortOrder>;
    endedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    lastOpenedAt?: InputMaybe<SortOrder>;
    lastOpenedBy?: InputMaybe<SortOrder>;
    lastOpenedVia?: InputMaybe<SortOrder>;
    lines?: InputMaybe<SortOrder>;
    linesHash?: InputMaybe<SortOrder>;
    openCount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentIntentId?: InputMaybe<SortOrder>;
    rail?: InputMaybe<SortOrder>;
    reconciledAt?: InputMaybe<SortOrder>;
    scope?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type PaymentContractCreateInput = {
    authorizedCents: Scalars['Int']['input'];
    collectedBy?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    endReason?: InputMaybe<PaymentContractEndReason>;
    endedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy: Scalars['String']['input'];
    lastOpenedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastOpenedBy: Scalars['String']['input'];
    lastOpenedVia?: InputMaybe<PaymentContractOpenedVia>;
    lines: Scalars['JSON']['input'];
    linesHash: Scalars['String']['input'];
    openCount?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    paymentIntentId?: InputMaybe<Scalars['String']['input']>;
    rail?: InputMaybe<Scalars['String']['input']>;
    reconciledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scope: Scalars['String']['input'];
    status?: InputMaybe<PaymentContractStatus>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    userId: Scalars['String']['input'];
};

export type PaymentContractCreateManyInput = {
    authorizedCents: Scalars['Int']['input'];
    collectedBy?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    endReason?: InputMaybe<PaymentContractEndReason>;
    endedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy: Scalars['String']['input'];
    lastOpenedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastOpenedBy: Scalars['String']['input'];
    lastOpenedVia?: InputMaybe<PaymentContractOpenedVia>;
    lines: Scalars['JSON']['input'];
    linesHash: Scalars['String']['input'];
    openCount?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    paymentIntentId?: InputMaybe<Scalars['String']['input']>;
    rail?: InputMaybe<Scalars['String']['input']>;
    reconciledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scope: Scalars['String']['input'];
    status?: InputMaybe<PaymentContractStatus>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    userId: Scalars['String']['input'];
};

export enum PaymentContractEndReason {
    BillChanged = 'BILL_CHANGED',
    HoldExpired = 'HOLD_EXPIRED',
    NothingOwed = 'NOTHING_OWED',
    StripeCanceled = 'STRIPE_CANCELED',
    Superseded = 'SUPERSEDED',
}

export type PaymentContractGroupBy = {
    __typename?: 'PaymentContractGroupBy';
    _avg?: Maybe<PaymentContractAvgAggregate>;
    _count?: Maybe<PaymentContractCountAggregate>;
    _max?: Maybe<PaymentContractMaxAggregate>;
    _min?: Maybe<PaymentContractMinAggregate>;
    _sum?: Maybe<PaymentContractSumAggregate>;
    authorizedCents: Scalars['Int']['output'];
    collectedBy?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    endReason?: Maybe<PaymentContractEndReason>;
    endedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    initiatedBy: Scalars['String']['output'];
    lastOpenedAt: Scalars['DateTimeISO']['output'];
    lastOpenedBy: Scalars['String']['output'];
    lastOpenedVia?: Maybe<PaymentContractOpenedVia>;
    lines: Scalars['JSON']['output'];
    linesHash: Scalars['String']['output'];
    openCount: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentIntentId?: Maybe<Scalars['String']['output']>;
    rail: Scalars['String']['output'];
    reconciledAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scope: Scalars['String']['output'];
    status: PaymentContractStatus;
    transactionId?: Maybe<Scalars['String']['output']>;
    userId: Scalars['String']['output'];
};

export type PaymentContractMaxAggregate = {
    __typename?: 'PaymentContractMaxAggregate';
    authorizedCents?: Maybe<Scalars['Int']['output']>;
    collectedBy?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    endReason?: Maybe<PaymentContractEndReason>;
    endedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    initiatedBy?: Maybe<Scalars['String']['output']>;
    lastOpenedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastOpenedBy?: Maybe<Scalars['String']['output']>;
    lastOpenedVia?: Maybe<PaymentContractOpenedVia>;
    linesHash?: Maybe<Scalars['String']['output']>;
    openCount?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentIntentId?: Maybe<Scalars['String']['output']>;
    rail?: Maybe<Scalars['String']['output']>;
    reconciledAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scope?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PaymentContractStatus>;
    transactionId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type PaymentContractMaxOrderByAggregateInput = {
    authorizedCents?: InputMaybe<SortOrder>;
    collectedBy?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    endReason?: InputMaybe<SortOrder>;
    endedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    lastOpenedAt?: InputMaybe<SortOrder>;
    lastOpenedBy?: InputMaybe<SortOrder>;
    lastOpenedVia?: InputMaybe<SortOrder>;
    linesHash?: InputMaybe<SortOrder>;
    openCount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentIntentId?: InputMaybe<SortOrder>;
    rail?: InputMaybe<SortOrder>;
    reconciledAt?: InputMaybe<SortOrder>;
    scope?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type PaymentContractMinAggregate = {
    __typename?: 'PaymentContractMinAggregate';
    authorizedCents?: Maybe<Scalars['Int']['output']>;
    collectedBy?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    endReason?: Maybe<PaymentContractEndReason>;
    endedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    initiatedBy?: Maybe<Scalars['String']['output']>;
    lastOpenedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    lastOpenedBy?: Maybe<Scalars['String']['output']>;
    lastOpenedVia?: Maybe<PaymentContractOpenedVia>;
    linesHash?: Maybe<Scalars['String']['output']>;
    openCount?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentIntentId?: Maybe<Scalars['String']['output']>;
    rail?: Maybe<Scalars['String']['output']>;
    reconciledAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scope?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PaymentContractStatus>;
    transactionId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type PaymentContractMinOrderByAggregateInput = {
    authorizedCents?: InputMaybe<SortOrder>;
    collectedBy?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    endReason?: InputMaybe<SortOrder>;
    endedAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    lastOpenedAt?: InputMaybe<SortOrder>;
    lastOpenedBy?: InputMaybe<SortOrder>;
    lastOpenedVia?: InputMaybe<SortOrder>;
    linesHash?: InputMaybe<SortOrder>;
    openCount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentIntentId?: InputMaybe<SortOrder>;
    rail?: InputMaybe<SortOrder>;
    reconciledAt?: InputMaybe<SortOrder>;
    scope?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export enum PaymentContractOpenedVia {
    Minted = 'MINTED',
    OtpLogin = 'OTP_LOGIN',
    Service = 'SERVICE',
    Staff = 'STAFF',
}

export type PaymentContractOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentContractAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentContractCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentContractMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentContractMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentContractSumOrderByAggregateInput>;
    authorizedCents?: InputMaybe<SortOrder>;
    collectedBy?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    endReason?: InputMaybe<SortOrderInput>;
    endedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    lastOpenedAt?: InputMaybe<SortOrder>;
    lastOpenedBy?: InputMaybe<SortOrder>;
    lastOpenedVia?: InputMaybe<SortOrderInput>;
    lines?: InputMaybe<SortOrder>;
    linesHash?: InputMaybe<SortOrder>;
    openCount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentIntentId?: InputMaybe<SortOrderInput>;
    rail?: InputMaybe<SortOrder>;
    reconciledAt?: InputMaybe<SortOrderInput>;
    scope?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrderInput>;
    userId?: InputMaybe<SortOrder>;
};

export type PaymentContractOrderByWithRelationInput = {
    authorizedCents?: InputMaybe<SortOrder>;
    collectedBy?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    endReason?: InputMaybe<SortOrderInput>;
    endedAt?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    lastOpenedAt?: InputMaybe<SortOrder>;
    lastOpenedBy?: InputMaybe<SortOrder>;
    lastOpenedVia?: InputMaybe<SortOrderInput>;
    lines?: InputMaybe<SortOrder>;
    linesHash?: InputMaybe<SortOrder>;
    openCount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentIntentId?: InputMaybe<SortOrderInput>;
    rail?: InputMaybe<SortOrder>;
    reconciledAt?: InputMaybe<SortOrderInput>;
    scope?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrderInput>;
    userId?: InputMaybe<SortOrder>;
};

export enum PaymentContractScalarFieldEnum {
    AuthorizedCents = 'authorizedCents',
    CollectedBy = 'collectedBy',
    CreatedAt = 'createdAt',
    EndReason = 'endReason',
    EndedAt = 'endedAt',
    Id = 'id',
    InitiatedBy = 'initiatedBy',
    LastOpenedAt = 'lastOpenedAt',
    LastOpenedBy = 'lastOpenedBy',
    LastOpenedVia = 'lastOpenedVia',
    Lines = 'lines',
    LinesHash = 'linesHash',
    OpenCount = 'openCount',
    OrgId = 'orgId',
    PaymentIntentId = 'paymentIntentId',
    Rail = 'rail',
    ReconciledAt = 'reconciledAt',
    Scope = 'scope',
    Status = 'status',
    TransactionId = 'transactionId',
    UserId = 'userId',
}

export type PaymentContractScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PaymentContractScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PaymentContractScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PaymentContractScalarWhereWithAggregatesInput>>;
    authorizedCents?: InputMaybe<IntWithAggregatesFilter>;
    collectedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    endReason?: InputMaybe<EnumPaymentContractEndReasonNullableWithAggregatesFilter>;
    endedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    initiatedBy?: InputMaybe<StringWithAggregatesFilter>;
    lastOpenedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    lastOpenedBy?: InputMaybe<StringWithAggregatesFilter>;
    lastOpenedVia?: InputMaybe<EnumPaymentContractOpenedViaNullableWithAggregatesFilter>;
    lines?: InputMaybe<JsonWithAggregatesFilter>;
    linesHash?: InputMaybe<StringWithAggregatesFilter>;
    openCount?: InputMaybe<IntWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    paymentIntentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    rail?: InputMaybe<StringWithAggregatesFilter>;
    reconciledAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    scope?: InputMaybe<StringWithAggregatesFilter>;
    status?: InputMaybe<EnumPaymentContractStatusWithAggregatesFilter>;
    transactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    userId?: InputMaybe<StringWithAggregatesFilter>;
};

/**
 * CREATED at the Pay press; RECONCILED when the money is in the ledger;
 * CANCELED when it never will be (see end_reason). Whether a card is held is
 * read from Stripe, not stored.
 */
export enum PaymentContractStatus {
    Canceled = 'CANCELED',
    Created = 'CREATED',
    Reconciled = 'RECONCILED',
}

export type PaymentContractSumAggregate = {
    __typename?: 'PaymentContractSumAggregate';
    authorizedCents?: Maybe<Scalars['Int']['output']>;
    openCount?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentContractSumOrderByAggregateInput = {
    authorizedCents?: InputMaybe<SortOrder>;
    openCount?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type PaymentContractUpdateInput = {
    authorizedCents?: InputMaybe<IntFieldUpdateOperationsInput>;
    collectedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    endReason?: InputMaybe<NullableEnumPaymentContractEndReasonFieldUpdateOperationsInput>;
    endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastOpenedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastOpenedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastOpenedVia?: InputMaybe<NullableEnumPaymentContractOpenedViaFieldUpdateOperationsInput>;
    lines?: InputMaybe<Scalars['JSON']['input']>;
    linesHash?: InputMaybe<StringFieldUpdateOperationsInput>;
    openCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    rail?: InputMaybe<StringFieldUpdateOperationsInput>;
    reconciledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    scope?: InputMaybe<StringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentContractStatusFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentContractUpdateManyMutationInput = {
    authorizedCents?: InputMaybe<IntFieldUpdateOperationsInput>;
    collectedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    endReason?: InputMaybe<NullableEnumPaymentContractEndReasonFieldUpdateOperationsInput>;
    endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastOpenedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastOpenedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastOpenedVia?: InputMaybe<NullableEnumPaymentContractOpenedViaFieldUpdateOperationsInput>;
    lines?: InputMaybe<Scalars['JSON']['input']>;
    linesHash?: InputMaybe<StringFieldUpdateOperationsInput>;
    openCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    rail?: InputMaybe<StringFieldUpdateOperationsInput>;
    reconciledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    scope?: InputMaybe<StringFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentContractStatusFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentContractWhereInput = {
    AND?: InputMaybe<Array<PaymentContractWhereInput>>;
    NOT?: InputMaybe<Array<PaymentContractWhereInput>>;
    OR?: InputMaybe<Array<PaymentContractWhereInput>>;
    authorizedCents?: InputMaybe<IntFilter>;
    collectedBy?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    endReason?: InputMaybe<EnumPaymentContractEndReasonNullableFilter>;
    endedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    initiatedBy?: InputMaybe<StringFilter>;
    lastOpenedAt?: InputMaybe<DateTimeFilter>;
    lastOpenedBy?: InputMaybe<StringFilter>;
    lastOpenedVia?: InputMaybe<EnumPaymentContractOpenedViaNullableFilter>;
    lines?: InputMaybe<JsonFilter>;
    linesHash?: InputMaybe<StringFilter>;
    openCount?: InputMaybe<IntFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentIntentId?: InputMaybe<StringNullableFilter>;
    rail?: InputMaybe<StringFilter>;
    reconciledAt?: InputMaybe<DateTimeNullableFilter>;
    scope?: InputMaybe<StringFilter>;
    status?: InputMaybe<EnumPaymentContractStatusFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    userId?: InputMaybe<StringFilter>;
};

export type PaymentContractWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentContractWhereInput>>;
    NOT?: InputMaybe<Array<PaymentContractWhereInput>>;
    OR?: InputMaybe<Array<PaymentContractWhereInput>>;
    authorizedCents?: InputMaybe<IntFilter>;
    collectedBy?: InputMaybe<StringNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    endReason?: InputMaybe<EnumPaymentContractEndReasonNullableFilter>;
    endedAt?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy?: InputMaybe<StringFilter>;
    lastOpenedAt?: InputMaybe<DateTimeFilter>;
    lastOpenedBy?: InputMaybe<StringFilter>;
    lastOpenedVia?: InputMaybe<EnumPaymentContractOpenedViaNullableFilter>;
    lines?: InputMaybe<JsonFilter>;
    linesHash?: InputMaybe<StringFilter>;
    openCount?: InputMaybe<IntFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentIntentId?: InputMaybe<Scalars['String']['input']>;
    rail?: InputMaybe<StringFilter>;
    reconciledAt?: InputMaybe<DateTimeNullableFilter>;
    scope?: InputMaybe<StringFilter>;
    status?: InputMaybe<EnumPaymentContractStatusFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    userId?: InputMaybe<StringFilter>;
};

export enum PaymentMethodType {
    AthenaCard = 'ATHENA_CARD',
    BadCharge = 'BAD_CHARGE',
    Card = 'CARD',
    Cash = 'CASH',
    Check = 'CHECK',
    ExternalPayment = 'EXTERNAL_PAYMENT',
    Guarantee = 'GUARANTEE',
    SuperscriptCovered = 'SUPERSCRIPT_COVERED',
    ZeroDollarTransaction = 'ZERO_DOLLAR_TRANSACTION',
}

export type PaymentPlan = {
    __typename?: 'PaymentPlan';
    _count?: Maybe<PaymentPlanCount>;
    activatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    adjustments: Array<PaymentPlanAdjustment>;
    athenaAcceptanceWindowExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    autoCharges: Array<PaymentPlanAutoCharge>;
    boughtTreatments: Array<PaymentPlanBoughtTreatment>;
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    chargeDayOfWeek?: Maybe<DayOfWeekEnum>;
    chargeFrequency: PaymentPlanFrequency;
    chargeMode: PaymentPlanChargeMode;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    confirmedRemaining: Scalars['Decimal']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount: Scalars['Decimal']['output'];
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    migratedFromAthena: Scalars['Boolean']['output'];
    newPaymentMethodRequiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    nextChargeDateAt?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId: Scalars['Int']['output'];
    payLaterAuthorization?: Maybe<PayLaterAuthorization>;
    paymentAuthorization?: Maybe<PaymentAuthorization>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    shortId: Scalars['Int']['output'];
    status: PaymentPlanStatus;
    type: PaymentPlanType;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAdjustmentsArgs = {
    cursor?: InputMaybe<PaymentPlanAdjustmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAdjustmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAdjustmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
};

export type PaymentPlanAutoChargesArgs = {
    cursor?: InputMaybe<PaymentPlanAutoChargeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAutoChargeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAutoChargeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
};

export type PaymentPlanBoughtTreatmentsArgs = {
    cursor?: InputMaybe<PaymentPlanBoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanBoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
};

export type PaymentPlanPayLaterAuthorizationArgs = {
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type PaymentPlanPaymentAuthorizationArgs = {
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type PaymentPlanAdjustment = {
    __typename?: 'PaymentPlanAdjustment';
    acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    acknowledgedBy?: Maybe<Scalars['String']['output']>;
    acknowledgedByRole?: Maybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: Maybe<AdjustmentAckActionEnum>;
    boughtTreatmentId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    newAmount: Scalars['Decimal']['output'];
    paymentPlanId: Scalars['String']['output'];
    plan: PaymentPlan;
    previousAmount: Scalars['Decimal']['output'];
    status: PaymentPlanAdjustmentStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanAdjustmentAuditLog = {
    __typename?: 'PaymentPlanAdjustmentAuditLog';
    acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    acknowledgedBy?: Maybe<Scalars['String']['output']>;
    acknowledgedByRole?: Maybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: Maybe<AdjustmentAckActionEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    operation: Scalars['String']['output'];
    paymentPlanAdjustmentId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
    status?: Maybe<PaymentPlanAdjustmentStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanAdjustmentAuditLogAvgAggregate = {
    __typename?: 'PaymentPlanAdjustmentAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentPlanAdjustmentAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    newAmount?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentAuditLogCountAggregate = {
    __typename?: 'PaymentPlanAdjustmentAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    acknowledgedAt: Scalars['Int']['output'];
    acknowledgedBy: Scalars['Int']['output'];
    acknowledgedByRole: Scalars['Int']['output'];
    acknowledgementAction: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    newAmount: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    paymentPlanAdjustmentId: Scalars['Int']['output'];
    paymentPlanId: Scalars['Int']['output'];
    previousAmount: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PaymentPlanAdjustmentAuditLogCountOrderByAggregateInput = {
    acknowledgedAt?: InputMaybe<SortOrder>;
    acknowledgedBy?: InputMaybe<SortOrder>;
    acknowledgedByRole?: InputMaybe<SortOrder>;
    acknowledgementAction?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    newAmount?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    paymentPlanAdjustmentId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentAuditLogCreateInput = {
    acknowledgedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
    acknowledgedByRole?: InputMaybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: InputMaybe<AdjustmentAckActionEnum>;
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    newAmount?: InputMaybe<Scalars['Decimal']['input']>;
    operation: Scalars['String']['input'];
    paymentPlanAdjustmentId?: InputMaybe<Scalars['String']['input']>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    previousAmount?: InputMaybe<Scalars['Decimal']['input']>;
    status?: InputMaybe<PaymentPlanAdjustmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAdjustmentAuditLogCreateManyInput = {
    acknowledgedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
    acknowledgedByRole?: InputMaybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: InputMaybe<AdjustmentAckActionEnum>;
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    newAmount?: InputMaybe<Scalars['Decimal']['input']>;
    operation: Scalars['String']['input'];
    paymentPlanAdjustmentId?: InputMaybe<Scalars['String']['input']>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    previousAmount?: InputMaybe<Scalars['Decimal']['input']>;
    status?: InputMaybe<PaymentPlanAdjustmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAdjustmentAuditLogGroupBy = {
    __typename?: 'PaymentPlanAdjustmentAuditLogGroupBy';
    _avg?: Maybe<PaymentPlanAdjustmentAuditLogAvgAggregate>;
    _count?: Maybe<PaymentPlanAdjustmentAuditLogCountAggregate>;
    _max?: Maybe<PaymentPlanAdjustmentAuditLogMaxAggregate>;
    _min?: Maybe<PaymentPlanAdjustmentAuditLogMinAggregate>;
    _sum?: Maybe<PaymentPlanAdjustmentAuditLogSumAggregate>;
    acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    acknowledgedBy?: Maybe<Scalars['String']['output']>;
    acknowledgedByRole?: Maybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: Maybe<AdjustmentAckActionEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    operation: Scalars['String']['output'];
    paymentPlanAdjustmentId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
    status?: Maybe<PaymentPlanAdjustmentStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanAdjustmentAuditLogMaxAggregate = {
    __typename?: 'PaymentPlanAdjustmentAuditLogMaxAggregate';
    acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    acknowledgedBy?: Maybe<Scalars['String']['output']>;
    acknowledgedByRole?: Maybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: Maybe<AdjustmentAckActionEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    paymentPlanAdjustmentId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
    status?: Maybe<PaymentPlanAdjustmentStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAdjustmentAuditLogMaxOrderByAggregateInput = {
    acknowledgedAt?: InputMaybe<SortOrder>;
    acknowledgedBy?: InputMaybe<SortOrder>;
    acknowledgedByRole?: InputMaybe<SortOrder>;
    acknowledgementAction?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    newAmount?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    paymentPlanAdjustmentId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentAuditLogMinAggregate = {
    __typename?: 'PaymentPlanAdjustmentAuditLogMinAggregate';
    acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    acknowledgedBy?: Maybe<Scalars['String']['output']>;
    acknowledgedByRole?: Maybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: Maybe<AdjustmentAckActionEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    paymentPlanAdjustmentId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
    status?: Maybe<PaymentPlanAdjustmentStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAdjustmentAuditLogMinOrderByAggregateInput = {
    acknowledgedAt?: InputMaybe<SortOrder>;
    acknowledgedBy?: InputMaybe<SortOrder>;
    acknowledgedByRole?: InputMaybe<SortOrder>;
    acknowledgementAction?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    newAmount?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    paymentPlanAdjustmentId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentPlanAdjustmentAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentPlanAdjustmentAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentPlanAdjustmentAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentPlanAdjustmentAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentPlanAdjustmentAuditLogSumOrderByAggregateInput>;
    acknowledgedAt?: InputMaybe<SortOrderInput>;
    acknowledgedBy?: InputMaybe<SortOrderInput>;
    acknowledgedByRole?: InputMaybe<SortOrderInput>;
    acknowledgementAction?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    newAmount?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    paymentPlanAdjustmentId?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    previousAmount?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentAuditLogOrderByWithRelationInput = {
    acknowledgedAt?: InputMaybe<SortOrderInput>;
    acknowledgedBy?: InputMaybe<SortOrderInput>;
    acknowledgedByRole?: InputMaybe<SortOrderInput>;
    acknowledgementAction?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    newAmount?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    paymentPlanAdjustmentId?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    previousAmount?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentPlanAdjustmentAuditLogScalarFieldEnum {
    AcknowledgedAt = 'acknowledgedAt',
    AcknowledgedBy = 'acknowledgedBy',
    AcknowledgedByRole = 'acknowledgedByRole',
    AcknowledgementAction = 'acknowledgementAction',
    BoughtTreatmentId = 'boughtTreatmentId',
    CreatedAt = 'createdAt',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    NewAmount = 'newAmount',
    Operation = 'operation',
    PaymentPlanAdjustmentId = 'paymentPlanAdjustmentId',
    PaymentPlanId = 'paymentPlanId',
    PreviousAmount = 'previousAmount',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type PaymentPlanAdjustmentAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PaymentPlanAdjustmentAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PaymentPlanAdjustmentAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<PaymentPlanAdjustmentAuditLogScalarWhereWithAggregatesInput>
    >;
    acknowledgedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    acknowledgedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    acknowledgedByRole?: InputMaybe<EnumAdjustmentAckRoleEnumNullableWithAggregatesFilter>;
    acknowledgementAction?: InputMaybe<EnumAdjustmentAckActionEnumNullableWithAggregatesFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    newAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    paymentPlanAdjustmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    paymentPlanId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    previousAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumPaymentPlanAdjustmentStatusNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PaymentPlanAdjustmentAuditLogSumAggregate = {
    __typename?: 'PaymentPlanAdjustmentAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentPlanAdjustmentAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    newAmount?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentAuditLogUpdateInput = {
    acknowledgedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    acknowledgedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    acknowledgedByRole?: InputMaybe<NullableEnumAdjustmentAckRoleEnumFieldUpdateOperationsInput>;
    acknowledgementAction?: InputMaybe<NullableEnumAdjustmentAckActionEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    newAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentPlanAdjustmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentPlanId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    previousAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumPaymentPlanAdjustmentStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAdjustmentAuditLogUpdateManyMutationInput = {
    acknowledgedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    acknowledgedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    acknowledgedByRole?: InputMaybe<NullableEnumAdjustmentAckRoleEnumFieldUpdateOperationsInput>;
    acknowledgementAction?: InputMaybe<NullableEnumAdjustmentAckActionEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    newAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentPlanAdjustmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentPlanId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    previousAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumPaymentPlanAdjustmentStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAdjustmentAuditLogWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanAdjustmentAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAdjustmentAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAdjustmentAuditLogWhereInput>>;
    acknowledgedAt?: InputMaybe<DateTimeNullableFilter>;
    acknowledgedBy?: InputMaybe<StringNullableFilter>;
    acknowledgedByRole?: InputMaybe<EnumAdjustmentAckRoleEnumNullableFilter>;
    acknowledgementAction?: InputMaybe<EnumAdjustmentAckActionEnumNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    newAmount?: InputMaybe<DecimalNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    paymentPlanAdjustmentId?: InputMaybe<UuidNullableFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    previousAmount?: InputMaybe<DecimalNullableFilter>;
    status?: InputMaybe<EnumPaymentPlanAdjustmentStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanAdjustmentAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentPlanAdjustmentAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAdjustmentAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAdjustmentAuditLogWhereInput>>;
    acknowledgedAt?: InputMaybe<DateTimeNullableFilter>;
    acknowledgedBy?: InputMaybe<StringNullableFilter>;
    acknowledgedByRole?: InputMaybe<EnumAdjustmentAckRoleEnumNullableFilter>;
    acknowledgementAction?: InputMaybe<EnumAdjustmentAckActionEnumNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    newAmount?: InputMaybe<DecimalNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    paymentPlanAdjustmentId?: InputMaybe<UuidNullableFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    previousAmount?: InputMaybe<DecimalNullableFilter>;
    status?: InputMaybe<EnumPaymentPlanAdjustmentStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanAdjustmentAvgAggregate = {
    __typename?: 'PaymentPlanAdjustmentAvgAggregate';
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentPlanAdjustmentAvgOrderByAggregateInput = {
    newAmount?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentCountAggregate = {
    __typename?: 'PaymentPlanAdjustmentCountAggregate';
    _all: Scalars['Int']['output'];
    acknowledgedAt: Scalars['Int']['output'];
    acknowledgedBy: Scalars['Int']['output'];
    acknowledgedByRole: Scalars['Int']['output'];
    acknowledgementAction: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    newAmount: Scalars['Int']['output'];
    paymentPlanId: Scalars['Int']['output'];
    previousAmount: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PaymentPlanAdjustmentCountOrderByAggregateInput = {
    acknowledgedAt?: InputMaybe<SortOrder>;
    acknowledgedBy?: InputMaybe<SortOrder>;
    acknowledgedByRole?: InputMaybe<SortOrder>;
    acknowledgementAction?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    newAmount?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentCreateInput = {
    acknowledgedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
    acknowledgedByRole?: InputMaybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: InputMaybe<AdjustmentAckActionEnum>;
    boughtTreatmentId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    newAmount: Scalars['Decimal']['input'];
    plan: PaymentPlanCreateNestedOneWithoutAdjustmentsInput;
    previousAmount: Scalars['Decimal']['input'];
    status?: InputMaybe<PaymentPlanAdjustmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAdjustmentCreateManyInput = {
    acknowledgedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
    acknowledgedByRole?: InputMaybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: InputMaybe<AdjustmentAckActionEnum>;
    boughtTreatmentId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    newAmount: Scalars['Decimal']['input'];
    paymentPlanId: Scalars['String']['input'];
    previousAmount: Scalars['Decimal']['input'];
    status?: InputMaybe<PaymentPlanAdjustmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAdjustmentCreateManyPlanInput = {
    acknowledgedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
    acknowledgedByRole?: InputMaybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: InputMaybe<AdjustmentAckActionEnum>;
    boughtTreatmentId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    newAmount: Scalars['Decimal']['input'];
    previousAmount: Scalars['Decimal']['input'];
    status?: InputMaybe<PaymentPlanAdjustmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAdjustmentCreateManyPlanInputEnvelope = {
    data: Array<PaymentPlanAdjustmentCreateManyPlanInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentPlanAdjustmentCreateNestedManyWithoutPlanInput = {
    connect?: InputMaybe<Array<PaymentPlanAdjustmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PaymentPlanAdjustmentCreateOrConnectWithoutPlanInput>
    >;
    create?: InputMaybe<Array<PaymentPlanAdjustmentCreateWithoutPlanInput>>;
    createMany?: InputMaybe<PaymentPlanAdjustmentCreateManyPlanInputEnvelope>;
};

export type PaymentPlanAdjustmentCreateOrConnectWithoutPlanInput = {
    create: PaymentPlanAdjustmentCreateWithoutPlanInput;
    where: PaymentPlanAdjustmentWhereUniqueInput;
};

export type PaymentPlanAdjustmentCreateWithoutPlanInput = {
    acknowledgedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
    acknowledgedByRole?: InputMaybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: InputMaybe<AdjustmentAckActionEnum>;
    boughtTreatmentId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    newAmount: Scalars['Decimal']['input'];
    previousAmount: Scalars['Decimal']['input'];
    status?: InputMaybe<PaymentPlanAdjustmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAdjustmentGroupBy = {
    __typename?: 'PaymentPlanAdjustmentGroupBy';
    _avg?: Maybe<PaymentPlanAdjustmentAvgAggregate>;
    _count?: Maybe<PaymentPlanAdjustmentCountAggregate>;
    _max?: Maybe<PaymentPlanAdjustmentMaxAggregate>;
    _min?: Maybe<PaymentPlanAdjustmentMinAggregate>;
    _sum?: Maybe<PaymentPlanAdjustmentSumAggregate>;
    acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    acknowledgedBy?: Maybe<Scalars['String']['output']>;
    acknowledgedByRole?: Maybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: Maybe<AdjustmentAckActionEnum>;
    boughtTreatmentId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    newAmount: Scalars['Decimal']['output'];
    paymentPlanId: Scalars['String']['output'];
    previousAmount: Scalars['Decimal']['output'];
    status: PaymentPlanAdjustmentStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanAdjustmentListRelationFilter = {
    every?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
    none?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
    some?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
};

export type PaymentPlanAdjustmentMaxAggregate = {
    __typename?: 'PaymentPlanAdjustmentMaxAggregate';
    acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    acknowledgedBy?: Maybe<Scalars['String']['output']>;
    acknowledgedByRole?: Maybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: Maybe<AdjustmentAckActionEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
    status?: Maybe<PaymentPlanAdjustmentStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAdjustmentMaxOrderByAggregateInput = {
    acknowledgedAt?: InputMaybe<SortOrder>;
    acknowledgedBy?: InputMaybe<SortOrder>;
    acknowledgedByRole?: InputMaybe<SortOrder>;
    acknowledgementAction?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    newAmount?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentMinAggregate = {
    __typename?: 'PaymentPlanAdjustmentMinAggregate';
    acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    acknowledgedBy?: Maybe<Scalars['String']['output']>;
    acknowledgedByRole?: Maybe<AdjustmentAckRoleEnum>;
    acknowledgementAction?: Maybe<AdjustmentAckActionEnum>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
    status?: Maybe<PaymentPlanAdjustmentStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAdjustmentMinOrderByAggregateInput = {
    acknowledgedAt?: InputMaybe<SortOrder>;
    acknowledgedBy?: InputMaybe<SortOrder>;
    acknowledgedByRole?: InputMaybe<SortOrder>;
    acknowledgementAction?: InputMaybe<SortOrder>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    newAmount?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentPlanAdjustmentAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentPlanAdjustmentCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentPlanAdjustmentMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentPlanAdjustmentMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentPlanAdjustmentSumOrderByAggregateInput>;
    acknowledgedAt?: InputMaybe<SortOrderInput>;
    acknowledgedBy?: InputMaybe<SortOrderInput>;
    acknowledgedByRole?: InputMaybe<SortOrderInput>;
    acknowledgementAction?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    newAmount?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentOrderByWithRelationInput = {
    acknowledgedAt?: InputMaybe<SortOrderInput>;
    acknowledgedBy?: InputMaybe<SortOrderInput>;
    acknowledgedByRole?: InputMaybe<SortOrderInput>;
    acknowledgementAction?: InputMaybe<SortOrderInput>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    newAmount?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    plan?: InputMaybe<PaymentPlanOrderByWithRelationInput>;
    previousAmount?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentPlanAdjustmentScalarFieldEnum {
    AcknowledgedAt = 'acknowledgedAt',
    AcknowledgedBy = 'acknowledgedBy',
    AcknowledgedByRole = 'acknowledgedByRole',
    AcknowledgementAction = 'acknowledgementAction',
    BoughtTreatmentId = 'boughtTreatmentId',
    CreatedAt = 'createdAt',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    NewAmount = 'newAmount',
    PaymentPlanId = 'paymentPlanId',
    PreviousAmount = 'previousAmount',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type PaymentPlanAdjustmentScalarWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanAdjustmentScalarWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAdjustmentScalarWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAdjustmentScalarWhereInput>>;
    acknowledgedAt?: InputMaybe<DateTimeNullableFilter>;
    acknowledgedBy?: InputMaybe<StringNullableFilter>;
    acknowledgedByRole?: InputMaybe<EnumAdjustmentAckRoleEnumNullableFilter>;
    acknowledgementAction?: InputMaybe<EnumAdjustmentAckActionEnumNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    newAmount?: InputMaybe<DecimalFilter>;
    paymentPlanId?: InputMaybe<UuidFilter>;
    previousAmount?: InputMaybe<DecimalFilter>;
    status?: InputMaybe<EnumPaymentPlanAdjustmentStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanAdjustmentScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PaymentPlanAdjustmentScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PaymentPlanAdjustmentScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<PaymentPlanAdjustmentScalarWhereWithAggregatesInput>>;
    acknowledgedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    acknowledgedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    acknowledgedByRole?: InputMaybe<EnumAdjustmentAckRoleEnumNullableWithAggregatesFilter>;
    acknowledgementAction?: InputMaybe<EnumAdjustmentAckActionEnumNullableWithAggregatesFilter>;
    boughtTreatmentId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    newAmount?: InputMaybe<DecimalWithAggregatesFilter>;
    paymentPlanId?: InputMaybe<UuidWithAggregatesFilter>;
    previousAmount?: InputMaybe<DecimalWithAggregatesFilter>;
    status?: InputMaybe<EnumPaymentPlanAdjustmentStatusWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum PaymentPlanAdjustmentStatus {
    AdminDismissed = 'ADMIN_DISMISSED',
    Applied = 'APPLIED',
    PatientDismissed = 'PATIENT_DISMISSED',
    Pending = 'PENDING',
}

export type PaymentPlanAdjustmentSumAggregate = {
    __typename?: 'PaymentPlanAdjustmentSumAggregate';
    newAmount?: Maybe<Scalars['Decimal']['output']>;
    previousAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentPlanAdjustmentSumOrderByAggregateInput = {
    newAmount?: InputMaybe<SortOrder>;
    previousAmount?: InputMaybe<SortOrder>;
};

export type PaymentPlanAdjustmentUpdateInput = {
    acknowledgedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    acknowledgedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    acknowledgedByRole?: InputMaybe<NullableEnumAdjustmentAckRoleEnumFieldUpdateOperationsInput>;
    acknowledgementAction?: InputMaybe<NullableEnumAdjustmentAckActionEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    newAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    plan?: InputMaybe<PaymentPlanUpdateOneRequiredWithoutAdjustmentsNestedInput>;
    previousAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanAdjustmentStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAdjustmentUpdateManyMutationInput = {
    acknowledgedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    acknowledgedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    acknowledgedByRole?: InputMaybe<NullableEnumAdjustmentAckRoleEnumFieldUpdateOperationsInput>;
    acknowledgementAction?: InputMaybe<NullableEnumAdjustmentAckActionEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    newAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    previousAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanAdjustmentStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAdjustmentUpdateManyWithWhereWithoutPlanInput = {
    data: PaymentPlanAdjustmentUpdateManyMutationInput;
    where: PaymentPlanAdjustmentScalarWhereInput;
};

export type PaymentPlanAdjustmentUpdateManyWithoutPlanNestedInput = {
    connect?: InputMaybe<Array<PaymentPlanAdjustmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PaymentPlanAdjustmentCreateOrConnectWithoutPlanInput>
    >;
    create?: InputMaybe<Array<PaymentPlanAdjustmentCreateWithoutPlanInput>>;
    createMany?: InputMaybe<PaymentPlanAdjustmentCreateManyPlanInputEnvelope>;
    delete?: InputMaybe<Array<PaymentPlanAdjustmentWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PaymentPlanAdjustmentScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PaymentPlanAdjustmentWhereUniqueInput>>;
    set?: InputMaybe<Array<PaymentPlanAdjustmentWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PaymentPlanAdjustmentUpdateWithWhereUniqueWithoutPlanInput>
    >;
    updateMany?: InputMaybe<
        Array<PaymentPlanAdjustmentUpdateManyWithWhereWithoutPlanInput>
    >;
    upsert?: InputMaybe<
        Array<PaymentPlanAdjustmentUpsertWithWhereUniqueWithoutPlanInput>
    >;
};

export type PaymentPlanAdjustmentUpdateWithWhereUniqueWithoutPlanInput = {
    data: PaymentPlanAdjustmentUpdateWithoutPlanInput;
    where: PaymentPlanAdjustmentWhereUniqueInput;
};

export type PaymentPlanAdjustmentUpdateWithoutPlanInput = {
    acknowledgedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    acknowledgedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    acknowledgedByRole?: InputMaybe<NullableEnumAdjustmentAckRoleEnumFieldUpdateOperationsInput>;
    acknowledgementAction?: InputMaybe<NullableEnumAdjustmentAckActionEnumFieldUpdateOperationsInput>;
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    newAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    previousAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanAdjustmentStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAdjustmentUpsertWithWhereUniqueWithoutPlanInput = {
    create: PaymentPlanAdjustmentCreateWithoutPlanInput;
    update: PaymentPlanAdjustmentUpdateWithoutPlanInput;
    where: PaymentPlanAdjustmentWhereUniqueInput;
};

export type PaymentPlanAdjustmentWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanAdjustmentWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAdjustmentWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAdjustmentWhereInput>>;
    acknowledgedAt?: InputMaybe<DateTimeNullableFilter>;
    acknowledgedBy?: InputMaybe<StringNullableFilter>;
    acknowledgedByRole?: InputMaybe<EnumAdjustmentAckRoleEnumNullableFilter>;
    acknowledgementAction?: InputMaybe<EnumAdjustmentAckActionEnumNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    newAmount?: InputMaybe<DecimalFilter>;
    paymentPlanId?: InputMaybe<UuidFilter>;
    plan?: InputMaybe<PaymentPlanRelationFilter>;
    previousAmount?: InputMaybe<DecimalFilter>;
    status?: InputMaybe<EnumPaymentPlanAdjustmentStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanAdjustmentWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentPlanAdjustmentWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAdjustmentWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAdjustmentWhereInput>>;
    acknowledgedAt?: InputMaybe<DateTimeNullableFilter>;
    acknowledgedBy?: InputMaybe<StringNullableFilter>;
    acknowledgedByRole?: InputMaybe<EnumAdjustmentAckRoleEnumNullableFilter>;
    acknowledgementAction?: InputMaybe<EnumAdjustmentAckActionEnumNullableFilter>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    newAmount?: InputMaybe<DecimalFilter>;
    paymentPlanId?: InputMaybe<UuidFilter>;
    plan?: InputMaybe<PaymentPlanRelationFilter>;
    previousAmount?: InputMaybe<DecimalFilter>;
    status?: InputMaybe<EnumPaymentPlanAdjustmentStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanAuditLog = {
    __typename?: 'PaymentPlanAuditLog';
    activatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    athenaAcceptanceWindowExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    chargeFrequency?: Maybe<PaymentPlanFrequency>;
    chargeMode?: Maybe<PaymentPlanChargeMode>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    initiatedBy?: Maybe<PaymentPlanInitiatedBy>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    migratedFromAthena?: Maybe<Scalars['Boolean']['output']>;
    newPaymentMethodRequiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    nextChargeDateAt?: Maybe<Scalars['DateTimeISO']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    shortId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<PaymentPlanStatus>;
    type?: Maybe<PaymentPlanType>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAuditLogAvgAggregate = {
    __typename?: 'PaymentPlanAuditLogAvgAggregate';
    chargeDayOfMonth?: Maybe<Scalars['Float']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    maxInstallments?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    shortId?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPlanAuditLogAvgOrderByAggregateInput = {
    chargeDayOfMonth?: InputMaybe<SortOrder>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    maxInstallments?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    shortId?: InputMaybe<SortOrder>;
};

export type PaymentPlanAuditLogCountAggregate = {
    __typename?: 'PaymentPlanAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    activatedAt: Scalars['Int']['output'];
    athenaAcceptanceWindowExpiresAt: Scalars['Int']['output'];
    chargeDayOfMonth: Scalars['Int']['output'];
    chargeFrequency: Scalars['Int']['output'];
    chargeMode: Scalars['Int']['output'];
    completedAt: Scalars['Int']['output'];
    confirmedRemaining: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    depositAmount: Scalars['Int']['output'];
    endDate: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    initiatedBy: Scalars['Int']['output'];
    installmentAmount: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    maxInstallments: Scalars['Int']['output'];
    migratedFromAthena: Scalars['Int']['output'];
    newPaymentMethodRequiredAt: Scalars['Int']['output'];
    nextChargeDateAt: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentAuthorizationId: Scalars['Int']['output'];
    paymentFailedAt: Scalars['Int']['output'];
    paymentPlanId: Scalars['Int']['output'];
    shortId: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    voidReason: Scalars['Int']['output'];
    voidedAt: Scalars['Int']['output'];
};

export type PaymentPlanAuditLogCountOrderByAggregateInput = {
    activatedAt?: InputMaybe<SortOrder>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<SortOrder>;
    chargeDayOfMonth?: InputMaybe<SortOrder>;
    chargeFrequency?: InputMaybe<SortOrder>;
    chargeMode?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrder>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    maxInstallments?: InputMaybe<SortOrder>;
    migratedFromAthena?: InputMaybe<SortOrder>;
    newPaymentMethodRequiredAt?: InputMaybe<SortOrder>;
    nextChargeDateAt?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentFailedAt?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    shortId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAuditLogCreateInput = {
    activatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<
        Scalars['DateTimeISO']['input']
    >;
    chargeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
    chargeFrequency?: InputMaybe<PaymentPlanFrequency>;
    chargeMode?: InputMaybe<PaymentPlanChargeMode>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    confirmedRemaining?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    initiatedBy?: InputMaybe<PaymentPlanInitiatedBy>;
    installmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maxInstallments?: InputMaybe<Scalars['Int']['input']>;
    migratedFromAthena?: InputMaybe<Scalars['Boolean']['input']>;
    newPaymentMethodRequiredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nextChargeDateAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    paymentFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    shortId?: InputMaybe<Scalars['Int']['input']>;
    status?: InputMaybe<PaymentPlanStatus>;
    type?: InputMaybe<PaymentPlanType>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAuditLogCreateManyInput = {
    activatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<
        Scalars['DateTimeISO']['input']
    >;
    chargeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
    chargeFrequency?: InputMaybe<PaymentPlanFrequency>;
    chargeMode?: InputMaybe<PaymentPlanChargeMode>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    confirmedRemaining?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    initiatedBy?: InputMaybe<PaymentPlanInitiatedBy>;
    installmentAmount?: InputMaybe<Scalars['Decimal']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maxInstallments?: InputMaybe<Scalars['Int']['input']>;
    migratedFromAthena?: InputMaybe<Scalars['Boolean']['input']>;
    newPaymentMethodRequiredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nextChargeDateAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    paymentAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    paymentFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    shortId?: InputMaybe<Scalars['Int']['input']>;
    status?: InputMaybe<PaymentPlanStatus>;
    type?: InputMaybe<PaymentPlanType>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAuditLogGroupBy = {
    __typename?: 'PaymentPlanAuditLogGroupBy';
    _avg?: Maybe<PaymentPlanAuditLogAvgAggregate>;
    _count?: Maybe<PaymentPlanAuditLogCountAggregate>;
    _max?: Maybe<PaymentPlanAuditLogMaxAggregate>;
    _min?: Maybe<PaymentPlanAuditLogMinAggregate>;
    _sum?: Maybe<PaymentPlanAuditLogSumAggregate>;
    activatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    athenaAcceptanceWindowExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    chargeFrequency?: Maybe<PaymentPlanFrequency>;
    chargeMode?: Maybe<PaymentPlanChargeMode>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    initiatedBy?: Maybe<PaymentPlanInitiatedBy>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    migratedFromAthena?: Maybe<Scalars['Boolean']['output']>;
    newPaymentMethodRequiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    nextChargeDateAt?: Maybe<Scalars['DateTimeISO']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    shortId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<PaymentPlanStatus>;
    type?: Maybe<PaymentPlanType>;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAuditLogMaxAggregate = {
    __typename?: 'PaymentPlanAuditLogMaxAggregate';
    activatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    athenaAcceptanceWindowExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    chargeFrequency?: Maybe<PaymentPlanFrequency>;
    chargeMode?: Maybe<PaymentPlanChargeMode>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    initiatedBy?: Maybe<PaymentPlanInitiatedBy>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    migratedFromAthena?: Maybe<Scalars['Boolean']['output']>;
    newPaymentMethodRequiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    nextChargeDateAt?: Maybe<Scalars['DateTimeISO']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    shortId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<PaymentPlanStatus>;
    type?: Maybe<PaymentPlanType>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAuditLogMaxOrderByAggregateInput = {
    activatedAt?: InputMaybe<SortOrder>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<SortOrder>;
    chargeDayOfMonth?: InputMaybe<SortOrder>;
    chargeFrequency?: InputMaybe<SortOrder>;
    chargeMode?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrder>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    maxInstallments?: InputMaybe<SortOrder>;
    migratedFromAthena?: InputMaybe<SortOrder>;
    newPaymentMethodRequiredAt?: InputMaybe<SortOrder>;
    nextChargeDateAt?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentFailedAt?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    shortId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAuditLogMinAggregate = {
    __typename?: 'PaymentPlanAuditLogMinAggregate';
    activatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    athenaAcceptanceWindowExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    chargeFrequency?: Maybe<PaymentPlanFrequency>;
    chargeMode?: Maybe<PaymentPlanChargeMode>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    initiatedBy?: Maybe<PaymentPlanInitiatedBy>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    migratedFromAthena?: Maybe<Scalars['Boolean']['output']>;
    newPaymentMethodRequiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    nextChargeDateAt?: Maybe<Scalars['DateTimeISO']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    shortId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<PaymentPlanStatus>;
    type?: Maybe<PaymentPlanType>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAuditLogMinOrderByAggregateInput = {
    activatedAt?: InputMaybe<SortOrder>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<SortOrder>;
    chargeDayOfMonth?: InputMaybe<SortOrder>;
    chargeFrequency?: InputMaybe<SortOrder>;
    chargeMode?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrder>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    maxInstallments?: InputMaybe<SortOrder>;
    migratedFromAthena?: InputMaybe<SortOrder>;
    newPaymentMethodRequiredAt?: InputMaybe<SortOrder>;
    nextChargeDateAt?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentFailedAt?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    shortId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentPlanAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentPlanAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentPlanAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentPlanAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentPlanAuditLogSumOrderByAggregateInput>;
    activatedAt?: InputMaybe<SortOrderInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<SortOrderInput>;
    chargeDayOfMonth?: InputMaybe<SortOrderInput>;
    chargeFrequency?: InputMaybe<SortOrderInput>;
    chargeMode?: InputMaybe<SortOrderInput>;
    completedAt?: InputMaybe<SortOrderInput>;
    confirmedRemaining?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrderInput>;
    endDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrderInput>;
    installmentAmount?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    maxInstallments?: InputMaybe<SortOrderInput>;
    migratedFromAthena?: InputMaybe<SortOrderInput>;
    newPaymentMethodRequiredAt?: InputMaybe<SortOrderInput>;
    nextChargeDateAt?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    paymentAuthorizationId?: InputMaybe<SortOrderInput>;
    paymentFailedAt?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    shortId?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    type?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrderInput>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export type PaymentPlanAuditLogOrderByWithRelationInput = {
    activatedAt?: InputMaybe<SortOrderInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<SortOrderInput>;
    chargeDayOfMonth?: InputMaybe<SortOrderInput>;
    chargeFrequency?: InputMaybe<SortOrderInput>;
    chargeMode?: InputMaybe<SortOrderInput>;
    completedAt?: InputMaybe<SortOrderInput>;
    confirmedRemaining?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrderInput>;
    endDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrderInput>;
    installmentAmount?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    maxInstallments?: InputMaybe<SortOrderInput>;
    migratedFromAthena?: InputMaybe<SortOrderInput>;
    newPaymentMethodRequiredAt?: InputMaybe<SortOrderInput>;
    nextChargeDateAt?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    paymentAuthorizationId?: InputMaybe<SortOrderInput>;
    paymentFailedAt?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    shortId?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    type?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrderInput>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export enum PaymentPlanAuditLogScalarFieldEnum {
    ActivatedAt = 'activatedAt',
    AthenaAcceptanceWindowExpiresAt = 'athenaAcceptanceWindowExpiresAt',
    ChargeDayOfMonth = 'chargeDayOfMonth',
    ChargeFrequency = 'chargeFrequency',
    ChargeMode = 'chargeMode',
    CompletedAt = 'completedAt',
    ConfirmedRemaining = 'confirmedRemaining',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    DepositAmount = 'depositAmount',
    EndDate = 'endDate',
    Id = 'id',
    InitiatedBy = 'initiatedBy',
    InstallmentAmount = 'installmentAmount',
    LastUpdatedBy = 'lastUpdatedBy',
    MaxInstallments = 'maxInstallments',
    MigratedFromAthena = 'migratedFromAthena',
    NewPaymentMethodRequiredAt = 'newPaymentMethodRequiredAt',
    NextChargeDateAt = 'nextChargeDateAt',
    Operation = 'operation',
    OrgId = 'orgId',
    PaymentAuthorizationId = 'paymentAuthorizationId',
    PaymentFailedAt = 'paymentFailedAt',
    PaymentPlanId = 'paymentPlanId',
    ShortId = 'shortId',
    Status = 'status',
    Type = 'type',
    UpdatedAt = 'updatedAt',
    VoidReason = 'voidReason',
    VoidedAt = 'voidedAt',
}

export type PaymentPlanAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PaymentPlanAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PaymentPlanAuditLogScalarWhereWithAggregatesInput>>;
    activatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    chargeDayOfMonth?: InputMaybe<IntNullableWithAggregatesFilter>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyNullableWithAggregatesFilter>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeNullableWithAggregatesFilter>;
    completedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    confirmedRemaining?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    depositAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    endDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByNullableWithAggregatesFilter>;
    installmentAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    maxInstallments?: InputMaybe<IntNullableWithAggregatesFilter>;
    migratedFromAthena?: InputMaybe<BoolNullableWithAggregatesFilter>;
    newPaymentMethodRequiredAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    nextChargeDateAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    paymentFailedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    paymentPlanId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    shortId?: InputMaybe<IntNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumPaymentPlanStatusNullableWithAggregatesFilter>;
    type?: InputMaybe<EnumPaymentPlanTypeNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    voidReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    voidedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type PaymentPlanAuditLogSumAggregate = {
    __typename?: 'PaymentPlanAuditLogSumAggregate';
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    shortId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentPlanAuditLogSumOrderByAggregateInput = {
    chargeDayOfMonth?: InputMaybe<SortOrder>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    maxInstallments?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    shortId?: InputMaybe<SortOrder>;
};

export type PaymentPlanAuditLogUpdateInput = {
    activatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    chargeDayOfMonth?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    chargeFrequency?: InputMaybe<NullableEnumPaymentPlanFrequencyFieldUpdateOperationsInput>;
    chargeMode?: InputMaybe<NullableEnumPaymentPlanChargeModeFieldUpdateOperationsInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    confirmedRemaining?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<NullableEnumPaymentPlanInitiatedByFieldUpdateOperationsInput>;
    installmentAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maxInstallments?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    migratedFromAthena?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    newPaymentMethodRequiredAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nextChargeDateAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    paymentPlanId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    shortId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumPaymentPlanStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<NullableEnumPaymentPlanTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAuditLogUpdateManyMutationInput = {
    activatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    chargeDayOfMonth?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    chargeFrequency?: InputMaybe<NullableEnumPaymentPlanFrequencyFieldUpdateOperationsInput>;
    chargeMode?: InputMaybe<NullableEnumPaymentPlanChargeModeFieldUpdateOperationsInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    confirmedRemaining?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<NullableEnumPaymentPlanInitiatedByFieldUpdateOperationsInput>;
    installmentAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maxInstallments?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    migratedFromAthena?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    newPaymentMethodRequiredAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nextChargeDateAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    paymentAuthorizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    paymentPlanId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    shortId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumPaymentPlanStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<NullableEnumPaymentPlanTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAuditLogWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAuditLogWhereInput>>;
    activatedAt?: InputMaybe<DateTimeNullableFilter>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<DateTimeNullableFilter>;
    chargeDayOfMonth?: InputMaybe<IntNullableFilter>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyNullableFilter>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeNullableFilter>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    confirmedRemaining?: InputMaybe<DecimalNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalNullableFilter>;
    endDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByNullableFilter>;
    installmentAmount?: InputMaybe<DecimalNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    maxInstallments?: InputMaybe<IntNullableFilter>;
    migratedFromAthena?: InputMaybe<BoolNullableFilter>;
    newPaymentMethodRequiredAt?: InputMaybe<DateTimeNullableFilter>;
    nextChargeDateAt?: InputMaybe<DateTimeNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableFilter>;
    paymentFailedAt?: InputMaybe<DateTimeNullableFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    shortId?: InputMaybe<IntNullableFilter>;
    status?: InputMaybe<EnumPaymentPlanStatusNullableFilter>;
    type?: InputMaybe<EnumPaymentPlanTypeNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidReason?: InputMaybe<StringNullableFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PaymentPlanAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentPlanAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAuditLogWhereInput>>;
    activatedAt?: InputMaybe<DateTimeNullableFilter>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<DateTimeNullableFilter>;
    chargeDayOfMonth?: InputMaybe<IntNullableFilter>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyNullableFilter>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeNullableFilter>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    confirmedRemaining?: InputMaybe<DecimalNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalNullableFilter>;
    endDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByNullableFilter>;
    installmentAmount?: InputMaybe<DecimalNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    maxInstallments?: InputMaybe<IntNullableFilter>;
    migratedFromAthena?: InputMaybe<BoolNullableFilter>;
    newPaymentMethodRequiredAt?: InputMaybe<DateTimeNullableFilter>;
    nextChargeDateAt?: InputMaybe<DateTimeNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableFilter>;
    paymentFailedAt?: InputMaybe<DateTimeNullableFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    shortId?: InputMaybe<IntNullableFilter>;
    status?: InputMaybe<EnumPaymentPlanStatusNullableFilter>;
    type?: InputMaybe<EnumPaymentPlanTypeNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidReason?: InputMaybe<StringNullableFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PaymentPlanAutoCharge = {
    __typename?: 'PaymentPlanAutoCharge';
    amount: Scalars['Decimal']['output'];
    attemptCount: Scalars['Int']['output'];
    attemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    idempotencyKey?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    nextRetryAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId: Scalars['String']['output'];
    plan: PaymentPlan;
    reminderSentAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scheduledDate: Scalars['DateTimeISO']['output'];
    snapshotAfterPayment?: Maybe<Scalars['JSON']['output']>;
    snapshotAtCreation: Scalars['JSON']['output'];
    status: PaymentPlanAutoChargeStatus;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    timezone: Scalars['String']['output'];
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanAutoChargeAuditLog = {
    __typename?: 'PaymentPlanAutoChargeAuditLog';
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
    attemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    idempotencyKey?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    nextRetryAt?: Maybe<Scalars['DateTimeISO']['output']>;
    operation: Scalars['String']['output'];
    paymentPlanAutoChargeId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    scheduledDate?: Maybe<Scalars['DateTimeISO']['output']>;
    snapshotAfterPayment?: Maybe<Scalars['JSON']['output']>;
    snapshotAtCreation?: Maybe<Scalars['JSON']['output']>;
    status?: Maybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanAutoChargeAuditLogAvgAggregate = {
    __typename?: 'PaymentPlanAutoChargeAuditLogAvgAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPlanAutoChargeAuditLogAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeAuditLogCountAggregate = {
    __typename?: 'PaymentPlanAutoChargeAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    attemptCount: Scalars['Int']['output'];
    attemptedAt: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    failedAt: Scalars['Int']['output'];
    failureReason: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    idempotencyKey: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    nextRetryAt: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    paymentPlanAutoChargeId: Scalars['Int']['output'];
    paymentPlanId: Scalars['Int']['output'];
    scheduledDate: Scalars['Int']['output'];
    snapshotAfterPayment: Scalars['Int']['output'];
    snapshotAtCreation: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    stripePaymentMethodId: Scalars['Int']['output'];
    timezone: Scalars['Int']['output'];
    transactionId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PaymentPlanAutoChargeAuditLogCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    attemptedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    failedAt?: InputMaybe<SortOrder>;
    failureReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idempotencyKey?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    nextRetryAt?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    paymentPlanAutoChargeId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    scheduledDate?: InputMaybe<SortOrder>;
    snapshotAfterPayment?: InputMaybe<SortOrder>;
    snapshotAtCreation?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeAuditLogCreateInput = {
    amount?: InputMaybe<Scalars['Decimal']['input']>;
    attemptCount?: InputMaybe<Scalars['Int']['input']>;
    attemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failureReason?: InputMaybe<Scalars['String']['input']>;
    idempotencyKey?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    nextRetryAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    operation: Scalars['String']['input'];
    paymentPlanAutoChargeId?: InputMaybe<Scalars['String']['input']>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    scheduledDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAutoChargeAuditLogCreateManyInput = {
    amount?: InputMaybe<Scalars['Decimal']['input']>;
    attemptCount?: InputMaybe<Scalars['Int']['input']>;
    attemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failureReason?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    idempotencyKey?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    nextRetryAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    operation: Scalars['String']['input'];
    paymentPlanAutoChargeId?: InputMaybe<Scalars['String']['input']>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    scheduledDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAutoChargeAuditLogGroupBy = {
    __typename?: 'PaymentPlanAutoChargeAuditLogGroupBy';
    _avg?: Maybe<PaymentPlanAutoChargeAuditLogAvgAggregate>;
    _count?: Maybe<PaymentPlanAutoChargeAuditLogCountAggregate>;
    _max?: Maybe<PaymentPlanAutoChargeAuditLogMaxAggregate>;
    _min?: Maybe<PaymentPlanAutoChargeAuditLogMinAggregate>;
    _sum?: Maybe<PaymentPlanAutoChargeAuditLogSumAggregate>;
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
    attemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    idempotencyKey?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    nextRetryAt?: Maybe<Scalars['DateTimeISO']['output']>;
    operation: Scalars['String']['output'];
    paymentPlanAutoChargeId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    scheduledDate?: Maybe<Scalars['DateTimeISO']['output']>;
    snapshotAfterPayment?: Maybe<Scalars['JSON']['output']>;
    snapshotAtCreation?: Maybe<Scalars['JSON']['output']>;
    status?: Maybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanAutoChargeAuditLogMaxAggregate = {
    __typename?: 'PaymentPlanAutoChargeAuditLogMaxAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
    attemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    idempotencyKey?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    nextRetryAt?: Maybe<Scalars['DateTimeISO']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    paymentPlanAutoChargeId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    scheduledDate?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAutoChargeAuditLogMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    attemptedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    failedAt?: InputMaybe<SortOrder>;
    failureReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idempotencyKey?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    nextRetryAt?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    paymentPlanAutoChargeId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    scheduledDate?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeAuditLogMinAggregate = {
    __typename?: 'PaymentPlanAutoChargeAuditLogMinAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
    attemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    idempotencyKey?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    nextRetryAt?: Maybe<Scalars['DateTimeISO']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    paymentPlanAutoChargeId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    scheduledDate?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAutoChargeAuditLogMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    attemptedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    failedAt?: InputMaybe<SortOrder>;
    failureReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idempotencyKey?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    nextRetryAt?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    paymentPlanAutoChargeId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    scheduledDate?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentPlanAutoChargeAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentPlanAutoChargeAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentPlanAutoChargeAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentPlanAutoChargeAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentPlanAutoChargeAuditLogSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrderInput>;
    attemptCount?: InputMaybe<SortOrderInput>;
    attemptedAt?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    failedAt?: InputMaybe<SortOrderInput>;
    failureReason?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    idempotencyKey?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    nextRetryAt?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    paymentPlanAutoChargeId?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    scheduledDate?: InputMaybe<SortOrderInput>;
    snapshotAfterPayment?: InputMaybe<SortOrderInput>;
    snapshotAtCreation?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    timezone?: InputMaybe<SortOrderInput>;
    transactionId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeAuditLogOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrderInput>;
    attemptCount?: InputMaybe<SortOrderInput>;
    attemptedAt?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    failedAt?: InputMaybe<SortOrderInput>;
    failureReason?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    idempotencyKey?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    nextRetryAt?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    paymentPlanAutoChargeId?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    scheduledDate?: InputMaybe<SortOrderInput>;
    snapshotAfterPayment?: InputMaybe<SortOrderInput>;
    snapshotAtCreation?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    timezone?: InputMaybe<SortOrderInput>;
    transactionId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentPlanAutoChargeAuditLogScalarFieldEnum {
    Amount = 'amount',
    AttemptCount = 'attemptCount',
    AttemptedAt = 'attemptedAt',
    CreatedAt = 'createdAt',
    FailedAt = 'failedAt',
    FailureReason = 'failureReason',
    Id = 'id',
    IdempotencyKey = 'idempotencyKey',
    LastUpdatedBy = 'lastUpdatedBy',
    NextRetryAt = 'nextRetryAt',
    Operation = 'operation',
    PaymentPlanAutoChargeId = 'paymentPlanAutoChargeId',
    PaymentPlanId = 'paymentPlanId',
    ScheduledDate = 'scheduledDate',
    SnapshotAfterPayment = 'snapshotAfterPayment',
    SnapshotAtCreation = 'snapshotAtCreation',
    Status = 'status',
    StripePaymentMethodId = 'stripePaymentMethodId',
    Timezone = 'timezone',
    TransactionId = 'transactionId',
    UpdatedAt = 'updatedAt',
}

export type PaymentPlanAutoChargeAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PaymentPlanAutoChargeAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PaymentPlanAutoChargeAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<PaymentPlanAutoChargeAuditLogScalarWhereWithAggregatesInput>
    >;
    amount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    attemptCount?: InputMaybe<IntNullableWithAggregatesFilter>;
    attemptedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    failedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    failureReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    idempotencyKey?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    nextRetryAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    paymentPlanAutoChargeId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    paymentPlanId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    scheduledDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    snapshotAfterPayment?: InputMaybe<JsonNullableWithAggregatesFilter>;
    snapshotAtCreation?: InputMaybe<JsonNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumPaymentPlanAutoChargeStatusNullableWithAggregatesFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableWithAggregatesFilter>;
    timezone?: InputMaybe<StringNullableWithAggregatesFilter>;
    transactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PaymentPlanAutoChargeAuditLogSumAggregate = {
    __typename?: 'PaymentPlanAutoChargeAuditLogSumAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type PaymentPlanAutoChargeAuditLogSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeAuditLogUpdateInput = {
    amount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    attemptCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    attemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    failedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    failureReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idempotencyKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    nextRetryAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentPlanAutoChargeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentPlanId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<NullableEnumPaymentPlanAutoChargeStatusFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAutoChargeAuditLogUpdateManyMutationInput = {
    amount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    attemptCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    attemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    failedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    failureReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    idempotencyKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    nextRetryAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    paymentPlanAutoChargeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentPlanId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<NullableEnumPaymentPlanAutoChargeStatusFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAutoChargeAuditLogWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanAutoChargeAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAutoChargeAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAutoChargeAuditLogWhereInput>>;
    amount?: InputMaybe<DecimalNullableFilter>;
    attemptCount?: InputMaybe<IntNullableFilter>;
    attemptedAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    failedAt?: InputMaybe<DateTimeNullableFilter>;
    failureReason?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    idempotencyKey?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    nextRetryAt?: InputMaybe<DateTimeNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    paymentPlanAutoChargeId?: InputMaybe<UuidNullableFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    scheduledDate?: InputMaybe<DateTimeNullableFilter>;
    snapshotAfterPayment?: InputMaybe<JsonNullableFilter>;
    snapshotAtCreation?: InputMaybe<JsonNullableFilter>;
    status?: InputMaybe<EnumPaymentPlanAutoChargeStatusNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    timezone?: InputMaybe<StringNullableFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanAutoChargeAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentPlanAutoChargeAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAutoChargeAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAutoChargeAuditLogWhereInput>>;
    amount?: InputMaybe<DecimalNullableFilter>;
    attemptCount?: InputMaybe<IntNullableFilter>;
    attemptedAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    failedAt?: InputMaybe<DateTimeNullableFilter>;
    failureReason?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    idempotencyKey?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    nextRetryAt?: InputMaybe<DateTimeNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    paymentPlanAutoChargeId?: InputMaybe<UuidNullableFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    scheduledDate?: InputMaybe<DateTimeNullableFilter>;
    snapshotAfterPayment?: InputMaybe<JsonNullableFilter>;
    snapshotAtCreation?: InputMaybe<JsonNullableFilter>;
    status?: InputMaybe<EnumPaymentPlanAutoChargeStatusNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    timezone?: InputMaybe<StringNullableFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanAutoChargeAvgAggregate = {
    __typename?: 'PaymentPlanAutoChargeAvgAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPlanAutoChargeAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeCountAggregate = {
    __typename?: 'PaymentPlanAutoChargeCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    attemptCount: Scalars['Int']['output'];
    attemptedAt: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    failedAt: Scalars['Int']['output'];
    failureReason: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    idempotencyKey: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    nextRetryAt: Scalars['Int']['output'];
    paymentPlanId: Scalars['Int']['output'];
    reminderSentAt: Scalars['Int']['output'];
    scheduledDate: Scalars['Int']['output'];
    snapshotAfterPayment: Scalars['Int']['output'];
    snapshotAtCreation: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    stripePaymentMethodId: Scalars['Int']['output'];
    timezone: Scalars['Int']['output'];
    transactionId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PaymentPlanAutoChargeCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    attemptedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    failedAt?: InputMaybe<SortOrder>;
    failureReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idempotencyKey?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    nextRetryAt?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    reminderSentAt?: InputMaybe<SortOrder>;
    scheduledDate?: InputMaybe<SortOrder>;
    snapshotAfterPayment?: InputMaybe<SortOrder>;
    snapshotAtCreation?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeCreateInput = {
    amount: Scalars['Decimal']['input'];
    attemptCount?: InputMaybe<Scalars['Int']['input']>;
    attemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failureReason?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    idempotencyKey?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    nextRetryAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    plan: PaymentPlanCreateNestedOneWithoutAutoChargesInput;
    reminderSentAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledDate: Scalars['DateTimeISO']['input'];
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation: Scalars['JSON']['input'];
    status?: InputMaybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAutoChargeCreateManyInput = {
    amount: Scalars['Decimal']['input'];
    attemptCount?: InputMaybe<Scalars['Int']['input']>;
    attemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failureReason?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    idempotencyKey?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    nextRetryAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    paymentPlanId: Scalars['String']['input'];
    reminderSentAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledDate: Scalars['DateTimeISO']['input'];
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation: Scalars['JSON']['input'];
    status?: InputMaybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAutoChargeCreateManyPlanInput = {
    amount: Scalars['Decimal']['input'];
    attemptCount?: InputMaybe<Scalars['Int']['input']>;
    attemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failureReason?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    idempotencyKey?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    nextRetryAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    reminderSentAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledDate: Scalars['DateTimeISO']['input'];
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation: Scalars['JSON']['input'];
    status?: InputMaybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAutoChargeCreateManyPlanInputEnvelope = {
    data: Array<PaymentPlanAutoChargeCreateManyPlanInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentPlanAutoChargeCreateNestedManyWithoutPlanInput = {
    connect?: InputMaybe<Array<PaymentPlanAutoChargeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PaymentPlanAutoChargeCreateOrConnectWithoutPlanInput>
    >;
    create?: InputMaybe<Array<PaymentPlanAutoChargeCreateWithoutPlanInput>>;
    createMany?: InputMaybe<PaymentPlanAutoChargeCreateManyPlanInputEnvelope>;
};

export type PaymentPlanAutoChargeCreateOrConnectWithoutPlanInput = {
    create: PaymentPlanAutoChargeCreateWithoutPlanInput;
    where: PaymentPlanAutoChargeWhereUniqueInput;
};

export type PaymentPlanAutoChargeCreateWithoutPlanInput = {
    amount: Scalars['Decimal']['input'];
    attemptCount?: InputMaybe<Scalars['Int']['input']>;
    attemptedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    failureReason?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    idempotencyKey?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    nextRetryAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    reminderSentAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    scheduledDate: Scalars['DateTimeISO']['input'];
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation: Scalars['JSON']['input'];
    status?: InputMaybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanAutoChargeGroupBy = {
    __typename?: 'PaymentPlanAutoChargeGroupBy';
    _avg?: Maybe<PaymentPlanAutoChargeAvgAggregate>;
    _count?: Maybe<PaymentPlanAutoChargeCountAggregate>;
    _max?: Maybe<PaymentPlanAutoChargeMaxAggregate>;
    _min?: Maybe<PaymentPlanAutoChargeMinAggregate>;
    _sum?: Maybe<PaymentPlanAutoChargeSumAggregate>;
    amount: Scalars['Decimal']['output'];
    attemptCount: Scalars['Int']['output'];
    attemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    idempotencyKey?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    nextRetryAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId: Scalars['String']['output'];
    reminderSentAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scheduledDate: Scalars['DateTimeISO']['output'];
    snapshotAfterPayment?: Maybe<Scalars['JSON']['output']>;
    snapshotAtCreation: Scalars['JSON']['output'];
    status: PaymentPlanAutoChargeStatus;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    timezone: Scalars['String']['output'];
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanAutoChargeListRelationFilter = {
    every?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
    none?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
    some?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
};

export type PaymentPlanAutoChargeMaxAggregate = {
    __typename?: 'PaymentPlanAutoChargeMaxAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
    attemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    idempotencyKey?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    nextRetryAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    reminderSentAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scheduledDate?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAutoChargeMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    attemptedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    failedAt?: InputMaybe<SortOrder>;
    failureReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idempotencyKey?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    nextRetryAt?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    reminderSentAt?: InputMaybe<SortOrder>;
    scheduledDate?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeMinAggregate = {
    __typename?: 'PaymentPlanAutoChargeMinAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
    attemptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    failureReason?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    idempotencyKey?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    nextRetryAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    reminderSentAt?: Maybe<Scalars['DateTimeISO']['output']>;
    scheduledDate?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<PaymentPlanAutoChargeStatus>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanAutoChargeMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    attemptedAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    failedAt?: InputMaybe<SortOrder>;
    failureReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    idempotencyKey?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    nextRetryAt?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    reminderSentAt?: InputMaybe<SortOrder>;
    scheduledDate?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentPlanAutoChargeAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentPlanAutoChargeCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentPlanAutoChargeMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentPlanAutoChargeMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentPlanAutoChargeSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    attemptedAt?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    failedAt?: InputMaybe<SortOrderInput>;
    failureReason?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    idempotencyKey?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    nextRetryAt?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrder>;
    reminderSentAt?: InputMaybe<SortOrderInput>;
    scheduledDate?: InputMaybe<SortOrder>;
    snapshotAfterPayment?: InputMaybe<SortOrderInput>;
    snapshotAtCreation?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    timezone?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
    attemptedAt?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    failedAt?: InputMaybe<SortOrderInput>;
    failureReason?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    idempotencyKey?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    nextRetryAt?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrder>;
    plan?: InputMaybe<PaymentPlanOrderByWithRelationInput>;
    reminderSentAt?: InputMaybe<SortOrderInput>;
    scheduledDate?: InputMaybe<SortOrder>;
    snapshotAfterPayment?: InputMaybe<SortOrderInput>;
    snapshotAtCreation?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    timezone?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentPlanAutoChargeScalarFieldEnum {
    Amount = 'amount',
    AttemptCount = 'attemptCount',
    AttemptedAt = 'attemptedAt',
    CreatedAt = 'createdAt',
    FailedAt = 'failedAt',
    FailureReason = 'failureReason',
    Id = 'id',
    IdempotencyKey = 'idempotencyKey',
    LastUpdatedBy = 'lastUpdatedBy',
    NextRetryAt = 'nextRetryAt',
    PaymentPlanId = 'paymentPlanId',
    ReminderSentAt = 'reminderSentAt',
    ScheduledDate = 'scheduledDate',
    SnapshotAfterPayment = 'snapshotAfterPayment',
    SnapshotAtCreation = 'snapshotAtCreation',
    Status = 'status',
    StripePaymentMethodId = 'stripePaymentMethodId',
    Timezone = 'timezone',
    TransactionId = 'transactionId',
    UpdatedAt = 'updatedAt',
}

export type PaymentPlanAutoChargeScalarWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanAutoChargeScalarWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAutoChargeScalarWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAutoChargeScalarWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    attemptCount?: InputMaybe<IntFilter>;
    attemptedAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    failedAt?: InputMaybe<DateTimeNullableFilter>;
    failureReason?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    idempotencyKey?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    nextRetryAt?: InputMaybe<DateTimeNullableFilter>;
    paymentPlanId?: InputMaybe<UuidFilter>;
    reminderSentAt?: InputMaybe<DateTimeNullableFilter>;
    scheduledDate?: InputMaybe<DateTimeFilter>;
    snapshotAfterPayment?: InputMaybe<JsonNullableFilter>;
    snapshotAtCreation?: InputMaybe<JsonFilter>;
    status?: InputMaybe<EnumPaymentPlanAutoChargeStatusFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    timezone?: InputMaybe<StringFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanAutoChargeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PaymentPlanAutoChargeScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PaymentPlanAutoChargeScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<PaymentPlanAutoChargeScalarWhereWithAggregatesInput>>;
    amount?: InputMaybe<DecimalWithAggregatesFilter>;
    attemptCount?: InputMaybe<IntWithAggregatesFilter>;
    attemptedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    failedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    failureReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    idempotencyKey?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    nextRetryAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    paymentPlanId?: InputMaybe<UuidWithAggregatesFilter>;
    reminderSentAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    scheduledDate?: InputMaybe<DateTimeWithAggregatesFilter>;
    snapshotAfterPayment?: InputMaybe<JsonNullableWithAggregatesFilter>;
    snapshotAtCreation?: InputMaybe<JsonWithAggregatesFilter>;
    status?: InputMaybe<EnumPaymentPlanAutoChargeStatusWithAggregatesFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableWithAggregatesFilter>;
    timezone?: InputMaybe<StringWithAggregatesFilter>;
    transactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum PaymentPlanAutoChargeStatus {
    Canceled = 'CANCELED',
    Failed = 'FAILED',
    Paid = 'PAID',
    Processing = 'PROCESSING',
    Scheduled = 'SCHEDULED',
    Sent = 'SENT',
}

export type PaymentPlanAutoChargeSumAggregate = {
    __typename?: 'PaymentPlanAutoChargeSumAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    attemptCount?: Maybe<Scalars['Int']['output']>;
};

export type PaymentPlanAutoChargeSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    attemptCount?: InputMaybe<SortOrder>;
};

export type PaymentPlanAutoChargeUpdateInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    attemptCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    attemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    failedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    failureReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    idempotencyKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    nextRetryAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    plan?: InputMaybe<PaymentPlanUpdateOneRequiredWithoutAutoChargesNestedInput>;
    reminderSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    scheduledDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<EnumPaymentPlanAutoChargeStatusFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAutoChargeUpdateManyMutationInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    attemptCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    attemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    failedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    failureReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    idempotencyKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    nextRetryAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    reminderSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    scheduledDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<EnumPaymentPlanAutoChargeStatusFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAutoChargeUpdateManyWithWhereWithoutPlanInput = {
    data: PaymentPlanAutoChargeUpdateManyMutationInput;
    where: PaymentPlanAutoChargeScalarWhereInput;
};

export type PaymentPlanAutoChargeUpdateManyWithoutPlanNestedInput = {
    connect?: InputMaybe<Array<PaymentPlanAutoChargeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PaymentPlanAutoChargeCreateOrConnectWithoutPlanInput>
    >;
    create?: InputMaybe<Array<PaymentPlanAutoChargeCreateWithoutPlanInput>>;
    createMany?: InputMaybe<PaymentPlanAutoChargeCreateManyPlanInputEnvelope>;
    delete?: InputMaybe<Array<PaymentPlanAutoChargeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PaymentPlanAutoChargeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PaymentPlanAutoChargeWhereUniqueInput>>;
    set?: InputMaybe<Array<PaymentPlanAutoChargeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PaymentPlanAutoChargeUpdateWithWhereUniqueWithoutPlanInput>
    >;
    updateMany?: InputMaybe<
        Array<PaymentPlanAutoChargeUpdateManyWithWhereWithoutPlanInput>
    >;
    upsert?: InputMaybe<
        Array<PaymentPlanAutoChargeUpsertWithWhereUniqueWithoutPlanInput>
    >;
};

export type PaymentPlanAutoChargeUpdateWithWhereUniqueWithoutPlanInput = {
    data: PaymentPlanAutoChargeUpdateWithoutPlanInput;
    where: PaymentPlanAutoChargeWhereUniqueInput;
};

export type PaymentPlanAutoChargeUpdateWithoutPlanInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    attemptCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    attemptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    failedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    failureReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    idempotencyKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    nextRetryAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    reminderSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    scheduledDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    snapshotAfterPayment?: InputMaybe<Scalars['JSON']['input']>;
    snapshotAtCreation?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<EnumPaymentPlanAutoChargeStatusFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanAutoChargeUpsertWithWhereUniqueWithoutPlanInput = {
    create: PaymentPlanAutoChargeCreateWithoutPlanInput;
    update: PaymentPlanAutoChargeUpdateWithoutPlanInput;
    where: PaymentPlanAutoChargeWhereUniqueInput;
};

export type PaymentPlanAutoChargeWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanAutoChargeWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAutoChargeWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAutoChargeWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    attemptCount?: InputMaybe<IntFilter>;
    attemptedAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    failedAt?: InputMaybe<DateTimeNullableFilter>;
    failureReason?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    idempotencyKey?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    nextRetryAt?: InputMaybe<DateTimeNullableFilter>;
    paymentPlanId?: InputMaybe<UuidFilter>;
    plan?: InputMaybe<PaymentPlanRelationFilter>;
    reminderSentAt?: InputMaybe<DateTimeNullableFilter>;
    scheduledDate?: InputMaybe<DateTimeFilter>;
    snapshotAfterPayment?: InputMaybe<JsonNullableFilter>;
    snapshotAtCreation?: InputMaybe<JsonFilter>;
    status?: InputMaybe<EnumPaymentPlanAutoChargeStatusFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    timezone?: InputMaybe<StringFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanAutoChargeWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentPlanAutoChargeWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanAutoChargeWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanAutoChargeWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    attemptCount?: InputMaybe<IntFilter>;
    attemptedAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    failedAt?: InputMaybe<DateTimeNullableFilter>;
    failureReason?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    idempotencyKey?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    nextRetryAt?: InputMaybe<DateTimeNullableFilter>;
    paymentPlanId?: InputMaybe<UuidFilter>;
    plan?: InputMaybe<PaymentPlanRelationFilter>;
    reminderSentAt?: InputMaybe<DateTimeNullableFilter>;
    scheduledDate?: InputMaybe<DateTimeFilter>;
    snapshotAfterPayment?: InputMaybe<JsonNullableFilter>;
    snapshotAtCreation?: InputMaybe<JsonFilter>;
    status?: InputMaybe<EnumPaymentPlanAutoChargeStatusFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    timezone?: InputMaybe<StringFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanAvgAggregate = {
    __typename?: 'PaymentPlanAvgAggregate';
    chargeDayOfMonth?: Maybe<Scalars['Float']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    maxInstallments?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    shortId?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPlanAvgOrderByAggregateInput = {
    chargeDayOfMonth?: InputMaybe<SortOrder>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    maxInstallments?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    shortId?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatment = {
    __typename?: 'PaymentPlanBoughtTreatment';
    boughtTreatmentId: Scalars['String']['output'];
    claimStage: PaymentPlanBoughtTreatmentClaimStage;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    patientAuthorizedIssueAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId: Scalars['String']['output'];
    plan: PaymentPlan;
    status: PaymentPlanBoughtTreatmentStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanBoughtTreatmentAuditLog = {
    __typename?: 'PaymentPlanBoughtTreatmentAuditLog';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimStage?: Maybe<PaymentPlanBoughtTreatmentClaimStage>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    patientAuthorizedIssueAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanBoughtTreatmentAuditLogAvgAggregate = {
    __typename?: 'PaymentPlanBoughtTreatmentAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPlanBoughtTreatmentAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentAuditLogCountAggregate = {
    __typename?: 'PaymentPlanBoughtTreatmentAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    claimStage: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    patientAuthorizedIssueAt: Scalars['Int']['output'];
    paymentPlanBoughtTreatmentId: Scalars['Int']['output'];
    paymentPlanId: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PaymentPlanBoughtTreatmentAuditLogCountOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimStage?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    patientAuthorizedIssueAt?: InputMaybe<SortOrder>;
    paymentPlanBoughtTreatmentId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentAuditLogCreateInput = {
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    claimStage?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    patientAuthorizedIssueAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    paymentPlanBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanBoughtTreatmentAuditLogCreateManyInput = {
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    claimStage?: InputMaybe<PaymentPlanBoughtTreatmentClaimStage>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    patientAuthorizedIssueAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    paymentPlanBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    paymentPlanId?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanBoughtTreatmentAuditLogGroupBy = {
    __typename?: 'PaymentPlanBoughtTreatmentAuditLogGroupBy';
    _avg?: Maybe<PaymentPlanBoughtTreatmentAuditLogAvgAggregate>;
    _count?: Maybe<PaymentPlanBoughtTreatmentAuditLogCountAggregate>;
    _max?: Maybe<PaymentPlanBoughtTreatmentAuditLogMaxAggregate>;
    _min?: Maybe<PaymentPlanBoughtTreatmentAuditLogMinAggregate>;
    _sum?: Maybe<PaymentPlanBoughtTreatmentAuditLogSumAggregate>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimStage?: Maybe<PaymentPlanBoughtTreatmentClaimStage>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    patientAuthorizedIssueAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanBoughtTreatmentAuditLogMaxAggregate = {
    __typename?: 'PaymentPlanBoughtTreatmentAuditLogMaxAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimStage?: Maybe<PaymentPlanBoughtTreatmentClaimStage>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    patientAuthorizedIssueAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanBoughtTreatmentAuditLogMaxOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimStage?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    patientAuthorizedIssueAt?: InputMaybe<SortOrder>;
    paymentPlanBoughtTreatmentId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentAuditLogMinAggregate = {
    __typename?: 'PaymentPlanBoughtTreatmentAuditLogMinAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimStage?: Maybe<PaymentPlanBoughtTreatmentClaimStage>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    patientAuthorizedIssueAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanBoughtTreatmentAuditLogMinOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimStage?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    patientAuthorizedIssueAt?: InputMaybe<SortOrder>;
    paymentPlanBoughtTreatmentId?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogSumOrderByAggregateInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    claimStage?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    patientAuthorizedIssueAt?: InputMaybe<SortOrderInput>;
    paymentPlanBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentAuditLogOrderByWithRelationInput = {
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    claimStage?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    patientAuthorizedIssueAt?: InputMaybe<SortOrderInput>;
    paymentPlanBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentPlanBoughtTreatmentAuditLogScalarFieldEnum {
    BoughtTreatmentId = 'boughtTreatmentId',
    ClaimStage = 'claimStage',
    CreatedAt = 'createdAt',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Operation = 'operation',
    PatientAuthorizedIssueAt = 'patientAuthorizedIssueAt',
    PaymentPlanBoughtTreatmentId = 'paymentPlanBoughtTreatmentId',
    PaymentPlanId = 'paymentPlanId',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type PaymentPlanBoughtTreatmentAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogScalarWhereWithAggregatesInput>
    >;
    boughtTreatmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    claimStage?: InputMaybe<EnumPaymentPlanBoughtTreatmentClaimStageNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    patientAuthorizedIssueAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    paymentPlanBoughtTreatmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    paymentPlanId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumPaymentPlanBoughtTreatmentStatusNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PaymentPlanBoughtTreatmentAuditLogSumAggregate = {
    __typename?: 'PaymentPlanBoughtTreatmentAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type PaymentPlanBoughtTreatmentAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentAuditLogUpdateInput = {
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimStage?: InputMaybe<NullableEnumPaymentPlanBoughtTreatmentClaimStageFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    patientAuthorizedIssueAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    paymentPlanBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentPlanId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumPaymentPlanBoughtTreatmentStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanBoughtTreatmentAuditLogUpdateManyMutationInput = {
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    claimStage?: InputMaybe<NullableEnumPaymentPlanBoughtTreatmentClaimStageFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    patientAuthorizedIssueAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    paymentPlanBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentPlanId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumPaymentPlanBoughtTreatmentStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanBoughtTreatmentAuditLogWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanBoughtTreatmentAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanBoughtTreatmentAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanBoughtTreatmentAuditLogWhereInput>>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    claimStage?: InputMaybe<EnumPaymentPlanBoughtTreatmentClaimStageNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    patientAuthorizedIssueAt?: InputMaybe<DateTimeNullableFilter>;
    paymentPlanBoughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    status?: InputMaybe<EnumPaymentPlanBoughtTreatmentStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanBoughtTreatmentAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentPlanBoughtTreatmentAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanBoughtTreatmentAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanBoughtTreatmentAuditLogWhereInput>>;
    boughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    claimStage?: InputMaybe<EnumPaymentPlanBoughtTreatmentClaimStageNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    patientAuthorizedIssueAt?: InputMaybe<DateTimeNullableFilter>;
    paymentPlanBoughtTreatmentId?: InputMaybe<UuidNullableFilter>;
    paymentPlanId?: InputMaybe<UuidNullableFilter>;
    status?: InputMaybe<EnumPaymentPlanBoughtTreatmentStatusNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum PaymentPlanBoughtTreatmentClaimStage {
    Confirmed = 'CONFIRMED',
    Issue = 'ISSUE',
}

export type PaymentPlanBoughtTreatmentCountAggregate = {
    __typename?: 'PaymentPlanBoughtTreatmentCountAggregate';
    _all: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    claimStage: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    patientAuthorizedIssueAt: Scalars['Int']['output'];
    paymentPlanId: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PaymentPlanBoughtTreatmentCountOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimStage?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    patientAuthorizedIssueAt?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentCreateInput = {
    boughtTreatmentId: Scalars['String']['input'];
    claimStage: PaymentPlanBoughtTreatmentClaimStage;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    patientAuthorizedIssueAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    plan: PaymentPlanCreateNestedOneWithoutBoughtTreatmentsInput;
    status?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanBoughtTreatmentCreateManyInput = {
    boughtTreatmentId: Scalars['String']['input'];
    claimStage: PaymentPlanBoughtTreatmentClaimStage;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    patientAuthorizedIssueAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    paymentPlanId: Scalars['String']['input'];
    status?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanBoughtTreatmentCreateManyPlanInput = {
    boughtTreatmentId: Scalars['String']['input'];
    claimStage: PaymentPlanBoughtTreatmentClaimStage;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    patientAuthorizedIssueAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    status?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanBoughtTreatmentCreateManyPlanInputEnvelope = {
    data: Array<PaymentPlanBoughtTreatmentCreateManyPlanInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentPlanBoughtTreatmentCreateNestedManyWithoutPlanInput = {
    connect?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentCreateOrConnectWithoutPlanInput>
    >;
    create?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentCreateWithoutPlanInput>
    >;
    createMany?: InputMaybe<PaymentPlanBoughtTreatmentCreateManyPlanInputEnvelope>;
};

export type PaymentPlanBoughtTreatmentCreateOrConnectWithoutPlanInput = {
    create: PaymentPlanBoughtTreatmentCreateWithoutPlanInput;
    where: PaymentPlanBoughtTreatmentWhereUniqueInput;
};

export type PaymentPlanBoughtTreatmentCreateWithoutPlanInput = {
    boughtTreatmentId: Scalars['String']['input'];
    claimStage: PaymentPlanBoughtTreatmentClaimStage;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    patientAuthorizedIssueAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    status?: InputMaybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanBoughtTreatmentGroupBy = {
    __typename?: 'PaymentPlanBoughtTreatmentGroupBy';
    _count?: Maybe<PaymentPlanBoughtTreatmentCountAggregate>;
    _max?: Maybe<PaymentPlanBoughtTreatmentMaxAggregate>;
    _min?: Maybe<PaymentPlanBoughtTreatmentMinAggregate>;
    boughtTreatmentId: Scalars['String']['output'];
    claimStage: PaymentPlanBoughtTreatmentClaimStage;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    patientAuthorizedIssueAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId: Scalars['String']['output'];
    status: PaymentPlanBoughtTreatmentStatus;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanBoughtTreatmentListRelationFilter = {
    every?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
    none?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
    some?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
};

export type PaymentPlanBoughtTreatmentMaxAggregate = {
    __typename?: 'PaymentPlanBoughtTreatmentMaxAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimStage?: Maybe<PaymentPlanBoughtTreatmentClaimStage>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    patientAuthorizedIssueAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanBoughtTreatmentMaxOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimStage?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    patientAuthorizedIssueAt?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentMinAggregate = {
    __typename?: 'PaymentPlanBoughtTreatmentMinAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    claimStage?: Maybe<PaymentPlanBoughtTreatmentClaimStage>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    patientAuthorizedIssueAt?: Maybe<Scalars['DateTimeISO']['output']>;
    paymentPlanId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PaymentPlanBoughtTreatmentStatus>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanBoughtTreatmentMinOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimStage?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    patientAuthorizedIssueAt?: InputMaybe<SortOrder>;
    paymentPlanId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentOrderByWithAggregationInput = {
    _count?: InputMaybe<PaymentPlanBoughtTreatmentCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentPlanBoughtTreatmentMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentPlanBoughtTreatmentMinOrderByAggregateInput>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimStage?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    patientAuthorizedIssueAt?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentOrderByWithRelationInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    claimStage?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    patientAuthorizedIssueAt?: InputMaybe<SortOrderInput>;
    paymentPlanId?: InputMaybe<SortOrder>;
    plan?: InputMaybe<PaymentPlanOrderByWithRelationInput>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanBoughtTreatmentPaymentPlanIdBoughtTreatmentIdCompoundUniqueInput =
    {
        boughtTreatmentId: Scalars['String']['input'];
        paymentPlanId: Scalars['String']['input'];
    };

export enum PaymentPlanBoughtTreatmentScalarFieldEnum {
    BoughtTreatmentId = 'boughtTreatmentId',
    ClaimStage = 'claimStage',
    CreatedAt = 'createdAt',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    PatientAuthorizedIssueAt = 'patientAuthorizedIssueAt',
    PaymentPlanId = 'paymentPlanId',
    Status = 'status',
    UpdatedAt = 'updatedAt',
}

export type PaymentPlanBoughtTreatmentScalarWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanBoughtTreatmentScalarWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanBoughtTreatmentScalarWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanBoughtTreatmentScalarWhereInput>>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    claimStage?: InputMaybe<EnumPaymentPlanBoughtTreatmentClaimStageFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    patientAuthorizedIssueAt?: InputMaybe<DateTimeNullableFilter>;
    paymentPlanId?: InputMaybe<UuidFilter>;
    status?: InputMaybe<EnumPaymentPlanBoughtTreatmentStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanBoughtTreatmentScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentScalarWhereWithAggregatesInput>
    >;
    boughtTreatmentId?: InputMaybe<UuidWithAggregatesFilter>;
    claimStage?: InputMaybe<EnumPaymentPlanBoughtTreatmentClaimStageWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    patientAuthorizedIssueAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    paymentPlanId?: InputMaybe<UuidWithAggregatesFilter>;
    status?: InputMaybe<EnumPaymentPlanBoughtTreatmentStatusWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum PaymentPlanBoughtTreatmentStatus {
    Included = 'INCLUDED',
    Issue = 'ISSUE',
    Removed = 'REMOVED',
}

export type PaymentPlanBoughtTreatmentUpdateInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimStage?: InputMaybe<EnumPaymentPlanBoughtTreatmentClaimStageFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientAuthorizedIssueAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    plan?: InputMaybe<PaymentPlanUpdateOneRequiredWithoutBoughtTreatmentsNestedInput>;
    status?: InputMaybe<EnumPaymentPlanBoughtTreatmentStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanBoughtTreatmentUpdateManyMutationInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimStage?: InputMaybe<EnumPaymentPlanBoughtTreatmentClaimStageFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientAuthorizedIssueAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanBoughtTreatmentStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanBoughtTreatmentUpdateManyWithWhereWithoutPlanInput = {
    data: PaymentPlanBoughtTreatmentUpdateManyMutationInput;
    where: PaymentPlanBoughtTreatmentScalarWhereInput;
};

export type PaymentPlanBoughtTreatmentUpdateManyWithoutPlanNestedInput = {
    connect?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentCreateOrConnectWithoutPlanInput>
    >;
    create?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentCreateWithoutPlanInput>
    >;
    createMany?: InputMaybe<PaymentPlanBoughtTreatmentCreateManyPlanInputEnvelope>;
    delete?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PaymentPlanBoughtTreatmentScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereUniqueInput>>;
    set?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentUpdateWithWhereUniqueWithoutPlanInput>
    >;
    updateMany?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentUpdateManyWithWhereWithoutPlanInput>
    >;
    upsert?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentUpsertWithWhereUniqueWithoutPlanInput>
    >;
};

export type PaymentPlanBoughtTreatmentUpdateWithWhereUniqueWithoutPlanInput = {
    data: PaymentPlanBoughtTreatmentUpdateWithoutPlanInput;
    where: PaymentPlanBoughtTreatmentWhereUniqueInput;
};

export type PaymentPlanBoughtTreatmentUpdateWithoutPlanInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    claimStage?: InputMaybe<EnumPaymentPlanBoughtTreatmentClaimStageFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    patientAuthorizedIssueAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanBoughtTreatmentStatusFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanBoughtTreatmentUpsertWithWhereUniqueWithoutPlanInput = {
    create: PaymentPlanBoughtTreatmentCreateWithoutPlanInput;
    update: PaymentPlanBoughtTreatmentUpdateWithoutPlanInput;
    where: PaymentPlanBoughtTreatmentWhereUniqueInput;
};

export type PaymentPlanBoughtTreatmentWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereInput>>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    claimStage?: InputMaybe<EnumPaymentPlanBoughtTreatmentClaimStageFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    patientAuthorizedIssueAt?: InputMaybe<DateTimeNullableFilter>;
    paymentPlanId?: InputMaybe<UuidFilter>;
    plan?: InputMaybe<PaymentPlanRelationFilter>;
    status?: InputMaybe<EnumPaymentPlanBoughtTreatmentStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanBoughtTreatmentWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanBoughtTreatmentWhereInput>>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    claimStage?: InputMaybe<EnumPaymentPlanBoughtTreatmentClaimStageFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    patientAuthorizedIssueAt?: InputMaybe<DateTimeNullableFilter>;
    paymentPlanId?: InputMaybe<UuidFilter>;
    paymentPlanId_boughtTreatmentId?: InputMaybe<PaymentPlanBoughtTreatmentPaymentPlanIdBoughtTreatmentIdCompoundUniqueInput>;
    plan?: InputMaybe<PaymentPlanRelationFilter>;
    status?: InputMaybe<EnumPaymentPlanBoughtTreatmentStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum PaymentPlanChargeMode {
    AutoCharge = 'AUTO_CHARGE',
    MessageOnly = 'MESSAGE_ONLY',
}

export type PaymentPlanConsumerIdShortIdCompoundUniqueInput = {
    consumerId: Scalars['String']['input'];
    shortId: Scalars['Int']['input'];
};

export type PaymentPlanCount = {
    __typename?: 'PaymentPlanCount';
    adjustments: Scalars['Int']['output'];
    autoCharges: Scalars['Int']['output'];
    boughtTreatments: Scalars['Int']['output'];
};

export type PaymentPlanCountAdjustmentsArgs = {
    where?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
};

export type PaymentPlanCountAutoChargesArgs = {
    where?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
};

export type PaymentPlanCountBoughtTreatmentsArgs = {
    where?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
};

export type PaymentPlanCountAggregate = {
    __typename?: 'PaymentPlanCountAggregate';
    _all: Scalars['Int']['output'];
    activatedAt: Scalars['Int']['output'];
    athenaAcceptanceWindowExpiresAt: Scalars['Int']['output'];
    chargeDayOfMonth: Scalars['Int']['output'];
    chargeDayOfWeek: Scalars['Int']['output'];
    chargeFrequency: Scalars['Int']['output'];
    chargeMode: Scalars['Int']['output'];
    completedAt: Scalars['Int']['output'];
    confirmedRemaining: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    depositAmount: Scalars['Int']['output'];
    endDate: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    initiatedBy: Scalars['Int']['output'];
    installmentAmount: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    maxInstallments: Scalars['Int']['output'];
    migratedFromAthena: Scalars['Int']['output'];
    newPaymentMethodRequiredAt: Scalars['Int']['output'];
    nextChargeDateAt: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    paymentAuthorizationId: Scalars['Int']['output'];
    paymentFailedAt: Scalars['Int']['output'];
    shortId: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    voidReason: Scalars['Int']['output'];
    voidedAt: Scalars['Int']['output'];
};

export type PaymentPlanCountOrderByAggregateInput = {
    activatedAt?: InputMaybe<SortOrder>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<SortOrder>;
    chargeDayOfMonth?: InputMaybe<SortOrder>;
    chargeDayOfWeek?: InputMaybe<SortOrder>;
    chargeFrequency?: InputMaybe<SortOrder>;
    chargeMode?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrder>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    maxInstallments?: InputMaybe<SortOrder>;
    migratedFromAthena?: InputMaybe<SortOrder>;
    newPaymentMethodRequiredAt?: InputMaybe<SortOrder>;
    nextChargeDateAt?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentFailedAt?: InputMaybe<SortOrder>;
    shortId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanCreateInput = {
    activatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentCreateNestedManyWithoutPlanInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<
        Scalars['DateTimeISO']['input']
    >;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeCreateNestedManyWithoutPlanInput>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentCreateNestedManyWithoutPlanInput>;
    chargeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
    chargeDayOfWeek?: InputMaybe<DayOfWeekEnum>;
    chargeFrequency?: InputMaybe<PaymentPlanFrequency>;
    chargeMode?: InputMaybe<PaymentPlanChargeMode>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    confirmedRemaining?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maxInstallments?: InputMaybe<Scalars['Int']['input']>;
    migratedFromAthena?: InputMaybe<Scalars['Boolean']['input']>;
    newPaymentMethodRequiredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nextChargeDateAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationCreateNestedOneWithoutPaymentPlanInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationCreateNestedOneWithoutPaymentPlansInput>;
    paymentFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    shortId: Scalars['Int']['input'];
    status?: InputMaybe<PaymentPlanStatus>;
    type: PaymentPlanType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanCreateManyInput = {
    activatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<
        Scalars['DateTimeISO']['input']
    >;
    chargeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
    chargeDayOfWeek?: InputMaybe<DayOfWeekEnum>;
    chargeFrequency?: InputMaybe<PaymentPlanFrequency>;
    chargeMode?: InputMaybe<PaymentPlanChargeMode>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    confirmedRemaining?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maxInstallments?: InputMaybe<Scalars['Int']['input']>;
    migratedFromAthena?: InputMaybe<Scalars['Boolean']['input']>;
    newPaymentMethodRequiredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nextChargeDateAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    paymentAuthorizationId?: InputMaybe<Scalars['String']['input']>;
    paymentFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    shortId: Scalars['Int']['input'];
    status?: InputMaybe<PaymentPlanStatus>;
    type: PaymentPlanType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanCreateManyPaymentAuthorizationInput = {
    activatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<
        Scalars['DateTimeISO']['input']
    >;
    chargeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
    chargeDayOfWeek?: InputMaybe<DayOfWeekEnum>;
    chargeFrequency?: InputMaybe<PaymentPlanFrequency>;
    chargeMode?: InputMaybe<PaymentPlanChargeMode>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    confirmedRemaining?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maxInstallments?: InputMaybe<Scalars['Int']['input']>;
    migratedFromAthena?: InputMaybe<Scalars['Boolean']['input']>;
    newPaymentMethodRequiredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nextChargeDateAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    paymentFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    shortId: Scalars['Int']['input'];
    status?: InputMaybe<PaymentPlanStatus>;
    type: PaymentPlanType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanCreateManyPaymentAuthorizationInputEnvelope = {
    data: Array<PaymentPlanCreateManyPaymentAuthorizationInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentPlanCreateNestedManyWithoutPaymentAuthorizationInput = {
    connect?: InputMaybe<Array<PaymentPlanWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PaymentPlanCreateOrConnectWithoutPaymentAuthorizationInput>
    >;
    create?: InputMaybe<
        Array<PaymentPlanCreateWithoutPaymentAuthorizationInput>
    >;
    createMany?: InputMaybe<PaymentPlanCreateManyPaymentAuthorizationInputEnvelope>;
};

export type PaymentPlanCreateNestedOneWithoutAdjustmentsInput = {
    connect?: InputMaybe<PaymentPlanWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PaymentPlanCreateOrConnectWithoutAdjustmentsInput>;
    create?: InputMaybe<PaymentPlanCreateWithoutAdjustmentsInput>;
};

export type PaymentPlanCreateNestedOneWithoutAutoChargesInput = {
    connect?: InputMaybe<PaymentPlanWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PaymentPlanCreateOrConnectWithoutAutoChargesInput>;
    create?: InputMaybe<PaymentPlanCreateWithoutAutoChargesInput>;
};

export type PaymentPlanCreateNestedOneWithoutBoughtTreatmentsInput = {
    connect?: InputMaybe<PaymentPlanWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PaymentPlanCreateOrConnectWithoutBoughtTreatmentsInput>;
    create?: InputMaybe<PaymentPlanCreateWithoutBoughtTreatmentsInput>;
};

export type PaymentPlanCreateNestedOneWithoutPayLaterAuthorizationInput = {
    connect?: InputMaybe<PaymentPlanWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PaymentPlanCreateOrConnectWithoutPayLaterAuthorizationInput>;
    create?: InputMaybe<PaymentPlanCreateWithoutPayLaterAuthorizationInput>;
};

export type PaymentPlanCreateOrConnectWithoutAdjustmentsInput = {
    create: PaymentPlanCreateWithoutAdjustmentsInput;
    where: PaymentPlanWhereUniqueInput;
};

export type PaymentPlanCreateOrConnectWithoutAutoChargesInput = {
    create: PaymentPlanCreateWithoutAutoChargesInput;
    where: PaymentPlanWhereUniqueInput;
};

export type PaymentPlanCreateOrConnectWithoutBoughtTreatmentsInput = {
    create: PaymentPlanCreateWithoutBoughtTreatmentsInput;
    where: PaymentPlanWhereUniqueInput;
};

export type PaymentPlanCreateOrConnectWithoutPayLaterAuthorizationInput = {
    create: PaymentPlanCreateWithoutPayLaterAuthorizationInput;
    where: PaymentPlanWhereUniqueInput;
};

export type PaymentPlanCreateOrConnectWithoutPaymentAuthorizationInput = {
    create: PaymentPlanCreateWithoutPaymentAuthorizationInput;
    where: PaymentPlanWhereUniqueInput;
};

export type PaymentPlanCreateWithoutAdjustmentsInput = {
    activatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<
        Scalars['DateTimeISO']['input']
    >;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeCreateNestedManyWithoutPlanInput>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentCreateNestedManyWithoutPlanInput>;
    chargeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
    chargeDayOfWeek?: InputMaybe<DayOfWeekEnum>;
    chargeFrequency?: InputMaybe<PaymentPlanFrequency>;
    chargeMode?: InputMaybe<PaymentPlanChargeMode>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    confirmedRemaining?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maxInstallments?: InputMaybe<Scalars['Int']['input']>;
    migratedFromAthena?: InputMaybe<Scalars['Boolean']['input']>;
    newPaymentMethodRequiredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nextChargeDateAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationCreateNestedOneWithoutPaymentPlanInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationCreateNestedOneWithoutPaymentPlansInput>;
    paymentFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    shortId: Scalars['Int']['input'];
    status?: InputMaybe<PaymentPlanStatus>;
    type: PaymentPlanType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanCreateWithoutAutoChargesInput = {
    activatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentCreateNestedManyWithoutPlanInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<
        Scalars['DateTimeISO']['input']
    >;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentCreateNestedManyWithoutPlanInput>;
    chargeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
    chargeDayOfWeek?: InputMaybe<DayOfWeekEnum>;
    chargeFrequency?: InputMaybe<PaymentPlanFrequency>;
    chargeMode?: InputMaybe<PaymentPlanChargeMode>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    confirmedRemaining?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maxInstallments?: InputMaybe<Scalars['Int']['input']>;
    migratedFromAthena?: InputMaybe<Scalars['Boolean']['input']>;
    newPaymentMethodRequiredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nextChargeDateAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationCreateNestedOneWithoutPaymentPlanInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationCreateNestedOneWithoutPaymentPlansInput>;
    paymentFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    shortId: Scalars['Int']['input'];
    status?: InputMaybe<PaymentPlanStatus>;
    type: PaymentPlanType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanCreateWithoutBoughtTreatmentsInput = {
    activatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentCreateNestedManyWithoutPlanInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<
        Scalars['DateTimeISO']['input']
    >;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeCreateNestedManyWithoutPlanInput>;
    chargeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
    chargeDayOfWeek?: InputMaybe<DayOfWeekEnum>;
    chargeFrequency?: InputMaybe<PaymentPlanFrequency>;
    chargeMode?: InputMaybe<PaymentPlanChargeMode>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    confirmedRemaining?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maxInstallments?: InputMaybe<Scalars['Int']['input']>;
    migratedFromAthena?: InputMaybe<Scalars['Boolean']['input']>;
    newPaymentMethodRequiredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nextChargeDateAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationCreateNestedOneWithoutPaymentPlanInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationCreateNestedOneWithoutPaymentPlansInput>;
    paymentFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    shortId: Scalars['Int']['input'];
    status?: InputMaybe<PaymentPlanStatus>;
    type: PaymentPlanType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanCreateWithoutPayLaterAuthorizationInput = {
    activatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentCreateNestedManyWithoutPlanInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<
        Scalars['DateTimeISO']['input']
    >;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeCreateNestedManyWithoutPlanInput>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentCreateNestedManyWithoutPlanInput>;
    chargeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
    chargeDayOfWeek?: InputMaybe<DayOfWeekEnum>;
    chargeFrequency?: InputMaybe<PaymentPlanFrequency>;
    chargeMode?: InputMaybe<PaymentPlanChargeMode>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    confirmedRemaining?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maxInstallments?: InputMaybe<Scalars['Int']['input']>;
    migratedFromAthena?: InputMaybe<Scalars['Boolean']['input']>;
    newPaymentMethodRequiredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nextChargeDateAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    paymentAuthorization?: InputMaybe<PaymentAuthorizationCreateNestedOneWithoutPaymentPlansInput>;
    paymentFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    shortId: Scalars['Int']['input'];
    status?: InputMaybe<PaymentPlanStatus>;
    type: PaymentPlanType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanCreateWithoutPaymentAuthorizationInput = {
    activatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentCreateNestedManyWithoutPlanInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<
        Scalars['DateTimeISO']['input']
    >;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeCreateNestedManyWithoutPlanInput>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentCreateNestedManyWithoutPlanInput>;
    chargeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
    chargeDayOfWeek?: InputMaybe<DayOfWeekEnum>;
    chargeFrequency?: InputMaybe<PaymentPlanFrequency>;
    chargeMode?: InputMaybe<PaymentPlanChargeMode>;
    completedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    confirmedRemaining?: InputMaybe<Scalars['Decimal']['input']>;
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['input'];
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    maxInstallments?: InputMaybe<Scalars['Int']['input']>;
    migratedFromAthena?: InputMaybe<Scalars['Boolean']['input']>;
    newPaymentMethodRequiredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nextChargeDateAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationCreateNestedOneWithoutPaymentPlanInput>;
    paymentFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    shortId: Scalars['Int']['input'];
    status?: InputMaybe<PaymentPlanStatus>;
    type: PaymentPlanType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    voidReason?: InputMaybe<Scalars['String']['input']>;
    voidedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export enum PaymentPlanFrequency {
    BiMonthly = 'BI_MONTHLY',
    BiWeekly = 'BI_WEEKLY',
    Monthly = 'MONTHLY',
    Weekly = 'WEEKLY',
}

export type PaymentPlanGroupBy = {
    __typename?: 'PaymentPlanGroupBy';
    _avg?: Maybe<PaymentPlanAvgAggregate>;
    _count?: Maybe<PaymentPlanCountAggregate>;
    _max?: Maybe<PaymentPlanMaxAggregate>;
    _min?: Maybe<PaymentPlanMinAggregate>;
    _sum?: Maybe<PaymentPlanSumAggregate>;
    activatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    athenaAcceptanceWindowExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    chargeDayOfWeek?: Maybe<DayOfWeekEnum>;
    chargeFrequency: PaymentPlanFrequency;
    chargeMode: PaymentPlanChargeMode;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    confirmedRemaining: Scalars['Decimal']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount: Scalars['Decimal']['output'];
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    initiatedBy: PaymentPlanInitiatedBy;
    installmentAmount: Scalars['Decimal']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    migratedFromAthena: Scalars['Boolean']['output'];
    newPaymentMethodRequiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    nextChargeDateAt?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId: Scalars['Int']['output'];
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    shortId: Scalars['Int']['output'];
    status: PaymentPlanStatus;
    type: PaymentPlanType;
    updatedAt: Scalars['DateTimeISO']['output'];
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum PaymentPlanInitiatedBy {
    Admin = 'ADMIN',
    Patient = 'PATIENT',
}

export type PaymentPlanListRelationFilter = {
    every?: InputMaybe<PaymentPlanWhereInput>;
    none?: InputMaybe<PaymentPlanWhereInput>;
    some?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentPlanMaxAggregate = {
    __typename?: 'PaymentPlanMaxAggregate';
    activatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    athenaAcceptanceWindowExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    chargeDayOfWeek?: Maybe<DayOfWeekEnum>;
    chargeFrequency?: Maybe<PaymentPlanFrequency>;
    chargeMode?: Maybe<PaymentPlanChargeMode>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    initiatedBy?: Maybe<PaymentPlanInitiatedBy>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    migratedFromAthena?: Maybe<Scalars['Boolean']['output']>;
    newPaymentMethodRequiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    nextChargeDateAt?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    shortId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<PaymentPlanStatus>;
    type?: Maybe<PaymentPlanType>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanMaxOrderByAggregateInput = {
    activatedAt?: InputMaybe<SortOrder>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<SortOrder>;
    chargeDayOfMonth?: InputMaybe<SortOrder>;
    chargeDayOfWeek?: InputMaybe<SortOrder>;
    chargeFrequency?: InputMaybe<SortOrder>;
    chargeMode?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrder>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    maxInstallments?: InputMaybe<SortOrder>;
    migratedFromAthena?: InputMaybe<SortOrder>;
    newPaymentMethodRequiredAt?: InputMaybe<SortOrder>;
    nextChargeDateAt?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentFailedAt?: InputMaybe<SortOrder>;
    shortId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanMinAggregate = {
    __typename?: 'PaymentPlanMinAggregate';
    activatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    athenaAcceptanceWindowExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    chargeDayOfWeek?: Maybe<DayOfWeekEnum>;
    chargeFrequency?: Maybe<PaymentPlanFrequency>;
    chargeMode?: Maybe<PaymentPlanChargeMode>;
    completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    endDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    initiatedBy?: Maybe<PaymentPlanInitiatedBy>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    migratedFromAthena?: Maybe<Scalars['Boolean']['output']>;
    newPaymentMethodRequiredAt?: Maybe<Scalars['DateTimeISO']['output']>;
    nextChargeDateAt?: Maybe<Scalars['DateTimeISO']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    paymentAuthorizationId?: Maybe<Scalars['String']['output']>;
    paymentFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    shortId?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<PaymentPlanStatus>;
    type?: Maybe<PaymentPlanType>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    voidReason?: Maybe<Scalars['String']['output']>;
    voidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanMinOrderByAggregateInput = {
    activatedAt?: InputMaybe<SortOrder>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<SortOrder>;
    chargeDayOfMonth?: InputMaybe<SortOrder>;
    chargeDayOfWeek?: InputMaybe<SortOrder>;
    chargeFrequency?: InputMaybe<SortOrder>;
    chargeMode?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrder>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    maxInstallments?: InputMaybe<SortOrder>;
    migratedFromAthena?: InputMaybe<SortOrder>;
    newPaymentMethodRequiredAt?: InputMaybe<SortOrder>;
    nextChargeDateAt?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrder>;
    paymentFailedAt?: InputMaybe<SortOrder>;
    shortId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrder>;
    voidedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanNullableRelationFilter = {
    is?: InputMaybe<PaymentPlanWhereInput>;
    isNot?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentPlanOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentPlanAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentPlanCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentPlanMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentPlanMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentPlanSumOrderByAggregateInput>;
    activatedAt?: InputMaybe<SortOrderInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<SortOrderInput>;
    chargeDayOfMonth?: InputMaybe<SortOrderInput>;
    chargeDayOfWeek?: InputMaybe<SortOrderInput>;
    chargeFrequency?: InputMaybe<SortOrder>;
    chargeMode?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrderInput>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    maxInstallments?: InputMaybe<SortOrderInput>;
    migratedFromAthena?: InputMaybe<SortOrder>;
    newPaymentMethodRequiredAt?: InputMaybe<SortOrderInput>;
    nextChargeDateAt?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    paymentAuthorizationId?: InputMaybe<SortOrderInput>;
    paymentFailedAt?: InputMaybe<SortOrderInput>;
    shortId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrderInput>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export type PaymentPlanOrderByWithRelationInput = {
    activatedAt?: InputMaybe<SortOrderInput>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentOrderByRelationAggregateInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<SortOrderInput>;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeOrderByRelationAggregateInput>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentOrderByRelationAggregateInput>;
    chargeDayOfMonth?: InputMaybe<SortOrderInput>;
    chargeDayOfWeek?: InputMaybe<SortOrderInput>;
    chargeFrequency?: InputMaybe<SortOrder>;
    chargeMode?: InputMaybe<SortOrder>;
    completedAt?: InputMaybe<SortOrderInput>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    endDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    initiatedBy?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    maxInstallments?: InputMaybe<SortOrderInput>;
    migratedFromAthena?: InputMaybe<SortOrder>;
    newPaymentMethodRequiredAt?: InputMaybe<SortOrderInput>;
    nextChargeDateAt?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationOrderByWithRelationInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationOrderByWithRelationInput>;
    paymentAuthorizationId?: InputMaybe<SortOrderInput>;
    paymentFailedAt?: InputMaybe<SortOrderInput>;
    shortId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    voidReason?: InputMaybe<SortOrderInput>;
    voidedAt?: InputMaybe<SortOrderInput>;
};

export type PaymentPlanOrgConfig = {
    __typename?: 'PaymentPlanOrgConfig';
    allowPaymentPlanCreateEditFromAccount: Scalars['Boolean']['output'];
    chargeDaysPostReturn: Scalars['Int']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    forceCardOnFile: Scalars['Boolean']['output'];
    installmentCadenceDays: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    migrationAcceptanceWindowDays: Scalars['Int']['output'];
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    orgId: Scalars['Int']['output'];
    payLaterAutoEnrollEnabled: Scalars['Boolean']['output'];
    payLaterEnabled: Scalars['Boolean']['output'];
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlansEnabled: Scalars['Boolean']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanOrgConfigAuditLog = {
    __typename?: 'PaymentPlanOrgConfigAuditLog';
    allowPaymentPlanCreateEditFromAccount?: Maybe<Scalars['Boolean']['output']>;
    chargeDaysPostReturn?: Maybe<Scalars['Int']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    forceCardOnFile?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['Int']['output'];
    installmentCadenceDays?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Int']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAutoEnrollEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlansEnabled?: Maybe<Scalars['Boolean']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanOrgConfigAuditLogAvgAggregate = {
    __typename?: 'PaymentPlanOrgConfigAuditLogAvgAggregate';
    chargeDaysPostReturn?: Maybe<Scalars['Float']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    installmentCadenceDays?: Maybe<Scalars['Float']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Float']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentPlanOrgConfigAuditLogAvgOrderByAggregateInput = {
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositPercent?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrder>;
    paymentPlanThreshold?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigAuditLogCountAggregate = {
    __typename?: 'PaymentPlanOrgConfigAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    allowPaymentPlanCreateEditFromAccount: Scalars['Int']['output'];
    chargeDaysPostReturn: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    depositAmount: Scalars['Int']['output'];
    depositPercent: Scalars['Int']['output'];
    forceCardOnFile: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    installmentCadenceDays: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    migrationAcceptanceWindowDays: Scalars['Int']['output'];
    minimumFloorPercent: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payLaterAutoEnrollEnabled: Scalars['Int']['output'];
    payLaterEnabled: Scalars['Int']['output'];
    payLaterThreshold: Scalars['Int']['output'];
    paymentPlanThreshold: Scalars['Int']['output'];
    paymentPlansEnabled: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PaymentPlanOrgConfigAuditLogCountOrderByAggregateInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<SortOrder>;
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositPercent?: InputMaybe<SortOrder>;
    forceCardOnFile?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAutoEnrollEnabled?: InputMaybe<SortOrder>;
    payLaterEnabled?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrder>;
    paymentPlanThreshold?: InputMaybe<SortOrder>;
    paymentPlansEnabled?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigAuditLogCreateInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<
        Scalars['Boolean']['input']
    >;
    chargeDaysPostReturn?: InputMaybe<Scalars['Int']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositPercent?: InputMaybe<Scalars['Decimal']['input']>;
    forceCardOnFile?: InputMaybe<Scalars['Boolean']['input']>;
    installmentCadenceDays?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    migrationAcceptanceWindowDays?: InputMaybe<Scalars['Int']['input']>;
    minimumFloorPercent?: InputMaybe<Scalars['Decimal']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    payLaterAutoEnrollEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    payLaterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    payLaterThreshold?: InputMaybe<Scalars['Decimal']['input']>;
    paymentPlanThreshold?: InputMaybe<Scalars['Decimal']['input']>;
    paymentPlansEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanOrgConfigAuditLogCreateManyInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<
        Scalars['Boolean']['input']
    >;
    chargeDaysPostReturn?: InputMaybe<Scalars['Int']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositPercent?: InputMaybe<Scalars['Decimal']['input']>;
    forceCardOnFile?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    installmentCadenceDays?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    migrationAcceptanceWindowDays?: InputMaybe<Scalars['Int']['input']>;
    minimumFloorPercent?: InputMaybe<Scalars['Decimal']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    payLaterAutoEnrollEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    payLaterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    payLaterThreshold?: InputMaybe<Scalars['Decimal']['input']>;
    paymentPlanThreshold?: InputMaybe<Scalars['Decimal']['input']>;
    paymentPlansEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanOrgConfigAuditLogGroupBy = {
    __typename?: 'PaymentPlanOrgConfigAuditLogGroupBy';
    _avg?: Maybe<PaymentPlanOrgConfigAuditLogAvgAggregate>;
    _count?: Maybe<PaymentPlanOrgConfigAuditLogCountAggregate>;
    _max?: Maybe<PaymentPlanOrgConfigAuditLogMaxAggregate>;
    _min?: Maybe<PaymentPlanOrgConfigAuditLogMinAggregate>;
    _sum?: Maybe<PaymentPlanOrgConfigAuditLogSumAggregate>;
    allowPaymentPlanCreateEditFromAccount?: Maybe<Scalars['Boolean']['output']>;
    chargeDaysPostReturn?: Maybe<Scalars['Int']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    forceCardOnFile?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['Int']['output'];
    installmentCadenceDays?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Int']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAutoEnrollEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlansEnabled?: Maybe<Scalars['Boolean']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanOrgConfigAuditLogMaxAggregate = {
    __typename?: 'PaymentPlanOrgConfigAuditLogMaxAggregate';
    allowPaymentPlanCreateEditFromAccount?: Maybe<Scalars['Boolean']['output']>;
    chargeDaysPostReturn?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    forceCardOnFile?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    installmentCadenceDays?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Int']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAutoEnrollEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlansEnabled?: Maybe<Scalars['Boolean']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanOrgConfigAuditLogMaxOrderByAggregateInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<SortOrder>;
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositPercent?: InputMaybe<SortOrder>;
    forceCardOnFile?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAutoEnrollEnabled?: InputMaybe<SortOrder>;
    payLaterEnabled?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrder>;
    paymentPlanThreshold?: InputMaybe<SortOrder>;
    paymentPlansEnabled?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigAuditLogMinAggregate = {
    __typename?: 'PaymentPlanOrgConfigAuditLogMinAggregate';
    allowPaymentPlanCreateEditFromAccount?: Maybe<Scalars['Boolean']['output']>;
    chargeDaysPostReturn?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    forceCardOnFile?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    installmentCadenceDays?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Int']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAutoEnrollEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlansEnabled?: Maybe<Scalars['Boolean']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanOrgConfigAuditLogMinOrderByAggregateInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<SortOrder>;
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositPercent?: InputMaybe<SortOrder>;
    forceCardOnFile?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAutoEnrollEnabled?: InputMaybe<SortOrder>;
    payLaterEnabled?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrder>;
    paymentPlanThreshold?: InputMaybe<SortOrder>;
    paymentPlansEnabled?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentPlanOrgConfigAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentPlanOrgConfigAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentPlanOrgConfigAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentPlanOrgConfigAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentPlanOrgConfigAuditLogSumOrderByAggregateInput>;
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<SortOrderInput>;
    chargeDaysPostReturn?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrderInput>;
    depositPercent?: InputMaybe<SortOrderInput>;
    forceCardOnFile?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrderInput>;
    minimumFloorPercent?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    payLaterAutoEnrollEnabled?: InputMaybe<SortOrderInput>;
    payLaterEnabled?: InputMaybe<SortOrderInput>;
    payLaterThreshold?: InputMaybe<SortOrderInput>;
    paymentPlanThreshold?: InputMaybe<SortOrderInput>;
    paymentPlansEnabled?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigAuditLogOrderByWithRelationInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<SortOrderInput>;
    chargeDaysPostReturn?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrderInput>;
    depositPercent?: InputMaybe<SortOrderInput>;
    forceCardOnFile?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrderInput>;
    minimumFloorPercent?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    payLaterAutoEnrollEnabled?: InputMaybe<SortOrderInput>;
    payLaterEnabled?: InputMaybe<SortOrderInput>;
    payLaterThreshold?: InputMaybe<SortOrderInput>;
    paymentPlanThreshold?: InputMaybe<SortOrderInput>;
    paymentPlansEnabled?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentPlanOrgConfigAuditLogScalarFieldEnum {
    AllowPaymentPlanCreateEditFromAccount = 'allowPaymentPlanCreateEditFromAccount',
    ChargeDaysPostReturn = 'chargeDaysPostReturn',
    CreatedAt = 'createdAt',
    DepositAmount = 'depositAmount',
    DepositPercent = 'depositPercent',
    ForceCardOnFile = 'forceCardOnFile',
    Id = 'id',
    InstallmentCadenceDays = 'installmentCadenceDays',
    LastUpdatedBy = 'lastUpdatedBy',
    MigrationAcceptanceWindowDays = 'migrationAcceptanceWindowDays',
    MinimumFloorPercent = 'minimumFloorPercent',
    Operation = 'operation',
    OrgId = 'orgId',
    PayLaterAutoEnrollEnabled = 'payLaterAutoEnrollEnabled',
    PayLaterEnabled = 'payLaterEnabled',
    PayLaterThreshold = 'payLaterThreshold',
    PaymentPlanThreshold = 'paymentPlanThreshold',
    PaymentPlansEnabled = 'paymentPlansEnabled',
    UpdatedAt = 'updatedAt',
}

export type PaymentPlanOrgConfigAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PaymentPlanOrgConfigAuditLogScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PaymentPlanOrgConfigAuditLogScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<PaymentPlanOrgConfigAuditLogScalarWhereWithAggregatesInput>
    >;
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<BoolNullableWithAggregatesFilter>;
    chargeDaysPostReturn?: InputMaybe<IntNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    depositAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    depositPercent?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    forceCardOnFile?: InputMaybe<BoolNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    installmentCadenceDays?: InputMaybe<IntNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    migrationAcceptanceWindowDays?: InputMaybe<IntNullableWithAggregatesFilter>;
    minimumFloorPercent?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    payLaterAutoEnrollEnabled?: InputMaybe<BoolNullableWithAggregatesFilter>;
    payLaterEnabled?: InputMaybe<BoolNullableWithAggregatesFilter>;
    payLaterThreshold?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    paymentPlanThreshold?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    paymentPlansEnabled?: InputMaybe<BoolNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PaymentPlanOrgConfigAuditLogSumAggregate = {
    __typename?: 'PaymentPlanOrgConfigAuditLogSumAggregate';
    chargeDaysPostReturn?: Maybe<Scalars['Int']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    installmentCadenceDays?: Maybe<Scalars['Int']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Int']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentPlanOrgConfigAuditLogSumOrderByAggregateInput = {
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositPercent?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrder>;
    paymentPlanThreshold?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigAuditLogUpdateInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    chargeDaysPostReturn?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    depositPercent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    forceCardOnFile?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    installmentCadenceDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    migrationAcceptanceWindowDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    minimumFloorPercent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payLaterAutoEnrollEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    payLaterEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    payLaterThreshold?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    paymentPlanThreshold?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    paymentPlansEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanOrgConfigAuditLogUpdateManyMutationInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    chargeDaysPostReturn?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    depositPercent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    forceCardOnFile?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    installmentCadenceDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    migrationAcceptanceWindowDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    minimumFloorPercent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payLaterAutoEnrollEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    payLaterEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    payLaterThreshold?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    paymentPlanThreshold?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    paymentPlansEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanOrgConfigAuditLogWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanOrgConfigAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanOrgConfigAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanOrgConfigAuditLogWhereInput>>;
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<BoolNullableFilter>;
    chargeDaysPostReturn?: InputMaybe<IntNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalNullableFilter>;
    depositPercent?: InputMaybe<DecimalNullableFilter>;
    forceCardOnFile?: InputMaybe<BoolNullableFilter>;
    id?: InputMaybe<IntFilter>;
    installmentCadenceDays?: InputMaybe<IntNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    migrationAcceptanceWindowDays?: InputMaybe<IntNullableFilter>;
    minimumFloorPercent?: InputMaybe<DecimalNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    payLaterAutoEnrollEnabled?: InputMaybe<BoolNullableFilter>;
    payLaterEnabled?: InputMaybe<BoolNullableFilter>;
    payLaterThreshold?: InputMaybe<DecimalNullableFilter>;
    paymentPlanThreshold?: InputMaybe<DecimalNullableFilter>;
    paymentPlansEnabled?: InputMaybe<BoolNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanOrgConfigAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentPlanOrgConfigAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanOrgConfigAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanOrgConfigAuditLogWhereInput>>;
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<BoolNullableFilter>;
    chargeDaysPostReturn?: InputMaybe<IntNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalNullableFilter>;
    depositPercent?: InputMaybe<DecimalNullableFilter>;
    forceCardOnFile?: InputMaybe<BoolNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    installmentCadenceDays?: InputMaybe<IntNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    migrationAcceptanceWindowDays?: InputMaybe<IntNullableFilter>;
    minimumFloorPercent?: InputMaybe<DecimalNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    payLaterAutoEnrollEnabled?: InputMaybe<BoolNullableFilter>;
    payLaterEnabled?: InputMaybe<BoolNullableFilter>;
    payLaterThreshold?: InputMaybe<DecimalNullableFilter>;
    paymentPlanThreshold?: InputMaybe<DecimalNullableFilter>;
    paymentPlansEnabled?: InputMaybe<BoolNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanOrgConfigAvgAggregate = {
    __typename?: 'PaymentPlanOrgConfigAvgAggregate';
    chargeDaysPostReturn?: Maybe<Scalars['Float']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    installmentCadenceDays?: Maybe<Scalars['Float']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Float']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentPlanOrgConfigAvgOrderByAggregateInput = {
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositPercent?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrder>;
    paymentPlanThreshold?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigCountAggregate = {
    __typename?: 'PaymentPlanOrgConfigCountAggregate';
    _all: Scalars['Int']['output'];
    allowPaymentPlanCreateEditFromAccount: Scalars['Int']['output'];
    chargeDaysPostReturn: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    depositAmount: Scalars['Int']['output'];
    depositPercent: Scalars['Int']['output'];
    forceCardOnFile: Scalars['Int']['output'];
    installmentCadenceDays: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    migrationAcceptanceWindowDays: Scalars['Int']['output'];
    minimumFloorPercent: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payLaterAutoEnrollEnabled: Scalars['Int']['output'];
    payLaterEnabled: Scalars['Int']['output'];
    payLaterThreshold: Scalars['Int']['output'];
    paymentPlanThreshold: Scalars['Int']['output'];
    paymentPlansEnabled: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PaymentPlanOrgConfigCountOrderByAggregateInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<SortOrder>;
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositPercent?: InputMaybe<SortOrder>;
    forceCardOnFile?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAutoEnrollEnabled?: InputMaybe<SortOrder>;
    payLaterEnabled?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrder>;
    paymentPlanThreshold?: InputMaybe<SortOrder>;
    paymentPlansEnabled?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigCreateInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<
        Scalars['Boolean']['input']
    >;
    chargeDaysPostReturn?: InputMaybe<Scalars['Int']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositPercent?: InputMaybe<Scalars['Decimal']['input']>;
    forceCardOnFile?: InputMaybe<Scalars['Boolean']['input']>;
    installmentCadenceDays?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    migrationAcceptanceWindowDays?: InputMaybe<Scalars['Int']['input']>;
    minimumFloorPercent?: InputMaybe<Scalars['Decimal']['input']>;
    orgId: Scalars['Int']['input'];
    payLaterAutoEnrollEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    payLaterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    payLaterThreshold?: InputMaybe<Scalars['Decimal']['input']>;
    paymentPlanThreshold?: InputMaybe<Scalars['Decimal']['input']>;
    paymentPlansEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanOrgConfigCreateManyInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<
        Scalars['Boolean']['input']
    >;
    chargeDaysPostReturn?: InputMaybe<Scalars['Int']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
    depositPercent?: InputMaybe<Scalars['Decimal']['input']>;
    forceCardOnFile?: InputMaybe<Scalars['Boolean']['input']>;
    installmentCadenceDays?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    migrationAcceptanceWindowDays?: InputMaybe<Scalars['Int']['input']>;
    minimumFloorPercent?: InputMaybe<Scalars['Decimal']['input']>;
    orgId: Scalars['Int']['input'];
    payLaterAutoEnrollEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    payLaterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    payLaterThreshold?: InputMaybe<Scalars['Decimal']['input']>;
    paymentPlanThreshold?: InputMaybe<Scalars['Decimal']['input']>;
    paymentPlansEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PaymentPlanOrgConfigGroupBy = {
    __typename?: 'PaymentPlanOrgConfigGroupBy';
    _avg?: Maybe<PaymentPlanOrgConfigAvgAggregate>;
    _count?: Maybe<PaymentPlanOrgConfigCountAggregate>;
    _max?: Maybe<PaymentPlanOrgConfigMaxAggregate>;
    _min?: Maybe<PaymentPlanOrgConfigMinAggregate>;
    _sum?: Maybe<PaymentPlanOrgConfigSumAggregate>;
    allowPaymentPlanCreateEditFromAccount: Scalars['Boolean']['output'];
    chargeDaysPostReturn: Scalars['Int']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    forceCardOnFile: Scalars['Boolean']['output'];
    installmentCadenceDays: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    migrationAcceptanceWindowDays: Scalars['Int']['output'];
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    orgId: Scalars['Int']['output'];
    payLaterAutoEnrollEnabled: Scalars['Boolean']['output'];
    payLaterEnabled: Scalars['Boolean']['output'];
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlansEnabled: Scalars['Boolean']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaymentPlanOrgConfigMaxAggregate = {
    __typename?: 'PaymentPlanOrgConfigMaxAggregate';
    allowPaymentPlanCreateEditFromAccount?: Maybe<Scalars['Boolean']['output']>;
    chargeDaysPostReturn?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    forceCardOnFile?: Maybe<Scalars['Boolean']['output']>;
    installmentCadenceDays?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Int']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAutoEnrollEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlansEnabled?: Maybe<Scalars['Boolean']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanOrgConfigMaxOrderByAggregateInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<SortOrder>;
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositPercent?: InputMaybe<SortOrder>;
    forceCardOnFile?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAutoEnrollEnabled?: InputMaybe<SortOrder>;
    payLaterEnabled?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrder>;
    paymentPlanThreshold?: InputMaybe<SortOrder>;
    paymentPlansEnabled?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigMinAggregate = {
    __typename?: 'PaymentPlanOrgConfigMinAggregate';
    allowPaymentPlanCreateEditFromAccount?: Maybe<Scalars['Boolean']['output']>;
    chargeDaysPostReturn?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    forceCardOnFile?: Maybe<Scalars['Boolean']['output']>;
    installmentCadenceDays?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Int']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterAutoEnrollEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterEnabled?: Maybe<Scalars['Boolean']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlansEnabled?: Maybe<Scalars['Boolean']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PaymentPlanOrgConfigMinOrderByAggregateInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<SortOrder>;
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositPercent?: InputMaybe<SortOrder>;
    forceCardOnFile?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAutoEnrollEnabled?: InputMaybe<SortOrder>;
    payLaterEnabled?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrder>;
    paymentPlanThreshold?: InputMaybe<SortOrder>;
    paymentPlansEnabled?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigOrderByWithAggregationInput = {
    _avg?: InputMaybe<PaymentPlanOrgConfigAvgOrderByAggregateInput>;
    _count?: InputMaybe<PaymentPlanOrgConfigCountOrderByAggregateInput>;
    _max?: InputMaybe<PaymentPlanOrgConfigMaxOrderByAggregateInput>;
    _min?: InputMaybe<PaymentPlanOrgConfigMinOrderByAggregateInput>;
    _sum?: InputMaybe<PaymentPlanOrgConfigSumOrderByAggregateInput>;
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<SortOrder>;
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrderInput>;
    depositPercent?: InputMaybe<SortOrderInput>;
    forceCardOnFile?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAutoEnrollEnabled?: InputMaybe<SortOrder>;
    payLaterEnabled?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrderInput>;
    paymentPlanThreshold?: InputMaybe<SortOrderInput>;
    paymentPlansEnabled?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigOrderByWithRelationInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<SortOrder>;
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrderInput>;
    depositPercent?: InputMaybe<SortOrderInput>;
    forceCardOnFile?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    payLaterAutoEnrollEnabled?: InputMaybe<SortOrder>;
    payLaterEnabled?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrderInput>;
    paymentPlanThreshold?: InputMaybe<SortOrderInput>;
    paymentPlansEnabled?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentPlanOrgConfigScalarFieldEnum {
    AllowPaymentPlanCreateEditFromAccount = 'allowPaymentPlanCreateEditFromAccount',
    ChargeDaysPostReturn = 'chargeDaysPostReturn',
    CreatedAt = 'createdAt',
    DepositAmount = 'depositAmount',
    DepositPercent = 'depositPercent',
    ForceCardOnFile = 'forceCardOnFile',
    InstallmentCadenceDays = 'installmentCadenceDays',
    LastUpdatedBy = 'lastUpdatedBy',
    MigrationAcceptanceWindowDays = 'migrationAcceptanceWindowDays',
    MinimumFloorPercent = 'minimumFloorPercent',
    OrgId = 'orgId',
    PayLaterAutoEnrollEnabled = 'payLaterAutoEnrollEnabled',
    PayLaterEnabled = 'payLaterEnabled',
    PayLaterThreshold = 'payLaterThreshold',
    PaymentPlanThreshold = 'paymentPlanThreshold',
    PaymentPlansEnabled = 'paymentPlansEnabled',
    UpdatedAt = 'updatedAt',
}

export type PaymentPlanOrgConfigScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PaymentPlanOrgConfigScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PaymentPlanOrgConfigScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PaymentPlanOrgConfigScalarWhereWithAggregatesInput>>;
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<BoolWithAggregatesFilter>;
    chargeDaysPostReturn?: InputMaybe<IntWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    depositAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    depositPercent?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    forceCardOnFile?: InputMaybe<BoolWithAggregatesFilter>;
    installmentCadenceDays?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    migrationAcceptanceWindowDays?: InputMaybe<IntWithAggregatesFilter>;
    minimumFloorPercent?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    payLaterAutoEnrollEnabled?: InputMaybe<BoolWithAggregatesFilter>;
    payLaterEnabled?: InputMaybe<BoolWithAggregatesFilter>;
    payLaterThreshold?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    paymentPlanThreshold?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    paymentPlansEnabled?: InputMaybe<BoolWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PaymentPlanOrgConfigSumAggregate = {
    __typename?: 'PaymentPlanOrgConfigSumAggregate';
    chargeDaysPostReturn?: Maybe<Scalars['Int']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    depositPercent?: Maybe<Scalars['Decimal']['output']>;
    installmentCadenceDays?: Maybe<Scalars['Int']['output']>;
    migrationAcceptanceWindowDays?: Maybe<Scalars['Int']['output']>;
    minimumFloorPercent?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payLaterThreshold?: Maybe<Scalars['Decimal']['output']>;
    paymentPlanThreshold?: Maybe<Scalars['Decimal']['output']>;
};

export type PaymentPlanOrgConfigSumOrderByAggregateInput = {
    chargeDaysPostReturn?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    depositPercent?: InputMaybe<SortOrder>;
    installmentCadenceDays?: InputMaybe<SortOrder>;
    migrationAcceptanceWindowDays?: InputMaybe<SortOrder>;
    minimumFloorPercent?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payLaterThreshold?: InputMaybe<SortOrder>;
    paymentPlanThreshold?: InputMaybe<SortOrder>;
};

export type PaymentPlanOrgConfigUpdateInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
    chargeDaysPostReturn?: InputMaybe<IntFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    depositPercent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    forceCardOnFile?: InputMaybe<BoolFieldUpdateOperationsInput>;
    installmentCadenceDays?: InputMaybe<IntFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    migrationAcceptanceWindowDays?: InputMaybe<IntFieldUpdateOperationsInput>;
    minimumFloorPercent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payLaterAutoEnrollEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    payLaterEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    payLaterThreshold?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    paymentPlanThreshold?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    paymentPlansEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanOrgConfigUpdateManyMutationInput = {
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
    chargeDaysPostReturn?: InputMaybe<IntFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    depositPercent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    forceCardOnFile?: InputMaybe<BoolFieldUpdateOperationsInput>;
    installmentCadenceDays?: InputMaybe<IntFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    migrationAcceptanceWindowDays?: InputMaybe<IntFieldUpdateOperationsInput>;
    minimumFloorPercent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payLaterAutoEnrollEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    payLaterEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    payLaterThreshold?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    paymentPlanThreshold?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    paymentPlansEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanOrgConfigWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanOrgConfigWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanOrgConfigWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanOrgConfigWhereInput>>;
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<BoolFilter>;
    chargeDaysPostReturn?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalNullableFilter>;
    depositPercent?: InputMaybe<DecimalNullableFilter>;
    forceCardOnFile?: InputMaybe<BoolFilter>;
    installmentCadenceDays?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    migrationAcceptanceWindowDays?: InputMaybe<IntFilter>;
    minimumFloorPercent?: InputMaybe<DecimalNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    payLaterAutoEnrollEnabled?: InputMaybe<BoolFilter>;
    payLaterEnabled?: InputMaybe<BoolFilter>;
    payLaterThreshold?: InputMaybe<DecimalNullableFilter>;
    paymentPlanThreshold?: InputMaybe<DecimalNullableFilter>;
    paymentPlansEnabled?: InputMaybe<BoolFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanOrgConfigWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentPlanOrgConfigWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanOrgConfigWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanOrgConfigWhereInput>>;
    allowPaymentPlanCreateEditFromAccount?: InputMaybe<BoolFilter>;
    chargeDaysPostReturn?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalNullableFilter>;
    depositPercent?: InputMaybe<DecimalNullableFilter>;
    forceCardOnFile?: InputMaybe<BoolFilter>;
    installmentCadenceDays?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    migrationAcceptanceWindowDays?: InputMaybe<IntFilter>;
    minimumFloorPercent?: InputMaybe<DecimalNullableFilter>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    payLaterAutoEnrollEnabled?: InputMaybe<BoolFilter>;
    payLaterEnabled?: InputMaybe<BoolFilter>;
    payLaterThreshold?: InputMaybe<DecimalNullableFilter>;
    paymentPlanThreshold?: InputMaybe<DecimalNullableFilter>;
    paymentPlansEnabled?: InputMaybe<BoolFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentPlanRelationFilter = {
    is?: InputMaybe<PaymentPlanWhereInput>;
    isNot?: InputMaybe<PaymentPlanWhereInput>;
};

export enum PaymentPlanScalarFieldEnum {
    ActivatedAt = 'activatedAt',
    AthenaAcceptanceWindowExpiresAt = 'athenaAcceptanceWindowExpiresAt',
    ChargeDayOfMonth = 'chargeDayOfMonth',
    ChargeDayOfWeek = 'chargeDayOfWeek',
    ChargeFrequency = 'chargeFrequency',
    ChargeMode = 'chargeMode',
    CompletedAt = 'completedAt',
    ConfirmedRemaining = 'confirmedRemaining',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    DepositAmount = 'depositAmount',
    EndDate = 'endDate',
    Id = 'id',
    InitiatedBy = 'initiatedBy',
    InstallmentAmount = 'installmentAmount',
    LastUpdatedBy = 'lastUpdatedBy',
    MaxInstallments = 'maxInstallments',
    MigratedFromAthena = 'migratedFromAthena',
    NewPaymentMethodRequiredAt = 'newPaymentMethodRequiredAt',
    NextChargeDateAt = 'nextChargeDateAt',
    OrgId = 'orgId',
    PaymentAuthorizationId = 'paymentAuthorizationId',
    PaymentFailedAt = 'paymentFailedAt',
    ShortId = 'shortId',
    Status = 'status',
    Type = 'type',
    UpdatedAt = 'updatedAt',
    VoidReason = 'voidReason',
    VoidedAt = 'voidedAt',
}

export type PaymentPlanScalarWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanScalarWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanScalarWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanScalarWhereInput>>;
    activatedAt?: InputMaybe<DateTimeNullableFilter>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<DateTimeNullableFilter>;
    chargeDayOfMonth?: InputMaybe<IntNullableFilter>;
    chargeDayOfWeek?: InputMaybe<EnumDayOfWeekEnumNullableFilter>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyFilter>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeFilter>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    confirmedRemaining?: InputMaybe<DecimalFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalFilter>;
    endDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByFilter>;
    installmentAmount?: InputMaybe<DecimalFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    maxInstallments?: InputMaybe<IntNullableFilter>;
    migratedFromAthena?: InputMaybe<BoolFilter>;
    newPaymentMethodRequiredAt?: InputMaybe<DateTimeNullableFilter>;
    nextChargeDateAt?: InputMaybe<DateTimeNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableFilter>;
    paymentFailedAt?: InputMaybe<DateTimeNullableFilter>;
    shortId?: InputMaybe<IntFilter>;
    status?: InputMaybe<EnumPaymentPlanStatusFilter>;
    type?: InputMaybe<EnumPaymentPlanTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidReason?: InputMaybe<StringNullableFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PaymentPlanScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PaymentPlanScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PaymentPlanScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PaymentPlanScalarWhereWithAggregatesInput>>;
    activatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    chargeDayOfMonth?: InputMaybe<IntNullableWithAggregatesFilter>;
    chargeDayOfWeek?: InputMaybe<EnumDayOfWeekEnumNullableWithAggregatesFilter>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyWithAggregatesFilter>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeWithAggregatesFilter>;
    completedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    confirmedRemaining?: InputMaybe<DecimalWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    depositAmount?: InputMaybe<DecimalWithAggregatesFilter>;
    endDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByWithAggregatesFilter>;
    installmentAmount?: InputMaybe<DecimalWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    maxInstallments?: InputMaybe<IntNullableWithAggregatesFilter>;
    migratedFromAthena?: InputMaybe<BoolWithAggregatesFilter>;
    newPaymentMethodRequiredAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    nextChargeDateAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    paymentFailedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    shortId?: InputMaybe<IntWithAggregatesFilter>;
    status?: InputMaybe<EnumPaymentPlanStatusWithAggregatesFilter>;
    type?: InputMaybe<EnumPaymentPlanTypeWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    voidReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    voidedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export enum PaymentPlanStatus {
    Active = 'ACTIVE',
    Completed = 'COMPLETED',
    NewPaymentMethodRequired = 'NEW_PAYMENT_METHOD_REQUIRED',
    PendingAcceptance = 'PENDING_ACCEPTANCE',
    Voided = 'VOIDED',
}

export type PaymentPlanSumAggregate = {
    __typename?: 'PaymentPlanSumAggregate';
    chargeDayOfMonth?: Maybe<Scalars['Int']['output']>;
    confirmedRemaining?: Maybe<Scalars['Decimal']['output']>;
    depositAmount?: Maybe<Scalars['Decimal']['output']>;
    installmentAmount?: Maybe<Scalars['Decimal']['output']>;
    maxInstallments?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    shortId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentPlanSumOrderByAggregateInput = {
    chargeDayOfMonth?: InputMaybe<SortOrder>;
    confirmedRemaining?: InputMaybe<SortOrder>;
    depositAmount?: InputMaybe<SortOrder>;
    installmentAmount?: InputMaybe<SortOrder>;
    maxInstallments?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    shortId?: InputMaybe<SortOrder>;
};

export enum PaymentPlanType {
    PaymentPlan = 'PAYMENT_PLAN',
    PayLater = 'PAY_LATER',
}

export type PaymentPlanUpdateInput = {
    activatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentUpdateManyWithoutPlanNestedInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeUpdateManyWithoutPlanNestedInput>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentUpdateManyWithoutPlanNestedInput>;
    chargeDayOfMonth?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    chargeDayOfWeek?: InputMaybe<NullableEnumDayOfWeekEnumFieldUpdateOperationsInput>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyFieldUpdateOperationsInput>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeFieldUpdateOperationsInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    confirmedRemaining?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByFieldUpdateOperationsInput>;
    installmentAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maxInstallments?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    migratedFromAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    newPaymentMethodRequiredAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nextChargeDateAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationUpdateOneWithoutPaymentPlanNestedInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationUpdateOneWithoutPaymentPlansNestedInput>;
    paymentFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    shortId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPaymentPlanTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanUpdateManyMutationInput = {
    activatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    chargeDayOfMonth?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    chargeDayOfWeek?: InputMaybe<NullableEnumDayOfWeekEnumFieldUpdateOperationsInput>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyFieldUpdateOperationsInput>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeFieldUpdateOperationsInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    confirmedRemaining?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByFieldUpdateOperationsInput>;
    installmentAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maxInstallments?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    migratedFromAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    newPaymentMethodRequiredAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nextChargeDateAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    shortId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPaymentPlanTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanUpdateManyWithWhereWithoutPaymentAuthorizationInput = {
    data: PaymentPlanUpdateManyMutationInput;
    where: PaymentPlanScalarWhereInput;
};

export type PaymentPlanUpdateManyWithoutPaymentAuthorizationNestedInput = {
    connect?: InputMaybe<Array<PaymentPlanWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PaymentPlanCreateOrConnectWithoutPaymentAuthorizationInput>
    >;
    create?: InputMaybe<
        Array<PaymentPlanCreateWithoutPaymentAuthorizationInput>
    >;
    createMany?: InputMaybe<PaymentPlanCreateManyPaymentAuthorizationInputEnvelope>;
    delete?: InputMaybe<Array<PaymentPlanWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PaymentPlanScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PaymentPlanWhereUniqueInput>>;
    set?: InputMaybe<Array<PaymentPlanWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PaymentPlanUpdateWithWhereUniqueWithoutPaymentAuthorizationInput>
    >;
    updateMany?: InputMaybe<
        Array<PaymentPlanUpdateManyWithWhereWithoutPaymentAuthorizationInput>
    >;
    upsert?: InputMaybe<
        Array<PaymentPlanUpsertWithWhereUniqueWithoutPaymentAuthorizationInput>
    >;
};

export type PaymentPlanUpdateOneRequiredWithoutAdjustmentsNestedInput = {
    connect?: InputMaybe<PaymentPlanWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PaymentPlanCreateOrConnectWithoutAdjustmentsInput>;
    create?: InputMaybe<PaymentPlanCreateWithoutAdjustmentsInput>;
    update?: InputMaybe<PaymentPlanUpdateToOneWithWhereWithoutAdjustmentsInput>;
    upsert?: InputMaybe<PaymentPlanUpsertWithoutAdjustmentsInput>;
};

export type PaymentPlanUpdateOneRequiredWithoutAutoChargesNestedInput = {
    connect?: InputMaybe<PaymentPlanWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PaymentPlanCreateOrConnectWithoutAutoChargesInput>;
    create?: InputMaybe<PaymentPlanCreateWithoutAutoChargesInput>;
    update?: InputMaybe<PaymentPlanUpdateToOneWithWhereWithoutAutoChargesInput>;
    upsert?: InputMaybe<PaymentPlanUpsertWithoutAutoChargesInput>;
};

export type PaymentPlanUpdateOneRequiredWithoutBoughtTreatmentsNestedInput = {
    connect?: InputMaybe<PaymentPlanWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PaymentPlanCreateOrConnectWithoutBoughtTreatmentsInput>;
    create?: InputMaybe<PaymentPlanCreateWithoutBoughtTreatmentsInput>;
    update?: InputMaybe<PaymentPlanUpdateToOneWithWhereWithoutBoughtTreatmentsInput>;
    upsert?: InputMaybe<PaymentPlanUpsertWithoutBoughtTreatmentsInput>;
};

export type PaymentPlanUpdateOneWithoutPayLaterAuthorizationNestedInput = {
    connect?: InputMaybe<PaymentPlanWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PaymentPlanCreateOrConnectWithoutPayLaterAuthorizationInput>;
    create?: InputMaybe<PaymentPlanCreateWithoutPayLaterAuthorizationInput>;
    delete?: InputMaybe<PaymentPlanWhereInput>;
    disconnect?: InputMaybe<PaymentPlanWhereInput>;
    update?: InputMaybe<PaymentPlanUpdateToOneWithWhereWithoutPayLaterAuthorizationInput>;
    upsert?: InputMaybe<PaymentPlanUpsertWithoutPayLaterAuthorizationInput>;
};

export type PaymentPlanUpdateToOneWithWhereWithoutAdjustmentsInput = {
    data: PaymentPlanUpdateWithoutAdjustmentsInput;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentPlanUpdateToOneWithWhereWithoutAutoChargesInput = {
    data: PaymentPlanUpdateWithoutAutoChargesInput;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentPlanUpdateToOneWithWhereWithoutBoughtTreatmentsInput = {
    data: PaymentPlanUpdateWithoutBoughtTreatmentsInput;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentPlanUpdateToOneWithWhereWithoutPayLaterAuthorizationInput = {
    data: PaymentPlanUpdateWithoutPayLaterAuthorizationInput;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentPlanUpdateWithWhereUniqueWithoutPaymentAuthorizationInput = {
    data: PaymentPlanUpdateWithoutPaymentAuthorizationInput;
    where: PaymentPlanWhereUniqueInput;
};

export type PaymentPlanUpdateWithoutAdjustmentsInput = {
    activatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeUpdateManyWithoutPlanNestedInput>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentUpdateManyWithoutPlanNestedInput>;
    chargeDayOfMonth?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    chargeDayOfWeek?: InputMaybe<NullableEnumDayOfWeekEnumFieldUpdateOperationsInput>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyFieldUpdateOperationsInput>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeFieldUpdateOperationsInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    confirmedRemaining?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByFieldUpdateOperationsInput>;
    installmentAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maxInstallments?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    migratedFromAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    newPaymentMethodRequiredAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nextChargeDateAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationUpdateOneWithoutPaymentPlanNestedInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationUpdateOneWithoutPaymentPlansNestedInput>;
    paymentFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    shortId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPaymentPlanTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanUpdateWithoutAutoChargesInput = {
    activatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentUpdateManyWithoutPlanNestedInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentUpdateManyWithoutPlanNestedInput>;
    chargeDayOfMonth?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    chargeDayOfWeek?: InputMaybe<NullableEnumDayOfWeekEnumFieldUpdateOperationsInput>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyFieldUpdateOperationsInput>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeFieldUpdateOperationsInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    confirmedRemaining?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByFieldUpdateOperationsInput>;
    installmentAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maxInstallments?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    migratedFromAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    newPaymentMethodRequiredAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nextChargeDateAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationUpdateOneWithoutPaymentPlanNestedInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationUpdateOneWithoutPaymentPlansNestedInput>;
    paymentFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    shortId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPaymentPlanTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanUpdateWithoutBoughtTreatmentsInput = {
    activatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentUpdateManyWithoutPlanNestedInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeUpdateManyWithoutPlanNestedInput>;
    chargeDayOfMonth?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    chargeDayOfWeek?: InputMaybe<NullableEnumDayOfWeekEnumFieldUpdateOperationsInput>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyFieldUpdateOperationsInput>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeFieldUpdateOperationsInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    confirmedRemaining?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByFieldUpdateOperationsInput>;
    installmentAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maxInstallments?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    migratedFromAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    newPaymentMethodRequiredAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nextChargeDateAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationUpdateOneWithoutPaymentPlanNestedInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationUpdateOneWithoutPaymentPlansNestedInput>;
    paymentFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    shortId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPaymentPlanTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanUpdateWithoutPayLaterAuthorizationInput = {
    activatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentUpdateManyWithoutPlanNestedInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeUpdateManyWithoutPlanNestedInput>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentUpdateManyWithoutPlanNestedInput>;
    chargeDayOfMonth?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    chargeDayOfWeek?: InputMaybe<NullableEnumDayOfWeekEnumFieldUpdateOperationsInput>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyFieldUpdateOperationsInput>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeFieldUpdateOperationsInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    confirmedRemaining?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByFieldUpdateOperationsInput>;
    installmentAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maxInstallments?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    migratedFromAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    newPaymentMethodRequiredAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nextChargeDateAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationUpdateOneWithoutPaymentPlansNestedInput>;
    paymentFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    shortId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPaymentPlanTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanUpdateWithoutPaymentAuthorizationInput = {
    activatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentUpdateManyWithoutPlanNestedInput>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeUpdateManyWithoutPlanNestedInput>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentUpdateManyWithoutPlanNestedInput>;
    chargeDayOfMonth?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    chargeDayOfWeek?: InputMaybe<NullableEnumDayOfWeekEnumFieldUpdateOperationsInput>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyFieldUpdateOperationsInput>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeFieldUpdateOperationsInput>;
    completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    confirmedRemaining?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    depositAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByFieldUpdateOperationsInput>;
    installmentAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    maxInstallments?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    migratedFromAthena?: InputMaybe<BoolFieldUpdateOperationsInput>;
    newPaymentMethodRequiredAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nextChargeDateAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationUpdateOneWithoutPaymentPlanNestedInput>;
    paymentFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    shortId?: InputMaybe<IntFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumPaymentPlanStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPaymentPlanTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    voidReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    voidedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PaymentPlanUpsertWithWhereUniqueWithoutPaymentAuthorizationInput = {
    create: PaymentPlanCreateWithoutPaymentAuthorizationInput;
    update: PaymentPlanUpdateWithoutPaymentAuthorizationInput;
    where: PaymentPlanWhereUniqueInput;
};

export type PaymentPlanUpsertWithoutAdjustmentsInput = {
    create: PaymentPlanCreateWithoutAdjustmentsInput;
    update: PaymentPlanUpdateWithoutAdjustmentsInput;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentPlanUpsertWithoutAutoChargesInput = {
    create: PaymentPlanCreateWithoutAutoChargesInput;
    update: PaymentPlanUpdateWithoutAutoChargesInput;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentPlanUpsertWithoutBoughtTreatmentsInput = {
    create: PaymentPlanCreateWithoutBoughtTreatmentsInput;
    update: PaymentPlanUpdateWithoutBoughtTreatmentsInput;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentPlanUpsertWithoutPayLaterAuthorizationInput = {
    create: PaymentPlanCreateWithoutPayLaterAuthorizationInput;
    update: PaymentPlanUpdateWithoutPayLaterAuthorizationInput;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type PaymentPlanWhereInput = {
    AND?: InputMaybe<Array<PaymentPlanWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanWhereInput>>;
    activatedAt?: InputMaybe<DateTimeNullableFilter>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentListRelationFilter>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<DateTimeNullableFilter>;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeListRelationFilter>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentListRelationFilter>;
    chargeDayOfMonth?: InputMaybe<IntNullableFilter>;
    chargeDayOfWeek?: InputMaybe<EnumDayOfWeekEnumNullableFilter>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyFilter>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeFilter>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    confirmedRemaining?: InputMaybe<DecimalFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalFilter>;
    endDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<UuidFilter>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByFilter>;
    installmentAmount?: InputMaybe<DecimalFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    maxInstallments?: InputMaybe<IntNullableFilter>;
    migratedFromAthena?: InputMaybe<BoolFilter>;
    newPaymentMethodRequiredAt?: InputMaybe<DateTimeNullableFilter>;
    nextChargeDateAt?: InputMaybe<DateTimeNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationNullableRelationFilter>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationNullableRelationFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableFilter>;
    paymentFailedAt?: InputMaybe<DateTimeNullableFilter>;
    shortId?: InputMaybe<IntFilter>;
    status?: InputMaybe<EnumPaymentPlanStatusFilter>;
    type?: InputMaybe<EnumPaymentPlanTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidReason?: InputMaybe<StringNullableFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PaymentPlanWhereUniqueInput = {
    AND?: InputMaybe<Array<PaymentPlanWhereInput>>;
    NOT?: InputMaybe<Array<PaymentPlanWhereInput>>;
    OR?: InputMaybe<Array<PaymentPlanWhereInput>>;
    activatedAt?: InputMaybe<DateTimeNullableFilter>;
    adjustments?: InputMaybe<PaymentPlanAdjustmentListRelationFilter>;
    athenaAcceptanceWindowExpiresAt?: InputMaybe<DateTimeNullableFilter>;
    autoCharges?: InputMaybe<PaymentPlanAutoChargeListRelationFilter>;
    boughtTreatments?: InputMaybe<PaymentPlanBoughtTreatmentListRelationFilter>;
    chargeDayOfMonth?: InputMaybe<IntNullableFilter>;
    chargeDayOfWeek?: InputMaybe<EnumDayOfWeekEnumNullableFilter>;
    chargeFrequency?: InputMaybe<EnumPaymentPlanFrequencyFilter>;
    chargeMode?: InputMaybe<EnumPaymentPlanChargeModeFilter>;
    completedAt?: InputMaybe<DateTimeNullableFilter>;
    confirmedRemaining?: InputMaybe<DecimalFilter>;
    consumerId?: InputMaybe<UuidFilter>;
    consumerId_shortId?: InputMaybe<PaymentPlanConsumerIdShortIdCompoundUniqueInput>;
    createdAt?: InputMaybe<DateTimeFilter>;
    depositAmount?: InputMaybe<DecimalFilter>;
    endDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    initiatedBy?: InputMaybe<EnumPaymentPlanInitiatedByFilter>;
    installmentAmount?: InputMaybe<DecimalFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    maxInstallments?: InputMaybe<IntNullableFilter>;
    migratedFromAthena?: InputMaybe<BoolFilter>;
    newPaymentMethodRequiredAt?: InputMaybe<DateTimeNullableFilter>;
    nextChargeDateAt?: InputMaybe<DateTimeNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    payLaterAuthorization?: InputMaybe<PayLaterAuthorizationNullableRelationFilter>;
    paymentAuthorization?: InputMaybe<PaymentAuthorizationNullableRelationFilter>;
    paymentAuthorizationId?: InputMaybe<UuidNullableFilter>;
    paymentFailedAt?: InputMaybe<DateTimeNullableFilter>;
    shortId?: InputMaybe<IntFilter>;
    status?: InputMaybe<EnumPaymentPlanStatusFilter>;
    type?: InputMaybe<EnumPaymentPlanTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    voidReason?: InputMaybe<StringNullableFilter>;
    voidedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum PaymentType {
    Invoice = 'INVOICE',
    Netted = 'NETTED',
    Other = 'OTHER',
}

export enum PaymentTypeEnum {
    Insurance = 'INSURANCE',
    Insurancemakeitfree = 'INSURANCEMAKEITFREE',
    Insuranceoverride = 'INSURANCEOVERRIDE',
    InsuranceAdminCreated = 'INSURANCE_ADMIN_CREATED',
    Postclaim = 'POSTCLAIM',
    Selfpay = 'SELFPAY',
    Selfpaydiscounted = 'SELFPAYDISCOUNTED',
    Selfpayoverride = 'SELFPAYOVERRIDE',
}

export type Payout = {
    __typename?: 'Payout';
    _count?: Maybe<PayoutCount>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    chargeIds: Array<Scalars['String']['output']>;
    charges: Array<Charge>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdByEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    expectedPayoutDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    isArtCreated?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedByEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    parentPayoutId?: Maybe<Scalars['String']['output']>;
    payoutReferencePaymentType?: Maybe<PayoutReferencePaymentType>;
    payoutType: Scalars['String']['output'];
    price: Scalars['Decimal']['output'];
    reattributionState?: Maybe<ReattributionState>;
    status: TransactionStatus;
    stripeDestinationId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePayoutFee?: Maybe<Scalars['Decimal']['output']>;
    stripeReversalId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayoutChargesArgs = {
    cursor?: InputMaybe<ChargeWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeWhereInput>;
};

export type PayoutAuditLog = {
    __typename?: 'PayoutAuditLog';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    chargeIds: Array<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    expectedPayoutDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    parentPayoutId?: Maybe<Scalars['String']['output']>;
    payoutId: Scalars['String']['output'];
    payoutType: Scalars['String']['output'];
    price: Scalars['Decimal']['output'];
    reattributionState?: Maybe<ReattributionState>;
    status: TransactionStatus;
    stripeDestinationId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripeReversalId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PayoutAuditLogAvgAggregate = {
    __typename?: 'PayoutAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    price?: Maybe<Scalars['Decimal']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type PayoutAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
};

export type PayoutAuditLogCountAggregate = {
    __typename?: 'PayoutAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    chargeIds: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    destinationPayment: Scalars['Int']['output'];
    ehrPostLedgerId: Scalars['Int']['output'];
    expectedPayoutDate: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    ourFee: Scalars['Int']['output'];
    parentPayoutId: Scalars['Int']['output'];
    payoutId: Scalars['Int']['output'];
    payoutType: Scalars['Int']['output'];
    price: Scalars['Int']['output'];
    reattributionState: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    stripeDestinationId: Scalars['Int']['output'];
    stripeFee: Scalars['Int']['output'];
    stripeReversalId: Scalars['Int']['output'];
    stripeTransferId: Scalars['Int']['output'];
    transferredAmount: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PayoutAuditLogCountOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    chargeIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    expectedPayoutDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrder>;
    parentPayoutId?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    payoutType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeDestinationId?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripeReversalId?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayoutAuditLogCreateInput = {
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    chargeIds?: InputMaybe<PayoutAuditLogCreatechargeIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    destinationPayment?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    expectedPayoutDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    ourFee?: InputMaybe<Scalars['Decimal']['input']>;
    parentPayoutId?: InputMaybe<Scalars['String']['input']>;
    payoutId: Scalars['String']['input'];
    payoutType: Scalars['String']['input'];
    price: Scalars['Decimal']['input'];
    reattributionState?: InputMaybe<ReattributionState>;
    status?: InputMaybe<TransactionStatus>;
    stripeDestinationId?: InputMaybe<Scalars['String']['input']>;
    stripeFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripeReversalId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    transferredAmount?: InputMaybe<Scalars['Decimal']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayoutAuditLogCreateManyInput = {
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    chargeIds?: InputMaybe<PayoutAuditLogCreatechargeIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    destinationPayment?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    expectedPayoutDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    ourFee?: InputMaybe<Scalars['Decimal']['input']>;
    parentPayoutId?: InputMaybe<Scalars['String']['input']>;
    payoutId: Scalars['String']['input'];
    payoutType: Scalars['String']['input'];
    price: Scalars['Decimal']['input'];
    reattributionState?: InputMaybe<ReattributionState>;
    status?: InputMaybe<TransactionStatus>;
    stripeDestinationId?: InputMaybe<Scalars['String']['input']>;
    stripeFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripeReversalId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    transferredAmount?: InputMaybe<Scalars['Decimal']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayoutAuditLogCreatechargeIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type PayoutAuditLogGroupBy = {
    __typename?: 'PayoutAuditLogGroupBy';
    _avg?: Maybe<PayoutAuditLogAvgAggregate>;
    _count?: Maybe<PayoutAuditLogCountAggregate>;
    _max?: Maybe<PayoutAuditLogMaxAggregate>;
    _min?: Maybe<PayoutAuditLogMinAggregate>;
    _sum?: Maybe<PayoutAuditLogSumAggregate>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    chargeIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    expectedPayoutDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    parentPayoutId?: Maybe<Scalars['String']['output']>;
    payoutId: Scalars['String']['output'];
    payoutType: Scalars['String']['output'];
    price: Scalars['Decimal']['output'];
    reattributionState?: Maybe<ReattributionState>;
    status: TransactionStatus;
    stripeDestinationId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripeReversalId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PayoutAuditLogMaxAggregate = {
    __typename?: 'PayoutAuditLogMaxAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    expectedPayoutDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    parentPayoutId?: Maybe<Scalars['String']['output']>;
    payoutId?: Maybe<Scalars['String']['output']>;
    payoutType?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Decimal']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    status?: Maybe<TransactionStatus>;
    stripeDestinationId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripeReversalId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayoutAuditLogMaxOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    expectedPayoutDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrder>;
    parentPayoutId?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    payoutType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeDestinationId?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripeReversalId?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayoutAuditLogMinAggregate = {
    __typename?: 'PayoutAuditLogMinAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    expectedPayoutDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    parentPayoutId?: Maybe<Scalars['String']['output']>;
    payoutId?: Maybe<Scalars['String']['output']>;
    payoutType?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Decimal']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    status?: Maybe<TransactionStatus>;
    stripeDestinationId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripeReversalId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayoutAuditLogMinOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    expectedPayoutDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrder>;
    parentPayoutId?: InputMaybe<SortOrder>;
    payoutId?: InputMaybe<SortOrder>;
    payoutType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeDestinationId?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripeReversalId?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayoutAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<PayoutAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<PayoutAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<PayoutAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<PayoutAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<PayoutAuditLogSumOrderByAggregateInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    chargeIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrderInput>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    expectedPayoutDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrderInput>;
    parentPayoutId?: InputMaybe<SortOrderInput>;
    payoutId?: InputMaybe<SortOrder>;
    payoutType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    stripeDestinationId?: InputMaybe<SortOrderInput>;
    stripeFee?: InputMaybe<SortOrderInput>;
    stripeReversalId?: InputMaybe<SortOrderInput>;
    stripeTransferId?: InputMaybe<SortOrderInput>;
    transferredAmount?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayoutAuditLogOrderByWithRelationInput = {
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    chargeIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrderInput>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    expectedPayoutDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrderInput>;
    parentPayoutId?: InputMaybe<SortOrderInput>;
    payoutId?: InputMaybe<SortOrder>;
    payoutType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    stripeDestinationId?: InputMaybe<SortOrderInput>;
    stripeFee?: InputMaybe<SortOrderInput>;
    stripeReversalId?: InputMaybe<SortOrderInput>;
    stripeTransferId?: InputMaybe<SortOrderInput>;
    transferredAmount?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PayoutAuditLogScalarFieldEnum {
    BoughtTreatmentId = 'boughtTreatmentId',
    ChargeIds = 'chargeIds',
    CreatedAt = 'createdAt',
    Date = 'date',
    DestinationPayment = 'destinationPayment',
    EhrPostLedgerId = 'ehrPostLedgerId',
    ExpectedPayoutDate = 'expectedPayoutDate',
    Id = 'id',
    Notes = 'notes',
    Operation = 'operation',
    OrgId = 'orgId',
    OurFee = 'ourFee',
    ParentPayoutId = 'parentPayoutId',
    PayoutId = 'payoutId',
    PayoutType = 'payoutType',
    Price = 'price',
    ReattributionState = 'reattributionState',
    Status = 'status',
    StripeDestinationId = 'stripeDestinationId',
    StripeFee = 'stripeFee',
    StripeReversalId = 'stripeReversalId',
    StripeTransferId = 'stripeTransferId',
    TransferredAmount = 'transferredAmount',
    UpdatedAt = 'updatedAt',
}

export type PayoutAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PayoutAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PayoutAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PayoutAuditLogScalarWhereWithAggregatesInput>>;
    boughtTreatmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    destinationPayment?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    expectedPayoutDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    ourFee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    parentPayoutId?: InputMaybe<StringNullableWithAggregatesFilter>;
    payoutId?: InputMaybe<StringWithAggregatesFilter>;
    payoutType?: InputMaybe<StringWithAggregatesFilter>;
    price?: InputMaybe<DecimalWithAggregatesFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumTransactionStatusWithAggregatesFilter>;
    stripeDestinationId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeFee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    stripeReversalId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeTransferId?: InputMaybe<StringNullableWithAggregatesFilter>;
    transferredAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PayoutAuditLogSumAggregate = {
    __typename?: 'PayoutAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    price?: Maybe<Scalars['Decimal']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type PayoutAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
};

export type PayoutAuditLogUpdateInput = {
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    chargeIds?: InputMaybe<PayoutAuditLogUpdatechargeIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationPayment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    expectedPayoutDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    ourFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    parentPayoutId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payoutId?: InputMaybe<StringFieldUpdateOperationsInput>;
    payoutType?: InputMaybe<StringFieldUpdateOperationsInput>;
    price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
    stripeDestinationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripeReversalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transferredAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayoutAuditLogUpdateManyMutationInput = {
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    chargeIds?: InputMaybe<PayoutAuditLogUpdatechargeIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationPayment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    expectedPayoutDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    ourFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    parentPayoutId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payoutId?: InputMaybe<StringFieldUpdateOperationsInput>;
    payoutType?: InputMaybe<StringFieldUpdateOperationsInput>;
    price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
    stripeDestinationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripeReversalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transferredAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayoutAuditLogUpdatechargeIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PayoutAuditLogWhereInput = {
    AND?: InputMaybe<Array<PayoutAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PayoutAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PayoutAuditLogWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringNullableFilter>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    date?: InputMaybe<DateTimeFilter>;
    destinationPayment?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    expectedPayoutDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    ourFee?: InputMaybe<DecimalNullableFilter>;
    parentPayoutId?: InputMaybe<StringNullableFilter>;
    payoutId?: InputMaybe<StringFilter>;
    payoutType?: InputMaybe<StringFilter>;
    price?: InputMaybe<DecimalFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    status?: InputMaybe<EnumTransactionStatusFilter>;
    stripeDestinationId?: InputMaybe<StringNullableFilter>;
    stripeFee?: InputMaybe<DecimalNullableFilter>;
    stripeReversalId?: InputMaybe<StringNullableFilter>;
    stripeTransferId?: InputMaybe<StringNullableFilter>;
    transferredAmount?: InputMaybe<DecimalNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PayoutAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<PayoutAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<PayoutAuditLogWhereInput>>;
    OR?: InputMaybe<Array<PayoutAuditLogWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringNullableFilter>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    date?: InputMaybe<DateTimeFilter>;
    destinationPayment?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    expectedPayoutDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    notes?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    ourFee?: InputMaybe<DecimalNullableFilter>;
    parentPayoutId?: InputMaybe<StringNullableFilter>;
    payoutId?: InputMaybe<StringFilter>;
    payoutType?: InputMaybe<StringFilter>;
    price?: InputMaybe<DecimalFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    status?: InputMaybe<EnumTransactionStatusFilter>;
    stripeDestinationId?: InputMaybe<StringNullableFilter>;
    stripeFee?: InputMaybe<DecimalNullableFilter>;
    stripeReversalId?: InputMaybe<StringNullableFilter>;
    stripeTransferId?: InputMaybe<StringNullableFilter>;
    transferredAmount?: InputMaybe<DecimalNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PayoutAvgAggregate = {
    __typename?: 'PayoutAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    price?: Maybe<Scalars['Decimal']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePayoutFee?: Maybe<Scalars['Decimal']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type PayoutAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripePayoutFee?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
};

export type PayoutCount = {
    __typename?: 'PayoutCount';
    charges: Scalars['Int']['output'];
};

export type PayoutCountChargesArgs = {
    where?: InputMaybe<ChargeWhereInput>;
};

export type PayoutCountAggregate = {
    __typename?: 'PayoutCountAggregate';
    _all: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    chargeIds: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    createdByEhrPostLedgerId: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    destinationPayment: Scalars['Int']['output'];
    ehrPostLedgerId: Scalars['Int']['output'];
    encounterId: Scalars['Int']['output'];
    expectedPayoutDate: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isArtCreated: Scalars['Int']['output'];
    lastUpdatedByEhrPostLedgerId: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    ourFee: Scalars['Int']['output'];
    parentPayoutId: Scalars['Int']['output'];
    payoutReferencePaymentType: Scalars['Int']['output'];
    payoutType: Scalars['Int']['output'];
    price: Scalars['Int']['output'];
    reattributionState: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    stripeDestinationId: Scalars['Int']['output'];
    stripeFee: Scalars['Int']['output'];
    stripePayoutFee: Scalars['Int']['output'];
    stripeReversalId: Scalars['Int']['output'];
    stripeTransferId: Scalars['Int']['output'];
    transactionId: Scalars['Int']['output'];
    transferredAmount: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PayoutCountOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    chargeIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    createdByEhrPostLedgerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    expectedPayoutDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArtCreated?: InputMaybe<SortOrder>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrder>;
    parentPayoutId?: InputMaybe<SortOrder>;
    payoutReferencePaymentType?: InputMaybe<SortOrder>;
    payoutType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeDestinationId?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripePayoutFee?: InputMaybe<SortOrder>;
    stripeReversalId?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayoutCreateInput = {
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    chargeIds?: InputMaybe<PayoutCreatechargeIdsInput>;
    charges?: InputMaybe<ChargeCreateNestedManyWithoutPayoutsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdByEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    destinationPayment?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    encounterId?: InputMaybe<Scalars['String']['input']>;
    expectedPayoutDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['String']['input'];
    isArtCreated?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    ourFee?: InputMaybe<Scalars['Decimal']['input']>;
    parentPayoutId?: InputMaybe<Scalars['String']['input']>;
    payoutReferencePaymentType?: InputMaybe<PayoutReferencePaymentType>;
    payoutType: Scalars['String']['input'];
    price: Scalars['Decimal']['input'];
    reattributionState?: InputMaybe<ReattributionState>;
    status?: InputMaybe<TransactionStatus>;
    stripeDestinationId?: InputMaybe<Scalars['String']['input']>;
    stripeFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripePayoutFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripeReversalId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    transferredAmount?: InputMaybe<Scalars['Decimal']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayoutCreateManyInput = {
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    chargeIds?: InputMaybe<PayoutCreatechargeIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdByEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    destinationPayment?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    encounterId?: InputMaybe<Scalars['String']['input']>;
    expectedPayoutDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['String']['input'];
    isArtCreated?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    ourFee?: InputMaybe<Scalars['Decimal']['input']>;
    parentPayoutId?: InputMaybe<Scalars['String']['input']>;
    payoutReferencePaymentType?: InputMaybe<PayoutReferencePaymentType>;
    payoutType: Scalars['String']['input'];
    price: Scalars['Decimal']['input'];
    reattributionState?: InputMaybe<ReattributionState>;
    status?: InputMaybe<TransactionStatus>;
    stripeDestinationId?: InputMaybe<Scalars['String']['input']>;
    stripeFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripePayoutFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripeReversalId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    transferredAmount?: InputMaybe<Scalars['Decimal']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayoutCreateNestedManyWithoutChargesInput = {
    connect?: InputMaybe<Array<PayoutWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PayoutCreateOrConnectWithoutChargesInput>
    >;
    create?: InputMaybe<Array<PayoutCreateWithoutChargesInput>>;
};

export type PayoutCreateOrConnectWithoutChargesInput = {
    create: PayoutCreateWithoutChargesInput;
    where: PayoutWhereUniqueInput;
};

export type PayoutCreateWithoutChargesInput = {
    boughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    chargeIds?: InputMaybe<PayoutCreatechargeIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdByEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    destinationPayment?: InputMaybe<Scalars['String']['input']>;
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    encounterId?: InputMaybe<Scalars['String']['input']>;
    expectedPayoutDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id: Scalars['String']['input'];
    isArtCreated?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    ourFee?: InputMaybe<Scalars['Decimal']['input']>;
    parentPayoutId?: InputMaybe<Scalars['String']['input']>;
    payoutReferencePaymentType?: InputMaybe<PayoutReferencePaymentType>;
    payoutType: Scalars['String']['input'];
    price: Scalars['Decimal']['input'];
    reattributionState?: InputMaybe<ReattributionState>;
    status?: InputMaybe<TransactionStatus>;
    stripeDestinationId?: InputMaybe<Scalars['String']['input']>;
    stripeFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripePayoutFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripeReversalId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    transferredAmount?: InputMaybe<Scalars['Decimal']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PayoutCreatechargeIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type PayoutGroupBy = {
    __typename?: 'PayoutGroupBy';
    _avg?: Maybe<PayoutAvgAggregate>;
    _count?: Maybe<PayoutCountAggregate>;
    _max?: Maybe<PayoutMaxAggregate>;
    _min?: Maybe<PayoutMinAggregate>;
    _sum?: Maybe<PayoutSumAggregate>;
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    chargeIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdByEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    expectedPayoutDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['String']['output'];
    isArtCreated?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedByEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId: Scalars['Int']['output'];
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    parentPayoutId?: Maybe<Scalars['String']['output']>;
    payoutReferencePaymentType?: Maybe<PayoutReferencePaymentType>;
    payoutType: Scalars['String']['output'];
    price: Scalars['Decimal']['output'];
    reattributionState?: Maybe<ReattributionState>;
    status: TransactionStatus;
    stripeDestinationId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePayoutFee?: Maybe<Scalars['Decimal']['output']>;
    stripeReversalId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayoutListRelationFilter = {
    every?: InputMaybe<PayoutWhereInput>;
    none?: InputMaybe<PayoutWhereInput>;
    some?: InputMaybe<PayoutWhereInput>;
};

export type PayoutMaxAggregate = {
    __typename?: 'PayoutMaxAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdByEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    expectedPayoutDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isArtCreated?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedByEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    parentPayoutId?: Maybe<Scalars['String']['output']>;
    payoutReferencePaymentType?: Maybe<PayoutReferencePaymentType>;
    payoutType?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Decimal']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    status?: Maybe<TransactionStatus>;
    stripeDestinationId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePayoutFee?: Maybe<Scalars['Decimal']['output']>;
    stripeReversalId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayoutMaxOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    createdByEhrPostLedgerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    expectedPayoutDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArtCreated?: InputMaybe<SortOrder>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrder>;
    parentPayoutId?: InputMaybe<SortOrder>;
    payoutReferencePaymentType?: InputMaybe<SortOrder>;
    payoutType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeDestinationId?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripePayoutFee?: InputMaybe<SortOrder>;
    stripeReversalId?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayoutMinAggregate = {
    __typename?: 'PayoutMinAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdByEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationPayment?: Maybe<Scalars['String']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    expectedPayoutDate?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isArtCreated?: Maybe<Scalars['Boolean']['output']>;
    lastUpdatedByEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    parentPayoutId?: Maybe<Scalars['String']['output']>;
    payoutReferencePaymentType?: Maybe<PayoutReferencePaymentType>;
    payoutType?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Decimal']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    status?: Maybe<TransactionStatus>;
    stripeDestinationId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePayoutFee?: Maybe<Scalars['Decimal']['output']>;
    stripeReversalId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PayoutMinOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    createdByEhrPostLedgerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    expectedPayoutDate?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArtCreated?: InputMaybe<SortOrder>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrder>;
    parentPayoutId?: InputMaybe<SortOrder>;
    payoutReferencePaymentType?: InputMaybe<SortOrder>;
    payoutType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeDestinationId?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripePayoutFee?: InputMaybe<SortOrder>;
    stripeReversalId?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PayoutOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PayoutOrderByWithAggregationInput = {
    _avg?: InputMaybe<PayoutAvgOrderByAggregateInput>;
    _count?: InputMaybe<PayoutCountOrderByAggregateInput>;
    _max?: InputMaybe<PayoutMaxOrderByAggregateInput>;
    _min?: InputMaybe<PayoutMinOrderByAggregateInput>;
    _sum?: InputMaybe<PayoutSumOrderByAggregateInput>;
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    chargeIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrderInput>;
    createdByEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrderInput>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    encounterId?: InputMaybe<SortOrderInput>;
    expectedPayoutDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isArtCreated?: InputMaybe<SortOrderInput>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrderInput>;
    parentPayoutId?: InputMaybe<SortOrderInput>;
    payoutReferencePaymentType?: InputMaybe<SortOrderInput>;
    payoutType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    stripeDestinationId?: InputMaybe<SortOrderInput>;
    stripeFee?: InputMaybe<SortOrderInput>;
    stripePayoutFee?: InputMaybe<SortOrderInput>;
    stripeReversalId?: InputMaybe<SortOrderInput>;
    stripeTransferId?: InputMaybe<SortOrderInput>;
    transactionId?: InputMaybe<SortOrderInput>;
    transferredAmount?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export type PayoutOrderByWithRelationInput = {
    boughtTreatmentId?: InputMaybe<SortOrderInput>;
    chargeIds?: InputMaybe<SortOrder>;
    charges?: InputMaybe<ChargeOrderByRelationAggregateInput>;
    createdAt?: InputMaybe<SortOrderInput>;
    createdByEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    destinationPayment?: InputMaybe<SortOrderInput>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    encounterId?: InputMaybe<SortOrderInput>;
    expectedPayoutDate?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    isArtCreated?: InputMaybe<SortOrderInput>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrderInput>;
    parentPayoutId?: InputMaybe<SortOrderInput>;
    payoutReferencePaymentType?: InputMaybe<SortOrderInput>;
    payoutType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    stripeDestinationId?: InputMaybe<SortOrderInput>;
    stripeFee?: InputMaybe<SortOrderInput>;
    stripePayoutFee?: InputMaybe<SortOrderInput>;
    stripeReversalId?: InputMaybe<SortOrderInput>;
    stripeTransferId?: InputMaybe<SortOrderInput>;
    transactionId?: InputMaybe<SortOrderInput>;
    transferredAmount?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export enum PayoutReferencePaymentType {
    AthenaCard = 'ATHENA_CARD',
    Card = 'CARD',
    Cash = 'CASH',
    Cashorcheck = 'CASHORCHECK',
    Check = 'CHECK',
}

export enum PayoutScalarFieldEnum {
    BoughtTreatmentId = 'boughtTreatmentId',
    ChargeIds = 'chargeIds',
    CreatedAt = 'createdAt',
    CreatedByEhrPostLedgerId = 'createdByEhrPostLedgerId',
    Date = 'date',
    DestinationPayment = 'destinationPayment',
    EhrPostLedgerId = 'ehrPostLedgerId',
    EncounterId = 'encounterId',
    ExpectedPayoutDate = 'expectedPayoutDate',
    Id = 'id',
    IsArtCreated = 'isArtCreated',
    LastUpdatedByEhrPostLedgerId = 'lastUpdatedByEhrPostLedgerId',
    Notes = 'notes',
    OrgId = 'orgId',
    OurFee = 'ourFee',
    ParentPayoutId = 'parentPayoutId',
    PayoutReferencePaymentType = 'payoutReferencePaymentType',
    PayoutType = 'payoutType',
    Price = 'price',
    ReattributionState = 'reattributionState',
    Status = 'status',
    StripeDestinationId = 'stripeDestinationId',
    StripeFee = 'stripeFee',
    StripePayoutFee = 'stripePayoutFee',
    StripeReversalId = 'stripeReversalId',
    StripeTransferId = 'stripeTransferId',
    TransactionId = 'transactionId',
    TransferredAmount = 'transferredAmount',
    UpdatedAt = 'updatedAt',
}

export type PayoutScalarWhereInput = {
    AND?: InputMaybe<Array<PayoutScalarWhereInput>>;
    NOT?: InputMaybe<Array<PayoutScalarWhereInput>>;
    OR?: InputMaybe<Array<PayoutScalarWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringNullableFilter>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    createdByEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    destinationPayment?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    expectedPayoutDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<StringFilter>;
    isArtCreated?: InputMaybe<BoolNullableFilter>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    ourFee?: InputMaybe<DecimalNullableFilter>;
    parentPayoutId?: InputMaybe<StringNullableFilter>;
    payoutReferencePaymentType?: InputMaybe<EnumPayoutReferencePaymentTypeNullableFilter>;
    payoutType?: InputMaybe<StringFilter>;
    price?: InputMaybe<DecimalFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    status?: InputMaybe<EnumTransactionStatusFilter>;
    stripeDestinationId?: InputMaybe<StringNullableFilter>;
    stripeFee?: InputMaybe<DecimalNullableFilter>;
    stripePayoutFee?: InputMaybe<DecimalNullableFilter>;
    stripeReversalId?: InputMaybe<StringNullableFilter>;
    stripeTransferId?: InputMaybe<StringNullableFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    transferredAmount?: InputMaybe<DecimalNullableFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PayoutScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PayoutScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PayoutScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PayoutScalarWhereWithAggregatesInput>>;
    boughtTreatmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    createdByEhrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    destinationPayment?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    encounterId?: InputMaybe<StringNullableWithAggregatesFilter>;
    expectedPayoutDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    isArtCreated?: InputMaybe<BoolNullableWithAggregatesFilter>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    ourFee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    parentPayoutId?: InputMaybe<StringNullableWithAggregatesFilter>;
    payoutReferencePaymentType?: InputMaybe<EnumPayoutReferencePaymentTypeNullableWithAggregatesFilter>;
    payoutType?: InputMaybe<StringWithAggregatesFilter>;
    price?: InputMaybe<DecimalWithAggregatesFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumTransactionStatusWithAggregatesFilter>;
    stripeDestinationId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeFee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    stripePayoutFee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    stripeReversalId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeTransferId?: InputMaybe<StringNullableWithAggregatesFilter>;
    transactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    transferredAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type PayoutSumAggregate = {
    __typename?: 'PayoutSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    ourFee?: Maybe<Scalars['Decimal']['output']>;
    price?: Maybe<Scalars['Decimal']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePayoutFee?: Maybe<Scalars['Decimal']['output']>;
    transferredAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type PayoutSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    ourFee?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripePayoutFee?: InputMaybe<SortOrder>;
    transferredAmount?: InputMaybe<SortOrder>;
};

export type PayoutUpdateInput = {
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    chargeIds?: InputMaybe<PayoutUpdatechargeIdsInput>;
    charges?: InputMaybe<ChargeUpdateManyWithoutPayoutsNestedInput>;
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdByEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationPayment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    expectedPayoutDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isArtCreated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    ourFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    parentPayoutId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payoutReferencePaymentType?: InputMaybe<NullableEnumPayoutReferencePaymentTypeFieldUpdateOperationsInput>;
    payoutType?: InputMaybe<StringFieldUpdateOperationsInput>;
    price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
    stripeDestinationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripePayoutFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripeReversalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transferredAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayoutUpdateManyMutationInput = {
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    chargeIds?: InputMaybe<PayoutUpdatechargeIdsInput>;
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdByEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationPayment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    expectedPayoutDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isArtCreated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    ourFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    parentPayoutId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payoutReferencePaymentType?: InputMaybe<NullableEnumPayoutReferencePaymentTypeFieldUpdateOperationsInput>;
    payoutType?: InputMaybe<StringFieldUpdateOperationsInput>;
    price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
    stripeDestinationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripePayoutFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripeReversalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transferredAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayoutUpdateManyWithWhereWithoutChargesInput = {
    data: PayoutUpdateManyMutationInput;
    where: PayoutScalarWhereInput;
};

export type PayoutUpdateManyWithoutChargesNestedInput = {
    connect?: InputMaybe<Array<PayoutWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PayoutCreateOrConnectWithoutChargesInput>
    >;
    create?: InputMaybe<Array<PayoutCreateWithoutChargesInput>>;
    delete?: InputMaybe<Array<PayoutWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PayoutScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PayoutWhereUniqueInput>>;
    set?: InputMaybe<Array<PayoutWhereUniqueInput>>;
    update?: InputMaybe<Array<PayoutUpdateWithWhereUniqueWithoutChargesInput>>;
    updateMany?: InputMaybe<
        Array<PayoutUpdateManyWithWhereWithoutChargesInput>
    >;
    upsert?: InputMaybe<Array<PayoutUpsertWithWhereUniqueWithoutChargesInput>>;
};

export type PayoutUpdateWithWhereUniqueWithoutChargesInput = {
    data: PayoutUpdateWithoutChargesInput;
    where: PayoutWhereUniqueInput;
};

export type PayoutUpdateWithoutChargesInput = {
    boughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    chargeIds?: InputMaybe<PayoutUpdatechargeIdsInput>;
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdByEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    destinationPayment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    expectedPayoutDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isArtCreated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    ourFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    parentPayoutId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payoutReferencePaymentType?: InputMaybe<NullableEnumPayoutReferencePaymentTypeFieldUpdateOperationsInput>;
    payoutType?: InputMaybe<StringFieldUpdateOperationsInput>;
    price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
    stripeDestinationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripePayoutFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripeReversalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transferredAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayoutUpdatechargeIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PayoutUpsertWithWhereUniqueWithoutChargesInput = {
    create: PayoutCreateWithoutChargesInput;
    update: PayoutUpdateWithoutChargesInput;
    where: PayoutWhereUniqueInput;
};

export type PayoutWhereInput = {
    AND?: InputMaybe<Array<PayoutWhereInput>>;
    NOT?: InputMaybe<Array<PayoutWhereInput>>;
    OR?: InputMaybe<Array<PayoutWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringNullableFilter>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    charges?: InputMaybe<ChargeListRelationFilter>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    createdByEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    destinationPayment?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    expectedPayoutDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<StringFilter>;
    isArtCreated?: InputMaybe<BoolNullableFilter>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    ourFee?: InputMaybe<DecimalNullableFilter>;
    parentPayoutId?: InputMaybe<StringNullableFilter>;
    payoutReferencePaymentType?: InputMaybe<EnumPayoutReferencePaymentTypeNullableFilter>;
    payoutType?: InputMaybe<StringFilter>;
    price?: InputMaybe<DecimalFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    status?: InputMaybe<EnumTransactionStatusFilter>;
    stripeDestinationId?: InputMaybe<StringNullableFilter>;
    stripeFee?: InputMaybe<DecimalNullableFilter>;
    stripePayoutFee?: InputMaybe<DecimalNullableFilter>;
    stripeReversalId?: InputMaybe<StringNullableFilter>;
    stripeTransferId?: InputMaybe<StringNullableFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    transferredAmount?: InputMaybe<DecimalNullableFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PayoutWhereUniqueInput = {
    AND?: InputMaybe<Array<PayoutWhereInput>>;
    NOT?: InputMaybe<Array<PayoutWhereInput>>;
    OR?: InputMaybe<Array<PayoutWhereInput>>;
    boughtTreatmentId?: InputMaybe<StringNullableFilter>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    charges?: InputMaybe<ChargeListRelationFilter>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    createdByEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    destinationPayment?: InputMaybe<StringNullableFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    expectedPayoutDate?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    isArtCreated?: InputMaybe<BoolNullableFilter>;
    lastUpdatedByEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntFilter>;
    ourFee?: InputMaybe<DecimalNullableFilter>;
    parentPayoutId?: InputMaybe<StringNullableFilter>;
    payoutReferencePaymentType?: InputMaybe<EnumPayoutReferencePaymentTypeNullableFilter>;
    payoutType?: InputMaybe<StringFilter>;
    price?: InputMaybe<DecimalFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    status?: InputMaybe<EnumTransactionStatusFilter>;
    stripeDestinationId?: InputMaybe<StringNullableFilter>;
    stripeFee?: InputMaybe<DecimalNullableFilter>;
    stripePayoutFee?: InputMaybe<DecimalNullableFilter>;
    stripeReversalId?: InputMaybe<StringNullableFilter>;
    stripeTransferId?: InputMaybe<StringNullableFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    transferredAmount?: InputMaybe<DecimalNullableFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PendingVoidPayoutReversal = {
    __typename?: 'PendingVoidPayoutReversal';
    boughtTreatmentId: Scalars['String']['output'];
    chargeIds: Array<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    processingStatus: PendingVoidPayoutReversalProcessingStatusEnum;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PendingVoidPayoutReversalAvgAggregate = {
    __typename?: 'PendingVoidPayoutReversalAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type PendingVoidPayoutReversalAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type PendingVoidPayoutReversalCountAggregate = {
    __typename?: 'PendingVoidPayoutReversalCountAggregate';
    _all: Scalars['Int']['output'];
    boughtTreatmentId: Scalars['Int']['output'];
    chargeIds: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrPostLedgerId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    processingStatus: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PendingVoidPayoutReversalCountOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    chargeIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    processingStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PendingVoidPayoutReversalCreateInput = {
    boughtTreatmentId: Scalars['String']['input'];
    chargeIds?: InputMaybe<PendingVoidPayoutReversalCreatechargeIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrPostLedgerId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    processingStatus?: InputMaybe<PendingVoidPayoutReversalProcessingStatusEnum>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PendingVoidPayoutReversalCreateManyInput = {
    boughtTreatmentId: Scalars['String']['input'];
    chargeIds?: InputMaybe<PendingVoidPayoutReversalCreatechargeIdsInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrPostLedgerId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
    processingStatus?: InputMaybe<PendingVoidPayoutReversalProcessingStatusEnum>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PendingVoidPayoutReversalCreatechargeIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type PendingVoidPayoutReversalGroupBy = {
    __typename?: 'PendingVoidPayoutReversalGroupBy';
    _avg?: Maybe<PendingVoidPayoutReversalAvgAggregate>;
    _count?: Maybe<PendingVoidPayoutReversalCountAggregate>;
    _max?: Maybe<PendingVoidPayoutReversalMaxAggregate>;
    _min?: Maybe<PendingVoidPayoutReversalMinAggregate>;
    _sum?: Maybe<PendingVoidPayoutReversalSumAggregate>;
    boughtTreatmentId: Scalars['String']['output'];
    chargeIds?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId: Scalars['String']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    processingStatus: PendingVoidPayoutReversalProcessingStatusEnum;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PendingVoidPayoutReversalMaxAggregate = {
    __typename?: 'PendingVoidPayoutReversalMaxAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    processingStatus?: Maybe<PendingVoidPayoutReversalProcessingStatusEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PendingVoidPayoutReversalMaxOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    processingStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PendingVoidPayoutReversalMinAggregate = {
    __typename?: 'PendingVoidPayoutReversalMinAggregate';
    boughtTreatmentId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    processingStatus?: Maybe<PendingVoidPayoutReversalProcessingStatusEnum>;
    slotId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PendingVoidPayoutReversalMinOrderByAggregateInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    processingStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PendingVoidPayoutReversalOrderByWithAggregationInput = {
    _avg?: InputMaybe<PendingVoidPayoutReversalAvgOrderByAggregateInput>;
    _count?: InputMaybe<PendingVoidPayoutReversalCountOrderByAggregateInput>;
    _max?: InputMaybe<PendingVoidPayoutReversalMaxOrderByAggregateInput>;
    _min?: InputMaybe<PendingVoidPayoutReversalMinOrderByAggregateInput>;
    _sum?: InputMaybe<PendingVoidPayoutReversalSumOrderByAggregateInput>;
    boughtTreatmentId?: InputMaybe<SortOrder>;
    chargeIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    processingStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PendingVoidPayoutReversalOrderByWithRelationInput = {
    boughtTreatmentId?: InputMaybe<SortOrder>;
    chargeIds?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    processingStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PendingVoidPayoutReversalProcessingStatusEnum {
    Cancelled = 'CANCELLED',
    CheckoutReversalPending = 'CHECKOUT_REVERSAL_PENDING',
    Completed = 'COMPLETED',
    Pending = 'PENDING',
}

export enum PendingVoidPayoutReversalScalarFieldEnum {
    BoughtTreatmentId = 'boughtTreatmentId',
    ChargeIds = 'chargeIds',
    CreatedAt = 'createdAt',
    EhrPostLedgerId = 'ehrPostLedgerId',
    Id = 'id',
    OrgId = 'orgId',
    ProcessingStatus = 'processingStatus',
    SlotId = 'slotId',
    UpdatedAt = 'updatedAt',
}

export type PendingVoidPayoutReversalScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PendingVoidPayoutReversalScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PendingVoidPayoutReversalScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<PendingVoidPayoutReversalScalarWhereWithAggregatesInput>
    >;
    boughtTreatmentId?: InputMaybe<UuidWithAggregatesFilter>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrPostLedgerId?: InputMaybe<UuidWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    processingStatus?: InputMaybe<EnumPendingVoidPayoutReversalProcessingStatusEnumWithAggregatesFilter>;
    slotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PendingVoidPayoutReversalSumAggregate = {
    __typename?: 'PendingVoidPayoutReversalSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type PendingVoidPayoutReversalSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type PendingVoidPayoutReversalUpdateInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    chargeIds?: InputMaybe<PendingVoidPayoutReversalUpdatechargeIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    processingStatus?: InputMaybe<EnumPendingVoidPayoutReversalProcessingStatusEnumFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PendingVoidPayoutReversalUpdateManyMutationInput = {
    boughtTreatmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
    chargeIds?: InputMaybe<PendingVoidPayoutReversalUpdatechargeIdsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
    processingStatus?: InputMaybe<EnumPendingVoidPayoutReversalProcessingStatusEnumFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PendingVoidPayoutReversalUpdatechargeIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PendingVoidPayoutReversalWhereInput = {
    AND?: InputMaybe<Array<PendingVoidPayoutReversalWhereInput>>;
    NOT?: InputMaybe<Array<PendingVoidPayoutReversalWhereInput>>;
    OR?: InputMaybe<Array<PendingVoidPayoutReversalWhereInput>>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrPostLedgerId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<UuidFilter>;
    orgId?: InputMaybe<IntFilter>;
    processingStatus?: InputMaybe<EnumPendingVoidPayoutReversalProcessingStatusEnumFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PendingVoidPayoutReversalWhereUniqueInput = {
    AND?: InputMaybe<Array<PendingVoidPayoutReversalWhereInput>>;
    NOT?: InputMaybe<Array<PendingVoidPayoutReversalWhereInput>>;
    OR?: InputMaybe<Array<PendingVoidPayoutReversalWhereInput>>;
    boughtTreatmentId?: InputMaybe<UuidFilter>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrPostLedgerId?: InputMaybe<UuidFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
    processingStatus?: InputMaybe<EnumPendingVoidPayoutReversalProcessingStatusEnumFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PhoneNumberType = {
    __typename?: 'PhoneNumberType';
    createdAt: Scalars['DateTimeISO']['output'];
    phoneNumber: Scalars['String']['output'];
    type: PhoneNumberTypeEnum;
};

export type PhoneNumberTypeCountAggregate = {
    __typename?: 'PhoneNumberTypeCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    phoneNumber: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
};

export type PhoneNumberTypeCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type PhoneNumberTypeCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    phoneNumber: Scalars['String']['input'];
    type: PhoneNumberTypeEnum;
};

export type PhoneNumberTypeCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    phoneNumber: Scalars['String']['input'];
    type: PhoneNumberTypeEnum;
};

export enum PhoneNumberTypeEnum {
    Fixedvoip = 'FIXEDVOIP',
    Invalid = 'INVALID',
    Landline = 'LANDLINE',
    Mobile = 'MOBILE',
    Nonfixedvoip = 'NONFIXEDVOIP',
    Pager = 'PAGER',
    Personal = 'PERSONAL',
    Premium = 'PREMIUM',
    Sharedcost = 'SHAREDCOST',
    Tollfree = 'TOLLFREE',
    Uan = 'UAN',
    Unknown = 'UNKNOWN',
    Voicemail = 'VOICEMAIL',
}

export type PhoneNumberTypeGroupBy = {
    __typename?: 'PhoneNumberTypeGroupBy';
    _count?: Maybe<PhoneNumberTypeCountAggregate>;
    _max?: Maybe<PhoneNumberTypeMaxAggregate>;
    _min?: Maybe<PhoneNumberTypeMinAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    phoneNumber: Scalars['String']['output'];
    type: PhoneNumberTypeEnum;
};

export type PhoneNumberTypeMaxAggregate = {
    __typename?: 'PhoneNumberTypeMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    type?: Maybe<PhoneNumberTypeEnum>;
};

export type PhoneNumberTypeMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type PhoneNumberTypeMinAggregate = {
    __typename?: 'PhoneNumberTypeMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    type?: Maybe<PhoneNumberTypeEnum>;
};

export type PhoneNumberTypeMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type PhoneNumberTypeOrderByWithAggregationInput = {
    _count?: InputMaybe<PhoneNumberTypeCountOrderByAggregateInput>;
    _max?: InputMaybe<PhoneNumberTypeMaxOrderByAggregateInput>;
    _min?: InputMaybe<PhoneNumberTypeMinOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type PhoneNumberTypeOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export enum PhoneNumberTypeScalarFieldEnum {
    CreatedAt = 'createdAt',
    PhoneNumber = 'phoneNumber',
    Type = 'type',
}

export type PhoneNumberTypeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PhoneNumberTypeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PhoneNumberTypeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PhoneNumberTypeScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    phoneNumber?: InputMaybe<StringWithAggregatesFilter>;
    type?: InputMaybe<EnumPhoneNumberTypeEnumWithAggregatesFilter>;
};

export type PhoneNumberTypeUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPhoneNumberTypeEnumFieldUpdateOperationsInput>;
};

export type PhoneNumberTypeUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumPhoneNumberTypeEnumFieldUpdateOperationsInput>;
};

export type PhoneNumberTypeWhereInput = {
    AND?: InputMaybe<Array<PhoneNumberTypeWhereInput>>;
    NOT?: InputMaybe<Array<PhoneNumberTypeWhereInput>>;
    OR?: InputMaybe<Array<PhoneNumberTypeWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    phoneNumber?: InputMaybe<StringFilter>;
    type?: InputMaybe<EnumPhoneNumberTypeEnumFilter>;
};

export type PhoneNumberTypeWhereUniqueInput = {
    AND?: InputMaybe<Array<PhoneNumberTypeWhereInput>>;
    NOT?: InputMaybe<Array<PhoneNumberTypeWhereInput>>;
    OR?: InputMaybe<Array<PhoneNumberTypeWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<EnumPhoneNumberTypeEnumFilter>;
};

export enum PhotoStatus {
    Current = 'CURRENT',
    Deleted = 'DELETED',
    Expired = 'EXPIRED',
}

export enum PhotoType {
    IdCardBack = 'ID_CARD_BACK',
    IdCardFront = 'ID_CARD_FRONT',
    InsuranceCardBack = 'INSURANCE_CARD_BACK',
    InsuranceCardFront = 'INSURANCE_CARD_FRONT',
    Other = 'OTHER',
    ProfilePhoto = 'PROFILE_PHOTO',
}

export type PlaceOfServiceCode = {
    __typename?: 'PlaceOfServiceCode';
    Practice: Array<Practice>;
    ProviderGroup: Array<ProviderGroup>;
    _count?: Maybe<PlaceOfServiceCodeCount>;
    defaultServiceType?: Maybe<ServiceTypeCode>;
    description?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    placeOfServiceCode: Scalars['String']['output'];
    serviceTypeCode?: Maybe<Scalars['String']['output']>;
};

export type PlaceOfServiceCodePracticeArgs = {
    cursor?: InputMaybe<PracticeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PlaceOfServiceCodeProviderGroupArgs = {
    cursor?: InputMaybe<ProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type PlaceOfServiceCodeDefaultServiceTypeArgs = {
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type PlaceOfServiceCodeCount = {
    __typename?: 'PlaceOfServiceCodeCount';
    Practice: Scalars['Int']['output'];
    ProviderGroup: Scalars['Int']['output'];
};

export type PlaceOfServiceCodeCountPracticeArgs = {
    where?: InputMaybe<PracticeWhereInput>;
};

export type PlaceOfServiceCodeCountProviderGroupArgs = {
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type PlaceOfServiceCodeCountAggregate = {
    __typename?: 'PlaceOfServiceCodeCountAggregate';
    _all: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    placeOfServiceCode: Scalars['Int']['output'];
    serviceTypeCode: Scalars['Int']['output'];
};

export type PlaceOfServiceCodeCountOrderByAggregateInput = {
    description?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    serviceTypeCode?: InputMaybe<SortOrder>;
};

export type PlaceOfServiceCodeCreateInput = {
    Practice?: InputMaybe<PracticeCreateNestedManyWithoutPlaceOfServiceInput>;
    ProviderGroup?: InputMaybe<ProviderGroupCreateNestedManyWithoutPlaceOfServiceInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeCreateNestedOneWithoutPlaceOfServiceCodeInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    placeOfServiceCode: Scalars['String']['input'];
};

export type PlaceOfServiceCodeCreateManyDefaultServiceTypeInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    placeOfServiceCode: Scalars['String']['input'];
};

export type PlaceOfServiceCodeCreateManyDefaultServiceTypeInputEnvelope = {
    data: Array<PlaceOfServiceCodeCreateManyDefaultServiceTypeInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlaceOfServiceCodeCreateManyInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    placeOfServiceCode: Scalars['String']['input'];
    serviceTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceOfServiceCodeCreateNestedManyWithoutDefaultServiceTypeInput = {
    connect?: InputMaybe<Array<PlaceOfServiceCodeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PlaceOfServiceCodeCreateOrConnectWithoutDefaultServiceTypeInput>
    >;
    create?: InputMaybe<
        Array<PlaceOfServiceCodeCreateWithoutDefaultServiceTypeInput>
    >;
    createMany?: InputMaybe<PlaceOfServiceCodeCreateManyDefaultServiceTypeInputEnvelope>;
};

export type PlaceOfServiceCodeCreateNestedOneWithoutPracticeInput = {
    connect?: InputMaybe<PlaceOfServiceCodeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PlaceOfServiceCodeCreateOrConnectWithoutPracticeInput>;
    create?: InputMaybe<PlaceOfServiceCodeCreateWithoutPracticeInput>;
};

export type PlaceOfServiceCodeCreateNestedOneWithoutProviderGroupInput = {
    connect?: InputMaybe<PlaceOfServiceCodeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PlaceOfServiceCodeCreateOrConnectWithoutProviderGroupInput>;
    create?: InputMaybe<PlaceOfServiceCodeCreateWithoutProviderGroupInput>;
};

export type PlaceOfServiceCodeCreateOrConnectWithoutDefaultServiceTypeInput = {
    create: PlaceOfServiceCodeCreateWithoutDefaultServiceTypeInput;
    where: PlaceOfServiceCodeWhereUniqueInput;
};

export type PlaceOfServiceCodeCreateOrConnectWithoutPracticeInput = {
    create: PlaceOfServiceCodeCreateWithoutPracticeInput;
    where: PlaceOfServiceCodeWhereUniqueInput;
};

export type PlaceOfServiceCodeCreateOrConnectWithoutProviderGroupInput = {
    create: PlaceOfServiceCodeCreateWithoutProviderGroupInput;
    where: PlaceOfServiceCodeWhereUniqueInput;
};

export type PlaceOfServiceCodeCreateWithoutDefaultServiceTypeInput = {
    Practice?: InputMaybe<PracticeCreateNestedManyWithoutPlaceOfServiceInput>;
    ProviderGroup?: InputMaybe<ProviderGroupCreateNestedManyWithoutPlaceOfServiceInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    placeOfServiceCode: Scalars['String']['input'];
};

export type PlaceOfServiceCodeCreateWithoutPracticeInput = {
    ProviderGroup?: InputMaybe<ProviderGroupCreateNestedManyWithoutPlaceOfServiceInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeCreateNestedOneWithoutPlaceOfServiceCodeInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    placeOfServiceCode: Scalars['String']['input'];
};

export type PlaceOfServiceCodeCreateWithoutProviderGroupInput = {
    Practice?: InputMaybe<PracticeCreateNestedManyWithoutPlaceOfServiceInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeCreateNestedOneWithoutPlaceOfServiceCodeInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    placeOfServiceCode: Scalars['String']['input'];
};

export type PlaceOfServiceCodeGroupBy = {
    __typename?: 'PlaceOfServiceCodeGroupBy';
    _count?: Maybe<PlaceOfServiceCodeCountAggregate>;
    _max?: Maybe<PlaceOfServiceCodeMaxAggregate>;
    _min?: Maybe<PlaceOfServiceCodeMinAggregate>;
    description?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    placeOfServiceCode: Scalars['String']['output'];
    serviceTypeCode?: Maybe<Scalars['String']['output']>;
};

export type PlaceOfServiceCodeListRelationFilter = {
    every?: InputMaybe<PlaceOfServiceCodeWhereInput>;
    none?: InputMaybe<PlaceOfServiceCodeWhereInput>;
    some?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type PlaceOfServiceCodeMaxAggregate = {
    __typename?: 'PlaceOfServiceCodeMaxAggregate';
    description?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    placeOfServiceCode?: Maybe<Scalars['String']['output']>;
    serviceTypeCode?: Maybe<Scalars['String']['output']>;
};

export type PlaceOfServiceCodeMaxOrderByAggregateInput = {
    description?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    serviceTypeCode?: InputMaybe<SortOrder>;
};

export type PlaceOfServiceCodeMinAggregate = {
    __typename?: 'PlaceOfServiceCodeMinAggregate';
    description?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    placeOfServiceCode?: Maybe<Scalars['String']['output']>;
    serviceTypeCode?: Maybe<Scalars['String']['output']>;
};

export type PlaceOfServiceCodeMinOrderByAggregateInput = {
    description?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    serviceTypeCode?: InputMaybe<SortOrder>;
};

export type PlaceOfServiceCodeNullableRelationFilter = {
    is?: InputMaybe<PlaceOfServiceCodeWhereInput>;
    isNot?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type PlaceOfServiceCodeOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PlaceOfServiceCodeOrderByWithAggregationInput = {
    _count?: InputMaybe<PlaceOfServiceCodeCountOrderByAggregateInput>;
    _max?: InputMaybe<PlaceOfServiceCodeMaxOrderByAggregateInput>;
    _min?: InputMaybe<PlaceOfServiceCodeMinOrderByAggregateInput>;
    description?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    serviceTypeCode?: InputMaybe<SortOrderInput>;
};

export type PlaceOfServiceCodeOrderByWithRelationInput = {
    Practice?: InputMaybe<PracticeOrderByRelationAggregateInput>;
    ProviderGroup?: InputMaybe<ProviderGroupOrderByRelationAggregateInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeOrderByWithRelationInput>;
    description?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    serviceTypeCode?: InputMaybe<SortOrderInput>;
};

export enum PlaceOfServiceCodeScalarFieldEnum {
    Description = 'description',
    Name = 'name',
    PlaceOfServiceCode = 'placeOfServiceCode',
    ServiceTypeCode = 'serviceTypeCode',
}

export type PlaceOfServiceCodeScalarWhereInput = {
    AND?: InputMaybe<Array<PlaceOfServiceCodeScalarWhereInput>>;
    NOT?: InputMaybe<Array<PlaceOfServiceCodeScalarWhereInput>>;
    OR?: InputMaybe<Array<PlaceOfServiceCodeScalarWhereInput>>;
    description?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    placeOfServiceCode?: InputMaybe<StringFilter>;
    serviceTypeCode?: InputMaybe<StringNullableFilter>;
};

export type PlaceOfServiceCodeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PlaceOfServiceCodeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PlaceOfServiceCodeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PlaceOfServiceCodeScalarWhereWithAggregatesInput>>;
    description?: InputMaybe<StringNullableWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    placeOfServiceCode?: InputMaybe<StringWithAggregatesFilter>;
    serviceTypeCode?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type PlaceOfServiceCodeUpdateInput = {
    Practice?: InputMaybe<PracticeUpdateManyWithoutPlaceOfServiceNestedInput>;
    ProviderGroup?: InputMaybe<ProviderGroupUpdateManyWithoutPlaceOfServiceNestedInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeUpdateOneWithoutPlaceOfServiceCodeNestedInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    placeOfServiceCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PlaceOfServiceCodeUpdateManyMutationInput = {
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    placeOfServiceCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PlaceOfServiceCodeUpdateManyWithWhereWithoutDefaultServiceTypeInput =
    {
        data: PlaceOfServiceCodeUpdateManyMutationInput;
        where: PlaceOfServiceCodeScalarWhereInput;
    };

export type PlaceOfServiceCodeUpdateManyWithoutDefaultServiceTypeNestedInput = {
    connect?: InputMaybe<Array<PlaceOfServiceCodeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PlaceOfServiceCodeCreateOrConnectWithoutDefaultServiceTypeInput>
    >;
    create?: InputMaybe<
        Array<PlaceOfServiceCodeCreateWithoutDefaultServiceTypeInput>
    >;
    createMany?: InputMaybe<PlaceOfServiceCodeCreateManyDefaultServiceTypeInputEnvelope>;
    delete?: InputMaybe<Array<PlaceOfServiceCodeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PlaceOfServiceCodeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PlaceOfServiceCodeWhereUniqueInput>>;
    set?: InputMaybe<Array<PlaceOfServiceCodeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PlaceOfServiceCodeUpdateWithWhereUniqueWithoutDefaultServiceTypeInput>
    >;
    updateMany?: InputMaybe<
        Array<PlaceOfServiceCodeUpdateManyWithWhereWithoutDefaultServiceTypeInput>
    >;
    upsert?: InputMaybe<
        Array<PlaceOfServiceCodeUpsertWithWhereUniqueWithoutDefaultServiceTypeInput>
    >;
};

export type PlaceOfServiceCodeUpdateOneWithoutPracticeNestedInput = {
    connect?: InputMaybe<PlaceOfServiceCodeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PlaceOfServiceCodeCreateOrConnectWithoutPracticeInput>;
    create?: InputMaybe<PlaceOfServiceCodeCreateWithoutPracticeInput>;
    delete?: InputMaybe<PlaceOfServiceCodeWhereInput>;
    disconnect?: InputMaybe<PlaceOfServiceCodeWhereInput>;
    update?: InputMaybe<PlaceOfServiceCodeUpdateToOneWithWhereWithoutPracticeInput>;
    upsert?: InputMaybe<PlaceOfServiceCodeUpsertWithoutPracticeInput>;
};

export type PlaceOfServiceCodeUpdateOneWithoutProviderGroupNestedInput = {
    connect?: InputMaybe<PlaceOfServiceCodeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PlaceOfServiceCodeCreateOrConnectWithoutProviderGroupInput>;
    create?: InputMaybe<PlaceOfServiceCodeCreateWithoutProviderGroupInput>;
    delete?: InputMaybe<PlaceOfServiceCodeWhereInput>;
    disconnect?: InputMaybe<PlaceOfServiceCodeWhereInput>;
    update?: InputMaybe<PlaceOfServiceCodeUpdateToOneWithWhereWithoutProviderGroupInput>;
    upsert?: InputMaybe<PlaceOfServiceCodeUpsertWithoutProviderGroupInput>;
};

export type PlaceOfServiceCodeUpdateToOneWithWhereWithoutPracticeInput = {
    data: PlaceOfServiceCodeUpdateWithoutPracticeInput;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type PlaceOfServiceCodeUpdateToOneWithWhereWithoutProviderGroupInput = {
    data: PlaceOfServiceCodeUpdateWithoutProviderGroupInput;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type PlaceOfServiceCodeUpdateWithWhereUniqueWithoutDefaultServiceTypeInput =
    {
        data: PlaceOfServiceCodeUpdateWithoutDefaultServiceTypeInput;
        where: PlaceOfServiceCodeWhereUniqueInput;
    };

export type PlaceOfServiceCodeUpdateWithoutDefaultServiceTypeInput = {
    Practice?: InputMaybe<PracticeUpdateManyWithoutPlaceOfServiceNestedInput>;
    ProviderGroup?: InputMaybe<ProviderGroupUpdateManyWithoutPlaceOfServiceNestedInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    placeOfServiceCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PlaceOfServiceCodeUpdateWithoutPracticeInput = {
    ProviderGroup?: InputMaybe<ProviderGroupUpdateManyWithoutPlaceOfServiceNestedInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeUpdateOneWithoutPlaceOfServiceCodeNestedInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    placeOfServiceCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PlaceOfServiceCodeUpdateWithoutProviderGroupInput = {
    Practice?: InputMaybe<PracticeUpdateManyWithoutPlaceOfServiceNestedInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeUpdateOneWithoutPlaceOfServiceCodeNestedInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    placeOfServiceCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PlaceOfServiceCodeUpsertWithWhereUniqueWithoutDefaultServiceTypeInput =
    {
        create: PlaceOfServiceCodeCreateWithoutDefaultServiceTypeInput;
        update: PlaceOfServiceCodeUpdateWithoutDefaultServiceTypeInput;
        where: PlaceOfServiceCodeWhereUniqueInput;
    };

export type PlaceOfServiceCodeUpsertWithoutPracticeInput = {
    create: PlaceOfServiceCodeCreateWithoutPracticeInput;
    update: PlaceOfServiceCodeUpdateWithoutPracticeInput;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type PlaceOfServiceCodeUpsertWithoutProviderGroupInput = {
    create: PlaceOfServiceCodeCreateWithoutProviderGroupInput;
    update: PlaceOfServiceCodeUpdateWithoutProviderGroupInput;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type PlaceOfServiceCodeWhereInput = {
    AND?: InputMaybe<Array<PlaceOfServiceCodeWhereInput>>;
    NOT?: InputMaybe<Array<PlaceOfServiceCodeWhereInput>>;
    OR?: InputMaybe<Array<PlaceOfServiceCodeWhereInput>>;
    Practice?: InputMaybe<PracticeListRelationFilter>;
    ProviderGroup?: InputMaybe<ProviderGroupListRelationFilter>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeNullableRelationFilter>;
    description?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    placeOfServiceCode?: InputMaybe<StringFilter>;
    serviceTypeCode?: InputMaybe<StringNullableFilter>;
};

export type PlaceOfServiceCodeWhereUniqueInput = {
    AND?: InputMaybe<Array<PlaceOfServiceCodeWhereInput>>;
    NOT?: InputMaybe<Array<PlaceOfServiceCodeWhereInput>>;
    OR?: InputMaybe<Array<PlaceOfServiceCodeWhereInput>>;
    Practice?: InputMaybe<PracticeListRelationFilter>;
    ProviderGroup?: InputMaybe<ProviderGroupListRelationFilter>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeNullableRelationFilter>;
    description?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    placeOfServiceCode?: InputMaybe<Scalars['String']['input']>;
    serviceTypeCode?: InputMaybe<StringNullableFilter>;
};

export type Practice = {
    __typename?: 'Practice';
    _count?: Maybe<PracticeCount>;
    address: Scalars['String']['output'];
    artPracticeConfig?: Maybe<ArtPracticeConfig>;
    defaultPractices: Array<DefaultPractice>;
    deploymentOrgTasks: Array<DeploymentOrgTask>;
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    googleMapsEmbed: Scalars['String']['output'];
    googleMapsUrl: Scalars['String']['output'];
    isAvailableFromStorefront: Scalars['Boolean']['output'];
    locationName: Scalars['String']['output'];
    metadata: Scalars['JSON']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    phoneNumber?: Maybe<Scalars['String']['output']>;
    placeOfService?: Maybe<PlaceOfServiceCode>;
    placeOfServiceCode?: Maybe<Scalars['String']['output']>;
    practiceHours: Array<PracticeHours>;
    practiceHoursOverrides: Array<PracticeHoursOverrides>;
    practiceId: Scalars['Int']['output'];
    providerGroups: Array<ProviderGroup>;
    schedulingSlotConfig: Array<SchedulingSlotConfig>;
    state: Scalars['String']['output'];
    timezone: Scalars['String']['output'];
};

export type PracticeArtPracticeConfigArgs = {
    where?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type PracticeDefaultPracticesArgs = {
    cursor?: InputMaybe<DefaultPracticeWhereUniqueInput>;
    distinct?: InputMaybe<Array<DefaultPracticeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DefaultPracticeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type PracticeDeploymentOrgTasksArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgTaskOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type PracticePlaceOfServiceArgs = {
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type PracticePracticeHoursArgs = {
    cursor?: InputMaybe<PracticeHoursWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeHoursScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeHoursOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursWhereInput>;
};

export type PracticePracticeHoursOverridesArgs = {
    cursor?: InputMaybe<PracticeHoursOverridesWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeHoursOverridesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeHoursOverridesOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursOverridesWhereInput>;
};

export type PracticeProviderGroupsArgs = {
    cursor?: InputMaybe<ProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type PracticeSchedulingSlotConfigArgs = {
    cursor?: InputMaybe<SchedulingSlotConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<SchedulingSlotConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SchedulingSlotConfigOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SchedulingSlotConfigWhereInput>;
};

export type PracticeAvgAggregate = {
    __typename?: 'PracticeAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type PracticeAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeConfiguration = {
    __typename?: 'PracticeConfiguration';
    activationCode: Scalars['String']['output'];
    posDeviceId: Scalars['String']['output'];
    practiceId: Scalars['Int']['output'];
};

export type PracticeConfigurationAvgAggregate = {
    __typename?: 'PracticeConfigurationAvgAggregate';
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type PracticeConfigurationAvgOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeConfigurationCountAggregate = {
    __typename?: 'PracticeConfigurationCountAggregate';
    _all: Scalars['Int']['output'];
    activationCode: Scalars['Int']['output'];
    posDeviceId: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
};

export type PracticeConfigurationCountOrderByAggregateInput = {
    activationCode?: InputMaybe<SortOrder>;
    posDeviceId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeConfigurationCreateInput = {
    activationCode: Scalars['String']['input'];
    posDeviceId: Scalars['String']['input'];
    practiceId: Scalars['Int']['input'];
};

export type PracticeConfigurationCreateManyInput = {
    activationCode: Scalars['String']['input'];
    posDeviceId: Scalars['String']['input'];
    practiceId: Scalars['Int']['input'];
};

export type PracticeConfigurationGroupBy = {
    __typename?: 'PracticeConfigurationGroupBy';
    _avg?: Maybe<PracticeConfigurationAvgAggregate>;
    _count?: Maybe<PracticeConfigurationCountAggregate>;
    _max?: Maybe<PracticeConfigurationMaxAggregate>;
    _min?: Maybe<PracticeConfigurationMinAggregate>;
    _sum?: Maybe<PracticeConfigurationSumAggregate>;
    activationCode: Scalars['String']['output'];
    posDeviceId: Scalars['String']['output'];
    practiceId: Scalars['Int']['output'];
};

export type PracticeConfigurationMaxAggregate = {
    __typename?: 'PracticeConfigurationMaxAggregate';
    activationCode?: Maybe<Scalars['String']['output']>;
    posDeviceId?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type PracticeConfigurationMaxOrderByAggregateInput = {
    activationCode?: InputMaybe<SortOrder>;
    posDeviceId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeConfigurationMinAggregate = {
    __typename?: 'PracticeConfigurationMinAggregate';
    activationCode?: Maybe<Scalars['String']['output']>;
    posDeviceId?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type PracticeConfigurationMinOrderByAggregateInput = {
    activationCode?: InputMaybe<SortOrder>;
    posDeviceId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeConfigurationOrderByWithAggregationInput = {
    _avg?: InputMaybe<PracticeConfigurationAvgOrderByAggregateInput>;
    _count?: InputMaybe<PracticeConfigurationCountOrderByAggregateInput>;
    _max?: InputMaybe<PracticeConfigurationMaxOrderByAggregateInput>;
    _min?: InputMaybe<PracticeConfigurationMinOrderByAggregateInput>;
    _sum?: InputMaybe<PracticeConfigurationSumOrderByAggregateInput>;
    activationCode?: InputMaybe<SortOrder>;
    posDeviceId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeConfigurationOrderByWithRelationInput = {
    activationCode?: InputMaybe<SortOrder>;
    posDeviceId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export enum PracticeConfigurationScalarFieldEnum {
    ActivationCode = 'activationCode',
    PosDeviceId = 'posDeviceId',
    PracticeId = 'practiceId',
}

export type PracticeConfigurationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PracticeConfigurationScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PracticeConfigurationScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<PracticeConfigurationScalarWhereWithAggregatesInput>>;
    activationCode?: InputMaybe<StringWithAggregatesFilter>;
    posDeviceId?: InputMaybe<StringWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
};

export type PracticeConfigurationSumAggregate = {
    __typename?: 'PracticeConfigurationSumAggregate';
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type PracticeConfigurationSumOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeConfigurationUpdateInput = {
    activationCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    posDeviceId?: InputMaybe<StringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type PracticeConfigurationUpdateManyMutationInput = {
    activationCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    posDeviceId?: InputMaybe<StringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type PracticeConfigurationWhereInput = {
    AND?: InputMaybe<Array<PracticeConfigurationWhereInput>>;
    NOT?: InputMaybe<Array<PracticeConfigurationWhereInput>>;
    OR?: InputMaybe<Array<PracticeConfigurationWhereInput>>;
    activationCode?: InputMaybe<StringFilter>;
    posDeviceId?: InputMaybe<StringFilter>;
    practiceId?: InputMaybe<IntFilter>;
};

export type PracticeConfigurationWhereUniqueInput = {
    AND?: InputMaybe<Array<PracticeConfigurationWhereInput>>;
    NOT?: InputMaybe<Array<PracticeConfigurationWhereInput>>;
    OR?: InputMaybe<Array<PracticeConfigurationWhereInput>>;
    activationCode?: InputMaybe<Scalars['String']['input']>;
    posDeviceId?: InputMaybe<StringFilter>;
    practiceId?: InputMaybe<IntFilter>;
};

export type PracticeCount = {
    __typename?: 'PracticeCount';
    defaultPractices: Scalars['Int']['output'];
    deploymentOrgTasks: Scalars['Int']['output'];
    practiceHours: Scalars['Int']['output'];
    practiceHoursOverrides: Scalars['Int']['output'];
    providerGroups: Scalars['Int']['output'];
    schedulingSlotConfig: Scalars['Int']['output'];
};

export type PracticeCountDefaultPracticesArgs = {
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type PracticeCountDeploymentOrgTasksArgs = {
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type PracticeCountPracticeHoursArgs = {
    where?: InputMaybe<PracticeHoursWhereInput>;
};

export type PracticeCountPracticeHoursOverridesArgs = {
    where?: InputMaybe<PracticeHoursOverridesWhereInput>;
};

export type PracticeCountProviderGroupsArgs = {
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type PracticeCountSchedulingSlotConfigArgs = {
    where?: InputMaybe<SchedulingSlotConfigWhereInput>;
};

export type PracticeCountAggregate = {
    __typename?: 'PracticeCountAggregate';
    _all: Scalars['Int']['output'];
    address: Scalars['Int']['output'];
    ehrLocationId: Scalars['Int']['output'];
    googleMapsEmbed: Scalars['Int']['output'];
    googleMapsUrl: Scalars['Int']['output'];
    isAvailableFromStorefront: Scalars['Int']['output'];
    locationName: Scalars['Int']['output'];
    metadata: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    phoneNumber: Scalars['Int']['output'];
    placeOfServiceCode: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
    timezone: Scalars['Int']['output'];
};

export type PracticeCountOrderByAggregateInput = {
    address?: InputMaybe<SortOrder>;
    ehrLocationId?: InputMaybe<SortOrder>;
    googleMapsEmbed?: InputMaybe<SortOrder>;
    googleMapsUrl?: InputMaybe<SortOrder>;
    isAvailableFromStorefront?: InputMaybe<SortOrder>;
    locationName?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
};

export type PracticeCreateInput = {
    address: Scalars['String']['input'];
    artPracticeConfig?: InputMaybe<ArtPracticeConfigCreateNestedOneWithoutPracticeInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutPracticeInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutPracticeInput>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    org: OrganizationCreateNestedOneWithoutPracticesInput;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutPracticeInput>;
    practiceHours?: InputMaybe<PracticeHoursCreateNestedManyWithoutPracticeInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesCreateNestedManyWithoutPracticeInput>;
    practiceId: Scalars['Int']['input'];
    providerGroups?: InputMaybe<ProviderGroupCreateNestedManyWithoutPracticeInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigCreateNestedManyWithoutPracticeInput>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateManyInput = {
    address: Scalars['String']['input'];
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    orgId: Scalars['Int']['input'];
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfServiceCode?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateManyOrgInput = {
    address: Scalars['String']['input'];
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfServiceCode?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateManyOrgInputEnvelope = {
    data: Array<PracticeCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PracticeCreateManyPlaceOfServiceInput = {
    address: Scalars['String']['input'];
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    orgId: Scalars['Int']['input'];
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateManyPlaceOfServiceInputEnvelope = {
    data: Array<PracticeCreateManyPlaceOfServiceInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PracticeCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<PracticeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<PracticeCreateOrConnectWithoutOrgInput>>;
    create?: InputMaybe<Array<PracticeCreateWithoutOrgInput>>;
    createMany?: InputMaybe<PracticeCreateManyOrgInputEnvelope>;
};

export type PracticeCreateNestedManyWithoutPlaceOfServiceInput = {
    connect?: InputMaybe<Array<PracticeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PracticeCreateOrConnectWithoutPlaceOfServiceInput>
    >;
    create?: InputMaybe<Array<PracticeCreateWithoutPlaceOfServiceInput>>;
    createMany?: InputMaybe<PracticeCreateManyPlaceOfServiceInputEnvelope>;
};

export type PracticeCreateNestedOneWithoutArtPracticeConfigInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutArtPracticeConfigInput>;
    create?: InputMaybe<PracticeCreateWithoutArtPracticeConfigInput>;
};

export type PracticeCreateNestedOneWithoutDefaultPracticesInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutDefaultPracticesInput>;
    create?: InputMaybe<PracticeCreateWithoutDefaultPracticesInput>;
};

export type PracticeCreateNestedOneWithoutDeploymentOrgTasksInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutDeploymentOrgTasksInput>;
    create?: InputMaybe<PracticeCreateWithoutDeploymentOrgTasksInput>;
};

export type PracticeCreateNestedOneWithoutPracticeHoursInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutPracticeHoursInput>;
    create?: InputMaybe<PracticeCreateWithoutPracticeHoursInput>;
};

export type PracticeCreateNestedOneWithoutPracticeHoursOverridesInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutPracticeHoursOverridesInput>;
    create?: InputMaybe<PracticeCreateWithoutPracticeHoursOverridesInput>;
};

export type PracticeCreateNestedOneWithoutProviderGroupsInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutProviderGroupsInput>;
    create?: InputMaybe<PracticeCreateWithoutProviderGroupsInput>;
};

export type PracticeCreateNestedOneWithoutSchedulingSlotConfigInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutSchedulingSlotConfigInput>;
    create?: InputMaybe<PracticeCreateWithoutSchedulingSlotConfigInput>;
};

export type PracticeCreateOrConnectWithoutArtPracticeConfigInput = {
    create: PracticeCreateWithoutArtPracticeConfigInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeCreateOrConnectWithoutDefaultPracticesInput = {
    create: PracticeCreateWithoutDefaultPracticesInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeCreateOrConnectWithoutDeploymentOrgTasksInput = {
    create: PracticeCreateWithoutDeploymentOrgTasksInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeCreateOrConnectWithoutOrgInput = {
    create: PracticeCreateWithoutOrgInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeCreateOrConnectWithoutPlaceOfServiceInput = {
    create: PracticeCreateWithoutPlaceOfServiceInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeCreateOrConnectWithoutPracticeHoursInput = {
    create: PracticeCreateWithoutPracticeHoursInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeCreateOrConnectWithoutPracticeHoursOverridesInput = {
    create: PracticeCreateWithoutPracticeHoursOverridesInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeCreateOrConnectWithoutProviderGroupsInput = {
    create: PracticeCreateWithoutProviderGroupsInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeCreateOrConnectWithoutSchedulingSlotConfigInput = {
    create: PracticeCreateWithoutSchedulingSlotConfigInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeCreateWithoutArtPracticeConfigInput = {
    address: Scalars['String']['input'];
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutPracticeInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutPracticeInput>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    org: OrganizationCreateNestedOneWithoutPracticesInput;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutPracticeInput>;
    practiceHours?: InputMaybe<PracticeHoursCreateNestedManyWithoutPracticeInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesCreateNestedManyWithoutPracticeInput>;
    practiceId: Scalars['Int']['input'];
    providerGroups?: InputMaybe<ProviderGroupCreateNestedManyWithoutPracticeInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigCreateNestedManyWithoutPracticeInput>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateWithoutDefaultPracticesInput = {
    address: Scalars['String']['input'];
    artPracticeConfig?: InputMaybe<ArtPracticeConfigCreateNestedOneWithoutPracticeInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutPracticeInput>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    org: OrganizationCreateNestedOneWithoutPracticesInput;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutPracticeInput>;
    practiceHours?: InputMaybe<PracticeHoursCreateNestedManyWithoutPracticeInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesCreateNestedManyWithoutPracticeInput>;
    practiceId: Scalars['Int']['input'];
    providerGroups?: InputMaybe<ProviderGroupCreateNestedManyWithoutPracticeInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigCreateNestedManyWithoutPracticeInput>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateWithoutDeploymentOrgTasksInput = {
    address: Scalars['String']['input'];
    artPracticeConfig?: InputMaybe<ArtPracticeConfigCreateNestedOneWithoutPracticeInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutPracticeInput>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    org: OrganizationCreateNestedOneWithoutPracticesInput;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutPracticeInput>;
    practiceHours?: InputMaybe<PracticeHoursCreateNestedManyWithoutPracticeInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesCreateNestedManyWithoutPracticeInput>;
    practiceId: Scalars['Int']['input'];
    providerGroups?: InputMaybe<ProviderGroupCreateNestedManyWithoutPracticeInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigCreateNestedManyWithoutPracticeInput>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateWithoutOrgInput = {
    address: Scalars['String']['input'];
    artPracticeConfig?: InputMaybe<ArtPracticeConfigCreateNestedOneWithoutPracticeInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutPracticeInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutPracticeInput>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutPracticeInput>;
    practiceHours?: InputMaybe<PracticeHoursCreateNestedManyWithoutPracticeInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesCreateNestedManyWithoutPracticeInput>;
    practiceId: Scalars['Int']['input'];
    providerGroups?: InputMaybe<ProviderGroupCreateNestedManyWithoutPracticeInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigCreateNestedManyWithoutPracticeInput>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateWithoutPlaceOfServiceInput = {
    address: Scalars['String']['input'];
    artPracticeConfig?: InputMaybe<ArtPracticeConfigCreateNestedOneWithoutPracticeInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutPracticeInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutPracticeInput>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    org: OrganizationCreateNestedOneWithoutPracticesInput;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    practiceHours?: InputMaybe<PracticeHoursCreateNestedManyWithoutPracticeInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesCreateNestedManyWithoutPracticeInput>;
    practiceId: Scalars['Int']['input'];
    providerGroups?: InputMaybe<ProviderGroupCreateNestedManyWithoutPracticeInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigCreateNestedManyWithoutPracticeInput>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateWithoutPracticeHoursInput = {
    address: Scalars['String']['input'];
    artPracticeConfig?: InputMaybe<ArtPracticeConfigCreateNestedOneWithoutPracticeInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutPracticeInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutPracticeInput>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    org: OrganizationCreateNestedOneWithoutPracticesInput;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutPracticeInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesCreateNestedManyWithoutPracticeInput>;
    practiceId: Scalars['Int']['input'];
    providerGroups?: InputMaybe<ProviderGroupCreateNestedManyWithoutPracticeInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigCreateNestedManyWithoutPracticeInput>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateWithoutPracticeHoursOverridesInput = {
    address: Scalars['String']['input'];
    artPracticeConfig?: InputMaybe<ArtPracticeConfigCreateNestedOneWithoutPracticeInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutPracticeInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutPracticeInput>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    org: OrganizationCreateNestedOneWithoutPracticesInput;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutPracticeInput>;
    practiceHours?: InputMaybe<PracticeHoursCreateNestedManyWithoutPracticeInput>;
    practiceId: Scalars['Int']['input'];
    providerGroups?: InputMaybe<ProviderGroupCreateNestedManyWithoutPracticeInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigCreateNestedManyWithoutPracticeInput>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateWithoutProviderGroupsInput = {
    address: Scalars['String']['input'];
    artPracticeConfig?: InputMaybe<ArtPracticeConfigCreateNestedOneWithoutPracticeInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutPracticeInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutPracticeInput>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    org: OrganizationCreateNestedOneWithoutPracticesInput;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutPracticeInput>;
    practiceHours?: InputMaybe<PracticeHoursCreateNestedManyWithoutPracticeInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesCreateNestedManyWithoutPracticeInput>;
    practiceId: Scalars['Int']['input'];
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigCreateNestedManyWithoutPracticeInput>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeCreateWithoutSchedulingSlotConfigInput = {
    address: Scalars['String']['input'];
    artPracticeConfig?: InputMaybe<ArtPracticeConfigCreateNestedOneWithoutPracticeInput>;
    defaultPractices?: InputMaybe<DefaultPracticeCreateNestedManyWithoutPracticeInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskCreateNestedManyWithoutPracticeInput>;
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    googleMapsEmbed?: InputMaybe<Scalars['String']['input']>;
    googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
    isAvailableFromStorefront?: InputMaybe<Scalars['Boolean']['input']>;
    locationName: Scalars['String']['input'];
    metadata: Scalars['JSON']['input'];
    org: OrganizationCreateNestedOneWithoutPracticesInput;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutPracticeInput>;
    practiceHours?: InputMaybe<PracticeHoursCreateNestedManyWithoutPracticeInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesCreateNestedManyWithoutPracticeInput>;
    practiceId: Scalars['Int']['input'];
    providerGroups?: InputMaybe<ProviderGroupCreateNestedManyWithoutPracticeInput>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
};

export type PracticeGroupBy = {
    __typename?: 'PracticeGroupBy';
    _avg?: Maybe<PracticeAvgAggregate>;
    _count?: Maybe<PracticeCountAggregate>;
    _max?: Maybe<PracticeMaxAggregate>;
    _min?: Maybe<PracticeMinAggregate>;
    _sum?: Maybe<PracticeSumAggregate>;
    address: Scalars['String']['output'];
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    googleMapsEmbed: Scalars['String']['output'];
    googleMapsUrl: Scalars['String']['output'];
    isAvailableFromStorefront: Scalars['Boolean']['output'];
    locationName: Scalars['String']['output'];
    metadata: Scalars['JSON']['output'];
    orgId: Scalars['Int']['output'];
    phoneNumber?: Maybe<Scalars['String']['output']>;
    placeOfServiceCode?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
    state: Scalars['String']['output'];
    timezone: Scalars['String']['output'];
};

export type PracticeHours = {
    __typename?: 'PracticeHours';
    closeTime: Scalars['DateTimeISO']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    dayOfWeek: DayOfWeek;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    openTime: Scalars['DateTimeISO']['output'];
    practice: Practice;
    practiceId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PracticeHoursAvgAggregate = {
    __typename?: 'PracticeHoursAvgAggregate';
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type PracticeHoursAvgOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeHoursCountAggregate = {
    __typename?: 'PracticeHoursCountAggregate';
    _all: Scalars['Int']['output'];
    closeTime: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    dayOfWeek: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    openTime: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PracticeHoursCountOrderByAggregateInput = {
    closeTime?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PracticeHoursCreateInput = {
    closeTime: Scalars['DateTimeISO']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dayOfWeek: DayOfWeek;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    openTime: Scalars['DateTimeISO']['input'];
    practice: PracticeCreateNestedOneWithoutPracticeHoursInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PracticeHoursCreateManyInput = {
    closeTime: Scalars['DateTimeISO']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dayOfWeek: DayOfWeek;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    openTime: Scalars['DateTimeISO']['input'];
    practiceId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PracticeHoursCreateManyPracticeInput = {
    closeTime: Scalars['DateTimeISO']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dayOfWeek: DayOfWeek;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    openTime: Scalars['DateTimeISO']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PracticeHoursCreateManyPracticeInputEnvelope = {
    data: Array<PracticeHoursCreateManyPracticeInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PracticeHoursCreateNestedManyWithoutPracticeInput = {
    connect?: InputMaybe<Array<PracticeHoursWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PracticeHoursCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<Array<PracticeHoursCreateWithoutPracticeInput>>;
    createMany?: InputMaybe<PracticeHoursCreateManyPracticeInputEnvelope>;
};

export type PracticeHoursCreateOrConnectWithoutPracticeInput = {
    create: PracticeHoursCreateWithoutPracticeInput;
    where: PracticeHoursWhereUniqueInput;
};

export type PracticeHoursCreateWithoutPracticeInput = {
    closeTime: Scalars['DateTimeISO']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    dayOfWeek: DayOfWeek;
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    openTime: Scalars['DateTimeISO']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PracticeHoursGroupBy = {
    __typename?: 'PracticeHoursGroupBy';
    _avg?: Maybe<PracticeHoursAvgAggregate>;
    _count?: Maybe<PracticeHoursCountAggregate>;
    _max?: Maybe<PracticeHoursMaxAggregate>;
    _min?: Maybe<PracticeHoursMinAggregate>;
    _sum?: Maybe<PracticeHoursSumAggregate>;
    closeTime: Scalars['DateTimeISO']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    dayOfWeek: DayOfWeek;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    openTime: Scalars['DateTimeISO']['output'];
    practiceId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PracticeHoursListRelationFilter = {
    every?: InputMaybe<PracticeHoursWhereInput>;
    none?: InputMaybe<PracticeHoursWhereInput>;
    some?: InputMaybe<PracticeHoursWhereInput>;
};

export type PracticeHoursMaxAggregate = {
    __typename?: 'PracticeHoursMaxAggregate';
    closeTime?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dayOfWeek?: Maybe<DayOfWeek>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    openTime?: Maybe<Scalars['DateTimeISO']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PracticeHoursMaxOrderByAggregateInput = {
    closeTime?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PracticeHoursMinAggregate = {
    __typename?: 'PracticeHoursMinAggregate';
    closeTime?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    dayOfWeek?: Maybe<DayOfWeek>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    openTime?: Maybe<Scalars['DateTimeISO']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PracticeHoursMinOrderByAggregateInput = {
    closeTime?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PracticeHoursOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PracticeHoursOrderByWithAggregationInput = {
    _avg?: InputMaybe<PracticeHoursAvgOrderByAggregateInput>;
    _count?: InputMaybe<PracticeHoursCountOrderByAggregateInput>;
    _max?: InputMaybe<PracticeHoursMaxOrderByAggregateInput>;
    _min?: InputMaybe<PracticeHoursMinOrderByAggregateInput>;
    _sum?: InputMaybe<PracticeHoursSumOrderByAggregateInput>;
    closeTime?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    openTime?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PracticeHoursOrderByWithRelationInput = {
    closeTime?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    openTime?: InputMaybe<SortOrder>;
    practice?: InputMaybe<PracticeOrderByWithRelationInput>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PracticeHoursOverrides = {
    __typename?: 'PracticeHoursOverrides';
    closeTime?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    isClosed: Scalars['Boolean']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    openTime?: Maybe<Scalars['DateTimeISO']['output']>;
    practice: Practice;
    practiceId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PracticeHoursOverridesAvgAggregate = {
    __typename?: 'PracticeHoursOverridesAvgAggregate';
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type PracticeHoursOverridesAvgOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeHoursOverridesCountAggregate = {
    __typename?: 'PracticeHoursOverridesCountAggregate';
    _all: Scalars['Int']['output'];
    closeTime: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    deletedAt: Scalars['Int']['output'];
    isClosed: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    openTime: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PracticeHoursOverridesCountOrderByAggregateInput = {
    closeTime?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    isClosed?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PracticeHoursOverridesCreateInput = {
    closeTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isClosed?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    openTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    practice: PracticeCreateNestedOneWithoutPracticeHoursOverridesInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PracticeHoursOverridesCreateManyInput = {
    closeTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isClosed?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    openTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    practiceId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PracticeHoursOverridesCreateManyPracticeInput = {
    closeTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isClosed?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    openTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PracticeHoursOverridesCreateManyPracticeInputEnvelope = {
    data: Array<PracticeHoursOverridesCreateManyPracticeInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PracticeHoursOverridesCreateNestedManyWithoutPracticeInput = {
    connect?: InputMaybe<Array<PracticeHoursOverridesWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PracticeHoursOverridesCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<
        Array<PracticeHoursOverridesCreateWithoutPracticeInput>
    >;
    createMany?: InputMaybe<PracticeHoursOverridesCreateManyPracticeInputEnvelope>;
};

export type PracticeHoursOverridesCreateOrConnectWithoutPracticeInput = {
    create: PracticeHoursOverridesCreateWithoutPracticeInput;
    where: PracticeHoursOverridesWhereUniqueInput;
};

export type PracticeHoursOverridesCreateWithoutPracticeInput = {
    closeTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    date: Scalars['DateTimeISO']['input'];
    deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isClosed?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    openTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PracticeHoursOverridesGroupBy = {
    __typename?: 'PracticeHoursOverridesGroupBy';
    _avg?: Maybe<PracticeHoursOverridesAvgAggregate>;
    _count?: Maybe<PracticeHoursOverridesCountAggregate>;
    _max?: Maybe<PracticeHoursOverridesMaxAggregate>;
    _min?: Maybe<PracticeHoursOverridesMinAggregate>;
    _sum?: Maybe<PracticeHoursOverridesSumAggregate>;
    closeTime?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    date: Scalars['DateTimeISO']['output'];
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    isClosed: Scalars['Boolean']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    openTime?: Maybe<Scalars['DateTimeISO']['output']>;
    practiceId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PracticeHoursOverridesListRelationFilter = {
    every?: InputMaybe<PracticeHoursOverridesWhereInput>;
    none?: InputMaybe<PracticeHoursOverridesWhereInput>;
    some?: InputMaybe<PracticeHoursOverridesWhereInput>;
};

export type PracticeHoursOverridesMaxAggregate = {
    __typename?: 'PracticeHoursOverridesMaxAggregate';
    closeTime?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    isClosed?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    openTime?: Maybe<Scalars['DateTimeISO']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PracticeHoursOverridesMaxOrderByAggregateInput = {
    closeTime?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    isClosed?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PracticeHoursOverridesMinAggregate = {
    __typename?: 'PracticeHoursOverridesMinAggregate';
    closeTime?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    isClosed?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    openTime?: Maybe<Scalars['DateTimeISO']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PracticeHoursOverridesMinOrderByAggregateInput = {
    closeTime?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrder>;
    isClosed?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    openTime?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PracticeHoursOverridesOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PracticeHoursOverridesOrderByWithAggregationInput = {
    _avg?: InputMaybe<PracticeHoursOverridesAvgOrderByAggregateInput>;
    _count?: InputMaybe<PracticeHoursOverridesCountOrderByAggregateInput>;
    _max?: InputMaybe<PracticeHoursOverridesMaxOrderByAggregateInput>;
    _min?: InputMaybe<PracticeHoursOverridesMinOrderByAggregateInput>;
    _sum?: InputMaybe<PracticeHoursOverridesSumOrderByAggregateInput>;
    closeTime?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    isClosed?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    openTime?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PracticeHoursOverridesOrderByWithRelationInput = {
    closeTime?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    deletedAt?: InputMaybe<SortOrderInput>;
    isClosed?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    openTime?: InputMaybe<SortOrderInput>;
    practice?: InputMaybe<PracticeOrderByWithRelationInput>;
    practiceId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PracticeHoursOverridesPracticeIdDateCompoundUniqueInput = {
    date: Scalars['DateTimeISO']['input'];
    practiceId: Scalars['Int']['input'];
};

export enum PracticeHoursOverridesScalarFieldEnum {
    CloseTime = 'closeTime',
    CreatedAt = 'createdAt',
    Date = 'date',
    DeletedAt = 'deletedAt',
    IsClosed = 'isClosed',
    Notes = 'notes',
    OpenTime = 'openTime',
    PracticeId = 'practiceId',
    UpdatedAt = 'updatedAt',
}

export type PracticeHoursOverridesScalarWhereInput = {
    AND?: InputMaybe<Array<PracticeHoursOverridesScalarWhereInput>>;
    NOT?: InputMaybe<Array<PracticeHoursOverridesScalarWhereInput>>;
    OR?: InputMaybe<Array<PracticeHoursOverridesScalarWhereInput>>;
    closeTime?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    date?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    isClosed?: InputMaybe<BoolFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    openTime?: InputMaybe<DateTimeNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PracticeHoursOverridesScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<PracticeHoursOverridesScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<PracticeHoursOverridesScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<PracticeHoursOverridesScalarWhereWithAggregatesInput>
    >;
    closeTime?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    isClosed?: InputMaybe<BoolWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    openTime?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PracticeHoursOverridesSumAggregate = {
    __typename?: 'PracticeHoursOverridesSumAggregate';
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type PracticeHoursOverridesSumOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeHoursOverridesUpdateInput = {
    closeTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    openTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutPracticeHoursOverridesNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PracticeHoursOverridesUpdateManyMutationInput = {
    closeTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    openTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PracticeHoursOverridesUpdateManyWithWhereWithoutPracticeInput = {
    data: PracticeHoursOverridesUpdateManyMutationInput;
    where: PracticeHoursOverridesScalarWhereInput;
};

export type PracticeHoursOverridesUpdateManyWithoutPracticeNestedInput = {
    connect?: InputMaybe<Array<PracticeHoursOverridesWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PracticeHoursOverridesCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<
        Array<PracticeHoursOverridesCreateWithoutPracticeInput>
    >;
    createMany?: InputMaybe<PracticeHoursOverridesCreateManyPracticeInputEnvelope>;
    delete?: InputMaybe<Array<PracticeHoursOverridesWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PracticeHoursOverridesScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PracticeHoursOverridesWhereUniqueInput>>;
    set?: InputMaybe<Array<PracticeHoursOverridesWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PracticeHoursOverridesUpdateWithWhereUniqueWithoutPracticeInput>
    >;
    updateMany?: InputMaybe<
        Array<PracticeHoursOverridesUpdateManyWithWhereWithoutPracticeInput>
    >;
    upsert?: InputMaybe<
        Array<PracticeHoursOverridesUpsertWithWhereUniqueWithoutPracticeInput>
    >;
};

export type PracticeHoursOverridesUpdateWithWhereUniqueWithoutPracticeInput = {
    data: PracticeHoursOverridesUpdateWithoutPracticeInput;
    where: PracticeHoursOverridesWhereUniqueInput;
};

export type PracticeHoursOverridesUpdateWithoutPracticeInput = {
    closeTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    isClosed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    openTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PracticeHoursOverridesUpsertWithWhereUniqueWithoutPracticeInput = {
    create: PracticeHoursOverridesCreateWithoutPracticeInput;
    update: PracticeHoursOverridesUpdateWithoutPracticeInput;
    where: PracticeHoursOverridesWhereUniqueInput;
};

export type PracticeHoursOverridesWhereInput = {
    AND?: InputMaybe<Array<PracticeHoursOverridesWhereInput>>;
    NOT?: InputMaybe<Array<PracticeHoursOverridesWhereInput>>;
    OR?: InputMaybe<Array<PracticeHoursOverridesWhereInput>>;
    closeTime?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    date?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    isClosed?: InputMaybe<BoolFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    openTime?: InputMaybe<DateTimeNullableFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    practiceId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PracticeHoursOverridesWhereUniqueInput = {
    AND?: InputMaybe<Array<PracticeHoursOverridesWhereInput>>;
    NOT?: InputMaybe<Array<PracticeHoursOverridesWhereInput>>;
    OR?: InputMaybe<Array<PracticeHoursOverridesWhereInput>>;
    closeTime?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    date?: InputMaybe<DateTimeFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    isClosed?: InputMaybe<BoolFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    openTime?: InputMaybe<DateTimeNullableFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    practiceId?: InputMaybe<IntFilter>;
    practiceId_date?: InputMaybe<PracticeHoursOverridesPracticeIdDateCompoundUniqueInput>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PracticeHoursPracticeIdDayOfWeekCompoundUniqueInput = {
    dayOfWeek: DayOfWeek;
    practiceId: Scalars['Int']['input'];
};

export enum PracticeHoursScalarFieldEnum {
    CloseTime = 'closeTime',
    CreatedAt = 'createdAt',
    DayOfWeek = 'dayOfWeek',
    DeletedAt = 'deletedAt',
    OpenTime = 'openTime',
    PracticeId = 'practiceId',
    UpdatedAt = 'updatedAt',
}

export type PracticeHoursScalarWhereInput = {
    AND?: InputMaybe<Array<PracticeHoursScalarWhereInput>>;
    NOT?: InputMaybe<Array<PracticeHoursScalarWhereInput>>;
    OR?: InputMaybe<Array<PracticeHoursScalarWhereInput>>;
    closeTime?: InputMaybe<DateTimeFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    openTime?: InputMaybe<DateTimeFilter>;
    practiceId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PracticeHoursScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PracticeHoursScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PracticeHoursScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PracticeHoursScalarWhereWithAggregatesInput>>;
    closeTime?: InputMaybe<DateTimeWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    dayOfWeek?: InputMaybe<EnumDayOfWeekWithAggregatesFilter>;
    deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    openTime?: InputMaybe<DateTimeWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PracticeHoursSumAggregate = {
    __typename?: 'PracticeHoursSumAggregate';
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type PracticeHoursSumOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeHoursUpdateInput = {
    closeTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    openTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutPracticeHoursNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PracticeHoursUpdateManyMutationInput = {
    closeTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    openTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PracticeHoursUpdateManyWithWhereWithoutPracticeInput = {
    data: PracticeHoursUpdateManyMutationInput;
    where: PracticeHoursScalarWhereInput;
};

export type PracticeHoursUpdateManyWithoutPracticeNestedInput = {
    connect?: InputMaybe<Array<PracticeHoursWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PracticeHoursCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<Array<PracticeHoursCreateWithoutPracticeInput>>;
    createMany?: InputMaybe<PracticeHoursCreateManyPracticeInputEnvelope>;
    delete?: InputMaybe<Array<PracticeHoursWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PracticeHoursScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PracticeHoursWhereUniqueInput>>;
    set?: InputMaybe<Array<PracticeHoursWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PracticeHoursUpdateWithWhereUniqueWithoutPracticeInput>
    >;
    updateMany?: InputMaybe<
        Array<PracticeHoursUpdateManyWithWhereWithoutPracticeInput>
    >;
    upsert?: InputMaybe<
        Array<PracticeHoursUpsertWithWhereUniqueWithoutPracticeInput>
    >;
};

export type PracticeHoursUpdateWithWhereUniqueWithoutPracticeInput = {
    data: PracticeHoursUpdateWithoutPracticeInput;
    where: PracticeHoursWhereUniqueInput;
};

export type PracticeHoursUpdateWithoutPracticeInput = {
    closeTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
    deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    openTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PracticeHoursUpsertWithWhereUniqueWithoutPracticeInput = {
    create: PracticeHoursCreateWithoutPracticeInput;
    update: PracticeHoursUpdateWithoutPracticeInput;
    where: PracticeHoursWhereUniqueInput;
};

export type PracticeHoursWhereInput = {
    AND?: InputMaybe<Array<PracticeHoursWhereInput>>;
    NOT?: InputMaybe<Array<PracticeHoursWhereInput>>;
    OR?: InputMaybe<Array<PracticeHoursWhereInput>>;
    closeTime?: InputMaybe<DateTimeFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    openTime?: InputMaybe<DateTimeFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    practiceId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PracticeHoursWhereUniqueInput = {
    AND?: InputMaybe<Array<PracticeHoursWhereInput>>;
    NOT?: InputMaybe<Array<PracticeHoursWhereInput>>;
    OR?: InputMaybe<Array<PracticeHoursWhereInput>>;
    closeTime?: InputMaybe<DateTimeFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
    deletedAt?: InputMaybe<DateTimeNullableFilter>;
    openTime?: InputMaybe<DateTimeFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    practiceId?: InputMaybe<IntFilter>;
    practiceId_dayOfWeek?: InputMaybe<PracticeHoursPracticeIdDayOfWeekCompoundUniqueInput>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PracticeListRelationFilter = {
    every?: InputMaybe<PracticeWhereInput>;
    none?: InputMaybe<PracticeWhereInput>;
    some?: InputMaybe<PracticeWhereInput>;
};

export type PracticeMaxAggregate = {
    __typename?: 'PracticeMaxAggregate';
    address?: Maybe<Scalars['String']['output']>;
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    googleMapsEmbed?: Maybe<Scalars['String']['output']>;
    googleMapsUrl?: Maybe<Scalars['String']['output']>;
    isAvailableFromStorefront?: Maybe<Scalars['Boolean']['output']>;
    locationName?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    placeOfServiceCode?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
};

export type PracticeMaxOrderByAggregateInput = {
    address?: InputMaybe<SortOrder>;
    ehrLocationId?: InputMaybe<SortOrder>;
    googleMapsEmbed?: InputMaybe<SortOrder>;
    googleMapsUrl?: InputMaybe<SortOrder>;
    isAvailableFromStorefront?: InputMaybe<SortOrder>;
    locationName?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
};

export type PracticeMinAggregate = {
    __typename?: 'PracticeMinAggregate';
    address?: Maybe<Scalars['String']['output']>;
    ehrLocationId?: Maybe<Scalars['String']['output']>;
    googleMapsEmbed?: Maybe<Scalars['String']['output']>;
    googleMapsUrl?: Maybe<Scalars['String']['output']>;
    isAvailableFromStorefront?: Maybe<Scalars['Boolean']['output']>;
    locationName?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    placeOfServiceCode?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
};

export type PracticeMinOrderByAggregateInput = {
    address?: InputMaybe<SortOrder>;
    ehrLocationId?: InputMaybe<SortOrder>;
    googleMapsEmbed?: InputMaybe<SortOrder>;
    googleMapsUrl?: InputMaybe<SortOrder>;
    isAvailableFromStorefront?: InputMaybe<SortOrder>;
    locationName?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
};

export type PracticeNullableRelationFilter = {
    is?: InputMaybe<PracticeWhereInput>;
    isNot?: InputMaybe<PracticeWhereInput>;
};

export type PracticeOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PracticeOrderByWithAggregationInput = {
    _avg?: InputMaybe<PracticeAvgOrderByAggregateInput>;
    _count?: InputMaybe<PracticeCountOrderByAggregateInput>;
    _max?: InputMaybe<PracticeMaxOrderByAggregateInput>;
    _min?: InputMaybe<PracticeMinOrderByAggregateInput>;
    _sum?: InputMaybe<PracticeSumOrderByAggregateInput>;
    address?: InputMaybe<SortOrder>;
    ehrLocationId?: InputMaybe<SortOrderInput>;
    googleMapsEmbed?: InputMaybe<SortOrder>;
    googleMapsUrl?: InputMaybe<SortOrder>;
    isAvailableFromStorefront?: InputMaybe<SortOrder>;
    locationName?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrderInput>;
    placeOfServiceCode?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
};

export type PracticeOrderByWithRelationInput = {
    address?: InputMaybe<SortOrder>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigOrderByWithRelationInput>;
    defaultPractices?: InputMaybe<DefaultPracticeOrderByRelationAggregateInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskOrderByRelationAggregateInput>;
    ehrLocationId?: InputMaybe<SortOrderInput>;
    googleMapsEmbed?: InputMaybe<SortOrder>;
    googleMapsUrl?: InputMaybe<SortOrder>;
    isAvailableFromStorefront?: InputMaybe<SortOrder>;
    locationName?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    phoneNumber?: InputMaybe<SortOrderInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeOrderByWithRelationInput>;
    placeOfServiceCode?: InputMaybe<SortOrderInput>;
    practiceHours?: InputMaybe<PracticeHoursOrderByRelationAggregateInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesOrderByRelationAggregateInput>;
    practiceId?: InputMaybe<SortOrder>;
    providerGroups?: InputMaybe<ProviderGroupOrderByRelationAggregateInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigOrderByRelationAggregateInput>;
    state?: InputMaybe<SortOrder>;
    timezone?: InputMaybe<SortOrder>;
};

export type PracticeRelationFilter = {
    is?: InputMaybe<PracticeWhereInput>;
    isNot?: InputMaybe<PracticeWhereInput>;
};

export enum PracticeScalarFieldEnum {
    Address = 'address',
    EhrLocationId = 'ehrLocationId',
    GoogleMapsEmbed = 'googleMapsEmbed',
    GoogleMapsUrl = 'googleMapsUrl',
    IsAvailableFromStorefront = 'isAvailableFromStorefront',
    LocationName = 'locationName',
    Metadata = 'metadata',
    OrgId = 'orgId',
    PhoneNumber = 'phoneNumber',
    PlaceOfServiceCode = 'placeOfServiceCode',
    PracticeId = 'practiceId',
    State = 'state',
    Timezone = 'timezone',
}

export type PracticeScalarWhereInput = {
    AND?: InputMaybe<Array<PracticeScalarWhereInput>>;
    NOT?: InputMaybe<Array<PracticeScalarWhereInput>>;
    OR?: InputMaybe<Array<PracticeScalarWhereInput>>;
    address?: InputMaybe<StringFilter>;
    ehrLocationId?: InputMaybe<StringNullableFilter>;
    googleMapsEmbed?: InputMaybe<StringFilter>;
    googleMapsUrl?: InputMaybe<StringFilter>;
    isAvailableFromStorefront?: InputMaybe<BoolFilter>;
    locationName?: InputMaybe<StringFilter>;
    metadata?: InputMaybe<JsonFilter>;
    orgId?: InputMaybe<IntFilter>;
    phoneNumber?: InputMaybe<StringNullableFilter>;
    placeOfServiceCode?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    state?: InputMaybe<StringFilter>;
    timezone?: InputMaybe<StringFilter>;
};

export type PracticeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PracticeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PracticeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PracticeScalarWhereWithAggregatesInput>>;
    address?: InputMaybe<StringWithAggregatesFilter>;
    ehrLocationId?: InputMaybe<StringNullableWithAggregatesFilter>;
    googleMapsEmbed?: InputMaybe<StringWithAggregatesFilter>;
    googleMapsUrl?: InputMaybe<StringWithAggregatesFilter>;
    isAvailableFromStorefront?: InputMaybe<BoolWithAggregatesFilter>;
    locationName?: InputMaybe<StringWithAggregatesFilter>;
    metadata?: InputMaybe<JsonWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    phoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
    placeOfServiceCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
    state?: InputMaybe<StringWithAggregatesFilter>;
    timezone?: InputMaybe<StringWithAggregatesFilter>;
};

export type PracticeSumAggregate = {
    __typename?: 'PracticeSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type PracticeSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type PracticeUpdateInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigUpdateOneWithoutPracticeNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutPracticeNestedInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutPracticeNestedInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPracticesNestedInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutPracticeNestedInput>;
    practiceHours?: InputMaybe<PracticeHoursUpdateManyWithoutPracticeNestedInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesUpdateManyWithoutPracticeNestedInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroups?: InputMaybe<ProviderGroupUpdateManyWithoutPracticeNestedInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigUpdateManyWithoutPracticeNestedInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpdateManyMutationInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpdateManyWithWhereWithoutOrgInput = {
    data: PracticeUpdateManyMutationInput;
    where: PracticeScalarWhereInput;
};

export type PracticeUpdateManyWithWhereWithoutPlaceOfServiceInput = {
    data: PracticeUpdateManyMutationInput;
    where: PracticeScalarWhereInput;
};

export type PracticeUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<PracticeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<PracticeCreateOrConnectWithoutOrgInput>>;
    create?: InputMaybe<Array<PracticeCreateWithoutOrgInput>>;
    createMany?: InputMaybe<PracticeCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<PracticeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PracticeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PracticeWhereUniqueInput>>;
    set?: InputMaybe<Array<PracticeWhereUniqueInput>>;
    update?: InputMaybe<Array<PracticeUpdateWithWhereUniqueWithoutOrgInput>>;
    updateMany?: InputMaybe<Array<PracticeUpdateManyWithWhereWithoutOrgInput>>;
    upsert?: InputMaybe<Array<PracticeUpsertWithWhereUniqueWithoutOrgInput>>;
};

export type PracticeUpdateManyWithoutPlaceOfServiceNestedInput = {
    connect?: InputMaybe<Array<PracticeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PracticeCreateOrConnectWithoutPlaceOfServiceInput>
    >;
    create?: InputMaybe<Array<PracticeCreateWithoutPlaceOfServiceInput>>;
    createMany?: InputMaybe<PracticeCreateManyPlaceOfServiceInputEnvelope>;
    delete?: InputMaybe<Array<PracticeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PracticeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PracticeWhereUniqueInput>>;
    set?: InputMaybe<Array<PracticeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PracticeUpdateWithWhereUniqueWithoutPlaceOfServiceInput>
    >;
    updateMany?: InputMaybe<
        Array<PracticeUpdateManyWithWhereWithoutPlaceOfServiceInput>
    >;
    upsert?: InputMaybe<
        Array<PracticeUpsertWithWhereUniqueWithoutPlaceOfServiceInput>
    >;
};

export type PracticeUpdateOneRequiredWithoutArtPracticeConfigNestedInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutArtPracticeConfigInput>;
    create?: InputMaybe<PracticeCreateWithoutArtPracticeConfigInput>;
    update?: InputMaybe<PracticeUpdateToOneWithWhereWithoutArtPracticeConfigInput>;
    upsert?: InputMaybe<PracticeUpsertWithoutArtPracticeConfigInput>;
};

export type PracticeUpdateOneRequiredWithoutDefaultPracticesNestedInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutDefaultPracticesInput>;
    create?: InputMaybe<PracticeCreateWithoutDefaultPracticesInput>;
    update?: InputMaybe<PracticeUpdateToOneWithWhereWithoutDefaultPracticesInput>;
    upsert?: InputMaybe<PracticeUpsertWithoutDefaultPracticesInput>;
};

export type PracticeUpdateOneRequiredWithoutPracticeHoursNestedInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutPracticeHoursInput>;
    create?: InputMaybe<PracticeCreateWithoutPracticeHoursInput>;
    update?: InputMaybe<PracticeUpdateToOneWithWhereWithoutPracticeHoursInput>;
    upsert?: InputMaybe<PracticeUpsertWithoutPracticeHoursInput>;
};

export type PracticeUpdateOneRequiredWithoutPracticeHoursOverridesNestedInput =
    {
        connect?: InputMaybe<PracticeWhereUniqueInput>;
        connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutPracticeHoursOverridesInput>;
        create?: InputMaybe<PracticeCreateWithoutPracticeHoursOverridesInput>;
        update?: InputMaybe<PracticeUpdateToOneWithWhereWithoutPracticeHoursOverridesInput>;
        upsert?: InputMaybe<PracticeUpsertWithoutPracticeHoursOverridesInput>;
    };

export type PracticeUpdateOneRequiredWithoutProviderGroupsNestedInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutProviderGroupsInput>;
    create?: InputMaybe<PracticeCreateWithoutProviderGroupsInput>;
    update?: InputMaybe<PracticeUpdateToOneWithWhereWithoutProviderGroupsInput>;
    upsert?: InputMaybe<PracticeUpsertWithoutProviderGroupsInput>;
};

export type PracticeUpdateOneRequiredWithoutSchedulingSlotConfigNestedInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutSchedulingSlotConfigInput>;
    create?: InputMaybe<PracticeCreateWithoutSchedulingSlotConfigInput>;
    update?: InputMaybe<PracticeUpdateToOneWithWhereWithoutSchedulingSlotConfigInput>;
    upsert?: InputMaybe<PracticeUpsertWithoutSchedulingSlotConfigInput>;
};

export type PracticeUpdateOneWithoutDeploymentOrgTasksNestedInput = {
    connect?: InputMaybe<PracticeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PracticeCreateOrConnectWithoutDeploymentOrgTasksInput>;
    create?: InputMaybe<PracticeCreateWithoutDeploymentOrgTasksInput>;
    delete?: InputMaybe<PracticeWhereInput>;
    disconnect?: InputMaybe<PracticeWhereInput>;
    update?: InputMaybe<PracticeUpdateToOneWithWhereWithoutDeploymentOrgTasksInput>;
    upsert?: InputMaybe<PracticeUpsertWithoutDeploymentOrgTasksInput>;
};

export type PracticeUpdateToOneWithWhereWithoutArtPracticeConfigInput = {
    data: PracticeUpdateWithoutArtPracticeConfigInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpdateToOneWithWhereWithoutDefaultPracticesInput = {
    data: PracticeUpdateWithoutDefaultPracticesInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpdateToOneWithWhereWithoutDeploymentOrgTasksInput = {
    data: PracticeUpdateWithoutDeploymentOrgTasksInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpdateToOneWithWhereWithoutPracticeHoursInput = {
    data: PracticeUpdateWithoutPracticeHoursInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpdateToOneWithWhereWithoutPracticeHoursOverridesInput = {
    data: PracticeUpdateWithoutPracticeHoursOverridesInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpdateToOneWithWhereWithoutProviderGroupsInput = {
    data: PracticeUpdateWithoutProviderGroupsInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpdateToOneWithWhereWithoutSchedulingSlotConfigInput = {
    data: PracticeUpdateWithoutSchedulingSlotConfigInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpdateWithWhereUniqueWithoutOrgInput = {
    data: PracticeUpdateWithoutOrgInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeUpdateWithWhereUniqueWithoutPlaceOfServiceInput = {
    data: PracticeUpdateWithoutPlaceOfServiceInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeUpdateWithoutArtPracticeConfigInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutPracticeNestedInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutPracticeNestedInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPracticesNestedInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutPracticeNestedInput>;
    practiceHours?: InputMaybe<PracticeHoursUpdateManyWithoutPracticeNestedInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesUpdateManyWithoutPracticeNestedInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroups?: InputMaybe<ProviderGroupUpdateManyWithoutPracticeNestedInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigUpdateManyWithoutPracticeNestedInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpdateWithoutDefaultPracticesInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigUpdateOneWithoutPracticeNestedInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutPracticeNestedInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPracticesNestedInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutPracticeNestedInput>;
    practiceHours?: InputMaybe<PracticeHoursUpdateManyWithoutPracticeNestedInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesUpdateManyWithoutPracticeNestedInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroups?: InputMaybe<ProviderGroupUpdateManyWithoutPracticeNestedInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigUpdateManyWithoutPracticeNestedInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpdateWithoutDeploymentOrgTasksInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigUpdateOneWithoutPracticeNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutPracticeNestedInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPracticesNestedInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutPracticeNestedInput>;
    practiceHours?: InputMaybe<PracticeHoursUpdateManyWithoutPracticeNestedInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesUpdateManyWithoutPracticeNestedInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroups?: InputMaybe<ProviderGroupUpdateManyWithoutPracticeNestedInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigUpdateManyWithoutPracticeNestedInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpdateWithoutOrgInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigUpdateOneWithoutPracticeNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutPracticeNestedInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutPracticeNestedInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutPracticeNestedInput>;
    practiceHours?: InputMaybe<PracticeHoursUpdateManyWithoutPracticeNestedInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesUpdateManyWithoutPracticeNestedInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroups?: InputMaybe<ProviderGroupUpdateManyWithoutPracticeNestedInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigUpdateManyWithoutPracticeNestedInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpdateWithoutPlaceOfServiceInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigUpdateOneWithoutPracticeNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutPracticeNestedInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutPracticeNestedInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPracticesNestedInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceHours?: InputMaybe<PracticeHoursUpdateManyWithoutPracticeNestedInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesUpdateManyWithoutPracticeNestedInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroups?: InputMaybe<ProviderGroupUpdateManyWithoutPracticeNestedInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigUpdateManyWithoutPracticeNestedInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpdateWithoutPracticeHoursInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigUpdateOneWithoutPracticeNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutPracticeNestedInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutPracticeNestedInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPracticesNestedInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutPracticeNestedInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesUpdateManyWithoutPracticeNestedInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroups?: InputMaybe<ProviderGroupUpdateManyWithoutPracticeNestedInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigUpdateManyWithoutPracticeNestedInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpdateWithoutPracticeHoursOverridesInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigUpdateOneWithoutPracticeNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutPracticeNestedInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutPracticeNestedInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPracticesNestedInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutPracticeNestedInput>;
    practiceHours?: InputMaybe<PracticeHoursUpdateManyWithoutPracticeNestedInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroups?: InputMaybe<ProviderGroupUpdateManyWithoutPracticeNestedInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigUpdateManyWithoutPracticeNestedInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpdateWithoutProviderGroupsInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigUpdateOneWithoutPracticeNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutPracticeNestedInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutPracticeNestedInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPracticesNestedInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutPracticeNestedInput>;
    practiceHours?: InputMaybe<PracticeHoursUpdateManyWithoutPracticeNestedInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesUpdateManyWithoutPracticeNestedInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigUpdateManyWithoutPracticeNestedInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpdateWithoutSchedulingSlotConfigInput = {
    address?: InputMaybe<StringFieldUpdateOperationsInput>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigUpdateOneWithoutPracticeNestedInput>;
    defaultPractices?: InputMaybe<DefaultPracticeUpdateManyWithoutPracticeNestedInput>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskUpdateManyWithoutPracticeNestedInput>;
    ehrLocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    googleMapsEmbed?: InputMaybe<StringFieldUpdateOperationsInput>;
    googleMapsUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAvailableFromStorefront?: InputMaybe<BoolFieldUpdateOperationsInput>;
    locationName?: InputMaybe<StringFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutPracticesNestedInput>;
    phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutPracticeNestedInput>;
    practiceHours?: InputMaybe<PracticeHoursUpdateManyWithoutPracticeNestedInput>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesUpdateManyWithoutPracticeNestedInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroups?: InputMaybe<ProviderGroupUpdateManyWithoutPracticeNestedInput>;
    state?: InputMaybe<StringFieldUpdateOperationsInput>;
    timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PracticeUpsertWithWhereUniqueWithoutOrgInput = {
    create: PracticeCreateWithoutOrgInput;
    update: PracticeUpdateWithoutOrgInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeUpsertWithWhereUniqueWithoutPlaceOfServiceInput = {
    create: PracticeCreateWithoutPlaceOfServiceInput;
    update: PracticeUpdateWithoutPlaceOfServiceInput;
    where: PracticeWhereUniqueInput;
};

export type PracticeUpsertWithoutArtPracticeConfigInput = {
    create: PracticeCreateWithoutArtPracticeConfigInput;
    update: PracticeUpdateWithoutArtPracticeConfigInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpsertWithoutDefaultPracticesInput = {
    create: PracticeCreateWithoutDefaultPracticesInput;
    update: PracticeUpdateWithoutDefaultPracticesInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpsertWithoutDeploymentOrgTasksInput = {
    create: PracticeCreateWithoutDeploymentOrgTasksInput;
    update: PracticeUpdateWithoutDeploymentOrgTasksInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpsertWithoutPracticeHoursInput = {
    create: PracticeCreateWithoutPracticeHoursInput;
    update: PracticeUpdateWithoutPracticeHoursInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpsertWithoutPracticeHoursOverridesInput = {
    create: PracticeCreateWithoutPracticeHoursOverridesInput;
    update: PracticeUpdateWithoutPracticeHoursOverridesInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpsertWithoutProviderGroupsInput = {
    create: PracticeCreateWithoutProviderGroupsInput;
    update: PracticeUpdateWithoutProviderGroupsInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeUpsertWithoutSchedulingSlotConfigInput = {
    create: PracticeCreateWithoutSchedulingSlotConfigInput;
    update: PracticeUpdateWithoutSchedulingSlotConfigInput;
    where?: InputMaybe<PracticeWhereInput>;
};

export type PracticeWhereInput = {
    AND?: InputMaybe<Array<PracticeWhereInput>>;
    NOT?: InputMaybe<Array<PracticeWhereInput>>;
    OR?: InputMaybe<Array<PracticeWhereInput>>;
    address?: InputMaybe<StringFilter>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigNullableRelationFilter>;
    defaultPractices?: InputMaybe<DefaultPracticeListRelationFilter>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskListRelationFilter>;
    ehrLocationId?: InputMaybe<StringNullableFilter>;
    googleMapsEmbed?: InputMaybe<StringFilter>;
    googleMapsUrl?: InputMaybe<StringFilter>;
    isAvailableFromStorefront?: InputMaybe<BoolFilter>;
    locationName?: InputMaybe<StringFilter>;
    metadata?: InputMaybe<JsonFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    phoneNumber?: InputMaybe<StringNullableFilter>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeNullableRelationFilter>;
    placeOfServiceCode?: InputMaybe<StringNullableFilter>;
    practiceHours?: InputMaybe<PracticeHoursListRelationFilter>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesListRelationFilter>;
    practiceId?: InputMaybe<IntFilter>;
    providerGroups?: InputMaybe<ProviderGroupListRelationFilter>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigListRelationFilter>;
    state?: InputMaybe<StringFilter>;
    timezone?: InputMaybe<StringFilter>;
};

export type PracticeWhereUniqueInput = {
    AND?: InputMaybe<Array<PracticeWhereInput>>;
    NOT?: InputMaybe<Array<PracticeWhereInput>>;
    OR?: InputMaybe<Array<PracticeWhereInput>>;
    address?: InputMaybe<StringFilter>;
    artPracticeConfig?: InputMaybe<ArtPracticeConfigNullableRelationFilter>;
    defaultPractices?: InputMaybe<DefaultPracticeListRelationFilter>;
    deploymentOrgTasks?: InputMaybe<DeploymentOrgTaskListRelationFilter>;
    ehrLocationId?: InputMaybe<StringNullableFilter>;
    googleMapsEmbed?: InputMaybe<StringFilter>;
    googleMapsUrl?: InputMaybe<StringFilter>;
    isAvailableFromStorefront?: InputMaybe<BoolFilter>;
    locationName?: InputMaybe<StringFilter>;
    metadata?: InputMaybe<JsonFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    phoneNumber?: InputMaybe<StringNullableFilter>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeNullableRelationFilter>;
    placeOfServiceCode?: InputMaybe<StringNullableFilter>;
    practiceHours?: InputMaybe<PracticeHoursListRelationFilter>;
    practiceHoursOverrides?: InputMaybe<PracticeHoursOverridesListRelationFilter>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    providerGroups?: InputMaybe<ProviderGroupListRelationFilter>;
    schedulingSlotConfig?: InputMaybe<SchedulingSlotConfigListRelationFilter>;
    state?: InputMaybe<StringFilter>;
    timezone?: InputMaybe<StringFilter>;
};

export enum PriceSwapReasonEnum {
    IssueWithClaim = 'ISSUE_WITH_CLAIM',
    NoClaim = 'NO_CLAIM',
    NoShowFee = 'NO_SHOW_FEE',
    Other = 'OTHER',
}

export type PricedTreatment = {
    __typename?: 'PricedTreatment';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrt: Hrt;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    metadata?: Maybe<Scalars['JSON']['output']>;
    paymentType: PaymentType;
    price: Scalars['Int']['output'];
    pricingAttempt?: Maybe<PricingAttempt>;
    pricingAttemptId?: Maybe<Scalars['Int']['output']>;
    pricingEntityIds: Array<Scalars['String']['output']>;
    requestId?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PricedTreatmentPricingAttemptArgs = {
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type PricedTreatmentAvgAggregate = {
    __typename?: 'PricedTreatmentAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    price?: Maybe<Scalars['Float']['output']>;
    pricingAttemptId?: Maybe<Scalars['Float']['output']>;
};

export type PricedTreatmentAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricingAttemptId?: InputMaybe<SortOrder>;
};

export type PricedTreatmentCountAggregate = {
    __typename?: 'PricedTreatmentCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    metadata: Scalars['Int']['output'];
    paymentType: Scalars['Int']['output'];
    price: Scalars['Int']['output'];
    pricingAttemptId: Scalars['Int']['output'];
    pricingEntityIds: Scalars['Int']['output'];
    requestId: Scalars['Int']['output'];
    transactionId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PricedTreatmentCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricingAttemptId?: InputMaybe<SortOrder>;
    pricingEntityIds?: InputMaybe<SortOrder>;
    requestId?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricedTreatmentCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutPricedTreatmentInput;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentType?: InputMaybe<PaymentType>;
    price: Scalars['Int']['input'];
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedOneWithoutPricedTreatmentInput>;
    pricingEntityIds?: InputMaybe<PricedTreatmentCreatepricingEntityIdsInput>;
    requestId?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricedTreatmentCreateManyHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentType?: InputMaybe<PaymentType>;
    price: Scalars['Int']['input'];
    pricingAttemptId?: InputMaybe<Scalars['Int']['input']>;
    pricingEntityIds?: InputMaybe<PricedTreatmentCreatepricingEntityIdsInput>;
    requestId?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricedTreatmentCreateManyHrtInputEnvelope = {
    data: Array<PricedTreatmentCreateManyHrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricedTreatmentCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentType?: InputMaybe<PaymentType>;
    price: Scalars['Int']['input'];
    pricingAttemptId?: InputMaybe<Scalars['Int']['input']>;
    pricingEntityIds?: InputMaybe<PricedTreatmentCreatepricingEntityIdsInput>;
    requestId?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricedTreatmentCreateManyPricingAttemptInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentType?: InputMaybe<PaymentType>;
    price: Scalars['Int']['input'];
    pricingEntityIds?: InputMaybe<PricedTreatmentCreatepricingEntityIdsInput>;
    requestId?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricedTreatmentCreateManyPricingAttemptInputEnvelope = {
    data: Array<PricedTreatmentCreateManyPricingAttemptInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricedTreatmentCreateNestedManyWithoutHrtInput = {
    connect?: InputMaybe<Array<PricedTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PricedTreatmentCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<PricedTreatmentCreateWithoutHrtInput>>;
    createMany?: InputMaybe<PricedTreatmentCreateManyHrtInputEnvelope>;
};

export type PricedTreatmentCreateNestedManyWithoutPricingAttemptInput = {
    connect?: InputMaybe<Array<PricedTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PricedTreatmentCreateOrConnectWithoutPricingAttemptInput>
    >;
    create?: InputMaybe<Array<PricedTreatmentCreateWithoutPricingAttemptInput>>;
    createMany?: InputMaybe<PricedTreatmentCreateManyPricingAttemptInputEnvelope>;
};

export type PricedTreatmentCreateOrConnectWithoutHrtInput = {
    create: PricedTreatmentCreateWithoutHrtInput;
    where: PricedTreatmentWhereUniqueInput;
};

export type PricedTreatmentCreateOrConnectWithoutPricingAttemptInput = {
    create: PricedTreatmentCreateWithoutPricingAttemptInput;
    where: PricedTreatmentWhereUniqueInput;
};

export type PricedTreatmentCreateWithoutHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentType?: InputMaybe<PaymentType>;
    price: Scalars['Int']['input'];
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedOneWithoutPricedTreatmentInput>;
    pricingEntityIds?: InputMaybe<PricedTreatmentCreatepricingEntityIdsInput>;
    requestId?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricedTreatmentCreateWithoutPricingAttemptInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutPricedTreatmentInput;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentType?: InputMaybe<PaymentType>;
    price: Scalars['Int']['input'];
    pricingEntityIds?: InputMaybe<PricedTreatmentCreatepricingEntityIdsInput>;
    requestId?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricedTreatmentCreatepricingEntityIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type PricedTreatmentGroupBy = {
    __typename?: 'PricedTreatmentGroupBy';
    _avg?: Maybe<PricedTreatmentAvgAggregate>;
    _count?: Maybe<PricedTreatmentCountAggregate>;
    _max?: Maybe<PricedTreatmentMaxAggregate>;
    _min?: Maybe<PricedTreatmentMinAggregate>;
    _sum?: Maybe<PricedTreatmentSumAggregate>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    metadata?: Maybe<Scalars['JSON']['output']>;
    paymentType: PaymentType;
    price: Scalars['Int']['output'];
    pricingAttemptId?: Maybe<Scalars['Int']['output']>;
    pricingEntityIds?: Maybe<Array<Scalars['String']['output']>>;
    requestId?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PricedTreatmentListRelationFilter = {
    every?: InputMaybe<PricedTreatmentWhereInput>;
    none?: InputMaybe<PricedTreatmentWhereInput>;
    some?: InputMaybe<PricedTreatmentWhereInput>;
};

export type PricedTreatmentMaxAggregate = {
    __typename?: 'PricedTreatmentMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    paymentType?: Maybe<PaymentType>;
    price?: Maybe<Scalars['Int']['output']>;
    pricingAttemptId?: Maybe<Scalars['Int']['output']>;
    requestId?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PricedTreatmentMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricingAttemptId?: InputMaybe<SortOrder>;
    requestId?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricedTreatmentMinAggregate = {
    __typename?: 'PricedTreatmentMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    paymentType?: Maybe<PaymentType>;
    price?: Maybe<Scalars['Int']['output']>;
    pricingAttemptId?: Maybe<Scalars['Int']['output']>;
    requestId?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PricedTreatmentMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    paymentType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricingAttemptId?: InputMaybe<SortOrder>;
    requestId?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricedTreatmentOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PricedTreatmentOrderByWithAggregationInput = {
    _avg?: InputMaybe<PricedTreatmentAvgOrderByAggregateInput>;
    _count?: InputMaybe<PricedTreatmentCountOrderByAggregateInput>;
    _max?: InputMaybe<PricedTreatmentMaxOrderByAggregateInput>;
    _min?: InputMaybe<PricedTreatmentMinOrderByAggregateInput>;
    _sum?: InputMaybe<PricedTreatmentSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrderInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrderInput>;
    paymentType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricingAttemptId?: InputMaybe<SortOrderInput>;
    pricingEntityIds?: InputMaybe<SortOrder>;
    requestId?: InputMaybe<SortOrderInput>;
    transactionId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export type PricedTreatmentOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrderInput>;
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    metadata?: InputMaybe<SortOrderInput>;
    paymentType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricingAttempt?: InputMaybe<PricingAttemptOrderByWithRelationInput>;
    pricingAttemptId?: InputMaybe<SortOrderInput>;
    pricingEntityIds?: InputMaybe<SortOrder>;
    requestId?: InputMaybe<SortOrderInput>;
    transactionId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export enum PricedTreatmentScalarFieldEnum {
    CreatedAt = 'createdAt',
    HrtId = 'hrtId',
    Id = 'id',
    Metadata = 'metadata',
    PaymentType = 'paymentType',
    Price = 'price',
    PricingAttemptId = 'pricingAttemptId',
    PricingEntityIds = 'pricingEntityIds',
    RequestId = 'requestId',
    TransactionId = 'transactionId',
    UpdatedAt = 'updatedAt',
}

export type PricedTreatmentScalarWhereInput = {
    AND?: InputMaybe<Array<PricedTreatmentScalarWhereInput>>;
    NOT?: InputMaybe<Array<PricedTreatmentScalarWhereInput>>;
    OR?: InputMaybe<Array<PricedTreatmentScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeFilter>;
    price?: InputMaybe<IntFilter>;
    pricingAttemptId?: InputMaybe<IntNullableFilter>;
    pricingEntityIds?: InputMaybe<StringNullableListFilter>;
    requestId?: InputMaybe<StringNullableFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PricedTreatmentScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PricedTreatmentScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PricedTreatmentScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PricedTreatmentScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeWithAggregatesFilter>;
    price?: InputMaybe<IntWithAggregatesFilter>;
    pricingAttemptId?: InputMaybe<IntNullableWithAggregatesFilter>;
    pricingEntityIds?: InputMaybe<StringNullableListFilter>;
    requestId?: InputMaybe<StringNullableWithAggregatesFilter>;
    transactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type PricedTreatmentSumAggregate = {
    __typename?: 'PricedTreatmentSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    price?: Maybe<Scalars['Int']['output']>;
    pricingAttemptId?: Maybe<Scalars['Int']['output']>;
};

export type PricedTreatmentSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    pricingAttemptId?: InputMaybe<SortOrder>;
};

export type PricedTreatmentUpdateInput = {
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutPricedTreatmentNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
    price?: InputMaybe<IntFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateOneWithoutPricedTreatmentNestedInput>;
    pricingEntityIds?: InputMaybe<PricedTreatmentUpdatepricingEntityIdsInput>;
    requestId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PricedTreatmentUpdateManyMutationInput = {
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
    price?: InputMaybe<IntFieldUpdateOperationsInput>;
    pricingEntityIds?: InputMaybe<PricedTreatmentUpdatepricingEntityIdsInput>;
    requestId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PricedTreatmentUpdateManyWithWhereWithoutHrtInput = {
    data: PricedTreatmentUpdateManyMutationInput;
    where: PricedTreatmentScalarWhereInput;
};

export type PricedTreatmentUpdateManyWithWhereWithoutPricingAttemptInput = {
    data: PricedTreatmentUpdateManyMutationInput;
    where: PricedTreatmentScalarWhereInput;
};

export type PricedTreatmentUpdateManyWithoutHrtNestedInput = {
    connect?: InputMaybe<Array<PricedTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PricedTreatmentCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<PricedTreatmentCreateWithoutHrtInput>>;
    createMany?: InputMaybe<PricedTreatmentCreateManyHrtInputEnvelope>;
    delete?: InputMaybe<Array<PricedTreatmentWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PricedTreatmentScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PricedTreatmentWhereUniqueInput>>;
    set?: InputMaybe<Array<PricedTreatmentWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PricedTreatmentUpdateWithWhereUniqueWithoutHrtInput>
    >;
    updateMany?: InputMaybe<
        Array<PricedTreatmentUpdateManyWithWhereWithoutHrtInput>
    >;
    upsert?: InputMaybe<
        Array<PricedTreatmentUpsertWithWhereUniqueWithoutHrtInput>
    >;
};

export type PricedTreatmentUpdateManyWithoutPricingAttemptNestedInput = {
    connect?: InputMaybe<Array<PricedTreatmentWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PricedTreatmentCreateOrConnectWithoutPricingAttemptInput>
    >;
    create?: InputMaybe<Array<PricedTreatmentCreateWithoutPricingAttemptInput>>;
    createMany?: InputMaybe<PricedTreatmentCreateManyPricingAttemptInputEnvelope>;
    delete?: InputMaybe<Array<PricedTreatmentWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PricedTreatmentScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PricedTreatmentWhereUniqueInput>>;
    set?: InputMaybe<Array<PricedTreatmentWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PricedTreatmentUpdateWithWhereUniqueWithoutPricingAttemptInput>
    >;
    updateMany?: InputMaybe<
        Array<PricedTreatmentUpdateManyWithWhereWithoutPricingAttemptInput>
    >;
    upsert?: InputMaybe<
        Array<PricedTreatmentUpsertWithWhereUniqueWithoutPricingAttemptInput>
    >;
};

export type PricedTreatmentUpdateWithWhereUniqueWithoutHrtInput = {
    data: PricedTreatmentUpdateWithoutHrtInput;
    where: PricedTreatmentWhereUniqueInput;
};

export type PricedTreatmentUpdateWithWhereUniqueWithoutPricingAttemptInput = {
    data: PricedTreatmentUpdateWithoutPricingAttemptInput;
    where: PricedTreatmentWhereUniqueInput;
};

export type PricedTreatmentUpdateWithoutHrtInput = {
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
    price?: InputMaybe<IntFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateOneWithoutPricedTreatmentNestedInput>;
    pricingEntityIds?: InputMaybe<PricedTreatmentUpdatepricingEntityIdsInput>;
    requestId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PricedTreatmentUpdateWithoutPricingAttemptInput = {
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutPricedTreatmentNestedInput>;
    metadata?: InputMaybe<Scalars['JSON']['input']>;
    paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
    price?: InputMaybe<IntFieldUpdateOperationsInput>;
    pricingEntityIds?: InputMaybe<PricedTreatmentUpdatepricingEntityIdsInput>;
    requestId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PricedTreatmentUpdatepricingEntityIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PricedTreatmentUpsertWithWhereUniqueWithoutHrtInput = {
    create: PricedTreatmentCreateWithoutHrtInput;
    update: PricedTreatmentUpdateWithoutHrtInput;
    where: PricedTreatmentWhereUniqueInput;
};

export type PricedTreatmentUpsertWithWhereUniqueWithoutPricingAttemptInput = {
    create: PricedTreatmentCreateWithoutPricingAttemptInput;
    update: PricedTreatmentUpdateWithoutPricingAttemptInput;
    where: PricedTreatmentWhereUniqueInput;
};

export type PricedTreatmentWhereInput = {
    AND?: InputMaybe<Array<PricedTreatmentWhereInput>>;
    NOT?: InputMaybe<Array<PricedTreatmentWhereInput>>;
    OR?: InputMaybe<Array<PricedTreatmentWhereInput>>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    metadata?: InputMaybe<JsonNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeFilter>;
    price?: InputMaybe<IntFilter>;
    pricingAttempt?: InputMaybe<PricingAttemptNullableRelationFilter>;
    pricingAttemptId?: InputMaybe<IntNullableFilter>;
    pricingEntityIds?: InputMaybe<StringNullableListFilter>;
    requestId?: InputMaybe<StringNullableFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PricedTreatmentWhereUniqueInput = {
    AND?: InputMaybe<Array<PricedTreatmentWhereInput>>;
    NOT?: InputMaybe<Array<PricedTreatmentWhereInput>>;
    OR?: InputMaybe<Array<PricedTreatmentWhereInput>>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    metadata?: InputMaybe<JsonNullableFilter>;
    paymentType?: InputMaybe<EnumPaymentTypeFilter>;
    price?: InputMaybe<IntFilter>;
    pricingAttempt?: InputMaybe<PricingAttemptNullableRelationFilter>;
    pricingAttemptId?: InputMaybe<IntNullableFilter>;
    pricingEntityIds?: InputMaybe<StringNullableListFilter>;
    requestId?: InputMaybe<StringNullableFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PricingAttempt = {
    __typename?: 'PricingAttempt';
    _count?: Maybe<PricingAttemptCount>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrt: Hrt;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    pricedTreatment: Array<PricedTreatment>;
    pricingCallId: Scalars['Int']['output'];
    pricingResults: PricingResults;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PricingAttemptPricedTreatmentArgs = {
    cursor?: InputMaybe<PricedTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricedTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricedTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type PricingAttemptAvgAggregate = {
    __typename?: 'PricingAttemptAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    pricingCallId?: Maybe<Scalars['Float']['output']>;
};

export type PricingAttemptAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
};

export type PricingAttemptCount = {
    __typename?: 'PricingAttemptCount';
    pricedTreatment: Scalars['Int']['output'];
};

export type PricingAttemptCountPricedTreatmentArgs = {
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type PricingAttemptCountAggregate = {
    __typename?: 'PricingAttemptCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    pricingCallId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PricingAttemptCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricingAttemptCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutPricingAttemptInput;
    pricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutPricingAttemptInput>;
    pricingResults: PricingResultsCreateNestedOneWithoutPricingAttemptInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricingAttemptCreateManyHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    pricingCallId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricingAttemptCreateManyHrtInputEnvelope = {
    data: Array<PricingAttemptCreateManyHrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricingAttemptCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    pricingCallId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricingAttemptCreateManyPricingResultsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricingAttemptCreateManyPricingResultsInputEnvelope = {
    data: Array<PricingAttemptCreateManyPricingResultsInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricingAttemptCreateNestedManyWithoutHrtInput = {
    connect?: InputMaybe<Array<PricingAttemptWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PricingAttemptCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<PricingAttemptCreateWithoutHrtInput>>;
    createMany?: InputMaybe<PricingAttemptCreateManyHrtInputEnvelope>;
};

export type PricingAttemptCreateNestedManyWithoutPricingResultsInput = {
    connect?: InputMaybe<Array<PricingAttemptWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PricingAttemptCreateOrConnectWithoutPricingResultsInput>
    >;
    create?: InputMaybe<Array<PricingAttemptCreateWithoutPricingResultsInput>>;
    createMany?: InputMaybe<PricingAttemptCreateManyPricingResultsInputEnvelope>;
};

export type PricingAttemptCreateNestedOneWithoutPricedTreatmentInput = {
    connect?: InputMaybe<PricingAttemptWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PricingAttemptCreateOrConnectWithoutPricedTreatmentInput>;
    create?: InputMaybe<PricingAttemptCreateWithoutPricedTreatmentInput>;
};

export type PricingAttemptCreateOrConnectWithoutHrtInput = {
    create: PricingAttemptCreateWithoutHrtInput;
    where: PricingAttemptWhereUniqueInput;
};

export type PricingAttemptCreateOrConnectWithoutPricedTreatmentInput = {
    create: PricingAttemptCreateWithoutPricedTreatmentInput;
    where: PricingAttemptWhereUniqueInput;
};

export type PricingAttemptCreateOrConnectWithoutPricingResultsInput = {
    create: PricingAttemptCreateWithoutPricingResultsInput;
    where: PricingAttemptWhereUniqueInput;
};

export type PricingAttemptCreateWithoutHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    pricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutPricingAttemptInput>;
    pricingResults: PricingResultsCreateNestedOneWithoutPricingAttemptInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricingAttemptCreateWithoutPricedTreatmentInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutPricingAttemptInput;
    pricingResults: PricingResultsCreateNestedOneWithoutPricingAttemptInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricingAttemptCreateWithoutPricingResultsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutPricingAttemptInput;
    pricedTreatment?: InputMaybe<PricedTreatmentCreateNestedManyWithoutPricingAttemptInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricingAttemptGroupBy = {
    __typename?: 'PricingAttemptGroupBy';
    _avg?: Maybe<PricingAttemptAvgAggregate>;
    _count?: Maybe<PricingAttemptCountAggregate>;
    _max?: Maybe<PricingAttemptMaxAggregate>;
    _min?: Maybe<PricingAttemptMinAggregate>;
    _sum?: Maybe<PricingAttemptSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    pricingCallId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PricingAttemptListRelationFilter = {
    every?: InputMaybe<PricingAttemptWhereInput>;
    none?: InputMaybe<PricingAttemptWhereInput>;
    some?: InputMaybe<PricingAttemptWhereInput>;
};

export type PricingAttemptMaxAggregate = {
    __typename?: 'PricingAttemptMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    pricingCallId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PricingAttemptMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricingAttemptMinAggregate = {
    __typename?: 'PricingAttemptMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    pricingCallId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PricingAttemptMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricingAttemptNullableRelationFilter = {
    is?: InputMaybe<PricingAttemptWhereInput>;
    isNot?: InputMaybe<PricingAttemptWhereInput>;
};

export type PricingAttemptOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type PricingAttemptOrderByWithAggregationInput = {
    _avg?: InputMaybe<PricingAttemptAvgOrderByAggregateInput>;
    _count?: InputMaybe<PricingAttemptCountOrderByAggregateInput>;
    _max?: InputMaybe<PricingAttemptMaxOrderByAggregateInput>;
    _min?: InputMaybe<PricingAttemptMinOrderByAggregateInput>;
    _sum?: InputMaybe<PricingAttemptSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricingAttemptOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricedTreatment?: InputMaybe<PricedTreatmentOrderByRelationAggregateInput>;
    pricingCallId?: InputMaybe<SortOrder>;
    pricingResults?: InputMaybe<PricingResultsOrderByWithRelationInput>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PricingAttemptScalarFieldEnum {
    CreatedAt = 'createdAt',
    HrtId = 'hrtId',
    Id = 'id',
    PricingCallId = 'pricingCallId',
    UpdatedAt = 'updatedAt',
}

export type PricingAttemptScalarWhereInput = {
    AND?: InputMaybe<Array<PricingAttemptScalarWhereInput>>;
    NOT?: InputMaybe<Array<PricingAttemptScalarWhereInput>>;
    OR?: InputMaybe<Array<PricingAttemptScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    pricingCallId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PricingAttemptScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PricingAttemptScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PricingAttemptScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PricingAttemptScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    pricingCallId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PricingAttemptSumAggregate = {
    __typename?: 'PricingAttemptSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    pricingCallId?: Maybe<Scalars['Int']['output']>;
};

export type PricingAttemptSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
};

export type PricingAttemptUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutPricingAttemptNestedInput>;
    pricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutPricingAttemptNestedInput>;
    pricingResults?: InputMaybe<PricingResultsUpdateOneRequiredWithoutPricingAttemptNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PricingAttemptUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PricingAttemptUpdateManyWithWhereWithoutHrtInput = {
    data: PricingAttemptUpdateManyMutationInput;
    where: PricingAttemptScalarWhereInput;
};

export type PricingAttemptUpdateManyWithWhereWithoutPricingResultsInput = {
    data: PricingAttemptUpdateManyMutationInput;
    where: PricingAttemptScalarWhereInput;
};

export type PricingAttemptUpdateManyWithoutHrtNestedInput = {
    connect?: InputMaybe<Array<PricingAttemptWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PricingAttemptCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<PricingAttemptCreateWithoutHrtInput>>;
    createMany?: InputMaybe<PricingAttemptCreateManyHrtInputEnvelope>;
    delete?: InputMaybe<Array<PricingAttemptWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PricingAttemptScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PricingAttemptWhereUniqueInput>>;
    set?: InputMaybe<Array<PricingAttemptWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PricingAttemptUpdateWithWhereUniqueWithoutHrtInput>
    >;
    updateMany?: InputMaybe<
        Array<PricingAttemptUpdateManyWithWhereWithoutHrtInput>
    >;
    upsert?: InputMaybe<
        Array<PricingAttemptUpsertWithWhereUniqueWithoutHrtInput>
    >;
};

export type PricingAttemptUpdateManyWithoutPricingResultsNestedInput = {
    connect?: InputMaybe<Array<PricingAttemptWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<PricingAttemptCreateOrConnectWithoutPricingResultsInput>
    >;
    create?: InputMaybe<Array<PricingAttemptCreateWithoutPricingResultsInput>>;
    createMany?: InputMaybe<PricingAttemptCreateManyPricingResultsInputEnvelope>;
    delete?: InputMaybe<Array<PricingAttemptWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<PricingAttemptScalarWhereInput>>;
    disconnect?: InputMaybe<Array<PricingAttemptWhereUniqueInput>>;
    set?: InputMaybe<Array<PricingAttemptWhereUniqueInput>>;
    update?: InputMaybe<
        Array<PricingAttemptUpdateWithWhereUniqueWithoutPricingResultsInput>
    >;
    updateMany?: InputMaybe<
        Array<PricingAttemptUpdateManyWithWhereWithoutPricingResultsInput>
    >;
    upsert?: InputMaybe<
        Array<PricingAttemptUpsertWithWhereUniqueWithoutPricingResultsInput>
    >;
};

export type PricingAttemptUpdateOneWithoutPricedTreatmentNestedInput = {
    connect?: InputMaybe<PricingAttemptWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PricingAttemptCreateOrConnectWithoutPricedTreatmentInput>;
    create?: InputMaybe<PricingAttemptCreateWithoutPricedTreatmentInput>;
    delete?: InputMaybe<PricingAttemptWhereInput>;
    disconnect?: InputMaybe<PricingAttemptWhereInput>;
    update?: InputMaybe<PricingAttemptUpdateToOneWithWhereWithoutPricedTreatmentInput>;
    upsert?: InputMaybe<PricingAttemptUpsertWithoutPricedTreatmentInput>;
};

export type PricingAttemptUpdateToOneWithWhereWithoutPricedTreatmentInput = {
    data: PricingAttemptUpdateWithoutPricedTreatmentInput;
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type PricingAttemptUpdateWithWhereUniqueWithoutHrtInput = {
    data: PricingAttemptUpdateWithoutHrtInput;
    where: PricingAttemptWhereUniqueInput;
};

export type PricingAttemptUpdateWithWhereUniqueWithoutPricingResultsInput = {
    data: PricingAttemptUpdateWithoutPricingResultsInput;
    where: PricingAttemptWhereUniqueInput;
};

export type PricingAttemptUpdateWithoutHrtInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    pricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutPricingAttemptNestedInput>;
    pricingResults?: InputMaybe<PricingResultsUpdateOneRequiredWithoutPricingAttemptNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PricingAttemptUpdateWithoutPricedTreatmentInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutPricingAttemptNestedInput>;
    pricingResults?: InputMaybe<PricingResultsUpdateOneRequiredWithoutPricingAttemptNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PricingAttemptUpdateWithoutPricingResultsInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutPricingAttemptNestedInput>;
    pricedTreatment?: InputMaybe<PricedTreatmentUpdateManyWithoutPricingAttemptNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PricingAttemptUpsertWithWhereUniqueWithoutHrtInput = {
    create: PricingAttemptCreateWithoutHrtInput;
    update: PricingAttemptUpdateWithoutHrtInput;
    where: PricingAttemptWhereUniqueInput;
};

export type PricingAttemptUpsertWithWhereUniqueWithoutPricingResultsInput = {
    create: PricingAttemptCreateWithoutPricingResultsInput;
    update: PricingAttemptUpdateWithoutPricingResultsInput;
    where: PricingAttemptWhereUniqueInput;
};

export type PricingAttemptUpsertWithoutPricedTreatmentInput = {
    create: PricingAttemptCreateWithoutPricedTreatmentInput;
    update: PricingAttemptUpdateWithoutPricedTreatmentInput;
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type PricingAttemptWhereInput = {
    AND?: InputMaybe<Array<PricingAttemptWhereInput>>;
    NOT?: InputMaybe<Array<PricingAttemptWhereInput>>;
    OR?: InputMaybe<Array<PricingAttemptWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    pricedTreatment?: InputMaybe<PricedTreatmentListRelationFilter>;
    pricingCallId?: InputMaybe<IntFilter>;
    pricingResults?: InputMaybe<PricingResultsRelationFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PricingAttemptWhereUniqueInput = {
    AND?: InputMaybe<Array<PricingAttemptWhereInput>>;
    NOT?: InputMaybe<Array<PricingAttemptWhereInput>>;
    OR?: InputMaybe<Array<PricingAttemptWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    pricedTreatment?: InputMaybe<PricedTreatmentListRelationFilter>;
    pricingCallId?: InputMaybe<IntFilter>;
    pricingResults?: InputMaybe<PricingResultsRelationFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PricingEscalator = {
    __typename?: 'PricingEscalator';
    id: Scalars['Int']['output'];
    insuredFee: Scalars['Decimal']['output'];
    milestoneProcessed: Scalars['Decimal']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    uninsuredFee: Scalars['Decimal']['output'];
};

export type PricingEscalatorAvgAggregate = {
    __typename?: 'PricingEscalatorAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    insuredFee?: Maybe<Scalars['Decimal']['output']>;
    milestoneProcessed?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    uninsuredFee?: Maybe<Scalars['Decimal']['output']>;
};

export type PricingEscalatorAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    insuredFee?: InputMaybe<SortOrder>;
    milestoneProcessed?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    uninsuredFee?: InputMaybe<SortOrder>;
};

export type PricingEscalatorCountAggregate = {
    __typename?: 'PricingEscalatorCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    insuredFee: Scalars['Int']['output'];
    milestoneProcessed: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    uninsuredFee: Scalars['Int']['output'];
};

export type PricingEscalatorCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    insuredFee?: InputMaybe<SortOrder>;
    milestoneProcessed?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    uninsuredFee?: InputMaybe<SortOrder>;
};

export type PricingEscalatorCreateInput = {
    insuredFee: Scalars['Decimal']['input'];
    milestoneProcessed: Scalars['Decimal']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    uninsuredFee: Scalars['Decimal']['input'];
};

export type PricingEscalatorCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    insuredFee: Scalars['Decimal']['input'];
    milestoneProcessed: Scalars['Decimal']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    uninsuredFee: Scalars['Decimal']['input'];
};

export type PricingEscalatorGroupBy = {
    __typename?: 'PricingEscalatorGroupBy';
    _avg?: Maybe<PricingEscalatorAvgAggregate>;
    _count?: Maybe<PricingEscalatorCountAggregate>;
    _max?: Maybe<PricingEscalatorMaxAggregate>;
    _min?: Maybe<PricingEscalatorMinAggregate>;
    _sum?: Maybe<PricingEscalatorSumAggregate>;
    id: Scalars['Int']['output'];
    insuredFee: Scalars['Decimal']['output'];
    milestoneProcessed: Scalars['Decimal']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    uninsuredFee: Scalars['Decimal']['output'];
};

export type PricingEscalatorMaxAggregate = {
    __typename?: 'PricingEscalatorMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    insuredFee?: Maybe<Scalars['Decimal']['output']>;
    milestoneProcessed?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    uninsuredFee?: Maybe<Scalars['Decimal']['output']>;
};

export type PricingEscalatorMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    insuredFee?: InputMaybe<SortOrder>;
    milestoneProcessed?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    uninsuredFee?: InputMaybe<SortOrder>;
};

export type PricingEscalatorMinAggregate = {
    __typename?: 'PricingEscalatorMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    insuredFee?: Maybe<Scalars['Decimal']['output']>;
    milestoneProcessed?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    uninsuredFee?: Maybe<Scalars['Decimal']['output']>;
};

export type PricingEscalatorMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    insuredFee?: InputMaybe<SortOrder>;
    milestoneProcessed?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    uninsuredFee?: InputMaybe<SortOrder>;
};

export type PricingEscalatorOrderByWithAggregationInput = {
    _avg?: InputMaybe<PricingEscalatorAvgOrderByAggregateInput>;
    _count?: InputMaybe<PricingEscalatorCountOrderByAggregateInput>;
    _max?: InputMaybe<PricingEscalatorMaxOrderByAggregateInput>;
    _min?: InputMaybe<PricingEscalatorMinOrderByAggregateInput>;
    _sum?: InputMaybe<PricingEscalatorSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    insuredFee?: InputMaybe<SortOrder>;
    milestoneProcessed?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    uninsuredFee?: InputMaybe<SortOrder>;
};

export type PricingEscalatorOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    insuredFee?: InputMaybe<SortOrder>;
    milestoneProcessed?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    uninsuredFee?: InputMaybe<SortOrder>;
};

export enum PricingEscalatorScalarFieldEnum {
    Id = 'id',
    InsuredFee = 'insuredFee',
    MilestoneProcessed = 'milestoneProcessed',
    OrgId = 'orgId',
    UninsuredFee = 'uninsuredFee',
}

export type PricingEscalatorScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PricingEscalatorScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PricingEscalatorScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PricingEscalatorScalarWhereWithAggregatesInput>>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    insuredFee?: InputMaybe<DecimalWithAggregatesFilter>;
    milestoneProcessed?: InputMaybe<DecimalWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    uninsuredFee?: InputMaybe<DecimalWithAggregatesFilter>;
};

export type PricingEscalatorSumAggregate = {
    __typename?: 'PricingEscalatorSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    insuredFee?: Maybe<Scalars['Decimal']['output']>;
    milestoneProcessed?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    uninsuredFee?: Maybe<Scalars['Decimal']['output']>;
};

export type PricingEscalatorSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    insuredFee?: InputMaybe<SortOrder>;
    milestoneProcessed?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    uninsuredFee?: InputMaybe<SortOrder>;
};

export type PricingEscalatorUpdateInput = {
    insuredFee?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    milestoneProcessed?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    uninsuredFee?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type PricingEscalatorUpdateManyMutationInput = {
    insuredFee?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    milestoneProcessed?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    uninsuredFee?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type PricingEscalatorWhereInput = {
    AND?: InputMaybe<Array<PricingEscalatorWhereInput>>;
    NOT?: InputMaybe<Array<PricingEscalatorWhereInput>>;
    OR?: InputMaybe<Array<PricingEscalatorWhereInput>>;
    id?: InputMaybe<IntFilter>;
    insuredFee?: InputMaybe<DecimalFilter>;
    milestoneProcessed?: InputMaybe<DecimalFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    uninsuredFee?: InputMaybe<DecimalFilter>;
};

export type PricingEscalatorWhereUniqueInput = {
    AND?: InputMaybe<Array<PricingEscalatorWhereInput>>;
    NOT?: InputMaybe<Array<PricingEscalatorWhereInput>>;
    OR?: InputMaybe<Array<PricingEscalatorWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    insuredFee?: InputMaybe<DecimalFilter>;
    milestoneProcessed?: InputMaybe<DecimalFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    uninsuredFee?: InputMaybe<DecimalFilter>;
};

export type PricingQueue = {
    __typename?: 'PricingQueue';
    applyAttempts: Scalars['Int']['output'];
    applyEligibleAfter: Scalars['DateTimeISO']['output'];
    applyFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    applyHandler: Scalars['String']['output'];
    applyLocked: Scalars['Boolean']['output'];
    applyStartedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    applySucceededAt?: Maybe<Scalars['DateTimeISO']['output']>;
    appointmentAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    intentId?: Maybe<Scalars['String']['output']>;
    processAttempts: Scalars['Int']['output'];
    processEligibleAfter: Scalars['DateTimeISO']['output'];
    processFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    processStartedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    processSucceededAt?: Maybe<Scalars['DateTimeISO']['output']>;
    request: Scalars['JSON']['output'];
    response?: Maybe<Scalars['JSON']['output']>;
    status: TaskStatus;
    type: TaskType;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PricingQueueAvgAggregate = {
    __typename?: 'PricingQueueAvgAggregate';
    applyAttempts?: Maybe<Scalars['Float']['output']>;
    processAttempts?: Maybe<Scalars['Float']['output']>;
};

export type PricingQueueAvgOrderByAggregateInput = {
    applyAttempts?: InputMaybe<SortOrder>;
    processAttempts?: InputMaybe<SortOrder>;
};

export type PricingQueueCountAggregate = {
    __typename?: 'PricingQueueCountAggregate';
    _all: Scalars['Int']['output'];
    applyAttempts: Scalars['Int']['output'];
    applyEligibleAfter: Scalars['Int']['output'];
    applyFailedAt: Scalars['Int']['output'];
    applyHandler: Scalars['Int']['output'];
    applyLocked: Scalars['Int']['output'];
    applyStartedAt: Scalars['Int']['output'];
    applySucceededAt: Scalars['Int']['output'];
    appointmentAt: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    intentId: Scalars['Int']['output'];
    processAttempts: Scalars['Int']['output'];
    processEligibleAfter: Scalars['Int']['output'];
    processFailedAt: Scalars['Int']['output'];
    processStartedAt: Scalars['Int']['output'];
    processSucceededAt: Scalars['Int']['output'];
    request: Scalars['Int']['output'];
    response: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type PricingQueueCountOrderByAggregateInput = {
    applyAttempts?: InputMaybe<SortOrder>;
    applyEligibleAfter?: InputMaybe<SortOrder>;
    applyFailedAt?: InputMaybe<SortOrder>;
    applyHandler?: InputMaybe<SortOrder>;
    applyLocked?: InputMaybe<SortOrder>;
    applyStartedAt?: InputMaybe<SortOrder>;
    applySucceededAt?: InputMaybe<SortOrder>;
    appointmentAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intentId?: InputMaybe<SortOrder>;
    processAttempts?: InputMaybe<SortOrder>;
    processEligibleAfter?: InputMaybe<SortOrder>;
    processFailedAt?: InputMaybe<SortOrder>;
    processStartedAt?: InputMaybe<SortOrder>;
    processSucceededAt?: InputMaybe<SortOrder>;
    request?: InputMaybe<SortOrder>;
    response?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricingQueueCreateInput = {
    applyAttempts?: InputMaybe<Scalars['Int']['input']>;
    applyEligibleAfter?: InputMaybe<Scalars['DateTimeISO']['input']>;
    applyFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    applyHandler: Scalars['String']['input'];
    applyLocked?: InputMaybe<Scalars['Boolean']['input']>;
    applyStartedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    applySucceededAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    appointmentAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    intentId?: InputMaybe<Scalars['String']['input']>;
    processAttempts?: InputMaybe<Scalars['Int']['input']>;
    processEligibleAfter?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processStartedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processSucceededAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    request: Scalars['JSON']['input'];
    response?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<TaskStatus>;
    type: TaskType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricingQueueCreateManyInput = {
    applyAttempts?: InputMaybe<Scalars['Int']['input']>;
    applyEligibleAfter?: InputMaybe<Scalars['DateTimeISO']['input']>;
    applyFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    applyHandler: Scalars['String']['input'];
    applyLocked?: InputMaybe<Scalars['Boolean']['input']>;
    applyStartedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    applySucceededAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    appointmentAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    intentId?: InputMaybe<Scalars['String']['input']>;
    processAttempts?: InputMaybe<Scalars['Int']['input']>;
    processEligibleAfter?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processFailedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processStartedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    processSucceededAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    request: Scalars['JSON']['input'];
    response?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<TaskStatus>;
    type: TaskType;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PricingQueueGroupBy = {
    __typename?: 'PricingQueueGroupBy';
    _avg?: Maybe<PricingQueueAvgAggregate>;
    _count?: Maybe<PricingQueueCountAggregate>;
    _max?: Maybe<PricingQueueMaxAggregate>;
    _min?: Maybe<PricingQueueMinAggregate>;
    _sum?: Maybe<PricingQueueSumAggregate>;
    applyAttempts: Scalars['Int']['output'];
    applyEligibleAfter: Scalars['DateTimeISO']['output'];
    applyFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    applyHandler: Scalars['String']['output'];
    applyLocked: Scalars['Boolean']['output'];
    applyStartedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    applySucceededAt?: Maybe<Scalars['DateTimeISO']['output']>;
    appointmentAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    intentId?: Maybe<Scalars['String']['output']>;
    processAttempts: Scalars['Int']['output'];
    processEligibleAfter: Scalars['DateTimeISO']['output'];
    processFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    processStartedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    processSucceededAt?: Maybe<Scalars['DateTimeISO']['output']>;
    request: Scalars['JSON']['output'];
    response?: Maybe<Scalars['JSON']['output']>;
    status: TaskStatus;
    type: TaskType;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type PricingQueueMaxAggregate = {
    __typename?: 'PricingQueueMaxAggregate';
    applyAttempts?: Maybe<Scalars['Int']['output']>;
    applyEligibleAfter?: Maybe<Scalars['DateTimeISO']['output']>;
    applyFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    applyHandler?: Maybe<Scalars['String']['output']>;
    applyLocked?: Maybe<Scalars['Boolean']['output']>;
    applyStartedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    applySucceededAt?: Maybe<Scalars['DateTimeISO']['output']>;
    appointmentAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    intentId?: Maybe<Scalars['String']['output']>;
    processAttempts?: Maybe<Scalars['Int']['output']>;
    processEligibleAfter?: Maybe<Scalars['DateTimeISO']['output']>;
    processFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    processStartedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    processSucceededAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<TaskStatus>;
    type?: Maybe<TaskType>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PricingQueueMaxOrderByAggregateInput = {
    applyAttempts?: InputMaybe<SortOrder>;
    applyEligibleAfter?: InputMaybe<SortOrder>;
    applyFailedAt?: InputMaybe<SortOrder>;
    applyHandler?: InputMaybe<SortOrder>;
    applyLocked?: InputMaybe<SortOrder>;
    applyStartedAt?: InputMaybe<SortOrder>;
    applySucceededAt?: InputMaybe<SortOrder>;
    appointmentAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intentId?: InputMaybe<SortOrder>;
    processAttempts?: InputMaybe<SortOrder>;
    processEligibleAfter?: InputMaybe<SortOrder>;
    processFailedAt?: InputMaybe<SortOrder>;
    processStartedAt?: InputMaybe<SortOrder>;
    processSucceededAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricingQueueMinAggregate = {
    __typename?: 'PricingQueueMinAggregate';
    applyAttempts?: Maybe<Scalars['Int']['output']>;
    applyEligibleAfter?: Maybe<Scalars['DateTimeISO']['output']>;
    applyFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    applyHandler?: Maybe<Scalars['String']['output']>;
    applyLocked?: Maybe<Scalars['Boolean']['output']>;
    applyStartedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    applySucceededAt?: Maybe<Scalars['DateTimeISO']['output']>;
    appointmentAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    intentId?: Maybe<Scalars['String']['output']>;
    processAttempts?: Maybe<Scalars['Int']['output']>;
    processEligibleAfter?: Maybe<Scalars['DateTimeISO']['output']>;
    processFailedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    processStartedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    processSucceededAt?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<TaskStatus>;
    type?: Maybe<TaskType>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PricingQueueMinOrderByAggregateInput = {
    applyAttempts?: InputMaybe<SortOrder>;
    applyEligibleAfter?: InputMaybe<SortOrder>;
    applyFailedAt?: InputMaybe<SortOrder>;
    applyHandler?: InputMaybe<SortOrder>;
    applyLocked?: InputMaybe<SortOrder>;
    applyStartedAt?: InputMaybe<SortOrder>;
    applySucceededAt?: InputMaybe<SortOrder>;
    appointmentAt?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intentId?: InputMaybe<SortOrder>;
    processAttempts?: InputMaybe<SortOrder>;
    processEligibleAfter?: InputMaybe<SortOrder>;
    processFailedAt?: InputMaybe<SortOrder>;
    processStartedAt?: InputMaybe<SortOrder>;
    processSucceededAt?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricingQueueOrderByWithAggregationInput = {
    _avg?: InputMaybe<PricingQueueAvgOrderByAggregateInput>;
    _count?: InputMaybe<PricingQueueCountOrderByAggregateInput>;
    _max?: InputMaybe<PricingQueueMaxOrderByAggregateInput>;
    _min?: InputMaybe<PricingQueueMinOrderByAggregateInput>;
    _sum?: InputMaybe<PricingQueueSumOrderByAggregateInput>;
    applyAttempts?: InputMaybe<SortOrder>;
    applyEligibleAfter?: InputMaybe<SortOrder>;
    applyFailedAt?: InputMaybe<SortOrderInput>;
    applyHandler?: InputMaybe<SortOrder>;
    applyLocked?: InputMaybe<SortOrder>;
    applyStartedAt?: InputMaybe<SortOrderInput>;
    applySucceededAt?: InputMaybe<SortOrderInput>;
    appointmentAt?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intentId?: InputMaybe<SortOrderInput>;
    processAttempts?: InputMaybe<SortOrder>;
    processEligibleAfter?: InputMaybe<SortOrder>;
    processFailedAt?: InputMaybe<SortOrderInput>;
    processStartedAt?: InputMaybe<SortOrderInput>;
    processSucceededAt?: InputMaybe<SortOrderInput>;
    request?: InputMaybe<SortOrder>;
    response?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type PricingQueueOrderByWithRelationInput = {
    applyAttempts?: InputMaybe<SortOrder>;
    applyEligibleAfter?: InputMaybe<SortOrder>;
    applyFailedAt?: InputMaybe<SortOrderInput>;
    applyHandler?: InputMaybe<SortOrder>;
    applyLocked?: InputMaybe<SortOrder>;
    applyStartedAt?: InputMaybe<SortOrderInput>;
    applySucceededAt?: InputMaybe<SortOrderInput>;
    appointmentAt?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    intentId?: InputMaybe<SortOrderInput>;
    processAttempts?: InputMaybe<SortOrder>;
    processEligibleAfter?: InputMaybe<SortOrder>;
    processFailedAt?: InputMaybe<SortOrderInput>;
    processStartedAt?: InputMaybe<SortOrderInput>;
    processSucceededAt?: InputMaybe<SortOrderInput>;
    request?: InputMaybe<SortOrder>;
    response?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum PricingQueueScalarFieldEnum {
    ApplyAttempts = 'applyAttempts',
    ApplyEligibleAfter = 'applyEligibleAfter',
    ApplyFailedAt = 'applyFailedAt',
    ApplyHandler = 'applyHandler',
    ApplyLocked = 'applyLocked',
    ApplyStartedAt = 'applyStartedAt',
    ApplySucceededAt = 'applySucceededAt',
    AppointmentAt = 'appointmentAt',
    CreatedAt = 'createdAt',
    Id = 'id',
    IntentId = 'intentId',
    ProcessAttempts = 'processAttempts',
    ProcessEligibleAfter = 'processEligibleAfter',
    ProcessFailedAt = 'processFailedAt',
    ProcessStartedAt = 'processStartedAt',
    ProcessSucceededAt = 'processSucceededAt',
    Request = 'request',
    Response = 'response',
    Status = 'status',
    Type = 'type',
    UpdatedAt = 'updatedAt',
}

export type PricingQueueScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PricingQueueScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PricingQueueScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PricingQueueScalarWhereWithAggregatesInput>>;
    applyAttempts?: InputMaybe<IntWithAggregatesFilter>;
    applyEligibleAfter?: InputMaybe<DateTimeWithAggregatesFilter>;
    applyFailedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    applyHandler?: InputMaybe<StringWithAggregatesFilter>;
    applyLocked?: InputMaybe<BoolWithAggregatesFilter>;
    applyStartedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    applySucceededAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    appointmentAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    intentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    processAttempts?: InputMaybe<IntWithAggregatesFilter>;
    processEligibleAfter?: InputMaybe<DateTimeWithAggregatesFilter>;
    processFailedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    processStartedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    processSucceededAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    request?: InputMaybe<JsonWithAggregatesFilter>;
    response?: InputMaybe<JsonNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumTaskStatusWithAggregatesFilter>;
    type?: InputMaybe<EnumTaskTypeWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PricingQueueSumAggregate = {
    __typename?: 'PricingQueueSumAggregate';
    applyAttempts?: Maybe<Scalars['Int']['output']>;
    processAttempts?: Maybe<Scalars['Int']['output']>;
};

export type PricingQueueSumOrderByAggregateInput = {
    applyAttempts?: InputMaybe<SortOrder>;
    processAttempts?: InputMaybe<SortOrder>;
};

export type PricingQueueUpdateInput = {
    applyAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
    applyEligibleAfter?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    applyFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    applyHandler?: InputMaybe<StringFieldUpdateOperationsInput>;
    applyLocked?: InputMaybe<BoolFieldUpdateOperationsInput>;
    applyStartedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    applySucceededAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    appointmentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    intentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    processAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
    processEligibleAfter?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    processFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    processStartedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    processSucceededAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    request?: InputMaybe<Scalars['JSON']['input']>;
    response?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<EnumTaskStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumTaskTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PricingQueueUpdateManyMutationInput = {
    applyAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
    applyEligibleAfter?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    applyFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    applyHandler?: InputMaybe<StringFieldUpdateOperationsInput>;
    applyLocked?: InputMaybe<BoolFieldUpdateOperationsInput>;
    applyStartedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    applySucceededAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    appointmentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    intentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    processAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
    processEligibleAfter?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    processFailedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    processStartedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    processSucceededAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    request?: InputMaybe<Scalars['JSON']['input']>;
    response?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<EnumTaskStatusFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumTaskTypeFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PricingQueueWhereInput = {
    AND?: InputMaybe<Array<PricingQueueWhereInput>>;
    NOT?: InputMaybe<Array<PricingQueueWhereInput>>;
    OR?: InputMaybe<Array<PricingQueueWhereInput>>;
    applyAttempts?: InputMaybe<IntFilter>;
    applyEligibleAfter?: InputMaybe<DateTimeFilter>;
    applyFailedAt?: InputMaybe<DateTimeNullableFilter>;
    applyHandler?: InputMaybe<StringFilter>;
    applyLocked?: InputMaybe<BoolFilter>;
    applyStartedAt?: InputMaybe<DateTimeNullableFilter>;
    applySucceededAt?: InputMaybe<DateTimeNullableFilter>;
    appointmentAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    intentId?: InputMaybe<UuidNullableFilter>;
    processAttempts?: InputMaybe<IntFilter>;
    processEligibleAfter?: InputMaybe<DateTimeFilter>;
    processFailedAt?: InputMaybe<DateTimeNullableFilter>;
    processStartedAt?: InputMaybe<DateTimeNullableFilter>;
    processSucceededAt?: InputMaybe<DateTimeNullableFilter>;
    request?: InputMaybe<JsonFilter>;
    response?: InputMaybe<JsonNullableFilter>;
    status?: InputMaybe<EnumTaskStatusFilter>;
    type?: InputMaybe<EnumTaskTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PricingQueueWhereUniqueInput = {
    AND?: InputMaybe<Array<PricingQueueWhereInput>>;
    NOT?: InputMaybe<Array<PricingQueueWhereInput>>;
    OR?: InputMaybe<Array<PricingQueueWhereInput>>;
    applyAttempts?: InputMaybe<IntFilter>;
    applyEligibleAfter?: InputMaybe<DateTimeFilter>;
    applyFailedAt?: InputMaybe<DateTimeNullableFilter>;
    applyHandler?: InputMaybe<StringFilter>;
    applyLocked?: InputMaybe<BoolFilter>;
    applyStartedAt?: InputMaybe<DateTimeNullableFilter>;
    applySucceededAt?: InputMaybe<DateTimeNullableFilter>;
    appointmentAt?: InputMaybe<DateTimeNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    intentId?: InputMaybe<UuidNullableFilter>;
    processAttempts?: InputMaybe<IntFilter>;
    processEligibleAfter?: InputMaybe<DateTimeFilter>;
    processFailedAt?: InputMaybe<DateTimeNullableFilter>;
    processStartedAt?: InputMaybe<DateTimeNullableFilter>;
    processSucceededAt?: InputMaybe<DateTimeNullableFilter>;
    request?: InputMaybe<JsonFilter>;
    response?: InputMaybe<JsonNullableFilter>;
    status?: InputMaybe<EnumTaskStatusFilter>;
    type?: InputMaybe<EnumTaskTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PricingResults = {
    __typename?: 'PricingResults';
    _count?: Maybe<PricingResultsCount>;
    date: Scalars['DateTimeISO']['output'];
    is_superscript_email: Scalars['Boolean']['output'];
    latency: Scalars['Int']['output'];
    not_from_cache: Scalars['Int']['output'];
    org_id?: Maybe<Scalars['Int']['output']>;
    parent_request_id?: Maybe<Scalars['String']['output']>;
    pricingAttempt: Array<PricingAttempt>;
    pricingCallId: Scalars['Int']['output'];
    pricing_type: PricingType;
    request_id: Scalars['String']['output'];
    request_source: RequestSource;
    results: AirStatusCode;
    session_id?: Maybe<Scalars['String']['output']>;
};

export type PricingResultsPricingAttemptArgs = {
    cursor?: InputMaybe<PricingAttemptWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingAttemptScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingAttemptOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type PricingResultsAvgAggregate = {
    __typename?: 'PricingResultsAvgAggregate';
    latency?: Maybe<Scalars['Float']['output']>;
    not_from_cache?: Maybe<Scalars['Float']['output']>;
    org_id?: Maybe<Scalars['Float']['output']>;
    pricingCallId?: Maybe<Scalars['Float']['output']>;
};

export type PricingResultsAvgOrderByAggregateInput = {
    latency?: InputMaybe<SortOrder>;
    not_from_cache?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
};

export type PricingResultsCount = {
    __typename?: 'PricingResultsCount';
    pricingAttempt: Scalars['Int']['output'];
};

export type PricingResultsCountPricingAttemptArgs = {
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type PricingResultsCountAggregate = {
    __typename?: 'PricingResultsCountAggregate';
    _all: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    is_superscript_email: Scalars['Int']['output'];
    latency: Scalars['Int']['output'];
    not_from_cache: Scalars['Int']['output'];
    org_id: Scalars['Int']['output'];
    parent_request_id: Scalars['Int']['output'];
    pricingCallId: Scalars['Int']['output'];
    pricing_type: Scalars['Int']['output'];
    request_id: Scalars['Int']['output'];
    request_source: Scalars['Int']['output'];
    results: Scalars['Int']['output'];
    session_id: Scalars['Int']['output'];
};

export type PricingResultsCountOrderByAggregateInput = {
    date?: InputMaybe<SortOrder>;
    is_superscript_email?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    not_from_cache?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    parent_request_id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
    pricing_type?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    request_source?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrder>;
};

export type PricingResultsCreateInput = {
    date: Scalars['DateTimeISO']['input'];
    is_superscript_email?: InputMaybe<Scalars['Boolean']['input']>;
    latency: Scalars['Int']['input'];
    not_from_cache?: InputMaybe<Scalars['Int']['input']>;
    org_id?: InputMaybe<Scalars['Int']['input']>;
    parent_request_id?: InputMaybe<Scalars['String']['input']>;
    pricingAttempt?: InputMaybe<PricingAttemptCreateNestedManyWithoutPricingResultsInput>;
    pricing_type: PricingType;
    request_id: Scalars['String']['input'];
    request_source: RequestSource;
    results?: InputMaybe<AirStatusCode>;
    session_id?: InputMaybe<Scalars['String']['input']>;
};

export type PricingResultsCreateManyInput = {
    date: Scalars['DateTimeISO']['input'];
    is_superscript_email?: InputMaybe<Scalars['Boolean']['input']>;
    latency: Scalars['Int']['input'];
    not_from_cache?: InputMaybe<Scalars['Int']['input']>;
    org_id?: InputMaybe<Scalars['Int']['input']>;
    parent_request_id?: InputMaybe<Scalars['String']['input']>;
    pricingCallId?: InputMaybe<Scalars['Int']['input']>;
    pricing_type: PricingType;
    request_id: Scalars['String']['input'];
    request_source: RequestSource;
    results?: InputMaybe<AirStatusCode>;
    session_id?: InputMaybe<Scalars['String']['input']>;
};

export type PricingResultsCreateNestedOneWithoutPricingAttemptInput = {
    connect?: InputMaybe<PricingResultsWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PricingResultsCreateOrConnectWithoutPricingAttemptInput>;
    create?: InputMaybe<PricingResultsCreateWithoutPricingAttemptInput>;
};

export type PricingResultsCreateOrConnectWithoutPricingAttemptInput = {
    create: PricingResultsCreateWithoutPricingAttemptInput;
    where: PricingResultsWhereUniqueInput;
};

export type PricingResultsCreateWithoutPricingAttemptInput = {
    date: Scalars['DateTimeISO']['input'];
    is_superscript_email?: InputMaybe<Scalars['Boolean']['input']>;
    latency: Scalars['Int']['input'];
    not_from_cache?: InputMaybe<Scalars['Int']['input']>;
    org_id?: InputMaybe<Scalars['Int']['input']>;
    parent_request_id?: InputMaybe<Scalars['String']['input']>;
    pricing_type: PricingType;
    request_id: Scalars['String']['input'];
    request_source: RequestSource;
    results?: InputMaybe<AirStatusCode>;
    session_id?: InputMaybe<Scalars['String']['input']>;
};

export type PricingResultsGroupBy = {
    __typename?: 'PricingResultsGroupBy';
    _avg?: Maybe<PricingResultsAvgAggregate>;
    _count?: Maybe<PricingResultsCountAggregate>;
    _max?: Maybe<PricingResultsMaxAggregate>;
    _min?: Maybe<PricingResultsMinAggregate>;
    _sum?: Maybe<PricingResultsSumAggregate>;
    date: Scalars['DateTimeISO']['output'];
    is_superscript_email: Scalars['Boolean']['output'];
    latency: Scalars['Int']['output'];
    not_from_cache: Scalars['Int']['output'];
    org_id?: Maybe<Scalars['Int']['output']>;
    parent_request_id?: Maybe<Scalars['String']['output']>;
    pricingCallId: Scalars['Int']['output'];
    pricing_type: PricingType;
    request_id: Scalars['String']['output'];
    request_source: RequestSource;
    results: AirStatusCode;
    session_id?: Maybe<Scalars['String']['output']>;
};

export type PricingResultsMaxAggregate = {
    __typename?: 'PricingResultsMaxAggregate';
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    is_superscript_email?: Maybe<Scalars['Boolean']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    not_from_cache?: Maybe<Scalars['Int']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    parent_request_id?: Maybe<Scalars['String']['output']>;
    pricingCallId?: Maybe<Scalars['Int']['output']>;
    pricing_type?: Maybe<PricingType>;
    request_id?: Maybe<Scalars['String']['output']>;
    request_source?: Maybe<RequestSource>;
    results?: Maybe<AirStatusCode>;
    session_id?: Maybe<Scalars['String']['output']>;
};

export type PricingResultsMaxOrderByAggregateInput = {
    date?: InputMaybe<SortOrder>;
    is_superscript_email?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    not_from_cache?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    parent_request_id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
    pricing_type?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    request_source?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrder>;
};

export type PricingResultsMinAggregate = {
    __typename?: 'PricingResultsMinAggregate';
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    is_superscript_email?: Maybe<Scalars['Boolean']['output']>;
    latency?: Maybe<Scalars['Int']['output']>;
    not_from_cache?: Maybe<Scalars['Int']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    parent_request_id?: Maybe<Scalars['String']['output']>;
    pricingCallId?: Maybe<Scalars['Int']['output']>;
    pricing_type?: Maybe<PricingType>;
    request_id?: Maybe<Scalars['String']['output']>;
    request_source?: Maybe<RequestSource>;
    results?: Maybe<AirStatusCode>;
    session_id?: Maybe<Scalars['String']['output']>;
};

export type PricingResultsMinOrderByAggregateInput = {
    date?: InputMaybe<SortOrder>;
    is_superscript_email?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    not_from_cache?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    parent_request_id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
    pricing_type?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    request_source?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrder>;
};

export type PricingResultsOrderByWithAggregationInput = {
    _avg?: InputMaybe<PricingResultsAvgOrderByAggregateInput>;
    _count?: InputMaybe<PricingResultsCountOrderByAggregateInput>;
    _max?: InputMaybe<PricingResultsMaxOrderByAggregateInput>;
    _min?: InputMaybe<PricingResultsMinOrderByAggregateInput>;
    _sum?: InputMaybe<PricingResultsSumOrderByAggregateInput>;
    date?: InputMaybe<SortOrder>;
    is_superscript_email?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    not_from_cache?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrderInput>;
    parent_request_id?: InputMaybe<SortOrderInput>;
    pricingCallId?: InputMaybe<SortOrder>;
    pricing_type?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    request_source?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrderInput>;
};

export type PricingResultsOrderByWithRelationInput = {
    date?: InputMaybe<SortOrder>;
    is_superscript_email?: InputMaybe<SortOrder>;
    latency?: InputMaybe<SortOrder>;
    not_from_cache?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrderInput>;
    parent_request_id?: InputMaybe<SortOrderInput>;
    pricingAttempt?: InputMaybe<PricingAttemptOrderByRelationAggregateInput>;
    pricingCallId?: InputMaybe<SortOrder>;
    pricing_type?: InputMaybe<SortOrder>;
    request_id?: InputMaybe<SortOrder>;
    request_source?: InputMaybe<SortOrder>;
    results?: InputMaybe<SortOrder>;
    session_id?: InputMaybe<SortOrderInput>;
};

export type PricingResultsRelationFilter = {
    is?: InputMaybe<PricingResultsWhereInput>;
    isNot?: InputMaybe<PricingResultsWhereInput>;
};

export enum PricingResultsScalarFieldEnum {
    Date = 'date',
    IsSuperscriptEmail = 'is_superscript_email',
    Latency = 'latency',
    NotFromCache = 'not_from_cache',
    OrgId = 'org_id',
    ParentRequestId = 'parent_request_id',
    PricingCallId = 'pricingCallId',
    PricingType = 'pricing_type',
    RequestId = 'request_id',
    RequestSource = 'request_source',
    Results = 'results',
    SessionId = 'session_id',
}

export type PricingResultsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<PricingResultsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<PricingResultsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<PricingResultsScalarWhereWithAggregatesInput>>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    is_superscript_email?: InputMaybe<BoolWithAggregatesFilter>;
    latency?: InputMaybe<IntWithAggregatesFilter>;
    not_from_cache?: InputMaybe<IntWithAggregatesFilter>;
    org_id?: InputMaybe<IntNullableWithAggregatesFilter>;
    parent_request_id?: InputMaybe<StringNullableWithAggregatesFilter>;
    pricingCallId?: InputMaybe<IntWithAggregatesFilter>;
    pricing_type?: InputMaybe<EnumPricingTypeWithAggregatesFilter>;
    request_id?: InputMaybe<StringWithAggregatesFilter>;
    request_source?: InputMaybe<EnumRequestSourceWithAggregatesFilter>;
    results?: InputMaybe<EnumAirStatusCodeWithAggregatesFilter>;
    session_id?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type PricingResultsSumAggregate = {
    __typename?: 'PricingResultsSumAggregate';
    latency?: Maybe<Scalars['Int']['output']>;
    not_from_cache?: Maybe<Scalars['Int']['output']>;
    org_id?: Maybe<Scalars['Int']['output']>;
    pricingCallId?: Maybe<Scalars['Int']['output']>;
};

export type PricingResultsSumOrderByAggregateInput = {
    latency?: InputMaybe<SortOrder>;
    not_from_cache?: InputMaybe<SortOrder>;
    org_id?: InputMaybe<SortOrder>;
    pricingCallId?: InputMaybe<SortOrder>;
};

export type PricingResultsUpdateInput = {
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    is_superscript_email?: InputMaybe<BoolFieldUpdateOperationsInput>;
    latency?: InputMaybe<IntFieldUpdateOperationsInput>;
    not_from_cache?: InputMaybe<IntFieldUpdateOperationsInput>;
    org_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    parent_request_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pricingAttempt?: InputMaybe<PricingAttemptUpdateManyWithoutPricingResultsNestedInput>;
    pricing_type?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
    request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    request_source?: InputMaybe<EnumRequestSourceFieldUpdateOperationsInput>;
    results?: InputMaybe<EnumAirStatusCodeFieldUpdateOperationsInput>;
    session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PricingResultsUpdateManyMutationInput = {
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    is_superscript_email?: InputMaybe<BoolFieldUpdateOperationsInput>;
    latency?: InputMaybe<IntFieldUpdateOperationsInput>;
    not_from_cache?: InputMaybe<IntFieldUpdateOperationsInput>;
    org_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    parent_request_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pricing_type?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
    request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    request_source?: InputMaybe<EnumRequestSourceFieldUpdateOperationsInput>;
    results?: InputMaybe<EnumAirStatusCodeFieldUpdateOperationsInput>;
    session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PricingResultsUpdateOneRequiredWithoutPricingAttemptNestedInput = {
    connect?: InputMaybe<PricingResultsWhereUniqueInput>;
    connectOrCreate?: InputMaybe<PricingResultsCreateOrConnectWithoutPricingAttemptInput>;
    create?: InputMaybe<PricingResultsCreateWithoutPricingAttemptInput>;
    update?: InputMaybe<PricingResultsUpdateToOneWithWhereWithoutPricingAttemptInput>;
    upsert?: InputMaybe<PricingResultsUpsertWithoutPricingAttemptInput>;
};

export type PricingResultsUpdateToOneWithWhereWithoutPricingAttemptInput = {
    data: PricingResultsUpdateWithoutPricingAttemptInput;
    where?: InputMaybe<PricingResultsWhereInput>;
};

export type PricingResultsUpdateWithoutPricingAttemptInput = {
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    is_superscript_email?: InputMaybe<BoolFieldUpdateOperationsInput>;
    latency?: InputMaybe<IntFieldUpdateOperationsInput>;
    not_from_cache?: InputMaybe<IntFieldUpdateOperationsInput>;
    org_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    parent_request_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    pricing_type?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
    request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
    request_source?: InputMaybe<EnumRequestSourceFieldUpdateOperationsInput>;
    results?: InputMaybe<EnumAirStatusCodeFieldUpdateOperationsInput>;
    session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PricingResultsUpsertWithoutPricingAttemptInput = {
    create: PricingResultsCreateWithoutPricingAttemptInput;
    update: PricingResultsUpdateWithoutPricingAttemptInput;
    where?: InputMaybe<PricingResultsWhereInput>;
};

export type PricingResultsWhereInput = {
    AND?: InputMaybe<Array<PricingResultsWhereInput>>;
    NOT?: InputMaybe<Array<PricingResultsWhereInput>>;
    OR?: InputMaybe<Array<PricingResultsWhereInput>>;
    date?: InputMaybe<DateTimeFilter>;
    is_superscript_email?: InputMaybe<BoolFilter>;
    latency?: InputMaybe<IntFilter>;
    not_from_cache?: InputMaybe<IntFilter>;
    org_id?: InputMaybe<IntNullableFilter>;
    parent_request_id?: InputMaybe<StringNullableFilter>;
    pricingAttempt?: InputMaybe<PricingAttemptListRelationFilter>;
    pricingCallId?: InputMaybe<IntFilter>;
    pricing_type?: InputMaybe<EnumPricingTypeFilter>;
    request_id?: InputMaybe<StringFilter>;
    request_source?: InputMaybe<EnumRequestSourceFilter>;
    results?: InputMaybe<EnumAirStatusCodeFilter>;
    session_id?: InputMaybe<StringNullableFilter>;
};

export type PricingResultsWhereUniqueInput = {
    AND?: InputMaybe<Array<PricingResultsWhereInput>>;
    NOT?: InputMaybe<Array<PricingResultsWhereInput>>;
    OR?: InputMaybe<Array<PricingResultsWhereInput>>;
    date?: InputMaybe<DateTimeFilter>;
    is_superscript_email?: InputMaybe<BoolFilter>;
    latency?: InputMaybe<IntFilter>;
    not_from_cache?: InputMaybe<IntFilter>;
    org_id?: InputMaybe<IntNullableFilter>;
    parent_request_id?: InputMaybe<StringNullableFilter>;
    pricingAttempt?: InputMaybe<PricingAttemptListRelationFilter>;
    pricingCallId?: InputMaybe<Scalars['Int']['input']>;
    pricing_type?: InputMaybe<EnumPricingTypeFilter>;
    request_id?: InputMaybe<StringFilter>;
    request_source?: InputMaybe<EnumRequestSourceFilter>;
    results?: InputMaybe<EnumAirStatusCodeFilter>;
    session_id?: InputMaybe<StringNullableFilter>;
};

export type ProcedureBenefitParsingRules = {
    __typename?: 'ProcedureBenefitParsingRules';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    parsingRule: ParsingRule;
    srtId?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type ProcedureBenefitParsingRulesAvgAggregate = {
    __typename?: 'ProcedureBenefitParsingRulesAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    srtId?: Maybe<Scalars['Float']['output']>;
};

export type ProcedureBenefitParsingRulesAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type ProcedureBenefitParsingRulesCountAggregate = {
    __typename?: 'ProcedureBenefitParsingRulesCountAggregate';
    _all: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    parsingRule: Scalars['Int']['output'];
    srtId: Scalars['Int']['output'];
    value: Scalars['Int']['output'];
};

export type ProcedureBenefitParsingRulesCountOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    parsingRule?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type ProcedureBenefitParsingRulesCreateInput = {
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    parsingRule: ParsingRule;
    srtId?: InputMaybe<Scalars['Int']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureBenefitParsingRulesCreateManyInput = {
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    parsingRule: ParsingRule;
    srtId?: InputMaybe<Scalars['Int']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureBenefitParsingRulesGroupBy = {
    __typename?: 'ProcedureBenefitParsingRulesGroupBy';
    _avg?: Maybe<ProcedureBenefitParsingRulesAvgAggregate>;
    _count?: Maybe<ProcedureBenefitParsingRulesCountAggregate>;
    _max?: Maybe<ProcedureBenefitParsingRulesMaxAggregate>;
    _min?: Maybe<ProcedureBenefitParsingRulesMinAggregate>;
    _sum?: Maybe<ProcedureBenefitParsingRulesSumAggregate>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    parsingRule: ParsingRule;
    srtId?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type ProcedureBenefitParsingRulesMaxAggregate = {
    __typename?: 'ProcedureBenefitParsingRulesMaxAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    parsingRule?: Maybe<ParsingRule>;
    srtId?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type ProcedureBenefitParsingRulesMaxOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    parsingRule?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type ProcedureBenefitParsingRulesMinAggregate = {
    __typename?: 'ProcedureBenefitParsingRulesMinAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    parsingRule?: Maybe<ParsingRule>;
    srtId?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type ProcedureBenefitParsingRulesMinOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    parsingRule?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
    value?: InputMaybe<SortOrder>;
};

export type ProcedureBenefitParsingRulesOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProcedureBenefitParsingRulesAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProcedureBenefitParsingRulesCountOrderByAggregateInput>;
    _max?: InputMaybe<ProcedureBenefitParsingRulesMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProcedureBenefitParsingRulesMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProcedureBenefitParsingRulesSumOrderByAggregateInput>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    parsingRule?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrderInput>;
    value?: InputMaybe<SortOrderInput>;
};

export type ProcedureBenefitParsingRulesOrderByWithRelationInput = {
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    parsingRule?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrderInput>;
    value?: InputMaybe<SortOrderInput>;
};

export enum ProcedureBenefitParsingRulesScalarFieldEnum {
    HrtId = 'hrtId',
    Id = 'id',
    ParsingRule = 'parsingRule',
    SrtId = 'srtId',
    Value = 'value',
}

export type ProcedureBenefitParsingRulesScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<ProcedureBenefitParsingRulesScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<ProcedureBenefitParsingRulesScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<ProcedureBenefitParsingRulesScalarWhereWithAggregatesInput>
    >;
    hrtId?: InputMaybe<IntNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    parsingRule?: InputMaybe<EnumParsingRuleWithAggregatesFilter>;
    srtId?: InputMaybe<IntNullableWithAggregatesFilter>;
    value?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ProcedureBenefitParsingRulesSumAggregate = {
    __typename?: 'ProcedureBenefitParsingRulesSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
};

export type ProcedureBenefitParsingRulesSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type ProcedureBenefitParsingRulesUpdateInput = {
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    parsingRule?: InputMaybe<EnumParsingRuleFieldUpdateOperationsInput>;
    srtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProcedureBenefitParsingRulesUpdateManyMutationInput = {
    hrtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    parsingRule?: InputMaybe<EnumParsingRuleFieldUpdateOperationsInput>;
    srtId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProcedureBenefitParsingRulesWhereInput = {
    AND?: InputMaybe<Array<ProcedureBenefitParsingRulesWhereInput>>;
    NOT?: InputMaybe<Array<ProcedureBenefitParsingRulesWhereInput>>;
    OR?: InputMaybe<Array<ProcedureBenefitParsingRulesWhereInput>>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<IntFilter>;
    parsingRule?: InputMaybe<EnumParsingRuleFilter>;
    srtId?: InputMaybe<IntNullableFilter>;
    value?: InputMaybe<StringNullableFilter>;
};

export type ProcedureBenefitParsingRulesWhereUniqueInput = {
    AND?: InputMaybe<Array<ProcedureBenefitParsingRulesWhereInput>>;
    NOT?: InputMaybe<Array<ProcedureBenefitParsingRulesWhereInput>>;
    OR?: InputMaybe<Array<ProcedureBenefitParsingRulesWhereInput>>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    parsingRule?: InputMaybe<EnumParsingRuleFilter>;
    srtId?: InputMaybe<IntNullableFilter>;
    value?: InputMaybe<StringNullableFilter>;
};

export type ProductCategories = {
    __typename?: 'ProductCategories';
    ProductCategoryTranslation: Array<ProductCategoryTranslation>;
    _count?: Maybe<ProductCategoriesCount>;
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    popularity: Scalars['Float']['output'];
    type: ProductCategoryType;
};

export type ProductCategoriesProductCategoryTranslationArgs = {
    cursor?: InputMaybe<ProductCategoryTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductCategoryTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProductCategoryTranslationOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoryTranslationWhereInput>;
};

export type ProductCategoriesAvgAggregate = {
    __typename?: 'ProductCategoriesAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type ProductCategoriesAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type ProductCategoriesCount = {
    __typename?: 'ProductCategoriesCount';
    ProductCategoryTranslation: Scalars['Int']['output'];
};

export type ProductCategoriesCountProductCategoryTranslationArgs = {
    where?: InputMaybe<ProductCategoryTranslationWhereInput>;
};

export type ProductCategoriesCountAggregate = {
    __typename?: 'ProductCategoriesCountAggregate';
    _all: Scalars['Int']['output'];
    displayMetadata: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    popularity: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
};

export type ProductCategoriesCountOrderByAggregateInput = {
    displayMetadata?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type ProductCategoriesCreateInput = {
    ProductCategoryTranslation?: InputMaybe<ProductCategoryTranslationCreateNestedManyWithoutProductCategoriesInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutProductCategoriesInput;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    type: ProductCategoryType;
};

export type ProductCategoriesCreateManyInput = {
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    popularity?: InputMaybe<Scalars['Float']['input']>;
    type: ProductCategoryType;
};

export type ProductCategoriesCreateManyOrgInput = {
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    popularity?: InputMaybe<Scalars['Float']['input']>;
    type: ProductCategoryType;
};

export type ProductCategoriesCreateManyOrgInputEnvelope = {
    data: Array<ProductCategoriesCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCategoriesCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<ProductCategoriesWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductCategoriesCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<ProductCategoriesCreateWithoutOrgInput>>;
    createMany?: InputMaybe<ProductCategoriesCreateManyOrgInputEnvelope>;
};

export type ProductCategoriesCreateNestedOneWithoutProductCategoryTranslationInput =
    {
        connect?: InputMaybe<ProductCategoriesWhereUniqueInput>;
        connectOrCreate?: InputMaybe<ProductCategoriesCreateOrConnectWithoutProductCategoryTranslationInput>;
        create?: InputMaybe<ProductCategoriesCreateWithoutProductCategoryTranslationInput>;
    };

export type ProductCategoriesCreateOrConnectWithoutOrgInput = {
    create: ProductCategoriesCreateWithoutOrgInput;
    where: ProductCategoriesWhereUniqueInput;
};

export type ProductCategoriesCreateOrConnectWithoutProductCategoryTranslationInput =
    {
        create: ProductCategoriesCreateWithoutProductCategoryTranslationInput;
        where: ProductCategoriesWhereUniqueInput;
    };

export type ProductCategoriesCreateWithoutOrgInput = {
    ProductCategoryTranslation?: InputMaybe<ProductCategoryTranslationCreateNestedManyWithoutProductCategoriesInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    popularity?: InputMaybe<Scalars['Float']['input']>;
    type: ProductCategoryType;
};

export type ProductCategoriesCreateWithoutProductCategoryTranslationInput = {
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutProductCategoriesInput;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    type: ProductCategoryType;
};

export type ProductCategoriesGroupBy = {
    __typename?: 'ProductCategoriesGroupBy';
    _avg?: Maybe<ProductCategoriesAvgAggregate>;
    _count?: Maybe<ProductCategoriesCountAggregate>;
    _max?: Maybe<ProductCategoriesMaxAggregate>;
    _min?: Maybe<ProductCategoriesMinAggregate>;
    _sum?: Maybe<ProductCategoriesSumAggregate>;
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    popularity: Scalars['Float']['output'];
    type: ProductCategoryType;
};

export type ProductCategoriesListRelationFilter = {
    every?: InputMaybe<ProductCategoriesWhereInput>;
    none?: InputMaybe<ProductCategoriesWhereInput>;
    some?: InputMaybe<ProductCategoriesWhereInput>;
};

export type ProductCategoriesMaxAggregate = {
    __typename?: 'ProductCategoriesMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
    type?: Maybe<ProductCategoryType>;
};

export type ProductCategoriesMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type ProductCategoriesMinAggregate = {
    __typename?: 'ProductCategoriesMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
    type?: Maybe<ProductCategoryType>;
};

export type ProductCategoriesMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type ProductCategoriesOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProductCategoriesOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProductCategoriesAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProductCategoriesCountOrderByAggregateInput>;
    _max?: InputMaybe<ProductCategoriesMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProductCategoriesMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProductCategoriesSumOrderByAggregateInput>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type ProductCategoriesOrderByWithRelationInput = {
    ProductCategoryTranslation?: InputMaybe<ProductCategoryTranslationOrderByRelationAggregateInput>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type ProductCategoriesRelationFilter = {
    is?: InputMaybe<ProductCategoriesWhereInput>;
    isNot?: InputMaybe<ProductCategoriesWhereInput>;
};

export enum ProductCategoriesScalarFieldEnum {
    DisplayMetadata = 'displayMetadata',
    Id = 'id',
    Name = 'name',
    OrgId = 'orgId',
    Popularity = 'popularity',
    Type = 'type',
}

export type ProductCategoriesScalarWhereInput = {
    AND?: InputMaybe<Array<ProductCategoriesScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProductCategoriesScalarWhereInput>>;
    OR?: InputMaybe<Array<ProductCategoriesScalarWhereInput>>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<IntFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    popularity?: InputMaybe<FloatFilter>;
    type?: InputMaybe<EnumProductCategoryTypeFilter>;
};

export type ProductCategoriesScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProductCategoriesScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProductCategoriesScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProductCategoriesScalarWhereWithAggregatesInput>>;
    displayMetadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    popularity?: InputMaybe<FloatWithAggregatesFilter>;
    type?: InputMaybe<EnumProductCategoryTypeWithAggregatesFilter>;
};

export type ProductCategoriesSumAggregate = {
    __typename?: 'ProductCategoriesSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type ProductCategoriesSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type ProductCategoriesUpdateInput = {
    ProductCategoryTranslation?: InputMaybe<ProductCategoryTranslationUpdateManyWithoutProductCategoriesNestedInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutProductCategoriesNestedInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumProductCategoryTypeFieldUpdateOperationsInput>;
};

export type ProductCategoriesUpdateManyMutationInput = {
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumProductCategoryTypeFieldUpdateOperationsInput>;
};

export type ProductCategoriesUpdateManyWithWhereWithoutOrgInput = {
    data: ProductCategoriesUpdateManyMutationInput;
    where: ProductCategoriesScalarWhereInput;
};

export type ProductCategoriesUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<ProductCategoriesWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductCategoriesCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<ProductCategoriesCreateWithoutOrgInput>>;
    createMany?: InputMaybe<ProductCategoriesCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<ProductCategoriesWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProductCategoriesScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProductCategoriesWhereUniqueInput>>;
    set?: InputMaybe<Array<ProductCategoriesWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProductCategoriesUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<ProductCategoriesUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<ProductCategoriesUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type ProductCategoriesUpdateOneRequiredWithoutProductCategoryTranslationNestedInput =
    {
        connect?: InputMaybe<ProductCategoriesWhereUniqueInput>;
        connectOrCreate?: InputMaybe<ProductCategoriesCreateOrConnectWithoutProductCategoryTranslationInput>;
        create?: InputMaybe<ProductCategoriesCreateWithoutProductCategoryTranslationInput>;
        update?: InputMaybe<ProductCategoriesUpdateToOneWithWhereWithoutProductCategoryTranslationInput>;
        upsert?: InputMaybe<ProductCategoriesUpsertWithoutProductCategoryTranslationInput>;
    };

export type ProductCategoriesUpdateToOneWithWhereWithoutProductCategoryTranslationInput =
    {
        data: ProductCategoriesUpdateWithoutProductCategoryTranslationInput;
        where?: InputMaybe<ProductCategoriesWhereInput>;
    };

export type ProductCategoriesUpdateWithWhereUniqueWithoutOrgInput = {
    data: ProductCategoriesUpdateWithoutOrgInput;
    where: ProductCategoriesWhereUniqueInput;
};

export type ProductCategoriesUpdateWithoutOrgInput = {
    ProductCategoryTranslation?: InputMaybe<ProductCategoryTranslationUpdateManyWithoutProductCategoriesNestedInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumProductCategoryTypeFieldUpdateOperationsInput>;
};

export type ProductCategoriesUpdateWithoutProductCategoryTranslationInput = {
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutProductCategoriesNestedInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumProductCategoryTypeFieldUpdateOperationsInput>;
};

export type ProductCategoriesUpsertWithWhereUniqueWithoutOrgInput = {
    create: ProductCategoriesCreateWithoutOrgInput;
    update: ProductCategoriesUpdateWithoutOrgInput;
    where: ProductCategoriesWhereUniqueInput;
};

export type ProductCategoriesUpsertWithoutProductCategoryTranslationInput = {
    create: ProductCategoriesCreateWithoutProductCategoryTranslationInput;
    update: ProductCategoriesUpdateWithoutProductCategoryTranslationInput;
    where?: InputMaybe<ProductCategoriesWhereInput>;
};

export type ProductCategoriesWhereInput = {
    AND?: InputMaybe<Array<ProductCategoriesWhereInput>>;
    NOT?: InputMaybe<Array<ProductCategoriesWhereInput>>;
    OR?: InputMaybe<Array<ProductCategoriesWhereInput>>;
    ProductCategoryTranslation?: InputMaybe<ProductCategoryTranslationListRelationFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<IntFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    popularity?: InputMaybe<FloatFilter>;
    type?: InputMaybe<EnumProductCategoryTypeFilter>;
};

export type ProductCategoriesWhereUniqueInput = {
    AND?: InputMaybe<Array<ProductCategoriesWhereInput>>;
    NOT?: InputMaybe<Array<ProductCategoriesWhereInput>>;
    OR?: InputMaybe<Array<ProductCategoriesWhereInput>>;
    ProductCategoryTranslation?: InputMaybe<ProductCategoryTranslationListRelationFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    popularity?: InputMaybe<FloatFilter>;
    type?: InputMaybe<EnumProductCategoryTypeFilter>;
};

export type ProductCategoryTranslation = {
    __typename?: 'ProductCategoryTranslation';
    ProductCategories: ProductCategories;
    createdAt: Scalars['DateTimeISO']['output'];
    languageCode: Scalars['String']['output'];
    name: Scalars['String']['output'];
    productCategoryId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    warningFlags: Array<Scalars['String']['output']>;
};

export type ProductCategoryTranslationAvgAggregate = {
    __typename?: 'ProductCategoryTranslationAvgAggregate';
    productCategoryId?: Maybe<Scalars['Float']['output']>;
};

export type ProductCategoryTranslationAvgOrderByAggregateInput = {
    productCategoryId?: InputMaybe<SortOrder>;
};

export type ProductCategoryTranslationCountAggregate = {
    __typename?: 'ProductCategoryTranslationCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    languageCode: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    productCategoryId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    warningFlags: Scalars['Int']['output'];
};

export type ProductCategoryTranslationCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    productCategoryId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type ProductCategoryTranslationCreateInput = {
    ProductCategories: ProductCategoriesCreateNestedOneWithoutProductCategoryTranslationInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<ProductCategoryTranslationCreatewarningFlagsInput>;
};

export type ProductCategoryTranslationCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    productCategoryId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<ProductCategoryTranslationCreatewarningFlagsInput>;
};

export type ProductCategoryTranslationCreateManyProductCategoriesInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<ProductCategoryTranslationCreatewarningFlagsInput>;
};

export type ProductCategoryTranslationCreateManyProductCategoriesInputEnvelope =
    {
        data: Array<ProductCategoryTranslationCreateManyProductCategoriesInput>;
        skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
    };

export type ProductCategoryTranslationCreateNestedManyWithoutProductCategoriesInput =
    {
        connect?: InputMaybe<Array<ProductCategoryTranslationWhereUniqueInput>>;
        connectOrCreate?: InputMaybe<
            Array<ProductCategoryTranslationCreateOrConnectWithoutProductCategoriesInput>
        >;
        create?: InputMaybe<
            Array<ProductCategoryTranslationCreateWithoutProductCategoriesInput>
        >;
        createMany?: InputMaybe<ProductCategoryTranslationCreateManyProductCategoriesInputEnvelope>;
    };

export type ProductCategoryTranslationCreateOrConnectWithoutProductCategoriesInput =
    {
        create: ProductCategoryTranslationCreateWithoutProductCategoriesInput;
        where: ProductCategoryTranslationWhereUniqueInput;
    };

export type ProductCategoryTranslationCreateWithoutProductCategoriesInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<ProductCategoryTranslationCreatewarningFlagsInput>;
};

export type ProductCategoryTranslationCreatewarningFlagsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ProductCategoryTranslationGroupBy = {
    __typename?: 'ProductCategoryTranslationGroupBy';
    _avg?: Maybe<ProductCategoryTranslationAvgAggregate>;
    _count?: Maybe<ProductCategoryTranslationCountAggregate>;
    _max?: Maybe<ProductCategoryTranslationMaxAggregate>;
    _min?: Maybe<ProductCategoryTranslationMinAggregate>;
    _sum?: Maybe<ProductCategoryTranslationSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    languageCode: Scalars['String']['output'];
    name: Scalars['String']['output'];
    productCategoryId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
    warningFlags?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProductCategoryTranslationListRelationFilter = {
    every?: InputMaybe<ProductCategoryTranslationWhereInput>;
    none?: InputMaybe<ProductCategoryTranslationWhereInput>;
    some?: InputMaybe<ProductCategoryTranslationWhereInput>;
};

export type ProductCategoryTranslationMaxAggregate = {
    __typename?: 'ProductCategoryTranslationMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    productCategoryId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProductCategoryTranslationMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    productCategoryId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProductCategoryTranslationMinAggregate = {
    __typename?: 'ProductCategoryTranslationMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    productCategoryId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProductCategoryTranslationMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    productCategoryId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProductCategoryTranslationOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProductCategoryTranslationOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProductCategoryTranslationAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProductCategoryTranslationCountOrderByAggregateInput>;
    _max?: InputMaybe<ProductCategoryTranslationMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProductCategoryTranslationMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProductCategoryTranslationSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    productCategoryId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type ProductCategoryTranslationOrderByWithRelationInput = {
    ProductCategories?: InputMaybe<ProductCategoriesOrderByWithRelationInput>;
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    productCategoryId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type ProductCategoryTranslationProductCategoryIdLanguageCodeCompoundUniqueInput =
    {
        languageCode: Scalars['String']['input'];
        productCategoryId: Scalars['Int']['input'];
    };

export enum ProductCategoryTranslationScalarFieldEnum {
    CreatedAt = 'createdAt',
    LanguageCode = 'languageCode',
    Name = 'name',
    ProductCategoryId = 'productCategoryId',
    UpdatedAt = 'updatedAt',
    WarningFlags = 'warningFlags',
}

export type ProductCategoryTranslationScalarWhereInput = {
    AND?: InputMaybe<Array<ProductCategoryTranslationScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProductCategoryTranslationScalarWhereInput>>;
    OR?: InputMaybe<Array<ProductCategoryTranslationScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    productCategoryId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type ProductCategoryTranslationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<ProductCategoryTranslationScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<ProductCategoryTranslationScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<ProductCategoryTranslationScalarWhereWithAggregatesInput>
    >;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    languageCode?: InputMaybe<StringWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    productCategoryId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type ProductCategoryTranslationSumAggregate = {
    __typename?: 'ProductCategoryTranslationSumAggregate';
    productCategoryId?: Maybe<Scalars['Int']['output']>;
};

export type ProductCategoryTranslationSumOrderByAggregateInput = {
    productCategoryId?: InputMaybe<SortOrder>;
};

export type ProductCategoryTranslationUpdateInput = {
    ProductCategories?: InputMaybe<ProductCategoriesUpdateOneRequiredWithoutProductCategoryTranslationNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<ProductCategoryTranslationUpdatewarningFlagsInput>;
};

export type ProductCategoryTranslationUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<ProductCategoryTranslationUpdatewarningFlagsInput>;
};

export type ProductCategoryTranslationUpdateManyWithWhereWithoutProductCategoriesInput =
    {
        data: ProductCategoryTranslationUpdateManyMutationInput;
        where: ProductCategoryTranslationScalarWhereInput;
    };

export type ProductCategoryTranslationUpdateManyWithoutProductCategoriesNestedInput =
    {
        connect?: InputMaybe<Array<ProductCategoryTranslationWhereUniqueInput>>;
        connectOrCreate?: InputMaybe<
            Array<ProductCategoryTranslationCreateOrConnectWithoutProductCategoriesInput>
        >;
        create?: InputMaybe<
            Array<ProductCategoryTranslationCreateWithoutProductCategoriesInput>
        >;
        createMany?: InputMaybe<ProductCategoryTranslationCreateManyProductCategoriesInputEnvelope>;
        delete?: InputMaybe<Array<ProductCategoryTranslationWhereUniqueInput>>;
        deleteMany?: InputMaybe<
            Array<ProductCategoryTranslationScalarWhereInput>
        >;
        disconnect?: InputMaybe<
            Array<ProductCategoryTranslationWhereUniqueInput>
        >;
        set?: InputMaybe<Array<ProductCategoryTranslationWhereUniqueInput>>;
        update?: InputMaybe<
            Array<ProductCategoryTranslationUpdateWithWhereUniqueWithoutProductCategoriesInput>
        >;
        updateMany?: InputMaybe<
            Array<ProductCategoryTranslationUpdateManyWithWhereWithoutProductCategoriesInput>
        >;
        upsert?: InputMaybe<
            Array<ProductCategoryTranslationUpsertWithWhereUniqueWithoutProductCategoriesInput>
        >;
    };

export type ProductCategoryTranslationUpdateWithWhereUniqueWithoutProductCategoriesInput =
    {
        data: ProductCategoryTranslationUpdateWithoutProductCategoriesInput;
        where: ProductCategoryTranslationWhereUniqueInput;
    };

export type ProductCategoryTranslationUpdateWithoutProductCategoriesInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<ProductCategoryTranslationUpdatewarningFlagsInput>;
};

export type ProductCategoryTranslationUpdatewarningFlagsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductCategoryTranslationUpsertWithWhereUniqueWithoutProductCategoriesInput =
    {
        create: ProductCategoryTranslationCreateWithoutProductCategoriesInput;
        update: ProductCategoryTranslationUpdateWithoutProductCategoriesInput;
        where: ProductCategoryTranslationWhereUniqueInput;
    };

export type ProductCategoryTranslationWhereInput = {
    AND?: InputMaybe<Array<ProductCategoryTranslationWhereInput>>;
    NOT?: InputMaybe<Array<ProductCategoryTranslationWhereInput>>;
    OR?: InputMaybe<Array<ProductCategoryTranslationWhereInput>>;
    ProductCategories?: InputMaybe<ProductCategoriesRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    productCategoryId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type ProductCategoryTranslationWhereUniqueInput = {
    AND?: InputMaybe<Array<ProductCategoryTranslationWhereInput>>;
    NOT?: InputMaybe<Array<ProductCategoryTranslationWhereInput>>;
    OR?: InputMaybe<Array<ProductCategoryTranslationWhereInput>>;
    ProductCategories?: InputMaybe<ProductCategoriesRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    productCategoryId?: InputMaybe<IntFilter>;
    productCategoryId_languageCode?: InputMaybe<ProductCategoryTranslationProductCategoryIdLanguageCodeCompoundUniqueInput>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type ProductToBundle = {
    __typename?: 'ProductToBundle';
    bundle: Bundle;
    bundleId: Scalars['Int']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    product: Products;
    productId: Scalars['Int']['output'];
    product_component_type: ProductComponentType;
};

export type ProductToBundleAvgAggregate = {
    __typename?: 'ProductToBundleAvgAggregate';
    bundleId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    productId?: Maybe<Scalars['Float']['output']>;
};

export type ProductToBundleAvgOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
};

export type ProductToBundleCountAggregate = {
    __typename?: 'ProductToBundleCountAggregate';
    _all: Scalars['Int']['output'];
    bundleId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    productId: Scalars['Int']['output'];
    product_component_type: Scalars['Int']['output'];
};

export type ProductToBundleCountOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    product_component_type?: InputMaybe<SortOrder>;
};

export type ProductToBundleCreateInput = {
    bundle: BundleCreateNestedOneWithoutProductToBundleInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    product: ProductsCreateNestedOneWithoutProductToBundleInput;
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToBundleCreateManyBundleInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    productId: Scalars['Int']['input'];
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToBundleCreateManyBundleInputEnvelope = {
    data: Array<ProductToBundleCreateManyBundleInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductToBundleCreateManyInput = {
    bundleId: Scalars['Int']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    productId: Scalars['Int']['input'];
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToBundleCreateManyProductInput = {
    bundleId: Scalars['Int']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToBundleCreateManyProductInputEnvelope = {
    data: Array<ProductToBundleCreateManyProductInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductToBundleCreateNestedManyWithoutBundleInput = {
    connect?: InputMaybe<Array<ProductToBundleWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductToBundleCreateOrConnectWithoutBundleInput>
    >;
    create?: InputMaybe<Array<ProductToBundleCreateWithoutBundleInput>>;
    createMany?: InputMaybe<ProductToBundleCreateManyBundleInputEnvelope>;
};

export type ProductToBundleCreateNestedManyWithoutProductInput = {
    connect?: InputMaybe<Array<ProductToBundleWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductToBundleCreateOrConnectWithoutProductInput>
    >;
    create?: InputMaybe<Array<ProductToBundleCreateWithoutProductInput>>;
    createMany?: InputMaybe<ProductToBundleCreateManyProductInputEnvelope>;
};

export type ProductToBundleCreateOrConnectWithoutBundleInput = {
    create: ProductToBundleCreateWithoutBundleInput;
    where: ProductToBundleWhereUniqueInput;
};

export type ProductToBundleCreateOrConnectWithoutProductInput = {
    create: ProductToBundleCreateWithoutProductInput;
    where: ProductToBundleWhereUniqueInput;
};

export type ProductToBundleCreateWithoutBundleInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    product: ProductsCreateNestedOneWithoutProductToBundleInput;
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToBundleCreateWithoutProductInput = {
    bundle: BundleCreateNestedOneWithoutProductToBundleInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToBundleGroupBy = {
    __typename?: 'ProductToBundleGroupBy';
    _avg?: Maybe<ProductToBundleAvgAggregate>;
    _count?: Maybe<ProductToBundleCountAggregate>;
    _max?: Maybe<ProductToBundleMaxAggregate>;
    _min?: Maybe<ProductToBundleMinAggregate>;
    _sum?: Maybe<ProductToBundleSumAggregate>;
    bundleId: Scalars['Int']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['Int']['output'];
    productId: Scalars['Int']['output'];
    product_component_type: ProductComponentType;
};

export type ProductToBundleListRelationFilter = {
    every?: InputMaybe<ProductToBundleWhereInput>;
    none?: InputMaybe<ProductToBundleWhereInput>;
    some?: InputMaybe<ProductToBundleWhereInput>;
};

export type ProductToBundleMaxAggregate = {
    __typename?: 'ProductToBundleMaxAggregate';
    bundleId?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    productId?: Maybe<Scalars['Int']['output']>;
    product_component_type?: Maybe<ProductComponentType>;
};

export type ProductToBundleMaxOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    product_component_type?: InputMaybe<SortOrder>;
};

export type ProductToBundleMinAggregate = {
    __typename?: 'ProductToBundleMinAggregate';
    bundleId?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    productId?: Maybe<Scalars['Int']['output']>;
    product_component_type?: Maybe<ProductComponentType>;
};

export type ProductToBundleMinOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    product_component_type?: InputMaybe<SortOrder>;
};

export type ProductToBundleOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProductToBundleOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProductToBundleAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProductToBundleCountOrderByAggregateInput>;
    _max?: InputMaybe<ProductToBundleMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProductToBundleMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProductToBundleSumOrderByAggregateInput>;
    bundleId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    product_component_type?: InputMaybe<SortOrder>;
};

export type ProductToBundleOrderByWithRelationInput = {
    bundle?: InputMaybe<BundleOrderByWithRelationInput>;
    bundleId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    product?: InputMaybe<ProductsOrderByWithRelationInput>;
    productId?: InputMaybe<SortOrder>;
    product_component_type?: InputMaybe<SortOrder>;
};

export enum ProductToBundleScalarFieldEnum {
    BundleId = 'bundleId',
    CreatedAt = 'createdAt',
    Id = 'id',
    ProductId = 'productId',
    ProductComponentType = 'product_component_type',
}

export type ProductToBundleScalarWhereInput = {
    AND?: InputMaybe<Array<ProductToBundleScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProductToBundleScalarWhereInput>>;
    OR?: InputMaybe<Array<ProductToBundleScalarWhereInput>>;
    bundleId?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    productId?: InputMaybe<IntFilter>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFilter>;
};

export type ProductToBundleScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProductToBundleScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProductToBundleScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProductToBundleScalarWhereWithAggregatesInput>>;
    bundleId?: InputMaybe<IntWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    productId?: InputMaybe<IntWithAggregatesFilter>;
    product_component_type?: InputMaybe<EnumProductComponentTypeWithAggregatesFilter>;
};

export type ProductToBundleSumAggregate = {
    __typename?: 'ProductToBundleSumAggregate';
    bundleId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    productId?: Maybe<Scalars['Int']['output']>;
};

export type ProductToBundleSumOrderByAggregateInput = {
    bundleId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
};

export type ProductToBundleUpdateInput = {
    bundle?: InputMaybe<BundleUpdateOneRequiredWithoutProductToBundleNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    product?: InputMaybe<ProductsUpdateOneRequiredWithoutProductToBundleNestedInput>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFieldUpdateOperationsInput>;
};

export type ProductToBundleUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFieldUpdateOperationsInput>;
};

export type ProductToBundleUpdateManyWithWhereWithoutBundleInput = {
    data: ProductToBundleUpdateManyMutationInput;
    where: ProductToBundleScalarWhereInput;
};

export type ProductToBundleUpdateManyWithWhereWithoutProductInput = {
    data: ProductToBundleUpdateManyMutationInput;
    where: ProductToBundleScalarWhereInput;
};

export type ProductToBundleUpdateManyWithoutBundleNestedInput = {
    connect?: InputMaybe<Array<ProductToBundleWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductToBundleCreateOrConnectWithoutBundleInput>
    >;
    create?: InputMaybe<Array<ProductToBundleCreateWithoutBundleInput>>;
    createMany?: InputMaybe<ProductToBundleCreateManyBundleInputEnvelope>;
    delete?: InputMaybe<Array<ProductToBundleWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProductToBundleScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProductToBundleWhereUniqueInput>>;
    set?: InputMaybe<Array<ProductToBundleWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProductToBundleUpdateWithWhereUniqueWithoutBundleInput>
    >;
    updateMany?: InputMaybe<
        Array<ProductToBundleUpdateManyWithWhereWithoutBundleInput>
    >;
    upsert?: InputMaybe<
        Array<ProductToBundleUpsertWithWhereUniqueWithoutBundleInput>
    >;
};

export type ProductToBundleUpdateManyWithoutProductNestedInput = {
    connect?: InputMaybe<Array<ProductToBundleWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductToBundleCreateOrConnectWithoutProductInput>
    >;
    create?: InputMaybe<Array<ProductToBundleCreateWithoutProductInput>>;
    createMany?: InputMaybe<ProductToBundleCreateManyProductInputEnvelope>;
    delete?: InputMaybe<Array<ProductToBundleWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProductToBundleScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProductToBundleWhereUniqueInput>>;
    set?: InputMaybe<Array<ProductToBundleWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProductToBundleUpdateWithWhereUniqueWithoutProductInput>
    >;
    updateMany?: InputMaybe<
        Array<ProductToBundleUpdateManyWithWhereWithoutProductInput>
    >;
    upsert?: InputMaybe<
        Array<ProductToBundleUpsertWithWhereUniqueWithoutProductInput>
    >;
};

export type ProductToBundleUpdateWithWhereUniqueWithoutBundleInput = {
    data: ProductToBundleUpdateWithoutBundleInput;
    where: ProductToBundleWhereUniqueInput;
};

export type ProductToBundleUpdateWithWhereUniqueWithoutProductInput = {
    data: ProductToBundleUpdateWithoutProductInput;
    where: ProductToBundleWhereUniqueInput;
};

export type ProductToBundleUpdateWithoutBundleInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    product?: InputMaybe<ProductsUpdateOneRequiredWithoutProductToBundleNestedInput>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFieldUpdateOperationsInput>;
};

export type ProductToBundleUpdateWithoutProductInput = {
    bundle?: InputMaybe<BundleUpdateOneRequiredWithoutProductToBundleNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFieldUpdateOperationsInput>;
};

export type ProductToBundleUpsertWithWhereUniqueWithoutBundleInput = {
    create: ProductToBundleCreateWithoutBundleInput;
    update: ProductToBundleUpdateWithoutBundleInput;
    where: ProductToBundleWhereUniqueInput;
};

export type ProductToBundleUpsertWithWhereUniqueWithoutProductInput = {
    create: ProductToBundleCreateWithoutProductInput;
    update: ProductToBundleUpdateWithoutProductInput;
    where: ProductToBundleWhereUniqueInput;
};

export type ProductToBundleWhereInput = {
    AND?: InputMaybe<Array<ProductToBundleWhereInput>>;
    NOT?: InputMaybe<Array<ProductToBundleWhereInput>>;
    OR?: InputMaybe<Array<ProductToBundleWhereInput>>;
    bundle?: InputMaybe<BundleRelationFilter>;
    bundleId?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<IntFilter>;
    product?: InputMaybe<ProductsRelationFilter>;
    productId?: InputMaybe<IntFilter>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFilter>;
};

export type ProductToBundleWhereUniqueInput = {
    AND?: InputMaybe<Array<ProductToBundleWhereInput>>;
    NOT?: InputMaybe<Array<ProductToBundleWhereInput>>;
    OR?: InputMaybe<Array<ProductToBundleWhereInput>>;
    bundle?: InputMaybe<BundleRelationFilter>;
    bundleId?: InputMaybe<IntFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    product?: InputMaybe<ProductsRelationFilter>;
    productId?: InputMaybe<IntFilter>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFilter>;
};

export type ProductToHrt = {
    __typename?: 'ProductToHrt';
    createdAt: Scalars['DateTimeISO']['output'];
    hrt: Hrt;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    product: Products;
    productId: Scalars['Int']['output'];
    product_component_type: ProductComponentType;
};

export type ProductToHrtAvgAggregate = {
    __typename?: 'ProductToHrtAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    productId?: Maybe<Scalars['Float']['output']>;
};

export type ProductToHrtAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
};

export type ProductToHrtCountAggregate = {
    __typename?: 'ProductToHrtCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    productId: Scalars['Int']['output'];
    product_component_type: Scalars['Int']['output'];
};

export type ProductToHrtCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    product_component_type?: InputMaybe<SortOrder>;
};

export type ProductToHrtCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutProductToHrtInput;
    product: ProductsCreateNestedOneWithoutProductToHrtInput;
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToHrtCreateManyHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    productId: Scalars['Int']['input'];
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToHrtCreateManyHrtInputEnvelope = {
    data: Array<ProductToHrtCreateManyHrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductToHrtCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    productId: Scalars['Int']['input'];
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToHrtCreateManyProductInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToHrtCreateManyProductInputEnvelope = {
    data: Array<ProductToHrtCreateManyProductInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductToHrtCreateNestedManyWithoutHrtInput = {
    connect?: InputMaybe<Array<ProductToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductToHrtCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<ProductToHrtCreateWithoutHrtInput>>;
    createMany?: InputMaybe<ProductToHrtCreateManyHrtInputEnvelope>;
};

export type ProductToHrtCreateNestedManyWithoutProductInput = {
    connect?: InputMaybe<Array<ProductToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductToHrtCreateOrConnectWithoutProductInput>
    >;
    create?: InputMaybe<Array<ProductToHrtCreateWithoutProductInput>>;
    createMany?: InputMaybe<ProductToHrtCreateManyProductInputEnvelope>;
};

export type ProductToHrtCreateOrConnectWithoutHrtInput = {
    create: ProductToHrtCreateWithoutHrtInput;
    where: ProductToHrtWhereUniqueInput;
};

export type ProductToHrtCreateOrConnectWithoutProductInput = {
    create: ProductToHrtCreateWithoutProductInput;
    where: ProductToHrtWhereUniqueInput;
};

export type ProductToHrtCreateWithoutHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    product: ProductsCreateNestedOneWithoutProductToHrtInput;
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToHrtCreateWithoutProductInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutProductToHrtInput;
    product_component_type?: InputMaybe<ProductComponentType>;
};

export type ProductToHrtGroupBy = {
    __typename?: 'ProductToHrtGroupBy';
    _avg?: Maybe<ProductToHrtAvgAggregate>;
    _count?: Maybe<ProductToHrtCountAggregate>;
    _max?: Maybe<ProductToHrtMaxAggregate>;
    _min?: Maybe<ProductToHrtMinAggregate>;
    _sum?: Maybe<ProductToHrtSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    productId: Scalars['Int']['output'];
    product_component_type: ProductComponentType;
};

export type ProductToHrtListRelationFilter = {
    every?: InputMaybe<ProductToHrtWhereInput>;
    none?: InputMaybe<ProductToHrtWhereInput>;
    some?: InputMaybe<ProductToHrtWhereInput>;
};

export type ProductToHrtMaxAggregate = {
    __typename?: 'ProductToHrtMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    productId?: Maybe<Scalars['Int']['output']>;
    product_component_type?: Maybe<ProductComponentType>;
};

export type ProductToHrtMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    product_component_type?: InputMaybe<SortOrder>;
};

export type ProductToHrtMinAggregate = {
    __typename?: 'ProductToHrtMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    productId?: Maybe<Scalars['Int']['output']>;
    product_component_type?: Maybe<ProductComponentType>;
};

export type ProductToHrtMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    product_component_type?: InputMaybe<SortOrder>;
};

export type ProductToHrtOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProductToHrtOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProductToHrtAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProductToHrtCountOrderByAggregateInput>;
    _max?: InputMaybe<ProductToHrtMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProductToHrtMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProductToHrtSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    product_component_type?: InputMaybe<SortOrder>;
};

export type ProductToHrtOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    product?: InputMaybe<ProductsOrderByWithRelationInput>;
    productId?: InputMaybe<SortOrder>;
    product_component_type?: InputMaybe<SortOrder>;
};

export enum ProductToHrtScalarFieldEnum {
    CreatedAt = 'createdAt',
    HrtId = 'hrtId',
    Id = 'id',
    ProductId = 'productId',
    ProductComponentType = 'product_component_type',
}

export type ProductToHrtScalarWhereInput = {
    AND?: InputMaybe<Array<ProductToHrtScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProductToHrtScalarWhereInput>>;
    OR?: InputMaybe<Array<ProductToHrtScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    productId?: InputMaybe<IntFilter>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFilter>;
};

export type ProductToHrtScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProductToHrtScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProductToHrtScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProductToHrtScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    productId?: InputMaybe<IntWithAggregatesFilter>;
    product_component_type?: InputMaybe<EnumProductComponentTypeWithAggregatesFilter>;
};

export type ProductToHrtSumAggregate = {
    __typename?: 'ProductToHrtSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    productId?: Maybe<Scalars['Int']['output']>;
};

export type ProductToHrtSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
};

export type ProductToHrtUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutProductToHrtNestedInput>;
    product?: InputMaybe<ProductsUpdateOneRequiredWithoutProductToHrtNestedInput>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFieldUpdateOperationsInput>;
};

export type ProductToHrtUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFieldUpdateOperationsInput>;
};

export type ProductToHrtUpdateManyWithWhereWithoutHrtInput = {
    data: ProductToHrtUpdateManyMutationInput;
    where: ProductToHrtScalarWhereInput;
};

export type ProductToHrtUpdateManyWithWhereWithoutProductInput = {
    data: ProductToHrtUpdateManyMutationInput;
    where: ProductToHrtScalarWhereInput;
};

export type ProductToHrtUpdateManyWithoutHrtNestedInput = {
    connect?: InputMaybe<Array<ProductToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductToHrtCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<ProductToHrtCreateWithoutHrtInput>>;
    createMany?: InputMaybe<ProductToHrtCreateManyHrtInputEnvelope>;
    delete?: InputMaybe<Array<ProductToHrtWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProductToHrtScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProductToHrtWhereUniqueInput>>;
    set?: InputMaybe<Array<ProductToHrtWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProductToHrtUpdateWithWhereUniqueWithoutHrtInput>
    >;
    updateMany?: InputMaybe<
        Array<ProductToHrtUpdateManyWithWhereWithoutHrtInput>
    >;
    upsert?: InputMaybe<
        Array<ProductToHrtUpsertWithWhereUniqueWithoutHrtInput>
    >;
};

export type ProductToHrtUpdateManyWithoutProductNestedInput = {
    connect?: InputMaybe<Array<ProductToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductToHrtCreateOrConnectWithoutProductInput>
    >;
    create?: InputMaybe<Array<ProductToHrtCreateWithoutProductInput>>;
    createMany?: InputMaybe<ProductToHrtCreateManyProductInputEnvelope>;
    delete?: InputMaybe<Array<ProductToHrtWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProductToHrtScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProductToHrtWhereUniqueInput>>;
    set?: InputMaybe<Array<ProductToHrtWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProductToHrtUpdateWithWhereUniqueWithoutProductInput>
    >;
    updateMany?: InputMaybe<
        Array<ProductToHrtUpdateManyWithWhereWithoutProductInput>
    >;
    upsert?: InputMaybe<
        Array<ProductToHrtUpsertWithWhereUniqueWithoutProductInput>
    >;
};

export type ProductToHrtUpdateWithWhereUniqueWithoutHrtInput = {
    data: ProductToHrtUpdateWithoutHrtInput;
    where: ProductToHrtWhereUniqueInput;
};

export type ProductToHrtUpdateWithWhereUniqueWithoutProductInput = {
    data: ProductToHrtUpdateWithoutProductInput;
    where: ProductToHrtWhereUniqueInput;
};

export type ProductToHrtUpdateWithoutHrtInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    product?: InputMaybe<ProductsUpdateOneRequiredWithoutProductToHrtNestedInput>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFieldUpdateOperationsInput>;
};

export type ProductToHrtUpdateWithoutProductInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutProductToHrtNestedInput>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFieldUpdateOperationsInput>;
};

export type ProductToHrtUpsertWithWhereUniqueWithoutHrtInput = {
    create: ProductToHrtCreateWithoutHrtInput;
    update: ProductToHrtUpdateWithoutHrtInput;
    where: ProductToHrtWhereUniqueInput;
};

export type ProductToHrtUpsertWithWhereUniqueWithoutProductInput = {
    create: ProductToHrtCreateWithoutProductInput;
    update: ProductToHrtUpdateWithoutProductInput;
    where: ProductToHrtWhereUniqueInput;
};

export type ProductToHrtWhereInput = {
    AND?: InputMaybe<Array<ProductToHrtWhereInput>>;
    NOT?: InputMaybe<Array<ProductToHrtWhereInput>>;
    OR?: InputMaybe<Array<ProductToHrtWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    product?: InputMaybe<ProductsRelationFilter>;
    productId?: InputMaybe<IntFilter>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFilter>;
};

export type ProductToHrtWhereUniqueInput = {
    AND?: InputMaybe<Array<ProductToHrtWhereInput>>;
    NOT?: InputMaybe<Array<ProductToHrtWhereInput>>;
    OR?: InputMaybe<Array<ProductToHrtWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    product?: InputMaybe<ProductsRelationFilter>;
    productId?: InputMaybe<IntFilter>;
    product_component_type?: InputMaybe<EnumProductComponentTypeFilter>;
};

export type ProductTranslation = {
    __typename?: 'ProductTranslation';
    Products: Products;
    createdAt: Scalars['DateTimeISO']['output'];
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    languageCode: Scalars['String']['output'];
    name: Scalars['String']['output'];
    productId: Scalars['Int']['output'];
    renderConfig?: Maybe<Scalars['JSON']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    warningFlags: Array<Scalars['String']['output']>;
};

export type ProductTranslationAvgAggregate = {
    __typename?: 'ProductTranslationAvgAggregate';
    productId?: Maybe<Scalars['Float']['output']>;
};

export type ProductTranslationAvgOrderByAggregateInput = {
    productId?: InputMaybe<SortOrder>;
};

export type ProductTranslationCountAggregate = {
    __typename?: 'ProductTranslationCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    displayMetadata: Scalars['Int']['output'];
    languageCode: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    productId: Scalars['Int']['output'];
    renderConfig: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    warningFlags: Scalars['Int']['output'];
};

export type ProductTranslationCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    renderConfig?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type ProductTranslationCreateInput = {
    Products: ProductsCreateNestedOneWithoutProductTranslationInput;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<ProductTranslationCreatewarningFlagsInput>;
};

export type ProductTranslationCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    productId: Scalars['Int']['input'];
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<ProductTranslationCreatewarningFlagsInput>;
};

export type ProductTranslationCreateManyProductsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<ProductTranslationCreatewarningFlagsInput>;
};

export type ProductTranslationCreateManyProductsInputEnvelope = {
    data: Array<ProductTranslationCreateManyProductsInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductTranslationCreateNestedManyWithoutProductsInput = {
    connect?: InputMaybe<Array<ProductTranslationWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductTranslationCreateOrConnectWithoutProductsInput>
    >;
    create?: InputMaybe<Array<ProductTranslationCreateWithoutProductsInput>>;
    createMany?: InputMaybe<ProductTranslationCreateManyProductsInputEnvelope>;
};

export type ProductTranslationCreateOrConnectWithoutProductsInput = {
    create: ProductTranslationCreateWithoutProductsInput;
    where: ProductTranslationWhereUniqueInput;
};

export type ProductTranslationCreateWithoutProductsInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    languageCode: Scalars['String']['input'];
    name: Scalars['String']['input'];
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    warningFlags?: InputMaybe<ProductTranslationCreatewarningFlagsInput>;
};

export type ProductTranslationCreatewarningFlagsInput = {
    set: Array<Scalars['String']['input']>;
};

export type ProductTranslationGroupBy = {
    __typename?: 'ProductTranslationGroupBy';
    _avg?: Maybe<ProductTranslationAvgAggregate>;
    _count?: Maybe<ProductTranslationCountAggregate>;
    _max?: Maybe<ProductTranslationMaxAggregate>;
    _min?: Maybe<ProductTranslationMinAggregate>;
    _sum?: Maybe<ProductTranslationSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    languageCode: Scalars['String']['output'];
    name: Scalars['String']['output'];
    productId: Scalars['Int']['output'];
    renderConfig?: Maybe<Scalars['JSON']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    warningFlags?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProductTranslationListRelationFilter = {
    every?: InputMaybe<ProductTranslationWhereInput>;
    none?: InputMaybe<ProductTranslationWhereInput>;
    some?: InputMaybe<ProductTranslationWhereInput>;
};

export type ProductTranslationMaxAggregate = {
    __typename?: 'ProductTranslationMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    productId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProductTranslationMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProductTranslationMinAggregate = {
    __typename?: 'ProductTranslationMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    languageCode?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    productId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProductTranslationMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProductTranslationOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProductTranslationOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProductTranslationAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProductTranslationCountOrderByAggregateInput>;
    _max?: InputMaybe<ProductTranslationMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProductTranslationMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProductTranslationSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    renderConfig?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type ProductTranslationOrderByWithRelationInput = {
    Products?: InputMaybe<ProductsOrderByWithRelationInput>;
    createdAt?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    languageCode?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    productId?: InputMaybe<SortOrder>;
    renderConfig?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    warningFlags?: InputMaybe<SortOrder>;
};

export type ProductTranslationProductIdLanguageCodeCompoundUniqueInput = {
    languageCode: Scalars['String']['input'];
    productId: Scalars['Int']['input'];
};

export enum ProductTranslationScalarFieldEnum {
    CreatedAt = 'createdAt',
    DisplayMetadata = 'displayMetadata',
    LanguageCode = 'languageCode',
    Name = 'name',
    ProductId = 'productId',
    RenderConfig = 'renderConfig',
    UpdatedAt = 'updatedAt',
    WarningFlags = 'warningFlags',
}

export type ProductTranslationScalarWhereInput = {
    AND?: InputMaybe<Array<ProductTranslationScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProductTranslationScalarWhereInput>>;
    OR?: InputMaybe<Array<ProductTranslationScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    productId?: InputMaybe<IntFilter>;
    renderConfig?: InputMaybe<JsonNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type ProductTranslationScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProductTranslationScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProductTranslationScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProductTranslationScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    displayMetadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    languageCode?: InputMaybe<StringWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    productId?: InputMaybe<IntWithAggregatesFilter>;
    renderConfig?: InputMaybe<JsonNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type ProductTranslationSumAggregate = {
    __typename?: 'ProductTranslationSumAggregate';
    productId?: Maybe<Scalars['Int']['output']>;
};

export type ProductTranslationSumOrderByAggregateInput = {
    productId?: InputMaybe<SortOrder>;
};

export type ProductTranslationUpdateInput = {
    Products?: InputMaybe<ProductsUpdateOneRequiredWithoutProductTranslationNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<ProductTranslationUpdatewarningFlagsInput>;
};

export type ProductTranslationUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<ProductTranslationUpdatewarningFlagsInput>;
};

export type ProductTranslationUpdateManyWithWhereWithoutProductsInput = {
    data: ProductTranslationUpdateManyMutationInput;
    where: ProductTranslationScalarWhereInput;
};

export type ProductTranslationUpdateManyWithoutProductsNestedInput = {
    connect?: InputMaybe<Array<ProductTranslationWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProductTranslationCreateOrConnectWithoutProductsInput>
    >;
    create?: InputMaybe<Array<ProductTranslationCreateWithoutProductsInput>>;
    createMany?: InputMaybe<ProductTranslationCreateManyProductsInputEnvelope>;
    delete?: InputMaybe<Array<ProductTranslationWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProductTranslationScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProductTranslationWhereUniqueInput>>;
    set?: InputMaybe<Array<ProductTranslationWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProductTranslationUpdateWithWhereUniqueWithoutProductsInput>
    >;
    updateMany?: InputMaybe<
        Array<ProductTranslationUpdateManyWithWhereWithoutProductsInput>
    >;
    upsert?: InputMaybe<
        Array<ProductTranslationUpsertWithWhereUniqueWithoutProductsInput>
    >;
};

export type ProductTranslationUpdateWithWhereUniqueWithoutProductsInput = {
    data: ProductTranslationUpdateWithoutProductsInput;
    where: ProductTranslationWhereUniqueInput;
};

export type ProductTranslationUpdateWithoutProductsInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    warningFlags?: InputMaybe<ProductTranslationUpdatewarningFlagsInput>;
};

export type ProductTranslationUpdatewarningFlagsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductTranslationUpsertWithWhereUniqueWithoutProductsInput = {
    create: ProductTranslationCreateWithoutProductsInput;
    update: ProductTranslationUpdateWithoutProductsInput;
    where: ProductTranslationWhereUniqueInput;
};

export type ProductTranslationWhereInput = {
    AND?: InputMaybe<Array<ProductTranslationWhereInput>>;
    NOT?: InputMaybe<Array<ProductTranslationWhereInput>>;
    OR?: InputMaybe<Array<ProductTranslationWhereInput>>;
    Products?: InputMaybe<ProductsRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    productId?: InputMaybe<IntFilter>;
    renderConfig?: InputMaybe<JsonNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type ProductTranslationWhereUniqueInput = {
    AND?: InputMaybe<Array<ProductTranslationWhereInput>>;
    NOT?: InputMaybe<Array<ProductTranslationWhereInput>>;
    OR?: InputMaybe<Array<ProductTranslationWhereInput>>;
    Products?: InputMaybe<ProductsRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    languageCode?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    productId?: InputMaybe<IntFilter>;
    productId_languageCode?: InputMaybe<ProductTranslationProductIdLanguageCodeCompoundUniqueInput>;
    renderConfig?: InputMaybe<JsonNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    warningFlags?: InputMaybe<StringNullableListFilter>;
};

export type Products = {
    __typename?: 'Products';
    ProductTranslation: Array<ProductTranslation>;
    _count?: Maybe<ProductsCount>;
    categoryIds: Array<Scalars['Int']['output']>;
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    popularity: Scalars['Float']['output'];
    productToBundle: Array<ProductToBundle>;
    productToHrt: Array<ProductToHrt>;
    product_page_type: ProductPageType;
    product_type: ProductType;
    renderConfig: Scalars['JSON']['output'];
};

export type ProductsProductTranslationArgs = {
    cursor?: InputMaybe<ProductTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductTranslationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductTranslationWhereInput>;
};

export type ProductsProductToBundleArgs = {
    cursor?: InputMaybe<ProductToBundleWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductToBundleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductToBundleOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type ProductsProductToHrtArgs = {
    cursor?: InputMaybe<ProductToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductToHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type ProductsAvgAggregate = {
    __typename?: 'ProductsAvgAggregate';
    categoryIds?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type ProductsAvgOrderByAggregateInput = {
    categoryIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type ProductsCount = {
    __typename?: 'ProductsCount';
    ProductTranslation: Scalars['Int']['output'];
    productToBundle: Scalars['Int']['output'];
    productToHrt: Scalars['Int']['output'];
};

export type ProductsCountProductTranslationArgs = {
    where?: InputMaybe<ProductTranslationWhereInput>;
};

export type ProductsCountProductToBundleArgs = {
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type ProductsCountProductToHrtArgs = {
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type ProductsCountAggregate = {
    __typename?: 'ProductsCountAggregate';
    _all: Scalars['Int']['output'];
    categoryIds: Scalars['Int']['output'];
    displayMetadata: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    popularity: Scalars['Int']['output'];
    product_page_type: Scalars['Int']['output'];
    product_type: Scalars['Int']['output'];
    renderConfig: Scalars['Int']['output'];
};

export type ProductsCountOrderByAggregateInput = {
    categoryIds?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    product_page_type?: InputMaybe<SortOrder>;
    product_type?: InputMaybe<SortOrder>;
    renderConfig?: InputMaybe<SortOrder>;
};

export type ProductsCreateInput = {
    ProductTranslation?: InputMaybe<ProductTranslationCreateNestedManyWithoutProductsInput>;
    categoryIds?: InputMaybe<ProductsCreatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutProductsInput;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    productToBundle?: InputMaybe<ProductToBundleCreateNestedManyWithoutProductInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutProductInput>;
    product_page_type?: InputMaybe<ProductPageType>;
    product_type?: InputMaybe<ProductType>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsCreateManyInput = {
    categoryIds?: InputMaybe<ProductsCreatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    popularity?: InputMaybe<Scalars['Float']['input']>;
    product_page_type?: InputMaybe<ProductPageType>;
    product_type?: InputMaybe<ProductType>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsCreateManyOrgInput = {
    categoryIds?: InputMaybe<ProductsCreatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    popularity?: InputMaybe<Scalars['Float']['input']>;
    product_page_type?: InputMaybe<ProductPageType>;
    product_type?: InputMaybe<ProductType>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsCreateManyOrgInputEnvelope = {
    data: Array<ProductsCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductsCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<ProductsWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<ProductsCreateOrConnectWithoutOrgInput>>;
    create?: InputMaybe<Array<ProductsCreateWithoutOrgInput>>;
    createMany?: InputMaybe<ProductsCreateManyOrgInputEnvelope>;
};

export type ProductsCreateNestedOneWithoutProductToBundleInput = {
    connect?: InputMaybe<ProductsWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProductsCreateOrConnectWithoutProductToBundleInput>;
    create?: InputMaybe<ProductsCreateWithoutProductToBundleInput>;
};

export type ProductsCreateNestedOneWithoutProductToHrtInput = {
    connect?: InputMaybe<ProductsWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProductsCreateOrConnectWithoutProductToHrtInput>;
    create?: InputMaybe<ProductsCreateWithoutProductToHrtInput>;
};

export type ProductsCreateNestedOneWithoutProductTranslationInput = {
    connect?: InputMaybe<ProductsWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProductsCreateOrConnectWithoutProductTranslationInput>;
    create?: InputMaybe<ProductsCreateWithoutProductTranslationInput>;
};

export type ProductsCreateOrConnectWithoutOrgInput = {
    create: ProductsCreateWithoutOrgInput;
    where: ProductsWhereUniqueInput;
};

export type ProductsCreateOrConnectWithoutProductToBundleInput = {
    create: ProductsCreateWithoutProductToBundleInput;
    where: ProductsWhereUniqueInput;
};

export type ProductsCreateOrConnectWithoutProductToHrtInput = {
    create: ProductsCreateWithoutProductToHrtInput;
    where: ProductsWhereUniqueInput;
};

export type ProductsCreateOrConnectWithoutProductTranslationInput = {
    create: ProductsCreateWithoutProductTranslationInput;
    where: ProductsWhereUniqueInput;
};

export type ProductsCreateWithoutOrgInput = {
    ProductTranslation?: InputMaybe<ProductTranslationCreateNestedManyWithoutProductsInput>;
    categoryIds?: InputMaybe<ProductsCreatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    popularity?: InputMaybe<Scalars['Float']['input']>;
    productToBundle?: InputMaybe<ProductToBundleCreateNestedManyWithoutProductInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutProductInput>;
    product_page_type?: InputMaybe<ProductPageType>;
    product_type?: InputMaybe<ProductType>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsCreateWithoutProductToBundleInput = {
    ProductTranslation?: InputMaybe<ProductTranslationCreateNestedManyWithoutProductsInput>;
    categoryIds?: InputMaybe<ProductsCreatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutProductsInput;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutProductInput>;
    product_page_type?: InputMaybe<ProductPageType>;
    product_type?: InputMaybe<ProductType>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsCreateWithoutProductToHrtInput = {
    ProductTranslation?: InputMaybe<ProductTranslationCreateNestedManyWithoutProductsInput>;
    categoryIds?: InputMaybe<ProductsCreatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutProductsInput;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    productToBundle?: InputMaybe<ProductToBundleCreateNestedManyWithoutProductInput>;
    product_page_type?: InputMaybe<ProductPageType>;
    product_type?: InputMaybe<ProductType>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsCreateWithoutProductTranslationInput = {
    categoryIds?: InputMaybe<ProductsCreatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    org: OrganizationCreateNestedOneWithoutProductsInput;
    popularity?: InputMaybe<Scalars['Float']['input']>;
    productToBundle?: InputMaybe<ProductToBundleCreateNestedManyWithoutProductInput>;
    productToHrt?: InputMaybe<ProductToHrtCreateNestedManyWithoutProductInput>;
    product_page_type?: InputMaybe<ProductPageType>;
    product_type?: InputMaybe<ProductType>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsCreatecategoryIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type ProductsGroupBy = {
    __typename?: 'ProductsGroupBy';
    _avg?: Maybe<ProductsAvgAggregate>;
    _count?: Maybe<ProductsCountAggregate>;
    _max?: Maybe<ProductsMaxAggregate>;
    _min?: Maybe<ProductsMinAggregate>;
    _sum?: Maybe<ProductsSumAggregate>;
    categoryIds?: Maybe<Array<Scalars['Int']['output']>>;
    displayMetadata?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    popularity: Scalars['Float']['output'];
    product_page_type: ProductPageType;
    product_type: ProductType;
    renderConfig: Scalars['JSON']['output'];
};

export type ProductsListRelationFilter = {
    every?: InputMaybe<ProductsWhereInput>;
    none?: InputMaybe<ProductsWhereInput>;
    some?: InputMaybe<ProductsWhereInput>;
};

export type ProductsMaxAggregate = {
    __typename?: 'ProductsMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
    product_page_type?: Maybe<ProductPageType>;
    product_type?: Maybe<ProductType>;
};

export type ProductsMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    product_page_type?: InputMaybe<SortOrder>;
    product_type?: InputMaybe<SortOrder>;
};

export type ProductsMinAggregate = {
    __typename?: 'ProductsMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
    product_page_type?: Maybe<ProductPageType>;
    product_type?: Maybe<ProductType>;
};

export type ProductsMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    product_page_type?: InputMaybe<SortOrder>;
    product_type?: InputMaybe<SortOrder>;
};

export type ProductsOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProductsOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProductsAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProductsCountOrderByAggregateInput>;
    _max?: InputMaybe<ProductsMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProductsMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProductsSumOrderByAggregateInput>;
    categoryIds?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    product_page_type?: InputMaybe<SortOrder>;
    product_type?: InputMaybe<SortOrder>;
    renderConfig?: InputMaybe<SortOrder>;
};

export type ProductsOrderByWithRelationInput = {
    ProductTranslation?: InputMaybe<ProductTranslationOrderByRelationAggregateInput>;
    categoryIds?: InputMaybe<SortOrder>;
    displayMetadata?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
    productToBundle?: InputMaybe<ProductToBundleOrderByRelationAggregateInput>;
    productToHrt?: InputMaybe<ProductToHrtOrderByRelationAggregateInput>;
    product_page_type?: InputMaybe<SortOrder>;
    product_type?: InputMaybe<SortOrder>;
    renderConfig?: InputMaybe<SortOrder>;
};

export type ProductsRelationFilter = {
    is?: InputMaybe<ProductsWhereInput>;
    isNot?: InputMaybe<ProductsWhereInput>;
};

export enum ProductsScalarFieldEnum {
    CategoryIds = 'categoryIds',
    DisplayMetadata = 'displayMetadata',
    Id = 'id',
    Name = 'name',
    OrgId = 'orgId',
    Popularity = 'popularity',
    ProductPageType = 'product_page_type',
    ProductType = 'product_type',
    RenderConfig = 'renderConfig',
}

export type ProductsScalarWhereInput = {
    AND?: InputMaybe<Array<ProductsScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProductsScalarWhereInput>>;
    OR?: InputMaybe<Array<ProductsScalarWhereInput>>;
    categoryIds?: InputMaybe<IntNullableListFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<IntFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntFilter>;
    popularity?: InputMaybe<FloatFilter>;
    product_page_type?: InputMaybe<EnumProductPageTypeFilter>;
    product_type?: InputMaybe<EnumProductTypeFilter>;
    renderConfig?: InputMaybe<JsonFilter>;
};

export type ProductsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProductsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProductsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProductsScalarWhereWithAggregatesInput>>;
    categoryIds?: InputMaybe<IntNullableListFilter>;
    displayMetadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    popularity?: InputMaybe<FloatWithAggregatesFilter>;
    product_page_type?: InputMaybe<EnumProductPageTypeWithAggregatesFilter>;
    product_type?: InputMaybe<EnumProductTypeWithAggregatesFilter>;
    renderConfig?: InputMaybe<JsonWithAggregatesFilter>;
};

export type ProductsSumAggregate = {
    __typename?: 'ProductsSumAggregate';
    categoryIds?: Maybe<Array<Scalars['Int']['output']>>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    popularity?: Maybe<Scalars['Float']['output']>;
};

export type ProductsSumOrderByAggregateInput = {
    categoryIds?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    popularity?: InputMaybe<SortOrder>;
};

export type ProductsUpdateInput = {
    ProductTranslation?: InputMaybe<ProductTranslationUpdateManyWithoutProductsNestedInput>;
    categoryIds?: InputMaybe<ProductsUpdatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutProductsNestedInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    productToBundle?: InputMaybe<ProductToBundleUpdateManyWithoutProductNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutProductNestedInput>;
    product_page_type?: InputMaybe<EnumProductPageTypeFieldUpdateOperationsInput>;
    product_type?: InputMaybe<EnumProductTypeFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsUpdateManyMutationInput = {
    categoryIds?: InputMaybe<ProductsUpdatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    product_page_type?: InputMaybe<EnumProductPageTypeFieldUpdateOperationsInput>;
    product_type?: InputMaybe<EnumProductTypeFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsUpdateManyWithWhereWithoutOrgInput = {
    data: ProductsUpdateManyMutationInput;
    where: ProductsScalarWhereInput;
};

export type ProductsUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<ProductsWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<ProductsCreateOrConnectWithoutOrgInput>>;
    create?: InputMaybe<Array<ProductsCreateWithoutOrgInput>>;
    createMany?: InputMaybe<ProductsCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<ProductsWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProductsScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProductsWhereUniqueInput>>;
    set?: InputMaybe<Array<ProductsWhereUniqueInput>>;
    update?: InputMaybe<Array<ProductsUpdateWithWhereUniqueWithoutOrgInput>>;
    updateMany?: InputMaybe<Array<ProductsUpdateManyWithWhereWithoutOrgInput>>;
    upsert?: InputMaybe<Array<ProductsUpsertWithWhereUniqueWithoutOrgInput>>;
};

export type ProductsUpdateOneRequiredWithoutProductToBundleNestedInput = {
    connect?: InputMaybe<ProductsWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProductsCreateOrConnectWithoutProductToBundleInput>;
    create?: InputMaybe<ProductsCreateWithoutProductToBundleInput>;
    update?: InputMaybe<ProductsUpdateToOneWithWhereWithoutProductToBundleInput>;
    upsert?: InputMaybe<ProductsUpsertWithoutProductToBundleInput>;
};

export type ProductsUpdateOneRequiredWithoutProductToHrtNestedInput = {
    connect?: InputMaybe<ProductsWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProductsCreateOrConnectWithoutProductToHrtInput>;
    create?: InputMaybe<ProductsCreateWithoutProductToHrtInput>;
    update?: InputMaybe<ProductsUpdateToOneWithWhereWithoutProductToHrtInput>;
    upsert?: InputMaybe<ProductsUpsertWithoutProductToHrtInput>;
};

export type ProductsUpdateOneRequiredWithoutProductTranslationNestedInput = {
    connect?: InputMaybe<ProductsWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProductsCreateOrConnectWithoutProductTranslationInput>;
    create?: InputMaybe<ProductsCreateWithoutProductTranslationInput>;
    update?: InputMaybe<ProductsUpdateToOneWithWhereWithoutProductTranslationInput>;
    upsert?: InputMaybe<ProductsUpsertWithoutProductTranslationInput>;
};

export type ProductsUpdateToOneWithWhereWithoutProductToBundleInput = {
    data: ProductsUpdateWithoutProductToBundleInput;
    where?: InputMaybe<ProductsWhereInput>;
};

export type ProductsUpdateToOneWithWhereWithoutProductToHrtInput = {
    data: ProductsUpdateWithoutProductToHrtInput;
    where?: InputMaybe<ProductsWhereInput>;
};

export type ProductsUpdateToOneWithWhereWithoutProductTranslationInput = {
    data: ProductsUpdateWithoutProductTranslationInput;
    where?: InputMaybe<ProductsWhereInput>;
};

export type ProductsUpdateWithWhereUniqueWithoutOrgInput = {
    data: ProductsUpdateWithoutOrgInput;
    where: ProductsWhereUniqueInput;
};

export type ProductsUpdateWithoutOrgInput = {
    ProductTranslation?: InputMaybe<ProductTranslationUpdateManyWithoutProductsNestedInput>;
    categoryIds?: InputMaybe<ProductsUpdatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    productToBundle?: InputMaybe<ProductToBundleUpdateManyWithoutProductNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutProductNestedInput>;
    product_page_type?: InputMaybe<EnumProductPageTypeFieldUpdateOperationsInput>;
    product_type?: InputMaybe<EnumProductTypeFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsUpdateWithoutProductToBundleInput = {
    ProductTranslation?: InputMaybe<ProductTranslationUpdateManyWithoutProductsNestedInput>;
    categoryIds?: InputMaybe<ProductsUpdatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutProductsNestedInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutProductNestedInput>;
    product_page_type?: InputMaybe<EnumProductPageTypeFieldUpdateOperationsInput>;
    product_type?: InputMaybe<EnumProductTypeFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsUpdateWithoutProductToHrtInput = {
    ProductTranslation?: InputMaybe<ProductTranslationUpdateManyWithoutProductsNestedInput>;
    categoryIds?: InputMaybe<ProductsUpdatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutProductsNestedInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    productToBundle?: InputMaybe<ProductToBundleUpdateManyWithoutProductNestedInput>;
    product_page_type?: InputMaybe<EnumProductPageTypeFieldUpdateOperationsInput>;
    product_type?: InputMaybe<EnumProductTypeFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsUpdateWithoutProductTranslationInput = {
    categoryIds?: InputMaybe<ProductsUpdatecategoryIdsInput>;
    displayMetadata?: InputMaybe<Scalars['JSON']['input']>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutProductsNestedInput>;
    popularity?: InputMaybe<FloatFieldUpdateOperationsInput>;
    productToBundle?: InputMaybe<ProductToBundleUpdateManyWithoutProductNestedInput>;
    productToHrt?: InputMaybe<ProductToHrtUpdateManyWithoutProductNestedInput>;
    product_page_type?: InputMaybe<EnumProductPageTypeFieldUpdateOperationsInput>;
    product_type?: InputMaybe<EnumProductTypeFieldUpdateOperationsInput>;
    renderConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProductsUpdatecategoryIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ProductsUpsertWithWhereUniqueWithoutOrgInput = {
    create: ProductsCreateWithoutOrgInput;
    update: ProductsUpdateWithoutOrgInput;
    where: ProductsWhereUniqueInput;
};

export type ProductsUpsertWithoutProductToBundleInput = {
    create: ProductsCreateWithoutProductToBundleInput;
    update: ProductsUpdateWithoutProductToBundleInput;
    where?: InputMaybe<ProductsWhereInput>;
};

export type ProductsUpsertWithoutProductToHrtInput = {
    create: ProductsCreateWithoutProductToHrtInput;
    update: ProductsUpdateWithoutProductToHrtInput;
    where?: InputMaybe<ProductsWhereInput>;
};

export type ProductsUpsertWithoutProductTranslationInput = {
    create: ProductsCreateWithoutProductTranslationInput;
    update: ProductsUpdateWithoutProductTranslationInput;
    where?: InputMaybe<ProductsWhereInput>;
};

export type ProductsWhereInput = {
    AND?: InputMaybe<Array<ProductsWhereInput>>;
    NOT?: InputMaybe<Array<ProductsWhereInput>>;
    OR?: InputMaybe<Array<ProductsWhereInput>>;
    ProductTranslation?: InputMaybe<ProductTranslationListRelationFilter>;
    categoryIds?: InputMaybe<IntNullableListFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<IntFilter>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    popularity?: InputMaybe<FloatFilter>;
    productToBundle?: InputMaybe<ProductToBundleListRelationFilter>;
    productToHrt?: InputMaybe<ProductToHrtListRelationFilter>;
    product_page_type?: InputMaybe<EnumProductPageTypeFilter>;
    product_type?: InputMaybe<EnumProductTypeFilter>;
    renderConfig?: InputMaybe<JsonFilter>;
};

export type ProductsWhereUniqueInput = {
    AND?: InputMaybe<Array<ProductsWhereInput>>;
    NOT?: InputMaybe<Array<ProductsWhereInput>>;
    OR?: InputMaybe<Array<ProductsWhereInput>>;
    ProductTranslation?: InputMaybe<ProductTranslationListRelationFilter>;
    categoryIds?: InputMaybe<IntNullableListFilter>;
    displayMetadata?: InputMaybe<JsonNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<StringFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    popularity?: InputMaybe<FloatFilter>;
    productToBundle?: InputMaybe<ProductToBundleListRelationFilter>;
    productToHrt?: InputMaybe<ProductToHrtListRelationFilter>;
    product_page_type?: InputMaybe<EnumProductPageTypeFilter>;
    product_type?: InputMaybe<EnumProductTypeFilter>;
    renderConfig?: InputMaybe<JsonFilter>;
};

export type Provider = {
    __typename?: 'Provider';
    _count?: Maybe<ProviderCount>;
    degrees?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    displayFirstName?: Maybe<Scalars['String']['output']>;
    displayLastName?: Maybe<Scalars['String']['output']>;
    ehrId?: Maybe<Scalars['String']['output']>;
    firstName: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    imageUrl?: Maybe<Scalars['String']['output']>;
    isSpecialist?: Maybe<Scalars['Boolean']['output']>;
    lastName: Scalars['String']['output'];
    npiId: Scalars['String']['output'];
    providerCredentialings: Array<ProviderCredentialing>;
    providerHrtMaxCount: Array<ProviderHrtMaxCount>;
    providerToOrgs: Array<ProviderToOrg>;
    providerToProviderGroups: Array<ProviderToProviderGroup>;
    taxonomy?: Maybe<ProviderTaxonomy>;
    taxonomyCode?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type ProviderProviderCredentialingsArgs = {
    cursor?: InputMaybe<ProviderCredentialingWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderCredentialingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderCredentialingOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderCredentialingWhereInput>;
};

export type ProviderProviderHrtMaxCountArgs = {
    cursor?: InputMaybe<ProviderHrtMaxCountWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderHrtMaxCountScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderHrtMaxCountOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type ProviderProviderToOrgsArgs = {
    cursor?: InputMaybe<ProviderToOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderToOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderToOrgOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type ProviderProviderToProviderGroupsArgs = {
    cursor?: InputMaybe<ProviderToProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderToProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProviderToProviderGroupOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type ProviderTaxonomyArgs = {
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type ProviderAvgAggregate = {
    __typename?: 'ProviderAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type ProviderAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ProviderCount = {
    __typename?: 'ProviderCount';
    providerCredentialings: Scalars['Int']['output'];
    providerHrtMaxCount: Scalars['Int']['output'];
    providerToOrgs: Scalars['Int']['output'];
    providerToProviderGroups: Scalars['Int']['output'];
};

export type ProviderCountProviderCredentialingsArgs = {
    where?: InputMaybe<ProviderCredentialingWhereInput>;
};

export type ProviderCountProviderHrtMaxCountArgs = {
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type ProviderCountProviderToOrgsArgs = {
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type ProviderCountProviderToProviderGroupsArgs = {
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type ProviderCountAggregate = {
    __typename?: 'ProviderCountAggregate';
    _all: Scalars['Int']['output'];
    degrees: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    displayFirstName: Scalars['Int']['output'];
    displayLastName: Scalars['Int']['output'];
    ehrId: Scalars['Int']['output'];
    firstName: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    imageUrl: Scalars['Int']['output'];
    isSpecialist: Scalars['Int']['output'];
    lastName: Scalars['Int']['output'];
    npiId: Scalars['Int']['output'];
    taxonomyCode: Scalars['Int']['output'];
    title: Scalars['Int']['output'];
};

export type ProviderCountOrderByAggregateInput = {
    degrees?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    displayFirstName?: InputMaybe<SortOrder>;
    displayLastName?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    imageUrl?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    npiId?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrder>;
    title?: InputMaybe<SortOrder>;
};

export type ProviderCreateInput = {
    degrees?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    displayFirstName?: InputMaybe<Scalars['String']['input']>;
    displayLastName?: InputMaybe<Scalars['String']['input']>;
    ehrId?: InputMaybe<Scalars['String']['input']>;
    firstName: Scalars['String']['input'];
    id: Scalars['Int']['input'];
    imageUrl?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    lastName: Scalars['String']['input'];
    npiId: Scalars['String']['input'];
    providerCredentialings?: InputMaybe<ProviderCredentialingCreateNestedManyWithoutProviderInput>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutProviderInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutProviderInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupCreateNestedManyWithoutProviderInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyCreateNestedOneWithoutProviderInput>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreateManyInput = {
    degrees?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    displayFirstName?: InputMaybe<Scalars['String']['input']>;
    displayLastName?: InputMaybe<Scalars['String']['input']>;
    ehrId?: InputMaybe<Scalars['String']['input']>;
    firstName: Scalars['String']['input'];
    id: Scalars['Int']['input'];
    imageUrl?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    lastName: Scalars['String']['input'];
    npiId: Scalars['String']['input'];
    taxonomyCode?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreateManyTaxonomyInput = {
    degrees?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    displayFirstName?: InputMaybe<Scalars['String']['input']>;
    displayLastName?: InputMaybe<Scalars['String']['input']>;
    ehrId?: InputMaybe<Scalars['String']['input']>;
    firstName: Scalars['String']['input'];
    id: Scalars['Int']['input'];
    imageUrl?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    lastName: Scalars['String']['input'];
    npiId: Scalars['String']['input'];
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreateManyTaxonomyInputEnvelope = {
    data: Array<ProviderCreateManyTaxonomyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderCreateNestedManyWithoutTaxonomyInput = {
    connect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderCreateOrConnectWithoutTaxonomyInput>
    >;
    create?: InputMaybe<Array<ProviderCreateWithoutTaxonomyInput>>;
    createMany?: InputMaybe<ProviderCreateManyTaxonomyInputEnvelope>;
};

export type ProviderCreateNestedOneWithoutProviderCredentialingsInput = {
    connect?: InputMaybe<ProviderWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutProviderCredentialingsInput>;
    create?: InputMaybe<ProviderCreateWithoutProviderCredentialingsInput>;
};

export type ProviderCreateNestedOneWithoutProviderHrtMaxCountInput = {
    connect?: InputMaybe<ProviderWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutProviderHrtMaxCountInput>;
    create?: InputMaybe<ProviderCreateWithoutProviderHrtMaxCountInput>;
};

export type ProviderCreateNestedOneWithoutProviderToOrgsInput = {
    connect?: InputMaybe<ProviderWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutProviderToOrgsInput>;
    create?: InputMaybe<ProviderCreateWithoutProviderToOrgsInput>;
};

export type ProviderCreateNestedOneWithoutProviderToProviderGroupsInput = {
    connect?: InputMaybe<ProviderWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutProviderToProviderGroupsInput>;
    create?: InputMaybe<ProviderCreateWithoutProviderToProviderGroupsInput>;
};

export type ProviderCreateOrConnectWithoutProviderCredentialingsInput = {
    create: ProviderCreateWithoutProviderCredentialingsInput;
    where: ProviderWhereUniqueInput;
};

export type ProviderCreateOrConnectWithoutProviderHrtMaxCountInput = {
    create: ProviderCreateWithoutProviderHrtMaxCountInput;
    where: ProviderWhereUniqueInput;
};

export type ProviderCreateOrConnectWithoutProviderToOrgsInput = {
    create: ProviderCreateWithoutProviderToOrgsInput;
    where: ProviderWhereUniqueInput;
};

export type ProviderCreateOrConnectWithoutProviderToProviderGroupsInput = {
    create: ProviderCreateWithoutProviderToProviderGroupsInput;
    where: ProviderWhereUniqueInput;
};

export type ProviderCreateOrConnectWithoutTaxonomyInput = {
    create: ProviderCreateWithoutTaxonomyInput;
    where: ProviderWhereUniqueInput;
};

export type ProviderCreateWithoutProviderCredentialingsInput = {
    degrees?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    displayFirstName?: InputMaybe<Scalars['String']['input']>;
    displayLastName?: InputMaybe<Scalars['String']['input']>;
    ehrId?: InputMaybe<Scalars['String']['input']>;
    firstName: Scalars['String']['input'];
    id: Scalars['Int']['input'];
    imageUrl?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    lastName: Scalars['String']['input'];
    npiId: Scalars['String']['input'];
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutProviderInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutProviderInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupCreateNestedManyWithoutProviderInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyCreateNestedOneWithoutProviderInput>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreateWithoutProviderHrtMaxCountInput = {
    degrees?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    displayFirstName?: InputMaybe<Scalars['String']['input']>;
    displayLastName?: InputMaybe<Scalars['String']['input']>;
    ehrId?: InputMaybe<Scalars['String']['input']>;
    firstName: Scalars['String']['input'];
    id: Scalars['Int']['input'];
    imageUrl?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    lastName: Scalars['String']['input'];
    npiId: Scalars['String']['input'];
    providerCredentialings?: InputMaybe<ProviderCredentialingCreateNestedManyWithoutProviderInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutProviderInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupCreateNestedManyWithoutProviderInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyCreateNestedOneWithoutProviderInput>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreateWithoutProviderToOrgsInput = {
    degrees?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    displayFirstName?: InputMaybe<Scalars['String']['input']>;
    displayLastName?: InputMaybe<Scalars['String']['input']>;
    ehrId?: InputMaybe<Scalars['String']['input']>;
    firstName: Scalars['String']['input'];
    id: Scalars['Int']['input'];
    imageUrl?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    lastName: Scalars['String']['input'];
    npiId: Scalars['String']['input'];
    providerCredentialings?: InputMaybe<ProviderCredentialingCreateNestedManyWithoutProviderInput>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutProviderInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupCreateNestedManyWithoutProviderInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyCreateNestedOneWithoutProviderInput>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreateWithoutProviderToProviderGroupsInput = {
    degrees?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    displayFirstName?: InputMaybe<Scalars['String']['input']>;
    displayLastName?: InputMaybe<Scalars['String']['input']>;
    ehrId?: InputMaybe<Scalars['String']['input']>;
    firstName: Scalars['String']['input'];
    id: Scalars['Int']['input'];
    imageUrl?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    lastName: Scalars['String']['input'];
    npiId: Scalars['String']['input'];
    providerCredentialings?: InputMaybe<ProviderCredentialingCreateNestedManyWithoutProviderInput>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutProviderInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutProviderInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyCreateNestedOneWithoutProviderInput>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreateWithoutTaxonomyInput = {
    degrees?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    displayFirstName?: InputMaybe<Scalars['String']['input']>;
    displayLastName?: InputMaybe<Scalars['String']['input']>;
    ehrId?: InputMaybe<Scalars['String']['input']>;
    firstName: Scalars['String']['input'];
    id: Scalars['Int']['input'];
    imageUrl?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    lastName: Scalars['String']['input'];
    npiId: Scalars['String']['input'];
    providerCredentialings?: InputMaybe<ProviderCredentialingCreateNestedManyWithoutProviderInput>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountCreateNestedManyWithoutProviderInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgCreateNestedManyWithoutProviderInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupCreateNestedManyWithoutProviderInput>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCredentialing = {
    __typename?: 'ProviderCredentialing';
    npiId: Scalars['String']['output'];
    provider: Provider;
    states: Array<Scalars['String']['output']>;
};

export type ProviderCredentialingCountAggregate = {
    __typename?: 'ProviderCredentialingCountAggregate';
    _all: Scalars['Int']['output'];
    npiId: Scalars['Int']['output'];
    states: Scalars['Int']['output'];
};

export type ProviderCredentialingCountOrderByAggregateInput = {
    npiId?: InputMaybe<SortOrder>;
    states?: InputMaybe<SortOrder>;
};

export type ProviderCredentialingCreateInput = {
    provider: ProviderCreateNestedOneWithoutProviderCredentialingsInput;
    states?: InputMaybe<ProviderCredentialingCreatestatesInput>;
};

export type ProviderCredentialingCreateManyInput = {
    npiId: Scalars['String']['input'];
    states?: InputMaybe<ProviderCredentialingCreatestatesInput>;
};

export type ProviderCredentialingCreateManyProviderInput = {
    states?: InputMaybe<ProviderCredentialingCreatestatesInput>;
};

export type ProviderCredentialingCreateManyProviderInputEnvelope = {
    data: Array<ProviderCredentialingCreateManyProviderInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderCredentialingCreateNestedManyWithoutProviderInput = {
    connect?: InputMaybe<Array<ProviderCredentialingWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderCredentialingCreateOrConnectWithoutProviderInput>
    >;
    create?: InputMaybe<Array<ProviderCredentialingCreateWithoutProviderInput>>;
    createMany?: InputMaybe<ProviderCredentialingCreateManyProviderInputEnvelope>;
};

export type ProviderCredentialingCreateOrConnectWithoutProviderInput = {
    create: ProviderCredentialingCreateWithoutProviderInput;
    where: ProviderCredentialingWhereUniqueInput;
};

export type ProviderCredentialingCreateWithoutProviderInput = {
    states?: InputMaybe<ProviderCredentialingCreatestatesInput>;
};

export type ProviderCredentialingCreatestatesInput = {
    set: Array<Scalars['String']['input']>;
};

export type ProviderCredentialingGroupBy = {
    __typename?: 'ProviderCredentialingGroupBy';
    _count?: Maybe<ProviderCredentialingCountAggregate>;
    _max?: Maybe<ProviderCredentialingMaxAggregate>;
    _min?: Maybe<ProviderCredentialingMinAggregate>;
    npiId: Scalars['String']['output'];
    states?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProviderCredentialingListRelationFilter = {
    every?: InputMaybe<ProviderCredentialingWhereInput>;
    none?: InputMaybe<ProviderCredentialingWhereInput>;
    some?: InputMaybe<ProviderCredentialingWhereInput>;
};

export type ProviderCredentialingMaxAggregate = {
    __typename?: 'ProviderCredentialingMaxAggregate';
    npiId?: Maybe<Scalars['String']['output']>;
};

export type ProviderCredentialingMaxOrderByAggregateInput = {
    npiId?: InputMaybe<SortOrder>;
};

export type ProviderCredentialingMinAggregate = {
    __typename?: 'ProviderCredentialingMinAggregate';
    npiId?: Maybe<Scalars['String']['output']>;
};

export type ProviderCredentialingMinOrderByAggregateInput = {
    npiId?: InputMaybe<SortOrder>;
};

export type ProviderCredentialingOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProviderCredentialingOrderByWithAggregationInput = {
    _count?: InputMaybe<ProviderCredentialingCountOrderByAggregateInput>;
    _max?: InputMaybe<ProviderCredentialingMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProviderCredentialingMinOrderByAggregateInput>;
    npiId?: InputMaybe<SortOrder>;
    states?: InputMaybe<SortOrder>;
};

export type ProviderCredentialingOrderByWithRelationInput = {
    npiId?: InputMaybe<SortOrder>;
    provider?: InputMaybe<ProviderOrderByWithRelationInput>;
    states?: InputMaybe<SortOrder>;
};

export enum ProviderCredentialingScalarFieldEnum {
    NpiId = 'npiId',
    States = 'states',
}

export type ProviderCredentialingScalarWhereInput = {
    AND?: InputMaybe<Array<ProviderCredentialingScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProviderCredentialingScalarWhereInput>>;
    OR?: InputMaybe<Array<ProviderCredentialingScalarWhereInput>>;
    npiId?: InputMaybe<StringFilter>;
    states?: InputMaybe<StringNullableListFilter>;
};

export type ProviderCredentialingScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<ProviderCredentialingScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<ProviderCredentialingScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<Array<ProviderCredentialingScalarWhereWithAggregatesInput>>;
    npiId?: InputMaybe<StringWithAggregatesFilter>;
    states?: InputMaybe<StringNullableListFilter>;
};

export type ProviderCredentialingUpdateInput = {
    provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderCredentialingsNestedInput>;
    states?: InputMaybe<ProviderCredentialingUpdatestatesInput>;
};

export type ProviderCredentialingUpdateManyMutationInput = {
    states?: InputMaybe<ProviderCredentialingUpdatestatesInput>;
};

export type ProviderCredentialingUpdateManyWithWhereWithoutProviderInput = {
    data: ProviderCredentialingUpdateManyMutationInput;
    where: ProviderCredentialingScalarWhereInput;
};

export type ProviderCredentialingUpdateManyWithoutProviderNestedInput = {
    connect?: InputMaybe<Array<ProviderCredentialingWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderCredentialingCreateOrConnectWithoutProviderInput>
    >;
    create?: InputMaybe<Array<ProviderCredentialingCreateWithoutProviderInput>>;
    createMany?: InputMaybe<ProviderCredentialingCreateManyProviderInputEnvelope>;
    delete?: InputMaybe<Array<ProviderCredentialingWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderCredentialingScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderCredentialingWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderCredentialingWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderCredentialingUpdateWithWhereUniqueWithoutProviderInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderCredentialingUpdateManyWithWhereWithoutProviderInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderCredentialingUpsertWithWhereUniqueWithoutProviderInput>
    >;
};

export type ProviderCredentialingUpdateWithWhereUniqueWithoutProviderInput = {
    data: ProviderCredentialingUpdateWithoutProviderInput;
    where: ProviderCredentialingWhereUniqueInput;
};

export type ProviderCredentialingUpdateWithoutProviderInput = {
    states?: InputMaybe<ProviderCredentialingUpdatestatesInput>;
};

export type ProviderCredentialingUpdatestatesInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProviderCredentialingUpsertWithWhereUniqueWithoutProviderInput = {
    create: ProviderCredentialingCreateWithoutProviderInput;
    update: ProviderCredentialingUpdateWithoutProviderInput;
    where: ProviderCredentialingWhereUniqueInput;
};

export type ProviderCredentialingWhereInput = {
    AND?: InputMaybe<Array<ProviderCredentialingWhereInput>>;
    NOT?: InputMaybe<Array<ProviderCredentialingWhereInput>>;
    OR?: InputMaybe<Array<ProviderCredentialingWhereInput>>;
    npiId?: InputMaybe<StringFilter>;
    provider?: InputMaybe<ProviderRelationFilter>;
    states?: InputMaybe<StringNullableListFilter>;
};

export type ProviderCredentialingWhereUniqueInput = {
    AND?: InputMaybe<Array<ProviderCredentialingWhereInput>>;
    NOT?: InputMaybe<Array<ProviderCredentialingWhereInput>>;
    OR?: InputMaybe<Array<ProviderCredentialingWhereInput>>;
    npiId?: InputMaybe<Scalars['String']['input']>;
    provider?: InputMaybe<ProviderRelationFilter>;
    states?: InputMaybe<StringNullableListFilter>;
};

export type ProviderGroup = {
    __typename?: 'ProviderGroup';
    _count?: Maybe<ProviderGroupCount>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    isSpecialist: Scalars['Boolean']['output'];
    name?: Maybe<Scalars['String']['output']>;
    placeOfService?: Maybe<PlaceOfServiceCode>;
    placeOfServiceCode?: Maybe<Scalars['String']['output']>;
    practice: Practice;
    practiceId: Scalars['Int']['output'];
    providerGroupId: Scalars['Int']['output'];
    providerGroupToHrt: Array<ProviderGroupToHrt>;
    providerToProviderGroup: Array<ProviderToProviderGroup>;
    taxonomy?: Maybe<ProviderTaxonomy>;
    taxonomyCode?: Maybe<Scalars['String']['output']>;
};

export type ProviderGroupPlaceOfServiceArgs = {
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type ProviderGroupProviderGroupToHrtArgs = {
    cursor?: InputMaybe<ProviderGroupToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupToHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type ProviderGroupProviderToProviderGroupArgs = {
    cursor?: InputMaybe<ProviderToProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderToProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProviderToProviderGroupOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type ProviderGroupTaxonomyArgs = {
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type ProviderGroupAvgAggregate = {
    __typename?: 'ProviderGroupAvgAggregate';
    practiceId?: Maybe<Scalars['Float']['output']>;
    providerGroupId?: Maybe<Scalars['Float']['output']>;
};

export type ProviderGroupAvgOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ProviderGroupBy = {
    __typename?: 'ProviderGroupBy';
    _avg?: Maybe<ProviderAvgAggregate>;
    _count?: Maybe<ProviderCountAggregate>;
    _max?: Maybe<ProviderMaxAggregate>;
    _min?: Maybe<ProviderMinAggregate>;
    _sum?: Maybe<ProviderSumAggregate>;
    degrees?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    displayFirstName?: Maybe<Scalars['String']['output']>;
    displayLastName?: Maybe<Scalars['String']['output']>;
    ehrId?: Maybe<Scalars['String']['output']>;
    firstName: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    imageUrl?: Maybe<Scalars['String']['output']>;
    isSpecialist?: Maybe<Scalars['Boolean']['output']>;
    lastName: Scalars['String']['output'];
    npiId: Scalars['String']['output'];
    taxonomyCode?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type ProviderGroupCount = {
    __typename?: 'ProviderGroupCount';
    providerGroupToHrt: Scalars['Int']['output'];
    providerToProviderGroup: Scalars['Int']['output'];
};

export type ProviderGroupCountProviderGroupToHrtArgs = {
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type ProviderGroupCountProviderToProviderGroupArgs = {
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type ProviderGroupCountAggregate = {
    __typename?: 'ProviderGroupCountAggregate';
    _all: Scalars['Int']['output'];
    ehrDepartmentId: Scalars['Int']['output'];
    isSpecialist: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    placeOfServiceCode: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    providerGroupId: Scalars['Int']['output'];
    taxonomyCode: Scalars['Int']['output'];
};

export type ProviderGroupCountOrderByAggregateInput = {
    ehrDepartmentId?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrder>;
};

export type ProviderGroupCreateInput = {
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutProviderGroupInput>;
    practice: PracticeCreateNestedOneWithoutProviderGroupsInput;
    providerGroupId: Scalars['Int']['input'];
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutProviderGroupInput>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupCreateNestedManyWithoutProviderGroupInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyCreateNestedOneWithoutProviderGroupInput>;
};

export type ProviderGroupCreateManyInput = {
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    placeOfServiceCode?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    providerGroupId: Scalars['Int']['input'];
    taxonomyCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderGroupCreateManyPlaceOfServiceInput = {
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    providerGroupId: Scalars['Int']['input'];
    taxonomyCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderGroupCreateManyPlaceOfServiceInputEnvelope = {
    data: Array<ProviderGroupCreateManyPlaceOfServiceInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderGroupCreateManyPracticeInput = {
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    placeOfServiceCode?: InputMaybe<Scalars['String']['input']>;
    providerGroupId: Scalars['Int']['input'];
    taxonomyCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderGroupCreateManyPracticeInputEnvelope = {
    data: Array<ProviderGroupCreateManyPracticeInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderGroupCreateManyTaxonomyInput = {
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    placeOfServiceCode?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    providerGroupId: Scalars['Int']['input'];
};

export type ProviderGroupCreateManyTaxonomyInputEnvelope = {
    data: Array<ProviderGroupCreateManyTaxonomyInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderGroupCreateNestedManyWithoutPlaceOfServiceInput = {
    connect?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderGroupCreateOrConnectWithoutPlaceOfServiceInput>
    >;
    create?: InputMaybe<Array<ProviderGroupCreateWithoutPlaceOfServiceInput>>;
    createMany?: InputMaybe<ProviderGroupCreateManyPlaceOfServiceInputEnvelope>;
};

export type ProviderGroupCreateNestedManyWithoutPracticeInput = {
    connect?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderGroupCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<Array<ProviderGroupCreateWithoutPracticeInput>>;
    createMany?: InputMaybe<ProviderGroupCreateManyPracticeInputEnvelope>;
};

export type ProviderGroupCreateNestedManyWithoutTaxonomyInput = {
    connect?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderGroupCreateOrConnectWithoutTaxonomyInput>
    >;
    create?: InputMaybe<Array<ProviderGroupCreateWithoutTaxonomyInput>>;
    createMany?: InputMaybe<ProviderGroupCreateManyTaxonomyInputEnvelope>;
};

export type ProviderGroupCreateNestedOneWithoutProviderGroupToHrtInput = {
    connect?: InputMaybe<ProviderGroupWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderGroupCreateOrConnectWithoutProviderGroupToHrtInput>;
    create?: InputMaybe<ProviderGroupCreateWithoutProviderGroupToHrtInput>;
};

export type ProviderGroupCreateNestedOneWithoutProviderToProviderGroupInput = {
    connect?: InputMaybe<ProviderGroupWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderGroupCreateOrConnectWithoutProviderToProviderGroupInput>;
    create?: InputMaybe<ProviderGroupCreateWithoutProviderToProviderGroupInput>;
};

export type ProviderGroupCreateOrConnectWithoutPlaceOfServiceInput = {
    create: ProviderGroupCreateWithoutPlaceOfServiceInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupCreateOrConnectWithoutPracticeInput = {
    create: ProviderGroupCreateWithoutPracticeInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupCreateOrConnectWithoutProviderGroupToHrtInput = {
    create: ProviderGroupCreateWithoutProviderGroupToHrtInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupCreateOrConnectWithoutProviderToProviderGroupInput = {
    create: ProviderGroupCreateWithoutProviderToProviderGroupInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupCreateOrConnectWithoutTaxonomyInput = {
    create: ProviderGroupCreateWithoutTaxonomyInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupCreateWithoutPlaceOfServiceInput = {
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    practice: PracticeCreateNestedOneWithoutProviderGroupsInput;
    providerGroupId: Scalars['Int']['input'];
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutProviderGroupInput>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupCreateNestedManyWithoutProviderGroupInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyCreateNestedOneWithoutProviderGroupInput>;
};

export type ProviderGroupCreateWithoutPracticeInput = {
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutProviderGroupInput>;
    providerGroupId: Scalars['Int']['input'];
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutProviderGroupInput>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupCreateNestedManyWithoutProviderGroupInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyCreateNestedOneWithoutProviderGroupInput>;
};

export type ProviderGroupCreateWithoutProviderGroupToHrtInput = {
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutProviderGroupInput>;
    practice: PracticeCreateNestedOneWithoutProviderGroupsInput;
    providerGroupId: Scalars['Int']['input'];
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupCreateNestedManyWithoutProviderGroupInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyCreateNestedOneWithoutProviderGroupInput>;
};

export type ProviderGroupCreateWithoutProviderToProviderGroupInput = {
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutProviderGroupInput>;
    practice: PracticeCreateNestedOneWithoutProviderGroupsInput;
    providerGroupId: Scalars['Int']['input'];
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutProviderGroupInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyCreateNestedOneWithoutProviderGroupInput>;
};

export type ProviderGroupCreateWithoutTaxonomyInput = {
    ehrDepartmentId?: InputMaybe<Scalars['String']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeCreateNestedOneWithoutProviderGroupInput>;
    practice: PracticeCreateNestedOneWithoutProviderGroupsInput;
    providerGroupId: Scalars['Int']['input'];
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtCreateNestedManyWithoutProviderGroupInput>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupCreateNestedManyWithoutProviderGroupInput>;
};

export type ProviderGroupGroupBy = {
    __typename?: 'ProviderGroupGroupBy';
    _avg?: Maybe<ProviderGroupAvgAggregate>;
    _count?: Maybe<ProviderGroupCountAggregate>;
    _max?: Maybe<ProviderGroupMaxAggregate>;
    _min?: Maybe<ProviderGroupMinAggregate>;
    _sum?: Maybe<ProviderGroupSumAggregate>;
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    isSpecialist: Scalars['Boolean']['output'];
    name?: Maybe<Scalars['String']['output']>;
    placeOfServiceCode?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
    providerGroupId: Scalars['Int']['output'];
    taxonomyCode?: Maybe<Scalars['String']['output']>;
};

export type ProviderGroupListRelationFilter = {
    every?: InputMaybe<ProviderGroupWhereInput>;
    none?: InputMaybe<ProviderGroupWhereInput>;
    some?: InputMaybe<ProviderGroupWhereInput>;
};

export type ProviderGroupMaxAggregate = {
    __typename?: 'ProviderGroupMaxAggregate';
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    isSpecialist?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    placeOfServiceCode?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    taxonomyCode?: Maybe<Scalars['String']['output']>;
};

export type ProviderGroupMaxOrderByAggregateInput = {
    ehrDepartmentId?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrder>;
};

export type ProviderGroupMinAggregate = {
    __typename?: 'ProviderGroupMinAggregate';
    ehrDepartmentId?: Maybe<Scalars['String']['output']>;
    isSpecialist?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    placeOfServiceCode?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    taxonomyCode?: Maybe<Scalars['String']['output']>;
};

export type ProviderGroupMinOrderByAggregateInput = {
    ehrDepartmentId?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    placeOfServiceCode?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrder>;
};

export type ProviderGroupOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProviderGroupOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProviderGroupAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProviderGroupCountOrderByAggregateInput>;
    _max?: InputMaybe<ProviderGroupMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProviderGroupMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProviderGroupSumOrderByAggregateInput>;
    ehrDepartmentId?: InputMaybe<SortOrderInput>;
    isSpecialist?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrderInput>;
    placeOfServiceCode?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrderInput>;
};

export type ProviderGroupOrderByWithRelationInput = {
    ehrDepartmentId?: InputMaybe<SortOrderInput>;
    isSpecialist?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrderInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeOrderByWithRelationInput>;
    placeOfServiceCode?: InputMaybe<SortOrderInput>;
    practice?: InputMaybe<PracticeOrderByWithRelationInput>;
    practiceId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtOrderByRelationAggregateInput>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupOrderByRelationAggregateInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyOrderByWithRelationInput>;
    taxonomyCode?: InputMaybe<SortOrderInput>;
};

export type ProviderGroupRelationFilter = {
    is?: InputMaybe<ProviderGroupWhereInput>;
    isNot?: InputMaybe<ProviderGroupWhereInput>;
};

export enum ProviderGroupScalarFieldEnum {
    EhrDepartmentId = 'ehrDepartmentId',
    IsSpecialist = 'isSpecialist',
    Name = 'name',
    PlaceOfServiceCode = 'placeOfServiceCode',
    PracticeId = 'practiceId',
    ProviderGroupId = 'providerGroupId',
    TaxonomyCode = 'taxonomyCode',
}

export type ProviderGroupScalarWhereInput = {
    AND?: InputMaybe<Array<ProviderGroupScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProviderGroupScalarWhereInput>>;
    OR?: InputMaybe<Array<ProviderGroupScalarWhereInput>>;
    ehrDepartmentId?: InputMaybe<StringNullableFilter>;
    isSpecialist?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringNullableFilter>;
    placeOfServiceCode?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    providerGroupId?: InputMaybe<IntFilter>;
    taxonomyCode?: InputMaybe<StringNullableFilter>;
};

export type ProviderGroupScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProviderGroupScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProviderGroupScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProviderGroupScalarWhereWithAggregatesInput>>;
    ehrDepartmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    isSpecialist?: InputMaybe<BoolWithAggregatesFilter>;
    name?: InputMaybe<StringNullableWithAggregatesFilter>;
    placeOfServiceCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
    providerGroupId?: InputMaybe<IntWithAggregatesFilter>;
    taxonomyCode?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ProviderGroupSumAggregate = {
    __typename?: 'ProviderGroupSumAggregate';
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ProviderGroupSumOrderByAggregateInput = {
    practiceId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ProviderGroupToHrt = {
    __typename?: 'ProviderGroupToHrt';
    createdAt: Scalars['DateTimeISO']['output'];
    hrt: Hrt;
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    notBookable?: Maybe<Scalars['Boolean']['output']>;
    providerGroup: ProviderGroup;
    providerGroupId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProviderGroupToHrtAvgAggregate = {
    __typename?: 'ProviderGroupToHrtAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    providerGroupId?: Maybe<Scalars['Float']['output']>;
};

export type ProviderGroupToHrtAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ProviderGroupToHrtCountAggregate = {
    __typename?: 'ProviderGroupToHrtCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    notBookable: Scalars['Int']['output'];
    providerGroupId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ProviderGroupToHrtCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notBookable?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderGroupToHrtCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutProviderGroupToHrtInput;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notBookable?: InputMaybe<Scalars['Boolean']['input']>;
    providerGroup: ProviderGroupCreateNestedOneWithoutProviderGroupToHrtInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderGroupToHrtCreateManyHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notBookable?: InputMaybe<Scalars['Boolean']['input']>;
    providerGroupId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderGroupToHrtCreateManyHrtInputEnvelope = {
    data: Array<ProviderGroupToHrtCreateManyHrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderGroupToHrtCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notBookable?: InputMaybe<Scalars['Boolean']['input']>;
    providerGroupId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderGroupToHrtCreateManyProviderGroupInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notBookable?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderGroupToHrtCreateManyProviderGroupInputEnvelope = {
    data: Array<ProviderGroupToHrtCreateManyProviderGroupInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderGroupToHrtCreateNestedManyWithoutHrtInput = {
    connect?: InputMaybe<Array<ProviderGroupToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderGroupToHrtCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<ProviderGroupToHrtCreateWithoutHrtInput>>;
    createMany?: InputMaybe<ProviderGroupToHrtCreateManyHrtInputEnvelope>;
};

export type ProviderGroupToHrtCreateNestedManyWithoutProviderGroupInput = {
    connect?: InputMaybe<Array<ProviderGroupToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderGroupToHrtCreateOrConnectWithoutProviderGroupInput>
    >;
    create?: InputMaybe<
        Array<ProviderGroupToHrtCreateWithoutProviderGroupInput>
    >;
    createMany?: InputMaybe<ProviderGroupToHrtCreateManyProviderGroupInputEnvelope>;
};

export type ProviderGroupToHrtCreateOrConnectWithoutHrtInput = {
    create: ProviderGroupToHrtCreateWithoutHrtInput;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type ProviderGroupToHrtCreateOrConnectWithoutProviderGroupInput = {
    create: ProviderGroupToHrtCreateWithoutProviderGroupInput;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type ProviderGroupToHrtCreateWithoutHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notBookable?: InputMaybe<Scalars['Boolean']['input']>;
    providerGroup: ProviderGroupCreateNestedOneWithoutProviderGroupToHrtInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderGroupToHrtCreateWithoutProviderGroupInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt: HrtCreateNestedOneWithoutProviderGroupToHrtInput;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notBookable?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderGroupToHrtGroupBy = {
    __typename?: 'ProviderGroupToHrtGroupBy';
    _avg?: Maybe<ProviderGroupToHrtAvgAggregate>;
    _count?: Maybe<ProviderGroupToHrtCountAggregate>;
    _max?: Maybe<ProviderGroupToHrtMaxAggregate>;
    _min?: Maybe<ProviderGroupToHrtMinAggregate>;
    _sum?: Maybe<ProviderGroupToHrtSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    notBookable?: Maybe<Scalars['Boolean']['output']>;
    providerGroupId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProviderGroupToHrtHrtIdProviderGroupIdUniqueCompoundUniqueInput = {
    hrtId: Scalars['Int']['input'];
    providerGroupId: Scalars['Int']['input'];
};

export type ProviderGroupToHrtListRelationFilter = {
    every?: InputMaybe<ProviderGroupToHrtWhereInput>;
    none?: InputMaybe<ProviderGroupToHrtWhereInput>;
    some?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type ProviderGroupToHrtMaxAggregate = {
    __typename?: 'ProviderGroupToHrtMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    notBookable?: Maybe<Scalars['Boolean']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProviderGroupToHrtMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notBookable?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderGroupToHrtMinAggregate = {
    __typename?: 'ProviderGroupToHrtMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    notBookable?: Maybe<Scalars['Boolean']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProviderGroupToHrtMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notBookable?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderGroupToHrtOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProviderGroupToHrtOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProviderGroupToHrtAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProviderGroupToHrtCountOrderByAggregateInput>;
    _max?: InputMaybe<ProviderGroupToHrtMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProviderGroupToHrtMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProviderGroupToHrtSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notBookable?: InputMaybe<SortOrderInput>;
    providerGroupId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderGroupToHrtOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notBookable?: InputMaybe<SortOrderInput>;
    providerGroup?: InputMaybe<ProviderGroupOrderByWithRelationInput>;
    providerGroupId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum ProviderGroupToHrtScalarFieldEnum {
    CreatedAt = 'createdAt',
    HrtId = 'hrtId',
    Id = 'id',
    IsActive = 'isActive',
    NotBookable = 'notBookable',
    ProviderGroupId = 'providerGroupId',
    UpdatedAt = 'updatedAt',
}

export type ProviderGroupToHrtScalarWhereInput = {
    AND?: InputMaybe<Array<ProviderGroupToHrtScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProviderGroupToHrtScalarWhereInput>>;
    OR?: InputMaybe<Array<ProviderGroupToHrtScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    notBookable?: InputMaybe<BoolNullableFilter>;
    providerGroupId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderGroupToHrtScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProviderGroupToHrtScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProviderGroupToHrtScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProviderGroupToHrtScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    notBookable?: InputMaybe<BoolNullableWithAggregatesFilter>;
    providerGroupId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProviderGroupToHrtSumAggregate = {
    __typename?: 'ProviderGroupToHrtSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ProviderGroupToHrtSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ProviderGroupToHrtUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutProviderGroupToHrtNestedInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notBookable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    providerGroup?: InputMaybe<ProviderGroupUpdateOneRequiredWithoutProviderGroupToHrtNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderGroupToHrtUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notBookable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderGroupToHrtUpdateManyWithWhereWithoutHrtInput = {
    data: ProviderGroupToHrtUpdateManyMutationInput;
    where: ProviderGroupToHrtScalarWhereInput;
};

export type ProviderGroupToHrtUpdateManyWithWhereWithoutProviderGroupInput = {
    data: ProviderGroupToHrtUpdateManyMutationInput;
    where: ProviderGroupToHrtScalarWhereInput;
};

export type ProviderGroupToHrtUpdateManyWithoutHrtNestedInput = {
    connect?: InputMaybe<Array<ProviderGroupToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderGroupToHrtCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<ProviderGroupToHrtCreateWithoutHrtInput>>;
    createMany?: InputMaybe<ProviderGroupToHrtCreateManyHrtInputEnvelope>;
    delete?: InputMaybe<Array<ProviderGroupToHrtWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderGroupToHrtScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderGroupToHrtWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderGroupToHrtWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderGroupToHrtUpdateWithWhereUniqueWithoutHrtInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderGroupToHrtUpdateManyWithWhereWithoutHrtInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderGroupToHrtUpsertWithWhereUniqueWithoutHrtInput>
    >;
};

export type ProviderGroupToHrtUpdateManyWithoutProviderGroupNestedInput = {
    connect?: InputMaybe<Array<ProviderGroupToHrtWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderGroupToHrtCreateOrConnectWithoutProviderGroupInput>
    >;
    create?: InputMaybe<
        Array<ProviderGroupToHrtCreateWithoutProviderGroupInput>
    >;
    createMany?: InputMaybe<ProviderGroupToHrtCreateManyProviderGroupInputEnvelope>;
    delete?: InputMaybe<Array<ProviderGroupToHrtWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderGroupToHrtScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderGroupToHrtWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderGroupToHrtWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderGroupToHrtUpdateWithWhereUniqueWithoutProviderGroupInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderGroupToHrtUpdateManyWithWhereWithoutProviderGroupInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderGroupToHrtUpsertWithWhereUniqueWithoutProviderGroupInput>
    >;
};

export type ProviderGroupToHrtUpdateWithWhereUniqueWithoutHrtInput = {
    data: ProviderGroupToHrtUpdateWithoutHrtInput;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type ProviderGroupToHrtUpdateWithWhereUniqueWithoutProviderGroupInput = {
    data: ProviderGroupToHrtUpdateWithoutProviderGroupInput;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type ProviderGroupToHrtUpdateWithoutHrtInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notBookable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    providerGroup?: InputMaybe<ProviderGroupUpdateOneRequiredWithoutProviderGroupToHrtNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderGroupToHrtUpdateWithoutProviderGroupInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneRequiredWithoutProviderGroupToHrtNestedInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notBookable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderGroupToHrtUpsertWithWhereUniqueWithoutHrtInput = {
    create: ProviderGroupToHrtCreateWithoutHrtInput;
    update: ProviderGroupToHrtUpdateWithoutHrtInput;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type ProviderGroupToHrtUpsertWithWhereUniqueWithoutProviderGroupInput = {
    create: ProviderGroupToHrtCreateWithoutProviderGroupInput;
    update: ProviderGroupToHrtUpdateWithoutProviderGroupInput;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type ProviderGroupToHrtWhereInput = {
    AND?: InputMaybe<Array<ProviderGroupToHrtWhereInput>>;
    NOT?: InputMaybe<Array<ProviderGroupToHrtWhereInput>>;
    OR?: InputMaybe<Array<ProviderGroupToHrtWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    notBookable?: InputMaybe<BoolNullableFilter>;
    providerGroup?: InputMaybe<ProviderGroupRelationFilter>;
    providerGroupId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderGroupToHrtWhereUniqueInput = {
    AND?: InputMaybe<Array<ProviderGroupToHrtWhereInput>>;
    NOT?: InputMaybe<Array<ProviderGroupToHrtWhereInput>>;
    OR?: InputMaybe<Array<ProviderGroupToHrtWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrt?: InputMaybe<HrtRelationFilter>;
    hrtId?: InputMaybe<IntFilter>;
    hrtId_providerGroupId_unique?: InputMaybe<ProviderGroupToHrtHrtIdProviderGroupIdUniqueCompoundUniqueInput>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<BoolFilter>;
    notBookable?: InputMaybe<BoolNullableFilter>;
    providerGroup?: InputMaybe<ProviderGroupRelationFilter>;
    providerGroupId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderGroupUpdateInput = {
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutProviderGroupNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutProviderGroupsNestedInput>;
    providerGroupId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutProviderGroupNestedInput>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupUpdateManyWithoutProviderGroupNestedInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyUpdateOneWithoutProviderGroupNestedInput>;
};

export type ProviderGroupUpdateManyMutationInput = {
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    providerGroupId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProviderGroupUpdateManyWithWhereWithoutPlaceOfServiceInput = {
    data: ProviderGroupUpdateManyMutationInput;
    where: ProviderGroupScalarWhereInput;
};

export type ProviderGroupUpdateManyWithWhereWithoutPracticeInput = {
    data: ProviderGroupUpdateManyMutationInput;
    where: ProviderGroupScalarWhereInput;
};

export type ProviderGroupUpdateManyWithWhereWithoutTaxonomyInput = {
    data: ProviderGroupUpdateManyMutationInput;
    where: ProviderGroupScalarWhereInput;
};

export type ProviderGroupUpdateManyWithoutPlaceOfServiceNestedInput = {
    connect?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderGroupCreateOrConnectWithoutPlaceOfServiceInput>
    >;
    create?: InputMaybe<Array<ProviderGroupCreateWithoutPlaceOfServiceInput>>;
    createMany?: InputMaybe<ProviderGroupCreateManyPlaceOfServiceInputEnvelope>;
    delete?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderGroupScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderGroupUpdateWithWhereUniqueWithoutPlaceOfServiceInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderGroupUpdateManyWithWhereWithoutPlaceOfServiceInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderGroupUpsertWithWhereUniqueWithoutPlaceOfServiceInput>
    >;
};

export type ProviderGroupUpdateManyWithoutPracticeNestedInput = {
    connect?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderGroupCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<Array<ProviderGroupCreateWithoutPracticeInput>>;
    createMany?: InputMaybe<ProviderGroupCreateManyPracticeInputEnvelope>;
    delete?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderGroupScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderGroupUpdateWithWhereUniqueWithoutPracticeInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderGroupUpdateManyWithWhereWithoutPracticeInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderGroupUpsertWithWhereUniqueWithoutPracticeInput>
    >;
};

export type ProviderGroupUpdateManyWithoutTaxonomyNestedInput = {
    connect?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderGroupCreateOrConnectWithoutTaxonomyInput>
    >;
    create?: InputMaybe<Array<ProviderGroupCreateWithoutTaxonomyInput>>;
    createMany?: InputMaybe<ProviderGroupCreateManyTaxonomyInputEnvelope>;
    delete?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderGroupScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderGroupWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderGroupUpdateWithWhereUniqueWithoutTaxonomyInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderGroupUpdateManyWithWhereWithoutTaxonomyInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderGroupUpsertWithWhereUniqueWithoutTaxonomyInput>
    >;
};

export type ProviderGroupUpdateOneRequiredWithoutProviderGroupToHrtNestedInput =
    {
        connect?: InputMaybe<ProviderGroupWhereUniqueInput>;
        connectOrCreate?: InputMaybe<ProviderGroupCreateOrConnectWithoutProviderGroupToHrtInput>;
        create?: InputMaybe<ProviderGroupCreateWithoutProviderGroupToHrtInput>;
        update?: InputMaybe<ProviderGroupUpdateToOneWithWhereWithoutProviderGroupToHrtInput>;
        upsert?: InputMaybe<ProviderGroupUpsertWithoutProviderGroupToHrtInput>;
    };

export type ProviderGroupUpdateOneRequiredWithoutProviderToProviderGroupNestedInput =
    {
        connect?: InputMaybe<ProviderGroupWhereUniqueInput>;
        connectOrCreate?: InputMaybe<ProviderGroupCreateOrConnectWithoutProviderToProviderGroupInput>;
        create?: InputMaybe<ProviderGroupCreateWithoutProviderToProviderGroupInput>;
        update?: InputMaybe<ProviderGroupUpdateToOneWithWhereWithoutProviderToProviderGroupInput>;
        upsert?: InputMaybe<ProviderGroupUpsertWithoutProviderToProviderGroupInput>;
    };

export type ProviderGroupUpdateToOneWithWhereWithoutProviderGroupToHrtInput = {
    data: ProviderGroupUpdateWithoutProviderGroupToHrtInput;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type ProviderGroupUpdateToOneWithWhereWithoutProviderToProviderGroupInput =
    {
        data: ProviderGroupUpdateWithoutProviderToProviderGroupInput;
        where?: InputMaybe<ProviderGroupWhereInput>;
    };

export type ProviderGroupUpdateWithWhereUniqueWithoutPlaceOfServiceInput = {
    data: ProviderGroupUpdateWithoutPlaceOfServiceInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupUpdateWithWhereUniqueWithoutPracticeInput = {
    data: ProviderGroupUpdateWithoutPracticeInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupUpdateWithWhereUniqueWithoutTaxonomyInput = {
    data: ProviderGroupUpdateWithoutTaxonomyInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupUpdateWithoutPlaceOfServiceInput = {
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutProviderGroupsNestedInput>;
    providerGroupId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutProviderGroupNestedInput>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupUpdateManyWithoutProviderGroupNestedInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyUpdateOneWithoutProviderGroupNestedInput>;
};

export type ProviderGroupUpdateWithoutPracticeInput = {
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutProviderGroupNestedInput>;
    providerGroupId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutProviderGroupNestedInput>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupUpdateManyWithoutProviderGroupNestedInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyUpdateOneWithoutProviderGroupNestedInput>;
};

export type ProviderGroupUpdateWithoutProviderGroupToHrtInput = {
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutProviderGroupNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutProviderGroupsNestedInput>;
    providerGroupId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupUpdateManyWithoutProviderGroupNestedInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyUpdateOneWithoutProviderGroupNestedInput>;
};

export type ProviderGroupUpdateWithoutProviderToProviderGroupInput = {
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutProviderGroupNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutProviderGroupsNestedInput>;
    providerGroupId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutProviderGroupNestedInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyUpdateOneWithoutProviderGroupNestedInput>;
};

export type ProviderGroupUpdateWithoutTaxonomyInput = {
    ehrDepartmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
    name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeUpdateOneWithoutProviderGroupNestedInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutProviderGroupsNestedInput>;
    providerGroupId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtUpdateManyWithoutProviderGroupNestedInput>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupUpdateManyWithoutProviderGroupNestedInput>;
};

export type ProviderGroupUpsertWithWhereUniqueWithoutPlaceOfServiceInput = {
    create: ProviderGroupCreateWithoutPlaceOfServiceInput;
    update: ProviderGroupUpdateWithoutPlaceOfServiceInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupUpsertWithWhereUniqueWithoutPracticeInput = {
    create: ProviderGroupCreateWithoutPracticeInput;
    update: ProviderGroupUpdateWithoutPracticeInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupUpsertWithWhereUniqueWithoutTaxonomyInput = {
    create: ProviderGroupCreateWithoutTaxonomyInput;
    update: ProviderGroupUpdateWithoutTaxonomyInput;
    where: ProviderGroupWhereUniqueInput;
};

export type ProviderGroupUpsertWithoutProviderGroupToHrtInput = {
    create: ProviderGroupCreateWithoutProviderGroupToHrtInput;
    update: ProviderGroupUpdateWithoutProviderGroupToHrtInput;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type ProviderGroupUpsertWithoutProviderToProviderGroupInput = {
    create: ProviderGroupCreateWithoutProviderToProviderGroupInput;
    update: ProviderGroupUpdateWithoutProviderToProviderGroupInput;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type ProviderGroupWhereInput = {
    AND?: InputMaybe<Array<ProviderGroupWhereInput>>;
    NOT?: InputMaybe<Array<ProviderGroupWhereInput>>;
    OR?: InputMaybe<Array<ProviderGroupWhereInput>>;
    ehrDepartmentId?: InputMaybe<StringNullableFilter>;
    isSpecialist?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringNullableFilter>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeNullableRelationFilter>;
    placeOfServiceCode?: InputMaybe<StringNullableFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    practiceId?: InputMaybe<IntFilter>;
    providerGroupId?: InputMaybe<IntFilter>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtListRelationFilter>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupListRelationFilter>;
    taxonomy?: InputMaybe<ProviderTaxonomyNullableRelationFilter>;
    taxonomyCode?: InputMaybe<StringNullableFilter>;
};

export type ProviderGroupWhereUniqueInput = {
    AND?: InputMaybe<Array<ProviderGroupWhereInput>>;
    NOT?: InputMaybe<Array<ProviderGroupWhereInput>>;
    OR?: InputMaybe<Array<ProviderGroupWhereInput>>;
    ehrDepartmentId?: InputMaybe<StringNullableFilter>;
    isSpecialist?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringNullableFilter>;
    placeOfService?: InputMaybe<PlaceOfServiceCodeNullableRelationFilter>;
    placeOfServiceCode?: InputMaybe<StringNullableFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    practiceId?: InputMaybe<IntFilter>;
    providerGroupId?: InputMaybe<Scalars['Int']['input']>;
    providerGroupToHrt?: InputMaybe<ProviderGroupToHrtListRelationFilter>;
    providerToProviderGroup?: InputMaybe<ProviderToProviderGroupListRelationFilter>;
    taxonomy?: InputMaybe<ProviderTaxonomyNullableRelationFilter>;
    taxonomyCode?: InputMaybe<StringNullableFilter>;
};

export type ProviderHrtMaxCount = {
    __typename?: 'ProviderHrtMaxCount';
    createdAt: Scalars['DateTimeISO']['output'];
    hrt?: Maybe<Hrt>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    maxCount: Scalars['Int']['output'];
    provider: Provider;
    providerId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProviderHrtMaxCountHrtArgs = {
    where?: InputMaybe<HrtWhereInput>;
};

export type ProviderHrtMaxCountAvgAggregate = {
    __typename?: 'ProviderHrtMaxCountAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    maxCount?: Maybe<Scalars['Float']['output']>;
    providerId?: Maybe<Scalars['Float']['output']>;
};

export type ProviderHrtMaxCountAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    maxCount?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type ProviderHrtMaxCountCountAggregate = {
    __typename?: 'ProviderHrtMaxCountCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    maxCount: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ProviderHrtMaxCountCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    maxCount?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderHrtMaxCountCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt?: InputMaybe<HrtCreateNestedOneWithoutProviderHrtMaxCountInput>;
    maxCount: Scalars['Int']['input'];
    provider: ProviderCreateNestedOneWithoutProviderHrtMaxCountInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderHrtMaxCountCreateManyHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    maxCount: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderHrtMaxCountCreateManyHrtInputEnvelope = {
    data: Array<ProviderHrtMaxCountCreateManyHrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderHrtMaxCountCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    maxCount: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderHrtMaxCountCreateManyProviderInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    maxCount: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderHrtMaxCountCreateManyProviderInputEnvelope = {
    data: Array<ProviderHrtMaxCountCreateManyProviderInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderHrtMaxCountCreateNestedManyWithoutHrtInput = {
    connect?: InputMaybe<Array<ProviderHrtMaxCountWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderHrtMaxCountCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<ProviderHrtMaxCountCreateWithoutHrtInput>>;
    createMany?: InputMaybe<ProviderHrtMaxCountCreateManyHrtInputEnvelope>;
};

export type ProviderHrtMaxCountCreateNestedManyWithoutProviderInput = {
    connect?: InputMaybe<Array<ProviderHrtMaxCountWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderHrtMaxCountCreateOrConnectWithoutProviderInput>
    >;
    create?: InputMaybe<Array<ProviderHrtMaxCountCreateWithoutProviderInput>>;
    createMany?: InputMaybe<ProviderHrtMaxCountCreateManyProviderInputEnvelope>;
};

export type ProviderHrtMaxCountCreateOrConnectWithoutHrtInput = {
    create: ProviderHrtMaxCountCreateWithoutHrtInput;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type ProviderHrtMaxCountCreateOrConnectWithoutProviderInput = {
    create: ProviderHrtMaxCountCreateWithoutProviderInput;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type ProviderHrtMaxCountCreateWithoutHrtInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    maxCount: Scalars['Int']['input'];
    provider: ProviderCreateNestedOneWithoutProviderHrtMaxCountInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderHrtMaxCountCreateWithoutProviderInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    hrt?: InputMaybe<HrtCreateNestedOneWithoutProviderHrtMaxCountInput>;
    maxCount: Scalars['Int']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProviderHrtMaxCountGroupBy = {
    __typename?: 'ProviderHrtMaxCountGroupBy';
    _avg?: Maybe<ProviderHrtMaxCountAvgAggregate>;
    _count?: Maybe<ProviderHrtMaxCountCountAggregate>;
    _max?: Maybe<ProviderHrtMaxCountMaxAggregate>;
    _min?: Maybe<ProviderHrtMaxCountMinAggregate>;
    _sum?: Maybe<ProviderHrtMaxCountSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['Int']['output'];
    maxCount: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProviderHrtMaxCountListRelationFilter = {
    every?: InputMaybe<ProviderHrtMaxCountWhereInput>;
    none?: InputMaybe<ProviderHrtMaxCountWhereInput>;
    some?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type ProviderHrtMaxCountMaxAggregate = {
    __typename?: 'ProviderHrtMaxCountMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    maxCount?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProviderHrtMaxCountMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    maxCount?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderHrtMaxCountMinAggregate = {
    __typename?: 'ProviderHrtMaxCountMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    maxCount?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProviderHrtMaxCountMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    maxCount?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderHrtMaxCountOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProviderHrtMaxCountOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProviderHrtMaxCountAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProviderHrtMaxCountCountOrderByAggregateInput>;
    _max?: InputMaybe<ProviderHrtMaxCountMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProviderHrtMaxCountMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProviderHrtMaxCountSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    maxCount?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderHrtMaxCountOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    hrt?: InputMaybe<HrtOrderByWithRelationInput>;
    hrtId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    maxCount?: InputMaybe<SortOrder>;
    provider?: InputMaybe<ProviderOrderByWithRelationInput>;
    providerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderHrtMaxCountProviderHrtMaxCountUniqueCompoundUniqueInput = {
    hrtId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
};

export enum ProviderHrtMaxCountScalarFieldEnum {
    CreatedAt = 'createdAt',
    HrtId = 'hrtId',
    Id = 'id',
    MaxCount = 'maxCount',
    ProviderId = 'providerId',
    UpdatedAt = 'updatedAt',
}

export type ProviderHrtMaxCountScalarWhereInput = {
    AND?: InputMaybe<Array<ProviderHrtMaxCountScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProviderHrtMaxCountScalarWhereInput>>;
    OR?: InputMaybe<Array<ProviderHrtMaxCountScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<IntFilter>;
    maxCount?: InputMaybe<IntFilter>;
    providerId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderHrtMaxCountScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProviderHrtMaxCountScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProviderHrtMaxCountScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProviderHrtMaxCountScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    hrtId?: InputMaybe<IntNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    maxCount?: InputMaybe<IntWithAggregatesFilter>;
    providerId?: InputMaybe<IntWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProviderHrtMaxCountSumAggregate = {
    __typename?: 'ProviderHrtMaxCountSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    maxCount?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
};

export type ProviderHrtMaxCountSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    maxCount?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type ProviderHrtMaxCountUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneWithoutProviderHrtMaxCountNestedInput>;
    maxCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderHrtMaxCountNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderHrtMaxCountUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    maxCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderHrtMaxCountUpdateManyWithWhereWithoutHrtInput = {
    data: ProviderHrtMaxCountUpdateManyMutationInput;
    where: ProviderHrtMaxCountScalarWhereInput;
};

export type ProviderHrtMaxCountUpdateManyWithWhereWithoutProviderInput = {
    data: ProviderHrtMaxCountUpdateManyMutationInput;
    where: ProviderHrtMaxCountScalarWhereInput;
};

export type ProviderHrtMaxCountUpdateManyWithoutHrtNestedInput = {
    connect?: InputMaybe<Array<ProviderHrtMaxCountWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderHrtMaxCountCreateOrConnectWithoutHrtInput>
    >;
    create?: InputMaybe<Array<ProviderHrtMaxCountCreateWithoutHrtInput>>;
    createMany?: InputMaybe<ProviderHrtMaxCountCreateManyHrtInputEnvelope>;
    delete?: InputMaybe<Array<ProviderHrtMaxCountWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderHrtMaxCountScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderHrtMaxCountWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderHrtMaxCountWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderHrtMaxCountUpdateWithWhereUniqueWithoutHrtInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderHrtMaxCountUpdateManyWithWhereWithoutHrtInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderHrtMaxCountUpsertWithWhereUniqueWithoutHrtInput>
    >;
};

export type ProviderHrtMaxCountUpdateManyWithoutProviderNestedInput = {
    connect?: InputMaybe<Array<ProviderHrtMaxCountWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderHrtMaxCountCreateOrConnectWithoutProviderInput>
    >;
    create?: InputMaybe<Array<ProviderHrtMaxCountCreateWithoutProviderInput>>;
    createMany?: InputMaybe<ProviderHrtMaxCountCreateManyProviderInputEnvelope>;
    delete?: InputMaybe<Array<ProviderHrtMaxCountWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderHrtMaxCountScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderHrtMaxCountWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderHrtMaxCountWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderHrtMaxCountUpdateWithWhereUniqueWithoutProviderInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderHrtMaxCountUpdateManyWithWhereWithoutProviderInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderHrtMaxCountUpsertWithWhereUniqueWithoutProviderInput>
    >;
};

export type ProviderHrtMaxCountUpdateWithWhereUniqueWithoutHrtInput = {
    data: ProviderHrtMaxCountUpdateWithoutHrtInput;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type ProviderHrtMaxCountUpdateWithWhereUniqueWithoutProviderInput = {
    data: ProviderHrtMaxCountUpdateWithoutProviderInput;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type ProviderHrtMaxCountUpdateWithoutHrtInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    maxCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderHrtMaxCountNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderHrtMaxCountUpdateWithoutProviderInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    hrt?: InputMaybe<HrtUpdateOneWithoutProviderHrtMaxCountNestedInput>;
    maxCount?: InputMaybe<IntFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderHrtMaxCountUpsertWithWhereUniqueWithoutHrtInput = {
    create: ProviderHrtMaxCountCreateWithoutHrtInput;
    update: ProviderHrtMaxCountUpdateWithoutHrtInput;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type ProviderHrtMaxCountUpsertWithWhereUniqueWithoutProviderInput = {
    create: ProviderHrtMaxCountCreateWithoutProviderInput;
    update: ProviderHrtMaxCountUpdateWithoutProviderInput;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type ProviderHrtMaxCountWhereInput = {
    AND?: InputMaybe<Array<ProviderHrtMaxCountWhereInput>>;
    NOT?: InputMaybe<Array<ProviderHrtMaxCountWhereInput>>;
    OR?: InputMaybe<Array<ProviderHrtMaxCountWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrt?: InputMaybe<HrtNullableRelationFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<IntFilter>;
    maxCount?: InputMaybe<IntFilter>;
    provider?: InputMaybe<ProviderRelationFilter>;
    providerId?: InputMaybe<IntFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderHrtMaxCountWhereUniqueInput = {
    AND?: InputMaybe<Array<ProviderHrtMaxCountWhereInput>>;
    NOT?: InputMaybe<Array<ProviderHrtMaxCountWhereInput>>;
    OR?: InputMaybe<Array<ProviderHrtMaxCountWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    hrt?: InputMaybe<HrtNullableRelationFilter>;
    hrtId?: InputMaybe<IntNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    maxCount?: InputMaybe<IntFilter>;
    provider?: InputMaybe<ProviderRelationFilter>;
    providerId?: InputMaybe<IntFilter>;
    provider_hrt_max_count_unique?: InputMaybe<ProviderHrtMaxCountProviderHrtMaxCountUniqueCompoundUniqueInput>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderListRelationFilter = {
    every?: InputMaybe<ProviderWhereInput>;
    none?: InputMaybe<ProviderWhereInput>;
    some?: InputMaybe<ProviderWhereInput>;
};

export type ProviderMaxAggregate = {
    __typename?: 'ProviderMaxAggregate';
    degrees?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    displayFirstName?: Maybe<Scalars['String']['output']>;
    displayLastName?: Maybe<Scalars['String']['output']>;
    ehrId?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    imageUrl?: Maybe<Scalars['String']['output']>;
    isSpecialist?: Maybe<Scalars['Boolean']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    npiId?: Maybe<Scalars['String']['output']>;
    taxonomyCode?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type ProviderMaxOrderByAggregateInput = {
    degrees?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    displayFirstName?: InputMaybe<SortOrder>;
    displayLastName?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    imageUrl?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    npiId?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrder>;
    title?: InputMaybe<SortOrder>;
};

export type ProviderMinAggregate = {
    __typename?: 'ProviderMinAggregate';
    degrees?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    displayFirstName?: Maybe<Scalars['String']['output']>;
    displayLastName?: Maybe<Scalars['String']['output']>;
    ehrId?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    imageUrl?: Maybe<Scalars['String']['output']>;
    isSpecialist?: Maybe<Scalars['Boolean']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    npiId?: Maybe<Scalars['String']['output']>;
    taxonomyCode?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type ProviderMinOrderByAggregateInput = {
    degrees?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    displayFirstName?: InputMaybe<SortOrder>;
    displayLastName?: InputMaybe<SortOrder>;
    ehrId?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    imageUrl?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    npiId?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrder>;
    title?: InputMaybe<SortOrder>;
};

export type ProviderOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProviderOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProviderAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProviderCountOrderByAggregateInput>;
    _max?: InputMaybe<ProviderMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProviderMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProviderSumOrderByAggregateInput>;
    degrees?: InputMaybe<SortOrderInput>;
    description?: InputMaybe<SortOrderInput>;
    displayFirstName?: InputMaybe<SortOrderInput>;
    displayLastName?: InputMaybe<SortOrderInput>;
    ehrId?: InputMaybe<SortOrderInput>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    imageUrl?: InputMaybe<SortOrderInput>;
    isSpecialist?: InputMaybe<SortOrderInput>;
    lastName?: InputMaybe<SortOrder>;
    npiId?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrderInput>;
    title?: InputMaybe<SortOrderInput>;
};

export type ProviderOrderByWithRelationInput = {
    degrees?: InputMaybe<SortOrderInput>;
    description?: InputMaybe<SortOrderInput>;
    displayFirstName?: InputMaybe<SortOrderInput>;
    displayLastName?: InputMaybe<SortOrderInput>;
    ehrId?: InputMaybe<SortOrderInput>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    imageUrl?: InputMaybe<SortOrderInput>;
    isSpecialist?: InputMaybe<SortOrderInput>;
    lastName?: InputMaybe<SortOrder>;
    npiId?: InputMaybe<SortOrder>;
    providerCredentialings?: InputMaybe<ProviderCredentialingOrderByRelationAggregateInput>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountOrderByRelationAggregateInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgOrderByRelationAggregateInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupOrderByRelationAggregateInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyOrderByWithRelationInput>;
    taxonomyCode?: InputMaybe<SortOrderInput>;
    title?: InputMaybe<SortOrderInput>;
};

export type ProviderRelationFilter = {
    is?: InputMaybe<ProviderWhereInput>;
    isNot?: InputMaybe<ProviderWhereInput>;
};

export enum ProviderScalarFieldEnum {
    Degrees = 'degrees',
    Description = 'description',
    DisplayFirstName = 'displayFirstName',
    DisplayLastName = 'displayLastName',
    EhrId = 'ehrId',
    FirstName = 'firstName',
    Id = 'id',
    ImageUrl = 'imageUrl',
    IsSpecialist = 'isSpecialist',
    LastName = 'lastName',
    NpiId = 'npiId',
    TaxonomyCode = 'taxonomyCode',
    Title = 'title',
}

export type ProviderScalarWhereInput = {
    AND?: InputMaybe<Array<ProviderScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProviderScalarWhereInput>>;
    OR?: InputMaybe<Array<ProviderScalarWhereInput>>;
    degrees?: InputMaybe<StringNullableFilter>;
    description?: InputMaybe<StringNullableFilter>;
    displayFirstName?: InputMaybe<StringNullableFilter>;
    displayLastName?: InputMaybe<StringNullableFilter>;
    ehrId?: InputMaybe<StringNullableFilter>;
    firstName?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    imageUrl?: InputMaybe<StringNullableFilter>;
    isSpecialist?: InputMaybe<BoolNullableFilter>;
    lastName?: InputMaybe<StringFilter>;
    npiId?: InputMaybe<StringFilter>;
    taxonomyCode?: InputMaybe<StringNullableFilter>;
    title?: InputMaybe<StringNullableFilter>;
};

export type ProviderScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProviderScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProviderScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProviderScalarWhereWithAggregatesInput>>;
    degrees?: InputMaybe<StringNullableWithAggregatesFilter>;
    description?: InputMaybe<StringNullableWithAggregatesFilter>;
    displayFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    displayLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrId?: InputMaybe<StringNullableWithAggregatesFilter>;
    firstName?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    imageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
    isSpecialist?: InputMaybe<BoolNullableWithAggregatesFilter>;
    lastName?: InputMaybe<StringWithAggregatesFilter>;
    npiId?: InputMaybe<StringWithAggregatesFilter>;
    taxonomyCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    title?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ProviderSumAggregate = {
    __typename?: 'ProviderSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type ProviderSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type ProviderTaxonomy = {
    __typename?: 'ProviderTaxonomy';
    Provider: Array<Provider>;
    ProviderGroup: Array<ProviderGroup>;
    _count?: Maybe<ProviderTaxonomyCount>;
    defaultServiceType?: Maybe<ServiceTypeCode>;
    medicareSpecialtyCode?: Maybe<Scalars['String']['output']>;
    provider_type: Scalars['String']['output'];
    serviceTypeCode?: Maybe<Scalars['String']['output']>;
    specialization: Scalars['String']['output'];
    supplier_type?: Maybe<Scalars['String']['output']>;
    taxonomyCode: Scalars['String']['output'];
    taxonomy_category: Scalars['String']['output'];
};

export type ProviderTaxonomyProviderArgs = {
    cursor?: InputMaybe<ProviderWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderTaxonomyProviderGroupArgs = {
    cursor?: InputMaybe<ProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type ProviderTaxonomyDefaultServiceTypeArgs = {
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type ProviderTaxonomyCount = {
    __typename?: 'ProviderTaxonomyCount';
    Provider: Scalars['Int']['output'];
    ProviderGroup: Scalars['Int']['output'];
};

export type ProviderTaxonomyCountProviderArgs = {
    where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderTaxonomyCountProviderGroupArgs = {
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type ProviderTaxonomyCountAggregate = {
    __typename?: 'ProviderTaxonomyCountAggregate';
    _all: Scalars['Int']['output'];
    medicareSpecialtyCode: Scalars['Int']['output'];
    provider_type: Scalars['Int']['output'];
    serviceTypeCode: Scalars['Int']['output'];
    specialization: Scalars['Int']['output'];
    supplier_type: Scalars['Int']['output'];
    taxonomyCode: Scalars['Int']['output'];
    taxonomy_category: Scalars['Int']['output'];
};

export type ProviderTaxonomyCountOrderByAggregateInput = {
    medicareSpecialtyCode?: InputMaybe<SortOrder>;
    provider_type?: InputMaybe<SortOrder>;
    serviceTypeCode?: InputMaybe<SortOrder>;
    specialization?: InputMaybe<SortOrder>;
    supplier_type?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrder>;
    taxonomy_category?: InputMaybe<SortOrder>;
};

export type ProviderTaxonomyCreateInput = {
    Provider?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomyInput>;
    ProviderGroup?: InputMaybe<ProviderGroupCreateNestedManyWithoutTaxonomyInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeCreateNestedOneWithoutProviderTaxonomyInput>;
    medicareSpecialtyCode?: InputMaybe<Scalars['String']['input']>;
    provider_type: Scalars['String']['input'];
    specialization: Scalars['String']['input'];
    supplier_type?: InputMaybe<Scalars['String']['input']>;
    taxonomyCode: Scalars['String']['input'];
    taxonomy_category: Scalars['String']['input'];
};

export type ProviderTaxonomyCreateManyDefaultServiceTypeInput = {
    medicareSpecialtyCode?: InputMaybe<Scalars['String']['input']>;
    provider_type: Scalars['String']['input'];
    specialization: Scalars['String']['input'];
    supplier_type?: InputMaybe<Scalars['String']['input']>;
    taxonomyCode: Scalars['String']['input'];
    taxonomy_category: Scalars['String']['input'];
};

export type ProviderTaxonomyCreateManyDefaultServiceTypeInputEnvelope = {
    data: Array<ProviderTaxonomyCreateManyDefaultServiceTypeInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderTaxonomyCreateManyInput = {
    medicareSpecialtyCode?: InputMaybe<Scalars['String']['input']>;
    provider_type: Scalars['String']['input'];
    serviceTypeCode?: InputMaybe<Scalars['String']['input']>;
    specialization: Scalars['String']['input'];
    supplier_type?: InputMaybe<Scalars['String']['input']>;
    taxonomyCode: Scalars['String']['input'];
    taxonomy_category: Scalars['String']['input'];
};

export type ProviderTaxonomyCreateNestedManyWithoutDefaultServiceTypeInput = {
    connect?: InputMaybe<Array<ProviderTaxonomyWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderTaxonomyCreateOrConnectWithoutDefaultServiceTypeInput>
    >;
    create?: InputMaybe<
        Array<ProviderTaxonomyCreateWithoutDefaultServiceTypeInput>
    >;
    createMany?: InputMaybe<ProviderTaxonomyCreateManyDefaultServiceTypeInputEnvelope>;
};

export type ProviderTaxonomyCreateNestedOneWithoutProviderGroupInput = {
    connect?: InputMaybe<ProviderTaxonomyWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderTaxonomyCreateOrConnectWithoutProviderGroupInput>;
    create?: InputMaybe<ProviderTaxonomyCreateWithoutProviderGroupInput>;
};

export type ProviderTaxonomyCreateNestedOneWithoutProviderInput = {
    connect?: InputMaybe<ProviderTaxonomyWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderTaxonomyCreateOrConnectWithoutProviderInput>;
    create?: InputMaybe<ProviderTaxonomyCreateWithoutProviderInput>;
};

export type ProviderTaxonomyCreateOrConnectWithoutDefaultServiceTypeInput = {
    create: ProviderTaxonomyCreateWithoutDefaultServiceTypeInput;
    where: ProviderTaxonomyWhereUniqueInput;
};

export type ProviderTaxonomyCreateOrConnectWithoutProviderGroupInput = {
    create: ProviderTaxonomyCreateWithoutProviderGroupInput;
    where: ProviderTaxonomyWhereUniqueInput;
};

export type ProviderTaxonomyCreateOrConnectWithoutProviderInput = {
    create: ProviderTaxonomyCreateWithoutProviderInput;
    where: ProviderTaxonomyWhereUniqueInput;
};

export type ProviderTaxonomyCreateWithoutDefaultServiceTypeInput = {
    Provider?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomyInput>;
    ProviderGroup?: InputMaybe<ProviderGroupCreateNestedManyWithoutTaxonomyInput>;
    medicareSpecialtyCode?: InputMaybe<Scalars['String']['input']>;
    provider_type: Scalars['String']['input'];
    specialization: Scalars['String']['input'];
    supplier_type?: InputMaybe<Scalars['String']['input']>;
    taxonomyCode: Scalars['String']['input'];
    taxonomy_category: Scalars['String']['input'];
};

export type ProviderTaxonomyCreateWithoutProviderGroupInput = {
    Provider?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomyInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeCreateNestedOneWithoutProviderTaxonomyInput>;
    medicareSpecialtyCode?: InputMaybe<Scalars['String']['input']>;
    provider_type: Scalars['String']['input'];
    specialization: Scalars['String']['input'];
    supplier_type?: InputMaybe<Scalars['String']['input']>;
    taxonomyCode: Scalars['String']['input'];
    taxonomy_category: Scalars['String']['input'];
};

export type ProviderTaxonomyCreateWithoutProviderInput = {
    ProviderGroup?: InputMaybe<ProviderGroupCreateNestedManyWithoutTaxonomyInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeCreateNestedOneWithoutProviderTaxonomyInput>;
    medicareSpecialtyCode?: InputMaybe<Scalars['String']['input']>;
    provider_type: Scalars['String']['input'];
    specialization: Scalars['String']['input'];
    supplier_type?: InputMaybe<Scalars['String']['input']>;
    taxonomyCode: Scalars['String']['input'];
    taxonomy_category: Scalars['String']['input'];
};

export type ProviderTaxonomyGroupBy = {
    __typename?: 'ProviderTaxonomyGroupBy';
    _count?: Maybe<ProviderTaxonomyCountAggregate>;
    _max?: Maybe<ProviderTaxonomyMaxAggregate>;
    _min?: Maybe<ProviderTaxonomyMinAggregate>;
    medicareSpecialtyCode?: Maybe<Scalars['String']['output']>;
    provider_type: Scalars['String']['output'];
    serviceTypeCode?: Maybe<Scalars['String']['output']>;
    specialization: Scalars['String']['output'];
    supplier_type?: Maybe<Scalars['String']['output']>;
    taxonomyCode: Scalars['String']['output'];
    taxonomy_category: Scalars['String']['output'];
};

export type ProviderTaxonomyListRelationFilter = {
    every?: InputMaybe<ProviderTaxonomyWhereInput>;
    none?: InputMaybe<ProviderTaxonomyWhereInput>;
    some?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type ProviderTaxonomyMaxAggregate = {
    __typename?: 'ProviderTaxonomyMaxAggregate';
    medicareSpecialtyCode?: Maybe<Scalars['String']['output']>;
    provider_type?: Maybe<Scalars['String']['output']>;
    serviceTypeCode?: Maybe<Scalars['String']['output']>;
    specialization?: Maybe<Scalars['String']['output']>;
    supplier_type?: Maybe<Scalars['String']['output']>;
    taxonomyCode?: Maybe<Scalars['String']['output']>;
    taxonomy_category?: Maybe<Scalars['String']['output']>;
};

export type ProviderTaxonomyMaxOrderByAggregateInput = {
    medicareSpecialtyCode?: InputMaybe<SortOrder>;
    provider_type?: InputMaybe<SortOrder>;
    serviceTypeCode?: InputMaybe<SortOrder>;
    specialization?: InputMaybe<SortOrder>;
    supplier_type?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrder>;
    taxonomy_category?: InputMaybe<SortOrder>;
};

export type ProviderTaxonomyMinAggregate = {
    __typename?: 'ProviderTaxonomyMinAggregate';
    medicareSpecialtyCode?: Maybe<Scalars['String']['output']>;
    provider_type?: Maybe<Scalars['String']['output']>;
    serviceTypeCode?: Maybe<Scalars['String']['output']>;
    specialization?: Maybe<Scalars['String']['output']>;
    supplier_type?: Maybe<Scalars['String']['output']>;
    taxonomyCode?: Maybe<Scalars['String']['output']>;
    taxonomy_category?: Maybe<Scalars['String']['output']>;
};

export type ProviderTaxonomyMinOrderByAggregateInput = {
    medicareSpecialtyCode?: InputMaybe<SortOrder>;
    provider_type?: InputMaybe<SortOrder>;
    serviceTypeCode?: InputMaybe<SortOrder>;
    specialization?: InputMaybe<SortOrder>;
    supplier_type?: InputMaybe<SortOrder>;
    taxonomyCode?: InputMaybe<SortOrder>;
    taxonomy_category?: InputMaybe<SortOrder>;
};

export type ProviderTaxonomyNullableRelationFilter = {
    is?: InputMaybe<ProviderTaxonomyWhereInput>;
    isNot?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type ProviderTaxonomyOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProviderTaxonomyOrderByWithAggregationInput = {
    _count?: InputMaybe<ProviderTaxonomyCountOrderByAggregateInput>;
    _max?: InputMaybe<ProviderTaxonomyMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProviderTaxonomyMinOrderByAggregateInput>;
    medicareSpecialtyCode?: InputMaybe<SortOrderInput>;
    provider_type?: InputMaybe<SortOrder>;
    serviceTypeCode?: InputMaybe<SortOrderInput>;
    specialization?: InputMaybe<SortOrder>;
    supplier_type?: InputMaybe<SortOrderInput>;
    taxonomyCode?: InputMaybe<SortOrder>;
    taxonomy_category?: InputMaybe<SortOrder>;
};

export type ProviderTaxonomyOrderByWithRelationInput = {
    Provider?: InputMaybe<ProviderOrderByRelationAggregateInput>;
    ProviderGroup?: InputMaybe<ProviderGroupOrderByRelationAggregateInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeOrderByWithRelationInput>;
    medicareSpecialtyCode?: InputMaybe<SortOrderInput>;
    provider_type?: InputMaybe<SortOrder>;
    serviceTypeCode?: InputMaybe<SortOrderInput>;
    specialization?: InputMaybe<SortOrder>;
    supplier_type?: InputMaybe<SortOrderInput>;
    taxonomyCode?: InputMaybe<SortOrder>;
    taxonomy_category?: InputMaybe<SortOrder>;
};

export enum ProviderTaxonomyScalarFieldEnum {
    MedicareSpecialtyCode = 'medicareSpecialtyCode',
    ProviderType = 'provider_type',
    ServiceTypeCode = 'serviceTypeCode',
    Specialization = 'specialization',
    SupplierType = 'supplier_type',
    TaxonomyCode = 'taxonomyCode',
    TaxonomyCategory = 'taxonomy_category',
}

export type ProviderTaxonomyScalarWhereInput = {
    AND?: InputMaybe<Array<ProviderTaxonomyScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProviderTaxonomyScalarWhereInput>>;
    OR?: InputMaybe<Array<ProviderTaxonomyScalarWhereInput>>;
    medicareSpecialtyCode?: InputMaybe<StringNullableFilter>;
    provider_type?: InputMaybe<StringFilter>;
    serviceTypeCode?: InputMaybe<StringNullableFilter>;
    specialization?: InputMaybe<StringFilter>;
    supplier_type?: InputMaybe<StringNullableFilter>;
    taxonomyCode?: InputMaybe<StringFilter>;
    taxonomy_category?: InputMaybe<StringFilter>;
};

export type ProviderTaxonomyScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProviderTaxonomyScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProviderTaxonomyScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProviderTaxonomyScalarWhereWithAggregatesInput>>;
    medicareSpecialtyCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    provider_type?: InputMaybe<StringWithAggregatesFilter>;
    serviceTypeCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    specialization?: InputMaybe<StringWithAggregatesFilter>;
    supplier_type?: InputMaybe<StringNullableWithAggregatesFilter>;
    taxonomyCode?: InputMaybe<StringWithAggregatesFilter>;
    taxonomy_category?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProviderTaxonomyUpdateInput = {
    Provider?: InputMaybe<ProviderUpdateManyWithoutTaxonomyNestedInput>;
    ProviderGroup?: InputMaybe<ProviderGroupUpdateManyWithoutTaxonomyNestedInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeUpdateOneWithoutProviderTaxonomyNestedInput>;
    medicareSpecialtyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    provider_type?: InputMaybe<StringFieldUpdateOperationsInput>;
    specialization?: InputMaybe<StringFieldUpdateOperationsInput>;
    supplier_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    taxonomyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    taxonomy_category?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyUpdateManyMutationInput = {
    medicareSpecialtyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    provider_type?: InputMaybe<StringFieldUpdateOperationsInput>;
    specialization?: InputMaybe<StringFieldUpdateOperationsInput>;
    supplier_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    taxonomyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    taxonomy_category?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyUpdateManyWithWhereWithoutDefaultServiceTypeInput =
    {
        data: ProviderTaxonomyUpdateManyMutationInput;
        where: ProviderTaxonomyScalarWhereInput;
    };

export type ProviderTaxonomyUpdateManyWithoutDefaultServiceTypeNestedInput = {
    connect?: InputMaybe<Array<ProviderTaxonomyWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderTaxonomyCreateOrConnectWithoutDefaultServiceTypeInput>
    >;
    create?: InputMaybe<
        Array<ProviderTaxonomyCreateWithoutDefaultServiceTypeInput>
    >;
    createMany?: InputMaybe<ProviderTaxonomyCreateManyDefaultServiceTypeInputEnvelope>;
    delete?: InputMaybe<Array<ProviderTaxonomyWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderTaxonomyScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderTaxonomyWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderTaxonomyWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderTaxonomyUpdateWithWhereUniqueWithoutDefaultServiceTypeInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderTaxonomyUpdateManyWithWhereWithoutDefaultServiceTypeInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderTaxonomyUpsertWithWhereUniqueWithoutDefaultServiceTypeInput>
    >;
};

export type ProviderTaxonomyUpdateOneWithoutProviderGroupNestedInput = {
    connect?: InputMaybe<ProviderTaxonomyWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderTaxonomyCreateOrConnectWithoutProviderGroupInput>;
    create?: InputMaybe<ProviderTaxonomyCreateWithoutProviderGroupInput>;
    delete?: InputMaybe<ProviderTaxonomyWhereInput>;
    disconnect?: InputMaybe<ProviderTaxonomyWhereInput>;
    update?: InputMaybe<ProviderTaxonomyUpdateToOneWithWhereWithoutProviderGroupInput>;
    upsert?: InputMaybe<ProviderTaxonomyUpsertWithoutProviderGroupInput>;
};

export type ProviderTaxonomyUpdateOneWithoutProviderNestedInput = {
    connect?: InputMaybe<ProviderTaxonomyWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderTaxonomyCreateOrConnectWithoutProviderInput>;
    create?: InputMaybe<ProviderTaxonomyCreateWithoutProviderInput>;
    delete?: InputMaybe<ProviderTaxonomyWhereInput>;
    disconnect?: InputMaybe<ProviderTaxonomyWhereInput>;
    update?: InputMaybe<ProviderTaxonomyUpdateToOneWithWhereWithoutProviderInput>;
    upsert?: InputMaybe<ProviderTaxonomyUpsertWithoutProviderInput>;
};

export type ProviderTaxonomyUpdateToOneWithWhereWithoutProviderGroupInput = {
    data: ProviderTaxonomyUpdateWithoutProviderGroupInput;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type ProviderTaxonomyUpdateToOneWithWhereWithoutProviderInput = {
    data: ProviderTaxonomyUpdateWithoutProviderInput;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type ProviderTaxonomyUpdateWithWhereUniqueWithoutDefaultServiceTypeInput =
    {
        data: ProviderTaxonomyUpdateWithoutDefaultServiceTypeInput;
        where: ProviderTaxonomyWhereUniqueInput;
    };

export type ProviderTaxonomyUpdateWithoutDefaultServiceTypeInput = {
    Provider?: InputMaybe<ProviderUpdateManyWithoutTaxonomyNestedInput>;
    ProviderGroup?: InputMaybe<ProviderGroupUpdateManyWithoutTaxonomyNestedInput>;
    medicareSpecialtyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    provider_type?: InputMaybe<StringFieldUpdateOperationsInput>;
    specialization?: InputMaybe<StringFieldUpdateOperationsInput>;
    supplier_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    taxonomyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    taxonomy_category?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyUpdateWithoutProviderGroupInput = {
    Provider?: InputMaybe<ProviderUpdateManyWithoutTaxonomyNestedInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeUpdateOneWithoutProviderTaxonomyNestedInput>;
    medicareSpecialtyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    provider_type?: InputMaybe<StringFieldUpdateOperationsInput>;
    specialization?: InputMaybe<StringFieldUpdateOperationsInput>;
    supplier_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    taxonomyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    taxonomy_category?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyUpdateWithoutProviderInput = {
    ProviderGroup?: InputMaybe<ProviderGroupUpdateManyWithoutTaxonomyNestedInput>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeUpdateOneWithoutProviderTaxonomyNestedInput>;
    medicareSpecialtyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    provider_type?: InputMaybe<StringFieldUpdateOperationsInput>;
    specialization?: InputMaybe<StringFieldUpdateOperationsInput>;
    supplier_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    taxonomyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    taxonomy_category?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyUpsertWithWhereUniqueWithoutDefaultServiceTypeInput =
    {
        create: ProviderTaxonomyCreateWithoutDefaultServiceTypeInput;
        update: ProviderTaxonomyUpdateWithoutDefaultServiceTypeInput;
        where: ProviderTaxonomyWhereUniqueInput;
    };

export type ProviderTaxonomyUpsertWithoutProviderGroupInput = {
    create: ProviderTaxonomyCreateWithoutProviderGroupInput;
    update: ProviderTaxonomyUpdateWithoutProviderGroupInput;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type ProviderTaxonomyUpsertWithoutProviderInput = {
    create: ProviderTaxonomyCreateWithoutProviderInput;
    update: ProviderTaxonomyUpdateWithoutProviderInput;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type ProviderTaxonomyWhereInput = {
    AND?: InputMaybe<Array<ProviderTaxonomyWhereInput>>;
    NOT?: InputMaybe<Array<ProviderTaxonomyWhereInput>>;
    OR?: InputMaybe<Array<ProviderTaxonomyWhereInput>>;
    Provider?: InputMaybe<ProviderListRelationFilter>;
    ProviderGroup?: InputMaybe<ProviderGroupListRelationFilter>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeNullableRelationFilter>;
    medicareSpecialtyCode?: InputMaybe<StringNullableFilter>;
    provider_type?: InputMaybe<StringFilter>;
    serviceTypeCode?: InputMaybe<StringNullableFilter>;
    specialization?: InputMaybe<StringFilter>;
    supplier_type?: InputMaybe<StringNullableFilter>;
    taxonomyCode?: InputMaybe<StringFilter>;
    taxonomy_category?: InputMaybe<StringFilter>;
};

export type ProviderTaxonomyWhereUniqueInput = {
    AND?: InputMaybe<Array<ProviderTaxonomyWhereInput>>;
    NOT?: InputMaybe<Array<ProviderTaxonomyWhereInput>>;
    OR?: InputMaybe<Array<ProviderTaxonomyWhereInput>>;
    Provider?: InputMaybe<ProviderListRelationFilter>;
    ProviderGroup?: InputMaybe<ProviderGroupListRelationFilter>;
    defaultServiceType?: InputMaybe<ServiceTypeCodeNullableRelationFilter>;
    medicareSpecialtyCode?: InputMaybe<StringNullableFilter>;
    provider_type?: InputMaybe<StringFilter>;
    serviceTypeCode?: InputMaybe<StringNullableFilter>;
    specialization?: InputMaybe<StringFilter>;
    supplier_type?: InputMaybe<StringNullableFilter>;
    taxonomyCode?: InputMaybe<Scalars['String']['input']>;
    taxonomy_category?: InputMaybe<StringFilter>;
};

export type ProviderToOrg = {
    __typename?: 'ProviderToOrg';
    orderNumber: Scalars['Int']['output'];
    org: Organization;
    orgId: Scalars['Int']['output'];
    provider: Provider;
    providerHidden: Scalars['Boolean']['output'];
    providerId: Scalars['Int']['output'];
};

export type ProviderToOrgAvgAggregate = {
    __typename?: 'ProviderToOrgAvgAggregate';
    orderNumber?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    providerId?: Maybe<Scalars['Float']['output']>;
};

export type ProviderToOrgAvgOrderByAggregateInput = {
    orderNumber?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type ProviderToOrgCountAggregate = {
    __typename?: 'ProviderToOrgCountAggregate';
    _all: Scalars['Int']['output'];
    orderNumber: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    providerHidden: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
};

export type ProviderToOrgCountOrderByAggregateInput = {
    orderNumber?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    providerHidden?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type ProviderToOrgCreateInput = {
    orderNumber?: InputMaybe<Scalars['Int']['input']>;
    org: OrganizationCreateNestedOneWithoutProviderToOrgsInput;
    provider: ProviderCreateNestedOneWithoutProviderToOrgsInput;
    providerHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderToOrgCreateManyInput = {
    orderNumber?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    providerHidden?: InputMaybe<Scalars['Boolean']['input']>;
    providerId: Scalars['Int']['input'];
};

export type ProviderToOrgCreateManyOrgInput = {
    orderNumber?: InputMaybe<Scalars['Int']['input']>;
    providerHidden?: InputMaybe<Scalars['Boolean']['input']>;
    providerId: Scalars['Int']['input'];
};

export type ProviderToOrgCreateManyOrgInputEnvelope = {
    data: Array<ProviderToOrgCreateManyOrgInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderToOrgCreateManyProviderInput = {
    orderNumber?: InputMaybe<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
    providerHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderToOrgCreateManyProviderInputEnvelope = {
    data: Array<ProviderToOrgCreateManyProviderInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderToOrgCreateNestedManyWithoutOrgInput = {
    connect?: InputMaybe<Array<ProviderToOrgWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderToOrgCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<ProviderToOrgCreateWithoutOrgInput>>;
    createMany?: InputMaybe<ProviderToOrgCreateManyOrgInputEnvelope>;
};

export type ProviderToOrgCreateNestedManyWithoutProviderInput = {
    connect?: InputMaybe<Array<ProviderToOrgWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderToOrgCreateOrConnectWithoutProviderInput>
    >;
    create?: InputMaybe<Array<ProviderToOrgCreateWithoutProviderInput>>;
    createMany?: InputMaybe<ProviderToOrgCreateManyProviderInputEnvelope>;
};

export type ProviderToOrgCreateOrConnectWithoutOrgInput = {
    create: ProviderToOrgCreateWithoutOrgInput;
    where: ProviderToOrgWhereUniqueInput;
};

export type ProviderToOrgCreateOrConnectWithoutProviderInput = {
    create: ProviderToOrgCreateWithoutProviderInput;
    where: ProviderToOrgWhereUniqueInput;
};

export type ProviderToOrgCreateWithoutOrgInput = {
    orderNumber?: InputMaybe<Scalars['Int']['input']>;
    provider: ProviderCreateNestedOneWithoutProviderToOrgsInput;
    providerHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderToOrgCreateWithoutProviderInput = {
    orderNumber?: InputMaybe<Scalars['Int']['input']>;
    org: OrganizationCreateNestedOneWithoutProviderToOrgsInput;
    providerHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderToOrgGroupBy = {
    __typename?: 'ProviderToOrgGroupBy';
    _avg?: Maybe<ProviderToOrgAvgAggregate>;
    _count?: Maybe<ProviderToOrgCountAggregate>;
    _max?: Maybe<ProviderToOrgMaxAggregate>;
    _min?: Maybe<ProviderToOrgMinAggregate>;
    _sum?: Maybe<ProviderToOrgSumAggregate>;
    orderNumber: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    providerHidden: Scalars['Boolean']['output'];
    providerId: Scalars['Int']['output'];
};

export type ProviderToOrgListRelationFilter = {
    every?: InputMaybe<ProviderToOrgWhereInput>;
    none?: InputMaybe<ProviderToOrgWhereInput>;
    some?: InputMaybe<ProviderToOrgWhereInput>;
};

export type ProviderToOrgMaxAggregate = {
    __typename?: 'ProviderToOrgMaxAggregate';
    orderNumber?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    providerHidden?: Maybe<Scalars['Boolean']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
};

export type ProviderToOrgMaxOrderByAggregateInput = {
    orderNumber?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    providerHidden?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type ProviderToOrgMinAggregate = {
    __typename?: 'ProviderToOrgMinAggregate';
    orderNumber?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    providerHidden?: Maybe<Scalars['Boolean']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
};

export type ProviderToOrgMinOrderByAggregateInput = {
    orderNumber?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    providerHidden?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type ProviderToOrgOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProviderToOrgOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProviderToOrgAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProviderToOrgCountOrderByAggregateInput>;
    _max?: InputMaybe<ProviderToOrgMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProviderToOrgMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProviderToOrgSumOrderByAggregateInput>;
    orderNumber?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    providerHidden?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type ProviderToOrgOrderByWithRelationInput = {
    orderNumber?: InputMaybe<SortOrder>;
    org?: InputMaybe<OrganizationOrderByWithRelationInput>;
    orgId?: InputMaybe<SortOrder>;
    provider?: InputMaybe<ProviderOrderByWithRelationInput>;
    providerHidden?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type ProviderToOrgProviderIdOrgIdCompoundUniqueInput = {
    orgId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
};

export type ProviderToOrgProviderIdOrgIdUniqueCompoundUniqueInput = {
    orgId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
};

export enum ProviderToOrgScalarFieldEnum {
    OrderNumber = 'orderNumber',
    OrgId = 'orgId',
    ProviderHidden = 'providerHidden',
    ProviderId = 'providerId',
}

export type ProviderToOrgScalarWhereInput = {
    AND?: InputMaybe<Array<ProviderToOrgScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProviderToOrgScalarWhereInput>>;
    OR?: InputMaybe<Array<ProviderToOrgScalarWhereInput>>;
    orderNumber?: InputMaybe<IntFilter>;
    orgId?: InputMaybe<IntFilter>;
    providerHidden?: InputMaybe<BoolFilter>;
    providerId?: InputMaybe<IntFilter>;
};

export type ProviderToOrgScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ProviderToOrgScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ProviderToOrgScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ProviderToOrgScalarWhereWithAggregatesInput>>;
    orderNumber?: InputMaybe<IntWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
    providerHidden?: InputMaybe<BoolWithAggregatesFilter>;
    providerId?: InputMaybe<IntWithAggregatesFilter>;
};

export type ProviderToOrgSumAggregate = {
    __typename?: 'ProviderToOrgSumAggregate';
    orderNumber?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
};

export type ProviderToOrgSumOrderByAggregateInput = {
    orderNumber?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type ProviderToOrgUpdateInput = {
    orderNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutProviderToOrgsNestedInput>;
    provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderToOrgsNestedInput>;
    providerHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProviderToOrgUpdateManyMutationInput = {
    orderNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProviderToOrgUpdateManyWithWhereWithoutOrgInput = {
    data: ProviderToOrgUpdateManyMutationInput;
    where: ProviderToOrgScalarWhereInput;
};

export type ProviderToOrgUpdateManyWithWhereWithoutProviderInput = {
    data: ProviderToOrgUpdateManyMutationInput;
    where: ProviderToOrgScalarWhereInput;
};

export type ProviderToOrgUpdateManyWithoutOrgNestedInput = {
    connect?: InputMaybe<Array<ProviderToOrgWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderToOrgCreateOrConnectWithoutOrgInput>
    >;
    create?: InputMaybe<Array<ProviderToOrgCreateWithoutOrgInput>>;
    createMany?: InputMaybe<ProviderToOrgCreateManyOrgInputEnvelope>;
    delete?: InputMaybe<Array<ProviderToOrgWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderToOrgScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderToOrgWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderToOrgWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderToOrgUpdateWithWhereUniqueWithoutOrgInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderToOrgUpdateManyWithWhereWithoutOrgInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderToOrgUpsertWithWhereUniqueWithoutOrgInput>
    >;
};

export type ProviderToOrgUpdateManyWithoutProviderNestedInput = {
    connect?: InputMaybe<Array<ProviderToOrgWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderToOrgCreateOrConnectWithoutProviderInput>
    >;
    create?: InputMaybe<Array<ProviderToOrgCreateWithoutProviderInput>>;
    createMany?: InputMaybe<ProviderToOrgCreateManyProviderInputEnvelope>;
    delete?: InputMaybe<Array<ProviderToOrgWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderToOrgScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderToOrgWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderToOrgWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderToOrgUpdateWithWhereUniqueWithoutProviderInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderToOrgUpdateManyWithWhereWithoutProviderInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderToOrgUpsertWithWhereUniqueWithoutProviderInput>
    >;
};

export type ProviderToOrgUpdateWithWhereUniqueWithoutOrgInput = {
    data: ProviderToOrgUpdateWithoutOrgInput;
    where: ProviderToOrgWhereUniqueInput;
};

export type ProviderToOrgUpdateWithWhereUniqueWithoutProviderInput = {
    data: ProviderToOrgUpdateWithoutProviderInput;
    where: ProviderToOrgWhereUniqueInput;
};

export type ProviderToOrgUpdateWithoutOrgInput = {
    orderNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
    provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderToOrgsNestedInput>;
    providerHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProviderToOrgUpdateWithoutProviderInput = {
    orderNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
    org?: InputMaybe<OrganizationUpdateOneRequiredWithoutProviderToOrgsNestedInput>;
    providerHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProviderToOrgUpsertWithWhereUniqueWithoutOrgInput = {
    create: ProviderToOrgCreateWithoutOrgInput;
    update: ProviderToOrgUpdateWithoutOrgInput;
    where: ProviderToOrgWhereUniqueInput;
};

export type ProviderToOrgUpsertWithWhereUniqueWithoutProviderInput = {
    create: ProviderToOrgCreateWithoutProviderInput;
    update: ProviderToOrgUpdateWithoutProviderInput;
    where: ProviderToOrgWhereUniqueInput;
};

export type ProviderToOrgWhereInput = {
    AND?: InputMaybe<Array<ProviderToOrgWhereInput>>;
    NOT?: InputMaybe<Array<ProviderToOrgWhereInput>>;
    OR?: InputMaybe<Array<ProviderToOrgWhereInput>>;
    orderNumber?: InputMaybe<IntFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    provider?: InputMaybe<ProviderRelationFilter>;
    providerHidden?: InputMaybe<BoolFilter>;
    providerId?: InputMaybe<IntFilter>;
};

export type ProviderToOrgWhereUniqueInput = {
    AND?: InputMaybe<Array<ProviderToOrgWhereInput>>;
    NOT?: InputMaybe<Array<ProviderToOrgWhereInput>>;
    OR?: InputMaybe<Array<ProviderToOrgWhereInput>>;
    orderNumber?: InputMaybe<IntFilter>;
    org?: InputMaybe<OrganizationRelationFilter>;
    orgId?: InputMaybe<IntFilter>;
    provider?: InputMaybe<ProviderRelationFilter>;
    providerHidden?: InputMaybe<BoolFilter>;
    providerId?: InputMaybe<IntFilter>;
    providerId_orgId?: InputMaybe<ProviderToOrgProviderIdOrgIdCompoundUniqueInput>;
    provider_id_org_id_unique?: InputMaybe<ProviderToOrgProviderIdOrgIdUniqueCompoundUniqueInput>;
};

export type ProviderToProviderGroup = {
    __typename?: 'ProviderToProviderGroup';
    createdAt: Scalars['DateTimeISO']['output'];
    npiId: Scalars['String']['output'];
    provider: Provider;
    providerGroupId: Scalars['Int']['output'];
    provider_group: ProviderGroup;
};

export type ProviderToProviderGroupAvgAggregate = {
    __typename?: 'ProviderToProviderGroupAvgAggregate';
    providerGroupId?: Maybe<Scalars['Float']['output']>;
};

export type ProviderToProviderGroupAvgOrderByAggregateInput = {
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ProviderToProviderGroupCountAggregate = {
    __typename?: 'ProviderToProviderGroupCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    npiId: Scalars['Int']['output'];
    providerGroupId: Scalars['Int']['output'];
};

export type ProviderToProviderGroupCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    npiId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ProviderToProviderGroupCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    provider: ProviderCreateNestedOneWithoutProviderToProviderGroupsInput;
    provider_group: ProviderGroupCreateNestedOneWithoutProviderToProviderGroupInput;
};

export type ProviderToProviderGroupCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    npiId: Scalars['String']['input'];
    providerGroupId: Scalars['Int']['input'];
};

export type ProviderToProviderGroupCreateManyProviderInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    providerGroupId: Scalars['Int']['input'];
};

export type ProviderToProviderGroupCreateManyProviderInputEnvelope = {
    data: Array<ProviderToProviderGroupCreateManyProviderInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderToProviderGroupCreateManyProviderGroupInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    npiId: Scalars['String']['input'];
};

export type ProviderToProviderGroupCreateManyProviderGroupInputEnvelope = {
    data: Array<ProviderToProviderGroupCreateManyProviderGroupInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderToProviderGroupCreateNestedManyWithoutProviderInput = {
    connect?: InputMaybe<Array<ProviderToProviderGroupWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderToProviderGroupCreateOrConnectWithoutProviderInput>
    >;
    create?: InputMaybe<
        Array<ProviderToProviderGroupCreateWithoutProviderInput>
    >;
    createMany?: InputMaybe<ProviderToProviderGroupCreateManyProviderInputEnvelope>;
};

export type ProviderToProviderGroupCreateNestedManyWithoutProviderGroupInput = {
    connect?: InputMaybe<Array<ProviderToProviderGroupWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderToProviderGroupCreateOrConnectWithoutProviderGroupInput>
    >;
    create?: InputMaybe<
        Array<ProviderToProviderGroupCreateWithoutProviderGroupInput>
    >;
    createMany?: InputMaybe<ProviderToProviderGroupCreateManyProviderGroupInputEnvelope>;
};

export type ProviderToProviderGroupCreateOrConnectWithoutProviderInput = {
    create: ProviderToProviderGroupCreateWithoutProviderInput;
    where: ProviderToProviderGroupWhereUniqueInput;
};

export type ProviderToProviderGroupCreateOrConnectWithoutProviderGroupInput = {
    create: ProviderToProviderGroupCreateWithoutProviderGroupInput;
    where: ProviderToProviderGroupWhereUniqueInput;
};

export type ProviderToProviderGroupCreateWithoutProviderInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    provider_group: ProviderGroupCreateNestedOneWithoutProviderToProviderGroupInput;
};

export type ProviderToProviderGroupCreateWithoutProviderGroupInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    provider: ProviderCreateNestedOneWithoutProviderToProviderGroupsInput;
};

export type ProviderToProviderGroupGroupBy = {
    __typename?: 'ProviderToProviderGroupGroupBy';
    _avg?: Maybe<ProviderToProviderGroupAvgAggregate>;
    _count?: Maybe<ProviderToProviderGroupCountAggregate>;
    _max?: Maybe<ProviderToProviderGroupMaxAggregate>;
    _min?: Maybe<ProviderToProviderGroupMinAggregate>;
    _sum?: Maybe<ProviderToProviderGroupSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    npiId: Scalars['String']['output'];
    providerGroupId: Scalars['Int']['output'];
};

export type ProviderToProviderGroupListRelationFilter = {
    every?: InputMaybe<ProviderToProviderGroupWhereInput>;
    none?: InputMaybe<ProviderToProviderGroupWhereInput>;
    some?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type ProviderToProviderGroupMaxAggregate = {
    __typename?: 'ProviderToProviderGroupMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    npiId?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ProviderToProviderGroupMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    npiId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ProviderToProviderGroupMinAggregate = {
    __typename?: 'ProviderToProviderGroupMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    npiId?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ProviderToProviderGroupMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    npiId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ProviderToProviderGroupNpiIdProviderGroupIdCompoundUniqueInput = {
    npiId: Scalars['String']['input'];
    providerGroupId: Scalars['Int']['input'];
};

export type ProviderToProviderGroupOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type ProviderToProviderGroupOrderByWithAggregationInput = {
    _avg?: InputMaybe<ProviderToProviderGroupAvgOrderByAggregateInput>;
    _count?: InputMaybe<ProviderToProviderGroupCountOrderByAggregateInput>;
    _max?: InputMaybe<ProviderToProviderGroupMaxOrderByAggregateInput>;
    _min?: InputMaybe<ProviderToProviderGroupMinOrderByAggregateInput>;
    _sum?: InputMaybe<ProviderToProviderGroupSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    npiId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ProviderToProviderGroupOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    npiId?: InputMaybe<SortOrder>;
    provider?: InputMaybe<ProviderOrderByWithRelationInput>;
    providerGroupId?: InputMaybe<SortOrder>;
    provider_group?: InputMaybe<ProviderGroupOrderByWithRelationInput>;
};

export enum ProviderToProviderGroupScalarFieldEnum {
    CreatedAt = 'createdAt',
    NpiId = 'npiId',
    ProviderGroupId = 'providerGroupId',
}

export type ProviderToProviderGroupScalarWhereInput = {
    AND?: InputMaybe<Array<ProviderToProviderGroupScalarWhereInput>>;
    NOT?: InputMaybe<Array<ProviderToProviderGroupScalarWhereInput>>;
    OR?: InputMaybe<Array<ProviderToProviderGroupScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    npiId?: InputMaybe<StringFilter>;
    providerGroupId?: InputMaybe<IntFilter>;
};

export type ProviderToProviderGroupScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<ProviderToProviderGroupScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<ProviderToProviderGroupScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<ProviderToProviderGroupScalarWhereWithAggregatesInput>
    >;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    npiId?: InputMaybe<StringWithAggregatesFilter>;
    providerGroupId?: InputMaybe<IntWithAggregatesFilter>;
};

export type ProviderToProviderGroupSumAggregate = {
    __typename?: 'ProviderToProviderGroupSumAggregate';
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ProviderToProviderGroupSumOrderByAggregateInput = {
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ProviderToProviderGroupUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderToProviderGroupsNestedInput>;
    provider_group?: InputMaybe<ProviderGroupUpdateOneRequiredWithoutProviderToProviderGroupNestedInput>;
};

export type ProviderToProviderGroupUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderToProviderGroupUpdateManyWithWhereWithoutProviderInput = {
    data: ProviderToProviderGroupUpdateManyMutationInput;
    where: ProviderToProviderGroupScalarWhereInput;
};

export type ProviderToProviderGroupUpdateManyWithWhereWithoutProviderGroupInput =
    {
        data: ProviderToProviderGroupUpdateManyMutationInput;
        where: ProviderToProviderGroupScalarWhereInput;
    };

export type ProviderToProviderGroupUpdateManyWithoutProviderNestedInput = {
    connect?: InputMaybe<Array<ProviderToProviderGroupWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderToProviderGroupCreateOrConnectWithoutProviderInput>
    >;
    create?: InputMaybe<
        Array<ProviderToProviderGroupCreateWithoutProviderInput>
    >;
    createMany?: InputMaybe<ProviderToProviderGroupCreateManyProviderInputEnvelope>;
    delete?: InputMaybe<Array<ProviderToProviderGroupWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderToProviderGroupScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderToProviderGroupWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderToProviderGroupWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderToProviderGroupUpdateWithWhereUniqueWithoutProviderInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderToProviderGroupUpdateManyWithWhereWithoutProviderInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderToProviderGroupUpsertWithWhereUniqueWithoutProviderInput>
    >;
};

export type ProviderToProviderGroupUpdateManyWithoutProviderGroupNestedInput = {
    connect?: InputMaybe<Array<ProviderToProviderGroupWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderToProviderGroupCreateOrConnectWithoutProviderGroupInput>
    >;
    create?: InputMaybe<
        Array<ProviderToProviderGroupCreateWithoutProviderGroupInput>
    >;
    createMany?: InputMaybe<ProviderToProviderGroupCreateManyProviderGroupInputEnvelope>;
    delete?: InputMaybe<Array<ProviderToProviderGroupWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderToProviderGroupScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderToProviderGroupWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderToProviderGroupWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderToProviderGroupUpdateWithWhereUniqueWithoutProviderGroupInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderToProviderGroupUpdateManyWithWhereWithoutProviderGroupInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderToProviderGroupUpsertWithWhereUniqueWithoutProviderGroupInput>
    >;
};

export type ProviderToProviderGroupUpdateWithWhereUniqueWithoutProviderInput = {
    data: ProviderToProviderGroupUpdateWithoutProviderInput;
    where: ProviderToProviderGroupWhereUniqueInput;
};

export type ProviderToProviderGroupUpdateWithWhereUniqueWithoutProviderGroupInput =
    {
        data: ProviderToProviderGroupUpdateWithoutProviderGroupInput;
        where: ProviderToProviderGroupWhereUniqueInput;
    };

export type ProviderToProviderGroupUpdateWithoutProviderInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    provider_group?: InputMaybe<ProviderGroupUpdateOneRequiredWithoutProviderToProviderGroupNestedInput>;
};

export type ProviderToProviderGroupUpdateWithoutProviderGroupInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderToProviderGroupsNestedInput>;
};

export type ProviderToProviderGroupUpsertWithWhereUniqueWithoutProviderInput = {
    create: ProviderToProviderGroupCreateWithoutProviderInput;
    update: ProviderToProviderGroupUpdateWithoutProviderInput;
    where: ProviderToProviderGroupWhereUniqueInput;
};

export type ProviderToProviderGroupUpsertWithWhereUniqueWithoutProviderGroupInput =
    {
        create: ProviderToProviderGroupCreateWithoutProviderGroupInput;
        update: ProviderToProviderGroupUpdateWithoutProviderGroupInput;
        where: ProviderToProviderGroupWhereUniqueInput;
    };

export type ProviderToProviderGroupWhereInput = {
    AND?: InputMaybe<Array<ProviderToProviderGroupWhereInput>>;
    NOT?: InputMaybe<Array<ProviderToProviderGroupWhereInput>>;
    OR?: InputMaybe<Array<ProviderToProviderGroupWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    npiId?: InputMaybe<StringFilter>;
    provider?: InputMaybe<ProviderRelationFilter>;
    providerGroupId?: InputMaybe<IntFilter>;
    provider_group?: InputMaybe<ProviderGroupRelationFilter>;
};

export type ProviderToProviderGroupWhereUniqueInput = {
    AND?: InputMaybe<Array<ProviderToProviderGroupWhereInput>>;
    NOT?: InputMaybe<Array<ProviderToProviderGroupWhereInput>>;
    OR?: InputMaybe<Array<ProviderToProviderGroupWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    npiId?: InputMaybe<StringFilter>;
    npiId_providerGroupId?: InputMaybe<ProviderToProviderGroupNpiIdProviderGroupIdCompoundUniqueInput>;
    provider?: InputMaybe<ProviderRelationFilter>;
    providerGroupId?: InputMaybe<IntFilter>;
    provider_group?: InputMaybe<ProviderGroupRelationFilter>;
};

export type ProviderUpdateInput = {
    degrees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
    npiId?: InputMaybe<StringFieldUpdateOperationsInput>;
    providerCredentialings?: InputMaybe<ProviderCredentialingUpdateManyWithoutProviderNestedInput>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutProviderNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutProviderNestedInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupUpdateManyWithoutProviderNestedInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyUpdateOneWithoutProviderNestedInput>;
    title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProviderUpdateManyMutationInput = {
    degrees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
    npiId?: InputMaybe<StringFieldUpdateOperationsInput>;
    title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProviderUpdateManyWithWhereWithoutTaxonomyInput = {
    data: ProviderUpdateManyMutationInput;
    where: ProviderScalarWhereInput;
};

export type ProviderUpdateManyWithoutTaxonomyNestedInput = {
    connect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<ProviderCreateOrConnectWithoutTaxonomyInput>
    >;
    create?: InputMaybe<Array<ProviderCreateWithoutTaxonomyInput>>;
    createMany?: InputMaybe<ProviderCreateManyTaxonomyInputEnvelope>;
    delete?: InputMaybe<Array<ProviderWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<ProviderScalarWhereInput>>;
    disconnect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
    set?: InputMaybe<Array<ProviderWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProviderUpdateWithWhereUniqueWithoutTaxonomyInput>
    >;
    updateMany?: InputMaybe<
        Array<ProviderUpdateManyWithWhereWithoutTaxonomyInput>
    >;
    upsert?: InputMaybe<
        Array<ProviderUpsertWithWhereUniqueWithoutTaxonomyInput>
    >;
};

export type ProviderUpdateOneRequiredWithoutProviderCredentialingsNestedInput =
    {
        connect?: InputMaybe<ProviderWhereUniqueInput>;
        connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutProviderCredentialingsInput>;
        create?: InputMaybe<ProviderCreateWithoutProviderCredentialingsInput>;
        update?: InputMaybe<ProviderUpdateToOneWithWhereWithoutProviderCredentialingsInput>;
        upsert?: InputMaybe<ProviderUpsertWithoutProviderCredentialingsInput>;
    };

export type ProviderUpdateOneRequiredWithoutProviderHrtMaxCountNestedInput = {
    connect?: InputMaybe<ProviderWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutProviderHrtMaxCountInput>;
    create?: InputMaybe<ProviderCreateWithoutProviderHrtMaxCountInput>;
    update?: InputMaybe<ProviderUpdateToOneWithWhereWithoutProviderHrtMaxCountInput>;
    upsert?: InputMaybe<ProviderUpsertWithoutProviderHrtMaxCountInput>;
};

export type ProviderUpdateOneRequiredWithoutProviderToOrgsNestedInput = {
    connect?: InputMaybe<ProviderWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutProviderToOrgsInput>;
    create?: InputMaybe<ProviderCreateWithoutProviderToOrgsInput>;
    update?: InputMaybe<ProviderUpdateToOneWithWhereWithoutProviderToOrgsInput>;
    upsert?: InputMaybe<ProviderUpsertWithoutProviderToOrgsInput>;
};

export type ProviderUpdateOneRequiredWithoutProviderToProviderGroupsNestedInput =
    {
        connect?: InputMaybe<ProviderWhereUniqueInput>;
        connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutProviderToProviderGroupsInput>;
        create?: InputMaybe<ProviderCreateWithoutProviderToProviderGroupsInput>;
        update?: InputMaybe<ProviderUpdateToOneWithWhereWithoutProviderToProviderGroupsInput>;
        upsert?: InputMaybe<ProviderUpsertWithoutProviderToProviderGroupsInput>;
    };

export type ProviderUpdateToOneWithWhereWithoutProviderCredentialingsInput = {
    data: ProviderUpdateWithoutProviderCredentialingsInput;
    where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpdateToOneWithWhereWithoutProviderHrtMaxCountInput = {
    data: ProviderUpdateWithoutProviderHrtMaxCountInput;
    where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpdateToOneWithWhereWithoutProviderToOrgsInput = {
    data: ProviderUpdateWithoutProviderToOrgsInput;
    where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpdateToOneWithWhereWithoutProviderToProviderGroupsInput = {
    data: ProviderUpdateWithoutProviderToProviderGroupsInput;
    where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpdateWithWhereUniqueWithoutTaxonomyInput = {
    data: ProviderUpdateWithoutTaxonomyInput;
    where: ProviderWhereUniqueInput;
};

export type ProviderUpdateWithoutProviderCredentialingsInput = {
    degrees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
    npiId?: InputMaybe<StringFieldUpdateOperationsInput>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutProviderNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutProviderNestedInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupUpdateManyWithoutProviderNestedInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyUpdateOneWithoutProviderNestedInput>;
    title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProviderUpdateWithoutProviderHrtMaxCountInput = {
    degrees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
    npiId?: InputMaybe<StringFieldUpdateOperationsInput>;
    providerCredentialings?: InputMaybe<ProviderCredentialingUpdateManyWithoutProviderNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutProviderNestedInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupUpdateManyWithoutProviderNestedInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyUpdateOneWithoutProviderNestedInput>;
    title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProviderUpdateWithoutProviderToOrgsInput = {
    degrees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
    npiId?: InputMaybe<StringFieldUpdateOperationsInput>;
    providerCredentialings?: InputMaybe<ProviderCredentialingUpdateManyWithoutProviderNestedInput>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutProviderNestedInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupUpdateManyWithoutProviderNestedInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyUpdateOneWithoutProviderNestedInput>;
    title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProviderUpdateWithoutProviderToProviderGroupsInput = {
    degrees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
    npiId?: InputMaybe<StringFieldUpdateOperationsInput>;
    providerCredentialings?: InputMaybe<ProviderCredentialingUpdateManyWithoutProviderNestedInput>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutProviderNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutProviderNestedInput>;
    taxonomy?: InputMaybe<ProviderTaxonomyUpdateOneWithoutProviderNestedInput>;
    title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProviderUpdateWithoutTaxonomyInput = {
    degrees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    displayLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<IntFieldUpdateOperationsInput>;
    imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
    npiId?: InputMaybe<StringFieldUpdateOperationsInput>;
    providerCredentialings?: InputMaybe<ProviderCredentialingUpdateManyWithoutProviderNestedInput>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountUpdateManyWithoutProviderNestedInput>;
    providerToOrgs?: InputMaybe<ProviderToOrgUpdateManyWithoutProviderNestedInput>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupUpdateManyWithoutProviderNestedInput>;
    title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProviderUpsertWithWhereUniqueWithoutTaxonomyInput = {
    create: ProviderCreateWithoutTaxonomyInput;
    update: ProviderUpdateWithoutTaxonomyInput;
    where: ProviderWhereUniqueInput;
};

export type ProviderUpsertWithoutProviderCredentialingsInput = {
    create: ProviderCreateWithoutProviderCredentialingsInput;
    update: ProviderUpdateWithoutProviderCredentialingsInput;
    where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpsertWithoutProviderHrtMaxCountInput = {
    create: ProviderCreateWithoutProviderHrtMaxCountInput;
    update: ProviderUpdateWithoutProviderHrtMaxCountInput;
    where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpsertWithoutProviderToOrgsInput = {
    create: ProviderCreateWithoutProviderToOrgsInput;
    update: ProviderUpdateWithoutProviderToOrgsInput;
    where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpsertWithoutProviderToProviderGroupsInput = {
    create: ProviderCreateWithoutProviderToProviderGroupsInput;
    update: ProviderUpdateWithoutProviderToProviderGroupsInput;
    where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderWhereInput = {
    AND?: InputMaybe<Array<ProviderWhereInput>>;
    NOT?: InputMaybe<Array<ProviderWhereInput>>;
    OR?: InputMaybe<Array<ProviderWhereInput>>;
    degrees?: InputMaybe<StringNullableFilter>;
    description?: InputMaybe<StringNullableFilter>;
    displayFirstName?: InputMaybe<StringNullableFilter>;
    displayLastName?: InputMaybe<StringNullableFilter>;
    ehrId?: InputMaybe<StringNullableFilter>;
    firstName?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    imageUrl?: InputMaybe<StringNullableFilter>;
    isSpecialist?: InputMaybe<BoolNullableFilter>;
    lastName?: InputMaybe<StringFilter>;
    npiId?: InputMaybe<StringFilter>;
    providerCredentialings?: InputMaybe<ProviderCredentialingListRelationFilter>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountListRelationFilter>;
    providerToOrgs?: InputMaybe<ProviderToOrgListRelationFilter>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupListRelationFilter>;
    taxonomy?: InputMaybe<ProviderTaxonomyNullableRelationFilter>;
    taxonomyCode?: InputMaybe<StringNullableFilter>;
    title?: InputMaybe<StringNullableFilter>;
};

export type ProviderWhereUniqueInput = {
    AND?: InputMaybe<Array<ProviderWhereInput>>;
    NOT?: InputMaybe<Array<ProviderWhereInput>>;
    OR?: InputMaybe<Array<ProviderWhereInput>>;
    degrees?: InputMaybe<StringNullableFilter>;
    description?: InputMaybe<StringNullableFilter>;
    displayFirstName?: InputMaybe<StringNullableFilter>;
    displayLastName?: InputMaybe<StringNullableFilter>;
    ehrId?: InputMaybe<StringNullableFilter>;
    firstName?: InputMaybe<StringFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    imageUrl?: InputMaybe<StringNullableFilter>;
    isSpecialist?: InputMaybe<BoolNullableFilter>;
    lastName?: InputMaybe<StringFilter>;
    npiId?: InputMaybe<Scalars['String']['input']>;
    providerCredentialings?: InputMaybe<ProviderCredentialingListRelationFilter>;
    providerHrtMaxCount?: InputMaybe<ProviderHrtMaxCountListRelationFilter>;
    providerToOrgs?: InputMaybe<ProviderToOrgListRelationFilter>;
    providerToProviderGroups?: InputMaybe<ProviderToProviderGroupListRelationFilter>;
    taxonomy?: InputMaybe<ProviderTaxonomyNullableRelationFilter>;
    taxonomyCode?: InputMaybe<StringNullableFilter>;
    title?: InputMaybe<StringNullableFilter>;
};

export type Query = {
    __typename?: 'Query';
    aLEConfig?: Maybe<AleConfig>;
    aLEConfigs: Array<AleConfig>;
    aLEDepartmentGoLive?: Maybe<AleDepartmentGoLive>;
    aLEDepartmentGoLives: Array<AleDepartmentGoLive>;
    adjudication?: Maybe<Adjudication>;
    adjudicationAuditLog?: Maybe<AdjudicationAuditLog>;
    adjudicationAuditLogs: Array<AdjudicationAuditLog>;
    adjudications: Array<Adjudication>;
    adjustment?: Maybe<Adjustment>;
    adjustmentAuditLog?: Maybe<AdjustmentAuditLog>;
    adjustmentAuditLogs: Array<AdjustmentAuditLog>;
    adjustments: Array<Adjustment>;
    admin?: Maybe<Admin>;
    adminInteraction?: Maybe<AdminInteraction>;
    adminInteractions: Array<AdminInteraction>;
    admins: Array<Admin>;
    aggregateALEConfig: AggregateAleConfig;
    aggregateALEDepartmentGoLive: AggregateAleDepartmentGoLive;
    aggregateAdjudication: AggregateAdjudication;
    aggregateAdjudicationAuditLog: AggregateAdjudicationAuditLog;
    aggregateAdjustment: AggregateAdjustment;
    aggregateAdjustmentAuditLog: AggregateAdjustmentAuditLog;
    aggregateAdmin: AggregateAdmin;
    aggregateAdminInteraction: AggregateAdminInteraction;
    aggregateAppointment: AggregateAppointment;
    aggregateAppointmentAuditLog: AggregateAppointmentAuditLog;
    aggregateArrearBilling: AggregateArrearBilling;
    aggregateArtClaim: AggregateArtClaim;
    aggregateArtClaimAuditLog: AggregateArtClaimAuditLog;
    aggregateArtClaimCptLine: AggregateArtClaimCptLine;
    aggregateArtClaimCptLineAuditLog: AggregateArtClaimCptLineAuditLog;
    aggregateArtOrgConfig: AggregateArtOrgConfig;
    aggregateArtPracticeConfig: AggregateArtPracticeConfig;
    aggregateAthenaMedications: AggregateAthenaMedications;
    aggregateAthenaPharmacy: AggregateAthenaPharmacy;
    aggregateAthenaProvider: AggregateAthenaProvider;
    aggregateBenefitParsingRules: AggregateBenefitParsingRules;
    aggregateBillingCode: AggregateBillingCode;
    aggregateBillingTableDownloadRequest: AggregateBillingTableDownloadRequest;
    aggregateBoughtTreatment: AggregateBoughtTreatment;
    aggregateBoughtTreatmentAuditLog: AggregateBoughtTreatmentAuditLog;
    aggregateBoughtTreatmentClaimDetail: AggregateBoughtTreatmentClaimDetail;
    aggregateBulkChargeCardRun: AggregateBulkChargeCardRun;
    aggregateBulkChargeCardRunItem: AggregateBulkChargeCardRunItem;
    aggregateBundle: AggregateBundle;
    aggregateBundleToHrt: AggregateBundleToHrt;
    aggregateBusinessHour: AggregateBusinessHour;
    aggregateCandidateTreatment: AggregateCandidateTreatment;
    aggregateCardAuthorization: AggregateCardAuthorization;
    aggregateCardAuthorizationAuditLog: AggregateCardAuthorizationAuditLog;
    aggregateCashPrice: AggregateCashPrice;
    aggregateCharge: AggregateCharge;
    aggregateChargeAuditLog: AggregateChargeAuditLog;
    aggregateChargeReattributionAndPartialPaymentLog: AggregateChargeReattributionAndPartialPaymentLog;
    aggregateChargeReattributionLog: AggregateChargeReattributionLog;
    aggregateCheckNetworkStatusResults: AggregateCheckNetworkStatusResults;
    aggregateCheckoutAdjudication: AggregateCheckoutAdjudication;
    aggregateClaimToBoughtTreatment: AggregateClaimToBoughtTreatment;
    aggregateConfigCommit: AggregateConfigCommit;
    aggregateConfigFlag: AggregateConfigFlag;
    aggregateConfigSession: AggregateConfigSession;
    aggregateConsentForm: AggregateConsentForm;
    aggregateConsumer: AggregateConsumer;
    aggregateConsumerAuditLog: AggregateConsumerAuditLog;
    aggregateConsumerMessage: AggregateConsumerMessage;
    aggregateConsumerNote: AggregateConsumerNote;
    aggregateConsumerPhotoMetaData: AggregateConsumerPhotoMetaData;
    aggregateConsumerSrtRecords: AggregateConsumerSrtRecords;
    aggregateContract: AggregateContract;
    aggregateContractAuditLog: AggregateContractAuditLog;
    aggregateCoverageResponses: AggregateCoverageResponses;
    aggregateCptExclusivityEdge: AggregateCptExclusivityEdge;
    aggregateCustomField: AggregateCustomField;
    aggregateCustomFieldValue: AggregateCustomFieldValue;
    aggregateDataMigrations: AggregateDataMigrations;
    aggregateDefaultPractice: AggregateDefaultPractice;
    aggregateDefault_providers: AggregateDefaultProviders;
    aggregateDeploymentOrgPhase: AggregateDeploymentOrgPhase;
    aggregateDeploymentOrgTask: AggregateDeploymentOrgTask;
    aggregateDeploymentOrgTaskDependency: AggregateDeploymentOrgTaskDependency;
    aggregateDeploymentPhase: AggregateDeploymentPhase;
    aggregateDeploymentTask: AggregateDeploymentTask;
    aggregateDeploymentTaskDependency: AggregateDeploymentTaskDependency;
    aggregateDeploymentTeam: AggregateDeploymentTeam;
    aggregateDiscountCodes: AggregateDiscountCodes;
    aggregateEcwPayerAlias: AggregateEcwPayerAlias;
    aggregateEcwPayerStc: AggregateEcwPayerStc;
    aggregateEhrAppointmentTypeIdToName: AggregateEhrAppointmentTypeIdToName;
    aggregateEhrPaymentDescriptor: AggregateEhrPaymentDescriptor;
    aggregateEhrPaymentDescriptorAuditLog: AggregateEhrPaymentDescriptorAuditLog;
    aggregateEhrPaymentDirectionSsAsset: AggregateEhrPaymentDirectionSsAsset;
    aggregateEhrPostDetail: AggregateEhrPostDetail;
    aggregateEhrPostDetailToPayout: AggregateEhrPostDetailToPayout;
    aggregateEhrPostLedger: AggregateEhrPostLedger;
    aggregateEhrPostLedgerAuditLog: AggregateEhrPostLedgerAuditLog;
    aggregateEhrPostLedgerToPayout: AggregateEhrPostLedgerToPayout;
    aggregateEhrPrimaryCareProvider: AggregateEhrPrimaryCareProvider;
    aggregateEhrProviderMapping: AggregateEhrProviderMapping;
    aggregateEhrSlot: AggregateEhrSlot;
    aggregateEhrSlotAuditLog: AggregateEhrSlotAuditLog;
    aggregateEncounter: AggregateEncounter;
    aggregateExperityEncounter: AggregateExperityEncounter;
    aggregateFaqDropdowns: AggregateFaqDropdowns;
    aggregateFeeConfig: AggregateFeeConfig;
    aggregateFeeConfigAuditLog: AggregateFeeConfigAuditLog;
    aggregateGuarantorPaymentLinkContext: AggregateGuarantorPaymentLinkContext;
    aggregateHoliday: AggregateHoliday;
    aggregateHrt: AggregateHrt;
    aggregateHrtFlags: AggregateHrtFlags;
    aggregateHrtPaymentType: AggregateHrtPaymentType;
    aggregateHrtToSrt: AggregateHrtToSrt;
    aggregateHrtTranslation: AggregateHrtTranslation;
    aggregateInboundRequestLog: AggregateInboundRequestLog;
    aggregateInboundTextMessageLog: AggregateInboundTextMessageLog;
    aggregateInsurance: AggregateInsurance;
    aggregateInsuranceAuditLog: AggregateInsuranceAuditLog;
    aggregateInsuranceMetadata: AggregateInsuranceMetadata;
    aggregateIntakeForm: AggregateIntakeForm;
    aggregateIntakeFormSection: AggregateIntakeFormSection;
    aggregateIntakeFormSectionTranslation: AggregateIntakeFormSectionTranslation;
    aggregateIntakeFormToQuestion: AggregateIntakeFormToQuestion;
    aggregateIntakeQuestion: AggregateIntakeQuestion;
    aggregateIntakeQuestionTranslation: AggregateIntakeQuestionTranslation;
    aggregateInvoiceDailyLineItems: AggregateInvoiceDailyLineItems;
    aggregateInvoices: AggregateInvoices;
    aggregateKeywordRule: AggregateKeywordRule;
    aggregateLinkMapping: AggregateLinkMapping;
    aggregateLiveTransfers: AggregateLiveTransfers;
    aggregateMcmsAssociation: AggregateMcmsAssociation;
    aggregateMcmsAssociationAuditLog: AggregateMcmsAssociationAuditLog;
    aggregateMcmsAssociationClaim: AggregateMcmsAssociationClaim;
    aggregateMcmsAssociationClaimAuditLog: AggregateMcmsAssociationClaimAuditLog;
    aggregateMcmsAssociationSlot: AggregateMcmsAssociationSlot;
    aggregateMcmsAssociationSlotAuditLog: AggregateMcmsAssociationSlotAuditLog;
    aggregateMessageBlueprint: AggregateMessageBlueprint;
    aggregateMessageConsolidationContext: AggregateMessageConsolidationContext;
    aggregateMessageConsolidationTemplate: AggregateMessageConsolidationTemplate;
    aggregateMessageNudge: AggregateMessageNudge;
    aggregateMessageOrchestrationRule: AggregateMessageOrchestrationRule;
    aggregateMessagePayAfter: AggregateMessagePayAfter;
    aggregateMessageSettingsHrt: AggregateMessageSettingsHrt;
    aggregateMessageSettingsOrg: AggregateMessageSettingsOrg;
    aggregateMessageTemplateHrt: AggregateMessageTemplateHrt;
    aggregateMessageTemplateOrg: AggregateMessageTemplateOrg;
    aggregateMigratedEncounter: AggregateMigratedEncounter;
    aggregateMigrations: AggregateMigrations;
    aggregateNetworkValidation: AggregateNetworkValidation;
    aggregateNetwork_plan_exceptions: AggregateNetworkPlanExceptions;
    aggregateNonCardRefunds: AggregateNonCardRefunds;
    aggregateOrgConfigFlag: AggregateOrgConfigFlag;
    aggregateOrgHrtSrtRule: AggregateOrgHrtSrtRule;
    aggregateOrgNetworkResults: AggregateOrgNetworkResults;
    aggregateOrgOverrideRule: AggregateOrgOverrideRule;
    aggregateOrg_fees: AggregateOrgFees;
    aggregateOrg_stripe_mapping: AggregateOrgStripeMapping;
    aggregateOrganization: AggregateOrganization;
    aggregateOrganizationAssets: AggregateOrganizationAssets;
    aggregateOrganizationTranslation: AggregateOrganizationTranslation;
    aggregatePayLaterAuthorization: AggregatePayLaterAuthorization;
    aggregatePayLaterAuthorizationAuditLog: AggregatePayLaterAuthorizationAuditLog;
    aggregatePayer: AggregatePayer;
    aggregatePayerPlanMapping: AggregatePayerPlanMapping;
    aggregatePayerToEhrInsurancePackageMapping: AggregatePayerToEhrInsurancePackageMapping;
    aggregatePaymentAuthorization: AggregatePaymentAuthorization;
    aggregatePaymentAuthorizationAuditLog: AggregatePaymentAuthorizationAuditLog;
    aggregatePaymentContract: AggregatePaymentContract;
    aggregatePaymentPlan: AggregatePaymentPlan;
    aggregatePaymentPlanAdjustment: AggregatePaymentPlanAdjustment;
    aggregatePaymentPlanAdjustmentAuditLog: AggregatePaymentPlanAdjustmentAuditLog;
    aggregatePaymentPlanAuditLog: AggregatePaymentPlanAuditLog;
    aggregatePaymentPlanAutoCharge: AggregatePaymentPlanAutoCharge;
    aggregatePaymentPlanAutoChargeAuditLog: AggregatePaymentPlanAutoChargeAuditLog;
    aggregatePaymentPlanBoughtTreatment: AggregatePaymentPlanBoughtTreatment;
    aggregatePaymentPlanBoughtTreatmentAuditLog: AggregatePaymentPlanBoughtTreatmentAuditLog;
    aggregatePaymentPlanOrgConfig: AggregatePaymentPlanOrgConfig;
    aggregatePaymentPlanOrgConfigAuditLog: AggregatePaymentPlanOrgConfigAuditLog;
    aggregatePayout: AggregatePayout;
    aggregatePayoutAuditLog: AggregatePayoutAuditLog;
    aggregatePendingVoidPayoutReversal: AggregatePendingVoidPayoutReversal;
    aggregatePhoneNumberType: AggregatePhoneNumberType;
    aggregatePlaceOfServiceCode: AggregatePlaceOfServiceCode;
    aggregatePractice: AggregatePractice;
    aggregatePracticeConfiguration: AggregatePracticeConfiguration;
    aggregatePracticeHours: AggregatePracticeHours;
    aggregatePracticeHoursOverrides: AggregatePracticeHoursOverrides;
    aggregatePricedTreatment: AggregatePricedTreatment;
    aggregatePricingAttempt: AggregatePricingAttempt;
    aggregatePricingEscalator: AggregatePricingEscalator;
    aggregatePricingQueue: AggregatePricingQueue;
    aggregatePricingResults: AggregatePricingResults;
    aggregateProcedureBenefitParsingRules: AggregateProcedureBenefitParsingRules;
    aggregateProductCategories: AggregateProductCategories;
    aggregateProductCategoryTranslation: AggregateProductCategoryTranslation;
    aggregateProductToBundle: AggregateProductToBundle;
    aggregateProductToHrt: AggregateProductToHrt;
    aggregateProductTranslation: AggregateProductTranslation;
    aggregateProducts: AggregateProducts;
    aggregateProvider: AggregateProvider;
    aggregateProviderCredentialing: AggregateProviderCredentialing;
    aggregateProviderGroup: AggregateProviderGroup;
    aggregateProviderGroupToHrt: AggregateProviderGroupToHrt;
    aggregateProviderHrtMaxCount: AggregateProviderHrtMaxCount;
    aggregateProviderTaxonomy: AggregateProviderTaxonomy;
    aggregateProviderToOrg: AggregateProviderToOrg;
    aggregateProviderToProviderGroup: AggregateProviderToProviderGroup;
    aggregateReattributionDirection: AggregateReattributionDirection;
    aggregateReceiptArrangement: AggregateReceiptArrangement;
    aggregateReservedEhrVisit: AggregateReservedEhrVisit;
    aggregateResetToken: AggregateResetToken;
    aggregateSavedIntakeResponse: AggregateSavedIntakeResponse;
    aggregateSchedulingSlotConfig: AggregateSchedulingSlotConfig;
    aggregateServiceTypeCode: AggregateServiceTypeCode;
    aggregateSlot: AggregateSlot;
    aggregateSlotAuditLog: AggregateSlotAuditLog;
    aggregateSrt: AggregateSrt;
    aggregateSrtFlags: AggregateSrtFlags;
    aggregateSrtMultiplierRule: AggregateSrtMultiplierRule;
    aggregateSrtToBillingCode: AggregateSrtToBillingCode;
    aggregateStatePayerMapping: AggregateStatePayerMapping;
    aggregateSuperscriptFeeLineItem: AggregateSuperscriptFeeLineItem;
    aggregateSuperscriptFees: AggregateSuperscriptFees;
    aggregateSuperscriptIntakeQuestion: AggregateSuperscriptIntakeQuestion;
    aggregateTimeBlock: AggregateTimeBlock;
    aggregateTransaction: AggregateTransaction;
    aggregateUser: AggregateUser;
    aggregateUserAuditLog: AggregateUserAuditLog;
    aggregateUserPracticeVisit: AggregateUserPracticeVisit;
    aggregateUserToNewUser: AggregateUserToNewUser;
    aggregateValidPayers: AggregateValidPayers;
    appointment?: Maybe<Appointment>;
    appointmentAuditLog?: Maybe<AppointmentAuditLog>;
    appointmentAuditLogs: Array<AppointmentAuditLog>;
    appointments: Array<Appointment>;
    arrearBilling?: Maybe<ArrearBilling>;
    arrearBillings: Array<ArrearBilling>;
    artClaim?: Maybe<ArtClaim>;
    artClaimAuditLog?: Maybe<ArtClaimAuditLog>;
    artClaimAuditLogs: Array<ArtClaimAuditLog>;
    artClaimCptLine?: Maybe<ArtClaimCptLine>;
    artClaimCptLineAuditLog?: Maybe<ArtClaimCptLineAuditLog>;
    artClaimCptLineAuditLogs: Array<ArtClaimCptLineAuditLog>;
    artClaimCptLines: Array<ArtClaimCptLine>;
    artClaims: Array<ArtClaim>;
    artOrgConfig?: Maybe<ArtOrgConfig>;
    artOrgConfigs: Array<ArtOrgConfig>;
    artPracticeConfig?: Maybe<ArtPracticeConfig>;
    artPracticeConfigs: Array<ArtPracticeConfig>;
    athenaPharmacies: Array<AthenaPharmacy>;
    athenaPharmacy?: Maybe<AthenaPharmacy>;
    athenaProvider?: Maybe<AthenaProvider>;
    athenaProviders: Array<AthenaProvider>;
    billingCode?: Maybe<BillingCode>;
    billingCodes: Array<BillingCode>;
    billingTableDownloadRequest?: Maybe<BillingTableDownloadRequest>;
    billingTableDownloadRequests: Array<BillingTableDownloadRequest>;
    boughtTreatment?: Maybe<BoughtTreatment>;
    boughtTreatmentAuditLog?: Maybe<BoughtTreatmentAuditLog>;
    boughtTreatmentAuditLogs: Array<BoughtTreatmentAuditLog>;
    boughtTreatmentClaimDetail?: Maybe<BoughtTreatmentClaimDetail>;
    boughtTreatmentClaimDetails: Array<BoughtTreatmentClaimDetail>;
    boughtTreatments: Array<BoughtTreatment>;
    bulkChargeCardRun?: Maybe<BulkChargeCardRun>;
    bulkChargeCardRunItem?: Maybe<BulkChargeCardRunItem>;
    bulkChargeCardRunItems: Array<BulkChargeCardRunItem>;
    bulkChargeCardRuns: Array<BulkChargeCardRun>;
    bundle?: Maybe<Bundle>;
    bundleToHrt?: Maybe<BundleToHrt>;
    bundleToHrts: Array<BundleToHrt>;
    bundles: Array<Bundle>;
    businessHour?: Maybe<BusinessHour>;
    businessHours: Array<BusinessHour>;
    candidateTreatment?: Maybe<CandidateTreatment>;
    candidateTreatments: Array<CandidateTreatment>;
    cardAuthorization?: Maybe<CardAuthorization>;
    cardAuthorizationAuditLog?: Maybe<CardAuthorizationAuditLog>;
    cardAuthorizationAuditLogs: Array<CardAuthorizationAuditLog>;
    cardAuthorizations: Array<CardAuthorization>;
    cashPrice?: Maybe<CashPrice>;
    cashPrices: Array<CashPrice>;
    charge?: Maybe<Charge>;
    chargeAuditLog?: Maybe<ChargeAuditLog>;
    chargeAuditLogs: Array<ChargeAuditLog>;
    chargeReattributionAndPartialPaymentLog?: Maybe<ChargeReattributionAndPartialPaymentLog>;
    chargeReattributionAndPartialPaymentLogs: Array<ChargeReattributionAndPartialPaymentLog>;
    chargeReattributionLog?: Maybe<ChargeReattributionLog>;
    chargeReattributionLogs: Array<ChargeReattributionLog>;
    charges: Array<Charge>;
    checkoutAdjudication?: Maybe<CheckoutAdjudication>;
    checkoutAdjudications: Array<CheckoutAdjudication>;
    claimToBoughtTreatment?: Maybe<ClaimToBoughtTreatment>;
    claimToBoughtTreatments: Array<ClaimToBoughtTreatment>;
    configCommit?: Maybe<ConfigCommit>;
    configCommits: Array<ConfigCommit>;
    configFlag?: Maybe<ConfigFlag>;
    configFlags: Array<ConfigFlag>;
    configSession?: Maybe<ConfigSession>;
    configSessions: Array<ConfigSession>;
    consentForm?: Maybe<ConsentForm>;
    consentForms: Array<ConsentForm>;
    consumer?: Maybe<Consumer>;
    consumerAuditLog?: Maybe<ConsumerAuditLog>;
    consumerAuditLogs: Array<ConsumerAuditLog>;
    consumerMessage?: Maybe<ConsumerMessage>;
    consumerMessages: Array<ConsumerMessage>;
    consumerNote?: Maybe<ConsumerNote>;
    consumerNotes: Array<ConsumerNote>;
    consumers: Array<Consumer>;
    contract?: Maybe<Contract>;
    contractAuditLog?: Maybe<ContractAuditLog>;
    contractAuditLogs: Array<ContractAuditLog>;
    contracts: Array<Contract>;
    cptExclusivityEdge?: Maybe<CptExclusivityEdge>;
    cptExclusivityEdges: Array<CptExclusivityEdge>;
    customField?: Maybe<CustomField>;
    customFieldValue?: Maybe<CustomFieldValue>;
    customFieldValues: Array<CustomFieldValue>;
    customFields: Array<CustomField>;
    defaultPractice?: Maybe<DefaultPractice>;
    defaultPractices: Array<DefaultPractice>;
    deploymentOrgPhase?: Maybe<DeploymentOrgPhase>;
    deploymentOrgPhases: Array<DeploymentOrgPhase>;
    deploymentOrgTask?: Maybe<DeploymentOrgTask>;
    deploymentOrgTaskDependencies: Array<DeploymentOrgTaskDependency>;
    deploymentOrgTaskDependency?: Maybe<DeploymentOrgTaskDependency>;
    deploymentOrgTasks: Array<DeploymentOrgTask>;
    deploymentPhase?: Maybe<DeploymentPhase>;
    deploymentPhases: Array<DeploymentPhase>;
    deploymentTask?: Maybe<DeploymentTask>;
    deploymentTaskDependencies: Array<DeploymentTaskDependency>;
    deploymentTaskDependency?: Maybe<DeploymentTaskDependency>;
    deploymentTasks: Array<DeploymentTask>;
    deploymentTeam?: Maybe<DeploymentTeam>;
    deploymentTeams: Array<DeploymentTeam>;
    detailBoughtTreatments: Array<DetailBoughtTreatment>;
    detailSlots: Array<DetailSlot>;
    ecwPayerAlias?: Maybe<EcwPayerAlias>;
    ecwPayerAliases: Array<EcwPayerAlias>;
    ecwPayerStc?: Maybe<EcwPayerStc>;
    ecwPayerStcs: Array<EcwPayerStc>;
    ehrAppointmentTypeIdToName?: Maybe<EhrAppointmentTypeIdToName>;
    ehrAppointmentTypeIdToNames: Array<EhrAppointmentTypeIdToName>;
    ehrPaymentDescriptor?: Maybe<EhrPaymentDescriptor>;
    ehrPaymentDescriptorAuditLog?: Maybe<EhrPaymentDescriptorAuditLog>;
    ehrPaymentDescriptorAuditLogs: Array<EhrPaymentDescriptorAuditLog>;
    ehrPaymentDescriptors: Array<EhrPaymentDescriptor>;
    ehrPaymentDirectionSsAsset?: Maybe<EhrPaymentDirectionSsAsset>;
    ehrPaymentDirectionSsAssets: Array<EhrPaymentDirectionSsAsset>;
    ehrPostDetail?: Maybe<EhrPostDetail>;
    ehrPostDetailToPayout?: Maybe<EhrPostDetailToPayout>;
    ehrPostDetailToPayouts: Array<EhrPostDetailToPayout>;
    ehrPostDetails: Array<EhrPostDetail>;
    ehrPostLedger?: Maybe<EhrPostLedger>;
    ehrPostLedgerAuditLog?: Maybe<EhrPostLedgerAuditLog>;
    ehrPostLedgerAuditLogs: Array<EhrPostLedgerAuditLog>;
    ehrPostLedgerToPayout?: Maybe<EhrPostLedgerToPayout>;
    ehrPostLedgerToPayouts: Array<EhrPostLedgerToPayout>;
    ehrPostLedgers: Array<EhrPostLedger>;
    ehrPrimaryCareProvider?: Maybe<EhrPrimaryCareProvider>;
    ehrPrimaryCareProviders: Array<EhrPrimaryCareProvider>;
    ehrProviderMapping?: Maybe<EhrProviderMapping>;
    ehrProviderMappings: Array<EhrProviderMapping>;
    ehrSlot?: Maybe<EhrSlot>;
    ehrSlotAuditLog?: Maybe<EhrSlotAuditLog>;
    ehrSlotAuditLogs: Array<EhrSlotAuditLog>;
    ehrSlots: Array<EhrSlot>;
    encounter?: Maybe<Encounter>;
    encounters: Array<Encounter>;
    experityEncounter?: Maybe<ExperityEncounter>;
    experityEncounters: Array<ExperityEncounter>;
    feeConfig?: Maybe<FeeConfig>;
    feeConfigAuditLog?: Maybe<FeeConfigAuditLog>;
    feeConfigAuditLogs: Array<FeeConfigAuditLog>;
    feeConfigs: Array<FeeConfig>;
    findFirstALEConfig?: Maybe<AleConfig>;
    findFirstALEConfigOrThrow?: Maybe<AleConfig>;
    findFirstALEDepartmentGoLive?: Maybe<AleDepartmentGoLive>;
    findFirstALEDepartmentGoLiveOrThrow?: Maybe<AleDepartmentGoLive>;
    findFirstAdjudication?: Maybe<Adjudication>;
    findFirstAdjudicationAuditLog?: Maybe<AdjudicationAuditLog>;
    findFirstAdjudicationAuditLogOrThrow?: Maybe<AdjudicationAuditLog>;
    findFirstAdjudicationOrThrow?: Maybe<Adjudication>;
    findFirstAdjustment?: Maybe<Adjustment>;
    findFirstAdjustmentAuditLog?: Maybe<AdjustmentAuditLog>;
    findFirstAdjustmentAuditLogOrThrow?: Maybe<AdjustmentAuditLog>;
    findFirstAdjustmentOrThrow?: Maybe<Adjustment>;
    findFirstAdmin?: Maybe<Admin>;
    findFirstAdminInteraction?: Maybe<AdminInteraction>;
    findFirstAdminInteractionOrThrow?: Maybe<AdminInteraction>;
    findFirstAdminOrThrow?: Maybe<Admin>;
    findFirstAppointment?: Maybe<Appointment>;
    findFirstAppointmentAuditLog?: Maybe<AppointmentAuditLog>;
    findFirstAppointmentAuditLogOrThrow?: Maybe<AppointmentAuditLog>;
    findFirstAppointmentOrThrow?: Maybe<Appointment>;
    findFirstArrearBilling?: Maybe<ArrearBilling>;
    findFirstArrearBillingOrThrow?: Maybe<ArrearBilling>;
    findFirstArtClaim?: Maybe<ArtClaim>;
    findFirstArtClaimAuditLog?: Maybe<ArtClaimAuditLog>;
    findFirstArtClaimAuditLogOrThrow?: Maybe<ArtClaimAuditLog>;
    findFirstArtClaimCptLine?: Maybe<ArtClaimCptLine>;
    findFirstArtClaimCptLineAuditLog?: Maybe<ArtClaimCptLineAuditLog>;
    findFirstArtClaimCptLineAuditLogOrThrow?: Maybe<ArtClaimCptLineAuditLog>;
    findFirstArtClaimCptLineOrThrow?: Maybe<ArtClaimCptLine>;
    findFirstArtClaimOrThrow?: Maybe<ArtClaim>;
    findFirstArtOrgConfig?: Maybe<ArtOrgConfig>;
    findFirstArtOrgConfigOrThrow?: Maybe<ArtOrgConfig>;
    findFirstArtPracticeConfig?: Maybe<ArtPracticeConfig>;
    findFirstArtPracticeConfigOrThrow?: Maybe<ArtPracticeConfig>;
    findFirstAthenaMedications?: Maybe<AthenaMedications>;
    findFirstAthenaMedicationsOrThrow?: Maybe<AthenaMedications>;
    findFirstAthenaPharmacy?: Maybe<AthenaPharmacy>;
    findFirstAthenaPharmacyOrThrow?: Maybe<AthenaPharmacy>;
    findFirstAthenaProvider?: Maybe<AthenaProvider>;
    findFirstAthenaProviderOrThrow?: Maybe<AthenaProvider>;
    findFirstBenefitParsingRules?: Maybe<BenefitParsingRules>;
    findFirstBenefitParsingRulesOrThrow?: Maybe<BenefitParsingRules>;
    findFirstBillingCode?: Maybe<BillingCode>;
    findFirstBillingCodeOrThrow?: Maybe<BillingCode>;
    findFirstBillingTableDownloadRequest?: Maybe<BillingTableDownloadRequest>;
    findFirstBillingTableDownloadRequestOrThrow?: Maybe<BillingTableDownloadRequest>;
    findFirstBoughtTreatment?: Maybe<BoughtTreatment>;
    findFirstBoughtTreatmentAuditLog?: Maybe<BoughtTreatmentAuditLog>;
    findFirstBoughtTreatmentAuditLogOrThrow?: Maybe<BoughtTreatmentAuditLog>;
    findFirstBoughtTreatmentClaimDetail?: Maybe<BoughtTreatmentClaimDetail>;
    findFirstBoughtTreatmentClaimDetailOrThrow?: Maybe<BoughtTreatmentClaimDetail>;
    findFirstBoughtTreatmentOrThrow?: Maybe<BoughtTreatment>;
    findFirstBulkChargeCardRun?: Maybe<BulkChargeCardRun>;
    findFirstBulkChargeCardRunItem?: Maybe<BulkChargeCardRunItem>;
    findFirstBulkChargeCardRunItemOrThrow?: Maybe<BulkChargeCardRunItem>;
    findFirstBulkChargeCardRunOrThrow?: Maybe<BulkChargeCardRun>;
    findFirstBundle?: Maybe<Bundle>;
    findFirstBundleOrThrow?: Maybe<Bundle>;
    findFirstBundleToHrt?: Maybe<BundleToHrt>;
    findFirstBundleToHrtOrThrow?: Maybe<BundleToHrt>;
    findFirstBusinessHour?: Maybe<BusinessHour>;
    findFirstBusinessHourOrThrow?: Maybe<BusinessHour>;
    findFirstCandidateTreatment?: Maybe<CandidateTreatment>;
    findFirstCandidateTreatmentOrThrow?: Maybe<CandidateTreatment>;
    findFirstCardAuthorization?: Maybe<CardAuthorization>;
    findFirstCardAuthorizationAuditLog?: Maybe<CardAuthorizationAuditLog>;
    findFirstCardAuthorizationAuditLogOrThrow?: Maybe<CardAuthorizationAuditLog>;
    findFirstCardAuthorizationOrThrow?: Maybe<CardAuthorization>;
    findFirstCashPrice?: Maybe<CashPrice>;
    findFirstCashPriceOrThrow?: Maybe<CashPrice>;
    findFirstCharge?: Maybe<Charge>;
    findFirstChargeAuditLog?: Maybe<ChargeAuditLog>;
    findFirstChargeAuditLogOrThrow?: Maybe<ChargeAuditLog>;
    findFirstChargeOrThrow?: Maybe<Charge>;
    findFirstChargeReattributionAndPartialPaymentLog?: Maybe<ChargeReattributionAndPartialPaymentLog>;
    findFirstChargeReattributionAndPartialPaymentLogOrThrow?: Maybe<ChargeReattributionAndPartialPaymentLog>;
    findFirstChargeReattributionLog?: Maybe<ChargeReattributionLog>;
    findFirstChargeReattributionLogOrThrow?: Maybe<ChargeReattributionLog>;
    findFirstCheckNetworkStatusResults?: Maybe<CheckNetworkStatusResults>;
    findFirstCheckNetworkStatusResultsOrThrow?: Maybe<CheckNetworkStatusResults>;
    findFirstCheckoutAdjudication?: Maybe<CheckoutAdjudication>;
    findFirstCheckoutAdjudicationOrThrow?: Maybe<CheckoutAdjudication>;
    findFirstClaimToBoughtTreatment?: Maybe<ClaimToBoughtTreatment>;
    findFirstClaimToBoughtTreatmentOrThrow?: Maybe<ClaimToBoughtTreatment>;
    findFirstConfigCommit?: Maybe<ConfigCommit>;
    findFirstConfigCommitOrThrow?: Maybe<ConfigCommit>;
    findFirstConfigFlag?: Maybe<ConfigFlag>;
    findFirstConfigFlagOrThrow?: Maybe<ConfigFlag>;
    findFirstConfigSession?: Maybe<ConfigSession>;
    findFirstConfigSessionOrThrow?: Maybe<ConfigSession>;
    findFirstConsentForm?: Maybe<ConsentForm>;
    findFirstConsentFormOrThrow?: Maybe<ConsentForm>;
    findFirstConsumer?: Maybe<Consumer>;
    findFirstConsumerAuditLog?: Maybe<ConsumerAuditLog>;
    findFirstConsumerAuditLogOrThrow?: Maybe<ConsumerAuditLog>;
    findFirstConsumerMessage?: Maybe<ConsumerMessage>;
    findFirstConsumerMessageOrThrow?: Maybe<ConsumerMessage>;
    findFirstConsumerNote?: Maybe<ConsumerNote>;
    findFirstConsumerNoteOrThrow?: Maybe<ConsumerNote>;
    findFirstConsumerOrThrow?: Maybe<Consumer>;
    findFirstConsumerPhotoMetaData?: Maybe<ConsumerPhotoMetaData>;
    findFirstConsumerPhotoMetaDataOrThrow?: Maybe<ConsumerPhotoMetaData>;
    findFirstConsumerSrtRecords?: Maybe<ConsumerSrtRecords>;
    findFirstConsumerSrtRecordsOrThrow?: Maybe<ConsumerSrtRecords>;
    findFirstContract?: Maybe<Contract>;
    findFirstContractAuditLog?: Maybe<ContractAuditLog>;
    findFirstContractAuditLogOrThrow?: Maybe<ContractAuditLog>;
    findFirstContractOrThrow?: Maybe<Contract>;
    findFirstCoverageResponses?: Maybe<CoverageResponses>;
    findFirstCoverageResponsesOrThrow?: Maybe<CoverageResponses>;
    findFirstCptExclusivityEdge?: Maybe<CptExclusivityEdge>;
    findFirstCptExclusivityEdgeOrThrow?: Maybe<CptExclusivityEdge>;
    findFirstCustomField?: Maybe<CustomField>;
    findFirstCustomFieldOrThrow?: Maybe<CustomField>;
    findFirstCustomFieldValue?: Maybe<CustomFieldValue>;
    findFirstCustomFieldValueOrThrow?: Maybe<CustomFieldValue>;
    findFirstDataMigrations?: Maybe<DataMigrations>;
    findFirstDataMigrationsOrThrow?: Maybe<DataMigrations>;
    findFirstDefaultPractice?: Maybe<DefaultPractice>;
    findFirstDefaultPracticeOrThrow?: Maybe<DefaultPractice>;
    findFirstDefault_providers?: Maybe<DefaultProviders>;
    findFirstDefault_providersOrThrow?: Maybe<DefaultProviders>;
    findFirstDeploymentOrgPhase?: Maybe<DeploymentOrgPhase>;
    findFirstDeploymentOrgPhaseOrThrow?: Maybe<DeploymentOrgPhase>;
    findFirstDeploymentOrgTask?: Maybe<DeploymentOrgTask>;
    findFirstDeploymentOrgTaskDependency?: Maybe<DeploymentOrgTaskDependency>;
    findFirstDeploymentOrgTaskDependencyOrThrow?: Maybe<DeploymentOrgTaskDependency>;
    findFirstDeploymentOrgTaskOrThrow?: Maybe<DeploymentOrgTask>;
    findFirstDeploymentPhase?: Maybe<DeploymentPhase>;
    findFirstDeploymentPhaseOrThrow?: Maybe<DeploymentPhase>;
    findFirstDeploymentTask?: Maybe<DeploymentTask>;
    findFirstDeploymentTaskDependency?: Maybe<DeploymentTaskDependency>;
    findFirstDeploymentTaskDependencyOrThrow?: Maybe<DeploymentTaskDependency>;
    findFirstDeploymentTaskOrThrow?: Maybe<DeploymentTask>;
    findFirstDeploymentTeam?: Maybe<DeploymentTeam>;
    findFirstDeploymentTeamOrThrow?: Maybe<DeploymentTeam>;
    findFirstDiscountCodes?: Maybe<DiscountCodes>;
    findFirstDiscountCodesOrThrow?: Maybe<DiscountCodes>;
    findFirstEcwPayerAlias?: Maybe<EcwPayerAlias>;
    findFirstEcwPayerAliasOrThrow?: Maybe<EcwPayerAlias>;
    findFirstEcwPayerStc?: Maybe<EcwPayerStc>;
    findFirstEcwPayerStcOrThrow?: Maybe<EcwPayerStc>;
    findFirstEhrAppointmentTypeIdToName?: Maybe<EhrAppointmentTypeIdToName>;
    findFirstEhrAppointmentTypeIdToNameOrThrow?: Maybe<EhrAppointmentTypeIdToName>;
    findFirstEhrPaymentDescriptor?: Maybe<EhrPaymentDescriptor>;
    findFirstEhrPaymentDescriptorAuditLog?: Maybe<EhrPaymentDescriptorAuditLog>;
    findFirstEhrPaymentDescriptorAuditLogOrThrow?: Maybe<EhrPaymentDescriptorAuditLog>;
    findFirstEhrPaymentDescriptorOrThrow?: Maybe<EhrPaymentDescriptor>;
    findFirstEhrPaymentDirectionSsAsset?: Maybe<EhrPaymentDirectionSsAsset>;
    findFirstEhrPaymentDirectionSsAssetOrThrow?: Maybe<EhrPaymentDirectionSsAsset>;
    findFirstEhrPostDetail?: Maybe<EhrPostDetail>;
    findFirstEhrPostDetailOrThrow?: Maybe<EhrPostDetail>;
    findFirstEhrPostDetailToPayout?: Maybe<EhrPostDetailToPayout>;
    findFirstEhrPostDetailToPayoutOrThrow?: Maybe<EhrPostDetailToPayout>;
    findFirstEhrPostLedger?: Maybe<EhrPostLedger>;
    findFirstEhrPostLedgerAuditLog?: Maybe<EhrPostLedgerAuditLog>;
    findFirstEhrPostLedgerAuditLogOrThrow?: Maybe<EhrPostLedgerAuditLog>;
    findFirstEhrPostLedgerOrThrow?: Maybe<EhrPostLedger>;
    findFirstEhrPostLedgerToPayout?: Maybe<EhrPostLedgerToPayout>;
    findFirstEhrPostLedgerToPayoutOrThrow?: Maybe<EhrPostLedgerToPayout>;
    findFirstEhrPrimaryCareProvider?: Maybe<EhrPrimaryCareProvider>;
    findFirstEhrPrimaryCareProviderOrThrow?: Maybe<EhrPrimaryCareProvider>;
    findFirstEhrProviderMapping?: Maybe<EhrProviderMapping>;
    findFirstEhrProviderMappingOrThrow?: Maybe<EhrProviderMapping>;
    findFirstEhrSlot?: Maybe<EhrSlot>;
    findFirstEhrSlotAuditLog?: Maybe<EhrSlotAuditLog>;
    findFirstEhrSlotAuditLogOrThrow?: Maybe<EhrSlotAuditLog>;
    findFirstEhrSlotOrThrow?: Maybe<EhrSlot>;
    findFirstEncounter?: Maybe<Encounter>;
    findFirstEncounterOrThrow?: Maybe<Encounter>;
    findFirstExperityEncounter?: Maybe<ExperityEncounter>;
    findFirstExperityEncounterOrThrow?: Maybe<ExperityEncounter>;
    findFirstFaqDropdowns?: Maybe<FaqDropdowns>;
    findFirstFaqDropdownsOrThrow?: Maybe<FaqDropdowns>;
    findFirstFeeConfig?: Maybe<FeeConfig>;
    findFirstFeeConfigAuditLog?: Maybe<FeeConfigAuditLog>;
    findFirstFeeConfigAuditLogOrThrow?: Maybe<FeeConfigAuditLog>;
    findFirstFeeConfigOrThrow?: Maybe<FeeConfig>;
    findFirstGuarantorPaymentLinkContext?: Maybe<GuarantorPaymentLinkContext>;
    findFirstGuarantorPaymentLinkContextOrThrow?: Maybe<GuarantorPaymentLinkContext>;
    findFirstHoliday?: Maybe<Holiday>;
    findFirstHolidayOrThrow?: Maybe<Holiday>;
    findFirstHrt?: Maybe<Hrt>;
    findFirstHrtFlags?: Maybe<HrtFlags>;
    findFirstHrtFlagsOrThrow?: Maybe<HrtFlags>;
    findFirstHrtOrThrow?: Maybe<Hrt>;
    findFirstHrtPaymentType?: Maybe<HrtPaymentType>;
    findFirstHrtPaymentTypeOrThrow?: Maybe<HrtPaymentType>;
    findFirstHrtToSrt?: Maybe<HrtToSrt>;
    findFirstHrtToSrtOrThrow?: Maybe<HrtToSrt>;
    findFirstHrtTranslation?: Maybe<HrtTranslation>;
    findFirstHrtTranslationOrThrow?: Maybe<HrtTranslation>;
    findFirstInboundRequestLog?: Maybe<InboundRequestLog>;
    findFirstInboundRequestLogOrThrow?: Maybe<InboundRequestLog>;
    findFirstInboundTextMessageLog?: Maybe<InboundTextMessageLog>;
    findFirstInboundTextMessageLogOrThrow?: Maybe<InboundTextMessageLog>;
    findFirstInsurance?: Maybe<Insurance>;
    findFirstInsuranceAuditLog?: Maybe<InsuranceAuditLog>;
    findFirstInsuranceAuditLogOrThrow?: Maybe<InsuranceAuditLog>;
    findFirstInsuranceMetadata?: Maybe<InsuranceMetadata>;
    findFirstInsuranceMetadataOrThrow?: Maybe<InsuranceMetadata>;
    findFirstInsuranceOrThrow?: Maybe<Insurance>;
    findFirstIntakeForm?: Maybe<IntakeForm>;
    findFirstIntakeFormOrThrow?: Maybe<IntakeForm>;
    findFirstIntakeFormSection?: Maybe<IntakeFormSection>;
    findFirstIntakeFormSectionOrThrow?: Maybe<IntakeFormSection>;
    findFirstIntakeFormSectionTranslation?: Maybe<IntakeFormSectionTranslation>;
    findFirstIntakeFormSectionTranslationOrThrow?: Maybe<IntakeFormSectionTranslation>;
    findFirstIntakeFormToQuestion?: Maybe<IntakeFormToQuestion>;
    findFirstIntakeFormToQuestionOrThrow?: Maybe<IntakeFormToQuestion>;
    findFirstIntakeQuestion?: Maybe<IntakeQuestion>;
    findFirstIntakeQuestionOrThrow?: Maybe<IntakeQuestion>;
    findFirstIntakeQuestionTranslation?: Maybe<IntakeQuestionTranslation>;
    findFirstIntakeQuestionTranslationOrThrow?: Maybe<IntakeQuestionTranslation>;
    findFirstInvoiceDailyLineItems?: Maybe<InvoiceDailyLineItems>;
    findFirstInvoiceDailyLineItemsOrThrow?: Maybe<InvoiceDailyLineItems>;
    findFirstInvoices?: Maybe<Invoices>;
    findFirstInvoicesOrThrow?: Maybe<Invoices>;
    findFirstKeywordRule?: Maybe<KeywordRule>;
    findFirstKeywordRuleOrThrow?: Maybe<KeywordRule>;
    findFirstLinkMapping?: Maybe<LinkMapping>;
    findFirstLinkMappingOrThrow?: Maybe<LinkMapping>;
    findFirstLiveTransfers?: Maybe<LiveTransfers>;
    findFirstLiveTransfersOrThrow?: Maybe<LiveTransfers>;
    findFirstMcmsAssociation?: Maybe<McmsAssociation>;
    findFirstMcmsAssociationAuditLog?: Maybe<McmsAssociationAuditLog>;
    findFirstMcmsAssociationAuditLogOrThrow?: Maybe<McmsAssociationAuditLog>;
    findFirstMcmsAssociationClaim?: Maybe<McmsAssociationClaim>;
    findFirstMcmsAssociationClaimAuditLog?: Maybe<McmsAssociationClaimAuditLog>;
    findFirstMcmsAssociationClaimAuditLogOrThrow?: Maybe<McmsAssociationClaimAuditLog>;
    findFirstMcmsAssociationClaimOrThrow?: Maybe<McmsAssociationClaim>;
    findFirstMcmsAssociationOrThrow?: Maybe<McmsAssociation>;
    findFirstMcmsAssociationSlot?: Maybe<McmsAssociationSlot>;
    findFirstMcmsAssociationSlotAuditLog?: Maybe<McmsAssociationSlotAuditLog>;
    findFirstMcmsAssociationSlotAuditLogOrThrow?: Maybe<McmsAssociationSlotAuditLog>;
    findFirstMcmsAssociationSlotOrThrow?: Maybe<McmsAssociationSlot>;
    findFirstMessageBlueprint?: Maybe<MessageBlueprint>;
    findFirstMessageBlueprintOrThrow?: Maybe<MessageBlueprint>;
    findFirstMessageConsolidationContext?: Maybe<MessageConsolidationContext>;
    findFirstMessageConsolidationContextOrThrow?: Maybe<MessageConsolidationContext>;
    findFirstMessageConsolidationTemplate?: Maybe<MessageConsolidationTemplate>;
    findFirstMessageConsolidationTemplateOrThrow?: Maybe<MessageConsolidationTemplate>;
    findFirstMessageNudge?: Maybe<MessageNudge>;
    findFirstMessageNudgeOrThrow?: Maybe<MessageNudge>;
    findFirstMessageOrchestrationRule?: Maybe<MessageOrchestrationRule>;
    findFirstMessageOrchestrationRuleOrThrow?: Maybe<MessageOrchestrationRule>;
    findFirstMessagePayAfter?: Maybe<MessagePayAfter>;
    findFirstMessagePayAfterOrThrow?: Maybe<MessagePayAfter>;
    findFirstMessageSettingsHrt?: Maybe<MessageSettingsHrt>;
    findFirstMessageSettingsHrtOrThrow?: Maybe<MessageSettingsHrt>;
    findFirstMessageSettingsOrg?: Maybe<MessageSettingsOrg>;
    findFirstMessageSettingsOrgOrThrow?: Maybe<MessageSettingsOrg>;
    findFirstMessageTemplateHrt?: Maybe<MessageTemplateHrt>;
    findFirstMessageTemplateHrtOrThrow?: Maybe<MessageTemplateHrt>;
    findFirstMessageTemplateOrg?: Maybe<MessageTemplateOrg>;
    findFirstMessageTemplateOrgOrThrow?: Maybe<MessageTemplateOrg>;
    findFirstMigratedEncounter?: Maybe<MigratedEncounter>;
    findFirstMigratedEncounterOrThrow?: Maybe<MigratedEncounter>;
    findFirstMigrations?: Maybe<Migrations>;
    findFirstMigrationsOrThrow?: Maybe<Migrations>;
    findFirstNetworkValidation?: Maybe<NetworkValidation>;
    findFirstNetworkValidationOrThrow?: Maybe<NetworkValidation>;
    findFirstNetwork_plan_exceptions?: Maybe<NetworkPlanExceptions>;
    findFirstNetwork_plan_exceptionsOrThrow?: Maybe<NetworkPlanExceptions>;
    findFirstNonCardRefunds?: Maybe<NonCardRefunds>;
    findFirstNonCardRefundsOrThrow?: Maybe<NonCardRefunds>;
    findFirstOrgConfigFlag?: Maybe<OrgConfigFlag>;
    findFirstOrgConfigFlagOrThrow?: Maybe<OrgConfigFlag>;
    findFirstOrgHrtSrtRule?: Maybe<OrgHrtSrtRule>;
    findFirstOrgHrtSrtRuleOrThrow?: Maybe<OrgHrtSrtRule>;
    findFirstOrgNetworkResults?: Maybe<OrgNetworkResults>;
    findFirstOrgNetworkResultsOrThrow?: Maybe<OrgNetworkResults>;
    findFirstOrgOverrideRule?: Maybe<OrgOverrideRule>;
    findFirstOrgOverrideRuleOrThrow?: Maybe<OrgOverrideRule>;
    findFirstOrg_fees?: Maybe<OrgFees>;
    findFirstOrg_feesOrThrow?: Maybe<OrgFees>;
    findFirstOrg_stripe_mapping?: Maybe<OrgStripeMapping>;
    findFirstOrg_stripe_mappingOrThrow?: Maybe<OrgStripeMapping>;
    findFirstOrganization?: Maybe<Organization>;
    findFirstOrganizationAssets?: Maybe<OrganizationAssets>;
    findFirstOrganizationAssetsOrThrow?: Maybe<OrganizationAssets>;
    findFirstOrganizationOrThrow?: Maybe<Organization>;
    findFirstOrganizationTranslation?: Maybe<OrganizationTranslation>;
    findFirstOrganizationTranslationOrThrow?: Maybe<OrganizationTranslation>;
    findFirstPayLaterAuthorization?: Maybe<PayLaterAuthorization>;
    findFirstPayLaterAuthorizationAuditLog?: Maybe<PayLaterAuthorizationAuditLog>;
    findFirstPayLaterAuthorizationAuditLogOrThrow?: Maybe<PayLaterAuthorizationAuditLog>;
    findFirstPayLaterAuthorizationOrThrow?: Maybe<PayLaterAuthorization>;
    findFirstPayer?: Maybe<Payer>;
    findFirstPayerOrThrow?: Maybe<Payer>;
    findFirstPayerPlanMapping?: Maybe<PayerPlanMapping>;
    findFirstPayerPlanMappingOrThrow?: Maybe<PayerPlanMapping>;
    findFirstPayerToEhrInsurancePackageMapping?: Maybe<PayerToEhrInsurancePackageMapping>;
    findFirstPayerToEhrInsurancePackageMappingOrThrow?: Maybe<PayerToEhrInsurancePackageMapping>;
    findFirstPaymentAuthorization?: Maybe<PaymentAuthorization>;
    findFirstPaymentAuthorizationAuditLog?: Maybe<PaymentAuthorizationAuditLog>;
    findFirstPaymentAuthorizationAuditLogOrThrow?: Maybe<PaymentAuthorizationAuditLog>;
    findFirstPaymentAuthorizationOrThrow?: Maybe<PaymentAuthorization>;
    findFirstPaymentContract?: Maybe<PaymentContract>;
    findFirstPaymentContractOrThrow?: Maybe<PaymentContract>;
    findFirstPaymentPlan?: Maybe<PaymentPlan>;
    findFirstPaymentPlanAdjustment?: Maybe<PaymentPlanAdjustment>;
    findFirstPaymentPlanAdjustmentAuditLog?: Maybe<PaymentPlanAdjustmentAuditLog>;
    findFirstPaymentPlanAdjustmentAuditLogOrThrow?: Maybe<PaymentPlanAdjustmentAuditLog>;
    findFirstPaymentPlanAdjustmentOrThrow?: Maybe<PaymentPlanAdjustment>;
    findFirstPaymentPlanAuditLog?: Maybe<PaymentPlanAuditLog>;
    findFirstPaymentPlanAuditLogOrThrow?: Maybe<PaymentPlanAuditLog>;
    findFirstPaymentPlanAutoCharge?: Maybe<PaymentPlanAutoCharge>;
    findFirstPaymentPlanAutoChargeAuditLog?: Maybe<PaymentPlanAutoChargeAuditLog>;
    findFirstPaymentPlanAutoChargeAuditLogOrThrow?: Maybe<PaymentPlanAutoChargeAuditLog>;
    findFirstPaymentPlanAutoChargeOrThrow?: Maybe<PaymentPlanAutoCharge>;
    findFirstPaymentPlanBoughtTreatment?: Maybe<PaymentPlanBoughtTreatment>;
    findFirstPaymentPlanBoughtTreatmentAuditLog?: Maybe<PaymentPlanBoughtTreatmentAuditLog>;
    findFirstPaymentPlanBoughtTreatmentAuditLogOrThrow?: Maybe<PaymentPlanBoughtTreatmentAuditLog>;
    findFirstPaymentPlanBoughtTreatmentOrThrow?: Maybe<PaymentPlanBoughtTreatment>;
    findFirstPaymentPlanOrThrow?: Maybe<PaymentPlan>;
    findFirstPaymentPlanOrgConfig?: Maybe<PaymentPlanOrgConfig>;
    findFirstPaymentPlanOrgConfigAuditLog?: Maybe<PaymentPlanOrgConfigAuditLog>;
    findFirstPaymentPlanOrgConfigAuditLogOrThrow?: Maybe<PaymentPlanOrgConfigAuditLog>;
    findFirstPaymentPlanOrgConfigOrThrow?: Maybe<PaymentPlanOrgConfig>;
    findFirstPayout?: Maybe<Payout>;
    findFirstPayoutAuditLog?: Maybe<PayoutAuditLog>;
    findFirstPayoutAuditLogOrThrow?: Maybe<PayoutAuditLog>;
    findFirstPayoutOrThrow?: Maybe<Payout>;
    findFirstPendingVoidPayoutReversal?: Maybe<PendingVoidPayoutReversal>;
    findFirstPendingVoidPayoutReversalOrThrow?: Maybe<PendingVoidPayoutReversal>;
    findFirstPhoneNumberType?: Maybe<PhoneNumberType>;
    findFirstPhoneNumberTypeOrThrow?: Maybe<PhoneNumberType>;
    findFirstPlaceOfServiceCode?: Maybe<PlaceOfServiceCode>;
    findFirstPlaceOfServiceCodeOrThrow?: Maybe<PlaceOfServiceCode>;
    findFirstPractice?: Maybe<Practice>;
    findFirstPracticeConfiguration?: Maybe<PracticeConfiguration>;
    findFirstPracticeConfigurationOrThrow?: Maybe<PracticeConfiguration>;
    findFirstPracticeHours?: Maybe<PracticeHours>;
    findFirstPracticeHoursOrThrow?: Maybe<PracticeHours>;
    findFirstPracticeHoursOverrides?: Maybe<PracticeHoursOverrides>;
    findFirstPracticeHoursOverridesOrThrow?: Maybe<PracticeHoursOverrides>;
    findFirstPracticeOrThrow?: Maybe<Practice>;
    findFirstPricedTreatment?: Maybe<PricedTreatment>;
    findFirstPricedTreatmentOrThrow?: Maybe<PricedTreatment>;
    findFirstPricingAttempt?: Maybe<PricingAttempt>;
    findFirstPricingAttemptOrThrow?: Maybe<PricingAttempt>;
    findFirstPricingEscalator?: Maybe<PricingEscalator>;
    findFirstPricingEscalatorOrThrow?: Maybe<PricingEscalator>;
    findFirstPricingQueue?: Maybe<PricingQueue>;
    findFirstPricingQueueOrThrow?: Maybe<PricingQueue>;
    findFirstPricingResults?: Maybe<PricingResults>;
    findFirstPricingResultsOrThrow?: Maybe<PricingResults>;
    findFirstProcedureBenefitParsingRules?: Maybe<ProcedureBenefitParsingRules>;
    findFirstProcedureBenefitParsingRulesOrThrow?: Maybe<ProcedureBenefitParsingRules>;
    findFirstProductCategories?: Maybe<ProductCategories>;
    findFirstProductCategoriesOrThrow?: Maybe<ProductCategories>;
    findFirstProductCategoryTranslation?: Maybe<ProductCategoryTranslation>;
    findFirstProductCategoryTranslationOrThrow?: Maybe<ProductCategoryTranslation>;
    findFirstProductToBundle?: Maybe<ProductToBundle>;
    findFirstProductToBundleOrThrow?: Maybe<ProductToBundle>;
    findFirstProductToHrt?: Maybe<ProductToHrt>;
    findFirstProductToHrtOrThrow?: Maybe<ProductToHrt>;
    findFirstProductTranslation?: Maybe<ProductTranslation>;
    findFirstProductTranslationOrThrow?: Maybe<ProductTranslation>;
    findFirstProducts?: Maybe<Products>;
    findFirstProductsOrThrow?: Maybe<Products>;
    findFirstProvider?: Maybe<Provider>;
    findFirstProviderCredentialing?: Maybe<ProviderCredentialing>;
    findFirstProviderCredentialingOrThrow?: Maybe<ProviderCredentialing>;
    findFirstProviderGroup?: Maybe<ProviderGroup>;
    findFirstProviderGroupOrThrow?: Maybe<ProviderGroup>;
    findFirstProviderGroupToHrt?: Maybe<ProviderGroupToHrt>;
    findFirstProviderGroupToHrtOrThrow?: Maybe<ProviderGroupToHrt>;
    findFirstProviderHrtMaxCount?: Maybe<ProviderHrtMaxCount>;
    findFirstProviderHrtMaxCountOrThrow?: Maybe<ProviderHrtMaxCount>;
    findFirstProviderOrThrow?: Maybe<Provider>;
    findFirstProviderTaxonomy?: Maybe<ProviderTaxonomy>;
    findFirstProviderTaxonomyOrThrow?: Maybe<ProviderTaxonomy>;
    findFirstProviderToOrg?: Maybe<ProviderToOrg>;
    findFirstProviderToOrgOrThrow?: Maybe<ProviderToOrg>;
    findFirstProviderToProviderGroup?: Maybe<ProviderToProviderGroup>;
    findFirstProviderToProviderGroupOrThrow?: Maybe<ProviderToProviderGroup>;
    findFirstReattributionDirection?: Maybe<ReattributionDirection>;
    findFirstReattributionDirectionOrThrow?: Maybe<ReattributionDirection>;
    findFirstReceiptArrangement?: Maybe<ReceiptArrangement>;
    findFirstReceiptArrangementOrThrow?: Maybe<ReceiptArrangement>;
    findFirstReservedEhrVisit?: Maybe<ReservedEhrVisit>;
    findFirstReservedEhrVisitOrThrow?: Maybe<ReservedEhrVisit>;
    findFirstResetToken?: Maybe<ResetToken>;
    findFirstResetTokenOrThrow?: Maybe<ResetToken>;
    findFirstSavedIntakeResponse?: Maybe<SavedIntakeResponse>;
    findFirstSavedIntakeResponseOrThrow?: Maybe<SavedIntakeResponse>;
    findFirstSchedulingSlotConfig?: Maybe<SchedulingSlotConfig>;
    findFirstSchedulingSlotConfigOrThrow?: Maybe<SchedulingSlotConfig>;
    findFirstServiceTypeCode?: Maybe<ServiceTypeCode>;
    findFirstServiceTypeCodeOrThrow?: Maybe<ServiceTypeCode>;
    findFirstSlot?: Maybe<Slot>;
    findFirstSlotAuditLog?: Maybe<SlotAuditLog>;
    findFirstSlotAuditLogOrThrow?: Maybe<SlotAuditLog>;
    findFirstSlotOrThrow?: Maybe<Slot>;
    findFirstSrt?: Maybe<Srt>;
    findFirstSrtFlags?: Maybe<SrtFlags>;
    findFirstSrtFlagsOrThrow?: Maybe<SrtFlags>;
    findFirstSrtMultiplierRule?: Maybe<SrtMultiplierRule>;
    findFirstSrtMultiplierRuleOrThrow?: Maybe<SrtMultiplierRule>;
    findFirstSrtOrThrow?: Maybe<Srt>;
    findFirstSrtToBillingCode?: Maybe<SrtToBillingCode>;
    findFirstSrtToBillingCodeOrThrow?: Maybe<SrtToBillingCode>;
    findFirstStatePayerMapping?: Maybe<StatePayerMapping>;
    findFirstStatePayerMappingOrThrow?: Maybe<StatePayerMapping>;
    findFirstSuperscriptFeeLineItem?: Maybe<SuperscriptFeeLineItem>;
    findFirstSuperscriptFeeLineItemOrThrow?: Maybe<SuperscriptFeeLineItem>;
    findFirstSuperscriptFees?: Maybe<SuperscriptFees>;
    findFirstSuperscriptFeesOrThrow?: Maybe<SuperscriptFees>;
    findFirstSuperscriptIntakeQuestion?: Maybe<SuperscriptIntakeQuestion>;
    findFirstSuperscriptIntakeQuestionOrThrow?: Maybe<SuperscriptIntakeQuestion>;
    findFirstTimeBlock?: Maybe<TimeBlock>;
    findFirstTimeBlockOrThrow?: Maybe<TimeBlock>;
    findFirstTransaction?: Maybe<Transaction>;
    findFirstTransactionOrThrow?: Maybe<Transaction>;
    findFirstUser?: Maybe<User>;
    findFirstUserAuditLog?: Maybe<UserAuditLog>;
    findFirstUserAuditLogOrThrow?: Maybe<UserAuditLog>;
    findFirstUserOrThrow?: Maybe<User>;
    findFirstUserPracticeVisit?: Maybe<UserPracticeVisit>;
    findFirstUserPracticeVisitOrThrow?: Maybe<UserPracticeVisit>;
    findFirstUserToNewUser?: Maybe<UserToNewUser>;
    findFirstUserToNewUserOrThrow?: Maybe<UserToNewUser>;
    findFirstValidPayers?: Maybe<ValidPayers>;
    findFirstValidPayersOrThrow?: Maybe<ValidPayers>;
    findManyAthenaMedications: Array<AthenaMedications>;
    findManyBenefitParsingRules: Array<BenefitParsingRules>;
    findManyCheckNetworkStatusResults: Array<CheckNetworkStatusResults>;
    findManyConsumerPhotoMetaData: Array<ConsumerPhotoMetaData>;
    findManyConsumerSrtRecords: Array<ConsumerSrtRecords>;
    findManyCoverageResponses: Array<CoverageResponses>;
    findManyDataMigrations: Array<DataMigrations>;
    findManyDefault_providers: Array<DefaultProviders>;
    findManyDiscountCodes: Array<DiscountCodes>;
    findManyFaqDropdowns: Array<FaqDropdowns>;
    findManyHrtFlags: Array<HrtFlags>;
    findManyInsuranceMetadata: Array<InsuranceMetadata>;
    findManyInvoiceDailyLineItems: Array<InvoiceDailyLineItems>;
    findManyInvoices: Array<Invoices>;
    findManyLiveTransfers: Array<LiveTransfers>;
    findManyMigrations: Array<Migrations>;
    findManyNetwork_plan_exceptions: Array<NetworkPlanExceptions>;
    findManyNonCardRefunds: Array<NonCardRefunds>;
    findManyOrgNetworkResults: Array<OrgNetworkResults>;
    findManyOrg_fees: Array<OrgFees>;
    findManyOrganizationAssets: Array<OrganizationAssets>;
    findManyPracticeHours: Array<PracticeHours>;
    findManyPracticeHoursOverrides: Array<PracticeHoursOverrides>;
    findManyPricingResults: Array<PricingResults>;
    findManyProcedureBenefitParsingRules: Array<ProcedureBenefitParsingRules>;
    findManyProductCategories: Array<ProductCategories>;
    findManyProducts: Array<Products>;
    findManySrtFlags: Array<SrtFlags>;
    findManySuperscriptFees: Array<SuperscriptFees>;
    findManyValidPayers: Array<ValidPayers>;
    findUniqueAthenaMedications?: Maybe<AthenaMedications>;
    findUniqueAthenaMedicationsOrThrow?: Maybe<AthenaMedications>;
    findUniqueBenefitParsingRules?: Maybe<BenefitParsingRules>;
    findUniqueBenefitParsingRulesOrThrow?: Maybe<BenefitParsingRules>;
    findUniqueCheckNetworkStatusResults?: Maybe<CheckNetworkStatusResults>;
    findUniqueCheckNetworkStatusResultsOrThrow?: Maybe<CheckNetworkStatusResults>;
    findUniqueConsumerPhotoMetaData?: Maybe<ConsumerPhotoMetaData>;
    findUniqueConsumerPhotoMetaDataOrThrow?: Maybe<ConsumerPhotoMetaData>;
    findUniqueConsumerSrtRecords?: Maybe<ConsumerSrtRecords>;
    findUniqueConsumerSrtRecordsOrThrow?: Maybe<ConsumerSrtRecords>;
    findUniqueCoverageResponses?: Maybe<CoverageResponses>;
    findUniqueCoverageResponsesOrThrow?: Maybe<CoverageResponses>;
    findUniqueDataMigrations?: Maybe<DataMigrations>;
    findUniqueDataMigrationsOrThrow?: Maybe<DataMigrations>;
    findUniqueDefault_providers?: Maybe<DefaultProviders>;
    findUniqueDefault_providersOrThrow?: Maybe<DefaultProviders>;
    findUniqueDiscountCodes?: Maybe<DiscountCodes>;
    findUniqueDiscountCodesOrThrow?: Maybe<DiscountCodes>;
    findUniqueFaqDropdowns?: Maybe<FaqDropdowns>;
    findUniqueFaqDropdownsOrThrow?: Maybe<FaqDropdowns>;
    findUniqueHrtFlags?: Maybe<HrtFlags>;
    findUniqueHrtFlagsOrThrow?: Maybe<HrtFlags>;
    findUniqueInsuranceMetadata?: Maybe<InsuranceMetadata>;
    findUniqueInsuranceMetadataOrThrow?: Maybe<InsuranceMetadata>;
    findUniqueInvoiceDailyLineItems?: Maybe<InvoiceDailyLineItems>;
    findUniqueInvoiceDailyLineItemsOrThrow?: Maybe<InvoiceDailyLineItems>;
    findUniqueInvoices?: Maybe<Invoices>;
    findUniqueInvoicesOrThrow?: Maybe<Invoices>;
    findUniqueLiveTransfers?: Maybe<LiveTransfers>;
    findUniqueLiveTransfersOrThrow?: Maybe<LiveTransfers>;
    findUniqueMigrations?: Maybe<Migrations>;
    findUniqueMigrationsOrThrow?: Maybe<Migrations>;
    findUniqueNetwork_plan_exceptions?: Maybe<NetworkPlanExceptions>;
    findUniqueNetwork_plan_exceptionsOrThrow?: Maybe<NetworkPlanExceptions>;
    findUniqueNonCardRefunds?: Maybe<NonCardRefunds>;
    findUniqueNonCardRefundsOrThrow?: Maybe<NonCardRefunds>;
    findUniqueOrgNetworkResults?: Maybe<OrgNetworkResults>;
    findUniqueOrgNetworkResultsOrThrow?: Maybe<OrgNetworkResults>;
    findUniqueOrg_fees?: Maybe<OrgFees>;
    findUniqueOrg_feesOrThrow?: Maybe<OrgFees>;
    findUniqueOrganizationAssets?: Maybe<OrganizationAssets>;
    findUniqueOrganizationAssetsOrThrow?: Maybe<OrganizationAssets>;
    findUniquePracticeHours?: Maybe<PracticeHours>;
    findUniquePracticeHoursOrThrow?: Maybe<PracticeHours>;
    findUniquePracticeHoursOverrides?: Maybe<PracticeHoursOverrides>;
    findUniquePracticeHoursOverridesOrThrow?: Maybe<PracticeHoursOverrides>;
    findUniquePricingResults?: Maybe<PricingResults>;
    findUniquePricingResultsOrThrow?: Maybe<PricingResults>;
    findUniqueProcedureBenefitParsingRules?: Maybe<ProcedureBenefitParsingRules>;
    findUniqueProcedureBenefitParsingRulesOrThrow?: Maybe<ProcedureBenefitParsingRules>;
    findUniqueProductCategories?: Maybe<ProductCategories>;
    findUniqueProductCategoriesOrThrow?: Maybe<ProductCategories>;
    findUniqueProducts?: Maybe<Products>;
    findUniqueProductsOrThrow?: Maybe<Products>;
    findUniqueSrtFlags?: Maybe<SrtFlags>;
    findUniqueSrtFlagsOrThrow?: Maybe<SrtFlags>;
    findUniqueSuperscriptFees?: Maybe<SuperscriptFees>;
    findUniqueSuperscriptFeesOrThrow?: Maybe<SuperscriptFees>;
    findUniqueValidPayers?: Maybe<ValidPayers>;
    findUniqueValidPayersOrThrow?: Maybe<ValidPayers>;
    getALEConfig?: Maybe<AleConfig>;
    getALEDepartmentGoLive?: Maybe<AleDepartmentGoLive>;
    getAdjudication?: Maybe<Adjudication>;
    getAdjudicationAuditLog?: Maybe<AdjudicationAuditLog>;
    getAdjustment?: Maybe<Adjustment>;
    getAdjustmentAuditLog?: Maybe<AdjustmentAuditLog>;
    getAdmin?: Maybe<Admin>;
    getAdminInteraction?: Maybe<AdminInteraction>;
    getAppointment?: Maybe<Appointment>;
    getAppointmentAuditLog?: Maybe<AppointmentAuditLog>;
    getArrearBilling?: Maybe<ArrearBilling>;
    getArtClaim?: Maybe<ArtClaim>;
    getArtClaimAuditLog?: Maybe<ArtClaimAuditLog>;
    getArtClaimCptLine?: Maybe<ArtClaimCptLine>;
    getArtClaimCptLineAuditLog?: Maybe<ArtClaimCptLineAuditLog>;
    getArtOrgConfig?: Maybe<ArtOrgConfig>;
    getArtPracticeConfig?: Maybe<ArtPracticeConfig>;
    getAthenaPharmacy?: Maybe<AthenaPharmacy>;
    getAthenaProvider?: Maybe<AthenaProvider>;
    getBillingCode?: Maybe<BillingCode>;
    getBillingTableDownloadRequest?: Maybe<BillingTableDownloadRequest>;
    getBoughtTreatment?: Maybe<BoughtTreatment>;
    getBoughtTreatmentAuditLog?: Maybe<BoughtTreatmentAuditLog>;
    getBoughtTreatmentClaimDetail?: Maybe<BoughtTreatmentClaimDetail>;
    getBulkChargeCardRun?: Maybe<BulkChargeCardRun>;
    getBulkChargeCardRunItem?: Maybe<BulkChargeCardRunItem>;
    getBundle?: Maybe<Bundle>;
    getBundleToHrt?: Maybe<BundleToHrt>;
    getBusinessHour?: Maybe<BusinessHour>;
    getCandidateTreatment?: Maybe<CandidateTreatment>;
    getCardAuthorization?: Maybe<CardAuthorization>;
    getCardAuthorizationAuditLog?: Maybe<CardAuthorizationAuditLog>;
    getCashPrice?: Maybe<CashPrice>;
    getCharge?: Maybe<Charge>;
    getChargeAuditLog?: Maybe<ChargeAuditLog>;
    getChargeReattributionAndPartialPaymentLog?: Maybe<ChargeReattributionAndPartialPaymentLog>;
    getChargeReattributionLog?: Maybe<ChargeReattributionLog>;
    getCheckoutAdjudication?: Maybe<CheckoutAdjudication>;
    getClaimToBoughtTreatment?: Maybe<ClaimToBoughtTreatment>;
    getConfigCommit?: Maybe<ConfigCommit>;
    getConfigFlag?: Maybe<ConfigFlag>;
    getConfigSession?: Maybe<ConfigSession>;
    getConsentForm?: Maybe<ConsentForm>;
    getConsumer?: Maybe<Consumer>;
    getConsumerAuditLog?: Maybe<ConsumerAuditLog>;
    getConsumerByName?: Maybe<Array<Consumer>>;
    getConsumerMessage?: Maybe<ConsumerMessage>;
    getConsumerNote?: Maybe<ConsumerNote>;
    getContract?: Maybe<Contract>;
    getContractAuditLog?: Maybe<ContractAuditLog>;
    getCptExclusivityEdge?: Maybe<CptExclusivityEdge>;
    getCustomField?: Maybe<CustomField>;
    getCustomFieldValue?: Maybe<CustomFieldValue>;
    getDefaultPractice?: Maybe<DefaultPractice>;
    getDeploymentOrgPhase?: Maybe<DeploymentOrgPhase>;
    getDeploymentOrgTask?: Maybe<DeploymentOrgTask>;
    getDeploymentOrgTaskDependency?: Maybe<DeploymentOrgTaskDependency>;
    getDeploymentPhase?: Maybe<DeploymentPhase>;
    getDeploymentTask?: Maybe<DeploymentTask>;
    getDeploymentTaskDependency?: Maybe<DeploymentTaskDependency>;
    getDeploymentTeam?: Maybe<DeploymentTeam>;
    getEcwPayerAlias?: Maybe<EcwPayerAlias>;
    getEcwPayerStc?: Maybe<EcwPayerStc>;
    getEhrAppointmentTypeIdToName?: Maybe<EhrAppointmentTypeIdToName>;
    getEhrPaymentDescriptor?: Maybe<EhrPaymentDescriptor>;
    getEhrPaymentDescriptorAuditLog?: Maybe<EhrPaymentDescriptorAuditLog>;
    getEhrPaymentDirectionSsAsset?: Maybe<EhrPaymentDirectionSsAsset>;
    getEhrPostDetail?: Maybe<EhrPostDetail>;
    getEhrPostDetailToPayout?: Maybe<EhrPostDetailToPayout>;
    getEhrPostLedger?: Maybe<EhrPostLedger>;
    getEhrPostLedgerAuditLog?: Maybe<EhrPostLedgerAuditLog>;
    getEhrPostLedgerToPayout?: Maybe<EhrPostLedgerToPayout>;
    getEhrPrimaryCareProvider?: Maybe<EhrPrimaryCareProvider>;
    getEhrProviderMapping?: Maybe<EhrProviderMapping>;
    getEhrSlot?: Maybe<EhrSlot>;
    getEhrSlotAuditLog?: Maybe<EhrSlotAuditLog>;
    getEncounter?: Maybe<Encounter>;
    getExperityEncounter?: Maybe<ExperityEncounter>;
    getFeeConfig?: Maybe<FeeConfig>;
    getFeeConfigAuditLog?: Maybe<FeeConfigAuditLog>;
    getGuarantorPaymentLinkContext?: Maybe<GuarantorPaymentLinkContext>;
    getHoliday?: Maybe<Holiday>;
    getHrt?: Maybe<Hrt>;
    getHrtPaymentType?: Maybe<HrtPaymentType>;
    getHrtToSrt?: Maybe<HrtToSrt>;
    getHrtTranslation?: Maybe<HrtTranslation>;
    getInboundRequestLog?: Maybe<InboundRequestLog>;
    getInboundTextMessageLog?: Maybe<InboundTextMessageLog>;
    getInsurance?: Maybe<Insurance>;
    getInsuranceAuditLog?: Maybe<InsuranceAuditLog>;
    getIntakeForm?: Maybe<IntakeForm>;
    getIntakeFormSection?: Maybe<IntakeFormSection>;
    getIntakeFormSectionTranslation?: Maybe<IntakeFormSectionTranslation>;
    getIntakeFormToQuestion?: Maybe<IntakeFormToQuestion>;
    getIntakeQuestion?: Maybe<IntakeQuestion>;
    getIntakeQuestionTranslation?: Maybe<IntakeQuestionTranslation>;
    getKeywordRule?: Maybe<KeywordRule>;
    getLinkMapping?: Maybe<LinkMapping>;
    getMcmsAssociation?: Maybe<McmsAssociation>;
    getMcmsAssociationAuditLog?: Maybe<McmsAssociationAuditLog>;
    getMcmsAssociationClaim?: Maybe<McmsAssociationClaim>;
    getMcmsAssociationClaimAuditLog?: Maybe<McmsAssociationClaimAuditLog>;
    getMcmsAssociationSlot?: Maybe<McmsAssociationSlot>;
    getMcmsAssociationSlotAuditLog?: Maybe<McmsAssociationSlotAuditLog>;
    getMessageBlueprint?: Maybe<MessageBlueprint>;
    getMessageConsolidationContext?: Maybe<MessageConsolidationContext>;
    getMessageConsolidationTemplate?: Maybe<MessageConsolidationTemplate>;
    getMessageNudge?: Maybe<MessageNudge>;
    getMessageOrchestrationRule?: Maybe<MessageOrchestrationRule>;
    getMessagePayAfter?: Maybe<MessagePayAfter>;
    getMessageSettingsHrt?: Maybe<MessageSettingsHrt>;
    getMessageSettingsOrg?: Maybe<MessageSettingsOrg>;
    getMessageTemplateHrt?: Maybe<MessageTemplateHrt>;
    getMessageTemplateOrg?: Maybe<MessageTemplateOrg>;
    getMigratedEncounter?: Maybe<MigratedEncounter>;
    getNetworkValidation?: Maybe<NetworkValidation>;
    getOrgConfigFlag?: Maybe<OrgConfigFlag>;
    getOrgHrtSrtRule?: Maybe<OrgHrtSrtRule>;
    getOrgOverrideRule?: Maybe<OrgOverrideRule>;
    getOrg_stripe_mapping?: Maybe<OrgStripeMapping>;
    getOrganization?: Maybe<Organization>;
    getOrganizationTranslation?: Maybe<OrganizationTranslation>;
    getPayLaterAuthorization?: Maybe<PayLaterAuthorization>;
    getPayLaterAuthorizationAuditLog?: Maybe<PayLaterAuthorizationAuditLog>;
    getPayer?: Maybe<Payer>;
    getPayerPlanMapping?: Maybe<PayerPlanMapping>;
    getPayerToEhrInsurancePackageMapping?: Maybe<PayerToEhrInsurancePackageMapping>;
    getPaymentAuthorization?: Maybe<PaymentAuthorization>;
    getPaymentAuthorizationAuditLog?: Maybe<PaymentAuthorizationAuditLog>;
    getPaymentContract?: Maybe<PaymentContract>;
    getPaymentPlan?: Maybe<PaymentPlan>;
    getPaymentPlanAdjustment?: Maybe<PaymentPlanAdjustment>;
    getPaymentPlanAdjustmentAuditLog?: Maybe<PaymentPlanAdjustmentAuditLog>;
    getPaymentPlanAuditLog?: Maybe<PaymentPlanAuditLog>;
    getPaymentPlanAutoCharge?: Maybe<PaymentPlanAutoCharge>;
    getPaymentPlanAutoChargeAuditLog?: Maybe<PaymentPlanAutoChargeAuditLog>;
    getPaymentPlanBoughtTreatment?: Maybe<PaymentPlanBoughtTreatment>;
    getPaymentPlanBoughtTreatmentAuditLog?: Maybe<PaymentPlanBoughtTreatmentAuditLog>;
    getPaymentPlanOrgConfig?: Maybe<PaymentPlanOrgConfig>;
    getPaymentPlanOrgConfigAuditLog?: Maybe<PaymentPlanOrgConfigAuditLog>;
    getPayout?: Maybe<Payout>;
    getPayoutAuditLog?: Maybe<PayoutAuditLog>;
    getPendingVoidPayoutReversal?: Maybe<PendingVoidPayoutReversal>;
    getPhoneNumberType?: Maybe<PhoneNumberType>;
    getPlaceOfServiceCode?: Maybe<PlaceOfServiceCode>;
    getPractice?: Maybe<Practice>;
    getPracticeConfiguration?: Maybe<PracticeConfiguration>;
    getPricedTreatment?: Maybe<PricedTreatment>;
    getPricingAttempt?: Maybe<PricingAttempt>;
    getPricingEscalator?: Maybe<PricingEscalator>;
    getPricingQueue?: Maybe<PricingQueue>;
    getProductCategoryTranslation?: Maybe<ProductCategoryTranslation>;
    getProductToBundle?: Maybe<ProductToBundle>;
    getProductToHrt?: Maybe<ProductToHrt>;
    getProductTranslation?: Maybe<ProductTranslation>;
    getProvider?: Maybe<Provider>;
    getProviderCredentialing?: Maybe<ProviderCredentialing>;
    getProviderGroup?: Maybe<ProviderGroup>;
    getProviderGroupToHrt?: Maybe<ProviderGroupToHrt>;
    getProviderHrtMaxCount?: Maybe<ProviderHrtMaxCount>;
    getProviderTaxonomy?: Maybe<ProviderTaxonomy>;
    getProviderToOrg?: Maybe<ProviderToOrg>;
    getProviderToProviderGroup?: Maybe<ProviderToProviderGroup>;
    getReattributionDirection?: Maybe<ReattributionDirection>;
    getReceiptArrangement?: Maybe<ReceiptArrangement>;
    getReservedEhrVisit?: Maybe<ReservedEhrVisit>;
    getResetToken?: Maybe<ResetToken>;
    getSavedIntakeResponse?: Maybe<SavedIntakeResponse>;
    getSchedulingSlotConfig?: Maybe<SchedulingSlotConfig>;
    getServiceTypeCode?: Maybe<ServiceTypeCode>;
    getSlot?: Maybe<Slot>;
    getSlotAuditLog?: Maybe<SlotAuditLog>;
    getSlotVirtualLink: VirtualLink;
    getSrt?: Maybe<Srt>;
    getSrtMultiplierRule?: Maybe<SrtMultiplierRule>;
    getSrtToBillingCode?: Maybe<SrtToBillingCode>;
    getStatePayerMapping?: Maybe<StatePayerMapping>;
    getSuperscriptFeeLineItem?: Maybe<SuperscriptFeeLineItem>;
    getSuperscriptIntakeQuestion?: Maybe<SuperscriptIntakeQuestion>;
    getTimeBlock?: Maybe<TimeBlock>;
    getTransaction?: Maybe<Transaction>;
    getUser?: Maybe<User>;
    getUserAuditLog?: Maybe<UserAuditLog>;
    getUserByPhone?: Maybe<User>;
    getUserPracticeVisit?: Maybe<UserPracticeVisit>;
    getUserToNewUser?: Maybe<UserToNewUser>;
    groupByALEConfig: Array<AleConfigGroupBy>;
    groupByALEDepartmentGoLive: Array<AleDepartmentGoLiveGroupBy>;
    groupByAdjudication: Array<AdjudicationGroupBy>;
    groupByAdjudicationAuditLog: Array<AdjudicationAuditLogGroupBy>;
    groupByAdjustment: Array<AdjustmentGroupBy>;
    groupByAdjustmentAuditLog: Array<AdjustmentAuditLogGroupBy>;
    groupByAdmin: Array<AdminGroupBy>;
    groupByAdminInteraction: Array<AdminInteractionGroupBy>;
    groupByAppointment: Array<AppointmentGroupBy>;
    groupByAppointmentAuditLog: Array<AppointmentAuditLogGroupBy>;
    groupByArrearBilling: Array<ArrearBillingGroupBy>;
    groupByArtClaim: Array<ArtClaimGroupBy>;
    groupByArtClaimAuditLog: Array<ArtClaimAuditLogGroupBy>;
    groupByArtClaimCptLine: Array<ArtClaimCptLineGroupBy>;
    groupByArtClaimCptLineAuditLog: Array<ArtClaimCptLineAuditLogGroupBy>;
    groupByArtOrgConfig: Array<ArtOrgConfigGroupBy>;
    groupByArtPracticeConfig: Array<ArtPracticeConfigGroupBy>;
    groupByAthenaMedications: Array<AthenaMedicationsGroupBy>;
    groupByAthenaPharmacy: Array<AthenaPharmacyGroupBy>;
    groupByAthenaProvider: Array<AthenaProviderGroupBy>;
    groupByBenefitParsingRules: Array<BenefitParsingRulesGroupBy>;
    groupByBillingCode: Array<BillingCodeGroupBy>;
    groupByBillingTableDownloadRequest: Array<BillingTableDownloadRequestGroupBy>;
    groupByBoughtTreatment: Array<BoughtTreatmentGroupBy>;
    groupByBoughtTreatmentAuditLog: Array<BoughtTreatmentAuditLogGroupBy>;
    groupByBoughtTreatmentClaimDetail: Array<BoughtTreatmentClaimDetailGroupBy>;
    groupByBulkChargeCardRun: Array<BulkChargeCardRunGroupBy>;
    groupByBulkChargeCardRunItem: Array<BulkChargeCardRunItemGroupBy>;
    groupByBundle: Array<BundleGroupBy>;
    groupByBundleToHrt: Array<BundleToHrtGroupBy>;
    groupByBusinessHour: Array<BusinessHourGroupBy>;
    groupByCandidateTreatment: Array<CandidateTreatmentGroupBy>;
    groupByCardAuthorization: Array<CardAuthorizationGroupBy>;
    groupByCardAuthorizationAuditLog: Array<CardAuthorizationAuditLogGroupBy>;
    groupByCashPrice: Array<CashPriceGroupBy>;
    groupByCharge: Array<ChargeGroupBy>;
    groupByChargeAuditLog: Array<ChargeAuditLogGroupBy>;
    groupByChargeReattributionAndPartialPaymentLog: Array<ChargeReattributionAndPartialPaymentLogGroupBy>;
    groupByChargeReattributionLog: Array<ChargeReattributionLogGroupBy>;
    groupByCheckNetworkStatusResults: Array<CheckNetworkStatusResultsGroupBy>;
    groupByCheckoutAdjudication: Array<CheckoutAdjudicationGroupBy>;
    groupByClaimToBoughtTreatment: Array<ClaimToBoughtTreatmentGroupBy>;
    groupByConfigCommit: Array<ConfigCommitGroupBy>;
    groupByConfigFlag: Array<ConfigFlagGroupBy>;
    groupByConfigSession: Array<ConfigSessionGroupBy>;
    groupByConsentForm: Array<ConsentFormGroupBy>;
    groupByConsumer: Array<ConsumerGroupBy>;
    groupByConsumerAuditLog: Array<ConsumerAuditLogGroupBy>;
    groupByConsumerMessage: Array<ConsumerMessageGroupBy>;
    groupByConsumerNote: Array<ConsumerNoteGroupBy>;
    groupByConsumerPhotoMetaData: Array<ConsumerPhotoMetaDataGroupBy>;
    groupByConsumerSrtRecords: Array<ConsumerSrtRecordsGroupBy>;
    groupByContract: Array<ContractGroupBy>;
    groupByContractAuditLog: Array<ContractAuditLogGroupBy>;
    groupByCoverageResponses: Array<CoverageResponsesGroupBy>;
    groupByCptExclusivityEdge: Array<CptExclusivityEdgeGroupBy>;
    groupByCustomField: Array<CustomFieldGroupBy>;
    groupByCustomFieldValue: Array<CustomFieldValueGroupBy>;
    groupByDataMigrations: Array<DataMigrationsGroupBy>;
    groupByDefaultPractice: Array<DefaultPracticeGroupBy>;
    groupByDefault_providers: Array<DefaultProvidersGroupBy>;
    groupByDeploymentOrgPhase: Array<DeploymentOrgPhaseGroupBy>;
    groupByDeploymentOrgTask: Array<DeploymentOrgTaskGroupBy>;
    groupByDeploymentOrgTaskDependency: Array<DeploymentOrgTaskDependencyGroupBy>;
    groupByDeploymentPhase: Array<DeploymentPhaseGroupBy>;
    groupByDeploymentTask: Array<DeploymentTaskGroupBy>;
    groupByDeploymentTaskDependency: Array<DeploymentTaskDependencyGroupBy>;
    groupByDeploymentTeam: Array<DeploymentTeamGroupBy>;
    groupByDiscountCodes: Array<DiscountCodesGroupBy>;
    groupByEcwPayerAlias: Array<EcwPayerAliasGroupBy>;
    groupByEcwPayerStc: Array<EcwPayerStcGroupBy>;
    groupByEhrAppointmentTypeIdToName: Array<EhrAppointmentTypeIdToNameGroupBy>;
    groupByEhrPaymentDescriptor: Array<EhrPaymentDescriptorGroupBy>;
    groupByEhrPaymentDescriptorAuditLog: Array<EhrPaymentDescriptorAuditLogGroupBy>;
    groupByEhrPaymentDirectionSsAsset: Array<EhrPaymentDirectionSsAssetGroupBy>;
    groupByEhrPostDetail: Array<EhrPostDetailGroupBy>;
    groupByEhrPostDetailToPayout: Array<EhrPostDetailToPayoutGroupBy>;
    groupByEhrPostLedger: Array<EhrPostLedgerGroupBy>;
    groupByEhrPostLedgerAuditLog: Array<EhrPostLedgerAuditLogGroupBy>;
    groupByEhrPostLedgerToPayout: Array<EhrPostLedgerToPayoutGroupBy>;
    groupByEhrPrimaryCareProvider: Array<EhrPrimaryCareProviderGroupBy>;
    groupByEhrProviderMapping: Array<EhrProviderMappingGroupBy>;
    groupByEhrSlot: Array<EhrSlotGroupBy>;
    groupByEhrSlotAuditLog: Array<EhrSlotAuditLogGroupBy>;
    groupByEncounter: Array<EncounterGroupBy>;
    groupByExperityEncounter: Array<ExperityEncounterGroupBy>;
    groupByFaqDropdowns: Array<FaqDropdownsGroupBy>;
    groupByFeeConfig: Array<FeeConfigGroupBy>;
    groupByFeeConfigAuditLog: Array<FeeConfigAuditLogGroupBy>;
    groupByGuarantorPaymentLinkContext: Array<GuarantorPaymentLinkContextGroupBy>;
    groupByHoliday: Array<HolidayGroupBy>;
    groupByHrt: Array<HrtGroupBy>;
    groupByHrtFlags: Array<HrtFlagsGroupBy>;
    groupByHrtPaymentType: Array<HrtPaymentTypeGroupBy>;
    groupByHrtToSrt: Array<HrtToSrtGroupBy>;
    groupByHrtTranslation: Array<HrtTranslationGroupBy>;
    groupByInboundRequestLog: Array<InboundRequestLogGroupBy>;
    groupByInboundTextMessageLog: Array<InboundTextMessageLogGroupBy>;
    groupByInsurance: Array<InsuranceGroupBy>;
    groupByInsuranceAuditLog: Array<InsuranceAuditLogGroupBy>;
    groupByInsuranceMetadata: Array<InsuranceMetadataGroupBy>;
    groupByIntakeForm: Array<IntakeFormGroupBy>;
    groupByIntakeFormSection: Array<IntakeFormSectionGroupBy>;
    groupByIntakeFormSectionTranslation: Array<IntakeFormSectionTranslationGroupBy>;
    groupByIntakeFormToQuestion: Array<IntakeFormToQuestionGroupBy>;
    groupByIntakeQuestion: Array<IntakeQuestionGroupBy>;
    groupByIntakeQuestionTranslation: Array<IntakeQuestionTranslationGroupBy>;
    groupByInvoiceDailyLineItems: Array<InvoiceDailyLineItemsGroupBy>;
    groupByInvoices: Array<InvoicesGroupBy>;
    groupByKeywordRule: Array<KeywordRuleGroupBy>;
    groupByLinkMapping: Array<LinkMappingGroupBy>;
    groupByLiveTransfers: Array<LiveTransfersGroupBy>;
    groupByMcmsAssociation: Array<McmsAssociationGroupBy>;
    groupByMcmsAssociationAuditLog: Array<McmsAssociationAuditLogGroupBy>;
    groupByMcmsAssociationClaim: Array<McmsAssociationClaimGroupBy>;
    groupByMcmsAssociationClaimAuditLog: Array<McmsAssociationClaimAuditLogGroupBy>;
    groupByMcmsAssociationSlot: Array<McmsAssociationSlotGroupBy>;
    groupByMcmsAssociationSlotAuditLog: Array<McmsAssociationSlotAuditLogGroupBy>;
    groupByMessageBlueprint: Array<MessageBlueprintGroupBy>;
    groupByMessageConsolidationContext: Array<MessageConsolidationContextGroupBy>;
    groupByMessageConsolidationTemplate: Array<MessageConsolidationTemplateGroupBy>;
    groupByMessageNudge: Array<MessageNudgeGroupBy>;
    groupByMessageOrchestrationRule: Array<MessageOrchestrationRuleGroupBy>;
    groupByMessagePayAfter: Array<MessagePayAfterGroupBy>;
    groupByMessageSettingsHrt: Array<MessageSettingsHrtGroupBy>;
    groupByMessageSettingsOrg: Array<MessageSettingsOrgGroupBy>;
    groupByMessageTemplateHrt: Array<MessageTemplateHrtGroupBy>;
    groupByMessageTemplateOrg: Array<MessageTemplateOrgGroupBy>;
    groupByMigratedEncounter: Array<MigratedEncounterGroupBy>;
    groupByMigrations: Array<MigrationsGroupBy>;
    groupByNetworkValidation: Array<NetworkValidationGroupBy>;
    groupByNetwork_plan_exceptions: Array<NetworkPlanExceptionsGroupBy>;
    groupByNonCardRefunds: Array<NonCardRefundsGroupBy>;
    groupByOrgConfigFlag: Array<OrgConfigFlagGroupBy>;
    groupByOrgHrtSrtRule: Array<OrgHrtSrtRuleGroupBy>;
    groupByOrgNetworkResults: Array<OrgNetworkResultsGroupBy>;
    groupByOrgOverrideRule: Array<OrgOverrideRuleGroupBy>;
    groupByOrg_fees: Array<OrgFeesGroupBy>;
    groupByOrg_stripe_mapping: Array<OrgStripeMappingGroupBy>;
    groupByOrganization: Array<OrganizationGroupBy>;
    groupByOrganizationAssets: Array<OrganizationAssetsGroupBy>;
    groupByOrganizationTranslation: Array<OrganizationTranslationGroupBy>;
    groupByPayLaterAuthorization: Array<PayLaterAuthorizationGroupBy>;
    groupByPayLaterAuthorizationAuditLog: Array<PayLaterAuthorizationAuditLogGroupBy>;
    groupByPayer: Array<PayerGroupBy>;
    groupByPayerPlanMapping: Array<PayerPlanMappingGroupBy>;
    groupByPayerToEhrInsurancePackageMapping: Array<PayerToEhrInsurancePackageMappingGroupBy>;
    groupByPaymentAuthorization: Array<PaymentAuthorizationGroupBy>;
    groupByPaymentAuthorizationAuditLog: Array<PaymentAuthorizationAuditLogGroupBy>;
    groupByPaymentContract: Array<PaymentContractGroupBy>;
    groupByPaymentPlan: Array<PaymentPlanGroupBy>;
    groupByPaymentPlanAdjustment: Array<PaymentPlanAdjustmentGroupBy>;
    groupByPaymentPlanAdjustmentAuditLog: Array<PaymentPlanAdjustmentAuditLogGroupBy>;
    groupByPaymentPlanAuditLog: Array<PaymentPlanAuditLogGroupBy>;
    groupByPaymentPlanAutoCharge: Array<PaymentPlanAutoChargeGroupBy>;
    groupByPaymentPlanAutoChargeAuditLog: Array<PaymentPlanAutoChargeAuditLogGroupBy>;
    groupByPaymentPlanBoughtTreatment: Array<PaymentPlanBoughtTreatmentGroupBy>;
    groupByPaymentPlanBoughtTreatmentAuditLog: Array<PaymentPlanBoughtTreatmentAuditLogGroupBy>;
    groupByPaymentPlanOrgConfig: Array<PaymentPlanOrgConfigGroupBy>;
    groupByPaymentPlanOrgConfigAuditLog: Array<PaymentPlanOrgConfigAuditLogGroupBy>;
    groupByPayout: Array<PayoutGroupBy>;
    groupByPayoutAuditLog: Array<PayoutAuditLogGroupBy>;
    groupByPendingVoidPayoutReversal: Array<PendingVoidPayoutReversalGroupBy>;
    groupByPhoneNumberType: Array<PhoneNumberTypeGroupBy>;
    groupByPlaceOfServiceCode: Array<PlaceOfServiceCodeGroupBy>;
    groupByPractice: Array<PracticeGroupBy>;
    groupByPracticeConfiguration: Array<PracticeConfigurationGroupBy>;
    groupByPracticeHours: Array<PracticeHoursGroupBy>;
    groupByPracticeHoursOverrides: Array<PracticeHoursOverridesGroupBy>;
    groupByPricedTreatment: Array<PricedTreatmentGroupBy>;
    groupByPricingAttempt: Array<PricingAttemptGroupBy>;
    groupByPricingEscalator: Array<PricingEscalatorGroupBy>;
    groupByPricingQueue: Array<PricingQueueGroupBy>;
    groupByPricingResults: Array<PricingResultsGroupBy>;
    groupByProcedureBenefitParsingRules: Array<ProcedureBenefitParsingRulesGroupBy>;
    groupByProductCategories: Array<ProductCategoriesGroupBy>;
    groupByProductCategoryTranslation: Array<ProductCategoryTranslationGroupBy>;
    groupByProductToBundle: Array<ProductToBundleGroupBy>;
    groupByProductToHrt: Array<ProductToHrtGroupBy>;
    groupByProductTranslation: Array<ProductTranslationGroupBy>;
    groupByProducts: Array<ProductsGroupBy>;
    groupByProvider: Array<ProviderGroupBy>;
    groupByProviderCredentialing: Array<ProviderCredentialingGroupBy>;
    groupByProviderGroup: Array<ProviderGroupGroupBy>;
    groupByProviderGroupToHrt: Array<ProviderGroupToHrtGroupBy>;
    groupByProviderHrtMaxCount: Array<ProviderHrtMaxCountGroupBy>;
    groupByProviderTaxonomy: Array<ProviderTaxonomyGroupBy>;
    groupByProviderToOrg: Array<ProviderToOrgGroupBy>;
    groupByProviderToProviderGroup: Array<ProviderToProviderGroupGroupBy>;
    groupByReattributionDirection: Array<ReattributionDirectionGroupBy>;
    groupByReceiptArrangement: Array<ReceiptArrangementGroupBy>;
    groupByReservedEhrVisit: Array<ReservedEhrVisitGroupBy>;
    groupByResetToken: Array<ResetTokenGroupBy>;
    groupBySavedIntakeResponse: Array<SavedIntakeResponseGroupBy>;
    groupBySchedulingSlotConfig: Array<SchedulingSlotConfigGroupBy>;
    groupByServiceTypeCode: Array<ServiceTypeCodeGroupBy>;
    groupBySlot: Array<SlotGroupBy>;
    groupBySlotAuditLog: Array<SlotAuditLogGroupBy>;
    groupBySrt: Array<SrtGroupBy>;
    groupBySrtFlags: Array<SrtFlagsGroupBy>;
    groupBySrtMultiplierRule: Array<SrtMultiplierRuleGroupBy>;
    groupBySrtToBillingCode: Array<SrtToBillingCodeGroupBy>;
    groupByStatePayerMapping: Array<StatePayerMappingGroupBy>;
    groupBySuperscriptFeeLineItem: Array<SuperscriptFeeLineItemGroupBy>;
    groupBySuperscriptFees: Array<SuperscriptFeesGroupBy>;
    groupBySuperscriptIntakeQuestion: Array<SuperscriptIntakeQuestionGroupBy>;
    groupByTimeBlock: Array<TimeBlockGroupBy>;
    groupByTransaction: Array<TransactionGroupBy>;
    groupByUser: Array<UserGroupBy>;
    groupByUserAuditLog: Array<UserAuditLogGroupBy>;
    groupByUserPracticeVisit: Array<UserPracticeVisitGroupBy>;
    groupByUserToNewUser: Array<UserToNewUserGroupBy>;
    groupByValidPayers: Array<ValidPayersGroupBy>;
    guarantorPaymentLinkContext?: Maybe<GuarantorPaymentLinkContext>;
    guarantorPaymentLinkContexts: Array<GuarantorPaymentLinkContext>;
    holiday?: Maybe<Holiday>;
    holidays: Array<Holiday>;
    hrt?: Maybe<Hrt>;
    hrtPaymentType?: Maybe<HrtPaymentType>;
    hrtPaymentTypes: Array<HrtPaymentType>;
    hrtToSrt?: Maybe<HrtToSrt>;
    hrtToSrts: Array<HrtToSrt>;
    hrtTranslation?: Maybe<HrtTranslation>;
    hrtTranslations: Array<HrtTranslation>;
    hrts: Array<Hrt>;
    inboundRequestLog?: Maybe<InboundRequestLog>;
    inboundRequestLogs: Array<InboundRequestLog>;
    inboundTextMessageLog?: Maybe<InboundTextMessageLog>;
    inboundTextMessageLogs: Array<InboundTextMessageLog>;
    insurance?: Maybe<Insurance>;
    insuranceAuditLog?: Maybe<InsuranceAuditLog>;
    insuranceAuditLogs: Array<InsuranceAuditLog>;
    insurances: Array<Insurance>;
    intakeForm?: Maybe<IntakeForm>;
    intakeFormSection?: Maybe<IntakeFormSection>;
    intakeFormSectionTranslation?: Maybe<IntakeFormSectionTranslation>;
    intakeFormSectionTranslations: Array<IntakeFormSectionTranslation>;
    intakeFormSections: Array<IntakeFormSection>;
    intakeFormToQuestion?: Maybe<IntakeFormToQuestion>;
    intakeFormToQuestions: Array<IntakeFormToQuestion>;
    intakeForms: Array<IntakeForm>;
    intakeQuestion?: Maybe<IntakeQuestion>;
    intakeQuestionTranslation?: Maybe<IntakeQuestionTranslation>;
    intakeQuestionTranslations: Array<IntakeQuestionTranslation>;
    intakeQuestions: Array<IntakeQuestion>;
    keywordRule?: Maybe<KeywordRule>;
    keywordRules: Array<KeywordRule>;
    linkMapping?: Maybe<LinkMapping>;
    linkMappings: Array<LinkMapping>;
    mcmsAssociation?: Maybe<McmsAssociation>;
    mcmsAssociationAuditLog?: Maybe<McmsAssociationAuditLog>;
    mcmsAssociationAuditLogs: Array<McmsAssociationAuditLog>;
    mcmsAssociationClaim?: Maybe<McmsAssociationClaim>;
    mcmsAssociationClaimAuditLog?: Maybe<McmsAssociationClaimAuditLog>;
    mcmsAssociationClaimAuditLogs: Array<McmsAssociationClaimAuditLog>;
    mcmsAssociationClaims: Array<McmsAssociationClaim>;
    mcmsAssociationSlot?: Maybe<McmsAssociationSlot>;
    mcmsAssociationSlotAuditLog?: Maybe<McmsAssociationSlotAuditLog>;
    mcmsAssociationSlotAuditLogs: Array<McmsAssociationSlotAuditLog>;
    mcmsAssociationSlots: Array<McmsAssociationSlot>;
    mcmsAssociations: Array<McmsAssociation>;
    messageBlueprint?: Maybe<MessageBlueprint>;
    messageBlueprints: Array<MessageBlueprint>;
    messageConsolidationContext?: Maybe<MessageConsolidationContext>;
    messageConsolidationContexts: Array<MessageConsolidationContext>;
    messageConsolidationTemplate?: Maybe<MessageConsolidationTemplate>;
    messageConsolidationTemplates: Array<MessageConsolidationTemplate>;
    messageNudge?: Maybe<MessageNudge>;
    messageNudges: Array<MessageNudge>;
    messageOrchestrationRule?: Maybe<MessageOrchestrationRule>;
    messageOrchestrationRules: Array<MessageOrchestrationRule>;
    messagePayAfter?: Maybe<MessagePayAfter>;
    messagePayAfters: Array<MessagePayAfter>;
    messageSettingsHrt?: Maybe<MessageSettingsHrt>;
    messageSettingsHrts: Array<MessageSettingsHrt>;
    messageSettingsOrg?: Maybe<MessageSettingsOrg>;
    messageSettingsOrgs: Array<MessageSettingsOrg>;
    messageTemplateHrt?: Maybe<MessageTemplateHrt>;
    messageTemplateHrts: Array<MessageTemplateHrt>;
    messageTemplateOrg?: Maybe<MessageTemplateOrg>;
    messageTemplateOrgs: Array<MessageTemplateOrg>;
    migratedEncounter?: Maybe<MigratedEncounter>;
    migratedEncounters: Array<MigratedEncounter>;
    networkValidation?: Maybe<NetworkValidation>;
    networkValidations: Array<NetworkValidation>;
    orgConfigFlag?: Maybe<OrgConfigFlag>;
    orgConfigFlags: Array<OrgConfigFlag>;
    orgHrtSrtRule?: Maybe<OrgHrtSrtRule>;
    orgHrtSrtRules: Array<OrgHrtSrtRule>;
    orgOverrideRule?: Maybe<OrgOverrideRule>;
    orgOverrideRules: Array<OrgOverrideRule>;
    org_stripe_mapping?: Maybe<OrgStripeMapping>;
    org_stripe_mappings: Array<OrgStripeMapping>;
    organization?: Maybe<Organization>;
    organizationTranslation?: Maybe<OrganizationTranslation>;
    organizationTranslations: Array<OrganizationTranslation>;
    organizations: Array<Organization>;
    payLaterAuthorization?: Maybe<PayLaterAuthorization>;
    payLaterAuthorizationAuditLog?: Maybe<PayLaterAuthorizationAuditLog>;
    payLaterAuthorizationAuditLogs: Array<PayLaterAuthorizationAuditLog>;
    payLaterAuthorizations: Array<PayLaterAuthorization>;
    payer?: Maybe<Payer>;
    payerPlanMapping?: Maybe<PayerPlanMapping>;
    payerPlanMappings: Array<PayerPlanMapping>;
    payerToEhrInsurancePackageMapping?: Maybe<PayerToEhrInsurancePackageMapping>;
    payerToEhrInsurancePackageMappings: Array<PayerToEhrInsurancePackageMapping>;
    payers: Array<Payer>;
    paymentAuthorization?: Maybe<PaymentAuthorization>;
    paymentAuthorizationAuditLog?: Maybe<PaymentAuthorizationAuditLog>;
    paymentAuthorizationAuditLogs: Array<PaymentAuthorizationAuditLog>;
    paymentAuthorizations: Array<PaymentAuthorization>;
    paymentContract?: Maybe<PaymentContract>;
    paymentContracts: Array<PaymentContract>;
    paymentPlan?: Maybe<PaymentPlan>;
    paymentPlanAdjustment?: Maybe<PaymentPlanAdjustment>;
    paymentPlanAdjustmentAuditLog?: Maybe<PaymentPlanAdjustmentAuditLog>;
    paymentPlanAdjustmentAuditLogs: Array<PaymentPlanAdjustmentAuditLog>;
    paymentPlanAdjustments: Array<PaymentPlanAdjustment>;
    paymentPlanAuditLog?: Maybe<PaymentPlanAuditLog>;
    paymentPlanAuditLogs: Array<PaymentPlanAuditLog>;
    paymentPlanAutoCharge?: Maybe<PaymentPlanAutoCharge>;
    paymentPlanAutoChargeAuditLog?: Maybe<PaymentPlanAutoChargeAuditLog>;
    paymentPlanAutoChargeAuditLogs: Array<PaymentPlanAutoChargeAuditLog>;
    paymentPlanAutoCharges: Array<PaymentPlanAutoCharge>;
    paymentPlanBoughtTreatment?: Maybe<PaymentPlanBoughtTreatment>;
    paymentPlanBoughtTreatmentAuditLog?: Maybe<PaymentPlanBoughtTreatmentAuditLog>;
    paymentPlanBoughtTreatmentAuditLogs: Array<PaymentPlanBoughtTreatmentAuditLog>;
    paymentPlanBoughtTreatments: Array<PaymentPlanBoughtTreatment>;
    paymentPlanOrgConfig?: Maybe<PaymentPlanOrgConfig>;
    paymentPlanOrgConfigAuditLog?: Maybe<PaymentPlanOrgConfigAuditLog>;
    paymentPlanOrgConfigAuditLogs: Array<PaymentPlanOrgConfigAuditLog>;
    paymentPlanOrgConfigs: Array<PaymentPlanOrgConfig>;
    paymentPlans: Array<PaymentPlan>;
    payout?: Maybe<Payout>;
    payoutAuditLog?: Maybe<PayoutAuditLog>;
    payoutAuditLogs: Array<PayoutAuditLog>;
    payouts: Array<Payout>;
    pendingVoidPayoutReversal?: Maybe<PendingVoidPayoutReversal>;
    pendingVoidPayoutReversals: Array<PendingVoidPayoutReversal>;
    phoneNumberType?: Maybe<PhoneNumberType>;
    phoneNumberTypes: Array<PhoneNumberType>;
    placeOfServiceCode?: Maybe<PlaceOfServiceCode>;
    placeOfServiceCodes: Array<PlaceOfServiceCode>;
    practice?: Maybe<Practice>;
    practiceConfiguration?: Maybe<PracticeConfiguration>;
    practiceConfigurations: Array<PracticeConfiguration>;
    practices: Array<Practice>;
    pricedTreatment?: Maybe<PricedTreatment>;
    pricedTreatments: Array<PricedTreatment>;
    pricingAttempt?: Maybe<PricingAttempt>;
    pricingAttempts: Array<PricingAttempt>;
    pricingEscalator?: Maybe<PricingEscalator>;
    pricingEscalators: Array<PricingEscalator>;
    pricingQueue?: Maybe<PricingQueue>;
    pricingQueues: Array<PricingQueue>;
    productCategoryTranslation?: Maybe<ProductCategoryTranslation>;
    productCategoryTranslations: Array<ProductCategoryTranslation>;
    productToBundle?: Maybe<ProductToBundle>;
    productToBundles: Array<ProductToBundle>;
    productToHrt?: Maybe<ProductToHrt>;
    productToHrts: Array<ProductToHrt>;
    productTranslation?: Maybe<ProductTranslation>;
    productTranslations: Array<ProductTranslation>;
    provider?: Maybe<Provider>;
    providerCredentialing?: Maybe<ProviderCredentialing>;
    providerCredentialings: Array<ProviderCredentialing>;
    providerGroup?: Maybe<ProviderGroup>;
    providerGroupToHrt?: Maybe<ProviderGroupToHrt>;
    providerGroupToHrts: Array<ProviderGroupToHrt>;
    providerGroups: Array<ProviderGroup>;
    providerHasGlobalPeriodProcedures: Scalars['Boolean']['output'];
    providerHrtMaxCount?: Maybe<ProviderHrtMaxCount>;
    providerHrtMaxCounts: Array<ProviderHrtMaxCount>;
    providerTaxonomies: Array<ProviderTaxonomy>;
    providerTaxonomy?: Maybe<ProviderTaxonomy>;
    providerToOrg?: Maybe<ProviderToOrg>;
    providerToOrgs: Array<ProviderToOrg>;
    providerToProviderGroup?: Maybe<ProviderToProviderGroup>;
    providerToProviderGroups: Array<ProviderToProviderGroup>;
    providers: Array<Provider>;
    reattributionDirection?: Maybe<ReattributionDirection>;
    reattributionDirections: Array<ReattributionDirection>;
    receiptArrangement?: Maybe<ReceiptArrangement>;
    receiptArrangements: Array<ReceiptArrangement>;
    reservedEhrVisit?: Maybe<ReservedEhrVisit>;
    reservedEhrVisits: Array<ReservedEhrVisit>;
    resetToken?: Maybe<ResetToken>;
    resetTokens: Array<ResetToken>;
    rosterBoughtTreatments: Array<RosterBoughtTreatment>;
    rosterSlots: Array<RosterSlot>;
    savedIntakeResponse?: Maybe<SavedIntakeResponse>;
    savedIntakeResponses: Array<SavedIntakeResponse>;
    schedulingSlotConfig?: Maybe<SchedulingSlotConfig>;
    schedulingSlotConfigs: Array<SchedulingSlotConfig>;
    serviceTypeCode?: Maybe<ServiceTypeCode>;
    serviceTypeCodes: Array<ServiceTypeCode>;
    slot?: Maybe<Slot>;
    slotAuditLog?: Maybe<SlotAuditLog>;
    slotAuditLogs: Array<SlotAuditLog>;
    slots: Array<Slot>;
    srt?: Maybe<Srt>;
    srtMultiplierRule?: Maybe<SrtMultiplierRule>;
    srtMultiplierRules: Array<SrtMultiplierRule>;
    srtToBillingCode?: Maybe<SrtToBillingCode>;
    srtToBillingCodes: Array<SrtToBillingCode>;
    srts: Array<Srt>;
    statePayerMapping?: Maybe<StatePayerMapping>;
    statePayerMappings: Array<StatePayerMapping>;
    superscriptFeeLineItem?: Maybe<SuperscriptFeeLineItem>;
    superscriptFeeLineItems: Array<SuperscriptFeeLineItem>;
    superscriptIntakeQuestion?: Maybe<SuperscriptIntakeQuestion>;
    superscriptIntakeQuestions: Array<SuperscriptIntakeQuestion>;
    timeBlock?: Maybe<TimeBlock>;
    timeBlocks: Array<TimeBlock>;
    transaction?: Maybe<Transaction>;
    transactions: Array<Transaction>;
    user?: Maybe<User>;
    userAuditLog?: Maybe<UserAuditLog>;
    userAuditLogs: Array<UserAuditLog>;
    userPracticeVisit?: Maybe<UserPracticeVisit>;
    userPracticeVisits: Array<UserPracticeVisit>;
    userToNewUser?: Maybe<UserToNewUser>;
    userToNewUsers: Array<UserToNewUser>;
    users: Array<User>;
};

export type QueryALeConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AleConfigWhereUniqueInput;
};

export type QueryALeConfigsArgs = {
    cursor?: InputMaybe<AleConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<AleConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AleConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleConfigWhereInput>;
};

export type QueryALeDepartmentGoLiveArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AleDepartmentGoLiveWhereUniqueInput;
};

export type QueryALeDepartmentGoLivesArgs = {
    cursor?: InputMaybe<AleDepartmentGoLiveWhereUniqueInput>;
    distinct?: InputMaybe<Array<AleDepartmentGoLiveScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AleDepartmentGoLiveOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleDepartmentGoLiveWhereInput>;
};

export type QueryAdjudicationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjudicationWhereUniqueInput;
};

export type QueryAdjudicationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjudicationAuditLogWhereUniqueInput;
};

export type QueryAdjudicationAuditLogsArgs = {
    cursor?: InputMaybe<AdjudicationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjudicationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjudicationAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjudicationAuditLogWhereInput>;
};

export type QueryAdjudicationsArgs = {
    cursor?: InputMaybe<AdjudicationWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjudicationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjudicationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjudicationWhereInput>;
};

export type QueryAdjustmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjustmentWhereUniqueInput;
};

export type QueryAdjustmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjustmentAuditLogWhereUniqueInput;
};

export type QueryAdjustmentAuditLogsArgs = {
    cursor?: InputMaybe<AdjustmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjustmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjustmentAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjustmentAuditLogWhereInput>;
};

export type QueryAdjustmentsArgs = {
    cursor?: InputMaybe<AdjustmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjustmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjustmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjustmentWhereInput>;
};

export type QueryAdminArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdminWhereUniqueInput;
};

export type QueryAdminInteractionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdminInteractionWhereUniqueInput;
};

export type QueryAdminInteractionsArgs = {
    cursor?: InputMaybe<AdminInteractionWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdminInteractionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdminInteractionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminInteractionWhereInput>;
};

export type QueryAdminsArgs = {
    cursor?: InputMaybe<AdminWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdminScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdminOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminWhereInput>;
};

export type QueryAggregateAleConfigArgs = {
    cursor?: InputMaybe<AleConfigWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AleConfigOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleConfigWhereInput>;
};

export type QueryAggregateAleDepartmentGoLiveArgs = {
    cursor?: InputMaybe<AleDepartmentGoLiveWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AleDepartmentGoLiveOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleDepartmentGoLiveWhereInput>;
};

export type QueryAggregateAdjudicationArgs = {
    cursor?: InputMaybe<AdjudicationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AdjudicationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjudicationWhereInput>;
};

export type QueryAggregateAdjudicationAuditLogArgs = {
    cursor?: InputMaybe<AdjudicationAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AdjudicationAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjudicationAuditLogWhereInput>;
};

export type QueryAggregateAdjustmentArgs = {
    cursor?: InputMaybe<AdjustmentWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AdjustmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjustmentWhereInput>;
};

export type QueryAggregateAdjustmentAuditLogArgs = {
    cursor?: InputMaybe<AdjustmentAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AdjustmentAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjustmentAuditLogWhereInput>;
};

export type QueryAggregateAdminArgs = {
    cursor?: InputMaybe<AdminWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AdminOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminWhereInput>;
};

export type QueryAggregateAdminInteractionArgs = {
    cursor?: InputMaybe<AdminInteractionWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AdminInteractionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminInteractionWhereInput>;
};

export type QueryAggregateAppointmentArgs = {
    cursor?: InputMaybe<AppointmentWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AppointmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AppointmentWhereInput>;
};

export type QueryAggregateAppointmentAuditLogArgs = {
    cursor?: InputMaybe<AppointmentAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AppointmentAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AppointmentAuditLogWhereInput>;
};

export type QueryAggregateArrearBillingArgs = {
    cursor?: InputMaybe<ArrearBillingWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ArrearBillingOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArrearBillingWhereInput>;
};

export type QueryAggregateArtClaimArgs = {
    cursor?: InputMaybe<ArtClaimWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ArtClaimOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimWhereInput>;
};

export type QueryAggregateArtClaimAuditLogArgs = {
    cursor?: InputMaybe<ArtClaimAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ArtClaimAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimAuditLogWhereInput>;
};

export type QueryAggregateArtClaimCptLineArgs = {
    cursor?: InputMaybe<ArtClaimCptLineWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ArtClaimCptLineOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineWhereInput>;
};

export type QueryAggregateArtClaimCptLineAuditLogArgs = {
    cursor?: InputMaybe<ArtClaimCptLineAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<ArtClaimCptLineAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineAuditLogWhereInput>;
};

export type QueryAggregateArtOrgConfigArgs = {
    cursor?: InputMaybe<ArtOrgConfigWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ArtOrgConfigOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type QueryAggregateArtPracticeConfigArgs = {
    cursor?: InputMaybe<ArtPracticeConfigWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ArtPracticeConfigOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type QueryAggregateAthenaMedicationsArgs = {
    cursor?: InputMaybe<AthenaMedicationsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AthenaMedicationsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaMedicationsWhereInput>;
};

export type QueryAggregateAthenaPharmacyArgs = {
    cursor?: InputMaybe<AthenaPharmacyWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AthenaPharmacyOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaPharmacyWhereInput>;
};

export type QueryAggregateAthenaProviderArgs = {
    cursor?: InputMaybe<AthenaProviderWhereUniqueInput>;
    orderBy?: InputMaybe<Array<AthenaProviderOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaProviderWhereInput>;
};

export type QueryAggregateBenefitParsingRulesArgs = {
    cursor?: InputMaybe<BenefitParsingRulesWhereUniqueInput>;
    orderBy?: InputMaybe<Array<BenefitParsingRulesOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BenefitParsingRulesWhereInput>;
};

export type QueryAggregateBillingCodeArgs = {
    cursor?: InputMaybe<BillingCodeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<BillingCodeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BillingCodeWhereInput>;
};

export type QueryAggregateBillingTableDownloadRequestArgs = {
    cursor?: InputMaybe<BillingTableDownloadRequestWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<BillingTableDownloadRequestOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BillingTableDownloadRequestWhereInput>;
};

export type QueryAggregateBoughtTreatmentArgs = {
    cursor?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    orderBy?: InputMaybe<Array<BoughtTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type QueryAggregateBoughtTreatmentAuditLogArgs = {
    cursor?: InputMaybe<BoughtTreatmentAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<BoughtTreatmentAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentAuditLogWhereInput>;
};

export type QueryAggregateBoughtTreatmentClaimDetailArgs = {
    cursor?: InputMaybe<BoughtTreatmentClaimDetailWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<BoughtTreatmentClaimDetailOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentClaimDetailWhereInput>;
};

export type QueryAggregateBulkChargeCardRunArgs = {
    cursor?: InputMaybe<BulkChargeCardRunWhereUniqueInput>;
    orderBy?: InputMaybe<Array<BulkChargeCardRunOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunWhereInput>;
};

export type QueryAggregateBulkChargeCardRunItemArgs = {
    cursor?: InputMaybe<BulkChargeCardRunItemWhereUniqueInput>;
    orderBy?: InputMaybe<Array<BulkChargeCardRunItemOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunItemWhereInput>;
};

export type QueryAggregateBundleArgs = {
    cursor?: InputMaybe<BundleWhereUniqueInput>;
    orderBy?: InputMaybe<Array<BundleOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleWhereInput>;
};

export type QueryAggregateBundleToHrtArgs = {
    cursor?: InputMaybe<BundleToHrtWhereUniqueInput>;
    orderBy?: InputMaybe<Array<BundleToHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type QueryAggregateBusinessHourArgs = {
    cursor?: InputMaybe<BusinessHourWhereUniqueInput>;
    orderBy?: InputMaybe<Array<BusinessHourOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BusinessHourWhereInput>;
};

export type QueryAggregateCandidateTreatmentArgs = {
    cursor?: InputMaybe<CandidateTreatmentWhereUniqueInput>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type QueryAggregateCardAuthorizationArgs = {
    cursor?: InputMaybe<CardAuthorizationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<CardAuthorizationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CardAuthorizationWhereInput>;
};

export type QueryAggregateCardAuthorizationAuditLogArgs = {
    cursor?: InputMaybe<CardAuthorizationAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<CardAuthorizationAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CardAuthorizationAuditLogWhereInput>;
};

export type QueryAggregateCashPriceArgs = {
    cursor?: InputMaybe<CashPriceWhereUniqueInput>;
    orderBy?: InputMaybe<Array<CashPriceOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CashPriceWhereInput>;
};

export type QueryAggregateChargeArgs = {
    cursor?: InputMaybe<ChargeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ChargeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeWhereInput>;
};

export type QueryAggregateChargeAuditLogArgs = {
    cursor?: InputMaybe<ChargeAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ChargeAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeAuditLogWhereInput>;
};

export type QueryAggregateChargeReattributionAndPartialPaymentLogArgs = {
    cursor?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<ChargeReattributionAndPartialPaymentLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereInput>;
};

export type QueryAggregateChargeReattributionLogArgs = {
    cursor?: InputMaybe<ChargeReattributionLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ChargeReattributionLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeReattributionLogWhereInput>;
};

export type QueryAggregateCheckNetworkStatusResultsArgs = {
    cursor?: InputMaybe<CheckNetworkStatusResultsWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<CheckNetworkStatusResultsOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CheckNetworkStatusResultsWhereInput>;
};

export type QueryAggregateCheckoutAdjudicationArgs = {
    cursor?: InputMaybe<CheckoutAdjudicationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<CheckoutAdjudicationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CheckoutAdjudicationWhereInput>;
};

export type QueryAggregateClaimToBoughtTreatmentArgs = {
    cursor?: InputMaybe<ClaimToBoughtTreatmentWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ClaimToBoughtTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ClaimToBoughtTreatmentWhereInput>;
};

export type QueryAggregateConfigCommitArgs = {
    cursor?: InputMaybe<ConfigCommitWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ConfigCommitOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type QueryAggregateConfigFlagArgs = {
    cursor?: InputMaybe<ConfigFlagWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ConfigFlagOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigFlagWhereInput>;
};

export type QueryAggregateConfigSessionArgs = {
    cursor?: InputMaybe<ConfigSessionWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ConfigSessionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigSessionWhereInput>;
};

export type QueryAggregateConsentFormArgs = {
    cursor?: InputMaybe<ConsentFormWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ConsentFormOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsentFormWhereInput>;
};

export type QueryAggregateConsumerArgs = {
    cursor?: InputMaybe<ConsumerWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ConsumerOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type QueryAggregateConsumerAuditLogArgs = {
    cursor?: InputMaybe<ConsumerAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ConsumerAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerAuditLogWhereInput>;
};

export type QueryAggregateConsumerMessageArgs = {
    cursor?: InputMaybe<ConsumerMessageWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ConsumerMessageOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type QueryAggregateConsumerNoteArgs = {
    cursor?: InputMaybe<ConsumerNoteWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ConsumerNoteOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type QueryAggregateConsumerPhotoMetaDataArgs = {
    cursor?: InputMaybe<ConsumerPhotoMetaDataWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ConsumerPhotoMetaDataOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type QueryAggregateConsumerSrtRecordsArgs = {
    cursor?: InputMaybe<ConsumerSrtRecordsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ConsumerSrtRecordsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerSrtRecordsWhereInput>;
};

export type QueryAggregateContractArgs = {
    cursor?: InputMaybe<ContractWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ContractOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractWhereInput>;
};

export type QueryAggregateContractAuditLogArgs = {
    cursor?: InputMaybe<ContractAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ContractAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractAuditLogWhereInput>;
};

export type QueryAggregateCoverageResponsesArgs = {
    cursor?: InputMaybe<CoverageResponsesWhereUniqueInput>;
    orderBy?: InputMaybe<Array<CoverageResponsesOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CoverageResponsesWhereInput>;
};

export type QueryAggregateCptExclusivityEdgeArgs = {
    cursor?: InputMaybe<CptExclusivityEdgeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<CptExclusivityEdgeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CptExclusivityEdgeWhereInput>;
};

export type QueryAggregateCustomFieldArgs = {
    cursor?: InputMaybe<CustomFieldWhereUniqueInput>;
    orderBy?: InputMaybe<Array<CustomFieldOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type QueryAggregateCustomFieldValueArgs = {
    cursor?: InputMaybe<CustomFieldValueWhereUniqueInput>;
    orderBy?: InputMaybe<Array<CustomFieldValueOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type QueryAggregateDataMigrationsArgs = {
    cursor?: InputMaybe<DataMigrationsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<DataMigrationsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DataMigrationsWhereInput>;
};

export type QueryAggregateDefaultPracticeArgs = {
    cursor?: InputMaybe<DefaultPracticeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<DefaultPracticeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type QueryAggregateDefaultProvidersArgs = {
    cursor?: InputMaybe<DefaultProvidersWhereUniqueInput>;
    orderBy?: InputMaybe<Array<DefaultProvidersOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultProvidersWhereInput>;
};

export type QueryAggregateDeploymentOrgPhaseArgs = {
    cursor?: InputMaybe<DeploymentOrgPhaseWhereUniqueInput>;
    orderBy?: InputMaybe<Array<DeploymentOrgPhaseOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type QueryAggregateDeploymentOrgTaskArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    orderBy?: InputMaybe<Array<DeploymentOrgTaskOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type QueryAggregateDeploymentOrgTaskDependencyArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskDependencyWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<DeploymentOrgTaskDependencyOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type QueryAggregateDeploymentPhaseArgs = {
    cursor?: InputMaybe<DeploymentPhaseWhereUniqueInput>;
    orderBy?: InputMaybe<Array<DeploymentPhaseOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type QueryAggregateDeploymentTaskArgs = {
    cursor?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    orderBy?: InputMaybe<Array<DeploymentTaskOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type QueryAggregateDeploymentTaskDependencyArgs = {
    cursor?: InputMaybe<DeploymentTaskDependencyWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<DeploymentTaskDependencyOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type QueryAggregateDeploymentTeamArgs = {
    cursor?: InputMaybe<DeploymentTeamWhereUniqueInput>;
    orderBy?: InputMaybe<Array<DeploymentTeamOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTeamWhereInput>;
};

export type QueryAggregateDiscountCodesArgs = {
    cursor?: InputMaybe<DiscountCodesWhereUniqueInput>;
    orderBy?: InputMaybe<Array<DiscountCodesOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DiscountCodesWhereInput>;
};

export type QueryAggregateEcwPayerAliasArgs = {
    cursor?: InputMaybe<EcwPayerAliasWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EcwPayerAliasOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerAliasWhereInput>;
};

export type QueryAggregateEcwPayerStcArgs = {
    cursor?: InputMaybe<EcwPayerStcWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EcwPayerStcOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerStcWhereInput>;
};

export type QueryAggregateEhrAppointmentTypeIdToNameArgs = {
    cursor?: InputMaybe<EhrAppointmentTypeIdToNameWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<EhrAppointmentTypeIdToNameOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrAppointmentTypeIdToNameWhereInput>;
};

export type QueryAggregateEhrPaymentDescriptorArgs = {
    cursor?: InputMaybe<EhrPaymentDescriptorWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EhrPaymentDescriptorOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDescriptorWhereInput>;
};

export type QueryAggregateEhrPaymentDescriptorAuditLogArgs = {
    cursor?: InputMaybe<EhrPaymentDescriptorAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDescriptorAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDescriptorAuditLogWhereInput>;
};

export type QueryAggregateEhrPaymentDirectionSsAssetArgs = {
    cursor?: InputMaybe<EhrPaymentDirectionSsAssetWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDirectionSsAssetOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDirectionSsAssetWhereInput>;
};

export type QueryAggregateEhrPostDetailArgs = {
    cursor?: InputMaybe<EhrPostDetailWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EhrPostDetailOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostDetailWhereInput>;
};

export type QueryAggregateEhrPostDetailToPayoutArgs = {
    cursor?: InputMaybe<EhrPostDetailToPayoutWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EhrPostDetailToPayoutOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostDetailToPayoutWhereInput>;
};

export type QueryAggregateEhrPostLedgerArgs = {
    cursor?: InputMaybe<EhrPostLedgerWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EhrPostLedgerOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerWhereInput>;
};

export type QueryAggregateEhrPostLedgerAuditLogArgs = {
    cursor?: InputMaybe<EhrPostLedgerAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EhrPostLedgerAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerAuditLogWhereInput>;
};

export type QueryAggregateEhrPostLedgerToPayoutArgs = {
    cursor?: InputMaybe<EhrPostLedgerToPayoutWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EhrPostLedgerToPayoutOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerToPayoutWhereInput>;
};

export type QueryAggregateEhrPrimaryCareProviderArgs = {
    cursor?: InputMaybe<EhrPrimaryCareProviderWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EhrPrimaryCareProviderOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPrimaryCareProviderWhereInput>;
};

export type QueryAggregateEhrProviderMappingArgs = {
    cursor?: InputMaybe<EhrProviderMappingWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EhrProviderMappingOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrProviderMappingWhereInput>;
};

export type QueryAggregateEhrSlotArgs = {
    cursor?: InputMaybe<EhrSlotWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EhrSlotOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type QueryAggregateEhrSlotAuditLogArgs = {
    cursor?: InputMaybe<EhrSlotAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EhrSlotAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrSlotAuditLogWhereInput>;
};

export type QueryAggregateEncounterArgs = {
    cursor?: InputMaybe<EncounterWhereUniqueInput>;
    orderBy?: InputMaybe<Array<EncounterOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EncounterWhereInput>;
};

export type QueryAggregateExperityEncounterArgs = {
    cursor?: InputMaybe<ExperityEncounterWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ExperityEncounterOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ExperityEncounterWhereInput>;
};

export type QueryAggregateFaqDropdownsArgs = {
    cursor?: InputMaybe<FaqDropdownsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<FaqDropdownsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FaqDropdownsWhereInput>;
};

export type QueryAggregateFeeConfigArgs = {
    cursor?: InputMaybe<FeeConfigWhereUniqueInput>;
    orderBy?: InputMaybe<Array<FeeConfigOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FeeConfigWhereInput>;
};

export type QueryAggregateFeeConfigAuditLogArgs = {
    cursor?: InputMaybe<FeeConfigAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<FeeConfigAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FeeConfigAuditLogWhereInput>;
};

export type QueryAggregateGuarantorPaymentLinkContextArgs = {
    cursor?: InputMaybe<GuarantorPaymentLinkContextWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<GuarantorPaymentLinkContextOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GuarantorPaymentLinkContextWhereInput>;
};

export type QueryAggregateHolidayArgs = {
    cursor?: InputMaybe<HolidayWhereUniqueInput>;
    orderBy?: InputMaybe<Array<HolidayOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HolidayWhereInput>;
};

export type QueryAggregateHrtArgs = {
    cursor?: InputMaybe<HrtWhereUniqueInput>;
    orderBy?: InputMaybe<Array<HrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtWhereInput>;
};

export type QueryAggregateHrtFlagsArgs = {
    cursor?: InputMaybe<HrtFlagsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<HrtFlagsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtFlagsWhereInput>;
};

export type QueryAggregateHrtPaymentTypeArgs = {
    cursor?: InputMaybe<HrtPaymentTypeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<HrtPaymentTypeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtPaymentTypeWhereInput>;
};

export type QueryAggregateHrtToSrtArgs = {
    cursor?: InputMaybe<HrtToSrtWhereUniqueInput>;
    orderBy?: InputMaybe<Array<HrtToSrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type QueryAggregateHrtTranslationArgs = {
    cursor?: InputMaybe<HrtTranslationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<HrtTranslationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtTranslationWhereInput>;
};

export type QueryAggregateInboundRequestLogArgs = {
    cursor?: InputMaybe<InboundRequestLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<InboundRequestLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InboundRequestLogWhereInput>;
};

export type QueryAggregateInboundTextMessageLogArgs = {
    cursor?: InputMaybe<InboundTextMessageLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<InboundTextMessageLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InboundTextMessageLogWhereInput>;
};

export type QueryAggregateInsuranceArgs = {
    cursor?: InputMaybe<InsuranceWhereUniqueInput>;
    orderBy?: InputMaybe<Array<InsuranceOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceWhereInput>;
};

export type QueryAggregateInsuranceAuditLogArgs = {
    cursor?: InputMaybe<InsuranceAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<InsuranceAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceAuditLogWhereInput>;
};

export type QueryAggregateInsuranceMetadataArgs = {
    cursor?: InputMaybe<InsuranceMetadataWhereUniqueInput>;
    orderBy?: InputMaybe<Array<InsuranceMetadataOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceMetadataWhereInput>;
};

export type QueryAggregateIntakeFormArgs = {
    cursor?: InputMaybe<IntakeFormWhereUniqueInput>;
    orderBy?: InputMaybe<Array<IntakeFormOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type QueryAggregateIntakeFormSectionArgs = {
    cursor?: InputMaybe<IntakeFormSectionWhereUniqueInput>;
    orderBy?: InputMaybe<Array<IntakeFormSectionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type QueryAggregateIntakeFormSectionTranslationArgs = {
    cursor?: InputMaybe<IntakeFormSectionTranslationWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<IntakeFormSectionTranslationOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
};

export type QueryAggregateIntakeFormToQuestionArgs = {
    cursor?: InputMaybe<IntakeFormToQuestionWhereUniqueInput>;
    orderBy?: InputMaybe<Array<IntakeFormToQuestionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type QueryAggregateIntakeQuestionArgs = {
    cursor?: InputMaybe<IntakeQuestionWhereUniqueInput>;
    orderBy?: InputMaybe<Array<IntakeQuestionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type QueryAggregateIntakeQuestionTranslationArgs = {
    cursor?: InputMaybe<IntakeQuestionTranslationWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<IntakeQuestionTranslationOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionTranslationWhereInput>;
};

export type QueryAggregateInvoiceDailyLineItemsArgs = {
    cursor?: InputMaybe<InvoiceDailyLineItemsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<InvoiceDailyLineItemsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
};

export type QueryAggregateInvoicesArgs = {
    cursor?: InputMaybe<InvoicesWhereUniqueInput>;
    orderBy?: InputMaybe<Array<InvoicesOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoicesWhereInput>;
};

export type QueryAggregateKeywordRuleArgs = {
    cursor?: InputMaybe<KeywordRuleWhereUniqueInput>;
    orderBy?: InputMaybe<Array<KeywordRuleOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<KeywordRuleWhereInput>;
};

export type QueryAggregateLinkMappingArgs = {
    cursor?: InputMaybe<LinkMappingWhereUniqueInput>;
    orderBy?: InputMaybe<Array<LinkMappingOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<LinkMappingWhereInput>;
};

export type QueryAggregateLiveTransfersArgs = {
    cursor?: InputMaybe<LiveTransfersWhereUniqueInput>;
    orderBy?: InputMaybe<Array<LiveTransfersOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<LiveTransfersWhereInput>;
};

export type QueryAggregateMcmsAssociationArgs = {
    cursor?: InputMaybe<McmsAssociationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<McmsAssociationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type QueryAggregateMcmsAssociationAuditLogArgs = {
    cursor?: InputMaybe<McmsAssociationAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<McmsAssociationAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationAuditLogWhereInput>;
};

export type QueryAggregateMcmsAssociationClaimArgs = {
    cursor?: InputMaybe<McmsAssociationClaimWhereUniqueInput>;
    orderBy?: InputMaybe<Array<McmsAssociationClaimOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimWhereInput>;
};

export type QueryAggregateMcmsAssociationClaimAuditLogArgs = {
    cursor?: InputMaybe<McmsAssociationClaimAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<McmsAssociationClaimAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimAuditLogWhereInput>;
};

export type QueryAggregateMcmsAssociationSlotArgs = {
    cursor?: InputMaybe<McmsAssociationSlotWhereUniqueInput>;
    orderBy?: InputMaybe<Array<McmsAssociationSlotOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotWhereInput>;
};

export type QueryAggregateMcmsAssociationSlotAuditLogArgs = {
    cursor?: InputMaybe<McmsAssociationSlotAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<McmsAssociationSlotAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotAuditLogWhereInput>;
};

export type QueryAggregateMessageBlueprintArgs = {
    cursor?: InputMaybe<MessageBlueprintWhereUniqueInput>;
    orderBy?: InputMaybe<Array<MessageBlueprintOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type QueryAggregateMessageConsolidationContextArgs = {
    cursor?: InputMaybe<MessageConsolidationContextWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationContextOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationContextWhereInput>;
};

export type QueryAggregateMessageConsolidationTemplateArgs = {
    cursor?: InputMaybe<MessageConsolidationTemplateWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationTemplateOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationTemplateWhereInput>;
};

export type QueryAggregateMessageNudgeArgs = {
    cursor?: InputMaybe<MessageNudgeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<MessageNudgeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type QueryAggregateMessageOrchestrationRuleArgs = {
    cursor?: InputMaybe<MessageOrchestrationRuleWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<MessageOrchestrationRuleOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageOrchestrationRuleWhereInput>;
};

export type QueryAggregateMessagePayAfterArgs = {
    cursor?: InputMaybe<MessagePayAfterWhereUniqueInput>;
    orderBy?: InputMaybe<Array<MessagePayAfterOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessagePayAfterWhereInput>;
};

export type QueryAggregateMessageSettingsHrtArgs = {
    cursor?: InputMaybe<MessageSettingsHrtWhereUniqueInput>;
    orderBy?: InputMaybe<Array<MessageSettingsHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageSettingsHrtWhereInput>;
};

export type QueryAggregateMessageSettingsOrgArgs = {
    cursor?: InputMaybe<MessageSettingsOrgWhereUniqueInput>;
    orderBy?: InputMaybe<Array<MessageSettingsOrgOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageSettingsOrgWhereInput>;
};

export type QueryAggregateMessageTemplateHrtArgs = {
    cursor?: InputMaybe<MessageTemplateHrtWhereUniqueInput>;
    orderBy?: InputMaybe<Array<MessageTemplateHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateHrtWhereInput>;
};

export type QueryAggregateMessageTemplateOrgArgs = {
    cursor?: InputMaybe<MessageTemplateOrgWhereUniqueInput>;
    orderBy?: InputMaybe<Array<MessageTemplateOrgOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateOrgWhereInput>;
};

export type QueryAggregateMigratedEncounterArgs = {
    cursor?: InputMaybe<MigratedEncounterWhereUniqueInput>;
    orderBy?: InputMaybe<Array<MigratedEncounterOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MigratedEncounterWhereInput>;
};

export type QueryAggregateMigrationsArgs = {
    cursor?: InputMaybe<MigrationsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<MigrationsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MigrationsWhereInput>;
};

export type QueryAggregateNetworkValidationArgs = {
    cursor?: InputMaybe<NetworkValidationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<NetworkValidationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NetworkValidationWhereInput>;
};

export type QueryAggregateNetworkPlanExceptionsArgs = {
    cursor?: InputMaybe<NetworkPlanExceptionsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<NetworkPlanExceptionsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NetworkPlanExceptionsWhereInput>;
};

export type QueryAggregateNonCardRefundsArgs = {
    cursor?: InputMaybe<NonCardRefundsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<NonCardRefundsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NonCardRefundsWhereInput>;
};

export type QueryAggregateOrgConfigFlagArgs = {
    cursor?: InputMaybe<OrgConfigFlagWhereUniqueInput>;
    orderBy?: InputMaybe<Array<OrgConfigFlagOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type QueryAggregateOrgHrtSrtRuleArgs = {
    cursor?: InputMaybe<OrgHrtSrtRuleWhereUniqueInput>;
    orderBy?: InputMaybe<Array<OrgHrtSrtRuleOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgHrtSrtRuleWhereInput>;
};

export type QueryAggregateOrgNetworkResultsArgs = {
    cursor?: InputMaybe<OrgNetworkResultsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<OrgNetworkResultsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgNetworkResultsWhereInput>;
};

export type QueryAggregateOrgOverrideRuleArgs = {
    cursor?: InputMaybe<OrgOverrideRuleWhereUniqueInput>;
    orderBy?: InputMaybe<Array<OrgOverrideRuleOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgOverrideRuleWhereInput>;
};

export type QueryAggregateOrgFeesArgs = {
    cursor?: InputMaybe<OrgFeesWhereUniqueInput>;
    orderBy?: InputMaybe<Array<OrgFeesOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgFeesWhereInput>;
};

export type QueryAggregateOrgStripeMappingArgs = {
    cursor?: InputMaybe<OrgStripeMappingWhereUniqueInput>;
    orderBy?: InputMaybe<Array<OrgStripeMappingOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgStripeMappingWhereInput>;
};

export type QueryAggregateOrganizationArgs = {
    cursor?: InputMaybe<OrganizationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type QueryAggregateOrganizationAssetsArgs = {
    cursor?: InputMaybe<OrganizationAssetsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<OrganizationAssetsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type QueryAggregateOrganizationTranslationArgs = {
    cursor?: InputMaybe<OrganizationTranslationWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<OrganizationTranslationOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationTranslationWhereInput>;
};

export type QueryAggregatePayLaterAuthorizationArgs = {
    cursor?: InputMaybe<PayLaterAuthorizationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PayLaterAuthorizationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type QueryAggregatePayLaterAuthorizationAuditLogArgs = {
    cursor?: InputMaybe<PayLaterAuthorizationAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<PayLaterAuthorizationAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationAuditLogWhereInput>;
};

export type QueryAggregatePayerArgs = {
    cursor?: InputMaybe<PayerWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PayerOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerWhereInput>;
};

export type QueryAggregatePayerPlanMappingArgs = {
    cursor?: InputMaybe<PayerPlanMappingWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PayerPlanMappingOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerPlanMappingWhereInput>;
};

export type QueryAggregatePayerToEhrInsurancePackageMappingArgs = {
    cursor?: InputMaybe<PayerToEhrInsurancePackageMappingWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type QueryAggregatePaymentAuthorizationArgs = {
    cursor?: InputMaybe<PaymentAuthorizationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PaymentAuthorizationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type QueryAggregatePaymentAuthorizationAuditLogArgs = {
    cursor?: InputMaybe<PaymentAuthorizationAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<PaymentAuthorizationAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentAuthorizationAuditLogWhereInput>;
};

export type QueryAggregatePaymentContractArgs = {
    cursor?: InputMaybe<PaymentContractWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PaymentContractOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentContractWhereInput>;
};

export type QueryAggregatePaymentPlanArgs = {
    cursor?: InputMaybe<PaymentPlanWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PaymentPlanOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type QueryAggregatePaymentPlanAdjustmentArgs = {
    cursor?: InputMaybe<PaymentPlanAdjustmentWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PaymentPlanAdjustmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
};

export type QueryAggregatePaymentPlanAdjustmentAuditLogArgs = {
    cursor?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAdjustmentAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereInput>;
};

export type QueryAggregatePaymentPlanAuditLogArgs = {
    cursor?: InputMaybe<PaymentPlanAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PaymentPlanAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAuditLogWhereInput>;
};

export type QueryAggregatePaymentPlanAutoChargeArgs = {
    cursor?: InputMaybe<PaymentPlanAutoChargeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PaymentPlanAutoChargeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
};

export type QueryAggregatePaymentPlanAutoChargeAuditLogArgs = {
    cursor?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAutoChargeAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereInput>;
};

export type QueryAggregatePaymentPlanBoughtTreatmentArgs = {
    cursor?: InputMaybe<PaymentPlanBoughtTreatmentWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
};

export type QueryAggregatePaymentPlanBoughtTreatmentAuditLogArgs = {
    cursor?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereInput>;
};

export type QueryAggregatePaymentPlanOrgConfigArgs = {
    cursor?: InputMaybe<PaymentPlanOrgConfigWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PaymentPlanOrgConfigOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanOrgConfigWhereInput>;
};

export type QueryAggregatePaymentPlanOrgConfigAuditLogArgs = {
    cursor?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanOrgConfigAuditLogOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereInput>;
};

export type QueryAggregatePayoutArgs = {
    cursor?: InputMaybe<PayoutWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutWhereInput>;
};

export type QueryAggregatePayoutAuditLogArgs = {
    cursor?: InputMaybe<PayoutAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PayoutAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutAuditLogWhereInput>;
};

export type QueryAggregatePendingVoidPayoutReversalArgs = {
    cursor?: InputMaybe<PendingVoidPayoutReversalWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<PendingVoidPayoutReversalOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PendingVoidPayoutReversalWhereInput>;
};

export type QueryAggregatePhoneNumberTypeArgs = {
    cursor?: InputMaybe<PhoneNumberTypeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PhoneNumberTypeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PhoneNumberTypeWhereInput>;
};

export type QueryAggregatePlaceOfServiceCodeArgs = {
    cursor?: InputMaybe<PlaceOfServiceCodeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PlaceOfServiceCodeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type QueryAggregatePracticeArgs = {
    cursor?: InputMaybe<PracticeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PracticeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeWhereInput>;
};

export type QueryAggregatePracticeConfigurationArgs = {
    cursor?: InputMaybe<PracticeConfigurationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PracticeConfigurationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeConfigurationWhereInput>;
};

export type QueryAggregatePracticeHoursArgs = {
    cursor?: InputMaybe<PracticeHoursWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PracticeHoursOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursWhereInput>;
};

export type QueryAggregatePracticeHoursOverridesArgs = {
    cursor?: InputMaybe<PracticeHoursOverridesWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PracticeHoursOverridesOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursOverridesWhereInput>;
};

export type QueryAggregatePricedTreatmentArgs = {
    cursor?: InputMaybe<PricedTreatmentWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PricedTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type QueryAggregatePricingAttemptArgs = {
    cursor?: InputMaybe<PricingAttemptWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PricingAttemptOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type QueryAggregatePricingEscalatorArgs = {
    cursor?: InputMaybe<PricingEscalatorWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PricingEscalatorOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingEscalatorWhereInput>;
};

export type QueryAggregatePricingQueueArgs = {
    cursor?: InputMaybe<PricingQueueWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PricingQueueOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingQueueWhereInput>;
};

export type QueryAggregatePricingResultsArgs = {
    cursor?: InputMaybe<PricingResultsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<PricingResultsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingResultsWhereInput>;
};

export type QueryAggregateProcedureBenefitParsingRulesArgs = {
    cursor?: InputMaybe<ProcedureBenefitParsingRulesWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<ProcedureBenefitParsingRulesOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProcedureBenefitParsingRulesWhereInput>;
};

export type QueryAggregateProductCategoriesArgs = {
    cursor?: InputMaybe<ProductCategoriesWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProductCategoriesOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoriesWhereInput>;
};

export type QueryAggregateProductCategoryTranslationArgs = {
    cursor?: InputMaybe<ProductCategoryTranslationWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<ProductCategoryTranslationOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoryTranslationWhereInput>;
};

export type QueryAggregateProductToBundleArgs = {
    cursor?: InputMaybe<ProductToBundleWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProductToBundleOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type QueryAggregateProductToHrtArgs = {
    cursor?: InputMaybe<ProductToHrtWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProductToHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type QueryAggregateProductTranslationArgs = {
    cursor?: InputMaybe<ProductTranslationWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProductTranslationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductTranslationWhereInput>;
};

export type QueryAggregateProductsArgs = {
    cursor?: InputMaybe<ProductsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProductsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductsWhereInput>;
};

export type QueryAggregateProviderArgs = {
    cursor?: InputMaybe<ProviderWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProviderOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderWhereInput>;
};

export type QueryAggregateProviderCredentialingArgs = {
    cursor?: InputMaybe<ProviderCredentialingWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProviderCredentialingOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderCredentialingWhereInput>;
};

export type QueryAggregateProviderGroupArgs = {
    cursor?: InputMaybe<ProviderGroupWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProviderGroupOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type QueryAggregateProviderGroupToHrtArgs = {
    cursor?: InputMaybe<ProviderGroupToHrtWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProviderGroupToHrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type QueryAggregateProviderHrtMaxCountArgs = {
    cursor?: InputMaybe<ProviderHrtMaxCountWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProviderHrtMaxCountOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type QueryAggregateProviderTaxonomyArgs = {
    cursor?: InputMaybe<ProviderTaxonomyWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProviderTaxonomyOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type QueryAggregateProviderToOrgArgs = {
    cursor?: InputMaybe<ProviderToOrgWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ProviderToOrgOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type QueryAggregateProviderToProviderGroupArgs = {
    cursor?: InputMaybe<ProviderToProviderGroupWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<ProviderToProviderGroupOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type QueryAggregateReattributionDirectionArgs = {
    cursor?: InputMaybe<ReattributionDirectionWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ReattributionDirectionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReattributionDirectionWhereInput>;
};

export type QueryAggregateReceiptArrangementArgs = {
    cursor?: InputMaybe<ReceiptArrangementWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ReceiptArrangementOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReceiptArrangementWhereInput>;
};

export type QueryAggregateReservedEhrVisitArgs = {
    cursor?: InputMaybe<ReservedEhrVisitWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ReservedEhrVisitOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReservedEhrVisitWhereInput>;
};

export type QueryAggregateResetTokenArgs = {
    cursor?: InputMaybe<ResetTokenWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ResetTokenOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ResetTokenWhereInput>;
};

export type QueryAggregateSavedIntakeResponseArgs = {
    cursor?: InputMaybe<SavedIntakeResponseWhereUniqueInput>;
    orderBy?: InputMaybe<Array<SavedIntakeResponseOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SavedIntakeResponseWhereInput>;
};

export type QueryAggregateSchedulingSlotConfigArgs = {
    cursor?: InputMaybe<SchedulingSlotConfigWhereUniqueInput>;
    orderBy?: InputMaybe<Array<SchedulingSlotConfigOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SchedulingSlotConfigWhereInput>;
};

export type QueryAggregateServiceTypeCodeArgs = {
    cursor?: InputMaybe<ServiceTypeCodeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ServiceTypeCodeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type QueryAggregateSlotArgs = {
    cursor?: InputMaybe<SlotWhereUniqueInput>;
    orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotWhereInput>;
};

export type QueryAggregateSlotAuditLogArgs = {
    cursor?: InputMaybe<SlotAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<SlotAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotAuditLogWhereInput>;
};

export type QueryAggregateSrtArgs = {
    cursor?: InputMaybe<SrtWhereUniqueInput>;
    orderBy?: InputMaybe<Array<SrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtWhereInput>;
};

export type QueryAggregateSrtFlagsArgs = {
    cursor?: InputMaybe<SrtFlagsWhereUniqueInput>;
    orderBy?: InputMaybe<Array<SrtFlagsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtFlagsWhereInput>;
};

export type QueryAggregateSrtMultiplierRuleArgs = {
    cursor?: InputMaybe<SrtMultiplierRuleWhereUniqueInput>;
    orderBy?: InputMaybe<Array<SrtMultiplierRuleOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtMultiplierRuleWhereInput>;
};

export type QueryAggregateSrtToBillingCodeArgs = {
    cursor?: InputMaybe<SrtToBillingCodeWhereUniqueInput>;
    orderBy?: InputMaybe<Array<SrtToBillingCodeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtToBillingCodeWhereInput>;
};

export type QueryAggregateStatePayerMappingArgs = {
    cursor?: InputMaybe<StatePayerMappingWhereUniqueInput>;
    orderBy?: InputMaybe<Array<StatePayerMappingOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<StatePayerMappingWhereInput>;
};

export type QueryAggregateSuperscriptFeeLineItemArgs = {
    cursor?: InputMaybe<SuperscriptFeeLineItemWhereUniqueInput>;
    orderBy?: InputMaybe<Array<SuperscriptFeeLineItemOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type QueryAggregateSuperscriptFeesArgs = {
    cursor?: InputMaybe<SuperscriptFeesWhereUniqueInput>;
    orderBy?: InputMaybe<Array<SuperscriptFeesOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type QueryAggregateSuperscriptIntakeQuestionArgs = {
    cursor?: InputMaybe<SuperscriptIntakeQuestionWhereUniqueInput>;
    orderBy?: InputMaybe<
        Array<SuperscriptIntakeQuestionOrderByWithRelationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
};

export type QueryAggregateTimeBlockArgs = {
    cursor?: InputMaybe<TimeBlockWhereUniqueInput>;
    orderBy?: InputMaybe<Array<TimeBlockOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TimeBlockWhereInput>;
};

export type QueryAggregateTransactionArgs = {
    cursor?: InputMaybe<TransactionWhereUniqueInput>;
    orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TransactionWhereInput>;
};

export type QueryAggregateUserArgs = {
    cursor?: InputMaybe<UserWhereUniqueInput>;
    orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserWhereInput>;
};

export type QueryAggregateUserAuditLogArgs = {
    cursor?: InputMaybe<UserAuditLogWhereUniqueInput>;
    orderBy?: InputMaybe<Array<UserAuditLogOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserAuditLogWhereInput>;
};

export type QueryAggregateUserPracticeVisitArgs = {
    cursor?: InputMaybe<UserPracticeVisitWhereUniqueInput>;
    orderBy?: InputMaybe<Array<UserPracticeVisitOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserPracticeVisitWhereInput>;
};

export type QueryAggregateUserToNewUserArgs = {
    cursor?: InputMaybe<UserToNewUserWhereUniqueInput>;
    orderBy?: InputMaybe<Array<UserToNewUserOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserToNewUserWhereInput>;
};

export type QueryAggregateValidPayersArgs = {
    cursor?: InputMaybe<ValidPayersWhereUniqueInput>;
    orderBy?: InputMaybe<Array<ValidPayersOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ValidPayersWhereInput>;
};

export type QueryAppointmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AppointmentWhereUniqueInput;
};

export type QueryAppointmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AppointmentAuditLogWhereUniqueInput;
};

export type QueryAppointmentAuditLogsArgs = {
    cursor?: InputMaybe<AppointmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<AppointmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AppointmentAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AppointmentAuditLogWhereInput>;
};

export type QueryAppointmentsArgs = {
    cursor?: InputMaybe<AppointmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<AppointmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AppointmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AppointmentWhereInput>;
};

export type QueryArrearBillingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArrearBillingWhereUniqueInput;
};

export type QueryArrearBillingsArgs = {
    cursor?: InputMaybe<ArrearBillingWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArrearBillingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArrearBillingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArrearBillingWhereInput>;
};

export type QueryArtClaimArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimWhereUniqueInput;
};

export type QueryArtClaimAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimAuditLogWhereUniqueInput;
};

export type QueryArtClaimAuditLogsArgs = {
    cursor?: InputMaybe<ArtClaimAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtClaimAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimAuditLogWhereInput>;
};

export type QueryArtClaimCptLineArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimCptLineWhereUniqueInput;
};

export type QueryArtClaimCptLineAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimCptLineAuditLogWhereUniqueInput;
};

export type QueryArtClaimCptLineAuditLogsArgs = {
    cursor?: InputMaybe<ArtClaimCptLineAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimCptLineAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ArtClaimCptLineAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineAuditLogWhereInput>;
};

export type QueryArtClaimCptLinesArgs = {
    cursor?: InputMaybe<ArtClaimCptLineWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimCptLineScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtClaimCptLineOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineWhereInput>;
};

export type QueryArtClaimsArgs = {
    cursor?: InputMaybe<ArtClaimWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtClaimOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimWhereInput>;
};

export type QueryArtOrgConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtOrgConfigWhereUniqueInput;
};

export type QueryArtOrgConfigsArgs = {
    cursor?: InputMaybe<ArtOrgConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtOrgConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtOrgConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type QueryArtPracticeConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtPracticeConfigWhereUniqueInput;
};

export type QueryArtPracticeConfigsArgs = {
    cursor?: InputMaybe<ArtPracticeConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtPracticeConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtPracticeConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type QueryAthenaPharmaciesArgs = {
    cursor?: InputMaybe<AthenaPharmacyWhereUniqueInput>;
    distinct?: InputMaybe<Array<AthenaPharmacyScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AthenaPharmacyOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaPharmacyWhereInput>;
};

export type QueryAthenaPharmacyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaPharmacyWhereUniqueInput;
};

export type QueryAthenaProviderArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaProviderWhereUniqueInput;
};

export type QueryAthenaProvidersArgs = {
    cursor?: InputMaybe<AthenaProviderWhereUniqueInput>;
    distinct?: InputMaybe<Array<AthenaProviderScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AthenaProviderOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaProviderWhereInput>;
};

export type QueryBillingCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BillingCodeWhereUniqueInput;
};

export type QueryBillingCodesArgs = {
    cursor?: InputMaybe<BillingCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<BillingCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BillingCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BillingCodeWhereInput>;
};

export type QueryBillingTableDownloadRequestArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BillingTableDownloadRequestWhereUniqueInput;
};

export type QueryBillingTableDownloadRequestsArgs = {
    cursor?: InputMaybe<BillingTableDownloadRequestWhereUniqueInput>;
    distinct?: InputMaybe<Array<BillingTableDownloadRequestScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<BillingTableDownloadRequestOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BillingTableDownloadRequestWhereInput>;
};

export type QueryBoughtTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentWhereUniqueInput;
};

export type QueryBoughtTreatmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentAuditLogWhereUniqueInput;
};

export type QueryBoughtTreatmentAuditLogsArgs = {
    cursor?: InputMaybe<BoughtTreatmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<BoughtTreatmentAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentAuditLogWhereInput>;
};

export type QueryBoughtTreatmentClaimDetailArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentClaimDetailWhereUniqueInput;
};

export type QueryBoughtTreatmentClaimDetailsArgs = {
    cursor?: InputMaybe<BoughtTreatmentClaimDetailWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentClaimDetailScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<BoughtTreatmentClaimDetailOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentClaimDetailWhereInput>;
};

export type QueryBoughtTreatmentsArgs = {
    cursor?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BoughtTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type QueryBulkChargeCardRunArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BulkChargeCardRunWhereUniqueInput;
};

export type QueryBulkChargeCardRunItemArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BulkChargeCardRunItemWhereUniqueInput;
};

export type QueryBulkChargeCardRunItemsArgs = {
    cursor?: InputMaybe<BulkChargeCardRunItemWhereUniqueInput>;
    distinct?: InputMaybe<Array<BulkChargeCardRunItemScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BulkChargeCardRunItemOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunItemWhereInput>;
};

export type QueryBulkChargeCardRunsArgs = {
    cursor?: InputMaybe<BulkChargeCardRunWhereUniqueInput>;
    distinct?: InputMaybe<Array<BulkChargeCardRunScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BulkChargeCardRunOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunWhereInput>;
};

export type QueryBundleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BundleWhereUniqueInput;
};

export type QueryBundleToHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BundleToHrtWhereUniqueInput;
};

export type QueryBundleToHrtsArgs = {
    cursor?: InputMaybe<BundleToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<BundleToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BundleToHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type QueryBundlesArgs = {
    cursor?: InputMaybe<BundleWhereUniqueInput>;
    distinct?: InputMaybe<Array<BundleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BundleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleWhereInput>;
};

export type QueryBusinessHourArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BusinessHourWhereUniqueInput;
};

export type QueryBusinessHoursArgs = {
    cursor?: InputMaybe<BusinessHourWhereUniqueInput>;
    distinct?: InputMaybe<Array<BusinessHourScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BusinessHourOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BusinessHourWhereInput>;
};

export type QueryCandidateTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CandidateTreatmentWhereUniqueInput;
};

export type QueryCandidateTreatmentsArgs = {
    cursor?: InputMaybe<CandidateTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<CandidateTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type QueryCardAuthorizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CardAuthorizationWhereUniqueInput;
};

export type QueryCardAuthorizationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CardAuthorizationAuditLogWhereUniqueInput;
};

export type QueryCardAuthorizationAuditLogsArgs = {
    cursor?: InputMaybe<CardAuthorizationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<CardAuthorizationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<CardAuthorizationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CardAuthorizationAuditLogWhereInput>;
};

export type QueryCardAuthorizationsArgs = {
    cursor?: InputMaybe<CardAuthorizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<CardAuthorizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CardAuthorizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CardAuthorizationWhereInput>;
};

export type QueryCashPriceArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CashPriceWhereUniqueInput;
};

export type QueryCashPricesArgs = {
    cursor?: InputMaybe<CashPriceWhereUniqueInput>;
    distinct?: InputMaybe<Array<CashPriceScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CashPriceOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CashPriceWhereInput>;
};

export type QueryChargeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeWhereUniqueInput;
};

export type QueryChargeAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeAuditLogWhereUniqueInput;
};

export type QueryChargeAuditLogsArgs = {
    cursor?: InputMaybe<ChargeAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeAuditLogWhereInput>;
};

export type QueryChargeReattributionAndPartialPaymentLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeReattributionAndPartialPaymentLogWhereUniqueInput;
};

export type QueryChargeReattributionAndPartialPaymentLogsArgs = {
    cursor?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<ChargeReattributionAndPartialPaymentLogScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<ChargeReattributionAndPartialPaymentLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereInput>;
};

export type QueryChargeReattributionLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeReattributionLogWhereUniqueInput;
};

export type QueryChargeReattributionLogsArgs = {
    cursor?: InputMaybe<ChargeReattributionLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeReattributionLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeReattributionLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeReattributionLogWhereInput>;
};

export type QueryChargesArgs = {
    cursor?: InputMaybe<ChargeWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeWhereInput>;
};

export type QueryCheckoutAdjudicationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CheckoutAdjudicationWhereUniqueInput;
};

export type QueryCheckoutAdjudicationsArgs = {
    cursor?: InputMaybe<CheckoutAdjudicationWhereUniqueInput>;
    distinct?: InputMaybe<Array<CheckoutAdjudicationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CheckoutAdjudicationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CheckoutAdjudicationWhereInput>;
};

export type QueryClaimToBoughtTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ClaimToBoughtTreatmentWhereUniqueInput;
};

export type QueryClaimToBoughtTreatmentsArgs = {
    cursor?: InputMaybe<ClaimToBoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<ClaimToBoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ClaimToBoughtTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ClaimToBoughtTreatmentWhereInput>;
};

export type QueryConfigCommitArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigCommitWhereUniqueInput;
};

export type QueryConfigCommitsArgs = {
    cursor?: InputMaybe<ConfigCommitWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigCommitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigCommitOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type QueryConfigFlagArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigFlagWhereUniqueInput;
};

export type QueryConfigFlagsArgs = {
    cursor?: InputMaybe<ConfigFlagWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigFlagScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigFlagOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigFlagWhereInput>;
};

export type QueryConfigSessionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigSessionWhereUniqueInput;
};

export type QueryConfigSessionsArgs = {
    cursor?: InputMaybe<ConfigSessionWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigSessionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigSessionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigSessionWhereInput>;
};

export type QueryConsentFormArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsentFormWhereUniqueInput;
};

export type QueryConsentFormsArgs = {
    cursor?: InputMaybe<ConsentFormWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsentFormScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsentFormOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsentFormWhereInput>;
};

export type QueryConsumerArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerWhereUniqueInput;
};

export type QueryConsumerAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerAuditLogWhereUniqueInput;
};

export type QueryConsumerAuditLogsArgs = {
    cursor?: InputMaybe<ConsumerAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerAuditLogWhereInput>;
};

export type QueryConsumerMessageArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerMessageWhereUniqueInput;
};

export type QueryConsumerMessagesArgs = {
    cursor?: InputMaybe<ConsumerMessageWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerMessageScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerMessageOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type QueryConsumerNoteArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerNoteWhereUniqueInput;
};

export type QueryConsumerNotesArgs = {
    cursor?: InputMaybe<ConsumerNoteWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerNoteScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerNoteOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type QueryConsumersArgs = {
    cursor?: InputMaybe<ConsumerWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type QueryContractArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ContractWhereUniqueInput;
};

export type QueryContractAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ContractAuditLogWhereUniqueInput;
};

export type QueryContractAuditLogsArgs = {
    cursor?: InputMaybe<ContractAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ContractAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ContractAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractAuditLogWhereInput>;
};

export type QueryContractsArgs = {
    cursor?: InputMaybe<ContractWhereUniqueInput>;
    distinct?: InputMaybe<Array<ContractScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ContractOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractWhereInput>;
};

export type QueryCptExclusivityEdgeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CptExclusivityEdgeWhereUniqueInput;
};

export type QueryCptExclusivityEdgesArgs = {
    cursor?: InputMaybe<CptExclusivityEdgeWhereUniqueInput>;
    distinct?: InputMaybe<Array<CptExclusivityEdgeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CptExclusivityEdgeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CptExclusivityEdgeWhereInput>;
};

export type QueryCustomFieldArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CustomFieldWhereUniqueInput;
};

export type QueryCustomFieldValueArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CustomFieldValueWhereUniqueInput;
};

export type QueryCustomFieldValuesArgs = {
    cursor?: InputMaybe<CustomFieldValueWhereUniqueInput>;
    distinct?: InputMaybe<Array<CustomFieldValueScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CustomFieldValueOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type QueryCustomFieldsArgs = {
    cursor?: InputMaybe<CustomFieldWhereUniqueInput>;
    distinct?: InputMaybe<Array<CustomFieldScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CustomFieldOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type QueryDefaultPracticeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DefaultPracticeWhereUniqueInput;
};

export type QueryDefaultPracticesArgs = {
    cursor?: InputMaybe<DefaultPracticeWhereUniqueInput>;
    distinct?: InputMaybe<Array<DefaultPracticeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DefaultPracticeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type QueryDeploymentOrgPhaseArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type QueryDeploymentOrgPhasesArgs = {
    cursor?: InputMaybe<DeploymentOrgPhaseWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgPhaseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgPhaseOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type QueryDeploymentOrgTaskArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type QueryDeploymentOrgTaskDependenciesArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskDependencyWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskDependencyScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<DeploymentOrgTaskDependencyOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type QueryDeploymentOrgTaskDependencyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgTaskDependencyWhereUniqueInput;
};

export type QueryDeploymentOrgTasksArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgTaskOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type QueryDeploymentPhaseArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentPhaseWhereUniqueInput;
};

export type QueryDeploymentPhasesArgs = {
    cursor?: InputMaybe<DeploymentPhaseWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentPhaseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentPhaseOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type QueryDeploymentTaskArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTaskWhereUniqueInput;
};

export type QueryDeploymentTaskDependenciesArgs = {
    cursor?: InputMaybe<DeploymentTaskDependencyWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTaskDependencyScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<DeploymentTaskDependencyOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type QueryDeploymentTaskDependencyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTaskDependencyWhereUniqueInput;
};

export type QueryDeploymentTasksArgs = {
    cursor?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentTaskOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type QueryDeploymentTeamArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTeamWhereUniqueInput;
};

export type QueryDeploymentTeamsArgs = {
    cursor?: InputMaybe<DeploymentTeamWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTeamScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentTeamOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTeamWhereInput>;
};

export type QueryDetailBoughtTreatmentsArgs = {
    cursor?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BoughtTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type QueryDetailSlotsArgs = {
    cursor?: InputMaybe<SlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
    orgId: Scalars['Int']['input'];
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotWhereInput>;
};

export type QueryEcwPayerAliasArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EcwPayerAliasWhereUniqueInput;
};

export type QueryEcwPayerAliasesArgs = {
    cursor?: InputMaybe<EcwPayerAliasWhereUniqueInput>;
    distinct?: InputMaybe<Array<EcwPayerAliasScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EcwPayerAliasOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerAliasWhereInput>;
};

export type QueryEcwPayerStcArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EcwPayerStcWhereUniqueInput;
};

export type QueryEcwPayerStcsArgs = {
    cursor?: InputMaybe<EcwPayerStcWhereUniqueInput>;
    distinct?: InputMaybe<Array<EcwPayerStcScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EcwPayerStcOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerStcWhereInput>;
};

export type QueryEhrAppointmentTypeIdToNameArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrAppointmentTypeIdToNameWhereUniqueInput;
};

export type QueryEhrAppointmentTypeIdToNamesArgs = {
    cursor?: InputMaybe<EhrAppointmentTypeIdToNameWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrAppointmentTypeIdToNameScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<EhrAppointmentTypeIdToNameOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrAppointmentTypeIdToNameWhereInput>;
};

export type QueryEhrPaymentDescriptorArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDescriptorWhereUniqueInput;
};

export type QueryEhrPaymentDescriptorAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDescriptorAuditLogWhereUniqueInput;
};

export type QueryEhrPaymentDescriptorAuditLogsArgs = {
    cursor?: InputMaybe<EhrPaymentDescriptorAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPaymentDescriptorAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDescriptorAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDescriptorAuditLogWhereInput>;
};

export type QueryEhrPaymentDescriptorsArgs = {
    cursor?: InputMaybe<EhrPaymentDescriptorWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPaymentDescriptorScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPaymentDescriptorOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDescriptorWhereInput>;
};

export type QueryEhrPaymentDirectionSsAssetArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDirectionSsAssetWhereUniqueInput;
};

export type QueryEhrPaymentDirectionSsAssetsArgs = {
    cursor?: InputMaybe<EhrPaymentDirectionSsAssetWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPaymentDirectionSsAssetScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDirectionSsAssetOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDirectionSsAssetWhereInput>;
};

export type QueryEhrPostDetailArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostDetailWhereUniqueInput;
};

export type QueryEhrPostDetailToPayoutArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostDetailToPayoutWhereUniqueInput;
};

export type QueryEhrPostDetailToPayoutsArgs = {
    cursor?: InputMaybe<EhrPostDetailToPayoutWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostDetailToPayoutScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostDetailToPayoutOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostDetailToPayoutWhereInput>;
};

export type QueryEhrPostDetailsArgs = {
    cursor?: InputMaybe<EhrPostDetailWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostDetailScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostDetailOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostDetailWhereInput>;
};

export type QueryEhrPostLedgerArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerWhereUniqueInput;
};

export type QueryEhrPostLedgerAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerAuditLogWhereUniqueInput;
};

export type QueryEhrPostLedgerAuditLogsArgs = {
    cursor?: InputMaybe<EhrPostLedgerAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostLedgerAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostLedgerAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerAuditLogWhereInput>;
};

export type QueryEhrPostLedgerToPayoutArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerToPayoutWhereUniqueInput;
};

export type QueryEhrPostLedgerToPayoutsArgs = {
    cursor?: InputMaybe<EhrPostLedgerToPayoutWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostLedgerToPayoutScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostLedgerToPayoutOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerToPayoutWhereInput>;
};

export type QueryEhrPostLedgersArgs = {
    cursor?: InputMaybe<EhrPostLedgerWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostLedgerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostLedgerOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerWhereInput>;
};

export type QueryEhrPrimaryCareProviderArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPrimaryCareProviderWhereUniqueInput;
};

export type QueryEhrPrimaryCareProvidersArgs = {
    cursor?: InputMaybe<EhrPrimaryCareProviderWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPrimaryCareProviderScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPrimaryCareProviderOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPrimaryCareProviderWhereInput>;
};

export type QueryEhrProviderMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrProviderMappingWhereUniqueInput;
};

export type QueryEhrProviderMappingsArgs = {
    cursor?: InputMaybe<EhrProviderMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrProviderMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrProviderMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrProviderMappingWhereInput>;
};

export type QueryEhrSlotArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrSlotWhereUniqueInput;
};

export type QueryEhrSlotAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrSlotAuditLogWhereUniqueInput;
};

export type QueryEhrSlotAuditLogsArgs = {
    cursor?: InputMaybe<EhrSlotAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrSlotAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrSlotAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrSlotAuditLogWhereInput>;
};

export type QueryEhrSlotsArgs = {
    cursor?: InputMaybe<EhrSlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrSlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrSlotOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type QueryEncounterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EncounterWhereUniqueInput;
};

export type QueryEncountersArgs = {
    cursor?: InputMaybe<EncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<EncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EncounterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EncounterWhereInput>;
};

export type QueryExperityEncounterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ExperityEncounterWhereUniqueInput;
};

export type QueryExperityEncountersArgs = {
    cursor?: InputMaybe<ExperityEncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<ExperityEncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ExperityEncounterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ExperityEncounterWhereInput>;
};

export type QueryFeeConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FeeConfigWhereUniqueInput;
};

export type QueryFeeConfigAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FeeConfigAuditLogWhereUniqueInput;
};

export type QueryFeeConfigAuditLogsArgs = {
    cursor?: InputMaybe<FeeConfigAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<FeeConfigAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<FeeConfigAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FeeConfigAuditLogWhereInput>;
};

export type QueryFeeConfigsArgs = {
    cursor?: InputMaybe<FeeConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<FeeConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<FeeConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FeeConfigWhereInput>;
};

export type QueryFindFirstAleConfigArgs = {
    cursor?: InputMaybe<AleConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<AleConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AleConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleConfigWhereInput>;
};

export type QueryFindFirstAleConfigOrThrowArgs = {
    cursor?: InputMaybe<AleConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<AleConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AleConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleConfigWhereInput>;
};

export type QueryFindFirstAleDepartmentGoLiveArgs = {
    cursor?: InputMaybe<AleDepartmentGoLiveWhereUniqueInput>;
    distinct?: InputMaybe<Array<AleDepartmentGoLiveScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AleDepartmentGoLiveOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleDepartmentGoLiveWhereInput>;
};

export type QueryFindFirstAleDepartmentGoLiveOrThrowArgs = {
    cursor?: InputMaybe<AleDepartmentGoLiveWhereUniqueInput>;
    distinct?: InputMaybe<Array<AleDepartmentGoLiveScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AleDepartmentGoLiveOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleDepartmentGoLiveWhereInput>;
};

export type QueryFindFirstAdjudicationArgs = {
    cursor?: InputMaybe<AdjudicationWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjudicationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjudicationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjudicationWhereInput>;
};

export type QueryFindFirstAdjudicationAuditLogArgs = {
    cursor?: InputMaybe<AdjudicationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjudicationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjudicationAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjudicationAuditLogWhereInput>;
};

export type QueryFindFirstAdjudicationAuditLogOrThrowArgs = {
    cursor?: InputMaybe<AdjudicationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjudicationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjudicationAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjudicationAuditLogWhereInput>;
};

export type QueryFindFirstAdjudicationOrThrowArgs = {
    cursor?: InputMaybe<AdjudicationWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjudicationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjudicationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjudicationWhereInput>;
};

export type QueryFindFirstAdjustmentArgs = {
    cursor?: InputMaybe<AdjustmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjustmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjustmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjustmentWhereInput>;
};

export type QueryFindFirstAdjustmentAuditLogArgs = {
    cursor?: InputMaybe<AdjustmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjustmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjustmentAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjustmentAuditLogWhereInput>;
};

export type QueryFindFirstAdjustmentAuditLogOrThrowArgs = {
    cursor?: InputMaybe<AdjustmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjustmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjustmentAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjustmentAuditLogWhereInput>;
};

export type QueryFindFirstAdjustmentOrThrowArgs = {
    cursor?: InputMaybe<AdjustmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdjustmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdjustmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjustmentWhereInput>;
};

export type QueryFindFirstAdminArgs = {
    cursor?: InputMaybe<AdminWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdminScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdminOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminWhereInput>;
};

export type QueryFindFirstAdminInteractionArgs = {
    cursor?: InputMaybe<AdminInteractionWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdminInteractionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdminInteractionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminInteractionWhereInput>;
};

export type QueryFindFirstAdminInteractionOrThrowArgs = {
    cursor?: InputMaybe<AdminInteractionWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdminInteractionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdminInteractionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminInteractionWhereInput>;
};

export type QueryFindFirstAdminOrThrowArgs = {
    cursor?: InputMaybe<AdminWhereUniqueInput>;
    distinct?: InputMaybe<Array<AdminScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AdminOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminWhereInput>;
};

export type QueryFindFirstAppointmentArgs = {
    cursor?: InputMaybe<AppointmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<AppointmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AppointmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AppointmentWhereInput>;
};

export type QueryFindFirstAppointmentAuditLogArgs = {
    cursor?: InputMaybe<AppointmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<AppointmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AppointmentAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AppointmentAuditLogWhereInput>;
};

export type QueryFindFirstAppointmentAuditLogOrThrowArgs = {
    cursor?: InputMaybe<AppointmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<AppointmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AppointmentAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AppointmentAuditLogWhereInput>;
};

export type QueryFindFirstAppointmentOrThrowArgs = {
    cursor?: InputMaybe<AppointmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<AppointmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AppointmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AppointmentWhereInput>;
};

export type QueryFindFirstArrearBillingArgs = {
    cursor?: InputMaybe<ArrearBillingWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArrearBillingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArrearBillingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArrearBillingWhereInput>;
};

export type QueryFindFirstArrearBillingOrThrowArgs = {
    cursor?: InputMaybe<ArrearBillingWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArrearBillingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArrearBillingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArrearBillingWhereInput>;
};

export type QueryFindFirstArtClaimArgs = {
    cursor?: InputMaybe<ArtClaimWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtClaimOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimWhereInput>;
};

export type QueryFindFirstArtClaimAuditLogArgs = {
    cursor?: InputMaybe<ArtClaimAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtClaimAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimAuditLogWhereInput>;
};

export type QueryFindFirstArtClaimAuditLogOrThrowArgs = {
    cursor?: InputMaybe<ArtClaimAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtClaimAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimAuditLogWhereInput>;
};

export type QueryFindFirstArtClaimCptLineArgs = {
    cursor?: InputMaybe<ArtClaimCptLineWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimCptLineScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtClaimCptLineOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineWhereInput>;
};

export type QueryFindFirstArtClaimCptLineAuditLogArgs = {
    cursor?: InputMaybe<ArtClaimCptLineAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimCptLineAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ArtClaimCptLineAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineAuditLogWhereInput>;
};

export type QueryFindFirstArtClaimCptLineAuditLogOrThrowArgs = {
    cursor?: InputMaybe<ArtClaimCptLineAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimCptLineAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ArtClaimCptLineAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineAuditLogWhereInput>;
};

export type QueryFindFirstArtClaimCptLineOrThrowArgs = {
    cursor?: InputMaybe<ArtClaimCptLineWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimCptLineScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtClaimCptLineOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineWhereInput>;
};

export type QueryFindFirstArtClaimOrThrowArgs = {
    cursor?: InputMaybe<ArtClaimWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtClaimScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtClaimOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimWhereInput>;
};

export type QueryFindFirstArtOrgConfigArgs = {
    cursor?: InputMaybe<ArtOrgConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtOrgConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtOrgConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type QueryFindFirstArtOrgConfigOrThrowArgs = {
    cursor?: InputMaybe<ArtOrgConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtOrgConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtOrgConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type QueryFindFirstArtPracticeConfigArgs = {
    cursor?: InputMaybe<ArtPracticeConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtPracticeConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtPracticeConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type QueryFindFirstArtPracticeConfigOrThrowArgs = {
    cursor?: InputMaybe<ArtPracticeConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<ArtPracticeConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ArtPracticeConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type QueryFindFirstAthenaMedicationsArgs = {
    cursor?: InputMaybe<AthenaMedicationsWhereUniqueInput>;
    distinct?: InputMaybe<Array<AthenaMedicationsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AthenaMedicationsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaMedicationsWhereInput>;
};

export type QueryFindFirstAthenaMedicationsOrThrowArgs = {
    cursor?: InputMaybe<AthenaMedicationsWhereUniqueInput>;
    distinct?: InputMaybe<Array<AthenaMedicationsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AthenaMedicationsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaMedicationsWhereInput>;
};

export type QueryFindFirstAthenaPharmacyArgs = {
    cursor?: InputMaybe<AthenaPharmacyWhereUniqueInput>;
    distinct?: InputMaybe<Array<AthenaPharmacyScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AthenaPharmacyOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaPharmacyWhereInput>;
};

export type QueryFindFirstAthenaPharmacyOrThrowArgs = {
    cursor?: InputMaybe<AthenaPharmacyWhereUniqueInput>;
    distinct?: InputMaybe<Array<AthenaPharmacyScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AthenaPharmacyOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaPharmacyWhereInput>;
};

export type QueryFindFirstAthenaProviderArgs = {
    cursor?: InputMaybe<AthenaProviderWhereUniqueInput>;
    distinct?: InputMaybe<Array<AthenaProviderScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AthenaProviderOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaProviderWhereInput>;
};

export type QueryFindFirstAthenaProviderOrThrowArgs = {
    cursor?: InputMaybe<AthenaProviderWhereUniqueInput>;
    distinct?: InputMaybe<Array<AthenaProviderScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AthenaProviderOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaProviderWhereInput>;
};

export type QueryFindFirstBenefitParsingRulesArgs = {
    cursor?: InputMaybe<BenefitParsingRulesWhereUniqueInput>;
    distinct?: InputMaybe<Array<BenefitParsingRulesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BenefitParsingRulesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BenefitParsingRulesWhereInput>;
};

export type QueryFindFirstBenefitParsingRulesOrThrowArgs = {
    cursor?: InputMaybe<BenefitParsingRulesWhereUniqueInput>;
    distinct?: InputMaybe<Array<BenefitParsingRulesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BenefitParsingRulesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BenefitParsingRulesWhereInput>;
};

export type QueryFindFirstBillingCodeArgs = {
    cursor?: InputMaybe<BillingCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<BillingCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BillingCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BillingCodeWhereInput>;
};

export type QueryFindFirstBillingCodeOrThrowArgs = {
    cursor?: InputMaybe<BillingCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<BillingCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BillingCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BillingCodeWhereInput>;
};

export type QueryFindFirstBillingTableDownloadRequestArgs = {
    cursor?: InputMaybe<BillingTableDownloadRequestWhereUniqueInput>;
    distinct?: InputMaybe<Array<BillingTableDownloadRequestScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<BillingTableDownloadRequestOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BillingTableDownloadRequestWhereInput>;
};

export type QueryFindFirstBillingTableDownloadRequestOrThrowArgs = {
    cursor?: InputMaybe<BillingTableDownloadRequestWhereUniqueInput>;
    distinct?: InputMaybe<Array<BillingTableDownloadRequestScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<BillingTableDownloadRequestOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BillingTableDownloadRequestWhereInput>;
};

export type QueryFindFirstBoughtTreatmentArgs = {
    cursor?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BoughtTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type QueryFindFirstBoughtTreatmentAuditLogArgs = {
    cursor?: InputMaybe<BoughtTreatmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<BoughtTreatmentAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentAuditLogWhereInput>;
};

export type QueryFindFirstBoughtTreatmentAuditLogOrThrowArgs = {
    cursor?: InputMaybe<BoughtTreatmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<BoughtTreatmentAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentAuditLogWhereInput>;
};

export type QueryFindFirstBoughtTreatmentClaimDetailArgs = {
    cursor?: InputMaybe<BoughtTreatmentClaimDetailWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentClaimDetailScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<BoughtTreatmentClaimDetailOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentClaimDetailWhereInput>;
};

export type QueryFindFirstBoughtTreatmentClaimDetailOrThrowArgs = {
    cursor?: InputMaybe<BoughtTreatmentClaimDetailWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentClaimDetailScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<BoughtTreatmentClaimDetailOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentClaimDetailWhereInput>;
};

export type QueryFindFirstBoughtTreatmentOrThrowArgs = {
    cursor?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BoughtTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type QueryFindFirstBulkChargeCardRunArgs = {
    cursor?: InputMaybe<BulkChargeCardRunWhereUniqueInput>;
    distinct?: InputMaybe<Array<BulkChargeCardRunScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BulkChargeCardRunOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunWhereInput>;
};

export type QueryFindFirstBulkChargeCardRunItemArgs = {
    cursor?: InputMaybe<BulkChargeCardRunItemWhereUniqueInput>;
    distinct?: InputMaybe<Array<BulkChargeCardRunItemScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BulkChargeCardRunItemOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunItemWhereInput>;
};

export type QueryFindFirstBulkChargeCardRunItemOrThrowArgs = {
    cursor?: InputMaybe<BulkChargeCardRunItemWhereUniqueInput>;
    distinct?: InputMaybe<Array<BulkChargeCardRunItemScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BulkChargeCardRunItemOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunItemWhereInput>;
};

export type QueryFindFirstBulkChargeCardRunOrThrowArgs = {
    cursor?: InputMaybe<BulkChargeCardRunWhereUniqueInput>;
    distinct?: InputMaybe<Array<BulkChargeCardRunScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BulkChargeCardRunOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunWhereInput>;
};

export type QueryFindFirstBundleArgs = {
    cursor?: InputMaybe<BundleWhereUniqueInput>;
    distinct?: InputMaybe<Array<BundleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BundleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleWhereInput>;
};

export type QueryFindFirstBundleOrThrowArgs = {
    cursor?: InputMaybe<BundleWhereUniqueInput>;
    distinct?: InputMaybe<Array<BundleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BundleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleWhereInput>;
};

export type QueryFindFirstBundleToHrtArgs = {
    cursor?: InputMaybe<BundleToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<BundleToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BundleToHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type QueryFindFirstBundleToHrtOrThrowArgs = {
    cursor?: InputMaybe<BundleToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<BundleToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BundleToHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type QueryFindFirstBusinessHourArgs = {
    cursor?: InputMaybe<BusinessHourWhereUniqueInput>;
    distinct?: InputMaybe<Array<BusinessHourScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BusinessHourOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BusinessHourWhereInput>;
};

export type QueryFindFirstBusinessHourOrThrowArgs = {
    cursor?: InputMaybe<BusinessHourWhereUniqueInput>;
    distinct?: InputMaybe<Array<BusinessHourScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BusinessHourOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BusinessHourWhereInput>;
};

export type QueryFindFirstCandidateTreatmentArgs = {
    cursor?: InputMaybe<CandidateTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<CandidateTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type QueryFindFirstCandidateTreatmentOrThrowArgs = {
    cursor?: InputMaybe<CandidateTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<CandidateTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type QueryFindFirstCardAuthorizationArgs = {
    cursor?: InputMaybe<CardAuthorizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<CardAuthorizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CardAuthorizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CardAuthorizationWhereInput>;
};

export type QueryFindFirstCardAuthorizationAuditLogArgs = {
    cursor?: InputMaybe<CardAuthorizationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<CardAuthorizationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<CardAuthorizationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CardAuthorizationAuditLogWhereInput>;
};

export type QueryFindFirstCardAuthorizationAuditLogOrThrowArgs = {
    cursor?: InputMaybe<CardAuthorizationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<CardAuthorizationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<CardAuthorizationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CardAuthorizationAuditLogWhereInput>;
};

export type QueryFindFirstCardAuthorizationOrThrowArgs = {
    cursor?: InputMaybe<CardAuthorizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<CardAuthorizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CardAuthorizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CardAuthorizationWhereInput>;
};

export type QueryFindFirstCashPriceArgs = {
    cursor?: InputMaybe<CashPriceWhereUniqueInput>;
    distinct?: InputMaybe<Array<CashPriceScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CashPriceOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CashPriceWhereInput>;
};

export type QueryFindFirstCashPriceOrThrowArgs = {
    cursor?: InputMaybe<CashPriceWhereUniqueInput>;
    distinct?: InputMaybe<Array<CashPriceScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CashPriceOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CashPriceWhereInput>;
};

export type QueryFindFirstChargeArgs = {
    cursor?: InputMaybe<ChargeWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeWhereInput>;
};

export type QueryFindFirstChargeAuditLogArgs = {
    cursor?: InputMaybe<ChargeAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeAuditLogWhereInput>;
};

export type QueryFindFirstChargeAuditLogOrThrowArgs = {
    cursor?: InputMaybe<ChargeAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeAuditLogWhereInput>;
};

export type QueryFindFirstChargeOrThrowArgs = {
    cursor?: InputMaybe<ChargeWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeWhereInput>;
};

export type QueryFindFirstChargeReattributionAndPartialPaymentLogArgs = {
    cursor?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<ChargeReattributionAndPartialPaymentLogScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<ChargeReattributionAndPartialPaymentLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereInput>;
};

export type QueryFindFirstChargeReattributionAndPartialPaymentLogOrThrowArgs = {
    cursor?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<ChargeReattributionAndPartialPaymentLogScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<ChargeReattributionAndPartialPaymentLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereInput>;
};

export type QueryFindFirstChargeReattributionLogArgs = {
    cursor?: InputMaybe<ChargeReattributionLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeReattributionLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeReattributionLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeReattributionLogWhereInput>;
};

export type QueryFindFirstChargeReattributionLogOrThrowArgs = {
    cursor?: InputMaybe<ChargeReattributionLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeReattributionLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeReattributionLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeReattributionLogWhereInput>;
};

export type QueryFindFirstCheckNetworkStatusResultsArgs = {
    cursor?: InputMaybe<CheckNetworkStatusResultsWhereUniqueInput>;
    distinct?: InputMaybe<Array<CheckNetworkStatusResultsScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<CheckNetworkStatusResultsOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CheckNetworkStatusResultsWhereInput>;
};

export type QueryFindFirstCheckNetworkStatusResultsOrThrowArgs = {
    cursor?: InputMaybe<CheckNetworkStatusResultsWhereUniqueInput>;
    distinct?: InputMaybe<Array<CheckNetworkStatusResultsScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<CheckNetworkStatusResultsOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CheckNetworkStatusResultsWhereInput>;
};

export type QueryFindFirstCheckoutAdjudicationArgs = {
    cursor?: InputMaybe<CheckoutAdjudicationWhereUniqueInput>;
    distinct?: InputMaybe<Array<CheckoutAdjudicationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CheckoutAdjudicationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CheckoutAdjudicationWhereInput>;
};

export type QueryFindFirstCheckoutAdjudicationOrThrowArgs = {
    cursor?: InputMaybe<CheckoutAdjudicationWhereUniqueInput>;
    distinct?: InputMaybe<Array<CheckoutAdjudicationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CheckoutAdjudicationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CheckoutAdjudicationWhereInput>;
};

export type QueryFindFirstClaimToBoughtTreatmentArgs = {
    cursor?: InputMaybe<ClaimToBoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<ClaimToBoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ClaimToBoughtTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ClaimToBoughtTreatmentWhereInput>;
};

export type QueryFindFirstClaimToBoughtTreatmentOrThrowArgs = {
    cursor?: InputMaybe<ClaimToBoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<ClaimToBoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ClaimToBoughtTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ClaimToBoughtTreatmentWhereInput>;
};

export type QueryFindFirstConfigCommitArgs = {
    cursor?: InputMaybe<ConfigCommitWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigCommitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigCommitOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type QueryFindFirstConfigCommitOrThrowArgs = {
    cursor?: InputMaybe<ConfigCommitWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigCommitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigCommitOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type QueryFindFirstConfigFlagArgs = {
    cursor?: InputMaybe<ConfigFlagWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigFlagScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigFlagOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigFlagWhereInput>;
};

export type QueryFindFirstConfigFlagOrThrowArgs = {
    cursor?: InputMaybe<ConfigFlagWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigFlagScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigFlagOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigFlagWhereInput>;
};

export type QueryFindFirstConfigSessionArgs = {
    cursor?: InputMaybe<ConfigSessionWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigSessionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigSessionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigSessionWhereInput>;
};

export type QueryFindFirstConfigSessionOrThrowArgs = {
    cursor?: InputMaybe<ConfigSessionWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConfigSessionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConfigSessionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigSessionWhereInput>;
};

export type QueryFindFirstConsentFormArgs = {
    cursor?: InputMaybe<ConsentFormWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsentFormScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsentFormOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsentFormWhereInput>;
};

export type QueryFindFirstConsentFormOrThrowArgs = {
    cursor?: InputMaybe<ConsentFormWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsentFormScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsentFormOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsentFormWhereInput>;
};

export type QueryFindFirstConsumerArgs = {
    cursor?: InputMaybe<ConsumerWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type QueryFindFirstConsumerAuditLogArgs = {
    cursor?: InputMaybe<ConsumerAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerAuditLogWhereInput>;
};

export type QueryFindFirstConsumerAuditLogOrThrowArgs = {
    cursor?: InputMaybe<ConsumerAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerAuditLogWhereInput>;
};

export type QueryFindFirstConsumerMessageArgs = {
    cursor?: InputMaybe<ConsumerMessageWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerMessageScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerMessageOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type QueryFindFirstConsumerMessageOrThrowArgs = {
    cursor?: InputMaybe<ConsumerMessageWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerMessageScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerMessageOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type QueryFindFirstConsumerNoteArgs = {
    cursor?: InputMaybe<ConsumerNoteWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerNoteScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerNoteOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type QueryFindFirstConsumerNoteOrThrowArgs = {
    cursor?: InputMaybe<ConsumerNoteWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerNoteScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerNoteOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type QueryFindFirstConsumerOrThrowArgs = {
    cursor?: InputMaybe<ConsumerWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type QueryFindFirstConsumerPhotoMetaDataArgs = {
    cursor?: InputMaybe<ConsumerPhotoMetaDataWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerPhotoMetaDataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerPhotoMetaDataOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type QueryFindFirstConsumerPhotoMetaDataOrThrowArgs = {
    cursor?: InputMaybe<ConsumerPhotoMetaDataWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerPhotoMetaDataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerPhotoMetaDataOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type QueryFindFirstConsumerSrtRecordsArgs = {
    cursor?: InputMaybe<ConsumerSrtRecordsWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerSrtRecordsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerSrtRecordsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerSrtRecordsWhereInput>;
};

export type QueryFindFirstConsumerSrtRecordsOrThrowArgs = {
    cursor?: InputMaybe<ConsumerSrtRecordsWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerSrtRecordsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerSrtRecordsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerSrtRecordsWhereInput>;
};

export type QueryFindFirstContractArgs = {
    cursor?: InputMaybe<ContractWhereUniqueInput>;
    distinct?: InputMaybe<Array<ContractScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ContractOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractWhereInput>;
};

export type QueryFindFirstContractAuditLogArgs = {
    cursor?: InputMaybe<ContractAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ContractAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ContractAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractAuditLogWhereInput>;
};

export type QueryFindFirstContractAuditLogOrThrowArgs = {
    cursor?: InputMaybe<ContractAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<ContractAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ContractAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractAuditLogWhereInput>;
};

export type QueryFindFirstContractOrThrowArgs = {
    cursor?: InputMaybe<ContractWhereUniqueInput>;
    distinct?: InputMaybe<Array<ContractScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ContractOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractWhereInput>;
};

export type QueryFindFirstCoverageResponsesArgs = {
    cursor?: InputMaybe<CoverageResponsesWhereUniqueInput>;
    distinct?: InputMaybe<Array<CoverageResponsesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CoverageResponsesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CoverageResponsesWhereInput>;
};

export type QueryFindFirstCoverageResponsesOrThrowArgs = {
    cursor?: InputMaybe<CoverageResponsesWhereUniqueInput>;
    distinct?: InputMaybe<Array<CoverageResponsesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CoverageResponsesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CoverageResponsesWhereInput>;
};

export type QueryFindFirstCptExclusivityEdgeArgs = {
    cursor?: InputMaybe<CptExclusivityEdgeWhereUniqueInput>;
    distinct?: InputMaybe<Array<CptExclusivityEdgeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CptExclusivityEdgeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CptExclusivityEdgeWhereInput>;
};

export type QueryFindFirstCptExclusivityEdgeOrThrowArgs = {
    cursor?: InputMaybe<CptExclusivityEdgeWhereUniqueInput>;
    distinct?: InputMaybe<Array<CptExclusivityEdgeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CptExclusivityEdgeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CptExclusivityEdgeWhereInput>;
};

export type QueryFindFirstCustomFieldArgs = {
    cursor?: InputMaybe<CustomFieldWhereUniqueInput>;
    distinct?: InputMaybe<Array<CustomFieldScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CustomFieldOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type QueryFindFirstCustomFieldOrThrowArgs = {
    cursor?: InputMaybe<CustomFieldWhereUniqueInput>;
    distinct?: InputMaybe<Array<CustomFieldScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CustomFieldOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type QueryFindFirstCustomFieldValueArgs = {
    cursor?: InputMaybe<CustomFieldValueWhereUniqueInput>;
    distinct?: InputMaybe<Array<CustomFieldValueScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CustomFieldValueOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type QueryFindFirstCustomFieldValueOrThrowArgs = {
    cursor?: InputMaybe<CustomFieldValueWhereUniqueInput>;
    distinct?: InputMaybe<Array<CustomFieldValueScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CustomFieldValueOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type QueryFindFirstDataMigrationsArgs = {
    cursor?: InputMaybe<DataMigrationsWhereUniqueInput>;
    distinct?: InputMaybe<Array<DataMigrationsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DataMigrationsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DataMigrationsWhereInput>;
};

export type QueryFindFirstDataMigrationsOrThrowArgs = {
    cursor?: InputMaybe<DataMigrationsWhereUniqueInput>;
    distinct?: InputMaybe<Array<DataMigrationsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DataMigrationsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DataMigrationsWhereInput>;
};

export type QueryFindFirstDefaultPracticeArgs = {
    cursor?: InputMaybe<DefaultPracticeWhereUniqueInput>;
    distinct?: InputMaybe<Array<DefaultPracticeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DefaultPracticeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type QueryFindFirstDefaultPracticeOrThrowArgs = {
    cursor?: InputMaybe<DefaultPracticeWhereUniqueInput>;
    distinct?: InputMaybe<Array<DefaultPracticeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DefaultPracticeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type QueryFindFirstDefaultProvidersArgs = {
    cursor?: InputMaybe<DefaultProvidersWhereUniqueInput>;
    distinct?: InputMaybe<Array<DefaultProvidersScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DefaultProvidersOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultProvidersWhereInput>;
};

export type QueryFindFirstDefaultProvidersOrThrowArgs = {
    cursor?: InputMaybe<DefaultProvidersWhereUniqueInput>;
    distinct?: InputMaybe<Array<DefaultProvidersScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DefaultProvidersOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultProvidersWhereInput>;
};

export type QueryFindFirstDeploymentOrgPhaseArgs = {
    cursor?: InputMaybe<DeploymentOrgPhaseWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgPhaseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgPhaseOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type QueryFindFirstDeploymentOrgPhaseOrThrowArgs = {
    cursor?: InputMaybe<DeploymentOrgPhaseWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgPhaseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgPhaseOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type QueryFindFirstDeploymentOrgTaskArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgTaskOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type QueryFindFirstDeploymentOrgTaskDependencyArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskDependencyWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskDependencyScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<DeploymentOrgTaskDependencyOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type QueryFindFirstDeploymentOrgTaskDependencyOrThrowArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskDependencyWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskDependencyScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<DeploymentOrgTaskDependencyOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type QueryFindFirstDeploymentOrgTaskOrThrowArgs = {
    cursor?: InputMaybe<DeploymentOrgTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentOrgTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentOrgTaskOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type QueryFindFirstDeploymentPhaseArgs = {
    cursor?: InputMaybe<DeploymentPhaseWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentPhaseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentPhaseOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type QueryFindFirstDeploymentPhaseOrThrowArgs = {
    cursor?: InputMaybe<DeploymentPhaseWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentPhaseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentPhaseOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type QueryFindFirstDeploymentTaskArgs = {
    cursor?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentTaskOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type QueryFindFirstDeploymentTaskDependencyArgs = {
    cursor?: InputMaybe<DeploymentTaskDependencyWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTaskDependencyScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<DeploymentTaskDependencyOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type QueryFindFirstDeploymentTaskDependencyOrThrowArgs = {
    cursor?: InputMaybe<DeploymentTaskDependencyWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTaskDependencyScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<DeploymentTaskDependencyOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type QueryFindFirstDeploymentTaskOrThrowArgs = {
    cursor?: InputMaybe<DeploymentTaskWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTaskScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentTaskOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type QueryFindFirstDeploymentTeamArgs = {
    cursor?: InputMaybe<DeploymentTeamWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTeamScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentTeamOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTeamWhereInput>;
};

export type QueryFindFirstDeploymentTeamOrThrowArgs = {
    cursor?: InputMaybe<DeploymentTeamWhereUniqueInput>;
    distinct?: InputMaybe<Array<DeploymentTeamScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DeploymentTeamOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTeamWhereInput>;
};

export type QueryFindFirstDiscountCodesArgs = {
    cursor?: InputMaybe<DiscountCodesWhereUniqueInput>;
    distinct?: InputMaybe<Array<DiscountCodesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DiscountCodesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DiscountCodesWhereInput>;
};

export type QueryFindFirstDiscountCodesOrThrowArgs = {
    cursor?: InputMaybe<DiscountCodesWhereUniqueInput>;
    distinct?: InputMaybe<Array<DiscountCodesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DiscountCodesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DiscountCodesWhereInput>;
};

export type QueryFindFirstEcwPayerAliasArgs = {
    cursor?: InputMaybe<EcwPayerAliasWhereUniqueInput>;
    distinct?: InputMaybe<Array<EcwPayerAliasScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EcwPayerAliasOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerAliasWhereInput>;
};

export type QueryFindFirstEcwPayerAliasOrThrowArgs = {
    cursor?: InputMaybe<EcwPayerAliasWhereUniqueInput>;
    distinct?: InputMaybe<Array<EcwPayerAliasScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EcwPayerAliasOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerAliasWhereInput>;
};

export type QueryFindFirstEcwPayerStcArgs = {
    cursor?: InputMaybe<EcwPayerStcWhereUniqueInput>;
    distinct?: InputMaybe<Array<EcwPayerStcScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EcwPayerStcOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerStcWhereInput>;
};

export type QueryFindFirstEcwPayerStcOrThrowArgs = {
    cursor?: InputMaybe<EcwPayerStcWhereUniqueInput>;
    distinct?: InputMaybe<Array<EcwPayerStcScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EcwPayerStcOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerStcWhereInput>;
};

export type QueryFindFirstEhrAppointmentTypeIdToNameArgs = {
    cursor?: InputMaybe<EhrAppointmentTypeIdToNameWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrAppointmentTypeIdToNameScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<EhrAppointmentTypeIdToNameOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrAppointmentTypeIdToNameWhereInput>;
};

export type QueryFindFirstEhrAppointmentTypeIdToNameOrThrowArgs = {
    cursor?: InputMaybe<EhrAppointmentTypeIdToNameWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrAppointmentTypeIdToNameScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<EhrAppointmentTypeIdToNameOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrAppointmentTypeIdToNameWhereInput>;
};

export type QueryFindFirstEhrPaymentDescriptorArgs = {
    cursor?: InputMaybe<EhrPaymentDescriptorWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPaymentDescriptorScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPaymentDescriptorOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDescriptorWhereInput>;
};

export type QueryFindFirstEhrPaymentDescriptorAuditLogArgs = {
    cursor?: InputMaybe<EhrPaymentDescriptorAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPaymentDescriptorAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDescriptorAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDescriptorAuditLogWhereInput>;
};

export type QueryFindFirstEhrPaymentDescriptorAuditLogOrThrowArgs = {
    cursor?: InputMaybe<EhrPaymentDescriptorAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPaymentDescriptorAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDescriptorAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDescriptorAuditLogWhereInput>;
};

export type QueryFindFirstEhrPaymentDescriptorOrThrowArgs = {
    cursor?: InputMaybe<EhrPaymentDescriptorWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPaymentDescriptorScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPaymentDescriptorOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDescriptorWhereInput>;
};

export type QueryFindFirstEhrPaymentDirectionSsAssetArgs = {
    cursor?: InputMaybe<EhrPaymentDirectionSsAssetWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPaymentDirectionSsAssetScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDirectionSsAssetOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDirectionSsAssetWhereInput>;
};

export type QueryFindFirstEhrPaymentDirectionSsAssetOrThrowArgs = {
    cursor?: InputMaybe<EhrPaymentDirectionSsAssetWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPaymentDirectionSsAssetScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDirectionSsAssetOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDirectionSsAssetWhereInput>;
};

export type QueryFindFirstEhrPostDetailArgs = {
    cursor?: InputMaybe<EhrPostDetailWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostDetailScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostDetailOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostDetailWhereInput>;
};

export type QueryFindFirstEhrPostDetailOrThrowArgs = {
    cursor?: InputMaybe<EhrPostDetailWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostDetailScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostDetailOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostDetailWhereInput>;
};

export type QueryFindFirstEhrPostDetailToPayoutArgs = {
    cursor?: InputMaybe<EhrPostDetailToPayoutWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostDetailToPayoutScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostDetailToPayoutOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostDetailToPayoutWhereInput>;
};

export type QueryFindFirstEhrPostDetailToPayoutOrThrowArgs = {
    cursor?: InputMaybe<EhrPostDetailToPayoutWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostDetailToPayoutScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostDetailToPayoutOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostDetailToPayoutWhereInput>;
};

export type QueryFindFirstEhrPostLedgerArgs = {
    cursor?: InputMaybe<EhrPostLedgerWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostLedgerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostLedgerOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerWhereInput>;
};

export type QueryFindFirstEhrPostLedgerAuditLogArgs = {
    cursor?: InputMaybe<EhrPostLedgerAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostLedgerAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostLedgerAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerAuditLogWhereInput>;
};

export type QueryFindFirstEhrPostLedgerAuditLogOrThrowArgs = {
    cursor?: InputMaybe<EhrPostLedgerAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostLedgerAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostLedgerAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerAuditLogWhereInput>;
};

export type QueryFindFirstEhrPostLedgerOrThrowArgs = {
    cursor?: InputMaybe<EhrPostLedgerWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostLedgerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostLedgerOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerWhereInput>;
};

export type QueryFindFirstEhrPostLedgerToPayoutArgs = {
    cursor?: InputMaybe<EhrPostLedgerToPayoutWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostLedgerToPayoutScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostLedgerToPayoutOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerToPayoutWhereInput>;
};

export type QueryFindFirstEhrPostLedgerToPayoutOrThrowArgs = {
    cursor?: InputMaybe<EhrPostLedgerToPayoutWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPostLedgerToPayoutScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPostLedgerToPayoutOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerToPayoutWhereInput>;
};

export type QueryFindFirstEhrPrimaryCareProviderArgs = {
    cursor?: InputMaybe<EhrPrimaryCareProviderWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPrimaryCareProviderScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPrimaryCareProviderOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPrimaryCareProviderWhereInput>;
};

export type QueryFindFirstEhrPrimaryCareProviderOrThrowArgs = {
    cursor?: InputMaybe<EhrPrimaryCareProviderWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrPrimaryCareProviderScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrPrimaryCareProviderOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPrimaryCareProviderWhereInput>;
};

export type QueryFindFirstEhrProviderMappingArgs = {
    cursor?: InputMaybe<EhrProviderMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrProviderMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrProviderMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrProviderMappingWhereInput>;
};

export type QueryFindFirstEhrProviderMappingOrThrowArgs = {
    cursor?: InputMaybe<EhrProviderMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrProviderMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrProviderMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrProviderMappingWhereInput>;
};

export type QueryFindFirstEhrSlotArgs = {
    cursor?: InputMaybe<EhrSlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrSlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrSlotOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type QueryFindFirstEhrSlotAuditLogArgs = {
    cursor?: InputMaybe<EhrSlotAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrSlotAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrSlotAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrSlotAuditLogWhereInput>;
};

export type QueryFindFirstEhrSlotAuditLogOrThrowArgs = {
    cursor?: InputMaybe<EhrSlotAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrSlotAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrSlotAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrSlotAuditLogWhereInput>;
};

export type QueryFindFirstEhrSlotOrThrowArgs = {
    cursor?: InputMaybe<EhrSlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<EhrSlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EhrSlotOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type QueryFindFirstEncounterArgs = {
    cursor?: InputMaybe<EncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<EncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EncounterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EncounterWhereInput>;
};

export type QueryFindFirstEncounterOrThrowArgs = {
    cursor?: InputMaybe<EncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<EncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<EncounterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EncounterWhereInput>;
};

export type QueryFindFirstExperityEncounterArgs = {
    cursor?: InputMaybe<ExperityEncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<ExperityEncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ExperityEncounterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ExperityEncounterWhereInput>;
};

export type QueryFindFirstExperityEncounterOrThrowArgs = {
    cursor?: InputMaybe<ExperityEncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<ExperityEncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ExperityEncounterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ExperityEncounterWhereInput>;
};

export type QueryFindFirstFaqDropdownsArgs = {
    cursor?: InputMaybe<FaqDropdownsWhereUniqueInput>;
    distinct?: InputMaybe<Array<FaqDropdownsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<FaqDropdownsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FaqDropdownsWhereInput>;
};

export type QueryFindFirstFaqDropdownsOrThrowArgs = {
    cursor?: InputMaybe<FaqDropdownsWhereUniqueInput>;
    distinct?: InputMaybe<Array<FaqDropdownsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<FaqDropdownsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FaqDropdownsWhereInput>;
};

export type QueryFindFirstFeeConfigArgs = {
    cursor?: InputMaybe<FeeConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<FeeConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<FeeConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FeeConfigWhereInput>;
};

export type QueryFindFirstFeeConfigAuditLogArgs = {
    cursor?: InputMaybe<FeeConfigAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<FeeConfigAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<FeeConfigAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FeeConfigAuditLogWhereInput>;
};

export type QueryFindFirstFeeConfigAuditLogOrThrowArgs = {
    cursor?: InputMaybe<FeeConfigAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<FeeConfigAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<FeeConfigAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FeeConfigAuditLogWhereInput>;
};

export type QueryFindFirstFeeConfigOrThrowArgs = {
    cursor?: InputMaybe<FeeConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<FeeConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<FeeConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FeeConfigWhereInput>;
};

export type QueryFindFirstGuarantorPaymentLinkContextArgs = {
    cursor?: InputMaybe<GuarantorPaymentLinkContextWhereUniqueInput>;
    distinct?: InputMaybe<Array<GuarantorPaymentLinkContextScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<GuarantorPaymentLinkContextOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GuarantorPaymentLinkContextWhereInput>;
};

export type QueryFindFirstGuarantorPaymentLinkContextOrThrowArgs = {
    cursor?: InputMaybe<GuarantorPaymentLinkContextWhereUniqueInput>;
    distinct?: InputMaybe<Array<GuarantorPaymentLinkContextScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<GuarantorPaymentLinkContextOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GuarantorPaymentLinkContextWhereInput>;
};

export type QueryFindFirstHolidayArgs = {
    cursor?: InputMaybe<HolidayWhereUniqueInput>;
    distinct?: InputMaybe<Array<HolidayScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HolidayOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HolidayWhereInput>;
};

export type QueryFindFirstHolidayOrThrowArgs = {
    cursor?: InputMaybe<HolidayWhereUniqueInput>;
    distinct?: InputMaybe<Array<HolidayScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HolidayOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HolidayWhereInput>;
};

export type QueryFindFirstHrtArgs = {
    cursor?: InputMaybe<HrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtWhereInput>;
};

export type QueryFindFirstHrtFlagsArgs = {
    cursor?: InputMaybe<HrtFlagsWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtFlagsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtFlagsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtFlagsWhereInput>;
};

export type QueryFindFirstHrtFlagsOrThrowArgs = {
    cursor?: InputMaybe<HrtFlagsWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtFlagsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtFlagsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtFlagsWhereInput>;
};

export type QueryFindFirstHrtOrThrowArgs = {
    cursor?: InputMaybe<HrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtWhereInput>;
};

export type QueryFindFirstHrtPaymentTypeArgs = {
    cursor?: InputMaybe<HrtPaymentTypeWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtPaymentTypeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtPaymentTypeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtPaymentTypeWhereInput>;
};

export type QueryFindFirstHrtPaymentTypeOrThrowArgs = {
    cursor?: InputMaybe<HrtPaymentTypeWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtPaymentTypeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtPaymentTypeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtPaymentTypeWhereInput>;
};

export type QueryFindFirstHrtToSrtArgs = {
    cursor?: InputMaybe<HrtToSrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtToSrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtToSrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type QueryFindFirstHrtToSrtOrThrowArgs = {
    cursor?: InputMaybe<HrtToSrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtToSrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtToSrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type QueryFindFirstHrtTranslationArgs = {
    cursor?: InputMaybe<HrtTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtTranslationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtTranslationWhereInput>;
};

export type QueryFindFirstHrtTranslationOrThrowArgs = {
    cursor?: InputMaybe<HrtTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtTranslationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtTranslationWhereInput>;
};

export type QueryFindFirstInboundRequestLogArgs = {
    cursor?: InputMaybe<InboundRequestLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<InboundRequestLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InboundRequestLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InboundRequestLogWhereInput>;
};

export type QueryFindFirstInboundRequestLogOrThrowArgs = {
    cursor?: InputMaybe<InboundRequestLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<InboundRequestLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InboundRequestLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InboundRequestLogWhereInput>;
};

export type QueryFindFirstInboundTextMessageLogArgs = {
    cursor?: InputMaybe<InboundTextMessageLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<InboundTextMessageLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InboundTextMessageLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InboundTextMessageLogWhereInput>;
};

export type QueryFindFirstInboundTextMessageLogOrThrowArgs = {
    cursor?: InputMaybe<InboundTextMessageLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<InboundTextMessageLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InboundTextMessageLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InboundTextMessageLogWhereInput>;
};

export type QueryFindFirstInsuranceArgs = {
    cursor?: InputMaybe<InsuranceWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceWhereInput>;
};

export type QueryFindFirstInsuranceAuditLogArgs = {
    cursor?: InputMaybe<InsuranceAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceAuditLogWhereInput>;
};

export type QueryFindFirstInsuranceAuditLogOrThrowArgs = {
    cursor?: InputMaybe<InsuranceAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceAuditLogWhereInput>;
};

export type QueryFindFirstInsuranceMetadataArgs = {
    cursor?: InputMaybe<InsuranceMetadataWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceMetadataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceMetadataOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceMetadataWhereInput>;
};

export type QueryFindFirstInsuranceMetadataOrThrowArgs = {
    cursor?: InputMaybe<InsuranceMetadataWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceMetadataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceMetadataOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceMetadataWhereInput>;
};

export type QueryFindFirstInsuranceOrThrowArgs = {
    cursor?: InputMaybe<InsuranceWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceWhereInput>;
};

export type QueryFindFirstIntakeFormArgs = {
    cursor?: InputMaybe<IntakeFormWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type QueryFindFirstIntakeFormOrThrowArgs = {
    cursor?: InputMaybe<IntakeFormWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type QueryFindFirstIntakeFormSectionArgs = {
    cursor?: InputMaybe<IntakeFormSectionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormSectionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormSectionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type QueryFindFirstIntakeFormSectionOrThrowArgs = {
    cursor?: InputMaybe<IntakeFormSectionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormSectionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormSectionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type QueryFindFirstIntakeFormSectionTranslationArgs = {
    cursor?: InputMaybe<IntakeFormSectionTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormSectionTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<IntakeFormSectionTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
};

export type QueryFindFirstIntakeFormSectionTranslationOrThrowArgs = {
    cursor?: InputMaybe<IntakeFormSectionTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormSectionTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<IntakeFormSectionTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
};

export type QueryFindFirstIntakeFormToQuestionArgs = {
    cursor?: InputMaybe<IntakeFormToQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormToQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormToQuestionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type QueryFindFirstIntakeFormToQuestionOrThrowArgs = {
    cursor?: InputMaybe<IntakeFormToQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormToQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormToQuestionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type QueryFindFirstIntakeQuestionArgs = {
    cursor?: InputMaybe<IntakeQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeQuestionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type QueryFindFirstIntakeQuestionOrThrowArgs = {
    cursor?: InputMaybe<IntakeQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeQuestionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type QueryFindFirstIntakeQuestionTranslationArgs = {
    cursor?: InputMaybe<IntakeQuestionTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeQuestionTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<IntakeQuestionTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionTranslationWhereInput>;
};

export type QueryFindFirstIntakeQuestionTranslationOrThrowArgs = {
    cursor?: InputMaybe<IntakeQuestionTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeQuestionTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<IntakeQuestionTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionTranslationWhereInput>;
};

export type QueryFindFirstInvoiceDailyLineItemsArgs = {
    cursor?: InputMaybe<InvoiceDailyLineItemsWhereUniqueInput>;
    distinct?: InputMaybe<Array<InvoiceDailyLineItemsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InvoiceDailyLineItemsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
};

export type QueryFindFirstInvoiceDailyLineItemsOrThrowArgs = {
    cursor?: InputMaybe<InvoiceDailyLineItemsWhereUniqueInput>;
    distinct?: InputMaybe<Array<InvoiceDailyLineItemsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InvoiceDailyLineItemsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
};

export type QueryFindFirstInvoicesArgs = {
    cursor?: InputMaybe<InvoicesWhereUniqueInput>;
    distinct?: InputMaybe<Array<InvoicesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InvoicesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoicesWhereInput>;
};

export type QueryFindFirstInvoicesOrThrowArgs = {
    cursor?: InputMaybe<InvoicesWhereUniqueInput>;
    distinct?: InputMaybe<Array<InvoicesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InvoicesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoicesWhereInput>;
};

export type QueryFindFirstKeywordRuleArgs = {
    cursor?: InputMaybe<KeywordRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<KeywordRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<KeywordRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<KeywordRuleWhereInput>;
};

export type QueryFindFirstKeywordRuleOrThrowArgs = {
    cursor?: InputMaybe<KeywordRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<KeywordRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<KeywordRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<KeywordRuleWhereInput>;
};

export type QueryFindFirstLinkMappingArgs = {
    cursor?: InputMaybe<LinkMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<LinkMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<LinkMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<LinkMappingWhereInput>;
};

export type QueryFindFirstLinkMappingOrThrowArgs = {
    cursor?: InputMaybe<LinkMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<LinkMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<LinkMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<LinkMappingWhereInput>;
};

export type QueryFindFirstLiveTransfersArgs = {
    cursor?: InputMaybe<LiveTransfersWhereUniqueInput>;
    distinct?: InputMaybe<Array<LiveTransfersScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<LiveTransfersOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<LiveTransfersWhereInput>;
};

export type QueryFindFirstLiveTransfersOrThrowArgs = {
    cursor?: InputMaybe<LiveTransfersWhereUniqueInput>;
    distinct?: InputMaybe<Array<LiveTransfersScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<LiveTransfersOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<LiveTransfersWhereInput>;
};

export type QueryFindFirstMcmsAssociationArgs = {
    cursor?: InputMaybe<McmsAssociationWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type QueryFindFirstMcmsAssociationAuditLogArgs = {
    cursor?: InputMaybe<McmsAssociationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<McmsAssociationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationAuditLogWhereInput>;
};

export type QueryFindFirstMcmsAssociationAuditLogOrThrowArgs = {
    cursor?: InputMaybe<McmsAssociationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<McmsAssociationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationAuditLogWhereInput>;
};

export type QueryFindFirstMcmsAssociationClaimArgs = {
    cursor?: InputMaybe<McmsAssociationClaimWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationClaimScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationClaimOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimWhereInput>;
};

export type QueryFindFirstMcmsAssociationClaimAuditLogArgs = {
    cursor?: InputMaybe<McmsAssociationClaimAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationClaimAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<McmsAssociationClaimAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimAuditLogWhereInput>;
};

export type QueryFindFirstMcmsAssociationClaimAuditLogOrThrowArgs = {
    cursor?: InputMaybe<McmsAssociationClaimAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationClaimAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<McmsAssociationClaimAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimAuditLogWhereInput>;
};

export type QueryFindFirstMcmsAssociationClaimOrThrowArgs = {
    cursor?: InputMaybe<McmsAssociationClaimWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationClaimScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationClaimOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimWhereInput>;
};

export type QueryFindFirstMcmsAssociationOrThrowArgs = {
    cursor?: InputMaybe<McmsAssociationWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type QueryFindFirstMcmsAssociationSlotArgs = {
    cursor?: InputMaybe<McmsAssociationSlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationSlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationSlotOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotWhereInput>;
};

export type QueryFindFirstMcmsAssociationSlotAuditLogArgs = {
    cursor?: InputMaybe<McmsAssociationSlotAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationSlotAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<McmsAssociationSlotAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotAuditLogWhereInput>;
};

export type QueryFindFirstMcmsAssociationSlotAuditLogOrThrowArgs = {
    cursor?: InputMaybe<McmsAssociationSlotAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationSlotAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<McmsAssociationSlotAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotAuditLogWhereInput>;
};

export type QueryFindFirstMcmsAssociationSlotOrThrowArgs = {
    cursor?: InputMaybe<McmsAssociationSlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationSlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationSlotOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotWhereInput>;
};

export type QueryFindFirstMessageBlueprintArgs = {
    cursor?: InputMaybe<MessageBlueprintWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageBlueprintScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageBlueprintOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type QueryFindFirstMessageBlueprintOrThrowArgs = {
    cursor?: InputMaybe<MessageBlueprintWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageBlueprintScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageBlueprintOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type QueryFindFirstMessageConsolidationContextArgs = {
    cursor?: InputMaybe<MessageConsolidationContextWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageConsolidationContextScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationContextOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationContextWhereInput>;
};

export type QueryFindFirstMessageConsolidationContextOrThrowArgs = {
    cursor?: InputMaybe<MessageConsolidationContextWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageConsolidationContextScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationContextOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationContextWhereInput>;
};

export type QueryFindFirstMessageConsolidationTemplateArgs = {
    cursor?: InputMaybe<MessageConsolidationTemplateWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageConsolidationTemplateScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationTemplateOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationTemplateWhereInput>;
};

export type QueryFindFirstMessageConsolidationTemplateOrThrowArgs = {
    cursor?: InputMaybe<MessageConsolidationTemplateWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageConsolidationTemplateScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationTemplateOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationTemplateWhereInput>;
};

export type QueryFindFirstMessageNudgeArgs = {
    cursor?: InputMaybe<MessageNudgeWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageNudgeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageNudgeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type QueryFindFirstMessageNudgeOrThrowArgs = {
    cursor?: InputMaybe<MessageNudgeWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageNudgeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageNudgeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type QueryFindFirstMessageOrchestrationRuleArgs = {
    cursor?: InputMaybe<MessageOrchestrationRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageOrchestrationRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<MessageOrchestrationRuleOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageOrchestrationRuleWhereInput>;
};

export type QueryFindFirstMessageOrchestrationRuleOrThrowArgs = {
    cursor?: InputMaybe<MessageOrchestrationRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageOrchestrationRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<MessageOrchestrationRuleOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageOrchestrationRuleWhereInput>;
};

export type QueryFindFirstMessagePayAfterArgs = {
    cursor?: InputMaybe<MessagePayAfterWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessagePayAfterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessagePayAfterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessagePayAfterWhereInput>;
};

export type QueryFindFirstMessagePayAfterOrThrowArgs = {
    cursor?: InputMaybe<MessagePayAfterWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessagePayAfterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessagePayAfterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessagePayAfterWhereInput>;
};

export type QueryFindFirstMessageSettingsHrtArgs = {
    cursor?: InputMaybe<MessageSettingsHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageSettingsHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageSettingsHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageSettingsHrtWhereInput>;
};

export type QueryFindFirstMessageSettingsHrtOrThrowArgs = {
    cursor?: InputMaybe<MessageSettingsHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageSettingsHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageSettingsHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageSettingsHrtWhereInput>;
};

export type QueryFindFirstMessageSettingsOrgArgs = {
    cursor?: InputMaybe<MessageSettingsOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageSettingsOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageSettingsOrgOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageSettingsOrgWhereInput>;
};

export type QueryFindFirstMessageSettingsOrgOrThrowArgs = {
    cursor?: InputMaybe<MessageSettingsOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageSettingsOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageSettingsOrgOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageSettingsOrgWhereInput>;
};

export type QueryFindFirstMessageTemplateHrtArgs = {
    cursor?: InputMaybe<MessageTemplateHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageTemplateHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageTemplateHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateHrtWhereInput>;
};

export type QueryFindFirstMessageTemplateHrtOrThrowArgs = {
    cursor?: InputMaybe<MessageTemplateHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageTemplateHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageTemplateHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateHrtWhereInput>;
};

export type QueryFindFirstMessageTemplateOrgArgs = {
    cursor?: InputMaybe<MessageTemplateOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageTemplateOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageTemplateOrgOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateOrgWhereInput>;
};

export type QueryFindFirstMessageTemplateOrgOrThrowArgs = {
    cursor?: InputMaybe<MessageTemplateOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageTemplateOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageTemplateOrgOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateOrgWhereInput>;
};

export type QueryFindFirstMigratedEncounterArgs = {
    cursor?: InputMaybe<MigratedEncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<MigratedEncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MigratedEncounterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MigratedEncounterWhereInput>;
};

export type QueryFindFirstMigratedEncounterOrThrowArgs = {
    cursor?: InputMaybe<MigratedEncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<MigratedEncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MigratedEncounterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MigratedEncounterWhereInput>;
};

export type QueryFindFirstMigrationsArgs = {
    cursor?: InputMaybe<MigrationsWhereUniqueInput>;
    distinct?: InputMaybe<Array<MigrationsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MigrationsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MigrationsWhereInput>;
};

export type QueryFindFirstMigrationsOrThrowArgs = {
    cursor?: InputMaybe<MigrationsWhereUniqueInput>;
    distinct?: InputMaybe<Array<MigrationsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MigrationsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MigrationsWhereInput>;
};

export type QueryFindFirstNetworkValidationArgs = {
    cursor?: InputMaybe<NetworkValidationWhereUniqueInput>;
    distinct?: InputMaybe<Array<NetworkValidationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<NetworkValidationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NetworkValidationWhereInput>;
};

export type QueryFindFirstNetworkValidationOrThrowArgs = {
    cursor?: InputMaybe<NetworkValidationWhereUniqueInput>;
    distinct?: InputMaybe<Array<NetworkValidationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<NetworkValidationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NetworkValidationWhereInput>;
};

export type QueryFindFirstNetworkPlanExceptionsArgs = {
    cursor?: InputMaybe<NetworkPlanExceptionsWhereUniqueInput>;
    distinct?: InputMaybe<Array<NetworkPlanExceptionsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<NetworkPlanExceptionsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NetworkPlanExceptionsWhereInput>;
};

export type QueryFindFirstNetworkPlanExceptionsOrThrowArgs = {
    cursor?: InputMaybe<NetworkPlanExceptionsWhereUniqueInput>;
    distinct?: InputMaybe<Array<NetworkPlanExceptionsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<NetworkPlanExceptionsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NetworkPlanExceptionsWhereInput>;
};

export type QueryFindFirstNonCardRefundsArgs = {
    cursor?: InputMaybe<NonCardRefundsWhereUniqueInput>;
    distinct?: InputMaybe<Array<NonCardRefundsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<NonCardRefundsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NonCardRefundsWhereInput>;
};

export type QueryFindFirstNonCardRefundsOrThrowArgs = {
    cursor?: InputMaybe<NonCardRefundsWhereUniqueInput>;
    distinct?: InputMaybe<Array<NonCardRefundsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<NonCardRefundsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NonCardRefundsWhereInput>;
};

export type QueryFindFirstOrgConfigFlagArgs = {
    cursor?: InputMaybe<OrgConfigFlagWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgConfigFlagScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgConfigFlagOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type QueryFindFirstOrgConfigFlagOrThrowArgs = {
    cursor?: InputMaybe<OrgConfigFlagWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgConfigFlagScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgConfigFlagOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type QueryFindFirstOrgHrtSrtRuleArgs = {
    cursor?: InputMaybe<OrgHrtSrtRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgHrtSrtRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgHrtSrtRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgHrtSrtRuleWhereInput>;
};

export type QueryFindFirstOrgHrtSrtRuleOrThrowArgs = {
    cursor?: InputMaybe<OrgHrtSrtRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgHrtSrtRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgHrtSrtRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgHrtSrtRuleWhereInput>;
};

export type QueryFindFirstOrgNetworkResultsArgs = {
    cursor?: InputMaybe<OrgNetworkResultsWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgNetworkResultsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgNetworkResultsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgNetworkResultsWhereInput>;
};

export type QueryFindFirstOrgNetworkResultsOrThrowArgs = {
    cursor?: InputMaybe<OrgNetworkResultsWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgNetworkResultsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgNetworkResultsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgNetworkResultsWhereInput>;
};

export type QueryFindFirstOrgOverrideRuleArgs = {
    cursor?: InputMaybe<OrgOverrideRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgOverrideRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgOverrideRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgOverrideRuleWhereInput>;
};

export type QueryFindFirstOrgOverrideRuleOrThrowArgs = {
    cursor?: InputMaybe<OrgOverrideRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgOverrideRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgOverrideRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgOverrideRuleWhereInput>;
};

export type QueryFindFirstOrgFeesArgs = {
    cursor?: InputMaybe<OrgFeesWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgFeesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgFeesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgFeesWhereInput>;
};

export type QueryFindFirstOrgFeesOrThrowArgs = {
    cursor?: InputMaybe<OrgFeesWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgFeesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgFeesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgFeesWhereInput>;
};

export type QueryFindFirstOrgStripeMappingArgs = {
    cursor?: InputMaybe<OrgStripeMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgStripeMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgStripeMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgStripeMappingWhereInput>;
};

export type QueryFindFirstOrgStripeMappingOrThrowArgs = {
    cursor?: InputMaybe<OrgStripeMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgStripeMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgStripeMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgStripeMappingWhereInput>;
};

export type QueryFindFirstOrganizationArgs = {
    cursor?: InputMaybe<OrganizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrganizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type QueryFindFirstOrganizationAssetsArgs = {
    cursor?: InputMaybe<OrganizationAssetsWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrganizationAssetsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrganizationAssetsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type QueryFindFirstOrganizationAssetsOrThrowArgs = {
    cursor?: InputMaybe<OrganizationAssetsWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrganizationAssetsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrganizationAssetsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type QueryFindFirstOrganizationOrThrowArgs = {
    cursor?: InputMaybe<OrganizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrganizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type QueryFindFirstOrganizationTranslationArgs = {
    cursor?: InputMaybe<OrganizationTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrganizationTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<OrganizationTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationTranslationWhereInput>;
};

export type QueryFindFirstOrganizationTranslationOrThrowArgs = {
    cursor?: InputMaybe<OrganizationTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrganizationTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<OrganizationTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationTranslationWhereInput>;
};

export type QueryFindFirstPayLaterAuthorizationArgs = {
    cursor?: InputMaybe<PayLaterAuthorizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayLaterAuthorizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayLaterAuthorizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type QueryFindFirstPayLaterAuthorizationAuditLogArgs = {
    cursor?: InputMaybe<PayLaterAuthorizationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayLaterAuthorizationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PayLaterAuthorizationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationAuditLogWhereInput>;
};

export type QueryFindFirstPayLaterAuthorizationAuditLogOrThrowArgs = {
    cursor?: InputMaybe<PayLaterAuthorizationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayLaterAuthorizationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PayLaterAuthorizationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationAuditLogWhereInput>;
};

export type QueryFindFirstPayLaterAuthorizationOrThrowArgs = {
    cursor?: InputMaybe<PayLaterAuthorizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayLaterAuthorizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayLaterAuthorizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type QueryFindFirstPayerArgs = {
    cursor?: InputMaybe<PayerWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayerOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerWhereInput>;
};

export type QueryFindFirstPayerOrThrowArgs = {
    cursor?: InputMaybe<PayerWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayerOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerWhereInput>;
};

export type QueryFindFirstPayerPlanMappingArgs = {
    cursor?: InputMaybe<PayerPlanMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayerPlanMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayerPlanMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerPlanMappingWhereInput>;
};

export type QueryFindFirstPayerPlanMappingOrThrowArgs = {
    cursor?: InputMaybe<PayerPlanMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayerPlanMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayerPlanMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerPlanMappingWhereInput>;
};

export type QueryFindFirstPayerToEhrInsurancePackageMappingArgs = {
    cursor?: InputMaybe<PayerToEhrInsurancePackageMappingWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type QueryFindFirstPayerToEhrInsurancePackageMappingOrThrowArgs = {
    cursor?: InputMaybe<PayerToEhrInsurancePackageMappingWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type QueryFindFirstPaymentAuthorizationArgs = {
    cursor?: InputMaybe<PaymentAuthorizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentAuthorizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentAuthorizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type QueryFindFirstPaymentAuthorizationAuditLogArgs = {
    cursor?: InputMaybe<PaymentAuthorizationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentAuthorizationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentAuthorizationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentAuthorizationAuditLogWhereInput>;
};

export type QueryFindFirstPaymentAuthorizationAuditLogOrThrowArgs = {
    cursor?: InputMaybe<PaymentAuthorizationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentAuthorizationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentAuthorizationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentAuthorizationAuditLogWhereInput>;
};

export type QueryFindFirstPaymentAuthorizationOrThrowArgs = {
    cursor?: InputMaybe<PaymentAuthorizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentAuthorizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentAuthorizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type QueryFindFirstPaymentContractArgs = {
    cursor?: InputMaybe<PaymentContractWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentContractScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentContractOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentContractWhereInput>;
};

export type QueryFindFirstPaymentContractOrThrowArgs = {
    cursor?: InputMaybe<PaymentContractWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentContractScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentContractOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentContractWhereInput>;
};

export type QueryFindFirstPaymentPlanArgs = {
    cursor?: InputMaybe<PaymentPlanWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type QueryFindFirstPaymentPlanAdjustmentArgs = {
    cursor?: InputMaybe<PaymentPlanAdjustmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAdjustmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAdjustmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
};

export type QueryFindFirstPaymentPlanAdjustmentAuditLogArgs = {
    cursor?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAdjustmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAdjustmentAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereInput>;
};

export type QueryFindFirstPaymentPlanAdjustmentAuditLogOrThrowArgs = {
    cursor?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAdjustmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAdjustmentAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereInput>;
};

export type QueryFindFirstPaymentPlanAdjustmentOrThrowArgs = {
    cursor?: InputMaybe<PaymentPlanAdjustmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAdjustmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAdjustmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
};

export type QueryFindFirstPaymentPlanAuditLogArgs = {
    cursor?: InputMaybe<PaymentPlanAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAuditLogWhereInput>;
};

export type QueryFindFirstPaymentPlanAuditLogOrThrowArgs = {
    cursor?: InputMaybe<PaymentPlanAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAuditLogWhereInput>;
};

export type QueryFindFirstPaymentPlanAutoChargeArgs = {
    cursor?: InputMaybe<PaymentPlanAutoChargeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAutoChargeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAutoChargeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
};

export type QueryFindFirstPaymentPlanAutoChargeAuditLogArgs = {
    cursor?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAutoChargeAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAutoChargeAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereInput>;
};

export type QueryFindFirstPaymentPlanAutoChargeAuditLogOrThrowArgs = {
    cursor?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAutoChargeAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAutoChargeAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereInput>;
};

export type QueryFindFirstPaymentPlanAutoChargeOrThrowArgs = {
    cursor?: InputMaybe<PaymentPlanAutoChargeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAutoChargeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAutoChargeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
};

export type QueryFindFirstPaymentPlanBoughtTreatmentArgs = {
    cursor?: InputMaybe<PaymentPlanBoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanBoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
};

export type QueryFindFirstPaymentPlanBoughtTreatmentAuditLogArgs = {
    cursor?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereInput>;
};

export type QueryFindFirstPaymentPlanBoughtTreatmentAuditLogOrThrowArgs = {
    cursor?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereInput>;
};

export type QueryFindFirstPaymentPlanBoughtTreatmentOrThrowArgs = {
    cursor?: InputMaybe<PaymentPlanBoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanBoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
};

export type QueryFindFirstPaymentPlanOrThrowArgs = {
    cursor?: InputMaybe<PaymentPlanWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type QueryFindFirstPaymentPlanOrgConfigArgs = {
    cursor?: InputMaybe<PaymentPlanOrgConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanOrgConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanOrgConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanOrgConfigWhereInput>;
};

export type QueryFindFirstPaymentPlanOrgConfigAuditLogArgs = {
    cursor?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanOrgConfigAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanOrgConfigAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereInput>;
};

export type QueryFindFirstPaymentPlanOrgConfigAuditLogOrThrowArgs = {
    cursor?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanOrgConfigAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanOrgConfigAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereInput>;
};

export type QueryFindFirstPaymentPlanOrgConfigOrThrowArgs = {
    cursor?: InputMaybe<PaymentPlanOrgConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanOrgConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanOrgConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanOrgConfigWhereInput>;
};

export type QueryFindFirstPayoutArgs = {
    cursor?: InputMaybe<PayoutWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayoutScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutWhereInput>;
};

export type QueryFindFirstPayoutAuditLogArgs = {
    cursor?: InputMaybe<PayoutAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayoutAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayoutAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutAuditLogWhereInput>;
};

export type QueryFindFirstPayoutAuditLogOrThrowArgs = {
    cursor?: InputMaybe<PayoutAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayoutAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayoutAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutAuditLogWhereInput>;
};

export type QueryFindFirstPayoutOrThrowArgs = {
    cursor?: InputMaybe<PayoutWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayoutScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutWhereInput>;
};

export type QueryFindFirstPendingVoidPayoutReversalArgs = {
    cursor?: InputMaybe<PendingVoidPayoutReversalWhereUniqueInput>;
    distinct?: InputMaybe<Array<PendingVoidPayoutReversalScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PendingVoidPayoutReversalOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PendingVoidPayoutReversalWhereInput>;
};

export type QueryFindFirstPendingVoidPayoutReversalOrThrowArgs = {
    cursor?: InputMaybe<PendingVoidPayoutReversalWhereUniqueInput>;
    distinct?: InputMaybe<Array<PendingVoidPayoutReversalScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PendingVoidPayoutReversalOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PendingVoidPayoutReversalWhereInput>;
};

export type QueryFindFirstPhoneNumberTypeArgs = {
    cursor?: InputMaybe<PhoneNumberTypeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PhoneNumberTypeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PhoneNumberTypeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PhoneNumberTypeWhereInput>;
};

export type QueryFindFirstPhoneNumberTypeOrThrowArgs = {
    cursor?: InputMaybe<PhoneNumberTypeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PhoneNumberTypeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PhoneNumberTypeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PhoneNumberTypeWhereInput>;
};

export type QueryFindFirstPlaceOfServiceCodeArgs = {
    cursor?: InputMaybe<PlaceOfServiceCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PlaceOfServiceCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PlaceOfServiceCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type QueryFindFirstPlaceOfServiceCodeOrThrowArgs = {
    cursor?: InputMaybe<PlaceOfServiceCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PlaceOfServiceCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PlaceOfServiceCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type QueryFindFirstPracticeArgs = {
    cursor?: InputMaybe<PracticeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeWhereInput>;
};

export type QueryFindFirstPracticeConfigurationArgs = {
    cursor?: InputMaybe<PracticeConfigurationWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeConfigurationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeConfigurationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeConfigurationWhereInput>;
};

export type QueryFindFirstPracticeConfigurationOrThrowArgs = {
    cursor?: InputMaybe<PracticeConfigurationWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeConfigurationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeConfigurationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeConfigurationWhereInput>;
};

export type QueryFindFirstPracticeHoursArgs = {
    cursor?: InputMaybe<PracticeHoursWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeHoursScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeHoursOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursWhereInput>;
};

export type QueryFindFirstPracticeHoursOrThrowArgs = {
    cursor?: InputMaybe<PracticeHoursWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeHoursScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeHoursOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursWhereInput>;
};

export type QueryFindFirstPracticeHoursOverridesArgs = {
    cursor?: InputMaybe<PracticeHoursOverridesWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeHoursOverridesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeHoursOverridesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursOverridesWhereInput>;
};

export type QueryFindFirstPracticeHoursOverridesOrThrowArgs = {
    cursor?: InputMaybe<PracticeHoursOverridesWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeHoursOverridesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeHoursOverridesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursOverridesWhereInput>;
};

export type QueryFindFirstPracticeOrThrowArgs = {
    cursor?: InputMaybe<PracticeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeWhereInput>;
};

export type QueryFindFirstPricedTreatmentArgs = {
    cursor?: InputMaybe<PricedTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricedTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricedTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type QueryFindFirstPricedTreatmentOrThrowArgs = {
    cursor?: InputMaybe<PricedTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricedTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricedTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type QueryFindFirstPricingAttemptArgs = {
    cursor?: InputMaybe<PricingAttemptWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingAttemptScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingAttemptOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type QueryFindFirstPricingAttemptOrThrowArgs = {
    cursor?: InputMaybe<PricingAttemptWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingAttemptScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingAttemptOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type QueryFindFirstPricingEscalatorArgs = {
    cursor?: InputMaybe<PricingEscalatorWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingEscalatorScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingEscalatorOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingEscalatorWhereInput>;
};

export type QueryFindFirstPricingEscalatorOrThrowArgs = {
    cursor?: InputMaybe<PricingEscalatorWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingEscalatorScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingEscalatorOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingEscalatorWhereInput>;
};

export type QueryFindFirstPricingQueueArgs = {
    cursor?: InputMaybe<PricingQueueWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingQueueScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingQueueOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingQueueWhereInput>;
};

export type QueryFindFirstPricingQueueOrThrowArgs = {
    cursor?: InputMaybe<PricingQueueWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingQueueScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingQueueOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingQueueWhereInput>;
};

export type QueryFindFirstPricingResultsArgs = {
    cursor?: InputMaybe<PricingResultsWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingResultsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingResultsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingResultsWhereInput>;
};

export type QueryFindFirstPricingResultsOrThrowArgs = {
    cursor?: InputMaybe<PricingResultsWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingResultsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingResultsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingResultsWhereInput>;
};

export type QueryFindFirstProcedureBenefitParsingRulesArgs = {
    cursor?: InputMaybe<ProcedureBenefitParsingRulesWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProcedureBenefitParsingRulesScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProcedureBenefitParsingRulesOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProcedureBenefitParsingRulesWhereInput>;
};

export type QueryFindFirstProcedureBenefitParsingRulesOrThrowArgs = {
    cursor?: InputMaybe<ProcedureBenefitParsingRulesWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProcedureBenefitParsingRulesScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProcedureBenefitParsingRulesOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProcedureBenefitParsingRulesWhereInput>;
};

export type QueryFindFirstProductCategoriesArgs = {
    cursor?: InputMaybe<ProductCategoriesWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductCategoriesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductCategoriesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoriesWhereInput>;
};

export type QueryFindFirstProductCategoriesOrThrowArgs = {
    cursor?: InputMaybe<ProductCategoriesWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductCategoriesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductCategoriesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoriesWhereInput>;
};

export type QueryFindFirstProductCategoryTranslationArgs = {
    cursor?: InputMaybe<ProductCategoryTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductCategoryTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProductCategoryTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoryTranslationWhereInput>;
};

export type QueryFindFirstProductCategoryTranslationOrThrowArgs = {
    cursor?: InputMaybe<ProductCategoryTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductCategoryTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProductCategoryTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoryTranslationWhereInput>;
};

export type QueryFindFirstProductToBundleArgs = {
    cursor?: InputMaybe<ProductToBundleWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductToBundleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductToBundleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type QueryFindFirstProductToBundleOrThrowArgs = {
    cursor?: InputMaybe<ProductToBundleWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductToBundleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductToBundleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type QueryFindFirstProductToHrtArgs = {
    cursor?: InputMaybe<ProductToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductToHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type QueryFindFirstProductToHrtOrThrowArgs = {
    cursor?: InputMaybe<ProductToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductToHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type QueryFindFirstProductTranslationArgs = {
    cursor?: InputMaybe<ProductTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductTranslationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductTranslationWhereInput>;
};

export type QueryFindFirstProductTranslationOrThrowArgs = {
    cursor?: InputMaybe<ProductTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductTranslationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductTranslationWhereInput>;
};

export type QueryFindFirstProductsArgs = {
    cursor?: InputMaybe<ProductsWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductsWhereInput>;
};

export type QueryFindFirstProductsOrThrowArgs = {
    cursor?: InputMaybe<ProductsWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductsWhereInput>;
};

export type QueryFindFirstProviderArgs = {
    cursor?: InputMaybe<ProviderWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderWhereInput>;
};

export type QueryFindFirstProviderCredentialingArgs = {
    cursor?: InputMaybe<ProviderCredentialingWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderCredentialingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderCredentialingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderCredentialingWhereInput>;
};

export type QueryFindFirstProviderCredentialingOrThrowArgs = {
    cursor?: InputMaybe<ProviderCredentialingWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderCredentialingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderCredentialingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderCredentialingWhereInput>;
};

export type QueryFindFirstProviderGroupArgs = {
    cursor?: InputMaybe<ProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type QueryFindFirstProviderGroupOrThrowArgs = {
    cursor?: InputMaybe<ProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type QueryFindFirstProviderGroupToHrtArgs = {
    cursor?: InputMaybe<ProviderGroupToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupToHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type QueryFindFirstProviderGroupToHrtOrThrowArgs = {
    cursor?: InputMaybe<ProviderGroupToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupToHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type QueryFindFirstProviderHrtMaxCountArgs = {
    cursor?: InputMaybe<ProviderHrtMaxCountWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderHrtMaxCountScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderHrtMaxCountOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type QueryFindFirstProviderHrtMaxCountOrThrowArgs = {
    cursor?: InputMaybe<ProviderHrtMaxCountWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderHrtMaxCountScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderHrtMaxCountOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type QueryFindFirstProviderOrThrowArgs = {
    cursor?: InputMaybe<ProviderWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderWhereInput>;
};

export type QueryFindFirstProviderTaxonomyArgs = {
    cursor?: InputMaybe<ProviderTaxonomyWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderTaxonomyScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderTaxonomyOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type QueryFindFirstProviderTaxonomyOrThrowArgs = {
    cursor?: InputMaybe<ProviderTaxonomyWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderTaxonomyScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderTaxonomyOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type QueryFindFirstProviderToOrgArgs = {
    cursor?: InputMaybe<ProviderToOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderToOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderToOrgOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type QueryFindFirstProviderToOrgOrThrowArgs = {
    cursor?: InputMaybe<ProviderToOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderToOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderToOrgOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type QueryFindFirstProviderToProviderGroupArgs = {
    cursor?: InputMaybe<ProviderToProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderToProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProviderToProviderGroupOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type QueryFindFirstProviderToProviderGroupOrThrowArgs = {
    cursor?: InputMaybe<ProviderToProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderToProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProviderToProviderGroupOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type QueryFindFirstReattributionDirectionArgs = {
    cursor?: InputMaybe<ReattributionDirectionWhereUniqueInput>;
    distinct?: InputMaybe<Array<ReattributionDirectionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ReattributionDirectionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReattributionDirectionWhereInput>;
};

export type QueryFindFirstReattributionDirectionOrThrowArgs = {
    cursor?: InputMaybe<ReattributionDirectionWhereUniqueInput>;
    distinct?: InputMaybe<Array<ReattributionDirectionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ReattributionDirectionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReattributionDirectionWhereInput>;
};

export type QueryFindFirstReceiptArrangementArgs = {
    cursor?: InputMaybe<ReceiptArrangementWhereUniqueInput>;
    distinct?: InputMaybe<Array<ReceiptArrangementScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ReceiptArrangementOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReceiptArrangementWhereInput>;
};

export type QueryFindFirstReceiptArrangementOrThrowArgs = {
    cursor?: InputMaybe<ReceiptArrangementWhereUniqueInput>;
    distinct?: InputMaybe<Array<ReceiptArrangementScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ReceiptArrangementOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReceiptArrangementWhereInput>;
};

export type QueryFindFirstReservedEhrVisitArgs = {
    cursor?: InputMaybe<ReservedEhrVisitWhereUniqueInput>;
    distinct?: InputMaybe<Array<ReservedEhrVisitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ReservedEhrVisitOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReservedEhrVisitWhereInput>;
};

export type QueryFindFirstReservedEhrVisitOrThrowArgs = {
    cursor?: InputMaybe<ReservedEhrVisitWhereUniqueInput>;
    distinct?: InputMaybe<Array<ReservedEhrVisitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ReservedEhrVisitOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReservedEhrVisitWhereInput>;
};

export type QueryFindFirstResetTokenArgs = {
    cursor?: InputMaybe<ResetTokenWhereUniqueInput>;
    distinct?: InputMaybe<Array<ResetTokenScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ResetTokenOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ResetTokenWhereInput>;
};

export type QueryFindFirstResetTokenOrThrowArgs = {
    cursor?: InputMaybe<ResetTokenWhereUniqueInput>;
    distinct?: InputMaybe<Array<ResetTokenScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ResetTokenOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ResetTokenWhereInput>;
};

export type QueryFindFirstSavedIntakeResponseArgs = {
    cursor?: InputMaybe<SavedIntakeResponseWhereUniqueInput>;
    distinct?: InputMaybe<Array<SavedIntakeResponseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SavedIntakeResponseOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SavedIntakeResponseWhereInput>;
};

export type QueryFindFirstSavedIntakeResponseOrThrowArgs = {
    cursor?: InputMaybe<SavedIntakeResponseWhereUniqueInput>;
    distinct?: InputMaybe<Array<SavedIntakeResponseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SavedIntakeResponseOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SavedIntakeResponseWhereInput>;
};

export type QueryFindFirstSchedulingSlotConfigArgs = {
    cursor?: InputMaybe<SchedulingSlotConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<SchedulingSlotConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SchedulingSlotConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SchedulingSlotConfigWhereInput>;
};

export type QueryFindFirstSchedulingSlotConfigOrThrowArgs = {
    cursor?: InputMaybe<SchedulingSlotConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<SchedulingSlotConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SchedulingSlotConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SchedulingSlotConfigWhereInput>;
};

export type QueryFindFirstServiceTypeCodeArgs = {
    cursor?: InputMaybe<ServiceTypeCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<ServiceTypeCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ServiceTypeCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type QueryFindFirstServiceTypeCodeOrThrowArgs = {
    cursor?: InputMaybe<ServiceTypeCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<ServiceTypeCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ServiceTypeCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type QueryFindFirstSlotArgs = {
    cursor?: InputMaybe<SlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotWhereInput>;
};

export type QueryFindFirstSlotAuditLogArgs = {
    cursor?: InputMaybe<SlotAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<SlotAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SlotAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotAuditLogWhereInput>;
};

export type QueryFindFirstSlotAuditLogOrThrowArgs = {
    cursor?: InputMaybe<SlotAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<SlotAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SlotAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotAuditLogWhereInput>;
};

export type QueryFindFirstSlotOrThrowArgs = {
    cursor?: InputMaybe<SlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotWhereInput>;
};

export type QueryFindFirstSrtArgs = {
    cursor?: InputMaybe<SrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtWhereInput>;
};

export type QueryFindFirstSrtFlagsArgs = {
    cursor?: InputMaybe<SrtFlagsWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtFlagsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtFlagsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtFlagsWhereInput>;
};

export type QueryFindFirstSrtFlagsOrThrowArgs = {
    cursor?: InputMaybe<SrtFlagsWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtFlagsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtFlagsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtFlagsWhereInput>;
};

export type QueryFindFirstSrtMultiplierRuleArgs = {
    cursor?: InputMaybe<SrtMultiplierRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtMultiplierRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtMultiplierRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtMultiplierRuleWhereInput>;
};

export type QueryFindFirstSrtMultiplierRuleOrThrowArgs = {
    cursor?: InputMaybe<SrtMultiplierRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtMultiplierRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtMultiplierRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtMultiplierRuleWhereInput>;
};

export type QueryFindFirstSrtOrThrowArgs = {
    cursor?: InputMaybe<SrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtWhereInput>;
};

export type QueryFindFirstSrtToBillingCodeArgs = {
    cursor?: InputMaybe<SrtToBillingCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtToBillingCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtToBillingCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtToBillingCodeWhereInput>;
};

export type QueryFindFirstSrtToBillingCodeOrThrowArgs = {
    cursor?: InputMaybe<SrtToBillingCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtToBillingCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtToBillingCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtToBillingCodeWhereInput>;
};

export type QueryFindFirstStatePayerMappingArgs = {
    cursor?: InputMaybe<StatePayerMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<StatePayerMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<StatePayerMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<StatePayerMappingWhereInput>;
};

export type QueryFindFirstStatePayerMappingOrThrowArgs = {
    cursor?: InputMaybe<StatePayerMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<StatePayerMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<StatePayerMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<StatePayerMappingWhereInput>;
};

export type QueryFindFirstSuperscriptFeeLineItemArgs = {
    cursor?: InputMaybe<SuperscriptFeeLineItemWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptFeeLineItemScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SuperscriptFeeLineItemOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type QueryFindFirstSuperscriptFeeLineItemOrThrowArgs = {
    cursor?: InputMaybe<SuperscriptFeeLineItemWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptFeeLineItemScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SuperscriptFeeLineItemOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type QueryFindFirstSuperscriptFeesArgs = {
    cursor?: InputMaybe<SuperscriptFeesWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptFeesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SuperscriptFeesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type QueryFindFirstSuperscriptFeesOrThrowArgs = {
    cursor?: InputMaybe<SuperscriptFeesWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptFeesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SuperscriptFeesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type QueryFindFirstSuperscriptIntakeQuestionArgs = {
    cursor?: InputMaybe<SuperscriptIntakeQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptIntakeQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<SuperscriptIntakeQuestionOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
};

export type QueryFindFirstSuperscriptIntakeQuestionOrThrowArgs = {
    cursor?: InputMaybe<SuperscriptIntakeQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptIntakeQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<SuperscriptIntakeQuestionOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
};

export type QueryFindFirstTimeBlockArgs = {
    cursor?: InputMaybe<TimeBlockWhereUniqueInput>;
    distinct?: InputMaybe<Array<TimeBlockScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<TimeBlockOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TimeBlockWhereInput>;
};

export type QueryFindFirstTimeBlockOrThrowArgs = {
    cursor?: InputMaybe<TimeBlockWhereUniqueInput>;
    distinct?: InputMaybe<Array<TimeBlockScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<TimeBlockOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TimeBlockWhereInput>;
};

export type QueryFindFirstTransactionArgs = {
    cursor?: InputMaybe<TransactionWhereUniqueInput>;
    distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TransactionWhereInput>;
};

export type QueryFindFirstTransactionOrThrowArgs = {
    cursor?: InputMaybe<TransactionWhereUniqueInput>;
    distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TransactionWhereInput>;
};

export type QueryFindFirstUserArgs = {
    cursor?: InputMaybe<UserWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserWhereInput>;
};

export type QueryFindFirstUserAuditLogArgs = {
    cursor?: InputMaybe<UserAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserAuditLogWhereInput>;
};

export type QueryFindFirstUserAuditLogOrThrowArgs = {
    cursor?: InputMaybe<UserAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserAuditLogWhereInput>;
};

export type QueryFindFirstUserOrThrowArgs = {
    cursor?: InputMaybe<UserWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserWhereInput>;
};

export type QueryFindFirstUserPracticeVisitArgs = {
    cursor?: InputMaybe<UserPracticeVisitWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserPracticeVisitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserPracticeVisitOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserPracticeVisitWhereInput>;
};

export type QueryFindFirstUserPracticeVisitOrThrowArgs = {
    cursor?: InputMaybe<UserPracticeVisitWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserPracticeVisitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserPracticeVisitOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserPracticeVisitWhereInput>;
};

export type QueryFindFirstUserToNewUserArgs = {
    cursor?: InputMaybe<UserToNewUserWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserToNewUserScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserToNewUserOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserToNewUserWhereInput>;
};

export type QueryFindFirstUserToNewUserOrThrowArgs = {
    cursor?: InputMaybe<UserToNewUserWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserToNewUserScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserToNewUserOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserToNewUserWhereInput>;
};

export type QueryFindFirstValidPayersArgs = {
    cursor?: InputMaybe<ValidPayersWhereUniqueInput>;
    distinct?: InputMaybe<Array<ValidPayersScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ValidPayersOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ValidPayersWhereInput>;
};

export type QueryFindFirstValidPayersOrThrowArgs = {
    cursor?: InputMaybe<ValidPayersWhereUniqueInput>;
    distinct?: InputMaybe<Array<ValidPayersScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ValidPayersOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ValidPayersWhereInput>;
};

export type QueryFindManyAthenaMedicationsArgs = {
    cursor?: InputMaybe<AthenaMedicationsWhereUniqueInput>;
    distinct?: InputMaybe<Array<AthenaMedicationsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<AthenaMedicationsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaMedicationsWhereInput>;
};

export type QueryFindManyBenefitParsingRulesArgs = {
    cursor?: InputMaybe<BenefitParsingRulesWhereUniqueInput>;
    distinct?: InputMaybe<Array<BenefitParsingRulesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BenefitParsingRulesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BenefitParsingRulesWhereInput>;
};

export type QueryFindManyCheckNetworkStatusResultsArgs = {
    cursor?: InputMaybe<CheckNetworkStatusResultsWhereUniqueInput>;
    distinct?: InputMaybe<Array<CheckNetworkStatusResultsScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<CheckNetworkStatusResultsOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CheckNetworkStatusResultsWhereInput>;
};

export type QueryFindManyConsumerPhotoMetaDataArgs = {
    cursor?: InputMaybe<ConsumerPhotoMetaDataWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerPhotoMetaDataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerPhotoMetaDataOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type QueryFindManyConsumerSrtRecordsArgs = {
    cursor?: InputMaybe<ConsumerSrtRecordsWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerSrtRecordsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerSrtRecordsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerSrtRecordsWhereInput>;
};

export type QueryFindManyCoverageResponsesArgs = {
    cursor?: InputMaybe<CoverageResponsesWhereUniqueInput>;
    distinct?: InputMaybe<Array<CoverageResponsesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CoverageResponsesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CoverageResponsesWhereInput>;
};

export type QueryFindManyDataMigrationsArgs = {
    cursor?: InputMaybe<DataMigrationsWhereUniqueInput>;
    distinct?: InputMaybe<Array<DataMigrationsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DataMigrationsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DataMigrationsWhereInput>;
};

export type QueryFindManyDefaultProvidersArgs = {
    cursor?: InputMaybe<DefaultProvidersWhereUniqueInput>;
    distinct?: InputMaybe<Array<DefaultProvidersScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DefaultProvidersOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultProvidersWhereInput>;
};

export type QueryFindManyDiscountCodesArgs = {
    cursor?: InputMaybe<DiscountCodesWhereUniqueInput>;
    distinct?: InputMaybe<Array<DiscountCodesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<DiscountCodesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DiscountCodesWhereInput>;
};

export type QueryFindManyFaqDropdownsArgs = {
    cursor?: InputMaybe<FaqDropdownsWhereUniqueInput>;
    distinct?: InputMaybe<Array<FaqDropdownsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<FaqDropdownsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FaqDropdownsWhereInput>;
};

export type QueryFindManyHrtFlagsArgs = {
    cursor?: InputMaybe<HrtFlagsWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtFlagsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtFlagsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtFlagsWhereInput>;
};

export type QueryFindManyInsuranceMetadataArgs = {
    cursor?: InputMaybe<InsuranceMetadataWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceMetadataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceMetadataOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceMetadataWhereInput>;
};

export type QueryFindManyInvoiceDailyLineItemsArgs = {
    cursor?: InputMaybe<InvoiceDailyLineItemsWhereUniqueInput>;
    distinct?: InputMaybe<Array<InvoiceDailyLineItemsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InvoiceDailyLineItemsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
};

export type QueryFindManyInvoicesArgs = {
    cursor?: InputMaybe<InvoicesWhereUniqueInput>;
    distinct?: InputMaybe<Array<InvoicesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InvoicesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoicesWhereInput>;
};

export type QueryFindManyLiveTransfersArgs = {
    cursor?: InputMaybe<LiveTransfersWhereUniqueInput>;
    distinct?: InputMaybe<Array<LiveTransfersScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<LiveTransfersOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<LiveTransfersWhereInput>;
};

export type QueryFindManyMigrationsArgs = {
    cursor?: InputMaybe<MigrationsWhereUniqueInput>;
    distinct?: InputMaybe<Array<MigrationsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MigrationsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MigrationsWhereInput>;
};

export type QueryFindManyNetworkPlanExceptionsArgs = {
    cursor?: InputMaybe<NetworkPlanExceptionsWhereUniqueInput>;
    distinct?: InputMaybe<Array<NetworkPlanExceptionsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<NetworkPlanExceptionsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NetworkPlanExceptionsWhereInput>;
};

export type QueryFindManyNonCardRefundsArgs = {
    cursor?: InputMaybe<NonCardRefundsWhereUniqueInput>;
    distinct?: InputMaybe<Array<NonCardRefundsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<NonCardRefundsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NonCardRefundsWhereInput>;
};

export type QueryFindManyOrgNetworkResultsArgs = {
    cursor?: InputMaybe<OrgNetworkResultsWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgNetworkResultsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgNetworkResultsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgNetworkResultsWhereInput>;
};

export type QueryFindManyOrgFeesArgs = {
    cursor?: InputMaybe<OrgFeesWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgFeesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgFeesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgFeesWhereInput>;
};

export type QueryFindManyOrganizationAssetsArgs = {
    cursor?: InputMaybe<OrganizationAssetsWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrganizationAssetsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrganizationAssetsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type QueryFindManyPracticeHoursArgs = {
    cursor?: InputMaybe<PracticeHoursWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeHoursScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeHoursOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursWhereInput>;
};

export type QueryFindManyPracticeHoursOverridesArgs = {
    cursor?: InputMaybe<PracticeHoursOverridesWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeHoursOverridesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeHoursOverridesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursOverridesWhereInput>;
};

export type QueryFindManyPricingResultsArgs = {
    cursor?: InputMaybe<PricingResultsWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingResultsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingResultsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingResultsWhereInput>;
};

export type QueryFindManyProcedureBenefitParsingRulesArgs = {
    cursor?: InputMaybe<ProcedureBenefitParsingRulesWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProcedureBenefitParsingRulesScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProcedureBenefitParsingRulesOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProcedureBenefitParsingRulesWhereInput>;
};

export type QueryFindManyProductCategoriesArgs = {
    cursor?: InputMaybe<ProductCategoriesWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductCategoriesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductCategoriesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoriesWhereInput>;
};

export type QueryFindManyProductsArgs = {
    cursor?: InputMaybe<ProductsWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductsWhereInput>;
};

export type QueryFindManySrtFlagsArgs = {
    cursor?: InputMaybe<SrtFlagsWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtFlagsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtFlagsOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtFlagsWhereInput>;
};

export type QueryFindManySuperscriptFeesArgs = {
    cursor?: InputMaybe<SuperscriptFeesWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptFeesScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SuperscriptFeesOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type QueryFindManyValidPayersArgs = {
    cursor?: InputMaybe<ValidPayersWhereUniqueInput>;
    distinct?: InputMaybe<Array<ValidPayersScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ValidPayersOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ValidPayersWhereInput>;
};

export type QueryFindUniqueAthenaMedicationsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaMedicationsWhereUniqueInput;
};

export type QueryFindUniqueAthenaMedicationsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaMedicationsWhereUniqueInput;
};

export type QueryFindUniqueBenefitParsingRulesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BenefitParsingRulesWhereUniqueInput;
};

export type QueryFindUniqueBenefitParsingRulesOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BenefitParsingRulesWhereUniqueInput;
};

export type QueryFindUniqueCheckNetworkStatusResultsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CheckNetworkStatusResultsWhereUniqueInput;
};

export type QueryFindUniqueCheckNetworkStatusResultsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CheckNetworkStatusResultsWhereUniqueInput;
};

export type QueryFindUniqueConsumerPhotoMetaDataArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type QueryFindUniqueConsumerPhotoMetaDataOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerPhotoMetaDataWhereUniqueInput;
};

export type QueryFindUniqueConsumerSrtRecordsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerSrtRecordsWhereUniqueInput;
};

export type QueryFindUniqueConsumerSrtRecordsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerSrtRecordsWhereUniqueInput;
};

export type QueryFindUniqueCoverageResponsesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CoverageResponsesWhereUniqueInput;
};

export type QueryFindUniqueCoverageResponsesOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CoverageResponsesWhereUniqueInput;
};

export type QueryFindUniqueDataMigrationsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DataMigrationsWhereUniqueInput;
};

export type QueryFindUniqueDataMigrationsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DataMigrationsWhereUniqueInput;
};

export type QueryFindUniqueDefaultProvidersArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DefaultProvidersWhereUniqueInput;
};

export type QueryFindUniqueDefaultProvidersOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DefaultProvidersWhereUniqueInput;
};

export type QueryFindUniqueDiscountCodesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DiscountCodesWhereUniqueInput;
};

export type QueryFindUniqueDiscountCodesOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DiscountCodesWhereUniqueInput;
};

export type QueryFindUniqueFaqDropdownsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FaqDropdownsWhereUniqueInput;
};

export type QueryFindUniqueFaqDropdownsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FaqDropdownsWhereUniqueInput;
};

export type QueryFindUniqueHrtFlagsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtFlagsWhereUniqueInput;
};

export type QueryFindUniqueHrtFlagsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtFlagsWhereUniqueInput;
};

export type QueryFindUniqueInsuranceMetadataArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceMetadataWhereUniqueInput;
};

export type QueryFindUniqueInsuranceMetadataOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceMetadataWhereUniqueInput;
};

export type QueryFindUniqueInvoiceDailyLineItemsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InvoiceDailyLineItemsWhereUniqueInput;
};

export type QueryFindUniqueInvoiceDailyLineItemsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InvoiceDailyLineItemsWhereUniqueInput;
};

export type QueryFindUniqueInvoicesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InvoicesWhereUniqueInput;
};

export type QueryFindUniqueInvoicesOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InvoicesWhereUniqueInput;
};

export type QueryFindUniqueLiveTransfersArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: LiveTransfersWhereUniqueInput;
};

export type QueryFindUniqueLiveTransfersOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: LiveTransfersWhereUniqueInput;
};

export type QueryFindUniqueMigrationsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MigrationsWhereUniqueInput;
};

export type QueryFindUniqueMigrationsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MigrationsWhereUniqueInput;
};

export type QueryFindUniqueNetworkPlanExceptionsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NetworkPlanExceptionsWhereUniqueInput;
};

export type QueryFindUniqueNetworkPlanExceptionsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NetworkPlanExceptionsWhereUniqueInput;
};

export type QueryFindUniqueNonCardRefundsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NonCardRefundsWhereUniqueInput;
};

export type QueryFindUniqueNonCardRefundsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NonCardRefundsWhereUniqueInput;
};

export type QueryFindUniqueOrgNetworkResultsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgNetworkResultsWhereUniqueInput;
};

export type QueryFindUniqueOrgNetworkResultsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgNetworkResultsWhereUniqueInput;
};

export type QueryFindUniqueOrgFeesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgFeesWhereUniqueInput;
};

export type QueryFindUniqueOrgFeesOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgFeesWhereUniqueInput;
};

export type QueryFindUniqueOrganizationAssetsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationAssetsWhereUniqueInput;
};

export type QueryFindUniqueOrganizationAssetsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationAssetsWhereUniqueInput;
};

export type QueryFindUniquePracticeHoursArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeHoursWhereUniqueInput;
};

export type QueryFindUniquePracticeHoursOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeHoursWhereUniqueInput;
};

export type QueryFindUniquePracticeHoursOverridesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeHoursOverridesWhereUniqueInput;
};

export type QueryFindUniquePracticeHoursOverridesOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeHoursOverridesWhereUniqueInput;
};

export type QueryFindUniquePricingResultsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingResultsWhereUniqueInput;
};

export type QueryFindUniquePricingResultsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingResultsWhereUniqueInput;
};

export type QueryFindUniqueProcedureBenefitParsingRulesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProcedureBenefitParsingRulesWhereUniqueInput;
};

export type QueryFindUniqueProcedureBenefitParsingRulesOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProcedureBenefitParsingRulesWhereUniqueInput;
};

export type QueryFindUniqueProductCategoriesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductCategoriesWhereUniqueInput;
};

export type QueryFindUniqueProductCategoriesOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductCategoriesWhereUniqueInput;
};

export type QueryFindUniqueProductsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductsWhereUniqueInput;
};

export type QueryFindUniqueProductsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductsWhereUniqueInput;
};

export type QueryFindUniqueSrtFlagsArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtFlagsWhereUniqueInput;
};

export type QueryFindUniqueSrtFlagsOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtFlagsWhereUniqueInput;
};

export type QueryFindUniqueSuperscriptFeesArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptFeesWhereUniqueInput;
};

export type QueryFindUniqueSuperscriptFeesOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptFeesWhereUniqueInput;
};

export type QueryFindUniqueValidPayersArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ValidPayersWhereUniqueInput;
};

export type QueryFindUniqueValidPayersOrThrowArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ValidPayersWhereUniqueInput;
};

export type QueryGetAleConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AleConfigWhereUniqueInput;
};

export type QueryGetAleDepartmentGoLiveArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AleDepartmentGoLiveWhereUniqueInput;
};

export type QueryGetAdjudicationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjudicationWhereUniqueInput;
};

export type QueryGetAdjudicationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjudicationAuditLogWhereUniqueInput;
};

export type QueryGetAdjustmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjustmentWhereUniqueInput;
};

export type QueryGetAdjustmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdjustmentAuditLogWhereUniqueInput;
};

export type QueryGetAdminArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdminWhereUniqueInput;
};

export type QueryGetAdminInteractionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AdminInteractionWhereUniqueInput;
};

export type QueryGetAppointmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AppointmentWhereUniqueInput;
};

export type QueryGetAppointmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AppointmentAuditLogWhereUniqueInput;
};

export type QueryGetArrearBillingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArrearBillingWhereUniqueInput;
};

export type QueryGetArtClaimArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimWhereUniqueInput;
};

export type QueryGetArtClaimAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimAuditLogWhereUniqueInput;
};

export type QueryGetArtClaimCptLineArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimCptLineWhereUniqueInput;
};

export type QueryGetArtClaimCptLineAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtClaimCptLineAuditLogWhereUniqueInput;
};

export type QueryGetArtOrgConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtOrgConfigWhereUniqueInput;
};

export type QueryGetArtPracticeConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ArtPracticeConfigWhereUniqueInput;
};

export type QueryGetAthenaPharmacyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaPharmacyWhereUniqueInput;
};

export type QueryGetAthenaProviderArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: AthenaProviderWhereUniqueInput;
};

export type QueryGetBillingCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BillingCodeWhereUniqueInput;
};

export type QueryGetBillingTableDownloadRequestArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BillingTableDownloadRequestWhereUniqueInput;
};

export type QueryGetBoughtTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentWhereUniqueInput;
};

export type QueryGetBoughtTreatmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentAuditLogWhereUniqueInput;
};

export type QueryGetBoughtTreatmentClaimDetailArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BoughtTreatmentClaimDetailWhereUniqueInput;
};

export type QueryGetBulkChargeCardRunArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BulkChargeCardRunWhereUniqueInput;
};

export type QueryGetBulkChargeCardRunItemArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BulkChargeCardRunItemWhereUniqueInput;
};

export type QueryGetBundleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BundleWhereUniqueInput;
};

export type QueryGetBundleToHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BundleToHrtWhereUniqueInput;
};

export type QueryGetBusinessHourArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: BusinessHourWhereUniqueInput;
};

export type QueryGetCandidateTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CandidateTreatmentWhereUniqueInput;
};

export type QueryGetCardAuthorizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CardAuthorizationWhereUniqueInput;
};

export type QueryGetCardAuthorizationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CardAuthorizationAuditLogWhereUniqueInput;
};

export type QueryGetCashPriceArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CashPriceWhereUniqueInput;
};

export type QueryGetChargeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeWhereUniqueInput;
};

export type QueryGetChargeAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeAuditLogWhereUniqueInput;
};

export type QueryGetChargeReattributionAndPartialPaymentLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeReattributionAndPartialPaymentLogWhereUniqueInput;
};

export type QueryGetChargeReattributionLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ChargeReattributionLogWhereUniqueInput;
};

export type QueryGetCheckoutAdjudicationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CheckoutAdjudicationWhereUniqueInput;
};

export type QueryGetClaimToBoughtTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ClaimToBoughtTreatmentWhereUniqueInput;
};

export type QueryGetConfigCommitArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigCommitWhereUniqueInput;
};

export type QueryGetConfigFlagArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigFlagWhereUniqueInput;
};

export type QueryGetConfigSessionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConfigSessionWhereUniqueInput;
};

export type QueryGetConsentFormArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsentFormWhereUniqueInput;
};

export type QueryGetConsumerArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerWhereUniqueInput;
};

export type QueryGetConsumerAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerAuditLogWhereUniqueInput;
};

export type QueryGetConsumerByNameArgs = {
    consumerName: Scalars['String']['input'];
    orgId: Scalars['Float']['input'];
};

export type QueryGetConsumerMessageArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerMessageWhereUniqueInput;
};

export type QueryGetConsumerNoteArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ConsumerNoteWhereUniqueInput;
};

export type QueryGetContractArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ContractWhereUniqueInput;
};

export type QueryGetContractAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ContractAuditLogWhereUniqueInput;
};

export type QueryGetCptExclusivityEdgeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CptExclusivityEdgeWhereUniqueInput;
};

export type QueryGetCustomFieldArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CustomFieldWhereUniqueInput;
};

export type QueryGetCustomFieldValueArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: CustomFieldValueWhereUniqueInput;
};

export type QueryGetDefaultPracticeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DefaultPracticeWhereUniqueInput;
};

export type QueryGetDeploymentOrgPhaseArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgPhaseWhereUniqueInput;
};

export type QueryGetDeploymentOrgTaskArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgTaskWhereUniqueInput;
};

export type QueryGetDeploymentOrgTaskDependencyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentOrgTaskDependencyWhereUniqueInput;
};

export type QueryGetDeploymentPhaseArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentPhaseWhereUniqueInput;
};

export type QueryGetDeploymentTaskArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTaskWhereUniqueInput;
};

export type QueryGetDeploymentTaskDependencyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTaskDependencyWhereUniqueInput;
};

export type QueryGetDeploymentTeamArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: DeploymentTeamWhereUniqueInput;
};

export type QueryGetEcwPayerAliasArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EcwPayerAliasWhereUniqueInput;
};

export type QueryGetEcwPayerStcArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EcwPayerStcWhereUniqueInput;
};

export type QueryGetEhrAppointmentTypeIdToNameArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrAppointmentTypeIdToNameWhereUniqueInput;
};

export type QueryGetEhrPaymentDescriptorArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDescriptorWhereUniqueInput;
};

export type QueryGetEhrPaymentDescriptorAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDescriptorAuditLogWhereUniqueInput;
};

export type QueryGetEhrPaymentDirectionSsAssetArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPaymentDirectionSsAssetWhereUniqueInput;
};

export type QueryGetEhrPostDetailArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostDetailWhereUniqueInput;
};

export type QueryGetEhrPostDetailToPayoutArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostDetailToPayoutWhereUniqueInput;
};

export type QueryGetEhrPostLedgerArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerWhereUniqueInput;
};

export type QueryGetEhrPostLedgerAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerAuditLogWhereUniqueInput;
};

export type QueryGetEhrPostLedgerToPayoutArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPostLedgerToPayoutWhereUniqueInput;
};

export type QueryGetEhrPrimaryCareProviderArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrPrimaryCareProviderWhereUniqueInput;
};

export type QueryGetEhrProviderMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrProviderMappingWhereUniqueInput;
};

export type QueryGetEhrSlotArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrSlotWhereUniqueInput;
};

export type QueryGetEhrSlotAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EhrSlotAuditLogWhereUniqueInput;
};

export type QueryGetEncounterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: EncounterWhereUniqueInput;
};

export type QueryGetExperityEncounterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ExperityEncounterWhereUniqueInput;
};

export type QueryGetFeeConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FeeConfigWhereUniqueInput;
};

export type QueryGetFeeConfigAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: FeeConfigAuditLogWhereUniqueInput;
};

export type QueryGetGuarantorPaymentLinkContextArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: GuarantorPaymentLinkContextWhereUniqueInput;
};

export type QueryGetHolidayArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HolidayWhereUniqueInput;
};

export type QueryGetHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtWhereUniqueInput;
};

export type QueryGetHrtPaymentTypeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtPaymentTypeWhereUniqueInput;
};

export type QueryGetHrtToSrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtToSrtWhereUniqueInput;
};

export type QueryGetHrtTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtTranslationWhereUniqueInput;
};

export type QueryGetInboundRequestLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InboundRequestLogWhereUniqueInput;
};

export type QueryGetInboundTextMessageLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InboundTextMessageLogWhereUniqueInput;
};

export type QueryGetInsuranceArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceWhereUniqueInput;
};

export type QueryGetInsuranceAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceAuditLogWhereUniqueInput;
};

export type QueryGetIntakeFormArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormWhereUniqueInput;
};

export type QueryGetIntakeFormSectionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormSectionWhereUniqueInput;
};

export type QueryGetIntakeFormSectionTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormSectionTranslationWhereUniqueInput;
};

export type QueryGetIntakeFormToQuestionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormToQuestionWhereUniqueInput;
};

export type QueryGetIntakeQuestionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeQuestionWhereUniqueInput;
};

export type QueryGetIntakeQuestionTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeQuestionTranslationWhereUniqueInput;
};

export type QueryGetKeywordRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: KeywordRuleWhereUniqueInput;
};

export type QueryGetLinkMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: LinkMappingWhereUniqueInput;
};

export type QueryGetMcmsAssociationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationWhereUniqueInput;
};

export type QueryGetMcmsAssociationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationAuditLogWhereUniqueInput;
};

export type QueryGetMcmsAssociationClaimArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationClaimWhereUniqueInput;
};

export type QueryGetMcmsAssociationClaimAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationClaimAuditLogWhereUniqueInput;
};

export type QueryGetMcmsAssociationSlotArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationSlotWhereUniqueInput;
};

export type QueryGetMcmsAssociationSlotAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationSlotAuditLogWhereUniqueInput;
};

export type QueryGetMessageBlueprintArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageBlueprintWhereUniqueInput;
};

export type QueryGetMessageConsolidationContextArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageConsolidationContextWhereUniqueInput;
};

export type QueryGetMessageConsolidationTemplateArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageConsolidationTemplateWhereUniqueInput;
};

export type QueryGetMessageNudgeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageNudgeWhereUniqueInput;
};

export type QueryGetMessageOrchestrationRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageOrchestrationRuleWhereUniqueInput;
};

export type QueryGetMessagePayAfterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessagePayAfterWhereUniqueInput;
};

export type QueryGetMessageSettingsHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageSettingsHrtWhereUniqueInput;
};

export type QueryGetMessageSettingsOrgArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageSettingsOrgWhereUniqueInput;
};

export type QueryGetMessageTemplateHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageTemplateHrtWhereUniqueInput;
};

export type QueryGetMessageTemplateOrgArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageTemplateOrgWhereUniqueInput;
};

export type QueryGetMigratedEncounterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MigratedEncounterWhereUniqueInput;
};

export type QueryGetNetworkValidationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NetworkValidationWhereUniqueInput;
};

export type QueryGetOrgConfigFlagArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgConfigFlagWhereUniqueInput;
};

export type QueryGetOrgHrtSrtRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgHrtSrtRuleWhereUniqueInput;
};

export type QueryGetOrgOverrideRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgOverrideRuleWhereUniqueInput;
};

export type QueryGetOrgStripeMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgStripeMappingWhereUniqueInput;
};

export type QueryGetOrganizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationWhereUniqueInput;
};

export type QueryGetOrganizationTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationTranslationWhereUniqueInput;
};

export type QueryGetPayLaterAuthorizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayLaterAuthorizationWhereUniqueInput;
};

export type QueryGetPayLaterAuthorizationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayLaterAuthorizationAuditLogWhereUniqueInput;
};

export type QueryGetPayerArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerWhereUniqueInput;
};

export type QueryGetPayerPlanMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerPlanMappingWhereUniqueInput;
};

export type QueryGetPayerToEhrInsurancePackageMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
};

export type QueryGetPaymentAuthorizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentAuthorizationWhereUniqueInput;
};

export type QueryGetPaymentAuthorizationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentAuthorizationAuditLogWhereUniqueInput;
};

export type QueryGetPaymentContractArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentContractWhereUniqueInput;
};

export type QueryGetPaymentPlanArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanWhereUniqueInput;
};

export type QueryGetPaymentPlanAdjustmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAdjustmentWhereUniqueInput;
};

export type QueryGetPaymentPlanAdjustmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAdjustmentAuditLogWhereUniqueInput;
};

export type QueryGetPaymentPlanAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAuditLogWhereUniqueInput;
};

export type QueryGetPaymentPlanAutoChargeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAutoChargeWhereUniqueInput;
};

export type QueryGetPaymentPlanAutoChargeAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAutoChargeAuditLogWhereUniqueInput;
};

export type QueryGetPaymentPlanBoughtTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanBoughtTreatmentWhereUniqueInput;
};

export type QueryGetPaymentPlanBoughtTreatmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanBoughtTreatmentAuditLogWhereUniqueInput;
};

export type QueryGetPaymentPlanOrgConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanOrgConfigWhereUniqueInput;
};

export type QueryGetPaymentPlanOrgConfigAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanOrgConfigAuditLogWhereUniqueInput;
};

export type QueryGetPayoutArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayoutWhereUniqueInput;
};

export type QueryGetPayoutAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayoutAuditLogWhereUniqueInput;
};

export type QueryGetPendingVoidPayoutReversalArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PendingVoidPayoutReversalWhereUniqueInput;
};

export type QueryGetPhoneNumberTypeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PhoneNumberTypeWhereUniqueInput;
};

export type QueryGetPlaceOfServiceCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PlaceOfServiceCodeWhereUniqueInput;
};

export type QueryGetPracticeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeWhereUniqueInput;
};

export type QueryGetPracticeConfigurationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeConfigurationWhereUniqueInput;
};

export type QueryGetPricedTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricedTreatmentWhereUniqueInput;
};

export type QueryGetPricingAttemptArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingAttemptWhereUniqueInput;
};

export type QueryGetPricingEscalatorArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingEscalatorWhereUniqueInput;
};

export type QueryGetPricingQueueArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingQueueWhereUniqueInput;
};

export type QueryGetProductCategoryTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductCategoryTranslationWhereUniqueInput;
};

export type QueryGetProductToBundleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductToBundleWhereUniqueInput;
};

export type QueryGetProductToHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductToHrtWhereUniqueInput;
};

export type QueryGetProductTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductTranslationWhereUniqueInput;
};

export type QueryGetProviderArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderWhereUniqueInput;
};

export type QueryGetProviderCredentialingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderCredentialingWhereUniqueInput;
};

export type QueryGetProviderGroupArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderGroupWhereUniqueInput;
};

export type QueryGetProviderGroupToHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type QueryGetProviderHrtMaxCountArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type QueryGetProviderTaxonomyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderTaxonomyWhereUniqueInput;
};

export type QueryGetProviderToOrgArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderToOrgWhereUniqueInput;
};

export type QueryGetProviderToProviderGroupArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderToProviderGroupWhereUniqueInput;
};

export type QueryGetReattributionDirectionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReattributionDirectionWhereUniqueInput;
};

export type QueryGetReceiptArrangementArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReceiptArrangementWhereUniqueInput;
};

export type QueryGetReservedEhrVisitArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReservedEhrVisitWhereUniqueInput;
};

export type QueryGetResetTokenArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ResetTokenWhereUniqueInput;
};

export type QueryGetSavedIntakeResponseArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SavedIntakeResponseWhereUniqueInput;
};

export type QueryGetSchedulingSlotConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SchedulingSlotConfigWhereUniqueInput;
};

export type QueryGetServiceTypeCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ServiceTypeCodeWhereUniqueInput;
};

export type QueryGetSlotArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SlotWhereUniqueInput;
};

export type QueryGetSlotAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SlotAuditLogWhereUniqueInput;
};

export type QueryGetSlotVirtualLinkArgs = {
    slotId: Scalars['String']['input'];
};

export type QueryGetSrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtWhereUniqueInput;
};

export type QueryGetSrtMultiplierRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtMultiplierRuleWhereUniqueInput;
};

export type QueryGetSrtToBillingCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtToBillingCodeWhereUniqueInput;
};

export type QueryGetStatePayerMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: StatePayerMappingWhereUniqueInput;
};

export type QueryGetSuperscriptFeeLineItemArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptFeeLineItemWhereUniqueInput;
};

export type QueryGetSuperscriptIntakeQuestionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptIntakeQuestionWhereUniqueInput;
};

export type QueryGetTimeBlockArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: TimeBlockWhereUniqueInput;
};

export type QueryGetTransactionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: TransactionWhereUniqueInput;
};

export type QueryGetUserArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserWhereUniqueInput;
};

export type QueryGetUserAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserAuditLogWhereUniqueInput;
};

export type QueryGetUserByPhoneArgs = {
    orgId: Scalars['Float']['input'];
    phoneNumber: Scalars['String']['input'];
};

export type QueryGetUserPracticeVisitArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserPracticeVisitWhereUniqueInput;
};

export type QueryGetUserToNewUserArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserToNewUserWhereUniqueInput;
};

export type QueryGroupByAleConfigArgs = {
    by: Array<AleConfigScalarFieldEnum>;
    having?: InputMaybe<AleConfigScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AleConfigOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleConfigWhereInput>;
};

export type QueryGroupByAleDepartmentGoLiveArgs = {
    by: Array<AleDepartmentGoLiveScalarFieldEnum>;
    having?: InputMaybe<AleDepartmentGoLiveScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AleDepartmentGoLiveOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AleDepartmentGoLiveWhereInput>;
};

export type QueryGroupByAdjudicationArgs = {
    by: Array<AdjudicationScalarFieldEnum>;
    having?: InputMaybe<AdjudicationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AdjudicationOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjudicationWhereInput>;
};

export type QueryGroupByAdjudicationAuditLogArgs = {
    by: Array<AdjudicationAuditLogScalarFieldEnum>;
    having?: InputMaybe<AdjudicationAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<AdjudicationAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjudicationAuditLogWhereInput>;
};

export type QueryGroupByAdjustmentArgs = {
    by: Array<AdjustmentScalarFieldEnum>;
    having?: InputMaybe<AdjustmentScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AdjustmentOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjustmentWhereInput>;
};

export type QueryGroupByAdjustmentAuditLogArgs = {
    by: Array<AdjustmentAuditLogScalarFieldEnum>;
    having?: InputMaybe<AdjustmentAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AdjustmentAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdjustmentAuditLogWhereInput>;
};

export type QueryGroupByAdminArgs = {
    by: Array<AdminScalarFieldEnum>;
    having?: InputMaybe<AdminScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AdminOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminWhereInput>;
};

export type QueryGroupByAdminInteractionArgs = {
    by: Array<AdminInteractionScalarFieldEnum>;
    having?: InputMaybe<AdminInteractionScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AdminInteractionOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AdminInteractionWhereInput>;
};

export type QueryGroupByAppointmentArgs = {
    by: Array<AppointmentScalarFieldEnum>;
    having?: InputMaybe<AppointmentScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AppointmentOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AppointmentWhereInput>;
};

export type QueryGroupByAppointmentAuditLogArgs = {
    by: Array<AppointmentAuditLogScalarFieldEnum>;
    having?: InputMaybe<AppointmentAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AppointmentAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AppointmentAuditLogWhereInput>;
};

export type QueryGroupByArrearBillingArgs = {
    by: Array<ArrearBillingScalarFieldEnum>;
    having?: InputMaybe<ArrearBillingScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ArrearBillingOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArrearBillingWhereInput>;
};

export type QueryGroupByArtClaimArgs = {
    by: Array<ArtClaimScalarFieldEnum>;
    having?: InputMaybe<ArtClaimScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ArtClaimOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimWhereInput>;
};

export type QueryGroupByArtClaimAuditLogArgs = {
    by: Array<ArtClaimAuditLogScalarFieldEnum>;
    having?: InputMaybe<ArtClaimAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ArtClaimAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimAuditLogWhereInput>;
};

export type QueryGroupByArtClaimCptLineArgs = {
    by: Array<ArtClaimCptLineScalarFieldEnum>;
    having?: InputMaybe<ArtClaimCptLineScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ArtClaimCptLineOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineWhereInput>;
};

export type QueryGroupByArtClaimCptLineAuditLogArgs = {
    by: Array<ArtClaimCptLineAuditLogScalarFieldEnum>;
    having?: InputMaybe<ArtClaimCptLineAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<ArtClaimCptLineAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtClaimCptLineAuditLogWhereInput>;
};

export type QueryGroupByArtOrgConfigArgs = {
    by: Array<ArtOrgConfigScalarFieldEnum>;
    having?: InputMaybe<ArtOrgConfigScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ArtOrgConfigOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtOrgConfigWhereInput>;
};

export type QueryGroupByArtPracticeConfigArgs = {
    by: Array<ArtPracticeConfigScalarFieldEnum>;
    having?: InputMaybe<ArtPracticeConfigScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ArtPracticeConfigOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ArtPracticeConfigWhereInput>;
};

export type QueryGroupByAthenaMedicationsArgs = {
    by: Array<AthenaMedicationsScalarFieldEnum>;
    having?: InputMaybe<AthenaMedicationsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AthenaMedicationsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaMedicationsWhereInput>;
};

export type QueryGroupByAthenaPharmacyArgs = {
    by: Array<AthenaPharmacyScalarFieldEnum>;
    having?: InputMaybe<AthenaPharmacyScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AthenaPharmacyOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaPharmacyWhereInput>;
};

export type QueryGroupByAthenaProviderArgs = {
    by: Array<AthenaProviderScalarFieldEnum>;
    having?: InputMaybe<AthenaProviderScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<AthenaProviderOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<AthenaProviderWhereInput>;
};

export type QueryGroupByBenefitParsingRulesArgs = {
    by: Array<BenefitParsingRulesScalarFieldEnum>;
    having?: InputMaybe<BenefitParsingRulesScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<BenefitParsingRulesOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BenefitParsingRulesWhereInput>;
};

export type QueryGroupByBillingCodeArgs = {
    by: Array<BillingCodeScalarFieldEnum>;
    having?: InputMaybe<BillingCodeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<BillingCodeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BillingCodeWhereInput>;
};

export type QueryGroupByBillingTableDownloadRequestArgs = {
    by: Array<BillingTableDownloadRequestScalarFieldEnum>;
    having?: InputMaybe<BillingTableDownloadRequestScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<BillingTableDownloadRequestOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BillingTableDownloadRequestWhereInput>;
};

export type QueryGroupByBoughtTreatmentArgs = {
    by: Array<BoughtTreatmentScalarFieldEnum>;
    having?: InputMaybe<BoughtTreatmentScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<BoughtTreatmentOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type QueryGroupByBoughtTreatmentAuditLogArgs = {
    by: Array<BoughtTreatmentAuditLogScalarFieldEnum>;
    having?: InputMaybe<BoughtTreatmentAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<BoughtTreatmentAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentAuditLogWhereInput>;
};

export type QueryGroupByBoughtTreatmentClaimDetailArgs = {
    by: Array<BoughtTreatmentClaimDetailScalarFieldEnum>;
    having?: InputMaybe<BoughtTreatmentClaimDetailScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<BoughtTreatmentClaimDetailOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentClaimDetailWhereInput>;
};

export type QueryGroupByBulkChargeCardRunArgs = {
    by: Array<BulkChargeCardRunScalarFieldEnum>;
    having?: InputMaybe<BulkChargeCardRunScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<BulkChargeCardRunOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunWhereInput>;
};

export type QueryGroupByBulkChargeCardRunItemArgs = {
    by: Array<BulkChargeCardRunItemScalarFieldEnum>;
    having?: InputMaybe<BulkChargeCardRunItemScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<BulkChargeCardRunItemOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BulkChargeCardRunItemWhereInput>;
};

export type QueryGroupByBundleArgs = {
    by: Array<BundleScalarFieldEnum>;
    having?: InputMaybe<BundleScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<BundleOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleWhereInput>;
};

export type QueryGroupByBundleToHrtArgs = {
    by: Array<BundleToHrtScalarFieldEnum>;
    having?: InputMaybe<BundleToHrtScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<BundleToHrtOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BundleToHrtWhereInput>;
};

export type QueryGroupByBusinessHourArgs = {
    by: Array<BusinessHourScalarFieldEnum>;
    having?: InputMaybe<BusinessHourScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<BusinessHourOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BusinessHourWhereInput>;
};

export type QueryGroupByCandidateTreatmentArgs = {
    by: Array<CandidateTreatmentScalarFieldEnum>;
    having?: InputMaybe<CandidateTreatmentScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type QueryGroupByCardAuthorizationArgs = {
    by: Array<CardAuthorizationScalarFieldEnum>;
    having?: InputMaybe<CardAuthorizationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<CardAuthorizationOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CardAuthorizationWhereInput>;
};

export type QueryGroupByCardAuthorizationAuditLogArgs = {
    by: Array<CardAuthorizationAuditLogScalarFieldEnum>;
    having?: InputMaybe<CardAuthorizationAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<CardAuthorizationAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CardAuthorizationAuditLogWhereInput>;
};

export type QueryGroupByCashPriceArgs = {
    by: Array<CashPriceScalarFieldEnum>;
    having?: InputMaybe<CashPriceScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<CashPriceOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CashPriceWhereInput>;
};

export type QueryGroupByChargeArgs = {
    by: Array<ChargeScalarFieldEnum>;
    having?: InputMaybe<ChargeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ChargeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeWhereInput>;
};

export type QueryGroupByChargeAuditLogArgs = {
    by: Array<ChargeAuditLogScalarFieldEnum>;
    having?: InputMaybe<ChargeAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ChargeAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeAuditLogWhereInput>;
};

export type QueryGroupByChargeReattributionAndPartialPaymentLogArgs = {
    by: Array<ChargeReattributionAndPartialPaymentLogScalarFieldEnum>;
    having?: InputMaybe<ChargeReattributionAndPartialPaymentLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<ChargeReattributionAndPartialPaymentLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeReattributionAndPartialPaymentLogWhereInput>;
};

export type QueryGroupByChargeReattributionLogArgs = {
    by: Array<ChargeReattributionLogScalarFieldEnum>;
    having?: InputMaybe<ChargeReattributionLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<ChargeReattributionLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeReattributionLogWhereInput>;
};

export type QueryGroupByCheckNetworkStatusResultsArgs = {
    by: Array<CheckNetworkStatusResultsScalarFieldEnum>;
    having?: InputMaybe<CheckNetworkStatusResultsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<CheckNetworkStatusResultsOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CheckNetworkStatusResultsWhereInput>;
};

export type QueryGroupByCheckoutAdjudicationArgs = {
    by: Array<CheckoutAdjudicationScalarFieldEnum>;
    having?: InputMaybe<CheckoutAdjudicationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<CheckoutAdjudicationOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CheckoutAdjudicationWhereInput>;
};

export type QueryGroupByClaimToBoughtTreatmentArgs = {
    by: Array<ClaimToBoughtTreatmentScalarFieldEnum>;
    having?: InputMaybe<ClaimToBoughtTreatmentScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<ClaimToBoughtTreatmentOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ClaimToBoughtTreatmentWhereInput>;
};

export type QueryGroupByConfigCommitArgs = {
    by: Array<ConfigCommitScalarFieldEnum>;
    having?: InputMaybe<ConfigCommitScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ConfigCommitOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigCommitWhereInput>;
};

export type QueryGroupByConfigFlagArgs = {
    by: Array<ConfigFlagScalarFieldEnum>;
    having?: InputMaybe<ConfigFlagScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ConfigFlagOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigFlagWhereInput>;
};

export type QueryGroupByConfigSessionArgs = {
    by: Array<ConfigSessionScalarFieldEnum>;
    having?: InputMaybe<ConfigSessionScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ConfigSessionOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConfigSessionWhereInput>;
};

export type QueryGroupByConsentFormArgs = {
    by: Array<ConsentFormScalarFieldEnum>;
    having?: InputMaybe<ConsentFormScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ConsentFormOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsentFormWhereInput>;
};

export type QueryGroupByConsumerArgs = {
    by: Array<ConsumerScalarFieldEnum>;
    having?: InputMaybe<ConsumerScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ConsumerOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type QueryGroupByConsumerAuditLogArgs = {
    by: Array<ConsumerAuditLogScalarFieldEnum>;
    having?: InputMaybe<ConsumerAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ConsumerAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerAuditLogWhereInput>;
};

export type QueryGroupByConsumerMessageArgs = {
    by: Array<ConsumerMessageScalarFieldEnum>;
    having?: InputMaybe<ConsumerMessageScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ConsumerMessageOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerMessageWhereInput>;
};

export type QueryGroupByConsumerNoteArgs = {
    by: Array<ConsumerNoteScalarFieldEnum>;
    having?: InputMaybe<ConsumerNoteScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ConsumerNoteOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerNoteWhereInput>;
};

export type QueryGroupByConsumerPhotoMetaDataArgs = {
    by: Array<ConsumerPhotoMetaDataScalarFieldEnum>;
    having?: InputMaybe<ConsumerPhotoMetaDataScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<ConsumerPhotoMetaDataOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type QueryGroupByConsumerSrtRecordsArgs = {
    by: Array<ConsumerSrtRecordsScalarFieldEnum>;
    having?: InputMaybe<ConsumerSrtRecordsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ConsumerSrtRecordsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerSrtRecordsWhereInput>;
};

export type QueryGroupByContractArgs = {
    by: Array<ContractScalarFieldEnum>;
    having?: InputMaybe<ContractScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ContractOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractWhereInput>;
};

export type QueryGroupByContractAuditLogArgs = {
    by: Array<ContractAuditLogScalarFieldEnum>;
    having?: InputMaybe<ContractAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ContractAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ContractAuditLogWhereInput>;
};

export type QueryGroupByCoverageResponsesArgs = {
    by: Array<CoverageResponsesScalarFieldEnum>;
    having?: InputMaybe<CoverageResponsesScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<CoverageResponsesOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CoverageResponsesWhereInput>;
};

export type QueryGroupByCptExclusivityEdgeArgs = {
    by: Array<CptExclusivityEdgeScalarFieldEnum>;
    having?: InputMaybe<CptExclusivityEdgeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<CptExclusivityEdgeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CptExclusivityEdgeWhereInput>;
};

export type QueryGroupByCustomFieldArgs = {
    by: Array<CustomFieldScalarFieldEnum>;
    having?: InputMaybe<CustomFieldScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<CustomFieldOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldWhereInput>;
};

export type QueryGroupByCustomFieldValueArgs = {
    by: Array<CustomFieldValueScalarFieldEnum>;
    having?: InputMaybe<CustomFieldValueScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<CustomFieldValueOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CustomFieldValueWhereInput>;
};

export type QueryGroupByDataMigrationsArgs = {
    by: Array<DataMigrationsScalarFieldEnum>;
    having?: InputMaybe<DataMigrationsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<DataMigrationsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DataMigrationsWhereInput>;
};

export type QueryGroupByDefaultPracticeArgs = {
    by: Array<DefaultPracticeScalarFieldEnum>;
    having?: InputMaybe<DefaultPracticeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<DefaultPracticeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultPracticeWhereInput>;
};

export type QueryGroupByDefaultProvidersArgs = {
    by: Array<DefaultProvidersScalarFieldEnum>;
    having?: InputMaybe<DefaultProvidersScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<DefaultProvidersOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DefaultProvidersWhereInput>;
};

export type QueryGroupByDeploymentOrgPhaseArgs = {
    by: Array<DeploymentOrgPhaseScalarFieldEnum>;
    having?: InputMaybe<DeploymentOrgPhaseScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<DeploymentOrgPhaseOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgPhaseWhereInput>;
};

export type QueryGroupByDeploymentOrgTaskArgs = {
    by: Array<DeploymentOrgTaskScalarFieldEnum>;
    having?: InputMaybe<DeploymentOrgTaskScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<DeploymentOrgTaskOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskWhereInput>;
};

export type QueryGroupByDeploymentOrgTaskDependencyArgs = {
    by: Array<DeploymentOrgTaskDependencyScalarFieldEnum>;
    having?: InputMaybe<DeploymentOrgTaskDependencyScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<DeploymentOrgTaskDependencyOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentOrgTaskDependencyWhereInput>;
};

export type QueryGroupByDeploymentPhaseArgs = {
    by: Array<DeploymentPhaseScalarFieldEnum>;
    having?: InputMaybe<DeploymentPhaseScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<DeploymentPhaseOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentPhaseWhereInput>;
};

export type QueryGroupByDeploymentTaskArgs = {
    by: Array<DeploymentTaskScalarFieldEnum>;
    having?: InputMaybe<DeploymentTaskScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<DeploymentTaskOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskWhereInput>;
};

export type QueryGroupByDeploymentTaskDependencyArgs = {
    by: Array<DeploymentTaskDependencyScalarFieldEnum>;
    having?: InputMaybe<DeploymentTaskDependencyScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<DeploymentTaskDependencyOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTaskDependencyWhereInput>;
};

export type QueryGroupByDeploymentTeamArgs = {
    by: Array<DeploymentTeamScalarFieldEnum>;
    having?: InputMaybe<DeploymentTeamScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<DeploymentTeamOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeploymentTeamWhereInput>;
};

export type QueryGroupByDiscountCodesArgs = {
    by: Array<DiscountCodesScalarFieldEnum>;
    having?: InputMaybe<DiscountCodesScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<DiscountCodesOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DiscountCodesWhereInput>;
};

export type QueryGroupByEcwPayerAliasArgs = {
    by: Array<EcwPayerAliasScalarFieldEnum>;
    having?: InputMaybe<EcwPayerAliasScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<EcwPayerAliasOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerAliasWhereInput>;
};

export type QueryGroupByEcwPayerStcArgs = {
    by: Array<EcwPayerStcScalarFieldEnum>;
    having?: InputMaybe<EcwPayerStcScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<EcwPayerStcOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EcwPayerStcWhereInput>;
};

export type QueryGroupByEhrAppointmentTypeIdToNameArgs = {
    by: Array<EhrAppointmentTypeIdToNameScalarFieldEnum>;
    having?: InputMaybe<EhrAppointmentTypeIdToNameScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<EhrAppointmentTypeIdToNameOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrAppointmentTypeIdToNameWhereInput>;
};

export type QueryGroupByEhrPaymentDescriptorArgs = {
    by: Array<EhrPaymentDescriptorScalarFieldEnum>;
    having?: InputMaybe<EhrPaymentDescriptorScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDescriptorOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDescriptorWhereInput>;
};

export type QueryGroupByEhrPaymentDescriptorAuditLogArgs = {
    by: Array<EhrPaymentDescriptorAuditLogScalarFieldEnum>;
    having?: InputMaybe<EhrPaymentDescriptorAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDescriptorAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDescriptorAuditLogWhereInput>;
};

export type QueryGroupByEhrPaymentDirectionSsAssetArgs = {
    by: Array<EhrPaymentDirectionSsAssetScalarFieldEnum>;
    having?: InputMaybe<EhrPaymentDirectionSsAssetScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<EhrPaymentDirectionSsAssetOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPaymentDirectionSsAssetWhereInput>;
};

export type QueryGroupByEhrPostDetailArgs = {
    by: Array<EhrPostDetailScalarFieldEnum>;
    having?: InputMaybe<EhrPostDetailScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<EhrPostDetailOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostDetailWhereInput>;
};

export type QueryGroupByEhrPostDetailToPayoutArgs = {
    by: Array<EhrPostDetailToPayoutScalarFieldEnum>;
    having?: InputMaybe<EhrPostDetailToPayoutScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<EhrPostDetailToPayoutOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostDetailToPayoutWhereInput>;
};

export type QueryGroupByEhrPostLedgerArgs = {
    by: Array<EhrPostLedgerScalarFieldEnum>;
    having?: InputMaybe<EhrPostLedgerScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<EhrPostLedgerOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerWhereInput>;
};

export type QueryGroupByEhrPostLedgerAuditLogArgs = {
    by: Array<EhrPostLedgerAuditLogScalarFieldEnum>;
    having?: InputMaybe<EhrPostLedgerAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<EhrPostLedgerAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerAuditLogWhereInput>;
};

export type QueryGroupByEhrPostLedgerToPayoutArgs = {
    by: Array<EhrPostLedgerToPayoutScalarFieldEnum>;
    having?: InputMaybe<EhrPostLedgerToPayoutScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<EhrPostLedgerToPayoutOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPostLedgerToPayoutWhereInput>;
};

export type QueryGroupByEhrPrimaryCareProviderArgs = {
    by: Array<EhrPrimaryCareProviderScalarFieldEnum>;
    having?: InputMaybe<EhrPrimaryCareProviderScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<EhrPrimaryCareProviderOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrPrimaryCareProviderWhereInput>;
};

export type QueryGroupByEhrProviderMappingArgs = {
    by: Array<EhrProviderMappingScalarFieldEnum>;
    having?: InputMaybe<EhrProviderMappingScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<EhrProviderMappingOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrProviderMappingWhereInput>;
};

export type QueryGroupByEhrSlotArgs = {
    by: Array<EhrSlotScalarFieldEnum>;
    having?: InputMaybe<EhrSlotScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<EhrSlotOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type QueryGroupByEhrSlotAuditLogArgs = {
    by: Array<EhrSlotAuditLogScalarFieldEnum>;
    having?: InputMaybe<EhrSlotAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<EhrSlotAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EhrSlotAuditLogWhereInput>;
};

export type QueryGroupByEncounterArgs = {
    by: Array<EncounterScalarFieldEnum>;
    having?: InputMaybe<EncounterScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<EncounterOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EncounterWhereInput>;
};

export type QueryGroupByExperityEncounterArgs = {
    by: Array<ExperityEncounterScalarFieldEnum>;
    having?: InputMaybe<ExperityEncounterScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ExperityEncounterOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ExperityEncounterWhereInput>;
};

export type QueryGroupByFaqDropdownsArgs = {
    by: Array<FaqDropdownsScalarFieldEnum>;
    having?: InputMaybe<FaqDropdownsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<FaqDropdownsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FaqDropdownsWhereInput>;
};

export type QueryGroupByFeeConfigArgs = {
    by: Array<FeeConfigScalarFieldEnum>;
    having?: InputMaybe<FeeConfigScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<FeeConfigOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FeeConfigWhereInput>;
};

export type QueryGroupByFeeConfigAuditLogArgs = {
    by: Array<FeeConfigAuditLogScalarFieldEnum>;
    having?: InputMaybe<FeeConfigAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<FeeConfigAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FeeConfigAuditLogWhereInput>;
};

export type QueryGroupByGuarantorPaymentLinkContextArgs = {
    by: Array<GuarantorPaymentLinkContextScalarFieldEnum>;
    having?: InputMaybe<GuarantorPaymentLinkContextScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<GuarantorPaymentLinkContextOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GuarantorPaymentLinkContextWhereInput>;
};

export type QueryGroupByHolidayArgs = {
    by: Array<HolidayScalarFieldEnum>;
    having?: InputMaybe<HolidayScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<HolidayOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HolidayWhereInput>;
};

export type QueryGroupByHrtArgs = {
    by: Array<HrtScalarFieldEnum>;
    having?: InputMaybe<HrtScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<HrtOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtWhereInput>;
};

export type QueryGroupByHrtFlagsArgs = {
    by: Array<HrtFlagsScalarFieldEnum>;
    having?: InputMaybe<HrtFlagsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<HrtFlagsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtFlagsWhereInput>;
};

export type QueryGroupByHrtPaymentTypeArgs = {
    by: Array<HrtPaymentTypeScalarFieldEnum>;
    having?: InputMaybe<HrtPaymentTypeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<HrtPaymentTypeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtPaymentTypeWhereInput>;
};

export type QueryGroupByHrtToSrtArgs = {
    by: Array<HrtToSrtScalarFieldEnum>;
    having?: InputMaybe<HrtToSrtScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<HrtToSrtOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type QueryGroupByHrtTranslationArgs = {
    by: Array<HrtTranslationScalarFieldEnum>;
    having?: InputMaybe<HrtTranslationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<HrtTranslationOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtTranslationWhereInput>;
};

export type QueryGroupByInboundRequestLogArgs = {
    by: Array<InboundRequestLogScalarFieldEnum>;
    having?: InputMaybe<InboundRequestLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<InboundRequestLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InboundRequestLogWhereInput>;
};

export type QueryGroupByInboundTextMessageLogArgs = {
    by: Array<InboundTextMessageLogScalarFieldEnum>;
    having?: InputMaybe<InboundTextMessageLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<InboundTextMessageLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InboundTextMessageLogWhereInput>;
};

export type QueryGroupByInsuranceArgs = {
    by: Array<InsuranceScalarFieldEnum>;
    having?: InputMaybe<InsuranceScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<InsuranceOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceWhereInput>;
};

export type QueryGroupByInsuranceAuditLogArgs = {
    by: Array<InsuranceAuditLogScalarFieldEnum>;
    having?: InputMaybe<InsuranceAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<InsuranceAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceAuditLogWhereInput>;
};

export type QueryGroupByInsuranceMetadataArgs = {
    by: Array<InsuranceMetadataScalarFieldEnum>;
    having?: InputMaybe<InsuranceMetadataScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<InsuranceMetadataOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceMetadataWhereInput>;
};

export type QueryGroupByIntakeFormArgs = {
    by: Array<IntakeFormScalarFieldEnum>;
    having?: InputMaybe<IntakeFormScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<IntakeFormOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type QueryGroupByIntakeFormSectionArgs = {
    by: Array<IntakeFormSectionScalarFieldEnum>;
    having?: InputMaybe<IntakeFormSectionScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<IntakeFormSectionOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type QueryGroupByIntakeFormSectionTranslationArgs = {
    by: Array<IntakeFormSectionTranslationScalarFieldEnum>;
    having?: InputMaybe<IntakeFormSectionTranslationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<IntakeFormSectionTranslationOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
};

export type QueryGroupByIntakeFormToQuestionArgs = {
    by: Array<IntakeFormToQuestionScalarFieldEnum>;
    having?: InputMaybe<IntakeFormToQuestionScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<IntakeFormToQuestionOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type QueryGroupByIntakeQuestionArgs = {
    by: Array<IntakeQuestionScalarFieldEnum>;
    having?: InputMaybe<IntakeQuestionScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<IntakeQuestionOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type QueryGroupByIntakeQuestionTranslationArgs = {
    by: Array<IntakeQuestionTranslationScalarFieldEnum>;
    having?: InputMaybe<IntakeQuestionTranslationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<IntakeQuestionTranslationOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionTranslationWhereInput>;
};

export type QueryGroupByInvoiceDailyLineItemsArgs = {
    by: Array<InvoiceDailyLineItemsScalarFieldEnum>;
    having?: InputMaybe<InvoiceDailyLineItemsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<InvoiceDailyLineItemsOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoiceDailyLineItemsWhereInput>;
};

export type QueryGroupByInvoicesArgs = {
    by: Array<InvoicesScalarFieldEnum>;
    having?: InputMaybe<InvoicesScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<InvoicesOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InvoicesWhereInput>;
};

export type QueryGroupByKeywordRuleArgs = {
    by: Array<KeywordRuleScalarFieldEnum>;
    having?: InputMaybe<KeywordRuleScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<KeywordRuleOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<KeywordRuleWhereInput>;
};

export type QueryGroupByLinkMappingArgs = {
    by: Array<LinkMappingScalarFieldEnum>;
    having?: InputMaybe<LinkMappingScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<LinkMappingOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<LinkMappingWhereInput>;
};

export type QueryGroupByLiveTransfersArgs = {
    by: Array<LiveTransfersScalarFieldEnum>;
    having?: InputMaybe<LiveTransfersScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<LiveTransfersOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<LiveTransfersWhereInput>;
};

export type QueryGroupByMcmsAssociationArgs = {
    by: Array<McmsAssociationScalarFieldEnum>;
    having?: InputMaybe<McmsAssociationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<McmsAssociationOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type QueryGroupByMcmsAssociationAuditLogArgs = {
    by: Array<McmsAssociationAuditLogScalarFieldEnum>;
    having?: InputMaybe<McmsAssociationAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<McmsAssociationAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationAuditLogWhereInput>;
};

export type QueryGroupByMcmsAssociationClaimArgs = {
    by: Array<McmsAssociationClaimScalarFieldEnum>;
    having?: InputMaybe<McmsAssociationClaimScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<McmsAssociationClaimOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimWhereInput>;
};

export type QueryGroupByMcmsAssociationClaimAuditLogArgs = {
    by: Array<McmsAssociationClaimAuditLogScalarFieldEnum>;
    having?: InputMaybe<McmsAssociationClaimAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<McmsAssociationClaimAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimAuditLogWhereInput>;
};

export type QueryGroupByMcmsAssociationSlotArgs = {
    by: Array<McmsAssociationSlotScalarFieldEnum>;
    having?: InputMaybe<McmsAssociationSlotScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<McmsAssociationSlotOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotWhereInput>;
};

export type QueryGroupByMcmsAssociationSlotAuditLogArgs = {
    by: Array<McmsAssociationSlotAuditLogScalarFieldEnum>;
    having?: InputMaybe<McmsAssociationSlotAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<McmsAssociationSlotAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotAuditLogWhereInput>;
};

export type QueryGroupByMessageBlueprintArgs = {
    by: Array<MessageBlueprintScalarFieldEnum>;
    having?: InputMaybe<MessageBlueprintScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<MessageBlueprintOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type QueryGroupByMessageConsolidationContextArgs = {
    by: Array<MessageConsolidationContextScalarFieldEnum>;
    having?: InputMaybe<MessageConsolidationContextScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationContextOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationContextWhereInput>;
};

export type QueryGroupByMessageConsolidationTemplateArgs = {
    by: Array<MessageConsolidationTemplateScalarFieldEnum>;
    having?: InputMaybe<MessageConsolidationTemplateScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationTemplateOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationTemplateWhereInput>;
};

export type QueryGroupByMessageNudgeArgs = {
    by: Array<MessageNudgeScalarFieldEnum>;
    having?: InputMaybe<MessageNudgeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<MessageNudgeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type QueryGroupByMessageOrchestrationRuleArgs = {
    by: Array<MessageOrchestrationRuleScalarFieldEnum>;
    having?: InputMaybe<MessageOrchestrationRuleScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<MessageOrchestrationRuleOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageOrchestrationRuleWhereInput>;
};

export type QueryGroupByMessagePayAfterArgs = {
    by: Array<MessagePayAfterScalarFieldEnum>;
    having?: InputMaybe<MessagePayAfterScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<MessagePayAfterOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessagePayAfterWhereInput>;
};

export type QueryGroupByMessageSettingsHrtArgs = {
    by: Array<MessageSettingsHrtScalarFieldEnum>;
    having?: InputMaybe<MessageSettingsHrtScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<MessageSettingsHrtOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageSettingsHrtWhereInput>;
};

export type QueryGroupByMessageSettingsOrgArgs = {
    by: Array<MessageSettingsOrgScalarFieldEnum>;
    having?: InputMaybe<MessageSettingsOrgScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<MessageSettingsOrgOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageSettingsOrgWhereInput>;
};

export type QueryGroupByMessageTemplateHrtArgs = {
    by: Array<MessageTemplateHrtScalarFieldEnum>;
    having?: InputMaybe<MessageTemplateHrtScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<MessageTemplateHrtOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateHrtWhereInput>;
};

export type QueryGroupByMessageTemplateOrgArgs = {
    by: Array<MessageTemplateOrgScalarFieldEnum>;
    having?: InputMaybe<MessageTemplateOrgScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<MessageTemplateOrgOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateOrgWhereInput>;
};

export type QueryGroupByMigratedEncounterArgs = {
    by: Array<MigratedEncounterScalarFieldEnum>;
    having?: InputMaybe<MigratedEncounterScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<MigratedEncounterOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MigratedEncounterWhereInput>;
};

export type QueryGroupByMigrationsArgs = {
    by: Array<MigrationsScalarFieldEnum>;
    having?: InputMaybe<MigrationsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<MigrationsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MigrationsWhereInput>;
};

export type QueryGroupByNetworkValidationArgs = {
    by: Array<NetworkValidationScalarFieldEnum>;
    having?: InputMaybe<NetworkValidationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<NetworkValidationOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NetworkValidationWhereInput>;
};

export type QueryGroupByNetworkPlanExceptionsArgs = {
    by: Array<NetworkPlanExceptionsScalarFieldEnum>;
    having?: InputMaybe<NetworkPlanExceptionsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<NetworkPlanExceptionsOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NetworkPlanExceptionsWhereInput>;
};

export type QueryGroupByNonCardRefundsArgs = {
    by: Array<NonCardRefundsScalarFieldEnum>;
    having?: InputMaybe<NonCardRefundsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<NonCardRefundsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NonCardRefundsWhereInput>;
};

export type QueryGroupByOrgConfigFlagArgs = {
    by: Array<OrgConfigFlagScalarFieldEnum>;
    having?: InputMaybe<OrgConfigFlagScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<OrgConfigFlagOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type QueryGroupByOrgHrtSrtRuleArgs = {
    by: Array<OrgHrtSrtRuleScalarFieldEnum>;
    having?: InputMaybe<OrgHrtSrtRuleScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<OrgHrtSrtRuleOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgHrtSrtRuleWhereInput>;
};

export type QueryGroupByOrgNetworkResultsArgs = {
    by: Array<OrgNetworkResultsScalarFieldEnum>;
    having?: InputMaybe<OrgNetworkResultsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<OrgNetworkResultsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgNetworkResultsWhereInput>;
};

export type QueryGroupByOrgOverrideRuleArgs = {
    by: Array<OrgOverrideRuleScalarFieldEnum>;
    having?: InputMaybe<OrgOverrideRuleScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<OrgOverrideRuleOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgOverrideRuleWhereInput>;
};

export type QueryGroupByOrgFeesArgs = {
    by: Array<OrgFeesScalarFieldEnum>;
    having?: InputMaybe<OrgFeesScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<OrgFeesOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgFeesWhereInput>;
};

export type QueryGroupByOrgStripeMappingArgs = {
    by: Array<OrgStripeMappingScalarFieldEnum>;
    having?: InputMaybe<OrgStripeMappingScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<OrgStripeMappingOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgStripeMappingWhereInput>;
};

export type QueryGroupByOrganizationArgs = {
    by: Array<OrganizationScalarFieldEnum>;
    having?: InputMaybe<OrganizationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<OrganizationOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type QueryGroupByOrganizationAssetsArgs = {
    by: Array<OrganizationAssetsScalarFieldEnum>;
    having?: InputMaybe<OrganizationAssetsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<OrganizationAssetsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationAssetsWhereInput>;
};

export type QueryGroupByOrganizationTranslationArgs = {
    by: Array<OrganizationTranslationScalarFieldEnum>;
    having?: InputMaybe<OrganizationTranslationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<OrganizationTranslationOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationTranslationWhereInput>;
};

export type QueryGroupByPayLaterAuthorizationArgs = {
    by: Array<PayLaterAuthorizationScalarFieldEnum>;
    having?: InputMaybe<PayLaterAuthorizationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PayLaterAuthorizationOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type QueryGroupByPayLaterAuthorizationAuditLogArgs = {
    by: Array<PayLaterAuthorizationAuditLogScalarFieldEnum>;
    having?: InputMaybe<PayLaterAuthorizationAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PayLaterAuthorizationAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationAuditLogWhereInput>;
};

export type QueryGroupByPayerArgs = {
    by: Array<PayerScalarFieldEnum>;
    having?: InputMaybe<PayerScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PayerOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerWhereInput>;
};

export type QueryGroupByPayerPlanMappingArgs = {
    by: Array<PayerPlanMappingScalarFieldEnum>;
    having?: InputMaybe<PayerPlanMappingScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PayerPlanMappingOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerPlanMappingWhereInput>;
};

export type QueryGroupByPayerToEhrInsurancePackageMappingArgs = {
    by: Array<PayerToEhrInsurancePackageMappingScalarFieldEnum>;
    having?: InputMaybe<PayerToEhrInsurancePackageMappingScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type QueryGroupByPaymentAuthorizationArgs = {
    by: Array<PaymentAuthorizationScalarFieldEnum>;
    having?: InputMaybe<PaymentAuthorizationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PaymentAuthorizationOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type QueryGroupByPaymentAuthorizationAuditLogArgs = {
    by: Array<PaymentAuthorizationAuditLogScalarFieldEnum>;
    having?: InputMaybe<PaymentAuthorizationAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PaymentAuthorizationAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentAuthorizationAuditLogWhereInput>;
};

export type QueryGroupByPaymentContractArgs = {
    by: Array<PaymentContractScalarFieldEnum>;
    having?: InputMaybe<PaymentContractScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PaymentContractOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentContractWhereInput>;
};

export type QueryGroupByPaymentPlanArgs = {
    by: Array<PaymentPlanScalarFieldEnum>;
    having?: InputMaybe<PaymentPlanScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PaymentPlanOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type QueryGroupByPaymentPlanAdjustmentArgs = {
    by: Array<PaymentPlanAdjustmentScalarFieldEnum>;
    having?: InputMaybe<PaymentPlanAdjustmentScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAdjustmentOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
};

export type QueryGroupByPaymentPlanAdjustmentAuditLogArgs = {
    by: Array<PaymentPlanAdjustmentAuditLogScalarFieldEnum>;
    having?: InputMaybe<PaymentPlanAdjustmentAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAdjustmentAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereInput>;
};

export type QueryGroupByPaymentPlanAuditLogArgs = {
    by: Array<PaymentPlanAuditLogScalarFieldEnum>;
    having?: InputMaybe<PaymentPlanAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PaymentPlanAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAuditLogWhereInput>;
};

export type QueryGroupByPaymentPlanAutoChargeArgs = {
    by: Array<PaymentPlanAutoChargeScalarFieldEnum>;
    having?: InputMaybe<PaymentPlanAutoChargeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAutoChargeOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
};

export type QueryGroupByPaymentPlanAutoChargeAuditLogArgs = {
    by: Array<PaymentPlanAutoChargeAuditLogScalarFieldEnum>;
    having?: InputMaybe<PaymentPlanAutoChargeAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAutoChargeAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereInput>;
};

export type QueryGroupByPaymentPlanBoughtTreatmentArgs = {
    by: Array<PaymentPlanBoughtTreatmentScalarFieldEnum>;
    having?: InputMaybe<PaymentPlanBoughtTreatmentScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
};

export type QueryGroupByPaymentPlanBoughtTreatmentAuditLogArgs = {
    by: Array<PaymentPlanBoughtTreatmentAuditLogScalarFieldEnum>;
    having?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereInput>;
};

export type QueryGroupByPaymentPlanOrgConfigArgs = {
    by: Array<PaymentPlanOrgConfigScalarFieldEnum>;
    having?: InputMaybe<PaymentPlanOrgConfigScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanOrgConfigOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanOrgConfigWhereInput>;
};

export type QueryGroupByPaymentPlanOrgConfigAuditLogArgs = {
    by: Array<PaymentPlanOrgConfigAuditLogScalarFieldEnum>;
    having?: InputMaybe<PaymentPlanOrgConfigAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PaymentPlanOrgConfigAuditLogOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereInput>;
};

export type QueryGroupByPayoutArgs = {
    by: Array<PayoutScalarFieldEnum>;
    having?: InputMaybe<PayoutScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PayoutOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutWhereInput>;
};

export type QueryGroupByPayoutAuditLogArgs = {
    by: Array<PayoutAuditLogScalarFieldEnum>;
    having?: InputMaybe<PayoutAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PayoutAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutAuditLogWhereInput>;
};

export type QueryGroupByPendingVoidPayoutReversalArgs = {
    by: Array<PendingVoidPayoutReversalScalarFieldEnum>;
    having?: InputMaybe<PendingVoidPayoutReversalScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PendingVoidPayoutReversalOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PendingVoidPayoutReversalWhereInput>;
};

export type QueryGroupByPhoneNumberTypeArgs = {
    by: Array<PhoneNumberTypeScalarFieldEnum>;
    having?: InputMaybe<PhoneNumberTypeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PhoneNumberTypeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PhoneNumberTypeWhereInput>;
};

export type QueryGroupByPlaceOfServiceCodeArgs = {
    by: Array<PlaceOfServiceCodeScalarFieldEnum>;
    having?: InputMaybe<PlaceOfServiceCodeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PlaceOfServiceCodeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type QueryGroupByPracticeArgs = {
    by: Array<PracticeScalarFieldEnum>;
    having?: InputMaybe<PracticeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PracticeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeWhereInput>;
};

export type QueryGroupByPracticeConfigurationArgs = {
    by: Array<PracticeConfigurationScalarFieldEnum>;
    having?: InputMaybe<PracticeConfigurationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PracticeConfigurationOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeConfigurationWhereInput>;
};

export type QueryGroupByPracticeHoursArgs = {
    by: Array<PracticeHoursScalarFieldEnum>;
    having?: InputMaybe<PracticeHoursScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PracticeHoursOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursWhereInput>;
};

export type QueryGroupByPracticeHoursOverridesArgs = {
    by: Array<PracticeHoursOverridesScalarFieldEnum>;
    having?: InputMaybe<PracticeHoursOverridesScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<PracticeHoursOverridesOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeHoursOverridesWhereInput>;
};

export type QueryGroupByPricedTreatmentArgs = {
    by: Array<PricedTreatmentScalarFieldEnum>;
    having?: InputMaybe<PricedTreatmentScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PricedTreatmentOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type QueryGroupByPricingAttemptArgs = {
    by: Array<PricingAttemptScalarFieldEnum>;
    having?: InputMaybe<PricingAttemptScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PricingAttemptOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type QueryGroupByPricingEscalatorArgs = {
    by: Array<PricingEscalatorScalarFieldEnum>;
    having?: InputMaybe<PricingEscalatorScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PricingEscalatorOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingEscalatorWhereInput>;
};

export type QueryGroupByPricingQueueArgs = {
    by: Array<PricingQueueScalarFieldEnum>;
    having?: InputMaybe<PricingQueueScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PricingQueueOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingQueueWhereInput>;
};

export type QueryGroupByPricingResultsArgs = {
    by: Array<PricingResultsScalarFieldEnum>;
    having?: InputMaybe<PricingResultsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<PricingResultsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingResultsWhereInput>;
};

export type QueryGroupByProcedureBenefitParsingRulesArgs = {
    by: Array<ProcedureBenefitParsingRulesScalarFieldEnum>;
    having?: InputMaybe<ProcedureBenefitParsingRulesScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<ProcedureBenefitParsingRulesOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProcedureBenefitParsingRulesWhereInput>;
};

export type QueryGroupByProductCategoriesArgs = {
    by: Array<ProductCategoriesScalarFieldEnum>;
    having?: InputMaybe<ProductCategoriesScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProductCategoriesOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoriesWhereInput>;
};

export type QueryGroupByProductCategoryTranslationArgs = {
    by: Array<ProductCategoryTranslationScalarFieldEnum>;
    having?: InputMaybe<ProductCategoryTranslationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<ProductCategoryTranslationOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoryTranslationWhereInput>;
};

export type QueryGroupByProductToBundleArgs = {
    by: Array<ProductToBundleScalarFieldEnum>;
    having?: InputMaybe<ProductToBundleScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProductToBundleOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type QueryGroupByProductToHrtArgs = {
    by: Array<ProductToHrtScalarFieldEnum>;
    having?: InputMaybe<ProductToHrtScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProductToHrtOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type QueryGroupByProductTranslationArgs = {
    by: Array<ProductTranslationScalarFieldEnum>;
    having?: InputMaybe<ProductTranslationScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProductTranslationOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductTranslationWhereInput>;
};

export type QueryGroupByProductsArgs = {
    by: Array<ProductsScalarFieldEnum>;
    having?: InputMaybe<ProductsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProductsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductsWhereInput>;
};

export type QueryGroupByProviderArgs = {
    by: Array<ProviderScalarFieldEnum>;
    having?: InputMaybe<ProviderScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProviderOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderWhereInput>;
};

export type QueryGroupByProviderCredentialingArgs = {
    by: Array<ProviderCredentialingScalarFieldEnum>;
    having?: InputMaybe<ProviderCredentialingScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<ProviderCredentialingOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderCredentialingWhereInput>;
};

export type QueryGroupByProviderGroupArgs = {
    by: Array<ProviderGroupScalarFieldEnum>;
    having?: InputMaybe<ProviderGroupScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProviderGroupOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type QueryGroupByProviderGroupToHrtArgs = {
    by: Array<ProviderGroupToHrtScalarFieldEnum>;
    having?: InputMaybe<ProviderGroupToHrtScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProviderGroupToHrtOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type QueryGroupByProviderHrtMaxCountArgs = {
    by: Array<ProviderHrtMaxCountScalarFieldEnum>;
    having?: InputMaybe<ProviderHrtMaxCountScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProviderHrtMaxCountOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type QueryGroupByProviderTaxonomyArgs = {
    by: Array<ProviderTaxonomyScalarFieldEnum>;
    having?: InputMaybe<ProviderTaxonomyScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProviderTaxonomyOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type QueryGroupByProviderToOrgArgs = {
    by: Array<ProviderToOrgScalarFieldEnum>;
    having?: InputMaybe<ProviderToOrgScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ProviderToOrgOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type QueryGroupByProviderToProviderGroupArgs = {
    by: Array<ProviderToProviderGroupScalarFieldEnum>;
    having?: InputMaybe<ProviderToProviderGroupScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<ProviderToProviderGroupOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type QueryGroupByReattributionDirectionArgs = {
    by: Array<ReattributionDirectionScalarFieldEnum>;
    having?: InputMaybe<ReattributionDirectionScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<ReattributionDirectionOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReattributionDirectionWhereInput>;
};

export type QueryGroupByReceiptArrangementArgs = {
    by: Array<ReceiptArrangementScalarFieldEnum>;
    having?: InputMaybe<ReceiptArrangementScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ReceiptArrangementOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReceiptArrangementWhereInput>;
};

export type QueryGroupByReservedEhrVisitArgs = {
    by: Array<ReservedEhrVisitScalarFieldEnum>;
    having?: InputMaybe<ReservedEhrVisitScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ReservedEhrVisitOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReservedEhrVisitWhereInput>;
};

export type QueryGroupByResetTokenArgs = {
    by: Array<ResetTokenScalarFieldEnum>;
    having?: InputMaybe<ResetTokenScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ResetTokenOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ResetTokenWhereInput>;
};

export type QueryGroupBySavedIntakeResponseArgs = {
    by: Array<SavedIntakeResponseScalarFieldEnum>;
    having?: InputMaybe<SavedIntakeResponseScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<SavedIntakeResponseOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SavedIntakeResponseWhereInput>;
};

export type QueryGroupBySchedulingSlotConfigArgs = {
    by: Array<SchedulingSlotConfigScalarFieldEnum>;
    having?: InputMaybe<SchedulingSlotConfigScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<SchedulingSlotConfigOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SchedulingSlotConfigWhereInput>;
};

export type QueryGroupByServiceTypeCodeArgs = {
    by: Array<ServiceTypeCodeScalarFieldEnum>;
    having?: InputMaybe<ServiceTypeCodeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ServiceTypeCodeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type QueryGroupBySlotArgs = {
    by: Array<SlotScalarFieldEnum>;
    having?: InputMaybe<SlotScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<SlotOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotWhereInput>;
};

export type QueryGroupBySlotAuditLogArgs = {
    by: Array<SlotAuditLogScalarFieldEnum>;
    having?: InputMaybe<SlotAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<SlotAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotAuditLogWhereInput>;
};

export type QueryGroupBySrtArgs = {
    by: Array<SrtScalarFieldEnum>;
    having?: InputMaybe<SrtScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<SrtOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtWhereInput>;
};

export type QueryGroupBySrtFlagsArgs = {
    by: Array<SrtFlagsScalarFieldEnum>;
    having?: InputMaybe<SrtFlagsScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<SrtFlagsOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtFlagsWhereInput>;
};

export type QueryGroupBySrtMultiplierRuleArgs = {
    by: Array<SrtMultiplierRuleScalarFieldEnum>;
    having?: InputMaybe<SrtMultiplierRuleScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<SrtMultiplierRuleOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtMultiplierRuleWhereInput>;
};

export type QueryGroupBySrtToBillingCodeArgs = {
    by: Array<SrtToBillingCodeScalarFieldEnum>;
    having?: InputMaybe<SrtToBillingCodeScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<SrtToBillingCodeOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtToBillingCodeWhereInput>;
};

export type QueryGroupByStatePayerMappingArgs = {
    by: Array<StatePayerMappingScalarFieldEnum>;
    having?: InputMaybe<StatePayerMappingScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<StatePayerMappingOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<StatePayerMappingWhereInput>;
};

export type QueryGroupBySuperscriptFeeLineItemArgs = {
    by: Array<SuperscriptFeeLineItemScalarFieldEnum>;
    having?: InputMaybe<SuperscriptFeeLineItemScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<SuperscriptFeeLineItemOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type QueryGroupBySuperscriptFeesArgs = {
    by: Array<SuperscriptFeesScalarFieldEnum>;
    having?: InputMaybe<SuperscriptFeesScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<SuperscriptFeesOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type QueryGroupBySuperscriptIntakeQuestionArgs = {
    by: Array<SuperscriptIntakeQuestionScalarFieldEnum>;
    having?: InputMaybe<SuperscriptIntakeQuestionScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<
        Array<SuperscriptIntakeQuestionOrderByWithAggregationInput>
    >;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
};

export type QueryGroupByTimeBlockArgs = {
    by: Array<TimeBlockScalarFieldEnum>;
    having?: InputMaybe<TimeBlockScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<TimeBlockOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TimeBlockWhereInput>;
};

export type QueryGroupByTransactionArgs = {
    by: Array<TransactionScalarFieldEnum>;
    having?: InputMaybe<TransactionScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<TransactionOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TransactionWhereInput>;
};

export type QueryGroupByUserArgs = {
    by: Array<UserScalarFieldEnum>;
    having?: InputMaybe<UserScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<UserOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserWhereInput>;
};

export type QueryGroupByUserAuditLogArgs = {
    by: Array<UserAuditLogScalarFieldEnum>;
    having?: InputMaybe<UserAuditLogScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<UserAuditLogOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserAuditLogWhereInput>;
};

export type QueryGroupByUserPracticeVisitArgs = {
    by: Array<UserPracticeVisitScalarFieldEnum>;
    having?: InputMaybe<UserPracticeVisitScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<UserPracticeVisitOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserPracticeVisitWhereInput>;
};

export type QueryGroupByUserToNewUserArgs = {
    by: Array<UserToNewUserScalarFieldEnum>;
    having?: InputMaybe<UserToNewUserScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<UserToNewUserOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserToNewUserWhereInput>;
};

export type QueryGroupByValidPayersArgs = {
    by: Array<ValidPayersScalarFieldEnum>;
    having?: InputMaybe<ValidPayersScalarWhereWithAggregatesInput>;
    orderBy?: InputMaybe<Array<ValidPayersOrderByWithAggregationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ValidPayersWhereInput>;
};

export type QueryGuarantorPaymentLinkContextArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: GuarantorPaymentLinkContextWhereUniqueInput;
};

export type QueryGuarantorPaymentLinkContextsArgs = {
    cursor?: InputMaybe<GuarantorPaymentLinkContextWhereUniqueInput>;
    distinct?: InputMaybe<Array<GuarantorPaymentLinkContextScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<GuarantorPaymentLinkContextOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GuarantorPaymentLinkContextWhereInput>;
};

export type QueryHolidayArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HolidayWhereUniqueInput;
};

export type QueryHolidaysArgs = {
    cursor?: InputMaybe<HolidayWhereUniqueInput>;
    distinct?: InputMaybe<Array<HolidayScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HolidayOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HolidayWhereInput>;
};

export type QueryHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtWhereUniqueInput;
};

export type QueryHrtPaymentTypeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtPaymentTypeWhereUniqueInput;
};

export type QueryHrtPaymentTypesArgs = {
    cursor?: InputMaybe<HrtPaymentTypeWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtPaymentTypeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtPaymentTypeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtPaymentTypeWhereInput>;
};

export type QueryHrtToSrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtToSrtWhereUniqueInput;
};

export type QueryHrtToSrtsArgs = {
    cursor?: InputMaybe<HrtToSrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtToSrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtToSrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type QueryHrtTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: HrtTranslationWhereUniqueInput;
};

export type QueryHrtTranslationsArgs = {
    cursor?: InputMaybe<HrtTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtTranslationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtTranslationWhereInput>;
};

export type QueryHrtsArgs = {
    cursor?: InputMaybe<HrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtWhereInput>;
};

export type QueryInboundRequestLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InboundRequestLogWhereUniqueInput;
};

export type QueryInboundRequestLogsArgs = {
    cursor?: InputMaybe<InboundRequestLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<InboundRequestLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InboundRequestLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InboundRequestLogWhereInput>;
};

export type QueryInboundTextMessageLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InboundTextMessageLogWhereUniqueInput;
};

export type QueryInboundTextMessageLogsArgs = {
    cursor?: InputMaybe<InboundTextMessageLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<InboundTextMessageLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InboundTextMessageLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InboundTextMessageLogWhereInput>;
};

export type QueryInsuranceArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceWhereUniqueInput;
};

export type QueryInsuranceAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: InsuranceAuditLogWhereUniqueInput;
};

export type QueryInsuranceAuditLogsArgs = {
    cursor?: InputMaybe<InsuranceAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceAuditLogWhereInput>;
};

export type QueryInsurancesArgs = {
    cursor?: InputMaybe<InsuranceWhereUniqueInput>;
    distinct?: InputMaybe<Array<InsuranceScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<InsuranceOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InsuranceWhereInput>;
};

export type QueryIntakeFormArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormWhereUniqueInput;
};

export type QueryIntakeFormSectionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormSectionWhereUniqueInput;
};

export type QueryIntakeFormSectionTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormSectionTranslationWhereUniqueInput;
};

export type QueryIntakeFormSectionTranslationsArgs = {
    cursor?: InputMaybe<IntakeFormSectionTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormSectionTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<IntakeFormSectionTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionTranslationWhereInput>;
};

export type QueryIntakeFormSectionsArgs = {
    cursor?: InputMaybe<IntakeFormSectionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormSectionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormSectionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormSectionWhereInput>;
};

export type QueryIntakeFormToQuestionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeFormToQuestionWhereUniqueInput;
};

export type QueryIntakeFormToQuestionsArgs = {
    cursor?: InputMaybe<IntakeFormToQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormToQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormToQuestionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormToQuestionWhereInput>;
};

export type QueryIntakeFormsArgs = {
    cursor?: InputMaybe<IntakeFormWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeFormScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeFormOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeFormWhereInput>;
};

export type QueryIntakeQuestionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeQuestionWhereUniqueInput;
};

export type QueryIntakeQuestionTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: IntakeQuestionTranslationWhereUniqueInput;
};

export type QueryIntakeQuestionTranslationsArgs = {
    cursor?: InputMaybe<IntakeQuestionTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeQuestionTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<IntakeQuestionTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionTranslationWhereInput>;
};

export type QueryIntakeQuestionsArgs = {
    cursor?: InputMaybe<IntakeQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeQuestionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type QueryKeywordRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: KeywordRuleWhereUniqueInput;
};

export type QueryKeywordRulesArgs = {
    cursor?: InputMaybe<KeywordRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<KeywordRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<KeywordRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<KeywordRuleWhereInput>;
};

export type QueryLinkMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: LinkMappingWhereUniqueInput;
};

export type QueryLinkMappingsArgs = {
    cursor?: InputMaybe<LinkMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<LinkMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<LinkMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<LinkMappingWhereInput>;
};

export type QueryMcmsAssociationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationWhereUniqueInput;
};

export type QueryMcmsAssociationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationAuditLogWhereUniqueInput;
};

export type QueryMcmsAssociationAuditLogsArgs = {
    cursor?: InputMaybe<McmsAssociationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<McmsAssociationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationAuditLogWhereInput>;
};

export type QueryMcmsAssociationClaimArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationClaimWhereUniqueInput;
};

export type QueryMcmsAssociationClaimAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationClaimAuditLogWhereUniqueInput;
};

export type QueryMcmsAssociationClaimAuditLogsArgs = {
    cursor?: InputMaybe<McmsAssociationClaimAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationClaimAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<McmsAssociationClaimAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimAuditLogWhereInput>;
};

export type QueryMcmsAssociationClaimsArgs = {
    cursor?: InputMaybe<McmsAssociationClaimWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationClaimScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationClaimOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationClaimWhereInput>;
};

export type QueryMcmsAssociationSlotArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationSlotWhereUniqueInput;
};

export type QueryMcmsAssociationSlotAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: McmsAssociationSlotAuditLogWhereUniqueInput;
};

export type QueryMcmsAssociationSlotAuditLogsArgs = {
    cursor?: InputMaybe<McmsAssociationSlotAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationSlotAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<McmsAssociationSlotAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotAuditLogWhereInput>;
};

export type QueryMcmsAssociationSlotsArgs = {
    cursor?: InputMaybe<McmsAssociationSlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationSlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationSlotOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationSlotWhereInput>;
};

export type QueryMcmsAssociationsArgs = {
    cursor?: InputMaybe<McmsAssociationWhereUniqueInput>;
    distinct?: InputMaybe<Array<McmsAssociationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<McmsAssociationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<McmsAssociationWhereInput>;
};

export type QueryMessageBlueprintArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageBlueprintWhereUniqueInput;
};

export type QueryMessageBlueprintsArgs = {
    cursor?: InputMaybe<MessageBlueprintWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageBlueprintScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageBlueprintOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageBlueprintWhereInput>;
};

export type QueryMessageConsolidationContextArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageConsolidationContextWhereUniqueInput;
};

export type QueryMessageConsolidationContextsArgs = {
    cursor?: InputMaybe<MessageConsolidationContextWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageConsolidationContextScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationContextOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationContextWhereInput>;
};

export type QueryMessageConsolidationTemplateArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageConsolidationTemplateWhereUniqueInput;
};

export type QueryMessageConsolidationTemplatesArgs = {
    cursor?: InputMaybe<MessageConsolidationTemplateWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageConsolidationTemplateScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<MessageConsolidationTemplateOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageConsolidationTemplateWhereInput>;
};

export type QueryMessageNudgeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageNudgeWhereUniqueInput;
};

export type QueryMessageNudgesArgs = {
    cursor?: InputMaybe<MessageNudgeWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageNudgeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageNudgeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageNudgeWhereInput>;
};

export type QueryMessageOrchestrationRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageOrchestrationRuleWhereUniqueInput;
};

export type QueryMessageOrchestrationRulesArgs = {
    cursor?: InputMaybe<MessageOrchestrationRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageOrchestrationRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<MessageOrchestrationRuleOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageOrchestrationRuleWhereInput>;
};

export type QueryMessagePayAfterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessagePayAfterWhereUniqueInput;
};

export type QueryMessagePayAftersArgs = {
    cursor?: InputMaybe<MessagePayAfterWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessagePayAfterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessagePayAfterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessagePayAfterWhereInput>;
};

export type QueryMessageSettingsHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageSettingsHrtWhereUniqueInput;
};

export type QueryMessageSettingsHrtsArgs = {
    cursor?: InputMaybe<MessageSettingsHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageSettingsHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageSettingsHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageSettingsHrtWhereInput>;
};

export type QueryMessageSettingsOrgArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageSettingsOrgWhereUniqueInput;
};

export type QueryMessageSettingsOrgsArgs = {
    cursor?: InputMaybe<MessageSettingsOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageSettingsOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageSettingsOrgOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageSettingsOrgWhereInput>;
};

export type QueryMessageTemplateHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageTemplateHrtWhereUniqueInput;
};

export type QueryMessageTemplateHrtsArgs = {
    cursor?: InputMaybe<MessageTemplateHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageTemplateHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageTemplateHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateHrtWhereInput>;
};

export type QueryMessageTemplateOrgArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MessageTemplateOrgWhereUniqueInput;
};

export type QueryMessageTemplateOrgsArgs = {
    cursor?: InputMaybe<MessageTemplateOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<MessageTemplateOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MessageTemplateOrgOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageTemplateOrgWhereInput>;
};

export type QueryMigratedEncounterArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: MigratedEncounterWhereUniqueInput;
};

export type QueryMigratedEncountersArgs = {
    cursor?: InputMaybe<MigratedEncounterWhereUniqueInput>;
    distinct?: InputMaybe<Array<MigratedEncounterScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<MigratedEncounterOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MigratedEncounterWhereInput>;
};

export type QueryNetworkValidationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: NetworkValidationWhereUniqueInput;
};

export type QueryNetworkValidationsArgs = {
    cursor?: InputMaybe<NetworkValidationWhereUniqueInput>;
    distinct?: InputMaybe<Array<NetworkValidationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<NetworkValidationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NetworkValidationWhereInput>;
};

export type QueryOrgConfigFlagArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgConfigFlagWhereUniqueInput;
};

export type QueryOrgConfigFlagsArgs = {
    cursor?: InputMaybe<OrgConfigFlagWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgConfigFlagScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgConfigFlagOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgConfigFlagWhereInput>;
};

export type QueryOrgHrtSrtRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgHrtSrtRuleWhereUniqueInput;
};

export type QueryOrgHrtSrtRulesArgs = {
    cursor?: InputMaybe<OrgHrtSrtRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgHrtSrtRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgHrtSrtRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgHrtSrtRuleWhereInput>;
};

export type QueryOrgOverrideRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgOverrideRuleWhereUniqueInput;
};

export type QueryOrgOverrideRulesArgs = {
    cursor?: InputMaybe<OrgOverrideRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgOverrideRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgOverrideRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgOverrideRuleWhereInput>;
};

export type QueryOrgStripeMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrgStripeMappingWhereUniqueInput;
};

export type QueryOrgStripeMappingsArgs = {
    cursor?: InputMaybe<OrgStripeMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrgStripeMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrgStripeMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrgStripeMappingWhereInput>;
};

export type QueryOrganizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationWhereUniqueInput;
};

export type QueryOrganizationTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: OrganizationTranslationWhereUniqueInput;
};

export type QueryOrganizationTranslationsArgs = {
    cursor?: InputMaybe<OrganizationTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrganizationTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<OrganizationTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationTranslationWhereInput>;
};

export type QueryOrganizationsArgs = {
    cursor?: InputMaybe<OrganizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<OrganizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OrganizationWhereInput>;
};

export type QueryPayLaterAuthorizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayLaterAuthorizationWhereUniqueInput;
};

export type QueryPayLaterAuthorizationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayLaterAuthorizationAuditLogWhereUniqueInput;
};

export type QueryPayLaterAuthorizationAuditLogsArgs = {
    cursor?: InputMaybe<PayLaterAuthorizationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayLaterAuthorizationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PayLaterAuthorizationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationAuditLogWhereInput>;
};

export type QueryPayLaterAuthorizationsArgs = {
    cursor?: InputMaybe<PayLaterAuthorizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayLaterAuthorizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayLaterAuthorizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type QueryPayerArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerWhereUniqueInput;
};

export type QueryPayerPlanMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerPlanMappingWhereUniqueInput;
};

export type QueryPayerPlanMappingsArgs = {
    cursor?: InputMaybe<PayerPlanMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayerPlanMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayerPlanMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerPlanMappingWhereInput>;
};

export type QueryPayerToEhrInsurancePackageMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayerToEhrInsurancePackageMappingWhereUniqueInput;
};

export type QueryPayerToEhrInsurancePackageMappingsArgs = {
    cursor?: InputMaybe<PayerToEhrInsurancePackageMappingWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<PayerToEhrInsurancePackageMappingOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerToEhrInsurancePackageMappingWhereInput>;
};

export type QueryPayersArgs = {
    cursor?: InputMaybe<PayerWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayerOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayerWhereInput>;
};

export type QueryPaymentAuthorizationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentAuthorizationWhereUniqueInput;
};

export type QueryPaymentAuthorizationAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentAuthorizationAuditLogWhereUniqueInput;
};

export type QueryPaymentAuthorizationAuditLogsArgs = {
    cursor?: InputMaybe<PaymentAuthorizationAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentAuthorizationAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentAuthorizationAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentAuthorizationAuditLogWhereInput>;
};

export type QueryPaymentAuthorizationsArgs = {
    cursor?: InputMaybe<PaymentAuthorizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentAuthorizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentAuthorizationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentAuthorizationWhereInput>;
};

export type QueryPaymentContractArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentContractWhereUniqueInput;
};

export type QueryPaymentContractsArgs = {
    cursor?: InputMaybe<PaymentContractWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentContractScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentContractOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentContractWhereInput>;
};

export type QueryPaymentPlanArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanWhereUniqueInput;
};

export type QueryPaymentPlanAdjustmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAdjustmentWhereUniqueInput;
};

export type QueryPaymentPlanAdjustmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAdjustmentAuditLogWhereUniqueInput;
};

export type QueryPaymentPlanAdjustmentAuditLogsArgs = {
    cursor?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAdjustmentAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAdjustmentAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentAuditLogWhereInput>;
};

export type QueryPaymentPlanAdjustmentsArgs = {
    cursor?: InputMaybe<PaymentPlanAdjustmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAdjustmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAdjustmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAdjustmentWhereInput>;
};

export type QueryPaymentPlanAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAuditLogWhereUniqueInput;
};

export type QueryPaymentPlanAuditLogsArgs = {
    cursor?: InputMaybe<PaymentPlanAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAuditLogWhereInput>;
};

export type QueryPaymentPlanAutoChargeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAutoChargeWhereUniqueInput;
};

export type QueryPaymentPlanAutoChargeAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanAutoChargeAuditLogWhereUniqueInput;
};

export type QueryPaymentPlanAutoChargeAuditLogsArgs = {
    cursor?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAutoChargeAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanAutoChargeAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeAuditLogWhereInput>;
};

export type QueryPaymentPlanAutoChargesArgs = {
    cursor?: InputMaybe<PaymentPlanAutoChargeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanAutoChargeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanAutoChargeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanAutoChargeWhereInput>;
};

export type QueryPaymentPlanBoughtTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanBoughtTreatmentWhereUniqueInput;
};

export type QueryPaymentPlanBoughtTreatmentAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanBoughtTreatmentAuditLogWhereUniqueInput;
};

export type QueryPaymentPlanBoughtTreatmentAuditLogsArgs = {
    cursor?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogScalarFieldEnum>
    >;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentAuditLogWhereInput>;
};

export type QueryPaymentPlanBoughtTreatmentsArgs = {
    cursor?: InputMaybe<PaymentPlanBoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanBoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanBoughtTreatmentOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanBoughtTreatmentWhereInput>;
};

export type QueryPaymentPlanOrgConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanOrgConfigWhereUniqueInput;
};

export type QueryPaymentPlanOrgConfigAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PaymentPlanOrgConfigAuditLogWhereUniqueInput;
};

export type QueryPaymentPlanOrgConfigAuditLogsArgs = {
    cursor?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanOrgConfigAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PaymentPlanOrgConfigAuditLogOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanOrgConfigAuditLogWhereInput>;
};

export type QueryPaymentPlanOrgConfigsArgs = {
    cursor?: InputMaybe<PaymentPlanOrgConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanOrgConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanOrgConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanOrgConfigWhereInput>;
};

export type QueryPaymentPlansArgs = {
    cursor?: InputMaybe<PaymentPlanWhereUniqueInput>;
    distinct?: InputMaybe<Array<PaymentPlanScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PaymentPlanOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PaymentPlanWhereInput>;
};

export type QueryPayoutArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayoutWhereUniqueInput;
};

export type QueryPayoutAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PayoutAuditLogWhereUniqueInput;
};

export type QueryPayoutAuditLogsArgs = {
    cursor?: InputMaybe<PayoutAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayoutAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayoutAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutAuditLogWhereInput>;
};

export type QueryPayoutsArgs = {
    cursor?: InputMaybe<PayoutWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayoutScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayoutWhereInput>;
};

export type QueryPendingVoidPayoutReversalArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PendingVoidPayoutReversalWhereUniqueInput;
};

export type QueryPendingVoidPayoutReversalsArgs = {
    cursor?: InputMaybe<PendingVoidPayoutReversalWhereUniqueInput>;
    distinct?: InputMaybe<Array<PendingVoidPayoutReversalScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<PendingVoidPayoutReversalOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PendingVoidPayoutReversalWhereInput>;
};

export type QueryPhoneNumberTypeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PhoneNumberTypeWhereUniqueInput;
};

export type QueryPhoneNumberTypesArgs = {
    cursor?: InputMaybe<PhoneNumberTypeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PhoneNumberTypeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PhoneNumberTypeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PhoneNumberTypeWhereInput>;
};

export type QueryPlaceOfServiceCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PlaceOfServiceCodeWhereUniqueInput;
};

export type QueryPlaceOfServiceCodesArgs = {
    cursor?: InputMaybe<PlaceOfServiceCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PlaceOfServiceCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PlaceOfServiceCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type QueryPracticeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeWhereUniqueInput;
};

export type QueryPracticeConfigurationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PracticeConfigurationWhereUniqueInput;
};

export type QueryPracticeConfigurationsArgs = {
    cursor?: InputMaybe<PracticeConfigurationWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeConfigurationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeConfigurationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeConfigurationWhereInput>;
};

export type QueryPracticesArgs = {
    cursor?: InputMaybe<PracticeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PracticeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PracticeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PracticeWhereInput>;
};

export type QueryPricedTreatmentArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricedTreatmentWhereUniqueInput;
};

export type QueryPricedTreatmentsArgs = {
    cursor?: InputMaybe<PricedTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricedTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricedTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricedTreatmentWhereInput>;
};

export type QueryPricingAttemptArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingAttemptWhereUniqueInput;
};

export type QueryPricingAttemptsArgs = {
    cursor?: InputMaybe<PricingAttemptWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingAttemptScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingAttemptOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingAttemptWhereInput>;
};

export type QueryPricingEscalatorArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingEscalatorWhereUniqueInput;
};

export type QueryPricingEscalatorsArgs = {
    cursor?: InputMaybe<PricingEscalatorWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingEscalatorScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingEscalatorOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingEscalatorWhereInput>;
};

export type QueryPricingQueueArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: PricingQueueWhereUniqueInput;
};

export type QueryPricingQueuesArgs = {
    cursor?: InputMaybe<PricingQueueWhereUniqueInput>;
    distinct?: InputMaybe<Array<PricingQueueScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PricingQueueOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PricingQueueWhereInput>;
};

export type QueryProductCategoryTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductCategoryTranslationWhereUniqueInput;
};

export type QueryProductCategoryTranslationsArgs = {
    cursor?: InputMaybe<ProductCategoryTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductCategoryTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProductCategoryTranslationOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductCategoryTranslationWhereInput>;
};

export type QueryProductToBundleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductToBundleWhereUniqueInput;
};

export type QueryProductToBundlesArgs = {
    cursor?: InputMaybe<ProductToBundleWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductToBundleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductToBundleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToBundleWhereInput>;
};

export type QueryProductToHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductToHrtWhereUniqueInput;
};

export type QueryProductToHrtsArgs = {
    cursor?: InputMaybe<ProductToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductToHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductToHrtWhereInput>;
};

export type QueryProductTranslationArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProductTranslationWhereUniqueInput;
};

export type QueryProductTranslationsArgs = {
    cursor?: InputMaybe<ProductTranslationWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProductTranslationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProductTranslationOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProductTranslationWhereInput>;
};

export type QueryProviderArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderWhereUniqueInput;
};

export type QueryProviderCredentialingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderCredentialingWhereUniqueInput;
};

export type QueryProviderCredentialingsArgs = {
    cursor?: InputMaybe<ProviderCredentialingWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderCredentialingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderCredentialingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderCredentialingWhereInput>;
};

export type QueryProviderGroupArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderGroupWhereUniqueInput;
};

export type QueryProviderGroupToHrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderGroupToHrtWhereUniqueInput;
};

export type QueryProviderGroupToHrtsArgs = {
    cursor?: InputMaybe<ProviderGroupToHrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupToHrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupToHrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupToHrtWhereInput>;
};

export type QueryProviderGroupsArgs = {
    cursor?: InputMaybe<ProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderGroupOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderGroupWhereInput>;
};

export type QueryProviderHasGlobalPeriodProceduresArgs = {
    npi: Scalars['String']['input'];
};

export type QueryProviderHrtMaxCountArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderHrtMaxCountWhereUniqueInput;
};

export type QueryProviderHrtMaxCountsArgs = {
    cursor?: InputMaybe<ProviderHrtMaxCountWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderHrtMaxCountScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderHrtMaxCountOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderHrtMaxCountWhereInput>;
};

export type QueryProviderTaxonomiesArgs = {
    cursor?: InputMaybe<ProviderTaxonomyWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderTaxonomyScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderTaxonomyOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type QueryProviderTaxonomyArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderTaxonomyWhereUniqueInput;
};

export type QueryProviderToOrgArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderToOrgWhereUniqueInput;
};

export type QueryProviderToOrgsArgs = {
    cursor?: InputMaybe<ProviderToOrgWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderToOrgScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderToOrgOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToOrgWhereInput>;
};

export type QueryProviderToProviderGroupArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ProviderToProviderGroupWhereUniqueInput;
};

export type QueryProviderToProviderGroupsArgs = {
    cursor?: InputMaybe<ProviderToProviderGroupWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderToProviderGroupScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<ProviderToProviderGroupOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderToProviderGroupWhereInput>;
};

export type QueryProvidersArgs = {
    cursor?: InputMaybe<ProviderWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderWhereInput>;
};

export type QueryReattributionDirectionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReattributionDirectionWhereUniqueInput;
};

export type QueryReattributionDirectionsArgs = {
    cursor?: InputMaybe<ReattributionDirectionWhereUniqueInput>;
    distinct?: InputMaybe<Array<ReattributionDirectionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ReattributionDirectionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReattributionDirectionWhereInput>;
};

export type QueryReceiptArrangementArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReceiptArrangementWhereUniqueInput;
};

export type QueryReceiptArrangementsArgs = {
    cursor?: InputMaybe<ReceiptArrangementWhereUniqueInput>;
    distinct?: InputMaybe<Array<ReceiptArrangementScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ReceiptArrangementOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReceiptArrangementWhereInput>;
};

export type QueryReservedEhrVisitArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ReservedEhrVisitWhereUniqueInput;
};

export type QueryReservedEhrVisitsArgs = {
    cursor?: InputMaybe<ReservedEhrVisitWhereUniqueInput>;
    distinct?: InputMaybe<Array<ReservedEhrVisitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ReservedEhrVisitOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ReservedEhrVisitWhereInput>;
};

export type QueryResetTokenArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ResetTokenWhereUniqueInput;
};

export type QueryResetTokensArgs = {
    cursor?: InputMaybe<ResetTokenWhereUniqueInput>;
    distinct?: InputMaybe<Array<ResetTokenScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ResetTokenOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ResetTokenWhereInput>;
};

export type QueryRosterBoughtTreatmentsArgs = {
    cursor?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BoughtTreatmentOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type QueryRosterSlotsArgs = {
    cursor?: InputMaybe<SlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
    orgId: Scalars['Int']['input'];
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotWhereInput>;
};

export type QuerySavedIntakeResponseArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SavedIntakeResponseWhereUniqueInput;
};

export type QuerySavedIntakeResponsesArgs = {
    cursor?: InputMaybe<SavedIntakeResponseWhereUniqueInput>;
    distinct?: InputMaybe<Array<SavedIntakeResponseScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SavedIntakeResponseOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SavedIntakeResponseWhereInput>;
};

export type QuerySchedulingSlotConfigArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SchedulingSlotConfigWhereUniqueInput;
};

export type QuerySchedulingSlotConfigsArgs = {
    cursor?: InputMaybe<SchedulingSlotConfigWhereUniqueInput>;
    distinct?: InputMaybe<Array<SchedulingSlotConfigScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SchedulingSlotConfigOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SchedulingSlotConfigWhereInput>;
};

export type QueryServiceTypeCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: ServiceTypeCodeWhereUniqueInput;
};

export type QueryServiceTypeCodesArgs = {
    cursor?: InputMaybe<ServiceTypeCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<ServiceTypeCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ServiceTypeCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type QuerySlotArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SlotWhereUniqueInput;
};

export type QuerySlotAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SlotAuditLogWhereUniqueInput;
};

export type QuerySlotAuditLogsArgs = {
    cursor?: InputMaybe<SlotAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<SlotAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SlotAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotAuditLogWhereInput>;
};

export type QuerySlotsArgs = {
    cursor?: InputMaybe<SlotWhereUniqueInput>;
    distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SlotWhereInput>;
};

export type QuerySrtArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtWhereUniqueInput;
};

export type QuerySrtMultiplierRuleArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtMultiplierRuleWhereUniqueInput;
};

export type QuerySrtMultiplierRulesArgs = {
    cursor?: InputMaybe<SrtMultiplierRuleWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtMultiplierRuleScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtMultiplierRuleOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtMultiplierRuleWhereInput>;
};

export type QuerySrtToBillingCodeArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SrtToBillingCodeWhereUniqueInput;
};

export type QuerySrtToBillingCodesArgs = {
    cursor?: InputMaybe<SrtToBillingCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtToBillingCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtToBillingCodeOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtToBillingCodeWhereInput>;
};

export type QuerySrtsArgs = {
    cursor?: InputMaybe<SrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtWhereInput>;
};

export type QueryStatePayerMappingArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: StatePayerMappingWhereUniqueInput;
};

export type QueryStatePayerMappingsArgs = {
    cursor?: InputMaybe<StatePayerMappingWhereUniqueInput>;
    distinct?: InputMaybe<Array<StatePayerMappingScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<StatePayerMappingOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<StatePayerMappingWhereInput>;
};

export type QuerySuperscriptFeeLineItemArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptFeeLineItemWhereUniqueInput;
};

export type QuerySuperscriptFeeLineItemsArgs = {
    cursor?: InputMaybe<SuperscriptFeeLineItemWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptFeeLineItemScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SuperscriptFeeLineItemOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type QuerySuperscriptIntakeQuestionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: SuperscriptIntakeQuestionWhereUniqueInput;
};

export type QuerySuperscriptIntakeQuestionsArgs = {
    cursor?: InputMaybe<SuperscriptIntakeQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptIntakeQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<
        Array<SuperscriptIntakeQuestionOrderByWithRelationInput>
    >;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
};

export type QueryTimeBlockArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: TimeBlockWhereUniqueInput;
};

export type QueryTimeBlocksArgs = {
    cursor?: InputMaybe<TimeBlockWhereUniqueInput>;
    distinct?: InputMaybe<Array<TimeBlockScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<TimeBlockOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TimeBlockWhereInput>;
};

export type QueryTransactionArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: TransactionWhereUniqueInput;
};

export type QueryTransactionsArgs = {
    cursor?: InputMaybe<TransactionWhereUniqueInput>;
    distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TransactionWhereInput>;
};

export type QueryUserArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserWhereUniqueInput;
};

export type QueryUserAuditLogArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserAuditLogWhereUniqueInput;
};

export type QueryUserAuditLogsArgs = {
    cursor?: InputMaybe<UserAuditLogWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserAuditLogScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserAuditLogOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserAuditLogWhereInput>;
};

export type QueryUserPracticeVisitArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserPracticeVisitWhereUniqueInput;
};

export type QueryUserPracticeVisitsArgs = {
    cursor?: InputMaybe<UserPracticeVisitWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserPracticeVisitScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserPracticeVisitOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserPracticeVisitWhereInput>;
};

export type QueryUserToNewUserArgs = {
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    where: UserToNewUserWhereUniqueInput;
};

export type QueryUserToNewUsersArgs = {
    cursor?: InputMaybe<UserToNewUserWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserToNewUserScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserToNewUserOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserToNewUserWhereInput>;
};

export type QueryUsersArgs = {
    cursor?: InputMaybe<UserWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
    relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserWhereInput>;
};

export enum QueryMode {
    Default = 'default',
    Insensitive = 'insensitive',
}

export enum RequestSource {
    Account = 'ACCOUNT',
    AleService = 'ALE_SERVICE',
    Companion = 'COMPANION',
    ExternalApi = 'EXTERNAL_API',
    ExternalApiBatch = 'EXTERNAL_API_BATCH',
    HexPc = 'HEX_PC',
    Kiosk = 'KIOSK',
    OvernightReprice = 'OVERNIGHT_REPRICE',
    Skylight = 'SKYLIGHT',
    Storefront = 'STOREFRONT',
}

export enum RequestType {
    CartPricingInsuranceStatus = 'CART_PRICING_INSURANCE_STATUS',
    CheckInsuranceStatus = 'CHECK_INSURANCE_STATUS',
    ExternalEligibility = 'EXTERNAL_ELIGIBILITY',
    OrgMatrixInsuranceStatus = 'ORG_MATRIX_INSURANCE_STATUS',
    PricingInsuranceStatus = 'PRICING_INSURANCE_STATUS',
    RefreshDailyStatus = 'REFRESH_DAILY_STATUS',
    RefreshMonthlyStatus = 'REFRESH_MONTHLY_STATUS',
    RefreshStatus = 'REFRESH_STATUS',
    RunCheck = 'RUN_CHECK',
}

export enum Race {
    AmericanIndianOrAlaskaNative = 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
    Asian = 'ASIAN',
    BlackOrAfricanAmerican = 'BLACK_OR_AFRICAN_AMERICAN',
    DeclineToAnswer = 'DECLINE_TO_ANSWER',
    MiddleEasternOrNorthAfrican = 'MIDDLE_EASTERN_OR_NORTH_AFRICAN',
    NativeHawaiianOrPacificIslander = 'NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER',
    Other = 'OTHER',
    White = 'WHITE',
}

export type ReattributionDirection = {
    __typename?: 'ReattributionDirection';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    destinationChargeId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostDetailId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    destinationPayoutId?: Maybe<Scalars['String']['output']>;
    destinationTransactionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    reattributionState?: Maybe<ReattributionState>;
    sourceBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    sourceChargeId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostDetailId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    sourcePayoutId?: Maybe<Scalars['String']['output']>;
    sourceTransactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ReattributionDirectionCountAggregate = {
    __typename?: 'ReattributionDirectionCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    destinationBoughtTreatmentId: Scalars['Int']['output'];
    destinationChargeId: Scalars['Int']['output'];
    destinationEhrPostDetailId: Scalars['Int']['output'];
    destinationEhrPostLedgerId: Scalars['Int']['output'];
    destinationPayoutId: Scalars['Int']['output'];
    destinationTransactionId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    reattributionState: Scalars['Int']['output'];
    sourceBoughtTreatmentId: Scalars['Int']['output'];
    sourceChargeId: Scalars['Int']['output'];
    sourceEhrPostDetailId: Scalars['Int']['output'];
    sourceEhrPostLedgerId: Scalars['Int']['output'];
    sourcePayoutId: Scalars['Int']['output'];
    sourceTransactionId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ReattributionDirectionCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    destinationBoughtTreatmentId?: InputMaybe<SortOrder>;
    destinationChargeId?: InputMaybe<SortOrder>;
    destinationEhrPostDetailId?: InputMaybe<SortOrder>;
    destinationEhrPostLedgerId?: InputMaybe<SortOrder>;
    destinationPayoutId?: InputMaybe<SortOrder>;
    destinationTransactionId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    sourceBoughtTreatmentId?: InputMaybe<SortOrder>;
    sourceChargeId?: InputMaybe<SortOrder>;
    sourceEhrPostDetailId?: InputMaybe<SortOrder>;
    sourceEhrPostLedgerId?: InputMaybe<SortOrder>;
    sourcePayoutId?: InputMaybe<SortOrder>;
    sourceTransactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ReattributionDirectionCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    destinationBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    destinationChargeId?: InputMaybe<Scalars['String']['input']>;
    destinationEhrPostDetailId?: InputMaybe<Scalars['String']['input']>;
    destinationEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    destinationPayoutId?: InputMaybe<Scalars['String']['input']>;
    destinationTransactionId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    reattributionState?: InputMaybe<ReattributionState>;
    sourceBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    sourceChargeId?: InputMaybe<Scalars['String']['input']>;
    sourceEhrPostDetailId?: InputMaybe<Scalars['String']['input']>;
    sourceEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    sourcePayoutId?: InputMaybe<Scalars['String']['input']>;
    sourceTransactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ReattributionDirectionCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    destinationBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    destinationChargeId?: InputMaybe<Scalars['String']['input']>;
    destinationEhrPostDetailId?: InputMaybe<Scalars['String']['input']>;
    destinationEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    destinationPayoutId?: InputMaybe<Scalars['String']['input']>;
    destinationTransactionId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    reattributionState?: InputMaybe<ReattributionState>;
    sourceBoughtTreatmentId?: InputMaybe<Scalars['String']['input']>;
    sourceChargeId?: InputMaybe<Scalars['String']['input']>;
    sourceEhrPostDetailId?: InputMaybe<Scalars['String']['input']>;
    sourceEhrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    sourcePayoutId?: InputMaybe<Scalars['String']['input']>;
    sourceTransactionId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ReattributionDirectionGroupBy = {
    __typename?: 'ReattributionDirectionGroupBy';
    _count?: Maybe<ReattributionDirectionCountAggregate>;
    _max?: Maybe<ReattributionDirectionMaxAggregate>;
    _min?: Maybe<ReattributionDirectionMinAggregate>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    destinationChargeId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostDetailId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    destinationPayoutId?: Maybe<Scalars['String']['output']>;
    destinationTransactionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    reattributionState?: Maybe<ReattributionState>;
    sourceBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    sourceChargeId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostDetailId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    sourcePayoutId?: Maybe<Scalars['String']['output']>;
    sourceTransactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ReattributionDirectionMaxAggregate = {
    __typename?: 'ReattributionDirectionMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    destinationChargeId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostDetailId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    destinationPayoutId?: Maybe<Scalars['String']['output']>;
    destinationTransactionId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    sourceBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    sourceChargeId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostDetailId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    sourcePayoutId?: Maybe<Scalars['String']['output']>;
    sourceTransactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ReattributionDirectionMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    destinationBoughtTreatmentId?: InputMaybe<SortOrder>;
    destinationChargeId?: InputMaybe<SortOrder>;
    destinationEhrPostDetailId?: InputMaybe<SortOrder>;
    destinationEhrPostLedgerId?: InputMaybe<SortOrder>;
    destinationPayoutId?: InputMaybe<SortOrder>;
    destinationTransactionId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    sourceBoughtTreatmentId?: InputMaybe<SortOrder>;
    sourceChargeId?: InputMaybe<SortOrder>;
    sourceEhrPostDetailId?: InputMaybe<SortOrder>;
    sourceEhrPostLedgerId?: InputMaybe<SortOrder>;
    sourcePayoutId?: InputMaybe<SortOrder>;
    sourceTransactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ReattributionDirectionMinAggregate = {
    __typename?: 'ReattributionDirectionMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    destinationBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    destinationChargeId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostDetailId?: Maybe<Scalars['String']['output']>;
    destinationEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    destinationPayoutId?: Maybe<Scalars['String']['output']>;
    destinationTransactionId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    reattributionState?: Maybe<ReattributionState>;
    sourceBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    sourceChargeId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostDetailId?: Maybe<Scalars['String']['output']>;
    sourceEhrPostLedgerId?: Maybe<Scalars['String']['output']>;
    sourcePayoutId?: Maybe<Scalars['String']['output']>;
    sourceTransactionId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ReattributionDirectionMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    destinationBoughtTreatmentId?: InputMaybe<SortOrder>;
    destinationChargeId?: InputMaybe<SortOrder>;
    destinationEhrPostDetailId?: InputMaybe<SortOrder>;
    destinationEhrPostLedgerId?: InputMaybe<SortOrder>;
    destinationPayoutId?: InputMaybe<SortOrder>;
    destinationTransactionId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrder>;
    sourceBoughtTreatmentId?: InputMaybe<SortOrder>;
    sourceChargeId?: InputMaybe<SortOrder>;
    sourceEhrPostDetailId?: InputMaybe<SortOrder>;
    sourceEhrPostLedgerId?: InputMaybe<SortOrder>;
    sourcePayoutId?: InputMaybe<SortOrder>;
    sourceTransactionId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ReattributionDirectionOrderByWithAggregationInput = {
    _count?: InputMaybe<ReattributionDirectionCountOrderByAggregateInput>;
    _max?: InputMaybe<ReattributionDirectionMaxOrderByAggregateInput>;
    _min?: InputMaybe<ReattributionDirectionMinOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrderInput>;
    destinationBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    destinationChargeId?: InputMaybe<SortOrderInput>;
    destinationEhrPostDetailId?: InputMaybe<SortOrderInput>;
    destinationEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    destinationPayoutId?: InputMaybe<SortOrderInput>;
    destinationTransactionId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrderInput>;
    sourceBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    sourceChargeId?: InputMaybe<SortOrderInput>;
    sourceEhrPostDetailId?: InputMaybe<SortOrderInput>;
    sourceEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    sourcePayoutId?: InputMaybe<SortOrderInput>;
    sourceTransactionId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export type ReattributionDirectionOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrderInput>;
    destinationBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    destinationChargeId?: InputMaybe<SortOrderInput>;
    destinationEhrPostDetailId?: InputMaybe<SortOrderInput>;
    destinationEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    destinationPayoutId?: InputMaybe<SortOrderInput>;
    destinationTransactionId?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    reattributionState?: InputMaybe<SortOrderInput>;
    sourceBoughtTreatmentId?: InputMaybe<SortOrderInput>;
    sourceChargeId?: InputMaybe<SortOrderInput>;
    sourceEhrPostDetailId?: InputMaybe<SortOrderInput>;
    sourceEhrPostLedgerId?: InputMaybe<SortOrderInput>;
    sourcePayoutId?: InputMaybe<SortOrderInput>;
    sourceTransactionId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrderInput>;
};

export enum ReattributionDirectionScalarFieldEnum {
    CreatedAt = 'createdAt',
    DestinationBoughtTreatmentId = 'destinationBoughtTreatmentId',
    DestinationChargeId = 'destinationChargeId',
    DestinationEhrPostDetailId = 'destinationEhrPostDetailId',
    DestinationEhrPostLedgerId = 'destinationEhrPostLedgerId',
    DestinationPayoutId = 'destinationPayoutId',
    DestinationTransactionId = 'destinationTransactionId',
    Id = 'id',
    ReattributionState = 'reattributionState',
    SourceBoughtTreatmentId = 'sourceBoughtTreatmentId',
    SourceChargeId = 'sourceChargeId',
    SourceEhrPostDetailId = 'sourceEhrPostDetailId',
    SourceEhrPostLedgerId = 'sourceEhrPostLedgerId',
    SourcePayoutId = 'sourcePayoutId',
    SourceTransactionId = 'sourceTransactionId',
    UpdatedAt = 'updatedAt',
}

export type ReattributionDirectionScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<ReattributionDirectionScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<ReattributionDirectionScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<ReattributionDirectionScalarWhereWithAggregatesInput>
    >;
    createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    destinationBoughtTreatmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    destinationChargeId?: InputMaybe<StringNullableWithAggregatesFilter>;
    destinationEhrPostDetailId?: InputMaybe<StringNullableWithAggregatesFilter>;
    destinationEhrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    destinationPayoutId?: InputMaybe<StringNullableWithAggregatesFilter>;
    destinationTransactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableWithAggregatesFilter>;
    sourceBoughtTreatmentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    sourceChargeId?: InputMaybe<StringNullableWithAggregatesFilter>;
    sourceEhrPostDetailId?: InputMaybe<StringNullableWithAggregatesFilter>;
    sourceEhrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    sourcePayoutId?: InputMaybe<StringNullableWithAggregatesFilter>;
    sourceTransactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type ReattributionDirectionUpdateInput = {
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    destinationBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationChargeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationEhrPostDetailId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationPayoutId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    sourceBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceChargeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceEhrPostDetailId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourcePayoutId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ReattributionDirectionUpdateManyMutationInput = {
    createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    destinationBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationChargeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationEhrPostDetailId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationPayoutId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    destinationTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    reattributionState?: InputMaybe<NullableEnumReattributionStateFieldUpdateOperationsInput>;
    sourceBoughtTreatmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceChargeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceEhrPostDetailId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceEhrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourcePayoutId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    sourceTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ReattributionDirectionWhereInput = {
    AND?: InputMaybe<Array<ReattributionDirectionWhereInput>>;
    NOT?: InputMaybe<Array<ReattributionDirectionWhereInput>>;
    OR?: InputMaybe<Array<ReattributionDirectionWhereInput>>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    destinationBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    destinationChargeId?: InputMaybe<StringNullableFilter>;
    destinationEhrPostDetailId?: InputMaybe<StringNullableFilter>;
    destinationEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    destinationPayoutId?: InputMaybe<StringNullableFilter>;
    destinationTransactionId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<StringFilter>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    sourceBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    sourceChargeId?: InputMaybe<StringNullableFilter>;
    sourceEhrPostDetailId?: InputMaybe<StringNullableFilter>;
    sourceEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    sourcePayoutId?: InputMaybe<StringNullableFilter>;
    sourceTransactionId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ReattributionDirectionWhereUniqueInput = {
    AND?: InputMaybe<Array<ReattributionDirectionWhereInput>>;
    NOT?: InputMaybe<Array<ReattributionDirectionWhereInput>>;
    OR?: InputMaybe<Array<ReattributionDirectionWhereInput>>;
    createdAt?: InputMaybe<DateTimeNullableFilter>;
    destinationBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    destinationChargeId?: InputMaybe<StringNullableFilter>;
    destinationEhrPostDetailId?: InputMaybe<StringNullableFilter>;
    destinationEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    destinationPayoutId?: InputMaybe<StringNullableFilter>;
    destinationTransactionId?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    reattributionState?: InputMaybe<EnumReattributionStateNullableFilter>;
    sourceBoughtTreatmentId?: InputMaybe<StringNullableFilter>;
    sourceChargeId?: InputMaybe<StringNullableFilter>;
    sourceEhrPostDetailId?: InputMaybe<StringNullableFilter>;
    sourceEhrPostLedgerId?: InputMaybe<StringNullableFilter>;
    sourcePayoutId?: InputMaybe<StringNullableFilter>;
    sourceTransactionId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum ReattributionState {
    LockedPaymentReschedule = 'LOCKED_PAYMENT_RESCHEDULE',
    Manual = 'MANUAL',
    Misroute = 'MISROUTE',
    Normal = 'NORMAL',
    SelfHealing = 'SELF_HEALING',
    Sherlock = 'SHERLOCK',
    TreatmentSwap = 'TREATMENT_SWAP',
}

export type ReceiptArrangement = {
    __typename?: 'ReceiptArrangement';
    blockGap?: Maybe<Scalars['Int']['output']>;
    components: Scalars['JSON']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    createdBy?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    receiptType: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ReceiptArrangementAvgAggregate = {
    __typename?: 'ReceiptArrangementAvgAggregate';
    blockGap?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type ReceiptArrangementAvgOrderByAggregateInput = {
    blockGap?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type ReceiptArrangementCountAggregate = {
    __typename?: 'ReceiptArrangementCountAggregate';
    _all: Scalars['Int']['output'];
    blockGap: Scalars['Int']['output'];
    components: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    createdBy: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    receiptType: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type ReceiptArrangementCountOrderByAggregateInput = {
    blockGap?: InputMaybe<SortOrder>;
    components?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    receiptType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ReceiptArrangementCreateInput = {
    blockGap?: InputMaybe<Scalars['Int']['input']>;
    components: Scalars['JSON']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy?: InputMaybe<Scalars['String']['input']>;
    receiptType: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ReceiptArrangementCreateManyInput = {
    blockGap?: InputMaybe<Scalars['Int']['input']>;
    components: Scalars['JSON']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    createdBy?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    receiptType: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ReceiptArrangementGroupBy = {
    __typename?: 'ReceiptArrangementGroupBy';
    _avg?: Maybe<ReceiptArrangementAvgAggregate>;
    _count?: Maybe<ReceiptArrangementCountAggregate>;
    _max?: Maybe<ReceiptArrangementMaxAggregate>;
    _min?: Maybe<ReceiptArrangementMinAggregate>;
    _sum?: Maybe<ReceiptArrangementSumAggregate>;
    blockGap?: Maybe<Scalars['Int']['output']>;
    components: Scalars['JSON']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    createdBy?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    receiptType: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type ReceiptArrangementMaxAggregate = {
    __typename?: 'ReceiptArrangementMaxAggregate';
    blockGap?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    receiptType?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ReceiptArrangementMaxOrderByAggregateInput = {
    blockGap?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    receiptType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ReceiptArrangementMinAggregate = {
    __typename?: 'ReceiptArrangementMinAggregate';
    blockGap?: Maybe<Scalars['Int']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    receiptType?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ReceiptArrangementMinOrderByAggregateInput = {
    blockGap?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    receiptType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ReceiptArrangementOrderByWithAggregationInput = {
    _avg?: InputMaybe<ReceiptArrangementAvgOrderByAggregateInput>;
    _count?: InputMaybe<ReceiptArrangementCountOrderByAggregateInput>;
    _max?: InputMaybe<ReceiptArrangementMaxOrderByAggregateInput>;
    _min?: InputMaybe<ReceiptArrangementMinOrderByAggregateInput>;
    _sum?: InputMaybe<ReceiptArrangementSumOrderByAggregateInput>;
    blockGap?: InputMaybe<SortOrderInput>;
    components?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    receiptType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ReceiptArrangementOrderByWithRelationInput = {
    blockGap?: InputMaybe<SortOrderInput>;
    components?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    createdBy?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    receiptType?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum ReceiptArrangementScalarFieldEnum {
    BlockGap = 'blockGap',
    Components = 'components',
    CreatedAt = 'createdAt',
    CreatedBy = 'createdBy',
    Id = 'id',
    ReceiptType = 'receiptType',
    UpdatedAt = 'updatedAt',
}

export type ReceiptArrangementScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ReceiptArrangementScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ReceiptArrangementScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ReceiptArrangementScalarWhereWithAggregatesInput>>;
    blockGap?: InputMaybe<IntNullableWithAggregatesFilter>;
    components?: InputMaybe<JsonWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    createdBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    receiptType?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ReceiptArrangementSumAggregate = {
    __typename?: 'ReceiptArrangementSumAggregate';
    blockGap?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type ReceiptArrangementSumOrderByAggregateInput = {
    blockGap?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type ReceiptArrangementUpdateInput = {
    blockGap?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    components?: InputMaybe<Scalars['JSON']['input']>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    receiptType?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReceiptArrangementUpdateManyMutationInput = {
    blockGap?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    components?: InputMaybe<Scalars['JSON']['input']>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    receiptType?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReceiptArrangementWhereInput = {
    AND?: InputMaybe<Array<ReceiptArrangementWhereInput>>;
    NOT?: InputMaybe<Array<ReceiptArrangementWhereInput>>;
    OR?: InputMaybe<Array<ReceiptArrangementWhereInput>>;
    blockGap?: InputMaybe<IntNullableFilter>;
    components?: InputMaybe<JsonFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    createdBy?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    receiptType?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ReceiptArrangementWhereUniqueInput = {
    AND?: InputMaybe<Array<ReceiptArrangementWhereInput>>;
    NOT?: InputMaybe<Array<ReceiptArrangementWhereInput>>;
    OR?: InputMaybe<Array<ReceiptArrangementWhereInput>>;
    blockGap?: InputMaybe<IntNullableFilter>;
    components?: InputMaybe<JsonFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    createdBy?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    receiptType?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum RelationLoadStrategy {
    Join = 'join',
    Query = 'query',
}

export type RelinkInsurancePhotoInput = {
    consumerId: Scalars['String']['input'];
    newInsuranceId: Scalars['String']['input'];
    oldInsuranceId: Scalars['String']['input'];
    orgId: Scalars['Float']['input'];
};

export type RelinkInsurancePhotoResponse = {
    __typename?: 'RelinkInsurancePhotoResponse';
    message: Scalars['String']['output'];
    success: Scalars['Boolean']['output'];
};

export type ReservedEhrVisit = {
    __typename?: 'ReservedEhrVisit';
    createdAt: Scalars['DateTimeISO']['output'];
    ehrVisitId: Scalars['String']['output'];
    expiresAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
};

export type ReservedEhrVisitAvgAggregate = {
    __typename?: 'ReservedEhrVisitAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type ReservedEhrVisitAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type ReservedEhrVisitCountAggregate = {
    __typename?: 'ReservedEhrVisitCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrVisitId: Scalars['Int']['output'];
    expiresAt: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
};

export type ReservedEhrVisitCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type ReservedEhrVisitCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrVisitId: Scalars['String']['input'];
    expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
};

export type ReservedEhrVisitCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrVisitId: Scalars['String']['input'];
    expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
};

export type ReservedEhrVisitGroupBy = {
    __typename?: 'ReservedEhrVisitGroupBy';
    _avg?: Maybe<ReservedEhrVisitAvgAggregate>;
    _count?: Maybe<ReservedEhrVisitCountAggregate>;
    _max?: Maybe<ReservedEhrVisitMaxAggregate>;
    _min?: Maybe<ReservedEhrVisitMinAggregate>;
    _sum?: Maybe<ReservedEhrVisitSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrVisitId: Scalars['String']['output'];
    expiresAt: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
};

export type ReservedEhrVisitMaxAggregate = {
    __typename?: 'ReservedEhrVisitMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrVisitId?: Maybe<Scalars['String']['output']>;
    expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type ReservedEhrVisitMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type ReservedEhrVisitMinAggregate = {
    __typename?: 'ReservedEhrVisitMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrVisitId?: Maybe<Scalars['String']['output']>;
    expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type ReservedEhrVisitMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type ReservedEhrVisitOrderByWithAggregationInput = {
    _avg?: InputMaybe<ReservedEhrVisitAvgOrderByAggregateInput>;
    _count?: InputMaybe<ReservedEhrVisitCountOrderByAggregateInput>;
    _max?: InputMaybe<ReservedEhrVisitMaxOrderByAggregateInput>;
    _min?: InputMaybe<ReservedEhrVisitMinOrderByAggregateInput>;
    _sum?: InputMaybe<ReservedEhrVisitSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type ReservedEhrVisitOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    expiresAt?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export enum ReservedEhrVisitScalarFieldEnum {
    CreatedAt = 'createdAt',
    EhrVisitId = 'ehrVisitId',
    ExpiresAt = 'expiresAt',
    Id = 'id',
    OrgId = 'orgId',
}

export type ReservedEhrVisitScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ReservedEhrVisitScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ReservedEhrVisitScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ReservedEhrVisitScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrVisitId?: InputMaybe<StringWithAggregatesFilter>;
    expiresAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    orgId?: InputMaybe<IntWithAggregatesFilter>;
};

export type ReservedEhrVisitSumAggregate = {
    __typename?: 'ReservedEhrVisitSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type ReservedEhrVisitSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type ReservedEhrVisitUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrVisitId?: InputMaybe<StringFieldUpdateOperationsInput>;
    expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ReservedEhrVisitUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrVisitId?: InputMaybe<StringFieldUpdateOperationsInput>;
    expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ReservedEhrVisitWhereInput = {
    AND?: InputMaybe<Array<ReservedEhrVisitWhereInput>>;
    NOT?: InputMaybe<Array<ReservedEhrVisitWhereInput>>;
    OR?: InputMaybe<Array<ReservedEhrVisitWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrVisitId?: InputMaybe<StringFilter>;
    expiresAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    orgId?: InputMaybe<IntFilter>;
};

export type ReservedEhrVisitWhereUniqueInput = {
    AND?: InputMaybe<Array<ReservedEhrVisitWhereInput>>;
    NOT?: InputMaybe<Array<ReservedEhrVisitWhereInput>>;
    OR?: InputMaybe<Array<ReservedEhrVisitWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrVisitId?: InputMaybe<StringFilter>;
    expiresAt?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
};

export type ResetToken = {
    __typename?: 'ResetToken';
    expiration: Scalars['DateTimeISO']['output'];
    token: Scalars['String']['output'];
    used: Scalars['Boolean']['output'];
    user_id: Scalars['String']['output'];
};

export type ResetTokenCountAggregate = {
    __typename?: 'ResetTokenCountAggregate';
    _all: Scalars['Int']['output'];
    expiration: Scalars['Int']['output'];
    token: Scalars['Int']['output'];
    used: Scalars['Int']['output'];
    user_id: Scalars['Int']['output'];
};

export type ResetTokenCountOrderByAggregateInput = {
    expiration?: InputMaybe<SortOrder>;
    token?: InputMaybe<SortOrder>;
    used?: InputMaybe<SortOrder>;
    user_id?: InputMaybe<SortOrder>;
};

export type ResetTokenCreateInput = {
    expiration: Scalars['DateTimeISO']['input'];
    token: Scalars['String']['input'];
    used: Scalars['Boolean']['input'];
    user_id: Scalars['String']['input'];
};

export type ResetTokenCreateManyInput = {
    expiration: Scalars['DateTimeISO']['input'];
    token: Scalars['String']['input'];
    used: Scalars['Boolean']['input'];
    user_id: Scalars['String']['input'];
};

export type ResetTokenGroupBy = {
    __typename?: 'ResetTokenGroupBy';
    _count?: Maybe<ResetTokenCountAggregate>;
    _max?: Maybe<ResetTokenMaxAggregate>;
    _min?: Maybe<ResetTokenMinAggregate>;
    expiration: Scalars['DateTimeISO']['output'];
    token: Scalars['String']['output'];
    used: Scalars['Boolean']['output'];
    user_id: Scalars['String']['output'];
};

export type ResetTokenMaxAggregate = {
    __typename?: 'ResetTokenMaxAggregate';
    expiration?: Maybe<Scalars['DateTimeISO']['output']>;
    token?: Maybe<Scalars['String']['output']>;
    used?: Maybe<Scalars['Boolean']['output']>;
    user_id?: Maybe<Scalars['String']['output']>;
};

export type ResetTokenMaxOrderByAggregateInput = {
    expiration?: InputMaybe<SortOrder>;
    token?: InputMaybe<SortOrder>;
    used?: InputMaybe<SortOrder>;
    user_id?: InputMaybe<SortOrder>;
};

export type ResetTokenMinAggregate = {
    __typename?: 'ResetTokenMinAggregate';
    expiration?: Maybe<Scalars['DateTimeISO']['output']>;
    token?: Maybe<Scalars['String']['output']>;
    used?: Maybe<Scalars['Boolean']['output']>;
    user_id?: Maybe<Scalars['String']['output']>;
};

export type ResetTokenMinOrderByAggregateInput = {
    expiration?: InputMaybe<SortOrder>;
    token?: InputMaybe<SortOrder>;
    used?: InputMaybe<SortOrder>;
    user_id?: InputMaybe<SortOrder>;
};

export type ResetTokenOrderByWithAggregationInput = {
    _count?: InputMaybe<ResetTokenCountOrderByAggregateInput>;
    _max?: InputMaybe<ResetTokenMaxOrderByAggregateInput>;
    _min?: InputMaybe<ResetTokenMinOrderByAggregateInput>;
    expiration?: InputMaybe<SortOrder>;
    token?: InputMaybe<SortOrder>;
    used?: InputMaybe<SortOrder>;
    user_id?: InputMaybe<SortOrder>;
};

export type ResetTokenOrderByWithRelationInput = {
    expiration?: InputMaybe<SortOrder>;
    token?: InputMaybe<SortOrder>;
    used?: InputMaybe<SortOrder>;
    user_id?: InputMaybe<SortOrder>;
};

export enum ResetTokenScalarFieldEnum {
    Expiration = 'expiration',
    Token = 'token',
    Used = 'used',
    UserId = 'user_id',
}

export type ResetTokenScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ResetTokenScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ResetTokenScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ResetTokenScalarWhereWithAggregatesInput>>;
    expiration?: InputMaybe<DateTimeWithAggregatesFilter>;
    token?: InputMaybe<StringWithAggregatesFilter>;
    used?: InputMaybe<BoolWithAggregatesFilter>;
    user_id?: InputMaybe<UuidWithAggregatesFilter>;
};

export type ResetTokenUpdateInput = {
    expiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    token?: InputMaybe<StringFieldUpdateOperationsInput>;
    used?: InputMaybe<BoolFieldUpdateOperationsInput>;
    user_id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ResetTokenUpdateManyMutationInput = {
    expiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    token?: InputMaybe<StringFieldUpdateOperationsInput>;
    used?: InputMaybe<BoolFieldUpdateOperationsInput>;
    user_id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ResetTokenWhereInput = {
    AND?: InputMaybe<Array<ResetTokenWhereInput>>;
    NOT?: InputMaybe<Array<ResetTokenWhereInput>>;
    OR?: InputMaybe<Array<ResetTokenWhereInput>>;
    expiration?: InputMaybe<DateTimeFilter>;
    token?: InputMaybe<StringFilter>;
    used?: InputMaybe<BoolFilter>;
    user_id?: InputMaybe<UuidFilter>;
};

export type ResetTokenWhereUniqueInput = {
    AND?: InputMaybe<Array<ResetTokenWhereInput>>;
    NOT?: InputMaybe<Array<ResetTokenWhereInput>>;
    OR?: InputMaybe<Array<ResetTokenWhereInput>>;
    expiration?: InputMaybe<DateTimeFilter>;
    token?: InputMaybe<Scalars['String']['input']>;
    used?: InputMaybe<BoolFilter>;
    user_id?: InputMaybe<UuidFilter>;
};

export enum RevenueType {
    Merchant = 'MERCHANT',
    Other = 'OTHER',
    Protocol = 'PROTOCOL',
}

export enum ReviewStatusEnum {
    ConfirmContract = 'CONFIRM_CONTRACT',
    ConfirmPrimaryOnly = 'CONFIRM_PRIMARY_ONLY',
    ConfirmSelfpay = 'CONFIRM_SELFPAY',
    InsuredPricingFailed = 'INSURED_PRICING_FAILED',
    NeedsAdminCreated = 'NEEDS_ADMIN_CREATED',
    RepriceInProgress = 'REPRICE_IN_PROGRESS',
}

export type RosterBoughtTreatment = {
    __typename?: 'RosterBoughtTreatment';
    _count?: Maybe<BoughtTreatmentCount>;
    adjustmentType?: Maybe<AdjustmentTypeEnum>;
    boughtTreatmentKind?: Maybe<BoughtTreatmentKind>;
    candidateTreatments: Array<CandidateTreatment>;
    charges: Array<Scalars['JSONObject']['output']>;
    consumer: Scalars['JSONObject']['output'];
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    discountCodeApplied?: Maybe<Scalars['String']['output']>;
    hrtFlags?: Maybe<Scalars['JSONObject']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['String']['output'];
    insuranceIds: Array<Scalars['String']['output']>;
    isVirtual: Scalars['Boolean']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    orgId: Scalars['Int']['output'];
    overrideReason?: Maybe<Scalars['String']['output']>;
    paymentContactId?: Maybe<Scalars['String']['output']>;
    paymentType: PaymentTypeEnum;
    previousBoughtTreatmentId?: Maybe<Scalars['String']['output']>;
    price: Scalars['Float']['output'];
    pricedTreatmentId: Scalars['Int']['output'];
    reviewStatus?: Maybe<ReviewStatusEnum>;
    slot?: Maybe<Slot>;
    slotId?: Maybe<Scalars['String']['output']>;
    source: EncounterSourceEnum;
    status: BoughtTreatmentStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type RosterBoughtTreatmentCandidateTreatmentsArgs = {
    cursor?: InputMaybe<CandidateTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<CandidateTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type RosterBoughtTreatmentSlotArgs = {
    where?: InputMaybe<SlotWhereInput>;
};

export type RosterSlot = {
    __typename?: 'RosterSlot';
    EhrSlot?: Maybe<EhrSlot>;
    _count?: Maybe<SlotCount>;
    appointment?: Maybe<Appointment>;
    appointmentId: Scalars['String']['output'];
    boughtTreatments: Array<BoughtTreatment>;
    candidateTreatments: Array<CandidateTreatment>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt: Scalars['DateTimeISO']['output'];
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practice: Scalars['JSONObject']['output'];
    practiceId: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    reviewStatus?: Maybe<Scalars['String']['output']>;
    rosterBoughtTreatments: Array<RosterBoughtTreatment>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['output'];
    status: SlotStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type RosterSlotEhrSlotArgs = {
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type RosterSlotAppointmentArgs = {
    where?: InputMaybe<AppointmentWhereInput>;
};

export type RosterSlotBoughtTreatmentsArgs = {
    cursor?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BoughtTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type RosterSlotCandidateTreatmentsArgs = {
    cursor?: InputMaybe<CandidateTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<CandidateTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export enum SchedulingType {
    Agnostic = 'AGNOSTIC',
    Ehr = 'EHR',
    GenericOnly = 'GENERIC_ONLY',
}

export enum SelectionPriority {
    Fallback = 'FALLBACK',
    Override = 'OVERRIDE',
}

export enum SelectionType {
    ExactMatch = 'EXACT_MATCH',
    Llm = 'LLM',
    OrderCpt = 'ORDER_CPT',
}

export enum Service {
    HexMessaging = 'HEX_MESSAGING',
    HexUser = 'HEX_USER',
    PricingGateway = 'PRICING_GATEWAY',
}

export enum State {
    Ak = 'AK',
    Al = 'AL',
    Ar = 'AR',
    Az = 'AZ',
    Ca = 'CA',
    Co = 'CO',
    Ct = 'CT',
    Dc = 'DC',
    De = 'DE',
    Fl = 'FL',
    Ga = 'GA',
    Hi = 'HI',
    Ia = 'IA',
    Id = 'ID',
    Il = 'IL',
    In = 'IN',
    Ks = 'KS',
    Ky = 'KY',
    La = 'LA',
    Ma = 'MA',
    Md = 'MD',
    Me = 'ME',
    Mi = 'MI',
    Mn = 'MN',
    Mo = 'MO',
    Ms = 'MS',
    Mt = 'MT',
    Nc = 'NC',
    Nd = 'ND',
    Ne = 'NE',
    Nh = 'NH',
    Nj = 'NJ',
    Nm = 'NM',
    Nv = 'NV',
    Ny = 'NY',
    Oh = 'OH',
    Ok = 'OK',
    Or = 'OR',
    Pa = 'PA',
    Pr = 'PR',
    Ri = 'RI',
    Sc = 'SC',
    Sd = 'SD',
    Tn = 'TN',
    Tx = 'TX',
    Ut = 'UT',
    Va = 'VA',
    Vt = 'VT',
    Wa = 'WA',
    Wi = 'WI',
    Wv = 'WV',
    Wy = 'WY',
}

export type SavedIntakeResponse = {
    __typename?: 'SavedIntakeResponse';
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    intakeQuestion: IntakeQuestion;
    intakeQuestionId: Scalars['Int']['output'];
    response: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type SavedIntakeResponseAvgAggregate = {
    __typename?: 'SavedIntakeResponseAvgAggregate';
    intakeQuestionId?: Maybe<Scalars['Float']['output']>;
};

export type SavedIntakeResponseAvgOrderByAggregateInput = {
    intakeQuestionId?: InputMaybe<SortOrder>;
};

export type SavedIntakeResponseCountAggregate = {
    __typename?: 'SavedIntakeResponseCountAggregate';
    _all: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    intakeQuestionId: Scalars['Int']['output'];
    response: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type SavedIntakeResponseCountOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    response?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SavedIntakeResponseCreateInput = {
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeQuestion: IntakeQuestionCreateNestedOneWithoutSavedIntakeResponsesInput;
    response: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SavedIntakeResponseCreateManyInput = {
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    intakeQuestionId: Scalars['Int']['input'];
    response: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SavedIntakeResponseCreateManyIntakeQuestionInput = {
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    response: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SavedIntakeResponseCreateManyIntakeQuestionInputEnvelope = {
    data: Array<SavedIntakeResponseCreateManyIntakeQuestionInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SavedIntakeResponseCreateNestedManyWithoutIntakeQuestionInput = {
    connect?: InputMaybe<Array<SavedIntakeResponseWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SavedIntakeResponseCreateOrConnectWithoutIntakeQuestionInput>
    >;
    create?: InputMaybe<
        Array<SavedIntakeResponseCreateWithoutIntakeQuestionInput>
    >;
    createMany?: InputMaybe<SavedIntakeResponseCreateManyIntakeQuestionInputEnvelope>;
};

export type SavedIntakeResponseCreateOrConnectWithoutIntakeQuestionInput = {
    create: SavedIntakeResponseCreateWithoutIntakeQuestionInput;
    where: SavedIntakeResponseWhereUniqueInput;
};

export type SavedIntakeResponseCreateWithoutIntakeQuestionInput = {
    consumerId: Scalars['String']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    response: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SavedIntakeResponseGroupBy = {
    __typename?: 'SavedIntakeResponseGroupBy';
    _avg?: Maybe<SavedIntakeResponseAvgAggregate>;
    _count?: Maybe<SavedIntakeResponseCountAggregate>;
    _max?: Maybe<SavedIntakeResponseMaxAggregate>;
    _min?: Maybe<SavedIntakeResponseMinAggregate>;
    _sum?: Maybe<SavedIntakeResponseSumAggregate>;
    consumerId: Scalars['String']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    intakeQuestionId: Scalars['Int']['output'];
    response: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type SavedIntakeResponseIntakeQuestionIdConsumerIdCompoundUniqueInput = {
    consumerId: Scalars['String']['input'];
    intakeQuestionId: Scalars['Int']['input'];
};

export type SavedIntakeResponseIntakeResponseConsumerUniqueCompoundUniqueInput =
    {
        consumerId: Scalars['String']['input'];
        intakeQuestionId: Scalars['Int']['input'];
    };

export type SavedIntakeResponseListRelationFilter = {
    every?: InputMaybe<SavedIntakeResponseWhereInput>;
    none?: InputMaybe<SavedIntakeResponseWhereInput>;
    some?: InputMaybe<SavedIntakeResponseWhereInput>;
};

export type SavedIntakeResponseMaxAggregate = {
    __typename?: 'SavedIntakeResponseMaxAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    intakeQuestionId?: Maybe<Scalars['Int']['output']>;
    response?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SavedIntakeResponseMaxOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    response?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SavedIntakeResponseMinAggregate = {
    __typename?: 'SavedIntakeResponseMinAggregate';
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    intakeQuestionId?: Maybe<Scalars['Int']['output']>;
    response?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SavedIntakeResponseMinOrderByAggregateInput = {
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    response?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SavedIntakeResponseOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type SavedIntakeResponseOrderByWithAggregationInput = {
    _avg?: InputMaybe<SavedIntakeResponseAvgOrderByAggregateInput>;
    _count?: InputMaybe<SavedIntakeResponseCountOrderByAggregateInput>;
    _max?: InputMaybe<SavedIntakeResponseMaxOrderByAggregateInput>;
    _min?: InputMaybe<SavedIntakeResponseMinOrderByAggregateInput>;
    _sum?: InputMaybe<SavedIntakeResponseSumOrderByAggregateInput>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    response?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SavedIntakeResponseOrderByWithRelationInput = {
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    intakeQuestion?: InputMaybe<IntakeQuestionOrderByWithRelationInput>;
    intakeQuestionId?: InputMaybe<SortOrder>;
    response?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum SavedIntakeResponseScalarFieldEnum {
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    IntakeQuestionId = 'intakeQuestionId',
    Response = 'response',
    UpdatedAt = 'updatedAt',
}

export type SavedIntakeResponseScalarWhereInput = {
    AND?: InputMaybe<Array<SavedIntakeResponseScalarWhereInput>>;
    NOT?: InputMaybe<Array<SavedIntakeResponseScalarWhereInput>>;
    OR?: InputMaybe<Array<SavedIntakeResponseScalarWhereInput>>;
    consumerId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeQuestionId?: InputMaybe<IntFilter>;
    response?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SavedIntakeResponseScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<SavedIntakeResponseScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<SavedIntakeResponseScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<SavedIntakeResponseScalarWhereWithAggregatesInput>>;
    consumerId?: InputMaybe<StringWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    intakeQuestionId?: InputMaybe<IntWithAggregatesFilter>;
    response?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type SavedIntakeResponseSumAggregate = {
    __typename?: 'SavedIntakeResponseSumAggregate';
    intakeQuestionId?: Maybe<Scalars['Int']['output']>;
};

export type SavedIntakeResponseSumOrderByAggregateInput = {
    intakeQuestionId?: InputMaybe<SortOrder>;
};

export type SavedIntakeResponseUpdateInput = {
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    intakeQuestion?: InputMaybe<IntakeQuestionUpdateOneRequiredWithoutSavedIntakeResponsesNestedInput>;
    response?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SavedIntakeResponseUpdateManyMutationInput = {
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    response?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SavedIntakeResponseUpdateManyWithWhereWithoutIntakeQuestionInput = {
    data: SavedIntakeResponseUpdateManyMutationInput;
    where: SavedIntakeResponseScalarWhereInput;
};

export type SavedIntakeResponseUpdateManyWithoutIntakeQuestionNestedInput = {
    connect?: InputMaybe<Array<SavedIntakeResponseWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SavedIntakeResponseCreateOrConnectWithoutIntakeQuestionInput>
    >;
    create?: InputMaybe<
        Array<SavedIntakeResponseCreateWithoutIntakeQuestionInput>
    >;
    createMany?: InputMaybe<SavedIntakeResponseCreateManyIntakeQuestionInputEnvelope>;
    delete?: InputMaybe<Array<SavedIntakeResponseWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<SavedIntakeResponseScalarWhereInput>>;
    disconnect?: InputMaybe<Array<SavedIntakeResponseWhereUniqueInput>>;
    set?: InputMaybe<Array<SavedIntakeResponseWhereUniqueInput>>;
    update?: InputMaybe<
        Array<SavedIntakeResponseUpdateWithWhereUniqueWithoutIntakeQuestionInput>
    >;
    updateMany?: InputMaybe<
        Array<SavedIntakeResponseUpdateManyWithWhereWithoutIntakeQuestionInput>
    >;
    upsert?: InputMaybe<
        Array<SavedIntakeResponseUpsertWithWhereUniqueWithoutIntakeQuestionInput>
    >;
};

export type SavedIntakeResponseUpdateWithWhereUniqueWithoutIntakeQuestionInput =
    {
        data: SavedIntakeResponseUpdateWithoutIntakeQuestionInput;
        where: SavedIntakeResponseWhereUniqueInput;
    };

export type SavedIntakeResponseUpdateWithoutIntakeQuestionInput = {
    consumerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    response?: InputMaybe<StringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SavedIntakeResponseUpsertWithWhereUniqueWithoutIntakeQuestionInput =
    {
        create: SavedIntakeResponseCreateWithoutIntakeQuestionInput;
        update: SavedIntakeResponseUpdateWithoutIntakeQuestionInput;
        where: SavedIntakeResponseWhereUniqueInput;
    };

export type SavedIntakeResponseWhereInput = {
    AND?: InputMaybe<Array<SavedIntakeResponseWhereInput>>;
    NOT?: InputMaybe<Array<SavedIntakeResponseWhereInput>>;
    OR?: InputMaybe<Array<SavedIntakeResponseWhereInput>>;
    consumerId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeQuestion?: InputMaybe<IntakeQuestionRelationFilter>;
    intakeQuestionId?: InputMaybe<IntFilter>;
    response?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SavedIntakeResponseWhereUniqueInput = {
    AND?: InputMaybe<Array<SavedIntakeResponseWhereInput>>;
    NOT?: InputMaybe<Array<SavedIntakeResponseWhereInput>>;
    OR?: InputMaybe<Array<SavedIntakeResponseWhereInput>>;
    consumerId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    intakeQuestion?: InputMaybe<IntakeQuestionRelationFilter>;
    intakeQuestionId?: InputMaybe<IntFilter>;
    intakeQuestionId_consumerId?: InputMaybe<SavedIntakeResponseIntakeQuestionIdConsumerIdCompoundUniqueInput>;
    intake_response_consumer_unique?: InputMaybe<SavedIntakeResponseIntakeResponseConsumerUniqueCompoundUniqueInput>;
    response?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SchedulingSlotConfig = {
    __typename?: 'SchedulingSlotConfig';
    duration: Scalars['Int']['output'];
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeIdOverride?: Maybe<Scalars['String']['output']>;
    ehrVisitId: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    isVirtual: Scalars['Boolean']['output'];
    linkedEhrVisitIds: Array<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    practice: Practice;
    practiceId: Scalars['Int']['output'];
    restrictedQuery: Scalars['Boolean']['output'];
};

export type SchedulingSlotConfigAvgAggregate = {
    __typename?: 'SchedulingSlotConfigAvgAggregate';
    duration?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type SchedulingSlotConfigAvgOrderByAggregateInput = {
    duration?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type SchedulingSlotConfigCountAggregate = {
    __typename?: 'SchedulingSlotConfigCountAggregate';
    _all: Scalars['Int']['output'];
    duration: Scalars['Int']['output'];
    ehrAppointmentTypeId: Scalars['Int']['output'];
    ehrAppointmentTypeIdOverride: Scalars['Int']['output'];
    ehrVisitId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isVirtual: Scalars['Int']['output'];
    linkedEhrVisitIds: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    restrictedQuery: Scalars['Int']['output'];
};

export type SchedulingSlotConfigCountOrderByAggregateInput = {
    duration?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrder>;
    ehrAppointmentTypeIdOverride?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    linkedEhrVisitIds?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    restrictedQuery?: InputMaybe<SortOrder>;
};

export type SchedulingSlotConfigCreateInput = {
    duration?: InputMaybe<Scalars['Int']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeIdOverride?: InputMaybe<Scalars['String']['input']>;
    ehrVisitId: Scalars['String']['input'];
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    linkedEhrVisitIds?: InputMaybe<SchedulingSlotConfigCreatelinkedEhrVisitIdsInput>;
    name: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practice: PracticeCreateNestedOneWithoutSchedulingSlotConfigInput;
    restrictedQuery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchedulingSlotConfigCreateManyInput = {
    duration?: InputMaybe<Scalars['Int']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeIdOverride?: InputMaybe<Scalars['String']['input']>;
    ehrVisitId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    linkedEhrVisitIds?: InputMaybe<SchedulingSlotConfigCreatelinkedEhrVisitIdsInput>;
    name: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId: Scalars['Int']['input'];
    restrictedQuery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchedulingSlotConfigCreateManyPracticeInput = {
    duration?: InputMaybe<Scalars['Int']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeIdOverride?: InputMaybe<Scalars['String']['input']>;
    ehrVisitId: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    linkedEhrVisitIds?: InputMaybe<SchedulingSlotConfigCreatelinkedEhrVisitIdsInput>;
    name: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    restrictedQuery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchedulingSlotConfigCreateManyPracticeInputEnvelope = {
    data: Array<SchedulingSlotConfigCreateManyPracticeInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchedulingSlotConfigCreateNestedManyWithoutPracticeInput = {
    connect?: InputMaybe<Array<SchedulingSlotConfigWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SchedulingSlotConfigCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<Array<SchedulingSlotConfigCreateWithoutPracticeInput>>;
    createMany?: InputMaybe<SchedulingSlotConfigCreateManyPracticeInputEnvelope>;
};

export type SchedulingSlotConfigCreateOrConnectWithoutPracticeInput = {
    create: SchedulingSlotConfigCreateWithoutPracticeInput;
    where: SchedulingSlotConfigWhereUniqueInput;
};

export type SchedulingSlotConfigCreateWithoutPracticeInput = {
    duration?: InputMaybe<Scalars['Int']['input']>;
    ehrAppointmentTypeId?: InputMaybe<Scalars['String']['input']>;
    ehrAppointmentTypeIdOverride?: InputMaybe<Scalars['String']['input']>;
    ehrVisitId: Scalars['String']['input'];
    isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
    linkedEhrVisitIds?: InputMaybe<SchedulingSlotConfigCreatelinkedEhrVisitIdsInput>;
    name: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    restrictedQuery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchedulingSlotConfigCreatelinkedEhrVisitIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type SchedulingSlotConfigGroupBy = {
    __typename?: 'SchedulingSlotConfigGroupBy';
    _avg?: Maybe<SchedulingSlotConfigAvgAggregate>;
    _count?: Maybe<SchedulingSlotConfigCountAggregate>;
    _max?: Maybe<SchedulingSlotConfigMaxAggregate>;
    _min?: Maybe<SchedulingSlotConfigMinAggregate>;
    _sum?: Maybe<SchedulingSlotConfigSumAggregate>;
    duration: Scalars['Int']['output'];
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeIdOverride?: Maybe<Scalars['String']['output']>;
    ehrVisitId: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    isVirtual: Scalars['Boolean']['output'];
    linkedEhrVisitIds?: Maybe<Array<Scalars['String']['output']>>;
    name: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId: Scalars['Int']['output'];
    restrictedQuery: Scalars['Boolean']['output'];
};

export type SchedulingSlotConfigListRelationFilter = {
    every?: InputMaybe<SchedulingSlotConfigWhereInput>;
    none?: InputMaybe<SchedulingSlotConfigWhereInput>;
    some?: InputMaybe<SchedulingSlotConfigWhereInput>;
};

export type SchedulingSlotConfigMaxAggregate = {
    __typename?: 'SchedulingSlotConfigMaxAggregate';
    duration?: Maybe<Scalars['Int']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeIdOverride?: Maybe<Scalars['String']['output']>;
    ehrVisitId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    restrictedQuery?: Maybe<Scalars['Boolean']['output']>;
};

export type SchedulingSlotConfigMaxOrderByAggregateInput = {
    duration?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrder>;
    ehrAppointmentTypeIdOverride?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    restrictedQuery?: InputMaybe<SortOrder>;
};

export type SchedulingSlotConfigMinAggregate = {
    __typename?: 'SchedulingSlotConfigMinAggregate';
    duration?: Maybe<Scalars['Int']['output']>;
    ehrAppointmentTypeId?: Maybe<Scalars['String']['output']>;
    ehrAppointmentTypeIdOverride?: Maybe<Scalars['String']['output']>;
    ehrVisitId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isVirtual?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    restrictedQuery?: Maybe<Scalars['Boolean']['output']>;
};

export type SchedulingSlotConfigMinOrderByAggregateInput = {
    duration?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrder>;
    ehrAppointmentTypeIdOverride?: InputMaybe<SortOrder>;
    ehrVisitId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    restrictedQuery?: InputMaybe<SortOrder>;
};

export type SchedulingSlotConfigOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type SchedulingSlotConfigOrderByWithAggregationInput = {
    _avg?: InputMaybe<SchedulingSlotConfigAvgOrderByAggregateInput>;
    _count?: InputMaybe<SchedulingSlotConfigCountOrderByAggregateInput>;
    _max?: InputMaybe<SchedulingSlotConfigMaxOrderByAggregateInput>;
    _min?: InputMaybe<SchedulingSlotConfigMinOrderByAggregateInput>;
    _sum?: InputMaybe<SchedulingSlotConfigSumOrderByAggregateInput>;
    duration?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrderInput>;
    ehrAppointmentTypeIdOverride?: InputMaybe<SortOrderInput>;
    ehrVisitId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    linkedEhrVisitIds?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
    restrictedQuery?: InputMaybe<SortOrder>;
};

export type SchedulingSlotConfigOrderByWithRelationInput = {
    duration?: InputMaybe<SortOrder>;
    ehrAppointmentTypeId?: InputMaybe<SortOrderInput>;
    ehrAppointmentTypeIdOverride?: InputMaybe<SortOrderInput>;
    ehrVisitId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isVirtual?: InputMaybe<SortOrder>;
    linkedEhrVisitIds?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    practice?: InputMaybe<PracticeOrderByWithRelationInput>;
    practiceId?: InputMaybe<SortOrder>;
    restrictedQuery?: InputMaybe<SortOrder>;
};

export enum SchedulingSlotConfigScalarFieldEnum {
    Duration = 'duration',
    EhrAppointmentTypeId = 'ehrAppointmentTypeId',
    EhrAppointmentTypeIdOverride = 'ehrAppointmentTypeIdOverride',
    EhrVisitId = 'ehrVisitId',
    Id = 'id',
    IsVirtual = 'isVirtual',
    LinkedEhrVisitIds = 'linkedEhrVisitIds',
    Name = 'name',
    OrgId = 'orgId',
    PracticeId = 'practiceId',
    RestrictedQuery = 'restrictedQuery',
}

export type SchedulingSlotConfigScalarWhereInput = {
    AND?: InputMaybe<Array<SchedulingSlotConfigScalarWhereInput>>;
    NOT?: InputMaybe<Array<SchedulingSlotConfigScalarWhereInput>>;
    OR?: InputMaybe<Array<SchedulingSlotConfigScalarWhereInput>>;
    duration?: InputMaybe<IntFilter>;
    ehrAppointmentTypeId?: InputMaybe<StringNullableFilter>;
    ehrAppointmentTypeIdOverride?: InputMaybe<StringNullableFilter>;
    ehrVisitId?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    isVirtual?: InputMaybe<BoolFilter>;
    linkedEhrVisitIds?: InputMaybe<StringNullableListFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    restrictedQuery?: InputMaybe<BoolFilter>;
};

export type SchedulingSlotConfigScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<SchedulingSlotConfigScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<SchedulingSlotConfigScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<SchedulingSlotConfigScalarWhereWithAggregatesInput>>;
    duration?: InputMaybe<IntWithAggregatesFilter>;
    ehrAppointmentTypeId?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrAppointmentTypeIdOverride?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrVisitId?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isVirtual?: InputMaybe<BoolWithAggregatesFilter>;
    linkedEhrVisitIds?: InputMaybe<StringNullableListFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
    restrictedQuery?: InputMaybe<BoolWithAggregatesFilter>;
};

export type SchedulingSlotConfigSumAggregate = {
    __typename?: 'SchedulingSlotConfigSumAggregate';
    duration?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type SchedulingSlotConfigSumOrderByAggregateInput = {
    duration?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type SchedulingSlotConfigUpdateInput = {
    duration?: InputMaybe<IntFieldUpdateOperationsInput>;
    ehrAppointmentTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrAppointmentTypeIdOverride?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitId?: InputMaybe<StringFieldUpdateOperationsInput>;
    isVirtual?: InputMaybe<BoolFieldUpdateOperationsInput>;
    linkedEhrVisitIds?: InputMaybe<SchedulingSlotConfigUpdatelinkedEhrVisitIdsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practice?: InputMaybe<PracticeUpdateOneRequiredWithoutSchedulingSlotConfigNestedInput>;
    restrictedQuery?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type SchedulingSlotConfigUpdateManyMutationInput = {
    duration?: InputMaybe<IntFieldUpdateOperationsInput>;
    ehrAppointmentTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrAppointmentTypeIdOverride?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitId?: InputMaybe<StringFieldUpdateOperationsInput>;
    isVirtual?: InputMaybe<BoolFieldUpdateOperationsInput>;
    linkedEhrVisitIds?: InputMaybe<SchedulingSlotConfigUpdatelinkedEhrVisitIdsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    restrictedQuery?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type SchedulingSlotConfigUpdateManyWithWhereWithoutPracticeInput = {
    data: SchedulingSlotConfigUpdateManyMutationInput;
    where: SchedulingSlotConfigScalarWhereInput;
};

export type SchedulingSlotConfigUpdateManyWithoutPracticeNestedInput = {
    connect?: InputMaybe<Array<SchedulingSlotConfigWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SchedulingSlotConfigCreateOrConnectWithoutPracticeInput>
    >;
    create?: InputMaybe<Array<SchedulingSlotConfigCreateWithoutPracticeInput>>;
    createMany?: InputMaybe<SchedulingSlotConfigCreateManyPracticeInputEnvelope>;
    delete?: InputMaybe<Array<SchedulingSlotConfigWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<SchedulingSlotConfigScalarWhereInput>>;
    disconnect?: InputMaybe<Array<SchedulingSlotConfigWhereUniqueInput>>;
    set?: InputMaybe<Array<SchedulingSlotConfigWhereUniqueInput>>;
    update?: InputMaybe<
        Array<SchedulingSlotConfigUpdateWithWhereUniqueWithoutPracticeInput>
    >;
    updateMany?: InputMaybe<
        Array<SchedulingSlotConfigUpdateManyWithWhereWithoutPracticeInput>
    >;
    upsert?: InputMaybe<
        Array<SchedulingSlotConfigUpsertWithWhereUniqueWithoutPracticeInput>
    >;
};

export type SchedulingSlotConfigUpdateWithWhereUniqueWithoutPracticeInput = {
    data: SchedulingSlotConfigUpdateWithoutPracticeInput;
    where: SchedulingSlotConfigWhereUniqueInput;
};

export type SchedulingSlotConfigUpdateWithoutPracticeInput = {
    duration?: InputMaybe<IntFieldUpdateOperationsInput>;
    ehrAppointmentTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrAppointmentTypeIdOverride?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrVisitId?: InputMaybe<StringFieldUpdateOperationsInput>;
    isVirtual?: InputMaybe<BoolFieldUpdateOperationsInput>;
    linkedEhrVisitIds?: InputMaybe<SchedulingSlotConfigUpdatelinkedEhrVisitIdsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    restrictedQuery?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type SchedulingSlotConfigUpdatelinkedEhrVisitIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SchedulingSlotConfigUpsertWithWhereUniqueWithoutPracticeInput = {
    create: SchedulingSlotConfigCreateWithoutPracticeInput;
    update: SchedulingSlotConfigUpdateWithoutPracticeInput;
    where: SchedulingSlotConfigWhereUniqueInput;
};

export type SchedulingSlotConfigWhereInput = {
    AND?: InputMaybe<Array<SchedulingSlotConfigWhereInput>>;
    NOT?: InputMaybe<Array<SchedulingSlotConfigWhereInput>>;
    OR?: InputMaybe<Array<SchedulingSlotConfigWhereInput>>;
    duration?: InputMaybe<IntFilter>;
    ehrAppointmentTypeId?: InputMaybe<StringNullableFilter>;
    ehrAppointmentTypeIdOverride?: InputMaybe<StringNullableFilter>;
    ehrVisitId?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    isVirtual?: InputMaybe<BoolFilter>;
    linkedEhrVisitIds?: InputMaybe<StringNullableListFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    practiceId?: InputMaybe<IntFilter>;
    restrictedQuery?: InputMaybe<BoolFilter>;
};

export type SchedulingSlotConfigWhereUniqueInput = {
    AND?: InputMaybe<Array<SchedulingSlotConfigWhereInput>>;
    NOT?: InputMaybe<Array<SchedulingSlotConfigWhereInput>>;
    OR?: InputMaybe<Array<SchedulingSlotConfigWhereInput>>;
    duration?: InputMaybe<IntFilter>;
    ehrAppointmentTypeId?: InputMaybe<StringNullableFilter>;
    ehrAppointmentTypeIdOverride?: InputMaybe<StringNullableFilter>;
    ehrVisitId?: InputMaybe<StringFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isVirtual?: InputMaybe<BoolFilter>;
    linkedEhrVisitIds?: InputMaybe<StringNullableListFilter>;
    name?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    practice?: InputMaybe<PracticeRelationFilter>;
    practiceId?: InputMaybe<IntFilter>;
    restrictedQuery?: InputMaybe<BoolFilter>;
};

export type ServiceTypeCode = {
    __typename?: 'ServiceTypeCode';
    PlaceOfServiceCode: Array<PlaceOfServiceCode>;
    ProviderTaxonomy: Array<ProviderTaxonomy>;
    _count?: Maybe<ServiceTypeCodeCount>;
    description?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    pverifyCode?: Maybe<Scalars['String']['output']>;
    service_type_code: Scalars['String']['output'];
};

export type ServiceTypeCodePlaceOfServiceCodeArgs = {
    cursor?: InputMaybe<PlaceOfServiceCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<PlaceOfServiceCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PlaceOfServiceCodeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type ServiceTypeCodeProviderTaxonomyArgs = {
    cursor?: InputMaybe<ProviderTaxonomyWhereUniqueInput>;
    distinct?: InputMaybe<Array<ProviderTaxonomyScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ProviderTaxonomyOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type ServiceTypeCodeCount = {
    __typename?: 'ServiceTypeCodeCount';
    PlaceOfServiceCode: Scalars['Int']['output'];
    ProviderTaxonomy: Scalars['Int']['output'];
};

export type ServiceTypeCodeCountPlaceOfServiceCodeArgs = {
    where?: InputMaybe<PlaceOfServiceCodeWhereInput>;
};

export type ServiceTypeCodeCountProviderTaxonomyArgs = {
    where?: InputMaybe<ProviderTaxonomyWhereInput>;
};

export type ServiceTypeCodeCountAggregate = {
    __typename?: 'ServiceTypeCodeCountAggregate';
    _all: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    pverifyCode: Scalars['Int']['output'];
    service_type_code: Scalars['Int']['output'];
};

export type ServiceTypeCodeCountOrderByAggregateInput = {
    description?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    pverifyCode?: InputMaybe<SortOrder>;
    service_type_code?: InputMaybe<SortOrder>;
};

export type ServiceTypeCodeCreateInput = {
    PlaceOfServiceCode?: InputMaybe<PlaceOfServiceCodeCreateNestedManyWithoutDefaultServiceTypeInput>;
    ProviderTaxonomy?: InputMaybe<ProviderTaxonomyCreateNestedManyWithoutDefaultServiceTypeInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    pverifyCode?: InputMaybe<Scalars['String']['input']>;
    service_type_code: Scalars['String']['input'];
};

export type ServiceTypeCodeCreateManyInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    pverifyCode?: InputMaybe<Scalars['String']['input']>;
    service_type_code: Scalars['String']['input'];
};

export type ServiceTypeCodeCreateNestedOneWithoutPlaceOfServiceCodeInput = {
    connect?: InputMaybe<ServiceTypeCodeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ServiceTypeCodeCreateOrConnectWithoutPlaceOfServiceCodeInput>;
    create?: InputMaybe<ServiceTypeCodeCreateWithoutPlaceOfServiceCodeInput>;
};

export type ServiceTypeCodeCreateNestedOneWithoutProviderTaxonomyInput = {
    connect?: InputMaybe<ServiceTypeCodeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ServiceTypeCodeCreateOrConnectWithoutProviderTaxonomyInput>;
    create?: InputMaybe<ServiceTypeCodeCreateWithoutProviderTaxonomyInput>;
};

export type ServiceTypeCodeCreateOrConnectWithoutPlaceOfServiceCodeInput = {
    create: ServiceTypeCodeCreateWithoutPlaceOfServiceCodeInput;
    where: ServiceTypeCodeWhereUniqueInput;
};

export type ServiceTypeCodeCreateOrConnectWithoutProviderTaxonomyInput = {
    create: ServiceTypeCodeCreateWithoutProviderTaxonomyInput;
    where: ServiceTypeCodeWhereUniqueInput;
};

export type ServiceTypeCodeCreateWithoutPlaceOfServiceCodeInput = {
    ProviderTaxonomy?: InputMaybe<ProviderTaxonomyCreateNestedManyWithoutDefaultServiceTypeInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    pverifyCode?: InputMaybe<Scalars['String']['input']>;
    service_type_code: Scalars['String']['input'];
};

export type ServiceTypeCodeCreateWithoutProviderTaxonomyInput = {
    PlaceOfServiceCode?: InputMaybe<PlaceOfServiceCodeCreateNestedManyWithoutDefaultServiceTypeInput>;
    description?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    pverifyCode?: InputMaybe<Scalars['String']['input']>;
    service_type_code: Scalars['String']['input'];
};

export type ServiceTypeCodeGroupBy = {
    __typename?: 'ServiceTypeCodeGroupBy';
    _count?: Maybe<ServiceTypeCodeCountAggregate>;
    _max?: Maybe<ServiceTypeCodeMaxAggregate>;
    _min?: Maybe<ServiceTypeCodeMinAggregate>;
    description?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    pverifyCode?: Maybe<Scalars['String']['output']>;
    service_type_code: Scalars['String']['output'];
};

export type ServiceTypeCodeMaxAggregate = {
    __typename?: 'ServiceTypeCodeMaxAggregate';
    description?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    pverifyCode?: Maybe<Scalars['String']['output']>;
    service_type_code?: Maybe<Scalars['String']['output']>;
};

export type ServiceTypeCodeMaxOrderByAggregateInput = {
    description?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    pverifyCode?: InputMaybe<SortOrder>;
    service_type_code?: InputMaybe<SortOrder>;
};

export type ServiceTypeCodeMinAggregate = {
    __typename?: 'ServiceTypeCodeMinAggregate';
    description?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    pverifyCode?: Maybe<Scalars['String']['output']>;
    service_type_code?: Maybe<Scalars['String']['output']>;
};

export type ServiceTypeCodeMinOrderByAggregateInput = {
    description?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    pverifyCode?: InputMaybe<SortOrder>;
    service_type_code?: InputMaybe<SortOrder>;
};

export type ServiceTypeCodeNullableRelationFilter = {
    is?: InputMaybe<ServiceTypeCodeWhereInput>;
    isNot?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type ServiceTypeCodeOrderByWithAggregationInput = {
    _count?: InputMaybe<ServiceTypeCodeCountOrderByAggregateInput>;
    _max?: InputMaybe<ServiceTypeCodeMaxOrderByAggregateInput>;
    _min?: InputMaybe<ServiceTypeCodeMinOrderByAggregateInput>;
    description?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    pverifyCode?: InputMaybe<SortOrderInput>;
    service_type_code?: InputMaybe<SortOrder>;
};

export type ServiceTypeCodeOrderByWithRelationInput = {
    PlaceOfServiceCode?: InputMaybe<PlaceOfServiceCodeOrderByRelationAggregateInput>;
    ProviderTaxonomy?: InputMaybe<ProviderTaxonomyOrderByRelationAggregateInput>;
    description?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    pverifyCode?: InputMaybe<SortOrderInput>;
    service_type_code?: InputMaybe<SortOrder>;
};

export enum ServiceTypeCodeScalarFieldEnum {
    Description = 'description',
    Name = 'name',
    PverifyCode = 'pverifyCode',
    ServiceTypeCode = 'service_type_code',
}

export type ServiceTypeCodeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ServiceTypeCodeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ServiceTypeCodeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ServiceTypeCodeScalarWhereWithAggregatesInput>>;
    description?: InputMaybe<StringNullableWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    pverifyCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    service_type_code?: InputMaybe<StringWithAggregatesFilter>;
};

export type ServiceTypeCodeUpdateInput = {
    PlaceOfServiceCode?: InputMaybe<PlaceOfServiceCodeUpdateManyWithoutDefaultServiceTypeNestedInput>;
    ProviderTaxonomy?: InputMaybe<ProviderTaxonomyUpdateManyWithoutDefaultServiceTypeNestedInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    pverifyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    service_type_code?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ServiceTypeCodeUpdateManyMutationInput = {
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    pverifyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    service_type_code?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ServiceTypeCodeUpdateOneWithoutPlaceOfServiceCodeNestedInput = {
    connect?: InputMaybe<ServiceTypeCodeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ServiceTypeCodeCreateOrConnectWithoutPlaceOfServiceCodeInput>;
    create?: InputMaybe<ServiceTypeCodeCreateWithoutPlaceOfServiceCodeInput>;
    delete?: InputMaybe<ServiceTypeCodeWhereInput>;
    disconnect?: InputMaybe<ServiceTypeCodeWhereInput>;
    update?: InputMaybe<ServiceTypeCodeUpdateToOneWithWhereWithoutPlaceOfServiceCodeInput>;
    upsert?: InputMaybe<ServiceTypeCodeUpsertWithoutPlaceOfServiceCodeInput>;
};

export type ServiceTypeCodeUpdateOneWithoutProviderTaxonomyNestedInput = {
    connect?: InputMaybe<ServiceTypeCodeWhereUniqueInput>;
    connectOrCreate?: InputMaybe<ServiceTypeCodeCreateOrConnectWithoutProviderTaxonomyInput>;
    create?: InputMaybe<ServiceTypeCodeCreateWithoutProviderTaxonomyInput>;
    delete?: InputMaybe<ServiceTypeCodeWhereInput>;
    disconnect?: InputMaybe<ServiceTypeCodeWhereInput>;
    update?: InputMaybe<ServiceTypeCodeUpdateToOneWithWhereWithoutProviderTaxonomyInput>;
    upsert?: InputMaybe<ServiceTypeCodeUpsertWithoutProviderTaxonomyInput>;
};

export type ServiceTypeCodeUpdateToOneWithWhereWithoutPlaceOfServiceCodeInput =
    {
        data: ServiceTypeCodeUpdateWithoutPlaceOfServiceCodeInput;
        where?: InputMaybe<ServiceTypeCodeWhereInput>;
    };

export type ServiceTypeCodeUpdateToOneWithWhereWithoutProviderTaxonomyInput = {
    data: ServiceTypeCodeUpdateWithoutProviderTaxonomyInput;
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type ServiceTypeCodeUpdateWithoutPlaceOfServiceCodeInput = {
    ProviderTaxonomy?: InputMaybe<ProviderTaxonomyUpdateManyWithoutDefaultServiceTypeNestedInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    pverifyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    service_type_code?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ServiceTypeCodeUpdateWithoutProviderTaxonomyInput = {
    PlaceOfServiceCode?: InputMaybe<PlaceOfServiceCodeUpdateManyWithoutDefaultServiceTypeNestedInput>;
    description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    pverifyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    service_type_code?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ServiceTypeCodeUpsertWithoutPlaceOfServiceCodeInput = {
    create: ServiceTypeCodeCreateWithoutPlaceOfServiceCodeInput;
    update: ServiceTypeCodeUpdateWithoutPlaceOfServiceCodeInput;
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type ServiceTypeCodeUpsertWithoutProviderTaxonomyInput = {
    create: ServiceTypeCodeCreateWithoutProviderTaxonomyInput;
    update: ServiceTypeCodeUpdateWithoutProviderTaxonomyInput;
    where?: InputMaybe<ServiceTypeCodeWhereInput>;
};

export type ServiceTypeCodeWhereInput = {
    AND?: InputMaybe<Array<ServiceTypeCodeWhereInput>>;
    NOT?: InputMaybe<Array<ServiceTypeCodeWhereInput>>;
    OR?: InputMaybe<Array<ServiceTypeCodeWhereInput>>;
    PlaceOfServiceCode?: InputMaybe<PlaceOfServiceCodeListRelationFilter>;
    ProviderTaxonomy?: InputMaybe<ProviderTaxonomyListRelationFilter>;
    description?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    pverifyCode?: InputMaybe<StringNullableFilter>;
    service_type_code?: InputMaybe<StringFilter>;
};

export type ServiceTypeCodeWhereUniqueInput = {
    AND?: InputMaybe<Array<ServiceTypeCodeWhereInput>>;
    NOT?: InputMaybe<Array<ServiceTypeCodeWhereInput>>;
    OR?: InputMaybe<Array<ServiceTypeCodeWhereInput>>;
    PlaceOfServiceCode?: InputMaybe<PlaceOfServiceCodeListRelationFilter>;
    ProviderTaxonomy?: InputMaybe<ProviderTaxonomyListRelationFilter>;
    description?: InputMaybe<StringNullableFilter>;
    name?: InputMaybe<StringFilter>;
    pverifyCode?: InputMaybe<StringNullableFilter>;
    service_type_code?: InputMaybe<Scalars['String']['input']>;
};

export type Slot = {
    __typename?: 'Slot';
    EhrSlot?: Maybe<EhrSlot>;
    _count?: Maybe<SlotCount>;
    appointment?: Maybe<Appointment>;
    appointmentId: Scalars['String']['output'];
    boughtTreatments: Array<BoughtTreatment>;
    candidateTreatments: Array<CandidateTreatment>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt: Scalars['DateTimeISO']['output'];
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['output'];
    status: SlotStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type SlotEhrSlotArgs = {
    where?: InputMaybe<EhrSlotWhereInput>;
};

export type SlotAppointmentArgs = {
    where?: InputMaybe<AppointmentWhereInput>;
};

export type SlotBoughtTreatmentsArgs = {
    cursor?: InputMaybe<BoughtTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<BoughtTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<BoughtTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type SlotCandidateTreatmentsArgs = {
    cursor?: InputMaybe<CandidateTreatmentWhereUniqueInput>;
    distinct?: InputMaybe<Array<CandidateTreatmentScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<CandidateTreatmentOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type SlotAuditLog = {
    __typename?: 'SlotAuditLog';
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<SlotStatusEnum>;
    updatedAt: Scalars['DateTimeISO']['output'];
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type SlotAuditLogAvgAggregate = {
    __typename?: 'SlotAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
    providerId?: Maybe<Scalars['Float']['output']>;
};

export type SlotAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type SlotAuditLogCountAggregate = {
    __typename?: 'SlotAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrCancellationReason: Scalars['Int']['output'];
    ehrSlotId: Scalars['Int']['output'];
    endTime: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    note: Scalars['Int']['output'];
    noteUpdatedAt: Scalars['Int']['output'];
    noteUpdatedBy: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    reviewStatus: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    slotType: Scalars['Int']['output'];
    startTime: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    virtualLink: Scalars['Int']['output'];
};

export type SlotAuditLogCountOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrCancellationReason?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
    noteUpdatedAt?: InputMaybe<SortOrder>;
    noteUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    slotType?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    virtualLink?: InputMaybe<SortOrder>;
};

export type SlotAuditLogCreateInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrCancellationReason?: InputMaybe<Scalars['String']['input']>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    endTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    noteUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    providerId?: InputMaybe<Scalars['Int']['input']>;
    reviewStatus?: InputMaybe<Scalars['String']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    startTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    status?: InputMaybe<SlotStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    virtualLink?: InputMaybe<Scalars['String']['input']>;
};

export type SlotAuditLogCreateManyInput = {
    appointmentId?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrCancellationReason?: InputMaybe<Scalars['String']['input']>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    endTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    noteUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    providerId?: InputMaybe<Scalars['Int']['input']>;
    reviewStatus?: InputMaybe<Scalars['String']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    startTime?: InputMaybe<Scalars['DateTimeISO']['input']>;
    status?: InputMaybe<SlotStatusEnum>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    virtualLink?: InputMaybe<Scalars['String']['input']>;
};

export type SlotAuditLogGroupBy = {
    __typename?: 'SlotAuditLogGroupBy';
    _avg?: Maybe<SlotAuditLogAvgAggregate>;
    _count?: Maybe<SlotAuditLogCountAggregate>;
    _max?: Maybe<SlotAuditLogMaxAggregate>;
    _min?: Maybe<SlotAuditLogMinAggregate>;
    _sum?: Maybe<SlotAuditLogSumAggregate>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime?: Maybe<Scalars['DateTimeISO']['output']>;
    id: Scalars['Int']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<SlotStatusEnum>;
    updatedAt: Scalars['DateTimeISO']['output'];
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type SlotAuditLogMaxAggregate = {
    __typename?: 'SlotAuditLogMaxAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<SlotStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type SlotAuditLogMaxOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrCancellationReason?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
    noteUpdatedAt?: InputMaybe<SortOrder>;
    noteUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    slotType?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    virtualLink?: InputMaybe<SortOrder>;
};

export type SlotAuditLogMinAggregate = {
    __typename?: 'SlotAuditLogMinAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<SlotStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type SlotAuditLogMinOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrCancellationReason?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
    noteUpdatedAt?: InputMaybe<SortOrder>;
    noteUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    slotType?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    virtualLink?: InputMaybe<SortOrder>;
};

export type SlotAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<SlotAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<SlotAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<SlotAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<SlotAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<SlotAuditLogSumOrderByAggregateInput>;
    appointmentId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrCancellationReason?: InputMaybe<SortOrderInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    endTime?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    note?: InputMaybe<SortOrderInput>;
    noteUpdatedAt?: InputMaybe<SortOrderInput>;
    noteUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrderInput>;
    providerId?: InputMaybe<SortOrderInput>;
    reviewStatus?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    slotType?: InputMaybe<SortOrderInput>;
    startTime?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    virtualLink?: InputMaybe<SortOrderInput>;
};

export type SlotAuditLogOrderByWithRelationInput = {
    appointmentId?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrCancellationReason?: InputMaybe<SortOrderInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    endTime?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    note?: InputMaybe<SortOrderInput>;
    noteUpdatedAt?: InputMaybe<SortOrderInput>;
    noteUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrderInput>;
    providerId?: InputMaybe<SortOrderInput>;
    reviewStatus?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    slotType?: InputMaybe<SortOrderInput>;
    startTime?: InputMaybe<SortOrderInput>;
    status?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    virtualLink?: InputMaybe<SortOrderInput>;
};

export enum SlotAuditLogScalarFieldEnum {
    AppointmentId = 'appointmentId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    EhrCancellationReason = 'ehrCancellationReason',
    EhrSlotId = 'ehrSlotId',
    EndTime = 'endTime',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Note = 'note',
    NoteUpdatedAt = 'noteUpdatedAt',
    NoteUpdatedBy = 'noteUpdatedBy',
    Operation = 'operation',
    OrgId = 'orgId',
    PracticeId = 'practiceId',
    ProviderId = 'providerId',
    ReviewStatus = 'reviewStatus',
    SlotId = 'slotId',
    SlotType = 'slotType',
    StartTime = 'startTime',
    Status = 'status',
    UpdatedAt = 'updatedAt',
    VirtualLink = 'virtualLink',
}

export type SlotAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<SlotAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<SlotAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<SlotAuditLogScalarWhereWithAggregatesInput>>;
    appointmentId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrCancellationReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrSlotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    endTime?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    note?: InputMaybe<StringNullableWithAggregatesFilter>;
    noteUpdatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    noteUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntNullableWithAggregatesFilter>;
    providerId?: InputMaybe<IntNullableWithAggregatesFilter>;
    reviewStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    slotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    slotType?: InputMaybe<EnumSlotTypeEnumNullableWithAggregatesFilter>;
    startTime?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    status?: InputMaybe<EnumSlotStatusEnumNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    virtualLink?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type SlotAuditLogSumAggregate = {
    __typename?: 'SlotAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
};

export type SlotAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type SlotAuditLogUpdateInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrCancellationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    endTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noteUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    noteUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    providerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotType?: InputMaybe<NullableEnumSlotTypeEnumFieldUpdateOperationsInput>;
    startTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    virtualLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SlotAuditLogUpdateManyMutationInput = {
    appointmentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrCancellationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    ehrSlotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    endTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noteUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    noteUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    providerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotType?: InputMaybe<NullableEnumSlotTypeEnumFieldUpdateOperationsInput>;
    startTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<NullableEnumSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    virtualLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SlotAuditLogWhereInput = {
    AND?: InputMaybe<Array<SlotAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<SlotAuditLogWhereInput>>;
    OR?: InputMaybe<Array<SlotAuditLogWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrCancellationReason?: InputMaybe<StringNullableFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    endTime?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<IntFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    note?: InputMaybe<StringNullableFilter>;
    noteUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    noteUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    providerId?: InputMaybe<IntNullableFilter>;
    reviewStatus?: InputMaybe<StringNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    slotType?: InputMaybe<EnumSlotTypeEnumNullableFilter>;
    startTime?: InputMaybe<DateTimeNullableFilter>;
    status?: InputMaybe<EnumSlotStatusEnumNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    virtualLink?: InputMaybe<StringNullableFilter>;
};

export type SlotAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<SlotAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<SlotAuditLogWhereInput>>;
    OR?: InputMaybe<Array<SlotAuditLogWhereInput>>;
    appointmentId?: InputMaybe<UuidNullableFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrCancellationReason?: InputMaybe<StringNullableFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    endTime?: InputMaybe<DateTimeNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    note?: InputMaybe<StringNullableFilter>;
    noteUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
    noteUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    practiceId?: InputMaybe<IntNullableFilter>;
    providerId?: InputMaybe<IntNullableFilter>;
    reviewStatus?: InputMaybe<StringNullableFilter>;
    slotId?: InputMaybe<UuidNullableFilter>;
    slotType?: InputMaybe<EnumSlotTypeEnumNullableFilter>;
    startTime?: InputMaybe<DateTimeNullableFilter>;
    status?: InputMaybe<EnumSlotStatusEnumNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    virtualLink?: InputMaybe<StringNullableFilter>;
};

export type SlotAvgAggregate = {
    __typename?: 'SlotAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
    providerId?: Maybe<Scalars['Float']['output']>;
};

export type SlotAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type SlotCount = {
    __typename?: 'SlotCount';
    boughtTreatments: Scalars['Int']['output'];
    candidateTreatments: Scalars['Int']['output'];
};

export type SlotCountBoughtTreatmentsArgs = {
    where?: InputMaybe<BoughtTreatmentWhereInput>;
};

export type SlotCountCandidateTreatmentsArgs = {
    where?: InputMaybe<CandidateTreatmentWhereInput>;
};

export type SlotCountAggregate = {
    __typename?: 'SlotCountAggregate';
    _all: Scalars['Int']['output'];
    appointmentId: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    ehrCancellationReason: Scalars['Int']['output'];
    ehrSlotId: Scalars['Int']['output'];
    endTime: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    note: Scalars['Int']['output'];
    noteUpdatedAt: Scalars['Int']['output'];
    noteUpdatedBy: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    reviewStatus: Scalars['Int']['output'];
    slotType: Scalars['Int']['output'];
    startTime: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    virtualLink: Scalars['Int']['output'];
};

export type SlotCountOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrCancellationReason?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
    noteUpdatedAt?: InputMaybe<SortOrder>;
    noteUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotType?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    virtualLink?: InputMaybe<SortOrder>;
};

export type SlotCreateInput = {
    EhrSlot?: InputMaybe<EhrSlotCreateNestedOneWithoutSlotInput>;
    appointment?: InputMaybe<AppointmentCreateNestedOneWithoutSlotsInput>;
    boughtTreatments?: InputMaybe<BoughtTreatmentCreateNestedManyWithoutSlotInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentCreateNestedManyWithoutSlotInput>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrCancellationReason?: InputMaybe<Scalars['String']['input']>;
    endTime: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    noteUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['input'];
    status: SlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    virtualLink?: InputMaybe<Scalars['String']['input']>;
};

export type SlotCreateManyAppointmentInput = {
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrCancellationReason?: InputMaybe<Scalars['String']['input']>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    endTime: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    noteUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['input'];
    status: SlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    virtualLink?: InputMaybe<Scalars['String']['input']>;
};

export type SlotCreateManyAppointmentInputEnvelope = {
    data: Array<SlotCreateManyAppointmentInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SlotCreateManyEhrSlotInput = {
    appointmentId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrCancellationReason?: InputMaybe<Scalars['String']['input']>;
    endTime: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    noteUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['input'];
    status: SlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    virtualLink?: InputMaybe<Scalars['String']['input']>;
};

export type SlotCreateManyEhrSlotInputEnvelope = {
    data: Array<SlotCreateManyEhrSlotInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SlotCreateManyInput = {
    appointmentId: Scalars['String']['input'];
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrCancellationReason?: InputMaybe<Scalars['String']['input']>;
    ehrSlotId?: InputMaybe<Scalars['String']['input']>;
    endTime: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    noteUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['input'];
    status: SlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    virtualLink?: InputMaybe<Scalars['String']['input']>;
};

export type SlotCreateNestedManyWithoutAppointmentInput = {
    connect?: InputMaybe<Array<SlotWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SlotCreateOrConnectWithoutAppointmentInput>
    >;
    create?: InputMaybe<Array<SlotCreateWithoutAppointmentInput>>;
    createMany?: InputMaybe<SlotCreateManyAppointmentInputEnvelope>;
};

export type SlotCreateNestedManyWithoutEhrSlotInput = {
    connect?: InputMaybe<Array<SlotWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<SlotCreateOrConnectWithoutEhrSlotInput>>;
    create?: InputMaybe<Array<SlotCreateWithoutEhrSlotInput>>;
    createMany?: InputMaybe<SlotCreateManyEhrSlotInputEnvelope>;
};

export type SlotCreateNestedOneWithoutBoughtTreatmentsInput = {
    connect?: InputMaybe<SlotWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SlotCreateOrConnectWithoutBoughtTreatmentsInput>;
    create?: InputMaybe<SlotCreateWithoutBoughtTreatmentsInput>;
};

export type SlotCreateNestedOneWithoutCandidateTreatmentsInput = {
    connect?: InputMaybe<SlotWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SlotCreateOrConnectWithoutCandidateTreatmentsInput>;
    create?: InputMaybe<SlotCreateWithoutCandidateTreatmentsInput>;
};

export type SlotCreateOrConnectWithoutAppointmentInput = {
    create: SlotCreateWithoutAppointmentInput;
    where: SlotWhereUniqueInput;
};

export type SlotCreateOrConnectWithoutBoughtTreatmentsInput = {
    create: SlotCreateWithoutBoughtTreatmentsInput;
    where: SlotWhereUniqueInput;
};

export type SlotCreateOrConnectWithoutCandidateTreatmentsInput = {
    create: SlotCreateWithoutCandidateTreatmentsInput;
    where: SlotWhereUniqueInput;
};

export type SlotCreateOrConnectWithoutEhrSlotInput = {
    create: SlotCreateWithoutEhrSlotInput;
    where: SlotWhereUniqueInput;
};

export type SlotCreateWithoutAppointmentInput = {
    EhrSlot?: InputMaybe<EhrSlotCreateNestedOneWithoutSlotInput>;
    boughtTreatments?: InputMaybe<BoughtTreatmentCreateNestedManyWithoutSlotInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentCreateNestedManyWithoutSlotInput>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrCancellationReason?: InputMaybe<Scalars['String']['input']>;
    endTime: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    noteUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['input'];
    status: SlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    virtualLink?: InputMaybe<Scalars['String']['input']>;
};

export type SlotCreateWithoutBoughtTreatmentsInput = {
    EhrSlot?: InputMaybe<EhrSlotCreateNestedOneWithoutSlotInput>;
    appointment?: InputMaybe<AppointmentCreateNestedOneWithoutSlotsInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentCreateNestedManyWithoutSlotInput>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrCancellationReason?: InputMaybe<Scalars['String']['input']>;
    endTime: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    noteUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['input'];
    status: SlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    virtualLink?: InputMaybe<Scalars['String']['input']>;
};

export type SlotCreateWithoutCandidateTreatmentsInput = {
    EhrSlot?: InputMaybe<EhrSlotCreateNestedOneWithoutSlotInput>;
    appointment?: InputMaybe<AppointmentCreateNestedOneWithoutSlotsInput>;
    boughtTreatments?: InputMaybe<BoughtTreatmentCreateNestedManyWithoutSlotInput>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrCancellationReason?: InputMaybe<Scalars['String']['input']>;
    endTime: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    noteUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['input'];
    status: SlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    virtualLink?: InputMaybe<Scalars['String']['input']>;
};

export type SlotCreateWithoutEhrSlotInput = {
    appointment?: InputMaybe<AppointmentCreateNestedOneWithoutSlotsInput>;
    boughtTreatments?: InputMaybe<BoughtTreatmentCreateNestedManyWithoutSlotInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentCreateNestedManyWithoutSlotInput>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    ehrCancellationReason?: InputMaybe<Scalars['String']['input']>;
    endTime: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    note?: InputMaybe<Scalars['String']['input']>;
    noteUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    noteUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    reviewStatus?: InputMaybe<Scalars['String']['input']>;
    slotType?: InputMaybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['input'];
    status: SlotStatusEnum;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    virtualLink?: InputMaybe<Scalars['String']['input']>;
};

export type SlotGroupBy = {
    __typename?: 'SlotGroupBy';
    _avg?: Maybe<SlotAvgAggregate>;
    _count?: Maybe<SlotCountAggregate>;
    _max?: Maybe<SlotMaxAggregate>;
    _min?: Maybe<SlotMinAggregate>;
    _sum?: Maybe<SlotSumAggregate>;
    appointmentId: Scalars['String']['output'];
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt: Scalars['DateTimeISO']['output'];
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime: Scalars['DateTimeISO']['output'];
    status: SlotStatusEnum;
    updatedAt: Scalars['DateTimeISO']['output'];
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type SlotListRelationFilter = {
    every?: InputMaybe<SlotWhereInput>;
    none?: InputMaybe<SlotWhereInput>;
    some?: InputMaybe<SlotWhereInput>;
};

export type SlotMaxAggregate = {
    __typename?: 'SlotMaxAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<SlotStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type SlotMaxOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrCancellationReason?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
    noteUpdatedAt?: InputMaybe<SortOrder>;
    noteUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotType?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    virtualLink?: InputMaybe<SortOrder>;
};

export type SlotMinAggregate = {
    __typename?: 'SlotMinAggregate';
    appointmentId?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrCancellationReason?: Maybe<Scalars['String']['output']>;
    ehrSlotId?: Maybe<Scalars['String']['output']>;
    endTime?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    noteUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    noteUpdatedBy?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    reviewStatus?: Maybe<Scalars['String']['output']>;
    slotType?: Maybe<SlotTypeEnum>;
    startTime?: Maybe<Scalars['DateTimeISO']['output']>;
    status?: Maybe<SlotStatusEnum>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    virtualLink?: Maybe<Scalars['String']['output']>;
};

export type SlotMinOrderByAggregateInput = {
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    ehrCancellationReason?: InputMaybe<SortOrder>;
    ehrSlotId?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    note?: InputMaybe<SortOrder>;
    noteUpdatedAt?: InputMaybe<SortOrder>;
    noteUpdatedBy?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrder>;
    slotType?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    virtualLink?: InputMaybe<SortOrder>;
};

export type SlotNullableRelationFilter = {
    is?: InputMaybe<SlotWhereInput>;
    isNot?: InputMaybe<SlotWhereInput>;
};

export type SlotOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type SlotOrderByWithAggregationInput = {
    _avg?: InputMaybe<SlotAvgOrderByAggregateInput>;
    _count?: InputMaybe<SlotCountOrderByAggregateInput>;
    _max?: InputMaybe<SlotMaxOrderByAggregateInput>;
    _min?: InputMaybe<SlotMinOrderByAggregateInput>;
    _sum?: InputMaybe<SlotSumOrderByAggregateInput>;
    appointmentId?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrCancellationReason?: InputMaybe<SortOrderInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    note?: InputMaybe<SortOrderInput>;
    noteUpdatedAt?: InputMaybe<SortOrder>;
    noteUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrderInput>;
    slotType?: InputMaybe<SortOrderInput>;
    startTime?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    virtualLink?: InputMaybe<SortOrderInput>;
};

export type SlotOrderByWithRelationInput = {
    EhrSlot?: InputMaybe<EhrSlotOrderByWithRelationInput>;
    appointment?: InputMaybe<AppointmentOrderByWithRelationInput>;
    appointmentId?: InputMaybe<SortOrder>;
    boughtTreatments?: InputMaybe<BoughtTreatmentOrderByRelationAggregateInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentOrderByRelationAggregateInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    createdAt?: InputMaybe<SortOrder>;
    ehrCancellationReason?: InputMaybe<SortOrderInput>;
    ehrSlotId?: InputMaybe<SortOrderInput>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    note?: InputMaybe<SortOrderInput>;
    noteUpdatedAt?: InputMaybe<SortOrder>;
    noteUpdatedBy?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    reviewStatus?: InputMaybe<SortOrderInput>;
    slotType?: InputMaybe<SortOrderInput>;
    startTime?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    virtualLink?: InputMaybe<SortOrderInput>;
};

export type SlotRelationFilter = {
    is?: InputMaybe<SlotWhereInput>;
    isNot?: InputMaybe<SlotWhereInput>;
};

export enum SlotScalarFieldEnum {
    AppointmentId = 'appointmentId',
    ConsumerId = 'consumerId',
    CreatedAt = 'createdAt',
    EhrCancellationReason = 'ehrCancellationReason',
    EhrSlotId = 'ehrSlotId',
    EndTime = 'endTime',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Note = 'note',
    NoteUpdatedAt = 'noteUpdatedAt',
    NoteUpdatedBy = 'noteUpdatedBy',
    OrgId = 'orgId',
    PracticeId = 'practiceId',
    ProviderId = 'providerId',
    ReviewStatus = 'reviewStatus',
    SlotType = 'slotType',
    StartTime = 'startTime',
    Status = 'status',
    UpdatedAt = 'updatedAt',
    VirtualLink = 'virtualLink',
}

export type SlotScalarWhereInput = {
    AND?: InputMaybe<Array<SlotScalarWhereInput>>;
    NOT?: InputMaybe<Array<SlotScalarWhereInput>>;
    OR?: InputMaybe<Array<SlotScalarWhereInput>>;
    appointmentId?: InputMaybe<UuidFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrCancellationReason?: InputMaybe<StringNullableFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    endTime?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    note?: InputMaybe<StringNullableFilter>;
    noteUpdatedAt?: InputMaybe<DateTimeFilter>;
    noteUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    providerId?: InputMaybe<IntFilter>;
    reviewStatus?: InputMaybe<StringNullableFilter>;
    slotType?: InputMaybe<EnumSlotTypeEnumNullableFilter>;
    startTime?: InputMaybe<DateTimeFilter>;
    status?: InputMaybe<EnumSlotStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    virtualLink?: InputMaybe<StringNullableFilter>;
};

export type SlotScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<SlotScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<SlotScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<SlotScalarWhereWithAggregatesInput>>;
    appointmentId?: InputMaybe<UuidWithAggregatesFilter>;
    consumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrCancellationReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    ehrSlotId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    endTime?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    note?: InputMaybe<StringNullableWithAggregatesFilter>;
    noteUpdatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    noteUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
    providerId?: InputMaybe<IntWithAggregatesFilter>;
    reviewStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
    slotType?: InputMaybe<EnumSlotTypeEnumNullableWithAggregatesFilter>;
    startTime?: InputMaybe<DateTimeWithAggregatesFilter>;
    status?: InputMaybe<EnumSlotStatusEnumWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    virtualLink?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum SlotStatusEnum {
    Canceled = 'canceled',
    Completed = 'completed',
    Deleted = 'deleted',
    Upcoming = 'upcoming',
}

export type SlotSumAggregate = {
    __typename?: 'SlotSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
};

export type SlotSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export enum SlotTypeEnum {
    Insurance = 'INSURANCE',
    Selfpay = 'SELFPAY',
    Unknown = 'UNKNOWN',
}

export type SlotUpdateInput = {
    EhrSlot?: InputMaybe<EhrSlotUpdateOneWithoutSlotNestedInput>;
    appointment?: InputMaybe<AppointmentUpdateOneWithoutSlotsNestedInput>;
    boughtTreatments?: InputMaybe<BoughtTreatmentUpdateManyWithoutSlotNestedInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentUpdateManyWithoutSlotNestedInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrCancellationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noteUpdatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    noteUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotType?: InputMaybe<NullableEnumSlotTypeEnumFieldUpdateOperationsInput>;
    startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    virtualLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SlotUpdateManyMutationInput = {
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrCancellationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noteUpdatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    noteUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotType?: InputMaybe<NullableEnumSlotTypeEnumFieldUpdateOperationsInput>;
    startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    virtualLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SlotUpdateManyWithWhereWithoutAppointmentInput = {
    data: SlotUpdateManyMutationInput;
    where: SlotScalarWhereInput;
};

export type SlotUpdateManyWithWhereWithoutEhrSlotInput = {
    data: SlotUpdateManyMutationInput;
    where: SlotScalarWhereInput;
};

export type SlotUpdateManyWithoutAppointmentNestedInput = {
    connect?: InputMaybe<Array<SlotWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SlotCreateOrConnectWithoutAppointmentInput>
    >;
    create?: InputMaybe<Array<SlotCreateWithoutAppointmentInput>>;
    createMany?: InputMaybe<SlotCreateManyAppointmentInputEnvelope>;
    delete?: InputMaybe<Array<SlotWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<SlotScalarWhereInput>>;
    disconnect?: InputMaybe<Array<SlotWhereUniqueInput>>;
    set?: InputMaybe<Array<SlotWhereUniqueInput>>;
    update?: InputMaybe<
        Array<SlotUpdateWithWhereUniqueWithoutAppointmentInput>
    >;
    updateMany?: InputMaybe<
        Array<SlotUpdateManyWithWhereWithoutAppointmentInput>
    >;
    upsert?: InputMaybe<
        Array<SlotUpsertWithWhereUniqueWithoutAppointmentInput>
    >;
};

export type SlotUpdateManyWithoutEhrSlotNestedInput = {
    connect?: InputMaybe<Array<SlotWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<SlotCreateOrConnectWithoutEhrSlotInput>>;
    create?: InputMaybe<Array<SlotCreateWithoutEhrSlotInput>>;
    createMany?: InputMaybe<SlotCreateManyEhrSlotInputEnvelope>;
    delete?: InputMaybe<Array<SlotWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<SlotScalarWhereInput>>;
    disconnect?: InputMaybe<Array<SlotWhereUniqueInput>>;
    set?: InputMaybe<Array<SlotWhereUniqueInput>>;
    update?: InputMaybe<Array<SlotUpdateWithWhereUniqueWithoutEhrSlotInput>>;
    updateMany?: InputMaybe<Array<SlotUpdateManyWithWhereWithoutEhrSlotInput>>;
    upsert?: InputMaybe<Array<SlotUpsertWithWhereUniqueWithoutEhrSlotInput>>;
};

export type SlotUpdateOneRequiredWithoutCandidateTreatmentsNestedInput = {
    connect?: InputMaybe<SlotWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SlotCreateOrConnectWithoutCandidateTreatmentsInput>;
    create?: InputMaybe<SlotCreateWithoutCandidateTreatmentsInput>;
    update?: InputMaybe<SlotUpdateToOneWithWhereWithoutCandidateTreatmentsInput>;
    upsert?: InputMaybe<SlotUpsertWithoutCandidateTreatmentsInput>;
};

export type SlotUpdateOneWithoutBoughtTreatmentsNestedInput = {
    connect?: InputMaybe<SlotWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SlotCreateOrConnectWithoutBoughtTreatmentsInput>;
    create?: InputMaybe<SlotCreateWithoutBoughtTreatmentsInput>;
    delete?: InputMaybe<SlotWhereInput>;
    disconnect?: InputMaybe<SlotWhereInput>;
    update?: InputMaybe<SlotUpdateToOneWithWhereWithoutBoughtTreatmentsInput>;
    upsert?: InputMaybe<SlotUpsertWithoutBoughtTreatmentsInput>;
};

export type SlotUpdateToOneWithWhereWithoutBoughtTreatmentsInput = {
    data: SlotUpdateWithoutBoughtTreatmentsInput;
    where?: InputMaybe<SlotWhereInput>;
};

export type SlotUpdateToOneWithWhereWithoutCandidateTreatmentsInput = {
    data: SlotUpdateWithoutCandidateTreatmentsInput;
    where?: InputMaybe<SlotWhereInput>;
};

export type SlotUpdateWithWhereUniqueWithoutAppointmentInput = {
    data: SlotUpdateWithoutAppointmentInput;
    where: SlotWhereUniqueInput;
};

export type SlotUpdateWithWhereUniqueWithoutEhrSlotInput = {
    data: SlotUpdateWithoutEhrSlotInput;
    where: SlotWhereUniqueInput;
};

export type SlotUpdateWithoutAppointmentInput = {
    EhrSlot?: InputMaybe<EhrSlotUpdateOneWithoutSlotNestedInput>;
    boughtTreatments?: InputMaybe<BoughtTreatmentUpdateManyWithoutSlotNestedInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentUpdateManyWithoutSlotNestedInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrCancellationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noteUpdatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    noteUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotType?: InputMaybe<NullableEnumSlotTypeEnumFieldUpdateOperationsInput>;
    startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    virtualLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SlotUpdateWithoutBoughtTreatmentsInput = {
    EhrSlot?: InputMaybe<EhrSlotUpdateOneWithoutSlotNestedInput>;
    appointment?: InputMaybe<AppointmentUpdateOneWithoutSlotsNestedInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentUpdateManyWithoutSlotNestedInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrCancellationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noteUpdatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    noteUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotType?: InputMaybe<NullableEnumSlotTypeEnumFieldUpdateOperationsInput>;
    startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    virtualLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SlotUpdateWithoutCandidateTreatmentsInput = {
    EhrSlot?: InputMaybe<EhrSlotUpdateOneWithoutSlotNestedInput>;
    appointment?: InputMaybe<AppointmentUpdateOneWithoutSlotsNestedInput>;
    boughtTreatments?: InputMaybe<BoughtTreatmentUpdateManyWithoutSlotNestedInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrCancellationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noteUpdatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    noteUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotType?: InputMaybe<NullableEnumSlotTypeEnumFieldUpdateOperationsInput>;
    startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    virtualLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SlotUpdateWithoutEhrSlotInput = {
    appointment?: InputMaybe<AppointmentUpdateOneWithoutSlotsNestedInput>;
    boughtTreatments?: InputMaybe<BoughtTreatmentUpdateManyWithoutSlotNestedInput>;
    candidateTreatments?: InputMaybe<CandidateTreatmentUpdateManyWithoutSlotNestedInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrCancellationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    noteUpdatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    noteUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    reviewStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    slotType?: InputMaybe<NullableEnumSlotTypeEnumFieldUpdateOperationsInput>;
    startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumSlotStatusEnumFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    virtualLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SlotUpsertWithWhereUniqueWithoutAppointmentInput = {
    create: SlotCreateWithoutAppointmentInput;
    update: SlotUpdateWithoutAppointmentInput;
    where: SlotWhereUniqueInput;
};

export type SlotUpsertWithWhereUniqueWithoutEhrSlotInput = {
    create: SlotCreateWithoutEhrSlotInput;
    update: SlotUpdateWithoutEhrSlotInput;
    where: SlotWhereUniqueInput;
};

export type SlotUpsertWithoutBoughtTreatmentsInput = {
    create: SlotCreateWithoutBoughtTreatmentsInput;
    update: SlotUpdateWithoutBoughtTreatmentsInput;
    where?: InputMaybe<SlotWhereInput>;
};

export type SlotUpsertWithoutCandidateTreatmentsInput = {
    create: SlotCreateWithoutCandidateTreatmentsInput;
    update: SlotUpdateWithoutCandidateTreatmentsInput;
    where?: InputMaybe<SlotWhereInput>;
};

export type SlotWhereInput = {
    AND?: InputMaybe<Array<SlotWhereInput>>;
    EhrSlot?: InputMaybe<EhrSlotNullableRelationFilter>;
    NOT?: InputMaybe<Array<SlotWhereInput>>;
    OR?: InputMaybe<Array<SlotWhereInput>>;
    appointment?: InputMaybe<AppointmentNullableRelationFilter>;
    appointmentId?: InputMaybe<UuidFilter>;
    boughtTreatments?: InputMaybe<BoughtTreatmentListRelationFilter>;
    candidateTreatments?: InputMaybe<CandidateTreatmentListRelationFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrCancellationReason?: InputMaybe<StringNullableFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    endTime?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    note?: InputMaybe<StringNullableFilter>;
    noteUpdatedAt?: InputMaybe<DateTimeFilter>;
    noteUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    providerId?: InputMaybe<IntFilter>;
    reviewStatus?: InputMaybe<StringNullableFilter>;
    slotType?: InputMaybe<EnumSlotTypeEnumNullableFilter>;
    startTime?: InputMaybe<DateTimeFilter>;
    status?: InputMaybe<EnumSlotStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    virtualLink?: InputMaybe<StringNullableFilter>;
};

export type SlotWhereUniqueInput = {
    AND?: InputMaybe<Array<SlotWhereInput>>;
    EhrSlot?: InputMaybe<EhrSlotNullableRelationFilter>;
    NOT?: InputMaybe<Array<SlotWhereInput>>;
    OR?: InputMaybe<Array<SlotWhereInput>>;
    appointment?: InputMaybe<AppointmentNullableRelationFilter>;
    appointmentId?: InputMaybe<UuidFilter>;
    boughtTreatments?: InputMaybe<BoughtTreatmentListRelationFilter>;
    candidateTreatments?: InputMaybe<CandidateTreatmentListRelationFilter>;
    consumerId?: InputMaybe<UuidNullableFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    ehrCancellationReason?: InputMaybe<StringNullableFilter>;
    ehrSlotId?: InputMaybe<UuidNullableFilter>;
    endTime?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    note?: InputMaybe<StringNullableFilter>;
    noteUpdatedAt?: InputMaybe<DateTimeFilter>;
    noteUpdatedBy?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    providerId?: InputMaybe<IntFilter>;
    reviewStatus?: InputMaybe<StringNullableFilter>;
    slotType?: InputMaybe<EnumSlotTypeEnumNullableFilter>;
    startTime?: InputMaybe<DateTimeFilter>;
    status?: InputMaybe<EnumSlotStatusEnumFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    virtualLink?: InputMaybe<StringNullableFilter>;
};

export enum SortOrder {
    Asc = 'asc',
    Desc = 'desc',
}

export type SortOrderInput = {
    nulls?: InputMaybe<NullsOrder>;
    sort: SortOrder;
};

export type Srt = {
    __typename?: 'Srt';
    SrtFlags: Array<SrtFlags>;
    SrtToBillingCode: Array<SrtToBillingCode>;
    _count?: Maybe<SrtCount>;
    cashPrice?: Maybe<Scalars['Int']['output']>;
    description: Scalars['String']['output'];
    hrt_to_srt: Array<HrtToSrt>;
    id: Scalars['Int']['output'];
    isSpecialist?: Maybe<Scalars['Boolean']['output']>;
    name: Scalars['String']['output'];
    posCode: Scalars['String']['output'];
    primaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
    secondaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
    tertiaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
};

export type SrtSrtFlagsArgs = {
    cursor?: InputMaybe<SrtFlagsWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtFlagsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtFlagsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtFlagsWhereInput>;
};

export type SrtSrtToBillingCodeArgs = {
    cursor?: InputMaybe<SrtToBillingCodeWhereUniqueInput>;
    distinct?: InputMaybe<Array<SrtToBillingCodeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SrtToBillingCodeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SrtToBillingCodeWhereInput>;
};

export type SrtHrtToSrtArgs = {
    cursor?: InputMaybe<HrtToSrtWhereUniqueInput>;
    distinct?: InputMaybe<Array<HrtToSrtScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<HrtToSrtOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type SrtAvgAggregate = {
    __typename?: 'SrtAvgAggregate';
    cashPrice?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
};

export type SrtAvgOrderByAggregateInput = {
    cashPrice?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type SrtCount = {
    __typename?: 'SrtCount';
    SrtFlags: Scalars['Int']['output'];
    SrtToBillingCode: Scalars['Int']['output'];
    hrt_to_srt: Scalars['Int']['output'];
};

export type SrtCountSrtFlagsArgs = {
    where?: InputMaybe<SrtFlagsWhereInput>;
};

export type SrtCountSrtToBillingCodeArgs = {
    where?: InputMaybe<SrtToBillingCodeWhereInput>;
};

export type SrtCountHrtToSrtArgs = {
    where?: InputMaybe<HrtToSrtWhereInput>;
};

export type SrtCountAggregate = {
    __typename?: 'SrtCountAggregate';
    _all: Scalars['Int']['output'];
    cashPrice: Scalars['Int']['output'];
    description: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isSpecialist: Scalars['Int']['output'];
    name: Scalars['Int']['output'];
    posCode: Scalars['Int']['output'];
    primaryServiceTypeCode: Scalars['Int']['output'];
    secondaryServiceTypeCode: Scalars['Int']['output'];
    tertiaryServiceTypeCode: Scalars['Int']['output'];
};

export type SrtCountOrderByAggregateInput = {
    cashPrice?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    posCode?: InputMaybe<SortOrder>;
    primaryServiceTypeCode?: InputMaybe<SortOrder>;
    secondaryServiceTypeCode?: InputMaybe<SortOrder>;
    tertiaryServiceTypeCode?: InputMaybe<SortOrder>;
};

export type SrtCreateInput = {
    SrtFlags?: InputMaybe<SrtFlagsCreateNestedManyWithoutSrtInput>;
    SrtToBillingCode?: InputMaybe<SrtToBillingCodeCreateNestedManyWithoutSrtInput>;
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    description: Scalars['String']['input'];
    hrt_to_srt?: InputMaybe<HrtToSrtCreateNestedManyWithoutSrtInput>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    posCode: Scalars['String']['input'];
    primaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
    secondaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
    tertiaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type SrtCreateManyInput = {
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    description: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    posCode: Scalars['String']['input'];
    primaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
    secondaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
    tertiaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type SrtCreateNestedOneWithoutHrtToSrtInput = {
    connect?: InputMaybe<SrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SrtCreateOrConnectWithoutHrtToSrtInput>;
    create?: InputMaybe<SrtCreateWithoutHrtToSrtInput>;
};

export type SrtCreateNestedOneWithoutSrtFlagsInput = {
    connect?: InputMaybe<SrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SrtCreateOrConnectWithoutSrtFlagsInput>;
    create?: InputMaybe<SrtCreateWithoutSrtFlagsInput>;
};

export type SrtCreateNestedOneWithoutSrtToBillingCodeInput = {
    connect?: InputMaybe<SrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SrtCreateOrConnectWithoutSrtToBillingCodeInput>;
    create?: InputMaybe<SrtCreateWithoutSrtToBillingCodeInput>;
};

export type SrtCreateOrConnectWithoutHrtToSrtInput = {
    create: SrtCreateWithoutHrtToSrtInput;
    where: SrtWhereUniqueInput;
};

export type SrtCreateOrConnectWithoutSrtFlagsInput = {
    create: SrtCreateWithoutSrtFlagsInput;
    where: SrtWhereUniqueInput;
};

export type SrtCreateOrConnectWithoutSrtToBillingCodeInput = {
    create: SrtCreateWithoutSrtToBillingCodeInput;
    where: SrtWhereUniqueInput;
};

export type SrtCreateWithoutHrtToSrtInput = {
    SrtFlags?: InputMaybe<SrtFlagsCreateNestedManyWithoutSrtInput>;
    SrtToBillingCode?: InputMaybe<SrtToBillingCodeCreateNestedManyWithoutSrtInput>;
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    description: Scalars['String']['input'];
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    posCode: Scalars['String']['input'];
    primaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
    secondaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
    tertiaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type SrtCreateWithoutSrtFlagsInput = {
    SrtToBillingCode?: InputMaybe<SrtToBillingCodeCreateNestedManyWithoutSrtInput>;
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    description: Scalars['String']['input'];
    hrt_to_srt?: InputMaybe<HrtToSrtCreateNestedManyWithoutSrtInput>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    posCode: Scalars['String']['input'];
    primaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
    secondaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
    tertiaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type SrtCreateWithoutSrtToBillingCodeInput = {
    SrtFlags?: InputMaybe<SrtFlagsCreateNestedManyWithoutSrtInput>;
    cashPrice?: InputMaybe<Scalars['Int']['input']>;
    description: Scalars['String']['input'];
    hrt_to_srt?: InputMaybe<HrtToSrtCreateNestedManyWithoutSrtInput>;
    isSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
    name: Scalars['String']['input'];
    posCode: Scalars['String']['input'];
    primaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
    secondaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
    tertiaryServiceTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type SrtFlags = {
    __typename?: 'SrtFlags';
    isAnesthesiaRoutedPainManagement: Scalars['Boolean']['output'];
    isInjection: Scalars['Boolean']['output'];
    srt: Srt;
    srtId: Scalars['Int']['output'];
};

export type SrtFlagsAvgAggregate = {
    __typename?: 'SrtFlagsAvgAggregate';
    srtId?: Maybe<Scalars['Float']['output']>;
};

export type SrtFlagsAvgOrderByAggregateInput = {
    srtId?: InputMaybe<SortOrder>;
};

export type SrtFlagsCountAggregate = {
    __typename?: 'SrtFlagsCountAggregate';
    _all: Scalars['Int']['output'];
    isAnesthesiaRoutedPainManagement: Scalars['Int']['output'];
    isInjection: Scalars['Int']['output'];
    srtId: Scalars['Int']['output'];
};

export type SrtFlagsCountOrderByAggregateInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<SortOrder>;
    isInjection?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type SrtFlagsCreateInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<Scalars['Boolean']['input']>;
    isInjection?: InputMaybe<Scalars['Boolean']['input']>;
    srt: SrtCreateNestedOneWithoutSrtFlagsInput;
};

export type SrtFlagsCreateManyInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<Scalars['Boolean']['input']>;
    isInjection?: InputMaybe<Scalars['Boolean']['input']>;
    srtId: Scalars['Int']['input'];
};

export type SrtFlagsCreateManySrtInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<Scalars['Boolean']['input']>;
    isInjection?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SrtFlagsCreateManySrtInputEnvelope = {
    data: Array<SrtFlagsCreateManySrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SrtFlagsCreateNestedManyWithoutSrtInput = {
    connect?: InputMaybe<Array<SrtFlagsWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<SrtFlagsCreateOrConnectWithoutSrtInput>>;
    create?: InputMaybe<Array<SrtFlagsCreateWithoutSrtInput>>;
    createMany?: InputMaybe<SrtFlagsCreateManySrtInputEnvelope>;
};

export type SrtFlagsCreateOrConnectWithoutSrtInput = {
    create: SrtFlagsCreateWithoutSrtInput;
    where: SrtFlagsWhereUniqueInput;
};

export type SrtFlagsCreateWithoutSrtInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<Scalars['Boolean']['input']>;
    isInjection?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SrtFlagsGroupBy = {
    __typename?: 'SrtFlagsGroupBy';
    _avg?: Maybe<SrtFlagsAvgAggregate>;
    _count?: Maybe<SrtFlagsCountAggregate>;
    _max?: Maybe<SrtFlagsMaxAggregate>;
    _min?: Maybe<SrtFlagsMinAggregate>;
    _sum?: Maybe<SrtFlagsSumAggregate>;
    isAnesthesiaRoutedPainManagement: Scalars['Boolean']['output'];
    isInjection: Scalars['Boolean']['output'];
    srtId: Scalars['Int']['output'];
};

export type SrtFlagsListRelationFilter = {
    every?: InputMaybe<SrtFlagsWhereInput>;
    none?: InputMaybe<SrtFlagsWhereInput>;
    some?: InputMaybe<SrtFlagsWhereInput>;
};

export type SrtFlagsMaxAggregate = {
    __typename?: 'SrtFlagsMaxAggregate';
    isAnesthesiaRoutedPainManagement?: Maybe<Scalars['Boolean']['output']>;
    isInjection?: Maybe<Scalars['Boolean']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
};

export type SrtFlagsMaxOrderByAggregateInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<SortOrder>;
    isInjection?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type SrtFlagsMinAggregate = {
    __typename?: 'SrtFlagsMinAggregate';
    isAnesthesiaRoutedPainManagement?: Maybe<Scalars['Boolean']['output']>;
    isInjection?: Maybe<Scalars['Boolean']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
};

export type SrtFlagsMinOrderByAggregateInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<SortOrder>;
    isInjection?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type SrtFlagsOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type SrtFlagsOrderByWithAggregationInput = {
    _avg?: InputMaybe<SrtFlagsAvgOrderByAggregateInput>;
    _count?: InputMaybe<SrtFlagsCountOrderByAggregateInput>;
    _max?: InputMaybe<SrtFlagsMaxOrderByAggregateInput>;
    _min?: InputMaybe<SrtFlagsMinOrderByAggregateInput>;
    _sum?: InputMaybe<SrtFlagsSumOrderByAggregateInput>;
    isAnesthesiaRoutedPainManagement?: InputMaybe<SortOrder>;
    isInjection?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type SrtFlagsOrderByWithRelationInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<SortOrder>;
    isInjection?: InputMaybe<SortOrder>;
    srt?: InputMaybe<SrtOrderByWithRelationInput>;
    srtId?: InputMaybe<SortOrder>;
};

export enum SrtFlagsScalarFieldEnum {
    IsAnesthesiaRoutedPainManagement = 'isAnesthesiaRoutedPainManagement',
    IsInjection = 'isInjection',
    SrtId = 'srtId',
}

export type SrtFlagsScalarWhereInput = {
    AND?: InputMaybe<Array<SrtFlagsScalarWhereInput>>;
    NOT?: InputMaybe<Array<SrtFlagsScalarWhereInput>>;
    OR?: InputMaybe<Array<SrtFlagsScalarWhereInput>>;
    isAnesthesiaRoutedPainManagement?: InputMaybe<BoolFilter>;
    isInjection?: InputMaybe<BoolFilter>;
    srtId?: InputMaybe<IntFilter>;
};

export type SrtFlagsScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<SrtFlagsScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<SrtFlagsScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<SrtFlagsScalarWhereWithAggregatesInput>>;
    isAnesthesiaRoutedPainManagement?: InputMaybe<BoolWithAggregatesFilter>;
    isInjection?: InputMaybe<BoolWithAggregatesFilter>;
    srtId?: InputMaybe<IntWithAggregatesFilter>;
};

export type SrtFlagsSumAggregate = {
    __typename?: 'SrtFlagsSumAggregate';
    srtId?: Maybe<Scalars['Int']['output']>;
};

export type SrtFlagsSumOrderByAggregateInput = {
    srtId?: InputMaybe<SortOrder>;
};

export type SrtFlagsUpdateInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isInjection?: InputMaybe<BoolFieldUpdateOperationsInput>;
    srt?: InputMaybe<SrtUpdateOneRequiredWithoutSrtFlagsNestedInput>;
};

export type SrtFlagsUpdateManyMutationInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isInjection?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type SrtFlagsUpdateManyWithWhereWithoutSrtInput = {
    data: SrtFlagsUpdateManyMutationInput;
    where: SrtFlagsScalarWhereInput;
};

export type SrtFlagsUpdateManyWithoutSrtNestedInput = {
    connect?: InputMaybe<Array<SrtFlagsWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<Array<SrtFlagsCreateOrConnectWithoutSrtInput>>;
    create?: InputMaybe<Array<SrtFlagsCreateWithoutSrtInput>>;
    createMany?: InputMaybe<SrtFlagsCreateManySrtInputEnvelope>;
    delete?: InputMaybe<Array<SrtFlagsWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<SrtFlagsScalarWhereInput>>;
    disconnect?: InputMaybe<Array<SrtFlagsWhereUniqueInput>>;
    set?: InputMaybe<Array<SrtFlagsWhereUniqueInput>>;
    update?: InputMaybe<Array<SrtFlagsUpdateWithWhereUniqueWithoutSrtInput>>;
    updateMany?: InputMaybe<Array<SrtFlagsUpdateManyWithWhereWithoutSrtInput>>;
    upsert?: InputMaybe<Array<SrtFlagsUpsertWithWhereUniqueWithoutSrtInput>>;
};

export type SrtFlagsUpdateWithWhereUniqueWithoutSrtInput = {
    data: SrtFlagsUpdateWithoutSrtInput;
    where: SrtFlagsWhereUniqueInput;
};

export type SrtFlagsUpdateWithoutSrtInput = {
    isAnesthesiaRoutedPainManagement?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isInjection?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type SrtFlagsUpsertWithWhereUniqueWithoutSrtInput = {
    create: SrtFlagsCreateWithoutSrtInput;
    update: SrtFlagsUpdateWithoutSrtInput;
    where: SrtFlagsWhereUniqueInput;
};

export type SrtFlagsWhereInput = {
    AND?: InputMaybe<Array<SrtFlagsWhereInput>>;
    NOT?: InputMaybe<Array<SrtFlagsWhereInput>>;
    OR?: InputMaybe<Array<SrtFlagsWhereInput>>;
    isAnesthesiaRoutedPainManagement?: InputMaybe<BoolFilter>;
    isInjection?: InputMaybe<BoolFilter>;
    srt?: InputMaybe<SrtRelationFilter>;
    srtId?: InputMaybe<IntFilter>;
};

export type SrtFlagsWhereUniqueInput = {
    AND?: InputMaybe<Array<SrtFlagsWhereInput>>;
    NOT?: InputMaybe<Array<SrtFlagsWhereInput>>;
    OR?: InputMaybe<Array<SrtFlagsWhereInput>>;
    isAnesthesiaRoutedPainManagement?: InputMaybe<BoolFilter>;
    isInjection?: InputMaybe<BoolFilter>;
    srt?: InputMaybe<SrtRelationFilter>;
    srtId?: InputMaybe<Scalars['Int']['input']>;
};

export type SrtGroupBy = {
    __typename?: 'SrtGroupBy';
    _avg?: Maybe<SrtAvgAggregate>;
    _count?: Maybe<SrtCountAggregate>;
    _max?: Maybe<SrtMaxAggregate>;
    _min?: Maybe<SrtMinAggregate>;
    _sum?: Maybe<SrtSumAggregate>;
    cashPrice?: Maybe<Scalars['Int']['output']>;
    description: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    isSpecialist?: Maybe<Scalars['Boolean']['output']>;
    name: Scalars['String']['output'];
    posCode: Scalars['String']['output'];
    primaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
    secondaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
    tertiaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
};

export type SrtMaxAggregate = {
    __typename?: 'SrtMaxAggregate';
    cashPrice?: Maybe<Scalars['Int']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isSpecialist?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    posCode?: Maybe<Scalars['String']['output']>;
    primaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
    secondaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
    tertiaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
};

export type SrtMaxOrderByAggregateInput = {
    cashPrice?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    posCode?: InputMaybe<SortOrder>;
    primaryServiceTypeCode?: InputMaybe<SortOrder>;
    secondaryServiceTypeCode?: InputMaybe<SortOrder>;
    tertiaryServiceTypeCode?: InputMaybe<SortOrder>;
};

export type SrtMinAggregate = {
    __typename?: 'SrtMinAggregate';
    cashPrice?: Maybe<Scalars['Int']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isSpecialist?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    posCode?: Maybe<Scalars['String']['output']>;
    primaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
    secondaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
    tertiaryServiceTypeCode?: Maybe<Scalars['String']['output']>;
};

export type SrtMinOrderByAggregateInput = {
    cashPrice?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    posCode?: InputMaybe<SortOrder>;
    primaryServiceTypeCode?: InputMaybe<SortOrder>;
    secondaryServiceTypeCode?: InputMaybe<SortOrder>;
    tertiaryServiceTypeCode?: InputMaybe<SortOrder>;
};

export type SrtMultiplierRule = {
    __typename?: 'SrtMultiplierRule';
    createdAt: Scalars['DateTimeISO']['output'];
    excludeMedicare: Scalars['Boolean']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    replacementSrtIds: Array<Scalars['Int']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type SrtMultiplierRuleAvgAggregate = {
    __typename?: 'SrtMultiplierRuleAvgAggregate';
    hrtId?: Maybe<Scalars['Float']['output']>;
    id?: Maybe<Scalars['Float']['output']>;
    replacementSrtIds?: Maybe<Scalars['Float']['output']>;
};

export type SrtMultiplierRuleAvgOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    replacementSrtIds?: InputMaybe<SortOrder>;
};

export type SrtMultiplierRuleCountAggregate = {
    __typename?: 'SrtMultiplierRuleCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    excludeMedicare: Scalars['Int']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    replacementSrtIds: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type SrtMultiplierRuleCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    excludeMedicare?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    replacementSrtIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SrtMultiplierRuleCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    excludeMedicare?: InputMaybe<Scalars['Boolean']['input']>;
    hrtId: Scalars['Int']['input'];
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    replacementSrtIds?: InputMaybe<SrtMultiplierRuleCreatereplacementSrtIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SrtMultiplierRuleCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    excludeMedicare?: InputMaybe<Scalars['Boolean']['input']>;
    hrtId: Scalars['Int']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    replacementSrtIds?: InputMaybe<SrtMultiplierRuleCreatereplacementSrtIdsInput>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SrtMultiplierRuleCreatereplacementSrtIdsInput = {
    set: Array<Scalars['Int']['input']>;
};

export type SrtMultiplierRuleGroupBy = {
    __typename?: 'SrtMultiplierRuleGroupBy';
    _avg?: Maybe<SrtMultiplierRuleAvgAggregate>;
    _count?: Maybe<SrtMultiplierRuleCountAggregate>;
    _max?: Maybe<SrtMultiplierRuleMaxAggregate>;
    _min?: Maybe<SrtMultiplierRuleMinAggregate>;
    _sum?: Maybe<SrtMultiplierRuleSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    excludeMedicare: Scalars['Boolean']['output'];
    hrtId: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isActive: Scalars['Boolean']['output'];
    notes?: Maybe<Scalars['String']['output']>;
    replacementSrtIds?: Maybe<Array<Scalars['Int']['output']>>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type SrtMultiplierRuleMaxAggregate = {
    __typename?: 'SrtMultiplierRuleMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    excludeMedicare?: Maybe<Scalars['Boolean']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SrtMultiplierRuleMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    excludeMedicare?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SrtMultiplierRuleMinAggregate = {
    __typename?: 'SrtMultiplierRuleMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    excludeMedicare?: Maybe<Scalars['Boolean']['output']>;
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SrtMultiplierRuleMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    excludeMedicare?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SrtMultiplierRuleOrderByWithAggregationInput = {
    _avg?: InputMaybe<SrtMultiplierRuleAvgOrderByAggregateInput>;
    _count?: InputMaybe<SrtMultiplierRuleCountOrderByAggregateInput>;
    _max?: InputMaybe<SrtMultiplierRuleMaxOrderByAggregateInput>;
    _min?: InputMaybe<SrtMultiplierRuleMinOrderByAggregateInput>;
    _sum?: InputMaybe<SrtMultiplierRuleSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    excludeMedicare?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    replacementSrtIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SrtMultiplierRuleOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    excludeMedicare?: InputMaybe<SortOrder>;
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isActive?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrderInput>;
    replacementSrtIds?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum SrtMultiplierRuleScalarFieldEnum {
    CreatedAt = 'createdAt',
    ExcludeMedicare = 'excludeMedicare',
    HrtId = 'hrtId',
    Id = 'id',
    IsActive = 'isActive',
    Notes = 'notes',
    ReplacementSrtIds = 'replacementSrtIds',
    UpdatedAt = 'updatedAt',
}

export type SrtMultiplierRuleScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<SrtMultiplierRuleScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<SrtMultiplierRuleScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<SrtMultiplierRuleScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    excludeMedicare?: InputMaybe<BoolWithAggregatesFilter>;
    hrtId?: InputMaybe<IntWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isActive?: InputMaybe<BoolWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    replacementSrtIds?: InputMaybe<IntNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type SrtMultiplierRuleSumAggregate = {
    __typename?: 'SrtMultiplierRuleSumAggregate';
    hrtId?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    replacementSrtIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type SrtMultiplierRuleSumOrderByAggregateInput = {
    hrtId?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    replacementSrtIds?: InputMaybe<SortOrder>;
};

export type SrtMultiplierRuleUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    excludeMedicare?: InputMaybe<BoolFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    replacementSrtIds?: InputMaybe<SrtMultiplierRuleUpdatereplacementSrtIdsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SrtMultiplierRuleUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    excludeMedicare?: InputMaybe<BoolFieldUpdateOperationsInput>;
    hrtId?: InputMaybe<IntFieldUpdateOperationsInput>;
    isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    replacementSrtIds?: InputMaybe<SrtMultiplierRuleUpdatereplacementSrtIdsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SrtMultiplierRuleUpdatereplacementSrtIdsInput = {
    push?: InputMaybe<Array<Scalars['Int']['input']>>;
    set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SrtMultiplierRuleWhereInput = {
    AND?: InputMaybe<Array<SrtMultiplierRuleWhereInput>>;
    NOT?: InputMaybe<Array<SrtMultiplierRuleWhereInput>>;
    OR?: InputMaybe<Array<SrtMultiplierRuleWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    excludeMedicare?: InputMaybe<BoolFilter>;
    hrtId?: InputMaybe<IntFilter>;
    id?: InputMaybe<IntFilter>;
    isActive?: InputMaybe<BoolFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    replacementSrtIds?: InputMaybe<IntNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SrtMultiplierRuleWhereUniqueInput = {
    AND?: InputMaybe<Array<SrtMultiplierRuleWhereInput>>;
    NOT?: InputMaybe<Array<SrtMultiplierRuleWhereInput>>;
    OR?: InputMaybe<Array<SrtMultiplierRuleWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    excludeMedicare?: InputMaybe<BoolFilter>;
    hrtId?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isActive?: InputMaybe<BoolFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    replacementSrtIds?: InputMaybe<IntNullableListFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SrtNullableRelationFilter = {
    is?: InputMaybe<SrtWhereInput>;
    isNot?: InputMaybe<SrtWhereInput>;
};

export type SrtOrderByWithAggregationInput = {
    _avg?: InputMaybe<SrtAvgOrderByAggregateInput>;
    _count?: InputMaybe<SrtCountOrderByAggregateInput>;
    _max?: InputMaybe<SrtMaxOrderByAggregateInput>;
    _min?: InputMaybe<SrtMinOrderByAggregateInput>;
    _sum?: InputMaybe<SrtSumOrderByAggregateInput>;
    cashPrice?: InputMaybe<SortOrderInput>;
    description?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    posCode?: InputMaybe<SortOrder>;
    primaryServiceTypeCode?: InputMaybe<SortOrderInput>;
    secondaryServiceTypeCode?: InputMaybe<SortOrderInput>;
    tertiaryServiceTypeCode?: InputMaybe<SortOrderInput>;
};

export type SrtOrderByWithRelationInput = {
    SrtFlags?: InputMaybe<SrtFlagsOrderByRelationAggregateInput>;
    SrtToBillingCode?: InputMaybe<SrtToBillingCodeOrderByRelationAggregateInput>;
    cashPrice?: InputMaybe<SortOrderInput>;
    description?: InputMaybe<SortOrder>;
    hrt_to_srt?: InputMaybe<HrtToSrtOrderByRelationAggregateInput>;
    id?: InputMaybe<SortOrder>;
    isSpecialist?: InputMaybe<SortOrderInput>;
    name?: InputMaybe<SortOrder>;
    posCode?: InputMaybe<SortOrder>;
    primaryServiceTypeCode?: InputMaybe<SortOrderInput>;
    secondaryServiceTypeCode?: InputMaybe<SortOrderInput>;
    tertiaryServiceTypeCode?: InputMaybe<SortOrderInput>;
};

export type SrtRelationFilter = {
    is?: InputMaybe<SrtWhereInput>;
    isNot?: InputMaybe<SrtWhereInput>;
};

export enum SrtScalarFieldEnum {
    CashPrice = 'cashPrice',
    Description = 'description',
    Id = 'id',
    IsSpecialist = 'isSpecialist',
    Name = 'name',
    PosCode = 'posCode',
    PrimaryServiceTypeCode = 'primaryServiceTypeCode',
    SecondaryServiceTypeCode = 'secondaryServiceTypeCode',
    TertiaryServiceTypeCode = 'tertiaryServiceTypeCode',
}

export type SrtScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<SrtScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<SrtScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<SrtScalarWhereWithAggregatesInput>>;
    cashPrice?: InputMaybe<IntNullableWithAggregatesFilter>;
    description?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    isSpecialist?: InputMaybe<BoolNullableWithAggregatesFilter>;
    name?: InputMaybe<StringWithAggregatesFilter>;
    posCode?: InputMaybe<StringWithAggregatesFilter>;
    primaryServiceTypeCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    secondaryServiceTypeCode?: InputMaybe<StringNullableWithAggregatesFilter>;
    tertiaryServiceTypeCode?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type SrtSumAggregate = {
    __typename?: 'SrtSumAggregate';
    cashPrice?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type SrtSumOrderByAggregateInput = {
    cashPrice?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
};

export type SrtToBillingCode = {
    __typename?: 'SrtToBillingCode';
    billingCode: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    srt?: Maybe<Srt>;
    srtId: Scalars['Int']['output'];
};

export type SrtToBillingCodeSrtArgs = {
    where?: InputMaybe<SrtWhereInput>;
};

export type SrtToBillingCodeAvgAggregate = {
    __typename?: 'SrtToBillingCodeAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    srtId?: Maybe<Scalars['Float']['output']>;
};

export type SrtToBillingCodeAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type SrtToBillingCodeCountAggregate = {
    __typename?: 'SrtToBillingCodeCountAggregate';
    _all: Scalars['Int']['output'];
    billingCode: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    srtId: Scalars['Int']['output'];
};

export type SrtToBillingCodeCountOrderByAggregateInput = {
    billingCode?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type SrtToBillingCodeCreateInput = {
    billingCode: Scalars['String']['input'];
    srt?: InputMaybe<SrtCreateNestedOneWithoutSrtToBillingCodeInput>;
};

export type SrtToBillingCodeCreateManyInput = {
    billingCode: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
    srtId: Scalars['Int']['input'];
};

export type SrtToBillingCodeCreateManySrtInput = {
    billingCode: Scalars['String']['input'];
    id?: InputMaybe<Scalars['Int']['input']>;
};

export type SrtToBillingCodeCreateManySrtInputEnvelope = {
    data: Array<SrtToBillingCodeCreateManySrtInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SrtToBillingCodeCreateNestedManyWithoutSrtInput = {
    connect?: InputMaybe<Array<SrtToBillingCodeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SrtToBillingCodeCreateOrConnectWithoutSrtInput>
    >;
    create?: InputMaybe<Array<SrtToBillingCodeCreateWithoutSrtInput>>;
    createMany?: InputMaybe<SrtToBillingCodeCreateManySrtInputEnvelope>;
};

export type SrtToBillingCodeCreateOrConnectWithoutSrtInput = {
    create: SrtToBillingCodeCreateWithoutSrtInput;
    where: SrtToBillingCodeWhereUniqueInput;
};

export type SrtToBillingCodeCreateWithoutSrtInput = {
    billingCode: Scalars['String']['input'];
};

export type SrtToBillingCodeGroupBy = {
    __typename?: 'SrtToBillingCodeGroupBy';
    _avg?: Maybe<SrtToBillingCodeAvgAggregate>;
    _count?: Maybe<SrtToBillingCodeCountAggregate>;
    _max?: Maybe<SrtToBillingCodeMaxAggregate>;
    _min?: Maybe<SrtToBillingCodeMinAggregate>;
    _sum?: Maybe<SrtToBillingCodeSumAggregate>;
    billingCode: Scalars['String']['output'];
    id: Scalars['Int']['output'];
    srtId: Scalars['Int']['output'];
};

export type SrtToBillingCodeListRelationFilter = {
    every?: InputMaybe<SrtToBillingCodeWhereInput>;
    none?: InputMaybe<SrtToBillingCodeWhereInput>;
    some?: InputMaybe<SrtToBillingCodeWhereInput>;
};

export type SrtToBillingCodeMaxAggregate = {
    __typename?: 'SrtToBillingCodeMaxAggregate';
    billingCode?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
};

export type SrtToBillingCodeMaxOrderByAggregateInput = {
    billingCode?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type SrtToBillingCodeMinAggregate = {
    __typename?: 'SrtToBillingCodeMinAggregate';
    billingCode?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
};

export type SrtToBillingCodeMinOrderByAggregateInput = {
    billingCode?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type SrtToBillingCodeOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type SrtToBillingCodeOrderByWithAggregationInput = {
    _avg?: InputMaybe<SrtToBillingCodeAvgOrderByAggregateInput>;
    _count?: InputMaybe<SrtToBillingCodeCountOrderByAggregateInput>;
    _max?: InputMaybe<SrtToBillingCodeMaxOrderByAggregateInput>;
    _min?: InputMaybe<SrtToBillingCodeMinOrderByAggregateInput>;
    _sum?: InputMaybe<SrtToBillingCodeSumOrderByAggregateInput>;
    billingCode?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type SrtToBillingCodeOrderByWithRelationInput = {
    billingCode?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    srt?: InputMaybe<SrtOrderByWithRelationInput>;
    srtId?: InputMaybe<SortOrder>;
};

export enum SrtToBillingCodeScalarFieldEnum {
    BillingCode = 'billingCode',
    Id = 'id',
    SrtId = 'srtId',
}

export type SrtToBillingCodeScalarWhereInput = {
    AND?: InputMaybe<Array<SrtToBillingCodeScalarWhereInput>>;
    NOT?: InputMaybe<Array<SrtToBillingCodeScalarWhereInput>>;
    OR?: InputMaybe<Array<SrtToBillingCodeScalarWhereInput>>;
    billingCode?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    srtId?: InputMaybe<IntFilter>;
};

export type SrtToBillingCodeScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<SrtToBillingCodeScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<SrtToBillingCodeScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<SrtToBillingCodeScalarWhereWithAggregatesInput>>;
    billingCode?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    srtId?: InputMaybe<IntWithAggregatesFilter>;
};

export type SrtToBillingCodeSumAggregate = {
    __typename?: 'SrtToBillingCodeSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    srtId?: Maybe<Scalars['Int']['output']>;
};

export type SrtToBillingCodeSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    srtId?: InputMaybe<SortOrder>;
};

export type SrtToBillingCodeUpdateInput = {
    billingCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    srt?: InputMaybe<SrtUpdateOneWithoutSrtToBillingCodeNestedInput>;
};

export type SrtToBillingCodeUpdateManyMutationInput = {
    billingCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SrtToBillingCodeUpdateManyWithWhereWithoutSrtInput = {
    data: SrtToBillingCodeUpdateManyMutationInput;
    where: SrtToBillingCodeScalarWhereInput;
};

export type SrtToBillingCodeUpdateManyWithoutSrtNestedInput = {
    connect?: InputMaybe<Array<SrtToBillingCodeWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SrtToBillingCodeCreateOrConnectWithoutSrtInput>
    >;
    create?: InputMaybe<Array<SrtToBillingCodeCreateWithoutSrtInput>>;
    createMany?: InputMaybe<SrtToBillingCodeCreateManySrtInputEnvelope>;
    delete?: InputMaybe<Array<SrtToBillingCodeWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<SrtToBillingCodeScalarWhereInput>>;
    disconnect?: InputMaybe<Array<SrtToBillingCodeWhereUniqueInput>>;
    set?: InputMaybe<Array<SrtToBillingCodeWhereUniqueInput>>;
    update?: InputMaybe<
        Array<SrtToBillingCodeUpdateWithWhereUniqueWithoutSrtInput>
    >;
    updateMany?: InputMaybe<
        Array<SrtToBillingCodeUpdateManyWithWhereWithoutSrtInput>
    >;
    upsert?: InputMaybe<
        Array<SrtToBillingCodeUpsertWithWhereUniqueWithoutSrtInput>
    >;
};

export type SrtToBillingCodeUpdateWithWhereUniqueWithoutSrtInput = {
    data: SrtToBillingCodeUpdateWithoutSrtInput;
    where: SrtToBillingCodeWhereUniqueInput;
};

export type SrtToBillingCodeUpdateWithoutSrtInput = {
    billingCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SrtToBillingCodeUpsertWithWhereUniqueWithoutSrtInput = {
    create: SrtToBillingCodeCreateWithoutSrtInput;
    update: SrtToBillingCodeUpdateWithoutSrtInput;
    where: SrtToBillingCodeWhereUniqueInput;
};

export type SrtToBillingCodeWhereInput = {
    AND?: InputMaybe<Array<SrtToBillingCodeWhereInput>>;
    NOT?: InputMaybe<Array<SrtToBillingCodeWhereInput>>;
    OR?: InputMaybe<Array<SrtToBillingCodeWhereInput>>;
    billingCode?: InputMaybe<StringFilter>;
    id?: InputMaybe<IntFilter>;
    srt?: InputMaybe<SrtNullableRelationFilter>;
    srtId?: InputMaybe<IntFilter>;
};

export type SrtToBillingCodeWhereUniqueInput = {
    AND?: InputMaybe<Array<SrtToBillingCodeWhereInput>>;
    NOT?: InputMaybe<Array<SrtToBillingCodeWhereInput>>;
    OR?: InputMaybe<Array<SrtToBillingCodeWhereInput>>;
    billingCode?: InputMaybe<StringFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    srt?: InputMaybe<SrtNullableRelationFilter>;
    srtId?: InputMaybe<IntFilter>;
};

export type SrtUpdateInput = {
    SrtFlags?: InputMaybe<SrtFlagsUpdateManyWithoutSrtNestedInput>;
    SrtToBillingCode?: InputMaybe<SrtToBillingCodeUpdateManyWithoutSrtNestedInput>;
    cashPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    hrt_to_srt?: InputMaybe<HrtToSrtUpdateManyWithoutSrtNestedInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    posCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    primaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    tertiaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SrtUpdateManyMutationInput = {
    cashPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    posCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    primaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    tertiaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SrtUpdateOneRequiredWithoutHrtToSrtNestedInput = {
    connect?: InputMaybe<SrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SrtCreateOrConnectWithoutHrtToSrtInput>;
    create?: InputMaybe<SrtCreateWithoutHrtToSrtInput>;
    update?: InputMaybe<SrtUpdateToOneWithWhereWithoutHrtToSrtInput>;
    upsert?: InputMaybe<SrtUpsertWithoutHrtToSrtInput>;
};

export type SrtUpdateOneRequiredWithoutSrtFlagsNestedInput = {
    connect?: InputMaybe<SrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SrtCreateOrConnectWithoutSrtFlagsInput>;
    create?: InputMaybe<SrtCreateWithoutSrtFlagsInput>;
    update?: InputMaybe<SrtUpdateToOneWithWhereWithoutSrtFlagsInput>;
    upsert?: InputMaybe<SrtUpsertWithoutSrtFlagsInput>;
};

export type SrtUpdateOneWithoutSrtToBillingCodeNestedInput = {
    connect?: InputMaybe<SrtWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SrtCreateOrConnectWithoutSrtToBillingCodeInput>;
    create?: InputMaybe<SrtCreateWithoutSrtToBillingCodeInput>;
    delete?: InputMaybe<SrtWhereInput>;
    disconnect?: InputMaybe<SrtWhereInput>;
    update?: InputMaybe<SrtUpdateToOneWithWhereWithoutSrtToBillingCodeInput>;
    upsert?: InputMaybe<SrtUpsertWithoutSrtToBillingCodeInput>;
};

export type SrtUpdateToOneWithWhereWithoutHrtToSrtInput = {
    data: SrtUpdateWithoutHrtToSrtInput;
    where?: InputMaybe<SrtWhereInput>;
};

export type SrtUpdateToOneWithWhereWithoutSrtFlagsInput = {
    data: SrtUpdateWithoutSrtFlagsInput;
    where?: InputMaybe<SrtWhereInput>;
};

export type SrtUpdateToOneWithWhereWithoutSrtToBillingCodeInput = {
    data: SrtUpdateWithoutSrtToBillingCodeInput;
    where?: InputMaybe<SrtWhereInput>;
};

export type SrtUpdateWithoutHrtToSrtInput = {
    SrtFlags?: InputMaybe<SrtFlagsUpdateManyWithoutSrtNestedInput>;
    SrtToBillingCode?: InputMaybe<SrtToBillingCodeUpdateManyWithoutSrtNestedInput>;
    cashPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    posCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    primaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    tertiaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SrtUpdateWithoutSrtFlagsInput = {
    SrtToBillingCode?: InputMaybe<SrtToBillingCodeUpdateManyWithoutSrtNestedInput>;
    cashPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    hrt_to_srt?: InputMaybe<HrtToSrtUpdateManyWithoutSrtNestedInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    posCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    primaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    tertiaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SrtUpdateWithoutSrtToBillingCodeInput = {
    SrtFlags?: InputMaybe<SrtFlagsUpdateManyWithoutSrtNestedInput>;
    cashPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    description?: InputMaybe<StringFieldUpdateOperationsInput>;
    hrt_to_srt?: InputMaybe<HrtToSrtUpdateManyWithoutSrtNestedInput>;
    isSpecialist?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    name?: InputMaybe<StringFieldUpdateOperationsInput>;
    posCode?: InputMaybe<StringFieldUpdateOperationsInput>;
    primaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    secondaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    tertiaryServiceTypeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SrtUpsertWithoutHrtToSrtInput = {
    create: SrtCreateWithoutHrtToSrtInput;
    update: SrtUpdateWithoutHrtToSrtInput;
    where?: InputMaybe<SrtWhereInput>;
};

export type SrtUpsertWithoutSrtFlagsInput = {
    create: SrtCreateWithoutSrtFlagsInput;
    update: SrtUpdateWithoutSrtFlagsInput;
    where?: InputMaybe<SrtWhereInput>;
};

export type SrtUpsertWithoutSrtToBillingCodeInput = {
    create: SrtCreateWithoutSrtToBillingCodeInput;
    update: SrtUpdateWithoutSrtToBillingCodeInput;
    where?: InputMaybe<SrtWhereInput>;
};

export type SrtWhereInput = {
    AND?: InputMaybe<Array<SrtWhereInput>>;
    NOT?: InputMaybe<Array<SrtWhereInput>>;
    OR?: InputMaybe<Array<SrtWhereInput>>;
    SrtFlags?: InputMaybe<SrtFlagsListRelationFilter>;
    SrtToBillingCode?: InputMaybe<SrtToBillingCodeListRelationFilter>;
    cashPrice?: InputMaybe<IntNullableFilter>;
    description?: InputMaybe<StringFilter>;
    hrt_to_srt?: InputMaybe<HrtToSrtListRelationFilter>;
    id?: InputMaybe<IntFilter>;
    isSpecialist?: InputMaybe<BoolNullableFilter>;
    name?: InputMaybe<StringFilter>;
    posCode?: InputMaybe<StringFilter>;
    primaryServiceTypeCode?: InputMaybe<StringNullableFilter>;
    secondaryServiceTypeCode?: InputMaybe<StringNullableFilter>;
    tertiaryServiceTypeCode?: InputMaybe<StringNullableFilter>;
};

export type SrtWhereUniqueInput = {
    AND?: InputMaybe<Array<SrtWhereInput>>;
    NOT?: InputMaybe<Array<SrtWhereInput>>;
    OR?: InputMaybe<Array<SrtWhereInput>>;
    SrtFlags?: InputMaybe<SrtFlagsListRelationFilter>;
    SrtToBillingCode?: InputMaybe<SrtToBillingCodeListRelationFilter>;
    cashPrice?: InputMaybe<IntNullableFilter>;
    description?: InputMaybe<StringFilter>;
    hrt_to_srt?: InputMaybe<HrtToSrtListRelationFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    isSpecialist?: InputMaybe<BoolNullableFilter>;
    name?: InputMaybe<StringFilter>;
    posCode?: InputMaybe<StringFilter>;
    primaryServiceTypeCode?: InputMaybe<StringNullableFilter>;
    secondaryServiceTypeCode?: InputMaybe<StringNullableFilter>;
    tertiaryServiceTypeCode?: InputMaybe<StringNullableFilter>;
};

export type StatePayerMapping = {
    __typename?: 'StatePayerMapping';
    id: Scalars['Int']['output'];
    payerId: Scalars['Int']['output'];
    payerType: PayerType;
    state: State;
    tag?: Maybe<PayerTag>;
};

export type StatePayerMappingAvgAggregate = {
    __typename?: 'StatePayerMappingAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    payerId?: Maybe<Scalars['Float']['output']>;
};

export type StatePayerMappingAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
};

export type StatePayerMappingCountAggregate = {
    __typename?: 'StatePayerMappingCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    payerId: Scalars['Int']['output'];
    payerType: Scalars['Int']['output'];
    state: Scalars['Int']['output'];
    tag: Scalars['Int']['output'];
};

export type StatePayerMappingCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    payerType?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    tag?: InputMaybe<SortOrder>;
};

export type StatePayerMappingCreateInput = {
    payerId: Scalars['Int']['input'];
    payerType: PayerType;
    state: State;
    tag?: InputMaybe<PayerTag>;
};

export type StatePayerMappingCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    payerId: Scalars['Int']['input'];
    payerType: PayerType;
    state: State;
    tag?: InputMaybe<PayerTag>;
};

export type StatePayerMappingGroupBy = {
    __typename?: 'StatePayerMappingGroupBy';
    _avg?: Maybe<StatePayerMappingAvgAggregate>;
    _count?: Maybe<StatePayerMappingCountAggregate>;
    _max?: Maybe<StatePayerMappingMaxAggregate>;
    _min?: Maybe<StatePayerMappingMinAggregate>;
    _sum?: Maybe<StatePayerMappingSumAggregate>;
    id: Scalars['Int']['output'];
    payerId: Scalars['Int']['output'];
    payerType: PayerType;
    state: State;
    tag?: Maybe<PayerTag>;
};

export type StatePayerMappingMaxAggregate = {
    __typename?: 'StatePayerMappingMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
    payerType?: Maybe<PayerType>;
    state?: Maybe<State>;
    tag?: Maybe<PayerTag>;
};

export type StatePayerMappingMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    payerType?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    tag?: InputMaybe<SortOrder>;
};

export type StatePayerMappingMinAggregate = {
    __typename?: 'StatePayerMappingMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
    payerType?: Maybe<PayerType>;
    state?: Maybe<State>;
    tag?: Maybe<PayerTag>;
};

export type StatePayerMappingMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    payerType?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    tag?: InputMaybe<SortOrder>;
};

export type StatePayerMappingOrderByWithAggregationInput = {
    _avg?: InputMaybe<StatePayerMappingAvgOrderByAggregateInput>;
    _count?: InputMaybe<StatePayerMappingCountOrderByAggregateInput>;
    _max?: InputMaybe<StatePayerMappingMaxOrderByAggregateInput>;
    _min?: InputMaybe<StatePayerMappingMinOrderByAggregateInput>;
    _sum?: InputMaybe<StatePayerMappingSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    payerType?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    tag?: InputMaybe<SortOrderInput>;
};

export type StatePayerMappingOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    payerType?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
    tag?: InputMaybe<SortOrderInput>;
};

export enum StatePayerMappingScalarFieldEnum {
    Id = 'id',
    PayerId = 'payerId',
    PayerType = 'payerType',
    State = 'state',
    Tag = 'tag',
}

export type StatePayerMappingScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<StatePayerMappingScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<StatePayerMappingScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<StatePayerMappingScalarWhereWithAggregatesInput>>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    payerId?: InputMaybe<IntWithAggregatesFilter>;
    payerType?: InputMaybe<EnumPayerTypeWithAggregatesFilter>;
    state?: InputMaybe<EnumStateWithAggregatesFilter>;
    tag?: InputMaybe<EnumPayerTagNullableWithAggregatesFilter>;
};

export type StatePayerMappingSumAggregate = {
    __typename?: 'StatePayerMappingSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['Int']['output']>;
};

export type StatePayerMappingSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
};

export type StatePayerMappingUpdateInput = {
    payerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payerType?: InputMaybe<EnumPayerTypeFieldUpdateOperationsInput>;
    state?: InputMaybe<EnumStateFieldUpdateOperationsInput>;
    tag?: InputMaybe<NullableEnumPayerTagFieldUpdateOperationsInput>;
};

export type StatePayerMappingUpdateManyMutationInput = {
    payerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    payerType?: InputMaybe<EnumPayerTypeFieldUpdateOperationsInput>;
    state?: InputMaybe<EnumStateFieldUpdateOperationsInput>;
    tag?: InputMaybe<NullableEnumPayerTagFieldUpdateOperationsInput>;
};

export type StatePayerMappingWhereInput = {
    AND?: InputMaybe<Array<StatePayerMappingWhereInput>>;
    NOT?: InputMaybe<Array<StatePayerMappingWhereInput>>;
    OR?: InputMaybe<Array<StatePayerMappingWhereInput>>;
    id?: InputMaybe<IntFilter>;
    payerId?: InputMaybe<IntFilter>;
    payerType?: InputMaybe<EnumPayerTypeFilter>;
    state?: InputMaybe<EnumStateFilter>;
    tag?: InputMaybe<EnumPayerTagNullableFilter>;
};

export type StatePayerMappingWhereUniqueInput = {
    AND?: InputMaybe<Array<StatePayerMappingWhereInput>>;
    NOT?: InputMaybe<Array<StatePayerMappingWhereInput>>;
    OR?: InputMaybe<Array<StatePayerMappingWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    payerId?: InputMaybe<IntFilter>;
    payerType?: InputMaybe<EnumPayerTypeFilter>;
    state?: InputMaybe<EnumStateFilter>;
    tag?: InputMaybe<EnumPayerTagNullableFilter>;
};

export type StringFieldUpdateOperationsInput = {
    set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
    contains?: InputMaybe<Scalars['String']['input']>;
    endsWith?: InputMaybe<Scalars['String']['input']>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<QueryMode>;
    not?: InputMaybe<NestedStringFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
    contains?: InputMaybe<Scalars['String']['input']>;
    endsWith?: InputMaybe<Scalars['String']['input']>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<QueryMode>;
    not?: InputMaybe<NestedStringNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
    equals?: InputMaybe<Array<Scalars['String']['input']>>;
    has?: InputMaybe<Scalars['String']['input']>;
    hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
    hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
    isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedStringNullableFilter>;
    _min?: InputMaybe<NestedStringNullableFilter>;
    contains?: InputMaybe<Scalars['String']['input']>;
    endsWith?: InputMaybe<Scalars['String']['input']>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<QueryMode>;
    not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedStringFilter>;
    _min?: InputMaybe<NestedStringFilter>;
    contains?: InputMaybe<Scalars['String']['input']>;
    endsWith?: InputMaybe<Scalars['String']['input']>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<QueryMode>;
    not?: InputMaybe<NestedStringWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SuperscriptFeeLineItem = {
    __typename?: 'SuperscriptFeeLineItem';
    amount: Scalars['Decimal']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    feeConfig: FeeConfig;
    feeConfigId: Scalars['String']['output'];
    feeType: FeeType;
    id: Scalars['String']['output'];
    isArrears: Scalars['Boolean']['output'];
    isWaived: Scalars['Boolean']['output'];
    superscriptFee: SuperscriptFees;
    superscriptFeeId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type SuperscriptFeeLineItemAvgAggregate = {
    __typename?: 'SuperscriptFeeLineItemAvgAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
};

export type SuperscriptFeeLineItemAvgOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
};

export type SuperscriptFeeLineItemCountAggregate = {
    __typename?: 'SuperscriptFeeLineItemCountAggregate';
    _all: Scalars['Int']['output'];
    amount: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    feeConfigId: Scalars['Int']['output'];
    feeType: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isArrears: Scalars['Int']['output'];
    isWaived: Scalars['Int']['output'];
    superscriptFeeId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
};

export type SuperscriptFeeLineItemCountOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    feeConfigId?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SuperscriptFeeLineItemCreateInput = {
    amount: Scalars['Decimal']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feeConfig: FeeConfigCreateNestedOneWithoutSuperscriptFeeLineItemInput;
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    superscriptFee: SuperscriptFeesCreateNestedOneWithoutFeeLineItemsInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SuperscriptFeeLineItemCreateManyFeeConfigInput = {
    amount: Scalars['Decimal']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    superscriptFeeId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SuperscriptFeeLineItemCreateManyFeeConfigInputEnvelope = {
    data: Array<SuperscriptFeeLineItemCreateManyFeeConfigInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuperscriptFeeLineItemCreateManyInput = {
    amount: Scalars['Decimal']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feeConfigId: Scalars['String']['input'];
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    superscriptFeeId: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SuperscriptFeeLineItemCreateManySuperscriptFeeInput = {
    amount: Scalars['Decimal']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feeConfigId: Scalars['String']['input'];
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SuperscriptFeeLineItemCreateManySuperscriptFeeInputEnvelope = {
    data: Array<SuperscriptFeeLineItemCreateManySuperscriptFeeInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuperscriptFeeLineItemCreateNestedManyWithoutFeeConfigInput = {
    connect?: InputMaybe<Array<SuperscriptFeeLineItemWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SuperscriptFeeLineItemCreateOrConnectWithoutFeeConfigInput>
    >;
    create?: InputMaybe<
        Array<SuperscriptFeeLineItemCreateWithoutFeeConfigInput>
    >;
    createMany?: InputMaybe<SuperscriptFeeLineItemCreateManyFeeConfigInputEnvelope>;
};

export type SuperscriptFeeLineItemCreateNestedManyWithoutSuperscriptFeeInput = {
    connect?: InputMaybe<Array<SuperscriptFeeLineItemWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SuperscriptFeeLineItemCreateOrConnectWithoutSuperscriptFeeInput>
    >;
    create?: InputMaybe<
        Array<SuperscriptFeeLineItemCreateWithoutSuperscriptFeeInput>
    >;
    createMany?: InputMaybe<SuperscriptFeeLineItemCreateManySuperscriptFeeInputEnvelope>;
};

export type SuperscriptFeeLineItemCreateOrConnectWithoutFeeConfigInput = {
    create: SuperscriptFeeLineItemCreateWithoutFeeConfigInput;
    where: SuperscriptFeeLineItemWhereUniqueInput;
};

export type SuperscriptFeeLineItemCreateOrConnectWithoutSuperscriptFeeInput = {
    create: SuperscriptFeeLineItemCreateWithoutSuperscriptFeeInput;
    where: SuperscriptFeeLineItemWhereUniqueInput;
};

export type SuperscriptFeeLineItemCreateWithoutFeeConfigInput = {
    amount: Scalars['Decimal']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    superscriptFee: SuperscriptFeesCreateNestedOneWithoutFeeLineItemsInput;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SuperscriptFeeLineItemCreateWithoutSuperscriptFeeInput = {
    amount: Scalars['Decimal']['input'];
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    feeConfig: FeeConfigCreateNestedOneWithoutSuperscriptFeeLineItemInput;
    feeType: FeeType;
    id?: InputMaybe<Scalars['String']['input']>;
    isArrears?: InputMaybe<Scalars['Boolean']['input']>;
    isWaived?: InputMaybe<Scalars['Boolean']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SuperscriptFeeLineItemGroupBy = {
    __typename?: 'SuperscriptFeeLineItemGroupBy';
    _avg?: Maybe<SuperscriptFeeLineItemAvgAggregate>;
    _count?: Maybe<SuperscriptFeeLineItemCountAggregate>;
    _max?: Maybe<SuperscriptFeeLineItemMaxAggregate>;
    _min?: Maybe<SuperscriptFeeLineItemMinAggregate>;
    _sum?: Maybe<SuperscriptFeeLineItemSumAggregate>;
    amount: Scalars['Decimal']['output'];
    createdAt: Scalars['DateTimeISO']['output'];
    feeConfigId: Scalars['String']['output'];
    feeType: FeeType;
    id: Scalars['String']['output'];
    isArrears: Scalars['Boolean']['output'];
    isWaived: Scalars['Boolean']['output'];
    superscriptFeeId: Scalars['String']['output'];
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type SuperscriptFeeLineItemListRelationFilter = {
    every?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
    none?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
    some?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type SuperscriptFeeLineItemMaxAggregate = {
    __typename?: 'SuperscriptFeeLineItemMaxAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feeConfigId?: Maybe<Scalars['String']['output']>;
    feeType?: Maybe<FeeType>;
    id?: Maybe<Scalars['String']['output']>;
    isArrears?: Maybe<Scalars['Boolean']['output']>;
    isWaived?: Maybe<Scalars['Boolean']['output']>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SuperscriptFeeLineItemMaxOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    feeConfigId?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SuperscriptFeeLineItemMinAggregate = {
    __typename?: 'SuperscriptFeeLineItemMinAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    feeConfigId?: Maybe<Scalars['String']['output']>;
    feeType?: Maybe<FeeType>;
    id?: Maybe<Scalars['String']['output']>;
    isArrears?: Maybe<Scalars['Boolean']['output']>;
    isWaived?: Maybe<Scalars['Boolean']['output']>;
    superscriptFeeId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SuperscriptFeeLineItemMinOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    feeConfigId?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SuperscriptFeeLineItemOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type SuperscriptFeeLineItemOrderByWithAggregationInput = {
    _avg?: InputMaybe<SuperscriptFeeLineItemAvgOrderByAggregateInput>;
    _count?: InputMaybe<SuperscriptFeeLineItemCountOrderByAggregateInput>;
    _max?: InputMaybe<SuperscriptFeeLineItemMaxOrderByAggregateInput>;
    _min?: InputMaybe<SuperscriptFeeLineItemMinOrderByAggregateInput>;
    _sum?: InputMaybe<SuperscriptFeeLineItemSumOrderByAggregateInput>;
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    feeConfigId?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type SuperscriptFeeLineItemOrderByWithRelationInput = {
    amount?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    feeConfig?: InputMaybe<FeeConfigOrderByWithRelationInput>;
    feeConfigId?: InputMaybe<SortOrder>;
    feeType?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isArrears?: InputMaybe<SortOrder>;
    isWaived?: InputMaybe<SortOrder>;
    superscriptFee?: InputMaybe<SuperscriptFeesOrderByWithRelationInput>;
    superscriptFeeId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export enum SuperscriptFeeLineItemScalarFieldEnum {
    Amount = 'amount',
    CreatedAt = 'createdAt',
    FeeConfigId = 'feeConfigId',
    FeeType = 'feeType',
    Id = 'id',
    IsArrears = 'isArrears',
    IsWaived = 'isWaived',
    SuperscriptFeeId = 'superscriptFeeId',
    UpdatedAt = 'updatedAt',
}

export type SuperscriptFeeLineItemScalarWhereInput = {
    AND?: InputMaybe<Array<SuperscriptFeeLineItemScalarWhereInput>>;
    NOT?: InputMaybe<Array<SuperscriptFeeLineItemScalarWhereInput>>;
    OR?: InputMaybe<Array<SuperscriptFeeLineItemScalarWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    feeConfigId?: InputMaybe<StringFilter>;
    feeType?: InputMaybe<EnumFeeTypeFilter>;
    id?: InputMaybe<StringFilter>;
    isArrears?: InputMaybe<BoolFilter>;
    isWaived?: InputMaybe<BoolFilter>;
    superscriptFeeId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SuperscriptFeeLineItemScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<SuperscriptFeeLineItemScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<SuperscriptFeeLineItemScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<SuperscriptFeeLineItemScalarWhereWithAggregatesInput>
    >;
    amount?: InputMaybe<DecimalWithAggregatesFilter>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    feeConfigId?: InputMaybe<StringWithAggregatesFilter>;
    feeType?: InputMaybe<EnumFeeTypeWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    isArrears?: InputMaybe<BoolWithAggregatesFilter>;
    isWaived?: InputMaybe<BoolWithAggregatesFilter>;
    superscriptFeeId?: InputMaybe<StringWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type SuperscriptFeeLineItemSumAggregate = {
    __typename?: 'SuperscriptFeeLineItemSumAggregate';
    amount?: Maybe<Scalars['Decimal']['output']>;
};

export type SuperscriptFeeLineItemSumOrderByAggregateInput = {
    amount?: InputMaybe<SortOrder>;
};

export type SuperscriptFeeLineItemUpdateInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    feeConfig?: InputMaybe<FeeConfigUpdateOneRequiredWithoutSuperscriptFeeLineItemNestedInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isArrears?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isWaived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    superscriptFee?: InputMaybe<SuperscriptFeesUpdateOneRequiredWithoutFeeLineItemsNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SuperscriptFeeLineItemUpdateManyMutationInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isArrears?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isWaived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SuperscriptFeeLineItemUpdateManyWithWhereWithoutFeeConfigInput = {
    data: SuperscriptFeeLineItemUpdateManyMutationInput;
    where: SuperscriptFeeLineItemScalarWhereInput;
};

export type SuperscriptFeeLineItemUpdateManyWithWhereWithoutSuperscriptFeeInput =
    {
        data: SuperscriptFeeLineItemUpdateManyMutationInput;
        where: SuperscriptFeeLineItemScalarWhereInput;
    };

export type SuperscriptFeeLineItemUpdateManyWithoutFeeConfigNestedInput = {
    connect?: InputMaybe<Array<SuperscriptFeeLineItemWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SuperscriptFeeLineItemCreateOrConnectWithoutFeeConfigInput>
    >;
    create?: InputMaybe<
        Array<SuperscriptFeeLineItemCreateWithoutFeeConfigInput>
    >;
    createMany?: InputMaybe<SuperscriptFeeLineItemCreateManyFeeConfigInputEnvelope>;
    delete?: InputMaybe<Array<SuperscriptFeeLineItemWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<SuperscriptFeeLineItemScalarWhereInput>>;
    disconnect?: InputMaybe<Array<SuperscriptFeeLineItemWhereUniqueInput>>;
    set?: InputMaybe<Array<SuperscriptFeeLineItemWhereUniqueInput>>;
    update?: InputMaybe<
        Array<SuperscriptFeeLineItemUpdateWithWhereUniqueWithoutFeeConfigInput>
    >;
    updateMany?: InputMaybe<
        Array<SuperscriptFeeLineItemUpdateManyWithWhereWithoutFeeConfigInput>
    >;
    upsert?: InputMaybe<
        Array<SuperscriptFeeLineItemUpsertWithWhereUniqueWithoutFeeConfigInput>
    >;
};

export type SuperscriptFeeLineItemUpdateManyWithoutSuperscriptFeeNestedInput = {
    connect?: InputMaybe<Array<SuperscriptFeeLineItemWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<SuperscriptFeeLineItemCreateOrConnectWithoutSuperscriptFeeInput>
    >;
    create?: InputMaybe<
        Array<SuperscriptFeeLineItemCreateWithoutSuperscriptFeeInput>
    >;
    createMany?: InputMaybe<SuperscriptFeeLineItemCreateManySuperscriptFeeInputEnvelope>;
    delete?: InputMaybe<Array<SuperscriptFeeLineItemWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<SuperscriptFeeLineItemScalarWhereInput>>;
    disconnect?: InputMaybe<Array<SuperscriptFeeLineItemWhereUniqueInput>>;
    set?: InputMaybe<Array<SuperscriptFeeLineItemWhereUniqueInput>>;
    update?: InputMaybe<
        Array<SuperscriptFeeLineItemUpdateWithWhereUniqueWithoutSuperscriptFeeInput>
    >;
    updateMany?: InputMaybe<
        Array<SuperscriptFeeLineItemUpdateManyWithWhereWithoutSuperscriptFeeInput>
    >;
    upsert?: InputMaybe<
        Array<SuperscriptFeeLineItemUpsertWithWhereUniqueWithoutSuperscriptFeeInput>
    >;
};

export type SuperscriptFeeLineItemUpdateWithWhereUniqueWithoutFeeConfigInput = {
    data: SuperscriptFeeLineItemUpdateWithoutFeeConfigInput;
    where: SuperscriptFeeLineItemWhereUniqueInput;
};

export type SuperscriptFeeLineItemUpdateWithWhereUniqueWithoutSuperscriptFeeInput =
    {
        data: SuperscriptFeeLineItemUpdateWithoutSuperscriptFeeInput;
        where: SuperscriptFeeLineItemWhereUniqueInput;
    };

export type SuperscriptFeeLineItemUpdateWithoutFeeConfigInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isArrears?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isWaived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    superscriptFee?: InputMaybe<SuperscriptFeesUpdateOneRequiredWithoutFeeLineItemsNestedInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SuperscriptFeeLineItemUpdateWithoutSuperscriptFeeInput = {
    amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    feeConfig?: InputMaybe<FeeConfigUpdateOneRequiredWithoutSuperscriptFeeLineItemNestedInput>;
    feeType?: InputMaybe<EnumFeeTypeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isArrears?: InputMaybe<BoolFieldUpdateOperationsInput>;
    isWaived?: InputMaybe<BoolFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SuperscriptFeeLineItemUpsertWithWhereUniqueWithoutFeeConfigInput = {
    create: SuperscriptFeeLineItemCreateWithoutFeeConfigInput;
    update: SuperscriptFeeLineItemUpdateWithoutFeeConfigInput;
    where: SuperscriptFeeLineItemWhereUniqueInput;
};

export type SuperscriptFeeLineItemUpsertWithWhereUniqueWithoutSuperscriptFeeInput =
    {
        create: SuperscriptFeeLineItemCreateWithoutSuperscriptFeeInput;
        update: SuperscriptFeeLineItemUpdateWithoutSuperscriptFeeInput;
        where: SuperscriptFeeLineItemWhereUniqueInput;
    };

export type SuperscriptFeeLineItemWhereInput = {
    AND?: InputMaybe<Array<SuperscriptFeeLineItemWhereInput>>;
    NOT?: InputMaybe<Array<SuperscriptFeeLineItemWhereInput>>;
    OR?: InputMaybe<Array<SuperscriptFeeLineItemWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    feeConfig?: InputMaybe<FeeConfigRelationFilter>;
    feeConfigId?: InputMaybe<StringFilter>;
    feeType?: InputMaybe<EnumFeeTypeFilter>;
    id?: InputMaybe<StringFilter>;
    isArrears?: InputMaybe<BoolFilter>;
    isWaived?: InputMaybe<BoolFilter>;
    superscriptFee?: InputMaybe<SuperscriptFeesRelationFilter>;
    superscriptFeeId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SuperscriptFeeLineItemWhereUniqueInput = {
    AND?: InputMaybe<Array<SuperscriptFeeLineItemWhereInput>>;
    NOT?: InputMaybe<Array<SuperscriptFeeLineItemWhereInput>>;
    OR?: InputMaybe<Array<SuperscriptFeeLineItemWhereInput>>;
    amount?: InputMaybe<DecimalFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    feeConfig?: InputMaybe<FeeConfigRelationFilter>;
    feeConfigId?: InputMaybe<StringFilter>;
    feeType?: InputMaybe<EnumFeeTypeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    isArrears?: InputMaybe<BoolFilter>;
    isWaived?: InputMaybe<BoolFilter>;
    superscriptFee?: InputMaybe<SuperscriptFeesRelationFilter>;
    superscriptFeeId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SuperscriptFees = {
    __typename?: 'SuperscriptFees';
    _count?: Maybe<SuperscriptFeesCount>;
    chargeIds: Array<Scalars['String']['output']>;
    charges: Array<Charge>;
    date: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    feeLineItems: Array<SuperscriptFeeLineItem>;
    feesToFloatTransferFailed: Scalars['Boolean']['output'];
    gross_fees: Scalars['Decimal']['output'];
    id: Scalars['String']['output'];
    net_fees: Scalars['Decimal']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    stripeInvoiceId?: Maybe<Scalars['String']['output']>;
    stripeRefundFeesTransferId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    totalFees?: Maybe<Scalars['Decimal']['output']>;
    totalFeesArrears?: Maybe<Scalars['Decimal']['output']>;
    totalFeesBilled?: Maybe<Scalars['Decimal']['output']>;
    totalFeesWaived?: Maybe<Scalars['Decimal']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
};

export type SuperscriptFeesChargesArgs = {
    cursor?: InputMaybe<ChargeWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeWhereInput>;
};

export type SuperscriptFeesFeeLineItemsArgs = {
    cursor?: InputMaybe<SuperscriptFeeLineItemWhereUniqueInput>;
    distinct?: InputMaybe<Array<SuperscriptFeeLineItemScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<SuperscriptFeeLineItemOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type SuperscriptFeesAvgAggregate = {
    __typename?: 'SuperscriptFeesAvgAggregate';
    gross_fees?: Maybe<Scalars['Decimal']['output']>;
    net_fees?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    totalFees?: Maybe<Scalars['Decimal']['output']>;
    totalFeesArrears?: Maybe<Scalars['Decimal']['output']>;
    totalFeesBilled?: Maybe<Scalars['Decimal']['output']>;
    totalFeesWaived?: Maybe<Scalars['Decimal']['output']>;
};

export type SuperscriptFeesAvgOrderByAggregateInput = {
    gross_fees?: InputMaybe<SortOrder>;
    net_fees?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    totalFees?: InputMaybe<SortOrder>;
    totalFeesArrears?: InputMaybe<SortOrder>;
    totalFeesBilled?: InputMaybe<SortOrder>;
    totalFeesWaived?: InputMaybe<SortOrder>;
};

export type SuperscriptFeesCount = {
    __typename?: 'SuperscriptFeesCount';
    charges: Scalars['Int']['output'];
    feeLineItems: Scalars['Int']['output'];
};

export type SuperscriptFeesCountChargesArgs = {
    where?: InputMaybe<ChargeWhereInput>;
};

export type SuperscriptFeesCountFeeLineItemsArgs = {
    where?: InputMaybe<SuperscriptFeeLineItemWhereInput>;
};

export type SuperscriptFeesCountAggregate = {
    __typename?: 'SuperscriptFeesCountAggregate';
    _all: Scalars['Int']['output'];
    chargeIds: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    ehrPostLedgerId: Scalars['Int']['output'];
    encounterId: Scalars['Int']['output'];
    feesToFloatTransferFailed: Scalars['Int']['output'];
    gross_fees: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    net_fees: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    slotId: Scalars['Int']['output'];
    stripeInvoiceId: Scalars['Int']['output'];
    stripeRefundFeesTransferId: Scalars['Int']['output'];
    stripeTransferId: Scalars['Int']['output'];
    totalFees: Scalars['Int']['output'];
    totalFeesArrears: Scalars['Int']['output'];
    totalFeesBilled: Scalars['Int']['output'];
    totalFeesWaived: Scalars['Int']['output'];
    transactionId: Scalars['Int']['output'];
};

export type SuperscriptFeesCountOrderByAggregateInput = {
    chargeIds?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    feesToFloatTransferFailed?: InputMaybe<SortOrder>;
    gross_fees?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    net_fees?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    stripeInvoiceId?: InputMaybe<SortOrder>;
    stripeRefundFeesTransferId?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    totalFees?: InputMaybe<SortOrder>;
    totalFeesArrears?: InputMaybe<SortOrder>;
    totalFeesBilled?: InputMaybe<SortOrder>;
    totalFeesWaived?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
};

export type SuperscriptFeesCreateInput = {
    chargeIds?: InputMaybe<SuperscriptFeesCreatechargeIdsInput>;
    charges?: InputMaybe<ChargeCreateNestedManyWithoutSuperscriptFeeInput>;
    date: Scalars['DateTimeISO']['input'];
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    encounterId?: InputMaybe<Scalars['String']['input']>;
    feeLineItems?: InputMaybe<SuperscriptFeeLineItemCreateNestedManyWithoutSuperscriptFeeInput>;
    feesToFloatTransferFailed?: InputMaybe<Scalars['Boolean']['input']>;
    gross_fees: Scalars['Decimal']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    net_fees: Scalars['Decimal']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    stripeInvoiceId?: InputMaybe<Scalars['String']['input']>;
    stripeRefundFeesTransferId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    totalFees?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesArrears?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesBilled?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesWaived?: InputMaybe<Scalars['Decimal']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SuperscriptFeesCreateManyInput = {
    chargeIds?: InputMaybe<SuperscriptFeesCreatechargeIdsInput>;
    date: Scalars['DateTimeISO']['input'];
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    encounterId?: InputMaybe<Scalars['String']['input']>;
    feesToFloatTransferFailed?: InputMaybe<Scalars['Boolean']['input']>;
    gross_fees: Scalars['Decimal']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    net_fees: Scalars['Decimal']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    stripeInvoiceId?: InputMaybe<Scalars['String']['input']>;
    stripeRefundFeesTransferId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    totalFees?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesArrears?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesBilled?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesWaived?: InputMaybe<Scalars['Decimal']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SuperscriptFeesCreateNestedOneWithoutChargesInput = {
    connect?: InputMaybe<SuperscriptFeesWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SuperscriptFeesCreateOrConnectWithoutChargesInput>;
    create?: InputMaybe<SuperscriptFeesCreateWithoutChargesInput>;
};

export type SuperscriptFeesCreateNestedOneWithoutFeeLineItemsInput = {
    connect?: InputMaybe<SuperscriptFeesWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SuperscriptFeesCreateOrConnectWithoutFeeLineItemsInput>;
    create?: InputMaybe<SuperscriptFeesCreateWithoutFeeLineItemsInput>;
};

export type SuperscriptFeesCreateOrConnectWithoutChargesInput = {
    create: SuperscriptFeesCreateWithoutChargesInput;
    where: SuperscriptFeesWhereUniqueInput;
};

export type SuperscriptFeesCreateOrConnectWithoutFeeLineItemsInput = {
    create: SuperscriptFeesCreateWithoutFeeLineItemsInput;
    where: SuperscriptFeesWhereUniqueInput;
};

export type SuperscriptFeesCreateWithoutChargesInput = {
    chargeIds?: InputMaybe<SuperscriptFeesCreatechargeIdsInput>;
    date: Scalars['DateTimeISO']['input'];
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    encounterId?: InputMaybe<Scalars['String']['input']>;
    feeLineItems?: InputMaybe<SuperscriptFeeLineItemCreateNestedManyWithoutSuperscriptFeeInput>;
    feesToFloatTransferFailed?: InputMaybe<Scalars['Boolean']['input']>;
    gross_fees: Scalars['Decimal']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    net_fees: Scalars['Decimal']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    stripeInvoiceId?: InputMaybe<Scalars['String']['input']>;
    stripeRefundFeesTransferId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    totalFees?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesArrears?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesBilled?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesWaived?: InputMaybe<Scalars['Decimal']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SuperscriptFeesCreateWithoutFeeLineItemsInput = {
    chargeIds?: InputMaybe<SuperscriptFeesCreatechargeIdsInput>;
    charges?: InputMaybe<ChargeCreateNestedManyWithoutSuperscriptFeeInput>;
    date: Scalars['DateTimeISO']['input'];
    ehrPostLedgerId?: InputMaybe<Scalars['String']['input']>;
    encounterId?: InputMaybe<Scalars['String']['input']>;
    feesToFloatTransferFailed?: InputMaybe<Scalars['Boolean']['input']>;
    gross_fees: Scalars['Decimal']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    net_fees: Scalars['Decimal']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    slotId?: InputMaybe<Scalars['String']['input']>;
    stripeInvoiceId?: InputMaybe<Scalars['String']['input']>;
    stripeRefundFeesTransferId?: InputMaybe<Scalars['String']['input']>;
    stripeTransferId?: InputMaybe<Scalars['String']['input']>;
    totalFees?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesArrears?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesBilled?: InputMaybe<Scalars['Decimal']['input']>;
    totalFeesWaived?: InputMaybe<Scalars['Decimal']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SuperscriptFeesCreatechargeIdsInput = {
    set: Array<Scalars['String']['input']>;
};

export type SuperscriptFeesGroupBy = {
    __typename?: 'SuperscriptFeesGroupBy';
    _avg?: Maybe<SuperscriptFeesAvgAggregate>;
    _count?: Maybe<SuperscriptFeesCountAggregate>;
    _max?: Maybe<SuperscriptFeesMaxAggregate>;
    _min?: Maybe<SuperscriptFeesMinAggregate>;
    _sum?: Maybe<SuperscriptFeesSumAggregate>;
    chargeIds?: Maybe<Array<Scalars['String']['output']>>;
    date: Scalars['DateTimeISO']['output'];
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    feesToFloatTransferFailed: Scalars['Boolean']['output'];
    gross_fees: Scalars['Decimal']['output'];
    id: Scalars['String']['output'];
    net_fees: Scalars['Decimal']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    stripeInvoiceId?: Maybe<Scalars['String']['output']>;
    stripeRefundFeesTransferId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    totalFees?: Maybe<Scalars['Decimal']['output']>;
    totalFeesArrears?: Maybe<Scalars['Decimal']['output']>;
    totalFeesBilled?: Maybe<Scalars['Decimal']['output']>;
    totalFeesWaived?: Maybe<Scalars['Decimal']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
};

export type SuperscriptFeesMaxAggregate = {
    __typename?: 'SuperscriptFeesMaxAggregate';
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    feesToFloatTransferFailed?: Maybe<Scalars['Boolean']['output']>;
    gross_fees?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    net_fees?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    stripeInvoiceId?: Maybe<Scalars['String']['output']>;
    stripeRefundFeesTransferId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    totalFees?: Maybe<Scalars['Decimal']['output']>;
    totalFeesArrears?: Maybe<Scalars['Decimal']['output']>;
    totalFeesBilled?: Maybe<Scalars['Decimal']['output']>;
    totalFeesWaived?: Maybe<Scalars['Decimal']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
};

export type SuperscriptFeesMaxOrderByAggregateInput = {
    date?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    feesToFloatTransferFailed?: InputMaybe<SortOrder>;
    gross_fees?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    net_fees?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    stripeInvoiceId?: InputMaybe<SortOrder>;
    stripeRefundFeesTransferId?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    totalFees?: InputMaybe<SortOrder>;
    totalFeesArrears?: InputMaybe<SortOrder>;
    totalFeesBilled?: InputMaybe<SortOrder>;
    totalFeesWaived?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
};

export type SuperscriptFeesMinAggregate = {
    __typename?: 'SuperscriptFeesMinAggregate';
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    ehrPostLedgerId?: Maybe<Scalars['String']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    feesToFloatTransferFailed?: Maybe<Scalars['Boolean']['output']>;
    gross_fees?: Maybe<Scalars['Decimal']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    net_fees?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    slotId?: Maybe<Scalars['String']['output']>;
    stripeInvoiceId?: Maybe<Scalars['String']['output']>;
    stripeRefundFeesTransferId?: Maybe<Scalars['String']['output']>;
    stripeTransferId?: Maybe<Scalars['String']['output']>;
    totalFees?: Maybe<Scalars['Decimal']['output']>;
    totalFeesArrears?: Maybe<Scalars['Decimal']['output']>;
    totalFeesBilled?: Maybe<Scalars['Decimal']['output']>;
    totalFeesWaived?: Maybe<Scalars['Decimal']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
};

export type SuperscriptFeesMinOrderByAggregateInput = {
    date?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    feesToFloatTransferFailed?: InputMaybe<SortOrder>;
    gross_fees?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    net_fees?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    slotId?: InputMaybe<SortOrder>;
    stripeInvoiceId?: InputMaybe<SortOrder>;
    stripeRefundFeesTransferId?: InputMaybe<SortOrder>;
    stripeTransferId?: InputMaybe<SortOrder>;
    totalFees?: InputMaybe<SortOrder>;
    totalFeesArrears?: InputMaybe<SortOrder>;
    totalFeesBilled?: InputMaybe<SortOrder>;
    totalFeesWaived?: InputMaybe<SortOrder>;
    transactionId?: InputMaybe<SortOrder>;
};

export type SuperscriptFeesNullableRelationFilter = {
    is?: InputMaybe<SuperscriptFeesWhereInput>;
    isNot?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type SuperscriptFeesOrderByWithAggregationInput = {
    _avg?: InputMaybe<SuperscriptFeesAvgOrderByAggregateInput>;
    _count?: InputMaybe<SuperscriptFeesCountOrderByAggregateInput>;
    _max?: InputMaybe<SuperscriptFeesMaxOrderByAggregateInput>;
    _min?: InputMaybe<SuperscriptFeesMinOrderByAggregateInput>;
    _sum?: InputMaybe<SuperscriptFeesSumOrderByAggregateInput>;
    chargeIds?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    encounterId?: InputMaybe<SortOrderInput>;
    feesToFloatTransferFailed?: InputMaybe<SortOrder>;
    gross_fees?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    net_fees?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    stripeInvoiceId?: InputMaybe<SortOrderInput>;
    stripeRefundFeesTransferId?: InputMaybe<SortOrderInput>;
    stripeTransferId?: InputMaybe<SortOrderInput>;
    totalFees?: InputMaybe<SortOrderInput>;
    totalFeesArrears?: InputMaybe<SortOrderInput>;
    totalFeesBilled?: InputMaybe<SortOrderInput>;
    totalFeesWaived?: InputMaybe<SortOrderInput>;
    transactionId?: InputMaybe<SortOrderInput>;
};

export type SuperscriptFeesOrderByWithRelationInput = {
    chargeIds?: InputMaybe<SortOrder>;
    charges?: InputMaybe<ChargeOrderByRelationAggregateInput>;
    date?: InputMaybe<SortOrder>;
    ehrPostLedgerId?: InputMaybe<SortOrderInput>;
    encounterId?: InputMaybe<SortOrderInput>;
    feeLineItems?: InputMaybe<SuperscriptFeeLineItemOrderByRelationAggregateInput>;
    feesToFloatTransferFailed?: InputMaybe<SortOrder>;
    gross_fees?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    net_fees?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    slotId?: InputMaybe<SortOrderInput>;
    stripeInvoiceId?: InputMaybe<SortOrderInput>;
    stripeRefundFeesTransferId?: InputMaybe<SortOrderInput>;
    stripeTransferId?: InputMaybe<SortOrderInput>;
    totalFees?: InputMaybe<SortOrderInput>;
    totalFeesArrears?: InputMaybe<SortOrderInput>;
    totalFeesBilled?: InputMaybe<SortOrderInput>;
    totalFeesWaived?: InputMaybe<SortOrderInput>;
    transactionId?: InputMaybe<SortOrderInput>;
};

export type SuperscriptFeesRelationFilter = {
    is?: InputMaybe<SuperscriptFeesWhereInput>;
    isNot?: InputMaybe<SuperscriptFeesWhereInput>;
};

export enum SuperscriptFeesScalarFieldEnum {
    ChargeIds = 'chargeIds',
    Date = 'date',
    EhrPostLedgerId = 'ehrPostLedgerId',
    EncounterId = 'encounterId',
    FeesToFloatTransferFailed = 'feesToFloatTransferFailed',
    GrossFees = 'gross_fees',
    Id = 'id',
    NetFees = 'net_fees',
    OrgId = 'orgId',
    SlotId = 'slotId',
    StripeInvoiceId = 'stripeInvoiceId',
    StripeRefundFeesTransferId = 'stripeRefundFeesTransferId',
    StripeTransferId = 'stripeTransferId',
    TotalFees = 'totalFees',
    TotalFeesArrears = 'totalFeesArrears',
    TotalFeesBilled = 'totalFeesBilled',
    TotalFeesWaived = 'totalFeesWaived',
    TransactionId = 'transactionId',
}

export type SuperscriptFeesScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<SuperscriptFeesScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<SuperscriptFeesScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<SuperscriptFeesScalarWhereWithAggregatesInput>>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    encounterId?: InputMaybe<StringNullableWithAggregatesFilter>;
    feesToFloatTransferFailed?: InputMaybe<BoolWithAggregatesFilter>;
    gross_fees?: InputMaybe<DecimalWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    net_fees?: InputMaybe<DecimalWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    slotId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeInvoiceId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeRefundFeesTransferId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeTransferId?: InputMaybe<StringNullableWithAggregatesFilter>;
    totalFees?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    totalFeesArrears?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    totalFeesBilled?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    totalFeesWaived?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    transactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type SuperscriptFeesSumAggregate = {
    __typename?: 'SuperscriptFeesSumAggregate';
    gross_fees?: Maybe<Scalars['Decimal']['output']>;
    net_fees?: Maybe<Scalars['Decimal']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    totalFees?: Maybe<Scalars['Decimal']['output']>;
    totalFeesArrears?: Maybe<Scalars['Decimal']['output']>;
    totalFeesBilled?: Maybe<Scalars['Decimal']['output']>;
    totalFeesWaived?: Maybe<Scalars['Decimal']['output']>;
};

export type SuperscriptFeesSumOrderByAggregateInput = {
    gross_fees?: InputMaybe<SortOrder>;
    net_fees?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    totalFees?: InputMaybe<SortOrder>;
    totalFeesArrears?: InputMaybe<SortOrder>;
    totalFeesBilled?: InputMaybe<SortOrder>;
    totalFeesWaived?: InputMaybe<SortOrder>;
};

export type SuperscriptFeesUpdateInput = {
    chargeIds?: InputMaybe<SuperscriptFeesUpdatechargeIdsInput>;
    charges?: InputMaybe<ChargeUpdateManyWithoutSuperscriptFeeNestedInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    feeLineItems?: InputMaybe<SuperscriptFeeLineItemUpdateManyWithoutSuperscriptFeeNestedInput>;
    feesToFloatTransferFailed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    gross_fees?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    net_fees?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeInvoiceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeRefundFeesTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    totalFees?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesArrears?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesBilled?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesWaived?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SuperscriptFeesUpdateManyMutationInput = {
    chargeIds?: InputMaybe<SuperscriptFeesUpdatechargeIdsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    feesToFloatTransferFailed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    gross_fees?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    net_fees?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeInvoiceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeRefundFeesTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    totalFees?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesArrears?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesBilled?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesWaived?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SuperscriptFeesUpdateOneRequiredWithoutFeeLineItemsNestedInput = {
    connect?: InputMaybe<SuperscriptFeesWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SuperscriptFeesCreateOrConnectWithoutFeeLineItemsInput>;
    create?: InputMaybe<SuperscriptFeesCreateWithoutFeeLineItemsInput>;
    update?: InputMaybe<SuperscriptFeesUpdateToOneWithWhereWithoutFeeLineItemsInput>;
    upsert?: InputMaybe<SuperscriptFeesUpsertWithoutFeeLineItemsInput>;
};

export type SuperscriptFeesUpdateOneWithoutChargesNestedInput = {
    connect?: InputMaybe<SuperscriptFeesWhereUniqueInput>;
    connectOrCreate?: InputMaybe<SuperscriptFeesCreateOrConnectWithoutChargesInput>;
    create?: InputMaybe<SuperscriptFeesCreateWithoutChargesInput>;
    delete?: InputMaybe<SuperscriptFeesWhereInput>;
    disconnect?: InputMaybe<SuperscriptFeesWhereInput>;
    update?: InputMaybe<SuperscriptFeesUpdateToOneWithWhereWithoutChargesInput>;
    upsert?: InputMaybe<SuperscriptFeesUpsertWithoutChargesInput>;
};

export type SuperscriptFeesUpdateToOneWithWhereWithoutChargesInput = {
    data: SuperscriptFeesUpdateWithoutChargesInput;
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type SuperscriptFeesUpdateToOneWithWhereWithoutFeeLineItemsInput = {
    data: SuperscriptFeesUpdateWithoutFeeLineItemsInput;
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type SuperscriptFeesUpdateWithoutChargesInput = {
    chargeIds?: InputMaybe<SuperscriptFeesUpdatechargeIdsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    feeLineItems?: InputMaybe<SuperscriptFeeLineItemUpdateManyWithoutSuperscriptFeeNestedInput>;
    feesToFloatTransferFailed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    gross_fees?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    net_fees?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeInvoiceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeRefundFeesTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    totalFees?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesArrears?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesBilled?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesWaived?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SuperscriptFeesUpdateWithoutFeeLineItemsInput = {
    chargeIds?: InputMaybe<SuperscriptFeesUpdatechargeIdsInput>;
    charges?: InputMaybe<ChargeUpdateManyWithoutSuperscriptFeeNestedInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    ehrPostLedgerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    feesToFloatTransferFailed?: InputMaybe<BoolFieldUpdateOperationsInput>;
    gross_fees?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    net_fees?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    slotId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeInvoiceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeRefundFeesTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeTransferId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    totalFees?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesArrears?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesBilled?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    totalFeesWaived?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    transactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SuperscriptFeesUpdatechargeIdsInput = {
    push?: InputMaybe<Array<Scalars['String']['input']>>;
    set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SuperscriptFeesUpsertWithoutChargesInput = {
    create: SuperscriptFeesCreateWithoutChargesInput;
    update: SuperscriptFeesUpdateWithoutChargesInput;
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type SuperscriptFeesUpsertWithoutFeeLineItemsInput = {
    create: SuperscriptFeesCreateWithoutFeeLineItemsInput;
    update: SuperscriptFeesUpdateWithoutFeeLineItemsInput;
    where?: InputMaybe<SuperscriptFeesWhereInput>;
};

export type SuperscriptFeesWhereInput = {
    AND?: InputMaybe<Array<SuperscriptFeesWhereInput>>;
    NOT?: InputMaybe<Array<SuperscriptFeesWhereInput>>;
    OR?: InputMaybe<Array<SuperscriptFeesWhereInput>>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    charges?: InputMaybe<ChargeListRelationFilter>;
    date?: InputMaybe<DateTimeFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    feeLineItems?: InputMaybe<SuperscriptFeeLineItemListRelationFilter>;
    feesToFloatTransferFailed?: InputMaybe<BoolFilter>;
    gross_fees?: InputMaybe<DecimalFilter>;
    id?: InputMaybe<StringFilter>;
    net_fees?: InputMaybe<DecimalFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    stripeInvoiceId?: InputMaybe<StringNullableFilter>;
    stripeRefundFeesTransferId?: InputMaybe<StringNullableFilter>;
    stripeTransferId?: InputMaybe<StringNullableFilter>;
    totalFees?: InputMaybe<DecimalNullableFilter>;
    totalFeesArrears?: InputMaybe<DecimalNullableFilter>;
    totalFeesBilled?: InputMaybe<DecimalNullableFilter>;
    totalFeesWaived?: InputMaybe<DecimalNullableFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
};

export type SuperscriptFeesWhereUniqueInput = {
    AND?: InputMaybe<Array<SuperscriptFeesWhereInput>>;
    NOT?: InputMaybe<Array<SuperscriptFeesWhereInput>>;
    OR?: InputMaybe<Array<SuperscriptFeesWhereInput>>;
    chargeIds?: InputMaybe<StringNullableListFilter>;
    charges?: InputMaybe<ChargeListRelationFilter>;
    date?: InputMaybe<DateTimeFilter>;
    ehrPostLedgerId?: InputMaybe<StringNullableFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    feeLineItems?: InputMaybe<SuperscriptFeeLineItemListRelationFilter>;
    feesToFloatTransferFailed?: InputMaybe<BoolFilter>;
    gross_fees?: InputMaybe<DecimalFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    net_fees?: InputMaybe<DecimalFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    slotId?: InputMaybe<StringNullableFilter>;
    stripeInvoiceId?: InputMaybe<StringNullableFilter>;
    stripeRefundFeesTransferId?: InputMaybe<StringNullableFilter>;
    stripeTransferId?: InputMaybe<StringNullableFilter>;
    totalFees?: InputMaybe<DecimalNullableFilter>;
    totalFeesArrears?: InputMaybe<DecimalNullableFilter>;
    totalFeesBilled?: InputMaybe<DecimalNullableFilter>;
    totalFeesWaived?: InputMaybe<DecimalNullableFilter>;
    transactionId?: InputMaybe<StringNullableFilter>;
};

export type SuperscriptIntakeQuestion = {
    __typename?: 'SuperscriptIntakeQuestion';
    _count?: Maybe<SuperscriptIntakeQuestionCount>;
    id: Scalars['Int']['output'];
    intakeQuestions: Array<IntakeQuestion>;
    questionAttributes?: Maybe<Scalars['JSON']['output']>;
    questionText: Scalars['String']['output'];
    retrievable: Scalars['Boolean']['output'];
    type: IntakeQuestionType;
};

export type SuperscriptIntakeQuestionIntakeQuestionsArgs = {
    cursor?: InputMaybe<IntakeQuestionWhereUniqueInput>;
    distinct?: InputMaybe<Array<IntakeQuestionScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<IntakeQuestionOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type SuperscriptIntakeQuestionAvgAggregate = {
    __typename?: 'SuperscriptIntakeQuestionAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
};

export type SuperscriptIntakeQuestionAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type SuperscriptIntakeQuestionCount = {
    __typename?: 'SuperscriptIntakeQuestionCount';
    intakeQuestions: Scalars['Int']['output'];
};

export type SuperscriptIntakeQuestionCountIntakeQuestionsArgs = {
    where?: InputMaybe<IntakeQuestionWhereInput>;
};

export type SuperscriptIntakeQuestionCountAggregate = {
    __typename?: 'SuperscriptIntakeQuestionCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    questionAttributes: Scalars['Int']['output'];
    questionText: Scalars['Int']['output'];
    retrievable: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
};

export type SuperscriptIntakeQuestionCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    questionAttributes?: InputMaybe<SortOrder>;
    questionText?: InputMaybe<SortOrder>;
    retrievable?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type SuperscriptIntakeQuestionCreateInput = {
    intakeQuestions?: InputMaybe<IntakeQuestionCreateNestedManyWithoutSuperscriptIntakeQuestionInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    type: IntakeQuestionType;
};

export type SuperscriptIntakeQuestionCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    type: IntakeQuestionType;
};

export type SuperscriptIntakeQuestionCreateNestedOneWithoutIntakeQuestionsInput =
    {
        connect?: InputMaybe<SuperscriptIntakeQuestionWhereUniqueInput>;
        connectOrCreate?: InputMaybe<SuperscriptIntakeQuestionCreateOrConnectWithoutIntakeQuestionsInput>;
        create?: InputMaybe<SuperscriptIntakeQuestionCreateWithoutIntakeQuestionsInput>;
    };

export type SuperscriptIntakeQuestionCreateOrConnectWithoutIntakeQuestionsInput =
    {
        create: SuperscriptIntakeQuestionCreateWithoutIntakeQuestionsInput;
        where: SuperscriptIntakeQuestionWhereUniqueInput;
    };

export type SuperscriptIntakeQuestionCreateWithoutIntakeQuestionsInput = {
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText: Scalars['String']['input'];
    retrievable?: InputMaybe<Scalars['Boolean']['input']>;
    type: IntakeQuestionType;
};

export type SuperscriptIntakeQuestionGroupBy = {
    __typename?: 'SuperscriptIntakeQuestionGroupBy';
    _avg?: Maybe<SuperscriptIntakeQuestionAvgAggregate>;
    _count?: Maybe<SuperscriptIntakeQuestionCountAggregate>;
    _max?: Maybe<SuperscriptIntakeQuestionMaxAggregate>;
    _min?: Maybe<SuperscriptIntakeQuestionMinAggregate>;
    _sum?: Maybe<SuperscriptIntakeQuestionSumAggregate>;
    id: Scalars['Int']['output'];
    questionAttributes?: Maybe<Scalars['JSON']['output']>;
    questionText: Scalars['String']['output'];
    retrievable: Scalars['Boolean']['output'];
    type: IntakeQuestionType;
};

export type SuperscriptIntakeQuestionMaxAggregate = {
    __typename?: 'SuperscriptIntakeQuestionMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    questionText?: Maybe<Scalars['String']['output']>;
    retrievable?: Maybe<Scalars['Boolean']['output']>;
    type?: Maybe<IntakeQuestionType>;
};

export type SuperscriptIntakeQuestionMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    questionText?: InputMaybe<SortOrder>;
    retrievable?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type SuperscriptIntakeQuestionMinAggregate = {
    __typename?: 'SuperscriptIntakeQuestionMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    questionText?: Maybe<Scalars['String']['output']>;
    retrievable?: Maybe<Scalars['Boolean']['output']>;
    type?: Maybe<IntakeQuestionType>;
};

export type SuperscriptIntakeQuestionMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    questionText?: InputMaybe<SortOrder>;
    retrievable?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type SuperscriptIntakeQuestionNullableRelationFilter = {
    is?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
    isNot?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
};

export type SuperscriptIntakeQuestionOrderByWithAggregationInput = {
    _avg?: InputMaybe<SuperscriptIntakeQuestionAvgOrderByAggregateInput>;
    _count?: InputMaybe<SuperscriptIntakeQuestionCountOrderByAggregateInput>;
    _max?: InputMaybe<SuperscriptIntakeQuestionMaxOrderByAggregateInput>;
    _min?: InputMaybe<SuperscriptIntakeQuestionMinOrderByAggregateInput>;
    _sum?: InputMaybe<SuperscriptIntakeQuestionSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    questionAttributes?: InputMaybe<SortOrderInput>;
    questionText?: InputMaybe<SortOrder>;
    retrievable?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export type SuperscriptIntakeQuestionOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    intakeQuestions?: InputMaybe<IntakeQuestionOrderByRelationAggregateInput>;
    questionAttributes?: InputMaybe<SortOrderInput>;
    questionText?: InputMaybe<SortOrder>;
    retrievable?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
};

export enum SuperscriptIntakeQuestionScalarFieldEnum {
    Id = 'id',
    QuestionAttributes = 'questionAttributes',
    QuestionText = 'questionText',
    Retrievable = 'retrievable',
    Type = 'type',
}

export type SuperscriptIntakeQuestionScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<
        Array<SuperscriptIntakeQuestionScalarWhereWithAggregatesInput>
    >;
    NOT?: InputMaybe<
        Array<SuperscriptIntakeQuestionScalarWhereWithAggregatesInput>
    >;
    OR?: InputMaybe<
        Array<SuperscriptIntakeQuestionScalarWhereWithAggregatesInput>
    >;
    id?: InputMaybe<IntWithAggregatesFilter>;
    questionAttributes?: InputMaybe<JsonNullableWithAggregatesFilter>;
    questionText?: InputMaybe<StringWithAggregatesFilter>;
    retrievable?: InputMaybe<BoolWithAggregatesFilter>;
    type?: InputMaybe<EnumIntakeQuestionTypeWithAggregatesFilter>;
};

export type SuperscriptIntakeQuestionSumAggregate = {
    __typename?: 'SuperscriptIntakeQuestionSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
};

export type SuperscriptIntakeQuestionSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
};

export type SuperscriptIntakeQuestionUpdateInput = {
    intakeQuestions?: InputMaybe<IntakeQuestionUpdateManyWithoutSuperscriptIntakeQuestionNestedInput>;
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
};

export type SuperscriptIntakeQuestionUpdateManyMutationInput = {
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
};

export type SuperscriptIntakeQuestionUpdateOneWithoutIntakeQuestionsNestedInput =
    {
        connect?: InputMaybe<SuperscriptIntakeQuestionWhereUniqueInput>;
        connectOrCreate?: InputMaybe<SuperscriptIntakeQuestionCreateOrConnectWithoutIntakeQuestionsInput>;
        create?: InputMaybe<SuperscriptIntakeQuestionCreateWithoutIntakeQuestionsInput>;
        delete?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
        disconnect?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
        update?: InputMaybe<SuperscriptIntakeQuestionUpdateToOneWithWhereWithoutIntakeQuestionsInput>;
        upsert?: InputMaybe<SuperscriptIntakeQuestionUpsertWithoutIntakeQuestionsInput>;
    };

export type SuperscriptIntakeQuestionUpdateToOneWithWhereWithoutIntakeQuestionsInput =
    {
        data: SuperscriptIntakeQuestionUpdateWithoutIntakeQuestionsInput;
        where?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
    };

export type SuperscriptIntakeQuestionUpdateWithoutIntakeQuestionsInput = {
    questionAttributes?: InputMaybe<Scalars['JSON']['input']>;
    questionText?: InputMaybe<StringFieldUpdateOperationsInput>;
    retrievable?: InputMaybe<BoolFieldUpdateOperationsInput>;
    type?: InputMaybe<EnumIntakeQuestionTypeFieldUpdateOperationsInput>;
};

export type SuperscriptIntakeQuestionUpsertWithoutIntakeQuestionsInput = {
    create: SuperscriptIntakeQuestionCreateWithoutIntakeQuestionsInput;
    update: SuperscriptIntakeQuestionUpdateWithoutIntakeQuestionsInput;
    where?: InputMaybe<SuperscriptIntakeQuestionWhereInput>;
};

export type SuperscriptIntakeQuestionWhereInput = {
    AND?: InputMaybe<Array<SuperscriptIntakeQuestionWhereInput>>;
    NOT?: InputMaybe<Array<SuperscriptIntakeQuestionWhereInput>>;
    OR?: InputMaybe<Array<SuperscriptIntakeQuestionWhereInput>>;
    id?: InputMaybe<IntFilter>;
    intakeQuestions?: InputMaybe<IntakeQuestionListRelationFilter>;
    questionAttributes?: InputMaybe<JsonNullableFilter>;
    questionText?: InputMaybe<StringFilter>;
    retrievable?: InputMaybe<BoolFilter>;
    type?: InputMaybe<EnumIntakeQuestionTypeFilter>;
};

export type SuperscriptIntakeQuestionWhereUniqueInput = {
    AND?: InputMaybe<Array<SuperscriptIntakeQuestionWhereInput>>;
    NOT?: InputMaybe<Array<SuperscriptIntakeQuestionWhereInput>>;
    OR?: InputMaybe<Array<SuperscriptIntakeQuestionWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    intakeQuestions?: InputMaybe<IntakeQuestionListRelationFilter>;
    questionAttributes?: InputMaybe<JsonNullableFilter>;
    questionText?: InputMaybe<StringFilter>;
    retrievable?: InputMaybe<BoolFilter>;
    type?: InputMaybe<EnumIntakeQuestionTypeFilter>;
};

export enum TaskVisibility {
    All = 'ALL',
    ProdOnly = 'PROD_ONLY',
}

export enum TaskStatus {
    Applied = 'applied',
    ApplyFailed = 'apply_failed',
    Applying = 'applying',
    Pending = 'pending',
    ProcessFailed = 'process_failed',
    Processed = 'processed',
    Processing = 'processing',
}

export enum TaskType {
    Eligibility = 'eligibility',
    Pricing = 'pricing',
}

export type TimeBlock = {
    __typename?: 'TimeBlock';
    available: Scalars['Boolean']['output'];
    category?: Maybe<TimeBlockCategoryEnum>;
    dayOfWeek: Scalars['Int']['output'];
    endTime: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    isAllDay: Scalars['Boolean']['output'];
    label?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    startTime: Scalars['DateTimeISO']['output'];
};

export type TimeBlockAvgAggregate = {
    __typename?: 'TimeBlockAvgAggregate';
    dayOfWeek?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
    providerId?: Maybe<Scalars['Float']['output']>;
};

export type TimeBlockAvgOrderByAggregateInput = {
    dayOfWeek?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export enum TimeBlockCategoryEnum {
    Hold = 'HOLD',
    Ooo = 'OOO',
    Provider = 'PROVIDER',
    Specialist = 'SPECIALIST',
}

export type TimeBlockCountAggregate = {
    __typename?: 'TimeBlockCountAggregate';
    _all: Scalars['Int']['output'];
    available: Scalars['Int']['output'];
    category: Scalars['Int']['output'];
    dayOfWeek: Scalars['Int']['output'];
    endTime: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    isAllDay: Scalars['Int']['output'];
    label: Scalars['Int']['output'];
    notes: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    startTime: Scalars['Int']['output'];
};

export type TimeBlockCountOrderByAggregateInput = {
    available?: InputMaybe<SortOrder>;
    category?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isAllDay?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
};

export type TimeBlockCreateInput = {
    available: Scalars['Boolean']['input'];
    category?: InputMaybe<TimeBlockCategoryEnum>;
    dayOfWeek: Scalars['Int']['input'];
    endTime: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    isAllDay: Scalars['Boolean']['input'];
    label?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    startTime: Scalars['DateTimeISO']['input'];
};

export type TimeBlockCreateManyInput = {
    available: Scalars['Boolean']['input'];
    category?: InputMaybe<TimeBlockCategoryEnum>;
    dayOfWeek: Scalars['Int']['input'];
    endTime: Scalars['DateTimeISO']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    isAllDay: Scalars['Boolean']['input'];
    label?: InputMaybe<Scalars['String']['input']>;
    notes?: InputMaybe<Scalars['String']['input']>;
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
    startTime: Scalars['DateTimeISO']['input'];
};

export type TimeBlockGroupBy = {
    __typename?: 'TimeBlockGroupBy';
    _avg?: Maybe<TimeBlockAvgAggregate>;
    _count?: Maybe<TimeBlockCountAggregate>;
    _max?: Maybe<TimeBlockMaxAggregate>;
    _min?: Maybe<TimeBlockMinAggregate>;
    _sum?: Maybe<TimeBlockSumAggregate>;
    available: Scalars['Boolean']['output'];
    category?: Maybe<TimeBlockCategoryEnum>;
    dayOfWeek: Scalars['Int']['output'];
    endTime: Scalars['DateTimeISO']['output'];
    id: Scalars['String']['output'];
    isAllDay: Scalars['Boolean']['output'];
    label?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    practiceId: Scalars['Int']['output'];
    providerId: Scalars['Int']['output'];
    startTime: Scalars['DateTimeISO']['output'];
};

export type TimeBlockMaxAggregate = {
    __typename?: 'TimeBlockMaxAggregate';
    available?: Maybe<Scalars['Boolean']['output']>;
    category?: Maybe<TimeBlockCategoryEnum>;
    dayOfWeek?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isAllDay?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    startTime?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TimeBlockMaxOrderByAggregateInput = {
    available?: InputMaybe<SortOrder>;
    category?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isAllDay?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
};

export type TimeBlockMinAggregate = {
    __typename?: 'TimeBlockMinAggregate';
    available?: Maybe<Scalars['Boolean']['output']>;
    category?: Maybe<TimeBlockCategoryEnum>;
    dayOfWeek?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['DateTimeISO']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isAllDay?: Maybe<Scalars['Boolean']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
    startTime?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TimeBlockMinOrderByAggregateInput = {
    available?: InputMaybe<SortOrder>;
    category?: InputMaybe<SortOrder>;
    dayOfWeek?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isAllDay?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrder>;
    notes?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
};

export type TimeBlockOrderByWithAggregationInput = {
    _avg?: InputMaybe<TimeBlockAvgOrderByAggregateInput>;
    _count?: InputMaybe<TimeBlockCountOrderByAggregateInput>;
    _max?: InputMaybe<TimeBlockMaxOrderByAggregateInput>;
    _min?: InputMaybe<TimeBlockMinOrderByAggregateInput>;
    _sum?: InputMaybe<TimeBlockSumOrderByAggregateInput>;
    available?: InputMaybe<SortOrder>;
    category?: InputMaybe<SortOrderInput>;
    dayOfWeek?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isAllDay?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
};

export type TimeBlockOrderByWithRelationInput = {
    available?: InputMaybe<SortOrder>;
    category?: InputMaybe<SortOrderInput>;
    dayOfWeek?: InputMaybe<SortOrder>;
    endTime?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    isAllDay?: InputMaybe<SortOrder>;
    label?: InputMaybe<SortOrderInput>;
    notes?: InputMaybe<SortOrderInput>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    startTime?: InputMaybe<SortOrder>;
};

export enum TimeBlockScalarFieldEnum {
    Available = 'available',
    Category = 'category',
    DayOfWeek = 'dayOfWeek',
    EndTime = 'endTime',
    Id = 'id',
    IsAllDay = 'isAllDay',
    Label = 'label',
    Notes = 'notes',
    PracticeId = 'practiceId',
    ProviderId = 'providerId',
    StartTime = 'startTime',
}

export type TimeBlockScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<TimeBlockScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<TimeBlockScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<TimeBlockScalarWhereWithAggregatesInput>>;
    available?: InputMaybe<BoolWithAggregatesFilter>;
    category?: InputMaybe<EnumTimeBlockCategoryEnumNullableWithAggregatesFilter>;
    dayOfWeek?: InputMaybe<IntWithAggregatesFilter>;
    endTime?: InputMaybe<DateTimeWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    isAllDay?: InputMaybe<BoolWithAggregatesFilter>;
    label?: InputMaybe<StringNullableWithAggregatesFilter>;
    notes?: InputMaybe<StringNullableWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
    providerId?: InputMaybe<IntWithAggregatesFilter>;
    startTime?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type TimeBlockSumAggregate = {
    __typename?: 'TimeBlockSumAggregate';
    dayOfWeek?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    providerId?: Maybe<Scalars['Int']['output']>;
};

export type TimeBlockSumOrderByAggregateInput = {
    dayOfWeek?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
};

export type TimeBlockUpdateInput = {
    available?: InputMaybe<BoolFieldUpdateOperationsInput>;
    category?: InputMaybe<NullableEnumTimeBlockCategoryEnumFieldUpdateOperationsInput>;
    dayOfWeek?: InputMaybe<IntFieldUpdateOperationsInput>;
    endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAllDay?: InputMaybe<BoolFieldUpdateOperationsInput>;
    label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TimeBlockUpdateManyMutationInput = {
    available?: InputMaybe<BoolFieldUpdateOperationsInput>;
    category?: InputMaybe<NullableEnumTimeBlockCategoryEnumFieldUpdateOperationsInput>;
    dayOfWeek?: InputMaybe<IntFieldUpdateOperationsInput>;
    endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    isAllDay?: InputMaybe<BoolFieldUpdateOperationsInput>;
    label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    providerId?: InputMaybe<IntFieldUpdateOperationsInput>;
    startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TimeBlockWhereInput = {
    AND?: InputMaybe<Array<TimeBlockWhereInput>>;
    NOT?: InputMaybe<Array<TimeBlockWhereInput>>;
    OR?: InputMaybe<Array<TimeBlockWhereInput>>;
    available?: InputMaybe<BoolFilter>;
    category?: InputMaybe<EnumTimeBlockCategoryEnumNullableFilter>;
    dayOfWeek?: InputMaybe<IntFilter>;
    endTime?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<UuidFilter>;
    isAllDay?: InputMaybe<BoolFilter>;
    label?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    providerId?: InputMaybe<IntFilter>;
    startTime?: InputMaybe<DateTimeFilter>;
};

export type TimeBlockWhereUniqueInput = {
    AND?: InputMaybe<Array<TimeBlockWhereInput>>;
    NOT?: InputMaybe<Array<TimeBlockWhereInput>>;
    OR?: InputMaybe<Array<TimeBlockWhereInput>>;
    available?: InputMaybe<BoolFilter>;
    category?: InputMaybe<EnumTimeBlockCategoryEnumNullableFilter>;
    dayOfWeek?: InputMaybe<IntFilter>;
    endTime?: InputMaybe<DateTimeFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    isAllDay?: InputMaybe<BoolFilter>;
    label?: InputMaybe<StringNullableFilter>;
    notes?: InputMaybe<StringNullableFilter>;
    practiceId?: InputMaybe<IntFilter>;
    providerId?: InputMaybe<IntFilter>;
    startTime?: InputMaybe<DateTimeFilter>;
};

export type Transaction = {
    __typename?: 'Transaction';
    _count?: Maybe<TransactionCount>;
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    bulkChargeCardRunId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    charges: Array<Charge>;
    checkNumber?: Maybe<Scalars['String']['output']>;
    collectedBy?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    encounterId?: Maybe<Scalars['String']['output']>;
    externalPaymentReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdateDate?: Maybe<Scalars['DateTimeISO']['output']>;
    nonCardRefunds: Array<NonCardRefunds>;
    paidDate?: Maybe<Scalars['DateTimeISO']['output']>;
    parentTransactionId?: Maybe<Scalars['String']['output']>;
    payLaterAuthorizations: Array<PayLaterAuthorization>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    price: Scalars['Decimal']['output'];
    status: TransactionStatus;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    stripeDisputeId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePaymentId?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeRefundIds?: Maybe<Scalars['String']['output']>;
    superscriptFee?: Maybe<Scalars['Decimal']['output']>;
    transactionType: TransactionType;
    userId: Scalars['String']['output'];
};

export type TransactionChargesArgs = {
    cursor?: InputMaybe<ChargeWhereUniqueInput>;
    distinct?: InputMaybe<Array<ChargeScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ChargeOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ChargeWhereInput>;
};

export type TransactionNonCardRefundsArgs = {
    cursor?: InputMaybe<NonCardRefundsWhereUniqueInput>;
    distinct?: InputMaybe<Array<NonCardRefundsScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<NonCardRefundsOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NonCardRefundsWhereInput>;
};

export type TransactionPayLaterAuthorizationsArgs = {
    cursor?: InputMaybe<PayLaterAuthorizationWhereUniqueInput>;
    distinct?: InputMaybe<Array<PayLaterAuthorizationScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<PayLaterAuthorizationOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type TransactionAvgAggregate = {
    __typename?: 'TransactionAvgAggregate';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    price?: Maybe<Scalars['Decimal']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    superscriptFee?: Maybe<Scalars['Decimal']['output']>;
};

export type TransactionAvgOrderByAggregateInput = {
    allowedAmount?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    superscriptFee?: InputMaybe<SortOrder>;
};

export type TransactionCount = {
    __typename?: 'TransactionCount';
    charges: Scalars['Int']['output'];
    nonCardRefunds: Scalars['Int']['output'];
    payLaterAuthorizations: Scalars['Int']['output'];
};

export type TransactionCountChargesArgs = {
    where?: InputMaybe<ChargeWhereInput>;
};

export type TransactionCountNonCardRefundsArgs = {
    where?: InputMaybe<NonCardRefundsWhereInput>;
};

export type TransactionCountPayLaterAuthorizationsArgs = {
    where?: InputMaybe<PayLaterAuthorizationWhereInput>;
};

export type TransactionCountAggregate = {
    __typename?: 'TransactionCountAggregate';
    _all: Scalars['Int']['output'];
    allowedAmount: Scalars['Int']['output'];
    bulkChargeCardRunId: Scalars['Int']['output'];
    cardLastFourDigits: Scalars['Int']['output'];
    checkNumber: Scalars['Int']['output'];
    collectedBy: Scalars['Int']['output'];
    consumerId: Scalars['Int']['output'];
    date: Scalars['Int']['output'];
    encounterId: Scalars['Int']['output'];
    externalPaymentReason: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdateDate: Scalars['Int']['output'];
    paidDate: Scalars['Int']['output'];
    parentTransactionId: Scalars['Int']['output'];
    paymentMethodType: Scalars['Int']['output'];
    price: Scalars['Int']['output'];
    status: Scalars['Int']['output'];
    stripeCustomerId: Scalars['Int']['output'];
    stripeDisputeId: Scalars['Int']['output'];
    stripeFee: Scalars['Int']['output'];
    stripePaymentId: Scalars['Int']['output'];
    stripePaymentMethodId: Scalars['Int']['output'];
    stripeRefundIds: Scalars['Int']['output'];
    superscriptFee: Scalars['Int']['output'];
    transactionType: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
};

export type TransactionCountOrderByAggregateInput = {
    allowedAmount?: InputMaybe<SortOrder>;
    bulkChargeCardRunId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    checkNumber?: InputMaybe<SortOrder>;
    collectedBy?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    externalPaymentReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdateDate?: InputMaybe<SortOrder>;
    paidDate?: InputMaybe<SortOrder>;
    parentTransactionId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    stripeDisputeId?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripePaymentId?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    stripeRefundIds?: InputMaybe<SortOrder>;
    superscriptFee?: InputMaybe<SortOrder>;
    transactionType?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type TransactionCreateInput = {
    allowedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    bulkChargeCardRunId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    charges?: InputMaybe<ChargeCreateNestedManyWithoutTransactionInput>;
    checkNumber?: InputMaybe<Scalars['String']['input']>;
    collectedBy?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    encounterId?: InputMaybe<Scalars['String']['input']>;
    externalPaymentReason?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['String']['input'];
    lastUpdateDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nonCardRefunds?: InputMaybe<NonCardRefundsCreateNestedManyWithoutTransactionInput>;
    paidDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    parentTransactionId?: InputMaybe<Scalars['String']['input']>;
    payLaterAuthorizations?: InputMaybe<PayLaterAuthorizationCreateNestedManyWithoutDepositTransactionInput>;
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    price: Scalars['Decimal']['input'];
    status?: InputMaybe<TransactionStatus>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    stripeDisputeId?: InputMaybe<Scalars['String']['input']>;
    stripeFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripePaymentId?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    stripeRefundIds?: InputMaybe<Scalars['String']['input']>;
    superscriptFee?: InputMaybe<Scalars['Decimal']['input']>;
    transactionType: TransactionType;
    userId: Scalars['String']['input'];
};

export type TransactionCreateManyInput = {
    allowedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    bulkChargeCardRunId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    checkNumber?: InputMaybe<Scalars['String']['input']>;
    collectedBy?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    encounterId?: InputMaybe<Scalars['String']['input']>;
    externalPaymentReason?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['String']['input'];
    lastUpdateDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    paidDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    parentTransactionId?: InputMaybe<Scalars['String']['input']>;
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    price: Scalars['Decimal']['input'];
    status?: InputMaybe<TransactionStatus>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    stripeDisputeId?: InputMaybe<Scalars['String']['input']>;
    stripeFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripePaymentId?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    stripeRefundIds?: InputMaybe<Scalars['String']['input']>;
    superscriptFee?: InputMaybe<Scalars['Decimal']['input']>;
    transactionType: TransactionType;
    userId: Scalars['String']['input'];
};

export type TransactionCreateNestedOneWithoutChargesInput = {
    connect?: InputMaybe<TransactionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<TransactionCreateOrConnectWithoutChargesInput>;
    create?: InputMaybe<TransactionCreateWithoutChargesInput>;
};

export type TransactionCreateNestedOneWithoutNonCardRefundsInput = {
    connect?: InputMaybe<TransactionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<TransactionCreateOrConnectWithoutNonCardRefundsInput>;
    create?: InputMaybe<TransactionCreateWithoutNonCardRefundsInput>;
};

export type TransactionCreateNestedOneWithoutPayLaterAuthorizationsInput = {
    connect?: InputMaybe<TransactionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<TransactionCreateOrConnectWithoutPayLaterAuthorizationsInput>;
    create?: InputMaybe<TransactionCreateWithoutPayLaterAuthorizationsInput>;
};

export type TransactionCreateOrConnectWithoutChargesInput = {
    create: TransactionCreateWithoutChargesInput;
    where: TransactionWhereUniqueInput;
};

export type TransactionCreateOrConnectWithoutNonCardRefundsInput = {
    create: TransactionCreateWithoutNonCardRefundsInput;
    where: TransactionWhereUniqueInput;
};

export type TransactionCreateOrConnectWithoutPayLaterAuthorizationsInput = {
    create: TransactionCreateWithoutPayLaterAuthorizationsInput;
    where: TransactionWhereUniqueInput;
};

export type TransactionCreateWithoutChargesInput = {
    allowedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    bulkChargeCardRunId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    checkNumber?: InputMaybe<Scalars['String']['input']>;
    collectedBy?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    encounterId?: InputMaybe<Scalars['String']['input']>;
    externalPaymentReason?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['String']['input'];
    lastUpdateDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nonCardRefunds?: InputMaybe<NonCardRefundsCreateNestedManyWithoutTransactionInput>;
    paidDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    parentTransactionId?: InputMaybe<Scalars['String']['input']>;
    payLaterAuthorizations?: InputMaybe<PayLaterAuthorizationCreateNestedManyWithoutDepositTransactionInput>;
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    price: Scalars['Decimal']['input'];
    status?: InputMaybe<TransactionStatus>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    stripeDisputeId?: InputMaybe<Scalars['String']['input']>;
    stripeFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripePaymentId?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    stripeRefundIds?: InputMaybe<Scalars['String']['input']>;
    superscriptFee?: InputMaybe<Scalars['Decimal']['input']>;
    transactionType: TransactionType;
    userId: Scalars['String']['input'];
};

export type TransactionCreateWithoutNonCardRefundsInput = {
    allowedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    bulkChargeCardRunId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    charges?: InputMaybe<ChargeCreateNestedManyWithoutTransactionInput>;
    checkNumber?: InputMaybe<Scalars['String']['input']>;
    collectedBy?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    encounterId?: InputMaybe<Scalars['String']['input']>;
    externalPaymentReason?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['String']['input'];
    lastUpdateDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    paidDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    parentTransactionId?: InputMaybe<Scalars['String']['input']>;
    payLaterAuthorizations?: InputMaybe<PayLaterAuthorizationCreateNestedManyWithoutDepositTransactionInput>;
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    price: Scalars['Decimal']['input'];
    status?: InputMaybe<TransactionStatus>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    stripeDisputeId?: InputMaybe<Scalars['String']['input']>;
    stripeFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripePaymentId?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    stripeRefundIds?: InputMaybe<Scalars['String']['input']>;
    superscriptFee?: InputMaybe<Scalars['Decimal']['input']>;
    transactionType: TransactionType;
    userId: Scalars['String']['input'];
};

export type TransactionCreateWithoutPayLaterAuthorizationsInput = {
    allowedAmount?: InputMaybe<Scalars['Decimal']['input']>;
    bulkChargeCardRunId?: InputMaybe<Scalars['String']['input']>;
    cardLastFourDigits?: InputMaybe<Scalars['String']['input']>;
    charges?: InputMaybe<ChargeCreateNestedManyWithoutTransactionInput>;
    checkNumber?: InputMaybe<Scalars['String']['input']>;
    collectedBy?: InputMaybe<Scalars['String']['input']>;
    consumerId?: InputMaybe<Scalars['String']['input']>;
    date: Scalars['DateTimeISO']['input'];
    encounterId?: InputMaybe<Scalars['String']['input']>;
    externalPaymentReason?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['String']['input'];
    lastUpdateDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    nonCardRefunds?: InputMaybe<NonCardRefundsCreateNestedManyWithoutTransactionInput>;
    paidDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
    parentTransactionId?: InputMaybe<Scalars['String']['input']>;
    paymentMethodType?: InputMaybe<PaymentMethodType>;
    price: Scalars['Decimal']['input'];
    status?: InputMaybe<TransactionStatus>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    stripeDisputeId?: InputMaybe<Scalars['String']['input']>;
    stripeFee?: InputMaybe<Scalars['Decimal']['input']>;
    stripePaymentId?: InputMaybe<Scalars['String']['input']>;
    stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
    stripeRefundIds?: InputMaybe<Scalars['String']['input']>;
    superscriptFee?: InputMaybe<Scalars['Decimal']['input']>;
    transactionType: TransactionType;
    userId: Scalars['String']['input'];
};

export type TransactionGroupBy = {
    __typename?: 'TransactionGroupBy';
    _avg?: Maybe<TransactionAvgAggregate>;
    _count?: Maybe<TransactionCountAggregate>;
    _max?: Maybe<TransactionMaxAggregate>;
    _min?: Maybe<TransactionMinAggregate>;
    _sum?: Maybe<TransactionSumAggregate>;
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    bulkChargeCardRunId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    checkNumber?: Maybe<Scalars['String']['output']>;
    collectedBy?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    date: Scalars['DateTimeISO']['output'];
    encounterId?: Maybe<Scalars['String']['output']>;
    externalPaymentReason?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    lastUpdateDate?: Maybe<Scalars['DateTimeISO']['output']>;
    paidDate?: Maybe<Scalars['DateTimeISO']['output']>;
    parentTransactionId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    price: Scalars['Decimal']['output'];
    status: TransactionStatus;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    stripeDisputeId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePaymentId?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeRefundIds?: Maybe<Scalars['String']['output']>;
    superscriptFee?: Maybe<Scalars['Decimal']['output']>;
    transactionType: TransactionType;
    userId: Scalars['String']['output'];
};

export type TransactionMaxAggregate = {
    __typename?: 'TransactionMaxAggregate';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    bulkChargeCardRunId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    checkNumber?: Maybe<Scalars['String']['output']>;
    collectedBy?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    externalPaymentReason?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdateDate?: Maybe<Scalars['DateTimeISO']['output']>;
    paidDate?: Maybe<Scalars['DateTimeISO']['output']>;
    parentTransactionId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    price?: Maybe<Scalars['Decimal']['output']>;
    status?: Maybe<TransactionStatus>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    stripeDisputeId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePaymentId?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeRefundIds?: Maybe<Scalars['String']['output']>;
    superscriptFee?: Maybe<Scalars['Decimal']['output']>;
    transactionType?: Maybe<TransactionType>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type TransactionMaxOrderByAggregateInput = {
    allowedAmount?: InputMaybe<SortOrder>;
    bulkChargeCardRunId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    checkNumber?: InputMaybe<SortOrder>;
    collectedBy?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    externalPaymentReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdateDate?: InputMaybe<SortOrder>;
    paidDate?: InputMaybe<SortOrder>;
    parentTransactionId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    stripeDisputeId?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripePaymentId?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    stripeRefundIds?: InputMaybe<SortOrder>;
    superscriptFee?: InputMaybe<SortOrder>;
    transactionType?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type TransactionMinAggregate = {
    __typename?: 'TransactionMinAggregate';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    bulkChargeCardRunId?: Maybe<Scalars['String']['output']>;
    cardLastFourDigits?: Maybe<Scalars['String']['output']>;
    checkNumber?: Maybe<Scalars['String']['output']>;
    collectedBy?: Maybe<Scalars['String']['output']>;
    consumerId?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTimeISO']['output']>;
    encounterId?: Maybe<Scalars['String']['output']>;
    externalPaymentReason?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdateDate?: Maybe<Scalars['DateTimeISO']['output']>;
    paidDate?: Maybe<Scalars['DateTimeISO']['output']>;
    parentTransactionId?: Maybe<Scalars['String']['output']>;
    paymentMethodType?: Maybe<PaymentMethodType>;
    price?: Maybe<Scalars['Decimal']['output']>;
    status?: Maybe<TransactionStatus>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    stripeDisputeId?: Maybe<Scalars['String']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    stripePaymentId?: Maybe<Scalars['String']['output']>;
    stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeRefundIds?: Maybe<Scalars['String']['output']>;
    superscriptFee?: Maybe<Scalars['Decimal']['output']>;
    transactionType?: Maybe<TransactionType>;
    userId?: Maybe<Scalars['String']['output']>;
};

export type TransactionMinOrderByAggregateInput = {
    allowedAmount?: InputMaybe<SortOrder>;
    bulkChargeCardRunId?: InputMaybe<SortOrder>;
    cardLastFourDigits?: InputMaybe<SortOrder>;
    checkNumber?: InputMaybe<SortOrder>;
    collectedBy?: InputMaybe<SortOrder>;
    consumerId?: InputMaybe<SortOrder>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrder>;
    externalPaymentReason?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdateDate?: InputMaybe<SortOrder>;
    paidDate?: InputMaybe<SortOrder>;
    parentTransactionId?: InputMaybe<SortOrder>;
    paymentMethodType?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    stripeDisputeId?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    stripePaymentId?: InputMaybe<SortOrder>;
    stripePaymentMethodId?: InputMaybe<SortOrder>;
    stripeRefundIds?: InputMaybe<SortOrder>;
    superscriptFee?: InputMaybe<SortOrder>;
    transactionType?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type TransactionNullableRelationFilter = {
    is?: InputMaybe<TransactionWhereInput>;
    isNot?: InputMaybe<TransactionWhereInput>;
};

export type TransactionOrderByWithAggregationInput = {
    _avg?: InputMaybe<TransactionAvgOrderByAggregateInput>;
    _count?: InputMaybe<TransactionCountOrderByAggregateInput>;
    _max?: InputMaybe<TransactionMaxOrderByAggregateInput>;
    _min?: InputMaybe<TransactionMinOrderByAggregateInput>;
    _sum?: InputMaybe<TransactionSumOrderByAggregateInput>;
    allowedAmount?: InputMaybe<SortOrderInput>;
    bulkChargeCardRunId?: InputMaybe<SortOrderInput>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    checkNumber?: InputMaybe<SortOrderInput>;
    collectedBy?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrderInput>;
    externalPaymentReason?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdateDate?: InputMaybe<SortOrderInput>;
    paidDate?: InputMaybe<SortOrderInput>;
    parentTransactionId?: InputMaybe<SortOrderInput>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    price?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrderInput>;
    stripeDisputeId?: InputMaybe<SortOrderInput>;
    stripeFee?: InputMaybe<SortOrderInput>;
    stripePaymentId?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    stripeRefundIds?: InputMaybe<SortOrderInput>;
    superscriptFee?: InputMaybe<SortOrderInput>;
    transactionType?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export type TransactionOrderByWithRelationInput = {
    allowedAmount?: InputMaybe<SortOrderInput>;
    bulkChargeCardRunId?: InputMaybe<SortOrderInput>;
    cardLastFourDigits?: InputMaybe<SortOrderInput>;
    charges?: InputMaybe<ChargeOrderByRelationAggregateInput>;
    checkNumber?: InputMaybe<SortOrderInput>;
    collectedBy?: InputMaybe<SortOrderInput>;
    consumerId?: InputMaybe<SortOrderInput>;
    date?: InputMaybe<SortOrder>;
    encounterId?: InputMaybe<SortOrderInput>;
    externalPaymentReason?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastUpdateDate?: InputMaybe<SortOrderInput>;
    nonCardRefunds?: InputMaybe<NonCardRefundsOrderByRelationAggregateInput>;
    paidDate?: InputMaybe<SortOrderInput>;
    parentTransactionId?: InputMaybe<SortOrderInput>;
    payLaterAuthorizations?: InputMaybe<PayLaterAuthorizationOrderByRelationAggregateInput>;
    paymentMethodType?: InputMaybe<SortOrderInput>;
    price?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrderInput>;
    stripeDisputeId?: InputMaybe<SortOrderInput>;
    stripeFee?: InputMaybe<SortOrderInput>;
    stripePaymentId?: InputMaybe<SortOrderInput>;
    stripePaymentMethodId?: InputMaybe<SortOrderInput>;
    stripeRefundIds?: InputMaybe<SortOrderInput>;
    superscriptFee?: InputMaybe<SortOrderInput>;
    transactionType?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
};

export enum TransactionScalarFieldEnum {
    AllowedAmount = 'allowedAmount',
    BulkChargeCardRunId = 'bulkChargeCardRunId',
    CardLastFourDigits = 'cardLastFourDigits',
    CheckNumber = 'checkNumber',
    CollectedBy = 'collectedBy',
    ConsumerId = 'consumerId',
    Date = 'date',
    EncounterId = 'encounterId',
    ExternalPaymentReason = 'externalPaymentReason',
    Id = 'id',
    LastUpdateDate = 'lastUpdateDate',
    PaidDate = 'paidDate',
    ParentTransactionId = 'parentTransactionId',
    PaymentMethodType = 'paymentMethodType',
    Price = 'price',
    Status = 'status',
    StripeCustomerId = 'stripeCustomerId',
    StripeDisputeId = 'stripeDisputeId',
    StripeFee = 'stripeFee',
    StripePaymentId = 'stripePaymentId',
    StripePaymentMethodId = 'stripePaymentMethodId',
    StripeRefundIds = 'stripeRefundIds',
    SuperscriptFee = 'superscriptFee',
    TransactionType = 'transactionType',
    UserId = 'userId',
}

export type TransactionScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<TransactionScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<TransactionScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<TransactionScalarWhereWithAggregatesInput>>;
    allowedAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    bulkChargeCardRunId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableWithAggregatesFilter>;
    checkNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
    collectedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    consumerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    date?: InputMaybe<DateTimeWithAggregatesFilter>;
    encounterId?: InputMaybe<StringNullableWithAggregatesFilter>;
    externalPaymentReason?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<StringWithAggregatesFilter>;
    lastUpdateDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    paidDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
    parentTransactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableWithAggregatesFilter>;
    price?: InputMaybe<DecimalWithAggregatesFilter>;
    status?: InputMaybe<EnumTransactionStatusWithAggregatesFilter>;
    stripeCustomerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeDisputeId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeFee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    stripePaymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableWithAggregatesFilter>;
    stripeRefundIds?: InputMaybe<StringNullableWithAggregatesFilter>;
    superscriptFee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
    transactionType?: InputMaybe<EnumTransactionTypeWithAggregatesFilter>;
    userId?: InputMaybe<StringWithAggregatesFilter>;
};

export enum TransactionStatus {
    Cancelled = 'CANCELLED',
    Checkcashing = 'CHECKCASHING',
    Completed = 'COMPLETED',
    Pending = 'PENDING',
    Recreated = 'RECREATED',
    Repaid = 'REPAID',
    Voided = 'VOIDED',
}

export type TransactionSumAggregate = {
    __typename?: 'TransactionSumAggregate';
    allowedAmount?: Maybe<Scalars['Decimal']['output']>;
    price?: Maybe<Scalars['Decimal']['output']>;
    stripeFee?: Maybe<Scalars['Decimal']['output']>;
    superscriptFee?: Maybe<Scalars['Decimal']['output']>;
};

export type TransactionSumOrderByAggregateInput = {
    allowedAmount?: InputMaybe<SortOrder>;
    price?: InputMaybe<SortOrder>;
    stripeFee?: InputMaybe<SortOrder>;
    superscriptFee?: InputMaybe<SortOrder>;
};

export enum TransactionType {
    Payment = 'PAYMENT',
    Refund = 'REFUND',
    TotalRefund = 'TOTAL_REFUND',
}

export type TransactionUpdateInput = {
    allowedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    bulkChargeCardRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    charges?: InputMaybe<ChargeUpdateManyWithoutTransactionNestedInput>;
    checkNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    collectedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    externalPaymentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdateDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nonCardRefunds?: InputMaybe<NonCardRefundsUpdateManyWithoutTransactionNestedInput>;
    paidDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    parentTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payLaterAuthorizations?: InputMaybe<PayLaterAuthorizationUpdateManyWithoutDepositTransactionNestedInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeDisputeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripePaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeRefundIds?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    transactionType?: InputMaybe<EnumTransactionTypeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransactionUpdateManyMutationInput = {
    allowedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    bulkChargeCardRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    checkNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    collectedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    externalPaymentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdateDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    paidDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    parentTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeDisputeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripePaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeRefundIds?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    transactionType?: InputMaybe<EnumTransactionTypeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransactionUpdateOneWithoutChargesNestedInput = {
    connect?: InputMaybe<TransactionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<TransactionCreateOrConnectWithoutChargesInput>;
    create?: InputMaybe<TransactionCreateWithoutChargesInput>;
    delete?: InputMaybe<TransactionWhereInput>;
    disconnect?: InputMaybe<TransactionWhereInput>;
    update?: InputMaybe<TransactionUpdateToOneWithWhereWithoutChargesInput>;
    upsert?: InputMaybe<TransactionUpsertWithoutChargesInput>;
};

export type TransactionUpdateOneWithoutNonCardRefundsNestedInput = {
    connect?: InputMaybe<TransactionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<TransactionCreateOrConnectWithoutNonCardRefundsInput>;
    create?: InputMaybe<TransactionCreateWithoutNonCardRefundsInput>;
    delete?: InputMaybe<TransactionWhereInput>;
    disconnect?: InputMaybe<TransactionWhereInput>;
    update?: InputMaybe<TransactionUpdateToOneWithWhereWithoutNonCardRefundsInput>;
    upsert?: InputMaybe<TransactionUpsertWithoutNonCardRefundsInput>;
};

export type TransactionUpdateOneWithoutPayLaterAuthorizationsNestedInput = {
    connect?: InputMaybe<TransactionWhereUniqueInput>;
    connectOrCreate?: InputMaybe<TransactionCreateOrConnectWithoutPayLaterAuthorizationsInput>;
    create?: InputMaybe<TransactionCreateWithoutPayLaterAuthorizationsInput>;
    delete?: InputMaybe<TransactionWhereInput>;
    disconnect?: InputMaybe<TransactionWhereInput>;
    update?: InputMaybe<TransactionUpdateToOneWithWhereWithoutPayLaterAuthorizationsInput>;
    upsert?: InputMaybe<TransactionUpsertWithoutPayLaterAuthorizationsInput>;
};

export type TransactionUpdateToOneWithWhereWithoutChargesInput = {
    data: TransactionUpdateWithoutChargesInput;
    where?: InputMaybe<TransactionWhereInput>;
};

export type TransactionUpdateToOneWithWhereWithoutNonCardRefundsInput = {
    data: TransactionUpdateWithoutNonCardRefundsInput;
    where?: InputMaybe<TransactionWhereInput>;
};

export type TransactionUpdateToOneWithWhereWithoutPayLaterAuthorizationsInput =
    {
        data: TransactionUpdateWithoutPayLaterAuthorizationsInput;
        where?: InputMaybe<TransactionWhereInput>;
    };

export type TransactionUpdateWithoutChargesInput = {
    allowedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    bulkChargeCardRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    checkNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    collectedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    externalPaymentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdateDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nonCardRefunds?: InputMaybe<NonCardRefundsUpdateManyWithoutTransactionNestedInput>;
    paidDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    parentTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payLaterAuthorizations?: InputMaybe<PayLaterAuthorizationUpdateManyWithoutDepositTransactionNestedInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeDisputeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripePaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeRefundIds?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    transactionType?: InputMaybe<EnumTransactionTypeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransactionUpdateWithoutNonCardRefundsInput = {
    allowedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    bulkChargeCardRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    charges?: InputMaybe<ChargeUpdateManyWithoutTransactionNestedInput>;
    checkNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    collectedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    externalPaymentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdateDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    paidDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    parentTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    payLaterAuthorizations?: InputMaybe<PayLaterAuthorizationUpdateManyWithoutDepositTransactionNestedInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeDisputeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripePaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeRefundIds?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    transactionType?: InputMaybe<EnumTransactionTypeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransactionUpdateWithoutPayLaterAuthorizationsInput = {
    allowedAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    bulkChargeCardRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    cardLastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    charges?: InputMaybe<ChargeUpdateManyWithoutTransactionNestedInput>;
    checkNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    collectedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    consumerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    encounterId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    externalPaymentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdateDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    nonCardRefunds?: InputMaybe<NonCardRefundsUpdateManyWithoutTransactionNestedInput>;
    paidDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
    parentTransactionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    paymentMethodType?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
    price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
    status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeDisputeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    stripePaymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    stripeRefundIds?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    superscriptFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
    transactionType?: InputMaybe<EnumTransactionTypeFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransactionUpsertWithoutChargesInput = {
    create: TransactionCreateWithoutChargesInput;
    update: TransactionUpdateWithoutChargesInput;
    where?: InputMaybe<TransactionWhereInput>;
};

export type TransactionUpsertWithoutNonCardRefundsInput = {
    create: TransactionCreateWithoutNonCardRefundsInput;
    update: TransactionUpdateWithoutNonCardRefundsInput;
    where?: InputMaybe<TransactionWhereInput>;
};

export type TransactionUpsertWithoutPayLaterAuthorizationsInput = {
    create: TransactionCreateWithoutPayLaterAuthorizationsInput;
    update: TransactionUpdateWithoutPayLaterAuthorizationsInput;
    where?: InputMaybe<TransactionWhereInput>;
};

export type TransactionWhereInput = {
    AND?: InputMaybe<Array<TransactionWhereInput>>;
    NOT?: InputMaybe<Array<TransactionWhereInput>>;
    OR?: InputMaybe<Array<TransactionWhereInput>>;
    allowedAmount?: InputMaybe<DecimalNullableFilter>;
    bulkChargeCardRunId?: InputMaybe<UuidNullableFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    charges?: InputMaybe<ChargeListRelationFilter>;
    checkNumber?: InputMaybe<StringNullableFilter>;
    collectedBy?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    externalPaymentReason?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<StringFilter>;
    lastUpdateDate?: InputMaybe<DateTimeNullableFilter>;
    nonCardRefunds?: InputMaybe<NonCardRefundsListRelationFilter>;
    paidDate?: InputMaybe<DateTimeNullableFilter>;
    parentTransactionId?: InputMaybe<StringNullableFilter>;
    payLaterAuthorizations?: InputMaybe<PayLaterAuthorizationListRelationFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableFilter>;
    price?: InputMaybe<DecimalFilter>;
    status?: InputMaybe<EnumTransactionStatusFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    stripeDisputeId?: InputMaybe<StringNullableFilter>;
    stripeFee?: InputMaybe<DecimalNullableFilter>;
    stripePaymentId?: InputMaybe<StringNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    stripeRefundIds?: InputMaybe<StringNullableFilter>;
    superscriptFee?: InputMaybe<DecimalNullableFilter>;
    transactionType?: InputMaybe<EnumTransactionTypeFilter>;
    userId?: InputMaybe<StringFilter>;
};

export type TransactionWhereUniqueInput = {
    AND?: InputMaybe<Array<TransactionWhereInput>>;
    NOT?: InputMaybe<Array<TransactionWhereInput>>;
    OR?: InputMaybe<Array<TransactionWhereInput>>;
    allowedAmount?: InputMaybe<DecimalNullableFilter>;
    bulkChargeCardRunId?: InputMaybe<UuidNullableFilter>;
    cardLastFourDigits?: InputMaybe<StringNullableFilter>;
    charges?: InputMaybe<ChargeListRelationFilter>;
    checkNumber?: InputMaybe<StringNullableFilter>;
    collectedBy?: InputMaybe<StringNullableFilter>;
    consumerId?: InputMaybe<StringNullableFilter>;
    date?: InputMaybe<DateTimeFilter>;
    encounterId?: InputMaybe<StringNullableFilter>;
    externalPaymentReason?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdateDate?: InputMaybe<DateTimeNullableFilter>;
    nonCardRefunds?: InputMaybe<NonCardRefundsListRelationFilter>;
    paidDate?: InputMaybe<DateTimeNullableFilter>;
    parentTransactionId?: InputMaybe<StringNullableFilter>;
    payLaterAuthorizations?: InputMaybe<PayLaterAuthorizationListRelationFilter>;
    paymentMethodType?: InputMaybe<EnumPaymentMethodTypeNullableFilter>;
    price?: InputMaybe<DecimalFilter>;
    status?: InputMaybe<EnumTransactionStatusFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    stripeDisputeId?: InputMaybe<StringNullableFilter>;
    stripeFee?: InputMaybe<DecimalNullableFilter>;
    stripePaymentId?: InputMaybe<StringNullableFilter>;
    stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
    stripeRefundIds?: InputMaybe<StringNullableFilter>;
    superscriptFee?: InputMaybe<DecimalNullableFilter>;
    transactionType?: InputMaybe<EnumTransactionTypeFilter>;
    userId?: InputMaybe<StringFilter>;
};

export type UpdateInsuranceInput = {
    id: Scalars['String']['input'];
    insurance: InsuranceUpdateInput;
    orgId: Scalars['Float']['input'];
};

export type UpdateInsuranceResponse = {
    __typename?: 'UpdateInsuranceResponse';
    _count?: Maybe<InsuranceCount>;
    consumer?: Maybe<Consumer>;
    consumerId?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['DateTimeISO']['output'];
    ehrInsuranceId?: Maybe<Scalars['String']['output']>;
    ehrInsurancePackageId?: Maybe<Scalars['String']['output']>;
    ehrWriteError?: Maybe<Scalars['Boolean']['output']>;
    groupNumber?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    insuranceAccountStatus?: Maybe<InsuranceAccountStatus>;
    insuredDob?: Maybe<Scalars['String']['output']>;
    insuredFirstName?: Maybe<Scalars['String']['output']>;
    insuredLastName?: Maybe<Scalars['String']['output']>;
    insuredRelationshipCode?: Maybe<Scalars['String']['output']>;
    isPrimaryInsurance: Scalars['Boolean']['output'];
    lastCheckedAt: Scalars['DateTimeISO']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    memberId: Scalars['String']['output'];
    otherInsurances?: Maybe<Scalars['JSON']['output']>;
    payer: Scalars['String']['output'];
    pcpCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    pcpCopayAmount?: Maybe<Scalars['Int']['output']>;
    pcpName?: Maybe<Scalars['String']['output']>;
    photos: Array<ConsumerPhotoMetaData>;
    planEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
    planName?: Maybe<Scalars['String']['output']>;
    planStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
    priority?: Maybe<Scalars['Int']['output']>;
    specialistCoinsurancePercentage?: Maybe<Scalars['Int']['output']>;
    specialistCopayAmount?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    status: InsurancesStatusEnum;
    subscriberInfo?: Maybe<Scalars['JSON']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
};

export type UpdateInsuranceResponseConsumerArgs = {
    where?: InputMaybe<ConsumerWhereInput>;
};

export type UpdateInsuranceResponsePhotosArgs = {
    cursor?: InputMaybe<ConsumerPhotoMetaDataWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerPhotoMetaDataScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerPhotoMetaDataOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerPhotoMetaDataWhereInput>;
};

export type UpdateUserInput = {
    id: Scalars['String']['input'];
    user: UserUpdateInput;
};

export type UpdateUserResponse = {
    __typename?: 'UpdateUserResponse';
    _count?: Maybe<UserCount>;
    consumers: Array<Consumer>;
    consumersWithEhrWriteErrors?: Maybe<Array<Scalars['String']['output']>>;
    createdAt: Scalars['DateTimeISO']['output'];
    disableMessaging: Scalars['Boolean']['output'];
    email?: Maybe<Scalars['String']['output']>;
    firstname: Scalars['String']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lastname: Scalars['String']['output'];
    mergedFrom: Array<UserToNewUser>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    primaryConsumer?: Maybe<Consumer>;
    primaryConsumerId?: Maybe<Scalars['String']['output']>;
    primaryLanguage: LanguageCode;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userAccountStatus?: Maybe<UserAccountStatus>;
    verifiedFlag: Scalars['Boolean']['output'];
};

export type UpdateUserResponseConsumersArgs = {
    cursor?: InputMaybe<ConsumerWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type UpdateUserResponseMergedFromArgs = {
    cursor?: InputMaybe<UserToNewUserWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserToNewUserScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserToNewUserOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserToNewUserWhereInput>;
};

export type UpdateUserResponsePrimaryConsumerArgs = {
    where?: InputMaybe<ConsumerWhereInput>;
};

export type User = {
    __typename?: 'User';
    _count?: Maybe<UserCount>;
    consumers: Array<Consumer>;
    createdAt: Scalars['DateTimeISO']['output'];
    disableMessaging: Scalars['Boolean']['output'];
    email?: Maybe<Scalars['String']['output']>;
    firstname: Scalars['String']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lastname: Scalars['String']['output'];
    mergedFrom: Array<UserToNewUser>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    primaryConsumer?: Maybe<Consumer>;
    primaryConsumerId?: Maybe<Scalars['String']['output']>;
    primaryLanguage: LanguageCode;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userAccountStatus?: Maybe<UserAccountStatus>;
    verifiedFlag: Scalars['Boolean']['output'];
};

export type UserConsumersArgs = {
    cursor?: InputMaybe<ConsumerWhereUniqueInput>;
    distinct?: InputMaybe<Array<ConsumerScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<ConsumerOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConsumerWhereInput>;
};

export type UserMergedFromArgs = {
    cursor?: InputMaybe<UserToNewUserWhereUniqueInput>;
    distinct?: InputMaybe<Array<UserToNewUserScalarFieldEnum>>;
    orderBy?: InputMaybe<Array<UserToNewUserOrderByWithRelationInput>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<UserToNewUserWhereInput>;
};

export type UserPrimaryConsumerArgs = {
    where?: InputMaybe<ConsumerWhereInput>;
};

export enum UserAccountStatus {
    AdminCreated = 'ADMIN_CREATED',
    Connected = 'CONNECTED',
    Deleted = 'DELETED',
    Replaced = 'REPLACED',
}

export type UserAuditLog = {
    __typename?: 'UserAuditLog';
    createdAt: Scalars['DateTimeISO']['output'];
    disableMessaging?: Maybe<Scalars['Boolean']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    primaryLanguage?: Maybe<LanguageCode>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userAccountStatus?: Maybe<UserAccountStatus>;
    userId?: Maybe<Scalars['String']['output']>;
    verifiedFlag?: Maybe<Scalars['Boolean']['output']>;
};

export type UserAuditLogAvgAggregate = {
    __typename?: 'UserAuditLogAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type UserAuditLogAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type UserAuditLogCountAggregate = {
    __typename?: 'UserAuditLogCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    disableMessaging: Scalars['Int']['output'];
    email: Scalars['Int']['output'];
    firstName: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastName: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    operation: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    phone: Scalars['Int']['output'];
    primaryLanguage: Scalars['Int']['output'];
    stripeCustomerId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    userAccountStatus: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
    verifiedFlag: Scalars['Int']['output'];
};

export type UserAuditLogCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    disableMessaging?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    primaryLanguage?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userAccountStatus?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    verifiedFlag?: InputMaybe<SortOrder>;
};

export type UserAuditLogCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    disableMessaging?: InputMaybe<Scalars['Boolean']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    primaryLanguage?: InputMaybe<LanguageCode>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userAccountStatus?: InputMaybe<UserAccountStatus>;
    userId?: InputMaybe<Scalars['String']['input']>;
    verifiedFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAuditLogCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    disableMessaging?: InputMaybe<Scalars['Boolean']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    operation?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    primaryLanguage?: InputMaybe<LanguageCode>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userAccountStatus?: InputMaybe<UserAccountStatus>;
    userId?: InputMaybe<Scalars['String']['input']>;
    verifiedFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAuditLogGroupBy = {
    __typename?: 'UserAuditLogGroupBy';
    _avg?: Maybe<UserAuditLogAvgAggregate>;
    _count?: Maybe<UserAuditLogCountAggregate>;
    _max?: Maybe<UserAuditLogMaxAggregate>;
    _min?: Maybe<UserAuditLogMinAggregate>;
    _sum?: Maybe<UserAuditLogSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    disableMessaging?: Maybe<Scalars['Boolean']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    primaryLanguage?: Maybe<LanguageCode>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userAccountStatus?: Maybe<UserAccountStatus>;
    userId?: Maybe<Scalars['String']['output']>;
    verifiedFlag?: Maybe<Scalars['Boolean']['output']>;
};

export type UserAuditLogMaxAggregate = {
    __typename?: 'UserAuditLogMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    disableMessaging?: Maybe<Scalars['Boolean']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    primaryLanguage?: Maybe<LanguageCode>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userAccountStatus?: Maybe<UserAccountStatus>;
    userId?: Maybe<Scalars['String']['output']>;
    verifiedFlag?: Maybe<Scalars['Boolean']['output']>;
};

export type UserAuditLogMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    disableMessaging?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    primaryLanguage?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userAccountStatus?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    verifiedFlag?: InputMaybe<SortOrder>;
};

export type UserAuditLogMinAggregate = {
    __typename?: 'UserAuditLogMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    disableMessaging?: Maybe<Scalars['Boolean']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    primaryLanguage?: Maybe<LanguageCode>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userAccountStatus?: Maybe<UserAccountStatus>;
    userId?: Maybe<Scalars['String']['output']>;
    verifiedFlag?: Maybe<Scalars['Boolean']['output']>;
};

export type UserAuditLogMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    disableMessaging?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    firstName?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    operation?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    primaryLanguage?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userAccountStatus?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    verifiedFlag?: InputMaybe<SortOrder>;
};

export type UserAuditLogOrderByWithAggregationInput = {
    _avg?: InputMaybe<UserAuditLogAvgOrderByAggregateInput>;
    _count?: InputMaybe<UserAuditLogCountOrderByAggregateInput>;
    _max?: InputMaybe<UserAuditLogMaxOrderByAggregateInput>;
    _min?: InputMaybe<UserAuditLogMinOrderByAggregateInput>;
    _sum?: InputMaybe<UserAuditLogSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    disableMessaging?: InputMaybe<SortOrderInput>;
    email?: InputMaybe<SortOrderInput>;
    firstName?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    phone?: InputMaybe<SortOrderInput>;
    primaryLanguage?: InputMaybe<SortOrderInput>;
    stripeCustomerId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    userAccountStatus?: InputMaybe<SortOrderInput>;
    userId?: InputMaybe<SortOrderInput>;
    verifiedFlag?: InputMaybe<SortOrderInput>;
};

export type UserAuditLogOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    disableMessaging?: InputMaybe<SortOrderInput>;
    email?: InputMaybe<SortOrderInput>;
    firstName?: InputMaybe<SortOrderInput>;
    id?: InputMaybe<SortOrder>;
    lastName?: InputMaybe<SortOrderInput>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    operation?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    phone?: InputMaybe<SortOrderInput>;
    primaryLanguage?: InputMaybe<SortOrderInput>;
    stripeCustomerId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    userAccountStatus?: InputMaybe<SortOrderInput>;
    userId?: InputMaybe<SortOrderInput>;
    verifiedFlag?: InputMaybe<SortOrderInput>;
};

export enum UserAuditLogScalarFieldEnum {
    CreatedAt = 'createdAt',
    DisableMessaging = 'disableMessaging',
    Email = 'email',
    FirstName = 'firstName',
    Id = 'id',
    LastName = 'lastName',
    LastUpdatedBy = 'lastUpdatedBy',
    Operation = 'operation',
    OrgId = 'orgId',
    Phone = 'phone',
    PrimaryLanguage = 'primaryLanguage',
    StripeCustomerId = 'stripeCustomerId',
    UpdatedAt = 'updatedAt',
    UserAccountStatus = 'userAccountStatus',
    UserId = 'userId',
    VerifiedFlag = 'verifiedFlag',
}

export type UserAuditLogScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<UserAuditLogScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<UserAuditLogScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<UserAuditLogScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    disableMessaging?: InputMaybe<BoolNullableWithAggregatesFilter>;
    email?: InputMaybe<StringNullableWithAggregatesFilter>;
    firstName?: InputMaybe<StringNullableWithAggregatesFilter>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    operation?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    phone?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeNullableWithAggregatesFilter>;
    stripeCustomerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    userAccountStatus?: InputMaybe<EnumUserAccountStatusNullableWithAggregatesFilter>;
    userId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    verifiedFlag?: InputMaybe<BoolNullableWithAggregatesFilter>;
};

export type UserAuditLogSumAggregate = {
    __typename?: 'UserAuditLogSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type UserAuditLogSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
};

export type UserAuditLogUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    disableMessaging?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userAccountStatus?: InputMaybe<NullableEnumUserAccountStatusFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verifiedFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type UserAuditLogUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    disableMessaging?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    operation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryLanguage?: InputMaybe<NullableEnumLanguageCodeFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userAccountStatus?: InputMaybe<NullableEnumUserAccountStatusFieldUpdateOperationsInput>;
    userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    verifiedFlag?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type UserAuditLogWhereInput = {
    AND?: InputMaybe<Array<UserAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<UserAuditLogWhereInput>>;
    OR?: InputMaybe<Array<UserAuditLogWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    disableMessaging?: InputMaybe<BoolNullableFilter>;
    email?: InputMaybe<StringNullableFilter>;
    firstName?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<IntFilter>;
    lastName?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeNullableFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userAccountStatus?: InputMaybe<EnumUserAccountStatusNullableFilter>;
    userId?: InputMaybe<UuidNullableFilter>;
    verifiedFlag?: InputMaybe<BoolNullableFilter>;
};

export type UserAuditLogWhereUniqueInput = {
    AND?: InputMaybe<Array<UserAuditLogWhereInput>>;
    NOT?: InputMaybe<Array<UserAuditLogWhereInput>>;
    OR?: InputMaybe<Array<UserAuditLogWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    disableMessaging?: InputMaybe<BoolNullableFilter>;
    email?: InputMaybe<StringNullableFilter>;
    firstName?: InputMaybe<StringNullableFilter>;
    id?: InputMaybe<Scalars['Int']['input']>;
    lastName?: InputMaybe<StringNullableFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    operation?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeNullableFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userAccountStatus?: InputMaybe<EnumUserAccountStatusNullableFilter>;
    userId?: InputMaybe<UuidNullableFilter>;
    verifiedFlag?: InputMaybe<BoolNullableFilter>;
};

export type UserAvgAggregate = {
    __typename?: 'UserAvgAggregate';
    orgId?: Maybe<Scalars['Float']['output']>;
};

export type UserAvgOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type UserCount = {
    __typename?: 'UserCount';
    consumers: Scalars['Int']['output'];
    mergedFrom: Scalars['Int']['output'];
};

export type UserCountConsumersArgs = {
    where?: InputMaybe<ConsumerWhereInput>;
};

export type UserCountMergedFromArgs = {
    where?: InputMaybe<UserToNewUserWhereInput>;
};

export type UserCountAggregate = {
    __typename?: 'UserCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    disableMessaging: Scalars['Int']['output'];
    email: Scalars['Int']['output'];
    firstname: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    lastUpdatedBy: Scalars['Int']['output'];
    lastname: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    phone: Scalars['Int']['output'];
    primaryConsumerId: Scalars['Int']['output'];
    primaryLanguage: Scalars['Int']['output'];
    stripeCustomerId: Scalars['Int']['output'];
    updatedAt: Scalars['Int']['output'];
    userAccountStatus: Scalars['Int']['output'];
    verifiedFlag: Scalars['Int']['output'];
};

export type UserCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    disableMessaging?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    firstname?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lastname?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    primaryConsumerId?: InputMaybe<SortOrder>;
    primaryLanguage?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userAccountStatus?: InputMaybe<SortOrder>;
    verifiedFlag?: InputMaybe<SortOrder>;
};

export type UserCreateInput = {
    consumers?: InputMaybe<ConsumerCreateNestedManyWithoutUserInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    disableMessaging?: InputMaybe<Scalars['Boolean']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    mergedFrom?: InputMaybe<UserToNewUserCreateNestedManyWithoutNewUserInput>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    primaryConsumer?: InputMaybe<ConsumerCreateNestedOneWithoutUserIfPrimaryConsumerInput>;
    primaryLanguage?: InputMaybe<LanguageCode>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userAccountStatus?: InputMaybe<UserAccountStatus>;
    verifiedFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    disableMessaging?: InputMaybe<Scalars['Boolean']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    primaryConsumerId?: InputMaybe<Scalars['String']['input']>;
    primaryLanguage?: InputMaybe<LanguageCode>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userAccountStatus?: InputMaybe<UserAccountStatus>;
    verifiedFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreateNestedOneWithoutConsumersInput = {
    connect?: InputMaybe<UserWhereUniqueInput>;
    connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutConsumersInput>;
    create?: InputMaybe<UserCreateWithoutConsumersInput>;
};

export type UserCreateNestedOneWithoutMergedFromInput = {
    connect?: InputMaybe<UserWhereUniqueInput>;
    connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMergedFromInput>;
    create?: InputMaybe<UserCreateWithoutMergedFromInput>;
};

export type UserCreateNestedOneWithoutPrimaryConsumerInput = {
    connect?: InputMaybe<UserWhereUniqueInput>;
    connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPrimaryConsumerInput>;
    create?: InputMaybe<UserCreateWithoutPrimaryConsumerInput>;
};

export type UserCreateOrConnectWithoutConsumersInput = {
    create: UserCreateWithoutConsumersInput;
    where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMergedFromInput = {
    create: UserCreateWithoutMergedFromInput;
    where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPrimaryConsumerInput = {
    create: UserCreateWithoutPrimaryConsumerInput;
    where: UserWhereUniqueInput;
};

export type UserCreateWithoutConsumersInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    disableMessaging?: InputMaybe<Scalars['Boolean']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    mergedFrom?: InputMaybe<UserToNewUserCreateNestedManyWithoutNewUserInput>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    primaryConsumer?: InputMaybe<ConsumerCreateNestedOneWithoutUserIfPrimaryConsumerInput>;
    primaryLanguage?: InputMaybe<LanguageCode>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userAccountStatus?: InputMaybe<UserAccountStatus>;
    verifiedFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreateWithoutMergedFromInput = {
    consumers?: InputMaybe<ConsumerCreateNestedManyWithoutUserInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    disableMessaging?: InputMaybe<Scalars['Boolean']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    primaryConsumer?: InputMaybe<ConsumerCreateNestedOneWithoutUserIfPrimaryConsumerInput>;
    primaryLanguage?: InputMaybe<LanguageCode>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userAccountStatus?: InputMaybe<UserAccountStatus>;
    verifiedFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreateWithoutPrimaryConsumerInput = {
    consumers?: InputMaybe<ConsumerCreateNestedManyWithoutUserInput>;
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    disableMessaging?: InputMaybe<Scalars['Boolean']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    firstname: Scalars['String']['input'];
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    lastname: Scalars['String']['input'];
    mergedFrom?: InputMaybe<UserToNewUserCreateNestedManyWithoutNewUserInput>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    primaryLanguage?: InputMaybe<LanguageCode>;
    stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    userAccountStatus?: InputMaybe<UserAccountStatus>;
    verifiedFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserGroupBy = {
    __typename?: 'UserGroupBy';
    _avg?: Maybe<UserAvgAggregate>;
    _count?: Maybe<UserCountAggregate>;
    _max?: Maybe<UserMaxAggregate>;
    _min?: Maybe<UserMinAggregate>;
    _sum?: Maybe<UserSumAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    disableMessaging: Scalars['Boolean']['output'];
    email?: Maybe<Scalars['String']['output']>;
    firstname: Scalars['String']['output'];
    id: Scalars['String']['output'];
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lastname: Scalars['String']['output'];
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    primaryConsumerId?: Maybe<Scalars['String']['output']>;
    primaryLanguage: LanguageCode;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTimeISO']['output'];
    userAccountStatus?: Maybe<UserAccountStatus>;
    verifiedFlag: Scalars['Boolean']['output'];
};

export type UserMaxAggregate = {
    __typename?: 'UserMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    disableMessaging?: Maybe<Scalars['Boolean']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstname?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lastname?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    primaryConsumerId?: Maybe<Scalars['String']['output']>;
    primaryLanguage?: Maybe<LanguageCode>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userAccountStatus?: Maybe<UserAccountStatus>;
    verifiedFlag?: Maybe<Scalars['Boolean']['output']>;
};

export type UserMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    disableMessaging?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    firstname?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lastname?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    primaryConsumerId?: InputMaybe<SortOrder>;
    primaryLanguage?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userAccountStatus?: InputMaybe<SortOrder>;
    verifiedFlag?: InputMaybe<SortOrder>;
};

export type UserMinAggregate = {
    __typename?: 'UserMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    disableMessaging?: Maybe<Scalars['Boolean']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstname?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdatedBy?: Maybe<Scalars['String']['output']>;
    lastname?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    primaryConsumerId?: Maybe<Scalars['String']['output']>;
    primaryLanguage?: Maybe<LanguageCode>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
    userAccountStatus?: Maybe<UserAccountStatus>;
    verifiedFlag?: Maybe<Scalars['Boolean']['output']>;
};

export type UserMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    disableMessaging?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrder>;
    firstname?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrder>;
    lastname?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    phone?: InputMaybe<SortOrder>;
    primaryConsumerId?: InputMaybe<SortOrder>;
    primaryLanguage?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
    userAccountStatus?: InputMaybe<SortOrder>;
    verifiedFlag?: InputMaybe<SortOrder>;
};

export type UserNullableRelationFilter = {
    is?: InputMaybe<UserWhereInput>;
    isNot?: InputMaybe<UserWhereInput>;
};

export type UserOrderByWithAggregationInput = {
    _avg?: InputMaybe<UserAvgOrderByAggregateInput>;
    _count?: InputMaybe<UserCountOrderByAggregateInput>;
    _max?: InputMaybe<UserMaxOrderByAggregateInput>;
    _min?: InputMaybe<UserMinOrderByAggregateInput>;
    _sum?: InputMaybe<UserSumOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    disableMessaging?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrderInput>;
    firstname?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    lastname?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrderInput>;
    phone?: InputMaybe<SortOrderInput>;
    primaryConsumerId?: InputMaybe<SortOrderInput>;
    primaryLanguage?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    userAccountStatus?: InputMaybe<SortOrderInput>;
    verifiedFlag?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
    consumers?: InputMaybe<ConsumerOrderByRelationAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    disableMessaging?: InputMaybe<SortOrder>;
    email?: InputMaybe<SortOrderInput>;
    firstname?: InputMaybe<SortOrder>;
    id?: InputMaybe<SortOrder>;
    lastUpdatedBy?: InputMaybe<SortOrderInput>;
    lastname?: InputMaybe<SortOrder>;
    mergedFrom?: InputMaybe<UserToNewUserOrderByRelationAggregateInput>;
    orgId?: InputMaybe<SortOrderInput>;
    phone?: InputMaybe<SortOrderInput>;
    primaryConsumer?: InputMaybe<ConsumerOrderByWithRelationInput>;
    primaryConsumerId?: InputMaybe<SortOrderInput>;
    primaryLanguage?: InputMaybe<SortOrder>;
    stripeCustomerId?: InputMaybe<SortOrderInput>;
    updatedAt?: InputMaybe<SortOrder>;
    userAccountStatus?: InputMaybe<SortOrderInput>;
    verifiedFlag?: InputMaybe<SortOrder>;
};

export type UserPracticeVisit = {
    __typename?: 'UserPracticeVisit';
    id: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    userId: Scalars['String']['output'];
    visitTimestamp: Scalars['DateTimeISO']['output'];
};

export type UserPracticeVisitAvgAggregate = {
    __typename?: 'UserPracticeVisitAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    practiceId?: Maybe<Scalars['Float']['output']>;
};

export type UserPracticeVisitAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type UserPracticeVisitCountAggregate = {
    __typename?: 'UserPracticeVisitCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    userId: Scalars['Int']['output'];
    visitTimestamp: Scalars['Int']['output'];
};

export type UserPracticeVisitCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    visitTimestamp?: InputMaybe<SortOrder>;
};

export type UserPracticeVisitCreateInput = {
    practiceId: Scalars['Int']['input'];
    userId: Scalars['String']['input'];
    visitTimestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserPracticeVisitCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    practiceId: Scalars['Int']['input'];
    userId: Scalars['String']['input'];
    visitTimestamp?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserPracticeVisitGroupBy = {
    __typename?: 'UserPracticeVisitGroupBy';
    _avg?: Maybe<UserPracticeVisitAvgAggregate>;
    _count?: Maybe<UserPracticeVisitCountAggregate>;
    _max?: Maybe<UserPracticeVisitMaxAggregate>;
    _min?: Maybe<UserPracticeVisitMinAggregate>;
    _sum?: Maybe<UserPracticeVisitSumAggregate>;
    id: Scalars['Int']['output'];
    practiceId: Scalars['Int']['output'];
    userId: Scalars['String']['output'];
    visitTimestamp: Scalars['DateTimeISO']['output'];
};

export type UserPracticeVisitMaxAggregate = {
    __typename?: 'UserPracticeVisitMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    visitTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type UserPracticeVisitMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    visitTimestamp?: InputMaybe<SortOrder>;
};

export type UserPracticeVisitMinAggregate = {
    __typename?: 'UserPracticeVisitMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    visitTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type UserPracticeVisitMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    visitTimestamp?: InputMaybe<SortOrder>;
};

export type UserPracticeVisitOrderByWithAggregationInput = {
    _avg?: InputMaybe<UserPracticeVisitAvgOrderByAggregateInput>;
    _count?: InputMaybe<UserPracticeVisitCountOrderByAggregateInput>;
    _max?: InputMaybe<UserPracticeVisitMaxOrderByAggregateInput>;
    _min?: InputMaybe<UserPracticeVisitMinOrderByAggregateInput>;
    _sum?: InputMaybe<UserPracticeVisitSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    visitTimestamp?: InputMaybe<SortOrder>;
};

export type UserPracticeVisitOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
    userId?: InputMaybe<SortOrder>;
    visitTimestamp?: InputMaybe<SortOrder>;
};

export enum UserPracticeVisitScalarFieldEnum {
    Id = 'id',
    PracticeId = 'practiceId',
    UserId = 'userId',
    VisitTimestamp = 'visitTimestamp',
}

export type UserPracticeVisitScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<UserPracticeVisitScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<UserPracticeVisitScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<UserPracticeVisitScalarWhereWithAggregatesInput>>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    practiceId?: InputMaybe<IntWithAggregatesFilter>;
    userId?: InputMaybe<UuidWithAggregatesFilter>;
    visitTimestamp?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type UserPracticeVisitSumAggregate = {
    __typename?: 'UserPracticeVisitSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    practiceId?: Maybe<Scalars['Int']['output']>;
};

export type UserPracticeVisitSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    practiceId?: InputMaybe<SortOrder>;
};

export type UserPracticeVisitUpdateInput = {
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
    visitTimestamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserPracticeVisitUpdateManyMutationInput = {
    practiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
    userId?: InputMaybe<StringFieldUpdateOperationsInput>;
    visitTimestamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserPracticeVisitUserIdPracticeIdCompoundUniqueInput = {
    practiceId: Scalars['Int']['input'];
    userId: Scalars['String']['input'];
};

export type UserPracticeVisitWhereInput = {
    AND?: InputMaybe<Array<UserPracticeVisitWhereInput>>;
    NOT?: InputMaybe<Array<UserPracticeVisitWhereInput>>;
    OR?: InputMaybe<Array<UserPracticeVisitWhereInput>>;
    id?: InputMaybe<IntFilter>;
    practiceId?: InputMaybe<IntFilter>;
    userId?: InputMaybe<UuidFilter>;
    visitTimestamp?: InputMaybe<DateTimeFilter>;
};

export type UserPracticeVisitWhereUniqueInput = {
    AND?: InputMaybe<Array<UserPracticeVisitWhereInput>>;
    NOT?: InputMaybe<Array<UserPracticeVisitWhereInput>>;
    OR?: InputMaybe<Array<UserPracticeVisitWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    practiceId?: InputMaybe<IntFilter>;
    userId?: InputMaybe<UuidFilter>;
    userId_practiceId?: InputMaybe<UserPracticeVisitUserIdPracticeIdCompoundUniqueInput>;
    visitTimestamp?: InputMaybe<DateTimeFilter>;
};

export type UserRelationFilter = {
    is?: InputMaybe<UserWhereInput>;
    isNot?: InputMaybe<UserWhereInput>;
};

export enum UserScalarFieldEnum {
    CreatedAt = 'createdAt',
    DisableMessaging = 'disableMessaging',
    Email = 'email',
    Firstname = 'firstname',
    Id = 'id',
    LastUpdatedBy = 'lastUpdatedBy',
    Lastname = 'lastname',
    OrgId = 'orgId',
    Phone = 'phone',
    PrimaryConsumerId = 'primaryConsumerId',
    PrimaryLanguage = 'primaryLanguage',
    StripeCustomerId = 'stripeCustomerId',
    UpdatedAt = 'updatedAt',
    UserAccountStatus = 'userAccountStatus',
    VerifiedFlag = 'verifiedFlag',
}

export type UserScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    disableMessaging?: InputMaybe<BoolWithAggregatesFilter>;
    email?: InputMaybe<StringNullableWithAggregatesFilter>;
    firstname?: InputMaybe<StringWithAggregatesFilter>;
    id?: InputMaybe<UuidWithAggregatesFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
    lastname?: InputMaybe<StringWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    phone?: InputMaybe<StringNullableWithAggregatesFilter>;
    primaryConsumerId?: InputMaybe<UuidNullableWithAggregatesFilter>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeWithAggregatesFilter>;
    stripeCustomerId?: InputMaybe<StringNullableWithAggregatesFilter>;
    updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    userAccountStatus?: InputMaybe<EnumUserAccountStatusNullableWithAggregatesFilter>;
    verifiedFlag?: InputMaybe<BoolWithAggregatesFilter>;
};

export type UserSumAggregate = {
    __typename?: 'UserSumAggregate';
    orgId?: Maybe<Scalars['Int']['output']>;
};

export type UserSumOrderByAggregateInput = {
    orgId?: InputMaybe<SortOrder>;
};

export type UserToNewUser = {
    __typename?: 'UserToNewUser';
    createdAt: Scalars['DateTimeISO']['output'];
    newUser: User;
    newUserId: Scalars['String']['output'];
    oldUserId: Scalars['String']['output'];
};

export type UserToNewUserCountAggregate = {
    __typename?: 'UserToNewUserCountAggregate';
    _all: Scalars['Int']['output'];
    createdAt: Scalars['Int']['output'];
    newUserId: Scalars['Int']['output'];
    oldUserId: Scalars['Int']['output'];
};

export type UserToNewUserCountOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    newUserId?: InputMaybe<SortOrder>;
    oldUserId?: InputMaybe<SortOrder>;
};

export type UserToNewUserCreateInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    newUser: UserCreateNestedOneWithoutMergedFromInput;
    oldUserId: Scalars['String']['input'];
};

export type UserToNewUserCreateManyInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    newUserId: Scalars['String']['input'];
    oldUserId: Scalars['String']['input'];
};

export type UserToNewUserCreateManyNewUserInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    oldUserId: Scalars['String']['input'];
};

export type UserToNewUserCreateManyNewUserInputEnvelope = {
    data: Array<UserToNewUserCreateManyNewUserInput>;
    skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserToNewUserCreateNestedManyWithoutNewUserInput = {
    connect?: InputMaybe<Array<UserToNewUserWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<UserToNewUserCreateOrConnectWithoutNewUserInput>
    >;
    create?: InputMaybe<Array<UserToNewUserCreateWithoutNewUserInput>>;
    createMany?: InputMaybe<UserToNewUserCreateManyNewUserInputEnvelope>;
};

export type UserToNewUserCreateOrConnectWithoutNewUserInput = {
    create: UserToNewUserCreateWithoutNewUserInput;
    where: UserToNewUserWhereUniqueInput;
};

export type UserToNewUserCreateWithoutNewUserInput = {
    createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
    oldUserId: Scalars['String']['input'];
};

export type UserToNewUserGroupBy = {
    __typename?: 'UserToNewUserGroupBy';
    _count?: Maybe<UserToNewUserCountAggregate>;
    _max?: Maybe<UserToNewUserMaxAggregate>;
    _min?: Maybe<UserToNewUserMinAggregate>;
    createdAt: Scalars['DateTimeISO']['output'];
    newUserId: Scalars['String']['output'];
    oldUserId: Scalars['String']['output'];
};

export type UserToNewUserListRelationFilter = {
    every?: InputMaybe<UserToNewUserWhereInput>;
    none?: InputMaybe<UserToNewUserWhereInput>;
    some?: InputMaybe<UserToNewUserWhereInput>;
};

export type UserToNewUserMaxAggregate = {
    __typename?: 'UserToNewUserMaxAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    newUserId?: Maybe<Scalars['String']['output']>;
    oldUserId?: Maybe<Scalars['String']['output']>;
};

export type UserToNewUserMaxOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    newUserId?: InputMaybe<SortOrder>;
    oldUserId?: InputMaybe<SortOrder>;
};

export type UserToNewUserMinAggregate = {
    __typename?: 'UserToNewUserMinAggregate';
    createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
    newUserId?: Maybe<Scalars['String']['output']>;
    oldUserId?: Maybe<Scalars['String']['output']>;
};

export type UserToNewUserMinOrderByAggregateInput = {
    createdAt?: InputMaybe<SortOrder>;
    newUserId?: InputMaybe<SortOrder>;
    oldUserId?: InputMaybe<SortOrder>;
};

export type UserToNewUserOrderByRelationAggregateInput = {
    _count?: InputMaybe<SortOrder>;
};

export type UserToNewUserOrderByWithAggregationInput = {
    _count?: InputMaybe<UserToNewUserCountOrderByAggregateInput>;
    _max?: InputMaybe<UserToNewUserMaxOrderByAggregateInput>;
    _min?: InputMaybe<UserToNewUserMinOrderByAggregateInput>;
    createdAt?: InputMaybe<SortOrder>;
    newUserId?: InputMaybe<SortOrder>;
    oldUserId?: InputMaybe<SortOrder>;
};

export type UserToNewUserOrderByWithRelationInput = {
    createdAt?: InputMaybe<SortOrder>;
    newUser?: InputMaybe<UserOrderByWithRelationInput>;
    newUserId?: InputMaybe<SortOrder>;
    oldUserId?: InputMaybe<SortOrder>;
};

export enum UserToNewUserScalarFieldEnum {
    CreatedAt = 'createdAt',
    NewUserId = 'newUserId',
    OldUserId = 'oldUserId',
}

export type UserToNewUserScalarWhereInput = {
    AND?: InputMaybe<Array<UserToNewUserScalarWhereInput>>;
    NOT?: InputMaybe<Array<UserToNewUserScalarWhereInput>>;
    OR?: InputMaybe<Array<UserToNewUserScalarWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    newUserId?: InputMaybe<UuidFilter>;
    oldUserId?: InputMaybe<UuidFilter>;
};

export type UserToNewUserScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<UserToNewUserScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<UserToNewUserScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<UserToNewUserScalarWhereWithAggregatesInput>>;
    createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
    newUserId?: InputMaybe<UuidWithAggregatesFilter>;
    oldUserId?: InputMaybe<UuidWithAggregatesFilter>;
};

export type UserToNewUserUpdateInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    newUser?: InputMaybe<UserUpdateOneRequiredWithoutMergedFromNestedInput>;
    oldUserId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserToNewUserUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    oldUserId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserToNewUserUpdateManyWithWhereWithoutNewUserInput = {
    data: UserToNewUserUpdateManyMutationInput;
    where: UserToNewUserScalarWhereInput;
};

export type UserToNewUserUpdateManyWithoutNewUserNestedInput = {
    connect?: InputMaybe<Array<UserToNewUserWhereUniqueInput>>;
    connectOrCreate?: InputMaybe<
        Array<UserToNewUserCreateOrConnectWithoutNewUserInput>
    >;
    create?: InputMaybe<Array<UserToNewUserCreateWithoutNewUserInput>>;
    createMany?: InputMaybe<UserToNewUserCreateManyNewUserInputEnvelope>;
    delete?: InputMaybe<Array<UserToNewUserWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<UserToNewUserScalarWhereInput>>;
    disconnect?: InputMaybe<Array<UserToNewUserWhereUniqueInput>>;
    set?: InputMaybe<Array<UserToNewUserWhereUniqueInput>>;
    update?: InputMaybe<
        Array<UserToNewUserUpdateWithWhereUniqueWithoutNewUserInput>
    >;
    updateMany?: InputMaybe<
        Array<UserToNewUserUpdateManyWithWhereWithoutNewUserInput>
    >;
    upsert?: InputMaybe<
        Array<UserToNewUserUpsertWithWhereUniqueWithoutNewUserInput>
    >;
};

export type UserToNewUserUpdateWithWhereUniqueWithoutNewUserInput = {
    data: UserToNewUserUpdateWithoutNewUserInput;
    where: UserToNewUserWhereUniqueInput;
};

export type UserToNewUserUpdateWithoutNewUserInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    oldUserId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserToNewUserUpsertWithWhereUniqueWithoutNewUserInput = {
    create: UserToNewUserCreateWithoutNewUserInput;
    update: UserToNewUserUpdateWithoutNewUserInput;
    where: UserToNewUserWhereUniqueInput;
};

export type UserToNewUserWhereInput = {
    AND?: InputMaybe<Array<UserToNewUserWhereInput>>;
    NOT?: InputMaybe<Array<UserToNewUserWhereInput>>;
    OR?: InputMaybe<Array<UserToNewUserWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    newUser?: InputMaybe<UserRelationFilter>;
    newUserId?: InputMaybe<UuidFilter>;
    oldUserId?: InputMaybe<UuidFilter>;
};

export type UserToNewUserWhereUniqueInput = {
    AND?: InputMaybe<Array<UserToNewUserWhereInput>>;
    NOT?: InputMaybe<Array<UserToNewUserWhereInput>>;
    OR?: InputMaybe<Array<UserToNewUserWhereInput>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    newUser?: InputMaybe<UserRelationFilter>;
    newUserId?: InputMaybe<UuidFilter>;
    oldUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdateInput = {
    consumers?: InputMaybe<ConsumerUpdateManyWithoutUserNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    disableMessaging?: InputMaybe<BoolFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    mergedFrom?: InputMaybe<UserToNewUserUpdateManyWithoutNewUserNestedInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryConsumer?: InputMaybe<ConsumerUpdateOneWithoutUserIfPrimaryConsumerNestedInput>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userAccountStatus?: InputMaybe<NullableEnumUserAccountStatusFieldUpdateOperationsInput>;
    verifiedFlag?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type UserUpdateManyMutationInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    disableMessaging?: InputMaybe<BoolFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userAccountStatus?: InputMaybe<NullableEnumUserAccountStatusFieldUpdateOperationsInput>;
    verifiedFlag?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type UserUpdateOneRequiredWithoutConsumersNestedInput = {
    connect?: InputMaybe<UserWhereUniqueInput>;
    connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutConsumersInput>;
    create?: InputMaybe<UserCreateWithoutConsumersInput>;
    update?: InputMaybe<UserUpdateToOneWithWhereWithoutConsumersInput>;
    upsert?: InputMaybe<UserUpsertWithoutConsumersInput>;
};

export type UserUpdateOneRequiredWithoutMergedFromNestedInput = {
    connect?: InputMaybe<UserWhereUniqueInput>;
    connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMergedFromInput>;
    create?: InputMaybe<UserCreateWithoutMergedFromInput>;
    update?: InputMaybe<UserUpdateToOneWithWhereWithoutMergedFromInput>;
    upsert?: InputMaybe<UserUpsertWithoutMergedFromInput>;
};

export type UserUpdateOneWithoutPrimaryConsumerNestedInput = {
    connect?: InputMaybe<UserWhereUniqueInput>;
    connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPrimaryConsumerInput>;
    create?: InputMaybe<UserCreateWithoutPrimaryConsumerInput>;
    delete?: InputMaybe<UserWhereInput>;
    disconnect?: InputMaybe<UserWhereInput>;
    update?: InputMaybe<UserUpdateToOneWithWhereWithoutPrimaryConsumerInput>;
    upsert?: InputMaybe<UserUpsertWithoutPrimaryConsumerInput>;
};

export type UserUpdateToOneWithWhereWithoutConsumersInput = {
    data: UserUpdateWithoutConsumersInput;
    where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutMergedFromInput = {
    data: UserUpdateWithoutMergedFromInput;
    where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPrimaryConsumerInput = {
    data: UserUpdateWithoutPrimaryConsumerInput;
    where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithoutConsumersInput = {
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    disableMessaging?: InputMaybe<BoolFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    mergedFrom?: InputMaybe<UserToNewUserUpdateManyWithoutNewUserNestedInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryConsumer?: InputMaybe<ConsumerUpdateOneWithoutUserIfPrimaryConsumerNestedInput>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userAccountStatus?: InputMaybe<NullableEnumUserAccountStatusFieldUpdateOperationsInput>;
    verifiedFlag?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutMergedFromInput = {
    consumers?: InputMaybe<ConsumerUpdateManyWithoutUserNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    disableMessaging?: InputMaybe<BoolFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryConsumer?: InputMaybe<ConsumerUpdateOneWithoutUserIfPrimaryConsumerNestedInput>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userAccountStatus?: InputMaybe<NullableEnumUserAccountStatusFieldUpdateOperationsInput>;
    verifiedFlag?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutPrimaryConsumerInput = {
    consumers?: InputMaybe<ConsumerUpdateManyWithoutUserNestedInput>;
    createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    disableMessaging?: InputMaybe<BoolFieldUpdateOperationsInput>;
    email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
    id?: InputMaybe<StringFieldUpdateOperationsInput>;
    lastUpdatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
    mergedFrom?: InputMaybe<UserToNewUserUpdateManyWithoutNewUserNestedInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
    stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
    userAccountStatus?: InputMaybe<NullableEnumUserAccountStatusFieldUpdateOperationsInput>;
    verifiedFlag?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type UserUpsertWithoutConsumersInput = {
    create: UserCreateWithoutConsumersInput;
    update: UserUpdateWithoutConsumersInput;
    where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutMergedFromInput = {
    create: UserCreateWithoutMergedFromInput;
    update: UserUpdateWithoutMergedFromInput;
    where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPrimaryConsumerInput = {
    create: UserCreateWithoutPrimaryConsumerInput;
    update: UserUpdateWithoutPrimaryConsumerInput;
    where?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
    AND?: InputMaybe<Array<UserWhereInput>>;
    NOT?: InputMaybe<Array<UserWhereInput>>;
    OR?: InputMaybe<Array<UserWhereInput>>;
    consumers?: InputMaybe<ConsumerListRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    disableMessaging?: InputMaybe<BoolFilter>;
    email?: InputMaybe<StringNullableFilter>;
    firstname?: InputMaybe<StringFilter>;
    id?: InputMaybe<UuidFilter>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    lastname?: InputMaybe<StringFilter>;
    mergedFrom?: InputMaybe<UserToNewUserListRelationFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    primaryConsumer?: InputMaybe<ConsumerNullableRelationFilter>;
    primaryConsumerId?: InputMaybe<UuidNullableFilter>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userAccountStatus?: InputMaybe<EnumUserAccountStatusNullableFilter>;
    verifiedFlag?: InputMaybe<BoolFilter>;
};

export type UserWhereUniqueInput = {
    AND?: InputMaybe<Array<UserWhereInput>>;
    NOT?: InputMaybe<Array<UserWhereInput>>;
    OR?: InputMaybe<Array<UserWhereInput>>;
    consumers?: InputMaybe<ConsumerListRelationFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    disableMessaging?: InputMaybe<BoolFilter>;
    email?: InputMaybe<StringNullableFilter>;
    firstname?: InputMaybe<StringFilter>;
    id?: InputMaybe<Scalars['String']['input']>;
    lastUpdatedBy?: InputMaybe<StringNullableFilter>;
    lastname?: InputMaybe<StringFilter>;
    mergedFrom?: InputMaybe<UserToNewUserListRelationFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    phone?: InputMaybe<StringNullableFilter>;
    primaryConsumer?: InputMaybe<ConsumerNullableRelationFilter>;
    primaryConsumerId?: InputMaybe<Scalars['String']['input']>;
    primaryLanguage?: InputMaybe<EnumLanguageCodeFilter>;
    stripeCustomerId?: InputMaybe<StringNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
    userAccountStatus?: InputMaybe<EnumUserAccountStatusNullableFilter>;
    verifiedFlag?: InputMaybe<BoolFilter>;
};

export type UuidFilter = {
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<QueryMode>;
    not?: InputMaybe<NestedUuidFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UuidNullableFilter = {
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<QueryMode>;
    not?: InputMaybe<NestedUuidNullableFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UuidNullableWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntNullableFilter>;
    _max?: InputMaybe<NestedStringNullableFilter>;
    _min?: InputMaybe<NestedStringNullableFilter>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<QueryMode>;
    not?: InputMaybe<NestedUuidNullableWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UuidWithAggregatesFilter = {
    _count?: InputMaybe<NestedIntFilter>;
    _max?: InputMaybe<NestedStringFilter>;
    _min?: InputMaybe<NestedStringFilter>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<Scalars['String']['input']>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<QueryMode>;
    not?: InputMaybe<NestedUuidWithAggregatesFilter>;
    notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum VerificationSource {
    Gateway = 'GATEWAY',
    Mongo = 'MONGO',
    Snowflake = 'SNOWFLAKE',
}

export enum VerificationStatus {
    Error = 'ERROR',
    Failing = 'FAILING',
    Passing = 'PASSING',
    Unknown = 'UNKNOWN',
}

export type ValidPayers = {
    __typename?: 'ValidPayers';
    id: Scalars['Int']['output'];
    network: NetworkType;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId: Scalars['String']['output'];
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ValidPayersAvgAggregate = {
    __typename?: 'ValidPayersAvgAggregate';
    id?: Maybe<Scalars['Float']['output']>;
    orgId?: Maybe<Scalars['Float']['output']>;
    providerGroupId?: Maybe<Scalars['Float']['output']>;
};

export type ValidPayersAvgOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ValidPayersCountAggregate = {
    __typename?: 'ValidPayersCountAggregate';
    _all: Scalars['Int']['output'];
    id: Scalars['Int']['output'];
    network: Scalars['Int']['output'];
    npi: Scalars['Int']['output'];
    orgId: Scalars['Int']['output'];
    payerId: Scalars['Int']['output'];
    providerGroupId: Scalars['Int']['output'];
};

export type ValidPayersCountOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    network?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ValidPayersCreateInput = {
    network?: InputMaybe<NetworkType>;
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    payerId: Scalars['String']['input'];
    providerGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidPayersCreateManyInput = {
    id?: InputMaybe<Scalars['Int']['input']>;
    network?: InputMaybe<NetworkType>;
    npi?: InputMaybe<Scalars['String']['input']>;
    orgId?: InputMaybe<Scalars['Int']['input']>;
    payerId: Scalars['String']['input'];
    providerGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidPayersGroupBy = {
    __typename?: 'ValidPayersGroupBy';
    _avg?: Maybe<ValidPayersAvgAggregate>;
    _count?: Maybe<ValidPayersCountAggregate>;
    _max?: Maybe<ValidPayersMaxAggregate>;
    _min?: Maybe<ValidPayersMinAggregate>;
    _sum?: Maybe<ValidPayersSumAggregate>;
    id: Scalars['Int']['output'];
    network: NetworkType;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId: Scalars['String']['output'];
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ValidPayersMaxAggregate = {
    __typename?: 'ValidPayersMaxAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    network?: Maybe<NetworkType>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ValidPayersMaxOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    network?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ValidPayersMinAggregate = {
    __typename?: 'ValidPayersMinAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    network?: Maybe<NetworkType>;
    npi?: Maybe<Scalars['String']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    payerId?: Maybe<Scalars['String']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ValidPayersMinOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    network?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    payerId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ValidPayersOrderByWithAggregationInput = {
    _avg?: InputMaybe<ValidPayersAvgOrderByAggregateInput>;
    _count?: InputMaybe<ValidPayersCountOrderByAggregateInput>;
    _max?: InputMaybe<ValidPayersMaxOrderByAggregateInput>;
    _min?: InputMaybe<ValidPayersMinOrderByAggregateInput>;
    _sum?: InputMaybe<ValidPayersSumOrderByAggregateInput>;
    id?: InputMaybe<SortOrder>;
    network?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    payerId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrderInput>;
};

export type ValidPayersOrderByWithRelationInput = {
    id?: InputMaybe<SortOrder>;
    network?: InputMaybe<SortOrder>;
    npi?: InputMaybe<SortOrderInput>;
    orgId?: InputMaybe<SortOrderInput>;
    payerId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrderInput>;
};

export enum ValidPayersScalarFieldEnum {
    Id = 'id',
    Network = 'network',
    Npi = 'npi',
    OrgId = 'orgId',
    PayerId = 'payerId',
    ProviderGroupId = 'providerGroupId',
}

export type ValidPayersScalarWhereWithAggregatesInput = {
    AND?: InputMaybe<Array<ValidPayersScalarWhereWithAggregatesInput>>;
    NOT?: InputMaybe<Array<ValidPayersScalarWhereWithAggregatesInput>>;
    OR?: InputMaybe<Array<ValidPayersScalarWhereWithAggregatesInput>>;
    id?: InputMaybe<IntWithAggregatesFilter>;
    network?: InputMaybe<EnumNetworkTypeWithAggregatesFilter>;
    npi?: InputMaybe<StringNullableWithAggregatesFilter>;
    orgId?: InputMaybe<IntNullableWithAggregatesFilter>;
    payerId?: InputMaybe<StringWithAggregatesFilter>;
    providerGroupId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type ValidPayersSumAggregate = {
    __typename?: 'ValidPayersSumAggregate';
    id?: Maybe<Scalars['Int']['output']>;
    orgId?: Maybe<Scalars['Int']['output']>;
    providerGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ValidPayersSumOrderByAggregateInput = {
    id?: InputMaybe<SortOrder>;
    orgId?: InputMaybe<SortOrder>;
    providerGroupId?: InputMaybe<SortOrder>;
};

export type ValidPayersUpdateInput = {
    network?: InputMaybe<EnumNetworkTypeFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    providerGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ValidPayersUpdateManyMutationInput = {
    network?: InputMaybe<EnumNetworkTypeFieldUpdateOperationsInput>;
    npi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
    orgId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
    payerId?: InputMaybe<StringFieldUpdateOperationsInput>;
    providerGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ValidPayersWhereInput = {
    AND?: InputMaybe<Array<ValidPayersWhereInput>>;
    NOT?: InputMaybe<Array<ValidPayersWhereInput>>;
    OR?: InputMaybe<Array<ValidPayersWhereInput>>;
    id?: InputMaybe<IntFilter>;
    network?: InputMaybe<EnumNetworkTypeFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    payerId?: InputMaybe<StringFilter>;
    providerGroupId?: InputMaybe<IntNullableFilter>;
};

export type ValidPayersWhereUniqueInput = {
    AND?: InputMaybe<Array<ValidPayersWhereInput>>;
    NOT?: InputMaybe<Array<ValidPayersWhereInput>>;
    OR?: InputMaybe<Array<ValidPayersWhereInput>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    network?: InputMaybe<EnumNetworkTypeFilter>;
    npi?: InputMaybe<StringNullableFilter>;
    orgId?: InputMaybe<IntNullableFilter>;
    payerId?: InputMaybe<StringFilter>;
    providerGroupId?: InputMaybe<IntNullableFilter>;
};

export enum VirtualDayOfReminder {
    ThirtyMinute = 'THIRTY_MINUTE',
    ZeroDay = 'ZERO_DAY',
    ZeroDayAndThirtyMinute = 'ZERO_DAY_AND_THIRTY_MINUTE',
}

export type VirtualLink = {
    __typename?: 'VirtualLink';
    virtualLink: Scalars['String']['output'];
};

export type EhrAppointmentTypeIdToNameEhrAppointmentTypeIdToNameCompoundUniqueInput =
    {
        ehrDepartmentId: Scalars['String']['input'];
        ehrPrimaryAppointmentTypeId: Scalars['String']['input'];
        npi: Scalars['String']['input'];
        orgId: Scalars['Int']['input'];
    };

export enum InsurancesStatusEnum {
    ActiveBenefitsNotReturned = 'ACTIVE_BENEFITS_NOT_RETURNED',
    ActiveOutOfNetwork = 'ACTIVE_OUT_OF_NETWORK',
    ManuallyVerifiedExpired = 'MANUALLY_VERIFIED_EXPIRED',
    Active = 'active',
    Inactive = 'inactive',
    Manuallyverified = 'manuallyverified',
    Unverified = 'unverified',
}

export type GetProvidersByPracticeIdQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetProvidersByPracticeIdQuery = {
    __typename?: 'Query';
    providers: Array<{
        __typename?: 'Provider';
        id: number;
        npiId: string;
        firstName: string;
        lastName: string;
        ehrId?: string | null;
    }>;
};

export type GetProvidersByOrgIdQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetProvidersByOrgIdQuery = {
    __typename?: 'Query';
    providers: Array<{
        __typename?: 'Provider';
        id: number;
        npiId: string;
        firstName: string;
        lastName: string;
        ehrId?: string | null;
        degrees?: string | null;
    }>;
};

export type GetBusinessHoursQueryVariables = Exact<{
    where?: InputMaybe<BusinessHourWhereInput>;
}>;

export type GetBusinessHoursQuery = {
    __typename?: 'Query';
    businessHours: Array<{
        __typename?: 'BusinessHour';
        id: string;
        practiceId: number;
        dayOfWeek: number;
        isEnabled: boolean;
        openTime?: string | null;
        closeTime?: string | null;
    }>;
};

export type UpdateBusinessHoursMutationVariables = Exact<{
    id: Scalars['String']['input'];
    businessHour: BusinessHourUpdateInput;
}>;

export type UpdateBusinessHoursMutation = {
    __typename?: 'Mutation';
    updateOneBusinessHour?: {
        __typename?: 'BusinessHour';
        id: string;
        practiceId: number;
        dayOfWeek: number;
        isEnabled: boolean;
        openTime?: string | null;
        closeTime?: string | null;
    } | null;
};

export type GetTimeBlocksQueryVariables = Exact<{
    where?: InputMaybe<TimeBlockWhereInput>;
}>;

export type GetTimeBlocksQuery = {
    __typename?: 'Query';
    timeBlocks: Array<{
        __typename?: 'TimeBlock';
        id: string;
        providerId: number;
        practiceId: number;
        startTime: any;
        endTime: any;
        available: boolean;
        notes?: string | null;
        label?: string | null;
        isAllDay: boolean;
        category?: TimeBlockCategoryEnum | null;
    }>;
};

export type DeleteOneTimeBlockByIdMutationVariables = Exact<{
    blockId: Scalars['String']['input'];
}>;

export type DeleteOneTimeBlockByIdMutation = {
    __typename?: 'Mutation';
    deleteOneTimeBlock?: { __typename?: 'TimeBlock'; id: string } | null;
};

export type GetSchedulingSlotConfigByPracticeIdQueryVariables = Exact<{
    practiceId: Scalars['Int']['input'];
}>;

export type GetSchedulingSlotConfigByPracticeIdQuery = {
    __typename?: 'Query';
    practice?: {
        __typename?: 'Practice';
        locationName: string;
        schedulingSlotConfig: Array<{
            __typename?: 'SchedulingSlotConfig';
            id: number;
            name: string;
        }>;
    } | null;
};

export type GetSchedulingSlotConfigByOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetSchedulingSlotConfigByOrgIdQuery = {
    __typename?: 'Query';
    schedulingSlotConfigs: Array<{
        __typename?: 'SchedulingSlotConfig';
        id: number;
        ehrAppointmentTypeId?: string | null;
        name: string;
        isVirtual: boolean;
    }>;
};

export type GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables = Exact<{
    ehrVisitId: Scalars['String']['input'];
}>;

export type GetSchedulingSlotConfigByEhrVisitIdIdQuery = {
    __typename?: 'Query';
    schedulingSlotConfigs: Array<{
        __typename?: 'SchedulingSlotConfig';
        name: string;
    }>;
};

export type GetProvidersByProviderGroupIdsQueryVariables = Exact<{
    ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;

export type GetProvidersByProviderGroupIdsQuery = {
    __typename?: 'Query';
    providers: Array<{
        __typename?: 'Provider';
        id: number;
        npiId: string;
        firstName: string;
        lastName: string;
        ehrId?: string | null;
    }>;
};

export type GetProvidersByIdsQueryVariables = Exact<{
    ids: Array<Scalars['Int']['input']>;
}>;

export type GetProvidersByIdsQuery = {
    __typename?: 'Query';
    providers: Array<{
        __typename?: 'Provider';
        id: number;
        npiId: string;
        firstName: string;
        lastName: string;
        title?: string | null;
        degrees?: string | null;
        imageUrl?: string | null;
    }>;
};

export type GetProviderGroupToHrtsByHrtIdsQueryVariables = Exact<{
    ids: Array<Scalars['Int']['input']>;
}>;

export type GetProviderGroupToHrtsByHrtIdsQuery = {
    __typename?: 'Query';
    providerGroupToHrts: Array<{
        __typename?: 'ProviderGroupToHrt';
        notBookable?: boolean | null;
        isActive: boolean;
        providerGroup: {
            __typename?: 'ProviderGroup';
            practiceId: number;
            providerToProviderGroup: Array<{
                __typename?: 'ProviderToProviderGroup';
                providerGroupId: number;
                provider: {
                    __typename?: 'Provider';
                    id: number;
                    npiId: string;
                    firstName: string;
                    lastName: string;
                    title?: string | null;
                    degrees?: string | null;
                    imageUrl?: string | null;
                };
            }>;
        };
    }>;
};

export type GetProviderGroupToHrtsByHrtIdQueryVariables = Exact<{
    hrtId: Scalars['Int']['input'];
}>;

export type GetProviderGroupToHrtsByHrtIdQuery = {
    __typename?: 'Query';
    providerGroupToHrts: Array<{
        __typename?: 'ProviderGroupToHrt';
        notBookable?: boolean | null;
        providerGroup: {
            __typename?: 'ProviderGroup';
            practiceId: number;
            providerToProviderGroup: Array<{
                __typename?: 'ProviderToProviderGroup';
                providerGroupId: number;
                provider: {
                    __typename?: 'Provider';
                    id: number;
                    firstName: string;
                    lastName: string;
                    title?: string | null;
                    degrees?: string | null;
                    imageUrl?: string | null;
                    providerToProviderGroups: Array<{
                        __typename?: 'ProviderToProviderGroup';
                        provider_group: {
                            __typename?: 'ProviderGroup';
                            practiceId: number;
                            providerGroupId: number;
                        };
                    }>;
                };
            }>;
        };
    }>;
};

export type GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables = Exact<{
    hrtId: Scalars['Int']['input'];
    practiceId: Scalars['Int']['input'];
}>;

export type GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery = {
    __typename?: 'Query';
    providerGroupToHrts: Array<{
        __typename?: 'ProviderGroupToHrt';
        notBookable?: boolean | null;
        providerGroup: {
            __typename?: 'ProviderGroup';
            practiceId: number;
            providerToProviderGroup: Array<{
                __typename?: 'ProviderToProviderGroup';
                providerGroupId: number;
                provider: {
                    __typename?: 'Provider';
                    id: number;
                    firstName: string;
                    lastName: string;
                    title?: string | null;
                    degrees?: string | null;
                    imageUrl?: string | null;
                    providerToProviderGroups: Array<{
                        __typename?: 'ProviderToProviderGroup';
                        provider_group: {
                            __typename?: 'ProviderGroup';
                            practiceId: number;
                            providerGroupId: number;
                        };
                    }>;
                };
            }>;
        };
    }>;
};

export type GetProviderByIdQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetProviderByIdQuery = {
    __typename?: 'Query';
    provider?: {
        __typename?: 'Provider';
        id: number;
        npiId: string;
        firstName: string;
        lastName: string;
        ehrId?: string | null;
        imageUrl?: string | null;
        degrees?: string | null;
    } | null;
};

export type GetProviderGroupsByPracticeIdQueryVariables = Exact<{
    id?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetProviderGroupsByPracticeIdQuery = {
    __typename?: 'Query';
    providerGroups: Array<{
        __typename?: 'ProviderGroup';
        providerGroupId: number;
    }>;
};

export type GetProviderGroupsByHrtIdQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetProviderGroupsByHrtIdQuery = {
    __typename?: 'Query';
    providerGroupToHrts: Array<{
        __typename?: 'ProviderGroupToHrt';
        providerGroupId: number;
    }>;
};

export type GetProductByProductIdQueryVariables = Exact<{
    id: Scalars['Int']['input'];
    orgId: Scalars['Int']['input'];
}>;

export type GetProductByProductIdQuery = {
    __typename?: 'Query';
    findFirstProducts?: {
        __typename?: 'Products';
        id: number;
        name: string;
        categoryIds: Array<number>;
        displayMetadata?: any | null;
        product_page_type: ProductPageType;
        product_type: ProductType;
        popularity: number;
        renderConfig: any;
        ProductTranslation: Array<{
            __typename?: 'ProductTranslation';
            name: string;
            displayMetadata?: any | null;
            renderConfig?: any | null;
            languageCode: string;
        }>;
        productToHrt: Array<{
            __typename?: 'ProductToHrt';
            hrtId: number;
            product_component_type: ProductComponentType;
            hrt: {
                __typename?: 'Hrt';
                hrtId: number;
                name: string;
                popularity: number;
                displayName?: string | null;
                displayMetadata?: any | null;
                isBookableOnStorefront: boolean;
                isConsumerFacing: boolean;
                ehrPrimaryAppointmentTypeId: Array<string>;
                productToHrt: Array<{
                    __typename?: 'ProductToHrt';
                    productId: number;
                }>;
                _count?: {
                    __typename?: 'HrtCount';
                    activeProviderGroups: number;
                } | null;
                providerGroupToHrt: Array<{
                    __typename?: 'ProviderGroupToHrt';
                    isActive: boolean;
                    providerGroup: {
                        __typename?: 'ProviderGroup';
                        providerGroupId: number;
                        practiceId: number;
                    };
                }>;
                hrtPaymentType: Array<{
                    __typename?: 'HrtPaymentType';
                    id: number;
                    paymentType: PaymentType;
                }>;
                cash_prices?: {
                    __typename?: 'CashPrice';
                    cashPrice: number;
                } | null;
                HrtTranslation: Array<{
                    __typename?: 'HrtTranslation';
                    name: string;
                    displayName: string;
                    displayMetadata?: any | null;
                    languageCode: string;
                }>;
            };
        }>;
    } | null;
};

export type GetProductsByProductIdsQueryVariables = Exact<{
    ids: Array<Scalars['Int']['input']>;
    orgId: Scalars['Int']['input'];
}>;

export type GetProductsByProductIdsQuery = {
    __typename?: 'Query';
    findManyProducts: Array<{
        __typename?: 'Products';
        id: number;
        name: string;
        categoryIds: Array<number>;
        displayMetadata?: any | null;
        product_page_type: ProductPageType;
        product_type: ProductType;
        popularity: number;
        productToHrt: Array<{
            __typename?: 'ProductToHrt';
            hrtId: number;
            product_component_type: ProductComponentType;
            hrt: {
                __typename?: 'Hrt';
                hrtId: number;
                name: string;
                popularity: number;
                displayName?: string | null;
                displayMetadata?: any | null;
                isConsumerFacing: boolean;
                ehrPrimaryAppointmentTypeId: Array<string>;
                _count?: {
                    __typename?: 'HrtCount';
                    activeProviderGroups: number;
                } | null;
                providerGroupToHrt: Array<{
                    __typename?: 'ProviderGroupToHrt';
                    isActive: boolean;
                    providerGroup: {
                        __typename?: 'ProviderGroup';
                        providerGroupId: number;
                        practiceId: number;
                    };
                }>;
                hrtPaymentType: Array<{
                    __typename?: 'HrtPaymentType';
                    id: number;
                    paymentType: PaymentType;
                }>;
                cash_prices?: {
                    __typename?: 'CashPrice';
                    cashPrice: number;
                } | null;
            };
        }>;
    }>;
};

export type GetUserByPhoneAndOrgQueryVariables = Exact<{
    phone: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
}>;

export type GetUserByPhoneAndOrgQuery = {
    __typename?: 'Query';
    users: Array<{ __typename?: 'User'; id: string; email?: string | null }>;
};

export type GetUserByPhoneAndOrgAndEmailQueryVariables = Exact<{
    phone: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    email: Scalars['String']['input'];
}>;

export type GetUserByPhoneAndOrgAndEmailQuery = {
    __typename?: 'Query';
    users: Array<{ __typename?: 'User'; id: string; email?: string | null }>;
};

export type GetIsUserVerifiedByPhoneNumberQueryVariables = Exact<{
    phone: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
}>;

export type GetIsUserVerifiedByPhoneNumberQuery = {
    __typename?: 'Query';
    users: Array<{ __typename?: 'User'; id: string }>;
};

export type GetMatchingConsumerQueryVariables = Exact<{
    userId: Scalars['String']['input'];
    dob: Scalars['DateTimeISO']['input'];
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
}>;

export type GetMatchingConsumerQuery = {
    __typename?: 'Query';
    consumers: Array<{
        __typename?: 'Consumer';
        id: string;
        firstname: string;
        lastname: string;
        dob: any;
        streetAddress?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        country?: string | null;
        sex?: string | null;
        ehrPatientId?: string | null;
        ehrEnterpriseId?: string | null;
        insurances: Array<{
            __typename?: 'Insurance';
            id: string;
            memberId: string;
            payer: string;
            state?: string | null;
            status: InsurancesStatusEnum;
            planName?: string | null;
            planStartDate?: any | null;
            planEndDate?: any | null;
            insuranceAccountStatus?: InsuranceAccountStatus | null;
            isPrimaryInsurance: boolean;
            priority?: number | null;
        }>;
    }>;
};

export type GetMatchingConsumerWithActiveInsuranceQueryVariables = Exact<{
    userId: Scalars['String']['input'];
    dob: Scalars['DateTimeISO']['input'];
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
}>;

export type GetMatchingConsumerWithActiveInsuranceQuery = {
    __typename?: 'Query';
    consumers: Array<{
        __typename?: 'Consumer';
        id: string;
        firstname: string;
        lastname: string;
        dob: any;
        streetAddress?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        country?: string | null;
        sex?: string | null;
        insurances: Array<{
            __typename?: 'Insurance';
            id: string;
            memberId: string;
            payer: string;
            state?: string | null;
            status: InsurancesStatusEnum;
            planName?: string | null;
            planStartDate?: any | null;
            planEndDate?: any | null;
            insuranceAccountStatus?: InsuranceAccountStatus | null;
            isPrimaryInsurance: boolean;
            priority?: number | null;
        }>;
    }>;
};

export type FindConsumerWithInsuranceByNameAndDobQueryVariables = Exact<{
    dob: Scalars['DateTimeISO']['input'];
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
}>;

export type FindConsumerWithInsuranceByNameAndDobQuery = {
    __typename?: 'Query';
    consumers: Array<{
        __typename?: 'Consumer';
        id: string;
        user: {
            __typename?: 'User';
            orgId?: number | null;
            phone?: string | null;
            email?: string | null;
            id: string;
            primaryLanguage: LanguageCode;
        };
    }>;
};

export type FindConsumerByNameDobAndContactQueryVariables = Exact<{
    dob: Scalars['DateTimeISO']['input'];
    phone?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
}>;

export type FindConsumerByNameDobAndContactQuery = {
    __typename?: 'Query';
    consumers: Array<{
        __typename?: 'Consumer';
        id: string;
        firstname: string;
        lastname: string;
        dob: any;
        consumerAccountStatus: ConsumerAccountStatus;
        user: {
            __typename?: 'User';
            orgId?: number | null;
            phone?: string | null;
            email?: string | null;
            id: string;
            primaryLanguage: LanguageCode;
        };
    }>;
};

export type FindConsumerByContactQueryVariables = Exact<{
    phone?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
}>;

export type FindConsumerByContactQuery = {
    __typename?: 'Query';
    consumers: Array<{
        __typename?: 'Consumer';
        id: string;
        firstname: string;
        lastname: string;
        dob: any;
        ehrPatientId?: string | null;
        consumerAccountStatus: ConsumerAccountStatus;
        user: {
            __typename?: 'User';
            id: string;
            orgId?: number | null;
            phone?: string | null;
            email?: string | null;
            userAccountStatus?: UserAccountStatus | null;
            primaryLanguage: LanguageCode;
        };
        insurances: Array<{
            __typename?: 'Insurance';
            id: string;
            memberId: string;
            payer: string;
            state?: string | null;
            ehrInsuranceId?: string | null;
            status: InsurancesStatusEnum;
            insuranceAccountStatus?: InsuranceAccountStatus | null;
            isPrimaryInsurance: boolean;
            priority?: number | null;
        }>;
    }>;
};

export type GetHrtsQueryVariables = Exact<{
    where?: InputMaybe<HrtWhereInput>;
    orderBy?: InputMaybe<Array<HrtOrderByWithRelationInput>>;
}>;

export type GetHrtsQuery = {
    __typename?: 'Query';
    hrts: Array<{
        __typename?: 'Hrt';
        hrtId: number;
        name: string;
        displayName?: string | null;
        displayMetadata?: any | null;
        ehrPrimaryAppointmentTypeId: Array<string>;
        isConsumerFacing: boolean;
        popularity: number;
        isBookableOnStorefront: boolean;
        customDuration: number;
        productToHrt: Array<{ __typename?: 'ProductToHrt'; productId: number }>;
        _count?: {
            __typename?: 'HrtCount';
            activeProviderGroups: number;
        } | null;
        HrtFlags: Array<{
            __typename?: 'HrtFlags';
            isVirtualVisit: boolean;
            isSurgery: boolean;
            isGlobalBilling: boolean;
            isAnnualVisit: boolean;
            kioskHrtType?: KioskHrtType | null;
        }>;
        hrtPaymentType: Array<{
            __typename?: 'HrtPaymentType';
            paymentType: PaymentType;
        }>;
        cash_prices?: { __typename?: 'CashPrice'; cashPrice: number } | null;
        providerGroupToHrt: Array<{
            __typename?: 'ProviderGroupToHrt';
            isActive: boolean;
            notBookable?: boolean | null;
            providerGroup: {
                __typename?: 'ProviderGroup';
                providerGroupId: number;
                practiceId: number;
            };
        }>;
        HrtTranslation: Array<{
            __typename?: 'HrtTranslation';
            name: string;
            displayName: string;
            displayMetadata?: any | null;
            languageCode: string;
        }>;
    }>;
};

export type GetResourcesFromPricedTreatmentIdsQueryVariables = Exact<{
    pricedTreatmentIds: Array<Scalars['Int']['input']>;
}>;

export type GetResourcesFromPricedTreatmentIdsQuery = {
    __typename?: 'Query';
    pricedTreatments: Array<{
        __typename?: 'PricedTreatment';
        hrt: { __typename?: 'Hrt'; additionalResources?: any | null };
    }>;
};

export type GetAllHrtPaymentTypesForOrgQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetAllHrtPaymentTypesForOrgQuery = {
    __typename?: 'Query';
    hrts: Array<{
        __typename?: 'Hrt';
        hrtId: number;
        ehrPrimaryAppointmentTypeId: Array<string>;
        hrtPaymentType: Array<{
            __typename?: 'HrtPaymentType';
            paymentType: PaymentType;
        }>;
    }>;
};

export type GetAllCategoriesQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetAllCategoriesQuery = {
    __typename?: 'Query';
    findManyProductCategories: Array<{
        __typename?: 'ProductCategories';
        id: number;
        orgId: number;
        name: string;
        displayMetadata?: any | null;
        type: ProductCategoryType;
    }>;
};

export type GetOrgDataByPracticeQueryVariables = Exact<{
    practiceId: Scalars['Int']['input'];
}>;

export type GetOrgDataByPracticeQuery = {
    __typename?: 'Query';
    practice?: {
        __typename?: 'Practice';
        orgId: number;
        org: { __typename?: 'Organization'; orgTitle: string };
    } | null;
};

export type GetOrgFaqDropdownInfoQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetOrgFaqDropdownInfoQuery = {
    __typename?: 'Query';
    findManyFaqDropdowns: Array<{
        __typename?: 'FaqDropdowns';
        orgId: number;
        question: string;
        answer: string;
        priority: number;
    }>;
};

export type GetPracticeByIdQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetPracticeByIdQuery = {
    __typename?: 'Query';
    practice?: {
        __typename?: 'Practice';
        practiceId: number;
        orgId: number;
        address: string;
        googleMapsUrl: string;
        googleMapsEmbed: string;
        locationName: string;
        metadata: any;
        phoneNumber?: string | null;
        ehrLocationId?: string | null;
        timezone: string;
    } | null;
};

export type GetPracticesByIdsQueryVariables = Exact<{
    ids: Array<Scalars['Int']['input']>;
}>;

export type GetPracticesByIdsQuery = {
    __typename?: 'Query';
    practices: Array<{
        __typename?: 'Practice';
        practiceId: number;
        orgId: number;
        address: string;
        googleMapsUrl: string;
        googleMapsEmbed: string;
        locationName: string;
        metadata: any;
        phoneNumber?: string | null;
        ehrLocationId?: string | null;
        isAvailableFromStorefront: boolean;
        timezone: string;
    }>;
};

export type GetPracticeByOrgIdForStorefrontQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetPracticeByOrgIdForStorefrontQuery = {
    __typename?: 'Query';
    findFirstPractice?: {
        __typename?: 'Practice';
        practiceId: number;
        orgId: number;
        address: string;
        googleMapsUrl: string;
        googleMapsEmbed: string;
        locationName: string;
        metadata: any;
        phoneNumber?: string | null;
        ehrLocationId?: string | null;
        timezone: string;
    } | null;
};

export type GetPracticesByOrgIdQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetPracticesByOrgIdQuery = {
    __typename?: 'Query';
    practices: Array<{
        __typename?: 'Practice';
        practiceId: number;
        orgId: number;
        address: string;
        googleMapsUrl: string;
        googleMapsEmbed: string;
        locationName: string;
        metadata: any;
        phoneNumber?: string | null;
        ehrLocationId?: string | null;
        isAvailableFromStorefront: boolean;
        timezone: string;
    }>;
};

export type GetAllOrgsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllOrgsQuery = {
    __typename?: 'Query';
    organizations: Array<{
        __typename?: 'Organization';
        orgName: string;
        orgTitle: string;
    }>;
};

export type GetOrgIdFromOrgTitleQueryVariables = Exact<{
    title?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOrgIdFromOrgTitleQuery = {
    __typename?: 'Query';
    findFirstOrganization?: {
        __typename?: 'Organization';
        id: number;
        orgName: string;
        googleAnalyticsTag?: string | null;
        organizationTranslations: Array<{
            __typename?: 'OrganizationTranslation';
            languageCode: string;
            renderConfig?: any | null;
        }>;
    } | null;
};

export type GetPracticeIdFromOrgTitleQueryVariables = Exact<{
    title?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPracticeIdFromOrgTitleQuery = {
    __typename?: 'Query';
    practices: Array<{ __typename?: 'Practice'; practiceId: number }>;
};

export type GetAllPracticesByOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetAllPracticesByOrgIdQuery = {
    __typename?: 'Query';
    practices: Array<{
        __typename?: 'Practice';
        practiceId: number;
        locationName: string;
        address: string;
        googleMapsEmbed: string;
        googleMapsUrl: string;
        metadata: any;
        ehrLocationId?: string | null;
        phoneNumber?: string | null;
        orgId: number;
        timezone: string;
        providerGroups: Array<{
            __typename?: 'ProviderGroup';
            providerGroupId: number;
        }>;
    }>;
};

export type GetPracticesByOrgIdAndProviderIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
}>;

export type GetPracticesByOrgIdAndProviderIdQuery = {
    __typename?: 'Query';
    practices: Array<{
        __typename?: 'Practice';
        practiceId: number;
        orgId: number;
        address: string;
        googleMapsUrl: string;
        googleMapsEmbed: string;
        locationName: string;
        metadata: any;
        phoneNumber?: string | null;
        ehrLocationId?: string | null;
        timezone: string;
        providerGroups: Array<{
            __typename?: 'ProviderGroup';
            providerGroupId: number;
            providerToProviderGroup: Array<{
                __typename?: 'ProviderToProviderGroup';
                provider: {
                    __typename?: 'Provider';
                    id: number;
                    firstName: string;
                };
            }>;
        }>;
    }>;
};

export type GetOrgAndPracticesByOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetOrgAndPracticesByOrgIdQuery = {
    __typename?: 'Query';
    findFirstOrganization?: {
        __typename?: 'Organization';
        id: number;
        orgName: string;
        orgTitle: string;
        ein: string;
        metadata: any;
        googleAnalyticsTag?: string | null;
        waitingRoomPin: string;
        facebookPixelId?: string | null;
        schedulingType: SchedulingType;
        schedulingTimeWindow: number;
        supportedLanguages: Array<string>;
        practices: Array<{
            __typename?: 'Practice';
            practiceId: number;
            locationName: string;
            address: string;
            googleMapsEmbed: string;
            googleMapsUrl: string;
            metadata: any;
            phoneNumber?: string | null;
            ehrLocationId?: string | null;
            orgId: number;
            timezone: string;
            providerGroups: Array<{
                __typename?: 'ProviderGroup';
                providerGroupId: number;
                providerToProviderGroup: Array<{
                    __typename?: 'ProviderToProviderGroup';
                    provider: {
                        __typename?: 'Provider';
                        id: number;
                        firstName: string;
                    };
                }>;
            }>;
        }>;
    } | null;
};

export type GetOrgByOrgTitleQueryVariables = Exact<{
    orgTitle: Scalars['String']['input'];
}>;

export type GetOrgByOrgTitleQuery = {
    __typename?: 'Query';
    findFirstOrganization?: {
        __typename?: 'Organization';
        id: number;
        orgName: string;
        orgTitle: string;
        ein: string;
        metadata: any;
        googleAnalyticsTag?: string | null;
        facebookPixelId?: string | null;
        storefrontEligibilityMinimumAge?: number | null;
        storefrontEligibilityAllowedStates: Array<State>;
        supportedLanguages: Array<string>;
        practices: Array<{
            __typename?: 'Practice';
            practiceId: number;
            locationName: string;
            address: string;
            googleMapsEmbed: string;
            googleMapsUrl: string;
            metadata: any;
            phoneNumber?: string | null;
            ehrLocationId?: string | null;
            orgId: number;
            timezone: string;
        }>;
        defaultPractices: Array<{
            __typename?: 'DefaultPractice';
            defaultPracticeId: number;
        }>;
    } | null;
};

export type GetOrgConfigFlagByOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
    flagName: Scalars['String']['input'];
}>;

export type GetOrgConfigFlagByOrgIdQuery = {
    __typename?: 'Query';
    orgConfigFlag?: {
        __typename?: 'OrgConfigFlag';
        isEnabled: boolean;
        flagName: string;
    } | null;
};

export type GetAllPayersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllPayersQuery = {
    __typename?: 'Query';
    payers: Array<{
        __typename?: 'Payer';
        id: number;
        payerName: string;
        availityPayerCode?: string | null;
        pverifyPayerCode?: string | null;
        ribbonCarrierName?: string | null;
    }>;
};

export type GetAppointmentForLinkIdQueryVariables = Exact<{
    linkId: Scalars['String']['input'];
}>;

export type GetAppointmentForLinkIdQuery = {
    __typename?: 'Query';
    migratedEncounters: Array<{
        __typename?: 'MigratedEncounter';
        appointmentId?: string | null;
        boughtTreatmentIds: Array<string>;
    }>;
};

export type GetAdminFromIdQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetAdminFromIdQuery = {
    __typename?: 'Query';
    getAdmin?: {
        __typename?: 'Admin';
        email: string;
        id: string;
        role: string;
        orgId: number;
    } | null;
};

export type GetAdminsForOrgQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetAdminsForOrgQuery = {
    __typename?: 'Query';
    admins: Array<{
        __typename?: 'Admin';
        email: string;
        id: string;
        role: string;
        orgId: number;
    }>;
};

export type ConsumerSearchFieldsFragment = {
    __typename?: 'Consumer';
    id: string;
    firstname: string;
    preferredFirstName?: string | null;
    lastname: string;
    preferredLastName?: string | null;
    dob: any;
    ehrPatientId?: string | null;
    user: {
        __typename?: 'User';
        id: string;
        firstname: string;
        lastname: string;
        phone?: string | null;
        email?: string | null;
        createdAt: any;
        primaryConsumerId?: string | null;
        verifiedFlag: boolean;
        orgId?: number | null;
        primaryLanguage: LanguageCode;
    };
    insurances: Array<{
        __typename?: 'Insurance';
        status: InsurancesStatusEnum;
        priority?: number | null;
        insuranceAccountStatus?: InsuranceAccountStatus | null;
    }>;
};

export type GetConsumerByNameQueryVariables = Exact<{
    consumerName: Scalars['String']['input'];
    orgId: Scalars['Float']['input'];
}>;

export type GetConsumerByNameQuery = {
    __typename?: 'Query';
    getConsumerByName?: Array<{
        __typename?: 'Consumer';
        id: string;
        firstname: string;
        preferredFirstName?: string | null;
        lastname: string;
        preferredLastName?: string | null;
        dob: any;
        ehrPatientId?: string | null;
        user: {
            __typename?: 'User';
            id: string;
            firstname: string;
            lastname: string;
            phone?: string | null;
            email?: string | null;
            createdAt: any;
            primaryConsumerId?: string | null;
            verifiedFlag: boolean;
            orgId?: number | null;
            primaryLanguage: LanguageCode;
        };
        insurances: Array<{
            __typename?: 'Insurance';
            status: InsurancesStatusEnum;
            priority?: number | null;
            insuranceAccountStatus?: InsuranceAccountStatus | null;
        }>;
    }> | null;
};

export type GetConsumersByEhrIdQueryVariables = Exact<{
    ehrPatientId: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
}>;

export type GetConsumersByEhrIdQuery = {
    __typename?: 'Query';
    consumers: Array<{
        __typename?: 'Consumer';
        id: string;
        firstname: string;
        preferredFirstName?: string | null;
        lastname: string;
        preferredLastName?: string | null;
        dob: any;
        ehrPatientId?: string | null;
        user: {
            __typename?: 'User';
            id: string;
            firstname: string;
            lastname: string;
            phone?: string | null;
            email?: string | null;
            createdAt: any;
            primaryConsumerId?: string | null;
            verifiedFlag: boolean;
            orgId?: number | null;
            primaryLanguage: LanguageCode;
        };
        insurances: Array<{
            __typename?: 'Insurance';
            status: InsurancesStatusEnum;
            priority?: number | null;
            insuranceAccountStatus?: InsuranceAccountStatus | null;
        }>;
    }>;
};

export type GetConsumerByKioskInformationQueryVariables = Exact<{
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
    dob: Scalars['DateTimeISO']['input'];
    orgId: Scalars['Int']['input'];
}>;

export type GetConsumerByKioskInformationQuery = {
    __typename?: 'Query';
    consumers: Array<{
        __typename?: 'Consumer';
        id: string;
        firstname: string;
        lastname: string;
        dob: any;
        ehrPatientId?: string | null;
        consumerAccountStatus: ConsumerAccountStatus;
        user: {
            __typename?: 'User';
            id: string;
            orgId?: number | null;
            phone?: string | null;
            email?: string | null;
            userAccountStatus?: UserAccountStatus | null;
            primaryLanguage: LanguageCode;
        };
        insurances: Array<{
            __typename?: 'Insurance';
            id: string;
            memberId: string;
            payer: string;
            state?: string | null;
            ehrInsuranceId?: string | null;
            status: InsurancesStatusEnum;
            insuranceAccountStatus?: InsuranceAccountStatus | null;
            isPrimaryInsurance: boolean;
            priority?: number | null;
        }>;
    }>;
};

export type GetConsumersByDobQueryVariables = Exact<{
    dobs: Array<Scalars['DateTimeISO']['input']>;
    orgId: Scalars['Int']['input'];
}>;

export type GetConsumersByDobQuery = {
    __typename?: 'Query';
    consumers: Array<{
        __typename?: 'Consumer';
        id: string;
        firstname: string;
        preferredFirstName?: string | null;
        lastname: string;
        preferredLastName?: string | null;
        dob: any;
        ehrPatientId?: string | null;
        user: {
            __typename?: 'User';
            id: string;
            firstname: string;
            lastname: string;
            phone?: string | null;
            email?: string | null;
            createdAt: any;
            primaryConsumerId?: string | null;
            verifiedFlag: boolean;
            orgId?: number | null;
            primaryLanguage: LanguageCode;
        };
        insurances: Array<{
            __typename?: 'Insurance';
            status: InsurancesStatusEnum;
            priority?: number | null;
            insuranceAccountStatus?: InsuranceAccountStatus | null;
        }>;
    }>;
};

export type GetAllIntakeFormsForOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetAllIntakeFormsForOrgIdQuery = {
    __typename?: 'Query';
    intakeForms: Array<{
        __typename?: 'IntakeForm';
        id: number;
        name: string;
        completionTiming: CompletionTimingType;
    }>;
};

export type CreateInsuranceMutationVariables = Exact<{
    data: CreateInsuranceWithEhrInput;
}>;

export type CreateInsuranceMutation = {
    __typename?: 'Mutation';
    createInsurance: { __typename?: 'CreateInsuranceResponse'; id: string };
};

export type DeactivateInsuranceMutationVariables = Exact<{
    data: DeactivateInsuranceInput;
}>;

export type DeactivateInsuranceMutation = {
    __typename?: 'Mutation';
    deactivateInsurance: {
        __typename?: 'DeactivateInsuranceResponse';
        id: string;
    };
};

export type UpdateInsuranceMutationVariables = Exact<{
    data: UpdateInsuranceInput;
}>;

export type UpdateInsuranceMutation = {
    __typename?: 'Mutation';
    updateInsurance: { __typename?: 'UpdateInsuranceResponse'; id: string };
};

export type GetUserDataFragment = {
    __typename?: 'User';
    id: string;
    firstname: string;
    lastname: string;
    phone?: string | null;
    email?: string | null;
    createdAt: any;
    primaryConsumerId?: string | null;
    verifiedFlag: boolean;
    orgId?: number | null;
    primaryLanguage: LanguageCode;
};

export type GetConsumerDataFragment = {
    __typename?: 'Consumer';
    id: string;
    firstname: string;
    preferredFirstName?: string | null;
    lastname: string;
    preferredLastName?: string | null;
    dob: any;
    createdAt: any;
    streetAddress?: string | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    zip?: string | null;
    sex?: string | null;
    userId: string;
    ehrPatientId?: string | null;
    ehrEnterpriseId?: string | null;
    race: Array<Race>;
    ethnicity?: Ethnicity | null;
    maritalStatus?: MaritalStatus | null;
    employmentStatus?: EmploymentStatus | null;
    referralSource?: string | null;
    referralSourceId?: string | null;
    referralSourceDetail?: string | null;
    pharmacyName?: string | null;
    pharmacyPhone?: string | null;
    pharmacyAddress?: any | null;
    pharmacyEhrId?: string | null;
    pcpFirstName?: string | null;
    pcpLastName?: string | null;
    pcpPhone?: string | null;
    pcpAddress?: any | null;
    pcpEhrId?: string | null;
    emergencyContactFirstName?: string | null;
    emergencyContactLastName?: string | null;
    emergencyContactRelationship?: EmergencyContactRelationship | null;
    emergencyContactPhone?: string | null;
    stripeCustomerId?: string | null;
};

export type GetInsuranceDataFragment = {
    __typename?: 'Insurance';
    id: string;
    memberId: string;
    payer: string;
    state?: string | null;
    isPrimaryInsurance: boolean;
    status: InsurancesStatusEnum;
    lastCheckedAt: any;
    insuranceAccountStatus?: InsuranceAccountStatus | null;
    priority?: number | null;
    insuredFirstName?: string | null;
    insuredLastName?: string | null;
    planName?: string | null;
    planStartDate?: any | null;
    planEndDate?: any | null;
    pcpName?: string | null;
    subscriberInfo?: any | null;
    otherInsurances?: any | null;
    pcpCopayAmount?: number | null;
    specialistCopayAmount?: number | null;
    pcpCoinsurancePercentage?: number | null;
};

export type GetUserByUserIdQueryVariables = Exact<{
    id: Scalars['String']['input'];
    includeConsumers?: InputMaybe<Scalars['Boolean']['input']>;
    includeInsurances?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetUserByUserIdQuery = {
    __typename?: 'Query';
    user?: {
        __typename?: 'User';
        id: string;
        firstname: string;
        lastname: string;
        phone?: string | null;
        email?: string | null;
        createdAt: any;
        primaryConsumerId?: string | null;
        verifiedFlag: boolean;
        orgId?: number | null;
        primaryLanguage: LanguageCode;
        consumers?: Array<{
            __typename?: 'Consumer';
            id: string;
            firstname: string;
            preferredFirstName?: string | null;
            lastname: string;
            preferredLastName?: string | null;
            dob: any;
            createdAt: any;
            streetAddress?: string | null;
            city?: string | null;
            state?: string | null;
            country?: string | null;
            zip?: string | null;
            sex?: string | null;
            userId: string;
            ehrPatientId?: string | null;
            ehrEnterpriseId?: string | null;
            race: Array<Race>;
            ethnicity?: Ethnicity | null;
            maritalStatus?: MaritalStatus | null;
            employmentStatus?: EmploymentStatus | null;
            referralSource?: string | null;
            referralSourceId?: string | null;
            referralSourceDetail?: string | null;
            pharmacyName?: string | null;
            pharmacyPhone?: string | null;
            pharmacyAddress?: any | null;
            pharmacyEhrId?: string | null;
            pcpFirstName?: string | null;
            pcpLastName?: string | null;
            pcpPhone?: string | null;
            pcpAddress?: any | null;
            pcpEhrId?: string | null;
            emergencyContactFirstName?: string | null;
            emergencyContactLastName?: string | null;
            emergencyContactRelationship?: EmergencyContactRelationship | null;
            emergencyContactPhone?: string | null;
            stripeCustomerId?: string | null;
            insurances?: Array<{
                __typename?: 'Insurance';
                id: string;
                memberId: string;
                payer: string;
                state?: string | null;
                isPrimaryInsurance: boolean;
                status: InsurancesStatusEnum;
                lastCheckedAt: any;
                insuranceAccountStatus?: InsuranceAccountStatus | null;
                priority?: number | null;
                insuredFirstName?: string | null;
                insuredLastName?: string | null;
                planName?: string | null;
                planStartDate?: any | null;
                planEndDate?: any | null;
                pcpName?: string | null;
                subscriberInfo?: any | null;
                otherInsurances?: any | null;
                pcpCopayAmount?: number | null;
                specialistCopayAmount?: number | null;
                pcpCoinsurancePercentage?: number | null;
            }>;
        }>;
    } | null;
};

export type GetUserByPhoneNumberQueryVariables = Exact<{
    phone: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
    includeConsumers?: InputMaybe<Scalars['Boolean']['input']>;
    includeInsurances?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetUserByPhoneNumberQuery = {
    __typename?: 'Query';
    users: Array<{
        __typename?: 'User';
        id: string;
        firstname: string;
        lastname: string;
        phone?: string | null;
        email?: string | null;
        createdAt: any;
        primaryConsumerId?: string | null;
        verifiedFlag: boolean;
        orgId?: number | null;
        primaryLanguage: LanguageCode;
        consumers?: Array<{
            __typename?: 'Consumer';
            id: string;
            firstname: string;
            preferredFirstName?: string | null;
            lastname: string;
            preferredLastName?: string | null;
            dob: any;
            createdAt: any;
            streetAddress?: string | null;
            city?: string | null;
            state?: string | null;
            country?: string | null;
            zip?: string | null;
            sex?: string | null;
            userId: string;
            ehrPatientId?: string | null;
            ehrEnterpriseId?: string | null;
            race: Array<Race>;
            ethnicity?: Ethnicity | null;
            maritalStatus?: MaritalStatus | null;
            employmentStatus?: EmploymentStatus | null;
            referralSource?: string | null;
            referralSourceId?: string | null;
            referralSourceDetail?: string | null;
            pharmacyName?: string | null;
            pharmacyPhone?: string | null;
            pharmacyAddress?: any | null;
            pharmacyEhrId?: string | null;
            pcpFirstName?: string | null;
            pcpLastName?: string | null;
            pcpPhone?: string | null;
            pcpAddress?: any | null;
            pcpEhrId?: string | null;
            emergencyContactFirstName?: string | null;
            emergencyContactLastName?: string | null;
            emergencyContactRelationship?: EmergencyContactRelationship | null;
            emergencyContactPhone?: string | null;
            stripeCustomerId?: string | null;
            insurances?: Array<{
                __typename?: 'Insurance';
                id: string;
                memberId: string;
                payer: string;
                state?: string | null;
                isPrimaryInsurance: boolean;
                status: InsurancesStatusEnum;
                lastCheckedAt: any;
                insuranceAccountStatus?: InsuranceAccountStatus | null;
                priority?: number | null;
                insuredFirstName?: string | null;
                insuredLastName?: string | null;
                planName?: string | null;
                planStartDate?: any | null;
                planEndDate?: any | null;
                pcpName?: string | null;
                subscriberInfo?: any | null;
                otherInsurances?: any | null;
                pcpCopayAmount?: number | null;
                specialistCopayAmount?: number | null;
                pcpCoinsurancePercentage?: number | null;
            }>;
        }>;
    }>;
};

export type GetUserWithMinimalDataQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetUserWithMinimalDataQuery = {
    __typename?: 'Query';
    user?: {
        __typename?: 'User';
        id: string;
        phone?: string | null;
        orgId?: number | null;
        primaryLanguage: LanguageCode;
        primaryConsumerId?: string | null;
        consumers: Array<{ __typename?: 'Consumer'; id: string; dob: any }>;
    } | null;
};

export type GetUserIdByConsumerIdQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetUserIdByConsumerIdQuery = {
    __typename?: 'Query';
    consumer?: { __typename?: 'Consumer'; userId: string } | null;
};

export type GetNewUserIdByOldUserIdQueryVariables = Exact<{
    oldUserId: Scalars['String']['input'];
}>;

export type GetNewUserIdByOldUserIdQuery = {
    __typename?: 'Query';
    userToNewUser?: {
        __typename?: 'UserToNewUser';
        oldUserId: string;
        newUserId: string;
        createdAt: any;
    } | null;
};

export type CheckDobMatchesConsumersQueryVariables = Exact<{
    dob: Scalars['DateTimeISO']['input'];
    consumerIds: Array<Scalars['String']['input']>;
}>;

export type CheckDobMatchesConsumersQuery = {
    __typename?: 'Query';
    consumers: Array<{ __typename?: 'Consumer'; id: string }>;
};

export type GetConsumerByConsumerIdQueryVariables = Exact<{
    id: Scalars['String']['input'];
    includeUser: Scalars['Boolean']['input'];
    isAdmin: Scalars['Boolean']['input'];
    includeInsurances: Scalars['Boolean']['input'];
}>;

export type GetConsumerByConsumerIdQuery = {
    __typename?: 'Query';
    consumer?: {
        __typename?: 'Consumer';
        id: string;
        firstname: string;
        preferredFirstName?: string | null;
        lastname: string;
        preferredLastName?: string | null;
        dob: any;
        createdAt: any;
        streetAddress?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        zip?: string | null;
        sex?: string | null;
        userId: string;
        ehrPatientId?: string | null;
        ehrEnterpriseId?: string | null;
        race: Array<Race>;
        ethnicity?: Ethnicity | null;
        maritalStatus?: MaritalStatus | null;
        employmentStatus?: EmploymentStatus | null;
        referralSource?: string | null;
        referralSourceId?: string | null;
        referralSourceDetail?: string | null;
        pharmacyName?: string | null;
        pharmacyPhone?: string | null;
        pharmacyAddress?: any | null;
        pharmacyEhrId?: string | null;
        pcpFirstName?: string | null;
        pcpLastName?: string | null;
        pcpPhone?: string | null;
        pcpAddress?: any | null;
        pcpEhrId?: string | null;
        emergencyContactFirstName?: string | null;
        emergencyContactLastName?: string | null;
        emergencyContactRelationship?: EmergencyContactRelationship | null;
        emergencyContactPhone?: string | null;
        stripeCustomerId?: string | null;
        user?: {
            __typename?: 'User';
            id: string;
            firstname: string;
            lastname: string;
            phone?: string | null;
            email?: string | null;
            createdAt: any;
            primaryConsumerId?: string | null;
            verifiedFlag: boolean;
            orgId?: number | null;
            primaryLanguage: LanguageCode;
        };
        insurances?: Array<{
            __typename?: 'Insurance';
            id: string;
            memberId: string;
            payer: string;
            state?: string | null;
            isPrimaryInsurance: boolean;
            status: InsurancesStatusEnum;
            lastCheckedAt: any;
            insuranceAccountStatus?: InsuranceAccountStatus | null;
            priority?: number | null;
            insuredFirstName?: string | null;
            insuredLastName?: string | null;
            planName?: string | null;
            planStartDate?: any | null;
            planEndDate?: any | null;
            pcpName?: string | null;
            subscriberInfo?: any | null;
            otherInsurances?: any | null;
            pcpCopayAmount?: number | null;
            specialistCopayAmount?: number | null;
            pcpCoinsurancePercentage?: number | null;
        }>;
        consumerNotes?: Array<{
            __typename?: 'ConsumerNote';
            note: string;
            createdAt: any;
        }>;
    } | null;
};

export type GetInsurancesByInsuranceIdsQueryVariables = Exact<{
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
}>;

export type GetInsurancesByInsuranceIdsQuery = {
    __typename?: 'Query';
    insurances: Array<{
        __typename?: 'Insurance';
        id: string;
        memberId: string;
        payer: string;
        state?: string | null;
        consumerId?: string | null;
        insuranceAccountStatus?: InsuranceAccountStatus | null;
        status: InsurancesStatusEnum;
        lastCheckedAt: any;
        isPrimaryInsurance: boolean;
    }>;
};

export type GetInsuranceByConsumerIdAndExcludeStatusQueryVariables = Exact<{
    id: Scalars['String']['input'];
    insuranceAccountStatus?: InputMaybe<Array<InsuranceAccountStatus>>;
}>;

export type GetInsuranceByConsumerIdAndExcludeStatusQuery = {
    __typename?: 'Query';
    consumer?: {
        __typename?: 'Consumer';
        id: string;
        insurances: Array<{
            __typename?: 'Insurance';
            id: string;
            memberId: string;
            payer: string;
            state?: string | null;
            status: InsurancesStatusEnum;
            planName?: string | null;
            planStartDate?: any | null;
            planEndDate?: any | null;
            isPrimaryInsurance: boolean;
            insuranceAccountStatus?: InsuranceAccountStatus | null;
            insuredFirstName?: string | null;
            insuredLastName?: string | null;
            priority?: number | null;
            subscriberInfo?: any | null;
            otherInsurances?: any | null;
            pcpName?: string | null;
            lastCheckedAt: any;
            pcpCopayAmount?: number | null;
            specialistCopayAmount?: number | null;
            pcpCoinsurancePercentage?: number | null;
            specialistCoinsurancePercentage?: number | null;
        }>;
    } | null;
};

export type UpdateUserAndEhrPatientMutationVariables = Exact<{
    userUpdateInput: UpdateUserInput;
}>;

export type UpdateUserAndEhrPatientMutation = {
    __typename?: 'Mutation';
    updateUserAndEhrPatient: {
        __typename?: 'UpdateUserResponse';
        id: string;
        consumersWithEhrWriteErrors?: Array<string> | null;
    };
};

export type GetSuperscriptQuestionsQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetSuperscriptQuestionsQuery = {
    __typename?: 'Query';
    superscriptIntakeQuestions: Array<{
        __typename?: 'SuperscriptIntakeQuestion';
        id: number;
        questionText: string;
        type: IntakeQuestionType;
        intakeQuestions: Array<{
            __typename?: 'IntakeQuestion';
            id: number;
            orgId: number;
        }>;
    }>;
};

export type GetIntakeQuestionByNameQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
    name: Scalars['String']['input'];
}>;

export type GetIntakeQuestionByNameQuery = {
    __typename?: 'Query';
    intakeQuestion?: {
        __typename?: 'IntakeQuestion';
        id: number;
        questionText: string;
        questionAttributes?: any | null;
        type: IntakeQuestionType;
        orgId: number;
        intakeFormSectionId?: number | null;
        intakeFormSectionOrder?: number | null;
        superscriptIntakeQuestionId?: number | null;
        superscriptIntakeQuestion?: {
            __typename?: 'SuperscriptIntakeQuestion';
            id: number;
            questionText: string;
            type: IntakeQuestionType;
        } | null;
        intakeFormSection?: {
            __typename?: 'IntakeFormSection';
            id: number;
            text: string;
            name: string;
            priority: number;
            intakeFormSectionTranslations: Array<{
                __typename?: 'IntakeFormSectionTranslation';
                languageCode: string;
                text: string;
                name: string;
            }>;
        } | null;
        intakeQuestionTranslations: Array<{
            __typename?: 'IntakeQuestionTranslation';
            languageCode: string;
            questionText: string;
            questionAttributes?: any | null;
        }>;
    } | null;
};

export type GetIntakeQuestionByIdQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetIntakeQuestionByIdQuery = {
    __typename?: 'Query';
    intakeQuestion?: {
        __typename?: 'IntakeQuestion';
        id: number;
        questionText: string;
        questionAttributes?: any | null;
        type: IntakeQuestionType;
        orgId: number;
        intakeFormSectionId?: number | null;
        intakeFormSectionOrder?: number | null;
        superscriptIntakeQuestionId?: number | null;
        superscriptIntakeQuestion?: {
            __typename?: 'SuperscriptIntakeQuestion';
            id: number;
            questionText: string;
            type: IntakeQuestionType;
        } | null;
        intakeFormSection?: {
            __typename?: 'IntakeFormSection';
            id: number;
            text: string;
            name: string;
            priority: number;
            intakeFormSectionTranslations: Array<{
                __typename?: 'IntakeFormSectionTranslation';
                languageCode: string;
                text: string;
                name: string;
            }>;
        } | null;
        intakeQuestionTranslations: Array<{
            __typename?: 'IntakeQuestionTranslation';
            languageCode: string;
            questionText: string;
            questionAttributes?: any | null;
        }>;
    } | null;
};

export type GetIntakeFormByFormIdQueryVariables = Exact<{
    ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;

export type GetIntakeFormByFormIdQuery = {
    __typename?: 'Query';
    intakeForms: Array<{
        __typename?: 'IntakeForm';
        name: string;
        priority: number;
        id: number;
        completionTiming: CompletionTimingType;
        consentTypes: Array<ConsentType>;
        _count?: {
            __typename?: 'IntakeFormCount';
            intakeFormToQuestions: number;
        } | null;
        intakeFormToQuestions: Array<{
            __typename?: 'IntakeFormToQuestion';
            intakeQuestionId: number;
        }>;
    }>;
};

export type GetSavedIntakeResponsesByIdsQueryVariables = Exact<{
    intakeQuestionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
    consumerId: Scalars['String']['input'];
}>;

export type GetSavedIntakeResponsesByIdsQuery = {
    __typename?: 'Query';
    savedIntakeResponses: Array<{
        __typename?: 'SavedIntakeResponse';
        response: string;
        intakeQuestionId: number;
        consumerId: string;
        updatedAt: any;
        intakeQuestion: {
            __typename?: 'IntakeQuestion';
            type: IntakeQuestionType;
        };
    }>;
};

export type GetIntakeFormForOrgQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetIntakeFormForOrgQuery = {
    __typename?: 'Query';
    intakeForms: Array<{
        __typename?: 'IntakeForm';
        id: number;
        autoAddRules: Array<AutoAddRule>;
        name: string;
        refreshPeriodInDays: number;
        intakeFormToQuestions: Array<{
            __typename?: 'IntakeFormToQuestion';
            intakeQuestionId: number;
        }>;
    }>;
};

export type BoughtTreatmentFieldsFragment = {
    __typename?: 'BoughtTreatment';
    id: string;
    name: string;
    consumerId: string;
    pricedTreatmentId: number;
    price: number;
    createdAt: any;
    insuranceIds: Array<string>;
    orgId: number;
    source: EncounterSourceEnum;
    status: BoughtTreatmentStatusEnum;
    updatedAt: any;
    paymentType: PaymentTypeEnum;
    discountCodeApplied?: string | null;
    overrideReason?: string | null;
    lastUpdatedBy?: string | null;
    isVirtual: boolean;
};

export type CreateChargesMutationVariables = Exact<{
    charges: Array<ChargeDto>;
}>;

export type CreateChargesMutation = {
    __typename?: 'Mutation';
    createCharges: Array<{
        __typename?: 'Charge';
        id: string;
        boughtTreatmentId: string;
    }>;
};

export type PayChargesMutationVariables = Exact<{
    transactionMetadata: CreateTransactionRequestDto;
}>;

export type PayChargesMutation = {
    __typename?: 'Mutation';
    payCharges: Array<{
        __typename?: 'Charge';
        id: string;
        transactionId?: string | null;
    }>;
};

export type CancelChargesMutationVariables = Exact<{
    data: CancelChargesDto;
}>;

export type CancelChargesMutation = {
    __typename?: 'Mutation';
    cancelCharges: Array<{ __typename?: 'Charge'; id: string }>;
};

export type GetIntakeFormsAndQuestionsByFormIdsQueryVariables = Exact<{
    ids: Array<Scalars['Int']['input']>;
}>;

export type GetIntakeFormsAndQuestionsByFormIdsQuery = {
    __typename?: 'Query';
    intakeForms: Array<{
        __typename?: 'IntakeForm';
        name: string;
        id: number;
        priority: number;
        consentTypes: Array<ConsentType>;
        intakeFormToQuestions: Array<{
            __typename?: 'IntakeFormToQuestion';
            section?: string | null;
            isRequired: boolean;
            questionNumber: number;
            intakeQuestion: {
                __typename?: 'IntakeQuestion';
                questionText: string;
                questionAttributes?: any | null;
                intakeFormSectionId?: number | null;
                intakeFormSectionOrder?: number | null;
                type: IntakeQuestionType;
                id: number;
                superscriptIntakeQuestion?: {
                    __typename?: 'SuperscriptIntakeQuestion';
                    id: number;
                    questionText: string;
                } | null;
                intakeFormSection?: {
                    __typename?: 'IntakeFormSection';
                    id: number;
                    text: string;
                    name: string;
                    priority: number;
                    intakeFormSectionTranslations: Array<{
                        __typename?: 'IntakeFormSectionTranslation';
                        languageCode: string;
                        text: string;
                        name: string;
                    }>;
                } | null;
                intakeQuestionTranslations: Array<{
                    __typename?: 'IntakeQuestionTranslation';
                    languageCode: string;
                    questionText: string;
                    questionAttributes?: any | null;
                }>;
            };
        }>;
    }>;
};

export type GetExistingSlotsForCalendarQueryVariables = Exact<{
    providerId?: InputMaybe<Scalars['Int']['input']>;
    practiceId?: InputMaybe<Scalars['Int']['input']>;
    startDateTime: Scalars['DateTimeISO']['input'];
    endDateTime: Scalars['DateTimeISO']['input'];
    orgId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetExistingSlotsForCalendarQuery = {
    __typename?: 'Query';
    slots: Array<{
        __typename?: 'Slot';
        id: string;
        ehrSlotId?: string | null;
        startTime: any;
        endTime: any;
        providerId: number;
        practiceId: number;
        status: SlotStatusEnum;
        reviewStatus?: string | null;
        boughtTreatments: Array<{
            __typename?: 'BoughtTreatment';
            name: string;
            consumerId: string;
            orgId: number;
        }>;
        EhrSlot?: {
            __typename?: 'EhrSlot';
            ehrVisitIds: Array<string>;
            ehrLocationId: string;
            scheduleSlotName?: string | null;
            ehrAppointmentTypeId?: string | null;
        } | null;
    }>;
};

export type GetProviderHrtMaxCountsQueryVariables = Exact<{
    providerId: Scalars['Int']['input'];
}>;

export type GetProviderHrtMaxCountsQuery = {
    __typename?: 'Query';
    providerHrtMaxCounts: Array<{
        __typename?: 'ProviderHrtMaxCount';
        id: number;
        maxCount: number;
        providerId: number;
        hrt?: {
            __typename?: 'Hrt';
            hrtId: number;
            orgId: number;
            name: string;
            displayName?: string | null;
        } | null;
    }>;
};

export type GetSlotConfigPracticeByIdQueryVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type GetSlotConfigPracticeByIdQuery = {
    __typename?: 'Query';
    schedulingSlotConfigs: Array<{
        __typename?: 'SchedulingSlotConfig';
        ehrVisitId: string;
        id: number;
        name: string;
        practiceId: number;
    }>;
};

export type GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetAllEnabledOrgConfigFlagsByOrgIdQuery = {
    __typename?: 'Query';
    orgConfigFlags: Array<{
        __typename?: 'OrgConfigFlag';
        flagName: string;
        isEnabled: boolean;
    }>;
};

export type GetProviderOrderingQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetProviderOrderingQuery = {
    __typename?: 'Query';
    providerToOrgs: Array<{
        __typename?: 'ProviderToOrg';
        providerId: number;
        providerHidden: boolean;
        orderNumber: number;
    }>;
};

export type AppointmentFieldsFragment = {
    __typename?: 'Appointment';
    id: string;
    intakeFormIds: Array<number>;
    status: AppointmentStatusEnum;
    slots: Array<{
        __typename?: 'Slot';
        id: string;
        startTime: any;
        endTime: any;
        note?: string | null;
        boughtTreatments: Array<{
            __typename?: 'BoughtTreatment';
            id: string;
            name: string;
            status: BoughtTreatmentStatusEnum;
        }>;
    }>;
};

export type CreateManyConsumerInsurancesMutationVariables = Exact<{
    id: Scalars['String']['input'];
    insurances: Array<InsuranceCreateManyConsumerInput>;
}>;

export type CreateManyConsumerInsurancesMutation = {
    __typename?: 'Mutation';
    updateOneConsumer?: {
        __typename?: 'Consumer';
        id: string;
        insurances: Array<{
            __typename?: 'Insurance';
            id: string;
            memberId: string;
            state?: string | null;
            payer: string;
        }>;
    } | null;
};

export type DetailSlotFieldsFragment = {
    __typename?: 'DetailSlot';
    id: string;
    startTime: any;
    endTime: any;
    consumerId?: string | null;
    provider: any;
    practice: any;
    ehrSlotId?: string | null;
    status: SlotStatusEnum;
    ehrCancellationReason?: string | null;
    note?: string | null;
    noteUpdatedAt: any;
    noteUpdatedBy?: string | null;
    reviewStatus?: string | null;
    virtualLink?: string | null;
    appointment?: {
        __typename?: 'Appointment';
        id: string;
        status: AppointmentStatusEnum;
        intakeFormIds: Array<number>;
        intakeBypassed: boolean;
        completedIntakeFormIds: Array<number>;
        arrivedAt?: any | null;
    } | null;
    EhrSlot?: {
        __typename?: 'EhrSlot';
        id: string;
        scheduleSlotName?: string | null;
        ehrAppointmentTypeId?: string | null;
        isCustomSlot: boolean;
    } | null;
    detailBoughtTreatments: Array<{
        __typename?: 'DetailBoughtTreatment';
        orgId: number;
        id: string;
        price: number;
        insuranceIds: Array<string>;
        pricedTreatmentId: number;
        status: BoughtTreatmentStatusEnum;
        source: EncounterSourceEnum;
        consumerId: string;
        consumer: any;
        name: string;
        paymentType: PaymentTypeEnum;
        charges: Array<any>;
        hrtId: number;
        discountCodeApplied?: string | null;
        overrideReason?: string | null;
        lastUpdatedBy?: string | null;
        reviewStatus?: ReviewStatusEnum | null;
        isVirtual: boolean;
        hrtFlags?: any | null;
    }>;
};

export type RosterSlotFieldsFragment = {
    __typename?: 'RosterSlot';
    id: string;
    startTime: any;
    endTime: any;
    ehrSlotId?: string | null;
    status: SlotStatusEnum;
    practiceId: number;
    practice: any;
    note?: string | null;
    reviewStatus?: string | null;
    virtualLink?: string | null;
    appointment?: {
        __typename?: 'Appointment';
        id: string;
        status: AppointmentStatusEnum;
        intakeFormIds: Array<number>;
        intakeBypassed: boolean;
        completedIntakeFormIds: Array<number>;
        checkedInAt?: any | null;
        arrivedAt?: any | null;
    } | null;
    rosterBoughtTreatments: Array<{
        __typename?: 'RosterBoughtTreatment';
        orgId: number;
        id: string;
        price: number;
        insuranceIds: Array<string>;
        pricedTreatmentId: number;
        status: BoughtTreatmentStatusEnum;
        consumerId: string;
        consumer: any;
        name: string;
        paymentType: PaymentTypeEnum;
        charges: Array<any>;
        discountCodeApplied?: string | null;
        overrideReason?: string | null;
        lastUpdatedBy?: string | null;
        reviewStatus?: ReviewStatusEnum | null;
        isVirtual: boolean;
        hrtFlags?: any | null;
    }>;
};

export type GetAllAppointmentsForConsumerIdForOrgQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
    consumerId: Scalars['String']['input'];
    appointmentStatus?: InputMaybe<Array<AppointmentStatusEnum>>;
    slotStatus?: InputMaybe<Array<SlotStatusEnum>>;
    boughtTreatmentStatuses?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
}>;

export type GetAllAppointmentsForConsumerIdForOrgQuery = {
    __typename?: 'Query';
    detailSlots: Array<{
        __typename?: 'DetailSlot';
        id: string;
        startTime: any;
        endTime: any;
        consumerId?: string | null;
        provider: any;
        practice: any;
        ehrSlotId?: string | null;
        status: SlotStatusEnum;
        ehrCancellationReason?: string | null;
        note?: string | null;
        noteUpdatedAt: any;
        noteUpdatedBy?: string | null;
        reviewStatus?: string | null;
        virtualLink?: string | null;
        appointment?: {
            __typename?: 'Appointment';
            id: string;
            status: AppointmentStatusEnum;
            intakeFormIds: Array<number>;
            intakeBypassed: boolean;
            completedIntakeFormIds: Array<number>;
            arrivedAt?: any | null;
        } | null;
        EhrSlot?: {
            __typename?: 'EhrSlot';
            id: string;
            scheduleSlotName?: string | null;
            ehrAppointmentTypeId?: string | null;
            isCustomSlot: boolean;
        } | null;
        detailBoughtTreatments: Array<{
            __typename?: 'DetailBoughtTreatment';
            orgId: number;
            id: string;
            price: number;
            insuranceIds: Array<string>;
            pricedTreatmentId: number;
            status: BoughtTreatmentStatusEnum;
            source: EncounterSourceEnum;
            consumerId: string;
            consumer: any;
            name: string;
            paymentType: PaymentTypeEnum;
            charges: Array<any>;
            hrtId: number;
            discountCodeApplied?: string | null;
            overrideReason?: string | null;
            lastUpdatedBy?: string | null;
            reviewStatus?: ReviewStatusEnum | null;
            isVirtual: boolean;
            hrtFlags?: any | null;
        }>;
    }>;
};

export type GetInsuranceIdsForUpcomingAppointmentsQueryVariables = Exact<{
    consumerIds: Array<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
}>;

export type GetInsuranceIdsForUpcomingAppointmentsQuery = {
    __typename?: 'Query';
    appointments: Array<{
        __typename?: 'Appointment';
        slots: Array<{
            __typename?: 'Slot';
            id: string;
            practiceId: number;
            boughtTreatments: Array<{
                __typename?: 'BoughtTreatment';
                insuranceIds: Array<string>;
            }>;
        }>;
    }>;
};

export type GetAllAppointmentsForConsumerIdForPracticeQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
    practiceId: Scalars['Int']['input'];
    consumerId: Scalars['String']['input'];
    appointmentStatus?: InputMaybe<Array<AppointmentStatusEnum>>;
    slotStatus?: InputMaybe<Array<SlotStatusEnum>>;
    boughtTreatmentStatuses?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
}>;

export type GetAllAppointmentsForConsumerIdForPracticeQuery = {
    __typename?: 'Query';
    detailSlots: Array<{
        __typename?: 'DetailSlot';
        id: string;
        startTime: any;
        endTime: any;
        consumerId?: string | null;
        provider: any;
        practice: any;
        ehrSlotId?: string | null;
        status: SlotStatusEnum;
        ehrCancellationReason?: string | null;
        note?: string | null;
        noteUpdatedAt: any;
        noteUpdatedBy?: string | null;
        reviewStatus?: string | null;
        virtualLink?: string | null;
        appointment?: {
            __typename?: 'Appointment';
            id: string;
            status: AppointmentStatusEnum;
            intakeFormIds: Array<number>;
            intakeBypassed: boolean;
            completedIntakeFormIds: Array<number>;
            arrivedAt?: any | null;
        } | null;
        EhrSlot?: {
            __typename?: 'EhrSlot';
            id: string;
            scheduleSlotName?: string | null;
            ehrAppointmentTypeId?: string | null;
            isCustomSlot: boolean;
        } | null;
        detailBoughtTreatments: Array<{
            __typename?: 'DetailBoughtTreatment';
            orgId: number;
            id: string;
            price: number;
            insuranceIds: Array<string>;
            pricedTreatmentId: number;
            status: BoughtTreatmentStatusEnum;
            source: EncounterSourceEnum;
            consumerId: string;
            consumer: any;
            name: string;
            paymentType: PaymentTypeEnum;
            charges: Array<any>;
            hrtId: number;
            discountCodeApplied?: string | null;
            overrideReason?: string | null;
            lastUpdatedBy?: string | null;
            reviewStatus?: ReviewStatusEnum | null;
            isVirtual: boolean;
            hrtFlags?: any | null;
        }>;
    }>;
};

export type GetCompletedAppointmentsForConsumersQueryVariables = Exact<{
    consumerIds: Array<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
}>;

export type GetCompletedAppointmentsForConsumersQuery = {
    __typename?: 'Query';
    appointments: Array<{
        __typename?: 'Appointment';
        id: string;
        status: AppointmentStatusEnum;
        claimReturnStatus?: ClaimReturnStatusEnum | null;
        intakeFormIds: Array<number>;
        completedIntakeFormIds: Array<number>;
        slots: Array<{
            __typename?: 'Slot';
            id: string;
            startTime: any;
            providerId: number;
            practiceId: number;
            boughtTreatments: Array<{
                __typename?: 'BoughtTreatment';
                id: string;
                name: string;
                consumerId: string;
                price: number;
                pricedTreatmentId: number;
                orgId: number;
                hrtId?: number | null;
                discountCodeApplied?: string | null;
                status: BoughtTreatmentStatusEnum;
                overrideReason?: string | null;
                lastUpdatedBy?: string | null;
                reviewStatus?: ReviewStatusEnum | null;
                paymentType: PaymentTypeEnum;
            }>;
        }>;
    }>;
};

export type GetAppointmentByIdQueryVariables = Exact<{
    appointmentId: Scalars['String']['input'];
}>;

export type GetAppointmentByIdQuery = {
    __typename?: 'Query';
    appointment?: {
        __typename?: 'Appointment';
        id: string;
        intakeFormIds: Array<number>;
        completedIntakeFormIds: Array<number>;
        status: AppointmentStatusEnum;
        claimReturnStatus?: ClaimReturnStatusEnum | null;
        slots: Array<{
            __typename?: 'Slot';
            id: string;
            startTime: any;
            practiceId: number;
            providerId: number;
            consumerId?: string | null;
            status: SlotStatusEnum;
            virtualLink?: string | null;
            boughtTreatments: Array<{
                __typename?: 'BoughtTreatment';
                id: string;
                name: string;
                consumerId: string;
                orgId: number;
                price: number;
                paymentType: PaymentTypeEnum;
                pricedTreatmentId: number;
                hrtId?: number | null;
                discountCodeApplied?: string | null;
                status: BoughtTreatmentStatusEnum;
                overrideReason?: string | null;
                lastUpdatedBy?: string | null;
                isVirtual: boolean;
                reviewStatus?: ReviewStatusEnum | null;
                insuranceIds: Array<string>;
            }>;
        }>;
    } | null;
};

export type GetAppointmentIntakeFormIdsQueryVariables = Exact<{
    appointmentId: Scalars['String']['input'];
}>;

export type GetAppointmentIntakeFormIdsQuery = {
    __typename?: 'Query';
    appointment?: {
        __typename?: 'Appointment';
        completedIntakeFormIds: Array<number>;
        intakeFormIds: Array<number>;
    } | null;
};

export type GetBoughtTreatmentByIdQueryVariables = Exact<{
    boughtTreatmentId: Scalars['String']['input'];
}>;

export type GetBoughtTreatmentByIdQuery = {
    __typename?: 'Query';
    boughtTreatment?: {
        __typename?: 'BoughtTreatment';
        id: string;
        name: string;
        consumerId: string;
        orgId: number;
        insuranceIds: Array<string>;
        paymentType: PaymentTypeEnum;
        pricedTreatmentId: number;
        discountCodeApplied?: string | null;
        status: BoughtTreatmentStatusEnum;
        overrideReason?: string | null;
        lastUpdatedBy?: string | null;
        isVirtual: boolean;
    } | null;
};

export type GetBoughtTreatmentsByIdsQueryVariables = Exact<{
    boughtTreatmentIds: Array<Scalars['String']['input']>;
}>;

export type GetBoughtTreatmentsByIdsQuery = {
    __typename?: 'Query';
    boughtTreatments: Array<{
        __typename?: 'BoughtTreatment';
        id: string;
        name: string;
        consumerId: string;
        orgId: number;
        insuranceIds: Array<string>;
        paymentType: PaymentTypeEnum;
        pricedTreatmentId: number;
        hrtId?: number | null;
        discountCodeApplied?: string | null;
        price: number;
        status: BoughtTreatmentStatusEnum;
        source: EncounterSourceEnum;
        overrideReason?: string | null;
        lastUpdatedBy?: string | null;
        reviewStatus?: ReviewStatusEnum | null;
        isVirtual: boolean;
    }>;
};

export type GetBoughtTreatmentsByIdsWithSlotsQueryVariables = Exact<{
    boughtTreatmentIds: Array<Scalars['String']['input']>;
}>;

export type GetBoughtTreatmentsByIdsWithSlotsQuery = {
    __typename?: 'Query';
    boughtTreatments: Array<{
        __typename?: 'BoughtTreatment';
        id: string;
        name: string;
        consumerId: string;
        orgId: number;
        insuranceIds: Array<string>;
        paymentType: PaymentTypeEnum;
        pricedTreatmentId: number;
        hrtId?: number | null;
        discountCodeApplied?: string | null;
        price: number;
        status: BoughtTreatmentStatusEnum;
        source: EncounterSourceEnum;
        overrideReason?: string | null;
        lastUpdatedBy?: string | null;
        reviewStatus?: ReviewStatusEnum | null;
        isVirtual: boolean;
        slot?: {
            __typename?: 'Slot';
            id: string;
            startTime: any;
            status: SlotStatusEnum;
            providerId: number;
            appointment?: {
                __typename?: 'Appointment';
                id: string;
                status: AppointmentStatusEnum;
                claimReturnStatus?: ClaimReturnStatusEnum | null;
            } | null;
        } | null;
    }>;
};

export type GetUnscheduledBoughtTreatmentsForConsumersQueryVariables = Exact<{
    consumerIds: Array<Scalars['String']['input']>;
}>;

export type GetUnscheduledBoughtTreatmentsForConsumersQuery = {
    __typename?: 'Query';
    boughtTreatments: Array<{
        __typename?: 'BoughtTreatment';
        id: string;
        name: string;
        orgId: number;
        consumerId: string;
        price: number;
        pricedTreatmentId: number;
        source: EncounterSourceEnum;
        insuranceIds: Array<string>;
        createdAt: any;
        discountCodeApplied?: string | null;
        status: BoughtTreatmentStatusEnum;
        overrideReason?: string | null;
        lastUpdatedBy?: string | null;
        isVirtual: boolean;
    }>;
};

export type GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables =
    Exact<{
        consumerIds: Array<Scalars['String']['input']>;
        statuses?: InputMaybe<Array<BoughtTreatmentStatusEnum>>;
    }>;

export type GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery = {
    __typename?: 'Query';
    detailBoughtTreatments: Array<{
        __typename?: 'DetailBoughtTreatment';
        id: string;
        name: string;
        orgId: number;
        consumerId: string;
        consumer: any;
        price: number;
        pricedTreatmentId: number;
        source: EncounterSourceEnum;
        hrtId: number;
        status: BoughtTreatmentStatusEnum;
        insuranceIds: Array<string>;
        paymentType: PaymentTypeEnum;
        createdAt: any;
        discountCodeApplied?: string | null;
        charges: Array<any>;
        overrideReason?: string | null;
        lastUpdatedBy?: string | null;
        isVirtual: boolean;
        reviewStatus?: ReviewStatusEnum | null;
    }>;
};

export type GetPricedTreatmentsByIdsQueryVariables = Exact<{
    ids: Array<Scalars['Int']['input']>;
}>;

export type GetPricedTreatmentsByIdsQuery = {
    __typename?: 'Query';
    pricedTreatments: Array<{
        __typename?: 'PricedTreatment';
        id: number;
        price: number;
        hrtId: number;
        paymentType: PaymentType;
        metadata?: any | null;
    }>;
};

export type GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables = Exact<{
    practiceId: Scalars['Int']['input'];
    providerId: Scalars['Int']['input'];
}>;

export type GetProviderGroupIdsByPracticeIdAndProviderIdQuery = {
    __typename?: 'Query';
    providerGroups: Array<{
        __typename?: 'ProviderGroup';
        name?: string | null;
        practiceId: number;
        providerGroupId: number;
    }>;
};

export type GetTransactionsForUserQueryVariables = Exact<{
    userId: Scalars['String']['input'];
}>;

export type GetTransactionsForUserQuery = {
    __typename?: 'Query';
    transactions: Array<{
        __typename?: 'Transaction';
        id: string;
        price: any;
        stripePaymentId?: string | null;
        paidDate?: any | null;
        userId: string;
        transactionType: TransactionType;
        paymentMethodType?: PaymentMethodType | null;
        charges: Array<{
            __typename?: 'Charge';
            orgId: number;
            boughtTreatmentId: string;
            total: any;
        }>;
    }>;
};

export type GetTransactionFromTransactionIdQueryVariables = Exact<{
    transactionId: Scalars['String']['input'];
}>;

export type GetTransactionFromTransactionIdQuery = {
    __typename?: 'Query';
    transaction?: {
        __typename?: 'Transaction';
        id: string;
        price: any;
        paidDate?: any | null;
        userId: string;
        transactionType: TransactionType;
        stripePaymentId?: string | null;
        paymentMethodType?: PaymentMethodType | null;
        charges: Array<{
            __typename?: 'Charge';
            id: string;
            boughtTreatmentId: string;
            total: any;
        }>;
    } | null;
};

export type CancelBoughtTreatmentsByIdsMutationVariables = Exact<{
    boughtTreatmentIds: Array<Scalars['String']['input']>;
}>;

export type CancelBoughtTreatmentsByIdsMutation = {
    __typename?: 'Mutation';
    updateManyBoughtTreatment: {
        __typename?: 'AffectedRowsOutput';
        count: number;
    };
};

export type CheckInMutationVariables = Exact<{
    appointmentId: Scalars['String']['input'];
    checkedInBy: Scalars['String']['input'];
}>;

export type CheckInMutation = {
    __typename?: 'Mutation';
    checkIn: {
        __typename?: 'MarkAppointmentStatusResult';
        ehrCheckinSuccessful: boolean;
        appointment: {
            __typename?: 'Appointment';
            id: string;
            status: AppointmentStatusEnum;
            slots: Array<{
                __typename?: 'Slot';
                id: string;
                status: SlotStatusEnum;
            }>;
        };
    };
};

export type GetOutstandingChargesForUserQueryVariables = Exact<{
    userId: Scalars['String']['input'];
}>;

export type GetOutstandingChargesForUserQuery = {
    __typename?: 'Query';
    charges: Array<{
        __typename?: 'Charge';
        id: string;
        boughtTreatmentId: string;
        total: any;
        orgId: number;
        date: any;
        type: string;
        payoutIds: Array<string>;
        payouts: Array<{ __typename?: 'Payout'; id: string }>;
    }>;
};

export type GetTransactionsForBoughtTreatmentsQueryVariables = Exact<{
    boughtTreatmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
}>;

export type GetTransactionsForBoughtTreatmentsQuery = {
    __typename?: 'Query';
    transactions: Array<{
        __typename?: 'Transaction';
        id: string;
        price: any;
        paymentMethodType?: PaymentMethodType | null;
        paidDate?: any | null;
        stripePaymentId?: string | null;
        charges: Array<{
            __typename?: 'Charge';
            id: string;
            boughtTreatmentId: string;
            total: any;
        }>;
    }>;
};

export type GetMissedAppointmentsForConsumersQueryVariables = Exact<{
    consumerIds: Array<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
}>;

export type GetMissedAppointmentsForConsumersQuery = {
    __typename?: 'Query';
    appointments: Array<{
        __typename?: 'Appointment';
        id: string;
        status: AppointmentStatusEnum;
        claimReturnStatus?: ClaimReturnStatusEnum | null;
        intakeFormIds: Array<number>;
        completedIntakeFormIds: Array<number>;
        slots: Array<{
            __typename?: 'Slot';
            id: string;
            startTime: any;
            endTime: any;
            practiceId: number;
            providerId: number;
            status: SlotStatusEnum;
            note?: string | null;
            virtualLink?: string | null;
            boughtTreatments: Array<{
                __typename?: 'BoughtTreatment';
                id: string;
                name: string;
                consumerId: string;
                price: number;
                pricedTreatmentId: number;
                orgId: number;
                hrtId?: number | null;
                discountCodeApplied?: string | null;
                source: EncounterSourceEnum;
                status: BoughtTreatmentStatusEnum;
                paymentType: PaymentTypeEnum;
                overrideReason?: string | null;
                isVirtual: boolean;
                lastUpdatedBy?: string | null;
                reviewStatus?: ReviewStatusEnum | null;
            }>;
        }>;
    }>;
};

export type GetUpcomingAppointmentsForConsumersQueryVariables = Exact<{
    consumerIds: Array<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
}>;

export type GetUpcomingAppointmentsForConsumersQuery = {
    __typename?: 'Query';
    appointments: Array<{
        __typename?: 'Appointment';
        id: string;
        status: AppointmentStatusEnum;
        intakeFormIds: Array<number>;
        completedIntakeFormIds: Array<number>;
        slots: Array<{
            __typename?: 'Slot';
            id: string;
            startTime: any;
            endTime: any;
            practiceId: number;
            providerId: number;
            status: SlotStatusEnum;
            note?: string | null;
            virtualLink?: string | null;
            boughtTreatments: Array<{
                __typename?: 'BoughtTreatment';
                id: string;
                name: string;
                consumerId: string;
                price: number;
                pricedTreatmentId: number;
                orgId: number;
                hrtId?: number | null;
                discountCodeApplied?: string | null;
                source: EncounterSourceEnum;
                status: BoughtTreatmentStatusEnum;
                paymentType: PaymentTypeEnum;
                overrideReason?: string | null;
                isVirtual: boolean;
                lastUpdatedBy?: string | null;
                reviewStatus?: ReviewStatusEnum | null;
            }>;
        }>;
    }>;
};

export type GetUpcomingAppointmentsForAccountQueryVariables = Exact<{
    consumerIds: Array<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
    orgIdNullable?: InputMaybe<IntNullableFilter>;
}>;

export type GetUpcomingAppointmentsForAccountQuery = {
    __typename?: 'Query';
    appointments: Array<{
        __typename?: 'Appointment';
        id: string;
        status: AppointmentStatusEnum;
        claimReturnStatus?: ClaimReturnStatusEnum | null;
        intakeFormIds: Array<number>;
        completedIntakeFormIds: Array<number>;
        slots: Array<{
            __typename?: 'Slot';
            id: string;
            startTime: any;
            endTime: any;
            practiceId: number;
            providerId: number;
            consumerId?: string | null;
            orgId?: number | null;
            status: SlotStatusEnum;
            note?: string | null;
            virtualLink?: string | null;
            boughtTreatments: Array<{
                __typename?: 'BoughtTreatment';
                id: string;
                name: string;
                consumerId: string;
                price: number;
                pricedTreatmentId: number;
                orgId: number;
                hrtId?: number | null;
                discountCodeApplied?: string | null;
                source: EncounterSourceEnum;
                status: BoughtTreatmentStatusEnum;
                paymentType: PaymentTypeEnum;
                overrideReason?: string | null;
                isVirtual: boolean;
                lastUpdatedBy?: string | null;
                reviewStatus?: ReviewStatusEnum | null;
            }>;
        }>;
    }>;
};

export type GetCompletedAppointmentsForAccountQueryVariables = Exact<{
    consumerIds: Array<Scalars['String']['input']>;
    orgId?: InputMaybe<IntFilter>;
    orgIdNullable?: InputMaybe<IntNullableFilter>;
}>;

export type GetCompletedAppointmentsForAccountQuery = {
    __typename?: 'Query';
    appointments: Array<{
        __typename?: 'Appointment';
        id: string;
        status: AppointmentStatusEnum;
        claimReturnStatus?: ClaimReturnStatusEnum | null;
        intakeFormIds: Array<number>;
        completedIntakeFormIds: Array<number>;
        slots: Array<{
            __typename?: 'Slot';
            id: string;
            startTime: any;
            providerId: number;
            practiceId: number;
            consumerId?: string | null;
            orgId?: number | null;
            boughtTreatments: Array<{
                __typename?: 'BoughtTreatment';
                id: string;
                name: string;
                consumerId: string;
                price: number;
                pricedTreatmentId: number;
                orgId: number;
                hrtId?: number | null;
                discountCodeApplied?: string | null;
                status: BoughtTreatmentStatusEnum;
                overrideReason?: string | null;
                lastUpdatedBy?: string | null;
                reviewStatus?: ReviewStatusEnum | null;
                paymentType: PaymentTypeEnum;
            }>;
        }>;
    }>;
};

export type GetExistingSlotsForCalendarCountQueryVariables = Exact<{
    providerId: Scalars['Int']['input'];
    startDateTime: Scalars['DateTimeISO']['input'];
    endDateTime: Scalars['DateTimeISO']['input'];
    orgId: Scalars['Int']['input'];
}>;

export type GetExistingSlotsForCalendarCountQuery = {
    __typename?: 'Query';
    aggregateSlot: {
        __typename?: 'AggregateSlot';
        _count?: { __typename?: 'SlotCountAggregate'; id: number } | null;
    };
};

export type GetUnscheduledTreatmentsCountForOrgQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetUnscheduledTreatmentsCountForOrgQuery = {
    __typename?: 'Query';
    boughtTreatments: Array<{
        __typename?: 'BoughtTreatment';
        id: string;
        consumerId: string;
    }>;
};

export type GetAppointmentCountQueryVariables = Exact<{
    filters: AppointmentWhereInput;
}>;

export type GetAppointmentCountQuery = {
    __typename?: 'Query';
    aggregateAppointment: {
        __typename?: 'AggregateAppointment';
        _count?: {
            __typename?: 'AppointmentCountAggregate';
            id: number;
        } | null;
    };
};

export type GetAppointmentsForOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
    orderBy: SlotOrderByWithRelationInput;
    filters: SlotWhereInput;
}>;

export type GetAppointmentsForOrgIdQuery = {
    __typename?: 'Query';
    rosterSlots: Array<{
        __typename?: 'RosterSlot';
        id: string;
        startTime: any;
        endTime: any;
        ehrSlotId?: string | null;
        status: SlotStatusEnum;
        practiceId: number;
        practice: any;
        note?: string | null;
        reviewStatus?: string | null;
        virtualLink?: string | null;
        appointment?: {
            __typename?: 'Appointment';
            id: string;
            status: AppointmentStatusEnum;
            intakeFormIds: Array<number>;
            intakeBypassed: boolean;
            completedIntakeFormIds: Array<number>;
            checkedInAt?: any | null;
            arrivedAt?: any | null;
        } | null;
        rosterBoughtTreatments: Array<{
            __typename?: 'RosterBoughtTreatment';
            orgId: number;
            id: string;
            price: number;
            insuranceIds: Array<string>;
            pricedTreatmentId: number;
            status: BoughtTreatmentStatusEnum;
            consumerId: string;
            consumer: any;
            name: string;
            paymentType: PaymentTypeEnum;
            charges: Array<any>;
            discountCodeApplied?: string | null;
            overrideReason?: string | null;
            lastUpdatedBy?: string | null;
            reviewStatus?: ReviewStatusEnum | null;
            isVirtual: boolean;
            hrtFlags?: any | null;
        }>;
    }>;
};

export type GetMoreAppointmentsForOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
    orderBy: SlotOrderByWithRelationInput;
    filters: SlotWhereInput;
    cursorId: Scalars['String']['input'];
}>;

export type GetMoreAppointmentsForOrgIdQuery = {
    __typename?: 'Query';
    rosterSlots: Array<{
        __typename?: 'RosterSlot';
        id: string;
        startTime: any;
        endTime: any;
        ehrSlotId?: string | null;
        status: SlotStatusEnum;
        practiceId: number;
        practice: any;
        note?: string | null;
        reviewStatus?: string | null;
        virtualLink?: string | null;
        appointment?: {
            __typename?: 'Appointment';
            id: string;
            status: AppointmentStatusEnum;
            intakeFormIds: Array<number>;
            intakeBypassed: boolean;
            completedIntakeFormIds: Array<number>;
            checkedInAt?: any | null;
            arrivedAt?: any | null;
        } | null;
        rosterBoughtTreatments: Array<{
            __typename?: 'RosterBoughtTreatment';
            orgId: number;
            id: string;
            price: number;
            insuranceIds: Array<string>;
            pricedTreatmentId: number;
            status: BoughtTreatmentStatusEnum;
            consumerId: string;
            consumer: any;
            name: string;
            paymentType: PaymentTypeEnum;
            charges: Array<any>;
            discountCodeApplied?: string | null;
            overrideReason?: string | null;
            lastUpdatedBy?: string | null;
            reviewStatus?: ReviewStatusEnum | null;
            isVirtual: boolean;
            hrtFlags?: any | null;
        }>;
    }>;
};

export type GetOutstandingChargesForBoughtTreatmentsQueryVariables = Exact<{
    boughtTreatmentIds: Array<Scalars['String']['input']>;
}>;

export type GetOutstandingChargesForBoughtTreatmentsQuery = {
    __typename?: 'Query';
    charges: Array<{
        __typename?: 'Charge';
        total: any;
        id: string;
        boughtTreatmentId: string;
    }>;
};

export type GetChargesByBoughtTreatmentIdsQueryVariables = Exact<{
    boughtTreatmentIds: Array<Scalars['String']['input']>;
}>;

export type GetChargesByBoughtTreatmentIdsQuery = {
    __typename?: 'Query';
    charges: Array<{
        __typename?: 'Charge';
        boughtTreatmentId: string;
        total: any;
        date: any;
        id: string;
        transactionId?: string | null;
        userId?: string | null;
    }>;
};

export type GetBoughtTreatmentClaimDetailsQueryVariables = Exact<{
    boughtTreatmentIds: Array<Scalars['String']['input']>;
}>;

export type GetBoughtTreatmentClaimDetailsQuery = {
    __typename?: 'Query';
    boughtTreatmentClaimDetails: Array<{
        __typename?: 'BoughtTreatmentClaimDetail';
        boughtTreatmentId: string;
        swapReason?: PriceSwapReasonEnum | null;
        remarkCodes: Array<string>;
    }>;
};

export type GetConsumerDataQueryVariables = Exact<{
    consumerId: Scalars['String']['input'];
}>;

export type GetConsumerDataQuery = {
    __typename?: 'Query';
    consumer?: {
        __typename?: 'Consumer';
        id: string;
        firstname: string;
        lastname: string;
        dob: any;
        streetAddress?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        zip?: string | null;
        sex?: string | null;
        consumerNotes: Array<{ __typename?: 'ConsumerNote'; note: string }>;
    } | null;
};

export type GetBoughtTreatmentDataQueryVariables = Exact<{
    boughtTreatmentId: Scalars['String']['input'];
}>;

export type GetBoughtTreatmentDataQuery = {
    __typename?: 'Query';
    boughtTreatment?: {
        __typename?: 'BoughtTreatment';
        id: string;
        name: string;
        price: number;
        consumerId: string;
        paymentType: PaymentTypeEnum;
        slot?: { __typename?: 'Slot'; practiceId: number } | null;
    } | null;
};

export type GetUserDataQueryVariables = Exact<{
    userId: Scalars['String']['input'];
}>;

export type GetUserDataQuery = {
    __typename?: 'Query';
    user?: {
        __typename?: 'User';
        id: string;
        firstname: string;
        lastname: string;
        phone?: string | null;
        email?: string | null;
    } | null;
};

export type GetChargeByIdQueryVariables = Exact<{
    chargeId: Scalars['String']['input'];
}>;

export type GetChargeByIdQuery = {
    __typename?: 'Query';
    charge?: {
        __typename?: 'Charge';
        id: string;
        boughtTreatmentId: string;
        type: string;
    } | null;
};

export type GetTransactionsQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetTransactionsQuery = {
    __typename?: 'Query';
    transactions: Array<{
        __typename?: 'Transaction';
        id: string;
        price: any;
        paidDate?: any | null;
        userId: string;
        transactionType: TransactionType;
        charges: Array<{
            __typename?: 'Charge';
            boughtTreatmentId: string;
            total: any;
        }>;
    }>;
};

export type GetPaginatedTransactionsQueryVariables = Exact<{
    where: TransactionWhereInput;
    take: Scalars['Int']['input'];
}>;

export type GetPaginatedTransactionsQuery = {
    __typename?: 'Query';
    transactions: Array<{
        __typename?: 'Transaction';
        id: string;
        userId: string;
        paidDate?: any | null;
        price: any;
        transactionType: TransactionType;
        paymentMethodType?: PaymentMethodType | null;
        externalPaymentReason?: string | null;
        collectedBy?: string | null;
        charges: Array<{
            __typename?: 'Charge';
            id: string;
            boughtTreatmentId: string;
            total: any;
        }>;
    }>;
    totalCount: {
        __typename?: 'AggregateTransaction';
        _count?: {
            __typename?: 'TransactionCountAggregate';
            id: number;
        } | null;
    };
};

export type GetMorePaginatedTransactionsQueryVariables = Exact<{
    where: TransactionWhereInput;
    take: Scalars['Int']['input'];
    cursorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMorePaginatedTransactionsQuery = {
    __typename?: 'Query';
    transactions: Array<{
        __typename?: 'Transaction';
        id: string;
        userId: string;
        paidDate?: any | null;
        price: any;
        transactionType: TransactionType;
        paymentMethodType?: PaymentMethodType | null;
        externalPaymentReason?: string | null;
        collectedBy?: string | null;
        charges: Array<{
            __typename?: 'Charge';
            id: string;
            boughtTreatmentId: string;
            total: any;
        }>;
    }>;
    totalCount: {
        __typename?: 'AggregateTransaction';
        _count?: {
            __typename?: 'TransactionCountAggregate';
            id: number;
        } | null;
    };
};

export type GetMessagesQueryVariables = Exact<{
    where?: InputMaybe<ConsumerMessageWhereInput>;
    take: Scalars['Int']['input'];
}>;

export type GetMessagesQuery = {
    __typename?: 'Query';
    consumerMessages: Array<{
        __typename?: 'ConsumerMessage';
        id: string;
        message: string;
        createdAt: any;
        consumer?: {
            __typename?: 'Consumer';
            firstname: string;
            lastname: string;
        } | null;
        admin?: { __typename?: 'Admin'; email: string } | null;
    }>;
    totalCount: {
        __typename?: 'AggregateConsumerMessage';
        _count?: {
            __typename?: 'ConsumerMessageCountAggregate';
            id: number;
        } | null;
    };
};

export type GetMorePaginatedMessagesQueryVariables = Exact<{
    where?: InputMaybe<ConsumerMessageWhereInput>;
    take: Scalars['Int']['input'];
    cursorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMorePaginatedMessagesQuery = {
    __typename?: 'Query';
    consumerMessages: Array<{
        __typename?: 'ConsumerMessage';
        id: string;
        message: string;
        createdAt: any;
        consumer?: {
            __typename?: 'Consumer';
            firstname: string;
            lastname: string;
        } | null;
        admin?: { __typename?: 'Admin'; email: string } | null;
    }>;
    totalCount: {
        __typename?: 'AggregateConsumerMessage';
        _count?: {
            __typename?: 'ConsumerMessageCountAggregate';
            id: number;
        } | null;
    };
};

export type ConsumerMessageFieldsFragment = {
    __typename?: 'ConsumerMessage';
    id: string;
    consumerId?: string | null;
    orgId?: number | null;
    message: string;
    createdAt: any;
    updatedAt: any;
    adminId?: string | null;
};

export type GetTransfersDataQueryVariables = Exact<{
    take: Scalars['Int']['input'];
    where?: InputMaybe<PayoutWhereInput>;
}>;

export type GetTransfersDataQuery = {
    __typename?: 'Query';
    totalCount: {
        __typename?: 'AggregatePayout';
        _count?: { __typename?: 'PayoutCountAggregate'; id: number } | null;
    };
    payouts: Array<{
        __typename?: 'Payout';
        id: string;
        orgId: number;
        date: any;
        stripeTransferId?: string | null;
        chargeIds: Array<string>;
        price: any;
        transferredAmount?: any | null;
        payoutType: string;
        stripeReversalId?: string | null;
        destinationPayment?: string | null;
        charges: Array<{
            __typename?: 'Charge';
            id: string;
            boughtTreatmentId: string;
        }>;
    }>;
};

export type GetMorePaginatedTransfersQueryVariables = Exact<{
    where: PayoutWhereInput;
    take: Scalars['Int']['input'];
    cursorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMorePaginatedTransfersQuery = {
    __typename?: 'Query';
    payouts: Array<{
        __typename?: 'Payout';
        id: string;
        orgId: number;
        date: any;
        stripeTransferId?: string | null;
        chargeIds: Array<string>;
        price: any;
        transferredAmount?: any | null;
        payoutType: string;
        stripeReversalId?: string | null;
        destinationPayment?: string | null;
        charges: Array<{
            __typename?: 'Charge';
            id: string;
            boughtTreatmentId: string;
        }>;
    }>;
    totalCount: {
        __typename?: 'AggregatePayout';
        _count?: { __typename?: 'PayoutCountAggregate'; id: number } | null;
    };
};

export type TransferFieldsFragment = {
    __typename?: 'Payout';
    id: string;
    orgId: number;
    date: any;
    stripeTransferId?: string | null;
    chargeIds: Array<string>;
    price: any;
    transferredAmount?: any | null;
    payoutType: string;
    stripeReversalId?: string | null;
    destinationPayment?: string | null;
    charges: Array<{
        __typename?: 'Charge';
        id: string;
        boughtTreatmentId: string;
    }>;
};

export type GetLiveTransfersDataQueryVariables = Exact<{
    take: Scalars['Int']['input'];
    where?: InputMaybe<LiveTransfersWhereInput>;
}>;

export type GetLiveTransfersDataQuery = {
    __typename?: 'Query';
    liveTransfers: Array<{
        __typename?: 'LiveTransfers';
        id: string;
        appointmentId?: string | null;
        consumerId?: string | null;
        claimId?: string | null;
        ehrVisitId?: string | null;
        patientOrgEhrId?: string | null;
        dateOfService: any;
        dateOfFirstCommunication?: any | null;
        status?: LiveTransferStatusEnum | null;
        action?: LiveTransferActionEnum | null;
        artNotes: Array<string>;
        patientName?: string | null;
        slotType?: SlotTypeEnum | null;
        dateTransferred?: any | null;
        provider?: string | null;
        location?: string | null;
        treatmentMap?: any | null;
        dateOfLastCommunication?: any | null;
        primaryPayer?: string | null;
        primaryPayerPackage?: string | null;
        secondaryPayer?: string | null;
        secondaryPayerPackage?: string | null;
        originalPrimaryPayerAllowableAmount?: number | null;
        currentPrimaryPayerAllowableAmount?: number | null;
        originalSecondaryPayerAllowableAmount?: number | null;
        currentSecondaryPayerAllowableAmount?: number | null;
        originalPatientResponsibility?: number | null;
        currentPatientResponsibility?: number | null;
        superscriptFeeAmount?: number | null;
        stripeFeeAmount?: number | null;
        grossPayout?: number | null;
        netPayout?: number | null;
        stripeTransferId?: string | null;
        treatmentTypes: Array<PaymentTypeEnum>;
        locationTimezone?: string | null;
        destinationPayment?: string | null;
        orgId?: number | null;
    }>;
    totalCount: {
        __typename?: 'AggregateLiveTransfers';
        _count?: {
            __typename?: 'LiveTransfersCountAggregate';
            id: number;
        } | null;
    };
};

export type GetMorePaginatedLiveTransfersQueryVariables = Exact<{
    where: LiveTransfersWhereInput;
    take: Scalars['Int']['input'];
    cursorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMorePaginatedLiveTransfersQuery = {
    __typename?: 'Query';
    liveTransfers: Array<{
        __typename?: 'LiveTransfers';
        id: string;
        appointmentId?: string | null;
        consumerId?: string | null;
        claimId?: string | null;
        ehrVisitId?: string | null;
        patientOrgEhrId?: string | null;
        dateOfService: any;
        dateOfFirstCommunication?: any | null;
        status?: LiveTransferStatusEnum | null;
        action?: LiveTransferActionEnum | null;
        artNotes: Array<string>;
        patientName?: string | null;
        slotType?: SlotTypeEnum | null;
        dateTransferred?: any | null;
        provider?: string | null;
        location?: string | null;
        treatmentMap?: any | null;
        dateOfLastCommunication?: any | null;
        primaryPayer?: string | null;
        primaryPayerPackage?: string | null;
        secondaryPayer?: string | null;
        secondaryPayerPackage?: string | null;
        originalPrimaryPayerAllowableAmount?: number | null;
        currentPrimaryPayerAllowableAmount?: number | null;
        originalSecondaryPayerAllowableAmount?: number | null;
        currentSecondaryPayerAllowableAmount?: number | null;
        originalPatientResponsibility?: number | null;
        currentPatientResponsibility?: number | null;
        superscriptFeeAmount?: number | null;
        stripeFeeAmount?: number | null;
        grossPayout?: number | null;
        netPayout?: number | null;
        stripeTransferId?: string | null;
        treatmentTypes: Array<PaymentTypeEnum>;
        locationTimezone?: string | null;
        destinationPayment?: string | null;
        orgId?: number | null;
    }>;
    totalCount: {
        __typename?: 'AggregateLiveTransfers';
        _count?: {
            __typename?: 'LiveTransfersCountAggregate';
            id: number;
        } | null;
    };
};

export type LiveTransferFieldsFragment = {
    __typename?: 'LiveTransfers';
    id: string;
    appointmentId?: string | null;
    consumerId?: string | null;
    claimId?: string | null;
    ehrVisitId?: string | null;
    patientOrgEhrId?: string | null;
    dateOfService: any;
    dateOfFirstCommunication?: any | null;
    status?: LiveTransferStatusEnum | null;
    action?: LiveTransferActionEnum | null;
    artNotes: Array<string>;
    patientName?: string | null;
    slotType?: SlotTypeEnum | null;
    dateTransferred?: any | null;
    provider?: string | null;
    location?: string | null;
    treatmentMap?: any | null;
    dateOfLastCommunication?: any | null;
    primaryPayer?: string | null;
    primaryPayerPackage?: string | null;
    secondaryPayer?: string | null;
    secondaryPayerPackage?: string | null;
    originalPrimaryPayerAllowableAmount?: number | null;
    currentPrimaryPayerAllowableAmount?: number | null;
    originalSecondaryPayerAllowableAmount?: number | null;
    currentSecondaryPayerAllowableAmount?: number | null;
    originalPatientResponsibility?: number | null;
    currentPatientResponsibility?: number | null;
    superscriptFeeAmount?: number | null;
    stripeFeeAmount?: number | null;
    grossPayout?: number | null;
    netPayout?: number | null;
    stripeTransferId?: string | null;
    treatmentTypes: Array<PaymentTypeEnum>;
    locationTimezone?: string | null;
    destinationPayment?: string | null;
    orgId?: number | null;
};

export type GetBoughtTreatmentDataForPayoutsQueryVariables = Exact<{
    boughtTreatmentId: Scalars['String']['input'];
}>;

export type GetBoughtTreatmentDataForPayoutsQuery = {
    __typename?: 'Query';
    boughtTreatment?: {
        __typename?: 'BoughtTreatment';
        price: number;
        consumerId: string;
        name: string;
        slot?: {
            __typename?: 'Slot';
            id: string;
            providerId: number;
            startTime: any;
            practiceId: number;
        } | null;
    } | null;
};

export type GetProviderDataForPayoutsQueryVariables = Exact<{
    providerId: Scalars['Int']['input'];
}>;

export type GetProviderDataForPayoutsQuery = {
    __typename?: 'Query';
    providers: Array<{
        __typename?: 'Provider';
        firstName: string;
        lastName: string;
    }>;
};

export type GetLocationDataForPayoutsQueryVariables = Exact<{
    practiceId: Scalars['Int']['input'];
}>;

export type GetLocationDataForPayoutsQuery = {
    __typename?: 'Query';
    practices: Array<{ __typename?: 'Practice'; locationName: string }>;
};

export type GetUnpaidChargesByBoughtTreatmentIdsQueryVariables = Exact<{
    boughtTreatmentIds: Array<Scalars['String']['input']>;
}>;

export type GetUnpaidChargesByBoughtTreatmentIdsQuery = {
    __typename?: 'Query';
    charges: Array<{
        __typename?: 'Charge';
        id: string;
        boughtTreatmentId: string;
        total: any;
        transactionId?: string | null;
        orgId: number;
        date: any;
    }>;
};

export type GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetUnscheduledBoughtTreatmentsByOrgIdQuery = {
    __typename?: 'Query';
    rosterBoughtTreatments: Array<{
        __typename?: 'RosterBoughtTreatment';
        id: string;
        price: number;
        pricedTreatmentId: number;
        insuranceIds: Array<string>;
        name: string;
        source: EncounterSourceEnum;
        consumer: any;
        createdAt: any;
        charges: Array<any>;
        paymentType: PaymentTypeEnum;
        discountCodeApplied?: string | null;
        status: BoughtTreatmentStatusEnum;
    }>;
};

export type GetOneAppointmentByIdQueryVariables = Exact<{
    appointmentId: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
}>;

export type GetOneAppointmentByIdQuery = {
    __typename?: 'Query';
    detailSlots: Array<{
        __typename?: 'DetailSlot';
        id: string;
        startTime: any;
        endTime: any;
        createdAt: any;
        consumerId?: string | null;
        providerId: number;
        practiceId: number;
        ehrSlotId?: string | null;
        practice: any;
        note?: string | null;
        noteUpdatedAt: any;
        noteUpdatedBy?: string | null;
        virtualLink?: string | null;
        appointment?: {
            __typename?: 'Appointment';
            id: string;
            status: AppointmentStatusEnum;
            intakeFormIds: Array<number>;
            completedIntakeFormIds: Array<number>;
        } | null;
        detailBoughtTreatments: Array<{
            __typename?: 'DetailBoughtTreatment';
            id: string;
            name: string;
            price: number;
            pricedTreatmentId: number;
            insuranceIds: Array<string>;
            consumerId: string;
            consumer: any;
            discountCodeApplied?: string | null;
            status: BoughtTreatmentStatusEnum;
            isVirtual: boolean;
        }>;
    }>;
};

export type GetChargesAndTheirStatusesQueryVariables = Exact<{
    boughtTreatmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
}>;

export type GetChargesAndTheirStatusesQuery = {
    __typename?: 'Query';
    all_charges: Array<{
        __typename?: 'Charge';
        id: string;
        total: any;
        transactionId?: string | null;
        slotId?: string | null;
        boughtTreatmentId: string;
        date: any;
    }>;
    unpaid_charges: Array<{
        __typename?: 'Charge';
        id: string;
        total: any;
        transactionId?: string | null;
        slotId?: string | null;
        boughtTreatmentId: string;
    }>;
};

export type GetDiscountCodeByOrgIdAndCodeQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
    code: Scalars['String']['input'];
    hrtIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;

export type GetDiscountCodeByOrgIdAndCodeQuery = {
    __typename?: 'Query';
    findFirstDiscountCodes?: {
        __typename?: 'DiscountCodes';
        code: string;
        discountPercent?: number | null;
        discountDollarAmount?: number | null;
        discountType: DiscountType;
        isActive: boolean;
        appliesToHrts: Array<number>;
    } | null;
};

export type UpdateCompletedAppointmentIntakeFormIdsMutationVariables = Exact<{
    appointmentId: Scalars['String']['input'];
    completedIntakeFormIds: Array<Scalars['Int']['input']>;
}>;

export type UpdateCompletedAppointmentIntakeFormIdsMutation = {
    __typename?: 'Mutation';
    updateOneAppointment?: {
        __typename?: 'Appointment';
        id: string;
        completedIntakeFormIds: Array<number>;
        intakeFormIds: Array<number>;
    } | null;
};

export type UpdateConsumerAndEhrPatientMutationVariables = Exact<{
    ehrLocationId?: InputMaybe<Scalars['String']['input']>;
    data: ConsumerUpdateInput;
    id: Scalars['String']['input'];
}>;

export type UpdateConsumerAndEhrPatientMutation = {
    __typename?: 'Mutation';
    updateConsumerAndEhrPatient: {
        __typename?: 'ConsumerUpdateResponse';
        id: string;
        ehrUpdateResponse?: {
            __typename?: 'EhrUpdateResponse';
            patientUpdateResponse?: any | null;
            pcpUpdateResponse?: any | null;
            pharmacyUpdateResponse?: any | null;
            patientAthenaUpdateResponse?: any | null;
        } | null;
    };
};

export type CreateConsumerAndEhrPatientMutationVariables = Exact<{
    input: ConsumerAndEhrPatientCreateInput;
}>;

export type CreateConsumerAndEhrPatientMutation = {
    __typename?: 'Mutation';
    createConsumerAndEhrPatient: { __typename?: 'Consumer'; id: string };
};

export type GetHolidaysQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
    practiceId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetHolidaysQuery = {
    __typename?: 'Query';
    holidays: Array<{
        __typename?: 'Holiday';
        id: string;
        name: string;
        day: any;
        enabled: boolean;
        practiceIdOverride: Array<number>;
        orgId: number;
    }>;
};

export type GetAllHolidaysQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetAllHolidaysQuery = {
    __typename?: 'Query';
    holidays: Array<{
        __typename?: 'Holiday';
        id: string;
        name: string;
        day: any;
        enabled: boolean;
        practiceIdOverride: Array<number>;
        orgId: number;
    }>;
};

export type CreateHolidayMutationVariables = Exact<{
    data: HolidayCreateInput;
}>;

export type CreateHolidayMutation = {
    __typename?: 'Mutation';
    createOneHoliday: {
        __typename?: 'Holiday';
        id: string;
        name: string;
        day: any;
        enabled: boolean;
        practiceIdOverride: Array<number>;
        orgId: number;
    };
};

export type UpdateHolidayMutationVariables = Exact<{
    id: Scalars['String']['input'];
    data: HolidayUpdateInput;
}>;

export type UpdateHolidayMutation = {
    __typename?: 'Mutation';
    updateOneHoliday?: {
        __typename?: 'Holiday';
        id: string;
        name: string;
        day: any;
        enabled: boolean;
        practiceIdOverride: Array<number>;
        orgId: number;
    } | null;
};

export type DeleteHolidayMutationVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type DeleteHolidayMutation = {
    __typename?: 'Mutation';
    deleteOneHoliday?: { __typename?: 'Holiday'; id: string } | null;
};

export type GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables = Exact<{
    consumerId: Scalars['String']['input'];
    reviewStatus: Array<ReviewStatusEnum>;
}>;

export type GetSlotsWithBoughtTreatmentsWithReviewStatusQuery = {
    __typename?: 'Query';
    slots: Array<{
        __typename?: 'Slot';
        id: string;
        startTime: any;
        endTime: any;
        practiceId: number;
        providerId: number;
        appointmentId: string;
        boughtTreatments: Array<{
            __typename?: 'BoughtTreatment';
            id: string;
            name: string;
            price: number;
            pricedTreatmentId: number;
            reviewStatus?: ReviewStatusEnum | null;
        }>;
    }>;
};

export type GetOrgRenderConfigQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetOrgRenderConfigQuery = {
    __typename?: 'Query';
    findFirstOrganization?: {
        __typename?: 'Organization';
        renderConfig: any;
        organizationTranslations: Array<{
            __typename?: 'OrganizationTranslation';
            languageCode: string;
            renderConfig?: any | null;
        }>;
    } | null;
};

export type GetCategoriesQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetCategoriesQuery = {
    __typename?: 'Query';
    findManyProductCategories: Array<{
        __typename?: 'ProductCategories';
        id: number;
        name: string;
        popularity: number;
        ProductCategoryTranslation: Array<{
            __typename?: 'ProductCategoryTranslation';
            name: string;
            languageCode: string;
        }>;
    }>;
};

export type GetProductCategoryTranslationsQueryVariables = Exact<{
    productCategoryIds: Array<Scalars['Int']['input']>;
}>;

export type GetProductCategoryTranslationsQuery = {
    __typename?: 'Query';
    productCategoryTranslations: Array<{
        __typename?: 'ProductCategoryTranslation';
        productCategoryId: number;
        languageCode: string;
        name: string;
    }>;
};

export type GetProductsByCategoryIdQueryVariables = Exact<{
    categoryIds: Array<Scalars['Int']['input']>;
}>;

export type GetProductsByCategoryIdQuery = {
    __typename?: 'Query';
    findManyProducts: Array<{
        __typename?: 'Products';
        id: number;
        name: string;
        categoryIds: Array<number>;
        displayMetadata?: any | null;
        popularity: number;
        product_type: ProductType;
        orgId: number;
        ProductTranslation: Array<{
            __typename?: 'ProductTranslation';
            name: string;
            displayMetadata?: any | null;
            languageCode: string;
        }>;
        productToHrt: Array<{
            __typename?: 'ProductToHrt';
            product_component_type: ProductComponentType;
            hrt: {
                __typename?: 'Hrt';
                hrtId: number;
                orgId: number;
                isConsumerFacing: boolean;
                name: string;
                ehrPrimaryAppointmentTypeId: Array<string>;
                isBookableOnStorefront: boolean;
                cash_prices?: {
                    __typename?: 'CashPrice';
                    cashPrice: number;
                } | null;
                hrtPaymentType: Array<{
                    __typename?: 'HrtPaymentType';
                    id: number;
                    paymentType: PaymentType;
                }>;
                HrtTranslation: Array<{
                    __typename?: 'HrtTranslation';
                    name: string;
                    displayName: string;
                    displayMetadata?: any | null;
                    languageCode: string;
                }>;
            };
        }>;
    }>;
};

export type GetConsumerPhotosQueryVariables = Exact<{
    consumerId: Scalars['String']['input'];
    orgId: Scalars['Int']['input'];
}>;

export type GetConsumerPhotosQuery = {
    __typename?: 'Query';
    findManyConsumerPhotoMetaData: Array<{
        __typename?: 'ConsumerPhotoMetaData';
        id: string;
        linkedInsuranceId?: string | null;
        type: PhotoType;
        s3Link?: string | null;
        uploadedBy?: string | null;
        uploadedToEhrAt?: any | null;
        associatedPhotoId?: string | null;
        orgId: number;
        status: PhotoStatus;
        ocrMetadata?: any | null;
        insurance?: {
            __typename?: 'Insurance';
            priority?: number | null;
        } | null;
    }>;
};

export type GuarantorPaymentLinkContextFieldsFragment = {
    __typename?: 'GuarantorPaymentLinkContext';
    id: string;
    orgId: number;
    patientName: string;
    guarantorName: string;
    appointmentId: string;
};

export type GetGuarantorPaymentLinkContextQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetGuarantorPaymentLinkContextQuery = {
    __typename?: 'Query';
    guarantorPaymentLinkContext?: {
        __typename?: 'GuarantorPaymentLinkContext';
        id: string;
        orgId: number;
        patientName: string;
        guarantorName: string;
        appointmentId: string;
    } | null;
};

export type EhrAppointmentTypeIdToNamesByOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type EhrAppointmentTypeIdToNamesByOrgIdQuery = {
    __typename?: 'Query';
    ehrAppointmentTypeIdToNames: Array<{
        __typename?: 'EhrAppointmentTypeIdToName';
        orgId?: number | null;
        ehrAppointmentTypeName: string;
        ehrPrimaryAppointmentTypeId: string;
        isGeneric: boolean;
        isVirtual: boolean;
        duration: number;
        id: number;
    }>;
};

export type GetHrtsByBillingCodesQueryVariables = Exact<{
    codes: Array<Scalars['String']['input']>;
    orgId: Scalars['Int']['input'];
}>;

export type GetHrtsByBillingCodesQuery = {
    __typename?: 'Query';
    hrts: Array<{
        __typename?: 'Hrt';
        hrtId: number;
        name: string;
        displayName?: string | null;
        isShownOnCompanion: boolean;
        hrtToSrt: Array<{
            __typename?: 'HrtToSrt';
            srt: {
                __typename?: 'Srt';
                SrtToBillingCode: Array<{
                    __typename?: 'SrtToBillingCode';
                    billingCode: string;
                }>;
            };
        }>;
    }>;
};

export type GetSlotVirtualLinkQueryVariables = Exact<{
    slotId: Scalars['String']['input'];
}>;

export type GetSlotVirtualLinkQuery = {
    __typename?: 'Query';
    getSlotVirtualLink: { __typename?: 'VirtualLink'; virtualLink: string };
};

export type GetContractsForConsumerQueryVariables = Exact<{
    consumerId: Scalars['String']['input'];
}>;

export type GetContractsForConsumerQuery = {
    __typename?: 'Query';
    contracts: Array<{
        __typename?: 'Contract';
        id: string;
        name: string;
        contractType: ContractType;
        policyNumber?: string | null;
        consumerId?: string | null;
        ehrInsuranceId: string;
        status?: ContractStatus | null;
        notes?: string | null;
        contractAccountStatus?: ContractAccountStatus | null;
        patientRelation?: string | null;
        issueDate?: any | null;
        expirationDate?: any | null;
    }>;
};

export type MarkAppointmentAsArrivedMutationVariables = Exact<{
    appointmentId: Scalars['String']['input'];
    markedAsArrivedBy: Scalars['String']['input'];
}>;

export type MarkAppointmentAsArrivedMutation = {
    __typename?: 'Mutation';
    markAppointmentArrived: {
        __typename?: 'MarkAppointmentStatusResult';
        appointment: {
            __typename?: 'Appointment';
            id: string;
            arrivedAt?: any | null;
        };
    };
};

export type UnmarkAppointmentAsArrivedMutationVariables = Exact<{
    appointmentId: Scalars['String']['input'];
    markedAsUnarrivedBy: Scalars['String']['input'];
}>;

export type UnmarkAppointmentAsArrivedMutation = {
    __typename?: 'Mutation';
    markAppointmentUnarrived: {
        __typename?: 'MarkAppointmentStatusResult';
        appointment: {
            __typename?: 'Appointment';
            id: string;
            arrivedAt?: any | null;
        };
    };
};

export type GetPylonAccountIdByOrgIdQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetPylonAccountIdByOrgIdQuery = {
    __typename?: 'Query';
    findFirstOrganization?: {
        __typename?: 'Organization';
        pylonAccountId?: string | null;
    } | null;
};

export type GetOrgStripeMappingsQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetOrgStripeMappingsQuery = {
    __typename?: 'Query';
    org_stripe_mappings: Array<{
        __typename?: 'Org_stripe_mapping';
        orgId: number;
        stripe_account_id: string;
    }>;
};

export type GetOrganizationAssetsQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GetOrganizationAssetsQuery = {
    __typename?: 'Query';
    findManyOrganizationAssets: Array<{
        __typename?: 'OrganizationAssets';
        orgId: number;
        lightModeLogo?: string | null;
        darkModeLogo?: string | null;
        iconLogo?: string | null;
        seoTitle?: string | null;
        seoDescription?: string | null;
        seoImageUrl?: string | null;
        email?: string | null;
        phoneNumber?: string | null;
        org: { __typename?: 'Organization'; orgName: string; orgTitle: string };
    }>;
};

export type GetOrganizationAssetsForOrgQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetOrganizationAssetsForOrgQuery = {
    __typename?: 'Query';
    findManyOrganizationAssets: Array<{
        __typename?: 'OrganizationAssets';
        orgId: number;
        lightModeLogo?: string | null;
        darkModeLogo?: string | null;
        iconLogo?: string | null;
        seoTitle?: string | null;
        seoDescription?: string | null;
        seoImageUrl?: string | null;
        email?: string | null;
        phoneNumber?: string | null;
        primaryColor?: string | null;
        primaryBackgroundColor?: string | null;
        secondaryBackgroundColor?: string | null;
        secondaryColor?: string | null;
        org: { __typename?: 'Organization'; orgName: string; orgTitle: string };
    }>;
};

export type GetOrgPylonAccountIdsQueryVariables = Exact<{
    orgId: Scalars['Int']['input'];
}>;

export type GetOrgPylonAccountIdsQuery = {
    __typename?: 'Query';
    findFirstOrganization?: {
        __typename?: 'Organization';
        pylonAccountId?: string | null;
        patientPylonAccountId?: string | null;
    } | null;
};

export type GetBillingCodesQueryVariables = Exact<{ [key: string]: never }>;

export type GetBillingCodesQuery = {
    __typename?: 'Query';
    billingCodes: Array<{
        __typename?: 'BillingCode';
        billingCode: string;
        description: string;
    }>;
};

export type GetPracticeAndHoursQueryVariables = Exact<{
    practiceId: Scalars['Int']['input'];
}>;

export type GetPracticeAndHoursQuery = {
    __typename?: 'Query';
    practice?: {
        __typename?: 'Practice';
        practiceId: number;
        address: string;
        locationName: string;
        timezone: string;
        practiceHours: Array<{
            __typename?: 'PracticeHours';
            dayOfWeek: DayOfWeek;
            openTime: any;
            closeTime: any;
            deletedAt?: any | null;
            updatedAt: any;
            createdAt: any;
        }>;
        practiceHoursOverrides: Array<{
            __typename?: 'PracticeHoursOverrides';
            date: any;
            openTime?: any | null;
            closeTime?: any | null;
            isClosed: boolean;
            notes?: string | null;
            deletedAt?: any | null;
            updatedAt: any;
            createdAt: any;
        }>;
    } | null;
};

export type GetProviderCredentialingByNpisAndStateQueryVariables = Exact<{
    npiIds: Array<Scalars['String']['input']>;
    state: Scalars['String']['input'];
}>;

export type GetProviderCredentialingByNpisAndStateQuery = {
    __typename?: 'Query';
    providerCredentialings: Array<{
        __typename?: 'ProviderCredentialing';
        npiId: string;
        states: Array<string>;
    }>;
};

export const GetUserDataFragmentDoc = gql`
    fragment getUserData on User {
        id
        firstname
        lastname
        phone
        email
        createdAt
        primaryConsumerId
        verifiedFlag
        orgId
        primaryLanguage
    }
`;
export const ConsumerSearchFieldsFragmentDoc = gql`
    fragment consumerSearchFields on Consumer {
        id
        firstname
        preferredFirstName
        lastname
        preferredLastName
        dob
        ehrPatientId
        user {
            ...getUserData
        }
        insurances {
            status
            priority
            insuranceAccountStatus
        }
    }
    ${GetUserDataFragmentDoc}
`;
export const GetConsumerDataFragmentDoc = gql`
    fragment getConsumerData on Consumer {
        id
        firstname
        preferredFirstName
        lastname
        preferredLastName
        dob
        createdAt
        streetAddress
        city
        state
        country
        zip
        sex
        userId
        ehrPatientId
        ehrEnterpriseId
        race
        ethnicity
        maritalStatus
        employmentStatus
        referralSource
        referralSourceId
        referralSourceDetail
        pharmacyName
        pharmacyPhone
        pharmacyAddress
        pharmacyEhrId
        pcpFirstName
        pcpLastName
        pcpPhone
        pcpAddress
        pcpEhrId
        emergencyContactFirstName
        emergencyContactLastName
        emergencyContactRelationship
        emergencyContactPhone
        stripeCustomerId
    }
`;
export const GetInsuranceDataFragmentDoc = gql`
    fragment getInsuranceData on Insurance {
        id
        memberId
        payer
        state
        isPrimaryInsurance
        status
        lastCheckedAt
        insuranceAccountStatus
        priority
        insuredFirstName
        insuredLastName
        planName
        planStartDate
        planEndDate
        pcpName
        subscriberInfo
        otherInsurances
        pcpCopayAmount
        specialistCopayAmount
        pcpCoinsurancePercentage
    }
`;
export const BoughtTreatmentFieldsFragmentDoc = gql`
    fragment boughtTreatmentFields on BoughtTreatment {
        id
        name
        consumerId
        pricedTreatmentId
        price
        createdAt
        insuranceIds
        orgId
        source
        status
        updatedAt
        paymentType
        discountCodeApplied
        overrideReason
        lastUpdatedBy
        isVirtual
    }
`;
export const AppointmentFieldsFragmentDoc = gql`
    fragment appointmentFields on Appointment {
        id
        intakeFormIds
        status
        slots {
            id
            startTime
            endTime
            note
            boughtTreatments {
                id
                name
                status
            }
        }
    }
`;
export const DetailSlotFieldsFragmentDoc = gql`
    fragment detailSlotFields on DetailSlot {
        id
        startTime
        endTime
        consumerId
        appointment {
            id
            status
            intakeFormIds
            intakeBypassed
            completedIntakeFormIds
            arrivedAt
        }
        provider
        practice
        ehrSlotId
        status
        EhrSlot {
            id
            scheduleSlotName
            ehrAppointmentTypeId
            isCustomSlot
        }
        ehrCancellationReason
        detailBoughtTreatments {
            orgId
            id
            price
            insuranceIds
            pricedTreatmentId
            status
            source
            pricedTreatmentId
            consumerId
            consumer
            name
            paymentType
            charges
            hrtId
            discountCodeApplied
            status
            overrideReason
            lastUpdatedBy
            reviewStatus
            isVirtual
            hrtFlags
        }
        note
        noteUpdatedAt
        noteUpdatedBy
        reviewStatus
        virtualLink
    }
`;
export const RosterSlotFieldsFragmentDoc = gql`
    fragment rosterSlotFields on RosterSlot {
        id
        startTime
        endTime
        appointment {
            id
            status
            intakeFormIds
            intakeBypassed
            completedIntakeFormIds
            checkedInAt
            arrivedAt
        }
        ehrSlotId
        status
        practiceId
        practice
        rosterBoughtTreatments {
            orgId
            id
            price
            insuranceIds
            pricedTreatmentId
            status
            pricedTreatmentId
            consumerId
            consumer
            name
            paymentType
            charges
            discountCodeApplied
            overrideReason
            lastUpdatedBy
            reviewStatus
            isVirtual
            hrtFlags
        }
        note
        reviewStatus
        virtualLink
    }
`;
export const ConsumerMessageFieldsFragmentDoc = gql`
    fragment consumerMessageFields on ConsumerMessage {
        id
        consumerId
        orgId
        message
        createdAt
        updatedAt
        adminId
    }
`;
export const TransferFieldsFragmentDoc = gql`
    fragment transferFields on Payout {
        id
        orgId
        date
        stripeTransferId
        chargeIds
        charges {
            id
            boughtTreatmentId
        }
        price
        transferredAmount
        stripeTransferId
        payoutType
        stripeReversalId
        destinationPayment
    }
`;
export const LiveTransferFieldsFragmentDoc = gql`
    fragment liveTransferFields on LiveTransfers {
        id
        appointmentId
        consumerId
        claimId
        ehrVisitId
        patientOrgEhrId
        dateOfService
        dateOfFirstCommunication
        status
        action
        artNotes
        patientName
        slotType
        dateTransferred
        provider
        location
        treatmentMap
        dateOfLastCommunication
        primaryPayer
        primaryPayerPackage
        secondaryPayer
        secondaryPayerPackage
        originalPrimaryPayerAllowableAmount
        currentPrimaryPayerAllowableAmount
        originalSecondaryPayerAllowableAmount
        currentSecondaryPayerAllowableAmount
        originalPatientResponsibility
        currentPatientResponsibility
        superscriptFeeAmount
        stripeFeeAmount
        grossPayout
        netPayout
        stripeTransferId
        treatmentTypes
        locationTimezone
        destinationPayment
        orgId
    }
`;
export const GuarantorPaymentLinkContextFieldsFragmentDoc = gql`
    fragment guarantorPaymentLinkContextFields on GuarantorPaymentLinkContext {
        id
        orgId
        patientName
        guarantorName
        appointmentId
    }
`;
export const GetProvidersByPracticeIdDocument = gql`
    query getProvidersByPracticeId($id: Int!) {
        providers(
            where: {
                providerToProviderGroups: {
                    some: {
                        provider_group: { is: { practiceId: { equals: $id } } }
                    }
                }
            }
        ) {
            id
            npiId
            firstName
            lastName
            ehrId
        }
    }
`;

/**
 * __useGetProvidersByPracticeIdQuery__
 *
 * To run a query within a React component, call `useGetProvidersByPracticeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersByPracticeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersByPracticeIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProvidersByPracticeIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProvidersByPracticeIdQuery,
        GetProvidersByPracticeIdQueryVariables
    > &
        (
            | {
                  variables: GetProvidersByPracticeIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProvidersByPracticeIdQuery,
        GetProvidersByPracticeIdQueryVariables
    >(GetProvidersByPracticeIdDocument, options);
}
export function useGetProvidersByPracticeIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProvidersByPracticeIdQuery,
        GetProvidersByPracticeIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProvidersByPracticeIdQuery,
        GetProvidersByPracticeIdQueryVariables
    >(GetProvidersByPracticeIdDocument, options);
}
// @ts-ignore
export function useGetProvidersByPracticeIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProvidersByPracticeIdQuery,
        GetProvidersByPracticeIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProvidersByPracticeIdQuery,
    GetProvidersByPracticeIdQueryVariables
>;
export function useGetProvidersByPracticeIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProvidersByPracticeIdQuery,
              GetProvidersByPracticeIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProvidersByPracticeIdQuery | undefined,
    GetProvidersByPracticeIdQueryVariables
>;
export function useGetProvidersByPracticeIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProvidersByPracticeIdQuery,
              GetProvidersByPracticeIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProvidersByPracticeIdQuery,
        GetProvidersByPracticeIdQueryVariables
    >(GetProvidersByPracticeIdDocument, options);
}
export type GetProvidersByPracticeIdQueryHookResult = ReturnType<
    typeof useGetProvidersByPracticeIdQuery
>;
export type GetProvidersByPracticeIdLazyQueryHookResult = ReturnType<
    typeof useGetProvidersByPracticeIdLazyQuery
>;
export type GetProvidersByPracticeIdSuspenseQueryHookResult = ReturnType<
    typeof useGetProvidersByPracticeIdSuspenseQuery
>;
export type GetProvidersByPracticeIdQueryResult = Apollo.QueryResult<
    GetProvidersByPracticeIdQuery,
    GetProvidersByPracticeIdQueryVariables
>;
export const GetProvidersByOrgIdDocument = gql`
    query getProvidersByOrgId($id: Int!) {
        providers(
            where: {
                providerToProviderGroups: {
                    some: {
                        provider_group: {
                            is: { practice: { is: { orgId: { equals: $id } } } }
                        }
                    }
                }
            }
        ) {
            id
            npiId
            firstName
            lastName
            ehrId
            degrees
        }
    }
`;

/**
 * __useGetProvidersByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetProvidersByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersByOrgIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProvidersByOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProvidersByOrgIdQuery,
        GetProvidersByOrgIdQueryVariables
    > &
        (
            | { variables: GetProvidersByOrgIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProvidersByOrgIdQuery,
        GetProvidersByOrgIdQueryVariables
    >(GetProvidersByOrgIdDocument, options);
}
export function useGetProvidersByOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProvidersByOrgIdQuery,
        GetProvidersByOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProvidersByOrgIdQuery,
        GetProvidersByOrgIdQueryVariables
    >(GetProvidersByOrgIdDocument, options);
}
// @ts-ignore
export function useGetProvidersByOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProvidersByOrgIdQuery,
        GetProvidersByOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProvidersByOrgIdQuery,
    GetProvidersByOrgIdQueryVariables
>;
export function useGetProvidersByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProvidersByOrgIdQuery,
              GetProvidersByOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProvidersByOrgIdQuery | undefined,
    GetProvidersByOrgIdQueryVariables
>;
export function useGetProvidersByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProvidersByOrgIdQuery,
              GetProvidersByOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProvidersByOrgIdQuery,
        GetProvidersByOrgIdQueryVariables
    >(GetProvidersByOrgIdDocument, options);
}
export type GetProvidersByOrgIdQueryHookResult = ReturnType<
    typeof useGetProvidersByOrgIdQuery
>;
export type GetProvidersByOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetProvidersByOrgIdLazyQuery
>;
export type GetProvidersByOrgIdSuspenseQueryHookResult = ReturnType<
    typeof useGetProvidersByOrgIdSuspenseQuery
>;
export type GetProvidersByOrgIdQueryResult = Apollo.QueryResult<
    GetProvidersByOrgIdQuery,
    GetProvidersByOrgIdQueryVariables
>;
export const GetBusinessHoursDocument = gql`
    query GetBusinessHours($where: BusinessHourWhereInput) {
        businessHours(where: $where) {
            id
            practiceId
            dayOfWeek
            isEnabled
            openTime
            closeTime
        }
    }
`;

/**
 * __useGetBusinessHoursQuery__
 *
 * To run a query within a React component, call `useGetBusinessHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessHoursQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetBusinessHoursQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetBusinessHoursQuery,
        GetBusinessHoursQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBusinessHoursQuery,
        GetBusinessHoursQueryVariables
    >(GetBusinessHoursDocument, options);
}
export function useGetBusinessHoursLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBusinessHoursQuery,
        GetBusinessHoursQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBusinessHoursQuery,
        GetBusinessHoursQueryVariables
    >(GetBusinessHoursDocument, options);
}
// @ts-ignore
export function useGetBusinessHoursSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetBusinessHoursQuery,
        GetBusinessHoursQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetBusinessHoursQuery,
    GetBusinessHoursQueryVariables
>;
export function useGetBusinessHoursSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBusinessHoursQuery,
              GetBusinessHoursQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetBusinessHoursQuery | undefined,
    GetBusinessHoursQueryVariables
>;
export function useGetBusinessHoursSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBusinessHoursQuery,
              GetBusinessHoursQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBusinessHoursQuery,
        GetBusinessHoursQueryVariables
    >(GetBusinessHoursDocument, options);
}
export type GetBusinessHoursQueryHookResult = ReturnType<
    typeof useGetBusinessHoursQuery
>;
export type GetBusinessHoursLazyQueryHookResult = ReturnType<
    typeof useGetBusinessHoursLazyQuery
>;
export type GetBusinessHoursSuspenseQueryHookResult = ReturnType<
    typeof useGetBusinessHoursSuspenseQuery
>;
export type GetBusinessHoursQueryResult = Apollo.QueryResult<
    GetBusinessHoursQuery,
    GetBusinessHoursQueryVariables
>;
export const UpdateBusinessHoursDocument = gql`
    mutation UpdateBusinessHours(
        $id: String!
        $businessHour: BusinessHourUpdateInput!
    ) {
        updateOneBusinessHour(where: { id: $id }, data: $businessHour) {
            id
            practiceId
            dayOfWeek
            isEnabled
            openTime
            closeTime
        }
    }
`;
export type UpdateBusinessHoursMutationFn = Apollo.MutationFunction<
    UpdateBusinessHoursMutation,
    UpdateBusinessHoursMutationVariables
>;

/**
 * __useUpdateBusinessHoursMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessHoursMutation, { data, loading, error }] = useUpdateBusinessHoursMutation({
 *   variables: {
 *      id: // value for 'id'
 *      businessHour: // value for 'businessHour'
 *   },
 * });
 */
export function useUpdateBusinessHoursMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateBusinessHoursMutation,
        UpdateBusinessHoursMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateBusinessHoursMutation,
        UpdateBusinessHoursMutationVariables
    >(UpdateBusinessHoursDocument, options);
}
export type UpdateBusinessHoursMutationHookResult = ReturnType<
    typeof useUpdateBusinessHoursMutation
>;
export type UpdateBusinessHoursMutationResult =
    Apollo.MutationResult<UpdateBusinessHoursMutation>;
export type UpdateBusinessHoursMutationOptions = Apollo.BaseMutationOptions<
    UpdateBusinessHoursMutation,
    UpdateBusinessHoursMutationVariables
>;
export const GetTimeBlocksDocument = gql`
    query GetTimeBlocks($where: TimeBlockWhereInput) {
        timeBlocks(where: $where) {
            id
            providerId
            practiceId
            startTime
            endTime
            available
            notes
            label
            isAllDay
            category
        }
    }
`;

/**
 * __useGetTimeBlocksQuery__
 *
 * To run a query within a React component, call `useGetTimeBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeBlocksQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTimeBlocksQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetTimeBlocksQuery,
        GetTimeBlocksQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetTimeBlocksQuery, GetTimeBlocksQueryVariables>(
        GetTimeBlocksDocument,
        options,
    );
}
export function useGetTimeBlocksLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTimeBlocksQuery,
        GetTimeBlocksQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetTimeBlocksQuery, GetTimeBlocksQueryVariables>(
        GetTimeBlocksDocument,
        options,
    );
}
// @ts-ignore
export function useGetTimeBlocksSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetTimeBlocksQuery,
        GetTimeBlocksQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetTimeBlocksQuery,
    GetTimeBlocksQueryVariables
>;
export function useGetTimeBlocksSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTimeBlocksQuery,
              GetTimeBlocksQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetTimeBlocksQuery | undefined,
    GetTimeBlocksQueryVariables
>;
export function useGetTimeBlocksSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTimeBlocksQuery,
              GetTimeBlocksQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetTimeBlocksQuery,
        GetTimeBlocksQueryVariables
    >(GetTimeBlocksDocument, options);
}
export type GetTimeBlocksQueryHookResult = ReturnType<
    typeof useGetTimeBlocksQuery
>;
export type GetTimeBlocksLazyQueryHookResult = ReturnType<
    typeof useGetTimeBlocksLazyQuery
>;
export type GetTimeBlocksSuspenseQueryHookResult = ReturnType<
    typeof useGetTimeBlocksSuspenseQuery
>;
export type GetTimeBlocksQueryResult = Apollo.QueryResult<
    GetTimeBlocksQuery,
    GetTimeBlocksQueryVariables
>;
export const DeleteOneTimeBlockByIdDocument = gql`
    mutation deleteOneTimeBlockById($blockId: String!) {
        deleteOneTimeBlock(where: { id: $blockId }) {
            id
        }
    }
`;
export type DeleteOneTimeBlockByIdMutationFn = Apollo.MutationFunction<
    DeleteOneTimeBlockByIdMutation,
    DeleteOneTimeBlockByIdMutationVariables
>;

/**
 * __useDeleteOneTimeBlockByIdMutation__
 *
 * To run a mutation, you first call `useDeleteOneTimeBlockByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneTimeBlockByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneTimeBlockByIdMutation, { data, loading, error }] = useDeleteOneTimeBlockByIdMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useDeleteOneTimeBlockByIdMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteOneTimeBlockByIdMutation,
        DeleteOneTimeBlockByIdMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        DeleteOneTimeBlockByIdMutation,
        DeleteOneTimeBlockByIdMutationVariables
    >(DeleteOneTimeBlockByIdDocument, options);
}
export type DeleteOneTimeBlockByIdMutationHookResult = ReturnType<
    typeof useDeleteOneTimeBlockByIdMutation
>;
export type DeleteOneTimeBlockByIdMutationResult =
    Apollo.MutationResult<DeleteOneTimeBlockByIdMutation>;
export type DeleteOneTimeBlockByIdMutationOptions = Apollo.BaseMutationOptions<
    DeleteOneTimeBlockByIdMutation,
    DeleteOneTimeBlockByIdMutationVariables
>;
export const GetSchedulingSlotConfigByPracticeIdDocument = gql`
    query getSchedulingSlotConfigByPracticeId($practiceId: Int!) {
        practice(where: { practiceId: $practiceId }) {
            locationName
            schedulingSlotConfig {
                id
                name
            }
        }
    }
`;

/**
 * __useGetSchedulingSlotConfigByPracticeIdQuery__
 *
 * To run a query within a React component, call `useGetSchedulingSlotConfigByPracticeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingSlotConfigByPracticeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingSlotConfigByPracticeIdQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *   },
 * });
 */
export function useGetSchedulingSlotConfigByPracticeIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSchedulingSlotConfigByPracticeIdQuery,
        GetSchedulingSlotConfigByPracticeIdQueryVariables
    > &
        (
            | {
                  variables: GetSchedulingSlotConfigByPracticeIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetSchedulingSlotConfigByPracticeIdQuery,
        GetSchedulingSlotConfigByPracticeIdQueryVariables
    >(GetSchedulingSlotConfigByPracticeIdDocument, options);
}
export function useGetSchedulingSlotConfigByPracticeIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSchedulingSlotConfigByPracticeIdQuery,
        GetSchedulingSlotConfigByPracticeIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetSchedulingSlotConfigByPracticeIdQuery,
        GetSchedulingSlotConfigByPracticeIdQueryVariables
    >(GetSchedulingSlotConfigByPracticeIdDocument, options);
}
// @ts-ignore
export function useGetSchedulingSlotConfigByPracticeIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetSchedulingSlotConfigByPracticeIdQuery,
        GetSchedulingSlotConfigByPracticeIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetSchedulingSlotConfigByPracticeIdQuery,
    GetSchedulingSlotConfigByPracticeIdQueryVariables
>;
export function useGetSchedulingSlotConfigByPracticeIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSchedulingSlotConfigByPracticeIdQuery,
              GetSchedulingSlotConfigByPracticeIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetSchedulingSlotConfigByPracticeIdQuery | undefined,
    GetSchedulingSlotConfigByPracticeIdQueryVariables
>;
export function useGetSchedulingSlotConfigByPracticeIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSchedulingSlotConfigByPracticeIdQuery,
              GetSchedulingSlotConfigByPracticeIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetSchedulingSlotConfigByPracticeIdQuery,
        GetSchedulingSlotConfigByPracticeIdQueryVariables
    >(GetSchedulingSlotConfigByPracticeIdDocument, options);
}
export type GetSchedulingSlotConfigByPracticeIdQueryHookResult = ReturnType<
    typeof useGetSchedulingSlotConfigByPracticeIdQuery
>;
export type GetSchedulingSlotConfigByPracticeIdLazyQueryHookResult = ReturnType<
    typeof useGetSchedulingSlotConfigByPracticeIdLazyQuery
>;
export type GetSchedulingSlotConfigByPracticeIdSuspenseQueryHookResult =
    ReturnType<typeof useGetSchedulingSlotConfigByPracticeIdSuspenseQuery>;
export type GetSchedulingSlotConfigByPracticeIdQueryResult = Apollo.QueryResult<
    GetSchedulingSlotConfigByPracticeIdQuery,
    GetSchedulingSlotConfigByPracticeIdQueryVariables
>;
export const GetSchedulingSlotConfigByOrgIdDocument = gql`
    query getSchedulingSlotConfigByOrgId($orgId: Int!) {
        schedulingSlotConfigs(where: { orgId: { equals: $orgId } }) {
            id
            ehrAppointmentTypeId
            name
            isVirtual
        }
    }
`;

/**
 * __useGetSchedulingSlotConfigByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetSchedulingSlotConfigByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingSlotConfigByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingSlotConfigByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetSchedulingSlotConfigByOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSchedulingSlotConfigByOrgIdQuery,
        GetSchedulingSlotConfigByOrgIdQueryVariables
    > &
        (
            | {
                  variables: GetSchedulingSlotConfigByOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetSchedulingSlotConfigByOrgIdQuery,
        GetSchedulingSlotConfigByOrgIdQueryVariables
    >(GetSchedulingSlotConfigByOrgIdDocument, options);
}
export function useGetSchedulingSlotConfigByOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSchedulingSlotConfigByOrgIdQuery,
        GetSchedulingSlotConfigByOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetSchedulingSlotConfigByOrgIdQuery,
        GetSchedulingSlotConfigByOrgIdQueryVariables
    >(GetSchedulingSlotConfigByOrgIdDocument, options);
}
// @ts-ignore
export function useGetSchedulingSlotConfigByOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetSchedulingSlotConfigByOrgIdQuery,
        GetSchedulingSlotConfigByOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetSchedulingSlotConfigByOrgIdQuery,
    GetSchedulingSlotConfigByOrgIdQueryVariables
>;
export function useGetSchedulingSlotConfigByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSchedulingSlotConfigByOrgIdQuery,
              GetSchedulingSlotConfigByOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetSchedulingSlotConfigByOrgIdQuery | undefined,
    GetSchedulingSlotConfigByOrgIdQueryVariables
>;
export function useGetSchedulingSlotConfigByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSchedulingSlotConfigByOrgIdQuery,
              GetSchedulingSlotConfigByOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetSchedulingSlotConfigByOrgIdQuery,
        GetSchedulingSlotConfigByOrgIdQueryVariables
    >(GetSchedulingSlotConfigByOrgIdDocument, options);
}
export type GetSchedulingSlotConfigByOrgIdQueryHookResult = ReturnType<
    typeof useGetSchedulingSlotConfigByOrgIdQuery
>;
export type GetSchedulingSlotConfigByOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetSchedulingSlotConfigByOrgIdLazyQuery
>;
export type GetSchedulingSlotConfigByOrgIdSuspenseQueryHookResult = ReturnType<
    typeof useGetSchedulingSlotConfigByOrgIdSuspenseQuery
>;
export type GetSchedulingSlotConfigByOrgIdQueryResult = Apollo.QueryResult<
    GetSchedulingSlotConfigByOrgIdQuery,
    GetSchedulingSlotConfigByOrgIdQueryVariables
>;
export const GetSchedulingSlotConfigByEhrVisitIdIdDocument = gql`
    query getSchedulingSlotConfigByEhrVisitIdId($ehrVisitId: String!) {
        schedulingSlotConfigs(where: { ehrVisitId: { equals: $ehrVisitId } }) {
            name
        }
    }
`;

/**
 * __useGetSchedulingSlotConfigByEhrVisitIdIdQuery__
 *
 * To run a query within a React component, call `useGetSchedulingSlotConfigByEhrVisitIdIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingSlotConfigByEhrVisitIdIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingSlotConfigByEhrVisitIdIdQuery({
 *   variables: {
 *      ehrVisitId: // value for 'ehrVisitId'
 *   },
 * });
 */
export function useGetSchedulingSlotConfigByEhrVisitIdIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSchedulingSlotConfigByEhrVisitIdIdQuery,
        GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
    > &
        (
            | {
                  variables: GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetSchedulingSlotConfigByEhrVisitIdIdQuery,
        GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
    >(GetSchedulingSlotConfigByEhrVisitIdIdDocument, options);
}
export function useGetSchedulingSlotConfigByEhrVisitIdIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSchedulingSlotConfigByEhrVisitIdIdQuery,
        GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetSchedulingSlotConfigByEhrVisitIdIdQuery,
        GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
    >(GetSchedulingSlotConfigByEhrVisitIdIdDocument, options);
}
// @ts-ignore
export function useGetSchedulingSlotConfigByEhrVisitIdIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetSchedulingSlotConfigByEhrVisitIdIdQuery,
        GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetSchedulingSlotConfigByEhrVisitIdIdQuery,
    GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
>;
export function useGetSchedulingSlotConfigByEhrVisitIdIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSchedulingSlotConfigByEhrVisitIdIdQuery,
              GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetSchedulingSlotConfigByEhrVisitIdIdQuery | undefined,
    GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
>;
export function useGetSchedulingSlotConfigByEhrVisitIdIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSchedulingSlotConfigByEhrVisitIdIdQuery,
              GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetSchedulingSlotConfigByEhrVisitIdIdQuery,
        GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
    >(GetSchedulingSlotConfigByEhrVisitIdIdDocument, options);
}
export type GetSchedulingSlotConfigByEhrVisitIdIdQueryHookResult = ReturnType<
    typeof useGetSchedulingSlotConfigByEhrVisitIdIdQuery
>;
export type GetSchedulingSlotConfigByEhrVisitIdIdLazyQueryHookResult =
    ReturnType<typeof useGetSchedulingSlotConfigByEhrVisitIdIdLazyQuery>;
export type GetSchedulingSlotConfigByEhrVisitIdIdSuspenseQueryHookResult =
    ReturnType<typeof useGetSchedulingSlotConfigByEhrVisitIdIdSuspenseQuery>;
export type GetSchedulingSlotConfigByEhrVisitIdIdQueryResult =
    Apollo.QueryResult<
        GetSchedulingSlotConfigByEhrVisitIdIdQuery,
        GetSchedulingSlotConfigByEhrVisitIdIdQueryVariables
    >;
export const GetProvidersByProviderGroupIdsDocument = gql`
    query getProvidersByProviderGroupIds($ids: [Int!]) {
        providers(
            where: {
                providerToProviderGroups: {
                    some: { providerGroupId: { in: $ids } }
                }
            }
        ) {
            id
            npiId
            firstName
            lastName
            ehrId
        }
    }
`;

/**
 * __useGetProvidersByProviderGroupIdsQuery__
 *
 * To run a query within a React component, call `useGetProvidersByProviderGroupIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersByProviderGroupIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersByProviderGroupIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetProvidersByProviderGroupIdsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetProvidersByProviderGroupIdsQuery,
        GetProvidersByProviderGroupIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProvidersByProviderGroupIdsQuery,
        GetProvidersByProviderGroupIdsQueryVariables
    >(GetProvidersByProviderGroupIdsDocument, options);
}
export function useGetProvidersByProviderGroupIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProvidersByProviderGroupIdsQuery,
        GetProvidersByProviderGroupIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProvidersByProviderGroupIdsQuery,
        GetProvidersByProviderGroupIdsQueryVariables
    >(GetProvidersByProviderGroupIdsDocument, options);
}
// @ts-ignore
export function useGetProvidersByProviderGroupIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProvidersByProviderGroupIdsQuery,
        GetProvidersByProviderGroupIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProvidersByProviderGroupIdsQuery,
    GetProvidersByProviderGroupIdsQueryVariables
>;
export function useGetProvidersByProviderGroupIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProvidersByProviderGroupIdsQuery,
              GetProvidersByProviderGroupIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProvidersByProviderGroupIdsQuery | undefined,
    GetProvidersByProviderGroupIdsQueryVariables
>;
export function useGetProvidersByProviderGroupIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProvidersByProviderGroupIdsQuery,
              GetProvidersByProviderGroupIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProvidersByProviderGroupIdsQuery,
        GetProvidersByProviderGroupIdsQueryVariables
    >(GetProvidersByProviderGroupIdsDocument, options);
}
export type GetProvidersByProviderGroupIdsQueryHookResult = ReturnType<
    typeof useGetProvidersByProviderGroupIdsQuery
>;
export type GetProvidersByProviderGroupIdsLazyQueryHookResult = ReturnType<
    typeof useGetProvidersByProviderGroupIdsLazyQuery
>;
export type GetProvidersByProviderGroupIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetProvidersByProviderGroupIdsSuspenseQuery
>;
export type GetProvidersByProviderGroupIdsQueryResult = Apollo.QueryResult<
    GetProvidersByProviderGroupIdsQuery,
    GetProvidersByProviderGroupIdsQueryVariables
>;
export const GetProvidersByIdsDocument = gql`
    query getProvidersByIds($ids: [Int!]!) {
        providers(where: { id: { in: $ids } }) {
            id
            npiId
            firstName
            lastName
            title
            degrees
            imageUrl
        }
    }
`;

/**
 * __useGetProvidersByIdsQuery__
 *
 * To run a query within a React component, call `useGetProvidersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetProvidersByIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProvidersByIdsQuery,
        GetProvidersByIdsQueryVariables
    > &
        (
            | { variables: GetProvidersByIdsQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProvidersByIdsQuery,
        GetProvidersByIdsQueryVariables
    >(GetProvidersByIdsDocument, options);
}
export function useGetProvidersByIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProvidersByIdsQuery,
        GetProvidersByIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProvidersByIdsQuery,
        GetProvidersByIdsQueryVariables
    >(GetProvidersByIdsDocument, options);
}
// @ts-ignore
export function useGetProvidersByIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProvidersByIdsQuery,
        GetProvidersByIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProvidersByIdsQuery,
    GetProvidersByIdsQueryVariables
>;
export function useGetProvidersByIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProvidersByIdsQuery,
              GetProvidersByIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProvidersByIdsQuery | undefined,
    GetProvidersByIdsQueryVariables
>;
export function useGetProvidersByIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProvidersByIdsQuery,
              GetProvidersByIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProvidersByIdsQuery,
        GetProvidersByIdsQueryVariables
    >(GetProvidersByIdsDocument, options);
}
export type GetProvidersByIdsQueryHookResult = ReturnType<
    typeof useGetProvidersByIdsQuery
>;
export type GetProvidersByIdsLazyQueryHookResult = ReturnType<
    typeof useGetProvidersByIdsLazyQuery
>;
export type GetProvidersByIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetProvidersByIdsSuspenseQuery
>;
export type GetProvidersByIdsQueryResult = Apollo.QueryResult<
    GetProvidersByIdsQuery,
    GetProvidersByIdsQueryVariables
>;
export const GetProviderGroupToHrtsByHrtIdsDocument = gql`
    query getProviderGroupToHrtsByHrtIds($ids: [Int!]!) {
        providerGroupToHrts(where: { hrtId: { in: $ids } }) {
            notBookable
            isActive
            providerGroup {
                practiceId
                providerToProviderGroup {
                    providerGroupId
                    provider {
                        id
                        npiId
                        firstName
                        lastName
                        title
                        degrees
                        imageUrl
                    }
                }
            }
        }
    }
`;

/**
 * __useGetProviderGroupToHrtsByHrtIdsQuery__
 *
 * To run a query within a React component, call `useGetProviderGroupToHrtsByHrtIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderGroupToHrtsByHrtIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderGroupToHrtsByHrtIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetProviderGroupToHrtsByHrtIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProviderGroupToHrtsByHrtIdsQuery,
        GetProviderGroupToHrtsByHrtIdsQueryVariables
    > &
        (
            | {
                  variables: GetProviderGroupToHrtsByHrtIdsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProviderGroupToHrtsByHrtIdsQuery,
        GetProviderGroupToHrtsByHrtIdsQueryVariables
    >(GetProviderGroupToHrtsByHrtIdsDocument, options);
}
export function useGetProviderGroupToHrtsByHrtIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderGroupToHrtsByHrtIdsQuery,
        GetProviderGroupToHrtsByHrtIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderGroupToHrtsByHrtIdsQuery,
        GetProviderGroupToHrtsByHrtIdsQueryVariables
    >(GetProviderGroupToHrtsByHrtIdsDocument, options);
}
// @ts-ignore
export function useGetProviderGroupToHrtsByHrtIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderGroupToHrtsByHrtIdsQuery,
        GetProviderGroupToHrtsByHrtIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupToHrtsByHrtIdsQuery,
    GetProviderGroupToHrtsByHrtIdsQueryVariables
>;
export function useGetProviderGroupToHrtsByHrtIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupToHrtsByHrtIdsQuery,
              GetProviderGroupToHrtsByHrtIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupToHrtsByHrtIdsQuery | undefined,
    GetProviderGroupToHrtsByHrtIdsQueryVariables
>;
export function useGetProviderGroupToHrtsByHrtIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupToHrtsByHrtIdsQuery,
              GetProviderGroupToHrtsByHrtIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderGroupToHrtsByHrtIdsQuery,
        GetProviderGroupToHrtsByHrtIdsQueryVariables
    >(GetProviderGroupToHrtsByHrtIdsDocument, options);
}
export type GetProviderGroupToHrtsByHrtIdsQueryHookResult = ReturnType<
    typeof useGetProviderGroupToHrtsByHrtIdsQuery
>;
export type GetProviderGroupToHrtsByHrtIdsLazyQueryHookResult = ReturnType<
    typeof useGetProviderGroupToHrtsByHrtIdsLazyQuery
>;
export type GetProviderGroupToHrtsByHrtIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetProviderGroupToHrtsByHrtIdsSuspenseQuery
>;
export type GetProviderGroupToHrtsByHrtIdsQueryResult = Apollo.QueryResult<
    GetProviderGroupToHrtsByHrtIdsQuery,
    GetProviderGroupToHrtsByHrtIdsQueryVariables
>;
export const GetProviderGroupToHrtsByHrtIdDocument = gql`
    query getProviderGroupToHrtsByHrtId($hrtId: Int!) {
        providerGroupToHrts(where: { hrtId: { equals: $hrtId } }) {
            notBookable
            providerGroup {
                practiceId
                providerToProviderGroup {
                    providerGroupId
                    provider {
                        providerToProviderGroups {
                            provider_group {
                                practiceId
                                providerGroupId
                            }
                        }
                        id
                        firstName
                        lastName
                        title
                        degrees
                        imageUrl
                    }
                }
            }
        }
    }
`;

/**
 * __useGetProviderGroupToHrtsByHrtIdQuery__
 *
 * To run a query within a React component, call `useGetProviderGroupToHrtsByHrtIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderGroupToHrtsByHrtIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderGroupToHrtsByHrtIdQuery({
 *   variables: {
 *      hrtId: // value for 'hrtId'
 *   },
 * });
 */
export function useGetProviderGroupToHrtsByHrtIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProviderGroupToHrtsByHrtIdQuery,
        GetProviderGroupToHrtsByHrtIdQueryVariables
    > &
        (
            | {
                  variables: GetProviderGroupToHrtsByHrtIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProviderGroupToHrtsByHrtIdQuery,
        GetProviderGroupToHrtsByHrtIdQueryVariables
    >(GetProviderGroupToHrtsByHrtIdDocument, options);
}
export function useGetProviderGroupToHrtsByHrtIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderGroupToHrtsByHrtIdQuery,
        GetProviderGroupToHrtsByHrtIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderGroupToHrtsByHrtIdQuery,
        GetProviderGroupToHrtsByHrtIdQueryVariables
    >(GetProviderGroupToHrtsByHrtIdDocument, options);
}
// @ts-ignore
export function useGetProviderGroupToHrtsByHrtIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderGroupToHrtsByHrtIdQuery,
        GetProviderGroupToHrtsByHrtIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupToHrtsByHrtIdQuery,
    GetProviderGroupToHrtsByHrtIdQueryVariables
>;
export function useGetProviderGroupToHrtsByHrtIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupToHrtsByHrtIdQuery,
              GetProviderGroupToHrtsByHrtIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupToHrtsByHrtIdQuery | undefined,
    GetProviderGroupToHrtsByHrtIdQueryVariables
>;
export function useGetProviderGroupToHrtsByHrtIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupToHrtsByHrtIdQuery,
              GetProviderGroupToHrtsByHrtIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderGroupToHrtsByHrtIdQuery,
        GetProviderGroupToHrtsByHrtIdQueryVariables
    >(GetProviderGroupToHrtsByHrtIdDocument, options);
}
export type GetProviderGroupToHrtsByHrtIdQueryHookResult = ReturnType<
    typeof useGetProviderGroupToHrtsByHrtIdQuery
>;
export type GetProviderGroupToHrtsByHrtIdLazyQueryHookResult = ReturnType<
    typeof useGetProviderGroupToHrtsByHrtIdLazyQuery
>;
export type GetProviderGroupToHrtsByHrtIdSuspenseQueryHookResult = ReturnType<
    typeof useGetProviderGroupToHrtsByHrtIdSuspenseQuery
>;
export type GetProviderGroupToHrtsByHrtIdQueryResult = Apollo.QueryResult<
    GetProviderGroupToHrtsByHrtIdQuery,
    GetProviderGroupToHrtsByHrtIdQueryVariables
>;
export const GetProviderGroupToHrtsByHrtIdsAndPracticeIdDocument = gql`
    query getProviderGroupToHrtsByHrtIdsAndPracticeId(
        $hrtId: Int!
        $practiceId: Int!
    ) {
        providerGroupToHrts(
            where: {
                AND: [
                    { hrtId: { equals: $hrtId } }
                    {
                        providerGroup: {
                            is: { practiceId: { equals: $practiceId } }
                        }
                    }
                ]
            }
        ) {
            notBookable
            providerGroup {
                practiceId
                providerToProviderGroup {
                    providerGroupId
                    provider {
                        providerToProviderGroups {
                            provider_group {
                                practiceId
                                providerGroupId
                            }
                        }
                        id
                        firstName
                        lastName
                        title
                        degrees
                        imageUrl
                    }
                }
            }
        }
    }
`;

/**
 * __useGetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery__
 *
 * To run a query within a React component, call `useGetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery({
 *   variables: {
 *      hrtId: // value for 'hrtId'
 *      practiceId: // value for 'practiceId'
 *   },
 * });
 */
export function useGetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery,
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
    > &
        (
            | {
                  variables: GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery,
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
    >(GetProviderGroupToHrtsByHrtIdsAndPracticeIdDocument, options);
}
export function useGetProviderGroupToHrtsByHrtIdsAndPracticeIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery,
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery,
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
    >(GetProviderGroupToHrtsByHrtIdsAndPracticeIdDocument, options);
}
// @ts-ignore
export function useGetProviderGroupToHrtsByHrtIdsAndPracticeIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery,
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery,
    GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
>;
export function useGetProviderGroupToHrtsByHrtIdsAndPracticeIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery,
              GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery | undefined,
    GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
>;
export function useGetProviderGroupToHrtsByHrtIdsAndPracticeIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery,
              GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery,
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
    >(GetProviderGroupToHrtsByHrtIdsAndPracticeIdDocument, options);
}
export type GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryHookResult =
    ReturnType<typeof useGetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery>;
export type GetProviderGroupToHrtsByHrtIdsAndPracticeIdLazyQueryHookResult =
    ReturnType<typeof useGetProviderGroupToHrtsByHrtIdsAndPracticeIdLazyQuery>;
export type GetProviderGroupToHrtsByHrtIdsAndPracticeIdSuspenseQueryHookResult =
    ReturnType<
        typeof useGetProviderGroupToHrtsByHrtIdsAndPracticeIdSuspenseQuery
    >;
export type GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryResult =
    Apollo.QueryResult<
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQuery,
        GetProviderGroupToHrtsByHrtIdsAndPracticeIdQueryVariables
    >;
export const GetProviderByIdDocument = gql`
    query getProviderById($id: Int!) {
        provider(where: { id: $id }) {
            id
            npiId
            firstName
            lastName
            ehrId
            imageUrl
            degrees
        }
    }
`;

/**
 * __useGetProviderByIdQuery__
 *
 * To run a query within a React component, call `useGetProviderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProviderByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProviderByIdQuery,
        GetProviderByIdQueryVariables
    > &
        (
            | { variables: GetProviderByIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetProviderByIdQuery, GetProviderByIdQueryVariables>(
        GetProviderByIdDocument,
        options,
    );
}
export function useGetProviderByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderByIdQuery,
        GetProviderByIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderByIdQuery,
        GetProviderByIdQueryVariables
    >(GetProviderByIdDocument, options);
}
// @ts-ignore
export function useGetProviderByIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderByIdQuery,
        GetProviderByIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderByIdQuery,
    GetProviderByIdQueryVariables
>;
export function useGetProviderByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderByIdQuery,
              GetProviderByIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderByIdQuery | undefined,
    GetProviderByIdQueryVariables
>;
export function useGetProviderByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderByIdQuery,
              GetProviderByIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderByIdQuery,
        GetProviderByIdQueryVariables
    >(GetProviderByIdDocument, options);
}
export type GetProviderByIdQueryHookResult = ReturnType<
    typeof useGetProviderByIdQuery
>;
export type GetProviderByIdLazyQueryHookResult = ReturnType<
    typeof useGetProviderByIdLazyQuery
>;
export type GetProviderByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetProviderByIdSuspenseQuery
>;
export type GetProviderByIdQueryResult = Apollo.QueryResult<
    GetProviderByIdQuery,
    GetProviderByIdQueryVariables
>;
export const GetProviderGroupsByPracticeIdDocument = gql`
    query getProviderGroupsByPracticeId($id: Int) {
        providerGroups(where: { practiceId: { equals: $id } }) {
            providerGroupId
        }
    }
`;

/**
 * __useGetProviderGroupsByPracticeIdQuery__
 *
 * To run a query within a React component, call `useGetProviderGroupsByPracticeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderGroupsByPracticeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderGroupsByPracticeIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProviderGroupsByPracticeIdQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetProviderGroupsByPracticeIdQuery,
        GetProviderGroupsByPracticeIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProviderGroupsByPracticeIdQuery,
        GetProviderGroupsByPracticeIdQueryVariables
    >(GetProviderGroupsByPracticeIdDocument, options);
}
export function useGetProviderGroupsByPracticeIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderGroupsByPracticeIdQuery,
        GetProviderGroupsByPracticeIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderGroupsByPracticeIdQuery,
        GetProviderGroupsByPracticeIdQueryVariables
    >(GetProviderGroupsByPracticeIdDocument, options);
}
// @ts-ignore
export function useGetProviderGroupsByPracticeIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderGroupsByPracticeIdQuery,
        GetProviderGroupsByPracticeIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupsByPracticeIdQuery,
    GetProviderGroupsByPracticeIdQueryVariables
>;
export function useGetProviderGroupsByPracticeIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupsByPracticeIdQuery,
              GetProviderGroupsByPracticeIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupsByPracticeIdQuery | undefined,
    GetProviderGroupsByPracticeIdQueryVariables
>;
export function useGetProviderGroupsByPracticeIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupsByPracticeIdQuery,
              GetProviderGroupsByPracticeIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderGroupsByPracticeIdQuery,
        GetProviderGroupsByPracticeIdQueryVariables
    >(GetProviderGroupsByPracticeIdDocument, options);
}
export type GetProviderGroupsByPracticeIdQueryHookResult = ReturnType<
    typeof useGetProviderGroupsByPracticeIdQuery
>;
export type GetProviderGroupsByPracticeIdLazyQueryHookResult = ReturnType<
    typeof useGetProviderGroupsByPracticeIdLazyQuery
>;
export type GetProviderGroupsByPracticeIdSuspenseQueryHookResult = ReturnType<
    typeof useGetProviderGroupsByPracticeIdSuspenseQuery
>;
export type GetProviderGroupsByPracticeIdQueryResult = Apollo.QueryResult<
    GetProviderGroupsByPracticeIdQuery,
    GetProviderGroupsByPracticeIdQueryVariables
>;
export const GetProviderGroupsByHrtIdDocument = gql`
    query getProviderGroupsByHrtId($id: Int!) {
        providerGroupToHrts(where: { hrtId: { equals: $id } }) {
            providerGroupId
        }
    }
`;

/**
 * __useGetProviderGroupsByHrtIdQuery__
 *
 * To run a query within a React component, call `useGetProviderGroupsByHrtIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderGroupsByHrtIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderGroupsByHrtIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProviderGroupsByHrtIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProviderGroupsByHrtIdQuery,
        GetProviderGroupsByHrtIdQueryVariables
    > &
        (
            | {
                  variables: GetProviderGroupsByHrtIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProviderGroupsByHrtIdQuery,
        GetProviderGroupsByHrtIdQueryVariables
    >(GetProviderGroupsByHrtIdDocument, options);
}
export function useGetProviderGroupsByHrtIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderGroupsByHrtIdQuery,
        GetProviderGroupsByHrtIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderGroupsByHrtIdQuery,
        GetProviderGroupsByHrtIdQueryVariables
    >(GetProviderGroupsByHrtIdDocument, options);
}
// @ts-ignore
export function useGetProviderGroupsByHrtIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderGroupsByHrtIdQuery,
        GetProviderGroupsByHrtIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupsByHrtIdQuery,
    GetProviderGroupsByHrtIdQueryVariables
>;
export function useGetProviderGroupsByHrtIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupsByHrtIdQuery,
              GetProviderGroupsByHrtIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupsByHrtIdQuery | undefined,
    GetProviderGroupsByHrtIdQueryVariables
>;
export function useGetProviderGroupsByHrtIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupsByHrtIdQuery,
              GetProviderGroupsByHrtIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderGroupsByHrtIdQuery,
        GetProviderGroupsByHrtIdQueryVariables
    >(GetProviderGroupsByHrtIdDocument, options);
}
export type GetProviderGroupsByHrtIdQueryHookResult = ReturnType<
    typeof useGetProviderGroupsByHrtIdQuery
>;
export type GetProviderGroupsByHrtIdLazyQueryHookResult = ReturnType<
    typeof useGetProviderGroupsByHrtIdLazyQuery
>;
export type GetProviderGroupsByHrtIdSuspenseQueryHookResult = ReturnType<
    typeof useGetProviderGroupsByHrtIdSuspenseQuery
>;
export type GetProviderGroupsByHrtIdQueryResult = Apollo.QueryResult<
    GetProviderGroupsByHrtIdQuery,
    GetProviderGroupsByHrtIdQueryVariables
>;
export const GetProductByProductIdDocument = gql`
    query getProductByProductId($id: Int!, $orgId: Int!) {
        findFirstProducts(
            where: {
                AND: [{ id: { equals: $id } }, { orgId: { equals: $orgId } }]
            }
        ) {
            id
            name
            categoryIds
            displayMetadata
            product_page_type
            product_type
            popularity
            renderConfig
            ProductTranslation {
                name
                displayMetadata
                renderConfig
                languageCode
            }
            productToHrt {
                hrtId
                product_component_type
                hrt {
                    hrtId
                    name
                    popularity
                    displayName
                    displayMetadata
                    isBookableOnStorefront
                    productToHrt {
                        productId
                    }
                    _count {
                        activeProviderGroups: providerGroupToHrt(
                            where: { isActive: { equals: true } }
                        )
                    }
                    providerGroupToHrt {
                        isActive
                        providerGroup {
                            providerGroupId
                            practiceId
                        }
                    }
                    isConsumerFacing
                    ehrPrimaryAppointmentTypeId
                    hrtPaymentType {
                        id
                        paymentType
                    }
                    cash_prices {
                        cashPrice
                    }
                    HrtTranslation {
                        name
                        displayName
                        displayMetadata
                        languageCode
                    }
                }
            }
        }
    }
`;

/**
 * __useGetProductByProductIdQuery__
 *
 * To run a query within a React component, call `useGetProductByProductIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductByProductIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductByProductIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetProductByProductIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProductByProductIdQuery,
        GetProductByProductIdQueryVariables
    > &
        (
            | { variables: GetProductByProductIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProductByProductIdQuery,
        GetProductByProductIdQueryVariables
    >(GetProductByProductIdDocument, options);
}
export function useGetProductByProductIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProductByProductIdQuery,
        GetProductByProductIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProductByProductIdQuery,
        GetProductByProductIdQueryVariables
    >(GetProductByProductIdDocument, options);
}
// @ts-ignore
export function useGetProductByProductIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProductByProductIdQuery,
        GetProductByProductIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProductByProductIdQuery,
    GetProductByProductIdQueryVariables
>;
export function useGetProductByProductIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProductByProductIdQuery,
              GetProductByProductIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProductByProductIdQuery | undefined,
    GetProductByProductIdQueryVariables
>;
export function useGetProductByProductIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProductByProductIdQuery,
              GetProductByProductIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProductByProductIdQuery,
        GetProductByProductIdQueryVariables
    >(GetProductByProductIdDocument, options);
}
export type GetProductByProductIdQueryHookResult = ReturnType<
    typeof useGetProductByProductIdQuery
>;
export type GetProductByProductIdLazyQueryHookResult = ReturnType<
    typeof useGetProductByProductIdLazyQuery
>;
export type GetProductByProductIdSuspenseQueryHookResult = ReturnType<
    typeof useGetProductByProductIdSuspenseQuery
>;
export type GetProductByProductIdQueryResult = Apollo.QueryResult<
    GetProductByProductIdQuery,
    GetProductByProductIdQueryVariables
>;
export const GetProductsByProductIdsDocument = gql`
    query getProductsByProductIds($ids: [Int!]!, $orgId: Int!) {
        findManyProducts(
            where: {
                AND: [{ id: { in: $ids } }, { orgId: { equals: $orgId } }]
            }
        ) {
            id
            name
            categoryIds
            displayMetadata
            product_page_type
            product_type
            popularity
            productToHrt {
                hrtId
                product_component_type
                hrt {
                    hrtId
                    name
                    popularity
                    displayName
                    displayMetadata
                    _count {
                        activeProviderGroups: providerGroupToHrt(
                            where: { isActive: { equals: true } }
                        )
                    }
                    providerGroupToHrt {
                        isActive
                        providerGroup {
                            providerGroupId
                            practiceId
                        }
                    }
                    isConsumerFacing
                    ehrPrimaryAppointmentTypeId
                    hrtPaymentType {
                        id
                        paymentType
                    }
                    cash_prices {
                        cashPrice
                    }
                }
            }
        }
    }
`;

/**
 * __useGetProductsByProductIdsQuery__
 *
 * To run a query within a React component, call `useGetProductsByProductIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsByProductIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsByProductIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetProductsByProductIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProductsByProductIdsQuery,
        GetProductsByProductIdsQueryVariables
    > &
        (
            | {
                  variables: GetProductsByProductIdsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProductsByProductIdsQuery,
        GetProductsByProductIdsQueryVariables
    >(GetProductsByProductIdsDocument, options);
}
export function useGetProductsByProductIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProductsByProductIdsQuery,
        GetProductsByProductIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProductsByProductIdsQuery,
        GetProductsByProductIdsQueryVariables
    >(GetProductsByProductIdsDocument, options);
}
// @ts-ignore
export function useGetProductsByProductIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProductsByProductIdsQuery,
        GetProductsByProductIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProductsByProductIdsQuery,
    GetProductsByProductIdsQueryVariables
>;
export function useGetProductsByProductIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProductsByProductIdsQuery,
              GetProductsByProductIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProductsByProductIdsQuery | undefined,
    GetProductsByProductIdsQueryVariables
>;
export function useGetProductsByProductIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProductsByProductIdsQuery,
              GetProductsByProductIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProductsByProductIdsQuery,
        GetProductsByProductIdsQueryVariables
    >(GetProductsByProductIdsDocument, options);
}
export type GetProductsByProductIdsQueryHookResult = ReturnType<
    typeof useGetProductsByProductIdsQuery
>;
export type GetProductsByProductIdsLazyQueryHookResult = ReturnType<
    typeof useGetProductsByProductIdsLazyQuery
>;
export type GetProductsByProductIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetProductsByProductIdsSuspenseQuery
>;
export type GetProductsByProductIdsQueryResult = Apollo.QueryResult<
    GetProductsByProductIdsQuery,
    GetProductsByProductIdsQueryVariables
>;
export const GetUserByPhoneAndOrgDocument = gql`
    query getUserByPhoneAndOrg($phone: String!, $orgId: Int!) {
        users(
            where: {
                phone: { equals: $phone }
                orgId: { equals: $orgId }
                userAccountStatus: { not: { equals: DELETED } }
            }
        ) {
            id
            email
        }
    }
`;

/**
 * __useGetUserByPhoneAndOrgQuery__
 *
 * To run a query within a React component, call `useGetUserByPhoneAndOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByPhoneAndOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByPhoneAndOrgQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetUserByPhoneAndOrgQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserByPhoneAndOrgQuery,
        GetUserByPhoneAndOrgQueryVariables
    > &
        (
            | { variables: GetUserByPhoneAndOrgQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUserByPhoneAndOrgQuery,
        GetUserByPhoneAndOrgQueryVariables
    >(GetUserByPhoneAndOrgDocument, options);
}
export function useGetUserByPhoneAndOrgLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserByPhoneAndOrgQuery,
        GetUserByPhoneAndOrgQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUserByPhoneAndOrgQuery,
        GetUserByPhoneAndOrgQueryVariables
    >(GetUserByPhoneAndOrgDocument, options);
}
// @ts-ignore
export function useGetUserByPhoneAndOrgSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUserByPhoneAndOrgQuery,
        GetUserByPhoneAndOrgQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUserByPhoneAndOrgQuery,
    GetUserByPhoneAndOrgQueryVariables
>;
export function useGetUserByPhoneAndOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserByPhoneAndOrgQuery,
              GetUserByPhoneAndOrgQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUserByPhoneAndOrgQuery | undefined,
    GetUserByPhoneAndOrgQueryVariables
>;
export function useGetUserByPhoneAndOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserByPhoneAndOrgQuery,
              GetUserByPhoneAndOrgQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUserByPhoneAndOrgQuery,
        GetUserByPhoneAndOrgQueryVariables
    >(GetUserByPhoneAndOrgDocument, options);
}
export type GetUserByPhoneAndOrgQueryHookResult = ReturnType<
    typeof useGetUserByPhoneAndOrgQuery
>;
export type GetUserByPhoneAndOrgLazyQueryHookResult = ReturnType<
    typeof useGetUserByPhoneAndOrgLazyQuery
>;
export type GetUserByPhoneAndOrgSuspenseQueryHookResult = ReturnType<
    typeof useGetUserByPhoneAndOrgSuspenseQuery
>;
export type GetUserByPhoneAndOrgQueryResult = Apollo.QueryResult<
    GetUserByPhoneAndOrgQuery,
    GetUserByPhoneAndOrgQueryVariables
>;
export const GetUserByPhoneAndOrgAndEmailDocument = gql`
    query getUserByPhoneAndOrgAndEmail(
        $phone: String!
        $orgId: Int!
        $email: String!
    ) {
        users(
            where: {
                email: { equals: $email }
                phone: { equals: $phone }
                orgId: { equals: $orgId }
                userAccountStatus: { not: { equals: DELETED } }
            }
        ) {
            id
            email
        }
    }
`;

/**
 * __useGetUserByPhoneAndOrgAndEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByPhoneAndOrgAndEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByPhoneAndOrgAndEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByPhoneAndOrgAndEmailQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      orgId: // value for 'orgId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserByPhoneAndOrgAndEmailQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserByPhoneAndOrgAndEmailQuery,
        GetUserByPhoneAndOrgAndEmailQueryVariables
    > &
        (
            | {
                  variables: GetUserByPhoneAndOrgAndEmailQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUserByPhoneAndOrgAndEmailQuery,
        GetUserByPhoneAndOrgAndEmailQueryVariables
    >(GetUserByPhoneAndOrgAndEmailDocument, options);
}
export function useGetUserByPhoneAndOrgAndEmailLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserByPhoneAndOrgAndEmailQuery,
        GetUserByPhoneAndOrgAndEmailQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUserByPhoneAndOrgAndEmailQuery,
        GetUserByPhoneAndOrgAndEmailQueryVariables
    >(GetUserByPhoneAndOrgAndEmailDocument, options);
}
// @ts-ignore
export function useGetUserByPhoneAndOrgAndEmailSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUserByPhoneAndOrgAndEmailQuery,
        GetUserByPhoneAndOrgAndEmailQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUserByPhoneAndOrgAndEmailQuery,
    GetUserByPhoneAndOrgAndEmailQueryVariables
>;
export function useGetUserByPhoneAndOrgAndEmailSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserByPhoneAndOrgAndEmailQuery,
              GetUserByPhoneAndOrgAndEmailQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUserByPhoneAndOrgAndEmailQuery | undefined,
    GetUserByPhoneAndOrgAndEmailQueryVariables
>;
export function useGetUserByPhoneAndOrgAndEmailSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserByPhoneAndOrgAndEmailQuery,
              GetUserByPhoneAndOrgAndEmailQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUserByPhoneAndOrgAndEmailQuery,
        GetUserByPhoneAndOrgAndEmailQueryVariables
    >(GetUserByPhoneAndOrgAndEmailDocument, options);
}
export type GetUserByPhoneAndOrgAndEmailQueryHookResult = ReturnType<
    typeof useGetUserByPhoneAndOrgAndEmailQuery
>;
export type GetUserByPhoneAndOrgAndEmailLazyQueryHookResult = ReturnType<
    typeof useGetUserByPhoneAndOrgAndEmailLazyQuery
>;
export type GetUserByPhoneAndOrgAndEmailSuspenseQueryHookResult = ReturnType<
    typeof useGetUserByPhoneAndOrgAndEmailSuspenseQuery
>;
export type GetUserByPhoneAndOrgAndEmailQueryResult = Apollo.QueryResult<
    GetUserByPhoneAndOrgAndEmailQuery,
    GetUserByPhoneAndOrgAndEmailQueryVariables
>;
export const GetIsUserVerifiedByPhoneNumberDocument = gql`
    query getIsUserVerifiedByPhoneNumber($phone: String!, $orgId: Int!) {
        users(
            where: {
                phone: { equals: $phone }
                orgId: { equals: $orgId }
                verifiedFlag: { equals: true }
                userAccountStatus: { not: { equals: DELETED } }
            }
        ) {
            id
        }
    }
`;

/**
 * __useGetIsUserVerifiedByPhoneNumberQuery__
 *
 * To run a query within a React component, call `useGetIsUserVerifiedByPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsUserVerifiedByPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsUserVerifiedByPhoneNumberQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetIsUserVerifiedByPhoneNumberQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetIsUserVerifiedByPhoneNumberQuery,
        GetIsUserVerifiedByPhoneNumberQueryVariables
    > &
        (
            | {
                  variables: GetIsUserVerifiedByPhoneNumberQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetIsUserVerifiedByPhoneNumberQuery,
        GetIsUserVerifiedByPhoneNumberQueryVariables
    >(GetIsUserVerifiedByPhoneNumberDocument, options);
}
export function useGetIsUserVerifiedByPhoneNumberLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetIsUserVerifiedByPhoneNumberQuery,
        GetIsUserVerifiedByPhoneNumberQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetIsUserVerifiedByPhoneNumberQuery,
        GetIsUserVerifiedByPhoneNumberQueryVariables
    >(GetIsUserVerifiedByPhoneNumberDocument, options);
}
// @ts-ignore
export function useGetIsUserVerifiedByPhoneNumberSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetIsUserVerifiedByPhoneNumberQuery,
        GetIsUserVerifiedByPhoneNumberQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetIsUserVerifiedByPhoneNumberQuery,
    GetIsUserVerifiedByPhoneNumberQueryVariables
>;
export function useGetIsUserVerifiedByPhoneNumberSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIsUserVerifiedByPhoneNumberQuery,
              GetIsUserVerifiedByPhoneNumberQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetIsUserVerifiedByPhoneNumberQuery | undefined,
    GetIsUserVerifiedByPhoneNumberQueryVariables
>;
export function useGetIsUserVerifiedByPhoneNumberSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIsUserVerifiedByPhoneNumberQuery,
              GetIsUserVerifiedByPhoneNumberQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetIsUserVerifiedByPhoneNumberQuery,
        GetIsUserVerifiedByPhoneNumberQueryVariables
    >(GetIsUserVerifiedByPhoneNumberDocument, options);
}
export type GetIsUserVerifiedByPhoneNumberQueryHookResult = ReturnType<
    typeof useGetIsUserVerifiedByPhoneNumberQuery
>;
export type GetIsUserVerifiedByPhoneNumberLazyQueryHookResult = ReturnType<
    typeof useGetIsUserVerifiedByPhoneNumberLazyQuery
>;
export type GetIsUserVerifiedByPhoneNumberSuspenseQueryHookResult = ReturnType<
    typeof useGetIsUserVerifiedByPhoneNumberSuspenseQuery
>;
export type GetIsUserVerifiedByPhoneNumberQueryResult = Apollo.QueryResult<
    GetIsUserVerifiedByPhoneNumberQuery,
    GetIsUserVerifiedByPhoneNumberQueryVariables
>;
export const GetMatchingConsumerDocument = gql`
    query getMatchingConsumer(
        $userId: String!
        $dob: DateTimeISO!
        $firstName: String!
        $lastName: String!
    ) {
        consumers(
            where: {
                userId: { equals: $userId }
                dob: { equals: $dob }
                firstname: { equals: $firstName, mode: insensitive }
                lastname: { equals: $lastName, mode: insensitive }
                consumerAccountStatus: { not: { equals: DELETED } }
                user: {
                    is: { userAccountStatus: { not: { equals: DELETED } } }
                }
            }
        ) {
            id
            firstname
            lastname
            dob
            streetAddress
            city
            state
            zip
            country
            sex
            insurances {
                id
                memberId
                payer
                state
                status
                planName
                planStartDate
                planEndDate
                insuranceAccountStatus
                isPrimaryInsurance
                priority
            }
            ehrPatientId
            ehrEnterpriseId
        }
    }
`;

/**
 * __useGetMatchingConsumerQuery__
 *
 * To run a query within a React component, call `useGetMatchingConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchingConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchingConsumerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      dob: // value for 'dob'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useGetMatchingConsumerQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMatchingConsumerQuery,
        GetMatchingConsumerQueryVariables
    > &
        (
            | { variables: GetMatchingConsumerQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetMatchingConsumerQuery,
        GetMatchingConsumerQueryVariables
    >(GetMatchingConsumerDocument, options);
}
export function useGetMatchingConsumerLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMatchingConsumerQuery,
        GetMatchingConsumerQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetMatchingConsumerQuery,
        GetMatchingConsumerQueryVariables
    >(GetMatchingConsumerDocument, options);
}
// @ts-ignore
export function useGetMatchingConsumerSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetMatchingConsumerQuery,
        GetMatchingConsumerQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetMatchingConsumerQuery,
    GetMatchingConsumerQueryVariables
>;
export function useGetMatchingConsumerSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMatchingConsumerQuery,
              GetMatchingConsumerQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetMatchingConsumerQuery | undefined,
    GetMatchingConsumerQueryVariables
>;
export function useGetMatchingConsumerSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMatchingConsumerQuery,
              GetMatchingConsumerQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetMatchingConsumerQuery,
        GetMatchingConsumerQueryVariables
    >(GetMatchingConsumerDocument, options);
}
export type GetMatchingConsumerQueryHookResult = ReturnType<
    typeof useGetMatchingConsumerQuery
>;
export type GetMatchingConsumerLazyQueryHookResult = ReturnType<
    typeof useGetMatchingConsumerLazyQuery
>;
export type GetMatchingConsumerSuspenseQueryHookResult = ReturnType<
    typeof useGetMatchingConsumerSuspenseQuery
>;
export type GetMatchingConsumerQueryResult = Apollo.QueryResult<
    GetMatchingConsumerQuery,
    GetMatchingConsumerQueryVariables
>;
export const GetMatchingConsumerWithActiveInsuranceDocument = gql`
    query getMatchingConsumerWithActiveInsurance(
        $userId: String!
        $dob: DateTimeISO!
        $firstName: String!
        $lastName: String!
    ) {
        consumers(
            where: {
                userId: { equals: $userId }
                dob: { equals: $dob }
                firstname: { equals: $firstName, mode: insensitive }
                lastname: { equals: $lastName, mode: insensitive }
                consumerAccountStatus: { not: { equals: DELETED } }
                user: {
                    is: { userAccountStatus: { not: { equals: DELETED } } }
                }
                insurances: {
                    some: {
                        insuranceAccountStatus: { equals: CONNECTED }
                        status: { in: [active, inactive, unverified] }
                    }
                }
            }
        ) {
            id
            firstname
            lastname
            dob
            streetAddress
            city
            state
            zip
            country
            sex
            insurances {
                id
                memberId
                payer
                state
                status
                planName
                planStartDate
                planEndDate
                insuranceAccountStatus
                isPrimaryInsurance
                priority
            }
        }
    }
`;

/**
 * __useGetMatchingConsumerWithActiveInsuranceQuery__
 *
 * To run a query within a React component, call `useGetMatchingConsumerWithActiveInsuranceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchingConsumerWithActiveInsuranceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchingConsumerWithActiveInsuranceQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      dob: // value for 'dob'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useGetMatchingConsumerWithActiveInsuranceQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMatchingConsumerWithActiveInsuranceQuery,
        GetMatchingConsumerWithActiveInsuranceQueryVariables
    > &
        (
            | {
                  variables: GetMatchingConsumerWithActiveInsuranceQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetMatchingConsumerWithActiveInsuranceQuery,
        GetMatchingConsumerWithActiveInsuranceQueryVariables
    >(GetMatchingConsumerWithActiveInsuranceDocument, options);
}
export function useGetMatchingConsumerWithActiveInsuranceLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMatchingConsumerWithActiveInsuranceQuery,
        GetMatchingConsumerWithActiveInsuranceQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetMatchingConsumerWithActiveInsuranceQuery,
        GetMatchingConsumerWithActiveInsuranceQueryVariables
    >(GetMatchingConsumerWithActiveInsuranceDocument, options);
}
// @ts-ignore
export function useGetMatchingConsumerWithActiveInsuranceSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetMatchingConsumerWithActiveInsuranceQuery,
        GetMatchingConsumerWithActiveInsuranceQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetMatchingConsumerWithActiveInsuranceQuery,
    GetMatchingConsumerWithActiveInsuranceQueryVariables
>;
export function useGetMatchingConsumerWithActiveInsuranceSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMatchingConsumerWithActiveInsuranceQuery,
              GetMatchingConsumerWithActiveInsuranceQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetMatchingConsumerWithActiveInsuranceQuery | undefined,
    GetMatchingConsumerWithActiveInsuranceQueryVariables
>;
export function useGetMatchingConsumerWithActiveInsuranceSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMatchingConsumerWithActiveInsuranceQuery,
              GetMatchingConsumerWithActiveInsuranceQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetMatchingConsumerWithActiveInsuranceQuery,
        GetMatchingConsumerWithActiveInsuranceQueryVariables
    >(GetMatchingConsumerWithActiveInsuranceDocument, options);
}
export type GetMatchingConsumerWithActiveInsuranceQueryHookResult = ReturnType<
    typeof useGetMatchingConsumerWithActiveInsuranceQuery
>;
export type GetMatchingConsumerWithActiveInsuranceLazyQueryHookResult =
    ReturnType<typeof useGetMatchingConsumerWithActiveInsuranceLazyQuery>;
export type GetMatchingConsumerWithActiveInsuranceSuspenseQueryHookResult =
    ReturnType<typeof useGetMatchingConsumerWithActiveInsuranceSuspenseQuery>;
export type GetMatchingConsumerWithActiveInsuranceQueryResult =
    Apollo.QueryResult<
        GetMatchingConsumerWithActiveInsuranceQuery,
        GetMatchingConsumerWithActiveInsuranceQueryVariables
    >;
export const FindConsumerWithInsuranceByNameAndDobDocument = gql`
    query findConsumerWithInsuranceByNameAndDob(
        $dob: DateTimeISO!
        $firstName: String!
        $lastName: String!
    ) {
        consumers(
            where: {
                dob: { equals: $dob }
                firstname: { equals: $firstName, mode: insensitive }
                lastname: { equals: $lastName, mode: insensitive }
                insurances: {
                    some: {
                        insuranceAccountStatus: { equals: CONNECTED }
                        status: { equals: active }
                    }
                }
            }
        ) {
            id
            user {
                orgId
                phone
                email
                id
                primaryLanguage
            }
        }
    }
`;

/**
 * __useFindConsumerWithInsuranceByNameAndDobQuery__
 *
 * To run a query within a React component, call `useFindConsumerWithInsuranceByNameAndDobQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindConsumerWithInsuranceByNameAndDobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindConsumerWithInsuranceByNameAndDobQuery({
 *   variables: {
 *      dob: // value for 'dob'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useFindConsumerWithInsuranceByNameAndDobQuery(
    baseOptions: Apollo.QueryHookOptions<
        FindConsumerWithInsuranceByNameAndDobQuery,
        FindConsumerWithInsuranceByNameAndDobQueryVariables
    > &
        (
            | {
                  variables: FindConsumerWithInsuranceByNameAndDobQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        FindConsumerWithInsuranceByNameAndDobQuery,
        FindConsumerWithInsuranceByNameAndDobQueryVariables
    >(FindConsumerWithInsuranceByNameAndDobDocument, options);
}
export function useFindConsumerWithInsuranceByNameAndDobLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        FindConsumerWithInsuranceByNameAndDobQuery,
        FindConsumerWithInsuranceByNameAndDobQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        FindConsumerWithInsuranceByNameAndDobQuery,
        FindConsumerWithInsuranceByNameAndDobQueryVariables
    >(FindConsumerWithInsuranceByNameAndDobDocument, options);
}
// @ts-ignore
export function useFindConsumerWithInsuranceByNameAndDobSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        FindConsumerWithInsuranceByNameAndDobQuery,
        FindConsumerWithInsuranceByNameAndDobQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    FindConsumerWithInsuranceByNameAndDobQuery,
    FindConsumerWithInsuranceByNameAndDobQueryVariables
>;
export function useFindConsumerWithInsuranceByNameAndDobSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              FindConsumerWithInsuranceByNameAndDobQuery,
              FindConsumerWithInsuranceByNameAndDobQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    FindConsumerWithInsuranceByNameAndDobQuery | undefined,
    FindConsumerWithInsuranceByNameAndDobQueryVariables
>;
export function useFindConsumerWithInsuranceByNameAndDobSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              FindConsumerWithInsuranceByNameAndDobQuery,
              FindConsumerWithInsuranceByNameAndDobQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        FindConsumerWithInsuranceByNameAndDobQuery,
        FindConsumerWithInsuranceByNameAndDobQueryVariables
    >(FindConsumerWithInsuranceByNameAndDobDocument, options);
}
export type FindConsumerWithInsuranceByNameAndDobQueryHookResult = ReturnType<
    typeof useFindConsumerWithInsuranceByNameAndDobQuery
>;
export type FindConsumerWithInsuranceByNameAndDobLazyQueryHookResult =
    ReturnType<typeof useFindConsumerWithInsuranceByNameAndDobLazyQuery>;
export type FindConsumerWithInsuranceByNameAndDobSuspenseQueryHookResult =
    ReturnType<typeof useFindConsumerWithInsuranceByNameAndDobSuspenseQuery>;
export type FindConsumerWithInsuranceByNameAndDobQueryResult =
    Apollo.QueryResult<
        FindConsumerWithInsuranceByNameAndDobQuery,
        FindConsumerWithInsuranceByNameAndDobQueryVariables
    >;
export const FindConsumerByNameDobAndContactDocument = gql`
    query findConsumerByNameDobAndContact(
        $dob: DateTimeISO!
        $phone: String
        $email: String
        $orgId: Int!
    ) {
        consumers(
            where: {
                dob: { equals: $dob }
                consumerAccountStatus: { equals: CONNECTED }
                user: {
                    is: {
                        orgId: { equals: $orgId }
                        OR: [
                            { phone: { equals: $phone } }
                            { email: { equals: $email } }
                        ]
                    }
                }
            }
        ) {
            id
            firstname
            lastname
            dob
            consumerAccountStatus
            user {
                orgId
                phone
                email
                id
                primaryLanguage
            }
        }
    }
`;

/**
 * __useFindConsumerByNameDobAndContactQuery__
 *
 * To run a query within a React component, call `useFindConsumerByNameDobAndContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindConsumerByNameDobAndContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindConsumerByNameDobAndContactQuery({
 *   variables: {
 *      dob: // value for 'dob'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useFindConsumerByNameDobAndContactQuery(
    baseOptions: Apollo.QueryHookOptions<
        FindConsumerByNameDobAndContactQuery,
        FindConsumerByNameDobAndContactQueryVariables
    > &
        (
            | {
                  variables: FindConsumerByNameDobAndContactQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        FindConsumerByNameDobAndContactQuery,
        FindConsumerByNameDobAndContactQueryVariables
    >(FindConsumerByNameDobAndContactDocument, options);
}
export function useFindConsumerByNameDobAndContactLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        FindConsumerByNameDobAndContactQuery,
        FindConsumerByNameDobAndContactQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        FindConsumerByNameDobAndContactQuery,
        FindConsumerByNameDobAndContactQueryVariables
    >(FindConsumerByNameDobAndContactDocument, options);
}
// @ts-ignore
export function useFindConsumerByNameDobAndContactSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        FindConsumerByNameDobAndContactQuery,
        FindConsumerByNameDobAndContactQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    FindConsumerByNameDobAndContactQuery,
    FindConsumerByNameDobAndContactQueryVariables
>;
export function useFindConsumerByNameDobAndContactSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              FindConsumerByNameDobAndContactQuery,
              FindConsumerByNameDobAndContactQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    FindConsumerByNameDobAndContactQuery | undefined,
    FindConsumerByNameDobAndContactQueryVariables
>;
export function useFindConsumerByNameDobAndContactSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              FindConsumerByNameDobAndContactQuery,
              FindConsumerByNameDobAndContactQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        FindConsumerByNameDobAndContactQuery,
        FindConsumerByNameDobAndContactQueryVariables
    >(FindConsumerByNameDobAndContactDocument, options);
}
export type FindConsumerByNameDobAndContactQueryHookResult = ReturnType<
    typeof useFindConsumerByNameDobAndContactQuery
>;
export type FindConsumerByNameDobAndContactLazyQueryHookResult = ReturnType<
    typeof useFindConsumerByNameDobAndContactLazyQuery
>;
export type FindConsumerByNameDobAndContactSuspenseQueryHookResult = ReturnType<
    typeof useFindConsumerByNameDobAndContactSuspenseQuery
>;
export type FindConsumerByNameDobAndContactQueryResult = Apollo.QueryResult<
    FindConsumerByNameDobAndContactQuery,
    FindConsumerByNameDobAndContactQueryVariables
>;
export const FindConsumerByContactDocument = gql`
    query findConsumerByContact($phone: String, $email: String, $orgId: Int!) {
        consumers(
            where: {
                ehrPatientId: { not: { equals: null } }
                consumerAccountStatus: { equals: CONNECTED }
                user: {
                    is: {
                        orgId: { equals: $orgId }
                        userAccountStatus: { equals: CONNECTED }
                        OR: [
                            { phone: { equals: $phone } }
                            { email: { equals: $email } }
                        ]
                    }
                }
            }
        ) {
            id
            firstname
            lastname
            dob
            ehrPatientId
            consumerAccountStatus
            user {
                id
                orgId
                phone
                email
                userAccountStatus
                primaryLanguage
            }
            insurances {
                id
                memberId
                payer
                state
                ehrInsuranceId
                status
                insuranceAccountStatus
                isPrimaryInsurance
                priority
            }
        }
    }
`;

/**
 * __useFindConsumerByContactQuery__
 *
 * To run a query within a React component, call `useFindConsumerByContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindConsumerByContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindConsumerByContactQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useFindConsumerByContactQuery(
    baseOptions: Apollo.QueryHookOptions<
        FindConsumerByContactQuery,
        FindConsumerByContactQueryVariables
    > &
        (
            | { variables: FindConsumerByContactQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        FindConsumerByContactQuery,
        FindConsumerByContactQueryVariables
    >(FindConsumerByContactDocument, options);
}
export function useFindConsumerByContactLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        FindConsumerByContactQuery,
        FindConsumerByContactQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        FindConsumerByContactQuery,
        FindConsumerByContactQueryVariables
    >(FindConsumerByContactDocument, options);
}
// @ts-ignore
export function useFindConsumerByContactSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        FindConsumerByContactQuery,
        FindConsumerByContactQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    FindConsumerByContactQuery,
    FindConsumerByContactQueryVariables
>;
export function useFindConsumerByContactSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              FindConsumerByContactQuery,
              FindConsumerByContactQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    FindConsumerByContactQuery | undefined,
    FindConsumerByContactQueryVariables
>;
export function useFindConsumerByContactSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              FindConsumerByContactQuery,
              FindConsumerByContactQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        FindConsumerByContactQuery,
        FindConsumerByContactQueryVariables
    >(FindConsumerByContactDocument, options);
}
export type FindConsumerByContactQueryHookResult = ReturnType<
    typeof useFindConsumerByContactQuery
>;
export type FindConsumerByContactLazyQueryHookResult = ReturnType<
    typeof useFindConsumerByContactLazyQuery
>;
export type FindConsumerByContactSuspenseQueryHookResult = ReturnType<
    typeof useFindConsumerByContactSuspenseQuery
>;
export type FindConsumerByContactQueryResult = Apollo.QueryResult<
    FindConsumerByContactQuery,
    FindConsumerByContactQueryVariables
>;
export const GetHrtsDocument = gql`
    query getHrts(
        $where: HrtWhereInput
        $orderBy: [HrtOrderByWithRelationInput!]
    ) {
        hrts(where: $where, orderBy: $orderBy, distinct: hrtId) {
            hrtId
            name
            displayName
            displayMetadata
            ehrPrimaryAppointmentTypeId
            isConsumerFacing
            popularity
            isBookableOnStorefront
            customDuration
            productToHrt {
                productId
            }
            _count {
                activeProviderGroups: providerGroupToHrt(
                    where: { isActive: { equals: true } }
                )
            }
            HrtFlags {
                isVirtualVisit
                isSurgery
                isGlobalBilling
                isAnnualVisit
                kioskHrtType
            }
            hrtPaymentType {
                paymentType
            }
            cash_prices {
                cashPrice
            }
            providerGroupToHrt {
                isActive
                notBookable
                providerGroup {
                    providerGroupId
                    practiceId
                }
            }
            HrtTranslation {
                name
                displayName
                displayMetadata
                languageCode
            }
        }
    }
`;

/**
 * __useGetHrtsQuery__
 *
 * To run a query within a React component, call `useGetHrtsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrtsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHrtsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetHrtsQuery(
    baseOptions?: Apollo.QueryHookOptions<GetHrtsQuery, GetHrtsQueryVariables>,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetHrtsQuery, GetHrtsQueryVariables>(
        GetHrtsDocument,
        options,
    );
}
export function useGetHrtsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetHrtsQuery,
        GetHrtsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetHrtsQuery, GetHrtsQueryVariables>(
        GetHrtsDocument,
        options,
    );
}
// @ts-ignore
export function useGetHrtsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetHrtsQuery,
        GetHrtsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<GetHrtsQuery, GetHrtsQueryVariables>;
export function useGetHrtsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetHrtsQuery, GetHrtsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
    GetHrtsQuery | undefined,
    GetHrtsQueryVariables
>;
export function useGetHrtsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetHrtsQuery, GetHrtsQueryVariables>,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetHrtsQuery, GetHrtsQueryVariables>(
        GetHrtsDocument,
        options,
    );
}
export type GetHrtsQueryHookResult = ReturnType<typeof useGetHrtsQuery>;
export type GetHrtsLazyQueryHookResult = ReturnType<typeof useGetHrtsLazyQuery>;
export type GetHrtsSuspenseQueryHookResult = ReturnType<
    typeof useGetHrtsSuspenseQuery
>;
export type GetHrtsQueryResult = Apollo.QueryResult<
    GetHrtsQuery,
    GetHrtsQueryVariables
>;
export const GetResourcesFromPricedTreatmentIdsDocument = gql`
    query getResourcesFromPricedTreatmentIds($pricedTreatmentIds: [Int!]!) {
        pricedTreatments(where: { id: { in: $pricedTreatmentIds } }) {
            hrt {
                additionalResources
            }
        }
    }
`;

/**
 * __useGetResourcesFromPricedTreatmentIdsQuery__
 *
 * To run a query within a React component, call `useGetResourcesFromPricedTreatmentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesFromPricedTreatmentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesFromPricedTreatmentIdsQuery({
 *   variables: {
 *      pricedTreatmentIds: // value for 'pricedTreatmentIds'
 *   },
 * });
 */
export function useGetResourcesFromPricedTreatmentIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetResourcesFromPricedTreatmentIdsQuery,
        GetResourcesFromPricedTreatmentIdsQueryVariables
    > &
        (
            | {
                  variables: GetResourcesFromPricedTreatmentIdsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetResourcesFromPricedTreatmentIdsQuery,
        GetResourcesFromPricedTreatmentIdsQueryVariables
    >(GetResourcesFromPricedTreatmentIdsDocument, options);
}
export function useGetResourcesFromPricedTreatmentIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetResourcesFromPricedTreatmentIdsQuery,
        GetResourcesFromPricedTreatmentIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetResourcesFromPricedTreatmentIdsQuery,
        GetResourcesFromPricedTreatmentIdsQueryVariables
    >(GetResourcesFromPricedTreatmentIdsDocument, options);
}
// @ts-ignore
export function useGetResourcesFromPricedTreatmentIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetResourcesFromPricedTreatmentIdsQuery,
        GetResourcesFromPricedTreatmentIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetResourcesFromPricedTreatmentIdsQuery,
    GetResourcesFromPricedTreatmentIdsQueryVariables
>;
export function useGetResourcesFromPricedTreatmentIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetResourcesFromPricedTreatmentIdsQuery,
              GetResourcesFromPricedTreatmentIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetResourcesFromPricedTreatmentIdsQuery | undefined,
    GetResourcesFromPricedTreatmentIdsQueryVariables
>;
export function useGetResourcesFromPricedTreatmentIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetResourcesFromPricedTreatmentIdsQuery,
              GetResourcesFromPricedTreatmentIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetResourcesFromPricedTreatmentIdsQuery,
        GetResourcesFromPricedTreatmentIdsQueryVariables
    >(GetResourcesFromPricedTreatmentIdsDocument, options);
}
export type GetResourcesFromPricedTreatmentIdsQueryHookResult = ReturnType<
    typeof useGetResourcesFromPricedTreatmentIdsQuery
>;
export type GetResourcesFromPricedTreatmentIdsLazyQueryHookResult = ReturnType<
    typeof useGetResourcesFromPricedTreatmentIdsLazyQuery
>;
export type GetResourcesFromPricedTreatmentIdsSuspenseQueryHookResult =
    ReturnType<typeof useGetResourcesFromPricedTreatmentIdsSuspenseQuery>;
export type GetResourcesFromPricedTreatmentIdsQueryResult = Apollo.QueryResult<
    GetResourcesFromPricedTreatmentIdsQuery,
    GetResourcesFromPricedTreatmentIdsQueryVariables
>;
export const GetAllHrtPaymentTypesForOrgDocument = gql`
    query getAllHrtPaymentTypesForOrg($orgId: Int!) {
        hrts(where: { orgId: { equals: $orgId } }) {
            hrtId
            hrtPaymentType {
                paymentType
            }
            ehrPrimaryAppointmentTypeId
        }
    }
`;

/**
 * __useGetAllHrtPaymentTypesForOrgQuery__
 *
 * To run a query within a React component, call `useGetAllHrtPaymentTypesForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllHrtPaymentTypesForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllHrtPaymentTypesForOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetAllHrtPaymentTypesForOrgQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAllHrtPaymentTypesForOrgQuery,
        GetAllHrtPaymentTypesForOrgQueryVariables
    > &
        (
            | {
                  variables: GetAllHrtPaymentTypesForOrgQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAllHrtPaymentTypesForOrgQuery,
        GetAllHrtPaymentTypesForOrgQueryVariables
    >(GetAllHrtPaymentTypesForOrgDocument, options);
}
export function useGetAllHrtPaymentTypesForOrgLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllHrtPaymentTypesForOrgQuery,
        GetAllHrtPaymentTypesForOrgQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAllHrtPaymentTypesForOrgQuery,
        GetAllHrtPaymentTypesForOrgQueryVariables
    >(GetAllHrtPaymentTypesForOrgDocument, options);
}
// @ts-ignore
export function useGetAllHrtPaymentTypesForOrgSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAllHrtPaymentTypesForOrgQuery,
        GetAllHrtPaymentTypesForOrgQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAllHrtPaymentTypesForOrgQuery,
    GetAllHrtPaymentTypesForOrgQueryVariables
>;
export function useGetAllHrtPaymentTypesForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllHrtPaymentTypesForOrgQuery,
              GetAllHrtPaymentTypesForOrgQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAllHrtPaymentTypesForOrgQuery | undefined,
    GetAllHrtPaymentTypesForOrgQueryVariables
>;
export function useGetAllHrtPaymentTypesForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllHrtPaymentTypesForOrgQuery,
              GetAllHrtPaymentTypesForOrgQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAllHrtPaymentTypesForOrgQuery,
        GetAllHrtPaymentTypesForOrgQueryVariables
    >(GetAllHrtPaymentTypesForOrgDocument, options);
}
export type GetAllHrtPaymentTypesForOrgQueryHookResult = ReturnType<
    typeof useGetAllHrtPaymentTypesForOrgQuery
>;
export type GetAllHrtPaymentTypesForOrgLazyQueryHookResult = ReturnType<
    typeof useGetAllHrtPaymentTypesForOrgLazyQuery
>;
export type GetAllHrtPaymentTypesForOrgSuspenseQueryHookResult = ReturnType<
    typeof useGetAllHrtPaymentTypesForOrgSuspenseQuery
>;
export type GetAllHrtPaymentTypesForOrgQueryResult = Apollo.QueryResult<
    GetAllHrtPaymentTypesForOrgQuery,
    GetAllHrtPaymentTypesForOrgQueryVariables
>;
export const GetAllCategoriesDocument = gql`
    query getAllCategories($id: Int!) {
        findManyProductCategories(
            where: { AND: [{ orgId: { equals: $id } }] }
        ) {
            id
            orgId
            name
            displayMetadata
            type
        }
    }
`;

/**
 * __useGetAllCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCategoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllCategoriesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAllCategoriesQuery,
        GetAllCategoriesQueryVariables
    > &
        (
            | { variables: GetAllCategoriesQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAllCategoriesQuery,
        GetAllCategoriesQueryVariables
    >(GetAllCategoriesDocument, options);
}
export function useGetAllCategoriesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllCategoriesQuery,
        GetAllCategoriesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAllCategoriesQuery,
        GetAllCategoriesQueryVariables
    >(GetAllCategoriesDocument, options);
}
// @ts-ignore
export function useGetAllCategoriesSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAllCategoriesQuery,
        GetAllCategoriesQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAllCategoriesQuery,
    GetAllCategoriesQueryVariables
>;
export function useGetAllCategoriesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllCategoriesQuery,
              GetAllCategoriesQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAllCategoriesQuery | undefined,
    GetAllCategoriesQueryVariables
>;
export function useGetAllCategoriesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllCategoriesQuery,
              GetAllCategoriesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAllCategoriesQuery,
        GetAllCategoriesQueryVariables
    >(GetAllCategoriesDocument, options);
}
export type GetAllCategoriesQueryHookResult = ReturnType<
    typeof useGetAllCategoriesQuery
>;
export type GetAllCategoriesLazyQueryHookResult = ReturnType<
    typeof useGetAllCategoriesLazyQuery
>;
export type GetAllCategoriesSuspenseQueryHookResult = ReturnType<
    typeof useGetAllCategoriesSuspenseQuery
>;
export type GetAllCategoriesQueryResult = Apollo.QueryResult<
    GetAllCategoriesQuery,
    GetAllCategoriesQueryVariables
>;
export const GetOrgDataByPracticeDocument = gql`
    query getOrgDataByPractice($practiceId: Int!) {
        practice(where: { practiceId: $practiceId }) {
            orgId
            org {
                orgTitle
            }
        }
    }
`;

/**
 * __useGetOrgDataByPracticeQuery__
 *
 * To run a query within a React component, call `useGetOrgDataByPracticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgDataByPracticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgDataByPracticeQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *   },
 * });
 */
export function useGetOrgDataByPracticeQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOrgDataByPracticeQuery,
        GetOrgDataByPracticeQueryVariables
    > &
        (
            | { variables: GetOrgDataByPracticeQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrgDataByPracticeQuery,
        GetOrgDataByPracticeQueryVariables
    >(GetOrgDataByPracticeDocument, options);
}
export function useGetOrgDataByPracticeLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrgDataByPracticeQuery,
        GetOrgDataByPracticeQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrgDataByPracticeQuery,
        GetOrgDataByPracticeQueryVariables
    >(GetOrgDataByPracticeDocument, options);
}
// @ts-ignore
export function useGetOrgDataByPracticeSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrgDataByPracticeQuery,
        GetOrgDataByPracticeQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrgDataByPracticeQuery,
    GetOrgDataByPracticeQueryVariables
>;
export function useGetOrgDataByPracticeSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgDataByPracticeQuery,
              GetOrgDataByPracticeQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrgDataByPracticeQuery | undefined,
    GetOrgDataByPracticeQueryVariables
>;
export function useGetOrgDataByPracticeSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgDataByPracticeQuery,
              GetOrgDataByPracticeQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrgDataByPracticeQuery,
        GetOrgDataByPracticeQueryVariables
    >(GetOrgDataByPracticeDocument, options);
}
export type GetOrgDataByPracticeQueryHookResult = ReturnType<
    typeof useGetOrgDataByPracticeQuery
>;
export type GetOrgDataByPracticeLazyQueryHookResult = ReturnType<
    typeof useGetOrgDataByPracticeLazyQuery
>;
export type GetOrgDataByPracticeSuspenseQueryHookResult = ReturnType<
    typeof useGetOrgDataByPracticeSuspenseQuery
>;
export type GetOrgDataByPracticeQueryResult = Apollo.QueryResult<
    GetOrgDataByPracticeQuery,
    GetOrgDataByPracticeQueryVariables
>;
export const GetOrgFaqDropdownInfoDocument = gql`
    query getOrgFaqDropdownInfo($id: Int!) {
        findManyFaqDropdowns(where: { orgId: { equals: $id } }) {
            orgId
            question
            answer
            priority
        }
    }
`;

/**
 * __useGetOrgFaqDropdownInfoQuery__
 *
 * To run a query within a React component, call `useGetOrgFaqDropdownInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgFaqDropdownInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgFaqDropdownInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrgFaqDropdownInfoQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOrgFaqDropdownInfoQuery,
        GetOrgFaqDropdownInfoQueryVariables
    > &
        (
            | { variables: GetOrgFaqDropdownInfoQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrgFaqDropdownInfoQuery,
        GetOrgFaqDropdownInfoQueryVariables
    >(GetOrgFaqDropdownInfoDocument, options);
}
export function useGetOrgFaqDropdownInfoLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrgFaqDropdownInfoQuery,
        GetOrgFaqDropdownInfoQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrgFaqDropdownInfoQuery,
        GetOrgFaqDropdownInfoQueryVariables
    >(GetOrgFaqDropdownInfoDocument, options);
}
// @ts-ignore
export function useGetOrgFaqDropdownInfoSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrgFaqDropdownInfoQuery,
        GetOrgFaqDropdownInfoQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrgFaqDropdownInfoQuery,
    GetOrgFaqDropdownInfoQueryVariables
>;
export function useGetOrgFaqDropdownInfoSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgFaqDropdownInfoQuery,
              GetOrgFaqDropdownInfoQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrgFaqDropdownInfoQuery | undefined,
    GetOrgFaqDropdownInfoQueryVariables
>;
export function useGetOrgFaqDropdownInfoSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgFaqDropdownInfoQuery,
              GetOrgFaqDropdownInfoQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrgFaqDropdownInfoQuery,
        GetOrgFaqDropdownInfoQueryVariables
    >(GetOrgFaqDropdownInfoDocument, options);
}
export type GetOrgFaqDropdownInfoQueryHookResult = ReturnType<
    typeof useGetOrgFaqDropdownInfoQuery
>;
export type GetOrgFaqDropdownInfoLazyQueryHookResult = ReturnType<
    typeof useGetOrgFaqDropdownInfoLazyQuery
>;
export type GetOrgFaqDropdownInfoSuspenseQueryHookResult = ReturnType<
    typeof useGetOrgFaqDropdownInfoSuspenseQuery
>;
export type GetOrgFaqDropdownInfoQueryResult = Apollo.QueryResult<
    GetOrgFaqDropdownInfoQuery,
    GetOrgFaqDropdownInfoQueryVariables
>;
export const GetPracticeByIdDocument = gql`
    query getPracticeById($id: Int!) {
        practice(where: { practiceId: $id }) {
            practiceId
            orgId
            address
            googleMapsUrl
            googleMapsEmbed
            locationName
            metadata
            phoneNumber
            ehrLocationId
            timezone
        }
    }
`;

/**
 * __useGetPracticeByIdQuery__
 *
 * To run a query within a React component, call `useGetPracticeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPracticeByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPracticeByIdQuery,
        GetPracticeByIdQueryVariables
    > &
        (
            | { variables: GetPracticeByIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetPracticeByIdQuery, GetPracticeByIdQueryVariables>(
        GetPracticeByIdDocument,
        options,
    );
}
export function useGetPracticeByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPracticeByIdQuery,
        GetPracticeByIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPracticeByIdQuery,
        GetPracticeByIdQueryVariables
    >(GetPracticeByIdDocument, options);
}
// @ts-ignore
export function useGetPracticeByIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetPracticeByIdQuery,
        GetPracticeByIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetPracticeByIdQuery,
    GetPracticeByIdQueryVariables
>;
export function useGetPracticeByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticeByIdQuery,
              GetPracticeByIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetPracticeByIdQuery | undefined,
    GetPracticeByIdQueryVariables
>;
export function useGetPracticeByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticeByIdQuery,
              GetPracticeByIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPracticeByIdQuery,
        GetPracticeByIdQueryVariables
    >(GetPracticeByIdDocument, options);
}
export type GetPracticeByIdQueryHookResult = ReturnType<
    typeof useGetPracticeByIdQuery
>;
export type GetPracticeByIdLazyQueryHookResult = ReturnType<
    typeof useGetPracticeByIdLazyQuery
>;
export type GetPracticeByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetPracticeByIdSuspenseQuery
>;
export type GetPracticeByIdQueryResult = Apollo.QueryResult<
    GetPracticeByIdQuery,
    GetPracticeByIdQueryVariables
>;
export const GetPracticesByIdsDocument = gql`
    query getPracticesByIds($ids: [Int!]!) {
        practices(where: { practiceId: { in: $ids } }) {
            practiceId
            orgId
            address
            googleMapsUrl
            googleMapsEmbed
            locationName
            metadata
            phoneNumber
            ehrLocationId
            isAvailableFromStorefront
            timezone
        }
    }
`;

/**
 * __useGetPracticesByIdsQuery__
 *
 * To run a query within a React component, call `useGetPracticesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetPracticesByIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPracticesByIdsQuery,
        GetPracticesByIdsQueryVariables
    > &
        (
            | { variables: GetPracticesByIdsQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetPracticesByIdsQuery,
        GetPracticesByIdsQueryVariables
    >(GetPracticesByIdsDocument, options);
}
export function useGetPracticesByIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPracticesByIdsQuery,
        GetPracticesByIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPracticesByIdsQuery,
        GetPracticesByIdsQueryVariables
    >(GetPracticesByIdsDocument, options);
}
// @ts-ignore
export function useGetPracticesByIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetPracticesByIdsQuery,
        GetPracticesByIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetPracticesByIdsQuery,
    GetPracticesByIdsQueryVariables
>;
export function useGetPracticesByIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticesByIdsQuery,
              GetPracticesByIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetPracticesByIdsQuery | undefined,
    GetPracticesByIdsQueryVariables
>;
export function useGetPracticesByIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticesByIdsQuery,
              GetPracticesByIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPracticesByIdsQuery,
        GetPracticesByIdsQueryVariables
    >(GetPracticesByIdsDocument, options);
}
export type GetPracticesByIdsQueryHookResult = ReturnType<
    typeof useGetPracticesByIdsQuery
>;
export type GetPracticesByIdsLazyQueryHookResult = ReturnType<
    typeof useGetPracticesByIdsLazyQuery
>;
export type GetPracticesByIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetPracticesByIdsSuspenseQuery
>;
export type GetPracticesByIdsQueryResult = Apollo.QueryResult<
    GetPracticesByIdsQuery,
    GetPracticesByIdsQueryVariables
>;
export const GetPracticeByOrgIdForStorefrontDocument = gql`
    query getPracticeByOrgIdForStorefront($id: Int!) {
        findFirstPractice(
            where: {
                orgId: { equals: $id }
                isAvailableFromStorefront: { equals: true }
            }
        ) {
            practiceId
            orgId
            address
            googleMapsUrl
            googleMapsEmbed
            locationName
            metadata
            phoneNumber
            ehrLocationId
            timezone
        }
    }
`;

/**
 * __useGetPracticeByOrgIdForStorefrontQuery__
 *
 * To run a query within a React component, call `useGetPracticeByOrgIdForStorefrontQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeByOrgIdForStorefrontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeByOrgIdForStorefrontQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPracticeByOrgIdForStorefrontQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPracticeByOrgIdForStorefrontQuery,
        GetPracticeByOrgIdForStorefrontQueryVariables
    > &
        (
            | {
                  variables: GetPracticeByOrgIdForStorefrontQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetPracticeByOrgIdForStorefrontQuery,
        GetPracticeByOrgIdForStorefrontQueryVariables
    >(GetPracticeByOrgIdForStorefrontDocument, options);
}
export function useGetPracticeByOrgIdForStorefrontLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPracticeByOrgIdForStorefrontQuery,
        GetPracticeByOrgIdForStorefrontQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPracticeByOrgIdForStorefrontQuery,
        GetPracticeByOrgIdForStorefrontQueryVariables
    >(GetPracticeByOrgIdForStorefrontDocument, options);
}
// @ts-ignore
export function useGetPracticeByOrgIdForStorefrontSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetPracticeByOrgIdForStorefrontQuery,
        GetPracticeByOrgIdForStorefrontQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetPracticeByOrgIdForStorefrontQuery,
    GetPracticeByOrgIdForStorefrontQueryVariables
>;
export function useGetPracticeByOrgIdForStorefrontSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticeByOrgIdForStorefrontQuery,
              GetPracticeByOrgIdForStorefrontQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetPracticeByOrgIdForStorefrontQuery | undefined,
    GetPracticeByOrgIdForStorefrontQueryVariables
>;
export function useGetPracticeByOrgIdForStorefrontSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticeByOrgIdForStorefrontQuery,
              GetPracticeByOrgIdForStorefrontQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPracticeByOrgIdForStorefrontQuery,
        GetPracticeByOrgIdForStorefrontQueryVariables
    >(GetPracticeByOrgIdForStorefrontDocument, options);
}
export type GetPracticeByOrgIdForStorefrontQueryHookResult = ReturnType<
    typeof useGetPracticeByOrgIdForStorefrontQuery
>;
export type GetPracticeByOrgIdForStorefrontLazyQueryHookResult = ReturnType<
    typeof useGetPracticeByOrgIdForStorefrontLazyQuery
>;
export type GetPracticeByOrgIdForStorefrontSuspenseQueryHookResult = ReturnType<
    typeof useGetPracticeByOrgIdForStorefrontSuspenseQuery
>;
export type GetPracticeByOrgIdForStorefrontQueryResult = Apollo.QueryResult<
    GetPracticeByOrgIdForStorefrontQuery,
    GetPracticeByOrgIdForStorefrontQueryVariables
>;
export const GetPracticesByOrgIdDocument = gql`
    query getPracticesByOrgId($id: Int!) {
        practices(where: { orgId: { equals: $id } }) {
            practiceId
            orgId
            address
            googleMapsUrl
            googleMapsEmbed
            locationName
            metadata
            phoneNumber
            ehrLocationId
            isAvailableFromStorefront
            timezone
        }
    }
`;

/**
 * __useGetPracticesByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetPracticesByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticesByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticesByOrgIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPracticesByOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPracticesByOrgIdQuery,
        GetPracticesByOrgIdQueryVariables
    > &
        (
            | { variables: GetPracticesByOrgIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetPracticesByOrgIdQuery,
        GetPracticesByOrgIdQueryVariables
    >(GetPracticesByOrgIdDocument, options);
}
export function useGetPracticesByOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPracticesByOrgIdQuery,
        GetPracticesByOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPracticesByOrgIdQuery,
        GetPracticesByOrgIdQueryVariables
    >(GetPracticesByOrgIdDocument, options);
}
// @ts-ignore
export function useGetPracticesByOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetPracticesByOrgIdQuery,
        GetPracticesByOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetPracticesByOrgIdQuery,
    GetPracticesByOrgIdQueryVariables
>;
export function useGetPracticesByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticesByOrgIdQuery,
              GetPracticesByOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetPracticesByOrgIdQuery | undefined,
    GetPracticesByOrgIdQueryVariables
>;
export function useGetPracticesByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticesByOrgIdQuery,
              GetPracticesByOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPracticesByOrgIdQuery,
        GetPracticesByOrgIdQueryVariables
    >(GetPracticesByOrgIdDocument, options);
}
export type GetPracticesByOrgIdQueryHookResult = ReturnType<
    typeof useGetPracticesByOrgIdQuery
>;
export type GetPracticesByOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetPracticesByOrgIdLazyQuery
>;
export type GetPracticesByOrgIdSuspenseQueryHookResult = ReturnType<
    typeof useGetPracticesByOrgIdSuspenseQuery
>;
export type GetPracticesByOrgIdQueryResult = Apollo.QueryResult<
    GetPracticesByOrgIdQuery,
    GetPracticesByOrgIdQueryVariables
>;
export const GetAllOrgsDocument = gql`
    query getAllOrgs {
        organizations(orderBy: { orgName: asc }) {
            orgName
            orgTitle
        }
    }
`;

/**
 * __useGetAllOrgsQuery__
 *
 * To run a query within a React component, call `useGetAllOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOrgsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAllOrgsQuery,
        GetAllOrgsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAllOrgsQuery, GetAllOrgsQueryVariables>(
        GetAllOrgsDocument,
        options,
    );
}
export function useGetAllOrgsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllOrgsQuery,
        GetAllOrgsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAllOrgsQuery, GetAllOrgsQueryVariables>(
        GetAllOrgsDocument,
        options,
    );
}
// @ts-ignore
export function useGetAllOrgsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAllOrgsQuery,
        GetAllOrgsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<GetAllOrgsQuery, GetAllOrgsQueryVariables>;
export function useGetAllOrgsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllOrgsQuery,
              GetAllOrgsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAllOrgsQuery | undefined,
    GetAllOrgsQueryVariables
>;
export function useGetAllOrgsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllOrgsQuery,
              GetAllOrgsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetAllOrgsQuery, GetAllOrgsQueryVariables>(
        GetAllOrgsDocument,
        options,
    );
}
export type GetAllOrgsQueryHookResult = ReturnType<typeof useGetAllOrgsQuery>;
export type GetAllOrgsLazyQueryHookResult = ReturnType<
    typeof useGetAllOrgsLazyQuery
>;
export type GetAllOrgsSuspenseQueryHookResult = ReturnType<
    typeof useGetAllOrgsSuspenseQuery
>;
export type GetAllOrgsQueryResult = Apollo.QueryResult<
    GetAllOrgsQuery,
    GetAllOrgsQueryVariables
>;
export const GetOrgIdFromOrgTitleDocument = gql`
    query getOrgIdFromOrgTitle($title: String) {
        findFirstOrganization(where: { orgTitle: { equals: $title } }) {
            id
            orgName
            googleAnalyticsTag
            organizationTranslations {
                languageCode
                renderConfig
            }
        }
    }
`;

/**
 * __useGetOrgIdFromOrgTitleQuery__
 *
 * To run a query within a React component, call `useGetOrgIdFromOrgTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgIdFromOrgTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgIdFromOrgTitleQuery({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useGetOrgIdFromOrgTitleQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetOrgIdFromOrgTitleQuery,
        GetOrgIdFromOrgTitleQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrgIdFromOrgTitleQuery,
        GetOrgIdFromOrgTitleQueryVariables
    >(GetOrgIdFromOrgTitleDocument, options);
}
export function useGetOrgIdFromOrgTitleLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrgIdFromOrgTitleQuery,
        GetOrgIdFromOrgTitleQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrgIdFromOrgTitleQuery,
        GetOrgIdFromOrgTitleQueryVariables
    >(GetOrgIdFromOrgTitleDocument, options);
}
// @ts-ignore
export function useGetOrgIdFromOrgTitleSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrgIdFromOrgTitleQuery,
        GetOrgIdFromOrgTitleQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrgIdFromOrgTitleQuery,
    GetOrgIdFromOrgTitleQueryVariables
>;
export function useGetOrgIdFromOrgTitleSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgIdFromOrgTitleQuery,
              GetOrgIdFromOrgTitleQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrgIdFromOrgTitleQuery | undefined,
    GetOrgIdFromOrgTitleQueryVariables
>;
export function useGetOrgIdFromOrgTitleSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgIdFromOrgTitleQuery,
              GetOrgIdFromOrgTitleQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrgIdFromOrgTitleQuery,
        GetOrgIdFromOrgTitleQueryVariables
    >(GetOrgIdFromOrgTitleDocument, options);
}
export type GetOrgIdFromOrgTitleQueryHookResult = ReturnType<
    typeof useGetOrgIdFromOrgTitleQuery
>;
export type GetOrgIdFromOrgTitleLazyQueryHookResult = ReturnType<
    typeof useGetOrgIdFromOrgTitleLazyQuery
>;
export type GetOrgIdFromOrgTitleSuspenseQueryHookResult = ReturnType<
    typeof useGetOrgIdFromOrgTitleSuspenseQuery
>;
export type GetOrgIdFromOrgTitleQueryResult = Apollo.QueryResult<
    GetOrgIdFromOrgTitleQuery,
    GetOrgIdFromOrgTitleQueryVariables
>;
export const GetPracticeIdFromOrgTitleDocument = gql`
    query getPracticeIdFromOrgTitle($title: String) {
        practices(where: { org: { is: { orgTitle: { equals: $title } } } }) {
            practiceId
        }
    }
`;

/**
 * __useGetPracticeIdFromOrgTitleQuery__
 *
 * To run a query within a React component, call `useGetPracticeIdFromOrgTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeIdFromOrgTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeIdFromOrgTitleQuery({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useGetPracticeIdFromOrgTitleQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetPracticeIdFromOrgTitleQuery,
        GetPracticeIdFromOrgTitleQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetPracticeIdFromOrgTitleQuery,
        GetPracticeIdFromOrgTitleQueryVariables
    >(GetPracticeIdFromOrgTitleDocument, options);
}
export function useGetPracticeIdFromOrgTitleLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPracticeIdFromOrgTitleQuery,
        GetPracticeIdFromOrgTitleQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPracticeIdFromOrgTitleQuery,
        GetPracticeIdFromOrgTitleQueryVariables
    >(GetPracticeIdFromOrgTitleDocument, options);
}
// @ts-ignore
export function useGetPracticeIdFromOrgTitleSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetPracticeIdFromOrgTitleQuery,
        GetPracticeIdFromOrgTitleQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetPracticeIdFromOrgTitleQuery,
    GetPracticeIdFromOrgTitleQueryVariables
>;
export function useGetPracticeIdFromOrgTitleSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticeIdFromOrgTitleQuery,
              GetPracticeIdFromOrgTitleQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetPracticeIdFromOrgTitleQuery | undefined,
    GetPracticeIdFromOrgTitleQueryVariables
>;
export function useGetPracticeIdFromOrgTitleSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticeIdFromOrgTitleQuery,
              GetPracticeIdFromOrgTitleQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPracticeIdFromOrgTitleQuery,
        GetPracticeIdFromOrgTitleQueryVariables
    >(GetPracticeIdFromOrgTitleDocument, options);
}
export type GetPracticeIdFromOrgTitleQueryHookResult = ReturnType<
    typeof useGetPracticeIdFromOrgTitleQuery
>;
export type GetPracticeIdFromOrgTitleLazyQueryHookResult = ReturnType<
    typeof useGetPracticeIdFromOrgTitleLazyQuery
>;
export type GetPracticeIdFromOrgTitleSuspenseQueryHookResult = ReturnType<
    typeof useGetPracticeIdFromOrgTitleSuspenseQuery
>;
export type GetPracticeIdFromOrgTitleQueryResult = Apollo.QueryResult<
    GetPracticeIdFromOrgTitleQuery,
    GetPracticeIdFromOrgTitleQueryVariables
>;
export const GetAllPracticesByOrgIdDocument = gql`
    query getAllPracticesByOrgId($orgId: Int!) {
        practices(where: { orgId: { equals: $orgId } }) {
            practiceId
            locationName
            address
            googleMapsEmbed
            googleMapsUrl
            metadata
            ehrLocationId
            phoneNumber
            orgId
            timezone
            providerGroups {
                providerGroupId
            }
        }
    }
`;

/**
 * __useGetAllPracticesByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetAllPracticesByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPracticesByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPracticesByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetAllPracticesByOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAllPracticesByOrgIdQuery,
        GetAllPracticesByOrgIdQueryVariables
    > &
        (
            | {
                  variables: GetAllPracticesByOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAllPracticesByOrgIdQuery,
        GetAllPracticesByOrgIdQueryVariables
    >(GetAllPracticesByOrgIdDocument, options);
}
export function useGetAllPracticesByOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllPracticesByOrgIdQuery,
        GetAllPracticesByOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAllPracticesByOrgIdQuery,
        GetAllPracticesByOrgIdQueryVariables
    >(GetAllPracticesByOrgIdDocument, options);
}
// @ts-ignore
export function useGetAllPracticesByOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAllPracticesByOrgIdQuery,
        GetAllPracticesByOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAllPracticesByOrgIdQuery,
    GetAllPracticesByOrgIdQueryVariables
>;
export function useGetAllPracticesByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllPracticesByOrgIdQuery,
              GetAllPracticesByOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAllPracticesByOrgIdQuery | undefined,
    GetAllPracticesByOrgIdQueryVariables
>;
export function useGetAllPracticesByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllPracticesByOrgIdQuery,
              GetAllPracticesByOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAllPracticesByOrgIdQuery,
        GetAllPracticesByOrgIdQueryVariables
    >(GetAllPracticesByOrgIdDocument, options);
}
export type GetAllPracticesByOrgIdQueryHookResult = ReturnType<
    typeof useGetAllPracticesByOrgIdQuery
>;
export type GetAllPracticesByOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetAllPracticesByOrgIdLazyQuery
>;
export type GetAllPracticesByOrgIdSuspenseQueryHookResult = ReturnType<
    typeof useGetAllPracticesByOrgIdSuspenseQuery
>;
export type GetAllPracticesByOrgIdQueryResult = Apollo.QueryResult<
    GetAllPracticesByOrgIdQuery,
    GetAllPracticesByOrgIdQueryVariables
>;
export const GetPracticesByOrgIdAndProviderIdDocument = gql`
    query getPracticesByOrgIdAndProviderId($orgId: Int!, $providerId: Int!) {
        practices(
            where: {
                AND: [
                    { orgId: { equals: $orgId } }
                    {
                        providerGroups: {
                            some: { providerGroupId: { equals: $providerId } }
                        }
                    }
                ]
            }
        ) {
            practiceId
            orgId
            address
            googleMapsUrl
            googleMapsEmbed
            locationName
            metadata
            phoneNumber
            ehrLocationId
            timezone
            providerGroups {
                providerGroupId
                providerToProviderGroup {
                    provider {
                        id
                        firstName
                    }
                }
            }
        }
    }
`;

/**
 * __useGetPracticesByOrgIdAndProviderIdQuery__
 *
 * To run a query within a React component, call `useGetPracticesByOrgIdAndProviderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticesByOrgIdAndProviderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticesByOrgIdAndProviderIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetPracticesByOrgIdAndProviderIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPracticesByOrgIdAndProviderIdQuery,
        GetPracticesByOrgIdAndProviderIdQueryVariables
    > &
        (
            | {
                  variables: GetPracticesByOrgIdAndProviderIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetPracticesByOrgIdAndProviderIdQuery,
        GetPracticesByOrgIdAndProviderIdQueryVariables
    >(GetPracticesByOrgIdAndProviderIdDocument, options);
}
export function useGetPracticesByOrgIdAndProviderIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPracticesByOrgIdAndProviderIdQuery,
        GetPracticesByOrgIdAndProviderIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPracticesByOrgIdAndProviderIdQuery,
        GetPracticesByOrgIdAndProviderIdQueryVariables
    >(GetPracticesByOrgIdAndProviderIdDocument, options);
}
// @ts-ignore
export function useGetPracticesByOrgIdAndProviderIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetPracticesByOrgIdAndProviderIdQuery,
        GetPracticesByOrgIdAndProviderIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetPracticesByOrgIdAndProviderIdQuery,
    GetPracticesByOrgIdAndProviderIdQueryVariables
>;
export function useGetPracticesByOrgIdAndProviderIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticesByOrgIdAndProviderIdQuery,
              GetPracticesByOrgIdAndProviderIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetPracticesByOrgIdAndProviderIdQuery | undefined,
    GetPracticesByOrgIdAndProviderIdQueryVariables
>;
export function useGetPracticesByOrgIdAndProviderIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticesByOrgIdAndProviderIdQuery,
              GetPracticesByOrgIdAndProviderIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPracticesByOrgIdAndProviderIdQuery,
        GetPracticesByOrgIdAndProviderIdQueryVariables
    >(GetPracticesByOrgIdAndProviderIdDocument, options);
}
export type GetPracticesByOrgIdAndProviderIdQueryHookResult = ReturnType<
    typeof useGetPracticesByOrgIdAndProviderIdQuery
>;
export type GetPracticesByOrgIdAndProviderIdLazyQueryHookResult = ReturnType<
    typeof useGetPracticesByOrgIdAndProviderIdLazyQuery
>;
export type GetPracticesByOrgIdAndProviderIdSuspenseQueryHookResult =
    ReturnType<typeof useGetPracticesByOrgIdAndProviderIdSuspenseQuery>;
export type GetPracticesByOrgIdAndProviderIdQueryResult = Apollo.QueryResult<
    GetPracticesByOrgIdAndProviderIdQuery,
    GetPracticesByOrgIdAndProviderIdQueryVariables
>;
export const GetOrgAndPracticesByOrgIdDocument = gql`
    query getOrgAndPracticesByOrgId($orgId: Int!) {
        findFirstOrganization(where: { id: { equals: $orgId } }) {
            id
            orgName
            orgTitle
            ein
            metadata
            googleAnalyticsTag
            waitingRoomPin
            facebookPixelId
            schedulingType
            schedulingTimeWindow
            supportedLanguages
            practices {
                practiceId
                locationName
                address
                googleMapsEmbed
                googleMapsUrl
                metadata
                phoneNumber
                ehrLocationId
                orgId
                timezone
                providerGroups {
                    providerGroupId
                    providerToProviderGroup {
                        provider {
                            id
                            firstName
                        }
                    }
                }
            }
        }
    }
`;

/**
 * __useGetOrgAndPracticesByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetOrgAndPracticesByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgAndPracticesByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgAndPracticesByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgAndPracticesByOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOrgAndPracticesByOrgIdQuery,
        GetOrgAndPracticesByOrgIdQueryVariables
    > &
        (
            | {
                  variables: GetOrgAndPracticesByOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrgAndPracticesByOrgIdQuery,
        GetOrgAndPracticesByOrgIdQueryVariables
    >(GetOrgAndPracticesByOrgIdDocument, options);
}
export function useGetOrgAndPracticesByOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrgAndPracticesByOrgIdQuery,
        GetOrgAndPracticesByOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrgAndPracticesByOrgIdQuery,
        GetOrgAndPracticesByOrgIdQueryVariables
    >(GetOrgAndPracticesByOrgIdDocument, options);
}
// @ts-ignore
export function useGetOrgAndPracticesByOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrgAndPracticesByOrgIdQuery,
        GetOrgAndPracticesByOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrgAndPracticesByOrgIdQuery,
    GetOrgAndPracticesByOrgIdQueryVariables
>;
export function useGetOrgAndPracticesByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgAndPracticesByOrgIdQuery,
              GetOrgAndPracticesByOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrgAndPracticesByOrgIdQuery | undefined,
    GetOrgAndPracticesByOrgIdQueryVariables
>;
export function useGetOrgAndPracticesByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgAndPracticesByOrgIdQuery,
              GetOrgAndPracticesByOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrgAndPracticesByOrgIdQuery,
        GetOrgAndPracticesByOrgIdQueryVariables
    >(GetOrgAndPracticesByOrgIdDocument, options);
}
export type GetOrgAndPracticesByOrgIdQueryHookResult = ReturnType<
    typeof useGetOrgAndPracticesByOrgIdQuery
>;
export type GetOrgAndPracticesByOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetOrgAndPracticesByOrgIdLazyQuery
>;
export type GetOrgAndPracticesByOrgIdSuspenseQueryHookResult = ReturnType<
    typeof useGetOrgAndPracticesByOrgIdSuspenseQuery
>;
export type GetOrgAndPracticesByOrgIdQueryResult = Apollo.QueryResult<
    GetOrgAndPracticesByOrgIdQuery,
    GetOrgAndPracticesByOrgIdQueryVariables
>;
export const GetOrgByOrgTitleDocument = gql`
    query getOrgByOrgTitle($orgTitle: String!) {
        findFirstOrganization(where: { orgTitle: { equals: $orgTitle } }) {
            id
            orgName
            orgTitle
            ein
            metadata
            googleAnalyticsTag
            facebookPixelId
            storefrontEligibilityMinimumAge
            storefrontEligibilityAllowedStates
            supportedLanguages
            practices {
                practiceId
                locationName
                address
                googleMapsEmbed
                googleMapsUrl
                metadata
                phoneNumber
                ehrLocationId
                orgId
                timezone
            }
            defaultPractices {
                defaultPracticeId
            }
        }
    }
`;

/**
 * __useGetOrgByOrgTitleQuery__
 *
 * To run a query within a React component, call `useGetOrgByOrgTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgByOrgTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgByOrgTitleQuery({
 *   variables: {
 *      orgTitle: // value for 'orgTitle'
 *   },
 * });
 */
export function useGetOrgByOrgTitleQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOrgByOrgTitleQuery,
        GetOrgByOrgTitleQueryVariables
    > &
        (
            | { variables: GetOrgByOrgTitleQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrgByOrgTitleQuery,
        GetOrgByOrgTitleQueryVariables
    >(GetOrgByOrgTitleDocument, options);
}
export function useGetOrgByOrgTitleLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrgByOrgTitleQuery,
        GetOrgByOrgTitleQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrgByOrgTitleQuery,
        GetOrgByOrgTitleQueryVariables
    >(GetOrgByOrgTitleDocument, options);
}
// @ts-ignore
export function useGetOrgByOrgTitleSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrgByOrgTitleQuery,
        GetOrgByOrgTitleQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrgByOrgTitleQuery,
    GetOrgByOrgTitleQueryVariables
>;
export function useGetOrgByOrgTitleSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgByOrgTitleQuery,
              GetOrgByOrgTitleQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrgByOrgTitleQuery | undefined,
    GetOrgByOrgTitleQueryVariables
>;
export function useGetOrgByOrgTitleSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgByOrgTitleQuery,
              GetOrgByOrgTitleQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrgByOrgTitleQuery,
        GetOrgByOrgTitleQueryVariables
    >(GetOrgByOrgTitleDocument, options);
}
export type GetOrgByOrgTitleQueryHookResult = ReturnType<
    typeof useGetOrgByOrgTitleQuery
>;
export type GetOrgByOrgTitleLazyQueryHookResult = ReturnType<
    typeof useGetOrgByOrgTitleLazyQuery
>;
export type GetOrgByOrgTitleSuspenseQueryHookResult = ReturnType<
    typeof useGetOrgByOrgTitleSuspenseQuery
>;
export type GetOrgByOrgTitleQueryResult = Apollo.QueryResult<
    GetOrgByOrgTitleQuery,
    GetOrgByOrgTitleQueryVariables
>;
export const GetOrgConfigFlagByOrgIdDocument = gql`
    query getOrgConfigFlagByOrgId($orgId: Int!, $flagName: String!) {
        orgConfigFlag(
            where: {
                org_id_flag_name_unique: { orgId: $orgId, flagName: $flagName }
            }
        ) {
            isEnabled
            flagName
        }
    }
`;

/**
 * __useGetOrgConfigFlagByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetOrgConfigFlagByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgConfigFlagByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgConfigFlagByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      flagName: // value for 'flagName'
 *   },
 * });
 */
export function useGetOrgConfigFlagByOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOrgConfigFlagByOrgIdQuery,
        GetOrgConfigFlagByOrgIdQueryVariables
    > &
        (
            | {
                  variables: GetOrgConfigFlagByOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrgConfigFlagByOrgIdQuery,
        GetOrgConfigFlagByOrgIdQueryVariables
    >(GetOrgConfigFlagByOrgIdDocument, options);
}
export function useGetOrgConfigFlagByOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrgConfigFlagByOrgIdQuery,
        GetOrgConfigFlagByOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrgConfigFlagByOrgIdQuery,
        GetOrgConfigFlagByOrgIdQueryVariables
    >(GetOrgConfigFlagByOrgIdDocument, options);
}
// @ts-ignore
export function useGetOrgConfigFlagByOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrgConfigFlagByOrgIdQuery,
        GetOrgConfigFlagByOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrgConfigFlagByOrgIdQuery,
    GetOrgConfigFlagByOrgIdQueryVariables
>;
export function useGetOrgConfigFlagByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgConfigFlagByOrgIdQuery,
              GetOrgConfigFlagByOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrgConfigFlagByOrgIdQuery | undefined,
    GetOrgConfigFlagByOrgIdQueryVariables
>;
export function useGetOrgConfigFlagByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgConfigFlagByOrgIdQuery,
              GetOrgConfigFlagByOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrgConfigFlagByOrgIdQuery,
        GetOrgConfigFlagByOrgIdQueryVariables
    >(GetOrgConfigFlagByOrgIdDocument, options);
}
export type GetOrgConfigFlagByOrgIdQueryHookResult = ReturnType<
    typeof useGetOrgConfigFlagByOrgIdQuery
>;
export type GetOrgConfigFlagByOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetOrgConfigFlagByOrgIdLazyQuery
>;
export type GetOrgConfigFlagByOrgIdSuspenseQueryHookResult = ReturnType<
    typeof useGetOrgConfigFlagByOrgIdSuspenseQuery
>;
export type GetOrgConfigFlagByOrgIdQueryResult = Apollo.QueryResult<
    GetOrgConfigFlagByOrgIdQuery,
    GetOrgConfigFlagByOrgIdQueryVariables
>;
export const GetAllPayersDocument = gql`
    query getAllPayers {
        payers(
            orderBy: { payerName: asc }
            where: { active: { equals: true } }
        ) {
            id
            payerName
            availityPayerCode
            pverifyPayerCode
            ribbonCarrierName
        }
    }
`;

/**
 * __useGetAllPayersQuery__
 *
 * To run a query within a React component, call `useGetAllPayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPayersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPayersQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAllPayersQuery,
        GetAllPayersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAllPayersQuery, GetAllPayersQueryVariables>(
        GetAllPayersDocument,
        options,
    );
}
export function useGetAllPayersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllPayersQuery,
        GetAllPayersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAllPayersQuery, GetAllPayersQueryVariables>(
        GetAllPayersDocument,
        options,
    );
}
// @ts-ignore
export function useGetAllPayersSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAllPayersQuery,
        GetAllPayersQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<GetAllPayersQuery, GetAllPayersQueryVariables>;
export function useGetAllPayersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllPayersQuery,
              GetAllPayersQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAllPayersQuery | undefined,
    GetAllPayersQueryVariables
>;
export function useGetAllPayersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllPayersQuery,
              GetAllPayersQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAllPayersQuery,
        GetAllPayersQueryVariables
    >(GetAllPayersDocument, options);
}
export type GetAllPayersQueryHookResult = ReturnType<
    typeof useGetAllPayersQuery
>;
export type GetAllPayersLazyQueryHookResult = ReturnType<
    typeof useGetAllPayersLazyQuery
>;
export type GetAllPayersSuspenseQueryHookResult = ReturnType<
    typeof useGetAllPayersSuspenseQuery
>;
export type GetAllPayersQueryResult = Apollo.QueryResult<
    GetAllPayersQuery,
    GetAllPayersQueryVariables
>;
export const GetAppointmentForLinkIdDocument = gql`
    query getAppointmentForLinkId($linkId: String!) {
        migratedEncounters(where: { linkId: { equals: $linkId } }) {
            appointmentId
            boughtTreatmentIds
        }
    }
`;

/**
 * __useGetAppointmentForLinkIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentForLinkIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentForLinkIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentForLinkIdQuery({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useGetAppointmentForLinkIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAppointmentForLinkIdQuery,
        GetAppointmentForLinkIdQueryVariables
    > &
        (
            | {
                  variables: GetAppointmentForLinkIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAppointmentForLinkIdQuery,
        GetAppointmentForLinkIdQueryVariables
    >(GetAppointmentForLinkIdDocument, options);
}
export function useGetAppointmentForLinkIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAppointmentForLinkIdQuery,
        GetAppointmentForLinkIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAppointmentForLinkIdQuery,
        GetAppointmentForLinkIdQueryVariables
    >(GetAppointmentForLinkIdDocument, options);
}
// @ts-ignore
export function useGetAppointmentForLinkIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAppointmentForLinkIdQuery,
        GetAppointmentForLinkIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAppointmentForLinkIdQuery,
    GetAppointmentForLinkIdQueryVariables
>;
export function useGetAppointmentForLinkIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAppointmentForLinkIdQuery,
              GetAppointmentForLinkIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAppointmentForLinkIdQuery | undefined,
    GetAppointmentForLinkIdQueryVariables
>;
export function useGetAppointmentForLinkIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAppointmentForLinkIdQuery,
              GetAppointmentForLinkIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAppointmentForLinkIdQuery,
        GetAppointmentForLinkIdQueryVariables
    >(GetAppointmentForLinkIdDocument, options);
}
export type GetAppointmentForLinkIdQueryHookResult = ReturnType<
    typeof useGetAppointmentForLinkIdQuery
>;
export type GetAppointmentForLinkIdLazyQueryHookResult = ReturnType<
    typeof useGetAppointmentForLinkIdLazyQuery
>;
export type GetAppointmentForLinkIdSuspenseQueryHookResult = ReturnType<
    typeof useGetAppointmentForLinkIdSuspenseQuery
>;
export type GetAppointmentForLinkIdQueryResult = Apollo.QueryResult<
    GetAppointmentForLinkIdQuery,
    GetAppointmentForLinkIdQueryVariables
>;
export const GetAdminFromIdDocument = gql`
    query getAdminFromId($id: String!) {
        getAdmin(where: { id: $id }) {
            email
            id
            role
            orgId
        }
    }
`;

/**
 * __useGetAdminFromIdQuery__
 *
 * To run a query within a React component, call `useGetAdminFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminFromIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminFromIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAdminFromIdQuery,
        GetAdminFromIdQueryVariables
    > &
        (
            | { variables: GetAdminFromIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAdminFromIdQuery, GetAdminFromIdQueryVariables>(
        GetAdminFromIdDocument,
        options,
    );
}
export function useGetAdminFromIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAdminFromIdQuery,
        GetAdminFromIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAdminFromIdQuery,
        GetAdminFromIdQueryVariables
    >(GetAdminFromIdDocument, options);
}
// @ts-ignore
export function useGetAdminFromIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAdminFromIdQuery,
        GetAdminFromIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAdminFromIdQuery,
    GetAdminFromIdQueryVariables
>;
export function useGetAdminFromIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAdminFromIdQuery,
              GetAdminFromIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAdminFromIdQuery | undefined,
    GetAdminFromIdQueryVariables
>;
export function useGetAdminFromIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAdminFromIdQuery,
              GetAdminFromIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAdminFromIdQuery,
        GetAdminFromIdQueryVariables
    >(GetAdminFromIdDocument, options);
}
export type GetAdminFromIdQueryHookResult = ReturnType<
    typeof useGetAdminFromIdQuery
>;
export type GetAdminFromIdLazyQueryHookResult = ReturnType<
    typeof useGetAdminFromIdLazyQuery
>;
export type GetAdminFromIdSuspenseQueryHookResult = ReturnType<
    typeof useGetAdminFromIdSuspenseQuery
>;
export type GetAdminFromIdQueryResult = Apollo.QueryResult<
    GetAdminFromIdQuery,
    GetAdminFromIdQueryVariables
>;
export const GetAdminsForOrgDocument = gql`
    query getAdminsForOrg($orgId: Int!) {
        admins(where: { orgId: { equals: $orgId } }) {
            email
            id
            role
            orgId
        }
    }
`;

/**
 * __useGetAdminsForOrgQuery__
 *
 * To run a query within a React component, call `useGetAdminsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminsForOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetAdminsForOrgQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAdminsForOrgQuery,
        GetAdminsForOrgQueryVariables
    > &
        (
            | { variables: GetAdminsForOrgQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAdminsForOrgQuery, GetAdminsForOrgQueryVariables>(
        GetAdminsForOrgDocument,
        options,
    );
}
export function useGetAdminsForOrgLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAdminsForOrgQuery,
        GetAdminsForOrgQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAdminsForOrgQuery,
        GetAdminsForOrgQueryVariables
    >(GetAdminsForOrgDocument, options);
}
// @ts-ignore
export function useGetAdminsForOrgSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAdminsForOrgQuery,
        GetAdminsForOrgQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAdminsForOrgQuery,
    GetAdminsForOrgQueryVariables
>;
export function useGetAdminsForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAdminsForOrgQuery,
              GetAdminsForOrgQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAdminsForOrgQuery | undefined,
    GetAdminsForOrgQueryVariables
>;
export function useGetAdminsForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAdminsForOrgQuery,
              GetAdminsForOrgQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAdminsForOrgQuery,
        GetAdminsForOrgQueryVariables
    >(GetAdminsForOrgDocument, options);
}
export type GetAdminsForOrgQueryHookResult = ReturnType<
    typeof useGetAdminsForOrgQuery
>;
export type GetAdminsForOrgLazyQueryHookResult = ReturnType<
    typeof useGetAdminsForOrgLazyQuery
>;
export type GetAdminsForOrgSuspenseQueryHookResult = ReturnType<
    typeof useGetAdminsForOrgSuspenseQuery
>;
export type GetAdminsForOrgQueryResult = Apollo.QueryResult<
    GetAdminsForOrgQuery,
    GetAdminsForOrgQueryVariables
>;
export const GetConsumerByNameDocument = gql`
    query getConsumerByName($consumerName: String!, $orgId: Float!) {
        getConsumerByName(consumerName: $consumerName, orgId: $orgId) {
            ...consumerSearchFields
        }
    }
    ${ConsumerSearchFieldsFragmentDoc}
`;

/**
 * __useGetConsumerByNameQuery__
 *
 * To run a query within a React component, call `useGetConsumerByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerByNameQuery({
 *   variables: {
 *      consumerName: // value for 'consumerName'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetConsumerByNameQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetConsumerByNameQuery,
        GetConsumerByNameQueryVariables
    > &
        (
            | { variables: GetConsumerByNameQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetConsumerByNameQuery,
        GetConsumerByNameQueryVariables
    >(GetConsumerByNameDocument, options);
}
export function useGetConsumerByNameLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetConsumerByNameQuery,
        GetConsumerByNameQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetConsumerByNameQuery,
        GetConsumerByNameQueryVariables
    >(GetConsumerByNameDocument, options);
}
// @ts-ignore
export function useGetConsumerByNameSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetConsumerByNameQuery,
        GetConsumerByNameQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetConsumerByNameQuery,
    GetConsumerByNameQueryVariables
>;
export function useGetConsumerByNameSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumerByNameQuery,
              GetConsumerByNameQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetConsumerByNameQuery | undefined,
    GetConsumerByNameQueryVariables
>;
export function useGetConsumerByNameSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumerByNameQuery,
              GetConsumerByNameQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetConsumerByNameQuery,
        GetConsumerByNameQueryVariables
    >(GetConsumerByNameDocument, options);
}
export type GetConsumerByNameQueryHookResult = ReturnType<
    typeof useGetConsumerByNameQuery
>;
export type GetConsumerByNameLazyQueryHookResult = ReturnType<
    typeof useGetConsumerByNameLazyQuery
>;
export type GetConsumerByNameSuspenseQueryHookResult = ReturnType<
    typeof useGetConsumerByNameSuspenseQuery
>;
export type GetConsumerByNameQueryResult = Apollo.QueryResult<
    GetConsumerByNameQuery,
    GetConsumerByNameQueryVariables
>;
export const GetConsumersByEhrIdDocument = gql`
    query getConsumersByEhrId($ehrPatientId: String!, $orgId: Int!) {
        consumers(
            where: {
                ehrPatientId: { equals: $ehrPatientId }
                user: { is: { orgId: { equals: $orgId } } }
                consumerAccountStatus: { equals: CONNECTED }
            }
        ) {
            ...consumerSearchFields
        }
    }
    ${ConsumerSearchFieldsFragmentDoc}
`;

/**
 * __useGetConsumersByEhrIdQuery__
 *
 * To run a query within a React component, call `useGetConsumersByEhrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumersByEhrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumersByEhrIdQuery({
 *   variables: {
 *      ehrPatientId: // value for 'ehrPatientId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetConsumersByEhrIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetConsumersByEhrIdQuery,
        GetConsumersByEhrIdQueryVariables
    > &
        (
            | { variables: GetConsumersByEhrIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetConsumersByEhrIdQuery,
        GetConsumersByEhrIdQueryVariables
    >(GetConsumersByEhrIdDocument, options);
}
export function useGetConsumersByEhrIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetConsumersByEhrIdQuery,
        GetConsumersByEhrIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetConsumersByEhrIdQuery,
        GetConsumersByEhrIdQueryVariables
    >(GetConsumersByEhrIdDocument, options);
}
// @ts-ignore
export function useGetConsumersByEhrIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetConsumersByEhrIdQuery,
        GetConsumersByEhrIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetConsumersByEhrIdQuery,
    GetConsumersByEhrIdQueryVariables
>;
export function useGetConsumersByEhrIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumersByEhrIdQuery,
              GetConsumersByEhrIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetConsumersByEhrIdQuery | undefined,
    GetConsumersByEhrIdQueryVariables
>;
export function useGetConsumersByEhrIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumersByEhrIdQuery,
              GetConsumersByEhrIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetConsumersByEhrIdQuery,
        GetConsumersByEhrIdQueryVariables
    >(GetConsumersByEhrIdDocument, options);
}
export type GetConsumersByEhrIdQueryHookResult = ReturnType<
    typeof useGetConsumersByEhrIdQuery
>;
export type GetConsumersByEhrIdLazyQueryHookResult = ReturnType<
    typeof useGetConsumersByEhrIdLazyQuery
>;
export type GetConsumersByEhrIdSuspenseQueryHookResult = ReturnType<
    typeof useGetConsumersByEhrIdSuspenseQuery
>;
export type GetConsumersByEhrIdQueryResult = Apollo.QueryResult<
    GetConsumersByEhrIdQuery,
    GetConsumersByEhrIdQueryVariables
>;
export const GetConsumerByKioskInformationDocument = gql`
    query getConsumerByKioskInformation(
        $firstName: String!
        $lastName: String!
        $dob: DateTimeISO!
        $orgId: Int!
    ) {
        consumers(
            where: {
                firstname: { equals: $firstName, mode: insensitive }
                lastname: { equals: $lastName, mode: insensitive }
                dob: { equals: $dob }
                user: {
                    is: {
                        orgId: { equals: $orgId }
                        userAccountStatus: { equals: CONNECTED }
                    }
                }
                ehrPatientId: { not: { equals: null } }
                consumerAccountStatus: { equals: CONNECTED }
            }
        ) {
            id
            firstname
            lastname
            dob
            ehrPatientId
            consumerAccountStatus
            user {
                id
                orgId
                phone
                email
                userAccountStatus
                primaryLanguage
            }
            insurances {
                id
                memberId
                payer
                state
                ehrInsuranceId
                status
                insuranceAccountStatus
                isPrimaryInsurance
                priority
            }
        }
    }
`;

/**
 * __useGetConsumerByKioskInformationQuery__
 *
 * To run a query within a React component, call `useGetConsumerByKioskInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerByKioskInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerByKioskInformationQuery({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      dob: // value for 'dob'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetConsumerByKioskInformationQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetConsumerByKioskInformationQuery,
        GetConsumerByKioskInformationQueryVariables
    > &
        (
            | {
                  variables: GetConsumerByKioskInformationQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetConsumerByKioskInformationQuery,
        GetConsumerByKioskInformationQueryVariables
    >(GetConsumerByKioskInformationDocument, options);
}
export function useGetConsumerByKioskInformationLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetConsumerByKioskInformationQuery,
        GetConsumerByKioskInformationQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetConsumerByKioskInformationQuery,
        GetConsumerByKioskInformationQueryVariables
    >(GetConsumerByKioskInformationDocument, options);
}
// @ts-ignore
export function useGetConsumerByKioskInformationSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetConsumerByKioskInformationQuery,
        GetConsumerByKioskInformationQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetConsumerByKioskInformationQuery,
    GetConsumerByKioskInformationQueryVariables
>;
export function useGetConsumerByKioskInformationSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumerByKioskInformationQuery,
              GetConsumerByKioskInformationQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetConsumerByKioskInformationQuery | undefined,
    GetConsumerByKioskInformationQueryVariables
>;
export function useGetConsumerByKioskInformationSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumerByKioskInformationQuery,
              GetConsumerByKioskInformationQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetConsumerByKioskInformationQuery,
        GetConsumerByKioskInformationQueryVariables
    >(GetConsumerByKioskInformationDocument, options);
}
export type GetConsumerByKioskInformationQueryHookResult = ReturnType<
    typeof useGetConsumerByKioskInformationQuery
>;
export type GetConsumerByKioskInformationLazyQueryHookResult = ReturnType<
    typeof useGetConsumerByKioskInformationLazyQuery
>;
export type GetConsumerByKioskInformationSuspenseQueryHookResult = ReturnType<
    typeof useGetConsumerByKioskInformationSuspenseQuery
>;
export type GetConsumerByKioskInformationQueryResult = Apollo.QueryResult<
    GetConsumerByKioskInformationQuery,
    GetConsumerByKioskInformationQueryVariables
>;
export const GetConsumersByDobDocument = gql`
    query getConsumersByDOB($dobs: [DateTimeISO!]!, $orgId: Int!) {
        consumers(
            where: {
                dob: { in: $dobs }
                user: { is: { orgId: { equals: $orgId } } }
                consumerAccountStatus: { equals: CONNECTED }
            }
        ) {
            ...consumerSearchFields
        }
    }
    ${ConsumerSearchFieldsFragmentDoc}
`;

/**
 * __useGetConsumersByDobQuery__
 *
 * To run a query within a React component, call `useGetConsumersByDobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumersByDobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumersByDobQuery({
 *   variables: {
 *      dobs: // value for 'dobs'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetConsumersByDobQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetConsumersByDobQuery,
        GetConsumersByDobQueryVariables
    > &
        (
            | { variables: GetConsumersByDobQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetConsumersByDobQuery,
        GetConsumersByDobQueryVariables
    >(GetConsumersByDobDocument, options);
}
export function useGetConsumersByDobLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetConsumersByDobQuery,
        GetConsumersByDobQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetConsumersByDobQuery,
        GetConsumersByDobQueryVariables
    >(GetConsumersByDobDocument, options);
}
// @ts-ignore
export function useGetConsumersByDobSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetConsumersByDobQuery,
        GetConsumersByDobQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetConsumersByDobQuery,
    GetConsumersByDobQueryVariables
>;
export function useGetConsumersByDobSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumersByDobQuery,
              GetConsumersByDobQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetConsumersByDobQuery | undefined,
    GetConsumersByDobQueryVariables
>;
export function useGetConsumersByDobSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumersByDobQuery,
              GetConsumersByDobQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetConsumersByDobQuery,
        GetConsumersByDobQueryVariables
    >(GetConsumersByDobDocument, options);
}
export type GetConsumersByDobQueryHookResult = ReturnType<
    typeof useGetConsumersByDobQuery
>;
export type GetConsumersByDobLazyQueryHookResult = ReturnType<
    typeof useGetConsumersByDobLazyQuery
>;
export type GetConsumersByDobSuspenseQueryHookResult = ReturnType<
    typeof useGetConsumersByDobSuspenseQuery
>;
export type GetConsumersByDobQueryResult = Apollo.QueryResult<
    GetConsumersByDobQuery,
    GetConsumersByDobQueryVariables
>;
export const GetAllIntakeFormsForOrgIdDocument = gql`
    query getAllIntakeFormsForOrgId($orgId: Int!) {
        intakeForms(where: { orgId: { equals: $orgId } }) {
            id
            name
            completionTiming
        }
    }
`;

/**
 * __useGetAllIntakeFormsForOrgIdQuery__
 *
 * To run a query within a React component, call `useGetAllIntakeFormsForOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllIntakeFormsForOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllIntakeFormsForOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetAllIntakeFormsForOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAllIntakeFormsForOrgIdQuery,
        GetAllIntakeFormsForOrgIdQueryVariables
    > &
        (
            | {
                  variables: GetAllIntakeFormsForOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAllIntakeFormsForOrgIdQuery,
        GetAllIntakeFormsForOrgIdQueryVariables
    >(GetAllIntakeFormsForOrgIdDocument, options);
}
export function useGetAllIntakeFormsForOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllIntakeFormsForOrgIdQuery,
        GetAllIntakeFormsForOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAllIntakeFormsForOrgIdQuery,
        GetAllIntakeFormsForOrgIdQueryVariables
    >(GetAllIntakeFormsForOrgIdDocument, options);
}
// @ts-ignore
export function useGetAllIntakeFormsForOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAllIntakeFormsForOrgIdQuery,
        GetAllIntakeFormsForOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAllIntakeFormsForOrgIdQuery,
    GetAllIntakeFormsForOrgIdQueryVariables
>;
export function useGetAllIntakeFormsForOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllIntakeFormsForOrgIdQuery,
              GetAllIntakeFormsForOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAllIntakeFormsForOrgIdQuery | undefined,
    GetAllIntakeFormsForOrgIdQueryVariables
>;
export function useGetAllIntakeFormsForOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllIntakeFormsForOrgIdQuery,
              GetAllIntakeFormsForOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAllIntakeFormsForOrgIdQuery,
        GetAllIntakeFormsForOrgIdQueryVariables
    >(GetAllIntakeFormsForOrgIdDocument, options);
}
export type GetAllIntakeFormsForOrgIdQueryHookResult = ReturnType<
    typeof useGetAllIntakeFormsForOrgIdQuery
>;
export type GetAllIntakeFormsForOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetAllIntakeFormsForOrgIdLazyQuery
>;
export type GetAllIntakeFormsForOrgIdSuspenseQueryHookResult = ReturnType<
    typeof useGetAllIntakeFormsForOrgIdSuspenseQuery
>;
export type GetAllIntakeFormsForOrgIdQueryResult = Apollo.QueryResult<
    GetAllIntakeFormsForOrgIdQuery,
    GetAllIntakeFormsForOrgIdQueryVariables
>;
export const CreateInsuranceDocument = gql`
    mutation createInsurance($data: CreateInsuranceWithEHRInput!) {
        createInsurance(data: $data) {
            id
        }
    }
`;
export type CreateInsuranceMutationFn = Apollo.MutationFunction<
    CreateInsuranceMutation,
    CreateInsuranceMutationVariables
>;

/**
 * __useCreateInsuranceMutation__
 *
 * To run a mutation, you first call `useCreateInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsuranceMutation, { data, loading, error }] = useCreateInsuranceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInsuranceMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateInsuranceMutation,
        CreateInsuranceMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CreateInsuranceMutation,
        CreateInsuranceMutationVariables
    >(CreateInsuranceDocument, options);
}
export type CreateInsuranceMutationHookResult = ReturnType<
    typeof useCreateInsuranceMutation
>;
export type CreateInsuranceMutationResult =
    Apollo.MutationResult<CreateInsuranceMutation>;
export type CreateInsuranceMutationOptions = Apollo.BaseMutationOptions<
    CreateInsuranceMutation,
    CreateInsuranceMutationVariables
>;
export const DeactivateInsuranceDocument = gql`
    mutation deactivateInsurance($data: DeactivateInsuranceInput!) {
        deactivateInsurance(data: $data) {
            id
        }
    }
`;
export type DeactivateInsuranceMutationFn = Apollo.MutationFunction<
    DeactivateInsuranceMutation,
    DeactivateInsuranceMutationVariables
>;

/**
 * __useDeactivateInsuranceMutation__
 *
 * To run a mutation, you first call `useDeactivateInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateInsuranceMutation, { data, loading, error }] = useDeactivateInsuranceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeactivateInsuranceMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeactivateInsuranceMutation,
        DeactivateInsuranceMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        DeactivateInsuranceMutation,
        DeactivateInsuranceMutationVariables
    >(DeactivateInsuranceDocument, options);
}
export type DeactivateInsuranceMutationHookResult = ReturnType<
    typeof useDeactivateInsuranceMutation
>;
export type DeactivateInsuranceMutationResult =
    Apollo.MutationResult<DeactivateInsuranceMutation>;
export type DeactivateInsuranceMutationOptions = Apollo.BaseMutationOptions<
    DeactivateInsuranceMutation,
    DeactivateInsuranceMutationVariables
>;
export const UpdateInsuranceDocument = gql`
    mutation updateInsurance($data: UpdateInsuranceInput!) {
        updateInsurance(data: $data) {
            id
        }
    }
`;
export type UpdateInsuranceMutationFn = Apollo.MutationFunction<
    UpdateInsuranceMutation,
    UpdateInsuranceMutationVariables
>;

/**
 * __useUpdateInsuranceMutation__
 *
 * To run a mutation, you first call `useUpdateInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsuranceMutation, { data, loading, error }] = useUpdateInsuranceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateInsuranceMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateInsuranceMutation,
        UpdateInsuranceMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateInsuranceMutation,
        UpdateInsuranceMutationVariables
    >(UpdateInsuranceDocument, options);
}
export type UpdateInsuranceMutationHookResult = ReturnType<
    typeof useUpdateInsuranceMutation
>;
export type UpdateInsuranceMutationResult =
    Apollo.MutationResult<UpdateInsuranceMutation>;
export type UpdateInsuranceMutationOptions = Apollo.BaseMutationOptions<
    UpdateInsuranceMutation,
    UpdateInsuranceMutationVariables
>;
export const GetUserByUserIdDocument = gql`
    query getUserByUserId(
        $id: String!
        $includeConsumers: Boolean = false
        $includeInsurances: Boolean = false
    ) {
        user(where: { id: $id, userAccountStatus: { equals: CONNECTED } }) {
            ...getUserData
            consumers(where: { consumerAccountStatus: { equals: CONNECTED } })
                @include(if: $includeConsumers) {
                ...getConsumerData
                insurances(
                    where: { insuranceAccountStatus: { equals: CONNECTED } }
                ) @include(if: $includeInsurances) {
                    ...getInsuranceData
                }
            }
        }
    }
    ${GetUserDataFragmentDoc}
    ${GetConsumerDataFragmentDoc}
    ${GetInsuranceDataFragmentDoc}
`;

/**
 * __useGetUserByUserIdQuery__
 *
 * To run a query within a React component, call `useGetUserByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeConsumers: // value for 'includeConsumers'
 *      includeInsurances: // value for 'includeInsurances'
 *   },
 * });
 */
export function useGetUserByUserIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserByUserIdQuery,
        GetUserByUserIdQueryVariables
    > &
        (
            | { variables: GetUserByUserIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUserByUserIdQuery, GetUserByUserIdQueryVariables>(
        GetUserByUserIdDocument,
        options,
    );
}
export function useGetUserByUserIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserByUserIdQuery,
        GetUserByUserIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUserByUserIdQuery,
        GetUserByUserIdQueryVariables
    >(GetUserByUserIdDocument, options);
}
// @ts-ignore
export function useGetUserByUserIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUserByUserIdQuery,
        GetUserByUserIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUserByUserIdQuery,
    GetUserByUserIdQueryVariables
>;
export function useGetUserByUserIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserByUserIdQuery,
              GetUserByUserIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUserByUserIdQuery | undefined,
    GetUserByUserIdQueryVariables
>;
export function useGetUserByUserIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserByUserIdQuery,
              GetUserByUserIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUserByUserIdQuery,
        GetUserByUserIdQueryVariables
    >(GetUserByUserIdDocument, options);
}
export type GetUserByUserIdQueryHookResult = ReturnType<
    typeof useGetUserByUserIdQuery
>;
export type GetUserByUserIdLazyQueryHookResult = ReturnType<
    typeof useGetUserByUserIdLazyQuery
>;
export type GetUserByUserIdSuspenseQueryHookResult = ReturnType<
    typeof useGetUserByUserIdSuspenseQuery
>;
export type GetUserByUserIdQueryResult = Apollo.QueryResult<
    GetUserByUserIdQuery,
    GetUserByUserIdQueryVariables
>;
export const GetUserByPhoneNumberDocument = gql`
    query getUserByPhoneNumber(
        $phone: String!
        $orgId: Int!
        $includeConsumers: Boolean = false
        $includeInsurances: Boolean = false
    ) {
        users(
            where: {
                phone: { equals: $phone }
                orgId: { equals: $orgId }
                userAccountStatus: { not: { equals: DELETED } }
            }
        ) {
            ...getUserData
            consumers(where: { consumerAccountStatus: { equals: CONNECTED } })
                @include(if: $includeConsumers) {
                ...getConsumerData
                insurances(
                    where: { insuranceAccountStatus: { equals: CONNECTED } }
                ) @include(if: $includeInsurances) {
                    ...getInsuranceData
                }
            }
        }
    }
    ${GetUserDataFragmentDoc}
    ${GetConsumerDataFragmentDoc}
    ${GetInsuranceDataFragmentDoc}
`;

/**
 * __useGetUserByPhoneNumberQuery__
 *
 * To run a query within a React component, call `useGetUserByPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByPhoneNumberQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      orgId: // value for 'orgId'
 *      includeConsumers: // value for 'includeConsumers'
 *      includeInsurances: // value for 'includeInsurances'
 *   },
 * });
 */
export function useGetUserByPhoneNumberQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserByPhoneNumberQuery,
        GetUserByPhoneNumberQueryVariables
    > &
        (
            | { variables: GetUserByPhoneNumberQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUserByPhoneNumberQuery,
        GetUserByPhoneNumberQueryVariables
    >(GetUserByPhoneNumberDocument, options);
}
export function useGetUserByPhoneNumberLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserByPhoneNumberQuery,
        GetUserByPhoneNumberQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUserByPhoneNumberQuery,
        GetUserByPhoneNumberQueryVariables
    >(GetUserByPhoneNumberDocument, options);
}
// @ts-ignore
export function useGetUserByPhoneNumberSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUserByPhoneNumberQuery,
        GetUserByPhoneNumberQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUserByPhoneNumberQuery,
    GetUserByPhoneNumberQueryVariables
>;
export function useGetUserByPhoneNumberSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserByPhoneNumberQuery,
              GetUserByPhoneNumberQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUserByPhoneNumberQuery | undefined,
    GetUserByPhoneNumberQueryVariables
>;
export function useGetUserByPhoneNumberSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserByPhoneNumberQuery,
              GetUserByPhoneNumberQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUserByPhoneNumberQuery,
        GetUserByPhoneNumberQueryVariables
    >(GetUserByPhoneNumberDocument, options);
}
export type GetUserByPhoneNumberQueryHookResult = ReturnType<
    typeof useGetUserByPhoneNumberQuery
>;
export type GetUserByPhoneNumberLazyQueryHookResult = ReturnType<
    typeof useGetUserByPhoneNumberLazyQuery
>;
export type GetUserByPhoneNumberSuspenseQueryHookResult = ReturnType<
    typeof useGetUserByPhoneNumberSuspenseQuery
>;
export type GetUserByPhoneNumberQueryResult = Apollo.QueryResult<
    GetUserByPhoneNumberQuery,
    GetUserByPhoneNumberQueryVariables
>;
export const GetUserWithMinimalDataDocument = gql`
    query getUserWithMinimalData($id: String!) {
        user(where: { id: $id }) {
            id
            phone
            orgId
            primaryLanguage
            primaryConsumerId
            consumers {
                id
                dob
            }
        }
    }
`;

/**
 * __useGetUserWithMinimalDataQuery__
 *
 * To run a query within a React component, call `useGetUserWithMinimalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithMinimalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithMinimalDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserWithMinimalDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserWithMinimalDataQuery,
        GetUserWithMinimalDataQueryVariables
    > &
        (
            | {
                  variables: GetUserWithMinimalDataQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUserWithMinimalDataQuery,
        GetUserWithMinimalDataQueryVariables
    >(GetUserWithMinimalDataDocument, options);
}
export function useGetUserWithMinimalDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserWithMinimalDataQuery,
        GetUserWithMinimalDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUserWithMinimalDataQuery,
        GetUserWithMinimalDataQueryVariables
    >(GetUserWithMinimalDataDocument, options);
}
// @ts-ignore
export function useGetUserWithMinimalDataSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUserWithMinimalDataQuery,
        GetUserWithMinimalDataQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUserWithMinimalDataQuery,
    GetUserWithMinimalDataQueryVariables
>;
export function useGetUserWithMinimalDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserWithMinimalDataQuery,
              GetUserWithMinimalDataQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUserWithMinimalDataQuery | undefined,
    GetUserWithMinimalDataQueryVariables
>;
export function useGetUserWithMinimalDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserWithMinimalDataQuery,
              GetUserWithMinimalDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUserWithMinimalDataQuery,
        GetUserWithMinimalDataQueryVariables
    >(GetUserWithMinimalDataDocument, options);
}
export type GetUserWithMinimalDataQueryHookResult = ReturnType<
    typeof useGetUserWithMinimalDataQuery
>;
export type GetUserWithMinimalDataLazyQueryHookResult = ReturnType<
    typeof useGetUserWithMinimalDataLazyQuery
>;
export type GetUserWithMinimalDataSuspenseQueryHookResult = ReturnType<
    typeof useGetUserWithMinimalDataSuspenseQuery
>;
export type GetUserWithMinimalDataQueryResult = Apollo.QueryResult<
    GetUserWithMinimalDataQuery,
    GetUserWithMinimalDataQueryVariables
>;
export const GetUserIdByConsumerIdDocument = gql`
    query getUserIdByConsumerId($id: String!) {
        consumer(where: { id: $id }) {
            userId
        }
    }
`;

/**
 * __useGetUserIdByConsumerIdQuery__
 *
 * To run a query within a React component, call `useGetUserIdByConsumerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIdByConsumerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIdByConsumerIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserIdByConsumerIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserIdByConsumerIdQuery,
        GetUserIdByConsumerIdQueryVariables
    > &
        (
            | { variables: GetUserIdByConsumerIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUserIdByConsumerIdQuery,
        GetUserIdByConsumerIdQueryVariables
    >(GetUserIdByConsumerIdDocument, options);
}
export function useGetUserIdByConsumerIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserIdByConsumerIdQuery,
        GetUserIdByConsumerIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUserIdByConsumerIdQuery,
        GetUserIdByConsumerIdQueryVariables
    >(GetUserIdByConsumerIdDocument, options);
}
// @ts-ignore
export function useGetUserIdByConsumerIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUserIdByConsumerIdQuery,
        GetUserIdByConsumerIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUserIdByConsumerIdQuery,
    GetUserIdByConsumerIdQueryVariables
>;
export function useGetUserIdByConsumerIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserIdByConsumerIdQuery,
              GetUserIdByConsumerIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUserIdByConsumerIdQuery | undefined,
    GetUserIdByConsumerIdQueryVariables
>;
export function useGetUserIdByConsumerIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserIdByConsumerIdQuery,
              GetUserIdByConsumerIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUserIdByConsumerIdQuery,
        GetUserIdByConsumerIdQueryVariables
    >(GetUserIdByConsumerIdDocument, options);
}
export type GetUserIdByConsumerIdQueryHookResult = ReturnType<
    typeof useGetUserIdByConsumerIdQuery
>;
export type GetUserIdByConsumerIdLazyQueryHookResult = ReturnType<
    typeof useGetUserIdByConsumerIdLazyQuery
>;
export type GetUserIdByConsumerIdSuspenseQueryHookResult = ReturnType<
    typeof useGetUserIdByConsumerIdSuspenseQuery
>;
export type GetUserIdByConsumerIdQueryResult = Apollo.QueryResult<
    GetUserIdByConsumerIdQuery,
    GetUserIdByConsumerIdQueryVariables
>;
export const GetNewUserIdByOldUserIdDocument = gql`
    query getNewUserIdByOldUserId($oldUserId: String!) {
        userToNewUser(where: { oldUserId: $oldUserId }) {
            oldUserId
            newUserId
            createdAt
        }
    }
`;

/**
 * __useGetNewUserIdByOldUserIdQuery__
 *
 * To run a query within a React component, call `useGetNewUserIdByOldUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewUserIdByOldUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewUserIdByOldUserIdQuery({
 *   variables: {
 *      oldUserId: // value for 'oldUserId'
 *   },
 * });
 */
export function useGetNewUserIdByOldUserIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetNewUserIdByOldUserIdQuery,
        GetNewUserIdByOldUserIdQueryVariables
    > &
        (
            | {
                  variables: GetNewUserIdByOldUserIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetNewUserIdByOldUserIdQuery,
        GetNewUserIdByOldUserIdQueryVariables
    >(GetNewUserIdByOldUserIdDocument, options);
}
export function useGetNewUserIdByOldUserIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetNewUserIdByOldUserIdQuery,
        GetNewUserIdByOldUserIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetNewUserIdByOldUserIdQuery,
        GetNewUserIdByOldUserIdQueryVariables
    >(GetNewUserIdByOldUserIdDocument, options);
}
// @ts-ignore
export function useGetNewUserIdByOldUserIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetNewUserIdByOldUserIdQuery,
        GetNewUserIdByOldUserIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetNewUserIdByOldUserIdQuery,
    GetNewUserIdByOldUserIdQueryVariables
>;
export function useGetNewUserIdByOldUserIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetNewUserIdByOldUserIdQuery,
              GetNewUserIdByOldUserIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetNewUserIdByOldUserIdQuery | undefined,
    GetNewUserIdByOldUserIdQueryVariables
>;
export function useGetNewUserIdByOldUserIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetNewUserIdByOldUserIdQuery,
              GetNewUserIdByOldUserIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetNewUserIdByOldUserIdQuery,
        GetNewUserIdByOldUserIdQueryVariables
    >(GetNewUserIdByOldUserIdDocument, options);
}
export type GetNewUserIdByOldUserIdQueryHookResult = ReturnType<
    typeof useGetNewUserIdByOldUserIdQuery
>;
export type GetNewUserIdByOldUserIdLazyQueryHookResult = ReturnType<
    typeof useGetNewUserIdByOldUserIdLazyQuery
>;
export type GetNewUserIdByOldUserIdSuspenseQueryHookResult = ReturnType<
    typeof useGetNewUserIdByOldUserIdSuspenseQuery
>;
export type GetNewUserIdByOldUserIdQueryResult = Apollo.QueryResult<
    GetNewUserIdByOldUserIdQuery,
    GetNewUserIdByOldUserIdQueryVariables
>;
export const CheckDobMatchesConsumersDocument = gql`
    query checkDOBMatchesConsumers(
        $dob: DateTimeISO!
        $consumerIds: [String!]!
    ) {
        consumers(where: { id: { in: $consumerIds }, dob: { equals: $dob } }) {
            id
        }
    }
`;

/**
 * __useCheckDobMatchesConsumersQuery__
 *
 * To run a query within a React component, call `useCheckDobMatchesConsumersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDobMatchesConsumersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDobMatchesConsumersQuery({
 *   variables: {
 *      dob: // value for 'dob'
 *      consumerIds: // value for 'consumerIds'
 *   },
 * });
 */
export function useCheckDobMatchesConsumersQuery(
    baseOptions: Apollo.QueryHookOptions<
        CheckDobMatchesConsumersQuery,
        CheckDobMatchesConsumersQueryVariables
    > &
        (
            | {
                  variables: CheckDobMatchesConsumersQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        CheckDobMatchesConsumersQuery,
        CheckDobMatchesConsumersQueryVariables
    >(CheckDobMatchesConsumersDocument, options);
}
export function useCheckDobMatchesConsumersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        CheckDobMatchesConsumersQuery,
        CheckDobMatchesConsumersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        CheckDobMatchesConsumersQuery,
        CheckDobMatchesConsumersQueryVariables
    >(CheckDobMatchesConsumersDocument, options);
}
// @ts-ignore
export function useCheckDobMatchesConsumersSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        CheckDobMatchesConsumersQuery,
        CheckDobMatchesConsumersQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    CheckDobMatchesConsumersQuery,
    CheckDobMatchesConsumersQueryVariables
>;
export function useCheckDobMatchesConsumersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              CheckDobMatchesConsumersQuery,
              CheckDobMatchesConsumersQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    CheckDobMatchesConsumersQuery | undefined,
    CheckDobMatchesConsumersQueryVariables
>;
export function useCheckDobMatchesConsumersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              CheckDobMatchesConsumersQuery,
              CheckDobMatchesConsumersQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        CheckDobMatchesConsumersQuery,
        CheckDobMatchesConsumersQueryVariables
    >(CheckDobMatchesConsumersDocument, options);
}
export type CheckDobMatchesConsumersQueryHookResult = ReturnType<
    typeof useCheckDobMatchesConsumersQuery
>;
export type CheckDobMatchesConsumersLazyQueryHookResult = ReturnType<
    typeof useCheckDobMatchesConsumersLazyQuery
>;
export type CheckDobMatchesConsumersSuspenseQueryHookResult = ReturnType<
    typeof useCheckDobMatchesConsumersSuspenseQuery
>;
export type CheckDobMatchesConsumersQueryResult = Apollo.QueryResult<
    CheckDobMatchesConsumersQuery,
    CheckDobMatchesConsumersQueryVariables
>;
export const GetConsumerByConsumerIdDocument = gql`
    query getConsumerByConsumerId(
        $id: String!
        $includeUser: Boolean!
        $isAdmin: Boolean!
        $includeInsurances: Boolean!
    ) {
        consumer(where: { id: $id }) {
            ...getConsumerData
            user @include(if: $includeUser) {
                ...getUserData
            }
            insurances(
                where: {
                    consumerId: { equals: $id }
                    insuranceAccountStatus: { equals: CONNECTED }
                }
            ) @include(if: $includeInsurances) {
                ...getInsuranceData
            }
            consumerNotes(
                where: { consumerId: { equals: $id } }
                orderBy: { createdAt: desc }
                take: 1
            ) @include(if: $isAdmin) {
                note
                createdAt
            }
        }
    }
    ${GetConsumerDataFragmentDoc}
    ${GetUserDataFragmentDoc}
    ${GetInsuranceDataFragmentDoc}
`;

/**
 * __useGetConsumerByConsumerIdQuery__
 *
 * To run a query within a React component, call `useGetConsumerByConsumerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerByConsumerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerByConsumerIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeUser: // value for 'includeUser'
 *      isAdmin: // value for 'isAdmin'
 *      includeInsurances: // value for 'includeInsurances'
 *   },
 * });
 */
export function useGetConsumerByConsumerIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetConsumerByConsumerIdQuery,
        GetConsumerByConsumerIdQueryVariables
    > &
        (
            | {
                  variables: GetConsumerByConsumerIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetConsumerByConsumerIdQuery,
        GetConsumerByConsumerIdQueryVariables
    >(GetConsumerByConsumerIdDocument, options);
}
export function useGetConsumerByConsumerIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetConsumerByConsumerIdQuery,
        GetConsumerByConsumerIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetConsumerByConsumerIdQuery,
        GetConsumerByConsumerIdQueryVariables
    >(GetConsumerByConsumerIdDocument, options);
}
// @ts-ignore
export function useGetConsumerByConsumerIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetConsumerByConsumerIdQuery,
        GetConsumerByConsumerIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetConsumerByConsumerIdQuery,
    GetConsumerByConsumerIdQueryVariables
>;
export function useGetConsumerByConsumerIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumerByConsumerIdQuery,
              GetConsumerByConsumerIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetConsumerByConsumerIdQuery | undefined,
    GetConsumerByConsumerIdQueryVariables
>;
export function useGetConsumerByConsumerIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumerByConsumerIdQuery,
              GetConsumerByConsumerIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetConsumerByConsumerIdQuery,
        GetConsumerByConsumerIdQueryVariables
    >(GetConsumerByConsumerIdDocument, options);
}
export type GetConsumerByConsumerIdQueryHookResult = ReturnType<
    typeof useGetConsumerByConsumerIdQuery
>;
export type GetConsumerByConsumerIdLazyQueryHookResult = ReturnType<
    typeof useGetConsumerByConsumerIdLazyQuery
>;
export type GetConsumerByConsumerIdSuspenseQueryHookResult = ReturnType<
    typeof useGetConsumerByConsumerIdSuspenseQuery
>;
export type GetConsumerByConsumerIdQueryResult = Apollo.QueryResult<
    GetConsumerByConsumerIdQuery,
    GetConsumerByConsumerIdQueryVariables
>;
export const GetInsurancesByInsuranceIdsDocument = gql`
    query getInsurancesByInsuranceIds($ids: [String!]) {
        insurances(where: { id: { in: $ids } }) {
            id
            memberId
            payer
            state
            consumerId
            insuranceAccountStatus
            status
            lastCheckedAt
            isPrimaryInsurance
        }
    }
`;

/**
 * __useGetInsurancesByInsuranceIdsQuery__
 *
 * To run a query within a React component, call `useGetInsurancesByInsuranceIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancesByInsuranceIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancesByInsuranceIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetInsurancesByInsuranceIdsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetInsurancesByInsuranceIdsQuery,
        GetInsurancesByInsuranceIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetInsurancesByInsuranceIdsQuery,
        GetInsurancesByInsuranceIdsQueryVariables
    >(GetInsurancesByInsuranceIdsDocument, options);
}
export function useGetInsurancesByInsuranceIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetInsurancesByInsuranceIdsQuery,
        GetInsurancesByInsuranceIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetInsurancesByInsuranceIdsQuery,
        GetInsurancesByInsuranceIdsQueryVariables
    >(GetInsurancesByInsuranceIdsDocument, options);
}
// @ts-ignore
export function useGetInsurancesByInsuranceIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetInsurancesByInsuranceIdsQuery,
        GetInsurancesByInsuranceIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetInsurancesByInsuranceIdsQuery,
    GetInsurancesByInsuranceIdsQueryVariables
>;
export function useGetInsurancesByInsuranceIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetInsurancesByInsuranceIdsQuery,
              GetInsurancesByInsuranceIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetInsurancesByInsuranceIdsQuery | undefined,
    GetInsurancesByInsuranceIdsQueryVariables
>;
export function useGetInsurancesByInsuranceIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetInsurancesByInsuranceIdsQuery,
              GetInsurancesByInsuranceIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetInsurancesByInsuranceIdsQuery,
        GetInsurancesByInsuranceIdsQueryVariables
    >(GetInsurancesByInsuranceIdsDocument, options);
}
export type GetInsurancesByInsuranceIdsQueryHookResult = ReturnType<
    typeof useGetInsurancesByInsuranceIdsQuery
>;
export type GetInsurancesByInsuranceIdsLazyQueryHookResult = ReturnType<
    typeof useGetInsurancesByInsuranceIdsLazyQuery
>;
export type GetInsurancesByInsuranceIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetInsurancesByInsuranceIdsSuspenseQuery
>;
export type GetInsurancesByInsuranceIdsQueryResult = Apollo.QueryResult<
    GetInsurancesByInsuranceIdsQuery,
    GetInsurancesByInsuranceIdsQueryVariables
>;
export const GetInsuranceByConsumerIdAndExcludeStatusDocument = gql`
    query getInsuranceByConsumerIdAndExcludeStatus(
        $id: String!
        $insuranceAccountStatus: [InsuranceAccountStatus!]
    ) {
        consumer(where: { id: $id }) {
            id
            insurances(
                where: {
                    insuranceAccountStatus: {
                        not: { in: $insuranceAccountStatus }
                    }
                }
                orderBy: { priority: { sort: asc } }
            ) {
                id
                memberId
                payer
                state
                status
                planName
                planStartDate
                planEndDate
                isPrimaryInsurance
                insuranceAccountStatus
                insuredFirstName
                insuredLastName
                priority
                subscriberInfo
                otherInsurances
                pcpName
                lastCheckedAt
                pcpCopayAmount
                specialistCopayAmount
                pcpCoinsurancePercentage
                specialistCoinsurancePercentage
            }
        }
    }
`;

/**
 * __useGetInsuranceByConsumerIdAndExcludeStatusQuery__
 *
 * To run a query within a React component, call `useGetInsuranceByConsumerIdAndExcludeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceByConsumerIdAndExcludeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceByConsumerIdAndExcludeStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *      insuranceAccountStatus: // value for 'insuranceAccountStatus'
 *   },
 * });
 */
export function useGetInsuranceByConsumerIdAndExcludeStatusQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetInsuranceByConsumerIdAndExcludeStatusQuery,
        GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
    > &
        (
            | {
                  variables: GetInsuranceByConsumerIdAndExcludeStatusQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetInsuranceByConsumerIdAndExcludeStatusQuery,
        GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
    >(GetInsuranceByConsumerIdAndExcludeStatusDocument, options);
}
export function useGetInsuranceByConsumerIdAndExcludeStatusLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetInsuranceByConsumerIdAndExcludeStatusQuery,
        GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetInsuranceByConsumerIdAndExcludeStatusQuery,
        GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
    >(GetInsuranceByConsumerIdAndExcludeStatusDocument, options);
}
// @ts-ignore
export function useGetInsuranceByConsumerIdAndExcludeStatusSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetInsuranceByConsumerIdAndExcludeStatusQuery,
        GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetInsuranceByConsumerIdAndExcludeStatusQuery,
    GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
>;
export function useGetInsuranceByConsumerIdAndExcludeStatusSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetInsuranceByConsumerIdAndExcludeStatusQuery,
              GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetInsuranceByConsumerIdAndExcludeStatusQuery | undefined,
    GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
>;
export function useGetInsuranceByConsumerIdAndExcludeStatusSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetInsuranceByConsumerIdAndExcludeStatusQuery,
              GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetInsuranceByConsumerIdAndExcludeStatusQuery,
        GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
    >(GetInsuranceByConsumerIdAndExcludeStatusDocument, options);
}
export type GetInsuranceByConsumerIdAndExcludeStatusQueryHookResult =
    ReturnType<typeof useGetInsuranceByConsumerIdAndExcludeStatusQuery>;
export type GetInsuranceByConsumerIdAndExcludeStatusLazyQueryHookResult =
    ReturnType<typeof useGetInsuranceByConsumerIdAndExcludeStatusLazyQuery>;
export type GetInsuranceByConsumerIdAndExcludeStatusSuspenseQueryHookResult =
    ReturnType<typeof useGetInsuranceByConsumerIdAndExcludeStatusSuspenseQuery>;
export type GetInsuranceByConsumerIdAndExcludeStatusQueryResult =
    Apollo.QueryResult<
        GetInsuranceByConsumerIdAndExcludeStatusQuery,
        GetInsuranceByConsumerIdAndExcludeStatusQueryVariables
    >;
export const UpdateUserAndEhrPatientDocument = gql`
    mutation updateUserAndEhrPatient($userUpdateInput: UpdateUserInput!) {
        updateUserAndEhrPatient(data: $userUpdateInput) {
            id
            consumersWithEhrWriteErrors
        }
    }
`;
export type UpdateUserAndEhrPatientMutationFn = Apollo.MutationFunction<
    UpdateUserAndEhrPatientMutation,
    UpdateUserAndEhrPatientMutationVariables
>;

/**
 * __useUpdateUserAndEhrPatientMutation__
 *
 * To run a mutation, you first call `useUpdateUserAndEhrPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAndEhrPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAndEhrPatientMutation, { data, loading, error }] = useUpdateUserAndEhrPatientMutation({
 *   variables: {
 *      userUpdateInput: // value for 'userUpdateInput'
 *   },
 * });
 */
export function useUpdateUserAndEhrPatientMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateUserAndEhrPatientMutation,
        UpdateUserAndEhrPatientMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateUserAndEhrPatientMutation,
        UpdateUserAndEhrPatientMutationVariables
    >(UpdateUserAndEhrPatientDocument, options);
}
export type UpdateUserAndEhrPatientMutationHookResult = ReturnType<
    typeof useUpdateUserAndEhrPatientMutation
>;
export type UpdateUserAndEhrPatientMutationResult =
    Apollo.MutationResult<UpdateUserAndEhrPatientMutation>;
export type UpdateUserAndEhrPatientMutationOptions = Apollo.BaseMutationOptions<
    UpdateUserAndEhrPatientMutation,
    UpdateUserAndEhrPatientMutationVariables
>;
export const GetSuperscriptQuestionsDocument = gql`
    query getSuperscriptQuestions($orgId: Int!) {
        superscriptIntakeQuestions {
            id
            questionText
            type
            intakeQuestions(where: { orgId: { equals: $orgId } }) {
                id
                orgId
            }
        }
    }
`;

/**
 * __useGetSuperscriptQuestionsQuery__
 *
 * To run a query within a React component, call `useGetSuperscriptQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuperscriptQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuperscriptQuestionsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetSuperscriptQuestionsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSuperscriptQuestionsQuery,
        GetSuperscriptQuestionsQueryVariables
    > &
        (
            | {
                  variables: GetSuperscriptQuestionsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetSuperscriptQuestionsQuery,
        GetSuperscriptQuestionsQueryVariables
    >(GetSuperscriptQuestionsDocument, options);
}
export function useGetSuperscriptQuestionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSuperscriptQuestionsQuery,
        GetSuperscriptQuestionsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetSuperscriptQuestionsQuery,
        GetSuperscriptQuestionsQueryVariables
    >(GetSuperscriptQuestionsDocument, options);
}
// @ts-ignore
export function useGetSuperscriptQuestionsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetSuperscriptQuestionsQuery,
        GetSuperscriptQuestionsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetSuperscriptQuestionsQuery,
    GetSuperscriptQuestionsQueryVariables
>;
export function useGetSuperscriptQuestionsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSuperscriptQuestionsQuery,
              GetSuperscriptQuestionsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetSuperscriptQuestionsQuery | undefined,
    GetSuperscriptQuestionsQueryVariables
>;
export function useGetSuperscriptQuestionsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSuperscriptQuestionsQuery,
              GetSuperscriptQuestionsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetSuperscriptQuestionsQuery,
        GetSuperscriptQuestionsQueryVariables
    >(GetSuperscriptQuestionsDocument, options);
}
export type GetSuperscriptQuestionsQueryHookResult = ReturnType<
    typeof useGetSuperscriptQuestionsQuery
>;
export type GetSuperscriptQuestionsLazyQueryHookResult = ReturnType<
    typeof useGetSuperscriptQuestionsLazyQuery
>;
export type GetSuperscriptQuestionsSuspenseQueryHookResult = ReturnType<
    typeof useGetSuperscriptQuestionsSuspenseQuery
>;
export type GetSuperscriptQuestionsQueryResult = Apollo.QueryResult<
    GetSuperscriptQuestionsQuery,
    GetSuperscriptQuestionsQueryVariables
>;
export const GetIntakeQuestionByNameDocument = gql`
    query getIntakeQuestionByName($orgId: Int!, $name: String!) {
        intakeQuestion(
            where: {
                intake_question_name_and_org_unique: {
                    orgId: $orgId
                    name: $name
                }
            }
        ) {
            id
            questionText
            questionAttributes
            type
            orgId
            intakeFormSectionId
            intakeFormSectionOrder
            superscriptIntakeQuestionId
            superscriptIntakeQuestion {
                id
                questionText
                type
            }
            intakeFormSection {
                id
                text
                name
                priority
                intakeFormSectionTranslations {
                    languageCode
                    text
                    name
                }
            }
            intakeQuestionTranslations {
                languageCode
                questionText
                questionAttributes
            }
        }
    }
`;

/**
 * __useGetIntakeQuestionByNameQuery__
 *
 * To run a query within a React component, call `useGetIntakeQuestionByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakeQuestionByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakeQuestionByNameQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetIntakeQuestionByNameQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetIntakeQuestionByNameQuery,
        GetIntakeQuestionByNameQueryVariables
    > &
        (
            | {
                  variables: GetIntakeQuestionByNameQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetIntakeQuestionByNameQuery,
        GetIntakeQuestionByNameQueryVariables
    >(GetIntakeQuestionByNameDocument, options);
}
export function useGetIntakeQuestionByNameLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetIntakeQuestionByNameQuery,
        GetIntakeQuestionByNameQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetIntakeQuestionByNameQuery,
        GetIntakeQuestionByNameQueryVariables
    >(GetIntakeQuestionByNameDocument, options);
}
// @ts-ignore
export function useGetIntakeQuestionByNameSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetIntakeQuestionByNameQuery,
        GetIntakeQuestionByNameQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetIntakeQuestionByNameQuery,
    GetIntakeQuestionByNameQueryVariables
>;
export function useGetIntakeQuestionByNameSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIntakeQuestionByNameQuery,
              GetIntakeQuestionByNameQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetIntakeQuestionByNameQuery | undefined,
    GetIntakeQuestionByNameQueryVariables
>;
export function useGetIntakeQuestionByNameSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIntakeQuestionByNameQuery,
              GetIntakeQuestionByNameQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetIntakeQuestionByNameQuery,
        GetIntakeQuestionByNameQueryVariables
    >(GetIntakeQuestionByNameDocument, options);
}
export type GetIntakeQuestionByNameQueryHookResult = ReturnType<
    typeof useGetIntakeQuestionByNameQuery
>;
export type GetIntakeQuestionByNameLazyQueryHookResult = ReturnType<
    typeof useGetIntakeQuestionByNameLazyQuery
>;
export type GetIntakeQuestionByNameSuspenseQueryHookResult = ReturnType<
    typeof useGetIntakeQuestionByNameSuspenseQuery
>;
export type GetIntakeQuestionByNameQueryResult = Apollo.QueryResult<
    GetIntakeQuestionByNameQuery,
    GetIntakeQuestionByNameQueryVariables
>;
export const GetIntakeQuestionByIdDocument = gql`
    query getIntakeQuestionById($id: Int!) {
        intakeQuestion(where: { id: $id }) {
            id
            questionText
            questionAttributes
            type
            orgId
            intakeFormSectionId
            intakeFormSectionOrder
            superscriptIntakeQuestionId
            superscriptIntakeQuestion {
                id
                questionText
                type
            }
            intakeFormSection {
                id
                text
                name
                priority
                intakeFormSectionTranslations {
                    languageCode
                    text
                    name
                }
            }
            intakeQuestionTranslations {
                languageCode
                questionText
                questionAttributes
            }
        }
    }
`;

/**
 * __useGetIntakeQuestionByIdQuery__
 *
 * To run a query within a React component, call `useGetIntakeQuestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakeQuestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakeQuestionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntakeQuestionByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetIntakeQuestionByIdQuery,
        GetIntakeQuestionByIdQueryVariables
    > &
        (
            | { variables: GetIntakeQuestionByIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetIntakeQuestionByIdQuery,
        GetIntakeQuestionByIdQueryVariables
    >(GetIntakeQuestionByIdDocument, options);
}
export function useGetIntakeQuestionByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetIntakeQuestionByIdQuery,
        GetIntakeQuestionByIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetIntakeQuestionByIdQuery,
        GetIntakeQuestionByIdQueryVariables
    >(GetIntakeQuestionByIdDocument, options);
}
// @ts-ignore
export function useGetIntakeQuestionByIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetIntakeQuestionByIdQuery,
        GetIntakeQuestionByIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetIntakeQuestionByIdQuery,
    GetIntakeQuestionByIdQueryVariables
>;
export function useGetIntakeQuestionByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIntakeQuestionByIdQuery,
              GetIntakeQuestionByIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetIntakeQuestionByIdQuery | undefined,
    GetIntakeQuestionByIdQueryVariables
>;
export function useGetIntakeQuestionByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIntakeQuestionByIdQuery,
              GetIntakeQuestionByIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetIntakeQuestionByIdQuery,
        GetIntakeQuestionByIdQueryVariables
    >(GetIntakeQuestionByIdDocument, options);
}
export type GetIntakeQuestionByIdQueryHookResult = ReturnType<
    typeof useGetIntakeQuestionByIdQuery
>;
export type GetIntakeQuestionByIdLazyQueryHookResult = ReturnType<
    typeof useGetIntakeQuestionByIdLazyQuery
>;
export type GetIntakeQuestionByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetIntakeQuestionByIdSuspenseQuery
>;
export type GetIntakeQuestionByIdQueryResult = Apollo.QueryResult<
    GetIntakeQuestionByIdQuery,
    GetIntakeQuestionByIdQueryVariables
>;
export const GetIntakeFormByFormIdDocument = gql`
    query getIntakeFormByFormId($ids: [Int!]) {
        intakeForms(where: { id: { in: $ids } }) {
            name
            priority
            id
            completionTiming
            consentTypes
            _count {
                intakeFormToQuestions
            }
            intakeFormToQuestions {
                intakeQuestionId
            }
        }
    }
`;

/**
 * __useGetIntakeFormByFormIdQuery__
 *
 * To run a query within a React component, call `useGetIntakeFormByFormIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakeFormByFormIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakeFormByFormIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetIntakeFormByFormIdQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetIntakeFormByFormIdQuery,
        GetIntakeFormByFormIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetIntakeFormByFormIdQuery,
        GetIntakeFormByFormIdQueryVariables
    >(GetIntakeFormByFormIdDocument, options);
}
export function useGetIntakeFormByFormIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetIntakeFormByFormIdQuery,
        GetIntakeFormByFormIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetIntakeFormByFormIdQuery,
        GetIntakeFormByFormIdQueryVariables
    >(GetIntakeFormByFormIdDocument, options);
}
// @ts-ignore
export function useGetIntakeFormByFormIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetIntakeFormByFormIdQuery,
        GetIntakeFormByFormIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetIntakeFormByFormIdQuery,
    GetIntakeFormByFormIdQueryVariables
>;
export function useGetIntakeFormByFormIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIntakeFormByFormIdQuery,
              GetIntakeFormByFormIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetIntakeFormByFormIdQuery | undefined,
    GetIntakeFormByFormIdQueryVariables
>;
export function useGetIntakeFormByFormIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIntakeFormByFormIdQuery,
              GetIntakeFormByFormIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetIntakeFormByFormIdQuery,
        GetIntakeFormByFormIdQueryVariables
    >(GetIntakeFormByFormIdDocument, options);
}
export type GetIntakeFormByFormIdQueryHookResult = ReturnType<
    typeof useGetIntakeFormByFormIdQuery
>;
export type GetIntakeFormByFormIdLazyQueryHookResult = ReturnType<
    typeof useGetIntakeFormByFormIdLazyQuery
>;
export type GetIntakeFormByFormIdSuspenseQueryHookResult = ReturnType<
    typeof useGetIntakeFormByFormIdSuspenseQuery
>;
export type GetIntakeFormByFormIdQueryResult = Apollo.QueryResult<
    GetIntakeFormByFormIdQuery,
    GetIntakeFormByFormIdQueryVariables
>;
export const GetSavedIntakeResponsesByIdsDocument = gql`
    query getSavedIntakeResponsesByIds(
        $intakeQuestionIds: [Int!]
        $consumerId: String!
    ) {
        savedIntakeResponses(
            where: {
                AND: [
                    { intakeQuestionId: { in: $intakeQuestionIds } }
                    { consumerId: { equals: $consumerId } }
                ]
            }
        ) {
            response
            intakeQuestionId
            consumerId
            updatedAt
            intakeQuestion {
                type
            }
        }
    }
`;

/**
 * __useGetSavedIntakeResponsesByIdsQuery__
 *
 * To run a query within a React component, call `useGetSavedIntakeResponsesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedIntakeResponsesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedIntakeResponsesByIdsQuery({
 *   variables: {
 *      intakeQuestionIds: // value for 'intakeQuestionIds'
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useGetSavedIntakeResponsesByIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSavedIntakeResponsesByIdsQuery,
        GetSavedIntakeResponsesByIdsQueryVariables
    > &
        (
            | {
                  variables: GetSavedIntakeResponsesByIdsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetSavedIntakeResponsesByIdsQuery,
        GetSavedIntakeResponsesByIdsQueryVariables
    >(GetSavedIntakeResponsesByIdsDocument, options);
}
export function useGetSavedIntakeResponsesByIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSavedIntakeResponsesByIdsQuery,
        GetSavedIntakeResponsesByIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetSavedIntakeResponsesByIdsQuery,
        GetSavedIntakeResponsesByIdsQueryVariables
    >(GetSavedIntakeResponsesByIdsDocument, options);
}
// @ts-ignore
export function useGetSavedIntakeResponsesByIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetSavedIntakeResponsesByIdsQuery,
        GetSavedIntakeResponsesByIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetSavedIntakeResponsesByIdsQuery,
    GetSavedIntakeResponsesByIdsQueryVariables
>;
export function useGetSavedIntakeResponsesByIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSavedIntakeResponsesByIdsQuery,
              GetSavedIntakeResponsesByIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetSavedIntakeResponsesByIdsQuery | undefined,
    GetSavedIntakeResponsesByIdsQueryVariables
>;
export function useGetSavedIntakeResponsesByIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSavedIntakeResponsesByIdsQuery,
              GetSavedIntakeResponsesByIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetSavedIntakeResponsesByIdsQuery,
        GetSavedIntakeResponsesByIdsQueryVariables
    >(GetSavedIntakeResponsesByIdsDocument, options);
}
export type GetSavedIntakeResponsesByIdsQueryHookResult = ReturnType<
    typeof useGetSavedIntakeResponsesByIdsQuery
>;
export type GetSavedIntakeResponsesByIdsLazyQueryHookResult = ReturnType<
    typeof useGetSavedIntakeResponsesByIdsLazyQuery
>;
export type GetSavedIntakeResponsesByIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetSavedIntakeResponsesByIdsSuspenseQuery
>;
export type GetSavedIntakeResponsesByIdsQueryResult = Apollo.QueryResult<
    GetSavedIntakeResponsesByIdsQuery,
    GetSavedIntakeResponsesByIdsQueryVariables
>;
export const GetIntakeFormForOrgDocument = gql`
    query getIntakeFormForOrg($orgId: Int!) {
        intakeForms(where: { orgId: { equals: $orgId } }) {
            id
            autoAddRules
            name
            refreshPeriodInDays
            intakeFormToQuestions {
                intakeQuestionId
            }
        }
    }
`;

/**
 * __useGetIntakeFormForOrgQuery__
 *
 * To run a query within a React component, call `useGetIntakeFormForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakeFormForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakeFormForOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetIntakeFormForOrgQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetIntakeFormForOrgQuery,
        GetIntakeFormForOrgQueryVariables
    > &
        (
            | { variables: GetIntakeFormForOrgQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetIntakeFormForOrgQuery,
        GetIntakeFormForOrgQueryVariables
    >(GetIntakeFormForOrgDocument, options);
}
export function useGetIntakeFormForOrgLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetIntakeFormForOrgQuery,
        GetIntakeFormForOrgQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetIntakeFormForOrgQuery,
        GetIntakeFormForOrgQueryVariables
    >(GetIntakeFormForOrgDocument, options);
}
// @ts-ignore
export function useGetIntakeFormForOrgSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetIntakeFormForOrgQuery,
        GetIntakeFormForOrgQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetIntakeFormForOrgQuery,
    GetIntakeFormForOrgQueryVariables
>;
export function useGetIntakeFormForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIntakeFormForOrgQuery,
              GetIntakeFormForOrgQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetIntakeFormForOrgQuery | undefined,
    GetIntakeFormForOrgQueryVariables
>;
export function useGetIntakeFormForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIntakeFormForOrgQuery,
              GetIntakeFormForOrgQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetIntakeFormForOrgQuery,
        GetIntakeFormForOrgQueryVariables
    >(GetIntakeFormForOrgDocument, options);
}
export type GetIntakeFormForOrgQueryHookResult = ReturnType<
    typeof useGetIntakeFormForOrgQuery
>;
export type GetIntakeFormForOrgLazyQueryHookResult = ReturnType<
    typeof useGetIntakeFormForOrgLazyQuery
>;
export type GetIntakeFormForOrgSuspenseQueryHookResult = ReturnType<
    typeof useGetIntakeFormForOrgSuspenseQuery
>;
export type GetIntakeFormForOrgQueryResult = Apollo.QueryResult<
    GetIntakeFormForOrgQuery,
    GetIntakeFormForOrgQueryVariables
>;
export const CreateChargesDocument = gql`
    mutation createCharges($charges: [ChargeDto!]!) {
        createCharges(charges: $charges) {
            id
            boughtTreatmentId
        }
    }
`;
export type CreateChargesMutationFn = Apollo.MutationFunction<
    CreateChargesMutation,
    CreateChargesMutationVariables
>;

/**
 * __useCreateChargesMutation__
 *
 * To run a mutation, you first call `useCreateChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChargesMutation, { data, loading, error }] = useCreateChargesMutation({
 *   variables: {
 *      charges: // value for 'charges'
 *   },
 * });
 */
export function useCreateChargesMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateChargesMutation,
        CreateChargesMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CreateChargesMutation,
        CreateChargesMutationVariables
    >(CreateChargesDocument, options);
}
export type CreateChargesMutationHookResult = ReturnType<
    typeof useCreateChargesMutation
>;
export type CreateChargesMutationResult =
    Apollo.MutationResult<CreateChargesMutation>;
export type CreateChargesMutationOptions = Apollo.BaseMutationOptions<
    CreateChargesMutation,
    CreateChargesMutationVariables
>;
export const PayChargesDocument = gql`
    mutation payCharges($transactionMetadata: CreateTransactionRequestDto!) {
        payCharges(transactionMetadata: $transactionMetadata) {
            id
            transactionId
        }
    }
`;
export type PayChargesMutationFn = Apollo.MutationFunction<
    PayChargesMutation,
    PayChargesMutationVariables
>;

/**
 * __usePayChargesMutation__
 *
 * To run a mutation, you first call `usePayChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payChargesMutation, { data, loading, error }] = usePayChargesMutation({
 *   variables: {
 *      transactionMetadata: // value for 'transactionMetadata'
 *   },
 * });
 */
export function usePayChargesMutation(
    baseOptions?: Apollo.MutationHookOptions<
        PayChargesMutation,
        PayChargesMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<PayChargesMutation, PayChargesMutationVariables>(
        PayChargesDocument,
        options,
    );
}
export type PayChargesMutationHookResult = ReturnType<
    typeof usePayChargesMutation
>;
export type PayChargesMutationResult =
    Apollo.MutationResult<PayChargesMutation>;
export type PayChargesMutationOptions = Apollo.BaseMutationOptions<
    PayChargesMutation,
    PayChargesMutationVariables
>;
export const CancelChargesDocument = gql`
    mutation cancelCharges($data: CancelChargesDto!) {
        cancelCharges(data: $data) {
            id
        }
    }
`;
export type CancelChargesMutationFn = Apollo.MutationFunction<
    CancelChargesMutation,
    CancelChargesMutationVariables
>;

/**
 * __useCancelChargesMutation__
 *
 * To run a mutation, you first call `useCancelChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelChargesMutation, { data, loading, error }] = useCancelChargesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelChargesMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CancelChargesMutation,
        CancelChargesMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CancelChargesMutation,
        CancelChargesMutationVariables
    >(CancelChargesDocument, options);
}
export type CancelChargesMutationHookResult = ReturnType<
    typeof useCancelChargesMutation
>;
export type CancelChargesMutationResult =
    Apollo.MutationResult<CancelChargesMutation>;
export type CancelChargesMutationOptions = Apollo.BaseMutationOptions<
    CancelChargesMutation,
    CancelChargesMutationVariables
>;
export const GetIntakeFormsAndQuestionsByFormIdsDocument = gql`
    query getIntakeFormsAndQuestionsByFormIds($ids: [Int!]!) {
        intakeForms(where: { id: { in: $ids } }) {
            name
            id
            priority
            consentTypes
            intakeFormToQuestions {
                section
                isRequired
                questionNumber
                intakeQuestion {
                    questionText
                    questionAttributes
                    intakeFormSectionId
                    intakeFormSectionOrder
                    superscriptIntakeQuestion {
                        id
                        questionText
                    }
                    intakeFormSection {
                        id
                        text
                        name
                        priority
                        intakeFormSectionTranslations {
                            languageCode
                            text
                            name
                        }
                    }
                    intakeQuestionTranslations {
                        languageCode
                        questionText
                        questionAttributes
                    }
                    type
                    id
                }
            }
        }
    }
`;

/**
 * __useGetIntakeFormsAndQuestionsByFormIdsQuery__
 *
 * To run a query within a React component, call `useGetIntakeFormsAndQuestionsByFormIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakeFormsAndQuestionsByFormIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakeFormsAndQuestionsByFormIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetIntakeFormsAndQuestionsByFormIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetIntakeFormsAndQuestionsByFormIdsQuery,
        GetIntakeFormsAndQuestionsByFormIdsQueryVariables
    > &
        (
            | {
                  variables: GetIntakeFormsAndQuestionsByFormIdsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetIntakeFormsAndQuestionsByFormIdsQuery,
        GetIntakeFormsAndQuestionsByFormIdsQueryVariables
    >(GetIntakeFormsAndQuestionsByFormIdsDocument, options);
}
export function useGetIntakeFormsAndQuestionsByFormIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetIntakeFormsAndQuestionsByFormIdsQuery,
        GetIntakeFormsAndQuestionsByFormIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetIntakeFormsAndQuestionsByFormIdsQuery,
        GetIntakeFormsAndQuestionsByFormIdsQueryVariables
    >(GetIntakeFormsAndQuestionsByFormIdsDocument, options);
}
// @ts-ignore
export function useGetIntakeFormsAndQuestionsByFormIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetIntakeFormsAndQuestionsByFormIdsQuery,
        GetIntakeFormsAndQuestionsByFormIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetIntakeFormsAndQuestionsByFormIdsQuery,
    GetIntakeFormsAndQuestionsByFormIdsQueryVariables
>;
export function useGetIntakeFormsAndQuestionsByFormIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIntakeFormsAndQuestionsByFormIdsQuery,
              GetIntakeFormsAndQuestionsByFormIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetIntakeFormsAndQuestionsByFormIdsQuery | undefined,
    GetIntakeFormsAndQuestionsByFormIdsQueryVariables
>;
export function useGetIntakeFormsAndQuestionsByFormIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetIntakeFormsAndQuestionsByFormIdsQuery,
              GetIntakeFormsAndQuestionsByFormIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetIntakeFormsAndQuestionsByFormIdsQuery,
        GetIntakeFormsAndQuestionsByFormIdsQueryVariables
    >(GetIntakeFormsAndQuestionsByFormIdsDocument, options);
}
export type GetIntakeFormsAndQuestionsByFormIdsQueryHookResult = ReturnType<
    typeof useGetIntakeFormsAndQuestionsByFormIdsQuery
>;
export type GetIntakeFormsAndQuestionsByFormIdsLazyQueryHookResult = ReturnType<
    typeof useGetIntakeFormsAndQuestionsByFormIdsLazyQuery
>;
export type GetIntakeFormsAndQuestionsByFormIdsSuspenseQueryHookResult =
    ReturnType<typeof useGetIntakeFormsAndQuestionsByFormIdsSuspenseQuery>;
export type GetIntakeFormsAndQuestionsByFormIdsQueryResult = Apollo.QueryResult<
    GetIntakeFormsAndQuestionsByFormIdsQuery,
    GetIntakeFormsAndQuestionsByFormIdsQueryVariables
>;
export const GetExistingSlotsForCalendarDocument = gql`
    query getExistingSlotsForCalendar(
        $providerId: Int
        $practiceId: Int
        $startDateTime: DateTimeISO!
        $endDateTime: DateTimeISO!
        $orgId: Int
    ) {
        slots(
            where: {
                AND: [
                    {
                        OR: [
                            { providerId: { equals: $providerId } }
                            { practiceId: { equals: $practiceId } }
                        ]
                    }
                    { startTime: { gte: $startDateTime } }
                    { endTime: { lte: $endDateTime } }
                    { status: { in: [upcoming, completed] } }
                    {
                        boughtTreatments: {
                            some: { orgId: { equals: $orgId } }
                        }
                    }
                ]
            }
        ) {
            id
            boughtTreatments {
                name
                consumerId
                orgId
            }
            ehrSlotId
            EhrSlot {
                ehrVisitIds
                ehrLocationId
                scheduleSlotName
                ehrAppointmentTypeId
            }
            startTime
            endTime
            providerId
            practiceId
            status
            reviewStatus
        }
    }
`;

/**
 * __useGetExistingSlotsForCalendarQuery__
 *
 * To run a query within a React component, call `useGetExistingSlotsForCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingSlotsForCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingSlotsForCalendarQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      practiceId: // value for 'practiceId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetExistingSlotsForCalendarQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetExistingSlotsForCalendarQuery,
        GetExistingSlotsForCalendarQueryVariables
    > &
        (
            | {
                  variables: GetExistingSlotsForCalendarQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetExistingSlotsForCalendarQuery,
        GetExistingSlotsForCalendarQueryVariables
    >(GetExistingSlotsForCalendarDocument, options);
}
export function useGetExistingSlotsForCalendarLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetExistingSlotsForCalendarQuery,
        GetExistingSlotsForCalendarQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetExistingSlotsForCalendarQuery,
        GetExistingSlotsForCalendarQueryVariables
    >(GetExistingSlotsForCalendarDocument, options);
}
// @ts-ignore
export function useGetExistingSlotsForCalendarSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetExistingSlotsForCalendarQuery,
        GetExistingSlotsForCalendarQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetExistingSlotsForCalendarQuery,
    GetExistingSlotsForCalendarQueryVariables
>;
export function useGetExistingSlotsForCalendarSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetExistingSlotsForCalendarQuery,
              GetExistingSlotsForCalendarQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetExistingSlotsForCalendarQuery | undefined,
    GetExistingSlotsForCalendarQueryVariables
>;
export function useGetExistingSlotsForCalendarSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetExistingSlotsForCalendarQuery,
              GetExistingSlotsForCalendarQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetExistingSlotsForCalendarQuery,
        GetExistingSlotsForCalendarQueryVariables
    >(GetExistingSlotsForCalendarDocument, options);
}
export type GetExistingSlotsForCalendarQueryHookResult = ReturnType<
    typeof useGetExistingSlotsForCalendarQuery
>;
export type GetExistingSlotsForCalendarLazyQueryHookResult = ReturnType<
    typeof useGetExistingSlotsForCalendarLazyQuery
>;
export type GetExistingSlotsForCalendarSuspenseQueryHookResult = ReturnType<
    typeof useGetExistingSlotsForCalendarSuspenseQuery
>;
export type GetExistingSlotsForCalendarQueryResult = Apollo.QueryResult<
    GetExistingSlotsForCalendarQuery,
    GetExistingSlotsForCalendarQueryVariables
>;
export const GetProviderHrtMaxCountsDocument = gql`
    query getProviderHrtMaxCounts($providerId: Int!) {
        providerHrtMaxCounts(
            where: { AND: [{ providerId: { equals: $providerId } }] }
        ) {
            id
            maxCount
            providerId
            hrt {
                hrtId
                orgId
                name
                displayName
            }
        }
    }
`;

/**
 * __useGetProviderHrtMaxCountsQuery__
 *
 * To run a query within a React component, call `useGetProviderHrtMaxCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderHrtMaxCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderHrtMaxCountsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetProviderHrtMaxCountsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProviderHrtMaxCountsQuery,
        GetProviderHrtMaxCountsQueryVariables
    > &
        (
            | {
                  variables: GetProviderHrtMaxCountsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProviderHrtMaxCountsQuery,
        GetProviderHrtMaxCountsQueryVariables
    >(GetProviderHrtMaxCountsDocument, options);
}
export function useGetProviderHrtMaxCountsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderHrtMaxCountsQuery,
        GetProviderHrtMaxCountsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderHrtMaxCountsQuery,
        GetProviderHrtMaxCountsQueryVariables
    >(GetProviderHrtMaxCountsDocument, options);
}
// @ts-ignore
export function useGetProviderHrtMaxCountsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderHrtMaxCountsQuery,
        GetProviderHrtMaxCountsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderHrtMaxCountsQuery,
    GetProviderHrtMaxCountsQueryVariables
>;
export function useGetProviderHrtMaxCountsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderHrtMaxCountsQuery,
              GetProviderHrtMaxCountsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderHrtMaxCountsQuery | undefined,
    GetProviderHrtMaxCountsQueryVariables
>;
export function useGetProviderHrtMaxCountsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderHrtMaxCountsQuery,
              GetProviderHrtMaxCountsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderHrtMaxCountsQuery,
        GetProviderHrtMaxCountsQueryVariables
    >(GetProviderHrtMaxCountsDocument, options);
}
export type GetProviderHrtMaxCountsQueryHookResult = ReturnType<
    typeof useGetProviderHrtMaxCountsQuery
>;
export type GetProviderHrtMaxCountsLazyQueryHookResult = ReturnType<
    typeof useGetProviderHrtMaxCountsLazyQuery
>;
export type GetProviderHrtMaxCountsSuspenseQueryHookResult = ReturnType<
    typeof useGetProviderHrtMaxCountsSuspenseQuery
>;
export type GetProviderHrtMaxCountsQueryResult = Apollo.QueryResult<
    GetProviderHrtMaxCountsQuery,
    GetProviderHrtMaxCountsQueryVariables
>;
export const GetSlotConfigPracticeByIdDocument = gql`
    query getSlotConfigPracticeById($id: Int!) {
        schedulingSlotConfigs(where: { practiceId: { equals: $id } }) {
            ehrVisitId
            id
            name
            practiceId
        }
    }
`;

/**
 * __useGetSlotConfigPracticeByIdQuery__
 *
 * To run a query within a React component, call `useGetSlotConfigPracticeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlotConfigPracticeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlotConfigPracticeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSlotConfigPracticeByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSlotConfigPracticeByIdQuery,
        GetSlotConfigPracticeByIdQueryVariables
    > &
        (
            | {
                  variables: GetSlotConfigPracticeByIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetSlotConfigPracticeByIdQuery,
        GetSlotConfigPracticeByIdQueryVariables
    >(GetSlotConfigPracticeByIdDocument, options);
}
export function useGetSlotConfigPracticeByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSlotConfigPracticeByIdQuery,
        GetSlotConfigPracticeByIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetSlotConfigPracticeByIdQuery,
        GetSlotConfigPracticeByIdQueryVariables
    >(GetSlotConfigPracticeByIdDocument, options);
}
// @ts-ignore
export function useGetSlotConfigPracticeByIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetSlotConfigPracticeByIdQuery,
        GetSlotConfigPracticeByIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetSlotConfigPracticeByIdQuery,
    GetSlotConfigPracticeByIdQueryVariables
>;
export function useGetSlotConfigPracticeByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSlotConfigPracticeByIdQuery,
              GetSlotConfigPracticeByIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetSlotConfigPracticeByIdQuery | undefined,
    GetSlotConfigPracticeByIdQueryVariables
>;
export function useGetSlotConfigPracticeByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSlotConfigPracticeByIdQuery,
              GetSlotConfigPracticeByIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetSlotConfigPracticeByIdQuery,
        GetSlotConfigPracticeByIdQueryVariables
    >(GetSlotConfigPracticeByIdDocument, options);
}
export type GetSlotConfigPracticeByIdQueryHookResult = ReturnType<
    typeof useGetSlotConfigPracticeByIdQuery
>;
export type GetSlotConfigPracticeByIdLazyQueryHookResult = ReturnType<
    typeof useGetSlotConfigPracticeByIdLazyQuery
>;
export type GetSlotConfigPracticeByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetSlotConfigPracticeByIdSuspenseQuery
>;
export type GetSlotConfigPracticeByIdQueryResult = Apollo.QueryResult<
    GetSlotConfigPracticeByIdQuery,
    GetSlotConfigPracticeByIdQueryVariables
>;
export const GetAllEnabledOrgConfigFlagsByOrgIdDocument = gql`
    query getAllEnabledOrgConfigFlagsByOrgId($orgId: Int!) {
        orgConfigFlags(where: { orgId: { equals: $orgId } }) {
            flagName
            isEnabled
        }
    }
`;

/**
 * __useGetAllEnabledOrgConfigFlagsByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetAllEnabledOrgConfigFlagsByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEnabledOrgConfigFlagsByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEnabledOrgConfigFlagsByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetAllEnabledOrgConfigFlagsByOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAllEnabledOrgConfigFlagsByOrgIdQuery,
        GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
    > &
        (
            | {
                  variables: GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAllEnabledOrgConfigFlagsByOrgIdQuery,
        GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
    >(GetAllEnabledOrgConfigFlagsByOrgIdDocument, options);
}
export function useGetAllEnabledOrgConfigFlagsByOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllEnabledOrgConfigFlagsByOrgIdQuery,
        GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAllEnabledOrgConfigFlagsByOrgIdQuery,
        GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
    >(GetAllEnabledOrgConfigFlagsByOrgIdDocument, options);
}
// @ts-ignore
export function useGetAllEnabledOrgConfigFlagsByOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAllEnabledOrgConfigFlagsByOrgIdQuery,
        GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAllEnabledOrgConfigFlagsByOrgIdQuery,
    GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
>;
export function useGetAllEnabledOrgConfigFlagsByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllEnabledOrgConfigFlagsByOrgIdQuery,
              GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAllEnabledOrgConfigFlagsByOrgIdQuery | undefined,
    GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
>;
export function useGetAllEnabledOrgConfigFlagsByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllEnabledOrgConfigFlagsByOrgIdQuery,
              GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAllEnabledOrgConfigFlagsByOrgIdQuery,
        GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
    >(GetAllEnabledOrgConfigFlagsByOrgIdDocument, options);
}
export type GetAllEnabledOrgConfigFlagsByOrgIdQueryHookResult = ReturnType<
    typeof useGetAllEnabledOrgConfigFlagsByOrgIdQuery
>;
export type GetAllEnabledOrgConfigFlagsByOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetAllEnabledOrgConfigFlagsByOrgIdLazyQuery
>;
export type GetAllEnabledOrgConfigFlagsByOrgIdSuspenseQueryHookResult =
    ReturnType<typeof useGetAllEnabledOrgConfigFlagsByOrgIdSuspenseQuery>;
export type GetAllEnabledOrgConfigFlagsByOrgIdQueryResult = Apollo.QueryResult<
    GetAllEnabledOrgConfigFlagsByOrgIdQuery,
    GetAllEnabledOrgConfigFlagsByOrgIdQueryVariables
>;
export const GetProviderOrderingDocument = gql`
    query getProviderOrdering($orgId: Int!) {
        providerToOrgs(where: { orgId: { equals: $orgId } }) {
            providerId
            providerHidden
            orderNumber
        }
    }
`;

/**
 * __useGetProviderOrderingQuery__
 *
 * To run a query within a React component, call `useGetProviderOrderingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderOrderingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderOrderingQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetProviderOrderingQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProviderOrderingQuery,
        GetProviderOrderingQueryVariables
    > &
        (
            | { variables: GetProviderOrderingQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProviderOrderingQuery,
        GetProviderOrderingQueryVariables
    >(GetProviderOrderingDocument, options);
}
export function useGetProviderOrderingLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderOrderingQuery,
        GetProviderOrderingQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderOrderingQuery,
        GetProviderOrderingQueryVariables
    >(GetProviderOrderingDocument, options);
}
// @ts-ignore
export function useGetProviderOrderingSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderOrderingQuery,
        GetProviderOrderingQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderOrderingQuery,
    GetProviderOrderingQueryVariables
>;
export function useGetProviderOrderingSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderOrderingQuery,
              GetProviderOrderingQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderOrderingQuery | undefined,
    GetProviderOrderingQueryVariables
>;
export function useGetProviderOrderingSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderOrderingQuery,
              GetProviderOrderingQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderOrderingQuery,
        GetProviderOrderingQueryVariables
    >(GetProviderOrderingDocument, options);
}
export type GetProviderOrderingQueryHookResult = ReturnType<
    typeof useGetProviderOrderingQuery
>;
export type GetProviderOrderingLazyQueryHookResult = ReturnType<
    typeof useGetProviderOrderingLazyQuery
>;
export type GetProviderOrderingSuspenseQueryHookResult = ReturnType<
    typeof useGetProviderOrderingSuspenseQuery
>;
export type GetProviderOrderingQueryResult = Apollo.QueryResult<
    GetProviderOrderingQuery,
    GetProviderOrderingQueryVariables
>;
export const CreateManyConsumerInsurancesDocument = gql`
    mutation createManyConsumerInsurances(
        $id: String!
        $insurances: [InsuranceCreateManyConsumerInput!]!
    ) {
        updateOneConsumer(
            data: { insurances: { createMany: { data: $insurances } } }
            where: { id: $id }
        ) {
            id
            insurances {
                id
                memberId
                state
                payer
            }
        }
    }
`;
export type CreateManyConsumerInsurancesMutationFn = Apollo.MutationFunction<
    CreateManyConsumerInsurancesMutation,
    CreateManyConsumerInsurancesMutationVariables
>;

/**
 * __useCreateManyConsumerInsurancesMutation__
 *
 * To run a mutation, you first call `useCreateManyConsumerInsurancesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManyConsumerInsurancesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManyConsumerInsurancesMutation, { data, loading, error }] = useCreateManyConsumerInsurancesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      insurances: // value for 'insurances'
 *   },
 * });
 */
export function useCreateManyConsumerInsurancesMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateManyConsumerInsurancesMutation,
        CreateManyConsumerInsurancesMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CreateManyConsumerInsurancesMutation,
        CreateManyConsumerInsurancesMutationVariables
    >(CreateManyConsumerInsurancesDocument, options);
}
export type CreateManyConsumerInsurancesMutationHookResult = ReturnType<
    typeof useCreateManyConsumerInsurancesMutation
>;
export type CreateManyConsumerInsurancesMutationResult =
    Apollo.MutationResult<CreateManyConsumerInsurancesMutation>;
export type CreateManyConsumerInsurancesMutationOptions =
    Apollo.BaseMutationOptions<
        CreateManyConsumerInsurancesMutation,
        CreateManyConsumerInsurancesMutationVariables
    >;
export const GetAllAppointmentsForConsumerIdForOrgDocument = gql`
    query getAllAppointmentsForConsumerIdForOrg(
        $orgId: Int!
        $consumerId: String!
        $appointmentStatus: [AppointmentStatusEnum!]
        $slotStatus: [SlotStatusEnum!]
        $boughtTreatmentStatuses: [BoughtTreatmentStatusEnum!]
    ) {
        detailSlots(
            orgId: $orgId
            where: {
                boughtTreatments: {
                    some: {
                        AND: [
                            { consumerId: { equals: $consumerId } }
                            { status: { in: $boughtTreatmentStatuses } }
                        ]
                    }
                }
                appointment: { is: { status: { in: $appointmentStatus } } }
                status: { in: $slotStatus }
            }
            orderBy: { startTime: asc }
        ) {
            ...detailSlotFields
        }
    }
    ${DetailSlotFieldsFragmentDoc}
`;

/**
 * __useGetAllAppointmentsForConsumerIdForOrgQuery__
 *
 * To run a query within a React component, call `useGetAllAppointmentsForConsumerIdForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAppointmentsForConsumerIdForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAppointmentsForConsumerIdForOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      consumerId: // value for 'consumerId'
 *      appointmentStatus: // value for 'appointmentStatus'
 *      slotStatus: // value for 'slotStatus'
 *      boughtTreatmentStatuses: // value for 'boughtTreatmentStatuses'
 *   },
 * });
 */
export function useGetAllAppointmentsForConsumerIdForOrgQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAllAppointmentsForConsumerIdForOrgQuery,
        GetAllAppointmentsForConsumerIdForOrgQueryVariables
    > &
        (
            | {
                  variables: GetAllAppointmentsForConsumerIdForOrgQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAllAppointmentsForConsumerIdForOrgQuery,
        GetAllAppointmentsForConsumerIdForOrgQueryVariables
    >(GetAllAppointmentsForConsumerIdForOrgDocument, options);
}
export function useGetAllAppointmentsForConsumerIdForOrgLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllAppointmentsForConsumerIdForOrgQuery,
        GetAllAppointmentsForConsumerIdForOrgQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAllAppointmentsForConsumerIdForOrgQuery,
        GetAllAppointmentsForConsumerIdForOrgQueryVariables
    >(GetAllAppointmentsForConsumerIdForOrgDocument, options);
}
// @ts-ignore
export function useGetAllAppointmentsForConsumerIdForOrgSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAllAppointmentsForConsumerIdForOrgQuery,
        GetAllAppointmentsForConsumerIdForOrgQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAllAppointmentsForConsumerIdForOrgQuery,
    GetAllAppointmentsForConsumerIdForOrgQueryVariables
>;
export function useGetAllAppointmentsForConsumerIdForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllAppointmentsForConsumerIdForOrgQuery,
              GetAllAppointmentsForConsumerIdForOrgQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAllAppointmentsForConsumerIdForOrgQuery | undefined,
    GetAllAppointmentsForConsumerIdForOrgQueryVariables
>;
export function useGetAllAppointmentsForConsumerIdForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllAppointmentsForConsumerIdForOrgQuery,
              GetAllAppointmentsForConsumerIdForOrgQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAllAppointmentsForConsumerIdForOrgQuery,
        GetAllAppointmentsForConsumerIdForOrgQueryVariables
    >(GetAllAppointmentsForConsumerIdForOrgDocument, options);
}
export type GetAllAppointmentsForConsumerIdForOrgQueryHookResult = ReturnType<
    typeof useGetAllAppointmentsForConsumerIdForOrgQuery
>;
export type GetAllAppointmentsForConsumerIdForOrgLazyQueryHookResult =
    ReturnType<typeof useGetAllAppointmentsForConsumerIdForOrgLazyQuery>;
export type GetAllAppointmentsForConsumerIdForOrgSuspenseQueryHookResult =
    ReturnType<typeof useGetAllAppointmentsForConsumerIdForOrgSuspenseQuery>;
export type GetAllAppointmentsForConsumerIdForOrgQueryResult =
    Apollo.QueryResult<
        GetAllAppointmentsForConsumerIdForOrgQuery,
        GetAllAppointmentsForConsumerIdForOrgQueryVariables
    >;
export const GetInsuranceIdsForUpcomingAppointmentsDocument = gql`
    query getInsuranceIdsForUpcomingAppointments(
        $consumerIds: [String!]!
        $orgId: Int!
    ) {
        appointments(
            where: {
                status: { in: [upcoming] }
                slots: {
                    some: {
                        status: { in: [upcoming] }
                        boughtTreatments: {
                            some: {
                                consumerId: { in: $consumerIds }
                                orgId: { equals: $orgId }
                                status: { in: [active] }
                            }
                        }
                    }
                }
            }
        ) {
            slots(orderBy: [{ startTime: asc }, { appointmentId: asc }]) {
                id
                practiceId
                boughtTreatments {
                    insuranceIds
                }
            }
        }
    }
`;

/**
 * __useGetInsuranceIdsForUpcomingAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetInsuranceIdsForUpcomingAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceIdsForUpcomingAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceIdsForUpcomingAppointmentsQuery({
 *   variables: {
 *      consumerIds: // value for 'consumerIds'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetInsuranceIdsForUpcomingAppointmentsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetInsuranceIdsForUpcomingAppointmentsQuery,
        GetInsuranceIdsForUpcomingAppointmentsQueryVariables
    > &
        (
            | {
                  variables: GetInsuranceIdsForUpcomingAppointmentsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetInsuranceIdsForUpcomingAppointmentsQuery,
        GetInsuranceIdsForUpcomingAppointmentsQueryVariables
    >(GetInsuranceIdsForUpcomingAppointmentsDocument, options);
}
export function useGetInsuranceIdsForUpcomingAppointmentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetInsuranceIdsForUpcomingAppointmentsQuery,
        GetInsuranceIdsForUpcomingAppointmentsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetInsuranceIdsForUpcomingAppointmentsQuery,
        GetInsuranceIdsForUpcomingAppointmentsQueryVariables
    >(GetInsuranceIdsForUpcomingAppointmentsDocument, options);
}
// @ts-ignore
export function useGetInsuranceIdsForUpcomingAppointmentsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetInsuranceIdsForUpcomingAppointmentsQuery,
        GetInsuranceIdsForUpcomingAppointmentsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetInsuranceIdsForUpcomingAppointmentsQuery,
    GetInsuranceIdsForUpcomingAppointmentsQueryVariables
>;
export function useGetInsuranceIdsForUpcomingAppointmentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetInsuranceIdsForUpcomingAppointmentsQuery,
              GetInsuranceIdsForUpcomingAppointmentsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetInsuranceIdsForUpcomingAppointmentsQuery | undefined,
    GetInsuranceIdsForUpcomingAppointmentsQueryVariables
>;
export function useGetInsuranceIdsForUpcomingAppointmentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetInsuranceIdsForUpcomingAppointmentsQuery,
              GetInsuranceIdsForUpcomingAppointmentsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetInsuranceIdsForUpcomingAppointmentsQuery,
        GetInsuranceIdsForUpcomingAppointmentsQueryVariables
    >(GetInsuranceIdsForUpcomingAppointmentsDocument, options);
}
export type GetInsuranceIdsForUpcomingAppointmentsQueryHookResult = ReturnType<
    typeof useGetInsuranceIdsForUpcomingAppointmentsQuery
>;
export type GetInsuranceIdsForUpcomingAppointmentsLazyQueryHookResult =
    ReturnType<typeof useGetInsuranceIdsForUpcomingAppointmentsLazyQuery>;
export type GetInsuranceIdsForUpcomingAppointmentsSuspenseQueryHookResult =
    ReturnType<typeof useGetInsuranceIdsForUpcomingAppointmentsSuspenseQuery>;
export type GetInsuranceIdsForUpcomingAppointmentsQueryResult =
    Apollo.QueryResult<
        GetInsuranceIdsForUpcomingAppointmentsQuery,
        GetInsuranceIdsForUpcomingAppointmentsQueryVariables
    >;
export const GetAllAppointmentsForConsumerIdForPracticeDocument = gql`
    query getAllAppointmentsForConsumerIdForPractice(
        $orgId: Int!
        $practiceId: Int!
        $consumerId: String!
        $appointmentStatus: [AppointmentStatusEnum!]
        $slotStatus: [SlotStatusEnum!]
        $boughtTreatmentStatuses: [BoughtTreatmentStatusEnum!]
    ) {
        detailSlots(
            orgId: $orgId
            where: {
                boughtTreatments: {
                    some: {
                        AND: [
                            { consumerId: { equals: $consumerId } }
                            { status: { in: $boughtTreatmentStatuses } }
                        ]
                    }
                }
                appointment: { is: { status: { in: $appointmentStatus } } }
                status: { in: $slotStatus }
                practiceId: { equals: $practiceId }
            }
            orderBy: { startTime: asc }
        ) {
            ...detailSlotFields
        }
    }
    ${DetailSlotFieldsFragmentDoc}
`;

/**
 * __useGetAllAppointmentsForConsumerIdForPracticeQuery__
 *
 * To run a query within a React component, call `useGetAllAppointmentsForConsumerIdForPracticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAppointmentsForConsumerIdForPracticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAppointmentsForConsumerIdForPracticeQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      practiceId: // value for 'practiceId'
 *      consumerId: // value for 'consumerId'
 *      appointmentStatus: // value for 'appointmentStatus'
 *      slotStatus: // value for 'slotStatus'
 *      boughtTreatmentStatuses: // value for 'boughtTreatmentStatuses'
 *   },
 * });
 */
export function useGetAllAppointmentsForConsumerIdForPracticeQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAllAppointmentsForConsumerIdForPracticeQuery,
        GetAllAppointmentsForConsumerIdForPracticeQueryVariables
    > &
        (
            | {
                  variables: GetAllAppointmentsForConsumerIdForPracticeQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAllAppointmentsForConsumerIdForPracticeQuery,
        GetAllAppointmentsForConsumerIdForPracticeQueryVariables
    >(GetAllAppointmentsForConsumerIdForPracticeDocument, options);
}
export function useGetAllAppointmentsForConsumerIdForPracticeLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllAppointmentsForConsumerIdForPracticeQuery,
        GetAllAppointmentsForConsumerIdForPracticeQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAllAppointmentsForConsumerIdForPracticeQuery,
        GetAllAppointmentsForConsumerIdForPracticeQueryVariables
    >(GetAllAppointmentsForConsumerIdForPracticeDocument, options);
}
// @ts-ignore
export function useGetAllAppointmentsForConsumerIdForPracticeSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAllAppointmentsForConsumerIdForPracticeQuery,
        GetAllAppointmentsForConsumerIdForPracticeQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAllAppointmentsForConsumerIdForPracticeQuery,
    GetAllAppointmentsForConsumerIdForPracticeQueryVariables
>;
export function useGetAllAppointmentsForConsumerIdForPracticeSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllAppointmentsForConsumerIdForPracticeQuery,
              GetAllAppointmentsForConsumerIdForPracticeQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAllAppointmentsForConsumerIdForPracticeQuery | undefined,
    GetAllAppointmentsForConsumerIdForPracticeQueryVariables
>;
export function useGetAllAppointmentsForConsumerIdForPracticeSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllAppointmentsForConsumerIdForPracticeQuery,
              GetAllAppointmentsForConsumerIdForPracticeQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAllAppointmentsForConsumerIdForPracticeQuery,
        GetAllAppointmentsForConsumerIdForPracticeQueryVariables
    >(GetAllAppointmentsForConsumerIdForPracticeDocument, options);
}
export type GetAllAppointmentsForConsumerIdForPracticeQueryHookResult =
    ReturnType<typeof useGetAllAppointmentsForConsumerIdForPracticeQuery>;
export type GetAllAppointmentsForConsumerIdForPracticeLazyQueryHookResult =
    ReturnType<typeof useGetAllAppointmentsForConsumerIdForPracticeLazyQuery>;
export type GetAllAppointmentsForConsumerIdForPracticeSuspenseQueryHookResult =
    ReturnType<
        typeof useGetAllAppointmentsForConsumerIdForPracticeSuspenseQuery
    >;
export type GetAllAppointmentsForConsumerIdForPracticeQueryResult =
    Apollo.QueryResult<
        GetAllAppointmentsForConsumerIdForPracticeQuery,
        GetAllAppointmentsForConsumerIdForPracticeQueryVariables
    >;
export const GetCompletedAppointmentsForConsumersDocument = gql`
    query getCompletedAppointmentsForConsumers(
        $consumerIds: [String!]!
        $orgId: IntFilter
    ) {
        appointments(
            where: {
                status: { in: [completed, missed, canceled] }
                slots: {
                    some: {
                        boughtTreatments: {
                            some: {
                                consumerId: { in: $consumerIds }
                                orgId: $orgId
                            }
                        }
                    }
                }
            }
        ) {
            id
            status
            claimReturnStatus
            intakeFormIds
            completedIntakeFormIds
            slots(orderBy: { startTime: asc }) {
                id
                startTime
                providerId
                practiceId
                boughtTreatments(orderBy: { createdAt: asc }) {
                    id
                    name
                    consumerId
                    price
                    pricedTreatmentId
                    orgId
                    hrtId
                    discountCodeApplied
                    status
                    overrideReason
                    lastUpdatedBy
                    reviewStatus
                    paymentType
                }
            }
        }
    }
`;

/**
 * __useGetCompletedAppointmentsForConsumersQuery__
 *
 * To run a query within a React component, call `useGetCompletedAppointmentsForConsumersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedAppointmentsForConsumersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedAppointmentsForConsumersQuery({
 *   variables: {
 *      consumerIds: // value for 'consumerIds'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetCompletedAppointmentsForConsumersQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetCompletedAppointmentsForConsumersQuery,
        GetCompletedAppointmentsForConsumersQueryVariables
    > &
        (
            | {
                  variables: GetCompletedAppointmentsForConsumersQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetCompletedAppointmentsForConsumersQuery,
        GetCompletedAppointmentsForConsumersQueryVariables
    >(GetCompletedAppointmentsForConsumersDocument, options);
}
export function useGetCompletedAppointmentsForConsumersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCompletedAppointmentsForConsumersQuery,
        GetCompletedAppointmentsForConsumersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetCompletedAppointmentsForConsumersQuery,
        GetCompletedAppointmentsForConsumersQueryVariables
    >(GetCompletedAppointmentsForConsumersDocument, options);
}
// @ts-ignore
export function useGetCompletedAppointmentsForConsumersSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetCompletedAppointmentsForConsumersQuery,
        GetCompletedAppointmentsForConsumersQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetCompletedAppointmentsForConsumersQuery,
    GetCompletedAppointmentsForConsumersQueryVariables
>;
export function useGetCompletedAppointmentsForConsumersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetCompletedAppointmentsForConsumersQuery,
              GetCompletedAppointmentsForConsumersQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetCompletedAppointmentsForConsumersQuery | undefined,
    GetCompletedAppointmentsForConsumersQueryVariables
>;
export function useGetCompletedAppointmentsForConsumersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetCompletedAppointmentsForConsumersQuery,
              GetCompletedAppointmentsForConsumersQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetCompletedAppointmentsForConsumersQuery,
        GetCompletedAppointmentsForConsumersQueryVariables
    >(GetCompletedAppointmentsForConsumersDocument, options);
}
export type GetCompletedAppointmentsForConsumersQueryHookResult = ReturnType<
    typeof useGetCompletedAppointmentsForConsumersQuery
>;
export type GetCompletedAppointmentsForConsumersLazyQueryHookResult =
    ReturnType<typeof useGetCompletedAppointmentsForConsumersLazyQuery>;
export type GetCompletedAppointmentsForConsumersSuspenseQueryHookResult =
    ReturnType<typeof useGetCompletedAppointmentsForConsumersSuspenseQuery>;
export type GetCompletedAppointmentsForConsumersQueryResult =
    Apollo.QueryResult<
        GetCompletedAppointmentsForConsumersQuery,
        GetCompletedAppointmentsForConsumersQueryVariables
    >;
export const GetAppointmentByIdDocument = gql`
    query getAppointmentById($appointmentId: String!) {
        appointment(where: { id: $appointmentId }) {
            id
            intakeFormIds
            completedIntakeFormIds
            status
            claimReturnStatus
            slots(orderBy: { startTime: asc }) {
                id
                startTime
                practiceId
                providerId
                consumerId
                status
                virtualLink
                boughtTreatments(orderBy: { createdAt: asc }) {
                    id
                    name
                    consumerId
                    orgId
                    price
                    paymentType
                    pricedTreatmentId
                    hrtId
                    discountCodeApplied
                    status
                    overrideReason
                    lastUpdatedBy
                    isVirtual
                    reviewStatus
                    insuranceIds
                }
            }
        }
    }
`;

/**
 * __useGetAppointmentByIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentByIdQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAppointmentByIdQuery,
        GetAppointmentByIdQueryVariables
    > &
        (
            | { variables: GetAppointmentByIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAppointmentByIdQuery,
        GetAppointmentByIdQueryVariables
    >(GetAppointmentByIdDocument, options);
}
export function useGetAppointmentByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAppointmentByIdQuery,
        GetAppointmentByIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAppointmentByIdQuery,
        GetAppointmentByIdQueryVariables
    >(GetAppointmentByIdDocument, options);
}
// @ts-ignore
export function useGetAppointmentByIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAppointmentByIdQuery,
        GetAppointmentByIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAppointmentByIdQuery,
    GetAppointmentByIdQueryVariables
>;
export function useGetAppointmentByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAppointmentByIdQuery,
              GetAppointmentByIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAppointmentByIdQuery | undefined,
    GetAppointmentByIdQueryVariables
>;
export function useGetAppointmentByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAppointmentByIdQuery,
              GetAppointmentByIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAppointmentByIdQuery,
        GetAppointmentByIdQueryVariables
    >(GetAppointmentByIdDocument, options);
}
export type GetAppointmentByIdQueryHookResult = ReturnType<
    typeof useGetAppointmentByIdQuery
>;
export type GetAppointmentByIdLazyQueryHookResult = ReturnType<
    typeof useGetAppointmentByIdLazyQuery
>;
export type GetAppointmentByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetAppointmentByIdSuspenseQuery
>;
export type GetAppointmentByIdQueryResult = Apollo.QueryResult<
    GetAppointmentByIdQuery,
    GetAppointmentByIdQueryVariables
>;
export const GetAppointmentIntakeFormIdsDocument = gql`
    query getAppointmentIntakeFormIds($appointmentId: String!) {
        appointment(where: { id: $appointmentId }) {
            completedIntakeFormIds
            intakeFormIds
        }
    }
`;

/**
 * __useGetAppointmentIntakeFormIdsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentIntakeFormIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentIntakeFormIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentIntakeFormIdsQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentIntakeFormIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAppointmentIntakeFormIdsQuery,
        GetAppointmentIntakeFormIdsQueryVariables
    > &
        (
            | {
                  variables: GetAppointmentIntakeFormIdsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAppointmentIntakeFormIdsQuery,
        GetAppointmentIntakeFormIdsQueryVariables
    >(GetAppointmentIntakeFormIdsDocument, options);
}
export function useGetAppointmentIntakeFormIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAppointmentIntakeFormIdsQuery,
        GetAppointmentIntakeFormIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAppointmentIntakeFormIdsQuery,
        GetAppointmentIntakeFormIdsQueryVariables
    >(GetAppointmentIntakeFormIdsDocument, options);
}
// @ts-ignore
export function useGetAppointmentIntakeFormIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAppointmentIntakeFormIdsQuery,
        GetAppointmentIntakeFormIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAppointmentIntakeFormIdsQuery,
    GetAppointmentIntakeFormIdsQueryVariables
>;
export function useGetAppointmentIntakeFormIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAppointmentIntakeFormIdsQuery,
              GetAppointmentIntakeFormIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAppointmentIntakeFormIdsQuery | undefined,
    GetAppointmentIntakeFormIdsQueryVariables
>;
export function useGetAppointmentIntakeFormIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAppointmentIntakeFormIdsQuery,
              GetAppointmentIntakeFormIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAppointmentIntakeFormIdsQuery,
        GetAppointmentIntakeFormIdsQueryVariables
    >(GetAppointmentIntakeFormIdsDocument, options);
}
export type GetAppointmentIntakeFormIdsQueryHookResult = ReturnType<
    typeof useGetAppointmentIntakeFormIdsQuery
>;
export type GetAppointmentIntakeFormIdsLazyQueryHookResult = ReturnType<
    typeof useGetAppointmentIntakeFormIdsLazyQuery
>;
export type GetAppointmentIntakeFormIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetAppointmentIntakeFormIdsSuspenseQuery
>;
export type GetAppointmentIntakeFormIdsQueryResult = Apollo.QueryResult<
    GetAppointmentIntakeFormIdsQuery,
    GetAppointmentIntakeFormIdsQueryVariables
>;
export const GetBoughtTreatmentByIdDocument = gql`
    query getBoughtTreatmentById($boughtTreatmentId: String!) {
        boughtTreatment(where: { id: $boughtTreatmentId }) {
            id
            name
            consumerId
            orgId
            insuranceIds
            paymentType
            pricedTreatmentId
            discountCodeApplied
            status
            overrideReason
            lastUpdatedBy
            isVirtual
        }
    }
`;

/**
 * __useGetBoughtTreatmentByIdQuery__
 *
 * To run a query within a React component, call `useGetBoughtTreatmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoughtTreatmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoughtTreatmentByIdQuery({
 *   variables: {
 *      boughtTreatmentId: // value for 'boughtTreatmentId'
 *   },
 * });
 */
export function useGetBoughtTreatmentByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetBoughtTreatmentByIdQuery,
        GetBoughtTreatmentByIdQueryVariables
    > &
        (
            | {
                  variables: GetBoughtTreatmentByIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBoughtTreatmentByIdQuery,
        GetBoughtTreatmentByIdQueryVariables
    >(GetBoughtTreatmentByIdDocument, options);
}
export function useGetBoughtTreatmentByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBoughtTreatmentByIdQuery,
        GetBoughtTreatmentByIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBoughtTreatmentByIdQuery,
        GetBoughtTreatmentByIdQueryVariables
    >(GetBoughtTreatmentByIdDocument, options);
}
// @ts-ignore
export function useGetBoughtTreatmentByIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetBoughtTreatmentByIdQuery,
        GetBoughtTreatmentByIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentByIdQuery,
    GetBoughtTreatmentByIdQueryVariables
>;
export function useGetBoughtTreatmentByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentByIdQuery,
              GetBoughtTreatmentByIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentByIdQuery | undefined,
    GetBoughtTreatmentByIdQueryVariables
>;
export function useGetBoughtTreatmentByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentByIdQuery,
              GetBoughtTreatmentByIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBoughtTreatmentByIdQuery,
        GetBoughtTreatmentByIdQueryVariables
    >(GetBoughtTreatmentByIdDocument, options);
}
export type GetBoughtTreatmentByIdQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentByIdQuery
>;
export type GetBoughtTreatmentByIdLazyQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentByIdLazyQuery
>;
export type GetBoughtTreatmentByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentByIdSuspenseQuery
>;
export type GetBoughtTreatmentByIdQueryResult = Apollo.QueryResult<
    GetBoughtTreatmentByIdQuery,
    GetBoughtTreatmentByIdQueryVariables
>;
export const GetBoughtTreatmentsByIdsDocument = gql`
    query getBoughtTreatmentsByIds($boughtTreatmentIds: [String!]!) {
        boughtTreatments(where: { id: { in: $boughtTreatmentIds } }) {
            id
            name
            consumerId
            orgId
            insuranceIds
            paymentType
            pricedTreatmentId
            hrtId
            discountCodeApplied
            price
            status
            source
            overrideReason
            lastUpdatedBy
            reviewStatus
            isVirtual
        }
    }
`;

/**
 * __useGetBoughtTreatmentsByIdsQuery__
 *
 * To run a query within a React component, call `useGetBoughtTreatmentsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoughtTreatmentsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoughtTreatmentsByIdsQuery({
 *   variables: {
 *      boughtTreatmentIds: // value for 'boughtTreatmentIds'
 *   },
 * });
 */
export function useGetBoughtTreatmentsByIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetBoughtTreatmentsByIdsQuery,
        GetBoughtTreatmentsByIdsQueryVariables
    > &
        (
            | {
                  variables: GetBoughtTreatmentsByIdsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBoughtTreatmentsByIdsQuery,
        GetBoughtTreatmentsByIdsQueryVariables
    >(GetBoughtTreatmentsByIdsDocument, options);
}
export function useGetBoughtTreatmentsByIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBoughtTreatmentsByIdsQuery,
        GetBoughtTreatmentsByIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBoughtTreatmentsByIdsQuery,
        GetBoughtTreatmentsByIdsQueryVariables
    >(GetBoughtTreatmentsByIdsDocument, options);
}
// @ts-ignore
export function useGetBoughtTreatmentsByIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetBoughtTreatmentsByIdsQuery,
        GetBoughtTreatmentsByIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentsByIdsQuery,
    GetBoughtTreatmentsByIdsQueryVariables
>;
export function useGetBoughtTreatmentsByIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentsByIdsQuery,
              GetBoughtTreatmentsByIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentsByIdsQuery | undefined,
    GetBoughtTreatmentsByIdsQueryVariables
>;
export function useGetBoughtTreatmentsByIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentsByIdsQuery,
              GetBoughtTreatmentsByIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBoughtTreatmentsByIdsQuery,
        GetBoughtTreatmentsByIdsQueryVariables
    >(GetBoughtTreatmentsByIdsDocument, options);
}
export type GetBoughtTreatmentsByIdsQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentsByIdsQuery
>;
export type GetBoughtTreatmentsByIdsLazyQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentsByIdsLazyQuery
>;
export type GetBoughtTreatmentsByIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentsByIdsSuspenseQuery
>;
export type GetBoughtTreatmentsByIdsQueryResult = Apollo.QueryResult<
    GetBoughtTreatmentsByIdsQuery,
    GetBoughtTreatmentsByIdsQueryVariables
>;
export const GetBoughtTreatmentsByIdsWithSlotsDocument = gql`
    query getBoughtTreatmentsByIdsWithSlots($boughtTreatmentIds: [String!]!) {
        boughtTreatments(where: { id: { in: $boughtTreatmentIds } }) {
            id
            name
            consumerId
            orgId
            insuranceIds
            paymentType
            pricedTreatmentId
            hrtId
            discountCodeApplied
            price
            status
            source
            overrideReason
            lastUpdatedBy
            reviewStatus
            isVirtual
            slot {
                id
                startTime
                status
                providerId
                appointment {
                    id
                    status
                    claimReturnStatus
                }
            }
        }
    }
`;

/**
 * __useGetBoughtTreatmentsByIdsWithSlotsQuery__
 *
 * To run a query within a React component, call `useGetBoughtTreatmentsByIdsWithSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoughtTreatmentsByIdsWithSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoughtTreatmentsByIdsWithSlotsQuery({
 *   variables: {
 *      boughtTreatmentIds: // value for 'boughtTreatmentIds'
 *   },
 * });
 */
export function useGetBoughtTreatmentsByIdsWithSlotsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetBoughtTreatmentsByIdsWithSlotsQuery,
        GetBoughtTreatmentsByIdsWithSlotsQueryVariables
    > &
        (
            | {
                  variables: GetBoughtTreatmentsByIdsWithSlotsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBoughtTreatmentsByIdsWithSlotsQuery,
        GetBoughtTreatmentsByIdsWithSlotsQueryVariables
    >(GetBoughtTreatmentsByIdsWithSlotsDocument, options);
}
export function useGetBoughtTreatmentsByIdsWithSlotsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBoughtTreatmentsByIdsWithSlotsQuery,
        GetBoughtTreatmentsByIdsWithSlotsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBoughtTreatmentsByIdsWithSlotsQuery,
        GetBoughtTreatmentsByIdsWithSlotsQueryVariables
    >(GetBoughtTreatmentsByIdsWithSlotsDocument, options);
}
// @ts-ignore
export function useGetBoughtTreatmentsByIdsWithSlotsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetBoughtTreatmentsByIdsWithSlotsQuery,
        GetBoughtTreatmentsByIdsWithSlotsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentsByIdsWithSlotsQuery,
    GetBoughtTreatmentsByIdsWithSlotsQueryVariables
>;
export function useGetBoughtTreatmentsByIdsWithSlotsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentsByIdsWithSlotsQuery,
              GetBoughtTreatmentsByIdsWithSlotsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentsByIdsWithSlotsQuery | undefined,
    GetBoughtTreatmentsByIdsWithSlotsQueryVariables
>;
export function useGetBoughtTreatmentsByIdsWithSlotsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentsByIdsWithSlotsQuery,
              GetBoughtTreatmentsByIdsWithSlotsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBoughtTreatmentsByIdsWithSlotsQuery,
        GetBoughtTreatmentsByIdsWithSlotsQueryVariables
    >(GetBoughtTreatmentsByIdsWithSlotsDocument, options);
}
export type GetBoughtTreatmentsByIdsWithSlotsQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentsByIdsWithSlotsQuery
>;
export type GetBoughtTreatmentsByIdsWithSlotsLazyQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentsByIdsWithSlotsLazyQuery
>;
export type GetBoughtTreatmentsByIdsWithSlotsSuspenseQueryHookResult =
    ReturnType<typeof useGetBoughtTreatmentsByIdsWithSlotsSuspenseQuery>;
export type GetBoughtTreatmentsByIdsWithSlotsQueryResult = Apollo.QueryResult<
    GetBoughtTreatmentsByIdsWithSlotsQuery,
    GetBoughtTreatmentsByIdsWithSlotsQueryVariables
>;
export const GetUnscheduledBoughtTreatmentsForConsumersDocument = gql`
    query getUnscheduledBoughtTreatmentsForConsumers($consumerIds: [String!]!) {
        boughtTreatments(
            where: {
                consumerId: { in: $consumerIds }
                slotId: { equals: null }
            }
            orderBy: { createdAt: asc }
        ) {
            id
            name
            name
            orgId
            consumerId
            price
            pricedTreatmentId
            source
            insuranceIds
            createdAt
            discountCodeApplied
            status
            overrideReason
            lastUpdatedBy
            isVirtual
        }
    }
`;

/**
 * __useGetUnscheduledBoughtTreatmentsForConsumersQuery__
 *
 * To run a query within a React component, call `useGetUnscheduledBoughtTreatmentsForConsumersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnscheduledBoughtTreatmentsForConsumersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnscheduledBoughtTreatmentsForConsumersQuery({
 *   variables: {
 *      consumerIds: // value for 'consumerIds'
 *   },
 * });
 */
export function useGetUnscheduledBoughtTreatmentsForConsumersQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUnscheduledBoughtTreatmentsForConsumersQuery,
        GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
    > &
        (
            | {
                  variables: GetUnscheduledBoughtTreatmentsForConsumersQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUnscheduledBoughtTreatmentsForConsumersQuery,
        GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
    >(GetUnscheduledBoughtTreatmentsForConsumersDocument, options);
}
export function useGetUnscheduledBoughtTreatmentsForConsumersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUnscheduledBoughtTreatmentsForConsumersQuery,
        GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUnscheduledBoughtTreatmentsForConsumersQuery,
        GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
    >(GetUnscheduledBoughtTreatmentsForConsumersDocument, options);
}
// @ts-ignore
export function useGetUnscheduledBoughtTreatmentsForConsumersSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUnscheduledBoughtTreatmentsForConsumersQuery,
        GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUnscheduledBoughtTreatmentsForConsumersQuery,
    GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
>;
export function useGetUnscheduledBoughtTreatmentsForConsumersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUnscheduledBoughtTreatmentsForConsumersQuery,
              GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUnscheduledBoughtTreatmentsForConsumersQuery | undefined,
    GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
>;
export function useGetUnscheduledBoughtTreatmentsForConsumersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUnscheduledBoughtTreatmentsForConsumersQuery,
              GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUnscheduledBoughtTreatmentsForConsumersQuery,
        GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
    >(GetUnscheduledBoughtTreatmentsForConsumersDocument, options);
}
export type GetUnscheduledBoughtTreatmentsForConsumersQueryHookResult =
    ReturnType<typeof useGetUnscheduledBoughtTreatmentsForConsumersQuery>;
export type GetUnscheduledBoughtTreatmentsForConsumersLazyQueryHookResult =
    ReturnType<typeof useGetUnscheduledBoughtTreatmentsForConsumersLazyQuery>;
export type GetUnscheduledBoughtTreatmentsForConsumersSuspenseQueryHookResult =
    ReturnType<
        typeof useGetUnscheduledBoughtTreatmentsForConsumersSuspenseQuery
    >;
export type GetUnscheduledBoughtTreatmentsForConsumersQueryResult =
    Apollo.QueryResult<
        GetUnscheduledBoughtTreatmentsForConsumersQuery,
        GetUnscheduledBoughtTreatmentsForConsumersQueryVariables
    >;
export const GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesDocument = gql`
    query getUnscheduledBoughtTreatmentsForConsumersExcludeStatuses(
        $consumerIds: [String!]!
        $statuses: [BoughtTreatmentStatusEnum!]
    ) {
        detailBoughtTreatments(
            where: {
                AND: [
                    {
                        consumerId: { in: $consumerIds }
                        slotId: { equals: null }
                    }
                    { status: { notIn: $statuses } }
                ]
            }
            orderBy: { createdAt: asc }
        ) {
            id
            name
            name
            orgId
            consumerId
            consumer
            price
            pricedTreatmentId
            source
            hrtId
            status
            insuranceIds
            paymentType
            createdAt
            discountCodeApplied
            charges
            overrideReason
            lastUpdatedBy
            isVirtual
            reviewStatus
        }
    }
`;

/**
 * __useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery__
 *
 * To run a query within a React component, call `useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery({
 *   variables: {
 *      consumerIds: // value for 'consumerIds'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery,
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
    > &
        (
            | {
                  variables: GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery,
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
    >(
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesDocument,
        options,
    );
}
export function useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery,
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery,
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
    >(
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesDocument,
        options,
    );
}
// @ts-ignore
export function useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery,
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery,
    GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
>;
export function useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery,
              GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery | undefined,
    GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
>;
export function useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery,
              GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery,
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
    >(
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesDocument,
        options,
    );
}
export type GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryHookResult =
    ReturnType<
        typeof useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery
    >;
export type GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesLazyQueryHookResult =
    ReturnType<
        typeof useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesLazyQuery
    >;
export type GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesSuspenseQueryHookResult =
    ReturnType<
        typeof useGetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesSuspenseQuery
    >;
export type GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryResult =
    Apollo.QueryResult<
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQuery,
        GetUnscheduledBoughtTreatmentsForConsumersExcludeStatusesQueryVariables
    >;
export const GetPricedTreatmentsByIdsDocument = gql`
    query getPricedTreatmentsByIds($ids: [Int!]!) {
        pricedTreatments(where: { id: { in: $ids } }) {
            id
            price
            hrtId
            paymentType
            metadata
        }
    }
`;

/**
 * __useGetPricedTreatmentsByIdsQuery__
 *
 * To run a query within a React component, call `useGetPricedTreatmentsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricedTreatmentsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricedTreatmentsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetPricedTreatmentsByIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPricedTreatmentsByIdsQuery,
        GetPricedTreatmentsByIdsQueryVariables
    > &
        (
            | {
                  variables: GetPricedTreatmentsByIdsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetPricedTreatmentsByIdsQuery,
        GetPricedTreatmentsByIdsQueryVariables
    >(GetPricedTreatmentsByIdsDocument, options);
}
export function useGetPricedTreatmentsByIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPricedTreatmentsByIdsQuery,
        GetPricedTreatmentsByIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPricedTreatmentsByIdsQuery,
        GetPricedTreatmentsByIdsQueryVariables
    >(GetPricedTreatmentsByIdsDocument, options);
}
// @ts-ignore
export function useGetPricedTreatmentsByIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetPricedTreatmentsByIdsQuery,
        GetPricedTreatmentsByIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetPricedTreatmentsByIdsQuery,
    GetPricedTreatmentsByIdsQueryVariables
>;
export function useGetPricedTreatmentsByIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPricedTreatmentsByIdsQuery,
              GetPricedTreatmentsByIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetPricedTreatmentsByIdsQuery | undefined,
    GetPricedTreatmentsByIdsQueryVariables
>;
export function useGetPricedTreatmentsByIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPricedTreatmentsByIdsQuery,
              GetPricedTreatmentsByIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPricedTreatmentsByIdsQuery,
        GetPricedTreatmentsByIdsQueryVariables
    >(GetPricedTreatmentsByIdsDocument, options);
}
export type GetPricedTreatmentsByIdsQueryHookResult = ReturnType<
    typeof useGetPricedTreatmentsByIdsQuery
>;
export type GetPricedTreatmentsByIdsLazyQueryHookResult = ReturnType<
    typeof useGetPricedTreatmentsByIdsLazyQuery
>;
export type GetPricedTreatmentsByIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetPricedTreatmentsByIdsSuspenseQuery
>;
export type GetPricedTreatmentsByIdsQueryResult = Apollo.QueryResult<
    GetPricedTreatmentsByIdsQuery,
    GetPricedTreatmentsByIdsQueryVariables
>;
export const GetProviderGroupIdsByPracticeIdAndProviderIdDocument = gql`
    query getProviderGroupIdsByPracticeIdAndProviderId(
        $practiceId: Int!
        $providerId: Int!
    ) {
        providerGroups(
            where: {
                providerToProviderGroup: {
                    some: {
                        AND: [
                            {
                                provider_group: {
                                    is: { practiceId: { equals: $practiceId } }
                                }
                                provider: {
                                    is: { id: { equals: $providerId } }
                                }
                            }
                        ]
                    }
                }
            }
        ) {
            name
            practiceId
            providerGroupId
        }
    }
`;

/**
 * __useGetProviderGroupIdsByPracticeIdAndProviderIdQuery__
 *
 * To run a query within a React component, call `useGetProviderGroupIdsByPracticeIdAndProviderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderGroupIdsByPracticeIdAndProviderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderGroupIdsByPracticeIdAndProviderIdQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetProviderGroupIdsByPracticeIdAndProviderIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProviderGroupIdsByPracticeIdAndProviderIdQuery,
        GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
    > &
        (
            | {
                  variables: GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProviderGroupIdsByPracticeIdAndProviderIdQuery,
        GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
    >(GetProviderGroupIdsByPracticeIdAndProviderIdDocument, options);
}
export function useGetProviderGroupIdsByPracticeIdAndProviderIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderGroupIdsByPracticeIdAndProviderIdQuery,
        GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderGroupIdsByPracticeIdAndProviderIdQuery,
        GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
    >(GetProviderGroupIdsByPracticeIdAndProviderIdDocument, options);
}
// @ts-ignore
export function useGetProviderGroupIdsByPracticeIdAndProviderIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderGroupIdsByPracticeIdAndProviderIdQuery,
        GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupIdsByPracticeIdAndProviderIdQuery,
    GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
>;
export function useGetProviderGroupIdsByPracticeIdAndProviderIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupIdsByPracticeIdAndProviderIdQuery,
              GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderGroupIdsByPracticeIdAndProviderIdQuery | undefined,
    GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
>;
export function useGetProviderGroupIdsByPracticeIdAndProviderIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderGroupIdsByPracticeIdAndProviderIdQuery,
              GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderGroupIdsByPracticeIdAndProviderIdQuery,
        GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
    >(GetProviderGroupIdsByPracticeIdAndProviderIdDocument, options);
}
export type GetProviderGroupIdsByPracticeIdAndProviderIdQueryHookResult =
    ReturnType<typeof useGetProviderGroupIdsByPracticeIdAndProviderIdQuery>;
export type GetProviderGroupIdsByPracticeIdAndProviderIdLazyQueryHookResult =
    ReturnType<typeof useGetProviderGroupIdsByPracticeIdAndProviderIdLazyQuery>;
export type GetProviderGroupIdsByPracticeIdAndProviderIdSuspenseQueryHookResult =
    ReturnType<
        typeof useGetProviderGroupIdsByPracticeIdAndProviderIdSuspenseQuery
    >;
export type GetProviderGroupIdsByPracticeIdAndProviderIdQueryResult =
    Apollo.QueryResult<
        GetProviderGroupIdsByPracticeIdAndProviderIdQuery,
        GetProviderGroupIdsByPracticeIdAndProviderIdQueryVariables
    >;
export const GetTransactionsForUserDocument = gql`
    query getTransactionsForUser($userId: String!) {
        transactions(
            where: { userId: { equals: $userId }, paidDate: { not: null } }
            orderBy: { paidDate: { sort: desc } }
        ) {
            id
            price
            stripePaymentId
            charges {
                orgId
                boughtTreatmentId
                total
            }
            paidDate
            userId
            transactionType
            paymentMethodType
        }
    }
`;

/**
 * __useGetTransactionsForUserQuery__
 *
 * To run a query within a React component, call `useGetTransactionsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetTransactionsForUserQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetTransactionsForUserQuery,
        GetTransactionsForUserQueryVariables
    > &
        (
            | {
                  variables: GetTransactionsForUserQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetTransactionsForUserQuery,
        GetTransactionsForUserQueryVariables
    >(GetTransactionsForUserDocument, options);
}
export function useGetTransactionsForUserLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTransactionsForUserQuery,
        GetTransactionsForUserQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetTransactionsForUserQuery,
        GetTransactionsForUserQueryVariables
    >(GetTransactionsForUserDocument, options);
}
// @ts-ignore
export function useGetTransactionsForUserSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetTransactionsForUserQuery,
        GetTransactionsForUserQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetTransactionsForUserQuery,
    GetTransactionsForUserQueryVariables
>;
export function useGetTransactionsForUserSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTransactionsForUserQuery,
              GetTransactionsForUserQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetTransactionsForUserQuery | undefined,
    GetTransactionsForUserQueryVariables
>;
export function useGetTransactionsForUserSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTransactionsForUserQuery,
              GetTransactionsForUserQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetTransactionsForUserQuery,
        GetTransactionsForUserQueryVariables
    >(GetTransactionsForUserDocument, options);
}
export type GetTransactionsForUserQueryHookResult = ReturnType<
    typeof useGetTransactionsForUserQuery
>;
export type GetTransactionsForUserLazyQueryHookResult = ReturnType<
    typeof useGetTransactionsForUserLazyQuery
>;
export type GetTransactionsForUserSuspenseQueryHookResult = ReturnType<
    typeof useGetTransactionsForUserSuspenseQuery
>;
export type GetTransactionsForUserQueryResult = Apollo.QueryResult<
    GetTransactionsForUserQuery,
    GetTransactionsForUserQueryVariables
>;
export const GetTransactionFromTransactionIdDocument = gql`
    query getTransactionFromTransactionId($transactionId: String!) {
        transaction(where: { id: $transactionId }) {
            id
            price
            paidDate
            userId
            transactionType
            stripePaymentId
            paymentMethodType
            charges(where: { boughtTreatmentId: { not: { equals: "" } } }) {
                id
                boughtTreatmentId
                total
            }
        }
    }
`;

/**
 * __useGetTransactionFromTransactionIdQuery__
 *
 * To run a query within a React component, call `useGetTransactionFromTransactionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionFromTransactionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionFromTransactionIdQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useGetTransactionFromTransactionIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetTransactionFromTransactionIdQuery,
        GetTransactionFromTransactionIdQueryVariables
    > &
        (
            | {
                  variables: GetTransactionFromTransactionIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetTransactionFromTransactionIdQuery,
        GetTransactionFromTransactionIdQueryVariables
    >(GetTransactionFromTransactionIdDocument, options);
}
export function useGetTransactionFromTransactionIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTransactionFromTransactionIdQuery,
        GetTransactionFromTransactionIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetTransactionFromTransactionIdQuery,
        GetTransactionFromTransactionIdQueryVariables
    >(GetTransactionFromTransactionIdDocument, options);
}
// @ts-ignore
export function useGetTransactionFromTransactionIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetTransactionFromTransactionIdQuery,
        GetTransactionFromTransactionIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetTransactionFromTransactionIdQuery,
    GetTransactionFromTransactionIdQueryVariables
>;
export function useGetTransactionFromTransactionIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTransactionFromTransactionIdQuery,
              GetTransactionFromTransactionIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetTransactionFromTransactionIdQuery | undefined,
    GetTransactionFromTransactionIdQueryVariables
>;
export function useGetTransactionFromTransactionIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTransactionFromTransactionIdQuery,
              GetTransactionFromTransactionIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetTransactionFromTransactionIdQuery,
        GetTransactionFromTransactionIdQueryVariables
    >(GetTransactionFromTransactionIdDocument, options);
}
export type GetTransactionFromTransactionIdQueryHookResult = ReturnType<
    typeof useGetTransactionFromTransactionIdQuery
>;
export type GetTransactionFromTransactionIdLazyQueryHookResult = ReturnType<
    typeof useGetTransactionFromTransactionIdLazyQuery
>;
export type GetTransactionFromTransactionIdSuspenseQueryHookResult = ReturnType<
    typeof useGetTransactionFromTransactionIdSuspenseQuery
>;
export type GetTransactionFromTransactionIdQueryResult = Apollo.QueryResult<
    GetTransactionFromTransactionIdQuery,
    GetTransactionFromTransactionIdQueryVariables
>;
export const CancelBoughtTreatmentsByIdsDocument = gql`
    mutation cancelBoughtTreatmentsByIds($boughtTreatmentIds: [String!]!) {
        updateManyBoughtTreatment(
            where: { id: { in: $boughtTreatmentIds } }
            data: { status: { set: canceled } }
        ) {
            count
        }
    }
`;
export type CancelBoughtTreatmentsByIdsMutationFn = Apollo.MutationFunction<
    CancelBoughtTreatmentsByIdsMutation,
    CancelBoughtTreatmentsByIdsMutationVariables
>;

/**
 * __useCancelBoughtTreatmentsByIdsMutation__
 *
 * To run a mutation, you first call `useCancelBoughtTreatmentsByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBoughtTreatmentsByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBoughtTreatmentsByIdsMutation, { data, loading, error }] = useCancelBoughtTreatmentsByIdsMutation({
 *   variables: {
 *      boughtTreatmentIds: // value for 'boughtTreatmentIds'
 *   },
 * });
 */
export function useCancelBoughtTreatmentsByIdsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CancelBoughtTreatmentsByIdsMutation,
        CancelBoughtTreatmentsByIdsMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CancelBoughtTreatmentsByIdsMutation,
        CancelBoughtTreatmentsByIdsMutationVariables
    >(CancelBoughtTreatmentsByIdsDocument, options);
}
export type CancelBoughtTreatmentsByIdsMutationHookResult = ReturnType<
    typeof useCancelBoughtTreatmentsByIdsMutation
>;
export type CancelBoughtTreatmentsByIdsMutationResult =
    Apollo.MutationResult<CancelBoughtTreatmentsByIdsMutation>;
export type CancelBoughtTreatmentsByIdsMutationOptions =
    Apollo.BaseMutationOptions<
        CancelBoughtTreatmentsByIdsMutation,
        CancelBoughtTreatmentsByIdsMutationVariables
    >;
export const CheckInDocument = gql`
    mutation checkIn($appointmentId: String!, $checkedInBy: String!) {
        checkIn(id: $appointmentId, checkedInBy: $checkedInBy) {
            appointment {
                id
                status
                slots {
                    id
                    status
                }
            }
            ehrCheckinSuccessful
        }
    }
`;
export type CheckInMutationFn = Apollo.MutationFunction<
    CheckInMutation,
    CheckInMutationVariables
>;

/**
 * __useCheckInMutation__
 *
 * To run a mutation, you first call `useCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInMutation, { data, loading, error }] = useCheckInMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      checkedInBy: // value for 'checkedInBy'
 *   },
 * });
 */
export function useCheckInMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CheckInMutation,
        CheckInMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<CheckInMutation, CheckInMutationVariables>(
        CheckInDocument,
        options,
    );
}
export type CheckInMutationHookResult = ReturnType<typeof useCheckInMutation>;
export type CheckInMutationResult = Apollo.MutationResult<CheckInMutation>;
export type CheckInMutationOptions = Apollo.BaseMutationOptions<
    CheckInMutation,
    CheckInMutationVariables
>;
export const GetOutstandingChargesForUserDocument = gql`
    query getOutstandingChargesForUser($userId: String!) {
        charges(
            where: {
                userId: { equals: $userId }
                transactionId: { equals: null }
            }
        ) {
            id
            boughtTreatmentId
            total
            orgId
            date
            type
            payoutIds
            payouts {
                id
            }
        }
    }
`;

/**
 * __useGetOutstandingChargesForUserQuery__
 *
 * To run a query within a React component, call `useGetOutstandingChargesForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutstandingChargesForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutstandingChargesForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOutstandingChargesForUserQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOutstandingChargesForUserQuery,
        GetOutstandingChargesForUserQueryVariables
    > &
        (
            | {
                  variables: GetOutstandingChargesForUserQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOutstandingChargesForUserQuery,
        GetOutstandingChargesForUserQueryVariables
    >(GetOutstandingChargesForUserDocument, options);
}
export function useGetOutstandingChargesForUserLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOutstandingChargesForUserQuery,
        GetOutstandingChargesForUserQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOutstandingChargesForUserQuery,
        GetOutstandingChargesForUserQueryVariables
    >(GetOutstandingChargesForUserDocument, options);
}
// @ts-ignore
export function useGetOutstandingChargesForUserSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOutstandingChargesForUserQuery,
        GetOutstandingChargesForUserQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOutstandingChargesForUserQuery,
    GetOutstandingChargesForUserQueryVariables
>;
export function useGetOutstandingChargesForUserSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOutstandingChargesForUserQuery,
              GetOutstandingChargesForUserQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOutstandingChargesForUserQuery | undefined,
    GetOutstandingChargesForUserQueryVariables
>;
export function useGetOutstandingChargesForUserSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOutstandingChargesForUserQuery,
              GetOutstandingChargesForUserQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOutstandingChargesForUserQuery,
        GetOutstandingChargesForUserQueryVariables
    >(GetOutstandingChargesForUserDocument, options);
}
export type GetOutstandingChargesForUserQueryHookResult = ReturnType<
    typeof useGetOutstandingChargesForUserQuery
>;
export type GetOutstandingChargesForUserLazyQueryHookResult = ReturnType<
    typeof useGetOutstandingChargesForUserLazyQuery
>;
export type GetOutstandingChargesForUserSuspenseQueryHookResult = ReturnType<
    typeof useGetOutstandingChargesForUserSuspenseQuery
>;
export type GetOutstandingChargesForUserQueryResult = Apollo.QueryResult<
    GetOutstandingChargesForUserQuery,
    GetOutstandingChargesForUserQueryVariables
>;
export const GetTransactionsForBoughtTreatmentsDocument = gql`
    query getTransactionsForBoughtTreatments($boughtTreatmentIds: [String!]) {
        transactions(
            where: {
                charges: {
                    some: { boughtTreatmentId: { in: $boughtTreatmentIds } }
                }
            }
            orderBy: { paidDate: { sort: asc } }
        ) {
            id
            price
            paymentMethodType
            paidDate
            stripePaymentId
            charges {
                id
                boughtTreatmentId
                total
            }
        }
    }
`;

/**
 * __useGetTransactionsForBoughtTreatmentsQuery__
 *
 * To run a query within a React component, call `useGetTransactionsForBoughtTreatmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsForBoughtTreatmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsForBoughtTreatmentsQuery({
 *   variables: {
 *      boughtTreatmentIds: // value for 'boughtTreatmentIds'
 *   },
 * });
 */
export function useGetTransactionsForBoughtTreatmentsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetTransactionsForBoughtTreatmentsQuery,
        GetTransactionsForBoughtTreatmentsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetTransactionsForBoughtTreatmentsQuery,
        GetTransactionsForBoughtTreatmentsQueryVariables
    >(GetTransactionsForBoughtTreatmentsDocument, options);
}
export function useGetTransactionsForBoughtTreatmentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTransactionsForBoughtTreatmentsQuery,
        GetTransactionsForBoughtTreatmentsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetTransactionsForBoughtTreatmentsQuery,
        GetTransactionsForBoughtTreatmentsQueryVariables
    >(GetTransactionsForBoughtTreatmentsDocument, options);
}
// @ts-ignore
export function useGetTransactionsForBoughtTreatmentsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetTransactionsForBoughtTreatmentsQuery,
        GetTransactionsForBoughtTreatmentsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetTransactionsForBoughtTreatmentsQuery,
    GetTransactionsForBoughtTreatmentsQueryVariables
>;
export function useGetTransactionsForBoughtTreatmentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTransactionsForBoughtTreatmentsQuery,
              GetTransactionsForBoughtTreatmentsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetTransactionsForBoughtTreatmentsQuery | undefined,
    GetTransactionsForBoughtTreatmentsQueryVariables
>;
export function useGetTransactionsForBoughtTreatmentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTransactionsForBoughtTreatmentsQuery,
              GetTransactionsForBoughtTreatmentsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetTransactionsForBoughtTreatmentsQuery,
        GetTransactionsForBoughtTreatmentsQueryVariables
    >(GetTransactionsForBoughtTreatmentsDocument, options);
}
export type GetTransactionsForBoughtTreatmentsQueryHookResult = ReturnType<
    typeof useGetTransactionsForBoughtTreatmentsQuery
>;
export type GetTransactionsForBoughtTreatmentsLazyQueryHookResult = ReturnType<
    typeof useGetTransactionsForBoughtTreatmentsLazyQuery
>;
export type GetTransactionsForBoughtTreatmentsSuspenseQueryHookResult =
    ReturnType<typeof useGetTransactionsForBoughtTreatmentsSuspenseQuery>;
export type GetTransactionsForBoughtTreatmentsQueryResult = Apollo.QueryResult<
    GetTransactionsForBoughtTreatmentsQuery,
    GetTransactionsForBoughtTreatmentsQueryVariables
>;
export const GetMissedAppointmentsForConsumersDocument = gql`
    query getMissedAppointmentsForConsumers(
        $consumerIds: [String!]!
        $orgId: IntFilter
    ) {
        appointments(
            where: {
                status: { equals: missed }
                slots: {
                    some: {
                        status: { equals: upcoming }
                        boughtTreatments: {
                            some: {
                                status: { equals: active }
                                consumerId: { in: $consumerIds }
                                orgId: $orgId
                            }
                        }
                    }
                }
            }
        ) {
            id
            status
            claimReturnStatus
            intakeFormIds
            completedIntakeFormIds
            slots(
                where: {
                    status: { equals: upcoming }
                    boughtTreatments: { some: { status: { equals: active } } }
                }
                orderBy: { startTime: asc }
            ) {
                id
                startTime
                endTime
                practiceId
                providerId
                status
                note
                virtualLink
                boughtTreatments(
                    where: { status: { equals: active } }
                    orderBy: { createdAt: asc }
                ) {
                    id
                    name
                    consumerId
                    price
                    pricedTreatmentId
                    orgId
                    hrtId
                    discountCodeApplied
                    source
                    status
                    paymentType
                    overrideReason
                    isVirtual
                    lastUpdatedBy
                    reviewStatus
                }
            }
        }
    }
`;

/**
 * __useGetMissedAppointmentsForConsumersQuery__
 *
 * To run a query within a React component, call `useGetMissedAppointmentsForConsumersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissedAppointmentsForConsumersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissedAppointmentsForConsumersQuery({
 *   variables: {
 *      consumerIds: // value for 'consumerIds'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetMissedAppointmentsForConsumersQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMissedAppointmentsForConsumersQuery,
        GetMissedAppointmentsForConsumersQueryVariables
    > &
        (
            | {
                  variables: GetMissedAppointmentsForConsumersQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetMissedAppointmentsForConsumersQuery,
        GetMissedAppointmentsForConsumersQueryVariables
    >(GetMissedAppointmentsForConsumersDocument, options);
}
export function useGetMissedAppointmentsForConsumersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMissedAppointmentsForConsumersQuery,
        GetMissedAppointmentsForConsumersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetMissedAppointmentsForConsumersQuery,
        GetMissedAppointmentsForConsumersQueryVariables
    >(GetMissedAppointmentsForConsumersDocument, options);
}
// @ts-ignore
export function useGetMissedAppointmentsForConsumersSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetMissedAppointmentsForConsumersQuery,
        GetMissedAppointmentsForConsumersQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetMissedAppointmentsForConsumersQuery,
    GetMissedAppointmentsForConsumersQueryVariables
>;
export function useGetMissedAppointmentsForConsumersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMissedAppointmentsForConsumersQuery,
              GetMissedAppointmentsForConsumersQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetMissedAppointmentsForConsumersQuery | undefined,
    GetMissedAppointmentsForConsumersQueryVariables
>;
export function useGetMissedAppointmentsForConsumersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMissedAppointmentsForConsumersQuery,
              GetMissedAppointmentsForConsumersQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetMissedAppointmentsForConsumersQuery,
        GetMissedAppointmentsForConsumersQueryVariables
    >(GetMissedAppointmentsForConsumersDocument, options);
}
export type GetMissedAppointmentsForConsumersQueryHookResult = ReturnType<
    typeof useGetMissedAppointmentsForConsumersQuery
>;
export type GetMissedAppointmentsForConsumersLazyQueryHookResult = ReturnType<
    typeof useGetMissedAppointmentsForConsumersLazyQuery
>;
export type GetMissedAppointmentsForConsumersSuspenseQueryHookResult =
    ReturnType<typeof useGetMissedAppointmentsForConsumersSuspenseQuery>;
export type GetMissedAppointmentsForConsumersQueryResult = Apollo.QueryResult<
    GetMissedAppointmentsForConsumersQuery,
    GetMissedAppointmentsForConsumersQueryVariables
>;
export const GetUpcomingAppointmentsForConsumersDocument = gql`
    query getUpcomingAppointmentsForConsumers(
        $consumerIds: [String!]!
        $orgId: IntFilter
    ) {
        appointments(
            where: {
                status: { in: [upcoming, active, missed] }
                slots: {
                    some: {
                        status: { in: [upcoming, completed] }
                        boughtTreatments: {
                            some: {
                                status: { equals: active }
                                consumerId: { in: $consumerIds }
                                orgId: $orgId
                            }
                        }
                    }
                }
            }
        ) {
            id
            status
            intakeFormIds
            completedIntakeFormIds
            slots(
                where: {
                    status: { in: [upcoming, completed] }
                    boughtTreatments: { some: { status: { equals: active } } }
                }
                orderBy: { startTime: asc }
            ) {
                id
                startTime
                endTime
                practiceId
                providerId
                status
                note
                virtualLink
                boughtTreatments(
                    where: { status: { equals: active } }
                    orderBy: { createdAt: asc }
                ) {
                    id
                    name
                    consumerId
                    price
                    pricedTreatmentId
                    orgId
                    hrtId
                    discountCodeApplied
                    source
                    status
                    paymentType
                    overrideReason
                    isVirtual
                    lastUpdatedBy
                    reviewStatus
                }
            }
        }
    }
`;

/**
 * __useGetUpcomingAppointmentsForConsumersQuery__
 *
 * To run a query within a React component, call `useGetUpcomingAppointmentsForConsumersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingAppointmentsForConsumersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingAppointmentsForConsumersQuery({
 *   variables: {
 *      consumerIds: // value for 'consumerIds'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetUpcomingAppointmentsForConsumersQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUpcomingAppointmentsForConsumersQuery,
        GetUpcomingAppointmentsForConsumersQueryVariables
    > &
        (
            | {
                  variables: GetUpcomingAppointmentsForConsumersQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUpcomingAppointmentsForConsumersQuery,
        GetUpcomingAppointmentsForConsumersQueryVariables
    >(GetUpcomingAppointmentsForConsumersDocument, options);
}
export function useGetUpcomingAppointmentsForConsumersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUpcomingAppointmentsForConsumersQuery,
        GetUpcomingAppointmentsForConsumersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUpcomingAppointmentsForConsumersQuery,
        GetUpcomingAppointmentsForConsumersQueryVariables
    >(GetUpcomingAppointmentsForConsumersDocument, options);
}
// @ts-ignore
export function useGetUpcomingAppointmentsForConsumersSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUpcomingAppointmentsForConsumersQuery,
        GetUpcomingAppointmentsForConsumersQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUpcomingAppointmentsForConsumersQuery,
    GetUpcomingAppointmentsForConsumersQueryVariables
>;
export function useGetUpcomingAppointmentsForConsumersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUpcomingAppointmentsForConsumersQuery,
              GetUpcomingAppointmentsForConsumersQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUpcomingAppointmentsForConsumersQuery | undefined,
    GetUpcomingAppointmentsForConsumersQueryVariables
>;
export function useGetUpcomingAppointmentsForConsumersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUpcomingAppointmentsForConsumersQuery,
              GetUpcomingAppointmentsForConsumersQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUpcomingAppointmentsForConsumersQuery,
        GetUpcomingAppointmentsForConsumersQueryVariables
    >(GetUpcomingAppointmentsForConsumersDocument, options);
}
export type GetUpcomingAppointmentsForConsumersQueryHookResult = ReturnType<
    typeof useGetUpcomingAppointmentsForConsumersQuery
>;
export type GetUpcomingAppointmentsForConsumersLazyQueryHookResult = ReturnType<
    typeof useGetUpcomingAppointmentsForConsumersLazyQuery
>;
export type GetUpcomingAppointmentsForConsumersSuspenseQueryHookResult =
    ReturnType<typeof useGetUpcomingAppointmentsForConsumersSuspenseQuery>;
export type GetUpcomingAppointmentsForConsumersQueryResult = Apollo.QueryResult<
    GetUpcomingAppointmentsForConsumersQuery,
    GetUpcomingAppointmentsForConsumersQueryVariables
>;
export const GetUpcomingAppointmentsForAccountDocument = gql`
    query getUpcomingAppointmentsForAccount(
        $consumerIds: [String!]!
        $orgId: IntFilter
        $orgIdNullable: IntNullableFilter
    ) {
        appointments(
            where: {
                status: { in: [upcoming, active, missed] }
                slots: {
                    some: {
                        status: { in: [upcoming, completed] }
                        OR: [
                            {
                                boughtTreatments: {
                                    some: {
                                        status: { equals: active }
                                        consumerId: { in: $consumerIds }
                                        orgId: $orgId
                                    }
                                }
                            }
                            {
                                consumerId: { in: $consumerIds }
                                orgId: $orgIdNullable
                                boughtTreatments: { none: {} }
                            }
                        ]
                    }
                }
            }
        ) {
            id
            status
            claimReturnStatus
            intakeFormIds
            completedIntakeFormIds
            slots(
                where: {
                    status: { in: [upcoming, completed] }
                    OR: [
                        {
                            boughtTreatments: {
                                some: { status: { equals: active } }
                            }
                        }
                        {
                            consumerId: { in: $consumerIds }
                            orgId: $orgIdNullable
                            boughtTreatments: { none: {} }
                        }
                    ]
                }
                orderBy: { startTime: asc }
            ) {
                id
                startTime
                endTime
                practiceId
                providerId
                consumerId
                orgId
                status
                note
                virtualLink
                boughtTreatments(
                    where: { status: { equals: active } }
                    orderBy: { createdAt: asc }
                ) {
                    id
                    name
                    consumerId
                    price
                    pricedTreatmentId
                    orgId
                    hrtId
                    discountCodeApplied
                    source
                    status
                    paymentType
                    overrideReason
                    isVirtual
                    lastUpdatedBy
                    reviewStatus
                }
            }
        }
    }
`;

/**
 * __useGetUpcomingAppointmentsForAccountQuery__
 *
 * To run a query within a React component, call `useGetUpcomingAppointmentsForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingAppointmentsForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingAppointmentsForAccountQuery({
 *   variables: {
 *      consumerIds: // value for 'consumerIds'
 *      orgId: // value for 'orgId'
 *      orgIdNullable: // value for 'orgIdNullable'
 *   },
 * });
 */
export function useGetUpcomingAppointmentsForAccountQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUpcomingAppointmentsForAccountQuery,
        GetUpcomingAppointmentsForAccountQueryVariables
    > &
        (
            | {
                  variables: GetUpcomingAppointmentsForAccountQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUpcomingAppointmentsForAccountQuery,
        GetUpcomingAppointmentsForAccountQueryVariables
    >(GetUpcomingAppointmentsForAccountDocument, options);
}
export function useGetUpcomingAppointmentsForAccountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUpcomingAppointmentsForAccountQuery,
        GetUpcomingAppointmentsForAccountQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUpcomingAppointmentsForAccountQuery,
        GetUpcomingAppointmentsForAccountQueryVariables
    >(GetUpcomingAppointmentsForAccountDocument, options);
}
// @ts-ignore
export function useGetUpcomingAppointmentsForAccountSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUpcomingAppointmentsForAccountQuery,
        GetUpcomingAppointmentsForAccountQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUpcomingAppointmentsForAccountQuery,
    GetUpcomingAppointmentsForAccountQueryVariables
>;
export function useGetUpcomingAppointmentsForAccountSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUpcomingAppointmentsForAccountQuery,
              GetUpcomingAppointmentsForAccountQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUpcomingAppointmentsForAccountQuery | undefined,
    GetUpcomingAppointmentsForAccountQueryVariables
>;
export function useGetUpcomingAppointmentsForAccountSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUpcomingAppointmentsForAccountQuery,
              GetUpcomingAppointmentsForAccountQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUpcomingAppointmentsForAccountQuery,
        GetUpcomingAppointmentsForAccountQueryVariables
    >(GetUpcomingAppointmentsForAccountDocument, options);
}
export type GetUpcomingAppointmentsForAccountQueryHookResult = ReturnType<
    typeof useGetUpcomingAppointmentsForAccountQuery
>;
export type GetUpcomingAppointmentsForAccountLazyQueryHookResult = ReturnType<
    typeof useGetUpcomingAppointmentsForAccountLazyQuery
>;
export type GetUpcomingAppointmentsForAccountSuspenseQueryHookResult =
    ReturnType<typeof useGetUpcomingAppointmentsForAccountSuspenseQuery>;
export type GetUpcomingAppointmentsForAccountQueryResult = Apollo.QueryResult<
    GetUpcomingAppointmentsForAccountQuery,
    GetUpcomingAppointmentsForAccountQueryVariables
>;
export const GetCompletedAppointmentsForAccountDocument = gql`
    query getCompletedAppointmentsForAccount(
        $consumerIds: [String!]!
        $orgId: IntFilter
        $orgIdNullable: IntNullableFilter
    ) {
        appointments(
            where: {
                status: { in: [completed, missed, canceled] }
                slots: {
                    some: {
                        OR: [
                            {
                                boughtTreatments: {
                                    some: {
                                        consumerId: { in: $consumerIds }
                                        orgId: $orgId
                                    }
                                }
                            }
                            {
                                consumerId: { in: $consumerIds }
                                orgId: $orgIdNullable
                                boughtTreatments: { none: {} }
                            }
                        ]
                    }
                }
            }
        ) {
            id
            status
            claimReturnStatus
            intakeFormIds
            completedIntakeFormIds
            slots(orderBy: { startTime: asc }) {
                id
                startTime
                providerId
                practiceId
                consumerId
                orgId
                boughtTreatments(orderBy: { createdAt: asc }) {
                    id
                    name
                    consumerId
                    price
                    pricedTreatmentId
                    orgId
                    hrtId
                    discountCodeApplied
                    status
                    overrideReason
                    lastUpdatedBy
                    reviewStatus
                    paymentType
                }
            }
        }
    }
`;

/**
 * __useGetCompletedAppointmentsForAccountQuery__
 *
 * To run a query within a React component, call `useGetCompletedAppointmentsForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedAppointmentsForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedAppointmentsForAccountQuery({
 *   variables: {
 *      consumerIds: // value for 'consumerIds'
 *      orgId: // value for 'orgId'
 *      orgIdNullable: // value for 'orgIdNullable'
 *   },
 * });
 */
export function useGetCompletedAppointmentsForAccountQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetCompletedAppointmentsForAccountQuery,
        GetCompletedAppointmentsForAccountQueryVariables
    > &
        (
            | {
                  variables: GetCompletedAppointmentsForAccountQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetCompletedAppointmentsForAccountQuery,
        GetCompletedAppointmentsForAccountQueryVariables
    >(GetCompletedAppointmentsForAccountDocument, options);
}
export function useGetCompletedAppointmentsForAccountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCompletedAppointmentsForAccountQuery,
        GetCompletedAppointmentsForAccountQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetCompletedAppointmentsForAccountQuery,
        GetCompletedAppointmentsForAccountQueryVariables
    >(GetCompletedAppointmentsForAccountDocument, options);
}
// @ts-ignore
export function useGetCompletedAppointmentsForAccountSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetCompletedAppointmentsForAccountQuery,
        GetCompletedAppointmentsForAccountQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetCompletedAppointmentsForAccountQuery,
    GetCompletedAppointmentsForAccountQueryVariables
>;
export function useGetCompletedAppointmentsForAccountSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetCompletedAppointmentsForAccountQuery,
              GetCompletedAppointmentsForAccountQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetCompletedAppointmentsForAccountQuery | undefined,
    GetCompletedAppointmentsForAccountQueryVariables
>;
export function useGetCompletedAppointmentsForAccountSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetCompletedAppointmentsForAccountQuery,
              GetCompletedAppointmentsForAccountQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetCompletedAppointmentsForAccountQuery,
        GetCompletedAppointmentsForAccountQueryVariables
    >(GetCompletedAppointmentsForAccountDocument, options);
}
export type GetCompletedAppointmentsForAccountQueryHookResult = ReturnType<
    typeof useGetCompletedAppointmentsForAccountQuery
>;
export type GetCompletedAppointmentsForAccountLazyQueryHookResult = ReturnType<
    typeof useGetCompletedAppointmentsForAccountLazyQuery
>;
export type GetCompletedAppointmentsForAccountSuspenseQueryHookResult =
    ReturnType<typeof useGetCompletedAppointmentsForAccountSuspenseQuery>;
export type GetCompletedAppointmentsForAccountQueryResult = Apollo.QueryResult<
    GetCompletedAppointmentsForAccountQuery,
    GetCompletedAppointmentsForAccountQueryVariables
>;
export const GetExistingSlotsForCalendarCountDocument = gql`
    query getExistingSlotsForCalendarCount(
        $providerId: Int!
        $startDateTime: DateTimeISO!
        $endDateTime: DateTimeISO!
        $orgId: Int!
    ) {
        aggregateSlot(
            where: {
                AND: [
                    { providerId: { equals: $providerId } }
                    { startTime: { gte: $startDateTime } }
                    { endTime: { lte: $endDateTime } }
                    { status: { in: [upcoming, completed] } }
                    {
                        boughtTreatments: {
                            some: { orgId: { equals: $orgId } }
                        }
                    }
                ]
            }
        ) {
            _count {
                id
            }
        }
    }
`;

/**
 * __useGetExistingSlotsForCalendarCountQuery__
 *
 * To run a query within a React component, call `useGetExistingSlotsForCalendarCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingSlotsForCalendarCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingSlotsForCalendarCountQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetExistingSlotsForCalendarCountQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetExistingSlotsForCalendarCountQuery,
        GetExistingSlotsForCalendarCountQueryVariables
    > &
        (
            | {
                  variables: GetExistingSlotsForCalendarCountQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetExistingSlotsForCalendarCountQuery,
        GetExistingSlotsForCalendarCountQueryVariables
    >(GetExistingSlotsForCalendarCountDocument, options);
}
export function useGetExistingSlotsForCalendarCountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetExistingSlotsForCalendarCountQuery,
        GetExistingSlotsForCalendarCountQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetExistingSlotsForCalendarCountQuery,
        GetExistingSlotsForCalendarCountQueryVariables
    >(GetExistingSlotsForCalendarCountDocument, options);
}
// @ts-ignore
export function useGetExistingSlotsForCalendarCountSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetExistingSlotsForCalendarCountQuery,
        GetExistingSlotsForCalendarCountQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetExistingSlotsForCalendarCountQuery,
    GetExistingSlotsForCalendarCountQueryVariables
>;
export function useGetExistingSlotsForCalendarCountSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetExistingSlotsForCalendarCountQuery,
              GetExistingSlotsForCalendarCountQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetExistingSlotsForCalendarCountQuery | undefined,
    GetExistingSlotsForCalendarCountQueryVariables
>;
export function useGetExistingSlotsForCalendarCountSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetExistingSlotsForCalendarCountQuery,
              GetExistingSlotsForCalendarCountQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetExistingSlotsForCalendarCountQuery,
        GetExistingSlotsForCalendarCountQueryVariables
    >(GetExistingSlotsForCalendarCountDocument, options);
}
export type GetExistingSlotsForCalendarCountQueryHookResult = ReturnType<
    typeof useGetExistingSlotsForCalendarCountQuery
>;
export type GetExistingSlotsForCalendarCountLazyQueryHookResult = ReturnType<
    typeof useGetExistingSlotsForCalendarCountLazyQuery
>;
export type GetExistingSlotsForCalendarCountSuspenseQueryHookResult =
    ReturnType<typeof useGetExistingSlotsForCalendarCountSuspenseQuery>;
export type GetExistingSlotsForCalendarCountQueryResult = Apollo.QueryResult<
    GetExistingSlotsForCalendarCountQuery,
    GetExistingSlotsForCalendarCountQueryVariables
>;
export const GetUnscheduledTreatmentsCountForOrgDocument = gql`
    query getUnscheduledTreatmentsCountForOrg($orgId: Int!) {
        boughtTreatments(
            where: {
                AND: [
                    { orgId: { equals: $orgId } }
                    { slotId: { equals: null } }
                    { status: { equals: active } }
                ]
            }
        ) {
            id
            consumerId
        }
    }
`;

/**
 * __useGetUnscheduledTreatmentsCountForOrgQuery__
 *
 * To run a query within a React component, call `useGetUnscheduledTreatmentsCountForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnscheduledTreatmentsCountForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnscheduledTreatmentsCountForOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetUnscheduledTreatmentsCountForOrgQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUnscheduledTreatmentsCountForOrgQuery,
        GetUnscheduledTreatmentsCountForOrgQueryVariables
    > &
        (
            | {
                  variables: GetUnscheduledTreatmentsCountForOrgQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUnscheduledTreatmentsCountForOrgQuery,
        GetUnscheduledTreatmentsCountForOrgQueryVariables
    >(GetUnscheduledTreatmentsCountForOrgDocument, options);
}
export function useGetUnscheduledTreatmentsCountForOrgLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUnscheduledTreatmentsCountForOrgQuery,
        GetUnscheduledTreatmentsCountForOrgQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUnscheduledTreatmentsCountForOrgQuery,
        GetUnscheduledTreatmentsCountForOrgQueryVariables
    >(GetUnscheduledTreatmentsCountForOrgDocument, options);
}
// @ts-ignore
export function useGetUnscheduledTreatmentsCountForOrgSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUnscheduledTreatmentsCountForOrgQuery,
        GetUnscheduledTreatmentsCountForOrgQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUnscheduledTreatmentsCountForOrgQuery,
    GetUnscheduledTreatmentsCountForOrgQueryVariables
>;
export function useGetUnscheduledTreatmentsCountForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUnscheduledTreatmentsCountForOrgQuery,
              GetUnscheduledTreatmentsCountForOrgQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUnscheduledTreatmentsCountForOrgQuery | undefined,
    GetUnscheduledTreatmentsCountForOrgQueryVariables
>;
export function useGetUnscheduledTreatmentsCountForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUnscheduledTreatmentsCountForOrgQuery,
              GetUnscheduledTreatmentsCountForOrgQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUnscheduledTreatmentsCountForOrgQuery,
        GetUnscheduledTreatmentsCountForOrgQueryVariables
    >(GetUnscheduledTreatmentsCountForOrgDocument, options);
}
export type GetUnscheduledTreatmentsCountForOrgQueryHookResult = ReturnType<
    typeof useGetUnscheduledTreatmentsCountForOrgQuery
>;
export type GetUnscheduledTreatmentsCountForOrgLazyQueryHookResult = ReturnType<
    typeof useGetUnscheduledTreatmentsCountForOrgLazyQuery
>;
export type GetUnscheduledTreatmentsCountForOrgSuspenseQueryHookResult =
    ReturnType<typeof useGetUnscheduledTreatmentsCountForOrgSuspenseQuery>;
export type GetUnscheduledTreatmentsCountForOrgQueryResult = Apollo.QueryResult<
    GetUnscheduledTreatmentsCountForOrgQuery,
    GetUnscheduledTreatmentsCountForOrgQueryVariables
>;
export const GetAppointmentCountDocument = gql`
    query getAppointmentCount($filters: AppointmentWhereInput!) {
        aggregateAppointment(where: $filters) {
            _count {
                id
            }
        }
    }
`;

/**
 * __useGetAppointmentCountQuery__
 *
 * To run a query within a React component, call `useGetAppointmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAppointmentCountQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAppointmentCountQuery,
        GetAppointmentCountQueryVariables
    > &
        (
            | { variables: GetAppointmentCountQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAppointmentCountQuery,
        GetAppointmentCountQueryVariables
    >(GetAppointmentCountDocument, options);
}
export function useGetAppointmentCountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAppointmentCountQuery,
        GetAppointmentCountQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAppointmentCountQuery,
        GetAppointmentCountQueryVariables
    >(GetAppointmentCountDocument, options);
}
// @ts-ignore
export function useGetAppointmentCountSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAppointmentCountQuery,
        GetAppointmentCountQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAppointmentCountQuery,
    GetAppointmentCountQueryVariables
>;
export function useGetAppointmentCountSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAppointmentCountQuery,
              GetAppointmentCountQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAppointmentCountQuery | undefined,
    GetAppointmentCountQueryVariables
>;
export function useGetAppointmentCountSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAppointmentCountQuery,
              GetAppointmentCountQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAppointmentCountQuery,
        GetAppointmentCountQueryVariables
    >(GetAppointmentCountDocument, options);
}
export type GetAppointmentCountQueryHookResult = ReturnType<
    typeof useGetAppointmentCountQuery
>;
export type GetAppointmentCountLazyQueryHookResult = ReturnType<
    typeof useGetAppointmentCountLazyQuery
>;
export type GetAppointmentCountSuspenseQueryHookResult = ReturnType<
    typeof useGetAppointmentCountSuspenseQuery
>;
export type GetAppointmentCountQueryResult = Apollo.QueryResult<
    GetAppointmentCountQuery,
    GetAppointmentCountQueryVariables
>;
export const GetAppointmentsForOrgIdDocument = gql`
    query getAppointmentsForOrgId(
        $orgId: Int!
        $orderBy: SlotOrderByWithRelationInput!
        $filters: SlotWhereInput!
    ) {
        rosterSlots(
            orgId: $orgId
            where: $filters
            orderBy: [$orderBy, { appointmentId: asc }]
            take: 50
        ) {
            ...rosterSlotFields
        }
    }
    ${RosterSlotFieldsFragmentDoc}
`;

/**
 * __useGetAppointmentsForOrgIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsForOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsForOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsForOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAppointmentsForOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAppointmentsForOrgIdQuery,
        GetAppointmentsForOrgIdQueryVariables
    > &
        (
            | {
                  variables: GetAppointmentsForOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAppointmentsForOrgIdQuery,
        GetAppointmentsForOrgIdQueryVariables
    >(GetAppointmentsForOrgIdDocument, options);
}
export function useGetAppointmentsForOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAppointmentsForOrgIdQuery,
        GetAppointmentsForOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAppointmentsForOrgIdQuery,
        GetAppointmentsForOrgIdQueryVariables
    >(GetAppointmentsForOrgIdDocument, options);
}
// @ts-ignore
export function useGetAppointmentsForOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAppointmentsForOrgIdQuery,
        GetAppointmentsForOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAppointmentsForOrgIdQuery,
    GetAppointmentsForOrgIdQueryVariables
>;
export function useGetAppointmentsForOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAppointmentsForOrgIdQuery,
              GetAppointmentsForOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAppointmentsForOrgIdQuery | undefined,
    GetAppointmentsForOrgIdQueryVariables
>;
export function useGetAppointmentsForOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAppointmentsForOrgIdQuery,
              GetAppointmentsForOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAppointmentsForOrgIdQuery,
        GetAppointmentsForOrgIdQueryVariables
    >(GetAppointmentsForOrgIdDocument, options);
}
export type GetAppointmentsForOrgIdQueryHookResult = ReturnType<
    typeof useGetAppointmentsForOrgIdQuery
>;
export type GetAppointmentsForOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetAppointmentsForOrgIdLazyQuery
>;
export type GetAppointmentsForOrgIdSuspenseQueryHookResult = ReturnType<
    typeof useGetAppointmentsForOrgIdSuspenseQuery
>;
export type GetAppointmentsForOrgIdQueryResult = Apollo.QueryResult<
    GetAppointmentsForOrgIdQuery,
    GetAppointmentsForOrgIdQueryVariables
>;
export const GetMoreAppointmentsForOrgIdDocument = gql`
    query getMoreAppointmentsForOrgId(
        $orgId: Int!
        $orderBy: SlotOrderByWithRelationInput!
        $filters: SlotWhereInput!
        $cursorId: String!
    ) {
        rosterSlots(
            orgId: $orgId
            where: $filters
            orderBy: [$orderBy, { appointmentId: asc }]
            take: 10
            cursor: { id: $cursorId }
        ) {
            ...rosterSlotFields
        }
    }
    ${RosterSlotFieldsFragmentDoc}
`;

/**
 * __useGetMoreAppointmentsForOrgIdQuery__
 *
 * To run a query within a React component, call `useGetMoreAppointmentsForOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoreAppointmentsForOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoreAppointmentsForOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      cursorId: // value for 'cursorId'
 *   },
 * });
 */
export function useGetMoreAppointmentsForOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMoreAppointmentsForOrgIdQuery,
        GetMoreAppointmentsForOrgIdQueryVariables
    > &
        (
            | {
                  variables: GetMoreAppointmentsForOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetMoreAppointmentsForOrgIdQuery,
        GetMoreAppointmentsForOrgIdQueryVariables
    >(GetMoreAppointmentsForOrgIdDocument, options);
}
export function useGetMoreAppointmentsForOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMoreAppointmentsForOrgIdQuery,
        GetMoreAppointmentsForOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetMoreAppointmentsForOrgIdQuery,
        GetMoreAppointmentsForOrgIdQueryVariables
    >(GetMoreAppointmentsForOrgIdDocument, options);
}
// @ts-ignore
export function useGetMoreAppointmentsForOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetMoreAppointmentsForOrgIdQuery,
        GetMoreAppointmentsForOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetMoreAppointmentsForOrgIdQuery,
    GetMoreAppointmentsForOrgIdQueryVariables
>;
export function useGetMoreAppointmentsForOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMoreAppointmentsForOrgIdQuery,
              GetMoreAppointmentsForOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetMoreAppointmentsForOrgIdQuery | undefined,
    GetMoreAppointmentsForOrgIdQueryVariables
>;
export function useGetMoreAppointmentsForOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMoreAppointmentsForOrgIdQuery,
              GetMoreAppointmentsForOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetMoreAppointmentsForOrgIdQuery,
        GetMoreAppointmentsForOrgIdQueryVariables
    >(GetMoreAppointmentsForOrgIdDocument, options);
}
export type GetMoreAppointmentsForOrgIdQueryHookResult = ReturnType<
    typeof useGetMoreAppointmentsForOrgIdQuery
>;
export type GetMoreAppointmentsForOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetMoreAppointmentsForOrgIdLazyQuery
>;
export type GetMoreAppointmentsForOrgIdSuspenseQueryHookResult = ReturnType<
    typeof useGetMoreAppointmentsForOrgIdSuspenseQuery
>;
export type GetMoreAppointmentsForOrgIdQueryResult = Apollo.QueryResult<
    GetMoreAppointmentsForOrgIdQuery,
    GetMoreAppointmentsForOrgIdQueryVariables
>;
export const GetOutstandingChargesForBoughtTreatmentsDocument = gql`
    query getOutstandingChargesForBoughtTreatments(
        $boughtTreatmentIds: [String!]!
    ) {
        charges(
            where: {
                boughtTreatmentId: { in: $boughtTreatmentIds }
                transactionId: { equals: null }
            }
        ) {
            total
            id
            boughtTreatmentId
        }
    }
`;

/**
 * __useGetOutstandingChargesForBoughtTreatmentsQuery__
 *
 * To run a query within a React component, call `useGetOutstandingChargesForBoughtTreatmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutstandingChargesForBoughtTreatmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutstandingChargesForBoughtTreatmentsQuery({
 *   variables: {
 *      boughtTreatmentIds: // value for 'boughtTreatmentIds'
 *   },
 * });
 */
export function useGetOutstandingChargesForBoughtTreatmentsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOutstandingChargesForBoughtTreatmentsQuery,
        GetOutstandingChargesForBoughtTreatmentsQueryVariables
    > &
        (
            | {
                  variables: GetOutstandingChargesForBoughtTreatmentsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOutstandingChargesForBoughtTreatmentsQuery,
        GetOutstandingChargesForBoughtTreatmentsQueryVariables
    >(GetOutstandingChargesForBoughtTreatmentsDocument, options);
}
export function useGetOutstandingChargesForBoughtTreatmentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOutstandingChargesForBoughtTreatmentsQuery,
        GetOutstandingChargesForBoughtTreatmentsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOutstandingChargesForBoughtTreatmentsQuery,
        GetOutstandingChargesForBoughtTreatmentsQueryVariables
    >(GetOutstandingChargesForBoughtTreatmentsDocument, options);
}
// @ts-ignore
export function useGetOutstandingChargesForBoughtTreatmentsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOutstandingChargesForBoughtTreatmentsQuery,
        GetOutstandingChargesForBoughtTreatmentsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOutstandingChargesForBoughtTreatmentsQuery,
    GetOutstandingChargesForBoughtTreatmentsQueryVariables
>;
export function useGetOutstandingChargesForBoughtTreatmentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOutstandingChargesForBoughtTreatmentsQuery,
              GetOutstandingChargesForBoughtTreatmentsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOutstandingChargesForBoughtTreatmentsQuery | undefined,
    GetOutstandingChargesForBoughtTreatmentsQueryVariables
>;
export function useGetOutstandingChargesForBoughtTreatmentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOutstandingChargesForBoughtTreatmentsQuery,
              GetOutstandingChargesForBoughtTreatmentsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOutstandingChargesForBoughtTreatmentsQuery,
        GetOutstandingChargesForBoughtTreatmentsQueryVariables
    >(GetOutstandingChargesForBoughtTreatmentsDocument, options);
}
export type GetOutstandingChargesForBoughtTreatmentsQueryHookResult =
    ReturnType<typeof useGetOutstandingChargesForBoughtTreatmentsQuery>;
export type GetOutstandingChargesForBoughtTreatmentsLazyQueryHookResult =
    ReturnType<typeof useGetOutstandingChargesForBoughtTreatmentsLazyQuery>;
export type GetOutstandingChargesForBoughtTreatmentsSuspenseQueryHookResult =
    ReturnType<typeof useGetOutstandingChargesForBoughtTreatmentsSuspenseQuery>;
export type GetOutstandingChargesForBoughtTreatmentsQueryResult =
    Apollo.QueryResult<
        GetOutstandingChargesForBoughtTreatmentsQuery,
        GetOutstandingChargesForBoughtTreatmentsQueryVariables
    >;
export const GetChargesByBoughtTreatmentIdsDocument = gql`
    query getChargesByBoughtTreatmentIds($boughtTreatmentIds: [String!]!) {
        charges(where: { boughtTreatmentId: { in: $boughtTreatmentIds } }) {
            boughtTreatmentId
            total
            date
            id
            transactionId
            userId
        }
    }
`;

/**
 * __useGetChargesByBoughtTreatmentIdsQuery__
 *
 * To run a query within a React component, call `useGetChargesByBoughtTreatmentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargesByBoughtTreatmentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargesByBoughtTreatmentIdsQuery({
 *   variables: {
 *      boughtTreatmentIds: // value for 'boughtTreatmentIds'
 *   },
 * });
 */
export function useGetChargesByBoughtTreatmentIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetChargesByBoughtTreatmentIdsQuery,
        GetChargesByBoughtTreatmentIdsQueryVariables
    > &
        (
            | {
                  variables: GetChargesByBoughtTreatmentIdsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetChargesByBoughtTreatmentIdsQuery,
        GetChargesByBoughtTreatmentIdsQueryVariables
    >(GetChargesByBoughtTreatmentIdsDocument, options);
}
export function useGetChargesByBoughtTreatmentIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetChargesByBoughtTreatmentIdsQuery,
        GetChargesByBoughtTreatmentIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetChargesByBoughtTreatmentIdsQuery,
        GetChargesByBoughtTreatmentIdsQueryVariables
    >(GetChargesByBoughtTreatmentIdsDocument, options);
}
// @ts-ignore
export function useGetChargesByBoughtTreatmentIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetChargesByBoughtTreatmentIdsQuery,
        GetChargesByBoughtTreatmentIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetChargesByBoughtTreatmentIdsQuery,
    GetChargesByBoughtTreatmentIdsQueryVariables
>;
export function useGetChargesByBoughtTreatmentIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetChargesByBoughtTreatmentIdsQuery,
              GetChargesByBoughtTreatmentIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetChargesByBoughtTreatmentIdsQuery | undefined,
    GetChargesByBoughtTreatmentIdsQueryVariables
>;
export function useGetChargesByBoughtTreatmentIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetChargesByBoughtTreatmentIdsQuery,
              GetChargesByBoughtTreatmentIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetChargesByBoughtTreatmentIdsQuery,
        GetChargesByBoughtTreatmentIdsQueryVariables
    >(GetChargesByBoughtTreatmentIdsDocument, options);
}
export type GetChargesByBoughtTreatmentIdsQueryHookResult = ReturnType<
    typeof useGetChargesByBoughtTreatmentIdsQuery
>;
export type GetChargesByBoughtTreatmentIdsLazyQueryHookResult = ReturnType<
    typeof useGetChargesByBoughtTreatmentIdsLazyQuery
>;
export type GetChargesByBoughtTreatmentIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetChargesByBoughtTreatmentIdsSuspenseQuery
>;
export type GetChargesByBoughtTreatmentIdsQueryResult = Apollo.QueryResult<
    GetChargesByBoughtTreatmentIdsQuery,
    GetChargesByBoughtTreatmentIdsQueryVariables
>;
export const GetBoughtTreatmentClaimDetailsDocument = gql`
    query getBoughtTreatmentClaimDetails($boughtTreatmentIds: [String!]!) {
        boughtTreatmentClaimDetails(
            where: { boughtTreatmentId: { in: $boughtTreatmentIds } }
        ) {
            boughtTreatmentId
            swapReason
            remarkCodes
        }
    }
`;

/**
 * __useGetBoughtTreatmentClaimDetailsQuery__
 *
 * To run a query within a React component, call `useGetBoughtTreatmentClaimDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoughtTreatmentClaimDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoughtTreatmentClaimDetailsQuery({
 *   variables: {
 *      boughtTreatmentIds: // value for 'boughtTreatmentIds'
 *   },
 * });
 */
export function useGetBoughtTreatmentClaimDetailsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetBoughtTreatmentClaimDetailsQuery,
        GetBoughtTreatmentClaimDetailsQueryVariables
    > &
        (
            | {
                  variables: GetBoughtTreatmentClaimDetailsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBoughtTreatmentClaimDetailsQuery,
        GetBoughtTreatmentClaimDetailsQueryVariables
    >(GetBoughtTreatmentClaimDetailsDocument, options);
}
export function useGetBoughtTreatmentClaimDetailsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBoughtTreatmentClaimDetailsQuery,
        GetBoughtTreatmentClaimDetailsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBoughtTreatmentClaimDetailsQuery,
        GetBoughtTreatmentClaimDetailsQueryVariables
    >(GetBoughtTreatmentClaimDetailsDocument, options);
}
// @ts-ignore
export function useGetBoughtTreatmentClaimDetailsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetBoughtTreatmentClaimDetailsQuery,
        GetBoughtTreatmentClaimDetailsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentClaimDetailsQuery,
    GetBoughtTreatmentClaimDetailsQueryVariables
>;
export function useGetBoughtTreatmentClaimDetailsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentClaimDetailsQuery,
              GetBoughtTreatmentClaimDetailsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentClaimDetailsQuery | undefined,
    GetBoughtTreatmentClaimDetailsQueryVariables
>;
export function useGetBoughtTreatmentClaimDetailsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentClaimDetailsQuery,
              GetBoughtTreatmentClaimDetailsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBoughtTreatmentClaimDetailsQuery,
        GetBoughtTreatmentClaimDetailsQueryVariables
    >(GetBoughtTreatmentClaimDetailsDocument, options);
}
export type GetBoughtTreatmentClaimDetailsQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentClaimDetailsQuery
>;
export type GetBoughtTreatmentClaimDetailsLazyQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentClaimDetailsLazyQuery
>;
export type GetBoughtTreatmentClaimDetailsSuspenseQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentClaimDetailsSuspenseQuery
>;
export type GetBoughtTreatmentClaimDetailsQueryResult = Apollo.QueryResult<
    GetBoughtTreatmentClaimDetailsQuery,
    GetBoughtTreatmentClaimDetailsQueryVariables
>;
export const GetConsumerDataDocument = gql`
    query getConsumerData($consumerId: String!) {
        consumer(where: { id: $consumerId }) {
            id
            firstname
            lastname
            dob
            streetAddress
            city
            state
            country
            zip
            sex
            consumerNotes {
                note
            }
        }
    }
`;

/**
 * __useGetConsumerDataQuery__
 *
 * To run a query within a React component, call `useGetConsumerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerDataQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useGetConsumerDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetConsumerDataQuery,
        GetConsumerDataQueryVariables
    > &
        (
            | { variables: GetConsumerDataQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetConsumerDataQuery, GetConsumerDataQueryVariables>(
        GetConsumerDataDocument,
        options,
    );
}
export function useGetConsumerDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetConsumerDataQuery,
        GetConsumerDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetConsumerDataQuery,
        GetConsumerDataQueryVariables
    >(GetConsumerDataDocument, options);
}
// @ts-ignore
export function useGetConsumerDataSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetConsumerDataQuery,
        GetConsumerDataQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetConsumerDataQuery,
    GetConsumerDataQueryVariables
>;
export function useGetConsumerDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumerDataQuery,
              GetConsumerDataQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetConsumerDataQuery | undefined,
    GetConsumerDataQueryVariables
>;
export function useGetConsumerDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumerDataQuery,
              GetConsumerDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetConsumerDataQuery,
        GetConsumerDataQueryVariables
    >(GetConsumerDataDocument, options);
}
export type GetConsumerDataQueryHookResult = ReturnType<
    typeof useGetConsumerDataQuery
>;
export type GetConsumerDataLazyQueryHookResult = ReturnType<
    typeof useGetConsumerDataLazyQuery
>;
export type GetConsumerDataSuspenseQueryHookResult = ReturnType<
    typeof useGetConsumerDataSuspenseQuery
>;
export type GetConsumerDataQueryResult = Apollo.QueryResult<
    GetConsumerDataQuery,
    GetConsumerDataQueryVariables
>;
export const GetBoughtTreatmentDataDocument = gql`
    query getBoughtTreatmentData($boughtTreatmentId: String!) {
        boughtTreatment(where: { id: $boughtTreatmentId }) {
            id
            name
            price
            consumerId
            paymentType
            slot {
                practiceId
            }
        }
    }
`;

/**
 * __useGetBoughtTreatmentDataQuery__
 *
 * To run a query within a React component, call `useGetBoughtTreatmentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoughtTreatmentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoughtTreatmentDataQuery({
 *   variables: {
 *      boughtTreatmentId: // value for 'boughtTreatmentId'
 *   },
 * });
 */
export function useGetBoughtTreatmentDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetBoughtTreatmentDataQuery,
        GetBoughtTreatmentDataQueryVariables
    > &
        (
            | {
                  variables: GetBoughtTreatmentDataQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBoughtTreatmentDataQuery,
        GetBoughtTreatmentDataQueryVariables
    >(GetBoughtTreatmentDataDocument, options);
}
export function useGetBoughtTreatmentDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBoughtTreatmentDataQuery,
        GetBoughtTreatmentDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBoughtTreatmentDataQuery,
        GetBoughtTreatmentDataQueryVariables
    >(GetBoughtTreatmentDataDocument, options);
}
// @ts-ignore
export function useGetBoughtTreatmentDataSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetBoughtTreatmentDataQuery,
        GetBoughtTreatmentDataQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentDataQuery,
    GetBoughtTreatmentDataQueryVariables
>;
export function useGetBoughtTreatmentDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentDataQuery,
              GetBoughtTreatmentDataQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentDataQuery | undefined,
    GetBoughtTreatmentDataQueryVariables
>;
export function useGetBoughtTreatmentDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentDataQuery,
              GetBoughtTreatmentDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBoughtTreatmentDataQuery,
        GetBoughtTreatmentDataQueryVariables
    >(GetBoughtTreatmentDataDocument, options);
}
export type GetBoughtTreatmentDataQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentDataQuery
>;
export type GetBoughtTreatmentDataLazyQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentDataLazyQuery
>;
export type GetBoughtTreatmentDataSuspenseQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentDataSuspenseQuery
>;
export type GetBoughtTreatmentDataQueryResult = Apollo.QueryResult<
    GetBoughtTreatmentDataQuery,
    GetBoughtTreatmentDataQueryVariables
>;
export const GetUserDataDocument = gql`
    query getUserData($userId: String!) {
        user(where: { id: $userId }) {
            id
            firstname
            lastname
            phone
            email
        }
    }
`;

/**
 * __useGetUserDataQuery__
 *
 * To run a query within a React component, call `useGetUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserDataQuery,
        GetUserDataQueryVariables
    > &
        (
            | { variables: GetUserDataQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUserDataQuery, GetUserDataQueryVariables>(
        GetUserDataDocument,
        options,
    );
}
export function useGetUserDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserDataQuery,
        GetUserDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetUserDataQuery, GetUserDataQueryVariables>(
        GetUserDataDocument,
        options,
    );
}
// @ts-ignore
export function useGetUserDataSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUserDataQuery,
        GetUserDataQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<GetUserDataQuery, GetUserDataQueryVariables>;
export function useGetUserDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserDataQuery,
              GetUserDataQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUserDataQuery | undefined,
    GetUserDataQueryVariables
>;
export function useGetUserDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserDataQuery,
              GetUserDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetUserDataQuery, GetUserDataQueryVariables>(
        GetUserDataDocument,
        options,
    );
}
export type GetUserDataQueryHookResult = ReturnType<typeof useGetUserDataQuery>;
export type GetUserDataLazyQueryHookResult = ReturnType<
    typeof useGetUserDataLazyQuery
>;
export type GetUserDataSuspenseQueryHookResult = ReturnType<
    typeof useGetUserDataSuspenseQuery
>;
export type GetUserDataQueryResult = Apollo.QueryResult<
    GetUserDataQuery,
    GetUserDataQueryVariables
>;
export const GetChargeByIdDocument = gql`
    query getChargeById($chargeId: String!) {
        charge(where: { id: $chargeId }) {
            id
            boughtTreatmentId
            type
        }
    }
`;

/**
 * __useGetChargeByIdQuery__
 *
 * To run a query within a React component, call `useGetChargeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargeByIdQuery({
 *   variables: {
 *      chargeId: // value for 'chargeId'
 *   },
 * });
 */
export function useGetChargeByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetChargeByIdQuery,
        GetChargeByIdQueryVariables
    > &
        (
            | { variables: GetChargeByIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetChargeByIdQuery, GetChargeByIdQueryVariables>(
        GetChargeByIdDocument,
        options,
    );
}
export function useGetChargeByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetChargeByIdQuery,
        GetChargeByIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetChargeByIdQuery, GetChargeByIdQueryVariables>(
        GetChargeByIdDocument,
        options,
    );
}
// @ts-ignore
export function useGetChargeByIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetChargeByIdQuery,
        GetChargeByIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetChargeByIdQuery,
    GetChargeByIdQueryVariables
>;
export function useGetChargeByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetChargeByIdQuery,
              GetChargeByIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetChargeByIdQuery | undefined,
    GetChargeByIdQueryVariables
>;
export function useGetChargeByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetChargeByIdQuery,
              GetChargeByIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetChargeByIdQuery,
        GetChargeByIdQueryVariables
    >(GetChargeByIdDocument, options);
}
export type GetChargeByIdQueryHookResult = ReturnType<
    typeof useGetChargeByIdQuery
>;
export type GetChargeByIdLazyQueryHookResult = ReturnType<
    typeof useGetChargeByIdLazyQuery
>;
export type GetChargeByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetChargeByIdSuspenseQuery
>;
export type GetChargeByIdQueryResult = Apollo.QueryResult<
    GetChargeByIdQuery,
    GetChargeByIdQueryVariables
>;
export const GetTransactionsDocument = gql`
    query getTransactions($orgId: Int!) {
        transactions(
            where: { charges: { some: { orgId: { equals: $orgId } } } }
        ) {
            id
            price
            charges(where: { boughtTreatmentId: { not: { equals: "" } } }) {
                boughtTreatmentId
                total
            }
            paidDate
            userId
            transactionType
        }
    }
`;

/**
 * __useGetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetTransactionsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetTransactionsQuery,
        GetTransactionsQueryVariables
    > &
        (
            | { variables: GetTransactionsQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(
        GetTransactionsDocument,
        options,
    );
}
export function useGetTransactionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTransactionsQuery,
        GetTransactionsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetTransactionsQuery,
        GetTransactionsQueryVariables
    >(GetTransactionsDocument, options);
}
// @ts-ignore
export function useGetTransactionsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetTransactionsQuery,
        GetTransactionsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetTransactionsQuery,
    GetTransactionsQueryVariables
>;
export function useGetTransactionsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTransactionsQuery,
              GetTransactionsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetTransactionsQuery | undefined,
    GetTransactionsQueryVariables
>;
export function useGetTransactionsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTransactionsQuery,
              GetTransactionsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetTransactionsQuery,
        GetTransactionsQueryVariables
    >(GetTransactionsDocument, options);
}
export type GetTransactionsQueryHookResult = ReturnType<
    typeof useGetTransactionsQuery
>;
export type GetTransactionsLazyQueryHookResult = ReturnType<
    typeof useGetTransactionsLazyQuery
>;
export type GetTransactionsSuspenseQueryHookResult = ReturnType<
    typeof useGetTransactionsSuspenseQuery
>;
export type GetTransactionsQueryResult = Apollo.QueryResult<
    GetTransactionsQuery,
    GetTransactionsQueryVariables
>;
export const GetPaginatedTransactionsDocument = gql`
    query getPaginatedTransactions(
        $where: TransactionWhereInput!
        $take: Int!
    ) {
        transactions(
            where: $where
            take: $take
            orderBy: { paidDate: { sort: desc } }
        ) {
            id
            userId
            paidDate
            price
            transactionType
            paymentMethodType
            externalPaymentReason
            charges {
                id
                boughtTreatmentId
                total
            }
            collectedBy
        }
        totalCount: aggregateTransaction(where: $where) {
            _count {
                id
            }
        }
    }
`;

/**
 * __useGetPaginatedTransactionsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedTransactionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPaginatedTransactionsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPaginatedTransactionsQuery,
        GetPaginatedTransactionsQueryVariables
    > &
        (
            | {
                  variables: GetPaginatedTransactionsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetPaginatedTransactionsQuery,
        GetPaginatedTransactionsQueryVariables
    >(GetPaginatedTransactionsDocument, options);
}
export function useGetPaginatedTransactionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPaginatedTransactionsQuery,
        GetPaginatedTransactionsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPaginatedTransactionsQuery,
        GetPaginatedTransactionsQueryVariables
    >(GetPaginatedTransactionsDocument, options);
}
// @ts-ignore
export function useGetPaginatedTransactionsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetPaginatedTransactionsQuery,
        GetPaginatedTransactionsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetPaginatedTransactionsQuery,
    GetPaginatedTransactionsQueryVariables
>;
export function useGetPaginatedTransactionsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPaginatedTransactionsQuery,
              GetPaginatedTransactionsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetPaginatedTransactionsQuery | undefined,
    GetPaginatedTransactionsQueryVariables
>;
export function useGetPaginatedTransactionsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPaginatedTransactionsQuery,
              GetPaginatedTransactionsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPaginatedTransactionsQuery,
        GetPaginatedTransactionsQueryVariables
    >(GetPaginatedTransactionsDocument, options);
}
export type GetPaginatedTransactionsQueryHookResult = ReturnType<
    typeof useGetPaginatedTransactionsQuery
>;
export type GetPaginatedTransactionsLazyQueryHookResult = ReturnType<
    typeof useGetPaginatedTransactionsLazyQuery
>;
export type GetPaginatedTransactionsSuspenseQueryHookResult = ReturnType<
    typeof useGetPaginatedTransactionsSuspenseQuery
>;
export type GetPaginatedTransactionsQueryResult = Apollo.QueryResult<
    GetPaginatedTransactionsQuery,
    GetPaginatedTransactionsQueryVariables
>;
export const GetMorePaginatedTransactionsDocument = gql`
    query getMorePaginatedTransactions(
        $where: TransactionWhereInput!
        $take: Int!
        $cursorId: String
    ) {
        transactions(
            where: $where
            take: $take
            orderBy: { paidDate: { sort: desc } }
            cursor: { id: $cursorId }
        ) {
            id
            userId
            paidDate
            price
            transactionType
            paymentMethodType
            externalPaymentReason
            charges {
                id
                boughtTreatmentId
                total
            }
            collectedBy
        }
        totalCount: aggregateTransaction(where: $where) {
            _count {
                id
            }
        }
    }
`;

/**
 * __useGetMorePaginatedTransactionsQuery__
 *
 * To run a query within a React component, call `useGetMorePaginatedTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMorePaginatedTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMorePaginatedTransactionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      cursorId: // value for 'cursorId'
 *   },
 * });
 */
export function useGetMorePaginatedTransactionsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMorePaginatedTransactionsQuery,
        GetMorePaginatedTransactionsQueryVariables
    > &
        (
            | {
                  variables: GetMorePaginatedTransactionsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetMorePaginatedTransactionsQuery,
        GetMorePaginatedTransactionsQueryVariables
    >(GetMorePaginatedTransactionsDocument, options);
}
export function useGetMorePaginatedTransactionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMorePaginatedTransactionsQuery,
        GetMorePaginatedTransactionsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetMorePaginatedTransactionsQuery,
        GetMorePaginatedTransactionsQueryVariables
    >(GetMorePaginatedTransactionsDocument, options);
}
// @ts-ignore
export function useGetMorePaginatedTransactionsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetMorePaginatedTransactionsQuery,
        GetMorePaginatedTransactionsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetMorePaginatedTransactionsQuery,
    GetMorePaginatedTransactionsQueryVariables
>;
export function useGetMorePaginatedTransactionsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMorePaginatedTransactionsQuery,
              GetMorePaginatedTransactionsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetMorePaginatedTransactionsQuery | undefined,
    GetMorePaginatedTransactionsQueryVariables
>;
export function useGetMorePaginatedTransactionsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMorePaginatedTransactionsQuery,
              GetMorePaginatedTransactionsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetMorePaginatedTransactionsQuery,
        GetMorePaginatedTransactionsQueryVariables
    >(GetMorePaginatedTransactionsDocument, options);
}
export type GetMorePaginatedTransactionsQueryHookResult = ReturnType<
    typeof useGetMorePaginatedTransactionsQuery
>;
export type GetMorePaginatedTransactionsLazyQueryHookResult = ReturnType<
    typeof useGetMorePaginatedTransactionsLazyQuery
>;
export type GetMorePaginatedTransactionsSuspenseQueryHookResult = ReturnType<
    typeof useGetMorePaginatedTransactionsSuspenseQuery
>;
export type GetMorePaginatedTransactionsQueryResult = Apollo.QueryResult<
    GetMorePaginatedTransactionsQuery,
    GetMorePaginatedTransactionsQueryVariables
>;
export const GetMessagesDocument = gql`
    query getMessages($where: ConsumerMessageWhereInput, $take: Int!) {
        consumerMessages(
            where: $where
            orderBy: { createdAt: desc }
            take: $take
        ) {
            id
            message
            consumer {
                firstname
                lastname
            }
            createdAt
            admin {
                email
            }
        }
        totalCount: aggregateConsumerMessage(where: $where) {
            _count {
                id
            }
        }
    }
`;

/**
 * __useGetMessagesQuery__
 *
 * To run a query within a React component, call `useGetMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetMessagesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMessagesQuery,
        GetMessagesQueryVariables
    > &
        (
            | { variables: GetMessagesQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetMessagesQuery, GetMessagesQueryVariables>(
        GetMessagesDocument,
        options,
    );
}
export function useGetMessagesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMessagesQuery,
        GetMessagesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetMessagesQuery, GetMessagesQueryVariables>(
        GetMessagesDocument,
        options,
    );
}
// @ts-ignore
export function useGetMessagesSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetMessagesQuery,
        GetMessagesQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<GetMessagesQuery, GetMessagesQueryVariables>;
export function useGetMessagesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMessagesQuery,
              GetMessagesQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetMessagesQuery | undefined,
    GetMessagesQueryVariables
>;
export function useGetMessagesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMessagesQuery,
              GetMessagesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetMessagesQuery, GetMessagesQueryVariables>(
        GetMessagesDocument,
        options,
    );
}
export type GetMessagesQueryHookResult = ReturnType<typeof useGetMessagesQuery>;
export type GetMessagesLazyQueryHookResult = ReturnType<
    typeof useGetMessagesLazyQuery
>;
export type GetMessagesSuspenseQueryHookResult = ReturnType<
    typeof useGetMessagesSuspenseQuery
>;
export type GetMessagesQueryResult = Apollo.QueryResult<
    GetMessagesQuery,
    GetMessagesQueryVariables
>;
export const GetMorePaginatedMessagesDocument = gql`
    query getMorePaginatedMessages(
        $where: ConsumerMessageWhereInput
        $take: Int!
        $cursorId: String
    ) {
        consumerMessages(
            where: $where
            orderBy: { createdAt: desc }
            take: $take
            cursor: { id: $cursorId }
        ) {
            id
            message
            consumer {
                firstname
                lastname
            }
            createdAt
            admin {
                email
            }
        }
        totalCount: aggregateConsumerMessage(where: $where) {
            _count {
                id
            }
        }
    }
`;

/**
 * __useGetMorePaginatedMessagesQuery__
 *
 * To run a query within a React component, call `useGetMorePaginatedMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMorePaginatedMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMorePaginatedMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      cursorId: // value for 'cursorId'
 *   },
 * });
 */
export function useGetMorePaginatedMessagesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMorePaginatedMessagesQuery,
        GetMorePaginatedMessagesQueryVariables
    > &
        (
            | {
                  variables: GetMorePaginatedMessagesQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetMorePaginatedMessagesQuery,
        GetMorePaginatedMessagesQueryVariables
    >(GetMorePaginatedMessagesDocument, options);
}
export function useGetMorePaginatedMessagesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMorePaginatedMessagesQuery,
        GetMorePaginatedMessagesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetMorePaginatedMessagesQuery,
        GetMorePaginatedMessagesQueryVariables
    >(GetMorePaginatedMessagesDocument, options);
}
// @ts-ignore
export function useGetMorePaginatedMessagesSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetMorePaginatedMessagesQuery,
        GetMorePaginatedMessagesQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetMorePaginatedMessagesQuery,
    GetMorePaginatedMessagesQueryVariables
>;
export function useGetMorePaginatedMessagesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMorePaginatedMessagesQuery,
              GetMorePaginatedMessagesQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetMorePaginatedMessagesQuery | undefined,
    GetMorePaginatedMessagesQueryVariables
>;
export function useGetMorePaginatedMessagesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMorePaginatedMessagesQuery,
              GetMorePaginatedMessagesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetMorePaginatedMessagesQuery,
        GetMorePaginatedMessagesQueryVariables
    >(GetMorePaginatedMessagesDocument, options);
}
export type GetMorePaginatedMessagesQueryHookResult = ReturnType<
    typeof useGetMorePaginatedMessagesQuery
>;
export type GetMorePaginatedMessagesLazyQueryHookResult = ReturnType<
    typeof useGetMorePaginatedMessagesLazyQuery
>;
export type GetMorePaginatedMessagesSuspenseQueryHookResult = ReturnType<
    typeof useGetMorePaginatedMessagesSuspenseQuery
>;
export type GetMorePaginatedMessagesQueryResult = Apollo.QueryResult<
    GetMorePaginatedMessagesQuery,
    GetMorePaginatedMessagesQueryVariables
>;
export const GetTransfersDataDocument = gql`
    query getTransfersData($take: Int!, $where: PayoutWhereInput) {
        totalCount: aggregatePayout(where: $where) {
            _count {
                id
            }
        }
        payouts(where: $where, take: $take, orderBy: { date: desc }) {
            ...transferFields
        }
    }
    ${TransferFieldsFragmentDoc}
`;

/**
 * __useGetTransfersDataQuery__
 *
 * To run a query within a React component, call `useGetTransfersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransfersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransfersDataQuery({
 *   variables: {
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTransfersDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetTransfersDataQuery,
        GetTransfersDataQueryVariables
    > &
        (
            | { variables: GetTransfersDataQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetTransfersDataQuery,
        GetTransfersDataQueryVariables
    >(GetTransfersDataDocument, options);
}
export function useGetTransfersDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTransfersDataQuery,
        GetTransfersDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetTransfersDataQuery,
        GetTransfersDataQueryVariables
    >(GetTransfersDataDocument, options);
}
// @ts-ignore
export function useGetTransfersDataSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetTransfersDataQuery,
        GetTransfersDataQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetTransfersDataQuery,
    GetTransfersDataQueryVariables
>;
export function useGetTransfersDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTransfersDataQuery,
              GetTransfersDataQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetTransfersDataQuery | undefined,
    GetTransfersDataQueryVariables
>;
export function useGetTransfersDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTransfersDataQuery,
              GetTransfersDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetTransfersDataQuery,
        GetTransfersDataQueryVariables
    >(GetTransfersDataDocument, options);
}
export type GetTransfersDataQueryHookResult = ReturnType<
    typeof useGetTransfersDataQuery
>;
export type GetTransfersDataLazyQueryHookResult = ReturnType<
    typeof useGetTransfersDataLazyQuery
>;
export type GetTransfersDataSuspenseQueryHookResult = ReturnType<
    typeof useGetTransfersDataSuspenseQuery
>;
export type GetTransfersDataQueryResult = Apollo.QueryResult<
    GetTransfersDataQuery,
    GetTransfersDataQueryVariables
>;
export const GetMorePaginatedTransfersDocument = gql`
    query getMorePaginatedTransfers(
        $where: PayoutWhereInput!
        $take: Int!
        $cursorId: String
    ) {
        payouts(
            where: $where
            take: $take
            orderBy: { date: desc }
            cursor: { id: $cursorId }
        ) {
            ...transferFields
        }
        totalCount: aggregatePayout(where: $where) {
            _count {
                id
            }
        }
    }
    ${TransferFieldsFragmentDoc}
`;

/**
 * __useGetMorePaginatedTransfersQuery__
 *
 * To run a query within a React component, call `useGetMorePaginatedTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMorePaginatedTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMorePaginatedTransfersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      cursorId: // value for 'cursorId'
 *   },
 * });
 */
export function useGetMorePaginatedTransfersQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMorePaginatedTransfersQuery,
        GetMorePaginatedTransfersQueryVariables
    > &
        (
            | {
                  variables: GetMorePaginatedTransfersQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetMorePaginatedTransfersQuery,
        GetMorePaginatedTransfersQueryVariables
    >(GetMorePaginatedTransfersDocument, options);
}
export function useGetMorePaginatedTransfersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMorePaginatedTransfersQuery,
        GetMorePaginatedTransfersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetMorePaginatedTransfersQuery,
        GetMorePaginatedTransfersQueryVariables
    >(GetMorePaginatedTransfersDocument, options);
}
// @ts-ignore
export function useGetMorePaginatedTransfersSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetMorePaginatedTransfersQuery,
        GetMorePaginatedTransfersQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetMorePaginatedTransfersQuery,
    GetMorePaginatedTransfersQueryVariables
>;
export function useGetMorePaginatedTransfersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMorePaginatedTransfersQuery,
              GetMorePaginatedTransfersQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetMorePaginatedTransfersQuery | undefined,
    GetMorePaginatedTransfersQueryVariables
>;
export function useGetMorePaginatedTransfersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMorePaginatedTransfersQuery,
              GetMorePaginatedTransfersQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetMorePaginatedTransfersQuery,
        GetMorePaginatedTransfersQueryVariables
    >(GetMorePaginatedTransfersDocument, options);
}
export type GetMorePaginatedTransfersQueryHookResult = ReturnType<
    typeof useGetMorePaginatedTransfersQuery
>;
export type GetMorePaginatedTransfersLazyQueryHookResult = ReturnType<
    typeof useGetMorePaginatedTransfersLazyQuery
>;
export type GetMorePaginatedTransfersSuspenseQueryHookResult = ReturnType<
    typeof useGetMorePaginatedTransfersSuspenseQuery
>;
export type GetMorePaginatedTransfersQueryResult = Apollo.QueryResult<
    GetMorePaginatedTransfersQuery,
    GetMorePaginatedTransfersQueryVariables
>;
export const GetLiveTransfersDataDocument = gql`
    query getLiveTransfersData($take: Int!, $where: LiveTransfersWhereInput) {
        liveTransfers: findManyLiveTransfers(
            where: $where
            take: $take
            orderBy: { dateOfService: desc }
        ) {
            ...liveTransferFields
        }
        totalCount: aggregateLiveTransfers(where: $where) {
            _count {
                id
            }
        }
    }
    ${LiveTransferFieldsFragmentDoc}
`;

/**
 * __useGetLiveTransfersDataQuery__
 *
 * To run a query within a React component, call `useGetLiveTransfersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveTransfersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveTransfersDataQuery({
 *   variables: {
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLiveTransfersDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetLiveTransfersDataQuery,
        GetLiveTransfersDataQueryVariables
    > &
        (
            | { variables: GetLiveTransfersDataQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetLiveTransfersDataQuery,
        GetLiveTransfersDataQueryVariables
    >(GetLiveTransfersDataDocument, options);
}
export function useGetLiveTransfersDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetLiveTransfersDataQuery,
        GetLiveTransfersDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetLiveTransfersDataQuery,
        GetLiveTransfersDataQueryVariables
    >(GetLiveTransfersDataDocument, options);
}
// @ts-ignore
export function useGetLiveTransfersDataSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetLiveTransfersDataQuery,
        GetLiveTransfersDataQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetLiveTransfersDataQuery,
    GetLiveTransfersDataQueryVariables
>;
export function useGetLiveTransfersDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetLiveTransfersDataQuery,
              GetLiveTransfersDataQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetLiveTransfersDataQuery | undefined,
    GetLiveTransfersDataQueryVariables
>;
export function useGetLiveTransfersDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetLiveTransfersDataQuery,
              GetLiveTransfersDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetLiveTransfersDataQuery,
        GetLiveTransfersDataQueryVariables
    >(GetLiveTransfersDataDocument, options);
}
export type GetLiveTransfersDataQueryHookResult = ReturnType<
    typeof useGetLiveTransfersDataQuery
>;
export type GetLiveTransfersDataLazyQueryHookResult = ReturnType<
    typeof useGetLiveTransfersDataLazyQuery
>;
export type GetLiveTransfersDataSuspenseQueryHookResult = ReturnType<
    typeof useGetLiveTransfersDataSuspenseQuery
>;
export type GetLiveTransfersDataQueryResult = Apollo.QueryResult<
    GetLiveTransfersDataQuery,
    GetLiveTransfersDataQueryVariables
>;
export const GetMorePaginatedLiveTransfersDocument = gql`
    query getMorePaginatedLiveTransfers(
        $where: LiveTransfersWhereInput!
        $take: Int!
        $cursorId: String
    ) {
        liveTransfers: findManyLiveTransfers(
            where: $where
            take: $take
            cursor: { id: $cursorId }
            orderBy: { dateOfService: desc }
        ) {
            ...liveTransferFields
        }
        totalCount: aggregateLiveTransfers(where: $where) {
            _count {
                id
            }
        }
    }
    ${LiveTransferFieldsFragmentDoc}
`;

/**
 * __useGetMorePaginatedLiveTransfersQuery__
 *
 * To run a query within a React component, call `useGetMorePaginatedLiveTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMorePaginatedLiveTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMorePaginatedLiveTransfersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      cursorId: // value for 'cursorId'
 *   },
 * });
 */
export function useGetMorePaginatedLiveTransfersQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMorePaginatedLiveTransfersQuery,
        GetMorePaginatedLiveTransfersQueryVariables
    > &
        (
            | {
                  variables: GetMorePaginatedLiveTransfersQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetMorePaginatedLiveTransfersQuery,
        GetMorePaginatedLiveTransfersQueryVariables
    >(GetMorePaginatedLiveTransfersDocument, options);
}
export function useGetMorePaginatedLiveTransfersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMorePaginatedLiveTransfersQuery,
        GetMorePaginatedLiveTransfersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetMorePaginatedLiveTransfersQuery,
        GetMorePaginatedLiveTransfersQueryVariables
    >(GetMorePaginatedLiveTransfersDocument, options);
}
// @ts-ignore
export function useGetMorePaginatedLiveTransfersSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetMorePaginatedLiveTransfersQuery,
        GetMorePaginatedLiveTransfersQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetMorePaginatedLiveTransfersQuery,
    GetMorePaginatedLiveTransfersQueryVariables
>;
export function useGetMorePaginatedLiveTransfersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMorePaginatedLiveTransfersQuery,
              GetMorePaginatedLiveTransfersQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetMorePaginatedLiveTransfersQuery | undefined,
    GetMorePaginatedLiveTransfersQueryVariables
>;
export function useGetMorePaginatedLiveTransfersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMorePaginatedLiveTransfersQuery,
              GetMorePaginatedLiveTransfersQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetMorePaginatedLiveTransfersQuery,
        GetMorePaginatedLiveTransfersQueryVariables
    >(GetMorePaginatedLiveTransfersDocument, options);
}
export type GetMorePaginatedLiveTransfersQueryHookResult = ReturnType<
    typeof useGetMorePaginatedLiveTransfersQuery
>;
export type GetMorePaginatedLiveTransfersLazyQueryHookResult = ReturnType<
    typeof useGetMorePaginatedLiveTransfersLazyQuery
>;
export type GetMorePaginatedLiveTransfersSuspenseQueryHookResult = ReturnType<
    typeof useGetMorePaginatedLiveTransfersSuspenseQuery
>;
export type GetMorePaginatedLiveTransfersQueryResult = Apollo.QueryResult<
    GetMorePaginatedLiveTransfersQuery,
    GetMorePaginatedLiveTransfersQueryVariables
>;
export const GetBoughtTreatmentDataForPayoutsDocument = gql`
    query getBoughtTreatmentDataForPayouts($boughtTreatmentId: String!) {
        boughtTreatment(where: { id: $boughtTreatmentId }) {
            price
            consumerId
            name
            slot {
                id
                providerId
                startTime
                practiceId
            }
        }
    }
`;

/**
 * __useGetBoughtTreatmentDataForPayoutsQuery__
 *
 * To run a query within a React component, call `useGetBoughtTreatmentDataForPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoughtTreatmentDataForPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoughtTreatmentDataForPayoutsQuery({
 *   variables: {
 *      boughtTreatmentId: // value for 'boughtTreatmentId'
 *   },
 * });
 */
export function useGetBoughtTreatmentDataForPayoutsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetBoughtTreatmentDataForPayoutsQuery,
        GetBoughtTreatmentDataForPayoutsQueryVariables
    > &
        (
            | {
                  variables: GetBoughtTreatmentDataForPayoutsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBoughtTreatmentDataForPayoutsQuery,
        GetBoughtTreatmentDataForPayoutsQueryVariables
    >(GetBoughtTreatmentDataForPayoutsDocument, options);
}
export function useGetBoughtTreatmentDataForPayoutsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBoughtTreatmentDataForPayoutsQuery,
        GetBoughtTreatmentDataForPayoutsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBoughtTreatmentDataForPayoutsQuery,
        GetBoughtTreatmentDataForPayoutsQueryVariables
    >(GetBoughtTreatmentDataForPayoutsDocument, options);
}
// @ts-ignore
export function useGetBoughtTreatmentDataForPayoutsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetBoughtTreatmentDataForPayoutsQuery,
        GetBoughtTreatmentDataForPayoutsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentDataForPayoutsQuery,
    GetBoughtTreatmentDataForPayoutsQueryVariables
>;
export function useGetBoughtTreatmentDataForPayoutsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentDataForPayoutsQuery,
              GetBoughtTreatmentDataForPayoutsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetBoughtTreatmentDataForPayoutsQuery | undefined,
    GetBoughtTreatmentDataForPayoutsQueryVariables
>;
export function useGetBoughtTreatmentDataForPayoutsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBoughtTreatmentDataForPayoutsQuery,
              GetBoughtTreatmentDataForPayoutsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBoughtTreatmentDataForPayoutsQuery,
        GetBoughtTreatmentDataForPayoutsQueryVariables
    >(GetBoughtTreatmentDataForPayoutsDocument, options);
}
export type GetBoughtTreatmentDataForPayoutsQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentDataForPayoutsQuery
>;
export type GetBoughtTreatmentDataForPayoutsLazyQueryHookResult = ReturnType<
    typeof useGetBoughtTreatmentDataForPayoutsLazyQuery
>;
export type GetBoughtTreatmentDataForPayoutsSuspenseQueryHookResult =
    ReturnType<typeof useGetBoughtTreatmentDataForPayoutsSuspenseQuery>;
export type GetBoughtTreatmentDataForPayoutsQueryResult = Apollo.QueryResult<
    GetBoughtTreatmentDataForPayoutsQuery,
    GetBoughtTreatmentDataForPayoutsQueryVariables
>;
export const GetProviderDataForPayoutsDocument = gql`
    query getProviderDataForPayouts($providerId: Int!) {
        providers(where: { id: { equals: $providerId } }) {
            firstName
            lastName
        }
    }
`;

/**
 * __useGetProviderDataForPayoutsQuery__
 *
 * To run a query within a React component, call `useGetProviderDataForPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderDataForPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderDataForPayoutsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetProviderDataForPayoutsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProviderDataForPayoutsQuery,
        GetProviderDataForPayoutsQueryVariables
    > &
        (
            | {
                  variables: GetProviderDataForPayoutsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProviderDataForPayoutsQuery,
        GetProviderDataForPayoutsQueryVariables
    >(GetProviderDataForPayoutsDocument, options);
}
export function useGetProviderDataForPayoutsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderDataForPayoutsQuery,
        GetProviderDataForPayoutsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderDataForPayoutsQuery,
        GetProviderDataForPayoutsQueryVariables
    >(GetProviderDataForPayoutsDocument, options);
}
// @ts-ignore
export function useGetProviderDataForPayoutsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderDataForPayoutsQuery,
        GetProviderDataForPayoutsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderDataForPayoutsQuery,
    GetProviderDataForPayoutsQueryVariables
>;
export function useGetProviderDataForPayoutsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderDataForPayoutsQuery,
              GetProviderDataForPayoutsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderDataForPayoutsQuery | undefined,
    GetProviderDataForPayoutsQueryVariables
>;
export function useGetProviderDataForPayoutsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderDataForPayoutsQuery,
              GetProviderDataForPayoutsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderDataForPayoutsQuery,
        GetProviderDataForPayoutsQueryVariables
    >(GetProviderDataForPayoutsDocument, options);
}
export type GetProviderDataForPayoutsQueryHookResult = ReturnType<
    typeof useGetProviderDataForPayoutsQuery
>;
export type GetProviderDataForPayoutsLazyQueryHookResult = ReturnType<
    typeof useGetProviderDataForPayoutsLazyQuery
>;
export type GetProviderDataForPayoutsSuspenseQueryHookResult = ReturnType<
    typeof useGetProviderDataForPayoutsSuspenseQuery
>;
export type GetProviderDataForPayoutsQueryResult = Apollo.QueryResult<
    GetProviderDataForPayoutsQuery,
    GetProviderDataForPayoutsQueryVariables
>;
export const GetLocationDataForPayoutsDocument = gql`
    query getLocationDataForPayouts($practiceId: Int!) {
        practices(where: { practiceId: { equals: $practiceId } }) {
            locationName
        }
    }
`;

/**
 * __useGetLocationDataForPayoutsQuery__
 *
 * To run a query within a React component, call `useGetLocationDataForPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationDataForPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationDataForPayoutsQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *   },
 * });
 */
export function useGetLocationDataForPayoutsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetLocationDataForPayoutsQuery,
        GetLocationDataForPayoutsQueryVariables
    > &
        (
            | {
                  variables: GetLocationDataForPayoutsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetLocationDataForPayoutsQuery,
        GetLocationDataForPayoutsQueryVariables
    >(GetLocationDataForPayoutsDocument, options);
}
export function useGetLocationDataForPayoutsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetLocationDataForPayoutsQuery,
        GetLocationDataForPayoutsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetLocationDataForPayoutsQuery,
        GetLocationDataForPayoutsQueryVariables
    >(GetLocationDataForPayoutsDocument, options);
}
// @ts-ignore
export function useGetLocationDataForPayoutsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetLocationDataForPayoutsQuery,
        GetLocationDataForPayoutsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetLocationDataForPayoutsQuery,
    GetLocationDataForPayoutsQueryVariables
>;
export function useGetLocationDataForPayoutsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetLocationDataForPayoutsQuery,
              GetLocationDataForPayoutsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetLocationDataForPayoutsQuery | undefined,
    GetLocationDataForPayoutsQueryVariables
>;
export function useGetLocationDataForPayoutsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetLocationDataForPayoutsQuery,
              GetLocationDataForPayoutsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetLocationDataForPayoutsQuery,
        GetLocationDataForPayoutsQueryVariables
    >(GetLocationDataForPayoutsDocument, options);
}
export type GetLocationDataForPayoutsQueryHookResult = ReturnType<
    typeof useGetLocationDataForPayoutsQuery
>;
export type GetLocationDataForPayoutsLazyQueryHookResult = ReturnType<
    typeof useGetLocationDataForPayoutsLazyQuery
>;
export type GetLocationDataForPayoutsSuspenseQueryHookResult = ReturnType<
    typeof useGetLocationDataForPayoutsSuspenseQuery
>;
export type GetLocationDataForPayoutsQueryResult = Apollo.QueryResult<
    GetLocationDataForPayoutsQuery,
    GetLocationDataForPayoutsQueryVariables
>;
export const GetUnpaidChargesByBoughtTreatmentIdsDocument = gql`
    query getUnpaidChargesByBoughtTreatmentIds(
        $boughtTreatmentIds: [String!]!
    ) {
        charges(
            where: {
                boughtTreatmentId: { in: $boughtTreatmentIds }
                transactionId: null
            }
        ) {
            id
            boughtTreatmentId
            total
            transactionId
            orgId
            date
        }
    }
`;

/**
 * __useGetUnpaidChargesByBoughtTreatmentIdsQuery__
 *
 * To run a query within a React component, call `useGetUnpaidChargesByBoughtTreatmentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnpaidChargesByBoughtTreatmentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnpaidChargesByBoughtTreatmentIdsQuery({
 *   variables: {
 *      boughtTreatmentIds: // value for 'boughtTreatmentIds'
 *   },
 * });
 */
export function useGetUnpaidChargesByBoughtTreatmentIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUnpaidChargesByBoughtTreatmentIdsQuery,
        GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
    > &
        (
            | {
                  variables: GetUnpaidChargesByBoughtTreatmentIdsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUnpaidChargesByBoughtTreatmentIdsQuery,
        GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
    >(GetUnpaidChargesByBoughtTreatmentIdsDocument, options);
}
export function useGetUnpaidChargesByBoughtTreatmentIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUnpaidChargesByBoughtTreatmentIdsQuery,
        GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUnpaidChargesByBoughtTreatmentIdsQuery,
        GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
    >(GetUnpaidChargesByBoughtTreatmentIdsDocument, options);
}
// @ts-ignore
export function useGetUnpaidChargesByBoughtTreatmentIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUnpaidChargesByBoughtTreatmentIdsQuery,
        GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUnpaidChargesByBoughtTreatmentIdsQuery,
    GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
>;
export function useGetUnpaidChargesByBoughtTreatmentIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUnpaidChargesByBoughtTreatmentIdsQuery,
              GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUnpaidChargesByBoughtTreatmentIdsQuery | undefined,
    GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
>;
export function useGetUnpaidChargesByBoughtTreatmentIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUnpaidChargesByBoughtTreatmentIdsQuery,
              GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUnpaidChargesByBoughtTreatmentIdsQuery,
        GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
    >(GetUnpaidChargesByBoughtTreatmentIdsDocument, options);
}
export type GetUnpaidChargesByBoughtTreatmentIdsQueryHookResult = ReturnType<
    typeof useGetUnpaidChargesByBoughtTreatmentIdsQuery
>;
export type GetUnpaidChargesByBoughtTreatmentIdsLazyQueryHookResult =
    ReturnType<typeof useGetUnpaidChargesByBoughtTreatmentIdsLazyQuery>;
export type GetUnpaidChargesByBoughtTreatmentIdsSuspenseQueryHookResult =
    ReturnType<typeof useGetUnpaidChargesByBoughtTreatmentIdsSuspenseQuery>;
export type GetUnpaidChargesByBoughtTreatmentIdsQueryResult =
    Apollo.QueryResult<
        GetUnpaidChargesByBoughtTreatmentIdsQuery,
        GetUnpaidChargesByBoughtTreatmentIdsQueryVariables
    >;
export const GetUnscheduledBoughtTreatmentsByOrgIdDocument = gql`
    query getUnscheduledBoughtTreatmentsByOrgId($orgId: Int!) {
        rosterBoughtTreatments(
            where: {
                AND: [
                    { orgId: { equals: $orgId } }
                    { slotId: { equals: null } }
                    { status: { equals: active } }
                ]
            }
        ) {
            id
            price
            pricedTreatmentId
            insuranceIds
            name
            source
            consumer
            createdAt
            charges
            paymentType
            discountCodeApplied
            status
        }
    }
`;

/**
 * __useGetUnscheduledBoughtTreatmentsByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetUnscheduledBoughtTreatmentsByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnscheduledBoughtTreatmentsByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnscheduledBoughtTreatmentsByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetUnscheduledBoughtTreatmentsByOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUnscheduledBoughtTreatmentsByOrgIdQuery,
        GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
    > &
        (
            | {
                  variables: GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetUnscheduledBoughtTreatmentsByOrgIdQuery,
        GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
    >(GetUnscheduledBoughtTreatmentsByOrgIdDocument, options);
}
export function useGetUnscheduledBoughtTreatmentsByOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUnscheduledBoughtTreatmentsByOrgIdQuery,
        GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUnscheduledBoughtTreatmentsByOrgIdQuery,
        GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
    >(GetUnscheduledBoughtTreatmentsByOrgIdDocument, options);
}
// @ts-ignore
export function useGetUnscheduledBoughtTreatmentsByOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetUnscheduledBoughtTreatmentsByOrgIdQuery,
        GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetUnscheduledBoughtTreatmentsByOrgIdQuery,
    GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
>;
export function useGetUnscheduledBoughtTreatmentsByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUnscheduledBoughtTreatmentsByOrgIdQuery,
              GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetUnscheduledBoughtTreatmentsByOrgIdQuery | undefined,
    GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
>;
export function useGetUnscheduledBoughtTreatmentsByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUnscheduledBoughtTreatmentsByOrgIdQuery,
              GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUnscheduledBoughtTreatmentsByOrgIdQuery,
        GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
    >(GetUnscheduledBoughtTreatmentsByOrgIdDocument, options);
}
export type GetUnscheduledBoughtTreatmentsByOrgIdQueryHookResult = ReturnType<
    typeof useGetUnscheduledBoughtTreatmentsByOrgIdQuery
>;
export type GetUnscheduledBoughtTreatmentsByOrgIdLazyQueryHookResult =
    ReturnType<typeof useGetUnscheduledBoughtTreatmentsByOrgIdLazyQuery>;
export type GetUnscheduledBoughtTreatmentsByOrgIdSuspenseQueryHookResult =
    ReturnType<typeof useGetUnscheduledBoughtTreatmentsByOrgIdSuspenseQuery>;
export type GetUnscheduledBoughtTreatmentsByOrgIdQueryResult =
    Apollo.QueryResult<
        GetUnscheduledBoughtTreatmentsByOrgIdQuery,
        GetUnscheduledBoughtTreatmentsByOrgIdQueryVariables
    >;
export const GetOneAppointmentByIdDocument = gql`
    query getOneAppointmentById($appointmentId: String!, $orgId: Int!) {
        detailSlots(
            orgId: $orgId
            where: { appointmentId: { equals: $appointmentId } }
            orderBy: { startTime: desc }
        ) {
            id
            startTime
            endTime
            createdAt
            consumerId
            appointment {
                id
                status
                intakeFormIds
                completedIntakeFormIds
            }
            providerId
            practiceId
            ehrSlotId
            practice
            detailBoughtTreatments {
                id
                name
                price
                pricedTreatmentId
                insuranceIds
                pricedTreatmentId
                consumerId
                consumer
                discountCodeApplied
                status
                isVirtual
            }
            note
            noteUpdatedAt
            noteUpdatedBy
            virtualLink
        }
    }
`;

/**
 * __useGetOneAppointmentByIdQuery__
 *
 * To run a query within a React component, call `useGetOneAppointmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneAppointmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneAppointmentByIdQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOneAppointmentByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOneAppointmentByIdQuery,
        GetOneAppointmentByIdQueryVariables
    > &
        (
            | { variables: GetOneAppointmentByIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOneAppointmentByIdQuery,
        GetOneAppointmentByIdQueryVariables
    >(GetOneAppointmentByIdDocument, options);
}
export function useGetOneAppointmentByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOneAppointmentByIdQuery,
        GetOneAppointmentByIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOneAppointmentByIdQuery,
        GetOneAppointmentByIdQueryVariables
    >(GetOneAppointmentByIdDocument, options);
}
// @ts-ignore
export function useGetOneAppointmentByIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOneAppointmentByIdQuery,
        GetOneAppointmentByIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOneAppointmentByIdQuery,
    GetOneAppointmentByIdQueryVariables
>;
export function useGetOneAppointmentByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOneAppointmentByIdQuery,
              GetOneAppointmentByIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOneAppointmentByIdQuery | undefined,
    GetOneAppointmentByIdQueryVariables
>;
export function useGetOneAppointmentByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOneAppointmentByIdQuery,
              GetOneAppointmentByIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOneAppointmentByIdQuery,
        GetOneAppointmentByIdQueryVariables
    >(GetOneAppointmentByIdDocument, options);
}
export type GetOneAppointmentByIdQueryHookResult = ReturnType<
    typeof useGetOneAppointmentByIdQuery
>;
export type GetOneAppointmentByIdLazyQueryHookResult = ReturnType<
    typeof useGetOneAppointmentByIdLazyQuery
>;
export type GetOneAppointmentByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetOneAppointmentByIdSuspenseQuery
>;
export type GetOneAppointmentByIdQueryResult = Apollo.QueryResult<
    GetOneAppointmentByIdQuery,
    GetOneAppointmentByIdQueryVariables
>;
export const GetChargesAndTheirStatusesDocument = gql`
    query getChargesAndTheirStatuses($boughtTreatmentIds: [String!]) {
        all_charges: charges(
            where: { boughtTreatmentId: { in: $boughtTreatmentIds } }
        ) {
            id
            total
            transactionId
            slotId
            boughtTreatmentId
            date
        }
        unpaid_charges: charges(
            where: {
                boughtTreatmentId: { in: $boughtTreatmentIds }
                transactionId: { equals: null }
            }
        ) {
            id
            total
            transactionId
            slotId
            boughtTreatmentId
        }
    }
`;

/**
 * __useGetChargesAndTheirStatusesQuery__
 *
 * To run a query within a React component, call `useGetChargesAndTheirStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargesAndTheirStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargesAndTheirStatusesQuery({
 *   variables: {
 *      boughtTreatmentIds: // value for 'boughtTreatmentIds'
 *   },
 * });
 */
export function useGetChargesAndTheirStatusesQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetChargesAndTheirStatusesQuery,
        GetChargesAndTheirStatusesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetChargesAndTheirStatusesQuery,
        GetChargesAndTheirStatusesQueryVariables
    >(GetChargesAndTheirStatusesDocument, options);
}
export function useGetChargesAndTheirStatusesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetChargesAndTheirStatusesQuery,
        GetChargesAndTheirStatusesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetChargesAndTheirStatusesQuery,
        GetChargesAndTheirStatusesQueryVariables
    >(GetChargesAndTheirStatusesDocument, options);
}
// @ts-ignore
export function useGetChargesAndTheirStatusesSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetChargesAndTheirStatusesQuery,
        GetChargesAndTheirStatusesQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetChargesAndTheirStatusesQuery,
    GetChargesAndTheirStatusesQueryVariables
>;
export function useGetChargesAndTheirStatusesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetChargesAndTheirStatusesQuery,
              GetChargesAndTheirStatusesQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetChargesAndTheirStatusesQuery | undefined,
    GetChargesAndTheirStatusesQueryVariables
>;
export function useGetChargesAndTheirStatusesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetChargesAndTheirStatusesQuery,
              GetChargesAndTheirStatusesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetChargesAndTheirStatusesQuery,
        GetChargesAndTheirStatusesQueryVariables
    >(GetChargesAndTheirStatusesDocument, options);
}
export type GetChargesAndTheirStatusesQueryHookResult = ReturnType<
    typeof useGetChargesAndTheirStatusesQuery
>;
export type GetChargesAndTheirStatusesLazyQueryHookResult = ReturnType<
    typeof useGetChargesAndTheirStatusesLazyQuery
>;
export type GetChargesAndTheirStatusesSuspenseQueryHookResult = ReturnType<
    typeof useGetChargesAndTheirStatusesSuspenseQuery
>;
export type GetChargesAndTheirStatusesQueryResult = Apollo.QueryResult<
    GetChargesAndTheirStatusesQuery,
    GetChargesAndTheirStatusesQueryVariables
>;
export const GetDiscountCodeByOrgIdAndCodeDocument = gql`
    query getDiscountCodeByOrgIdAndCode(
        $orgId: Int!
        $code: String!
        $hrtIds: [Int!]
    ) {
        findFirstDiscountCodes(
            where: {
                code: { equals: $code }
                orgId: { equals: $orgId }
                appliesToHrts: { hasSome: $hrtIds }
            }
        ) {
            code
            discountPercent
            discountDollarAmount
            discountType
            isActive
            appliesToHrts
        }
    }
`;

/**
 * __useGetDiscountCodeByOrgIdAndCodeQuery__
 *
 * To run a query within a React component, call `useGetDiscountCodeByOrgIdAndCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountCodeByOrgIdAndCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountCodeByOrgIdAndCodeQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      code: // value for 'code'
 *      hrtIds: // value for 'hrtIds'
 *   },
 * });
 */
export function useGetDiscountCodeByOrgIdAndCodeQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetDiscountCodeByOrgIdAndCodeQuery,
        GetDiscountCodeByOrgIdAndCodeQueryVariables
    > &
        (
            | {
                  variables: GetDiscountCodeByOrgIdAndCodeQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetDiscountCodeByOrgIdAndCodeQuery,
        GetDiscountCodeByOrgIdAndCodeQueryVariables
    >(GetDiscountCodeByOrgIdAndCodeDocument, options);
}
export function useGetDiscountCodeByOrgIdAndCodeLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetDiscountCodeByOrgIdAndCodeQuery,
        GetDiscountCodeByOrgIdAndCodeQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetDiscountCodeByOrgIdAndCodeQuery,
        GetDiscountCodeByOrgIdAndCodeQueryVariables
    >(GetDiscountCodeByOrgIdAndCodeDocument, options);
}
// @ts-ignore
export function useGetDiscountCodeByOrgIdAndCodeSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetDiscountCodeByOrgIdAndCodeQuery,
        GetDiscountCodeByOrgIdAndCodeQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetDiscountCodeByOrgIdAndCodeQuery,
    GetDiscountCodeByOrgIdAndCodeQueryVariables
>;
export function useGetDiscountCodeByOrgIdAndCodeSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetDiscountCodeByOrgIdAndCodeQuery,
              GetDiscountCodeByOrgIdAndCodeQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetDiscountCodeByOrgIdAndCodeQuery | undefined,
    GetDiscountCodeByOrgIdAndCodeQueryVariables
>;
export function useGetDiscountCodeByOrgIdAndCodeSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetDiscountCodeByOrgIdAndCodeQuery,
              GetDiscountCodeByOrgIdAndCodeQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetDiscountCodeByOrgIdAndCodeQuery,
        GetDiscountCodeByOrgIdAndCodeQueryVariables
    >(GetDiscountCodeByOrgIdAndCodeDocument, options);
}
export type GetDiscountCodeByOrgIdAndCodeQueryHookResult = ReturnType<
    typeof useGetDiscountCodeByOrgIdAndCodeQuery
>;
export type GetDiscountCodeByOrgIdAndCodeLazyQueryHookResult = ReturnType<
    typeof useGetDiscountCodeByOrgIdAndCodeLazyQuery
>;
export type GetDiscountCodeByOrgIdAndCodeSuspenseQueryHookResult = ReturnType<
    typeof useGetDiscountCodeByOrgIdAndCodeSuspenseQuery
>;
export type GetDiscountCodeByOrgIdAndCodeQueryResult = Apollo.QueryResult<
    GetDiscountCodeByOrgIdAndCodeQuery,
    GetDiscountCodeByOrgIdAndCodeQueryVariables
>;
export const UpdateCompletedAppointmentIntakeFormIdsDocument = gql`
    mutation updateCompletedAppointmentIntakeFormIds(
        $appointmentId: String!
        $completedIntakeFormIds: [Int!]!
    ) {
        updateOneAppointment(
            where: { id: $appointmentId }
            data: { completedIntakeFormIds: { set: $completedIntakeFormIds } }
        ) {
            id
            completedIntakeFormIds
            intakeFormIds
        }
    }
`;
export type UpdateCompletedAppointmentIntakeFormIdsMutationFn =
    Apollo.MutationFunction<
        UpdateCompletedAppointmentIntakeFormIdsMutation,
        UpdateCompletedAppointmentIntakeFormIdsMutationVariables
    >;

/**
 * __useUpdateCompletedAppointmentIntakeFormIdsMutation__
 *
 * To run a mutation, you first call `useUpdateCompletedAppointmentIntakeFormIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompletedAppointmentIntakeFormIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompletedAppointmentIntakeFormIdsMutation, { data, loading, error }] = useUpdateCompletedAppointmentIntakeFormIdsMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      completedIntakeFormIds: // value for 'completedIntakeFormIds'
 *   },
 * });
 */
export function useUpdateCompletedAppointmentIntakeFormIdsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateCompletedAppointmentIntakeFormIdsMutation,
        UpdateCompletedAppointmentIntakeFormIdsMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateCompletedAppointmentIntakeFormIdsMutation,
        UpdateCompletedAppointmentIntakeFormIdsMutationVariables
    >(UpdateCompletedAppointmentIntakeFormIdsDocument, options);
}
export type UpdateCompletedAppointmentIntakeFormIdsMutationHookResult =
    ReturnType<typeof useUpdateCompletedAppointmentIntakeFormIdsMutation>;
export type UpdateCompletedAppointmentIntakeFormIdsMutationResult =
    Apollo.MutationResult<UpdateCompletedAppointmentIntakeFormIdsMutation>;
export type UpdateCompletedAppointmentIntakeFormIdsMutationOptions =
    Apollo.BaseMutationOptions<
        UpdateCompletedAppointmentIntakeFormIdsMutation,
        UpdateCompletedAppointmentIntakeFormIdsMutationVariables
    >;
export const UpdateConsumerAndEhrPatientDocument = gql`
    mutation updateConsumerAndEhrPatient(
        $ehrLocationId: String
        $data: ConsumerUpdateInput!
        $id: String!
    ) {
        updateConsumerAndEhrPatient(
            ehrLocationId: $ehrLocationId
            data: $data
            id: $id
        ) {
            id
            ehrUpdateResponse {
                patientUpdateResponse
                pcpUpdateResponse
                pharmacyUpdateResponse
                patientAthenaUpdateResponse
            }
        }
    }
`;
export type UpdateConsumerAndEhrPatientMutationFn = Apollo.MutationFunction<
    UpdateConsumerAndEhrPatientMutation,
    UpdateConsumerAndEhrPatientMutationVariables
>;

/**
 * __useUpdateConsumerAndEhrPatientMutation__
 *
 * To run a mutation, you first call `useUpdateConsumerAndEhrPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsumerAndEhrPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsumerAndEhrPatientMutation, { data, loading, error }] = useUpdateConsumerAndEhrPatientMutation({
 *   variables: {
 *      ehrLocationId: // value for 'ehrLocationId'
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateConsumerAndEhrPatientMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateConsumerAndEhrPatientMutation,
        UpdateConsumerAndEhrPatientMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateConsumerAndEhrPatientMutation,
        UpdateConsumerAndEhrPatientMutationVariables
    >(UpdateConsumerAndEhrPatientDocument, options);
}
export type UpdateConsumerAndEhrPatientMutationHookResult = ReturnType<
    typeof useUpdateConsumerAndEhrPatientMutation
>;
export type UpdateConsumerAndEhrPatientMutationResult =
    Apollo.MutationResult<UpdateConsumerAndEhrPatientMutation>;
export type UpdateConsumerAndEhrPatientMutationOptions =
    Apollo.BaseMutationOptions<
        UpdateConsumerAndEhrPatientMutation,
        UpdateConsumerAndEhrPatientMutationVariables
    >;
export const CreateConsumerAndEhrPatientDocument = gql`
    mutation createConsumerAndEhrPatient(
        $input: ConsumerAndEhrPatientCreateInput!
    ) {
        createConsumerAndEhrPatient(consumerAndEhrPatientInput: $input) {
            id
        }
    }
`;
export type CreateConsumerAndEhrPatientMutationFn = Apollo.MutationFunction<
    CreateConsumerAndEhrPatientMutation,
    CreateConsumerAndEhrPatientMutationVariables
>;

/**
 * __useCreateConsumerAndEhrPatientMutation__
 *
 * To run a mutation, you first call `useCreateConsumerAndEhrPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsumerAndEhrPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsumerAndEhrPatientMutation, { data, loading, error }] = useCreateConsumerAndEhrPatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConsumerAndEhrPatientMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateConsumerAndEhrPatientMutation,
        CreateConsumerAndEhrPatientMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CreateConsumerAndEhrPatientMutation,
        CreateConsumerAndEhrPatientMutationVariables
    >(CreateConsumerAndEhrPatientDocument, options);
}
export type CreateConsumerAndEhrPatientMutationHookResult = ReturnType<
    typeof useCreateConsumerAndEhrPatientMutation
>;
export type CreateConsumerAndEhrPatientMutationResult =
    Apollo.MutationResult<CreateConsumerAndEhrPatientMutation>;
export type CreateConsumerAndEhrPatientMutationOptions =
    Apollo.BaseMutationOptions<
        CreateConsumerAndEhrPatientMutation,
        CreateConsumerAndEhrPatientMutationVariables
    >;
export const GetHolidaysDocument = gql`
    query GetHolidays($orgId: Int!, $practiceId: Int) {
        holidays(
            where: {
                orgId: { equals: $orgId }
                OR: [
                    { practiceIdOverride: { isEmpty: true } }
                    { practiceIdOverride: { has: $practiceId } }
                ]
            }
        ) {
            id
            name
            day
            enabled
            practiceIdOverride
            orgId
        }
    }
`;

/**
 * __useGetHolidaysQuery__
 *
 * To run a query within a React component, call `useGetHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidaysQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      practiceId: // value for 'practiceId'
 *   },
 * });
 */
export function useGetHolidaysQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetHolidaysQuery,
        GetHolidaysQueryVariables
    > &
        (
            | { variables: GetHolidaysQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetHolidaysQuery, GetHolidaysQueryVariables>(
        GetHolidaysDocument,
        options,
    );
}
export function useGetHolidaysLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetHolidaysQuery,
        GetHolidaysQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetHolidaysQuery, GetHolidaysQueryVariables>(
        GetHolidaysDocument,
        options,
    );
}
// @ts-ignore
export function useGetHolidaysSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetHolidaysQuery,
        GetHolidaysQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<GetHolidaysQuery, GetHolidaysQueryVariables>;
export function useGetHolidaysSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetHolidaysQuery,
              GetHolidaysQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetHolidaysQuery | undefined,
    GetHolidaysQueryVariables
>;
export function useGetHolidaysSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetHolidaysQuery,
              GetHolidaysQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetHolidaysQuery, GetHolidaysQueryVariables>(
        GetHolidaysDocument,
        options,
    );
}
export type GetHolidaysQueryHookResult = ReturnType<typeof useGetHolidaysQuery>;
export type GetHolidaysLazyQueryHookResult = ReturnType<
    typeof useGetHolidaysLazyQuery
>;
export type GetHolidaysSuspenseQueryHookResult = ReturnType<
    typeof useGetHolidaysSuspenseQuery
>;
export type GetHolidaysQueryResult = Apollo.QueryResult<
    GetHolidaysQuery,
    GetHolidaysQueryVariables
>;
export const GetAllHolidaysDocument = gql`
    query GetAllHolidays($orgId: Int!) {
        holidays(where: { orgId: { equals: $orgId } }) {
            id
            name
            day
            enabled
            practiceIdOverride
            orgId
        }
    }
`;

/**
 * __useGetAllHolidaysQuery__
 *
 * To run a query within a React component, call `useGetAllHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllHolidaysQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetAllHolidaysQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAllHolidaysQuery,
        GetAllHolidaysQueryVariables
    > &
        (
            | { variables: GetAllHolidaysQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAllHolidaysQuery, GetAllHolidaysQueryVariables>(
        GetAllHolidaysDocument,
        options,
    );
}
export function useGetAllHolidaysLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllHolidaysQuery,
        GetAllHolidaysQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAllHolidaysQuery,
        GetAllHolidaysQueryVariables
    >(GetAllHolidaysDocument, options);
}
// @ts-ignore
export function useGetAllHolidaysSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetAllHolidaysQuery,
        GetAllHolidaysQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetAllHolidaysQuery,
    GetAllHolidaysQueryVariables
>;
export function useGetAllHolidaysSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllHolidaysQuery,
              GetAllHolidaysQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetAllHolidaysQuery | undefined,
    GetAllHolidaysQueryVariables
>;
export function useGetAllHolidaysSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAllHolidaysQuery,
              GetAllHolidaysQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAllHolidaysQuery,
        GetAllHolidaysQueryVariables
    >(GetAllHolidaysDocument, options);
}
export type GetAllHolidaysQueryHookResult = ReturnType<
    typeof useGetAllHolidaysQuery
>;
export type GetAllHolidaysLazyQueryHookResult = ReturnType<
    typeof useGetAllHolidaysLazyQuery
>;
export type GetAllHolidaysSuspenseQueryHookResult = ReturnType<
    typeof useGetAllHolidaysSuspenseQuery
>;
export type GetAllHolidaysQueryResult = Apollo.QueryResult<
    GetAllHolidaysQuery,
    GetAllHolidaysQueryVariables
>;
export const CreateHolidayDocument = gql`
    mutation CreateHoliday($data: HolidayCreateInput!) {
        createOneHoliday(data: $data) {
            id
            name
            day
            enabled
            practiceIdOverride
            orgId
        }
    }
`;
export type CreateHolidayMutationFn = Apollo.MutationFunction<
    CreateHolidayMutation,
    CreateHolidayMutationVariables
>;

/**
 * __useCreateHolidayMutation__
 *
 * To run a mutation, you first call `useCreateHolidayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHolidayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHolidayMutation, { data, loading, error }] = useCreateHolidayMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateHolidayMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateHolidayMutation,
        CreateHolidayMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CreateHolidayMutation,
        CreateHolidayMutationVariables
    >(CreateHolidayDocument, options);
}
export type CreateHolidayMutationHookResult = ReturnType<
    typeof useCreateHolidayMutation
>;
export type CreateHolidayMutationResult =
    Apollo.MutationResult<CreateHolidayMutation>;
export type CreateHolidayMutationOptions = Apollo.BaseMutationOptions<
    CreateHolidayMutation,
    CreateHolidayMutationVariables
>;
export const UpdateHolidayDocument = gql`
    mutation UpdateHoliday($id: String!, $data: HolidayUpdateInput!) {
        updateOneHoliday(where: { id: $id }, data: $data) {
            id
            name
            day
            enabled
            practiceIdOverride
            orgId
        }
    }
`;
export type UpdateHolidayMutationFn = Apollo.MutationFunction<
    UpdateHolidayMutation,
    UpdateHolidayMutationVariables
>;

/**
 * __useUpdateHolidayMutation__
 *
 * To run a mutation, you first call `useUpdateHolidayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHolidayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHolidayMutation, { data, loading, error }] = useUpdateHolidayMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateHolidayMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateHolidayMutation,
        UpdateHolidayMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateHolidayMutation,
        UpdateHolidayMutationVariables
    >(UpdateHolidayDocument, options);
}
export type UpdateHolidayMutationHookResult = ReturnType<
    typeof useUpdateHolidayMutation
>;
export type UpdateHolidayMutationResult =
    Apollo.MutationResult<UpdateHolidayMutation>;
export type UpdateHolidayMutationOptions = Apollo.BaseMutationOptions<
    UpdateHolidayMutation,
    UpdateHolidayMutationVariables
>;
export const DeleteHolidayDocument = gql`
    mutation DeleteHoliday($id: String!) {
        deleteOneHoliday(where: { id: $id }) {
            id
        }
    }
`;
export type DeleteHolidayMutationFn = Apollo.MutationFunction<
    DeleteHolidayMutation,
    DeleteHolidayMutationVariables
>;

/**
 * __useDeleteHolidayMutation__
 *
 * To run a mutation, you first call `useDeleteHolidayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHolidayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHolidayMutation, { data, loading, error }] = useDeleteHolidayMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHolidayMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteHolidayMutation,
        DeleteHolidayMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        DeleteHolidayMutation,
        DeleteHolidayMutationVariables
    >(DeleteHolidayDocument, options);
}
export type DeleteHolidayMutationHookResult = ReturnType<
    typeof useDeleteHolidayMutation
>;
export type DeleteHolidayMutationResult =
    Apollo.MutationResult<DeleteHolidayMutation>;
export type DeleteHolidayMutationOptions = Apollo.BaseMutationOptions<
    DeleteHolidayMutation,
    DeleteHolidayMutationVariables
>;
export const GetSlotsWithBoughtTreatmentsWithReviewStatusDocument = gql`
    query getSlotsWithBoughtTreatmentsWithReviewStatus(
        $consumerId: String!
        $reviewStatus: [ReviewStatusEnum!]!
    ) {
        slots(
            where: {
                AND: [
                    { status: { equals: upcoming } }
                    {
                        boughtTreatments: {
                            some: {
                                reviewStatus: { in: $reviewStatus }
                                consumerId: { equals: $consumerId }
                            }
                        }
                    }
                ]
            }
        ) {
            id
            startTime
            endTime
            practiceId
            providerId
            appointmentId
            boughtTreatments(where: { status: { equals: active } }) {
                id
                name
                price
                pricedTreatmentId
                reviewStatus
            }
        }
    }
`;

/**
 * __useGetSlotsWithBoughtTreatmentsWithReviewStatusQuery__
 *
 * To run a query within a React component, call `useGetSlotsWithBoughtTreatmentsWithReviewStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlotsWithBoughtTreatmentsWithReviewStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlotsWithBoughtTreatmentsWithReviewStatusQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      reviewStatus: // value for 'reviewStatus'
 *   },
 * });
 */
export function useGetSlotsWithBoughtTreatmentsWithReviewStatusQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSlotsWithBoughtTreatmentsWithReviewStatusQuery,
        GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
    > &
        (
            | {
                  variables: GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetSlotsWithBoughtTreatmentsWithReviewStatusQuery,
        GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
    >(GetSlotsWithBoughtTreatmentsWithReviewStatusDocument, options);
}
export function useGetSlotsWithBoughtTreatmentsWithReviewStatusLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSlotsWithBoughtTreatmentsWithReviewStatusQuery,
        GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetSlotsWithBoughtTreatmentsWithReviewStatusQuery,
        GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
    >(GetSlotsWithBoughtTreatmentsWithReviewStatusDocument, options);
}
// @ts-ignore
export function useGetSlotsWithBoughtTreatmentsWithReviewStatusSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetSlotsWithBoughtTreatmentsWithReviewStatusQuery,
        GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetSlotsWithBoughtTreatmentsWithReviewStatusQuery,
    GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
>;
export function useGetSlotsWithBoughtTreatmentsWithReviewStatusSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSlotsWithBoughtTreatmentsWithReviewStatusQuery,
              GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetSlotsWithBoughtTreatmentsWithReviewStatusQuery | undefined,
    GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
>;
export function useGetSlotsWithBoughtTreatmentsWithReviewStatusSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSlotsWithBoughtTreatmentsWithReviewStatusQuery,
              GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetSlotsWithBoughtTreatmentsWithReviewStatusQuery,
        GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
    >(GetSlotsWithBoughtTreatmentsWithReviewStatusDocument, options);
}
export type GetSlotsWithBoughtTreatmentsWithReviewStatusQueryHookResult =
    ReturnType<typeof useGetSlotsWithBoughtTreatmentsWithReviewStatusQuery>;
export type GetSlotsWithBoughtTreatmentsWithReviewStatusLazyQueryHookResult =
    ReturnType<typeof useGetSlotsWithBoughtTreatmentsWithReviewStatusLazyQuery>;
export type GetSlotsWithBoughtTreatmentsWithReviewStatusSuspenseQueryHookResult =
    ReturnType<
        typeof useGetSlotsWithBoughtTreatmentsWithReviewStatusSuspenseQuery
    >;
export type GetSlotsWithBoughtTreatmentsWithReviewStatusQueryResult =
    Apollo.QueryResult<
        GetSlotsWithBoughtTreatmentsWithReviewStatusQuery,
        GetSlotsWithBoughtTreatmentsWithReviewStatusQueryVariables
    >;
export const GetOrgRenderConfigDocument = gql`
    query getOrgRenderConfig($orgId: Int!) {
        findFirstOrganization(where: { id: { equals: $orgId } }) {
            renderConfig
            organizationTranslations {
                languageCode
                renderConfig
            }
        }
    }
`;

/**
 * __useGetOrgRenderConfigQuery__
 *
 * To run a query within a React component, call `useGetOrgRenderConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgRenderConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgRenderConfigQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgRenderConfigQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOrgRenderConfigQuery,
        GetOrgRenderConfigQueryVariables
    > &
        (
            | { variables: GetOrgRenderConfigQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrgRenderConfigQuery,
        GetOrgRenderConfigQueryVariables
    >(GetOrgRenderConfigDocument, options);
}
export function useGetOrgRenderConfigLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrgRenderConfigQuery,
        GetOrgRenderConfigQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrgRenderConfigQuery,
        GetOrgRenderConfigQueryVariables
    >(GetOrgRenderConfigDocument, options);
}
// @ts-ignore
export function useGetOrgRenderConfigSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrgRenderConfigQuery,
        GetOrgRenderConfigQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrgRenderConfigQuery,
    GetOrgRenderConfigQueryVariables
>;
export function useGetOrgRenderConfigSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgRenderConfigQuery,
              GetOrgRenderConfigQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrgRenderConfigQuery | undefined,
    GetOrgRenderConfigQueryVariables
>;
export function useGetOrgRenderConfigSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgRenderConfigQuery,
              GetOrgRenderConfigQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrgRenderConfigQuery,
        GetOrgRenderConfigQueryVariables
    >(GetOrgRenderConfigDocument, options);
}
export type GetOrgRenderConfigQueryHookResult = ReturnType<
    typeof useGetOrgRenderConfigQuery
>;
export type GetOrgRenderConfigLazyQueryHookResult = ReturnType<
    typeof useGetOrgRenderConfigLazyQuery
>;
export type GetOrgRenderConfigSuspenseQueryHookResult = ReturnType<
    typeof useGetOrgRenderConfigSuspenseQuery
>;
export type GetOrgRenderConfigQueryResult = Apollo.QueryResult<
    GetOrgRenderConfigQuery,
    GetOrgRenderConfigQueryVariables
>;
export const GetCategoriesDocument = gql`
    query getCategories($orgId: Int!) {
        findManyProductCategories(where: { orgId: { equals: $orgId } }) {
            id
            name
            popularity
            ProductCategoryTranslation {
                name
                languageCode
            }
        }
    }
`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetCategoriesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetCategoriesQuery,
        GetCategoriesQueryVariables
    > &
        (
            | { variables: GetCategoriesQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(
        GetCategoriesDocument,
        options,
    );
}
export function useGetCategoriesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCategoriesQuery,
        GetCategoriesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(
        GetCategoriesDocument,
        options,
    );
}
// @ts-ignore
export function useGetCategoriesSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetCategoriesQuery,
        GetCategoriesQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetCategoriesQuery,
    GetCategoriesQueryVariables
>;
export function useGetCategoriesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetCategoriesQuery,
              GetCategoriesQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetCategoriesQuery | undefined,
    GetCategoriesQueryVariables
>;
export function useGetCategoriesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetCategoriesQuery,
              GetCategoriesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetCategoriesQuery,
        GetCategoriesQueryVariables
    >(GetCategoriesDocument, options);
}
export type GetCategoriesQueryHookResult = ReturnType<
    typeof useGetCategoriesQuery
>;
export type GetCategoriesLazyQueryHookResult = ReturnType<
    typeof useGetCategoriesLazyQuery
>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<
    typeof useGetCategoriesSuspenseQuery
>;
export type GetCategoriesQueryResult = Apollo.QueryResult<
    GetCategoriesQuery,
    GetCategoriesQueryVariables
>;
export const GetProductCategoryTranslationsDocument = gql`
    query getProductCategoryTranslations($productCategoryIds: [Int!]!) {
        productCategoryTranslations(
            where: { productCategoryId: { in: $productCategoryIds } }
        ) {
            productCategoryId
            languageCode
            name
        }
    }
`;

/**
 * __useGetProductCategoryTranslationsQuery__
 *
 * To run a query within a React component, call `useGetProductCategoryTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoryTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoryTranslationsQuery({
 *   variables: {
 *      productCategoryIds: // value for 'productCategoryIds'
 *   },
 * });
 */
export function useGetProductCategoryTranslationsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProductCategoryTranslationsQuery,
        GetProductCategoryTranslationsQueryVariables
    > &
        (
            | {
                  variables: GetProductCategoryTranslationsQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProductCategoryTranslationsQuery,
        GetProductCategoryTranslationsQueryVariables
    >(GetProductCategoryTranslationsDocument, options);
}
export function useGetProductCategoryTranslationsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProductCategoryTranslationsQuery,
        GetProductCategoryTranslationsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProductCategoryTranslationsQuery,
        GetProductCategoryTranslationsQueryVariables
    >(GetProductCategoryTranslationsDocument, options);
}
// @ts-ignore
export function useGetProductCategoryTranslationsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProductCategoryTranslationsQuery,
        GetProductCategoryTranslationsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProductCategoryTranslationsQuery,
    GetProductCategoryTranslationsQueryVariables
>;
export function useGetProductCategoryTranslationsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProductCategoryTranslationsQuery,
              GetProductCategoryTranslationsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProductCategoryTranslationsQuery | undefined,
    GetProductCategoryTranslationsQueryVariables
>;
export function useGetProductCategoryTranslationsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProductCategoryTranslationsQuery,
              GetProductCategoryTranslationsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProductCategoryTranslationsQuery,
        GetProductCategoryTranslationsQueryVariables
    >(GetProductCategoryTranslationsDocument, options);
}
export type GetProductCategoryTranslationsQueryHookResult = ReturnType<
    typeof useGetProductCategoryTranslationsQuery
>;
export type GetProductCategoryTranslationsLazyQueryHookResult = ReturnType<
    typeof useGetProductCategoryTranslationsLazyQuery
>;
export type GetProductCategoryTranslationsSuspenseQueryHookResult = ReturnType<
    typeof useGetProductCategoryTranslationsSuspenseQuery
>;
export type GetProductCategoryTranslationsQueryResult = Apollo.QueryResult<
    GetProductCategoryTranslationsQuery,
    GetProductCategoryTranslationsQueryVariables
>;
export const GetProductsByCategoryIdDocument = gql`
    query getProductsByCategoryId($categoryIds: [Int!]!) {
        findManyProducts(where: { categoryIds: { hasSome: $categoryIds } }) {
            id
            name
            categoryIds
            displayMetadata
            popularity
            product_type
            orgId
            ProductTranslation {
                name
                displayMetadata
                languageCode
            }
            productToHrt {
                product_component_type
                hrt {
                    hrtId
                    orgId
                    isConsumerFacing
                    name
                    cash_prices {
                        cashPrice
                    }
                    hrtId
                    isConsumerFacing
                    ehrPrimaryAppointmentTypeId
                    isBookableOnStorefront
                    hrtPaymentType {
                        id
                        paymentType
                    }
                    HrtTranslation {
                        name
                        displayName
                        displayMetadata
                        languageCode
                    }
                }
            }
        }
    }
`;

/**
 * __useGetProductsByCategoryIdQuery__
 *
 * To run a query within a React component, call `useGetProductsByCategoryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsByCategoryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsByCategoryIdQuery({
 *   variables: {
 *      categoryIds: // value for 'categoryIds'
 *   },
 * });
 */
export function useGetProductsByCategoryIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProductsByCategoryIdQuery,
        GetProductsByCategoryIdQueryVariables
    > &
        (
            | {
                  variables: GetProductsByCategoryIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProductsByCategoryIdQuery,
        GetProductsByCategoryIdQueryVariables
    >(GetProductsByCategoryIdDocument, options);
}
export function useGetProductsByCategoryIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProductsByCategoryIdQuery,
        GetProductsByCategoryIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProductsByCategoryIdQuery,
        GetProductsByCategoryIdQueryVariables
    >(GetProductsByCategoryIdDocument, options);
}
// @ts-ignore
export function useGetProductsByCategoryIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProductsByCategoryIdQuery,
        GetProductsByCategoryIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProductsByCategoryIdQuery,
    GetProductsByCategoryIdQueryVariables
>;
export function useGetProductsByCategoryIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProductsByCategoryIdQuery,
              GetProductsByCategoryIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProductsByCategoryIdQuery | undefined,
    GetProductsByCategoryIdQueryVariables
>;
export function useGetProductsByCategoryIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProductsByCategoryIdQuery,
              GetProductsByCategoryIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProductsByCategoryIdQuery,
        GetProductsByCategoryIdQueryVariables
    >(GetProductsByCategoryIdDocument, options);
}
export type GetProductsByCategoryIdQueryHookResult = ReturnType<
    typeof useGetProductsByCategoryIdQuery
>;
export type GetProductsByCategoryIdLazyQueryHookResult = ReturnType<
    typeof useGetProductsByCategoryIdLazyQuery
>;
export type GetProductsByCategoryIdSuspenseQueryHookResult = ReturnType<
    typeof useGetProductsByCategoryIdSuspenseQuery
>;
export type GetProductsByCategoryIdQueryResult = Apollo.QueryResult<
    GetProductsByCategoryIdQuery,
    GetProductsByCategoryIdQueryVariables
>;
export const GetConsumerPhotosDocument = gql`
    query getConsumerPhotos($consumerId: String!, $orgId: Int!) {
        findManyConsumerPhotoMetaData(
            where: {
                consumerId: { equals: $consumerId }
                orgId: { equals: $orgId }
                status: { equals: CURRENT }
            }
        ) {
            id
            linkedInsuranceId
            type
            s3Link
            uploadedBy
            uploadedToEhrAt
            associatedPhotoId
            orgId
            status
            ocrMetadata
            insurance {
                priority
            }
        }
    }
`;

/**
 * __useGetConsumerPhotosQuery__
 *
 * To run a query within a React component, call `useGetConsumerPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerPhotosQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetConsumerPhotosQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetConsumerPhotosQuery,
        GetConsumerPhotosQueryVariables
    > &
        (
            | { variables: GetConsumerPhotosQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetConsumerPhotosQuery,
        GetConsumerPhotosQueryVariables
    >(GetConsumerPhotosDocument, options);
}
export function useGetConsumerPhotosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetConsumerPhotosQuery,
        GetConsumerPhotosQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetConsumerPhotosQuery,
        GetConsumerPhotosQueryVariables
    >(GetConsumerPhotosDocument, options);
}
// @ts-ignore
export function useGetConsumerPhotosSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetConsumerPhotosQuery,
        GetConsumerPhotosQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetConsumerPhotosQuery,
    GetConsumerPhotosQueryVariables
>;
export function useGetConsumerPhotosSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumerPhotosQuery,
              GetConsumerPhotosQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetConsumerPhotosQuery | undefined,
    GetConsumerPhotosQueryVariables
>;
export function useGetConsumerPhotosSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetConsumerPhotosQuery,
              GetConsumerPhotosQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetConsumerPhotosQuery,
        GetConsumerPhotosQueryVariables
    >(GetConsumerPhotosDocument, options);
}
export type GetConsumerPhotosQueryHookResult = ReturnType<
    typeof useGetConsumerPhotosQuery
>;
export type GetConsumerPhotosLazyQueryHookResult = ReturnType<
    typeof useGetConsumerPhotosLazyQuery
>;
export type GetConsumerPhotosSuspenseQueryHookResult = ReturnType<
    typeof useGetConsumerPhotosSuspenseQuery
>;
export type GetConsumerPhotosQueryResult = Apollo.QueryResult<
    GetConsumerPhotosQuery,
    GetConsumerPhotosQueryVariables
>;
export const GetGuarantorPaymentLinkContextDocument = gql`
    query getGuarantorPaymentLinkContext($id: String!) {
        guarantorPaymentLinkContext(where: { id: $id }) {
            ...guarantorPaymentLinkContextFields
        }
    }
    ${GuarantorPaymentLinkContextFieldsFragmentDoc}
`;

/**
 * __useGetGuarantorPaymentLinkContextQuery__
 *
 * To run a query within a React component, call `useGetGuarantorPaymentLinkContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuarantorPaymentLinkContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuarantorPaymentLinkContextQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGuarantorPaymentLinkContextQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetGuarantorPaymentLinkContextQuery,
        GetGuarantorPaymentLinkContextQueryVariables
    > &
        (
            | {
                  variables: GetGuarantorPaymentLinkContextQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetGuarantorPaymentLinkContextQuery,
        GetGuarantorPaymentLinkContextQueryVariables
    >(GetGuarantorPaymentLinkContextDocument, options);
}
export function useGetGuarantorPaymentLinkContextLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetGuarantorPaymentLinkContextQuery,
        GetGuarantorPaymentLinkContextQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetGuarantorPaymentLinkContextQuery,
        GetGuarantorPaymentLinkContextQueryVariables
    >(GetGuarantorPaymentLinkContextDocument, options);
}
// @ts-ignore
export function useGetGuarantorPaymentLinkContextSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetGuarantorPaymentLinkContextQuery,
        GetGuarantorPaymentLinkContextQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetGuarantorPaymentLinkContextQuery,
    GetGuarantorPaymentLinkContextQueryVariables
>;
export function useGetGuarantorPaymentLinkContextSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetGuarantorPaymentLinkContextQuery,
              GetGuarantorPaymentLinkContextQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetGuarantorPaymentLinkContextQuery | undefined,
    GetGuarantorPaymentLinkContextQueryVariables
>;
export function useGetGuarantorPaymentLinkContextSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetGuarantorPaymentLinkContextQuery,
              GetGuarantorPaymentLinkContextQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetGuarantorPaymentLinkContextQuery,
        GetGuarantorPaymentLinkContextQueryVariables
    >(GetGuarantorPaymentLinkContextDocument, options);
}
export type GetGuarantorPaymentLinkContextQueryHookResult = ReturnType<
    typeof useGetGuarantorPaymentLinkContextQuery
>;
export type GetGuarantorPaymentLinkContextLazyQueryHookResult = ReturnType<
    typeof useGetGuarantorPaymentLinkContextLazyQuery
>;
export type GetGuarantorPaymentLinkContextSuspenseQueryHookResult = ReturnType<
    typeof useGetGuarantorPaymentLinkContextSuspenseQuery
>;
export type GetGuarantorPaymentLinkContextQueryResult = Apollo.QueryResult<
    GetGuarantorPaymentLinkContextQuery,
    GetGuarantorPaymentLinkContextQueryVariables
>;
export const EhrAppointmentTypeIdToNamesByOrgIdDocument = gql`
    query ehrAppointmentTypeIdToNamesByOrgId($orgId: Int!) {
        ehrAppointmentTypeIdToNames(where: { orgId: { equals: $orgId } }) {
            orgId
            ehrAppointmentTypeName
            ehrPrimaryAppointmentTypeId
            isGeneric
            isVirtual
            duration
            id
        }
    }
`;

/**
 * __useEhrAppointmentTypeIdToNamesByOrgIdQuery__
 *
 * To run a query within a React component, call `useEhrAppointmentTypeIdToNamesByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEhrAppointmentTypeIdToNamesByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEhrAppointmentTypeIdToNamesByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useEhrAppointmentTypeIdToNamesByOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        EhrAppointmentTypeIdToNamesByOrgIdQuery,
        EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
    > &
        (
            | {
                  variables: EhrAppointmentTypeIdToNamesByOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        EhrAppointmentTypeIdToNamesByOrgIdQuery,
        EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
    >(EhrAppointmentTypeIdToNamesByOrgIdDocument, options);
}
export function useEhrAppointmentTypeIdToNamesByOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        EhrAppointmentTypeIdToNamesByOrgIdQuery,
        EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        EhrAppointmentTypeIdToNamesByOrgIdQuery,
        EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
    >(EhrAppointmentTypeIdToNamesByOrgIdDocument, options);
}
// @ts-ignore
export function useEhrAppointmentTypeIdToNamesByOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        EhrAppointmentTypeIdToNamesByOrgIdQuery,
        EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    EhrAppointmentTypeIdToNamesByOrgIdQuery,
    EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
>;
export function useEhrAppointmentTypeIdToNamesByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              EhrAppointmentTypeIdToNamesByOrgIdQuery,
              EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    EhrAppointmentTypeIdToNamesByOrgIdQuery | undefined,
    EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
>;
export function useEhrAppointmentTypeIdToNamesByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              EhrAppointmentTypeIdToNamesByOrgIdQuery,
              EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        EhrAppointmentTypeIdToNamesByOrgIdQuery,
        EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
    >(EhrAppointmentTypeIdToNamesByOrgIdDocument, options);
}
export type EhrAppointmentTypeIdToNamesByOrgIdQueryHookResult = ReturnType<
    typeof useEhrAppointmentTypeIdToNamesByOrgIdQuery
>;
export type EhrAppointmentTypeIdToNamesByOrgIdLazyQueryHookResult = ReturnType<
    typeof useEhrAppointmentTypeIdToNamesByOrgIdLazyQuery
>;
export type EhrAppointmentTypeIdToNamesByOrgIdSuspenseQueryHookResult =
    ReturnType<typeof useEhrAppointmentTypeIdToNamesByOrgIdSuspenseQuery>;
export type EhrAppointmentTypeIdToNamesByOrgIdQueryResult = Apollo.QueryResult<
    EhrAppointmentTypeIdToNamesByOrgIdQuery,
    EhrAppointmentTypeIdToNamesByOrgIdQueryVariables
>;
export const GetHrtsByBillingCodesDocument = gql`
    query getHrtsByBillingCodes($codes: [String!]!, $orgId: Int!) {
        hrts(
            where: {
                AND: [
                    { orgId: { equals: $orgId } }
                    {
                        hrtToSrt: {
                            some: {
                                srt: {
                                    is: {
                                        SrtToBillingCode: {
                                            some: {
                                                billingCode: { in: $codes }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                ]
            }
        ) {
            hrtId
            name
            displayName
            hrtToSrt {
                srt {
                    SrtToBillingCode {
                        billingCode
                    }
                }
            }
            isShownOnCompanion
        }
    }
`;

/**
 * __useGetHrtsByBillingCodesQuery__
 *
 * To run a query within a React component, call `useGetHrtsByBillingCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrtsByBillingCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHrtsByBillingCodesQuery({
 *   variables: {
 *      codes: // value for 'codes'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetHrtsByBillingCodesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetHrtsByBillingCodesQuery,
        GetHrtsByBillingCodesQueryVariables
    > &
        (
            | { variables: GetHrtsByBillingCodesQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetHrtsByBillingCodesQuery,
        GetHrtsByBillingCodesQueryVariables
    >(GetHrtsByBillingCodesDocument, options);
}
export function useGetHrtsByBillingCodesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetHrtsByBillingCodesQuery,
        GetHrtsByBillingCodesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetHrtsByBillingCodesQuery,
        GetHrtsByBillingCodesQueryVariables
    >(GetHrtsByBillingCodesDocument, options);
}
// @ts-ignore
export function useGetHrtsByBillingCodesSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetHrtsByBillingCodesQuery,
        GetHrtsByBillingCodesQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetHrtsByBillingCodesQuery,
    GetHrtsByBillingCodesQueryVariables
>;
export function useGetHrtsByBillingCodesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetHrtsByBillingCodesQuery,
              GetHrtsByBillingCodesQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetHrtsByBillingCodesQuery | undefined,
    GetHrtsByBillingCodesQueryVariables
>;
export function useGetHrtsByBillingCodesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetHrtsByBillingCodesQuery,
              GetHrtsByBillingCodesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetHrtsByBillingCodesQuery,
        GetHrtsByBillingCodesQueryVariables
    >(GetHrtsByBillingCodesDocument, options);
}
export type GetHrtsByBillingCodesQueryHookResult = ReturnType<
    typeof useGetHrtsByBillingCodesQuery
>;
export type GetHrtsByBillingCodesLazyQueryHookResult = ReturnType<
    typeof useGetHrtsByBillingCodesLazyQuery
>;
export type GetHrtsByBillingCodesSuspenseQueryHookResult = ReturnType<
    typeof useGetHrtsByBillingCodesSuspenseQuery
>;
export type GetHrtsByBillingCodesQueryResult = Apollo.QueryResult<
    GetHrtsByBillingCodesQuery,
    GetHrtsByBillingCodesQueryVariables
>;
export const GetSlotVirtualLinkDocument = gql`
    query getSlotVirtualLink($slotId: String!) {
        getSlotVirtualLink(slotId: $slotId) {
            virtualLink
        }
    }
`;

/**
 * __useGetSlotVirtualLinkQuery__
 *
 * To run a query within a React component, call `useGetSlotVirtualLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlotVirtualLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlotVirtualLinkQuery({
 *   variables: {
 *      slotId: // value for 'slotId'
 *   },
 * });
 */
export function useGetSlotVirtualLinkQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSlotVirtualLinkQuery,
        GetSlotVirtualLinkQueryVariables
    > &
        (
            | { variables: GetSlotVirtualLinkQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetSlotVirtualLinkQuery,
        GetSlotVirtualLinkQueryVariables
    >(GetSlotVirtualLinkDocument, options);
}
export function useGetSlotVirtualLinkLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSlotVirtualLinkQuery,
        GetSlotVirtualLinkQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetSlotVirtualLinkQuery,
        GetSlotVirtualLinkQueryVariables
    >(GetSlotVirtualLinkDocument, options);
}
// @ts-ignore
export function useGetSlotVirtualLinkSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetSlotVirtualLinkQuery,
        GetSlotVirtualLinkQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetSlotVirtualLinkQuery,
    GetSlotVirtualLinkQueryVariables
>;
export function useGetSlotVirtualLinkSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSlotVirtualLinkQuery,
              GetSlotVirtualLinkQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetSlotVirtualLinkQuery | undefined,
    GetSlotVirtualLinkQueryVariables
>;
export function useGetSlotVirtualLinkSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSlotVirtualLinkQuery,
              GetSlotVirtualLinkQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetSlotVirtualLinkQuery,
        GetSlotVirtualLinkQueryVariables
    >(GetSlotVirtualLinkDocument, options);
}
export type GetSlotVirtualLinkQueryHookResult = ReturnType<
    typeof useGetSlotVirtualLinkQuery
>;
export type GetSlotVirtualLinkLazyQueryHookResult = ReturnType<
    typeof useGetSlotVirtualLinkLazyQuery
>;
export type GetSlotVirtualLinkSuspenseQueryHookResult = ReturnType<
    typeof useGetSlotVirtualLinkSuspenseQuery
>;
export type GetSlotVirtualLinkQueryResult = Apollo.QueryResult<
    GetSlotVirtualLinkQuery,
    GetSlotVirtualLinkQueryVariables
>;
export const GetContractsForConsumerDocument = gql`
    query getContractsForConsumer($consumerId: String!) {
        contracts(
            where: {
                AND: [
                    { consumerId: { equals: $consumerId } }
                    { contractAccountStatus: { equals: CONNECTED } }
                ]
            }
        ) {
            id
            name
            contractType
            policyNumber
            consumerId
            ehrInsuranceId
            status
            notes
            contractAccountStatus
            patientRelation
            issueDate
            expirationDate
        }
    }
`;

/**
 * __useGetContractsForConsumerQuery__
 *
 * To run a query within a React component, call `useGetContractsForConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsForConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsForConsumerQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useGetContractsForConsumerQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetContractsForConsumerQuery,
        GetContractsForConsumerQueryVariables
    > &
        (
            | {
                  variables: GetContractsForConsumerQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetContractsForConsumerQuery,
        GetContractsForConsumerQueryVariables
    >(GetContractsForConsumerDocument, options);
}
export function useGetContractsForConsumerLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetContractsForConsumerQuery,
        GetContractsForConsumerQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetContractsForConsumerQuery,
        GetContractsForConsumerQueryVariables
    >(GetContractsForConsumerDocument, options);
}
// @ts-ignore
export function useGetContractsForConsumerSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetContractsForConsumerQuery,
        GetContractsForConsumerQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetContractsForConsumerQuery,
    GetContractsForConsumerQueryVariables
>;
export function useGetContractsForConsumerSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetContractsForConsumerQuery,
              GetContractsForConsumerQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetContractsForConsumerQuery | undefined,
    GetContractsForConsumerQueryVariables
>;
export function useGetContractsForConsumerSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetContractsForConsumerQuery,
              GetContractsForConsumerQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetContractsForConsumerQuery,
        GetContractsForConsumerQueryVariables
    >(GetContractsForConsumerDocument, options);
}
export type GetContractsForConsumerQueryHookResult = ReturnType<
    typeof useGetContractsForConsumerQuery
>;
export type GetContractsForConsumerLazyQueryHookResult = ReturnType<
    typeof useGetContractsForConsumerLazyQuery
>;
export type GetContractsForConsumerSuspenseQueryHookResult = ReturnType<
    typeof useGetContractsForConsumerSuspenseQuery
>;
export type GetContractsForConsumerQueryResult = Apollo.QueryResult<
    GetContractsForConsumerQuery,
    GetContractsForConsumerQueryVariables
>;
export const MarkAppointmentAsArrivedDocument = gql`
    mutation markAppointmentAsArrived(
        $appointmentId: String!
        $markedAsArrivedBy: String!
    ) {
        markAppointmentArrived(
            markedAsArrivedBy: $markedAsArrivedBy
            id: $appointmentId
        ) {
            appointment {
                id
                arrivedAt
            }
        }
    }
`;
export type MarkAppointmentAsArrivedMutationFn = Apollo.MutationFunction<
    MarkAppointmentAsArrivedMutation,
    MarkAppointmentAsArrivedMutationVariables
>;

/**
 * __useMarkAppointmentAsArrivedMutation__
 *
 * To run a mutation, you first call `useMarkAppointmentAsArrivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAppointmentAsArrivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAppointmentAsArrivedMutation, { data, loading, error }] = useMarkAppointmentAsArrivedMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      markedAsArrivedBy: // value for 'markedAsArrivedBy'
 *   },
 * });
 */
export function useMarkAppointmentAsArrivedMutation(
    baseOptions?: Apollo.MutationHookOptions<
        MarkAppointmentAsArrivedMutation,
        MarkAppointmentAsArrivedMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        MarkAppointmentAsArrivedMutation,
        MarkAppointmentAsArrivedMutationVariables
    >(MarkAppointmentAsArrivedDocument, options);
}
export type MarkAppointmentAsArrivedMutationHookResult = ReturnType<
    typeof useMarkAppointmentAsArrivedMutation
>;
export type MarkAppointmentAsArrivedMutationResult =
    Apollo.MutationResult<MarkAppointmentAsArrivedMutation>;
export type MarkAppointmentAsArrivedMutationOptions =
    Apollo.BaseMutationOptions<
        MarkAppointmentAsArrivedMutation,
        MarkAppointmentAsArrivedMutationVariables
    >;
export const UnmarkAppointmentAsArrivedDocument = gql`
    mutation unmarkAppointmentAsArrived(
        $appointmentId: String!
        $markedAsUnarrivedBy: String!
    ) {
        markAppointmentUnarrived(
            markedAsUnarrivedBy: $markedAsUnarrivedBy
            id: $appointmentId
        ) {
            appointment {
                id
                arrivedAt
            }
        }
    }
`;
export type UnmarkAppointmentAsArrivedMutationFn = Apollo.MutationFunction<
    UnmarkAppointmentAsArrivedMutation,
    UnmarkAppointmentAsArrivedMutationVariables
>;

/**
 * __useUnmarkAppointmentAsArrivedMutation__
 *
 * To run a mutation, you first call `useUnmarkAppointmentAsArrivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmarkAppointmentAsArrivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmarkAppointmentAsArrivedMutation, { data, loading, error }] = useUnmarkAppointmentAsArrivedMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      markedAsUnarrivedBy: // value for 'markedAsUnarrivedBy'
 *   },
 * });
 */
export function useUnmarkAppointmentAsArrivedMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UnmarkAppointmentAsArrivedMutation,
        UnmarkAppointmentAsArrivedMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UnmarkAppointmentAsArrivedMutation,
        UnmarkAppointmentAsArrivedMutationVariables
    >(UnmarkAppointmentAsArrivedDocument, options);
}
export type UnmarkAppointmentAsArrivedMutationHookResult = ReturnType<
    typeof useUnmarkAppointmentAsArrivedMutation
>;
export type UnmarkAppointmentAsArrivedMutationResult =
    Apollo.MutationResult<UnmarkAppointmentAsArrivedMutation>;
export type UnmarkAppointmentAsArrivedMutationOptions =
    Apollo.BaseMutationOptions<
        UnmarkAppointmentAsArrivedMutation,
        UnmarkAppointmentAsArrivedMutationVariables
    >;
export const GetPylonAccountIdByOrgIdDocument = gql`
    query getPylonAccountIdByOrgId($orgId: Int!) {
        findFirstOrganization(where: { id: { equals: $orgId } }) {
            pylonAccountId
        }
    }
`;

/**
 * __useGetPylonAccountIdByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetPylonAccountIdByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPylonAccountIdByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPylonAccountIdByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetPylonAccountIdByOrgIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPylonAccountIdByOrgIdQuery,
        GetPylonAccountIdByOrgIdQueryVariables
    > &
        (
            | {
                  variables: GetPylonAccountIdByOrgIdQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetPylonAccountIdByOrgIdQuery,
        GetPylonAccountIdByOrgIdQueryVariables
    >(GetPylonAccountIdByOrgIdDocument, options);
}
export function useGetPylonAccountIdByOrgIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPylonAccountIdByOrgIdQuery,
        GetPylonAccountIdByOrgIdQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPylonAccountIdByOrgIdQuery,
        GetPylonAccountIdByOrgIdQueryVariables
    >(GetPylonAccountIdByOrgIdDocument, options);
}
// @ts-ignore
export function useGetPylonAccountIdByOrgIdSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetPylonAccountIdByOrgIdQuery,
        GetPylonAccountIdByOrgIdQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetPylonAccountIdByOrgIdQuery,
    GetPylonAccountIdByOrgIdQueryVariables
>;
export function useGetPylonAccountIdByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPylonAccountIdByOrgIdQuery,
              GetPylonAccountIdByOrgIdQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetPylonAccountIdByOrgIdQuery | undefined,
    GetPylonAccountIdByOrgIdQueryVariables
>;
export function useGetPylonAccountIdByOrgIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPylonAccountIdByOrgIdQuery,
              GetPylonAccountIdByOrgIdQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPylonAccountIdByOrgIdQuery,
        GetPylonAccountIdByOrgIdQueryVariables
    >(GetPylonAccountIdByOrgIdDocument, options);
}
export type GetPylonAccountIdByOrgIdQueryHookResult = ReturnType<
    typeof useGetPylonAccountIdByOrgIdQuery
>;
export type GetPylonAccountIdByOrgIdLazyQueryHookResult = ReturnType<
    typeof useGetPylonAccountIdByOrgIdLazyQuery
>;
export type GetPylonAccountIdByOrgIdSuspenseQueryHookResult = ReturnType<
    typeof useGetPylonAccountIdByOrgIdSuspenseQuery
>;
export type GetPylonAccountIdByOrgIdQueryResult = Apollo.QueryResult<
    GetPylonAccountIdByOrgIdQuery,
    GetPylonAccountIdByOrgIdQueryVariables
>;
export const GetOrgStripeMappingsDocument = gql`
    query getOrgStripeMappings($orgId: Int!) {
        org_stripe_mappings(where: { orgId: { equals: $orgId } }) {
            orgId
            stripe_account_id
        }
    }
`;

/**
 * __useGetOrgStripeMappingsQuery__
 *
 * To run a query within a React component, call `useGetOrgStripeMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgStripeMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgStripeMappingsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgStripeMappingsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOrgStripeMappingsQuery,
        GetOrgStripeMappingsQueryVariables
    > &
        (
            | { variables: GetOrgStripeMappingsQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrgStripeMappingsQuery,
        GetOrgStripeMappingsQueryVariables
    >(GetOrgStripeMappingsDocument, options);
}
export function useGetOrgStripeMappingsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrgStripeMappingsQuery,
        GetOrgStripeMappingsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrgStripeMappingsQuery,
        GetOrgStripeMappingsQueryVariables
    >(GetOrgStripeMappingsDocument, options);
}
// @ts-ignore
export function useGetOrgStripeMappingsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrgStripeMappingsQuery,
        GetOrgStripeMappingsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrgStripeMappingsQuery,
    GetOrgStripeMappingsQueryVariables
>;
export function useGetOrgStripeMappingsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgStripeMappingsQuery,
              GetOrgStripeMappingsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrgStripeMappingsQuery | undefined,
    GetOrgStripeMappingsQueryVariables
>;
export function useGetOrgStripeMappingsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgStripeMappingsQuery,
              GetOrgStripeMappingsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrgStripeMappingsQuery,
        GetOrgStripeMappingsQueryVariables
    >(GetOrgStripeMappingsDocument, options);
}
export type GetOrgStripeMappingsQueryHookResult = ReturnType<
    typeof useGetOrgStripeMappingsQuery
>;
export type GetOrgStripeMappingsLazyQueryHookResult = ReturnType<
    typeof useGetOrgStripeMappingsLazyQuery
>;
export type GetOrgStripeMappingsSuspenseQueryHookResult = ReturnType<
    typeof useGetOrgStripeMappingsSuspenseQuery
>;
export type GetOrgStripeMappingsQueryResult = Apollo.QueryResult<
    GetOrgStripeMappingsQuery,
    GetOrgStripeMappingsQueryVariables
>;
export const GetOrganizationAssetsDocument = gql`
    query getOrganizationAssets {
        findManyOrganizationAssets {
            orgId
            org {
                orgName
                orgTitle
            }
            lightModeLogo
            darkModeLogo
            iconLogo
            seoTitle
            seoDescription
            seoImageUrl
            email
            phoneNumber
        }
    }
`;

/**
 * __useGetOrganizationAssetsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAssetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationAssetsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetOrganizationAssetsQuery,
        GetOrganizationAssetsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrganizationAssetsQuery,
        GetOrganizationAssetsQueryVariables
    >(GetOrganizationAssetsDocument, options);
}
export function useGetOrganizationAssetsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrganizationAssetsQuery,
        GetOrganizationAssetsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrganizationAssetsQuery,
        GetOrganizationAssetsQueryVariables
    >(GetOrganizationAssetsDocument, options);
}
// @ts-ignore
export function useGetOrganizationAssetsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrganizationAssetsQuery,
        GetOrganizationAssetsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrganizationAssetsQuery,
    GetOrganizationAssetsQueryVariables
>;
export function useGetOrganizationAssetsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrganizationAssetsQuery,
              GetOrganizationAssetsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrganizationAssetsQuery | undefined,
    GetOrganizationAssetsQueryVariables
>;
export function useGetOrganizationAssetsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrganizationAssetsQuery,
              GetOrganizationAssetsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrganizationAssetsQuery,
        GetOrganizationAssetsQueryVariables
    >(GetOrganizationAssetsDocument, options);
}
export type GetOrganizationAssetsQueryHookResult = ReturnType<
    typeof useGetOrganizationAssetsQuery
>;
export type GetOrganizationAssetsLazyQueryHookResult = ReturnType<
    typeof useGetOrganizationAssetsLazyQuery
>;
export type GetOrganizationAssetsSuspenseQueryHookResult = ReturnType<
    typeof useGetOrganizationAssetsSuspenseQuery
>;
export type GetOrganizationAssetsQueryResult = Apollo.QueryResult<
    GetOrganizationAssetsQuery,
    GetOrganizationAssetsQueryVariables
>;
export const GetOrganizationAssetsForOrgDocument = gql`
    query getOrganizationAssetsForOrg($orgId: Int!) {
        findManyOrganizationAssets(where: { orgId: { equals: $orgId } }) {
            orgId
            org {
                orgName
                orgTitle
            }
            lightModeLogo
            darkModeLogo
            iconLogo
            seoTitle
            seoDescription
            seoImageUrl
            email
            phoneNumber
            primaryColor
            primaryBackgroundColor
            secondaryBackgroundColor
            secondaryColor
        }
    }
`;

/**
 * __useGetOrganizationAssetsForOrgQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAssetsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAssetsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAssetsForOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrganizationAssetsForOrgQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOrganizationAssetsForOrgQuery,
        GetOrganizationAssetsForOrgQueryVariables
    > &
        (
            | {
                  variables: GetOrganizationAssetsForOrgQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrganizationAssetsForOrgQuery,
        GetOrganizationAssetsForOrgQueryVariables
    >(GetOrganizationAssetsForOrgDocument, options);
}
export function useGetOrganizationAssetsForOrgLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrganizationAssetsForOrgQuery,
        GetOrganizationAssetsForOrgQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrganizationAssetsForOrgQuery,
        GetOrganizationAssetsForOrgQueryVariables
    >(GetOrganizationAssetsForOrgDocument, options);
}
// @ts-ignore
export function useGetOrganizationAssetsForOrgSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrganizationAssetsForOrgQuery,
        GetOrganizationAssetsForOrgQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrganizationAssetsForOrgQuery,
    GetOrganizationAssetsForOrgQueryVariables
>;
export function useGetOrganizationAssetsForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrganizationAssetsForOrgQuery,
              GetOrganizationAssetsForOrgQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrganizationAssetsForOrgQuery | undefined,
    GetOrganizationAssetsForOrgQueryVariables
>;
export function useGetOrganizationAssetsForOrgSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrganizationAssetsForOrgQuery,
              GetOrganizationAssetsForOrgQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrganizationAssetsForOrgQuery,
        GetOrganizationAssetsForOrgQueryVariables
    >(GetOrganizationAssetsForOrgDocument, options);
}
export type GetOrganizationAssetsForOrgQueryHookResult = ReturnType<
    typeof useGetOrganizationAssetsForOrgQuery
>;
export type GetOrganizationAssetsForOrgLazyQueryHookResult = ReturnType<
    typeof useGetOrganizationAssetsForOrgLazyQuery
>;
export type GetOrganizationAssetsForOrgSuspenseQueryHookResult = ReturnType<
    typeof useGetOrganizationAssetsForOrgSuspenseQuery
>;
export type GetOrganizationAssetsForOrgQueryResult = Apollo.QueryResult<
    GetOrganizationAssetsForOrgQuery,
    GetOrganizationAssetsForOrgQueryVariables
>;
export const GetOrgPylonAccountIdsDocument = gql`
    query getOrgPylonAccountIds($orgId: Int!) {
        findFirstOrganization(where: { id: { equals: $orgId } }) {
            pylonAccountId
            patientPylonAccountId
        }
    }
`;

/**
 * __useGetOrgPylonAccountIdsQuery__
 *
 * To run a query within a React component, call `useGetOrgPylonAccountIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgPylonAccountIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgPylonAccountIdsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgPylonAccountIdsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOrgPylonAccountIdsQuery,
        GetOrgPylonAccountIdsQueryVariables
    > &
        (
            | { variables: GetOrgPylonAccountIdsQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOrgPylonAccountIdsQuery,
        GetOrgPylonAccountIdsQueryVariables
    >(GetOrgPylonAccountIdsDocument, options);
}
export function useGetOrgPylonAccountIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrgPylonAccountIdsQuery,
        GetOrgPylonAccountIdsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOrgPylonAccountIdsQuery,
        GetOrgPylonAccountIdsQueryVariables
    >(GetOrgPylonAccountIdsDocument, options);
}
// @ts-ignore
export function useGetOrgPylonAccountIdsSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetOrgPylonAccountIdsQuery,
        GetOrgPylonAccountIdsQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetOrgPylonAccountIdsQuery,
    GetOrgPylonAccountIdsQueryVariables
>;
export function useGetOrgPylonAccountIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgPylonAccountIdsQuery,
              GetOrgPylonAccountIdsQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetOrgPylonAccountIdsQuery | undefined,
    GetOrgPylonAccountIdsQueryVariables
>;
export function useGetOrgPylonAccountIdsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOrgPylonAccountIdsQuery,
              GetOrgPylonAccountIdsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOrgPylonAccountIdsQuery,
        GetOrgPylonAccountIdsQueryVariables
    >(GetOrgPylonAccountIdsDocument, options);
}
export type GetOrgPylonAccountIdsQueryHookResult = ReturnType<
    typeof useGetOrgPylonAccountIdsQuery
>;
export type GetOrgPylonAccountIdsLazyQueryHookResult = ReturnType<
    typeof useGetOrgPylonAccountIdsLazyQuery
>;
export type GetOrgPylonAccountIdsSuspenseQueryHookResult = ReturnType<
    typeof useGetOrgPylonAccountIdsSuspenseQuery
>;
export type GetOrgPylonAccountIdsQueryResult = Apollo.QueryResult<
    GetOrgPylonAccountIdsQuery,
    GetOrgPylonAccountIdsQueryVariables
>;
export const GetBillingCodesDocument = gql`
    query getBillingCodes {
        billingCodes {
            billingCode
            description
        }
    }
`;

/**
 * __useGetBillingCodesQuery__
 *
 * To run a query within a React component, call `useGetBillingCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingCodesQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetBillingCodesQuery,
        GetBillingCodesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetBillingCodesQuery, GetBillingCodesQueryVariables>(
        GetBillingCodesDocument,
        options,
    );
}
export function useGetBillingCodesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBillingCodesQuery,
        GetBillingCodesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBillingCodesQuery,
        GetBillingCodesQueryVariables
    >(GetBillingCodesDocument, options);
}
// @ts-ignore
export function useGetBillingCodesSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetBillingCodesQuery,
        GetBillingCodesQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetBillingCodesQuery,
    GetBillingCodesQueryVariables
>;
export function useGetBillingCodesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBillingCodesQuery,
              GetBillingCodesQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetBillingCodesQuery | undefined,
    GetBillingCodesQueryVariables
>;
export function useGetBillingCodesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBillingCodesQuery,
              GetBillingCodesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBillingCodesQuery,
        GetBillingCodesQueryVariables
    >(GetBillingCodesDocument, options);
}
export type GetBillingCodesQueryHookResult = ReturnType<
    typeof useGetBillingCodesQuery
>;
export type GetBillingCodesLazyQueryHookResult = ReturnType<
    typeof useGetBillingCodesLazyQuery
>;
export type GetBillingCodesSuspenseQueryHookResult = ReturnType<
    typeof useGetBillingCodesSuspenseQuery
>;
export type GetBillingCodesQueryResult = Apollo.QueryResult<
    GetBillingCodesQuery,
    GetBillingCodesQueryVariables
>;
export const GetPracticeAndHoursDocument = gql`
    query getPracticeAndHours($practiceId: Int!) {
        practice(where: { practiceId: $practiceId }) {
            practiceId
            address
            locationName
            timezone
            practiceHours {
                dayOfWeek
                openTime
                closeTime
                deletedAt
                updatedAt
                createdAt
            }
            practiceHoursOverrides {
                date
                openTime
                closeTime
                isClosed
                notes
                deletedAt
                updatedAt
                createdAt
            }
        }
    }
`;

/**
 * __useGetPracticeAndHoursQuery__
 *
 * To run a query within a React component, call `useGetPracticeAndHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeAndHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeAndHoursQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *   },
 * });
 */
export function useGetPracticeAndHoursQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPracticeAndHoursQuery,
        GetPracticeAndHoursQueryVariables
    > &
        (
            | { variables: GetPracticeAndHoursQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetPracticeAndHoursQuery,
        GetPracticeAndHoursQueryVariables
    >(GetPracticeAndHoursDocument, options);
}
export function useGetPracticeAndHoursLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPracticeAndHoursQuery,
        GetPracticeAndHoursQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPracticeAndHoursQuery,
        GetPracticeAndHoursQueryVariables
    >(GetPracticeAndHoursDocument, options);
}
// @ts-ignore
export function useGetPracticeAndHoursSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetPracticeAndHoursQuery,
        GetPracticeAndHoursQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetPracticeAndHoursQuery,
    GetPracticeAndHoursQueryVariables
>;
export function useGetPracticeAndHoursSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticeAndHoursQuery,
              GetPracticeAndHoursQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetPracticeAndHoursQuery | undefined,
    GetPracticeAndHoursQueryVariables
>;
export function useGetPracticeAndHoursSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPracticeAndHoursQuery,
              GetPracticeAndHoursQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPracticeAndHoursQuery,
        GetPracticeAndHoursQueryVariables
    >(GetPracticeAndHoursDocument, options);
}
export type GetPracticeAndHoursQueryHookResult = ReturnType<
    typeof useGetPracticeAndHoursQuery
>;
export type GetPracticeAndHoursLazyQueryHookResult = ReturnType<
    typeof useGetPracticeAndHoursLazyQuery
>;
export type GetPracticeAndHoursSuspenseQueryHookResult = ReturnType<
    typeof useGetPracticeAndHoursSuspenseQuery
>;
export type GetPracticeAndHoursQueryResult = Apollo.QueryResult<
    GetPracticeAndHoursQuery,
    GetPracticeAndHoursQueryVariables
>;
export const GetProviderCredentialingByNpisAndStateDocument = gql`
    query getProviderCredentialingByNpisAndState(
        $npiIds: [String!]!
        $state: String!
    ) {
        providerCredentialings(
            where: {
                AND: [{ npiId: { in: $npiIds } }, { states: { has: $state } }]
            }
        ) {
            npiId
            states
        }
    }
`;

/**
 * __useGetProviderCredentialingByNpisAndStateQuery__
 *
 * To run a query within a React component, call `useGetProviderCredentialingByNpisAndStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderCredentialingByNpisAndStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderCredentialingByNpisAndStateQuery({
 *   variables: {
 *      npiIds: // value for 'npiIds'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetProviderCredentialingByNpisAndStateQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetProviderCredentialingByNpisAndStateQuery,
        GetProviderCredentialingByNpisAndStateQueryVariables
    > &
        (
            | {
                  variables: GetProviderCredentialingByNpisAndStateQueryVariables;
                  skip?: boolean;
              }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetProviderCredentialingByNpisAndStateQuery,
        GetProviderCredentialingByNpisAndStateQueryVariables
    >(GetProviderCredentialingByNpisAndStateDocument, options);
}
export function useGetProviderCredentialingByNpisAndStateLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetProviderCredentialingByNpisAndStateQuery,
        GetProviderCredentialingByNpisAndStateQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetProviderCredentialingByNpisAndStateQuery,
        GetProviderCredentialingByNpisAndStateQueryVariables
    >(GetProviderCredentialingByNpisAndStateDocument, options);
}
// @ts-ignore
export function useGetProviderCredentialingByNpisAndStateSuspenseQuery(
    baseOptions?: Apollo.SuspenseQueryHookOptions<
        GetProviderCredentialingByNpisAndStateQuery,
        GetProviderCredentialingByNpisAndStateQueryVariables
    >,
): Apollo.UseSuspenseQueryResult<
    GetProviderCredentialingByNpisAndStateQuery,
    GetProviderCredentialingByNpisAndStateQueryVariables
>;
export function useGetProviderCredentialingByNpisAndStateSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderCredentialingByNpisAndStateQuery,
              GetProviderCredentialingByNpisAndStateQueryVariables
          >,
): Apollo.UseSuspenseQueryResult<
    GetProviderCredentialingByNpisAndStateQuery | undefined,
    GetProviderCredentialingByNpisAndStateQueryVariables
>;
export function useGetProviderCredentialingByNpisAndStateSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetProviderCredentialingByNpisAndStateQuery,
              GetProviderCredentialingByNpisAndStateQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken
            ? baseOptions
            : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetProviderCredentialingByNpisAndStateQuery,
        GetProviderCredentialingByNpisAndStateQueryVariables
    >(GetProviderCredentialingByNpisAndStateDocument, options);
}
export type GetProviderCredentialingByNpisAndStateQueryHookResult = ReturnType<
    typeof useGetProviderCredentialingByNpisAndStateQuery
>;
export type GetProviderCredentialingByNpisAndStateLazyQueryHookResult =
    ReturnType<typeof useGetProviderCredentialingByNpisAndStateLazyQuery>;
export type GetProviderCredentialingByNpisAndStateSuspenseQueryHookResult =
    ReturnType<typeof useGetProviderCredentialingByNpisAndStateSuspenseQuery>;
export type GetProviderCredentialingByNpisAndStateQueryResult =
    Apollo.QueryResult<
        GetProviderCredentialingByNpisAndStateQuery,
        GetProviderCredentialingByNpisAndStateQueryVariables
    >;
